
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("dnhKp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $20e3d3c7990d266d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("2Geeh");

var $iqr2y = parcelRequire("iqr2y");

var $co1wz = parcelRequire("co1wz");

var $lfTZh = parcelRequire("lfTZh");

var $6awMq = parcelRequire("6awMq");

var $9kARR = parcelRequire("9kARR");

var $4dRjY = parcelRequire("4dRjY");

var $l8ruj = parcelRequire("l8ruj");

var $dIdda = parcelRequire("dIdda");

var $29QEe = parcelRequire("29QEe");
const $20e3d3c7990d266d$var$RouterWrapper = (0, $dIdda.withRouter)((0, $29QEe.Board));
const $20e3d3c7990d266d$var$BoardSPAApp = ()=>{
    const children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "next-gen-board",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6awMq.NextGenBoardSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9kARR.SuspenseTrackerFallback), null))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqr2y.ErrorBoundaryFlag), {
        id: "spa-app-bootstrap.next-gen.board"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20e3d3c7990d266d$var$RouterWrapper, null)));
    if ((0, $co1wz.ff)('jsw.perf.critical-board-with-relay')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "next-gen-board"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9kARR.SuspenseTrackerProvider), null, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "next-gen-board"
    }, children);
};
var $20e3d3c7990d266d$export$2e2bcd8739ae039 = $20e3d3c7990d266d$var$BoardSPAApp;

});
parcelRegister("9kARR", function(module, exports) {

$parcel$export(module.exports, "SuspenseTrackerProvider", () => $e05a0c2231be48ec$export$58f6796252ab3147);
$parcel$export(module.exports, "SuspenseTrackerFallback", () => $e05a0c2231be48ec$export$8637c61d65a3606b);
$parcel$export(module.exports, "useGetHasSuspended", () => $e05a0c2231be48ec$export$a143cd14d496de4d);

var $5uXOq = parcelRequire("5uXOq");
class $e05a0c2231be48ec$export$87993bf75925b3bd {
    getHasSuspended() {
        return this.suspendCount !== 0;
    }
    /**
	 * Should be called on unmount of the tracked sub-tree
	 */ reset() {
        this.suspendCount = 0;
    }
    /**
	 * Should be called when a suspend happens
	 */ onSuspend() {
        this.suspendCount += 1;
    }
    constructor(){
        this.suspendCount = 0;
    }
}
const $e05a0c2231be48ec$var$SuspenseTrackerContext = /*#__PURE__*/ (0, $5uXOq.createContext)(new $e05a0c2231be48ec$export$87993bf75925b3bd());
const $e05a0c2231be48ec$export$58f6796252ab3147 = ({ children: children })=>{
    const suspenseTrackerRef = (0, $5uXOq.useRef)(new $e05a0c2231be48ec$export$87993bf75925b3bd());
    (0, $5uXOq.useEffect)(()=>()=>{
            suspenseTrackerRef.current?.reset();
        }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e05a0c2231be48ec$var$SuspenseTrackerContext.Provider, {
        value: suspenseTrackerRef.current
    }, children);
};
const $e05a0c2231be48ec$export$8637c61d65a3606b = ()=>{
    const suspenseTracker = (0, $5uXOq.useContext)($e05a0c2231be48ec$var$SuspenseTrackerContext);
    (0, $5uXOq.useEffect)(()=>{
        suspenseTracker.onSuspend();
    }, [
        suspenseTracker
    ]);
    return null;
};
const $e05a0c2231be48ec$export$a143cd14d496de4d = ()=>{
    const suspenseTracker = (0, $5uXOq.useContext)($e05a0c2231be48ec$var$SuspenseTrackerContext);
    return suspenseTracker.getHasSuspended();
};

});

parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("29QEe", function(module, exports) {

$parcel$export(module.exports, "Board", () => $e20b36b875aef26b$export$dc537a3a3893548e);

var $5uXOq = parcelRequire("5uXOq");

var $2i4sA = parcelRequire("2i4sA");

var $co1wz = parcelRequire("co1wz");

var $ao2h1 = parcelRequire("ao2h1");

var $5qQ9I = parcelRequire("5qQ9I");

var $efvDm = parcelRequire("efvDm");

var $9NiTW = parcelRequire("9NiTW");

var $3RV1W = parcelRequire("3RV1W");

var $38Y30 = parcelRequire("38Y30");

var $9OXo1 = parcelRequire("9OXo1");

var $12Sv5 = parcelRequire("12Sv5");

var $6Zotr = parcelRequire("6Zotr");

var $54XqP = parcelRequire("54XqP");

var $kCEVs = parcelRequire("kCEVs");
const $e20b36b875aef26b$var$BoardWithRouterWrapper = (props)=>{
    const isCMPBoard = (0, $12Sv5.useIsCMPBoardRoute)();
    if (isCMPBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $54XqP.BoardWithRouterCMP), props);
    if ((0, $co1wz.ff)('jsw.perf.critical-board-with-relay')) {
        /* eslint-disable-next-line react-hooks/rules-of-hooks */ const response = (0, $ao2h1.useRelayResource)((0, $5qQ9I.boardRelayResource));
        return response.queryReference != null ? // @ts-expect-error - TS2322 - Type 'PreloadedQuery<OperationType, Record<string, unknown>>' is not assignable to type 'PreloadedQuery<boardWithRouterRelayQuery, Record<string, unknown>>'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kCEVs.BoardWithRouterRelay), {
            ...props,
            boardQueryReference: response.queryReference
        }) : null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Zotr.BoardWithRouter), props);
};
const $e20b36b875aef26b$export$dc537a3a3893548e = ({ route: route, match: match })=>{
    const boardId = Number(match.params.boardId);
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const isAuthenticated = (0, $9NiTW.checkAuthentication)(tenantContext);
    const hasSoftwareLicense = (0, $3RV1W.checkLicense)(tenantContext, 'software');
    const isCMPBoard = (0, $12Sv5.useIsCMPBoardRoute)();
    if (!isAuthenticated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Y30.RedirectToLoginPage), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2i4sA.ViewExperienceTrackingProvider), {
        experienceId: `${boardId}`,
        experience: "viewBoard",
        analyticsSource: "board",
        edition: tenantContext.appEditions.software,
        application: (0, $efvDm.JIRA_SOFTWARE),
        additionalAttributes: {
            isClassic: isCMPBoard,
            isUIF: true,
            taskId: boardId,
            synthetic: (0, $co1wz.ff)('jsw.pollinator.tenants')
        }
    }, route ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e20b36b875aef26b$var$BoardWithRouterWrapper, {
        hasSoftwareLicense: hasSoftwareLicense
    }) : null);
};

});
parcelRegister("9NiTW", function(module, exports) {

$parcel$export(module.exports, "checkAuthentication", () => $ad297a7f2ce81084$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "AuthenticationCheck", () => $ad297a7f2ce81084$export$e9b9096e887386fe);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");

var $38Y30 = parcelRequire("38Y30");
const $ad297a7f2ce81084$export$b8dbb7d6029c5413 = (tenantContext)=>Boolean(tenantContext.atlassianAccountId);
const $ad297a7f2ce81084$export$e9b9096e887386fe = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if ($ad297a7f2ce81084$export$b8dbb7d6029c5413(tenantContext)) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Y30.RedirectToLoginPage), null);
    });

});
parcelRegister("38Y30", function(module, exports) {

$parcel$export(module.exports, "RedirectToLoginPage", () => $08f8c3f776d557a9$export$938182bd3fddc3a8);

var $5uXOq = parcelRequire("5uXOq");

var $dIdda = parcelRequire("dIdda");
const $08f8c3f776d557a9$export$3da29de62ed7a388 = ({ to: to })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("script", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window.location.assign("${to}")`
        }
    });
$08f8c3f776d557a9$export$3da29de62ed7a388.displayName = 'InlineRedirect';
const $08f8c3f776d557a9$export$938182bd3fddc3a8 = ()=>{
    const [{ location: { pathname: pathname, search: search } }] = (0, $dIdda.useRouter)();
    const redirectUrl = pathname + search;
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);
    let path = `/login.jsp?os_destination=${encodedRedirectUrl}`;
    const parentProductQueryName = 'parentProduct';
    const [parentProduct] = (0, $dIdda.useQueryParam)(parentProductQueryName);
    if (pathname.endsWith('/embed')) {
        const searchParams = new URLSearchParams(search);
        // We need to remove parentProduct param as it is only used in embed urls
        searchParams.delete(parentProductQueryName);
        /**
		 * encodedLink is the link to the non embedded version of the embed url.
		 * So, we strip out the /embed suffix from path
		 */ let encodedLink = encodeURIComponent(`${pathname.slice(0, -6)}?${searchParams}`);
        /**
		 * this is the specific case for create issue embed, where we need to redirect
		 * user to your-work page with create issue as true to open GIC by default.
		 * We will remove this when we FPIC exp implemented for GIC
		 */ if (pathname.includes('/issues/create')) encodedLink = encodeURIComponent('/jira/your-work?createissue=true');
        const encodedParentProduct = encodeURIComponent(parentProduct || '');
        path = `/jira-login/embed?destination=${encodedRedirectUrl}&link=${encodedLink}&parentProduct=${encodedParentProduct}`;
    }
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08f8c3f776d557a9$export$3da29de62ed7a388, {
        to: path
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
        to: path
    });
};

});


parcelRegister("3RV1W", function(module, exports) {

$parcel$export(module.exports, "checkLicense", () => $6334356fa938c5d8$export$fe2591be8b7e59ce);
$parcel$export(module.exports, "LicenseCheck", () => $6334356fa938c5d8$export$944be0b3bf2a6feb);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");
const $6334356fa938c5d8$var$appPermissionMapper = {
    software: 'hasSoftwareAccess',
    servicedesk: 'hasServiceDeskAccess'
};
const $6334356fa938c5d8$export$fe2591be8b7e59ce = (tenantContext, type)=>Boolean(tenantContext.appPermissions && tenantContext.appPermissions[$6334356fa938c5d8$var$appPermissionMapper[type]]);
const $6334356fa938c5d8$export$944be0b3bf2a6feb = ({ children: children, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const result = $6334356fa938c5d8$export$fe2591be8b7e59ce(tenantContext, type);
        return children({
            result: result
        });
    });

});

parcelRegister("12Sv5", function(module, exports) {

$parcel$export(module.exports, "useIsCMPBoardRoute", () => $ea8f3f30149f8216$export$ab192852bd2b5277);

var $65Ltd = parcelRequire("65Ltd");

var $6jY6G = parcelRequire("6jY6G");
const $ea8f3f30149f8216$export$ab192852bd2b5277 = ()=>{
    const { name: routeName } = (0, $6jY6G.useCurrentRoute)();
    return [
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_BOARD),
        (0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED),
        (0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_USER_BOARD)
    ].includes(routeName);
};

});

parcelRegister("6Zotr", function(module, exports) {

$parcel$export(module.exports, "BoardWithRouter", () => $7afc6accdedf8e8f$export$80a10a58d5111cf6);

var $5uXOq = parcelRequire("5uXOq");

var $gEFwt = parcelRequire("gEFwt");

var $2vSU6 = parcelRequire("2vSU6");

var $3mYHL = parcelRequire("3mYHL");

var $ao2h1 = parcelRequire("ao2h1");

var $5qQ9I = parcelRequire("5qQ9I");

var $dMC1b = parcelRequire("dMC1b");

var $9dbF6 = parcelRequire("9dbF6");

var $6XsPQ = parcelRequire("6XsPQ");

var $9OXo1 = parcelRequire("9OXo1");

var $dIdda = parcelRequire("dIdda");

var $12Sv5 = parcelRequire("12Sv5");

var $k6PKo = parcelRequire("k6PKo");

var $8XaG5 = parcelRequire("8XaG5");
const $7afc6accdedf8e8f$export$80a10a58d5111cf6 = ({ hasSoftwareLicense: hasSoftwareLicense })=>{
    const isCMPBoard = (0, $12Sv5.useIsCMPBoardRoute)();
    const [paramBoardId] = (0, $dIdda.usePathParam)('boardId');
    const [projectKey] = (0, $dIdda.usePathParam)('projectKey');
    const boardState = (0, $dIdda.useResource)((0, $dMC1b.boardResource));
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const boardId = Number(paramBoardId);
    const isCacheHitRef = (0, $5uXOq.useRef)(boardState.data != null);
    const isCacheHit = isCacheHitRef.current;
    const boardData = {
        data: boardState.data,
        loading: boardState.loading,
        error: boardState.error
    };
    const { key: key, id: id, name: name } = boardData.data?.projectLocation || {};
    const projectDetails = {
        key: key,
        id: id,
        name: name
    };
    const projectKeyFromContext = projectDetails.key || projectKey || '';
    const response = (0, $ao2h1.useRelayResource)((0, $5qQ9I.customFiltersResource));
    const customFiltersQueryRef = response.queryReference;
    return hasSoftwareLicense ? // @ts-expect-error - TS2739 - Type '{ children: (history: any) => Element; }' is missing the following properties from type 'RouteContext': location, query, route, match, action
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6XsPQ.HistoryAdapter), null, (history)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
            /* eslint-disable-next-line jira/deprecations/no-base-url */ baseUrl: tenantContext.baseUrl,
            projectKey: projectKeyFromContext,
            projectName: projectDetails.name ?? projectKey,
            projectId: projectDetails.id,
            isSimplifiedProject: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
            subProduct: "software"
        }), (0, $k6PKo.renderBoardApp)({
            rapidViewId: boardId,
            projectKey: projectKeyFromContext,
            projectType: (0, $2vSU6.SOFTWARE_PROJECT),
            context: {
                tenantContext: tenantContext
            },
            boardData: isCMPBoard ? null : boardData,
            history: history,
            isCacheHit: isCacheHit,
            customFiltersQueryRef: customFiltersQueryRef,
            isCMPBoard: isCMPBoard
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mYHL.default), {
            projectKey: projectKey || projectKeyFromContext || null
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8XaG5.NoSoftwareLicense), null);
};

});
parcelRegister("3mYHL", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $90d8776d2c89f4bd$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $90d8776d2c89f4bd$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $90d8776d2c89f4bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dAfqg = parcelRequire("dAfqg");

var $dIdda = parcelRequire("dIdda");

const $90d8776d2c89f4bd$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $90d8776d2c89f4bd$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAfqg.ProjectContextProvider), null, (projectContext)=>$90d8776d2c89f4bd$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
        }) : null);
};
const $90d8776d2c89f4bd$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
        to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
    });
var $90d8776d2c89f4bd$export$2e2bcd8739ae039 = $90d8776d2c89f4bd$var$RedirectIfProjectArchived;

});
const $a9bebd574fd66055$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("dMC1b", function(module, exports) {

$parcel$export(module.exports, "boardResource", () => $73a4b6179bd7e4aa$export$286b76e0f2661cfb);

var $dIdda = parcelRequire("dIdda");


var $11pNz = parcelRequire("11pNz");
const $73a4b6179bd7e4aa$export$286b76e0f2661cfb = (0, $dIdda.createResource)({
    type: (0, $a00fc8fb83f2948a$export$a38ac7339e3f31db),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>Promise.resolve({
            default: (0, $11pNz.default)
        }),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000
});

});
const $a00fc8fb83f2948a$export$a38ac7339e3f31db = 'NEXTGEN_BOARD';
const $a00fc8fb83f2948a$export$b48bcc76a0105016 = 'NEXTGEN_BOARD_CUSTOM_FILTERS';
const $a00fc8fb83f2948a$export$5cef388780439aec = 'NEXTGEN_BOARD_RELAY';

parcelRegister("11pNz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getEarlyPreload", () => $9b1c3000d033b19c$export$fed0052f40119df3);
$parcel$export(module.exports, "fetchData", () => $9b1c3000d033b19c$export$8134c072fddab6a5);
$parcel$export(module.exports, "default", () => $9b1c3000d033b19c$export$2e2bcd8739ae039);

var $x9xyg = parcelRequire("x9xyg");

var $8PRuf = parcelRequire("8PRuf");

var $iR3GG = parcelRequire("iR3GG");

var $cNrxd = parcelRequire("cNrxd");

var $9NiTW = parcelRequire("9NiTW");

var $3RV1W = parcelRequire("3RV1W");

var $luzsA = parcelRequire("luzsA");
const $9b1c3000d033b19c$export$fed0052f40119df3 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__JSW_BOARD_DATA_PROMISE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const earlyPreloadPromise = window.__JSW_BOARD_DATA_PROMISE__;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__JSW_BOARD_DATA_PROMISE__ = null;
        return earlyPreloadPromise.then((preload)=>{
            if (preload.errors && preload.errors.length || !preload.data?.boardScope) throw new (0, $cNrxd.SwagError)({
                graphQLErrors: preload.errors,
                errorMessage: 'Board critical early fetch failed'
            });
            return preload.data.boardScope;
        });
    }
    return null;
};
const $9b1c3000d033b19c$export$8134c072fddab6a5 = (baseUrl, boardId)=>{
    const earlyPreload = $9b1c3000d033b19c$export$fed0052f40119df3();
    if (earlyPreload != null) return earlyPreload;
    return (0, $luzsA.fetchBoardData)(baseUrl, boardId || '');
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9b1c3000d033b19c$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
    if (!(0, $9NiTW.checkAuthentication)(tenantContext) || !match.params.boardId) throw (0, $iR3GG.createResourceError)({
        component: 'spa.view.routes.next-gen.software-boards-data.getData',
        message: 'Current user is not authenticated',
        name: 'AuthenticationError',
        skipSentry: true
    });
    if (!(0, $3RV1W.checkLicense)(tenantContext, 'software')) throw (0, $iR3GG.createResourceError)({
        component: 'spa.view.routes.next-gen.software-boards-data.getData',
        message: 'License check failed',
        name: 'AuthenticationError',
        skipSentry: true
    });
    const { baseUrl: baseUrl } = tenantContext;
    try {
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiStartMark));
        const data = await $9b1c3000d033b19c$export$8134c072fddab6a5(baseUrl, match.params.boardId);
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.next-gen.software-boards.getData',
            message: 'An error was thrown while prefetching board data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("8PRuf", function(module, exports) {

$parcel$export(module.exports, "appBundleReadyMark", () => $0ec5205bf4957ca4$export$7e50945a65dd40e);
$parcel$export(module.exports, "prefetchApiReadyMark", () => $0ec5205bf4957ca4$export$17cbe723d23101d8);
$parcel$export(module.exports, "prefetchApiStartMark", () => $0ec5205bf4957ca4$export$887fadb22e7c7735);
$parcel$export(module.exports, "jswRenderStartMark", () => $0ec5205bf4957ca4$export$bd099c0a906f4b3f);
$parcel$export(module.exports, "jswCreateReduxStoreStartMark", () => $0ec5205bf4957ca4$export$d23ef9e7633e30e7);
$parcel$export(module.exports, "jswCreateReduxStoreEndMark", () => $0ec5205bf4957ca4$export$319da6d901948a6d);
$parcel$export(module.exports, "jswTransformCriticalDataStartMark", () => $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f);
$parcel$export(module.exports, "jswTransformCriticalDataEndMark", () => $0ec5205bf4957ca4$export$37e82663aa1e79a8);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", () => $0ec5205bf4957ca4$export$21146514eacceb12);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", () => $0ec5205bf4957ca4$export$4eb8d44ddb14424a);


var $hXKq5 = parcelRequire("hXKq5");
const $0ec5205bf4957ca4$export$7e50945a65dd40e = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$ff834eccc35b9089));
const $0ec5205bf4957ca4$export$17cbe723d23101d8 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$86b05e34d462ead8));
const $0ec5205bf4957ca4$export$887fadb22e7c7735 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$d6a604a7d9a390fb));
const $0ec5205bf4957ca4$export$bd099c0a906f4b3f = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$3ae43cc1782d058f));
const $0ec5205bf4957ca4$export$d23ef9e7633e30e7 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$363f6703ffa600be));
const $0ec5205bf4957ca4$export$319da6d901948a6d = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$e87b74567b79c8));
const $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$99fe642459a8b02));
const $0ec5205bf4957ca4$export$37e82663aa1e79a8 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$ab1f5705fc8e0571));
const $0ec5205bf4957ca4$export$21146514eacceb12 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$8c3a9046da692c35));
const $0ec5205bf4957ca4$export$4eb8d44ddb14424a = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$5aa497d1efdcc5bf));

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';

parcelRegister("hXKq5", function(module, exports) {

$parcel$export(module.exports, "getPrefixedMarkName", () => $f6cddc52a08e036c$export$c8f0e9837e7e9425);

const $f6cddc52a08e036c$export$c8f0e9837e7e9425 = (name)=>`${0, $ce556f125dee8174$export$56940a9488e85199}${name}`;

});


parcelRegister("iR3GG", function(module, exports) {

$parcel$export(module.exports, "createResourceError", () => $d895341acba1e817$export$13487d18466bc8a5);

var $dJl1T = parcelRequire("dJl1T");
class $d895341acba1e817$var$ResourceErrorClass extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
const $d895341acba1e817$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $dJl1T.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $d895341acba1e817$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});

parcelRegister("cNrxd", function(module, exports) {

$parcel$export(module.exports, "SwagError", () => $116bdf44a4142aa3$export$c6b77322a15ada4f);
$parcel$export(module.exports, "isJson", () => $116bdf44a4142aa3$export$952e1d8683e4d0c4);
$parcel$export(module.exports, "isFetchError", () => $116bdf44a4142aa3$export$96f7e6db4105d70c);
$parcel$export(module.exports, "isSwagError", () => $116bdf44a4142aa3$export$7d7253f3a1a7c031);

var $jJZqs = parcelRequire("jJZqs");
const $116bdf44a4142aa3$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if (Array.isArray(err.graphQLErrors) && err.graphQLErrors.length !== 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `GraphQL error: ${errorMessage}\n`;
    });
    if (err.networkError) message += `Network error: ${err.networkError.message}\n`;
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $116bdf44a4142aa3$export$c6b77322a15ada4f extends Error {
    constructor({ graphQLErrors: graphQLErrors, networkError: networkError, errorMessage: errorMessage, traceId: traceId = '' }){
        super(errorMessage);
        this.graphQLErrors = [];
        this.networkError = null;
        // SWAG trace id, extracted from "atl-traceid" response-header
        // Helps to find relevant error in SWAG logs
        this.traceId = '';
        this.graphQLErrors = graphQLErrors || [];
        this.networkError = networkError || null;
        if (!errorMessage) this.message = $116bdf44a4142aa3$var$generateErrorMessage(this);
        else this.message = errorMessage;
        this.name = this.constructor.name;
        this.traceId = traceId;
        this.cause = networkError || graphQLErrors?.[0];
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(this.message).stack;
    }
    skipSentry() {
        return this.networkError != null || this.graphQLErrors.length > 0;
    }
}
const $116bdf44a4142aa3$export$952e1d8683e4d0c4 = (value)=>{
    try {
        JSON.parse(value);
    } catch (e) {
        return false;
    }
    return true;
};
const $116bdf44a4142aa3$export$96f7e6db4105d70c = (error)=>error !== null && typeof error === 'object' && error instanceof (0, $jJZqs.default);
const $116bdf44a4142aa3$export$7d7253f3a1a7c031 = (error)=>{
    if (error !== null && typeof error === 'object' && error instanceof $116bdf44a4142aa3$export$c6b77322a15ada4f) return 'graphQLErrors' in error || 'networkError' in error;
    return false;
};

});

parcelRegister("luzsA", function(module, exports) {

$parcel$export(module.exports, "fetchBoardData", () => $9dbb7d1ba2164e90$export$c454496371605af);
/* eslint-disable jira/import-whitelist */ /**
 * This is a duplicate of ./index.js with a reduced surface area to limit bundle
 * size for testing a new approach to route-based critical data fetching.
 * See https://jdog.jira-dev.com/jira/software/projects/SPAF/boards/3052?selectedIssue=SPAF-22
 */ 
var $x9xyg = parcelRequire("x9xyg");

var $8PRuf = parcelRequire("8PRuf");

var $71VJw = parcelRequire("71VJw");
const $9dbb7d1ba2164e90$export$c454496371605af = (baseUrl, rapidViewId)=>(0, $71VJw.default)(baseUrl, rapidViewId).toPromise().then((data)=>{
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return data;
    });

});
parcelRegister("71VJw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b81dd50241c07ede$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $4R6GH = parcelRequire("4R6GH");

var $fy8gS = parcelRequire("fy8gS");

var $cBLvH = parcelRequire("cBLvH");

var $l9rGV = parcelRequire("l9rGV");
const $b81dd50241c07ede$export$ba14d9a5a581e827 = (result)=>(0, $kVLXA.Observable).of(result.boardScope);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b81dd50241c07ede$export$2e2bcd8739ae039 = (contextPath, boardId)=>(0, $cBLvH.query$)(contextPath, (0, $fy8gS.softwareBoardScopeCriticalDataOperationName), (0, $fy8gS.getBoardScopeGraphqlQuery)(), {
        boardId: boardId,
        useBackendIccConfig: (0, $4R6GH.fg)('use_backend_tmp_icc_config_'),
        showIssueTransition: (0, $4R6GH.fg)('issue_transition_screen_in_jsw_tmp_board')
    }, (0, $l9rGV.boardScopeDataCriticalAnalyticsOptions)).flatMap($b81dd50241c07ede$export$ba14d9a5a581e827);

});
parcelRegister("fy8gS", function(module, exports) {

$parcel$export(module.exports, "softwareBoardScopeCriticalDataOperationName", () => $557b489490412bcc$export$33da63e9ed5a1c48);
$parcel$export(module.exports, "columnStatus", () => $557b489490412bcc$export$48a92d19f93c7dd6);
$parcel$export(module.exports, "getBoardScopeGraphqlQuery", () => $557b489490412bcc$export$f2f3dcc8e95c3168);
/*!
 * ATTENTION
 *
 * This module is used on both the main board app and its vendorless early-script entry.
 *
 * Because of this, it can't have dependencies. Feature-flagging logic should be done outside this
 * module and values should be passed in. For now changes must happen on both calls.
 */ const $557b489490412bcc$export$33da63e9ed5a1c48 = 'SoftwareBoardScopeCriticalData';
const $557b489490412bcc$export$225522b2e3455b2 = `
        editConfig {
            inlineColumnEdit {
                enabled
            }
            inlineIssueCreate @skip(if: $useBackendIccConfig){
                enabled
            }
        }
    `;
const $557b489490412bcc$export$48a92d19f93c7dd6 = `columnStatus {
            status {
                id
                name
                category
            }
            transitions {
                id
                name
                status {
                    id
                }
                originStatus { id }
                cardType { id }
                isGlobal
                isInitial
                hasConditions
				hasScreen @include(if: $showIssueTransition)
            }
        }`;
const $557b489490412bcc$export$f2f3dcc8e95c3168 = ()=>{
    const issueChildren = `issueChildren {
                id
                flagged
                done
                parentId
                estimate {
                    storyPoints
                    originalEstimate {
                        value
                        valueAsText
                    }
                }
                issue {
                    id
                    key
                    summary
                    labels
                    assignee {
                        accountId
                        displayName
                        avatarUrl
                    }
                    type { id, name, iconUrl }
                    status { id }
                    activeSprint { id }
                }
                priority {
                    name
                    iconUrl
                }
                dueDate
            }`;
    return `query ${$557b489490412bcc$export$33da63e9ed5a1c48} ($boardId: ID!, $useBackendIccConfig: Boolean!, $showIssueTransition: Boolean!) {
            boardScope(boardId: $boardId) {
                userSwimlaneStrategy
                board {
                    name
                    swimlaneStrategy
                    hasClearedIssues
                    rankCustomFieldId
                    assignees {
                        accountId
                        displayName
                        avatarUrl
                    }
                    columns {
                        id
                        name
                        maxIssueCount
                        status {
                            id
                            name
                        }
                        ${$557b489490412bcc$export$48a92d19f93c7dd6}
                        isDone
                        isInitial
                        cards {
                            id
                            flagged
                            done
                            parentId
                            estimate {
                                storyPoints
                                originalEstimate {
                                    value
                                    valueAsText
                                }
                            }
                            issue {
                                id
                                key
                                summary
                                labels
                                assignee {
                                    accountId
                                }
                                type { id, name, iconUrl }
                                status { id }
                                activeSprint { id }
                            }
                            priority {
                                name
                                iconUrl
                            }
                            dueDate
                            childIssuesMetadata { complete, total }
                        }
                    }
                    issueTypes {
                        id
                        name
                        iconUrl
                        hierarchyLevelType
                    }
                    inlineIssueCreate @skip(if: $useBackendIccConfig) { enabled }
                    ${issueChildren}
                    cards { id }
                    ${$557b489490412bcc$export$225522b2e3455b2}
                    inlineCardCreateConfig @include(if: $useBackendIccConfig)
                }
                sprints(state: [ACTIVE]) {
                    id
                    name
                    goal
                    startDate
                    endDate
                    daysRemaining
                }
                features { key, status, toggle, category }
                projectLocation {
                    id
                    key
                    name
                    isSimplifiedProject
                    issueTypes {
                        id
                        name
                        iconUrl
                        hierarchyLevelType
                    }
                }
                issueParents {
                    id
                    key
                    summary
                    issue {
                        status {
                            id
                            name
                            category
                        }
                    }
                    issueType {
                        id
                        name
                        iconUrl
                    }
                    color
                }
                currentUser { permissions }
                estimation {
                    current {
                        customFieldId
                    }
                }
            }
        }`;
};

});

parcelRegister("cBLvH", function(module, exports) {

$parcel$export(module.exports, "query$", () => $b2e62d4903324e0d$export$a332dd84c3221bf2);

var $4nUsC = parcelRequire("4nUsC");
const $b2e62d4903324e0d$export$a332dd84c3221bf2 = (baseUrl, operationName, query, variables, analyticOptions)=>(0, $4nUsC.operation$)('query', baseUrl, operationName, query, variables, analyticOptions);

});
parcelRegister("4nUsC", function(module, exports) {

$parcel$export(module.exports, "operation$", () => $9d6dd91dc35e6aa9$export$cbc7c612df05bda);
parcelRequire("fp4O3");
parcelRequire("3q49N");
parcelRequire("inj9P");
parcelRequire("64ZAE");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $9XE6b = parcelRequire("9XE6b");

var $aZFhV = parcelRequire("aZFhV");

var $kVLXA = parcelRequire("kVLXA");

var $7Jxgt = parcelRequire("7Jxgt");

var $dGrdR = parcelRequire("dGrdR");

var $dJl1T = parcelRequire("dJl1T");

var $kobfu = parcelRequire("kobfu");

var $4R6GH = parcelRequire("4R6GH");

var $487fd = parcelRequire("487fd");

var $fnyT4 = parcelRequire("fnyT4");

var $4tcSU = parcelRequire("4tcSU");

var $fjcgS = parcelRequire("fjcgS");

var $cNrxd = parcelRequire("cNrxd");

var $04zaL = parcelRequire("04zaL");
const $9d6dd91dc35e6aa9$var$sendOperationalEvent = (analyticKey, statusCode)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        // SSR doesn't have an analytics client
        if (!analyticsClient) return;
        let statusCodeFamily = 'unknown';
        if (statusCode !== null) {
            const statusCodeAsStr = String(statusCode);
            if (statusCodeAsStr === '0' || statusCodeAsStr === '429') // special status codes
            statusCodeFamily = statusCodeAsStr;
            else if (statusCodeAsStr.match(/^[12345][0-9]{2}$/)) statusCodeFamily = `${statusCodeAsStr[0]}xx`;
        }
        analyticsClient.sendOperationalEvent({
            action: 'fetch',
            actionSubject: 'swag operation',
            attributes: {
                key: analyticKey,
                statusCode: statusCode,
                statusCodeFamily: statusCodeFamily
            },
            source: 'swagOperation'
        });
    });
};
const $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark = (analyticKey, slo, statusCode, concurrentId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
bm3Interaction)=>{
    if (analyticKey !== undefined) {
        // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        $9d6dd91dc35e6aa9$var$sendOperationalEvent(analyticKey, statusCode);
        if (bm3Interaction) bm3Interaction.cancel();
    }
};
const $9d6dd91dc35e6aa9$var$callSwag$ = ({ baseUrl: baseUrl, operationName: operationName, query: query, variables: variables, action: action, headersProcessor: headersProcessor })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let headers = {};
    // set empty xsrfToken for SSR as cookies are unavailable
    const xsrfToken = false ? '' : (0, $4tcSU.default)();
    if (action === 'mutation') {
        if (!xsrfToken) (0, $dJl1T.default).safeErrorWithoutCustomerData('board.xsrf-token.load.failure', 'XSRF Token failed to load');
        headers = {
            'atl-xsrf-token': xsrfToken
        };
    }
    return (0, $487fd.default)(`${baseUrl}/jsw2/graphql?operation=${operationName}`, {
        method: 'POST',
        body: JSON.stringify({
            operationName: operationName,
            query: query,
            variables: variables
        }),
        headers: headers,
        headersProcessor: headersProcessor
    });
};
const $9d6dd91dc35e6aa9$export$cbc7c612df05bda = (action, baseUrl, operationName, query, variables, analyticOptions)=>{
    const { analyticKey: analyticKey, slo: slo, useBm3Interaction: useBm3Interaction, concurrentMetricDefinition: concurrentMetricDefinition } = analyticOptions || {};
    let traceId = '';
    const headersProcessor = (headers)=>{
        traceId = headers.get((0, $fnyT4.TRACE_ID_HEADER)) || '';
    };
    const concurrentId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4();
    let bm3Interaction = null;
    if (analyticKey && useBm3Interaction) bm3Interaction = (0, $dGrdR.metrics).interaction({
        key: analyticKey,
        // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
        histogram: {
            result: '1000_2000_3000_4000_5000_6000'
        }
    });
    return (0, $kVLXA.Observable).defer(()=>{
        if (bm3Interaction) bm3Interaction.start();
        if (concurrentMetricDefinition !== undefined) concurrentMetricDefinition(concurrentId).start();
        return $9d6dd91dc35e6aa9$var$callSwag$({
            baseUrl: baseUrl,
            operationName: operationName,
            query: query,
            variables: variables,
            action: action,
            headersProcessor: headersProcessor
        });
    }).catch((error)=>{
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'statusCode'
        ], null);
        const isRetryStatusCode = [
            502,
            503,
            504
        ].includes(Number(statusCode));
        if (isRetryStatusCode && action === 'query') return $9d6dd91dc35e6aa9$var$callSwag$({
            baseUrl: baseUrl,
            operationName: operationName,
            query: query,
            variables: variables,
            action: action,
            headersProcessor: headersProcessor
        }).do(()=>{
            (0, $04zaL.logRestRetry)({
                queryName: operationName,
                statusCode: statusCode,
                isRetrySuccessful: true,
                retryStatusCode: null
            });
        }, (retryError)=>{
            const retryStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(retryError, [
                'statusCode'
            ], null);
            (0, $04zaL.logRestRetry)({
                queryName: operationName,
                statusCode: statusCode,
                isRetrySuccessful: false,
                retryStatusCode: retryStatusCode
            });
        });
        // throw exception to the next level
        return (0, $kVLXA.Observable).throw(error);
    })// catch network error
    .catch((error)=>{
        const e = (0, (/*@__PURE__*/$parcel$interopDefault($aZFhV)))(error) ? error.message : `[unknown error] = ${JSON.stringify(error)}`;
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'statusCode'
        ], null);
        const errorName = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'name'
        ], null);
        const swagError = new (0, $cNrxd.SwagError)({
            networkError: error,
            traceId: traceId
        });
        const hash = (0, $kobfu.getErrorHash)(swagError);
        (0, $04zaL.logRestNetworkError)(e, statusCode, operationName, errorName, hash);
        $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, statusCode, concurrentId, bm3Interaction);
        return (0, $kVLXA.Observable).throw(swagError);
    }).flatMap((response)=>{
        if (!response || !response.data) (0, $04zaL.logRestParsingError)('empty response.data', operationName);
        try {
            // SWAG errors from response
            if (response.errors) {
                // eslint-disable-next-line jira/ff/no-preconditioning
                if ((0, $4R6GH.fg)('jsw_swag_response_too_many_errors_log_fix') && response.errors.length > 100) {
                    const genericMessage = `Too many Errors in response for ${operationName}`;
                    (0, $04zaL.logRestError)([
                        genericMessage
                    ], null, operationName, 'too-many-errors');
                    $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, null, concurrentId, bm3Interaction);
                    return (0, $kVLXA.Observable).throw(new (0, $cNrxd.SwagError)({
                        graphQLErrors: [
                            {
                                message: genericMessage,
                                path: [
                                    genericMessage
                                ],
                                extensions: {
                                    statusCode: null,
                                    errorType: 'too-many-errors'
                                }
                            }
                        ],
                        traceId: traceId
                    }));
                }
                const payload = response.errors.map((e)=>{
                    const { path: path, message: message } = e;
                    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'statusCode'
                    ], null);
                    const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'errorType'
                    ], undefined);
                    const userMessage = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'userMessage'
                    ], undefined);
                    (0, $04zaL.logRestError)(path, statusCode, operationName, errorType);
                    $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, statusCode, concurrentId, bm3Interaction);
                    return {
                        message: message,
                        path: path,
                        extensions: {
                            statusCode: statusCode ? Number(statusCode) : null,
                            errorType: errorType,
                            userMessage: userMessage
                        }
                    };
                });
                return (0, $kVLXA.Observable).throw(new (0, $cNrxd.SwagError)({
                    graphQLErrors: payload,
                    traceId: traceId
                }));
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const e = (0, (/*@__PURE__*/$parcel$interopDefault($aZFhV)))(error) ? error.message : `[unknown error] = ${JSON.stringify(error)}`;
            (0, $04zaL.logRestParsingError)(e, operationName);
            $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, 'unknown', concurrentId, bm3Interaction);
            throw error;
        }
        if (analyticKey !== undefined) {
            // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Response<Data>'.
            $9d6dd91dc35e6aa9$var$sendOperationalEvent(analyticKey, response.statusCode ?? '200');
            if (bm3Interaction) bm3Interaction.stop();
            if (concurrentMetricDefinition !== undefined) concurrentMetricDefinition(concurrentId).stop();
        }
        return (0, $kVLXA.Observable).of(response.data);
    });
};

});
parcelRegister("aZFhV", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");

var $1QOns = parcelRequire("1QOns");
/** `Object#toString` result references. */ var $800fa0dabdb52684$var$domExcTag = '[object DOMException]', $800fa0dabdb52684$var$errorTag = '[object Error]';
/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */ function $800fa0dabdb52684$var$isError(value) {
    if (!$fC1Kz(value)) return false;
    var tag = $beQoo(value);
    return tag == $800fa0dabdb52684$var$errorTag || tag == $800fa0dabdb52684$var$domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !$1QOns(value);
}
module.exports = $800fa0dabdb52684$var$isError;

});

parcelRegister("487fd", function(module, exports) {

$parcel$export(module.exports, "default", () => $96196282ac54fa24$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("1oQta");
parcelRequire("d0pqD");
parcelRequire("fPS7b");

var $aDvGo = parcelRequire("aDvGo");

var $x9xyg = parcelRequire("x9xyg");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $96196282ac54fa24$var$noContentStatus = 204;
const $96196282ac54fa24$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $96196282ac54fa24$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$96196282ac54fa24$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $x9xyg.setMark)(`BEGIN_${key}`);
    }
    return (0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $aDvGo.default), opts), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $x9xyg.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, str, traceId);
                else throw new (0, $jJZqs.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $96196282ac54fa24$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        return response.json();
    });
}
var $96196282ac54fa24$export$2e2bcd8739ae039 = $96196282ac54fa24$var$fetchJson$;

});

parcelRegister("04zaL", function(module, exports) {

$parcel$export(module.exports, "logApolloError", () => $1590485f1b901936$export$2c9c775c9aa1863d);
$parcel$export(module.exports, "logApolloNetworkError", () => $1590485f1b901936$export$45c096492076b53a);
$parcel$export(module.exports, "logRestError", () => $1590485f1b901936$export$9a40393cdc64dc7d);
$parcel$export(module.exports, "logRestNetworkError", () => $1590485f1b901936$export$b2eb9fe68368f77d);
$parcel$export(module.exports, "logRestParsingError", () => $1590485f1b901936$export$25d52be9f4671e9e);
$parcel$export(module.exports, "logRestRetry", () => $1590485f1b901936$export$e8ce08d55ac713ef);
$parcel$export(module.exports, "logApolloRetry", () => $1590485f1b901936$export$3e50530825dee9d1);

var $dJl1T = parcelRequire("dJl1T");
const $1590485f1b901936$var$logError = (type, m, extra)=>{
    const { message: message, path: path, queryName: queryName, statusCode: statusCode, errorType: errorType, errorName: errorName, hash: hash } = extra;
    const params = {
        message: message || '',
        path: JSON.stringify(path || []),
        statusCode: String(statusCode || '[unknown]'),
        queryName: queryName,
        errorType: errorType ? String(errorType) : '',
        errorName: errorName ? String(errorName) : '',
        hash: hash
    };
    return (0, $dJl1T.default).safeErrorWithoutCustomerData(type, m, params);
};
const $1590485f1b901936$var$SwagErrorPlaceholder = '[errors in SWAG response]';
const $1590485f1b901936$export$2c9c775c9aa1863d = (path, statusCode, queryName, errorType)=>$1590485f1b901936$var$logError('apollo.swag.error.graphql', '[GraphQL error]', {
        message: $1590485f1b901936$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
const $1590485f1b901936$export$45c096492076b53a = (networkError, statusCode, queryName)=>{
    $1590485f1b901936$var$logError('apollo.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName
    });
};
const $1590485f1b901936$export$9a40393cdc64dc7d = (path, statusCode, queryName, errorType)=>{
    $1590485f1b901936$var$logError('rest.swag.error.graphql', '[GraphQL error]', {
        message: $1590485f1b901936$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
};
const $1590485f1b901936$export$b2eb9fe68368f77d = (networkError, statusCode, queryName, errorName, hash)=>{
    $1590485f1b901936$var$logError('rest.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName,
        errorName: errorName,
        hash: hash
    });
};
const $1590485f1b901936$export$25d52be9f4671e9e = (error, queryName)=>{
    $1590485f1b901936$var$logError('rest.swag.error.parsing', '[Parsing error]', {
        message: `[Parsing error]: ${error}`,
        queryName: queryName
    });
};
const $1590485f1b901936$export$e8ce08d55ac713ef = ({ queryName: queryName, statusCode: statusCode, isRetrySuccessful: isRetrySuccessful, retryStatusCode: retryStatusCode })=>(0, $dJl1T.default).safeErrorWithoutCustomerData('rest.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode || '',
        isRetrySuccessful: String(isRetrySuccessful),
        retryStatusCode: retryStatusCode || ''
    });
const $1590485f1b901936$export$3e50530825dee9d1 = ({ queryName: queryName, statusCode: statusCode })=>(0, $dJl1T.default).safeErrorWithoutCustomerData('apollo.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode
    });

});



parcelRegister("l9rGV", function(module, exports) {

$parcel$export(module.exports, "boardScopeDataCriticalAnalyticsOptions", () => $704c21e5cce64332$export$6d18ac14fb11db9a);
const $704c21e5cce64332$var$APP_METRIC_KEY = 'software.next-gen.boards';
const $704c21e5cce64332$var$BOARD_SCOPE_CRITICAL_METRIC_KEY = `${$704c21e5cce64332$var$APP_METRIC_KEY}.boardscope.critical`;
const $704c21e5cce64332$var$BOARD_SCOPE_CRITICAL_SLO = 1000;
const $704c21e5cce64332$export$6d18ac14fb11db9a = {
    analyticKey: $704c21e5cce64332$var$BOARD_SCOPE_CRITICAL_METRIC_KEY,
    slo: $704c21e5cce64332$var$BOARD_SCOPE_CRITICAL_SLO
};

});





parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $bNvU3 = parcelRequire("bNvU3");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bNvU3.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1u3Jv = parcelRequire("1u3Jv");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1u3Jv.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $dJl1T = parcelRequire("dJl1T");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $6BZYo.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $dJl1T.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("6XsPQ", function(module, exports) {

$parcel$export(module.exports, "HistoryAdapter", () => $c364a1ba7d823379$export$d852f51b8427aefc);

var $5uXOq = parcelRequire("5uXOq");

var $dIdda = parcelRequire("dIdda");

var $8oKIZ = parcelRequire("8oKIZ");
// eslint-disable-next-line jira/react/no-class-components
class $c364a1ba7d823379$var$HistoryAdapterComponent extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.compatibleHistory = (0, $8oKIZ.createReactRouterCompatibleHistory)(props.history);
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.children !== this.props.children;
    }
    componentWillUnmount() {
        this.compatibleHistory.destroy && this.compatibleHistory.destroy();
    }
    render() {
        const { children: children } = this.props;
        return children(this.compatibleHistory);
    }
}
const $c364a1ba7d823379$export$d852f51b8427aefc = (0, $dIdda.withRouter)($c364a1ba7d823379$var$HistoryAdapterComponent);

});
parcelRegister("8oKIZ", function(module, exports) {

$parcel$export(module.exports, "createReactRouterCompatibleHistory", () => $e043da36553b4806$export$2df73cd79c2401bf);

var $bxYf9 = parcelRequire("bxYf9");
const $e043da36553b4806$export$2df73cd79c2401bf = (history)=>{
    let cleaned = false;
    let listeners = [];
    // @ts-expect-error - TS2304 - Cannot find name 'HistoryAction'.
    const listen = (callback)=>{
        if (cleaned) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const unsubscribe = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(history.listen(callback));
        const listener = {
            unsubscribe: unsubscribe
        };
        listeners.push(listener);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(()=>{
            listener.unsubscribe();
        });
    };
    const cleanup = ()=>{
        listeners.forEach(({ unsubscribe: unsubscribe })=>{
            unsubscribe();
        });
        cleaned = true;
        listeners = [];
    };
    return {
        get length () {
            return history.length;
        },
        get location () {
            return history.location;
        },
        get action () {
            return history.action;
        },
        get index () {
            return history.index;
        },
        get entries () {
            return history.entries;
        },
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        push: (path, state)=>history.push(path, state),
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        replace: (path, state)=>history.replace(path, state),
        // @ts-expect-error - TS7006 - Parameter 'n' implicitly has an 'any' type.
        go: (n)=>history.go(n),
        goBack: ()=>history.goBack(),
        goForward: ()=>history.goForward(),
        // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
        createHref: (...args)=>history.createHref(...args),
        // Memory only
        // @ts-expect-error - TS7006 - Parameter 'n' implicitly has an 'any' type.
        canGo: (n)=>{
            if (history.canGo) return history.canGo(n);
            return true;
        },
        listen: listen,
        // @ts-expect-error - TS7006 - Parameter 'blocker' implicitly has an 'any' type.
        block: (blocker)=>history.block(blocker),
        destroy: cleanup
    };
};

});


parcelRegister("k6PKo", function(module, exports) {

$parcel$export(module.exports, "renderBoardApp", () => $ff48902f5a4fd7db$export$23d0ab3b8e29eb8a);

var $5uXOq = parcelRequire("5uXOq");

var $6BZYo = parcelRequire("6BZYo");

var $2vSU6 = parcelRequire("2vSU6");

var $iqr2y = parcelRequire("iqr2y");

var $4tcSU = parcelRequire("4tcSU");

var $feJRr = parcelRequire("feJRr");

var $6awMq = parcelRequire("6awMq");

var $jST59 = parcelRequire("jST59");

var $5sgUt = parcelRequire("5sgUt");

var $7LEyz = parcelRequire("7LEyz");

var $8R2g1 = parcelRequire("8R2g1");

var $dZw8H = parcelRequire("dZw8H");
// @ts-expect-error - TS7006 - Parameter 'callback' implicitly has an 'any' type.
const $ff48902f5a4fd7db$var$bindToOnJiraGlobalIssueCreateClose = (callback)=>{
    // window.require is not available on initial script load.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $6BZYo.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    }).then((Events)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        Events?.bind?.('QuickCreateIssue.sessionComplete', callback);
    });
};
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $ff48902f5a4fd7db$var$noop = ()=>{};
const $ff48902f5a4fd7db$export$23d0ab3b8e29eb8a = ({ rapidViewId: rapidViewId, projectKey: projectKey, projectType: projectType = (0, $2vSU6.SOFTWARE_PROJECT), context: { tenantContext: tenantContext }, boardData: boardData, cmpBoardData: cmpBoardData, history: history, isCacheHit: isCacheHit, customFiltersQueryRef: customFiltersQueryRef, isCMPBoard: isCMPBoard })=>{
    const { error: prefetchError, loading: boardPrefetchIsLoading } = boardData || cmpBoardData || {};
    const { data: data } = boardData || {};
    const isCustomFiltersReady = customFiltersQueryRef !== null;
    // Terminate loading cases early
    if (!isCMPBoard && (boardPrefetchIsLoading || !isCustomFiltersReady)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6awMq.NextGenBoardSkeleton), null);
    // If we find any prefetch error or the data is null/invalid for any reason this is a failure
    if (!isCMPBoard && (prefetchError || !data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8R2g1.BoardSlaTracker), {
        boardData: boardData || cmpBoardData
    }), (0, $5sgUt.isBoardSizeLimitError)(prefetchError) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7LEyz.default), {
        projectKey: projectKey
    }) : // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null | undefined' is not assignable to type 'Error | null'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqr2y.ErrorFlagRenderer), {
        id: "next-gen-board",
        error: prefetchError
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
        key: rapidViewId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $feJRr.default), {
        name: "configApiReady"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jST59.default), {
        isCMPBoard: isCMPBoard === true,
        isCacheHit: isCacheHit,
        locale: tenantContext.locale,
        /* eslint-disable-next-line jira/deprecations/no-base-url */ contextPath: tenantContext.baseUrl,
        cloudId: tenantContext.cloudId,
        activationId: tenantContext.activationId,
        rapidViewId: rapidViewId,
        projectKey: projectKey || '',
        projectId: Number(data?.projectLocation.id || ''),
        projectType: projectType,
        userAccountId: tenantContext.atlassianAccountId || '',
        xsrfToken: (0, $4tcSU.default)() || '',
        bindToOnJiraGlobalIssueCreateClose: $ff48902f5a4fd7db$var$bindToOnJiraGlobalIssueCreateClose,
        prefetchedData: data,
        cmpBoardData: cmpBoardData?.promise ?? null,
        siteAdminStatus: tenantContext.siteAdminStatus,
        licensedProducts: tenantContext.licensedProducts,
        productCrossSellConfig: tenantContext.productCrossSellConfig,
        onUnmount: $ff48902f5a4fd7db$var$noop,
        isServer: false,
        history: history,
        customFiltersQueryRef: customFiltersQueryRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null));
};

});
parcelRegister("feJRr", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa35a5a19d0a4620$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bNvU3 = parcelRequire("bNvU3");

var $8Qrwl = parcelRequire("8Qrwl");
class $aa35a5a19d0a4620$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { name: name } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Qrwl.default).Consumer, null, ({ pageId: pageId, onCustomMark: onCustomMark })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bNvU3.default), {
                op: onCustomMark,
                args: [
                    name,
                    pageId
                ]
            }));
    }
}

});

parcelRegister("jST59", function(module, exports) {

$parcel$export(module.exports, "default", () => $1712308f25f5ee94$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $imZsD = parcelRequire("imZsD");

var $AeWM3 = parcelRequire("AeWM3");

var $aWb5p = parcelRequire("aWb5p");

var $jD5no = parcelRequire("jD5no");

var $lKocD = parcelRequire("lKocD");

var $2vSU6 = parcelRequire("2vSU6");

var $x9xyg = parcelRequire("x9xyg");

var $bRUzT = parcelRequire("bRUzT");

var $heNNl = parcelRequire("heNNl");

var $wKznQ = parcelRequire("wKznQ");

var $97Kan = parcelRequire("97Kan");

var $joFsm = parcelRequire("joFsm");

var $5sUih = parcelRequire("5sUih");

var $8PRuf = parcelRequire("8PRuf");


var $6jwh3 = parcelRequire("6jwh3");

var $iUagi = parcelRequire("iUagi");

var $i6HlS = parcelRequire("i6HlS");


var $4ldpW = parcelRequire("4ldpW");

var $jQCwr = parcelRequire("jQCwr");

var $jM0wW = parcelRequire("jM0wW");

var $67sX6 = parcelRequire("67sX6");

var $65C0W = parcelRequire("65C0W");

var $cW3pH = parcelRequire("cW3pH");

var $67Z81 = parcelRequire("67Z81");

var $a9mbK = parcelRequire("a9mbK");

var $b5JVP = parcelRequire("b5JVP");

var $j0iXE = parcelRequire("j0iXE");

var $gru50 = parcelRequire("gru50");

var $buSp0 = parcelRequire("buSp0");

var $4zzhM = parcelRequire("4zzhM");
class $1712308f25f5ee94$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onUnmount: ()=>{},
            isCMPBoard: false,
            isIncrementPlanningBoard: false,
            projectType: (0, $2vSU6.SOFTWARE_PROJECT)
        };
    }
    constructor(props){
        super(props);
        this.hasRendered = false;
        const { contextPath: contextPath, rapidViewId: rapidViewId, projectKey: projectKey, projectId: projectId, projectType: projectType, cloudId: cloudId, activationId: activationId, userAccountId: userAccountId, locale: locale, bindToOnJiraGlobalIssueCreateClose: bindToOnJiraGlobalIssueCreateClose, licensedProducts: licensedProducts, siteAdminStatus: siteAdminStatus, productCrossSellConfig: productCrossSellConfig, isServer: isServer, history: history, isCMPBoard: isCMPBoard, disableStoreCaches: disableStoreCaches, isIncrementPlanningBoard: /**
			 * ARJ increment planning board
			 */ isIncrementPlanningBoard, planId: planId, scenarioId: scenarioId, customRequestHandlers: customRequestHandlers } = props;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const initialState = {
            configuration: {
                contextPath: contextPath,
                rapidViewId: String(rapidViewId),
                projectKey: projectKey,
                projectId: projectId,
                projectType: projectType,
                cloudId: cloudId,
                activationId: activationId,
                userAccountId: userAccountId,
                locale: locale,
                licensedProducts: licensedProducts,
                siteAdminStatus: siteAdminStatus,
                productCrossSellConfig: productCrossSellConfig,
                sessionId: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4(),
                isCMPBoard: isCMPBoard,
                isIncrementPlanningBoard: /**
				 * ARJ increment planning board
				 */ isIncrementPlanningBoard,
                planId: planId,
                scenarioId: scenarioId
            },
            ui: {
                swimlane: {
                    collapsed: (0, $jQCwr.getCollapsedSwimlanes)(rapidViewId)
                },
                ...isCMPBoard && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                !window.location.search && {
                    workFilters: {
                        values: (0, $wKznQ.getCachedFilters)('board', rapidViewId) ?? {}
                    }
                }
            }
        };
        (0, $x9xyg.setMark)((0, $8PRuf.jswCreateReduxStoreStartMark));
        this.store = isCMPBoard ? (0, $67sX6.createStoreWithCache)(String(rapidViewId), initialState, {
            isCMPBoard: isCMPBoard,
            isServer: isServer,
            projectType: projectType,
            disableStoreCaches: disableStoreCaches ?? false,
            swagClient: (0, $AeWM3.getClient)(contextPath, (0, $aWb5p.default), this.props.xsrfToken)
        }) : (0, $67sX6.default)(initialState, {
            isCMPBoard: isCMPBoard,
            isServer: isServer,
            projectType: projectType,
            swagClient: (0, $AeWM3.getClient)(contextPath, (0, $aWb5p.default), this.props.xsrfToken),
            // noop in this position
            disableStoreCaches: false,
            customRequestHandlers: customRequestHandlers
        });
        (0, $x9xyg.setMark)((0, $8PRuf.jswCreateReduxStoreEndMark));
        // In increment planning board, there are URL params set by other packages, eg. software/view-settings
        const keepNonManagedParams = isIncrementPlanningBoard || (0, $iUagi.isTailoredViewExperimentEnabled)();
        this.unsubscribeUrlBindings = (0, $lKocD.default)(this.store, [
            ...(0, $4ldpW.default)(isCMPBoard),
            ...(0, $jM0wW.default)(isIncrementPlanningBoard)
        ], keepNonManagedParams, history);
        // let's update store before it's attached to virtual DOM
        this.store.dispatch((0, $65C0W.softwareAppLoaded)(props.prefetchedData, props.cmpBoardData));
        bindToOnJiraGlobalIssueCreateClose((event, issues, triggerSource)=>{
            this.store.dispatch((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$8cabdc85b8691f12), issues, triggerSource));
        });
    }
    componentDidMount() {
        this.hasRendered = true;
    }
    componentWillUnmount() {
        this.unsubscribeUrlBindings();
        if (this.store) {
            if ((0, $67Z81.getIsCMPBoard)(this.store.getState())) this.store.dispatch((0, $cW3pH.beforeDispose));
            this.store.dispatch((0, $bRUzT.DISPOSE_ACTION));
        }
        this.props.onUnmount();
        (0, $67sX6.unmountCachedStore)();
    }
    render() {
        if (!this.hasRendered) (0, $x9xyg.setMark)((0, $8PRuf.jswRenderStartMark));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $AeWM3.ApolloClientProvider), {
            client: (0, $aWb5p.default)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            id: (0, $dcbb2bce513725b3$export$d76071d5de2774fc),
            store: this.store,
            teamName: (0, $dcbb2bce513725b3$export$d57b6b390e78d90f),
            packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
            fallback: "page"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67sX6.BoardReduxProvider), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5sUih.default).Provider, {
            value: {
                scenarioId: this.props.scenarioId,
                planId: this.props.planId
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9mbK.default), {
            isCacheHit: this.props.isCacheHit,
            rapidViewId: (0, $67Z81.rapidViewIdSelector)(this.store.getState()),
            xsrfToken: this.props.xsrfToken,
            hasMinimap: !this.props.isServer,
            hasModals: !this.props.isServer,
            hasFlags: !this.props.isServer,
            customFiltersQueryRef: this.props.customFiltersQueryRef,
            projectId: (0, $67Z81.projectIdSelector)(this.store.getState()),
            isIncrementPlanningBoard: this.props.isIncrementPlanningBoard
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $97Kan.FlagsDispatcher), {
            mapper: (0, $i6HlS.flagsMapper)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
            id: "async-resources-cache-wrapper",
            packageName: "software-board"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6jwh3.AsyncResourcesCacheWrapper), {
            origin: (0, $8631d6ce464ccf2e$export$9b8283d5878d2491)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zzhM.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $joFsm.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5JVP.AllFieldsSync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gru50.FiltersStorage), null), (0, $iUagi.isTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $buSp0.SwimlaneModeFromUrl), null), this.props.isIncrementPlanningBoard && this.props.boardApiRef !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j0iXE.default), {
            boardApiRef: this.props.boardApiRef
        }))))));
    }
}

});
parcelRegister("AeWM3", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $63ae5caf575c2d55$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "getClient", () => $63ae5caf575c2d55$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $63ae5caf575c2d55$export$8e363dbef886ff17);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $bvsgq = parcelRequire("bvsgq");

var $9OXo1 = parcelRequire("9OXo1");
const $63ae5caf575c2d55$var$CLIENTS_CACHE = {};
const $63ae5caf575c2d55$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
};
const $63ae5caf575c2d55$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($63ae5caf575c2d55$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $63ae5caf575c2d55$var$CLIENTS_CACHE[key].extract()
        }), {});
const $63ae5caf575c2d55$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $63ae5caf575c2d55$export$8e363dbef886ff17 extends (0, $5uXOq.Component) {
    getClient(baseUrl, xsrfToken) {
        return $63ae5caf575c2d55$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvsgq.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});
parcelRegister("bvsgq", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $02296d7a3662bd2d$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $02296d7a3662bd2d$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $02296d7a3662bd2d$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $02296d7a3662bd2d$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $02296d7a3662bd2d$export$8f49e4af10703ce3);

var $5uXOq = parcelRequire("5uXOq");

var $1DiV8 = parcelRequire("1DiV8");
var $02296d7a3662bd2d$var$apolloContext;
function $02296d7a3662bd2d$export$a47505d961ee3a1() {
    if (!$02296d7a3662bd2d$var$apolloContext) $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
    return $02296d7a3662bd2d$var$apolloContext;
}
function $02296d7a3662bd2d$export$c2ee824bcc89ca6a() {
    $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
}
var $02296d7a3662bd2d$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $1DiV8.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $02296d7a3662bd2d$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $1DiV8.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $02296d7a3662bd2d$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($02296d7a3662bd2d$export$d1d99cf900472499 || ($02296d7a3662bd2d$export$d1d99cf900472499 = {}));
var $02296d7a3662bd2d$var$cache = new Map();
function $02296d7a3662bd2d$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $02296d7a3662bd2d$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $02296d7a3662bd2d$export$8f49e4af10703ce3(document) {
    var cached = $02296d7a3662bd2d$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $1DiV8.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $1DiV8.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $1DiV8.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $02296d7a3662bd2d$export$d1d99cf900472499.Query : $02296d7a3662bd2d$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $02296d7a3662bd2d$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $1DiV8.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $02296d7a3662bd2d$var$cache.set(document, payload);
    return payload;
}

});


parcelRegister("aWb5p", function(module, exports) {

$parcel$export(module.exports, "default", () => $de6560d9e86b64da$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $ivfDv = parcelRequire("ivfDv");

var $e3a3O = parcelRequire("e3a3O");

var $clSzL = parcelRequire("clSzL");

var $43WKH = parcelRequire("43WKH");

var $h4ppL = parcelRequire("h4ppL");

var $JPsIz = parcelRequire("JPsIz");

var $lC4FX = parcelRequire("lC4FX");

var $cuKXc = parcelRequire("cuKXc");

var $4tcSU = parcelRequire("4tcSU");

var $04zaL = parcelRequire("04zaL");

var $dxpxC = parcelRequire("dxpxC");

var $5uTwE = parcelRequire("5uTwE");



const $de6560d9e86b64da$var$retryLink = new (0, $lC4FX.RetryLink)({
    attempts: {
        max: 2,
        retryIf: (networkError, operation)=>{
            const { operationName: operationName } = operation;
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(networkError, [
                'statusCode'
            ], null);
            // retry once when SWAG Node is dead.
            const shouldRetry = [
                502,
                503,
                504
            ].includes(Number(statusCode));
            if (shouldRetry) (0, $04zaL.logApolloRetry)({
                queryName: operationName,
                statusCode: statusCode
            });
            return shouldRetry;
        }
    }
});
const $de6560d9e86b64da$var$errorLink = (0, $h4ppL.onError)(({ operation: operation, graphQLErrors: graphQLErrors, networkError: networkError })=>{
    const { operationName: operationName } = operation;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ path: path, extensions: extensions })=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(extensions, [
                'statusCode'
            ], null);
            const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(extensions, [
                'errorType'
            ], null);
            return (0, $04zaL.logApolloError)(path, statusCode, operationName, errorType);
        });
        else (0, $04zaL.logRestParsingError)('Unexpected error message format', JSON.stringify(graphQLErrors));
    }
    if (networkError) {
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(networkError, [
            'statusCode'
        ], null);
        (0, $04zaL.logApolloNetworkError)(networkError.toString(), statusCode, operationName);
    }
});
// Exporting fragmentMatcher to use it in StoryBook examples
const $de6560d9e86b64da$var$fragmentMatcher = new (0, $ivfDv.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($5uTwE))
});
const $de6560d9e86b64da$var$cacheConfig = {
    cacheRedirects: {
        Query: {
            ...(0, $cuKXc.fragmentCacheRedirect)()
        }
    },
    freezeResults: true,
    fragmentMatcher: $de6560d9e86b64da$var$fragmentMatcher
};
const $de6560d9e86b64da$var$cache = new (0, $ivfDv.InMemoryCache)($de6560d9e86b64da$var$cacheConfig);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $de6560d9e86b64da$var$customFetch = (uri, options)=>{
    const body = options && options.body ? JSON.parse(options.body) : null;
    return fetch(`${uri}?operation=${body ? body.operationName : 'unknown'}`, options);
};
const $de6560d9e86b64da$var$xsrfLink = ()=>(0, $43WKH.setContext)((operation, previousContext)=>{
        const { headers: headers } = previousContext;
        // set empty xsrfToken for SSR as cookies are unavailable
        const xsrfToken = false ? '' : (0, $4tcSU.default)();
        if (!xsrfToken) return previousContext;
        return {
            ...previousContext,
            headers: {
                ...headers,
                'atl-xsrf-token': xsrfToken
            }
        };
    });
const $de6560d9e86b64da$var$clientCreator = (baseUrl)=>new (0, $e3a3O.ApolloClient)({
        name: 'SWAG',
        link: (0, $clSzL.ApolloLink).from([
            $de6560d9e86b64da$var$retryLink,
            $de6560d9e86b64da$var$xsrfLink(),
            $de6560d9e86b64da$var$errorLink,
            (0, $dxpxC.UFOLoggerLink),
            (0, $cuKXc.fragmentLinkState)($de6560d9e86b64da$var$cache),
            new (0, $JPsIz.HttpLink)({
                uri: `${baseUrl}/jsw2/graphql`,
                credentials: 'same-origin',
                fetch: $de6560d9e86b64da$var$customFetch
            })
        ]),
        cache: $de6560d9e86b64da$var$cache,
        assumeImmutableResults: true
    });
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$de6560d9e86b64da$export$2e2bcd8739ae039 = {
    clientId: 'SWAG',
    clientCreator: $de6560d9e86b64da$var$clientCreator
};

});
parcelRegister("ivfDv", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $d7874048ca668ecb$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $d7874048ca668ecb$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $d7874048ca668ecb$export$467265324939f47f);

var $3VFsf = parcelRequire("3VFsf");

var $hzuXv = parcelRequire("hzuXv");

var $jojW6 = parcelRequire("jojW6");
var $bqMzA = parcelRequire("bqMzA");

var $gLy2H = parcelRequire("gLy2H");

var $1DiV8 = parcelRequire("1DiV8");
var $d7874048ca668ecb$var$haveWarned = false;
function $d7874048ca668ecb$var$shouldWarn() {
    var answer = !$d7874048ca668ecb$var$haveWarned;
    if (!(0, $jojW6.isTest)()) $d7874048ca668ecb$var$haveWarned = true;
    return answer;
}
var $d7874048ca668ecb$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $d7874048ca668ecb$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $d7874048ca668ecb$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $d7874048ca668ecb$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $1DiV8.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $1DiV8.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $d7874048ca668ecb$var$hasOwn = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $gLy2H.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($d7874048ca668ecb$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$d7874048ca668ecb$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $d7874048ca668ecb$var$defaultNormalizedCacheFactory(seed) {
    return new $d7874048ca668ecb$var$DepTrackingCache(seed);
}
var $d7874048ca668ecb$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $gLy2H.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $gLy2H.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $gLy2H.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $jojW6.getQueryDefinition)(query);
        variables = (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $1DiV8.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $bqMzA.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d7874048ca668ecb$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $jojW6.getMainDefinition)(query);
        var fragments = (0, $jojW6.getFragmentDefinitions)(query);
        var fragmentMap = (0, $jojW6.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $jojW6.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $1DiV8.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $jojW6.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $jojW6.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $jojW6.resultKeyNameFromField)(field),
            directives: (0, $jojW6.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $jojW6.isIdValue)(value)) throw new (0, $1DiV8.InvariantError)(10);
}
function $d7874048ca668ecb$var$defaultFragmentMatcher() {
    return true;
}
function $d7874048ca668ecb$export$7a4899fe13f33235(idValue) {
    (0, $1DiV8.invariant)((0, $jojW6.isIdValue)(idValue), 11);
}
function $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $jojW6.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $jojW6.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $jojW6.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $d7874048ca668ecb$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $d7874048ca668ecb$export$7e2b40d1002de152(seed) {
    return new $d7874048ca668ecb$export$ee7258b8691956a3(seed);
}
var $d7874048ca668ecb$export$de4e6870dc6ac801 = function(_super) {
    (0, $3VFsf.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $d7874048ca668ecb$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $d7874048ca668ecb$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $d7874048ca668ecb$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $jojW6.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $jojW6.createFragmentMap)((0, $jojW6.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $d7874048ca668ecb$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var resultFieldKey = (0, $jojW6.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $1DiV8.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $jojW6.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $d7874048ca668ecb$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $jojW6.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $jojW6.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$d7874048ca668ecb$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $1DiV8.invariant)(!semanticId || !$d7874048ca668ecb$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $jojW6.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $jojW6.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $1DiV8.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $1DiV8.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $d7874048ca668ecb$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $bqMzA.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $jojW6.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $d7874048ca668ecb$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $d7874048ca668ecb$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $jojW6.isIdValue)(value) && $d7874048ca668ecb$var$isGeneratedId(value.id) && (0, $jojW6.isIdValue)(realValue) && !(0, $bqMzA.equal)(value, realValue) && $d7874048ca668ecb$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, generated), real);
    if ((0, $bqMzA.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $d7874048ca668ecb$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $d7874048ca668ecb$var$defaultConfig = {
    fragmentMatcher: new $d7874048ca668ecb$export$5d3fcf53267091de(),
    dataIdFromObject: $d7874048ca668ecb$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $d7874048ca668ecb$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $d7874048ca668ecb$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$OptimisticCacheLayer = function(_super) {
    (0, $3VFsf.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $d7874048ca668ecb$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($d7874048ca668ecb$export$ee7258b8691956a3);
var $d7874048ca668ecb$export$467265324939f47f = function(_super) {
    (0, $3VFsf.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, $d7874048ca668ecb$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $d7874048ca668ecb$var$DepTrackingCache() : new $d7874048ca668ecb$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $d7874048ca668ecb$export$eb8361c5d132fb8f();
        _this.storeReader = new $d7874048ca668ecb$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $gLy2H.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $d7874048ca668ecb$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $1DiV8.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $d7874048ca668ecb$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d7874048ca668ecb$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $jojW6.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $hzuXv.ApolloCache));

});
parcelRegister("hzuXv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $ccadb856bf057658$export$5fc74f25506aa9c);

var $jojW6 = parcelRequire("jojW6");
function $ccadb856bf057658$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $ccadb856bf057658$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $ccadb856bf057658$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $ccadb856bf057658$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $ccadb856bf057658$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $ccadb856bf057658$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $ccadb856bf057658$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $ccadb856bf057658$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $ccadb856bf057658$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $ccadb856bf057658$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $ccadb856bf057658$export$94affb487e701bf2;
$ccadb856bf057658$export$94affb487e701bf2 || ($ccadb856bf057658$export$94affb487e701bf2 = {});

});

parcelRegister("gLy2H", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $c34b71496108423e$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $c34b71496108423e$export$4997ffc0176396a6);

var $jFbNy = parcelRequire("jFbNy");
function $c34b71496108423e$var$defaultDispose() {}
var $c34b71496108423e$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $c34b71496108423e$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $c34b71496108423e$var$parentEntrySlot = new (0, $jFbNy.Slot)();
var $c34b71496108423e$var$reusableEmptyArray = [];
var $c34b71496108423e$var$emptySetPool = [];
var $c34b71496108423e$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $c34b71496108423e$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $c34b71496108423e$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $c34b71496108423e$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $c34b71496108423e$var$valueCopy(value) {
    return value.slice(0);
}
var $c34b71496108423e$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $c34b71496108423e$var$assert(!this.recomputing, "already recomputing");
        if (!$c34b71496108423e$var$rememberParent(this) && $c34b71496108423e$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $c34b71496108423e$var$mightBeDirty(this) ? $c34b71496108423e$var$reallyRecompute(this) : $c34b71496108423e$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $c34b71496108423e$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $c34b71496108423e$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $c34b71496108423e$var$forgetChildren(this).forEach($c34b71496108423e$var$maybeReportOrphan);
        $c34b71496108423e$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $c34b71496108423e$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $c34b71496108423e$var$rememberParent(child) {
    var parent = $c34b71496108423e$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($c34b71496108423e$var$mightBeDirty(child)) $c34b71496108423e$var$reportDirtyChild(parent, child);
        else $c34b71496108423e$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $c34b71496108423e$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $c34b71496108423e$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $c34b71496108423e$var$parentEntrySlot.withValue(entry, $c34b71496108423e$var$recomputeNewValue, [
        entry
    ]);
    if ($c34b71496108423e$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $c34b71496108423e$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($c34b71496108423e$var$maybeReportOrphan);
    return $c34b71496108423e$var$valueGet(entry.value);
}
function $c34b71496108423e$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $c34b71496108423e$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $c34b71496108423e$var$setClean(entry) {
    entry.dirty = false;
    if ($c34b71496108423e$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $c34b71496108423e$var$reportClean(entry);
}
function $c34b71496108423e$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportDirtyChild(parent, child);
    });
}
function $c34b71496108423e$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $c34b71496108423e$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert($c34b71496108423e$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $c34b71496108423e$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $c34b71496108423e$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $c34b71496108423e$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert(!$c34b71496108423e$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $c34b71496108423e$var$valueCopy(child.value));
    else if (!$c34b71496108423e$var$valueIs(childValue, child.value)) parent.setDirty();
    $c34b71496108423e$var$removeDirtyChild(parent, child);
    if ($c34b71496108423e$var$mightBeDirty(parent)) return;
    $c34b71496108423e$var$reportClean(parent);
}
function $c34b71496108423e$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($c34b71496108423e$var$emptySetPool.length < $c34b71496108423e$var$POOL_TARGET_SIZE) $c34b71496108423e$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $c34b71496108423e$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $c34b71496108423e$var$forgetChildren(parent) {
    var children = $c34b71496108423e$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $c34b71496108423e$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $c34b71496108423e$var$assert(parent.dirtyChildren === null);
    return children;
}
function $c34b71496108423e$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $c34b71496108423e$var$removeDirtyChild(parent, child);
}
function $c34b71496108423e$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $c34b71496108423e$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $c34b71496108423e$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $c34b71496108423e$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $c34b71496108423e$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $c34b71496108423e$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $c34b71496108423e$var$keyTrie = new $c34b71496108423e$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $c34b71496108423e$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $c34b71496108423e$var$keyTrie.lookupArray(args);
}
var $c34b71496108423e$var$caches = new Set();
function $c34b71496108423e$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $c34b71496108423e$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $c34b71496108423e$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$c34b71496108423e$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $c34b71496108423e$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $c34b71496108423e$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$c34b71496108423e$var$parentEntrySlot.hasValue()) {
            $c34b71496108423e$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $c34b71496108423e$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("jFbNy", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $e50aff8f879ebe36$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $e50aff8f879ebe36$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $e50aff8f879ebe36$var$MISSING_VALUE = {};
var $e50aff8f879ebe36$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $e50aff8f879ebe36$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $e50aff8f879ebe36$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $e50aff8f879ebe36$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $e50aff8f879ebe36$var$MISSING_VALUE) break;
                if (context_1 !== $e50aff8f879ebe36$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $e50aff8f879ebe36$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($e50aff8f879ebe36$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $e50aff8f879ebe36$var$currentContext.slots[this.id] = $e50aff8f879ebe36$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $e50aff8f879ebe36$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $e50aff8f879ebe36$var$currentContext;
            $e50aff8f879ebe36$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $e50aff8f879ebe36$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $e50aff8f879ebe36$var$currentContext;
            return function() {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($e50aff8f879ebe36$var$currentContext) {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $e50aff8f879ebe36$var$globalKey = "@wry/context:Slot";
var $e50aff8f879ebe36$var$host = Array;
var $e50aff8f879ebe36$export$8c6ed5c666ac1360 = $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] || function() {
    var Slot = $e50aff8f879ebe36$var$makeSlotClass();
    try {
        Object.defineProperty($e50aff8f879ebe36$var$host, $e50aff8f879ebe36$var$globalKey, {
            value: $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $e50aff8f879ebe36$export$2385a24977818dd0 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.bind, $e50aff8f879ebe36$export$9fa6f2e300a97f8 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.noContext;
function $e50aff8f879ebe36$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($e50aff8f879ebe36$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $e50aff8f879ebe36$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $e50aff8f879ebe36$export$2385a24977818dd0(gen.next);
        var boundThrow = $e50aff8f879ebe36$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($e50aff8f879ebe36$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $e50aff8f879ebe36$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $e50aff8f879ebe36$var$wrappedFibers = [];
function $e50aff8f879ebe36$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($e50aff8f879ebe36$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $e50aff8f879ebe36$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $e50aff8f879ebe36$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("43WKH", function(module, exports) {

$parcel$export(module.exports, "setContext", () => $2f550436daecafe0$export$2f04de43fe27971a);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $2f550436daecafe0$export$2f04de43fe27971a(setter) {
    return new (0, $clSzL.ApolloLink)(function(operation, forward) {
        var request = (0, $3VFsf.__rest)(operation, []);
        return new (0, $clSzL.Observable)(function(observer) {
            var handle;
            Promise.resolve(request).then(function(req) {
                return setter(req, operation.getContext());
            }).then(operation.setContext).then(function() {
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            }).catch(observer.error.bind(observer));
            return function() {
                if (handle) handle.unsubscribe();
            };
        });
    });
}

});

parcelRegister("h4ppL", function(module, exports) {

$parcel$export(module.exports, "onError", () => $c6d6862dd229df53$export$2288787135a8f66e);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $c6d6862dd229df53$export$2288787135a8f66e(errorHandler) {
    return new (0, $clSzL.ApolloLink)(function(operation, forward) {
        return new (0, $clSzL.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $c6d6862dd229df53$export$d2c8415987899609 = function(_super) {
    (0, $3VFsf.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $c6d6862dd229df53$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("JPsIz", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $089c1f6736cf7295$export$f4bbf1aec241cc1);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");

var $f0Elb = parcelRequire("f0Elb");
var $089c1f6736cf7295$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $3VFsf.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $f0Elb.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $clSzL.ApolloLink)(function(operation) {
        var chosenURI = (0, $f0Elb.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $3VFsf.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $f0Elb.selectHttpOptionsAndBody)(operation, (0, $f0Elb.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $f0Elb.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $clSzL.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $f0Elb.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $clSzL.fromError)(parseError);
        }
        return new (0, $clSzL.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $f0Elb.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $f0Elb.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $f0Elb.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $089c1f6736cf7295$export$f4bbf1aec241cc1 = function(_super) {
    (0, $3VFsf.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $089c1f6736cf7295$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $clSzL.ApolloLink));

});
parcelRegister("f0Elb", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $aed625edf13c57eb$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $aed625edf13c57eb$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $aed625edf13c57eb$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $aed625edf13c57eb$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $aed625edf13c57eb$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $aed625edf13c57eb$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $aed625edf13c57eb$export$63ccc2571850f81a);

var $3VFsf = parcelRequire("3VFsf");

var $1c8Um = parcelRequire("1c8Um");

var $1DiV8 = parcelRequire("1DiV8");
var $aed625edf13c57eb$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $aed625edf13c57eb$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $aed625edf13c57eb$var$defaultOptions = {
    method: 'POST'
};
var $aed625edf13c57eb$export$dd86f00dc866e75d = {
    http: $aed625edf13c57eb$var$defaultHttpOptions,
    headers: $aed625edf13c57eb$var$defaultHeaders,
    options: $aed625edf13c57eb$var$defaultOptions
};
var $aed625edf13c57eb$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $aed625edf13c57eb$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $aed625edf13c57eb$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $1DiV8.InvariantError)(1);
    }
};
var $aed625edf13c57eb$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $aed625edf13c57eb$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $3VFsf.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $3VFsf.__assign)({}, options, config.options, {
            headers: (0, $3VFsf.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $3VFsf.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $1c8Um.print)(query);
    return {
        options: options,
        body: body
    };
};
var $aed625edf13c57eb$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $1DiV8.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $aed625edf13c57eb$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("lC4FX", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $fbc0c610016bf5c5$export$943d544ad120494a);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $fbc0c610016bf5c5$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $fbc0c610016bf5c5$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $fbc0c610016bf5c5$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $3VFsf.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $fbc0c610016bf5c5$export$943d544ad120494a = function(_super) {
    (0, $3VFsf.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $fbc0c610016bf5c5$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $fbc0c610016bf5c5$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $fbc0c610016bf5c5$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $clSzL.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("cuKXc", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $918cb5692ff82562$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $918cb5692ff82562$export$3f9ecfb4d42ab23d);

var $jojW6 = parcelRequire("jojW6");

var $9HlP2 = parcelRequire("9HlP2");

var $ivfDv = parcelRequire("ivfDv");
function $918cb5692ff82562$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $ivfDv.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $jojW6.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $918cb5692ff82562$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $9HlP2.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("9HlP2", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $70f90ea50d538958$export$a13f755900e15d9e);

var $clSzL = parcelRequire("clSzL");

var $jojW6 = parcelRequire("jojW6");

var $jWd7i = parcelRequire("jWd7i");

var $b2p88 = parcelRequire("b2p88");
var $70f90ea50d538958$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $70f90ea50d538958$var$graphql = $jWd7i.graphql;
var $70f90ea50d538958$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $70f90ea50d538958$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $70f90ea50d538958$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $clSzL.Observable).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $b2p88.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $jojW6.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $b2p88.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $70f90ea50d538958$var$capitalizeFirstLetter(((0, $jojW6.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $clSzL.Observable).of({
                data: {}
            });
            return new (0, $clSzL.Observable)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $70f90ea50d538958$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $clSzL.ApolloLink)))();
};

});
parcelRegister("jWd7i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");

var $jDjTr = parcelRequire("jDjTr");
function $e83d9bca6fb9481d$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e83d9bca6fb9481d$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e83d9bca6fb9481d$var$graphql;
function $e83d9bca6fb9481d$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $3VFsf.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $3VFsf.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$jojW6.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$jojW6.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $jojW6.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $jDjTr.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($jojW6.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $jDjTr.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeField(field, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $jojW6.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $jojW6.resultKeyNameFromField(field),
                        directives: $jojW6.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e83d9bca6fb9481d$var$executeSubSelectedArray(field, item, execContext);
        return $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("jDjTr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jojW6 = parcelRequire("jojW6");
function $e4b11739b667b187$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e4b11739b667b187$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e4b11739b667b187$var$graphql;
function $e4b11739b667b187$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$jojW6.shouldInclude(selection, variables)) return;
        if ($jojW6.isField(selection)) {
            var fieldResult = $e4b11739b667b187$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $jojW6.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $e4b11739b667b187$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($jojW6.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $e4b11739b667b187$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $e4b11739b667b187$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $e4b11739b667b187$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $jojW6.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $jojW6.resultKeyNameFromField(field),
        directives: $jojW6.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext);
    return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e4b11739b667b187$var$executeSubSelectedArray(field, item, execContext);
        return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $e4b11739b667b187$var$hasOwn = Object.prototype.hasOwnProperty;
function $e4b11739b667b187$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$e4b11739b667b187$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $e4b11739b667b187$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $e4b11739b667b187$var$merge;

});


parcelRegister("b2p88", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $80935fed9657b3c7$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $80935fed9657b3c7$export$467f9c465e4ace4e);

var $1c8Um = parcelRequire("1c8Um");

var $jojW6 = parcelRequire("jojW6");
var $80935fed9657b3c7$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $80935fed9657b3c7$var$removed = new Map();
function $80935fed9657b3c7$export$8eae69e876ee321e(query) {
    var cached = $80935fed9657b3c7$var$removed.get(query);
    if (cached) return cached;
    (0, $jojW6.checkDocument)(query);
    var docClone = (0, $jojW6.removeDirectivesFromDocument)([
        $80935fed9657b3c7$var$connectionRemoveConfig
    ], query);
    $80935fed9657b3c7$var$removed.set(query, docClone);
    return docClone;
}
function $80935fed9657b3c7$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $1c8Um.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("dxpxC", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $4350c2bcf1320fcf$export$fb326ed954631f3f);

var $clSzL = parcelRequire("clSzL");

var $bFU4G = parcelRequire("bFU4G");
const $4350c2bcf1320fcf$export$fb326ed954631f3f = new (0, $clSzL.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $bFU4G.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("5uTwE", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"Admin\",\"possibleTypes\":[{\"name\":\"JiraGroup\"},{\"name\":\"JiraUser\"}]},{\"kind\":\"UNION\",\"name\":\"BoardFeatureView\",\"possibleTypes\":[{\"name\":\"BasicBoardFeatureView\"},{\"name\":\"EstimationBoardFeatureView\"}]},{\"kind\":\"UNION\",\"name\":\"BoardLocation\",\"possibleTypes\":[{\"name\":\"Project\"},{\"name\":\"UserLocation\"}]}]}}");

});


parcelRegister("lKocD", function(module, exports) {

$parcel$export(module.exports, "default", () => $73a7c750c3dfc37c$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $kGsr8 = parcelRequire("kGsr8");

var $ebyGx = parcelRequire("ebyGx");

var $9pe79 = parcelRequire("9pe79");
function $73a7c750c3dfc37c$var$stringifySafe(queryLike) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(queryLike);
}
function $73a7c750c3dfc37c$var$parseSafe(search) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search);
}
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $73a7c750c3dfc37c$var$getQueryString = ()=>$73a7c750c3dfc37c$var$parseSafe(window.location.search);
function $73a7c750c3dfc37c$var$getNonManagedParams(currentParams, managedKeys) {
    const previous = {};
    Object.keys(currentParams).forEach((key)=>{
        if (managedKeys.includes(key)) return;
        previous[key] = currentParams[key];
    });
    return previous;
}
function $73a7c750c3dfc37c$var$setQueryString(params, managedKeys, history) {
    const current = $73a7c750c3dfc37c$var$getQueryString();
    const mergedParams = {
        ...managedKeys.length ? $73a7c750c3dfc37c$var$getNonManagedParams(current, managedKeys) : {},
        ...params
    };
    // do not bother updating the query string if you do not need to
    if ((0, $9pe79.default)(current, mergedParams)) return;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const currentUrlPath = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
    const qs = Object.keys(mergedParams).length ? `?${$73a7c750c3dfc37c$var$stringifySafe(mergedParams)}` : '';
    if (history) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    history.replace(window.location.pathname + qs);
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.history.replaceState({}, '', currentUrlPath + qs);
}
function $73a7c750c3dfc37c$var$setStateFromUrl(dispatch, urlBindings) {
    const qs = $73a7c750c3dfc37c$var$getQueryString();
    urlBindings.forEach((binding)=>{
        let value = qs[binding.urlKey];
        if (typeof value === 'undefined') {
            const { getDefaultValue: getDefaultValue } = binding;
            value = typeof getDefaultValue === 'function' ? getDefaultValue() : undefined;
        }
        if (typeof value === 'undefined') return;
        binding.setValueFromUrl(dispatch, binding.transform.parse(value));
    });
}
function $73a7c750c3dfc37c$var$setUrlFromState(state, urlBindings, keepNonManagedParams, history) {
    const search = {};
    urlBindings.forEach((binding)=>{
        const value = binding.getValueForUrl(state);
        if (typeof value === 'undefined') return;
        search[binding.urlKey] = binding.transform.stringify(value);
    });
    const managedKeys = keepNonManagedParams ? urlBindings.map(({ urlKey: urlKey })=>urlKey) : [];
    $73a7c750c3dfc37c$var$setQueryString(search, managedKeys, history);
}
function $73a7c750c3dfc37c$export$2e2bcd8739ae039(store, urlBindings = [], keepNonManagedParams = false, history) {
    if (!urlBindings.length) return 0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz));
    const urlKeys = urlBindings.map((binding)=>binding.urlKey);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(urlKeys).length !== urlKeys.length) {
        // eslint-disable-next-line no-console
        console.warn('clash found in url binding keys', urlKeys);
        return 0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz));
    }
    $73a7c750c3dfc37c$var$setStateFromUrl(store.dispatch, urlBindings);
    return store.subscribe(()=>{
        const state = store.getState();
        $73a7c750c3dfc37c$var$setUrlFromState(state, urlBindings, keepNonManagedParams, history);
    });
}

});
parcelRegister("9pe79", function(module, exports) {

$parcel$export(module.exports, "default", () => $06cb96a92cdfd43f$export$2e2bcd8739ae039);

var $0xdyK = parcelRequire("0xdyK");
var /**
 * Shallow equal using '===' comparison and one-level array checks.
 *
 * WARNING: This is not a true shallow equal, use @atlassian/jira-platform-shallow-equal.
 *
 * @see {@link http://go.atlassian.com/shallow-equal}
 *
 * @param {*} obj1
 * @param {*} obj2
 * @returns {boolean}
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$06cb96a92cdfd43f$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    if (!(0, $0xdyK.default)(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const value = obj1[key];
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        return Array.isArray(nextValue) && Array.isArray(value) && (0, $0xdyK.default)(value, nextValue);
    });
    return areValuesEqual;
};

});
parcelRegister("0xdyK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c50cb723ebf4f109$export$2e2bcd8739ae039);
/**
 * Returns true if the two given arrays are equal one level deep
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $c50cb723ebf4f109$export$2e2bcd8739ae039 = (array1 = [], array2 = [])=>{
    // @ts-expect-error - This comparison appears to be unintentional because the types 'readonly T[]' and 'readonly U[]' have no overlap.
    if (array1 === array2) return true;
    // check one level deep
    // @ts-expect-error - This comparison appears to be unintentional because the types 'T' and 'U' have no overlap.
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};

});



parcelRegister("bRUzT", function(module, exports) {

$parcel$export(module.exports, "DISPOSE_ACTION", () => $b69e8859fbb50550$export$78be82e7e063a3fb);

const $b69e8859fbb50550$export$78be82e7e063a3fb = {
    type: (0, $167b7959815986d2$export$58387e80544dbf03)
};

});
const $167b7959815986d2$export$58387e80544dbf03 = 'COMMON/REDUX_DISPOSABLE/DISPOSE_ACTION';


parcelRegister("wKznQ", function(module, exports) {

$parcel$export(module.exports, "getCachedFilters", () => $a26a3456dc06172d$export$cc165fee46da38d4);
$parcel$export(module.exports, "setCachedFilters", () => $a26a3456dc06172d$export$fb56bc6b9e534664);

var $bSSG7 = parcelRequire("bSSG7");
const $a26a3456dc06172d$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('software');
const $a26a3456dc06172d$var$CACHED_FILTERS_KEY = 'filters';
const $a26a3456dc06172d$var$getKey = (feature, projectId)=>`${feature}-${$a26a3456dc06172d$var$CACHED_FILTERS_KEY}.${projectId}`;
function $a26a3456dc06172d$export$cc165fee46da38d4(feature, projectId) {
    return $a26a3456dc06172d$var$localStorage.get($a26a3456dc06172d$var$getKey(feature, projectId)) || undefined;
}
function $a26a3456dc06172d$export$fb56bc6b9e534664(feature, projectId, filters) {
    if (filters && Object.entries(filters).length > 0) $a26a3456dc06172d$var$localStorage.set($a26a3456dc06172d$var$getKey(feature, projectId), filters);
    else $a26a3456dc06172d$var$localStorage.remove($a26a3456dc06172d$var$getKey(feature, projectId));
}

});

parcelRegister("97Kan", function(module, exports) {

$parcel$export(module.exports, "FlagsDispatcher", () => $4ddeb9f500a62e17$export$9e60e3d40b6e758f);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $fpHHI = parcelRequire("fpHHI");
const $4ddeb9f500a62e17$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fpHHI.Dispatcher), {
        store: store,
        mapper: mapper,
        showFlag: (0, $pa9q9.showFlag),
        dismissFlag: (0, $pa9q9.dismissFlag)
    });

});
parcelRegister("fpHHI", function(module, exports) {

$parcel$export(module.exports, "Dispatcher", () => $eef6139685bfb64e$export$ab054a1ef92eeb01);

var $5uXOq = parcelRequire("5uXOq");

var $1kijq = parcelRequire("1kijq");
const $eef6139685bfb64e$export$ab054a1ef92eeb01 = (props)=>{
    const { store: store, ...dispatcherProps } = props;
    const [lastStore, setLastStore] = (0, $5uXOq.useState)(store);
    if (store !== lastStore) setLastStore(store);
    const DispatcherComponent = (0, $5uXOq.useMemo)(()=>(0, $1kijq.createDispatcher)(store), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DispatcherComponent, dispatcherProps);
};

});
parcelRegister("1kijq", function(module, exports) {

$parcel$export(module.exports, "createDispatcher", () => $c324e875f8c6fe8f$export$7b259d28468da15b);

var $5uXOq = parcelRequire("5uXOq");

var $kVVL1 = parcelRequire("kVVL1");

var $pa9q9 = parcelRequire("pa9q9");
const $c324e875f8c6fe8f$export$81c2f3c810206fa9 = (store)=>{
    if (!store) throw new Error('Store not available through direct injection or Provider context');
    if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
    return store;
};
const $c324e875f8c6fe8f$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
    if (!result) return;
    if ((0, $pa9q9.isDismissFlag)(result)) dismissFlag(result);
    else if ((0, $pa9q9.isFlagComponent)(result)) {
        const FlagComponent = result;
        const FlagComponentWithProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kVVL1.Provider), {
                store: store
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FlagComponent, props));
        showFlag(FlagComponentWithProvider);
    } else showFlag(result);
};
const $c324e875f8c6fe8f$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
    // handle batch middleware
    if ((0, $pa9q9.isBatchAction)(action)) action.payload.forEach((childAction)=>{
        if (childAction.type && typeof childAction.type === 'string') {
            const childResult = mapper(childAction, state);
            $c324e875f8c6fe8f$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
        }
    });
    else {
        const result = mapper(action, state);
        $c324e875f8c6fe8f$export$8a44987212de21b(store, result, showFlag, dismissFlag);
    }
};
const $c324e875f8c6fe8f$var$Dispatcher8 = (props)=>{
    const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
    const store = (0, $5uXOq.useMemo)(()=>$c324e875f8c6fe8f$export$81c2f3c810206fa9(storeUnchecked), [
        storeUnchecked
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const handleAction = (action, state)=>{
            $c324e875f8c6fe8f$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
        };
        store.addActionListener(handleAction);
        return ()=>store.removeActionListener(handleAction);
    }, [
        store,
        mapper,
        showFlag,
        dismissFlag
    ]);
    return null;
};
const $c324e875f8c6fe8f$var$Dispatcher8DefaultStore = (props)=>{
    const store = (0, $kVVL1.useStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
        ...props,
        store: store
    });
};
const $c324e875f8c6fe8f$export$7b259d28468da15b = (customStore)=>{
    const Dispatcher8CustomStore = (props)=>customStore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
            ...props,
            store: customStore
        }) : null;
    return customStore ? Dispatcher8CustomStore : $c324e875f8c6fe8f$var$Dispatcher8DefaultStore;
};

});



parcelRegister("joFsm", function(module, exports) {

$parcel$export(module.exports, "default", () => $45670090ce80d9dc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $5jlQc = parcelRequire("5jlQc");
const $45670090ce80d9dc$var$MemoryObserver = ({ getCustomData: getCustomData })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const memoryReporter = new (0, $5jlQc.PollingMemoryReporter)(createAnalyticsEvent, getCustomData);
        memoryReporter.start();
        memoryReporter.setBucketTimeouts();
        return ()=>{
            memoryReporter.stop();
            memoryReporter.clearBucketTimeouts();
        };
    }, [
        createAnalyticsEvent,
        getCustomData
    ]);
    return null;
};
var $45670090ce80d9dc$export$2e2bcd8739ae039 = $45670090ce80d9dc$var$MemoryObserver;

});
parcelRegister("5jlQc", function(module, exports) {

$parcel$export(module.exports, "PollingMemoryReporter", () => $621c8fa9757e42da$export$3e76404af7b93e06);

var $dJl1T = parcelRequire("dJl1T");

var $8zOmE = parcelRequire("8zOmE");

var $4wNtT = parcelRequire("4wNtT");

var $aA83m = parcelRequire("aA83m");
const $621c8fa9757e42da$var$minMs = 60000; // number of ms in a minute
const $621c8fa9757e42da$export$54912f9240c8e5db = 20 * $621c8fa9757e42da$var$minMs;
const $621c8fa9757e42da$export$9f536c7d89257714 = [
    2 * $621c8fa9757e42da$var$minMs,
    10 * $621c8fa9757e42da$var$minMs
];
const $621c8fa9757e42da$export$c63950c55adb1607 = (createAnalyticsEvent, getCustomData)=>{
    try {
        const memoryUsageReport = (0, $aA83m.getMemoryUsageReport)();
        if (memoryUsageReport == null) return;
        const { sessionTime: sessionTime, performanceMemoryEntry: { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } } = memoryUsageReport;
        const customData = getCustomData ? getCustomData() : {};
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'memory tracked', {
            bucket: (0, $4wNtT.memoryBucketHandler).getBucket(usedJSHeapSize),
            sessionTime: sessionTime,
            sessionTimeBucket: (0, $4wNtT.sessionTimeBucketHandler).getBucket(sessionTime),
            jsHeapSizeLimit: jsHeapSizeLimit,
            totalJSHeapSize: totalJSHeapSize,
            usedJSHeapSize: usedJSHeapSize,
            ...customData
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('observability.memory-metrics.measure-and-report-memory', 'Failed to poll for memory usage');
    }
};
class $621c8fa9757e42da$export$3e76404af7b93e06 {
    constructor(createAnalyticsEvent, getCustomData){
        this.pollInterval = null;
        this.bucketTimeouts = null;
        this.report = ()=>{
            $621c8fa9757e42da$export$c63950c55adb1607(this.createAnalyticsEvent, this.getCustomData);
        };
        this.onVisibilityChange = ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const isHidden = window.document?.hidden === true;
            if (isHidden) this.stop();
            else {
                this.stop();
                this.start();
            }
        };
        this.createAnalyticsEvent = createAnalyticsEvent;
        this.getCustomData = getCustomData;
    }
    start() {
        if (this.pollInterval != null) return;
        this.report();
        // @ts-expect-error - TS2322 - Type 'Timer' is not assignable to type 'number'.
        this.pollInterval = setInterval(()=>{
            if (this.pollInterval == null) return;
            this.report();
        }, $621c8fa9757e42da$export$54912f9240c8e5db);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('visibilitychange', this.onVisibilityChange);
    }
    stop() {
        if (this.pollInterval != null) {
            clearInterval(this.pollInterval);
            this.pollInterval = null;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
    setBucketTimeouts() {
        this.bucketTimeouts = $621c8fa9757e42da$export$9f536c7d89257714.map((ms)=>setTimeout(()=>{
                this.report();
            }, ms));
    }
    clearBucketTimeouts() {
        this.bucketTimeouts?.forEach((timeout)=>{
            clearTimeout(timeout);
        });
    }
}

});
parcelRegister("4wNtT", function(module, exports) {

$parcel$export(module.exports, "memoryBucketHandler", () => $2459a841a83bbb5c$export$26aac2ead17b35e5);
$parcel$export(module.exports, "sessionTimeBucketHandler", () => $2459a841a83bbb5c$export$af08fe8a31c89520);
class $2459a841a83bbb5c$export$a9fa854dd2f29162 {
    constructor(buckets, options){
        this.buckets = buckets;
        this.formatLabel = options?.formatLabel ?? ((low, high)=>`${low}-${high ?? 'Inf'}`);
    }
    /**
	 * Returns the lowest matching bucket for this measurement.
	 *
	 * For example, if buckets are [0, 10, 20, 30] and the measurement is 15,
	 * this function will return 10 meaning this measurement is in the 10-20
	 * range.
	 */ getBucket(measurement) {
        const bucketIndex = this.buckets.findIndex((bucket)=>measurement < bucket);
        if (bucketIndex < 0) return this.formatLabel(this.buckets[this.buckets.length - 1]);
        return this.formatLabel(this.buckets[bucketIndex - 1], this.buckets[bucketIndex]);
    }
}
const $2459a841a83bbb5c$var$mbBytes = 1048576; // number of bytes in a MB
const $2459a841a83bbb5c$var$minMs = 60000; // number of ms in a minute
const $2459a841a83bbb5c$export$26aac2ead17b35e5 = new $2459a841a83bbb5c$export$a9fa854dd2f29162([
    0,
    100 * $2459a841a83bbb5c$var$mbBytes,
    200 * $2459a841a83bbb5c$var$mbBytes,
    400 * $2459a841a83bbb5c$var$mbBytes,
    800 * $2459a841a83bbb5c$var$mbBytes,
    1600 * $2459a841a83bbb5c$var$mbBytes,
    3200 * $2459a841a83bbb5c$var$mbBytes
], {
    formatLabel: (lowBucket, highBucket)=>`${lowBucket / $2459a841a83bbb5c$var$mbBytes}-${highBucket != null ? highBucket / $2459a841a83bbb5c$var$mbBytes : 'Inf'}MB`
});
const $2459a841a83bbb5c$export$af08fe8a31c89520 = new $2459a841a83bbb5c$export$a9fa854dd2f29162([
    0,
    2 * $2459a841a83bbb5c$var$minMs,
    5 * $2459a841a83bbb5c$var$minMs,
    10 * $2459a841a83bbb5c$var$minMs,
    20 * $2459a841a83bbb5c$var$minMs
], {
    formatLabel: (lowBucket, highBucket)=>`${lowBucket / $2459a841a83bbb5c$var$minMs}-${highBucket != null ? highBucket / $2459a841a83bbb5c$var$minMs : 'Inf'}MIN`
});

});



parcelRegister("5sUih", function(module, exports) {

$parcel$export(module.exports, "default", () => $4af9e7daa433ec70$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $4af9e7daa433ec70$var$Ipcontext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    planId: undefined,
    scenarioId: undefined
});
var $4af9e7daa433ec70$export$2e2bcd8739ae039 = $4af9e7daa433ec70$var$Ipcontext;

});

const $8631d6ce464ccf2e$export$9b8283d5878d2491 = 'BOARD';
const $8631d6ce464ccf2e$export$dedbdcc35e955187 = 'BACKLOG';
const $8631d6ce464ccf2e$export$ffff0a2c60bf4822 = 'ROADMAPS';
const $8631d6ce464ccf2e$export$78244dbb77cfa6b6 = 'UNKNOWN';
const $8631d6ce464ccf2e$export$b7dfe28569b170a1 = 'RESOURCES_CACHE_UPDATER_SOURCE';
const $8631d6ce464ccf2e$export$889129cf7f70997b = 'resourcesCacheSource';

parcelRegister("6jwh3", function(module, exports) {

$parcel$export(module.exports, "AsyncResourcesCacheWrapper", () => $15da7f00442fe8c1$export$3e6c6a80a1f4cb5a);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $15da7f00442fe8c1$var$LazyResourcesCacheWrapper = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cwILk")), {
    moduleId: "./src/packages/software/resource-invalidator/src/ui/resources-cache-wrapper/index.tsx"
});
const $15da7f00442fe8c1$export$3e6c6a80a1f4cb5a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-software-resource-invalidator-cache-wrapper",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($15da7f00442fe8c1$var$LazyResourcesCacheWrapper, props));

});
parcelRegister("cwILk", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("73b65").then(()=>parcelRequire('bicfN'));

});


parcelRegister("iUagi", function(module, exports) {

$parcel$export(module.exports, "isNewAutomationMenuEnabled", () => $6698347a19479bea$export$72300c156ed00f26);
$parcel$export(module.exports, "isDevStatusOnCardsDisabled", () => $6698347a19479bea$export$90468f55d7a06b26);
$parcel$export(module.exports, "getBoardJirtJitter", () => $6698347a19479bea$export$b9435597444f4ffc);
$parcel$export(module.exports, "isErrorTrackingEnabledWithSentry", () => $6698347a19479bea$export$23d600ca6d887b4d);
$parcel$export(module.exports, "isPrefetchIssueDataByColumnLimitEnabled", () => $6698347a19479bea$export$18aec82be8c5ed76);
$parcel$export(module.exports, "isSyntheticTenant", () => $6698347a19479bea$export$f7ab30339d40bcd);
$parcel$export(module.exports, "emitApdexOnAnimationFrame", () => $6698347a19479bea$export$2d887f955f551bbf);
$parcel$export(module.exports, "isTailoredViewExperimentEnabled", () => $6698347a19479bea$export$f8f18cae4b906873);
$parcel$export(module.exports, "isInAddPeopleButtonOpenTMPControlCohort", () => $6698347a19479bea$export$ebdf1290b0dde9e3);
$parcel$export(module.exports, "isViewSettingAsPanelExpEnabledWithNoExposure", () => $6698347a19479bea$export$6f295af995afef94);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $6s1PB = parcelRequire("6s1PB");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");
const $6698347a19479bea$export$72300c156ed00f26 = ()=>(0, $co1wz.ff)('jsw-replace-automationmenu-with-new-context-aware-menu_rltpk');
const $6698347a19479bea$export$90468f55d7a06b26 = ()=>(0, $co1wz.ff)('jsw.killswitch.dev-status-on-cards');
const $6698347a19479bea$export$b9435597444f4ffc = ()=>(0, $co1wz.getFeatureFlagValue)('jsw.nextgen.board.jirt.jitter', 500);
const $6698347a19479bea$export$23d600ca6d887b4d = ()=>(0, $co1wz.ff)('fe.platform.error.tracking.enabled');
const $6698347a19479bea$export$18aec82be8c5ed76 = ()=>(0, $co1wz.ff)('jsw-agile-board-prefetch-issue-data-by-column-limit');
const $6698347a19479bea$export$f7ab30339d40bcd = ()=>(0, $co1wz.ff)('jsw.pollinator.tenants');
const $6698347a19479bea$export$2d887f955f551bbf = ()=>(0, $co1wz.ff)('jsw.perf.board-backlog-emit-apdex-on-animation-frame');
const $6698347a19479bea$export$f8f18cae4b906873 = ()=>(0, $6s1PB.expValEquals)('jsw_additional_card_fields_in_view_settings', 'cohort', 'variation');
function $6698347a19479bea$export$ebdf1290b0dde9e3() {
    return (0, $6s1PB.expValEquals)('open_invite_for_open_tmp_projects', 'cohort', 'control');
}
const $6698347a19479bea$export$6f295af995afef94 = ()=>(0, $4R6GH.fg)('jira_view_settings_additional_fields');

});

parcelRegister("i6HlS", function(module, exports) {

$parcel$export(module.exports, "flagsMapper", () => $c00f953137ed60c6$export$4de5eb17326eea98);

var $5uXOq = parcelRequire("5uXOq");

var $6c57g = parcelRequire("6c57g");

var $4cr9K = parcelRequire("4cr9K");

var $4tEQ4 = parcelRequire("4tEQ4");

var $3n582 = parcelRequire("3n582");

var $cY26q = parcelRequire("cY26q");

var $bkCF5 = parcelRequire("bkCF5");

var $ls4NM = parcelRequire("ls4NM");

var $cW3pH = parcelRequire("cW3pH");

var $3i1Rr = parcelRequire("3i1Rr");

var $03PHH = parcelRequire("03PHH");

var $gYo9d = parcelRequire("gYo9d");

var $bri2z = parcelRequire("bri2z");

var $2obSb = parcelRequire("2obSb");

var $elCuX = parcelRequire("elCuX");
const $c00f953137ed60c6$export$4de5eb17326eea98 = (action)=>{
    switch(action.type){
        case 0, $4cr9K.SHOW_ERROR_FLAG_FROM_SWAG:
            return (0, $4tEQ4.extractFlagFromAction)(action);
        case 0, $bkCF5.ISSUE_CREATE_FILTERED_V2:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bri2z.default), {
                    ...props,
                    cardKeys: action.payload.cardKeys,
                    sprints: action.payload.sprints
                });
        case 0, $bkCF5.ISSUE_CREATE_MOVED_BETWEEN_SWIMLANES:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bri2z.default), {
                    ...props,
                    cardKeys: action.payload.cardKeys,
                    issueMovedBetweenSwimlanes: true
                });
        case 0, $ls4NM.CARD_CREATE_UNMAPPED:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $03PHH.default), {
                    ...props,
                    cardKeys: action.payload.cardKeys
                });
        case 0, $bkCF5.CARD_CREATE_FILTERED_OUT_IN_IP_BOARD:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYo9d.default), props);
        case 0, $ls4NM.CARD_CREATE_GLOBAL:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6c57g.CardCreateGlobalFlag), {
                    ...props,
                    cardKeys: action.payload.cardKeys
                });
        case 0, $cY26q.FILTERED_CARD_FAILURE:
        case 0, $cY26q.REFILTER_FAILURE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2obSb.default), props);
        case 0, $cW3pH.SHOW_MISSING_ISSUE_TYPE_MESSAGE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $elCuX.default), {
                    ...props,
                    missingIssueType: action.payload
                });
        case 0, $3n582.FETCH_CARD_COVERS_FAILURE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3i1Rr.CardCoverToggleFailedFlag), props);
        default:
            return undefined;
    }
};

});
parcelRegister("6c57g", function(module, exports) {

$parcel$export(module.exports, "CardCreateGlobalFlag", () => $44cad0f844ccec7d$export$b6918b93a6420e06);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $ftuxv = parcelRequire("ftuxv");

var $6ioBm = parcelRequire("6ioBm");

var $24y3R = parcelRequire("24y3R");

var $eCbBU = parcelRequire("eCbBU");
const $44cad0f844ccec7d$var$GLOBAL_CREATE_POLLINATOR_DATA_TEST_ID = 'jira-issue-create.modal.create-form.success-flag';
const $44cad0f844ccec7d$export$93f5b027a66006a6 = ({ onDismissed: onDismissed, id: id, cardKeys: cardKeys })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isCopied, setCopied] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        let timeoutId;
        if (isCopied) timeoutId = setTimeout(()=>{
            setCopied(false);
        }, 2000);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        isCopied
    ]);
    const issueDiscoveryUrl = (0, $24y3R.getIssueDiscoveryUrl)(cardKeys);
    const copyToClipboard = (0, $5uXOq.useCallback)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        navigator.clipboard.writeText(`${window.location.origin}${issueDiscoveryUrl}`);
        setCopied(true);
    }, [
        issueDiscoveryUrl
    ]);
    const flagTitle = cardKeys.length > 1 ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eCbBU.default).multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh : (0, $eCbBU.default).multiplesIssuesCreatedSuccessFlagTitle, {
        issueCount: cardKeys.length
    }) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eCbBU.default).createSuccessFlagTitleIssueTermRefresh : (0, $eCbBU.default).createSuccessFlagTitle, {
        issueKey: cardKeys[0]
    });
    const actions = [
        {
            content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eCbBU.default).viewIssueLinkTextIssueTermRefresh : (0, $eCbBU.default).viewIssueLinkText, {
                numIssues: cardKeys.length
            }),
            href: issueDiscoveryUrl
        },
        {
            content: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($44cad0f844ccec7d$var$CopySuccess, null, formatMessage((0, $eCbBU.default).linkCopied)) : formatMessage((0, $eCbBU.default).copyLink),
            onClick: ()=>{
                copyToClipboard();
            }
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": $44cad0f844ccec7d$var$GLOBAL_CREATE_POLLINATOR_DATA_TEST_ID,
        "data-issue-key": cardKeys[0]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: flagTitle,
        actions: actions
    }));
};
const $44cad0f844ccec7d$var$CheckEligibilityAndReturnFlag = (props)=>{
    const { id: id, cardKeys: cardKeys, onDismissed: onDismissed } = props;
    const { isLoading: isLoading, shouldShowRecommendTrialFlag: shouldShowRecommendTrialFlag } = (0, $ftuxv.useRecommendTrialToFree)({
        id: id
    });
    if (isLoading) return null;
    if (shouldShowRecommendTrialFlag) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ioBm.RecommendTrialToFreeFlag), {
        flagId: `${id}`,
        issueKeys: cardKeys,
        onDismiss: onDismissed ? ()=>onDismissed(id) : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($44cad0f844ccec7d$export$93f5b027a66006a6, props);
};
const $44cad0f844ccec7d$export$b6918b93a6420e06 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jira_recommended_trial_to_free_ab_gate'), $44cad0f844ccec7d$var$CheckEligibilityAndReturnFlag, $44cad0f844ccec7d$export$93f5b027a66006a6); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44cad0f844ccec7d$var$CopySuccess = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1ft0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3KRpp", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $ef767762d5402ccf$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $ef767762d5402ccf$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $ef767762d5402ccf$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $ef767762d5402ccf$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $ef767762d5402ccf$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $ef767762d5402ccf$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $ef767762d5402ccf$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $ef767762d5402ccf$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $1eg3p = parcelRequire("1eg3p");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, $kxZPA.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, $kxZPA.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("fhw5b")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, $kxZPA.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("fhw5b")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));

});
parcelRegister("lKKug", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("4yB9l")
]).then(()=>parcelRequire('8ZHDV'));

});

parcelRegister("fhw5b", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("Fkef4").then(()=>parcelRequire('5pz6a'));

});


parcelRegister("ftuxv", function(module, exports) {

$parcel$export(module.exports, "useRecommendTrialToFree", () => $94af4859a16bc856$export$12cc6b04754d240d);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $joX8T = parcelRequire("joX8T");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $2NMNM = parcelRequire("2NMNM");

var $8zOmE = parcelRequire("8zOmE");

var $dAfqg = parcelRequire("dAfqg");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $2XPB5 = parcelRequire("2XPB5");

var $bPCb6 = parcelRequire("bPCb6");
const $94af4859a16bc856$export$12cc6b04754d240d = ({ id: id })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { software: jswEdition } = (0, $k9JTq.useAppEditions)();
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig, fireExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_recommended_trial_to_free_ab');
    const cohort = expConfig.get((0, $joX8T.COHORT), (0, $joX8T.NOT_ENROLLED));
    const flagId = (0, $2XPB5.getFlagId)();
    const [shouldShowRecommendTrialFlag, setShouldShowRecommendTrialFlag] = (0, $5uXOq.useState)(false);
    const isInJiraProject = projectContext?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const isTestCohort = cohort === 'test';
    const isEligible = (0, $5uXOq.useMemo)(()=>// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('jira_recommended_trial_to_free_ab_gate') && cohort !== (0, $joX8T.NOT_ENROLLED) && jswEdition === (0, $ldyPw.FREE_EDITION) && isInJiraProject && (!flagId || flagId === `${id}`), [
        cohort,
        jswEdition,
        isInJiraProject,
        flagId,
        id
    ]);
    const { userCanUpgrade: userCanUpgrade, isLoading: isLoading } = (0, $bPCb6.useCheckIfUserCanUpgrade)(!isEligible);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEligible || !userCanUpgrade) return;
        // only fire exposure if the user is eligible
        fireExposure();
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'rtfExperiment exposed', {
            experiment: 'jira_recommended_trial_to_free_ab',
            cohort: cohort
        });
        // for the test cohort, we will set the flag as seen once it has rendered
        if (!isTestCohort) {
            (0, $2XPB5.setHasSeenFlag)(`${id}`);
            return;
        }
        // only set the flag if the user is eligible and in the test cohort
        setShouldShowRecommendTrialFlag(true);
    }, [
        isEligible,
        userCanUpgrade,
        cohort,
        isTestCohort,
        id,
        fireExposure,
        createAnalyticsEvent
    ]);
    return {
        shouldShowRecommendTrialFlag: shouldShowRecommendTrialFlag,
        isLoading: isLoading
    };
};

});
parcelRegister("joX8T", function(module, exports) {

$parcel$export(module.exports, "COHORT", () => $a85d1363752adaec$export$3d370c33621572df);
$parcel$export(module.exports, "NOT_ENROLLED", () => $a85d1363752adaec$export$5b7423264d48ab04);
$parcel$export(module.exports, "CONTROL", () => $a85d1363752adaec$export$43f367b3e957f219);
$parcel$export(module.exports, "VARIATION", () => $a85d1363752adaec$export$fa04ad826acc90da);

var $co1wz = parcelRequire("co1wz");
const $a85d1363752adaec$export$3d370c33621572df = 'cohort';
const $a85d1363752adaec$export$5b7423264d48ab04 = 'not-enrolled';
const $a85d1363752adaec$export$43f367b3e957f219 = 'control';
const $a85d1363752adaec$export$9ba2bc3b1bdc1519 = 'experiment';
const $a85d1363752adaec$export$fa04ad826acc90da = 'variation';
const $a85d1363752adaec$export$6486974e39493fa6 = 'variation-1';
const $a85d1363752adaec$export$7d994996134ad562 = 'variation-2';
const $a85d1363752adaec$export$795e7d69b248dcd0 = 'variation-3';
const $a85d1363752adaec$export$c9c947c57470b787 = 'variation-4';
const $a85d1363752adaec$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
    $a85d1363752adaec$export$5b7423264d48ab04,
    $a85d1363752adaec$export$43f367b3e957f219,
    $a85d1363752adaec$export$9ba2bc3b1bdc1519,
    $a85d1363752adaec$export$fa04ad826acc90da,
    $a85d1363752adaec$export$6486974e39493fa6,
    $a85d1363752adaec$export$7d994996134ad562,
    $a85d1363752adaec$export$795e7d69b248dcd0,
    $a85d1363752adaec$export$c9c947c57470b787
];
var // Use optionalValidExperimentGroups to further restrict the list of cohorts
// eslint-disable-next-line jira/import/no-anonymous-default-export
$a85d1363752adaec$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $a85d1363752adaec$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, $co1wz.getMultivariateFeatureFlag)(experimentFeatureFlag, $a85d1363752adaec$export$5b7423264d48ab04, validExperimentGroups);

});

parcelRegister("2XPB5", function(module, exports) {

$parcel$export(module.exports, "getFlagId", () => $3543236f451df4c9$export$415e9f2b45fdf9bb);
$parcel$export(module.exports, "setHasSeenFlag", () => $3543236f451df4c9$export$3d880171a29f5f5c);
const $3543236f451df4c9$var$storageKey = 'jira_recommended_trial_to_free_ab_flag_seen';
function $3543236f451df4c9$export$415e9f2b45fdf9bb() {
    if (typeof window === 'undefined') return true;
    return localStorage.getItem($3543236f451df4c9$var$storageKey)?.toString();
}
function $3543236f451df4c9$export$3d880171a29f5f5c(id) {
    if (typeof window === 'undefined') return;
    localStorage.setItem($3543236f451df4c9$var$storageKey, id);
}

});

parcelRegister("bPCb6", function(module, exports) {

$parcel$export(module.exports, "useCheckIfUserCanUpgrade", () => $4bb7ecfce8361721$export$8242cede3f5a02b3);

var $fLoq8 = parcelRequire("fLoq8");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");
const $4bb7ecfce8361721$export$8242cede3f5a02b3 = (skip = false)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [userCanUpgrade, setUserCanUpgrade] = (0, $5uXOq.useState)(false);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    (0, $5uXOq.useEffect)(()=>{
        if (skip) return;
        (0, $8Uumt.fetchQuery)(environment, (0, $fLoq8.default), {
            cloudId: cloudId,
            productKey: 'jira-software.ondemand',
            offeringKey: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526'
        }).subscribe({
            start: ()=>{
                setIsLoading(true);
            },
            complete: ()=>{
                setIsLoading(false);
            },
            next: (data)=>{
                const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
                const canUserUpgrade = entitlement?.experienceCapabilities?.changeOffering?.isAvailableToUser;
                setUserCanUpgrade(!!canUserUpgrade);
            },
            error: (error)=>{
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useCheckIfUserCanUpgrade',
                        packageName: 'jiraRecommendTrialToFree',
                        teamName: 'luna-growth'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    error: error
                });
                setIsLoading(false);
                setUserCanUpgrade(false);
            }
        });
    }, [
        cloudId,
        skip,
        createAnalyticsEvent,
        environment
    ]);
    return {
        userCanUpgrade: userCanUpgrade,
        isLoading: isLoading
    };
};

});
parcelRegister("fLoq8", function(module, exports) {

$parcel$export(module.exports, "default", () => $456100b00a8c0d97$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5260673e7b49f18bba0b28122ce4ee09>>
 * @relayHash 0e295bd8cf5556f9a2ed20c4e7811231
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3363969b24a2c14b0a0a295feb9e9c205423d0ccd5685c2eaf9083dda1987721
const $456100b00a8c0d97$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "offeringKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productKey"
    }, v3 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "offeringKey",
            "variableName": "offeringKey"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "eligibilityUserCanUpgradeQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOffering",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "eligibilityUserCanUpgradeQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOffering",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3363969b24a2c14b0a0a295feb9e9c205423d0ccd5685c2eaf9083dda1987721",
            "metadata": {},
            "name": "eligibilityUserCanUpgradeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$456100b00a8c0d97$var$node.hash = "bfb3759dfd2863e60432f4c195d1030a";
var $456100b00a8c0d97$export$2e2bcd8739ae039 = $456100b00a8c0d97$var$node;

});



parcelRegister("6ioBm", function(module, exports) {

$parcel$export(module.exports, "RecommendTrialToFreeFlag", () => $8c6d38d59ee39900$export$2de2b4a8ed8a1389);

var $5uXOq = parcelRequire("5uXOq");

var $1PedV = parcelRequire("1PedV");

var $flJYh = parcelRequire("flJYh");
const $8c6d38d59ee39900$export$2de2b4a8ed8a1389 = ({ flagId: flagId, onDismiss: onDismiss, issueKeys: issueKeys })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PedV.FeatureGateChecker), {
        experiment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flJYh.IssueCreatedFlag), {
            flagId: flagId,
            onDismiss: onDismiss,
            issueKeys: issueKeys
        })
    });

});
parcelRegister("1PedV", function(module, exports) {

$parcel$export(module.exports, "FeatureGateChecker", () => $6adbd2160cc3d9ec$export$5f9d7deb88921f2f);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $3Syrj = parcelRequire("3Syrj");
const $6adbd2160cc3d9ec$export$5f9d7deb88921f2f = ({ experiment: experiment })=>{
    if ((0, $4R6GH.fg)('jira_recommended_trial_to_free_ab_gate')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Syrj.EligibilityChecker), null, experiment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};

});
parcelRegister("3Syrj", function(module, exports) {

$parcel$export(module.exports, "EligibilityChecker", () => $93b19d108b39ba8d$export$cca196bfee81cdcf);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $bPCb6 = parcelRequire("bPCb6");
const $93b19d108b39ba8d$export$cca196bfee81cdcf = ({ children: children })=>{
    const { userCanUpgrade: userCanUpgrade } = (0, $bPCb6.useCheckIfUserCanUpgrade)((0, $6s1PB.expVal)('jira_recommended_trial_to_free_ab', 'cohort', 'not_enrolled') === 'not_enrolled');
    const { software: jswEdition } = (0, $k9JTq.useAppEditions)();
    const eligibleForTrial = jswEdition === (0, $ldyPw.FREE_EDITION) && userCanUpgrade && (0, $6s1PB.expVal)('jira_recommended_trial_to_free_ab', 'cohort', 'not_enrolled') && (0, $6s1PB.expValEquals)('jira_recommended_trial_to_free_ab', 'cohort', 'test');
    if (eligibleForTrial) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};

});


parcelRegister("flJYh", function(module, exports) {

$parcel$export(module.exports, "IssueCreatedFlag", () => $6e8c2958b2d97644$export$6ac95aa79f7e7f3f);

var $56tYp = parcelRequire("56tYp");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2gQ83 = parcelRequire("2gQ83");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $1dJ6S = parcelRequire("1dJ6S");

var $i28qQ = parcelRequire("i28qQ");

var $a9R4o = parcelRequire("a9R4o");

var $e4yMr = parcelRequire("e4yMr");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $39xOx = parcelRequire("39xOx");

var $pa9q9 = parcelRequire("pa9q9");

var $ousew = parcelRequire("ousew");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $aOzfJ = parcelRequire("aOzfJ");

var $2XPB5 = parcelRequire("2XPB5");

var $5mx0k = parcelRequire("5mx0k");
function $6e8c2958b2d97644$export$6ac95aa79f7e7f3f(props) {
    return /*#__PURE__*/ $5uXOq.createElement((0, $39xOx.JSErrorBoundary), {
        id: "rtfIssueCreatedFlag",
        packageName: "jiraRecommendTrialToFree",
        teamName: "luna-growth",
        fallback: "unmount"
    }, /*#__PURE__*/ $5uXOq.createElement($6e8c2958b2d97644$export$92f18cc245e11db5, props));
}
function $6e8c2958b2d97644$export$92f18cc245e11db5({ flagId: flagId, onDismiss: onDismiss, issueKeys: issueKeys }) {
    const [showReloadPageModal, setShowReloadPageModal] = (0, $5uXOq.useState)(false);
    const openModal = (0, $5uXOq.useCallback)(()=>setShowReloadPageModal(true), []);
    const closeModal = (0, $5uXOq.useCallback)(()=>setShowReloadPageModal(false), []);
    const { dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const cloudId = (0, $koeKL.useCloudId)();
    const linkToTrial = (0, $8Uumt.useLazyLoadQuery)((0, $56tYp.default), {
        cloudId: cloudId,
        productKey: 'jira-software.ondemand',
        offeringKey: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526'
    })?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.experienceCapabilities?.changeOffering?.experienceUrl;
    (0, $5uXOq.useEffect)(()=>{
        (0, $2XPB5.setHasSeenFlag)(flagId);
    }, [
        flagId
    ]);
    const origin = new (0, $2gQ83.default)({
        product: 'jira'
    });
    const issueCount = issueKeys.length;
    if (showReloadPageModal) return /*#__PURE__*/ $5uXOq.createElement((0, $5mx0k.ReloadPageModal), {
        closeModal: closeModal
    });
    return /*#__PURE__*/ $5uXOq.createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "recommendTrialToFreeFlag"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $6e8c2958b2d97644$var$cardStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $luBm6.default), {
        alignInline: "start",
        spread: "space-between"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $f5TWP.default), {
        alignInline: "stretch",
        alignBlock: "center",
        grow: "fill",
        spread: "space-between",
        xcss: $6e8c2958b2d97644$var$inlineStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.200"
    }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a9R4o))), {
        label: "success",
        color: "var(--ds-icon-success, #22A06B)",
        LEGACY_size: "large",
        spacing: "spacious"
    }), /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $6e8c2958b2d97644$var$titleStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $cgL5K.default), null, issueCount > 1 ? /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), {
        id: "jira-recommend-trial-to-free.issue-created.card-title-multiple",
        defaultMessage: "You've created {issueCount, plural, one {# issue} other {# issues}}",
        values: {
            issueCount: issueCount
        }
    }) : /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), {
        id: "jira-recommend-trial-to-free.issue-created.card-title-single",
        defaultMessage: 'You\'ve created "{issueKey}" issue',
        values: {
            issueKey: issueKeys[0]
        }
    })))), /*#__PURE__*/ $5uXOq.createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'rtfDismissFlag');
            if (onDismiss) {
                onDismiss();
                return;
            }
            dismissFlag(flagId);
        },
        "aria-label": "Close"
    }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))), {
        label: "close",
        color: "var(--ds-icon, #44546F)"
    }))), /*#__PURE__*/ $5uXOq.createElement((0, $f5TWP.default), {
        space: "space.200",
        alignBlock: "center",
        spread: "space-between",
        grow: "fill",
        xcss: $6e8c2958b2d97644$var$contentContainerStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $luBm6.default), {
        alignBlock: "center",
        alignInline: "start",
        space: "space.100",
        xcss: $6e8c2958b2d97644$var$mainContentStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $1dJ6S.default), {
        size: "small"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), {
        id: "jira-recommend-trial-to-free.issue-created.content-title",
        defaultMessage: "Now add your team"
    })), /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $6e8c2958b2d97644$var$bodyStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $cgL5K.default), null, /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), {
        id: "jira-recommend-trial-to-free.issue-created.content",
        defaultMessage: "Upgrade to get unlimited users and add everyone you work with."
    }))), linkToTrial && /*#__PURE__*/ $5uXOq.createElement((0, $e4yMr.default), {
        href: origin.addToUrl(linkToTrial),
        onClick: (_, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'rtfTryItFree');
            openModal();
        },
        target: "_blank"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $cgL5K.default), {
        color: "color.link"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), {
        id: "jira-recommend-trial-to-free.issue-created.try-it-now-link",
        defaultMessage: "Try it free"
    })))), /*#__PURE__*/ $5uXOq.createElement((0, $luBm6.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $6e8c2958b2d97644$var$illustrationStackStyles
    }, /*#__PURE__*/ $5uXOq.createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aOzfJ))),
        alt: "",
        className: (0, $bwpsq.default)([
            "_c71l1ame _p12f1ame"
        ])
    }))))));
}
const $6e8c2958b2d97644$var$cardStyles = (0, $8CUq3.xcss)({
    borderColor: 'color.border',
    borderRadius: '3px',
    boxShadow: 'elevation.shadow.overlay',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'elevation.surface.overlay'
});
const $6e8c2958b2d97644$var$inlineStyles = (0, $8CUq3.xcss)({
    borderBottom: '1px solid',
    borderColor: 'color.border',
    padding: 'space.200'
});
const $6e8c2958b2d97644$var$titleStyles = (0, $8CUq3.xcss)({
    fontSize: 'font.body'
});
const $6e8c2958b2d97644$var$contentContainerStyles = (0, $8CUq3.xcss)({
    background: 'color.neutral.light',
    paddingInline: 'space.250',
    paddingBlock: 'space.400',
    width: '100%'
});
const $6e8c2958b2d97644$var$mainContentStyles = (0, $8CUq3.xcss)({
    maxWidth: '240px'
});
const $6e8c2958b2d97644$var$bodyStyles = (0, $8CUq3.xcss)({
    fontSize: 'font.body',
    lineHeight: '20px',
    fontWeight: '400'
});
const $6e8c2958b2d97644$var$illustrationStyles = null;
const $6e8c2958b2d97644$var$illustrationStackStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.200'
});

});
parcelRegister("56tYp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7a5082779d6bc38$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a0d3fbb3610dfdcd8128a1b88d6f6a8>>
 * @relayHash 9e0292a0e9e1a7cfc043ea04242ec447
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d7442a20376f6ce597664338dc598c7ade7ff8e2f238b04acb696e15c5022319
const $a7a5082779d6bc38$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "offeringKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productKey"
    }, v3 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "offeringKey",
            "variableName": "offeringKey"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueCreatedFlagGetTrialLinkQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOffering",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueCreatedFlagGetTrialLinkQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOffering",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d7442a20376f6ce597664338dc598c7ade7ff8e2f238b04acb696e15c5022319",
            "metadata": {},
            "name": "issueCreatedFlagGetTrialLinkQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a7a5082779d6bc38$var$node.hash = "4d50fdd81aa1005eb031986467ce9f75";
var $a7a5082779d6bc38$export$2e2bcd8739ae039 = $a7a5082779d6bc38$var$node;

});

parcelRegister("a9R4o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5be69851386531f5b95e24ba5766e7ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7653e93bf7da1948$var$_react = $7653e93bf7da1948$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7653e93bf7da1948$var$_success = $7653e93bf7da1948$var$_interopRequireDefault((parcelRequire("b0JGA")));

var $7653e93bf7da1948$var$_success2 = $7653e93bf7da1948$var$_interopRequireDefault((parcelRequire("kJ541")));
function $7653e93bf7da1948$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7653e93bf7da1948$var$SuccessIcon = (props)=>/*#__PURE__*/ $7653e93bf7da1948$var$_react.default.createElement($7653e93bf7da1948$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $7653e93bf7da1948$var$_success2.default
    }, props));
$7653e93bf7da1948$var$SuccessIcon.Name = 'SuccessIconMigration';
var $7653e93bf7da1948$var$_default = module.exports.default = $7653e93bf7da1948$var$SuccessIcon;

});
parcelRegister("b0JGA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f4494144da7877c599489a550534c1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8043220a46fa3485$var$_react = $8043220a46fa3485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8043220a46fa3485$var$_UNSAFE_baseNew = $8043220a46fa3485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8043220a46fa3485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8043220a46fa3485$var$SuccessIcon = (props)=>/*#__PURE__*/ $8043220a46fa3485$var$_react.default.createElement($8043220a46fa3485$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$8043220a46fa3485$var$SuccessIcon.displayName = 'SuccessIcon';
var $8043220a46fa3485$var$_default = module.exports.default = $8043220a46fa3485$var$SuccessIcon;

});

parcelRegister("kJ541", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f16bf031974cd311$var$_react = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $f16bf031974cd311$var$_success = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("b0JGA")));
function $f16bf031974cd311$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f16bf031974cd311$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $f16bf031974cd311$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $f16bf031974cd311$var$_success.default
    }));
$f16bf031974cd311$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $f16bf031974cd311$var$_default = module.exports.default = $f16bf031974cd311$var$EditorSuccessIcon;

});


// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("aOzfJ", function(module, exports) {
module.exports = new URL("now-add-your-team.9826b1af.svg", import.meta.url).toString();

});

parcelRegister("5mx0k", function(module, exports) {

$parcel$export(module.exports, "ReloadPageModal", () => $11cc1ff3d8018c4e$export$7db633aff5c8fd9a);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $2Yv61 = parcelRequire("2Yv61");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");

var $ousew = parcelRequire("ousew");
const $11cc1ff3d8018c4e$export$7db633aff5c8fd9a = ({ closeModal: closeModal })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        onClose: closeModal,
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Yv61))), {
        label: "info",
        color: "var(--ds-icon-accent-blue, #1D7AFC)",
        spacing: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        id: "jira-recommend-trial-to-free.reload-this-page.title",
        defaultMessage: "Reload this page"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        id: "jira-recommend-trial-to-free.reload-this-page.body",
        defaultMessage: "If you've upgraded, reload this page to start your trial. Changes may take up to a minute."
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: closeModal
    }, "Close"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "primary",
        onClick: ()=>{
            if (typeof window !== 'undefined') window.location.reload();
        }
    }, "Reload"))));

});



parcelRegister("24y3R", function(module, exports) {

$parcel$export(module.exports, "getIssueDiscoveryUrl", () => $ebd8351448f87226$export$852450339fdb3b37);
const $ebd8351448f87226$export$852450339fdb3b37 = (cardKeys)=>{
    if (cardKeys.length > 1) {
        const issueKeys = cardKeys.join(',');
        const jqlSearch = encodeURIComponent(`issueKey in (${issueKeys})`);
        return `/issues/?jql=${jqlSearch}`;
    }
    return `/browse/${cardKeys[0]}`;
};

});

parcelRegister("eCbBU", function(module, exports) {

$parcel$export(module.exports, "default", () => $a405eb29c4610c88$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a405eb29c4610c88$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createSuccessFlagTitle: {
        "id": "software-flags.card-create-global.create-success-flag-title",
        "defaultMessage": "You've created \"{issueKey}\" issue."
    },
    viewIssueLinkText: {
        "id": "software-flags.card-create-global.view-issue-link-text",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    },
    multiplesIssuesCreatedSuccessFlagTitle: {
        "id": "software-flags.card-create-global.multiples-issues-created-success-flag-title",
        "defaultMessage": "You've created {issueCount, plural, one {# issue} other {# issues}}."
    },
    copyLink: {
        "id": "software-flags.card-create-global.copy-link",
        "defaultMessage": "Copy link"
    },
    linkCopied: {
        "id": "software-flags.card-create-global.link-copied",
        "defaultMessage": "Copied"
    },
    createSuccessFlagTitleIssueTermRefresh: {
        "id": "software-flags.card-create-global.create-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created \"{issueKey}\" issue."
    },
    viewIssueLinkTextIssueTermRefresh: {
        "id": "software-flags.card-create-global.view-issue-link-text-issue-term-refresh",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    },
    multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh: {
        "id": "software-flags.card-create-global.multiples-issues-created-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created {issueCount, plural, one {# issue} other {# issues}}."
    }
});

});


parcelRegister("4cr9K", function(module, exports) {

$parcel$export(module.exports, "SHOW_ERROR_FLAG_FROM_SWAG", () => $dcafaf5dc15a1c9d$export$849b6aff5e6c9763);
$parcel$export(module.exports, "showErrorFlag", () => $dcafaf5dc15a1c9d$export$dfa2148cdb92917d);
$parcel$export(module.exports, "XSRF_CHECK_FAILED", () => $dcafaf5dc15a1c9d$export$653597ecd43ee3b5);
const $dcafaf5dc15a1c9d$export$849b6aff5e6c9763 = 'SHOW_ERROR_FLAG_FROM_SWAG';
const $dcafaf5dc15a1c9d$export$dfa2148cdb92917d = (error)=>({
        type: $dcafaf5dc15a1c9d$export$849b6aff5e6c9763,
        payload: error
    });
const $dcafaf5dc15a1c9d$export$653597ecd43ee3b5 = 'XSRF_CHECK_FAILED';

});

parcelRegister("4tEQ4", function(module, exports) {

$parcel$export(module.exports, "getErrorFlag", () => $854596c2afd2e9d8$export$7a23a73c35436772);
$parcel$export(module.exports, "extractFlagFromAction", () => $854596c2afd2e9d8$export$6783b18b1c9d1ab1);

var $9XE6b = parcelRequire("9XE6b");

var $467lJ = parcelRequire("467lJ");

var $4cr9K = parcelRequire("4cr9K");

var $i5xPZ = parcelRequire("i5xPZ");

var $cNrxd = parcelRequire("cNrxd");
const $854596c2afd2e9d8$export$2cf9ab1b4d75e34e = (error)=>{
    const { graphQLErrors: graphQLErrors } = error;
    if (!graphQLErrors || graphQLErrors.length === 0) return null;
    const applicationError = graphQLErrors.find((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
            'extensions',
            'errorType'
        ], false));
    if (!applicationError) return null;
    return {
        errorType: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(applicationError, [
            'extensions',
            'errorType'
        ], '')
    };
};
const $854596c2afd2e9d8$export$eeae51b1c2ad1cfa = (error)=>{
    if ((0, $cNrxd.isFetchError)(error)) return {
        statusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'statusCode'
        ], null),
        userMessage: null
    };
    const { graphQLErrors: graphQLErrors, networkError: networkError } = error;
    if (networkError) return {
        statusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(networkError, [
            'statusCode'
        ], null),
        userMessage: null
    };
    if (graphQLErrors.length > 0) return {
        statusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(graphQLErrors, [
            0,
            'extensions',
            'statusCode'
        ], null),
        userMessage: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(graphQLErrors, [
            0,
            'extensions',
            'userMessage'
        ], null)
    };
    return {
        statusCode: null,
        userMessage: null
    };
};
const $854596c2afd2e9d8$var$isApplicationError = (error)=>{
    const applicationError = $854596c2afd2e9d8$export$2cf9ab1b4d75e34e(error);
    return applicationError?.errorType === (0, $4cr9K.XSRF_CHECK_FAILED);
};
const $854596c2afd2e9d8$export$7a23a73c35436772 = (error)=>{
    if (!(0, $cNrxd.isFetchError)(error)) {
        // check if any error contains "errorType", and process prior to http-status-code
        if ($854596c2afd2e9d8$var$isApplicationError(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            type: 'error',
            title: (0, $i5xPZ.default).xsrfCheckFailedTitle,
            description: (0, $i5xPZ.default).xsrfCheckFailedDescription,
            error: error
        };
    }
    const { statusCode: httpStatusCode, userMessage: userMessage } = $854596c2afd2e9d8$export$eeae51b1c2ad1cfa(error);
    if ((httpStatusCode === 400 || httpStatusCode === 403) && userMessage) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        type: 'error',
        title: (0, $467lJ.default).genericError().title,
        description: [
            (0, $i5xPZ.default).genericErrorDescription,
            {
                userMessage: userMessage
            }
        ],
        error: error
    };
    if (httpStatusCode === 401) {
        const unauthorizedError = (0, $467lJ.default).unauthorized();
        unauthorizedError.error = error;
        return unauthorizedError;
    }
    if (httpStatusCode === 403) {
        const forbiddenError = (0, $467lJ.default).forbidden();
        forbiddenError.error = error;
        return forbiddenError;
    }
    const genericError = (0, $467lJ.default).genericError();
    genericError.error = error;
    return genericError;
};
const $854596c2afd2e9d8$export$6783b18b1c9d1ab1 = (action)=>{
    const { payload: error } = action;
    if ((0, $cNrxd.isSwagError)(error) || (0, $cNrxd.isFetchError)(error)) return $854596c2afd2e9d8$export$7a23a73c35436772(error);
    // eslint-disable-next-line no-console
    console.error('Action showErrorFlag(error) contains invalid error format. \n Make sure you are using query$() or mutation$() utils from @atlassian/jira-software-swag in /rest layer');
    return undefined;
};

});
parcelRegister("467lJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc639d9ac2372482$export$2e2bcd8739ae039);

var $8BkAH = parcelRequire("8BkAH");

var $8hiuq = parcelRequire("8hiuq");

var $l7mS2 = parcelRequire("l7mS2");

var $5jDRa = parcelRequire("5jDRa");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dc639d9ac2372482$export$2e2bcd8739ae039 = {
    forbidden: $8BkAH.default,
    genericError: $8hiuq.default,
    serverError: $l7mS2.default,
    unauthorized: $5jDRa.default
};

});
parcelRegister("8BkAH", function(module, exports) {

$parcel$export(module.exports, "default", () => $47acdb71562a5159$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package
    --------
    Temporary disable while refactoring the flags package
    so that we don't trigger retranslation of strings */ 
var $7VHMR = parcelRequire("7VHMR");
const $47acdb71562a5159$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.forbidden.title",
        "defaultMessage": "You don't have permission to do that"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.forbidden.description",
        "defaultMessage": "Ask your Jira admin for help."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$47acdb71562a5159$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $47acdb71562a5159$var$messages.title,
        description: $47acdb71562a5159$var$messages.description
    });

});

parcelRegister("8hiuq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffd4533bf12eb3f1$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package
    --------
    Temporary disable while refactoring the flags package
    so that we don't trigger retranslation of strings */ 
var $7VHMR = parcelRequire("7VHMR");
const $ffd4533bf12eb3f1$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.generic-error.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.generic-error.description",
        "defaultMessage": "Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ffd4533bf12eb3f1$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $ffd4533bf12eb3f1$var$messages.title,
        description: $ffd4533bf12eb3f1$var$messages.description
    });

});

parcelRegister("l7mS2", function(module, exports) {

$parcel$export(module.exports, "default", () => $31a915dd4c1d2142$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package
    --------
    Temporary disable while refactoring the flags package
    so that we don't trigger retranslation of strings */ 
var $7VHMR = parcelRequire("7VHMR");
const $31a915dd4c1d2142$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.server-error.title",
        "defaultMessage": "We're having some trouble"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.server-error.description",
        "defaultMessage": "Something went wrong on our end. Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$31a915dd4c1d2142$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $31a915dd4c1d2142$var$messages.title,
        description: $31a915dd4c1d2142$var$messages.description
    });

});

parcelRegister("5jDRa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8754751d720d57d4$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package
    --------
    Temporary disable while refactoring the flags package
    so that we don't trigger retranslation of strings */ 
var $7VHMR = parcelRequire("7VHMR");
const $8754751d720d57d4$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.unauthorized.title",
        "defaultMessage": "You're logged out"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.unauthorized.description",
        "defaultMessage": "Log back in and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8754751d720d57d4$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $8754751d720d57d4$var$messages.title,
        description: $8754751d720d57d4$var$messages.description
    });

});


parcelRegister("i5xPZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $61a9111c121ba41d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $61a9111c121ba41d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    genericErrorDescription: {
        "id": "software-swag.common.generic-error-description",
        "defaultMessage": "{userMessage}"
    },
    xsrfCheckFailedTitle: {
        "id": "software-swag.common.xsrf-check-failed-title",
        "defaultMessage": "Our session has expired"
    },
    xsrfCheckFailedDescription: {
        "id": "software-swag.common.xsrf-check-failed-description",
        "defaultMessage": "Refresh the page and try again"
    }
});

});


parcelRegister("3n582", function(module, exports) {

$parcel$export(module.exports, "FETCH_CARD_COVERS", () => $443a314e0c613ebf$export$534c677d2df3db30);
$parcel$export(module.exports, "fetchCardCovers", () => $443a314e0c613ebf$export$a33810576a7257f6);
$parcel$export(module.exports, "FETCH_CARD_COVERS_FAILURE", () => $443a314e0c613ebf$export$d0e94650aa3d127e);
$parcel$export(module.exports, "fetchCardCoversFailure", () => $443a314e0c613ebf$export$cd46ad5e4990a08b);
const $443a314e0c613ebf$export$534c677d2df3db30 = 'state.actions.card-covers.FETCH_CARD_COVERS';
const $443a314e0c613ebf$export$a33810576a7257f6 = (payload, meta)=>({
        type: $443a314e0c613ebf$export$534c677d2df3db30,
        payload: payload,
        meta: meta
    });
const $443a314e0c613ebf$export$d0e94650aa3d127e = 'state.actions.card-covers.FETCH_CARD_COVERS_FAILURE';
const $443a314e0c613ebf$export$cd46ad5e4990a08b = (meta)=>({
        type: $443a314e0c613ebf$export$d0e94650aa3d127e,
        meta: meta
    });

});

parcelRegister("cY26q", function(module, exports) {

$parcel$export(module.exports, "FILTERED_CARD_SUCCESS", () => $0b8f662f946cb57b$export$8f5834f2d50f84b5);
$parcel$export(module.exports, "filteredCardsSuccess", () => $0b8f662f946cb57b$export$aa1ef8dc8bb1be1b);
$parcel$export(module.exports, "FILTERED_CARD_CLEAR", () => $0b8f662f946cb57b$export$507d49f4a5857f49);
$parcel$export(module.exports, "clearFilteredCards", () => $0b8f662f946cb57b$export$81b4fe421a8e6fe4);
$parcel$export(module.exports, "REFILTER_SUCCESS", () => $0b8f662f946cb57b$export$4d3b992e541cd8ce);
$parcel$export(module.exports, "refilterSuccess", () => $0b8f662f946cb57b$export$a76ad4df662ec1fb);
$parcel$export(module.exports, "REFILTER_FAILURE", () => $0b8f662f946cb57b$export$f09f82741fa84c27);
$parcel$export(module.exports, "refilterFailure", () => $0b8f662f946cb57b$export$138c508cb95b66c3);
$parcel$export(module.exports, "FILTERED_CARD_FAILURE", () => $0b8f662f946cb57b$export$a17483c6b4ef650d);
$parcel$export(module.exports, "filteredCardsFailed", () => $0b8f662f946cb57b$export$8357ffeaf5f8e6b8);
const $0b8f662f946cb57b$export$8f5834f2d50f84b5 = 'state.actions.card.filtered-cards.FILTERED_CARD_SUCCESS';
const $0b8f662f946cb57b$export$aa1ef8dc8bb1be1b = (cardIds, numCustomFiltersApplied = 0, numIssueIds = 0, analyticsEvent)=>({
        type: $0b8f662f946cb57b$export$8f5834f2d50f84b5,
        payload: cardIds,
        meta: {
            analyticsEvent: analyticsEvent,
            numIssueIds: numIssueIds,
            numCustomFiltersApplied: numCustomFiltersApplied
        }
    });
const $0b8f662f946cb57b$export$507d49f4a5857f49 = 'state.actions.card.filtered-cards.FILTERED_CARD_CLEAR';
const $0b8f662f946cb57b$export$81b4fe421a8e6fe4 = ()=>({
        type: $0b8f662f946cb57b$export$507d49f4a5857f49
    });
const $0b8f662f946cb57b$export$4d3b992e541cd8ce = 'state.actions.card.filtered-cards.REFILTER_SUCCESS';
const $0b8f662f946cb57b$export$a76ad4df662ec1fb = (excludedCardIds, filteredCardIds)=>({
        type: $0b8f662f946cb57b$export$4d3b992e541cd8ce,
        payload: {
            excludedCardIds: excludedCardIds,
            filteredCardIds: filteredCardIds
        }
    });
const $0b8f662f946cb57b$export$f09f82741fa84c27 = 'state.actions.card.filtered-cards.REFILTER_FAILURE';
const $0b8f662f946cb57b$export$138c508cb95b66c3 = (error)=>({
        type: $0b8f662f946cb57b$export$f09f82741fa84c27,
        payload: {
            error: error
        }
    });
const $0b8f662f946cb57b$export$a17483c6b4ef650d = 'state.actions.card.filtered-cards.FILTERED_CARD_FAILURE';
const $0b8f662f946cb57b$export$8357ffeaf5f8e6b8 = (error, analyticsEvent)=>({
        type: $0b8f662f946cb57b$export$a17483c6b4ef650d,
        payload: {
            error: error
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });

});

parcelRegister("bkCF5", function(module, exports) {

$parcel$export(module.exports, "FLAG_DISMISSED", () => $301f2494ee9de7ef$export$5c5fc6956b7600ea);
$parcel$export(module.exports, "dismissFlag", () => $301f2494ee9de7ef$export$900a08a292ad23cd);
$parcel$export(module.exports, "SHOW_UNDO_FLAG", () => $301f2494ee9de7ef$export$a811985861f141bb);
$parcel$export(module.exports, "showUndoFlag", () => $301f2494ee9de7ef$export$2646d8864c5ffec);
$parcel$export(module.exports, "UNDO_FLAG_PERFORM_UNDO", () => $301f2494ee9de7ef$export$898c0a8fad557fd2);
$parcel$export(module.exports, "undoFlagPerformUndo", () => $301f2494ee9de7ef$export$a09bb6e3a530a563);
$parcel$export(module.exports, "UNDO_FLAG_PERFORM_COMMIT", () => $301f2494ee9de7ef$export$e3a088c896dc9670);
$parcel$export(module.exports, "undoFlagPerformCommit", () => $301f2494ee9de7ef$export$b5092a88314b2b7d);
$parcel$export(module.exports, "FLAG_CREATED_ISSUE_IS_FILTERED", () => $301f2494ee9de7ef$export$cce2f64939b3097a);
$parcel$export(module.exports, "ISSUE_CREATE_FILTERED_V2", () => $301f2494ee9de7ef$export$3d3099932583397e);
$parcel$export(module.exports, "issueCreateFilteredV2", () => $301f2494ee9de7ef$export$fa537ae37a1502ad);
$parcel$export(module.exports, "ISSUE_CREATE_MOVED_BETWEEN_SWIMLANES", () => $301f2494ee9de7ef$export$d625226adb2f3b49);
$parcel$export(module.exports, "issueCreateMovedBetweenJqlSwimlanes", () => $301f2494ee9de7ef$export$2002a6bc80b9565e);
$parcel$export(module.exports, "CARD_CREATE_FILTERED_OUT_IN_IP_BOARD", () => $301f2494ee9de7ef$export$7cf0dcc6369bfe2b);
$parcel$export(module.exports, "cardCreateFilteredOutInIPBoard", () => $301f2494ee9de7ef$export$2c2745cdb0117bd5);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $301f2494ee9de7ef$export$5c5fc6956b7600ea = 'state.actions.flags.FLAG_DISMISSED';
const $301f2494ee9de7ef$export$900a08a292ad23cd = (flagData)=>({
        type: $301f2494ee9de7ef$export$5c5fc6956b7600ea,
        payload: flagData
    });
const $301f2494ee9de7ef$export$a811985861f141bb = 'state.actions.flags.SHOW_UNDO_FLAG';
const $301f2494ee9de7ef$export$2646d8864c5ffec = ({ id: id, titleMessage: titleMessage, descriptionMessage: descriptionMessage, links: links, context: context })=>({
        type: $301f2494ee9de7ef$export$a811985861f141bb,
        meta: (0, $sdxnu.undoFlagMeta)({
            id: `${$301f2494ee9de7ef$export$a811985861f141bb}::${id}`,
            titleMessage: titleMessage,
            descriptionMessage: descriptionMessage,
            context: context,
            links: links
        })
    });
const $301f2494ee9de7ef$export$898c0a8fad557fd2 = 'state.actions.flags.UNDO_FLAG_PERFORM_UNDO';
const $301f2494ee9de7ef$export$a09bb6e3a530a563 = (flagId)=>({
        type: $301f2494ee9de7ef$export$898c0a8fad557fd2,
        payload: {
            flagId: flagId
        }
    });
const $301f2494ee9de7ef$export$e3a088c896dc9670 = 'state.actions.flags.UNDO_FLAG_PERFORM_COMMIT';
const $301f2494ee9de7ef$export$b5092a88314b2b7d = (flagId)=>({
        type: $301f2494ee9de7ef$export$e3a088c896dc9670,
        payload: {
            flagId: flagId
        }
    });
const $301f2494ee9de7ef$export$cce2f64939b3097a = 'state.actions.flags.FLAG_CREATED_ISSUE_IS_FILTERED';
const $301f2494ee9de7ef$export$102c376be77e2ca5 = (issue)=>({
        type: $301f2494ee9de7ef$export$cce2f64939b3097a,
        payload: issue,
        meta: (0, $sdxnu.warningFlagMeta)({
            id: $301f2494ee9de7ef$export$cce2f64939b3097a,
            titleMessage: (0, $7AVqz.default).createdIssueIsFilteredTitle,
            // Overridden
            descriptionMessage: (0, $7AVqz.default).createdIssueIsFilteredDescription,
            // Overridden
            context: {
                issueKey: issue.key,
                issueId: issue.id
            }
        })
    });
const $301f2494ee9de7ef$export$3d3099932583397e = 'state.actions.flags.ISSUE_CREATE_FILTERED_V2';
const $301f2494ee9de7ef$export$fa537ae37a1502ad = (cardKeys, sprints, filteredOnServer)=>({
        type: $301f2494ee9de7ef$export$3d3099932583397e,
        payload: {
            cardKeys: cardKeys,
            sprints: sprints,
            filteredOnServer: filteredOnServer
        }
    });
const $301f2494ee9de7ef$export$d625226adb2f3b49 = 'state.actions.flags.ISSUE_CREATE_MOVED_BETWEEN_SWIMLANES';
const $301f2494ee9de7ef$export$2002a6bc80b9565e = (cardKeys)=>({
        type: $301f2494ee9de7ef$export$d625226adb2f3b49,
        payload: {
            cardKeys: cardKeys
        }
    });
const $301f2494ee9de7ef$export$7cf0dcc6369bfe2b = 'state.actions.flags.CARD_CREATE_FILTERED_OUT_IN_IP_BOARD';
const $301f2494ee9de7ef$export$2c2745cdb0117bd5 = ()=>({
        type: $301f2494ee9de7ef$export$7cf0dcc6369bfe2b
    });

});
parcelRegister("7AVqz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f5b8de7af91e687$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4f5b8de7af91e687$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    warning: {
        "id": "software.main.flags.warning",
        "defaultMessage": "Warning"
    },
    boardLoadedFailureTitle: {
        "id": "software.main.flags.board-loaded-failure-title",
        "defaultMessage": "Board data failed to load"
    },
    boardLoadedFailureDescription: {
        "id": "software.main.flags.board-loaded-failure-description",
        "defaultMessage": "Try refreshing the page, or contact your admin"
    },
    logBackInTitle: {
        "id": "software.main.flags.log-back-in-title",
        "defaultMessage": "Anyone there?"
    },
    logBackInAnchorText: {
        "id": "software.main.flags.log-back-in-anchor-text",
        "defaultMessage": "Log back in"
    },
    logBackInDescription: {
        "id": "software.main.flags.log-back-in-description",
        "defaultMessage": "You've been inactive for a while, so we've logged you out."
    },
    genericTitle: {
        "id": "software.main.flags.generic-title",
        "defaultMessage": "Something's gone wrong"
    },
    genericDescription: {
        "id": "software.main.flags.generic-description",
        "defaultMessage": "An error occurred on our end. Refresh the page and try again"
    },
    warningLabel: {
        "id": "software.main.flags.warning-label",
        "defaultMessage": "An error occurred"
    },
    errorLabel: {
        "id": "software.main.flags.error-label",
        "defaultMessage": "An error occurred"
    },
    failureDescription: {
        "id": "software.main.flags.failure-description",
        "defaultMessage": "{error}"
    },
    columnRemoveDoneFlagTitle: {
        "id": "software.main.flags.column-remove-done-flag-title",
        "defaultMessage": "Your board has no completion columns"
    },
    columnRemoveDoneFlagDescription: {
        "id": "software.main.flags.column-remove-done-flag-description",
        "defaultMessage": "Issues on this board can't be treated as done until you set a completion column."
    },
    createdIssueIsFilteredTitle: {
        "id": "software.main.flags.created-issue-is-filtered-title",
        "defaultMessage": "{issueKey} has been created."
    },
    createdIssueIsFilteredDescription: {
        "id": "software.main.flags.created-issue-is-filtered-description",
        "defaultMessage": "It's hidden by your current filter."
    },
    createdIssueIsFilteredLink: {
        "id": "software.main.flags.created-issue-is-filtered-link",
        "defaultMessage": "View issue"
    },
    issueRankFailTitle: {
        "id": "software.main.flags.issue-rank-fail-title",
        "defaultMessage": "We couldn't update the issue"
    },
    issueRankFailDescription: {
        "id": "software.main.flags.issue-rank-fail-description",
        "defaultMessage": "We failed to reorder the issue or your admin has restricted how you can move it. Try moving the issue again or move it to a different drop zone."
    },
    issueRankFailFieldRequiredTitle: {
        "id": "software.main.flags.issue-rank-fail-field-required-title",
        "defaultMessage": "Issue {issueKey} couldn't be moved."
    },
    issueRankFailFieldRequiredDescription: {
        "id": "software.main.flags.issue-rank-fail-field-required-description",
        "defaultMessage": "{errorMessage}"
    },
    bulkIssueRankFailTitle: {
        "id": "software.main.flags.bulk-issue-rank-fail-title",
        "defaultMessage": "Issue {issueKey} couldn't be moved."
    },
    devStatusFetchFailedTitle: {
        "id": "software.main.flags.dev-status-fetch-failed-title",
        "defaultMessage": "Something's gone wrong"
    },
    devStatusFetchFailedDescription: {
        "id": "software.main.flags.dev-status-fetch-failed-description",
        "defaultMessage": "Your cards' development statuses have failed to update. We'll keep trying."
    },
    boardDeferredDataFetchFailedTitle: {
        "id": "software.main.flags.board-deferred-data-fetch-failed-title",
        "defaultMessage": "Something's gone wrong"
    },
    boardDeferredDataFetchFailedDescription: {
        "id": "software.main.flags.board-deferred-data-fetch-failed-description",
        "defaultMessage": "We couldn't load some of your board data. Refresh the page and try again."
    },
    issueLabelsSaveFailed: {
        "id": "software.main.flags.issue-labels-save-failed",
        "defaultMessage": "We couldn't update some of your issues. Try again."
    },
    newPeopleAddedSuccessTitle: {
        "id": "software.main.flags.new-people-added-success-title",
        "defaultMessage": "New people added"
    },
    noColumnFailureTitle: {
        "id": "software.main.flags.no-column-failure-title",
        "defaultMessage": "Boards must have at least one column"
    },
    noColumnFailureAdminDescription: {
        "id": "software.main.flags.no-column-failure-admin-description",
        "defaultMessage": "Add at least one column to continue."
    },
    noColumnFailureNonAdminDescription: {
        "id": "software.main.flags.no-column-failure-non-admin-description",
        "defaultMessage": "Your project admin must add a column to continue."
    },
    manageStatusesLink: {
        "id": "software.main.flags.manage-statuses-link",
        "defaultMessage": "Manage columns and statuses"
    },
    deleteFailureTitle: {
        "id": "software.main.flags.delete-failure-title",
        "defaultMessage": "Failed to delete issue"
    },
    teamSwimlaneMoveInvalidTitle: {
        "id": "software.main.flags.team-swimlane-move-invalid-title",
        "defaultMessage": "Couldn\u2019t assign issue to {teamName}"
    },
    teamSwimlaneMoveInvalidMessage: {
        "id": "software.main.flags.team-swimlane-move-invalid-message",
        "defaultMessage": "Issues can only be assigned to teams that are part of your plan."
    },
    swimlaneColumnClosedSprintInvalidMoveTitle: {
        "id": "software.main.flags.swimlane-column-closed-sprint-invalid-move-title",
        "defaultMessage": "Couldn\u2019t assign issue to {sprintName}"
    },
    swimlaneColumnClosedSprintInvalidMoveMessage: {
        "id": "software.main.flags.swimlane-column-closed-sprint-invalid-move-message",
        "defaultMessage": "Issues can\u2019t be assigned to a closed sprint."
    },
    cardMoveFailureInIpBoardTitleNoTranslate: {
        "id": "software.main.flags.card-move-failure-in-ip-board-title-no-translate",
        "defaultMessage": "We can't update the issue"
    },
    cardMoveFailureInIpBoardMessageNoTranslate: {
        "id": "software.main.flags.card-move-failure-in-ip-board-message-no-translate",
        "defaultMessage": "We failed to reorder the issue. Try moving the issue again or move it to a different drop zone."
    },
    customFieldOptionMissedTitle: {
        "id": "software.main.flags.custom-field-option-missed-title",
        "defaultMessage": "Issue couldn\u2019t be created"
    },
    customFieldOptionMissedDescription: {
        "id": "software.main.flags.custom-field-option-missed-description",
        "defaultMessage": "{fieldValue} can\u2019t be applied to {issueTypeName} type issues in {projectName}. Your admin needs to add the {fieldValue} option to the {fieldName} custom field."
    },
    reachDependencyLineLimitTitle: {
        "id": "software.main.flags.reach-dependency-line-limit-title",
        "defaultMessage": "You can only show dependencies for {limit, plural, one {# issue} other {# issues}} at one time"
    }
});

});

parcelRegister("sdxnu", function(module, exports) {

$parcel$export(module.exports, "warningFlagMeta", () => $09c88d05be3e9dcb$export$fd216f66b62fa159);
$parcel$export(module.exports, "undoFlagMeta", () => $09c88d05be3e9dcb$export$f02c70ed4364732c);
$parcel$export(module.exports, "successFlagMeta", () => $09c88d05be3e9dcb$export$a4f3d10259c20559);
$parcel$export(module.exports, "errorFlagMeta", () => $09c88d05be3e9dcb$export$10dda59e82a6948c);
$parcel$export(module.exports, "infoFlagMeta", () => $09c88d05be3e9dcb$export$96a3d0e918faf45b);

var $7Jxgt = parcelRequire("7Jxgt");

const $09c88d05be3e9dcb$export$fd216f66b62fa159 = (flagParameters)=>({
        flag: {
            type: (0, $587ae274b8f0e917$export$3e8caae81220a92d),
            id: flagParameters.id || (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4(),
            titleMessage: flagParameters.titleMessage,
            descriptionMessage: flagParameters.descriptionMessage,
            rawDescriptionMessage: flagParameters.rawDescriptionMessage,
            context: flagParameters.context
        }
    });
const $09c88d05be3e9dcb$export$f02c70ed4364732c = (flagParameters)=>({
        flag: {
            type: (0, $587ae274b8f0e917$export$b80f3194b3ff34b4),
            id: flagParameters.id || (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4(),
            titleMessage: flagParameters.titleMessage,
            descriptionMessage: flagParameters.descriptionMessage,
            context: flagParameters.context,
            links: flagParameters.links
        }
    });
const $09c88d05be3e9dcb$export$a4f3d10259c20559 = (flagParameters)=>({
        flag: {
            type: (0, $587ae274b8f0e917$export$1d0740fae54799e6),
            id: flagParameters.id || (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4(),
            titleMessage: flagParameters.titleMessage,
            descriptionMessage: flagParameters.descriptionMessage,
            context: flagParameters.context
        }
    });
const $09c88d05be3e9dcb$export$10dda59e82a6948c = (flagParameters)=>({
        flag: {
            type: (0, $587ae274b8f0e917$export$b0516b50882e8fbc),
            id: flagParameters.id || (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4(),
            titleMessage: flagParameters.titleMessage,
            descriptionMessage: flagParameters.descriptionMessage,
            errorMessages: flagParameters.errorMessages,
            context: flagParameters.context
        }
    });
const $09c88d05be3e9dcb$export$96a3d0e918faf45b = (flagParameters)=>({
        flag: {
            type: (0, $587ae274b8f0e917$export$f1471fc4e853391b),
            id: flagParameters.id || (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4(),
            titleMessage: flagParameters.titleMessage,
            descriptionMessage: flagParameters.descriptionMessage,
            errorMessages: flagParameters.errorMessages,
            context: flagParameters.context
        }
    });

});
const $587ae274b8f0e917$export$3e8caae81220a92d = 'WARNING';
const $587ae274b8f0e917$export$1d0740fae54799e6 = 'SUCCESS';
const $587ae274b8f0e917$export$b0516b50882e8fbc = 'ERROR';
const $587ae274b8f0e917$export$b80f3194b3ff34b4 = 'UNDO';
const $587ae274b8f0e917$export$f1471fc4e853391b = 'INFO';



parcelRegister("ls4NM", function(module, exports) {

$parcel$export(module.exports, "ISSUE_CREATE_REQUEST", () => $40338ac9e4bbe7a0$export$cafcbf49eb8c002);
$parcel$export(module.exports, "issueCreateRequest", () => $40338ac9e4bbe7a0$export$735389bea7eedaad);
$parcel$export(module.exports, "ISSUE_CREATE_SUCCESS", () => $40338ac9e4bbe7a0$export$fbccf9014fab045);
$parcel$export(module.exports, "issueCreateSuccess", () => $40338ac9e4bbe7a0$export$359b420f9850fc61);
$parcel$export(module.exports, "ISSUE_CREATE_FAILURE", () => $40338ac9e4bbe7a0$export$6fdf0f2026f59ec8);
$parcel$export(module.exports, "issueCreateFailure", () => $40338ac9e4bbe7a0$export$d2f4535c9fcca3f3);
$parcel$export(module.exports, "issueCreateIPValidateFailure", () => $40338ac9e4bbe7a0$export$8115d8ee3d5a2c3e);
$parcel$export(module.exports, "CARD_CREATE_UNMAPPED", () => $40338ac9e4bbe7a0$export$ac5655119bbf2fd5);
$parcel$export(module.exports, "cardCreateUnmapped", () => $40338ac9e4bbe7a0$export$2afdf25d9071462e);
$parcel$export(module.exports, "CARD_CREATE_GLOBAL", () => $40338ac9e4bbe7a0$export$7e3530b9017404ec);
$parcel$export(module.exports, "cardCreateGlobal", () => $40338ac9e4bbe7a0$export$7fd1edcce679a11d);
$parcel$export(module.exports, "customFieldMissedInIPBoard", () => $40338ac9e4bbe7a0$export$c33e3f9f36f8dbca);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");

var $9rND4 = parcelRequire("9rND4");
const $40338ac9e4bbe7a0$export$cafcbf49eb8c002 = 'state.actions.issue.create.ISSUE_CREATE_REQUEST';
const $40338ac9e4bbe7a0$export$735389bea7eedaad = ({ temporaryIssueIds: temporaryIssueIds, issues: issues, insertBefore: insertBefore, columnIndex: columnIndex, cardIndex: cardIndex, swimlaneId: swimlaneId, type: type, analyticsEvent: analyticsEvent, isSubtaskMissingParent: isSubtaskMissingParent, transitionInfo: transitionInfo, isSwimlaneByJql: isSwimlaneByJql })=>({
        type: $40338ac9e4bbe7a0$export$cafcbf49eb8c002,
        payload: {
            temporaryIssueIds: temporaryIssueIds,
            issues: issues,
            type: type
        },
        meta: {
            insertBefore: insertBefore,
            columnIndex: columnIndex,
            cardIndex: cardIndex,
            swimlaneId: swimlaneId,
            ...(0, $9rND4.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent,
            isSubtaskMissingParent: isSubtaskMissingParent,
            transitionInfo: transitionInfo,
            isSwimlaneByJql: isSwimlaneByJql
        }
    });
const $40338ac9e4bbe7a0$export$fbccf9014fab045 = 'state.actions.issue.create.ISSUE_CREATE_SUCCESS';
const $40338ac9e4bbe7a0$export$359b420f9850fc61 = (optimisticId, temporaryIssueIds, issues, columnIndex, cardIndex, analyticsEvent)=>({
        type: $40338ac9e4bbe7a0$export$fbccf9014fab045,
        payload: {
            temporaryIssueIds: temporaryIssueIds,
            issues: issues
        },
        meta: {
            columnIndex: columnIndex,
            cardIndex: cardIndex,
            ...(0, $9rND4.commitOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });
const $40338ac9e4bbe7a0$export$6fdf0f2026f59ec8 = 'state.actions.issue.create.ISSUE_CREATE_FAILURE';
const $40338ac9e4bbe7a0$export$d2f4535c9fcca3f3 = (optimisticId, analyticsEvent, error)=>({
        type: $40338ac9e4bbe7a0$export$6fdf0f2026f59ec8,
        // Flag handled by a concurrent action
        meta: {
            ...(0, $9rND4.revertOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent,
            error: error
        }
    });
const $40338ac9e4bbe7a0$export$7bc25041dbb7f97f = 'state.actions.issue.create.IP_ISSUE_CREATE_VALIDATE_FAILURE';
const $40338ac9e4bbe7a0$export$8115d8ee3d5a2c3e = (analyticsEvent, error)=>({
        type: $40338ac9e4bbe7a0$export$7bc25041dbb7f97f,
        meta: {
            analyticsEvent: analyticsEvent,
            error: error
        }
    });
const $40338ac9e4bbe7a0$export$ac5655119bbf2fd5 = 'state.actions.issue.create.CARD_CREATE_UNMAPPED';
const $40338ac9e4bbe7a0$export$2afdf25d9071462e = (cardKeys)=>({
        type: $40338ac9e4bbe7a0$export$ac5655119bbf2fd5,
        payload: {
            cardKeys: cardKeys
        }
    });
const $40338ac9e4bbe7a0$export$7e3530b9017404ec = 'state.actions.issue.create.CARD_CREATE_GLOBAL';
const $40338ac9e4bbe7a0$export$7fd1edcce679a11d = (cardKeys)=>({
        type: $40338ac9e4bbe7a0$export$7e3530b9017404ec,
        payload: {
            cardKeys: cardKeys
        }
    });
const $40338ac9e4bbe7a0$export$bf24aba99d557627 = 'state.actions.issue.create.CUSTOM_FIELD_OPTIONS_MISSED_IN_IP_BOARD';
const $40338ac9e4bbe7a0$export$c33e3f9f36f8dbca = (payload)=>({
        type: $40338ac9e4bbe7a0$export$bf24aba99d557627,
        meta: {
            ...(0, $sdxnu.errorFlagMeta)({
                titleMessage: (0, $7AVqz.default).customFieldOptionMissedTitle,
                descriptionMessage: (0, $7AVqz.default).customFieldOptionMissedDescription,
                context: {
                    ...payload
                }
            })
        }
    });

});
parcelRegister("9rND4", function(module, exports) {

$parcel$export(module.exports, "beginOptimisticUiMeta", () => $559a37778065ad75$export$ebf02a95198109b6);
$parcel$export(module.exports, "commitOptimisticUiMeta", () => $559a37778065ad75$export$76fabd640a0893d7);
$parcel$export(module.exports, "revertOptimisticUiMeta", () => $559a37778065ad75$export$732172a3c90c9446);
$parcel$export(module.exports, "revertOptimisticUiWithFlagMeta", () => $559a37778065ad75$export$62b48e9d9fa388fd);

var $alNv9 = parcelRequire("alNv9");

var $7Jxgt = parcelRequire("7Jxgt");

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $559a37778065ad75$export$afc40f9cba31cfb3 = 'OPTIMISTIC_REVERT_FLAG';
const $559a37778065ad75$export$ebf02a95198109b6 = ()=>({
        optimistic: {
            type: (0, $alNv9.BEGIN),
            id: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4()
        }
    });
const $559a37778065ad75$export$76fabd640a0893d7 = (optimisticId)=>({
        optimistic: {
            type: (0, $alNv9.COMMIT),
            id: optimisticId
        }
    });
const $559a37778065ad75$export$732172a3c90c9446 = (optimisticId)=>({
        optimistic: {
            type: (0, $alNv9.REVERT),
            id: optimisticId
        }
    });
const $559a37778065ad75$export$62b48e9d9fa388fd = (optimisticId)=>({
        optimistic: {
            type: (0, $alNv9.REVERT),
            id: optimisticId
        },
        ...(0, $sdxnu.warningFlagMeta)({
            id: $559a37778065ad75$export$afc40f9cba31cfb3,
            titleMessage: (0, $7AVqz.default).genericTitle,
            descriptionMessage: (0, $7AVqz.default).genericDescription
        })
    });

});
parcelRegister("alNv9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.optimistic = module.exports.ensureState = module.exports.REVERT = module.exports.COMMIT = module.exports.BEGIN = undefined;
var $78924382a593567a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $bXQuv = parcelRequire("bXQuv");
var $78924382a593567a$var$BEGIN = module.exports.BEGIN = '@@optimist/BEGIN';
var $78924382a593567a$var$COMMIT = module.exports.COMMIT = '@@optimist/COMMIT';
var $78924382a593567a$var$REVERT = module.exports.REVERT = '@@optimist/REVERT';
var $78924382a593567a$var$isOptimistState = function isOptimistState(state) {
    return state && Object.keys(state).length === 3 && state.hasOwnProperty('beforeState') && state.hasOwnProperty('history') && state.hasOwnProperty('current');
};
var $78924382a593567a$var$ensureState = module.exports.ensureState = function ensureState(state) {
    return $78924382a593567a$var$isOptimistState(state) ? state.current : state;
};
var $78924382a593567a$var$createState = function createState(state) {
    return {
        beforeState: undefined,
        history: [],
        current: state
    };
};
var $78924382a593567a$var$applyCommit = function applyCommit(state, targetActionIndex, reducer) {
    var history = state.history;
    // If the action to commit is the first in the queue (most common scenario)
    if (targetActionIndex === 0) {
        var historyWithoutCommit = history.slice(1);
        var nextOptimisticIndex = (0, $bXQuv.findIndex)(historyWithoutCommit, function(action) {
            return action.meta && action.meta.optimistic && !action.meta.optimistic.isNotOptimistic && action.meta.optimistic.id;
        });
        // If this is the only optimistic item in the queue, we're done!
        if (nextOptimisticIndex === -1) return $78924382a593567a$var$_extends({}, state, {
            history: [],
            beforeState: undefined
        });
        // Create a new history starting with the next one
        var newHistory = historyWithoutCommit.slice(nextOptimisticIndex);
        // And run every action up until that next one to get the new beforeState
        var newBeforeState = history.reduce(function(mutState, action, index) {
            return index <= nextOptimisticIndex ? reducer(mutState, action) : mutState;
        }, state.beforeState);
        return $78924382a593567a$var$_extends({}, state, {
            history: newHistory,
            beforeState: newBeforeState
        });
    } else {
        // If the committed action isn't the first in the queue, find out where it is
        var actionToCommit = history[targetActionIndex];
        // Make it a regular non-optimistic action
        var newAction = Object.assign({}, actionToCommit, {
            meta: Object.assign({}, actionToCommit.meta, {
                optimistic: null
            })
        });
        var _newHistory = state.history.slice();
        _newHistory.splice(targetActionIndex, 1, newAction);
        return $78924382a593567a$var$_extends({}, state, {
            history: _newHistory
        });
    }
};
var $78924382a593567a$var$applyRevert = function applyRevert(state, targetActionIndex, reducer) {
    var beforeState = state.beforeState, history = state.history;
    var newHistory = void 0;
    // If the action to revert is the first in the queue (most common scenario)
    if (targetActionIndex === 0) {
        var historyWithoutRevert = history.slice(1);
        var nextOptimisticIndex = (0, $bXQuv.findIndex)(historyWithoutRevert, function(action) {
            return action.meta && action.meta.optimistic && !action.meta.optimistic.isNotOptimistic && action.meta.optimistic.id;
        });
        // If this is the only optimistic action in the queue, we're done!
        if (nextOptimisticIndex === -1) return $78924382a593567a$var$_extends({}, state, {
            history: [],
            current: historyWithoutRevert.reduce(function(s, action) {
                return reducer(s, action);
            }, beforeState),
            beforeState: undefined
        });
        newHistory = historyWithoutRevert.slice(nextOptimisticIndex);
    } else {
        newHistory = history.slice();
        newHistory.splice(targetActionIndex, 1);
    }
    var newCurrent = newHistory.reduce(function(s, action) {
        return reducer(s, action);
    }, beforeState);
    return $78924382a593567a$var$_extends({}, state, {
        history: newHistory,
        current: newCurrent,
        beforeState: beforeState
    });
};
var $78924382a593567a$var$optimistic = module.exports.optimistic = function optimistic(reducer) {
    var rawConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config = Object.assign({
        maxHistory: 100
    }, rawConfig);
    return function(state, action) {
        if (state === undefined || !$78924382a593567a$var$isOptimistState(state)) state = $78924382a593567a$var$createState(reducer($78924382a593567a$var$ensureState(state), {}));
        var historySize = state.history.length;
        var _ref = action.meta && action.meta.optimistic || {}, type = _ref.type, id = _ref.id;
        // a historySize means there is at least 1 outstanding fetch
        if (historySize) {
            if (type !== $78924382a593567a$var$COMMIT && type !== $78924382a593567a$var$REVERT) {
                if (historySize > config.maxHistory) console.error('@@optimist: Possible memory leak detected.\n                  Verify all actions result in a commit or revert and\n                  don\'t use optimistic-UI for long-running server fetches');
                // if it's a BEGIN but we already have a historySize, treat it like a non-opt
                return $78924382a593567a$var$_extends({}, state, {
                    history: state.history.concat([
                        action
                    ]),
                    current: reducer(state.current, action)
                });
            }
            var targetActionIndex = (0, $bXQuv.findIndex)(state.history, function(action) {
                return action.meta && action.meta.optimistic && action.meta.optimistic.id === id;
            });
            if (targetActionIndex === -1) throw new Error('@@optimist: Failed to ' + (type === $78924382a593567a$var$COMMIT ? 'commit' : 'revert') + '. Transaction #' + id + ' does not exist!');
            // for resolutions, add a flag so that we know it is not an optimistic action
            action.meta.optimistic.isNotOptimistic = true;
            // include the resolution in the history & current state
            var nextState = $78924382a593567a$var$_extends({}, state, {
                history: state.history.concat([
                    action
                ]),
                current: reducer(state.current, action)
            });
            var applyFunc = type === $78924382a593567a$var$COMMIT ? $78924382a593567a$var$applyCommit : $78924382a593567a$var$applyRevert;
            return applyFunc(nextState, targetActionIndex, reducer);
        }
        // create a beforeState since one doesn't already exist
        if (type === $78924382a593567a$var$BEGIN) return $78924382a593567a$var$_extends({}, state, {
            history: state.history.concat([
                action
            ]),
            current: reducer(state.current, action),
            beforeState: state.current
        });
        // standard action escape
        return $78924382a593567a$var$_extends({}, state, {
            current: reducer(state.current, action)
        });
    };
};

});
parcelRegister("bXQuv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findIndex = $8b5dec00f6be39ba$var$findIndex;
function $8b5dec00f6be39ba$var$findIndex(arr, predicate) {
    var l = arr.length;
    for(var i = 0; i < l; i++){
        if (predicate(arr[i])) return i;
    }
    return -1;
}

});




parcelRegister("cW3pH", function(module, exports) {

$parcel$export(module.exports, "BOARD_LOAD_FAILURE", () => $d3fec575bea28757$export$80388ad0ac612bc0);
$parcel$export(module.exports, "loadBoardFailure", () => $d3fec575bea28757$export$292130a747fcac92);
$parcel$export(module.exports, "BOARD_LOAD_FAILURE_NO_COLUMN", () => $d3fec575bea28757$export$fd087a1805a6a0b2);
$parcel$export(module.exports, "loadBoardFailureNoColumn", () => $d3fec575bea28757$export$3e8eb403d18e7d62);
$parcel$export(module.exports, "BOARD_VIEW", () => $d3fec575bea28757$export$10c63dc5c09466d2);
$parcel$export(module.exports, "boardView", () => $d3fec575bea28757$export$50191da575ef3bdf);
$parcel$export(module.exports, "BOARD_NON_CRITICAL_VIEW", () => $d3fec575bea28757$export$f85c604990de6759);
$parcel$export(module.exports, "boardNonCriticalView", () => $d3fec575bea28757$export$8a605ef273fd8c8);
$parcel$export(module.exports, "IP_BOARD_404_VIEW", () => $d3fec575bea28757$export$56ca4bd173eb29be);
$parcel$export(module.exports, "showIPBoard404View", () => $d3fec575bea28757$export$ec78e5cf35893249);
$parcel$export(module.exports, "LOG_BACK_IN_SHOW", () => $d3fec575bea28757$export$de023dc2f4184994);
$parcel$export(module.exports, "showLogBackInMessage", () => $d3fec575bea28757$export$96f05b7d0945be06);
$parcel$export(module.exports, "SHOW_MISSING_ISSUE_TYPE_MESSAGE", () => $d3fec575bea28757$export$e58aba294be0a960);
$parcel$export(module.exports, "showMissingIssueTypeMessage", () => $d3fec575bea28757$export$1f55b5c98bc5eff4);
$parcel$export(module.exports, "WORK_REFRESH_DATA", () => $d3fec575bea28757$export$328746aa1d3259d8);
$parcel$export(module.exports, "workRefreshData", () => $d3fec575bea28757$export$c65e4e12058e64e2);
$parcel$export(module.exports, "WORK_DATA_SET", () => $d3fec575bea28757$export$7e2e1da5ab64812b);
$parcel$export(module.exports, "workDataSet", () => $d3fec575bea28757$export$1afa76dc1bdfbb50);
$parcel$export(module.exports, "WORK_DATA_CRITICAL_SET", () => $d3fec575bea28757$export$6f1f5cb5b6c8d7c2);
$parcel$export(module.exports, "workDataCriticalSet", () => $d3fec575bea28757$export$703025f987f2856a);
$parcel$export(module.exports, "BEFORE_DISPOSE", () => $d3fec575bea28757$export$af5317a892490d47);
$parcel$export(module.exports, "beforeDispose", () => $d3fec575bea28757$export$ff37a62a94a80510);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $d3fec575bea28757$export$80388ad0ac612bc0 = 'state.actions.work.BOARD_LOAD_FAILURE';
const $d3fec575bea28757$export$292130a747fcac92 = (error = '', showErrorFlag = true)=>({
        type: $d3fec575bea28757$export$80388ad0ac612bc0,
        meta: showErrorFlag ? (0, $sdxnu.warningFlagMeta)({
            id: $d3fec575bea28757$export$80388ad0ac612bc0,
            titleMessage: (0, $7AVqz.default).boardLoadedFailureTitle,
            descriptionMessage: (0, $7AVqz.default).boardLoadedFailureDescription,
            context: {
                error: error || ''
            }
        }) : null
    });
const $d3fec575bea28757$export$fd087a1805a6a0b2 = 'state.actions.work.BOARD_LOAD_FAILURE_NO_COLUMN';
const $d3fec575bea28757$export$3e8eb403d18e7d62 = (showErrorFlag = true, canConfigureBoard)=>({
        type: $d3fec575bea28757$export$fd087a1805a6a0b2,
        meta: showErrorFlag ? (0, $sdxnu.warningFlagMeta)({
            id: $d3fec575bea28757$export$fd087a1805a6a0b2,
            titleMessage: (0, $7AVqz.default).noColumnFailureTitle,
            descriptionMessage: canConfigureBoard ? (0, $7AVqz.default).noColumnFailureAdminDescription : (0, $7AVqz.default).noColumnFailureNonAdminDescription,
            context: {
                canConfigureBoard: canConfigureBoard
            }
        }) : null
    });
const $d3fec575bea28757$export$10c63dc5c09466d2 = 'state.actions.work.BOARD_VIEW';
const $d3fec575bea28757$export$50191da575ef3bdf = (boardInfo, analyticsEvent)=>({
        type: $d3fec575bea28757$export$10c63dc5c09466d2,
        payload: boardInfo,
        meta: {
            analytics: analyticsEvent
        }
    });
const $d3fec575bea28757$export$f85c604990de6759 = 'state.actions.work.BOARD_NON_CRITICAL_VIEW';
const $d3fec575bea28757$export$8a605ef273fd8c8 = (analyticsEvent)=>({
        type: $d3fec575bea28757$export$f85c604990de6759,
        meta: {
            analytics: analyticsEvent
        }
    });
const $d3fec575bea28757$export$56ca4bd173eb29be = 'state.actions.work.IP_BOARD_404_VIEW';
const $d3fec575bea28757$export$ec78e5cf35893249 = ()=>({
        type: $d3fec575bea28757$export$56ca4bd173eb29be,
        meta: null
    });
const $d3fec575bea28757$export$de023dc2f4184994 = 'state.actions.work.LOG_BACK_IN_SHOW';
const $d3fec575bea28757$export$96f05b7d0945be06 = (logBackInUrl)=>({
        type: $d3fec575bea28757$export$de023dc2f4184994,
        payload: logBackInUrl,
        meta: (0, $sdxnu.warningFlagMeta)({
            id: $d3fec575bea28757$export$de023dc2f4184994,
            titleMessage: (0, $7AVqz.default).logBackInTitle,
            descriptionMessage: (0, $7AVqz.default).logBackInDescription,
            context: {
                url: logBackInUrl
            }
        })
    });
const $d3fec575bea28757$export$e58aba294be0a960 = 'state.actions.work.SHOW_MISSING_ISSUE_TYPE_MESSAGE';
const $d3fec575bea28757$export$1f55b5c98bc5eff4 = (missingIssueTypeName)=>({
        type: $d3fec575bea28757$export$e58aba294be0a960,
        payload: missingIssueTypeName
    });
const $d3fec575bea28757$export$328746aa1d3259d8 = 'state.actions.work.WORK_REFRESH_DATA';
const $d3fec575bea28757$export$c65e4e12058e64e2 = (source, issues, triggerSource, hasShownFlag)=>({
        type: $d3fec575bea28757$export$328746aa1d3259d8,
        payload: {
            source: source,
            issues: issues,
            triggerSource: triggerSource,
            hasShownFlag: hasShownFlag
        }
    });
const $d3fec575bea28757$export$7e2e1da5ab64812b = 'state.actions.work.WORK_DATA_SET';
const $d3fec575bea28757$export$1afa76dc1bdfbb50 = (workData)=>({
        type: $d3fec575bea28757$export$7e2e1da5ab64812b,
        payload: workData
    });
const $d3fec575bea28757$export$6f1f5cb5b6c8d7c2 = 'state.actions.work.WORK_DATA_CRITICAL_SET';
const $d3fec575bea28757$export$703025f987f2856a = ({ issues: issues, people: people, projects: projects, config: config, hasFilteredIssues: hasFilteredIssues, columns: columns, swimlaneModeId: swimlaneModeId, sprints: sprints, isSprintsEnabled: isSprintsEnabled, boardName: boardName, capabilities: capabilities, incrementConfig: incrementConfig, issueParents: issueParents, issueTypes: issueTypes, projectIssueTypes: projectIssueTypes, boardPermissions: boardPermissions, issueChildren: issueChildren, cardTransitions: cardTransitions, allFeatures: allFeatures, inlineCardCreate: inlineCardCreate, isInlineColumnEditEnabled: isInlineColumnEditEnabled, estimationStatistic: estimationStatistic, teams: teams })=>({
        type: $d3fec575bea28757$export$6f1f5cb5b6c8d7c2,
        payload: {
            issues: issues,
            people: people,
            projects: projects,
            config: config,
            hasFilteredIssues: hasFilteredIssues,
            columns: columns,
            swimlaneModeId: swimlaneModeId,
            sprints: sprints,
            isSprintsEnabled: isSprintsEnabled,
            boardName: boardName,
            capabilities: capabilities,
            incrementConfig: incrementConfig,
            issueParents: issueParents,
            issueTypes: issueTypes,
            projectIssueTypes: projectIssueTypes,
            boardPermissions: boardPermissions,
            issueChildren: issueChildren,
            cardTransitions: cardTransitions,
            allFeatures: allFeatures,
            inlineCardCreate: inlineCardCreate,
            isInlineColumnEditEnabled: isInlineColumnEditEnabled,
            estimationStatistic: estimationStatistic,
            teams: teams
        }
    });
const $d3fec575bea28757$export$af5317a892490d47 = 'state.actions.work.BEFORE_DISPOSE';
const $d3fec575bea28757$export$ff37a62a94a80510 = {
    type: $d3fec575bea28757$export$af5317a892490d47
};

});

parcelRegister("3i1Rr", function(module, exports) {

$parcel$export(module.exports, "CardCoverToggleFailedFlag", () => $f78d35f88ddcd47b$export$890869be905669a7);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $cQyPh = parcelRequire("cQyPh");
const $f78d35f88ddcd47b$export$890869be905669a7 = ({ id: id, onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.ErrorFlag), {
        title: formatMessage((0, $cQyPh.default).title),
        description: formatMessage((0, $cQyPh.default).description),
        id: id,
        onDismissed: onDismissed
    });
};

});
parcelRegister("cQyPh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c5d60eddd250e02$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8c5d60eddd250e02$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software.main.flags.card-cover-toggle-failed.title",
        "defaultMessage": "We couldn\u2019t show your card images"
    },
    description: {
        "id": "software.main.flags.card-cover-toggle-failed.description",
        "defaultMessage": "Reload the page and try again."
    }
});

});


parcelRegister("03PHH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d80a757d1870c4fb$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $esJnl = parcelRequire("esJnl");

var $eph8m = parcelRequire("eph8m");


var $1vXOx = parcelRequire("1vXOx");

var $67Z81 = parcelRequire("67Z81");
const $d80a757d1870c4fb$var$mapStateToProps = (state)=>{
    const permissions = (0, $1vXOx.getPermissionsSelector)(state);
    return {
        boardConfigUrl: (0, $eph8m.getColumnStatusMappingUrl)((0, $67Z81.projectKeySelector)(state), (0, $67Z81.rapidViewIdSelector)(state)),
        isConfigureBoardEnabled: permissions[0, $e525e6c25695c9df$export$aadc620ce91112df] === true && !(0, $67Z81.getIsCMPBoard)(state)
    };
};
var $d80a757d1870c4fb$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($d80a757d1870c4fb$var$mapStateToProps, {})((0, $esJnl.CardCreateUnmappedFlag));

});
parcelRegister("esJnl", function(module, exports) {

$parcel$export(module.exports, "CardCreateUnmappedFlag", () => $39f5c9a19aa037a2$export$41f7bf5526b10063);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $24y3R = parcelRequire("24y3R");

var $pvsdI = parcelRequire("pvsdI");
const $39f5c9a19aa037a2$export$41f7bf5526b10063 = ({ cardKeys: cardKeys, onDismissed: onDismissed, id: id })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const numIssues = cardKeys.length;
    const getFlagDescription = ()=>formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $pvsdI.default).updatedIssueHiddenDescriptionIssueTermRefresh : (0, $pvsdI.default).updatedIssueHiddenDescription);
    const getActions = ()=>{
        const actions = [
            {
                content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $pvsdI.default).issueLinkIssueTermRefresh : (0, $pvsdI.default).issueLink, {
                    numIssues: numIssues
                }),
                href: (0, $24y3R.getIssueDiscoveryUrl)(cardKeys),
                target: '_blank'
            }
        ];
        return actions;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $pvsdI.default).updatedIssueHiddenTitleIssueTermRefresh : (0, $pvsdI.default).updatedIssueHiddenTitle, {
            numIssues: numIssues
        }),
        description: getFlagDescription(),
        actions: getActions()
    });
};

});
parcelRegister("pvsdI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3834fa35b5b67285$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3834fa35b5b67285$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueHiddenTitle: {
        "id": "software-flags.card-create-unmapped.issue-hidden-title",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {issue} other {issues}} not visible"
    },
    issueHiddenDescription: {
        "id": "software-flags.card-create-unmapped.issue-hidden-description",
        "defaultMessage": "Issue {linkStart}{linkEnd} has a status that\u2019s not visible on the board and backlog."
    },
    multipleIssuesHiddenDescription: {
        "id": "software-flags.card-create-unmapped.multiple-issues-hidden-description",
        "defaultMessage": "{numIssues, plural, one {{numIssues} issue has} other {{numIssues} issues have}} been created, but one or more have a status that's not visible on the board and backlog"
    },
    issueLink: {
        "id": "software-flags.card-create-unmapped.issue-link",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    },
    updatedIssueHiddenTitle: {
        "id": "software-flags.card-create-unmapped.updated-issue-hidden-title",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {Issue} other {Issues}} not visible"
    },
    updatedIssueHiddenDescription: {
        "id": "software-flags.card-create-unmapped.updated-issue-hidden-description",
        "defaultMessage": "For an issue to be visible, it must match your project and filters, and have a status that\u2019s assigned to the board."
    },
    issueHiddenTitleIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.issue-hidden-title-issue-term-refresh",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {issue} other {issues}} not visible"
    },
    issueHiddenDescriptionIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.issue-hidden-description-issue-term-refresh",
        "defaultMessage": "Issue {linkStart}{linkEnd} has a status that\u2019s not visible on the board and backlog."
    },
    multipleIssuesHiddenDescriptionIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.multiple-issues-hidden-description-issue-term-refresh",
        "defaultMessage": "{numIssues, plural, one {{numIssues} issue has} other {{numIssues} issues have}} been created, but one or more have a status that's not visible on the board and backlog"
    },
    issueLinkIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.issue-link-issue-term-refresh",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    },
    updatedIssueHiddenTitleIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.updated-issue-hidden-title-issue-term-refresh",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {Issue} other {Issues}} not visible"
    },
    updatedIssueHiddenDescriptionIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.updated-issue-hidden-description-issue-term-refresh",
        "defaultMessage": "For an issue to be visible, it must match your project and filters, and have a status that\u2019s assigned to the board."
    }
});

});


parcelRegister("eph8m", function(module, exports) {

$parcel$export(module.exports, "getColumnStatusMappingUrl", () => $5ab4bc978b070321$export$5eee224adec4e661);
$parcel$export(module.exports, "getManageCustomFiltersUrl", () => $5ab4bc978b070321$export$84a62bf03b005a81);
$parcel$export(module.exports, "getIssueTypesUrl", () => $5ab4bc978b070321$export$683c0f6db415ca97);
const $5ab4bc978b070321$export$5eee224adec4e661 = (projectKey, boardId, isCMPBoard = false)=>isCMPBoard ? `/jira/software/c/projects/${projectKey}/boards/${boardId}/?config=columns` : `/jira/software/projects/${projectKey}/settings/boards/${boardId}/columns`;
const $5ab4bc978b070321$export$84a62bf03b005a81 = (projectKey, boardId)=>`/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;
const $5ab4bc978b070321$export$683c0f6db415ca97 = (projectKey)=>`/plugins/servlet/project-config/${projectKey}/issuetypes`;

});

const $e525e6c25695c9df$export$9f1186f5f46d05d7 = 'CAN_MANAGE_LABS';
const $e525e6c25695c9df$export$1d4594bb2516d9ef = 'CAN_RANK_COLUMNS';
const $e525e6c25695c9df$export$aadc620ce91112df = 'CAN_EDIT_BOARD';
const $e525e6c25695c9df$export$5cd553a40d575c6c = 'CAN_EDIT_ISSUE';
const $e525e6c25695c9df$export$b5cf1ddd753a0a1c = 'CAN_RENAME_COLUMNS';
const $e525e6c25695c9df$export$c5d82f9af027c432 = 'CAN_CREATE_COLUMNS';
const $e525e6c25695c9df$export$9205190dd90cb392 = 'CAN_CREATE_CARDS';
const $e525e6c25695c9df$export$d4845393d78ba468 = 'CAN_DELETE_ISSUE';
const $e525e6c25695c9df$export$112115098b6cf79b = 'CAN_MANAGE_SPRINT';
const $e525e6c25695c9df$export$7c16e92435670968 = 'CAN_MANAGE_AUTOMATION';
const $e525e6c25695c9df$export$172db259b98bcef1 = 'CAN_RELEASE';
const $e525e6c25695c9df$export$e6bcada406923d66 = 'CAN_ARCHIVE_ISSUE';

parcelRegister("1vXOx", function(module, exports) {

$parcel$export(module.exports, "boardPermissionsSelector", () => $c1f72d1bf425b620$export$ab9a84b9372951ab);
$parcel$export(module.exports, "getPermissionsSelector", () => $c1f72d1bf425b620$export$7517e0443a661546);
$parcel$export(module.exports, "isIncrementPlanningReadOnly", () => $c1f72d1bf425b620$export$d23d829605c420dc);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");


var $67Z81 = parcelRequire("67Z81");
const $c1f72d1bf425b620$export$ab9a84b9372951ab = (state)=>(0, $67Z81.getBoardEntity)(state).permissions;
const $c1f72d1bf425b620$export$7517e0443a661546 = (0, $dGvGJ.createSelector)([
    $c1f72d1bf425b620$export$ab9a84b9372951ab
], (permissions)=>(0, $7uUwQ.freeze)({
        [(0, $e525e6c25695c9df$export$aadc620ce91112df)]: permissions.editBoardConfig,
        [(0, $e525e6c25695c9df$export$1d4594bb2516d9ef)]: permissions.editBoardConfig || false,
        [(0, $e525e6c25695c9df$export$b5cf1ddd753a0a1c)]: permissions.editBoardConfig || false,
        [(0, $e525e6c25695c9df$export$c5d82f9af027c432)]: permissions.editBoardConfig || false,
        [(0, $e525e6c25695c9df$export$9f1186f5f46d05d7)]: false,
        [(0, $e525e6c25695c9df$export$9205190dd90cb392)]: permissions.createIssue || false,
        [(0, $e525e6c25695c9df$export$5cd553a40d575c6c)]: permissions.editIssue || false,
        [(0, $e525e6c25695c9df$export$d4845393d78ba468)]: permissions.deleteIssue,
        [(0, $e525e6c25695c9df$export$112115098b6cf79b)]: permissions.manageSprint,
        [(0, $e525e6c25695c9df$export$7c16e92435670968)]: permissions.manageAutomation || false,
        [(0, $e525e6c25695c9df$export$172db259b98bcef1)]: permissions.canRelease || false,
        ...(0, $co1wz.ff)('issue-unarchival_wdpb9') ? {
            [(0, $e525e6c25695c9df$export$e6bcada406923d66)]: permissions.archiveIssue || false
        } : {}
    }));
const $c1f72d1bf425b620$export$d23d829605c420dc = (0, $dGvGJ.createSelector)([
    $c1f72d1bf425b620$export$7517e0443a661546,
    (0, $67Z81.getIsIncrementPlanningBoard),
    (0, $67Z81.getIsIncrementPlanningBoardEmbed)
], (permissions, isIncrementPlanningBoard, isIncrementPlanningBoardEmbed)=>{
    if (!isIncrementPlanningBoard) return false;
    // User is read only if they don't have create cards permission
    // or if the User is access the increment board via embed
    return (0, $4R6GH.fg)('smart_links_for_plans') ? !permissions[0, $e525e6c25695c9df$export$9205190dd90cb392] || isIncrementPlanningBoardEmbed : !permissions[0, $e525e6c25695c9df$export$9205190dd90cb392];
});

});
parcelRegister("67Z81", function(module, exports) {

$parcel$export(module.exports, "getUi", () => $3bb2e3ee04eeeeab$export$4725deb5993d78ae);
$parcel$export(module.exports, "getEntities", () => $3bb2e3ee04eeeeab$export$e2e3f9f64b249105);
$parcel$export(module.exports, "getIssueTypes", () => $3bb2e3ee04eeeeab$export$4cf4b24b88599615);
$parcel$export(module.exports, "getIssueLinkTypes", () => $3bb2e3ee04eeeeab$export$6ddaadcbafcd26f5);
$parcel$export(module.exports, "getIssueLinkTypeById", () => $3bb2e3ee04eeeeab$export$8b0014e82b332300);
$parcel$export(module.exports, "getProjectIssueTypes", () => $3bb2e3ee04eeeeab$export$3fdf4c5c6ee04f6a);
$parcel$export(module.exports, "getIssueTypesByProject", () => $3bb2e3ee04eeeeab$export$e3c86a4bf1a35488);
$parcel$export(module.exports, "getIssueTypeInIPboard", () => $3bb2e3ee04eeeeab$export$72c541e09abc58a);
$parcel$export(module.exports, "getIssues", () => $3bb2e3ee04eeeeab$export$73a53226406d7fe);
$parcel$export(module.exports, "getRequestTypes", () => $3bb2e3ee04eeeeab$export$12f7fd1ebbcde80c);
$parcel$export(module.exports, "getStatuses", () => $3bb2e3ee04eeeeab$export$dcc5d2f98fd9404b);
$parcel$export(module.exports, "getMissingParents", () => $3bb2e3ee04eeeeab$export$44b65eb211450c23);
$parcel$export(module.exports, "getCardTransitions", () => $3bb2e3ee04eeeeab$export$c5f25828191314fe);
$parcel$export(module.exports, "getIssueTransitions", () => $3bb2e3ee04eeeeab$export$72f59a26cdbd80f7);
$parcel$export(module.exports, "getIssueProjects", () => $3bb2e3ee04eeeeab$export$be5248c466188e1e);
$parcel$export(module.exports, "getTeams", () => $3bb2e3ee04eeeeab$export$5a622455e94bac3);
$parcel$export(module.exports, "getIssueCount", () => $3bb2e3ee04eeeeab$export$56d545f19dc75191);
$parcel$export(module.exports, "getIssueProjectsPermissionGroup", () => $3bb2e3ee04eeeeab$export$ec1c8958fe62c3e0);
$parcel$export(module.exports, "getIssueProjectIds", () => $3bb2e3ee04eeeeab$export$5df97f05806d557e);
$parcel$export(module.exports, "hasMultipleProjects", () => $3bb2e3ee04eeeeab$export$fe12e63e07cfc7f1);
$parcel$export(module.exports, "getVersionData", () => $3bb2e3ee04eeeeab$export$6de24118cf63db1d);
$parcel$export(module.exports, "getBoardEntity", () => $3bb2e3ee04eeeeab$export$8933098120edcb76);
$parcel$export(module.exports, "getOrderedColumnIds", () => $3bb2e3ee04eeeeab$export$f83f9f72ba8c4f46);
$parcel$export(module.exports, "getOrderedIssueIds", () => $3bb2e3ee04eeeeab$export$6238ec962277eeda);
$parcel$export(module.exports, "getOrderedIssueChildrenIds", () => $3bb2e3ee04eeeeab$export$5cec7656a4a996e6);
$parcel$export(module.exports, "getIssueParentOrderIds", () => $3bb2e3ee04eeeeab$export$8383695e8cf09c1b);
$parcel$export(module.exports, "getBoardName", () => $3bb2e3ee04eeeeab$export$dce2562af6cbec6e);
$parcel$export(module.exports, "getAppConfiguration", () => $3bb2e3ee04eeeeab$export$cf1bba1f87489c02);
$parcel$export(module.exports, "getLocale", () => $3bb2e3ee04eeeeab$export$180605366c04f0cd);
$parcel$export(module.exports, "getBoardConfig", () => $3bb2e3ee04eeeeab$export$5f9288f90460d6e);
$parcel$export(module.exports, "isBoardRankable", () => $3bb2e3ee04eeeeab$export$a510d45029fb94ae);
$parcel$export(module.exports, "getIsIncrementPlanningBoard", () => $3bb2e3ee04eeeeab$export$58598521cc17408);
$parcel$export(module.exports, "getIsIncrementPlanningBoardEmbed", () => $3bb2e3ee04eeeeab$export$4f81bf0056c92691);
$parcel$export(module.exports, "getCanInviteOthersToProject", () => $3bb2e3ee04eeeeab$export$5124aa00ca92f2c0);
$parcel$export(module.exports, "getIncrementConfig", () => $3bb2e3ee04eeeeab$export$2cfcd96e42bc72df);
$parcel$export(module.exports, "getPlanningUnit", () => $3bb2e3ee04eeeeab$export$7bd856f542fb6dc5);
$parcel$export(module.exports, "getIncrementPlanningEstimateFieldId", () => $3bb2e3ee04eeeeab$export$57d806afd0066281);
$parcel$export(module.exports, "getScenarioColor", () => $3bb2e3ee04eeeeab$export$e3ba46cc07a8e3c4);
$parcel$export(module.exports, "getBoardScopeFilter", () => $3bb2e3ee04eeeeab$export$794ec6fabc63d98b);
$parcel$export(module.exports, "getBoardScopeFilterType", () => $3bb2e3ee04eeeeab$export$27ef735461d030e);
$parcel$export(module.exports, "getPlanId", () => $3bb2e3ee04eeeeab$export$203ed8b65c3b2a28);
$parcel$export(module.exports, "getScenarioId", () => $3bb2e3ee04eeeeab$export$8572797243a693b9);
$parcel$export(module.exports, "getIsCMPBoard", () => $3bb2e3ee04eeeeab$export$2d6b2800d72a04f9);
$parcel$export(module.exports, "getIsJSWBoard", () => $3bb2e3ee04eeeeab$export$7f8f378c3fc0f2e8);
$parcel$export(module.exports, "getCanEditBoard", () => $3bb2e3ee04eeeeab$export$7af50752d48bdabc);
$parcel$export(module.exports, "getBoardType", () => $3bb2e3ee04eeeeab$export$985c8cf86abe2d42);
$parcel$export(module.exports, "getBoardTypeForAnalytics", () => $3bb2e3ee04eeeeab$export$3997d54b0837aa80);
$parcel$export(module.exports, "getHierarchyNomenclature", () => $3bb2e3ee04eeeeab$export$e755a2f4c5e8ae37);
$parcel$export(module.exports, "contextPathSelector", () => $3bb2e3ee04eeeeab$export$84437322c8301f05);
$parcel$export(module.exports, "rapidViewIdSelector", () => $3bb2e3ee04eeeeab$export$718e830000b27a0e);
$parcel$export(module.exports, "currentUserAccountIdSelector", () => $3bb2e3ee04eeeeab$export$3b6693bb0269a108);
$parcel$export(module.exports, "projectKeySelector", () => $3bb2e3ee04eeeeab$export$404de5ac601b84bc);
$parcel$export(module.exports, "projectIdSelector", () => $3bb2e3ee04eeeeab$export$4c9d6034f65d22f4);
$parcel$export(module.exports, "projectNameSelector", () => $3bb2e3ee04eeeeab$export$aa9f20f9c212aac2);
$parcel$export(module.exports, "cloudIdSelector", () => $3bb2e3ee04eeeeab$export$b5a643cfff945455);
$parcel$export(module.exports, "activationIdSelector", () => $3bb2e3ee04eeeeab$export$2335b963a9875096);
$parcel$export(module.exports, "sessionIdSelector", () => $3bb2e3ee04eeeeab$export$e4acd42e3f15be28);
$parcel$export(module.exports, "projectTypeSelector", () => $3bb2e3ee04eeeeab$export$69316f88206ca90b);
$parcel$export(module.exports, "getIssueLimitExceeded", () => $3bb2e3ee04eeeeab$export$df55630d3e8d5b50);
$parcel$export(module.exports, "getSavedFilterId", () => $3bb2e3ee04eeeeab$export$61c8853134cd8886);
$parcel$export(module.exports, "getCanRankByIssue", () => $3bb2e3ee04eeeeab$export$7ee12a197503edb8);
$parcel$export(module.exports, "getIsDaysInColumnEnabled", () => $3bb2e3ee04eeeeab$export$5e459bc04e88e2ec);
$parcel$export(module.exports, "getIsEstimateEnabled", () => $3bb2e3ee04eeeeab$export$6839f41197f5a977);
$parcel$export(module.exports, "getIsPriorityEnabled", () => $3bb2e3ee04eeeeab$export$538dfd7d997a5ce3);
$parcel$export(module.exports, "getIsDevelopmentEnabled", () => $3bb2e3ee04eeeeab$export$50491a160efc0813);
$parcel$export(module.exports, "getIsDueDateEnabled", () => $3bb2e3ee04eeeeab$export$563e039f46413317);
$parcel$export(module.exports, "getIsIssueLabelsEnabled", () => $3bb2e3ee04eeeeab$export$5f0d2767bd7b902c);
$parcel$export(module.exports, "getCardExtraFields", () => $3bb2e3ee04eeeeab$export$f338837bff9d7477);
$parcel$export(module.exports, "getFirstNonEpicIssueInFirstColumn", () => $3bb2e3ee04eeeeab$export$c8b787a7644fe978);

var $alNv9 = parcelRequire("alNv9");

var $dGvGJ = parcelRequire("dGvGJ");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $4jAPy = parcelRequire("4jAPy");

const $3bb2e3ee04eeeeab$export$4725deb5993d78ae = (state)=>(0, $alNv9.ensureState)(state.ui);
const $3bb2e3ee04eeeeab$export$e2e3f9f64b249105 = (state)=>(0, $alNv9.ensureState)(state.entities);
const $3bb2e3ee04eeeeab$export$4cf4b24b88599615 = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).issueTypes;
const $3bb2e3ee04eeeeab$export$6ddaadcbafcd26f5 = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).issueLinkTypes;
const $3bb2e3ee04eeeeab$export$8b0014e82b332300 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$6ddaadcbafcd26f5
], (issueLinkTypes)=>(linkTypeId)=>issueLinkTypes.find((type)=>`${type.id}` === `${linkTypeId}`));
const $3bb2e3ee04eeeeab$export$3fdf4c5c6ee04f6a = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).projectIssueTypes;
const $3bb2e3ee04eeeeab$export$e3c86a4bf1a35488 = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).issueTypesByProject;
const $3bb2e3ee04eeeeab$export$72c541e09abc58a = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$e3c86a4bf1a35488
], (issueTypesByProject)=>(projectId, issueTypeId)=>{
        const issueTypeArray = (issueTypesByProject[projectId] || []).filter((t)=>t.id === issueTypeId);
        return issueTypeArray.length > 0 ? issueTypeArray[0] : undefined;
    });
const $3bb2e3ee04eeeeab$export$73a53226406d7fe = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).issues;
// not meant to export this function as it is the same as /selectors/issue-children/index.tsx@getIssueChildren
// it is used by getCanRankByIssue only
const $3bb2e3ee04eeeeab$var$getIssueChildren = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).issueChildren;
const $3bb2e3ee04eeeeab$export$12f7fd1ebbcde80c = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).requestTypes;
const $3bb2e3ee04eeeeab$export$dcc5d2f98fd9404b = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).statuses;
const $3bb2e3ee04eeeeab$export$44b65eb211450c23 = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).missingParents;
const $3bb2e3ee04eeeeab$export$c5f25828191314fe = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).cardTransitions;
const $3bb2e3ee04eeeeab$export$72f59a26cdbd80f7 = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).issueTransitions;
const $3bb2e3ee04eeeeab$export$be5248c466188e1e = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).issueProjects;
const $3bb2e3ee04eeeeab$export$5a622455e94bac3 = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).teams;
const $3bb2e3ee04eeeeab$export$56d545f19dc75191 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$73a53226406d7fe
], (issues)=>Object.keys(issues).length);
const $3bb2e3ee04eeeeab$export$ec1c8958fe62c3e0 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$be5248c466188e1e
], (projects)=>{
    const projectsWithCreatePermission = [];
    const projectsWithDeletePermission = [];
    Object.values(projects).forEach((project)=>{
        const { id: id, permissions: permissions } = project;
        permissions?.CREATE_ISSUES && projectsWithCreatePermission.push(id);
        permissions?.DELETE_ISSUES && projectsWithDeletePermission.push(id);
    });
    return {
        projectsWithCreatePermission: projectsWithCreatePermission,
        projectsWithDeletePermission: projectsWithDeletePermission
    };
});
const $3bb2e3ee04eeeeab$export$5df97f05806d557e = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$be5248c466188e1e
], (projects)=>Object.keys(projects).map(Number));
const $3bb2e3ee04eeeeab$export$fe12e63e07cfc7f1 = (state)=>Object.keys($3bb2e3ee04eeeeab$export$be5248c466188e1e(state)).length > 1;
const $3bb2e3ee04eeeeab$export$6de24118cf63db1d = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).versionData;
const $3bb2e3ee04eeeeab$export$8933098120edcb76 = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).board;
const $3bb2e3ee04eeeeab$export$f83f9f72ba8c4f46 = (state)=>$3bb2e3ee04eeeeab$export$8933098120edcb76(state).columns;
const $3bb2e3ee04eeeeab$export$6238ec962277eeda = (state)=>$3bb2e3ee04eeeeab$export$8933098120edcb76(state).issues;
const $3bb2e3ee04eeeeab$export$5cec7656a4a996e6 = (state)=>$3bb2e3ee04eeeeab$export$8933098120edcb76(state).issueChildren;
const $3bb2e3ee04eeeeab$export$8383695e8cf09c1b = (state)=>$3bb2e3ee04eeeeab$export$8933098120edcb76(state).issueParentOrder;
const $3bb2e3ee04eeeeab$export$dce2562af6cbec6e = (state)=>$3bb2e3ee04eeeeab$export$8933098120edcb76(state).config.name;
const $3bb2e3ee04eeeeab$export$cf1bba1f87489c02 = (state)=>state.configuration;
const $3bb2e3ee04eeeeab$export$180605366c04f0cd = (state)=>$3bb2e3ee04eeeeab$export$cf1bba1f87489c02(state).locale;
const $3bb2e3ee04eeeeab$export$5f9288f90460d6e = (state)=>$3bb2e3ee04eeeeab$export$8933098120edcb76(state).config;
const $3bb2e3ee04eeeeab$export$a510d45029fb94ae = (state)=>$3bb2e3ee04eeeeab$export$5f9288f90460d6e(state).rankConfig.boardIsRankable;
const $3bb2e3ee04eeeeab$export$58598521cc17408 = (state)=>$3bb2e3ee04eeeeab$export$cf1bba1f87489c02(state).isIncrementPlanningBoard;
const $3bb2e3ee04eeeeab$export$4f81bf0056c92691 = ()=>globalThis.window && globalThis.window?.location.pathname.includes('plans') && globalThis.window?.location.pathname.includes('scenarios') && globalThis.window?.location.pathname.includes('/embed');
const $3bb2e3ee04eeeeab$export$5124aa00ca92f2c0 = (state)=>$3bb2e3ee04eeeeab$export$cf1bba1f87489c02(state).canInviteOthersToProject;
const $3bb2e3ee04eeeeab$export$2cfcd96e42bc72df = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).incrementConfig;
const $3bb2e3ee04eeeeab$export$7bd856f542fb6dc5 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$2cfcd96e42bc72df
], (incrementConfig)=>incrementConfig?.planningUnit);
const $3bb2e3ee04eeeeab$export$57d806afd0066281 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$7bd856f542fb6dc5
], (planningUnit)=>planningUnit === (0, $4jAPy.IP_BOARD_STORY_POINTS_PLANNING_UNIT) ? (0, $7e733a5d4e4331fc$export$10056d7262ed95fe) : (0, $7e733a5d4e4331fc$export$b9e5c87716334747));
const $3bb2e3ee04eeeeab$export$e3ba46cc07a8e3c4 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$2cfcd96e42bc72df
], (incrementConfig)=>incrementConfig?.scenarioColor);
const $3bb2e3ee04eeeeab$export$794ec6fabc63d98b = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$2cfcd96e42bc72df
], (incrementConfig)=>incrementConfig?.boardScopeFilter);
const $3bb2e3ee04eeeeab$export$27ef735461d030e = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$2cfcd96e42bc72df
], (incrementConfig)=>{
    const boardScopeFilter = incrementConfig?.boardScopeFilter;
    if (boardScopeFilter === undefined) return 0, $4jAPy.BOARD_SCOPE_FILTER_NONE;
    if (boardScopeFilter.filterFieldId === (0, $4jAPy.SYSTEM_LABEL_FIELD_ID)) return 0, $4jAPy.BOARD_SCOPE_FILTER_LABEL;
    if (boardScopeFilter.filterFieldTypeKey === (0, $4jAPy.SINGLE_CUSTOM_FIELD_TYPE_KEY)) return 0, $4jAPy.BOARD_SCOPE_FILTER_SINGLE_SELECT;
    if (boardScopeFilter.filterFieldTypeKey === (0, $4jAPy.MULTI_CUSTOM_FIELD_TYPE_KEY)) return 0, $4jAPy.BOARD_SCOPE_FILTER_MULTI_SELECT;
    return 0, $4jAPy.BOARD_SCOPE_FILTER_NONE;
});
const $3bb2e3ee04eeeeab$export$203ed8b65c3b2a28 = (state)=>$3bb2e3ee04eeeeab$export$cf1bba1f87489c02(state).planId;
const $3bb2e3ee04eeeeab$export$8572797243a693b9 = (state)=>$3bb2e3ee04eeeeab$export$cf1bba1f87489c02(state).scenarioId;
const $3bb2e3ee04eeeeab$export$2d6b2800d72a04f9 = (state)=>$3bb2e3ee04eeeeab$export$cf1bba1f87489c02(state)?.isCMPBoard === true;
const $3bb2e3ee04eeeeab$export$7f8f378c3fc0f2e8 = (state)=>$3bb2e3ee04eeeeab$export$cf1bba1f87489c02(state)?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
const $3bb2e3ee04eeeeab$export$7af50752d48bdabc = (state)=>$3bb2e3ee04eeeeab$export$8933098120edcb76(state).permissions.editBoardConfig;
const $3bb2e3ee04eeeeab$export$985c8cf86abe2d42 = (state)=>$3bb2e3ee04eeeeab$export$cf1bba1f87489c02(state)?.boardType;
const $3bb2e3ee04eeeeab$export$3997d54b0837aa80 = (state)=>{
    if ($3bb2e3ee04eeeeab$export$2d6b2800d72a04f9(state)) {
        const cmpBoardType = $3bb2e3ee04eeeeab$export$cf1bba1f87489c02(state)?.boardType?.toLowerCase();
        if (cmpBoardType === 'scrum') return 0, $7e733a5d4e4331fc$export$8ee1fad10cc70eb5;
        if (cmpBoardType === 'kanban') return 0, $7e733a5d4e4331fc$export$9f54a1518145e351;
    }
    return 0, $7e733a5d4e4331fc$export$9a2b21d55c0f061c;
};
const $3bb2e3ee04eeeeab$export$e755a2f4c5e8ae37 = (state)=>state.configuration.hierarchyNomenclature;
const $3bb2e3ee04eeeeab$export$84437322c8301f05 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.contextPath);
const $3bb2e3ee04eeeeab$export$718e830000b27a0e = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.rapidViewId);
const $3bb2e3ee04eeeeab$export$3b6693bb0269a108 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.userAccountId);
const $3bb2e3ee04eeeeab$export$404de5ac601b84bc = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.projectKey);
const $3bb2e3ee04eeeeab$export$4c9d6034f65d22f4 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.projectId);
const $3bb2e3ee04eeeeab$export$aa9f20f9c212aac2 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.projectName);
const $3bb2e3ee04eeeeab$export$b5a643cfff945455 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.cloudId);
const $3bb2e3ee04eeeeab$export$2335b963a9875096 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.activationId);
const $3bb2e3ee04eeeeab$export$e4acd42e3f15be28 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.sessionId);
const $3bb2e3ee04eeeeab$export$69316f88206ca90b = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.projectType);
const $3bb2e3ee04eeeeab$export$df55630d3e8d5b50 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$2d6b2800d72a04f9,
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (isCMPBoard, configuration)=>isCMPBoard && Boolean(configuration.issueLimitExceeded));
const $3bb2e3ee04eeeeab$export$61c8853134cd8886 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.savedFilterId);
const $3bb2e3ee04eeeeab$export$7ee12a197503edb8 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$a510d45029fb94ae,
    $3bb2e3ee04eeeeab$export$be5248c466188e1e,
    $3bb2e3ee04eeeeab$export$73a53226406d7fe,
    $3bb2e3ee04eeeeab$var$getIssueChildren,
    $3bb2e3ee04eeeeab$export$2d6b2800d72a04f9
], (isRankable, issueProjects, allIssues, issueChildren, isCMPBoard)=>(issueId)=>{
        // TMP is always rankable
        if (!isCMPBoard) return true;
        if (!isRankable) return false;
        // find the issue from all issues and issue children
        const issue = allIssues[issueId] || issueChildren[issueId];
        if (!issue) return false;
        const project = issueProjects[issue.projectId];
        return Boolean(project?.canRank);
    });
const $3bb2e3ee04eeeeab$export$5e459bc04e88e2ec = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$73a53226406d7fe
], (allIssues)=>Object.values(allIssues).some((issue)=>Boolean(issue.daysInColumn)));
const $3bb2e3ee04eeeeab$export$6839f41197f5a977 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$73a53226406d7fe
], (allIssues)=>Object.values(allIssues).some((issue)=>Boolean(issue?.estimate?.value)));
const $3bb2e3ee04eeeeab$export$538dfd7d997a5ce3 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$73a53226406d7fe
], (allIssues)=>Object.values(allIssues).some((issue)=>Boolean(issue?.priority)));
const $3bb2e3ee04eeeeab$export$50491a160efc0813 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$73a53226406d7fe
], (allIssues)=>Object.values(allIssues).some((issue)=>Boolean(issue?.devStatus)));
const $3bb2e3ee04eeeeab$export$563e039f46413317 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$73a53226406d7fe,
    $3bb2e3ee04eeeeab$export$2d6b2800d72a04f9
], (allIssues, isCMPBoard)=>{
    return (0, $4R6GH.fg)('jsw_cmp_show_due_date_by_default') ? Object.values(allIssues).some((issue)=>Boolean(issue.dueDate)) : !isCMPBoard && Object.values(allIssues).some((issue)=>Boolean(issue.dueDate));
});
const $3bb2e3ee04eeeeab$export$5f0d2767bd7b902c = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$73a53226406d7fe,
    $3bb2e3ee04eeeeab$export$2d6b2800d72a04f9
], (allIssues, isCMPBoard)=>!isCMPBoard && Object.values(allIssues).some((issue)=>Boolean(issue.labels?.length > 0)));
const $3bb2e3ee04eeeeab$export$f338837bff9d7477 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$73a53226406d7fe
], (allIssues)=>{
    const extraFieldsMap = new Map();
    Object.values(allIssues).forEach((issue)=>{
        issue.extraFields?.forEach((field)=>extraFieldsMap.set(field.id, field));
    });
    return Array.from(extraFieldsMap.values());
});
const $3bb2e3ee04eeeeab$export$c8b787a7644fe978 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$73a53226406d7fe,
    $3bb2e3ee04eeeeab$export$f83f9f72ba8c4f46,
    $3bb2e3ee04eeeeab$export$6238ec962277eeda
], (allIssues, orderedColumnIds, orderedIssueIds)=>{
    const issueVals = Object.keys(allIssues);
    if (!orderedColumnIds || orderedColumnIds.length === 0 || !allIssues || issueVals.length === 0) return undefined;
    const firstColumnId = orderedColumnIds[0];
    const firstIssueId = orderedIssueIds.find((issueId)=>allIssues[issueId].columnId === firstColumnId);
    if (firstIssueId) return allIssues[firstIssueId].key;
    return undefined;
});

});
parcelRegister("4jAPy", function(module, exports) {

$parcel$export(module.exports, "SCRUM_TEAM", () => $acaa4e836b6925cd$export$103a728db4a941f8);
$parcel$export(module.exports, "KANBAN_TEAM", () => $acaa4e836b6925cd$export$f43662b315e78f32);
$parcel$export(module.exports, "BOARD_ISSUE_SOURCE", () => $acaa4e836b6925cd$export$4c4602fa98384024);
$parcel$export(module.exports, "SINGLE_CUSTOM_FIELD_TYPE_KEY", () => $acaa4e836b6925cd$export$7a7b05cceb7cc8a9);
$parcel$export(module.exports, "MULTI_CUSTOM_FIELD_TYPE_KEY", () => $acaa4e836b6925cd$export$2afd90c3608e7105);
$parcel$export(module.exports, "SYSTEM_LABEL_FIELD_ID", () => $acaa4e836b6925cd$export$84bf4e4e31fe4475);
$parcel$export(module.exports, "CUSTOM_FIELD_OPTION_MISSED_ERROR", () => $acaa4e836b6925cd$export$aa4bdec93afa2924);
$parcel$export(module.exports, "FILTER_FIELD_ERROR", () => $acaa4e836b6925cd$export$a497a01fd14a64af);
$parcel$export(module.exports, "MAX_ACTIVE_BOARDS", () => $acaa4e836b6925cd$export$70493a18b15fa2cc);
$parcel$export(module.exports, "IP_BOARD_STORY_POINTS_PLANNING_UNIT", () => $acaa4e836b6925cd$export$e2ffaae341a16c5e);
$parcel$export(module.exports, "IP_BOARD_HOURS_PLANNING_UNIT", () => $acaa4e836b6925cd$export$9a6e823d5b9e62be);
$parcel$export(module.exports, "IP_BOARD_DAYS_PLANNING_UNIT", () => $acaa4e836b6925cd$export$ad92792f1d38ffba);
$parcel$export(module.exports, "ERROR_REPORTING_TEAM", () => $acaa4e836b6925cd$export$cfeee2ee86ead336);
$parcel$export(module.exports, "PACKAGE_NAME", () => $acaa4e836b6925cd$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "DOC_LINKS", () => $acaa4e836b6925cd$export$f8975d2c25cd8c82);
$parcel$export(module.exports, "IPH_IDS", () => $acaa4e836b6925cd$export$253194752488840a);
$parcel$export(module.exports, "MARK_SYNC_SPRINTS_PREFIX", () => $acaa4e836b6925cd$export$c78721cd39b97424);
$parcel$export(module.exports, "MARK_SYNC_SPRINTS_START", () => $acaa4e836b6925cd$export$1bb2633f6c6f66d1);
$parcel$export(module.exports, "MARK_SYNC_SPRINTS_END", () => $acaa4e836b6925cd$export$9583c6ba8c6caee3);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_NONE", () => $acaa4e836b6925cd$export$f2ee1113933b4540);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_LABEL", () => $acaa4e836b6925cd$export$3212503575d06ffd);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_SINGLE_SELECT", () => $acaa4e836b6925cd$export$ba991b7dc2732ca3);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_MULTI_SELECT", () => $acaa4e836b6925cd$export$df2129225b939441);
$parcel$export(module.exports, "DEFAULT_ITERATION_LENGTH", () => $acaa4e836b6925cd$export$8400d4ac050fc755);
$parcel$export(module.exports, "DEFAULT_ITERATIONS_COUNT", () => $acaa4e836b6925cd$export$b83f977709573647);
$parcel$export(module.exports, "ITERATIONS_COUNT_OPTIONS", () => $acaa4e836b6925cd$export$f16a2b8db5d397c);
$parcel$export(module.exports, "SWIMLANE_TEAMLESS", () => $acaa4e836b6925cd$export$b5d1b5cc4a0cc53c);
$parcel$export(module.exports, "MAX_SELECTED_ISSUES_FOR_DEPENDENCY_LINES", () => $acaa4e836b6925cd$export$ca464ff38a49aee8);
const $acaa4e836b6925cd$export$103a728db4a941f8 = 'Scrum';
const $acaa4e836b6925cd$export$f43662b315e78f32 = 'Kanban';
const $acaa4e836b6925cd$export$4c4602fa98384024 = 'Board';
const $acaa4e836b6925cd$export$ab08f53e1080ee4f = 'Project';
const $acaa4e836b6925cd$export$e5b9ed989e245a1a = 'Filter';
const $acaa4e836b6925cd$export$7a7b05cceb7cc8a9 = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $acaa4e836b6925cd$export$2afd90c3608e7105 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $acaa4e836b6925cd$export$84bf4e4e31fe4475 = 'labels';
const $acaa4e836b6925cd$export$aa4bdec93afa2924 = 'CUSTOM_FIELD_OPTION_MISSED';
const $acaa4e836b6925cd$export$a497a01fd14a64af = {
    NOT_FOUND: 'CUSTOM_FIELD_NOT_FOUND',
    TRASHED: 'CUSTOM_FIELD_TRASHED',
    NOT_IN_PLAN: 'CUSTOM_FIELD_NOT_IN_PLAN',
    OPTION_NOT_FOUND: 'CUSTOM_FIELD_OPTION_NOT_FOUND'
};
const $acaa4e836b6925cd$export$70493a18b15fa2cc = 2;
const $acaa4e836b6925cd$export$e2ffaae341a16c5e = 'StoryPoints';
const $acaa4e836b6925cd$export$9a6e823d5b9e62be = 'Hours';
const $acaa4e836b6925cd$export$ad92792f1d38ffba = 'Days';
const $acaa4e836b6925cd$export$cfeee2ee86ead336 = 'axolotl';
const $acaa4e836b6925cd$export$b8b9d90f9e5bd72b = 'jiraPortfolio3PlanIncrementCommon';
const $acaa4e836b6925cd$export$f8975d2c25cd8c82 = {
    PROGRAM_BOARD: 'https://support.atlassian.com/jira-software-cloud/docs/what-is-the-program-board-in-my-plan/',
    LINK_SPRINTS: 'https://support.atlassian.com/jira-software-cloud/docs/add-and-change-sprints-on-the-program-board-in-your-plan/',
    CREATION: 'https://support.atlassian.com/jira-software-cloud/docs/what-does-the-program-board-show/',
    CAPACITY_PLANNING: 'https://support.atlassian.com/jira-software-cloud/docs/enable-capacity-planning-in-advanced-roadmaps/',
    OFFTRACK_DEPENDENCIES: 'https://support.atlassian.com/jira-software-cloud/docs/what-are-dependencies-in-advanced-roadmaps/'
};
const $acaa4e836b6925cd$export$253194752488840a = {
    PROGRAM_BOARDS_CREATE: '6gJCMknYvLjnUgKrm4BKIj',
    PROGRAM_BOARDS_SETTINGS: '1pdnvDJUBHtLdAcH6F03rm',
    CAPACITY_PLANNING: '4kDm3TUQ7LwIEubH72m3Gk',
    OFFTRACK_DEPENDENCIES: '2HQv4dgTi14DCpGY1YU2ZF'
};
const $acaa4e836b6925cd$export$c78721cd39b97424 = 'plan-increment.sync-sprints:';
const $acaa4e836b6925cd$export$1bb2633f6c6f66d1 = `${$acaa4e836b6925cd$export$c78721cd39b97424}start`;
const $acaa4e836b6925cd$export$9583c6ba8c6caee3 = `${$acaa4e836b6925cd$export$c78721cd39b97424}end`;
const $acaa4e836b6925cd$export$f2ee1113933b4540 = 'none';
const $acaa4e836b6925cd$export$3212503575d06ffd = 'label';
const $acaa4e836b6925cd$export$ba991b7dc2732ca3 = 'select';
const $acaa4e836b6925cd$export$df2129225b939441 = 'multiselect';
const $acaa4e836b6925cd$export$8400d4ac050fc755 = 2;
const $acaa4e836b6925cd$export$b83f977709573647 = 6;
const $acaa4e836b6925cd$export$f16a2b8db5d397c = [
    {
        label: '3',
        value: 3
    },
    {
        label: '4',
        value: 4
    },
    {
        label: '5',
        value: 5
    },
    {
        label: '6',
        value: 6
    },
    {
        label: '7',
        value: 7
    },
    {
        label: '8',
        value: 8
    },
    {
        label: '9',
        value: 9
    },
    {
        label: '10',
        value: 10
    },
    {
        label: '11',
        value: 11
    },
    {
        label: '12',
        value: 12
    },
    {
        label: '13',
        value: 13
    }
];
const $acaa4e836b6925cd$export$b5d1b5cc4a0cc53c = '$teamless$';
const $acaa4e836b6925cd$export$ca464ff38a49aee8 = 10;

});

const $7e733a5d4e4331fc$export$24f467771705aaff = 'board';
const $7e733a5d4e4331fc$export$360e7ca29749d455 = 6;
const $7e733a5d4e4331fc$export$8ee1fad10cc70eb5 = 'Scrum';
const $7e733a5d4e4331fc$export$9f54a1518145e351 = 'Kanban';
const $7e733a5d4e4331fc$export$70f4a301e337eb0b = 600000;
const $7e733a5d4e4331fc$export$9a2b21d55c0f061c = 'Agility';
const $7e733a5d4e4331fc$export$8a5f5fbe7aeddf5 = 'IP';
const $7e733a5d4e4331fc$export$b1cb468c302d21f9 = 'labels';
const $7e733a5d4e4331fc$export$85243b761a28eea7 = '105px';
const $7e733a5d4e4331fc$export$b9e5c87716334747 = 'timeEstimate';
const $7e733a5d4e4331fc$export$10056d7262ed95fe = 'storyPoints';
const $7e733a5d4e4331fc$export$184668482d48a5f3 = '-unscheduled';




parcelRegister("gYo9d", function(module, exports) {

$parcel$export(module.exports, "default", () => $f28405d0562ceff9$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $dnW4F = parcelRequire("dnW4F");

var $11tjn = parcelRequire("11tjn");
const $f28405d0562ceff9$var$mapDispatchToProps = (dispatch)=>({
        onClearAllButtonClicked: ()=>{
            dispatch((0, $dnW4F.setAllFilters)({}));
        }
    });
var $f28405d0562ceff9$export$2e2bcd8739ae039 = (0, $bC2fB.connect)(null, $f28405d0562ceff9$var$mapDispatchToProps)((0, $11tjn.default));

});
parcelRegister("dnW4F", function(module, exports) {

$parcel$export(module.exports, "FILTERS_SET", () => $7331c3a36486313c$export$8c6563fc087181f);
$parcel$export(module.exports, "setFilters", () => $7331c3a36486313c$export$90e9b0558f0311af);
$parcel$export(module.exports, "SET_ALL_FILTERS", () => $7331c3a36486313c$export$2771e5a27cdc85fe);
$parcel$export(module.exports, "setAllFilters", () => $7331c3a36486313c$export$1e6b2e9f0ff84131);
$parcel$export(module.exports, "SEARCH_FOCUS", () => $7331c3a36486313c$export$ac2b2941224e429b);
$parcel$export(module.exports, "searchFieldFocus", () => $7331c3a36486313c$export$a6aa455a6b69d463);
$parcel$export(module.exports, "extraAvatarMenuOpen", () => $7331c3a36486313c$export$48ffba39408a256d);
$parcel$export(module.exports, "FILTER_PANEL_MOUNTED", () => $7331c3a36486313c$export$e3c91525b0677428);
$parcel$export(module.exports, "filterPanelMounted", () => $7331c3a36486313c$export$c48d1dabfffb8ec0);
$parcel$export(module.exports, "CLEAR_ALL_FILTERS_CLICKED", () => $7331c3a36486313c$export$f9f63b3db141632b);
$parcel$export(module.exports, "clearAllFiltersClicked", () => $7331c3a36486313c$export$5845d1911d8d06dd);
$parcel$export(module.exports, "CUSTOM_FILTER_FORCE_REFRESH_START", () => $7331c3a36486313c$export$a93d3497aade82c7);
$parcel$export(module.exports, "customFilterForceRefreshStart", () => $7331c3a36486313c$export$164137b141902cad);
const $7331c3a36486313c$export$8c6563fc087181f = 'state.actions.filter.FILTERS_SET';
const $7331c3a36486313c$export$90e9b0558f0311af = (filterType, values)=>({
        type: $7331c3a36486313c$export$8c6563fc087181f,
        payload: {
            filterType: filterType,
            values: values
        }
    });
const $7331c3a36486313c$export$2771e5a27cdc85fe = 'state.actions.filter.SET_ALL_FILTERS';
const $7331c3a36486313c$export$1e6b2e9f0ff84131 = (filters, filterType, analyticsEvent)=>({
        type: $7331c3a36486313c$export$2771e5a27cdc85fe,
        payload: {
            filters: filters
        },
        meta: {
            filterType: filterType,
            analyticsEvent: analyticsEvent
        }
    });
const $7331c3a36486313c$export$ac2b2941224e429b = 'state.actions.filter.SEARCH_FOCUS';
const $7331c3a36486313c$export$a6aa455a6b69d463 = ()=>({
        type: $7331c3a36486313c$export$ac2b2941224e429b
    });
const $7331c3a36486313c$export$f75e48e89e1e814a = 'state.actions.filter.EXTRA_AVATAR_MENU_OPEN';
const $7331c3a36486313c$export$48ffba39408a256d = ()=>({
        type: $7331c3a36486313c$export$f75e48e89e1e814a
    });
const $7331c3a36486313c$export$e3c91525b0677428 = 'state.actions.filter.FILTER_PANEL_MOUNTED';
const $7331c3a36486313c$export$c48d1dabfffb8ec0 = ()=>({
        type: $7331c3a36486313c$export$e3c91525b0677428
    });
const $7331c3a36486313c$export$f9f63b3db141632b = 'state.actions.filter.CLEAR_ALL_FILTERS_CLICKED';
const $7331c3a36486313c$export$5845d1911d8d06dd = ()=>({
        type: $7331c3a36486313c$export$f9f63b3db141632b
    });
const $7331c3a36486313c$export$a93d3497aade82c7 = 'state.actions.filter.CUSTOM_FILTER_FORCE_REFRESH_START';
const $7331c3a36486313c$export$164137b141902cad = ()=>({
        type: $7331c3a36486313c$export$a93d3497aade82c7
    });

});

parcelRegister("11tjn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d700774fc2b35141$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $hDoXj = parcelRequire("hDoXj");
const $d700774fc2b35141$var$CardCreateUnmappedFlagInIpBoard = ({ onDismissed: onDismissed, id: id, onClearAllButtonClicked: onClearAllButtonClicked })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hDoXj.default).updatedIssueHiddenTitleIssueTermRefresh : (0, $hDoXj.default).updatedIssueHiddenTitle),
        description: formatMessage((0, $hDoXj.default).updatedIssueHiddenDescription),
        actions: [
            {
                content: formatMessage((0, $hDoXj.default).clearFiltersActionText),
                onClick: ()=>{
                    onClearAllButtonClicked();
                    onDismissed && onDismissed(id);
                }
            }
        ]
    });
};
var $d700774fc2b35141$export$2e2bcd8739ae039 = $d700774fc2b35141$var$CardCreateUnmappedFlagInIpBoard;

});
parcelRegister("hDoXj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c796ca3e08d094e5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c796ca3e08d094e5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    updatedIssueHiddenTitle: {
        "id": "software.main.flags.card-create-unmapped-in-ip-board.updated-issue-hidden-title",
        "defaultMessage": "Your issue has been created, but it's hidden by a filter"
    },
    updatedIssueHiddenDescription: {
        "id": "software.main.flags.card-create-unmapped-in-ip-board.updated-issue-hidden-description",
        "defaultMessage": "Remove your filters to see it on your board."
    },
    clearFiltersActionText: {
        "id": "software.main.flags.card-create-unmapped-in-ip-board.clear-filters-action-text",
        "defaultMessage": "Clear filters"
    },
    updatedIssueHiddenTitleIssueTermRefresh: {
        "id": "software.main.flags.card-create-unmapped-in-ip-board.updated-issue-hidden-title-issue-term-refresh",
        "defaultMessage": "Your issue has been created, but it's hidden by a filter"
    }
});

});



parcelRegister("bri2z", function(module, exports) {

$parcel$export(module.exports, "default", () => $dddc1beb9d4b7c14$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $c6Bgi = parcelRequire("c6Bgi");

var $dW1HX = parcelRequire("dW1HX");

var $dkGow = parcelRequire("dkGow");

var $k8auG = parcelRequire("k8auG");
const $dddc1beb9d4b7c14$var$mapStateToProps = (state)=>({
        isAddedToSprintSuccess: (0, $k8auG.addToSprintSuccessSelector)(state),
        isAddedToSprintLoading: (0, $k8auG.addToSprintLoadingSelector)(state)
    });
const $dddc1beb9d4b7c14$var$mapDispatchToProps = {
    onViewIssue: (0, $dW1HX.openIssueModal),
    onAddToSprint: (0, $dkGow.addToSprintRequest)
};
var $dddc1beb9d4b7c14$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($dddc1beb9d4b7c14$var$mapStateToProps, $dddc1beb9d4b7c14$var$mapDispatchToProps)((0, $c6Bgi.CardFilteredFlag));

});
parcelRegister("c6Bgi", function(module, exports) {

$parcel$export(module.exports, "CardFilteredFlag", () => $85d6c211f93c7022$export$89ed935144048144);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $3KRpp = parcelRequire("3KRpp");

var $8Q4sF = parcelRequire("8Q4sF");

var $koVbs = parcelRequire("koVbs");

var $jQ7vZ = parcelRequire("jQ7vZ");

var $24y3R = parcelRequire("24y3R");

var $kDbMP = parcelRequire("kDbMP");
const $85d6c211f93c7022$export$89ed935144048144 = ({ cardKeys: cardKeys, sprints: sprints, onDismissed: onDismissed, onViewIssue: onViewIssue, onAddToSprint: onAddToSprint, isAddedToSprintLoading: isAddedToSprintLoading, isAddedToSprintSuccess: isAddedToSprintSuccess, issueMovedBetweenSwimlanes: issueMovedBetweenSwimlanes, id: id })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, setIssueKey] = (0, $jQ7vZ.useQueryParam)('selectedIssue');
    // support for multiple active sprints
    const [selectedAddToSprintIndex, setSelectedAddToSprintIndex] = (0, $5uXOq.useState)(null);
    const numIssues = cardKeys.length;
    const getAddToSprintActionContent = (0, $5uXOq.useCallback)((selectedSprintIndex = 0)=>{
        if (selectedAddToSprintIndex === selectedSprintIndex && isAddedToSprintLoading) return formatMessage((0, $kDbMP.default).issueAddToSprintLoading);
        if (selectedAddToSprintIndex === selectedSprintIndex && isAddedToSprintSuccess) return formatMessage((0, $kDbMP.default).issueAddToSprintSuccess);
         // TODO Fail message
        return formatMessage((0, $kDbMP.default).issueAddToSprint, {
            sprintName: sprints?.[selectedSprintIndex]?.name
        });
    }, [
        isAddedToSprintLoading,
        isAddedToSprintSuccess,
        selectedAddToSprintIndex,
        sprints,
        formatMessage
    ]);
    const onViewClick = numIssues === 1 && onViewIssue ? (e)=>{
        e.preventDefault();
        onViewIssue(cardKeys[0]);
        setIssueKey(cardKeys[0]);
    } : undefined;
    const onAddToSprintClickNew = (e, index)=>{
        e.preventDefault();
        if (!onAddToSprint) return;
        setSelectedAddToSprintIndex(index);
        onAddToSprint(cardKeys[0], sprints?.length ? sprints[index]?.id : undefined);
    };
    const onAddToSprintClick = numIssues === 1 ? onAddToSprintClickNew : undefined;
    const descriptionMovedBetweenSwimlanesMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kDbMP.default).descriptionMovedBetweenSwimlanesIssueTermRefresh : (0, $kDbMP.default).descriptionMovedBetweenSwimlanes;
    const descriptionMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kDbMP.default).descriptionIssueTermRefresh : (0, $kDbMP.default).description;
    const flagDescriptionMessage = issueMovedBetweenSwimlanes ? descriptionMovedBetweenSwimlanesMessage : descriptionMessage;
    const flagDescription = !issueMovedBetweenSwimlanes && numIssues === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
        message: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kDbMP.default).descriptionWithLinkIssueTermRefresh : (0, $kDbMP.default).descriptionWithLink, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        }),
        componentsMapping: {
            link: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                    href: (0, $24y3R.getIssueDiscoveryUrl)([
                        cardKeys[0]
                    ]),
                    onClick: onViewClick,
                    target: "_blank",
                    className: (0, $bwpsq.default)([
                        (0, $4R6GH.fg)('jira-a11y-links-contrast-fix') && "_4bfu18uv _1hms8stv _ajmmnqa1"
                    ])
                }, cardKeys[0])
        }
    }) : formatMessage(flagDescriptionMessage, {
        numIssues: numIssues
    });
    const generateAddToSprintActions = ()=>sprints?.length && onAddToSprintClick ? sprints.map((sprint, index)=>({
                content: getAddToSprintActionContent(index),
                onClick: (event)=>onAddToSprintClick(event, index)
            })) : [];
    const actions = numIssues > 0 ? [
        {
            content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kDbMP.default).issueLinkIssueTermRefresh : (0, $kDbMP.default).issueLink, {
                numIssues: numIssues
            }),
            href: (0, $24y3R.getIssueDiscoveryUrl)(cardKeys),
            onClick: onViewClick,
            target: '_blank'
        },
        ...generateAddToSprintActions()
    ] : [];
    (0, $5uXOq.useEffect)(()=>{
        getAddToSprintActionContent();
    }, [
        isAddedToSprintSuccess,
        isAddedToSprintLoading,
        getAddToSprintActionContent
    ]);
    const titleMovedBetweenSwimlanesMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kDbMP.default).titleMovedBetweenSwimlanesIssueTermRefresh : (0, $kDbMP.default).titleMovedBetweenSwimlanes;
    const titleMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kDbMP.default).titleIssueTermRefresh : (0, $kDbMP.default).title;
    const flagTitle = issueMovedBetweenSwimlanes ? titleMovedBetweenSwimlanesMessage : titleMessage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage(flagTitle, {
            numIssues: numIssues
        }),
        description: flagDescription,
        actions: actions
    });
};
const $85d6c211f93c7022$var$underlineLinkStyles = null;

});
parcelRegister("8Q4sF", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $7c8c20575fbc9bfc$export$200d7bd7633253ce);

var $5uXOq = parcelRequire("5uXOq");

var $gHDlh = parcelRequire("gHDlh");

var $9Byym = parcelRequire("9Byym");
const $7c8c20575fbc9bfc$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $5uXOq.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $9Byym.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $9Byym.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $9Byym.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $gHDlh.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $gHDlh.MalformedMessageError)) {
                (0, $gHDlh.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $gHDlh.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("gHDlh", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $ecff24857c176a60$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $ecff24857c176a60$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $ecff24857c176a60$export$40d900e818b9630e);

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

const $ecff24857c176a60$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $ecff24857c176a60$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $jcw0u.default)({
            meta: {
                packageName: packageName,
                id: (0, $5514815b06163219$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $5514815b06163219$export$f3390a0e172fee41)}`;
        (0, $dJl1T.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $ecff24857c176a60$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $5514815b06163219$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("9Byym", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $84498158f946a67b$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $84498158f946a67b$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $84498158f946a67b$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $84498158f946a67b$export$d5170904651e91b1);

const $84498158f946a67b$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $84498158f946a67b$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $84498158f946a67b$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $84498158f946a67b$export$d5170904651e91b1 = (letter)=>letter === (0, $7ed9c0b663db8b35$export$a10c567c3288a6b4);

});
const $7ed9c0b663db8b35$export$a10c567c3288a6b4 = '}';



parcelRegister("jQ7vZ", function(module, exports) {

$parcel$export(module.exports, "useQueryParam", () => $9fff0bf09ea99829$export$ae316f0eeb712a36);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $9xWGk = parcelRequire("9xWGk");

var $ebyGx = parcelRequire("ebyGx");

var $dIdda = parcelRequire("dIdda");
const $9fff0bf09ea99829$export$ae316f0eeb712a36 = (queryParam)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push }] = (0, $dIdda.useRouter)();
    const queryParamValue = query[queryParam];
    const setQueryParam = (0, $5uXOq.useCallback)((newValue)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
            ...query,
            [queryParam]: newValue
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value));
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(parsedSearch);
        push(pathname + (strSearch !== '' ? `?${strSearch}` : ''));
    }, [
        pathname,
        push,
        query,
        queryParam
    ]);
    return [
        queryParamValue,
        setQueryParam
    ];
};

});

parcelRegister("kDbMP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f493812da96b319$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9f493812da96b319$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software-flags.card-filtered.title",
        "defaultMessage": "Changes are saved, but {numIssues, plural, one {issue isn't} other {issues aren't}} visible"
    },
    titleMovedBetweenSwimlanes: {
        "id": "software-flags.card-filtered.title-moved-between-swimlanes",
        "defaultMessage": "You've created {numIssues, plural, one {# issue} other {# issues}}"
    },
    descriptionMovedBetweenSwimlanes: {
        "id": "software-flags.card-filtered.description-moved-between-swimlanes",
        "defaultMessage": "{numIssues, plural, one {It's} other {They've}} been created in a different swimlane because of the board's JQL setup."
    },
    descriptionWithLink: {
        "id": "software-flags.card-filtered.description-with-link",
        "defaultMessage": "For issue {linkStart}{linkEnd} to be visible, it must match your project and filters, and have a status that\u2019s assigned to the board."
    },
    description: {
        "id": "software-flags.card-filtered.description",
        "defaultMessage": "For an issue to be visible, it must match your project and filters, and have a status that\u2019s assigned to the board."
    },
    issueLink: {
        "id": "software-flags.card-filtered.issue-link",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    },
    issueAddToSprint: {
        "id": "software-flags.card-filtered.issue-add-to-sprint",
        "defaultMessage": "Add to {sprintName}"
    },
    issueAddToSprintLoading: {
        "id": "software-flags.card-filtered.issue-add-to-sprint-loading",
        "defaultMessage": "Adding..."
    },
    issueAddToSprintSuccess: {
        "id": "software-flags.card-filtered.issue-add-to-sprint-success",
        "defaultMessage": "Added to sprint"
    },
    titleIssueTermRefresh: {
        "id": "software-flags.card-filtered.title-issue-term-refresh",
        "defaultMessage": "Changes are saved, but {numIssues, plural, one {issue isn't} other {issues aren't}} visible"
    },
    titleMovedBetweenSwimlanesIssueTermRefresh: {
        "id": "software-flags.card-filtered.title-moved-between-swimlanes-issue-term-refresh",
        "defaultMessage": "You've created {numIssues, plural, one {# issue} other {# issues}}"
    },
    descriptionMovedBetweenSwimlanesIssueTermRefresh: {
        "id": "software-flags.card-filtered.description-moved-between-swimlanes-issue-term-refresh",
        "defaultMessage": "{numIssues, plural, one {It's} other {They've}} been created in a different swimlane because of the board's JQL setup."
    },
    descriptionWithLinkIssueTermRefresh: {
        "id": "software-flags.card-filtered.description-with-link-issue-term-refresh",
        "defaultMessage": "For issue {linkStart}{linkEnd} to be visible, it must match your project and filters, and have a status that\u2019s assigned to the board."
    },
    descriptionIssueTermRefresh: {
        "id": "software-flags.card-filtered.description-issue-term-refresh",
        "defaultMessage": "For an issue to be visible, it must match your project and filters, and have a status that\u2019s assigned to the board."
    },
    issueLinkIssueTermRefresh: {
        "id": "software-flags.card-filtered.issue-link-issue-term-refresh",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    }
});

});


parcelRegister("dW1HX", function(module, exports) {

$parcel$export(module.exports, "OPEN_ISSUE_MODAL", () => $8b1c17eebaa9fcb9$export$80341990b52b578a);
$parcel$export(module.exports, "openIssueModal", () => $8b1c17eebaa9fcb9$export$7aa6c7dd30954cbc);
$parcel$export(module.exports, "OPEN_PLAN_ISSUE_MODAL", () => $8b1c17eebaa9fcb9$export$9b985108e47f7d94);
$parcel$export(module.exports, "openPlanIssueModal", () => $8b1c17eebaa9fcb9$export$e7f062d9a7a48eec);
$parcel$export(module.exports, "CLOSE_PLAN_ISSUE_MODAL", () => $8b1c17eebaa9fcb9$export$d224fd2efd0fb3e7);
$parcel$export(module.exports, "closePlanIssueModal", () => $8b1c17eebaa9fcb9$export$1e7fdcc8d7bd083f);
$parcel$export(module.exports, "OPEN_ISSUE_MODAL_DEBOUNCED", () => $8b1c17eebaa9fcb9$export$113609c05439f0d1);
$parcel$export(module.exports, "openIssueModalDebounced", () => $8b1c17eebaa9fcb9$export$7395ef93f45ef532);
$parcel$export(module.exports, "CLOSE_ISSUE_MODAL", () => $8b1c17eebaa9fcb9$export$c246d364cf9f796c);
$parcel$export(module.exports, "closeIssueModal", () => $8b1c17eebaa9fcb9$export$d985da263b49e04b);
$parcel$export(module.exports, "RESET_EXTERNAL_ACTION", () => $8b1c17eebaa9fcb9$export$6c02b00db69a816);
$parcel$export(module.exports, "resetExternalAction", () => $8b1c17eebaa9fcb9$export$52fe5d486c3c9c71);
const $8b1c17eebaa9fcb9$export$80341990b52b578a = 'state.actions.issue.modal.OPEN_ISSUE_MODAL';
const $8b1c17eebaa9fcb9$export$7aa6c7dd30954cbc = (issueKey, externalAction)=>({
        type: $8b1c17eebaa9fcb9$export$80341990b52b578a,
        payload: {
            issueKey: issueKey,
            externalAction: externalAction
        }
    });
const $8b1c17eebaa9fcb9$export$9b985108e47f7d94 = 'state.actions.issue.modal.OPEN_PLAN_ISSUE_MODAL';
const $8b1c17eebaa9fcb9$export$e7f062d9a7a48eec = (issueId)=>({
        type: $8b1c17eebaa9fcb9$export$9b985108e47f7d94,
        payload: {
            issueId: issueId
        }
    });
const $8b1c17eebaa9fcb9$export$d224fd2efd0fb3e7 = 'state.actions.issue.modal.CLOSE_PLAN_ISSUE_MODAL';
const $8b1c17eebaa9fcb9$export$1e7fdcc8d7bd083f = ()=>({
        type: $8b1c17eebaa9fcb9$export$d224fd2efd0fb3e7
    });
const $8b1c17eebaa9fcb9$export$113609c05439f0d1 = 'state.actions.issue.modal.OPEN_ISSUE_MODAL_DEBOUNCED';
const $8b1c17eebaa9fcb9$export$7395ef93f45ef532 = (issueKey, externalAction)=>({
        type: $8b1c17eebaa9fcb9$export$113609c05439f0d1,
        payload: {
            issueKey: issueKey,
            externalAction: externalAction
        }
    });
const $8b1c17eebaa9fcb9$export$c246d364cf9f796c = 'state.actions.issue.modal.CLOSE_ISSUE_MODAL';
const $8b1c17eebaa9fcb9$export$d985da263b49e04b = (issuekey)=>({
        type: $8b1c17eebaa9fcb9$export$c246d364cf9f796c,
        payload: issuekey
    });
const $8b1c17eebaa9fcb9$export$6c02b00db69a816 = 'state.actions.issue.modal.RESET_EXTERNAL_ACTION';
const $8b1c17eebaa9fcb9$export$52fe5d486c3c9c71 = ()=>({
        type: $8b1c17eebaa9fcb9$export$6c02b00db69a816
    });

});

parcelRegister("dkGow", function(module, exports) {

$parcel$export(module.exports, "ADD_TO_SPRINT_REQUEST", () => $9ff718b10b6f2626$export$7bdcd99783be67bd);
$parcel$export(module.exports, "addToSprintRequest", () => $9ff718b10b6f2626$export$84c916c5eb9d94e4);
$parcel$export(module.exports, "ADD_TO_SPRINT_SUCCESS", () => $9ff718b10b6f2626$export$e9db83c78a8c2bf1);
$parcel$export(module.exports, "addToSprintSuccess", () => $9ff718b10b6f2626$export$181f94f7c9641e5b);
$parcel$export(module.exports, "ADD_TO_SPRINT_FAILURE", () => $9ff718b10b6f2626$export$55ef7a39277088c3);
$parcel$export(module.exports, "addToSprintFailure", () => $9ff718b10b6f2626$export$b8aaecf8ac2c3d6f);

var $9rND4 = parcelRequire("9rND4");
const $9ff718b10b6f2626$export$7bdcd99783be67bd = 'state.actions.sprints.add-to-sprint.ADD_TO_SPRINT_REQUEST';
function $9ff718b10b6f2626$export$84c916c5eb9d94e4(issueId, sprintId) {
    return {
        type: $9ff718b10b6f2626$export$7bdcd99783be67bd,
        payload: {
            issueId: issueId,
            sprintId: sprintId
        },
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    };
}
const $9ff718b10b6f2626$export$e9db83c78a8c2bf1 = 'state.actions.sprints.add-to-sprint.ADD_TO_SPRINT_SUCCESS';
function $9ff718b10b6f2626$export$181f94f7c9641e5b(issueKey, sprintId, optimisticId) {
    return {
        type: $9ff718b10b6f2626$export$e9db83c78a8c2bf1,
        payload: {
            issueKey: issueKey,
            sprintId: sprintId
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    };
}
const $9ff718b10b6f2626$export$55ef7a39277088c3 = 'state.actions.sprints.add-to-sprint.ADD_TO_SPRINT_FAILURE';
function $9ff718b10b6f2626$export$b8aaecf8ac2c3d6f(issueKey, sprintId, optimisticId) {
    return {
        type: $9ff718b10b6f2626$export$55ef7a39277088c3,
        payload: {
            issueKey: issueKey,
            sprintId: sprintId
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    };
}

});

parcelRegister("k8auG", function(module, exports) {

$parcel$export(module.exports, "isPollingEnabled", () => $eb31a6415d2c861f$export$ded593d93e24b277);
$parcel$export(module.exports, "isDragging", () => $eb31a6415d2c861f$export$9e9bc3c487fccc00);
$parcel$export(module.exports, "isIpBoardFailed", () => $eb31a6415d2c861f$export$77e8ff16a50d05bc);
$parcel$export(module.exports, "getPreventInlineEditing", () => $eb31a6415d2c861f$export$62c58c3c18699748);
$parcel$export(module.exports, "getIsHeaderCompactMode", () => $eb31a6415d2c861f$export$da6f0d255ab51043);
$parcel$export(module.exports, "isBoardEmptySelector", () => $eb31a6415d2c861f$export$56bc3c6954b31f2);
$parcel$export(module.exports, "isBacklogEnabled", () => $eb31a6415d2c861f$export$892dff07798b1501);
$parcel$export(module.exports, "operationsSelector", () => $eb31a6415d2c861f$export$5244c0030b3a418e);
$parcel$export(module.exports, "isEligibleForSimplifyIccBundleExperiment", () => $eb31a6415d2c861f$export$f90d16c90ee974b2);
$parcel$export(module.exports, "isUserAtLeastMemberOfProject", () => $eb31a6415d2c861f$export$56dbce3d18728488);
$parcel$export(module.exports, "getJQLSwimlanesData", () => $eb31a6415d2c861f$export$2aca7fe5f3c872c9);
$parcel$export(module.exports, "shouldRenderSwimlaneSelector", () => $eb31a6415d2c861f$export$aa9ba823fad8376b);
$parcel$export(module.exports, "addToSprintSuccessSelector", () => $eb31a6415d2c861f$export$200898df6d6c8527);
$parcel$export(module.exports, "addToSprintLoadingSelector", () => $eb31a6415d2c861f$export$e6c1d68a0e638129);
$parcel$export(module.exports, "isFavouriteSelector", () => $eb31a6415d2c861f$export$2527c507c9238fe0);

var $dGvGJ = parcelRequire("dGvGJ");

var $2vSU6 = parcelRequire("2vSU6");


var $iuuJH = parcelRequire("iuuJH");

var $c79wa = parcelRequire("c79wa");

var $9OPlz = parcelRequire("9OPlz");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $5mTgl = parcelRequire("5mTgl");

var $1vXOx = parcelRequire("1vXOx");
const $eb31a6415d2c861f$export$ded593d93e24b277 = (state)=>state.ui.board.isPollingEnabled;
const $eb31a6415d2c861f$export$9e9bc3c487fccc00 = (state)=>state.ui.board.isDragging;
const $eb31a6415d2c861f$export$77e8ff16a50d05bc = (state)=>state.ui.board.isIpBoardFailed;
const $eb31a6415d2c861f$export$62c58c3c18699748 = (state)=>state.ui.board.displayOptions.preventInlineEditing;
const $eb31a6415d2c861f$export$da6f0d255ab51043 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIsIncrementPlanningBoard),
    (state)=>state.ui.board.displayOptions.isHeaderCompactMode
], (isIncrementPlanningBoard, isHeaderCompactMode)=>{
    if (isIncrementPlanningBoard) return true;
    return isHeaderCompactMode;
});
const $eb31a6415d2c861f$export$56bc3c6954b31f2 = (0, $dGvGJ.createSelector)([
    (0, $5mTgl.workIssuesSelector)
], (allIssues)=>allIssues.length === 0);
const $eb31a6415d2c861f$export$892dff07798b1501 = (state)=>(0, $67Z81.getBoardConfig)(state).isBacklogEnabled || false;
const $eb31a6415d2c861f$export$4eefc3930c8615a5 = (state)=>(0, $67Z81.getBoardConfig)(state).isManageRulesEnabled;
const $eb31a6415d2c861f$export$5244c0030b3a418e = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getAppConfiguration)
], (configuration)=>configuration.extension.operations);
const $eb31a6415d2c861f$export$f90d16c90ee974b2 = (state)=>!(0, $67Z81.getIsCMPBoard)(state) && (0, $67Z81.projectTypeSelector)(state) === (0, $2vSU6.SOFTWARE_PROJECT) && !(0, $67Z81.getIsIncrementPlanningBoard)(state);
const $eb31a6415d2c861f$export$30f8059a9cd28e6f = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    (0, $5mTgl.isInlineColumnEditEnabled),
    (0, $5mTgl.getAppliedIssueTypeFilters)
], (swimlaneMode, inlineColumnEditEnabled, issueTypeFilters)=>(swimlaneId, isAddingSubtaskToGroup)=>{
        const isSubtaskSwimlane = swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && swimlaneId !== (0, $c79wa.ChildlessSwimlane).id && swimlaneId !== null || isAddingSubtaskToGroup;
        const hasIssueTypeFilters = issueTypeFilters ? issueTypeFilters.length > 0 : false;
        return inlineColumnEditEnabled && !isSubtaskSwimlane && !hasIssueTypeFilters;
    });
const $eb31a6415d2c861f$export$56dbce3d18728488 = (state)=>// this directly). If a user can create issues in this project, they must be at least a Member,
    // and enjoy all the privileges of a Project Member (e.g. creating and ranking issues).
    !!(0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$9205190dd90cb392];
const $eb31a6415d2c861f$export$d7a4d4bd1ecde768 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIsCMPBoard),
    (0, $45cXl.getSwimlaneMode),
    (0, $4jZ56.getSwimlanes),
    (state)=>(0, $67Z81.getEntities)(state).jqlSwimlanes
], (isCMPBoard, swimlaneMode, swimlanes, jqlSwimlanes)=>{
    if (!isCMPBoard) return false;
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_JQL).id) {
        const nonEmptySwimlanes = jqlSwimlanes.swimlanes?.filter((swimlane)=>swimlane.issueIds.length > 0);
        return nonEmptySwimlanes?.length === 1 && nonEmptySwimlanes[0].isDefaultSwimlane;
    }
    return swimlanes.length === 1 && (0, $4jZ56.isDefaultSwimlane)(swimlanes[0].id);
});
const $eb31a6415d2c861f$export$2aca7fe5f3c872c9 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIsCMPBoard),
    (0, $45cXl.getSwimlaneMode),
    (state)=>(0, $67Z81.getEntities)(state).jqlSwimlanes
], (isCMPBoard, swimlaneMode, jqlSwimlanes)=>{
    // is only available on CMP boards
    if (isCMPBoard && swimlaneMode === (0, $iuuJH.SWIMLANE_BY_JQL).id) return jqlSwimlanes.swimlanes;
    return undefined;
});
const $eb31a6415d2c861f$export$aa9ba823fad8376b = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    $eb31a6415d2c861f$export$56bc3c6954b31f2,
    (0, $67Z81.getIsCMPBoard),
    $eb31a6415d2c861f$export$d7a4d4bd1ecde768
], (swimlaneMode, isBoardEmpty, isCMPBoard, onlyHasDefaultSwimlane)=>{
    const hasSwimlanes = swimlaneMode !== (0, $iuuJH.NO_SWIMLANE).id;
    return isCMPBoard ? hasSwimlanes && !isBoardEmpty && !onlyHasDefaultSwimlane : hasSwimlanes;
});
const $eb31a6415d2c861f$export$200898df6d6c8527 = (state)=>state.ui.board.boardAddNewIssueToSprint?.isSuccess;
const $eb31a6415d2c861f$export$e6c1d68a0e638129 = (state)=>state.ui.board.boardAddNewIssueToSprint?.isLoading;
const $eb31a6415d2c861f$export$46339264d5c5653b = (0, $dGvGJ.createSelector)([
    $eb31a6415d2c861f$export$56bc3c6954b31f2,
    (0, $67Z81.getOrderedColumnIds),
    (0, $9OPlz.getColumnIdToKeepICCOpen)
], (isBoardEmpty, orderedIds, columnIdToKeepOpen)=>(columnId)=>isBoardEmpty && orderedIds.indexOf(columnId) === 0 && columnIdToKeepOpen === null);
const $eb31a6415d2c861f$export$2527c507c9238fe0 = (state)=>(0, $67Z81.getEntities)(state).board.boardFavourite.isFavourite;

});
parcelRegister("iuuJH", function(module, exports) {

$parcel$export(module.exports, "NO_SWIMLANE", () => $f9df2e6cad45bdb6$export$601dd9e413c617ed);
$parcel$export(module.exports, "SWIMLANE_BY_ASSIGNEE", () => $f9df2e6cad45bdb6$export$c0f3aef3732a1477);
$parcel$export(module.exports, "SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST", () => $f9df2e6cad45bdb6$export$2ff7658012a5c88c);
$parcel$export(module.exports, "SWIMLANE_BY_PARENT_ISSUE", () => $f9df2e6cad45bdb6$export$947c02da00077326);
$parcel$export(module.exports, "SWIMLANE_BY_SUBTASK", () => $f9df2e6cad45bdb6$export$90710dcc49445a49);
$parcel$export(module.exports, "SWIMLANE_BY_JQL", () => $f9df2e6cad45bdb6$export$2f0ea84d02e5757f);
$parcel$export(module.exports, "SWIMLANE_BY_PROJECT", () => $f9df2e6cad45bdb6$export$4625977a5c2afe09);
$parcel$export(module.exports, "SWIMLANE_BY_TEAM", () => $f9df2e6cad45bdb6$export$60dcf85dae148a2);
$parcel$export(module.exports, "SWIMLANE_BY_REQUEST_TYPE", () => $f9df2e6cad45bdb6$export$c2f0dc0dfc7ea0cc);
$parcel$export(module.exports, "defaultSwimlanes", () => $f9df2e6cad45bdb6$export$ec433d4f27cc09fa);
$parcel$export(module.exports, "SWIMLANE_CHILDLESS", () => $f9df2e6cad45bdb6$export$fba1af95ff9008dd);
$parcel$export(module.exports, "SWIMLANE_PARENTLESS", () => $f9df2e6cad45bdb6$export$90b669333b86623f);
$parcel$export(module.exports, "SWIMLANE_UNASSIGNED", () => $f9df2e6cad45bdb6$export$c0ac84cf8e34b8ae);

var $6s1PB = parcelRequire("6s1PB");

var $e5wyW = parcelRequire("e5wyW");

var $5VJuY = parcelRequire("5VJuY");
const $f9df2e6cad45bdb6$export$601dd9e413c617ed = {
    id: 'NO_SWIMLANE',
    message: (0, $5VJuY.default).none
};
const $f9df2e6cad45bdb6$export$c0f3aef3732a1477 = {
    id: 'SWIMLANE_BY_ASSIGNEE',
    message: (0, $5VJuY.default).assignee
};
const $f9df2e6cad45bdb6$var$selectAssigneeunassignedfirstMessage = (0, $e5wyW.functionWithCondition)(()=>(0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false), ()=>(0, $5VJuY.default).assigneeunassignedfirstIssueTermRefresh, ()=>(0, $5VJuY.default).assigneeunassignedfirst);
const $f9df2e6cad45bdb6$export$2ff7658012a5c88c = {
    id: 'SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST',
    message: $f9df2e6cad45bdb6$var$selectAssigneeunassignedfirstMessage()
};
const $f9df2e6cad45bdb6$export$947c02da00077326 = {
    id: 'SWIMLANE_BY_PARENT_ISSUE',
    message: (0, $5VJuY.default).epic
};
const $f9df2e6cad45bdb6$export$90710dcc49445a49 = {
    id: 'SWIMLANE_BY_SUBTASK',
    message: (0, $5VJuY.default).subtask
};
const $f9df2e6cad45bdb6$export$2f0ea84d02e5757f = {
    id: 'SWIMLANE_BY_JQL',
    message: (0, $5VJuY.default).jql
};
const $f9df2e6cad45bdb6$export$4625977a5c2afe09 = {
    id: 'SWIMLANE_BY_PROJECT',
    message: (0, $5VJuY.default).project
};
const $f9df2e6cad45bdb6$export$60dcf85dae148a2 = {
    id: 'SWIMLANE_BY_TEAM'
};
const $f9df2e6cad45bdb6$export$c2f0dc0dfc7ea0cc = {
    id: 'SWIMLANE_BY_REQUEST_TYPE',
    message: (0, $5VJuY.default).requestType
};
const $f9df2e6cad45bdb6$export$ec433d4f27cc09fa = [
    $f9df2e6cad45bdb6$export$601dd9e413c617ed,
    $f9df2e6cad45bdb6$export$c0f3aef3732a1477
];
const $f9df2e6cad45bdb6$export$fba1af95ff9008dd = '$childless$';
const $f9df2e6cad45bdb6$export$90b669333b86623f = '$parentless$';
const $f9df2e6cad45bdb6$export$c0ac84cf8e34b8ae = '$unassigned$';

});
parcelRegister("5VJuY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4518803524dd7272$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4518803524dd7272$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    none: {
        "id": "software.main.model.swimlane.none",
        "defaultMessage": "None"
    },
    assignee: {
        "id": "software.main.model.swimlane.assignee",
        "defaultMessage": "Assignee"
    },
    assigneeunassignedfirst: {
        "id": "software.main.model.swimlane.assigneeunassignedfirst",
        "defaultMessage": "Assignee with unassigned issues showing above"
    },
    epic: {
        "id": "software.main.model.swimlane.epic",
        "defaultMessage": "{displayText}"
    },
    subtask: {
        "id": "software.main.model.swimlane.subtask",
        "defaultMessage": "{displayText}"
    },
    stories: {
        "id": "software.main.model.swimlane.stories",
        "defaultMessage": "Stories"
    },
    unassigned: {
        "id": "software.main.model.swimlane.unassigned",
        "defaultMessage": "Unassigned"
    },
    parentless: {
        "id": "software.main.model.swimlane.parentless",
        "defaultMessage": "Issues without {issueParentTypeName}"
    },
    jql: {
        "id": "software.main.model.swimlane.jql",
        "defaultMessage": "Queries"
    },
    project: {
        "id": "software.main.model.swimlane.project",
        "defaultMessage": "Projects"
    },
    childless: {
        "id": "software.main.model.swimlane.childless",
        "defaultMessage": "Everything else"
    },
    requestType: {
        "id": "software.main.model.swimlane.request-type",
        "defaultMessage": "Request type"
    },
    noRequestType: {
        "id": "software.main.model.swimlane.no-request-type",
        "defaultMessage": "No request type"
    },
    assigneeunassignedfirstIssueTermRefresh: {
        "id": "software.main.model.swimlane.assigneeunassignedfirst-issue-term-refresh",
        "defaultMessage": "Assignee with unassigned issues showing above"
    },
    parentlessIssueTermRefresh: {
        "id": "software.main.model.swimlane.parentless-issue-term-refresh",
        "defaultMessage": "Issues without {issueParentTypeName}"
    }
});

});


parcelRegister("c79wa", function(module, exports) {

$parcel$export(module.exports, "ASSIGNEE", () => $c3d281ff0bb76f0d$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "PARENT", () => $c3d281ff0bb76f0d$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "STORY", () => $c3d281ff0bb76f0d$export$1ea39a3ae330045);
$parcel$export(module.exports, "JQL", () => $c3d281ff0bb76f0d$export$dc9697aa7b3a6d6f);
$parcel$export(module.exports, "PROJECT", () => $c3d281ff0bb76f0d$export$fe791c4fa892e400);
$parcel$export(module.exports, "TEAM", () => $c3d281ff0bb76f0d$export$bc8b984358922f81);
$parcel$export(module.exports, "REQUEST_TYPE", () => $c3d281ff0bb76f0d$export$92ab80c1dc9baf44);
$parcel$export(module.exports, "TeamlessSwimlane", () => $c3d281ff0bb76f0d$export$c8e393a416c39da2);
$parcel$export(module.exports, "UnassignedSwimlane", () => $c3d281ff0bb76f0d$export$94cce519f399219b);
$parcel$export(module.exports, "ParentlessSwimlane", () => $c3d281ff0bb76f0d$export$5fed833af0de9852);
$parcel$export(module.exports, "ChildlessSwimlane", () => $c3d281ff0bb76f0d$export$360035322a41fdcd);
$parcel$export(module.exports, "UnassignedRequestTypeSwimlane", () => $c3d281ff0bb76f0d$export$ff317ed97c0f34eb);

var $7uUwQ = parcelRequire("7uUwQ");

var $6s1PB = parcelRequire("6s1PB");

var $e5wyW = parcelRequire("e5wyW");

var $4jAPy = parcelRequire("4jAPy");

var $5VJuY = parcelRequire("5VJuY");

var $iuuJH = parcelRequire("iuuJH");
const $c3d281ff0bb76f0d$export$f8f7545d2bb78afb = 'ASSIGNEE';
const $c3d281ff0bb76f0d$export$e0dfb65d1047c53c = 'PARENT';
const $c3d281ff0bb76f0d$export$1ea39a3ae330045 = 'STORY';
const $c3d281ff0bb76f0d$export$dc9697aa7b3a6d6f = 'JQL';
const $c3d281ff0bb76f0d$export$fe791c4fa892e400 = 'PROJECT';
const $c3d281ff0bb76f0d$export$bc8b984358922f81 = 'TEAM';
const $c3d281ff0bb76f0d$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $c3d281ff0bb76f0d$export$c8e393a416c39da2 = (0, $7uUwQ.freeze)({
    id: (0, $4jAPy.SWIMLANE_TEAMLESS),
    message: (0, $5VJuY.default).unassigned,
    name: null,
    imageUrl: null,
    // set the isPlanTeam is true to hide the external lozenge
    values: {
        type: $c3d281ff0bb76f0d$export$bc8b984358922f81,
        isPlanTeam: true
    },
    issueKey: null
});
const $c3d281ff0bb76f0d$export$94cce519f399219b = (0, $7uUwQ.freeze)({
    id: (0, $iuuJH.SWIMLANE_UNASSIGNED),
    message: (0, $5VJuY.default).unassigned,
    name: null,
    imageUrl: null,
    values: {
        type: $c3d281ff0bb76f0d$export$f8f7545d2bb78afb,
        assignee: null,
        assigneeAccountId: null
    },
    issueKey: null
});
const $c3d281ff0bb76f0d$var$selectParentlessMessage = (0, $e5wyW.functionWithCondition)(()=>(0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false), ()=>(0, $5VJuY.default).parentlessIssueTermRefresh, ()=>(0, $5VJuY.default).parentlessIssueTermRefresh);
const $c3d281ff0bb76f0d$export$5fed833af0de9852 = (0, $7uUwQ.freeze)({
    id: (0, $iuuJH.SWIMLANE_PARENTLESS),
    message: $c3d281ff0bb76f0d$var$selectParentlessMessage(),
    name: null,
    imageUrl: null,
    values: {
        type: $c3d281ff0bb76f0d$export$e0dfb65d1047c53c,
        parentId: null
    },
    issueKey: null
});
const $c3d281ff0bb76f0d$export$360035322a41fdcd = (0, $7uUwQ.freeze)({
    id: (0, $iuuJH.SWIMLANE_CHILDLESS),
    message: (0, $5VJuY.default).childless,
    name: null,
    imageUrl: null,
    values: {
        type: $c3d281ff0bb76f0d$export$1ea39a3ae330045,
        parentId: null
    },
    issueKey: null
});
const $c3d281ff0bb76f0d$export$ff317ed97c0f34eb = (0, $7uUwQ.freeze)({
    id: (0, $iuuJH.SWIMLANE_UNASSIGNED),
    message: (0, $5VJuY.default).noRequestType,
    name: null,
    imageUrl: null,
    values: {
        type: $c3d281ff0bb76f0d$export$92ab80c1dc9baf44,
        id: null
    },
    issueKey: null
});

});

parcelRegister("9OPlz", function(module, exports) {

$parcel$export(module.exports, "getCardSelection", () => $9c373a482d4254d7$export$7710a9df00706385);
$parcel$export(module.exports, "getCardDragState", () => $9c373a482d4254d7$export$d5f32efe7e74f270);
$parcel$export(module.exports, "getSelectedTransition", () => $9c373a482d4254d7$export$95f346fb59c0427f);
$parcel$export(module.exports, "isHoverIntended", () => $9c373a482d4254d7$export$3b2830cc402a5863);
$parcel$export(module.exports, "getCardAutoScroll", () => $9c373a482d4254d7$export$4eeaff5dde2f423b);
$parcel$export(module.exports, "getCardActive", () => $9c373a482d4254d7$export$85bf96ba919898ca);
$parcel$export(module.exports, "getCardActiveKey", () => $9c373a482d4254d7$export$924ece9a606bacd2);
$parcel$export(module.exports, "getCardActiveAssignee", () => $9c373a482d4254d7$export$4fb0ea66004e1b43);
$parcel$export(module.exports, "getDraggingCardId", () => $9c373a482d4254d7$export$1320f484db5f7bb0);
$parcel$export(module.exports, "isDragInSnapMode", () => $9c373a482d4254d7$export$16cd88dec02ef1bb);
$parcel$export(module.exports, "hasNonGlobalTransitions", () => $9c373a482d4254d7$export$190c87267e0826dd);
$parcel$export(module.exports, "makeGetHasConditions", () => $9c373a482d4254d7$export$a59f9b626e859644);
$parcel$export(module.exports, "hasConditionsOnTransitions", () => $9c373a482d4254d7$export$2e3730a667f8f1b6);
$parcel$export(module.exports, "hasNoTransitionSelector", () => $9c373a482d4254d7$export$9c9dc7cd33e477eb);
$parcel$export(module.exports, "isTransactionValid", () => $9c373a482d4254d7$export$b26126c87aa5db8f);
$parcel$export(module.exports, "isCardSelected", () => $9c373a482d4254d7$export$a67ae423fb9ea0f9);
$parcel$export(module.exports, "isCardFocused", () => $9c373a482d4254d7$export$525d749d966b122a);
$parcel$export(module.exports, "shouldCardShowRipple", () => $9c373a482d4254d7$export$cbe9d09100880591);
$parcel$export(module.exports, "areAnySelectedCardsIssueChildren", () => $9c373a482d4254d7$export$738ad8fdfc61d783);
$parcel$export(module.exports, "draggingCardSourceColumnIdSelector", () => $9c373a482d4254d7$export$547687b52becf582);
$parcel$export(module.exports, "draggingCardSourceSwimlaneIdSelector", () => $9c373a482d4254d7$export$a20afd2c88b78002);
$parcel$export(module.exports, "draggingCardIssueTypeId", () => $9c373a482d4254d7$export$9af5355c0a2b8eaf);
$parcel$export(module.exports, "draggingCardIssueStatusId", () => $9c373a482d4254d7$export$bd2e9e5f3d9710b6);
$parcel$export(module.exports, "getIssueIdWithAboveICCOpen", () => $9c373a482d4254d7$export$4f6134c81576f6c8);
$parcel$export(module.exports, "hasICCOpen", () => $9c373a482d4254d7$export$8f8d79952e8c1b8f);
$parcel$export(module.exports, "getColumnIdToKeepICCOpen", () => $9c373a482d4254d7$export$57e6136c07401474);
$parcel$export(module.exports, "getLastOpenedColumnId", () => $9c373a482d4254d7$export$9f41588a1efd6d68);
$parcel$export(module.exports, "keepICCOpenInColumn", () => $9c373a482d4254d7$export$5c497d1106b09e75);
$parcel$export(module.exports, "isUnscheduledColumnICCOpen", () => $9c373a482d4254d7$export$3baa40ff5c726e5e);
$parcel$export(module.exports, "draggingCardSourceStatusSelector", () => $9c373a482d4254d7$export$2cad9a22cc3d4e69);
$parcel$export(module.exports, "draggingCardTargetColumnIdSelector", () => $9c373a482d4254d7$export$ae21bfdcca8ab956);
$parcel$export(module.exports, "draggingCardHoverIntentSelector", () => $9c373a482d4254d7$export$c89387469f496cfe);
$parcel$export(module.exports, "selectedIssueKeysSelector", () => $9c373a482d4254d7$export$3084e509c1c105f7);
$parcel$export(module.exports, "selectedIssueIdsSelector", () => $9c373a482d4254d7$export$96bec1932f9604ac);
$parcel$export(module.exports, "getVisibleCardSelection", () => $9c373a482d4254d7$export$73106b7a505f2e87);
$parcel$export(module.exports, "getShouldShowParent", () => $9c373a482d4254d7$export$bf98019ef3e35fb4);
$parcel$export(module.exports, "getCardEditSummary", () => $9c373a482d4254d7$export$a4a515b62d43884e);
$parcel$export(module.exports, "getAnyCardEditingSummary", () => $9c373a482d4254d7$export$7666a8f0609019d3);
$parcel$export(module.exports, "getCardEditAssignee", () => $9c373a482d4254d7$export$65b4fa1de1c6580a);

var $dGvGJ = parcelRequire("dGvGJ");

var $chc6P = parcelRequire("chc6P");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $gJBT6 = parcelRequire("gJBT6");

var $kGsr8 = parcelRequire("kGsr8");

var $5rFbt = parcelRequire("5rFbt");

var $iuuJH = parcelRequire("iuuJH");

var $bwTbl = parcelRequire("bwTbl");

var $vAfHD = parcelRequire("vAfHD");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");
const $9c373a482d4254d7$export$7710a9df00706385 = (state)=>state.ui.cards.selected;
const $9c373a482d4254d7$var$getCardUi = (state)=>(0, $67Z81.getUi)(state).cards;
const $9c373a482d4254d7$export$d5f32efe7e74f270 = (state)=>$9c373a482d4254d7$var$getCardUi(state).drag;
const $9c373a482d4254d7$export$95f346fb59c0427f = (state)=>$9c373a482d4254d7$export$d5f32efe7e74f270(state).selectedTransition;
const $9c373a482d4254d7$export$3b2830cc402a5863 = (state)=>$9c373a482d4254d7$export$d5f32efe7e74f270(state).hoverIntended || false;
const $9c373a482d4254d7$export$4083f6bcc362a6f5 = (state)=>$9c373a482d4254d7$var$getCardUi(state).focused;
const $9c373a482d4254d7$export$4eeaff5dde2f423b = (state)=>$9c373a482d4254d7$var$getCardUi(state).autoScroll;
const $9c373a482d4254d7$export$85bf96ba919898ca = (state)=>{
    const focusedCard = $9c373a482d4254d7$export$4083f6bcc362a6f5(state);
    if (focusedCard !== null) return focusedCard;
    const selectedCards = $9c373a482d4254d7$export$7710a9df00706385(state);
    return selectedCards[selectedCards.length - 1];
};
const $9c373a482d4254d7$export$924ece9a606bacd2 = (state)=>{
    const activeIssueId = $9c373a482d4254d7$export$85bf96ba919898ca(state);
    const issue = activeIssueId ? (0, $d2i8f.getIssueById)(state, activeIssueId) : null;
    return issue ? issue.key : null;
};
const $9c373a482d4254d7$export$4fb0ea66004e1b43 = (state)=>{
    const activeIssueId = $9c373a482d4254d7$export$85bf96ba919898ca(state);
    const issue = activeIssueId ? (0, $d2i8f.getIssueById)(state, activeIssueId) : null;
    return issue ? issue.assigneeAccountId : null;
};
const $9c373a482d4254d7$export$1320f484db5f7bb0 = (state)=>$9c373a482d4254d7$export$d5f32efe7e74f270(state).cardId;
const $9c373a482d4254d7$export$16cd88dec02ef1bb = (state)=>$9c373a482d4254d7$export$d5f32efe7e74f270(state).snapMode;
const $9c373a482d4254d7$var$getCardDragShowRipple = (state)=>$9c373a482d4254d7$export$d5f32efe7e74f270(state).rippleIdsToShow;
const $9c373a482d4254d7$export$190c87267e0826dd = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions)
], (cardTransitions)=>!!cardTransitions && (0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(cardTransitions.columnIssueTypeTransitions, (issueTypeTransitions)=>(0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(issueTypeTransitions)).some((t)=>!(t.isGlobal || t.isInitial)));
const $9c373a482d4254d7$export$a59f9b626e859644 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions),
    $9c373a482d4254d7$export$7710a9df00706385,
    (0, $vAfHD.boardIssuesSelector)
], (cardTransitions, cardSelection, boardIssues)=>(issueId)=>{
        const getIssueTypeHasConditions = (issueTypeId)=>{
            if (!cardTransitions) return false;
            return Object.keys(cardTransitions.columnIssueTypeTransitions).some((columnId)=>{
                const issueTypeTransitions = cardTransitions.columnIssueTypeTransitions[columnId];
                const transitions = issueTypeTransitions[issueTypeId];
                return Boolean(transitions?.some((transition)=>Boolean(transition.hasConditions)));
            });
        };
        const selectedIssueTypes = (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
            ...cardSelection,
            issueId
        ].map((id)=>boardIssues[id]?.typeId));
        return selectedIssueTypes.some(getIssueTypeHasConditions);
    });
const $9c373a482d4254d7$export$2e3730a667f8f1b6 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions)
], (cardTransitions)=>!!cardTransitions && (0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(cardTransitions.columnIssueTypeTransitions, (issueTypeTransitions)=>(0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(issueTypeTransitions)).some((t)=>t.hasConditions === true));
const $9c373a482d4254d7$export$9c9dc7cd33e477eb = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions)
], (cardTransitions)=>!cardTransitions || Object.values(cardTransitions.columnIssueTypeTransitions).every((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))));
const $9c373a482d4254d7$export$b26126c87aa5db8f = (state, issueId, transactionId)=>state.ui.cards.transactions[String(issueId)] === transactionId;
const $9c373a482d4254d7$export$a67ae423fb9ea0f9 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$7710a9df00706385
], (cardSelection)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId)=>cardSelection.includes(issueId)));
const $9c373a482d4254d7$export$525d749d966b122a = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$4083f6bcc362a6f5
], (focusedCardId)=>(issueId)=>focusedCardId === issueId);
const $9c373a482d4254d7$export$d955f9a510c083e3 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$4083f6bcc362a6f5,
    (0, $vAfHD.boardIssuesSelector)
], (focusedCardId, issues)=>issues[String(focusedCardId)]);
const $9c373a482d4254d7$export$cbe9d09100880591 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$var$getCardDragShowRipple
], (rippleIdsToShow)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId)=>rippleIdsToShow.includes(issueId)));
const $9c373a482d4254d7$export$87ae9db9bc3086e9 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$7710a9df00706385
], (cardSelection)=>cardSelection.length);
const $9c373a482d4254d7$export$66743788dd4e9bd8 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$7710a9df00706385
], (cardSelection)=>cardSelection.length > 0 ? cardSelection[cardSelection.length - 1] : null);
const $9c373a482d4254d7$export$738ad8fdfc61d783 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$7710a9df00706385,
    (0, $vAfHD.isBoardIssueAChild)
], (cardSelection, isBoardIssueAChild)=>cardSelection.some((cardId)=>isBoardIssueAChild(cardId)));
const $9c373a482d4254d7$export$547687b52becf582 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$d5f32efe7e74f270,
    (0, $vAfHD.boardIssuesSelector)
], (cardDrag, issues)=>issues[String(cardDrag.cardId)] && issues[String(cardDrag.cardId)].columnId);
const $9c373a482d4254d7$export$a20afd2c88b78002 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$d5f32efe7e74f270,
    (0, $vAfHD.boardIssuesSelector),
    (0, $45cXl.getSwimlaneMode),
    (0, $4jZ56.getSwimlanes),
    (0, $67Z81.getIsCMPBoard)
], (cardDrag, issues, swimlaneMode, availableSwimlanes, isCMPBoard)=>{
    const issue = issues[String(cardDrag.cardId)];
    if (!issue) return null;
    return (0, $bwTbl.getSwimlaneId)(swimlaneMode, availableSwimlanes, issue, isCMPBoard, (issueId)=>issues[issueId]);
});
const $9c373a482d4254d7$export$9af5355c0a2b8eaf = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$1320f484db5f7bb0,
    (0, $vAfHD.boardIssuesSelector)
], (issueId, boardIssues)=>issueId != null && boardIssues[String(issueId)] != null ? boardIssues[String(issueId)].typeId : undefined);
const $9c373a482d4254d7$export$bd2e9e5f3d9710b6 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$1320f484db5f7bb0,
    (0, $vAfHD.boardIssuesSelector)
], (issueId, boardIssues)=>issueId != null && boardIssues[String(issueId)] ? boardIssues[String(issueId)].statusId : undefined);
const $9c373a482d4254d7$export$4f6134c81576f6c8 = (state)=>state.ui.cards.cardWithIcc.cardIdWithAboveIccOpen ?? null;
const $9c373a482d4254d7$export$8f8d79952e8c1b8f = (state, cardId)=>cardId === $9c373a482d4254d7$export$4f6134c81576f6c8(state);
const $9c373a482d4254d7$export$57e6136c07401474 = (state)=>state.ui.cards.cardWithIcc.columnIdToKeepIccOpen ?? null;
const $9c373a482d4254d7$export$9f41588a1efd6d68 = (state)=>state.ui.cards.cardWithIcc.lastColumnIdOpen ?? null;
const $9c373a482d4254d7$export$5c497d1106b09e75 = (state, columnId)=>$9c373a482d4254d7$export$4f6134c81576f6c8(state) === null && !(0, $45cXl.hasSwimlanes)(state) && $9c373a482d4254d7$export$57e6136c07401474(state) === columnId;
const $9c373a482d4254d7$export$9c5f5305c3f51a9e = (state)=>state.ui.cards.cardWithIcc.swimlaneIdToKeepIccOpen ?? null;
const $9c373a482d4254d7$export$3baa40ff5c726e5e = (state, swimlaneId, columnId)=>columnId === (0, $5rFbt.UNSCHEDULED_COLUMN_ID) && !!swimlaneId && $9c373a482d4254d7$export$9c5f5305c3f51a9e(state) === swimlaneId;
const $9c373a482d4254d7$export$2cad9a22cc3d4e69 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions),
    $9c373a482d4254d7$export$bd2e9e5f3d9710b6,
    $9c373a482d4254d7$export$9af5355c0a2b8eaf
], (cardTransitions, statusId, issueTypeId)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(statusId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueTypeId)) return undefined;
    const statusesForIssueType = cardTransitions.issueTypeStatus[issueTypeId];
    return statusesForIssueType && statusesForIssueType[statusId];
});
const $9c373a482d4254d7$export$ae21bfdcca8ab956 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$d5f32efe7e74f270
], (cardDrag)=>cardDrag.overTransition && cardDrag.overTransition.toColumnId);
const $9c373a482d4254d7$export$c89387469f496cfe = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$d5f32efe7e74f270
], (cardDrag)=>!!(cardDrag.overTransition && cardDrag.overTransition.hoverIntent));
const $9c373a482d4254d7$export$3084e509c1c105f7 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$7710a9df00706385,
    (0, $vAfHD.boardIssuesSelector)
], (selectedIssueIds, issuesById)=>selectedIssueIds.map((issueId)=>issuesById[String(issueId)]).filter((issue)=>!!issue).map((issue)=>issue.key));
const $9c373a482d4254d7$export$96bec1932f9604ac = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$7710a9df00706385
], (selectedIssueIds)=>selectedIssueIds);
const $9c373a482d4254d7$export$73106b7a505f2e87 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$7710a9df00706385,
    (0, $vAfHD.boardIssuesSelector)
], (selectedIssueIds, issuesById)=>selectedIssueIds.filter((issueId)=>!!issuesById[String(issueId)]));
const $9c373a482d4254d7$export$bf98019ef3e35fb4 = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    (0, $67Z81.getIsCMPBoard)
], (swimlaneMode, isCMPBoard)=>isCMPBoard || swimlaneMode !== (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id);
const $9c373a482d4254d7$export$a4a515b62d43884e = (state)=>(cardId)=>state.ui.cards.inlineEditing[cardId]?.summary;
const $9c373a482d4254d7$export$7666a8f0609019d3 = (state)=>Object.values(state.ui.cards.inlineEditing).some((editing)=>editing.summary);
const $9c373a482d4254d7$export$65b4fa1de1c6580a = (state)=>(cardId)=>state.ui.cards.inlineEditing[cardId]?.assignee;

});
parcelRegister("5rFbt", function(module, exports) {

$parcel$export(module.exports, "ColumnType", () => $2fcdffd3f24185e5$export$7ce43d0a8f00d826);
$parcel$export(module.exports, "UNSCHEDULED_COLUMN_ID", () => $2fcdffd3f24185e5$export$643b1cad600bd98c);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $2fcdffd3f24185e5$export$7ce43d0a8f00d826;
(function(ColumnType) {
    ColumnType["STATUS"] = "status";
    ColumnType["DATE_RANGE"] = "date-range";
})($2fcdffd3f24185e5$export$7ce43d0a8f00d826 || ($2fcdffd3f24185e5$export$7ce43d0a8f00d826 = {}));
const $2fcdffd3f24185e5$export$643b1cad600bd98c = 0;

});

parcelRegister("bwTbl", function(module, exports) {

$parcel$export(module.exports, "getSwimlaneId", () => $44e0b000221912e7$export$3f1eedfdbe634808);
$parcel$export(module.exports, "transformSoftwareToPlatformIssue", () => $44e0b000221912e7$export$517177e029f89d28);
$parcel$export(module.exports, "getIssueCreateOrUpdateFields", () => $44e0b000221912e7$export$2e4d5b7d0f7ca2fb);
$parcel$export(module.exports, "getIssueAssignee", () => $44e0b000221912e7$export$f336191813f4b9e2);

var $7uUwQ = parcelRequire("7uUwQ");

var $6Csk1 = parcelRequire("6Csk1");

var $hGgHi = parcelRequire("hGgHi");


var $iuuJH = parcelRequire("iuuJH");

var $c79wa = parcelRequire("c79wa");
const $44e0b000221912e7$export$6383ec137697c73b = (latestDevActivity)=>{
    const { activity: activity } = latestDevActivity;
    const devStatusMap = {};
    Object.keys(activity).forEach((issueIdString)=>{
        const { dataType: dataType, count: count, stateCount: stateCount, state: prState, open: open } = activity[issueIdString];
        if (stateCount && stateCount > 0) {
            if (open || prState === 'OPEN') devStatusMap[issueIdString] = {
                activity: 'pullrequest',
                count: stateCount
            };
            else if (prState === 'MERGED') devStatusMap[issueIdString] = {
                activity: 'merged',
                count: stateCount
            };
            else if (prState === 'DECLINED') devStatusMap[issueIdString] = {
                activity: 'declined',
                count: stateCount
            };
        } else if (count > 0) {
            if (dataType === 'branch') devStatusMap[issueIdString] = {
                activity: 'branch',
                count: count
            };
            else if (dataType === 'repository') devStatusMap[issueIdString] = {
                activity: 'commit',
                count: count
            };
            else if (dataType === 'deployment') devStatusMap[issueIdString] = {
                activity: 'deployment',
                count: count
            };
            else if (dataType === 'design') devStatusMap[issueIdString] = {
                activity: 'design',
                count: count
            };
        }
    });
    return devStatusMap;
};
const $44e0b000221912e7$export$3f1eedfdbe634808 = (swimlaneMode, availableSwimlanes, issue, isCMPBoard, getIssueById)=>{
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE).id || swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST).id) return issue.assigneeAccountId || (0, $c79wa.UnassignedSwimlane).id;
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id) {
        // Try getting the epic from a subtask
        if (isCMPBoard && getIssueById && issue.parentId) {
            const issueParentIds = availableSwimlanes.map(({ id: id })=>id);
            const isChildOfIssueParent = issueParentIds.indexOf(String(issue.parentId)) > -1;
            if (!isChildOfIssueParent) return String(getIssueById(String(issue.parentId))?.parentId || (0, $c79wa.ParentlessSwimlane).id);
        }
        return issue.parentId ? String(issue.parentId) : (0, $c79wa.ParentlessSwimlane).id;
    }
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) {
        // in the case the a story issue has been rendered as swimlane header,
        // we should not assign it to a swimlane
        if (isCMPBoard && availableSwimlanes.map(({ id: id })=>id).includes(String(issue.id))) return null;
        return issue.parentId && availableSwimlanes.find((swimlane)=>swimlane.id === String(issue.parentId)) ? String(issue.parentId) : (0, $c79wa.ChildlessSwimlane).id;
    }
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_JQL).id) return availableSwimlanes.find((swimlane)=>swimlane.values?.type === 'JQL' && swimlane.values?.issueIds.includes(issue.id))?.id ?? null;
    if (isCMPBoard && swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PROJECT).id) return String(issue.projectId);
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_TEAM).id) return issue.teamId || (0, $c79wa.TeamlessSwimlane).id;
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_REQUEST_TYPE).id) return issue.requestTypeId ?? (0, $c79wa.UnassignedRequestTypeSwimlane).id;
    return null;
};
function $44e0b000221912e7$export$e8526dd1ace08941(field) {
    if (field.renderer === 'text' || field.renderer === 'epiclink' || field.renderer === 'status' || field.renderer === 'url') return !field.text || !field.text.trim();
    if (field.renderer === 'html' || field.renderer === 'date' || field.renderer === 'duration') return !field.html || field.html?.trim() === '&nbsp;';
    if (field.renderer === 'number') return field.value == null;
    if (field.renderer === 'sla') return field.value === undefined;
    // This is a type-assertion so all CustomField types are handled above
    const _invalid = field;
    // If we have an unknown custom field type assume it's non-empty
    return false;
}
const $44e0b000221912e7$export$517177e029f89d28 = (issue, swimlaneMode, availableSwimlanes, isCMPBoard, getIssueById)=>{
    const labels = {
        labels: Array.isArray(issue.labels) ? [
            ...issue.labels
        ] : []
    };
    const card = {
        id: issue.id,
        url: '',
        key: issue.key,
        summary: issue.summary,
        assigneeAccountId: issue.assigneeAccountId || null,
        typeId: String(issue.typeId),
        typeName: issue.typeName,
        typeUrl: issue.typeUrl,
        statusId: issue.statusId,
        columnId: issue.columnId,
        projectId: issue.projectId,
        swimlaneId: $44e0b000221912e7$export$3f1eedfdbe634808(swimlaneMode, availableSwimlanes, issue, isCMPBoard, getIssueById),
        isFlagged: issue.isFlagged,
        // @ts-expect-error isDone is not a part of PlatformCard
        isDone: issue.isDone,
        parentId: issue.parentId,
        estimateFieldId: issue.estimate?.fieldId,
        estimate: issue.estimate?.type === (0, $b383ed62f6689e0b$export$73bc902d1e240cad) ? issue.estimate?.valueAsText : issue.estimate?.value,
        estimateUnit: issue.estimate?.displayName,
        dueDate: issue.dueDate,
        priority: issue.priority ? {
            ...issue.priority
        } : null,
        numCompleteChildren: issue.numCompleteChildren,
        numTotalChildren: issue.numTotalChildren,
        daysInColumn: issue.daysInColumn ?? undefined,
        cardColor: issue.cardColor,
        customFields: issue.extraFields?.filter((field)=>!$44e0b000221912e7$export$e8526dd1ace08941(field)),
        issueLinks: issue.issueLinks,
        hasScenarioChanges: issue.hasScenarioChanges,
        fixVersions: issue.fixVersions,
        ...labels
    };
    const { devStatus: devStatus } = issue;
    if (devStatus) {
        const deploymentDetails = devStatus.deploymentDetails ? {
            deploymentDetails: devStatus.deploymentDetails
        } : {};
        card.devStatusField = {
            activity: devStatus.activity,
            count: devStatus.count,
            ...deploymentDetails
        };
    }
    return card;
};
const $44e0b000221912e7$export$4375d65c4249ba96 = (issue, response)=>{
    if (!response) return issue;
    const { id: id, key: key, fields: { summary: summary, status: status, project: project, assignee: assignee, issuetype: issuetype, labels: labels, resolutiondate: resolutiondate, priority: priority, duedate: duedate } } = response;
    const newIssue = {
        ...issue,
        id: Number(id),
        key: key,
        summary: summary,
        statusId: Number(status.id),
        projectId: Number(project.id),
        isDone: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(resolutiondate),
        priority: priority || null,
        dueDate: duedate || null
    };
    if (assignee) (0, (/*@__PURE__*/$parcel$interopDefault($6Csk1)))(newIssue, {
        assigneeAccountId: assignee.accountId,
        assigneeName: assignee.name
    });
    if (issuetype) (0, (/*@__PURE__*/$parcel$interopDefault($6Csk1)))(newIssue, {
        typeId: issuetype.id,
        typeName: issuetype.name,
        typeUrl: issuetype.iconUrl
    });
    if (labels) (0, (/*@__PURE__*/$parcel$interopDefault($6Csk1)))(newIssue, {
        labels: labels
    });
    return newIssue;
};
const $44e0b000221912e7$var$emptyObj = (0, $7uUwQ.freeze)({});
const $44e0b000221912e7$export$2e4d5b7d0f7ca2fb = (values)=>{
    if (values.type === (0, $c79wa.ASSIGNEE)) return {
        assignee: {
            id: values.assigneeAccountId
        }
    };
    return $44e0b000221912e7$var$emptyObj;
};
const $44e0b000221912e7$export$f336191813f4b9e2 = (swimlaneValues)=>swimlaneValues.type === (0, $c79wa.ASSIGNEE) ? {
        assigneeAccountId: swimlaneValues.assigneeAccountId
    } : $44e0b000221912e7$var$emptyObj;

});
const $b383ed62f6689e0b$export$a092d6877c35430e = 'TMP_STORY_POINTS';
const $b383ed62f6689e0b$export$73bc902d1e240cad = 'TMP_ORIGINAL_TIME_ESTIMATE';
const $b383ed62f6689e0b$export$feb32b877d96492 = 'CUSTOM_ESTIMATE_FIELD';
const $b383ed62f6689e0b$export$24c68738fb7a96c7 = 'INCREMENT_PLANNING_ESTIMATE_FIELD';


parcelRegister("vAfHD", function(module, exports) {

$parcel$export(module.exports, "issueIdsWithSubtasksSelector", () => $127094222b407ab0$export$6a593bab20bef101);
$parcel$export(module.exports, "orderedIssuesWithSubtasksSelector", () => $127094222b407ab0$export$76220d546b87854e);
$parcel$export(module.exports, "boardIssuesSelector", () => $127094222b407ab0$export$d28e3ad6b62447a8);
$parcel$export(module.exports, "boardIssuesAndChildrenSelector", () => $127094222b407ab0$export$17d58dbbb9df5b49);
$parcel$export(module.exports, "boardOrderedIssueIdsSelector", () => $127094222b407ab0$export$fbf9bc381f8dfefe);
$parcel$export(module.exports, "isBoardIssueAChild", () => $127094222b407ab0$export$25181966ab630bdc);
$parcel$export(module.exports, "makeGetIssueKeyFromIssueId", () => $127094222b407ab0$export$960526337bf0f2d9);

var $dGvGJ = parcelRequire("dGvGJ");

var $fn8B5 = parcelRequire("fn8B5");

var $4wVpT = parcelRequire("4wVpT");

var $gJBT6 = parcelRequire("gJBT6");

var $fr1K2 = parcelRequire("fr1K2");

var $kGsr8 = parcelRequire("kGsr8");

var $iuuJH = parcelRequire("iuuJH");

var $3UY9S = parcelRequire("3UY9S");

var $4gt6L = parcelRequire("4gt6L");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");
const $127094222b407ab0$export$6a593bab20bef101 = (0, $dGvGJ.createSelector)([
    (0, $3UY9S.issueChildrenSelector)
], (issueChildren)=>(0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(issueChildren.map((issueChild)=>issueChild.parentId || 0).filter((parentId)=>parentId !== 0)));
const $127094222b407ab0$export$54c1dc9ca3ac499b = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssues),
    $127094222b407ab0$export$6a593bab20bef101
], (issues, issueIdsWithSubtasks)=>(0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(issues, issueIdsWithSubtasks.map((issueId)=>String(issueId))));
const $127094222b407ab0$export$76220d546b87854e = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getOrderedIssueIds),
    (0, $67Z81.getIssues),
    $127094222b407ab0$export$6a593bab20bef101,
    (0, $67Z81.getIsCMPBoard),
    (0, $67Z81.getMissingParents)
], (orderedIssueIds, issues, issueIdsWithSubtasks, isCMPBoard, missingParents)=>{
    const allIssueIds = isCMPBoard ? [
        ...orderedIssueIds,
        ...Object.keys(missingParents).map((missingParentId)=>Number(missingParentId))
    ] : orderedIssueIds;
    const allIssues = (()=>{
        if (!isCMPBoard) return {
            ...issues
        };
        return {
            ...missingParents,
            ...issues
        };
    })();
    return (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(allIssueIds, issueIdsWithSubtasks).map((issueId)=>allIssues[String(issueId)]).filter((issue)=>issue);
});
const $127094222b407ab0$export$d28e3ad6b62447a8 = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    (0, $67Z81.getIssues),
    $127094222b407ab0$export$54c1dc9ca3ac499b,
    (0, $3UY9S.getIssueChildren),
    (0, $67Z81.getIsCMPBoard)
], (swimlaneMode, allIssues, issuesWithoutSubtasks, children, isCMPBoard)=>{
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return isCMPBoard ? {
        ...allIssues,
        ...children
    } : {
        ...issuesWithoutSubtasks,
        ...children
    };
    if (isCMPBoard) return {
        ...allIssues,
        ...children
    };
    return allIssues;
});
const $127094222b407ab0$export$17d58dbbb9df5b49 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssues),
    (0, $3UY9S.getIssueChildren)
], (allIssues, children)=>({
        ...allIssues,
        ...children
    }));
const $127094222b407ab0$export$fbf9bc381f8dfefe = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    (0, $67Z81.getIssues),
    $127094222b407ab0$export$54c1dc9ca3ac499b,
    (0, $67Z81.getOrderedIssueIds),
    (0, $67Z81.getOrderedIssueChildrenIds),
    (0, $67Z81.getIsCMPBoard),
    (0, $3UY9S.getIssueChildren),
    (0, $67Z81.isBoardRankable)
], (swimlaneMode, allIssues, issuesWithoutSubtasks, orderedIssueIds, orderedChildrenIds, isCMPBoard, children, isRankable)=>{
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) {
        if (isCMPBoard) {
            // ordered swimlane header issue ids. It does not include children issue id.
            const orderedSwimlaneHeaderIssueIds = orderedIssueIds.filter((id)=>id in allIssues);
            return [
                ...orderedSwimlaneHeaderIssueIds,
                ...orderedChildrenIds
            ];
        }
        const issueIdsWithoutSubtasks = Object.keys(issuesWithoutSubtasks);
        const orderedIssueWithoutSubtasksIds = orderedIssueIds.filter((id)=>issueIdsWithoutSubtasks.includes(String(id)));
        return [
            ...orderedIssueWithoutSubtasksIds,
            ...orderedChildrenIds
        ];
    }
    if (isCMPBoard && isRankable) {
        const childrenIdsByParentId = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(orderedChildrenIds, (childId)=>children[childId].parentId);
        return orderedIssueIds.flatMap((issueId)=>[
                issueId,
                ...childrenIdsByParentId[issueId] ?? []
            ]);
    }
    return orderedIssueIds;
});
const $127094222b407ab0$export$25181966ab630bdc = (0, $dGvGJ.createSelector)([
    (0, $4gt6L.issueChildrenTypeIdsSelector),
    $127094222b407ab0$export$d28e3ad6b62447a8
], (issueChildrenTypeIds, boardIssues)=>{
    const isBoardIssueAChildCheck = (issueId)=>{
        const issue = boardIssues[String(issueId)];
        if (!issue) return false;
        return issueChildrenTypeIds.includes(String(issue.typeId));
    };
    return isBoardIssueAChildCheck;
});
const $127094222b407ab0$export$960526337bf0f2d9 = (0, $dGvGJ.createSelector)((0, $67Z81.getIssues), (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId)=>issues[issueId]?.key ?? undefined));

});
parcelRegister("4wVpT", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $9dThv = parcelRequire("9dThv");

var $g7i7g = parcelRequire("g7i7g");

var $d9Hx6 = parcelRequire("d9Hx6");
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var $34c6b050456654f8$var$intersection = $g7i7g(function(arrays) {
    var mapped = $1nIHN(arrays, $d9Hx6);
    return mapped.length && mapped[0] === arrays[0] ? $9dThv(mapped) : [];
});
module.exports = $34c6b050456654f8$var$intersection;

});
parcelRegister("9dThv", function(module, exports) {

var $ijRUK = parcelRequire("ijRUK");

var $fUP98 = parcelRequire("fUP98");

var $dA3tP = parcelRequire("dA3tP");

var $1nIHN = parcelRequire("1nIHN");

var $cW28x = parcelRequire("cW28x");

var $40I25 = parcelRequire("40I25");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6b7035a795ecd274$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $6b7035a795ecd274$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $dA3tP : $fUP98, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $1nIHN(array, $cW28x(iteratee));
        maxLength = $6b7035a795ecd274$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $ijRUK(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $40I25(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $40I25(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $6b7035a795ecd274$var$baseIntersection;

});

parcelRegister("d9Hx6", function(module, exports) {

var $f3SOL = parcelRequire("f3SOL");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $993de25d5a02863a$var$castArrayLikeObject(value) {
    return $f3SOL(value) ? value : [];
}
module.exports = $993de25d5a02863a$var$castArrayLikeObject;

});


parcelRegister("3UY9S", function(module, exports) {

$parcel$export(module.exports, "getIssueChildren", () => $cd00b884759d904f$export$9ed60bbe06bbd06b);
$parcel$export(module.exports, "issueChildrenSelector", () => $cd00b884759d904f$export$e4d41a6d0bc11e95);
$parcel$export(module.exports, "numTotalIssueChildren", () => $cd00b884759d904f$export$1b6edd941a4eaddd);
$parcel$export(module.exports, "numCompleteIssueChildren", () => $cd00b884759d904f$export$18ec94fe8e415ca5);
$parcel$export(module.exports, "getChildrenOfParent", () => $cd00b884759d904f$export$e35229fc554ba8ff);
$parcel$export(module.exports, "getParentIdByIssueChildSelector", () => $cd00b884759d904f$export$b971fb01711c101b);

var $dGvGJ = parcelRequire("dGvGJ");

var $hGgHi = parcelRequire("hGgHi");

var $gJBT6 = parcelRequire("gJBT6");

var $27NS3 = parcelRequire("27NS3");

var $67Z81 = parcelRequire("67Z81");
const $cd00b884759d904f$export$9ed60bbe06bbd06b = (state)=>(0, $67Z81.getEntities)(state).issueChildren;
const $cd00b884759d904f$export$e4d41a6d0bc11e95 = (0, $dGvGJ.createSelector)($cd00b884759d904f$export$9ed60bbe06bbd06b, (issueChildren)=>Object.keys(issueChildren).map((issueId)=>({
            ...issueChildren[issueId]
        })));
const $cd00b884759d904f$export$1b6edd941a4eaddd = (0, $dGvGJ.createSelector)((0, $67Z81.getIssues), (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($27NS3)))(Object.keys(issues).map((key)=>issues[key]), (num, issue)=>num + issue.numTotalChildren, 0));
const $cd00b884759d904f$export$18ec94fe8e415ca5 = (0, $dGvGJ.createSelector)((0, $67Z81.getIssues), (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($27NS3)))(Object.keys(issues).map((key)=>issues[key]), (num, issue)=>num + issue.numCompleteChildren, 0));
const $cd00b884759d904f$export$e35229fc554ba8ff = (0, $dGvGJ.createSelector)([
    $cd00b884759d904f$export$e4d41a6d0bc11e95
], (issueChildren)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((parentIssueId)=>issueChildren.filter((issue)=>issue.parentId === parentIssueId).map((issue)=>issue.id)));
const $cd00b884759d904f$export$b971fb01711c101b = (0, $dGvGJ.createSelector)([
    $cd00b884759d904f$export$9ed60bbe06bbd06b,
    (0, $67Z81.getIssues),
    (0, $67Z81.getMissingParents)
], (issueChildren, issues, missingParents)=>(issueChildId)=>{
        const parentId = issueChildren[issueChildId]?.parentId;
        // make sure the parent of the child issue is available in redux context (issues or missing parents)
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(parentId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issues[parentId] ?? missingParents[parentId])) return null;
        return parentId;
    });

});
parcelRegister("27NS3", function(module, exports) {

var $2YkAc = parcelRequire("2YkAc");

var $e7pfQ = parcelRequire("e7pfQ");

var $bxDef = parcelRequire("bxDef");

var $87mh8 = parcelRequire("87mh8");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $18c2eb891b6f17d9$var$reduce(collection, iteratee, accumulator) {
    var func = $8LQ84(collection) ? $2YkAc : $87mh8, initAccum = arguments.length < 3;
    return func(collection, $bxDef(iteratee, 4), accumulator, initAccum, $e7pfQ);
}
module.exports = $18c2eb891b6f17d9$var$reduce;

});
parcelRegister("87mh8", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $5e90419f1ca7764f$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $5e90419f1ca7764f$var$baseReduce;

});



parcelRegister("4gt6L", function(module, exports) {

$parcel$export(module.exports, "issueTypeIdsSelector", () => $fc9184903598526c$export$47eaf9be2ebcbbc9);
$parcel$export(module.exports, "issueBaseTypesSelector", () => $fc9184903598526c$export$3a71d66f3073758e);
$parcel$export(module.exports, "firstIssueTypeIdSelector", () => $fc9184903598526c$export$14696f459f535378);
$parcel$export(module.exports, "issueChildrenTypesSelector", () => $fc9184903598526c$export$9d03bda0ec379196);
$parcel$export(module.exports, "issueChildrenTypeIdsSelector", () => $fc9184903598526c$export$d0ca2ed0336e2f78);
$parcel$export(module.exports, "defaultIssueTypeIdSelector", () => $fc9184903598526c$export$bc7d33c61daa84f5);
$parcel$export(module.exports, "getIssueTypesGroupedByNameLevel", () => $fc9184903598526c$export$fd9bedde62940919);

var $dGvGJ = parcelRequire("dGvGJ");

var $183uB = parcelRequire("183uB");

var $fn8B5 = parcelRequire("fn8B5");

var $bH3EF = parcelRequire("bH3EF");

var $3JOCw = parcelRequire("3JOCw");

var $g4tDr = parcelRequire("g4tDr");

var $67Z81 = parcelRequire("67Z81");
const $fc9184903598526c$export$47eaf9be2ebcbbc9 = (0, $dGvGJ.createSelector)((0, $67Z81.getIssueTypes), (issueTypes)=>Object.keys(issueTypes));
const $fc9184903598526c$export$3a71d66f3073758e = (0, $dGvGJ.createSelector)((0, $67Z81.getIssueTypes), (issueTypes)=>Object.keys(issueTypes).map((id)=>issueTypes[id]));
const $fc9184903598526c$export$14696f459f535378 = (0, $dGvGJ.createSelector)($fc9184903598526c$export$47eaf9be2ebcbbc9, (issueTypeIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($bH3EF)))(issueTypeIds));
const $fc9184903598526c$export$64a747bfcd854971 = (0, $dGvGJ.createSelector)((0, $67Z81.getProjectIssueTypes), (projectIssueTypes)=>Object.keys(projectIssueTypes).map((key)=>projectIssueTypes[key]).filter((issueType)=>issueType.hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE)));
const $fc9184903598526c$export$9d03bda0ec379196 = (0, $dGvGJ.createSelector)((0, $67Z81.getProjectIssueTypes), (projectIssueTypes)=>Object.keys(projectIssueTypes).map((key)=>projectIssueTypes[key]).filter((issueType)=>issueType.hierarchyLevelType === (0, $g4tDr.CHILD_HIERARCHY_TYPE)));
const $fc9184903598526c$export$d0ca2ed0336e2f78 = (0, $dGvGJ.createSelector)($fc9184903598526c$export$9d03bda0ec379196, (issueTypes)=>issueTypes.map((issueType)=>issueType.id));
const $fc9184903598526c$export$e8a77cfae7b2c053 = (0, $dGvGJ.createSelector)((0, $67Z81.getProjectIssueTypes), (projectIssueTypes)=>(issueTypeId)=>!!projectIssueTypes[issueTypeId]?.hasRequiredFields);
const $fc9184903598526c$var$getDefaultIssueTypeIdPure = (issueTypes)=>{
    const defaultIssueType = issueTypes.find((issueType)=>issueType.default);
    return defaultIssueType ? Number(defaultIssueType.id) : undefined;
};
const $fc9184903598526c$export$bc7d33c61daa84f5 = (0, $dGvGJ.createSelector)([
    $fc9184903598526c$export$3a71d66f3073758e
], (issueTypes)=>$fc9184903598526c$var$getDefaultIssueTypeIdPure(issueTypes));
const $fc9184903598526c$export$fd9bedde62940919 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssueTypesByProject)
], (issueTypesByProject)=>{
    const allIssueTypes = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))((0, (/*@__PURE__*/$parcel$interopDefault($183uB)))(Object.values(issueTypesByProject)), 'id').filter(Boolean);
    const grouped = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(allIssueTypes, ({ name: name, hierarchyLevelType: hierarchyLevelType })=>`${hierarchyLevelType}/${name}`);
    const issueTypeGroups = Object.entries(grouped).map(([key, issueTypes])=>({
            issueTypes: issueTypes.map(({ id: id })=>id),
            name: issueTypes[0].name,
            iconUrl: issueTypes[0].iconUrl,
            key: key
        }));
    return issueTypeGroups;
});

});
parcelRegister("bH3EF", function(module, exports) {
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */ function $88368ba58341d518$var$head(array) {
    return array && array.length ? array[0] : undefined;
}
module.exports = $88368ba58341d518$var$head;

});


parcelRegister("45cXl", function(module, exports) {

$parcel$export(module.exports, "getSwimlaneMode", () => $6737c7e8fdf3dd27$export$3be4c2f22d918721);
$parcel$export(module.exports, "getJqlSwimlanesData", () => $6737c7e8fdf3dd27$export$5a8eaf3993ee8e01);
$parcel$export(module.exports, "getSwimlaneModes", () => $6737c7e8fdf3dd27$export$5cf50704ac4c4ed6);
$parcel$export(module.exports, "hasSwimlanes", () => $6737c7e8fdf3dd27$export$1cc4960b9362aa3);
$parcel$export(module.exports, "isSwimlanesByJqlAvailable", () => $6737c7e8fdf3dd27$export$8e8f69c56d25b276);

var $dGvGJ = parcelRequire("dGvGJ");

var $2xFXk = parcelRequire("2xFXk");

var $5VJuY = parcelRequire("5VJuY");

var $iuuJH = parcelRequire("iuuJH");

var $kc6Ry = parcelRequire("kc6Ry");

var $bSSdD = parcelRequire("bSSdD");

var $4gt6L = parcelRequire("4gt6L");

var $67Z81 = parcelRequire("67Z81");
const $6737c7e8fdf3dd27$export$3be4c2f22d918721 = (state)=>state.ui.swimlane.mode;
const $6737c7e8fdf3dd27$export$5a8eaf3993ee8e01 = (state)=>(0, $67Z81.getEntities)(state).jqlSwimlanes?.swimlanes;
const $6737c7e8fdf3dd27$export$5cf50704ac4c4ed6 = (0, $dGvGJ.createSelector)((0, $bSSdD.hasIssueParentsSelector), (0, $bSSdD.firstParentIssueTypeNameSelector), (0, $4gt6L.issueChildrenTypesSelector), $6737c7e8fdf3dd27$export$5a8eaf3993ee8e01, (0, $67Z81.getIsCMPBoard), (0, $kc6Ry.getCapability), (0, $67Z81.getHierarchyNomenclature), (hasIssueParents, firstParentIssueTypeName, issueChildrenTypes, jqlSwimlanesData, isCMPBoard, hasCapability, hierarchyNomenclature)=>{
    const swimlaneModes = [
        ...(0, $iuuJH.defaultSwimlanes)
    ];
    if (hasIssueParents && hasCapability((0, $2xFXk.Capability).RENDER_EPIC_SWIMLANE_OPTION)) {
        const displayText = isCMPBoard && hierarchyNomenclature ? hierarchyNomenclature.firstLevelName : firstParentIssueTypeName;
        swimlaneModes.push({
            ...(0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE),
            values: {
                displayText: displayText
            }
        });
    }
    if (hasCapability((0, $2xFXk.Capability).RENDER_REQUEST_TYPE_SWIMLANE_OPTION)) swimlaneModes.push((0, $iuuJH.SWIMLANE_BY_REQUEST_TYPE));
    const hasIssueChildrens = issueChildrenTypes && issueChildrenTypes.length > 0;
    if (hasIssueChildrens && isCMPBoard) {
        if (hasCapability((0, $2xFXk.Capability).RENDER_STORIES_SWIMLANE_OPTION)) swimlaneModes.push({
            ...(0, $iuuJH.SWIMLANE_BY_SUBTASK),
            message: (0, $5VJuY.default).stories
        });
    } else if (hasIssueChildrens) swimlaneModes.push({
        ...(0, $iuuJH.SWIMLANE_BY_SUBTASK),
        values: {
            displayText: issueChildrenTypes[0].name
        }
    });
    if (jqlSwimlanesData && jqlSwimlanesData.length > 0 && hasCapability((0, $2xFXk.Capability).RENDER_QUERIES_SWIMLANE_OPTION)) swimlaneModes.push((0, $iuuJH.SWIMLANE_BY_JQL));
    if (isCMPBoard && hasCapability((0, $2xFXk.Capability).RENDER_PROJECTS_SWIMLANE_OPTION)) swimlaneModes.push((0, $iuuJH.SWIMLANE_BY_PROJECT));
    return swimlaneModes;
});
const $6737c7e8fdf3dd27$export$1cc4960b9362aa3 = (state)=>$6737c7e8fdf3dd27$export$3be4c2f22d918721(state) !== (0, $iuuJH.NO_SWIMLANE).id;
const $6737c7e8fdf3dd27$export$8e8f69c56d25b276 = (0, $dGvGJ.createSelector)($6737c7e8fdf3dd27$export$5cf50704ac4c4ed6, (swimlaneModes)=>swimlaneModes.includes((0, $iuuJH.SWIMLANE_BY_JQL)));

});
parcelRegister("2xFXk", function(module, exports) {

$parcel$export(module.exports, "Capability", () => $dd24abdaf4d342ab$export$790a66df9dc00390);
$parcel$export(module.exports, "hasCapability", () => $dd24abdaf4d342ab$export$c76adb160242209c);

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");
const $dd24abdaf4d342ab$export$790a66df9dc00390 = {
    /**
	 * Can be removed when the new navigation is enabled for all users
	 * and the old navigation is removed. And when jsm_views_of_work_phase_1
	 * is cleaned up.
	 */ IS_TAB_NAVIGATION: 'IS_TAB_NAVIGATION',
    RENDER_UIF_OPT_IN_FLAG: 'RENDER_UIF_OPT_IN_FLAG',
    REMOVE_FROM_SPRINT: 'REMOVE_FROM_SPRINT',
    // CMP header menu items
    RENDER_BOARD_MORE_MENU_ITEM: 'RENDER_BOARD_MORE_MENU_ITEM',
    RENDER_BOARD_SETTINGS_MENU_ITEM: 'RENDER_BOARD_SETTINGS_MENU_ITEM',
    RENDER_CREATE_BOARD_MENU_ITEM: 'RENDER_CREATE_BOARD_MENU_ITEM',
    /**
	 * When enabled, columns will expand to fit the display width. The board
	 * will be scrollable when columns are under a minimum width.
	 */ FLEXIBLE_BOARD_COLUMNS: 'FLEXIBLE_BOARD_COLUMNS',
    INLINE_COLUMN_EDIT: 'INLINE_COLUMN_EDIT',
    // TMP header menu items
    RENDER_EDIT_SPRINT_MENU_ITEM: 'RENDER_EDIT_SPRINT_MENU_ITEM',
    RENDER_MANAGE_WORKFLOW_MENU_ITEM: 'RENDER_MANAGE_WORKFLOW_MENU_ITEM',
    RENDER_MOVE_TO_BACKLOG_CONTEXT_MENU_ITEM: 'RENDER_MOVE_TO_BACKLOG_CONTEXT_MENU_ITEM',
    // header filters
    RENDER_STATUS_CATEGORIES_FILTER: 'RENDER_STATUS_CATEGORIES_FILTER',
    RENDER_VERSIONS_FILTER: 'RENDER_VERSIONS_FILTER',
    RENDER_ISSUE_PARENTS_FILTER: 'RENDER_ISSUE_PARENTS_FILTER',
    RENDER_LABELS_FILTER: 'RENDER_LABELS_FILTER',
    RENDER_ISSUE_PROJECTS_FILTER: 'RENDER_ISSUE_PROJECTS_FILTER',
    RENDER_ISSUE_TYPES_FILTER: 'RENDER_ISSUE_TYPES_FILTER',
    RENDER_COMPONENTS_FILTER: 'RENDER_COMPONENTS_FILTER',
    RENDER_SPRINTS_FILTER: 'RENDER_SPRINTS_FILTER',
    RENDER_REQUEST_TYPES_FILTER: 'RENDER_REQUEST_TYPES_FILTER',
    RENDER_STATUSES_FILTER: 'RENDER_STATUSES_FILTER',
    RENDER_DEPENDENCIES_FILTER: 'RENDER_DEPENDENCIES_FILTER',
    // Transition zone label
    HIDE_COLUMN_HEADER_OVERLAY: 'HIDE_COLUMN_HEADER_OVERLAY',
    DISABLE_TRANSITION_IN_SAME_COLUMN: 'DISABLE_TRANSITION_IN_SAME_COLUMN',
    // Card Menu Items
    RENDER_ADD_FLAG_CARD_MENU_ITEM: 'RENDER_ADD_FLAG_CARD_MENU_ITEM',
    RENDER_ADD_LABEL_CARD_MENU_ITEM: 'RENDER_ADD_LABEL_CARD_MENU_ITEM',
    RENDER_EDIT_COVER: 'RENDER_EDIT_COVER',
    // Request type icon position for service management cards.
    RENDER_COMPACT_ISSUE_TYPE_ICON_ON_CARD: 'RENDER_COMPACT_ISSUE_TYPE_ICON_ON_CARD',
    // Board Header Buttons
    RENDER_BOARD_AUTOMATION_HEADER_BUTTON: 'RENDER_BOARD_AUTOMATION_HEADER_BUTTON',
    RENDER_BOARD_FAVOURITE_HEADER_BUTTON: 'RENDER_BOARD_FAVOURITE_HEADER_BUTTON',
    RENDER_BOARD_RELEASE_MENU_BUTON: 'RENDER_BOARD_RELEASE_MENU_BUTON',
    RENDER_BOARD_INSIGHT_BUTTON: 'RENDER_BOARD_INSIGHT_BUTTON',
    RENDER_JSM_BOARD_INSIGHT_BUTTON: 'RENDER_JSM_BOARD_INSIGHT_BUTTON',
    RENDER_BOARD_FEEDBACK_COLLECTOR_BUTTON: 'RENDER_BOARD_FEEDBACK_COLLECTOR_BUTTON',
    RENDER_BOARD_FULLSCREEN_BUTTON: 'RENDER_BOARD_FULLSCREEN_BUTTON',
    RENDER_BOARD_FULLSCREEN_MENU_ITEM: 'RENDER_BOARD_FULLSCREEN_MENU_ITEM',
    // View Settings
    RENDER_VIEW_SETTINGS_CARD_DETAILS_OPTION: 'RENDER_VIEW_SETTINGS_CARD_DETAILS_OPTION',
    // Card devops status
    ENABLE_DEVOPS_ON_BOARD: 'ENABLE_DEVOPS_ON_BOARD',
    // Card multiselection
    MULTISELECT_CARD_ACROSS_SWIMLANES: 'MULTISELECT_CARD_ACROSS_SWIMLANES,',
    // Card context menu display
    RENDER_INCREMENT_PLANNING_CONTEXT_MENU: 'RENDER_INCREMENT_PLANNING_CONTEXT_MENU',
    RENDER_REQUEST_TYPE_SWIMLANE_OPTION: 'RENDER_REQUEST_TYPE_SWIMLANE_OPTION',
    RENDER_EPIC_SWIMLANE_OPTION: 'RENDER_EPIC_SWIMLANE_OPTION',
    RENDER_QUERIES_SWIMLANE_OPTION: 'RENDER_QUERIES_SWIMLANE_OPTION',
    RENDER_PROJECTS_SWIMLANE_OPTION: 'RENDER_PROJECTS_SWIMLANE_OPTTION',
    RENDER_STORIES_SWIMLANE_OPTION: 'RENDER_STORIES_SWIMLANE_OPTION',
    // Show flags for issue limits
    SHOW_ISSUE_LIMIT_FLAGS: 'SHOW_ISSUE_LIMIT_FLAGS'
};
function $dd24abdaf4d342ab$export$c76adb160242209c(key, isCMPBoard, isIncrementPlanningBoard, allFeatures, projectType = (0, $2vSU6.SOFTWARE_PROJECT)) {
    const hasSprintFeatureEnabled = allFeatures?.some((feature)=>feature.key === 'SPRINTS' && feature.status === 'ENABLED') ?? false;
    switch(key){
        case $dd24abdaf4d342ab$export$790a66df9dc00390.IS_TAB_NAVIGATION:
            return (0, $3HwlS.getWillShowNav4)() && projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && (0, $4R6GH.fg)('jsm_views_of_work_phase_1');
        case $dd24abdaf4d342ab$export$790a66df9dc00390.REMOVE_FROM_SPRINT:
            return isCMPBoard && hasSprintFeatureEnabled;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_UIF_OPT_IN_FLAG:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_CREATE_BOARD_MENU_ITEM:
            return projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT) && isCMPBoard;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_BOARD_MORE_MENU_ITEM:
            return !(0, $4R6GH.fg)('jsm_views_of_work_phase_1') || projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_BOARD_SETTINGS_MENU_ITEM:
            if ((0, $4R6GH.fg)('jsm_views_of_work_phase_1')) return isCMPBoard && projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT);
            return isCMPBoard;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_BOARD_FULLSCREEN_BUTTON:
            return !(0, $4R6GH.fg)('jsm_views_of_work_phase_1') || (0, $3HwlS.getWillShowNav4)() || projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_BOARD_FULLSCREEN_MENU_ITEM:
            return (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('jira_nav4_beta_drop_1') && projectType === (0, $2vSU6.SOFTWARE_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.HIDE_COLUMN_HEADER_OVERLAY:
            return isCMPBoard;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.FLEXIBLE_BOARD_COLUMNS:
            return isCMPBoard || isIncrementPlanningBoard;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.INLINE_COLUMN_EDIT:
            if (isIncrementPlanningBoard || projectType !== (0, $2vSU6.SOFTWARE_PROJECT)) return false;
            return true;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.DISABLE_TRANSITION_IN_SAME_COLUMN:
            // Only disable the transitions if the project is NOT service desk.
            // This should only ever be disabled for CMP software projects
            return isCMPBoard && projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.MULTISELECT_CARD_ACROSS_SWIMLANES:
            return !isIncrementPlanningBoard;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_INCREMENT_PLANNING_CONTEXT_MENU:
            return isIncrementPlanningBoard;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_EDIT_SPRINT_MENU_ITEM:
            if (isIncrementPlanningBoard) return false;
            return hasSprintFeatureEnabled;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_MANAGE_WORKFLOW_MENU_ITEM:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_MOVE_TO_BACKLOG_CONTEXT_MENU_ITEM:
            if (isIncrementPlanningBoard) return false;
            return !isCMPBoard;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_ISSUE_PROJECTS_FILTER:
            return isIncrementPlanningBoard;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_DEPENDENCIES_FILTER:
            return (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') && isIncrementPlanningBoard;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_LABELS_FILTER:
            if (isIncrementPlanningBoard) return false;
            return projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_ISSUE_PARENTS_FILTER:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_ISSUE_TYPES_FILTER:
            return projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT) || isIncrementPlanningBoard;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_STATUS_CATEGORIES_FILTER:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_SPRINTS_FILTER:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_BOARD_AUTOMATION_HEADER_BUTTON:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_BOARD_FAVOURITE_HEADER_BUTTON:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_BOARD_RELEASE_MENU_BUTON:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_BOARD_INSIGHT_BUTTON:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_ADD_FLAG_CARD_MENU_ITEM:
            if (isIncrementPlanningBoard) return false;
            return projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_ADD_LABEL_CARD_MENU_ITEM:
            if (isIncrementPlanningBoard) return true;
            return projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_EDIT_COVER:
            return projectType === (0, $2vSU6.SOFTWARE_PROJECT) && isCMPBoard && (0, $6s1PB.expVal)('jsw_cmp_card_cover_images_experiment', 'isCardCoverFeatureEnabled', false);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.ENABLE_DEVOPS_ON_BOARD:
            if (isIncrementPlanningBoard) return false;
            return projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_JSM_BOARD_INSIGHT_BUTTON:
            if (!(0, $co1wz.ff)('jsm-board-insights-issues-for-attention_erwbg')) return false;
            if (isIncrementPlanningBoard) return false;
            return projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_COMPACT_ISSUE_TYPE_ICON_ON_CARD:
            return projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_REQUEST_TYPES_FILTER:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_STATUSES_FILTER:
            return projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_BOARD_FEEDBACK_COLLECTOR_BUTTON:
            return projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && !(0, $4R6GH.fg)('jsm_views_of_work_phase_1');
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_VIEW_SETTINGS_CARD_DETAILS_OPTION:
            if (isIncrementPlanningBoard) return false;
            return !(projectType === (0, $2vSU6.SERVICE_DESK_PROJECT));
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_PROJECTS_SWIMLANE_OPTION:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_STORIES_SWIMLANE_OPTION:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_EPIC_SWIMLANE_OPTION:
            if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) return false;
            return true;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_QUERIES_SWIMLANE_OPTION:
            return true;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_REQUEST_TYPE_SWIMLANE_OPTION:
            if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) return true;
            return false;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.SHOW_ISSUE_LIMIT_FLAGS:
            return projectType === (0, $2vSU6.SOFTWARE_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_VERSIONS_FILTER:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_COMPONENTS_FILTER:
        default:
            return false;
    }
}

});

parcelRegister("kc6Ry", function(module, exports) {

$parcel$export(module.exports, "getCapability", () => $383dbfdaea507d5b$export$38805c31c710553c);

var $2xFXk = parcelRequire("2xFXk");

var $67Z81 = parcelRequire("67Z81");
const $383dbfdaea507d5b$export$38805c31c710553c = (state)=>(key)=>(0, $2xFXk.hasCapability)(key, state.configuration.isCMPBoard, (0, $67Z81.getIsIncrementPlanningBoard)(state), (0, $67Z81.getEntities)(state).board.config.allFeatures, (0, $67Z81.projectTypeSelector)(state));

});

parcelRegister("bSSdD", function(module, exports) {

$parcel$export(module.exports, "getIssueParents", () => $2eb3e41683b9322e$export$df9259146e40d32c);
$parcel$export(module.exports, "hasIssueParentsSelector", () => $2eb3e41683b9322e$export$6ee7fa79061874f6);
$parcel$export(module.exports, "issueParentTypeIdsSelector", () => $2eb3e41683b9322e$export$80f40427dc008040);
$parcel$export(module.exports, "issueParentsSelector", () => $2eb3e41683b9322e$export$27ed9219e3872aed);
$parcel$export(module.exports, "availableIssueParentsForIssueProjectSelector", () => $2eb3e41683b9322e$export$fcfc1acf491b9a49);
$parcel$export(module.exports, "filteredIssueParentsToListItemSelector", () => $2eb3e41683b9322e$export$82d321a1b1eb045c);
$parcel$export(module.exports, "filteredIssueParentsToListItemSelectorNew", () => $2eb3e41683b9322e$export$eadb996f8d83526);
$parcel$export(module.exports, "issueParentIdsSelector", () => $2eb3e41683b9322e$export$e69b35537968b7e1);
$parcel$export(module.exports, "firstParentIssueTypeNameSelector", () => $2eb3e41683b9322e$export$461364b3b51e10c1);
$parcel$export(module.exports, "makeIssueParentByIdSelector", () => $2eb3e41683b9322e$export$dbff01ed0e86fffd);

var $dGvGJ = parcelRequire("dGvGJ");

var $2HfxU = parcelRequire("2HfxU");

var $9XE6b = parcelRequire("9XE6b");

var $gccSB = parcelRequire("gccSB");

var $gJBT6 = parcelRequire("gJBT6");

var $kGsr8 = parcelRequire("kGsr8");

var $g4tDr = parcelRequire("g4tDr");


var $3UY9S = parcelRequire("3UY9S");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");
const $2eb3e41683b9322e$export$df9259146e40d32c = (state)=>(0, $67Z81.getEntities)(state).issueParents;
const $2eb3e41683b9322e$export$6ee7fa79061874f6 = (0, $dGvGJ.createSelector)($2eb3e41683b9322e$export$df9259146e40d32c, (issueParents)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issueParents));
const $2eb3e41683b9322e$export$80f40427dc008040 = (0, $dGvGJ.createSelector)($2eb3e41683b9322e$export$df9259146e40d32c, (issueParents)=>(0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(Object.values(issueParents).map((issueParent)=>Number(issueParent.issueType.id))));
const $2eb3e41683b9322e$export$27ed9219e3872aed = (0, $dGvGJ.createSelector)([
    $2eb3e41683b9322e$export$df9259146e40d32c,
    (0, $67Z81.getIssueParentOrderIds)
], (issueParents, orderedIssueParentsIds)=>orderedIssueParentsIds.reduce((issueParentIds, issueParentId)=>{
        const issueParent = issueParents[String(issueParentId)];
        issueParent && issueParentIds.push(issueParent);
        return issueParentIds;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, []));
const $2eb3e41683b9322e$export$fcfc1acf491b9a49 = (0, $dGvGJ.createSelector)([
    $2eb3e41683b9322e$export$27ed9219e3872aed,
    (0, $67Z81.getIssueProjects),
    (0, $67Z81.getIsIncrementPlanningBoard)
], (issueParents, projects, isIncrementPlanningBoard)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueProjectId)=>{
        if (!isIncrementPlanningBoard) return issueParents;
        if (!issueProjectId) return [];
        const issueProject = projects[issueProjectId];
        if (!issueProject.isCMP) // for TMP issues, filter the issue parents to be in the same project
        return issueParents.filter((parent)=>parent.projectId === issueProject.id);
        // for CMP issues, filter issue parents to be in any CMP project
        return issueParents.filter((parent)=>{
            const parentProject = parent.projectId ? projects[parent.projectId] : null;
            return parentProject && parentProject.isCMP;
        });
    }));
const $2eb3e41683b9322e$export$ed2bad70f85ffb04 = (0, $dGvGJ.createSelector)($2eb3e41683b9322e$export$27ed9219e3872aed, (issueParents)=>issueParents.map(({ id: id, summary: summary })=>({
            id: String(id),
            name: summary
        })));
const $2eb3e41683b9322e$export$82d321a1b1eb045c = (0, $dGvGJ.createSelector)($2eb3e41683b9322e$export$27ed9219e3872aed, (0, $67Z81.getIssues), (0, $ebHh7.hasNoActiveSprintStateSelector), (0, $67Z81.getIsIncrementPlanningBoard), (0, $67Z81.getIsCMPBoard), (issueParents, boardIssues, hasNoActiveSprint, isIncrementPlanningBoard, isCMPBoard)=>{
    if (hasNoActiveSprint) return [];
    const filteredIssueParents = !isCMPBoard ? issueParents : issueParents.filter(({ issueType: { hierarchyLevel: hierarchyLevel } })=>(0, $g4tDr.isEpicHierarchyLevel)(hierarchyLevel));
    const listItems = filteredIssueParents.map(({ id: id, summary: summary, key: key })=>({
            id: String(id),
            key: key,
            name: summary
        }));
    // in the increment planning board, we show epic cards, hence we want to show all epics in the filter
    if (isIncrementPlanningBoard) return listItems;
    // Generate a set of all distinct parentIds for all visible issues on the board.
    const allVisibleParentIds = new Set(Object.values(boardIssues).map((issue)=>`${issue.parentId}`));
    // remove issueParents that dont have any active issues on the board
    return listItems.filter((issueParent)=>allVisibleParentIds.has(issueParent.id));
});
const $2eb3e41683b9322e$export$eadb996f8d83526 = (0, $dGvGJ.createSelector)($2eb3e41683b9322e$export$27ed9219e3872aed, (0, $67Z81.getIssues), (0, $3UY9S.getIssueChildren), (0, $ebHh7.hasNoActiveSprintStateSelector), (0, $67Z81.getIsIncrementPlanningBoard), (0, $67Z81.getIsCMPBoard), (issueParents, boardIssues, childIssues, hasNoActiveSprint, isIncrementPlanningBoard, isCMPBoard)=>{
    if (hasNoActiveSprint) return [];
    const filteredIssueParents = !isCMPBoard ? issueParents : issueParents.filter(({ issueType: { hierarchyLevel: hierarchyLevel } })=>(0, $g4tDr.isEpicHierarchyLevel)(hierarchyLevel));
    const listItems = filteredIssueParents.map(({ id: id, summary: summary, key: key })=>({
            id: String(id),
            key: key,
            name: summary
        }));
    // in the increment planning board, we show epic cards, hence we want to show all epics in the filter
    if (isIncrementPlanningBoard) return listItems;
    const visibleParentIds = new Set(Object.values(boardIssues).map((issue)=>`${issue.parentId || issue.id}`));
    const visibleParentIdsFromSubtasks = new Set(Object.values(childIssues).map((issue)=>`${issue.parentId}`));
    // Generate a set of all distinct parentIds for all visible issues and subtasks on the board.
    const allVisibleParentIds = new Set([
        ...visibleParentIds,
        ...visibleParentIdsFromSubtasks
    ]);
    // remove issueParents that dont have any active issues on the board
    return listItems.filter((issueParent)=>allVisibleParentIds.has(issueParent.id));
});
const $2eb3e41683b9322e$export$e69b35537968b7e1 = (0, $dGvGJ.createSelector)($2eb3e41683b9322e$export$df9259146e40d32c, (issueParents)=>Object.keys(issueParents));
const $2eb3e41683b9322e$export$461364b3b51e10c1 = (0, $dGvGJ.createSelector)($2eb3e41683b9322e$export$27ed9219e3872aed, (issueParents)=>issueParents ? (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, (/*@__PURE__*/$parcel$interopDefault($2HfxU)))(issueParents), [
        'issueType',
        'name'
    ], (0, $dcbb2bce513725b3$export$cb17e3c17bc50301)) : (0, $dcbb2bce513725b3$export$cb17e3c17bc50301));
const $2eb3e41683b9322e$export$dbff01ed0e86fffd = (0, $dGvGJ.createSelector)($2eb3e41683b9322e$export$df9259146e40d32c, (issueParents)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueParentId)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(issueParents, String(issueParentId), null)));

});
parcelRegister("2HfxU", function(module, exports) {

module.exports = (parcelRequire("bH3EF"));

});

const $dcbb2bce513725b3$export$faf85b5ed93b0538 = 'd/MMM/yy hh:mm a';
const $dcbb2bce513725b3$export$ad42fdc358b8c597 = 'MMM d, yyyy';
const $dcbb2bce513725b3$export$cb17e3c17bc50301 = 'Epic';
const $dcbb2bce513725b3$export$d29cf9c8492f955d = 'Base';
const $dcbb2bce513725b3$export$725480b44dc3539d = 'TAB_BECAME_ACTIVE';
const $dcbb2bce513725b3$export$8125ab02c04ac8e7 = 'POLLING';
const $dcbb2bce513725b3$export$af001fd9213b0b63 = 'REALTIME';
const $dcbb2bce513725b3$export$d9d2fe902bd6d9a7 = 'FAILURE';
const $dcbb2bce513725b3$export$8cabdc85b8691f12 = 'GLOBAL_ISSUE_CREATE';
const $dcbb2bce513725b3$export$a0b8ab2c9a9afaaa = 'MODAL_CLOSED';
const $dcbb2bce513725b3$export$9808bb47382c679c = 'BENTO';
const $dcbb2bce513725b3$export$8d3fdbb8c61d9d21 = 'CARD_CLEAR_UNDO';
const $dcbb2bce513725b3$export$443de2b93e4aa6c6 = 'STATUS_REMAPPED';
const $dcbb2bce513725b3$export$3b24bb12b5615667 = 'RELEASE_VERSION';
const $dcbb2bce513725b3$export$ce2132697bb05fef = 'TRANSITION';
const $dcbb2bce513725b3$export$5e8e8357f5d6fec1 = 'BULK_ISSUE_RANK';
const $dcbb2bce513725b3$export$7aa54af91613c70a = 'INLINE_CREATE';
const $dcbb2bce513725b3$export$bddadd6eeae21573 = 'COLUMN_CREATE';
const $dcbb2bce513725b3$export$d44770975cd9746d = 'COLUMN_DELETE';
const $dcbb2bce513725b3$export$97b91dd49f0a73f1 = 'ADD_FLAG';
const $dcbb2bce513725b3$export$62b6dae85d0fc668 = 'BOARD_ADD_TO_SPRINT';
const $dcbb2bce513725b3$export$17d7097367e94100 = 'BOARD_API';
const $dcbb2bce513725b3$export$ccb7bcb751e6027e = 'ARCHIVE_ISSUE';
const $dcbb2bce513725b3$export$66e48a348bf0e91e = 'ADD_ISSUE_TYPE_MODAL';
const $dcbb2bce513725b3$export$67cc25959ff33188 = 'board.long-tasks-dnd';
const $dcbb2bce513725b3$export$d76071d5de2774fc = 'software.work';
const $dcbb2bce513725b3$export$d57b6b390e78d90f = 'a4t-tanuki';
const $dcbb2bce513725b3$export$b8b9d90f9e5bd72b = '@atlassian/jira-software-board';
const $dcbb2bce513725b3$export$b05303cbde3e8c8c = 'CARD';
const $dcbb2bce513725b3$export$1f24f91824c6822f = 'SUBTASK';
const $dcbb2bce513725b3$export$dd0edbbd0cedc7cb = 'CARD_GROUP';
const $dcbb2bce513725b3$export$fa0622448a6f265 = 'ng-board';
const $dcbb2bce513725b3$export$3ccc579abb61693b = 'cmp-board';
const $dcbb2bce513725b3$export$e3639dbf0033629d = 'BOARD_INTERACTIVE_MARK';
const $dcbb2bce513725b3$export$405b6d72f2d243a9 = 'STORY_POINTS';
const $dcbb2bce513725b3$export$bfb354504bb547a0 = 'ORIGINAL_ESTIMATE';
const $dcbb2bce513725b3$export$8775696968c9b13c = 'ISSUE_COUNT';
const $dcbb2bce513725b3$export$d02889a654103c98 = 'timeoriginalestimate';
const $dcbb2bce513725b3$export$2683a6b6da85de4d = 50;
const $dcbb2bce513725b3$export$e5bf25b985a7619d = 'TOP_OF_CONTAINER';
const $dcbb2bce513725b3$export$e044c7349fbdcb2 = 'BOTTOM_OF_CONTAINER';
const $dcbb2bce513725b3$export$9b8283d5878d2491 = 'BOARD';
const $dcbb2bce513725b3$export$26ad7c86aba35f49 = 'DEFAULT_JQL_SWIMLANE_ID';

parcelRegister("ebHh7", function(module, exports) {

$parcel$export(module.exports, "getSprintEntities", () => $6b82a816f7cc09a6$export$99b5f08df8a22dd3);
$parcel$export(module.exports, "isSprintsEnabled", () => $6b82a816f7cc09a6$export$e9a842814803cf10);
$parcel$export(module.exports, "getSprintsSelector", () => $6b82a816f7cc09a6$export$9fa4434d31d5cb0e);
$parcel$export(module.exports, "activeSprintsSelector", () => $6b82a816f7cc09a6$export$cb586b0fb4a1e305);
$parcel$export(module.exports, "hasActiveSprintsSelector", () => $6b82a816f7cc09a6$export$cd91bbbea8056197);
$parcel$export(module.exports, "hasNoActiveSprintStateSelector", () => $6b82a816f7cc09a6$export$cc16fcf4a89b80e2);
$parcel$export(module.exports, "getSelectedSprintsKeys", () => $6b82a816f7cc09a6$export$7b1349fd52e8647a);
$parcel$export(module.exports, "activeSprintGoalSelector", () => $6b82a816f7cc09a6$export$a2ae85498e9ef7b4);
$parcel$export(module.exports, "getSelectedOrAllSprintsSelector", () => $6b82a816f7cc09a6$export$3cf5d7ead1a6863d);
$parcel$export(module.exports, "remainingDaysSelector", () => $6b82a816f7cc09a6$export$70ce2bd4b7920794);
$parcel$export(module.exports, "canCompleteSprintSelector", () => $6b82a816f7cc09a6$export$51fb954a1ccf54db);
$parcel$export(module.exports, "hasManageSprintPermission", () => $6b82a816f7cc09a6$export$e744169f0c37fc19);

var $dGvGJ = parcelRequire("dGvGJ");

var $k7m40 = parcelRequire("k7m40");
var $eZDAP = parcelRequire("eZDAP");

var $jcw0u = parcelRequire("jcw0u");

var $g5X3G = parcelRequire("g5X3G");


var $aXi41 = parcelRequire("aXi41");

var $1vXOx = parcelRequire("1vXOx");

var $67Z81 = parcelRequire("67Z81");
const $6b82a816f7cc09a6$export$99b5f08df8a22dd3 = (state)=>(0, $67Z81.getEntities)(state).sprints;
const $6b82a816f7cc09a6$export$a42917320a6b1916 = (state)=>(0, $67Z81.getUi)(state).sprints ?? (0, $aXi41.initialSprintsState);
const $6b82a816f7cc09a6$export$e9a842814803cf10 = (state)=>(0, $67Z81.getBoardEntity)(state).config.isSprintsEnabled || false;
// "selected" in the context of the board entity means "active"
// vs. "selected" in the context of the sprint UI state means "selected for display" (subset of active)
// WARNING: empirically (as of 2024/09) seen "null" when there are no active sprints
// instead of [] (empty array). This behavior is debatable but is important for "activeSprintsSelector" below.
// Be careful if you change this behavior.
const $6b82a816f7cc09a6$var$getActiveSprintsIds = (state)=>(0, $67Z81.getBoardEntity)(state).selectedSprints;
const $6b82a816f7cc09a6$export$9fa4434d31d5cb0e = (0, $dGvGJ.createSelector)([
    $6b82a816f7cc09a6$export$99b5f08df8a22dd3,
    $6b82a816f7cc09a6$export$e9a842814803cf10
], (sprints, sprintsEnabled)=>sprintsEnabled ? (0, $g5X3G.values)(sprints) : []);
const $6b82a816f7cc09a6$export$cb586b0fb4a1e305 = (0, $dGvGJ.createSelector)([
    $6b82a816f7cc09a6$export$e9a842814803cf10,
    $6b82a816f7cc09a6$export$99b5f08df8a22dd3,
    $6b82a816f7cc09a6$var$getActiveSprintsIds
], (sprintsEnabled, sprints, ids)=>sprintsEnabled && ids !== null ? Object.keys(sprints).filter((key)=>ids.includes(parseInt(key, 10))).map((key)=>sprints[key]) : null);
const $6b82a816f7cc09a6$export$cd91bbbea8056197 = (0, $dGvGJ.createSelector)([
    $6b82a816f7cc09a6$export$cb586b0fb4a1e305
], (activeSprints)=>activeSprints !== null);
const $6b82a816f7cc09a6$export$cc16fcf4a89b80e2 = (0, $dGvGJ.createSelector)([
    $6b82a816f7cc09a6$export$e9a842814803cf10,
    $6b82a816f7cc09a6$export$cd91bbbea8056197
], (sprintsEnabled, sprintActive)=>sprintsEnabled && !sprintActive);
const $6b82a816f7cc09a6$export$7b1349fd52e8647a = (0, $dGvGJ.createSelector)([
    $6b82a816f7cc09a6$export$a42917320a6b1916
], (sprintUiState)=>sprintUiState.selected);
const $6b82a816f7cc09a6$export$a2ae85498e9ef7b4 = (0, $dGvGJ.createSelector)([
    $6b82a816f7cc09a6$export$cb586b0fb4a1e305,
    $6b82a816f7cc09a6$export$7b1349fd52e8647a
], (activeSprints, selectedSprints)=>{
    const goals = activeSprints && activeSprints.filter((sprint)=>selectedSprints && selectedSprints.length > 0 ? selectedSprints.includes(sprint.id.toString()) : true).map((sprint)=>sprint.goal || '');
    return goals && // We only want to display if there is 1 sprint or 1 sprint selected
    goals.length === 1 && goals.filter((goal)=>goal.trim() !== '').length > 0 ? goals[0] : null;
});
const $6b82a816f7cc09a6$export$3cf5d7ead1a6863d = (0, $dGvGJ.createSelector)([
    $6b82a816f7cc09a6$export$cb586b0fb4a1e305,
    $6b82a816f7cc09a6$export$7b1349fd52e8647a
], (activeSprints, selectedSprints)=>{
    const hasSelectedSprints = selectedSprints && selectedSprints.length > 0;
    const sprints = activeSprints ?? [];
    return hasSelectedSprints ? sprints.filter((sprint)=>selectedSprints.includes(sprint.id.toString())) : sprints;
});
const $6b82a816f7cc09a6$var$formatDate = (date)=>(0, $k7m40.default)((0, $eZDAP.default)(date), 'yyyy-MM-dd');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6b82a816f7cc09a6$var$identity = (x)=>x;
function $6b82a816f7cc09a6$var$getValue(key, transform = $6b82a816f7cc09a6$var$identity) {
    return (selectedSprints)=>{
        const sprintsHaveEqual = (sprint)=>{
            // The transform function could potentially throw. So we need a try catch
            // eg: When the transform function uses parseISO, it will throw when an invalid date is used. i.e.: parseISO('foo') will throw an error
            try {
                // Try to minimise error throwing by checking for undefined scenarios first
                if (!sprint || !sprint[key] || !selectedSprints?.[0]?.[key]) return false;
                return transform(sprint[key]) === transform(selectedSprints[0][key]);
            } catch (e) {
                (0, $jcw0u.default)({
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    error: e,
                    meta: {
                        id: 'remainingDaysSelector',
                        packageName: 'jiraSoftwareBoard'
                    }
                });
                return false;
            }
        };
        return selectedSprints.length === 1 || selectedSprints.length > 0 && selectedSprints.every(sprintsHaveEqual) ? selectedSprints[0][key] : null;
    };
}
const $6b82a816f7cc09a6$export$70ce2bd4b7920794 = (0, $dGvGJ.createSelector)([
    $6b82a816f7cc09a6$export$cb586b0fb4a1e305,
    $6b82a816f7cc09a6$export$7b1349fd52e8647a
], (sprints, selectedSprintKeys)=>{
    if (sprints && sprints.length > 0) {
        const hasSelectedSprints = selectedSprintKeys && selectedSprintKeys.length > 0;
        const selectedSprints = sprints.length > 1 ? sprints.filter((sprint)=>hasSelectedSprints ? selectedSprintKeys.includes(sprint.id.toString()) : true) : sprints;
        const remainingDays = $6b82a816f7cc09a6$var$getValue('daysRemaining')(selectedSprints);
        const startDate = $6b82a816f7cc09a6$var$getValue('startDate', $6b82a816f7cc09a6$var$formatDate)(selectedSprints) || null;
        const endDate = $6b82a816f7cc09a6$var$getValue('endDate', $6b82a816f7cc09a6$var$formatDate)(selectedSprints) || null;
        return {
            remainingDays: remainingDays,
            startDate: startDate,
            endDate: endDate
        };
    }
    return {
        remainingDays: null,
        startDate: null,
        endDate: null
    };
});
const $6b82a816f7cc09a6$export$51fb954a1ccf54db = (0, $dGvGJ.createSelector)([
    (0, $1vXOx.getPermissionsSelector),
    $6b82a816f7cc09a6$export$cd91bbbea8056197
], (permissions, isActiveSprint)=>{
    const canManageSprint = !!permissions[0, $e525e6c25695c9df$export$112115098b6cf79b];
    return isActiveSprint && canManageSprint;
});
const $6b82a816f7cc09a6$export$e744169f0c37fc19 = (0, $dGvGJ.createSelector)([
    (0, $1vXOx.getPermissionsSelector)
], (permissions)=>!!permissions[0, $e525e6c25695c9df$export$112115098b6cf79b]);

});
parcelRegister("aXi41", function(module, exports) {

$parcel$export(module.exports, "initialSprintsState", () => $0fa1ad59b68785f4$export$dc5c1bcca875074c);
const $0fa1ad59b68785f4$export$dc5c1bcca875074c = {
    selected: []
};

});





parcelRegister("d2i8f", function(module, exports) {

$parcel$export(module.exports, "isAssignedToIssueParent", () => $3c504b6d6dc181e6$export$a9b1eabca1c583fe);
$parcel$export(module.exports, "getIssueById", () => $3c504b6d6dc181e6$export$75010363f38d9dc8);
$parcel$export(module.exports, "getIssueIndex", () => $3c504b6d6dc181e6$export$3fc2b15c8f070ca9);
$parcel$export(module.exports, "isDoneIssueSelector", () => $3c504b6d6dc181e6$export$4faaf52f6bb50544);
$parcel$export(module.exports, "getIssueByKey", () => $3c504b6d6dc181e6$export$90673c605758652a);
$parcel$export(module.exports, "getIssueOrIssueChildById", () => $3c504b6d6dc181e6$export$12ca3f76ae252a08);
$parcel$export(module.exports, "hasIssueOrIssueChild", () => $3c504b6d6dc181e6$export$b5d531bf7b799a0b);
$parcel$export(module.exports, "getRankConfig", () => $3c504b6d6dc181e6$export$f4b7bab45cfe9501);
$parcel$export(module.exports, "getOrderedIssuesByColumn", () => $3c504b6d6dc181e6$export$9e0bc259bacafb93);
$parcel$export(module.exports, "getDoneIssuesInColumn", () => $3c504b6d6dc181e6$export$6a9dec6161a76344);
$parcel$export(module.exports, "getIssueTypeLevelForBoardIssue", () => $3c504b6d6dc181e6$export$9e240be2729e2455);
$parcel$export(module.exports, "getFirstIssueInColumn", () => $3c504b6d6dc181e6$export$cf39cd1dac4bf6f1);
$parcel$export(module.exports, "getFirstIssueChildInColumnByParent", () => $3c504b6d6dc181e6$export$127dd3e8092f4ed1);
$parcel$export(module.exports, "getLastIssueInColumn", () => $3c504b6d6dc181e6$export$f996d11bfdc851b8);
$parcel$export(module.exports, "getLastIssueChildInColumnByParent", () => $3c504b6d6dc181e6$export$2dac73d418cca0de);
$parcel$export(module.exports, "isFirstIssueInColumn", () => $3c504b6d6dc181e6$export$b902a84f09e4102f);
$parcel$export(module.exports, "isLastIssueInColumn", () => $3c504b6d6dc181e6$export$63c1cd181e56ff6);
$parcel$export(module.exports, "isIssueFlagged", () => $3c504b6d6dc181e6$export$12b0817fd637143e);
$parcel$export(module.exports, "makeGetColumnIdForIssue", () => $3c504b6d6dc181e6$export$d34f58875bd9ab64);
$parcel$export(module.exports, "issueLabelsSelector", () => $3c504b6d6dc181e6$export$66a8f4f78b4fa842);
$parcel$export(module.exports, "makeIssueDevStatusSelector", () => $3c504b6d6dc181e6$export$2a446fc7a9aee050);
$parcel$export(module.exports, "issueProjectIdsSelector", () => $3c504b6d6dc181e6$export$ba5d9003371c95ce);
$parcel$export(module.exports, "issueTypeFilterSelector", () => $3c504b6d6dc181e6$export$74763dafa7432178);
$parcel$export(module.exports, "sortedIssueTypeSelector", () => $3c504b6d6dc181e6$export$744fc5e35b11a96e);
$parcel$export(module.exports, "issueTypeGroupSelector", () => $3c504b6d6dc181e6$export$e668ba5420de7f05);
$parcel$export(module.exports, "requestTypesSelector", () => $3c504b6d6dc181e6$export$813c027a6bea724b);
$parcel$export(module.exports, "statusesSelector", () => $3c504b6d6dc181e6$export$1b3e7a08cee8d1ac);
$parcel$export(module.exports, "makeDoesColumnContainDoneCardsSelector", () => $3c504b6d6dc181e6$export$fae650fc801d3a0);
$parcel$export(module.exports, "getIssueTypeById", () => $3c504b6d6dc181e6$export$49508c02463816d4);
$parcel$export(module.exports, "getIssueKeysFromIssueIds", () => $3c504b6d6dc181e6$export$792b0fb756f9c021);
$parcel$export(module.exports, "getIssueStatusSelector", () => $3c504b6d6dc181e6$export$39efdf2aa70bd5a2);
$parcel$export(module.exports, "getIsIssueDoneInClosedSprint", () => $3c504b6d6dc181e6$export$e39cb5ba3742d388);
$parcel$export(module.exports, "makeGetAncestorsOfIssueForProgramBoard", () => $3c504b6d6dc181e6$export$ee39db6350284e88);

var $dGvGJ = parcelRequire("dGvGJ");

var $hIkqU = parcelRequire("hIkqU");

var $9XE6b = parcelRequire("9XE6b");

var $fn8B5 = parcelRequire("fn8B5");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $hYfgW = parcelRequire("hYfgW");

var $gJBT6 = parcelRequire("gJBT6");

var $kGsr8 = parcelRequire("kGsr8");

var $3JOCw = parcelRequire("3JOCw");

var $8O7FC = parcelRequire("8O7FC");

var $g4tDr = parcelRequire("g4tDr");

var $3spCR = parcelRequire("3spCR");

var $fyeGd = parcelRequire("fyeGd");

var $3UY9S = parcelRequire("3UY9S");

var $bSSdD = parcelRequire("bSSdD");

var $4gt6L = parcelRequire("4gt6L");

var $67Z81 = parcelRequire("67Z81");

var $cPGP0 = parcelRequire("cPGP0");

var $vAfHD = parcelRequire("vAfHD");
const $3c504b6d6dc181e6$export$a9b1eabca1c583fe = (0, $dGvGJ.createSelector)((0, $vAfHD.boardIssuesSelector), (issues)=>{
    const isAssignedToIssueParentCheck = (issueIds)=>{
        const stringIds = issueIds.map((id)=>String(id));
        return Object.keys(issues).filter((id)=>stringIds.includes(id) && issues[id].parentId).length > 0;
    };
    return isAssignedToIssueParentCheck;
});
const $3c504b6d6dc181e6$export$75010363f38d9dc8 = (state, issueId)=>(0, $vAfHD.boardIssuesSelector)(state)[String(issueId)];
const $3c504b6d6dc181e6$export$5120de20e5917187 = (state, issueId)=>!!$3c504b6d6dc181e6$export$75010363f38d9dc8(state, issueId);
const $3c504b6d6dc181e6$export$3fc2b15c8f070ca9 = (state, issueId)=>(0, $vAfHD.boardOrderedIssueIdsSelector)(state).indexOf(issueId);
const $3c504b6d6dc181e6$export$4faaf52f6bb50544 = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $vAfHD.boardIssuesAndChildrenSelector)
], (issuesWithoutSubtasks, allIssues)=>{
    // using the boardIssuesAndChildrenSelector here allows this selector to be used in any situation.
    // boardIssuesSelector filters out issues with subtasks when grouping by subtasks/stories and this selector couldn't access those issues.
    const isDoneIssueSelectorCheck = (issueId)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(allIssues[String(issueId)], [
            'isDone'
        ], false);
    return isDoneIssueSelectorCheck;
});
const $3c504b6d6dc181e6$var$getIssuesByKeys = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector)
], (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(issues, 'key'));
const $3c504b6d6dc181e6$var$getIssuesAndIssueChildrenByKeys = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesAndChildrenSelector)
], (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(issues, 'key'));
const $3c504b6d6dc181e6$export$e8655af1be698e8b = (state, issueKey)=>$3c504b6d6dc181e6$var$getIssuesAndIssueChildrenByKeys(state)[issueKey] ? $3c504b6d6dc181e6$var$getIssuesAndIssueChildrenByKeys(state)[issueKey][0] : undefined;
const $3c504b6d6dc181e6$export$90673c605758652a = (state, issueKey)=>$3c504b6d6dc181e6$var$getIssuesByKeys(state)[issueKey] ? $3c504b6d6dc181e6$var$getIssuesByKeys(state)[issueKey][0] : undefined;
const $3c504b6d6dc181e6$export$12ca3f76ae252a08 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssues),
    (0, $3UY9S.getIssueChildren)
], (issues, issueChildren)=>(issueId)=>issues[String(issueId)] || issueChildren[String(issueId)]);
const $3c504b6d6dc181e6$export$b5d531bf7b799a0b = (state, issueId)=>!!$3c504b6d6dc181e6$export$12ca3f76ae252a08(state)(issueId);
const $3c504b6d6dc181e6$export$f4b7bab45cfe9501 = (state)=>(0, $67Z81.getBoardEntity)(state).config.rankConfig;
const $3c504b6d6dc181e6$var$getOrderedIssues = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardOrderedIssueIdsSelector),
    (0, $vAfHD.boardIssuesSelector)
], (orderedIds, issues)=>orderedIds.map((issueId)=>issues[String(issueId)]));
const $3c504b6d6dc181e6$export$9e0bc259bacafb93 = (0, $dGvGJ.createSelector)($3c504b6d6dc181e6$var$getOrderedIssues, (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(issues, (issue)=>issue.columnId));
const $3c504b6d6dc181e6$export$eb62af33a0f99619 = (0, $dGvGJ.createSelector)((0, $67Z81.getIssues), (issues)=>Object.keys(issues).map((issueId)=>issues[issueId]).filter((issue)=>issue.isDone));
const $3c504b6d6dc181e6$export$6a9dec6161a76344 = (0, $dGvGJ.createSelector)($3c504b6d6dc181e6$export$eb62af33a0f99619, (doneIssues)=>{
    const doneIssuesInColumn = (columnId)=>doneIssues.filter((issue)=>issue.columnId === columnId);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(doneIssuesInColumn);
});
const $3c504b6d6dc181e6$export$9e240be2729e2455 = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $67Z81.getProjectIssueTypes)
], (issues, projectIssueTypes)=>{
    const issueTypeLevel = (issueId)=>{
        const issue = issues[String(issueId)];
        // If issue is not on the board then it's most likely an issue parent
        if (!issue) return 1;
        const projectIssueType = projectIssueTypes[String(issue.typeId)];
        if (projectIssueType.hierarchyLevelType === (0, $g4tDr.CHILD_HIERARCHY_TYPE)) return -1;
        if (projectIssueType.hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE)) return 1;
        return 0;
    };
    return issueTypeLevel;
});
const $3c504b6d6dc181e6$export$cf39cd1dac4bf6f1 = (state, columnId)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))($3c504b6d6dc181e6$export$9e0bc259bacafb93(state), [
        columnId,
        0,
        'id'
    ], null);
const $3c504b6d6dc181e6$export$127dd3e8092f4ed1 = (state, columnId, parentId)=>$3c504b6d6dc181e6$export$9e0bc259bacafb93(state)[columnId]?.find((issue)=>issue.parentId === parentId)?.id;
const $3c504b6d6dc181e6$export$f996d11bfdc851b8 = (state, columnId)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($3c504b6d6dc181e6$export$9e0bc259bacafb93(state)[columnId]), [
        'id'
    ], null);
const $3c504b6d6dc181e6$export$2dac73d418cca0de = (state, columnId, parentId)=>(0, (/*@__PURE__*/$parcel$interopDefault($hIkqU)))($3c504b6d6dc181e6$export$9e0bc259bacafb93(state)[columnId], (issue)=>issue.parentId === parentId)?.id;
const $3c504b6d6dc181e6$export$8471aa4931bcf100 = (0, $dGvGJ.createSelector)([
    $3c504b6d6dc181e6$export$9e0bc259bacafb93
], (orderedIssuesByColumn)=>(columnId, issue1, issue2)=>{
        const issueIds = orderedIssuesByColumn[columnId].map((issue)=>issue.id);
        if (!issueIds.includes(issue1) || !issueIds.includes(issue2)) return 0;
        return issueIds.indexOf(issue1) - issueIds.indexOf(issue2);
    });
const $3c504b6d6dc181e6$export$b902a84f09e4102f = (state, issueId)=>{
    const issue = (0, $vAfHD.boardIssuesSelector)(state)[String(issueId)];
    return issue !== undefined && $3c504b6d6dc181e6$export$cf39cd1dac4bf6f1(state, issue.columnId) === issueId;
};
const $3c504b6d6dc181e6$export$63c1cd181e56ff6 = (state, issueId)=>{
    const issue = (0, $vAfHD.boardIssuesSelector)(state)[String(issueId)];
    return issue !== undefined && $3c504b6d6dc181e6$export$f996d11bfdc851b8(state, issue.columnId) === issueId;
};
const $3c504b6d6dc181e6$export$12b0817fd637143e = (state, issueId)=>{
    const issue = (0, $vAfHD.boardIssuesSelector)(state)[String(issueId)];
    return !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue) && Boolean(issue.isFlagged);
};
const $3c504b6d6dc181e6$var$getColumnIdForIssue = (state, issueId)=>(0, $vAfHD.boardIssuesSelector)(state)[String(issueId)].columnId;
const $3c504b6d6dc181e6$export$d34f58875bd9ab64 = (0, $dGvGJ.createSelector)((0, $vAfHD.boardIssuesSelector), (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId)=>issues[String(issueId)].columnId));
const $3c504b6d6dc181e6$export$6be9e908edb1e82d = (state, issueId)=>{
    const columnId = $3c504b6d6dc181e6$var$getColumnIdForIssue(state, issueId);
    return (0, $fyeGd.getColumnIndex)(state, columnId);
};
const $3c504b6d6dc181e6$export$66a8f4f78b4fa842 = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector)
], (issues)=>Array.from((0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(Object.keys(issues).map((key)=>issues[key]).reduce((labels, issue)=>issue.labels ? issue.labels.reduce((acc, label)=>{
            acc.push(label);
            return acc;
        }, labels) : labels, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [])).sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a, b))));
const $3c504b6d6dc181e6$export$2a446fc7a9aee050 = (0, $dGvGJ.createSelector)((0, $vAfHD.boardIssuesSelector), (previousIssues)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issues)=>issues.map((issue)=>{
            const idString = String(issue.id);
            if (previousIssues[idString] && previousIssues[idString].devStatus) {
                const { devStatus: devStatus } = previousIssues[idString];
                return {
                    ...issue,
                    devStatus: devStatus
                };
            }
            return issue;
        })));
const $3c504b6d6dc181e6$export$e04c2adc17b387c5 = (0, $dGvGJ.createSelector)((0, $vAfHD.boardIssuesSelector), (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((expectedDevStatuses)=>Object.keys(issues).filter((issueId)=>{
            const { devStatus: devStatus } = issues[issueId];
            return devStatus && expectedDevStatuses.includes(devStatus.activity);
        })));
const $3c504b6d6dc181e6$export$ba5d9003371c95ce = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssueProjects)
], (issueProjects)=>(0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(Object.keys(issueProjects).map((key)=>String(key))));
const $3c504b6d6dc181e6$export$74763dafa7432178 = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector)
], (issues)=>Array.from((0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(Object.keys(issues).map((key)=>String(issues[key].typeId)))));
const $3c504b6d6dc181e6$export$c5a236f192993436 = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector)
], (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(Object.keys(issues).map((key)=>{
        const issue = issues[key];
        return {
            id: String(issue.typeId),
            name: issue.typeName || '',
            iconUrl: issue.typeUrl || ''
        };
    }), 'id'));
const $3c504b6d6dc181e6$export$744fc5e35b11a96e = (0, $dGvGJ.createSelector)([
    $3c504b6d6dc181e6$export$c5a236f192993436
], (issues)=>issues.sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a.name, b.name)));
const $3c504b6d6dc181e6$export$e668ba5420de7f05 = (0, $dGvGJ.createSelector)([
    $3c504b6d6dc181e6$export$74763dafa7432178,
    (0, $4gt6L.getIssueTypesGroupedByNameLevel)
], (issueTypes, issueTypeGroups)=>issueTypeGroups.map((group)=>({
            ...group,
            issueTypes: group.issueTypes.filter((issueType)=>issueTypes.includes(issueType))
        })).filter((group)=>group.issueTypes.length > 0));
const $3c504b6d6dc181e6$export$813c027a6bea724b = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $67Z81.getRequestTypes)
], (issues, requestTypes)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(requestTypes)) return [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(Object.keys(issues).filter((key)=>{
        const issue = issues[key];
        return !!(issue.requestTypeId && requestTypes[issue.requestTypeId]);
    }).map((key)=>{
        const issue = issues[key];
        // requestTypeId will always have a value, because we are filtering out issues without request types
        const { id: id, name: name, iconUrl: iconUrl } = requestTypes[issue.requestTypeId ?? ''];
        return {
            id: id,
            name: name,
            iconUrl: iconUrl
        };
    }), 'id').sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a.name, b.name));
});
const $3c504b6d6dc181e6$export$1b3e7a08cee8d1ac = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $67Z81.getStatuses)
], (issues, statuses)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(statuses)) return [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(Object.keys(issues).filter((key)=>{
        const issue = issues[key];
        return !!statuses[issue.statusId];
    }).map((key)=>{
        const issue = issues[key];
        const { id: id, name: name } = statuses[issue.statusId];
        return {
            id: String(id),
            name: name
        };
    }), 'id').sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a.name, b.name));
});
const $3c504b6d6dc181e6$export$fae650fc801d3a0 = (0, $dGvGJ.createSelector)([
    $3c504b6d6dc181e6$export$eb62af33a0f99619
], (doneCards)=>{
    const doesColumnContainDoneCardsCheck = (columnId)=>doneCards.filter((card)=>columnId === card.columnId).length > 0;
    return doesColumnContainDoneCardsCheck;
});
const $3c504b6d6dc181e6$export$49508c02463816d4 = (state, typeId)=>(0, $67Z81.getIssueTypes)(state)[typeId.toString()] || (0, $67Z81.getProjectIssueTypes)(state)[typeId.toString()];
const $3c504b6d6dc181e6$export$6572a8aea8235af8 = (0, $dGvGJ.createSelector)((0, $67Z81.getIssues), (issues)=>{
    const getPartialIssuesFromIssueIds = (issueIds)=>issueIds.filter((issueId)=>issues[String(issueId)]).map((issueId)=>{
            const { id: id, key: key, parentId: parentId } = issues[String(issueId)];
            return {
                id: id,
                key: key,
                parentId: parentId
            };
        });
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getPartialIssuesFromIssueIds);
});
const $3c504b6d6dc181e6$export$792b0fb756f9c021 = (0, $dGvGJ.createSelector)((0, $67Z81.getIssues), (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueIds)=>issueIds.map((issueId)=>issues[String(issueId)]?.key).filter((issueKey)=>!!issueKey)));
const $3c504b6d6dc181e6$export$39efdf2aa70bd5a2 = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $fyeGd.getStatusMapSelector)
], (issues, statusMap)=>(issueId)=>{
        const issue = issues[String(issueId)];
        return statusMap[issue?.statusId];
    });
const $3c504b6d6dc181e6$export$e39cb5ba3742d388 = (state, issueId)=>{
    const issue = (0, $67Z81.getIssues)(state)[issueId];
    if (!issue) return false;
    const isDone = issue.isDone;
    const swimlane = issue.teamId;
    // teamless swimlane
    if (!swimlane) return false;
    const teamSprintsForIterations = (0, $cPGP0.getTeamSprintsForIterations)(state, swimlane);
    // no sprints associated to team
    if (teamSprintsForIterations === null) return false;
    const sprintAssociatedToSwimlaneColumn = teamSprintsForIterations[Number(issue.columnId)];
    // no sprint associated to column
    if (!sprintAssociatedToSwimlaneColumn) return false;
    return isDone && sprintAssociatedToSwimlaneColumn.state === (0, $3spCR.SPRINT_STATES).CLOSED;
};
const $3c504b6d6dc181e6$var$isIssueParent = (issue)=>'issueType' in issue;
const $3c504b6d6dc181e6$export$ee39db6350284e88 = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $bSSdD.getIssueParents)
], (issuesById, issueParents)=>(issue, projectKey)=>{
        const ancestors = [];
        const ancestorsIds = [];
        let parent = issuesById[issue?.parentId || ''];
        while(parent){
            if (ancestorsIds.includes(parent.id)) break;
            ancestorsIds.push(parent.id);
            ancestors.push(parent);
            const parentId = $3c504b6d6dc181e6$var$isIssueParent(parent) ? parent.id : parent.parentId;
            parent = issuesById[parentId || ''];
            if (!parent) parent = issueParents[parentId || ''];
        }
        const normalisedAncestors = ancestors.map((ancestor)=>({
                id: ancestor.id.toString(),
                key: ancestor.key,
                projectKey: projectKey,
                summary: ancestor.summary,
                typeUrl: $3c504b6d6dc181e6$var$isIssueParent(ancestor) ? ancestor.issueType.iconUrl : ancestor.typeUrl,
                typeName: $3c504b6d6dc181e6$var$isIssueParent(ancestor) ? ancestor.issueType.name : ancestor.typeName
            }));
        return normalisedAncestors;
    });

});
parcelRegister("hIkqU", function(module, exports) {

var $bptzf = parcelRequire("bptzf");

var $apUNl = parcelRequire("apUNl");
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var $0353f9604956038c$var$findLast = $bptzf($apUNl);
module.exports = $0353f9604956038c$var$findLast;

});
parcelRegister("bptzf", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $hTJwX = parcelRequire("hTJwX");

var $66FNL = parcelRequire("66FNL");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $84e8f705a13e859f$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$hTJwX(collection)) {
            var iteratee = $bxDef(predicate, 3);
            collection = $66FNL(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $84e8f705a13e859f$var$createFind;

});

parcelRegister("apUNl", function(module, exports) {

var $b5dwA = parcelRequire("b5dwA");

var $bxDef = parcelRequire("bxDef");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $79584b713e0c6354$var$nativeMax = Math.max, $79584b713e0c6354$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $79584b713e0c6354$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $kPZpS(fromIndex);
        index = fromIndex < 0 ? $79584b713e0c6354$var$nativeMax(length + index, 0) : $79584b713e0c6354$var$nativeMin(index, length - 1);
    }
    return $b5dwA(array, $bxDef(predicate, 3), index, true);
}
module.exports = $79584b713e0c6354$var$findLastIndex;

});


parcelRegister("3spCR", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_SPRINT_STATE", () => $113c1ed08a0bda4f$export$3ebc9911a79d714f);
$parcel$export(module.exports, "FUTURE_SPRINT_STATE", () => $113c1ed08a0bda4f$export$863e42082c6bde5);
$parcel$export(module.exports, "CLOSED_SPRINT_STATE", () => $113c1ed08a0bda4f$export$86cdef09a89e8c4b);
$parcel$export(module.exports, "SPRINT_STATES", () => $113c1ed08a0bda4f$export$73a0206a4dc59760);
const $113c1ed08a0bda4f$export$3ebc9911a79d714f = 'ACTIVE';
const $113c1ed08a0bda4f$export$863e42082c6bde5 = 'FUTURE';
const $113c1ed08a0bda4f$export$86cdef09a89e8c4b = 'CLOSED';
const $113c1ed08a0bda4f$export$73a0206a4dc59760 = {
    ACTIVE: $113c1ed08a0bda4f$export$3ebc9911a79d714f,
    CLOSED: $113c1ed08a0bda4f$export$86cdef09a89e8c4b,
    FUTURE: $113c1ed08a0bda4f$export$863e42082c6bde5
};

});

parcelRegister("fyeGd", function(module, exports) {

$parcel$export(module.exports, "isInitialColumn", () => $6a25cd9aef6b667c$export$2b76b0b5245526);
$parcel$export(module.exports, "isDoneColumn", () => $6a25cd9aef6b667c$export$844d7708d71f3c7a);
$parcel$export(module.exports, "getColumnLozenges", () => $6a25cd9aef6b667c$export$af5417af3fd8a43e);
$parcel$export(module.exports, "getColumnIndex", () => $6a25cd9aef6b667c$export$19642b3ccdd58d52);
$parcel$export(module.exports, "isLastColumn", () => $6a25cd9aef6b667c$export$e509b4c22370e953);
$parcel$export(module.exports, "getColumns", () => $6a25cd9aef6b667c$export$978e30a0fb8610d8);
$parcel$export(module.exports, "getColumnById", () => $6a25cd9aef6b667c$export$e85f3ae1437b5b1e);
$parcel$export(module.exports, "initialColumnIdSelector", () => $6a25cd9aef6b667c$export$8cca2eac80b2d07b);
$parcel$export(module.exports, "initialColumnSelector", () => $6a25cd9aef6b667c$export$8e38f35aef868f9);
$parcel$export(module.exports, "doneColumnIdSelector", () => $6a25cd9aef6b667c$export$52746a4a3c64914);
$parcel$export(module.exports, "getStatusesByColumnId", () => $6a25cd9aef6b667c$export$90275f6847b087c6);
$parcel$export(module.exports, "getStatusCategoryByStatusInColumnId", () => $6a25cd9aef6b667c$export$fdfafe8417f25b23);
$parcel$export(module.exports, "getStatusIdsByColumnId", () => $6a25cd9aef6b667c$export$227bd920fba16fc9);
$parcel$export(module.exports, "columnByStatusIdSelector", () => $6a25cd9aef6b667c$export$d387fce3079a165a);
$parcel$export(module.exports, "orderedColumnsSelector", () => $6a25cd9aef6b667c$export$797a3f448cda3e3a);
$parcel$export(module.exports, "columnStatusMappingSelector", () => $6a25cd9aef6b667c$export$3133db18f9e069b6);
$parcel$export(module.exports, "isDoneColumnSelector", () => $6a25cd9aef6b667c$export$5e7d90f7b0706af);
$parcel$export(module.exports, "makeValidateColumnSelector", () => $6a25cd9aef6b667c$export$54e158f99bd87a8c);
$parcel$export(module.exports, "hasColumnLimits", () => $6a25cd9aef6b667c$export$5473fcc76aa5870d);
$parcel$export(module.exports, "makeClosestColumnSelector", () => $6a25cd9aef6b667c$export$bade1fd14989df4);
$parcel$export(module.exports, "getUiColumnLimits", () => $6a25cd9aef6b667c$export$e011995956f16fa6);
$parcel$export(module.exports, "getUiColumnLimitsModalOpen", () => $6a25cd9aef6b667c$export$6229c4dc5d2efe61);
$parcel$export(module.exports, "makeGetAllOtherColumnsSelector", () => $6a25cd9aef6b667c$export$ba1c28f70ced5ab2);
$parcel$export(module.exports, "hasDoneColumnInLastPositionSelector", () => $6a25cd9aef6b667c$export$6177e2dff5c71e5a);
$parcel$export(module.exports, "getDoneColumnsSelector", () => $6a25cd9aef6b667c$export$ce78defaaf63f45e);
$parcel$export(module.exports, "hasMultipleStatusesPerColumn", () => $6a25cd9aef6b667c$export$f851b13c9530ca04);
$parcel$export(module.exports, "hasMoreThanFiveColumn", () => $6a25cd9aef6b667c$export$f5665e99431cf4b7);
$parcel$export(module.exports, "hasMultipleDoneColumnSelector", () => $6a25cd9aef6b667c$export$9ad385df1369641f);
$parcel$export(module.exports, "firstGlobalTransitionIdForColumnWithProjectFilteringSelector", () => $6a25cd9aef6b667c$export$2b86311255d06539);
$parcel$export(module.exports, "getStatusIdsOfColumns", () => $6a25cd9aef6b667c$export$12d7e6f3168b0074);
$parcel$export(module.exports, "getStatusMapSelector", () => $6a25cd9aef6b667c$export$606f94fde0d9e9d1);

var $dGvGJ = parcelRequire("dGvGJ");

var $1sWm7 = parcelRequire("1sWm7");

var $9UgXz = parcelRequire("9UgXz");

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $gJBT6 = parcelRequire("gJBT6");

var $biBvi = parcelRequire("biBvi");

var $5rFbt = parcelRequire("5rFbt");

var $6s1PB = parcelRequire("6s1PB");

var $1ShTS = parcelRequire("1ShTS");

var $67Z81 = parcelRequire("67Z81");

var $6VRfR = parcelRequire("6VRfR");
const $6a25cd9aef6b667c$export$2b76b0b5245526 = (column)=>column?.type === (0, $5rFbt.ColumnType).STATUS && column.statuses.some(({ isInitial: isInitial })=>isInitial);
const $6a25cd9aef6b667c$export$844d7708d71f3c7a = (column)=>column?.type === (0, $5rFbt.ColumnType).STATUS && column?.statuses.length >= 1 && column?.statuses.every(({ isDone: isDone })=>isDone);
const $6a25cd9aef6b667c$export$dd393610384faf93 = (column, totalOfIssues)=>column.type === (0, $5rFbt.ColumnType).STATUS && column.maxIssueCount !== null && totalOfIssues > column.maxIssueCount;
const $6a25cd9aef6b667c$export$af5417af3fd8a43e = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueCount, maxIssueCount, minIssueCount)=>{
    const lozenges = [];
    if (minIssueCount != null) lozenges.push({
        descriptor: (0, $6VRfR.default).minIssueCount,
        values: {
            count: String(minIssueCount)
        },
        type: 'minimum',
        busted: issueCount < minIssueCount,
        tooltip: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6VRfR.default).minIssueCountTooltipIssueTermRefresh : (0, $6VRfR.default).minIssueCountTooltip
    });
    if (maxIssueCount != null) lozenges.push({
        descriptor: (0, $6VRfR.default).maxIssueCount,
        values: {
            count: String(maxIssueCount)
        },
        type: 'maximum',
        busted: issueCount > maxIssueCount,
        tooltip: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6VRfR.default).maxIssueCountTooltipIssueTermRefresh : (0, $6VRfR.default).maxIssueCountTooltip
    });
    return lozenges;
}, (issueCount, maxIssueCount, minIssueCount)=>`${maxIssueCount}::${minIssueCount}::${issueCount}`);
const $6a25cd9aef6b667c$var$getStatusColumn = (column)=>column.type === (0, $5rFbt.ColumnType).STATUS ? column : null;
const $6a25cd9aef6b667c$export$19642b3ccdd58d52 = (state, columnId)=>(0, $67Z81.getOrderedColumnIds)(state).indexOf(columnId);
const $6a25cd9aef6b667c$export$e509b4c22370e953 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getOrderedColumnIds)
], (columnIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnId)=>columnIds.indexOf(columnId) === columnIds.length - 1));
const $6a25cd9aef6b667c$export$978e30a0fb8610d8 = (state)=>(0, $67Z81.getEntities)(state).columns;
const $6a25cd9aef6b667c$export$e85f3ae1437b5b1e = (state, columnId)=>$6a25cd9aef6b667c$export$978e30a0fb8610d8(state)[String(columnId)];
const $6a25cd9aef6b667c$export$8cca2eac80b2d07b = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8
], (columns)=>Number((0, (/*@__PURE__*/$parcel$interopDefault($9UgXz)))(columns, $6a25cd9aef6b667c$export$2b76b0b5245526)));
const $6a25cd9aef6b667c$export$8e38f35aef868f9 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8,
    $6a25cd9aef6b667c$export$8cca2eac80b2d07b
], (columns, initialColumId)=>columns[String(initialColumId)]);
const $6a25cd9aef6b667c$export$52746a4a3c64914 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8
], (columns)=>Number((0, (/*@__PURE__*/$parcel$interopDefault($9UgXz)))(columns, $6a25cd9aef6b667c$export$844d7708d71f3c7a)));
const $6a25cd9aef6b667c$export$90275f6847b087c6 = (state)=>(columnId)=>$6a25cd9aef6b667c$var$getStatusColumn($6a25cd9aef6b667c$export$978e30a0fb8610d8(state)[String(columnId)])?.statuses ?? [];
const $6a25cd9aef6b667c$export$fdfafe8417f25b23 = (state)=>(columnId, statusInColumnId)=>$6a25cd9aef6b667c$export$90275f6847b087c6(state)(columnId).find((status)=>status.id === statusInColumnId)?.category ?? 'UNDEFINED';
const $6a25cd9aef6b667c$export$227bd920fba16fc9 = (state)=>(columnId)=>$6a25cd9aef6b667c$export$90275f6847b087c6(state)(columnId).map(({ id: id })=>id);
const $6a25cd9aef6b667c$export$202ea9e4e5534381 = (state, columnId)=>$6a25cd9aef6b667c$export$978e30a0fb8610d8(state)[String(columnId)].name;
const $6a25cd9aef6b667c$export$d387fce3079a165a = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8,
    (0, (/*@__PURE__*/$parcel$interopDefault($biBvi)))(1)
], (columns, statusId)=>(0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(columns, (column)=>$6a25cd9aef6b667c$var$getStatusColumn(column)?.statuses.some((status)=>status.id === statusId) ?? false));
const $6a25cd9aef6b667c$export$797a3f448cda3e3a = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8,
    (0, $67Z81.getOrderedColumnIds)
], (columns, columnIds)=>columnIds.map((columnId)=>columns[String(columnId)]));
const $6a25cd9aef6b667c$export$3133db18f9e069b6 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$797a3f448cda3e3a
], (columns)=>{
    const mapping = {};
    columns.forEach((column)=>{
        mapping[column.id] = {
            isInitial: $6a25cd9aef6b667c$export$2b76b0b5245526(column),
            isDone: $6a25cd9aef6b667c$export$844d7708d71f3c7a(column)
        };
    });
    return mapping;
});
const $6a25cd9aef6b667c$var$isNotItSelfAndHasValidId = (entity, id)=>entity.id !== id && entity.id > 0;
const $6a25cd9aef6b667c$var$hasSameName = (entity, name)=>entity.name.toLowerCase() === name.toLowerCase();
const $6a25cd9aef6b667c$export$4c08b6f17508bf74 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getOrderedColumnIds),
    $6a25cd9aef6b667c$export$3133db18f9e069b6
], (columnIds, statusMapping)=>columnIds.some((id)=>statusMapping[id].isDone));
const $6a25cd9aef6b667c$export$5e7d90f7b0706af = (0, $dGvGJ.createSelector)($6a25cd9aef6b667c$export$3133db18f9e069b6, (columnStatusMapping)=>{
    const getIsDoneColumn = (columnId)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(columnStatusMapping, [
            String(columnId),
            'isDone'
        ], false);
    return getIsDoneColumn;
});
const $6a25cd9aef6b667c$export$ec52759a7c6325ea = (columns, id, name)=>columns.filter((column)=>$6a25cd9aef6b667c$var$isNotItSelfAndHasValidId(column, id)).some((column)=>$6a25cd9aef6b667c$var$hasSameName(column, name) || $6a25cd9aef6b667c$var$getStatusColumn(column)?.statuses.some((status)=>$6a25cd9aef6b667c$var$hasSameName(status, name)));
const $6a25cd9aef6b667c$export$54e158f99bd87a8c = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$797a3f448cda3e3a
], (columns)=>{
    const makeValidateColumn = (columnId, columnName)=>{
        if ($6a25cd9aef6b667c$export$ec52759a7c6325ea(columns, columnId, columnName)) return {
            isValid: false,
            message: {
                title: (0, $6VRfR.default).nameIsTakenTitle,
                description: (0, $6VRfR.default).nameIsTakenDescription
            }
        };
        return {
            isValid: true,
            message: null
        };
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(makeValidateColumn, (columnId, columnName)=>`${columnId}:${columnName}`);
});
const $6a25cd9aef6b667c$export$5473fcc76aa5870d = (0, $dGvGJ.createSelector)($6a25cd9aef6b667c$export$797a3f448cda3e3a, (columns)=>columns.some((column)=>column.type === (0, $5rFbt.ColumnType).STATUS && column.maxIssueCount !== null && column.maxIssueCount >= 0));
const $6a25cd9aef6b667c$export$bade1fd14989df4 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$797a3f448cda3e3a
], (columns)=>{
    const makeClosestColumn = (columnId)=>{
        const index = columns.findIndex((column)=>column.id === columnId);
        if (index === -1 || columns.length === 1) return null;
        const isFirstColumn = index === 0;
        if (isFirstColumn) {
            const nextColumn = columns[index + 1];
            return nextColumn;
        }
        const prevColumn = columns[index - 1];
        return prevColumn;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(makeClosestColumn);
});
const $6a25cd9aef6b667c$export$e011995956f16fa6 = (state)=>(0, $67Z81.getUi)(state).columnLimits ?? {
        isOpen: false
    };
const $6a25cd9aef6b667c$export$6229c4dc5d2efe61 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$e011995956f16fa6
], (columnLimits)=>columnLimits.isOpen);
const $6a25cd9aef6b667c$export$ba1c28f70ced5ab2 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8,
    (0, $67Z81.getOrderedColumnIds)
], (columns, columnIds)=>{
    const makeGetAllOtherColumns = (columnId)=>columnIds.filter((id)=>id !== columnId).map((id)=>columns[String(id)]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(makeGetAllOtherColumns);
});
const $6a25cd9aef6b667c$export$6177e2dff5c71e5a = (0, $dGvGJ.createSelector)($6a25cd9aef6b667c$export$797a3f448cda3e3a, (columns)=>columns[columns.length - 1] ? $6a25cd9aef6b667c$export$844d7708d71f3c7a(columns[columns.length - 1]) : false);
const $6a25cd9aef6b667c$export$ce78defaaf63f45e = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$797a3f448cda3e3a
], (columns)=>columns.filter((column)=>$6a25cd9aef6b667c$export$844d7708d71f3c7a(column)));
const $6a25cd9aef6b667c$export$f851b13c9530ca04 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8
], (columns)=>Object.keys(columns).some((columnId)=>{
        const column = columns[columnId];
        return column.type === (0, $5rFbt.ColumnType).STATUS && column.statuses.length > 1;
    }));
const $6a25cd9aef6b667c$export$f5665e99431cf4b7 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8
], (columns)=>Object.keys(columns).length > 5);
const $6a25cd9aef6b667c$export$9ad385df1369641f = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$ce78defaaf63f45e
], (columns)=>columns.length > 1);
const $6a25cd9aef6b667c$export$2b86311255d06539 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions),
    (0, $67Z81.getIssueProjects)
], (cardTransitions, issueProjects)=>(columnId, issue)=>{
        const transitionsForColumn = cardTransitions.columnIssueTypeTransitions[String(columnId)];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transitionsForColumn) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transitionsForColumn[String(issue?.typeId)])) return null;
        // TMP issues don't have a project id/key so we just get whatever
        const issueMissingProjectId = !issue.projectId;
        const projectKey = issue ? Object.values(issueProjects).find((project)=>project.id === issue.projectId)?.key : null;
        // TMP transitions have project keys populated dynamically but we can't show TMP issues on a
        // CMP board so if its a TMP issue, just grab ANY of the global transitions because we
        // know that TMP can't have duplicates like CMP.
        const transition = transitionsForColumn[String(issue.typeId)].find((t)=>(issueMissingProjectId || t.projectKey === projectKey) && t.isGlobal && !t.isInitial);
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transition) ? transition.id : null;
    });
const $6a25cd9aef6b667c$export$12d7e6f3168b0074 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8
], (columns)=>Object.keys(columns).flatMap((columnId)=>$6a25cd9aef6b667c$var$getStatusColumn(columns[columnId])?.statuses ?? []).map((status)=>status.id));
const $6a25cd9aef6b667c$export$729d92c1e0c9db28 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8
], (columns)=>Object.values(columns).filter((column)=>$6a25cd9aef6b667c$var$getStatusColumn(column)?.statuses.some((status)=>status.category && status.category.toUpperCase() === 'DONE')));
const $6a25cd9aef6b667c$export$606f94fde0d9e9d1 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8
], (columns)=>(0, $1ShTS.entityArrayToMap)(Object.keys(columns).flatMap((columnId)=>$6a25cd9aef6b667c$var$getStatusColumn(columns[columnId])?.statuses ?? [])));

});
parcelRegister("1sWm7", function(module, exports) {

var $bptzf = parcelRequire("bptzf");

var $fW7cr = parcelRequire("fW7cr");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $1115ac3ae60cc7bc$var$find = $bptzf($fW7cr);
module.exports = $1115ac3ae60cc7bc$var$find;

});
parcelRegister("fW7cr", function(module, exports) {

var $b5dwA = parcelRequire("b5dwA");

var $bxDef = parcelRequire("bxDef");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b9a1db7d7901532f$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $b9a1db7d7901532f$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $kPZpS(fromIndex);
    if (index < 0) index = $b9a1db7d7901532f$var$nativeMax(length + index, 0);
    return $b5dwA(array, $bxDef(predicate, 3), index);
}
module.exports = $b9a1db7d7901532f$var$findIndex;

});


parcelRegister("9UgXz", function(module, exports) {

var $fR2dZ = parcelRequire("fR2dZ");

var $hDnyx = parcelRequire("hDnyx");

var $bxDef = parcelRequire("bxDef");
/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */ function $73667fdf8c12f2c8$var$findKey(object, predicate) {
    return $fR2dZ(object, $bxDef(predicate, 3), $hDnyx);
}
module.exports = $73667fdf8c12f2c8$var$findKey;

});
parcelRegister("fR2dZ", function(module, exports) {
/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */ function $b8ad880aaae778a0$var$baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
            result = key;
            return false;
        }
    });
    return result;
}
module.exports = $b8ad880aaae778a0$var$baseFindKey;

});


parcelRegister("biBvi", function(module, exports) {

var $l0M9G = parcelRequire("l0M9G");

var $g7i7g = parcelRequire("g7i7g");

var $kPZpS = parcelRequire("kPZpS");
/**
 * Creates a function that gets the argument at index `n`. If `n` is negative,
 * the nth argument from the end is returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {number} [n=0] The index of the argument to return.
 * @returns {Function} Returns the new pass-thru function.
 * @example
 *
 * var func = _.nthArg(1);
 * func('a', 'b', 'c', 'd');
 * // => 'b'
 *
 * var func = _.nthArg(-2);
 * func('a', 'b', 'c', 'd');
 * // => 'c'
 */ function $839e77a0b37b78b8$var$nthArg(n) {
    n = $kPZpS(n);
    return $g7i7g(function(args) {
        return $l0M9G(args, n);
    });
}
module.exports = $839e77a0b37b78b8$var$nthArg;

});
parcelRegister("l0M9G", function(module, exports) {

var $e8U1z = parcelRequire("e8U1z");
/**
 * The base implementation of `_.nth` which doesn't coerce arguments.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {number} n The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 */ function $f4bef3b14fc69d11$var$baseNth(array, n) {
    var length = array.length;
    if (!length) return;
    n += n < 0 ? length : 0;
    return $e8U1z(n, length) ? array[n] : undefined;
}
module.exports = $f4bef3b14fc69d11$var$baseNth;

});


parcelRegister("1ShTS", function(module, exports) {

$parcel$export(module.exports, "entityArrayToMap", () => $434b748ab03c045f$export$5de9d608b9fa8851);
const $434b748ab03c045f$export$5de9d608b9fa8851 = (entities)=>{
    const result = {};
    entities.forEach((entity)=>{
        result[String(entity.id)] = entity;
    });
    return result;
};

});

parcelRegister("6VRfR", function(module, exports) {

$parcel$export(module.exports, "default", () => $fca6f21418cf0d40$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fca6f21418cf0d40$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    nameIsTakenTitle: {
        "id": "software.main.state.selectors.column.name-is-taken-title",
        "defaultMessage": "The name \u2018{name}\u2019 is already being used on this board"
    },
    nameIsTakenDescription: {
        "id": "software.main.state.selectors.column.name-is-taken-description",
        "defaultMessage": "You\u2019ll need to give your column a unique name. Trust us - it\u2019ll be less confusing this way"
    },
    minIssueCount: {
        "id": "software.main.state.selectors.column.min-issue-count",
        "defaultMessage": "MIN: {count}"
    },
    minIssueCountTooltip: {
        "id": "software.main.state.selectors.column.min-issue-count-tooltip",
        "defaultMessage": "This column will be highlighted when the number of issues is under this limit"
    },
    maxIssueCount: {
        "id": "software.main.state.selectors.column.max-issue-count",
        "defaultMessage": "MAX: {count}"
    },
    maxIssueCountTooltip: {
        "id": "software.main.state.selectors.column.max-issue-count-tooltip",
        "defaultMessage": "This column will be highlighted when the number of issues exceeds this limit"
    },
    minIssueCountTooltipIssueTermRefresh: {
        "id": "software.main.state.selectors.column.min-issue-count-tooltip-issue-term-refresh",
        "defaultMessage": "This column will be highlighted when the number of issues is under this limit"
    },
    maxIssueCountTooltipIssueTermRefresh: {
        "id": "software.main.state.selectors.column.max-issue-count-tooltip-issue-term-refresh",
        "defaultMessage": "This column will be highlighted when the number of issues exceeds this limit"
    }
});

});


parcelRegister("cPGP0", function(module, exports) {

$parcel$export(module.exports, "getTeams", () => $6832ab781e992eca$export$5a622455e94bac3);
$parcel$export(module.exports, "getTeamById", () => $6832ab781e992eca$export$5dcc6aff8319c1fe);
$parcel$export(module.exports, "getTeamSprintsForIterations", () => $6832ab781e992eca$export$9c3564d047dbecae);
$parcel$export(module.exports, "getSprintCapacityInfo", () => $6832ab781e992eca$export$f54f23fd5351ffad);
$parcel$export(module.exports, "getOverlappedSprintPerTeam", () => $6832ab781e992eca$export$90bff6a70efe7be5);
$parcel$export(module.exports, "getIterationCapacityInfo", () => $6832ab781e992eca$export$aa4cf32120268e72);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $hGgHi = parcelRequire("hGgHi");

var $gJBT6 = parcelRequire("gJBT6");

var $g4tDr = parcelRequire("g4tDr");

var $4jAPy = parcelRequire("4jAPy");

var $3spCR = parcelRequire("3spCR");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");
const $6832ab781e992eca$export$5a622455e94bac3 = (state)=>(0, $67Z81.getEntities)(state).teams;
const $6832ab781e992eca$export$5dcc6aff8319c1fe = (0, $dGvGJ.createSelector)($6832ab781e992eca$export$5a622455e94bac3, (teams)=>{
    const getTeamByIdInner = (teamId)=>teams[teamId];
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getTeamByIdInner);
});
const $6832ab781e992eca$export$9c3564d047dbecae = (state, teamId)=>{
    const teams = $6832ab781e992eca$export$5a622455e94bac3(state);
    if (!teamId || !teams[teamId]) return null;
    return teams[teamId].sprintByIterationId || null;
};
const $6832ab781e992eca$var$getUsedCapacityPerSprint = (0, $dGvGJ.createSelector)((0, $67Z81.getIssues), (0, $67Z81.getProjectIssueTypes), (issues, projectIssueTypes)=>{
    let usedCapacityInfoPerSprint = {};
    Object.values(issues).forEach((issue)=>{
        const { teamId: teamId, sprintId: sprintId, typeId: typeId, isDone: isDone } = issue;
        // if it is epic, skip it
        const isEpicLevel = projectIssueTypes[typeId].hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE);
        if (!isEpicLevel && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(teamId) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(sprintId) && sprintId !== '') {
            const usedCapacity = (0, $7uUwQ.getIn)(usedCapacityInfoPerSprint, [
                teamId,
                sprintId,
                'total'
            ]) || 0;
            const doneCapacity = (0, $7uUwQ.getIn)(usedCapacityInfoPerSprint, [
                teamId,
                sprintId,
                'done'
            ]) || 0;
            usedCapacityInfoPerSprint = (0, $7uUwQ.setIn)(usedCapacityInfoPerSprint, [
                teamId,
                sprintId,
                'total'
            ], Number(usedCapacity) + Number(issue.estimate?.value) || 0);
            if (isDone) usedCapacityInfoPerSprint = (0, $7uUwQ.setIn)(usedCapacityInfoPerSprint, [
                teamId,
                sprintId,
                'done'
            ], Number(doneCapacity) + Number(issue.estimate?.value) || 0);
        }
    });
    return usedCapacityInfoPerSprint;
});
const $6832ab781e992eca$export$f54f23fd5351ffad = (0, $dGvGJ.createSelector)([
    $6832ab781e992eca$export$5a622455e94bac3,
    $6832ab781e992eca$var$getUsedCapacityPerSprint
], (teams, usedCapacityInfoPerSprint)=>{
    let sprintCapacityInfoPerSprint = {};
    Object.values(teams).forEach((team)=>{
        const { id: teamId, capacity: defaultCapacity, capacityBySprintId: capacityBySprintId, sprintByIterationId: sprintByIterationId } = team;
        const sprintIds = sprintByIterationId ? Object.values(sprintByIterationId).map((sprint)=>`${sprint.id}`) : [];
        sprintIds.forEach((sprintId)=>{
            sprintCapacityInfoPerSprint = (0, $7uUwQ.setIn)(sprintCapacityInfoPerSprint, [
                teamId,
                sprintId
            ], {
                defaultCapacity: defaultCapacity,
                usedCapacity: (0, $7uUwQ.getIn)(usedCapacityInfoPerSprint, [
                    teamId,
                    sprintId,
                    'total'
                ]) || 0,
                doneCapacity: (0, $7uUwQ.getIn)(usedCapacityInfoPerSprint, [
                    teamId,
                    sprintId,
                    'done'
                ]) || 0,
                totalCapacity: capacityBySprintId?.[Number(sprintId)]?.capacity ?? null,
                itemKey: capacityBySprintId?.[Number(sprintId)]?.itemKey ?? undefined
            });
        });
    });
    return sprintCapacityInfoPerSprint;
});
const $6832ab781e992eca$export$f6d30755cc17452 = (sprintA, sprintB)=>{
    let startDateA = sprintA.startDate;
    let endDateA = sprintA.state === (0, $3spCR.SPRINT_STATES).CLOSED ? sprintA.completedDate : sprintA.endDate;
    let startDateB = sprintB.startDate;
    let endDateB = sprintB.state === (0, $3spCR.SPRINT_STATES).CLOSED ? sprintB.completedDate : sprintB.endDate;
    // if one of sprint doesn't have start and end date, they are not overlapped.
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(startDateA) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(endDateA) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(startDateB) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(endDateB)) return undefined;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(endDateA) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(endDateB)) endDateA = Number.POSITIVE_INFINITY;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(endDateA) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(endDateB)) endDateB = Number.POSITIVE_INFINITY;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(startDateA) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(startDateB)) startDateA = Number.NEGATIVE_INFINITY;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(startDateA) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(startDateB)) startDateB = Number.NEGATIVE_INFINITY;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(startDateA) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(endDateA) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(startDateB) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(endDateB)) {
        const baseEndTime = Math.min(endDateB, endDateA);
        const baseStartTime = Math.max(startDateA, startDateB);
        const time = Math.abs(baseEndTime - baseStartTime);
        return {
            // if the time gap is less than 1 day, it is not overlapped
            isOverlapped: !(startDateB > endDateA || endDateB < startDateA) && time > 86400000,
            time: time
        };
    }
};
const $6832ab781e992eca$export$90bff6a70efe7be5 = (0, $dGvGJ.createSelector)($6832ab781e992eca$export$5a622455e94bac3, (teams)=>{
    let overlappedSprintInfo = {};
    Object.values(teams).forEach((team)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(team.sprintByIterationId)) {
            const sprints = Object.values(team.sprintByIterationId);
            for(let i = 0; i < sprints.length; i++)for(let j = i + 1; j < sprints.length; j++){
                const isOverlappedResult = $6832ab781e992eca$export$f6d30755cc17452(sprints[i], sprints[j]);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(isOverlappedResult) && isOverlappedResult.isOverlapped) {
                    overlappedSprintInfo = (0, $7uUwQ.setIn)(overlappedSprintInfo, [
                        team.id,
                        sprints[i].id
                    ], [
                        ...(0, $7uUwQ.getIn)(overlappedSprintInfo, [
                            team.id,
                            sprints[i].id
                        ]) || [],
                        {
                            sprintName: sprints[j].name,
                            time: isOverlappedResult.time
                        }
                    ]);
                    overlappedSprintInfo = (0, $7uUwQ.setIn)(overlappedSprintInfo, [
                        team.id,
                        sprints[j].id
                    ], [
                        ...(0, $7uUwQ.getIn)(overlappedSprintInfo, [
                            team.id,
                            sprints[j].id
                        ]) || [],
                        {
                            sprintName: sprints[i].name,
                            time: isOverlappedResult.time
                        }
                    ]);
                }
            }
        }
    });
    return overlappedSprintInfo;
});
const $6832ab781e992eca$var$getUsedCapacityPerIteration = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssues),
    (0, $67Z81.getProjectIssueTypes)
], (issues, projectIssueTypes)=>{
    let usedCapacityInfoPerIteration = {};
    Object.values(issues).forEach((issue)=>{
        const { teamId: teamId, columnId: columnId, typeId: typeId } = issue;
        const team = teamId ?? (0, $4jAPy.SWIMLANE_TEAMLESS);
        // if it is epic, skip it
        const isEpicLevel = projectIssueTypes[typeId].hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE);
        if (!isEpicLevel && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(team) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(columnId)) {
            const usedCapacity = (0, $7uUwQ.getIn)(usedCapacityInfoPerIteration, [
                team,
                columnId
            ]) || 0;
            usedCapacityInfoPerIteration = (0, $7uUwQ.setIn)(usedCapacityInfoPerIteration, [
                team,
                columnId
            ], Number(usedCapacity) + Number(issue.estimate?.value) || 0);
        }
    });
    return usedCapacityInfoPerIteration;
});
const $6832ab781e992eca$export$aa4cf32120268e72 = (0, $dGvGJ.createSelector)([
    $6832ab781e992eca$export$5a622455e94bac3,
    $6832ab781e992eca$var$getUsedCapacityPerIteration,
    (0, $fyeGd.getColumns)
], (teams, usedCapacityInfoPerIteration, columns)=>{
    let capacityInfoPerIteration = {};
    [
        ...Object.values(teams),
        {
            id: (0, $4jAPy.SWIMLANE_TEAMLESS),
            capacity: null,
            capacityByIterationId: null
        }
    ].forEach((team)=>{
        const { id: teamId, capacity: defaultCapacity, capacityByIterationId: capacityByIterationId } = team;
        Object.keys(columns).forEach((iterationId)=>{
            capacityInfoPerIteration = (0, $7uUwQ.setIn)(capacityInfoPerIteration, [
                teamId,
                iterationId
            ], {
                defaultCapacity: defaultCapacity,
                usedCapacity: (0, $7uUwQ.getIn)(usedCapacityInfoPerIteration, [
                    teamId,
                    iterationId
                ]) || 0,
                totalCapacity: capacityByIterationId?.[Number(iterationId)]?.capacity ?? undefined
            });
        });
    });
    return capacityInfoPerIteration;
});

});


parcelRegister("4jZ56", function(module, exports) {

$parcel$export(module.exports, "swimlaneByTeamSelector", () => $839fb1eec13ba4e0$export$277f97a60fb97da1);
$parcel$export(module.exports, "getSwimlanes", () => $839fb1eec13ba4e0$export$612dc65e36d0eaf3);
$parcel$export(module.exports, "makeSwimlaneValuesSelector", () => $839fb1eec13ba4e0$export$42245eb297e9b819);
$parcel$export(module.exports, "isDefaultSwimlane", () => $839fb1eec13ba4e0$export$167f1fb297e78fe2);
$parcel$export(module.exports, "isInDefaultSwimlane", () => $839fb1eec13ba4e0$export$4def584ab131faf7);
$parcel$export(module.exports, "getCollapsedSwimlanes", () => $839fb1eec13ba4e0$export$676aff045298a75d);
$parcel$export(module.exports, "isSwimlaneCollapsed", () => $839fb1eec13ba4e0$export$90d7287d73f2112f);
$parcel$export(module.exports, "getIsSwimlaneCollapsed", () => $839fb1eec13ba4e0$export$37433a3d3d73dc9);
$parcel$export(module.exports, "makeIsSwimlaneCollapsed", () => $839fb1eec13ba4e0$export$9db3862b3df9c29d);
$parcel$export(module.exports, "isSwimlaneBySubtaskParentDoneSelector", () => $839fb1eec13ba4e0$export$13cce384be20a94b);
$parcel$export(module.exports, "areSwimlaneBySubtaskParentChildrenDoneSelector", () => $839fb1eec13ba4e0$export$32f30df65f500bd);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $9XE6b = parcelRequire("9XE6b");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $gJBT6 = parcelRequire("gJBT6");

var $3JOCw = parcelRequire("3JOCw");

var $g4tDr = parcelRequire("g4tDr");

var $iuuJH = parcelRequire("iuuJH");

var $c79wa = parcelRequire("c79wa");

var $3UY9S = parcelRequire("3UY9S");

var $bSSdD = parcelRequire("bSSdD");

var $vAfHD = parcelRequire("vAfHD");

var $d2i8f = parcelRequire("d2i8f");

var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");
const $839fb1eec13ba4e0$var$assigneeWithoutUnassignedSwimlanesSelector = (0, $dGvGJ.createSelector)([
    (0, $36pz7.getPeople),
    (0, $36pz7.getCurrentUserAccountId)
], (people, currentUserAccountId)=>Object.entries(people).map(([id, person])=>{
        const { id: assigneeId } = person;
        return {
            id: id,
            name: people[id].displayName,
            imageUrl: people[id].avatarUrl,
            values: {
                type: (0, $c79wa.ASSIGNEE),
                assigneeAccountId: assigneeId
            },
            issueKey: null
        };
    }).sort((a, b)=>{
        // Current user first and the rest of the users in alphabetical order
        if (a.id === currentUserAccountId) return -1;
        if (b.id === currentUserAccountId) return 1;
        return (a.name ?? '').localeCompare(b.name ?? '');
    }));
const $839fb1eec13ba4e0$export$1032e5fe171b1eb9 = (0, $dGvGJ.createSelector)([
    $839fb1eec13ba4e0$var$assigneeWithoutUnassignedSwimlanesSelector
], (assigneeSwimlanes)=>[
        ...assigneeSwimlanes,
        {
            ...(0, $c79wa.UnassignedSwimlane)
        }
    ]);
const $839fb1eec13ba4e0$export$b46208e06a990c41 = (0, $dGvGJ.createSelector)([
    $839fb1eec13ba4e0$var$assigneeWithoutUnassignedSwimlanesSelector
], (assigneeSwimlanes)=>[
        {
            ...(0, $c79wa.UnassignedSwimlane)
        },
        ...assigneeSwimlanes
    ]);
const $839fb1eec13ba4e0$var$swimlanesParentIssueSelector = (0, $dGvGJ.createSelector)([
    (0, $bSSdD.issueParentsSelector),
    (0, $67Z81.getIsCMPBoard)
], (issueParents, isCMPBoard)=>issueParents.filter((issue)=>issue.issueType.hierarchyLevel ? issue.issueType.hierarchyLevel === (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_EPIC) : true).map((issue)=>({
            id: String(issue.id),
            name: issue.summary,
            imageUrl: issue.issueType.iconUrl,
            values: {
                type: (0, $c79wa.PARENT),
                parentId: issue.id
            },
            issueKey: issue.key,
            isFlagged: isCMPBoard ? issue.flagged : undefined
        })).concat([
        {
            ...(0, $c79wa.ParentlessSwimlane)
        }
    ]));
const $839fb1eec13ba4e0$var$swimlanesIssueChildrenSelector = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.orderedIssuesWithSubtasksSelector)
], (issuesWithSubtasks)=>issuesWithSubtasks.map((issue)=>({
            id: String(issue.id),
            name: issue.summary,
            imageUrl: issue.typeUrl,
            values: {
                type: (0, $c79wa.STORY),
                parentId: issue.id
            },
            issueKey: issue.key,
            parentId: issue.parentId,
            assigneeAccountId: issue.assigneeAccountId,
            isFlagged: issue.isFlagged
        })).concat([
        {
            ...(0, $c79wa.ChildlessSwimlane)
        }
    ]));
const $839fb1eec13ba4e0$export$e468fcb20c90508 = (state)=>(0, $67Z81.getEntities)(state).jqlSwimlanes?.swimlanes.map((swimlane)=>({
            id: swimlane.id,
            name: swimlane.name,
            imageUrl: '',
            issueKey: null,
            values: {
                type: (0, $c79wa.JQL),
                issueIds: swimlane.issueIds
            }
        })) ?? [];
const $839fb1eec13ba4e0$export$d94a0a1f910ed9a6 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssueProjects)
], (issueProjects)=>Object.values(issueProjects).map(({ id: id, name: name, key: key, avatar: avatar })=>{
        const url = avatar ? new URL(avatar) : undefined;
        url?.searchParams.set('size', 'xsmall');
        return {
            id: String(id),
            name: name,
            imageUrl: url?.toString(),
            issueKey: null,
            projectKey: key,
            values: {
                type: (0, $c79wa.PROJECT),
                projectId: id
            }
        };
    }).sort((a, b)=>a.projectKey.localeCompare(b.projectKey)));
const $839fb1eec13ba4e0$export$277f97a60fb97da1 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getTeams)
], (teams)=>{
    const swimlanes = Object.values(teams).map(({ id: id, name: name, isPlanTeam: isPlanTeam, externalId: externalId, avatarUrl: avatarUrl, planningStyle: planningStyle })=>({
            id: id,
            name: name,
            imageUrl: avatarUrl || undefined,
            issueKey: null,
            values: {
                type: (0, $c79wa.TEAM),
                externalId: externalId,
                isPlanTeam: isPlanTeam,
                planningStyle: planningStyle
            }
        })).sort((a, b)=>a.name.localeCompare(b.name));
    return [
        ...swimlanes,
        (0, $c79wa.TeamlessSwimlane)
    ];
});
const $839fb1eec13ba4e0$export$5e292a752aac9b8f = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $67Z81.getRequestTypes)
], (issues, requestTypes)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(requestTypes)) return [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(Object.keys(issues).filter((key)=>{
        const issue = issues[key];
        return !!(issue.requestTypeId && requestTypes[issue.requestTypeId]);
    }).map((key)=>{
        const issue = issues[key];
        // requestTypeId will always have a value, because we are filtering out issues without a request type
        const { id: id, name: name, iconUrl: iconUrl } = requestTypes[issue.requestTypeId ?? ''];
        return {
            id: id,
            name: name,
            imageUrl: iconUrl,
            values: {
                type: (0, $c79wa.REQUEST_TYPE),
                id: id
            },
            issueKey: null
        };
    }), 'id');
});
const $839fb1eec13ba4e0$export$b9dd5eba76fd821e = (0, $dGvGJ.createSelector)([
    $839fb1eec13ba4e0$export$5e292a752aac9b8f
], (requestTypeSwimlanes)=>[
        ...requestTypeSwimlanes,
        {
            ...(0, $c79wa.UnassignedRequestTypeSwimlane)
        }
    ]);
const $839fb1eec13ba4e0$var$noSwimlanes = (0, $7uUwQ.freeze)([]);
const $839fb1eec13ba4e0$export$612dc65e36d0eaf3 = (state)=>{
    const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
    const isIncrementalPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
    if (swimlaneMode === (0, $iuuJH.NO_SWIMLANE).id) return $839fb1eec13ba4e0$var$noSwimlanes;
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE).id) return $839fb1eec13ba4e0$export$1032e5fe171b1eb9(state);
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST).id) return $839fb1eec13ba4e0$export$b46208e06a990c41(state);
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id) return $839fb1eec13ba4e0$var$swimlanesParentIssueSelector(state);
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return $839fb1eec13ba4e0$var$swimlanesIssueChildrenSelector(state);
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_JQL).id) return $839fb1eec13ba4e0$export$e468fcb20c90508(state);
    if ((0, $67Z81.getIsCMPBoard)(state) && swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PROJECT).id) return $839fb1eec13ba4e0$export$d94a0a1f910ed9a6(state);
    if (isIncrementalPlanningBoard && swimlaneMode === (0, $iuuJH.SWIMLANE_BY_TEAM).id) return $839fb1eec13ba4e0$export$277f97a60fb97da1(state);
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_REQUEST_TYPE).id) return $839fb1eec13ba4e0$export$b9dd5eba76fd821e(state);
    return $839fb1eec13ba4e0$var$noSwimlanes;
};
const $839fb1eec13ba4e0$export$42245eb297e9b819 = (0, $dGvGJ.createSelector)($839fb1eec13ba4e0$export$612dc65e36d0eaf3, (swimlanes)=>{
    const makeSwimlaneValues = (swimlaneId)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(swimlanes.find((swimlane)=>swimlane.id === swimlaneId), [
            'values'
        ], null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(makeSwimlaneValues);
});
const $839fb1eec13ba4e0$export$167f1fb297e78fe2 = (swimlaneId)=>swimlaneId === (0, $c79wa.UnassignedSwimlane).id || swimlaneId === (0, $c79wa.ParentlessSwimlane).id || swimlaneId === (0, $c79wa.ChildlessSwimlane).id;
const $839fb1eec13ba4e0$export$4def584ab131faf7 = (state)=>{
    const inDefaultSwimlaneCheck = (swimlaneId)=>{
        if (!swimlaneId) return false;
        const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
        if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE).id || swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST).id) return swimlaneId === (0, $c79wa.UnassignedSwimlane).id;
        if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id) return swimlaneId === (0, $c79wa.ParentlessSwimlane).id;
        if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return swimlaneId === (0, $c79wa.ChildlessSwimlane).id;
        return false;
    };
    return inDefaultSwimlaneCheck;
};
const $839fb1eec13ba4e0$export$676aff045298a75d = (state)=>(0, $67Z81.getUi)(state).swimlane.collapsed;
const $839fb1eec13ba4e0$export$90d7287d73f2112f = (state, swimlaneId)=>(0, $67Z81.getUi)(state).swimlane.collapsed.includes(swimlaneId);
const $839fb1eec13ba4e0$export$37433a3d3d73dc9 = (state)=>(swimlaneId)=>(0, $67Z81.getUi)(state).swimlane.collapsed.includes(swimlaneId);
const $839fb1eec13ba4e0$export$9db3862b3df9c29d = (0, $dGvGJ.createSelector)($839fb1eec13ba4e0$export$676aff045298a75d, (collapsedSwimlanes)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((swimlaneId)=>collapsedSwimlanes.includes(swimlaneId)));
const $839fb1eec13ba4e0$export$13cce384be20a94b = (0, $dGvGJ.createSelector)([
    (0, $d2i8f.isDoneIssueSelector),
    (0, $d2i8f.getIssueStatusSelector),
    (0, $45cXl.getSwimlaneMode),
    (0, $67Z81.getIsCMPBoard),
    (0, $67Z81.getMissingParents)
], (isDoneIssue, getIssueStatus, swimlaneMode, isCMPBoard, missingParents)=>{
    const isSwimlaneBySubtaskParentDone = (issueId)=>{
        const missingParentIssue = missingParents[issueId];
        // In certain situations, an issue's `isDone` key isn't `true` even when the issue's status' category is done.
        // But the `/transitionAndRank` endpoint (which the swimlane "Move to Done" button calls) doesn't return enough info
        // to update issue state to the new status, so only the issue's `isDone` key is set to `true` when using that functionality.
        // Using a combination of both allows us to ensures the button is always hidden correctly when the issue might be done.
        const isDone = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(missingParentIssue) ? isDoneIssue(issueId) || getIssueStatus(issueId)?.category === 'DONE' : missingParentIssue.status.category === 'DONE';
        return swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && isCMPBoard && isDone;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(isSwimlaneBySubtaskParentDone);
});
const $839fb1eec13ba4e0$export$32f30df65f500bd = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    (0, $67Z81.getIsCMPBoard),
    (0, $3UY9S.getChildrenOfParent),
    (0, $3UY9S.getIssueChildren)
], (swimlaneMode, isCMPBoard, getChildrenOfParent, issueChildren)=>{
    const areSwimlaneBySubtaskParentChildrenDone = (swimlaneValues)=>{
        const parentChildren = swimlaneValues?.type === (0, $c79wa.STORY) && swimlaneValues?.parentId ? getChildrenOfParent(swimlaneValues?.parentId) : [];
        return swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && isCMPBoard && parentChildren.length > 0 && parentChildren.every((childId)=>issueChildren[childId]?.isDone);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(areSwimlaneBySubtaskParentChildrenDone);
});
const $839fb1eec13ba4e0$export$b3f3cf27e378fcec = (0, $dGvGJ.createSelector)([
    $839fb1eec13ba4e0$export$277f97a60fb97da1
], (swimlanesByTeam)=>(swimlaneId)=>{
        const swimlane = swimlanesByTeam.filter((s)=>s.id === swimlaneId);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return swimlane.length > 0 && !swimlane[0].values?.isPlanTeam;
    });

});
parcelRegister("36pz7", function(module, exports) {

$parcel$export(module.exports, "getPeople", () => $7ae15d96adf6163b$export$b9c97d5330cbe844);
$parcel$export(module.exports, "getPerson", () => $7ae15d96adf6163b$export$1935eb9cdd85a29d);
$parcel$export(module.exports, "getCurrentUserAccountId", () => $7ae15d96adf6163b$export$4635f55bc9feebdb);
$parcel$export(module.exports, "getAssigneeAccountIds", () => $7ae15d96adf6163b$export$57f01d0afe40b3ba);

var $dGvGJ = parcelRequire("dGvGJ");


var $67Z81 = parcelRequire("67Z81");
const $7ae15d96adf6163b$export$b9c97d5330cbe844 = (state)=>(0, $67Z81.getEntities)(state).people;
const $7ae15d96adf6163b$export$1935eb9cdd85a29d = (state, id)=>$7ae15d96adf6163b$export$b9c97d5330cbe844(state)[id];
const $7ae15d96adf6163b$export$4635f55bc9feebdb = (state)=>state.configuration.userAccountId;
const $7ae15d96adf6163b$export$57f01d0afe40b3ba = (0, $dGvGJ.createSelector)([
    $7ae15d96adf6163b$export$b9c97d5330cbe844
], (assignees)=>{
    const accountIds = Object.keys(assignees);
    return [
        ...accountIds,
        (0, $15a528573ccd89ae$export$12e572fd459c10dc)
    ];
});

});
const $15a528573ccd89ae$export$d597759d33be802e = 'TEXT';
const $15a528573ccd89ae$export$f8f7545d2bb78afb = 'ASSIGNEE';
const $15a528573ccd89ae$export$37aee82a3cb1e8f7 = 'LABEL';
const $15a528573ccd89ae$export$2a4f270075a033de = 'ISSUE_PARENT';
const $15a528573ccd89ae$export$401f4b6eda6a369c = 'ISSUE_PROJECT';
const $15a528573ccd89ae$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $15a528573ccd89ae$export$a4ad2735b021c132 = 'VERSION';
const $15a528573ccd89ae$export$af1e30ebbae9df3b = 'COMPONENT';
const $15a528573ccd89ae$export$f863b019d19144f4 = 'STATUS_CATEGORY';
const $15a528573ccd89ae$export$a316570a0dbfd2b0 = 'SPRINT';
const $15a528573ccd89ae$export$e50006273435e7d4 = 'STATUS';
const $15a528573ccd89ae$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $15a528573ccd89ae$export$68d693c35a8d8866 = 'CUSTOM_FILTER';
const $15a528573ccd89ae$export$1ea95b94fb0c51d9 = 'QUICK_FILTER';
const $15a528573ccd89ae$export$871e58afc769b358 = 'GOAL';
const $15a528573ccd89ae$export$6c4d37c7f376a1de = 'CLEAR';
const $15a528573ccd89ae$export$db362e2d293fe52e = 'DEPENDENCIES';
const $15a528573ccd89ae$export$12e572fd459c10dc = 'unassigned';
const $15a528573ccd89ae$export$ac95b4b2317d4b33 = 'unassigned';
const $15a528573ccd89ae$export$81ef49afbbead0a1 = 'label unassigned';
const $15a528573ccd89ae$export$4b7c755e61199a36 = 'unassigned';
const $15a528573ccd89ae$export$c9408e3fb31ddc71 = 'offline';
const $15a528573ccd89ae$export$7a105aa475396c65 = 'online';




parcelRegister("5mTgl", function(module, exports) {

$parcel$export(module.exports, "isBoardConfigLoaded", () => $2007c62349361047$export$d49006793d041c52);
$parcel$export(module.exports, "isCurrentUserLoaded", () => $2007c62349361047$export$6b3694fe2dc20c31);
$parcel$export(module.exports, "getEstimationStatistic", () => $2007c62349361047$export$8dc27e15988a8928);
$parcel$export(module.exports, "hasAnyActiveOptimistic", () => $2007c62349361047$export$5c9c2a640adc17da);
$parcel$export(module.exports, "getWorkFilters", () => $2007c62349361047$export$bfbfdc2dda3d42ac);
$parcel$export(module.exports, "getCustomFilters", () => $2007c62349361047$export$ada7918f4af738ad);
$parcel$export(module.exports, "isFilterOnCurrentUserOnly", () => $2007c62349361047$export$c13d0e4be78b916c);
$parcel$export(module.exports, "isInlineColumnEditEnabled", () => $2007c62349361047$export$9682312c5ac76dea);
$parcel$export(module.exports, "isCardMediaEnabled", () => $2007c62349361047$export$d702c21e54b7d02);
$parcel$export(module.exports, "isCardMediaAvailable", () => $2007c62349361047$export$517314af7ddca56f);
$parcel$export(module.exports, "isReleasesFeatureEnabled", () => $2007c62349361047$export$d9ef39d66b89734f);
$parcel$export(module.exports, "boardColumnConstraintTypeSelector", () => $2007c62349361047$export$3892b6ff82249ef9);
$parcel$export(module.exports, "getNumberOfCardsWithCovers", () => $2007c62349361047$export$58f6e12eca9eaacb);
$parcel$export(module.exports, "getNumberOfCardsWithDueDates", () => $2007c62349361047$export$8983c3cdc7e8c1a5);
$parcel$export(module.exports, "getTimeTrackingOptions", () => $2007c62349361047$export$cb06173d4516a1bf);
$parcel$export(module.exports, "getIsAnyStatusInCreateEnabled", () => $2007c62349361047$export$509c01424b13a8d7);
$parcel$export(module.exports, "getColumnDeleteModalColumnId", () => $2007c62349361047$export$664aa5c36021df12);
$parcel$export(module.exports, "getColumnDeleteModalIsOpen", () => $2007c62349361047$export$c97bfeafd86d3880);
$parcel$export(module.exports, "isIssueDeleteModalOpen", () => $2007c62349361047$export$ecc8f72c94c5c10f);
$parcel$export(module.exports, "getIssueDeleteModalIssueId", () => $2007c62349361047$export$5a246c8ca4516a10);
$parcel$export(module.exports, "isLastRemainingColumn", () => $2007c62349361047$export$bfc0a3b2c66f2571);
$parcel$export(module.exports, "getBoardHasFilteredIssues", () => $2007c62349361047$export$6dd0ed6404bbbe1a);
$parcel$export(module.exports, "shouldRenderCardTypesSelector", () => $2007c62349361047$export$8950057b90a7be0);
$parcel$export(module.exports, "workColumnsSelector", () => $2007c62349361047$export$4ec9b51959de43e9);
$parcel$export(module.exports, "workIssuesSelector", () => $2007c62349361047$export$f496179039a6c96a);
$parcel$export(module.exports, "getColumnTotalIssuesCount", () => $2007c62349361047$export$42858dbfcc0ce9c6);
$parcel$export(module.exports, "getTeamSwimlaneColumnTotalIssuesCount", () => $2007c62349361047$export$45544dfa626588d1);
$parcel$export(module.exports, "getTeamSwimlaneColumnSprint", () => $2007c62349361047$export$1f985e0e5786e956);
$parcel$export(module.exports, "getIsUnscheduledColumnVisible", () => $2007c62349361047$export$6d5a132be16d7b29);
$parcel$export(module.exports, "unscheduledColumnSelector", () => $2007c62349361047$export$89d0463c0245d2f2);
$parcel$export(module.exports, "columnsWithResolutionSelector", () => $2007c62349361047$export$502e3142eedda17e);
$parcel$export(module.exports, "orderedWorkAssigneesByAccountIdSelector", () => $2007c62349361047$export$1bbbdcc3b9f74565);
$parcel$export(module.exports, "orderedWorkAssigneesAlphabeticallySelector", () => $2007c62349361047$export$7b365bd1ab5fa00b);
$parcel$export(module.exports, "doesColumnHaveIssuesSelector", () => $2007c62349361047$export$cf831ce22df95e40);
$parcel$export(module.exports, "hasIssuesNotOnBoard", () => $2007c62349361047$export$130d5e3f88c9116d);
$parcel$export(module.exports, "getFilteredCardIds", () => $2007c62349361047$export$5496a8bd76ac3cc7);
$parcel$export(module.exports, "isFilteredCardsLoading", () => $2007c62349361047$export$eadf838276efbfae);
$parcel$export(module.exports, "workFilteredIssuesSelector", () => $2007c62349361047$export$83704ff797ee645e);
$parcel$export(module.exports, "getColumnIssuesCount", () => $2007c62349361047$export$bdcb688a64d33e13);
$parcel$export(module.exports, "platformIssueSelector", () => $2007c62349361047$export$c3eddeee4fff0c95);
$parcel$export(module.exports, "getEstimateExtendedByIssueId", () => $2007c62349361047$export$49400d4dee597710);
$parcel$export(module.exports, "platformIssueIdsBySwimlaneSelector", () => $2007c62349361047$export$8b37d0d4754c2222);
$parcel$export(module.exports, "swimlaneHeightsSelector", () => $2007c62349361047$export$c8eb34d22f45afc2);
$parcel$export(module.exports, "filtersForInlineCardCreateCountSelector", () => $2007c62349361047$export$2f80a678ff297046);
$parcel$export(module.exports, "hasWorkFiltersSelector", () => $2007c62349361047$export$a7e88415a097d4e1);
$parcel$export(module.exports, "hasCustomFiltersSelector", () => $2007c62349361047$export$100f6402dcbc1c5);
$parcel$export(module.exports, "platformHighlightScopeSelector", () => $2007c62349361047$export$18912e4e4d90673c);
$parcel$export(module.exports, "platformSwimlanesSelector", () => $2007c62349361047$export$25cdb7cc38e01f95);
$parcel$export(module.exports, "platformSwimlaneSelector", () => $2007c62349361047$export$547cddb5216fa288);
$parcel$export(module.exports, "platformSwimlaneIdsSelector", () => $2007c62349361047$export$258129f9697957ee);
$parcel$export(module.exports, "getFirstOpenSwimlaneIdSelector", () => $2007c62349361047$export$fe8e61f95247eb77);
$parcel$export(module.exports, "getColumnTheme", () => $2007c62349361047$export$f26c3b512bbb6d6d);
$parcel$export(module.exports, "isColumnUpdating", () => $2007c62349361047$export$b7de3298691c708c);
$parcel$export(module.exports, "isAnyColumnUpdating", () => $2007c62349361047$export$8b6be5e9a544d475);
$parcel$export(module.exports, "isCardDragDisabled", () => $2007c62349361047$export$a80f3c30adc36a1b);
$parcel$export(module.exports, "getCardDndType", () => $2007c62349361047$export$4b99acc1a687df2e);
$parcel$export(module.exports, "isDraggingSubtaskSelector", () => $2007c62349361047$export$1de4ece81cabd754);
$parcel$export(module.exports, "isSwimlaneTransitionZoneEnabledForSubtask", () => $2007c62349361047$export$9020a94481968b53);
$parcel$export(module.exports, "getAppliedIssueTypeFilters", () => $2007c62349361047$export$7ea0d3589e75ea3e);
$parcel$export(module.exports, "getLastFilteredIssueTypeId", () => $2007c62349361047$export$66fc4c808781b0dd);
$parcel$export(module.exports, "getLastFilteredProjectId", () => $2007c62349361047$export$b75a7d5a0b2593df);
$parcel$export(module.exports, "getHasAppliedEpicFilters", () => $2007c62349361047$export$717522cf1f80bfcb);
$parcel$export(module.exports, "validFilterValuesSelector", () => $2007c62349361047$export$a3e606d31ce14076);
$parcel$export(module.exports, "hasInvalidFilterValuesSelector", () => $2007c62349361047$export$e5ce012c8ff94f67);
$parcel$export(module.exports, "getFilteredIssueIdsByColumn", () => $2007c62349361047$export$8da24954392d0b6b);
$parcel$export(module.exports, "getFilteredIssueKeysAsRapidViewMap", () => $2007c62349361047$export$76423ca425841ce3);
$parcel$export(module.exports, "getColumnIssuesCountWithLimit", () => $2007c62349361047$export$a3d88d5fd2477a5c);
$parcel$export(module.exports, "lastFilteredIssueParentIdSelector", () => $2007c62349361047$export$8fc92f4a10e91c3b);
$parcel$export(module.exports, "workDataWithDevStatusSelector", () => $2007c62349361047$export$6d848ac469f8f1d5);
$parcel$export(module.exports, "isIssueVisible", () => $2007c62349361047$export$fc04e99ac3563a66);
$parcel$export(module.exports, "getInvisibleIssueIdsFromClientSideFiltersOnly", () => $2007c62349361047$export$bacbd1cd61f6f690);
$parcel$export(module.exports, "getInvisibleIssueKeys", () => $2007c62349361047$export$675ae7d7d995e6cd);
$parcel$export(module.exports, "getActiveIssueWithIcc", () => $2007c62349361047$export$2c3764a24d5a77a5);
$parcel$export(module.exports, "isActiveCardSelector", () => $2007c62349361047$export$45f354b7131bf0a2);
$parcel$export(module.exports, "shouldRenderIcc", () => $2007c62349361047$export$1f1c155fbe31f55a);
$parcel$export(module.exports, "getIssuesIdsForColumn", () => $2007c62349361047$export$9c38ecda34a0899c);
$parcel$export(module.exports, "makeGetIssueEntriesForColumnSelector", () => $2007c62349361047$export$138c2389bbf22c2d);
$parcel$export(module.exports, "getIssuesEntriesWithIssueLinksInBoard", () => $2007c62349361047$export$d7699a71638fd9d4);
$parcel$export(module.exports, "getIssuesWithIssueLinksInBoardIds", () => $2007c62349361047$export$1e1a7e899f73dc6f);
$parcel$export(module.exports, "issueColumnIdSelector", () => $2007c62349361047$export$cc6f4dd9bb04ac0a);
$parcel$export(module.exports, "issueSwimlaneIdSelector", () => $2007c62349361047$export$db5d57ea014e1a9f);
$parcel$export(module.exports, "getStatusByIssueIdSelector", () => $2007c62349361047$export$5c4dc04d949c48c3);
$parcel$export(module.exports, "getActiveIssueKey", () => $2007c62349361047$export$98d29ba803e92a0e);
$parcel$export(module.exports, "makeGetIssueParentForSwimlaneHeader", () => $2007c62349361047$export$78a44af01b2680d);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $hm7zS = parcelRequire("hm7zS");

var $k8IPx = parcelRequire("k8IPx");

var $9XE6b = parcelRequire("9XE6b");

var $fn8B5 = parcelRequire("fn8B5");

var $4wVpT = parcelRequire("4wVpT");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $4Xk2W = parcelRequire("4Xk2W");

var $hYfgW = parcelRequire("hYfgW");

var $dPSWJ = parcelRequire("dPSWJ");

var $gJBT6 = parcelRequire("gJBT6");

var $4f8Oj = parcelRequire("4f8Oj");

var $kGsr8 = parcelRequire("kGsr8");

var $8QpSo = parcelRequire("8QpSo");

var $5rFbt = parcelRequire("5rFbt");

var $2vSU6 = parcelRequire("2vSU6");

var $dJl1T = parcelRequire("dJl1T");

var $4R6GH = parcelRequire("4R6GH");

var $kIDH3 = parcelRequire("kIDH3");

var $645AZ = parcelRequire("645AZ");

var $3kNE6 = parcelRequire("3kNE6");

var $4jAPy = parcelRequire("4jAPy");

var $g5X3G = parcelRequire("g5X3G");

var $2xFXk = parcelRequire("2xFXk");

var $esu6n = parcelRequire("esu6n");

var $kgiLc = parcelRequire("kgiLc");



var $iuuJH = parcelRequire("iuuJH");

var $c79wa = parcelRequire("c79wa");

var $bwTbl = parcelRequire("bwTbl");


var $kc6Ry = parcelRequire("kc6Ry");

var $9OPlz = parcelRequire("9OPlz");

var $fyeGd = parcelRequire("fyeGd");

var $idNc7 = parcelRequire("idNc7");

var $3UY9S = parcelRequire("3UY9S");

var $bSSdD = parcelRequire("bSSdD");

var $4gt6L = parcelRequire("4gt6L");

var $vAfHD = parcelRequire("vAfHD");

var $iGIww = parcelRequire("iGIww");

var $2VkyK = parcelRequire("2VkyK");

var $d2i8f = parcelRequire("d2i8f");

var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");
const $2007c62349361047$export$d49006793d041c52 = (state)=>(0, $67Z81.getBoardEntity)(state).isConfigLoaded;
const $2007c62349361047$export$6b3694fe2dc20c31 = (state)=>(0, $67Z81.getBoardEntity)(state).isCurrentUserLoaded;
const $2007c62349361047$export$8dc27e15988a8928 = (state)=>(0, $67Z81.getEntities)(state).estimationStatistic;
const $2007c62349361047$export$5c9c2a640adc17da = (state)=>{
    const beforeState = state.entities && state.entities.beforeState;
    return beforeState !== undefined;
};
const $2007c62349361047$export$7b4d448d658d5a3b = (state)=>(0, $67Z81.getUi)(state).columns;
const $2007c62349361047$export$bfbfdc2dda3d42ac = (state)=>(0, $67Z81.getUi)(state).workFilters ?? {
        values: {}
    };
const $2007c62349361047$export$ada7918f4af738ad = (state)=>(0, $67Z81.getEntities)(state).customFilters.filters;
const $2007c62349361047$export$c13d0e4be78b916c = (state)=>{
    const assignees = $2007c62349361047$export$bfbfdc2dda3d42ac(state).values[0, $dcff40112356dfc1$export$f8f7545d2bb78afb];
    return assignees && assignees.length === 1 && (0, $36pz7.getCurrentUserAccountId)(state) === assignees[0];
};
const $2007c62349361047$export$9682312c5ac76dea = (state)=>(0, $67Z81.getBoardConfig)(state).isInlineColumnEditEnabled && (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).INLINE_COLUMN_EDIT);
const $2007c62349361047$export$d702c21e54b7d02 = (state)=>(0, $67Z81.getBoardConfig)(state).isCardMediaEnabled || false;
const $2007c62349361047$export$517314af7ddca56f = (0, $dGvGJ.createSelector)([
    (0, $2VkyK.getIssuesMedia)
], (issueMedia)=>(0, $g5X3G.values)(issueMedia).some((media)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(media, [
            'isHiddenByUser'
        ]) === false));
const $2007c62349361047$export$d9ef39d66b89734f = (state)=>(0, $67Z81.getBoardConfig)(state).isReleasesFeatureEnabled === true;
const $2007c62349361047$export$3892b6ff82249ef9 = (state)=>(0, $67Z81.getBoardConfig)(state).columnConstraintType;
const $2007c62349361047$export$58f6e12eca9eaacb = (state)=>(0, $g5X3G.values)((0, $2VkyK.getIssuesMedia)(state)).filter((media)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(media, [
            'isHiddenByUser'
        ]) === false).length;
const $2007c62349361047$export$8983c3cdc7e8c1a5 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssues)
], (allIssues)=>(0, $g5X3G.values)(allIssues).filter((issue)=>Boolean(issue.dueDate)).length);
const $2007c62349361047$export$cb06173d4516a1bf = (state)=>(0, $67Z81.getBoardConfig)(state).timeTrackingOptions;
const $2007c62349361047$export$509c01424b13a8d7 = (state)=>(0, $67Z81.getBoardConfig)(state).isAnyStatusInCreateEnabled;
const $2007c62349361047$var$getUiColumn = (state)=>(0, $67Z81.getUi)(state).column;
const $2007c62349361047$var$getColumnDeleteModal = (state)=>$2007c62349361047$var$getUiColumn(state).deleteModal;
const $2007c62349361047$export$664aa5c36021df12 = (state)=>{
    const deleteModalState = $2007c62349361047$var$getColumnDeleteModal(state);
    return deleteModalState && 'columnId' in deleteModalState ? deleteModalState.columnId : undefined;
};
const $2007c62349361047$export$c97bfeafd86d3880 = (state)=>$2007c62349361047$var$getColumnDeleteModal(state).isOpen;
const $2007c62349361047$export$ecc8f72c94c5c10f = (state)=>Boolean((0, $67Z81.getUi)(state).issueDeleteModal?.isOpen);
const $2007c62349361047$export$5a246c8ca4516a10 = (state)=>(0, $67Z81.getUi)(state).issueDeleteModal?.issueId;
const $2007c62349361047$export$bfc0a3b2c66f2571 = (state)=>Object.keys((0, $67Z81.getEntities)(state).columns).length === 1;
const $2007c62349361047$export$6dd0ed6404bbbe1a = (state)=>(0, $67Z81.getBoardEntity)(state).hasFilteredIssues;
const $2007c62349361047$export$16eaaab637a3ff60 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssueTypes)
], (issueTypes)=>Object.keys(issueTypes).map((id)=>issueTypes[id]));
const $2007c62349361047$export$8950057b90a7be0 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssueTypes),
    (0, $4gt6L.issueChildrenTypesSelector)
], (issueTypes, issueChildrenTypes)=>Object.keys(issueTypes).length > 1 || issueChildrenTypes.length > 0);
const $2007c62349361047$export$4ec9b51959de43e9 = (0, $dGvGJ.createSelector)([
    (0, $fyeGd.getColumns),
    (0, $67Z81.getOrderedColumnIds)
], (columns, columnIds)=>columnIds.map((columnId)=>columns[String(columnId)]));
const $2007c62349361047$export$f496179039a6c96a = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $vAfHD.boardOrderedIssueIdsSelector)
], (issueEntities, boardIssuesIds)=>boardIssuesIds.map((id)=>issueEntities[String(id)]).filter(Boolean));
const $2007c62349361047$export$cc6af36a61576fbf = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$f496179039a6c96a
], (issues)=>issues?.length || 0);
const $2007c62349361047$export$9b1ea4b9173c2926 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$4ec9b51959de43e9,
    $2007c62349361047$export$f496179039a6c96a,
    $2007c62349361047$export$3892b6ff82249ef9,
    (0, $3UY9S.getIssueChildren)
], (columns, issues, columnConstraintType, issueChildren)=>{
    const countMap = {};
    columns.forEach((column)=>{
        countMap[String(column.id)] = 0;
    });
    issues.forEach((issue)=>{
        if (columnConstraintType === 'ISSUE_COUNT_EXCLUDE_SUBTASKS' && issue.id in issueChildren) return;
        countMap[String(issue.columnId)] += 1;
    });
    return countMap;
});
const $2007c62349361047$export$42858dbfcc0ce9c6 = (state, columnId)=>$2007c62349361047$export$9b1ea4b9173c2926(state)[String(columnId)];
const $2007c62349361047$export$d543024fc9769252 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$4ec9b51959de43e9,
    $2007c62349361047$export$f496179039a6c96a,
    (0, $4jZ56.swimlaneByTeamSelector)
], (columns, issues, swimlanesByTeam)=>{
    const countMap = {};
    columns.forEach((column)=>{
        countMap[String(column.id)] = {};
        swimlanesByTeam.forEach((swimlane)=>{
            countMap[String(column.id)][swimlane.id] = 0;
        });
    });
    issues.forEach((issue)=>{
        const teamId = issue.teamId || (0, $4jAPy.SWIMLANE_TEAMLESS);
        countMap[String(issue.columnId)][teamId] += 1;
    });
    return countMap;
});
const $2007c62349361047$export$45544dfa626588d1 = (state, columnId, swimlaneId)=>$2007c62349361047$export$d543024fc9769252(state)[String(columnId)][swimlaneId];
const $2007c62349361047$export$1f985e0e5786e956 = (state, columnId, swimlaneId)=>{
    if (swimlaneId === (0, $4jAPy.SWIMLANE_TEAMLESS) || columnId === (0, $5rFbt.UNSCHEDULED_COLUMN_ID)) return undefined;
    const teams = (0, $67Z81.getTeams)(state);
    const sprintByIteration = teams[Number(swimlaneId)]?.sprintByIterationId;
    return sprintByIteration && sprintByIteration[Number(columnId)];
};
const $2007c62349361047$export$6d5a132be16d7b29 = (state)=>state.ui.board.displayOptions.showUnscheduledColumn;
const $2007c62349361047$export$89d0463c0245d2f2 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$4ec9b51959de43e9
], (columns)=>columns.filter((column)=>column.type === (0, $5rFbt.ColumnType).DATE_RANGE && (0, $esu6n.isUnscheduledColumn)(column)).map((column)=>({
            id: column.id,
            name: column.name,
            isDone: false,
            isInitial: false,
            limitJql: undefined
        })));
const $2007c62349361047$export$502e3142eedda17e = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$4ec9b51959de43e9,
    (0, $67Z81.getIsIncrementPlanningBoard)
], (columns, isIPBoard)=>{
    if (isIPBoard) return columns.filter((column)=>column.type === (0, $5rFbt.ColumnType).DATE_RANGE && !(0, $esu6n.isUnscheduledColumn)(column)).map((column)=>({
            id: column.id,
            name: column.name,
            isDone: false,
            isInitial: false,
            limitJql: undefined
        }));
    return columns.filter((column)=>column.type === (0, $5rFbt.ColumnType).STATUS && column.statuses && column.statuses.length > 0).map((column)=>{
        const isDone = (0, $fyeGd.isDoneColumn)(column);
        return {
            id: column.id,
            name: column.name,
            isDone: isDone,
            isInitial: (0, $fyeGd.isInitialColumn)(column),
            limitJql: column.limitJql
        };
    });
});
const $2007c62349361047$export$1bbbdcc3b9f74565 = (0, $dGvGJ.createSelector)([
    (0, $36pz7.getPeople),
    (0, $36pz7.getCurrentUserAccountId),
    $2007c62349361047$export$f496179039a6c96a
], (assignees, currentUserAccountId, allIssues)=>{
    const currentUser = assignees[currentUserAccountId];
    const assigneeList = currentUser ? [
        currentUser
    ] : [];
    const issuesWithAssignees = allIssues.filter((i)=>i.assigneeAccountId && i.assigneeAccountId !== currentUserAccountId && assignees[i.assigneeAccountId]);
    const assigneeCounts = (0, (/*@__PURE__*/$parcel$interopDefault($hm7zS)))(issuesWithAssignees, (i)=>i.assigneeAccountId);
    Object.keys(assigneeCounts).sort((a, b)=>assigneeCounts[b] - assigneeCounts[a]).forEach((assigneeId)=>assigneeList.push(assignees[assigneeId]));
    return (0, $7uUwQ.freeze)(assigneeList);
});
const $2007c62349361047$export$7b365bd1ab5fa00b = (0, $dGvGJ.createSelector)([
    (0, $36pz7.getPeople),
    (0, $36pz7.getCurrentUserAccountId)
], (assignees, currentUserAccountId)=>{
    const currentUser = assignees[currentUserAccountId];
    const assigneeList = currentUser ? [
        currentUser
    ] : [];
    const otherAssignees = Object.values(assignees).filter((assignee)=>assignee.id !== currentUserAccountId);
    const sortedOtherAssignees = otherAssignees.sort((a, b)=>a.displayName.localeCompare(b.displayName));
    return (0, $7uUwQ.freeze)([
        ...assigneeList,
        ...sortedOtherAssignees
    ]);
});
const $2007c62349361047$export$cf831ce22df95e40 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$f496179039a6c96a
], (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnId)=>issues.some((issue)=>issue.columnId === columnId)));
const $2007c62349361047$var$getIssuesNotOnBoard = (state)=>(0, $67Z81.getUi)(state).column.issuesNotOnBoard;
const $2007c62349361047$export$130d5e3f88c9116d = (0, $dGvGJ.createSelector)([
    $2007c62349361047$var$getIssuesNotOnBoard
], (issuesNotOnBoard)=>(columnId)=>issuesNotOnBoard[String(columnId)]);
const $2007c62349361047$export$5496a8bd76ac3cc7 = (state)=>state.ui.cards.filteredCards.filteredCardsIds;
const $2007c62349361047$export$eadf838276efbfae = (state)=>state.ui.cards.filteredCards.isLoading;
const $2007c62349361047$export$83704ff797ee645e = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac,
    $2007c62349361047$export$f496179039a6c96a,
    (0, $67Z81.getIssues),
    (0, $36pz7.getPeople),
    $2007c62349361047$export$5496a8bd76ac3cc7
], (workFilters, issues, issueHash, people, filteredCardIds)=>(0, $iGIww.filter)(workFilters.values, issues, issueHash, people, filteredCardIds || undefined));
const $2007c62349361047$export$26127d4a6365327c = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac,
    (0, $vAfHD.boardIssuesAndChildrenSelector),
    (0, $67Z81.getIssues),
    (0, $36pz7.getPeople),
    $2007c62349361047$export$5496a8bd76ac3cc7
], (workFilters, issues, issueHash, people, filteredCardIds)=>(0, $iGIww.filter)(workFilters.values, Object.values(issues), issueHash, people, filteredCardIds || undefined));
const $2007c62349361047$export$6f94a60a61d0a7c1 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$83704ff797ee645e,
    $2007c62349361047$export$26127d4a6365327c,
    (0, $67Z81.getIsCMPBoard)
], (issues, cmpEpicSwimlaneIssue, isCMPBoard)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnId)=>isCMPBoard ? cmpEpicSwimlaneIssue.filter((issue)=>issue.columnId === columnId).map((issue)=>issue.id) : issues.filter((issue)=>issue.columnId === columnId).map((issue)=>issue.id)));
const $2007c62349361047$export$bdcb688a64d33e13 = (state, columnId)=>{
    const issueIds = $2007c62349361047$export$6f94a60a61d0a7c1(state)(columnId);
    const columnConstraintType = $2007c62349361047$export$3892b6ff82249ef9(state);
    const issueChildren = (0, $3UY9S.getIssueChildren)(state);
    const filteredIssueIds = issueIds.filter((issueId)=>columnConstraintType !== 'ISSUE_COUNT_EXCLUDE_SUBTASKS' || !(issueId in issueChildren));
    return filteredIssueIds.length;
};
const $2007c62349361047$export$6e9b8e59636a4bbf = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$f496179039a6c96a,
    (0, $67Z81.projectIdSelector)
], (issues, projectId)=>(0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(issues.map((issue)=>Number(issue.projectId)) // get project ids
    .filter((id)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(id)).concat(projectId ? [
        projectId
    ] : [])));
const $2007c62349361047$export$1481a23387579796 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (filters)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$37aee82a3cb1e8f7)
    ], null)));
const $2007c62349361047$var$getIssueById = (0, $dGvGJ.createSelector)([
    (state, props)=>props.id,
    (state)=>(0, $vAfHD.boardIssuesSelector)(state)
], (id, issues)=>{
    const foundIssue = issues[String(id)];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(foundIssue)) (0, $dJl1T.default).safeErrorWithoutCustomerData('board.getIssueById.failure', 'Failure to found issue by id', new Error(`Issue Id to find ${id} not found in context ${Object.keys(issues).join(',')}`));
    return foundIssue;
});
// JSM uses request type name and icon as typeName and typeUrl.
const $2007c62349361047$var$getIssueForProject = (issue, projectType, requestTypes = [])=>{
    if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) {
        const requestType = requestTypes.find((req)=>req.id === issue.requestTypeId);
        const typeName = requestType?.name;
        const typeUrl = requestType?.iconUrl;
        return {
            ...issue,
            typeName: typeName,
            typeUrl: typeUrl
        };
    }
    return issue;
};
const $2007c62349361047$export$c3eddeee4fff0c95 = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $45cXl.getSwimlaneMode),
    (0, $4jZ56.getSwimlanes),
    (0, $67Z81.getIsCMPBoard),
    (0, $67Z81.projectTypeSelector),
    (0, $d2i8f.requestTypesSelector)
], (boardIssues, swimlaneMode, availableSwimlanes, isCMPBoard, projectType, requestTypes)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((id)=>{
        const issueToBeTransformed = boardIssues[String(id)];
        if (!issueToBeTransformed) return null;
        return (0, $bwTbl.transformSoftwareToPlatformIssue)($2007c62349361047$var$getIssueForProject(issueToBeTransformed, projectType, requestTypes), swimlaneMode, availableSwimlanes, isCMPBoard, (issueId)=>boardIssues[issueId]);
    }));
const $2007c62349361047$export$b6964ddef57f801 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$83704ff797ee645e,
    (0, $45cXl.getSwimlaneMode),
    (0, $4jZ56.getSwimlanes),
    (0, $67Z81.getIsCMPBoard),
    (0, $vAfHD.boardIssuesSelector)
], (issues, swimlaneMode, availableSwimlanes, isCMPBoard, boardIssues)=>issues.map((issue)=>(0, $bwTbl.transformSoftwareToPlatformIssue)(issue, swimlaneMode, availableSwimlanes, isCMPBoard, (issueId)=>boardIssues[issueId])));
const $2007c62349361047$export$a05529bcb9c00a96 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$b6964ddef57f801,
    (0, $67Z81.getIsIncrementPlanningBoard),
    $2007c62349361047$export$6d5a132be16d7b29
], (issues, isIPBoard, isUnscheduledColumnVisible)=>{
    if (isIPBoard && !isUnscheduledColumnVisible) return issues.filter(({ columnId: columnId })=>columnId !== (0, $5rFbt.UNSCHEDULED_COLUMN_ID));
    return issues;
});
const $2007c62349361047$export$49400d4dee597710 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$var$getIssueById
], (issue)=>issue?.estimate ?? null);
const $2007c62349361047$export$8b37d0d4754c2222 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$a05529bcb9c00a96,
    (0, $45cXl.getSwimlaneMode),
    (0, $4jZ56.getSwimlanes),
    (0, $bSSdD.getIssueParents)
], (issues, swimlaneMode, swimlanes, issueParents)=>{
    if (!swimlaneMode || swimlaneMode === (0, $iuuJH.NO_SWIMLANE).id) return {};
    const issuesBySwimlane = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(issues, (issue)=>issue.swimlaneId);
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id && (0, $c79wa.ParentlessSwimlane).id in issuesBySwimlane) {
        // remove all the Epic issues as they should not be counted the parentless swimlane
        const issueParentIds = Object.values(issueParents).map((issueParent)=>issueParent.id);
        const filteredIssues = issuesBySwimlane[(0, $c79wa.ParentlessSwimlane).id]?.filter((issue)=>!issueParentIds.includes(issue.id));
        issuesBySwimlane[(0, $c79wa.ParentlessSwimlane).id] = filteredIssues || [];
    }
    swimlanes.forEach(({ id: id })=>{
        if (issuesBySwimlane[id] === undefined) issuesBySwimlane[id] = [];
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(issuesBySwimlane, (issuesInSwimlane)=>{
        const issuesByColumnId = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(issuesInSwimlane, (issue)=>issue.columnId);
        return (0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(issuesByColumnId, (issuesInColumn)=>issuesInColumn.map((issue)=>issue.id));
    });
});
const $2007c62349361047$export$808aa6f47af32b37 = (swimlaneColumns)=>{
    let swimlaneHeight = 0;
    Object.values(swimlaneColumns).forEach((column)=>{
        if (column.length > swimlaneHeight) swimlaneHeight = column.length;
    });
    return swimlaneHeight * (0, $7455914ed26b7de2$export$428a1825e984a589);
};
const $2007c62349361047$export$c8eb34d22f45afc2 = (0, $dGvGJ.createSelector)([
    (0, $4jZ56.getSwimlanes),
    (0, $4jZ56.getIsSwimlaneCollapsed),
    $2007c62349361047$export$8b37d0d4754c2222
], (swimlanes, isSwimlaneCollapsed, issueIdsBySwimlane)=>swimlanes.reduce((result, swimlane)=>{
        // eslint-disable-next-line no-param-reassign
        result[swimlane.id] = (0, $645AZ.swimlaneHeaderHeight) + (isSwimlaneCollapsed(swimlane.id) ? 0 : $2007c62349361047$export$808aa6f47af32b37(issueIdsBySwimlane[swimlane.id]));
        return result;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {}));
const $2007c62349361047$export$8e7b436529ceb24b = (0, $dGvGJ.createSelector)([
    (0, $4jZ56.getSwimlanes),
    (0, $4jZ56.getIsSwimlaneCollapsed),
    $2007c62349361047$export$8b37d0d4754c2222
], (swimlanes, isSwimlaneCollapsed, issueIdsBySwimlane)=>()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const swimlaneHeights = [];
        swimlanes.forEach((swimlane)=>{
            // If an above swimlane is collapsed, don't count its height
            if (isSwimlaneCollapsed(swimlane.id)) return;
            swimlaneHeights.push({
                swimlaneId: swimlane.id,
                height: $2007c62349361047$export$808aa6f47af32b37(issueIdsBySwimlane[swimlane.id])
            });
        });
        const swimlaneOffsets = {};
        swimlaneHeights.forEach(({ swimlaneId: swimlaneId }, index)=>{
            if (index === 0) swimlaneOffsets[swimlaneId] = 0;
            else {
                const previousId = swimlaneHeights[index - 1].swimlaneId;
                const previousHeight = swimlaneHeights[index - 1].height;
                const previousOffset = swimlaneOffsets[previousId];
                swimlaneOffsets[swimlaneId] = previousOffset + previousHeight;
            }
        });
        return swimlaneOffsets;
    });
const $2007c62349361047$var$getCardAmount = (swimlaneId, issueIdsBySwimlane)=>(0, $g5X3G.values)(issueIdsBySwimlane[swimlaneId] || {}).reduce((amount, issueIdsInColumn)=>amount + (Array.isArray(issueIdsInColumn) ? issueIdsInColumn.length : 0), 0);
const $2007c62349361047$export$605dc12eff71b2e5 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (filterObject)=>Object.keys(filterObject.values).length);
const $2007c62349361047$var$excludedFilters = [
    (0, $dcff40112356dfc1$export$d597759d33be802e),
    (0, $dcff40112356dfc1$export$ebb48b08205007c5)
];
const $2007c62349361047$export$2f80a678ff297046 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (filterObject)=>Object.keys(filterObject.values).filter((type)=>!$2007c62349361047$var$excludedFilters.includes(type)).length);
const $2007c62349361047$export$a7e88415a097d4e1 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$605dc12eff71b2e5
], (appliedWorkFiltersCount)=>appliedWorkFiltersCount > 0);
const $2007c62349361047$export$100f6402dcbc1c5 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (filterObject)=>filterObject.values[0, $dcff40112356dfc1$export$68d693c35a8d8866] !== undefined && filterObject.values[0, $dcff40112356dfc1$export$68d693c35a8d8866].length > 0);
const $2007c62349361047$export$18912e4e4d90673c = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (filters)=>{
    const filterText = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$d597759d33be802e)
    ], null);
    const filterLabels = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$37aee82a3cb1e8f7)
    ], null);
    if (!filterText && !filterLabels) return null;
    return {
        text: filterText,
        labels: filterLabels
    };
});
const $2007c62349361047$export$25cdb7cc38e01f95 = (0, $dGvGJ.createSelector)([
    (0, $4jZ56.getSwimlanes),
    (0, $45cXl.getSwimlaneMode),
    $2007c62349361047$export$8b37d0d4754c2222,
    $2007c62349361047$export$83704ff797ee645e,
    (0, $67Z81.getIsCMPBoard),
    (0, $67Z81.getIsIncrementPlanningBoard),
    $2007c62349361047$export$a7e88415a097d4e1
], (swimlanes, swimlaneMode, issueIdsBySwimlane, filteredIssue, isCMPBoard, isIncrementPlanningBoard, hasWorkFilters)=>{
    const subtaskSwimlaneFilter = ({ id: id, cardAmount: cardAmount })=>{
        if (isCMPBoard) {
            // do not render the bottom "Everything else" swimlane when there are no cards in it
            if (id === (0, $c79wa.ChildlessSwimlane).id && cardAmount > 0) return true;
            // render the swimlane header even it is empty
            if (filteredIssue.map((issue)=>String(issue.id)).includes(id)) return true;
            return false;
        }
        return id === (0, $c79wa.ChildlessSwimlane).id;
    };
    /*
		 * When grouping by Epic.
		 * remove the "issue without epic" swimlane when empty on a CMP board
		 * keep it on a TMP board
		 */ const epicSwimlaneFilter = ({ id: id, cardAmount: cardAmount })=>id === (0, $c79wa.ParentlessSwimlane).id && (isCMPBoard ? cardAmount > 0 : true);
    /*
		 * When grouping by Assignee.
		 * remove the "Unassigned" swimlane when empty on a CMP board
		 * keep it on a TMP board
		 */ const assigneeSwimlaneFilter = ({ id: id, cardAmount: cardAmount })=>id === (0, $c79wa.UnassignedSwimlane).id && (isCMPBoard ? cardAmount > 0 : true);
    /*
		 * When grouping by Team.
		 * show empty swimlanes only if there is no filters applied
		 * and the team is a plan team
		 */ const teamSwimlaneFilter = ({ values: swimlaneValues }, hasFilters)=>!hasFilters && swimlaneValues?.type === (0, $c79wa.TEAM) && swimlaneValues?.isPlanTeam;
    return swimlanes.map((swimlane)=>({
            id: swimlane.id,
            name: swimlane.name,
            issueKey: swimlane.issueKey,
            mode: swimlaneMode || '',
            message: swimlane.message,
            imageUrl: swimlane.imageUrl,
            cardAmount: $2007c62349361047$var$getCardAmount(swimlane.id, issueIdsBySwimlane),
            parentId: swimlane.parentId || null,
            values: swimlane.values,
            assigneeAccountId: swimlane.assigneeAccountId ?? null,
            projectKey: swimlane.projectKey ?? null,
            isFlagged: swimlane.isFlagged
        })).filter((swimlane)=>(swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE).id || swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST).id) && assigneeSwimlaneFilter(swimlane) || swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id && epicSwimlaneFilter(swimlane) || swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && subtaskSwimlaneFilter(swimlane) || isIncrementPlanningBoard && swimlaneMode === (0, $iuuJH.SWIMLANE_BY_TEAM).id && teamSwimlaneFilter(swimlane, hasWorkFilters) || swimlane.cardAmount > 0);
});
const $2007c62349361047$export$547cddb5216fa288 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$25cdb7cc38e01f95
], (swimlanes)=>{
    const platformSwimlane = (swimlaneId)=>swimlanes.find((swimlane)=>swimlane.id === swimlaneId);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(platformSwimlane);
});
const $2007c62349361047$export$258129f9697957ee = (0, $idNc7.createDeepEqualSelector)([
    (state)=>{
        const swimlanes = $2007c62349361047$export$25cdb7cc38e01f95(state);
        return swimlanes.map(({ id: id })=>id);
    }
], (swimlaneIds)=>swimlaneIds);
const $2007c62349361047$export$fe8e61f95247eb77 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$258129f9697957ee,
    (0, $4jZ56.getCollapsedSwimlanes)
], (swimlaneIds, collapsedSwimlanesIds)=>swimlaneIds.find((swimlaneId)=>!collapsedSwimlanesIds.includes(swimlaneId)));
const $2007c62349361047$export$f26c3b512bbb6d6d = (state, columnId)=>{
    if ((0, $ebHh7.hasNoActiveSprintStateSelector)(state)) return (0, $3kNE6.ColumnTheme).Default;
    const issuesCount = $2007c62349361047$export$42858dbfcc0ce9c6(state, columnId);
    const column = (0, $fyeGd.getColumnById)(state, columnId);
    if (column?.type === (0, $5rFbt.ColumnType).STATUS && column?.maxIssueCount != null && issuesCount > column?.maxIssueCount) return (0, $3kNE6.ColumnTheme).Danger;
    if (column?.type === (0, $5rFbt.ColumnType).STATUS && column?.minIssueCount != null && issuesCount < column?.minIssueCount) return (0, $3kNE6.ColumnTheme).Warning;
    return (0, $3kNE6.ColumnTheme).Default;
};
const $2007c62349361047$export$b7de3298691c708c = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$7b4d448d658d5a3b
], (columnUi)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnId)=>!!(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(columnUi, [
            columnId,
            'isUpdating'
        ], false)));
const $2007c62349361047$export$8b6be5e9a544d475 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$7b4d448d658d5a3b
], (columnUi)=>columnUi && Object.keys(columnUi).some((key)=>columnUi[key].isUpdating === true));
const $2007c62349361047$export$a80f3c30adc36a1b = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$8b6be5e9a544d475
], // Disable card drag if column updating or ICC is not complete
(anyColumnsUpdating)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((id)=>anyColumnsUpdating || id <= 0));
const $2007c62349361047$export$4b99acc1a687df2e = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode)
], (swimlaneMode)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((isLastSwimlane)=>!isLastSwimlane && swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id ? (0, $dcbb2bce513725b3$export$1f24f91824c6822f) : (0, $dcbb2bce513725b3$export$b05303cbde3e8c8c)));
const $2007c62349361047$export$1de4ece81cabd754 = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    (0, $9OPlz.getDraggingCardId),
    (0, $3UY9S.getIssueChildren)
], (swimlaneMode, draggingCardId, issueChildren)=>swimlaneMode !== (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && draggingCardId != null && draggingCardId in issueChildren);
const $2007c62349361047$export$9020a94481968b53 = (0, $dGvGJ.createSelector)([
    (0, $4jZ56.getSwimlanes),
    (0, $45cXl.getSwimlaneMode),
    (0, $vAfHD.boardIssuesSelector),
    (0, $9OPlz.getDraggingCardId),
    (0, $67Z81.getIsCMPBoard)
], (swimlanes, swimlaneMode, boardIssues, draggingCardId, isCMPBoard)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((isLastSwimlane)=>{
        const issue = boardIssues[String(draggingCardId)];
        const draggingCardSwimlaneId = (0, $bwTbl.getSwimlaneId)(swimlaneMode, swimlanes, issue);
        // For TMP: If parent issue is unmapped, subtasks will appear in last swimlane
        // subtask in last swimlane can transition only in that swimlane
        // also subtasks in other swimlane cannot transition to last swimlane
        return isLastSwimlane ? isCMPBoard || draggingCardSwimlaneId === (0, $c79wa.ChildlessSwimlane).id : draggingCardSwimlaneId !== (0, $c79wa.ChildlessSwimlane).id;
    }));
const $2007c62349361047$export$7ea0d3589e75ea3e = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (filters)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$ebb48b08205007c5)
    ], undefined));
const $2007c62349361047$export$66fc4c808781b0dd = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$7ea0d3589e75ea3e
], (issueTypes)=>{
    if (issueTypes && issueTypes.length) return Number((0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(issueTypes));
    return undefined;
});
const $2007c62349361047$export$a416adb3e931289c = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (filters)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$401f4b6eda6a369c)
    ], []));
const $2007c62349361047$export$fea75492585ff771 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (filters)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$db362e2d293fe52e)
    ], []));
const $2007c62349361047$export$b75a7d5a0b2593df = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$a416adb3e931289c
], (projects)=>{
    if (projects && projects.length) return Number((0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(projects));
    return undefined;
});
const $2007c62349361047$export$717522cf1f80bfcb = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (filters)=>!!(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$2a4f270075a033de)
    ], undefined)?.length);
const $2007c62349361047$export$a3e606d31ce14076 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac,
    (0, $36pz7.getAssigneeAccountIds),
    (0, $d2i8f.issueLabelsSelector),
    (0, $bSSdD.issueParentIdsSelector),
    (0, $d2i8f.issueProjectIdsSelector),
    (0, $d2i8f.issueTypeFilterSelector),
    (0, $d2i8f.requestTypesSelector),
    (0, $d2i8f.statusesSelector),
    (0, $ebHh7.activeSprintsSelector),
    $2007c62349361047$export$ada7918f4af738ad,
    (0, $67Z81.getIsCMPBoard)
], (filters, validAssigneeIds, validLabels, validIssueParentIds, validIssueProjectIds, validIssueTypes, validRequestTypes, validStatuses, activeSprints, customFilters, isCMPBoard)=>{
    const filterTypeWhitelist = [
        (0, $dcff40112356dfc1$export$37aee82a3cb1e8f7),
        (0, $dcff40112356dfc1$export$f8f7545d2bb78afb),
        (0, $dcff40112356dfc1$export$d597759d33be802e),
        (0, $dcff40112356dfc1$export$2a4f270075a033de),
        (0, $dcff40112356dfc1$export$401f4b6eda6a369c),
        (0, $dcff40112356dfc1$export$ebb48b08205007c5),
        (0, $dcff40112356dfc1$export$68d693c35a8d8866),
        (0, $dcff40112356dfc1$export$a316570a0dbfd2b0),
        (0, $dcff40112356dfc1$export$92ab80c1dc9baf44),
        (0, $dcff40112356dfc1$export$e50006273435e7d4),
        ...(0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') ? [
            (0, $dcff40112356dfc1$export$db362e2d293fe52e)
        ] : []
    ];
    const validFilters = {};
    if (filters.values[0, $dcff40112356dfc1$export$f8f7545d2bb78afb]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(validAssigneeIds, filters.values[0, $dcff40112356dfc1$export$f8f7545d2bb78afb]);
        if (inter.length > 0) validFilters[0, $dcff40112356dfc1$export$f8f7545d2bb78afb] = (0, $g5X3G.toAccountIdArray)(inter);
    }
    if (filters.values[0, $dcff40112356dfc1$export$37aee82a3cb1e8f7]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(validLabels, filters.values[0, $dcff40112356dfc1$export$37aee82a3cb1e8f7]);
        if (inter.length > 0) validFilters[0, $dcff40112356dfc1$export$37aee82a3cb1e8f7] = inter;
    }
    if (filters.values[0, $dcff40112356dfc1$export$2a4f270075a033de]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(validIssueParentIds, filters.values[0, $dcff40112356dfc1$export$2a4f270075a033de]);
        if (inter.length > 0) validFilters[0, $dcff40112356dfc1$export$2a4f270075a033de] = (0, $g5X3G.toIssueIdArray)(inter);
    }
    if (filters.values[0, $dcff40112356dfc1$export$401f4b6eda6a369c]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(validIssueProjectIds, filters.values[0, $dcff40112356dfc1$export$401f4b6eda6a369c]);
        if (inter.length > 0) validFilters[0, $dcff40112356dfc1$export$401f4b6eda6a369c] = (0, $g5X3G.toProjectIdArray)(inter);
    }
    if (filters.values[0, $dcff40112356dfc1$export$ebb48b08205007c5]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(validIssueTypes, filters.values[0, $dcff40112356dfc1$export$ebb48b08205007c5]);
        if (inter.length > 0) validFilters[0, $dcff40112356dfc1$export$ebb48b08205007c5] = (0, $g5X3G.toIssueTypeIdArray)(inter);
    }
    if (filters.values[0, $dcff40112356dfc1$export$92ab80c1dc9baf44]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(validRequestTypes.map(({ id: id })=>id), filters.values[0, $dcff40112356dfc1$export$92ab80c1dc9baf44]);
        if (inter.length > 0) validFilters[0, $dcff40112356dfc1$export$92ab80c1dc9baf44] = inter;
    }
    if (filters.values[0, $dcff40112356dfc1$export$e50006273435e7d4]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(validStatuses.map(({ id: id })=>id), filters.values[0, $dcff40112356dfc1$export$e50006273435e7d4]);
        if (inter.length > 0) validFilters[0, $dcff40112356dfc1$export$e50006273435e7d4] = inter;
    }
    if (filters.values[0, $dcff40112356dfc1$export$a316570a0dbfd2b0]) {
        const activeSprintIds = activeSprints?.map((sprint)=>String(sprint.id)) ?? [];
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(activeSprintIds, filters.values[0, $dcff40112356dfc1$export$a316570a0dbfd2b0]);
        if (inter.length > 0) validFilters[0, $dcff40112356dfc1$export$a316570a0dbfd2b0] = inter;
    }
    if (isCMPBoard && filters.values[0, $dcff40112356dfc1$export$68d693c35a8d8866]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(customFilters.map(({ id: id })=>id), filters.values[0, $dcff40112356dfc1$export$68d693c35a8d8866]);
        if (inter.length > 0) validFilters[0, $dcff40112356dfc1$export$68d693c35a8d8866] = inter;
    }
    if (filters.values[0, $dcff40112356dfc1$export$db362e2d293fe52e] && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(Object.values((0, $kIDH3.DependencyFilterOption)), filters.values[0, $dcff40112356dfc1$export$db362e2d293fe52e]);
        if (inter.length > 0) validFilters[0, $dcff40112356dfc1$export$db362e2d293fe52e] = inter;
    }
    Object.keys(filters.values).filter((filterType)=>!filterTypeWhitelist.includes(filterType)).forEach((notAllowedFilter)=>{
        throw new Error(`Please whitelist filter '${notAllowedFilter}' in work selectors`);
    });
    return validFilters;
});
const $2007c62349361047$export$333b83a56fe77194 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac,
    (0, $36pz7.getAssigneeAccountIds),
    (0, $d2i8f.issueLabelsSelector),
    (0, $bSSdD.issueParentIdsSelector),
    (0, $d2i8f.issueProjectIdsSelector),
    (0, $d2i8f.issueTypeFilterSelector),
    (0, $d2i8f.requestTypesSelector),
    (0, $d2i8f.statusesSelector),
    (0, $ebHh7.activeSprintsSelector),
    $2007c62349361047$export$ada7918f4af738ad,
    (0, $67Z81.getIsCMPBoard)
], (filters, validAssigneeIds, validLabels, validIssueParentIds, validIssueProjectIds, validIssueTypes, validRequestTypes, validStatuses, validSprints, validCustomFilters, isCMPBoard)=>{
    const filterTypeWhitelist = [
        (0, $dcff40112356dfc1$export$37aee82a3cb1e8f7),
        (0, $dcff40112356dfc1$export$f8f7545d2bb78afb),
        (0, $dcff40112356dfc1$export$d597759d33be802e),
        (0, $dcff40112356dfc1$export$2a4f270075a033de),
        (0, $dcff40112356dfc1$export$401f4b6eda6a369c),
        (0, $dcff40112356dfc1$export$ebb48b08205007c5),
        (0, $dcff40112356dfc1$export$68d693c35a8d8866),
        (0, $dcff40112356dfc1$export$a316570a0dbfd2b0),
        (0, $dcff40112356dfc1$export$92ab80c1dc9baf44),
        (0, $dcff40112356dfc1$export$e50006273435e7d4),
        ...(0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') ? [
            (0, $dcff40112356dfc1$export$db362e2d293fe52e)
        ] : []
    ];
    const invalidFilters = {};
    if (filters.values[0, $dcff40112356dfc1$export$f8f7545d2bb78afb]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters.values[0, $dcff40112356dfc1$export$f8f7545d2bb78afb], validAssigneeIds);
        if (diff.length > 0) invalidFilters[0, $dcff40112356dfc1$export$f8f7545d2bb78afb] = (0, $g5X3G.toAccountIdArray)(diff);
    }
    if (filters.values[0, $dcff40112356dfc1$export$37aee82a3cb1e8f7]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters.values[0, $dcff40112356dfc1$export$37aee82a3cb1e8f7], validLabels);
        if (diff.length > 0) invalidFilters[0, $dcff40112356dfc1$export$37aee82a3cb1e8f7] = diff;
    }
    if (filters.values[0, $dcff40112356dfc1$export$2a4f270075a033de]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters.values[0, $dcff40112356dfc1$export$2a4f270075a033de], validIssueParentIds);
        if (diff.length > 0) invalidFilters[0, $dcff40112356dfc1$export$2a4f270075a033de] = (0, $g5X3G.toIssueIdArray)(diff);
    }
    if (filters.values[0, $dcff40112356dfc1$export$401f4b6eda6a369c]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters.values[0, $dcff40112356dfc1$export$401f4b6eda6a369c], validIssueProjectIds);
        if (diff.length > 0) invalidFilters[0, $dcff40112356dfc1$export$401f4b6eda6a369c] = (0, $g5X3G.toProjectIdArray)(diff);
    }
    if (filters.values[0, $dcff40112356dfc1$export$ebb48b08205007c5]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters.values[0, $dcff40112356dfc1$export$ebb48b08205007c5], validIssueTypes);
        if (diff.length > 0) invalidFilters[0, $dcff40112356dfc1$export$ebb48b08205007c5] = (0, $g5X3G.toIssueTypeIdArray)(diff);
    }
    if (filters.values[0, $dcff40112356dfc1$export$92ab80c1dc9baf44]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters.values[0, $dcff40112356dfc1$export$92ab80c1dc9baf44], validRequestTypes.map(({ id: id })=>id));
        if (diff.length > 0) invalidFilters[0, $dcff40112356dfc1$export$92ab80c1dc9baf44] = diff;
    }
    if (filters.values[0, $dcff40112356dfc1$export$e50006273435e7d4]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters.values[0, $dcff40112356dfc1$export$e50006273435e7d4], validStatuses.map(({ id: id })=>id));
        if (diff.length > 0) invalidFilters[0, $dcff40112356dfc1$export$e50006273435e7d4] = diff;
    }
    if (filters.values[0, $dcff40112356dfc1$export$a316570a0dbfd2b0]) {
        const activeSprintIds = validSprints?.map((sprint)=>String(sprint.id)) ?? [];
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters.values[0, $dcff40112356dfc1$export$a316570a0dbfd2b0], activeSprintIds);
        if (diff.length > 0) invalidFilters[0, $dcff40112356dfc1$export$a316570a0dbfd2b0] = diff;
    }
    if (isCMPBoard && filters.values[0, $dcff40112356dfc1$export$68d693c35a8d8866]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters.values[0, $dcff40112356dfc1$export$68d693c35a8d8866], validCustomFilters.map(({ id: id })=>id));
        if (diff.length > 0) invalidFilters[0, $dcff40112356dfc1$export$68d693c35a8d8866] = diff;
    }
    if (filters.values[0, $dcff40112356dfc1$export$db362e2d293fe52e] && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters.values[0, $dcff40112356dfc1$export$db362e2d293fe52e], Object.values((0, $kIDH3.DependencyFilterOption)));
        if (diff.length > 0) invalidFilters[0, $dcff40112356dfc1$export$db362e2d293fe52e] = diff;
    }
    Object.keys(filters.values).filter((filterType)=>!filterTypeWhitelist.includes(filterType)).forEach((notAllowedFilter)=>{
        throw new Error(`Please whitelist filter '${notAllowedFilter}' in work selectors`);
    });
    return invalidFilters;
});
const $2007c62349361047$export$e5ce012c8ff94f67 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$333b83a56fe77194
], (invalidFilterValues)=>Object.keys(invalidFilterValues).length > 0);
const $2007c62349361047$export$8da24954392d0b6b = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getOrderedColumnIds),
    $2007c62349361047$export$83704ff797ee645e
], (columnIds, issues)=>{
    const issueIdsByColumnMap = {};
    columnIds.forEach((columnId)=>{
        const issuesIds = issues.filter((issue)=>issue.columnId === columnId).map((issue)=>issue.id);
        issueIdsByColumnMap[String(columnId)] = issuesIds;
    });
    return issueIdsByColumnMap;
});
const $2007c62349361047$export$b8bb2f4853de2d02 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$a05529bcb9c00a96,
    (0, $45cXl.getSwimlaneMode),
    (0, $4jZ56.getSwimlanes)
], (issues, swimlaneMode, swimlanes)=>{
    if (!swimlaneMode || swimlaneMode === (0, $iuuJH.NO_SWIMLANE).id) return {};
    const issuesBySwimlane = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(issues, (issue)=>issue.swimlaneId);
    swimlanes.forEach(({ id: id })=>{
        if (issuesBySwimlane[id] === undefined) issuesBySwimlane[id] = [];
    });
    return Object.keys(issuesBySwimlane).reduce((accum, swimlaneId)=>{
        const issuesInSwimlane = issuesBySwimlane[swimlaneId];
        const issuesByColumnId = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(issuesInSwimlane, (issue)=>issue.columnId);
        // eslint-disable-next-line no-param-reassign
        accum[swimlaneId] = issuesByColumnId;
        return accum;
    }, {});
});
const $2007c62349361047$export$76423ca425841ce3 = (0, $dGvGJ.createSelector)([
    (0, $4jZ56.getSwimlanes),
    (0, $67Z81.getOrderedColumnIds),
    $2007c62349361047$export$b8bb2f4853de2d02,
    $2007c62349361047$export$b6964ddef57f801
], (swimlanes, columnIds, issuesBySwimlane, platformIssues)=>{
    // If there are any swimlanes, we need to call a different selector and handle it very differently
    if (swimlanes.length > 0) // NOTE that we use the swimlanes array here instead of the dictionary returned. This
    // is to preserve the ordering of the swimlanes AS they are rendered/displayed on screen.
    return columnIds.map((columnId)=>swimlanes.filter((swimlane)=>swimlane.id in issuesBySwimlane).flatMap((swimlane)=>issuesBySwimlane[swimlane.id][columnId] ?? []).map((issue)=>issue.key));
    // Otherwise we just grab all filtered issues and return them in the correct shape
    return columnIds.map((columnId)=>platformIssues.filter((issue)=>issue.columnId === columnId).map((issue)=>issue.key));
});
const $2007c62349361047$var$getCardAmountByColumn = (issueCountPerColumn, limit)=>{
    let remainingCards = limit;
    let columnCount = issueCountPerColumn.length;
    return issueCountPerColumn.map(({ key: key, amount: amount })=>{
        const columnLimit = Math.min(amount, Math.ceil(remainingCards / columnCount));
        columnCount -= 1;
        remainingCards -= columnLimit;
        return {
            key: key,
            amount: columnLimit
        };
    });
};
const $2007c62349361047$var$getTruncatedIssueIdsBySortedColumns = (issueIdsByColumn, limit)=>{
    // Sort column by issue count in ascending order so we handle the column with the least cards first.
    // This ensures that we do not have empty columns where there should be issues.
    const sortedIssueCountPerColumn = Object.keys(issueIdsByColumn).map((column)=>({
            key: column,
            amount: (0, $g5X3G.values)(issueIdsByColumn[column]).flat().length
        })).sort((a, b)=>Number(a.amount) - Number(b.amount));
    // Calculate the number of cards allowed in each column
    const allowedCardCountPerColumn = $2007c62349361047$var$getCardAmountByColumn(sortedIssueCountPerColumn, limit);
    // Populate mapping of swimlane to columns to issues with number of issues from the calculated limits
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const issueIdsByColumnWithLimit = {};
    allowedCardCountPerColumn.map(({ key: key, amount: amount })=>({
            column: key,
            columnIssueLimit: amount
        })).forEach(({ column: column, columnIssueLimit: columnIssueLimit })=>{
        issueIdsByColumnWithLimit[column] = issueIdsByColumn[column].slice(0, columnIssueLimit);
    });
    return issueIdsByColumnWithLimit;
};
const $2007c62349361047$export$c42e69e614304b3b = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$8da24954392d0b6b
], (issueIdsByColumn)=>$2007c62349361047$var$getTruncatedIssueIdsBySortedColumns(issueIdsByColumn, (0, $dcbb2bce513725b3$export$2683a6b6da85de4d)));
const $2007c62349361047$export$ee662c5bb14e469c = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$8b37d0d4754c2222,
    (0, $4jZ56.getSwimlanes)
], (issueIdsBySwimlane, swimlanes)=>{
    // Get a list of pairings that contain swimlane id and the calculate the number of cards allowed
    // per swimlane considering the SSR card limit. We want to greedily assign the number of cards up
    // to the limit rather than equally spreading cards among swimlanes.
    let remainingCards = (0, $dcbb2bce513725b3$export$2683a6b6da85de4d);
    const allowedCardCountPerSwimlane = swimlanes.map(({ id: id })=>({
            key: id,
            amount: (0, $g5X3G.values)(issueIdsBySwimlane[id]).flat().length
        })).map(({ key: key, amount: amount })=>{
        const swimlaneLimit = Math.min(amount, remainingCards);
        remainingCards -= swimlaneLimit;
        return {
            key: key,
            amount: swimlaneLimit
        };
    });
    // For each swimlane, iterate through each column to calculate how many and which cards to select
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const truncatedIssueIdsBySwimlane = {};
    allowedCardCountPerSwimlane.map(({ key: key, amount: amount })=>({
            swimlane: key,
            swimlaneIssueLimit: amount
        })).forEach(({ swimlane: swimlane, swimlaneIssueLimit: swimlaneIssueLimit })=>{
        truncatedIssueIdsBySwimlane[swimlane] = $2007c62349361047$var$getTruncatedIssueIdsBySortedColumns(issueIdsBySwimlane[swimlane], swimlaneIssueLimit);
    });
    return truncatedIssueIdsBySwimlane;
});
const $2007c62349361047$export$a3d88d5fd2477a5c = (state, columnId)=>{
    const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
    if (!swimlaneMode || swimlaneMode === (0, $iuuJH.NO_SWIMLANE).id) return $2007c62349361047$export$c42e69e614304b3b(state)[String(columnId)].length;
    const issueIdsBySwimlane = $2007c62349361047$export$ee662c5bb14e469c(state);
    return Object.keys(issueIdsBySwimlane).map((swimlaneId)=>issueIdsBySwimlane[swimlaneId]).reduce((acc, issueIdsByColumn)=>acc + (issueIdsByColumn[String(columnId)]?.length || 0), 0);
};
const $2007c62349361047$export$4dfb307b48a9ff4b = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac,
    (0, $67Z81.getIsIncrementPlanningBoard)
], (filters, isIncrementPlanningBoard)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$2a4f270075a033de)
    ], []).map((issueParentId)=>// Scenario parent ids are strings on the program board
        isIncrementPlanningBoard ? issueParentId : Number(issueParentId)));
const $2007c62349361047$export$8fc92f4a10e91c3b = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$4dfb307b48a9ff4b,
    (0, $67Z81.getIsIncrementPlanningBoard)
], (filteredIssueParentIds, isIncrementPlanningBoard)=>{
    if (isIncrementPlanningBoard) {
        const lastFiltered = !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filteredIssueParentIds) ? (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(filteredIssueParentIds) : null;
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(lastFiltered) ? lastFiltered : null;
    }
    return !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filteredIssueParentIds) ? Number((0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(filteredIssueParentIds)) : null;
});
const $2007c62349361047$export$6d848ac469f8f1d5 = (0, $dGvGJ.createSelector)((0, $d2i8f.makeIssueDevStatusSelector), (issueDevStatusSelector)=>(0, $8QpSo.default)((workData)=>({
            ...workData,
            issues: issueDevStatusSelector(workData.issues)
        })));
const $2007c62349361047$export$fc04e99ac3563a66 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$83704ff797ee645e
], (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((id)=>issues.some((issue)=>issue.id === id)));
const $2007c62349361047$export$bacbd1cd61f6f690 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac,
    $2007c62349361047$export$f496179039a6c96a,
    (0, $67Z81.getIssues),
    (0, $36pz7.getPeople)
], (workFilters, issues, issueHash, people)=>{
    const visibleIssueIds = (0, $iGIww.filter)(workFilters.values, issues, issueHash, people).map((issue)=>issue.id);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueIds)=>issueIds.filter((issueId)=>!visibleIssueIds.includes(issueId)));
});
const $2007c62349361047$export$675ae7d7d995e6cd = (0, $dGvGJ.createSelector)($2007c62349361047$export$83704ff797ee645e, (workFilteredIssues)=>{
    const visibleIssueKeys = workFilteredIssues.map((issue)=>issue.key);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueKeys)=>issueKeys.filter((issueKey)=>!visibleIssueKeys.includes(issueKey)));
});
const $2007c62349361047$export$2c3764a24d5a77a5 = (state)=>state.ui.cards.cardWithIcc.mainActiveIssue;
const $2007c62349361047$export$45f354b7131bf0a2 = (0, $dGvGJ.createSelector)([
    (state, props)=>props.issueId,
    (state)=>$2007c62349361047$export$2c3764a24d5a77a5(state)
], (targetIssueId, activeIssueId)=>targetIssueId === activeIssueId);
const $2007c62349361047$export$1f1c155fbe31f55a = (0, $dGvGJ.createSelector)([
    (state, props)=>props.issueId,
    (state)=>(0, $9OPlz.getIssueIdWithAboveICCOpen)(state),
    (state)=>$2007c62349361047$export$2c3764a24d5a77a5(state),
    (state)=>(0, $d2i8f.getOrderedIssuesByColumn)(state),
    (state)=>$2007c62349361047$export$8da24954392d0b6b(state)
], (targetIssueId, issueIdWithAboveICCOpen, activeIssueId, orderedIssuesByColumn, getVisibleIssuesForColumn)=>{
    if (issueIdWithAboveICCOpen != null && issueIdWithAboveICCOpen === targetIssueId) return true;
    if (!activeIssueId) return false;
    if (targetIssueId === activeIssueId) return true;
    const activeColumn = Object.entries(orderedIssuesByColumn).find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, issues])=>Array.isArray(issues) && issues.find((issue)=>{
            // Flow currently doesn't keep types when Object.entries() is used
            // https://github.com/facebook/flow/issues/2174
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            const typedIssue = issue;
            return typedIssue.id === activeIssueId;
        }));
    if (!activeColumn) return false;
    const [activeColumnId] = activeColumn;
    const visibleIssuesOfActiveColumn = getVisibleIssuesForColumn[activeColumnId];
    if (!Array.isArray(visibleIssuesOfActiveColumn)) return false;
    const activeIssueIndex = visibleIssuesOfActiveColumn.indexOf(activeIssueId);
    const targetIssueIndex = visibleIssuesOfActiveColumn.indexOf(targetIssueId);
    return activeIssueIndex !== -1 && targetIssueIndex !== -1 && targetIssueIndex === activeIssueIndex + 1;
});
const $2007c62349361047$var$getIssuesIdsByColumn = (state, { swimlaneId: swimlaneId, isUnscheduledWorkColumn: isUnscheduledWorkColumn })=>{
    // In the Program Board, the unscheduled work column adds an additional suffix to the id of the
    // swimlane so that the swimlane collapse behaviour can be independent between the board and the
    // unscheduled work column. For all other column behaviour, we want to truncate this suffix.
    const swimlaneIdTruncated = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(swimlaneId) ? (0, $kgiLc.truncateUnscheduledWorkSwimlaneId)(swimlaneId, isUnscheduledWorkColumn) : swimlaneId;
    if (false) return (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(swimlaneIdTruncated) ? $2007c62349361047$export$c42e69e614304b3b(state) : $2007c62349361047$export$ee662c5bb14e469c(state)[swimlaneIdTruncated];
    return (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(swimlaneIdTruncated) ? $2007c62349361047$export$8da24954392d0b6b(state) : $2007c62349361047$export$8b37d0d4754c2222(state)[swimlaneIdTruncated];
};
const $2007c62349361047$export$9c38ecda34a0899c = (0, $dGvGJ.createSelector)([
    (state, props)=>props.columnId,
    $2007c62349361047$var$getIssuesIdsByColumn
], (columnId, issueIdsByColumn)=>issueIdsByColumn && issueIdsByColumn[String(columnId)]);
const $2007c62349361047$export$138c2389bbf22c2d = ()=>(0, $idNc7.createDeepEqualSelector)([
        $2007c62349361047$export$9c38ecda34a0899c,
        (0, $67Z81.getIsCMPBoard),
        (0, $45cXl.getSwimlaneMode),
        (0, $3UY9S.getParentIdByIssueChildSelector),
        (0, $bSSdD.issueParentIdsSelector),
        (0, $67Z81.isBoardRankable)
    ], (issueIds, isCMPBoard, swimlaneMode, getParentIdByIssueChild, issueParentIds, isRankable)=>{
        const skipGroupingChildren = !isCMPBoard || swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id;
        if (skipGroupingChildren) return issueIds?.map((issueId)=>({
                type: 'issue',
                issueId: issueId
            }));
        const issueEntries = [];
        if (!isRankable) {
            // Filter out issue children which has parent. As it should be rendered in a group
            const shouldRenderInCardGroup = (issueId)=>!!getParentIdByIssueChild(issueId);
            // An Epics are rendered as the swimlane headers when grouped by Epic
            // Otherwise Epics are rendered as cards
            const shouldRenderAsSwimlaneHeader = (issueId)=>swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id && issueParentIds.includes(String(issueId));
            issueIds?.forEach((issueId)=>{
                if (!shouldRenderInCardGroup(issueId) && !shouldRenderAsSwimlaneHeader(issueId)) {
                    issueEntries.push({
                        type: 'issue',
                        issueId: issueId
                    });
                    return;
                }
                const parentId = getParentIdByIssueChild(issueId);
                if (!parentId) return;
                const previousItem = issueEntries[issueEntries.length - 1];
                if (previousItem?.type === 'group' && previousItem.parentId === parentId) {
                    previousItem.issueIds.push(issueId);
                    return;
                }
                const group = {
                    type: 'group',
                    parentId: parentId,
                    issueIds: [
                        issueId
                    ],
                    isAttachedToParent: isRankable ? issueIds.includes(parentId) : previousItem?.type === 'issue' && previousItem.issueId === parentId
                };
                issueEntries.push(group);
            });
        } else {
            // Filter out issue children and issue parents if swimlane by epic
            const nonChildIssueIds = (issueIds || []).filter((issueId)=>!getParentIdByIssueChild(issueId) && (swimlaneMode !== (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id || !issueParentIds.includes(String(issueId))));
            const childIssueIds = (issueIds || []).filter((issue)=>!!getParentIdByIssueChild(issue));
            const childIdsByParent = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(childIssueIds, getParentIdByIssueChild);
            issueIds?.forEach((issueId)=>{
                if (nonChildIssueIds.includes(issueId)) {
                    issueEntries.push({
                        type: 'issue',
                        issueId: issueId
                    });
                    return;
                }
                const parentId = getParentIdByIssueChild(issueId);
                if (!parentId || !(parentId in childIdsByParent)) return;
                issueEntries.push({
                    type: 'group',
                    parentId: parentId,
                    issueIds: childIdsByParent[parentId],
                    isAttachedToParent: nonChildIssueIds.includes(parentId)
                });
                delete childIdsByParent[parentId];
            });
        }
        return issueEntries;
    });
const $2007c62349361047$var$filteredInIssuesById = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$83704ff797ee645e
], (filteredIssues)=>(0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(filteredIssues, 'id'));
const $2007c62349361047$export$d7699a71638fd9d4 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$var$filteredInIssuesById
], (issues)=>{
    const issuesWithIssueLinks = (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))(issues, (issue)=>issue.issueLinks && issue.issueLinks.length > 0 && issue.columnId !== (0, $5rFbt.UNSCHEDULED_COLUMN_ID));
    return issuesWithIssueLinks;
});
const $2007c62349361047$export$1e1a7e899f73dc6f = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$d7699a71638fd9d4
], (issuesEntriesWithIssueLinksInBoard)=>{
    return Object.keys(issuesEntriesWithIssueLinksInBoard);
});
const $2007c62349361047$export$b11164626e861e2e = (columnId, swimlaneId)=>`${columnId}:${swimlaneId ?? (0, $iuuJH.NO_SWIMLANE).id}`;
const $2007c62349361047$export$cc6f4dd9bb04ac0a = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector)
], (issues)=>(issueId)=>issues[String(issueId)]?.columnId);
const $2007c62349361047$export$db5d57ea014e1a9f = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $45cXl.getSwimlaneMode),
    (0, $4jZ56.getSwimlanes),
    (0, $67Z81.getIsCMPBoard)
], (issues, swimlaneMode, availableSwimlanes, isCMPBoard)=>(boardIssueId)=>{
        const issue = issues[String(boardIssueId)];
        if (!issue) return null;
        return (0, $bwTbl.getSwimlaneId)(swimlaneMode, availableSwimlanes, issue, isCMPBoard, (issueId)=>issues[issueId]);
    });
const $2007c62349361047$export$5c4dc04d949c48c3 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$var$getIssueById,
    (0, $67Z81.getStatuses)
], (issue, statuses)=>statuses[issue.statusId]);
const $2007c62349361047$export$98d29ba803e92a0e = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$2c3764a24d5a77a5,
    (0, $vAfHD.makeGetIssueKeyFromIssueId)
], (activeIssueId, issueKeyFromIssueId)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeIssueId)) return null;
    return issueKeyFromIssueId(activeIssueId);
});
const $2007c62349361047$export$78a44af01b2680d = (0, $dGvGJ.createSelector)([
    (0, $bSSdD.getIssueParents),
    $2007c62349361047$export$547cddb5216fa288
], (issueParents, swimlaneSelector)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((swimlaneId)=>{
        const { mode: mode, parentId: parentId } = swimlaneSelector(swimlaneId) || {};
        if (mode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && parentId) return issueParents[parentId] || null;
        if (mode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id) return issueParents[swimlaneId] || null;
        return null;
    }));

});
parcelRegister("hm7zS", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/** Used for built-in method references. */ var $ca2a5e84e2b42ea9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ca2a5e84e2b42ea9$var$hasOwnProperty = $ca2a5e84e2b42ea9$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */ var $ca2a5e84e2b42ea9$var$countBy = $4CZTG(function(result, value, key) {
    if ($ca2a5e84e2b42ea9$var$hasOwnProperty.call(result, key)) ++result[key];
    else $1m3dq(result, key, 1);
});
module.exports = $ca2a5e84e2b42ea9$var$countBy;

});

parcelRegister("4Xk2W", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $39bc38f0156cacc0$var$keyBy = $4CZTG(function(result, value, key) {
    $1m3dq(result, key, value);
});
module.exports = $39bc38f0156cacc0$var$keyBy;

});

parcelRegister("dPSWJ", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $hDnyx = parcelRequire("hDnyx");

var $bxDef = parcelRequire("bxDef");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $a12aa8fd8ab9a7da$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $bxDef(iteratee, 3);
    $hDnyx(object, function(value, key, object) {
        $1m3dq(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $a12aa8fd8ab9a7da$var$mapValues;

});

parcelRegister("kIDH3", function(module, exports) {

$parcel$export(module.exports, "DependencyFilterOption", () => $ddac187df0965772$export$499848eca2db01cf);
const $ddac187df0965772$export$499848eca2db01cf = {
    OFF_TRACK: 'off-track',
    ON_TRACK: 'on-track'
};

});

parcelRegister("645AZ", function(module, exports) {

$parcel$export(module.exports, "layout", () => $a67c0a983b5112a4$export$b3219800bda33a1f);
$parcel$export(module.exports, "colors", () => $a67c0a983b5112a4$export$8f45430ccf837300);
$parcel$export(module.exports, "zIndex", () => $a67c0a983b5112a4$export$56446adcecbeec34);
$parcel$export(module.exports, "columnHeaderHeight", () => $a67c0a983b5112a4$export$b10d8d0737c2bc95);
$parcel$export(module.exports, "columnFixedWidth", () => $a67c0a983b5112a4$export$fa05dc858c5009bb);
$parcel$export(module.exports, "columnMinWidth", () => $a67c0a983b5112a4$export$dc572e5846332cb1);
$parcel$export(module.exports, "columnWithMarginWidth", () => $a67c0a983b5112a4$export$28e72c3a8a93ac77);
$parcel$export(module.exports, "columnMinWithMarginWidth", () => $a67c0a983b5112a4$export$f47ba5aa0a13b432);
$parcel$export(module.exports, "columnHeaderFontSize", () => $a67c0a983b5112a4$export$bc68d684b3f68e0);
$parcel$export(module.exports, "swimlaneHeaderHeight", () => $a67c0a983b5112a4$export$b12ee424ee8005de);
$parcel$export(module.exports, "minCardHeight", () => $a67c0a983b5112a4$export$9c20cef8efa8ff1c);
$parcel$export(module.exports, "miniMapMapHeight", () => $a67c0a983b5112a4$export$73febd7a1d3f7041);
$parcel$export(module.exports, "collapsedColumnFixedWidth", () => $a67c0a983b5112a4$export$7709c197eb61e438);
$parcel$export(module.exports, "collapsedColumnWithMarginWidth", () => $a67c0a983b5112a4$export$a18d33b11d25b5c7);
$parcel$export(module.exports, "scrollbarWidth", () => $a67c0a983b5112a4$export$14c8a45ff6da16d);
$parcel$export(module.exports, "unscheduledColumnWidth", () => $a67c0a983b5112a4$export$e635defc4ff8e744);
$parcel$export(module.exports, "unscheduledColumnHeaderHeight", () => $a67c0a983b5112a4$export$1f19522691bf7df6);
// eslint-disable-next-line import/order

var $gwIPs = parcelRequire("gwIPs");
const $a67c0a983b5112a4$export$b3219800bda33a1f = {
    gutter: 10,
    smallGutter: 5,
    cardRadius: 3,
    cardListRadius: 6,
    adg3smallGutter: 8,
    columnMargin: 6,
    boardBorderWidth: (0, $gwIPs.contentHorizontalSpacing)
};
const $a67c0a983b5112a4$export$8f45430ccf837300 = {
    shadow: "var(--ds-border, rgba(0, 0, 0, 0.2))"
};
const $a67c0a983b5112a4$export$56446adcecbeec34 = {
    // Inside board
    boardBorders: 90,
    minimap: 6,
    cardDoneRipple: 5,
    transitionZoneIndicator: 5,
    stickyHeaders: 4,
    swimlaneTickMask: 3,
    stickySwimlaneBar: 2,
    icc: 1,
    transitionZones: 1,
    fullColumnHeightTransitionZones: 3
};
const $a67c0a983b5112a4$export$b10d8d0737c2bc95 = 32 + 2 * $a67c0a983b5112a4$export$b3219800bda33a1f.adg3smallGutter;
const $a67c0a983b5112a4$export$fa05dc858c5009bb = 270;
const $a67c0a983b5112a4$export$dc572e5846332cb1 = 150;
const $a67c0a983b5112a4$export$28e72c3a8a93ac77 = $a67c0a983b5112a4$export$fa05dc858c5009bb + $a67c0a983b5112a4$export$b3219800bda33a1f.columnMargin * 2;
const $a67c0a983b5112a4$export$f47ba5aa0a13b432 = $a67c0a983b5112a4$export$dc572e5846332cb1 + $a67c0a983b5112a4$export$b3219800bda33a1f.columnMargin * 2;
const $a67c0a983b5112a4$export$bc68d684b3f68e0 = 12;
const $a67c0a983b5112a4$export$b12ee424ee8005de = 24 + 2 * $a67c0a983b5112a4$export$b3219800bda33a1f.adg3smallGutter;
const $a67c0a983b5112a4$export$9c20cef8efa8ff1c = (0, $gwIPs.gridSize) * 10;
const $a67c0a983b5112a4$export$73febd7a1d3f7041 = 36;
const $a67c0a983b5112a4$export$7709c197eb61e438 = 40;
const $a67c0a983b5112a4$export$a18d33b11d25b5c7 = $a67c0a983b5112a4$export$7709c197eb61e438 + $a67c0a983b5112a4$export$b3219800bda33a1f.columnMargin * 2;
const $a67c0a983b5112a4$export$14c8a45ff6da16d = '10px';
const $a67c0a983b5112a4$export$e635defc4ff8e744 = '270px';
const $a67c0a983b5112a4$var$unscheduledColumnTitleHeight = 20;
const $a67c0a983b5112a4$export$1f19522691bf7df6 = $a67c0a983b5112a4$export$b12ee424ee8005de + $a67c0a983b5112a4$var$unscheduledColumnTitleHeight;

});

parcelRegister("3kNE6", function(module, exports) {

$parcel$export(module.exports, "ColumnTheme", () => $355fce6f5fc0d1f0$export$18d9d841e20106b9);
const $355fce6f5fc0d1f0$export$18d9d841e20106b9 = {
    Default: 'default',
    Warning: 'warning',
    Danger: 'danger'
};

});

parcelRegister("esu6n", function(module, exports) {

$parcel$export(module.exports, "getStatusColumn", () => $91f4bd490f381404$export$f9a77580ef71cadc);
$parcel$export(module.exports, "getDateRangeColumn", () => $91f4bd490f381404$export$cddf68fa5ecd76f1);
$parcel$export(module.exports, "isUnscheduledColumn", () => $91f4bd490f381404$export$2131c06200a944a9);

var $5rFbt = parcelRequire("5rFbt");
const $91f4bd490f381404$export$f9a77580ef71cadc = (column)=>column?.type === (0, $5rFbt.ColumnType).STATUS ? column : null;
const $91f4bd490f381404$export$cddf68fa5ecd76f1 = (column)=>column?.type === (0, $5rFbt.ColumnType).DATE_RANGE ? column : null;
const $91f4bd490f381404$export$2131c06200a944a9 = (column)=>column?.type === (0, $5rFbt.ColumnType).DATE_RANGE && column?.id === (0, $5rFbt.UNSCHEDULED_COLUMN_ID);

});

parcelRegister("kgiLc", function(module, exports) {

$parcel$export(module.exports, "transformDateValue", () => $06446ad58bef335e$export$baa3b72fc17cd5bb);
$parcel$export(module.exports, "transformDateRangeUpdateValues", () => $06446ad58bef335e$export$93f7fa7e723c5db9);
$parcel$export(module.exports, "wrapActionWithPromise", () => $06446ad58bef335e$export$d933127b5630afb0);
$parcel$export(module.exports, "truncateUnscheduledWorkSwimlaneId", () => $06446ad58bef335e$export$728fdc4d4544b775);
$parcel$export(module.exports, "appendUnscheduledWorkSwimlaneIdSuffix", () => $06446ad58bef335e$export$1ca85b4c3d462fa1);

var $hGgHi = parcelRequire("hGgHi");

var $1QDGC = parcelRequire("1QDGC");

const $06446ad58bef335e$export$baa3b72fc17cd5bb = (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) || value === 0 ? null : value;
const $06446ad58bef335e$export$93f7fa7e723c5db9 = (incrementConfig, startDate, endDate)=>{
    let dateFields = {};
    if (startDate !== undefined) {
        const startDateValue = {
            [incrementConfig.startDateField.key]: startDate
        };
        if (incrementConfig.startDateField.type === (0, $1QDGC.FieldType).Custom) dateFields.customFields = startDateValue;
        else dateFields = startDateValue;
    }
    const endDateValue = {
        [incrementConfig.endDateField.key]: endDate
    };
    if (incrementConfig.endDateField.type === (0, $1QDGC.FieldType).Custom) {
        if (dateFields.customFields) dateFields.customFields = {
            ...dateFields.customFields,
            ...endDateValue
        };
        else dateFields.customFields = endDateValue;
    } else dateFields = {
        ...dateFields,
        ...endDateValue
    };
    return dateFields;
};
const $06446ad58bef335e$export$d933127b5630afb0 = (dispatch, action)=>{
    const promise = new Promise((resolve, reject)=>{
        dispatch({
            ...action,
            promise: {
                resolve: resolve,
                reject: reject
            }
        });
    });
    return promise;
};
const $06446ad58bef335e$export$728fdc4d4544b775 = (swimlaneId, isUnscheduledColumn)=>isUnscheduledColumn && swimlaneId.endsWith((0, $7e733a5d4e4331fc$export$184668482d48a5f3)) ? swimlaneId.slice(0, -(0, $7e733a5d4e4331fc$export$184668482d48a5f3).length) : swimlaneId;
const $06446ad58bef335e$export$1ca85b4c3d462fa1 = (swimlaneId)=>`${swimlaneId}${0, $7e733a5d4e4331fc$export$184668482d48a5f3}`;

});
parcelRegister("1QDGC", function(module, exports) {

$parcel$export(module.exports, "FieldType", () => $cc6f4fa8362b8e89$export$ed12481c953b8653);
const $cc6f4fa8362b8e89$export$ed12481c953b8653 = {
    BuiltIn: 'BuiltIn',
    Custom: 'Custom'
};

});


const $dcff40112356dfc1$export$d597759d33be802e = 'TEXT';
const $dcff40112356dfc1$export$f8f7545d2bb78afb = 'ASSIGNEE';
const $dcff40112356dfc1$export$37aee82a3cb1e8f7 = 'LABEL';
const $dcff40112356dfc1$export$2a4f270075a033de = 'ISSUE_PARENT';
const $dcff40112356dfc1$export$401f4b6eda6a369c = 'ISSUE_PROJECT';
const $dcff40112356dfc1$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $dcff40112356dfc1$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $dcff40112356dfc1$export$e50006273435e7d4 = 'STATUS';
const $dcff40112356dfc1$export$68d693c35a8d8866 = 'CUSTOM_FILTER';
const $dcff40112356dfc1$export$a316570a0dbfd2b0 = 'SPRINT';
const $dcff40112356dfc1$export$db362e2d293fe52e = 'DEPENDENCIES';

const $7455914ed26b7de2$export$a57c8b25e45b243f = 'footer';
const $7455914ed26b7de2$export$428a1825e984a589 = 84;
const $7455914ed26b7de2$export$3eeaa9cdb48b7cc4 = 'virtual_list_dnd_key';
const $7455914ed26b7de2$export$a6188c2645d6aef3 = 260;
const $7455914ed26b7de2$export$a93995a3737ff205 = 40;

parcelRegister("idNc7", function(module, exports) {

$parcel$export(module.exports, "createDeepEqualSelector", () => $d29ef4afb46b16e9$export$4b5ed82e6a727aff);

var $dGvGJ = parcelRequire("dGvGJ");

var $ajpes = parcelRequire("ajpes");
const $d29ef4afb46b16e9$export$4b5ed82e6a727aff = (0, $dGvGJ.createSelectorCreator)((0, $dGvGJ.defaultMemoize), (0, (/*@__PURE__*/$parcel$interopDefault($ajpes))));

});

parcelRegister("iGIww", function(module, exports) {

$parcel$export(module.exports, "filter", () => $e34fce1c7e0a982f$export$3dea766d36a8935f);

var $hGgHi = parcelRequire("hGgHi");

var $4R6GH = parcelRequire("4R6GH");

var $g5X3G = parcelRequire("g5X3G");

var $dVREV = parcelRequire("dVREV");
const $e34fce1c7e0a982f$export$79e3f18eafd008ab = (issue)=>Number(issue.id) < 0;
const $e34fce1c7e0a982f$export$3dea766d36a8935f = (filterValues, issues, issueHash, people, filteredIssueIds)=>{
    const toFilterableIssue = ({ id: id, key: key, summary: summary, labels: labels, typeId: typeId, typeName: typeName, parentId: parentId, assigneeAccountId: assigneeAccountId, requestTypeId: requestTypeId, statusId: statusId, sprintId: sprintId, projectId: projectId, issueLinks: issueLinks })=>{
        const assignee = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(assigneeAccountId) && assigneeAccountId in people ? {
            id: (0, $g5X3G.toAccountId)(assigneeAccountId),
            displayName: (0, $g5X3G.toDisplayName)(people[assigneeAccountId].displayName)
        } : undefined;
        return {
            id: (0, $g5X3G.toIssueId)(id.toString()),
            key: (0, $g5X3G.toIssueKey)(key),
            summary: summary,
            labels: labels,
            type: {
                id: (0, $g5X3G.toIssueTypeId)(typeId.toString()),
                name: typeName
            },
            parentId: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(parentId) ? (0, $g5X3G.toIssueId)(parentId.toString()) : undefined,
            requestTypeId: requestTypeId,
            statusId: statusId != null ? (0, $g5X3G.toIssueStatusId)(String(statusId)) : undefined,
            assignee: assignee,
            sprintId: sprintId,
            projectId: (0, $g5X3G.toProjectId)(projectId.toString()),
            hasOfftrackDependency: (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') ? issueLinks?.some((link)=>link.isOfftrack) : false,
            hasOntrackDependency: (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') ? issueLinks?.some((link)=>!link.isOfftrack) : false
        };
    };
    const filterableIssues = Object.keys(issueHash).map((id)=>toFilterableIssue(issueHash[id]));
    const filterableIssuesHash = filterableIssues.reduce((acc, filterableIssue)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(filterableIssue.id)) return acc;
        acc[`${filterableIssue.id}`] = filterableIssue;
        return acc;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});
    const filterFunction = (0, $dVREV.createFilterFunction)(filterValues, {
        issues: {
            list: filterableIssues,
            hash: filterableIssuesHash
        },
        filteredIssueIds: filteredIssueIds
    }, (0, $dVREV.createDefaultMatcherCreators)(), [
        $e34fce1c7e0a982f$export$79e3f18eafd008ab
    ]);
    return issues.filter((issue)=>{
        const filterableIssue = filterableIssuesHash[issue.id] ?? toFilterableIssue(issue);
        return filterFunction(filterableIssue);
    });
};

});
parcelRegister("dVREV", function(module, exports) {

$parcel$export(module.exports, "createDefaultMatcherCreators", () => $da698aa4f276c01f$export$551eb27bf5bd708);
$parcel$export(module.exports, "createFilterFunction", () => $da698aa4f276c01f$export$5b4da3e2bd753e6);


var $83R7M = parcelRequire("83R7M");

var $9NUFF = parcelRequire("9NUFF");

var $bOpxF = parcelRequire("bOpxF");

var $2Ol4g = parcelRequire("2Ol4g");

var $kSow3 = parcelRequire("kSow3");

var $91AxA = parcelRequire("91AxA");

var $8wcaA = parcelRequire("8wcaA");

var $7vODb = parcelRequire("7vODb");

var $bliRS = parcelRequire("bliRS");

var $iZeAQ = parcelRequire("iZeAQ");

var $ly5rg = parcelRequire("ly5rg");

var $4nYh7 = parcelRequire("4nYh7");

var $gbBLn = parcelRequire("gbBLn");

var $gw6jA = parcelRequire("gw6jA");
const $da698aa4f276c01f$export$551eb27bf5bd708 = ()=>({
        [(0, $15a528573ccd89ae$export$d597759d33be802e)]: (0, $gbBLn.textMatcherCreator),
        [(0, $15a528573ccd89ae$export$f8f7545d2bb78afb)]: (0, $83R7M.assigneeMatcherCreator),
        [(0, $15a528573ccd89ae$export$37aee82a3cb1e8f7)]: (0, $7vODb.labelMatcherCreator),
        [(0, $15a528573ccd89ae$export$2a4f270075a033de)]: (0, $kSow3.issueParentMatcherCreator),
        [(0, $15a528573ccd89ae$export$401f4b6eda6a369c)]: (0, $91AxA.issueProjectMatcherCreator),
        [(0, $15a528573ccd89ae$export$ebb48b08205007c5)]: (0, $8wcaA.issueTypeMatcherCreator),
        [(0, $15a528573ccd89ae$export$a4ad2735b021c132)]: (0, $gw6jA.versionMatcherCreator),
        [(0, $15a528573ccd89ae$export$68d693c35a8d8866)]: (0, $2Ol4g.filteredIssueIdsMatcherCreator),
        [(0, $15a528573ccd89ae$export$af1e30ebbae9df3b)]: (0, $9NUFF.componentMatcherCreator),
        [(0, $15a528573ccd89ae$export$92ab80c1dc9baf44)]: (0, $bliRS.requestTypeMatcherCreator),
        [(0, $15a528573ccd89ae$export$f863b019d19144f4)]: (0, $ly5rg.statusCategoryMatcherCreator),
        [(0, $15a528573ccd89ae$export$e50006273435e7d4)]: (0, $4nYh7.statusMatcherCreator),
        [(0, $15a528573ccd89ae$export$1ea95b94fb0c51d9)]: (0, $2Ol4g.filteredIssueIdsMatcherCreator),
        [(0, $15a528573ccd89ae$export$a316570a0dbfd2b0)]: (0, $iZeAQ.sprintMatcherCreator),
        [(0, $15a528573ccd89ae$export$871e58afc769b358)]: (0, $2Ol4g.filteredIssueIdsMatcherCreator),
        [(0, $15a528573ccd89ae$export$db362e2d293fe52e)]: (0, $bOpxF.dependenciesMatcherCreator)
    });
const $da698aa4f276c01f$var$createMatchers = (filter, context, matcherCreators)=>Object.keys(filter).reduce((acc, key)=>{
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Filters'.
        const filterValue = filter[key];
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'MatcherCreators<Issue>'.
        const matcherCreator = matcherCreators[key];
        if (filterValue === undefined || filterValue.length <= 0 || matcherCreator === undefined) return acc;
        acc.push(matcherCreator(filterValue, context));
        return acc;
    }, []);
const $da698aa4f276c01f$export$5b4da3e2bd753e6 = (filter, context, matcherCreators, overrideMatchers)=>{
    const matchers = $da698aa4f276c01f$var$createMatchers(filter, context, matcherCreators ?? $da698aa4f276c01f$export$551eb27bf5bd708());
    return (issue)=>matchers.every((matcher)=>matcher(issue)) || overrideMatchers !== undefined && overrideMatchers.some((matcher)=>matcher(issue));
};

});
parcelRegister("83R7M", function(module, exports) {

$parcel$export(module.exports, "assigneeMatcherCreator", () => $516b0f9136210863$export$5c453ff7d8a6957f);

var $g5X3G = parcelRequire("g5X3G");

const $516b0f9136210863$export$5c453ff7d8a6957f = (assigneeFilter)=>{
    const assigneeSet = new Set(assigneeFilter);
    return ({ assignee: assignee })=>assignee !== undefined && assigneeSet.has(assignee.id) || assignee === undefined && assigneeSet.has((0, $g5X3G.toAccountId)((0, $15a528573ccd89ae$export$12e572fd459c10dc)));
};

});

parcelRegister("9NUFF", function(module, exports) {

$parcel$export(module.exports, "componentMatcherCreator", () => $f76f751e605f1ced$export$667cab6ac6c65512);

const $f76f751e605f1ced$export$667cab6ac6c65512 = (componentFilter)=>{
    const componentSet = new Set(componentFilter);
    return ({ componentIds: componentIds })=>componentIds !== undefined && (componentIds.some((componentId)=>componentSet.has(componentId)) || componentIds.length === 0 && componentSet.has((0, $15a528573ccd89ae$export$4b7c755e61199a36)));
};

});

parcelRegister("bOpxF", function(module, exports) {

$parcel$export(module.exports, "dependenciesMatcherCreator", () => $03061179e3dc93a9$export$18a8a0a9891403f1);

var $4R6GH = parcelRequire("4R6GH");

var $kIDH3 = parcelRequire("kIDH3");
const $03061179e3dc93a9$export$18a8a0a9891403f1 = (dependenciesFilter)=>{
    // General rule of dependencies filter is that it should include issues that has at least 1 dependency matches the selected filter.
    // So if off track is selected, it should include issues that has at least 1 off track dependency and vice versa,
    // if on track is selected, it should include issues that has at least 1 on track dependency.
    // If both off track and on track are selected, it should include issues that has at least 1 off track or on track dependency.
    if (dependenciesFilter && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) {
        const includeOffTrack = dependenciesFilter.includes((0, $kIDH3.DependencyFilterOption).OFF_TRACK);
        const includeOnTrack = dependenciesFilter.includes((0, $kIDH3.DependencyFilterOption).ON_TRACK);
        return (issue)=>includeOffTrack && !!issue.hasOfftrackDependency || includeOnTrack && !!issue.hasOntrackDependency;
    }
    return ()=>true;
};

});

parcelRegister("2Ol4g", function(module, exports) {

$parcel$export(module.exports, "filteredIssueIdsMatcherCreator", () => $497597637c50e49d$export$4493d922cd011b1a);
const $497597637c50e49d$export$4493d922cd011b1a = (value, { filteredIssueIds: filteredIssueIds })=>({ id: id })=>filteredIssueIds !== undefined ? id !== undefined && filteredIssueIds.has(id) : true;

});

parcelRegister("kSow3", function(module, exports) {

$parcel$export(module.exports, "issueParentMatcherCreator", () => $a81202b8afefb6ff$export$4729465fe91e6864);

const $a81202b8afefb6ff$export$4729465fe91e6864 = (issueParentFilter, { issues: issues })=>{
    const issueParentSet = new Set(issueParentFilter);
    const isAncestorInFilter = (id, checked = [])=>{
        if (id === undefined) return issueParentSet.has((0, $9ac224d9ad6eb576$export$794f07be04aca3fe));
        if (issueParentSet.has(id)) return true;
        if (checked.includes(id)) return false;
        if (issues === undefined) return false;
        const issue = issues.hash[id];
        if (issue === undefined) return false;
        const { parentId: parentId } = issue;
        return isAncestorInFilter(parentId, checked.concat(id));
    };
    return ({ id: id, parentId: parentId })=>{
        if (id === undefined) return false;
        if (issueParentSet.has(id)) return true;
        if (id === parentId) return false;
        return isAncestorInFilter(parentId, [
            id
        ]);
    };
};

});
const $9ac224d9ad6eb576$export$794f07be04aca3fe = '0';
const $9ac224d9ad6eb576$export$cb17e3c17bc50301 = 'Epic';
const $9ac224d9ad6eb576$export$7fbc739f2667a35e = 'Subtask';


parcelRegister("91AxA", function(module, exports) {

$parcel$export(module.exports, "issueProjectMatcherCreator", () => $4fdd97fe73369965$export$b10ee43342090204);
const $4fdd97fe73369965$export$b10ee43342090204 = (projectFilter)=>{
    const projectSet = new Set(projectFilter);
    return ({ projectId: projectId })=>!!projectId && projectSet.has(projectId);
};

});

parcelRegister("8wcaA", function(module, exports) {

$parcel$export(module.exports, "issueTypeMatcherCreator", () => $1427bf4cc0e6bee2$export$48b17418005f8b9b);
const $1427bf4cc0e6bee2$export$48b17418005f8b9b = (issueTypeFilter)=>{
    const issueTypeSet = new Set(issueTypeFilter);
    return ({ type: type })=>issueTypeSet.has(type.id);
};

});

parcelRegister("7vODb", function(module, exports) {

$parcel$export(module.exports, "labelMatcherCreator", () => $40f84c5420493f05$export$71d90ee236f2e796);

const $40f84c5420493f05$export$71d90ee236f2e796 = (labelFilter)=>{
    const labelSet = new Set(labelFilter);
    return ({ labels: labels })=>labels !== undefined && (labels.some((label)=>labelSet.has(label)) || labels.length === 0 && labelSet.has((0, $15a528573ccd89ae$export$81ef49afbbead0a1)));
};

});

parcelRegister("bliRS", function(module, exports) {

$parcel$export(module.exports, "requestTypeMatcherCreator", () => $0e9572c0a83b3cdc$export$d04e41d82fbfb8ba);
const $0e9572c0a83b3cdc$export$d04e41d82fbfb8ba = (requestTypeFilter)=>{
    const requestTypeSet = new Set(requestTypeFilter);
    return ({ requestTypeId: requestTypeId })=>!!requestTypeId && requestTypeSet.has(requestTypeId);
};

});

parcelRegister("iZeAQ", function(module, exports) {

$parcel$export(module.exports, "sprintMatcherCreator", () => $18f99efa97d4433e$export$4706275ba29d0c7);
const $18f99efa97d4433e$export$4706275ba29d0c7 = (sprintFilter)=>({ sprintId: sprintId })=>sprintFilter.includes(sprintId || '');

});

parcelRegister("ly5rg", function(module, exports) {

$parcel$export(module.exports, "statusCategoryMatcherCreator", () => $e669431e48d4db53$export$bb986e45707c6c33);
const $e669431e48d4db53$export$bb986e45707c6c33 = (statusCategoryFilter)=>{
    const statusCategorySet = new Set(statusCategoryFilter);
    return ({ statusCategoryId: statusCategoryId })=>statusCategoryId !== undefined && statusCategorySet.has(statusCategoryId);
};

});

parcelRegister("4nYh7", function(module, exports) {

$parcel$export(module.exports, "statusMatcherCreator", () => $931417eb46388f8b$export$c61724a440d8ea1d);
const $931417eb46388f8b$export$c61724a440d8ea1d = (statusFilter)=>{
    const statusSet = new Set(statusFilter);
    return ({ statusId: statusId })=>!!statusId && statusSet.has(statusId);
};

});

parcelRegister("gbBLn", function(module, exports) {

$parcel$export(module.exports, "textMatcherCreator", () => $b425285590e5a6aa$export$71a22d4a5d2891fc);

var $8QDwl = parcelRequire("8QDwl");

var $gJBT6 = parcelRequire("gJBT6");
const $b425285590e5a6aa$export$f3f2882e8b11d731 = (text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const $b425285590e5a6aa$var$doesSummaryContainText = (summary, lowercaseText)=>summary.toLowerCase().includes(lowercaseText) || $b425285590e5a6aa$export$f3f2882e8b11d731(summary).toLowerCase().includes(lowercaseText);
const $b425285590e5a6aa$var$doesIssueKeyMatchLoosely = (key, lowercaseText)=>key !== undefined && key?.toLowerCase().includes(lowercaseText);
const $b425285590e5a6aa$var$createDisplayNameChecker = (text)=>{
    // It transforms a text to a regular expression.
    // eg: text='mi ze', the transformed regexp would be 'mi.*\s+ze'
    // which searches for 'mi' followed by anything then 'ze'.
    const pattern = text.split(/\s+/).map((0, (/*@__PURE__*/$parcel$interopDefault($8QDwl)))).join('.*\\s+');
    const regExp = new RegExp(pattern, 'i');
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((displayName)=>regExp.test(displayName));
};
const $b425285590e5a6aa$export$71a22d4a5d2891fc = (textFilter)=>{
    const lowercaseText = textFilter.toLowerCase();
    const doesDisplayNameMatchRegExp = $b425285590e5a6aa$var$createDisplayNameChecker(textFilter);
    return ({ summary: summary, key: key, assignee: assignee })=>summary && $b425285590e5a6aa$var$doesSummaryContainText(summary, lowercaseText) || $b425285590e5a6aa$var$doesIssueKeyMatchLoosely(key, lowercaseText) || assignee !== undefined && doesDisplayNameMatchRegExp(assignee.displayName);
};

});
parcelRegister("8QDwl", function(module, exports) {

var $jJVtR = parcelRequire("jJVtR");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $6711d60dd8e02df4$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $6711d60dd8e02df4$var$reHasRegExpChar = RegExp($6711d60dd8e02df4$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $6711d60dd8e02df4$var$escapeRegExp(string) {
    string = $jJVtR(string);
    return string && $6711d60dd8e02df4$var$reHasRegExpChar.test(string) ? string.replace($6711d60dd8e02df4$var$reRegExpChar, '\\$&') : string;
}
module.exports = $6711d60dd8e02df4$var$escapeRegExp;

});


parcelRegister("gw6jA", function(module, exports) {

$parcel$export(module.exports, "versionMatcherCreator", () => $f7a5a8a45b854dff$export$fb114a888e0e17b4);

const $f7a5a8a45b854dff$export$fb114a888e0e17b4 = (versionFilter)=>{
    const versionSet = new Set(versionFilter);
    return ({ versionIds: versionIds })=>versionIds !== undefined && (versionIds.some((versionId)=>versionSet.has(versionId)) || versionIds.length === 0 && versionSet.has((0, $15a528573ccd89ae$export$ac95b4b2317d4b33)));
};

});



parcelRegister("2VkyK", function(module, exports) {

$parcel$export(module.exports, "getIssuesMedia", () => $044dc117eedc593d$export$f7bdab95f5be7b0a);
$parcel$export(module.exports, "getIssueMedia", () => $044dc117eedc593d$export$9596202b205d705);
$parcel$export(module.exports, "isIssueMediaHiddenByUser", () => $044dc117eedc593d$export$7ed559c90d15c6ab);

var $9XE6b = parcelRequire("9XE6b");

var $67Z81 = parcelRequire("67Z81");
const $044dc117eedc593d$export$f7bdab95f5be7b0a = (state)=>(0, $67Z81.getEntities)(state).issueMedia;
const $044dc117eedc593d$export$9596202b205d705 = (state, issueId)=>$044dc117eedc593d$export$f7bdab95f5be7b0a(state)[String(issueId)];
const $044dc117eedc593d$export$7ed559c90d15c6ab = (state, issueId)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))($044dc117eedc593d$export$9596202b205d705(state, issueId), [
        'isHiddenByUser'
    ], false);

});




parcelRegister("2obSb", function(module, exports) {

$parcel$export(module.exports, "default", () => $0052f06985acee83$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $eph8m = parcelRequire("eph8m");


var $1vXOx = parcelRequire("1vXOx");

var $67Z81 = parcelRequire("67Z81");

var $dNGbd = parcelRequire("dNGbd");
const $0052f06985acee83$var$mapStateToProps = (state)=>{
    const permissions = (0, $1vXOx.getPermissionsSelector)(state);
    return {
        canAccessCustomFilterSettings: permissions[0, $e525e6c25695c9df$export$aadc620ce91112df] === true && !(0, $67Z81.getIsCMPBoard)(state),
        customFiltersSettingsUrl: (0, $eph8m.getManageCustomFiltersUrl)((0, $67Z81.projectKeySelector)(state), (0, $67Z81.rapidViewIdSelector)(state))
    };
};
var $0052f06985acee83$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($0052f06985acee83$var$mapStateToProps, {})((0, $dNGbd.default));

});
parcelRegister("dNGbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d24d83ace57b2f3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8igKv = parcelRequire("8igKv");

var $koVbs = parcelRequire("koVbs");

var $14uhY = parcelRequire("14uhY");

var $8zOmE = parcelRequire("8zOmE");

var $jJ5ra = parcelRequire("jJ5ra");
const $9d24d83ace57b2f3$var$CustomFilterFailed = ({ id: id, customFiltersSettingsUrl: customFiltersSettingsUrl, canAccessCustomFilterSettings: canAccessCustomFilterSettings, onDismissed: onDismissed = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dismissFlag = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $14uhY.setReturnToProjectUrl)();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'customFilterFailedFlagLink', {
            canAccessCustomFilterSettings: canAccessCustomFilterSettings
        });
        onDismissed(id);
    }, [
        canAccessCustomFilterSettings,
        id,
        onDismissed
    ]);
    return canAccessCustomFilterSettings ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8igKv.default), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $jJ5ra.default).adminUserTitle),
        description: formatMessage((0, $jJ5ra.default).adminUserDescription),
        actions: [
            {
                content: formatMessage((0, $jJ5ra.default).adminUserActionLink),
                href: customFiltersSettingsUrl,
                target: '_blank',
                onClick: dismissFlag
            }
        ]
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8igKv.default), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $jJ5ra.default).endUserTitle),
        description: formatMessage((0, $jJ5ra.default).endUserDescription),
        actions: [
            {
                content: formatMessage((0, $jJ5ra.default).endUserActionLink),
                onClick: dismissFlag
            }
        ]
    });
};
var $9d24d83ace57b2f3$export$2e2bcd8739ae039 = $9d24d83ace57b2f3$var$CustomFilterFailed;

});
parcelRegister("8igKv", function(module, exports) {

$parcel$export(module.exports, "default", () => $87b804070d792a00$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$87b804070d792a00$export$2e2bcd8739ae039 = (0, $3KRpp.WarningFlag);

});

parcelRegister("14uhY", function(module, exports) {

$parcel$export(module.exports, "setReturnToProjectUrl", () => $5f614763a26e8877$export$127f7bd1c092fc8f);
$parcel$export(module.exports, "getReturnToProjectUrl", () => $5f614763a26e8877$export$575dc7c4a154874b);

var $eNf8a = parcelRequire("eNf8a");
const $5f614763a26e8877$var$RETURN_TO_PROJECT_URL = 'returnToProjectUrl';
const $5f614763a26e8877$var$sessionStorage = (0, $eNf8a.createSessionExpirableStorageProvider)('navigation');
const $5f614763a26e8877$export$127f7bd1c092fc8f = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $5f614763a26e8877$var$sessionStorage.set($5f614763a26e8877$var$RETURN_TO_PROJECT_URL, window.location.pathname + window.location.search);
};
const $5f614763a26e8877$export$575dc7c4a154874b = ()=>String($5f614763a26e8877$var$sessionStorage.get($5f614763a26e8877$var$RETURN_TO_PROJECT_URL) || '');

});

parcelRegister("jJ5ra", function(module, exports) {

$parcel$export(module.exports, "default", () => $438d52296c72073d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $438d52296c72073d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    adminUserTitle: {
        "id": "software.main.flags.custom-filter-failed.admin-user-title",
        "defaultMessage": "We couldn't load your filters"
    },
    adminUserDescription: {
        "id": "software.main.flags.custom-filter-failed.admin-user-description",
        "defaultMessage": "One or more of your filters can't be used right now. You can check your filter queries and try again."
    },
    adminUserActionLink: {
        "id": "software.main.flags.custom-filter-failed.admin-user-action-link",
        "defaultMessage": "Manage custom filters"
    },
    endUserTitle: {
        "id": "software.main.flags.custom-filter-failed.end-user-title",
        "defaultMessage": "We couldn't load your filters"
    },
    endUserDescription: {
        "id": "software.main.flags.custom-filter-failed.end-user-description",
        "defaultMessage": "One or more of your filters can't be used right now. Contact your Jira admin to check the filter queries, then try again."
    },
    endUserActionLink: {
        "id": "software.main.flags.custom-filter-failed.end-user-action-link",
        "defaultMessage": "OK"
    }
});

});



parcelRegister("elCuX", function(module, exports) {

$parcel$export(module.exports, "default", () => $027735dadff37032$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $eph8m = parcelRequire("eph8m");


var $1vXOx = parcelRequire("1vXOx");

var $67Z81 = parcelRequire("67Z81");

var $ldtVh = parcelRequire("ldtVh");
const $027735dadff37032$var$mapStateToProps = (state)=>{
    const permissions = (0, $1vXOx.getPermissionsSelector)(state);
    return {
        contextPath: (0, $67Z81.contextPathSelector)(state),
        canEditBoard: permissions[0, $e525e6c25695c9df$export$aadc620ce91112df] === true && !(0, $67Z81.getIsCMPBoard)(state),
        wantedUrl: (0, $eph8m.getIssueTypesUrl)((0, $67Z81.projectKeySelector)(state))
    };
};
var $027735dadff37032$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($027735dadff37032$var$mapStateToProps, {})((0, $ldtVh.default));

});
parcelRegister("ldtVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $86b41bca2ec32d00$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $7f4tk = parcelRequire("7f4tk");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $2bQEl = parcelRequire("2bQEl");

var $4OoQs = parcelRequire("4OoQs");
const $86b41bca2ec32d00$var$fetchIssueTypes = (contextPath, fetchOptions, missingIssueType)=>(0, $7f4tk.default)((0, $2bQEl.getIssueTypes)(contextPath, missingIssueType), fetchOptions);
const $86b41bca2ec32d00$var$fetchOptions = {
    method: 'GET'
};
const $86b41bca2ec32d00$var$MissingIssueTypeFlag = ({ id: id, onDismissed: onDismissed, contextPath: contextPath, canEditBoard: canEditBoard, wantedUrl: wantedUrl, missingIssueType: missingIssueType })=>{
    const flagShown = (0, $5uXOq.useRef)(false);
    const [issueType, setIssueType] = (0, $5uXOq.useState)({
        name: '',
        isName: false
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const missingIssueTypeDescriptionMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4OoQs.default).missingIssueTypeDescriptionIssueTermRefresh : (0, $4OoQs.default).missingIssueTypeDescription;
    const defaultMissingIssueTypeDescriptionMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4OoQs.default).defaultMissingIssueTypeDescriptionIssueTermRefresh : (0, $4OoQs.default).defaultMissingIssueTypeDescription;
    (0, $5uXOq.useEffect)(()=>{
        $86b41bca2ec32d00$var$fetchIssueTypes(contextPath, $86b41bca2ec32d00$var$fetchOptions, missingIssueType).then(({ name: name })=>{
            setIssueType({
                name: name,
                isName: true
            });
        }).catch(()=>{
            setIssueType({
                name: missingIssueType,
                isName: false
            });
        });
    }, [
        missingIssueType,
        contextPath
    ]);
    if (flagShown.current || !issueType.name) return null;
    if (!flagShown.current) flagShown.current = true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.WarningFlag), {
        id: id,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4OoQs.default).missingIssueTypeTitleIssueTermRefresh : (0, $4OoQs.default).missingIssueTypeTitle),
        description: formatMessage(issueType.isName ? missingIssueTypeDescriptionMessage : defaultMissingIssueTypeDescriptionMessage, {
            missingIssueTypeName: issueType.name,
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, chunks)
        }),
        actions: canEditBoard ? [
            {
                content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4OoQs.default).adminIssueTypeActionLinkIssueTermRefresh : (0, $4OoQs.default).adminIssueTypeActionLink),
                href: wantedUrl,
                target: '_blank',
                onClick: ()=>onDismissed(id)
            }
        ] : []
    });
};
var $86b41bca2ec32d00$export$2e2bcd8739ae039 = $86b41bca2ec32d00$var$MissingIssueTypeFlag;

});
parcelRegister("2bQEl", function(module, exports) {

$parcel$export(module.exports, "STATUS_CATEGORY_URL", () => $0b1ad1b6b9c53193$export$5bea8fb5e10d6ac0);
$parcel$export(module.exports, "getJSWGraphQlEndpointUrl", () => $0b1ad1b6b9c53193$export$fecea24c8d34782b);
$parcel$export(module.exports, "getIssueEditUrl", () => $0b1ad1b6b9c53193$export$5d595c3dde9874c);
$parcel$export(module.exports, "getIssueTransitionWithoutColumnUrl", () => $0b1ad1b6b9c53193$export$70f64f88eb86fdc0);
$parcel$export(module.exports, "getIssueTransitionUrl", () => $0b1ad1b6b9c53193$export$5b2875d63118103e);
$parcel$export(module.exports, "getBulkIssueRankUrl", () => $0b1ad1b6b9c53193$export$29d30514d27cd4d0);
$parcel$export(module.exports, "getCurrentUserDataFromAccountIdUrl", () => $0b1ad1b6b9c53193$export$cd6324a706a70a6d);
$parcel$export(module.exports, "getCardMediaUrl", () => $0b1ad1b6b9c53193$export$8842e395ceb4fa93);
$parcel$export(module.exports, "getIssueMediaVisibilityChangeUrl", () => $0b1ad1b6b9c53193$export$88504e44da09203f);
$parcel$export(module.exports, "getBacklogIssueMoveUrl", () => $0b1ad1b6b9c53193$export$1ea50550b3eb8a6e);
$parcel$export(module.exports, "getIssuesMoveToBacklogUrl", () => $0b1ad1b6b9c53193$export$e59f8900eb9b733f);
$parcel$export(module.exports, "getFeaturesUrl", () => $0b1ad1b6b9c53193$export$979ec3e17da473a5);
$parcel$export(module.exports, "getNextGenBacklogUrl", () => $0b1ad1b6b9c53193$export$fd40fa3fee2372f8);
$parcel$export(module.exports, "getVersionUrl", () => $0b1ad1b6b9c53193$export$f6b360c59c43e332);
$parcel$export(module.exports, "getIssueTypes", () => $0b1ad1b6b9c53193$export$4cf4b24b88599615);
const $0b1ad1b6b9c53193$export$5bea8fb5e10d6ac0 = '/rest/api/2/statuscategory';
const $0b1ad1b6b9c53193$export$fecea24c8d34782b = (contextPath)=>`${contextPath}/jsw2/graphql`;
const $0b1ad1b6b9c53193$export$a0b9ef211caa7367 = (contextPath)=>`${$0b1ad1b6b9c53193$export$fecea24c8d34782b(contextPath)}?operation=SoftwareColumnCreate`;
const $0b1ad1b6b9c53193$export$145570eb57e3197c = (contextPath)=>`${$0b1ad1b6b9c53193$export$fecea24c8d34782b(contextPath)}?operation=SoftwareColumnDelete`;
const $0b1ad1b6b9c53193$export$7b704b3494f4d7 = (contextPath)=>`${$0b1ad1b6b9c53193$export$fecea24c8d34782b(contextPath)}?operation=SoftwareColumnRename`;
const $0b1ad1b6b9c53193$export$fff9fff088167caa = (contextPath)=>`${$0b1ad1b6b9c53193$export$fecea24c8d34782b(contextPath)}?operation=SoftwareColumnRank`;
const $0b1ad1b6b9c53193$export$5d2970d85cd0112a = (contextPath)=>`${$0b1ad1b6b9c53193$export$fecea24c8d34782b(contextPath)}?operation=SoftwareColumnSetLimit`;
const $0b1ad1b6b9c53193$export$bf62d1e5e809d480 = (projectId, contextPath)=>`${contextPath}/rest/internal/2/invite-user/project/${projectId}/invitation-settings`;
const $0b1ad1b6b9c53193$export$5dcaad3da99bf44f = (projectId, contextPath)=>`${contextPath}/rest/internal/2/invite-user/project/${projectId}/invitation-settings`;
const $0b1ad1b6b9c53193$export$ac9729118da67b8b = (contextPath)=>`${$0b1ad1b6b9c53193$export$fecea24c8d34782b(contextPath)}?operation=CompleteSprintMetadata`;
const $0b1ad1b6b9c53193$export$7cb1f34c2c8b82ed = (contextPath)=>`${$0b1ad1b6b9c53193$export$fecea24c8d34782b(contextPath)}?operation=SoftwareBoardClearCards`;
const $0b1ad1b6b9c53193$export$796a7264fa69ddca = (contextPath)=>`${$0b1ad1b6b9c53193$export$fecea24c8d34782b(contextPath)}?operation=FilteredCardIds`;
const $0b1ad1b6b9c53193$export$1f40a3867ec104dd = (contextPath)=>`${$0b1ad1b6b9c53193$export$fecea24c8d34782b(contextPath)}?operation=BoardCardCreate`;
const $0b1ad1b6b9c53193$export$a92012cc19d68266 = (contextPath)=>`${contextPath}/rest/api/2/issue`;
const $0b1ad1b6b9c53193$export$5d595c3dde9874c = (contextPath, issueKey)=>`${contextPath}/rest/api/2/issue/${issueKey}`;
const $0b1ad1b6b9c53193$export$70f64f88eb86fdc0 = (contextPath)=>`${contextPath}/rest/greenhopper/1.0/board/issues/transition`;
const $0b1ad1b6b9c53193$export$5b2875d63118103e = ()=>'/rest/greenhopper/1.0/xboard/transitionAndRank';
const $0b1ad1b6b9c53193$export$29d30514d27cd4d0 = ()=>'/rest/greenhopper/1.0/rank';
const $0b1ad1b6b9c53193$export$cd6324a706a70a6d = (contextPath, accountId)=>`${contextPath}/rest/api/3/user?accountId=${encodeURIComponent(accountId)}`;
const $0b1ad1b6b9c53193$export$505a9f131607d070 = (contextPath, rapidViewId)=>`${contextPath}/secure/RapidBoard.jspa?rapidView=${rapidViewId}`;
const $0b1ad1b6b9c53193$export$4742ff7bed4e2624 = (contextPath, rapidViewId, additionalParams = [])=>{
    const paramString = additionalParams.map((param)=>`&${param}`).join('');
    return `${contextPath}/secure/RapidBoard.jspa?rapidView=${rapidViewId}&view=planning${paramString}`;
};
const $0b1ad1b6b9c53193$export$8842e395ceb4fa93 = (contextPath, rapidViewId, display)=>`${contextPath}/rest/greenhopper/1.0/xboard/work/media?rapidViewId=${rapidViewId}&display=${String(display)}`;
const $0b1ad1b6b9c53193$export$88504e44da09203f = (contextPath, issueId)=>`${contextPath}/rest/greenhopper/1.0/xboard/work/media/${issueId}`;
const $0b1ad1b6b9c53193$export$c17be2774c33b6d4 = (contextPath, rapidViewId)=>`${contextPath}/rest/agile/1.0/board/${rapidViewId}/properties`;
const $0b1ad1b6b9c53193$export$cb1e8590d79b2c2c = (contextPath, rapidViewId, propertyKey)=>`${contextPath}/rest/agile/1.0/board/${rapidViewId}/properties/${propertyKey}`;
const $0b1ad1b6b9c53193$export$1ea50550b3eb8a6e = (contextPath)=>`${contextPath}/rest/greenhopper/1.0/xboard/migrateFirstColumnToBacklog`;
const $0b1ad1b6b9c53193$export$e59f8900eb9b733f = (contextPath)=>`${contextPath}/rest/greenhopper/1.0/xboard/assignToListAndRank`;
const $0b1ad1b6b9c53193$export$33182ffdef0919b7 = ()=>'/gateway/api/pubsub/subscribe';
const $0b1ad1b6b9c53193$export$979ec3e17da473a5 = (contextPath, rapidViewId)=>`${contextPath}/rest/agile/latest/board/${rapidViewId}/features`;
const $0b1ad1b6b9c53193$export$fd40fa3fee2372f8 = (contextPath, projectKey, rapidViewId)=>`${contextPath}/jira/software/projects/${projectKey}/boards/${rapidViewId}/backlog`;
const $0b1ad1b6b9c53193$export$f6b360c59c43e332 = (rapidViewId)=>`/rest/greenhopper/1.0/xboard/work/versions?rapidViewId=${rapidViewId}`;
const $0b1ad1b6b9c53193$export$4cf4b24b88599615 = (contextPath, issueTypeId)=>`${contextPath}/rest/api/3/issuetype/${issueTypeId}`;
const $0b1ad1b6b9c53193$export$c0b167d82b41a1c = (contextPath)=>`${contextPath}/rest/greenhopper/1.0/rapidview/addtohistory`;
const $0b1ad1b6b9c53193$export$fd09219a8cde557b = (projectId, contextPath)=>`${contextPath}/rest/api/3/project/${projectId}/roledetails?excludeConnectAddons=true`;
const $0b1ad1b6b9c53193$export$d5badd8c822522b9 = (projectKey, contextPath, hasCurrentMember)=>`${contextPath}/rest/api/3/project/${projectKey}/roledetails?excludeConnectAddons=true${hasCurrentMember ? '&currentMember=true' : ''}`;
const $0b1ad1b6b9c53193$export$aec63e27a1c559f6 = ()=>'/rest/api/2/user/assignable/search';
const $0b1ad1b6b9c53193$export$6ff259328e55f46 = ()=>'/rest/api/3/search';
const $0b1ad1b6b9c53193$export$a4b3b6dec5572b97 = ()=>'/rest/graphql/1';
const $0b1ad1b6b9c53193$export$bd35faba0afabad2 = ()=>'/rest/api/3/issue/:issueKey';
const $0b1ad1b6b9c53193$export$160a21daf4cb73b = ()=>'/rest/api/3/issue/:issueKey/assignee';
const $0b1ad1b6b9c53193$export$accc30140c2c7e1b = ()=>'/rest/internal/simplified/1.0/projects/:projectId/issues/:issueId/children';
const $0b1ad1b6b9c53193$export$aefb19023b2eda55 = ()=>'/rest/gira/1/';

});

parcelRegister("4OoQs", function(module, exports) {

$parcel$export(module.exports, "default", () => $5453f5c6883e143e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5453f5c6883e143e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    missingIssueTypeTitle: {
        "id": "software.main.flags.missing-issue-type.missing-issue-type-title",
        "defaultMessage": "Issue types in this board and project don't match"
    },
    missingIssueTypeDescription: {
        "id": "software.main.flags.missing-issue-type.missing-issue-type-description",
        "defaultMessage": "The <b>{missingIssueTypeName}</b> issue type is used on this board, but isn't configured for this project."
    },
    defaultMissingIssueTypeDescription: {
        "id": "software.main.flags.missing-issue-type.default-missing-issue-type-description",
        "defaultMessage": "The issue type <b>{missingIssueTypeName}</b> is used on this board, but isn't configured for this project."
    },
    adminIssueTypeActionLink: {
        "id": "software.main.flags.missing-issue-type.admin-issue-type-action-link",
        "defaultMessage": "Manage issue types"
    },
    missingIssueTypeTitleIssueTermRefresh: {
        "id": "software.main.flags.missing-issue-type.missing-issue-type-title-issue-term-refresh",
        "defaultMessage": "Issue types in this board and project don't match"
    },
    missingIssueTypeDescriptionIssueTermRefresh: {
        "id": "software.main.flags.missing-issue-type.missing-issue-type-description-issue-term-refresh",
        "defaultMessage": "The <b>{missingIssueTypeName}</b> issue type is used on this board, but isn't configured for this project."
    },
    defaultMissingIssueTypeDescriptionIssueTermRefresh: {
        "id": "software.main.flags.missing-issue-type.default-missing-issue-type-description-issue-term-refresh",
        "defaultMessage": "The issue type <b>{missingIssueTypeName}</b> is used on this board, but isn't configured for this project."
    },
    adminIssueTypeActionLinkIssueTermRefresh: {
        "id": "software.main.flags.missing-issue-type.admin-issue-type-action-link-issue-term-refresh",
        "defaultMessage": "Manage issue types"
    }
});

});




parcelRegister("4ldpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b646dc7d2474321c$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $aud83 = parcelRequire("aud83");

var $4R6GH = parcelRequire("4R6GH");


var $dnW4F = parcelRequire("dnW4F");
/**
 * Despite incorrect types due to use of the `icepick` library setIn operators
 * most filters only accept array values. The exception is the text search.
 */ function $b646dc7d2474321c$var$castToArray(queryValue) {
    if (queryValue && Array.isArray(queryValue)) return queryValue.map((value)=>String(value));
    return [
        String(queryValue)
    ];
}
function $b646dc7d2474321c$export$2e2bcd8739ae039(isCMPBoard) {
    const filterTypes = [
        {
            urlKey: isCMPBoard ? 'search' : 'text',
            transform: $aud83.string,
            getValueForUrl: (state)=>state.ui.workFilters?.values[0, $dcff40112356dfc1$export$d597759d33be802e],
            setValueFromUrl: (dispatch, value)=>{
                if (value) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$d597759d33be802e), String(value)));
            }
        },
        {
            urlKey: 'assignee',
            transform: isCMPBoard ? $aud83.multiple : $aud83.array,
            getValueForUrl: (state)=>{
                const filters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(state, [
                    'ui',
                    'workFilters',
                    'values',
                    (0, $dcff40112356dfc1$export$f8f7545d2bb78afb)
                ], []);
                return filters.length ? filters : undefined;
            },
            setValueFromUrl: (dispatch, values)=>{
                if (values) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$f8f7545d2bb78afb), $b646dc7d2474321c$var$castToArray(values)));
            }
        },
        {
            urlKey: 'label',
            transform: $aud83.array,
            getValueForUrl: (state)=>{
                const filters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(state, [
                    'ui',
                    'workFilters',
                    'values',
                    (0, $dcff40112356dfc1$export$37aee82a3cb1e8f7)
                ], []);
                return filters.length ? filters : undefined;
            },
            setValueFromUrl: (dispatch, values)=>{
                if (values) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$37aee82a3cb1e8f7), $b646dc7d2474321c$var$castToArray(values)));
            }
        },
        {
            urlKey: 'issueParent',
            transform: $aud83.array,
            getValueForUrl: (state)=>{
                const filters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(state, [
                    'ui',
                    'workFilters',
                    'values',
                    (0, $dcff40112356dfc1$export$2a4f270075a033de)
                ], []);
                return filters.length ? filters : undefined;
            },
            setValueFromUrl: (dispatch, values)=>{
                if (values) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$2a4f270075a033de), $b646dc7d2474321c$var$castToArray(values)));
            }
        },
        {
            urlKey: 'issueType',
            transform: $aud83.array,
            getValueForUrl: (state)=>{
                const filters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(state, [
                    'ui',
                    'workFilters',
                    'values',
                    (0, $dcff40112356dfc1$export$ebb48b08205007c5)
                ], []);
                return filters.length ? filters : undefined;
            },
            setValueFromUrl: (dispatch, values)=>{
                if (values) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$ebb48b08205007c5), $b646dc7d2474321c$var$castToArray(values)));
            }
        },
        {
            urlKey: isCMPBoard ? 'quickFilter' : 'customFilter',
            transform: isCMPBoard ? $aud83.multiple : $aud83.array,
            getValueForUrl: (state)=>{
                const filters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(state, [
                    'ui',
                    'workFilters',
                    'values',
                    (0, $dcff40112356dfc1$export$68d693c35a8d8866)
                ], []);
                return filters.length ? filters : undefined;
            },
            setValueFromUrl: (dispatch, values)=>{
                // CMP only. TMP boards do NOT support this yet
                if (values && isCMPBoard) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$68d693c35a8d8866), $b646dc7d2474321c$var$castToArray(values)));
            }
        },
        {
            urlKey: 'sprints',
            transform: $aud83.array,
            getValueForUrl: (state)=>{
                const filters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(state, [
                    'ui',
                    'workFilters',
                    'values',
                    (0, $dcff40112356dfc1$export$a316570a0dbfd2b0)
                ], []);
                return filters.length ? filters : undefined;
            },
            setValueFromUrl: (dispatch, values)=>{
                if (values) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$a316570a0dbfd2b0), $b646dc7d2474321c$var$castToArray(values)));
            }
        },
        /**
		 * the "Project" filter is currently only used by the Increment Planning board of Advanced Roadmaps
		 * please refer to src/packages/software/filters/src/ui/stateless/index.tsx
		 */ {
            urlKey: 'project',
            transform: $aud83.array,
            getValueForUrl: (state)=>{
                const filters = state.ui.workFilters?.values[0, $dcff40112356dfc1$export$401f4b6eda6a369c] || [];
                return filters.length ? filters : undefined;
            },
            setValueFromUrl: (dispatch, values)=>{
                if (values) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$401f4b6eda6a369c), $b646dc7d2474321c$var$castToArray(values)));
            }
        }
    ];
    /**
	 * delete this condition but keep code inside and move it inside
	 * the filterTypes array when removing 'dependency_visualisation_program_board_fe_and_be' FF
	 */ if ((0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) filterTypes.push({
        urlKey: 'dependencies',
        transform: $aud83.array,
        getValueForUrl: (state)=>{
            const filters = state.ui.workFilters?.values[0, $dcff40112356dfc1$export$db362e2d293fe52e] || [];
            return filters.length ? filters : undefined;
        },
        setValueFromUrl: (dispatch, values)=>{
            if (values) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$db362e2d293fe52e), $b646dc7d2474321c$var$castToArray(values)));
        }
    });
    return filterTypes;
}

});

parcelRegister("jQCwr", function(module, exports) {

$parcel$export(module.exports, "getDetailViewWidthRatio", () => $baaf486e7d950ad6$export$5a9c556da9744b1b);
$parcel$export(module.exports, "setDetailViewWidthRatio", () => $baaf486e7d950ad6$export$d194f7c4bdc33538);
$parcel$export(module.exports, "getCollapsedSwimlanes", () => $baaf486e7d950ad6$export$676aff045298a75d);
$parcel$export(module.exports, "setCollapsedSwimlanes", () => $baaf486e7d950ad6$export$b621d43268491671);
$parcel$export(module.exports, "setSwimlaneModeSetting", () => $baaf486e7d950ad6$export$cc714c2bb2344bfd);
$parcel$export(module.exports, "getSwimlaneModeSetting", () => $baaf486e7d950ad6$export$1708c8217a67f3f9);

var $9XE6b = parcelRequire("9XE6b");

var $bSSG7 = parcelRequire("bSSG7");
// app provides it's unique prefix
const $baaf486e7d950ad6$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('software');
const $baaf486e7d950ad6$var$COLLAPSED_SWIMLANES = 'collapsed-swimlanes';
const $baaf486e7d950ad6$var$DETAIL_VIEW_WIDTH_RATIO = 'gh.detailViewWidth';
const $baaf486e7d950ad6$var$GROUP_BY_SELECTION = 'gh.groupBySelection.';
const $baaf486e7d950ad6$export$5a9c556da9744b1b = ()=>{
    const value = $baaf486e7d950ad6$var$localStorage.get($baaf486e7d950ad6$var$DETAIL_VIEW_WIDTH_RATIO);
    return value ? Number(value) : 0;
};
const $baaf486e7d950ad6$export$d194f7c4bdc33538 = (ratio)=>$baaf486e7d950ad6$var$localStorage.set($baaf486e7d950ad6$var$DETAIL_VIEW_WIDTH_RATIO, ratio);
const $baaf486e7d950ad6$export$676aff045298a75d = (boardId)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))($baaf486e7d950ad6$var$localStorage.get($baaf486e7d950ad6$var$COLLAPSED_SWIMLANES), [
        String(boardId)
    ], []);
const $baaf486e7d950ad6$export$b621d43268491671 = (boardId, swimlanesId)=>$baaf486e7d950ad6$var$localStorage.set($baaf486e7d950ad6$var$COLLAPSED_SWIMLANES, {
        [boardId]: swimlanesId
    });
const $baaf486e7d950ad6$export$cc714c2bb2344bfd = (boardId, groupBy)=>{
    $baaf486e7d950ad6$var$localStorage.set(`${$baaf486e7d950ad6$var$GROUP_BY_SELECTION}${boardId}`, groupBy);
};
const $baaf486e7d950ad6$export$1708c8217a67f3f9 = (boardId)=>{
    const data = $baaf486e7d950ad6$var$localStorage.get(`${$baaf486e7d950ad6$var$GROUP_BY_SELECTION}${boardId}`);
    if (!data) return null;
    return data;
};

});

parcelRegister("jM0wW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6fb7ad3eb61a656$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $aud83 = parcelRequire("aud83");

var $d1i1b = parcelRequire("d1i1b");

var $dW1HX = parcelRequire("dW1HX");

var $2ON1s = parcelRequire("2ON1s");

var $67Z81 = parcelRequire("67Z81");
function $d6fb7ad3eb61a656$export$2e2bcd8739ae039(isIncrementPlanningBoard = false) {
    /**
	 * We won't use any of the url keys listed below in increment planning boards.
	 */ if (isIncrementPlanningBoard) return [];
    return [
        {
            urlKey: 'selectedIssue',
            transform: $aud83.string,
            getValueForUrl: (state)=>{
                const key = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $67Z81.getUi)(state), [
                    'issueModal',
                    'selectedIssueKey'
                ], undefined);
                if (key) return key;
                return undefined;
            },
            setValueFromUrl: (dispatch, value)=>{
                if (value && typeof value === 'string') {
                    dispatch((0, $dW1HX.openIssueModal)(value));
                    dispatch((0, $d1i1b.cardAutoScrollRequestOnLoad)(value));
                }
            }
        },
        {
            urlKey: 'isInsightsOpen',
            transform: $aud83.bool,
            getValueForUrl: (state)=>{
                const key = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $67Z81.getUi)(state), [
                    'panels',
                    'INSIGHTS_PANEL'
                ], undefined);
                if (key) return key;
                return undefined;
            },
            setValueFromUrl: (dispatch, value)=>{
                if (value) dispatch((0, $2ON1s.openInsightsPanel)());
            }
        }
    ];
}

});
parcelRegister("d1i1b", function(module, exports) {

$parcel$export(module.exports, "CARD_AUTO_SCROLL", () => $737bec5b19c367b3$export$21e828c0e9d1105a);
$parcel$export(module.exports, "cardAutoScroll", () => $737bec5b19c367b3$export$274e46dc8e4633e0);
$parcel$export(module.exports, "CARD_AUTO_SCROLL_REQUEST_ON_LOAD", () => $737bec5b19c367b3$export$a7d9dbfd9ccf9cd8);
$parcel$export(module.exports, "cardAutoScrollRequestOnLoad", () => $737bec5b19c367b3$export$f894c82154cc28a0);
$parcel$export(module.exports, "CARD_AUTO_SCROLL_REQUEST_ON_FILTER", () => $737bec5b19c367b3$export$3a965e6001d5e2e9);
$parcel$export(module.exports, "cardAutoScrollRequestOnFilter", () => $737bec5b19c367b3$export$58d9ced87e626159);
$parcel$export(module.exports, "CARD_AUTO_SCROLL_UNSCHEDULED_COLUMN_ICC", () => $737bec5b19c367b3$export$fbb1bd2388e5c263);
$parcel$export(module.exports, "cardAutoScrollUnscheduledColumnIcc", () => $737bec5b19c367b3$export$ec5c5166fa42e94d);
const $737bec5b19c367b3$export$21e828c0e9d1105a = 'state.actions.card.CARD_AUTO_SCROLL';
const $737bec5b19c367b3$export$274e46dc8e4633e0 = (issueId)=>({
        type: $737bec5b19c367b3$export$21e828c0e9d1105a,
        payload: {
            issueId: issueId
        }
    });
const $737bec5b19c367b3$export$a7d9dbfd9ccf9cd8 = 'state.actions.card.CARD_AUTO_SCROLL_REQUEST_ON_LOAD';
const $737bec5b19c367b3$export$f894c82154cc28a0 = (issueKey)=>({
        type: $737bec5b19c367b3$export$a7d9dbfd9ccf9cd8,
        payload: {
            issueKey: issueKey
        }
    });
const $737bec5b19c367b3$export$3a965e6001d5e2e9 = 'state.actions.card.CARD_AUTO_SCROLL_REQUEST_ON_FILTER';
const $737bec5b19c367b3$export$58d9ced87e626159 = ()=>({
        type: $737bec5b19c367b3$export$3a965e6001d5e2e9
    });
const $737bec5b19c367b3$export$fbb1bd2388e5c263 = 'state.actions.card.CARD_AUTO_SCROLL_UNSCHEDULED_COLUMN_ICC';
const $737bec5b19c367b3$export$ec5c5166fa42e94d = (swimlaneId, isImmediate)=>({
        type: $737bec5b19c367b3$export$fbb1bd2388e5c263,
        payload: {
            swimlaneId: swimlaneId,
            isImmediate: isImmediate
        }
    });

});

parcelRegister("2ON1s", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_PANEL", () => $b52f7c84c7e591b8$export$81879e9427948bf);
$parcel$export(module.exports, "togglePanel", () => $b52f7c84c7e591b8$export$67879b1cfc177b88);
$parcel$export(module.exports, "OPEN_INSIGHTS_PANEL", () => $b52f7c84c7e591b8$export$894891eae2c7b097);
$parcel$export(module.exports, "openInsightsPanel", () => $b52f7c84c7e591b8$export$ffae5ab992b11d10);
$parcel$export(module.exports, "CLOSE_INSIGHTS_PANEL", () => $b52f7c84c7e591b8$export$8e43d92e9c342d0);
$parcel$export(module.exports, "closeInsightsPanel", () => $b52f7c84c7e591b8$export$4fda8ba2e49f8d0c);
$parcel$export(module.exports, "CLOSE_VIEW_SETTINGS_PANEL", () => $b52f7c84c7e591b8$export$b1f480ba0abd2610);
$parcel$export(module.exports, "closeViewSettingsPanel", () => $b52f7c84c7e591b8$export$ef3e4b5eca4263a7);
const $b52f7c84c7e591b8$export$81879e9427948bf = 'state.actions.panels.TOGGLE_PANEL';
const $b52f7c84c7e591b8$export$67879b1cfc177b88 = (panel)=>({
        type: $b52f7c84c7e591b8$export$81879e9427948bf,
        payload: {
            panel: panel
        }
    });
const $b52f7c84c7e591b8$export$894891eae2c7b097 = 'state.actions.panels.OPEN_INSIGHTS_PANEL';
const $b52f7c84c7e591b8$export$ffae5ab992b11d10 = ()=>({
        type: $b52f7c84c7e591b8$export$894891eae2c7b097
    });
const $b52f7c84c7e591b8$export$8e43d92e9c342d0 = 'state.actions.panels.CLOSE_INSIGHTS_PANEL';
const $b52f7c84c7e591b8$export$4fda8ba2e49f8d0c = ()=>({
        type: $b52f7c84c7e591b8$export$8e43d92e9c342d0
    });
const $b52f7c84c7e591b8$export$b1f480ba0abd2610 = 'state.actions.panels.CLOSE_VIEW_SETTINGS_PANEL';
const $b52f7c84c7e591b8$export$ef3e4b5eca4263a7 = ()=>({
        type: $b52f7c84c7e591b8$export$b1f480ba0abd2610
    });

});


parcelRegister("67sX6", function(module, exports) {

$parcel$export(module.exports, "default", () => $0386bfdf0ed24c6f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "BoardReduxProvider", () => $0386bfdf0ed24c6f$export$9a7703ca29dba112);
$parcel$export(module.exports, "useBoardSelector", () => $0386bfdf0ed24c6f$export$96e82ea2a3badaf7);
$parcel$export(module.exports, "useBoardDispatch", () => $0386bfdf0ed24c6f$export$be5272ae2502876c);
$parcel$export(module.exports, "useBoardActionCreator", () => $0386bfdf0ed24c6f$export$a6babbe6110b8b10);
$parcel$export(module.exports, "useBoardStore", () => $0386bfdf0ed24c6f$export$18a7b27690614aac);
$parcel$export(module.exports, "createStoreWithCache", () => $0386bfdf0ed24c6f$export$96feb51b037b866);
$parcel$export(module.exports, "unmountCachedStore", () => $0386bfdf0ed24c6f$export$a0196b1023d1dffd);
parcelRequire("korqb");

var $1UikQ = parcelRequire("1UikQ");

var $j2mQS = parcelRequire("j2mQS");

var $F2Mxm = parcelRequire("F2Mxm");

var $g3qyq = parcelRequire("g3qyq");

var $5Ue2S = parcelRequire("5Ue2S");

var $46ha9 = parcelRequire("46ha9");


var $kt1kI = parcelRequire("kt1kI");

var $fip9w = parcelRequire("fip9w");


var $5kyJ5 = parcelRequire("5kyJ5");

var $iQYKJ = parcelRequire("iQYKJ");

var $5YGyZ = parcelRequire("5YGyZ");

var $3sree = parcelRequire("3sree");
function $0386bfdf0ed24c6f$export$2e2bcd8739ae039(state, options) {
    const rootReducer = (0, $3sree.default)();
    const middlewares = [];
    let initRootEpic;
    if (options.isServer) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    initRootEpic = (0, $fip9w.default);
    else initRootEpic = (0, $j2mQS.disposableEpic)((0, $kt1kI.default)());
    const boardDependencies = {
        isCMPBoard: options.isCMPBoard,
        swagClient: options.swagClient,
        customRequestHandlers: options.customRequestHandlers
    };
    var _getState, action;
    if (!options.isServer) {
        middlewares.push((0, $5kyJ5.default));
        middlewares.push((0, $iQYKJ.actionMetricsMiddleware));
        // @ts-expect-error - Argument of type '() => (next: (action: Action) => Action) => (action: Action) => Action' is not assignable to parameter of type 'Middleware'.
        middlewares.push((0, $5YGyZ.default));
        middlewares.push((0, $g3qyq.default)((0, $dcbb2bce513725b3$export$d76071d5de2774fc)));
    }
    return (0, $F2Mxm.default)({
        appName: 'Software',
        rootReducer: rootReducer,
        rootEpic: initRootEpic,
        rootEpicDependencies: boardDependencies,
        middlewares: middlewares,
        initialState: state
    });
}
const { Provider: $0386bfdf0ed24c6f$export$9a7703ca29dba112, useSelector: $0386bfdf0ed24c6f$export$96e82ea2a3badaf7, useDispatch: $0386bfdf0ed24c6f$export$be5272ae2502876c, useActionCreator: $0386bfdf0ed24c6f$export$a6babbe6110b8b10, useStore: $0386bfdf0ed24c6f$export$18a7b27690614aac } = (0, $46ha9.createJiraSoftwareStoreContext)();
const $0386bfdf0ed24c6f$var$cachedStoreManager = new (0, $5Ue2S.CachedStoreManager)({
    mergeCachedState (cachedState, preloadedState) {
        return {
            configuration: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(preloadedState.configuration, cachedState.configuration),
            ui: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(preloadedState.ui, {
                swimlane: cachedState.ui.swimlane
            }),
            entities: cachedState.entities
        };
    },
    storeFactory: $0386bfdf0ed24c6f$export$2e2bcd8739ae039
});
const $0386bfdf0ed24c6f$export$96feb51b037b866 = (boardId, preloadedStateParam, options)=>$0386bfdf0ed24c6f$var$cachedStoreManager.createStore(boardId, preloadedStateParam, options);
const $0386bfdf0ed24c6f$export$a0196b1023d1dffd = ()=>{
    $0386bfdf0ed24c6f$var$cachedStoreManager.unmount();
};

});
parcelRegister("j2mQS", function(module, exports) {

$parcel$export(module.exports, "disposableEpic", () => $1c9d4320a4bfd294$export$e6b812e492b046b8);
parcelRequire("7qVV7");

const $1c9d4320a4bfd294$export$e6b812e492b046b8 = (rootEpic)=>(action$, store, dependencies)=>rootEpic(action$, store, dependencies).takeUntil(action$.ofType((0, $167b7959815986d2$export$58387e80544dbf03)));

});

parcelRegister("g3qyq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c091411acc86b19$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $iR96x = parcelRequire("iR96x");
/**
 * Catches errors within redux reducers and makes them available to monitoring.
 *
 * Takes an optional error action creator as a parameter to be reduced when an error is encountered.
 * This could be used to show an error flag, for example.
 *
 * Should be passed as part of the middleware array when creating the store.
 * E.g. [middlewareOne, errorHandling('your-app-name')]
 */ const $4c091411acc86b19$var$errorHandling = (appId, errorActionCreator, /**
		 * Callback for errors
		 */ onError)=>()=>(next)=>(action)=>{
                try {
                    next(action);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    const fullLocation = `common.redux-error.${appId}`;
                    (0, $dJl1T.default).safeErrorWithoutCustomerData(fullLocation, `Unhandled error for Redux action: '${action?.type}'`, error);
                    (0, $iR96x.captureException)(fullLocation, error);
                    errorActionCreator && next(errorActionCreator());
                    onError && onError(error);
                }
            };
var $4c091411acc86b19$export$2e2bcd8739ae039 = $4c091411acc86b19$var$errorHandling;

});

parcelRegister("5Ue2S", function(module, exports) {

$parcel$export(module.exports, "CachedStoreManager", () => $8f61412efdaebad3$export$519eb0cf9e49db0c);

var $91VA7 = parcelRequire("91VA7");
class $8f61412efdaebad3$export$519eb0cf9e49db0c {
    constructor({ storeFactory: storeFactory, mergeCachedState: mergeCachedState }){
        this.cache = null;
        this.storeFactory = storeFactory;
        this.mergeCachedState = mergeCachedState;
    }
    /**
	 * Return true if the redux state was in cache. In this case, we won't consider
	 * the resources' data.
	 */ hasCachedState(boardId) {
        return Boolean(this.cache && this.cache.boardId === boardId);
    }
    getCachedState(boardId) {
        if (this.cache && this.cache.boardId === boardId) return this.cache.state;
        return null;
    }
    /**
	 * Create a new store, merging a preloadedState with any cached state that was
	 * previously held in memory.
	 */ createStore(boardId, preloadedStateParam, options) {
        // Cast to get rid of Omit<...>. Both types are partial so this is valid
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        let preloadedState = (0, (/*@__PURE__*/$parcel$interopDefault($91VA7)))(preloadedStateParam);
        const cachedState = this.getCachedState(boardId);
        if (!options.disableStoreCaches && cachedState) preloadedState = this.mergeCachedState(cachedState, preloadedState);
        const store = this.storeFactory(preloadedState, options);
        if (options.disableStoreCaches) return store;
        // On every change copy a reference to the redux state to this
        // `cachedStoreState` object.
        this.unmount();
        this.cache = {
            boardId: boardId,
            state: store.getState(),
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unsubscribe: ()=>{}
        };
        this.cache.unsubscribe = store.subscribe(()=>{
            if (this.cache) this.cache.state = store.getState();
        });
        return store;
    }
    /**
	 * Clean-up redux store subscriptions.
	 */ unmount() {
        this.cache?.unsubscribe();
    }
    /**
	 * FOR TESTING ONLY
	 */ getCacheForTesting() {
        return this.cache;
    }
}

});
parcelRegister("91VA7", function(module, exports) {

var $7MmCC = parcelRequire("7MmCC");
/** Used to compose bitmasks for cloning. */ var $6930df867851495d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $6930df867851495d$var$clone(value) {
    return $7MmCC(value, $6930df867851495d$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $6930df867851495d$var$clone;

});


parcelRegister("46ha9", function(module, exports) {

$parcel$export(module.exports, "createJiraSoftwareStoreContext", () => $b414fa8c478f8909$export$884b1d3e4c97abdd);

var $5uXOq = parcelRequire("5uXOq");

var $bDWQ3 = parcelRequire("bDWQ3");

var $7D59a = parcelRequire("7D59a");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b414fa8c478f8909$var$refEquality = (a, b)=>a === b;
function $b414fa8c478f8909$export$884b1d3e4c97abdd() {
    const ctx = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
    const useStore = ()=>{
        const store = (0, $5uXOq.useContext)(ctx);
        if (!store) throw new Error('useStore called outside of redux JiraSoftwareStoreContext tree');
        return store;
    };
    function useSelector(selector, equalityFn = $b414fa8c478f8909$var$refEquality) {
        const store = useStore();
        const result = (0, $bDWQ3.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, // Server state probably wont exist but we can use store.getState in case it does work.
        store.getState, selector, equalityFn);
        return result;
    }
    function useDispatch() {
        const store = useStore();
        return store.dispatch;
    }
    function useActionCreator(actionCreator) {
        const dispatch = useDispatch();
        return (0, $7D59a.useEvent)((...args)=>{
            const action = actionCreator(...args);
            dispatch(action);
        });
    }
    function ReduxProvider(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ctx.Provider, {
            value: props.store
        }, props.children);
    }
    return {
        Provider: ReduxProvider,
        useSelector: useSelector,
        useStore: useStore,
        useDispatch: useDispatch,
        useActionCreator: useActionCreator
    };
}

});
parcelRegister("7D59a", function(module, exports) {

$parcel$export(module.exports, "useEvent", () => $cc6c832ad15d24e3$export$90fc3a17d93f704c);

var $5uXOq = parcelRequire("5uXOq");
const $cc6c832ad15d24e3$export$90fc3a17d93f704c = (callback)=>{
    const callbackRef = (0, $5uXOq.useRef)(callback);
    (0, $5uXOq.useLayoutEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    return (0, $5uXOq.useCallback)((...args)=>callbackRef.current(...args), []);
};

});


parcelRegister("kt1kI", function(module, exports) {

$parcel$export(module.exports, "default", () => $11a93b681cb84aea$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $4R6GH = parcelRequire("4R6GH");

var $iUagi = parcelRequire("iUagi");

var $RDO6A = parcelRequire("RDO6A");

var $c7TLG = parcelRequire("c7TLG");

var $jGHzz = parcelRequire("jGHzz");

var $gT8Nn = parcelRequire("gT8Nn");

var $9KrY0 = parcelRequire("9KrY0");

var $ivoZ6 = parcelRequire("ivoZ6");

var $iUPbp = parcelRequire("iUPbp");

var $8Wyzi = parcelRequire("8Wyzi");

var $dxMXW = parcelRequire("dxMXW");

var $kuD1K = parcelRequire("kuD1K");

var $9s50S = parcelRequire("9s50S");

var $gZyMz = parcelRequire("gZyMz");

var $8ornp = parcelRequire("8ornp");

var $c0Qhv = parcelRequire("c0Qhv");

var $7COzu = parcelRequire("7COzu");

var $f72yS = parcelRequire("f72yS");

var $41QbH = parcelRequire("41QbH");

var $fGfXq = parcelRequire("fGfXq");

var $gG0ZK = parcelRequire("gG0ZK");

var $5Farb = parcelRequire("5Farb");

var $5ZlmD = parcelRequire("5ZlmD");

var $93Fzk = parcelRequire("93Fzk");

var $i9XZM = parcelRequire("i9XZM");

var $enaRv = parcelRequire("enaRv");

var $hh3dt = parcelRequire("hh3dt");

var $erSBH = parcelRequire("erSBH");

var $dNJJS = parcelRequire("dNJJS");

var $hM7SN = parcelRequire("hM7SN");

var $kAzMD = parcelRequire("kAzMD");

var $7Tp6S = parcelRequire("7Tp6S");

var $14rCC = parcelRequire("14rCC");

var $8SGPr = parcelRequire("8SGPr");

var $8gsv0 = parcelRequire("8gsv0");

var $gMi9d = parcelRequire("gMi9d");

var $dzWxI = parcelRequire("dzWxI");

var $EGoh4 = parcelRequire("EGoh4");

var $4FKf7 = parcelRequire("4FKf7");

var $9C8b7 = parcelRequire("9C8b7");

var $iH73B = parcelRequire("iH73B");

var $2u4LO = parcelRequire("2u4LO");

var $14ODQ = parcelRequire("14ODQ");

var $a9PrS = parcelRequire("a9PrS");

var $2RHGv = parcelRequire("2RHGv");

var $4rj2F = parcelRequire("4rj2F");

var $fgxdE = parcelRequire("fgxdE");

var $6Yser = parcelRequire("6Yser");

var $2D01T = parcelRequire("2D01T");

var $5I1Fz = parcelRequire("5I1Fz");

var $eTCf8 = parcelRequire("eTCf8");

var $fElG1 = parcelRequire("fElG1");

var $4tES9 = parcelRequire("4tES9");

var $fb1Ne = parcelRequire("fb1Ne");

var $b8T1q = parcelRequire("b8T1q");

var $7UfD9 = parcelRequire("7UfD9");

var $bTMOX = parcelRequire("bTMOX");

var $9mZdS = parcelRequire("9mZdS");

var $bIfkc = parcelRequire("bIfkc");

var $jlZom = parcelRequire("jlZom");

var $8cD7G = parcelRequire("8cD7G");

var $juuG5 = parcelRequire("juuG5");

var $csUBy = parcelRequire("csUBy");

var $19Ino = parcelRequire("19Ino");

var $fip9w = parcelRequire("fip9w");

var $dEmHW = parcelRequire("dEmHW");

var $1wh3p = parcelRequire("1wh3p");

var $3usqj = parcelRequire("3usqj");

var $h07lG = parcelRequire("h07lG");

var $7QNZV = parcelRequire("7QNZV");

var $lfaRE = parcelRequire("lfaRE");

var $l4Gux = parcelRequire("l4Gux");

var $1AmgY = parcelRequire("1AmgY");

var $8wkzB = parcelRequire("8wkzB");

var $deevq = parcelRequire("deevq");

var $iAr3J = parcelRequire("iAr3J");

var $kmCzR = parcelRequire("kmCzR");
const $11a93b681cb84aea$var$epicWithKillSwitch = (predicate)=>(epic)=>(action$, store, dependencies)=>epic(new (0, $e1AU2.ActionsObservable)(action$.filter(()=>!predicate())), store, dependencies);
const $11a93b681cb84aea$var$epicWithDevStatusOnCardsKillSwitch = $11a93b681cb84aea$var$epicWithKillSwitch((0, $iUagi.isDevStatusOnCardsDisabled));
const $11a93b681cb84aea$var$withAddPeopleButtonOpenTMPExperimentKillSwitch = $11a93b681cb84aea$var$epicWithKillSwitch((0, $iUagi.isInAddPeopleButtonOpenTMPControlCohort));
const $11a93b681cb84aea$var$getCardCoversWithKillSwitch = $11a93b681cb84aea$var$epicWithKillSwitch(()=>!(0, $4R6GH.fg)('jsw_cmp_card_cover_images'));
const $11a93b681cb84aea$var$boardDataShadowRequestEpicKillSwitch = $11a93b681cb84aea$var$epicWithKillSwitch(()=>!(0, $4R6GH.fg)('jsw_board_simple_pagination_spike'));
const $11a93b681cb84aea$var$getRootEpic = ()=>(0, $e1AU2.combineEpics)((0, $RDO6A.default), (0, $c7TLG.default), (0, $h07lG.default), (0, $kAzMD.default), (0, $dNJJS.default), (0, $hM7SN.default), (0, $7Tp6S.default), (0, $14rCC.default), (0, $6Yser.default), (0, $csUBy.default), (0, $kmCzR.default)(), (0, $8cD7G.default), (0, $8cD7G.workLoadOnInitialLoadEpic), (0, $iAr3J.default), (0, $2D01T.issueFlagWithCommentEpic), (0, $gZyMz.default), (0, $fip9w.default), (0, $fb1Ne.default), (0, $EGoh4.default), $11a93b681cb84aea$var$epicWithDevStatusOnCardsKillSwitch((0, $a9PrS.devStatusLoadEpic)), (0, $jGHzz.boardDeferredDataLoadEpic), (0, $8wkzB.default), (0, $lfaRE.default), (0, $l4Gux.default), (0, $i9XZM.default), (0, $iUPbp.default), (0, $9KrY0.default), (0, $fElG1.default), (0, $8Wyzi.default), (0, $5Farb.default), (0, $41QbH.default), (0, $8ornp.cardAssignToMeEpic), (0, $8ornp.cardAssignToMeThrottledEpic), (0, $gG0ZK.default), (0, $f72yS.default), (0, $enaRv.default), (0, $fGfXq.default), (0, $hh3dt.default), (0, $7COzu.cardChangeTeamEpic), (0, $4tES9.issueMoveToBacklogEpic), (0, $4FKf7.filteredCardsEpic), (0, $dzWxI.default), (0, $juuG5.default), (0, $gMi9d.detailViewUpdateEpic), (0, $8SGPr.detailViewCloseEpic), (0, $8gsv0.detailViewOpenDebouncedEpic), (0, $bIfkc.default), (0, $2RHGv.issueBentoUpdateEpic), (0, $5I1Fz.issueIncrementPlanningUpdateEpic), (0, $7UfD9.issueRankTransitionEpic), (0, $b8T1q.issueRankTeamDateEpic), (0, $4rj2F.issueBulkUpdateEpic), (0, $eTCf8.issueLinkEpic), (0, $eTCf8.issueLinkUpdateEpic), (0, $9mZdS.issueUnlinkEpic), (0, $9C8b7.initiateIccInUnscheduledColumnEpic), (0, $erSBH.checkGlobalIssueCreateEpic), (0, $bTMOX.default), (0, $1wh3p.removeFromSprintEpic), (0, $3usqj.updatePlannedCapacityEpic), (0, $dEmHW.addToSprintEpic), (0, $deevq.versionGetEpic), (0, $fgxdE.issueChildrenInFinalColumnEpic), (0, $93Fzk.cardsMoveEpic), (0, $dxMXW.bulkIssueRankTransitionRequestEpic), (0, $5ZlmD.cardDragStartEpic), (0, $c0Qhv.cardAutoScrollOnLoadEpic), (0, $c0Qhv.cardAutoScrollOnFilterEpic), (0, $14ODQ.getIssueLinksStatsEpic), (0, $2u4LO.getIsIssueLinksStatsLoadingEpic), (0, $jlZom.missingParentResolveEpic), (0, $iH73B.getIssueLinksPermissionsEpic), $11a93b681cb84aea$var$withAddPeopleButtonOpenTMPExperimentKillSwitch((0, $kuD1K.getCanUserInviteEpic)), (0, $ivoZ6.displayFlagForIssuesFilteredOnServerEpic), (0, $7QNZV.jqlSwimlanesEpic), (0, $1AmgY.updateIterationCapacityEpic), (0, $gT8Nn.boardFavouriteEpic), $11a93b681cb84aea$var$getCardCoversWithKillSwitch((0, $9s50S.getCardCoversEpic)), $11a93b681cb84aea$var$boardDataShadowRequestEpicKillSwitch((0, $19Ino.boardDataShadowRequestEpic)));
var $11a93b681cb84aea$export$2e2bcd8739ae039 = $11a93b681cb84aea$var$getRootEpic;

});
parcelRegister("RDO6A", function(module, exports) {

$parcel$export(module.exports, "default", () => $df668f8c164378df$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $dJl1T = parcelRequire("dJl1T");

var $82cU2 = parcelRequire("82cU2");

var $2bQEl = parcelRequire("2bQEl");

var $2Ysq2 = parcelRequire("2Ysq2");

var $absT5 = parcelRequire("absT5");

var $67Z81 = parcelRequire("67Z81");
const $df668f8c164378df$var$confirmEpic = (action$, store)=>action$.ofType((0, $2Ysq2.BACKLOG_ENABLE_CONFIRM)).switchMap((action)=>(0, $kVLXA.Observable).of((0, $2Ysq2.backlogEnableExecute)((0, $absT5.getFirstColumnIssueIds)(store.getState()), action.payload.push, action.payload.refresh)));
const $df668f8c164378df$var$executeEnableBacklogEpic = (action$, store)=>action$.ofType((0, $2Ysq2.BACKLOG_ENABLE_EXECUTE)).switchMap((action)=>(0, $82cU2.executeBacklogEnable)(store.getState()).switchMap(()=>(0, $kVLXA.Observable).of((0, $2Ysq2.backlogEnableExecuteSuccess)(action.payload.push, action.payload.refresh))).catch((error)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.enable.failure', 'Failed to enable the backlog', error);
            return (0, $kVLXA.Observable).of((0, $2Ysq2.backlogEnableExecuteFailure)());
        }));
const $df668f8c164378df$var$executeEnableBacklogEpicSuccess = (action$, store)=>action$.ofType((0, $2Ysq2.BACKLOG_ENABLE_EXECUTE_SUCCESS)).mergeMap((action)=>{
        const contextPath = (0, $67Z81.contextPathSelector)(store.getState());
        const rapidViewId = (0, $67Z81.rapidViewIdSelector)(store.getState());
        const projectKey = (0, $67Z81.projectKeySelector)(store.getState());
        const { push: push, refresh: refresh } = action.payload;
        const url = (0, $2bQEl.getNextGenBacklogUrl)(contextPath, projectKey, rapidViewId);
        push(url);
        refresh();
        return (0, $kVLXA.Observable).empty();
    });
var $df668f8c164378df$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)($df668f8c164378df$var$confirmEpic, $df668f8c164378df$var$executeEnableBacklogEpic, $df668f8c164378df$var$executeEnableBacklogEpicSuccess);

});
parcelRegister("82cU2", function(module, exports) {

$parcel$export(module.exports, "executeBacklogEnable", () => $1bbf271ff42241ac$export$690ad42fb0e955f6);

var $487fd = parcelRequire("487fd");

var $67Z81 = parcelRequire("67Z81");

var $2bQEl = parcelRequire("2bQEl");
const $1bbf271ff42241ac$export$690ad42fb0e955f6 = (state)=>{
    const contextPath = (0, $67Z81.contextPathSelector)(state);
    const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
    const url = (0, $2bQEl.getFeaturesUrl)(contextPath, rapidViewId);
    return (0, $487fd.default)(url, {
        method: 'PUT',
        body: JSON.stringify({
            boardId: rapidViewId,
            feature: 'jsw.agility.backlog',
            enabling: true
        })
    });
};

});

parcelRegister("2Ysq2", function(module, exports) {

$parcel$export(module.exports, "BACKLOG_ENABLE_CANCEL", () => $e4e769740361c175$export$3c77343ffc194a44);
$parcel$export(module.exports, "backlogEnableCancel", () => $e4e769740361c175$export$52c00a4647b8e037);
$parcel$export(module.exports, "BACKLOG_ENABLE_CONFIRM", () => $e4e769740361c175$export$6b33e6709d7730dc);
$parcel$export(module.exports, "backlogEnableConfirm", () => $e4e769740361c175$export$32df3f70300e2871);
$parcel$export(module.exports, "BACKLOG_ENABLE_EXECUTE", () => $e4e769740361c175$export$aed41f3e4822edd);
$parcel$export(module.exports, "backlogEnableExecute", () => $e4e769740361c175$export$e9c8908c57a6a62d);
$parcel$export(module.exports, "BACKLOG_ENABLE_EXECUTE_SUCCESS", () => $e4e769740361c175$export$8806068f70c10739);
$parcel$export(module.exports, "backlogEnableExecuteSuccess", () => $e4e769740361c175$export$28d6e28e210a421d);
$parcel$export(module.exports, "backlogEnableExecuteFailure", () => $e4e769740361c175$export$faef2c83a5ea3eff);
const $e4e769740361c175$export$3c77343ffc194a44 = 'state.actions.board.backlog-enable.BACKLOG_ENABLE_CANCEL';
const $e4e769740361c175$export$52c00a4647b8e037 = ()=>({
        type: $e4e769740361c175$export$3c77343ffc194a44
    });
const $e4e769740361c175$export$6b33e6709d7730dc = 'state.actions.board.backlog-enable.BACKLOG_ENABLE_CONFIRM';
const $e4e769740361c175$export$32df3f70300e2871 = (push, refresh)=>({
        type: $e4e769740361c175$export$6b33e6709d7730dc,
        payload: {
            push: push,
            refresh: refresh
        }
    });
const $e4e769740361c175$export$aed41f3e4822edd = 'state.actions.board.backlog-enable.BACKLOG_ENABLE_EXECUTE';
const $e4e769740361c175$export$e9c8908c57a6a62d = (issueIds, push, refresh)=>({
        type: $e4e769740361c175$export$aed41f3e4822edd,
        payload: {
            issueIds: issueIds,
            push: push,
            refresh: refresh
        }
    });
const $e4e769740361c175$export$8806068f70c10739 = 'state.actions.board.backlog-enable.BACKLOG_ENABLE_EXECUTE_SUCCESS';
const $e4e769740361c175$export$28d6e28e210a421d = (push, refresh)=>({
        type: $e4e769740361c175$export$8806068f70c10739,
        payload: {
            push: push,
            refresh: refresh
        }
    });
const $e4e769740361c175$export$e1d4177958834b9d = 'state.actions.board.backlog-enable.BACKLOG_ENABLE_EXECUTE_FAILURE';
const $e4e769740361c175$export$faef2c83a5ea3eff = ()=>({
        type: $e4e769740361c175$export$e1d4177958834b9d
    });

});

parcelRegister("absT5", function(module, exports) {

$parcel$export(module.exports, "getFirstColumnIssueIds", () => $99b3e60f9f65f47a$export$96f2113557912d36);
$parcel$export(module.exports, "isOpenSelector", () => $99b3e60f9f65f47a$export$eacfcc6aba3b8af4);
$parcel$export(module.exports, "isDialogVisibleSelector", () => $99b3e60f9f65f47a$export$c130901f07b1d4e4);

var $dGvGJ = parcelRequire("dGvGJ");

var $gccSB = parcelRequire("gccSB");

var $co1wz = parcelRequire("co1wz");

var $iuuJH = parcelRequire("iuuJH");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");
const $99b3e60f9f65f47a$export$96f2113557912d36 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getOrderedColumnIds),
    (0, $d2i8f.getOrderedIssuesByColumn)
], (orderedColumnIds, orderedIssuesByColumn)=>{
    if ((0, $co1wz.ff)('jsw.board.backlog-issue-move-undefined-fix') && (!orderedColumnIds || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(orderedColumnIds) || !orderedIssuesByColumn || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(orderedIssuesByColumn))) return [];
    const firstColumnId = orderedColumnIds[0];
    const firstColumnIssues = orderedIssuesByColumn[firstColumnId];
    return firstColumnIssues ? firstColumnIssues.map((i)=>i.id) : [];
});
const $99b3e60f9f65f47a$export$eacfcc6aba3b8af4 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getUi)
], (ui)=>Boolean(ui.backlogIssueMoveDialog?.isOpen));
const $99b3e60f9f65f47a$export$c130901f07b1d4e4 = (0, $dGvGJ.createSelector)([
    $99b3e60f9f65f47a$export$eacfcc6aba3b8af4,
    $99b3e60f9f65f47a$export$96f2113557912d36,
    (0, $45cXl.getSwimlaneMode)
], (isOpen, firstColumnIssueIds, swimlaneMode)=>{
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return false;
    const firstColumnNotEmpty = firstColumnIssueIds.length > 0;
    return isOpen && firstColumnNotEmpty;
});

});


parcelRegister("c7TLG", function(module, exports) {

$parcel$export(module.exports, "default", () => $71f505c3631c1813$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");
parcelRequire("1oQta");
parcelRequire("d0pqD");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");
parcelRequire("hZWgu");
parcelRequire("6cbqE");

var $9XE6b = parcelRequire("9XE6b");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $e7Vtd = parcelRequire("e7Vtd");

var $aZavt = parcelRequire("aZavt");

var $doOdQ = parcelRequire("doOdQ");

var $cW3pH = parcelRequire("cW3pH");

var $absT5 = parcelRequire("absT5");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");
const $71f505c3631c1813$var$shouldCheckForDialogOnRefresh = (action, state)=>{
    if (action?.payload?.boardConfig == null) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.move.issue.no.board.config', 'Board config is null on enabled Swag Extended feature flag', {
            error: JSON.stringify(action, Object.getOwnPropertyNames(action))
        });
        return false;
    }
    const { boardIssueListKey: boardIssueListKey, requestColumnMigration: requestColumnMigration } = action.payload.boardConfig;
    const canEdit = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(action, [
        'payload',
        'boardPermissions',
        'editBoardConfig'
    ], false) && !(0, $67Z81.getIsCMPBoard)(state);
    const isIssueListBoard = Boolean(boardIssueListKey);
    const isActiveSprint = Boolean((0, $ebHh7.activeSprintsSelector)(state));
    const isAlreadyOpen = (0, $absT5.isOpenSelector)(state);
    return (requestColumnMigration || false) && isIssueListBoard && canEdit && !isActiveSprint && !isAlreadyOpen;
};
const $71f505c3631c1813$var$checkDismissEpicOnRefresh = (action$, store)=>action$.ofType((0, $cW3pH.WORK_DATA_SET)).filter((action)=>$71f505c3631c1813$var$shouldCheckForDialogOnRefresh(action, store.getState())).switchMap(()=>(0, $kVLXA.Observable).of((0, $doOdQ.backlogIssueMoveShow)()));
const $71f505c3631c1813$var$setDismissEpic = (action$, store)=>action$.ofType((0, $doOdQ.BACKLOG_ISSUE_MOVE_CANCEL), (0, $doOdQ.BACKLOG_ISSUE_MOVE_CONFIRM)).switchMap(()=>{
        const state = store.getState();
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
        return (0, $aZavt.dismissMigrationModal)(contextPath, rapidViewId).ignoreElements()// impossible:
        .map(()=>({
                type: 'UNSUPPORTED_ACTION_TYPE'
            }));
    });
const $71f505c3631c1813$var$confirmEpic = (action$, store)=>action$.ofType((0, $doOdQ.BACKLOG_ISSUE_MOVE_CONFIRM)).switchMap(()=>(0, $kVLXA.Observable).of((0, $doOdQ.backlogIssueMoveExecute)((0, $absT5.getFirstColumnIssueIds)(store.getState()))));
const $71f505c3631c1813$var$executeMoveEpic = (action$, store)=>action$.ofType((0, $doOdQ.BACKLOG_ISSUE_MOVE_EXECUTE)).mergeMap((action)=>(0, $e7Vtd.executeBacklogIssueMove)(store.getState()).switchMap(()=>(0, $kVLXA.Observable).of((0, $doOdQ.backlogIssueMoveExecuteSuccess)(action.meta.optimistic.id))).catch((error)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.move.issue.failure', 'Failed to move issues to backlog', error);
            return (0, $kVLXA.Observable).of((0, $doOdQ.backlogIssueMoveExecuteFailure)(action.meta.optimistic.id));
        }));
var $71f505c3631c1813$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)($71f505c3631c1813$var$checkDismissEpicOnRefresh, $71f505c3631c1813$var$setDismissEpic, $71f505c3631c1813$var$confirmEpic, $71f505c3631c1813$var$executeMoveEpic);

});
parcelRegister("e7Vtd", function(module, exports) {

$parcel$export(module.exports, "executeBacklogIssueMove", () => $eb25df84b768bbf2$export$750a6ad19c52b3ed);

var $487fd = parcelRequire("487fd");

var $67Z81 = parcelRequire("67Z81");

var $2bQEl = parcelRequire("2bQEl");
const $eb25df84b768bbf2$export$750a6ad19c52b3ed = (state)=>{
    const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
    const contextPath = (0, $67Z81.contextPathSelector)(state);
    const url = (0, $2bQEl.getBacklogIssueMoveUrl)(contextPath);
    return (0, $487fd.default)(url, {
        method: 'PUT',
        body: JSON.stringify({
            rapidViewId: rapidViewId
        })
    });
};

});

parcelRegister("aZavt", function(module, exports) {

$parcel$export(module.exports, "dismissMigrationModal", () => $981d6b72ff2111e1$export$e05baac531611192);

var $ivqh1 = parcelRequire("ivqh1");

var $6iJbJ = parcelRequire("6iJbJ");

var $CFxE9 = parcelRequire("CFxE9");
const $981d6b72ff2111e1$export$716b4280dda478e9 = 'DismissFirstColumnMigrationModal';
const $981d6b72ff2111e1$export$19a8cfc9fd174c1c = (0, $ivqh1.gqlTagSwag)`
    mutation DismissFirstColumnMigrationModal($boardId: ID!) {
        dismissFirstColumnMigrationModal(input: {boardId: $boardId}) {
            boardScope {
                id
            }
        }
    }
`;
const $981d6b72ff2111e1$export$e05baac531611192 = (contextPath, boardId)=>(0, $6iJbJ.mutation$)(contextPath, $981d6b72ff2111e1$export$716b4280dda478e9, $981d6b72ff2111e1$export$19a8cfc9fd174c1c, {
        boardId: boardId
    }, (0, $CFxE9.dismissMigrationModalAnalyticsOptions));

});
parcelRegister("ivqh1", function(module, exports) {

$parcel$export(module.exports, "gqlTagSwag", () => $01c130fdc769ad97$export$c4eea1172a449e1a);

var $ftbQH = parcelRequire("ftbQH");
const $01c130fdc769ad97$export$c4eea1172a449e1a = (0, $ftbQH.gqlTagRest);

});
parcelRegister("ftbQH", function(module, exports) {

$parcel$export(module.exports, "gqlTagRest", () => $e1de9369168f5428$export$ecc155df19ba52ff);
/**
 * This file is to define tags for GraphQL queries to be identified
 * by https://github.com/apollographql/eslint-plugin-graphql
 * It returns the full query string for template literals
 */ const $e1de9369168f5428$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});


parcelRegister("6iJbJ", function(module, exports) {

$parcel$export(module.exports, "mutation$", () => $fd52b7b2722ec81e$export$3c168c5a8b47d553);

var $4nUsC = parcelRequire("4nUsC");
const $fd52b7b2722ec81e$export$3c168c5a8b47d553 = (baseUrl, operationName, query, variables, analyticOptions)=>(0, $4nUsC.operation$)('mutation', baseUrl, operationName, query, variables, analyticOptions);

});

parcelRegister("CFxE9", function(module, exports) {

$parcel$export(module.exports, "columnCreateAnalyticsOptions", () => $1d87f422c20d6fb4$export$3009f6a98d0222d7);
$parcel$export(module.exports, "columnCreateInteraction", () => $1d87f422c20d6fb4$export$7cece60792def420);
$parcel$export(module.exports, "columnRenameAnalyticsOptions", () => $1d87f422c20d6fb4$export$e39ccf35fc62d1b);
$parcel$export(module.exports, "columnRenameInteraction", () => $1d87f422c20d6fb4$export$41003cf816bb8221);
$parcel$export(module.exports, "columnRankAnalyticsOptions", () => $1d87f422c20d6fb4$export$89b4c340d9939ed9);
$parcel$export(module.exports, "columnRankInteraction", () => $1d87f422c20d6fb4$export$b9f6994a9f080d4d);
$parcel$export(module.exports, "columnDeleteAnalyticsOptions", () => $1d87f422c20d6fb4$export$5b23342a6a197f18);
$parcel$export(module.exports, "columnDeleteInteraction", () => $1d87f422c20d6fb4$export$2c54f096c209762e);
$parcel$export(module.exports, "columnSetLimitAnalyticsOptions", () => $1d87f422c20d6fb4$export$58a3eac1c0822c79);
$parcel$export(module.exports, "columnSetLimitInteraction", () => $1d87f422c20d6fb4$export$8c79986dfa78fcdf);
$parcel$export(module.exports, "boardScopeDataNonCriticalAnalyticsOptions", () => $1d87f422c20d6fb4$export$e97ac4cb4d0a1231);
$parcel$export(module.exports, "cardCreateAnalyticsOptions", () => $1d87f422c20d6fb4$export$90f1c46b5c27e9d2);
$parcel$export(module.exports, "loadExtensionAnalyticsOptions", () => $1d87f422c20d6fb4$export$7aa6483bdb308d69);
$parcel$export(module.exports, "setUserSwimlaneAnalyticsOptions", () => $1d87f422c20d6fb4$export$d62aa526ed93638f);
$parcel$export(module.exports, "boardRenameAnalyticsOptions", () => $1d87f422c20d6fb4$export$c511eb222d867bfd);
$parcel$export(module.exports, "completeSprintModalLoad", () => $1d87f422c20d6fb4$export$281157708c6b132a);
$parcel$export(module.exports, "dismissMigrationModalAnalyticsOptions", () => $1d87f422c20d6fb4$export$aabc7f67e3ae59ef);
// Note: Metrics key need to be added to key - enum list in the data-portal registry
// - https://data-portal.internal.atlassian.com/analytics/registry/28587?tabIndex=Attributes

var $dGrdR = parcelRequire("dGrdR");
const $1d87f422c20d6fb4$var$APP_METRIC_KEY = 'software.next-gen.boards';
const $1d87f422c20d6fb4$var$COLUMN_CREATE_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.column.create`;
const $1d87f422c20d6fb4$var$COLUMN_CREATE_SLO = 4000;
const $1d87f422c20d6fb4$export$3009f6a98d0222d7 = {
    analyticKey: $1d87f422c20d6fb4$var$COLUMN_CREATE_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$COLUMN_CREATE_SLO
};
const $1d87f422c20d6fb4$export$7cece60792def420 = (0, $dGrdR.metrics).concurrent.interaction({
    key: $1d87f422c20d6fb4$var$COLUMN_CREATE_METRIC_KEY,
    histogram: {
        response: '50_100_150_200_300_500',
        result: '100_500_1000_2000_3000_4000_5000_6000'
    }
});
const $1d87f422c20d6fb4$var$COLUMN_RENAME_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.column.rename`;
const $1d87f422c20d6fb4$var$COLUMN_RENAME_SLO = 4000;
const $1d87f422c20d6fb4$export$e39ccf35fc62d1b = {
    analyticKey: $1d87f422c20d6fb4$var$COLUMN_RENAME_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$COLUMN_RENAME_SLO
};
const $1d87f422c20d6fb4$export$41003cf816bb8221 = (0, $dGrdR.metrics).concurrent.interaction({
    key: $1d87f422c20d6fb4$var$COLUMN_RENAME_METRIC_KEY,
    histogram: {
        response: '50_100_150_200_300_500',
        result: '100_500_1000_2000_3000_4000_5000_6000'
    }
});
const $1d87f422c20d6fb4$var$COLUMN_RANK_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.column.rank`;
const $1d87f422c20d6fb4$var$COLUMN_RANK_SLO = 2000;
const $1d87f422c20d6fb4$export$89b4c340d9939ed9 = {
    analyticKey: $1d87f422c20d6fb4$var$COLUMN_RANK_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$COLUMN_RANK_SLO
};
const $1d87f422c20d6fb4$export$b9f6994a9f080d4d = (0, $dGrdR.metrics).concurrent.interaction({
    key: $1d87f422c20d6fb4$var$COLUMN_RANK_METRIC_KEY,
    histogram: {
        response: '50_100_150_200_300_500',
        result: '100_500_1000_2000_3000_4000_5000_6000'
    }
});
const $1d87f422c20d6fb4$var$COLUMN_DELETE_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.column.delete`;
const $1d87f422c20d6fb4$var$COLUMN_DELETE_SLO = 4000;
const $1d87f422c20d6fb4$export$5b23342a6a197f18 = {
    analyticKey: $1d87f422c20d6fb4$var$COLUMN_DELETE_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$COLUMN_DELETE_SLO
};
const $1d87f422c20d6fb4$export$2c54f096c209762e = (0, $dGrdR.metrics).concurrent.interaction({
    key: $1d87f422c20d6fb4$var$COLUMN_DELETE_METRIC_KEY,
    histogram: {
        response: '50_100_150_200_300_500',
        result: '100_500_1000_2000_3000_4000_5000_6000'
    }
});
const $1d87f422c20d6fb4$var$COLUMN_SET_LIMIT_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.column.set-limit`;
const $1d87f422c20d6fb4$var$COLUMN_SET_LIMIT_SLO = 2000;
const $1d87f422c20d6fb4$export$58a3eac1c0822c79 = {
    analyticKey: $1d87f422c20d6fb4$var$COLUMN_SET_LIMIT_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$COLUMN_SET_LIMIT_SLO
};
const $1d87f422c20d6fb4$export$8c79986dfa78fcdf = (0, $dGrdR.metrics).interaction({
    key: $1d87f422c20d6fb4$var$COLUMN_SET_LIMIT_METRIC_KEY,
    histogram: {
        response: '50_100_150_200_300_500',
        result: '100_500_1000_2000_3000_4000_5000_6000'
    }
});
const $1d87f422c20d6fb4$var$BOARD_SCOPE_NON_CRITICAL_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.boardscope.non-critical`;
const $1d87f422c20d6fb4$var$BOARD_SCOPE_NON_CRITICAL_SLO = 1500;
const $1d87f422c20d6fb4$export$e97ac4cb4d0a1231 = {
    analyticKey: $1d87f422c20d6fb4$var$BOARD_SCOPE_NON_CRITICAL_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$BOARD_SCOPE_NON_CRITICAL_SLO
};
const $1d87f422c20d6fb4$var$CARD_CREATE_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.card.create`;
const $1d87f422c20d6fb4$var$CARD_CREATE_SLO = 1000;
const $1d87f422c20d6fb4$export$90f1c46b5c27e9d2 = {
    analyticKey: $1d87f422c20d6fb4$var$CARD_CREATE_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$CARD_CREATE_SLO
};
const $1d87f422c20d6fb4$var$LOAD_EXTENSION_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.load.extension`;
const $1d87f422c20d6fb4$var$LOAD_EXTENSION_SLO = 1000;
const $1d87f422c20d6fb4$export$7aa6483bdb308d69 = {
    analyticKey: $1d87f422c20d6fb4$var$LOAD_EXTENSION_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$LOAD_EXTENSION_SLO
};
const $1d87f422c20d6fb4$var$SET_USER_SWIMLANE_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.set.user.swimlane`;
const $1d87f422c20d6fb4$var$SET_USER_SWIMLANE_SLO = 1000;
const $1d87f422c20d6fb4$export$d62aa526ed93638f = {
    analyticKey: $1d87f422c20d6fb4$var$SET_USER_SWIMLANE_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$SET_USER_SWIMLANE_SLO
};
const $1d87f422c20d6fb4$var$BOARD_RENAME_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.board.rename`;
const $1d87f422c20d6fb4$var$BOARD_RENAME_SLO = 1000;
const $1d87f422c20d6fb4$export$c511eb222d867bfd = {
    analyticKey: $1d87f422c20d6fb4$var$BOARD_RENAME_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$BOARD_RENAME_SLO
};
const $1d87f422c20d6fb4$export$281157708c6b132a = (0, $dGrdR.metrics).interaction({
    key: 'jsw-complete-sprint-modal'
});
const $1d87f422c20d6fb4$var$DISMISS_MIGRATION_MODAL_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.board.migration.dismiss`;
const $1d87f422c20d6fb4$var$DISMISS_MIGRATION_MODAL_SLO = 1000;
const $1d87f422c20d6fb4$export$aabc7f67e3ae59ef = {
    analyticKey: $1d87f422c20d6fb4$var$DISMISS_MIGRATION_MODAL_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$DISMISS_MIGRATION_MODAL_SLO
};

});


parcelRegister("doOdQ", function(module, exports) {

$parcel$export(module.exports, "BACKLOG_ISSUE_MOVE_SHOW", () => $cca980f057656731$export$4cf2a2bfea1b391e);
$parcel$export(module.exports, "backlogIssueMoveShow", () => $cca980f057656731$export$d855544cc5ffa4f4);
$parcel$export(module.exports, "BACKLOG_ISSUE_MOVE_CANCEL", () => $cca980f057656731$export$94d3402bbf79157b);
$parcel$export(module.exports, "backlogIssueMoveCancel", () => $cca980f057656731$export$8ad0be7d3c5b884d);
$parcel$export(module.exports, "BACKLOG_ISSUE_MOVE_CONFIRM", () => $cca980f057656731$export$c7a3f3d486dc3983);
$parcel$export(module.exports, "backlogIssueMoveConfirm", () => $cca980f057656731$export$813ea7e4ff757951);
$parcel$export(module.exports, "BACKLOG_ISSUE_MOVE_EXECUTE", () => $cca980f057656731$export$8726de1bdb4de658);
$parcel$export(module.exports, "backlogIssueMoveExecute", () => $cca980f057656731$export$deb012b7ca9ae918);
$parcel$export(module.exports, "BACKLOG_ISSUE_MOVE_EXECUTE_SUCCESS", () => $cca980f057656731$export$2f753f18a8f89f7f);
$parcel$export(module.exports, "backlogIssueMoveExecuteSuccess", () => $cca980f057656731$export$306bba8cd988ac22);
$parcel$export(module.exports, "BACKLOG_ISSUE_MOVE_EXECUTE_FAILURE", () => $cca980f057656731$export$3ff51b6c3fbc7aa8);
$parcel$export(module.exports, "backlogIssueMoveExecuteFailure", () => $cca980f057656731$export$e67e8d09cf0c08f4);

var $9rND4 = parcelRequire("9rND4");
const $cca980f057656731$export$4cf2a2bfea1b391e = 'state.actions.board.backlog-issue-move.BACKLOG_ISSUE_MOVE_SHOW';
const $cca980f057656731$export$d855544cc5ffa4f4 = ()=>({
        type: $cca980f057656731$export$4cf2a2bfea1b391e
    });
const $cca980f057656731$export$94d3402bbf79157b = 'state.actions.board.backlog-issue-move.BACKLOG_ISSUE_MOVE_CANCEL';
const $cca980f057656731$export$8ad0be7d3c5b884d = ()=>({
        type: $cca980f057656731$export$94d3402bbf79157b
    });
const $cca980f057656731$export$c7a3f3d486dc3983 = 'state.actions.board.backlog-issue-move.BACKLOG_ISSUE_MOVE_CONFIRM';
const $cca980f057656731$export$813ea7e4ff757951 = ()=>({
        type: $cca980f057656731$export$c7a3f3d486dc3983
    });
const $cca980f057656731$export$8726de1bdb4de658 = 'state.actions.board.backlog-issue-move.BACKLOG_ISSUE_MOVE_EXECUTE';
const $cca980f057656731$export$deb012b7ca9ae918 = (issueIds)=>({
        type: $cca980f057656731$export$8726de1bdb4de658,
        payload: {
            issueIds: issueIds
        },
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    });
const $cca980f057656731$export$2f753f18a8f89f7f = 'state.actions.board.backlog-issue-move.BACKLOG_ISSUE_MOVE_EXECUTE_SUCCESS';
const $cca980f057656731$export$306bba8cd988ac22 = (optimisticId)=>({
        type: $cca980f057656731$export$2f753f18a8f89f7f,
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $cca980f057656731$export$3ff51b6c3fbc7aa8 = 'state.actions.board.backlog-issue-move.BACKLOG_ISSUE_MOVE_EXECUTE_FAILURE';
const $cca980f057656731$export$e67e8d09cf0c08f4 = (optimisticId)=>({
        type: $cca980f057656731$export$3ff51b6c3fbc7aa8,
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("jGHzz", function(module, exports) {

$parcel$export(module.exports, "boardDeferredDataLoadEpic", () => $1f363c3ed189fc20$export$213815e477b73dd5);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");
parcelRequire("6cbqE");

var $dJl1T = parcelRequire("dJl1T");

var $itF8x = parcelRequire("itF8x");

var $127QL = parcelRequire("127QL");

var $67Z81 = parcelRequire("67Z81");
const $1f363c3ed189fc20$var$handleFailure = (error)=>{
    (0, $dJl1T.default).safeErrorWithoutCustomerData('board.deferred-data.load.failure', 'Board deferred data failed to load', error);
    return (0, $kVLXA.Observable).of((0, $127QL.boardDeferredDataLoadFailure)());
};
const $1f363c3ed189fc20$var$handleSuccess = (result)=>(0, $kVLXA.Observable).of((0, $127QL.boardDeferredDataLoadSuccess)(result));
const $1f363c3ed189fc20$var$handleSuccessNoop = ()=>(0, $kVLXA.Observable).empty();
function $1f363c3ed189fc20$export$213815e477b73dd5(action$, store) {
    return action$.ofType((0, $127QL.BOARD_DEFERRED_DATA_LOAD)).switchMap(()=>{
        const state = store.getState();
        // Only applies to CMP boards
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        if (!isCMPBoard) return $1f363c3ed189fc20$var$handleSuccessNoop();
        return (0, $itF8x.boardDeferredDataService)(state).flatMap((result)=>$1f363c3ed189fc20$var$handleSuccess(result)).catch((error)=>$1f363c3ed189fc20$var$handleFailure(error));
    });
}

});
parcelRegister("itF8x", function(module, exports) {

$parcel$export(module.exports, "boardDeferredDataService", () => $0b9246f64e9774ba$export$92732d7626194f64);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("d0pqD");

var $4R6GH = parcelRequire("4R6GH");

var $2xFXk = parcelRequire("2xFXk");

var $c4Y0z = parcelRequire("c4Y0z");

var $kc6Ry = parcelRequire("kc6Ry");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $45cXl = parcelRequire("45cXl");
function $0b9246f64e9774ba$var$getParamsFromState(state) {
    const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
    const isSprintsEnabled = (0, $ebHh7.isSprintsEnabled)(state);
    const isJqlSwimlanesEnabled = (0, $45cXl.isSwimlanesByJqlAvailable)(state);
    const sprintIds = isSprintsEnabled ? Object.values((0, $ebHh7.getSprintEntities)(state)).map((sprint)=>sprint.id) : undefined;
    const isInlineColumnEditEnabled = (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).INLINE_COLUMN_EDIT);
    const fields = [
        ...isSprintsEnabled && !(0, $4R6GH.fg)('simplified_and_update_sprint_when_skip_extra') ? [
            'sprints_permission'
        ] : [],
        ...isJqlSwimlanesEnabled ? [
            'swimlanes_query'
        ] : [],
        ...isInlineColumnEditEnabled && !(0, $4R6GH.fg)('simplified_and_update_sprint_when_skip_extra') ? [
            'simplified_workflow'
        ] : []
    ];
    return {
        rapidViewId: rapidViewId,
        fields: fields,
        sprintIds: sprintIds
    };
}
function $0b9246f64e9774ba$var$transformResponse(state, { sprintsData: sprintsData, swimlanesData: swimlanesData, workflowData: workflowData }) {
    // The sprint data returned from deferred endpoint does not include everything, so fill out the sprint type with value from state, overriding updated values (canUpdateSprint).
    const existingSprints = (0, $ebHh7.getSprintEntities)(state);
    const sprints = sprintsData?.sprints.map(({ id: id, canUpdateSprint: canUpdateSprint })=>({
            ...existingSprints[id],
            canUpdateSprint: canUpdateSprint
        })) ?? undefined;
    // The swimlane data returned from the deferred endpoint is not complete, so fill out the swimlanes with value from state, while overriding updated values (query).
    const existingSwimlanes = (0, $67Z81.getEntities)(state).jqlSwimlanes.swimlanes;
    const jqlSwimlanes = swimlanesData ? existingSwimlanes.map((swimlane)=>({
            ...swimlane,
            query: swimlanesData.customSwimlanesData.swimlanes.find((s)=>String(s.id) === swimlane.id)?.query ?? swimlane.query
        })) : undefined;
    const isUsingSimplifiedWorkflow = workflowData?.isUsingSimplifiedWorkflow;
    return {
        sprints: sprints,
        jqlSwimlanes: jqlSwimlanes,
        isUsingSimplifiedWorkflow: isUsingSimplifiedWorkflow
    };
}
function $0b9246f64e9774ba$export$92732d7626194f64(state) {
    const params = $0b9246f64e9774ba$var$getParamsFromState(state);
    return params.fields.length ? (0, $c4Y0z.fetchBoardDeferredData)(params).map((response)=>$0b9246f64e9774ba$var$transformResponse(state, response)) : (0, $kVLXA.Observable).of({});
}

});
parcelRegister("c4Y0z", function(module, exports) {

$parcel$export(module.exports, "fetchBoardDeferredData", () => $8c74af111b0d8684$export$821f1f3b498e8a3a);

var $487fd = parcelRequire("487fd");
function $8c74af111b0d8684$export$821f1f3b498e8a3a({ rapidViewId: rapidViewId, fields: fields, sprintIds: sprintIds }) {
    return (0, $487fd.default)('/rest/greenhopper/1.0/xboard/work', {
        method: 'POST',
        body: JSON.stringify({
            rapidViewId: rapidViewId,
            fields: fields,
            sprintIds: sprintIds
        })
    });
}

});


parcelRegister("127QL", function(module, exports) {

$parcel$export(module.exports, "BOARD_DEFERRED_DATA_LOAD", () => $69e04667c910af41$export$488156a2acedb365);
$parcel$export(module.exports, "boardDeferredDataLoad", () => $69e04667c910af41$export$1377d0ddf952f96e);
$parcel$export(module.exports, "BOARD_DEFERRED_DATA_LOAD_SUCCESS", () => $69e04667c910af41$export$7d135eea66f1e179);
$parcel$export(module.exports, "boardDeferredDataLoadSuccess", () => $69e04667c910af41$export$aacf22e753eac02d);
$parcel$export(module.exports, "boardDeferredDataLoadFailure", () => $69e04667c910af41$export$a69030bf716a8538);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $69e04667c910af41$export$488156a2acedb365 = 'state.actions.board.deferred-data.BOARD_DEFERRED_DATA_LOAD';
const $69e04667c910af41$export$1377d0ddf952f96e = ()=>({
        type: $69e04667c910af41$export$488156a2acedb365
    });
const $69e04667c910af41$export$7d135eea66f1e179 = 'state.actions.board.deferred-data.BOARD_DEFERRED_DATA_LOAD_SUCCESS';
const $69e04667c910af41$export$aacf22e753eac02d = (data)=>({
        type: $69e04667c910af41$export$7d135eea66f1e179,
        payload: data
    });
const $69e04667c910af41$export$6127366444e01d37 = 'state.actions.board.deferred-data.BOARD_DEFERRED_DATA_LOAD_FAILURE';
const $69e04667c910af41$export$a69030bf716a8538 = ()=>({
        type: $69e04667c910af41$export$6127366444e01d37,
        meta: (0, $sdxnu.warningFlagMeta)({
            id: $69e04667c910af41$export$6127366444e01d37,
            titleMessage: (0, $7AVqz.default).boardDeferredDataFetchFailedTitle,
            descriptionMessage: (0, $7AVqz.default).boardDeferredDataFetchFailedDescription
        })
    });

});


parcelRegister("gT8Nn", function(module, exports) {

$parcel$export(module.exports, "boardFavouriteEpic", () => $023abee6a537bc22$export$4e1b6ecf03cefd35);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("9o0uh");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $dJl1T = parcelRequire("dJl1T");

var $1WPu2 = parcelRequire("1WPu2");

var $eXQym = parcelRequire("eXQym");

var $2xFXk = parcelRequire("2xFXk");

var $fC72p = parcelRequire("fC72p");

var $65C0W = parcelRequire("65C0W");

var $kc6Ry = parcelRequire("kc6Ry");

var $67Z81 = parcelRequire("67Z81");
function $023abee6a537bc22$export$4e1b6ecf03cefd35(action$, store) {
    return action$.ofType((0, $65C0W.SOFTWARE_APP_LOADED)).mergeMap(()=>{
        const state = store.getState();
        const rapidViewId = state.configuration.rapidViewId;
        const shouldRenderFavouriteButton = (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).RENDER_BOARD_FAVOURITE_HEADER_BUTTON);
        if (!rapidViewId || !shouldRenderFavouriteButton) return (0, $kVLXA.Observable).empty();
        const baseUrl = (0, $67Z81.contextPathSelector)(state);
        return (0, $kVLXA.Observable).fromPromise((0, $1WPu2.getFavorite)(baseUrl, {
            id: rapidViewId,
            type: (0, $eXQym.BOARDS_ITEM_TYPE)
        })).flatMap((isFavourite)=>(0, $kVLXA.Observable).of((0, $fC72p.setIsFavourite)(isFavourite))).catch((error)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('board.get-favourite.failure', 'Board failed to get favourite', error);
            return (0, $kVLXA.Observable).empty();
        });
    });
}

});
parcelRegister("1WPu2", function(module, exports) {

$parcel$export(module.exports, "getFavorite", () => $1961b1823763022d$export$fce5eda070ce88d0);

var $eusud = parcelRequire("eusud");
const $1961b1823763022d$export$959ca2ee969adb8d = (baseUrl, request)=>`${baseUrl}/rest/internal/2/favourites/${request.type}/${request.id}`;
const $1961b1823763022d$export$fce5eda070ce88d0 = async (baseUrl, request)=>(0, $eusud.performGetRequest)($1961b1823763022d$export$959ca2ee969adb8d(baseUrl, request));

});

parcelRegister("fC72p", function(module, exports) {

$parcel$export(module.exports, "SET_IS_FAVOURITE", () => $2e4582cc57659349$export$beee5c21ec9e5d60);
$parcel$export(module.exports, "setIsFavourite", () => $2e4582cc57659349$export$24a32ddf7656ac02);
const $2e4582cc57659349$export$beee5c21ec9e5d60 = 'state.actions.board.board-favourite.SET_IS_FAVOURITE';
const $2e4582cc57659349$export$24a32ddf7656ac02 = (isFavourite)=>({
        type: $2e4582cc57659349$export$beee5c21ec9e5d60,
        payload: {
            isFavourite: isFavourite
        }
    });

});

parcelRegister("65C0W", function(module, exports) {

$parcel$export(module.exports, "SOFTWARE_APP_LOADED", () => $af4c703fcf2c2b34$export$e4a71ef6d3a53f9f);
$parcel$export(module.exports, "softwareAppLoaded", () => $af4c703fcf2c2b34$export$5b3b8639617316c7);
$parcel$export(module.exports, "SOFTWARE_APP_INITIAL_STATE_LOADED", () => $af4c703fcf2c2b34$export$28370bb41782563c);
$parcel$export(module.exports, "SOFTWARE_DISPLAY_WARNING", () => $af4c703fcf2c2b34$export$3bce66e79613bc5);
$parcel$export(module.exports, "displayWarning", () => $af4c703fcf2c2b34$export$fca88e81122bb575);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $af4c703fcf2c2b34$export$e4a71ef6d3a53f9f = 'state.actions.software.SOFTWARE_APP_LOADED';
const $af4c703fcf2c2b34$export$5b3b8639617316c7 = (prefetchData = null, cmpBoardData = null)=>({
        type: $af4c703fcf2c2b34$export$e4a71ef6d3a53f9f,
        payload: {
            prefetchData: prefetchData,
            cmpBoardData: cmpBoardData
        }
    });
const $af4c703fcf2c2b34$export$28370bb41782563c = 'state.actions.software.SOFTWARE_APP_INITIAL_STATE_LOADED';
const $af4c703fcf2c2b34$export$50d71bea8315649f = ()=>({
        type: $af4c703fcf2c2b34$export$28370bb41782563c
    });
const $af4c703fcf2c2b34$export$3bce66e79613bc5 = 'state.actions.software.SOFTWARE_DISPLAY_WARNING';
const $af4c703fcf2c2b34$export$fca88e81122bb575 = (error)=>({
        type: $af4c703fcf2c2b34$export$3bce66e79613bc5,
        meta: (0, $sdxnu.warningFlagMeta)({
            titleMessage: (0, $7AVqz.default).genericTitle,
            descriptionMessage: error ? (0, $7AVqz.default).failureDescription : (0, $7AVqz.default).genericDescription,
            context: {
                error: Array.isArray(error) ? error.join('. ') : error
            }
        })
    });

});


parcelRegister("9KrY0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5563228d2ce9baa5$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6cbqE");
parcelRequire("1oQta");
parcelRequire("fp4O3");

var $cW3pH = parcelRequire("cW3pH");

var $67Z81 = parcelRequire("67Z81");
const $5563228d2ce9baa5$var$showMissingIssueTypeMessageEpic = (action$, store)=>action$.ofType((0, $cW3pH.WORK_DATA_SET)).filter(({ payload: payload })=>(0, $67Z81.getIsCMPBoard)(store.getState()) && !!payload?.missingIssueType).switchMap(({ payload: payload })=>(0, $kVLXA.Observable).of((0, $cW3pH.showMissingIssueTypeMessage)(`${payload.missingIssueType}`)));
var $5563228d2ce9baa5$export$2e2bcd8739ae039 = $5563228d2ce9baa5$var$showMissingIssueTypeMessageEpic;

});

parcelRegister("ivoZ6", function(module, exports) {

$parcel$export(module.exports, "displayFlagForIssuesFilteredOnServerEpic", () => $b1635913d88ff144$export$94543f588a9945cb);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fPS7b");
parcelRequire("6cbqE");
parcelRequire("1oQta");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("7mHDu");


var $bkCF5 = parcelRequire("bkCF5");

var $cW3pH = parcelRequire("cW3pH");

var $9UXXB = parcelRequire("9UXXB");
const $b1635913d88ff144$export$94543f588a9945cb = (action$, store)=>action$.ofType((0, $cW3pH.WORK_REFRESH_DATA)).filter(({ payload: payload })=>payload.source === (0, $dcbb2bce513725b3$export$7aa54af91613c70a)).filter(()=>(0, $9UXXB.getIsCustomBoardWithIcc)(store.getState())).switchMap((workRefreshDataAction)=>{
        const newIssues = workRefreshDataAction.payload.issues;
        // Do nothing if there are no new issues, or we have already shown a flag to let the user
        // know that the issue(s) is not visible on the board
        if (!newIssues?.length || workRefreshDataAction.payload.hasShownFlag) return (0, $kVLXA.Observable).empty();
        return action$.ofType((0, $cW3pH.WORK_DATA_SET)).take(1).mergeMap((workDataSetAction)=>{
            const boardIssuesSet = new Set(workDataSetAction.payload.issues.map((existingIssue)=>String(existingIssue.id)));
            const invisibleIssueKeys = newIssues.filter((newIssue)=>!boardIssuesSet.has(newIssue.issueId)).map((newIssue)=>newIssue.issueKey);
            if (invisibleIssueKeys.length) return (0, $kVLXA.Observable).of((0, $bkCF5.issueCreateFilteredV2)(invisibleIssueKeys, undefined, true));
            return (0, $kVLXA.Observable).empty();
        });
    });

});
parcelRegister("9UXXB", function(module, exports) {

$parcel$export(module.exports, "hasInlineCardCreateConfig", () => $bf77070a4338987d$export$ba9264a1c34ce4c2);
$parcel$export(module.exports, "getInlineCardCreateConfig", () => $bf77070a4338987d$export$28108d977d110000);
$parcel$export(module.exports, "getIsCustomBoardWithIcc", () => $bf77070a4338987d$export$78757dfac0be9638);
$parcel$export(module.exports, "getInlineCreateSessionId", () => $bf77070a4338987d$export$12a9e7e0a7f5b591);
$parcel$export(module.exports, "hasAnyPartialIcc", () => $bf77070a4338987d$export$b671685f7447c75d);
$parcel$export(module.exports, "createIsIccEnabledForCardType", () => $bf77070a4338987d$export$d09efa5cd727594e);
$parcel$export(module.exports, "isIccEnabledForColumnOrSwimlane", () => $bf77070a4338987d$export$13138fa53969b181);
$parcel$export(module.exports, "getShouldCreateWithSwimlaneContext", () => $bf77070a4338987d$export$a70828438c7709f);

var $dGvGJ = parcelRequire("dGvGJ");

var $gccSB = parcelRequire("gccSB");

var $gJBT6 = parcelRequire("gJBT6");

var $5rFbt = parcelRequire("5rFbt");

var $kgiLc = parcelRequire("kgiLc");


var $iuuJH = parcelRequire("iuuJH");

var $k8auG = parcelRequire("k8auG");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");

var $3WIXk = parcelRequire("3WIXk");
const $bf77070a4338987d$export$ba9264a1c34ce4c2 = (state)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))($bf77070a4338987d$export$28108d977d110000(state));
const $bf77070a4338987d$export$28108d977d110000 = (state)=>(0, $67Z81.getBoardConfig)(state).inlineCardCreate;
const $bf77070a4338987d$export$78757dfac0be9638 = (0, $dGvGJ.createSelector)([
    $bf77070a4338987d$export$28108d977d110000
], (config)=>config?.requireJqlContext === true || false);
const $bf77070a4338987d$export$1ca4cd34e6f2914c = (state)=>(0, $67Z81.getEntities)(state).inlineCreate;
const $bf77070a4338987d$export$12a9e7e0a7f5b591 = (0, $dGvGJ.createSelector)([
    $bf77070a4338987d$export$1ca4cd34e6f2914c
], (inlineCreateState)=>inlineCreateState?.sessionId);
const $bf77070a4338987d$export$b671685f7447c75d = (0, $dGvGJ.createSelector)([
    $bf77070a4338987d$export$28108d977d110000
], (config)=>config?.mode === (0, $c8d1b8aabfd899d6$export$c6861d2875ea3898) || Object.values(config?.columns ?? {}).some((column)=>column?.mode === (0, $c8d1b8aabfd899d6$export$c6861d2875ea3898) || Object.values(column?.issueTypes ?? {}).some((issueType)=>issueType === (0, $c8d1b8aabfd899d6$export$c6861d2875ea3898))));
const $bf77070a4338987d$export$d09efa5cd727594e = (0, $dGvGJ.createSelector)([
    $bf77070a4338987d$export$28108d977d110000
], (config)=>{
    const getConfigForCardType = (columnId, issueTypeId)=>(0, $3WIXk.isIccEnabledForBoard)(config) || (0, $3WIXk.isIccEnabledForColumn)(config?.columns?.[columnId], false) || (0, $3WIXk.isFullOrPartialMode)(config?.columns?.[columnId]?.issueTypes?.[issueTypeId]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getConfigForCardType, (columnId, issueTypeId)=>`${columnId}-${issueTypeId}`);
});
const $bf77070a4338987d$export$90eaa0d797c99f72 = (state)=>$bf77070a4338987d$var$mapColumnIdToIsIccEnabled(state);
const $bf77070a4338987d$export$13138fa53969b181 = (state, swimlaneId, columnId)=>swimlaneId && $bf77070a4338987d$var$isIccEnabledForColumnInSwimlane(state, swimlaneId, columnId) || $bf77070a4338987d$var$mapColumnIdToIsIccEnabled(state)[columnId];
const $bf77070a4338987d$var$mapColumnIdToIsIccEnabled = (0, $dGvGJ.createSelector)([
    (0, $5mTgl.workColumnsSelector),
    $bf77070a4338987d$export$28108d977d110000
], (columns, inlineCardCreateConfig)=>{
    const isIccEnabledInAllColumns = (0, $3WIXk.isIccEnabledForBoard)(inlineCardCreateConfig);
    return columns.reduce((acc, column)=>{
        acc[column.id] = isIccEnabledInAllColumns || (0, $3WIXk.isIccEnabledForColumn)(inlineCardCreateConfig?.columns?.[column.id]);
        return acc;
    }, {});
});
const $bf77070a4338987d$var$isIccEnabledForColumnInSwimlane = (state, swimlaneId, columnId)=>{
    const inlineCardCreate = $bf77070a4338987d$export$28108d977d110000(state);
    if (inlineCardCreate === undefined) return false;
    // Unscheduled work column swimlanes should have ICC enabled if their
    // regular swimlane is also allowed.
    const targetSwimlaneId = (0, $kgiLc.truncateUnscheduledWorkSwimlaneId)(swimlaneId, columnId === (0, $5rFbt.UNSCHEDULED_COLUMN_ID));
    const config = inlineCardCreate?.swimlanes?.[targetSwimlaneId];
    if (config === undefined) return false;
    if (typeof config === 'string') return config === (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b);
    if (typeof config === 'object') return config?.[columnId]?.mode === (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b);
};
const $bf77070a4338987d$export$a70828438c7709f = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIsCMPBoard),
    (0, $45cXl.getSwimlaneMode),
    (0, $k8auG.getJQLSwimlanesData)
], (isCMPBoard, swimlaneMode, jqlSwimlanesData)=>(swimlaneId)=>{
        if (!swimlaneId || !isCMPBoard || swimlaneMode !== (0, $iuuJH.SWIMLANE_BY_JQL).id) return false;
        const currentSwimlaneQuery = jqlSwimlanesData?.find((jqlSwimlane)=>jqlSwimlane.id === swimlaneId)?.query || '';
        return currentSwimlaneQuery !== '';
    });

});
const $c8d1b8aabfd899d6$export$c53d0f541b41b88e = 'NONE';
const $c8d1b8aabfd899d6$export$c6861d2875ea3898 = 'PARTIAL';
const $c8d1b8aabfd899d6$export$bb410559a65d3418 = 'MIXED';
const $c8d1b8aabfd899d6$export$3789e4b2a10baa2b = 'FULL';

parcelRegister("3WIXk", function(module, exports) {

$parcel$export(module.exports, "isFullOrPartialMode", () => $d4b1c6bd73471a37$export$b977e039f5321bc8);
$parcel$export(module.exports, "isIccEnabledForBoard", () => $d4b1c6bd73471a37$export$da5b0c54e4174c46);
$parcel$export(module.exports, "isIccEnabledForColumn", () => $d4b1c6bd73471a37$export$84781b659512b3e3);

const $d4b1c6bd73471a37$export$b977e039f5321bc8 = (mode)=>mode === 'FULL' || mode === 'PARTIAL';
const $d4b1c6bd73471a37$export$da5b0c54e4174c46 = (iccConfig)=>$d4b1c6bd73471a37$export$b977e039f5321bc8(iccConfig?.mode);
const $d4b1c6bd73471a37$export$84781b659512b3e3 = (iccColumnConfig, mixedCountsAsEnabled = true)=>$d4b1c6bd73471a37$export$b977e039f5321bc8(iccColumnConfig?.mode) || mixedCountsAsEnabled && iccColumnConfig?.mode === (0, $c8d1b8aabfd899d6$export$bb410559a65d3418);

});



parcelRegister("iUPbp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bd03208ac61b763$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $7zmUm = parcelRequire("7zmUm");


var $2bQEl = parcelRequire("2bQEl");

var $bRqd3 = parcelRequire("bRqd3");

var $cW3pH = parcelRequire("cW3pH");

var $67Z81 = parcelRequire("67Z81");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8bd03208ac61b763$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $bRqd3.CARD_MEDIA_TOGGLE_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const { meta: { optimistic: { id: txId } }, payload: payload } = action;
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
        return (0, $7zmUm.default)((0, $2bQEl.getCardMediaUrl)(contextPath, rapidViewId, payload), {
            method: 'PUT'
        }).flatMap(()=>(0, $kVLXA.Observable).of((0, $bRqd3.cardMediaToggleSuccess)(txId))).catch(()=>(0, $kVLXA.Observable).of(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $bRqd3.cardMediaToggleFailure)(txId), (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$d9d2fe902bd6d9a7))));
    });

});
parcelRegister("7zmUm", function(module, exports) {

$parcel$export(module.exports, "default", () => $198ed207dec01cca$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $aDvGo = parcelRequire("aDvGo");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $198ed207dec01cca$var$noContentStatus = 204;
var // This function returns a stream which emits a single string value on success, and throws
// an error on failure
// eslint-disable-next-line jira/import/no-anonymous-default-export
$198ed207dec01cca$export$2e2bcd8739ae039 = (url, options = {})=>(0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $aDvGo.default), options), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
            else throw new (0, $jJZqs.default)(status);
        }
        if (response.status === $198ed207dec01cca$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        // @ts-expect-error - TS2339 - Property 'responseText' does not exist on type 'Response'.
        return (0, $kVLXA.Observable).of(response.responseText || 'OK');
    });

});

parcelRegister("bRqd3", function(module, exports) {

$parcel$export(module.exports, "CARD_MEDIA_TOGGLE_REQUEST", () => $e75e8c8203ec2d0b$export$719306e34608019a);
$parcel$export(module.exports, "cardMediaToggleRequest", () => $e75e8c8203ec2d0b$export$4b1efbebdd54c3d);
$parcel$export(module.exports, "cardMediaToggleSuccess", () => $e75e8c8203ec2d0b$export$285b5a0a83782540);
$parcel$export(module.exports, "cardMediaToggleFailure", () => $e75e8c8203ec2d0b$export$f7ec8b763e0e34a9);
$parcel$export(module.exports, "TOGGLE_EPIC_LABELS", () => $e75e8c8203ec2d0b$export$8891d4381b655683);
$parcel$export(module.exports, "TOGGLE_BOARD_MENUS", () => $e75e8c8203ec2d0b$export$5f9ed1654c2cc426);
$parcel$export(module.exports, "toggleBoardMenus", () => $e75e8c8203ec2d0b$export$243850555d503a0e);
$parcel$export(module.exports, "SET_SHOW_UNSCHEDULED_COLUMN", () => $e75e8c8203ec2d0b$export$4abd03d3963e57b5);
$parcel$export(module.exports, "setShowUnscheduledColumn", () => $e75e8c8203ec2d0b$export$6edce735c6eb4cb0);
$parcel$export(module.exports, "SET_SHOW_OFFTRACK_DEPENDENCY_LINES", () => $e75e8c8203ec2d0b$export$93995bde3b9283cd);
$parcel$export(module.exports, "setShowOfftrackDependencyLines", () => $e75e8c8203ec2d0b$export$2c48063cd4ef1ade);
$parcel$export(module.exports, "SET_ISSUE_IDS_TO_SHOW_DEPENDENCIES", () => $e75e8c8203ec2d0b$export$5dae7370c17441a3);
$parcel$export(module.exports, "setIssueIdsToShowDependencies", () => $e75e8c8203ec2d0b$export$f7b68cb584e33d77);

var $9rND4 = parcelRequire("9rND4");
const $e75e8c8203ec2d0b$export$719306e34608019a = 'state.actions.board.menu.CARD_MEDIA_TOGGLE_REQUEST';
const $e75e8c8203ec2d0b$export$4b1efbebdd54c3d = (enabled)=>({
        type: $e75e8c8203ec2d0b$export$719306e34608019a,
        payload: enabled,
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    });
const $e75e8c8203ec2d0b$export$1fb38032498c251e = 'state.actions.board.menu.CARD_MEDIA_TOGGLE_SUCCESS';
const $e75e8c8203ec2d0b$export$285b5a0a83782540 = (optimisticId)=>({
        type: $e75e8c8203ec2d0b$export$1fb38032498c251e,
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $e75e8c8203ec2d0b$export$3a6ff55415f705db = 'state.actions.board.menu.CARD_MEDIA_TOGGLE_FAILURE';
const $e75e8c8203ec2d0b$export$f7ec8b763e0e34a9 = (optimisticId)=>({
        type: $e75e8c8203ec2d0b$export$3a6ff55415f705db,
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });
const $e75e8c8203ec2d0b$export$8891d4381b655683 = 'state.actions.board.menu.TOGGLE_EPIC_LABELS';
const $e75e8c8203ec2d0b$export$ee8c4e37e8444ea0 = ()=>({
        type: $e75e8c8203ec2d0b$export$8891d4381b655683
    });
const $e75e8c8203ec2d0b$export$5f9ed1654c2cc426 = 'state.actions.board.menu.TOGGLE_BOARD_MENUS';
const $e75e8c8203ec2d0b$export$243850555d503a0e = ()=>({
        type: $e75e8c8203ec2d0b$export$5f9ed1654c2cc426
    });
const $e75e8c8203ec2d0b$export$4abd03d3963e57b5 = 'state.actions.board.menu.SET_SHOW_UNSCHEDULED_COLUMN';
const $e75e8c8203ec2d0b$export$6edce735c6eb4cb0 = (isVisible)=>({
        type: $e75e8c8203ec2d0b$export$4abd03d3963e57b5,
        payload: isVisible
    });
const $e75e8c8203ec2d0b$export$93995bde3b9283cd = 'state.actions.board.menu.SET_SHOW_OFFTRACK_DEPENDENCY_LINES';
const $e75e8c8203ec2d0b$export$2c48063cd4ef1ade = (isVisible)=>({
        type: $e75e8c8203ec2d0b$export$93995bde3b9283cd,
        payload: isVisible
    });
const $e75e8c8203ec2d0b$export$5dae7370c17441a3 = 'state.actions.board.menu.SET_ISSUE_IDS_TO_SHOW_DEPENDENCIES';
const $e75e8c8203ec2d0b$export$f7b68cb584e33d77 = (issueIds)=>({
        type: $e75e8c8203ec2d0b$export$5dae7370c17441a3,
        payload: issueIds
    });

});


parcelRegister("8Wyzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $40e2e2eb84d7bcca$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("6cbqE");


var $53WSK = parcelRequire("53WSK");

var $7buQq = parcelRequire("7buQq");

var $cW3pH = parcelRequire("cW3pH");

var $67Z81 = parcelRequire("67Z81");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$40e2e2eb84d7bcca$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $7buQq.RENAME_BOARD_REQUEST)).switchMap((action)=>{
        const state = store.getState();
        const { meta: { optimistic: { id: txId } }, payload: payload } = action;
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
        return (0, $53WSK.boardRename)(contextPath, rapidViewId, payload).flatMap(()=>(0, $kVLXA.Observable).of((0, $7buQq.renameBoardSuccess)(txId))).catch(()=>(0, $kVLXA.Observable).of(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $7buQq.renameBoardFailure)(txId), (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$d9d2fe902bd6d9a7))));
    });

});
parcelRegister("53WSK", function(module, exports) {

$parcel$export(module.exports, "boardRename", () => $cae6afb0909c8563$export$8da1f9009157a0df);

var $ivqh1 = parcelRequire("ivqh1");

var $6iJbJ = parcelRequire("6iJbJ");

var $CFxE9 = parcelRequire("CFxE9");
const $cae6afb0909c8563$export$fb5697ad18168ddd = 'SoftwareBoardRename';
const $cae6afb0909c8563$export$4031368f5d20bd91 = (0, $ivqh1.gqlTagSwag)`
    mutation SoftwareBoardRename($boardId: ID!, $boardName: String!) {
        setBoardName(input: {boardId: $boardId, boardName: $boardName}) {
            boardName
        }
    }
`;
const $cae6afb0909c8563$export$8da1f9009157a0df = (contextPath, boardId, boardName)=>(0, $6iJbJ.mutation$)(contextPath, $cae6afb0909c8563$export$fb5697ad18168ddd, $cae6afb0909c8563$export$4031368f5d20bd91, {
        boardId: boardId,
        boardName: boardName
    }, (0, $CFxE9.boardRenameAnalyticsOptions));

});

parcelRegister("7buQq", function(module, exports) {

$parcel$export(module.exports, "RENAME_BOARD_REQUEST", () => $36bdd2cfb2ea3f95$export$b59e884cbd8a2072);
$parcel$export(module.exports, "renameBoardRequest", () => $36bdd2cfb2ea3f95$export$43cfff342e1dcc87);
$parcel$export(module.exports, "RENAME_BOARD_SUCCESS", () => $36bdd2cfb2ea3f95$export$5a20dd2dded5bbca);
$parcel$export(module.exports, "renameBoardSuccess", () => $36bdd2cfb2ea3f95$export$21475b90a48a2c95);
$parcel$export(module.exports, "RENAME_BOARD_FAILURE", () => $36bdd2cfb2ea3f95$export$f719aabfc87bc812);
$parcel$export(module.exports, "renameBoardFailure", () => $36bdd2cfb2ea3f95$export$244d02fac7e80a83);

var $9rND4 = parcelRequire("9rND4");
const $36bdd2cfb2ea3f95$export$b59e884cbd8a2072 = 'state.actions.board.rename.RENAME_BOARD_REQUEST';
const $36bdd2cfb2ea3f95$export$43cfff342e1dcc87 = (title)=>({
        type: $36bdd2cfb2ea3f95$export$b59e884cbd8a2072,
        payload: title,
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    });
const $36bdd2cfb2ea3f95$export$5a20dd2dded5bbca = 'state.actions.board.rename.RENAME_BOARD_SUCCESS';
const $36bdd2cfb2ea3f95$export$21475b90a48a2c95 = (optimisticId)=>({
        type: $36bdd2cfb2ea3f95$export$5a20dd2dded5bbca,
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $36bdd2cfb2ea3f95$export$f719aabfc87bc812 = 'state.actions.board.rename.RENAME_BOARD_FAILURE';
const $36bdd2cfb2ea3f95$export$244d02fac7e80a83 = (optimisticId)=>({
        type: $36bdd2cfb2ea3f95$export$f719aabfc87bc812,
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("dxMXW", function(module, exports) {

$parcel$export(module.exports, "bulkIssueRankTransitionRequestEpic", () => $ce592a45e2208b19$export$602946aa03c7ea46);
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("93e44");
parcelRequire("d6iim");
parcelRequire("1oQta");
parcelRequire("fPS7b");
parcelRequire("fjPtF");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $7Jxgt = parcelRequire("7Jxgt");

var $dJl1T = parcelRequire("dJl1T");

var $8zOmE = parcelRequire("8zOmE");


var $2W0EG = parcelRequire("2W0EG");

var $9iM6y = parcelRequire("9iM6y");

var $hdmw1 = parcelRequire("hdmw1");

var $4gHuj = parcelRequire("4gHuj");

var $71oFY = parcelRequire("71oFY");

var $cW3pH = parcelRequire("cW3pH");

var $lIysR = parcelRequire("lIysR");

var $fyeGd = parcelRequire("fyeGd");

var $3UY9S = parcelRequire("3UY9S");

var $vAfHD = parcelRequire("vAfHD");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $cN1y7 = parcelRequire("cN1y7");
const $ce592a45e2208b19$var$checkIfAnyIssueHasScreen = (state, payload)=>{
    const { issueIds: issueIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, transitionId: transitionId } = payload;
    const allIssues = (0, $vAfHD.boardIssuesSelector)(state);
    for (const issueId of issueIds){
        const issue = allIssues[String(issueId)];
        const destinationTransitions = (0, $lIysR.getTransitionsByColumnAndIssueType)(state, {
            columnId: destinationColumnId,
            issueTypeId: issue.typeId,
            projectId: issue.projectId
        });
        let selectedTransitionId = transitionId;
        // Set the new value based on the project key
        selectedTransitionId = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transitionId) && sourceColumnId !== destinationColumnId ? (0, $fyeGd.firstGlobalTransitionIdForColumnWithProjectFilteringSelector)(state)(destinationColumnId, issue) : transitionId;
        const transitionIndex = selectedTransitionId != null ? destinationTransitions.findIndex((transition)=>transition.id === transitionId) : null;
        const transition = transitionIndex != null ? destinationTransitions[transitionIndex] : null;
        if (transition?.hasScreen) return true;
    }
    return false;
};
const $ce592a45e2208b19$var$handleBulkIssueRankSuccess = ({ payload: payload, optimisticId: optimisticId, boardId: boardId, analyticsEvent: analyticsEvent })=>{
    if (analyticsEvent) {
        const { issueIds: issueIds, rankAfterId: rankAfterId, rankBeforeId: rankBeforeId, columnId: columnId } = payload;
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'bulkIssueRank success', {
            boardId: boardId,
            issueIds: issueIds,
            rankAfterId: rankAfterId,
            rankBeforeId: rankBeforeId,
            columnId: columnId
        });
    }
    return (0, $kVLXA.Observable).from([
        (0, $71oFY.bulkIssueRankSuccess)({
            payload: payload,
            optimisticId: optimisticId,
            analyticsEvent: analyticsEvent
        }),
        (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$5e8e8357f5d6fec1))
    ]);
};
const $ce592a45e2208b19$var$handleBulkIssueRankError = ({ payload: payload, optimisticId: optimisticId, boardId: boardId, error: error, analyticsEvent: analyticsEvent })=>{
    (0, $dJl1T.default).safeErrorWithoutCustomerData('bulk.issue.rank.failure', 'Failed to rank multiple issues', error);
    if (analyticsEvent && (0, $cN1y7.shouldFireFailureSLOMetric)(error)) {
        const { issueIds: issueIds, issueKeys: issueKeys, rankAfterId: rankAfterId, rankBeforeId: rankBeforeId, columnId: columnId } = payload;
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'bulkIssueRank failed', {
            errorMessage: error.message ? error.message : error,
            statusCodeGroup: (0, $cN1y7.getStatusCodeGroup)(error),
            boardId: boardId,
            issueIds: issueIds,
            issueKeys: issueKeys,
            rankAfterId: rankAfterId,
            rankBeforeId: rankBeforeId,
            columnId: columnId
        });
    }
    return (0, $kVLXA.Observable).of((0, $71oFY.bulkIssueRankFailure)({
        payload: payload,
        optimisticId: optimisticId,
        errorMessages: (0, $2W0EG.parseJiraErrorMessages)(error),
        analyticsEvent: analyticsEvent
    }));
};
const $ce592a45e2208b19$var$doBulkIssueRank = ({ request: request, columnId: columnId, boardId: boardId, analyticsEvent: analyticsEvent })=>{
    const { issueIds: issueIds, issueKeys: issueKeys, rankAfterId: rankAfterId, rankBeforeId: rankBeforeId } = request;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueIds)) return (0, $kVLXA.Observable).empty();
    const bulkIssueRankOptimisticAction = (0, $71oFY.bulkIssueRankOptimistic)({
        issueIds: issueIds,
        rankAfterId: rankAfterId,
        rankBeforeId: rankBeforeId
    });
    const optimisticId = bulkIssueRankOptimisticAction.meta.optimistic.id;
    return (0, $kVLXA.Observable).merge((0, $kVLXA.Observable).of(bulkIssueRankOptimisticAction), (0, $9iM6y.bulkIssueRankService)(request).flatMap(()=>$ce592a45e2208b19$var$handleBulkIssueRankSuccess({
            payload: {
                issueIds: issueIds,
                rankAfterId: rankAfterId,
                rankBeforeId: rankBeforeId,
                columnId: columnId
            },
            boardId: boardId,
            optimisticId: optimisticId,
            analyticsEvent: analyticsEvent
        })).catch((error)=>$ce592a45e2208b19$var$handleBulkIssueRankError({
            payload: {
                issueIds: issueIds,
                issueKeys: issueKeys,
                rankAfterId: rankAfterId,
                rankBeforeId: rankBeforeId,
                columnId: columnId
            },
            boardId: boardId,
            optimisticId: optimisticId,
            error: error,
            analyticsEvent: analyticsEvent
        })));
};
function $ce592a45e2208b19$export$602946aa03c7ea46(action$, store) {
    return action$.ofType((0, $71oFY.BULK_ISSUE_RANK_TRANSITION_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        const { rankCustomFieldId: rankCustomFieldId, boardIsRankable: boardIsRankable } = (0, $d2i8f.getRankConfig)(state);
        const { payload: { issueIds: issueIds, ...restPayload }, meta: { analyticsEvent: analyticsEvent } } = action;
        const { sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, rankAfterIssueId: rankAfterIssueId, rankBeforeIssueId: rankBeforeIssueId, transitionId: transitionId } = restPayload;
        // Transition screen check only works for single issue
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueIds) && issueIds.length > 1) {
            const canBulkRankIssues = isCMPBoard && boardIsRankable && sourceColumnId === destinationColumnId && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transitionId);
            // TNK-628: bulk issue rank within the same column
            if (canBulkRankIssues) {
                const request = {
                    customFieldId: rankCustomFieldId,
                    issueIds: issueIds,
                    issueKeys: (0, $d2i8f.getIssueKeysFromIssueIds)(state)(issueIds),
                    rankAfterId: rankAfterIssueId ?? null,
                    rankBeforeId: rankBeforeIssueId ?? null
                };
                const { boardId: boardId } = (0, $hdmw1.makeServiceContext)(state);
                return $ce592a45e2208b19$var$doBulkIssueRank({
                    request: request,
                    columnId: destinationColumnId,
                    boardId: boardId,
                    analyticsEvent: analyticsEvent
                });
            }
            const hasScreen = $ce592a45e2208b19$var$checkIfAnyIssueHasScreen(state, action.payload);
            if (hasScreen) return (0, $kVLXA.Observable).empty();
        }
        const getSortedIssuedIds = ()=>{
            const orderedAllIssueIds = isCMPBoard ? (0, $vAfHD.boardOrderedIssueIdsSelector)(state) : [
                ...(0, $67Z81.getOrderedIssueIds)(state),
                ...(0, $67Z81.getOrderedIssueChildrenIds)(state)
            ];
            const orderedIssueIds = orderedAllIssueIds.filter((issueId)=>issueIds.includes(issueId));
            // Fire the requests in the reverse order when ranking after an issue, so we will receive the right order within optimistic update
            if (rankAfterIssueId) orderedIssueIds.reverse();
            return orderedIssueIds;
        };
        const batchId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4();
        const shouldRetainRankingOrder = isCMPBoard && transitionId;
        const mode = shouldRetainRankingOrder ? 'TRANSITION_ONLY' : 'TRANSITION_AND_RANK';
        const bufferCount = shouldRetainRankingOrder ? 1 : issueIds.length;
        const requestActions$ = (0, $kVLXA.Observable).from(shouldRetainRankingOrder ? [
            (0, $71oFY.issueRankTransitionRequest)({
                issueIds: issueIds,
                batchId: batchId,
                mode: mode,
                ...restPayload,
                analyticsEvent: analyticsEvent
            })
        ] : getSortedIssuedIds().map((issueId)=>(0, $71oFY.issueRankTransitionRequest)({
                issueIds: [
                    issueId
                ],
                batchId: batchId,
                mode: mode,
                ...restPayload,
                analyticsEvent: analyticsEvent
            })));
        const resultActions$ = action$.ofType((0, $71oFY.ISSUE_RANK_TRANSITION_SUCCESS), (0, $71oFY.ISSUE_RANK_TRANSITION_FAILURE)).filter((resultAction)=>resultAction.payload.batchId === batchId).bufferCount(bufferCount).flatMap((bulkRankTransitionActions)=>{
            const success = bulkRankTransitionActions.every(({ type: type })=>type === (0, $71oFY.ISSUE_RANK_TRANSITION_SUCCESS));
            const actions = [];
            if (isCMPBoard && issueIds.length === 1) {
                const issueChild = (0, $3UY9S.getIssueChildren)(state)[issueIds[0]];
                const isDestinationLastColumn = (0, $fyeGd.isLastColumn)(state)(destinationColumnId);
                const isMoveIssueChildToFinalColumn = !!issueChild && isDestinationLastColumn;
                if (isMoveIssueChildToFinalColumn && issueChild?.parentId) actions.push((0, $4gHuj.issueChildrenInFinalColumnRequest)(issueChild.parentId));
            }
            if (isCMPBoard || !success) actions.push((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$ce2132697bb05fef)));
            return actions;
        });
        return requestActions$.merge(resultActions$);
    });
}

});
parcelRegister("2W0EG", function(module, exports) {

$parcel$export(module.exports, "flatErrorCollection", () => $a35e6abd1f710935$export$b3cd6c63b23466db);
$parcel$export(module.exports, "parseErrorCollection", () => $a35e6abd1f710935$export$3ff6e9345ed6c068);
$parcel$export(module.exports, "hasJiraErrorMessages", () => $a35e6abd1f710935$export$7ee986d35f407138);
$parcel$export(module.exports, "parseJiraErrorMessages", () => $a35e6abd1f710935$export$d11297bc34463f4);

var $9XE6b = parcelRequire("9XE6b");

var $g5X3G = parcelRequire("g5X3G");
const $a35e6abd1f710935$export$b3cd6c63b23466db = ({ errorMessages: errorMessages, errors: errors })=>[
        ...errorMessages,
        ...(0, $g5X3G.values)(errors).map((error)=>String(error))
    ];
const $a35e6abd1f710935$export$3ff6e9345ed6c068 = (value)=>{
    try {
        return JSON.parse(value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
};
const $a35e6abd1f710935$var$parseMessage = (error)=>{
    if (error === null || typeof error !== 'object') return null;
    try {
        const message = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'message'
        ], null);
        return JSON.parse(message);
    } catch  {
        return null;
    }
};
const $a35e6abd1f710935$var$hasErrorMessagesProperty = (response)=>response !== null && typeof response === 'object' && 'errorMessages' in response && Array.isArray(response.errorMessages);
function $a35e6abd1f710935$export$7ee986d35f407138(error) {
    const response = $a35e6abd1f710935$var$parseMessage(error);
    return $a35e6abd1f710935$var$hasErrorMessagesProperty(response) && response.errorMessages.length > 0;
}
function $a35e6abd1f710935$export$d11297bc34463f4(error) {
    const response = $a35e6abd1f710935$var$parseMessage(error);
    if ($a35e6abd1f710935$var$hasErrorMessagesProperty(response)) return response.errorMessages;
    return [];
}

});

parcelRegister("9iM6y", function(module, exports) {

$parcel$export(module.exports, "issueRankTransitionService", () => $f3edef2c3e1d93a0$export$9d336858bcd7405d);
$parcel$export(module.exports, "issueTransitionService", () => $f3edef2c3e1d93a0$export$ba3cd808df5aa712);
$parcel$export(module.exports, "bulkIssueRankService", () => $f3edef2c3e1d93a0$export$ba8ad8c2abac62ca);
/*!
 * This module contains services to perform the "issue rank transition"
 * interaction. It is the core interation on the board triggered by DnD.
 */ 
var $6IdBA = parcelRequire("6IdBA");

var $ebtJs = parcelRequire("ebtJs");
const $f3edef2c3e1d93a0$export$9d336858bcd7405d = (ctx, params)=>(0, $ebtJs.issueRankTransitionRest)({
        ...params,
        rapidViewId: ctx.boardId
    });
const $f3edef2c3e1d93a0$export$ba3cd808df5aa712 = (ctx, params)=>(0, $ebtJs.issueTransitionRest)({
        ...params,
        rapidViewId: ctx.boardId
    });
const $f3edef2c3e1d93a0$export$7b83c1de334ef96f = (boardCardMoveInput)=>(0, $6IdBA.fetchBoardCardMoveData)(boardCardMoveInput);
const $f3edef2c3e1d93a0$export$ba8ad8c2abac62ca = (request)=>(0, $ebtJs.bulkIssuesRankRest)(request);

});
parcelRegister("6IdBA", function(module, exports) {

$parcel$export(module.exports, "fetchBoardCardMoveData", () => $2db63b1697da1157$export$80d34452c0dfeb9f);

var $cyB0k = parcelRequire("cyB0k");

var $9XE6b = parcelRequire("9XE6b");

var $8Uumt = parcelRequire("8Uumt");

var $kVLXA = parcelRequire("kVLXA");

var $jJZqs = parcelRequire("jJZqs");

var $5yJb9 = parcelRequire("5yJb9");

var $3vXOY = parcelRequire("3vXOY");
const $2db63b1697da1157$var$commitMutationPromise = (environment, config)=>new Promise((resolve, reject)=>{
        (0, $8Uumt.commitMutation)(environment, {
            ...config,
            onCompleted: (payload, errors)=>{
                if (errors && errors.length) {
                    const statusCode = (0, $3vXOY.getStatusCodeFromGraphQLErrors)(errors);
                    if (statusCode == null) {
                        reject(errors);
                        return;
                    }
                    reject(new (0, $jJZqs.default)(statusCode, ''));
                    return;
                }
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(payload, 'boardCardMove.issuesWereTransitioned')) /**
         * reponse may return 200 with issuesWereTransitioned value of false or null.
         * It indicates a card move failure due to permission limit, not an server error.
         * an example would be a board viewer (no transit/rank permission) is trying to move a card to an empty column in a private/limited board.
         */ reject(new (0, $jJZqs.default)(400, 'Either transition or rank operation has failed'));
                resolve(payload);
            },
            onError: (error)=>{
                reject(error);
            }
        });
    });
const $2db63b1697da1157$export$80d34452c0dfeb9f = (boardCardMoveInput)=>(0, $kVLXA.Observable).fromPromise($2db63b1697da1157$var$commitMutationPromise((0, $5yJb9.default)(), {
        mutation: (0, $cyB0k.default),
        variables: {
            input: boardCardMoveInput
        }
    }));

});
parcelRegister("cyB0k", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcc86afb0e7a79a2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bc3d20ecb89f269e5ad3b832be7a9157>>
 * @relayHash 17884dd7a2725afd1ecddbac0203e0c6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 40d424bfde4b11217f082daf833da3f2b16249a245232509f69ddfc2ece3f52d
const $bcc86afb0e7a79a2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "MoveCardOutput",
            "kind": "LinkedField",
            "name": "boardCardMove",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientMutationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                },
                {
                    "kind": "ScalarField",
                    "name": "issuesWereTransitioned"
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "boardCardMoveGraphqlMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "boardCardMoveGraphqlMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "40d424bfde4b11217f082daf833da3f2b16249a245232509f69ddfc2ece3f52d",
            "metadata": {},
            "name": "boardCardMoveGraphqlMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$bcc86afb0e7a79a2$var$node.hash = "07779c221ada4d8e57caa4881dae0ab4";
var $bcc86afb0e7a79a2$export$2e2bcd8739ae039 = $bcc86afb0e7a79a2$var$node;

});

parcelRegister("3vXOY", function(module, exports) {

$parcel$export(module.exports, "getStatusCodeFromGraphQLErrors", () => $47b135a1579c5003$export$37c7f88726f3fb5e);
$parcel$export(module.exports, "extractStatusCode", () => $47b135a1579c5003$export$1fdf7c1c0741a7e7);

var $9XE6b = parcelRequire("9XE6b");

var $fEeCa = parcelRequire("fEeCa");
const $47b135a1579c5003$export$37c7f88726f3fb5e = (graphQLErrors)=>{
    const statusCodes = graphQLErrors.map((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
            'extensions',
            'statusCode'
        ])).filter((statusCode)=>!!statusCode);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($fEeCa)))(statusCodes);
    return statusCode || null;
};
const $47b135a1579c5003$export$1fdf7c1c0741a7e7 = (error)=>{
    const errorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'statusCode'
    ], null);
    const graphQLErrors = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'graphQLErrors'
    ], null);
    const networkError = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'networkError'
    ], null);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(networkError, [
        'statusCode'
    ], null);
    if (typeof errorStatusCode === 'number') return errorStatusCode;
    if (typeof statusCode === 'number') return statusCode;
    if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) return $47b135a1579c5003$export$37c7f88726f3fb5e(graphQLErrors);
    return null;
};

});
parcelRegister("fEeCa", function(module, exports) {

var $la2vn = parcelRequire("la2vn");

var $5JMmU = parcelRequire("5JMmU");

var $etyzk = parcelRequire("etyzk");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $b645ed9a7ba1767e$var$max(array) {
    return array && array.length ? $la2vn(array, $etyzk, $5JMmU) : undefined;
}
module.exports = $b645ed9a7ba1767e$var$max;

});
parcelRegister("la2vn", function(module, exports) {

var $4faK3 = parcelRequire("4faK3");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $f67c7999c5b61dcb$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$4faK3(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $f67c7999c5b61dcb$var$baseExtremum;

});

parcelRegister("5JMmU", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $42d6acb577163acc$var$baseGt(value, other) {
    return value > other;
}
module.exports = $42d6acb577163acc$var$baseGt;

});




parcelRegister("ebtJs", function(module, exports) {

$parcel$export(module.exports, "issueRankTransitionRest", () => $625414a6b60d7282$export$111e8fb2c8c47d7c);
$parcel$export(module.exports, "issueTransitionRest", () => $625414a6b60d7282$export$6ad92272c657c4f2);
$parcel$export(module.exports, "bulkIssuesRankRest", () => $625414a6b60d7282$export$2a0723596931d3);
parcelRequire("d0pqD");

var $487fd = parcelRequire("487fd");

var $jJZqs = parcelRequire("jJZqs");

var $2bQEl = parcelRequire("2bQEl");
const $625414a6b60d7282$var$FAIL_TO_TRANSITION_MESSAGE = 'Either transition or rank operation has failed';
const $625414a6b60d7282$var$FAIL_TO_BULK_RANK_MESSAGE = 'Bulk rank issue has failed';
function $625414a6b60d7282$export$111e8fb2c8c47d7c(request) {
    const url = (0, $2bQEl.getIssueTransitionWithoutColumnUrl)('');
    return (0, $487fd.default)(url, {
        method: 'PUT',
        body: JSON.stringify(request)
    }).map((response)=>{
        if (!response.issuesWereTransitioned) // The 'PUT /rest/greenhopper/1.0/board/issues/transition' may return HTTP 200 but either
        // transition or ranking may have failed.
        throw new (0, $jJZqs.default)(200, $625414a6b60d7282$var$FAIL_TO_TRANSITION_MESSAGE);
        return response;
    });
}
function $625414a6b60d7282$export$6ad92272c657c4f2(request) {
    const url = (0, $2bQEl.getIssueTransitionUrl)();
    return (0, $487fd.default)(url, {
        method: 'PUT',
        body: JSON.stringify(request)
    }).map((response)=>{
        if (!response.issuesWereTransitioned) throw new (0, $jJZqs.default)(200, $625414a6b60d7282$var$FAIL_TO_TRANSITION_MESSAGE);
        return response;
    });
}
function $625414a6b60d7282$export$2a0723596931d3(request) {
    const url = (0, $2bQEl.getBulkIssueRankUrl)();
    return (0, $487fd.default)(url, {
        method: 'PUT',
        body: JSON.stringify(request)
    }).map((response)=>{
        if (!response.rankableChanges.every((change)=>change.wasChanged)) throw new (0, $jJZqs.default)(200, $625414a6b60d7282$var$FAIL_TO_BULK_RANK_MESSAGE);
        return response;
    });
}

});


parcelRegister("hdmw1", function(module, exports) {

$parcel$export(module.exports, "makeServiceContext", () => $dddff9ba935cce70$export$47bf8333d7adacd0);
/*!
 * `ServiceContext` should be the first parameter of all service functions.
 *
 * Its purpouse is to have a pattern for switching between CMP/TMP
 * implementations of service calls.
 */ 
var $67Z81 = parcelRequire("67Z81");
function $dddff9ba935cce70$export$47bf8333d7adacd0(state) {
    return {
        boardId: (0, $67Z81.rapidViewIdSelector)(state),
        contextPath: state.configuration.contextPath,
        isCMPBoard: state.configuration.isCMPBoard,
        projectType: state.configuration.projectType,
        /**
		 * ARJ Increment Planning Board
		 */ isIncrementPlanningBoard: state.configuration.isIncrementPlanningBoard,
        planId: state.configuration.planId,
        scenarioId: state.configuration.scenarioId
    };
}

});

parcelRegister("4gHuj", function(module, exports) {

$parcel$export(module.exports, "SET_ISSUE_CHILDREN", () => $763f0d2a873de2fb$export$bad3c245445c8a02);
$parcel$export(module.exports, "setIssueChildren", () => $763f0d2a873de2fb$export$295fd024aec9d7fc);
$parcel$export(module.exports, "SET_ISSUE_CHILDREN_RANK", () => $763f0d2a873de2fb$export$dcc4baa31a152f1f);
$parcel$export(module.exports, "setIssueChildrenRank", () => $763f0d2a873de2fb$export$ace85f775492db73);
$parcel$export(module.exports, "ISSUE_CHILDREN_IN_FINAL_COLUMN_REQUEST", () => $763f0d2a873de2fb$export$397897ffe4d78f07);
$parcel$export(module.exports, "issueChildrenInFinalColumnRequest", () => $763f0d2a873de2fb$export$8013b6ba4a423c1e);
const $763f0d2a873de2fb$export$bad3c245445c8a02 = 'state.actions.issue-children.SET_ISSUE_CHILDREN';
const $763f0d2a873de2fb$export$295fd024aec9d7fc = (issueChildren)=>({
        type: $763f0d2a873de2fb$export$bad3c245445c8a02,
        payload: issueChildren
    });
const $763f0d2a873de2fb$export$dcc4baa31a152f1f = 'state.actions.issue-children.SET_ISSUE_CHILDREN_RANK';
const $763f0d2a873de2fb$export$ace85f775492db73 = ({ issueIds: issueIds, rankId: rankId, isRankAfter: isRankAfter })=>({
        type: $763f0d2a873de2fb$export$dcc4baa31a152f1f,
        payload: {
            issueIds: issueIds,
            rankId: rankId,
            isRankAfter: isRankAfter
        }
    });
const $763f0d2a873de2fb$export$397897ffe4d78f07 = 'state.actions.issue-children.ISSUE_CHILDREN_IN_FINAL_COLUMN_REQUEST';
const $763f0d2a873de2fb$export$8013b6ba4a423c1e = (parentId)=>({
        type: $763f0d2a873de2fb$export$397897ffe4d78f07,
        payload: {
            parentId: parentId
        }
    });
const $763f0d2a873de2fb$export$178eb342582389a5 = 'state.actions.issue.mentions.CLEAR_ISSUE_CHILDREN_MENTIONS_OPTIMISTIC';
const $763f0d2a873de2fb$export$497ab62da21b0596 = (issueId)=>({
        type: $763f0d2a873de2fb$export$178eb342582389a5,
        payload: {
            issueId: issueId
        }
    });

});

parcelRegister("71oFY", function(module, exports) {

$parcel$export(module.exports, "ISSUE_MOVE_TOP_OR_BOTTOM_OF_CONTAINER", () => $9f8e1ddea3adc68b$export$b80f022994c740bc);
$parcel$export(module.exports, "issueMoveToTopOrBottomOfContainer", () => $9f8e1ddea3adc68b$export$2ff1e3c40336316d);
$parcel$export(module.exports, "ISSUE_RANK_TRANSITION_REQUEST", () => $9f8e1ddea3adc68b$export$938599f8d9ebcd04);
$parcel$export(module.exports, "issueRankTransitionRequest", () => $9f8e1ddea3adc68b$export$2ad8924ae4613236);
$parcel$export(module.exports, "ISSUE_RANK_TRANSITION_SUCCESS", () => $9f8e1ddea3adc68b$export$b3d13442a2ed1704);
$parcel$export(module.exports, "issueRankTransitionSuccess", () => $9f8e1ddea3adc68b$export$fc64d70c84553912);
$parcel$export(module.exports, "issueRankTransitionAbort", () => $9f8e1ddea3adc68b$export$5a1d2ddad6ab4718);
$parcel$export(module.exports, "ISSUE_RANK_TRANSITION_FAILURE", () => $9f8e1ddea3adc68b$export$d3e0b64e628deb4e);
$parcel$export(module.exports, "issueRankTransitionFailure", () => $9f8e1ddea3adc68b$export$ade8b8e0a05059d7);
$parcel$export(module.exports, "issueRankTransitionFailureFieldRequired", () => $9f8e1ddea3adc68b$export$d43c922db5540629);
$parcel$export(module.exports, "SET_ISSUES_RANK", () => $9f8e1ddea3adc68b$export$bf5069f2a3267b16);
$parcel$export(module.exports, "setIssuesRank", () => $9f8e1ddea3adc68b$export$fb8df558645d5a07);
$parcel$export(module.exports, "BULK_ISSUE_RANK_TRANSITION_REQUEST", () => $9f8e1ddea3adc68b$export$ac1d3ac6f7579174);
$parcel$export(module.exports, "bulkIssueRankTransitionRequest", () => $9f8e1ddea3adc68b$export$8e38daa216161e13);
$parcel$export(module.exports, "BULK_ISSUE_RANK_OPTIMISTIC", () => $9f8e1ddea3adc68b$export$9f14d1e314ad435a);
$parcel$export(module.exports, "bulkIssueRankOptimistic", () => $9f8e1ddea3adc68b$export$56be38daffc22c8e);
$parcel$export(module.exports, "bulkIssueRankSuccess", () => $9f8e1ddea3adc68b$export$6c201115eb201f20);
$parcel$export(module.exports, "bulkIssueRankFailure", () => $9f8e1ddea3adc68b$export$b60518cba10c4e49);
$parcel$export(module.exports, "ISSUE_RANK_TRANSITION_UPDATE_OPTIMISTIC", () => $9f8e1ddea3adc68b$export$283d056fd81e831b);
$parcel$export(module.exports, "issueRankTransitionUpdateOptimistic", () => $9f8e1ddea3adc68b$export$6b9877d4e7f0e46e);

var $4R6GH = parcelRequire("4R6GH");

var $4O0IR = parcelRequire("4O0IR");

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");

var $9rND4 = parcelRequire("9rND4");
const $9f8e1ddea3adc68b$export$b80f022994c740bc = 'state.actions.issue.rank-transition.ISSUE_MOVE_TOP_OR_BOTTOM_OF_CONTAINER';
const $9f8e1ddea3adc68b$export$2ff1e3c40336316d = (placement, fireShortcutAnalyticsFn, analyticsEvent)=>({
        type: $9f8e1ddea3adc68b$export$b80f022994c740bc,
        payload: {
            placement: placement,
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $9f8e1ddea3adc68b$export$938599f8d9ebcd04 = 'state.actions.issue.rank-transition.ISSUE_RANK_TRANSITION_REQUEST';
const $9f8e1ddea3adc68b$export$2ad8924ae4613236 = ({ issueIds: issueIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId, isSourceDone: isSourceDone, isDestinationDone: isDestinationDone, transitionId: transitionId, sourceStatus: sourceStatus, destinationStatus: destinationStatus, isRankable: isRankable, batchId: batchId, mode: mode = 'TRANSITION_AND_RANK', analyticsEvent: analyticsEvent })=>({
        type: $9f8e1ddea3adc68b$export$938599f8d9ebcd04,
        payload: {
            issueIds: issueIds,
            sourceColumnId: sourceColumnId,
            destinationColumnId: destinationColumnId,
            rankBeforeIssueId: rankBeforeIssueId,
            rankAfterIssueId: rankAfterIssueId,
            sourceSwimlaneId: sourceSwimlaneId,
            destinationSwimlaneId: destinationSwimlaneId,
            isSourceDone: isSourceDone,
            isDestinationDone: isDestinationDone,
            transitionId: transitionId,
            sourceStatus: sourceStatus,
            destinationStatus: destinationStatus,
            isRankable: isRankable,
            batchId: batchId,
            mode: mode
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $9f8e1ddea3adc68b$export$b3d13442a2ed1704 = 'state.actions.issue.rank-transition.ISSUE_RANK_TRANSITION_SUCCESS';
const $9f8e1ddea3adc68b$export$fc64d70c84553912 = ({ optimisticId: optimisticId, issueIds: issueIds, batchId: batchId, analyticsEvent: analyticsEvent, issueKeys: issueKeys, destinationStatus: destinationStatus })=>({
        type: $9f8e1ddea3adc68b$export$b3d13442a2ed1704,
        payload: {
            issueIds: issueIds,
            batchId: batchId
        },
        meta: {
            ...(0, $9rND4.commitOptimisticUiMeta)(optimisticId),
            ...issueKeys && issueKeys.length === 1 && (0, $4R6GH.fg)('show-success-flag-for-jsw-board-card-transition') && (0, $sdxnu.successFlagMeta)({
                id: 'issueTransitionSuccessful',
                titleMessage: (0, $4O0IR.default).issueTransitionSuccessfulWithIssueKeyAndStatus,
                descriptionMessage: (0, $4O0IR.default).issueTransitionSuccessfulFlagDescription,
                context: {
                    issueKey: issueKeys[0],
                    status: destinationStatus
                }
            }),
            analyticsEvent: analyticsEvent
        }
    });
const $9f8e1ddea3adc68b$export$fae66629a3d8d258 = 'state.actions.issue.rank-transition.ISSUE_RANK_TRANSITION_ABORT';
const $9f8e1ddea3adc68b$export$5a1d2ddad6ab4718 = (optimisticId)=>({
        type: $9f8e1ddea3adc68b$export$fae66629a3d8d258,
        meta: {
            ...(0, $9rND4.revertOptimisticUiMeta)(optimisticId)
        }
    });
const $9f8e1ddea3adc68b$export$d3e0b64e628deb4e = 'state.actions.issue.rank-transition.ISSUE_RANK_TRANSITION_FAILURE';
const $9f8e1ddea3adc68b$export$ade8b8e0a05059d7 = (optimisticId, batchId)=>({
        type: $9f8e1ddea3adc68b$export$d3e0b64e628deb4e,
        payload: {
            batchId: batchId
        },
        meta: {
            ...(0, $9rND4.revertOptimisticUiMeta)(optimisticId),
            ...(0, $sdxnu.errorFlagMeta)({
                titleMessage: (0, $7AVqz.default).issueRankFailTitle,
                descriptionMessage: (0, $7AVqz.default).issueRankFailDescription
            })
        }
    });
const $9f8e1ddea3adc68b$export$e99298839edfb128 = 'state.actions.issue.rank-transition.ISSUE_RANK_TRANSITION_FAILURE_FIELD_REQUIRED';
const $9f8e1ddea3adc68b$export$d43c922db5540629 = (optimisticId, issueKey, errorMessages)=>({
        type: $9f8e1ddea3adc68b$export$e99298839edfb128,
        payload: {
            issueKey: issueKey,
            errorMessages: errorMessages
        },
        meta: {
            ...(0, $9rND4.revertOptimisticUiMeta)(optimisticId),
            ...(0, $sdxnu.warningFlagMeta)({
                id: $9f8e1ddea3adc68b$export$e99298839edfb128,
                titleMessage: (0, $7AVqz.default).issueRankFailFieldRequiredTitle,
                descriptionMessage: (0, $7AVqz.default).issueRankFailFieldRequiredDescription,
                context: {
                    issueKey: issueKey,
                    errorMessage: errorMessages.join('\n\n')
                }
            })
        }
    });
const $9f8e1ddea3adc68b$export$bf5069f2a3267b16 = 'state.actions.issue.rank-transition.SET_ISSUES_RANK';
const $9f8e1ddea3adc68b$export$fb8df558645d5a07 = ({ issueIds: issueIds, rankId: rankId, isRankAfter: isRankAfter })=>({
        type: $9f8e1ddea3adc68b$export$bf5069f2a3267b16,
        payload: {
            issueIds: issueIds,
            rankId: rankId,
            isRankAfter: isRankAfter
        }
    });
const $9f8e1ddea3adc68b$export$ac1d3ac6f7579174 = 'state.actions.issue.rank-transition.BULK_ISSUE_RANK_TRANSITION_REQUEST';
const $9f8e1ddea3adc68b$export$8e38daa216161e13 = ({ issueIds: issueIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId, isSourceDone: isSourceDone, isDestinationDone: isDestinationDone, transitionId: transitionId, sourceStatus: sourceStatus, destinationStatus: destinationStatus, isRankable: isRankable, analyticsEvent: analyticsEvent })=>({
        type: $9f8e1ddea3adc68b$export$ac1d3ac6f7579174,
        payload: {
            issueIds: issueIds,
            sourceColumnId: sourceColumnId,
            destinationColumnId: destinationColumnId,
            rankBeforeIssueId: rankBeforeIssueId,
            rankAfterIssueId: rankAfterIssueId,
            sourceSwimlaneId: sourceSwimlaneId,
            destinationSwimlaneId: destinationSwimlaneId,
            isSourceDone: isSourceDone,
            isDestinationDone: isDestinationDone,
            transitionId: transitionId,
            sourceStatus: sourceStatus,
            destinationStatus: destinationStatus,
            isRankable: isRankable
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $9f8e1ddea3adc68b$export$9f14d1e314ad435a = 'state.actions.issue.rank-transition.BULK_ISSUE_RANK_OPTIMISTIC';
const $9f8e1ddea3adc68b$export$56be38daffc22c8e = (payload)=>({
        type: $9f8e1ddea3adc68b$export$9f14d1e314ad435a,
        payload: payload,
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)()
        }
    });
const $9f8e1ddea3adc68b$export$99245ad6da62415e = 'state.actions.issue.rank-transition.BULK_ISSUE_RANK_SUCCESS';
const $9f8e1ddea3adc68b$export$6c201115eb201f20 = ({ payload: payload, optimisticId: optimisticId, analyticsEvent: analyticsEvent })=>({
        type: $9f8e1ddea3adc68b$export$99245ad6da62415e,
        payload: payload,
        meta: {
            ...(0, $9rND4.commitOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });
const $9f8e1ddea3adc68b$export$c0ad1cdc93728592 = 'state.actions.issue.rank-transition.BULK_ISSUE_RANK_FAILURE';
const $9f8e1ddea3adc68b$export$b60518cba10c4e49 = ({ payload: payload, optimisticId: optimisticId, errorMessages: errorMessages, analyticsEvent: analyticsEvent })=>({
        type: $9f8e1ddea3adc68b$export$c0ad1cdc93728592,
        payload: payload,
        meta: {
            ...(0, $9rND4.revertOptimisticUiMeta)(optimisticId),
            ...(0, $sdxnu.errorFlagMeta)({
                id: $9f8e1ddea3adc68b$export$c0ad1cdc93728592,
                titleMessage: (0, $7AVqz.default).bulkIssueRankFailTitle,
                descriptionMessage: (0, $7AVqz.default).issueRankFailDescription,
                errorMessages: errorMessages,
                context: {
                    issueKey: payload.issueKeys.join(', '),
                    errorMessage: errorMessages.join('\n\n')
                }
            }),
            analyticsEvent: analyticsEvent
        }
    });
const $9f8e1ddea3adc68b$export$283d056fd81e831b = 'state.actions.issue.rank-transition.ISSUE_RANK_TRANSITION_UPDATE_OPTIMISTIC';
const $9f8e1ddea3adc68b$export$6b9877d4e7f0e46e = ({ analyticsEvent: analyticsEvent, ...payload })=>({
        type: $9f8e1ddea3adc68b$export$283d056fd81e831b,
        payload: payload,
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });

});
parcelRegister("4O0IR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d201576bd998790a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d201576bd998790a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueTransitionSuccessful: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful",
        "defaultMessage": "Issue has been updated."
    },
    issueTransitionSuccessfulWithIssueKeyAndStatus: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-with-issue-key-and-status",
        "defaultMessage": "{issueKey} moved to {status}."
    },
    issueTransitionSuccessfulFlagDescription: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-flag-description",
        "defaultMessage": "Kudos for keeping things up-to-date!"
    },
    issueTransitionFailure: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure",
        "defaultMessage": "Issue could not be updated."
    },
    issueTransitionFailureWithKey: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-with-key",
        "defaultMessage": "We couldn't update {issueKey}."
    },
    viewIssue: {
        "id": "issue-transition-use-show-flag.use-show-flag.view-issue",
        "defaultMessage": "View issue"
    },
    issueTransitionSuccessfulIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-issue-term-refresh",
        "defaultMessage": "Issue has been updated."
    },
    issueTransitionSuccessfulWithIssueKeyAndStatusIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-with-issue-key-and-status-issue-term-refresh",
        "defaultMessage": "{issueKey} moved to {status}."
    },
    issueTransitionFailureIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-issue-term-refresh",
        "defaultMessage": "Issue could not be updated."
    },
    issueTransitionFailureWithKeyIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-with-key-issue-term-refresh",
        "defaultMessage": "We couldn't update {issueKey}."
    },
    viewIssueIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.view-issue-issue-term-refresh",
        "defaultMessage": "View issue"
    }
});

});


parcelRegister("lIysR", function(module, exports) {

$parcel$export(module.exports, "activeTransitionNameSelector", () => $8871cd8632f54a14$export$e88249bdda95e0a2);
$parcel$export(module.exports, "isActiveTransitionGlobalSelector", () => $8871cd8632f54a14$export$f2578d43a9cf8c67);
$parcel$export(module.exports, "activeTransitionDestinationStatusSelector", () => $8871cd8632f54a14$export$85da65aa4d428a9a);
$parcel$export(module.exports, "cardTransitionDestinationStatusSelector", () => $8871cd8632f54a14$export$e07fcec45e31ecae);
$parcel$export(module.exports, "cardTransitionSourceStatusSelector", () => $8871cd8632f54a14$export$c0177cb7a0156468);
$parcel$export(module.exports, "draggingIssueTransitionsForColumnSelector", () => $8871cd8632f54a14$export$6493de80e7420969);
$parcel$export(module.exports, "makeGetShowAllTransitionZones", () => $8871cd8632f54a14$export$96d2b9c7793d0852);
$parcel$export(module.exports, "shouldDisableDropOnColumn", () => $8871cd8632f54a14$export$98f9342952b17976);
$parcel$export(module.exports, "hasDifferentIssueTypeTransitionsInColumns", () => $8871cd8632f54a14$export$ea5b40548774f675);
$parcel$export(module.exports, "getTransitionsByColumnAndIssueType", () => $8871cd8632f54a14$export$162369d1646e3e2d);
$parcel$export(module.exports, "transitionsByColumnIdSelector", () => $8871cd8632f54a14$export$291fa08de619b517);

var $dGvGJ = parcelRequire("dGvGJ");

var $k8IPx = parcelRequire("k8IPx");

var $hGgHi = parcelRequire("hGgHi");

var $gJBT6 = parcelRequire("gJBT6");

var $gULOk = parcelRequire("gULOk");

var $dJl1T = parcelRequire("dJl1T");

var $iuuJH = parcelRequire("iuuJH");

var $9OPlz = parcelRequire("9OPlz");

var $vAfHD = parcelRequire("vAfHD");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");
const $8871cd8632f54a14$export$8473f1f08dc4b3e9 = (0, $dGvGJ.createSelector)([
    (0, $9OPlz.getCardDragState)
], (dragState)=>dragState.cardId != null && dragState.overTransition != null ? dragState.overTransition : undefined);
const $8871cd8632f54a14$export$e88249bdda95e0a2 = (0, $dGvGJ.createSelector)([
    (0, $9OPlz.draggingCardIssueTypeId),
    $8871cd8632f54a14$export$8473f1f08dc4b3e9,
    (0, $67Z81.getCardTransitions)
], (issueTypeId, activeTransition, cardTransitions)=>activeTransition && cardTransitions.columnIssueTypeTransitions[String(activeTransition.toColumnId)][String(issueTypeId)].filter((transition)=>transition.id === activeTransition.transitionId)[0].name);
const $8871cd8632f54a14$export$f2578d43a9cf8c67 = (0, $dGvGJ.createSelector)([
    (0, $9OPlz.draggingCardIssueTypeId),
    $8871cd8632f54a14$export$8473f1f08dc4b3e9,
    (0, $67Z81.getCardTransitions)
], (issueTypeId, activeTransition, cardTransitions)=>activeTransition && cardTransitions.columnIssueTypeTransitions[String(activeTransition.toColumnId)][String(issueTypeId)].filter((transition)=>transition.id === activeTransition.transitionId)[0].isGlobal || false);
const $8871cd8632f54a14$export$85da65aa4d428a9a = (0, $dGvGJ.createSelector)([
    (0, $9OPlz.draggingCardIssueTypeId),
    $8871cd8632f54a14$export$8473f1f08dc4b3e9,
    (0, $67Z81.getCardTransitions)
], (issueTypeId, activeTransition, cardTransitions)=>{
    const destinationStatusId = activeTransition && cardTransitions.columnIssueTypeTransitions[String(activeTransition.toColumnId)][String(issueTypeId)].filter((transition)=>transition.id === activeTransition.transitionId)[0].destinationStatusId;
    return destinationStatusId != null ? cardTransitions.issueTypeStatus[String(issueTypeId)][String(destinationStatusId)] : undefined;
});
const $8871cd8632f54a14$export$e07fcec45e31ecae = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $9OPlz.getSelectedTransition),
    (0, $67Z81.getCardTransitions)
], (boardIssues, selectedTransition, cardTransitions)=>(issueId, destinationColumnId)=>{
        const issueTypeId = boardIssues[String(issueId)]?.typeId;
        if (!issueTypeId) return undefined;
        const destinationTransitions = cardTransitions.columnIssueTypeTransitions[destinationColumnId]?.[String(issueTypeId)];
        if (!destinationTransitions?.length) return undefined;
        const destinationTransition = selectedTransition ? destinationTransitions.find(({ id: id })=>id === selectedTransition.transitionId) : destinationTransitions[0];
        return destinationTransition ? cardTransitions.issueTypeStatus[String(issueTypeId)][destinationTransition.destinationStatusId] : undefined;
    });
const $8871cd8632f54a14$export$c0177cb7a0156468 = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $67Z81.getCardTransitions)
], (boardIssues, cardTransitions)=>(issueId)=>{
        const issue = boardIssues[String(issueId)];
        if (!issue) return undefined;
        const { statusId: statusId, typeId: typeId } = issue;
        return cardTransitions.issueTypeStatus[typeId]?.[statusId];
    });
const $8871cd8632f54a14$var$emptyArray = [];
const $8871cd8632f54a14$var$getColumnTransitions = (cardTransitions, issueTypeId, issueStatusId, destinationColumnId, draggingCard, issueProjects)=>{
    // Per column transitions, with filtering by project key and
    // source/destination statuses.
    const columnTransitions = cardTransitions.columnIssueTypeTransitions?.[String(destinationColumnId)]?.[String(issueTypeId)];
    const projectKey = draggingCard ? Object.values(issueProjects).find((project)=>project.id === draggingCard.projectId)?.key : null;
    if (columnTransitions && Array.isArray(columnTransitions)) {
        const statuses = cardTransitions.issueTypeStatus[String(issueTypeId)];
        return {
            transitions: columnTransitions.filter((transition)=>!transition.isInitial && (transition.sourceStatusId === issueStatusId || transition.isGlobal)).filter((transition)=>projectKey == null || transition.projectKey === projectKey).filter((transition)=>statuses[String(transition.destinationStatusId)]).map((transition)=>{
                const toStatus = statuses[String(transition.destinationStatusId)];
                return {
                    transitionId: transition.id,
                    transitionName: transition.name,
                    targetStatusName: toStatus.name,
                    targetStatusId: transition.destinationStatusId,
                    targetStatusCategory: toStatus.category || (0, $gULOk.IN_PROGRESS),
                    isGlobal: transition.isGlobal,
                    isAvailable: true
                };
            })
        };
    }
    return {
        transitions: $8871cd8632f54a14$var$emptyArray
    };
};
const $8871cd8632f54a14$var$getDraggingCard = (0, $dGvGJ.createSelector)([
    (0, $9OPlz.getDraggingCardId),
    (0, $d2i8f.getIssueOrIssueChildById)
], (draggingCardId, getIssueFn)=>getIssueFn(draggingCardId));
const $8871cd8632f54a14$export$6493de80e7420969 = (0, $dGvGJ.createSelector)([
    (0, $9OPlz.draggingCardIssueTypeId),
    (0, $9OPlz.draggingCardIssueStatusId),
    (0, $67Z81.getCardTransitions),
    (0, $67Z81.getIssueTransitions),
    $8871cd8632f54a14$var$getDraggingCard,
    (0, $67Z81.getIssueProjects)
], (issueTypeId, issueStatusId, cardTransitions, issueTransitionsById, draggingCard, issueProjects)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((destinationColumnId)=>{
        // Early termination if this is called incorrectly.
        if (!draggingCard) return {
            transitions: $8871cd8632f54a14$var$emptyArray
        };
        // Check if there are transitions specifically for this issue
        const issueTransitions = issueTransitionsById?.[String(draggingCard.id)];
        // If there are transitions specifically for this card, we need to handle them
        if (issueTransitions && issueTransitions.status !== 'failure') {
            if (issueTransitions.status === 'success') {
                // Per issue available transitions, this is fetched from the
                // back-end, so doesn't require project filters.
                const selfTransitions = issueTransitions.data[String(destinationColumnId)] || [];
                const statuses = cardTransitions.issueTypeStatus[String(issueTypeId)];
                return {
                    transitions: selfTransitions.filter((transition)=>transition && !transition.isInitial).filter((transition)=>statuses[String(transition.destinationStatusId)]).filter((transition)=>transition.isAvailable).map((transition)=>{
                        const toStatus = statuses[String(transition.destinationStatusId)];
                        return {
                            transitionId: transition.id,
                            transitionName: transition.name,
                            targetStatusName: toStatus.name,
                            targetStatusId: transition.destinationStatusId,
                            targetStatusCategory: toStatus.category || (0, $gULOk.IN_PROGRESS),
                            isGlobal: transition.isGlobal,
                            isAvailable: transition.isAvailable
                        };
                    })
                };
            }
            return {
                transitions: $8871cd8632f54a14$var$emptyArray,
                isLoading: true
            };
        }
        return $8871cd8632f54a14$var$getColumnTransitions(cardTransitions, issueTypeId, issueStatusId, destinationColumnId, draggingCard, issueProjects);
    }));
const $8871cd8632f54a14$export$96d2b9c7793d0852 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIsCMPBoard),
    (0, $9OPlz.draggingCardSourceSwimlaneIdSelector),
    (0, $45cXl.getSwimlaneMode),
    (0, $5mTgl.isDraggingSubtaskSelector),
    (0, $67Z81.isBoardRankable)
], (isCMPBoard, draggingSwimlaneId, swimlaneMode, isDraggingSubtask, isOrderByRank)=>(swimlaneId)=>{
        const hasSwimlanes = swimlaneMode !== (0, $iuuJH.NO_SWIMLANE).id;
        const isDraggingAcrossSwimlanes = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(swimlaneId) && draggingSwimlaneId !== swimlaneId;
        return isCMPBoard && (isDraggingSubtask || isOrderByRank) && hasSwimlanes && isDraggingAcrossSwimlanes;
    });
const $8871cd8632f54a14$export$98f9342952b17976 = (0, $dGvGJ.createSelector)([
    (0, $9OPlz.draggingCardSourceColumnIdSelector),
    (0, $9OPlz.draggingCardTargetColumnIdSelector)
], (sourceColumnId, targetColumnId)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnId)=>{
        // Drags within same column always ok
        if (sourceColumnId === columnId) return false;
        // If last hovered over column is not this one, disable.
        return targetColumnId !== columnId;
    }));
const $8871cd8632f54a14$var$getNonEmptyIssueTypeIds = (issueTypeTransitions)=>Object.keys(issueTypeTransitions).filter((issueTypeId)=>{
        const transitions = issueTypeTransitions[issueTypeId];
        return transitions.length > 0;
    });
const $8871cd8632f54a14$export$ea5b40548774f675 = (0, $dGvGJ.createSelector)((0, $67Z81.getCardTransitions), ({ columnIssueTypeTransitions: columnIssueTypeTransitions })=>{
    const columnIds = Object.keys(columnIssueTypeTransitions);
    if (columnIds.length === 0) return false;
    const firstColumnId = columnIds[0];
    const firstColumnIssueTypes = columnIssueTypeTransitions[firstColumnId];
    let previousIssueTypeIds = $8871cd8632f54a14$var$getNonEmptyIssueTypeIds(firstColumnIssueTypes);
    for(let i = 1; i < columnIds.length; i += 1){
        const columnId = columnIds[i];
        const columnIssueTypes = columnIssueTypeTransitions[columnId];
        const columnIssueTypeIds = $8871cd8632f54a14$var$getNonEmptyIssueTypeIds(columnIssueTypes);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(previousIssueTypeIds, columnIssueTypeIds).length > 0 || (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(columnIssueTypeIds, previousIssueTypeIds).length > 0) return true;
        previousIssueTypeIds = columnIssueTypeIds;
    }
    return false;
});
const $8871cd8632f54a14$export$162369d1646e3e2d = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions),
    (0, $67Z81.getIssueProjects),
    (_, props)=>props
], (cardTransitions, issueProjects, { columnId: columnId, issueTypeId: issueTypeId, projectId: projectId })=>{
    try {
        const projectKey = Object.values(issueProjects).find((project)=>project.id === projectId)?.key;
        return cardTransitions.columnIssueTypeTransitions[String(columnId)][String(issueTypeId)].filter((transition)=>!transition.isInitial && (!projectKey || transition.projectKey === projectKey));
    } catch (_err) {
        (0, $dJl1T.default).unsafeErrorWithCustomerData('jsw.board-selectors.getTransitionsByColumnAndIssueType', 'Error retrieving issue transitions by column and issue type', {
            cardTransitions: JSON.stringify(cardTransitions),
            issueProjects: JSON.stringify(issueProjects),
            columnId: columnId,
            issueTypeId: issueTypeId
        });
        return [];
    }
});
const $8871cd8632f54a14$export$d276c2740c89d6e = (state)=>(columnId)=>(issueTypeId)=>!!(0, $67Z81.getCardTransitions)(state).columnIssueTypeTransitions[String(columnId)][String(issueTypeId)].find(({ isInitial: isInitial })=>isInitial);
const $8871cd8632f54a14$export$291fa08de619b517 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions),
    (0, $67Z81.getIssueProjects)
], (cardTransition, issueProjects)=>(columnId, issue)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(columnId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue.typeId)) return null;
        const projectKey = issue ? Object.values(issueProjects).find((project)=>project.id === issue.projectId)?.key : null;
        // Filter by project key since we can get a single transition returned once for each
        // project associated with a board and we do not want to return duplicates
        // which will affect the issue parent assign modal
        const transitionsByIssueType = cardTransition.columnIssueTypeTransitions[columnId]?.[issue.typeId]?.filter((transition)=>transition.projectKey === projectKey);
        // only show transitions relevant to the parent issue moving from it's current
        // column/backlog to the specified end column
        const validTransitionsForParentIssue = transitionsByIssueType ? transitionsByIssueType.filter((transition)=>transition.sourceStatusId === issue.statusId || transition.isGlobal) : null;
        return validTransitionsForParentIssue ?? null;
    });

});

parcelRegister("cN1y7", function(module, exports) {

$parcel$export(module.exports, "shouldFireFailureSLOMetric", () => $615d454a49fa4a48$export$fe8a8e492606443e);
$parcel$export(module.exports, "getStatusCodeGroup", () => $615d454a49fa4a48$export$d14e9b22afc87cb3);

var $8J83Y = parcelRequire("8J83Y");

var $fZneA = parcelRequire("fZneA");
const $615d454a49fa4a48$export$9e972e23fe5eb411 = 'Either transition or rank operation has failed';
const $615d454a49fa4a48$var$isHttpSuccessfulButFailedToMoveCard = (error)=>error.statusCode === 200 && error.message === $615d454a49fa4a48$export$9e972e23fe5eb411;
const $615d454a49fa4a48$export$fe8a8e492606443e = (error)=>!(0, $fZneA.isHttpClientErrorResponse)(error) && !(0, $fZneA.isClientFetchError)(error) && !$615d454a49fa4a48$var$isHttpSuccessfulButFailedToMoveCard(error) && !(0, $fZneA.isHttpTooManyRequestsResponse)(error);
const $615d454a49fa4a48$export$d14e9b22afc87cb3 = (error)=>error.statusCode === 429 ? '429' : (0, $8J83Y.getHttpStatusCodeGroup)(error.statusCode);

});
parcelRegister("8J83Y", function(module, exports) {

$parcel$export(module.exports, "getHttpStatusCodeGroup", () => $48bc5fed831643fb$export$50638b58bcff17eb);
const $48bc5fed831643fb$export$e984131957e55a57 = '1xx';
const $48bc5fed831643fb$export$c82f97ba058d81c6 = '2xx';
const $48bc5fed831643fb$export$a619f875c67bad8a = '3xx';
const $48bc5fed831643fb$export$54c00699f1d3b78f = '4xx';
const $48bc5fed831643fb$export$e3bc6416e310d1b3 = '5xx';
const $48bc5fed831643fb$var$HTTP_UNKNOWN_CODE_GROUP = 'unknown';
const $48bc5fed831643fb$export$50638b58bcff17eb = (statusCode)=>{
    if (statusCode === null || statusCode === undefined) return $48bc5fed831643fb$var$HTTP_UNKNOWN_CODE_GROUP;
    if (statusCode >= 100 && statusCode < 200) return $48bc5fed831643fb$export$e984131957e55a57;
    if (statusCode >= 200 && statusCode < 300) return $48bc5fed831643fb$export$c82f97ba058d81c6;
    if (statusCode >= 300 && statusCode < 400) return $48bc5fed831643fb$export$a619f875c67bad8a;
    if (statusCode >= 400 && statusCode < 500) return $48bc5fed831643fb$export$54c00699f1d3b78f;
    if (statusCode >= 500 && statusCode < 600) return $48bc5fed831643fb$export$e3bc6416e310d1b3;
    return $48bc5fed831643fb$var$HTTP_UNKNOWN_CODE_GROUP;
};

});



parcelRegister("kuD1K", function(module, exports) {

$parcel$export(module.exports, "getCanUserInviteEpic", () => $68fe4291b413d80f$export$89828008460b535c);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $3MnpT = parcelRequire("3MnpT");

var $f3MfI = parcelRequire("f3MfI");

var $cW3pH = parcelRequire("cW3pH");

var $67Z81 = parcelRequire("67Z81");
const $68fe4291b413d80f$export$89828008460b535c = (action$, store)=>action$.ofType((0, $cW3pH.WORK_DATA_SET)).switchMap(()=>{
        const state = store.getState();
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        if (isCMPBoard) return (0, $kVLXA.Observable).of();
        const projectId = (0, $67Z81.projectIdSelector)(state);
        return (0, $3MnpT.fetchCanUserInviteService)(projectId).mergeMap((canUserInviteResponse)=>(0, $kVLXA.Observable).of((0, $f3MfI.setCanUserInvite)(canUserInviteResponse))).catch((error)=>{
            if (!(0, $fZneA.isClientFetchError)(error)) (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'board.can-user-invite.load.failure',
                    packageName: 'jiraSoftwareBoard',
                    teamName: 'a4t-tanuki'
                }
            });
            return (0, $kVLXA.Observable).of();
        });
    });

});
parcelRegister("3MnpT", function(module, exports) {

$parcel$export(module.exports, "fetchCanUserInviteService", () => $f91f06591f16391c$export$583ef539d905855);

var $kQMHY = parcelRequire("kQMHY");
const $f91f06591f16391c$export$583ef539d905855 = (projectId)=>(0, $kQMHY.getUserInviteCapability)(projectId);

});
parcelRegister("kQMHY", function(module, exports) {

$parcel$export(module.exports, "getUserInviteCapability", () => $ba35bcaf191891e1$export$22c733f1adfb0925);
parcelRequire("3q49N");

var $487fd = parcelRequire("487fd");
const $ba35bcaf191891e1$var$getCanInviteOthersUrl = (projectId)=>`/rest/internal/latest/invite-user/project/${projectId}/can-invite-others`;
const $ba35bcaf191891e1$export$22c733f1adfb0925 = (projectId)=>(0, $487fd.default)($ba35bcaf191891e1$var$getCanInviteOthersUrl(projectId), {
        method: 'GET'
    });

});


parcelRegister("f3MfI", function(module, exports) {

$parcel$export(module.exports, "SET_CAN_USER_INVITE", () => $9704966df89e8459$export$c09a6e8888fd28fa);
$parcel$export(module.exports, "setCanUserInvite", () => $9704966df89e8459$export$c07b821618e68774);
const $9704966df89e8459$export$c09a6e8888fd28fa = 'state.actions.can-user-invite.SET_CAN_USER_INVITE';
const $9704966df89e8459$export$c07b821618e68774 = (payload)=>({
        type: $9704966df89e8459$export$c09a6e8888fd28fa,
        payload: payload
    });

});


parcelRegister("9s50S", function(module, exports) {

$parcel$export(module.exports, "getCardCoversEpic", () => $701a8311895abbe5$export$7faa2dc8787edae1);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("3awJm");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");

var $4vr5z = parcelRequire("4vr5z");

var $l5UTI = parcelRequire("l5UTI");

var $2f454 = parcelRequire("2f454");

var $3n582 = parcelRequire("3n582");

var $vAfHD = parcelRequire("vAfHD");
const $701a8311895abbe5$export$7faa2dc8787edae1 = (action$, store)=>action$.ofType((0, $3n582.FETCH_CARD_COVERS)).throttleTime(1000).switchMap((action)=>{
        const state = store.getState();
        // if there are no issue IDs in the payload, fetch card covers for all of the issue IDs on the board
        const issueIds = action.payload.length > 0 ? action.payload : (0, $vAfHD.boardOrderedIssueIdsSelector)(state);
        const analyticsEvent = action.meta?.analyticsEvent;
        if (issueIds.length === 0) return (0, $kVLXA.Observable).of();
        return (0, $4vr5z.fetchCardCoversService)(issueIds).mergeMap((response)=>{
            if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'cardCovers fetchSucceeded', {
                task: 'cardCoversFetch'
            });
            return (0, $kVLXA.Observable).of((0, $2f454.cardMediaDataSet)((0, $l5UTI.transformCardCoversRestApiResponse)(response, issueIds)));
        }).catch((error)=>{
            if (!(0, $fZneA.isClientFetchError)(error)) (0, $jcw0u.default)({
                event: analyticsEvent,
                error: error,
                meta: {
                    id: 'board.cardCovers.fetch.failure',
                    packageName: 'jiraSoftwareBoard',
                    teamName: 'A4T-Pandora'
                }
            });
            return (0, $kVLXA.Observable).of((0, $3n582.fetchCardCoversFailure)());
        });
    });

});
parcelRegister("4vr5z", function(module, exports) {

$parcel$export(module.exports, "fetchCardCoversService", () => $4ad057fc806b9136$export$9715adb13e235e9d);

var $4UCYm = parcelRequire("4UCYm");
const $4ad057fc806b9136$export$9715adb13e235e9d = (issueIds)=>(0, $4UCYm.getCardCovers)(issueIds);

});
parcelRegister("4UCYm", function(module, exports) {

$parcel$export(module.exports, "getCardCovers", () => $bdd4e9fc98827e9d$export$8fd4f4f9aa54b892);
parcelRequire("3q49N");

var $487fd = parcelRequire("487fd");
// A lightweight endpoint for retrieving only card cover data for a given set of issueIds
const $bdd4e9fc98827e9d$var$CARD_COVERS_API_URL = '/rest/greenhopper/1.0/cardCovers';
const $bdd4e9fc98827e9d$export$8fd4f4f9aa54b892 = (issueIds)=>(0, $487fd.default)($bdd4e9fc98827e9d$var$CARD_COVERS_API_URL, {
        method: 'POST',
        body: JSON.stringify(issueIds),
        perf: {
            prefix: 'jsw.board',
            key: 'cardCovers.fetch'
        }
    });

});


parcelRegister("l5UTI", function(module, exports) {

$parcel$export(module.exports, "transformMediaDataForSingleIssue", () => $91ddad88d6dd232b$export$20baab53b2c16681);
$parcel$export(module.exports, "transformCardCoversRestApiResponse", () => $91ddad88d6dd232b$export$26f54dfacebc2306);
const $91ddad88d6dd232b$export$20baab53b2c16681 = (cardMedia, media)=>({
        attachmentId: String(cardMedia.attachmentId),
        attachmentMediaApiId: cardMedia.mediaApiFileId,
        endpointUrl: media.endpointUrl,
        clientId: media.clientId,
        isHiddenByUser: false,
        token: cardMedia.mediaReadToken
    });
const $91ddad88d6dd232b$export$26f54dfacebc2306 = (cardCoversResponse, issueIdsFromRequest)=>issueIdsFromRequest.reduce((map, issueId)=>Object.assign(map, {
            [String(issueId)]: issueId in cardCoversResponse.cardMedia ? $91ddad88d6dd232b$export$20baab53b2c16681(cardCoversResponse.cardMedia[Number(issueId)], cardCoversResponse.media) : null
        }), {});

});

parcelRegister("2f454", function(module, exports) {

$parcel$export(module.exports, "CARD_DATA_SET", () => $a8783f929f39d4cc$export$273ea1cef989293);
$parcel$export(module.exports, "cardDataSet", () => $a8783f929f39d4cc$export$c24b8bc48062c07d);
$parcel$export(module.exports, "CARD_MEDIA_DATA_SET", () => $a8783f929f39d4cc$export$7c85c65079439bf2);
$parcel$export(module.exports, "cardMediaDataSet", () => $a8783f929f39d4cc$export$1292f97e47f8c4f4);
$parcel$export(module.exports, "CARD_REFRESH_REQUEST", () => $a8783f929f39d4cc$export$a5cacf6c12c6c43b);
$parcel$export(module.exports, "cardRefreshRequestWith", () => $a8783f929f39d4cc$export$de0715285e6d5218);
$parcel$export(module.exports, "CARD_CLICK", () => $a8783f929f39d4cc$export$1f7bc7dd5a83e5d6);
$parcel$export(module.exports, "cardClick", () => $a8783f929f39d4cc$export$e7d364bce6e7eb03);
$parcel$export(module.exports, "CARD_TOGGLE_SELECTION", () => $a8783f929f39d4cc$export$5f8bf17701529b20);
$parcel$export(module.exports, "CARD_MULTI_SELECT", () => $a8783f929f39d4cc$export$674d868bde506f3c);
$parcel$export(module.exports, "cardMultiSelect", () => $a8783f929f39d4cc$export$43cca0fb4ffd3a83);
$parcel$export(module.exports, "cardToggleSelection", () => $a8783f929f39d4cc$export$bf1970aeeba42166);
$parcel$export(module.exports, "CARD_SINGLE_SELECT", () => $a8783f929f39d4cc$export$c68d63d54996a817);
$parcel$export(module.exports, "cardSingleSelect", () => $a8783f929f39d4cc$export$9df5a921382fd88e);
$parcel$export(module.exports, "CARD_CANCEL_SELECTION", () => $a8783f929f39d4cc$export$98df3a708f34d816);
$parcel$export(module.exports, "cardCancelSelection", () => $a8783f929f39d4cc$export$a9618aba37578c3a);
$parcel$export(module.exports, "CARD_CLEAR", () => $a8783f929f39d4cc$export$bc9a106375114441);
$parcel$export(module.exports, "cardClear", () => $a8783f929f39d4cc$export$bdf5dd34d7025486);
$parcel$export(module.exports, "cardClearSuccess", () => $a8783f929f39d4cc$export$c6b9b0adb28bc068);
$parcel$export(module.exports, "cardClearFailure", () => $a8783f929f39d4cc$export$4da3d14df563def7);
$parcel$export(module.exports, "cardClearRevert", () => $a8783f929f39d4cc$export$abd1d00c8fd946b8);
$parcel$export(module.exports, "CARD_CLEAR_UNDO", () => $a8783f929f39d4cc$export$9c64600376e3d373);
$parcel$export(module.exports, "cardClearUndo", () => $a8783f929f39d4cc$export$73bb242cdcb8f96);
$parcel$export(module.exports, "CARD_DELETE", () => $a8783f929f39d4cc$export$b82590935cfab60f);
$parcel$export(module.exports, "cardDelete", () => $a8783f929f39d4cc$export$ba9d764de574147c);
$parcel$export(module.exports, "CARD_DELETE_OPTIMISTIC", () => $a8783f929f39d4cc$export$60d48bfd6db6297f);
$parcel$export(module.exports, "cardDeleteOptimistic", () => $a8783f929f39d4cc$export$8c23f90a573b475d);
$parcel$export(module.exports, "CARD_DRAG_OVER_TRANSITION", () => $a8783f929f39d4cc$export$c9359f309b5f4898);
$parcel$export(module.exports, "cardDragOverTransition", () => $a8783f929f39d4cc$export$5a37155dbb24c55d);
$parcel$export(module.exports, "CARD_DRAG_OVER_TRANSITION_REQUEST", () => $a8783f929f39d4cc$export$639e98b190c1f7b7);
$parcel$export(module.exports, "cardDragOverTransitionRequest", () => $a8783f929f39d4cc$export$371faa1fb1a6bca3);
$parcel$export(module.exports, "CARD_DRAG_SELECTED_TRANSITION", () => $a8783f929f39d4cc$export$ec18418d1159cde3);
$parcel$export(module.exports, "cardDragSelectedTransition", () => $a8783f929f39d4cc$export$ee55e5ac05a9811a);
$parcel$export(module.exports, "CARD_GET_ISSUE_TRANSITIONS", () => $a8783f929f39d4cc$export$7e4b8027ee23adc0);
$parcel$export(module.exports, "cardGetIssueTransitions", () => $a8783f929f39d4cc$export$611a578ff56e22fb);
$parcel$export(module.exports, "CARD_GET_ISSUE_TRANSITIONS_FAILURE", () => $a8783f929f39d4cc$export$6ea7c16576dd08bc);
$parcel$export(module.exports, "cardGetIssueTransitionsFailure", () => $a8783f929f39d4cc$export$8df71fbcf20d401f);
$parcel$export(module.exports, "CARD_SET_ISSUE_TRANSITIONS", () => $a8783f929f39d4cc$export$713b5a2539e4ed6f);
$parcel$export(module.exports, "cardSetIssueTransitions", () => $a8783f929f39d4cc$export$31d2270f6fdce884);
$parcel$export(module.exports, "CARD_FOCUS", () => $a8783f929f39d4cc$export$7de76f693f0d3820);
$parcel$export(module.exports, "cardFocus", () => $a8783f929f39d4cc$export$e462552ef1675527);
$parcel$export(module.exports, "CARD_BLUR", () => $a8783f929f39d4cc$export$6ac448f92e1f338b);
$parcel$export(module.exports, "cardBlur", () => $a8783f929f39d4cc$export$9dea9abf478df7d7);
$parcel$export(module.exports, "CARD_ADD_SHOW_RIPPLE", () => $a8783f929f39d4cc$export$34a15cd7bcc20e7c);
$parcel$export(module.exports, "cardAddShowRipple", () => $a8783f929f39d4cc$export$d5db5f1fced5f46b);
$parcel$export(module.exports, "CARD_REMOVE_SHOW_RIPPLE", () => $a8783f929f39d4cc$export$daf49e5bace84185);
$parcel$export(module.exports, "cardRemoveShowRipple", () => $a8783f929f39d4cc$export$fa511ac22ea1432e);
$parcel$export(module.exports, "CARD_NEXT", () => $a8783f929f39d4cc$export$e780294f9cb0bbfd);
$parcel$export(module.exports, "cardNext", () => $a8783f929f39d4cc$export$d848405832f5c1d5);
$parcel$export(module.exports, "CARD_PREV", () => $a8783f929f39d4cc$export$22f722071ae1a37d);
$parcel$export(module.exports, "cardPrev", () => $a8783f929f39d4cc$export$6dc88d98f7609a22);
$parcel$export(module.exports, "CARD_NEXT_COLUMN", () => $a8783f929f39d4cc$export$a3decb2cf51ca764);
$parcel$export(module.exports, "cardNextColumn", () => $a8783f929f39d4cc$export$1c08e25c16d65f20);
$parcel$export(module.exports, "CARD_PREV_COLUMN", () => $a8783f929f39d4cc$export$15b65905b49dfb04);
$parcel$export(module.exports, "cardPrevColumn", () => $a8783f929f39d4cc$export$ff3c6f9feddb9cb4);
$parcel$export(module.exports, "SET_ACTIVE_ISSUE_WITH_ICC", () => $a8783f929f39d4cc$export$af33f44f9fd7f318);
$parcel$export(module.exports, "setActiveIssueWithIcc", () => $a8783f929f39d4cc$export$7a1001b4ab64bb5b);
$parcel$export(module.exports, "SET_ISSUE_ID_WITH_ABOVE_ICC_OPEN", () => $a8783f929f39d4cc$export$9e8acf9161cb5486);
$parcel$export(module.exports, "setIssueIdWithAboveICCOpen", () => $a8783f929f39d4cc$export$924f3c9943a9e692);
$parcel$export(module.exports, "INITIATE_ICC_IN_UNSCHEDULED_COLUMN", () => $a8783f929f39d4cc$export$2bd1973a23529d49);
$parcel$export(module.exports, "initiateIccInUnscheduledColumn", () => $a8783f929f39d4cc$export$1eb38ee28983095);
$parcel$export(module.exports, "OPEN_ICC_IN_UNSCHEDULED_COLUMN", () => $a8783f929f39d4cc$export$a25c0f10847dde81);
$parcel$export(module.exports, "openIccInUnscheduledColumn", () => $a8783f929f39d4cc$export$ad9ede75967abe4d);
$parcel$export(module.exports, "CLOSE_ICC_IN_UNSCHEDULED_COLUMN", () => $a8783f929f39d4cc$export$1156eedf1d733b04);
$parcel$export(module.exports, "closeIccInUnscheduledColumn", () => $a8783f929f39d4cc$export$8e78d62a86915719);
$parcel$export(module.exports, "SET_INLINE_EDITING", () => $a8783f929f39d4cc$export$ef54802623416719);
$parcel$export(module.exports, "setInlineEditing", () => $a8783f929f39d4cc$export$1c5b461d4719dea6);

var $7Jxgt = parcelRequire("7Jxgt");


var $9rND4 = parcelRequire("9rND4");
const $a8783f929f39d4cc$export$273ea1cef989293 = 'state.actions.card.CARD_DATA_SET';
const $a8783f929f39d4cc$export$c24b8bc48062c07d = (issue, person, origin = (0, $f32ae13c2b9742f4$export$d46a05f8561f868a))=>({
        type: $a8783f929f39d4cc$export$273ea1cef989293,
        payload: {
            issue: issue,
            person: person,
            origin: origin
        }
    });
const $a8783f929f39d4cc$export$7c85c65079439bf2 = 'state.actions.card.CARD_MEDIA_DATA_SET';
const $a8783f929f39d4cc$export$1292f97e47f8c4f4 = (issueMedia)=>({
        type: $a8783f929f39d4cc$export$7c85c65079439bf2,
        payload: {
            issueMedia: issueMedia
        }
    });
const $a8783f929f39d4cc$export$a5cacf6c12c6c43b = 'state.actions.card.CARD_REFRESH_REQUEST';
const $a8783f929f39d4cc$export$de0715285e6d5218 = ({ issueIds: issueIds, origin: origin, transactionId: transactionId, skipTransactionUpdate: skipTransactionUpdate })=>({
        type: $a8783f929f39d4cc$export$a5cacf6c12c6c43b,
        payload: {
            issueIds: issueIds,
            origin: origin,
            skipTransactionUpdate: skipTransactionUpdate,
            transactionId: transactionId
        }
    });
const $a8783f929f39d4cc$export$54efae65153e525a = (issueIds = [], origin = (0, $f32ae13c2b9742f4$export$d46a05f8561f868a))=>$a8783f929f39d4cc$export$de0715285e6d5218({
        issueIds: issueIds,
        origin: origin,
        transactionId: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))(),
        skipTransactionUpdate: false
    });
const $a8783f929f39d4cc$export$1f7bc7dd5a83e5d6 = 'state.actions.card.CARD_CLICK';
const $a8783f929f39d4cc$export$e7d364bce6e7eb03 = (issueId, withCmd, withShift, externalAction)=>({
        type: $a8783f929f39d4cc$export$1f7bc7dd5a83e5d6,
        payload: {
            issueId: issueId,
            withCmd: withCmd,
            withShift: withShift,
            externalAction: externalAction
        }
    });
const $a8783f929f39d4cc$export$5f8bf17701529b20 = 'state.actions.card.CARD_TOGGLE_SELECTION';
const $a8783f929f39d4cc$export$674d868bde506f3c = 'state.actions.card.CARD_MULTI_SELECT';
const $a8783f929f39d4cc$export$43cca0fb4ffd3a83 = (issueIds)=>({
        type: $a8783f929f39d4cc$export$674d868bde506f3c,
        payload: {
            issueIds: issueIds
        }
    });
const $a8783f929f39d4cc$export$bf1970aeeba42166 = (issueId)=>({
        type: $a8783f929f39d4cc$export$5f8bf17701529b20,
        payload: {
            issueId: issueId
        }
    });
const $a8783f929f39d4cc$export$c68d63d54996a817 = 'state.actions.card.CARD_SINGLE_SELECT';
const $a8783f929f39d4cc$export$9df5a921382fd88e = (issueId)=>({
        type: $a8783f929f39d4cc$export$c68d63d54996a817,
        payload: {
            issueId: issueId
        }
    });
const $a8783f929f39d4cc$export$98df3a708f34d816 = 'state.actions.card.CARD_CANCEL_SELECTION';
const $a8783f929f39d4cc$export$a9618aba37578c3a = ()=>({
        type: $a8783f929f39d4cc$export$98df3a708f34d816
    });
const $a8783f929f39d4cc$export$bc9a106375114441 = 'state.actions.card.CARD_CLEAR';
const $a8783f929f39d4cc$export$bdf5dd34d7025486 = (cardIds, childCardIds)=>({
        type: $a8783f929f39d4cc$export$bc9a106375114441,
        payload: {
            cardIds: cardIds,
            childCardIds: childCardIds
        },
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    });
const $a8783f929f39d4cc$export$b28aa61b9e4e4c13 = 'state.actions.card.CARD_CLEAR_SUCCESS';
const $a8783f929f39d4cc$export$c6b9b0adb28bc068 = (optimisticId)=>({
        type: $a8783f929f39d4cc$export$b28aa61b9e4e4c13,
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $a8783f929f39d4cc$export$1add5abc4ada3dcb = 'state.actions.card.CARD_CLEAR_FAILURE';
const $a8783f929f39d4cc$export$4da3d14df563def7 = (optimisticId)=>({
        type: $a8783f929f39d4cc$export$1add5abc4ada3dcb,
        meta: (0, $9rND4.revertOptimisticUiMeta)(optimisticId)
    });
const $a8783f929f39d4cc$export$6fa90d6b83f582d7 = 'state.actions.card.CARD_CLEAR_REVERT';
const $a8783f929f39d4cc$export$abd1d00c8fd946b8 = (optimisticId)=>({
        type: $a8783f929f39d4cc$export$6fa90d6b83f582d7,
        meta: (0, $9rND4.revertOptimisticUiMeta)(optimisticId)
    });
const $a8783f929f39d4cc$export$9c64600376e3d373 = 'state.actions.card.CARD_CLEAR_UNDO';
const $a8783f929f39d4cc$export$73bb242cdcb8f96 = (undoPromise, retry, optimisticId)=>({
        type: $a8783f929f39d4cc$export$9c64600376e3d373,
        payload: {
            undoPromise: undoPromise,
            retry: retry,
            optimisticId: optimisticId
        }
    });
const $a8783f929f39d4cc$export$b82590935cfab60f = 'state.actions.card.CARD_DELETE';
const $a8783f929f39d4cc$export$ba9d764de574147c = (issueId, parentId = null, isDone = false)=>({
        type: $a8783f929f39d4cc$export$b82590935cfab60f,
        payload: {
            issueId: issueId,
            parentId: parentId,
            isDone: isDone
        }
    });
const $a8783f929f39d4cc$export$60d48bfd6db6297f = 'state.actions.card.CARD_DELETE_OPTIMISTIC';
const $a8783f929f39d4cc$export$8c23f90a573b475d = (issueId)=>({
        type: $a8783f929f39d4cc$export$60d48bfd6db6297f,
        payload: {
            issueId: issueId
        }
    });
const $a8783f929f39d4cc$export$c9359f309b5f4898 = 'state.actions.card.CARD_DRAG_OVER_TRANSITION';
const $a8783f929f39d4cc$export$5a37155dbb24c55d = (transitionId, toColumnId, hoverIntent)=>({
        type: $a8783f929f39d4cc$export$c9359f309b5f4898,
        payload: {
            transitionId: transitionId,
            toColumnId: toColumnId,
            hoverIntent: hoverIntent
        }
    });
const $a8783f929f39d4cc$export$639e98b190c1f7b7 = 'state.actions.card.CARD_DRAG_OVER_TRANSITION_REQUEST';
const $a8783f929f39d4cc$export$371faa1fb1a6bca3 = (transitionId, toColumnId, hoverIntent)=>({
        type: $a8783f929f39d4cc$export$639e98b190c1f7b7,
        payload: {
            transitionId: transitionId,
            toColumnId: toColumnId,
            hoverIntent: hoverIntent
        }
    });
const $a8783f929f39d4cc$export$ec18418d1159cde3 = 'state.actions.card.CARD_DRAG_SELECTED_TRANSITION';
const $a8783f929f39d4cc$export$ee55e5ac05a9811a = (transitionId, toColumnId, toSwimlaneId)=>({
        type: $a8783f929f39d4cc$export$ec18418d1159cde3,
        payload: {
            transitionId: transitionId,
            toColumnId: toColumnId,
            toSwimlaneId: toSwimlaneId
        }
    });
const $a8783f929f39d4cc$export$7e4b8027ee23adc0 = 'state.actions.card.CARD_GET_ISSUE_TRANSITIONS';
const $a8783f929f39d4cc$export$611a578ff56e22fb = (issueId, analyticsEvent)=>({
        type: $a8783f929f39d4cc$export$7e4b8027ee23adc0,
        payload: {
            issueId: issueId
        },
        meta: {
            analytics: analyticsEvent
        }
    });
const $a8783f929f39d4cc$export$6ea7c16576dd08bc = 'state.actions.card.CARD_GET_ISSUE_TRANSITIONS_FAILURE';
const $a8783f929f39d4cc$export$8df71fbcf20d401f = (issueId)=>({
        type: $a8783f929f39d4cc$export$6ea7c16576dd08bc,
        payload: {
            issueId: issueId
        }
    });
const $a8783f929f39d4cc$export$713b5a2539e4ed6f = 'state.actions.card.CARD_SET_ISSUE_TRANSITIONS';
const $a8783f929f39d4cc$export$31d2270f6fdce884 = (issueId, columnTransitions)=>({
        type: $a8783f929f39d4cc$export$713b5a2539e4ed6f,
        payload: {
            issueId: issueId,
            columnTransitions: columnTransitions
        }
    });
const $a8783f929f39d4cc$export$7de76f693f0d3820 = 'state.actions.card.CARD_FOCUS';
const $a8783f929f39d4cc$export$e462552ef1675527 = (issueId)=>({
        type: $a8783f929f39d4cc$export$7de76f693f0d3820,
        payload: {
            issueId: issueId
        }
    });
const $a8783f929f39d4cc$export$6ac448f92e1f338b = 'state.actions.card.CARD_BLUR';
const $a8783f929f39d4cc$export$9dea9abf478df7d7 = ()=>({
        type: $a8783f929f39d4cc$export$6ac448f92e1f338b
    });
const $a8783f929f39d4cc$export$34a15cd7bcc20e7c = 'state.actions.card.CARD_ADD_SHOW_RIPPLE';
const $a8783f929f39d4cc$export$d5db5f1fced5f46b = (issueIds)=>({
        type: $a8783f929f39d4cc$export$34a15cd7bcc20e7c,
        payload: {
            rippleIdsToShow: issueIds
        }
    });
const $a8783f929f39d4cc$export$daf49e5bace84185 = 'state.actions.card.CARD_REMOVE_SHOW_RIPPLE';
const $a8783f929f39d4cc$export$fa511ac22ea1432e = (issueId)=>({
        type: $a8783f929f39d4cc$export$daf49e5bace84185,
        payload: {
            issueId: issueId
        }
    });
const $a8783f929f39d4cc$export$e780294f9cb0bbfd = 'state.actions.card.CARD_NEXT';
const $a8783f929f39d4cc$export$d848405832f5c1d5 = (fireShortcutAnalyticsFn)=>({
        type: $a8783f929f39d4cc$export$e780294f9cb0bbfd,
        payload: {
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }
    });
const $a8783f929f39d4cc$export$22f722071ae1a37d = 'state.actions.card.CARD_PREV';
const $a8783f929f39d4cc$export$6dc88d98f7609a22 = (fireShortcutAnalyticsFn)=>({
        type: $a8783f929f39d4cc$export$22f722071ae1a37d,
        payload: {
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }
    });
const $a8783f929f39d4cc$export$a3decb2cf51ca764 = 'state.actions.card.CARD_NEXT_COLUMN';
const $a8783f929f39d4cc$export$1c08e25c16d65f20 = (fireShortcutAnalyticsFn)=>({
        type: $a8783f929f39d4cc$export$a3decb2cf51ca764,
        payload: {
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }
    });
const $a8783f929f39d4cc$export$15b65905b49dfb04 = 'state.actions.card.CARD_PREV_COLUMN';
const $a8783f929f39d4cc$export$ff3c6f9feddb9cb4 = (fireShortcutAnalyticsFn)=>({
        type: $a8783f929f39d4cc$export$15b65905b49dfb04,
        payload: {
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }
    });
const $a8783f929f39d4cc$export$af33f44f9fd7f318 = 'state.actions.card.SET_ACTIVE_ISSUE_WITH_ICC';
const $a8783f929f39d4cc$export$7a1001b4ab64bb5b = (issueId)=>({
        type: $a8783f929f39d4cc$export$af33f44f9fd7f318,
        payload: {
            issueId: issueId
        }
    });
const $a8783f929f39d4cc$export$9e8acf9161cb5486 = 'state.actions.card.SET_ISSUE_ID_WITH_ABOVE_ICC_OPEN';
const $a8783f929f39d4cc$export$924f3c9943a9e692 = (issueId, columnId)=>({
        type: $a8783f929f39d4cc$export$9e8acf9161cb5486,
        payload: {
            issueId: issueId,
            columnId: columnId
        }
    });
const $a8783f929f39d4cc$export$2bd1973a23529d49 = 'state.actions.card.INITIATE_ICC_IN_UNSCHEDULED_COLUMN';
const $a8783f929f39d4cc$export$1eb38ee28983095 = (swimlaneId, shouldToggleSwimlane)=>({
        type: $a8783f929f39d4cc$export$2bd1973a23529d49,
        payload: {
            swimlaneId: swimlaneId,
            shouldToggleSwimlane: shouldToggleSwimlane
        }
    });
const $a8783f929f39d4cc$export$a25c0f10847dde81 = 'state.actions.card.OPEN_ICC_IN_UNSCHEDULED_COLUMN';
const $a8783f929f39d4cc$export$ad9ede75967abe4d = (swimlaneId)=>({
        type: $a8783f929f39d4cc$export$a25c0f10847dde81,
        payload: {
            swimlaneId: swimlaneId
        }
    });
const $a8783f929f39d4cc$export$1156eedf1d733b04 = 'state.actions.card.CLOSE_ICC_IN_UNSCHEDULED_COLUMN';
const $a8783f929f39d4cc$export$8e78d62a86915719 = ()=>({
        type: $a8783f929f39d4cc$export$1156eedf1d733b04
    });
const $a8783f929f39d4cc$export$ef54802623416719 = 'state.actions.card.SET_INLINE_EDITING';
const $a8783f929f39d4cc$export$1c5b461d4719dea6 = (field, issueId, value)=>({
        type: $a8783f929f39d4cc$export$ef54802623416719,
        payload: {
            field: field,
            issueId: issueId,
            value: value
        }
    });

});
const $f32ae13c2b9742f4$export$306c754c61954570 = 'BENTO';
const $f32ae13c2b9742f4$export$f2127cf693ff3edc = 'TRANSITION';
const $f32ae13c2b9742f4$export$c1d71ceefe04e35a = 'SYNC';
const $f32ae13c2b9742f4$export$d46a05f8561f868a = 'OTHER';



parcelRegister("gZyMz", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd9a63ebcd6dfbf9$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $8zOmE = parcelRequire("8zOmE");

var $5bE6a = parcelRequire("5bE6a");

var $2f454 = parcelRequire("2f454");

var $9OPlz = parcelRequire("9OPlz");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");
const $cd9a63ebcd6dfbf9$export$4a76ddc96cd4947 = 'card-fetch-issue-transitions.info';
const $cd9a63ebcd6dfbf9$export$9a9cdf8240af39c4 = 'card-fetch-issue-transitions.failure';
const $cd9a63ebcd6dfbf9$export$fd93422e69803b8b = (issue, issueProject, columnIssueTypeTransitions)=>(issueTransitions)=>{
        const columnIds = Object.keys(columnIssueTypeTransitions);
        const comparisonFn = (columnTransition, issueTransition)=>columnTransition.id === issueTransition.id && columnTransition.destinationStatusId === issueTransition.destinationStatusId && (issueProject === undefined || columnTransition.projectKey === issueProject.key);
        const availableColumnTransitions = {};
        columnIds.forEach((columnId)=>{
            const columnTransitions = columnIssueTypeTransitions[columnId][String(issue.typeId)] || [];
            // Match based on project KEY
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            availableColumnTransitions[columnId] = columnTransitions.map((columnTransition)=>// We retrieve the issue one because we grabbed it recently from SWAG
                issueTransitions.find((issueTransition)=>comparisonFn(columnTransition, issueTransition))).filter((columnTransition)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(columnTransition));
        });
        return availableColumnTransitions;
    };
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cd9a63ebcd6dfbf9$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $2f454.CARD_GET_ISSUE_TRANSITIONS)).switchMap((action)=>{
        const { meta: { analytics: analyticsEvent } } = action;
        const state = store.getState();
        const cardId = (0, $9OPlz.getDraggingCardId)(state);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(cardId)) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData($cd9a63ebcd6dfbf9$export$9a9cdf8240af39c4, 'No dragging issue data present in state to fetch transitions');
            return (0, $kVLXA.Observable).empty();
        }
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const issue = (0, $d2i8f.getIssueById)(state, cardId);
        const cardTransitions = (0, $67Z81.getCardTransitions)(state);
        const projects = (0, $67Z81.getIssueProjects)(state);
        const issueProject = projects[issue?.projectId];
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'boardIssueTransitions fetchRequested');
        return (0, $5bE6a.fetchCardIssueTransitionsService)(contextPath, boardId, cardId).switchMap((issueTransitions)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issueTransitions)) {
                (0, $dJl1T.default).safeInfoWithoutCustomerData($cd9a63ebcd6dfbf9$export$4a76ddc96cd4947, `No transitions available for issue ${cardId}`);
                return (0, $kVLXA.Observable).empty();
            }
            return (0, $kVLXA.Observable).of(issueTransitions);
        }).map($cd9a63ebcd6dfbf9$export$fd93422e69803b8b(issue, issueProject, cardTransitions.columnIssueTypeTransitions)).switchMap((availableColumnTransitions)=>{
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'boardIssueTransitions fetchSucceeded');
            return (0, $kVLXA.Observable).of((0, $2f454.cardSetIssueTransitions)(cardId, availableColumnTransitions));
        }).catch((error)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData($cd9a63ebcd6dfbf9$export$9a9cdf8240af39c4, 'Failed to get card transition data', error);
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'boardIssueTransitions fetchFailed');
            return (0, $kVLXA.Observable).of((0, $2f454.cardGetIssueTransitionsFailure)(cardId));
        });
    });

});
parcelRegister("5bE6a", function(module, exports) {

$parcel$export(module.exports, "fetchCardIssueTransitionsService", () => $9590ae909268ce6b$export$accee6f68a886973);
parcelRequire("d0pqD");

var $bQEek = parcelRequire("bQEek");
const $9590ae909268ce6b$export$f51a517f410d7626 = (response = {})=>{
    const transitions = response.boardScope?.cards[0].issue?.transitions;
    if (transitions === null || transitions === undefined) return [];
    // Filter out the nulls from the array here
    const filteredTransitions = transitions.filter(// eslint-disable-next-line camelcase
    (transition)=>transition != null);
    // Convert to new type
    return filteredTransitions.map((transition)=>({
            id: Number(transition.id),
            name: transition.name,
            destinationStatusId: Number(transition.toStatusId),
            isGlobal: transition.isGlobal,
            isInitial: transition.isInitial,
            isAvailable: transition.isAvailable
        }));
};
const $9590ae909268ce6b$export$accee6f68a886973 = (contextPath, boardId, cardId)=>(0, $bQEek.fetchCardIssueTransitions)(contextPath, boardId, [
        cardId
    ]).map($9590ae909268ce6b$export$f51a517f410d7626);

});
parcelRegister("bQEek", function(module, exports) {

$parcel$export(module.exports, "fetchCardIssueTransitions", () => $7b8afae71e0ff488$export$b3aab32da3483734);

var $ivqh1 = parcelRequire("ivqh1");

var $cBLvH = parcelRequire("cBLvH");
const $7b8afae71e0ff488$export$d600414b4ff35a1 = 'CardIssueTransitions';
const $7b8afae71e0ff488$export$2b91517d6d5b4365 = (0, $ivqh1.gqlTagSwag)`
query CardIssueTransitions($boardId: ID!, $cardIds: [ID!]!) {
    boardScope(boardId: $boardId) {
        cards(cardIds: $cardIds) {
            issue {
                transitions {
                    id
                    name
                    isAvailable
                    isConditional
                    isGlobal
                    toStatusId
                    isInitial
                    hasScreen
                }
            }
        }
    }
}`;
const $7b8afae71e0ff488$export$b3aab32da3483734 = (contextPath, boardId, cardIds)=>(0, $cBLvH.query$)(contextPath, $7b8afae71e0ff488$export$d600414b4ff35a1, $7b8afae71e0ff488$export$2b91517d6d5b4365, {
        boardId: boardId,
        cardIds: cardIds
    });

});



parcelRegister("8ornp", function(module, exports) {

$parcel$export(module.exports, "cardAssignToMeEpic", () => $a383a3fc08d2115a$export$2bee3a5e157b7bbf);
$parcel$export(module.exports, "cardAssignToMeThrottledEpic", () => $a383a3fc08d2115a$export$5ed483b9a7992e55);

var $e1AU2 = parcelRequire("e1AU2");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("9o0uh");
parcelRequire("3awJm");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $kVLXA = parcelRequire("kVLXA");

var $7Jxgt = parcelRequire("7Jxgt");

var $k12ix = parcelRequire("k12ix");

var $aYkSv = parcelRequire("aYkSv");

var $4G04L = parcelRequire("4G04L");

var $hz3OZ = parcelRequire("hz3OZ");

var $cAxle = parcelRequire("cAxle");
const $a383a3fc08d2115a$export$3ab433d598b5afda = {
    onStart: (action)=>{
        const { concurrentId: concurrentId, assigneeAccountId: assigneeAccountId, fireShortcutAnalyticsFn: fireShortcutAnalyticsFn } = action.payload;
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $hz3OZ.assignToMeInteraction)(String(concurrentId)).mark('feedback');
        });
        if (fireShortcutAnalyticsFn) fireShortcutAnalyticsFn({
            id: 'assignToMeKeyboardShortcut',
            key: 'i',
            attributes: {
                assignStatus: assigneeAccountId !== null ? 'assign' : 'unassign'
            }
        });
    },
    onSuccess: (action)=>{
        const { concurrentId: concurrentId } = action.payload;
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $hz3OZ.assignToMeInteraction)(String(concurrentId)).stop({
                customData: (0, $k12ix.getNormalisedPerformanceFFs)()
            });
        });
    }
};
const $a383a3fc08d2115a$export$59640cb3aa92677 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
swagClient, action, hooks = $a383a3fc08d2115a$export$3ab433d598b5afda)=>{
    const { issueId: issueId, assigneeAccountId: assigneeAccountId } = action.payload;
    const { optimistic: { id: optimisticId } } = action.meta;
    if (hooks.onStart) hooks.onStart(action);
    const requestObservable = (0, $kVLXA.Observable).fromPromise((0, $aYkSv.assignToMe)(swagClient, {
        issueId: `${issueId}`,
        accountId: assigneeAccountId
    }));
    return requestObservable.map(()=>{
        if (hooks.onSuccess) hooks.onSuccess(action);
        return (0, $cAxle.assignToMeSucess)(optimisticId);
    }).catch(()=>{
        if (hooks.onFailure) hooks.onFailure(action);
        return (0, $e1AU2.ActionsObservable).of((0, $cAxle.assignToMeFailure)(optimisticId));
    });
};
const $a383a3fc08d2115a$export$2bee3a5e157b7bbf = (action$, state, dependencies)=>dependencies ? action$.ofType((0, $cAxle.ASSIGN_TO_ME_REQUEST)).flatMap((action)=>$a383a3fc08d2115a$export$59640cb3aa92677(dependencies.swagClient, action)) : (0, $kVLXA.Observable).empty();
const $a383a3fc08d2115a$export$5ed483b9a7992e55 = (action$)=>action$.ofType((0, $cAxle.ASSIGN_TO_ME_REQUEST_THROTTLED)).throttleTime(500).flatMap((action)=>{
        const { issueId: issueId, assigneeAccountId: assigneeAccountId, fireShortcutAnalyticsFn: fireShortcutAnalyticsFn } = action.payload;
        const concurrentId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        (0, $hz3OZ.assignToMeInteraction)(concurrentId).start();
        return (0, $kVLXA.Observable).of((0, $cAxle.assignToMeRequest)({
            issueId: issueId,
            assigneeAccountId: assigneeAccountId,
            concurrentId: concurrentId,
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }));
    });

});
parcelRegister("k12ix", function(module, exports) {

$parcel$export(module.exports, "getPerformanceFFsString", () => $c2cbddd7f2605816$export$c983ad7dc5517558);
$parcel$export(module.exports, "getNormalisedPerformanceFFs", () => $c2cbddd7f2605816$export$de03840ff3eb49a4);

var $6eBRn = parcelRequire("6eBRn");

var $9XE6b = parcelRequire("9XE6b");

var $8QpSo = parcelRequire("8QpSo");

var $y7eb2 = parcelRequire("y7eb2");
const $c2cbddd7f2605816$var$PERF_FF_PREFIX = 'jsw.perf.';
const $c2cbddd7f2605816$var$EXTRA_FFS_WHITELIST = new Set([
    'fe.platform.error.tracking.enabled',
    'jsw-epic-panel-performance-async-epic-details'
]);
const $c2cbddd7f2605816$var$getPerformanceFFs = (0, $8QpSo.default)(()=>{
    const featureFlags = Object.entries((0, $y7eb2.default)() || {})// @ts-expect-error - TS2769 - No overload matches this call.
    .filter(([key])=>key.startsWith($c2cbddd7f2605816$var$PERF_FF_PREFIX)) // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(([key, value])=>[
            key.substring($c2cbddd7f2605816$var$PERF_FF_PREFIX.length),
            (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(value, [
                'value'
            ], null)
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6eBRn)))(featureFlags);
});
const $c2cbddd7f2605816$var$isConsistencyCheckValue = (value)=>value === 'NEW' || value === 'OLD' || value === 'CHECK' || value === 'CHECK_RETURN_NEW';
const $c2cbddd7f2605816$export$448575db1388a8e6 = (0, $8QpSo.default)((whitelist = $c2cbddd7f2605816$var$EXTRA_FFS_WHITELIST)=>{
    const featurePairs = Object.entries((0, $y7eb2.default)() || {})// @ts-expect-error - TS2769 - No overload matches this call.
    .filter(([key])=>whitelist.has(key)) // eslint-disable-line @typescript-eslint/no-explicit-any
    .map(([key, value])=>[
            key,
            (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(value, [
                'value'
            ], null)
        ]); // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    // @ts-expect-error - TS2345 - Argument of type '([key, value]: [any, any]) => void' is not assignable to parameter of type '(value: any[], index: number, array: any[][]) => void'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    featurePairs.forEach(([key, value])=>{
        result[key] = value;
        if ($c2cbddd7f2605816$var$isConsistencyCheckValue(value)) {
            result[`${key}-new`] = value === 'NEW';
            result[`${key}-old`] = value === 'OLD';
            result[`${key}-check`] = value === 'CHECK';
            result[`${key}-check-return-new`] = value === 'CHECK_RETURN_NEW';
        }
    });
    return result;
});
const $c2cbddd7f2605816$export$c983ad7dc5517558 = (0, $8QpSo.default)(()=>JSON.stringify($c2cbddd7f2605816$var$getPerformanceFFs()));
const $c2cbddd7f2605816$export$de03840ff3eb49a4 = (0, $8QpSo.default)(()=>{
    const featureEntries = Object.entries({
        ...$c2cbddd7f2605816$var$getPerformanceFFs(),
        ...$c2cbddd7f2605816$export$448575db1388a8e6()
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const map = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    featureEntries.forEach(([key, value])=>{
        const normalisedKey = key.replace(/\./g, '-');
        map[normalisedKey] = value;
        return map;
    });
    return map;
});

});

parcelRegister("aYkSv", function(module, exports) {

$parcel$export(module.exports, "assignToMe", () => $4addbd3196ad60f5$export$521df9d10558315a);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $cNrxd = parcelRequire("cNrxd");

var $1EJrV = parcelRequire("1EJrV");

var $j8ZVG = parcelRequire("j8ZVG");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4addbd3196ad60f5$var$onMutationError = (error)=>{
    if ((0, $1EJrV.isExpectedGraphQLError)(error)) return;
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: 'assignToMeMutationFailed',
            packageName: 'jiraSoftwareKeyboardShortcuts'
        }
    });
};
const $4addbd3196ad60f5$export$521df9d10558315a = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
swagClient, variables)=>swagClient.mutate({
        mutation: (0, $j8ZVG.MUTATION),
        variables: variables
    }).then((result)=>{
        if (result.errors && result.errors.length || !result.data) throw new (0, $cNrxd.SwagError)({
            // @ts-expect-error - TS2322 - Type 'readonly GraphQLError[] | undefined' is not assignable to type 'GraphqlError[] | undefined'.
            graphQLErrors: result.errors,
            errorMessage: 'Assign to me failed'
        });
        return result.data;
    }).catch((err)=>{
        $4addbd3196ad60f5$var$onMutationError(err);
        throw err;
    });
const $4addbd3196ad60f5$export$5d2cd46d1c41b734 = ()=>{
    const [assignToMeMutation] = (0, $j8ZVG.useAssignToMeMutation)();
    return (0, $5uXOq.useCallback)(({ issueId: issueId, accountId: accountId })=>{
        const assignMutationPromise = assignToMeMutation({
            variables: {
                issueId: issueId,
                accountId: accountId
            }
        });
        assignMutationPromise.catch($4addbd3196ad60f5$var$onMutationError);
        return assignMutationPromise;
    }, [
        assignToMeMutation
    ]);
};

});
parcelRegister("1EJrV", function(module, exports) {

$parcel$export(module.exports, "isExpectedGraphQLError", () => $ec71481172594c19$export$9bfdf944b8987eac);
const $ec71481172594c19$export$9bfdf944b8987eac = (error)=>Boolean(error.graphQLErrors?.length > 0 && error.graphQLErrors?.every((graphQLError)=>{
        const statusCode = graphQLError?.extensions?.statusCode;
        return Boolean(statusCode);
    }));

});

parcelRegister("j8ZVG", function(module, exports) {

$parcel$export(module.exports, "MUTATION", () => $37c313ac561550fe$export$7473a9a03a67999e);
$parcel$export(module.exports, "useAssignToMeMutation", () => $37c313ac561550fe$export$9c4806aca0078faa);

var $5tTFS = parcelRequire("5tTFS");

var $5cllN = parcelRequire("5cllN");
const $37c313ac561550fe$export$7473a9a03a67999e = (0, $5cllN.default)`
    mutation AssignIssue($issueId: ID!, $accountId: ID) {
        assignIssue(input: { issueId: $issueId, accountId: $accountId }) {
            statusCode
            message
        }
    }
`;
const $37c313ac561550fe$export$9c4806aca0078faa = ()=>(0, $5tTFS.useMutation)($37c313ac561550fe$export$7473a9a03a67999e);

});
parcelRegister("5tTFS", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $3fdad8fd02cd9507$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $3fdad8fd02cd9507$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $3fdad8fd02cd9507$export$eb9a56e7a29e494);

var $bvsgq = parcelRequire("bvsgq");

var $3VFsf = parcelRequire("3VFsf");

var $5uXOq = parcelRequire("5uXOq");

var $e3a3O = parcelRequire("e3a3O");

var $bqMzA = parcelRequire("bqMzA");

var $1DiV8 = parcelRequire("1DiV8");
var $3fdad8fd02cd9507$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $bqMzA.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $1DiV8.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $bvsgq.parser)(document);
        var requiredOperationName = (0, $bvsgq.operationName)(type);
        var usedOperationName = (0, $bvsgq.operationName)(operation.type);
        (0, $1DiV8.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $3fdad8fd02cd9507$var$QueryData = function(_super) {
    (0, $3VFsf.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $e3a3O.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $e3a3O.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $bvsgq.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $3VFsf.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $bqMzA.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $bqMzA.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $bqMzA.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $e3a3O.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $e3a3O.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $bqMzA.equal)(this.previousOptions.query, query) && (0, $bqMzA.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$var$useDeepMemo(memoFn, key) {
    var ref = (0, $5uXOq.useRef)();
    if (!ref.current || !(0, $bqMzA.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $3fdad8fd02cd9507$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $5uXOq.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $3fdad8fd02cd9507$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $3fdad8fd02cd9507$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $5uXOq.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $5uXOq.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $3fdad8fd02cd9507$export$dd0a697e1782aedd(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, false);
}
function $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, true);
}
var $3fdad8fd02cd9507$var$MutationData = function(_super) {
    (0, $3VFsf.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $bvsgq.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $bvsgq.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $3VFsf.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $3VFsf.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $e3a3O.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $bqMzA.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$609860bf8b0084c(mutation, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $5uXOq.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $3fdad8fd02cd9507$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $3fdad8fd02cd9507$var$SubscriptionData = function(_super) {
    (0, $3VFsf.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $bqMzA.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$368b4214baeb914c(subscription, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $5uXOq.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $5uXOq.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $3fdad8fd02cd9507$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $3fdad8fd02cd9507$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $bvsgq.getApolloContext)()).client;
    (0, $1DiV8.invariant)(client, 1);
    return client;
}
function $3fdad8fd02cd9507$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $3fdad8fd02cd9507$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $3fdad8fd02cd9507$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});



parcelRegister("4G04L", function(module, exports) {

$parcel$export(module.exports, "scheduleAfterRender", () => $2060ab97dc501826$export$a845aafd0a0e29e6);

var $gg6CF = parcelRequire("gg6CF");

var $6cAn5 = parcelRequire("6cAn5");
const $2060ab97dc501826$export$a845aafd0a0e29e6 = (callback)=>{
    if ($gg6CF && $gg6CF.unstable_scheduleCallback) // Wait a tick for renders that will still be scheduled on this event-loop tick.
    $6cAn5.nextTick(()=>{
        try {
            // Schedule an idle priority callback with react's scheduler.
            $gg6CF.unstable_scheduleCallback($gg6CF.unstable_IdlePriority, ()=>{
                callback();
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // React.js' lower priority is at minimum 0ms or a postMessage tick.
            // Waiting 1ms seems to be a good enough approximation to run after that.
            setTimeout(()=>{
                callback();
            }, 1);
        }
    });
    else setTimeout(()=>{
        callback();
    }, 1);
};

});

parcelRegister("hz3OZ", function(module, exports) {

$parcel$export(module.exports, "nextGenBoardPageLoad", () => $f8931d5d75ce11bd$export$4b801a62907d6b94);
$parcel$export(module.exports, "uifBoardNewUiPageLoad", () => $f8931d5d75ce11bd$export$f1b77d03d220d9bf);
$parcel$export(module.exports, "incrementPlanningBoardPageLoad", () => $f8931d5d75ce11bd$export$c86a9609fe658c66);
$parcel$export(module.exports, "issueViewOpenInteraction", () => $f8931d5d75ce11bd$export$412ac2e825a54154);
$parcel$export(module.exports, "issueCreateInteraction", () => $f8931d5d75ce11bd$export$be312698838f27be);
$parcel$export(module.exports, "issueDeleteInteraction", () => $f8931d5d75ce11bd$export$1b8cf3f3c2894329);
$parcel$export(module.exports, "issueRankAndTransitionInteraction", () => $f8931d5d75ce11bd$export$2e13f822f1d07fc6);
$parcel$export(module.exports, "flagToggleInteraction", () => $f8931d5d75ce11bd$export$6c532396e24c45e7);
$parcel$export(module.exports, "assignToMeInteraction", () => $f8931d5d75ce11bd$export$79f93553011c8d54);
$parcel$export(module.exports, "cardsClearInteraction", () => $f8931d5d75ce11bd$export$fa7a624cdb34cdd3);
$parcel$export(module.exports, "cardsUnclearInteraction", () => $f8931d5d75ce11bd$export$9bc31a8417066b8d);
$parcel$export(module.exports, "filterInteraction", () => $f8931d5d75ce11bd$export$8decf314e9f3b4a0);
$parcel$export(module.exports, "editSprintModalLoad", () => $f8931d5d75ce11bd$export$c39d6b5415c8a491);
$parcel$export(module.exports, "customFilterInteraction", () => $f8931d5d75ce11bd$export$ae56111e009a2b76);
$parcel$export(module.exports, "devStatusLoadInteraction", () => $f8931d5d75ce11bd$export$1adf9bab2b71f504);

var $dGrdR = parcelRequire("dGrdR");

const $f8931d5d75ce11bd$export$9fc6070c69058000 = 4000;
const $f8931d5d75ce11bd$export$f984a7a89ddef798 = 8000;
const $f8931d5d75ce11bd$var$SLO_FMP = 4000;
const $f8931d5d75ce11bd$export$3a8025f2f3e0c64 = {
    EARLY_FETCH_START: 'EARLY_FETCH_START',
    EARLY_FETCH_END: 'EARLY_FETCH_END'
};
const $f8931d5d75ce11bd$var$NEXT_GEN_BOARD = 'next-gen-board';
const $f8931d5d75ce11bd$var$UIF_BOARD_NEW_UI = 'classic-board';
const $f8931d5d75ce11bd$var$INCREMENT_PLANNING_BOARD = 'increment-planning-board';
const $f8931d5d75ce11bd$var$boardPageLoad = (key)=>(0, $dGrdR.metrics).pageLoad({
        key: key,
        featureFlags: [],
        ssr: {
            doneAsFmp: true
        },
        slo: {
            fmp: {
                initial: {
                    threshold: $f8931d5d75ce11bd$var$SLO_FMP
                },
                transition: {
                    threshold: $f8931d5d75ce11bd$var$SLO_FMP
                }
            },
            tti: {
                initial: {
                    threshold: $f8931d5d75ce11bd$export$f984a7a89ddef798
                },
                transition: {
                    threshold: $f8931d5d75ce11bd$export$f984a7a89ddef798
                }
            }
        },
        timings: [
            {
                key: 'early-fetch',
                startMark: $f8931d5d75ce11bd$export$3a8025f2f3e0c64.EARLY_FETCH_START,
                endMark: $f8931d5d75ce11bd$export$3a8025f2f3e0c64.EARLY_FETCH_END
            },
            {
                key: (0, $ce556f125dee8174$export$48552baa9db8ce1d),
                endMark: (0, $ce556f125dee8174$export$99c08ec92759c71c)
            }
        ]
    });
const $f8931d5d75ce11bd$export$4b801a62907d6b94 = $f8931d5d75ce11bd$var$boardPageLoad($f8931d5d75ce11bd$var$NEXT_GEN_BOARD);
const $f8931d5d75ce11bd$export$f1b77d03d220d9bf = $f8931d5d75ce11bd$var$boardPageLoad($f8931d5d75ce11bd$var$UIF_BOARD_NEW_UI);
const $f8931d5d75ce11bd$export$c86a9609fe658c66 = $f8931d5d75ce11bd$var$boardPageLoad($f8931d5d75ce11bd$var$INCREMENT_PLANNING_BOARD);
const $f8931d5d75ce11bd$export$412ac2e825a54154 = (0, $dGrdR.metrics).interaction({
    key: 'board.issue-view-open',
    histogram: {
        result: '1000_2000_3000_4000_5000_6000',
        response: '50_100_150_200_250_300'
    },
    timings: [
        {
            key: 'feedbackPreMount',
            endMark: 'feedbackPreMountEnd'
        }
    ]
});
const $f8931d5d75ce11bd$export$be312698838f27be = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'board.issue-create',
    histogram: {
        result: '1000_2000_3000_4000_5000_6000',
        response: '50_100_150_200_300_500'
    }
});
const $f8931d5d75ce11bd$export$1b8cf3f3c2894329 = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'board.issue-delete'
});
const $f8931d5d75ce11bd$export$2e13f822f1d07fc6 = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'board.issue-rank-and-transition',
    histogram: {
        result: '500_1000_1100_1200_1300_1400_1500_2000',
        response: '50_100_150_200_300_500'
    }
});
const $f8931d5d75ce11bd$export$6c532396e24c45e7 = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'board.flag-toggle',
    histogram: {
        result: '1000_2000_3000_4000_5000_6000',
        response: '50_100_150_200_300_500'
    }
});
const $f8931d5d75ce11bd$export$79f93553011c8d54 = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'board.assign-to-me',
    histogram: {
        result: '500_1000_2000_3000_4000',
        response: '200_300_400_500_1000_2000'
    }
});
const $f8931d5d75ce11bd$export$fa7a624cdb34cdd3 = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'board.cards-clear',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.result]' is missing in type '{ response: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        response: '50_100_150_200_300_400_500'
    }
});
const $f8931d5d75ce11bd$export$9bc31a8417066b8d = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'board.cards-unclear',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.result]' is missing in type '{ response: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        response: '50_100_150_200_300_400_500'
    }
});
const $f8931d5d75ce11bd$export$8decf314e9f3b4a0 = (0, $dGrdR.metrics).interaction({
    key: 'board.filter'
});
const $f8931d5d75ce11bd$export$c39d6b5415c8a491 = (0, $dGrdR.metrics).interaction({
    key: 'edit-sprint-modal-load'
});
const $f8931d5d75ce11bd$export$ae56111e009a2b76 = (0, $dGrdR.metrics).interaction({
    key: 'board.custom-filter',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_1500_2000_2500_3000_3500_4000'
    }
});
const $f8931d5d75ce11bd$export$1adf9bab2b71f504 = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'board.dev-status-load',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_2000_3000_4000_5000_6000_7000_8000'
    }
});

});

parcelRegister("cAxle", function(module, exports) {

$parcel$export(module.exports, "ASSIGN_TO_ME_REQUEST", () => $11e64ffb6a72261e$export$4a7b4d6811230566);
$parcel$export(module.exports, "assignToMeRequest", () => $11e64ffb6a72261e$export$e2776354d9221c82);
$parcel$export(module.exports, "ASSIGN_TO_ME_REQUEST_THROTTLED", () => $11e64ffb6a72261e$export$f241ab4d2fe8b61e);
$parcel$export(module.exports, "assignToMeRequestThrottled", () => $11e64ffb6a72261e$export$13bfccdb4d681951);
$parcel$export(module.exports, "assignToMeSucess", () => $11e64ffb6a72261e$export$163b3f2e6c6f331d);
$parcel$export(module.exports, "assignToMeFailure", () => $11e64ffb6a72261e$export$50fd16f97611da56);

var $9rND4 = parcelRequire("9rND4");
const $11e64ffb6a72261e$export$4a7b4d6811230566 = 'state.actions.issue.assign-to-me.ASSIGN_TO_ME_REQUEST';
const $11e64ffb6a72261e$export$e2776354d9221c82 = ({ issueId: issueId, assigneeAccountId: assigneeAccountId, concurrentId: concurrentId, fireShortcutAnalyticsFn: fireShortcutAnalyticsFn })=>({
        type: $11e64ffb6a72261e$export$4a7b4d6811230566,
        payload: {
            issueId: issueId,
            assigneeAccountId: assigneeAccountId,
            concurrentId: concurrentId,
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        },
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    });
const $11e64ffb6a72261e$export$f241ab4d2fe8b61e = 'state.actions.issue.assign-to-me.ASSIGN_TO_ME_REQUEST_THROTTLED';
const $11e64ffb6a72261e$export$13bfccdb4d681951 = (issueId, assigneeAccountId, fireShortcutAnalyticsFn)=>({
        type: $11e64ffb6a72261e$export$f241ab4d2fe8b61e,
        payload: {
            issueId: issueId,
            assigneeAccountId: assigneeAccountId,
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }
    });
const $11e64ffb6a72261e$export$1249a100986a9489 = 'state.actions.issue.assign-to-me.ASSIGN_TO_ME_SUCCESS';
const $11e64ffb6a72261e$export$163b3f2e6c6f331d = (optimisticId)=>({
        type: $11e64ffb6a72261e$export$1249a100986a9489,
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $11e64ffb6a72261e$export$1ce003be5a9445ee = 'state.actions.issue.assign-to-me.ASSIGN_TO_ME_FAILURE';
const $11e64ffb6a72261e$export$50fd16f97611da56 = (optimisticId)=>({
        type: $11e64ffb6a72261e$export$1ce003be5a9445ee,
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("c0Qhv", function(module, exports) {

$parcel$export(module.exports, "cardAutoScrollOnLoadEpic", () => $3053e82f3445748a$export$b3fa7f35f3b0229c);
$parcel$export(module.exports, "cardAutoScrollOnFilterEpic", () => $3053e82f3445748a$export$1eee00ad491917f1);
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("aSIuP");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $2f454 = parcelRequire("2f454");

var $d1i1b = parcelRequire("d1i1b");

var $cW3pH = parcelRequire("cW3pH");

var $9OPlz = parcelRequire("9OPlz");

var $d2i8f = parcelRequire("d2i8f");
const $3053e82f3445748a$export$b3fa7f35f3b0229c = (action$, store)=>(0, $kVLXA.Observable).zip(action$.ofType((0, $d1i1b.CARD_AUTO_SCROLL_REQUEST_ON_LOAD)), action$.ofType((0, $cW3pH.WORK_DATA_SET))).flatMap(([action])=>{
        const state = store.getState();
        const issueId = (0, $d2i8f.getIssueByKey)(state, action.payload.issueKey)?.id;
        return issueId ? (0, $kVLXA.Observable).from([
            (0, $2f454.cardSingleSelect)(issueId),
            (0, $d1i1b.cardAutoScroll)(issueId)
        ]) : (0, $kVLXA.Observable).empty();
    });
const $3053e82f3445748a$export$1eee00ad491917f1 = (action$, store)=>action$.ofType((0, $d1i1b.CARD_AUTO_SCROLL_REQUEST_ON_FILTER)).mergeMap(()=>{
        const state = store.getState();
        const selectedIssueId = (0, $9OPlz.getCardSelection)(state)[0];
        return selectedIssueId ? (0, $kVLXA.Observable).from([
            (0, $d1i1b.cardAutoScroll)(selectedIssueId)
        ]) : (0, $kVLXA.Observable).empty();
    });

});

parcelRegister("7COzu", function(module, exports) {

$parcel$export(module.exports, "cardChangeTeamEpic", () => $623e6dcd2ed75595$export$7d0d92f19a76b6f4);
parcelRequire("fp4O3");
parcelRequire("aSIuP");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $3spCR = parcelRequire("3spCR");

var $3vq48 = parcelRequire("3vq48");

var $5UXId = parcelRequire("5UXId");

var $k50Aq = parcelRequire("k50Aq");

var $cPGP0 = parcelRequire("cPGP0");
function $623e6dcd2ed75595$export$77b9245dd5cde151(store, action) {
    const state = store.getState();
    const { sourceSwimlaneId: sourceSwimlaneId, destinationColumnId: destinationColumnId, destinationSwimlaneId: destinationSwimlaneId } = action.payload;
    const teamSprintsForIterations = (0, $cPGP0.getTeamSprintsForIterations)(state, destinationSwimlaneId);
    if (teamSprintsForIterations) {
        const sprint = teamSprintsForIterations[destinationColumnId];
        const isClosedSprint = sprint && sprint.state === (0, $3spCR.SPRINT_STATES).CLOSED;
        const movingToClosedSprintColumn = sourceSwimlaneId !== destinationSwimlaneId && isClosedSprint;
        if (movingToClosedSprintColumn) return (0, $kVLXA.Observable).of((0, $k50Aq.swimlaneColumnClosedSprintInvalidMove)(sprint.name));
    }
    return (0, $kVLXA.Observable).of((0, $5UXId.issueRankTeamDateRequest)(action.payload));
}
function $623e6dcd2ed75595$export$7d0d92f19a76b6f4(action$, store) {
    return action$.ofType((0, $3vq48.ISSUE_CHANGE_TEAM_REQUEST)).mergeMap((action)=>$623e6dcd2ed75595$export$77b9245dd5cde151(store, action));
}

});
parcelRegister("3vq48", function(module, exports) {

$parcel$export(module.exports, "ISSUE_CHANGE_TEAM_REQUEST", () => $34f35c73a61123a4$export$c0a4cd5a1c65021);
$parcel$export(module.exports, "issueChangeTeamRequest", () => $34f35c73a61123a4$export$706aef2f190eaf8c);
const $34f35c73a61123a4$export$c0a4cd5a1c65021 = 'state.actions.issue.change-team.ISSUE_CHANGE_TEAM_REQUEST';
const $34f35c73a61123a4$export$706aef2f190eaf8c = ({ issueIds: issueIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId })=>({
        type: $34f35c73a61123a4$export$c0a4cd5a1c65021,
        payload: {
            issueIds: issueIds,
            sourceColumnId: sourceColumnId,
            destinationColumnId: destinationColumnId,
            rankBeforeIssueId: rankBeforeIssueId,
            rankAfterIssueId: rankAfterIssueId,
            sourceSwimlaneId: sourceSwimlaneId,
            destinationSwimlaneId: destinationSwimlaneId
        }
    });

});

parcelRegister("5UXId", function(module, exports) {

$parcel$export(module.exports, "ISSUE_RANK_TEAM_DATE_REQUEST", () => $4a74d8cfa0217593$export$f770861e1cd0420f);
$parcel$export(module.exports, "issueRankTeamDateRequest", () => $4a74d8cfa0217593$export$50d3ae9d4842cf2f);
$parcel$export(module.exports, "issueTeamDateRankSuccess", () => $4a74d8cfa0217593$export$9c1e4663f2a01a9c);
$parcel$export(module.exports, "issueTeamDateRankFailure", () => $4a74d8cfa0217593$export$c47a6d27a78c3859);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $4a74d8cfa0217593$export$f770861e1cd0420f = 'state.actions.issue.rank-team-date.ISSUE_RANK_TEAM_DATE_REQUEST';
const $4a74d8cfa0217593$export$50d3ae9d4842cf2f = ({ issueIds: issueIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId })=>({
        type: $4a74d8cfa0217593$export$f770861e1cd0420f,
        payload: {
            issueIds: issueIds,
            sourceColumnId: sourceColumnId,
            destinationColumnId: destinationColumnId,
            rankBeforeIssueId: rankBeforeIssueId,
            rankAfterIssueId: rankAfterIssueId,
            sourceSwimlaneId: sourceSwimlaneId,
            destinationSwimlaneId: destinationSwimlaneId
        }
    });
const $4a74d8cfa0217593$export$dcd2925734ee2c83 = 'state.actions.issue.rank-team-date.ISSUE_TEAM_DATE_RANK_SUCCESS';
const $4a74d8cfa0217593$export$9c1e4663f2a01a9c = ()=>({
        type: $4a74d8cfa0217593$export$dcd2925734ee2c83
    });
const $4a74d8cfa0217593$export$d5394c28a5cea4c4 = 'state.actions.issue.rank-team-date.ISSUE_TEAM_DATE_RANK_FAILURE';
const $4a74d8cfa0217593$export$c47a6d27a78c3859 = ()=>({
        type: $4a74d8cfa0217593$export$d5394c28a5cea4c4,
        meta: (0, $sdxnu.errorFlagMeta)({
            titleMessage: (0, $7AVqz.default).cardMoveFailureInIpBoardTitleNoTranslate,
            descriptionMessage: (0, $7AVqz.default).cardMoveFailureInIpBoardMessageNoTranslate
        })
    });

});

parcelRegister("k50Aq", function(module, exports) {

$parcel$export(module.exports, "SWIMLANE_JQL_SET_DATA", () => $2b7bae92bddec112$export$96fac0fff9ed98fe);
$parcel$export(module.exports, "swimlaneJqlSetDataRequest", () => $2b7bae92bddec112$export$b01f1b1d735934ac);
$parcel$export(module.exports, "SWIMLANE_MODE_CHANGE_REQUEST", () => $2b7bae92bddec112$export$5fc9250064496098);
$parcel$export(module.exports, "swimlaneModeChangeRequest", () => $2b7bae92bddec112$export$a1284c964c572f87);
$parcel$export(module.exports, "swimlaneModeChangeSuccess", () => $2b7bae92bddec112$export$4b06b30aca7a7a1e);
$parcel$export(module.exports, "swimlaneModeChangeFailure", () => $2b7bae92bddec112$export$197c20a7a0293523);
$parcel$export(module.exports, "SWIMLANE_TOGGLE", () => $2b7bae92bddec112$export$69ae1c228ec01051);
$parcel$export(module.exports, "swimlaneToggle", () => $2b7bae92bddec112$export$df1a2052b3e720d8);
$parcel$export(module.exports, "SWIMLANES_TOGGLE", () => $2b7bae92bddec112$export$b3d0b922cac32f08);
$parcel$export(module.exports, "swimlanesToggle", () => $2b7bae92bddec112$export$e612403e1e93ac1d);
$parcel$export(module.exports, "SWIMLANES_COLLAPSE", () => $2b7bae92bddec112$export$2804c32308eeed21);
$parcel$export(module.exports, "swimlanesCollapse", () => $2b7bae92bddec112$export$8e93c288898e1510);
$parcel$export(module.exports, "SWIMLANES_EXPAND", () => $2b7bae92bddec112$export$ff13a00f585c347d);
$parcel$export(module.exports, "swimlanesExpand", () => $2b7bae92bddec112$export$e04c42f829645718);
$parcel$export(module.exports, "teamSwimLaneInvalidMove", () => $2b7bae92bddec112$export$933859197afb7512);
$parcel$export(module.exports, "swimlaneColumnClosedSprintInvalidMove", () => $2b7bae92bddec112$export$8547552d002c47e0);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");

var $9rND4 = parcelRequire("9rND4");
const $2b7bae92bddec112$export$96fac0fff9ed98fe = 'state.actions.swimlane.SWIMLANE_JQL_SET_DATA';
const $2b7bae92bddec112$export$b01f1b1d735934ac = (swimlanes)=>({
        type: $2b7bae92bddec112$export$96fac0fff9ed98fe,
        payload: swimlanes
    });
const $2b7bae92bddec112$export$5fc9250064496098 = 'state.actions.swimlane.SWIMLANE_MODE_CHANGE_REQUEST';
const $2b7bae92bddec112$export$a1284c964c572f87 = (mode)=>({
        type: $2b7bae92bddec112$export$5fc9250064496098,
        payload: mode,
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    });
const $2b7bae92bddec112$export$f8c4c2f4cf453bae = 'state.actions.swimlane.SWIMLANE_MODE_CHANGE_SUCCESS';
const $2b7bae92bddec112$export$4b06b30aca7a7a1e = (optimisticId)=>({
        type: $2b7bae92bddec112$export$f8c4c2f4cf453bae,
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $2b7bae92bddec112$export$335af86bff4f19e8 = 'state.actions.swimlane.SWIMLANE_MODE_CHANGE_FAILURE';
const $2b7bae92bddec112$export$197c20a7a0293523 = (optimisticId)=>({
        type: $2b7bae92bddec112$export$335af86bff4f19e8,
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });
const $2b7bae92bddec112$export$69ae1c228ec01051 = 'state.actions.swimlane.SWIMLANE_TOGGLE';
const $2b7bae92bddec112$export$df1a2052b3e720d8 = (id)=>({
        type: $2b7bae92bddec112$export$69ae1c228ec01051,
        payload: id
    });
const $2b7bae92bddec112$export$b3d0b922cac32f08 = 'state.actions.swimlane.SWIMLANES_TOGGLE';
const $2b7bae92bddec112$export$e612403e1e93ac1d = (ids)=>({
        type: $2b7bae92bddec112$export$b3d0b922cac32f08,
        payload: ids
    });
const $2b7bae92bddec112$export$2804c32308eeed21 = 'state.actions.swimlane.SWIMLANES_COLLAPSE';
const $2b7bae92bddec112$export$8e93c288898e1510 = (ids)=>({
        type: $2b7bae92bddec112$export$2804c32308eeed21,
        payload: ids
    });
const $2b7bae92bddec112$export$ff13a00f585c347d = 'state.actions.swimlane.SWIMLANES_EXPAND';
const $2b7bae92bddec112$export$e04c42f829645718 = ()=>({
        type: $2b7bae92bddec112$export$ff13a00f585c347d
    });
const $2b7bae92bddec112$export$7bae716e6e950a58 = 'state.actions.swimlane.TEAM_SWIMLANE_INVALID_MOVE';
const $2b7bae92bddec112$export$933859197afb7512 = (teamName)=>({
        type: $2b7bae92bddec112$export$7bae716e6e950a58,
        meta: (0, $sdxnu.errorFlagMeta)({
            id: $2b7bae92bddec112$export$7bae716e6e950a58,
            context: {
                teamName: teamName
            },
            titleMessage: (0, $7AVqz.default).teamSwimlaneMoveInvalidTitle,
            descriptionMessage: (0, $7AVqz.default).teamSwimlaneMoveInvalidMessage
        })
    });
const $2b7bae92bddec112$export$ea34e094caf902a = 'state.actions.swimlane.SWIMLANE_COLUMN_CLOSED_SPRINT_INVALID_MOVE';
const $2b7bae92bddec112$export$8547552d002c47e0 = (sprintName)=>({
        type: $2b7bae92bddec112$export$ea34e094caf902a,
        meta: (0, $sdxnu.errorFlagMeta)({
            id: $2b7bae92bddec112$export$ea34e094caf902a,
            context: {
                sprintName: sprintName
            },
            titleMessage: (0, $7AVqz.default).swimlaneColumnClosedSprintInvalidMoveTitle,
            descriptionMessage: (0, $7AVqz.default).swimlaneColumnClosedSprintInvalidMoveMessage
        })
    });

});


parcelRegister("f72yS", function(module, exports) {

$parcel$export(module.exports, "default", () => $55cee968a65092cc$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("9o0uh");
parcelRequire("fp4O3");
parcelRequire("jFVZ1");
parcelRequire("djSMA");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");


var $2f454 = parcelRequire("2f454");

var $cW3pH = parcelRequire("cW3pH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$55cee968a65092cc$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $2f454.CARD_CLEAR_UNDO)).mergeMap((action)=>{
        const { undoPromise: undoPromise, retry: retry, optimisticId: optimisticId } = action.payload;
        return (0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, $2f454.cardClearRevert)(optimisticId)), (0, $kVLXA.Observable).fromPromise(undoPromise).takeWhile(()=>retry).map(()=>(0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$8d3fdbb8c61d9d21))).catch(()=>(0, $kVLXA.Observable).of((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$8d3fdbb8c61d9d21)))));
    });

});

parcelRegister("41QbH", function(module, exports) {

$parcel$export(module.exports, "default", () => $53398ea24e376224$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $4R6GH = parcelRequire("4R6GH");

var $2xFXk = parcelRequire("2xFXk");

var $2f454 = parcelRequire("2f454");

var $dW1HX = parcelRequire("dW1HX");

var $kc6Ry = parcelRequire("kc6Ry");

var $ptvay = parcelRequire("ptvay");

var $9OPlz = parcelRequire("9OPlz");

var $vAfHD = parcelRequire("vAfHD");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");
function $53398ea24e376224$export$2e2bcd8739ae039(action$, store) {
    return action$.ofType((0, $2f454.CARD_CLICK)).mergeMap((action)=>{
        const state = store.getState();
        const { issueId: issueId, withCmd: withCmd, withShift: withShift } = action.payload;
        if (withCmd) {
            const cardSelection = (0, $9OPlz.getCardSelection)(state);
            const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
            const isMultiSelectAcrossSwimlanesEnabled = (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).MULTISELECT_CARD_ACROSS_SWIMLANES);
            const isAdding = cardSelection.indexOf(action.payload.issueId) === -1;
            // We only allow issues with the same column, swimlane and card type to be selected together in a CMP board
            if (isCMPBoard && cardSelection.length !== 0 && isAdding) {
                const getColumnIdByIssue = (0, $5mTgl.issueColumnIdSelector)(state);
                const getSwimlaneIdByIssue = (0, $5mTgl.issueSwimlaneIdSelector)(state);
                const isIssueAChild = (0, $vAfHD.isBoardIssueAChild)(state);
                const existingSelectedId = cardSelection[0];
                const sameColumnId = getColumnIdByIssue(existingSelectedId) === getColumnIdByIssue(issueId);
                const sameSwimlaneId = getSwimlaneIdByIssue(existingSelectedId) === getSwimlaneIdByIssue(issueId);
                const sameCardType = isIssueAChild(existingSelectedId) === isIssueAChild(issueId);
                const sameCardGroup = (0, $d2i8f.getIssueById)(state, existingSelectedId).parentId === (0, $d2i8f.getIssueById)(state, issueId).parentId;
                if (!sameColumnId || !sameSwimlaneId || !sameCardType || isIssueAChild(issueId) && !sameCardGroup) return (0, $kVLXA.Observable).empty();
            }
            // Don't allow issues in the same swimlane to be selected together when
            // MULTISELECT_CARD_ACROSS_SWIMLANES capability is false
            if (!isMultiSelectAcrossSwimlanesEnabled && cardSelection.length !== 0 && isAdding) {
                const getSwimlaneIdByIssue = (0, $5mTgl.issueSwimlaneIdSelector)(state);
                const existingSelectedId = cardSelection[0];
                const sameSwimlaneId = getSwimlaneIdByIssue(existingSelectedId) === getSwimlaneIdByIssue(issueId);
                if (!sameSwimlaneId) return (0, $kVLXA.Observable).empty();
            }
            return (0, $kVLXA.Observable).of((0, $2f454.cardToggleSelection)(issueId));
        }
        if (withShift) {
            const rangeSelection = (0, $ptvay.getCardShiftSelectionIds)(state)(issueId);
            if (rangeSelection) return (0, $kVLXA.Observable).of((0, $2f454.cardMultiSelect)(rangeSelection));
        }
        // open bento + select card
        const issue = (0, $d2i8f.getIssueById)(state, issueId);
        const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        if (isIncrementPlanningBoard) {
            if ((0, $4R6GH.fg)('issue_view_in_program_board')) return (0, $kVLXA.Observable).from([
                (0, $2f454.cardSingleSelect)(issueId),
                (0, $dW1HX.openPlanIssueModal)(issueId.toString())
            ]);
            (0, $kVLXA.Observable).from([
                (0, $2f454.cardSingleSelect)(issueId)
            ]);
        }
        return (0, $kVLXA.Observable).from([
            (0, $2f454.cardSingleSelect)(issueId),
            (0, $dW1HX.openIssueModal)(issue.key, action.payload.externalAction)
        ]);
    });
}

});
parcelRegister("ptvay", function(module, exports) {

$parcel$export(module.exports, "getCardShiftSelectionIds", () => $37b4bb4aa286c991$export$4ef555e4d871575f);

var $hGgHi = parcelRequire("hGgHi");

var $7JoAD = parcelRequire("7JoAD");

var $5mTgl = parcelRequire("5mTgl");

var $9OPlz = parcelRequire("9OPlz");
const $37b4bb4aa286c991$export$4ef555e4d871575f = (0, $7JoAD.createSelector)([
    (0, $9OPlz.getCardSelection),
    (0, $5mTgl.platformIssueSelector),
    (0, $5mTgl.getFilteredIssueIdsByColumn),
    (0, $5mTgl.platformIssueIdsBySwimlaneSelector)
], (cardSelection, getPlatformIssue, filteredIssuesByColumn, filteredIssuesBySwimlane)=>(issueId)=>{
        if (!cardSelection.length) return null;
        const lastCardId = cardSelection[cardSelection.length - 1];
        const lastCard = getPlatformIssue(lastCardId);
        const thisCard = getPlatformIssue(issueId);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(lastCard) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(thisCard) || lastCard.columnId !== thisCard.columnId || lastCard.swimlaneId !== thisCard.swimlaneId) return null;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(thisCard.swimlaneId)) // no swimlane
        return $37b4bb4aa286c991$var$rangeSelectWithinColumn(filteredIssuesByColumn[thisCard.columnId], lastCardId, issueId);
        // has swimlane
        return $37b4bb4aa286c991$var$rangeSelectWithinColumn(filteredIssuesBySwimlane[thisCard.swimlaneId][thisCard.columnId], lastCardId, issueId);
    });
const $37b4bb4aa286c991$var$rangeSelectWithinColumn = (orderedIssues, lastCardId, issueId)=>{
    const startIndex = orderedIssues.indexOf(lastCardId);
    const endIndex = orderedIssues.indexOf(issueId);
    return orderedIssues.slice(Math.min(startIndex, endIndex), Math.max(startIndex, endIndex) + 1);
};

});


parcelRegister("fGfXq", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd2c73dff3af8640$export$2e2bcd8739ae039);
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("3awJm");
parcelRequire("fPS7b");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $2f454 = parcelRequire("2f454");

var $d1i1b = parcelRequire("d1i1b");

var $dW1HX = parcelRequire("dW1HX");

var $9OPlz = parcelRequire("9OPlz");

var $fqLDH = parcelRequire("fqLDH");

var $gR0bs = parcelRequire("gR0bs");

var $d2i8f = parcelRequire("d2i8f");
const $dd2c73dff3af8640$var$cardColumnNavigationEpic = (action$, store)=>action$.ofType((0, $2f454.CARD_NEXT_COLUMN), (0, $2f454.CARD_PREV_COLUMN)).throttleTime(200).mergeMap(({ type: type, payload: payload })=>{
        const state = store.getState();
        const activeCardId = (0, $9OPlz.getCardActive)(state);
        // Applying a filter or collapsing a swimlane does not clear the active card,
        // So we need to check manually if it is actually visible.
        const isActiveCardVisible = (0, $gR0bs.isActiveCardVisible)(state);
        const isCardNextColumn = type === (0, $2f454.CARD_NEXT_COLUMN);
        // The function to call when there's no card currently active
        const getFirstSelectableIssueFn = isCardNextColumn ? (0, $gR0bs.getFirstSelectableIssueInFirstColumn) : (0, $gR0bs.getFirstSelectableIssueInLastColumn);
        // The function to call when there's an active card
        const getNextOrPrevIssueFn = isCardNextColumn ? (0, $gR0bs.makeGetNeighbouringIssueInNextColumn) : (0, $gR0bs.makeGetNeighbouringIssueInPrevColumn);
        const newActiveIssueId = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeCardId) || !isActiveCardVisible ? getFirstSelectableIssueFn(state) : getNextOrPrevIssueFn(state)(activeCardId);
        const attributes = isCardNextColumn ? {
            id: 'nextColumnKeyboardShortcut',
            key: 'n'
        } : {
            id: 'previousColumnKeyboardShortcut',
            key: 'p'
        };
        payload.fireShortcutAnalyticsFn(attributes);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(newActiveIssueId)) return (0, $kVLXA.Observable).empty();
        const actions = [
            (0, $2f454.cardSingleSelect)(newActiveIssueId),
            (0, $2f454.cardFocus)(newActiveIssueId),
            (0, $d1i1b.cardAutoScroll)(newActiveIssueId)
        ];
        if ((0, $fqLDH.isIssueModalShowingSelector)(state)) {
            const issueKey = (0, $d2i8f.getIssueById)(state, newActiveIssueId).key;
            actions.push((0, $dW1HX.openIssueModalDebounced)(issueKey));
        }
        return (0, $kVLXA.Observable).from(actions);
    });
var $dd2c73dff3af8640$export$2e2bcd8739ae039 = $dd2c73dff3af8640$var$cardColumnNavigationEpic;

});
parcelRegister("fqLDH", function(module, exports) {

$parcel$export(module.exports, "getIssueModal", () => $ca4d10cff4d8f2d0$export$d50a1e4d7624445f);
$parcel$export(module.exports, "getIssueKeyForModal", () => $ca4d10cff4d8f2d0$export$9865dacc0ccd6c8e);
$parcel$export(module.exports, "getTimestampForModal", () => $ca4d10cff4d8f2d0$export$b858c74a94f5e00b);
$parcel$export(module.exports, "getExternalActionForModal", () => $ca4d10cff4d8f2d0$export$abec5eeca0d49152);
$parcel$export(module.exports, "getIssueByIdForModal", () => $ca4d10cff4d8f2d0$export$205b1cdd95c7fd35);
$parcel$export(module.exports, "getIssueIdForModal", () => $ca4d10cff4d8f2d0$export$d6b21a93073a1a2f);
$parcel$export(module.exports, "isIssueModalShowingSelector", () => $ca4d10cff4d8f2d0$export$747dd163f6ef1912);

var $dGvGJ = parcelRequire("dGvGJ");

var $gJBT6 = parcelRequire("gJBT6");

var $3UY9S = parcelRequire("3UY9S");

var $bSSdD = parcelRequire("bSSdD");

var $67Z81 = parcelRequire("67Z81");
const $ca4d10cff4d8f2d0$export$d50a1e4d7624445f = (state)=>(0, $67Z81.getUi)(state).issueModal;
const $ca4d10cff4d8f2d0$export$9865dacc0ccd6c8e = (state)=>$ca4d10cff4d8f2d0$export$d50a1e4d7624445f(state)?.selectedIssueKey;
const $ca4d10cff4d8f2d0$export$b858c74a94f5e00b = (state)=>$ca4d10cff4d8f2d0$export$d50a1e4d7624445f(state)?.timestamp ?? 0;
const $ca4d10cff4d8f2d0$export$abec5eeca0d49152 = (state)=>$ca4d10cff4d8f2d0$export$d50a1e4d7624445f(state)?.externalAction;
const $ca4d10cff4d8f2d0$export$205b1cdd95c7fd35 = (0, $dGvGJ.createSelector)([
    (0, $bSSdD.getIssueParents),
    (0, $67Z81.getIssues),
    (0, $3UY9S.getIssueChildren)
], (issueParents, issues, issueChildren)=>{
    const issueById = (issueId)=>issueParents[String(issueId)] || issues[String(issueId)] || issueChildren[String(issueId)] || null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(issueById);
});
const $ca4d10cff4d8f2d0$export$3c86cc428a87aa5e = (0, $dGvGJ.createSelector)([
    (0, $bSSdD.getIssueParents),
    (0, $67Z81.getIssues),
    (0, $3UY9S.getIssueChildren)
], (issueParents, issues, issueChildren)=>{
    const issueByKeyForModal = (issueKey)=>{
        const allIssues = {
            ...issueParents,
            ...issues,
            ...issueChildren
        };
        return Object.keys(allIssues).map((key)=>allIssues[key]).find((issue)=>issue.key === issueKey) || null;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(issueByKeyForModal);
});
const $ca4d10cff4d8f2d0$export$d6b21a93073a1a2f = (state)=>{
    const issueKey = $ca4d10cff4d8f2d0$export$9865dacc0ccd6c8e(state);
    const issue = $ca4d10cff4d8f2d0$export$3c86cc428a87aa5e(state)(issueKey);
    return issue ? issue.id : null;
};
const $ca4d10cff4d8f2d0$export$747dd163f6ef1912 = (state)=>$ca4d10cff4d8f2d0$export$9865dacc0ccd6c8e(state) !== null;

});

parcelRegister("gR0bs", function(module, exports) {

$parcel$export(module.exports, "getFirstSelectableIssueAscending", () => $2b50e391ccc94ced$export$10c0b19e7f67cd54);
$parcel$export(module.exports, "getFirstSelectableIssueDescending", () => $2b50e391ccc94ced$export$66eabf17ea5e1f07);
$parcel$export(module.exports, "getNextSelectableIssue", () => $2b50e391ccc94ced$export$91f27091d99780d1);
$parcel$export(module.exports, "getPrevSelectableIssue", () => $2b50e391ccc94ced$export$890c8ca26561b146);
$parcel$export(module.exports, "getFirstSelectableIssueInFirstColumn", () => $2b50e391ccc94ced$export$743d6303a5a83c8a);
$parcel$export(module.exports, "getFirstSelectableIssueInLastColumn", () => $2b50e391ccc94ced$export$f052e308ab96dfe1);
$parcel$export(module.exports, "makeGetNeighbouringIssueInNextColumn", () => $2b50e391ccc94ced$export$9284a66d7f0ff606);
$parcel$export(module.exports, "makeGetNeighbouringIssueInPrevColumn", () => $2b50e391ccc94ced$export$f83ca7f5aff3017);
$parcel$export(module.exports, "isActiveCardVisible", () => $2b50e391ccc94ced$export$5bfea476de38a26e);

var $dGvGJ = parcelRequire("dGvGJ");

var $gJBT6 = parcelRequire("gJBT6");

var $iuuJH = parcelRequire("iuuJH");

var $bwTbl = parcelRequire("bwTbl");

var $9OPlz = parcelRequire("9OPlz");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $5mTgl = parcelRequire("5mTgl");

var $vAfHD = parcelRequire("vAfHD");

var $d2i8f = parcelRequire("d2i8f");
const $2b50e391ccc94ced$var$getIsSwimlaneModeSet = (0, $dGvGJ.createSelector)((0, $45cXl.getSwimlaneMode), (swimlaneMode)=>swimlaneMode !== (0, $iuuJH.NO_SWIMLANE).id);
const $2b50e391ccc94ced$export$c7a1835f4be8a376 = (0, $dGvGJ.createSelector)([
    $2b50e391ccc94ced$var$getIsSwimlaneModeSet,
    (0, $5mTgl.platformIssueIdsBySwimlaneSelector),
    (0, $5mTgl.getFilteredIssueIdsByColumn),
    (0, $67Z81.getOrderedColumnIds),
    (0, $4jZ56.getSwimlanes),
    (0, $4jZ56.makeIsSwimlaneCollapsed)
], (isSwimlaneModeSet, issuesBySwimlane, issuesByColumn, orderedColumnIds, swimlanes, isSwimlaneCollapsed)=>{
    // Ids of all columns that contain issues
    const columndIds = orderedColumnIds.filter((columnId)=>issuesByColumn[String(columnId)].length).map(String);
    if (!columndIds.length) return [];
    if (isSwimlaneModeSet) {
        // Sort swimlanes in issuesBySwimlane into correct order
        const orderedSwimlanes = swimlanes.filter(({ id: id })=>!isSwimlaneCollapsed(id)).map(({ id: id })=>issuesBySwimlane[id]).filter(Boolean);
        // Find the first column that contains issues in one of the swimlanes
        const populatedColumnId = columndIds.find((id)=>orderedSwimlanes.some((swimlane)=>!!swimlane[id]));
        // Return issue ids for all issues in the given column, respecting swimlanes
        return populatedColumnId !== undefined ? orderedSwimlanes.map((swimlane)=>swimlane[populatedColumnId]).filter(Boolean).flat() : [];
    }
    // No swimlane mode is selected, return issues in the first ordered column
    return issuesByColumn[String(columndIds[0])];
});
const $2b50e391ccc94ced$export$10c0b19e7f67cd54 = (0, $dGvGJ.createSelector)($2b50e391ccc94ced$export$c7a1835f4be8a376, (issues)=>issues[0]);
const $2b50e391ccc94ced$export$66eabf17ea5e1f07 = (0, $dGvGJ.createSelector)($2b50e391ccc94ced$export$c7a1835f4be8a376, (issues)=>issues[issues.length - 1]);
const $2b50e391ccc94ced$export$bc08a2100ab1739b = (0, $dGvGJ.createSelector)([
    $2b50e391ccc94ced$var$getIsSwimlaneModeSet,
    (0, $5mTgl.platformIssueIdsBySwimlaneSelector),
    (0, $5mTgl.getFilteredIssueIdsByColumn),
    (0, $4jZ56.getSwimlanes),
    (0, $4jZ56.makeIsSwimlaneCollapsed)
], (isSwimlaneModeSet, issuesBySwimlane, issuesByColumn, swimlanes, isSwimlaneCollapsed)=>{
    const selectableIssuesInColumn = (columnId)=>{
        if (isSwimlaneModeSet) return swimlanes.filter(({ id: id })=>!isSwimlaneCollapsed(id)).map(({ id: id })=>issuesBySwimlane[id]).map((swimlane)=>swimlane && swimlane[String(columnId)]).filter(Boolean).flat();
        // No swimlane mode is selected
        return issuesByColumn[String(columnId)] || [];
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(selectableIssuesInColumn);
});
const $2b50e391ccc94ced$export$91f27091d99780d1 = (0, $dGvGJ.createSelector)([
    $2b50e391ccc94ced$export$bc08a2100ab1739b,
    (0, $d2i8f.makeGetColumnIdForIssue)
], (getSelectableIssuesInColumn, getColumnIdForIssue)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId)=>{
        const columnId = getColumnIdForIssue(issueId);
        const column = getSelectableIssuesInColumn(columnId);
        const issueIndex = column.indexOf(issueId);
        return column[issueIndex + 1];
    }));
const $2b50e391ccc94ced$export$890c8ca26561b146 = (0, $dGvGJ.createSelector)([
    $2b50e391ccc94ced$export$bc08a2100ab1739b,
    (0, $d2i8f.makeGetColumnIdForIssue)
], (getSelectableIssuesInColumn, getColumnIdForIssue)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId)=>{
        const columnId = getColumnIdForIssue(issueId);
        const column = getSelectableIssuesInColumn(columnId);
        const issueIndex = column.indexOf(issueId);
        return column[issueIndex - 1];
    }));
const $2b50e391ccc94ced$export$1ee41e350e15bf0a = (0, $dGvGJ.createSelector)([
    $2b50e391ccc94ced$var$getIsSwimlaneModeSet,
    (0, $5mTgl.platformIssueIdsBySwimlaneSelector),
    (0, $5mTgl.getFilteredIssueIdsByColumn),
    (0, $4jZ56.getSwimlanes),
    (0, $67Z81.getOrderedColumnIds),
    (0, $4jZ56.makeIsSwimlaneCollapsed)
], (isSwimlaneModeSet, issuesBySwimlane, issuesByColumn, swimlanes, orderedColumnIds, isSwimlaneCollapsed)=>{
    if (isSwimlaneModeSet) {
        const firstSwimlane = swimlanes.filter(({ id: id })=>!isSwimlaneCollapsed(id)).map(({ id: id })=>issuesBySwimlane[id]).filter(Boolean).shift();
        // All swimlanes are collapsed or there is no populated swimlane
        // based on the current filters
        if (!firstSwimlane) return undefined;
        return orderedColumnIds.filter((id)=>firstSwimlane[String(id)]).map((id)=>firstSwimlane[String(id)]);
    }
    // No swimlane mode is selected
    return orderedColumnIds.filter((id)=>issuesByColumn[String(id)].length).map((id)=>issuesByColumn[String(id)]);
});
const $2b50e391ccc94ced$export$743d6303a5a83c8a = (0, $dGvGJ.createSelector)($2b50e391ccc94ced$export$1ee41e350e15bf0a, (columns)=>{
    if (!columns || !columns.length) return undefined;
    return columns[0][0];
});
const $2b50e391ccc94ced$export$f052e308ab96dfe1 = (0, $dGvGJ.createSelector)($2b50e391ccc94ced$export$1ee41e350e15bf0a, (columns)=>{
    if (!columns || !columns.length) return undefined;
    return columns[columns.length - 1][0];
});
const $2b50e391ccc94ced$var$makeGetSwimlaneForIssue = (0, $dGvGJ.createSelector)([
    (0, $d2i8f.makeGetColumnIdForIssue),
    (0, $4jZ56.getSwimlanes),
    (0, $5mTgl.platformIssueIdsBySwimlaneSelector)
], (getColumnIdForIssue, swimlanes, issuesBySwimlane)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId)=>{
        const issueColumnId = getColumnIdForIssue(issueId);
        const swimlane = swimlanes.find(({ id: id })=>issuesBySwimlane[id] && issuesBySwimlane[id][String(issueColumnId)] && issuesBySwimlane[id][String(issueColumnId)].indexOf(issueId) > -1);
        return swimlane && issuesBySwimlane[swimlane.id];
    }));
const $2b50e391ccc94ced$export$1a4c2ddb73ee852d = (0, $dGvGJ.createSelector)([
    $2b50e391ccc94ced$var$getIsSwimlaneModeSet,
    (0, $d2i8f.makeGetColumnIdForIssue),
    (0, $67Z81.getOrderedColumnIds),
    (0, $5mTgl.getFilteredIssueIdsByColumn),
    $2b50e391ccc94ced$var$makeGetSwimlaneForIssue
], (isSwimlaneModeSet, getColumnIdForIssue, orderedColumnIds, issuesByColumn, getSwimlaneForIssue)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId)=>{
        const issueColumnId = getColumnIdForIssue(issueId);
        // If we're using a swimlane mode, get all issues by column for this swimlane,
        // Otherwise use all issues by column
        const issues = isSwimlaneModeSet ? getSwimlaneForIssue(issueId) : issuesByColumn;
        if (!issues) return undefined;
        // Get rid of columns that are empty
        const orderedPopulatedColumnIds = orderedColumnIds.filter((id)=>issues[String(id)] && issues[String(id)].length);
        const orderedPopulatedColumns = orderedPopulatedColumnIds.map((id)=>issues[String(id)]);
        // Find the column the issue resides in, and return the columns before and after it
        const issueColumnIndex = orderedPopulatedColumnIds.indexOf(issueColumnId);
        const currColumn = orderedPopulatedColumns[issueColumnIndex];
        const nextColumn = orderedPopulatedColumns[issueColumnIndex + 1];
        const prevColumn = orderedPopulatedColumns[issueColumnIndex - 1];
        return {
            current: currColumn,
            next: nextColumn,
            prev: prevColumn
        };
    }));
// Based on the rank of the issue in the current column,
// return an issue in the new column
const $2b50e391ccc94ced$var$getIssueInNewColumn = (currentIssue, currentColumn, newColumn)=>{
    const issueColumnRank = currentColumn.indexOf(currentIssue);
    // Return an issue in the new column that is in the same rank as the current issue.
    // If the new column is shorter, then we return the last issue in that column.
    return newColumn[issueColumnRank] || newColumn[newColumn.length - 1];
};
const $2b50e391ccc94ced$export$9284a66d7f0ff606 = (0, $dGvGJ.createSelector)([
    $2b50e391ccc94ced$export$1a4c2ddb73ee852d
], (getNeighbouringColumnsForIssue)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId)=>{
        const neighbouringColumns = getNeighbouringColumnsForIssue(issueId);
        if (!neighbouringColumns || !neighbouringColumns.next) return undefined;
        return $2b50e391ccc94ced$var$getIssueInNewColumn(issueId, neighbouringColumns.current, neighbouringColumns.next);
    }));
const $2b50e391ccc94ced$export$f83ca7f5aff3017 = (0, $dGvGJ.createSelector)([
    $2b50e391ccc94ced$export$1a4c2ddb73ee852d
], (getNeighbouringColumnsForIssue)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId)=>{
        const neighbouringColumns = getNeighbouringColumnsForIssue(issueId);
        if (!neighbouringColumns || !neighbouringColumns.prev) return undefined;
        return $2b50e391ccc94ced$var$getIssueInNewColumn(issueId, neighbouringColumns.current, neighbouringColumns.prev);
    }));
const $2b50e391ccc94ced$export$5bfea476de38a26e = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    (0, $4jZ56.getSwimlanes),
    (0, $vAfHD.boardIssuesSelector),
    (0, $9OPlz.getCardActive),
    (0, $5mTgl.isIssueVisible),
    (0, $4jZ56.makeIsSwimlaneCollapsed)
], (swimlaneMode, swimlanes, boardIssues, activeCardId, getIsIssueVisible, isSwimlaneCollapsed)=>{
    if (activeCardId === null || activeCardId === undefined) return false;
    const isVisible = getIsIssueVisible(activeCardId);
    const issue = boardIssues[String(activeCardId)];
    const issueSwimlaneId = (0, $bwTbl.getSwimlaneId)(swimlaneMode, swimlanes, issue);
    const isCollapsed = issueSwimlaneId !== null ? isSwimlaneCollapsed(issueSwimlaneId) : false;
    return isVisible && !isCollapsed;
});

});


parcelRegister("gG0ZK", function(module, exports) {

$parcel$export(module.exports, "default", () => $14c6b3c1831cb426$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $2f454 = parcelRequire("2f454");

var $3UY9S = parcelRequire("3UY9S");

var $67Z81 = parcelRequire("67Z81");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$14c6b3c1831cb426$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $2f454.CARD_DELETE_OPTIMISTIC)).mergeMap((action)=>{
        const state = store.getState();
        const issues = (0, $67Z81.getIssues)(state);
        const issueChildren = (0, $3UY9S.getIssueChildren)(state);
        const { issueId: issueId } = action.payload;
        const { parentId: parentId, isDone: isDone } = issues[String(issueId)] || issueChildren[String(issueId)] || {};
        return (0, $kVLXA.Observable).of((0, $2f454.cardDelete)(issueId, !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(parentId) && parentId !== 0 ? Number(parentId) : null, isDone || false));
    });

});

parcelRegister("5Farb", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0e549fb3fb4ded3$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $6eDJO = parcelRequire("6eDJO");

var $hdmw1 = parcelRequire("hdmw1");

var $kXqRJ = parcelRequire("kXqRJ");

var $67Z81 = parcelRequire("67Z81");
const $c0e549fb3fb4ded3$export$f8970984cad95ae6 = (state, action)=>{
    const siteId = (0, $67Z81.cloudIdSelector)(state);
    const activationId = (0, $67Z81.activationIdSelector)(state);
    const boardId = (0, $67Z81.rapidViewIdSelector)(state);
    const cardId = action.payload.issue.id.toString();
    // TODO: Update this to use ARI library @atlassian/ari when dependency is accepted https://jdog.jira-dev.com/browse/TOTEM-3113
    const cardAri = `ari:cloud:jira-software:${siteId}:card/activation/${activationId}/${boardId}/${cardId}`;
    return {
        cardId: cardAri
    };
};
const $c0e549fb3fb4ded3$export$5b7b119918f28224 = (state, action)=>({
        cloudId: (0, $67Z81.cloudIdSelector)(state),
        issueId: action.payload.issue.id
    });
const $c0e549fb3fb4ded3$export$d3da1ecaf1206c58 = ({ error: error, issueId: issueId, optimisticId: optimisticId })=>{
    try {
        const response = JSON.parse(error.message);
        if (response && typeof response === 'object' && 'errorMessages' in response && response.errorMessages && Array.isArray(response.errorMessages)) {
            const errors = response.errorMessages.map((message)=>String(message));
            return (0, $kXqRJ.issueDeleteFailure)(optimisticId, issueId, errors);
        }
    } catch (_parseErr) {
    /* empty */ }
    return (0, $kXqRJ.issueDeleteFailure)(optimisticId, issueId);
};
const $c0e549fb3fb4ded3$var$cardDeleteEpic = (action$, store)=>action$.ofType((0, $kXqRJ.ISSUE_DELETE_REQUEST)).mergeMap((action)=>{
        const { payload: { issue: issue }, meta: { optimistic: { id: optimisticId } } } = action;
        const state = store.getState();
        const ctx = (0, $hdmw1.makeServiceContext)(state);
        const deleteCardInput = $c0e549fb3fb4ded3$export$f8970984cad95ae6(state, action);
        const extraInput = $c0e549fb3fb4ded3$export$5b7b119918f28224(state, action);
        return (0, $6eDJO.deleteCardService)(ctx, {
            deleteCardInput: deleteCardInput,
            extraInput: extraInput
        }).flatMap(()=>(0, $kVLXA.Observable).of((0, $kXqRJ.issueDeleteSuccess)(optimisticId, issue.id))).catch((err)=>(0, $kVLXA.Observable).of($c0e549fb3fb4ded3$export$d3da1ecaf1206c58({
                error: err,
                optimisticId: optimisticId,
                issueId: issue.id
            })));
    });
var $c0e549fb3fb4ded3$export$2e2bcd8739ae039 = $c0e549fb3fb4ded3$var$cardDeleteEpic;

});
parcelRegister("6eDJO", function(module, exports) {

$parcel$export(module.exports, "deleteCardService", () => $120e01bab0465847$export$f17f430ad1b1a795);
parcelRequire("d0pqD");

var $95uwh = parcelRequire("95uwh");
const $120e01bab0465847$export$f17f430ad1b1a795 = (ctx, { deleteCardInput: deleteCardInput, extraInput: extraInput })=>(0, $95uwh.deleteCard)(deleteCardInput, extraInput);

});
parcelRegister("95uwh", function(module, exports) {

$parcel$export(module.exports, "deleteCard", () => $109dd98e4d861aae$export$cbb49d44ad636b27);

var $6qa57 = parcelRequire("6qa57");

var $8Uumt = parcelRequire("8Uumt");

var $kVLXA = parcelRequire("kVLXA");

var $dXq4S = parcelRequire("dXq4S");

var $5yJb9 = parcelRequire("5yJb9");

var $3vXOY = parcelRequire("3vXOY");

var $iJZ8l = parcelRequire("iJZ8l");
const $109dd98e4d861aae$export$cbb49d44ad636b27 = (deleteCardInput, extraInput)=>{
    const variables = {
        input: deleteCardInput
    };
    return (0, $kVLXA.Observable).fromPromise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    new Promise((resolve, reject)=>{
        (0, $8Uumt.commitMutation)((0, $5yJb9.default)(), {
            mutation: (0, $6qa57.default),
            variables: variables,
            updater: (store)=>{
                const { cloudId: cloudId, issueId: issueId } = extraInput;
                const issueAri = (0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'issue',
                    resourceId: issueId.toString()
                });
                const issueDataId = (0, $iJZ8l.default)({
                    id: issueAri
                }, 'SoftwareCard');
                if (issueDataId !== undefined) store.delete(issueDataId);
            },
            onCompleted: (response, errors)=>{
                if (errors && errors.length) {
                    const statusCode = (0, $3vXOY.getStatusCodeFromGraphQLErrors)(errors);
                    if (statusCode == null) {
                        reject(errors);
                        return;
                    }
                    errors.map((error)=>reject(error));
                    return;
                }
                resolve(response);
            },
            onError: (error)=>{
                reject(error);
            }
        });
    }));
};

});
parcelRegister("6qa57", function(module, exports) {

$parcel$export(module.exports, "default", () => $127a78bc27ebca2d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c7f0c26ed76fc88a07d0b6e2727631e>>
 * @relayHash fa42f3dae449dd75a7e68c391802ede8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ac6e9aa13260fb57ab6309b16626fe198ec2f0135614da11dfbd6db4f09891f
const $127a78bc27ebca2d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JswMutation",
            "kind": "LinkedField",
            "name": "jsw",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "DeleteCardOutput",
                    "kind": "LinkedField",
                    "name": "deleteCard",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientMutationId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "deleteCardMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "deleteCardMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "7ac6e9aa13260fb57ab6309b16626fe198ec2f0135614da11dfbd6db4f09891f",
            "metadata": {},
            "name": "deleteCardMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$127a78bc27ebca2d$var$node.hash = "1b3d8079ce3d693831c2e051a32abf3b";
var $127a78bc27ebca2d$export$2e2bcd8739ae039 = $127a78bc27ebca2d$var$node;

});



parcelRegister("kXqRJ", function(module, exports) {

$parcel$export(module.exports, "ISSUE_DELETE_REQUEST", () => $41524edc0ab150e2$export$a6c1c8403721a005);
$parcel$export(module.exports, "issueDeleteRequest", () => $41524edc0ab150e2$export$6460f58b640b4012);
$parcel$export(module.exports, "ISSUE_DELETE_SUCCESS", () => $41524edc0ab150e2$export$dec6ab7199007975);
$parcel$export(module.exports, "issueDeleteSuccess", () => $41524edc0ab150e2$export$bcb7ef15796f58b0);
$parcel$export(module.exports, "ISSUE_DELETE_FAILURE", () => $41524edc0ab150e2$export$f2386abdd28c7f20);
$parcel$export(module.exports, "issueDeleteFailure", () => $41524edc0ab150e2$export$3d3a8d020fe32306);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");

var $9rND4 = parcelRequire("9rND4");
const $41524edc0ab150e2$export$a6c1c8403721a005 = 'state.actions.issue.delete.ISSUE_DELETE_REQUEST';
const $41524edc0ab150e2$export$6460f58b640b4012 = (issue, childIssueIds)=>({
        type: $41524edc0ab150e2$export$a6c1c8403721a005,
        payload: {
            issue: issue,
            childIssueIds: childIssueIds
        },
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)()
        }
    });
const $41524edc0ab150e2$export$dec6ab7199007975 = 'state.actions.issue.delete.ISSUE_DELETE_SUCCESS';
const $41524edc0ab150e2$export$bcb7ef15796f58b0 = (optimisticId, issueId)=>({
        type: $41524edc0ab150e2$export$dec6ab7199007975,
        payload: {
            issueId: issueId
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $41524edc0ab150e2$export$f2386abdd28c7f20 = 'state.actions.issue.delete.ISSUE_DELETE_FAILURE';
const $41524edc0ab150e2$export$3d3a8d020fe32306 = (optimisticId, issueId, errorMessages = null)=>({
        type: $41524edc0ab150e2$export$f2386abdd28c7f20,
        payload: {
            issueId: issueId
        },
        meta: errorMessages ? {
            ...(0, $9rND4.revertOptimisticUiMeta)(optimisticId),
            ...(0, $sdxnu.warningFlagMeta)({
                id: 'ISSUE_DELETE_ERROR_FLAG',
                titleMessage: (0, $7AVqz.default).deleteFailureTitle,
                descriptionMessage: (0, $7AVqz.default).genericDescription,
                rawDescriptionMessage: errorMessages.join('\n\n')
            })
        } : (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("5ZlmD", function(module, exports) {

$parcel$export(module.exports, "cardDragStartEpic", () => $a68f3b7618cc7f07$export$c65f66b1d098a388);
parcelRequire("fp4O3");
parcelRequire("6hSeW");

var $kVLXA = parcelRequire("kVLXA");

var $6oUms = parcelRequire("6oUms");

var $eu61M = parcelRequire("eu61M");

var $2f454 = parcelRequire("2f454");

var $9OPlz = parcelRequire("9OPlz");
const $a68f3b7618cc7f07$export$4861ae22c9708538 = (payload, state)=>{
    if (!payload) return (0, $kVLXA.Observable).empty();
    const cardId = `${(0, $6oUms.getDescriptor)(payload.draggableId).id}`;
    const selectedIds = (0, $9OPlz.getCardSelection)(state).map((id)=>`${id}`);
    if (selectedIds.length === 0 || selectedIds.includes(cardId)) return (0, $kVLXA.Observable).empty();
    return (0, $kVLXA.Observable).of((0, $2f454.cardCancelSelection)());
};
function $a68f3b7618cc7f07$export$c65f66b1d098a388(action$, store) {
    return action$.ofType((0, $eu61M.DRAG_START)).mergeMap((action)=>$a68f3b7618cc7f07$export$4861ae22c9708538(action.payload, store.getState()));
}

});
parcelRegister("6oUms", function(module, exports) {

$parcel$export(module.exports, "getDescriptor", () => $ae2b40e955a59f76$export$dd068f9289a3efeb);
$parcel$export(module.exports, "getColumnDescriptor", () => $ae2b40e955a59f76$export$37010f521c16e534);
$parcel$export(module.exports, "getCardDescriptor", () => $ae2b40e955a59f76$export$e50ce3233c010197);

const $ae2b40e955a59f76$export$dd068f9289a3efeb = (identifier)=>{
    const [type, id, swimlaneId] = identifier.split('::');
    const maybeNumberId = Number(id);
    return {
        type: type,
        id: Number.isNaN(maybeNumberId) ? id : maybeNumberId,
        swimlaneId: swimlaneId || undefined
    };
};
const $ae2b40e955a59f76$export$37010f521c16e534 = (columnId, swimlaneId)=>swimlaneId ? `${0, $589d07317c4524ed$export$7f092194d45e1f0d}::${columnId}::${swimlaneId}` : `${0, $589d07317c4524ed$export$7f092194d45e1f0d}::${columnId}`;
const $ae2b40e955a59f76$export$e50ce3233c010197 = (cardId)=>`${0, $589d07317c4524ed$export$76a449e52fa0e1e8}::${cardId}`;

});
const $589d07317c4524ed$export$76a449e52fa0e1e8 = 'ISSUE';
const $589d07317c4524ed$export$7f092194d45e1f0d = 'COLUMN';


parcelRegister("eu61M", function(module, exports) {

$parcel$export(module.exports, "DRAG_START", () => $b6559dcb336b0737$export$56a2165aef3d890f);
$parcel$export(module.exports, "dragStart", () => $b6559dcb336b0737$export$c34730c351bf3a09);
$parcel$export(module.exports, "DRAG_END", () => $b6559dcb336b0737$export$fc1141357993c252);
$parcel$export(module.exports, "dragEnd", () => $b6559dcb336b0737$export$5d38b0bd4bef40ba);
const $b6559dcb336b0737$export$56a2165aef3d890f = 'state.actions.board.drag.DRAG_START';
const $b6559dcb336b0737$export$c34730c351bf3a09 = (draggableId, mode)=>draggableId && mode ? {
        type: $b6559dcb336b0737$export$56a2165aef3d890f,
        payload: {
            draggableId: draggableId,
            mode: mode
        }
    } : {
        type: $b6559dcb336b0737$export$56a2165aef3d890f
    };
const $b6559dcb336b0737$export$fc1141357993c252 = 'state.actions.board.drag.DRAG_END';
const $b6559dcb336b0737$export$5d38b0bd4bef40ba = ()=>({
        type: $b6559dcb336b0737$export$fc1141357993c252
    });

});


parcelRegister("93Fzk", function(module, exports) {

$parcel$export(module.exports, "cardsMoveEpic", () => $607fa67f873704d7$export$e54c6a4679c869f3);
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $gULOk = parcelRequire("gULOk");

var $4jAPy = parcelRequire("4jAPy");

var $3spCR = parcelRequire("3spCR");

var $iuuJH = parcelRequire("iuuJH");

var $2f454 = parcelRequire("2f454");

var $iDcEO = parcelRequire("iDcEO");

var $e1q2I = parcelRequire("e1q2I");

var $5UXId = parcelRequire("5UXId");

var $71oFY = parcelRequire("71oFY");

var $k50Aq = parcelRequire("k50Aq");

var $lIysR = parcelRequire("lIysR");

var $9OPlz = parcelRequire("9OPlz");

var $fyeGd = parcelRequire("fyeGd");

var $3UY9S = parcelRequire("3UY9S");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $cPGP0 = parcelRequire("cPGP0");

var $5mTgl = parcelRequire("5mTgl");
const $607fa67f873704d7$export$555d348c9f201554 = (destinationCardIds, sourceColumnId, destinationColumnId, sourceCardIndex, destinationCardIndex, sourceSwimlaneId, destinationSwimlaneId)=>{
    if (!destinationCardIds || destinationCardIds.length === 0) return {};
    // rank. move inside same column
    if (destinationColumnId === sourceColumnId && sourceSwimlaneId === destinationSwimlaneId) {
        // move down list
        if (destinationCardIndex > sourceCardIndex) // rank after last moved item
        return {
            rankAfterCardId: destinationCardIds[destinationCardIndex]
        };
        // rank before last moved item
        return {
            rankBeforeCardId: destinationCardIds[destinationCardIndex]
        };
    }
    // rank + transition. Move from one column to another + rank inside destination column
    if (destinationCardIndex === 0) // rank before first item
    return {
        rankBeforeCardId: destinationCardIds[destinationCardIndex]
    };
    return {
        rankAfterCardId: destinationCardIds[destinationCardIndex - 1]
    };
};
const $607fa67f873704d7$export$e8f4ada03ddbca5e = ({ cardIds: cardIds, destinationCardIds: destinationCardIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, sourceCardIndex: sourceCardIndex, destinationCardIndex: destinationCardIndex, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId }, state)=>{
    const { rankBeforeCardId: rankBeforeCardId, rankAfterCardId: rankAfterCardId } = $607fa67f873704d7$export$555d348c9f201554(destinationCardIds, sourceColumnId, destinationColumnId, sourceCardIndex, destinationCardIndex, sourceSwimlaneId, destinationSwimlaneId);
    if (sourceColumnId === destinationColumnId && sourceCardIndex === destinationCardIndex && sourceSwimlaneId === destinationSwimlaneId) return (0, $kVLXA.Observable).empty();
    const destinationSwimlaneTeam = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(destinationSwimlaneId) ? (0, $cPGP0.getTeamById)(state)(destinationSwimlaneId) : undefined;
    if (sourceSwimlaneId !== destinationSwimlaneId && !destinationSwimlaneTeam?.isPlanTeam && destinationSwimlaneId !== (0, $4jAPy.SWIMLANE_TEAMLESS)) return (0, $kVLXA.Observable).of((0, $k50Aq.teamSwimLaneInvalidMove)(destinationSwimlaneTeam?.name || ''));
    const sprintForTeamSwimlaneColumn = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(destinationSwimlaneId) ? (0, $5mTgl.getTeamSwimlaneColumnSprint)(state, destinationColumnId, destinationSwimlaneId) : undefined;
    const isClosedSprint = sprintForTeamSwimlaneColumn && sprintForTeamSwimlaneColumn.state === (0, $3spCR.SPRINT_STATES).CLOSED;
    if (isClosedSprint) return (0, $kVLXA.Observable).of((0, $k50Aq.swimlaneColumnClosedSprintInvalidMove)(sprintForTeamSwimlaneColumn.name));
    return (0, $kVLXA.Observable).of((0, $5UXId.issueRankTeamDateRequest)({
        issueIds: cardIds,
        sourceColumnId: sourceColumnId,
        destinationColumnId: destinationColumnId,
        rankBeforeIssueId: rankBeforeCardId,
        rankAfterIssueId: rankAfterCardId,
        sourceSwimlaneId: sourceSwimlaneId,
        destinationSwimlaneId: destinationSwimlaneId
    }));
};
const $607fa67f873704d7$export$a11ebd2d21578b3 = ({ cardIds: cardIds, destinationCardIds: destinationCardIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, sourceCardIndex: sourceCardIndex, destinationCardIndex: destinationCardIndex, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId, analyticsEvent: analyticsEvent }, state)=>{
    const { rankBeforeCardId: rankBeforeCardId, rankAfterCardId: rankAfterCardId } = $607fa67f873704d7$export$555d348c9f201554(destinationCardIds, sourceColumnId, destinationColumnId, sourceCardIndex, destinationCardIndex, sourceSwimlaneId, destinationSwimlaneId);
    const transitionId = (0, $9OPlz.getSelectedTransition)(state)?.transitionId;
    const destinationStatus = (0, $lIysR.cardTransitionDestinationStatusSelector)(state)(cardIds[0], destinationColumnId);
    // If we drag-and-dropped the issue into exactly the same place, do nothing.
    if (sourceColumnId === destinationColumnId && sourceCardIndex === destinationCardIndex && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transitionId) && ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(sourceSwimlaneId) && !destinationSwimlaneId || sourceSwimlaneId === destinationSwimlaneId)) return (0, $kVLXA.Observable).empty();
    // When there are multiple statuses per column isSourceDone represents the resolution of the issue
    // rather than the column, as an unresolved issue can be in a done column and vise versa.
    const isSourceDone = (0, $d2i8f.isDoneIssueSelector)(state)(cardIds[0]);
    let isDestinationDone = (0, $fyeGd.isDoneColumnSelector)(state)(destinationColumnId);
    // When there are multiple statuses per column a user can move an issue to a not done status even
    // though the column is considered "done", therefore we need to check the destinationStatus as it will be used
    // when selecting a status within a column that has multiple statuses
    if (destinationStatus) isDestinationDone = destinationStatus.category === (0, $gULOk.DONE);
    const actions = [
        (0, $71oFY.bulkIssueRankTransitionRequest)({
            issueIds: cardIds,
            sourceColumnId: sourceColumnId,
            destinationColumnId: destinationColumnId,
            rankBeforeIssueId: rankBeforeCardId,
            rankAfterIssueId: rankAfterCardId,
            sourceSwimlaneId: sourceSwimlaneId,
            destinationSwimlaneId: destinationSwimlaneId,
            isSourceDone: isSourceDone,
            isDestinationDone: isDestinationDone,
            transitionId: transitionId,
            sourceStatus: (0, $lIysR.cardTransitionSourceStatusSelector)(state)(cardIds[0]),
            destinationStatus: destinationStatus,
            isRankable: (0, $67Z81.isBoardRankable)(state),
            analyticsEvent: analyticsEvent
        })
    ];
    if (isDestinationDone && !isSourceDone) actions.push((0, $2f454.cardAddShowRipple)(cardIds));
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(destinationSwimlaneId) && sourceSwimlaneId !== destinationSwimlaneId) {
        const values = (0, $4jZ56.makeSwimlaneValuesSelector)(state)(destinationSwimlaneId);
        if (values) actions.push((0, $e1q2I.issueChangeSwimlane)(cardIds, destinationSwimlaneId, values));
    }
    return (0, $kVLXA.Observable).from(actions);
};
const $607fa67f873704d7$var$tryGetBulkSelectionIds = (state, cardId)=>{
    const cardSelection = (0, $9OPlz.getCardSelection)(state);
    return cardSelection.includes(cardId) ? [
        ...cardSelection
    ] : [
        cardId
    ];
};
const $607fa67f873704d7$export$8af04b1252e03f45 = ({ cardIds: cardIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, sourceCardIndex: sourceCardIndex, destinationCardIndex: destinationCardIndex, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId, analyticsEvent: analyticsEvent }, state)=>{
    const cardsByColumn = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(destinationSwimlaneId) ? (0, $5mTgl.platformIssueIdsBySwimlaneSelector)(state)[destinationSwimlaneId] : (0, $5mTgl.getFilteredIssueIdsByColumn)(state);
    let destinationCardIds = cardsByColumn[String(destinationColumnId)] ?? [];
    const issueChildren = (0, $3UY9S.getIssueChildren)(state);
    const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
    if ((0, $67Z81.getIsCMPBoard)(state) && (0, $45cXl.getSwimlaneMode)(state) !== (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) {
        const cardGroupParentIds = [];
        const isIssueChild = cardIds[0] in issueChildren;
        const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
        if (swimlaneMode !== (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && isIssueChild) {
            const issueChild = issueChildren[cardIds[0]];
            const childrenIds = (0, $3UY9S.getChildrenOfParent)(state)(issueChild.parentId) || [];
            destinationCardIds = destinationCardIds.filter((id)=>childrenIds.includes(id));
        } else destinationCardIds = destinationCardIds.reduce((result, cardId)=>{
            const parentId = (0, $3UY9S.getParentIdByIssueChildSelector)(state)(cardId);
            if (parentId) // Get the parent id for the subtask group, because subtasks always follow their parents when ranking if the board is rankable
            {
                if (!cardGroupParentIds.includes(parentId)) {
                    cardGroupParentIds.push(parentId);
                    result.push(parentId);
                }
            } else result.push(cardId);
            return result;
        }, []);
    }
    const cardIdsToMove = $607fa67f873704d7$var$tryGetBulkSelectionIds(state, cardIds[0]);
    if (isIncrementPlanningBoard) return $607fa67f873704d7$export$e8f4ada03ddbca5e({
        cardIds: cardIdsToMove,
        destinationCardIds: destinationCardIds,
        sourceColumnId: sourceColumnId,
        destinationColumnId: destinationColumnId,
        sourceCardIndex: sourceCardIndex,
        destinationCardIndex: destinationCardIndex,
        sourceSwimlaneId: sourceSwimlaneId,
        destinationSwimlaneId: destinationSwimlaneId
    }, state);
    return $607fa67f873704d7$export$a11ebd2d21578b3({
        cardIds: cardIdsToMove,
        destinationCardIds: destinationCardIds,
        sourceColumnId: sourceColumnId,
        destinationColumnId: destinationColumnId,
        sourceCardIndex: sourceCardIndex,
        destinationCardIndex: destinationCardIndex,
        sourceSwimlaneId: sourceSwimlaneId,
        destinationSwimlaneId: destinationSwimlaneId,
        analyticsEvent: analyticsEvent
    }, state);
};
function $607fa67f873704d7$export$e54c6a4679c869f3(action$, store) {
    return action$.ofType((0, $iDcEO.CARDS_MOVE)).mergeMap((action)=>$607fa67f873704d7$export$8af04b1252e03f45(action.payload, store.getState()));
}

});
parcelRegister("iDcEO", function(module, exports) {

$parcel$export(module.exports, "CARDS_MOVE", () => $264035bd19c86665$export$b33d2f47990782ba);
$parcel$export(module.exports, "cardsMove", () => $264035bd19c86665$export$68ae240377a1a3d7);
const $264035bd19c86665$export$b33d2f47990782ba = 'state.action.card.card-move.CARDS_MOVE';
const $264035bd19c86665$export$68ae240377a1a3d7 = (payload)=>({
        type: $264035bd19c86665$export$b33d2f47990782ba,
        payload: payload
    });
const $264035bd19c86665$export$c54ee0b69949f6a9 = 'state.action.card.card-move.GROUP_CARDS_MOVE';

});

parcelRegister("e1q2I", function(module, exports) {

$parcel$export(module.exports, "DONE_ISSUES_BUTTON_CLICK", () => $afb9c731414a4c17$export$4e6e21c1d555ffb9);
$parcel$export(module.exports, "doneIssuesButtonClick", () => $afb9c731414a4c17$export$fdc4a4b0f77c4bc1);
$parcel$export(module.exports, "ISSUE_CHANGE_SWIMLANE", () => $afb9c731414a4c17$export$80573f0ea27967f9);
$parcel$export(module.exports, "issueChangeSwimlane", () => $afb9c731414a4c17$export$b1b86dea7a51e7b5);
$parcel$export(module.exports, "SET_ISSUES_NOT_ON_BOARD", () => $afb9c731414a4c17$export$26e74a859871d970);
const $afb9c731414a4c17$export$4e6e21c1d555ffb9 = 'state.actions.issue.DONE_ISSUES_BUTTON_CLICK';
const $afb9c731414a4c17$export$fdc4a4b0f77c4bc1 = ()=>({
        type: $afb9c731414a4c17$export$4e6e21c1d555ffb9
    });
const $afb9c731414a4c17$export$80573f0ea27967f9 = 'state.actions.issue.ISSUE_CHANGE_SWIMLANE';
const $afb9c731414a4c17$export$b1b86dea7a51e7b5 = (issueIds, swimlaneId, swimlaneValues)=>({
        type: $afb9c731414a4c17$export$80573f0ea27967f9,
        payload: {
            issueIds: issueIds,
            swimlaneId: swimlaneId,
            swimlaneValues: swimlaneValues
        }
    });
const $afb9c731414a4c17$export$26e74a859871d970 = 'state.actions.issue.SET_ISSUES_NOT_ON_BOARD';
const $afb9c731414a4c17$export$c80308cab8e885d8 = (payload)=>({
        type: $afb9c731414a4c17$export$26e74a859871d970,
        payload: payload
    });

});


parcelRegister("i9XZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e657e869fe364458$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");
parcelRequire("d0pqD");
parcelRequire("1oQta");
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $gccSB = parcelRequire("gccSB");

var $kVLXA = parcelRequire("kVLXA");

var $5rFbt = parcelRequire("5rFbt");

var $dJl1T = parcelRequire("dJl1T");

var $g5X3G = parcelRequire("g5X3G");


var $hjlQ8 = parcelRequire("hjlQ8");

var $6fpfm = parcelRequire("6fpfm");

var $252qi = parcelRequire("252qi");

var $lF9PL = parcelRequire("lF9PL");

var $2f454 = parcelRequire("2f454");

var $4gHuj = parcelRequire("4gHuj");

var $dN3Ms = parcelRequire("dN3Ms");

var $evkwq = parcelRequire("evkwq");

var $9OPlz = parcelRequire("9OPlz");

var $fyeGd = parcelRequire("fyeGd");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");
const $e657e869fe364458$export$343b49279bcad83d = (action$, store)=>action$.ofType((0, $2f454.CARD_REFRESH_REQUEST)).switchMap((action)=>{
        const state = store.getState();
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const estimateFieldId = (0, $5mTgl.getEstimationStatistic)(state);
        const cardIds = action.payload.issueIds ? action.payload.issueIds.map((issueId)=>String(issueId)) : [];
        if ((0, $67Z81.getIsCMPBoard)(state)) return (0, $kVLXA.Observable).empty();
        // eslint-disable-next-line @atlassian/eng-health/code-evolution/ts-migration-4.9-5.4
        return (0, $6fpfm.cardRefreshBoardScopeService)(contextPath, boardId, cardIds) // @ts-expect-error([Part of upgrade 4.9-5.4]) - Argument of type '(response: CardRefreshBoardScopeResponse) => Observable<IssueUpdateFailureAction> | Observable<AnyAction>' is not assignable to parameter of type '(value: CardRefreshBoardScopeResponse, index: number) => ObservableInput<AnyAction>'.
        .flatMap((response)=>{
            const { projectLocation: { id: projectId }, cards: cards, board: board } = response.data.boardScope;
            if (cards === null) return (0, $kVLXA.Observable).of((0, $evkwq.issueUpdateFailure)(`failed to get cards ${String(cardIds)}`));
            const stateAfterRefresh = store.getState();
            return (0, $kVLXA.Observable).from(cards.reduce((actions, card)=>{
                const cardPerson = card.issue.assignee !== null ? (0, $lF9PL.cardRefreshPersonTransformer)(card.issue.assignee) : null;
                const { issue: { status: status } } = card;
                const column = (0, $fyeGd.columnByStatusIdSelector)(stateAfterRefresh, // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                Number(status.id));
                const transactionIsValid = (0, $9OPlz.isTransactionValid)(stateAfterRefresh, +card.id, action.payload.transactionId);
                if (transactionIsValid) actions.push((0, $2f454.cardDataSet)((0, $252qi.cardRefreshIssueTransformer)(projectId, // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                column, estimateFieldId, card), cardPerson, action.payload.origin), (0, $2f454.cardMediaDataSet)((0, $252qi.cardRefreshMediaTransformer)(card.id, card)));
                if (board && board.issueChildren) actions.push((0, $4gHuj.setIssueChildren)((0, $hjlQ8.getIssueChildren)(board.issueChildren, Number(projectId), (0, $g5X3G.values)((0, $fyeGd.getColumns)(state)).filter((c)=>c.type === (0, $5rFbt.ColumnType).STATUS), estimateFieldId)));
                return actions;
            }, []));
        }).catch((error)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('card-refresh.failure', 'Failed to refresh card', error);
            return (0, $kVLXA.Observable).empty();
        });
    });
// listens to issue-updates (happen when Bento is closed) and triggers image refresh
const $e657e869fe364458$var$issueUpdateListenerEpic = (action$, store)=>action$.ofType((0, $evkwq.ISSUE_UPDATE_REQUEST)).flatMap((action)=>{
        const state = store.getState();
        const filterExistingIssues = (issueId)=>(0, $d2i8f.hasIssueOrIssueChild)(state, issueId);
        const issueIds = action.payload.issueIds.filter(filterExistingIssues);
        if (issueIds && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issueIds)) {
            const skipTransactionUpdate = action.payload.origin === (0, $f32ae13c2b9742f4$export$f2127cf693ff3edc);
            return (0, $kVLXA.Observable).of((0, $2f454.cardRefreshRequestWith)({
                issueIds: issueIds,
                origin: action.payload.origin,
                transactionId: action.payload.transactionId,
                skipTransactionUpdate: skipTransactionUpdate
            }));
        }
        return (0, $kVLXA.Observable).empty();
    });
// listens to card menu show/hide image changes
const $e657e869fe364458$var$cardMenuClicksListenerEpic = (action$)=>action$.ofType((0, $dN3Ms.ISSUE_MEDIA_VISIBILITY_CHANGE_SUCCESS)).filter((action)=>action.payload.isVisible).map((action)=>(0, $2f454.cardRefreshRequestWith)({
            issueIds: [
                action.payload.issueId
            ],
            origin: (0, $f32ae13c2b9742f4$export$d46a05f8561f868a),
            transactionId: action.meta.optimistic.id,
            skipTransactionUpdate: false
        }));
var $e657e869fe364458$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)($e657e869fe364458$export$343b49279bcad83d, $e657e869fe364458$var$issueUpdateListenerEpic, $e657e869fe364458$var$cardMenuClicksListenerEpic);

});
parcelRegister("hjlQ8", function(module, exports) {

$parcel$export(module.exports, "getIssueChildren", () => $c2a0409d5db822bd$export$9ed60bbe06bbd06b);
$parcel$export(module.exports, "transformColumn", () => $c2a0409d5db822bd$export$71ab8832c85346b);
$parcel$export(module.exports, "getCardTransitions", () => $c2a0409d5db822bd$export$c5f25828191314fe);
$parcel$export(module.exports, "transformCriticalData", () => $c2a0409d5db822bd$export$9bbdc053b14eb715);
$parcel$export(module.exports, "transformNonCriticalData", () => $c2a0409d5db822bd$export$ccde3e79901f52d6);

var $6Csk1 = parcelRequire("6Csk1");

var $6eBRn = parcelRequire("6eBRn");

var $9XE6b = parcelRequire("9XE6b");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $5rFbt = parcelRequire("5rFbt");

var $2vSU6 = parcelRequire("2vSU6");

var $gULOk = parcelRequire("gULOk");

var $4R6GH = parcelRequire("4R6GH");

var $g4tDr = parcelRequire("g4tDr");



var $iuuJH = parcelRequire("iuuJH");

var $bO1Vt = parcelRequire("bO1Vt");

var $cjoN4 = parcelRequire("cjoN4");

var $bDyOs = parcelRequire("bDyOs");
const $c2a0409d5db822bd$export$73a53226406d7fe = (boardScopeGQL)=>{
    const issues = (boardScopeGQL.board.columns || []).reduce((acc, col)=>acc.concat(col.cards// TODO: remove when backend fixed
        .filter((card)=>boardScopeGQL.board.issueChildren ? boardScopeGQL.board.issueChildren.every((child)=>child.issue.id !== card.issue.id) : true).map((card)=>{
            const issueCard = {
                id: Number(card.issue.id),
                key: card.issue.key,
                summary: card.issue.summary,
                assigneeAccountId: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(card, [
                    'issue',
                    'assignee',
                    'accountId'
                ], null),
                typeId: Number(card.issue.type.id),
                typeName: card.issue.type.name,
                typeUrl: card.issue.type.iconUrl,
                statusId: Number(card.issue.status.id),
                projectId: Number((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
                    'projectLocation',
                    'id'
                ], '-1')),
                columnId: Number(col.id),
                isFlagged: card.flagged,
                labels: [
                    ...card.issue.labels
                ],
                isDone: card.done,
                parentId: card.parentId ? Number(card.parentId) : null,
                estimate: (0, $bDyOs.calculateEstimateValue)(card.estimate, boardScopeGQL.estimation.current?.customFieldId),
                priority: card.priority ? {
                    ...card.priority
                } : null,
                dueDate: card.dueDate || null,
                numCompleteChildren: card.childIssuesMetadata ? card.childIssuesMetadata.complete : 0,
                numTotalChildren: card.childIssuesMetadata ? card.childIssuesMetadata.total : 0,
                sprintId: card.issue?.activeSprint?.id || ''
            };
            return issueCard;
        })), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    []);
    // We fetch the board/cards array since it as the correct ordering rather
    // than the mismash of orderings created by the joining of column.cards above
    return issues.sort((a, b)=>{
        const firstIndex = (boardScopeGQL.board.cards || []).findIndex((card)=>Number(card.id) === a.id);
        const secondIndex = (boardScopeGQL.board.cards || []).findIndex((card)=>Number(card.id) === b.id);
        return firstIndex - secondIndex;
    });
};
const $c2a0409d5db822bd$export$9ed60bbe06bbd06b = (issueChildren, projectId, columns, estimationStatistic)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(columns)) return [];
    return (issueChildren || []).map((card)=>({
            id: Number(card.issue.id),
            key: card.issue.key,
            summary: card.issue.summary,
            assigneeAccountId: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(card, [
                'issue',
                'assignee',
                'accountId'
            ], null),
            typeId: Number(card.issue.type.id),
            typeName: card.issue.type.name,
            typeUrl: card.issue.type.iconUrl,
            statusId: Number(card.issue.status.id),
            projectId: projectId,
            columnId: Number((columns.find((column)=>column?.statuses.some(({ id: id })=>id === Number(card.issue.status.id))) || {}).id),
            isFlagged: card.flagged,
            labels: [
                ...card.issue.labels
            ],
            isDone: card.done,
            parentId: card.parentId ? Number(card.parentId) : null,
            estimate: (0, $bDyOs.calculateEstimateValue)(card.estimate, estimationStatistic),
            priority: card.priority ? {
                ...card.priority
            } : null,
            dueDate: card.dueDate || null,
            numCompleteChildren: 0,
            numTotalChildren: 0,
            sprintId: card.issue.activeSprint?.id || ''
        }));
};
const $c2a0409d5db822bd$export$b9c97d5330cbe844 = (boardScopeBoardGQL)=>boardScopeBoardGQL.assignees.map((a)=>({
            id: a.accountId,
            displayName: a.displayName,
            avatarUrl: a.avatarUrl
        }));
const $c2a0409d5db822bd$export$637b60a42bb03f06 = (boardScopeGQL)=>({
        id: Number((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'projectLocation',
            'id'
        ], '-1')),
        key: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'projectLocation',
            'key'
        ], 'unknown'),
        name: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'projectLocation',
            'name'
        ], 'unknown'),
        projectTypeKey: (0, $2vSU6.SOFTWARE_PROJECT)
    });
// Temporary workaround, to be removed once swag returns ids instead of keys
const $c2a0409d5db822bd$var$statusCategoryKeyIdMap = {
    undefined: 1,
    new: 2,
    indeterminate: 4,
    done: 3
};
const $c2a0409d5db822bd$var$getStatusCategoryForKey = (key)=>(0, $gULOk.statusCategoryForId)($c2a0409d5db822bd$var$statusCategoryKeyIdMap[key || 'undefined'] || $c2a0409d5db822bd$var$statusCategoryKeyIdMap.undefined);
const $c2a0409d5db822bd$export$71ab8832c85346b = (column)=>({
        type: (0, $5rFbt.ColumnType).STATUS,
        id: Number(column.id),
        name: column.name,
        maxIssueCount: (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(column.maxIssueCount) ? null : column.maxIssueCount,
        statuses: column.columnStatus.map((columnStatus)=>{
            const category = $c2a0409d5db822bd$var$getStatusCategoryForKey(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            columnStatus.status.category);
            return {
                id: Number(columnStatus.status.id),
                name: columnStatus.status.name,
                isInitial: columnStatus.transitions.some((transition)=>transition.isInitial),
                isDone: category === (0, $gULOk.DONE),
                category: category
            };
        })
    });
const $c2a0409d5db822bd$export$15e690098786978a = (boardScopeGQL, projectIssueTypes)=>{
    const swimlaneStrategy = (boardScopeGQL.userSwimlaneStrategy || boardScopeGQL.board.swimlaneStrategy).toLowerCase();
    if (swimlaneStrategy === 'issuechildren' && !projectIssueTypes.some((issueType)=>issueType.hierarchyLevelType === (0, $g4tDr.CHILD_HIERARCHY_TYPE))) return (0, $iuuJH.NO_SWIMLANE).id;
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'SwimlaneModeId'.
    return (0, $cjoN4.swimlaneStrategiesToMode)[swimlaneStrategy] || (0, $iuuJH.NO_SWIMLANE).id;
};
const $c2a0409d5db822bd$export$1b132ed8629e9cb0 = (boardScopeGQL)=>boardScopeGQL.sprints.map((sprint)=>({
            id: Number(sprint.id),
            name: sprint.name,
            goal: sprint.goal,
            canUpdateSprint: true,
            daysRemaining: sprint.daysRemaining,
            startDate: sprint.startDate,
            endDate: sprint.endDate
        }));
const $c2a0409d5db822bd$export$4cf4b24b88599615 = (issueTypes)=>issueTypes.map((issueType)=>({
            id: issueType.id,
            name: issueType.name,
            iconUrl: issueType.iconUrl,
            hierarchyLevelType: issueType.hierarchyLevelType || (0, $g4tDr.BASE_HIERARCHY_TYPE),
            default: false,
            description: '',
            hasRequiredFields: !!issueType.hasRequiredFields
        }));
const $c2a0409d5db822bd$export$7a0cb16aa5a43d4d = (boardScopeGQL)=>// @ts-expect-error - TS2322 - Type '{ id: number; key: string; summary: string; status: { id: string; name: string; category: StatusCategory; } | null; issueType: { id: string; name: string; iconUrl: string; }; color: Color | ... 1 more ... | undefined; }[]' is not assignable to type 'IssueParent[]'.
    (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
        'issueParents'
    ], []).map((issueParent)=>{
        let status = null;
        if (issueParent.issue && issueParent.issue.status) {
            const { id: id, name: name, category: category } = issueParent.issue.status;
            status = {
                id: id,
                name: name,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                category: $c2a0409d5db822bd$var$getStatusCategoryForKey(category)
            };
        }
        return {
            id: Number(issueParent.id),
            key: issueParent.key,
            summary: issueParent.summary,
            status: status,
            issueType: {
                id: issueParent.issueType.id,
                name: issueParent.issueType.name,
                iconUrl: issueParent.issueType.iconUrl
            },
            color: issueParent.color
        };
    });
const $c2a0409d5db822bd$var$isEnabled = (checkKey, features)=>features.filter(({ key: key, status: status })=>key === checkKey && status === 'ENABLED').length > 0;
const $c2a0409d5db822bd$export$61ef2ba0b96af4cf = (boardScopeGQL)=>{
    const columns = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
        'board',
        'columns'
    ], []);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(columns)) return {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($6eBRn)))(columns.map(({ id: id, cards: cards })=>[
            id,
            cards.length
        ]));
};
const $c2a0409d5db822bd$export$5f9288f90460d6e = (boardScopeGQL, jiraGQL, globalConfigGQL)=>({
        isCardMediaEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'board',
            'cardMedia',
            'enabled'
        ], false),
        boardIssueListKey: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'backlog',
            'boardIssueListKey'
        ]),
        requestColumnMigration: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'backlog',
            'requestColumnMigration'
        ]),
        issuesCountByColumn: $c2a0409d5db822bd$export$61ef2ba0b96af4cf(boardScopeGQL),
        isSprintsEnabled: $c2a0409d5db822bd$var$isEnabled('SPRINTS', boardScopeGQL.features),
        isBacklogEnabled: $c2a0409d5db822bd$var$isEnabled('BACKLOG', boardScopeGQL.features),
        isManageRulesEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'projectLocation',
            'isSimplifiedProject'
        ], false) && // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'currentUser',
            'permissions'
        ], []).includes((0, $68cf6bf1ce76db03$export$b893894941c14e43)),
        timeTrackingOptions: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(jiraGQL, [
            'timeTrackingOptions'
        ]),
        ...!(0, $4R6GH.fg)('use_backend_tmp_icc_config_') && {
            isAnyStatusInCreateEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(globalConfigGQL, [
                'applicationProperties',
                'createStatusIsEnabled'
            ])
        }
    });
const $c2a0409d5db822bd$export$c5f25828191314fe = (projectKey, columns = [], parentHierarchyIssueTypeId)=>{
    const columnIssueTypeTransitions = {};
    const issueTypeStatus = {};
    columns.forEach((column)=>{
        columnIssueTypeTransitions[column.id] = {};
        column.columnStatus.forEach((colStatus)=>{
            // We dont show transitions related to epic issue type on board
            const filteredTransitions = parentHierarchyIssueTypeId ? colStatus.transitions.filter((transition)=>transition.cardType.id !== parentHierarchyIssueTypeId) : colStatus.transitions;
            filteredTransitions.forEach((transition)=>{
                columnIssueTypeTransitions[column.id][transition.cardType.id] = columnIssueTypeTransitions[column.id][transition.cardType.id] || [];
                issueTypeStatus[transition.cardType.id] = issueTypeStatus[transition.cardType.id] || {};
                issueTypeStatus[transition.cardType.id][colStatus.status.id] = {
                    ...colStatus.status,
                    id: Number(colStatus.status.id),
                    category: $c2a0409d5db822bd$var$getStatusCategoryForKey(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    colStatus.status.category)
                };
                const cardTransition = {
                    id: Number(transition.id),
                    name: transition.name,
                    sourceStatusId: transition.originStatus != null ? Number(transition.originStatus.id) : null,
                    destinationStatusId: Number(transition.status.id),
                    isGlobal: transition.isGlobal,
                    isInitial: transition.isInitial,
                    hasConditions: transition.hasConditions,
                    hasScreen: transition.hasScreen,
                    projectKey: projectKey
                };
                columnIssueTypeTransitions[column.id][transition.cardType.id].push(cardTransition);
            });
        });
    });
    return {
        columnIssueTypeTransitions: columnIssueTypeTransitions,
        issueTypeStatus: issueTypeStatus
    };
};
const $c2a0409d5db822bd$export$a064de9c304ad444 = (boardGQL)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(boardGQL.columns)) return {};
    return boardGQL.columns // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .reduce((acc, column)=>acc.concat(column.cards), []).reduce((map, card)=>{
        const { coverMedia: coverMedia } = card;
        if (!coverMedia) return Object.assign(map, {
            [String(card.id)]: null
        });
        return Object.assign(map, {
            [String(card.id)]: {
                isHiddenByUser: coverMedia.hiddenByUser,
                endpointUrl: coverMedia.endpointUrl,
                clientId: coverMedia.clientId,
                token: coverMedia.token,
                attachmentId: coverMedia.attachmentId,
                attachmentMediaApiId: coverMedia.attachmentMediaApiId
            }
        });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});
};
const $c2a0409d5db822bd$export$69903c99443079ec = (boardScopeGQL)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const issuesMedia = {};
    (boardScopeGQL.board.apolloSwimlanes || []).forEach((swimlane)=>swimlane.columnsInSwimlane.forEach((column)=>column.cards.forEach((card)=>{
                const { coverMedia: coverMedia } = card;
                issuesMedia[String(card.issue.id)] = coverMedia ? {
                    isHiddenByUser: coverMedia.hiddenByUser,
                    endpointUrl: coverMedia.endpointUrl,
                    clientId: coverMedia.clientId,
                    token: coverMedia.token,
                    attachmentId: coverMedia.attachmentId,
                    attachmentMediaApiId: coverMedia.attachmentMediaApiId
                } : null;
            })));
    return issuesMedia;
};
const $c2a0409d5db822bd$export$8c80ff32686eb3f = (boardGQL)=>boardGQL.issueChildren.reduce((map, card)=>{
        const { coverMedia: coverMedia } = card;
        if (!coverMedia) return Object.assign(map, {
            [String(card.id)]: null
        });
        return Object.assign(map, {
            [String(card.id)]: {
                isHiddenByUser: coverMedia.hiddenByUser,
                endpointUrl: coverMedia.endpointUrl,
                clientId: coverMedia.clientId,
                token: coverMedia.token,
                attachmentId: coverMedia.attachmentId,
                attachmentMediaApiId: coverMedia.attachmentMediaApiId
            }
        });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});
const $c2a0409d5db822bd$export$9bbdc053b14eb715 = (boardScopeGQL)=>{
    const issues = $c2a0409d5db822bd$export$73a53226406d7fe(boardScopeGQL);
    const people = $c2a0409d5db822bd$export$b9c97d5330cbe844(boardScopeGQL.board);
    const projects = [
        $c2a0409d5db822bd$export$637b60a42bb03f06(boardScopeGQL)
    ];
    const config = {
        rankCustomFieldId: Number(boardScopeGQL.board.rankCustomFieldId),
        boardIsRankable: true
    };
    const hasFilteredIssues = boardScopeGQL.board.hasClearedIssues;
    const columns = !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(boardScopeGQL.board.columns) && boardScopeGQL.board.columns.map($c2a0409d5db822bd$export$71ab8832c85346b) || [];
    const projectIssueTypes = $c2a0409d5db822bd$export$4cf4b24b88599615((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
        'projectLocation',
        'issueTypes'
    ], []));
    const swimlaneModeId = $c2a0409d5db822bd$export$15e690098786978a(boardScopeGQL, projectIssueTypes);
    const sprints = $c2a0409d5db822bd$export$1b132ed8629e9cb0(boardScopeGQL);
    const features = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
        'features'
    ], []);
    const isSprintsEnabled = features.filter((f)=>f.key === 'SPRINTS' && f.status === 'ENABLED').length > 0;
    const isBacklogEnabled = features.filter((f)=>f.key === 'BACKLOG' && f.status === 'ENABLED').length > 0;
    const isReportsEnabled = features.filter((f)=>f.key === 'REPORTS' && f.status === 'ENABLED').length > 0;
    const isEstimationFeatureEnabled = features.filter((f)=>f.key === 'ESTIMATION' && f.status === 'ENABLED').length > 0;
    const isReleasesFeatureEnabled = features.filter((f)=>f.key === 'RELEASES' && f.status === 'ENABLED').length > 0;
    const capabilities = {
        BACKLOG: isBacklogEnabled,
        SPRINTS: isSprintsEnabled,
        REPORTS: isReportsEnabled,
        ESTIMATION: isEstimationFeatureEnabled,
        RELEASES: isReleasesFeatureEnabled
    };
    const estimationStatistic = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
        'estimation',
        'current',
        'customFieldId'
    ]);
    // fetching the Epic issue type from all issueType
    const parentHierarchyIssueType = projectIssueTypes.find((issueType)=>issueType.hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE));
    const boardPermissions = (0, $bO1Vt.getBoardPermissions)(boardScopeGQL.currentUser.permissions);
    let inlineCardCreate;
    if ((0, $4R6GH.fg)('use_backend_tmp_icc_config_')) inlineCardCreate = boardScopeGQL.board.inlineCardCreateConfig;
    else inlineCardCreate = $c2a0409d5db822bd$var$canHaveICC(boardPermissions, isSprintsEnabled, sprints) ? {
        mode: (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b)
    } : undefined;
    return {
        issues: issues,
        people: people,
        projects: projects,
        config: config,
        hasFilteredIssues: hasFilteredIssues,
        columns: columns,
        swimlaneModeId: swimlaneModeId,
        sprints: sprints,
        isSprintsEnabled: isSprintsEnabled,
        boardName: boardScopeGQL.board.name,
        capabilities: capabilities,
        inlineCardCreate: inlineCardCreate,
        isInlineColumnEditEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'board',
            'editConfig',
            'inlineColumnEdit',
            'enabled'
        ], false),
        issueParents: $c2a0409d5db822bd$export$7a0cb16aa5a43d4d(boardScopeGQL),
        issueTypes: $c2a0409d5db822bd$export$4cf4b24b88599615((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'board',
            'issueTypes'
        ], [])),
        projectIssueTypes: [
            ...projectIssueTypes
        ],
        boardPermissions: boardPermissions,
        issueChildren: $c2a0409d5db822bd$export$9ed60bbe06bbd06b((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'board',
            'issueChildren'
        ], []), projects[0].id, columns, estimationStatistic),
        allFeatures: [
            ...boardScopeGQL.features.map((feature)=>({
                    ...feature
                }))
        ],
        cardTransitions: $c2a0409d5db822bd$export$c5f25828191314fe(projects[0].key, boardScopeGQL.board.columns.map((column)=>({
                ...column
            })), parentHierarchyIssueType?.id),
        estimationStatistic: estimationStatistic
    };
};
// Defines the inline card create config for the TMP board
// Based on config, inline create experience can vary per columns and issue types (e.g. can trigger GIC with pre-filled fields)
//
// Conditions for inline create to appear:
// 1. User has create issue permission
// 2. If board is scrum board and there is an active sprint
// 3. Issues can be created in any statuses (if not, then inline create restricted to columns with initial statuses only)
// 4. If issue types have required fields, then inline create is partial (it will accept input, than open GIC with pre-filled fields)
//
// This serves as an interim solution until the ICC eligibility conditions are transferred to BE, similar to the process implemented for the CMP board
const $c2a0409d5db822bd$var$getInlineCardCreate = (boardScopeGQL, globalConfigGQL)=>{
    const boardPermissions = (0, $bO1Vt.getBoardPermissions)(boardScopeGQL.currentUser.permissions);
    const isSprintsEnabled = $c2a0409d5db822bd$var$isEnabled('SPRINTS', boardScopeGQL.features);
    const isIccEnabled = $c2a0409d5db822bd$var$canHaveICC(boardPermissions, isSprintsEnabled, $c2a0409d5db822bd$export$1b132ed8629e9cb0(boardScopeGQL));
    const { columns: columns } = boardScopeGQL.board;
    if (!isIccEnabled || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(columns)) return undefined;
    const isAnyStatusInCreateEnabled = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(globalConfigGQL, [
        'applicationProperties',
        'createStatusIsEnabled'
    ]);
    const issueTypes = $c2a0409d5db822bd$export$4cf4b24b88599615((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
        'projectLocation',
        'issueTypes'
    ], [])).filter(// Filter out issue types with hierarchy level PARENT or higher, to avoid unneccessary
    // logic with MIXED icc mode when only parent issue types have required fields.
    (issueType)=>issueType.hierarchyLevelType === (0, $g4tDr.BASE_HIERARCHY_TYPE) || issueType.hierarchyLevelType === (0, $g4tDr.CHILD_HIERARCHY_TYPE));
    const hasRequiredFields = issueTypes.some((issueType)=>!!issueType.hasRequiredFields);
    if (isAnyStatusInCreateEnabled !== false && !hasRequiredFields) return {
        mode: (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b)
    };
    const initalConfig = {
        mode: (0, $c8d1b8aabfd899d6$export$bb410559a65d3418),
        columns: {}
    };
    const issueTypesInIcc = hasRequiredFields ? issueTypes.reduce((issueTypesAcc, issueType)=>Object.assign(issueTypesAcc, {
            [issueType.id]: issueType.hasRequiredFields ? (0, $c8d1b8aabfd899d6$export$c6861d2875ea3898) : (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b)
        }), {}) : undefined;
    const inlineCardCreateConfig = columns.reduce((acc, column)=>{
        if (acc.columns !== undefined && (isAnyStatusInCreateEnabled !== false || column.columnStatus.some((status)=>status.transitions.some((t)=>t.isInitial)))) acc.columns[Number(column.id)] = {
            mode: hasRequiredFields ? (0, $c8d1b8aabfd899d6$export$bb410559a65d3418) : (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b),
            issueTypes: issueTypesInIcc
        };
        return acc;
    }, initalConfig);
    return inlineCardCreateConfig;
};
const $c2a0409d5db822bd$var$canHaveICC = (boardPermissions, isSprintsEnabled, sprints)=>boardPermissions.createIssue === true && (!isSprintsEnabled || sprints.length > 0);
const $c2a0409d5db822bd$export$ccde3e79901f52d6 = (nonCriticalDataResponse)=>({
        ...$c2a0409d5db822bd$export$9bbdc053b14eb715(nonCriticalDataResponse.boardScope),
        boardConfig: $c2a0409d5db822bd$export$5f9288f90460d6e(nonCriticalDataResponse.boardScope, nonCriticalDataResponse.jira, nonCriticalDataResponse.globalConfig),
        issueMedia: (0, (/*@__PURE__*/$parcel$interopDefault($6Csk1)))($c2a0409d5db822bd$export$8c80ff32686eb3f(nonCriticalDataResponse.boardScope.board), $c2a0409d5db822bd$export$a064de9c304ad444(nonCriticalDataResponse.boardScope.board)),
        requestTypes: [],
        statuses: [],
        ...!(0, $4R6GH.fg)('use_backend_tmp_icc_config_') && {
            inlineCardCreate: $c2a0409d5db822bd$var$getInlineCardCreate(nonCriticalDataResponse.boardScope, nonCriticalDataResponse.globalConfig)
        }
    });

});
// Note to maintainer: Add GraphQL enum on the server instead of using a scalar
// then replace all of this any you'll be back to what you intend
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $68cf6bf1ce76db03$export$b893894941c14e43 = 'EDIT_BOARD_CONFIG';
const $68cf6bf1ce76db03$export$4e8756b18ce4cf17 = 'DELETE_ISSUE';
const $68cf6bf1ce76db03$export$a84692caf5a334ea = 'CREATE_ISSUE';
const $68cf6bf1ce76db03$export$47e89ba04d79d88d = 'MANAGE_SPRINT';
const $68cf6bf1ce76db03$export$52f11126cce982f0 = 'EDIT_ISSUE';
const $68cf6bf1ce76db03$export$554b2c24370f61c1 = 'MANAGE_AUTOMATION';
const $68cf6bf1ce76db03$export$f6220122141a5652 = 'LINK_ISSUE';
const $68cf6bf1ce76db03$export$84886e19f4ac5f8e = 'ARCHIVE_ISSUE';

parcelRegister("bO1Vt", function(module, exports) {

$parcel$export(module.exports, "getBoardPermissions", () => $7e42d3062e574a13$export$6e76d430ac3d961);

var $co1wz = parcelRequire("co1wz");

const $7e42d3062e574a13$export$6e76d430ac3d961 = (boardPermissions)=>({
        createIssue: boardPermissions.includes((0, $68cf6bf1ce76db03$export$a84692caf5a334ea)),
        deleteIssue: boardPermissions.includes((0, $68cf6bf1ce76db03$export$4e8756b18ce4cf17)),
        manageSprint: boardPermissions.includes((0, $68cf6bf1ce76db03$export$47e89ba04d79d88d)),
        editBoardConfig: boardPermissions.includes((0, $68cf6bf1ce76db03$export$b893894941c14e43)),
        editIssue: boardPermissions.includes((0, $68cf6bf1ce76db03$export$52f11126cce982f0)),
        manageAutomation: boardPermissions.includes((0, $68cf6bf1ce76db03$export$554b2c24370f61c1)),
        ...(0, $co1wz.ff)('issue-unarchival_wdpb9') ? {
            archiveIssue: boardPermissions.includes((0, $68cf6bf1ce76db03$export$84886e19f4ac5f8e))
        } : {}
    });

});

parcelRegister("cjoN4", function(module, exports) {

$parcel$export(module.exports, "swimlaneStrategiesToMode", () => $bd901d53ae51226f$export$866fc1e015e78d67);
$parcel$export(module.exports, "transformSwimlaneModeToApi", () => $bd901d53ae51226f$export$dd327d08709313eb);

var $iuuJH = parcelRequire("iuuJH");
const $bd901d53ae51226f$export$6b0228c67b1e82cf = {
    NO_SWIMLANE: 'none',
    SWIMLANE_BY_JQL: 'jql',
    SWIMLANE_BY_ASSIGNEE: 'assignee',
    SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST: 'assigneeunassignedfirst',
    SWIMLANE_BY_PARENT_ISSUE: 'issueparent',
    SWIMLANE_BY_SUBTASK: 'issuechildren',
    SWIMLANE_BY_PROJECT: 'project',
    SWIMLANE_BY_TEAM: 'team',
    SWIMLANE_BY_REQUEST_TYPE: 'requesttype'
};
const $bd901d53ae51226f$export$866fc1e015e78d67 = {
    none: (0, $iuuJH.NO_SWIMLANE).id,
    jql: (0, $iuuJH.SWIMLANE_BY_JQL).id,
    assignee: (0, $iuuJH.SWIMLANE_BY_ASSIGNEE).id,
    issueparent: (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id,
    assigneeunassignedfirst: (0, $iuuJH.SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST).id,
    issuechildren: (0, $iuuJH.SWIMLANE_BY_SUBTASK).id,
    project: (0, $iuuJH.SWIMLANE_BY_PROJECT).id,
    team: (0, $iuuJH.SWIMLANE_BY_TEAM).id,
    requesttype: (0, $iuuJH.SWIMLANE_BY_REQUEST_TYPE).id
};
const $bd901d53ae51226f$export$dd327d08709313eb = (swimlaneModeId)=>$bd901d53ae51226f$export$6b0228c67b1e82cf[swimlaneModeId] || 'none';

});

parcelRegister("bDyOs", function(module, exports) {

$parcel$export(module.exports, "calculateEstimateValue", () => $9bde04010432e1f5$export$33f32b887d0f86d3);



var $cn1Wo = parcelRequire("cn1Wo");
const $9bde04010432e1f5$export$33f32b887d0f86d3 = (estimate, estimationStatisticFieldId)=>{
    if (!estimationStatisticFieldId) return null;
    if (estimationStatisticFieldId === (0, $dcbb2bce513725b3$export$d02889a654103c98)) return {
        type: (0, $b383ed62f6689e0b$export$73bc902d1e240cad),
        displayName: (0, $cn1Wo.default).originalEstimateDisplayLabel,
        fieldId: estimationStatisticFieldId,
        value: estimate?.originalEstimate?.value,
        valueAsText: estimate?.originalEstimate?.valueAsText
    };
    return {
        type: (0, $b383ed62f6689e0b$export$a092d6877c35430e),
        fieldId: estimationStatisticFieldId,
        displayName: (0, $cn1Wo.default).storyPointsDisplayLabel,
        value: estimate?.storyPoints ?? undefined
    };
};

});
parcelRegister("cn1Wo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e57d33efcda9b6c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9e57d33efcda9b6c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    storyPointsDisplayLabel: {
        "id": "software.main.services.utils.estimation.story-points-display-label",
        "defaultMessage": "{value, plural, one {# story point} other {# story points}}"
    },
    originalEstimateDisplayLabel: {
        "id": "software.main.services.utils.estimation.original-estimate-display-label",
        "defaultMessage": "{value} original estimate"
    },
    remainingEstimateDisplayLabel: {
        "id": "software.main.services.utils.estimation.remaining-estimate-display-label",
        "defaultMessage": "{value} remaining"
    }
});

});



parcelRegister("6fpfm", function(module, exports) {

$parcel$export(module.exports, "cardRefreshBoardScopeService", () => $aeec9a375ba45eb3$export$58e261badcfdf3ce);

var $37XVp = parcelRequire("37XVp");
const $aeec9a375ba45eb3$export$58e261badcfdf3ce = (contextPath, boardId, cardIds, shouldLoadChildren = true)=>(0, $37XVp.fetchCardRefreshBoardScopeData)(contextPath, boardId, cardIds, shouldLoadChildren);

});
parcelRegister("37XVp", function(module, exports) {

$parcel$export(module.exports, "fetchCardRefreshBoardScopeData", () => $6042aeb19b49bdfa$export$669392d2ca93f95a);

var $487fd = parcelRequire("487fd");

var $2bQEl = parcelRequire("2bQEl");
const $6042aeb19b49bdfa$var$softwareBoardCardOperationName = 'SoftwareBoardCard';
const $6042aeb19b49bdfa$export$5feba1c4cb038873 = (boardId, cardIds, shouldLoadChildren)=>{
    const issueChildren = shouldLoadChildren ? `board {
            issueChildren {
                id
                flagged
                done
                parentId
                estimate {
                    storyPoints
                    originalEstimate {
                        value
                        valueAsText
                    }
                }
                issue {
                    id
                    key
                    summary
                    labels
                    assignee {
                        accountId
                        displayName
                        avatarUrl
                    }
                    type { id, name, iconUrl }
                    status { id }
                    activeSprint { id }
                }
                coverMedia {
                    attachmentId
                    endpointUrl
                    clientId
                    token
                    attachmentMediaApiId
                    hiddenByUser
                }
                priority {
                    name
                    iconUrl
                }
                dueDate
            }
        }` : '';
    return `query ${$6042aeb19b49bdfa$var$softwareBoardCardOperationName} {
        boardScope(boardId:${boardId}){
            projectLocation {
                id
            }
            cards(cardIds: [${String(cardIds)}]){
                id
                flagged
                done
                parentId
                estimate {
                    storyPoints
                    originalEstimate {
                        value
                        valueAsText
                    }
                }
                coverMedia{
                    attachmentId
                    endpointUrl
                    clientId
                    token
                    attachmentMediaApiId
                    hiddenByUser
                }
                issue{
                    id
                    key
                    summary
                    labels
                    status{
                        id
                        name
                    }
                    assignee{
                        accountId
                        displayName
                        avatarUrl
                    }
                    type{
                        id
                        name
                        iconUrl
                    }
                    activeSprint { id }
                }
                childIssuesMetadata { complete, total }
                priority {
                    name
                    iconUrl
                }
                dueDate
            }
            ${issueChildren}
        }
    }`;
};
const $6042aeb19b49bdfa$var$fetchBoardScopeCardData = (boardId, cardIds, shouldLoadChildren)=>({
        method: 'POST',
        body: JSON.stringify({
            operationName: $6042aeb19b49bdfa$var$softwareBoardCardOperationName,
            query: $6042aeb19b49bdfa$export$5feba1c4cb038873(boardId, cardIds, shouldLoadChildren)
        })
    });
const $6042aeb19b49bdfa$export$669392d2ca93f95a = (contextPath, boardId, cardIds, shouldLoadChildren = true)=>(0, $487fd.default)((0, $2bQEl.getJSWGraphQlEndpointUrl)(contextPath), $6042aeb19b49bdfa$var$fetchBoardScopeCardData(boardId, cardIds, shouldLoadChildren));

});


parcelRegister("252qi", function(module, exports) {

$parcel$export(module.exports, "cardRefreshMediaTransformer", () => $b487bc2022acb2c1$export$d5c84a2e797269cc);
$parcel$export(module.exports, "cardRefreshIssueTransformer", () => $b487bc2022acb2c1$export$230f7a3cfbfec489);

var $7uUwQ = parcelRequire("7uUwQ");

var $bDyOs = parcelRequire("bDyOs");
const $b487bc2022acb2c1$export$d5c84a2e797269cc = (cardId, card)=>{
    const collection = {};
    if (card === null || !card.coverMedia || card.id !== cardId) {
        collection[cardId] = {
            isHiddenByUser: true
        };
        return collection;
    }
    const { endpointUrl: endpointUrl, clientId: clientId, token: token, attachmentId: attachmentId, attachmentMediaApiId: attachmentMediaApiId } = card.coverMedia;
    collection[String(cardId)] = {
        isHiddenByUser: false,
        endpointUrl: endpointUrl,
        clientId: clientId,
        token: token,
        attachmentId: attachmentId,
        attachmentMediaApiId: String(attachmentMediaApiId)
    };
    return collection;
};
const $b487bc2022acb2c1$export$230f7a3cfbfec489 = (projectId, column, estimateFieldId, card)=>{
    const { id: id, issue: { key: key, summary: summary, labels: labels, status: status, type: { id: typeId, name: typeName, iconUrl: typeUrl }, assignee: assignee }, done: isDone, flagged: isFlagged, parentId: parentId, estimate: estimate, priority: priority, dueDate: dueDate, childIssuesMetadata: childIssuesMetadata } = card;
    const sprintId = card.issue.activeSprint?.id ?? '';
    const assigneeAccountId = assignee && {
        assigneeAccountId: assignee.accountId
    };
    const columnId = column && {
        columnId: column.id
    };
    return (0, $7uUwQ.freeze)({
        id: Number(id),
        key: key,
        summary: summary,
        statusId: Number(status.id),
        ...columnId,
        projectId: Number(projectId),
        typeId: Number(typeId),
        typeName: typeName,
        typeUrl: typeUrl,
        ...assigneeAccountId,
        isFlagged: // devStatus TODO https://jdog.jira-dev.com/browse/ABS-257
        isFlagged,
        labels: [
            ...labels
        ],
        isDone: isDone,
        parentId: Number(parentId) || null,
        estimate: (0, $bDyOs.calculateEstimateValue)(estimate, estimateFieldId),
        priority: priority ? {
            ...priority
        } : null,
        dueDate: dueDate || null,
        numCompleteChildren: childIssuesMetadata ? childIssuesMetadata.complete : 0,
        numTotalChildren: childIssuesMetadata ? childIssuesMetadata.total : 0,
        sprintId: sprintId
    });
};

});

parcelRegister("lF9PL", function(module, exports) {

$parcel$export(module.exports, "transformPerson", () => $fb948c35f99f88f8$export$6a0763407d6de4b9);
$parcel$export(module.exports, "cardRefreshPersonTransformer", () => $fb948c35f99f88f8$export$4e2039085623abd6);
const $fb948c35f99f88f8$export$6a0763407d6de4b9 = (user)=>{
    const { displayName: displayName, accountId: accountId } = user;
    return {
        id: accountId,
        displayName: displayName,
        avatarUrl: user.avatarUrls && user.avatarUrls['48x48']
    };
};
const $fb948c35f99f88f8$export$4e2039085623abd6 = (cardAssignee)=>{
    const { displayName: displayName, avatarUrl: avatarUrl, accountId: accountId } = cardAssignee;
    return {
        id: accountId,
        displayName: displayName,
        avatarUrl: avatarUrl
    };
};

});

parcelRegister("dN3Ms", function(module, exports) {

$parcel$export(module.exports, "ISSUE_MEDIA_VISIBILITY_CHANGE_REQUEST", () => $3b79a5866454876b$export$74f28ea71139942);
$parcel$export(module.exports, "ISSUE_MEDIA_VISIBILITY_CHANGE_SUCCESS", () => $3b79a5866454876b$export$2b8c4e2590a67bf6);
$parcel$export(module.exports, "issueMediaVisibilityChangeSuccess", () => $3b79a5866454876b$export$2971d39a697e3ae7);
$parcel$export(module.exports, "issueMediaVisibilityChangeFailure", () => $3b79a5866454876b$export$e96d312c45990dd1);

var $9rND4 = parcelRequire("9rND4");
const $3b79a5866454876b$export$74f28ea71139942 = 'state.actions.issue.media.ISSUE_MEDIA_VISIBILITY_CHANGE_REQUEST';
const $3b79a5866454876b$export$b1b981f00a4325d = (issueId, isVisible)=>({
        type: $3b79a5866454876b$export$74f28ea71139942,
        payload: {
            issueId: issueId,
            isVisible: isVisible
        },
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    });
const $3b79a5866454876b$export$2b8c4e2590a67bf6 = 'state.actions.issue.media.ISSUE_MEDIA_VISIBILITY_CHANGE_SUCCESS';
const $3b79a5866454876b$export$2971d39a697e3ae7 = (optimisticId, issueId, isVisible)=>({
        type: $3b79a5866454876b$export$2b8c4e2590a67bf6,
        payload: {
            issueId: issueId,
            isVisible: isVisible
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $3b79a5866454876b$export$ebff87f39ef732cb = 'state.actions.issue.media.ISSUE_MEDIA_VISIBILITY_CHANGE_FAILURE';
const $3b79a5866454876b$export$e96d312c45990dd1 = (optimisticId)=>({
        type: $3b79a5866454876b$export$ebff87f39ef732cb,
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});

parcelRegister("evkwq", function(module, exports) {

$parcel$export(module.exports, "ISSUE_UPDATE_REQUEST", () => $9d6313849b2d7855$export$7285b51affc95621);
$parcel$export(module.exports, "issueUpdateRequestWithTransactionId", () => $9d6313849b2d7855$export$1203f74fc478d4cf);
$parcel$export(module.exports, "issueUpdateRequest", () => $9d6313849b2d7855$export$f30638dd71fdf98d);
$parcel$export(module.exports, "ISSUE_UPDATE_SUCCESS", () => $9d6313849b2d7855$export$e26c3ff402573522);
$parcel$export(module.exports, "issueUpdateFailure", () => $9d6313849b2d7855$export$2128979ebf312943);
$parcel$export(module.exports, "ISSUE_BENTO_UPDATE", () => $9d6313849b2d7855$export$7ab59871c3a39808);
$parcel$export(module.exports, "issueBentoUpdate", () => $9d6313849b2d7855$export$3066c3fab411604b);
$parcel$export(module.exports, "SET_ISSUE_PARENT", () => $9d6313849b2d7855$export$3acc54c28c7b46c1);
$parcel$export(module.exports, "setIssueParent", () => $9d6313849b2d7855$export$6bdf52f105cc4319);
$parcel$export(module.exports, "issueIncrementPlanningUpdateSuccess", () => $9d6313849b2d7855$export$2c7c57af8e3deb8);
$parcel$export(module.exports, "issueIncrementPlanningUpdateFailed", () => $9d6313849b2d7855$export$80e317938cb55070);
$parcel$export(module.exports, "ISSUE_INCREMENT_PLANNING_UPDATE", () => $9d6313849b2d7855$export$7f1f6552f76e0f62);
$parcel$export(module.exports, "issueIncrementPlanningUpdate", () => $9d6313849b2d7855$export$59aff2f80ca5eb52);

var $7Jxgt = parcelRequire("7Jxgt");


var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $9d6313849b2d7855$export$7285b51affc95621 = 'state.actions.issue.update.ISSUE_UPDATE_REQUEST';
const $9d6313849b2d7855$export$1203f74fc478d4cf = (issueIds, origin, transactionId)=>({
        type: $9d6313849b2d7855$export$7285b51affc95621,
        payload: {
            issueIds: issueIds,
            origin: origin,
            transactionId: transactionId
        }
    });
const $9d6313849b2d7855$export$f30638dd71fdf98d = (issueIds, origin = (0, $f32ae13c2b9742f4$export$d46a05f8561f868a))=>$9d6313849b2d7855$export$1203f74fc478d4cf(issueIds, origin, (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))());
const $9d6313849b2d7855$export$e26c3ff402573522 = 'state.actions.issue.update.ISSUE_UPDATE_SUCCESS';
const $9d6313849b2d7855$export$5b5bc0de8568f975 = (issue, origin)=>({
        type: $9d6313849b2d7855$export$e26c3ff402573522,
        payload: {
            issue: issue,
            origin: origin
        }
    });
const $9d6313849b2d7855$export$8caae7a939724b26 = 'state.actions.issue.update.ISSUE_UPDATE_FAILURE';
const $9d6313849b2d7855$export$2128979ebf312943 = (errorString)=>({
        type: $9d6313849b2d7855$export$8caae7a939724b26,
        payload: {
            errorString: errorString
        }
    });
const $9d6313849b2d7855$export$7ab59871c3a39808 = 'state.actions.issue.update.ISSUE_BENTO_UPDATE';
const $9d6313849b2d7855$export$3066c3fab411604b = (payload, transactionId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))())=>({
        type: $9d6313849b2d7855$export$7ab59871c3a39808,
        payload: payload,
        meta: {
            transactionId: transactionId
        }
    });
const $9d6313849b2d7855$export$3acc54c28c7b46c1 = 'state.actions.issue.update.SET_ISSUE_PARENT';
const $9d6313849b2d7855$export$6bdf52f105cc4319 = (issueId, issueParentId)=>({
        type: $9d6313849b2d7855$export$3acc54c28c7b46c1,
        payload: {
            issueId: issueId,
            issueParentId: issueParentId
        }
    });
const $9d6313849b2d7855$export$3457bc01094e4186 = 'state.actions.issue.update.ISSUE_INCREMENT_PLANNING_UPDATE_SUCCESS';
const $9d6313849b2d7855$export$2c7c57af8e3deb8 = ()=>({
        type: $9d6313849b2d7855$export$3457bc01094e4186
    });
const $9d6313849b2d7855$export$6240223118018833 = 'state.actions.issue.update.ISSUE_INCREMENT_PLANNING_UPDATE_FAILURE';
const $9d6313849b2d7855$export$80e317938cb55070 = ()=>({
        type: $9d6313849b2d7855$export$6240223118018833,
        meta: (0, $sdxnu.errorFlagMeta)({
            titleMessage: (0, $7AVqz.default).genericTitle,
            descriptionMessage: (0, $7AVqz.default).genericDescription
        })
    });
const $9d6313849b2d7855$export$7f1f6552f76e0f62 = 'state.actions.issue.update.ISSUE_INCREMENT_PLANNING_UPDATE';
const $9d6313849b2d7855$export$59aff2f80ca5eb52 = (payload)=>({
        type: $9d6313849b2d7855$export$7f1f6552f76e0f62,
        payload: payload
    });

});


parcelRegister("enaRv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5d1140138f38460$export$2e2bcd8739ae039);
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("3awJm");
parcelRequire("fPS7b");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $2f454 = parcelRequire("2f454");

var $d1i1b = parcelRequire("d1i1b");

var $dW1HX = parcelRequire("dW1HX");

var $9OPlz = parcelRequire("9OPlz");

var $fqLDH = parcelRequire("fqLDH");

var $gR0bs = parcelRequire("gR0bs");

var $d2i8f = parcelRequire("d2i8f");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e5d1140138f38460$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $2f454.CARD_NEXT), (0, $2f454.CARD_PREV)).throttleTime(200).mergeMap(({ type: type, payload: payload })=>{
        const state = store.getState();
        const activeCardId = (0, $9OPlz.getCardActive)(state);
        // Applying a filter or collapsing a swimlane does not clear the active card,
        // So we need to check manually if it is actually visible.
        const isActiveCardVisible = (0, $gR0bs.isActiveCardVisible)(state);
        const isCardNext = type === (0, $2f454.CARD_NEXT);
        const getFirstSelectableIssueFn = isCardNext ? (0, $gR0bs.getFirstSelectableIssueAscending) : (0, $gR0bs.getFirstSelectableIssueDescending);
        const getNextOrPrevIssueFn = isCardNext ? (0, $gR0bs.getNextSelectableIssue) : (0, $gR0bs.getPrevSelectableIssue);
        const newActiveIssueId = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeCardId) || !isActiveCardVisible ? getFirstSelectableIssueFn(state) : getNextOrPrevIssueFn(state)(activeCardId);
        const attributes = isCardNext ? {
            id: 'nextIssueKeyboardShortcut',
            key: 'j'
        } : {
            id: 'previousIssueKeyboardShortcut',
            key: 'k'
        };
        payload.fireShortcutAnalyticsFn(attributes);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(newActiveIssueId)) return (0, $kVLXA.Observable).empty();
        const actions = [
            (0, $2f454.cardSingleSelect)(newActiveIssueId),
            (0, $2f454.cardFocus)(newActiveIssueId),
            (0, $d1i1b.cardAutoScroll)(newActiveIssueId)
        ];
        if ((0, $fqLDH.isIssueModalShowingSelector)(state)) {
            const issueKey = (0, $d2i8f.getIssueById)(state, newActiveIssueId).key;
            actions.push((0, $dW1HX.openIssueModalDebounced)(issueKey));
        }
        return (0, $kVLXA.Observable).from(actions);
    });

});

parcelRegister("hh3dt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d881c0d70ff61978$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $2f454 = parcelRequire("2f454");

var $67Z81 = parcelRequire("67Z81");
function $d881c0d70ff61978$export$2e2bcd8739ae039(action$, store) {
    return action$.ofType((0, $2f454.CARD_DRAG_OVER_TRANSITION_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        const { transitionId: transitionId, toColumnId: toColumnId, hoverIntent: hoverIntent } = action.payload;
        if (isCMPBoard) // We always avoid passing the hover intent in a CMP board, so the ranking mode is disabled when hovering on the transition zone
        return (0, $kVLXA.Observable).of((0, $2f454.cardDragOverTransition)(transitionId, toColumnId, false));
        return (0, $kVLXA.Observable).of((0, $2f454.cardDragOverTransition)(transitionId, toColumnId, hoverIntent));
    });
}

});

parcelRegister("erSBH", function(module, exports) {

$parcel$export(module.exports, "checkGlobalIssueCreateEpic", () => $23cee30e0dc21388$export$c92e72129db344be);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");


var $iuuJH = parcelRequire("iuuJH");

var $1YOzt = parcelRequire("1YOzt");

var $bkCF5 = parcelRequire("bkCF5");

var $ls4NM = parcelRequire("ls4NM");

var $k8auG = parcelRequire("k8auG");

var $fyeGd = parcelRequire("fyeGd");

var $ebHh7 = parcelRequire("ebHh7");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");
const $23cee30e0dc21388$export$c92e72129db344be = (action$, store)=>// @ts-expect-error - TS2684 - The 'this' context of type 'ActionsObservable<Action>' is not assignable to method's 'this' of type 'Observable<CheckGlobalIssueCreateAction>'.
    action$.ofType((0, $1YOzt.CHECK_GLOBAL_ISSUE_CREATE)).mergeMap((action)=>{
        const { payload: { issues: globalIssues } } = action;
        if (globalIssues.length === 0) return (0, $kVLXA.Observable).empty();
        const state = store.getState();
        const cardKeys = globalIssues.map((issue)=>String(issue.issueKey));
        const columnStatusIds = (0, $fyeGd.getStatusIdsOfColumns)(state).map((statusId)=>String(statusId));
        const unmappedIssuesExist = globalIssues.filter((issue)=>issue.createdIssueDetails.fields.issuetype.hierarchyLevel < 1).some((issue)=>!columnStatusIds.includes(issue.createdIssueDetails.fields.status.id));
        if (unmappedIssuesExist) return (0, $kVLXA.Observable).of((0, $ls4NM.cardCreateUnmapped)(cardKeys));
        const hasNoActiveSprint = (0, $ebHh7.hasNoActiveSprintStateSelector)(state);
        const sprints = hasNoActiveSprint ? null : (0, $ebHh7.activeSprintsSelector)(state);
        // If issues are not present on the board (not being in a current sprint) or are hidden due to any filter, show a flag as well
        const invisibleIssueKeys = (0, $5mTgl.getInvisibleIssueKeys)(state)(cardKeys);
        if (invisibleIssueKeys.length > 0) return hasNoActiveSprint ? (0, $kVLXA.Observable).of((0, $bkCF5.issueCreateFilteredV2)(invisibleIssueKeys)) : (0, $kVLXA.Observable).of((0, $bkCF5.issueCreateFilteredV2)(invisibleIssueKeys, sprints));
        if ((0, $45cXl.getSwimlaneMode)(state) === (0, $iuuJH.SWIMLANE_BY_JQL).id) {
            const jqlSwimlanes = (0, $k8auG.getJQLSwimlanesData)(state);
            if (!jqlSwimlanes) return (0, $kVLXA.Observable).of((0, $ls4NM.cardCreateGlobal)(cardKeys));
            const jqlSwimlanesMap = {};
            let defaultSwimlaneId = '';
            jqlSwimlanes.forEach((swimlane)=>{
                if (swimlane.isDefaultSwimlane) defaultSwimlaneId = swimlane.id;
                Object.assign(jqlSwimlanesMap, {
                    [swimlane.id]: new Set(swimlane.issueIds)
                });
            });
            // If we have not returned before this, then we know that the issue is present on the board.
            // We just need to check if any of the created issues is missing from the swimlane that it was created in,
            // and then we can infer that it has been moved to a different swimlane.
            const issuesRemovedFromSwimlane = globalIssues.find((issue)=>{
                if (!issue.jqlSwimlaneId) return false;
                const originalSwimlaneId = issue.jqlSwimlaneId === (0, $dcbb2bce513725b3$export$26ad7c86aba35f49) ? defaultSwimlaneId : issue.jqlSwimlaneId;
                return !jqlSwimlanesMap[originalSwimlaneId]?.has(issue.issueId);
            });
            if (issuesRemovedFromSwimlane) return (0, $kVLXA.Observable).of((0, $bkCF5.issueCreateMovedBetweenJqlSwimlanes)(cardKeys));
        }
        return (0, $kVLXA.Observable).of((0, $ls4NM.cardCreateGlobal)(cardKeys));
    });

});
parcelRegister("1YOzt", function(module, exports) {

$parcel$export(module.exports, "CHECK_GLOBAL_ISSUE_CREATE", () => $94c6996ad1d1ae55$export$d3342655e6919343);
$parcel$export(module.exports, "checkGlobalIssueCreate", () => $94c6996ad1d1ae55$export$d2425890b90f3347);
const $94c6996ad1d1ae55$export$d3342655e6919343 = 'state.actions.check-global-issue-create.CHECK_GLOBAL_ISSUE_CREATE';
const $94c6996ad1d1ae55$export$d2425890b90f3347 = (issues)=>({
        type: $94c6996ad1d1ae55$export$d3342655e6919343,
        payload: {
            issues: issues
        }
    });

});


parcelRegister("dNJJS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7659694ae75062d$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("c66Ur");
parcelRequire("fPS7b");


var $cSLHE = parcelRequire("cSLHE");

var $glGhK = parcelRequire("glGhK");

var $cW3pH = parcelRequire("cW3pH");

var $67Z81 = parcelRequire("67Z81");
const $d7659694ae75062d$var$columnCreate = (state, action)=>{
    const contextPath = (0, $67Z81.contextPathSelector)(state);
    const boardId = (0, $67Z81.rapidViewIdSelector)(state);
    const projectKey = (0, $67Z81.projectKeySelector)(state);
    const { name: name } = action.payload;
    return (0, $cSLHE.default)(contextPath, boardId, name, projectKey);
};
const $d7659694ae75062d$var$handleFailure = (action, error)=>{
    const { meta: { analyticsEvent: analyticsEvent } } = action;
    return (0, $kVLXA.Observable).of((0, $glGhK.columnCreateFailure)(action.meta.optimistic.id, action.payload.temporaryColumnId, error, analyticsEvent));
};
const $d7659694ae75062d$var$handleSuccess = (action, result, state)=>{
    const { payload: { temporaryColumnId: temporaryColumnId }, meta: { optimistic: optimistic, analyticsEvent: analyticsEvent } } = action;
    const { column: column, columns: columns, cardTransitions: cardTransitions } = result;
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    const actions = [
        (0, $glGhK.columnCreateSuccess)(optimistic.id, temporaryColumnId, column, columns, cardTransitions, analyticsEvent)
    ];
    if (isCMPBoard) actions.push((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$bddadd6eeae21573)));
    return (0, $kVLXA.Observable).from(actions);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d7659694ae75062d$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $glGhK.COLUMN_CREATE_REQUEST)).mergeMap((action)=>$d7659694ae75062d$var$columnCreate(store.getState(), action).flatMap((result)=>$d7659694ae75062d$var$handleSuccess(action, result, store.getState())).catch((error)=>$d7659694ae75062d$var$handleFailure(action, error)));

});
parcelRegister("cSLHE", function(module, exports) {

$parcel$export(module.exports, "default", () => $096f6b6f8ee5bb24$export$2e2bcd8739ae039);
parcelRequire("3q49N");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $9XE6b = parcelRequire("9XE6b");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $fo45h = parcelRequire("fo45h");

var $hjlQ8 = parcelRequire("hjlQ8");
const $096f6b6f8ee5bb24$export$51186ad6e864892a = (projectKey, data)=>({
        column: (0, $hjlQ8.transformColumn)(data.newColumn),
        columns: data.columns.map((0, $hjlQ8.transformColumn)),
        cardTransitions: (0, $hjlQ8.getCardTransitions)(projectKey, data.columns.concat(data.newColumn))
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$096f6b6f8ee5bb24$export$2e2bcd8739ae039 = (contextPath, boardId, columnName, projectKey)=>(0, $fo45h.default)(contextPath, boardId, columnName).flatMap((columnCreateData)=>(0, $kVLXA.Observable).of($096f6b6f8ee5bb24$export$51186ad6e864892a(projectKey, columnCreateData))).catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('board.column.create.graphql.failure', 'Failed to create column via GraphQl', {
            message: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                'message'
            ], '') || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                0,
                'message'
            ], '')
        });
        return (0, $kVLXA.Observable).throw(error);
    });

});
parcelRegister("fo45h", function(module, exports) {

$parcel$export(module.exports, "default", () => $c70a0a539dbdd9ef$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $ivqh1 = parcelRequire("ivqh1");

var $6iJbJ = parcelRequire("6iJbJ");

var $Zbn1V = parcelRequire("Zbn1V");

var $CFxE9 = parcelRequire("CFxE9");
const $c70a0a539dbdd9ef$export$d6dad7cb3d8dcedd = 'SoftwareColumnCreate';
const $c70a0a539dbdd9ef$export$66843dda88b883b6 = (0, $ivqh1.gqlTagSwag)`mutation SoftwareColumnCreate($boardId: ID!, $columnName: String!){
        createColumn(input: {boardId: $boardId, columnName: $columnName}) {
            newColumn {
                id
                name
                maxIssueCount
                status {
                    id
                    name
                }
                columnStatus {
                    ...ColumnStatusFragment
                }
                isInitial
                isDone
                transitionId
            }
            columns {
                id
                name
                maxIssueCount
                status {
                    id
                    name
                }
                columnStatus {
                    ...ColumnStatusFragment
                }
                isInitial
                isDone
                transitionId
            }
        }
    }
    
    ${(0, $Zbn1V.ColumnStatusFragment)}
`;
const $c70a0a539dbdd9ef$export$ba14d9a5a581e827 = (data)=>(0, $kVLXA.Observable).of(data.createColumn);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c70a0a539dbdd9ef$export$2e2bcd8739ae039 = (contextPath, boardId, columnName)=>(0, $6iJbJ.mutation$)(contextPath, $c70a0a539dbdd9ef$export$d6dad7cb3d8dcedd, $c70a0a539dbdd9ef$export$66843dda88b883b6, {
        boardId: boardId,
        columnName: columnName
    }, (0, $CFxE9.columnCreateAnalyticsOptions)).flatMap($c70a0a539dbdd9ef$export$ba14d9a5a581e827);

});
parcelRegister("Zbn1V", function(module, exports) {

$parcel$export(module.exports, "ColumnStatusFragment", () => $9ac8bab06ebfc0f2$export$91351318a76e5eab);

var $ivqh1 = parcelRequire("ivqh1");
const $9ac8bab06ebfc0f2$export$91351318a76e5eab = (0, $ivqh1.gqlTagSwag)`
    fragment ColumnStatusFragment on ColumnStatus {
        status {
            id
            name
            category
        }
        transitions {
            id
            name
            status { 
                id
            }
            originStatus { id }
            cardType { id }
            isGlobal
            isInitial
            hasConditions
        }
    }
`;

});



parcelRegister("glGhK", function(module, exports) {

$parcel$export(module.exports, "COLUMN_CREATE_REQUEST", () => $f9561824c85fd000$export$cb06a5725603209e);
$parcel$export(module.exports, "columnCreateRequest", () => $f9561824c85fd000$export$e17a54aca50f971e);
$parcel$export(module.exports, "COLUMN_CREATE_SUCCESS", () => $f9561824c85fd000$export$a26373aaaa8736b1);
$parcel$export(module.exports, "columnCreateSuccess", () => $f9561824c85fd000$export$4d3e535c643e516d);
$parcel$export(module.exports, "COLUMN_CREATE_FAILURE", () => $f9561824c85fd000$export$d11eec7b8f8e0cd3);
$parcel$export(module.exports, "columnCreateFailure", () => $f9561824c85fd000$export$7a6298113a6c73fb);

var $9rND4 = parcelRequire("9rND4");
const $f9561824c85fd000$export$cb06a5725603209e = 'state.actions.column.create.COLUMN_CREATE_REQUEST';
const $f9561824c85fd000$export$e17a54aca50f971e = (temporaryColumnId, name, analyticsEvent, isCMPBoard)=>({
        type: $f9561824c85fd000$export$cb06a5725603209e,
        payload: {
            temporaryColumnId: temporaryColumnId,
            name: name
        },
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent,
            isCMPBoard: isCMPBoard
        }
    });
const $f9561824c85fd000$export$a26373aaaa8736b1 = 'state.actions.column.create.COLUMN_CREATE_SUCCESS';
const $f9561824c85fd000$export$4d3e535c643e516d = (optimisticId, temporaryColumnId, column, columns, cardTransitions, analyticsEvent)=>({
        type: $f9561824c85fd000$export$a26373aaaa8736b1,
        payload: {
            temporaryColumnId: temporaryColumnId,
            column: column,
            columns: columns,
            cardTransitions: cardTransitions
        },
        meta: {
            ...(0, $9rND4.commitOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });
const $f9561824c85fd000$export$d11eec7b8f8e0cd3 = 'state.actions.column.create.COLUMN_CREATE_FAILURE';
const $f9561824c85fd000$export$7a6298113a6c73fb = (optimisticId, temporaryColumnId, error, analyticsEvent)=>({
        type: $f9561824c85fd000$export$d11eec7b8f8e0cd3,
        payload: {
            temporaryColumnId: temporaryColumnId
        },
        error: error,
        meta: {
            ...(0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });

});


parcelRegister("hM7SN", function(module, exports) {

$parcel$export(module.exports, "default", () => $31e504f54b5cdffc$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("fg0YM");

var $8zOmE = parcelRequire("8zOmE");


var $fYPOW = parcelRequire("fYPOW");

var $63F6h = parcelRequire("63F6h");

var $cW3pH = parcelRequire("cW3pH");

var $67Z81 = parcelRequire("67Z81");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$31e504f54b5cdffc$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $63F6h.COLUMN_DELETE_REQUEST)).concatMap((action)=>{
        const state = store.getState();
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const projectKey = (0, $67Z81.projectKeySelector)(state);
        const { payload: { columnId: columnId, closestColumn: closestColumn }, meta: { optimistic: optimistic, analyticsEvent: analyticsEvent } } = action;
        return (0, $fYPOW.default)(contextPath, boardId, columnId, closestColumn && closestColumn.id, projectKey).flatMap((columnsDeleteData)=>{
            const { columns: columns, cardTransitions: cardTransitions } = columnsDeleteData;
            if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'column deleted');
            const actions = [
                (0, $63F6h.columnDeleteSuccess)(optimistic.id, closestColumn, columns, cardTransitions)
            ];
            if (!closestColumn) actions.push((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$d44770975cd9746d)));
            return (0, $kVLXA.Observable).from(actions);
        }).catch((error)=>{
            if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'column deleteFailed', {
                error: error
            });
            return (0, $kVLXA.Observable).of((0, $63F6h.columnDeleteFailure)(optimistic.id, columnId), // @ts-expect-error - TS2769 - No overload matches this call.
            (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$d9d2fe902bd6d9a7)));
        });
    });

});
parcelRegister("fYPOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e841e1f0c5624fc9$export$2e2bcd8739ae039);
parcelRequire("3q49N");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $9XE6b = parcelRequire("9XE6b");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $hbDJg = parcelRequire("hbDJg");

var $hjlQ8 = parcelRequire("hjlQ8");
const $e841e1f0c5624fc9$export$51186ad6e864892a = (projectKey, response)=>({
        columns: response.columns.map((0, $hjlQ8.transformColumn)),
        cardTransitions: (0, $hjlQ8.getCardTransitions)(projectKey, response.columns)
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e841e1f0c5624fc9$export$2e2bcd8739ae039 = (contextPath, boardId, columnId, replacementColumnId, projectKey)=>(0, $hbDJg.default)(contextPath, boardId, columnId, replacementColumnId).flatMap((response)=>(0, $kVLXA.Observable).of($e841e1f0c5624fc9$export$51186ad6e864892a(projectKey, response))).catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('board.column.delete.graphql.failure', 'Failed to delete column via GraphQl', {
            message: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                'message'
            ], '') || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                0,
                'message'
            ], '')
        });
        return (0, $kVLXA.Observable).throw(error);
    });

});
parcelRegister("hbDJg", function(module, exports) {

$parcel$export(module.exports, "default", () => $42d2fa9be8f4cdb6$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $ivqh1 = parcelRequire("ivqh1");

var $6iJbJ = parcelRequire("6iJbJ");

var $Zbn1V = parcelRequire("Zbn1V");

var $CFxE9 = parcelRequire("CFxE9");
const $42d2fa9be8f4cdb6$export$fa62bc5e5bc2b62c = 'SoftwareColumnDelete';
const $42d2fa9be8f4cdb6$export$3b6f3376f9bb8f22 = (0, $ivqh1.gqlTagSwag)`mutation SoftwareColumnDelete($boardId:ID!, $columnId: ID!, $replacementColumnId: ID) {
        deleteColumn(input: {boardId: $boardId, columnId: $columnId, replacementColumnId: $replacementColumnId}) {
            columns {
                id
                name
                maxIssueCount
                status {
                    id
                    name
                }
                columnStatus {
                    ...ColumnStatusFragment
                }
                isInitial
                isDone
                transitionId
            }
        }
    }

    ${(0, $Zbn1V.ColumnStatusFragment)}
`;
const $42d2fa9be8f4cdb6$export$ba14d9a5a581e827 = (data)=>(0, $kVLXA.Observable).of(data.deleteColumn);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$42d2fa9be8f4cdb6$export$2e2bcd8739ae039 = (contextPath, boardId, columnId, replacementColumnId)=>(0, $6iJbJ.mutation$)(contextPath, $42d2fa9be8f4cdb6$export$fa62bc5e5bc2b62c, $42d2fa9be8f4cdb6$export$3b6f3376f9bb8f22, {
        boardId: boardId,
        columnId: columnId,
        replacementColumnId: replacementColumnId
    }, (0, $CFxE9.columnDeleteAnalyticsOptions)).flatMap($42d2fa9be8f4cdb6$export$ba14d9a5a581e827);

});


parcelRegister("63F6h", function(module, exports) {

$parcel$export(module.exports, "COLUMN_DELETE_REQUEST", () => $d967a0e2b1fbb357$export$b4535d25697f9b52);
$parcel$export(module.exports, "columnDeleteRequest", () => $d967a0e2b1fbb357$export$2d450a2a2ff1d73c);
$parcel$export(module.exports, "COLUMN_DELETE_SUCCESS", () => $d967a0e2b1fbb357$export$3120df1059711c9f);
$parcel$export(module.exports, "columnDeleteSuccess", () => $d967a0e2b1fbb357$export$a2524e4771fdebc1);
$parcel$export(module.exports, "COLUMN_DELETE_FAILURE", () => $d967a0e2b1fbb357$export$b5933586fe1ed35f);
$parcel$export(module.exports, "columnDeleteFailure", () => $d967a0e2b1fbb357$export$d12468113e6a687f);
$parcel$export(module.exports, "COLUMN_DELETE", () => $d967a0e2b1fbb357$export$da91fdc68bfa18b3);
$parcel$export(module.exports, "columnDelete", () => $d967a0e2b1fbb357$export$6897d9588103ae0);
$parcel$export(module.exports, "COLUMN_DELETE_MODAL_CLOSE", () => $d967a0e2b1fbb357$export$27782fe81bbd5131);
$parcel$export(module.exports, "columnDeleteModalClose", () => $d967a0e2b1fbb357$export$4ddfb40c6de9d0ec);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");

var $9rND4 = parcelRequire("9rND4");
const $d967a0e2b1fbb357$export$b4535d25697f9b52 = 'state.actions.column.delete.COLUMN_DELETE_REQUEST';
const $d967a0e2b1fbb357$export$2d450a2a2ff1d73c = (columnId, closestColumn, issuesInColumn = [], analyticsEvent)=>({
        type: $d967a0e2b1fbb357$export$b4535d25697f9b52,
        payload: {
            columnId: columnId,
            closestColumn: closestColumn,
            issuesInColumn: issuesInColumn
        },
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $d967a0e2b1fbb357$export$3120df1059711c9f = 'state.actions.column.delete.COLUMN_DELETE_SUCCESS';
const $d967a0e2b1fbb357$export$a2524e4771fdebc1 = (optimisticId, closestColumn, columns, cardTransitions)=>({
        type: $d967a0e2b1fbb357$export$3120df1059711c9f,
        payload: {
            closestColumn: closestColumn,
            columns: columns,
            cardTransitions: cardTransitions
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $d967a0e2b1fbb357$export$b5933586fe1ed35f = 'state.actions.column.delete.COLUMN_DELETE_FAILURE';
const $d967a0e2b1fbb357$export$d12468113e6a687f = (optimisticId, columnId, error = '')=>({
        type: $d967a0e2b1fbb357$export$b5933586fe1ed35f,
        payload: {
            columnId: columnId
        },
        meta: {
            ...(0, $9rND4.revertOptimisticUiMeta)(optimisticId),
            ...(0, $sdxnu.warningFlagMeta)({
                titleMessage: (0, $7AVqz.default).genericTitle,
                descriptionMessage: error ? (0, $7AVqz.default).failureDescription : (0, $7AVqz.default).genericDescription,
                context: {
                    error: error
                }
            })
        }
    });
const $d967a0e2b1fbb357$export$da91fdc68bfa18b3 = 'state.actions.column.delete.COLUMN_DELETE';
const $d967a0e2b1fbb357$export$6897d9588103ae0 = (columnId, hasIssues, hasIssuesNotOnBoard)=>({
        type: $d967a0e2b1fbb357$export$da91fdc68bfa18b3,
        payload: {
            columnId: columnId,
            hasIssues: hasIssues,
            hasIssuesNotOnBoard: hasIssuesNotOnBoard
        }
    });
const $d967a0e2b1fbb357$export$27782fe81bbd5131 = 'state.actions.column.delete.COLUMN_DELETE_MODAL_CLOSE';
const $d967a0e2b1fbb357$export$4ddfb40c6de9d0ec = ()=>({
        type: $d967a0e2b1fbb357$export$27782fe81bbd5131
    });

});


parcelRegister("kAzMD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f13d5fb4d26dc73$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("fg0YM");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $8zOmE = parcelRequire("8zOmE");

var $7MDCq = parcelRequire("7MDCq");

var $55fEr = parcelRequire("55fEr");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7f13d5fb4d26dc73$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $55fEr.COLUMN_RANK_REQUEST)).concatMap((action)=>{
        const state = store.getState();
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const hasDoneColumnInLastPosition = (0, $fyeGd.hasDoneColumnInLastPositionSelector)(state);
        const isSprintsEnabled = (0, $ebHh7.isSprintsEnabled)(state);
        const { payload: { columnId: columnId, sourceColumnIndex: sourceColumnIndex }, meta: { optimistic: optimistic, analyticsEvent: analyticsEvent } } = action;
        // The redux state contains optimistic order, hence we can use columnID instead of targetID
        const position = (0, $fyeGd.getColumnIndex)(state, columnId);
        return (0, $7MDCq.default)(contextPath, boardId, columnId, position).flatMap(()=>{
            if (analyticsEvent && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(sourceColumnIndex)) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'column moved', {
                initialPosition: sourceColumnIndex + 1,
                destinationPosition: position + 1,
                hasDoneColumnInLastPosition: hasDoneColumnInLastPosition,
                isSprintsEnabled: isSprintsEnabled
            });
            return (0, $kVLXA.Observable).of((0, $55fEr.columnRankSuccess)(optimistic.id, columnId));
        }).catch((error)=>{
            if (analyticsEvent && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(sourceColumnIndex)) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'column moveFailed', {
                error: error,
                initialColumn: sourceColumnIndex + 1,
                destinationColumn: position + 1
            });
            return (0, $kVLXA.Observable).of((0, $55fEr.columnRankFailure)(optimistic.id, columnId, error));
        });
    });

});
parcelRegister("7MDCq", function(module, exports) {

$parcel$export(module.exports, "default", () => $114b7a257ed172ff$export$2e2bcd8739ae039);
parcelRequire("3q49N");
parcelRequire("c66Ur");

var $9XE6b = parcelRequire("9XE6b");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $3XBVR = parcelRequire("3XBVR");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$114b7a257ed172ff$export$2e2bcd8739ae039 = (contextPath, boardId, columnId, position)=>(0, $3XBVR.default)(contextPath, boardId, columnId, position).catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('board.column.rank.graphql.failure', 'Failed to rank column via GraphQl', {
            message: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                'message'
            ], '') || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                0,
                'message'
            ], '')
        });
        return (0, $kVLXA.Observable).throw(error);
    });

});
parcelRegister("3XBVR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c5aeb5883765e44$export$2e2bcd8739ae039);

var $ivqh1 = parcelRequire("ivqh1");

var $6iJbJ = parcelRequire("6iJbJ");

var $CFxE9 = parcelRequire("CFxE9");
const $1c5aeb5883765e44$export$b5a4bd8cd48ce8d1 = 'SoftwareColumnRank';
const $1c5aeb5883765e44$export$e808ae55ccdba094 = (0, $ivqh1.gqlTagSwag)`mutation SoftwareColumnRank($boardId: ID!, $columnId: ID!, $position: Int!){
        rankColumn(input: {boardId: $boardId, columnId: $columnId, position: $position}) {
            success
        }
    }
`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1c5aeb5883765e44$export$2e2bcd8739ae039 = (contextPath, boardId, columnId, position)=>(0, $6iJbJ.mutation$)(contextPath, $1c5aeb5883765e44$export$b5a4bd8cd48ce8d1, $1c5aeb5883765e44$export$e808ae55ccdba094, {
        boardId: boardId,
        columnId: columnId,
        position: position
    }, (0, $CFxE9.columnRankAnalyticsOptions));

});


parcelRegister("55fEr", function(module, exports) {

$parcel$export(module.exports, "COLUMN_RANK_REQUEST", () => $9bfbfef736995cc8$export$335da9e5c94e8e13);
$parcel$export(module.exports, "columnRankRequest", () => $9bfbfef736995cc8$export$52f00a5a5ec3dade);
$parcel$export(module.exports, "COLUMN_RANK_SUCCESS", () => $9bfbfef736995cc8$export$12932c9778919ee);
$parcel$export(module.exports, "columnRankSuccess", () => $9bfbfef736995cc8$export$2011044b8a484462);
$parcel$export(module.exports, "COLUMN_RANK_FAILURE", () => $9bfbfef736995cc8$export$be97721c3848d982);
$parcel$export(module.exports, "columnRankFailure", () => $9bfbfef736995cc8$export$8c4ab2c0d8c0dc47);

var $9rND4 = parcelRequire("9rND4");
const $9bfbfef736995cc8$export$335da9e5c94e8e13 = 'state.actions.column.rank.COLUMN_RANK_REQUEST';
const $9bfbfef736995cc8$export$52f00a5a5ec3dade = (columnId, targetColumnId, sourceColumnIndex, analyticsEvent)=>({
        type: $9bfbfef736995cc8$export$335da9e5c94e8e13,
        payload: {
            columnId: columnId,
            targetColumnId: targetColumnId,
            sourceColumnIndex: sourceColumnIndex
        },
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $9bfbfef736995cc8$export$12932c9778919ee = 'state.actions.column.rank.COLUMN_RANK_SUCCESS';
const $9bfbfef736995cc8$export$2011044b8a484462 = (optimisticId, columnId)=>({
        type: $9bfbfef736995cc8$export$12932c9778919ee,
        payload: {
            columnId: columnId
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $9bfbfef736995cc8$export$be97721c3848d982 = 'state.actions.column.rank.COLUMN_RANK_FAILURE';
const $9bfbfef736995cc8$export$8c4ab2c0d8c0dc47 = (optimisticId, columnId, error)=>({
        type: $9bfbfef736995cc8$export$be97721c3848d982,
        payload: {
            columnId: columnId
        },
        error: error,
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("7Tp6S", function(module, exports) {

$parcel$export(module.exports, "default", () => $e45e6f48a22a2cfb$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("fg0YM");

var $8zOmE = parcelRequire("8zOmE");

var $esu6n = parcelRequire("esu6n");

var $2RMda = parcelRequire("2RMda");

var $63VRQ = parcelRequire("63VRQ");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e45e6f48a22a2cfb$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $63VRQ.COLUMN_RENAME_REQUEST)).concatMap((action)=>{
        const state = store.getState();
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const projectKey = (0, $67Z81.projectKeySelector)(state);
        const { payload: { columnId: columnId, name: name }, meta: { optimistic: optimistic, analyticsEvent: analyticsEvent } } = action;
        const position = (0, $fyeGd.getColumnIndex)(state, columnId);
        return (0, $2RMda.default)(contextPath, boardId, columnId, name, projectKey).flatMap((columnRenameResponse)=>{
            const { column: column, cardTransitions: cardTransitions } = columnRenameResponse;
            const statuses = (0, $esu6n.getStatusColumn)(column)?.statuses ?? [];
            if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'column renamed', {
                position: position + 1
            });
            return (0, $kVLXA.Observable).of((0, $63VRQ.columnRenameSuccess)(optimistic.id, columnId, statuses, cardTransitions));
        }).catch((error)=>{
            if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'column renameFailed', {
                error: error,
                position: position + 1
            });
            return (0, $kVLXA.Observable).of((0, $63VRQ.columnRenameFailure)(optimistic.id, columnId, error));
        });
    });

});
parcelRegister("2RMda", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf5e04400d4a7f02$export$2e2bcd8739ae039);
parcelRequire("3q49N");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $9XE6b = parcelRequire("9XE6b");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $5LA50 = parcelRequire("5LA50");

var $hjlQ8 = parcelRequire("hjlQ8");
const $cf5e04400d4a7f02$export$51186ad6e864892a = (projectKey, columnRenameData)=>({
        column: (0, $hjlQ8.transformColumn)(columnRenameData.column),
        cardTransitions: (0, $hjlQ8.getCardTransitions)(projectKey, [
            columnRenameData.column
        ])
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cf5e04400d4a7f02$export$2e2bcd8739ae039 = (contextPath, boardId, columnId, columnName, projectKey)=>(0, $5LA50.default)(contextPath, boardId, columnId, columnName).flatMap((columnRenameData)=>(0, $kVLXA.Observable).of($cf5e04400d4a7f02$export$51186ad6e864892a(projectKey, columnRenameData))).catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('board.column.rename.graphql.failure', 'Failed to rename column via GraphQl', {
            message: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                'message'
            ], '') || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                0,
                'message'
            ], '')
        });
        return (0, $kVLXA.Observable).throw(error);
    });

});
parcelRegister("5LA50", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e5426f29097d4f0$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $ivqh1 = parcelRequire("ivqh1");

var $6iJbJ = parcelRequire("6iJbJ");

var $Zbn1V = parcelRequire("Zbn1V");

var $CFxE9 = parcelRequire("CFxE9");
const $6e5426f29097d4f0$export$2d9274ca8bff19e7 = 'SoftwareColumnRename';
const $6e5426f29097d4f0$export$b9999446542b88b6 = (0, $ivqh1.gqlTagSwag)`
    mutation SoftwareColumnRename($boardId: ID!, $columnId: ID!, $columnName: String!) {
        setColumnName(input: {boardId: $boardId, columnId: $columnId, columnName: $columnName}) {
            column {
                id
                status {
                    id
                    name
                }
                columnStatus {
                    ...ColumnStatusFragment
                }
                isDone
                isInitial
                transitionId
            }
        }
    }

    ${(0, $Zbn1V.ColumnStatusFragment)}
`;
const $6e5426f29097d4f0$export$ba14d9a5a581e827 = (data)=>(0, $kVLXA.Observable).of(data.setColumnName);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6e5426f29097d4f0$export$2e2bcd8739ae039 = (contextPath, boardId, columnId, columnName)=>(0, $6iJbJ.mutation$)(contextPath, $6e5426f29097d4f0$export$2d9274ca8bff19e7, $6e5426f29097d4f0$export$b9999446542b88b6, {
        boardId: boardId,
        columnId: columnId,
        columnName: columnName
    }, (0, $CFxE9.columnRenameAnalyticsOptions)).flatMap($6e5426f29097d4f0$export$ba14d9a5a581e827);

});


parcelRegister("63VRQ", function(module, exports) {

$parcel$export(module.exports, "COLUMN_RENAME_REQUEST", () => $6bea3bff04912ecc$export$c40a1a33681bf057);
$parcel$export(module.exports, "columnRenameRequest", () => $6bea3bff04912ecc$export$26259738ac7d398);
$parcel$export(module.exports, "COLUMN_RENAME_SUCCESS", () => $6bea3bff04912ecc$export$dc8c46a85951229d);
$parcel$export(module.exports, "columnRenameSuccess", () => $6bea3bff04912ecc$export$e91d130c91c717f8);
$parcel$export(module.exports, "COLUMN_RENAME_FAILURE", () => $6bea3bff04912ecc$export$430334cf6e52a887);
$parcel$export(module.exports, "columnRenameFailure", () => $6bea3bff04912ecc$export$519e7ffdc12c083f);

var $9rND4 = parcelRequire("9rND4");
const $6bea3bff04912ecc$export$c40a1a33681bf057 = 'state.actions.column.rename.COLUMN_RENAME_REQUEST';
const $6bea3bff04912ecc$export$26259738ac7d398 = (columnId, name, analyticsEvent)=>({
        type: $6bea3bff04912ecc$export$c40a1a33681bf057,
        payload: {
            columnId: columnId,
            name: name
        },
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $6bea3bff04912ecc$export$dc8c46a85951229d = 'state.actions.column.rename.COLUMN_RENAME_SUCCESS';
const $6bea3bff04912ecc$export$e91d130c91c717f8 = (optimisticId, columnId, statuses, cardTransitions)=>({
        type: $6bea3bff04912ecc$export$dc8c46a85951229d,
        payload: {
            columnId: columnId,
            statuses: statuses,
            cardTransitions: cardTransitions
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $6bea3bff04912ecc$export$430334cf6e52a887 = 'state.actions.column.rename.COLUMN_RENAME_FAILURE';
const $6bea3bff04912ecc$export$519e7ffdc12c083f = (optimisticId, columnId, error)=>({
        type: $6bea3bff04912ecc$export$430334cf6e52a887,
        payload: {
            columnId: columnId
        },
        error: error,
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("14rCC", function(module, exports) {

$parcel$export(module.exports, "default", () => $deddf958d81ff2ce$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("fg0YM");

var $8zOmE = parcelRequire("8zOmE");

var $1ypcX = parcelRequire("1ypcX");

var $9eeht = parcelRequire("9eeht");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$deddf958d81ff2ce$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $9eeht.COLUMN_SET_LIMITS_REQUEST)).concatMap((action)=>{
        const state = store.getState();
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const { payload: { columnId: columnId, maxIssueCount: maxIssueCount, minIssueCount: minIssueCount }, meta: { optimistic: optimistic, analyticsEvent: analyticsEvent } } = action;
        const position = (0, $fyeGd.getColumnIndex)(state, columnId);
        return (0, $1ypcX.default)(contextPath, boardId, columnId, maxIssueCount, minIssueCount).flatMap(()=>{
            if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'column setLimit', {
                position: position + 1,
                maxIssueCount: maxIssueCount,
                minIssueCount: minIssueCount
            });
            return (0, $kVLXA.Observable).of((0, $9eeht.columnSetLimitsSuccess)(optimistic.id, columnId));
        }).catch((error)=>{
            if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'column setLimitFailed', {
                error: error,
                position: position + 1,
                maxIssueCount: maxIssueCount
            });
            return (0, $kVLXA.Observable).of((0, $9eeht.columnSetLimitsFailure)(optimistic.id, columnId));
        });
    });

});
parcelRegister("1ypcX", function(module, exports) {

$parcel$export(module.exports, "default", () => $21e1a6daf9e5fc4c$export$2e2bcd8739ae039);

var $bUfxy = parcelRequire("bUfxy");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$21e1a6daf9e5fc4c$export$2e2bcd8739ae039 = (contextPath, boardId, columnId, limit, minimum)=>(0, $bUfxy.default)(contextPath, boardId, columnId, limit, minimum);

});
parcelRegister("bUfxy", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c2bcc5f22c9c3c7$export$2e2bcd8739ae039);

var $ivqh1 = parcelRequire("ivqh1");

var $6iJbJ = parcelRequire("6iJbJ");

var $CFxE9 = parcelRequire("CFxE9");
const $1c2bcc5f22c9c3c7$export$6b26f3650e1da55a = 'SoftwareColumnSetLimit';
const $1c2bcc5f22c9c3c7$export$5298fb188d74e2c3 = (0, $ivqh1.gqlTagSwag)`mutation SoftwareColumnSetLimit($boardId:ID!, $columnId: ID!, $limit:Int, $minimum:Int){
    setColumnLimit(input: {boardId: $boardId, columnId: $columnId, limit: $limit, minimum: $minimum}) {
        success
    }
}`;
function $1c2bcc5f22c9c3c7$export$2e2bcd8739ae039(contextPath, boardId, columnId, limit, minimum) {
    return (0, $6iJbJ.mutation$)(contextPath, $1c2bcc5f22c9c3c7$export$6b26f3650e1da55a, $1c2bcc5f22c9c3c7$export$5298fb188d74e2c3, {
        boardId: boardId,
        columnId: columnId,
        limit: limit,
        minimum: minimum
    }, (0, $CFxE9.columnSetLimitAnalyticsOptions));
}

});


parcelRegister("9eeht", function(module, exports) {

$parcel$export(module.exports, "COLUMN_OPEN_LIMITS_MODAL", () => $4d13db2916dc0c09$export$6a8e8c210302f17a);
$parcel$export(module.exports, "columnOpenLimitsModal", () => $4d13db2916dc0c09$export$7db64843dc1f34b6);
$parcel$export(module.exports, "COLUMN_CLOSE_LIMITS_MODAL", () => $4d13db2916dc0c09$export$f7f89717d9dcf7fb);
$parcel$export(module.exports, "columnCloseLimitsModal", () => $4d13db2916dc0c09$export$5eb828385c591dbf);
$parcel$export(module.exports, "COLUMN_SET_LIMITS_REQUEST", () => $4d13db2916dc0c09$export$c4d8590d75985d98);
$parcel$export(module.exports, "columnSetLimitsRequest", () => $4d13db2916dc0c09$export$426784419a12c1b5);
$parcel$export(module.exports, "COLUMN_SET_LIMITS_SUCCESS", () => $4d13db2916dc0c09$export$3edc87fb0dc6ea8e);
$parcel$export(module.exports, "columnSetLimitsSuccess", () => $4d13db2916dc0c09$export$c9f0c15978432dec);
$parcel$export(module.exports, "COLUMN_SET_LIMITS_FAILURE", () => $4d13db2916dc0c09$export$b946c8d5d7849f8a);
$parcel$export(module.exports, "columnSetLimitsFailure", () => $4d13db2916dc0c09$export$3b783b9b2a0ab085);

var $9rND4 = parcelRequire("9rND4");
const $4d13db2916dc0c09$export$6a8e8c210302f17a = 'state.actions.column.limits.COLUMN_OPEN_LIMITS_MODAL';
const $4d13db2916dc0c09$export$7db64843dc1f34b6 = (columnId)=>({
        type: $4d13db2916dc0c09$export$6a8e8c210302f17a,
        payload: {
            columnId: columnId
        }
    });
const $4d13db2916dc0c09$export$f7f89717d9dcf7fb = 'state.actions.column.limits.COLUMN_CLOSE_LIMITS_MODAL';
const $4d13db2916dc0c09$export$5eb828385c591dbf = (columnId)=>({
        type: $4d13db2916dc0c09$export$f7f89717d9dcf7fb,
        payload: {
            columnId: columnId
        }
    });
const $4d13db2916dc0c09$export$c4d8590d75985d98 = 'state.actions.column.limits.COLUMN_SET_LIMITS_REQUEST';
const $4d13db2916dc0c09$export$426784419a12c1b5 = (columnId, maxIssueCount, minIssueCount, analyticsEvent)=>({
        type: $4d13db2916dc0c09$export$c4d8590d75985d98,
        payload: {
            columnId: columnId,
            maxIssueCount: maxIssueCount,
            minIssueCount: minIssueCount
        },
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $4d13db2916dc0c09$export$3edc87fb0dc6ea8e = 'state.actions.column.limits.COLUMN_SET_LIMITS_SUCCESS';
const $4d13db2916dc0c09$export$c9f0c15978432dec = (optimisticId, columnId)=>({
        type: $4d13db2916dc0c09$export$3edc87fb0dc6ea8e,
        payload: {
            columnId: columnId
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $4d13db2916dc0c09$export$b946c8d5d7849f8a = 'state.actions.column.limits.COLUMN_SET_LIMITS_FAILURE';
const $4d13db2916dc0c09$export$3b783b9b2a0ab085 = (optimisticId, columnId)=>({
        type: $4d13db2916dc0c09$export$b946c8d5d7849f8a,
        payload: {
            columnId: columnId
        },
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("8SGPr", function(module, exports) {

$parcel$export(module.exports, "detailViewCloseEpic", () => $316fb987c7134ef2$export$511093f766907f93);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("6cbqE");

var $kXqRJ = parcelRequire("kXqRJ");

var $dW1HX = parcelRequire("dW1HX");

var $cIqUn = parcelRequire("cIqUn");

var $fqLDH = parcelRequire("fqLDH");
const $316fb987c7134ef2$export$511093f766907f93 = (action$, store)=>action$.ofType((0, $kXqRJ.ISSUE_DELETE_REQUEST), (0, $cIqUn.ISSUE_MOVE_TO_BACKLOG_REQUEST)).switchMap((action)=>{
        const state = store.getState();
        const issueId = (0, $fqLDH.getIssueIdForModal)(state);
        if (!issueId) return (0, $kVLXA.Observable).empty();
        if (action.type === (0, $cIqUn.ISSUE_MOVE_TO_BACKLOG_REQUEST) && action.payload.issueIds.includes(issueId)) return (0, $kVLXA.Observable).of((0, $dW1HX.closeIssueModal)((0, $fqLDH.getIssueKeyForModal)(state)));
        if (action.type === (0, $kXqRJ.ISSUE_DELETE_REQUEST) && action.payload.issue.id === issueId) return (0, $kVLXA.Observable).of((0, $dW1HX.closeIssueModal)((0, $fqLDH.getIssueKeyForModal)(state)));
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("cIqUn", function(module, exports) {

$parcel$export(module.exports, "ISSUE_MOVE_TO_BACKLOG_REQUEST", () => $19e3779f54beab8e$export$f180b23a6d76a36c);
$parcel$export(module.exports, "issueMoveToBacklogRequest", () => $19e3779f54beab8e$export$1c79b09f3075e4ea);
$parcel$export(module.exports, "ISSUE_MOVE_TO_BACKLOG_SUCCESS", () => $19e3779f54beab8e$export$d4a24bc75ec9e22b);
$parcel$export(module.exports, "issueMoveToBacklogSuccess", () => $19e3779f54beab8e$export$5a53dd39dd4e0e24);
$parcel$export(module.exports, "ISSUE_MOVE_TO_BACKLOG_FAILURE", () => $19e3779f54beab8e$export$60cf36654ed56c30);
$parcel$export(module.exports, "issueMoveToBacklogFailure", () => $19e3779f54beab8e$export$a9d1ce754cbce39);

var $9rND4 = parcelRequire("9rND4");
const $19e3779f54beab8e$export$f180b23a6d76a36c = 'state.actions.issue.move-to-backlog.ISSUE_MOVE_TO_BACKLOG_REQUEST';
const $19e3779f54beab8e$export$1c79b09f3075e4ea = (issueIds, issueKeys, columnId)=>({
        type: $19e3779f54beab8e$export$f180b23a6d76a36c,
        payload: {
            issueIds: issueIds,
            issueKeys: issueKeys,
            columnId: columnId
        },
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    });
const $19e3779f54beab8e$export$d4a24bc75ec9e22b = 'state.actions.issue.move-to-backlog.ISSUE_MOVE_TO_BACKLOG_SUCCESS';
const $19e3779f54beab8e$export$5a53dd39dd4e0e24 = (optimisticId, issueIds, columnId)=>({
        type: $19e3779f54beab8e$export$d4a24bc75ec9e22b,
        payload: {
            issueIds: issueIds,
            columnId: columnId
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $19e3779f54beab8e$export$60cf36654ed56c30 = 'state.actions.issue.move-to-backlog.ISSUE_MOVE_TO_BACKLOG_FAILURE';
const $19e3779f54beab8e$export$a9d1ce754cbce39 = (optimisticId, issueIds)=>({
        type: $19e3779f54beab8e$export$60cf36654ed56c30,
        payload: {
            issueIds: issueIds
        },
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("8gsv0", function(module, exports) {

$parcel$export(module.exports, "detailViewOpenDebouncedEpic", () => $f3dab53a380a8c8b$export$2e5970b542a40342);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("eSGL3");
parcelRequire("fPS7b");

var $dW1HX = parcelRequire("dW1HX");
const $f3dab53a380a8c8b$export$2e5970b542a40342 = (action$)=>action$.ofType((0, $dW1HX.OPEN_ISSUE_MODAL_DEBOUNCED)).debounceTime(500).mergeMap((action)=>(0, $kVLXA.Observable).of((0, $dW1HX.openIssueModal)(action.payload.issueKey, action.payload.externalAction)));

});

parcelRegister("gMi9d", function(module, exports) {

$parcel$export(module.exports, "detailViewUpdateEpic", () => $3c9fa8f890559c9c$export$ddc67837ea92e238);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("6cbqE");


var $2f454 = parcelRequire("2f454");

var $7tJ5d = parcelRequire("7tJ5d");

var $iaYF9 = parcelRequire("iaYF9");

var $fBkjL = parcelRequire("fBkjL");

var $3n65g = parcelRequire("3n65g");

var $71oFY = parcelRequire("71oFY");

var $evkwq = parcelRequire("evkwq");

var $fqLDH = parcelRequire("fqLDH");
const $3c9fa8f890559c9c$export$ddc67837ea92e238 = (action$, store)=>action$.ofType((0, $2f454.CARD_DATA_SET), (0, $evkwq.ISSUE_UPDATE_SUCCESS), (0, $fBkjL.ISSUE_FLAG_WITH_COMMENT_SUCCESS), (0, $iaYF9.ISSUE_ADD_LABELS_SUCCESS), (0, $71oFY.ISSUE_RANK_TRANSITION_SUCCESS), (0, $3n65g.SET_PARENT_SUCCESS), (0, $3n65g.UNSET_PARENT_SUCCESS), (0, $3n65g.SET_PARENT_OPTIMISTIC)).switchMap((action)=>{
        const state = store.getState();
        const issueId = (0, $fqLDH.getIssueIdForModal)(state);
        if (!issueId) return (0, $kVLXA.Observable).empty();
        if ((action.type === (0, $2f454.CARD_DATA_SET) || action.type === (0, $evkwq.ISSUE_UPDATE_SUCCESS)) && action.payload.origin === (0, $f32ae13c2b9742f4$export$d46a05f8561f868a) && action.payload.issue.id === issueId) return (0, $kVLXA.Observable).of((0, $7tJ5d.updateDetailView)());
        if (action.type === (0, $fBkjL.ISSUE_FLAG_WITH_COMMENT_SUCCESS) && action.payload.issueIds.includes(issueId)) return (0, $kVLXA.Observable).of((0, $7tJ5d.updateDetailView)());
        if (action.type === (0, $iaYF9.ISSUE_ADD_LABELS_SUCCESS) && action.payload.includes(issueId)) return (0, $kVLXA.Observable).of((0, $7tJ5d.updateDetailView)());
        if (action.type === (0, $71oFY.ISSUE_RANK_TRANSITION_SUCCESS)) {
            const parentIds = action.payload.issueIds.flatMap((id)=>{
                const issue = (0, $fqLDH.getIssueByIdForModal)(state)(id);
                // @ts-expect-error - TS2339 - Property 'parentId' does not exist on type 'Issue | IssueParent'.
                if (issue && issue.parentId !== undefined) // @ts-expect-error - TS2339 - Property 'parentId' does not exist on type 'Issue | IssueParent'.
                return issue.parentId;
                return [];
            });
            if (action.payload.issueIds.includes(issueId) || parentIds.includes(issueId)) return (0, $kVLXA.Observable).of((0, $7tJ5d.updateDetailView)());
        }
        if ((action.type === (0, $3n65g.SET_PARENT_SUCCESS) || action.type === (0, $3n65g.UNSET_PARENT_SUCCESS)) && action.payload.issueIds.includes(issueId)) return (0, $kVLXA.Observable).of((0, $7tJ5d.updateDetailView)());
        if (action.type === (0, $3n65g.SET_PARENT_OPTIMISTIC) && action.payload.issues.map((issue)=>issue.id).includes(issueId)) return (0, $kVLXA.Observable).of((0, $7tJ5d.updateDetailView)());
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("7tJ5d", function(module, exports) {

$parcel$export(module.exports, "UPDATE_DETAIL_VIEW", () => $eda17ead7b9b9550$export$e38020a85931f37e);
$parcel$export(module.exports, "updateDetailView", () => $eda17ead7b9b9550$export$d5df566661a69c2d);
const $eda17ead7b9b9550$export$e38020a85931f37e = 'state.actions.detail-view.UPDATE_DETAIL_VIEW';
const $eda17ead7b9b9550$export$d5df566661a69c2d = ()=>({
        type: $eda17ead7b9b9550$export$e38020a85931f37e
    });

});

parcelRegister("iaYF9", function(module, exports) {

$parcel$export(module.exports, "SHOW_ISSUE_ADD_LABEL_MODAL", () => $02c1e897250b17fa$export$2512ad1fa2a5cc9);
$parcel$export(module.exports, "showIssueAddLabelModal", () => $02c1e897250b17fa$export$bac21fa33dff3d0e);
$parcel$export(module.exports, "HIDE_ISSUE_ADD_LABEL_MODAL", () => $02c1e897250b17fa$export$d3b2c62cf224a7f5);
$parcel$export(module.exports, "hideIssueAddLabelModal", () => $02c1e897250b17fa$export$5314c0004ac7176c);
$parcel$export(module.exports, "ISSUE_ADD_LABELS", () => $02c1e897250b17fa$export$dcd34e7fa01d17de);
$parcel$export(module.exports, "issueAddLabels", () => $02c1e897250b17fa$export$5c330854b670e947);
$parcel$export(module.exports, "ISSUE_ADD_LABELS_SUCCESS", () => $02c1e897250b17fa$export$ff85d5b1f744d6c8);
$parcel$export(module.exports, "issueAddLabelsSuccess", () => $02c1e897250b17fa$export$128c05d32ac24ef7);
$parcel$export(module.exports, "issueAddLabelsFailure", () => $02c1e897250b17fa$export$5ba38608dc882ffb);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $02c1e897250b17fa$export$2512ad1fa2a5cc9 = 'state.actions.issue.add-label-modal.SHOW_ISSUE_ADD_LABEL_MODAL';
const $02c1e897250b17fa$export$bac21fa33dff3d0e = (issueIds)=>({
        type: $02c1e897250b17fa$export$2512ad1fa2a5cc9,
        payload: issueIds
    });
const $02c1e897250b17fa$export$d3b2c62cf224a7f5 = 'state.actions.issue.add-label-modal.HIDE_ISSUE_ADD_LABEL_MODAL';
const $02c1e897250b17fa$export$5314c0004ac7176c = ()=>({
        type: $02c1e897250b17fa$export$d3b2c62cf224a7f5
    });
const $02c1e897250b17fa$export$dcd34e7fa01d17de = 'state.actions.issue.add-label-modal.ISSUE_ADD_LABELS';
const $02c1e897250b17fa$export$5c330854b670e947 = (issueIds, labels)=>({
        type: $02c1e897250b17fa$export$dcd34e7fa01d17de,
        payload: {
            issueIds: issueIds,
            labels: labels
        }
    });
const $02c1e897250b17fa$export$ff85d5b1f744d6c8 = 'state.actions.issue.add-label-modal.ISSUE_ADD_LABELS_SUCCESS';
const $02c1e897250b17fa$export$128c05d32ac24ef7 = (issueIds)=>({
        type: $02c1e897250b17fa$export$ff85d5b1f744d6c8,
        payload: issueIds
    });
const $02c1e897250b17fa$export$75246e0069503880 = 'state.actions.issue.add-label-modal.ISSUE_ADD_LABELS_FAILURE';
const $02c1e897250b17fa$export$5ba38608dc882ffb = (savedIssueIds, failedIssueIds)=>({
        type: $02c1e897250b17fa$export$75246e0069503880,
        payload: {
            savedIssueIds: savedIssueIds,
            failedIssueIds: failedIssueIds
        },
        meta: {
            ...(0, $sdxnu.warningFlagMeta)({
                titleMessage: (0, $7AVqz.default).genericTitle,
                descriptionMessage: (0, $7AVqz.default).issueLabelsSaveFailed
            })
        }
    });

});

parcelRegister("fBkjL", function(module, exports) {

$parcel$export(module.exports, "ISSUE_FLAG_WITH_COMMENT_REQUEST", () => $969635107447c135$export$a1d537152eece2c6);
$parcel$export(module.exports, "issueFlagWithCommentRequest", () => $969635107447c135$export$7fa3ed92e351f9d9);
$parcel$export(module.exports, "ISSUE_FLAG_WITH_COMMENT_SUCCESS", () => $969635107447c135$export$da38bc4d28a28087);
$parcel$export(module.exports, "issueFlagWithCommentSuccess", () => $969635107447c135$export$d3d00de1178f8de8);
$parcel$export(module.exports, "issueFlagWithCommentFailure", () => $969635107447c135$export$b0866a7a86e285af);

var $9rND4 = parcelRequire("9rND4");
const $969635107447c135$export$a1d537152eece2c6 = 'state.actions.issue.flag-with-comment.ISSUE_FLAG_WITH_COMMENT_REQUEST';
const $969635107447c135$export$7fa3ed92e351f9d9 = (issueIds, flag, comment, analyticsEvent)=>({
        type: $969635107447c135$export$a1d537152eece2c6,
        payload: {
            issueIds: issueIds,
            flag: flag,
            comment: comment
        },
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $969635107447c135$export$da38bc4d28a28087 = 'state.actions.issue.flag-with-comment.ISSUE_FLAG_WITH_COMMENT_SUCCESS';
const $969635107447c135$export$d3d00de1178f8de8 = (optimisticId, issueIds)=>({
        type: $969635107447c135$export$da38bc4d28a28087,
        payload: {
            issueIds: issueIds
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $969635107447c135$export$90380d57abbfaa43 = 'state.actions.issue.flag-with-comment.ISSUE_FLAG_WITH_COMMENT_FAILURE';
const $969635107447c135$export$b0866a7a86e285af = (optimisticId, issueIds)=>({
        type: $969635107447c135$export$90380d57abbfaa43,
        payload: {
            issueIds: issueIds
        },
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});

parcelRegister("3n65g", function(module, exports) {

$parcel$export(module.exports, "SET_PARENT_OPTIMISTIC", () => $4a0bde56d1b17de8$export$f12fa57c5a24cc9f);
$parcel$export(module.exports, "setParentOptimistic", () => $4a0bde56d1b17de8$export$c2dcedde7d23b594);
$parcel$export(module.exports, "SET_PARENT_SUCCESS", () => $4a0bde56d1b17de8$export$4bb036ce8efdbcff);
$parcel$export(module.exports, "setParentSuccess", () => $4a0bde56d1b17de8$export$6db24407ee10b2d3);
$parcel$export(module.exports, "setParentFailure", () => $4a0bde56d1b17de8$export$c7950a8b245b9032);
$parcel$export(module.exports, "UNSET_PARENT_SUCCESS", () => $4a0bde56d1b17de8$export$fe453787af036e5f);
$parcel$export(module.exports, "SET_ISSUE_PARENT_STATUS", () => $4a0bde56d1b17de8$export$362b3491e984673e);
$parcel$export(module.exports, "setIssueParentStatus", () => $4a0bde56d1b17de8$export$6cca14d1fad7b326);
$parcel$export(module.exports, "SET_ISSUE_PARENT_SUMMARY", () => $4a0bde56d1b17de8$export$1f6b71a6b4bb1d3f);
$parcel$export(module.exports, "setIssueParentSummary", () => $4a0bde56d1b17de8$export$acf348b3d3d2f816);
$parcel$export(module.exports, "ADD_ISSUE_PARENT", () => $4a0bde56d1b17de8$export$f15f4813e6a1098b);
$parcel$export(module.exports, "addIssueParent", () => $4a0bde56d1b17de8$export$c4c252d1768346ba);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");

var $9rND4 = parcelRequire("9rND4");
const $4a0bde56d1b17de8$export$f12fa57c5a24cc9f = 'state.actions.issue.parent.SET_PARENT_OPTIMISTIC';
const $4a0bde56d1b17de8$export$c2dcedde7d23b594 = (issues, parentId, requestPromise)=>({
        type: $4a0bde56d1b17de8$export$f12fa57c5a24cc9f,
        payload: {
            issues: issues,
            parentId: parentId,
            requestPromise: requestPromise
        },
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    });
const $4a0bde56d1b17de8$export$4bb036ce8efdbcff = 'state.actions.issue.parent.SET_PARENT_SUCCESS';
const $4a0bde56d1b17de8$export$6db24407ee10b2d3 = (optimisticId, issueIds)=>({
        type: $4a0bde56d1b17de8$export$4bb036ce8efdbcff,
        payload: {
            issueIds: issueIds
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $4a0bde56d1b17de8$export$5c2ad12189bbd49d = 'state.actions.issue.parent.SET_PARENT_FAILURE';
const $4a0bde56d1b17de8$export$c7950a8b245b9032 = (optimisticId)=>({
        type: $4a0bde56d1b17de8$export$5c2ad12189bbd49d,
        meta: {
            ...(0, $sdxnu.warningFlagMeta)({
                id: $4a0bde56d1b17de8$export$5c2ad12189bbd49d,
                titleMessage: (0, $7AVqz.default).genericTitle,
                descriptionMessage: (0, $7AVqz.default).genericDescription
            }),
            ...(0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
        }
    });
const $4a0bde56d1b17de8$export$fe453787af036e5f = 'state.actions.issue.parent.UNSET_PARENT_SUCCESS';
const $4a0bde56d1b17de8$export$60feaf55fd14c76a = (optimisticId, issueIds)=>({
        type: $4a0bde56d1b17de8$export$fe453787af036e5f,
        payload: {
            issueIds: issueIds
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $4a0bde56d1b17de8$export$ab972ebdce5decb = 'state.actions.issue.parent.UNSET_PARENT_FAILURE';
const $4a0bde56d1b17de8$export$df5db15564db21af = (optimisticId)=>({
        type: $4a0bde56d1b17de8$export$ab972ebdce5decb,
        meta: {
            ...(0, $sdxnu.warningFlagMeta)({
                id: $4a0bde56d1b17de8$export$ab972ebdce5decb,
                titleMessage: (0, $7AVqz.default).genericTitle,
                descriptionMessage: (0, $7AVqz.default).genericDescription
            }),
            ...(0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
        }
    });
const $4a0bde56d1b17de8$export$362b3491e984673e = 'state.actions.issue.parent.SET_ISSUE_PARENT_STATUS';
const $4a0bde56d1b17de8$export$6cca14d1fad7b326 = (issueId, status)=>({
        type: $4a0bde56d1b17de8$export$362b3491e984673e,
        payload: {
            issueId: issueId,
            status: status
        }
    });
const $4a0bde56d1b17de8$export$1f6b71a6b4bb1d3f = 'state.actions.issue.parent.SET_ISSUE_PARENT_SUMMARY';
const $4a0bde56d1b17de8$export$acf348b3d3d2f816 = (issueId, issueSummary)=>({
        type: $4a0bde56d1b17de8$export$1f6b71a6b4bb1d3f,
        payload: {
            issueId: issueId,
            issueSummary: issueSummary
        }
    });
const $4a0bde56d1b17de8$export$f15f4813e6a1098b = 'state.actions.issue.parent.ADD_ISSUE_PARENT';
const $4a0bde56d1b17de8$export$c4c252d1768346ba = ({ issue: issue })=>({
        type: $4a0bde56d1b17de8$export$f15f4813e6a1098b,
        payload: {
            issue: issue
        }
    });

});


parcelRegister("dzWxI", function(module, exports) {

$parcel$export(module.exports, "default", () => $293eba2d146d0727$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $dJl1T = parcelRequire("dJl1T");

var $2Fkae = parcelRequire("2Fkae");

var $i2eOb = parcelRequire("i2eOb");

var $eQEtH = parcelRequire("eQEtH");

var $65C0W = parcelRequire("65C0W");

var $cW3pH = parcelRequire("cW3pH");

var $67Z81 = parcelRequire("67Z81");
function $293eba2d146d0727$export$2e2bcd8739ae039(action$, store) {
    return action$.ofType((0, $cW3pH.WORK_REFRESH_DATA), (0, $65C0W.SOFTWARE_APP_INITIAL_STATE_LOADED), (0, $65C0W.SOFTWARE_APP_LOADED)).switchMap(()=>{
        const state = store.getState();
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        const baseUrl = (0, $67Z81.contextPathSelector)(state);
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const handleError = (location, error)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData(location, error.message, error);
            return (0, $kVLXA.Observable).empty();
        };
        if (isCMPBoard) return (0, $kVLXA.Observable).empty();
        return (0, $2Fkae.fetchExtensionData)(baseUrl, boardId).map((0, $i2eOb.transformOperation)).flatMap((extension)=>(0, $kVLXA.Observable).of((0, $eQEtH.extensionFetchSuccess)(extension))).catch((error)=>handleError('software.extension.operations', error));
    });
}

});
parcelRegister("2Fkae", function(module, exports) {

$parcel$export(module.exports, "fetchExtensionData", () => $e2e93974abf36621$export$5fe98ae96d282610);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $cBLvH = parcelRequire("cBLvH");

var $CFxE9 = parcelRequire("CFxE9");
const $e2e93974abf36621$var$softwareBoardExtensionOperationName = 'SoftwareBoardExtension';
const $e2e93974abf36621$export$1d6e6c1cef4b8fcc = (boardId)=>`query ${$e2e93974abf36621$var$softwareBoardExtensionOperationName} {
        boardScope(boardId:${boardId}) {
            board {
                id
                extension {
                    operations {
                        icon {
                           url
                        }
                        name
                        url
                        tooltip
                        styleClass
                    } 
                }
            }
        }
    }`;
function $e2e93974abf36621$export$5fe98ae96d282610(contextPath, boardId) {
    return (0, $cBLvH.query$)(contextPath, $e2e93974abf36621$var$softwareBoardExtensionOperationName, $e2e93974abf36621$export$1d6e6c1cef4b8fcc(boardId), (0, $CFxE9.loadExtensionAnalyticsOptions)).flatMap((data)=>(0, $kVLXA.Observable).of(data.boardScope.board));
}

});

parcelRegister("i2eOb", function(module, exports) {

$parcel$export(module.exports, "transformOperation", () => $7c3d15bee26bc2d5$export$4f3f7df1b558c729);
const $7c3d15bee26bc2d5$export$4f3f7df1b558c729 = (boardGQLExtension)=>{
    const operations = boardGQLExtension.extension ? boardGQLExtension.extension.operations.map((op)=>({
            icon: {
                url: op.icon && op.icon.url
            },
            name: op.name,
            url: op.url,
            tooltip: op.tooltip,
            styleClass: op.styleClass
        })) : [];
    return {
        operations: operations
    };
};

});

parcelRegister("eQEtH", function(module, exports) {

$parcel$export(module.exports, "EXTENSION_FETCH_SUCCESS", () => $459dc97ab913f41a$export$4b80f261a964f809);
$parcel$export(module.exports, "extensionFetchSuccess", () => $459dc97ab913f41a$export$12037fbc95e2254d);
const $459dc97ab913f41a$export$4b80f261a964f809 = 'state.actions.extension.EXTENSION_FETCH_SUCCESS';
const $459dc97ab913f41a$export$12037fbc95e2254d = (extension)=>({
        type: $459dc97ab913f41a$export$4b80f261a964f809,
        payload: {
            extension: extension
        }
    });

});


parcelRegister("EGoh4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ae057d5dada39ef$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("1oQta");
parcelRequire("zjDln");
parcelRequire("fPS7b");

var $dnW4F = parcelRequire("dnW4F");

var $5mTgl = parcelRequire("5mTgl");
const $3ae057d5dada39ef$var$makeFilter = (state)=>(0, $5mTgl.isBoardConfigLoaded)(state) && (0, $5mTgl.isCurrentUserLoaded)(state) && (0, $5mTgl.hasInvalidFilterValuesSelector)(state);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3ae057d5dada39ef$export$2e2bcd8739ae039 = (action$, store)=>action$.filter(()=>$3ae057d5dada39ef$var$makeFilter(store.getState())).mergeMap(()=>(0, $kVLXA.Observable).from([
            (0, $dnW4F.setAllFilters)((0, $5mTgl.validFilterValuesSelector)(store.getState()))
        ]));

});

parcelRegister("4FKf7", function(module, exports) {

$parcel$export(module.exports, "filteredCardsEpic", () => $2dee44e6dc4514e3$export$e2f185e35a8c9054);

var $e1AU2 = parcelRequire("e1AU2");

var $g9fl7 = parcelRequire("g9fl7");

var $20mkj = parcelRequire("20mkj");
const $2dee44e6dc4514e3$export$e2f185e35a8c9054 = (0, $e1AU2.combineEpics)((0, $g9fl7.filteredCardsRequestEpic), (0, $20mkj.refilterRequestEpic));

});
parcelRegister("g9fl7", function(module, exports) {

$parcel$export(module.exports, "filteredCardsRequestEpic", () => $02472c74f2c2db57$export$ee8377ae46706014);

var $kVLXA = parcelRequire("kVLXA");

var $hSQIY = parcelRequire("hSQIY");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("jFVZ1");
parcelRequire("eSGL3");
parcelRequire("3awJm");
parcelRequire("6cbqE");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $dJl1T = parcelRequire("dJl1T");


var $iuuJH = parcelRequire("iuuJH");

var $8KZbe = parcelRequire("8KZbe");

var $hdmw1 = parcelRequire("hdmw1");

var $d1i1b = parcelRequire("d1i1b");

var $cY26q = parcelRequire("cY26q");

var $dnW4F = parcelRequire("dnW4F");

var $k50Aq = parcelRequire("k50Aq");

var $vAfHD = parcelRequire("vAfHD");

var $45cXl = parcelRequire("45cXl");

var $6c7Tw = parcelRequire("6c7Tw");
const $02472c74f2c2db57$var$handleFilterCards = (action, store)=>{
    const state = store.getState();
    const ctx = (0, $hdmw1.makeServiceContext)(state);
    const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
    // If you have JQL swimlanes, you ALWAYS fetch the data even when clearing the filters
    const mustForciblyRefreshSwimlanesOnClear = ctx.isCMPBoard && swimlaneMode === (0, $iuuJH.SWIMLANE_BY_JQL).id;
    if (!mustForciblyRefreshSwimlanesOnClear && action.meta.filterType !== (0, $dcff40112356dfc1$export$68d693c35a8d8866)) return (0, $kVLXA.Observable).of((0, $d1i1b.cardAutoScrollRequestOnFilter)());
    const customFilterIds = action.payload?.filters[0, $dcff40112356dfc1$export$68d693c35a8d8866] || [];
    const hasCustomFilters = customFilterIds && customFilterIds.length;
    if (!mustForciblyRefreshSwimlanesOnClear && !hasCustomFilters) return (0, $kVLXA.Observable).from([
        (0, $cY26q.clearFilteredCards)(),
        (0, $d1i1b.cardAutoScrollRequestOnFilter)()
    ]);
    const issueIds = (0, $vAfHD.boardOrderedIssueIdsSelector)(state);
    const { analyticsEvent: analyticsEvent } = action.meta;
    const setLoading$ = mustForciblyRefreshSwimlanesOnClear ? (0, $kVLXA.Observable).of((0, $dnW4F.customFilterForceRefreshStart)()) : (0, $kVLXA.Observable).empty();
    const request$ = (0, $8KZbe.fetchFilteredCardIds)(ctx, {
        issueIds: issueIds,
        customFilterIds: customFilterIds
    }).mergeMap(({ cardIds: cardIds, jqlSwimlanes: jqlSwimlanes })=>{
        // Always fire the action for success or the Loading animation will always play
        const actions = [
            (0, $cY26q.filteredCardsSuccess)(cardIds.map((id)=>`${id}`), customFilterIds.length, issueIds.length, analyticsEvent)
        ];
        if (!mustForciblyRefreshSwimlanesOnClear) actions.push((0, $d1i1b.cardAutoScrollRequestOnFilter)());
        if (ctx.isCMPBoard) actions.push((0, $k50Aq.swimlaneJqlSetDataRequest)(jqlSwimlanes ?? []));
        return (0, $kVLXA.Observable).from(actions);
    }).catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('board.filtered-cards.failure', 'Fail to filter cards with custom filters on board', error);
        return (0, $kVLXA.Observable).of((0, $cY26q.filteredCardsFailed)(error, analyticsEvent), (0, $dnW4F.setAllFilters)({}));
    });
    return (0, $kVLXA.Observable).concat(setLoading$, request$);
};
const $02472c74f2c2db57$export$ee8377ae46706014 = (action$, store)=>action$.ofType((0, $dnW4F.SET_ALL_FILTERS)).throttleTime((0, $6c7Tw.getCustomFiltersDebounceTime)(), (0, $hSQIY.async), {
        leading: true,
        trailing: true
    }).switchMap((action)=>$02472c74f2c2db57$var$handleFilterCards(action, store));

});
parcelRegister("8KZbe", function(module, exports) {

$parcel$export(module.exports, "fetchFilteredCardIds", () => $1e3a1d2a5c5c391a$export$820b8754a87a4350);
parcelRequire("d0pqD");

var $9EUYU = parcelRequire("9EUYU");

var $duA0Q = parcelRequire("duA0Q");
function $1e3a1d2a5c5c391a$export$820b8754a87a4350(ctx, { issueIds: issueIds, customFilterIds: customFilterIds }) {
    if (ctx.isCMPBoard) return (0, $duA0Q.fetchCMPBoardScopeData)(ctx.boardId, {
        activeQuickFilters: customFilterIds,
        projectType: ctx.projectType
    }).map(({ issues: issues, issueChildren: issueChildren, jqlSwimlanes: jqlSwimlanes })=>{
        const resultSet = new Set([
            ...issues,
            ...issueChildren
        ].map(({ id: id })=>id));
        return {
            cardIds: issueIds.filter((id)=>resultSet.has(id)).map((id)=>String(id)),
            jqlSwimlanes: jqlSwimlanes
        };
    });
    return (0, $9EUYU.fetchTMPFilteredCardIds)({
        boardId: ctx.boardId,
        issueIds: issueIds,
        customFilterIds: customFilterIds
    }).map((cardIds)=>({
            cardIds: cardIds
        }));
}

});
parcelRegister("9EUYU", function(module, exports) {

$parcel$export(module.exports, "fetchTMPFilteredCardIds", () => $d978ffd94d9886f6$export$36fe402b17bbc309);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $cBLvH = parcelRequire("cBLvH");
const $d978ffd94d9886f6$var$filteredCardsQuery = 'FilteredCardIds';
const $d978ffd94d9886f6$export$71eec30d9db46a56 = ()=>`
    query ${$d978ffd94d9886f6$var$filteredCardsQuery} ($boardId: ID!, $issueIds: [ID]!, $customFilterIds: [ID]!) {
        boardScope(boardId: $boardId) {
            filteredCardIds(
                issueIds: $issueIds,
                customFilterIds: $customFilterIds
            )
        }
    }
`;
function $d978ffd94d9886f6$export$36fe402b17bbc309({ boardId: boardId, issueIds: issueIds, customFilterIds: customFilterIds }) {
    return (0, $cBLvH.query$)('', $d978ffd94d9886f6$var$filteredCardsQuery, $d978ffd94d9886f6$export$71eec30d9db46a56(), {
        boardId: boardId,
        issueIds: issueIds,
        customFilterIds: customFilterIds
    }).flatMap(({ boardScope: boardScope })=>(0, $kVLXA.Observable).of(boardScope.filteredCardIds));
}

});

parcelRegister("duA0Q", function(module, exports) {

$parcel$export(module.exports, "fetchCMPBoardScopeData", () => $007589a2fb3ec1c4$export$f28480bd3cf8f969);
parcelRequire("d0pqD");

var $ebyGx = parcelRequire("ebyGx");

var $2vSU6 = parcelRequire("2vSU6");

var $487fd = parcelRequire("487fd");

var $bpHwy = parcelRequire("bpHwy");

var $kjrfP = parcelRequire("kjrfP");
function $007589a2fb3ec1c4$export$f28480bd3cf8f969(boardId, { activeQuickFilters: activeQuickFilters, activeSprints: activeSprints, includeHidden: includeHidden, projectType: projectType = (0, $2vSU6.SOFTWARE_PROJECT), skipExtraFields: skipExtraFields, issueLimit: issueLimit } = {}) {
    const query = {
        moduleKey: 'agile-web-board-service',
        hideCardExtraFields: true,
        onlyUseEpicsFromIssues: true,
        includeHidden: includeHidden,
        skipExtraFields: skipExtraFields,
        skipEtag: true,
        fields: projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) ? [
            'request_type',
            'status'
        ] : undefined,
        operation: 'fetchBoardData',
        issueLimit: issueLimit
    };
    if (activeQuickFilters && activeQuickFilters.length) // When you pass an array, we convert the query string into:
    // ? activeQuickFilters=1&activeQuickFilters=21
    // But unfortunately the monolith endpoint only supports CSV for this query parameter.
    query.activeQuickFilters = activeQuickFilters.join(',');
    if (activeSprints && activeSprints.length) query.activeSprints = activeSprints;
    const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query);
    return (0, $487fd.default)(`/rest/boards/latest/board/${boardId}?${queryStr}`).map((json)=>{
        // Refresh the board cache if we are fetching all issues (eg, no filters applied)
        if (includeHidden || !(query.activeQuickFilters || query.activeSprints)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $bpHwy.refreshUIFBoardData)(boardId, json);
        return (0, $kjrfP.transformMobileResponse)(json);
    });
}

});
parcelRegister("bpHwy", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBoardData", () => $620843ca516c403b$export$240c6c415d37cd75);
$parcel$export(module.exports, "refreshUIFBoardData", () => $620843ca516c403b$export$f34cbc63057c38be);
$parcel$export(module.exports, "fetchUIFBacklogData", () => $620843ca516c403b$export$60a4d33615c60f8);
$parcel$export(module.exports, "refreshUIFBacklogData", () => $620843ca516c403b$export$69efc1d2bf5ce2ae);

var $jywXF = parcelRequire("jywXF");

var $cRqmM = parcelRequire("cRqmM");

var $l8SKN = parcelRequire("l8SKN");

var $c1BZi = parcelRequire("c1BZi");
async function $620843ca516c403b$export$240c6c415d37cd75(params) {
    const { cachedPromise: cachedPromise, refreshPromise: refreshPromise } = (0, $c1BZi.fetchUIFBoardDataStream)(params);
    const refreshResult = refreshPromise.then((value)=>({
            value: value,
            type: 'refresh'
        }));
    const { value: result, type: type } = await Promise.race([
        cachedPromise.then((value)=>value != null ? {
                value: value,
                type: 'cache'
            } : refreshResult),
        refreshResult
    ]);
    const isCacheHit = type === 'cache';
    return {
        result: result,
        refresh: isCacheHit ? refreshPromise : null,
        isCacheHit: isCacheHit
    };
}
async function $620843ca516c403b$export$f34cbc63057c38be(boardId, response) {
    (0, $l8SKN.setBoardCachedEntry)({
        boardId: boardId
    }, {
        timestamp: Date.now(),
        etag: response.etag,
        data: response
    });
}
async function $620843ca516c403b$export$60a4d33615c60f8(boardId, queryParameters) {
    const { cachedPromise: cachedPromise, requestPromise: requestPromise } = (0, $jywXF.fetchUIFBacklogData)(boardId, queryParameters);
    const refreshResult = requestPromise.then((response)=>{
        $620843ca516c403b$export$69efc1d2bf5ce2ae(boardId, response);
        return {
            result: response,
            type: 'refresh'
        };
    });
    const { result: result, type: type } = await Promise.race([
        cachedPromise.then((cachedResult)=>cachedResult != null ? {
                result: cachedResult.data,
                type: 'cache'
            } : refreshResult),
        refreshResult
    ]);
    const isCacheHit = type === 'cache';
    return {
        result: result,
        refresh: type === 'cache' ? requestPromise : null,
        isCacheHit: isCacheHit
    };
}
function $620843ca516c403b$export$69efc1d2bf5ce2ae(boardId, response) {
    return (0, $cRqmM.setBacklogCachedEntry)(boardId, {
        timestamp: Date.now(),
        data: response
    });
}

});
parcelRegister("jywXF", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBacklogDataOld", () => $b625b9c23407900e$export$df49ad631c58a3f6);
$parcel$export(module.exports, "fetchUIFBacklogData", () => $b625b9c23407900e$export$60a4d33615c60f8);
$parcel$export(module.exports, "runUIFBacklogEarlyScript", () => $b625b9c23407900e$export$a0c2e05a12ae5621);

var $ebyGx = parcelRequire("ebyGx");

var $tcn7E = parcelRequire("tcn7E");


var $x9xyg = parcelRequire("x9xyg");

var $l83Uu = parcelRequire("l83Uu");

var $dO0aE = parcelRequire("dO0aE");

var $4R6GH = parcelRequire("4R6GH");

var $eKonk = parcelRequire("eKonk");

var $cRqmM = parcelRequire("cRqmM");

var $aBK23 = parcelRequire("aBK23");

var $hUQ5s = parcelRequire("hUQ5s");
// Removing isIndexedDBCachingEnabledForBacklog will make this obsolete.
let $b625b9c23407900e$var$backlogResponsePromise;
let $b625b9c23407900e$var$backlogResponse = null;
const $b625b9c23407900e$export$b08a6e96e3de5356 = (response)=>{
    $b625b9c23407900e$var$backlogResponsePromise = response;
};
const $b625b9c23407900e$export$592ab10c6cb9d596 = ()=>{
    const response = $b625b9c23407900e$var$backlogResponsePromise;
    $b625b9c23407900e$var$backlogResponsePromise = null;
    return response;
};
const $b625b9c23407900e$export$55e9294018933a18 = (response)=>{
    $b625b9c23407900e$var$backlogResponse = response;
};
const $b625b9c23407900e$export$b55ab086f6a0c481 = ()=>{
    const response = $b625b9c23407900e$var$backlogResponse;
    $b625b9c23407900e$var$backlogResponse = null;
    return response;
};
const $b625b9c23407900e$var$onEnd = ()=>{
    (0, $x9xyg.setMark)('uif-backlog-fetch-end');
    (0, $x9xyg.setMeasure)('uif-backlog-fetch/request', 'uif-backlog-fetch-start-request', 'uif-backlog-fetch-end');
    (0, $x9xyg.setMeasure)('uif-backlog-fetch', 'uif-backlog-fetch-start', 'uif-backlog-fetch-end');
};
const $b625b9c23407900e$export$df49ad631c58a3f6 = async (boardId, queryParameters)=>{
    const earlyScriptResponse = $b625b9c23407900e$export$592ab10c6cb9d596();
    if (earlyScriptResponse) return earlyScriptResponse;
    (0, $x9xyg.setMark)('uif-backlog-fetch-start');
    const fetchUIFBacklogDataParams = (0, $hUQ5s.buildPlanDataFetchOptions)(boardId, queryParameters);
    const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(fetchUIFBacklogDataParams);
    (0, $x9xyg.setMark)('uif-backlog-fetch-start-request');
    const backlogDataUrl = `/rest/greenhopper/1.0/xboard/plan/v2/backlog/data?${queryStr}`;
    const enhancedCapabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)((0, $281cbd47ba46dd7d$export$571692eec8a399e1));
    const headers = {
        ...enhancedCapabilityHeader ? {
            'X-Atlassian-Capability': enhancedCapabilityHeader
        } : {}
    };
    Object.assign(headers, (0, $tcn7E.getActiveTraceHttpRequestHeaders)(backlogDataUrl));
    const res = await fetch(backlogDataUrl, {
        headers: headers
    });
    const json = await res.json().catch(()=>null);
    if (!res.ok) {
        $b625b9c23407900e$var$onEnd();
        const traceId = (0, $l83Uu.getTraceId)(res);
        const message = (0, $aBK23.extractErrorMessage)(json);
        if (traceId) throw new (0, $dO0aE.FetchError)(res.status, message, traceId);
        else throw new (0, $dO0aE.FetchError)(res.status, message);
    }
    $b625b9c23407900e$var$onEnd();
    return json;
};
const $b625b9c23407900e$export$60a4d33615c60f8 = (boardId, queryParameters)=>{
    const earlyScriptResponse = $b625b9c23407900e$export$b55ab086f6a0c481();
    if (earlyScriptResponse) return earlyScriptResponse;
    const requestPromise = (async ()=>{
        (0, $x9xyg.setMark)('uif-backlog-fetch-start');
        const fetchUIFBacklogDataParams = (0, $hUQ5s.buildPlanDataFetchOptions)(boardId, queryParameters);
        const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(fetchUIFBacklogDataParams);
        (0, $x9xyg.setMark)('uif-backlog-fetch-start-request');
        const backlogDataUrl = `/rest/greenhopper/1.0/xboard/plan/v2/backlog/data?${queryStr}`;
        const enhancedCapabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)((0, $281cbd47ba46dd7d$export$571692eec8a399e1));
        const headers = {
            ...enhancedCapabilityHeader ? {
                'X-Atlassian-Capability': enhancedCapabilityHeader
            } : {}
        };
        Object.assign(headers, (0, $tcn7E.getActiveTraceHttpRequestHeaders)(backlogDataUrl));
        const res = await fetch(backlogDataUrl, {
            headers: headers
        });
        const json = await res.json().catch(()=>null);
        if (!res.ok) {
            $b625b9c23407900e$var$onEnd();
            const traceId = (0, $l83Uu.getTraceId)(res);
            const message = (0, $aBK23.extractErrorMessage)(json);
            if (traceId) throw new (0, $dO0aE.FetchError)(res.status, message, traceId);
            else throw new (0, $dO0aE.FetchError)(res.status, message);
        }
        $b625b9c23407900e$var$onEnd();
        return json;
    })();
    const cachedPromise = (0, $cRqmM.getBacklogCachedEntry)(boardId);
    return {
        requestPromise: requestPromise,
        cachedPromise: cachedPromise
    };
};
function $b625b9c23407900e$export$a0c2e05a12ae5621(location) {
    const parsedResult = (0, $aBK23.parseBacklogLocation)(location);
    if (!parsedResult) return false;
    const { boardId: boardId, queryParameters: queryParameters } = parsedResult;
    if ((0, $4R6GH.fg)('indexeddb_cache_for_backlog')) {
        const backlogData = $b625b9c23407900e$export$60a4d33615c60f8(boardId, queryParameters);
        $b625b9c23407900e$export$55e9294018933a18(backlogData);
    } else {
        const backlogData = $b625b9c23407900e$export$df49ad631c58a3f6(boardId, queryParameters);
        $b625b9c23407900e$export$b08a6e96e3de5356(backlogData);
    }
    return true;
}

});
const $281cbd47ba46dd7d$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $281cbd47ba46dd7d$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $281cbd47ba46dd7d$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $281cbd47ba46dd7d$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$6d592df97fba16ca = 'GIN_GLOBAL_ISSUE_NAVIGATOR';
const $281cbd47ba46dd7d$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $281cbd47ba46dd7d$export$4695c1a423ffe431 = 'DASHBOARD';
const $281cbd47ba46dd7d$export$4ce203fc8c0eb2d1 = 'ISSUE_MOVE';
const $281cbd47ba46dd7d$export$49d57bef9ac2550b = 'GLOBAL_ISSUE_CREATE';
const $281cbd47ba46dd7d$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $281cbd47ba46dd7d$export$9a80695e72849f84 = 'X-Atlassian-Capability';

parcelRegister("dO0aE", function(module, exports) {

$parcel$export(module.exports, "FetchError", () => $7345e390d0c3a088$export$26e841bcf1aeb894);
$parcel$export(module.exports, "ResponseNullError", () => $7345e390d0c3a088$export$895e385291c3b753);
/* eslint-disable max-classes-per-file */ class $7345e390d0c3a088$var$ExtensibleError extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message, options);
        this.message = message;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
class $7345e390d0c3a088$export$26e841bcf1aeb894 extends $7345e390d0c3a088$var$ExtensibleError {
    constructor(statusCode, message, traceId){
        super(message == null ? `Fetch call failed with status code: ${statusCode}` : message);
        this.graphQLErrors = [];
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.networkError = {
            statusCode: statusCode
        };
        this.skipSentry = true;
        if (traceId != null) this.traceId = traceId;
    }
}
class $7345e390d0c3a088$export$895e385291c3b753 extends $7345e390d0c3a088$var$ExtensibleError {
    constructor(message){
        super(message);
        this.name = 'ResponseNullError';
        this.skipSentry = true;
    }
}

});

parcelRegister("cRqmM", function(module, exports) {

$parcel$export(module.exports, "setBacklogCachedEntry", () => $31c19adcc162b6bc$export$a9fe76d96b47f80a);
$parcel$export(module.exports, "getBacklogCachedEntry", () => $31c19adcc162b6bc$export$d01cbd23f4b0c290);

var $sn9QA = parcelRequire("sn9QA");

var $2FZUH = parcelRequire("2FZUH");
const $31c19adcc162b6bc$export$1ba4f312a27970c1 = (0, $sn9QA.createIndexedDBStorageProvider)('cmp-backlog');
async function $31c19adcc162b6bc$export$a9fe76d96b47f80a(boardId, entry) {
    if (!entry.data.localDeviceCacheEnabled) {
        $31c19adcc162b6bc$export$1ba4f312a27970c1.clearAll();
        return Promise.resolve();
    }
    const key = (0, $2FZUH.buildCachedEntryKey)(boardId);
    return $31c19adcc162b6bc$export$1ba4f312a27970c1.set(key, entry);
}
async function $31c19adcc162b6bc$export$d01cbd23f4b0c290(boardId) {
    const key = (0, $2FZUH.buildCachedEntryKey)(boardId);
    try {
        const entry = await $31c19adcc162b6bc$export$1ba4f312a27970c1.get(key);
        if (!entry) return null;
        if (!(0, $2FZUH.isValid)(entry)) {
            await $31c19adcc162b6bc$export$1ba4f312a27970c1.remove(key);
            return null;
        }
        return entry;
    } catch (err) {
        return null;
    }
}

});
parcelRegister("sn9QA", function(module, exports) {

$parcel$export(module.exports, "createIndexedDBStorageProvider", () => $cf3437e9474a0e2b$export$6ba36c4f5fb8919d);

var $gJBT6 = parcelRequire("gJBT6");

var $8vEj7 = parcelRequire("8vEj7");
const $cf3437e9474a0e2b$export$6ba36c4f5fb8919d = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix, options)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const provider = (0, $8vEj7.createStorageProvider)(appPrefix);
    if (options?.shouldAutoReconnect) return (0, $8vEj7.withAutoReconnect)(provider);
    return provider;
});

});
parcelRegister("8vEj7", function(module, exports) {

$parcel$export(module.exports, "createStorageProvider", () => $33b8db71261fb346$export$8441605555fbd60c);
$parcel$export(module.exports, "withAutoReconnect", () => $33b8db71261fb346$export$8432fe49db7d8865);

var $jIIX7 = parcelRequire("jIIX7");
const $33b8db71261fb346$export$7382f85ef4ff4314 = (prefix, key)=>`${prefix.replace(/_*$/, '')}__${key || ''}`;
const $33b8db71261fb346$var$createCustomStore = ()=>(0, $jIIX7.createStore)('keyval-store', 'keyval');
let $33b8db71261fb346$var$customStore;
const $33b8db71261fb346$var$getStore = ()=>{
    let store = $33b8db71261fb346$var$customStore;
    if (!store) {
        $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
        store = $33b8db71261fb346$var$customStore;
    }
    return store;
};
const $33b8db71261fb346$export$8441605555fbd60c = (appPrefix)=>{
    const KEYS_STORE_PREFIX = $33b8db71261fb346$export$7382f85ef4ff4314(appPrefix);
    const prefix = (key)=>$33b8db71261fb346$export$7382f85ef4ff4314(appPrefix, key);
    // Runtime check to ensure a key is provided as the prefix without a key
    // holds an array of all the keys that are prefixed by this store
    const assertKey = (key)=>{
        if (!key) throw Error('You must provide a key');
    };
    // Calling `clearAll` would require us to iterate over every key in the
    // indexed-db, filtering by this instance's prefix and subsequently deleting
    // all the filtered keys. As indexed-db gains traction within Jira, this
    // will quickly become an expensive operation. To counteract this, we
    // instead store all the keys that this instance has created so that when it
    // comes time to clear them all, we simply just have to clear every key in
    // this store. This removes the need for iterating and filtering all
    // together.
    const updateStoreKeys = async (key, remove = false)=>(0, $jIIX7.update)(KEYS_STORE_PREFIX, (currentKeys)=>{
            const storeKeys = new Set(currentKeys);
            if (remove) {
                storeKeys.delete(key);
                return Array.from(storeKeys.values());
            }
            storeKeys.add(key);
            return Array.from(storeKeys.values());
        }, $33b8db71261fb346$var$getStore());
    return {
        async get (key) {
            assertKey(key);
            return (0, $jIIX7.get)(prefix(key), $33b8db71261fb346$var$getStore());
        },
        async remove (key) {
            assertKey(key);
            const prefixedKey = prefix(key);
            await (0, $jIIX7.del)(prefixedKey, $33b8db71261fb346$var$getStore());
            return updateStoreKeys(prefixedKey, true);
        },
        async clearAll () {
            const prefixedKeys = await (0, $jIIX7.get)(KEYS_STORE_PREFIX, $33b8db71261fb346$var$getStore());
            if (!prefixedKeys || prefixedKeys.length === 0) return undefined;
            return (0, $jIIX7.delMany)(prefixedKeys.concat(KEYS_STORE_PREFIX));
        },
        async set (key, value) {
            assertKey(key);
            const prefixedKey = prefix(key);
            if (typeof value === 'function') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            (0, $jIIX7.update)(prefixedKey, value);
            else (0, $jIIX7.set)(prefixedKey, value, $33b8db71261fb346$var$getStore());
            return updateStoreKeys(prefixedKey);
        },
        async reconnect () {
            $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
        }
    };
};
const $33b8db71261fb346$export$8432fe49db7d8865 = (storageProvider)=>({
        async get (...args) {
            try {
                return await storageProvider.get(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.get(...args);
                }
                throw e;
            }
        },
        async set (...args) {
            try {
                return await storageProvider.set(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.set(...args);
                }
                throw e;
            }
        },
        async remove (...args) {
            try {
                return await storageProvider.remove(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.remove(...args);
                }
                throw e;
            }
        },
        async clearAll (...args) {
            try {
                return await storageProvider.clearAll(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.clearAll(...args);
                }
                throw e;
            }
        },
        async reconnect () {
            await storageProvider.reconnect?.();
        }
    });

});
parcelRegister("jIIX7", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $e5b4ff07e835609c$export$f51a9068ac82ea43);
$parcel$export(module.exports, "get", () => $e5b4ff07e835609c$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $e5b4ff07e835609c$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "update", () => $e5b4ff07e835609c$export$722fbec263ad908a);
$parcel$export(module.exports, "del", () => $e5b4ff07e835609c$export$1d2f21e549771e67);
$parcel$export(module.exports, "delMany", () => $e5b4ff07e835609c$export$c8aa84257229cac8);
function $e5b4ff07e835609c$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $e5b4ff07e835609c$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $e5b4ff07e835609c$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $e5b4ff07e835609c$var$defaultGetStoreFunc;
function $e5b4ff07e835609c$var$defaultGetStore() {
    if (!$e5b4ff07e835609c$var$defaultGetStoreFunc) $e5b4ff07e835609c$var$defaultGetStoreFunc = $e5b4ff07e835609c$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $e5b4ff07e835609c$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$3988ae62b71be9a3(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$adaa4cf7ef1b65be(key, value, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$daa0a5170277c7a8(entries, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$5df405cccea42673(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$722fbec263ad908a(key, updater, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($e5b4ff07e835609c$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$1d2f21e549771e67(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$c8aa84257229cac8(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$42ffd38884aecdac(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
function $e5b4ff07e835609c$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$ed97f33186d4b816(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$68c286be0e7e55b7(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAll());
        const items = [];
        return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$3e9f948b41964866(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys()),
            $e5b4ff07e835609c$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore('readonly', (store)=>$e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}

});



parcelRegister("2FZUH", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $ec6817f630f9a6c9$export$1ea939691cdc45b8);
$parcel$export(module.exports, "getAccountId", () => $ec6817f630f9a6c9$export$c1e0336bde96e2dc);
$parcel$export(module.exports, "buildCachedEntryKey", () => $ec6817f630f9a6c9$export$59c82678f286b00f);

var $8QpSo = parcelRequire("8QpSo");

var $sn9QA = parcelRequire("sn9QA");

var $co1wz = parcelRequire("co1wz");
const $ec6817f630f9a6c9$var$EXPIRATION_TIME_OLD = 86400000; // 1 day
const $ec6817f630f9a6c9$var$EXPIRATION_TIME = 259200000; // 3 days
const $ec6817f630f9a6c9$var$extendExpirationTime = ()=>(0, $co1wz.ff)('jsw.perf.local-device-cache-extend-expiery_seg8y');
function $ec6817f630f9a6c9$export$1ea939691cdc45b8(cachedDataEntry) {
    const timeDelta = Date.now() - cachedDataEntry.timestamp;
    const expirationTime = $ec6817f630f9a6c9$var$extendExpirationTime() ? $ec6817f630f9a6c9$var$EXPIRATION_TIME : $ec6817f630f9a6c9$var$EXPIRATION_TIME_OLD;
    return timeDelta < expirationTime;
}
const $ec6817f630f9a6c9$export$c1e0336bde96e2dc = (0, $8QpSo.default)(()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const el = document.querySelector('meta[name="ajs-atlassian-account-id"]');
    return el?.getAttribute('content') ?? null;
});
function $ec6817f630f9a6c9$export$59c82678f286b00f(boardId) {
    const accountId = $ec6817f630f9a6c9$export$c1e0336bde96e2dc() ?? 'no-account-id';
    return `local-device-cache::${accountId}::${boardId}`;
}
const $ec6817f630f9a6c9$export$cc1314e9c2424f02 = (0, $sn9QA.createIndexedDBStorageProvider)('labs-preferences');

});


parcelRegister("aBK23", function(module, exports) {

$parcel$export(module.exports, "convertQuickFiltersToString", () => $2271887588c9e1ef$export$4f216f9114f89403);
$parcel$export(module.exports, "getCachedQuickFilters", () => $2271887588c9e1ef$export$e59cda69449c77c2);
$parcel$export(module.exports, "parseBoardLocation", () => $2271887588c9e1ef$export$97471107364bd76c);
$parcel$export(module.exports, "parseBacklogLocation", () => $2271887588c9e1ef$export$be59cb299ab0331c);
$parcel$export(module.exports, "extractErrorMessage", () => $2271887588c9e1ef$export$8cc545829c7461b0);
$parcel$export(module.exports, "View", () => $2271887588c9e1ef$export$27a5bd065ad55220);
$parcel$export(module.exports, "getViewSettings", () => $2271887588c9e1ef$export$3ae70db4a97563c);

var $ebyGx = parcelRequire("ebyGx");

var $cYeCp = parcelRequire("cYeCp");
const $2271887588c9e1ef$var$SOFTWARE_BOARD_REGEX = /\/jira\/software\/c\/?projects\/\w+\/boards\/(\d+)\/?(\?.*)?$/;
const $2271887588c9e1ef$var$USER_LOCATED_BOARD_REGEX = /\/jira\/people\/[^/]+\/boards\/(\d+)\/?(\?.*)?$/;
// people/project match needs to consider `...:...` ids
const $2271887588c9e1ef$var$SOFTWARE_BACKLOG_REGEX = /\/jira\/(?:software\/c\/)?(?:projects|people)\/[^/]+\/boards\/(\d+)\/backlog\/?(\?.*)?$/;
const $2271887588c9e1ef$var$parsePath = (pathname, pattern)=>{
    const match = pattern.exec(pathname);
    if (!match) return null;
    const boardId = match[1];
    return {
        boardId: Number(boardId)
    };
};
const $2271887588c9e1ef$export$4f216f9114f89403 = (queryParameters)=>{
    // Terminate early for the null/undefined cases
    if (!queryParameters?.quickFilter) return undefined; // This is safe to return as it means the query string will just be excluded
    if (!Array.isArray(queryParameters.quickFilter)) {
        // If for whatever reason an object gets in here
        if (typeof queryParameters.quickFilter === 'object') // Fail gracefully
        return undefined;
        // Ensure that the value is a number
        if (Number.isNaN(Number(queryParameters.quickFilter))) return undefined;
        // this isn't an array. It's probably a string or number which is fine to return as is.
        return `${queryParameters.quickFilter}`;
    }
    // Array passed in is the common case
    // If it is empty, don't include it at all.
    if (queryParameters.quickFilter.length === 0) return undefined;
    return queryParameters.quickFilter.filter((val)=>Number.isInteger(Number(val))).join(',');
};
const $2271887588c9e1ef$export$e59cda69449c77c2 = (feature, boardId)=>{
    const cachedFilters = localStorage.getItem(`__storejs_software_${feature}-filters.${boardId}`);
    if (!cachedFilters) return undefined;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { CUSTOM_FILTER: cachedQuickFilters } = JSON.parse(cachedFilters);
    return cachedQuickFilters && cachedQuickFilters.length > 0 ? cachedQuickFilters.join(',') : undefined;
};
const $2271887588c9e1ef$export$97471107364bd76c = ({ pathname: pathname, search: search })=>{
    const parsedPath = $2271887588c9e1ef$var$parsePath(pathname, $2271887588c9e1ef$var$SOFTWARE_BOARD_REGEX) ?? $2271887588c9e1ef$var$parsePath(pathname, $2271887588c9e1ef$var$USER_LOCATED_BOARD_REGEX);
    if (!parsedPath) return null;
    const queryStringParameters = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search) ?? {};
    // Early termination if the quick filter isnt a part of the query string
    if (!queryStringParameters.quickFilter) return {
        ...parsedPath
    };
    // Guarantee that the quick filter will be returned as an array. This helps with typing further upstream
    const quickFilterArray = Array.isArray(queryStringParameters.quickFilter) ? queryStringParameters.quickFilter : [
        queryStringParameters.quickFilter
    ];
    return {
        ...parsedPath,
        queryParameters: {
            quickFilter: quickFilterArray
        }
    };
};
const $2271887588c9e1ef$export$be59cb299ab0331c = ({ pathname: pathname, search: search })=>{
    const parsedPath = $2271887588c9e1ef$var$parsePath(pathname, $2271887588c9e1ef$var$SOFTWARE_BACKLOG_REGEX);
    if (!parsedPath) return null;
    return {
        ...parsedPath,
        queryParameters: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search) ?? {}
    };
};
const $2271887588c9e1ef$var$isErrorMessagesResponse = (json)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    json?.errorMessages instanceof Array;
const $2271887588c9e1ef$export$8cc545829c7461b0 = (json)=>{
    if ($2271887588c9e1ef$var$isErrorMessagesResponse(json)) {
        const { errorMessages: errorMessages } = json;
        return errorMessages.length ? errorMessages.join(', ') : undefined;
    }
    return undefined;
};
/* Copied from jira/src/packages/software/view-settings/src/services/local-storage/index.tsx
 to reduce bundle size by using native localStorage */ const $2271887588c9e1ef$var$VIEW_SETTINGS = 'view-settings';
const $2271887588c9e1ef$var$VIEW_SETTINGS_LOCAL_STORAGE = 'jira-software-view-settings';
const $2271887588c9e1ef$export$27a5bd065ad55220 = {
    BACKLOG: 'jsw-backlog',
    BOARD: 'jsw-board',
    INCREMENT_PLANNING_BOARD: 'increment-planning-board',
    JSM_BOARD: 'jsm-board'
};
const $2271887588c9e1ef$export$36e24695f02d4503 = (view)=>{
    if (view && view === $2271887588c9e1ef$export$27a5bd065ad55220.INCREMENT_PLANNING_BOARD) return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.INCREMENT_PLANNING_BOARD}`;
    if ((0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) switch(view){
        case $2271887588c9e1ef$export$27a5bd065ad55220.INCREMENT_PLANNING_BOARD:
            return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.INCREMENT_PLANNING_BOARD}`;
        case $2271887588c9e1ef$export$27a5bd065ad55220.BACKLOG:
            return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.BACKLOG}`;
        case $2271887588c9e1ef$export$27a5bd065ad55220.BOARD:
            return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.BOARD}`;
        case $2271887588c9e1ef$export$27a5bd065ad55220.JSM_BOARD:
            return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.JSM_BOARD}`;
        default:
            return $2271887588c9e1ef$var$VIEW_SETTINGS;
    }
    return $2271887588c9e1ef$var$VIEW_SETTINGS;
};
const $2271887588c9e1ef$export$3ae70db4a97563c = ({ boardId: boardId, view: view })=>{
    /**
	 * This usage is excluded via package exclusion in jira/ratcheting-rules.tsx
	 * Because it is only a READ Operation, and reads are not blocked in compliant APIs.
	 * This read will be tracked via a compliant API read in following code
	 * - Initializing view-settings panel on board: jira/src/packages/software/view-settings/src/ui/index.tsx
	 * - rendering cards on the board (Implementatin In Progress https://hello.jira.atlassian.cloud/browse/PNDR-1926)
	 * More context in this discussion: https://atlassian.slack.com/archives/C02785CLSTW/p1722822320190909
	 */ const viewSettingStorageValue = localStorage.getItem(`__storejs_${$2271887588c9e1ef$var$VIEW_SETTINGS_LOCAL_STORAGE}_${$2271887588c9e1ef$export$36e24695f02d4503(view)}-${boardId}`) || // return legacy view settings if prefixed storage doesn't exist
    localStorage.getItem(`__storejs_${$2271887588c9e1ef$var$VIEW_SETTINGS_LOCAL_STORAGE}_${$2271887588c9e1ef$var$VIEW_SETTINGS}-${boardId}`);
    return JSON.parse(viewSettingStorageValue ?? 'null');
};

});
parcelRegister("cYeCp", function(module, exports) {

$parcel$export(module.exports, "parseSearchQuery", () => $e84c24ee8b7a736a$export$6298490de4ddc3eb);
$parcel$export(module.exports, "setPanels", () => $e84c24ee8b7a736a$export$d89c07c704083e54);
$parcel$export(module.exports, "parseSearchQueryForIPBoard", () => $e84c24ee8b7a736a$export$442a6f7c9ee1c18a);
$parcel$export(module.exports, "setIncrementPlanningSettingsQuery", () => $e84c24ee8b7a736a$export$8bc567645273ba46);
$parcel$export(module.exports, "isViewSettingsPanelAndTailoredViewExperimentEnabled", () => $e84c24ee8b7a736a$export$eed360eb853808ee);

var $7uUwQ = parcelRequire("7uUwQ");

var $ebyGx = parcelRequire("ebyGx");

var $4R6GH = parcelRequire("4R6GH");

const $e84c24ee8b7a736a$export$6298490de4ddc3eb = (search)=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search);
    return {
        EPIC_PANEL: searchParams[0, $2634c0a33984ecbe$export$ec3c43b997309252] === 'visible',
        VERSION_PANEL: searchParams[0, $2634c0a33984ecbe$export$a86c1a6dde9da34f] === 'visible'
    };
};
const $e84c24ee8b7a736a$export$d89c07c704083e54 = (panels, location)=>{
    const search = (0, $7uUwQ.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search)
    });
    search.unset((0, $2634c0a33984ecbe$export$ec3c43b997309252));
    search.unset((0, $2634c0a33984ecbe$export$a86c1a6dde9da34f));
    if (panels.EPIC_PANEL) search.set((0, $2634c0a33984ecbe$export$ec3c43b997309252), 'visible');
    if (panels.VERSION_PANEL) search.set((0, $2634c0a33984ecbe$export$a86c1a6dde9da34f), 'visible');
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(search.value())
    };
};
const $e84c24ee8b7a736a$export$442a6f7c9ee1c18a = (search)=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search);
    if (!(0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) return {
        SHOW_UNSCHEDULED_COLUMN: searchParams[0, $2634c0a33984ecbe$export$bfa26a3d2f080ac5] === 'hidden' ? false : undefined,
        SHOW_OFFTRACK_DEPENDENCY_LINES: false,
        ISSUE_IDS_TO_SHOW_DEPENDENCIES: []
    };
    const issuesQuery = searchParams[0, $2634c0a33984ecbe$export$1692762d83d78f09] ? decodeURIComponent(searchParams[0, $2634c0a33984ecbe$export$1692762d83d78f09]) : undefined;
    const issuesSplit = issuesQuery ? issuesQuery.split(',') : [];
    const issueIdsToShowDependencies = [];
    issuesSplit.forEach((issueId)=>{
        const trimmedIssueId = issueId.trim();
        if (trimmedIssueId.length) issueIdsToShowDependencies.push(trimmedIssueId);
    });
    return {
        SHOW_UNSCHEDULED_COLUMN: searchParams[0, $2634c0a33984ecbe$export$bfa26a3d2f080ac5] === 'hidden' ? false : undefined,
        SHOW_OFFTRACK_DEPENDENCY_LINES: searchParams[0, $2634c0a33984ecbe$export$8b0819c4fa234ad] === 'visible' ? true : undefined,
        ISSUE_IDS_TO_SHOW_DEPENDENCIES: issueIdsToShowDependencies
    };
};
const $e84c24ee8b7a736a$export$8bc567645273ba46 = (incrementPlanningSettings, location)=>{
    const search = (0, $7uUwQ.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search)
    });
    search.unset((0, $2634c0a33984ecbe$export$bfa26a3d2f080ac5));
    if (!incrementPlanningSettings.SHOW_UNSCHEDULED_COLUMN) search.set((0, $2634c0a33984ecbe$export$bfa26a3d2f080ac5), 'hidden');
    if ((0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) {
        search.unset((0, $2634c0a33984ecbe$export$8b0819c4fa234ad));
        search.unset((0, $2634c0a33984ecbe$export$1692762d83d78f09));
        if (incrementPlanningSettings.SHOW_OFFTRACK_DEPENDENCY_LINES) search.set((0, $2634c0a33984ecbe$export$8b0819c4fa234ad), 'visible');
        if (incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES && incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES.length) search.set((0, $2634c0a33984ecbe$export$1692762d83d78f09), encodeURIComponent(incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES.toString()));
    }
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(search.value())
    };
};
const $e84c24ee8b7a736a$export$eed360eb853808ee = ()=>(0, $4R6GH.fg)('jira_view_settings_additional_fields');

});
const $2634c0a33984ecbe$export$ec3c43b997309252 = 'epics';
const $2634c0a33984ecbe$export$a86c1a6dde9da34f = 'versions';
const $2634c0a33984ecbe$export$bfa26a3d2f080ac5 = 'unscheduledWork';
const $2634c0a33984ecbe$export$8b0819c4fa234ad = 'showOfftrackDependencyLines';
const $2634c0a33984ecbe$export$1692762d83d78f09 = 'issueIdsToShowDependencies';



parcelRegister("hUQ5s", function(module, exports) {

$parcel$export(module.exports, "buildPlanDataFetchOptions", () => $f874c35ef69356eb$export$dab2d96649ebf00a);

var $aBK23 = parcelRequire("aBK23");
const $f874c35ef69356eb$export$68c4c1e22c91f23f = 'fetchBacklogData';
const $f874c35ef69356eb$var$parseActiveQuickFilters = (queryParameters, boardId)=>{
    if (queryParameters?.customFilter && typeof queryParameters?.customFilter === 'string') return queryParameters.customFilter.split(',');
    return (0, $aBK23.getCachedQuickFilters)('backlog', boardId)?.split(',');
};
const $f874c35ef69356eb$export$dab2d96649ebf00a = (boardId, queryParameters)=>({
        rapidViewId: boardId,
        forceConsistency: queryParameters?.forceConsistency ? /true/i.test(String(queryParameters.forceConsistency)) : true,
        activeQuickFilters: $f874c35ef69356eb$var$parseActiveQuickFilters(queryParameters, boardId),
        operation: $f874c35ef69356eb$export$68c4c1e22c91f23f
    });

});


parcelRegister("l8SKN", function(module, exports) {

$parcel$export(module.exports, "setBoardCachedEntry", () => $378b724625452625$export$ce85349d82f1217c);
$parcel$export(module.exports, "getBoardCachedEntry", () => $378b724625452625$export$992aa38aa2da87a4);

var $sn9QA = parcelRequire("sn9QA");

var $x9xyg = parcelRequire("x9xyg");

var $2FZUH = parcelRequire("2FZUH");
const $378b724625452625$export$13bc140835202cda = (0, $sn9QA.createIndexedDBStorageProvider)('cmp-board');
function $378b724625452625$export$4c715dd110bf64d2({ boardId: boardId, accountId: accountId, queryParameters: queryParameters }) {
    const params = [
        accountId,
        boardId
    ];
    if (queryParameters) params.push(JSON.stringify(queryParameters));
    const paramString = params.join('::');
    return `local-device-cache::${paramString}`;
}
async function $378b724625452625$export$ce85349d82f1217c({ boardId: boardId, queryParameters: queryParameters }, entry) {
    if (!entry.data.localDeviceCacheEnabled) {
        $378b724625452625$export$13bc140835202cda.clearAll();
        return Promise.resolve();
    }
    const accountId = (0, $2FZUH.getAccountId)() ?? 'no-account-id';
    const key = $378b724625452625$export$4c715dd110bf64d2({
        boardId: boardId,
        accountId: accountId,
        queryParameters: queryParameters
    });
    return $378b724625452625$export$13bc140835202cda.set(key, entry);
}
async function $378b724625452625$export$992aa38aa2da87a4({ boardId: boardId, queryParameters: queryParameters }) {
    const accountId = (0, $2FZUH.getAccountId)() ?? 'no-account-id';
    const cacheKey = $378b724625452625$export$4c715dd110bf64d2({
        boardId: boardId,
        accountId: accountId,
        queryParameters: queryParameters
    });
    try {
        (0, $x9xyg.setMark)('uif-board-fetch-read-cache-start');
        const entry = await $378b724625452625$export$13bc140835202cda.get(cacheKey);
        if (entry) (0, $x9xyg.setMark)('uif-board-fetch-read-cache-end');
        else return null;
        if (!(0, $2FZUH.isValid)(entry)) {
            await $378b724625452625$export$13bc140835202cda.remove(cacheKey);
            return null;
        }
        return entry;
    } catch (err) {
        return null;
    }
}

});

parcelRegister("c1BZi", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBoardDataStream", () => $8173307478a42629$export$92fdd848ddb362ed);

var $dO0aE = parcelRequire("dO0aE");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $d4P1V = parcelRequire("d4P1V");

var $l8SKN = parcelRequire("l8SKN");
function $8173307478a42629$export$92fdd848ddb362ed({ boardId: boardId, queryParameters: queryParameters, fields: fields }) {
    const { cachedPromise: cachedBoardData, promise: promise } = (0, $d4P1V.fetchUIFBoardData)({
        boardId: boardId,
        queryParameters: queryParameters,
        fields: fields
    });
    const cachedPromise = cachedBoardData.then((cache)=>cache?.data ?? null);
    const refreshPromise = (async ()=>{
        const response = await promise;
        if ((0, $co1wz.ff)('jsw.cmp.response-null-abort') && !response) {
            if ((0, $4R6GH.fg)('skip_responsenullerror_on_sentry')) throw new (0, $dO0aE.ResponseNullError)('CMP fetchUIFBoardData returned null');
            const error = new Error('CMP fetchUIFBoardData returned null');
            error.name = 'ResponseNullError';
            throw error;
        }
        (0, $l8SKN.setBoardCachedEntry)({
            boardId: boardId
        }, {
            timestamp: Date.now(),
            etag: response.etag,
            data: response
        });
        return response;
    })();
    return {
        cachedPromise: cachedPromise,
        refreshPromise: refreshPromise
    };
}

});
parcelRegister("d4P1V", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBoardData", () => $29c6e7c438197219$export$240c6c415d37cd75);
$parcel$export(module.exports, "runUIFBoardEarlyScript", () => $29c6e7c438197219$export$4c749dee5e4e8bc6);

var $ebyGx = parcelRequire("ebyGx");

var $tcn7E = parcelRequire("tcn7E");


var $x9xyg = parcelRequire("x9xyg");

var $l83Uu = parcelRequire("l83Uu");

var $dO0aE = parcelRequire("dO0aE");

var $4R6GH = parcelRequire("4R6GH");

var $eKonk = parcelRequire("eKonk");

var $l8SKN = parcelRequire("l8SKN");

var $aBK23 = parcelRequire("aBK23");
const $29c6e7c438197219$export$5aec1fe89a336a5d = 'fetchBoardData';
let $29c6e7c438197219$var$combinedBoardPromises = null;
function $29c6e7c438197219$var$putBoardEarlyScriptResponse(promises) {
    $29c6e7c438197219$var$combinedBoardPromises = promises;
}
function $29c6e7c438197219$export$1601e80f8f15c5cd() {
    const promises = $29c6e7c438197219$var$combinedBoardPromises;
    $29c6e7c438197219$var$combinedBoardPromises = null;
    return promises;
}
function $29c6e7c438197219$export$3b583d36792fd1ab(boardId) {
    const isCardCoversToggled = (0, $aBK23.getViewSettings)({
        boardId: Number(boardId),
        view: (0, $aBK23.View).BOARD
    })?.showCardCovers;
    if ((0, $4R6GH.fg)('jsw_card_cover_image_default_on')) {
        // If viewSetting isn't set, return skipCardCovers as false by default
        if (isCardCoversToggled === null || isCardCoversToggled === undefined) return false;
    }
    return !isCardCoversToggled;
}
function $29c6e7c438197219$export$240c6c415d37cd75({ boardId: boardId, queryParameters: queryParameters, fields: fields }) {
    // It is important that there is no async operation before this first
    // return block, otherwise we may create a cycle of this fetch with itself.
    const response = $29c6e7c438197219$export$1601e80f8f15c5cd();
    if (response) return response;
    (0, $x9xyg.setMark)('uif-board-fetch-start');
    const query = {
        moduleKey: 'agile-web-board-service',
        hideCardExtraFields: true,
        onlyUseEpicsFromIssues: true,
        skipEtag: true,
        skipExtraFields: true,
        includeHidden: true,
        activeQuickFilters: (0, $aBK23.convertQuickFiltersToString)(queryParameters) ?? (0, $aBK23.getCachedQuickFilters)('board', boardId),
        fields: fields,
        operation: $29c6e7c438197219$export$5aec1fe89a336a5d,
        ...(0, $4R6GH.fg)('jsw_cmp_card_cover_images') ? {
            skipCardCovers: $29c6e7c438197219$export$3b583d36792fd1ab(boardId)
        } : {}
    };
    const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query);
    (0, $x9xyg.setMark)('uif-board-fetch-start-request');
    const boardDataUrl = `/rest/boards/latest/board/${boardId}?${queryStr}`;
    const capabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)((0, $281cbd47ba46dd7d$export$664edf77d4c76110));
    const headers = {
        ...capabilityHeader ? {
            'X-Atlassian-Capability': capabilityHeader
        } : {}
    };
    Object.assign(headers, (0, $tcn7E.getActiveTraceHttpRequestHeaders)(boardDataUrl));
    const cachedPromise = (0, $l8SKN.getBoardCachedEntry)({
        boardId: boardId
    });
    const promise = fetch(boardDataUrl, {
        headers: headers
    }).then(async (res)=>{
        const json = await res.json().catch(()=>null);
        (0, $x9xyg.setMark)('uif-board-fetch-end');
        (0, $x9xyg.setMeasure)('uif-board-fetch/request', 'uif-board-fetch-start-request', 'uif-board-fetch-end');
        (0, $x9xyg.setMeasure)('uif-board-fetch', 'uif-board-fetch-start', 'uif-board-fetch-end');
        if (!res.ok) {
            const traceId = (0, $l83Uu.getTraceId)(res);
            const message = (0, $aBK23.extractErrorMessage)(json);
            if (traceId) throw new (0, $dO0aE.FetchError)(res.status, message, traceId);
            else throw new (0, $dO0aE.FetchError)(res.status, message);
        }
        return json;
    });
    return {
        cachedPromise: cachedPromise,
        promise: promise
    };
}
function $29c6e7c438197219$export$4c749dee5e4e8bc6(location) {
    const parsedResult = (0, $aBK23.parseBoardLocation)(location);
    if (!parsedResult) return false;
    $29c6e7c438197219$var$putBoardEarlyScriptResponse($29c6e7c438197219$export$240c6c415d37cd75(parsedResult));
    return true;
}

});



parcelRegister("kjrfP", function(module, exports) {

$parcel$export(module.exports, "transformMobileResponse", () => $ab45c064a6f47d86$export$811bc00fcb931acd);

var $fn8B5 = parcelRequire("fn8B5");

var $gccSB = parcelRequire("gccSB");

var $4Xk2W = parcelRequire("4Xk2W");

var $5rFbt = parcelRequire("5rFbt");

var $gULOk = parcelRequire("gULOk");

var $x9xyg = parcelRequire("x9xyg");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $kFsv3 = parcelRequire("kFsv3");

var $g4tDr = parcelRequire("g4tDr");

var $iuuJH = parcelRequire("iuuJH");

var $9qXMi = parcelRequire("9qXMi");

var $8qfoo = parcelRequire("8qfoo");
function $ab45c064a6f47d86$export$227473965d2e27db(mobileResponse) {
    return Object.values(mobileResponse.projects).map((project)=>{
        const { id: id, name: name, key: key, avatar: avatar, permissions: permissions, projectTypeKey: projectTypeKey, canRank: canRank } = project;
        return {
            id: id,
            name: name,
            key: key,
            avatar: avatar,
            permissions: permissions,
            projectTypeKey: projectTypeKey,
            canRank: canRank
        };
    });
}
const $ab45c064a6f47d86$var$GHX_TO_EPIC_COLOR = {
    'ghx-label-1': 'DARK_GREY',
    'ghx-label-2': 'DARK_YELLOW',
    'ghx-label-3': 'YELLOW',
    'ghx-label-4': 'DARK_BLUE',
    'ghx-label-5': 'DARK_TEAL',
    'ghx-label-6': 'GREEN',
    'ghx-label-7': 'PURPLE',
    'ghx-label-8': 'DARK_PURPLE',
    'ghx-label-9': 'ORANGE',
    'ghx-label-10': 'BLUE',
    'ghx-label-11': 'TEAL',
    'ghx-label-12': 'GREY',
    'ghx-label-13': 'DARK_GREEN',
    'ghx-label-14': 'DARK_ORANGE'
};
function $ab45c064a6f47d86$export$a718b06ed585fbab(color) {
    return $ab45c064a6f47d86$var$GHX_TO_EPIC_COLOR[color] ?? (0, $kFsv3.PURPLE);
}
function $ab45c064a6f47d86$var$isValidEpicColor(color) {
    const colorsAsStrings = (0, $kFsv3.COLORS);
    return colorsAsStrings.includes(color);
}
function $ab45c064a6f47d86$export$e8d914406885ae13(color) {
    if (!color) return 0, $kFsv3.PURPLE;
    const upperCaseColor = color?.toUpperCase();
    return $ab45c064a6f47d86$var$isValidEpicColor(upperCaseColor) ? upperCaseColor : (0, $kFsv3.PURPLE);
}
function $ab45c064a6f47d86$export$dbdfe6bbd9575fbb(mobileResponse) {
    return mobileResponse.epicIssues.map((epic)=>({
            id: epic.id,
            key: epic.key,
            // This might be okay to remove when https://app.launchdarkly.com/jira/staging/features/epic-related-fields-deprecation-main-flag_plni4/targeting
            // is fully rolled-out.
            summary: epic.summary || epic.epicName,
            status: epic.status ? $ab45c064a6f47d86$export$95f71e2e6b5bd102(epic.status) : undefined,
            issueType: {
                id: String(epic.issueType.id),
                iconUrl: epic.issueType.iconUrl,
                name: epic.issueType.name,
                hierarchyLevel: epic.issueType.hierarchyLevel
            },
            color: (0, $co1wz.ff)('jsw.epic-panel.return-non-system-epics') ? $ab45c064a6f47d86$export$e8d914406885ae13(epic.color) : $ab45c064a6f47d86$export$a718b06ed585fbab(epic.color),
            flagged: epic.flagged
        }));
}
function $ab45c064a6f47d86$export$4c05e2584b34e4d8(mobileResponse) {
    return Object.keys(mobileResponse.issueTypes).map((issueTypeId)=>{
        const issueType = mobileResponse.issueTypes[issueTypeId];
        return {
            id: String(issueType.id),
            name: issueType.name,
            iconUrl: issueType.iconUrl,
            hierarchyLevelType: (0, $g4tDr.getHierarchyLevelType)(issueType.hierarchyLevel),
            default: issueType.default,
            // TODO: Missing issue type required fields and description
            hasRequiredFields: false,
            // so messy type, why is this required? crying....
            description: 'WHAT'
        };
    });
}
function $ab45c064a6f47d86$export$d3b8217e83b5a13c(mobileResponse) {
    return Object.keys(mobileResponse.requestTypes).map((requestTypeId)=>{
        const { id: id, name: name, iconUrl: iconUrl } = mobileResponse.requestTypes[requestTypeId];
        return {
            id: id,
            name: name,
            iconUrl: iconUrl
        };
    });
}
function $ab45c064a6f47d86$export$95f71e2e6b5bd102(mobileStatus) {
    return {
        id: Number(mobileStatus.id),
        name: mobileStatus.name,
        category: (0, $gULOk.statusCategoryForId)(mobileStatus.statusCategory.id)
    };
}
function $ab45c064a6f47d86$export$20a57a5ec025f2d(mobileResponse) {
    return Object.values(mobileResponse.statuses).map((status)=>$ab45c064a6f47d86$export$95f71e2e6b5bd102(status));
}
function $ab45c064a6f47d86$export$afdec38cdd10abc(mobileResponse) {
    const transitionsByIssueType = {};
    Object.values(mobileResponse.projects).forEach((project)=>{
        Object.keys(project.transitionsPerIssueType).forEach((key)=>{
            if (!transitionsByIssueType[key]) transitionsByIssueType[key] = [];
            transitionsByIssueType[key].push(...project.transitionsPerIssueType[key]);
        });
    });
    return transitionsByIssueType;
}
function $ab45c064a6f47d86$export$22390684d5fb6120(mobileResponse) {
    const allStatuses = mobileResponse.columns.flatMap((column)=>column.statuses);
    const statusesById = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(allStatuses, 'id');
    const transitionsByIssueType = $ab45c064a6f47d86$export$afdec38cdd10abc(mobileResponse);
    const issueTypeStatus = {};
    Object.keys(mobileResponse.issueTypes).forEach((issueTypeId)=>{
        const issueType = mobileResponse.issueTypes[issueTypeId];
        const transitions = transitionsByIssueType[issueType.id];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        issueTypeStatus[issueType.id] = {};
        transitions?.forEach((transition)=>{
            const status = statusesById[transition.toStatusId];
            if (!status) return;
            issueTypeStatus[issueType.id][transition.toStatusId] = {
                id: Number(status.id),
                name: status.name,
                category: (0, $gULOk.statusCategoryForId)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                (0, $gULOk.StatusCategoryIds)[status.statusCategory.key])
            };
        });
    });
    return issueTypeStatus;
}
function $ab45c064a6f47d86$export$a769014d580cbcab(column, transitionsByDestinationStatus) {
    const current = {};
    // The status ID here is a destination status ID, is there any reason to map
    // it against transitions by the source
    column.statusIds.forEach((statusId)=>{
        const transitions = [
            ...transitionsByDestinationStatus[statusId] || []
        ];
        transitions.forEach(({ issueTypeId: issueTypeId, transition: transition, projectKey: projectKey })=>{
            if (!current[issueTypeId]) current[issueTypeId] = [];
            // Don't allow duplicates if they have the same transition ID, project key and
            // source/destination status.
            // In JSM, it is entirely possible for transitions to have the same ID but different
            // source and destination statuses.
            // For CMP boards you can have multiple boards per project
            if (current[issueTypeId].some((issueTransition)=>issueTransition.id === transition.transitionId && issueTransition.projectKey === projectKey && issueTransition.sourceStatusId === Number(transition.fromStatusId) && issueTransition.destinationStatusId === Number(transition.toStatusId))) // transition already added to issueTypeId, avoid duplicate entry
            return;
            current[issueTypeId].push({
                id: transition.transitionId,
                name: transition.name,
                sourceStatusId: Number(transition.fromStatusId),
                destinationStatusId: Number(transition.toStatusId),
                isGlobal: transition.global,
                isInitial: transition.initial,
                hasConditions: transition.hasConditions,
                hasScreen: transition.hasScreen,
                projectKey: projectKey
            });
        });
    });
    return current;
}
function $ab45c064a6f47d86$export$b3d38447b0b164cc(mobileResponse) {
    // Note this contains duplicate entries for the same transitions if they
    // appear on multiple projects.
    const allTransitions = Object.values(mobileResponse.projects).flatMap((project)=>Object.keys(project.transitionsPerIssueType).flatMap((issueTypeId)=>project.transitionsPerIssueType[issueTypeId].map((transition)=>({
                    transition: transition,
                    issueTypeId: issueTypeId,
                    projectKey: project.key
                }))));
    const transitionsByDestinationStatus = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(allTransitions, (t)=>t.transition.toStatusId);
    const columnIssueTypeTransitions = {};
    mobileResponse.columns.forEach((column)=>{
        const current = $ab45c064a6f47d86$export$a769014d580cbcab(column, transitionsByDestinationStatus);
        columnIssueTypeTransitions[column.id] = current;
    });
    return columnIssueTypeTransitions;
}
function $ab45c064a6f47d86$export$fa6ea2b1c2da21b8(mobileResponse) {
    const issueTypeStatus = $ab45c064a6f47d86$export$22390684d5fb6120(mobileResponse);
    const columnIssueTypeTransitions = $ab45c064a6f47d86$export$b3d38447b0b164cc(mobileResponse);
    const cardTransitions = {
        columnIssueTypeTransitions: columnIssueTypeTransitions,
        issueTypeStatus: issueTypeStatus
    };
    return cardTransitions;
}
function $ab45c064a6f47d86$export$6e8deebce7129a99(mobileResponse, columnTransitions) {
    const isColumnConstraintSet = mobileResponse.statisticsConfig?.typeId && mobileResponse.statisticsConfig.typeId !== 'none';
    return mobileResponse.columns.map((column)=>({
            type: (0, $5rFbt.ColumnType).STATUS,
            id: column.id,
            maxIssueCount: isColumnConstraintSet ? column.maxLimit ?? null : null,
            minIssueCount: isColumnConstraintSet ? column.minLimit ?? null : null,
            limitJql: column.limitJql,
            name: column.name,
            statuses: column.statuses.map((status)=>{
                const category = (0, $gULOk.statusCategoryForId)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                (0, $gULOk.StatusCategoryIds)[status.statusCategory.key]);
                return {
                    id: Number(status.id),
                    name: status.name,
                    category: category,
                    isDone: category === (0, $gULOk.DONE),
                    isInitial: Object.values(columnTransitions[column.id]).flatMap((t)=>t).some(({ isInitial: isInitial })=>isInitial)
                };
            })
        }));
}
function $ab45c064a6f47d86$export$6a33be7fc7f04943(mobileResponse) {
    return mobileResponse.sprints?.map((sprint)=>({
            id: sprint.id,
            name: sprint.name,
            startDate: sprint.isoStartDate,
            endDate: sprint.isoEndDate,
            canUpdateSprint: sprint.canUpdateSprint,
            daysRemaining: sprint.daysRemaining,
            goal: sprint.goal,
            state: sprint.state
        })) ?? [];
}
const $ab45c064a6f47d86$var$CMP_SWIMLANE_STRATEGY_TO_UIF_ID = {
    assignee: (0, $iuuJH.SWIMLANE_BY_ASSIGNEE).id,
    assigneeUnassignedFirst: (0, $iuuJH.SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST).id,
    parentChild: (0, $iuuJH.SWIMLANE_BY_SUBTASK).id,
    epic: (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id,
    none: (0, $iuuJH.NO_SWIMLANE).id,
    custom: (0, $iuuJH.SWIMLANE_BY_JQL).id,
    project: (0, $iuuJH.SWIMLANE_BY_PROJECT).id,
    request_type: (0, $iuuJH.SWIMLANE_BY_REQUEST_TYPE).id
};
function $ab45c064a6f47d86$export$cb77b16c47800e8d(swimlaneStrategy) {
    return $ab45c064a6f47d86$var$CMP_SWIMLANE_STRATEGY_TO_UIF_ID[swimlaneStrategy] ?? (0, $iuuJH.NO_SWIMLANE).id;
}
function $ab45c064a6f47d86$export$b9be17218375befc(mobileResponse) {
    return mobileResponse.swimlaneInfo.swimlaneStrategy === 'custom' ? mobileResponse.swimlaneInfo.swimlanes?.map((swimlane)=>({
            id: String(swimlane.id),
            name: swimlane.name,
            query: swimlane.query ?? 'true',
            description: swimlane.description,
            issueIds: swimlane.issueIds,
            isDefaultSwimlane: swimlane.defaultSwimlane
        })) : undefined;
}
const $ab45c064a6f47d86$export$844d7708d71f3c7a = (column)=>column.statuses?.every((status)=>status.statusCategory.key === 'done') || false;
const $ab45c064a6f47d86$export$56ce4f6aa58a4e44 = (issueTypesById, issueTypeId)=>issueTypesById[issueTypeId] != null;
function $ab45c064a6f47d86$export$a26a6de2e9ae64a0(mobileResponse) {
    const epicsByKey = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(mobileResponse.epicIssues, 'key');
    const issueTypesById = mobileResponse.issueTypes;
    const prioritiesById = mobileResponse.priorities;
    const isChildIssueType = (issueTypeId)=>!!mobileResponse.issueTypes[issueTypeId]?.subtask;
    let missingIssueType = '';
    const allIssuesById = new Map(mobileResponse.columns.flatMap((column)=>column.issues.filter((issue)=>{
            const requirement = $ab45c064a6f47d86$export$56ce4f6aa58a4e44(issueTypesById, issue.issueTypeId);
            if (!requirement) missingIssueType = issue.issueTypeId;
            return requirement;
        }).map((issue)=>[
                issue.id,
                (0, $8qfoo.transformIssue)({
                    issue: issue,
                    estimation: mobileResponse.estimation,
                    column: column,
                    epicsByKey: epicsByKey,
                    issueTypesById: issueTypesById,
                    prioritiesById: prioritiesById,
                    sprints: mobileResponse.sprints
                })
            ])));
    const issues = [];
    const issueChildren = [];
    // We also filter out issue ids that are with missing issue types.
    const orderedIssueIds = [];
    mobileResponse.orderedIssueIds.forEach((id)=>{
        const issue = allIssuesById.get(id);
        if (!issue) return;
        if (isChildIssueType(issue.typeId)) issueChildren.push(issue);
        else // This is actually issue + issue parent
        // We need to render epics in CMP board except for swimlane by epic, so issue parents are included here with retaining the order.
        issues.push(issue);
        orderedIssueIds.push(id);
    });
    return {
        issues: issues,
        issueChildren: issueChildren,
        orderedIssueIds: orderedIssueIds,
        missingIssueType: missingIssueType
    };
}
function $ab45c064a6f47d86$export$d43fa2529adfda6d({ typeId: typeId }) {
    switch(typeId){
        case 'issueCount':
            return 'ISSUE_COUNT';
        case 'issueCountExclSubs':
            return 'ISSUE_COUNT_EXCLUDE_SUBTASKS';
        default:
            return undefined;
    }
}
function $ab45c064a6f47d86$export$1f9b32e9db1f9511(mobileResponse) {
    const { missingParents: missingParents } = mobileResponse;
    if (!missingParents) return [];
    return missingParents.map((missingParent)=>{
        const { id: id, key: key, summary: summary, assigneeAccountId: assigneeAccountId, parentId: parentId, typeUrl: typeUrl, status: status, projectId: projectId, typeId: typeId } = missingParent;
        const category = (0, $gULOk.statusCategoryForId)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $gULOk.StatusCategoryIds)[status.statusCategory.key]);
        return {
            id: id,
            key: key,
            summary: summary,
            assigneeAccountId: assigneeAccountId,
            typeUrl: typeUrl,
            parentId: parentId,
            status: {
                id: Number(status.id),
                name: status.name,
                category: category,
                isDone: category === (0, $gULOk.DONE),
                isInitial: false
            },
            projectId: projectId,
            typeId: Number(typeId),
            statusId: Number(status.id)
        };
    });
}
const $ab45c064a6f47d86$export$6e2c69d2f1c0121 = (mobileResponse)=>{
    // for a multi-project CMP boards, check if any of the projects can rank
    const canUserRank = Object.values(mobileResponse.projects).some((project)=>project.canRank);
    return {
        boardIsRankable: mobileResponse.rankable && canUserRank,
        rankCustomFieldId: canUserRank ? Number(mobileResponse.rankingCustomField) : NaN
    };
};
const $ab45c064a6f47d86$export$3f1f00772d9a3cb3 = ({ columns: columns, media: media })=>{
    // We can potentially do nothing if card media is turned off as well
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(columns) || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(media)) return {};
    return columns.flatMap((column)=>column.issues).reduce((map, issue)=>{
        const { cardMedia: cardMedia } = issue;
        if (!cardMedia) return Object.assign(map, {
            [String(issue.id)]: null
        });
        return Object.assign(map, {
            [String(issue.id)]: {
                attachmentId: String(cardMedia.attachmentId),
                attachmentMediaApiId: cardMedia.mediaApiFileId,
                endpointUrl: media?.endpointUrl,
                clientId: media?.clientId,
                isHiddenByUser: false,
                token: cardMedia.mediaReadToken
            }
        });
    }, {});
};
function $ab45c064a6f47d86$export$811bc00fcb931acd(json) {
    return (0, $x9xyg.measureFunc)('uif-board-transformMobileResponse', ()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const mobileResponse = json;
        const { issues: issues, issueChildren: issueChildren, orderedIssueIds: orderedIssueIds, missingIssueType: missingIssueType } = $ab45c064a6f47d86$export$a26a6de2e9ae64a0(mobileResponse);
        const people = Object.values(mobileResponse.people).map((person)=>({
                ...person,
                id: person.accountId
            }));
        const cardTransitions = $ab45c064a6f47d86$export$fa6ea2b1c2da21b8(mobileResponse);
        const columns = $ab45c064a6f47d86$export$6e8deebce7129a99(mobileResponse, cardTransitions.columnIssueTypeTransitions);
        const issueParents = $ab45c064a6f47d86$export$dbdfe6bbd9575fbb(mobileResponse);
        const issueTypes = $ab45c064a6f47d86$export$4c05e2584b34e4d8(mobileResponse);
        const requestTypes = $ab45c064a6f47d86$export$d3b8217e83b5a13c(mobileResponse);
        const statuses = $ab45c064a6f47d86$export$20a57a5ec025f2d(mobileResponse);
        const projects = $ab45c064a6f47d86$export$227473965d2e27db(mobileResponse);
        const capabilities = {
            BACKLOG: mobileResponse.capabilities.BACKLOG.enabled,
            SPRINTS: mobileResponse.capabilities.SPRINTS.enabled,
            REPORTS: mobileResponse.capabilities.REPORTS.enabled,
            ESTIMATION: mobileResponse.capabilities.ESTIMATION.enabled,
            RELEASES: mobileResponse.capabilities.RELEASES.enabled
        };
        const boardConfig = {
            isCardMediaEnabled: false,
            boardIssueListKey: undefined,
            requestColumnMigration: undefined,
            isSprintsEnabled: false,
            isBacklogEnabled: false,
            issuesCountByColumn: {},
            isManageRulesEnabled: false,
            areEpicLabelsHidden: (0, $9qXMi.getHideEpics)(mobileResponse.id),
            columnConstraintType: $ab45c064a6f47d86$export$d43fa2529adfda6d(mobileResponse.statisticsConfig)
        };
        const sprints = $ab45c064a6f47d86$export$6a33be7fc7f04943(mobileResponse);
        return {
            issues: issues,
            people: people,
            projects: projects,
            boardConfig: boardConfig,
            issueMedia: (0, $4R6GH.fg)('jsw_cmp_card_cover_images') ? $ab45c064a6f47d86$export$3f1f00772d9a3cb3(mobileResponse) : {},
            config: $ab45c064a6f47d86$export$6e2c69d2f1c0121(mobileResponse),
            hasFilteredIssues: false,
            columns: columns,
            swimlaneModeId: $ab45c064a6f47d86$export$cb77b16c47800e8d(mobileResponse.swimlaneInfo.swimlaneStrategy),
            sprints: sprints,
            isSprintsEnabled: (sprints?.length ?? 0) > 0,
            boardName: mobileResponse.name,
            capabilities: capabilities,
            issueParents: issueParents,
            issueTypes: issueTypes,
            projectIssueTypes: issueTypes,
            requestTypes: requestTypes,
            statuses: statuses,
            boardPermissions: {
                createIssue: projects[0]?.permissions?.CREATE_ISSUES ?? true,
                // TODO: per issue permissions
                // ! project permissions doesn't include EDIT_ISSUES so will assume create issue at the moment
                editIssue: projects[0]?.permissions?.CREATE_ISSUES ?? true,
                // TODO: per issue permissions???
                deleteIssue: projects[0]?.permissions?.DELETE_ISSUES ?? true,
                ...(0, $co1wz.ff)('issue-unarchival_wdpb9') ? {
                    archiveIssue: projects[0]?.permissions?.ARCHIVE_ISSUES ?? true
                } : {},
                manageSprint: sprints.some((sprint)=>sprint.canUpdateSprint),
                editBoardConfig: mobileResponse.canEdit,
                manageAutomation: true,
                canRelease: mobileResponse.canRelease
            },
            issueChildren: issueChildren,
            cardTransitions: cardTransitions,
            inlineCardCreate: mobileResponse.inlineCardCreate,
            isInlineColumnEditEnabled: mobileResponse.isUsingSimplifiedWorkflow === true,
            // TODO: Missing features
            allFeatures: [
                {
                    key: 'BACKLOG',
                    status: mobileResponse.capabilities.BACKLOG.enabled ? 'ENABLED' : 'DISABLED',
                    toggle: mobileResponse.capabilities.BACKLOG.enabled ? 'ENABLED' : 'DISABLED',
                    category: 'CMP STUFF'
                },
                {
                    key: 'SPRINTS',
                    status: mobileResponse.capabilities.SPRINTS.enabled ? 'ENABLED' : 'DISABLED',
                    toggle: mobileResponse.capabilities.SPRINTS.enabled ? 'ENABLED' : 'DISABLED',
                    category: 'CMP STUFF'
                }
            ],
            // THIS MUST BE NULL
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            estimationStatistic: null,
            customFilters: mobileResponse.filters?.map((filter)=>({
                    id: String(filter.id),
                    name: filter.name,
                    description: filter.description
                })),
            jqlSwimlanes: $ab45c064a6f47d86$export$b9be17218375befc(mobileResponse),
            boardType: mobileResponse.type === 'SCRUM' ? 'SCRUM' : 'KANBAN',
            etag: mobileResponse.etag,
            orderedIssueIds: orderedIssueIds,
            missingParents: $ab45c064a6f47d86$export$1f9b32e9db1f9511(mobileResponse),
            hierarchyNomenclature: mobileResponse?.flexibleNomenclatureData?.levelOneName ? {
                firstLevelName: mobileResponse.flexibleNomenclatureData.levelOneName
            } : null,
            issueLimitExceeded: mobileResponse.issueLimitExceeded,
            savedFilterId: mobileResponse.savedFilterId,
            missingIssueType: missingIssueType
        };
    });
}

});
parcelRegister("kFsv3", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $da8a77f13d52b186$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $da8a77f13d52b186$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $da8a77f13d52b186$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $da8a77f13d52b186$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $da8a77f13d52b186$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $da8a77f13d52b186$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $da8a77f13d52b186$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $da8a77f13d52b186$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $da8a77f13d52b186$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $da8a77f13d52b186$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $da8a77f13d52b186$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $da8a77f13d52b186$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $da8a77f13d52b186$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $da8a77f13d52b186$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $da8a77f13d52b186$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $da8a77f13d52b186$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $da8a77f13d52b186$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $da8a77f13d52b186$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $da8a77f13d52b186$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $da8a77f13d52b186$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $da8a77f13d52b186$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $da8a77f13d52b186$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $da8a77f13d52b186$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $da8a77f13d52b186$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $da8a77f13d52b186$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $da8a77f13d52b186$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $da8a77f13d52b186$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $da8a77f13d52b186$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $da8a77f13d52b186$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $da8a77f13d52b186$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $da8a77f13d52b186$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $da8a77f13d52b186$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $da8a77f13d52b186$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $da8a77f13d52b186$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $da8a77f13d52b186$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $da8a77f13d52b186$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $da8a77f13d52b186$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $da8a77f13d52b186$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $da8a77f13d52b186$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $da8a77f13d52b186$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $da8a77f13d52b186$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $da8a77f13d52b186$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $da8a77f13d52b186$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $da8a77f13d52b186$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $da8a77f13d52b186$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $da8a77f13d52b186$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $da8a77f13d52b186$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $da8a77f13d52b186$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $da8a77f13d52b186$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $da8a77f13d52b186$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $da8a77f13d52b186$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $da8a77f13d52b186$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $da8a77f13d52b186$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $da8a77f13d52b186$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $da8a77f13d52b186$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $da8a77f13d52b186$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $da8a77f13d52b186$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $da8a77f13d52b186$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $da8a77f13d52b186$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $da8a77f13d52b186$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $da8a77f13d52b186$export$4b7407b8700035bd);
/**
 * Color constants
 */ const $da8a77f13d52b186$export$7ffdeca4b2f927a2 = 'PURPLE';
const $da8a77f13d52b186$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $da8a77f13d52b186$export$738c3b9a44c87ecc = 'BLUE';
const $da8a77f13d52b186$export$1225f83626261b80 = 'DARK_BLUE';
const $da8a77f13d52b186$export$48d4b2cd5bc0e88b = 'GREEN';
const $da8a77f13d52b186$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $da8a77f13d52b186$export$d0446fe88325854e = 'TEAL';
const $da8a77f13d52b186$export$bb848c92687e69dc = 'DARK_TEAL';
const $da8a77f13d52b186$export$aab610c505c06a8f = 'YELLOW';
const $da8a77f13d52b186$export$466af87757d343a2 = 'DARK_YELLOW';
const $da8a77f13d52b186$export$3de5e29ed1757f9b = 'ORANGE';
const $da8a77f13d52b186$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $da8a77f13d52b186$export$7d278ca694634874 = 'GREY';
const $da8a77f13d52b186$export$26453300bfc61cb8 = 'DARK_GREY';
const $da8a77f13d52b186$export$56d196d2844d1ca1 = [
    $da8a77f13d52b186$export$7ffdeca4b2f927a2,
    $da8a77f13d52b186$export$c815fe495e8174a0,
    $da8a77f13d52b186$export$738c3b9a44c87ecc,
    $da8a77f13d52b186$export$1225f83626261b80,
    $da8a77f13d52b186$export$48d4b2cd5bc0e88b,
    $da8a77f13d52b186$export$c6f4cf2e5768eb78,
    $da8a77f13d52b186$export$d0446fe88325854e,
    $da8a77f13d52b186$export$bb848c92687e69dc,
    $da8a77f13d52b186$export$aab610c505c06a8f,
    $da8a77f13d52b186$export$466af87757d343a2,
    $da8a77f13d52b186$export$3de5e29ed1757f9b,
    $da8a77f13d52b186$export$da02e4820b6ab753,
    $da8a77f13d52b186$export$7d278ca694634874,
    $da8a77f13d52b186$export$26453300bfc61cb8
];
const $da8a77f13d52b186$export$792af22a0198af8d = 'purple';
const $da8a77f13d52b186$export$588af712afdcb006 = 'dark_purple';
const $da8a77f13d52b186$export$84c4918645391802 = 'blue';
const $da8a77f13d52b186$export$b8f1f5838352a33a = 'dark_blue';
const $da8a77f13d52b186$export$9384b7e350ee6542 = 'green';
const $da8a77f13d52b186$export$87d3fb8d8656d38b = 'dark_green';
const $da8a77f13d52b186$export$b0b4ce3e99e66aae = 'teal';
const $da8a77f13d52b186$export$a89b77a449bd223e = 'dark_teal';
const $da8a77f13d52b186$export$9a33b5e3cde94885 = 'yellow';
const $da8a77f13d52b186$export$33253d7862bceb8a = 'dark_yellow';
const $da8a77f13d52b186$export$6609c2b23fc42f39 = 'orange';
const $da8a77f13d52b186$export$cd994662b5911917 = 'dark_orange';
const $da8a77f13d52b186$export$1793d43e13e078c5 = 'grey';
const $da8a77f13d52b186$export$487a6e9145526564 = 'dark_grey';
const $da8a77f13d52b186$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $da8a77f13d52b186$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $da8a77f13d52b186$export$94ac87c81ed074a7 = 'ghx-label-3';
const $da8a77f13d52b186$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $da8a77f13d52b186$export$610a2c132b6fcf96 = 'ghx-label-5';
const $da8a77f13d52b186$export$8e4997dba71f1c40 = 'ghx-label-6';
const $da8a77f13d52b186$export$18a545b4e69b27b4 = 'ghx-label-7';
const $da8a77f13d52b186$export$27fff1a0d295292a = 'ghx-label-8';
const $da8a77f13d52b186$export$e57aa662a56724e1 = 'ghx-label-9';
const $da8a77f13d52b186$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $da8a77f13d52b186$export$457ecb9560f2bf83 = 'ghx-label-11';
const $da8a77f13d52b186$export$a866db37165a696c = 'ghx-label-12';
const $da8a77f13d52b186$export$9b18447c1168a1b6 = 'ghx-label-13';
const $da8a77f13d52b186$export$93b9ad4020e271b7 = 'ghx-label-14';
const $da8a77f13d52b186$export$5cd2af17b34de3e3 = 'color_1';
const $da8a77f13d52b186$export$987671fa69482a7b = 'color_2';
const $da8a77f13d52b186$export$70ba8a5b1f4c7446 = 'color_3';
const $da8a77f13d52b186$export$fcd1c42d8d3ebd36 = 'color_4';
const $da8a77f13d52b186$export$f80a5bd2fa0ba256 = 'color_5';
const $da8a77f13d52b186$export$37ad5ce8d2aeaf78 = 'color_6';
const $da8a77f13d52b186$export$9dc62d5d151cb355 = 'color_7';
const $da8a77f13d52b186$export$1ed15b30f5663f92 = 'color_8';
const $da8a77f13d52b186$export$5d23a84d55ac1644 = 'color_9';
const $da8a77f13d52b186$export$bf08c9a6ed42e349 = 'color_10';
const $da8a77f13d52b186$export$66c5d8f0b5ff279c = 'color_11';
const $da8a77f13d52b186$export$da30755a37c3a597 = 'color_12';
const $da8a77f13d52b186$export$721cf84faff6bf19 = 'color_13';
const $da8a77f13d52b186$export$4b8f8666bd7b61dd = 'color_14';
const $da8a77f13d52b186$export$c537fa0d021d010b = {
    PURPLE: $da8a77f13d52b186$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $da8a77f13d52b186$export$c815fe495e8174a0,
    BLUE: $da8a77f13d52b186$export$738c3b9a44c87ecc,
    DARK_BLUE: $da8a77f13d52b186$export$1225f83626261b80,
    GREEN: $da8a77f13d52b186$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $da8a77f13d52b186$export$c6f4cf2e5768eb78,
    TEAL: $da8a77f13d52b186$export$d0446fe88325854e,
    DARK_TEAL: $da8a77f13d52b186$export$bb848c92687e69dc,
    YELLOW: $da8a77f13d52b186$export$aab610c505c06a8f,
    DARK_YELLOW: $da8a77f13d52b186$export$466af87757d343a2,
    ORANGE: $da8a77f13d52b186$export$3de5e29ed1757f9b,
    DARK_ORANGE: $da8a77f13d52b186$export$da02e4820b6ab753,
    GREY: $da8a77f13d52b186$export$7d278ca694634874,
    DARK_GREY: $da8a77f13d52b186$export$26453300bfc61cb8
};
const $da8a77f13d52b186$export$d33d39828a18210a = {
    SERVER_PURPLE: $da8a77f13d52b186$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $da8a77f13d52b186$export$588af712afdcb006,
    SERVER_BLUE: $da8a77f13d52b186$export$84c4918645391802,
    SERVER_DARK_BLUE: $da8a77f13d52b186$export$b8f1f5838352a33a,
    SERVER_GREEN: $da8a77f13d52b186$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $da8a77f13d52b186$export$87d3fb8d8656d38b,
    SERVER_TEAL: $da8a77f13d52b186$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $da8a77f13d52b186$export$a89b77a449bd223e,
    SERVER_YELLOW: $da8a77f13d52b186$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $da8a77f13d52b186$export$33253d7862bceb8a,
    SERVER_ORANGE: $da8a77f13d52b186$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $da8a77f13d52b186$export$cd994662b5911917,
    SERVER_GREY: $da8a77f13d52b186$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $da8a77f13d52b186$export$487a6e9145526564
};
const $da8a77f13d52b186$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $da8a77f13d52b186$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $da8a77f13d52b186$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $da8a77f13d52b186$export$94ac87c81ed074a7,
    GHX_LABEL_4: $da8a77f13d52b186$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $da8a77f13d52b186$export$610a2c132b6fcf96,
    GHX_LABEL_6: $da8a77f13d52b186$export$8e4997dba71f1c40,
    GHX_LABEL_7: $da8a77f13d52b186$export$18a545b4e69b27b4,
    GHX_LABEL_8: $da8a77f13d52b186$export$27fff1a0d295292a,
    GHX_LABEL_9: $da8a77f13d52b186$export$e57aa662a56724e1,
    GHX_LABEL_10: $da8a77f13d52b186$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $da8a77f13d52b186$export$457ecb9560f2bf83,
    GHX_LABEL_12: $da8a77f13d52b186$export$a866db37165a696c,
    GHX_LABEL_13: $da8a77f13d52b186$export$9b18447c1168a1b6,
    GHX_LABEL_14: $da8a77f13d52b186$export$93b9ad4020e271b7
};
const $da8a77f13d52b186$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $da8a77f13d52b186$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $da8a77f13d52b186$export$987671fa69482a7b,
    AGILE_COLOR_3: $da8a77f13d52b186$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $da8a77f13d52b186$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $da8a77f13d52b186$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $da8a77f13d52b186$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $da8a77f13d52b186$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $da8a77f13d52b186$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $da8a77f13d52b186$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $da8a77f13d52b186$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $da8a77f13d52b186$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $da8a77f13d52b186$export$da30755a37c3a597,
    AGILE_COLOR_13: $da8a77f13d52b186$export$721cf84faff6bf19,
    AGILE_COLOR_14: $da8a77f13d52b186$export$4b8f8666bd7b61dd
};

});

parcelRegister("9qXMi", function(module, exports) {

$parcel$export(module.exports, "getHideEpics", () => $6ae7dcaa40b8804a$export$344e252cb642fb56);
const $6ae7dcaa40b8804a$var$HIDE_EPICS_KEY_PREFIX = 'gh.epicShownOnRapidBoard.';
function $6ae7dcaa40b8804a$export$344e252cb642fb56(boardId) {
    return localStorage.getItem(`${$6ae7dcaa40b8804a$var$HIDE_EPICS_KEY_PREFIX}${boardId}`) === 'false';
}
function $6ae7dcaa40b8804a$export$c9ac14c6e06788a3(boardId, hideEpics) {
    localStorage.setItem(`${$6ae7dcaa40b8804a$var$HIDE_EPICS_KEY_PREFIX}${boardId}`, (!hideEpics).toString());
}

});

parcelRegister("8qfoo", function(module, exports) {

$parcel$export(module.exports, "transformIssue", () => $1eb32a05a39b2409$export$2d1bde06ef9e2dcc);

var $4R6GH = parcelRequire("4R6GH");



var $9vSWT = parcelRequire("9vSWT");
const $1eb32a05a39b2409$var$ExtraFieldLabelDefaultEmptyValue = 'None';
function $1eb32a05a39b2409$export$e6e327a97512715e(issue, epicsByKey) {
    if (issue.epic) {
        const epicId = epicsByKey[issue.epic.key]?.id ?? null;
        return epicId === issue.id ? null : epicId;
    }
    return issue.subTaskParentId ?? null;
}
function $1eb32a05a39b2409$export$2d1bde06ef9e2dcc({ issue: issue, estimation: estimation, column: column, epicsByKey: epicsByKey, issueTypesById: issueTypesById, prioritiesById: prioritiesById, sprints: sprints }) {
    const labels = [
        ...issue.labels ?? []
    ];
    if (labels.length === 0) {
        const labelsExtraField = issue.fieldEntries?.find((field)=>field.id === (0, $7e733a5d4e4331fc$export$b1cb468c302d21f9));
        if (labelsExtraField && labelsExtraField.renderer === 'text') {
            const fieldLabels = labelsExtraField.text?.split(/,\s*/g) ?? [];
            // If there is exactly one label and it is 'None' we ignore it.
            // This could be a problem if the Customer actually sets None but
            // right now the default value returned via the mobile endpoint is 'None'
            // if it should be empty..
            if (fieldLabels.length > 1 || fieldLabels[0] !== $1eb32a05a39b2409$var$ExtraFieldLabelDefaultEmptyValue) fieldLabels.forEach((label)=>{
                labels.push(label);
            });
        }
    }
    const sprintId = sprints?.find((sprint)=>issue.sprintIds.includes(sprint.id))?.id;
    // All estimate types in CMP considered as CUSTOM_ESTIMATE_FIELD
    const estimate = estimation != null && 'field' in estimation ? {
        type: (0, $b383ed62f6689e0b$export$feb32b877d96492),
        displayName: issue.trackingStatistic ? (0, $9vSWT.messages).remainingTimeEstimate : estimation.field.displayName,
        fieldId: issue.trackingStatistic?.statFieldId ?? estimation.field.fieldId,
        value: issue.trackingStatistic?.statFieldValue.text ?? issue.estimation
    } : null;
    const daysInColumnSourceMillis = (issue.cumulativeTimeInColumnMillis ?? 0) + (issue.currentTimeInColumnMillis ?? 0);
    const dueDate = issue.dueDate && (0, $4R6GH.fg)('jsw_cmp_show_due_date_by_default') ? issue.dueDate : null;
    return {
        id: issue.id,
        key: issue.key,
        summary: issue.summary,
        statusId: Number(issue.statusId),
        requestTypeId: issue.requestTypeId,
        columnId: column.id,
        projectId: Number(issue.projectId),
        parentId: $1eb32a05a39b2409$export$e6e327a97512715e(issue, epicsByKey),
        typeId: Number(issue.issueTypeId),
        typeName: issueTypesById[issue.issueTypeId].name,
        typeUrl: issueTypesById[issue.issueTypeId].iconUrl,
        assigneeAccountId: issue.assigneeAccountId,
        isFlagged: issue.flagged,
        priority: issue.priorityId ? {
            name: prioritiesById[issue.priorityId]?.name,
            iconUrl: prioritiesById[issue.priorityId]?.iconUrl
        } : null,
        daysInColumn: daysInColumnSourceMillis != null ? daysInColumnSourceMillis / 86400000 : null,
        extraFields: issue.fieldEntries,
        cardColor: issue.cardColor,
        labels: labels,
        estimate: estimate,
        isDone: issue.isResolved ?? false,
        sprintId: sprintId != null ? String(sprintId) : 'none',
        dueDate: dueDate,
        // TODO: Missing children stats
        numCompleteChildren: 0,
        numTotalChildren: 0,
        // These are not a problem to be missing
        swimlaneId: undefined,
        devStatus: undefined,
        fixVersions: issue.fixVersions,
        isVisible: issue.isVisible ?? true
    };
}

});
parcelRegister("9vSWT", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ff1e0f2420a6273f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $ff1e0f2420a6273f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    remainingTimeEstimate: {
        "id": "software.main.services.board-scope-graphql.non-critical.mobile-rest.transformer.issue.remaining-time-estimate",
        "defaultMessage": "{value} Remaining Time Estimate"
    }
});

});





parcelRegister("6c7Tw", function(module, exports) {

$parcel$export(module.exports, "getCustomFiltersDebounceTime", () => $eca1f60956407533$export$2ecac126a7851701);
const $eca1f60956407533$export$2ecac126a7851701 = ()=>500;

});


parcelRegister("20mkj", function(module, exports) {

$parcel$export(module.exports, "refilterRequestEpic", () => $1e902e1d2484cde0$export$12fb76cfeb5c0ed2);
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("8n054");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("1oQta");
parcelRequire("6cbqE");

var $k8IPx = parcelRequire("k8IPx");

var $1sXeC = parcelRequire("1sXeC");

var $kVLXA = parcelRequire("kVLXA");

var $icZql = parcelRequire("icZql");

var $7aklh = parcelRequire("7aklh");

var $dJl1T = parcelRequire("dJl1T");


var $8KZbe = parcelRequire("8KZbe");

var $hdmw1 = parcelRequire("hdmw1");

var $cY26q = parcelRequire("cY26q");

var $bkCF5 = parcelRequire("bkCF5");

var $d315K = parcelRequire("d315K");

var $8yiLS = parcelRequire("8yiLS");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $6c7Tw = parcelRequire("6c7Tw");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $1e902e1d2484cde0$var$isActiveTab = ()=>!document.hidden;
const $1e902e1d2484cde0$var$isCurrentUser = (state, action)=>(0, $67Z81.currentUserAccountIdSelector)(state) === action.payload.event.payload.atlassianId;
// The realtime provider returns board scope issue events as well as the issue
// created and updated events when the FF is enabled. The BSI updated event
// will be used for refreshing the board but the issue create/updated events
// are here ONLY for custom filter support
const $1e902e1d2484cde0$var$isIssueEvent = (action)=>action.payload.event.type === (0, $09d938f04e8899c4$export$b22a14d5dac59664) || action.payload.event.type === (0, $09d938f04e8899c4$export$b22142e61b3fdbee);
const $1e902e1d2484cde0$export$12fb76cfeb5c0ed2 = (action$, store)=>{
    const refilterAction$ = action$.ofType((0, $d315K.REALTIME_DISPATCH_EVENT)).filter($1e902e1d2484cde0$var$isActiveTab).filter($1e902e1d2484cde0$var$isIssueEvent).filter(()=>(0, $8yiLS.isCustomFiltersActive)(store.getState())).filter((action)=>$1e902e1d2484cde0$var$isCurrentUser(store.getState(), action));
    let debouncedActions = [];
    const newRefilterAction$ = refilterAction$.pipe((0, $icZql.buffer)(refilterAction$.pipe((0, $7aklh.debounce)((valueRaw)=>{
        // Saving debounced actions to be check if create flag should be shown
        debouncedActions.push(valueRaw);
        return (0, $kVLXA.Observable).timer((0, $6c7Tw.getCustomFiltersDebounceTime)());
    }))));
    return newRefilterAction$.switchMap((actions)=>{
        const state = store.getState();
        const customFilterIds = (0, $8yiLS.getActiveCustomFilterIds)(state);
        const isCreatedIssue = (cardId)=>debouncedActions.some((action)=>'issueId' in action.payload.event.payload && action.payload.event.payload.issueId === cardId && action.payload.event.type === (0, $09d938f04e8899c4$export$b22a14d5dac59664));
        const issueIds = [
            // remove duplicates via Set
            ...new Set(actions.map((action)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const payload = action.payload.event.payload;
                return payload.issueId;
            }))
        ];
        const ctx = (0, $hdmw1.makeServiceContext)(state);
        return (0, $8KZbe.fetchFilteredCardIds)(ctx, {
            issueIds: issueIds,
            customFilterIds: customFilterIds
        }).mergeMap(({ cardIds: cardIds })=>{
            const filteredCardIds = cardIds?.map((cardId)=>(0, (/*@__PURE__*/$parcel$interopDefault($1sXeC)))(cardId)); // convert str to num/IssueKey
            const excludedCardIds = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(issueIds, filteredCardIds); // diff them against the query response
            const invisibleIssueIdsSelector = (0, $5mTgl.getInvisibleIssueIdsFromClientSideFiltersOnly);
            const invisibleCardIds = [
                ...invisibleIssueIdsSelector(state)(filteredCardIds),
                ...excludedCardIds
            ];
            if (invisibleCardIds.length) {
                // we only want to show the flag for created issues
                const invisibleCreatedCardIds = invisibleCardIds.filter(isCreatedIssue);
                const invisibleCreatedCardKeys = (0, $d2i8f.getIssueKeysFromIssueIds)(state)(invisibleCreatedCardIds);
                // if we were unable to get card keys, the issue isn't present on the board at all.
                // as such, we don't want to show the flag here, as we'll already be showing a flag prior to this (due to unmapped status or not in a current sprint).
                if (invisibleCreatedCardKeys.length) {
                    debouncedActions = [];
                    return [
                        (0, $bkCF5.issueCreateFilteredV2)(invisibleCreatedCardKeys),
                        (0, $cY26q.refilterSuccess)(excludedCardIds.map((cardId)=>cardId.toString()), cardIds)
                    ];
                }
            }
            debouncedActions = [];
            return [
                (0, $cY26q.refilterSuccess)(excludedCardIds.map((cardId)=>cardId.toString()), cardIds)
            ];
        }).catch((error)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('board.filtered-cards.refilter.failure', 'Fail to re-filter cards with custom filters', error);
            debouncedActions = [];
            return (0, $kVLXA.Observable).of((0, $cY26q.refilterFailure)(error));
        });
    });
};

});
const $09d938f04e8899c4$export$86d416e8d15777d = 'avi:jira:assigned:issue';
const $09d938f04e8899c4$export$b22a14d5dac59664 = 'avi:jira:created:issue';
const $09d938f04e8899c4$export$25fa37e5059c5a99 = 'avi:jira:deleted:issue';
const $09d938f04e8899c4$export$d9bc8850eeef9f60 = 'avi:jira:transitioned:issue';
const $09d938f04e8899c4$export$b22142e61b3fdbee = 'avi:jira:updated:issue';
const $09d938f04e8899c4$export$773466d9acc404c0 = 'avi:jira:commented:issue';
const $09d938f04e8899c4$export$6b7e46ea0442b66c = 'avi:jira:updated:issue_parent_association';
const $09d938f04e8899c4$export$6024bd0c20931af3 = 'avi:jira-software:update:board-scope-issues';

parcelRegister("d315K", function(module, exports) {

$parcel$export(module.exports, "REALTIME_DISPATCH_EVENT", () => $c0dbbae35befe3e5$export$b5816ca887d8baac);
$parcel$export(module.exports, "dispatchRealtimeEvent", () => $c0dbbae35befe3e5$export$e0f58b7bfd5c1657);
const $c0dbbae35befe3e5$export$b5816ca887d8baac = 'state.actions.realtime.REALTIME_DISPATCH_EVENT';
const $c0dbbae35befe3e5$export$e0f58b7bfd5c1657 = (event)=>({
        type: $c0dbbae35befe3e5$export$b5816ca887d8baac,
        payload: {
            event: event
        }
    });

});

parcelRegister("8yiLS", function(module, exports) {

$parcel$export(module.exports, "getActiveCustomFilterIds", () => $0bf8cdb422c26644$export$82bff6cad9152357);
$parcel$export(module.exports, "isCustomFiltersActive", () => $0bf8cdb422c26644$export$42709fe30c51b78a);
const $0bf8cdb422c26644$export$82bff6cad9152357 = (state)=>state.ui.workFilters?.values.CUSTOM_FILTER ?? [];
const $0bf8cdb422c26644$export$42709fe30c51b78a = (state)=>$0bf8cdb422c26644$export$82bff6cad9152357(state).length > 0;

});



parcelRegister("9C8b7", function(module, exports) {

$parcel$export(module.exports, "initiateIccInUnscheduledColumnEpic", () => $ebc7e90c724eb587$export$c8b97467c24e77a0);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fPS7b");
parcelRequire("jFVZ1");
parcelRequire("fp4O3");
parcelRequire("eV0gs");

var $kgiLc = parcelRequire("kgiLc");

var $2f454 = parcelRequire("2f454");

var $d1i1b = parcelRequire("d1i1b");

var $k50Aq = parcelRequire("k50Aq");
function $ebc7e90c724eb587$export$c8b97467c24e77a0(action$) {
    return action$.ofType((0, $2f454.INITIATE_ICC_IN_UNSCHEDULED_COLUMN)).mergeMap((action)=>{
        const { swimlaneId: swimlaneId, shouldToggleSwimlane: shouldToggleSwimlane } = action.payload;
        const truncatedSwimlaneId = (0, $kgiLc.truncateUnscheduledWorkSwimlaneId)(swimlaneId, true);
        if (shouldToggleSwimlane) return (0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, $k50Aq.swimlaneToggle)(swimlaneId)), // Delay autoscroll after swimlane toggle so it scrolls to the right position
        (0, $kVLXA.Observable).of((0, $d1i1b.cardAutoScrollUnscheduledColumnIcc)(truncatedSwimlaneId, true)).delay(100), (0, $kVLXA.Observable).of((0, $2f454.openIccInUnscheduledColumn)(truncatedSwimlaneId)));
        // isImmediate true works better when swimlane is expanded
        return (0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, $d1i1b.cardAutoScrollUnscheduledColumnIcc)(truncatedSwimlaneId, true)), (0, $kVLXA.Observable).of((0, $2f454.openIccInUnscheduledColumn)(truncatedSwimlaneId)));
    });
}

});

parcelRegister("iH73B", function(module, exports) {

$parcel$export(module.exports, "getIssueLinksPermissionsEpic", () => $0bc4c8208171d954$export$619d310548798f07);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $bi02m = parcelRequire("bi02m");

var $cwdC8 = parcelRequire("cwdC8");

var $67Z81 = parcelRequire("67Z81");
const $0bc4c8208171d954$export$619d310548798f07 = (action$, store)=>{
    const state = store.getState();
    const boardId = (0, $67Z81.rapidViewIdSelector)(state);
    const cloudId = (0, $67Z81.cloudIdSelector)(state);
    const isCMP = (0, $67Z81.getIsCMPBoard)(state);
    const isJSWBoard = (0, $67Z81.getIsJSWBoard)(state);
    const isIPBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
    return action$.ofType((0, $cwdC8.FETCH_ISSUE_LINKS_PERMISSIONS)).switchMap(()=>{
        if (!isJSWBoard || isIPBoard) return (0, $kVLXA.Observable).of();
        return (0, $bi02m.fetchIssueLinksPermissionsService)({
            boardId: boardId,
            cloudId: cloudId,
            isCMP: isCMP
        }).mergeMap((linkedIssuesPermissionsResponse)=>(0, $kVLXA.Observable).of((0, $cwdC8.setIssueLinksPermissions)(linkedIssuesPermissionsResponse))).catch((error)=>{
            if (!(0, $fZneA.isClientFetchError)(error)) (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'board.issueLinksPermissions.load.failure',
                    packageName: 'jiraSoftwareBoard',
                    teamName: 'a4t-tanuki'
                }
            });
            return (0, $kVLXA.Observable).of();
        });
    });
};

});
parcelRegister("bi02m", function(module, exports) {

$parcel$export(module.exports, "fetchIssueLinksPermissionsService", () => $21d8f391cc013f03$export$ef2dbb65561dba4e);

var $bWs5d = parcelRequire("bWs5d");
const $21d8f391cc013f03$export$ef2dbb65561dba4e = (props)=>(0, $bWs5d.getIssueLinksPermissions)(props);

});
parcelRegister("bWs5d", function(module, exports) {

$parcel$export(module.exports, "getIssueLinksPermissions", () => $45f38b82b152c349$export$7b960698e444da91);

var $3fgrt = parcelRequire("3fgrt");

var $8Uumt = parcelRequire("8Uumt");

var $kVLXA = parcelRequire("kVLXA");

var $dXq4S = parcelRequire("dXq4S");

var $5yJb9 = parcelRequire("5yJb9");

const $45f38b82b152c349$export$42ba6d3bd814bf95 = (0, $3fgrt.default);
const $45f38b82b152c349$export$7b960698e444da91 = ({ boardId: boardId, cloudId: cloudId, isCMP: isCMP })=>{
    const boardIdAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: String(boardId)
    });
    return (0, $kVLXA.Observable).fromPromise((0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), $45f38b82b152c349$export$42ba6d3bd814bf95, {
        boardIdAri: boardIdAri,
        cloudId: cloudId,
        isCMP: isCMP
    }).toPromise().then((data)=>{
        const permissionsArray = data?.boardScope?.currentUser?.permissions || [];
        const issueLinkTypes = data?.jira?.issueLinkTypes?.edges?.length ? data?.jira?.issueLinkTypes?.edges : [];
        return {
            canUserLinkIssue: permissionsArray.includes((0, $68cf6bf1ce76db03$export$f6220122141a5652)),
            issueLinkTypes: issueLinkTypes
        };
    }));
};

});
parcelRegister("3fgrt", function(module, exports) {

$parcel$export(module.exports, "default", () => $70386253e62a237d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f26e8c3b24c528914919a2150996cd25>>
 * @relayHash f48f330c176a0bc6c4d76bc83cbee746
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ac4dc58065040cf5a8f44c73a0e311e3ddca81d9d89c27266d24353f848557fe
const $70386253e62a237d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardIdAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isCMP"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "inwards"
    }, v6 = {
        "kind": "ScalarField",
        "name": "outwards"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardIdAri"
        },
        {
            "kind": "Variable",
            "name": "isCMP",
            "variableName": "isCMP"
        }
    ], v8 = {
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "permissions"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueLinksPermissionsData_PermissionsAndIssueLinkTypesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssueLinkTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueLinkTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueLinkTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueLinkType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v4 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v5 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.inwards"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v6 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.outwards"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueLinksPermissionsData_PermissionsAndIssueLinkTypesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssueLinkTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueLinkTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueLinkTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueLinkType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "ac4dc58065040cf5a8f44c73a0e311e3ddca81d9d89c27266d24353f848557fe",
            "metadata": {},
            "name": "issueLinksPermissionsData_PermissionsAndIssueLinkTypesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$70386253e62a237d$var$node.hash = "2b9e58e9f316f1a984e9838714d0ff74";
var $70386253e62a237d$export$2e2bcd8739ae039 = $70386253e62a237d$var$node;

});



parcelRegister("cwdC8", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_LINKS_PERMISSIONS", () => $50c479909b968228$export$60091d1f159f3cbc);
$parcel$export(module.exports, "fetchIssueLinksPermissions", () => $50c479909b968228$export$171a8ea28f7c89ec);
$parcel$export(module.exports, "SET_ISSUE_LINKS_PERMISSIONS", () => $50c479909b968228$export$c222f1203afb49dd);
$parcel$export(module.exports, "setIssueLinksPermissions", () => $50c479909b968228$export$93bcf6e82d828eae);
const $50c479909b968228$export$60091d1f159f3cbc = 'state.actions.issue-links-stats.FETCH_ISSUE_LINKS_PERMISSIONS';
const $50c479909b968228$export$171a8ea28f7c89ec = ()=>({
        type: $50c479909b968228$export$60091d1f159f3cbc
    });
const $50c479909b968228$export$c222f1203afb49dd = 'state.actions.issue-links-stats.SET_ISSUE_LINKS_PERMISSIONS';
const $50c479909b968228$export$93bcf6e82d828eae = (payload)=>({
        type: $50c479909b968228$export$c222f1203afb49dd,
        payload: payload
    });

});


parcelRegister("2u4LO", function(module, exports) {

$parcel$export(module.exports, "getIsIssueLinksStatsLoadingEpic", () => $89a3340f3b3d1aba$export$61c63a85112220c0);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $4RVsR = parcelRequire("4RVsR");
const $89a3340f3b3d1aba$export$61c63a85112220c0 = (action$)=>action$.ofType((0, $4RVsR.FETCH_ISSUE_LINKS_STATS)).switchMap((action)=>{
        const payloadIssueIds = action.type === (0, $4RVsR.FETCH_ISSUE_LINKS_STATS) && action.payload;
        if (payloadIssueIds) return (0, $kVLXA.Observable).of((0, $4RVsR.setIssueLinksStatsLoading)(payloadIssueIds));
        return (0, $kVLXA.Observable).of();
    });

});
parcelRegister("4RVsR", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_LINKS_STATS", () => $06296a4e0819b2a8$export$c78aaa122aa7a55a);
$parcel$export(module.exports, "fetchIssueLinksStats", () => $06296a4e0819b2a8$export$2be3f0ee613bdf6);
$parcel$export(module.exports, "SET_ISSUE_LINKS_STATS", () => $06296a4e0819b2a8$export$9f3b5a75c7d30595);
$parcel$export(module.exports, "setIssueLinksStats", () => $06296a4e0819b2a8$export$3da474195d54a10a);
$parcel$export(module.exports, "SET_ISSUE_LINKS_STATS_LOADING", () => $06296a4e0819b2a8$export$ba81d05052f97ec0);
$parcel$export(module.exports, "setIssueLinksStatsLoading", () => $06296a4e0819b2a8$export$78440f18a9d54204);
const $06296a4e0819b2a8$export$c78aaa122aa7a55a = 'state.actions.issue-links-stats.FETCH_ISSUE_LINKS_STATS';
const $06296a4e0819b2a8$export$2be3f0ee613bdf6 = (payload, meta)=>({
        type: $06296a4e0819b2a8$export$c78aaa122aa7a55a,
        payload: payload,
        meta: meta
    });
const $06296a4e0819b2a8$export$9f3b5a75c7d30595 = 'state.actions.issue-links-stats.SET_ISSUE_LINKS_STATS';
const $06296a4e0819b2a8$export$3da474195d54a10a = (payload)=>({
        type: $06296a4e0819b2a8$export$9f3b5a75c7d30595,
        payload: payload
    });
const $06296a4e0819b2a8$export$ba81d05052f97ec0 = 'state.actions.issue-links-stats.SET_ISSUE_LINKS_STATS_LOADING';
const $06296a4e0819b2a8$export$78440f18a9d54204 = (payload)=>({
        type: $06296a4e0819b2a8$export$ba81d05052f97ec0,
        payload: payload
    });

});


parcelRegister("14ODQ", function(module, exports) {

$parcel$export(module.exports, "getIssueLinksStatsEpic", () => $f05fd26440934fad$export$28dfbb4ad1451837);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");

var $a4XJc = parcelRequire("a4XJc");

var $8zmNw = parcelRequire("8zmNw");

var $b7xIp = parcelRequire("b7xIp");

var $4RVsR = parcelRequire("4RVsR");

var $cW3pH = parcelRequire("cW3pH");

var $vAfHD = parcelRequire("vAfHD");

var $67Z81 = parcelRequire("67Z81");
const $f05fd26440934fad$export$28dfbb4ad1451837 = (action$, store)=>action$.ofType((0, $4RVsR.FETCH_ISSUE_LINKS_STATS), (0, $cW3pH.WORK_DATA_SET)).switchMap((action)=>{
        const state = store.getState();
        const isJSWBoard = (0, $67Z81.getIsJSWBoard)(state);
        const isIPBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        const showIssueLinksStatsViewSettings = (0, $8zmNw.getViewSettings)({
            boardId: Number((0, $67Z81.rapidViewIdSelector)(state)),
            view: (0, $a4XJc.View).BOARD
        })?.showIssueLinksStats;
        if (!isJSWBoard || isIPBoard || !showIssueLinksStatsViewSettings) return (0, $kVLXA.Observable).of();
        const payloadIssueIds = action.type === (0, $4RVsR.FETCH_ISSUE_LINKS_STATS) && action.payload;
        const analyticsEvent = action.type === (0, $4RVsR.FETCH_ISSUE_LINKS_STATS) && action.meta?.analyticsEvent;
        const issueIds = payloadIssueIds || (0, $vAfHD.boardOrderedIssueIdsSelector)(state);
        if (!issueIds.length) return (0, $kVLXA.Observable).of();
        return (0, $b7xIp.fetchIssueLinksStatsService)(issueIds).mergeMap((linkedIssuesStatsResponse)=>{
            if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'ui taskSuccess', {
                task: 'issueLinksStatsFetch'
            });
            return (0, $kVLXA.Observable).of((0, $4RVsR.setIssueLinksStats)(linkedIssuesStatsResponse));
        }).catch((error)=>{
            if (!(0, $fZneA.isClientFetchError)(error)) analyticsEvent && (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'ui taskFail', {
                task: 'issueLinksStatsFetch',
                isClientFetchError: false
            });
            return (0, $kVLXA.Observable).of();
        });
    });

});
parcelRegister("a4XJc", function(module, exports) {

$parcel$export(module.exports, "View", () => $3338322e4425e825$export$27a5bd065ad55220);
$parcel$export(module.exports, "KeyboardShortcut", () => $3338322e4425e825$export$47a1bf8d9994c680);
$parcel$export(module.exports, "ExpandableState", () => $3338322e4425e825$export$d0f8c009a99b9c1b);
$parcel$export(module.exports, "ViewLocation", () => $3338322e4425e825$export$7ee1cf745baadfcd);
$parcel$export(module.exports, "ViewAs", () => $3338322e4425e825$export$70549c4aef7e1632);
$parcel$export(module.exports, "QUICK_FILTERS", () => $3338322e4425e825$export$59191afd909777e0);
$parcel$export(module.exports, "COMPACT_MODE", () => $3338322e4425e825$export$abd09d2531440e47);
$parcel$export(module.exports, "SHOW_EPICS", () => $3338322e4425e825$export$f3d7917d25ca2d13);
$parcel$export(module.exports, "SHOW_STATUSES", () => $3338322e4425e825$export$933792f2c41e7c51);
$parcel$export(module.exports, "SHOW_VERSIONS", () => $3338322e4425e825$export$fe0a5eeac8bdee53);
$parcel$export(module.exports, "SHOW_ISSUE_LINKS_STATS", () => $3338322e4425e825$export$889dbf130218e8b3);
$parcel$export(module.exports, "SHOW_ISSUE_KEY", () => $3338322e4425e825$export$f199de710b228934);
$parcel$export(module.exports, "SHOW_ISSUE_TYPE", () => $3338322e4425e825$export$e8f86e49139c6abb);
$parcel$export(module.exports, "SHOW_ESTIMATE", () => $3338322e4425e825$export$e1f60d3e74825af0);
$parcel$export(module.exports, "SHOW_PRIORITY", () => $3338322e4425e825$export$bcfd60da3302536e);
$parcel$export(module.exports, "SHOW_DEVELOPMENT", () => $3338322e4425e825$export$e7b5d3d062c615d5);
$parcel$export(module.exports, "SHOW_ASSIGNEE", () => $3338322e4425e825$export$3c14ba0cd46183b);
$parcel$export(module.exports, "SHOW_DAYS_IN_COLUMN", () => $3338322e4425e825$export$8224ffeed837235e);
$parcel$export(module.exports, "SHOW_DUE_DATE", () => $3338322e4425e825$export$770e28bfe2e0208d);
$parcel$export(module.exports, "SHOW_LABELS", () => $3338322e4425e825$export$63993996bfd99919);
$parcel$export(module.exports, "SHOW_CARD_COVERS", () => $3338322e4425e825$export$b811e8bce70dd7c2);
$parcel$export(module.exports, "Panels", () => $3338322e4425e825$export$b94e9de8950563ef);
$parcel$export(module.exports, "IncrementPlanningSettings", () => $3338322e4425e825$export$ad46e765f851721f);
const $3338322e4425e825$export$27a5bd065ad55220 = {
    BACKLOG: 'jsw-backlog',
    BOARD: 'jsw-board',
    INCREMENT_PLANNING_BOARD: 'increment-planning-board',
    JSM_BOARD: 'jsm-board'
};
const $3338322e4425e825$export$47a1bf8d9994c680 = {
    ISSUE_PARENT_PANEL_SHORTCUT: 'E',
    VERSION_PANEL_SHORTCUT: 'V'
};
const $3338322e4425e825$export$d0f8c009a99b9c1b = {
    EXPANDED: 'expanded',
    COLLAPSED: 'collapsed'
};
const $3338322e4425e825$export$7ee1cf745baadfcd = {
    SIDEBAR: 'sidebar',
    MODAL: 'modal'
};
const $3338322e4425e825$export$70549c4aef7e1632 = {
    PANEL: 'Panel',
    POPUP: 'Popup'
};
const $3338322e4425e825$export$41073ac826c57195 = 'VERSION_PANEL';
const $3338322e4425e825$export$86bfe5c9d2cf6b7c = 'EPIC_PANEL';
const $3338322e4425e825$export$59191afd909777e0 = 'QUICK_FILTERS';
const $3338322e4425e825$export$abd09d2531440e47 = 'COMPACT_MODE';
const $3338322e4425e825$export$f3d7917d25ca2d13 = 'SHOW_EPICS';
const $3338322e4425e825$export$933792f2c41e7c51 = 'SHOW_STATUSES';
const $3338322e4425e825$export$fe0a5eeac8bdee53 = 'SHOW_VERSIONS';
const $3338322e4425e825$export$889dbf130218e8b3 = 'SHOW_ISSUE_LINKS_STATS';
const $3338322e4425e825$export$c3308fa11d994bc5 = 'SHOW_UNSCHEDULED_COLUMN';
const $3338322e4425e825$export$f199de710b228934 = 'SHOW_ISSUE_KEY';
const $3338322e4425e825$export$e8f86e49139c6abb = 'SHOW_ISSUE_TYPE';
const $3338322e4425e825$export$e1f60d3e74825af0 = 'SHOW_ESTIMATE';
const $3338322e4425e825$export$bcfd60da3302536e = 'SHOW_PRIORITY';
const $3338322e4425e825$export$e7b5d3d062c615d5 = 'SHOW_DEVELOPMENT';
const $3338322e4425e825$export$3c14ba0cd46183b = 'SHOW_ASSIGNEE';
const $3338322e4425e825$export$8224ffeed837235e = 'SHOW_DAYS_IN_COLUMN';
const $3338322e4425e825$export$770e28bfe2e0208d = 'SHOW_DUE_DATE';
const $3338322e4425e825$export$63993996bfd99919 = 'SHOW_LABELS';
const $3338322e4425e825$export$b811e8bce70dd7c2 = 'SHOW_CARD_COVERS';
const $3338322e4425e825$export$ecec86e489253c13 = 'SHOW_OFFTRACK_DEPENDENCY_LINES';
const $3338322e4425e825$export$79b3cada7e291288 = 'ISSUE_IDS_TO_SHOW_DEPENDENCIES';
const $3338322e4425e825$export$b94e9de8950563ef = {
    VERSION_PANEL: $3338322e4425e825$export$41073ac826c57195,
    EPIC_PANEL: $3338322e4425e825$export$86bfe5c9d2cf6b7c
};
const $3338322e4425e825$export$ad46e765f851721f = {
    SHOW_UNSCHEDULED_COLUMN: $3338322e4425e825$export$c3308fa11d994bc5,
    SHOW_OFFTRACK_DEPENDENCY_LINES: $3338322e4425e825$export$ecec86e489253c13,
    ISSUE_IDS_TO_SHOW_DEPENDENCIES: $3338322e4425e825$export$79b3cada7e291288
};

});

parcelRegister("8zmNw", function(module, exports) {

$parcel$export(module.exports, "getViewSettings", () => $a5d579bc47cfed7a$export$3ae70db4a97563c);
$parcel$export(module.exports, "setViewSettingsIsFullscreen", () => $a5d579bc47cfed7a$export$322210075289ef56);
$parcel$export(module.exports, "getViewSettingsIsFullscreen", () => $a5d579bc47cfed7a$export$d2c8042121049ae8);
$parcel$export(module.exports, "getViewSettingsPanels", () => $a5d579bc47cfed7a$export$d6a5a0d616fcec93);
$parcel$export(module.exports, "setViewSettings", () => $a5d579bc47cfed7a$export$99f2d9eb0b41b93);
$parcel$export(module.exports, "setViewSettingsPanels", () => $a5d579bc47cfed7a$export$427f126b21640252);
$parcel$export(module.exports, "getViewSettingsQuickFilters", () => $a5d579bc47cfed7a$export$18eb87e1feb49f18);
$parcel$export(module.exports, "setViewSettingsQuickFilters", () => $a5d579bc47cfed7a$export$60d0caf3b1c59159);
$parcel$export(module.exports, "getViewSettingsCompactMode", () => $a5d579bc47cfed7a$export$658ed39e1ffe75b);
$parcel$export(module.exports, "setViewSettingsCompactMode", () => $a5d579bc47cfed7a$export$9ca6e4490ca9b1fc);
$parcel$export(module.exports, "getViewSettingsCardDetails", () => $a5d579bc47cfed7a$export$a2a95ab43ea98277);
$parcel$export(module.exports, "setViewSettingsCardDetails", () => $a5d579bc47cfed7a$export$af2e5a35023755b5);
$parcel$export(module.exports, "getViewSettingsCardExtraFields", () => $a5d579bc47cfed7a$export$6a2173913af81755);
$parcel$export(module.exports, "setViewSettingsCardExtraFields", () => $a5d579bc47cfed7a$export$b54537ba70def946);
$parcel$export(module.exports, "setShowEpics", () => $a5d579bc47cfed7a$export$294c0e262bd1285a);
$parcel$export(module.exports, "setShowVersions", () => $a5d579bc47cfed7a$export$a3ab3e2c6a6189bd);
$parcel$export(module.exports, "setShowStatuses", () => $a5d579bc47cfed7a$export$e95c7c8d7cbf6350);
$parcel$export(module.exports, "setShowIssueLinksStats", () => $a5d579bc47cfed7a$export$163e0dded7eda9d9);
$parcel$export(module.exports, "setShowUnscheduledColumn", () => $a5d579bc47cfed7a$export$6edce735c6eb4cb0);
$parcel$export(module.exports, "getShowUnscheduledColumn", () => $a5d579bc47cfed7a$export$bf31a7b99f7bc62f);
$parcel$export(module.exports, "setShowDaysInColumn", () => $a5d579bc47cfed7a$export$68382c1a767b0133);
$parcel$export(module.exports, "setShowDueDate", () => $a5d579bc47cfed7a$export$13fed6c54275816a);
$parcel$export(module.exports, "setShowLabels", () => $a5d579bc47cfed7a$export$43aa76b69739d220);
$parcel$export(module.exports, "setExtraFields", () => $a5d579bc47cfed7a$export$b24e660e664a6bba);
$parcel$export(module.exports, "setShowOfftrackDependencyLines", () => $a5d579bc47cfed7a$export$2c48063cd4ef1ade);
$parcel$export(module.exports, "getShowOfftrackDependencyLines", () => $a5d579bc47cfed7a$export$32c01395d25dfdcc);
$parcel$export(module.exports, "setIssueIdsToShowDependencies", () => $a5d579bc47cfed7a$export$f7b68cb584e33d77);
$parcel$export(module.exports, "getIssueIdsToShowDependencies", () => $a5d579bc47cfed7a$export$67e6bba1326e537a);

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");

var $duOMW = parcelRequire("duOMW");

var $a4XJc = parcelRequire("a4XJc");

var $cYeCp = parcelRequire("cYeCp");
const $a5d579bc47cfed7a$var$browserLocalStorage = (0, $bSSG7.createLocalStorageProvider)((0, $duOMW.VIEW_SETTINGS_LOCAL_STORAGE));
const $a5d579bc47cfed7a$export$36e24695f02d4503 = (view)=>{
    if (view && view === (0, $a4XJc.View).INCREMENT_PLANNING_BOARD) return `${0, $duOMW.VIEW_SETTINGS}-${(0, $a4XJc.View).INCREMENT_PLANNING_BOARD}`;
    if ((0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) switch(view){
        case (0, $a4XJc.View).INCREMENT_PLANNING_BOARD:
            return `${0, $duOMW.VIEW_SETTINGS}-${(0, $a4XJc.View).INCREMENT_PLANNING_BOARD}`;
        case (0, $a4XJc.View).BACKLOG:
            return `${0, $duOMW.VIEW_SETTINGS}-${(0, $a4XJc.View).BACKLOG}`;
        case (0, $a4XJc.View).BOARD:
            return `${0, $duOMW.VIEW_SETTINGS}-${(0, $a4XJc.View).BOARD}`;
        case (0, $a4XJc.View).JSM_BOARD:
            return `${0, $duOMW.VIEW_SETTINGS}-${(0, $a4XJc.View).JSM_BOARD}`;
        default:
            return 0, $duOMW.VIEW_SETTINGS;
    }
    return 0, $duOMW.VIEW_SETTINGS;
};
const $a5d579bc47cfed7a$export$3ae70db4a97563c = ({ boardId: boardId, view: view })=>$a5d579bc47cfed7a$var$browserLocalStorage.get(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`) || $a5d579bc47cfed7a$var$browserLocalStorage.get(`${(0, $duOMW.VIEW_SETTINGS)}-${boardId}`); // return legacy view settings if prefixed storage doesn't exist
const $a5d579bc47cfed7a$export$322210075289ef56 = ({ boardId: boardId, isFullscreen: isFullscreen, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        isFullscreen: isFullscreen
    });
};
const $a5d579bc47cfed7a$export$d2c8042121049ae8 = ({ boardId: boardId, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.isFullscreen ?? (0, $duOMW.initialState).isFullscreen;
};
const $a5d579bc47cfed7a$export$d6a5a0d616fcec93 = ({ boardId: boardId, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return {
        EPIC_PANEL: state?.showEpicPanel ?? (0, $duOMW.initialState).showEpicPanel,
        VERSION_PANEL: state?.showVersionPanel ?? (0, $duOMW.initialState).showVersionPanel
    };
};
const $a5d579bc47cfed7a$export$99f2d9eb0b41b93 = ({ boardId: boardId, state: state, view: view })=>$a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, state);
const $a5d579bc47cfed7a$export$427f126b21640252 = ({ boardId: boardId, panelState: panelState, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpicPanel: panelState.EPIC_PANEL,
        showVersionPanel: panelState.VERSION_PANEL
    });
};
const $a5d579bc47cfed7a$export$7a001fa75693814b = ({ boardId: boardId, panel: panel, show: show, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    if (panel === (0, $a4XJc.Panels).EPIC_PANEL) $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpicPanel: show
    });
    if (panel === (0, $a4XJc.Panels).VERSION_PANEL) $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showVersionPanel: show
    });
};
const $a5d579bc47cfed7a$export$18eb87e1feb49f18 = ({ boardId: boardId, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.showQuickFilters ?? (0, $duOMW.initialState).showQuickFilters;
};
const $a5d579bc47cfed7a$export$60d0caf3b1c59159 = ({ boardId: boardId, showQuickFilters: showQuickFilters, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showQuickFilters: showQuickFilters
    });
};
const $a5d579bc47cfed7a$export$658ed39e1ffe75b = ({ boardId: boardId, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.showCompactMode ?? (0, $duOMW.initialState).showCompactMode;
};
const $a5d579bc47cfed7a$export$9ca6e4490ca9b1fc = ({ boardId: boardId, showCompactMode: showCompactMode, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showCompactMode: showCompactMode
    });
};
const $a5d579bc47cfed7a$export$a2a95ab43ea98277 = ({ boardId: boardId, view: view, isDaysInColumnEnabled: isDaysInColumnEnabled, isDueDateEnabled: isDueDateEnabled, isLabelsEnabled: isLabelsEnabled, isEstimateEnabled: isEstimateEnabled, isPriorityEnabled: isPriorityEnabled })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    const defaultState = (0, $4R6GH.fg)('jsw_card_cover_image_default_on') ? (0, $duOMW.initialStateNew) : (0, $duOMW.initialState);
    return {
        SHOW_EPICS: state?.showEpics ?? defaultState.showEpics,
        SHOW_STATUSES: state?.showStatuses ?? defaultState.showStatuses,
        SHOW_VERSIONS: state?.showVersions ?? defaultState.showVersions,
        SHOW_ISSUE_LINKS_STATS: state?.showIssueLinksStats ?? defaultState.showIssueLinksStats,
        SHOW_ISSUE_KEY: state?.showIssueKey ?? defaultState.showIssueKey,
        SHOW_ISSUE_TYPE: state?.showIssueType ?? defaultState.showIssueType,
        SHOW_ASSIGNEE: state?.showAssignee ?? defaultState.showAssignee,
        SHOW_PRIORITY: (isPriorityEnabled ? state?.showPriority : defaultState.showPriority) ?? defaultState.showPriority,
        SHOW_DEVELOPMENT: state?.showDevelopment ?? defaultState.showDevelopment,
        SHOW_ESTIMATE: (isEstimateEnabled ? state?.showEstimate : defaultState.showEstimate) ?? defaultState.showEstimate,
        SHOW_DAYS_IN_COLUMN: (isDaysInColumnEnabled ? state?.showDaysInColumn : defaultState.showDaysInColumn) ?? defaultState.showDaysInColumn,
        SHOW_DUE_DATE: (isDueDateEnabled ? state?.showDueDate : defaultState.showDueDate) ?? defaultState.showDueDate,
        SHOW_LABELS: (isLabelsEnabled ? state?.showLabels : defaultState.showLabels) ?? defaultState.showLabels,
        SHOW_CARD_COVERS: state?.showCardCovers ?? defaultState.showCardCovers
    };
};
const $a5d579bc47cfed7a$export$af2e5a35023755b5 = ({ boardId: boardId, cardDetailsState: cardDetailsState, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpics: cardDetailsState.SHOW_EPICS,
        showStatuses: cardDetailsState.SHOW_STATUSES,
        showVersions: cardDetailsState.SHOW_VERSIONS,
        showDaysInColumn: cardDetailsState.SHOW_DAYS_IN_COLUMN,
        showEstimate: cardDetailsState.SHOW_ESTIMATE,
        showIssueLinksStats: cardDetailsState.SHOW_ISSUE_LINKS_STATS,
        showIssueKey: cardDetailsState.SHOW_ISSUE_KEY,
        showIssueType: cardDetailsState.SHOW_ISSUE_TYPE,
        showAssignee: cardDetailsState.SHOW_ASSIGNEE,
        showPriority: cardDetailsState.SHOW_PRIORITY,
        showDevelopment: cardDetailsState.SHOW_DEVELOPMENT,
        showDueDate: cardDetailsState.SHOW_DUE_DATE,
        showLabels: cardDetailsState.SHOW_LABELS,
        showCardCovers: cardDetailsState.SHOW_CARD_COVERS
    });
};
const $a5d579bc47cfed7a$export$6a2173913af81755 = ({ boardId: boardId, view: view, cardExtraFields: cardExtraFields })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return cardExtraFields.reduce((acc, field)=>{
        acc[field.id] = state?.cardExtraFields?.[field.id] ?? true;
        return acc;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});
};
const $a5d579bc47cfed7a$export$b54537ba70def946 = ({ boardId: boardId, cardExtraFieldsState: cardExtraFieldsState, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        cardExtraFields: cardExtraFieldsState
    });
};
const $a5d579bc47cfed7a$export$294c0e262bd1285a = ({ boardId: boardId, showEpics: showEpics, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpics: showEpics
    });
};
const $a5d579bc47cfed7a$export$a3ab3e2c6a6189bd = ({ boardId: boardId, showVersions: showVersions, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showVersions: showVersions
    });
};
const $a5d579bc47cfed7a$export$e95c7c8d7cbf6350 = ({ boardId: boardId, showStatuses: showStatuses, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showStatuses: showStatuses
    });
};
const $a5d579bc47cfed7a$export$163e0dded7eda9d9 = ({ boardId: boardId, showIssueLinksStats: showIssueLinksStats, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showIssueLinksStats: showIssueLinksStats
    });
};
const $a5d579bc47cfed7a$export$6edce735c6eb4cb0 = ({ boardId: boardId, showUnscheduledColumn: showUnscheduledColumn })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503((0, $a4XJc.View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
        ...state,
        showUnscheduledColumn: showUnscheduledColumn
    });
};
const $a5d579bc47cfed7a$export$bf31a7b99f7bc62f = (boardId)=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    return state?.showUnscheduledColumn ?? (0, $duOMW.initialState).showUnscheduledColumn;
};
const $a5d579bc47cfed7a$export$68382c1a767b0133 = ({ boardId: boardId, showDaysInColumn: showDaysInColumn, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showDaysInColumn: showDaysInColumn
    });
};
const $a5d579bc47cfed7a$export$13fed6c54275816a = ({ boardId: boardId, showDueDate: showDueDate, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showDueDate: showDueDate
    });
};
const $a5d579bc47cfed7a$export$43aa76b69739d220 = ({ boardId: boardId, showLabels: showLabels, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showLabels: showLabels
    });
};
const $a5d579bc47cfed7a$export$b24e660e664a6bba = ({ boardId: boardId, cardExtraFields: cardExtraFields, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        cardExtraFields: cardExtraFields
    });
};
const $a5d579bc47cfed7a$export$90df0703e41f9b = ({ boardId: boardId, showCardCovers: showCardCovers, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showCardCovers: showCardCovers
    });
};
const $a5d579bc47cfed7a$export$2c48063cd4ef1ade = ({ boardId: boardId, showOfftrackDependencyLines: showOfftrackDependencyLines })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503((0, $a4XJc.View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
        ...state,
        showOfftrackDependencyLines: showOfftrackDependencyLines
    });
};
const $a5d579bc47cfed7a$export$32c01395d25dfdcc = (boardId)=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    return state?.showOfftrackDependencyLines ?? (0, $duOMW.initialState).showOfftrackDependencyLines;
};
const $a5d579bc47cfed7a$export$f7b68cb584e33d77 = ({ boardId: boardId, issueIds: issueIds })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503((0, $a4XJc.View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
        ...state,
        issueIdsToShowDependencies: issueIds
    });
};
const $a5d579bc47cfed7a$export$67e6bba1326e537a = (boardId)=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    return state?.issueIdsToShowDependencies ?? (0, $duOMW.initialState).issueIdsToShowDependencies;
};

});
parcelRegister("duOMW", function(module, exports) {

$parcel$export(module.exports, "VIEW_SETTINGS", () => $6350b42865dc529c$export$f900da9acbf1ac33);
$parcel$export(module.exports, "VIEW_SETTINGS_LOCAL_STORAGE", () => $6350b42865dc529c$export$752f3d44db2fbd2d);
$parcel$export(module.exports, "initialState", () => $6350b42865dc529c$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "initialStateNew", () => $6350b42865dc529c$export$d85d94032b13e11a);
$parcel$export(module.exports, "boardViewTestIds", () => $6350b42865dc529c$export$9cf6a064d9c55597);
$parcel$export(module.exports, "backlogViewTestIds", () => $6350b42865dc529c$export$af828cca0407ed81);
$parcel$export(module.exports, "VIEW_SETTINGS_PANEL_CLOSE_BUTTON_TEST_ID", () => $6350b42865dc529c$export$b954e2c30216a1e9);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_LG", () => $6350b42865dc529c$export$20070c180403c06a);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_SM", () => $6350b42865dc529c$export$563c80e8ea5620c4);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_RESPONSIVE", () => $6350b42865dc529c$export$3895498dfef21366);
$parcel$export(module.exports, "QUERY_ENABLED_VALUE", () => $6350b42865dc529c$export$c0d46007b8549aca);
const $6350b42865dc529c$export$f900da9acbf1ac33 = 'view-settings';
const $6350b42865dc529c$export$752f3d44db2fbd2d = 'jira-software-view-settings';
const $6350b42865dc529c$export$d4c72bab9d6cc13a = {
    view: null,
    isFullscreen: false,
    showEpicPanel: false,
    showVersionPanel: false,
    showQuickFilters: false,
    showEpics: true,
    showStatuses: true,
    showVersions: true,
    showCompactMode: false,
    showUnscheduledColumn: true,
    showIssueLinksStats: false,
    showIssueKey: true,
    showIssueType: true,
    showEstimate: true,
    showAssignee: true,
    showPriority: true,
    showDevelopment: true,
    showDaysInColumn: true,
    showDueDate: true,
    showLabels: true,
    showCardCovers: false,
    showOfftrackDependencyLines: false,
    issueIdsToShowDependencies: [],
    cardExtraFields: {}
};
const $6350b42865dc529c$export$d85d94032b13e11a = {
    view: null,
    isFullscreen: false,
    showEpicPanel: false,
    showVersionPanel: false,
    showQuickFilters: false,
    showEpics: true,
    showStatuses: true,
    showVersions: true,
    showCompactMode: false,
    showUnscheduledColumn: true,
    showIssueLinksStats: false,
    showIssueKey: true,
    showIssueType: true,
    showEstimate: true,
    showAssignee: true,
    showPriority: true,
    showDevelopment: true,
    showDaysInColumn: true,
    showDueDate: true,
    showLabels: true,
    showCardCovers: true,
    showOfftrackDependencyLines: false,
    issueIdsToShowDependencies: [],
    cardExtraFields: {}
};
const $6350b42865dc529c$export$9cf6a064d9c55597 = {
    viewSettingsBoardMenu: 'software-view-settings.ui.view-settings-menu.menu-board',
    openIssuesInSidebarToggle: 'software-view-settings.ui.view-settings-menu.views.board.open-issues-in-sidebar',
    showQuickFiltersToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-quick-filters-toggle',
    showWorkSuggestionsToggle: 'software-view-settings.ui.view-settings-menu.views.board.work-suggestions-toggle',
    swimlaneExpandAll: 'software-view-settings.ui.view-settings-menu.views.board.expand-all',
    swimlaneCollapseAll: 'software-view-settings.ui.view-settings-menu.views.board.collapse-all',
    cardDetailsSection: 'software-view-settings.ui.view-settings-menu.views.board.card-details-board',
    showIssueTypeToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-issue-type-toggle-board',
    showIssueKeyToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-issue-key-toggle-board',
    showEpicsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-epics-toggle-board',
    showDueDateToggle: 'software-view-settings.ui.view-settings-menu.views.board.due-date-toggle-board',
    showLabelsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-labels-toggle-board',
    showEstimateToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-estimate-toggle-board',
    showDaysInColumnToggle: 'software-view-settings.ui.view-settings-menu.views.board.days-in-column-toggle-board',
    showLinkedIssueStatsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-linked-issue-stats-toggle-board',
    showCardCoversToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-card-covers-toggle-board',
    showPriorityToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-priority-toggle-board',
    showDevelopmentToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-development-toggle-board',
    showAssigneeToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-assignee-toggle-board',
    customFieldsSection: 'software-view-settings.ui.view-settings-menu.views.board.custom-fields-board'
};
const $6350b42865dc529c$export$af828cca0407ed81 = {
    showVersionPanelToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-version-panel-toggle',
    showEpicPanelToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-epic-panel-toggle',
    showQuickFiltersToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-quick-filters-toggle',
    cardLayoutSection: 'software-view-settings.view-settings-menu.card-layout',
    cardLayoutRadioGroup: 'software-view-settings.ui.view-settings-menu.views.backlog.card-layout',
    showCompactModeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-compact-mode-toggle',
    subtaskSection: 'software-view-settings.view-settings-menu.subtasks',
    subtaskExpandAll: 'software-view-settings.ui.view-settings-menu.views.backlog.expand-all-subtasks',
    subtaskCollapseAll: 'software-view-settings.ui.view-settings-menu.views.backlog.collapse-all-subtasks',
    cardDetailsSection: 'software-view-settings.ui.view-settings-menu.views.backlog.card-details-backlog',
    showIssueTypeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-issue-type-toggle-backlog',
    showIssueKeyToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-issue-key-toggle-backlog',
    showVersionsToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-versions-toggle-backlog',
    showEpicsToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-epics-toggle-backlog',
    showDueDateToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.due-date-toggle-backlog',
    showStatusToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-statuses-toggle-backlog',
    showEstimateToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-estimate-toggle-backlog',
    showPriorityToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-priority-toggle-backlog',
    showAssigneeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-assignee-toggle-backlog',
    customFieldsSection: 'software-view-settings.ui.view-settings-menu.views.backlog.custom-fields-backlog'
};
const $6350b42865dc529c$export$b954e2c30216a1e9 = 'view-settings.ui.panel.header.close-button';
const $6350b42865dc529c$export$20070c180403c06a = 'view-settings-show-button.ui.view-settings-button-large';
const $6350b42865dc529c$export$563c80e8ea5620c4 = 'view-settings-show-button.ui.view-settings-button-small';
const $6350b42865dc529c$export$3895498dfef21366 = 'view-settings-show-button.ui.view-settings-button-responsive';
const $6350b42865dc529c$export$c0d46007b8549aca = 'on';
const $6350b42865dc529c$export$788a94e8107fb947 = 'off';

});


parcelRegister("b7xIp", function(module, exports) {

$parcel$export(module.exports, "fetchIssueLinksStatsService", () => $28bc3335888782d5$export$612b8b1593c7e884);

var $3hZs5 = parcelRequire("3hZs5");
const $28bc3335888782d5$export$612b8b1593c7e884 = (issueIds)=>(0, $3hZs5.getIssueLinksStats)(issueIds);

});
parcelRegister("3hZs5", function(module, exports) {

$parcel$export(module.exports, "getIssueLinksStats", () => $b590e08c361b9af7$export$225e8725aa4749ad);
parcelRequire("3q49N");

var $487fd = parcelRequire("487fd");
const $b590e08c361b9af7$var$LINKED_ISSUES_STATS_API_URL = '/rest/api/2/issues/linkedissues/stats';
const $b590e08c361b9af7$export$225e8725aa4749ad = (issueIds)=>(0, $487fd.default)($b590e08c361b9af7$var$LINKED_ISSUES_STATS_API_URL, {
        method: 'POST',
        body: JSON.stringify({
            issueIds: issueIds
        }),
        perf: {
            prefix: 'jsw.board',
            key: 'issueLinksStats.fetch'
        }
    });

});



parcelRegister("a9PrS", function(module, exports) {

$parcel$export(module.exports, "devStatusLoadEpic", () => $27da959b46c87683$export$dcb5545e5709681);
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");
parcelRequire("6cbqE");

var $80afZ = parcelRequire("80afZ");

var $kVLXA = parcelRequire("kVLXA");

var $7Jxgt = parcelRequire("7Jxgt");

var $k12ix = parcelRequire("k12ix");

var $dJl1T = parcelRequire("dJl1T");

var $4G04L = parcelRequire("4G04L");

var $2xFXk = parcelRequire("2xFXk");

var $2gXL1 = parcelRequire("2gXL1");

var $hdmw1 = parcelRequire("hdmw1");

var $hz3OZ = parcelRequire("hz3OZ");

var $9WrsG = parcelRequire("9WrsG");

var $kc6Ry = parcelRequire("kc6Ry");

var $vAfHD = parcelRequire("vAfHD");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");
const $27da959b46c87683$export$a0e8f4d548e5896 = (result)=>Object.keys(result).length;
const $27da959b46c87683$export$3ab433d598b5afda = {
    onSuccess: (store, action, result)=>{
        const { concurrentId: concurrentId } = action.payload;
        (0, $4G04L.scheduleAfterRender)(()=>{
            const state = store.getState();
            (0, $hz3OZ.devStatusLoadInteraction)(concurrentId).stop({
                customData: {
                    ...(0, $k12ix.getNormalisedPerformanceFFs)(),
                    numOfIssuesHasDevStatus: $27da959b46c87683$export$a0e8f4d548e5896(result),
                    numOfIssues: (0, $5mTgl.workIssuesSelector)(state).length
                }
            });
        });
    }
};
const $27da959b46c87683$var$handleFailure = (error)=>{
    (0, $dJl1T.default).safeErrorWithoutCustomerData('board.dev-status.load.failure', 'Dev status failed to load', error);
    return (0, $kVLXA.Observable).of((0, $9WrsG.devStatusLoadFailure)());
};
const $27da959b46c87683$var$handleSuccessNoop = ()=>(0, $kVLXA.Observable).of((0, $9WrsG.devStatusLoadSuccess)({}));
const $27da959b46c87683$var$handleSuccess = (result)=>(0, $kVLXA.Observable).of((0, $9WrsG.devStatusLoadSuccess)(result));
const $27da959b46c87683$export$e2e71e4a11967728 = 100;
const $27da959b46c87683$export$c3864266aa54a212 = (store, action, hooks = $27da959b46c87683$export$3ab433d598b5afda)=>{
    if (hooks.onStart) hooks.onStart(store, action);
    const state = store.getState();
    const ctx = (0, $hdmw1.makeServiceContext)(state);
    const issueIds = (0, (/*@__PURE__*/$parcel$interopDefault($80afZ)))((0, $67Z81.getEntities)(state).issues, (issue)=>issue.id);
    const issueChildrenIds = (0, (/*@__PURE__*/$parcel$interopDefault($80afZ)))((0, $67Z81.getEntities)(state).issueChildren, (issueChild)=>issueChild.id);
    const issueParentIds = (0, (/*@__PURE__*/$parcel$interopDefault($80afZ)))((0, $67Z81.getEntities)(state).issueParents, (issueParent)=>issueParent.id);
    let allIssueIds;
    if (ctx.isCMPBoard) allIssueIds = [
        ...issueIds,
        ...issueChildrenIds,
        ...issueParentIds
    ];
    else allIssueIds = issueIds;
    return (0, $2gXL1.devStatusService)(ctx, {
        issueIds: allIssueIds
    }).flatMap((result)=>{
        if (hooks.onSuccess) hooks.onSuccess(store, action, result);
        return $27da959b46c87683$var$handleSuccess(result);
    }).catch((error)=>{
        if (hooks.onFailure) hooks.onFailure(store, action);
        return $27da959b46c87683$var$handleFailure(error);
    });
};
function $27da959b46c87683$export$dcb5545e5709681(action$, store) {
    return action$.ofType((0, $9WrsG.DEV_STATUS_LOAD)).switchMap(()=>{
        if (!(0, $kc6Ry.getCapability)(store.getState())((0, $2xFXk.Capability).ENABLE_DEVOPS_ON_BOARD)) // No Capability to fetch status
        return $27da959b46c87683$var$handleSuccessNoop();
        const issuesCount = (0, $vAfHD.boardOrderedIssueIdsSelector)(store.getState()).length;
        if (issuesCount === 0) // No cards on the board
        return $27da959b46c87683$var$handleSuccessNoop();
        const concurrentId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        (0, $hz3OZ.devStatusLoadInteraction)(concurrentId).start();
        return $27da959b46c87683$export$c3864266aa54a212(store, (0, $9WrsG.devStatusLoadRequest)(concurrentId));
    });
}

});
parcelRegister("2gXL1", function(module, exports) {

$parcel$export(module.exports, "devStatusService", () => $ee8352428da9f97c$export$8ad62c14f77d0106);
parcelRequire("d0pqD");

var $4W1hd = parcelRequire("4W1hd");
function $ee8352428da9f97c$export$dbbd4778d05e824e(gqlActivity) {
    switch(gqlActivity){
        case 'PR_OPEN':
            return 'pullrequest';
        case 'PR_MERGED':
            return 'merged';
        case 'PR_DECLINED':
            return 'declined';
        case 'BRANCH_OPEN':
            return 'branch';
        case 'COMMIT':
            return 'commit';
        case 'DEPLOYMENT':
            return 'deployment';
        case 'DESIGN':
            return 'design';
        default:
            return null;
    }
}
function $ee8352428da9f97c$export$e21d47d83e1e84d6(response) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const devStatusMap = {};
    response.agile.board.columns.forEach((column)=>{
        column.cards.forEach((card)=>{
            const activity = card.devStatus && $ee8352428da9f97c$export$dbbd4778d05e824e(card.devStatus.activity);
            // skip when activity is unknown as we would not be able to show it anyway
            if (card.devStatus && activity) {
                const deploymentDetails = card.devStatus.properties?.state && card.devStatus.properties?.environment?.type ? {
                    deploymentDetails: {
                        deploymentState: card.devStatus.properties?.state,
                        deploymentEnvironment: card.devStatus.properties?.environment?.type
                    }
                } : {};
                devStatusMap[String(card.id)] = {
                    activity: activity,
                    count: card.devStatus.count,
                    ...deploymentDetails
                };
            }
        });
    });
    return devStatusMap;
}
function $ee8352428da9f97c$export$73ba76a6408c630a(response) {
    const devStatusMap = {};
    Object.entries(response.devOpsActivityForIssues).forEach(([issueIdStr, activity])=>{
        const issueId = Number(issueIdStr);
        const activityTag = $ee8352428da9f97c$export$dbbd4778d05e824e(activity.devOpsInfoActivityState);
        if (activityTag == null) return;
        const deploymentDetails = activity.properties?.state && activity.properties?.environment?.type ? {
            deploymentDetails: {
                deploymentState: activity.properties.state,
                deploymentEnvironment: activity.properties.environment.type
            }
        } : {};
        devStatusMap[issueId] = {
            count: activity.count,
            activity: activityTag,
            ...deploymentDetails
        };
    });
    return devStatusMap;
}
function $ee8352428da9f97c$export$8ad62c14f77d0106(ctx, { issueIds: issueIds }) {
    if (ctx.isCMPBoard) return (0, $4W1hd.fetchDevStatusFromRest)({
        boardId: ctx.boardId,
        issueIds: issueIds
    }).map((response)=>$ee8352428da9f97c$export$73ba76a6408c630a(response));
    return (0, $4W1hd.fetchDevStatusFromSwag)(ctx.contextPath, ctx.boardId).map((resp)=>$ee8352428da9f97c$export$e21d47d83e1e84d6(resp));
}

});
parcelRegister("4W1hd", function(module, exports) {

$parcel$export(module.exports, "fetchDevStatusFromSwag", () => $db6875dff46fa7c6$export$9406ec190ad97fd2);
$parcel$export(module.exports, "fetchDevStatusFromRest", () => $db6875dff46fa7c6$export$968bc8cd6063e243);

var $487fd = parcelRequire("487fd");

var $cBLvH = parcelRequire("cBLvH");
const $db6875dff46fa7c6$export$5db520940cf00715 = 'SoftwareBoardDevStatus';
const $db6875dff46fa7c6$export$2b91517d6d5b4365 = `
    query ${$db6875dff46fa7c6$export$5db520940cf00715} ($boardId: ID!) {
        agile { 
            board(id: $boardId) {
                columns {
                    cards {
                        id
                        devStatus {
                            activity
                            count
                            properties {
                                state
                                environment {
                                    type
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
function $db6875dff46fa7c6$export$9406ec190ad97fd2(baseUrl, boardId) {
    return (0, $cBLvH.query$)(baseUrl, $db6875dff46fa7c6$export$5db520940cf00715, $db6875dff46fa7c6$export$2b91517d6d5b4365, {
        boardId: boardId
    });
}
function $db6875dff46fa7c6$export$968bc8cd6063e243({ boardId: boardId, issueIds: issueIds }) {
    return (0, $487fd.default)('/rest/greenhopper/1.0/xboard/work', {
        method: 'POST',
        body: JSON.stringify({
            rapidViewId: boardId,
            fields: [
                'issues_dev_info_activity'
            ],
            issueIds: issueIds
        })
    });
}

});


parcelRegister("9WrsG", function(module, exports) {

$parcel$export(module.exports, "DEV_STATUS_LOAD", () => $ff98431a0666bbb9$export$7a3d9aad824c5875);
$parcel$export(module.exports, "devStatusLoad", () => $ff98431a0666bbb9$export$e84ac5e45ad9d43d);
$parcel$export(module.exports, "devStatusLoadRequest", () => $ff98431a0666bbb9$export$c72e6cf4c2c4fb29);
$parcel$export(module.exports, "DEV_STATUS_LOAD_SUCCESS", () => $ff98431a0666bbb9$export$ca1ef0650dff91c);
$parcel$export(module.exports, "devStatusLoadSuccess", () => $ff98431a0666bbb9$export$d5dceae9c7c7bc77);
$parcel$export(module.exports, "devStatusLoadFailure", () => $ff98431a0666bbb9$export$fcc06855ffb9341c);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $ff98431a0666bbb9$export$7a3d9aad824c5875 = 'state.actions.issue.dev-status.DEV_STATUS_LOAD';
const $ff98431a0666bbb9$export$e84ac5e45ad9d43d = (issueIds)=>({
        type: $ff98431a0666bbb9$export$7a3d9aad824c5875,
        payload: issueIds
    });
const $ff98431a0666bbb9$export$ff87d2c500ee1e70 = 'state.actions.issue.dev-status.DEV_STATUS_LOAD_REQUEST';
const $ff98431a0666bbb9$export$c72e6cf4c2c4fb29 = (concurrentId)=>({
        type: $ff98431a0666bbb9$export$ff87d2c500ee1e70,
        payload: {
            concurrentId: concurrentId
        }
    });
const $ff98431a0666bbb9$export$ca1ef0650dff91c = 'state.actions.issue.dev-status.DEV_STATUS_LOAD_SUCCESS';
const $ff98431a0666bbb9$export$d5dceae9c7c7bc77 = (activity)=>({
        type: $ff98431a0666bbb9$export$ca1ef0650dff91c,
        payload: activity
    });
const $ff98431a0666bbb9$export$c79938f4edfaa10d = 'state.actions.issue.dev-status.DEV_STATUS_LOAD_FAILURE';
const $ff98431a0666bbb9$export$fcc06855ffb9341c = ()=>({
        type: $ff98431a0666bbb9$export$c79938f4edfaa10d,
        meta: (0, $sdxnu.warningFlagMeta)({
            id: $ff98431a0666bbb9$export$c79938f4edfaa10d,
            titleMessage: (0, $7AVqz.default).devStatusFetchFailedTitle,
            descriptionMessage: (0, $7AVqz.default).devStatusFetchFailedDescription
        })
    });

});


parcelRegister("2RHGv", function(module, exports) {

$parcel$export(module.exports, "issueBentoUpdateEpic", () => $dce0b88d04659266$export$9df2b0b3d6b0f9c3);

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $FTaAj = parcelRequire("FTaAj");


var $6zzBT = parcelRequire("6zzBT");

var $lSEpr = parcelRequire("lSEpr");

var $2ZOF9 = parcelRequire("2ZOF9");

var $2f454 = parcelRequire("2f454");

var $4RVsR = parcelRequire("4RVsR");

var $ls4NM = parcelRequire("ls4NM");

var $evkwq = parcelRequire("evkwq");

var $cW3pH = parcelRequire("cW3pH");

var $3UY9S = parcelRequire("3UY9S");

var $bSSdD = parcelRequire("bSSdD");

var $67Z81 = parcelRequire("67Z81");
const $dce0b88d04659266$var$mapPayloadToActions = (state, action, isCMPBoard)=>{
    const { payload: payload } = action;
    if (payload.type === (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_FIELD_UPDATED) return isCMPBoard ? [
        (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$9808bb47382c679c))
    ] : null;
    if (payload.type === (0, $FTaAj.ChangeEventTypes).ISSUE_LINKS_CREATED) {
        const issuesToUpdate = payload.meta?.links?.reduce((acc, curr)=>{
            acc.push(curr.linkedIssueId);
            return acc;
        }, [
            payload.issueId
        ]);
        return [
            (0, $4RVsR.fetchIssueLinksStats)(issuesToUpdate)
        ];
    }
    if (payload.type === (0, $FTaAj.ChangeEventTypes).ISSUE_LINK_DELETED) {
        const issuesToUpdate = [
            payload.issueId,
            payload.meta.linkedIssueId
        ];
        return [
            (0, $4RVsR.fetchIssueLinksStats)(issuesToUpdate)
        ];
    }
    const missingParents = (0, $67Z81.getMissingParents)(state);
    if (isCMPBoard && missingParents[Number(payload.issueId)]) {
        const mapMissingParentResult = (0, $2ZOF9.mapBentoResponseToMissingParent)(missingParents[Number(payload.issueId)], payload);
        if (!mapMissingParentResult) return null;
        return [
            mapMissingParentResult
        ];
    }
    const issueParents = (0, $bSSdD.getIssueParents)(state);
    if (issueParents[payload.issueId]) {
        const mapResult = (0, $6zzBT.mapBentoResponseToIssueParent)(issueParents[payload.issueId], state, payload, action.meta.transactionId);
        if (!mapResult) return null;
        return [
            mapResult
        ];
    }
    const issue = (0, $67Z81.getIssues)(state)[payload.issueId] || (0, $3UY9S.getIssueChildren)(state)[payload.issueId];
    if (!issue) // if issue does not exist on board, check if its status is changed to status on board and refresh data
    return (0, $lSEpr.checkIssueStatusRemapped)(state, payload) ? [
        (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$443de2b93e4aa6c6))
    ] : null;
    const mapResult = (0, $lSEpr.mapBentoResponseToIssue)(issue, state, payload, action.meta.transactionId);
    if (!mapResult) return null;
    // If the status of the issue is unmapped trigger a flag
    if ((0, $lSEpr.checkIssueStatusUnmapped)(state, payload)) return [
        mapResult,
        (0, $ls4NM.cardCreateUnmapped)([
            issue.key
        ])
    ];
    return [
        mapResult
    ];
};
const $dce0b88d04659266$var$ACTIONS_THAT_DONT_TRIGGER_REFRESH = [
    (0, $2f454.CARD_DATA_SET),
    (0, $cW3pH.WORK_REFRESH_DATA)
];
const $dce0b88d04659266$export$9df2b0b3d6b0f9c3 = (action$, store)=>action$.ofType((0, $evkwq.ISSUE_BENTO_UPDATE)).mergeMap((action)=>{
        const state = store.getState();
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        const actions = $dce0b88d04659266$var$mapPayloadToActions(state, action, isCMPBoard);
        if (isCMPBoard && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(actions)) // If we get a card data set action it means we have interpretted it properly and handled it
        // internally and do NOT need to fire any APIs
        {
            if (!actions.find(({ type: type })=>$dce0b88d04659266$var$ACTIONS_THAT_DONT_TRIGGER_REFRESH.includes(type))) // Otherwise we refresh everything.....
            // NOTE: Once we have relay we can simplify this OR we could look into extending the
            // existing query used in src/packages/software/board/src/ops/card/card-refresh-epic.tsx
            actions.push((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$9808bb47382c679c)));
        }
        return actions ? (0, $kVLXA.Observable).from(actions) : (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("FTaAj", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $0a7f3a2a8450d0c8$export$8db21fc94823e1cc);
const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $0a7f3a2a8450d0c8$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $0a7f3a2a8450d0c8$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $0a7f3a2a8450d0c8$export$8db21fc94823e1cc = {
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED,
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED,
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGED,
    [$0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED,
    [$0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED]: $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED,
    [$0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED]: $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED,
    [$0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED]: $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED,
    [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED,
    [$0a7f3a2a8450d0c8$var$SUBTASK_ADDED]: $0a7f3a2a8450d0c8$var$SUBTASK_ADDED,
    [$0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED,
    [$0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});

parcelRegister("6zzBT", function(module, exports) {

$parcel$export(module.exports, "mapBentoResponseToIssueParent", () => $3eb64125839942ef$export$71bd8f52850c3034);

var $hGgHi = parcelRequire("hGgHi");

var $gULOk = parcelRequire("gULOk");

var $FTaAj = parcelRequire("FTaAj");



var $3n65g = parcelRequire("3n65g");

var $71oFY = parcelRequire("71oFY");

var $evkwq = parcelRequire("evkwq");

var $cW3pH = parcelRequire("cW3pH");
const $3eb64125839942ef$export$4ec695d64c39a571 = [
    'description',
    'assignee',
    'status',
    'labels',
    'reporter'
];
const $3eb64125839942ef$export$71bd8f52850c3034 = (issueParent, state, payload, transactionId)=>{
    if (!payload.type || !issueParent) return null;
    const { type: type } = payload;
    /* uncomment when https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/pull-requests/20736 merged */ if (type === (0, $FTaAj.ChangeEventTypes).ISSUE_TYPE_CHANGED /* || type === ChangeEventTypes.ISSUE_COVER_SET */ ) return null;
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGE_REQUESTED && payload.meta.fieldId === 'summary') return (0, $3n65g.setIssueParentSummary)(Number(payload.issueId), payload.meta.fieldValue);
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGE_FAILED && payload.meta.fieldId === 'summary') return (0, $evkwq.issueUpdateRequestWithTransactionId)([
        issueParent.id
    ], (0, $f32ae13c2b9742f4$export$306c754c61954570), transactionId);
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED && payload.meta.fieldId !== 'summary' && !$3eb64125839942ef$export$4ec695d64c39a571.includes(payload.meta.fieldId)) return (0, $evkwq.issueUpdateRequestWithTransactionId)([
        issueParent.id
    ], (0, $f32ae13c2b9742f4$export$306c754c61954570), transactionId);
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED) {
        if (payload.meta.fieldId === 'status' && payload.meta.fieldValue && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(payload.meta.fieldValue.id) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(payload.meta.fieldValue.name) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(payload.meta.fieldValue.statusCategory)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const { id: id, name: name, statusCategory: statusCategory } = payload.meta.fieldValue;
            const status = {
                id: id,
                name: name,
                category: (0, $gULOk.statusCategoryForId)(statusCategory.id)
            };
            return (0, $3n65g.setIssueParentStatus)(Number(payload.issueId), status);
        }
    }
    if (payload.type === (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_ADDED) return (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$9808bb47382c679c));
    if (payload.type === (0, $FTaAj.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED) {
        const meta = {
            issueIds: payload.meta.issueIds.map((id)=>Number(id)),
            rankId: payload.meta.rankId,
            isRankAfter: payload.meta.isRankAfter
        };
        return (0, $71oFY.setIssuesRank)(meta);
    }
    return null;
};

});

parcelRegister("lSEpr", function(module, exports) {

$parcel$export(module.exports, "checkIssueStatusUnmapped", () => $8a82c1f355cb7bb5$export$4db59565c47f54df);
$parcel$export(module.exports, "checkIssueStatusRemapped", () => $8a82c1f355cb7bb5$export$c6b04776cded39e0);
$parcel$export(module.exports, "mapBentoResponseToIssue", () => $8a82c1f355cb7bb5$export$e896a8751ab959a2);

var $5rFbt = parcelRequire("5rFbt");

var $FTaAj = parcelRequire("FTaAj");

var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");



var $2f454 = parcelRequire("2f454");

var $4gHuj = parcelRequire("4gHuj");

var $evkwq = parcelRequire("evkwq");

var $cW3pH = parcelRequire("cW3pH");

var $fyeGd = parcelRequire("fyeGd");

var $4gt6L = parcelRequire("4gt6L");
const $8a82c1f355cb7bb5$export$c6057a4504428e8e = [
    'description',
    'reporter'
];
const $8a82c1f355cb7bb5$export$c8a3dfc27ec07f10 = [
    'reporter'
];
const $8a82c1f355cb7bb5$export$fbd9c46dbe46d35d = [
    'summary',
    'assignee',
    'labels'
];
const $8a82c1f355cb7bb5$export$855877a195ad3aa9 = [
    'assignee'
];
const $8a82c1f355cb7bb5$var$FieldsWithOptimisticCardUpdate = new Set([
    (0, $5fc53.STATUS_TYPE),
    (0, $5fc53.SUMMARY_TYPE)
]);
const $8a82c1f355cb7bb5$var$updateAssignee = (meta, issue)=>{
    if (meta.fieldValue === null) return (0, $2f454.cardDataSet)({
        ...issue,
        assigneeAccountId: null
    }, undefined, (0, $f32ae13c2b9742f4$export$306c754c61954570));
    const avatars = (0, $g5X3G.values)(meta.fieldValue.avatarUrls);
    return (0, $2f454.cardDataSet)({
        ...issue,
        assigneeAccountId: meta.fieldValue.accountId
    }, {
        id: meta.fieldValue.accountId,
        displayName: meta.fieldValue.displayName,
        avatarUrl: String(avatars[0])
    }, (0, $f32ae13c2b9742f4$export$306c754c61954570));
};
const $8a82c1f355cb7bb5$export$4db59565c47f54df = (state, payload)=>{
    // to check unmapped status make sure field being updated is status
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED && payload.meta.fieldId === (0, $5fc53.STATUS_TYPE)) {
        const statusIdsOfColumns = (0, $fyeGd.getStatusIdsOfColumns)(state);
        return !statusIdsOfColumns.includes(Number(payload.meta.fieldValue.id));
    }
    return false;
};
const $8a82c1f355cb7bb5$export$c6b04776cded39e0 = (state, payload)=>{
    // Check if issue's status is changed to status mapped to board
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED && payload.meta.fieldId === (0, $5fc53.STATUS_TYPE)) {
        const statusIdsOfColumns = (0, $fyeGd.getStatusIdsOfColumns)(state);
        return statusIdsOfColumns.includes(Number(payload.meta.fieldValue.id));
    }
    return false;
};
const $8a82c1f355cb7bb5$export$e896a8751ab959a2 = (issue, state, payload, transactionId)=>{
    if (!payload.type || !issue) return null;
    const { meta: meta, type: type } = payload;
    if (type === (0, $FTaAj.ChangeEventTypes).ISSUE_TYPE_CHANGED) {
        const issueTypeName = meta.typeName || null;
        if (!issueTypeName) return null;
        const issueType = (0, $4gt6L.issueBaseTypesSelector)(state).find((issueBaseType)=>issueBaseType.name === issueTypeName);
        if (!issueType) return (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$9808bb47382c679c));
        return (0, $2f454.cardDataSet)({
            ...issue,
            typeId: Number(issueType.id),
            typeName: issueType.name,
            typeUrl: issueType.iconUrl
        }, undefined, (0, $f32ae13c2b9742f4$export$306c754c61954570));
    }
    // If we get a field change request, try to handle it internally (without another API call)
    // Otherwise fire an action or do nothing for CMP
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGE_REQUESTED) switch(payload.meta.fieldId){
        case 'assignee':
            return $8a82c1f355cb7bb5$var$updateAssignee(payload.meta, issue);
        case 'summary':
        case 'priority':
        case 'labels':
            return (0, $2f454.cardDataSet)({
                ...issue,
                [payload.meta.fieldId]: payload.meta.fieldValue
            }, undefined, (0, $f32ae13c2b9742f4$export$306c754c61954570));
        default:
            // Some fields have no impact on the rendering of the board so we just
            // ignore them
            if ($8a82c1f355cb7bb5$export$c8a3dfc27ec07f10.includes(payload.meta.fieldId)) return null; // null will catch in issue-bento-update-epic
            // If its CMP, There is no way to handle this yet. What happens normally in TMP
            // is we fire the `issueUpdateRequestWithTransactionId` action which in turn
            // fires a graphql query to fetch a new version of THAT card. This endpoint
            // doesn't officially support CMP as there are fields that we need for CMP
            // that aren't in the query
            return (0, $evkwq.issueUpdateRequestWithTransactionId)([
                issue.id
            ], (0, $f32ae13c2b9742f4$export$306c754c61954570), transactionId);
    }
    // Bento extracted fields, that can update optimistically as they fire "FIELD_CHANGED"
    // afteru sucess API call.
    const optimisticallyUpdatableFields = $8a82c1f355cb7bb5$var$FieldsWithOptimisticCardUpdate;
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED && optimisticallyUpdatableFields.has(payload.meta.fieldId)) {
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const column = (0, $fyeGd.columnByStatusIdSelector)(state, Number(payload.meta.fieldValue.id));
        if (!column || issue?.extraFields?.some((ef)=>ef.id === payload.meta.fieldId)) return (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$9808bb47382c679c));
        return (0, $2f454.cardDataSet)({
            ...issue,
            statusId: Number(payload.meta.fieldValue.id),
            columnId: column.id,
            isDone: column.type === (0, $5rFbt.ColumnType).STATUS ? column.statuses.some((status)=>status.isDone) : false
        }, undefined, (0, $f32ae13c2b9742f4$export$306c754c61954570));
    }
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED && $8a82c1f355cb7bb5$export$855877a195ad3aa9.includes(payload.meta.fieldId)) switch(payload.meta.fieldId){
        case 'assignee':
            {
                const currentAssignee = issue.assigneeAccountId;
                const payloadAssignee = payload.meta.fieldValue?.accountId || null;
                if (currentAssignee !== payloadAssignee) return $8a82c1f355cb7bb5$var$updateAssignee(payload.meta, issue);
                return null;
            }
        default:
            return null;
    }
    if (payload.type === (0, $FTaAj.ChangeEventTypes).ISSUE_RELATIONSHIP_UPDATED) return (0, $evkwq.setIssueParent)(issue.id, Number(payload.meta.newParentIssueId));
    if (payload.type === (0, $FTaAj.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED) {
        const setIssueChildrenRankPayload = {
            issueIds: payload.meta.issueIds.map((id)=>Number(id)),
            rankId: payload.meta.rankId,
            isRankAfter: payload.meta.isRankAfter
        };
        return (0, $4gHuj.setIssueChildrenRank)(setIssueChildrenRankPayload);
    }
    if (payload.type === (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_ADDED) return (0, $evkwq.issueUpdateRequestWithTransactionId)([
        issue.id
    ], (0, $f32ae13c2b9742f4$export$306c754c61954570), transactionId);
    if (payload.type === (0, $FTaAj.ChangeEventTypes).SUBTASK_ADDED) return (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$9808bb47382c679c));
    if (payload?.meta && 'fieldId' in payload.meta && payload.meta.fieldId && $8a82c1f355cb7bb5$export$c6057a4504428e8e.includes(payload.meta.fieldId)) return null;
    // Bento field update succeeded but change is not committed to the board yet via ChangeEventTypes.FIELD_CHANGE_REQUESTED
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED && !$8a82c1f355cb7bb5$export$fbd9c46dbe46d35d.includes(payload.meta.fieldId)) return (0, $evkwq.issueUpdateRequestWithTransactionId)([
        issue.id
    ], (0, $f32ae13c2b9742f4$export$306c754c61954570), transactionId);
    // Bento field update failed -> revert optimistic change
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGE_FAILED) return (0, $evkwq.issueUpdateRequestWithTransactionId)([
        issue.id
    ], (0, $f32ae13c2b9742f4$export$306c754c61954570), transactionId);
    return null;
};

});

parcelRegister("2ZOF9", function(module, exports) {

$parcel$export(module.exports, "mapBentoResponseToMissingParent", () => $41dc0733ef2ff99a$export$56b90e3b9a92ede);

var $FTaAj = parcelRequire("FTaAj");


var $cW3pH = parcelRequire("cW3pH");
const $41dc0733ef2ff99a$export$56b90e3b9a92ede = (missingParent, payload)=>{
    if (!payload.type || !missingParent) return null;
    /**
	 * we care about four fields change on the missing parent Bento
	 * 1.summary
	 * 2. status
	 * 3. assignee
	 * 4. epic
	 * Since the epic field is a custom field e.g. customfield_10014,
	 * we do backlisting instead of whitelisting
	 */ const ignoreFields = [
        'fixVersions',
        'labels',
        'priority',
        'timeoriginalestimate',
        'description',
        'votes'
    ];
    const { type: type, meta: meta } = payload;
    const monitoringTypes = [
        (0, $FTaAj.ChangeEventTypes).ISSUE_TYPE_CHANGED,
        (0, $FTaAj.ChangeEventTypes).SUBTASK_ADDED,
        (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_FIELD_UPDATED
    ];
    if (monitoringTypes.find((monitoringType)=>monitoringType === type) || type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED && !ignoreFields.includes(meta.fieldId)) return (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$9808bb47382c679c));
    return null;
};

});


parcelRegister("4rj2F", function(module, exports) {

$parcel$export(module.exports, "issueBulkUpdateEpic", () => $54b8f55f8043a932$export$8039b5375000d1f4);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $dJl1T = parcelRequire("dJl1T");

var $dMBwz = parcelRequire("dMBwz");
function $54b8f55f8043a932$export$8039b5375000d1f4(action$, store, { customRequestHandlers: customRequestHandlers }) {
    return action$.ofType((0, $dMBwz.ISSUE_BULK_UPDATE_REQUEST)).mergeMap((action)=>{
        const success = (response)=>{
            if (action.promise) action.promise.resolve(response);
            return (0, $kVLXA.Observable).of((0, $dMBwz.issueBulkUpdateSuccess)());
        };
        const error = (err)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('issue.issue-bulk-update.failure', 'Failed to bulk update on IP board', // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            err);
            if (action.promise) action.promise.reject(err);
            return (0, $kVLXA.Observable).of((0, $dMBwz.issueBulkUpdateFailed)());
        };
        if (!customRequestHandlers || !customRequestHandlers.bulkUpdateIssues) return error(new Error('no request handler found for bulk update'));
        return (0, $kVLXA.Observable).from(customRequestHandlers.bulkUpdateIssues(action.payload)).flatMap((response)=>success(response)).catch((err)=>error(err));
    });
}

});
parcelRegister("dMBwz", function(module, exports) {

$parcel$export(module.exports, "ISSUE_BULK_UPDATE_REQUEST", () => $9d161783e4afcb8e$export$5bfd2f80d856fe03);
$parcel$export(module.exports, "issueBulkUpdateRequest", () => $9d161783e4afcb8e$export$4d9d42d62d3b54f7);
$parcel$export(module.exports, "issueBulkUpdateSuccess", () => $9d161783e4afcb8e$export$4b88a56083e2ad37);
$parcel$export(module.exports, "issueBulkUpdateFailed", () => $9d161783e4afcb8e$export$383f6bf4f457791b);
const $9d161783e4afcb8e$export$5bfd2f80d856fe03 = 'state.actions.issue.bulk-update.ISSUE_BULK_UPDATE_REQUEST';
const $9d161783e4afcb8e$export$4d9d42d62d3b54f7 = (payload)=>({
        type: $9d161783e4afcb8e$export$5bfd2f80d856fe03,
        payload: payload
    });
const $9d161783e4afcb8e$export$2b99e3cfe4b3c804 = 'state.actions.issue.bulk-update.ISSUE_BULK_UPDATE_SUCCESS';
const $9d161783e4afcb8e$export$4b88a56083e2ad37 = ()=>({
        type: $9d161783e4afcb8e$export$2b99e3cfe4b3c804
    });
const $9d161783e4afcb8e$export$189459f8d84a28bc = 'state.actions.issue.bulk-update.ISSUE_BULK_UPDATE_FAILED';
const $9d161783e4afcb8e$export$383f6bf4f457791b = ()=>({
        type: $9d161783e4afcb8e$export$189459f8d84a28bc
    });

});


parcelRegister("fgxdE", function(module, exports) {

$parcel$export(module.exports, "issueChildrenInFinalColumnEpic", () => $93a9d883822ec989$export$79f7ca1c01707d22);
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $4R6GH = parcelRequire("4R6GH");

var $5bE6a = parcelRequire("5bE6a");

var $cMQ7P = parcelRequire("cMQ7P");

var $hdmw1 = parcelRequire("hdmw1");

var $4gHuj = parcelRequire("4gHuj");

var $cdcje = parcelRequire("cdcje");

var $lIysR = parcelRequire("lIysR");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");
function $93a9d883822ec989$export$79f7ca1c01707d22(action$, store) {
    return action$.ofType((0, $4gHuj.ISSUE_CHILDREN_IN_FINAL_COLUMN_REQUEST)).mergeMap((action)=>{
        const ctx = (0, $hdmw1.makeServiceContext)(store.getState());
        return (0, $cMQ7P.issueChildrenInFinalColumnService)(ctx, action.payload.parentId).flatMap(({ subtasksInFinalColumn: subtasksInFinalColumn })=>{
            if (subtasksInFinalColumn) {
                if (!(0, $4R6GH.fg)('jsw-update-parent-modal-check-transitions')) return (0, $kVLXA.Observable).of((0, $cdcje.showUpdateIssueParentModal)(action.payload.parentId, []));
                const { getState: getState } = store;
                const state = getState();
                const issueParent = (0, $67Z81.getIssues)(state)[action.payload.parentId] ?? null;
                const missingParent = (0, $67Z81.getMissingParents)(state)[action.payload.parentId] ?? null;
                const parentIssue = issueParent || missingParent;
                if (!parentIssue) return (0, $kVLXA.Observable).empty();
                const columns = (0, $fyeGd.orderedColumnsSelector)(state);
                const lastColumn = columns[columns.length - 1];
                const transitions = (0, $lIysR.transitionsByColumnIdSelector)(state)(lastColumn.id, parentIssue);
                if (!transitions || transitions.length === 0) return (0, $kVLXA.Observable).empty();
                const transitionsHaveConditions = transitions.some((transition)=>transition.hasConditions);
                if (!transitionsHaveConditions) return (0, $kVLXA.Observable).of((0, $cdcje.showUpdateIssueParentModal)(action.payload.parentId, transitions));
                const contextPath = (0, $67Z81.contextPathSelector)(state);
                const boardId = (0, $67Z81.rapidViewIdSelector)(state);
                return (0, $5bE6a.fetchCardIssueTransitionsService)(contextPath, boardId, parentIssue.id).flatMap((issueTransitions)=>{
                    const lastColumnStatuses = 'statuses' in lastColumn ? lastColumn.statuses.map((status)=>status.id) : [];
                    const validTransitions = issueTransitions.filter((transition)=>transition.isAvailable && lastColumnStatuses.includes(transition.destinationStatusId));
                    if (validTransitions.length > 0) return (0, $kVLXA.Observable).of((0, $cdcje.showUpdateIssueParentModal)(action.payload.parentId, validTransitions));
                    return (0, $kVLXA.Observable).empty();
                }).catch((err)=>{
                    (0, $dJl1T.default).safeErrorWithoutCustomerData('issue.issue-children-in-final-column.failure', 'Failed to check available transitions', err);
                    return (0, $kVLXA.Observable).empty();
                });
            }
            return (0, $kVLXA.Observable).empty();
        }).catch((err)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('issue.issue-children-in-final-column.failure', 'Failed to check if all issue children are in final column', err);
            return (0, $kVLXA.Observable).empty();
        });
    });
}

});
parcelRegister("cMQ7P", function(module, exports) {

$parcel$export(module.exports, "issueChildrenInFinalColumnService", () => $58d68d110824c01b$export$e8d6f9a2a40b6e2a);

var $aHvt6 = parcelRequire("aHvt6");
const $58d68d110824c01b$export$e8d6f9a2a40b6e2a = (ctx, parentId)=>(0, $aHvt6.issueChildrenInFinalColumnRest)(parentId, ctx.boardId);

});
parcelRegister("aHvt6", function(module, exports) {

$parcel$export(module.exports, "issueChildrenInFinalColumnRest", () => $3c53606ec990b560$export$3b598c13ea0c18af);

var $487fd = parcelRequire("487fd");
function $3c53606ec990b560$export$3b598c13ea0c18af(parentId, rapidViewId) {
    return (0, $487fd.default)(`/rest/greenhopper/1.0/xboard/issue/subtasksInFinalColumn.json?issueId=${parentId}&rapidViewId=${rapidViewId}`, {
        method: 'GET'
    });
}

});


parcelRegister("cdcje", function(module, exports) {

$parcel$export(module.exports, "SHOW_UPDATE_ISSUE_PARENT_MODAL", () => $ae592c453de648d6$export$8c94067b9b76f3d);
$parcel$export(module.exports, "showUpdateIssueParentModal", () => $ae592c453de648d6$export$eeb78f32bb6c8306);
$parcel$export(module.exports, "HIDE_UPDATE_ISSUE_PARENT_MODAL", () => $ae592c453de648d6$export$58fce3932176ed24);
$parcel$export(module.exports, "hideUpdateIssueParentModal", () => $ae592c453de648d6$export$6c8eb96d597d4f6c);
const $ae592c453de648d6$export$8c94067b9b76f3d = 'state.actions.issue.update-issue-parent-modal.SHOW_UPDATE_ISSUE_PARENT_MODAL';
const $ae592c453de648d6$export$eeb78f32bb6c8306 = (issueParentId, transitions)=>({
        type: $ae592c453de648d6$export$8c94067b9b76f3d,
        payload: {
            issueParentId: issueParentId,
            transitions: transitions
        }
    });
const $ae592c453de648d6$export$58fce3932176ed24 = 'state.actions.issue.update-issue-parent-modal.HIDE_UPDATE_ISSUE_PARENT_MODAL';
const $ae592c453de648d6$export$6c8eb96d597d4f6c = ()=>({
        type: $ae592c453de648d6$export$58fce3932176ed24
    });

});


parcelRegister("6Yser", function(module, exports) {

$parcel$export(module.exports, "default", () => $7754c640f8b7ce26$export$2e2bcd8739ae039);

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $dJl1T = parcelRequire("dJl1T");

var $4jAPy = parcelRequire("4jAPy");

var $2W0EG = parcelRequire("2W0EG");

var $fTVet = parcelRequire("fTVet");

var $3D2mY = parcelRequire("3D2mY");

var $lWvJn = parcelRequire("lWvJn");

var $ls4NM = parcelRequire("ls4NM");

var $65C0W = parcelRequire("65C0W");

var $9UXXB = parcelRequire("9UXXB");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");
const $7754c640f8b7ce26$var$createAndRankIssuesInIPBoard = (action, store, dependencies)=>{
    const { payload: { temporaryIssueIds: temporaryIssueIds, issues: optimisticIssues }, meta: { insertBefore: insertBefore, optimistic: { id: optimisticId }, columnIndex: columnIndex, cardIndex: cardIndex, analyticsEvent: analyticsEvent } } = action;
    const optimisticIssue = optimisticIssues[0];
    const { projectId: projectId, typeId: typeId } = optimisticIssue;
    const state = store.getState();
    const customRequestHandlers = dependencies ? dependencies.customRequestHandlers : {};
    const incrementConfig = (0, $67Z81.getIncrementConfig)(state);
    const validateError = (analyticEvent, err)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('create.scenario.issue.validate.failure', 'planId, scenarioId and incrementconfig cannot be null in IP board', err);
        return (0, $kVLXA.Observable).of((0, $ls4NM.issueCreateIPValidateFailure)(analyticEvent, err));
    };
    const onError = (error, source)=>{
        const errorCollection = (0, $2W0EG.parseErrorCollection)(error.message);
        // error is a SwagError which contains nested objects
        // nested objects are not accepted by the backend
        const flattenedError = new Error(error.message);
        flattenedError.stack = error.stack;
        flattenedError.name = error.name;
        // @ts-expect-error - TS2339 - Property 'traceId' does not exist on type 'Error'.
        flattenedError.traceId = error.traceId;
        (0, $dJl1T.default).safeErrorWithoutCustomerData('board.issue-create.failure', `Failed to ${source} when create issue in IP board`, flattenedError);
        if (error.message === (0, $4jAPy.CUSTOM_FIELD_OPTION_MISSED_ERROR)) {
            const boardScopeFilter = incrementConfig?.boardScopeFilter;
            return (0, $kVLXA.Observable).from([
                (0, $ls4NM.customFieldMissedInIPBoard)({
                    fieldValue: boardScopeFilter?.filterFieldValue || '',
                    issueTypeName: (0, $d2i8f.getIssueTypeById)(state, typeId).name,
                    projectName: (0, $67Z81.getIssueProjects)(state)[projectId].name,
                    fieldName: boardScopeFilter?.filterFieldName || ''
                }),
                (0, $ls4NM.issueCreateFailure)(optimisticId, analyticsEvent, error)
            ]);
        }
        return (0, $kVLXA.Observable).from([
            (0, $ls4NM.issueCreateFailure)(optimisticId, analyticsEvent, error),
            (0, $65C0W.displayWarning)(errorCollection ? (0, $2W0EG.flatErrorCollection)(errorCollection) : errorCollection)
        ]);
    };
    const onSuccess = (issue)=>(0, $kVLXA.Observable).of((0, $ls4NM.issueCreateSuccess)(optimisticId, temporaryIssueIds, [
            issue
        ], columnIndex, cardIndex, analyticsEvent));
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(incrementConfig)) return validateError(analyticsEvent, new Error('incrementconfig cannot be null'));
    if (!customRequestHandlers || !customRequestHandlers.rankIssue) return validateError(analyticsEvent, new Error('no request handler found for creating or ranking issues'));
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectId)) return validateError(analyticsEvent, new Error('projectId for new issue cannot be null'));
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(typeId)) return validateError(analyticsEvent, new Error('issue typeId for new issue cannot be null'));
    const { rankIssue: rankIssue } = customRequestHandlers;
    const doRank = (issue)=>(0, $lWvJn.issueRankJPOService)({
            issueIds: [
                issue.id
            ],
            rankBeforeIssueId: insertBefore,
            isLastPosition: (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(insertBefore),
            requestHandler: rankIssue
        }).flatMap(()=>onSuccess(issue)).catch((error)=>onError(error, 'rank'));
    return (0, $3D2mY.default)(store.getState(), incrementConfig, optimisticIssues[0], customRequestHandlers).flatMap((issue)=>doRank(issue)).catch((error)=>onError(error, 'addIssue'));
};
const $7754c640f8b7ce26$var$createAndRankIssues = (action, store)=>{
    const { payload: { temporaryIssueIds: temporaryIssueIds, issues: optimisticIssues }, meta: { insertBefore: insertBefore, optimistic: { id: optimisticId }, columnIndex: columnIndex, cardIndex: cardIndex, analyticsEvent: analyticsEvent, transitionInfo: transitionInfo, swimlaneId: swimlaneId } } = action;
    const shouldCreateWithSwimlaneContext = (0, $9UXXB.getShouldCreateWithSwimlaneContext)(store.getState())(swimlaneId);
    return (0, $fTVet.default)(store.getState(), insertBefore, optimisticIssues, transitionInfo, shouldCreateWithSwimlaneContext ? swimlaneId : undefined).flatMap((issues)=>(0, $kVLXA.Observable).of((0, $ls4NM.issueCreateSuccess)(optimisticId, temporaryIssueIds, issues, columnIndex, cardIndex, analyticsEvent))).catch((error)=>{
        const errorCollection = (0, $2W0EG.parseErrorCollection)(error.message);
        // error is a SwagError which contains nested objects
        // nested objects are not accepted by the backend
        const flattenedError = new Error(error.message);
        flattenedError.stack = error.stack;
        flattenedError.name = error.name;
        // @ts-expect-error - TS2339 - Property 'traceId' does not exist on type 'Error'.
        flattenedError.traceId = error.traceId;
        (0, $dJl1T.default).safeErrorWithoutCustomerData('board.issue-create.failure', 'Failed to create issue', flattenedError);
        return (0, $kVLXA.Observable).from([
            (0, $ls4NM.issueCreateFailure)(optimisticId, analyticsEvent, error),
            (0, $65C0W.displayWarning)(errorCollection ? (0, $2W0EG.flatErrorCollection)(errorCollection) : errorCollection)
        ]);
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7754c640f8b7ce26$export$2e2bcd8739ae039 = (action$, store, dependencies)=>action$.ofType((0, $ls4NM.ISSUE_CREATE_REQUEST)).mergeMap((action)=>{
        if ((0, $67Z81.getIsIncrementPlanningBoard)(store.getState())) return $7754c640f8b7ce26$var$createAndRankIssuesInIPBoard(action, store, dependencies);
        return $7754c640f8b7ce26$var$createAndRankIssues(action, store);
    });

});
parcelRegister("fTVet", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c2f1692294fadd4$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $4R6GH = parcelRequire("4R6GH");

var $3bjR0 = parcelRequire("3bjR0");

var $gXFr2 = parcelRequire("gXFr2");

var $9UXXB = parcelRequire("9UXXB");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");
const $0c2f1692294fadd4$export$6b468dcfb64c653c = (state, response, optimisticIssues, transitionInfo)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(response.boardCardCreate)) return [];
    return response?.boardCardCreate?.newCards?.filter((card)=>card != null)?.map((card, index)=>{
        const { id: id, issue: { key: key } } = card;
        const { summary: summary, statusId: statusId, columnId: columnId, projectId: projectId, typeId: typeId, isDone: isDone, parentId: parentId, estimate: estimate, priority: priority, dueDate: dueDate, numCompleteChildren: numCompleteChildren, numTotalChildren: numTotalChildren, assigneeAccountId: assigneeAccountId, labels: labels, sprintId: sprintId, fixVersions: fixVersions } = optimisticIssues[index];
        const { name: typeName, iconUrl: typeUrl } = (0, $d2i8f.getIssueTypeById)(state, typeId);
        return {
            id: Number(id),
            key: String(key),
            summary: summary,
            statusId: transitionInfo ? transitionInfo.statusId : statusId,
            columnId: columnId,
            projectId: projectId,
            typeId: typeId,
            typeName: typeName,
            typeUrl: typeUrl,
            assigneeAccountId: assigneeAccountId,
            labels: labels,
            isDone: isDone,
            parentId: parentId,
            estimate: estimate,
            priority: priority,
            dueDate: dueDate,
            numCompleteChildren: numCompleteChildren,
            numTotalChildren: numTotalChildren,
            sprintId: sprintId,
            fixVersions: fixVersions
        };
    }) ?? [];
};
const $0c2f1692294fadd4$export$66141e785ca0d76 = (optimisticIssues)=>optimisticIssues.map((issue)=>{
        const { assigneeAccountId: assigneeAccountId, typeId: typeId, labels: labels, parentId: parentId, summary: summary } = issue;
        return {
            assigneeId: assigneeAccountId != null ? String(assigneeAccountId) : null,
            fixVersions: [],
            issueTypeId: typeId != null ? String(typeId) : '',
            labels: labels,
            parentId: parentId != null ? String(parentId) : null,
            summary: summary
        };
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0c2f1692294fadd4$export$2e2bcd8739ae039 = (state, rankBeforeCardId = null, optimisticIssues, transitionInfo, swimlaneId)=>{
    const transitionInfoForNewIssues = transitionInfo || ((0, $4R6GH.fg)('use_backend_tmp_icc_config_') ? (0, $gXFr2.transitionIDForCardCreateSelectorNew)(state)(optimisticIssues[0].columnId, optimisticIssues[0].typeId) : (0, $gXFr2.transitionIDForCardCreateSelector)(state)(optimisticIssues[0].columnId, optimisticIssues[0].typeId));
    const { sprintId: sprintId = '' } = optimisticIssues?.[0] ?? {};
    return (0, $3bjR0.default)((0, $67Z81.contextPathSelector)(state), {
        boardId: (0, $67Z81.rapidViewIdSelector)(state),
        cardTransitionId: transitionInfoForNewIssues?.transitionId || null,
        rankBeforeCardId: rankBeforeCardId,
        newCards: $0c2f1692294fadd4$export$66141e785ca0d76(optimisticIssues),
        ...sprintId ? {
            destinationId: sprintId
        } : {},
        requireJqlContext: (0, $9UXXB.getIsCustomBoardWithIcc)(state),
        ...swimlaneId ? {
            swimlaneId: swimlaneId
        } : {}
    }).flatMap((result)=>(0, $kVLXA.Observable).of($0c2f1692294fadd4$export$6b468dcfb64c653c(state, result, optimisticIssues, transitionInfoForNewIssues)));
};

});
parcelRegister("3bjR0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0aab4220ed333b77$export$2e2bcd8739ae039);

var $ivqh1 = parcelRequire("ivqh1");

var $6iJbJ = parcelRequire("6iJbJ");

var $CFxE9 = parcelRequire("CFxE9");
const $0aab4220ed333b77$var$boardCardCreateOperationName = 'BoardCardCreate';
const $0aab4220ed333b77$export$86b8d46928cd7bbb = (0, $ivqh1.gqlTagSwag)`
mutation BoardCardCreate (
    $boardId: ID!,
    $cardTransitionId: ID,
    $rankBeforeCardId: Long,
    $newCards: [NewCard]!
    $destinationId: ID,
    $requireJqlContext: Boolean
	$swimlaneId: ID
) {
    boardCardCreate(input: {
        boardId: $boardId,
        cardTransitionId: $cardTransitionId,
        rankBeforeCardId: $rankBeforeCardId,
        newCards: $newCards
        destinationId: $destinationId
        requireJqlContext: $requireJqlContext
		swimlaneId: $swimlaneId
        
    }) {
        newCards {
            id
            issue {
                key
            }
        }
    }
}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0aab4220ed333b77$export$2e2bcd8739ae039 = (baseUrl, input)=>{
    const { boardId: boardId, cardTransitionId: cardTransitionId, rankBeforeCardId: rankBeforeCardId, newCards: newCards, destinationId: destinationId, requireJqlContext: requireJqlContext, swimlaneId: swimlaneId } = input;
    const variables = {
        boardId: boardId,
        cardTransitionId: cardTransitionId,
        rankBeforeCardId: rankBeforeCardId,
        newCards: newCards,
        ...destinationId ? {
            destinationId: destinationId
        } : {},
        requireJqlContext: requireJqlContext,
        ...swimlaneId ? {
            swimlaneId: swimlaneId
        } : {}
    };
    return (0, $6iJbJ.mutation$)(baseUrl, $0aab4220ed333b77$var$boardCardCreateOperationName, $0aab4220ed333b77$export$86b8d46928cd7bbb, variables, (0, $CFxE9.cardCreateAnalyticsOptions));
};

});

parcelRegister("gXFr2", function(module, exports) {

$parcel$export(module.exports, "allowedCardTypesForIccSelector", () => $8133e73592e62d8c$export$f22a16f57b3ae991);
$parcel$export(module.exports, "transitionIDForCardCreateSelector", () => $8133e73592e62d8c$export$9f36396280765a13);
$parcel$export(module.exports, "transitionIDForCardCreateSelectorNew", () => $8133e73592e62d8c$export$57f8a50673eeab03);
$parcel$export(module.exports, "getInitialTransitionsForColumn", () => $8133e73592e62d8c$export$41c8dd7cee50a968);
$parcel$export(module.exports, "makeGetStatusTransitionsForType", () => $8133e73592e62d8c$export$ec7e6959583c9985);
$parcel$export(module.exports, "manageIssueTypesLinkSelector", () => $8133e73592e62d8c$export$ddd0d47434cf9e05);
$parcel$export(module.exports, "getIssueProjectsForIssueCreation", () => $8133e73592e62d8c$export$2c1218071d6b5bb2);
$parcel$export(module.exports, "getDefaultProjectIdForIssueCreation", () => $8133e73592e62d8c$export$6b08fee64011acdb);
$parcel$export(module.exports, "getIssueTypesForIssueCreation", () => $8133e73592e62d8c$export$de67b2a86891c711);
$parcel$export(module.exports, "getParentIdForIssueCreation", () => $8133e73592e62d8c$export$8b1e452ee0e8eef0);
$parcel$export(module.exports, "getDestinationStatusSelector", () => $8133e73592e62d8c$export$26a46ce3707c0a02);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $9XE6b = parcelRequire("9XE6b");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $gJBT6 = parcelRequire("gJBT6");

var $vNXgH = parcelRequire("vNXgH");

var $2vSU6 = parcelRequire("2vSU6");

var $gULOk = parcelRequire("gULOk");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $g4tDr = parcelRequire("g4tDr");

var $02Psx = parcelRequire("02Psx");

var $eph8m = parcelRequire("eph8m");

var $iuuJH = parcelRequire("iuuJH");

var $c79wa = parcelRequire("c79wa");

var $fyeGd = parcelRequire("fyeGd");

var $9UXXB = parcelRequire("9UXXB");

var $4gt6L = parcelRequire("4gt6L");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");
const $8133e73592e62d8c$export$f22a16f57b3ae991 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions),
    (0, $4gt6L.issueBaseTypesSelector),
    (0, $4gt6L.issueChildrenTypesSelector),
    (0, $5mTgl.getHasAppliedEpicFilters),
    (0, $9UXXB.createIsIccEnabledForCardType),
    (0, $67Z81.getIsCMPBoard),
    (0, $45cXl.getSwimlaneMode),
    (0, $5mTgl.getAppliedIssueTypeFilters)
], (cardTransitions, baseIssueTypes, issueChildrenIssueTypes, hasAppliedEpicFilters, isIccEnabledForCardType, isCMPBoard, swimlaneMode, issueTypeFilters)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnId, swimlaneId, isAddingSubtaskToGroup)=>{
        let types = baseIssueTypes;
        let shouldFilterOutEpicIssueTypes = false;
        let shouldFilterOutChildIssueTypes = false;
        const isSubtaskSwimlane = swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && swimlaneId !== (0, $c79wa.ChildlessSwimlane).id && swimlaneId !== null;
        if (isSubtaskSwimlane || isAddingSubtaskToGroup) types = issueChildrenIssueTypes;
        else {
            shouldFilterOutEpicIssueTypes = hasAppliedEpicFilters || swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id;
            shouldFilterOutChildIssueTypes = true;
        }
        return types.filter((issueType)=>{
            if (shouldFilterOutChildIssueTypes && issueType.hierarchyLevelType === (0, $g4tDr.CHILD_HIERARCHY_TYPE)) return false;
            if (shouldFilterOutEpicIssueTypes && issueType.hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE)) return false;
            if (issueTypeFilters?.length && !issueTypeFilters.includes(issueType.id)) return false;
            // This is a temporary condition to fix a bug until use_backend_tmp_icc_config_ is rolled out
            // Delete this condition when cleaning up use_backend_tmp_icc_config_
            if (isCMPBoard && (0, $4R6GH.fg)('jsw-cmp-icc-unmapped-status-bugfix')) return isIccEnabledForCardType(columnId, issueType.id);
            return (0, $4R6GH.fg)('use_backend_tmp_icc_config_') ? isIccEnabledForCardType(columnId, issueType.id) : (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(cardTransitions, [
                'columnIssueTypeTransitions',
                columnId,
                issueType.id
            ], []).some((transition)=>transition.isInitial || transition.isGlobal);
        });
    }, (columnId, swimlaneId, isAddingSubtaskToGroup)=>`${columnId}:${swimlaneId || ''}${isAddingSubtaskToGroup ? ':subtask' : ''}}`));
const $8133e73592e62d8c$export$9f36396280765a13 = (0, $dGvGJ.createSelector)((0, $67Z81.getCardTransitions), (cardTransitions)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnId, issueTypeId)=>{
        // check if there is an initial transition, if there is no need to pass anything
        const initialTransition = cardTransitions.columnIssueTypeTransitions[String(columnId)]?.[String(issueTypeId)]?.find((transition)=>transition.isInitial);
        if (initialTransition) return {
            transitionId: null,
            statusId: initialTransition.destinationStatusId
        };
        const globalTransition = cardTransitions.columnIssueTypeTransitions[String(columnId)]?.[String(issueTypeId)].find((transition)=>transition.isGlobal);
        if (globalTransition) return {
            transitionId: String(globalTransition.id),
            statusId: globalTransition.destinationStatusId
        };
        // this is an error state, card create is not possible without initial or global transition
        return null;
    }, (columnId, issueTypeId)=>`${columnId}:${issueTypeId}`));
const $8133e73592e62d8c$export$57f8a50673eeab03 = (0, $dGvGJ.createSelector)((0, $67Z81.getCardTransitions), (cardTransitions)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnId, issueTypeId)=>{
        if (Object.values(cardTransitions.columnIssueTypeTransitions).every((issueTypeTransitions)=>(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issueTypeTransitions))) // User probably doesn't have transition permissions
        return null;
        const columnIssueTypeTransitions = cardTransitions.columnIssueTypeTransitions[String(columnId)];
        // check if there is an initial transition, if there is no need to pass anything
        const initialTransition = columnIssueTypeTransitions?.[String(issueTypeId)]?.find((transition)=>transition.isInitial);
        if (initialTransition) return {
            transitionId: null,
            statusId: initialTransition.destinationStatusId
        };
        const globalTransition = columnIssueTypeTransitions?.[String(issueTypeId)]?.find((transition)=>transition.isGlobal);
        if (globalTransition) return {
            transitionId: String(globalTransition.id),
            statusId: globalTransition.destinationStatusId
        };
        (0, $jcw0u.default)({
            error: new Error(`No initial or global transition found for column ${columnId} and issue type ${issueTypeId}`),
            meta: {
                // Remove `new` from id when cleaning up `use_backend_tmp_icc_config_`
                id: 'board.cardCreateSelectors.transitionIDForCardCreateSelectorNew.missing.transition',
                packageName: 'jiraSoftwareBoard',
                teamName: 'a4t-tanuki'
            }
        });
        // this is an error state, card create is not possible without initial or global transition
        return null;
    }, (columnId, issueTypeId)=>`${columnId}:${issueTypeId}`));
const $8133e73592e62d8c$var$checkIfTransitionIsEqual = (source, target)=>source.statusId === target.statusId;
const $8133e73592e62d8c$export$41c8dd7cee50a968 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions)
], (cardTransitions)=>(columnId)=>cardTransitions.columnIssueTypeTransitions[String(columnId)]);
const $8133e73592e62d8c$export$ec7e6959583c9985 = (0, $dGvGJ.createSelector)([
    (0, $fyeGd.getStatusesByColumnId),
    (0, $4gt6L.defaultIssueTypeIdSelector),
    (0, $4gt6L.issueBaseTypesSelector)
], (statusesByColumnId, defaultIssueTypeId, projectIssueTypes)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnId, issueTypeTransitions, selectedIssueTypeId)=>{
        if (!issueTypeTransitions) return [];
        const statuses = statusesByColumnId(columnId);
        const issueTypeId = selectedIssueTypeId ?? defaultIssueTypeId ?? projectIssueTypes?.[0]?.id;
        if (!issueTypeId) return [];
        const transitionsForIssueType = issueTypeTransitions[String(issueTypeId)];
        const statusTransitions = transitionsForIssueType?.reduce((acc, transition)=>{
            if (transition.isInitial || transition.isGlobal) {
                const toStatus = statuses.find((status)=>status.id === transition.destinationStatusId);
                if (toStatus) acc.push({
                    transitionId: transition.id,
                    name: toStatus.name,
                    statusId: toStatus.id,
                    isInitial: transition.isInitial,
                    statusCategoryId: (0, $gULOk.categoryIdForStatusCategory)(toStatus.category)
                });
            }
            return acc;
        }, []) || [];
        const deduplicatedTransitions = (0, (/*@__PURE__*/$parcel$interopDefault($vNXgH)))(statusTransitions, $8133e73592e62d8c$var$checkIfTransitionIsEqual);
        return deduplicatedTransitions.length > 1 ? deduplicatedTransitions : [];
    }, (columnId, _, selectedIssueTypeId)=>`${columnId}:${selectedIssueTypeId}`));
const $8133e73592e62d8c$export$ddd0d47434cf9e05 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIsCMPBoard),
    (0, $67Z81.projectKeySelector)
], (isCMPBoard, projectKey)=>isCMPBoard ? (0, $eph8m.getIssueTypesUrl)(projectKey) : (0, $02Psx.getNextgenSettingsIssueTypesUrl)((0, $2vSU6.SOFTWARE_PROJECT), projectKey));
const $8133e73592e62d8c$export$2c1218071d6b5bb2 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssueProjects),
    (0, $67Z81.getIssueTypesByProject),
    (0, $67Z81.getIsIncrementPlanningBoard)
], (issueProjects, issueTypesByProject, isIPBoard)=>{
    if (!isIPBoard) return issueProjects;
    const initialProjects = {};
    // Filter out projects that don't have story or epic level issue types
    return Object.entries(issueProjects).reduce((acc, [projectKey, project])=>{
        const projectIssueTypes = issueTypesByProject[project.id];
        if (projectIssueTypes?.some((issueType)=>issueType.hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE) || issueType.hierarchyLevelType === (0, $g4tDr.BASE_HIERARCHY_TYPE))) acc[projectKey] = project;
        return acc;
    }, initialProjects);
});
const $8133e73592e62d8c$export$6b08fee64011acdb = (0, $dGvGJ.createSelector)([
    $8133e73592e62d8c$export$2c1218071d6b5bb2,
    (0, $67Z81.projectIdSelector)
], (allIssueProjects, projectIdFromConfiguration)=>{
    const projectFromConfiguration = allIssueProjects[projectIdFromConfiguration];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectFromConfiguration)) return projectIdFromConfiguration;
    const projectKeys = Object.keys(allIssueProjects);
    return projectKeys.length > 0 ? Number(projectKeys[0]) : undefined;
});
const $8133e73592e62d8c$var$emptyArray = (0, $7uUwQ.freeze)([]);
const $8133e73592e62d8c$export$de67b2a86891c711 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssueTypesByProject),
    (0, $67Z81.getIsIncrementPlanningBoard)
], (issueTypesByProject, isIPBoard)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((projectId)=>{
        if (isIPBoard && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueTypesByProject)) return issueTypesByProject[`${projectId}`] ?? $8133e73592e62d8c$var$emptyArray;
        return $8133e73592e62d8c$var$emptyArray;
    }));
const $8133e73592e62d8c$export$8b1e452ee0e8eef0 = (0, $dGvGJ.createSelector)([
    (0, $5mTgl.lastFilteredIssueParentIdSelector),
    (0, $67Z81.getIssues),
    (0, $67Z81.getIsIncrementPlanningBoard)
], (lastFilteredIssueParentId, issues, isIPBoard)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((projectId)=>{
        if (!isIPBoard) return lastFilteredIssueParentId;
        // for the IP board, we should check if the epic belongs to the project
        const parentIssue = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(lastFilteredIssueParentId) ? null : issues[lastFilteredIssueParentId];
        return parentIssue?.projectId === projectId ? lastFilteredIssueParentId : null;
    }));
const $8133e73592e62d8c$export$26a46ce3707c0a02 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions)
], (cardTransitions)=>(columnId, issueTypeId, transitionId)=>{
        const { columnIssueTypeTransitions: columnIssueTypeTransitions, issueTypeStatus: issueTypeStatus } = cardTransitions;
        const transitionsByIssueType = columnIssueTypeTransitions[columnId];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transitionsByIssueType)) return null;
        const transition = transitionsByIssueType[issueTypeId]?.find((trans)=>trans.id === transitionId);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transition) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transition.destinationStatusId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueTypeStatus[issueTypeId])) return null;
        return issueTypeStatus[issueTypeId][transition.destinationStatusId];
    });

});
parcelRegister("vNXgH", function(module, exports) {

var $7CoLY = parcelRequire("7CoLY");
/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */ function $05f9a56040cc5a05$var$uniqWith(array, comparator) {
    comparator = typeof comparator == 'function' ? comparator : undefined;
    return array && array.length ? $7CoLY(array, undefined, comparator) : [];
}
module.exports = $05f9a56040cc5a05$var$uniqWith;

});



parcelRegister("3D2mY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f43b06f240ce3b7$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("fPS7b");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $fr1K2 = parcelRequire("fr1K2");

var $kVLXA = parcelRequire("kVLXA");

var $iHPnC = parcelRequire("iHPnC");

var $g4tDr = parcelRequire("g4tDr");

var $4jAPy = parcelRequire("4jAPy");

var $tZ4NF = parcelRequire("tZ4NF");

var $kgiLc = parcelRequire("kgiLc");

var $fyeGd = parcelRequire("fyeGd");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");
const $6f43b06f240ce3b7$var$getTeamId = (teamId)=>teamId === (0, $4jAPy.SWIMLANE_TEAMLESS) ? null : teamId;
const $6f43b06f240ce3b7$export$78f957e4bfdb730f = (optimisticIssue, dateFields, epicLevel, sprint)=>{
    const { projectId: projectId, teamId: teamId, typeId: typeId, summary: summary, parentId: parentId, color: color, estimate: estimate, customFields: customFields, labels: labels } = optimisticIssue;
    const team = $6f43b06f240ce3b7$var$getTeamId(teamId);
    const customFieldsInner = {
        ...customFields || {},
        ...dateFields.customFields || {}
    };
    return {
        project: projectId,
        ...!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(team) ? {
            team: team
        } : {},
        ...!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(labels) && labels.length > 0 ? {
            labels: labels
        } : {},
        type: typeId,
        summary: summary,
        ...!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(parentId) ? {
            parent: String(parentId)
        } : {},
        estimate: estimate,
        ...epicLevel ? {
            color: $6f43b06f240ce3b7$var$getEpicColor(color)
        } : {},
        ...(0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(dateFields, 'customFields'),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(customFieldsInner) ? {} : {
            customFields: customFieldsInner
        },
        ...sprint && !epicLevel ? {
            sprint: `${sprint.id}`
        } : {}
    };
};
const $6f43b06f240ce3b7$var$setCustomFieldValue = (incrementConfig, optimisticIssue)=>{
    const { projectId: projectId, typeId: issueTypeId } = optimisticIssue;
    const boardScopeFilter = incrementConfig?.boardScopeFilter;
    const filterFieldId = boardScopeFilter?.filterFieldId;
    // if there is not filterFieldId
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(filterFieldId)) return (0, $kVLXA.Observable).of(optimisticIssue);
    if (filterFieldId === (0, $4jAPy.SYSTEM_LABEL_FIELD_ID)) {
        const customFields = {
            [(0, $4jAPy.SYSTEM_LABEL_FIELD_ID)]: [
                boardScopeFilter?.filterFieldValue || ''
            ]
        };
        return (0, $kVLXA.Observable).of({
            ...optimisticIssue,
            ...customFields
        });
    }
    const regex = /^(.*)_(.*)$/g;
    const fieldIdArray = regex.exec(filterFieldId || '') || [];
    const customFieldId = fieldIdArray.length > 3 ? '' : fieldIdArray[2];
    if (customFieldId.length < 1) throw new Error("The customFieldId doesn't follow customfield_id format");
    return (0, $tZ4NF.fetchOptionsForCustomFields)({
        projectId: `${projectId}`,
        issueTypeId: `${issueTypeId}`,
        customFieldId: customFieldId
    }).flatMap((options)=>{
        const option = options.find((o)=>o.value === boardScopeFilter?.filterFieldValue);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(option)) throw new Error((0, $4jAPy.CUSTOM_FIELD_OPTION_MISSED_ERROR));
        let customFieldValue;
        if (boardScopeFilter?.filterFieldTypeKey === (0, $4jAPy.SINGLE_CUSTOM_FIELD_TYPE_KEY)) customFieldValue = option.id;
        else customFieldValue = [
            option.id
        ];
        return (0, $kVLXA.Observable).of({
            ...optimisticIssue,
            customFields: {
                [customFieldId]: customFieldValue
            }
        });
    });
};
const $6f43b06f240ce3b7$var$createCardServiceInner = (state, incrementConfig, originalOptimisticIssue, customRequestHandlers)=>{
    const optimisticIssue = {
        ...originalOptimisticIssue
    };
    const column = (0, $fyeGd.getColumnById)(state, optimisticIssue.columnId);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const dateRange = column?.dateRange;
    const { name: typeName, iconUrl: typeUrl, hierarchyLevelType: hierarchyLevelType } = (0, $d2i8f.getIssueTypeById)(state, optimisticIssue.typeId);
    const epicLevel = hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE);
    let dateFields = (0, $kgiLc.transformDateRangeUpdateValues)(incrementConfig, // Only set start date for non epic issues
    !epicLevel ? (0, $kgiLc.transformDateValue)(dateRange?.start) : undefined, (0, $kgiLc.transformDateValue)(dateRange?.end));
    const { columnId: columnId, teamId: teamId } = optimisticIssue;
    const sprint = teamId ? (0, $5mTgl.getTeamSwimlaneColumnSprint)(state, columnId, teamId) : undefined;
    if (sprint) {
        if (epicLevel) // for Epic level issues, update the date range to reflect the sprint dates if they exist
        {
            if (sprint.endDate) dateFields = (0, $kgiLc.transformDateRangeUpdateValues)(incrementConfig, undefined, (0, $kgiLc.transformDateValue)(sprint.endDate));
        } else {
            // for story level issues, if sprints are associated, don't update the date range, but need to update the sprint of issue
            dateFields = {};
            optimisticIssue.sprintId = `${sprint.id}`;
        }
    }
    // Estimate is an empty placeholder value that's only needed for optimistic update in the board,
    // but would break review changes in the plan as the format is incorrect for the plan
    const { estimate: estimate, ...description } = $6f43b06f240ce3b7$export$78f957e4bfdb730f(optimisticIssue, dateFields, epicLevel, sprint);
    const issueProjects = (0, $67Z81.getIssueProjects)(state);
    const createObservable = (result)=>{
        const scenarioIssueId = result?.itemKey;
        //  we will not show the labels on the ip board issue card, so need to get rid of labels in here
        const optimisticIssueForBoard = !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(optimisticIssue.labels) ? {
            ...optimisticIssue,
            labels: []
        } : optimisticIssue;
        return (0, $kVLXA.Observable).of({
            ...optimisticIssueForBoard,
            typeName: typeName,
            typeUrl: typeUrl,
            id: scenarioIssueId,
            key: issueProjects[optimisticIssue.projectId].key
        });
    };
    if (!customRequestHandlers || !customRequestHandlers.addIssue) throw new Error('no request handler found for creating issues');
    const isCreateIssueResponse = (result)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        result?.itemKey !== undefined;
    return (0, $kVLXA.Observable).from(customRequestHandlers.addIssue({
        ...description
    })).flatMap((result)=>{
        if (isCreateIssueResponse(result)) return createObservable(result);
        // It should never reach here, adding the fallback due to the typechecks above
        return (0, $kVLXA.Observable).of(optimisticIssue);
    });
};
const $6f43b06f240ce3b7$var$createCardService = (state, incrementConfig, optimisticIssue, customRequestHandlers)=>$6f43b06f240ce3b7$var$setCustomFieldValue(incrementConfig, optimisticIssue).flatMap((issue)=>$6f43b06f240ce3b7$var$createCardServiceInner(state, incrementConfig, issue, customRequestHandlers));
var $6f43b06f240ce3b7$export$2e2bcd8739ae039 = $6f43b06f240ce3b7$var$createCardService;
function $6f43b06f240ce3b7$var$getEpicColor(color) {
    return (0, $iHPnC.toBackendColor)(color ?? (0, $iHPnC.getRandomColor)());
}

});
parcelRegister("iHPnC", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $e626bf77f0e696c5$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $e626bf77f0e696c5$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $e626bf77f0e696c5$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $e626bf77f0e696c5$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $e626bf77f0e696c5$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $e626bf77f0e696c5$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $e626bf77f0e696c5$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $e626bf77f0e696c5$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $e626bf77f0e696c5$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $e626bf77f0e696c5$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $e626bf77f0e696c5$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $e626bf77f0e696c5$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $e626bf77f0e696c5$export$e4369cabd7e84cd9);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $ggSx2 = parcelRequire("ggSx2");

var $heWHN = parcelRequire("heWHN");

var $ehxiD = parcelRequire("ehxiD");

var $kFsv3 = parcelRequire("kFsv3");
const $e626bf77f0e696c5$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $kFsv3.Colors).PURPLE;
    if (color in (0, $kFsv3.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $kFsv3.Colors).PURPLE;
};
const $e626bf77f0e696c5$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $kFsv3.ServerColors).SERVER_PURPLE;
    if (color in (0, $kFsv3.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_AGILE_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $heWHN.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $kFsv3.ServerColors).SERVER_PURPLE;
};
const $e626bf77f0e696c5$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $kFsv3.Colors).PURPLE];
    if (color in (0, $kFsv3.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $heWHN.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_AGILE_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $heWHN.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $kFsv3.Colors).PURPLE];
};
const $e626bf77f0e696c5$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $kFsv3.Colors).PURPLE];
    if (color in (0, $kFsv3.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $heWHN.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $kFsv3.Colors).PURPLE];
};
const $e626bf77f0e696c5$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $heWHN.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $kFsv3.Colors)));
    return extendedColors.reduce((obj, color)=>({
            ...obj,
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $e626bf77f0e696c5$export$a00423580059ae28 = (color)=>(0, $heWHN.MAP_COLORS_TO_VALUE)[color] || (0, $heWHN.MAP_COLORS_TO_VALUE)[0, $kFsv3.PURPLE];
const $e626bf77f0e696c5$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))((0, $heWHN.MAP_COLORS_TO_VALUE))[value] || (0, $kFsv3.PURPLE);
const $e626bf77f0e696c5$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $heWHN.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $kFsv3.PURPLE);
const $e626bf77f0e696c5$export$47af25386a01de1 = (color)=>(0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $e626bf77f0e696c5$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $kFsv3.PURPLE);
const $e626bf77f0e696c5$export$28fb68bb1de025d5 = (color)=>(0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $e626bf77f0e696c5$var$paletteColorValues = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $e626bf77f0e696c5$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $ehxiD.default).purpleLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $ehxiD.default).blueLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).BLUE]
        },
        {
            label: formatMessage((0, $ehxiD.default).greenLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).GREEN]
        },
        {
            label: formatMessage((0, $ehxiD.default).tealLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).TEAL]
        },
        {
            label: formatMessage((0, $ehxiD.default).yellowLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $ehxiD.default).orangeLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $ehxiD.default).greyLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).GREY]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkPurpleLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkBlueLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkGreenLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkTealLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkYellowLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkOrangeLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkGreyLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_GREY]
        }
    ];
const $e626bf77f0e696c5$export$9b822862d986dfdf = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $e626bf77f0e696c5$export$949dc67535a8ff2 = (color = (0, $heWHN.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $e626bf77f0e696c5$export$9b822862d986dfdf[color] ?? $e626bf77f0e696c5$export$9b822862d986dfdf[0, $heWHN.DEFAULT_EPIC_COLOR];
const $e626bf77f0e696c5$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $kFsv3.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("heWHN", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $3a4ee6f2b0ce40ab$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $3a4ee6f2b0ce40ab$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $3a4ee6f2b0ce40ab$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_CLASSIC_COLOR_TO_AGILE_COLOR", () => $3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $3a4ee6f2b0ce40ab$export$82fc3b0b98905453);
$parcel$export(module.exports, "MAP_AGILE_COLOR_TO_AK_COLOR", () => $3a4ee6f2b0ce40ab$export$703aca53c431bb88);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9);

var $ggSx2 = parcelRequire("ggSx2");


var $kFsv3 = parcelRequire("kFsv3");
const $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b = 'PURPLE';
const $3a4ee6f2b0ce40ab$export$db33d74b098e3da9 = {
    [(0, $kFsv3.PURPLE)]: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
    [(0, $kFsv3.BLUE)]: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
    [(0, $kFsv3.GREEN)]: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
    [(0, $kFsv3.TEAL)]: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
    [(0, $kFsv3.YELLOW)]: `var(--ds-background-accent-yellow-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
    [(0, $kFsv3.ORANGE)]: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
    [(0, $kFsv3.GREY)]: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
    [(0, $kFsv3.DARK_PURPLE)]: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
    [(0, $kFsv3.DARK_BLUE)]: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
    [(0, $kFsv3.DARK_GREEN)]: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
    [(0, $kFsv3.DARK_TEAL)]: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
    [(0, $kFsv3.DARK_YELLOW)]: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
    [(0, $kFsv3.DARK_ORANGE)]: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
    [(0, $kFsv3.DARK_GREY)]: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N700})`
};
const $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1 = {
    [(0, $829f609a65d26a98$exports).P200]: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
    [(0, $829f609a65d26a98$exports).B200]: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
    [(0, $829f609a65d26a98$exports).G200]: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
    [(0, $829f609a65d26a98$exports).T200]: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
    [(0, $829f609a65d26a98$exports).Y200]: `var(--ds-background-accent-yellow-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
    [(0, $829f609a65d26a98$exports).R200]: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
    [(0, $829f609a65d26a98$exports).N200]: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
    [(0, $829f609a65d26a98$exports).P400]: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
    [(0, $829f609a65d26a98$exports).B400]: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
    [(0, $829f609a65d26a98$exports).G400]: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
    [(0, $829f609a65d26a98$exports).T400]: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
    [(0, $829f609a65d26a98$exports).Y400]: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
    [(0, $829f609a65d26a98$exports).R400]: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
    [(0, $829f609a65d26a98$exports).N700]: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N700})`
};
const $3a4ee6f2b0ce40ab$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
const $3a4ee6f2b0ce40ab$export$43264b0781f10167 = {
    [(0, $kFsv3.SERVER_PURPLE)]: (0, $kFsv3.PURPLE),
    [(0, $kFsv3.SERVER_DARK_PURPLE)]: (0, $kFsv3.DARK_PURPLE),
    [(0, $kFsv3.SERVER_BLUE)]: (0, $kFsv3.BLUE),
    [(0, $kFsv3.SERVER_DARK_BLUE)]: (0, $kFsv3.DARK_BLUE),
    [(0, $kFsv3.SERVER_GREEN)]: (0, $kFsv3.GREEN),
    [(0, $kFsv3.SERVER_DARK_GREEN)]: (0, $kFsv3.DARK_GREEN),
    [(0, $kFsv3.SERVER_TEAL)]: (0, $kFsv3.TEAL),
    [(0, $kFsv3.SERVER_DARK_TEAL)]: (0, $kFsv3.DARK_TEAL),
    [(0, $kFsv3.SERVER_YELLOW)]: (0, $kFsv3.YELLOW),
    [(0, $kFsv3.SERVER_DARK_YELLOW)]: (0, $kFsv3.DARK_YELLOW),
    [(0, $kFsv3.SERVER_ORANGE)]: (0, $kFsv3.ORANGE),
    [(0, $kFsv3.SERVER_DARK_ORANGE)]: (0, $kFsv3.DARK_ORANGE),
    [(0, $kFsv3.SERVER_GREY)]: (0, $kFsv3.GREY),
    [(0, $kFsv3.SERVER_DARK_GREY)]: (0, $kFsv3.DARK_GREY)
};
const $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$43264b0781f10167);
const $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc = {
    [(0, $kFsv3.GHX_LABEL_1)]: (0, $kFsv3.DARK_GREY),
    [(0, $kFsv3.GHX_LABEL_2)]: (0, $kFsv3.DARK_YELLOW),
    [(0, $kFsv3.GHX_LABEL_3)]: (0, $kFsv3.YELLOW),
    [(0, $kFsv3.GHX_LABEL_4)]: (0, $kFsv3.DARK_BLUE),
    [(0, $kFsv3.GHX_LABEL_5)]: (0, $kFsv3.DARK_TEAL),
    [(0, $kFsv3.GHX_LABEL_6)]: (0, $kFsv3.GREEN),
    [(0, $kFsv3.GHX_LABEL_7)]: (0, $kFsv3.PURPLE),
    [(0, $kFsv3.GHX_LABEL_8)]: (0, $kFsv3.DARK_PURPLE),
    [(0, $kFsv3.GHX_LABEL_9)]: (0, $kFsv3.ORANGE),
    [(0, $kFsv3.GHX_LABEL_10)]: (0, $kFsv3.BLUE),
    [(0, $kFsv3.GHX_LABEL_11)]: (0, $kFsv3.TEAL),
    [(0, $kFsv3.GHX_LABEL_12)]: (0, $kFsv3.GREY),
    [(0, $kFsv3.GHX_LABEL_13)]: (0, $kFsv3.DARK_GREEN),
    [(0, $kFsv3.GHX_LABEL_14)]: (0, $kFsv3.DARK_ORANGE)
};
const $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
const $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd = {
    [(0, $kFsv3.AGILE_COLOR_1)]: (0, $kFsv3.DARK_GREY),
    [(0, $kFsv3.AGILE_COLOR_2)]: (0, $kFsv3.DARK_YELLOW),
    [(0, $kFsv3.AGILE_COLOR_3)]: (0, $kFsv3.YELLOW),
    [(0, $kFsv3.AGILE_COLOR_4)]: (0, $kFsv3.DARK_BLUE),
    [(0, $kFsv3.AGILE_COLOR_5)]: (0, $kFsv3.DARK_TEAL),
    [(0, $kFsv3.AGILE_COLOR_6)]: (0, $kFsv3.GREEN),
    [(0, $kFsv3.AGILE_COLOR_7)]: (0, $kFsv3.PURPLE),
    [(0, $kFsv3.AGILE_COLOR_8)]: (0, $kFsv3.DARK_PURPLE),
    [(0, $kFsv3.AGILE_COLOR_9)]: (0, $kFsv3.ORANGE),
    [(0, $kFsv3.AGILE_COLOR_10)]: (0, $kFsv3.BLUE),
    [(0, $kFsv3.AGILE_COLOR_11)]: (0, $kFsv3.TEAL),
    [(0, $kFsv3.AGILE_COLOR_12)]: (0, $kFsv3.GREY),
    [(0, $kFsv3.AGILE_COLOR_13)]: (0, $kFsv3.DARK_GREEN),
    [(0, $kFsv3.AGILE_COLOR_14)]: (0, $kFsv3.DARK_ORANGE)
};
const $3a4ee6f2b0ce40ab$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
const $3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c = {
    [(0, $kFsv3.GHX_LABEL_1)]: (0, $kFsv3.AGILE_COLOR_1),
    [(0, $kFsv3.GHX_LABEL_2)]: (0, $kFsv3.AGILE_COLOR_2),
    [(0, $kFsv3.GHX_LABEL_3)]: (0, $kFsv3.AGILE_COLOR_3),
    [(0, $kFsv3.GHX_LABEL_4)]: (0, $kFsv3.AGILE_COLOR_4),
    [(0, $kFsv3.GHX_LABEL_5)]: (0, $kFsv3.AGILE_COLOR_5),
    [(0, $kFsv3.GHX_LABEL_6)]: (0, $kFsv3.AGILE_COLOR_6),
    [(0, $kFsv3.GHX_LABEL_7)]: (0, $kFsv3.AGILE_COLOR_7),
    [(0, $kFsv3.GHX_LABEL_8)]: (0, $kFsv3.AGILE_COLOR_8),
    [(0, $kFsv3.GHX_LABEL_9)]: (0, $kFsv3.AGILE_COLOR_9),
    [(0, $kFsv3.GHX_LABEL_10)]: (0, $kFsv3.AGILE_COLOR_10),
    [(0, $kFsv3.GHX_LABEL_11)]: (0, $kFsv3.AGILE_COLOR_11),
    [(0, $kFsv3.GHX_LABEL_12)]: (0, $kFsv3.AGILE_COLOR_12),
    [(0, $kFsv3.GHX_LABEL_13)]: (0, $kFsv3.AGILE_COLOR_13),
    [(0, $kFsv3.GHX_LABEL_14)]: (0, $kFsv3.AGILE_COLOR_14)
};
const $3a4ee6f2b0ce40ab$export$82fc3b0b98905453 = {
    [(0, $kFsv3.DARK_GREY)]: 'grey',
    [(0, $kFsv3.DARK_YELLOW)]: 'yellow',
    [(0, $kFsv3.YELLOW)]: 'yellowLight',
    [(0, $kFsv3.DARK_BLUE)]: 'blue',
    [(0, $kFsv3.DARK_TEAL)]: 'teal',
    [(0, $kFsv3.GREEN)]: 'greenLight',
    [(0, $kFsv3.PURPLE)]: 'purpleLight',
    [(0, $kFsv3.DARK_PURPLE)]: 'purple',
    [(0, $kFsv3.ORANGE)]: 'redLight',
    [(0, $kFsv3.BLUE)]: 'blueLight',
    [(0, $kFsv3.TEAL)]: 'tealLight',
    [(0, $kFsv3.GREY)]: 'greyLight',
    [(0, $kFsv3.DARK_GREEN)]: 'green',
    [(0, $kFsv3.DARK_ORANGE)]: 'red'
};
const $3a4ee6f2b0ce40ab$export$703aca53c431bb88 = {
    [(0, $kFsv3.AGILE_COLOR_1)]: 'grey',
    [(0, $kFsv3.AGILE_COLOR_2)]: 'yellow',
    [(0, $kFsv3.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $kFsv3.AGILE_COLOR_4)]: 'blue',
    [(0, $kFsv3.AGILE_COLOR_5)]: 'teal',
    [(0, $kFsv3.AGILE_COLOR_6)]: 'greenLight',
    [(0, $kFsv3.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $kFsv3.AGILE_COLOR_8)]: 'purple',
    [(0, $kFsv3.AGILE_COLOR_9)]: 'redLight',
    [(0, $kFsv3.AGILE_COLOR_10)]: 'blueLight',
    [(0, $kFsv3.AGILE_COLOR_11)]: 'tealLight',
    [(0, $kFsv3.AGILE_COLOR_12)]: 'greyLight',
    [(0, $kFsv3.AGILE_COLOR_13)]: 'green',
    [(0, $kFsv3.AGILE_COLOR_14)]: 'red'
};
const $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9 = {
    [(0, $kFsv3.PURPLE)]: {
        primary: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
        secondary: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P500})`,
        text: `var(--ds-text-accent-purple, ${(0, $829f609a65d26a98$exports).P500})`,
        textBackground: `var(--ds-background-accent-purple-subtler, ${(0, $829f609a65d26a98$exports).P50})`,
        border: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P400})`,
        line: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtler, ${(0, $829f609a65d26a98$exports).P75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.BLUE)]: {
        primary: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
        secondary: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B500})`,
        text: `var(--ds-text-accent-blue, ${(0, $829f609a65d26a98$exports).B500})`,
        textBackground: `var(--ds-background-accent-blue-subtler, ${(0, $829f609a65d26a98$exports).B50})`,
        border: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B400})`,
        line: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B300})`,
        primaryGradient: `var(--ds-background-accent-blue-subtler, ${(0, $829f609a65d26a98$exports).B75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.GREEN)]: {
        primary: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
        secondary: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G500})`,
        text: `var(--ds-text-accent-green, ${(0, $829f609a65d26a98$exports).G500})`,
        textBackground: `var(--ds-background-accent-green-subtler, ${(0, $829f609a65d26a98$exports).G50})`,
        border: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G400})`,
        line: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtler, ${(0, $829f609a65d26a98$exports).G75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.TEAL)]: {
        primary: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
        secondary: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T500})`,
        text: `var(--ds-text-accent-teal, ${(0, $829f609a65d26a98$exports).T500})`,
        textBackground: `var(--ds-background-accent-teal-subtler, ${(0, $829f609a65d26a98$exports).T50})`,
        border: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T400})`,
        line: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtler, ${(0, $829f609a65d26a98$exports).T75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.YELLOW)]: {
        primary: `var(--ds-background-accent-yellow-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
        secondary: `var(--ds-background-accent-yellow-bolder, ${(0, $829f609a65d26a98$exports).Y500})`,
        text: `var(--ds-text-accent-yellow, ${(0, $829f609a65d26a98$exports).Y500})`,
        textBackground: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$exports).Y50})`,
        border: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$exports).Y400})`,
        line: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$exports).Y300})`,
        primaryGradient: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$exports).Y75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.ORANGE)]: {
        primary: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
        secondary: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R500})`,
        text: `var(--ds-text-accent-red, ${(0, $829f609a65d26a98$exports).R500})`,
        textBackground: `var(--ds-background-accent-red-subtler, ${(0, $829f609a65d26a98$exports).R50})`,
        border: `var(--ds-border-accent-red, ${(0, $829f609a65d26a98$exports).R400})`,
        line: `var(--ds-border-accent-red, ${(0, $829f609a65d26a98$exports).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtler, ${(0, $829f609a65d26a98$exports).R75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.GREY)]: {
        primary: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
        secondary: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N500})`,
        text: `var(--ds-text-accent-gray, ${(0, $829f609a65d26a98$exports).N500})`,
        textBackground: `var(--ds-background-accent-gray-subtler, ${(0, $829f609a65d26a98$exports).N30})`,
        border: `var(--ds-border-accent-gray, ${(0, $829f609a65d26a98$exports).N700})`,
        line: `var(--ds-border-accent-gray, ${(0, $829f609a65d26a98$exports).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtler, ${(0, $829f609a65d26a98$exports).N50})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.DARK_PURPLE)]: {
        primary: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
        secondary: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
        text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        textBackground: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
        border: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P100})`,
        line: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $kFsv3.DARK_BLUE)]: {
        primary: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
        secondary: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
        text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        textBackground: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
        border: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B200})`,
        line: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B100})`,
        primaryGradient: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $kFsv3.DARK_GREEN)]: {
        primary: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
        secondary: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
        text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        textBackground: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
        border: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G200})`,
        line: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $kFsv3.DARK_TEAL)]: {
        primary: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
        secondary: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
        text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        textBackground: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
        border: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T200})`,
        line: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $kFsv3.DARK_YELLOW)]: {
        primary: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
        secondary: `var(--ds-background-accent-orange-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
        text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        textBackground: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
        border: `var(--ds-background-accent-orange-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
        line: `var(--ds-border-accent-orange, ${(0, $829f609a65d26a98$exports).Y300})`,
        primaryGradient: `var(--ds-background-accent-orange-subtle, ${(0, $829f609a65d26a98$exports).Y100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $kFsv3.DARK_ORANGE)]: {
        primary: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
        secondary: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
        text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        textBackground: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
        border: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R100})`,
        line: `var(--ds-border-accent-red, ${(0, $829f609a65d26a98$exports).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $kFsv3.DARK_GREY)]: {
        primary: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N700})`,
        secondary: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N300})`,
        text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        textBackground: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N500})`,
        border: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N100})`,
        line: `var(--ds-border-accent-gray, ${(0, $829f609a65d26a98$exports).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N100})`,
        hasContrastSecondaryGradient: false
    }
};

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';


parcelRegister("ehxiD", function(module, exports) {

$parcel$export(module.exports, "default", () => $50b7e3d933c7b9f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50b7e3d933c7b9f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});


parcelRegister("tZ4NF", function(module, exports) {

$parcel$export(module.exports, "fetchOptionsForCustomFields", () => $90d1bb8f1e1e143e$export$68400c67f26ee713);

var $487fd = parcelRequire("487fd");
const $90d1bb8f1e1e143e$export$68400c67f26ee713 = ({ projectId: projectId, issueTypeId: issueTypeId, customFieldId: customFieldId })=>(0, $487fd.default)('/rest/jpo/1.0/customfield/getSettableOptions', {
        method: 'POST',
        body: JSON.stringify({
            customFieldId: customFieldId,
            issueTypeId: issueTypeId,
            projectId: projectId
        })
    });

});


parcelRegister("lWvJn", function(module, exports) {

$parcel$export(module.exports, "issueUpdateService", () => $c35f5051fe4e6d5f$export$4f6796016f60fcae);
$parcel$export(module.exports, "issueRankJPOService", () => $c35f5051fe4e6d5f$export$fc0043ca24fa881a);

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $binmg = parcelRequire("binmg");
function $c35f5051fe4e6d5f$export$4f6796016f60fcae(_ctx, { issueKey: issueKey, values: values }) {
    return (0, $binmg.issueUpdateRest)(issueKey, values);
}
function $c35f5051fe4e6d5f$export$cab2c8be868d8e42({ issueIds: issueIds, planId: planId, scenarioId: scenarioId, values: values }) {
    return (0, $binmg.issueUpdateJPORest)({
        issueIds: issueIds,
        planId: planId,
        scenarioId: scenarioId,
        values: values
    });
}
function $c35f5051fe4e6d5f$export$fc0043ca24fa881a({ issueIds: issueIds, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId, isLastPosition: isLastPosition, requestHandler: requestHandler }) {
    let relation = 'BEFORE';
    let anchor = rankBeforeIssueId;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(rankBeforeIssueId) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(rankAfterIssueId)) {
        relation = 'AFTER';
        anchor = rankAfterIssueId;
    }
    let operation = {
        anchor: `${anchor}`,
        itemKeys: issueIds.filter((id)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(id)).map((id)=>`${id}`),
        relation: relation
    };
    if (isLastPosition) operation = {
        itemKeys: issueIds.filter((id)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(id)).map((id)=>`${id}`),
        relation: 'LAST'
    };
    return (0, $kVLXA.Observable).from(requestHandler(operation));
}

});
parcelRegister("binmg", function(module, exports) {

$parcel$export(module.exports, "issueUpdateRest", () => $a718535ca355b011$export$c0cb20b0a7c268f2);
$parcel$export(module.exports, "issueUpdateJPORest", () => $a718535ca355b011$export$b84318079028d336);

var $487fd = parcelRequire("487fd");

var $2bQEl = parcelRequire("2bQEl");
function $a718535ca355b011$export$c0cb20b0a7c268f2(issueKey, values) {
    return (0, $487fd.default)((0, $2bQEl.getIssueEditUrl)('', issueKey), {
        method: 'PUT',
        body: JSON.stringify({
            fields: values
        })
    });
}
function $a718535ca355b011$export$b84318079028d336({ issueIds: issueIds, planId: planId, scenarioId: scenarioId, values: values }) {
    return (0, $487fd.default)('/rest/jpo/1.0/scenarios/updateIssues', {
        method: 'POST',
        body: JSON.stringify({
            planId: planId,
            scenarioId: scenarioId,
            itemKeys: issueIds,
            description: values
        })
    });
}

});



parcelRegister("2D01T", function(module, exports) {

$parcel$export(module.exports, "issueFlagWithCommentEpic", () => $de98bd2462700fac$export$a1a30b7a4bf55618);

var $alNv9 = parcelRequire("alNv9");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $faGMz = parcelRequire("faGMz");

var $2vSU6 = parcelRequire("2vSU6");

var $dJl1T = parcelRequire("dJl1T");

var $8zOmE = parcelRequire("8zOmE");


var $8Fckk = parcelRequire("8Fckk");

var $hdmw1 = parcelRequire("hdmw1");

var $fBkjL = parcelRequire("fBkjL");

var $cW3pH = parcelRequire("cW3pH");

var $vAfHD = parcelRequire("vAfHD");
const $de98bd2462700fac$export$a1a30b7a4bf55618 = (action$, store)=>action$.ofType((0, $fBkjL.ISSUE_FLAG_WITH_COMMENT_REQUEST)).mergeMap((action)=>{
        const { payload: { issueIds: issueIds, flag: flag, comment: comment }, meta: { optimistic: { id: optimisticId }, analyticsEvent: analyticsEvent } } = action;
        const state = store.getState();
        const ctx = (0, $hdmw1.makeServiceContext)(state);
        const { issueProjects: issueProjects } = (0, $alNv9.ensureState)(state.entities);
        const issues = (0, $vAfHD.boardIssuesSelector)(state);
        const issuesToFlag = issueIds.map((id)=>issues[id]);
        const internallyCommentingIssueKeys = issuesToFlag.filter((issue)=>issueProjects[issue.projectId]?.projectTypeKey === (0, $2vSU6.SERVICE_DESK_PROJECT)).map((issue)=>issue.key);
        const publiclyCommentingIssueKeys = issuesToFlag.filter((issue)=>issueProjects[issue.projectId]?.projectTypeKey !== (0, $2vSU6.SERVICE_DESK_PROJECT)).map((issue)=>issue.key);
        const requests = [];
        if (internallyCommentingIssueKeys.length) requests.push((0, $8Fckk.default)(ctx, {
            issueKeys: internallyCommentingIssueKeys,
            flag: flag,
            comment: comment,
            internal: true
        }));
        if (publiclyCommentingIssueKeys.length) requests.push((0, $8Fckk.default)(ctx, {
            issueKeys: publiclyCommentingIssueKeys,
            flag: flag,
            comment: comment,
            internal: false
        }));
        return (0, $faGMz.forkJoin)(requests).flatMap((responses)=>{
            if (responses.every((r)=>r === null)) {
                // if we get here, all of the issues were successfully updated
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'cards flagged', {
                    numCards: issueIds.length,
                    flagAction: flag ? 'added' : 'removed'
                });
                return (0, $kVLXA.Observable).from([
                    (0, $fBkjL.issueFlagWithCommentSuccess)(optimisticId, issueIds),
                    (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$97b91dd49f0a73f1))
                ]);
            }
            // if we get here, at least one of the issues failed to be updated,
            // so we treat it as a failure
            const errorMessages = responses.map((r)=>r?.errorMessages || []).flat(1);
            const error = new Error(errorMessages.join(', '));
            (0, $dJl1T.default).safeErrorWithoutCustomerData('board.issue-flag-with-comment.partial-failure', 'Failed to flag and/or comment on some issues.', error);
            throw error;
        }).catch(()=>{
            // if we get here directly from the cardsFlagWithCommentService, none
            // of the issues were successfully updated
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'ui taskFail', {
                task: 'flagCards',
                numCards: issueIds.length,
                flagAction: flag ? 'added' : 'removed'
            });
            return (0, $kVLXA.Observable).from([
                (0, $fBkjL.issueFlagWithCommentFailure)(optimisticId, issueIds),
                (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$d9d2fe902bd6d9a7))
            ]);
        });
    });

});
parcelRegister("8Fckk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7540c63b11fc724$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");

var $ikizX = parcelRequire("ikizX");
function $d7540c63b11fc724$export$2e2bcd8739ae039(ctx, { issueKeys: issueKeys, flag: flag, comment: comment, internal: internal }) {
    return (0, $kVLXA.Observable).fromPromise((0, $ikizX.makeFlagWithCommentRequest)(issueKeys, flag, comment, internal));
}

});
parcelRegister("ikizX", function(module, exports) {

$parcel$export(module.exports, "makeFlagWithCommentRequest", () => $8f07cf7f745a7bf3$export$bfe9c76f17e80968);

var $jJZqs = parcelRequire("jJZqs");

var $iwPwz = parcelRequire("iwPwz");
const $8f07cf7f745a7bf3$var$noContentStatus = 204;
const $8f07cf7f745a7bf3$export$3ae968343ffb0d2b = '/rest/greenhopper/3/xboard/issue/flag/flag';
const $8f07cf7f745a7bf3$export$bfe9c76f17e80968 = (issueKeys, flag, comment, internal = false)=>fetch($8f07cf7f745a7bf3$export$3ae968343ffb0d2b, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            issueKeys: issueKeys,
            flag: flag,
            comment: comment,
            commentProperty: internal ? '{"key": "sd.public.comment", "value": {"internal": true}}' : '',
            commentVisibility: ''
        })
    }).then((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = (0, $iwPwz.getTraceId)(response);
            if (traceId) throw new (0, $jJZqs.default)(status, `Fetch call failed with status code: ${status}`, traceId);
            else throw new (0, $jJZqs.default)(status);
        }
        if (response.status === $8f07cf7f745a7bf3$var$noContentStatus) return null;
        return response.text().then((body)=>body ? JSON.parse(body) : null);
    });
var $8f07cf7f745a7bf3$export$2e2bcd8739ae039 = $8f07cf7f745a7bf3$export$bfe9c76f17e80968;

});



parcelRegister("5I1Fz", function(module, exports) {

$parcel$export(module.exports, "issueIncrementPlanningUpdateEpic", () => $be7222332eb90898$export$b98bf9e5e594be07);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fPS7b");
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("c66Ur");

var $dJl1T = parcelRequire("dJl1T");

var $evkwq = parcelRequire("evkwq");

var $67Z81 = parcelRequire("67Z81");
function $be7222332eb90898$export$b98bf9e5e594be07(actions, store, { customRequestHandlers: customRequestHandlers }) {
    return actions.ofType((0, $evkwq.ISSUE_INCREMENT_PLANNING_UPDATE)).mergeMap((action)=>{
        const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(store.getState());
        if (isIncrementPlanningBoard) {
            const { payload: { issueId: issueId, fieldValue: fieldValue, fieldId: fieldId } } = action;
            const success = ()=>(0, $kVLXA.Observable).of((0, $evkwq.issueIncrementPlanningUpdateSuccess)());
            const error = (err)=>{
                (0, $dJl1T.default).safeErrorWithoutCustomerData('issue.increment.planning.update', 'Failed to update IP board issue', // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                err);
                return (0, $kVLXA.Observable).of((0, $evkwq.issueIncrementPlanningUpdateFailed)());
            };
            if (!customRequestHandlers || !customRequestHandlers?.updateIssue) return error(new Error('no request handler found for update issue'));
            return (0, $kVLXA.Observable).from(customRequestHandlers.updateIssue({
                id: issueId,
                [fieldId]: fieldValue
            })).flatMap(()=>success()).catch((err)=>error(err));
        }
        return (0, $kVLXA.Observable).empty();
    });
}

});

parcelRegister("eTCf8", function(module, exports) {

$parcel$export(module.exports, "issueLinkEpic", () => $274edd7dd18c90e1$export$b9129588162208f8);
$parcel$export(module.exports, "issueLinkUpdateEpic", () => $274edd7dd18c90e1$export$98d01d02eac3ac51);
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $4R6GH = parcelRequire("4R6GH");

var $esu6n = parcelRequire("esu6n");

var $6WzWZ = parcelRequire("6WzWZ");

var $5UXId = parcelRequire("5UXId");

var $fyeGd = parcelRequire("fyeGd");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");
function $274edd7dd18c90e1$export$b9129588162208f8(action$, store, { customRequestHandlers: customRequestHandlers }) {
    return action$.ofType((0, $6WzWZ.ISSUE_LINK_CREATE_REQUEST)).mergeMap((action)=>{
        const { sourceItemKey: sourceItemKey, targetItemKey: targetItemKey, type: type } = action.payload;
        const success = (response)=>{
            if (action.promise) action.promise.resolve(response);
            return (0, $kVLXA.Observable).of((0, $6WzWZ.issueLinkCreateSuccess)());
        };
        const error = (err)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('issue.issue-link-epic.failure', 'Failed to link IP board issue', // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            err);
            if (action.promise) action.promise.reject(err);
            return (0, $kVLXA.Observable).of((0, $6WzWZ.issueLinkCreateFailed)());
        };
        if (!customRequestHandlers || !customRequestHandlers.addIssueLink) return error(new Error('no request handler found for adding dependency'));
        return (0, $kVLXA.Observable).from(customRequestHandlers.addIssueLink({
            sourceItemKey: sourceItemKey,
            targetItemKey: targetItemKey,
            type: type
        })).flatMap((response)=>success(response)).catch((err)=>error(err));
    });
}
const $274edd7dd18c90e1$export$3c3b065ce00d8564 = ({ issueLinkType: issueLinkType, sourceIssueColumnId: sourceIssueColumnId, destinationIssueColumnId: destinationIssueColumnId, isConcurrentScheduling: isConcurrentScheduling, columns: columns })=>{
    const sourceColumn = issueLinkType.isOutward ? sourceIssueColumnId : destinationIssueColumnId;
    const destinationColumn = issueLinkType.isOutward ? destinationIssueColumnId : sourceIssueColumnId;
    if ((0, $esu6n.isUnscheduledColumn)(columns[sourceColumn]) || (0, $esu6n.isUnscheduledColumn)(columns[destinationColumn])) return false;
    if (isConcurrentScheduling) return sourceColumn > destinationColumn;
    return sourceColumn >= destinationColumn;
};
const $274edd7dd18c90e1$export$63cd13864b935a4c = (originalIssueLinks, state)=>{
    const columns = (0, $fyeGd.getColumns)(state);
    // when clean up the fg dependency_visualisation_program_board_fe_and_be ,
    // the isConcurrentScheduling would always be filled and will not be undefined
    // change this line to `const isConcurrentScheduling = getIncrementConfig(state).isConcurrentScheduling`
    const isConcurrentScheduling = !!(0, $67Z81.getIncrementConfig)(state)?.isConcurrentScheduling;
    const newIssueLinks = {};
    Object.entries(originalIssueLinks).forEach(([issueId, issueLinks])=>{
        const existingIssueLinks = (0, $d2i8f.getIssueById)(state, issueId)?.issueLinks || [];
        const newAddedIssueLinksWithOfftrack = issueLinks.map((link)=>{
            const issueLinkType = (0, $67Z81.getIssueLinkTypeById)(state)(link.linkTypeId);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueLinkType)) throw new Error('the issue link type is not existing');
            return {
                ...link,
                isOfftrack: $274edd7dd18c90e1$export$3c3b065ce00d8564({
                    issueLinkType: issueLinkType,
                    sourceIssueColumnId: (0, $d2i8f.getIssueById)(state, link.sourceId).columnId,
                    destinationIssueColumnId: (0, $d2i8f.getIssueById)(state, link.destinationId).columnId,
                    columns: columns,
                    isConcurrentScheduling: isConcurrentScheduling
                })
            };
        });
        newIssueLinks[issueId] = existingIssueLinks.concat(newAddedIssueLinksWithOfftrack);
    });
    return newIssueLinks;
};
const $274edd7dd18c90e1$var$updateIssueLinkOfftrack = (issueLinks, issueLinkId, offtrackValue)=>{
    return issueLinks.map((link)=>link.id === issueLinkId ? {
            ...link,
            isOfftrack: offtrackValue
        } : link);
};
const $274edd7dd18c90e1$export$de9c5b7f2a5b647c = (issueIds, destinationColumnId, state)=>{
    const columns = (0, $fyeGd.getColumns)(state);
    const isConcurrentScheduling = !!(0, $67Z81.getIncrementConfig)(state)?.isConcurrentScheduling;
    const newIssueLinks = {};
    issueIds.forEach((issueId)=>{
        const issueLinks = (0, $d2i8f.getIssueById)(state, issueId)?.issueLinks || [];
        const issueLinksWithUpdatedOfftrack = issueLinks.map((link)=>{
            const issueLinkType = (0, $67Z81.getIssueLinkTypeById)(state)(link.linkTypeId);
            const isSourceIssue = link.sourceId === issueId;
            const sourceIssue = isSourceIssue ? {
                ...(0, $d2i8f.getIssueById)(state, link.sourceId),
                columnId: destinationColumnId
            } : (0, $d2i8f.getIssueById)(state, link.sourceId);
            const destinationIssue = isSourceIssue ? (0, $d2i8f.getIssueById)(state, link.destinationId) : {
                ...(0, $d2i8f.getIssueById)(state, link.destinationId),
                columnId: destinationColumnId
            };
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueLinkType)) throw new Error('the issue link type is not existing');
            const isOffTrackValue = $274edd7dd18c90e1$export$3c3b065ce00d8564({
                issueLinkType: issueLinkType,
                sourceIssueColumnId: sourceIssue.columnId,
                destinationIssueColumnId: destinationIssue.columnId,
                columns: columns,
                isConcurrentScheduling: isConcurrentScheduling
            });
            // if the dragged issue is the source issue of the link, need to update issue links of the destination issue of the link,
            // if the dragged issue is the target issue of the link, need to update issue links of the source issue of the link.
            const issueUpdated = isSourceIssue ? destinationIssue : sourceIssue;
            const issueLinksWithOfftrack = $274edd7dd18c90e1$var$updateIssueLinkOfftrack(newIssueLinks[issueUpdated.id] || issueUpdated?.issueLinks || [], link.id, isOffTrackValue);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issueLinksWithOfftrack)) newIssueLinks[issueUpdated.id] = issueLinksWithOfftrack;
            return {
                ...link,
                isOfftrack: isOffTrackValue
            };
        });
        newIssueLinks[issueId] = issueLinksWithUpdatedOfftrack;
    });
    return newIssueLinks;
};
const $274edd7dd18c90e1$var$handleIssueLinkUpdate = (action, state)=>{
    let newIssueLinks = {};
    if (action.type === (0, $6WzWZ.ISSUE_LINKS_CREATE)) newIssueLinks = $274edd7dd18c90e1$export$63cd13864b935a4c(action.payload.newIssueLinks, state);
    if (action.type === (0, $5UXId.ISSUE_RANK_TEAM_DATE_REQUEST)) newIssueLinks = $274edd7dd18c90e1$export$de9c5b7f2a5b647c(action.payload.issueIds, action.payload.destinationColumnId, state);
    return newIssueLinks;
};
function $274edd7dd18c90e1$export$98d01d02eac3ac51(action$, store) {
    return action$.ofType((0, $6WzWZ.ISSUE_LINKS_CREATE), (0, $5UXId.ISSUE_RANK_TEAM_DATE_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        if (isIncrementPlanningBoard && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) return (0, $kVLXA.Observable).of($274edd7dd18c90e1$var$handleIssueLinkUpdate(action, state)).flatMap((newIssueLinks)=>{
            return (0, $kVLXA.Observable).of((0, $6WzWZ.issueLinksAddAndUpdateSuccess)({
                newIssueLinks: newIssueLinks
            }));
        }).catch((err)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('issue.issue-link-add-update-success-epic.failure', 'The issue links failed to update', err);
            return (0, $kVLXA.Observable).of((0, $6WzWZ.issueLinksAddAndUpdateFailed)());
        });
        return (0, $kVLXA.Observable).empty();
    });
}

});
parcelRegister("6WzWZ", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINKS_CREATE", () => $c497fae38ad3141e$export$9b86f34aa487330f);
$parcel$export(module.exports, "issueLinksCreate", () => $c497fae38ad3141e$export$695074c2cd38a954);
$parcel$export(module.exports, "ISSUE_LINK_CREATE_REQUEST", () => $c497fae38ad3141e$export$a360ded071b8ad75);
$parcel$export(module.exports, "issueLinkCreateRequest", () => $c497fae38ad3141e$export$daac9ff0ef08b318);
$parcel$export(module.exports, "issueLinkCreateSuccess", () => $c497fae38ad3141e$export$897cdb99a776480b);
$parcel$export(module.exports, "issueLinkCreateFailed", () => $c497fae38ad3141e$export$9629175ea4c8225f);
$parcel$export(module.exports, "ISSUE_LINKS_REMOVE_REQUEST", () => $c497fae38ad3141e$export$a11cc88ebb18ead2);
$parcel$export(module.exports, "issueLinksRemoveRequest", () => $c497fae38ad3141e$export$4e1225be108c8cc);
$parcel$export(module.exports, "ISSUE_LINKS_REMOVE_SUCCESS", () => $c497fae38ad3141e$export$9028eccea4410398);
$parcel$export(module.exports, "issueLinksRemoveSuccess", () => $c497fae38ad3141e$export$ec4e17f9ac9ec830);
$parcel$export(module.exports, "issueLinksRemoveFailed", () => $c497fae38ad3141e$export$9e26eeb7c4d4c29a);
$parcel$export(module.exports, "ISSUE_LINKS_ADD_UPDATE_SUCCESS", () => $c497fae38ad3141e$export$ffd13079184b6b1e);
$parcel$export(module.exports, "issueLinksAddAndUpdateSuccess", () => $c497fae38ad3141e$export$f9f50e91f5dd466);
$parcel$export(module.exports, "issueLinksAddAndUpdateFailed", () => $c497fae38ad3141e$export$343182dd42310851);
$parcel$export(module.exports, "reachDependencyLinesLimitInIPBoard", () => $c497fae38ad3141e$export$c48a8dd0a23a5210);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $c497fae38ad3141e$export$9b86f34aa487330f = 'state.actions.issue.issue-link.ISSUE_LINK_CREATE';
const $c497fae38ad3141e$export$695074c2cd38a954 = (payload)=>({
        type: $c497fae38ad3141e$export$9b86f34aa487330f,
        payload: payload
    });
const $c497fae38ad3141e$export$a360ded071b8ad75 = 'state.actions.issue.issue-link.ISSUE_LINK_CREATE_REQUEST';
const $c497fae38ad3141e$export$daac9ff0ef08b318 = (payload)=>({
        type: $c497fae38ad3141e$export$a360ded071b8ad75,
        payload: payload
    });
const $c497fae38ad3141e$export$3a45528ea0878487 = 'state.actions.issue.issue-link.ISSUE_LINK_CREATE_SUCCESS';
const $c497fae38ad3141e$export$897cdb99a776480b = ()=>({
        type: $c497fae38ad3141e$export$3a45528ea0878487
    });
const $c497fae38ad3141e$export$ca26aad29ddbd14b = 'state.actions.issue.issue-link.ISSUE_LINK_CREATE_FAILED';
const $c497fae38ad3141e$export$9629175ea4c8225f = ()=>({
        type: $c497fae38ad3141e$export$ca26aad29ddbd14b
    });
const $c497fae38ad3141e$export$a11cc88ebb18ead2 = 'state.actions.issue.issue-link.ISSUE_LINKS_REMOVE_REQUEST';
const $c497fae38ad3141e$export$4e1225be108c8cc = (payload)=>({
        type: $c497fae38ad3141e$export$a11cc88ebb18ead2,
        payload: payload
    });
const $c497fae38ad3141e$export$9028eccea4410398 = 'state.actions.issue.issue-link.ISSUE_LINKS_REMOVE_SUCCESS';
const $c497fae38ad3141e$export$ec4e17f9ac9ec830 = (payload)=>({
        type: $c497fae38ad3141e$export$9028eccea4410398,
        payload: payload
    });
const $c497fae38ad3141e$export$fcfc54069b26e23c = 'state.actions.issue.issue-link.ISSUE_LINKS_REMOVE_FAILED';
const $c497fae38ad3141e$export$9e26eeb7c4d4c29a = ()=>({
        type: $c497fae38ad3141e$export$fcfc54069b26e23c,
        meta: (0, $sdxnu.errorFlagMeta)({
            titleMessage: (0, $7AVqz.default).genericTitle,
            descriptionMessage: (0, $7AVqz.default).genericDescription
        })
    });
const $c497fae38ad3141e$export$ffd13079184b6b1e = 'state.actions.issue.issue-link.ISSUE_LINKS_ADD_UPDATE_SUCCESS';
const $c497fae38ad3141e$export$f9f50e91f5dd466 = (payload)=>({
        type: $c497fae38ad3141e$export$ffd13079184b6b1e,
        payload: payload
    });
const $c497fae38ad3141e$export$3224e930ca89533f = 'state.actions.issue.issue-link.ISSUE_LINKS_ADD_UPDATE_FAILED';
const $c497fae38ad3141e$export$343182dd42310851 = ()=>({
        type: $c497fae38ad3141e$export$3224e930ca89533f,
        meta: (0, $sdxnu.errorFlagMeta)({
            titleMessage: (0, $7AVqz.default).genericTitle,
            descriptionMessage: (0, $7AVqz.default).genericDescription
        })
    });
const $c497fae38ad3141e$export$2f3aaf81816ff1f4 = 'state.actions.flags.REACH_DEPENDENCY_LINES_LIMIT_FLAG_IP_BOARD';
const $c497fae38ad3141e$export$c48a8dd0a23a5210 = (dependencyLinesLimit)=>({
        type: $c497fae38ad3141e$export$2f3aaf81816ff1f4,
        meta: (0, $sdxnu.infoFlagMeta)({
            titleMessage: (0, $7AVqz.default).reachDependencyLineLimitTitle,
            context: {
                limit: dependencyLinesLimit
            }
        })
    });

});


parcelRegister("fElG1", function(module, exports) {

$parcel$export(module.exports, "default", () => $54f16bef8721ff54$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $487fd = parcelRequire("487fd");

var $2bQEl = parcelRequire("2bQEl");

var $dN3Ms = parcelRequire("dN3Ms");

var $67Z81 = parcelRequire("67Z81");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$54f16bef8721ff54$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $dN3Ms.ISSUE_MEDIA_VISIBILITY_CHANGE_REQUEST)).switchMap((action)=>{
        const state = store.getState();
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const { payload: { issueId: issueId, isVisible: isVisible }, meta: { optimistic: { id: txId } } } = action;
        const fetchOptions = {
            method: isVisible ? 'PUT' : 'DELETE'
        };
        return (0, $487fd.default)((0, $2bQEl.getIssueMediaVisibilityChangeUrl)(contextPath, issueId), fetchOptions).flatMap(()=>(0, $kVLXA.Observable).of((0, $dN3Ms.issueMediaVisibilityChangeSuccess)(txId, issueId, isVisible))).catch(()=>(0, $kVLXA.Observable).of((0, $dN3Ms.issueMediaVisibilityChangeFailure)(txId)));
    });

});

parcelRegister("4tES9", function(module, exports) {

$parcel$export(module.exports, "issueMoveToBacklogEpic", () => $b1612da6359624df$export$9d05d3a44f2a11ad);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $dJl1T = parcelRequire("dJl1T");

var $7zmUm = parcelRequire("7zmUm");

var $2bQEl = parcelRequire("2bQEl");

var $cIqUn = parcelRequire("cIqUn");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");
const $b1612da6359624df$export$9d05d3a44f2a11ad = (action$, store)=>action$.ofType((0, $cIqUn.ISSUE_MOVE_TO_BACKLOG_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
        const { rankCustomFieldId: rankCustomFieldId } = (0, $d2i8f.getRankConfig)(state);
        return (0, $7zmUm.default)((0, $2bQEl.getIssuesMoveToBacklogUrl)(contextPath), {
            method: 'PUT',
            body: JSON.stringify({
                calculateNewIssuesOrder: false,
                issueKeys: action.payload.issueKeys,
                rankBeforeIssueIdOrKey: null,
                rankCustomFieldId: rankCustomFieldId,
                rapidViewId: rapidViewId,
                target: 'BACKLOG'
            })
        }).flatMap(()=>(0, $kVLXA.Observable).of((0, $cIqUn.issueMoveToBacklogSuccess)(action.meta.optimistic.id, action.payload.issueIds, action.payload.columnId))).catch((error)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('issue.move.to.backlog.failure', 'Failed to move issue to backlog', error);
            return (0, $kVLXA.Observable).of((0, $cIqUn.issueMoveToBacklogFailure)(action.meta.optimistic.id, action.payload.issueIds));
        });
    });

});

parcelRegister("fb1Ne", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6cfaad44a38c8fb$export$2e2bcd8739ae039);

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $kFsv3 = parcelRequire("kFsv3");

var $g4tDr = parcelRequire("g4tDr");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("fPS7b");


var $bkCF5 = parcelRequire("bkCF5");

var $ls4NM = parcelRequire("ls4NM");

var $3n65g = parcelRequire("3n65g");

var $cW3pH = parcelRequire("cW3pH");

var $8yiLS = parcelRequire("8yiLS");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $5mTgl = parcelRequire("5mTgl");
const $c6cfaad44a38c8fb$var$transformNewIssues = (issues)=>issues.map((issue)=>({
            issueId: String(issue.id),
            issueKey: String(issue.key),
            issueTypeId: String(issue.typeId),
            createdIssueDetails: {
                fields: {
                    status: {
                        id: String(issue.statusId)
                    },
                    project: {
                        id: String(issue.projectId)
                    },
                    issuetype: {
                        // We do not have access to hierarchy level of the new issues,
                        // but it is not used when creating via ICC, so we are hardcoding to 0
                        hierarchyLevel: 0
                    }
                }
            }
        }));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c6cfaad44a38c8fb$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $ls4NM.ISSUE_CREATE_SUCCESS)).mergeMap((action)=>{
        const currentIssues = action.payload.issues;
        const state = store.getState();
        const actions = [];
        const isIPBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        const filteredIssues = (0, $5mTgl.workFilteredIssuesSelector)(state);
        const activeSprints = (0, $ebHh7.activeSprintsSelector)(state);
        const createdAndFilteredIssues = currentIssues.filter(({ id: id })=>!filteredIssues.some((issue)=>issue.id === id));
        // don't show this flag here if custom filters are active,
        // we'll show it after the refiltering succeeds
        const shouldShowFlag = createdAndFilteredIssues.length && !(0, $8yiLS.isCustomFiltersActive)(state);
        let hasShownFlag = false;
        if (shouldShowFlag) {
            if (isIPBoard) actions.push((0, $bkCF5.cardCreateFilteredOutInIPBoard)());
            else actions.push((0, $bkCF5.issueCreateFilteredV2)(createdAndFilteredIssues.map(({ key: key })=>key)));
            hasShownFlag = true;
        } else if ((activeSprints?.length ?? 0) > 1 && !currentIssues.every((issue)=>issue.sprintId)) {
            // show a flag to pick sprint for issues created if there are multiple active sprints and no sprint filter applied as its value will be preset otherwise
            actions.push((0, $bkCF5.issueCreateFilteredV2)(currentIssues.map(({ key: key })=>key), activeSprints));
            hasShownFlag = true;
        }
        if (isCMPBoard) actions.push((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$7aa54af91613c70a), $c6cfaad44a38c8fb$var$transformNewIssues(action.payload.issues), undefined, hasShownFlag));
        // in the IP board, adding the newly created epic level issue to the issueParents
        if (isIPBoard) {
            const issue = currentIssues[0];
            const { typeId: typeId, projectId: projectId } = issue;
            const issueType = (0, $67Z81.getIssueTypeInIPboard)(state)(projectId, `${typeId}`);
            const color = issue.color ?? (0, $kFsv3.Colors).PURPLE;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueType) && issueType?.hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE)) actions.push((0, $3n65g.addIssueParent)({
                issue: {
                    id: issue.id,
                    key: issue.key,
                    summary: issue.summary,
                    issueType: {
                        iconUrl: issueType.iconUrl,
                        id: issueType.id,
                        name: issueType.name
                    },
                    color: color,
                    projectId: projectId,
                    flagged: issue?.isFlagged ?? false
                }
            }));
        }
        return (0, $kVLXA.Observable).from(actions);
    });

});

parcelRegister("b8T1q", function(module, exports) {

$parcel$export(module.exports, "issueRankTeamDateEpic", () => $f9e1d3bcbac4e8b5$export$83fa292e308a3ba);
parcelRequire("fp4O3");
parcelRequire("aSIuP");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $hGgHi = parcelRequire("hGgHi");

var $ifg6x = parcelRequire("ifg6x");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $g4tDr = parcelRequire("g4tDr");

var $4jAPy = parcelRequire("4jAPy");

var $esu6n = parcelRequire("esu6n");

var $kgiLc = parcelRequire("kgiLc");

var $lWvJn = parcelRequire("lWvJn");

var $dMBwz = parcelRequire("dMBwz");

var $5UXId = parcelRequire("5UXId");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");

var $cPGP0 = parcelRequire("cPGP0");
const $f9e1d3bcbac4e8b5$var$error = (err)=>{
    (0, $dJl1T.default).safeErrorWithoutCustomerData('team.date.and.rank.failure', 'Failed to update IP board issue', err);
    return (0, $kVLXA.Observable).of((0, $5UXId.issueTeamDateRankFailure)());
};
const $f9e1d3bcbac4e8b5$var$success = ()=>(0, $kVLXA.Observable).of((0, $5UXId.issueTeamDateRankSuccess)());
function $f9e1d3bcbac4e8b5$var$doRank(state, { payload: { issueIds: issueIds, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId } }, { customRequestHandlers: customRequestHandlers }) {
    if (!customRequestHandlers || !customRequestHandlers.rankIssue) return $f9e1d3bcbac4e8b5$var$error(new Error('no request handler found for ranking issues'));
    return (0, $lWvJn.issueRankJPOService)({
        issueIds: issueIds,
        rankBeforeIssueId: rankBeforeIssueId,
        rankAfterIssueId: rankAfterIssueId,
        requestHandler: customRequestHandlers.rankIssue
    }).flatMap(()=>$f9e1d3bcbac4e8b5$var$success()).catch((err)=>$f9e1d3bcbac4e8b5$var$error(err));
}
function $f9e1d3bcbac4e8b5$var$doSwimlaneAndColumnMove(state, action, dependencies) {
    const incrementConfig = (0, $67Z81.getIncrementConfig)(state);
    const { issueIds: issueIds, destinationColumnId: destinationColumnId, destinationSwimlaneId: destinationSwimlaneId } = action.payload;
    const teamSprintsForIterations = (0, $cPGP0.getTeamSprintsForIterations)(state, destinationSwimlaneId);
    if (incrementConfig === null) return $f9e1d3bcbac4e8b5$var$error(new Error('incrementConfig cannot be null'));
    const destinationColumn = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(destinationColumnId) && (0, $esu6n.getDateRangeColumn)((0, $fyeGd.getColumnById)(state, Number(destinationColumnId)));
    let sprint;
    // if we move the issue to a teamless swimlane (i.e. no sprints associated), we remove the sprint OR
    // if we move the issue to the unscheduled column, we clear the sprint OR
    // if the destination swimlane doesn't have sprints associated, we clear the sprint value
    if (destinationSwimlaneId === (0, $4jAPy.SWIMLANE_TEAMLESS) || destinationColumn && (0, $esu6n.isUnscheduledColumn)(destinationColumn) || !teamSprintsForIterations) sprint = null;
    if (teamSprintsForIterations) sprint = teamSprintsForIterations[destinationColumnId];
    let dateRange = destinationColumn ? destinationColumn.dateRange : null;
    // If the destination column has a sprint associated and the sprint has dates set,
    // we use these dates for the dateRange instead of the iteration dates (for Epic level issues)
    if (teamSprintsForIterations !== null && dateRange !== null && sprint && sprint.startDate !== null && sprint.endDate !== null) dateRange = {
        start: sprint.startDate,
        end: sprint.endDate
    };
    // Split issues into epics and stories
    const [epicIds, storyIds] = (0, (/*@__PURE__*/$parcel$interopDefault($ifg6x)))(issueIds, (issueId)=>{
        const issue = (0, $67Z81.getIssues)(state)[issueId];
        const issueType = (0, $67Z81.getIssueTypeInIPboard)(state)(issue.projectId, `${issue.typeId}`);
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueType) && issueType.hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE);
    });
    // Split epic that has existing start date and it's after the end of iteration (or sprint) end dates
    const [epicsWithClearStartDate, otherEpics] = (0, (/*@__PURE__*/$parcel$interopDefault($ifg6x)))(epicIds, (epicId)=>{
        const epic = (0, $67Z81.getIssues)(state)[epicId];
        return epic && epic.startDate && dateRange && dateRange.end !== 0 && new Date(epic.startDate) > new Date(dateRange.end);
    });
    const requests$ = [];
    // Clear start date for epics that has existing start date and it's after the end of iteration (or sprint) end dates
    if (epicsWithClearStartDate.length > 0) requests$.push($f9e1d3bcbac4e8b5$var$doSwimlaneAndColumnMoveWithStartAndEndDate(state, {
        type: action.type,
        payload: {
            ...action.payload,
            issueIds: epicsWithClearStartDate
        }
    }, dependencies, (0, $kgiLc.transformDateValue)(dateRange?.end), null));
    // Keep start date for epics that doesn't have existing start date or if it's before the end of iteration dates
    if (otherEpics.length > 0) requests$.push($f9e1d3bcbac4e8b5$var$doSwimlaneAndColumnMoveWithStartAndEndDate(state, {
        type: action.type,
        payload: {
            ...action.payload,
            issueIds: otherEpics
        }
    }, dependencies, (0, $kgiLc.transformDateValue)(dateRange?.end), undefined));
    // Set iteration start date or sprint for stories
    if (storyIds.length > 0) {
        if (sprint) requests$.push($f9e1d3bcbac4e8b5$var$doSwimlaneAndColumnMoveWithSprint(state, {
            type: action.type,
            payload: {
                ...action.payload,
                issueIds: storyIds
            }
        }, dependencies, sprint.id));
        else requests$.push($f9e1d3bcbac4e8b5$var$doSwimlaneAndColumnMoveWithStartAndEndDate(state, {
            type: action.type,
            payload: {
                ...action.payload,
                issueIds: storyIds
            }
        }, dependencies, (0, $kgiLc.transformDateValue)(dateRange?.end), (0, $kgiLc.transformDateValue)(dateRange?.start), sprint === null));
    }
    return (0, $kVLXA.Observable).forkJoin(...requests$);
}
/* This function is called for Epic level issues, or Story level issues where the destination team column does not have a sprint association */ function $f9e1d3bcbac4e8b5$var$doSwimlaneAndColumnMoveWithStartAndEndDate(state, { payload: { issueIds: issueIds, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId } }, { customRequestHandlers: customRequestHandlers }, newEndDate, newStartDate, shouldClearSprint) {
    if (!customRequestHandlers || !customRequestHandlers.bulkUpdateIssues) return $f9e1d3bcbac4e8b5$var$error(new Error('no request handler found for swimlane and column move'));
    const incrementConfig = (0, $67Z81.getIncrementConfig)(state);
    if (incrementConfig === null) return $f9e1d3bcbac4e8b5$var$error(new Error('incrementConfig cannot be null'));
    const destinationColumn = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(destinationColumnId) && (0, $esu6n.getDateRangeColumn)((0, $fyeGd.getColumnById)(state, Number(destinationColumnId)));
    const destinationSwimlaneHasSprints = (0, $cPGP0.getTeamSprintsForIterations)(state, destinationSwimlaneId) !== null;
    const sourceSwimlaneHasSprints = (0, $cPGP0.getTeamSprintsForIterations)(state, sourceSwimlaneId) !== null;
    const values = (()=>{
        let innerValues = {};
        const startEndValues = (0, $kgiLc.transformDateRangeUpdateValues)(incrementConfig, newStartDate, newEndDate);
        const isColumnChange = destinationColumnId !== sourceColumnId;
        const isSwimlaneChange = destinationSwimlaneId && sourceSwimlaneId !== destinationSwimlaneId;
        const sprintSwimlaneToDateSwimlane = sourceSwimlaneHasSprints && !destinationSwimlaneHasSprints;
        // Regardless of column change, update start / end date when epics are moved to swimlanes with linked sprints
        // or when both epic and story-level issues are moved from sprint linked swimlanes to date range swimlanes
        if (sprintSwimlaneToDateSwimlane || destinationSwimlaneHasSprints || isColumnChange) {
            // Update start and end dates
            innerValues = startEndValues;
            // Clear sprints when moving to unscheduled column
            // or when epics moving to a column linked to sprints
            if (destinationColumn && ((0, $esu6n.isUnscheduledColumn)(destinationColumn) || destinationSwimlaneHasSprints)) innerValues.sprint = null;
        }
        if (isSwimlaneChange) {
            // if moving an issue from sprint associated team/column to teamless swimlane or team w/out sprint assoc we assign iteration dates
            if (sprintSwimlaneToDateSwimlane) // Update start and end dates
            innerValues = {
                ...innerValues,
                ...startEndValues
            };
            innerValues.team = destinationSwimlaneId === (0, $4jAPy.SWIMLANE_TEAMLESS) ? null : destinationSwimlaneId;
        }
        if (shouldClearSprint) innerValues.sprint = null;
        return innerValues;
    })();
    return (0, $kVLXA.Observable).of((0, $dMBwz.issueBulkUpdateRequest)({
        issueIds: issueIds,
        ...values
    }));
}
/* This function is called for Story level issues where the destination team column has a sprint association */ function $f9e1d3bcbac4e8b5$var$doSwimlaneAndColumnMoveWithSprint(state, { payload: { issueIds: issueIds, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId } }, { customRequestHandlers: customRequestHandlers }, sprintId) {
    if (!customRequestHandlers || !customRequestHandlers.bulkUpdateIssues) return $f9e1d3bcbac4e8b5$var$error(new Error('no request handler found for swimlane and column move'));
    const incrementConfig = (0, $67Z81.getIncrementConfig)(state);
    if (incrementConfig === null) return $f9e1d3bcbac4e8b5$var$error(new Error('incrementConfig cannot be null'));
    const values = (()=>{
        const innerValues = {};
        // assign sprint value when an issue moves from a different swimlane or column
        if (sourceSwimlaneId !== destinationSwimlaneId || destinationColumnId !== sourceColumnId) innerValues.sprint = `${sprintId}`;
        // assign team value when an issue moves from a different swimlane
        if (destinationSwimlaneId && sourceSwimlaneId !== destinationSwimlaneId) innerValues.team = destinationSwimlaneId;
        return innerValues;
    })();
    return (0, $kVLXA.Observable).of((0, $dMBwz.issueBulkUpdateRequest)({
        issueIds: issueIds,
        ...values
    }));
}
function $f9e1d3bcbac4e8b5$export$e8f4ada03ddbca5e(store, action, dependencies) {
    const state = store.getState();
    const { rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId } = action.payload;
    const hasRankChanged = !((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(rankBeforeIssueId) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(rankAfterIssueId));
    return $f9e1d3bcbac4e8b5$var$doSwimlaneAndColumnMove(state, action, dependencies).flatMap((followUpAction)=>{
        if (followUpAction) return (0, $kVLXA.Observable).merge(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        followUpAction, hasRankChanged ? $f9e1d3bcbac4e8b5$var$doRank(state, action, dependencies) : $f9e1d3bcbac4e8b5$var$success());
        return hasRankChanged ? $f9e1d3bcbac4e8b5$var$doRank(state, action, dependencies) : $f9e1d3bcbac4e8b5$var$success();
    }).catch((err)=>$f9e1d3bcbac4e8b5$var$error(err));
}
function $f9e1d3bcbac4e8b5$export$83fa292e308a3ba(action$, store, dependencies) {
    return action$.ofType((0, $5UXId.ISSUE_RANK_TEAM_DATE_REQUEST)).mergeMap((action)=>$f9e1d3bcbac4e8b5$export$e8f4ada03ddbca5e(store, action, dependencies));
}

});

parcelRegister("7UfD9", function(module, exports) {

$parcel$export(module.exports, "issueRankTransitionEpic", () => $e472efe013064c67$export$1768053f95c4bd6a);
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("9IWoG");
parcelRequire("6hSeW");
parcelRequire("d0pqD");
parcelRequire("93e44");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");


var $c79wa = parcelRequire("c79wa");

var $41Cb8 = parcelRequire("41Cb8");

var $4EkCk = parcelRequire("4EkCk");

var $2W0EG = parcelRequire("2W0EG");

var $9iM6y = parcelRequire("9iM6y");

var $bwTbl = parcelRequire("bwTbl");

var $lWvJn = parcelRequire("lWvJn");

var $hdmw1 = parcelRequire("hdmw1");

var $71oFY = parcelRequire("71oFY");

var $evkwq = parcelRequire("evkwq");

var $lIysR = parcelRequire("lIysR");

var $fyeGd = parcelRequire("fyeGd");

var $vAfHD = parcelRequire("vAfHD");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $4jZ56 = parcelRequire("4jZ56");

var $cN1y7 = parcelRequire("cN1y7");

var $7mswo = parcelRequire("7mswo");
function $e472efe013064c67$export$ee82a854da62e9b7(analyticsEvent, state, { payload: { issueIds: issueIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId, isDestinationDone: isDestinationDone, sourceStatus: sourceStatus, destinationStatus: destinationStatus } }) {
    const updatedItems = [];
    let rankOnlyOp = true;
    const firstStatusInDestinationColumn = (0, $fyeGd.getStatusesByColumnId)(state)(destinationColumnId)[0];
    updatedItems.push({
        name: 'statusCategory',
        oldValName: sourceStatus?.category,
        // destinationStatus is undefined when board is in default mode, retrieve first status from destination column
        newValName: destinationStatus ? destinationStatus?.category : firstStatusInDestinationColumn.category
    });
    if (sourceSwimlaneId !== destinationSwimlaneId) {
        updatedItems.push({
            name: 'assignee'
        }, {
            name: 'swimlane'
        });
        rankOnlyOp = false;
    }
    if (sourceColumnId !== destinationColumnId) {
        updatedItems.push({
            name: 'status',
            oldValId: sourceStatus?.id,
            // destinationStatus is undefined when board is in default mode, retrieve first status from destination column
            newValId: destinationStatus ? destinationStatus?.id : firstStatusInDestinationColumn.id
        });
        const isSourceDone = (0, $fyeGd.isDoneColumnSelector)(state)(sourceColumnId);
        if (isSourceDone !== isDestinationDone) updatedItems.push({
            name: 'resolution',
            oldValId: isSourceDone,
            newValId: isDestinationDone
        });
        rankOnlyOp = false;
    }
    if (rankOnlyOp) updatedItems.push({
        name: `customfield_${(0, $d2i8f.getRankConfig)(state).rankCustomFieldId}`
    });
    const issueTypeLevel = (0, $d2i8f.getIssueTypeLevelForBoardIssue)(state)(issueIds[0]);
    analyticsEvent.update({
        updatedItems: updatedItems,
        issueTypeLevel: issueTypeLevel
    });
}
function $e472efe013064c67$export$dd20008182c41b85(state, { payload: { issueIds: issueIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId, transitionId: transitionId } }) {
    const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
    const allIssues = (0, $vAfHD.boardIssuesSelector)(state);
    const issueKeys = issueIds.map((issueId)=>allIssues[String(issueId)]?.key);
    const { rankCustomFieldId: rankCustomFieldId } = (0, $d2i8f.getRankConfig)(state);
    const requestPayload = {
        rapidViewId: rapidViewId,
        issueKeys: issueKeys,
        rankCustomFieldId: rankCustomFieldId,
        rankBeforeIssueIdOrKey: rankBeforeIssueId,
        rankAfterIssueIdOrKey: rankAfterIssueId
    };
    // If FF enabled, make sure we filter by project key as well
    const issue = allIssues[String(issueIds[0])];
    const selectedTransition = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transitionId) && sourceColumnId !== destinationColumnId ? (0, $fyeGd.firstGlobalTransitionIdForColumnWithProjectFilteringSelector)(state)(destinationColumnId, issue) : transitionId;
    return {
        ...requestPayload,
        selectedTransitionId: selectedTransition
    };
}
function $e472efe013064c67$export$2f1dedbab5d9015b(state, { payload: { issueIds: issueIds, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId } }) {
    const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
    const allIssues = (0, $vAfHD.boardIssuesSelector)(state);
    const issueKeys = issueIds.map((issueId)=>allIssues[String(issueId)]?.key);
    const { rankCustomFieldId: rankCustomFieldId } = (0, $d2i8f.getRankConfig)(state);
    return {
        rapidViewId: rapidViewId,
        issueKeys: issueKeys,
        rankCustomFieldId: rankCustomFieldId,
        rankBeforeIssueIdOrKey: rankBeforeIssueId,
        rankAfterIssueIdOrKey: rankAfterIssueId
    };
}
/**
 * Perform all updates for a swimlane move drag operation and return an
 * observable that completes after all of the operations emit.
 *
 * If multiple issues are moved between swimlanes at the same time, this will
 * fire requests concurrently.
 */ function $e472efe013064c67$var$doSwimlaneMove(state, { payload: { issueIds: issueIds, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId } }) {
    const ctx = (0, $hdmw1.makeServiceContext)(state);
    const allIssues = (0, $vAfHD.boardIssuesSelector)(state);
    const contextPath = (0, $67Z81.contextPathSelector)(state);
    const projectId = (0, $67Z81.projectIdSelector)(state);
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    const values = destinationSwimlaneId && sourceSwimlaneId !== destinationSwimlaneId ? (0, $4jZ56.makeSwimlaneValuesSelector)(state)(destinationSwimlaneId) : null;
    if (!values) return (0, $kVLXA.Observable).empty();
    if (values.type === (0, $c79wa.ASSIGNEE)) {
        const issueFields = (0, $bwTbl.getIssueCreateOrUpdateFields)(values);
        return (0, $kVLXA.Observable).forkJoin(issueIds.map((issueId)=>(0, $lWvJn.issueUpdateService)(ctx, {
                issueKey: allIssues[String(issueId)]?.key,
                values: issueFields
            })));
    }
    if (values.type === (0, $c79wa.STORY)) {
        if (isCMPBoard) return (0, $kVLXA.Observable).forkJoin(issueIds.map((issueId)=>{
            const issueKey = (0, $d2i8f.getIssueById)(state, issueId)?.key;
            return (0, $4EkCk.fetchSetCMPIssueParent)(issueKey, Number(values.parentId));
        }));
        return (0, $4EkCk.fetchSetIssueParent)(contextPath, projectId, Number(values.parentId), {
            issueIds: issueIds
        });
    }
    if (values.type === (0, $c79wa.PARENT)) {
        if (isCMPBoard) return (0, $kVLXA.Observable).forkJoin(issueIds.map((issueId)=>{
            const issueKey = (0, $d2i8f.getIssueById)(state, issueId)?.key;
            return (0, $4EkCk.fetchSetCMPIssueParent)(issueKey, values.parentId ? Number(destinationSwimlaneId) : null);
        }));
        if (values.parentId) return (0, $4EkCk.fetchSetIssueParent)(contextPath, projectId, Number(destinationSwimlaneId), {
            issueIds: issueIds
        });
        // If parentId is null then we need to unassign the parent
        return (0, $41Cb8.default)(contextPath, projectId, {
            issueIds: issueIds
        });
    }
    return (0, $kVLXA.Observable).empty();
}
const $e472efe013064c67$export$3134aad02465a5ae = ({ issueKeys: issueKeys, issueIds: issueIds, analyticsEvent: analyticsEvent, txId: txId, extraAnalyticsAttrs: extraAnalyticsAttrs, parentIds: parentIds, batchId: batchId, isCMPBoard: isCMPBoard, destinationStatus: destinationStatus })=>{
    if (analyticsEvent) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'cards moved', {
        ...extraAnalyticsAttrs,
        issueKeys: issueKeys.toString(),
        issueIds: issueIds.toString()
    });
    if (analyticsEvent && parentIds) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueParent updated', {
        ...extraAnalyticsAttrs,
        issueKeys: issueKeys.toString(),
        issueIds: issueIds.toString(),
        parentId: parentIds.toString()
    });
    const actions = [
        (0, $71oFY.issueRankTransitionSuccess)({
            optimisticId: txId,
            issueIds: issueIds,
            batchId: batchId,
            analyticsEvent: analyticsEvent,
            issueKeys: issueKeys,
            destinationStatus: destinationStatus
        })
    ];
    if (!isCMPBoard) actions.push((0, $evkwq.issueUpdateRequestWithTransactionId)(issueIds, (0, $f32ae13c2b9742f4$export$f2127cf693ff3edc), txId));
    return (0, $kVLXA.Observable).from(actions);
};
function $e472efe013064c67$export$d2523457fef715f({ error: error, txId: txId, batchId: batchId, analyticsEvent: analyticsEvent }) {
    (0, $dJl1T.default).safeErrorWithoutCustomerData('transition.and.rank.failure', 'Failed to transition issue', error);
    if (analyticsEvent && (0, $cN1y7.shouldFireFailureSLOMetric)(error)) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'cards moveFailed', {
        errorMessage: error.message ? error.message : error,
        statusCodeGroup: (0, $cN1y7.getStatusCodeGroup)(error)
    });
    if ((0, $fZneA.isHttpTooManyRequestsResponse)(error)) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'cards moveAborted', {
        errorMessage: error.message ? error.message : error,
        statusCodeGroup: '429'
    });
    return (0, $kVLXA.Observable).of((0, $71oFY.issueRankTransitionFailure)(txId, batchId));
}
function $e472efe013064c67$export$ebec16eb1bd24c45(store, action) {
    const state = store.getState();
    const { payload: { issueIds: issueIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId, batchId: batchId, transitionId: transitionId, isDestinationDone: isDestinationDone, destinationStatus: destinationStatus, rankAfterIssueId: rankAfterIssueId, rankBeforeIssueId: rankBeforeIssueId, isRankable: isRankable, mode: mode }, meta: { analyticsEvent: analyticsEvent } } = action;
    const txIdOld = String(action.meta.optimistic?.id);
    const requestPayload = $e472efe013064c67$export$dd20008182c41b85(state, action);
    $e472efe013064c67$export$ee82a854da62e9b7(analyticsEvent, state, action);
    const allIssues = (0, $vAfHD.boardIssuesSelector)(state);
    const issueParents = issueIds.map((issueId)=>allIssues[String(issueId)].parentId);
    const issue = allIssues[String(issueIds[0])];
    const destinationTransitions = (0, $lIysR.getTransitionsByColumnAndIssueType)(state, {
        columnId: destinationColumnId,
        issueTypeId: issue.typeId,
        projectId: issue.projectId
    });
    const transitionIndex = requestPayload.selectedTransitionId != null ? destinationTransitions.findIndex((transition)=>transition.id === requestPayload.selectedTransitionId) : null;
    const transition = transitionIndex != null ? destinationTransitions[transitionIndex] : null;
    const extraAnalyticsAttrs = {
        movedColumns: sourceColumnId !== destinationColumnId,
        hasMovedSwimlanes: sourceSwimlaneId !== destinationSwimlaneId,
        columnTransitionsCount: destinationTransitions.length,
        transitionIndex: transitionIndex
    };
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    const transitionOptimisticUpdateAction = (0, $71oFY.issueRankTransitionUpdateOptimistic)({
        sourceColumnId: sourceColumnId,
        issueIds: issueIds,
        destinationColumnId: destinationColumnId,
        isDestinationDone: isDestinationDone,
        destinationStatus: destinationStatus,
        rankAfterIssueId: rankAfterIssueId,
        rankBeforeIssueId: rankBeforeIssueId,
        isRankable: isRankable,
        mode: mode,
        isCMPBoard: isCMPBoard,
        analyticsEvent: analyticsEvent
    });
    const txId = transitionOptimisticUpdateAction.meta.optimistic.id ?? txIdOld;
    const transitionOptimisticUpdate$ = (0, $kVLXA.Observable).of(transitionOptimisticUpdateAction);
    const error = (err)=>{
        !transition?.hasScreen && (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueTransition failed', {
            triggerPointKey: (0, $7mswo.SOFTWARE_BOARD_ISSUE_TRANSITION),
            isModalOpen: false
        });
        return (0, $2W0EG.hasJiraErrorMessages)(err) ? (0, $kVLXA.Observable).of((0, $71oFY.issueRankTransitionFailureFieldRequired)(txId, issue.key, (0, $2W0EG.parseJiraErrorMessages)(err))) : $e472efe013064c67$export$d2523457fef715f({
            error: err,
            txId: txId,
            batchId: batchId,
            analyticsEvent: analyticsEvent
        });
    };
    const success = ()=>{
        !transition?.hasScreen && (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueTransition success', {
            triggerPointKey: (0, $7mswo.SOFTWARE_BOARD_ISSUE_TRANSITION),
            isModalOpen: false
        });
        return $e472efe013064c67$export$3134aad02465a5ae({
            issueKeys: requestPayload.issueKeys,
            issueIds: issueIds,
            analyticsEvent: analyticsEvent,
            txId: txId,
            extraAnalyticsAttrs: extraAnalyticsAttrs,
            parentIds: issueParents,
            batchId: batchId,
            isCMPBoard: isCMPBoard,
            destinationStatus: destinationStatus?.name
        });
    };
    const hasScreen = transition?.hasScreen === true;
    const doTransitionRank = ()=>{
        const ctx = (0, $hdmw1.makeServiceContext)(store.getState());
        if (hasScreen) {
            const dispatch = store.dispatch.bind(store);
            // TODO this only works for single issue drag, also if this is
            // aborted or fails the correct behaviour would be to revert the
            // entire operation, but we will already have committed issue field
            // changes.
            return (0, $7mswo.openTransitionScreen)({
                issueId: String(issue.id),
                issueKey: issue.key,
                transitionId: transition.id,
                analyticsEvent: analyticsEvent,
                dispatch: dispatch
            }).flatMap((result)=>{
                if (result.type === (0, $7mswo.TRANSITION_SCREEN_SUCCESS)) {
                    if (!isRankable) return (0, $kVLXA.Observable).merge(transitionOptimisticUpdate$, success());
                    const shouldRankRequest = mode === 'TRANSITION_AND_RANK' && (rankBeforeIssueId || rankAfterIssueId);
                    // don't rank request if there are no issues to rank against
                    if (!shouldRankRequest) return (0, $kVLXA.Observable).merge(transitionOptimisticUpdate$, success());
                    const requestRankPayload = $e472efe013064c67$export$2f1dedbab5d9015b(state, action);
                    return (0, $kVLXA.Observable).merge(transitionOptimisticUpdate$, (0, $9iM6y.issueRankTransitionService)(ctx, requestRankPayload).flatMap(()=>success()).catch((err)=>error(err)));
                }
                if (result.type === (0, $7mswo.TRANSITION_SCREEN_CANCEL)) return (0, $kVLXA.Observable).of((0, $71oFY.issueRankTransitionAbort)(txId));
                if (result.type === (0, $7mswo.TRANSITION_SCREEN_ERROR)) return error(result.error);
                return (0, $kVLXA.Observable).empty();
            });
        }
        if (mode === 'TRANSITION_ONLY') // Call the transition API used in legacy CMP to retain the ranking order after transition,
        // remove this once issueRankTransitionService supports this
        return (0, $9iM6y.issueTransitionService)(ctx, {
            issueKeys: requestPayload.issueKeys,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            selectedTransitionId: transitionId,
            targetColumn: destinationColumnId
        }).flatMap(()=>success()).catch((err)=>error(err));
        return (0, $9iM6y.issueRankTransitionService)(ctx, requestPayload).flatMap(()=>success()).catch((err)=>error(err));
    };
    const hasRankOrTransitionChanged = Boolean(requestPayload.rankAfterIssueIdOrKey != null || requestPayload.rankBeforeIssueIdOrKey != null || requestPayload.selectedTransitionId != null);
    const hasSwimlaneChanged = Boolean(destinationSwimlaneId && sourceSwimlaneId !== destinationSwimlaneId);
    if (!hasSwimlaneChanged) return (0, $kVLXA.Observable).merge(hasScreen ? (0, $kVLXA.Observable).empty() : transitionOptimisticUpdate$, doTransitionRank());
    return (0, $kVLXA.Observable).merge(hasScreen ? (0, $kVLXA.Observable).empty() : transitionOptimisticUpdate$, $e472efe013064c67$var$doSwimlaneMove(state, action).catch((err)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('pre.issue.transition.update.failure', 'Failed to prepare issues data to transition', err);
        if (hasRankOrTransitionChanged) return (0, $kVLXA.Observable).of(null);
        throw err;
    }).flatMap(()=>hasRankOrTransitionChanged ? doTransitionRank() : success()).catch((err)=>error(err)));
}
const $e472efe013064c67$var$concurrencyLimits = 10;
function $e472efe013064c67$export$1768053f95c4bd6a(action$, store) {
    return action$.ofType((0, $71oFY.ISSUE_RANK_TRANSITION_REQUEST)).mergeMap((action)=>$e472efe013064c67$export$ebec16eb1bd24c45(store, action), $e472efe013064c67$var$concurrencyLimits);
}

});
parcelRegister("41Cb8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9040bbece1764cea$export$2e2bcd8739ae039);

var $487fd = parcelRequire("487fd");
const $9040bbece1764cea$export$65ffcd95f70c1bda = (contextPath, projectId)=>`${contextPath}/rest/internal/simplified/1.0/projects/${projectId}/issues/delete-parents`;
var // Remove with TOTEM-2726 ff
// eslint-disable-next-line jira/import/no-anonymous-default-export
$9040bbece1764cea$export$2e2bcd8739ae039 = (contextPath, projectId, payload)=>(0, $487fd.default)($9040bbece1764cea$export$65ffcd95f70c1bda(contextPath, projectId), {
        method: 'POST',
        body: JSON.stringify(payload)
    });

});

parcelRegister("4EkCk", function(module, exports) {

$parcel$export(module.exports, "fetchSetIssueParent", () => $750c8ada738ff48c$export$822e6d48be31975);
$parcel$export(module.exports, "fetchSetCMPIssueParent", () => $750c8ada738ff48c$export$9724e1b3adad0582);

var $487fd = parcelRequire("487fd");
const $750c8ada738ff48c$var$getIssueSetParentUrl = (contextPath, projectId, parentId)=>`${contextPath}/rest/internal/simplified/1.0/projects/${projectId}/issues/${parentId}/children`;
const $750c8ada738ff48c$export$822e6d48be31975 = (contextPath, projectId, parentId, payload)=>(0, $487fd.default)($750c8ada738ff48c$var$getIssueSetParentUrl(contextPath, projectId, parentId), {
        method: 'POST',
        body: JSON.stringify(payload)
    });
const $750c8ada738ff48c$export$9724e1b3adad0582 = (issueKey, parentId)=>(0, $487fd.default)(`/rest/api/3/issue/${issueKey}`, {
        method: 'PUT',
        body: JSON.stringify({
            fields: {
                parent: {
                    id: parentId && String(parentId)
                }
            }
        })
    });

});

parcelRegister("7mswo", function(module, exports) {

$parcel$export(module.exports, "TRANSITION_SCREEN_SUCCESS", () => $d142bca829a4b440$export$e8f04beef9e7ac2b);
$parcel$export(module.exports, "TRANSITION_SCREEN_ERROR", () => $d142bca829a4b440$export$15efa9bd4dbe702b);
$parcel$export(module.exports, "TRANSITION_SCREEN_CANCEL", () => $d142bca829a4b440$export$96ee4dc1a27f098d);
$parcel$export(module.exports, "SOFTWARE_BOARD_ISSUE_TRANSITION", () => $d142bca829a4b440$export$f662a3f45b12c977);
$parcel$export(module.exports, "openTransitionScreen", () => $d142bca829a4b440$export$8cdda22e86b8604a);

var $kVLXA = parcelRequire("kVLXA");

var $8zOmE = parcelRequire("8zOmE");

var $1fh1A = parcelRequire("1fh1A");
const $d142bca829a4b440$export$e8f04beef9e7ac2b = 'TRANSITION_SCREEN_SUCCESS';
const $d142bca829a4b440$export$15efa9bd4dbe702b = 'TRANSITION_SCREEN_ERROR';
const $d142bca829a4b440$export$96ee4dc1a27f098d = 'TRANSITION_SCREEN_CANCEL';
const $d142bca829a4b440$export$f662a3f45b12c977 = 'software-board-issue-transition';
function $d142bca829a4b440$export$8cdda22e86b8604a({ issueId: issueId, issueKey: issueKey, transitionId: transitionId, analyticsEvent: analyticsEvent, dispatch: dispatch }) {
    return new (0, $kVLXA.Observable)((subscriber)=>{
        const handleDialogSuccess = ()=>{
            subscriber.next({
                type: $d142bca829a4b440$export$e8f04beef9e7ac2b
            });
            subscriber.complete();
            // @ts-expect-error - Argument of type 'UIAnalyticsEvent | undefined' is not assignable to parameter of type 'UIAnalyticsEvent'.
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueTransition success', {
                triggerPointKey: $d142bca829a4b440$export$f662a3f45b12c977,
                isModalOpen: true
            });
        };
        const handleDialogCancel = ()=>{
            subscriber.next({
                type: $d142bca829a4b440$export$96ee4dc1a27f098d
            });
            subscriber.complete();
            // @ts-expect-error - Argument of type 'UIAnalyticsEvent | undefined' is not assignable to parameter of type 'UIAnalyticsEvent'.
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueTransition cancel', {
                triggerPointKey: $d142bca829a4b440$export$f662a3f45b12c977,
                isModalOpen: true
            });
        };
        const handleDialogError = (error)=>{
            subscriber.next({
                type: $d142bca829a4b440$export$15efa9bd4dbe702b,
                error: error ?? new Error('Failed to execute transition screen')
            });
            subscriber.complete();
            // @ts-expect-error - Argument of type 'UIAnalyticsEvent | undefined' is not assignable to parameter of type 'UIAnalyticsEvent'.
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueTransition failed', {
                triggerPointKey: $d142bca829a4b440$export$f662a3f45b12c977,
                isModalOpen: true
            });
        };
        dispatch((0, $1fh1A.openIssueTransitionModal)({
            issueId: issueId,
            issueKey: issueKey,
            transitionId: String(transitionId),
            onDialogCancel: handleDialogCancel,
            onDialogError: handleDialogError,
            onDialogSuccess: handleDialogSuccess
        }));
    });
}

});
parcelRegister("1fh1A", function(module, exports) {

$parcel$export(module.exports, "OPEN_ISSUE_TRANSITION_MODAL", () => $6b36abdf6f0f816d$export$8832c8eada77a7);
$parcel$export(module.exports, "openIssueTransitionModal", () => $6b36abdf6f0f816d$export$bb76131907dfafc);
$parcel$export(module.exports, "CLOSE_ISSUE_TRANSITION_MODAL", () => $6b36abdf6f0f816d$export$e15861bd6dba960e);
$parcel$export(module.exports, "closeIssueTransitionModal", () => $6b36abdf6f0f816d$export$221941c279d4f72);
const $6b36abdf6f0f816d$export$8832c8eada77a7 = 'state.actions.issue.update-issue-parent-modal.OPEN_ISSUE_TRANSITION_MODAL';
const $6b36abdf6f0f816d$export$bb76131907dfafc = (payload)=>({
        type: $6b36abdf6f0f816d$export$8832c8eada77a7,
        payload: payload
    });
const $6b36abdf6f0f816d$export$e15861bd6dba960e = 'state.actions.issue.update-issue-parent-modal.CLOSE_ISSUE_TRANSITION_MODAL';
const $6b36abdf6f0f816d$export$221941c279d4f72 = ()=>({
        type: $6b36abdf6f0f816d$export$e15861bd6dba960e
    });

});



parcelRegister("bTMOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c04ebdce5640308$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");


var $iuuJH = parcelRequire("iuuJH");

var $bwTbl = parcelRequire("bwTbl");

var $71oFY = parcelRequire("71oFY");

var $9OPlz = parcelRequire("9OPlz");

var $cPmFH = parcelRequire("cPmFH");

var $d2i8f = parcelRequire("d2i8f");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7c04ebdce5640308$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $71oFY.ISSUE_MOVE_TOP_OR_BOTTOM_OF_CONTAINER)).mergeMap((action)=>{
        const state = store.getState();
        const { payload: { placement: placement, fireShortcutAnalyticsFn: fireShortcutAnalyticsFn }, meta: { analyticsEvent: analyticsEvent } } = action;
        const issueIds = (0, $9OPlz.getCardSelection)(state);
        // will be removed if multi-select movement is added
        if (issueIds.length !== 1) return (0, $kVLXA.Observable).empty();
        const issueId = issueIds[0];
        const issue = (0, $d2i8f.getIssueById)(state, issueId);
        const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
        const hasSwimlanes = swimlaneMode !== (0, $iuuJH.NO_SWIMLANE).id;
        const isTop = placement === (0, $dcbb2bce513725b3$export$e5bf25b985a7619d);
        const isBottom = placement === (0, $dcbb2bce513725b3$export$e044c7349fbdcb2);
        const isFirst = !hasSwimlanes ? (0, $d2i8f.isFirstIssueInColumn)(state, issueId) : (0, $cPmFH.isFirstIssueInSwimlane)(state, issueId);
        const isLast = !hasSwimlanes ? (0, $d2i8f.isLastIssueInColumn)(state, issueId) : (0, $cPmFH.isLastIssueInSwimlane)(state, issueId);
        if (isTop && isFirst || isBottom && isLast) return (0, $kVLXA.Observable).empty();
        const swimlaneId = hasSwimlanes ? (0, $bwTbl.getSwimlaneId)(swimlaneMode, (0, $4jZ56.getSwimlanes)(state), issue) : null;
        const firstIssueId = !hasSwimlanes || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(swimlaneId) ? (0, $d2i8f.getFirstIssueInColumn)(state, issue.columnId) : (0, $cPmFH.getFirstIssueIdInSwimlane)(state, issue.columnId, swimlaneId);
        const lastIssueId = !hasSwimlanes || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(swimlaneId) ? (0, $d2i8f.getLastIssueInColumn)(state, issue.columnId) : (0, $cPmFH.getLastIssueIdInSwimlane)(state, issue.columnId, swimlaneId);
        const payload = {
            issueIds: issueIds,
            sourceColumnId: issue.columnId,
            destinationColumnId: issue.columnId,
            rankBeforeIssueId: isTop ? firstIssueId : null,
            rankAfterIssueId: isBottom ? lastIssueId : null,
            sourceSwimlaneId: null,
            destinationSwimlaneId: null,
            isSourceDone: false,
            isDestinationDone: false,
            analyticsEvent: analyticsEvent
        };
        const attributes = {
            key: isTop ? 's t' : 's b',
            id: isTop ? 'sendToTopKeyboardShortcut' : 'sendToBottomKeyboardShortcut',
            attributes: {
                isMultiSelect: issueIds.length > 1
            }
        };
        fireShortcutAnalyticsFn(attributes);
        return (0, $kVLXA.Observable).of((0, $71oFY.issueRankTransitionRequest)(payload));
    });

});
parcelRegister("cPmFH", function(module, exports) {

$parcel$export(module.exports, "getFirstIssueIdInSwimlane", () => $354fa4f988c91859$export$98ede6267b8600eb);
$parcel$export(module.exports, "getLastIssueIdInSwimlane", () => $354fa4f988c91859$export$e7018d5dca9b70f6);
$parcel$export(module.exports, "isFirstIssueInSwimlane", () => $354fa4f988c91859$export$c1b8534c3ed82c1c);
$parcel$export(module.exports, "isLastIssueInSwimlane", () => $354fa4f988c91859$export$fc100c375fce1b71);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $hYfgW = parcelRequire("hYfgW");

var $bwTbl = parcelRequire("bwTbl");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $vAfHD = parcelRequire("vAfHD");

var $d2i8f = parcelRequire("d2i8f");
const $354fa4f988c91859$export$5111e8c99c5b8e11 = (0, $dGvGJ.createSelector)([
    (0, $4jZ56.getSwimlanes),
    (0, $45cXl.getSwimlaneMode),
    (0, $d2i8f.getOrderedIssuesByColumn)
], (swimlanes, swimlaneMode, issues)=>{
    const swimlaneIssuesMap = {};
    swimlanes.forEach((swimlane)=>{
        swimlaneIssuesMap[swimlane.id] = Object.keys(issues).reduce((groupedIssues, columnId)=>{
            groupedIssues.setIn([
                String(columnId)
            ], issues[Number(columnId)].filter((issue)=>(0, $bwTbl.getSwimlaneId)(swimlaneMode, swimlanes, issue) === swimlane.id));
            return groupedIssues;
        }, (0, $7uUwQ.chain)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {})).value();
    });
    return swimlaneIssuesMap;
});
const $354fa4f988c91859$export$283bde08d2f5fddb = (state, swimlaneId)=>{
    let issueCount = 0;
    const swimlane = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))($354fa4f988c91859$export$5111e8c99c5b8e11(state), [
        swimlaneId
    ], null);
    if (swimlane) Object.values(swimlane).forEach((column)=>{
        issueCount += column.length;
    });
    return issueCount === 0;
};
const $354fa4f988c91859$export$98ede6267b8600eb = (state, columnId, swimlaneId)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))($354fa4f988c91859$export$5111e8c99c5b8e11(state), [
        swimlaneId,
        columnId,
        0,
        'id'
    ], null);
const $354fa4f988c91859$export$e7018d5dca9b70f6 = (state, columnId, swimlaneId)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))($354fa4f988c91859$export$5111e8c99c5b8e11(state), [
        swimlaneId,
        columnId
    ], [])), [
        'id'
    ], null);
const $354fa4f988c91859$export$c1b8534c3ed82c1c = (state, issueId)=>{
    const issue = (0, $vAfHD.boardIssuesSelector)(state)[String(issueId)];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue)) return false;
    const swimlaneId = (0, $bwTbl.getSwimlaneId)((0, $45cXl.getSwimlaneMode)(state), (0, $4jZ56.getSwimlanes)(state), issue);
    return issue !== undefined && swimlaneId !== null && $354fa4f988c91859$export$98ede6267b8600eb(state, issue.columnId, swimlaneId) === issueId;
};
const $354fa4f988c91859$export$fc100c375fce1b71 = (state, issueId)=>{
    const issue = (0, $vAfHD.boardIssuesSelector)(state)[String(issueId)];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue)) return false;
    const swimlaneId = (0, $bwTbl.getSwimlaneId)((0, $45cXl.getSwimlaneMode)(state), (0, $4jZ56.getSwimlanes)(state), issue);
    return issue !== undefined && swimlaneId !== null && $354fa4f988c91859$export$e7018d5dca9b70f6(state, issue.columnId, swimlaneId) === issueId;
};

});


parcelRegister("9mZdS", function(module, exports) {

$parcel$export(module.exports, "issueUnlinkEpic", () => $ff3b15731b9213fe$export$7533c4e5f6ddb0de);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $dJl1T = parcelRequire("dJl1T");

var $6WzWZ = parcelRequire("6WzWZ");
function $ff3b15731b9213fe$export$7533c4e5f6ddb0de(action$, store, { customRequestHandlers: customRequestHandlers }) {
    return action$.ofType((0, $6WzWZ.ISSUE_LINKS_REMOVE_REQUEST)).mergeMap((action)=>{
        const { issueId: issueId, issueLink: issueLink } = action.payload;
        const success = ()=>(0, $kVLXA.Observable).of((0, $6WzWZ.issueLinksRemoveSuccess)({
                issueLinksToRemove: {
                    [issueId]: issueLink.id
                }
            }));
        const error = (err)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('issue.issue-unlink-epic.failure', 'Failed to unlink IP board issue', // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            err);
            return (0, $kVLXA.Observable).of((0, $6WzWZ.issueLinksRemoveFailed)());
        };
        if (!customRequestHandlers || !customRequestHandlers.removeIssueLink) return error(new Error('no request handler found for removing dependency'));
        return (0, $kVLXA.Observable).from(customRequestHandlers.removeIssueLink({
            itemKey: issueLink.id,
            type: issueLink.linkTypeId,
            sourceItemKey: `${issueLink.sourceId}`,
            targetItemKey: `${issueLink.destinationId}`
        })).flatMap(()=>success()).catch((err)=>error(err));
    });
}

});

parcelRegister("bIfkc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c2ed91379dc4a3d$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $6oxJH = parcelRequire("6oxJH");

var $bScH2 = parcelRequire("bScH2");

var $kVLXA = parcelRequire("kVLXA");


var $iuuJH = parcelRequire("iuuJH");

var $4nScF = parcelRequire("4nScF");

var $ls4NM = parcelRequire("ls4NM");

var $kXqRJ = parcelRequire("kXqRJ");

var $71oFY = parcelRequire("71oFY");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");
const $7c2ed91379dc4a3d$export$735389bea7eedaad = (action$, store)=>action$.ofType((0, $ls4NM.ISSUE_CREATE_REQUEST)).mergeMap((action)=>{
        const { payload: { issues: issues, type: type }, meta: { swimlaneId: swimlaneId } } = action;
        const allIssues = (0, $67Z81.getIssues)(store.getState());
        if (type !== (0, $dcbb2bce513725b3$export$1f24f91824c6822f)) return (0, $kVLXA.Observable).empty();
        const parent = allIssues[String(swimlaneId)];
        if (!parent) return (0, $kVLXA.Observable).empty();
        return (0, $kVLXA.Observable).of((0, $4nScF.setChildIssuesMetadata)([
            {
                id: parent.id,
                numTotalChildren: parent.numTotalChildren + issues.length,
                numCompleteChildren: parent.numCompleteChildren + (0, (/*@__PURE__*/$parcel$interopDefault($6oxJH)))(issues, (issue)=>issue.isDone ? 1 : 0)
            }
        ]));
    });
const $7c2ed91379dc4a3d$export$6460f58b640b4012 = (action$, store)=>action$.ofType((0, $kXqRJ.ISSUE_DELETE_REQUEST)).mergeMap((action)=>{
        const { payload: { issue: issue } } = action;
        const state = store.getState();
        if ((0, $45cXl.getSwimlaneMode)(state) !== (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return (0, $kVLXA.Observable).empty();
        const issues = (0, $67Z81.getIssues)(state);
        const parent = issues[String(issue.parentId)];
        if (!parent) return (0, $kVLXA.Observable).empty();
        return (0, $kVLXA.Observable).of((0, $4nScF.setChildIssuesMetadata)([
            {
                id: parent.id,
                numTotalChildren: parent.numTotalChildren - 1,
                numCompleteChildren: parent.numCompleteChildren - (issue.isDone ? 1 : 0)
            }
        ]));
    });
const $7c2ed91379dc4a3d$export$2ad8924ae4613236 = (action$, store)=>action$.ofType((0, $71oFY.ISSUE_RANK_TRANSITION_REQUEST)).mergeMap((action)=>{
        const { payload: { issueIds: issueIds, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId, isSourceDone: isSourceDone, isDestinationDone: isDestinationDone } } = action;
        const state = store.getState();
        if ((0, $45cXl.getSwimlaneMode)(state) !== (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return (0, $kVLXA.Observable).empty();
        const issues = (0, $67Z81.getIssues)(state);
        const sourceParent = issues[String(sourceSwimlaneId)];
        const destinationParent = issues[String(destinationSwimlaneId)];
        if (!sourceParent || !destinationParent || sourceSwimlaneId === destinationSwimlaneId && isSourceDone === isDestinationDone) return (0, $kVLXA.Observable).empty();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedIssues = {};
        updatedIssues[String(sourceSwimlaneId)] = {
            numTotalChildren: sourceParent.numTotalChildren,
            numCompleteChildren: sourceParent.numCompleteChildren
        };
        updatedIssues[String(destinationSwimlaneId)] = {
            numTotalChildren: destinationParent.numTotalChildren,
            numCompleteChildren: destinationParent.numCompleteChildren
        };
        if (sourceSwimlaneId !== destinationSwimlaneId) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bScH2)))(updatedIssues, // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'PropertyName'.
            [
                sourceSwimlaneId,
                'numTotalChildren'
            ], (current)=>current - issueIds.length);
            (0, (/*@__PURE__*/$parcel$interopDefault($bScH2)))(updatedIssues, // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'PropertyName'.
            [
                destinationSwimlaneId,
                'numTotalChildren'
            ], (current)=>current + issueIds.length);
        }
        if (isSourceDone) (0, (/*@__PURE__*/$parcel$interopDefault($bScH2)))(updatedIssues, // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'PropertyName'.
        [
            sourceSwimlaneId,
            'numCompleteChildren'
        ], (current)=>current - issueIds.length);
        if (isDestinationDone) (0, (/*@__PURE__*/$parcel$interopDefault($bScH2)))(updatedIssues, // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'PropertyName'.
        [
            destinationSwimlaneId,
            'numCompleteChildren'
        ], (current)=>current + issueIds.length);
        const updatedItems = Object.keys(updatedIssues).map((id)=>{
            const { numTotalChildren: numTotalChildren, numCompleteChildren: numCompleteChildren } = updatedIssues[id];
            return {
                id: Number(id),
                numTotalChildren: numTotalChildren,
                numCompleteChildren: numCompleteChildren
            };
        });
        return (0, $kVLXA.Observable).of((0, $4nScF.setChildIssuesMetadata)(updatedItems));
    });
var $7c2ed91379dc4a3d$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)($7c2ed91379dc4a3d$export$735389bea7eedaad, $7c2ed91379dc4a3d$export$6460f58b640b4012, $7c2ed91379dc4a3d$export$2ad8924ae4613236);

});
parcelRegister("6oxJH", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $gBzAF = parcelRequire("gBzAF");
/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */ function $4a7f273a61dd10a7$var$sumBy(array, iteratee) {
    return array && array.length ? $gBzAF(array, $bxDef(iteratee, 2)) : 0;
}
module.exports = $4a7f273a61dd10a7$var$sumBy;

});
parcelRegister("gBzAF", function(module, exports) {
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function $c16bb58eedefe4cd$var$baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
module.exports = $c16bb58eedefe4cd$var$baseSum;

});


parcelRegister("bScH2", function(module, exports) {

var $4tlBN = parcelRequire("4tlBN");

var $2KOtB = parcelRequire("2KOtB");
/**
 * This method is like `_.set` except that accepts `updater` to produce the
 * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
 * is invoked with one argument: (value).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {Function} updater The function to produce the updated value.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.update(object, 'a[0].b.c', function(n) { return n * n; });
 * console.log(object.a[0].b.c);
 * // => 9
 *
 * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
 * console.log(object.x[0].y.z);
 * // => 0
 */ function $8a4e9576f44b63f2$var$update(object, path, updater) {
    return object == null ? object : $4tlBN(object, path, $2KOtB(updater));
}
module.exports = $8a4e9576f44b63f2$var$update;

});
parcelRegister("4tlBN", function(module, exports) {

var $fTwLR = parcelRequire("fTwLR");

var $ajB7H = parcelRequire("ajB7H");
/**
 * The base implementation of `_.update`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to update.
 * @param {Function} updater The function to produce the updated value.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $341aa1dd6380288c$var$baseUpdate(object, path, updater, customizer) {
    return $ajB7H(object, path, updater($fTwLR(object, path)), customizer);
}
module.exports = $341aa1dd6380288c$var$baseUpdate;

});


parcelRegister("4nScF", function(module, exports) {

$parcel$export(module.exports, "SET_CHILD_ISSUES_METADATA", () => $9ffdfdef102812b7$export$1a5205eaf2c29edc);
$parcel$export(module.exports, "setChildIssuesMetadata", () => $9ffdfdef102812b7$export$dc5bde40f28284aa);
const $9ffdfdef102812b7$export$1a5205eaf2c29edc = 'state.actions.issue.child-issues-metadata.SET_CHILD_ISSUES_METADATA';
const $9ffdfdef102812b7$export$dc5bde40f28284aa = (issues)=>({
        type: $9ffdfdef102812b7$export$1a5205eaf2c29edc,
        payload: issues
    });

});


parcelRegister("jlZom", function(module, exports) {

$parcel$export(module.exports, "missingParentResolveEpic", () => $927f535e38163999$export$7a4b906e63c2e974);

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");
parcelRequire("93e44");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("6hSeW");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $8zOmE = parcelRequire("8zOmE");


var $9iM6y = parcelRequire("9iM6y");

var $hdmw1 = parcelRequire("hdmw1");

var $hDdMY = parcelRequire("hDdMY");

var $cW3pH = parcelRequire("cW3pH");

var $gXFr2 = parcelRequire("gXFr2");

var $lIysR = parcelRequire("lIysR");

var $67Z81 = parcelRequire("67Z81");

var $cN1y7 = parcelRequire("cN1y7");

var $7mswo = parcelRequire("7mswo");
const $927f535e38163999$var$handleSuccess = ({ optimisticId: optimisticId, issueId: issueId, issueKey: issueKey, transitionId: transitionId, projectId: projectId, analyticsEvent: analyticsEvent })=>{
    if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'missingParentResolution success', {
        issueKey: issueKey,
        issueId: issueId,
        transitionId: transitionId,
        projectId: projectId
    });
    return (0, $kVLXA.Observable).from([
        (0, $hDdMY.missingParentResolveSuccess)({
            optimisticId: optimisticId,
            issueId: issueId,
            analyticsEvent: analyticsEvent
        }),
        (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$ce2132697bb05fef))
    ]);
};
const $927f535e38163999$var$handleError = ({ optimisticId: optimisticId, issueId: issueId, issueKey: issueKey, transitionId: transitionId, projectId: projectId, analyticsEvent: analyticsEvent, error: error })=>{
    (0, $dJl1T.default).safeErrorWithoutCustomerData('missing.parent.resolution.failure', 'Failed to resolve missing parent', error);
    if (analyticsEvent && (0, $cN1y7.shouldFireFailureSLOMetric)(error)) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'missingParentResolution failed', {
        errorMessage: error.message ? error.message : error,
        statusCodeGroup: (0, $cN1y7.getStatusCodeGroup)(error),
        issueKey: issueKey,
        issueId: issueId,
        transitionId: transitionId,
        projectId: projectId
    });
    return (0, $kVLXA.Observable).of((0, $hDdMY.missingParentResolveFailure)({
        optimisticId: optimisticId,
        issueId: issueId,
        analyticsEvent: analyticsEvent,
        error: error
    }));
};
const $927f535e38163999$var$hasTransitionScreen = (store, action)=>{
    const state = store.getState();
    const { payload: { destinationColumnId: destinationColumnId, transitionId: transitionId, issueTypeId: issueTypeId, projectId: projectId } } = action;
    const destinationTransitions = (0, $lIysR.getTransitionsByColumnAndIssueType)(state, {
        columnId: destinationColumnId,
        issueTypeId: issueTypeId,
        projectId: projectId
    });
    const transitionIndex = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transitionId) ? destinationTransitions.findIndex((transition)=>transition.id === transitionId) : null;
    const transition = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transitionIndex) ? destinationTransitions[transitionIndex] : null;
    return Boolean(transition?.hasScreen);
};
const $927f535e38163999$var$handleTransitionScreen = (store, action)=>{
    const { payload: { issueId: issueId, issueKey: issueKey, transitionId: transitionId, projectId: projectId }, meta: { analyticsEvent: analyticsEvent } } = action;
    const dispatch = store.dispatch.bind(store);
    return (0, $7mswo.openTransitionScreen)({
        issueId: String(issueId),
        issueKey: issueKey,
        transitionId: transitionId,
        analyticsEvent: analyticsEvent,
        dispatch: dispatch
    }).flatMap((result)=>{
        if (result.type === (0, $7mswo.TRANSITION_SCREEN_SUCCESS)) return $927f535e38163999$var$handleMissingParentResolveAction(store, action);
        if (result.type === (0, $7mswo.TRANSITION_SCREEN_CANCEL)) return (0, $kVLXA.Observable).empty();
        if (result.type === (0, $7mswo.TRANSITION_SCREEN_ERROR)) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('missing.parent.transition.screen.error', 'Failed to resolve missing parent from transition screen', result.error);
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'missingParentTransitionScreen error', {
                triggerPointKey: 'software-board-missing-parent-resolution-screen',
                isModalOpen: true,
                issueId: issueId,
                issueKey: issueKey,
                transitionId: transitionId,
                projectId: projectId
            });
            return (0, $kVLXA.Observable).empty();
        }
        return (0, $kVLXA.Observable).empty();
    });
};
function $927f535e38163999$var$handleMissingParentResolveAction(store, action) {
    const state = store.getState();
    const { payload: { issueId: issueId, issueKey: issueKey, issueTypeId: issueTypeId, destinationColumnId: destinationColumnId, transitionId: transitionId, projectId: projectId }, meta: { analyticsEvent: analyticsEvent } } = action;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transitionId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(destinationColumnId)) return (0, $kVLXA.Observable).empty();
    const missingParents = (0, $67Z81.getMissingParents)(state);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(missingParents)) return (0, $kVLXA.Observable).empty();
    const missingParent = missingParents[issueId];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(missingParent) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(missingParent.projectId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(missingParent.typeId)) return (0, $kVLXA.Observable).empty();
    const destinationStatus = (0, $gXFr2.getDestinationStatusSelector)(state)(destinationColumnId, issueTypeId, transitionId);
    const transitionOptimisticAction = (0, $hDdMY.missingParentResolveOptimistic)({
        issueId: issueId,
        doneStatusName: destinationStatus?.name || ''
    });
    const optimisticId = transitionOptimisticAction.meta.optimistic.id;
    const ctx = (0, $hdmw1.makeServiceContext)(state);
    return (0, $kVLXA.Observable).merge((0, $kVLXA.Observable).of(transitionOptimisticAction), (0, $9iM6y.issueTransitionService)(ctx, {
        issueKeys: [
            missingParent.key
        ],
        selectedTransitionId: transitionId,
        targetColumn: destinationColumnId
    }).flatMap(()=>$927f535e38163999$var$handleSuccess({
            optimisticId: optimisticId,
            issueId: issueId,
            issueKey: issueKey,
            transitionId: transitionId,
            projectId: projectId,
            analyticsEvent: analyticsEvent
        })).catch((error)=>$927f535e38163999$var$handleError({
            optimisticId: optimisticId,
            issueId: issueId,
            issueKey: issueKey,
            transitionId: transitionId,
            projectId: projectId,
            analyticsEvent: analyticsEvent,
            error: error
        })));
}
function $927f535e38163999$export$7a4b906e63c2e974(action$, store) {
    return action$.ofType((0, $hDdMY.MISSING_PARENT_RESOLVE_REQUEST)).mergeMap((action)=>{
        if ($927f535e38163999$var$hasTransitionScreen(store, action)) return $927f535e38163999$var$handleTransitionScreen(store, action);
        return $927f535e38163999$var$handleMissingParentResolveAction(store, action);
    }, 10);
}

});
parcelRegister("hDdMY", function(module, exports) {

$parcel$export(module.exports, "MISSING_PARENT_RESOLVE_REQUEST", () => $30c361e88a2ec46d$export$db5c83e3629f342f);
$parcel$export(module.exports, "missingParentResolveRequest", () => $30c361e88a2ec46d$export$27a2bf747a2129f4);
$parcel$export(module.exports, "MISSING_PARENT_RESOLVE_OPTIMISTIC", () => $30c361e88a2ec46d$export$7a3a558c75d97e52);
$parcel$export(module.exports, "missingParentResolveOptimistic", () => $30c361e88a2ec46d$export$59fc8bacf22cfc6b);
$parcel$export(module.exports, "missingParentResolveSuccess", () => $30c361e88a2ec46d$export$62d6a97ae2726424);
$parcel$export(module.exports, "missingParentResolveFailure", () => $30c361e88a2ec46d$export$1db1f02a43251cc4);

var $9rND4 = parcelRequire("9rND4");
const $30c361e88a2ec46d$export$db5c83e3629f342f = 'state.actions.issue.missing-parent-issue-transition.MISSING_PARENT_ISSUE_RESOLVE';
const $30c361e88a2ec46d$export$27a2bf747a2129f4 = ({ issueId: issueId, issueTypeId: issueTypeId, issueKey: issueKey, projectId: projectId, transitionId: transitionId, destinationColumnId: destinationColumnId, analyticsEvent: analyticsEvent })=>({
        type: $30c361e88a2ec46d$export$db5c83e3629f342f,
        payload: {
            issueId: issueId,
            issueTypeId: issueTypeId,
            issueKey: issueKey,
            transitionId: transitionId,
            projectId: projectId,
            destinationColumnId: destinationColumnId
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $30c361e88a2ec46d$export$7a3a558c75d97e52 = 'state.actions.issue.missing-parent-issue-transition.MISSING_PARENT_RESOLVE_OPTIMISTIC';
const $30c361e88a2ec46d$export$59fc8bacf22cfc6b = ({ issueId: issueId, doneStatusName: doneStatusName })=>({
        type: $30c361e88a2ec46d$export$7a3a558c75d97e52,
        payload: {
            issueId: issueId,
            doneStatusName: doneStatusName
        },
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)()
        }
    });
const $30c361e88a2ec46d$export$8a0856a3d0c4feea = 'state.actions.issue.missing-parent-issue-transition.MISSING_PARENT_RESOLVE_SUCCESS';
const $30c361e88a2ec46d$export$62d6a97ae2726424 = ({ optimisticId: optimisticId, issueId: issueId, analyticsEvent: analyticsEvent })=>({
        type: $30c361e88a2ec46d$export$8a0856a3d0c4feea,
        payload: {
            issueId: issueId
        },
        meta: {
            ...(0, $9rND4.commitOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });
const $30c361e88a2ec46d$export$32992dadde2f9ea1 = 'state.actions.issue.missing-parent-issue-transition.MISSING_PARENT_RESOLVE_FAILURE';
const $30c361e88a2ec46d$export$1db1f02a43251cc4 = ({ optimisticId: optimisticId, issueId: issueId, error: error, analyticsEvent: analyticsEvent })=>({
        type: $30c361e88a2ec46d$export$32992dadde2f9ea1,
        payload: {
            issueId: issueId,
            error: error
        },
        meta: {
            ...(0, $9rND4.revertOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });

});


parcelRegister("8cD7G", function(module, exports) {

$parcel$export(module.exports, "default", () => $03b4f4b6a2e902b6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "workLoadOnInitialLoadEpic", () => $03b4f4b6a2e902b6$export$9b5fbdd469a3e217);
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("93e44");
parcelRequire("7qVV7");
parcelRequire("76ueo");
parcelRequire("1oQta");
parcelRequire("eV0gs");
parcelRequire("bZiwb");
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("2HNfr");
parcelRequire("c66Ur");

var $gccSB = parcelRequire("gccSB");

var $ajpes = parcelRequire("ajpes");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $hULKg = parcelRequire("hULKg");

var $jBiMd = parcelRequire("jBiMd");


var $hN2XX = parcelRequire("hN2XX");

var $iUagi = parcelRequire("iUagi");



var $iuuJH = parcelRequire("iuuJH");

var $3GxuF = parcelRequire("3GxuF");

var $hjlQ8 = parcelRequire("hjlQ8");

var $hdmw1 = parcelRequire("hdmw1");

var $1YOzt = parcelRequire("1YOzt");

var $65C0W = parcelRequire("65C0W");

var $cW3pH = parcelRequire("cW3pH");

var $k8auG = parcelRequire("k8auG");

var $8yiLS = parcelRequire("8yiLS");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $4Tseb = parcelRequire("4Tseb");
function $03b4f4b6a2e902b6$var$isOptimisticOrDragging(store) {
    const state = store.getState();
    return (0, $5mTgl.hasAnyActiveOptimistic)(state) || (0, $k8auG.isDragging)(state);
}
function $03b4f4b6a2e902b6$var$shouldCloseBuffer(action$, store) {
    return action$.filter(()=>!$03b4f4b6a2e902b6$var$isOptimisticOrDragging(store));
}
function $03b4f4b6a2e902b6$var$shouldAbort(action$, store) {
    return action$.filter(()=>$03b4f4b6a2e902b6$var$isOptimisticOrDragging(store));
}
function $03b4f4b6a2e902b6$var$updateIssueDevStatus(store) {
    return (workData)=>(0, $5mTgl.workDataWithDevStatusSelector)(store.getState())(workData);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $03b4f4b6a2e902b6$var$onFailure(error, store) {
    // when fetching with etag, backend responses 304 meaning that no data change
    // do nothing in thi case
    if (error.statusCode === 304) return (0, $kVLXA.Observable).empty();
    if (error.statusCode === 401 || error.statusCode === 403) {
        const boardUrl = (0, $jBiMd.getBoardPrettyUrl)((0, $67Z81.contextPathSelector)(store.getState()), (0, $67Z81.projectKeySelector)(store.getState()), (0, $67Z81.rapidViewIdSelector)(store.getState()));
        return (0, $kVLXA.Observable).of((0, $cW3pH.showLogBackInMessage)(boardUrl));
    }
    if (error.statusCode === 404 && (0, $67Z81.getIsIncrementPlanningBoard)(store.getState())) return (0, $kVLXA.Observable).of((0, $cW3pH.showIPBoard404View)());
    (0, $dJl1T.default).safeErrorWithoutCustomerData('board.noncritical.load.failure', 'Failure on board load', error);
    return (0, $kVLXA.Observable).of((0, $cW3pH.loadBoardFailure)(error, false));
}
/**
 * Remove swimlaneModId from refreshes for CMP boards so user based swimlanes are
 * not overridden on refresh.
 */ function $03b4f4b6a2e902b6$var$onCMPBoardRefreshResult(store, action) {
    const state = store.getState();
    const swimlaneMode = state.ui.swimlane.mode;
    const customFilterIds = (0, $8yiLS.getActiveCustomFilterIds)(state);
    const isCustomFiltersOn = customFilterIds.length > 0;
    // For JQL swimlanes in CMP boards, use admin/backend settings as only admins can configure them
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_JQL).id) return (0, $4Tseb.handleCMPBoardDataSet)(action, isCustomFiltersOn);
    return (0, $4Tseb.handleCMPBoardDataSet)({
        ...action,
        payload: {
            ...action.payload,
            swimlaneModeId: swimlaneMode ?? action.payload.swimlaneModeId
        }
    }, isCustomFiltersOn);
}
function $03b4f4b6a2e902b6$var$fetchBoardScopeData(store) {
    const state = store.getState();
    const ctx = (0, $hdmw1.makeServiceContext)(state);
    const customFilterIds = (0, $8yiLS.getActiveCustomFilterIds)(state);
    // We do not pass quick filters and we do not want hidden issues for a refresh.
    return (0, $3GxuF.fetchWorkModeData)(ctx, ctx.isCMPBoard ? {
        activeQuickFilters: customFilterIds,
        includeHidden: customFilterIds.length > 0
    } : undefined).map($03b4f4b6a2e902b6$var$updateIssueDevStatus(store)).map((0, $cW3pH.workDataSet)).flatMap((action)=>{
        if (ctx.isCMPBoard) return $03b4f4b6a2e902b6$var$onCMPBoardRefreshResult(store, action);
        return (0, $kVLXA.Observable).of(action);
    }).catch((error)=>$03b4f4b6a2e902b6$var$onFailure(error, store));
}
function $03b4f4b6a2e902b6$export$7a1171f81211a01b(refreshActions) {
    const globalIssueCreateAction = refreshActions.find((action)=>action.payload.source === (0, $dcbb2bce513725b3$export$8cabdc85b8691f12));
    // GIC already shows a flag for issue create success so check if the GIC was triggered from Bento to disable the board flag
    const isTriggeredByBento = globalIssueCreateAction?.payload?.triggerSource === (0, $hULKg.JSW_ISSUE_VIEW_CREATE_SUBTASK) || globalIssueCreateAction?.payload?.triggerSource === (0, $hULKg.JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC);
    const globalIssues = globalIssueCreateAction?.payload?.issues;
    return (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(globalIssues) || isTriggeredByBento ? [] : [
        (0, $1YOzt.checkGlobalIssueCreate)(globalIssues)
    ];
}
function $03b4f4b6a2e902b6$var$onBoardWithNoColumn(canEditBoard) {
    return (0, $kVLXA.Observable).of((0, $cW3pH.loadBoardFailureNoColumn)(false, canEditBoard));
}
function $03b4f4b6a2e902b6$export$6a152ab28b3fdeb6(action$) {
    let failures = 0;
    const getDelay = ()=>Math.min(failures > 0 ? 1000 * Math.pow(2, failures) + Math.random() * (0, $iUagi.getBoardJirtJitter)() : 0, 60000);
    const refreshAllowedStream$ = action$.ofType((0, $cW3pH.BOARD_LOAD_FAILURE)).flatMap(()=>{
        failures += 1;
        return (0, $kVLXA.Observable).empty();
    });
    const successStream$ = action$.ofType((0, $cW3pH.WORK_DATA_SET)).flatMap(()=>{
        failures = 0;
        return (0, $kVLXA.Observable).empty();
    });
    const refreshDelayHandler$ = (0, $kVLXA.Observable).merge(refreshAllowedStream$, successStream$);
    return {
        refreshDelayHandler$: refreshDelayHandler$,
        getDelay: getDelay
    };
}
function $03b4f4b6a2e902b6$export$2e2bcd8739ae039(action$, store) {
    const { getDelay: getDelay, refreshDelayHandler$: refreshDelayHandler$ } = $03b4f4b6a2e902b6$export$6a152ab28b3fdeb6(action$);
    const epicOutput$ = action$.ofType((0, $cW3pH.WORK_REFRESH_DATA)).bufferWhen(()=>$03b4f4b6a2e902b6$var$shouldCloseBuffer(action$, store)).filter((buffer)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(buffer)).exhaustMap((refreshActions)=>(0, $kVLXA.Observable).of(refreshActions).delay(getDelay()).flatMap(()=>$03b4f4b6a2e902b6$var$fetchBoardScopeData(store)).concat($03b4f4b6a2e902b6$export$7a1171f81211a01b(refreshActions)).takeUntil($03b4f4b6a2e902b6$var$shouldAbort(action$, store)));
    return (0, $kVLXA.Observable).merge(epicOutput$, refreshDelayHandler$);
}
function $03b4f4b6a2e902b6$export$9b5fbdd469a3e217(action$, store) {
    return action$.ofType((0, $65C0W.SOFTWARE_APP_LOADED), (0, $65C0W.SOFTWARE_APP_INITIAL_STATE_LOADED)).filter(()=>!(0, $5mTgl.hasAnyActiveOptimistic)(store.getState())).flatMap((action)=>{
        const state = store.getState();
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const data = action.type === (0, $65C0W.SOFTWARE_APP_LOADED) && action.payload.prefetchData != null ? action.payload.prefetchData : null;
        if (action.type === (0, $65C0W.SOFTWARE_APP_LOADED) && action.payload.cmpBoardData != null) return (0, $kVLXA.Observable).from([]);
        if (data && (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(data.board.columns)) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('board.transform.critical.data', 'Board does not have any columns', {
                message: `Columns does not exist for Board with id :  ${boardId}`
            });
            // these data wont be in state , need to retrieve from payload.
            const canConfigureBoard = data.currentUser.permissions.includes((0, $68cf6bf1ce76db03$export$b893894941c14e43));
            return $03b4f4b6a2e902b6$var$onBoardWithNoColumn(canConfigureBoard);
        }
        const transformedData = data ? (0, $hjlQ8.transformCriticalData)(data) : {};
        // Get filters and put them in here
        const customFilterIds = (0, $8yiLS.getActiveCustomFilterIds)(state);
        const isCustomFiltersOn = customFilterIds.length > 0;
        const ctx = (0, $hdmw1.makeServiceContext)(state);
        return (0, $3GxuF.fetchWorkModeData)(ctx, {
            activeQuickFilters: customFilterIds,
            includeHidden: customFilterIds.length > 0
        }).map($03b4f4b6a2e902b6$var$updateIssueDevStatus(store)).map((nonCriticalData)=>{
            // Do a comparison based on what was given by the cache and what we just retrieved
            // Not all keys will match but the ones we loaded from cache are the ones we want to compare
            const isCacheValid = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            Object.keys(transformedData).every((key)=>{
                if (key in nonCriticalData) return (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(transformedData[key], nonCriticalData[key]);
                return true;
            });
            if (!isCacheValid) // Fire analytics;
            (0, $hN2XX.triggerCacheRefreshAnalytics)((0, $8631d6ce464ccf2e$export$9b8283d5878d2491));
            return nonCriticalData;
        }).map((0, $cW3pH.workDataSet)).flatMap((response)=>{
            if (ctx.isCMPBoard) return (0, $4Tseb.handleCMPBoardDataSet)(response, isCustomFiltersOn);
            return (0, $kVLXA.Observable).of(response);
        }).catch((error)=>$03b4f4b6a2e902b6$var$onFailure(error, store));
    });
}

});
parcelRegister("hULKg", function(module, exports) {

$parcel$export(module.exports, "GENERIC_FORGE_USE_PRODUCT_MODALS", () => $62659eb193cd5c9c$export$a05673a22505d5ee);
$parcel$export(module.exports, "GENERIC_GLOBAL_CREATE_BUTTON", () => $62659eb193cd5c9c$export$c78d329777576aa0);
$parcel$export(module.exports, "MOBILE_GLOBAL_CREATE_BUTTON", () => $62659eb193cd5c9c$export$992ab052fd10f8e8);
$parcel$export(module.exports, "GENERIC_KEYBOARD_SHORTCUT", () => $62659eb193cd5c9c$export$affdc3af7a9a4677);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC", () => $62659eb193cd5c9c$export$7e9cfd1f59e60910);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_SUBTASK", () => $62659eb193cd5c9c$export$708499dcd016e5e9);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_CHILD_ISSUE", () => $62659eb193cd5c9c$export$e1c8789144c4c810);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_SUBTASK", () => $62659eb193cd5c9c$export$c5afabb7a17e802);
$parcel$export(module.exports, "JSW_RELEASES_CREATE_ISSUE", () => $62659eb193cd5c9c$export$2086a63173b79b56);
$parcel$export(module.exports, "JSW_ROADMAP_CREATE_ISSUE", () => $62659eb193cd5c9c$export$fe1e5e4597147709);
$parcel$export(module.exports, "JSW_SECURITY_CREATE_ISSUE", () => $62659eb193cd5c9c$export$9bc326812a93707);
$parcel$export(module.exports, "JSM_CALENDAR_CREATE_CHANGE_REQUEST", () => $62659eb193cd5c9c$export$f352934e06f44599);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_DETAIL", () => $62659eb193cd5c9c$export$6ae07c77acc64360);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_LIST", () => $62659eb193cd5c9c$export$b41d0684e4b6ab1);
$parcel$export(module.exports, "JSM_EMPTY_QUEUE_CREATE_REQUEST", () => $62659eb193cd5c9c$export$be9b2b1329ff7ec9);
$parcel$export(module.exports, "JSW_CREATE_ISSUE_DIALOG", () => $62659eb193cd5c9c$export$aa348159181703a0);
$parcel$export(module.exports, "ISSUE_VIEW_CREATE_LINKED_ISSUE", () => $62659eb193cd5c9c$export$f90eec3841adf619);
$parcel$export(module.exports, "COMMAND_PALETTE_CREATE_LINKED_ISSUE", () => $62659eb193cd5c9c$export$718822a309bffada);
$parcel$export(module.exports, "SERVICE_DESK_LINKED_ISSUE_TRIGEER", () => $62659eb193cd5c9c$export$2753dafac81e805c);
$parcel$export(module.exports, "JSW_INCIDENTS_CREATE_JSM_PIR_TRIGGER", () => $62659eb193cd5c9c$export$7c4d5cc5711d9294);
$parcel$export(module.exports, "JPO_DIALOGS_CREATE_ISSUE_TRIGGER", () => $62659eb193cd5c9c$export$998dfc72404b9e14);
$parcel$export(module.exports, "JSW_ADAPTED_GLOBAL_ISSUE_CREATE", () => $62659eb193cd5c9c$export$fc180a4b5785d2f4);
$parcel$export(module.exports, "JSW_CREATE_EPIC_ISSUE", () => $62659eb193cd5c9c$export$946ec0b21cb84fd0);
$parcel$export(module.exports, "CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW", () => $62659eb193cd5c9c$export$5b97e2844e620e54);
$parcel$export(module.exports, "CREATE_SUBTASK_NIN_TRIGGER", () => $62659eb193cd5c9c$export$b99842c2cf46f6be);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_NOT_DEFINED", () => $62659eb193cd5c9c$export$8d987f6e80b74000);
$parcel$export(module.exports, "ISSUE_PARENT_SWITCHER_FIELD_CREATE_ISSUE", () => $62659eb193cd5c9c$export$8de9fa43731c4b5b);
$parcel$export(module.exports, "POLARIS_CREATE_DELIVERY_ISSUE", () => $62659eb193cd5c9c$export$87249ccbfd10fb78);
$parcel$export(module.exports, "HOME_PAGE_DEFAULT_OPEN_GIC", () => $62659eb193cd5c9c$export$c0eeeb31d264de76);
$parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER", () => $62659eb193cd5c9c$export$f546e18e46478c84);
$parcel$export(module.exports, "DEVELOPER_ESCALATIONS_ISSUE_CREATE_TRIGGER", () => $62659eb193cd5c9c$export$1784e634ba79f1f9);
$parcel$export(module.exports, "JWM_INLINE_CREATE", () => $62659eb193cd5c9c$export$145eb8935a34e85e);
$parcel$export(module.exports, "POLARIS_GLOBAL_SUBMIT_IDEA_SWITCH_PROJECTS_TRIGGER", () => $62659eb193cd5c9c$export$32648b574a536c8b);
$parcel$export(module.exports, "ALLOWED_EXTERNAL_CONTROLS", () => $62659eb193cd5c9c$export$c0e2ab74dfaa67cc);
const $62659eb193cd5c9c$export$a05673a22505d5ee = 'forge-open-issue-create';
const $62659eb193cd5c9c$export$c78d329777576aa0 = 'global-create-button';
const $62659eb193cd5c9c$export$992ab052fd10f8e8 = 'mobile-global-create-button';
const $62659eb193cd5c9c$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $62659eb193cd5c9c$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $62659eb193cd5c9c$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $62659eb193cd5c9c$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $62659eb193cd5c9c$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $62659eb193cd5c9c$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $62659eb193cd5c9c$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $62659eb193cd5c9c$export$9bc326812a93707 = 'jsw-security-create-issue';
const $62659eb193cd5c9c$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $62659eb193cd5c9c$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $62659eb193cd5c9c$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $62659eb193cd5c9c$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $62659eb193cd5c9c$export$235b856f54db8916 = 'jwm-board-create-issue';
const $62659eb193cd5c9c$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $62659eb193cd5c9c$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $62659eb193cd5c9c$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $62659eb193cd5c9c$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $62659eb193cd5c9c$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $62659eb193cd5c9c$export$aa348159181703a0 = 'software-create-issue-dialog';
const $62659eb193cd5c9c$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $62659eb193cd5c9c$export$718822a309bffada = 'create-linked-issue-command-palette';
const $62659eb193cd5c9c$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $62659eb193cd5c9c$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $62659eb193cd5c9c$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $62659eb193cd5c9c$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $62659eb193cd5c9c$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $62659eb193cd5c9c$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $62659eb193cd5c9c$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $62659eb193cd5c9c$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $62659eb193cd5c9c$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $62659eb193cd5c9c$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $62659eb193cd5c9c$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $62659eb193cd5c9c$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $62659eb193cd5c9c$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $62659eb193cd5c9c$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $62659eb193cd5c9c$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $62659eb193cd5c9c$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $62659eb193cd5c9c$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $62659eb193cd5c9c$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $62659eb193cd5c9c$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $62659eb193cd5c9c$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $62659eb193cd5c9c$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $62659eb193cd5c9c$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $62659eb193cd5c9c$export$145eb8935a34e85e = 'jwm-inline-create';
const $62659eb193cd5c9c$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
const $62659eb193cd5c9c$export$818f24c6c32e18a = 'jira-calendar-create-issue';
const $62659eb193cd5c9c$export$f352408886aa304b = 'connect-app-ecosystem';
const $62659eb193cd5c9c$export$c0e2ab74dfaa67cc = {
    FIELD_IDS: [
        'description'
    ],
    TRIGGER_POINTS: [
        'service-desk-gen-ai-pir'
    ]
};

});

parcelRegister("jBiMd", function(module, exports) {

$parcel$export(module.exports, "getBoardPrettyUrl", () => $e2dfb6bdf3985745$export$65019f7aa89ee0d);
const $e2dfb6bdf3985745$export$65019f7aa89ee0d = (contextPath, projectKey, rapidViewId)=>`${contextPath}/jira/software/projects/${projectKey}/boards/${rapidViewId}`;
const $e2dfb6bdf3985745$export$325baf08e53250a1 = (contextPath, projectKey, rapidViewId, isCMPBoard, additionalParams = [])=>{
    const paramString = additionalParams.map((param)=>`${param}`).join('&');
    return `${contextPath}/jira/software${isCMPBoard ? '/c' : ''}/projects/${projectKey}/boards/${rapidViewId}/backlog${additionalParams.length ? `?${paramString}` : ''}`;
};

});

parcelRegister("hN2XX", function(module, exports) {

$parcel$export(module.exports, "default", () => $43e79ffcea087bf1$export$2e2bcd8739ae039);
$parcel$export(module.exports, "triggerCacheRefreshAnalytics", () => $43e79ffcea087bf1$export$e78b5ce2eed37743);

var $cab1K = parcelRequire("cab1K");
// Standard observer pattern, when the board/backlog/roadmap is mounted and loaded cache,
// but cache is stale and is updated by live data, this will be triggered
const $43e79ffcea087bf1$var$ResourcesCacheRefreshAnalytics = new (0, $cab1K.Subject)();
var $43e79ffcea087bf1$export$2e2bcd8739ae039 = $43e79ffcea087bf1$var$ResourcesCacheRefreshAnalytics;
const $43e79ffcea087bf1$export$e78b5ce2eed37743 = (origin)=>{
    $43e79ffcea087bf1$var$ResourcesCacheRefreshAnalytics.next(origin);
};

});

parcelRegister("3GxuF", function(module, exports) {

$parcel$export(module.exports, "fetchWorkModeData", () => $18b8f0cae70dfc00$export$a4889071ab1c6bf9);
parcelRequire("3q49N");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $9XE6b = parcelRequire("9XE6b");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");


var $gBFyV = parcelRequire("gBFyV");

var $cNk8F = parcelRequire("cNk8F");

var $j0Jg0 = parcelRequire("j0Jg0");

var $hjlQ8 = parcelRequire("hjlQ8");

var $duA0Q = parcelRequire("duA0Q");
function $18b8f0cae70dfc00$export$2e2bcd8739ae039(contextPath, boardId) {
    return (0, $cNk8F.default)(contextPath, boardId).flatMap((nonCritialDataResponse)=>{
        // Everytime we fetch this data, we can use it to hydrate the BOARD resources-cache
        (0, $gBFyV.default).next({
            origin: (0, $8631d6ce464ccf2e$export$9b8283d5878d2491),
            payload: nonCritialDataResponse
        });
        return (0, $kVLXA.Observable).of((0, $hjlQ8.transformNonCriticalData)(nonCritialDataResponse));
    }).catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('board.non-critical.load.boardscope.graphql.failure', 'Failed to load board scope data via GraphQl', {
            message: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, 'message', '') || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                0,
                'message',
                ''
            ])
        });
        return (0, $kVLXA.Observable).throw(error);
    });
}
function $18b8f0cae70dfc00$export$7840010629c20713(planId, scenarioId, incrementId) {
    return (0, $j0Jg0.fetchPlanDataRest)(+planId, +scenarioId, +incrementId);
}
function $18b8f0cae70dfc00$export$a4889071ab1c6bf9(ctx, parameters = {}) {
    if (ctx.isIncrementPlanningBoard) {
        if (!ctx.planId || !ctx.scenarioId || !ctx.boardId) throw new Error('planId and scenarioId must be provided for incremental planning board');
        return $18b8f0cae70dfc00$export$7840010629c20713(ctx.planId, ctx.scenarioId, ctx.boardId);
    }
    if (ctx.isCMPBoard) {
        const { boardId: boardId } = ctx;
        return (0, $duA0Q.fetchCMPBoardScopeData)(boardId, {
            projectType: ctx.projectType,
            ...parameters
        });
    }
    return $18b8f0cae70dfc00$export$2e2bcd8739ae039(ctx.contextPath, ctx.boardId);
}

});
parcelRegister("gBFyV", function(module, exports) {

$parcel$export(module.exports, "default", () => $48bba9321b275587$export$2e2bcd8739ae039);

var $cab1K = parcelRequire("cab1K");
var // Standard observer pattern, the middleware in board/backlog will invoke this
// when it comes across a matching redux mutation that requires the cache
// to be updated
// eslint-disable-next-line jira/import/no-anonymous-default-export
$48bba9321b275587$export$2e2bcd8739ae039 = new (0, $cab1K.Subject)();

});

parcelRegister("cNk8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $63ab48391f281820$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $4R6GH = parcelRequire("4R6GH");

var $fy8gS = parcelRequire("fy8gS");

var $cBLvH = parcelRequire("cBLvH");

var $CFxE9 = parcelRequire("CFxE9");
const $63ab48391f281820$export$708e6644dde09094 = 'SoftwareBoardScopeData';
const $63ab48391f281820$export$f2f3dcc8e95c3168 = ()=>{
    const editConfig = `
        editConfig {
            inlineColumnEdit {
                enabled
            }
            inlineIssueCreate @skip(if: $useBackendIccConfig){
                enabled
            }
        }
    `;
    const issueChildren = `issueChildren {
                id
                flagged
                done
                parentId
                estimate {
                    storyPoints
                    originalEstimate {
                        value
                        valueAsText
                    }
                }
                issue {
                    id
                    key
                    summary
                    labels
                    assignee {
                        accountId
                        displayName
                        avatarUrl
                    }
                    type { id, name, iconUrl }
                    status { id }
                    activeSprint { id }
                }
                coverMedia {
                    attachmentId
                    endpointUrl
                    clientId
                    token
                    attachmentMediaApiId
                    hiddenByUser
                }
                priority {
                    name
                    iconUrl
                }
                dueDate
            }`;
    const timeTrackingConfig = `
    jira {
        timeTrackingOptions {
            workingHoursPerDay
            workingDaysPerWeek
            defaultUnit
            timeFormat
        }
    }`;
    const globalConfig = `
        globalConfig @skip(if: $useBackendIccConfig){
            applicationProperties {
                createStatusIsEnabled
            }
        }
    `;
    return `query ${$63ab48391f281820$export$708e6644dde09094} ($boardId: ID!, $useBackendIccConfig: Boolean!, $showIssueTransition: Boolean!) {
            boardScope(boardId: $boardId) {
                userSwimlaneStrategy
                board {
                    name
                    swimlaneStrategy
                    hasClearedIssues
                    rankCustomFieldId
                    assignees {
                        accountId
                        displayName
                        avatarUrl
                    }
                    columns {
                        id
                        name
                        maxIssueCount
                        status {
                            id
                            name
                        }
                        ${0, $fy8gS.columnStatus}
                        isDone
                        isInitial
                        transitionId
                        cards {
                            id
                            flagged
                            done
                            parentId
                            estimate {
                                storyPoints
                                originalEstimate {
                                    value
                                    valueAsText
                                }
                            }
                            issue {
                                id
                                key
                                summary
                                labels
                                assignee {
                                    accountId
                                    displayName
                                    avatarUrl
                                }
                                type { id, name, iconUrl }
                                status { id }
                                activeSprint { id }
                            }
                            coverMedia {
                                attachmentId
                                endpointUrl
                                clientId
                                token
                                attachmentMediaApiId
                                hiddenByUser
                            }
                            priority {
                                name
                                iconUrl
                            }
                            dueDate
                            childIssuesMetadata { complete, total }
                        }
                    }
                    issueTypes {
                        id
                        name
                        iconUrl
                        hierarchyLevelType
                        hasRequiredFields @skip(if: $useBackendIccConfig)
                    }
                    inlineIssueCreate @skip(if: $useBackendIccConfig) { enabled }
                    cardMedia { enabled }
                    ${issueChildren}
                    cards { id }
                    ${editConfig}
                    inlineCardCreateConfig @include(if: $useBackendIccConfig)
                }
                backlog {
                    boardIssueListKey
                    requestColumnMigration
                }
                sprints(state: [ACTIVE]) {
                    id
                    name
                    goal
                    startDate
                    endDate
                    daysRemaining
                }
                features { key, status, toggle, category }
                projectLocation {
                    id
                    key
                    name
                    isSimplifiedProject
                    issueTypes {
                        id
                        name
                        iconUrl
                        hierarchyLevelType
                        hasRequiredFields
                    }
                }
                issueParents {
                    id
                    key
                    summary
                    issue {
                        status {
                            id
                            name
                            category
                        }
                    }
                    issueType {
                        id
                        name
                        iconUrl
                    }
                    color
                }
                currentUser { permissions }
                estimation {
                    current {
                        customFieldId
                    }
                }
            }
            ${timeTrackingConfig}
            ${globalConfig}
        }`;
};
const $63ab48391f281820$export$ba14d9a5a581e827 = (data)=>(0, $kVLXA.Observable).of(data);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$63ab48391f281820$export$2e2bcd8739ae039 = (contextPath, boardId)=>(0, $cBLvH.query$)(contextPath, $63ab48391f281820$export$708e6644dde09094, $63ab48391f281820$export$f2f3dcc8e95c3168(), {
        boardId: boardId,
        useBackendIccConfig: (0, $4R6GH.fg)('use_backend_tmp_icc_config_'),
        showIssueTransition: (0, $4R6GH.fg)('issue_transition_screen_in_jsw_tmp_board')
    }, (0, $CFxE9.boardScopeDataNonCriticalAnalyticsOptions)).flatMap($63ab48391f281820$export$ba14d9a5a581e827);

});

parcelRegister("j0Jg0", function(module, exports) {

$parcel$export(module.exports, "fetchPlanDataRest", () => $cd10897187a68f30$export$61eb3ebe06db86b9);
parcelRequire("aSIuP");

var $hGgHi = parcelRequire("hGgHi");

var $gZL7V = parcelRequire("gZL7V");

var $5rFbt = parcelRequire("5rFbt");

var $gULOk = parcelRequire("gULOk");

var $4R6GH = parcelRequire("4R6GH");

var $487fd = parcelRequire("487fd");

var $4jAPy = parcelRequire("4jAPy");

var $3spCR = parcelRequire("3spCR");


var $67Z81 = parcelRequire("67Z81");
const $cd10897187a68f30$export$9e95d7af046055ce = (teams, createIssuePermission)=>{
    if (!createIssuePermission) return {
        mode: (0, $c8d1b8aabfd899d6$export$c53d0f541b41b88e)
    };
    const hasExternalTeams = teams?.some((team)=>team.isPlanTeam === false);
    let isFullMode = !hasExternalTeams;
    const initalConfig = {
        mode: (0, $c8d1b8aabfd899d6$export$bb410559a65d3418),
        swimlanes: {
            [(0, $4jAPy.SWIMLANE_TEAMLESS)]: (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b)
        }
    };
    const inlineCardCreateConfig = teams?.reduce((acc, team)=>{
        if (acc.swimlanes !== undefined && team.isPlanTeam) {
            const sprintByIterationId = team.sprintByIterationId;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(sprintByIterationId)) {
                const columnsIcc = Object.keys(sprintByIterationId).reduce((columnsIccAcc, columnId)=>{
                    const sprint = sprintByIterationId[Number(columnId)];
                    if (sprint.state === (0, $3spCR.CLOSED_SPRINT_STATE)) isFullMode = false;
                    else (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(columnsIccAcc, [
                        columnId
                    ], {
                        mode: (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b)
                    });
                    return columnsIccAcc;
                }, {
                    [(0, $5rFbt.UNSCHEDULED_COLUMN_ID)]: {
                        mode: (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b)
                    }
                });
                acc.swimlanes[team.id] = columnsIcc;
            } else acc.swimlanes[team.id] = (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b);
        }
        return acc;
    }, initalConfig);
    return isFullMode ? {
        mode: (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b)
    } : inlineCardCreateConfig;
};
function $cd10897187a68f30$var$transformStatuses(response) {
    return response.statuses.map((s)=>({
            id: s.id,
            name: s.name,
            category: (0, $gULOk.statusCategoryForId)(s.categoryId)
        }));
}
function $cd10897187a68f30$export$6e76d430ac3d961(boardPermissions, isEmbed) {
    return isEmbed ? {
        createIssue: false,
        editIssue: false,
        deleteIssue: false,
        manageSprint: false,
        editBoardConfig: false,
        manageAutomation: false,
        canRelease: false,
        createSprint: false,
        archiveIssue: false
    } : boardPermissions;
}
const $cd10897187a68f30$export$61eb3ebe06db86b9 = (planId, scenarioId, incrementId)=>(0, $487fd.default)(`/rest/jpo/2.0/plans/${planId}/increment/board/${incrementId}?scenarioId=${scenarioId}`, {
        method: 'GET'
    }).map((json)=>{
        if ((0, $4R6GH.fg)('smart_links_for_plans')) {
            const isEmbed = (0, $67Z81.getIsIncrementPlanningBoardEmbed)();
            return {
                ...json,
                statuses: $cd10897187a68f30$var$transformStatuses(json),
                inlineCardCreate: $cd10897187a68f30$export$9e95d7af046055ce(json?.teams, !isEmbed && json.boardPermissions.createIssue),
                boardPermissions: $cd10897187a68f30$export$6e76d430ac3d961(json.boardPermissions, isEmbed)
            };
        }
        return {
            ...json,
            statuses: $cd10897187a68f30$var$transformStatuses(json),
            inlineCardCreate: $cd10897187a68f30$export$9e95d7af046055ce(json?.teams, json.boardPermissions.createIssue)
        };
    });

});
parcelRegister("gZL7V", function(module, exports) {

var $ajB7H = parcelRequire("ajB7H");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $c5f6e64373be0bfc$var$set(object, path, value) {
    return object == null ? object : $ajB7H(object, path, value);
}
module.exports = $c5f6e64373be0bfc$var$set;

});



parcelRegister("4Tseb", function(module, exports) {

$parcel$export(module.exports, "handleCMPBoardDataSet", () => $3b20dbe0a7669860$export$ed13ed88f142803b);

var $80afZ = parcelRequire("80afZ");

var $kVLXA = parcelRequire("kVLXA");

var $cY26q = parcelRequire("cY26q");

var $9WrsG = parcelRequire("9WrsG");
function $3b20dbe0a7669860$export$ed13ed88f142803b(response, isCustomFilterOn = false) {
    const { payload: workModeData } = response;
    // TODO: We can implement resources loading and then this would not need to be here.
    const issueIds = (0, (/*@__PURE__*/$parcel$interopDefault($80afZ)))(workModeData.issues, (issue)=>issue.id);
    const actions = [
        response,
        (0, $9WrsG.devStatusLoad)(issueIds)
    ];
    const allIssues = [
        ...workModeData.issues ?? [],
        ...workModeData.issueChildren ?? []
    ];
    const visibleIssueIds = allIssues.filter((issue)=>issue.isVisible === undefined || issue.isVisible) // IF not set, then visible. Otherwise check
    .map((issue)=>String(issue.id));
    // Only fire the filtered cards success (set the filtered card Ids) if there is any difference
    // or when custom filters are on
    if (isCustomFilterOn || visibleIssueIds.length !== allIssues.length) actions.push((0, $cY26q.filteredCardsSuccess)(visibleIssueIds));
    return (0, $kVLXA.Observable).from(actions);
}

});


parcelRegister("juuG5", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ff31aa6766e24a6$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("93e44");
parcelRequire("76ueo");
parcelRequire("c66Ur");
parcelRequire("2agIZ");
parcelRequire("eSGL3");
parcelRequire("1oQta");
parcelRequire("ihPQR");
parcelRequire("fPS7b");
parcelRequire("ifthi");
parcelRequire("59oNb");
parcelRequire("7mHDu");

var $9XE6b = parcelRequire("9XE6b");

var $kVLXA = parcelRequire("kVLXA");

var $jKX30 = parcelRequire("jKX30");

var $gSIcW = parcelRequire("gSIcW");

var $dJl1T = parcelRequire("dJl1T");


var $iUagi = parcelRequire("iUagi");


var $d315K = parcelRequire("d315K");

var $cW3pH = parcelRequire("cW3pH");

var $67Z81 = parcelRequire("67Z81");

var $btYft = parcelRequire("btYft");
const $9ff31aa6766e24a6$var$isNotCurrentUserInActiveTab = (state, action)=>(0, $67Z81.currentUserAccountIdSelector)(state) !== (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(action, [
        'payload',
        'event',
        'payload',
        'atlassianId'
    ], null) || (0, $btYft.isBlurredDocument)();
/**
 * In order to prevent spikes in load when front-end receives real-time events,
 * we introduce jitter onto the refreshes.
 *
 * By adding random per tab jitter refresh request load will be randomly (and
 * evenly) spread across a time window. For example, if the jitter window is 3
 * seconds, and we have 300 connected clients, our spike load in the case of a
 * refresh event is reduced from peak 300 req/s to 100 req/s, because 1/3 of
 * the clients will be scheduled for each second.
 *
 * Looking at sub-second, timings, all clients' refreshes will be evenly spread
 * within the jitter window rather than happening at the same or close instants.
 */ const $9ff31aa6766e24a6$var$tabJitter = Math.random() * (0, $iUagi.getBoardJirtJitter)();
const $9ff31aa6766e24a6$export$54ca11c0f992f1f = 3000;
const $9ff31aa6766e24a6$var$realtimeEpic = (action$, store)=>{
    const events$ = action$.ofType((0, $d315K.REALTIME_DISPATCH_EVENT)).filter((action)=>$9ff31aa6766e24a6$var$isNotCurrentUserInActiveTab(store.getState(), action));
    const [tabShownEvents$, tabHiddenEvents$] = events$.partition(()=>!(0, $btYft.isInactiveTab)());
    const delayedHiddenEvents$ = tabHiddenEvents$.bufferWhen(()=>(0, $gSIcW.default)().skip(1).filter(Boolean).take(1)).flatMap((actions)=>(0, $kVLXA.Observable).from(actions));
    const result$ = (0, $kVLXA.Observable).merge(tabShownEvents$, delayedHiddenEvents$).filter((action)=>{
        // We want to only listen to board scope issues updated events here since we
        // additionally get both issue create and issue update specifically for custom filters
        // So we ignore them here so custom filters still know how to react to those events
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(store.getState());
        return isCMPBoard || action.payload.event.type === (0, $09d938f04e8899c4$export$6024bd0c20931af3);
    });
    return result$.debounce(()=>(0, $jKX30.timer)($9ff31aa6766e24a6$export$54ca11c0f992f1f + $9ff31aa6766e24a6$var$tabJitter)).mapTo((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$af001fd9213b0b63))).catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('board.realtime.event.process.failure', 'Failed to process realtime event', error);
        return (0, $kVLXA.Observable).empty();
    });
};
var $9ff31aa6766e24a6$export$2e2bcd8739ae039 = $9ff31aa6766e24a6$var$realtimeEpic;

});
parcelRegister("ifthi", function(module, exports) {
"use strict";

var $kVLXA = parcelRequire("kVLXA");

var $65pxe = parcelRequire("65pxe");
$kVLXA.Observable.prototype.partition = $65pxe.partition;

});
parcelRegister("65pxe", function(module, exports) {

$parcel$export(module.exports, "partition", () => $46e7046de8bb9e17$export$b29f828819edca8d, (v) => $46e7046de8bb9e17$export$b29f828819edca8d = v);
var $46e7046de8bb9e17$export$b29f828819edca8d;
"use strict";

var $hU4zQ = parcelRequire("hU4zQ");
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */ function $46e7046de8bb9e17$var$partition(predicate, thisArg) {
    return $hU4zQ.partition(predicate, thisArg)(this);
}
$46e7046de8bb9e17$export$b29f828819edca8d = $46e7046de8bb9e17$var$partition;

});
parcelRegister("hU4zQ", function(module, exports) {

$parcel$export(module.exports, "partition", () => $d08b378cea94b111$export$b29f828819edca8d, (v) => $d08b378cea94b111$export$b29f828819edca8d = v);
var $d08b378cea94b111$export$b29f828819edca8d;
"use strict";

var $226Ym = parcelRequire("226Ym");

var $4cJXk = parcelRequire("4cJXk");
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */ function $d08b378cea94b111$var$partition(predicate, thisArg) {
    return function(source) {
        return [
            $4cJXk.filter(predicate, thisArg)(source),
            $4cJXk.filter($226Ym.not(predicate, thisArg))(source)
        ];
    };
}
$d08b378cea94b111$export$b29f828819edca8d = $d08b378cea94b111$var$partition;

});
parcelRegister("226Ym", function(module, exports) {

$parcel$export(module.exports, "not", () => $17b12d47d6027eff$export$6003a5f097c73977, (v) => $17b12d47d6027eff$export$6003a5f097c73977 = v);
var $17b12d47d6027eff$export$6003a5f097c73977;
"use strict";
function $17b12d47d6027eff$var$not(pred, thisArg) {
    function notPred() {
        return !notPred.pred.apply(notPred.thisArg, arguments);
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
$17b12d47d6027eff$export$6003a5f097c73977 = $17b12d47d6027eff$var$not;

});




parcelRegister("59oNb", function(module, exports) {
"use strict";

var $kVLXA = parcelRequire("kVLXA");

var $kPv2w = parcelRequire("kPv2w");
$kVLXA.Observable.prototype.skip = $kPv2w.skip;

});
parcelRegister("kPv2w", function(module, exports) {

$parcel$export(module.exports, "skip", () => $f2a0a5e10a86d5fc$export$955fc4a6c4be454d, (v) => $f2a0a5e10a86d5fc$export$955fc4a6c4be454d = v);
var $f2a0a5e10a86d5fc$export$955fc4a6c4be454d;
"use strict";

var $3ZBte = parcelRequire("3ZBte");
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */ function $f2a0a5e10a86d5fc$var$skip(count) {
    return $3ZBte.skip(count)(this);
}
$f2a0a5e10a86d5fc$export$955fc4a6c4be454d = $f2a0a5e10a86d5fc$var$skip;

});
parcelRegister("3ZBte", function(module, exports) {
"use strict";
var $2e84226f7a2e14b9$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */ function $2e84226f7a2e14b9$var$skip(count) {
    return function(source) {
        return source.lift(new $2e84226f7a2e14b9$var$SkipOperator(count));
    };
}
module.exports.skip = $2e84226f7a2e14b9$var$skip;
var $2e84226f7a2e14b9$var$SkipOperator = function() {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2e84226f7a2e14b9$var$SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2e84226f7a2e14b9$var$SkipSubscriber = function(_super) {
    $2e84226f7a2e14b9$var$__extends(SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    SkipSubscriber.prototype._next = function(x) {
        if (++this.count > this.total) this.destination.next(x);
    };
    return SkipSubscriber;
}($ggvKU.Subscriber);

});



parcelRegister("gSIcW", function(module, exports) {

$parcel$export(module.exports, "default", () => $63d01e218c271471$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");

var $cab1K = parcelRequire("cab1K");
parcelRequire("jG6Un");
parcelRequire("iQCJJ");
parcelRequire("d0pqD");

var $laTox = parcelRequire("laTox");
/**
 * Returns a stream of the current page visibility state whenever it changes.
 * Emits 'true' when the page is visible and 'false' when the page is hidden.
 *
 * Will emit `null` if document is not defined.
 *
 * This Observable WILL EMIT a value at the start of the load. If you're using
 * it to trigger refreshes, you should skip 1 value.
 */ const $63d01e218c271471$var$getVisibility$ = ()=>// @ts-expect-error - TS2322 - Type 'Observable<unknown>' is not assignable to type 'Observable<boolean | null>'.
    typeof document !== 'undefined' ? (0, $kVLXA.Observable).fromEvent(document, (0, $laTox.supportedVisiblityEvent))// We want to send the current visibility on a new subscription.
    // If we use `.startWith(isPageVisible())` then new subscribers
    // will get the initial visibility at load and not the current
    // visibility as the initial value.
    .startWith(null).map((0, $laTox.isPageVisible)) : new (0, $cab1K.Subject)().startWith(null);
var $63d01e218c271471$export$2e2bcd8739ae039 = $63d01e218c271471$var$getVisibility$;

});

parcelRegister("btYft", function(module, exports) {

$parcel$export(module.exports, "isInactiveTab", () => $56264c7cca60bd31$export$ffeec43e65aaf0d2);
$parcel$export(module.exports, "isBlurredDocument", () => $56264c7cca60bd31$export$b548a2387e025fd3);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $56264c7cca60bd31$export$ffeec43e65aaf0d2 = ()=>document.hidden;
const $56264c7cca60bd31$export$b548a2387e025fd3 = ()=>!document.hasFocus();

});


parcelRegister("csUBy", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bb5eaa28912c10e$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("9o0uh");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $dJl1T = parcelRequire("dJl1T");


var $3n65g = parcelRequire("3n65g");

var $cW3pH = parcelRequire("cW3pH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5bb5eaa28912c10e$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $3n65g.SET_PARENT_OPTIMISTIC)).mergeMap((action)=>{
        const { payload: { issues: issues, parentId: parentId }, meta: { optimistic: optimistic } } = action;
        const changedIssueIds = issues.filter((issue)=>issue.parentId !== parentId).map((issue)=>issue.id);
        if (changedIssueIds.length === 0) return (0, $kVLXA.Observable).of((0, $3n65g.setParentSuccess)(optimistic.id, changedIssueIds));
        const cardsParentAction = (0, $kVLXA.Observable).fromPromise(action.payload.requestPromise);
        return cardsParentAction.flatMap(()=>(0, $kVLXA.Observable).of((0, $3n65g.setParentSuccess)(optimistic.id, changedIssueIds))).catch((error)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('issue.set-parent.failure', 'Failed to set issue parent', error);
            return (0, $kVLXA.Observable).of(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $3n65g.setParentFailure)(optimistic.id), (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$d9d2fe902bd6d9a7)));
        });
    });

});

parcelRegister("19Ino", function(module, exports) {

$parcel$export(module.exports, "boardDataShadowRequestEpic", () => $1203da15cc708643$export$8a6214ffd3a36c85);
parcelRequire("6hSeW");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $kVLXA = parcelRequire("kVLXA");

var $x9xyg = parcelRequire("x9xyg");

var $6s1PB = parcelRequire("6s1PB");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");

var $duA0Q = parcelRequire("duA0Q");

var $hdmw1 = parcelRequire("hdmw1");

var $kr8xx = parcelRequire("kr8xx");

var $8yiLS = parcelRequire("8yiLS");
const $1203da15cc708643$var$fetchBoardDataShadowRequestExperience = new (0, $duUGa.UFOExperience)('fetch-board-data-shadow-request', {
    type: (0, $atdLB.ExperienceTypes).Operation,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
});
function $1203da15cc708643$export$8a6214ffd3a36c85(action$, store) {
    return action$.ofType((0, $kr8xx.BOARD_DATA_SHADOW_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const { boardId: boardId, isCMPBoard: isCMPBoard, projectType: projectType } = (0, $hdmw1.makeServiceContext)(state);
        if (!isCMPBoard) return (0, $kVLXA.Observable).empty();
        const customFilterIds = (0, $8yiLS.getActiveCustomFilterIds)(state);
        $1203da15cc708643$var$fetchBoardDataShadowRequestExperience.start();
        const issueLimit = (0, $6s1PB.expVal)('jsw_cmp_board_pagination_spike_issue_limit', 'issueLimit', 0) || undefined;
        return (0, $duA0Q.fetchCMPBoardScopeData)(boardId, {
            projectType: projectType,
            includeHidden: true,
            skipExtraFields: true,
            activeQuickFilters: customFilterIds,
            issueLimit: issueLimit
        }).flatMap((data)=>{
            $1203da15cc708643$var$fetchBoardDataShadowRequestExperience.success({
                metadata: {
                    originalRequestIssueCount: action.payload.issueCount,
                    originalRequestDuration: (0, $x9xyg.getMark)('uif-board-fetch/request')?.duration ?? 0,
                    shadowRequestIssueCount: data.orderedIssueIds?.length ?? 0
                }
            });
            return (0, $kVLXA.Observable).empty();
        }).catch(()=>{
            $1203da15cc708643$var$fetchBoardDataShadowRequestExperience.failure();
            return (0, $kVLXA.Observable).empty();
        });
    });
}

});
parcelRegister("kr8xx", function(module, exports) {

$parcel$export(module.exports, "BOARD_DATA_SHADOW_REQUEST", () => $052ee7653c6933de$export$c6e7dd3aa714beb4);
$parcel$export(module.exports, "boardDataShadowRequest", () => $052ee7653c6933de$export$cffec0ba3f2debf8);
const $052ee7653c6933de$export$c6e7dd3aa714beb4 = 'state.actions.board.shadow-request.BOARD_DATA_SHADOW_REQUEST';
const $052ee7653c6933de$export$cffec0ba3f2debf8 = (payload)=>({
        type: $052ee7653c6933de$export$c6e7dd3aa714beb4,
        payload: payload
    });

});


parcelRegister("fip9w", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9ece440dec8b281$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");
parcelRequire("d0pqD");
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $9XE6b = parcelRequire("9XE6b");

var $gccSB = parcelRequire("gccSB");

var $kVLXA = parcelRequire("kVLXA");

var $8B7Oi = parcelRequire("8B7Oi");

var $gI62y = parcelRequire("gI62y");

var $bXPjr = parcelRequire("bXPjr");

var $7a5fK = parcelRequire("7a5fK");

var $aq199 = parcelRequire("aq199");

var $x9xyg = parcelRequire("x9xyg");

var $dJl1T = parcelRequire("dJl1T");

var $4R6GH = parcelRequire("4R6GH");

var $8PRuf = parcelRequire("8PRuf");


var $iuuJH = parcelRequire("iuuJH");

var $kjrfP = parcelRequire("kjrfP");

var $hjlQ8 = parcelRequire("hjlQ8");

var $jQCwr = parcelRequire("jQCwr");

var $127QL = parcelRequire("127QL");

var $kr8xx = parcelRequire("kr8xx");

var $9WrsG = parcelRequire("9WrsG");

var $65C0W = parcelRequire("65C0W");

var $cW3pH = parcelRequire("cW3pH");

var $8yiLS = parcelRequire("8yiLS");

var $vAfHD = parcelRequire("vAfHD");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $4Tseb = parcelRequire("4Tseb");
// This epic will trigger when server side rendering provides a initial state
const $b9ece440dec8b281$var$onReadyWithInitializeStateEpic = (action$, store)=>action$.ofType((0, $65C0W.SOFTWARE_APP_INITIAL_STATE_LOADED)).map(()=>(0, $9WrsG.devStatusLoad)((0, $vAfHD.boardOrderedIssueIdsSelector)(store.getState())));
const $b9ece440dec8b281$export$a28f8e714e737b2e = (cmpBoardData, store)=>{
    const setDataFromCmpBoard = (response)=>{
        const action = (0, $cW3pH.workDataSet)((0, $kjrfP.transformMobileResponse)(response));
        const state = store.getState();
        const customFilterIds = (0, $8yiLS.getActiveCustomFilterIds)(state);
        const isCustomFiltersOn = customFilterIds.length > 0;
        const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
        const swimlaneModeIdLocalStorage = (0, $jQCwr.getSwimlaneModeSetting)(rapidViewId.toString());
        if (!swimlaneModeIdLocalStorage) return (0, $4Tseb.handleCMPBoardDataSet)(action, isCustomFiltersOn);
        // For JQL swimlanes in CMP boards, use admin/backend settings as only admins can configure them
        if (swimlaneModeIdLocalStorage === (0, $iuuJH.SWIMLANE_BY_JQL).id) return (0, $4Tseb.handleCMPBoardDataSet)(action, isCustomFiltersOn);
        return (0, $4Tseb.handleCMPBoardDataSet)({
            ...action,
            payload: {
                ...action.payload,
                swimlaneModeId: swimlaneModeIdLocalStorage
            }
        }, isCustomFiltersOn);
    };
    return (0, $bXPjr.fromPromise)(cmpBoardData).flatMap((cachedDataResult)=>{
        if (!cachedDataResult) return (0, $8B7Oi.empty)();
        const { result: result, refresh: refresh } = cachedDataResult;
        const refresh$ = refresh ? (0, $bXPjr.fromPromise)(refresh) : (0, $8B7Oi.empty)();
        const refreshActions$ = refresh$.flatMap(setDataFromCmpBoard);
        const boardShadowRequest$ = (0, $4R6GH.fg)('jsw_board_simple_pagination_spike') ? (0, $bXPjr.fromPromise)(refresh || Promise.resolve(null)).flatMap(()=>(0, $kVLXA.Observable).of((0, $kr8xx.boardDataShadowRequest)({
                issueCount: result.orderedIssueIds.length
            }))) : (0, $kVLXA.Observable).empty();
        if ((0, $5mTgl.isBoardConfigLoaded)(store.getState()) && refresh) return (0, $4R6GH.fg)('jsw_fix_complete_sprint_button_disappear_issue') ? (0, $7a5fK.merge)((0, $kVLXA.Observable).of((0, $127QL.boardDeferredDataLoad)()), refreshActions$) : refreshActions$;
        return (0, $7a5fK.merge)(setDataFromCmpBoard(result), refreshActions$, (0, $kVLXA.Observable).of((0, $127QL.boardDeferredDataLoad)()), boardShadowRequest$);
    });
};
const $b9ece440dec8b281$var$onBoardScopeLoadEpic = (action$, store)=>action$.ofType((0, $65C0W.SOFTWARE_APP_LOADED)).switchMap((action)=>{
        if (action.payload.cmpBoardData) return $b9ece440dec8b281$export$a28f8e714e737b2e(action.payload.cmpBoardData, store);
        const boardScope = action.payload.prefetchData;
        // No boardScope is an error for TMP boards (means the prefetch has
        // failed). For CMP and Incremental Planning we will just no-op.
        if (!boardScope) {
            const { isCMPBoard: isCMPBoard, isIncrementPlanningBoard: isIncrementPlanningBoard } = store.getState().configuration;
            return isCMPBoard || isIncrementPlanningBoard ? (0, $gI62y.from)([]) : (0, $aq199.of)((0, $cW3pH.loadBoardFailure)());
        }
        if (boardScope && (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(boardScope.board.columns)) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('board.transform.critical.data', 'Board does not have any columns', {
                message: 'Columns does not exist for Board'
            });
            // data wont be in state, need to retrieve from payload.
            const canConfigureBoard = boardScope.currentUser.permissions.includes((0, $68cf6bf1ce76db03$export$b893894941c14e43));
            return (0, $aq199.of)((0, $cW3pH.loadBoardFailureNoColumn)(true, canConfigureBoard));
        }
        // Used to gather data to see impact of transformer on performance of large boards.
        // Will be removed once enough data is gathered.
        (0, $x9xyg.setMark)((0, $8PRuf.jswTransformCriticalDataStartMark));
        const criticalData = (0, $hjlQ8.transformCriticalData)(boardScope);
        (0, $x9xyg.setMark)((0, $8PRuf.jswTransformCriticalDataEndMark));
        const actions = [
            (0, $cW3pH.workDataCriticalSet)(criticalData)
        ];
        // Async actions to kick off after the first load only
        const issues = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(criticalData, [
            'issues'
        ], null);
        if (issues) {
            const issueIds = issues.map((issue)=>issue.id);
            actions.push((0, $9WrsG.devStatusLoad)(issueIds));
        }
        return (0, $gI62y.from)(actions);
    }).catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('board.scope.on.ready.failure', 'Failure on board scope on ready', error);
        return (0, $aq199.of)((0, $cW3pH.loadBoardFailure)());
    });
var $b9ece440dec8b281$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)($b9ece440dec8b281$var$onReadyWithInitializeStateEpic, $b9ece440dec8b281$var$onBoardScopeLoadEpic);

});

parcelRegister("dEmHW", function(module, exports) {

$parcel$export(module.exports, "addToSprintEpic", () => $8c8c7351b59abb61$export$58f658ee7e67fdd6);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("93e44");
parcelRequire("6hSeW");
parcelRequire("7mHDu");
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("c66Ur");


var $23D0N = parcelRequire("23D0N");

var $hdmw1 = parcelRequire("hdmw1");

var $dkGow = parcelRequire("dkGow");

var $cW3pH = parcelRequire("cW3pH");

var $ebHh7 = parcelRequire("ebHh7");
function $8c8c7351b59abb61$export$58f658ee7e67fdd6(action$, store) {
    return action$.ofType((0, $dkGow.ADD_TO_SPRINT_REQUEST)).flatMap((action)=>{
        const state = store.getState();
        const context = (0, $hdmw1.makeServiceContext)(state);
        const optimisticId = action?.meta?.optimistic.id;
        const activeSprints = (0, $ebHh7.activeSprintsSelector)(state);
        const sprint = activeSprints && activeSprints.length && activeSprints.find((sprintItem)=>sprintItem.id === action?.payload?.sprintId);
        if (!action?.payload?.issueId || !sprint) return (0, $kVLXA.Observable).empty();
        return (0, $23D0N.addToSprint)(action.payload.issueId, sprint.id, Number(context.boardId)).mergeMap(()=>(0, $kVLXA.Observable).merge((0, $kVLXA.Observable).of((0, $dkGow.addToSprintSuccess)(action.payload.issueId, sprint.id, optimisticId ?? '')), (0, $kVLXA.Observable).of((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$62b6dae85d0fc668))))).catch(()=>(0, $kVLXA.Observable).of((0, $dkGow.addToSprintFailure)(action.payload.issueId, sprint.id, optimisticId ?? '')));
    });
}

});
parcelRegister("23D0N", function(module, exports) {

$parcel$export(module.exports, "addToSprint", () => $61997d122914c9b4$export$96b61236d7221fa);

var $7zmUm = parcelRequire("7zmUm");
function $61997d122914c9b4$export$96b61236d7221fa(issueKey, sprintId, rapidViewId) {
    return (0, $7zmUm.default)('/rest/greenhopper/1.0/sprint/rank', {
        method: 'PUT',
        body: JSON.stringify({
            addToBacklog: false,
            sprintId: sprintId,
            rapidViewId: rapidViewId,
            calculateNewIssuesOrder: false,
            idOrKeys: [
                issueKey
            ]
        })
    });
}

});


parcelRegister("1wh3p", function(module, exports) {

$parcel$export(module.exports, "removeFromSprintEpic", () => $7f7aa3071789685b$export$eebf8a140511e790);

var $kVLXA = parcelRequire("kVLXA");

var $6s1PB = parcelRequire("6s1PB");
parcelRequire("fp4O3");
parcelRequire("93e44");
parcelRequire("6hSeW");
parcelRequire("7mHDu");
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $4R6GH = parcelRequire("4R6GH");

var $23D0N = parcelRequire("23D0N");

var $bHNg5 = parcelRequire("bHNg5");

var $hdmw1 = parcelRequire("hdmw1");

var $bkCF5 = parcelRequire("bkCF5");

var $dkGow = parcelRequire("dkGow");

var $5G4Hb = parcelRequire("5G4Hb");

var $cW3pH = parcelRequire("cW3pH");

var $d2i8f = parcelRequire("d2i8f");

var $h0yHz = parcelRequire("h0yHz");
function $7f7aa3071789685b$var$onBeforeunload(e) {
    e.preventDefault(); // Firefox
    // The message returned in `beforeunload` handler doesn't have any effect in modern browsers
    const message = '';
    e.returnValue = message; // Chrome
    return message; // IE
}
function $7f7aa3071789685b$export$eebf8a140511e790(action$, store) {
    return action$.ofType((0, $5G4Hb.REMOVE_FROM_SPRINT_REQUEST)).flatMap((action)=>{
        const state = store.getState();
        const context = (0, $hdmw1.makeServiceContext)(state);
        const issue = (0, $d2i8f.getIssueById)(state, action.payload.issueId);
        // Ignore if issue missing, could be some sort of race condition from real-time updates
        if (!issue) return (0, $kVLXA.Observable).empty();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('beforeunload', $7f7aa3071789685b$var$onBeforeunload);
        const undoFlag = (0, $bkCF5.showUndoFlag)({
            id: action.meta.optimistic.id,
            titleMessage: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $h0yHz.messages).undoMessageTitleIssueTermRefresh : (0, $h0yHz.messages).undoMessageTitle,
            descriptionMessage: (0, $h0yHz.messages).undoMessageDescription,
            context: {
                issueKey: issue.key
            },
            links: [
                {
                    content: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $h0yHz.messages).undoMessageViewIssueIssueTermRefresh : (0, $h0yHz.messages).undoMessageViewIssue,
                    href: `/browse/${issue.key}`
                }
            ]
        });
        const optimisticId = action.meta.optimistic.id;
        const undoFlagId = undoFlag.meta.flag.id;
        const issueId = issue.id;
        const issueKey = issue.key;
        const sprintId = issue.sprintId;
        const remove$ = action$.ofType((0, $bkCF5.SHOW_UNDO_FLAG)).take(1).flatMap(()=>{
            if ((0, $4R6GH.fg)('jira-removefromsprint-nodelay')) return (0, $bHNg5.removeFromSprintService)(context, {
                issueKey: issueKey
            }).map(()=>(0, $5G4Hb.removeFromSprintSuccess)(issueId, issueKey, optimisticId)).catch((_err)=>(0, $kVLXA.Observable).of((0, $5G4Hb.removeFromSprintFailure)(issueKey, optimisticId)));
            return (0, $kVLXA.Observable).empty();
        });
        const finish$ = action$.ofType((0, $bkCF5.UNDO_FLAG_PERFORM_COMMIT), (0, $bkCF5.UNDO_FLAG_PERFORM_UNDO), (0, $cW3pH.BEFORE_DISPOSE)).filter((commitAction)=>commitAction.type === (0, $cW3pH.BEFORE_DISPOSE) || commitAction.payload.flagId === undoFlagId).take(1).flatMap((undoAction)=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('beforeunload', $7f7aa3071789685b$var$onBeforeunload);
            if (undoAction.type === (0, $bkCF5.UNDO_FLAG_PERFORM_UNDO)) {
                if ((0, $4R6GH.fg)('jira-removefromsprint-nodelay')) {
                    const sprintIdNumber = Number.parseInt(sprintId, 10);
                    const boardId = Number.parseInt(context.boardId, 10);
                    return (0, $23D0N.addToSprint)(issueId.toString(), sprintIdNumber, boardId).map(()=>(0, $dkGow.addToSprintSuccess)(issueId.toString(), sprintIdNumber, optimisticId)).catch((_err)=>(0, $kVLXA.Observable).of((0, $dkGow.addToSprintFailure)(issueId.toString(), sprintIdNumber, optimisticId)));
                }
                return (0, $kVLXA.Observable).of((0, $5G4Hb.removeFromSprintFailure)(issueKey, optimisticId));
            }
            if (!(0, $4R6GH.fg)('jira-removefromsprint-nodelay')) return (0, $bHNg5.removeFromSprintService)(context, {
                issueKey: issueKey
            }).map(()=>(0, $5G4Hb.removeFromSprintSuccess)(issueId, issueKey, optimisticId)).catch((_err)=>(0, $kVLXA.Observable).of((0, $5G4Hb.removeFromSprintFailure)(issueKey, optimisticId)));
            return (0, $kVLXA.Observable).empty();
        });
        return (0, $kVLXA.Observable).merge(remove$, (0, $kVLXA.Observable).of(undoFlag), finish$);
    });
}

});
parcelRegister("bHNg5", function(module, exports) {

$parcel$export(module.exports, "removeFromSprintService", () => $a15286b8733fe1e4$export$c6f196f77fdc2f20);

var $lnBKM = parcelRequire("lnBKM");
function $a15286b8733fe1e4$export$c6f196f77fdc2f20(ctx, { issueKey: issueKey }) {
    return (0, $lnBKM.removeFromSprint)(ctx.boardId, ctx.contextPath, issueKey);
}

});
parcelRegister("lnBKM", function(module, exports) {

$parcel$export(module.exports, "removeFromSprint", () => $579cdffa4308cff3$export$6fa72ebb3370c788);

var $487fd = parcelRequire("487fd");
function $579cdffa4308cff3$export$6fa72ebb3370c788(rapidViewId, contextPath, issueKey) {
    return (0, $487fd.default)(`${contextPath}/rest/greenhopper/1.0/sprint/rank/${rapidViewId}/remove`, {
        method: 'PUT',
        body: JSON.stringify({
            rapidViewId: rapidViewId,
            idOrKeys: [
                issueKey
            ]
        })
    });
}

});


parcelRegister("5G4Hb", function(module, exports) {

$parcel$export(module.exports, "REMOVE_FROM_SPRINT_REQUEST", () => $aadb230814d99b94$export$6c875bdb249fba00);
$parcel$export(module.exports, "removeFromSprintRequest", () => $aadb230814d99b94$export$ea2399222f9b9105);
$parcel$export(module.exports, "removeFromSprintSuccess", () => $aadb230814d99b94$export$164a6a996c3b9d17);
$parcel$export(module.exports, "removeFromSprintFailure", () => $aadb230814d99b94$export$ddcd9eec6bce5fe0);

var $9rND4 = parcelRequire("9rND4");
const $aadb230814d99b94$export$6c875bdb249fba00 = 'state.actions.sprints.remove-from-sprint.REMOVE_FROM_SPRINT_REQUEST';
function $aadb230814d99b94$export$ea2399222f9b9105(issueId) {
    return {
        type: $aadb230814d99b94$export$6c875bdb249fba00,
        payload: {
            issueId: issueId
        },
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    };
}
const $aadb230814d99b94$export$734d921bbf79186d = 'state.actions.sprints.remove-from-sprint.REMOVE_FROM_SPRINT_SUCCESS';
function $aadb230814d99b94$export$164a6a996c3b9d17(issueId, issueKey, optimisticId) {
    return {
        type: $aadb230814d99b94$export$734d921bbf79186d,
        payload: {
            issueKey: issueKey
        },
        meta: {
            ...(0, $9rND4.commitOptimisticUiMeta)(optimisticId)
        }
    };
}
const $aadb230814d99b94$export$fb018d68d0e9917b = 'state.actions.sprints.remove-from-sprint.REMOVE_FROM_SPRINT_FAILURE';
function $aadb230814d99b94$export$ddcd9eec6bce5fe0(issueKey, optimisticId) {
    return {
        type: $aadb230814d99b94$export$fb018d68d0e9917b,
        payload: {
            issueKey: issueKey
        },
        meta: (0, $9rND4.revertOptimisticUiMeta)(optimisticId)
    };
}

});

parcelRegister("h0yHz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $82fa575f4524509b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $82fa575f4524509b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    undoMessageTitle: {
        "id": "software.main.ops.sprint.remove-from-sprint.undo-message-title",
        "defaultMessage": "{issueKey} removed from sprint"
    },
    undoMessageDescription: {
        "id": "software.main.ops.sprint.remove-from-sprint.undo-message-description",
        "defaultMessage": "Sprint scope will be affected by this action"
    },
    undoMessageViewIssue: {
        "id": "software.main.ops.sprint.remove-from-sprint.undo-message-view-issue",
        "defaultMessage": "View issue"
    },
    undoMessageTitleIssueTermRefresh: {
        "id": "software.main.ops.sprint.remove-from-sprint.undo-message-title-issue-term-refresh",
        "defaultMessage": "{issueKey} removed from sprint"
    },
    undoMessageViewIssueIssueTermRefresh: {
        "id": "software.main.ops.sprint.remove-from-sprint.undo-message-view-issue-issue-term-refresh",
        "defaultMessage": "View issue"
    }
});

});


parcelRegister("3usqj", function(module, exports) {

$parcel$export(module.exports, "updatePlannedCapacityEpic", () => $43d8352dbd9ca057$export$f1770649aa810bf1);
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $hUobS = parcelRequire("hUobS");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $bdYfL = parcelRequire("bdYfL");

var $4kOHs = parcelRequire("4kOHs");

var $cPGP0 = parcelRequire("cPGP0");
function $43d8352dbd9ca057$export$f1770649aa810bf1(action$, store, { customRequestHandlers: customRequestHandlers }) {
    return action$.ofType((0, $4kOHs.UPDATE_PLANNED_CAPACITY_REQUEST)).mergeMap((action)=>{
        const { payload: { capacity: capacity, planningUnit: planningUnit, workingHoursPerDay: workingHoursPerDay, iterationId: iterationId, teamId: teamId, totalCapacity: totalCapacity, defaultCapacity: defaultCapacity } } = action;
        const { planningStyle: planningStyle } = (0, $cPGP0.getTeamById)(store.getState())(teamId);
        const currentCapacity = totalCapacity === null ? defaultCapacity : totalCapacity;
        if (capacity !== '') {
            const newCapacity = parseFloat(capacity);
            const convertedCapacity = (0, (/*@__PURE__*/$parcel$interopDefault($hUobS)))(currentCapacity) && (0, $bdYfL.convertCapacity)(currentCapacity, planningUnit, workingHoursPerDay) || 0;
            if (Number.isNaN(newCapacity) || convertedCapacity === newCapacity) return (0, $kVLXA.Observable).empty();
        }
        const requestPayload = {
            iterationId: `${iterationId}`,
            planningUnit: planningUnit,
            teamId: teamId,
            schedulingMode: planningStyle
        };
        const success = (payload)=>(0, $kVLXA.Observable).of((0, $4kOHs.updatePlannedCapacitySuccess)(payload));
        const error = (err)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('increment.planning.planned.capacity.update', 'Failed to update IP board planned capacity', // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            err);
            return (0, $kVLXA.Observable).of((0, $4kOHs.updatePlannedCapacityFailed)());
        };
        if (!customRequestHandlers) return error(new Error('no request handler found for planned capacity update'));
        if (capacity === '') {
            if (!customRequestHandlers?.removePlannedCapacity) return error(new Error('no request handler found for planned capacity update'));
            return (0, $kVLXA.Observable).from(customRequestHandlers.removePlannedCapacity({
                ...requestPayload,
                capacity: null
            })).flatMap(()=>success({
                    teamId: teamId,
                    iterationId: `${iterationId}`,
                    capacity: null
                })).catch((err)=>error(err));
        }
        const parsed = parseFloat(capacity);
        const convertedCapacity = (0, $bdYfL.convertCapacityFromPlanningUnitToSeconds)({
            capacity: parsed || 0,
            planningUnit: planningUnit,
            workingHours: workingHoursPerDay
        });
        if (!customRequestHandlers?.updatePlannedCapacity) return error(new Error('no request handler found for planned capacity update'));
        return (0, $kVLXA.Observable).from(customRequestHandlers.updatePlannedCapacity({
            ...requestPayload,
            capacity: convertedCapacity
        })).flatMap(()=>success({
                teamId: teamId,
                iterationId: `${iterationId}`,
                capacity: convertedCapacity
            })).catch((err)=>error(err));
    });
}

});
parcelRegister("hUobS", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $d09a6e5a442af90c$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $d09a6e5a442af90c$var$isNumber(value) {
    return typeof value == 'number' || $fC1Kz(value) && $beQoo(value) == $d09a6e5a442af90c$var$numberTag;
}
module.exports = $d09a6e5a442af90c$var$isNumber;

});

parcelRegister("bdYfL", function(module, exports) {

$parcel$export(module.exports, "getPlanId", () => $f1501fc223d29b95$export$203ed8b65c3b2a28);
$parcel$export(module.exports, "urls", () => $f1501fc223d29b95$export$bcae9ba627f604b6);
$parcel$export(module.exports, "getBoardUrl", () => $f1501fc223d29b95$export$505a9f131607d070);
$parcel$export(module.exports, "getManageBoardSettingsUrl", () => $f1501fc223d29b95$export$ba13e822080a5be4);
$parcel$export(module.exports, "convertCapacity", () => $f1501fc223d29b95$export$48e790d731821dac);
$parcel$export(module.exports, "getCapacityUnitMessage", () => $f1501fc223d29b95$export$fb95ed64ed4e0e59);
$parcel$export(module.exports, "getSprintStateLabel", () => $f1501fc223d29b95$export$6f891d146561f05a);
$parcel$export(module.exports, "convertCapacityFromPlanningUnitToSeconds", () => $f1501fc223d29b95$export$acbcfbe3e761e0b4);
$parcel$export(module.exports, "isScenarioPlanonlyTeamCheck", () => $f1501fc223d29b95$export$458ffa13814d195c);

var $6icp6 = parcelRequire("6icp6");

var $hGgHi = parcelRequire("hGgHi");

var $3spCR = parcelRequire("3spCR");

var $gBj4V = parcelRequire("gBj4V");

var $4jAPy = parcelRequire("4jAPy");

var $gZK1Z = parcelRequire("gZK1Z");
const $f1501fc223d29b95$var$PLAN_PARAMS = {
    PLAN: 'plans',
    SCENARIO: 'scenarios',
    BOARD: 'program',
    ROADMAP: 'backlog'
};
const $f1501fc223d29b95$var$parsePathParams = (path, param)=>{
    const regex = new RegExp(`/${param}/(\\w+)`, 'g');
    const matches = Array.from(path.matchAll(regex), (match)=>match[1]);
    return matches[0];
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $f1501fc223d29b95$var$getPathParams = (param)=>$f1501fc223d29b95$var$parsePathParams(window.location.pathname, param);
const $f1501fc223d29b95$export$203ed8b65c3b2a28 = ()=>+$f1501fc223d29b95$var$getPathParams($f1501fc223d29b95$var$PLAN_PARAMS.PLAN) || undefined;
const $f1501fc223d29b95$export$8572797243a693b9 = ()=>+$f1501fc223d29b95$var$getPathParams($f1501fc223d29b95$var$PLAN_PARAMS.SCENARIO) || undefined;
const $f1501fc223d29b95$export$bcae9ba627f604b6 = {
    managePortfolio: '/jira/plans/'
};
const $f1501fc223d29b95$export$505a9f131607d070 = (boardId)=>`/jira/${$f1501fc223d29b95$var$PLAN_PARAMS.PLAN}/${$f1501fc223d29b95$export$203ed8b65c3b2a28()}/${$f1501fc223d29b95$var$PLAN_PARAMS.SCENARIO}/${$f1501fc223d29b95$export$8572797243a693b9()}/${$f1501fc223d29b95$var$PLAN_PARAMS.BOARD}/${boardId}`;
const $f1501fc223d29b95$export$ba13e822080a5be4 = (planId, scenarioId)=>`/jira/plans/${planId}/scenarios/${scenarioId}/settings/program-boards`;
const $f1501fc223d29b95$export$48e790d731821dac = (capacity, planningUnit, workingHoursPerDay)=>{
    if (planningUnit === (0, $4jAPy.IP_BOARD_DAYS_PLANNING_UNIT)) return (0, (/*@__PURE__*/$parcel$interopDefault($6icp6)))(capacity / workingHoursPerDay / (0, $gBj4V.SECONDS_PER_HOUR), 2);
    if (planningUnit === (0, $4jAPy.IP_BOARD_HOURS_PLANNING_UNIT)) return (0, (/*@__PURE__*/$parcel$interopDefault($6icp6)))(capacity / (0, $gBj4V.SECONDS_PER_HOUR), 2);
    return capacity;
};
const $f1501fc223d29b95$export$fb95ed64ed4e0e59 = (planningUnit, formatMessage, originalCapacity)=>{
    // if the originalCapacity is undefined, assign the capacity to 2 to get the plural unit
    const capacity = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(originalCapacity) ? 2 : originalCapacity;
    switch(planningUnit){
        case 0, $4jAPy.IP_BOARD_DAYS_PLANNING_UNIT:
            return formatMessage((0, $gZK1Z.default).dayUnit, {
                days: capacity
            });
        case 0, $4jAPy.IP_BOARD_HOURS_PLANNING_UNIT:
            return formatMessage((0, $gZK1Z.default).hourUnit, {
                hours: capacity
            });
        default:
            return formatMessage((0, $gZK1Z.default).storyPointUnit, {
                points: capacity
            });
    }
};
const $f1501fc223d29b95$export$6f891d146561f05a = (sprintState, formatMessage)=>{
    switch(sprintState){
        case (0, $3spCR.SPRINT_STATES).ACTIVE:
            return formatMessage((0, $gZK1Z.default).activeSprint);
        case (0, $3spCR.SPRINT_STATES).CLOSED:
            return formatMessage((0, $gZK1Z.default).closedSprint);
        case (0, $3spCR.SPRINT_STATES).FUTURE:
        default:
            return formatMessage((0, $gZK1Z.default).futureSprint);
    }
};
const $f1501fc223d29b95$export$acbcfbe3e761e0b4 = ({ capacity: capacity, planningUnit: planningUnit, workingHours: workingHours })=>{
    switch(planningUnit){
        case 0, $4jAPy.IP_BOARD_DAYS_PLANNING_UNIT:
            return capacity * (0, $gBj4V.SECONDS_PER_HOUR) * workingHours;
        case 0, $4jAPy.IP_BOARD_HOURS_PLANNING_UNIT:
            return capacity * (0, $gBj4V.SECONDS_PER_HOUR);
        default:
            return capacity;
    }
};
const $f1501fc223d29b95$export$458ffa13814d195c = (teamId)=>Number.isNaN(parseInt(teamId, 10));

});
parcelRegister("6icp6", function(module, exports) {

var $aza9E = parcelRequire("aza9E");
/**
 * Computes `number` rounded down to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round down.
 * @param {number} [precision=0] The precision to round down to.
 * @returns {number} Returns the rounded down number.
 * @example
 *
 * _.floor(4.006);
 * // => 4
 *
 * _.floor(0.046, 2);
 * // => 0.04
 *
 * _.floor(4060, -2);
 * // => 4000
 */ var $494e0ba682121fe5$var$floor = $aza9E('floor');
module.exports = $494e0ba682121fe5$var$floor;

});
parcelRegister("aza9E", function(module, exports) {

var $1V15E = parcelRequire("1V15E");

var $kPZpS = parcelRequire("kPZpS");

var $1sXeC = parcelRequire("1sXeC");

var $jJVtR = parcelRequire("jJVtR");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7b150cc928607d87$var$nativeIsFinite = $1V15E.isFinite, $7b150cc928607d87$var$nativeMin = Math.min;
/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */ function $7b150cc928607d87$var$createRound(methodName) {
    var func = Math[methodName];
    return function(number, precision) {
        number = $1sXeC(number);
        precision = precision == null ? 0 : $7b150cc928607d87$var$nativeMin($kPZpS(precision), 292);
        if (precision && $7b150cc928607d87$var$nativeIsFinite(number)) {
            // Shift with exponential notation to avoid floating-point issues.
            // See [MDN](https://mdn.io/round#Examples) for more details.
            var pair = ($jJVtR(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
            pair = ($jJVtR(value) + 'e').split('e');
            return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
    };
}
module.exports = $7b150cc928607d87$var$createRound;

});


parcelRegister("gBj4V", function(module, exports) {

$parcel$export(module.exports, "SECONDS_PER_MINUTE", () => $f8bb2765f8828f08$export$544c576050746347);
$parcel$export(module.exports, "SECONDS_PER_HOUR", () => $f8bb2765f8828f08$export$3cc7ae4b390f50a);
$parcel$export(module.exports, "TimeFormats", () => $f8bb2765f8828f08$export$5d7ed58d46354b1);
$parcel$export(module.exports, "TimeUnits", () => $f8bb2765f8828f08$export$5d7753c8ad881494);
$parcel$export(module.exports, "defaultTimeTrackingOptions", () => $f8bb2765f8828f08$export$f8d48c1fed813e90);
const $f8bb2765f8828f08$export$544c576050746347 = 60;
const $f8bb2765f8828f08$export$a4982fdb1458274 = 60;
const $f8bb2765f8828f08$export$3cc7ae4b390f50a = $f8bb2765f8828f08$export$a4982fdb1458274 * $f8bb2765f8828f08$export$544c576050746347;
const $f8bb2765f8828f08$var$TIME_FORMAT_PRETTY = 'pretty';
const $f8bb2765f8828f08$var$TIME_FORMAT_DAYS = 'days';
const $f8bb2765f8828f08$var$TIME_FORMAT_HOURS = 'hours';
const $f8bb2765f8828f08$export$5d7ed58d46354b1 = Object.freeze({
    PRETTY: $f8bb2765f8828f08$var$TIME_FORMAT_PRETTY,
    DAYS: $f8bb2765f8828f08$var$TIME_FORMAT_DAYS,
    HOURS: $f8bb2765f8828f08$var$TIME_FORMAT_HOURS
});
const $f8bb2765f8828f08$var$TIME_UNIT_WEEK = 'week';
const $f8bb2765f8828f08$var$TIME_UNIT_DAY = 'day';
const $f8bb2765f8828f08$var$TIME_UNIT_HOUR = 'hour';
const $f8bb2765f8828f08$var$TIME_UNIT_MINUTE = 'minute';
const $f8bb2765f8828f08$export$5d7753c8ad881494 = Object.freeze({
    WEEK: $f8bb2765f8828f08$var$TIME_UNIT_WEEK,
    DAY: $f8bb2765f8828f08$var$TIME_UNIT_DAY,
    HOUR: $f8bb2765f8828f08$var$TIME_UNIT_HOUR,
    MINUTE: $f8bb2765f8828f08$var$TIME_UNIT_MINUTE
});
const $f8bb2765f8828f08$export$f8d48c1fed813e90 = {
    workingHoursPerDay: 8,
    workingDaysPerWeek: 5,
    timeFormat: $f8bb2765f8828f08$export$5d7ed58d46354b1.PRETTY,
    defaultUnit: $f8bb2765f8828f08$export$5d7753c8ad881494.MINUTE
};

});

parcelRegister("gZK1Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fb4520eab764533$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9fb4520eab764533$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    backToBoards: {
        "id": "portfolio-3-plan-increment-common.common.back-to-boards",
        "defaultMessage": "Choose another board"
    },
    dayUnit: {
        "id": "portfolio-3-plan-increment-common.common.day-unit",
        "defaultMessage": "{days, plural, one {day} other {days}}"
    },
    hourUnit: {
        "id": "portfolio-3-plan-increment-common.common.hour-unit",
        "defaultMessage": "{hours, plural, one {hour} other {hours}}"
    },
    storyPointUnit: {
        "id": "portfolio-3-plan-increment-common.common.story-point-unit",
        "defaultMessage": "{points, plural, one {point} other {points}}"
    },
    activeSprint: {
        "id": "portfolio-3-plan-increment-common.common.active-sprint",
        "defaultMessage": "ACTIVE"
    },
    closedSprint: {
        "id": "portfolio-3-plan-increment-common.common.closed-sprint",
        "defaultMessage": "COMPLETED"
    },
    futureSprint: {
        "id": "portfolio-3-plan-increment-common.common.future-sprint",
        "defaultMessage": "FUTURE"
    },
    apiErrorFlagTitle: {
        "id": "portfolio-3-plan-increment-common.common.api-error-flag-title",
        "defaultMessage": "Something went wrong."
    },
    apiErrorFlagDescription: {
        "id": "portfolio-3-plan-increment-common.common.api-error-flag-description",
        "defaultMessage": "Refresh the page and try that again. "
    },
    editCapacityLabel: {
        "id": "portfolio-3-plan-increment-common.common.edit-capacity-label",
        "defaultMessage": "Edit capacity"
    },
    confirmButtonLabel: {
        "id": "portfolio-3-plan-increment-common.common.confirm-button-label",
        "defaultMessage": "Confirm"
    },
    cancelButtonLabel: {
        "id": "portfolio-3-plan-increment-common.common.cancel-button-label",
        "defaultMessage": "Cancel"
    }
});

});


parcelRegister("4kOHs", function(module, exports) {

$parcel$export(module.exports, "UPDATE_PLANNED_CAPACITY_REQUEST", () => $22a59df7f5bb3c13$export$5859d8c0e774f8e8);
$parcel$export(module.exports, "updatePlannedCapacityRequest", () => $22a59df7f5bb3c13$export$cd7a68543ecb6c);
$parcel$export(module.exports, "UPDATE_PLANNED_CAPACITY_SUCCESS", () => $22a59df7f5bb3c13$export$b9d4eb073fa690f1);
$parcel$export(module.exports, "updatePlannedCapacitySuccess", () => $22a59df7f5bb3c13$export$3f0ed55bbd56051);
$parcel$export(module.exports, "updatePlannedCapacityFailed", () => $22a59df7f5bb3c13$export$308743726309d7b7);
const $22a59df7f5bb3c13$export$5859d8c0e774f8e8 = 'state.actions.sprint.update-planned-capacity.UPDATE_PLANNED_CAPACITY_REQUEST';
const $22a59df7f5bb3c13$export$cd7a68543ecb6c = (payload)=>({
        type: $22a59df7f5bb3c13$export$5859d8c0e774f8e8,
        payload: payload
    });
const $22a59df7f5bb3c13$export$b9d4eb073fa690f1 = 'state.actions.sprint.update-planned-capacity.UPDATE_PLANNED_CAPACITY_SUCCESS';
const $22a59df7f5bb3c13$export$3f0ed55bbd56051 = (payload)=>({
        type: $22a59df7f5bb3c13$export$b9d4eb073fa690f1,
        payload: payload
    });
const $22a59df7f5bb3c13$export$ce51476e09ff4eff = 'state.actions.sprint.update-planned-capacity.UPDATE_PLANNED_CAPACITY_FAILED';
const $22a59df7f5bb3c13$export$308743726309d7b7 = ()=>({
        type: $22a59df7f5bb3c13$export$ce51476e09ff4eff
    });

});


parcelRegister("h07lG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a9be163e55c3a38$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $487fd = parcelRequire("487fd");

var $2bQEl = parcelRequire("2bQEl");

var $65C0W = parcelRequire("65C0W");

var $j6rJH = parcelRequire("j6rJH");

var $67Z81 = parcelRequire("67Z81");
const $2a9be163e55c3a38$var$getUrl = (contextPath)=>`${contextPath}${0, $2bQEl.STATUS_CATEGORY_URL}`;
const $2a9be163e55c3a38$var$loadStatusCategories = (state)=>{
    const url = $2a9be163e55c3a38$var$getUrl((0, $67Z81.contextPathSelector)(state));
    return (0, $487fd.default)(url);
};
const $2a9be163e55c3a38$var$handleSuccess = (result)=>{
    const statusCategories = result.map((statusCategory)=>({
            id: statusCategory.id,
            key: statusCategory.key,
            name: statusCategory.name
        }));
    return (0, $kVLXA.Observable).of((0, $j6rJH.statusCategoryLoadSuccess)(statusCategories));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2a9be163e55c3a38$var$handleFailure = (error)=>(0, $kVLXA.Observable).of((0, $j6rJH.statusCategoryLoadFailure)(error));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2a9be163e55c3a38$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $65C0W.SOFTWARE_APP_LOADED), (0, $65C0W.SOFTWARE_APP_INITIAL_STATE_LOADED)).switchMap(()=>$2a9be163e55c3a38$var$loadStatusCategories(store.getState())).flatMap((result)=>$2a9be163e55c3a38$var$handleSuccess(result)).catch((error)=>$2a9be163e55c3a38$var$handleFailure(error));

});
parcelRegister("j6rJH", function(module, exports) {

$parcel$export(module.exports, "STATUS_CATEGORY_LOAD_SUCCESS", () => $03dc4b7ee6adc6c5$export$147e518ef26092bd);
$parcel$export(module.exports, "statusCategoryLoadSuccess", () => $03dc4b7ee6adc6c5$export$20ce695a9c21c055);
$parcel$export(module.exports, "statusCategoryLoadFailure", () => $03dc4b7ee6adc6c5$export$a44c75f1752a390e);
const $03dc4b7ee6adc6c5$export$147e518ef26092bd = 'state.actions.status-category.STATUS_CATEGORY_LOAD_SUCCESS';
const $03dc4b7ee6adc6c5$export$20ce695a9c21c055 = (statusCategories)=>({
        type: $03dc4b7ee6adc6c5$export$147e518ef26092bd,
        payload: {
            statusCategories: statusCategories
        }
    });
const $03dc4b7ee6adc6c5$export$114d3cbff3f74bbf = 'state.actions.status-category.STATUS_CATEGORY_LOAD_FAILURE';
const $03dc4b7ee6adc6c5$export$a44c75f1752a390e = (error)=>({
        type: $03dc4b7ee6adc6c5$export$114d3cbff3f74bbf,
        error: error
    });

});


parcelRegister("7QNZV", function(module, exports) {

$parcel$export(module.exports, "jqlSwimlanesEpic", () => $68714754f5d7237c$export$cc17f82cc987d2f3);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fPS7b");
parcelRequire("6cbqE");
parcelRequire("1oQta");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("7mHDu");

var $iuuJH = parcelRequire("iuuJH");

var $bkCF5 = parcelRequire("bkCF5");

var $ls4NM = parcelRequire("ls4NM");

var $cW3pH = parcelRequire("cW3pH");

var $45cXl = parcelRequire("45cXl");
const $68714754f5d7237c$export$cc17f82cc987d2f3 = (action$, store)=>action$.ofType((0, $ls4NM.ISSUE_CREATE_REQUEST)).filter(()=>(0, $45cXl.getSwimlaneMode)(store.getState()) === (0, $iuuJH.SWIMLANE_BY_JQL).id).switchMap((issueCreateRequestAction)=>{
        const { meta: { swimlaneId: swimlaneId, isSwimlaneByJql: isSwimlaneByJql } } = issueCreateRequestAction;
        const jqlSwimlanesData = (0, $45cXl.getJqlSwimlanesData)(store.getState());
        if (!isSwimlaneByJql || !jqlSwimlanesData) return (0, $kVLXA.Observable).empty();
        let originalSwimlaneId = swimlaneId;
        const jqlSwimlanesMap = {};
        jqlSwimlanesData.forEach((swimlane)=>{
            // If swimlaneId is null in the create request, then it corresponds to the default swimlane
            if (swimlaneId === null && swimlane.isDefaultSwimlane) originalSwimlaneId = swimlane.id;
            Object.assign(jqlSwimlanesMap, {
                [swimlane.id]: {
                    length: swimlane.issueIds.length,
                    issueIds: new Set(swimlane.issueIds)
                }
            });
        });
        return action$.ofType((0, $cW3pH.WORK_DATA_SET)).take(1).mergeMap((workDataSetAction)=>{
            if (!workDataSetAction.payload.jqlSwimlanes) return (0, $kVLXA.Observable).empty();
            let issuesWereRemovedFromOriginalSwimlane = false;
            const movedIssueKeys = [];
            // Here we compare the current jql swimlanes in state, with the new jql swimlanes after board refresh
            // to see if any issues were removed from the original swimlane and added to another swimlane
            workDataSetAction.payload.jqlSwimlanes.forEach(({ id: id, issueIds: issueIds })=>{
                const jqlSwimlane = jqlSwimlanesMap[id];
                // exit if the swimlane does not exist in the original state
                if (!jqlSwimlane) return;
                const oldSwimlaneLength = jqlSwimlane.length;
                const newSwimlaneLength = issueIds.length;
                if (id === originalSwimlaneId) // Check if the original swimlane has had issues removed
                {
                    if (oldSwimlaneLength > newSwimlaneLength) issuesWereRemovedFromOriginalSwimlane = true;
                } else if (oldSwimlaneLength < newSwimlaneLength) issueIds.forEach((issueId)=>{
                    if (!jqlSwimlane.issueIds.has(issueId)) {
                        // Get the issue key of any issues that were added to a swimlane, as this will be needed
                        // for the flag component
                        const issueKey = workDataSetAction.payload.issues.find((issue)=>issue.id === issueId)?.key;
                        issueKey && movedIssueKeys.push(issueKey);
                    }
                });
            });
            // We show the flag if issues were removed from the original swimlane AND added to another swimlane
            if (issuesWereRemovedFromOriginalSwimlane && movedIssueKeys.length) return (0, $kVLXA.Observable).of((0, $bkCF5.issueCreateMovedBetweenJqlSwimlanes)(movedIssueKeys));
            return (0, $kVLXA.Observable).empty();
        });
    });

});

parcelRegister("lfaRE", function(module, exports) {

$parcel$export(module.exports, "default", () => $2911ccd4c540473a$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $jQCwr = parcelRequire("jQCwr");

var $k50Aq = parcelRequire("k50Aq");

var $67Z81 = parcelRequire("67Z81");

var $4jZ56 = parcelRequire("4jZ56");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2911ccd4c540473a$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $k50Aq.SWIMLANE_TOGGLE)).mergeMap(()=>{
        const state = store.getState();
        (0, $jQCwr.setCollapsedSwimlanes)((0, $67Z81.rapidViewIdSelector)(state), (0, $4jZ56.getCollapsedSwimlanes)(state));
        return (0, $kVLXA.Observable).empty();
    });

});

parcelRegister("l4Gux", function(module, exports) {

$parcel$export(module.exports, "default", () => $d11f4256b05ac949$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $jQCwr = parcelRequire("jQCwr");

var $k50Aq = parcelRequire("k50Aq");

var $67Z81 = parcelRequire("67Z81");

var $4jZ56 = parcelRequire("4jZ56");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d11f4256b05ac949$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $k50Aq.SWIMLANES_TOGGLE)).mergeMap(()=>{
        const state = store.getState();
        (0, $jQCwr.setCollapsedSwimlanes)((0, $67Z81.rapidViewIdSelector)(state), (0, $4jZ56.getCollapsedSwimlanes)(state));
        return (0, $kVLXA.Observable).empty();
    });

});

parcelRegister("1AmgY", function(module, exports) {

$parcel$export(module.exports, "updateIterationCapacityEpic", () => $852676863afb8d79$export$fa884f29220c32ee);
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $hUobS = parcelRequire("hUobS");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $bdYfL = parcelRequire("bdYfL");

var $iOpiy = parcelRequire("iOpiy");

var $bL0WB = parcelRequire("bL0WB");

var $67Z81 = parcelRequire("67Z81");

var $cPGP0 = parcelRequire("cPGP0");
function $852676863afb8d79$export$fa884f29220c32ee(action$, store) {
    return action$.ofType((0, $bL0WB.UPDATE_ITERATION_CAPACITY_REQUEST)).mergeMap((action)=>{
        const { payload: { capacity: capacity, planningUnit: planningUnit, workingHoursPerDay: workingHoursPerDay, iterationId: iterationId, teamId: teamId, totalCapacity: totalCapacity, defaultCapacity: defaultCapacity } } = action;
        const { planningStyle: planningStyle } = (0, $cPGP0.getTeamById)(store.getState())(teamId);
        const planId = (0, $67Z81.getPlanId)(store.getState());
        const incrementId = (0, $67Z81.rapidViewIdSelector)(store.getState());
        const currentCapacity = totalCapacity ?? defaultCapacity;
        if (capacity !== '') {
            const newCapacity = parseFloat(capacity);
            const convertedCapacity = (0, (/*@__PURE__*/$parcel$interopDefault($hUobS)))(currentCapacity) && (0, $bdYfL.convertCapacity)(currentCapacity, planningUnit, workingHoursPerDay) || 0;
            if (Number.isNaN(newCapacity) || convertedCapacity === newCapacity) return (0, $kVLXA.Observable).empty();
        }
        const success = (payload)=>(0, $kVLXA.Observable).of((0, $bL0WB.updateIterationCapacitySuccess)(payload));
        const error = (err)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('increment.planning.iteration.capacity.update', 'Failed to update IP board iteration capacity', // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            err);
            return (0, $kVLXA.Observable).of((0, $bL0WB.updateIterationCapacityFailed)());
        };
        if (!planId) return error(new Error('planId is empty in the update iteration capacity request'));
        if (!incrementId) return error(new Error('incrementId is empty in the update iteration capacity request'));
        const requestPayload = {
            iterationId: iterationId,
            planningUnit: planningUnit,
            teamId: teamId,
            schedulingMode: planningStyle,
            planId: planId,
            incrementId: incrementId
        };
        if (capacity === '') return (0, $iOpiy.removeIterationCapacity)(requestPayload).flatMap(()=>success({
                teamId: teamId,
                iterationId: iterationId,
                capacity: null
            })).catch((err)=>error(err));
        const parsed = parseFloat(capacity);
        const convertedCapacity = (0, $bdYfL.convertCapacityFromPlanningUnitToSeconds)({
            capacity: parsed || 0,
            planningUnit: planningUnit,
            workingHours: workingHoursPerDay
        });
        return (0, $iOpiy.updateIterationCapacity)({
            ...requestPayload,
            capacity: convertedCapacity
        }).flatMap(()=>success({
                teamId: teamId,
                iterationId: iterationId,
                capacity: convertedCapacity
            })).catch((err)=>error(err));
    });
}

});
parcelRegister("iOpiy", function(module, exports) {

$parcel$export(module.exports, "updateIterationCapacity", () => $aaaf310c869d7c09$export$10e76591bc519cd7);
$parcel$export(module.exports, "removeIterationCapacity", () => $aaaf310c869d7c09$export$be150319b39796ad);

var $7zmUm = parcelRequire("7zmUm");
function $aaaf310c869d7c09$export$10e76591bc519cd7({ iterationId: iterationId, teamId: teamId, planningUnit: planningUnit, planId: planId, incrementId: incrementId, capacity: capacity }) {
    return (0, $7zmUm.default)(`/rest/jpo/2.0/plans/${planId}/increments/${incrementId}/capacity/add`, {
        method: 'POST',
        body: JSON.stringify({
            iterationId: iterationId,
            teamId: teamId,
            planningUnit: planningUnit,
            capacity: capacity
        })
    });
}
function $aaaf310c869d7c09$export$be150319b39796ad({ iterationId: iterationId, teamId: teamId, planningUnit: planningUnit, planId: planId, incrementId: incrementId }) {
    return (0, $7zmUm.default)(`/rest/jpo/2.0/plans/${planId}/increments/${incrementId}/capacity/delete`, {
        method: 'POST',
        body: JSON.stringify({
            iterationId: iterationId,
            teamId: teamId,
            planningUnit: planningUnit
        })
    });
}

});

parcelRegister("bL0WB", function(module, exports) {

$parcel$export(module.exports, "UPDATE_ITERATION_CAPACITY_REQUEST", () => $1bfbc9662e37081d$export$6a88665027e1b4e8);
$parcel$export(module.exports, "updateIterationCapacityRequest", () => $1bfbc9662e37081d$export$fe39897c107ee69b);
$parcel$export(module.exports, "UPDATE_ITERATION_CAPACITY_SUCCESS", () => $1bfbc9662e37081d$export$9d109fc28006a62);
$parcel$export(module.exports, "updateIterationCapacitySuccess", () => $1bfbc9662e37081d$export$1f3c13015efad73d);
$parcel$export(module.exports, "updateIterationCapacityFailed", () => $1bfbc9662e37081d$export$4a9a123cabbe169);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $1bfbc9662e37081d$export$6a88665027e1b4e8 = 'state.actions.team.UPDATE_ITERATION_CAPACITY_REQUEST';
const $1bfbc9662e37081d$export$fe39897c107ee69b = (payload)=>({
        type: $1bfbc9662e37081d$export$6a88665027e1b4e8,
        payload: payload
    });
const $1bfbc9662e37081d$export$9d109fc28006a62 = 'state.actions.team.UPDATE_ITERATION_CAPACITY_SUCCESS';
const $1bfbc9662e37081d$export$1f3c13015efad73d = (payload)=>({
        type: $1bfbc9662e37081d$export$9d109fc28006a62,
        payload: payload
    });
const $1bfbc9662e37081d$export$9a57682116a37e4c = 'state.actions.team.UPDATE_ITERATION_CAPACITY_FAILED';
const $1bfbc9662e37081d$export$4a9a123cabbe169 = ()=>({
        type: $1bfbc9662e37081d$export$9a57682116a37e4c,
        meta: (0, $sdxnu.errorFlagMeta)({
            titleMessage: (0, $7AVqz.default).genericTitle,
            descriptionMessage: (0, $7AVqz.default).genericDescription
        })
    });

});


parcelRegister("8wkzB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1357d07a1f414a1$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $4cr9K = parcelRequire("4cr9K");


var $hdmw1 = parcelRequire("hdmw1");

var $jQCwr = parcelRequire("jQCwr");

var $FARqm = parcelRequire("FARqm");

var $k50Aq = parcelRequire("k50Aq");

var $cW3pH = parcelRequire("cW3pH");

var $67Z81 = parcelRequire("67Z81");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a1357d07a1f414a1$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $k50Aq.SWIMLANE_MODE_CHANGE_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const { meta: { optimistic: { id: txId } }, payload: swimlaneMode } = action;
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
        const ctx = (0, $hdmw1.makeServiceContext)(state);
        if (ctx.isCMPBoard) {
            (0, $jQCwr.setSwimlaneModeSetting)(rapidViewId, action.payload);
            return (0, $kVLXA.Observable).of((0, $k50Aq.swimlaneModeChangeSuccess)(txId));
        }
        return (0, $FARqm.default)(contextPath, rapidViewId, swimlaneMode).flatMap(()=>(0, $kVLXA.Observable).of((0, $k50Aq.swimlaneModeChangeSuccess)(txId))).catch((error)=>(0, $kVLXA.Observable).of(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $k50Aq.swimlaneModeChangeFailure)(txId), (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$d9d2fe902bd6d9a7)), (0, $4cr9K.showErrorFlag)(error)));
    });

});
parcelRegister("FARqm", function(module, exports) {

$parcel$export(module.exports, "default", () => $15ab360a2a7cca30$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("3q49N");
parcelRequire("c66Ur");

var $dJl1T = parcelRequire("dJl1T");

var $jVaxm = parcelRequire("jVaxm");

var $cjoN4 = parcelRequire("cjoN4");
const $15ab360a2a7cca30$export$51186ad6e864892a = (data)=>data.strategy;
function $15ab360a2a7cca30$export$2e2bcd8739ae039(contextPath, boardId, swimlaneStrategy) {
    return (0, $jVaxm.default)(contextPath, boardId, (0, $cjoN4.transformSwimlaneModeToApi)(swimlaneStrategy)).catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('board.user.swimlane.strategy.mutate.graphql.failure', 'Failed to mutate user swimlane strategy via GraphQL');
        return (0, $kVLXA.Observable).throw(error);
    });
}

});
parcelRegister("jVaxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2d44a0443e31c43$export$2e2bcd8739ae039);

var $6iJbJ = parcelRequire("6iJbJ");

var $CFxE9 = parcelRequire("CFxE9");
const $f2d44a0443e31c43$export$fb8289a9b8ee99a3 = 'SetUserSwimlaneStrategy';
const $f2d44a0443e31c43$export$192cb43903d0219e = `mutation ${$f2d44a0443e31c43$export$fb8289a9b8ee99a3} ($boardId: ID!, $strategy: SwimlaneStrategy!) {
    setUserSwimlaneStrategy(input: {boardId: $boardId, strategy: $strategy}) {
        statusCode
        strategy
        message
    }
}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f2d44a0443e31c43$export$2e2bcd8739ae039 = (contextPath, boardId, swimlaneStrategy)=>{
    const transformedSwimlaneStrategyForMutation = swimlaneStrategy.toUpperCase();
    return (0, $6iJbJ.mutation$)(contextPath, $f2d44a0443e31c43$export$fb8289a9b8ee99a3, $f2d44a0443e31c43$export$192cb43903d0219e, {
        boardId: boardId,
        strategy: transformedSwimlaneStrategyForMutation
    }, (0, $CFxE9.setUserSwimlaneAnalyticsOptions));
};

});



parcelRegister("deevq", function(module, exports) {

$parcel$export(module.exports, "versionGetEpic", () => $fc3f54ec18d59e66$export$dc3a899b72eaca08);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $dJl1T = parcelRequire("dJl1T");

var $hdmw1 = parcelRequire("hdmw1");

var $71cRN = parcelRequire("71cRN");

var $65C0W = parcelRequire("65C0W");

var $j00DX = parcelRequire("j00DX");
const $fc3f54ec18d59e66$export$dc3a899b72eaca08 = (action$, store)=>action$.ofType((0, $j00DX.FETCH_VERSION_DATA), (0, $65C0W.SOFTWARE_APP_LOADED), (0, $65C0W.SOFTWARE_APP_INITIAL_STATE_LOADED)).switchMap(()=>{
        const ctx = (0, $hdmw1.makeServiceContext)(store.getState());
        if (!ctx.isCMPBoard) return (0, $kVLXA.Observable).of();
        return (0, $71cRN.fetchVersionDataService)(ctx).mergeMap((versionResponse)=>(0, $kVLXA.Observable).of((0, $j00DX.setVersionData)(versionResponse))).catch((error)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('board.version.load.failure', 'Failure on version data load', error);
            return (0, $kVLXA.Observable).of();
        });
    });

});
parcelRegister("71cRN", function(module, exports) {

$parcel$export(module.exports, "fetchVersionDataService", () => $25180b01382befb7$export$367efd4995472a7);

var $cXzOE = parcelRequire("cXzOE");
const $25180b01382befb7$export$367efd4995472a7 = (ctx)=>(0, $cXzOE.fetchVersionDataRest)(ctx.boardId).map((response)=>response.versionData);

});
parcelRegister("cXzOE", function(module, exports) {

$parcel$export(module.exports, "fetchVersionDataRest", () => $bf1e80b0da2c3f61$export$3d5af46d1a00703d);

var $487fd = parcelRequire("487fd");

var $2bQEl = parcelRequire("2bQEl");
const $bf1e80b0da2c3f61$export$3d5af46d1a00703d = (boardId)=>(0, $487fd.default)((0, $2bQEl.getVersionUrl)(boardId));

});


parcelRegister("j00DX", function(module, exports) {

$parcel$export(module.exports, "FETCH_VERSION_DATA", () => $8e4f38cd90396a7f$export$eb55b6af2b295f7f);
$parcel$export(module.exports, "SET_VERSION_DATA", () => $8e4f38cd90396a7f$export$19e17d103ff6d4c6);
$parcel$export(module.exports, "setVersionData", () => $8e4f38cd90396a7f$export$2e9c1519373ac155);
const $8e4f38cd90396a7f$export$eb55b6af2b295f7f = 'state.actions.version.FETCH_VERSION_DATA';
const $8e4f38cd90396a7f$export$52600acdc8e4fd18 = ()=>({
        type: $8e4f38cd90396a7f$export$eb55b6af2b295f7f
    });
const $8e4f38cd90396a7f$export$19e17d103ff6d4c6 = 'state.actions.version.SET_VERSION_DATA';
const $8e4f38cd90396a7f$export$2e9c1519373ac155 = (payload)=>({
        type: $8e4f38cd90396a7f$export$19e17d103ff6d4c6,
        payload: payload
    });

});


parcelRegister("iAr3J", function(module, exports) {

$parcel$export(module.exports, "default", () => $1446920092f2369d$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");
parcelRequire("6cbqE");

var $jcw0u = parcelRequire("jcw0u");

var $487fd = parcelRequire("487fd");

var $2bQEl = parcelRequire("2bQEl");

var $lF9PL = parcelRequire("lF9PL");

var $hoX5N = parcelRequire("hoX5N");

var $65C0W = parcelRequire("65C0W");

var $cW3pH = parcelRequire("cW3pH");

var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");
const $1446920092f2369d$var$workGetCurrentUserEpic = (action$, store)=>action$.ofType((0, $cW3pH.WORK_REFRESH_DATA), (0, $65C0W.SOFTWARE_APP_LOADED), (0, $65C0W.SOFTWARE_APP_INITIAL_STATE_LOADED)).switchMap(()=>{
        const state = store.getState();
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const currentUserAccountId = (0, $67Z81.currentUserAccountIdSelector)(state);
        const people = (0, $36pz7.getPeople)(state);
        if (people[currentUserAccountId]) return (0, $kVLXA.Observable).empty();
        return (0, $487fd.default)((0, $2bQEl.getCurrentUserDataFromAccountIdUrl)(contextPath, currentUserAccountId)).flatMap((response)=>(0, $kVLXA.Observable).of((0, $hoX5N.setPerson)({
                ...(0, $lF9PL.transformPerson)(response)
            }))).catch((error)=>{
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'board.getCurrentUser.failure',
                    packageName: 'jiraSoftwareBoard',
                    teamName: 'a4t-tanuki'
                }
            });
            return (0, $kVLXA.Observable).empty();
        });
    });
var $1446920092f2369d$export$2e2bcd8739ae039 = $1446920092f2369d$var$workGetCurrentUserEpic;

});
parcelRegister("hoX5N", function(module, exports) {

$parcel$export(module.exports, "PERSON_SET", () => $a6b6d53e57e67328$export$5ea066dfbb9cdc4d);
$parcel$export(module.exports, "setPerson", () => $a6b6d53e57e67328$export$89eefa97e3be5ee3);
const $a6b6d53e57e67328$export$5ea066dfbb9cdc4d = 'state.actions.people.PERSON_SET';
const $a6b6d53e57e67328$export$89eefa97e3be5ee3 = (person)=>({
        type: $a6b6d53e57e67328$export$5ea066dfbb9cdc4d,
        payload: person
    });

});


parcelRegister("kmCzR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3324163fd5cdf9f$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("2JdQp");
parcelRequire("huL2s");
parcelRequire("3awJm");
parcelRequire("iQCJJ");
parcelRequire("ihPQR");
parcelRequire("1oQta");
parcelRequire("kxK5F");
parcelRequire("eSGL3");
parcelRequire("6cbqE");

var $gSIcW = parcelRequire("gSIcW");



var $cW3pH = parcelRequire("cW3pH");

var $k8auG = parcelRequire("k8auG");

var $5mTgl = parcelRequire("5mTgl");
/**
 * Start with marker, so that we guarantee there are no
 * polls or visibility changed refresh actions emitted
 * without throttling.
 */ const $d3324163fd5cdf9f$var$STREAM_START_MARKER = Symbol('STREAM_START_MARKER');
// This stream controls whether the board will poll the server for data.
// The stream will create BOARD_GET_DATA actions:
// 1. On start up to populate the board with initial data.
const $d3324163fd5cdf9f$var$workRefreshDataEpic = (scheduler, debounceScheduler)=>(action$, store)=>{
        const refresh$ = (0, $gSIcW.default)().distinctUntilChanged().debounceTime(500, debounceScheduler) // prevent multiple requests when ppl play around the tabs
        .switchMap((shouldPoll, idx)=>{
            if (!shouldPoll) return (0, $kVLXA.Observable).never();
            const refreshStream = (0, $kVLXA.Observable).interval((0, $7e733a5d4e4331fc$export$70f4a301e337eb0b), scheduler).mapTo((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$8125ab02c04ac8e7))).filter(()=>!(0, $5mTgl.hasAnyActiveOptimistic)(store.getState())).filter(()=>(0, $k8auG.isPollingEnabled)(store.getState()));
            if (idx === 0) return refreshStream.startWith($d3324163fd5cdf9f$var$STREAM_START_MARKER);
            return refreshStream.startWith((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$725480b44dc3539d)));
        });
        return refresh$.throttleTime((0, $7e733a5d4e4331fc$export$70f4a301e337eb0b), scheduler).filter((action)=>action !== $d3324163fd5cdf9f$var$STREAM_START_MARKER);
    };
var $d3324163fd5cdf9f$export$2e2bcd8739ae039 = $d3324163fd5cdf9f$var$workRefreshDataEpic;

});


parcelRegister("5kyJ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2bd300124c49df2$export$2e2bcd8739ae039);

var $gccSB = parcelRequire("gccSB");

var $hhweD = parcelRequire("hhweD");

var $knz2T = parcelRequire("knz2T");
const $b2bd300124c49df2$var$shouldTriggerAnalytics = ({ type: type } = {})=>(0, $knz2T.default)()[type ?? ''] !== undefined;
const $b2bd300124c49df2$var$getAnalyticsForAction = (preActionState, postActionState, // eslint-disable-next-line @typescript-eslint/no-explicit-any
action)=>(0, $knz2T.default)()[action.type].map((createAnalytic)=>createAnalytic((0, $knz2T.ANALYTIC_PREFIX))(preActionState, postActionState, action)).filter((analyticEvent)=>analyticEvent !== null);
const $b2bd300124c49df2$var$triggerAnalyticsForAction = (analyticEvents)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(analyticEvents)) return;
    analyticEvents.forEach(({ trackEvents: trackEvents = [] })=>{
        trackEvents.forEach((trackEvent)=>(0, $hhweD.fireTrackAnalytics)(trackEvent, {
                action: trackEvent.payload.action
            }));
    });
};
// @ts-expect-error - Type 'MiddlewareAPI<S>' is not assignable to type 'MiddlewareAPI'.
const $b2bd300124c49df2$var$analyticsMiddleware = (store)=>(next)=>(action)=>{
            if (!$b2bd300124c49df2$var$shouldTriggerAnalytics(action)) return next(action);
            const preActionState = store.getState();
            const result = next(action);
            const postActionState = store.getState();
            const analyticEvents = $b2bd300124c49df2$var$getAnalyticsForAction(preActionState, postActionState, action);
            $b2bd300124c49df2$var$triggerAnalyticsForAction(analyticEvents);
            return result;
        };
var $b2bd300124c49df2$export$2e2bcd8739ae039 = $b2bd300124c49df2$var$analyticsMiddleware;

});
parcelRegister("knz2T", function(module, exports) {

$parcel$export(module.exports, "ANALYTIC_PREFIX", () => $03a8ef826366cb8d$export$c88107e5c6decd92);
$parcel$export(module.exports, "default", () => $03a8ef826366cb8d$export$2e2bcd8739ae039);

var $doOdQ = parcelRequire("doOdQ");

var $bRqd3 = parcelRequire("bRqd3");

var $7buQq = parcelRequire("7buQq");

var $2f454 = parcelRequire("2f454");

var $cY26q = parcelRequire("cY26q");

var $glGhK = parcelRequire("glGhK");

var $63F6h = parcelRequire("63F6h");

var $9eeht = parcelRequire("9eeht");

var $55fEr = parcelRequire("55fEr");

var $63VRQ = parcelRequire("63VRQ");

var $dnW4F = parcelRequire("dnW4F");

var $bkCF5 = parcelRequire("bkCF5");

var $e1q2I = parcelRequire("e1q2I");

var $ls4NM = parcelRequire("ls4NM");

var $kXqRJ = parcelRequire("kXqRJ");

var $5s6yC = parcelRequire("5s6yC");

var $9WrsG = parcelRequire("9WrsG");

var $fBkjL = parcelRequire("fBkjL");

var $dN3Ms = parcelRequire("dN3Ms");

var $dW1HX = parcelRequire("dW1HX");

var $cIqUn = parcelRequire("cIqUn");

var $71oFY = parcelRequire("71oFY");

var $evkwq = parcelRequire("evkwq");

var $k50Aq = parcelRequire("k50Aq");

var $cW3pH = parcelRequire("cW3pH");

var $30dmz = parcelRequire("30dmz");

var $3Nbzx = parcelRequire("3Nbzx");

var $kegsr = parcelRequire("kegsr");

var $ccYou = parcelRequire("ccYou");

var $kVgZQ = parcelRequire("kVgZQ");

var $anKCl = parcelRequire("anKCl");

var $a8X4R = parcelRequire("a8X4R");

var $dOmSg = parcelRequire("dOmSg");

var $7PXr3 = parcelRequire("7PXr3");

var $6KwKW = parcelRequire("6KwKW");

var $6qosr = parcelRequire("6qosr");

var $c0Kii = parcelRequire("c0Kii");

var $hpG0x = parcelRequire("hpG0x");

var $8yIXy = parcelRequire("8yIXy");

var $jYl7U = parcelRequire("jYl7U");
const $03a8ef826366cb8d$export$c88107e5c6decd92 = 'board';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$03a8ef826366cb8d$export$2e2bcd8739ae039 = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ({
        [(0, $doOdQ.BACKLOG_ISSUE_MOVE_SHOW)]: [
            (0, $30dmz.backlogIssueMoveShow)
        ],
        [(0, $doOdQ.BACKLOG_ISSUE_MOVE_CANCEL)]: [
            (0, $30dmz.backlogIssueMoveCancel)
        ],
        [(0, $doOdQ.BACKLOG_ISSUE_MOVE_EXECUTE)]: [
            (0, $30dmz.backlogIssueMoveExecute)
        ],
        [(0, $doOdQ.BACKLOG_ISSUE_MOVE_EXECUTE_FAILURE)]: [
            (0, $30dmz.backlogIssueMoveExecuteFailure)
        ],
        [(0, $doOdQ.BACKLOG_ISSUE_MOVE_EXECUTE_SUCCESS)]: [
            (0, $30dmz.backlogIssueMoveExecuteSuccess)
        ],
        [(0, $cW3pH.BOARD_LOAD_FAILURE)]: [
            (0, $jYl7U.boardLoadFailure)
        ],
        [(0, $cW3pH.BOARD_LOAD_FAILURE_NO_COLUMN)]: [
            (0, $jYl7U.boardLoadNoColumnFailure)
        ],
        [(0, $cW3pH.BOARD_VIEW)]: [
            (0, $jYl7U.boardView)
        ],
        [(0, $cW3pH.BOARD_NON_CRITICAL_VIEW)]: [
            (0, $jYl7U.boardNonCriticalView)
        ],
        [(0, $cW3pH.WORK_DATA_SET)]: [
            (0, $6KwKW.issueLabelsAmount)
        ],
        [(0, $cW3pH.WORK_DATA_CRITICAL_SET)]: [
            (0, $6KwKW.issueLabelsAmount)
        ],
        [(0, $cW3pH.WORK_REFRESH_DATA)]: [
            (0, $jYl7U.workRefreshData)
        ],
        [(0, $7buQq.RENAME_BOARD_FAILURE)]: [
            (0, $kegsr.renameBoardFailure)
        ],
        [(0, $7buQq.RENAME_BOARD_REQUEST)]: [
            (0, $kegsr.renameBoardRequest)
        ],
        [(0, $7buQq.RENAME_BOARD_SUCCESS)]: [
            (0, $kegsr.renameBoardSuccess)
        ],
        [(0, $bRqd3.CARD_MEDIA_TOGGLE_REQUEST)]: [
            (0, $3Nbzx.cardMediaToggled)
        ],
        [(0, $55fEr.COLUMN_RANK_REQUEST)]: [
            (0, $ccYou.columnRankRequest),
            (0, $kVgZQ.columnRankRequestPerformance)
        ],
        [(0, $55fEr.COLUMN_RANK_SUCCESS)]: [
            (0, $ccYou.columnRankSuccess),
            (0, $kVgZQ.columnRankSuccessPerformance)
        ],
        [(0, $55fEr.COLUMN_RANK_FAILURE)]: [
            (0, $ccYou.columnRankFailure)
        ],
        [(0, $63VRQ.COLUMN_RENAME_REQUEST)]: [
            (0, $ccYou.columnRenameRequest),
            (0, $kVgZQ.columnRenameRequestPerformance)
        ],
        [(0, $63VRQ.COLUMN_RENAME_SUCCESS)]: [
            (0, $ccYou.columnRenameSuccess),
            (0, $kVgZQ.columnRenameSuccessPerformance)
        ],
        [(0, $63VRQ.COLUMN_RENAME_FAILURE)]: [
            (0, $ccYou.columnRenameFailure)
        ],
        [(0, $glGhK.COLUMN_CREATE_REQUEST)]: [
            (0, $ccYou.columnCreateRequest),
            (0, $kVgZQ.columnCreateRequestPerformance)
        ],
        [(0, $glGhK.COLUMN_CREATE_SUCCESS)]: [
            (0, $ccYou.columnCreateSuccess),
            (0, $kVgZQ.columnCreateSuccessPerformance)
        ],
        [(0, $glGhK.COLUMN_CREATE_FAILURE)]: [
            (0, $ccYou.columnCreateFailure)
        ],
        [(0, $63F6h.COLUMN_DELETE)]: [
            (0, $ccYou.columnDelete)
        ],
        [(0, $63F6h.COLUMN_DELETE_REQUEST)]: [
            (0, $ccYou.columnDeleteRequest),
            (0, $kVgZQ.columnDeleteRequestPerformance)
        ],
        [(0, $63F6h.COLUMN_DELETE_SUCCESS)]: [
            (0, $ccYou.columnDeleteSuccess),
            (0, $kVgZQ.columnDeleteSuccessPerformance)
        ],
        [(0, $63F6h.COLUMN_DELETE_FAILURE)]: [
            (0, $ccYou.columnDeleteFailure)
        ],
        [(0, $9eeht.COLUMN_OPEN_LIMITS_MODAL)]: [
            (0, $ccYou.columnOpenLimitsModal)
        ],
        [(0, $9eeht.COLUMN_CLOSE_LIMITS_MODAL)]: [
            (0, $ccYou.columnCloseLimitsModal)
        ],
        [(0, $9eeht.COLUMN_SET_LIMITS_REQUEST)]: [
            (0, $ccYou.columnSetLimitsRequest),
            (0, $ccYou.columnBustStatus),
            (0, $kVgZQ.columnLimitRequestPerformance)
        ],
        [(0, $9eeht.COLUMN_SET_LIMITS_SUCCESS)]: [
            (0, $ccYou.columnSetLimitsSuccess),
            (0, $kVgZQ.columnLimitSuccessPerformance)
        ],
        [(0, $9eeht.COLUMN_SET_LIMITS_FAILURE)]: [
            (0, $ccYou.columnSetLimitsFailure)
        ],
        [(0, $e1q2I.DONE_ISSUES_BUTTON_CLICK)]: [
            (0, $6KwKW.doneIssuesButtonClick)
        ],
        [(0, $ls4NM.ISSUE_CREATE_REQUEST)]: [
            (0, $6KwKW.issueCreateRequest),
            (0, $6qosr.issueCreateRequestPerformance)
        ],
        [(0, $ls4NM.ISSUE_CREATE_SUCCESS)]: [
            (0, $6KwKW.issueCreateSuccess),
            (0, $6qosr.issueCreateSuccessPerformance)
        ],
        [(0, $ls4NM.ISSUE_CREATE_FAILURE)]: [
            (0, $6KwKW.issueCreateFailure)
        ],
        [(0, $kXqRJ.ISSUE_DELETE_REQUEST)]: [
            (0, $6qosr.issueDeleteRequestPerformance)
        ],
        [(0, $kXqRJ.ISSUE_DELETE_SUCCESS)]: [
            (0, $6KwKW.issueDeleteSuccess)
        ],
        [(0, $kXqRJ.ISSUE_DELETE_FAILURE)]: [
            (0, $6KwKW.issueDeleteFailure)
        ],
        [(0, $5s6yC.ISSUE_DELETE_MODAL_OPEN)]: [
            (0, $c0Kii.issueDeleteModalOpen)
        ],
        [(0, $5s6yC.ISSUE_DELETE_MODAL_CLOSE)]: [
            (0, $c0Kii.issueDeleteModalClose)
        ],
        [(0, $fBkjL.ISSUE_FLAG_WITH_COMMENT_REQUEST)]: [
            (0, $6qosr.issueFlagToggleRequestPerformance)
        ],
        [(0, $cIqUn.ISSUE_MOVE_TO_BACKLOG_REQUEST)]: [
            (0, $6KwKW.issueMoveToBacklogRequest)
        ],
        [(0, $cIqUn.ISSUE_MOVE_TO_BACKLOG_SUCCESS)]: [
            (0, $6KwKW.issueMoveToBacklogSuccess)
        ],
        [(0, $cIqUn.ISSUE_MOVE_TO_BACKLOG_FAILURE)]: [
            (0, $6KwKW.issueMoveToBacklogFailure)
        ],
        [(0, $71oFY.ISSUE_RANK_TRANSITION_UPDATE_OPTIMISTIC)]: [
            (0, $6KwKW.issueRankTransitionRequest),
            (0, $ccYou.columnBustStatus),
            (0, $6qosr.issueRankTransitionRequestPerformance)
        ],
        [(0, $71oFY.ISSUE_RANK_TRANSITION_SUCCESS)]: [
            (0, $6KwKW.issueRankTransitionSuccess),
            (0, $6qosr.issueRankTransitionSuccessPerformance)
        ],
        [(0, $71oFY.ISSUE_RANK_TRANSITION_FAILURE)]: [
            (0, $6KwKW.issueRankTransitionFailure)
        ],
        [(0, $evkwq.ISSUE_UPDATE_SUCCESS)]: [
            (0, $6KwKW.issueLabelsAmount)
        ],
        [(0, $e1q2I.ISSUE_CHANGE_SWIMLANE)]: [
            (0, $6KwKW.issueChangeSwimlane)
        ],
        [(0, $9WrsG.DEV_STATUS_LOAD_SUCCESS)]: [
            (0, $6KwKW.devStatusLoadSuccess)
        ],
        [(0, $dnW4F.FILTER_PANEL_MOUNTED)]: [
            (0, $a8X4R.filterPanelMounted)
        ],
        [(0, $dnW4F.SEARCH_FOCUS)]: [
            (0, $a8X4R.searchFocus)
        ],
        [(0, $dnW4F.SET_ALL_FILTERS)]: [
            (0, $a8X4R.setAllFilters),
            (0, $a8X4R.setAllFiltersPerformance)
        ],
        [(0, $dnW4F.CLEAR_ALL_FILTERS_CLICKED)]: [
            (0, $a8X4R.clearAllFiltersClicked)
        ],
        [(0, $bkCF5.FLAG_DISMISSED)]: [
            (0, $dOmSg.flagDismissed)
        ],
        [(0, $bkCF5.FLAG_CREATED_ISSUE_IS_FILTERED)]: [
            (0, $dOmSg.flagCreatedIssueIsFiltered)
        ],
        [(0, $bkCF5.ISSUE_CREATE_FILTERED_V2)]: [
            (0, $dOmSg.flagIssueCreateFilteredV2)
        ],
        [(0, $bkCF5.ISSUE_CREATE_MOVED_BETWEEN_SWIMLANES)]: [
            (0, $dOmSg.flagIssueCreateMovedBetweenJqlSwimlanes)
        ],
        [(0, $dW1HX.OPEN_ISSUE_MODAL)]: [
            (0, $6KwKW.openIssueCreate)
        ],
        [(0, $k50Aq.SWIMLANE_MODE_CHANGE_REQUEST)]: [
            (0, $8yIXy.swimlaneModeChanged)
        ],
        [(0, $dN3Ms.ISSUE_MEDIA_VISIBILITY_CHANGE_REQUEST)]: [
            (0, $hpG0x.issueMediaVisibilityChange)
        ],
        [(0, $2f454.CARD_CLICK)]: [
            (0, $7PXr3.issueViewOpenPerformance)
        ],
        [(0, $cY26q.FILTERED_CARD_SUCCESS)]: [
            (0, $anKCl.setCustomFiltersPerformance),
            (0, $anKCl.setCustomFiltersSuccess)
        ],
        [(0, $cY26q.FILTERED_CARD_FAILURE)]: [
            (0, $anKCl.setCustomFiltersFailure)
        ],
        [(0, $cY26q.REFILTER_SUCCESS)]: [
            (0, $anKCl.setCustomFiltersRefilterSuccess)
        ],
        [(0, $cY26q.REFILTER_FAILURE)]: [
            (0, $anKCl.setCustomFiltersRefilterFailure)
        ]
    });

});
parcelRegister("5s6yC", function(module, exports) {

$parcel$export(module.exports, "ISSUE_DELETE_MODAL_OPEN", () => $2265289d779cbe46$export$976c1e3393aa0887);
$parcel$export(module.exports, "issueDeleteModalOpen", () => $2265289d779cbe46$export$4807059b0e0495d2);
$parcel$export(module.exports, "ISSUE_DELETE_MODAL_CLOSE", () => $2265289d779cbe46$export$8201bc2c56389a43);
$parcel$export(module.exports, "issueDeleteModalClose", () => $2265289d779cbe46$export$b8ef0a3642381);
const $2265289d779cbe46$export$976c1e3393aa0887 = 'state.actions.issue.delete-modal.ISSUE_DELETE_MODAL_OPEN';
const $2265289d779cbe46$export$4807059b0e0495d2 = (issueId, columnIndex)=>({
        type: $2265289d779cbe46$export$976c1e3393aa0887,
        payload: {
            issueId: issueId,
            columnIndex: columnIndex
        }
    });
const $2265289d779cbe46$export$8201bc2c56389a43 = 'state.actions.issue.delete-modal.ISSUE_DELETE_MODAL_CLOSE';
const $2265289d779cbe46$export$b8ef0a3642381 = ()=>({
        type: $2265289d779cbe46$export$8201bc2c56389a43
    });

});

parcelRegister("30dmz", function(module, exports) {

$parcel$export(module.exports, "backlogIssueMoveShow", () => $d2eaa2ff91065976$export$d855544cc5ffa4f4);
$parcel$export(module.exports, "backlogIssueMoveCancel", () => $d2eaa2ff91065976$export$8ad0be7d3c5b884d);
$parcel$export(module.exports, "backlogIssueMoveExecute", () => $d2eaa2ff91065976$export$deb012b7ca9ae918);
$parcel$export(module.exports, "backlogIssueMoveExecuteSuccess", () => $d2eaa2ff91065976$export$306bba8cd988ac22);
$parcel$export(module.exports, "backlogIssueMoveExecuteFailure", () => $d2eaa2ff91065976$export$e67e8d09cf0c08f4);

var $absT5 = parcelRequire("absT5");
const $d2eaa2ff91065976$export$d855544cc5ffa4f4 = (eventPrefix)=>(preState, state)=>({
            name: `${eventPrefix}.backlog-issue-move.show`,
            data: {
                numIssues: (0, $absT5.getFirstColumnIssueIds)(state).length
            }
        });
const $d2eaa2ff91065976$export$8ad0be7d3c5b884d = (eventPrefix)=>(preState, state)=>({
            name: `${eventPrefix}.backlog-issue-move.cancel`,
            data: {
                numIssues: (0, $absT5.getFirstColumnIssueIds)(state).length
            }
        });
const $d2eaa2ff91065976$export$deb012b7ca9ae918 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.backlog-issue-move.execute`,
            data: {
                numIssues: action.payload.issueIds.length,
                transactionId: action.meta.optimistic.id
            }
        });
const $d2eaa2ff91065976$export$306bba8cd988ac22 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.backlog-issue-move.execute.success`,
            data: {
                transactionId: action.meta.optimistic.id
            }
        });
const $d2eaa2ff91065976$export$e67e8d09cf0c08f4 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.backlog-issue-move.execute.failure`,
            data: {
                transactionId: action.meta.optimistic.id
            }
        });

});

parcelRegister("3Nbzx", function(module, exports) {

$parcel$export(module.exports, "cardMediaToggled", () => $dc97f64e23967130$export$c679084c7b832b31);

var $5mTgl = parcelRequire("5mTgl");
const $dc97f64e23967130$export$c679084c7b832b31 = (eventPrefix)=>(preState, state)=>{
        const enabled = (0, $5mTgl.isCardMediaEnabled)(state);
        return {
            name: `${eventPrefix}.card.media.toggled.global`,
            data: {
                enabled: enabled
            }
        };
    };

});

parcelRegister("kegsr", function(module, exports) {

$parcel$export(module.exports, "renameBoardSuccess", () => $49ba23132ca991f0$export$21475b90a48a2c95);
$parcel$export(module.exports, "renameBoardFailure", () => $49ba23132ca991f0$export$244d02fac7e80a83);
$parcel$export(module.exports, "renameBoardRequest", () => $49ba23132ca991f0$export$43cfff342e1dcc87);
const $49ba23132ca991f0$export$21475b90a48a2c95 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.rename-board.success`,
            data: {}
        });
const $49ba23132ca991f0$export$244d02fac7e80a83 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.rename-board.failure`,
            data: {}
        });
const $49ba23132ca991f0$export$43cfff342e1dcc87 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.rename-board.request`,
            data: {}
        });

});

parcelRegister("ccYou", function(module, exports) {

$parcel$export(module.exports, "columnRankRequest", () => $4ccbfd59385b6fff$export$52f00a5a5ec3dade);
$parcel$export(module.exports, "columnRankSuccess", () => $4ccbfd59385b6fff$export$2011044b8a484462);
$parcel$export(module.exports, "columnRankFailure", () => $4ccbfd59385b6fff$export$8c4ab2c0d8c0dc47);
$parcel$export(module.exports, "columnRenameRequest", () => $4ccbfd59385b6fff$export$26259738ac7d398);
$parcel$export(module.exports, "columnRenameSuccess", () => $4ccbfd59385b6fff$export$e91d130c91c717f8);
$parcel$export(module.exports, "columnRenameFailure", () => $4ccbfd59385b6fff$export$519e7ffdc12c083f);
$parcel$export(module.exports, "columnCreateRequest", () => $4ccbfd59385b6fff$export$e17a54aca50f971e);
$parcel$export(module.exports, "columnCreateSuccess", () => $4ccbfd59385b6fff$export$4d3e535c643e516d);
$parcel$export(module.exports, "columnCreateFailure", () => $4ccbfd59385b6fff$export$7a6298113a6c73fb);
$parcel$export(module.exports, "columnDelete", () => $4ccbfd59385b6fff$export$6897d9588103ae0);
$parcel$export(module.exports, "columnDeleteRequest", () => $4ccbfd59385b6fff$export$2d450a2a2ff1d73c);
$parcel$export(module.exports, "columnDeleteSuccess", () => $4ccbfd59385b6fff$export$a2524e4771fdebc1);
$parcel$export(module.exports, "columnDeleteFailure", () => $4ccbfd59385b6fff$export$d12468113e6a687f);
$parcel$export(module.exports, "columnOpenLimitsModal", () => $4ccbfd59385b6fff$export$7db64843dc1f34b6);
$parcel$export(module.exports, "columnCloseLimitsModal", () => $4ccbfd59385b6fff$export$5eb828385c591dbf);
$parcel$export(module.exports, "columnSetLimitsRequest", () => $4ccbfd59385b6fff$export$426784419a12c1b5);
$parcel$export(module.exports, "columnSetLimitsSuccess", () => $4ccbfd59385b6fff$export$c9f0c15978432dec);
$parcel$export(module.exports, "columnSetLimitsFailure", () => $4ccbfd59385b6fff$export$3b783b9b2a0ab085);
$parcel$export(module.exports, "columnBustStatus", () => $4ccbfd59385b6fff$export$9c3af719b5697422);

var $8zOmE = parcelRequire("8zOmE");

var $esu6n = parcelRequire("esu6n");

var $9eeht = parcelRequire("9eeht");

var $71oFY = parcelRequire("71oFY");

var $fyeGd = parcelRequire("fyeGd");

var $5mTgl = parcelRequire("5mTgl");

var $8ECQ2 = parcelRequire("8ECQ2");
const $4ccbfd59385b6fff$export$52f00a5a5ec3dade = (eventPrefix)=>(preState, state, action)=>{
        const { columnId: columnId } = action.payload;
        const { isInitial: isInitial, isDone: isDone } = (0, $fyeGd.columnStatusMappingSelector)(state)[columnId];
        return {
            name: `${eventPrefix}.column.rank`,
            data: {
                startIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(preState, columnId)),
                endIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, columnId)),
                hasInitialStatus: isInitial,
                isResolutionDone: isDone
            }
        };
    };
const $4ccbfd59385b6fff$export$2011044b8a484462 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.column.rank.success`,
            data: {}
        });
const $4ccbfd59385b6fff$export$8c4ab2c0d8c0dc47 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.column.rank.failure`,
            data: {}
        });
const $4ccbfd59385b6fff$export$26259738ac7d398 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column-header.edit.request`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId)),
                transactionId: action.meta.optimistic.id
            }
        });
const $4ccbfd59385b6fff$export$e91d130c91c717f8 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column-header.edit.success`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId)),
                transactionId: action.meta.optimistic.id
            }
        });
const $4ccbfd59385b6fff$export$519e7ffdc12c083f = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column-header.edit.failure`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId)),
                transactionId: action.meta.optimistic.id
            }
        });
const $4ccbfd59385b6fff$export$e17a54aca50f971e = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column.add`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.temporaryColumnId))
            }
        });
const $4ccbfd59385b6fff$export$4d3e535c643e516d = (eventPrefix)=>(preState, state, action)=>{
        const { payload: { column: { id: id } }, meta: { analyticsEvent: analyticsEvent } } = action;
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'column created', {
            columnId: id
        });
        return {
            name: `${eventPrefix}.column.add.success`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.temporaryColumnId))
            }
        };
    };
const $4ccbfd59385b6fff$export$7a6298113a6c73fb = (eventPrefix)=>(preState, state, action)=>{
        const { error: error, meta: { analyticsEvent: analyticsEvent } } = action;
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'column createFailed', {
            errorMessage: error
        });
        return {
            name: `${eventPrefix}.column.add.failure`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.temporaryColumnId))
            }
        };
    };
const $4ccbfd59385b6fff$export$6897d9588103ae0 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column.delete`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId)),
                hasIssues: action.payload.hasIssues,
                hasIssuesNotOnBoard: action.payload.hasIssuesNotOnBoard
            }
        });
const $4ccbfd59385b6fff$export$2d450a2a2ff1d73c = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column.delete.request`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId))
            }
        });
const $4ccbfd59385b6fff$export$a2524e4771fdebc1 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column.delete.success`,
            data: {
                columnIndexes: action.payload.columns.map((column)=>(0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, column.id)))
            }
        });
const $4ccbfd59385b6fff$export$d12468113e6a687f = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column.delete.failure`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId))
            }
        });
const $4ccbfd59385b6fff$export$7db64843dc1f34b6 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column.limits.dialog.open`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId))
            }
        });
const $4ccbfd59385b6fff$export$5eb828385c591dbf = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column.limits.dialog.close`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId))
            }
        });
const $4ccbfd59385b6fff$export$426784419a12c1b5 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column.limits.set.request`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId)),
                maxIssueCount: action.payload.maxIssueCount,
                minIssueCount: action.payload.minIssueCount,
                transactionId: action.meta.optimistic.id
            }
        });
const $4ccbfd59385b6fff$export$c9f0c15978432dec = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column.limits.set.success`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId)),
                transactionId: action.meta.optimistic.id
            }
        });
const $4ccbfd59385b6fff$export$3b783b9b2a0ab085 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column.limits.set.failure`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId)),
                transactionId: action.meta.optimistic.id
            }
        });
const $4ccbfd59385b6fff$var$getColumnBustedEvent = (eventName, checkState, payloadState, columnId)=>(0, $5mTgl.getColumnTheme)(checkState, columnId) !== 'default' ? {
        name: eventName,
        data: {
            columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(payloadState, columnId)),
            maxIssueCount: (0, $esu6n.getStatusColumn)((0, $fyeGd.getColumnById)(payloadState, columnId))?.maxIssueCount,
            issueCount: (0, $5mTgl.getColumnTotalIssuesCount)(payloadState, columnId)
        }
    } : null;
const $4ccbfd59385b6fff$export$9c3af719b5697422 = (eventPrefix)=>(preState, state, action)=>{
        const bustedEventName = `${eventPrefix}.column.limits.busted`;
        const unbustedEventName = `${eventPrefix}.column.limits.unbusted`;
        if (action.type === (0, $71oFY.ISSUE_RANK_TRANSITION_REQUEST)) {
            const { payload: { destinationColumnId: destinationColumnId, sourceColumnId: sourceColumnId } } = action;
            return $4ccbfd59385b6fff$var$getColumnBustedEvent(bustedEventName, state, state, destinationColumnId) || $4ccbfd59385b6fff$var$getColumnBustedEvent(unbustedEventName, preState, state, sourceColumnId) || null;
        }
        if (action.type === (0, $9eeht.COLUMN_SET_LIMITS_REQUEST)) {
            const { payload: { columnId: columnId } } = action;
            return $4ccbfd59385b6fff$var$getColumnBustedEvent(bustedEventName, state, state, columnId) || $4ccbfd59385b6fff$var$getColumnBustedEvent(unbustedEventName, preState, state, columnId) || null;
        }
        return null;
    };

});
parcelRegister("8ECQ2", function(module, exports) {

$parcel$export(module.exports, "toOneBasedIndex", () => $1d31b46bd10c4912$export$7b5012c669f99025);
const $1d31b46bd10c4912$export$7b5012c669f99025 = (index)=>index + 1;
const $1d31b46bd10c4912$export$7cc93f0f60c50950 = (indexes)=>indexes.map($1d31b46bd10c4912$export$7b5012c669f99025);

});


parcelRegister("kVgZQ", function(module, exports) {

$parcel$export(module.exports, "columnRankRequestPerformance", () => $885dae14e264453f$export$d837df4151f4ad93);
$parcel$export(module.exports, "columnRankSuccessPerformance", () => $885dae14e264453f$export$9a2c8aae5b38c5a0);
$parcel$export(module.exports, "columnRenameRequestPerformance", () => $885dae14e264453f$export$814d029099d0e639);
$parcel$export(module.exports, "columnRenameSuccessPerformance", () => $885dae14e264453f$export$8da4a68fc37a7a04);
$parcel$export(module.exports, "columnCreateRequestPerformance", () => $885dae14e264453f$export$4be72e44b849cf1b);
$parcel$export(module.exports, "columnCreateSuccessPerformance", () => $885dae14e264453f$export$9dd5fbdc332952a1);
$parcel$export(module.exports, "columnDeleteRequestPerformance", () => $885dae14e264453f$export$43717ed5e4b52002);
$parcel$export(module.exports, "columnDeleteSuccessPerformance", () => $885dae14e264453f$export$dc19c78b5b2c0920);
$parcel$export(module.exports, "columnLimitRequestPerformance", () => $885dae14e264453f$export$5adc931e85a4c8d);
$parcel$export(module.exports, "columnLimitSuccessPerformance", () => $885dae14e264453f$export$d7542d74bd8f75b6);

var $CFxE9 = parcelRequire("CFxE9");
const $885dae14e264453f$export$d837df4151f4ad93 = ()=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $CFxE9.columnRankInteraction)(concurrentId).start();
        return null;
    };
const $885dae14e264453f$export$9a2c8aae5b38c5a0 = ()=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $CFxE9.columnRankInteraction)(concurrentId).stop();
        return null;
    };
const $885dae14e264453f$export$814d029099d0e639 = ()=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $CFxE9.columnRenameInteraction)(concurrentId).start();
        return null;
    };
const $885dae14e264453f$export$8da4a68fc37a7a04 = ()=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $CFxE9.columnRenameInteraction)(concurrentId).stop();
        return null;
    };
const $885dae14e264453f$export$4be72e44b849cf1b = ()=>(preState, state, action)=>{
        const concurrentId = String(action.payload.temporaryColumnId);
        (0, $CFxE9.columnCreateInteraction)(concurrentId).start();
        return null;
    };
const $885dae14e264453f$export$9dd5fbdc332952a1 = ()=>(preState, state, action)=>{
        const concurrentId = String(action.payload.temporaryColumnId);
        (0, $CFxE9.columnCreateInteraction)(concurrentId).stop();
        return null;
    };
const $885dae14e264453f$export$43717ed5e4b52002 = ()=>(preState, state, action)=>{
        const concurrentId = String(action.meta.optimistic.id);
        (0, $CFxE9.columnDeleteInteraction)(concurrentId).start();
        return null;
    };
const $885dae14e264453f$export$dc19c78b5b2c0920 = ()=>(preState, state, action)=>{
        const concurrentId = String(action.meta.optimistic.id);
        (0, $CFxE9.columnDeleteInteraction)(concurrentId).stop();
        return null;
    };
const $885dae14e264453f$export$5adc931e85a4c8d = ()=>()=>{
        (0, $CFxE9.columnSetLimitInteraction).start();
        return null;
    };
const $885dae14e264453f$export$d7542d74bd8f75b6 = ()=>()=>{
        (0, $CFxE9.columnSetLimitInteraction).stop();
        return null;
    };

});

parcelRegister("anKCl", function(module, exports) {

$parcel$export(module.exports, "setCustomFiltersPerformance", () => $d03e6a22240c3a0e$export$a4497c4897069a2b);
$parcel$export(module.exports, "setCustomFiltersFailure", () => $d03e6a22240c3a0e$export$b6336fdfea9c7130);
$parcel$export(module.exports, "setCustomFiltersSuccess", () => $d03e6a22240c3a0e$export$807bc3d6fd05a3f8);
$parcel$export(module.exports, "setCustomFiltersRefilterSuccess", () => $d03e6a22240c3a0e$export$be433321d98a3ffa);
$parcel$export(module.exports, "setCustomFiltersRefilterFailure", () => $d03e6a22240c3a0e$export$d76e8115781031ba);

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");

var $fjcgS = parcelRequire("fjcgS");

var $4G04L = parcelRequire("4G04L");

var $gNaDq = parcelRequire("gNaDq");

var $67Z81 = parcelRequire("67Z81");
const $d03e6a22240c3a0e$export$a4497c4897069a2b = ()=>(preState, state, action)=>{
        const { meta: { numCustomFiltersApplied: numCustomFiltersApplied, numIssueIds: numIssueIds } } = action;
        const isCompanyManaged = (0, $67Z81.getIsCMPBoard)(state);
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $gNaDq.stopCustomFilterInteraction)(numCustomFiltersApplied, numIssueIds, isCompanyManaged);
        });
        return null;
    };
const $d03e6a22240c3a0e$export$b6336fdfea9c7130 = ()=>(preState, state, action)=>{
        const { payload: { error: error }, meta: { analyticsEvent: analyticsEvent } } = action;
        if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'customFilters failed', {
            isClientFetchError: (0, $fZneA.isClientFetchError)(error),
            errorMessage: error?.message
        });
        (0, $gNaDq.cancelCustomFilterInteraction)();
        return null;
    };
const $d03e6a22240c3a0e$export$807bc3d6fd05a3f8 = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent, numCustomFiltersApplied: numCustomFiltersApplied, numIssueIds: numIssueIds } } = action;
        if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'customFilters applied', {
            numCustomFiltersApplied: numCustomFiltersApplied,
            numIssueIds: numIssueIds
        });
        return null;
    };
const $d03e6a22240c3a0e$export$be433321d98a3ffa = ()=>(preState, state, action)=>{
        const { excludedCardIds: excludedCardIds, filteredCardIds: filteredCardIds } = action.payload;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'boardScreen',
                actionSubject: 'customFiltersRefilter',
                action: 'applied',
                attributes: {
                    excludedCards: excludedCardIds.length,
                    filteredCards: filteredCardIds.length
                }
            };
            client.getInstance().sendTrackEvent(payload);
        });
        return null;
    };
const $d03e6a22240c3a0e$export$d76e8115781031ba = ()=>(preState, state, action)=>{
        const { error: error } = action.payload;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'boardScreen',
                actionSubject: 'customFiltersRefilter',
                action: 'failed',
                attributes: {
                    isClientFetchError: (0, $fZneA.isClientFetchError)(error),
                    errorMessage: error?.message
                }
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        return null;
    };

});
parcelRegister("gNaDq", function(module, exports) {

$parcel$export(module.exports, "setCustomFilterInteractionFeedbackMark", () => $c297c1d837604846$export$5dd87a22b8e2c81c);
$parcel$export(module.exports, "setCustomFilterInteractionStartMark", () => $c297c1d837604846$export$600569a4fb9e5675);
$parcel$export(module.exports, "cancelCustomFilterInteraction", () => $c297c1d837604846$export$178f6b8399be6909);
$parcel$export(module.exports, "stopCustomFilterInteraction", () => $c297c1d837604846$export$90db63ac5c02197a);

var $k12ix = parcelRequire("k12ix");

var $hz3OZ = parcelRequire("hz3OZ");
const $c297c1d837604846$export$5dd87a22b8e2c81c = ()=>{
    (0, $hz3OZ.customFilterInteraction).mark('feedback');
};
const $c297c1d837604846$export$600569a4fb9e5675 = ()=>{
    (0, $hz3OZ.customFilterInteraction).start();
};
const $c297c1d837604846$export$178f6b8399be6909 = ()=>{
    (0, $hz3OZ.customFilterInteraction).cancel();
};
const $c297c1d837604846$export$90db63ac5c02197a = (numCustomFiltersApplied, numIssueIds, isCompanyManaged)=>{
    (0, $hz3OZ.customFilterInteraction).stop({
        customData: {
            ...(0, $k12ix.getNormalisedPerformanceFFs)(),
            numCustomFiltersApplied: numCustomFiltersApplied,
            numIssueIds: numIssueIds,
            isCompanyManaged: isCompanyManaged
        }
    });
};

});


parcelRegister("a8X4R", function(module, exports) {

$parcel$export(module.exports, "filterPanelMounted", () => $a46544a5d194c56f$export$c48d1dabfffb8ec0);
$parcel$export(module.exports, "searchFocus", () => $a46544a5d194c56f$export$556a5ff7bd7ac86);
$parcel$export(module.exports, "clearAllFiltersClicked", () => $a46544a5d194c56f$export$5845d1911d8d06dd);
$parcel$export(module.exports, "setAllFilters", () => $a46544a5d194c56f$export$1e6b2e9f0ff84131);
$parcel$export(module.exports, "setAllFiltersPerformance", () => $a46544a5d194c56f$export$338d2cd01a36c93d);

var $9XE6b = parcelRequire("9XE6b");

var $k12ix = parcelRequire("k12ix");

var $4G04L = parcelRequire("4G04L");



var $hz3OZ = parcelRequire("hz3OZ");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");
const $a46544a5d194c56f$export$c48d1dabfffb8ec0 = (eventPrefix)=>(preState, state)=>{
        const totalAssigneeCount = (0, $5mTgl.orderedWorkAssigneesByAccountIdSelector)(state).length;
        return {
            name: `${eventPrefix}.filters.show`,
            data: {
                numAvatarsDisplayed: totalAssigneeCount > (0, $7e733a5d4e4331fc$export$360e7ca29749d455) ? (0, $7e733a5d4e4331fc$export$360e7ca29749d455) : totalAssigneeCount
            }
        };
    };
const $a46544a5d194c56f$export$556a5ff7bd7ac86 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.filters.search-field.focus`,
            data: {}
        });
const $a46544a5d194c56f$export$5845d1911d8d06dd = (eventPrefix)=>(preState)=>{
        const selectedFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $5mTgl.getWorkFilters)(preState), [
            'values'
        ]);
        return {
            name: `${eventPrefix}.filters.clear-button.click`,
            data: {
                numSelectedAvatars: (selectedFilters[0, $dcff40112356dfc1$export$f8f7545d2bb78afb] || []).length
            }
        };
    };
const $a46544a5d194c56f$var$getFilterAnalyticsData = (state)=>{
    const filters = (0, $5mTgl.getWorkFilters)(state).values;
    const assigneeFilters = filters[0, $dcff40112356dfc1$export$f8f7545d2bb78afb] || [];
    const labelFilters = filters[0, $dcff40112356dfc1$export$37aee82a3cb1e8f7] || [];
    const issueParentFilters = filters[0, $dcff40112356dfc1$export$2a4f270075a033de] || [];
    const issueTypeFilters = filters[0, $dcff40112356dfc1$export$ebb48b08205007c5] || [];
    const sprintFilters = filters[0, $dcff40112356dfc1$export$a316570a0dbfd2b0] || [];
    return {
        numSelectedAvatars: assigneeFilters.length,
        isAssignedToMeSelected: assigneeFilters.indexOf((0, $67Z81.currentUserAccountIdSelector)(state)) > -1,
        numSelectedLabels: labelFilters.length,
        numVisibleIssues: (0, $5mTgl.workFilteredIssuesSelector)(state).length,
        numSelectedIssueParents: issueParentFilters.length,
        numSelectedIssueTypes: issueTypeFilters.length,
        numSelectedSprints: sprintFilters.length
    };
};
const $a46544a5d194c56f$export$1e6b2e9f0ff84131 = (eventPrefix)=>(preState, state, action)=>{
        const { filterType: filterType } = action.meta;
        if (filterType) {
            let actionName = 'select';
            const filters = (0, $5mTgl.getWorkFilters)(state).values;
            if (filterType === (0, $dcff40112356dfc1$export$d597759d33be802e) && !filters[0, $dcff40112356dfc1$export$d597759d33be802e]) actionName = 'deselect';
            else {
                const preFilters = (0, $5mTgl.getWorkFilters)(preState).values;
                actionName = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
                    filterType
                ], []).length < (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(preFilters, [
                    filterType
                ], []).length ? 'deselect' : actionName;
            }
            return {
                name: `${eventPrefix}.filters.${filterType}.${actionName}`,
                data: $a46544a5d194c56f$var$getFilterAnalyticsData(state)
            };
        }
        return null;
    };
const $a46544a5d194c56f$export$338d2cd01a36c93d = ()=>()=>{
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $hz3OZ.filterInteraction).stop({
                customData: (0, $k12ix.getNormalisedPerformanceFFs)()
            });
        });
        return null;
    };

});

parcelRegister("dOmSg", function(module, exports) {

$parcel$export(module.exports, "flagDismissed", () => $efad231c4bf847fc$export$1dd1bd800908fb39);
$parcel$export(module.exports, "flagCreatedIssueIsFiltered", () => $efad231c4bf847fc$export$a5b2adda95b0f64);
$parcel$export(module.exports, "flagIssueCreateFilteredV2", () => $efad231c4bf847fc$export$979d979cc98fe9a4);
$parcel$export(module.exports, "flagIssueCreateMovedBetweenJqlSwimlanes", () => $efad231c4bf847fc$export$45aa6b129599aaa1);

var $9XE6b = parcelRequire("9XE6b");

var $fjcgS = parcelRequire("fjcgS");


var $bkCF5 = parcelRequire("bkCF5");

var $8yiLS = parcelRequire("8yiLS");

var $9UXXB = parcelRequire("9UXXB");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");
const $efad231c4bf847fc$export$1dd1bd800908fb39 = (eventPrefix)=>(preState, state, action)=>{
        const flag = action.payload;
        if (flag.id === (0, $bkCF5.FLAG_CREATED_ISSUE_IS_FILTERED)) {
            const issueId = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(flag, [
                'context',
                'issueId'
            ]);
            return {
                name: `${eventPrefix}.filter.flag.new-issue-filtered.dismissed`,
                data: {
                    issueId: issueId
                }
            };
        }
        // Don't fire analytic events when any other kind of flag is dismissed
        return null;
    };
const $efad231c4bf847fc$export$a5b2adda95b0f64 = (eventPrefix)=>(preState, state, action)=>{
        const issue = action.payload;
        const filterValues = (0, $5mTgl.getWorkFilters)(state).values;
        // There is only ever at most 1 text filter
        const textFilter = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $dcff40112356dfc1$export$d597759d33be802e),
            'length'
        ], 0) > 0;
        const numAssigneeFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $dcff40112356dfc1$export$f8f7545d2bb78afb),
            'length'
        ], 0);
        const numLabelFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $dcff40112356dfc1$export$37aee82a3cb1e8f7),
            'length'
        ], 0);
        return {
            name: `${eventPrefix}.filter.flag.new-issue-filtered.shown`,
            data: {
                issueId: issue.id,
                textFilter: textFilter,
                numAssigneeFilters: numAssigneeFilters,
                numLabelFilters: numLabelFilters
            }
        };
    };
const $efad231c4bf847fc$export$979d979cc98fe9a4 = (eventPrefix)=>(preState, state, action)=>{
        const issueKeys = action.payload.cardKeys;
        const filterValues = (0, $5mTgl.getWorkFilters)(state).values;
        if (action.payload.filteredOnServer) {
            const isCustomBoardWithIcc = (0, $9UXXB.getIsCustomBoardWithIcc)(state);
            const hasCustomFilters = (0, $8yiLS.isCustomFiltersActive)(state);
            const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
            (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
                const payload = {
                    action: 'filteredOnServer',
                    actionSubject: 'newIssues',
                    source: 'boardScreen',
                    attributes: {
                        isCustomBoardWithIcc: isCustomBoardWithIcc,
                        hasCustomFilters: hasCustomFilters,
                        swimlaneMode: swimlaneMode
                    }
                };
                client.getInstance().sendTrackEvent(payload);
            });
            return null;
        }
        // There is only ever at most 1 text filter
        const textFilter = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $dcff40112356dfc1$export$d597759d33be802e),
            'length'
        ], 0) > 0;
        const numAssigneeFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $dcff40112356dfc1$export$f8f7545d2bb78afb),
            'length'
        ], 0);
        const numLabelFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $dcff40112356dfc1$export$37aee82a3cb1e8f7),
            'length'
        ], 0);
        return {
            name: `${eventPrefix}.filter.flag.new-issue-filtered.shown`,
            data: {
                issueKeys: issueKeys,
                textFilter: textFilter,
                numAssigneeFilters: numAssigneeFilters,
                numLabelFilters: numLabelFilters
            }
        };
    };
const $efad231c4bf847fc$export$45aa6b129599aaa1 = ()=>(preState, state)=>{
        const isCustomBoardWithIcc = (0, $9UXXB.getIsCustomBoardWithIcc)(state);
        const hasCustomFilters = (0, $8yiLS.isCustomFiltersActive)(state);
        const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                action: 'movedBetweenSwimlanes',
                actionSubject: 'newIssues',
                source: 'boardScreen',
                attributes: {
                    isCustomBoardWithIcc: isCustomBoardWithIcc,
                    hasCustomFilters: hasCustomFilters,
                    swimlaneMode: swimlaneMode
                }
            };
            client.getInstance().sendTrackEvent(payload);
        });
        return null;
    };

});

parcelRegister("7PXr3", function(module, exports) {

$parcel$export(module.exports, "issueViewOpenPerformance", () => $150727174c17eda7$export$2da4dabf4eeee402);

var $eTXmK = parcelRequire("eTXmK");

var $hz3OZ = parcelRequire("hz3OZ");
const $150727174c17eda7$export$2da4dabf4eeee402 = ()=>(prevState, state, action)=>{
        if (!action.payload.withCmd && !action.payload.withShift) {
            (0, $eTXmK.default)('board.issue-view-opened');
            (0, $hz3OZ.issueViewOpenInteraction).start();
        }
        return null;
    };

});

parcelRegister("6KwKW", function(module, exports) {

$parcel$export(module.exports, "openIssueCreate", () => $8d4d6905372db5ee$export$c235e9bafca0cdee);
$parcel$export(module.exports, "doneIssuesButtonClick", () => $8d4d6905372db5ee$export$fdc4a4b0f77c4bc1);
$parcel$export(module.exports, "issueCreateRequest", () => $8d4d6905372db5ee$export$735389bea7eedaad);
$parcel$export(module.exports, "issueCreateSuccess", () => $8d4d6905372db5ee$export$359b420f9850fc61);
$parcel$export(module.exports, "issueCreateFailure", () => $8d4d6905372db5ee$export$d2f4535c9fcca3f3);
$parcel$export(module.exports, "issueDeleteSuccess", () => $8d4d6905372db5ee$export$bcb7ef15796f58b0);
$parcel$export(module.exports, "issueDeleteFailure", () => $8d4d6905372db5ee$export$3d3a8d020fe32306);
$parcel$export(module.exports, "issueRankTransitionRequest", () => $8d4d6905372db5ee$export$2ad8924ae4613236);
$parcel$export(module.exports, "issueRankTransitionSuccess", () => $8d4d6905372db5ee$export$fc64d70c84553912);
$parcel$export(module.exports, "issueRankTransitionFailure", () => $8d4d6905372db5ee$export$ade8b8e0a05059d7);
$parcel$export(module.exports, "issueLabelsAmount", () => $8d4d6905372db5ee$export$2653a763eb1e7ed2);
$parcel$export(module.exports, "devStatusLoadSuccess", () => $8d4d6905372db5ee$export$d5dceae9c7c7bc77);
$parcel$export(module.exports, "issueChangeSwimlane", () => $8d4d6905372db5ee$export$b1b86dea7a51e7b5);
$parcel$export(module.exports, "issueMoveToBacklogRequest", () => $8d4d6905372db5ee$export$1c79b09f3075e4ea);
$parcel$export(module.exports, "issueMoveToBacklogSuccess", () => $8d4d6905372db5ee$export$5a53dd39dd4e0e24);
$parcel$export(module.exports, "issueMoveToBacklogFailure", () => $8d4d6905372db5ee$export$a9d1ce754cbce39);

var $hm7zS = parcelRequire("hm7zS");

var $9XE6b = parcelRequire("9XE6b");

var $iThRn = parcelRequire("iThRn");

var $h4EJ8 = parcelRequire("h4EJ8");

var $k12ix = parcelRequire("k12ix");

var $fZneA = parcelRequire("fZneA");

var $f2NGE = parcelRequire("f2NGE");

var $8zOmE = parcelRequire("8zOmE");

var $g5X3G = parcelRequire("g5X3G");

var $3eGwD = parcelRequire("3eGwD");

var $01j5n = parcelRequire("01j5n");

var $3vXOY = parcelRequire("3vXOY");

var $iUagi = parcelRequire("iUagi");


var $iuuJH = parcelRequire("iuuJH");

var $5yzdy = parcelRequire("5yzdy");

var $hz3OZ = parcelRequire("hz3OZ");

var $fyeGd = parcelRequire("fyeGd");

var $9UXXB = parcelRequire("9UXXB");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $5mTgl = parcelRequire("5mTgl");

var $8ECQ2 = parcelRequire("8ECQ2");
const $8d4d6905372db5ee$export$d516175c274e4e4b = (state, issueId)=>{
    const issue = (0, $d2i8f.getIssueById)(state, issueId);
    return {
        actionSubjectId: issueId,
        objectType: 'issue',
        objectId: issueId,
        issueTypeId: issue.typeId,
        issueTypeLevel: (0, $d2i8f.getIssueTypeLevelForBoardIssue)(state)(issueId)
    };
};
const $8d4d6905372db5ee$var$getIssueTrackEventAttributes = (state, issueId, updatedItems)=>{
    const issue = (0, $d2i8f.getIssueById)(state, issueId);
    return {
        updatedItems: updatedItems,
        issueTypeId: issue.typeId,
        issueTypeLevel: (0, $d2i8f.getIssueTypeLevelForBoardIssue)(state)(issueId),
        devInfoActivityState: issue.devStatus?.activity
    };
};
const $8d4d6905372db5ee$export$c235e9bafca0cdee = (eventPrefix)=>(preState, state, action)=>{
        const issue = (0, $d2i8f.getIssueByKey)(state, action.payload.issueKey);
        if (issue) return {
            name: `${eventPrefix}.issue.view`,
            data: {
                issueId: issue.id,
                viewMode: (0, $3eGwD.getBoardDetailViewMode)()
            }
        };
        return null;
    };
const $8d4d6905372db5ee$export$fdc4a4b0f77c4bc1 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.looking.for.old.issues.to.pin`,
            data: {}
        });
const $8d4d6905372db5ee$export$735389bea7eedaad = (eventPrefix)=>(preState, state, action)=>{
        const hasSwimlanes = (0, $45cXl.getSwimlaneMode)(preState) !== (0, $iuuJH.NO_SWIMLANE).id;
        return {
            name: `${eventPrefix}.issue.create.request`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)(action.meta.columnIndex),
                cardIndex: (0, $8ECQ2.toOneBasedIndex)(action.meta.cardIndex),
                transactionId: action.meta.optimistic.id,
                hasSwimlanes: hasSwimlanes,
                numSwimlanes: hasSwimlanes ? (0, $4jZ56.getSwimlanes)(preState).length : 0,
                inDefaultSwimlane: (0, $4jZ56.isInDefaultSwimlane)(preState)(action.meta.swimlaneId)
            }
        };
    };
const $8d4d6905372db5ee$export$359b420f9850fc61 = (eventPrefix)=>(preState, state, action)=>{
        // GET THE SESSION ID & EVERYTHING ELSE HERE.
        const { payload: { issues: issues }, meta: { columnIndex: columnIndex, cardIndex: cardIndex, optimistic: optimistic, analyticsEvent: analyticsEvent } } = action;
        /* session id set in useOnCreate to avoid update for autoOpenedICC - if undefined use from state */ const { sessionId: sessionId } = analyticsEvent.payload;
        const filterValues = (0, $5mTgl.getWorkFilters)(state).values;
        const trackEvents = [];
        issues.forEach((issue)=>{
            const clonedEvent = analyticsEvent.clone();
            if (clonedEvent) {
                /** Have to cast the state here as it is an optimistic state at this point in time. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const sessionIdFromState = state.entities.current?.inlineCreate?.sessionId;
                let improvedAnalyticsAttributes = {};
                if (sessionId !== undefined || sessionIdFromState !== undefined) {
                    // Fields inputted by the user
                    const issueCreateFieldsUsed = [
                        {
                            gqlType: 'JiraSingleLineTextField',
                            issueFieldId: 'summary',
                            issueFieldType: 'summary',
                            isPopulated: true
                        }
                    ];
                    // Fields that can be populated automatically e.g. by filters, swimlanes
                    const fieldsPopulated = {
                        ASSIGNEE: !!issue.assigneeAccountId,
                        PARENT: !!issue.parentId,
                        PRIORITY: !!issue.priority,
                        SPRINT: !!issue.sprintId,
                        FIX_VERSIONS: (0, $f2NGE.getFieldLengthForAnalytics)(issue.fixVersions?.length),
                        LABELS: (0, $f2NGE.getFieldLengthForAnalytics)(issue.labels?.length),
                        STATUS_CATEGORY: (0, $fyeGd.getStatusCategoryByStatusInColumnId)(state)(issue.columnId, issue.statusId)
                    };
                    improvedAnalyticsAttributes = {
                        sessionId: sessionId || sessionIdFromState,
                        issueCreateFieldsUsed: issueCreateFieldsUsed,
                        boardType: (0, $67Z81.getBoardTypeForAnalytics)(state),
                        fieldsPopulated: fieldsPopulated,
                        isAnyStatusInCreateEnabled: (0, $5mTgl.getIsAnyStatusInCreateEnabled)(state) !== false
                    };
                }
                trackEvents.push(clonedEvent.update({
                    ...$8d4d6905372db5ee$export$d516175c274e4e4b(state, issue.id),
                    appliedFilters: Object.keys(filterValues),
                    ...improvedAnalyticsAttributes,
                    isCustomBoardWithIcc: (0, $9UXXB.getIsCustomBoardWithIcc)(state),
                    swimlaneMode: (0, $45cXl.getSwimlaneMode)(state)
                }));
            }
        });
        const swimlanes = (0, $45cXl.getSwimlaneMode)(state) || (0, $iuuJH.NO_SWIMLANE).id;
        // There is only ever at most 1 text filter
        const textFilter = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $dcff40112356dfc1$export$d597759d33be802e),
            'length'
        ], 0) > 0;
        const numAssigneeFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $dcff40112356dfc1$export$f8f7545d2bb78afb),
            'length'
        ], 0);
        const numLabelFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $dcff40112356dfc1$export$37aee82a3cb1e8f7),
            'length'
        ], 0);
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'ui taskSuccess', {
            task: 'createIssue'
        });
        return {
            name: `${eventPrefix}.issue.create.success`,
            data: {
                issueId: issues[0].id,
                numIssues: issues.length,
                columnIndex: (0, $8ECQ2.toOneBasedIndex)(columnIndex),
                cardIndex: (0, $8ECQ2.toOneBasedIndex)(cardIndex),
                transactionId: optimistic.id,
                swimlanes: swimlanes,
                textFilter: textFilter,
                numAssigneeFilters: numAssigneeFilters,
                numLabelFilters: numLabelFilters
            },
            trackEvents: trackEvents
        };
    };
const $8d4d6905372db5ee$export$d2f4535c9fcca3f3 = (eventPrefix)=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent, error: error } } = action;
        const statusCode = error ? (0, $3vXOY.extractStatusCode)(error) : 200;
        if (analyticsEvent) {
            const sloResultType = error && ((0, $fZneA.isClientFetchError)(error) || (0, $01j5n.isUserNetworkError)(error)) ? 'taskAbort' : 'taskFail';
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `ui ${sloResultType}`, {
                task: 'createIssue',
                statusCode: statusCode,
                isClassic: (0, $67Z81.getIsCMPBoard)(state),
                synthetic: (0, $iUagi.isSyntheticTenant)(),
                errorMessage: error?.message ? (0, (/*@__PURE__*/$parcel$interopDefault($h4EJ8)))(error.message, {
                    length: 140
                }) : ''
            });
        }
        return {
            name: `${eventPrefix}.issue.create.failure`,
            data: {
                transactionId: action.meta.optimistic.id
            }
        };
    };
const $8d4d6905372db5ee$export$bcb7ef15796f58b0 = (eventPrefix)=>(preState, state, action)=>{
        const concurrentId = String(action.meta.optimistic.id);
        (0, $hz3OZ.issueDeleteInteraction)(concurrentId).stop({
            customData: {
                ...(0, $k12ix.getNormalisedPerformanceFFs)(),
                ...(0, $5yzdy.getBoardExtraData)(state)
            }
        });
        return {
            name: `${eventPrefix}.issue.delete.success`,
            data: {
                issueId: action.payload.issueId
            }
        };
    };
const $8d4d6905372db5ee$export$3d3a8d020fe32306 = (eventPrefix)=>(preState, state, action)=>{
        const concurrentId = String(action.meta.optimistic.id);
        (0, $hz3OZ.issueDeleteInteraction)(concurrentId).cancel();
        return {
            name: `${eventPrefix}.issue.delete.failure`,
            data: {
                issueId: action.payload.issueId
            }
        };
    };
const $8d4d6905372db5ee$export$2ad8924ae4613236 = (eventPrefix)=>(preState, state, action)=>{
        const { issueIds: issueIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId } = action.payload;
        const beforeRankIssueIndex = (0, $d2i8f.getIssueIndex)(preState, action.payload.issueIds[0]);
        const afterRankIssueIndex = (0, $d2i8f.getIssueIndex)(state, action.payload.issueIds[0]);
        const sourceColumnIndex = (0, $fyeGd.getColumnIndex)(state, sourceColumnId);
        const destinationColumnIndex = (0, $fyeGd.getColumnIndex)(state, destinationColumnId);
        return {
            name: `${eventPrefix}.issue.move`,
            data: {
                numIssues: issueIds.length,
                oldIssueIndex: (0, $8ECQ2.toOneBasedIndex)(beforeRankIssueIndex),
                newRankIssueIndex: (0, $8ECQ2.toOneBasedIndex)(afterRankIssueIndex),
                oldColumnIndex: (0, $8ECQ2.toOneBasedIndex)(sourceColumnIndex),
                newColumnIndex: (0, $8ECQ2.toOneBasedIndex)(destinationColumnIndex),
                hasTransitioned: sourceColumnId !== destinationColumnId,
                transactionId: action.meta.optimistic?.id
            }
        };
    };
const $8d4d6905372db5ee$export$fc64d70c84553912 = (eventPrefix)=>(preState, state, action)=>{
        const { payload: { issueIds: issueIds }, meta: { analyticsEvent: analyticsEvent, optimistic: optimistic } } = action;
        const trackEvents = [];
        issueIds.forEach((issueId)=>(0, $8zOmE.fireTrackAnalytics)(// @ts-expect-error - Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'.
            analyticsEvent.clone(), 'issue updated', issueId.toString(), $8d4d6905372db5ee$var$getIssueTrackEventAttributes(state, issueId, analyticsEvent.payload.updatedItems)));
        return {
            name: `${eventPrefix}.issue.move.success`,
            data: {
                transactionId: optimistic.id
            },
            trackEvents: trackEvents
        };
    };
const $8d4d6905372db5ee$export$ade8b8e0a05059d7 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.issue.move.failure`,
            data: {
                transactionId: action.meta.optimistic.id
            }
        });
const $8d4d6905372db5ee$export$2653a763eb1e7ed2 = (eventPrefix)=>(preState, state)=>{
        const issuesByLabel = (0, (/*@__PURE__*/$parcel$interopDefault($hm7zS)))((0, $5mTgl.workIssuesSelector)(state), (issue)=>issue.labels.length > 10 ? 10 : issue.labels.length);
        const numIssues = (0, (/*@__PURE__*/$parcel$interopDefault($iThRn)))((0, $g5X3G.values)(issuesByLabel));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const issueLabelsFlatten = {};
        Array(11).fill(0).forEach((value, labelsCount)=>{
            const issuesCount = issuesByLabel[String(labelsCount)] || 0;
            const labelCountPropName = labelsCount > 9 ? '10AndMore' : String(labelsCount);
            issueLabelsFlatten[`numIssuesWith${labelCountPropName}Labels`] = issuesCount;
        });
        return {
            name: `${eventPrefix}.issue.labels`,
            data: {
                numIssues: numIssues,
                ...issueLabelsFlatten
            }
        };
    };
const $8d4d6905372db5ee$export$d5dceae9c7c7bc77 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.dev-status.load.success`,
            data: {
                statusCount: Object.keys(action.payload).length
            }
        });
const $8d4d6905372db5ee$export$b1b86dea7a51e7b5 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.issue.swimlane-change`
        });
const $8d4d6905372db5ee$export$1c79b09f3075e4ea = (eventPrefix)=>(preState, state, action)=>{
        const { issueIds: issueIds, columnId: columnId } = action.payload;
        const columnIndex = (0, $fyeGd.getColumnIndex)(state, columnId);
        return {
            name: `${eventPrefix}.issue.move-to-backlog.request`,
            data: {
                issueIds: issueIds,
                columnIndex: (0, $8ECQ2.toOneBasedIndex)(columnIndex)
            }
        };
    };
const $8d4d6905372db5ee$export$5a53dd39dd4e0e24 = (eventPrefix)=>(preState, state, action)=>{
        const { issueIds: issueIds, columnId: columnId } = action.payload;
        const columnIndex = (0, $fyeGd.getColumnIndex)(state, columnId);
        return {
            name: `${eventPrefix}.issue.move-to-backlog.success`,
            data: {
                issueIds: issueIds,
                columnIndex: (0, $8ECQ2.toOneBasedIndex)(columnIndex)
            }
        };
    };
const $8d4d6905372db5ee$export$a9d1ce754cbce39 = (eventPrefix)=>(preState, state, action)=>{
        const { issueIds: issueIds } = action.payload;
        return {
            name: `${eventPrefix}.issue.move-to-backlog.failure`,
            data: {
                issueIds: issueIds
            }
        };
    };

});
parcelRegister("iThRn", function(module, exports) {

var $gBzAF = parcelRequire("gBzAF");

var $etyzk = parcelRequire("etyzk");
/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */ function $dc0b37ac120f9bb6$var$sum(array) {
    return array && array.length ? $gBzAF(array, $etyzk) : 0;
}
module.exports = $dc0b37ac120f9bb6$var$sum;

});

parcelRegister("h4EJ8", function(module, exports) {

var $kHBB0 = parcelRequire("kHBB0");

var $gvFfr = parcelRequire("gvFfr");

var $axH2S = parcelRequire("axH2S");

var $k0qYG = parcelRequire("k0qYG");

var $cErmc = parcelRequire("cErmc");

var $ifYxh = parcelRequire("ifYxh");

var $jx6Tp = parcelRequire("jx6Tp");

var $kPZpS = parcelRequire("kPZpS");

var $jJVtR = parcelRequire("jJVtR");
/** Used as default options for `_.truncate`. */ var $c6e266ef199f8e9f$var$DEFAULT_TRUNC_LENGTH = 30, $c6e266ef199f8e9f$var$DEFAULT_TRUNC_OMISSION = '...';
/** Used to match `RegExp` flags from their coerced string values. */ var $c6e266ef199f8e9f$var$reFlags = /\w*$/;
/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */ function $c6e266ef199f8e9f$var$truncate(string, options) {
    var length = $c6e266ef199f8e9f$var$DEFAULT_TRUNC_LENGTH, omission = $c6e266ef199f8e9f$var$DEFAULT_TRUNC_OMISSION;
    if ($k0qYG(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? $kPZpS(options.length) : length;
        omission = 'omission' in options ? $kHBB0(options.omission) : omission;
    }
    string = $jJVtR(string);
    var strLength = string.length;
    if ($axH2S(string)) {
        var strSymbols = $jx6Tp(string);
        strLength = strSymbols.length;
    }
    if (length >= strLength) return string;
    var end = length - $ifYxh(omission);
    if (end < 1) return omission;
    var result = strSymbols ? $gvFfr(strSymbols, 0, end).join('') : string.slice(0, end);
    if (separator === undefined) return result + omission;
    if (strSymbols) end += result.length - end;
    if ($cErmc(separator)) {
        if (string.slice(end).search(separator)) {
            var match, substring = result;
            if (!separator.global) separator = RegExp(separator.source, $jJVtR($c6e266ef199f8e9f$var$reFlags.exec(separator)) + 'g');
            separator.lastIndex = 0;
            while(match = separator.exec(substring))var newEnd = match.index;
            result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
    } else if (string.indexOf($kHBB0(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) result = result.slice(0, index);
    }
    return result + omission;
}
module.exports = $c6e266ef199f8e9f$var$truncate;

});
parcelRegister("cErmc", function(module, exports) {

var $3euyi = parcelRequire("3euyi");

var $cW28x = parcelRequire("cW28x");

var $lMQGH = parcelRequire("lMQGH");
/* Node.js helper references. */ var $935e70fe57caa939$var$nodeIsRegExp = $lMQGH && $lMQGH.isRegExp;
/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */ var $935e70fe57caa939$var$isRegExp = $935e70fe57caa939$var$nodeIsRegExp ? $cW28x($935e70fe57caa939$var$nodeIsRegExp) : $3euyi;
module.exports = $935e70fe57caa939$var$isRegExp;

});
parcelRegister("3euyi", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $25aa60f3dfdc1028$var$regexpTag = '[object RegExp]';
/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */ function $25aa60f3dfdc1028$var$baseIsRegExp(value) {
    return $fC1Kz(value) && $beQoo(value) == $25aa60f3dfdc1028$var$regexpTag;
}
module.exports = $25aa60f3dfdc1028$var$baseIsRegExp;

});


parcelRegister("ifYxh", function(module, exports) {

var $dkmPN = parcelRequire("dkmPN");

var $axH2S = parcelRequire("axH2S");

var $61ekh = parcelRequire("61ekh");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $d4a895dd16218f22$var$stringSize(string) {
    return $axH2S(string) ? $61ekh(string) : $dkmPN(string);
}
module.exports = $d4a895dd16218f22$var$stringSize;

});
parcelRegister("dkmPN", function(module, exports) {

var $8hdQS = parcelRequire("8hdQS");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $9b3edb0cff432526$var$asciiSize = $8hdQS('length');
module.exports = $9b3edb0cff432526$var$asciiSize;

});

parcelRegister("61ekh", function(module, exports) {
/** Used to compose unicode character classes. */ var $461df2ef275f3803$var$rsAstralRange = '\\ud800-\\udfff', $461df2ef275f3803$var$rsComboMarksRange = '\\u0300-\\u036f', $461df2ef275f3803$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $461df2ef275f3803$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $461df2ef275f3803$var$rsComboRange = $461df2ef275f3803$var$rsComboMarksRange + $461df2ef275f3803$var$reComboHalfMarksRange + $461df2ef275f3803$var$rsComboSymbolsRange, $461df2ef275f3803$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $461df2ef275f3803$var$rsAstral = '[' + $461df2ef275f3803$var$rsAstralRange + ']', $461df2ef275f3803$var$rsCombo = '[' + $461df2ef275f3803$var$rsComboRange + ']', $461df2ef275f3803$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $461df2ef275f3803$var$rsModifier = '(?:' + $461df2ef275f3803$var$rsCombo + '|' + $461df2ef275f3803$var$rsFitz + ')', $461df2ef275f3803$var$rsNonAstral = '[^' + $461df2ef275f3803$var$rsAstralRange + ']', $461df2ef275f3803$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $461df2ef275f3803$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $461df2ef275f3803$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $461df2ef275f3803$var$reOptMod = $461df2ef275f3803$var$rsModifier + '?', $461df2ef275f3803$var$rsOptVar = '[' + $461df2ef275f3803$var$rsVarRange + ']?', $461df2ef275f3803$var$rsOptJoin = '(?:' + $461df2ef275f3803$var$rsZWJ + '(?:' + [
    $461df2ef275f3803$var$rsNonAstral,
    $461df2ef275f3803$var$rsRegional,
    $461df2ef275f3803$var$rsSurrPair
].join('|') + ')' + $461df2ef275f3803$var$rsOptVar + $461df2ef275f3803$var$reOptMod + ')*', $461df2ef275f3803$var$rsSeq = $461df2ef275f3803$var$rsOptVar + $461df2ef275f3803$var$reOptMod + $461df2ef275f3803$var$rsOptJoin, $461df2ef275f3803$var$rsSymbol = '(?:' + [
    $461df2ef275f3803$var$rsNonAstral + $461df2ef275f3803$var$rsCombo + '?',
    $461df2ef275f3803$var$rsCombo,
    $461df2ef275f3803$var$rsRegional,
    $461df2ef275f3803$var$rsSurrPair,
    $461df2ef275f3803$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $461df2ef275f3803$var$reUnicode = RegExp($461df2ef275f3803$var$rsFitz + '(?=' + $461df2ef275f3803$var$rsFitz + ')|' + $461df2ef275f3803$var$rsSymbol + $461df2ef275f3803$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $461df2ef275f3803$var$unicodeSize(string) {
    var result = $461df2ef275f3803$var$reUnicode.lastIndex = 0;
    while($461df2ef275f3803$var$reUnicode.test(string))++result;
    return result;
}
module.exports = $461df2ef275f3803$var$unicodeSize;

});



parcelRegister("f2NGE", function(module, exports) {

$parcel$export(module.exports, "getFieldLengthForAnalytics", () => $b46d240c3082c919$export$e337040f61dd6dff);
const $b46d240c3082c919$export$e337040f61dd6dff = (length)=>{
    if (!length) return '0';
    if (length > 3) return '>3';
    return String(length);
};

});

parcelRegister("3eGwD", function(module, exports) {

$parcel$export(module.exports, "setBoardDetailViewMode", () => $2bcfa667ce8ad985$export$5aec23d4b2954b61);
$parcel$export(module.exports, "getBoardDetailViewMode", () => $2bcfa667ce8ad985$export$30296c2892a21468);
$parcel$export(module.exports, "getIsIssueIdValid", () => $2bcfa667ce8ad985$export$19a52456f915e7ce);
$parcel$export(module.exports, "isIssueEntryIssue", () => $2bcfa667ce8ad985$export$dd68addaaf18caa0);
$parcel$export(module.exports, "isIssueEntryGroup", () => $2bcfa667ce8ad985$export$a9cdbc0e2d3f64a7);
$parcel$export(module.exports, "getIssueEntryGroupKey", () => $2bcfa667ce8ad985$export$e5641ceb7fc8f20a);

var $bSSG7 = parcelRequire("bSSG7");

var $jOSD5 = parcelRequire("jOSD5");
const $2bcfa667ce8ad985$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('software');
const $2bcfa667ce8ad985$var$GROUP_BY_SELECTION = 'gh.groupBySelection.';
const $2bcfa667ce8ad985$export$5aec23d4b2954b61 = (detailViewMode)=>$2bcfa667ce8ad985$var$localStorage.set((0, $jOSD5.BOARD_DETAIL_VIEW_MODE), detailViewMode);
const $2bcfa667ce8ad985$export$30296c2892a21468 = ()=>$2bcfa667ce8ad985$var$localStorage.get((0, $jOSD5.BOARD_DETAIL_VIEW_MODE)) || (0, $jOSD5.DETAIL_VIEW_DEFAULT);
const $2bcfa667ce8ad985$export$1708c8217a67f3f9 = (boardId)=>{
    const data = $2bcfa667ce8ad985$var$localStorage.get(`${$2bcfa667ce8ad985$var$GROUP_BY_SELECTION}${boardId}`);
    if (!data) return null;
    return data;
};
const $2bcfa667ce8ad985$export$19a52456f915e7ce = (issueId)=>{
    if (typeof issueId === 'number') return issueId > 0;
    return !!issueId;
};
const $2bcfa667ce8ad985$export$dd68addaaf18caa0 = (issueEntry)=>issueEntry.type === 'issue';
const $2bcfa667ce8ad985$export$a9cdbc0e2d3f64a7 = (issueEntry)=>issueEntry.type === 'group';
const $2bcfa667ce8ad985$export$e5641ceb7fc8f20a = ({ parentId: parentId, issueIds: issueIds })=>`${parentId}::${issueIds.join(',')}`;

});
parcelRegister("jOSD5", function(module, exports) {

$parcel$export(module.exports, "DETAIL_VIEW_DEFAULT", () => $91937a74349ee4f3$export$ad4637adae7d3e97);
$parcel$export(module.exports, "BOARD_DETAIL_VIEW_MODE", () => $91937a74349ee4f3$export$201bf1eb7c447afa);
const $91937a74349ee4f3$export$dfb67e34e4333816 = 'SIDEBAR';
const $91937a74349ee4f3$export$1d6094128a3bfe4a = 'MODAL';
const $91937a74349ee4f3$export$ad4637adae7d3e97 = 'DEFAULT';
const $91937a74349ee4f3$export$201bf1eb7c447afa = 'board-detail-view-mode';
const $91937a74349ee4f3$export$6b0228c67b1e82cf = {
    NO_SWIMLANE: 'none',
    SWIMLANE_BY_JQL: 'jql',
    SWIMLANE_BY_ASSIGNEE: 'assignee',
    SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST: 'assigneeunassignedfirst',
    SWIMLANE_BY_PARENT_ISSUE: 'issueparent',
    SWIMLANE_BY_SUBTASK: 'issuechildren',
    SWIMLANE_BY_PROJECT: 'project',
    SWIMLANE_BY_TEAM: 'team',
    SWIMLANE_BY_REQUEST_TYPE: 'requesttype'
};

});


parcelRegister("01j5n", function(module, exports) {

$parcel$export(module.exports, "isUserNetworkError", () => $5ca31bd2f34603ab$export$34bc86f6bf17f1e0);
$parcel$export(module.exports, "isClientSideThirdPartyAppError", () => $5ca31bd2f34603ab$export$ed0f33c09abc69f3);
$parcel$export(module.exports, "isFailureStatusCode", () => $5ca31bd2f34603ab$export$790c76b8c83c3421);
$parcel$export(module.exports, "default", () => $5ca31bd2f34603ab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $g0Gtc = parcelRequire("g0Gtc");

var $dJl1T = parcelRequire("dJl1T");

var $kobfu = parcelRequire("kobfu");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $fZneA = parcelRequire("fZneA");

var $dIdda = parcelRequire("dIdda");

var $eKlYC = parcelRequire("eKlYC");

var $hdE8g = parcelRequire("hdE8g");

var $3vXOY = parcelRequire("3vXOY");

var $e2KRD = parcelRequire("e2KRD");

const $5ca31bd2f34603ab$var$renderExperienceFailureWithStatus = ({ location: location, statusCode: statusCode, traceId: traceId, hash: hash, buildKey: buildKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceFailureTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $e2KRD.createFailureReasonWithStatusCode)((0, $3e83829bdc9c581d$export$a3bb34ea5a520df8), statusCode),
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
const $5ca31bd2f34603ab$export$34bc86f6bf17f1e0 = (error)=>{
    const networkErrorName = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'networkError',
        'name'
    ], null);
    const networkErrorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'networkError',
        'statusCode'
    ], null);
    if (networkErrorName && !networkErrorStatusCode) (0, $dJl1T.default).safeErrorWithoutCustomerData('nextgen.sla.network.error.unknown.error.name', networkErrorName);
    // A fetch() promise will reject with a TypeError when a network error is encountered or CORS is misconfigured on the server-side,
    // although this usually means permission issues or similar — a 404 does not constitute a network error
    // more https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#Checking_that_the_fetch_was_successful
    return networkErrorName === 'TypeError' || networkErrorName === 'AbortError';
};
const $5ca31bd2f34603ab$export$8a5d666d6e5b82fc = (error)=>{
    if (error?.name === 'ChunkLoadError') {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('nextgen.sla.chunk.load.error', error?.name, {
            message: error.message
        });
        return true;
    }
    return false;
};
const $5ca31bd2f34603ab$export$7193151b5738a995 = (error)=>{
    if (error?.name === 'ResponseNullError') {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('nextgen.sla.response.null.error', error?.name, {
            message: error.message
        });
        return true;
    }
    return false;
};
const $5ca31bd2f34603ab$var$KNOWN_CLIENT_SIDE_THIRD_PARTY_APP_ERRORS = [
    'FPClassifier is not defined'
];
const $5ca31bd2f34603ab$export$ed0f33c09abc69f3 = (error)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(error) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(error.message) && !!$5ca31bd2f34603ab$var$KNOWN_CLIENT_SIDE_THIRD_PARTY_APP_ERRORS.find((errorMessage)=>error?.message?.includes(errorMessage));
const $5ca31bd2f34603ab$export$790c76b8c83c3421 = (statusCode)=>{
    if (statusCode == null || statusCode === 429 || statusCode >= 500) // jira is too busy, unknown error or server error
    return true;
    if (statusCode >= 400 && statusCode < 500) return false;
    return true;
};
const $5ca31bd2f34603ab$var$detectLocalNetworkErrors = (errorResponse)=>{
    if ($5ca31bd2f34603ab$export$34bc86f6bf17f1e0(errorResponse)) return 0, $3e83829bdc9c581d$export$3c39b2049cd1acb3;
    if ($5ca31bd2f34603ab$export$8a5d666d6e5b82fc(errorResponse)) return 0, $3e83829bdc9c581d$export$fdfe3175a0c7be80;
    if ((0, $fZneA.isClientFetchError)(errorResponse)) return 0, $3e83829bdc9c581d$export$38fe4329f59f7ac5;
    if ((0, $co1wz.ff)('jsw.cmp.response-null-abort') && $5ca31bd2f34603ab$export$7193151b5738a995(errorResponse)) return 0, $3e83829bdc9c581d$export$49d11848b43d6dbf;
    if ($5ca31bd2f34603ab$export$ed0f33c09abc69f3(errorResponse)) return 0, $3e83829bdc9c581d$export$32e56551129a1642;
    return null;
};
const $5ca31bd2f34603ab$var$responseToSla = (errorResponse, location)=>{
    const statusCode = (0, $3vXOY.extractStatusCode)(errorResponse);
    const abortFailureReason = $5ca31bd2f34603ab$var$detectLocalNetworkErrors(errorResponse);
    const traceId = (0, $hdE8g.extractTraceId)(errorResponse) || (0, $3e83829bdc9c581d$export$fa14a20fcf1b1eb4);
    const hash = (0, $kobfu.getErrorHash)(errorResponse) || (0, $3e83829bdc9c581d$export$fa14a20fcf1b1eb4);
    const buildKey = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(window, [
        'BUILD_KEY'
    ]) || (0, $3e83829bdc9c581d$export$fa14a20fcf1b1eb4);
    const errorResponseMessage = errorResponse?.message || (0, $3e83829bdc9c581d$export$fa14a20fcf1b1eb4);
    if (abortFailureReason) // Fire SLA Abort event to monitor the volume of client-side issues without impacting SLO
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceAbortTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $e2KRD.createFailureReason)(abortFailureReason),
            error: errorResponseMessage,
            statusCode: statusCode || '',
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
    if (statusCode === null) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('nextgen.sla.unknown.failure', (0, $3e83829bdc9c581d$export$b4f05a271d0831dc), {
            networkErrorName: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(errorResponse, [
                'networkError',
                'name'
            ], ''),
            networkStatusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(errorResponse, [
                'networkError',
                'statusCode'
            ], ''),
            graphqlStatusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(errorResponse, [
                'graphQLErrors',
                0,
                'extensions',
                'statusCode'
            ], ''),
            location: location,
            error: JSON.stringify(errorResponse, Object.getOwnPropertyNames(errorResponse)),
            hash: hash,
            isBacklogWithRelayEnabled: (0, $eKlYC.isBacklogWithRelayEnabled)()
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceFailureTracker), {
            location: location,
            failureEventAttributes: {
                ...(0, $e2KRD.createFailureReason)((0, $3e83829bdc9c581d$export$b4f05a271d0831dc)),
                traceId: traceId,
                buildKey: buildKey,
                error: JSON.stringify({
                    message: errorResponseMessage
                }),
                hash: hash
            }
        });
    }
    // based on https://hello.atlassian.net/wiki/spaces/agile/pages/512782292/SWAG+response+handling+on+the+client
    // 40x missing permission, experience does not exist, not logged in, etc
    if (statusCode === 400 || statusCode === 401 || statusCode === 403) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceSuccessTracker), {
        location: location
    });
    if (statusCode === 429) // jira is too busy
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceAbortTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $e2KRD.createFailureReason)((0, $3e83829bdc9c581d$export$7b9f56c34c008ec2)),
            error: errorResponseMessage,
            statusCode: '429',
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
    if (statusCode === 404) // redirect to "all-projects" page or error page, when page is not found
    return (0, $4R6GH.fg)('jsw-jet-yamato-fe-perm-content-and-error-page') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
        to: "/jira/software/projects/not-found"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
        to: "/jira/projects?showFlag=jsw.project-not-found"
    });
    if (statusCode > 400 && statusCode < 500) // the rest of 40X
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceSuccessTracker), {
        location: location
    });
    if (statusCode >= 500) return $5ca31bd2f34603ab$var$renderExperienceFailureWithStatus({
        location: location,
        statusCode: statusCode,
        traceId: traceId,
        hash: hash,
        buildKey: buildKey
    });
    return $5ca31bd2f34603ab$var$renderExperienceFailureWithStatus({
        location: location,
        statusCode: statusCode,
        traceId: traceId,
        hash: hash,
        buildKey: buildKey
    });
};
var $5ca31bd2f34603ab$export$2e2bcd8739ae039 = $5ca31bd2f34603ab$var$responseToSla;

});
parcelRegister("eKlYC", function(module, exports) {

$parcel$export(module.exports, "isBacklogWithRelayEnabled", () => $988924d63bfd64f6$export$bc84f8a9593e9b2c);

var $co1wz = parcelRequire("co1wz");
const $988924d63bfd64f6$export$bc84f8a9593e9b2c = ()=>(0, $co1wz.ff)('jsw.perf.critical-backlog-with-relay');

});

parcelRegister("hdE8g", function(module, exports) {

$parcel$export(module.exports, "extractTraceId", () => $6db1ddf832c04f2d$export$431eacb6aecbacdf);
const $6db1ddf832c04f2d$export$431eacb6aecbacdf = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>String(error?.traceId || error?.networkError?.traceId || '');

});

parcelRegister("e2KRD", function(module, exports) {

$parcel$export(module.exports, "createFailureReason", () => $360af9265ac477eb$export$b9e48ed6f1b092c7);
$parcel$export(module.exports, "createFailureReasonWithStatusCode", () => $360af9265ac477eb$export$cc7dce678df87fe9);
const $360af9265ac477eb$export$b9e48ed6f1b092c7 = (reason)=>({
        failureReason: reason,
        errorMessage: reason
    });
const $360af9265ac477eb$export$cc7dce678df87fe9 = (reason, statusCode)=>{
    if (statusCode === undefined || statusCode === null) return {
        failureReason: reason,
        statusCode: '[unknown]',
        errorMessage: `${reason}-unknown`
    };
    return {
        failureReason: reason,
        statusCode: `${statusCode}`,
        errorMessage: `${reason}-${statusCode}`
    };
};

});

const $3e83829bdc9c581d$export$b4f05a271d0831dc = 'critical-data-failed-unknown-reason';
const $3e83829bdc9c581d$export$a3bb34ea5a520df8 = 'critical-data-failed-with-status-code';
const $3e83829bdc9c581d$export$7b9f56c34c008ec2 = '429-error';
const $3e83829bdc9c581d$export$3c39b2049cd1acb3 = 'user-network-error';
const $3e83829bdc9c581d$export$fdfe3175a0c7be80 = 'chunk-load-error';
const $3e83829bdc9c581d$export$38fe4329f59f7ac5 = 'client-fetch-error';
const $3e83829bdc9c581d$export$49d11848b43d6dbf = 'response-null-error';
const $3e83829bdc9c581d$export$32e56551129a1642 = 'client-third-party-app-error';
const $3e83829bdc9c581d$export$fa14a20fcf1b1eb4 = 'unknown';


parcelRegister("5yzdy", function(module, exports) {

$parcel$export(module.exports, "getBoardExtraData", () => $1f2884452d611059$export$736611f042606509);

var $vAfHD = parcelRequire("vAfHD");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");
const $1f2884452d611059$export$736611f042606509 = (state)=>({
        issuesCount: (0, $vAfHD.boardOrderedIssueIdsSelector)(state).length,
        filteredIssuesCount: (0, $5mTgl.workFilteredIssuesSelector)(state).length,
        columnsCount: (0, $67Z81.getOrderedColumnIds)(state).length,
        isCompanyManaged: (0, $67Z81.getIsCMPBoard)(state)
    });

});


parcelRegister("6qosr", function(module, exports) {

$parcel$export(module.exports, "issueCreateRequestPerformance", () => $7fbf29447c28ca04$export$d3a6a79448f0e45);
$parcel$export(module.exports, "issueCreateSuccessPerformance", () => $7fbf29447c28ca04$export$c06b8e463871bb27);
$parcel$export(module.exports, "issueRankTransitionRequestPerformance", () => $7fbf29447c28ca04$export$7bbea59c986ad3b9);
$parcel$export(module.exports, "issueRankTransitionSuccessPerformance", () => $7fbf29447c28ca04$export$e5f6ae46e503f358);
$parcel$export(module.exports, "issueDeleteRequestPerformance", () => $7fbf29447c28ca04$export$6772d78aa70edaf8);
$parcel$export(module.exports, "issueFlagToggleRequestPerformance", () => $7fbf29447c28ca04$export$2ca02dd8a0e8a281);

var $k12ix = parcelRequire("k12ix");

var $4G04L = parcelRequire("4G04L");

var $5yzdy = parcelRequire("5yzdy");

var $hz3OZ = parcelRequire("hz3OZ");
const $7fbf29447c28ca04$export$d3a6a79448f0e45 = ()=>(preState, state, action)=>{
        const concurrentId = String(action.payload.temporaryIssueIds[0]);
        (0, $hz3OZ.issueCreateInteraction)(concurrentId).start();
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $hz3OZ.issueCreateInteraction)(concurrentId).mark('feedback');
        });
        return null;
    };
const $7fbf29447c28ca04$export$c06b8e463871bb27 = ()=>(preState, state, action)=>{
        const concurrentId = String(action.payload.temporaryIssueIds[0]);
        (0, $hz3OZ.issueCreateInteraction)(concurrentId).stop({
            customData: {
                ...(0, $k12ix.getNormalisedPerformanceFFs)(),
                ...(0, $5yzdy.getBoardExtraData)(state)
            }
        });
        return null;
    };
const $7fbf29447c28ca04$export$7bbea59c986ad3b9 = ()=>(preState, state, action)=>{
        const concurrentId = String(action.meta.optimistic?.id);
        (0, $hz3OZ.issueRankAndTransitionInteraction)(concurrentId).start();
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $hz3OZ.issueRankAndTransitionInteraction)(concurrentId).mark('feedback');
        });
        return null;
    };
const $7fbf29447c28ca04$export$e5f6ae46e503f358 = ()=>(preState, state, action)=>{
        const concurrentId = String(action.meta.optimistic.id);
        (0, $hz3OZ.issueRankAndTransitionInteraction)(concurrentId).stop({
            customData: {
                ...(0, $k12ix.getNormalisedPerformanceFFs)(),
                ...(0, $5yzdy.getBoardExtraData)(state)
            }
        });
        return null;
    };
const $7fbf29447c28ca04$export$6772d78aa70edaf8 = ()=>(preState, state, action)=>{
        const concurrentId = String(action.meta.optimistic.id);
        (0, $hz3OZ.issueDeleteInteraction)(concurrentId).start();
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $hz3OZ.issueDeleteInteraction)(concurrentId).mark('feedback');
        });
        return null;
    };
const $7fbf29447c28ca04$export$2ca02dd8a0e8a281 = ()=>(preState, state, action)=>{
        const concurrentId = String(action.meta.optimistic.id);
        (0, $hz3OZ.flagToggleInteraction)(concurrentId).start();
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $hz3OZ.flagToggleInteraction)(concurrentId).mark('feedback');
        });
        return null;
    };

});

parcelRegister("c0Kii", function(module, exports) {

$parcel$export(module.exports, "issueDeleteModalOpen", () => $3445d9a636e939f1$export$4807059b0e0495d2);
$parcel$export(module.exports, "issueDeleteModalClose", () => $3445d9a636e939f1$export$b8ef0a3642381);
const $3445d9a636e939f1$export$4807059b0e0495d2 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.issue.delete.modal.open`,
            data: {
                issueId: action.payload.issueId,
                columnIndex: action.payload.columnIndex
            }
        });
const $3445d9a636e939f1$export$b8ef0a3642381 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.issue.delete.modal.close`
        });

});

parcelRegister("hpG0x", function(module, exports) {

$parcel$export(module.exports, "issueMediaVisibilityChange", () => $c00e88311800c1a3$export$729fe6d4b853e2ab);
const $c00e88311800c1a3$export$729fe6d4b853e2ab = (eventPrefix)=>(preState, state, action)=>{
        const { issueId: issueId, isVisible: isVisible } = action.payload;
        return {
            name: `${eventPrefix}.card.media.toggled.card`,
            data: {
                issueId: issueId,
                enabled: isVisible
            }
        };
    };

});

parcelRegister("8yIXy", function(module, exports) {

$parcel$export(module.exports, "swimlaneModeChanged", () => $740bbfadba4b444f$export$ddc71706a3b45faf);

var $iuuJH = parcelRequire("iuuJH");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");
const $740bbfadba4b444f$export$ddc71706a3b45faf = (eventPrefix)=>(preState, state)=>{
        const hasSwimlanes = (0, $45cXl.getSwimlaneMode)(state) !== (0, $iuuJH.NO_SWIMLANE).id;
        return {
            name: `${eventPrefix}.swimlane.mode.changed`,
            data: {
                hasSwimlanes: hasSwimlanes,
                numSwimlanes: hasSwimlanes ? (0, $4jZ56.getSwimlanes)(state).length : 0
            }
        };
    };

});

parcelRegister("jYl7U", function(module, exports) {

$parcel$export(module.exports, "boardNonCriticalView", () => $c0680dad691ef4f6$export$8a605ef273fd8c8);
$parcel$export(module.exports, "boardView", () => $c0680dad691ef4f6$export$50191da575ef3bdf);
$parcel$export(module.exports, "boardLoadFailure", () => $c0680dad691ef4f6$export$dd70b93515666e3a);
$parcel$export(module.exports, "boardLoadNoColumnFailure", () => $c0680dad691ef4f6$export$dd59f805aee5f1b7);
$parcel$export(module.exports, "workRefreshData", () => $c0680dad691ef4f6$export$c65e4e12058e64e2);

var $9XE6b = parcelRequire("9XE6b");

var $gccSB = parcelRequire("gccSB");

var $cuHs1 = parcelRequire("cuHs1");

var $hhweD = parcelRequire("hhweD");

var $dJl1T = parcelRequire("dJl1T");

var $4R6GH = parcelRequire("4R6GH");

var $fjcgS = parcelRequire("fjcgS");

var $6uzgj = parcelRequire("6uzgj");

var $a4XJc = parcelRequire("a4XJc");

var $8zmNw = parcelRequire("8zmNw");


var $iuuJH = parcelRequire("iuuJH");

var $1vXOx = parcelRequire("1vXOx");

var $9OPlz = parcelRequire("9OPlz");

var $fyeGd = parcelRequire("fyeGd");

var $9UXXB = parcelRequire("9UXXB");

var $3UY9S = parcelRequire("3UY9S");

var $bSSdD = parcelRequire("bSSdD");

var $4gt6L = parcelRequire("4gt6L");

var $d2i8f = parcelRequire("d2i8f");

var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $5mTgl = parcelRequire("5mTgl");
const $c0680dad691ef4f6$export$21761b53d261ebd0 = (estimationStatisticFieldId)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(estimationStatisticFieldId)) return 0, $dcbb2bce513725b3$export$8775696968c9b13c;
    if (estimationStatisticFieldId === (0, $dcbb2bce513725b3$export$d02889a654103c98)) return 0, $dcbb2bce513725b3$export$bfb354504bb547a0;
    if (!estimationStatisticFieldId.startsWith('customfield_')) (0, $dJl1T.default).safeErrorWithoutCustomerData('board.critical.load.boardscope.transform.failure', `Could not map estimation with field id ${estimationStatisticFieldId} to supported estimation types`);
    return 0, $dcbb2bce513725b3$export$405b6d72f2d243a9;
};
const $c0680dad691ef4f6$export$8a605ef273fd8c8 = (eventPrefix)=>(preState, state, action)=>{
        const isCMP = (0, $67Z81.getIsCMPBoard)(state);
        const isClassicCardCoverViewSettingEnabled = (0, $8zmNw.getViewSettings)({
            boardId: Number((0, $67Z81.rapidViewIdSelector)(state)),
            view: (0, $a4XJc.View).BOARD
        })?.showCardCovers;
        const hasCovers = isCMP && (0, $4R6GH.fg)('jsw_cmp_card_cover_images') ? isClassicCardCoverViewSettingEnabled : (0, $5mTgl.isCardMediaEnabled)(state);
        const issueLinkStatsViewSettings = {
            showIssueLinksStatsViewSettings: Boolean((0, $8zmNw.getViewSettings)({
                boardId: Number((0, $67Z81.rapidViewIdSelector)(state)),
                view: (0, $a4XJc.View).BOARD
            })?.showIssueLinksStats)
        };
        const dueDateStats = (0, $4R6GH.fg)('jsw_due_date_metrics') ? {
            showDueDateViewSettings: (0, $67Z81.getIsDueDateEnabled)(state) && Boolean((0, $8zmNw.getViewSettings)({
                boardId: Number((0, $67Z81.rapidViewIdSelector)(state)),
                view: (0, $a4XJc.View).BOARD
            })?.showDueDate),
            numCardsWithDueDates: (0, $5mTgl.getNumberOfCardsWithDueDates)(state)
        } : {};
        const attributes = {
            numCards: (0, $5mTgl.workIssuesSelector)(state).length,
            numCardsWithCovers: hasCovers ? (0, $5mTgl.getNumberOfCardsWithCovers)(state) : 0,
            hasCovers: hasCovers,
            ...issueLinkStatsViewSettings,
            ...dueDateStats
        };
        const cardCoverAnalyticsAttributes = {
            action: 'viewed',
            containerType: 'project',
            containerId: String((0, $67Z81.projectIdSelector)(state)),
            objectType: 'board',
            objectId: String((0, $67Z81.rapidViewIdSelector)(state)),
            attributes: attributes
        };
        (0, $hhweD.fireTrackAnalytics)(action.meta.analytics, cardCoverAnalyticsAttributes);
        return {
            name: `${eventPrefix}.view`,
            data: {}
        };
    };
const $c0680dad691ef4f6$export$50191da575ef3bdf = (eventPrefix)=>(preState, state, action)=>{
        // Performance based marks on board view
        const issueNo = (0, $5mTgl.workIssuesSelector)(state).length;
        const people = (0, $36pz7.getPeople)(state);
        const doneColumnId = (0, $fyeGd.doneColumnIdSelector)(state);
        const numIssuesInDoneColumn = {
            numIssuesInDoneColumn: (0, $5mTgl.getColumnTotalIssuesCount)(state, doneColumnId)
        };
        const toDoColumnId = (0, $fyeGd.initialColumnIdSelector)(state);
        const numIssuesInToDoColumn = {
            numIssuesInToDoColumn: (0, $5mTgl.getColumnTotalIssuesCount)(state, toDoColumnId)
        };
        const featureAttributes = (0, $6uzgj.getFeatureAnalyticsAttributes)((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $67Z81.getEntities)(state), [
            'board',
            'config',
            'allFeatures'
        ], []));
        const permissions = (0, (/*@__PURE__*/$parcel$interopDefault($cuHs1)))((0, $1vXOx.boardPermissionsSelector)(state), (permission, key)=>`has_${key}_permission`);
        const hasSwimlanes = (0, $45cXl.getSwimlaneMode)(state) !== (0, $iuuJH.NO_SWIMLANE).id;
        const swimlanesPayload = {
            hasSwimlanes: hasSwimlanes,
            numSwimlanes: hasSwimlanes ? (0, $4jZ56.getSwimlanes)(state).length : 0,
            numVisibleSwimlanes: hasSwimlanes ? (0, $4jZ56.getSwimlanes)(state).length : 0
        };
        const estimationType = $c0680dad691ef4f6$export$21761b53d261ebd0((0, $5mTgl.getEstimationStatistic)(state));
        const isCompanyManaged = (0, $67Z81.getIsCMPBoard)(state);
        const isQuickFiltersBarToggled = (0, $8zmNw.getViewSettings)({
            boardId: Number((0, $67Z81.rapidViewIdSelector)(state)),
            view: (0, $a4XJc.View).BOARD
        })?.showQuickFilters;
        const numQuickFilters = (0, $5mTgl.getCustomFilters)(state).length;
        const cmpAttributes = isCompanyManaged && {
            numQuickFilters: numQuickFilters,
            isQuickFiltersBarToggled: isQuickFiltersBarToggled
        };
        const isIPBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        let ipAttributes;
        if (isIPBoard && (0, $4R6GH.fg)('program_board_flexible_cadence')) {
            const { iterationLength: iterationLength, iterationsCount: iterationsCount } = (0, $67Z81.getIncrementConfig)(state) ?? {};
            ipAttributes = {
                iterationLength: iterationLength,
                iterationsCount: iterationsCount
            };
        }
        const isUnscheduledWorkColumnPanel = action.payload.isUnscheduledWorkColumnPanel;
        const boardViewAnalyticsAttributes = {
            action: 'viewed',
            containerType: 'project',
            containerId: String((0, $67Z81.projectIdSelector)(state)),
            objectType: 'board',
            objectId: String((0, $67Z81.rapidViewIdSelector)(state)),
            attributes: {
                ...featureAttributes,
                ...permissions,
                boardId: (0, $67Z81.rapidViewIdSelector)(state),
                boardType: (0, $67Z81.getBoardTypeForAnalytics)(state),
                numIssues: issueNo,
                numSubtasks: (0, $3UY9S.numTotalIssueChildren)(state),
                numCompleteSubtasks: (0, $3UY9S.numCompleteIssueChildren)(state),
                numIssueParents: (0, $bSSdD.issueParentIdsSelector)(state).length,
                numIssueTypes: (0, $4gt6L.issueTypeIdsSelector)(state).length,
                numColumns: (0, $5mTgl.workColumnsSelector)(state).length,
                numLabels: (0, $d2i8f.issueLabelsSelector)(state).length,
                hasHorizontalScrollbar: action.payload.hasHorizontalScrollbar,
                hasFilteredIssues: (0, $5mTgl.getBoardHasFilteredIssues)(state),
                hasColumnLimits: (0, $fyeGd.hasColumnLimits)(state),
                hasNonGlobalTransitions: (0, $9OPlz.hasNonGlobalTransitions)(state),
                hasConditionsOnTransitions: (0, $9OPlz.hasConditionsOnTransitions)(state),
                hasDoneColumnInLastPosition: (0, $fyeGd.hasDoneColumnInLastPositionSelector)(state),
                hasMoreThanFiveColumn: (0, $fyeGd.hasMoreThanFiveColumn)(state),
                hasMultipleDoneColumns: (0, $fyeGd.hasMultipleDoneColumnSelector)(state),
                swimlaneMode: (0, $45cXl.getSwimlaneMode)(state),
                numberOfAssigneesOnBoard: Object.keys(people).length,
                numDoneColumns: (0, $fyeGd.getDoneColumnsSelector)(state).length,
                hasInlineColumnEdit: (0, $5mTgl.isInlineColumnEditEnabled)(state),
                hasInlineCardCreate: (0, $9UXXB.hasInlineCardCreateConfig)(state),
                isCustomBoardWithIcc: (0, $9UXXB.getIsCustomBoardWithIcc)(state),
                inlineCardCreateMode: (0, $9UXXB.getInlineCardCreateConfig)(state)?.mode,
                ...numIssuesInDoneColumn,
                ...numIssuesInToDoColumn,
                ...swimlanesPayload,
                estimationStatistic: estimationType,
                issueResultProjectIds: (0, $67Z81.getIssueProjectIds)(state),
                ...cmpAttributes,
                ...ipAttributes
            }
        };
        if (!isUnscheduledWorkColumnPanel) // we don't want to fire analytics if the board is the unscheduled work panel (increment planning)
        // as this is unneccessarily doubling the analytics events on the page
        (0, $hhweD.fireTrackAnalytics)(action.meta.analytics, boardViewAnalyticsAttributes);
        return {
            name: `${eventPrefix}.view`,
            data: {
                hasHorizontalScrollbar: action.payload.hasHorizontalScrollbar,
                hasFilteredIssues: (0, $5mTgl.getBoardHasFilteredIssues)(state),
                hasColumnLimits: (0, $fyeGd.hasColumnLimits)(state),
                numIssues: issueNo,
                numIssueParents: (0, $bSSdD.issueParentIdsSelector)(state).length,
                numIssueTypes: (0, $4gt6L.issueTypeIdsSelector)(state).length,
                numColumns: (0, $5mTgl.workColumnsSelector)(state).length,
                numLabels: (0, $d2i8f.issueLabelsSelector)(state).length,
                ...swimlanesPayload
            }
        };
    };
const $c0680dad691ef4f6$export$dd70b93515666e3a = (eventPrefix)=>()=>({
            name: `${eventPrefix}.load.failure`,
            data: {}
        });
const $c0680dad691ef4f6$export$dd59f805aee5f1b7 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.load.failure.no-column`,
            data: {}
        });
const $c0680dad691ef4f6$export$c65e4e12058e64e2 = (eventPrefix)=>(preState, state, action)=>{
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                action: 'triggered',
                actionSubject: 'workRefreshData',
                actionSubjectId: `${eventPrefix}.refresh`,
                source: 'boardScreen',
                attributes: {
                    source: action.payload.source
                }
            };
            client.getInstance().sendTrackEvent(payload);
        });
        return {
            name: `${eventPrefix}.refresh`,
            data: {
                source: action.payload.source
            }
        };
    };

});
parcelRegister("6uzgj", function(module, exports) {

$parcel$export(module.exports, "getFeatureAnalyticsAttributes", () => $130d3cc5b8e064da$export$ac70e171fbeaebce);
const $130d3cc5b8e064da$export$4517b897375f940f = (key)=>`is_${key}_enabled`;
const $130d3cc5b8e064da$export$ac70e171fbeaebce = (allFeatures)=>{
    const result = {};
    allFeatures.forEach((feature)=>{
        result[$130d3cc5b8e064da$export$4517b897375f940f(feature.key)] = feature.status === 'ENABLED';
    });
    return result;
};

});




parcelRegister("iQYKJ", function(module, exports) {

$parcel$export(module.exports, "actionMetricsMiddleware", () => $98e159e32061235a$export$86019bcfe40705fe);

var $x9xyg = parcelRequire("x9xyg");

var $8PRuf = parcelRequire("8PRuf");

var $65C0W = parcelRequire("65C0W");
const $98e159e32061235a$export$86019bcfe40705fe = ()=>(next)=>(action)=>{
            let result;
            if (action.type === (0, $65C0W.SOFTWARE_APP_LOADED)) {
                // Measure how long it takes to execute the action when the software app is loaded
                // to get better insight into performance of large boards.
                (0, $x9xyg.setMark)((0, $8PRuf.jswReduxSoftwareAppLoadedStartMark));
                result = next(action);
                (0, $x9xyg.setMark)((0, $8PRuf.jswReduxSoftwareAppLoadedEndMark));
            } else result = next(action);
            return result;
        };

});

parcelRegister("5YGyZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae1ac2a5e90639e8$export$2e2bcd8739ae039);


var $hi6AJ = parcelRequire("hi6AJ");

var $eu61M = parcelRequire("eu61M");

var $2f454 = parcelRequire("2f454");

var $63F6h = parcelRequire("63F6h");

var $7tJ5d = parcelRequire("7tJ5d");

var $dnW4F = parcelRequire("dnW4F");

var $bkCF5 = parcelRequire("bkCF5");

var $bZ9IJ = parcelRequire("bZ9IJ");

var $9WrsG = parcelRequire("9WrsG");

var $dN3Ms = parcelRequire("dN3Ms");

var $dW1HX = parcelRequire("dW1HX");

var $2ON1s = parcelRequire("2ON1s");

var $hoX5N = parcelRequire("hoX5N");

var $d315K = parcelRequire("d315K");

var $65C0W = parcelRequire("65C0W");

var $k50Aq = parcelRequire("k50Aq");

var $cW3pH = parcelRequire("cW3pH");
// We ignore the success and failure mutations, we just invalidate them as soon as the request
// is fired. That way if someone navigates away before the SUCCESS/FAILURE mutation returns they
// won't get an incorrect cached version
const $ae1ac2a5e90639e8$var$BOARD_IGNORE_REGEX = /^(state\.actions\.).+(_SUCCESS|_FAILURE)$/;
// This one helps us ignore junk like COMMON/REDUX_DISPOSABLE/DISPOSE_ACTION
const $ae1ac2a5e90639e8$var$ELIGIBLE_FOR_INVALIDATION = /^(state\.actions\.).+$/;
const $ae1ac2a5e90639e8$export$d4b7dead01a52ae = ({ type: type })=>{
    // There are a lot of mutations that just get fired on startup which will immediately
    // invalidate the cache. Just ignore those
    switch(type){
        case 0, $cW3pH.WORK_REFRESH_DATA:
        case 0, $hoX5N.PERSON_SET:
        case 0, $65C0W.SOFTWARE_APP_LOADED:
        case 0, $9WrsG.DEV_STATUS_LOAD:
        case 0, $cW3pH.BOARD_VIEW:
        case 0, $cW3pH.BOARD_NON_CRITICAL_VIEW:
        case 0, $cW3pH.WORK_DATA_SET:
        case 0, $cW3pH.WORK_DATA_CRITICAL_SET:
        case 0, $d315K.REALTIME_DISPATCH_EVENT:
        case 0, $dnW4F.FILTER_PANEL_MOUNTED:
        case 0, $dW1HX.CLOSE_ISSUE_MODAL:
        case 0, $dW1HX.OPEN_ISSUE_MODAL:
        case 0, $dN3Ms.ISSUE_MEDIA_VISIBILITY_CHANGE_REQUEST:
        case 0, $2f454.CARD_MEDIA_DATA_SET:
        case 0, $2f454.CARD_REFRESH_REQUEST:
        case 0, $2f454.SET_ACTIVE_ISSUE_WITH_ICC:
        case 0, $2f454.CARD_CLICK:
        case 0, $2f454.CARD_TOGGLE_SELECTION:
        case 0, $2f454.CARD_MULTI_SELECT:
        case 0, $2f454.CARD_SINGLE_SELECT:
        case 0, $2f454.CARD_DRAG_SELECTED_TRANSITION:
        case 0, $2f454.CARD_DRAG_OVER_TRANSITION:
        case 0, $2f454.CARD_DRAG_OVER_TRANSITION_REQUEST:
        case 0, $dnW4F.SEARCH_FOCUS:
        case 0, $2f454.SET_ISSUE_ID_WITH_ABOVE_ICC_OPEN:
        case 0, $dnW4F.CLEAR_ALL_FILTERS_CLICKED:
        case 0, $2f454.CARD_FOCUS:
        case 0, $bZ9IJ.SHOW_ASSIGN_ISSUE_PARENT_MODAL:
        case 0, $bZ9IJ.HIDE_ASSIGN_ISSUE_PARENT_MODAL:
        case 0, $63F6h.COLUMN_DELETE_MODAL_CLOSE:
        case 0, $dnW4F.FILTERS_SET:
        case 0, $dnW4F.SET_ALL_FILTERS:
        case 0, $2f454.CARD_REMOVE_SHOW_RIPPLE:
        case 0, $2f454.CARD_ADD_SHOW_RIPPLE:
        case 0, $2f454.CARD_GET_ISSUE_TRANSITIONS:
        case 0, $2f454.CARD_SET_ISSUE_TRANSITIONS:
        case 0, $7tJ5d.UPDATE_DETAIL_VIEW:
        case 0, $2ON1s.TOGGLE_PANEL:
        case 0, $bkCF5.FLAG_DISMISSED:
        case 0, $k50Aq.SWIMLANES_TOGGLE:
        case 0, $k50Aq.SWIMLANE_TOGGLE:
        case 0, $k50Aq.SWIMLANE_MODE_CHANGE_REQUEST:
        case 0, $eu61M.DRAG_START:
        case 0, $eu61M.DRAG_END:
        case 0, $2f454.CARD_BLUR:
        case 0, $2f454.CARD_PREV:
        case 0, $2f454.CARD_NEXT:
        case 0, $2f454.CARD_PREV_COLUMN:
        case 0, $2f454.CARD_NEXT_COLUMN:
        case 0, $65C0W.SOFTWARE_DISPLAY_WARNING:
        case 0, $2f454.SET_INLINE_EDITING:
            return false;
        default:
            break;
    }
    // Ignore stuff that isn't applicable to the board (e.g. COMMON/REDUX_DISPOSABLE/DISPOSE_ACTION)
    // Or If it is one that we ignore (SUCCESS/FAILURE)
    if (!$ae1ac2a5e90639e8$var$ELIGIBLE_FOR_INVALIDATION.exec(type) || $ae1ac2a5e90639e8$var$BOARD_IGNORE_REGEX.exec(type)) return false;
    // DEFAULT TO TRUE. It's better to forcibly refresh the cache if someone forgets to add
    // their mutation here
    return true;
};
var $ae1ac2a5e90639e8$export$2e2bcd8739ae039 = (0, $hi6AJ.default)((0, $8631d6ce464ccf2e$export$9b8283d5878d2491), $ae1ac2a5e90639e8$export$d4b7dead01a52ae);

});
parcelRegister("hi6AJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1904eee7acf3b502$export$2e2bcd8739ae039);

var $b0yad = parcelRequire("b0yad");
const $1904eee7acf3b502$export$41c940a04807c68c = (subject)=>(origin, invalidationFunction)=>()=>(next)=>(action)=>{
                    // There is a potential that the action gets passed as undefined
                    if (action && invalidationFunction(action)) {
                        // Trigger cache invalidation. Let the listeners handle everything else
                        subject.next(origin);
                        (0, $b0yad.addInvalidationReason)(origin, action.type ?? 'UNKNOWN');
                    }
                    return next(action);
                };
var $1904eee7acf3b502$export$2e2bcd8739ae039 = $1904eee7acf3b502$export$41c940a04807c68c((0, $b0yad.default));

});
parcelRegister("b0yad", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d7966c085fcd143$export$2e2bcd8739ae039);
$parcel$export(module.exports, "triggerResourceCacheInvalidation", () => $0d7966c085fcd143$export$76c3549b2288ab5d);
$parcel$export(module.exports, "addInvalidationReason", () => $0d7966c085fcd143$export$77045c8772786aca);
$parcel$export(module.exports, "getAndClearInvalidationReasons", () => $0d7966c085fcd143$export$c5ab3b0612bd31b4);

var $cab1K = parcelRequire("cab1K");


var $h8O2U = parcelRequire("h8O2U");
const $0d7966c085fcd143$var$invalidationTracker = new (0, $h8O2U.CacheInvalidationTracker)();
// Standard observer pattern, the middleware in board/backlog will invoke this
// when it comes across a matching redux mutation that requires the cache
// to be purged
const $0d7966c085fcd143$var$ResourcesCacheInvalidationSubject = new (0, $cab1K.Subject)();
var $0d7966c085fcd143$export$2e2bcd8739ae039 = $0d7966c085fcd143$var$ResourcesCacheInvalidationSubject;
const $0d7966c085fcd143$export$76c3549b2288ab5d = (origin, reason = (0, $8631d6ce464ccf2e$export$78244dbb77cfa6b6))=>{
    $0d7966c085fcd143$var$ResourcesCacheInvalidationSubject.next(origin);
    $0d7966c085fcd143$var$invalidationTracker.addReason(origin, reason);
};
const $0d7966c085fcd143$export$77045c8772786aca = (origin, reason)=>{
    $0d7966c085fcd143$var$invalidationTracker.addReason(origin, reason);
};
const $0d7966c085fcd143$export$c5ab3b0612bd31b4 = (origin)=>$0d7966c085fcd143$var$invalidationTracker.getAndClearReasons(origin);

});
parcelRegister("h8O2U", function(module, exports) {

$parcel$export(module.exports, "CacheInvalidationTracker", () => $42c3911f8f33a9e0$export$71900622f425a7c3);

class $42c3911f8f33a9e0$export$71900622f425a7c3 {
    /**
	 * Pushes an invalidation reason to be tracked on the next cache-miss.
	 */ addReason(origin, reason = (0, $8631d6ce464ccf2e$export$78244dbb77cfa6b6)) {
        const reasonString = `${origin}:${reason}`;
        Object.keys(this.reasons).forEach((key)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<CacheInvalidationType, Set<string>>>'.
            if (this.reasons[key].size >= 10) return;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<CacheInvalidationType, Set<string>>>'.
            this.reasons[key].add(reasonString);
        });
    }
    /**
	 * Fetch invalidation reasons from the reasons set.
	 *
	 * If an experience does not read / clear reasons there's still only a bounded number of strings
	 * (10) that will be added into the Set; e.g. it's not a memory concern.
	 *
	 * The reasons are sorted.
	 */ getAndClearReasons(origin) {
        const reasonsSet = this.reasons[origin];
        const reasons = Array.from(reasonsSet);
        reasons.sort();
        reasonsSet.clear();
        return reasons;
    }
    constructor(){
        /**
	 * Holds reasons cache has been invalidated as a set of strings, for example:
	 *
	 * * BOARD:state.ISSUE_MOVE
	 * * BACKLOG:CREATE_SPRINT
	 *
	 * Reasons are kept separately for each page because they'll be cleared when the page is loaded.
	 *
	 * The reasoning can be exemplified by:
	 *
	 * * Visit board
	 * * Visit backlog
	 * * Visit roadmaps
	 * * Visit backlog - Load from cache
	 * * Make a BACKLOG:CARD_MOVE invalidation reason in backlog
	 *   * All 3 caches are now cleared
	 * * Visit board - reason is BACKLOG:CARD_MOVE - reasons are cleared;
	 * * Visit roadmaps - reason is BACKLOG:CARD_MOVE - reasons are cleared;
	 * * Visit backlog - reason is BACKLOG:CARD_MOVE - reasons are cleared;
	 * * Make a BACKLOG:SPRINT_COMPLETE invalidation reason in backlog
	 * * Visit board - reason is BACKLOG:SPRINT_COMPLETE **only**
	 */ this.reasons = {
            [(0, $8631d6ce464ccf2e$export$9b8283d5878d2491)]: new Set(),
            [(0, $8631d6ce464ccf2e$export$dedbdcc35e955187)]: new Set(),
            [(0, $8631d6ce464ccf2e$export$ffff0a2c60bf4822)]: new Set(),
            [(0, $8631d6ce464ccf2e$export$78244dbb77cfa6b6)]: new Set()
        };
    }
}

});



parcelRegister("bZ9IJ", function(module, exports) {

$parcel$export(module.exports, "SHOW_ASSIGN_ISSUE_PARENT_MODAL", () => $57b16eab1c65412b$export$a1239bded0580595);
$parcel$export(module.exports, "showAssignIssueParentModal", () => $57b16eab1c65412b$export$bde7b0aee6aed1e);
$parcel$export(module.exports, "HIDE_ASSIGN_ISSUE_PARENT_MODAL", () => $57b16eab1c65412b$export$5a2556acdb3df33b);
$parcel$export(module.exports, "hideAssignIssueParentModal", () => $57b16eab1c65412b$export$bac41e77c8fec802);
const $57b16eab1c65412b$export$a1239bded0580595 = 'state.actions.issue.assign-issue-parent-modal.SHOW_ASSIGN_ISSUE_PARENT_MODAL';
const $57b16eab1c65412b$export$bde7b0aee6aed1e = (issueIds)=>({
        type: $57b16eab1c65412b$export$a1239bded0580595,
        payload: {
            issueIds: issueIds
        }
    });
const $57b16eab1c65412b$export$5a2556acdb3df33b = 'state.actions.issue.assign-issue-parent-modal.HIDE_ASSIGN_ISSUE_PARENT_MODAL';
const $57b16eab1c65412b$export$bac41e77c8fec802 = ()=>({
        type: $57b16eab1c65412b$export$5a2556acdb3df33b
    });

});


parcelRegister("3sree", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2911f7d75948388$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $ja5ob = parcelRequire("ja5ob");

var $gJesu = parcelRequire("gJesu");

var $88zgs = parcelRequire("88zgs");
function $c2911f7d75948388$export$2e2bcd8739ae039() {
    return (0, $3f2cs.combineReducers)({
        configuration: (0, $ja5ob.configurationReducer),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        entities: (0, $gJesu.default),
        ui: (0, $88zgs.default)()
    });
}

});
parcelRegister("ja5ob", function(module, exports) {

$parcel$export(module.exports, "configurationReducer", () => $6720da300ed73b3e$export$d089b7f237574d6);

var $2vSU6 = parcelRequire("2vSU6");

var $lzeFL = parcelRequire("lzeFL");

var $l2T6l = parcelRequire("l2T6l");

var $f3MfI = parcelRequire("f3MfI");

var $cW3pH = parcelRequire("cW3pH");

var $fR6rG = parcelRequire("fR6rG");
const $6720da300ed73b3e$var$initialState = {
    contextPath: '',
    rapidViewId: '',
    cloudId: '',
    activationId: '',
    userAccountId: '',
    locale: (0, $lzeFL.defaultLocale),
    projectKey: '',
    projectId: 0,
    projectName: '',
    projectType: (0, $2vSU6.SOFTWARE_PROJECT),
    siteAdminStatus: 'unknown',
    licensedProducts: {},
    productCrossSellConfig: 'unknown',
    extension: {
        operations: []
    },
    sessionId: '',
    isCMPBoard: false,
    isIncrementPlanningBoard: false,
    issueLimitExceeded: false,
    missingIssueType: '',
    canInviteOthersToProject: false
};
const $6720da300ed73b3e$export$d089b7f237574d6 = (state = $6720da300ed73b3e$var$initialState, action)=>{
    const newState = (0, $l2T6l.chainUnsafe)(state).set('extension', (0, $fR6rG.default)(state.extension, action)).value();
    if (action.type === (0, $cW3pH.WORK_DATA_SET)) return {
        ...newState,
        projectName: action.payload.projects[0]?.name ?? '',
        projectId: action.payload.projects[0]?.id ?? '',
        projectKey: action.payload.projects[0]?.key ?? '',
        boardType: action.payload.boardType,
        etag: action.payload.etag,
        hierarchyNomenclature: action.payload.hierarchyNomenclature,
        issueLimitExceeded: action.payload.issueLimitExceeded ?? false,
        savedFilterId: action.payload.savedFilterId
    };
    if (action.type === (0, $f3MfI.SET_CAN_USER_INVITE)) return {
        ...newState,
        canInviteOthersToProject: action.payload.canInviteOthersToProject
    };
    return newState;
};

});
parcelRegister("l2T6l", function(module, exports) {

$parcel$export(module.exports, "assocUnsafe", () => $10cc07b888293773$export$a759ec8fde46de77);
$parcel$export(module.exports, "dissocUnsafe", () => $10cc07b888293773$export$e0867c1b5da854fe);
$parcel$export(module.exports, "assocInUnsafe", () => $10cc07b888293773$export$1bfac1118aad2c2f);
$parcel$export(module.exports, "updateInUnsafe", () => $10cc07b888293773$export$f920b8c255ec1192);
$parcel$export(module.exports, "chainUnsafe", () => $10cc07b888293773$export$181c753256d1c9a0);

var $7uUwQ = parcelRequire("7uUwQ");
const $10cc07b888293773$export$a759ec8fde46de77 = (collection, key, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.assoc(collection, key, value);
const $10cc07b888293773$export$9b65d21cdbb50a87 = (collection, key, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.set(collection, key, value);
const $10cc07b888293773$export$e0867c1b5da854fe = (collection, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.dissoc(collection, key);
const $10cc07b888293773$export$958195bad0a3dbcf = (collection, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.unset(collection, key);
const $10cc07b888293773$export$1bfac1118aad2c2f = (collection, path, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.assocIn(collection, path, value);
const $10cc07b888293773$export$565e6fa2e54b66b3 = (collection, path, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.setIn(collection, path, value);
const $10cc07b888293773$export$75197f11bfe5de5f = (collection, path)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.getIn(collection, path);
const $10cc07b888293773$export$f920b8c255ec1192 = (collection, path, callback)=>$7uUwQ.updateIn(collection, path, callback);
class $10cc07b888293773$var$IcepickUnsafeWrapper {
    constructor(collection){
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        this.wrapper = $7uUwQ.chain(collection);
    }
    value() {
        return this.wrapper.value();
    }
    freeze() {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.freeze().value());
    }
    assoc(key, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assoc(key, value).value());
    }
    set(key, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.set(key, value).value());
    }
    dissoc(key) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.dissoc(key).value());
    }
    unset(key) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.unset(key).value());
    }
    assocIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assocIn(path, value).value());
    }
    setIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.setIn(path, value).value());
    }
    getIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.getIn(path, value).value());
    }
    updateIn(path, callback) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.updateIn(path, callback).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(source) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assign(source).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2, s3) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2, s3).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2, s3, s4) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2, s3, s4).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(source) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.extend(source).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2, s3) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2, s3).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2, s3, s4) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2, s3, s4).value());
    }
    merge(source) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.merge(source).value());
    }
    thru(val) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.thru(val).value());
    }
}
const $10cc07b888293773$export$181c753256d1c9a0 = (collection)=>new $10cc07b888293773$var$IcepickUnsafeWrapper(collection);

});

parcelRegister("fR6rG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3350f6b2dc8e67d$export$2e2bcd8739ae039);

var $eQEtH = parcelRequire("eQEtH");
const $c3350f6b2dc8e67d$var$initialState = {
    operations: []
};
function $c3350f6b2dc8e67d$export$2e2bcd8739ae039(state = $c3350f6b2dc8e67d$var$initialState, action) {
    if (action.type === (0, $eQEtH.EXTENSION_FETCH_SUCCESS)) return {
        ...state,
        ...action.payload.extension
    };
    return state;
}

});


parcelRegister("gJesu", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe0e0555959d2fb0$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $alNv9 = parcelRequire("alNv9");

var $8J1tE = parcelRequire("8J1tE");

var $f8jqi = parcelRequire("f8jqi");

var $lAVlQ = parcelRequire("lAVlQ");

var $1cp3g = parcelRequire("1cp3g");

var $b4Neb = parcelRequire("b4Neb");

var $4AaHD = parcelRequire("4AaHD");

var $6v6W4 = parcelRequire("6v6W4");

var $7ANej = parcelRequire("7ANej");

var $9YkOZ = parcelRequire("9YkOZ");

var $8UrfO = parcelRequire("8UrfO");

var $7UqIo = parcelRequire("7UqIo");

var $2ZUt8 = parcelRequire("2ZUt8");

var $jVK6B = parcelRequire("jVK6B");

var $e3PD9 = parcelRequire("e3PD9");

var $qY0zX = parcelRequire("qY0zX");

var $11N2b = parcelRequire("11N2b");

var $ilheH = parcelRequire("ilheH");

var $eeFib = parcelRequire("eeFib");

var $gnRwu = parcelRequire("gnRwu");

var $1gv2w = parcelRequire("1gv2w");

var $8DmOP = parcelRequire("8DmOP");

var $cidFT = parcelRequire("cidFT");

var $kLXNe = parcelRequire("kLXNe");

var $6S8mJ = parcelRequire("6S8mJ");

var $3IVsJ = parcelRequire("3IVsJ");

var $9i87f = parcelRequire("9i87f");

var $lEneF = parcelRequire("lEneF");

var $8YtrK = parcelRequire("8YtrK");
var $fe0e0555959d2fb0$export$2e2bcd8739ae039 = (0, $alNv9.optimistic)((0, $3f2cs.combineReducers)({
    board: (0, $8J1tE.default),
    columns: (0, $lAVlQ.columnsReducer),
    issueChildren: (0, $7ANej.issueChildrenReducer),
    issueMedia: (0, $2ZUt8.issueMediaReducer),
    issueParents: (0, $jVK6B.default),
    issueProjects: (0, $e3PD9.issueProjectsReducer),
    issueTypes: (0, $ilheH.issueTypesReducer),
    projectIssueTypes: (0, $cidFT.projectIssueTypesReducer),
    requestTypes: (0, $kLXNe.requestTypesReducer),
    issues: (0, $eeFib.issueEntitiesReducer),
    people: (0, $8DmOP.peopleReducer),
    sprints: (0, $6S8mJ.sprintsReducer),
    statusCategories: (0, $3IVsJ.statusCategoriesReducer),
    statuses: (0, $9i87f.statusesReducer),
    cardTransitions: (0, $f8jqi.cardTransitionsReducer),
    issueTransitions: (0, $qY0zX.default),
    estimationStatistic: (0, $b4Neb.estimationStatisticReducer),
    inlineCreate: (0, $6v6W4.inlineCreateReducer),
    customFilters: (0, $1cp3g.customFiltersReducer),
    jqlSwimlanes: (0, $gnRwu.jqlSwimlanesReducer),
    versionData: (0, $8YtrK.versionDataReducer),
    missingParents: (0, $1gv2w.missingParentsReducer),
    teams: (0, $lEneF.teamsReducer),
    incrementConfig: (0, $4AaHD.incrementConfigReducer),
    issueTypesByProject: (0, $11N2b.issueTypesByProjectReducer),
    issueLinksStats: (0, $7UqIo.issueLinksStatsReducer),
    issueLinkTypes: (0, $9YkOZ.IssueLinkTypesReducer),
    issueLinksPermissions: (0, $8UrfO.issueLinksPermissionsReducer)
}));

});
parcelRegister("8J1tE", function(module, exports) {

$parcel$export(module.exports, "default", () => $46a2470043bf5078$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $bM8Kn = parcelRequire("bM8Kn");

var $w3nA1 = parcelRequire("w3nA1");

var $heNh0 = parcelRequire("heNh0");

var $6nzKY = parcelRequire("6nzKY");

var $gg51X = parcelRequire("gg51X");

var $cAwia = parcelRequire("cAwia");

var $57YkG = parcelRequire("57YkG");

var $h6HH2 = parcelRequire("h6HH2");

var $8nEK3 = parcelRequire("8nEK3");

var $5NCzb = parcelRequire("5NCzb");

var $94E7k = parcelRequire("94E7k");
var $46a2470043bf5078$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    columns: (0, $bM8Kn.boardColumnsReducer),
    config: (0, $w3nA1.boardConfigReducer),
    hasFilteredIssues: (0, $6nzKY.hasFilteredIssuesReducer),
    issues: (0, $8nEK3.boardIssuesReducer),
    selectedSprints: (0, $94E7k.selectedSprintsReducer),
    isConfigLoaded: (0, $gg51X.isConfigLoadedReducer),
    isCurrentUserLoaded: (0, $cAwia.isCurrentUserLoadedReducer),
    permissions: (0, $5NCzb.permissionsReducer),
    issueChildren: (0, $57YkG.boardIssueChildrenReducer),
    issueParentOrder: (0, $h6HH2.boardIssueParentReducer),
    boardFavourite: (0, $heNh0.boardFavouriteReducer)
});

});
parcelRegister("bM8Kn", function(module, exports) {

$parcel$export(module.exports, "boardColumnsReducer", () => $7d59f6c43d60b4f1$export$203a64aa0627727a);

var $7uUwQ = parcelRequire("7uUwQ");

var $glGhK = parcelRequire("glGhK");

var $63F6h = parcelRequire("63F6h");

var $55fEr = parcelRequire("55fEr");

var $cW3pH = parcelRequire("cW3pH");
const $7d59f6c43d60b4f1$export$203a64aa0627727a = (state = (0, $7uUwQ.freeze)([]), action)=>{
    if ((action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) && action.payload.columns) return (0, $7uUwQ.freeze)(action.payload.columns.map((column)=>column.id));
    if (action.type === (0, $63F6h.COLUMN_DELETE_REQUEST)) {
        const { columnId: columnId } = action.payload;
        return (0, $7uUwQ.filter)((id)=>id !== columnId, state);
    }
    if (action.type === (0, $55fEr.COLUMN_RANK_REQUEST)) {
        let columnIds = state;
        const { columnId: columnId, targetColumnId: targetColumnId } = action.payload;
        const currentIndex = columnIds.indexOf(columnId);
        const newIndex = columnIds.indexOf(targetColumnId);
        columnIds = (0, $7uUwQ.splice)(columnIds, currentIndex, 1);
        columnIds = (0, $7uUwQ.splice)(columnIds, newIndex, 0, columnId);
        return columnIds;
    }
    if (action.type === (0, $glGhK.COLUMN_CREATE_REQUEST)) {
        const { temporaryColumnId: temporaryColumnId } = action.payload;
        // For CMP boards, we put the new column before the final Done column
        if (action.meta.isCMPBoard) return (0, $7uUwQ.splice)(state, state.length - 1, 0, temporaryColumnId);
        return (0, $7uUwQ.push)(state, temporaryColumnId);
    }
    if (action.type === (0, $glGhK.COLUMN_CREATE_SUCCESS)) {
        const { temporaryColumnId: temporaryColumnId, column: column } = action.payload;
        const currentIndex = state.indexOf(temporaryColumnId);
        return (0, $7uUwQ.splice)(state, currentIndex, 1, column.id);
    }
    return state;
};

});

parcelRegister("w3nA1", function(module, exports) {

$parcel$export(module.exports, "boardConfigReducer", () => $f8055b3084354013$export$c160cae4040278a0);

var $7uUwQ = parcelRequire("7uUwQ");

var $9XE6b = parcelRequire("9XE6b");

var $127QL = parcelRequire("127QL");

var $bRqd3 = parcelRequire("bRqd3");

var $7buQq = parcelRequire("7buQq");

var $65C0W = parcelRequire("65C0W");

var $cW3pH = parcelRequire("cW3pH");
const $f8055b3084354013$var$initialState = {
    name: '',
    rankConfig: {
        boardIsRankable: true,
        rankCustomFieldId: 1234
    },
    isInlineColumnEditEnabled: false,
    isCardMediaEnabled: false,
    isSprintsEnabled: false,
    isBacklogEnabled: false,
    isEstimationEnabled: false,
    isManageRulesEnabled: false,
    isReleasesFeatureEnabled: false,
    allFeatures: [],
    timeTrackingOptions: {
        workingHoursPerDay: 8,
        workingDaysPerWeek: 5,
        timeFormat: 'pretty',
        defaultUnit: 'minute'
    },
    isAnyStatusInCreateEnabled: true
};
const $f8055b3084354013$export$c160cae4040278a0 = (state = $f8055b3084354013$var$initialState, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET)) {
        const { config: config, boardName: boardName, capabilities: capabilities, boardConfig: boardConfig, inlineCardCreate: inlineCardCreate, isInlineColumnEditEnabled: isInlineColumnEditEnabled, allFeatures: allFeatures } = action.payload;
        const { isCardMediaEnabled: isCardMediaEnabled, boardIssueListKey: boardIssueListKey, isManageRulesEnabled: isManageRulesEnabled, timeTrackingOptions: timeTrackingOptions, columnConstraintType: columnConstraintType, isAnyStatusInCreateEnabled: isAnyStatusInCreateEnabled } = boardConfig;
        const newState = (0, $7uUwQ.chain)(state).set('rankConfig', config).set('name', boardName).set('isBacklogEnabled', capabilities && capabilities.BACKLOG).set('isSprintsEnabled', capabilities && capabilities.SPRINTS).set('inlineCardCreate', inlineCardCreate).set('isInlineColumnEditEnabled', isInlineColumnEditEnabled).set('isCardMediaEnabled', isCardMediaEnabled).set('boardIssueListKey', boardIssueListKey).set('isManageRulesEnabled', isManageRulesEnabled).set('isReleasesFeatureEnabled', capabilities && capabilities.RELEASES).set('allFeatures', allFeatures).set('timeTrackingOptions', timeTrackingOptions).set('columnConstraintType', columnConstraintType).set('isAnyStatusInCreateEnabled', isAnyStatusInCreateEnabled).value();
        return newState;
    }
    if (action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        const { config: config, boardName: boardName, capabilities: capabilities, inlineCardCreate: inlineCardCreate, isInlineColumnEditEnabled: isInlineColumnEditEnabled, allFeatures: allFeatures } = action.payload;
        const newState = (0, $7uUwQ.chain)(state).set('rankConfig', config).set('name', boardName).set('isBacklogEnabled', capabilities && capabilities.BACKLOG).set('isSprintsEnabled', capabilities && capabilities.SPRINTS).set('isEstimationEnabled', capabilities && capabilities.ESTIMATION).set('inlineCardCreate', inlineCardCreate).set('isInlineColumnEditEnabled', isInlineColumnEditEnabled).set('isReleasesFeatureEnabled', capabilities && capabilities.RELEASES).set('allFeatures', allFeatures).value();
        return newState;
    }
    if (action.type === (0, $bRqd3.CARD_MEDIA_TOGGLE_REQUEST)) return (0, $7uUwQ.set)(state, 'isCardMediaEnabled', action.payload);
    if (action.type === (0, $7buQq.RENAME_BOARD_REQUEST)) return (0, $7uUwQ.set)(state, 'name', action.payload);
    if (action.type === (0, $65C0W.SOFTWARE_APP_LOADED)) return (0, $7uUwQ.set)(state, 'name', (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(action.payload.prefetchData, [
        'boardData',
        'boardName'
    ], state.name));
    if (action.type === (0, $127QL.BOARD_DEFERRED_DATA_LOAD_SUCCESS)) {
        const { payload: { isUsingSimplifiedWorkflow: isUsingSimplifiedWorkflow } } = action;
        // For CMP boards, we allow inline column editing only with simplified workflow boards
        if (isUsingSimplifiedWorkflow !== undefined) return (0, $7uUwQ.set)(state, 'isInlineColumnEditEnabled', isUsingSimplifiedWorkflow);
    }
    return state;
};

});

parcelRegister("heNh0", function(module, exports) {

$parcel$export(module.exports, "boardFavouriteReducer", () => $0879794f84f656e7$export$e44a04a90b9b0017);

var $fC72p = parcelRequire("fC72p");
const $0879794f84f656e7$var$initialState = {
    isFavourite: undefined
};
const $0879794f84f656e7$export$e44a04a90b9b0017 = (state = $0879794f84f656e7$var$initialState, action)=>{
    switch(action.type){
        case 0, $fC72p.SET_IS_FAVOURITE:
            return {
                isFavourite: action.payload.isFavourite
            };
        default:
            return state;
    }
};

});

parcelRegister("6nzKY", function(module, exports) {

$parcel$export(module.exports, "hasFilteredIssuesReducer", () => $1d4b2fa673705b1e$export$9c25a54b5e38e3ae);

var $cW3pH = parcelRequire("cW3pH");
const $1d4b2fa673705b1e$export$9c25a54b5e38e3ae = (state = false, action)=>{
    switch(action.type){
        case 0, $cW3pH.WORK_DATA_SET:
        case 0, $cW3pH.WORK_DATA_CRITICAL_SET:
            return action.payload.hasFilteredIssues;
        default:
            return state;
    }
};

});

parcelRegister("gg51X", function(module, exports) {

$parcel$export(module.exports, "isConfigLoadedReducer", () => $153f872a117427a8$export$8da0e005528236f5);

var $cW3pH = parcelRequire("cW3pH");
const $153f872a117427a8$export$8da0e005528236f5 = (state = false, action)=>{
    switch(action.type){
        case 0, $cW3pH.WORK_DATA_SET:
            return true;
        default:
            return state;
    }
};

});

parcelRegister("cAwia", function(module, exports) {

$parcel$export(module.exports, "isCurrentUserLoadedReducer", () => $b8b157d0c919f365$export$49f02b71768c5e88);

var $hoX5N = parcelRequire("hoX5N");
const $b8b157d0c919f365$export$49f02b71768c5e88 = (state = false, action)=>{
    switch(action.type){
        case 0, $hoX5N.PERSON_SET:
            return true;
        default:
            {
                // @ts-expect-error - TS2322: Type 'ShowErrorFlagAction | AddToSprintRequestAction | AddToSprintSuccessAction | AddToSprintFailureAction | ... 256 more ... | UnsupportedAction' is not assignable to type 'never'.
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("57YkG", function(module, exports) {

$parcel$export(module.exports, "boardIssueChildrenReducer", () => $632455f55662c841$export$dff3145c7f53c7db);

var $7uUwQ = parcelRequire("7uUwQ");

var $k8IPx = parcelRequire("k8IPx");

var $4wVpT = parcelRequire("4wVpT");


var $2f454 = parcelRequire("2f454");

var $63F6h = parcelRequire("63F6h");

var $4gHuj = parcelRequire("4gHuj");

var $ls4NM = parcelRequire("ls4NM");

var $kXqRJ = parcelRequire("kXqRJ");

var $71oFY = parcelRequire("71oFY");

var $cW3pH = parcelRequire("cW3pH");
const $632455f55662c841$var$rankChildIssues = ({ state: state, issueIds: issueIds, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId })=>{
    const availableIssues = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(state, issueIds);
    if (availableIssues.length === 0) return state;
    const newState = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(state, availableIssues);
    let destinationIndex;
    if (rankBeforeIssueId) destinationIndex = newState.indexOf(rankBeforeIssueId);
    else if (rankAfterIssueId) destinationIndex = newState.indexOf(rankAfterIssueId) + 1;
    else return state;
    return (0, $7uUwQ.splice)(newState, destinationIndex, 0, ...issueIds);
};
const $632455f55662c841$export$dff3145c7f53c7db = (state = [], action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        const { payload: { issueChildren: issueChildren } } = action;
        return issueChildren.map((issue)=>issue.id);
    }
    if (action.type === (0, $4gHuj.SET_ISSUE_CHILDREN)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: issueChildren } = action;
        return issueChildren.map((issue)=>issue.id);
    }
    if (action.type === (0, $kXqRJ.ISSUE_DELETE_REQUEST)) {
        const { payload: { issue: issue, childIssueIds: childIssueIds } } = action;
        const childIssueToDelete = issue.id;
        const childIssueOfDeletedParent = childIssueIds;
        return state.filter((childIssueId)=>childIssueId !== childIssueToDelete && childIssueOfDeletedParent.indexOf(childIssueId) < 0);
    }
    if (action.type === (0, $2f454.CARD_CLEAR)) {
        const { payload: { childCardIds: childCardIds } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        childCardIds.forEach((cardId)=>{
            const index = newState.value().indexOf(cardId);
            if (index >= 0) // @ts-expect-error - TS2339 - Property 'splice' does not exist on type 'IcepickWrapper<IssueChildrenState>'.
            newState.splice(index, 1);
        });
        return newState.value();
    }
    if (action.type === (0, $2f454.CARD_DELETE)) {
        const { payload: { issueId: issueId } } = action;
        const index = state.indexOf(issueId);
        if (index < 0) return state;
        return (0, $7uUwQ.splice)(state, index, 1);
    }
    if (action.type === (0, $ls4NM.ISSUE_CREATE_REQUEST)) {
        const { payload: { issues: issues, type: type }, meta: { insertBefore: insertBefore } } = action;
        if (type !== (0, $dcbb2bce513725b3$export$1f24f91824c6822f)) return state;
        const issueIds = issues.map(({ id: id })=>id);
        const insertionPoint = insertBefore ? state.indexOf(insertBefore) : state.length;
        return (0, $7uUwQ.splice)(state, insertionPoint, 0, ...issueIds);
    }
    if (action.type === (0, $ls4NM.ISSUE_CREATE_SUCCESS)) {
        const { payload: { temporaryIssueIds: temporaryIssueIds, issues: issues } } = action;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const translation = {};
        temporaryIssueIds.forEach((id, index)=>{
            if (issues[index]) translation[id] = issues[index].id;
        });
        // Assume that no temporary id will ever be falsey (0).
        return Object.keys(translation).length > 0 ? (0, $7uUwQ.map)((oldId)=>translation[oldId] || oldId, state) : state;
    }
    if (action.type === (0, $71oFY.ISSUE_RANK_TRANSITION_UPDATE_OPTIMISTIC)) {
        const { payload: { issueIds: issueIds, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId, mode: mode } } = action;
        /**
		 * We won't update the ranking if the moving card is transition only
		 * */ if (mode === 'TRANSITION_ONLY') return state;
        return $632455f55662c841$var$rankChildIssues({
            state: state,
            issueIds: issueIds,
            rankBeforeIssueId: rankBeforeIssueId,
            rankAfterIssueId: rankAfterIssueId
        });
    }
    if (action.type === (0, $71oFY.BULK_ISSUE_RANK_OPTIMISTIC)) {
        const { payload: { issueIds: issueIds, rankAfterId: rankAfterId, rankBeforeId: rankBeforeId } } = action;
        return $632455f55662c841$var$rankChildIssues({
            state: state,
            issueIds: issueIds,
            rankBeforeIssueId: rankBeforeId,
            rankAfterIssueId: rankAfterId
        });
    }
    if (action.type === (0, $4gHuj.SET_ISSUE_CHILDREN_RANK)) {
        const { payload: { issueIds: issueIds, rankId: rankId, isRankAfter: isRankAfter } } = action;
        const availableIssues = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(state, issueIds);
        if (!availableIssues.length) return state;
        const newState = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(state, availableIssues);
        const rankItemIndex = newState.indexOf(rankId);
        const destinationIndex = isRankAfter ? rankItemIndex + 1 : rankItemIndex;
        return (0, $7uUwQ.splice)(newState, destinationIndex, 0, ...issueIds);
    }
    if (action.type === (0, $63F6h.COLUMN_DELETE_REQUEST)) {
        const { payload: { closestColumn: closestColumn, issuesInColumn: issuesInColumn } } = action;
        if (!closestColumn) {
            const issueIdsInColumn = new Set(issuesInColumn.map((issue)=>issue.id));
            return state.filter((id)=>!issueIdsInColumn.has(id));
        }
    }
    return state;
};

});

parcelRegister("h6HH2", function(module, exports) {

$parcel$export(module.exports, "boardIssueParentReducer", () => $ecf8ac1a8e63a493$export$2c22cce5c981884b);

var $7uUwQ = parcelRequire("7uUwQ");

var $2f454 = parcelRequire("2f454");

var $63F6h = parcelRequire("63F6h");

var $3n65g = parcelRequire("3n65g");

var $cW3pH = parcelRequire("cW3pH");
const $ecf8ac1a8e63a493$export$2c22cce5c981884b = (state = [], action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        const { payload: { issueParents: issueParents } } = action;
        return issueParents.map((issue)=>issue.id);
    }
    if (action.type === (0, $2f454.CARD_DELETE)) {
        const { payload: { issueId: issueId } } = action;
        const index = state.indexOf(issueId);
        return index < 0 ? state : (0, $7uUwQ.splice)(state, index, 1);
    }
    if (action.type === (0, $3n65g.ADD_ISSUE_PARENT)) return [
        ...state,
        action.payload?.issue.id
    ];
    if (action.type === (0, $63F6h.COLUMN_DELETE_REQUEST)) {
        const { payload: { closestColumn: closestColumn, issuesInColumn: issuesInColumn } } = action;
        if (!closestColumn) {
            const issueIdsInColumn = new Set(issuesInColumn.map((issue)=>issue.id));
            return state.filter((id)=>!issueIdsInColumn.has(id));
        }
    }
    return state;
};

});

parcelRegister("8nEK3", function(module, exports) {

$parcel$export(module.exports, "boardIssuesReducer", () => $2c591dbfe53e913a$export$4cb59de18fd154ba);

var $7uUwQ = parcelRequire("7uUwQ");

var $k8IPx = parcelRequire("k8IPx");

var $4wVpT = parcelRequire("4wVpT");

var $4R6GH = parcelRequire("4R6GH");


var $doOdQ = parcelRequire("doOdQ");

var $2f454 = parcelRequire("2f454");

var $63F6h = parcelRequire("63F6h");

var $ls4NM = parcelRequire("ls4NM");

var $kXqRJ = parcelRequire("kXqRJ");

var $cIqUn = parcelRequire("cIqUn");

var $5UXId = parcelRequire("5UXId");

var $71oFY = parcelRequire("71oFY");

var $dkGow = parcelRequire("dkGow");

var $5G4Hb = parcelRequire("5G4Hb");

var $cW3pH = parcelRequire("cW3pH");
const $2c591dbfe53e913a$var$rankIssues = (state, payload)=>{
    const { issueIds: issueIds, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId } = payload;
    const availableIssues = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(state, issueIds);
    if (availableIssues.length === 0) return state;
    const newState = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(state, availableIssues);
    let destinationIndex;
    if (rankBeforeIssueId) destinationIndex = newState.indexOf(rankBeforeIssueId);
    else if (rankAfterIssueId) destinationIndex = newState.indexOf(rankAfterIssueId) + 1;
    else return state;
    return (0, $7uUwQ.splice)(newState, destinationIndex, 0, ...issueIds);
};
const $2c591dbfe53e913a$export$4cb59de18fd154ba = (state = [], action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        const { payload: { issues: issues, config: { boardIsRankable: boardIsRankable } } } = action;
        /* For a CMP project, the ordered issues include in:
		 * - issues and orphan subtasks if the board is rankable
		 * - issues and subtasks if the board is not rankable
		 * */ if (action.type === (0, $cW3pH.WORK_DATA_SET) && action.payload.orderedIssueIds) {
            if (!boardIsRankable) return action.payload.orderedIssueIds;
            const issueChildrenIdsWithParent = action.payload.issueChildren.filter(({ parentId: parentId })=>!!parentId && action.payload.orderedIssueIds?.includes(parentId)).map(({ id: id })=>id);
            return action.payload.orderedIssueIds.filter((id)=>!issueChildrenIdsWithParent.includes(id));
        }
        return issues.map((issue)=>issue.id);
    }
    if (action.type === (0, $ls4NM.ISSUE_CREATE_REQUEST)) {
        const { payload: { issues: issues, type: type }, meta: { insertBefore: insertBefore, isSubtaskMissingParent: isSubtaskMissingParent = false } } = action;
        if (type !== (0, $dcbb2bce513725b3$export$b05303cbde3e8c8c) && !isSubtaskMissingParent) return state;
        const issueIds = issues.map(({ id: id })=>id);
        const insertionPoint = insertBefore ? state.indexOf(insertBefore) : state.length;
        return (0, $7uUwQ.splice)(state, insertionPoint, 0, ...issueIds);
    }
    if (action.type === (0, $5G4Hb.REMOVE_FROM_SPRINT_REQUEST)) {
        const { payload: { issueId: issueId } } = action;
        const index = state.indexOf(issueId);
        return index < 0 ? state : (0, $7uUwQ.splice)(state, index, 1);
    }
    if ((0, $4R6GH.fg)('jira-removefromsprint-nodelay')) {
        if (action.type === (0, $dkGow.ADD_TO_SPRINT_SUCCESS)) {
            const { payload: { issueKey: issueKey } } = action;
            return (0, $7uUwQ.splice)(state, state.length, 0, issueKey);
        }
    }
    if (action.type === (0, $kXqRJ.ISSUE_DELETE_REQUEST)) {
        const { payload: { issue: issue } } = action;
        const index = state.indexOf(issue.id);
        if (index < 0) return state;
        return (0, $7uUwQ.splice)(state, index, 1);
    }
    if (action.type === (0, $2f454.CARD_DELETE)) {
        const { payload: { issueId: issueId } } = action;
        const index = state.indexOf(issueId);
        if (index < 0) return state;
        return (0, $7uUwQ.splice)(state, index, 1);
    }
    if (action.type === (0, $2f454.CARD_CLEAR)) {
        const { payload: { cardIds: cardIds } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        cardIds.forEach((cardId)=>{
            const index = newState.value().indexOf(cardId);
            if (index >= 0) // @ts-expect-error - TS2339 - Property 'splice' does not exist on type 'IcepickWrapper<IssuesState>'.
            newState.splice(index, 1);
        });
        return newState.value();
    }
    if (action.type === (0, $cIqUn.ISSUE_MOVE_TO_BACKLOG_REQUEST)) {
        const { payload: { issueIds: issueIds } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        issueIds.forEach((issueId)=>{
            const index = newState.value().indexOf(issueId);
            if (index >= 0) // @ts-expect-error - TS2339 - Property 'splice' does not exist on type 'IcepickWrapper<IssuesState>'.
            newState.splice(index, 1);
        });
        return newState.value();
    }
    if (action.type === (0, $ls4NM.ISSUE_CREATE_SUCCESS)) {
        const { payload: { temporaryIssueIds: temporaryIssueIds, issues: issues } } = action;
        const translation = {};
        temporaryIssueIds.forEach((id, index)=>{
            if (issues[index]) translation[id] = issues[index].id;
        });
        // Assume that no temporary id will ever be falsey (0).
        return Object.keys(translation).length > 0 ? (0, $7uUwQ.map)((oldId)=>translation[oldId] || oldId, state) : state;
    }
    if (action.type === (0, $5UXId.ISSUE_RANK_TEAM_DATE_REQUEST)) {
        const { payload: { issueIds: issueIds, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId } } = action;
        return $2c591dbfe53e913a$var$rankIssues(state, {
            issueIds: issueIds,
            rankBeforeIssueId: rankBeforeIssueId,
            rankAfterIssueId: rankAfterIssueId
        });
    }
    if (action.type === (0, $71oFY.ISSUE_RANK_TRANSITION_UPDATE_OPTIMISTIC)) {
        const { payload: { issueIds: issueIds, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId, mode: mode } } = action;
        /**
		 * We won't update the ranking if the moving card is transition only
		 * */ if (mode === 'TRANSITION_ONLY' || [
            rankBeforeIssueId,
            rankAfterIssueId
        ].includes(issueIds[0])) return state;
        return $2c591dbfe53e913a$var$rankIssues(state, {
            issueIds: issueIds,
            rankBeforeIssueId: rankBeforeIssueId,
            rankAfterIssueId: rankAfterIssueId
        });
    }
    if (action.type === (0, $71oFY.BULK_ISSUE_RANK_OPTIMISTIC)) {
        const { payload: { issueIds: issueIds, rankAfterId: rankAfterId, rankBeforeId: rankBeforeId } } = action;
        return $2c591dbfe53e913a$var$rankIssues(state, {
            issueIds: issueIds,
            rankBeforeIssueId: rankBeforeId,
            rankAfterIssueId: rankAfterId
        });
    }
    if (action.type === (0, $71oFY.SET_ISSUES_RANK)) {
        const { payload: { issueIds: issueIds, rankId: rankId, isRankAfter: isRankAfter } } = action;
        const availableIssues = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(state, issueIds);
        if (!availableIssues.length) return state;
        const newState = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(state, availableIssues);
        const rankItemIndex = newState.indexOf(rankId);
        const destinationIndex = isRankAfter ? rankItemIndex + 1 : rankItemIndex;
        return (0, $7uUwQ.splice)(newState, destinationIndex, 0, ...issueIds);
    }
    if (action.type === (0, $doOdQ.BACKLOG_ISSUE_MOVE_EXECUTE)) {
        const { payload: { issueIds: issueIds } } = action;
        return (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(state, issueIds);
    }
    if (action.type === (0, $63F6h.COLUMN_DELETE_REQUEST)) {
        const { payload: { closestColumn: closestColumn, issuesInColumn: issuesInColumn } } = action;
        if (!closestColumn) {
            const issueIdsInColumn = new Set(issuesInColumn.map((issue)=>issue.id));
            return state.filter((id)=>!issueIdsInColumn.has(id));
        }
    }
    return state;
};

});

parcelRegister("5NCzb", function(module, exports) {

$parcel$export(module.exports, "permissionsReducer", () => $561e00495f5b1795$export$b37cab870badc2b9);

var $127QL = parcelRequire("127QL");

var $cW3pH = parcelRequire("cW3pH");
const $561e00495f5b1795$export$d4c72bab9d6cc13a = {
    createIssue: false,
    deleteIssue: false,
    editIssue: false,
    manageSprint: false,
    editBoardConfig: false,
    manageAutomation: false,
    canRelease: false,
    createSprint: false,
    archiveIssue: false
};
const $561e00495f5b1795$export$b37cab870badc2b9 = (state = $561e00495f5b1795$export$d4c72bab9d6cc13a, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) return action.payload.boardPermissions;
    if (action.type === (0, $127QL.BOARD_DEFERRED_DATA_LOAD_SUCCESS) && action.payload.sprints) return {
        ...state,
        manageSprint: action.payload.sprints.some((sprint)=>sprint.canUpdateSprint)
    };
    return state;
};

});

parcelRegister("94E7k", function(module, exports) {

$parcel$export(module.exports, "selectedSprintsReducer", () => $f14f71dca75bd65b$export$631001c1ce1d2568);

var $cW3pH = parcelRequire("cW3pH");
const $f14f71dca75bd65b$export$631001c1ce1d2568 = (state = null, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        const { sprints: sprints } = action.payload;
        return sprints && sprints.length > 0 ? sprints.map((sprint)=>sprint.id) : null;
    }
    return state;
};

});


parcelRegister("f8jqi", function(module, exports) {

$parcel$export(module.exports, "cardTransitionsReducer", () => $88394d411a7227ba$export$5d84a78ff63fb23c);

var $7uUwQ = parcelRequire("7uUwQ");

var $glGhK = parcelRequire("glGhK");

var $63F6h = parcelRequire("63F6h");

var $63VRQ = parcelRequire("63VRQ");

var $cW3pH = parcelRequire("cW3pH");
const $88394d411a7227ba$var$initialState = (0, $7uUwQ.freeze)({
    columnIssueTypeTransitions: {},
    issueTypeStatus: {}
});
const $88394d411a7227ba$export$5d84a78ff63fb23c = (state = $88394d411a7227ba$var$initialState, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        const { payload: { cardTransitions: cardTransitions } } = action;
        return (0, $7uUwQ.freeze)(cardTransitions || $88394d411a7227ba$var$initialState);
    }
    if (action.type === (0, $glGhK.COLUMN_CREATE_SUCCESS)) {
        const { payload: { cardTransitions: cardTransitions } } = action;
        if (cardTransitions) return (0, $7uUwQ.freeze)(cardTransitions);
    }
    if (action.type === (0, $63F6h.COLUMN_DELETE_SUCCESS)) {
        const { payload: { cardTransitions: cardTransitions } } = action;
        if (cardTransitions) return (0, $7uUwQ.freeze)(cardTransitions);
    }
    if (action.type === (0, $63VRQ.COLUMN_RENAME_SUCCESS)) {
        const { payload: { cardTransitions: cardTransitions } } = action;
        if (cardTransitions) return (0, $7uUwQ.merge)(state, cardTransitions);
    }
    return state;
};

});

parcelRegister("lAVlQ", function(module, exports) {

$parcel$export(module.exports, "columnsReducer", () => $0a5b0d53133a989d$export$e965e01e388e7003);

var $7uUwQ = parcelRequire("7uUwQ");

var $91VA7 = parcelRequire("91VA7");

var $hGgHi = parcelRequire("hGgHi");

var $5rFbt = parcelRequire("5rFbt");

var $esu6n = parcelRequire("esu6n");

var $1ShTS = parcelRequire("1ShTS");

var $glGhK = parcelRequire("glGhK");

var $63F6h = parcelRequire("63F6h");

var $9eeht = parcelRequire("9eeht");

var $63VRQ = parcelRequire("63VRQ");

var $cW3pH = parcelRequire("cW3pH");
const $0a5b0d53133a989d$export$e965e01e388e7003 = (state = (0, $7uUwQ.freeze)({}), action)=>{
    if ((action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) && action.payload.columns) return (0, $7uUwQ.freeze)((0, $1ShTS.entityArrayToMap)(action.payload.columns));
    if (action.type === (0, $63VRQ.COLUMN_RENAME_REQUEST)) {
        const { columnId: columnId, name: name } = action.payload;
        return (0, $7uUwQ.setIn)(state, [
            columnId,
            'name'
        ], name);
    }
    if (action.type === (0, $63F6h.COLUMN_DELETE_REQUEST)) {
        const { columnId: columnId } = action.payload;
        return (0, $7uUwQ.unset)(state, columnId);
    }
    if (action.type === (0, $63VRQ.COLUMN_RENAME_SUCCESS)) {
        const { columnId: columnId, statuses: statuses } = action.payload;
        const newStatuses = [
            ...statuses
        ];
        return (0, $7uUwQ.setIn)(state, [
            columnId,
            'statuses'
        ], newStatuses);
    }
    if (action.type === (0, $63F6h.COLUMN_DELETE_SUCCESS) || action.type === (0, $glGhK.COLUMN_CREATE_SUCCESS)) {
        let newState = (0, (/*@__PURE__*/$parcel$interopDefault($91VA7)))(state);
        if (action.type === (0, $glGhK.COLUMN_CREATE_SUCCESS)) {
            const { temporaryColumnId: temporaryColumnId, column: column } = action.payload;
            newState = (0, $7uUwQ.unset)(newState, temporaryColumnId);
            newState = (0, $7uUwQ.set)(newState, column.id, column);
        }
        action.payload.columns.filter((column)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(newState[column.id]) && column.type === (0, $5rFbt.ColumnType).STATUS).forEach((column)=>{
            newState = (0, $7uUwQ.setIn)(newState, [
                column.id,
                'statuses'
            ], (0, $7uUwQ.map)((status)=>({
                    ...status,
                    category: column.statuses[0].category,
                    isInitial: column.statuses[0].isInitial,
                    isDone: column.statuses[0].isDone
                }), (0, $esu6n.getStatusColumn)(newState[column.id])?.statuses ?? []));
        });
        return newState;
    }
    if (action.type === (0, $glGhK.COLUMN_CREATE_REQUEST)) {
        const { temporaryColumnId: id, name: name } = action.payload;
        const newState = (0, $7uUwQ.merge)(state, {
            [id]: {
                id: id,
                name: name,
                statuses: [
                    {
                        id: id,
                        name: name,
                        isInitial: false,
                        isDone: false
                    }
                ],
                maxIssueCount: null
            }
        });
        return newState;
    }
    if (action.type === (0, $9eeht.COLUMN_SET_LIMITS_REQUEST)) {
        const { columnId: columnId, maxIssueCount: maxIssueCount, minIssueCount: minIssueCount } = action.payload;
        const newState = (0, $7uUwQ.merge)(state, {
            [columnId]: {
                maxIssueCount: maxIssueCount,
                minIssueCount: minIssueCount
            }
        });
        return newState;
    }
    return state;
};

});

parcelRegister("1cp3g", function(module, exports) {

$parcel$export(module.exports, "customFiltersReducer", () => $6965c6a3cdfa88e9$export$dbd98ee5f91df1a);

var $cW3pH = parcelRequire("cW3pH");
const $6965c6a3cdfa88e9$var$initialState = {
    filters: []
};
function $6965c6a3cdfa88e9$export$dbd98ee5f91df1a(state = $6965c6a3cdfa88e9$var$initialState, action) {
    if (action.type === (0, $cW3pH.WORK_DATA_SET) && action.payload.customFilters) return {
        filters: action.payload.customFilters
    };
    return state;
}

});

parcelRegister("b4Neb", function(module, exports) {

$parcel$export(module.exports, "estimationStatisticReducer", () => $e3162cc4f5f52d29$export$f90c5d49c06c31b6);

var $cW3pH = parcelRequire("cW3pH");
const $e3162cc4f5f52d29$export$f90c5d49c06c31b6 = (state = '', action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) return action.payload.estimationStatistic;
    return state;
};

});

parcelRegister("4AaHD", function(module, exports) {

$parcel$export(module.exports, "incrementConfigReducer", () => $6d5928cf94d48ee0$export$c12241c4f89682f);

var $cW3pH = parcelRequire("cW3pH");
const $6d5928cf94d48ee0$export$c12241c4f89682f = (state = null, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) return action.payload.incrementConfig || null;
    return state;
};

});

parcelRegister("6v6W4", function(module, exports) {

$parcel$export(module.exports, "inlineCreateReducer", () => $e87fe470f7fcfd99$export$1b02c7a713d71ddd);

var $l67YV = parcelRequire("l67YV");
const $e87fe470f7fcfd99$var$defaultState = {
    sessionId: undefined
};
const $e87fe470f7fcfd99$export$1b02c7a713d71ddd = (state = $e87fe470f7fcfd99$var$defaultState, action)=>{
    switch(action.type){
        case 0, $l67YV.SET_INLINE_CREATE_SESSION_ID:
            return {
                ...state,
                sessionId: action.payload.sessionId
            };
        case 0, $l67YV.CLEAR_INLINE_CREATE_SESSION_ID:
            return {
                ...state,
                sessionId: undefined
            };
        default:
            return state;
    }
};

});
parcelRegister("l67YV", function(module, exports) {

$parcel$export(module.exports, "SET_INLINE_CREATE_SESSION_ID", () => $9350534239458f71$export$b7afd69edc8efc16);
$parcel$export(module.exports, "setInlineCreateSessionId", () => $9350534239458f71$export$69abc158578163fc);
$parcel$export(module.exports, "CLEAR_INLINE_CREATE_SESSION_ID", () => $9350534239458f71$export$932498ee6899f22a);
$parcel$export(module.exports, "clearInlineCreateSessionId", () => $9350534239458f71$export$138f7b7b7eb9ceaa);
const $9350534239458f71$export$b7afd69edc8efc16 = 'state.actions.inline-create.SET_INLINE_CREATE_SESSION_ID';
const $9350534239458f71$export$69abc158578163fc = (sessionId)=>({
        type: $9350534239458f71$export$b7afd69edc8efc16,
        payload: {
            sessionId: sessionId
        }
    });
const $9350534239458f71$export$49df3fa957b0423b = 'state.actions.inline-create.SET_SELECTED_PROJECT_ID_IN_ICC';
const $9350534239458f71$export$a77c5a113697f11b = (projectId)=>({
        type: $9350534239458f71$export$49df3fa957b0423b,
        payload: {
            projectId: projectId
        }
    });
const $9350534239458f71$export$932498ee6899f22a = 'state.actions.inline-create.CLEAR_INLINE_CREATE_SESSION_ID';
const $9350534239458f71$export$138f7b7b7eb9ceaa = ()=>({
        type: $9350534239458f71$export$932498ee6899f22a
    });

});


parcelRegister("7ANej", function(module, exports) {

$parcel$export(module.exports, "issueChildrenReducer", () => $cea454cbf4b26b1a$export$fef692bb0099f36);

var $7uUwQ = parcelRequire("7uUwQ");

var $dDkmN = parcelRequire("dDkmN");

var $5rFbt = parcelRequire("5rFbt");


var $c79wa = parcelRequire("c79wa");

var $1ShTS = parcelRequire("1ShTS");

var $2f454 = parcelRequire("2f454");

var $63F6h = parcelRequire("63F6h");

var $e1q2I = parcelRequire("e1q2I");

var $4gHuj = parcelRequire("4gHuj");

var $iaYF9 = parcelRequire("iaYF9");

var $cAxle = parcelRequire("cAxle");

var $ls4NM = parcelRequire("ls4NM");

var $kXqRJ = parcelRequire("kXqRJ");

var $9WrsG = parcelRequire("9WrsG");

var $fBkjL = parcelRequire("fBkjL");

var $3n65g = parcelRequire("3n65g");

var $71oFY = parcelRequire("71oFY");

var $evkwq = parcelRequire("evkwq");

var $cW3pH = parcelRequire("cW3pH");
const $cea454cbf4b26b1a$export$fef692bb0099f36 = (state = {}, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) return (0, $1ShTS.entityArrayToMap)(action.payload.issueChildren);
    if (action.type === (0, $ls4NM.ISSUE_CREATE_REQUEST)) {
        const { payload: { issues: issues, type: type } } = action;
        if (type !== (0, $dcbb2bce513725b3$export$1f24f91824c6822f)) return state;
        const newState = {
            ...state
        };
        issues.forEach((issue)=>{
            newState[String(issue.id)] = issue;
        });
        return (0, $7uUwQ.freeze)(newState);
    }
    if (action.type === (0, $ls4NM.ISSUE_CREATE_SUCCESS)) {
        const { payload: { temporaryIssueIds: temporaryIssueIds, issues: issues } } = action;
        const newState = {
            ...state
        };
        if (temporaryIssueIds.some((id)=>state[String(id)])) {
            temporaryIssueIds.forEach((temporaryId)=>{
                delete newState[String(temporaryId)];
            });
            issues.forEach((issue)=>{
                newState[String(issue.id)] = issue;
            });
            return (0, $7uUwQ.freeze)(newState);
        }
        return state;
    }
    if (action.type === (0, $4gHuj.SET_ISSUE_CHILDREN)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: issueChildren } = action;
        return (0, $7uUwQ.freeze)((0, $1ShTS.entityArrayToMap)(issueChildren));
    }
    if (action.type === (0, $evkwq.ISSUE_UPDATE_SUCCESS)) {
        const { payload: { issue: issue } } = action;
        const issueId = String(issue.id);
        if (state[issueId]) return (0, $7uUwQ.set)(state, issueId, issue);
        return state;
    }
    if (action.type === (0, $2f454.CARD_CLEAR)) {
        const { payload: { childCardIds: childCardIds } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        childCardIds.forEach((cardId)=>{
            newState.unset(cardId);
        });
        return newState.value();
    }
    if (action.type === (0, $2f454.CARD_DATA_SET)) {
        const { payload: { issue: issue } } = action;
        const issueId = String(issue.id);
        if (state[issueId]) return (0, $7uUwQ.set)(state, issueId, issue);
        return state;
    }
    if (action.type === (0, $kXqRJ.ISSUE_DELETE_REQUEST)) {
        const { payload: { issue: { id: id }, childIssueIds: childIssueIds } } = action;
        const subtaskIssueId = String(id);
        if (state[subtaskIssueId]) return (0, $7uUwQ.unset)(state, subtaskIssueId);
        if (childIssueIds.length > 0) {
            const changeChain = (0, $7uUwQ.chain)(state);
            childIssueIds.forEach((childIssueId)=>{
                changeChain.unset(String(childIssueId));
            });
            return changeChain.value();
        }
        return state;
    }
    if (action.type === (0, $2f454.CARD_DELETE)) {
        const { payload: { issueId: issueId } } = action;
        if (state[String(issueId)]) return (0, $7uUwQ.unset)(state, String(issueId));
        return state;
    }
    if (action.type === (0, $71oFY.ISSUE_RANK_TRANSITION_UPDATE_OPTIMISTIC)) {
        const { payload: { issueIds: issueIds, destinationColumnId: destinationColumnId, isDestinationDone: isDestinationDone, destinationStatus: destinationStatus } } = action;
        const changeChain = (0, $7uUwQ.chain)(state);
        issueIds.forEach((issueId)=>{
            if (!state[String(issueId)]) return;
            changeChain.setIn([
                String(issueId),
                'columnId'
            ], destinationColumnId);
            if (destinationStatus) changeChain.setIn([
                String(issueId),
                'statusId'
            ], Number(destinationStatus.id));
            const currentIssue = state[String(issueId)];
            if (currentIssue.columnId !== destinationColumnId) changeChain.setIn([
                String(issueId),
                'isDone'
            ], isDestinationDone);
        });
        return changeChain.value();
    }
    if (action.type === (0, $e1q2I.ISSUE_CHANGE_SWIMLANE)) {
        const { payload: { issueIds: issueIds, swimlaneValues: swimlaneValues } } = action;
        const changeChain = (0, $7uUwQ.chain)(state);
        issueIds.forEach((issueId)=>{
            if (!state[String(issueId)]) return;
            if (swimlaneValues.type === (0, $c79wa.STORY)) changeChain.setIn([
                String(issueId),
                'parentId'
            ], swimlaneValues.parentId);
            if (swimlaneValues.type === (0, $c79wa.ASSIGNEE)) changeChain.setIn([
                String(issueId),
                'assigneeAccountId'
            ], swimlaneValues.assigneeAccountId);
        });
        return changeChain.value();
    }
    if (action.type === (0, $9WrsG.DEV_STATUS_LOAD_SUCCESS)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        const newState = (0, $7uUwQ.chain)(state);
        Object.keys(payload).forEach((issueIdString)=>{
            if (!state[String(issueIdString)]) return;
            newState.setIn([
                issueIdString,
                'devStatus'
            ], payload[issueIdString]);
        });
        return newState.value();
    }
    if (action.type === (0, $fBkjL.ISSUE_FLAG_WITH_COMMENT_REQUEST)) {
        const { payload: { issueIds: issueIds, flag: flag } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        issueIds.forEach((id)=>{
            if (state[String(id)]) newState.setIn([
                String(id),
                'isFlagged'
            ], flag);
        });
        return newState.value();
    }
    if (action.type === (0, $63F6h.COLUMN_DELETE_REQUEST)) {
        const newState = {
            ...state
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        Object.keys(state).filter((issueKey)=>state[issueKey].columnId === payload.columnId).forEach((issueKey)=>{
            if (!payload.closestColumn) delete newState[issueKey];
            else if (payload.closestColumn.type === (0, $5rFbt.ColumnType).STATUS) newState[issueKey] = {
                ...newState[issueKey],
                columnId: payload.closestColumn.id,
                statusId: payload.closestColumn.statuses[0].id
            };
        });
        return newState;
    }
    if (action.type === (0, $iaYF9.ISSUE_ADD_LABELS)) {
        const { payload: { issueIds: issueIds, labels: labels } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        issueIds.forEach((id)=>{
            if (!state[String(id)]) return;
            const currentLabels = state[String(id)].labels || [];
            newState.setIn([
                String(id),
                'labels'
            ], (0, (/*@__PURE__*/$parcel$interopDefault($dDkmN)))(currentLabels, labels));
        });
        return newState.value();
    }
    if (action.type === (0, $3n65g.SET_PARENT_OPTIMISTIC)) {
        const { payload: { issues: issues, parentId: parentId } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        issues.forEach((issue)=>{
            if (!state[String(issue.id)]) return;
            newState.setIn([
                String(issue.id),
                'parentId'
            ], parentId);
        });
        return newState.value();
    }
    if (action.type === (0, $evkwq.SET_ISSUE_PARENT)) {
        const { payload: { issueId: issueId, issueParentId: issueParentId } } = action;
        return state[String(issueId)] ? (0, $7uUwQ.setIn)(state, [
            String(issueId),
            'parentId'
        ], issueParentId) : state;
    }
    if (action.type === (0, $cAxle.ASSIGN_TO_ME_REQUEST)) {
        const { payload: { issueId: issueId, assigneeAccountId: assigneeAccountId } } = action;
        return state[String(issueId)] ? (0, $7uUwQ.setIn)(state, [
            String(issueId),
            'assigneeAccountId'
        ], assigneeAccountId) : state;
    }
    return state;
};

});
parcelRegister("dDkmN", function(module, exports) {

var $ekcP3 = parcelRequire("ekcP3");

var $g7i7g = parcelRequire("g7i7g");

var $7CoLY = parcelRequire("7CoLY");

var $f3SOL = parcelRequire("f3SOL");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $9eceb74c74389aa2$var$union = $g7i7g(function(arrays) {
    return $7CoLY($ekcP3(arrays, 1, $f3SOL, true));
});
module.exports = $9eceb74c74389aa2$var$union;

});


parcelRegister("9YkOZ", function(module, exports) {

$parcel$export(module.exports, "IssueLinkTypesReducer", () => $9048799d461b8027$export$8ae1bfe9b50d49e1);

var $cW3pH = parcelRequire("cW3pH");
const $9048799d461b8027$export$8ae1bfe9b50d49e1 = (state = [], action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) return action.payload.issueLinkTypes || [];
    return state;
};

});

parcelRegister("8UrfO", function(module, exports) {

$parcel$export(module.exports, "issueLinksPermissionsReducer", () => $5badfcd4f6059ce4$export$c36129b79b23648c);

var $cwdC8 = parcelRequire("cwdC8");
const $5badfcd4f6059ce4$var$initialState = {
    canUserLinkIssue: false,
    issueLinkTypes: []
};
const $5badfcd4f6059ce4$export$c36129b79b23648c = (state = $5badfcd4f6059ce4$var$initialState, action)=>{
    if (action.type === (0, $cwdC8.SET_ISSUE_LINKS_PERMISSIONS)) {
        const { payload: payload } = action;
        return payload;
    }
    return state;
};

});

parcelRegister("7UqIo", function(module, exports) {

$parcel$export(module.exports, "issueLinksStatsReducer", () => $2739d03280fa896b$export$2d8536f954ee93c4);

var $4RVsR = parcelRequire("4RVsR");
const $2739d03280fa896b$var$initialState = {
    statisticItems: {},
    loadingStatisticsItems: []
};
const $2739d03280fa896b$export$2d8536f954ee93c4 = (state = $2739d03280fa896b$var$initialState, action)=>{
    if (action.type === (0, $4RVsR.SET_ISSUE_LINKS_STATS)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        return {
            statisticItems: {
                ...state.statisticItems,
                ...payload.statisticItems
            },
            loadingStatisticsItems: []
        };
    }
    if (action.type === (0, $4RVsR.SET_ISSUE_LINKS_STATS_LOADING)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        return {
            ...state,
            loadingStatisticsItems: payload
        };
    }
    return state;
};

});

parcelRegister("2ZUt8", function(module, exports) {

$parcel$export(module.exports, "issueMediaReducer", () => $065f4ee1be2c8dd1$export$f10a05bd85382e68);

var $7uUwQ = parcelRequire("7uUwQ");

var $2f454 = parcelRequire("2f454");

var $dN3Ms = parcelRequire("dN3Ms");

var $cW3pH = parcelRequire("cW3pH");
const $065f4ee1be2c8dd1$export$f10a05bd85382e68 = (state = {}, action)=>{
    if (action.type === (0, $dN3Ms.ISSUE_MEDIA_VISIBILITY_CHANGE_REQUEST)) {
        const { issueId: issueId, isVisible: isVisible } = action.payload;
        return (0, $7uUwQ.setIn)(state, [
            `${issueId}`,
            'isHiddenByUser'
        ], !isVisible);
    }
    if (action.type === (0, $cW3pH.WORK_DATA_SET)) {
        const { payload: { issueMedia: issueMedia } } = action;
        return (0, $7uUwQ.merge)(state, issueMedia);
    }
    if (action.type === (0, $2f454.CARD_MEDIA_DATA_SET)) {
        const { payload: { issueMedia: issueMedia } } = action;
        return (0, $7uUwQ.merge)(state, issueMedia);
    }
    return state;
};

});

parcelRegister("jVK6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $1043ebaae86b63b4$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $1ShTS = parcelRequire("1ShTS");

var $2f454 = parcelRequire("2f454");

var $3n65g = parcelRequire("3n65g");

var $4l4AL = parcelRequire("4l4AL");

var $cW3pH = parcelRequire("cW3pH");
const $1043ebaae86b63b4$var$reducer = (state = {}, action)=>{
    switch(action.type){
        case 0, $cW3pH.WORK_DATA_SET:
        case 0, $cW3pH.WORK_DATA_CRITICAL_SET:
            return (0, $1ShTS.entityArrayToMap)(action.payload.issueParents);
        case 0, $3n65g.SET_ISSUE_PARENT_SUMMARY:
            {
                const { issueId: issueId, issueSummary: issueSummary } = action.payload;
                if (state[String(issueId)]) return (0, $7uUwQ.setIn)(state, [
                    String(issueId),
                    'summary'
                ], issueSummary);
                return state;
            }
        case 0, $4l4AL.SET_SUMMARY:
            {
                const { payload: { issueId: issueId, summary: summary } } = action;
                if (state[String(issueId)]) return (0, $7uUwQ.chain)(state).setIn([
                    String(issueId),
                    'summary'
                ], summary).value();
                return state;
            }
        case 0, $3n65g.SET_ISSUE_PARENT_STATUS:
            {
                const { issueId: issueId, status: status } = action.payload;
                if (state[String(issueId)]) return (0, $7uUwQ.setIn)(state, [
                    String(issueId),
                    'status'
                ], status);
                return state;
            }
        case 0, $2f454.CARD_DELETE:
            {
                const { payload: { issueId: issueId } } = action;
                return state[String(issueId)] ? (0, $7uUwQ.unset)(state, String(issueId)) : state;
            }
        case 0, $3n65g.ADD_ISSUE_PARENT:
            {
                const { issue: issue } = action.payload;
                return (0, $7uUwQ.setIn)(state, [
                    String(issue.id)
                ], issue);
            }
        default:
            return state;
    }
};
var $1043ebaae86b63b4$export$2e2bcd8739ae039 = $1043ebaae86b63b4$var$reducer;

});
parcelRegister("4l4AL", function(module, exports) {

$parcel$export(module.exports, "SET_SUMMARY", () => $8493049eed778780$export$f10628d1e68d9122);
$parcel$export(module.exports, "setSummary", () => $8493049eed778780$export$73eb0ea85742026e);
const $8493049eed778780$export$f10628d1e68d9122 = 'state.actions.issue.summary.SET_SUMMARY';
const $8493049eed778780$export$73eb0ea85742026e = (issueId, summary)=>({
        type: $8493049eed778780$export$f10628d1e68d9122,
        payload: {
            issueId: issueId,
            summary: summary
        }
    });

});


parcelRegister("e3PD9", function(module, exports) {

$parcel$export(module.exports, "issueProjectsReducer", () => $03b0cf5266a48e76$export$389f8d361922f42f);

var $1ShTS = parcelRequire("1ShTS");

var $cW3pH = parcelRequire("cW3pH");
const $03b0cf5266a48e76$export$389f8d361922f42f = (state = {}, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) return (0, $1ShTS.entityArrayToMap)(action.payload.projects);
    return state;
};

});

parcelRegister("qY0zX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cf6a330964f9ec0$export$2e2bcd8739ae039);

var $eu61M = parcelRequire("eu61M");

var $2f454 = parcelRequire("2f454");
const $1cf6a330964f9ec0$var$emptyState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1cf6a330964f9ec0$export$2e2bcd8739ae039 = (state = $1cf6a330964f9ec0$var$emptyState, action)=>{
    switch(action.type){
        case 0, $2f454.CARD_GET_ISSUE_TRANSITIONS:
            return {
                [String(action.payload.issueId)]: {
                    status: 'loading'
                }
            };
        case 0, $2f454.CARD_SET_ISSUE_TRANSITIONS:
            return {
                [String(action.payload.issueId)]: {
                    status: 'success',
                    data: action.payload.columnTransitions
                }
            };
        case 0, $2f454.CARD_GET_ISSUE_TRANSITIONS_FAILURE:
            return {
                [String(action.payload.issueId)]: {
                    status: 'failure'
                }
            };
        case 0, $eu61M.DRAG_END:
            return $1cf6a330964f9ec0$var$emptyState;
        default:
            return state;
    }
};

});

parcelRegister("11N2b", function(module, exports) {

$parcel$export(module.exports, "issueTypesByProjectReducer", () => $7beb707e6ea337be$export$1ca1e60461ab7ad0);

var $cW3pH = parcelRequire("cW3pH");
const $7beb707e6ea337be$export$1ca1e60461ab7ad0 = (state = {}, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) return action.payload.issueTypesByProject || {};
    return state;
};

});

parcelRegister("ilheH", function(module, exports) {

$parcel$export(module.exports, "issueTypesReducer", () => $ec796d54b4bd0aa3$export$336eabad729f8d11);

var $1ShTS = parcelRequire("1ShTS");

var $cW3pH = parcelRequire("cW3pH");
const $ec796d54b4bd0aa3$export$336eabad729f8d11 = (state = {}, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        const { payload: { issueTypes: issueTypes } } = action;
        return (0, $1ShTS.entityArrayToMap)(issueTypes);
    }
    return state;
};

});

parcelRegister("eeFib", function(module, exports) {

$parcel$export(module.exports, "issueEntitiesReducer", () => $3466276f37f06248$export$cef6d2e3275b53a3);

var $7uUwQ = parcelRequire("7uUwQ");

var $dDkmN = parcelRequire("dDkmN");

var $5rFbt = parcelRequire("5rFbt");

var $4R6GH = parcelRequire("4R6GH");

var $4jAPy = parcelRequire("4jAPy");

var $g5X3G = parcelRequire("g5X3G");


var $c79wa = parcelRequire("c79wa");

var $1ShTS = parcelRequire("1ShTS");

var $doOdQ = parcelRequire("doOdQ");

var $2f454 = parcelRequire("2f454");

var $63F6h = parcelRequire("63F6h");

var $e1q2I = parcelRequire("e1q2I");

var $iaYF9 = parcelRequire("iaYF9");

var $cAxle = parcelRequire("cAxle");

var $dMBwz = parcelRequire("dMBwz");

var $4nScF = parcelRequire("4nScF");

var $ls4NM = parcelRequire("ls4NM");

var $kXqRJ = parcelRequire("kXqRJ");

var $9WrsG = parcelRequire("9WrsG");

var $9jMeJ = parcelRequire("9jMeJ");

var $fBkjL = parcelRequire("fBkjL");

var $6WzWZ = parcelRequire("6WzWZ");

var $cIqUn = parcelRequire("cIqUn");

var $3n65g = parcelRequire("3n65g");

var $5UXId = parcelRequire("5UXId");

var $71oFY = parcelRequire("71oFY");

var $4l4AL = parcelRequire("4l4AL");

var $evkwq = parcelRequire("evkwq");

var $cW3pH = parcelRequire("cW3pH");
const $3466276f37f06248$export$cef6d2e3275b53a3 = (state = (0, $7uUwQ.freeze)({}), action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        const { payload: { issues: issues } } = action;
        return (0, $7uUwQ.freeze)((0, $1ShTS.entityArrayToMap)(issues));
    }
    if (action.type === (0, $5UXId.ISSUE_RANK_TEAM_DATE_REQUEST)) {
        const { payload: { issueIds: issueIds, destinationColumnId: destinationColumnId, destinationSwimlaneId: destinationSwimlaneId } } = action;
        const changeChain = (0, $7uUwQ.chain)(state);
        issueIds.forEach((issueId)=>{
            if (!state[String(issueId)]) return;
            changeChain.setIn([
                String(issueId),
                'columnId'
            ], destinationColumnId);
            changeChain.setIn([
                String(issueId),
                'teamId'
            ], destinationSwimlaneId === (0, $4jAPy.SWIMLANE_TEAMLESS) ? undefined : destinationSwimlaneId);
            changeChain.setIn([
                String(issueId),
                'hasScenarioChanges'
            ], true);
        });
        return changeChain.value();
    }
    if (action.type === (0, $dMBwz.ISSUE_BULK_UPDATE_REQUEST)) {
        const { payload: { issueIds: issueIds, sprint: sprint } } = action;
        const changeChain = (0, $7uUwQ.chain)(state);
        issueIds.forEach((issueId)=>{
            if (!state[String(issueId)] || sprint === undefined) return;
            changeChain.setIn([
                String(issueId),
                'sprintId'
            ], sprint);
        });
        return changeChain.value();
    }
    if (action.type === (0, $ls4NM.ISSUE_CREATE_REQUEST)) {
        const { payload: { issues: issues, type: type } } = action;
        if (type !== (0, $dcbb2bce513725b3$export$b05303cbde3e8c8c)) return state;
        const newState = {
            ...state
        };
        issues.forEach((issue)=>{
            newState[String(issue.id)] = issue;
        });
        return (0, $7uUwQ.freeze)(newState);
    }
    if (action.type === (0, $ls4NM.ISSUE_CREATE_SUCCESS)) {
        const { payload: { temporaryIssueIds: temporaryIssueIds, issues: issues } } = action;
        const newState = {
            ...state
        };
        if (temporaryIssueIds.some((id)=>state[String(id)])) {
            temporaryIssueIds.forEach((temporaryId)=>{
                delete newState[String(temporaryId)];
            });
            issues.forEach((issue)=>{
                newState[String(issue.id)] = issue;
            });
            return (0, $7uUwQ.freeze)(newState);
        }
        return state;
    }
    if (action.type === (0, $evkwq.ISSUE_UPDATE_SUCCESS)) {
        const { payload: { issue: issue } } = action;
        const issueId = String(issue.id);
        if (state[issueId]) return (0, $7uUwQ.set)(state, issueId, issue);
        return state;
    }
    if (action.type === (0, $2f454.CARD_DATA_SET)) {
        const { payload: { issue: issue } } = action;
        const issueId = String(issue.id);
        const issueInState = state[issueId];
        if (issueInState) return (0, $7uUwQ.set)(state, issueId, {
            ...issue,
            devStatus: issue.devStatus || issueInState.devStatus
        });
        if (state[issueId]) return (0, $7uUwQ.set)(state, issueId, issue);
        return state;
    }
    if (action.type === (0, $kXqRJ.ISSUE_DELETE_REQUEST)) {
        const { payload: { issue: issue } } = action;
        return (0, $7uUwQ.unset)(state, String(issue.id));
    }
    if (action.type === (0, $2f454.CARD_DELETE)) {
        const { payload: { issueId: issueId, parentId: parentId, isDone: isDone } } = action;
        // if the deleted issue is a base level issue, remove the issue right away
        if (state[String(issueId)]) return (0, $7uUwQ.unset)(state, String(issueId));
        // if the deleted issue is a subtask, update children properties of the issue
        if (state[String(parentId)]) return (0, $7uUwQ.chain)(state).updateIn([
            String(parentId),
            'numCompleteChildren'
        ], (value)=>isDone ? Math.max(value - 1, 0) : value).updateIn([
            String(parentId),
            'numTotalChildren'
        ], (value)=>Math.max(value - 1, 0)).value();
        // if the deleted issue is an epic, update the issues that are children of the epic
        const newState = (0, $7uUwQ.chain)(state);
        (0, $g5X3G.values)(state).forEach(({ id: id, parentId: issueParentId })=>{
            if (issueId && issueId === issueParentId) newState.setIn([
                String(id),
                'parentId'
            ], null);
        });
        return newState.value();
    }
    if (action.type === (0, $2f454.CARD_CLEAR)) {
        const { payload: { cardIds: cardIds } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        cardIds.forEach((cardId)=>{
            newState.unset(String(cardId));
        });
        return newState.value();
    }
    if (action.type === (0, $cIqUn.ISSUE_MOVE_TO_BACKLOG_REQUEST)) {
        const { payload: { issueIds: issueIds } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        issueIds.forEach((issueId)=>{
            newState.unset(String(issueId));
        });
        return newState.value();
    }
    if (action.type === (0, $71oFY.ISSUE_RANK_TRANSITION_UPDATE_OPTIMISTIC)) {
        const { payload: { issueIds: issueIds, destinationColumnId: destinationColumnId, isDestinationDone: isDestinationDone, destinationStatus: destinationStatus, isCMPBoard: isCMPBoard } } = action;
        const changeChain = (0, $7uUwQ.chain)(state);
        issueIds.forEach((issueId)=>{
            if (!state[String(issueId)]) return;
            changeChain.setIn([
                String(issueId),
                'columnId'
            ], destinationColumnId);
            if (destinationStatus) changeChain.setIn([
                String(issueId),
                'statusId'
            ], Number(destinationStatus.id));
            if (!isCMPBoard) // We use `isDone` to show issue key strikethrough as an indicator of issue resolution.
            // Only for TMP, status' category equaling `Done` means the issue is resolved.
            // For CMP, we cannot determine an issue's resolution completely client-side due to the complexities of non-simplified workflows.
            // As we fire a data refresh request on each issue transition for CMP, the correct `isDone` value will be pulled from the server anyway with a slight delay.
            changeChain.setIn([
                String(issueId),
                'isDone'
            ], isDestinationDone);
        });
        return changeChain.value();
    }
    if (action.type === (0, $doOdQ.BACKLOG_ISSUE_MOVE_EXECUTE)) {
        const { payload: { issueIds: issueIds } } = action;
        const changeChain = (0, $7uUwQ.chain)(state);
        issueIds.forEach((id)=>changeChain.unset(String(id)));
        return changeChain.value();
    }
    if (action.type === (0, $e1q2I.ISSUE_CHANGE_SWIMLANE)) {
        const { payload: { issueIds: issueIds, swimlaneValues: swimlaneValues } } = action;
        const changeChain = (0, $7uUwQ.chain)(state);
        issueIds.forEach((issueId)=>{
            if (!state[String(issueId)]) return;
            if (swimlaneValues.type === (0, $c79wa.ASSIGNEE)) changeChain.setIn([
                String(issueId),
                'assigneeAccountId'
            ], swimlaneValues.assigneeAccountId);
            if (swimlaneValues.type === (0, $c79wa.PARENT)) changeChain.setIn([
                String(issueId),
                'parentId'
            ], swimlaneValues.parentId);
        });
        return changeChain.value();
    }
    if (action.type === (0, $9WrsG.DEV_STATUS_LOAD_SUCCESS)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        const newState = (0, $7uUwQ.chain)(state);
        Object.keys(payload).forEach((issueIdString)=>{
            if (!state[String(issueIdString)]) return;
            newState.setIn([
                issueIdString,
                'devStatus'
            ], payload[issueIdString]);
        });
        return newState.value();
    }
    if (action.type === (0, $fBkjL.ISSUE_FLAG_WITH_COMMENT_REQUEST)) {
        const { payload: { issueIds: issueIds, flag: flag } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        issueIds.forEach((id)=>{
            if (state[String(id)]) newState.setIn([
                String(id),
                'isFlagged'
            ], flag);
        });
        return newState.value();
    }
    if (action.type === (0, $cAxle.ASSIGN_TO_ME_REQUEST)) {
        const { payload: { issueId: issueId, assigneeAccountId: assigneeAccountId } } = action;
        return state[String(issueId)] ? (0, $7uUwQ.setIn)(state, [
            String(issueId),
            'assigneeAccountId'
        ], assigneeAccountId) : state;
    }
    if (action.type === (0, $63F6h.COLUMN_DELETE_REQUEST)) {
        const newState = {
            ...state
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        Object.keys(state).filter((issueKey)=>state[issueKey].columnId === payload.columnId).forEach((issueKey)=>{
            if (!payload.closestColumn) delete newState[issueKey];
            else if (payload.closestColumn.type === (0, $5rFbt.ColumnType).STATUS) newState[issueKey] = {
                ...newState[issueKey],
                columnId: payload.closestColumn.id,
                statusId: payload.closestColumn.statuses[0].id
            };
        });
        return newState;
    }
    if (action.type === (0, $iaYF9.ISSUE_ADD_LABELS)) {
        const { payload: { issueIds: issueIds, labels: labels } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        issueIds.forEach((id)=>{
            if (!state[String(id)]) return;
            const currentLabels = state[String(id)].labels || [];
            newState.setIn([
                String(id),
                'labels'
            ], (0, (/*@__PURE__*/$parcel$interopDefault($dDkmN)))(currentLabels, labels));
        });
        return newState.value();
    }
    if (action.type === (0, $3n65g.SET_PARENT_OPTIMISTIC)) {
        const { payload: { issues: issues, parentId: parentId } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        issues.forEach((issue)=>{
            if (!state[String(issue.id)]) return;
            newState.setIn([
                String(issue.id),
                'parentId'
            ], parentId);
            newState.setIn([
                String(issue.id),
                'hasScenarioChanges'
            ], true);
        });
        return newState.value();
    }
    if (action.type === (0, $9jMeJ.SET_ESTIMATE)) {
        const { payload: { issueId: issueId, estimate: estimate } } = action;
        if (state[String(issueId)]) return (0, $7uUwQ.chain)(state).setIn([
            String(issueId),
            'estimate'
        ], estimate).setIn([
            String(issueId),
            'hasScenarioChanges'
        ], true).value();
        return state;
    }
    if (action.type === (0, $evkwq.SET_ISSUE_PARENT)) {
        const { payload: { issueId: issueId, issueParentId: issueParentId } } = action;
        if (state[String(issueId)]) return (0, $7uUwQ.chain)(state).setIn([
            String(issueId),
            'parentId'
        ], issueParentId).setIn([
            String(issueId),
            'hasScenarioChanges'
        ], true).value();
        return state;
    }
    if (action.type === (0, $4nScF.SET_CHILD_ISSUES_METADATA)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: issues } = action;
        const newState = (0, $7uUwQ.chain)(state);
        issues.forEach((issue)=>{
            if (!state[String(issue.id)]) return;
            newState.setIn([
                String(issue.id),
                'numTotalChildren'
            ], issue.numTotalChildren || 0);
            newState.setIn([
                String(issue.id),
                'numCompleteChildren'
            ], issue.numCompleteChildren || 0);
        });
        return newState.value();
    }
    if (action.type === (0, $4l4AL.SET_SUMMARY)) {
        const { payload: { issueId: issueId, summary: summary } } = action;
        if (state[String(issueId)]) return (0, $7uUwQ.chain)(state).setIn([
            String(issueId),
            'summary'
        ], summary).setIn([
            String(issueId),
            'hasScenarioChanges'
        ], true).value();
        return state;
    }
    if (!(0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') && action.type === (0, $6WzWZ.ISSUE_LINKS_CREATE)) {
        const { payload: { newIssueLinks: newIssueLinks } } = action;
        const newIssueLinksGroups = Object.entries(newIssueLinks);
        const newState = (0, $7uUwQ.chain)(state);
        newIssueLinksGroups.forEach(([issueId, issueLinks])=>{
            newState.setIn([
                String(issueId),
                'issueLinks'
            ], [
                ...state[String(issueId)]?.issueLinks ?? [],
                ...issueLinks
            ]);
            newState.setIn([
                String(issueId),
                'hasScenarioChanges'
            ], true);
        });
        return newState.value();
    }
    if (action.type === (0, $6WzWZ.ISSUE_LINKS_ADD_UPDATE_SUCCESS) && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) {
        const { payload: { newIssueLinks: newIssueLinks } } = action;
        const newIssueLinksGroups = Object.entries(newIssueLinks);
        const newState = (0, $7uUwQ.chain)(state);
        newIssueLinksGroups.forEach(([issueId, issueLinks])=>{
            newState.setIn([
                String(issueId),
                'issueLinks'
            ], issueLinks);
            newState.setIn([
                String(issueId),
                'hasScenarioChanges'
            ], true);
        });
        return newState.value();
    }
    if (action.type === (0, $6WzWZ.ISSUE_LINKS_REMOVE_SUCCESS)) {
        const { payload: { issueLinksToRemove: issueLinksToRemove } } = action;
        const issueLinksGroups = Object.entries(issueLinksToRemove);
        const newState = (0, $7uUwQ.chain)(state);
        const updateState = (issueId, issueLinkIdToRemove)=>{
            if (issueId) {
                const issueLinks = state[String(issueId)]?.issueLinks ?? [];
                newState.setIn([
                    String(issueId),
                    'issueLinks'
                ], issueLinks.filter((issueLink)=>issueLinkIdToRemove !== issueLink.id));
                newState.setIn([
                    String(issueId),
                    'hasScenarioChanges'
                ], true);
            }
        };
        issueLinksGroups.forEach(([issueId, issueLinkId])=>{
            const issueLinks = state[String(issueId)]?.issueLinks ?? [];
            const issueLinkToRemove = issueLinks.find((issueLink)=>issueLinkId === issueLink.id);
            // Update issue links state in the source issue
            updateState(issueLinkToRemove?.sourceId, issueLinkId);
            // Update issue links state in the destination issue
            updateState(issueLinkToRemove?.destinationId, issueLinkId);
        });
        return newState.value();
    }
    return state;
};

});
parcelRegister("9jMeJ", function(module, exports) {

$parcel$export(module.exports, "SET_ESTIMATE", () => $05cbc5c61ca66428$export$c2ccd34996aa2a3);
$parcel$export(module.exports, "setEstimate", () => $05cbc5c61ca66428$export$c07ffb1ffa646b52);
const $05cbc5c61ca66428$export$c2ccd34996aa2a3 = 'state.actions.issue.SET_ESTIMATE';
const $05cbc5c61ca66428$export$c07ffb1ffa646b52 = (issueId, estimate)=>({
        type: $05cbc5c61ca66428$export$c2ccd34996aa2a3,
        payload: {
            issueId: issueId,
            estimate: estimate
        }
    });

});


parcelRegister("gnRwu", function(module, exports) {

$parcel$export(module.exports, "jqlSwimlanesReducer", () => $45dac62359d26ad8$export$1198b282f759ee69);

var $7uUwQ = parcelRequire("7uUwQ");

var $127QL = parcelRequire("127QL");

var $ls4NM = parcelRequire("ls4NM");

var $k50Aq = parcelRequire("k50Aq");

var $cW3pH = parcelRequire("cW3pH");
const $45dac62359d26ad8$var$initialState = {
    swimlanes: []
};
function $45dac62359d26ad8$export$1198b282f759ee69(// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
state = $45dac62359d26ad8$var$initialState, action) {
    if (action.type === (0, $cW3pH.WORK_DATA_SET) && action.payload.jqlSwimlanes) {
        const { jqlSwimlanes: jqlSwimlanes } = action.payload;
        return {
            swimlanes: jqlSwimlanes
        };
    }
    if (action.type === (0, $k50Aq.SWIMLANE_JQL_SET_DATA) && action.payload != null) return {
        swimlanes: action.payload
    };
    if (action.type === (0, $127QL.BOARD_DEFERRED_DATA_LOAD_SUCCESS) && action.payload.jqlSwimlanes) {
        const { jqlSwimlanes: jqlSwimlanes } = action.payload;
        return {
            swimlanes: jqlSwimlanes
        };
    }
    if (action.type === (0, $ls4NM.ISSUE_CREATE_REQUEST)) {
        const { payload: { issues: issues }, meta: { insertBefore: insertBefore, swimlaneId: swimlaneId, isSwimlaneByJql: isSwimlaneByJql } } = action;
        if (!isSwimlaneByJql || !state) return state || $45dac62359d26ad8$var$initialState;
        const swimlaneWithNewIssuesIndex = state.swimlanes.findIndex((sw)=>{
            // If swimlaneId is null in the create request, then it corresponds to the default swimlane
            if (swimlaneId === null) return sw.isDefaultSwimlane;
            return String(sw.id) === String(swimlaneId);
        });
        if (swimlaneWithNewIssuesIndex === -1) return state || $45dac62359d26ad8$var$initialState;
        const swimlaneIssueIds = state.swimlanes[swimlaneWithNewIssuesIndex].issueIds;
        const insertionPoint = insertBefore ? swimlaneIssueIds.indexOf(insertBefore) : swimlaneIssueIds.length;
        const issueIds = issues.map(({ id: id })=>id);
        const chainState = (0, $7uUwQ.chain)(state);
        chainState.setIn([
            'swimlanes',
            swimlaneWithNewIssuesIndex,
            'issueIds'
        ], (0, $7uUwQ.splice)(swimlaneIssueIds, insertionPoint, 0, ...issueIds));
        return chainState.value();
    }
    return state || $45dac62359d26ad8$var$initialState;
}

});

parcelRegister("1gv2w", function(module, exports) {

$parcel$export(module.exports, "missingParentsReducer", () => $b10ef32ddec0b98d$export$8807809ac34c19b3);

var $7uUwQ = parcelRequire("7uUwQ");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $4Xk2W = parcelRequire("4Xk2W");

var $hDdMY = parcelRequire("hDdMY");

var $cW3pH = parcelRequire("cW3pH");
const $b10ef32ddec0b98d$export$8807809ac34c19b3 = (state = {}, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) && action.payload.missingParents) return (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(action.payload.missingParents, 'id');
    if (action.type === (0, $hDdMY.MISSING_PARENT_RESOLVE_OPTIMISTIC)) {
        const { payload: { issueId: issueId, doneStatusName: doneStatusName } } = action;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(state) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(state[issueId] && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(doneStatusName))) return (0, $7uUwQ.chain)(state).setIn([
            issueId,
            'status',
            'name'
        ], doneStatusName)// update this for displaying correct status color and strikethrough on issue key
        .setIn([
            issueId,
            'status',
            'category'
        ], 'DONE').value();
    }
    return state;
};

});

parcelRegister("8DmOP", function(module, exports) {

$parcel$export(module.exports, "peopleReducer", () => $8a3c043ce49ee73f$export$932ae1ae35decba3);

var $7uUwQ = parcelRequire("7uUwQ");

var $1ShTS = parcelRequire("1ShTS");

var $2f454 = parcelRequire("2f454");

var $hoX5N = parcelRequire("hoX5N");

var $cW3pH = parcelRequire("cW3pH");
const $8a3c043ce49ee73f$export$932ae1ae35decba3 = (state = (0, $7uUwQ.freeze)({}), action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) return (0, $7uUwQ.merge)(state, (0, $1ShTS.entityArrayToMap)(action.payload.people));
    if (action.type === (0, $hoX5N.PERSON_SET)) return (0, $7uUwQ.merge)(state, {
        [action.payload.id]: action.payload
    });
    if (action.type === (0, $2f454.CARD_DATA_SET)) {
        const { payload: { person: person } } = action;
        if (person) return (0, $7uUwQ.merge)(state, {
            [person.id]: person
        });
    }
    return state;
};

});

parcelRegister("cidFT", function(module, exports) {

$parcel$export(module.exports, "projectIssueTypesReducer", () => $348d978c6ff3e4fc$export$a7ff3ce1c63497a1);

var $1ShTS = parcelRequire("1ShTS");

var $cW3pH = parcelRequire("cW3pH");
const $348d978c6ff3e4fc$export$a7ff3ce1c63497a1 = (state = {}, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        const { payload: { projectIssueTypes: projectIssueTypes } } = action;
        return (0, $1ShTS.entityArrayToMap)(projectIssueTypes);
    }
    return state;
};

});

parcelRegister("kLXNe", function(module, exports) {

$parcel$export(module.exports, "requestTypesReducer", () => $ec11ba9c8eef2662$export$dae3c1635063e9bf);

var $1ShTS = parcelRequire("1ShTS");

var $cW3pH = parcelRequire("cW3pH");
const $ec11ba9c8eef2662$export$dae3c1635063e9bf = (state = {}, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET)) {
        const { payload: { requestTypes: requestTypes } } = action;
        return (0, $1ShTS.entityArrayToMap)(requestTypes);
    }
    return state;
};

});

parcelRegister("6S8mJ", function(module, exports) {

$parcel$export(module.exports, "sprintsReducer", () => $60d381dec2296b87$export$4b86860ac786fd91);

var $7uUwQ = parcelRequire("7uUwQ");

var $1ShTS = parcelRequire("1ShTS");

var $127QL = parcelRequire("127QL");

var $e0GMz = parcelRequire("e0GMz");

var $cW3pH = parcelRequire("cW3pH");
const $60d381dec2296b87$export$4b86860ac786fd91 = (state = (0, $7uUwQ.freeze)({}), action)=>{
    if ((action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) && action.payload.sprints) return (0, $7uUwQ.freeze)((0, $1ShTS.entityArrayToMap)(action.payload.sprints));
    if (action.type === (0, $e0GMz.EDIT_SPRINT_REQUEST)) {
        const { id: id, name: name, goal: goal, startDate: startDate, endDate: endDate } = action.payload;
        const newState = (0, $7uUwQ.chain)(state).setIn([
            id,
            'name'
        ], name).setIn([
            id,
            'goal'
        ], goal).setIn([
            id,
            'startDate'
        ], startDate).setIn([
            id,
            'endDate'
        ], endDate).value();
        return newState;
    }
    if (action.type === (0, $e0GMz.EDIT_SPRINT_SUCCESS)) {
        const { id: id, daysRemaining: daysRemaining } = action.payload;
        return (0, $7uUwQ.setIn)(state, [
            id,
            'daysRemaining'
        ], daysRemaining);
    }
    if (action.type === (0, $127QL.BOARD_DEFERRED_DATA_LOAD_SUCCESS)) {
        const { sprints: sprints } = action.payload;
        if (sprints) return (0, $7uUwQ.freeze)((0, $1ShTS.entityArrayToMap)(sprints));
    }
    return state;
};

});
parcelRegister("e0GMz", function(module, exports) {

$parcel$export(module.exports, "EDIT_SPRINT_REQUEST", () => $a0b30c282ed6c8d9$export$123abdbc4d2e52b2);
$parcel$export(module.exports, "editSprintRequest", () => $a0b30c282ed6c8d9$export$f1ede94f3f629cd9);
$parcel$export(module.exports, "EDIT_SPRINT_SUCCESS", () => $a0b30c282ed6c8d9$export$e043c26cf23a5c18);
$parcel$export(module.exports, "editSprintSuccess", () => $a0b30c282ed6c8d9$export$3b274a040443f185);
$parcel$export(module.exports, "editSprintFailure", () => $a0b30c282ed6c8d9$export$193b8520faf6f6b0);

var $9rND4 = parcelRequire("9rND4");
const $a0b30c282ed6c8d9$export$123abdbc4d2e52b2 = 'state.actions.sprints.edit.EDIT_SPRINT_REQUEST';
const $a0b30c282ed6c8d9$export$f1ede94f3f629cd9 = (id, name, goal, startDate, endDate)=>({
        type: $a0b30c282ed6c8d9$export$123abdbc4d2e52b2,
        payload: {
            id: id,
            name: name,
            goal: goal,
            startDate: startDate,
            endDate: endDate
        },
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    });
const $a0b30c282ed6c8d9$export$e043c26cf23a5c18 = 'state.actions.sprints.edit.EDIT_SPRINT_SUCCESS';
const $a0b30c282ed6c8d9$export$3b274a040443f185 = (txId, id, daysRemaining)=>({
        type: $a0b30c282ed6c8d9$export$e043c26cf23a5c18,
        payload: {
            id: id,
            daysRemaining: daysRemaining
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(txId)
    });
const $a0b30c282ed6c8d9$export$c58baca64c75a779 = 'state.actions.sprints.edit.EDIT_SPRINT_FAILURE';
const $a0b30c282ed6c8d9$export$193b8520faf6f6b0 = (txId)=>({
        type: $a0b30c282ed6c8d9$export$c58baca64c75a779,
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(txId)
    });

});


parcelRegister("3IVsJ", function(module, exports) {

$parcel$export(module.exports, "statusCategoriesReducer", () => $fa7d382cb4f206fe$export$871c8938e4e152c3);

var $7uUwQ = parcelRequire("7uUwQ");

var $1ShTS = parcelRequire("1ShTS");

var $j6rJH = parcelRequire("j6rJH");
const $fa7d382cb4f206fe$export$871c8938e4e152c3 = (state = (0, $7uUwQ.freeze)({}), action)=>{
    if (action.type === (0, $j6rJH.STATUS_CATEGORY_LOAD_SUCCESS)) {
        const { statusCategories: statusCategories } = action.payload;
        return (0, $7uUwQ.merge)(state, (0, $1ShTS.entityArrayToMap)(statusCategories));
    }
    return state;
};

});

parcelRegister("9i87f", function(module, exports) {

$parcel$export(module.exports, "statusesReducer", () => $305df271d28d9124$export$3839708f801ae842);

var $1ShTS = parcelRequire("1ShTS");

var $cW3pH = parcelRequire("cW3pH");
const $305df271d28d9124$export$3839708f801ae842 = (state = {}, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET)) {
        const { payload: { statuses: statuses } } = action;
        return (0, $1ShTS.entityArrayToMap)(statuses);
    }
    return state;
};

});

parcelRegister("lEneF", function(module, exports) {

$parcel$export(module.exports, "teamsReducer", () => $f57d90a115faafdb$export$dfa96653a810691);

var $7uUwQ = parcelRequire("7uUwQ");

var $h2cxV = parcelRequire("h2cxV");

var $1ShTS = parcelRequire("1ShTS");

var $4kOHs = parcelRequire("4kOHs");

var $bL0WB = parcelRequire("bL0WB");

var $cW3pH = parcelRequire("cW3pH");
const $f57d90a115faafdb$export$dfa96653a810691 = (state = {}, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) return (0, $1ShTS.entityArrayToMap)(action.payload.teams || []);
    if (action.type === (0, $4kOHs.UPDATE_PLANNED_CAPACITY_SUCCESS)) {
        const { teamId: teamId, iterationId: iterationId, capacity: capacity } = action.payload;
        if (capacity === null) // if the capacity has been removed, we remove the entry from state so that we fall back to the default capacity
        return (0, $h2cxV.default)(state, [
            teamId,
            'capacityBySprintId',
            iterationId
        ]);
        const newState = (0, $7uUwQ.chain)(state).setIn([
            teamId,
            'capacityBySprintId',
            iterationId,
            'capacity'
        ], capacity).value();
        return newState;
    }
    if (action.type === (0, $bL0WB.UPDATE_ITERATION_CAPACITY_SUCCESS)) {
        const { teamId: teamId, iterationId: iterationId, capacity: capacity } = action.payload;
        if (capacity === null) // if the capacity has been removed, we remove the entry from state so that we fall back to the default capacity
        return (0, $h2cxV.default)(state, [
            teamId,
            'capacityByIterationId',
            iterationId
        ]);
        const newState = (0, $7uUwQ.chain)(state).setIn([
            teamId,
            'capacityByIterationId',
            iterationId,
            'capacity'
        ], capacity).value();
        return newState;
    }
    return state;
};

});
parcelRegister("h2cxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2606ddc7a8f25b8$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b2606ddc7a8f25b8$var$unsetInSingle = (state, pathToParent, key)=>{
    if (pathToParent.length === 0) return (0, $7uUwQ.unset)(state, key);
    const ret = (0, $7uUwQ.updateIn)(state, pathToParent, (parent)=>parent ? (0, $7uUwQ.unset)(parent, key) : undefined);
    return ret;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b2606ddc7a8f25b8$var$unsetInMulti = (state, pathToParent, keys)=>// @ts-expect-error - TS7006 - Parameter 'folded' implicitly has an 'any' type. | TS7006 - Parameter 'subkey' implicitly has an 'any' type.
    keys.reduce((folded, subkey)=>$b2606ddc7a8f25b8$var$unsetInSingle(folded, pathToParent, subkey), state);
var //   ['a', 'b', 'c'] - removes values at 'a/b/c'
//   ['a', ['b', 'c']] - removes values at 'a/b' and 'a/c'
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$b2606ddc7a8f25b8$export$2e2bcd8739ae039 = (state, path)=>{
    if (path.length === 0) return state;
    const pathToParent = path.slice(0, path.length - 1);
    const lastPathItem = path.slice(-1)[0];
    if (Array.isArray(lastPathItem)) return $b2606ddc7a8f25b8$var$unsetInMulti(state, pathToParent, lastPathItem);
    return $b2606ddc7a8f25b8$var$unsetInSingle(state, pathToParent, lastPathItem);
};

});


parcelRegister("8YtrK", function(module, exports) {

$parcel$export(module.exports, "versionDataReducer", () => $4679910da2681cca$export$a5073c7abdddbae4);

var $j00DX = parcelRequire("j00DX");
const $4679910da2681cca$var$initVersionDataState = {
    versionsPerProject: {},
    canCreateVersion: false
};
const $4679910da2681cca$export$a5073c7abdddbae4 = (state = $4679910da2681cca$var$initVersionDataState, action)=>{
    if (action.type === (0, $j00DX.SET_VERSION_DATA)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        return {
            ...payload
        };
    }
    return state;
};

});


parcelRegister("88zgs", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b344137c61b107e$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $4ZaWM = parcelRequire("4ZaWM");

var $69epK = parcelRequire("69epK");

var $8HqML = parcelRequire("8HqML");

var $bZSiz = parcelRequire("bZSiz");

var $98a9H = parcelRequire("98a9H");

var $4WnRS = parcelRequire("4WnRS");

var $5xTT6 = parcelRequire("5xTT6");

var $96rsq = parcelRequire("96rsq");

var $eRAwv = parcelRequire("eRAwv");

var $2hNE6 = parcelRequire("2hNE6");

var $jRjcj = parcelRequire("jRjcj");

var $kVppN = parcelRequire("kVppN");

var $i1NTq = parcelRequire("i1NTq");

var $ge2Re = parcelRequire("ge2Re");

var $iGgUa = parcelRequire("iGgUa");

var $gXQl3 = parcelRequire("gXQl3");

var $d9fmE = parcelRequire("d9fmE");

var $fJuCu = parcelRequire("fJuCu");

var $6dO4m = parcelRequire("6dO4m");

var $8V3MB = parcelRequire("8V3MB");

var $3Nx75 = parcelRequire("3Nx75");

var $7N9ZT = parcelRequire("7N9ZT");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b344137c61b107e$export$2e2bcd8739ae039 = ()=>(0, $3f2cs.combineReducers)({
        backlogIssueMoveDialog: (0, $8HqML.backlogIssueMoveDialogReducer),
        backlogEnableDialog: (0, $69epK.backlogEnableDialogReducer),
        board: (0, $bZSiz.default),
        column: (0, $5xTT6.default),
        columns: (0, $96rsq.columnsUIReducer),
        flags: (0, $eRAwv.flagsReducer),
        issueModal: (0, $ge2Re.issueModalReducer),
        planIssueModal: (0, $d9fmE.planIssueModalReducer),
        issueDeleteModal: (0, $kVppN.issueDeleteModalReducer),
        swimlane: (0, $8V3MB.default),
        workFilters: (0, $7N9ZT.workFiltersReducer),
        cards: (0, $98a9H.default),
        issueAddLabelModal: $jRjcj.default,
        issueTransitionModal: $iGgUa.default,
        assignIssueParentModal: $4ZaWM.default,
        columnLimits: (0, $4WnRS.default),
        panels: (0, $gXQl3.default),
        sprints: (0, $6dO4m.sprintsReducer),
        globalIssueCreate: (0, $2hNE6.default),
        updateIssueParentModal: (0, $3Nx75.updateIssueParentModalReducer),
        issueFlagWithCommentModal: (0, $i1NTq.issueFlagWithCommentModalReducer),
        sprintAssociationModal: (0, $fJuCu.sprintAssociationModalReducer)
    });

});
parcelRegister("4ZaWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d95d5fefbfd65b15$export$2e2bcd8739ae039);

var $bZ9IJ = parcelRequire("bZ9IJ");
const $d95d5fefbfd65b15$var$defaultState = {
    isOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d95d5fefbfd65b15$export$2e2bcd8739ae039 = (state = $d95d5fefbfd65b15$var$defaultState, action)=>{
    if (action.type === (0, $bZ9IJ.SHOW_ASSIGN_ISSUE_PARENT_MODAL)) return {
        isOpen: true,
        issueIds: action.payload.issueIds
    };
    if (action.type === (0, $bZ9IJ.HIDE_ASSIGN_ISSUE_PARENT_MODAL)) return {
        isOpen: false
    };
    return state;
};

});

parcelRegister("69epK", function(module, exports) {

$parcel$export(module.exports, "backlogEnableDialogReducer", () => $214b4c0a561a3326$export$75630e0069e51f4e);

var $7uUwQ = parcelRequire("7uUwQ");

var $2Ysq2 = parcelRequire("2Ysq2");
const $214b4c0a561a3326$var$closedState = (0, $7uUwQ.freeze)({
    isOpen: false
});
const $214b4c0a561a3326$var$openState = (0, $7uUwQ.freeze)({
    isOpen: true
});
const $214b4c0a561a3326$export$75630e0069e51f4e = (state = $214b4c0a561a3326$var$openState, action)=>{
    switch(action.type){
        case 0, $2Ysq2.BACKLOG_ENABLE_CANCEL:
            return $214b4c0a561a3326$var$closedState;
        case 0, $2Ysq2.BACKLOG_ENABLE_CONFIRM:
            return $214b4c0a561a3326$var$closedState;
        default:
            return state;
    }
};

});

parcelRegister("8HqML", function(module, exports) {

$parcel$export(module.exports, "backlogIssueMoveDialogReducer", () => $d8f17807cb00e8fb$export$c7f896523fc95ea3);

var $7uUwQ = parcelRequire("7uUwQ");

var $doOdQ = parcelRequire("doOdQ");
const $d8f17807cb00e8fb$var$closedState = (0, $7uUwQ.freeze)({
    isOpen: false
});
const $d8f17807cb00e8fb$var$openState = (0, $7uUwQ.freeze)({
    isOpen: true
});
const $d8f17807cb00e8fb$export$c7f896523fc95ea3 = (state = $d8f17807cb00e8fb$var$closedState, action)=>{
    switch(action.type){
        case 0, $doOdQ.BACKLOG_ISSUE_MOVE_SHOW:
            return $d8f17807cb00e8fb$var$openState;
        case 0, $doOdQ.BACKLOG_ISSUE_MOVE_CANCEL:
            return $d8f17807cb00e8fb$var$closedState;
        case 0, $doOdQ.BACKLOG_ISSUE_MOVE_CONFIRM:
            return $d8f17807cb00e8fb$var$closedState;
        default:
            return state;
    }
};

});

parcelRegister("bZSiz", function(module, exports) {

$parcel$export(module.exports, "default", () => $0745563943afa1e3$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $dXb3J = parcelRequire("dXb3J");

var $aX9AQ = parcelRequire("aX9AQ");

var $k8w9P = parcelRequire("k8w9P");

var $bEgEd = parcelRequire("bEgEd");

var $4Hgc5 = parcelRequire("4Hgc5");
var $0745563943afa1e3$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    isPollingEnabled: (0, $4Hgc5.isPollingEnabledReducer),
    isDragging: (0, $k8w9P.isDraggingReducer),
    displayOptions: (0, $aX9AQ.displayOptionsReducer),
    boardAddNewIssueToSprint: (0, $dXb3J.boardAddNewIssueToSprintReducer),
    isIpBoardFailed: (0, $bEgEd.isIpBoardFailedReducer)
});

});
parcelRegister("dXb3J", function(module, exports) {

$parcel$export(module.exports, "boardAddNewIssueToSprintReducer", () => $9c88adf8c3b03a8a$export$ae55eb7d73dbc5c7);

var $dkGow = parcelRequire("dkGow");
const $9c88adf8c3b03a8a$var$initialState = {
    isLoading: false,
    isSuccess: false
};
const $9c88adf8c3b03a8a$export$ae55eb7d73dbc5c7 = (state = $9c88adf8c3b03a8a$var$initialState, action)=>{
    switch(action.type){
        case 0, $dkGow.ADD_TO_SPRINT_REQUEST:
            return {
                isLoading: true,
                isSuccess: false
            };
        case 0, $dkGow.ADD_TO_SPRINT_SUCCESS:
            return {
                isLoading: false,
                isSuccess: true
            };
        case 0, $dkGow.ADD_TO_SPRINT_FAILURE:
            return {
                isLoading: false,
                isSuccess: false
            };
        default:
            break;
    }
    return state;
};

});

parcelRegister("aX9AQ", function(module, exports) {

$parcel$export(module.exports, "displayOptionsReducer", () => $7806877f42df5f5b$export$ac9a4de53985de9f);

var $bRqd3 = parcelRequire("bRqd3");

var $cTkW0 = parcelRequire("cTkW0");

var $cW3pH = parcelRequire("cW3pH");
const $7806877f42df5f5b$var$initialState = {
    areEpicLabelsHidden: false,
    isHeaderCompactMode: false,
    preventInlineEditing: false,
    // Display option for Increment planning board
    showUnscheduledColumn: true,
    showOfftrackDependencyLines: false,
    issueIdsToShowDependencies: []
};
function $7806877f42df5f5b$export$ac9a4de53985de9f(state = $7806877f42df5f5b$var$initialState, action) {
    if (action.type === (0, $cW3pH.WORK_DATA_SET)) return {
        ...state,
        areEpicLabelsHidden: Boolean(action.payload.boardConfig.areEpicLabelsHidden)
    };
    if (action.type === (0, $bRqd3.TOGGLE_BOARD_MENUS)) return {
        ...state,
        isHeaderCompactMode: !state.isHeaderCompactMode
    };
    if (action.type === (0, $bRqd3.TOGGLE_EPIC_LABELS)) return {
        ...state,
        areEpicLabelsHidden: !state.areEpicLabelsHidden
    };
    if (action.type === (0, $cTkW0.PREVENT_INLINE_EDITING)) return {
        ...state,
        preventInlineEditing: action.payload.preventInlineEditing
    };
    if (action.type === (0, $bRqd3.SET_SHOW_UNSCHEDULED_COLUMN)) return {
        ...state,
        showUnscheduledColumn: action.payload
    };
    if (action.type === (0, $bRqd3.SET_SHOW_OFFTRACK_DEPENDENCY_LINES)) return {
        ...state,
        showOfftrackDependencyLines: action.payload
    };
    if (action.type === (0, $bRqd3.SET_ISSUE_IDS_TO_SHOW_DEPENDENCIES)) return {
        ...state,
        issueIdsToShowDependencies: action.payload
    };
    return state;
}

});
parcelRegister("cTkW0", function(module, exports) {

$parcel$export(module.exports, "PREVENT_INLINE_EDITING", () => $5ff3a4f82008cbb5$export$8bc7fdd820d3843);
$parcel$export(module.exports, "preventInlineEditingAction", () => $5ff3a4f82008cbb5$export$5a98a6267260ac54);
const $5ff3a4f82008cbb5$export$8bc7fdd820d3843 = 'state.actions.board.PREVENT_INLINE_EDITING';
const $5ff3a4f82008cbb5$export$5a98a6267260ac54 = (preventInlineEditing)=>({
        type: $5ff3a4f82008cbb5$export$8bc7fdd820d3843,
        payload: {
            preventInlineEditing: preventInlineEditing
        }
    });

});


parcelRegister("k8w9P", function(module, exports) {

$parcel$export(module.exports, "isDraggingReducer", () => $da895b06ac1cab47$export$80e81a739b833d9b);

var $eu61M = parcelRequire("eu61M");
const $da895b06ac1cab47$export$80e81a739b833d9b = (state = false, action)=>{
    if (action.type === (0, $eu61M.DRAG_START)) return true;
    if (action.type === (0, $eu61M.DRAG_END)) return false;
    return state;
};

});

parcelRegister("bEgEd", function(module, exports) {

$parcel$export(module.exports, "isIpBoardFailedReducer", () => $ae0035cbc719904b$export$6c7ed8b976c677d8);

var $cW3pH = parcelRequire("cW3pH");
const $ae0035cbc719904b$export$6c7ed8b976c677d8 = (state = false, action)=>{
    if (action.type === (0, $cW3pH.IP_BOARD_404_VIEW)) return true;
    return state;
};

});

parcelRegister("4Hgc5", function(module, exports) {

$parcel$export(module.exports, "isPollingEnabledReducer", () => $37fc91adcc46c2be$export$d3425b8c9fd351d8);

var $eu61M = parcelRequire("eu61M");
const $37fc91adcc46c2be$export$d3425b8c9fd351d8 = (state = true, action)=>{
    if (action.type === (0, $eu61M.DRAG_START)) return false;
    if (action.type === (0, $eu61M.DRAG_END)) return true;
    return state;
};

});


parcelRegister("98a9H", function(module, exports) {

$parcel$export(module.exports, "default", () => $85fdeaa32d3a0d6a$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $5SWy0 = parcelRequire("5SWy0");

var $9scgE = parcelRequire("9scgE");

var $ciATa = parcelRequire("ciATa");

var $694Tc = parcelRequire("694Tc");

var $1Kv4W = parcelRequire("1Kv4W");

var $2eHlb = parcelRequire("2eHlb");

var $fMV8U = parcelRequire("fMV8U");

var $aqN9l = parcelRequire("aqN9l");
var $85fdeaa32d3a0d6a$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    selected: (0, $fMV8U.cardSelectionReducer),
    transactions: (0, $aqN9l.cardTransactionsReducer),
    drag: (0, $ciATa.cardDragReducer),
    focused: (0, $1Kv4W.default),
    cardWithIcc: (0, $9scgE.cardWithIccReducer),
    filteredCards: (0, $694Tc.filteredCardsReducer),
    autoScroll: (0, $5SWy0.default),
    inlineEditing: (0, $2eHlb.cardInlineEditingReducer)
});

});
parcelRegister("5SWy0", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d87785e631a6181$export$2e2bcd8739ae039);

var $d1i1b = parcelRequire("d1i1b");
const $1d87785e631a6181$var$initialAutoScrollState = {
    issueId: null,
    unscheduledColumnSwimlaneId: null,
    isImmediate: false
};
const $1d87785e631a6181$var$cardAutoScrollReducer = (state = $1d87785e631a6181$var$initialAutoScrollState, action)=>{
    if (action.type === (0, $d1i1b.CARD_AUTO_SCROLL)) return {
        ...state,
        issueId: action.payload.issueId
    };
    if (action.type === (0, $d1i1b.CARD_AUTO_SCROLL_UNSCHEDULED_COLUMN_ICC)) return {
        ...state,
        unscheduledColumnSwimlaneId: action.payload.swimlaneId,
        isImmediate: action.payload.isImmediate ?? false
    };
    return state;
};
var $1d87785e631a6181$export$2e2bcd8739ae039 = $1d87785e631a6181$var$cardAutoScrollReducer;

});

parcelRegister("9scgE", function(module, exports) {

$parcel$export(module.exports, "cardWithIccReducer", () => $68603d7d461b5d3d$export$22c3cac0160e001a);

var $2f454 = parcelRequire("2f454");

var $kXqRJ = parcelRequire("kXqRJ");
const $68603d7d461b5d3d$export$d4c72bab9d6cc13a = {
    mainActiveIssue: null,
    cardIdWithAboveIccOpen: null,
    columnIdToKeepIccOpen: null,
    lastColumnIdOpen: null,
    // used in program board unscheduled column
    swimlaneIdToKeepIccOpen: null
};
const $68603d7d461b5d3d$export$22c3cac0160e001a = (state, action)=>{
    switch(action.type){
        case 0, $2f454.SET_ACTIVE_ISSUE_WITH_ICC:
            return {
                ...state || $68603d7d461b5d3d$export$d4c72bab9d6cc13a,
                mainActiveIssue: action.payload.issueId
            };
        case 0, $2f454.SET_ISSUE_ID_WITH_ABOVE_ICC_OPEN:
            return {
                ...state || $68603d7d461b5d3d$export$d4c72bab9d6cc13a,
                cardIdWithAboveIccOpen: action.payload.issueId,
                columnIdToKeepIccOpen: action.payload.columnId,
                lastColumnIdOpen: action.payload.columnId || state?.lastColumnIdOpen || null
            };
        case 0, $kXqRJ.ISSUE_DELETE_SUCCESS:
            // Reset the lastColumnIdOpen on deletion so if the board is empty again, the ICC will pop open
            return {
                ...state || $68603d7d461b5d3d$export$d4c72bab9d6cc13a,
                lastColumnIdOpen: null
            };
        case 0, $2f454.OPEN_ICC_IN_UNSCHEDULED_COLUMN:
            // Used in program board unscheduled column to open ICC in column footer
            return {
                ...state || $68603d7d461b5d3d$export$d4c72bab9d6cc13a,
                swimlaneIdToKeepIccOpen: action.payload.swimlaneId
            };
        case 0, $2f454.CLOSE_ICC_IN_UNSCHEDULED_COLUMN:
            // Close ICC in program board unscheduled column
            return {
                ...state || $68603d7d461b5d3d$export$d4c72bab9d6cc13a,
                swimlaneIdToKeepIccOpen: null
            };
        default:
            {
                // @ts-expect-error - TS2322: Type 'ShowErrorFlagAction | SetPersonAction | AddToSprintRequestAction | AddToSprintSuccessAction | ... 255 more ... | UnsupportedAction' is not assignable to type 'never'.
                const _exhaustiveCheck = action;
                return state || $68603d7d461b5d3d$export$d4c72bab9d6cc13a;
            }
    }
};

});

parcelRegister("ciATa", function(module, exports) {

$parcel$export(module.exports, "cardDragReducer", () => $9ab2999199893664$export$bfd76de3490d0a87);

var $7uUwQ = parcelRequire("7uUwQ");

var $hGgHi = parcelRequire("hGgHi");

var $6oUms = parcelRequire("6oUms");

var $eu61M = parcelRequire("eu61M");

var $2f454 = parcelRequire("2f454");
const $9ab2999199893664$export$97c487b880ccd37d = {
    cardId: null,
    overTransition: undefined,
    snapMode: false,
    rippleIdsToShow: []
};
const $9ab2999199893664$var$makeCardUiState = (draggableId, mode, rippleIdsToShow)=>{
    const cardId = (0, $6oUms.getDescriptor)(draggableId).id;
    if (Number.isNaN(cardId)) return $9ab2999199893664$export$97c487b880ccd37d;
    return {
        cardId: Number(cardId),
        snapMode: mode === 'SNAP',
        hoverIntended: false,
        rippleIdsToShow: rippleIdsToShow
    };
};
const $9ab2999199893664$export$bfd76de3490d0a87 = (state = $9ab2999199893664$export$97c487b880ccd37d, action)=>{
    if (action.type === (0, $eu61M.DRAG_START)) {
        if (action.payload) return $9ab2999199893664$var$makeCardUiState(action.payload.draggableId, action.payload.mode, state.rippleIdsToShow);
        return {
            ...$9ab2999199893664$export$97c487b880ccd37d,
            rippleIdsToShow: state.rippleIdsToShow
        };
    }
    if (action.type === (0, $2f454.CARD_DRAG_OVER_TRANSITION) && state.cardId) {
        const { toColumnId: toColumnId, transitionId: transitionId, hoverIntent: hoverIntent } = action.payload;
        const newTransitionState = transitionId ? {
            transitionId: transitionId,
            toColumnId: toColumnId,
            hoverIntent: hoverIntent
        } : null;
        const hoverState = {
            ...newTransitionState && {
                // HoverIntended is set to true if hover intent is true once during the drag event later to be used in analytics
                // hoverIntent && transitionId to exclude hover intents to TransitionTo area
                hoverIntended: state.hoverIntended || hoverIntent && !!transitionId
            }
        };
        return (0, $7uUwQ.freeze)({
            ...state,
            overTransition: newTransitionState,
            ...hoverState
        });
    }
    if (action.type === (0, $2f454.CARD_DRAG_SELECTED_TRANSITION)) {
        const { transitionId: transitionId, toColumnId: toColumnId, toSwimlaneId: toSwimlaneId } = action.payload;
        return (0, $7uUwQ.freeze)({
            ...state,
            selectedTransition: {
                transitionId: transitionId,
                toColumnId: toColumnId,
                toSwimlaneId: toSwimlaneId
            }
        });
    }
    if (action.type === (0, $2f454.CARD_SET_ISSUE_TRANSITIONS)) {
        const { columnTransitions: columnTransitions } = action.payload;
        const { overTransition: overTransition } = state;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(overTransition) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(overTransition.transitionId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(overTransition.toColumnId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(columnTransitions[overTransition.toColumnId])) return state;
        const selectedTransition = columnTransitions[overTransition.toColumnId].find((transition)=>transition.id === overTransition.transitionId);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(selectedTransition) || selectedTransition.isAvailable) return state;
        return (0, $7uUwQ.freeze)({
            ...state,
            selectedTransition: undefined,
            overTransition: null
        });
    }
    if (action.type === (0, $eu61M.DRAG_END)) return (0, $7uUwQ.freeze)({
        ...state,
        ...$9ab2999199893664$export$97c487b880ccd37d
    });
    if (action.type === (0, $2f454.CARD_ADD_SHOW_RIPPLE)) {
        const { rippleIdsToShow: rippleIdsToShow } = action.payload;
        return (0, $7uUwQ.freeze)({
            ...state,
            rippleIdsToShow: [
                ...state.rippleIdsToShow,
                ...rippleIdsToShow
            ]
        });
    }
    if (action.type === (0, $2f454.CARD_REMOVE_SHOW_RIPPLE)) {
        const { issueId: issueId } = action.payload;
        return (0, $7uUwQ.freeze)({
            ...state,
            rippleIdsToShow: [
                ...state.rippleIdsToShow.filter((id)=>id !== issueId)
            ]
        });
    }
    return state;
};

});

parcelRegister("694Tc", function(module, exports) {

$parcel$export(module.exports, "filteredCardsReducer", () => $e6cd39f4878a15e1$export$a42af41a01ab9b7a);


var $cY26q = parcelRequire("cY26q");

var $dnW4F = parcelRequire("dnW4F");
const $e6cd39f4878a15e1$export$d4c72bab9d6cc13a = {
    isLoading: false,
    filteredCardsIds: null
};
const $e6cd39f4878a15e1$export$a42af41a01ab9b7a = (state = $e6cd39f4878a15e1$export$d4c72bab9d6cc13a, action)=>{
    if (action.type === (0, $dnW4F.SET_ALL_FILTERS) && action.meta.filterType === (0, $dcff40112356dfc1$export$68d693c35a8d8866)) return {
        ...state,
        isLoading: true
    };
    if (action.type === (0, $dnW4F.CUSTOM_FILTER_FORCE_REFRESH_START)) return {
        ...state,
        isLoading: true
    };
    if (action.type === (0, $cY26q.FILTERED_CARD_SUCCESS)) return {
        isLoading: false,
        filteredCardsIds: new Set(action.payload)
    };
    if (action.type === (0, $cY26q.FILTERED_CARD_FAILURE)) return {
        isLoading: false,
        filteredCardsIds: null
    };
    if (action.type === (0, $cY26q.FILTERED_CARD_CLEAR)) return $e6cd39f4878a15e1$export$d4c72bab9d6cc13a;
    if (action.type === (0, $cY26q.REFILTER_SUCCESS)) {
        const { excludedCardIds: excludedCardIds, filteredCardIds: filteredCardIds } = action.payload;
        const updatedFilteredCardIds = new Set([
            ...state.filteredCardsIds || [],
            ...filteredCardIds
        ]);
        excludedCardIds.forEach((cardId)=>updatedFilteredCardIds.delete(cardId)); // delete is faster than filtering on state
        return {
            isLoading: false,
            filteredCardsIds: updatedFilteredCardIds
        };
    }
    return state;
};

});

parcelRegister("1Kv4W", function(module, exports) {

$parcel$export(module.exports, "default", () => $032efb4f27485b10$export$2e2bcd8739ae039);

var $2f454 = parcelRequire("2f454");
const $032efb4f27485b10$var$cardFocusReducer = (state = null, action)=>{
    if (action.type === (0, $2f454.CARD_FOCUS)) return action.payload.issueId;
    if (action.type === (0, $2f454.CARD_BLUR)) return null;
    return state;
};
var $032efb4f27485b10$export$2e2bcd8739ae039 = $032efb4f27485b10$var$cardFocusReducer;

});

parcelRegister("2eHlb", function(module, exports) {

$parcel$export(module.exports, "cardInlineEditingReducer", () => $7609277707c0efdf$export$b81c30b4d16a65d);

var $2f454 = parcelRequire("2f454");
const $7609277707c0efdf$export$d4c72bab9d6cc13a = {};
const $7609277707c0efdf$export$b81c30b4d16a65d = (state = $7609277707c0efdf$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $2f454.SET_INLINE_EDITING:
            return {
                ...state,
                [action.payload.issueId]: {
                    // Setting all fields to false except the one we are setting
                    assignee: false,
                    summary: false,
                    [action.payload.field]: action.payload.value
                }
            };
        default:
            return state;
    }
};

});

parcelRegister("fMV8U", function(module, exports) {

$parcel$export(module.exports, "cardSelectionReducer", () => $5d0402a1c51be99a$export$bef5bad89d1f8b41);

var $7uUwQ = parcelRequire("7uUwQ");

var $kGsr8 = parcelRequire("kGsr8");

var $2f454 = parcelRequire("2f454");

var $k50Aq = parcelRequire("k50Aq");
const $5d0402a1c51be99a$var$initialState = [];
const $5d0402a1c51be99a$export$bef5bad89d1f8b41 = (state = $5d0402a1c51be99a$var$initialState, action)=>{
    if (action.type === (0, $2f454.CARD_TOGGLE_SELECTION)) {
        const { issueId: issueId } = action.payload;
        const selectedCardIndex = state.indexOf(action.payload.issueId);
        return selectedCardIndex === -1 ? (0, $7uUwQ.push)(state, issueId) : (0, $7uUwQ.splice)(state, selectedCardIndex, 1);
    }
    if (action.type === (0, $2f454.CARD_MULTI_SELECT)) {
        const { issueIds: issueIds } = action.payload;
        return (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(state.concat(issueIds));
    }
    if (action.type === (0, $2f454.CARD_SINGLE_SELECT)) {
        const { issueId: issueId } = action.payload;
        return [
            issueId
        ];
    }
    if (action.type === (0, $k50Aq.SWIMLANE_MODE_CHANGE_REQUEST)) return $5d0402a1c51be99a$var$initialState;
    if (action.type === (0, $2f454.CARD_CANCEL_SELECTION)) return $5d0402a1c51be99a$var$initialState;
    return state;
};

});

parcelRegister("aqN9l", function(module, exports) {

$parcel$export(module.exports, "cardTransactionsReducer", () => $1c8787c4dbca4995$export$6639e0d78731564c);

var $2f454 = parcelRequire("2f454");

var $71oFY = parcelRequire("71oFY");
const $1c8787c4dbca4995$export$d4c72bab9d6cc13a = {};
const $1c8787c4dbca4995$export$619c15727cd4c9af = (state, issueIds, transactionId)=>{
    const newTransactions = {};
    issueIds.forEach((issueId)=>{
        newTransactions[issueId] = transactionId;
    });
    return {
        // @ts-expect-error - TS2698 - Spread types may only be created from object types.
        ...state.transactions,
        ...newTransactions
    };
};
const $1c8787c4dbca4995$export$6639e0d78731564c = (state = $1c8787c4dbca4995$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $71oFY.ISSUE_RANK_TRANSITION_UPDATE_OPTIMISTIC:
            return $1c8787c4dbca4995$export$619c15727cd4c9af(state, action.payload.issueIds.map((id)=>String(id)), action.meta.optimistic.id);
        case 0, $2f454.CARD_REFRESH_REQUEST:
            if (action.payload.skipTransactionUpdate) return state;
            return $1c8787c4dbca4995$export$619c15727cd4c9af(state, action.payload.issueIds.map((id)=>String(id)), action.payload.transactionId);
        default:
            return state;
    }
};

});


parcelRegister("4WnRS", function(module, exports) {

$parcel$export(module.exports, "default", () => $86db4ea08a83be24$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $9eeht = parcelRequire("9eeht");
const $86db4ea08a83be24$export$d4c72bab9d6cc13a = (0, $7uUwQ.freeze)({
    isOpen: false
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$86db4ea08a83be24$export$2e2bcd8739ae039 = (state = $86db4ea08a83be24$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $9eeht.COLUMN_OPEN_LIMITS_MODAL:
            return (0, $7uUwQ.freeze)({
                isOpen: true,
                columnId: action.payload.columnId
            });
        case 0, $9eeht.COLUMN_SET_LIMITS_REQUEST:
        case 0, $9eeht.COLUMN_CLOSE_LIMITS_MODAL:
            return (0, $7uUwQ.freeze)({
                isOpen: false
            });
        default:
            {
                // @ts-expect-error - TS2322: Type 'ShowErrorFlagAction | SetPersonAction | AddToSprintRequestAction | AddToSprintSuccessAction | ... 254 more ... | UnsupportedAction' is not assignable to type 'never'.
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("5xTT6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3801bc28497742dc$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $a8wAH = parcelRequire("a8wAH");

var $kr8Rv = parcelRequire("kr8Rv");
var $3801bc28497742dc$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    deleteModal: (0, $a8wAH.columnDeleteModalReducer),
    issuesNotOnBoard: (0, $kr8Rv.issuesNotOnBoardReducer)
});

});
parcelRegister("a8wAH", function(module, exports) {

$parcel$export(module.exports, "columnDeleteModalReducer", () => $1a3bdda22ea95f01$export$b62fd9e48bba962a);

var $63F6h = parcelRequire("63F6h");
const $1a3bdda22ea95f01$export$b62fd9e48bba962a = (state = {
    isOpen: false
}, action)=>{
    if (action.type === (0, $63F6h.COLUMN_DELETE)) {
        const { columnId: columnId } = action.payload;
        return {
            isOpen: true,
            columnId: columnId
        };
    }
    if (action.type === (0, $63F6h.COLUMN_DELETE_MODAL_CLOSE)) return {
        isOpen: false
    };
    return state;
};

});

parcelRegister("kr8Rv", function(module, exports) {

$parcel$export(module.exports, "issuesNotOnBoardReducer", () => $84807d2e57a3c923$export$2667ef7905a994f5);

var $e1q2I = parcelRequire("e1q2I");
const $84807d2e57a3c923$export$2667ef7905a994f5 = (state = {}, action)=>{
    if (action.type === (0, $e1q2I.SET_ISSUES_NOT_ON_BOARD)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        return payload;
    }
    return state;
};

});


parcelRegister("96rsq", function(module, exports) {

$parcel$export(module.exports, "columnsUIReducer", () => $4c7e4e4d6fa086c1$export$bc16d83eead4beb6);

var $7uUwQ = parcelRequire("7uUwQ");

var $gccSB = parcelRequire("gccSB");

var $glGhK = parcelRequire("glGhK");

var $63F6h = parcelRequire("63F6h");

var $55fEr = parcelRequire("55fEr");

var $63VRQ = parcelRequire("63VRQ");
const $4c7e4e4d6fa086c1$export$bc16d83eead4beb6 = (state = (0, $7uUwQ.freeze)({}), action)=>{
    if (action.type === (0, $63VRQ.COLUMN_RENAME_REQUEST)) {
        const { columnId: columnId } = action.payload;
        return (0, $7uUwQ.setIn)(state, [
            String(columnId),
            'isUpdating'
        ], true);
    }
    if (action.type === (0, $63VRQ.COLUMN_RENAME_SUCCESS) || action.type === (0, $63VRQ.COLUMN_RENAME_FAILURE)) {
        const { columnId: columnId } = action.payload;
        return (0, $7uUwQ.setIn)(state, [
            String(columnId),
            'isUpdating'
        ], false);
    }
    if (action.type === (0, $55fEr.COLUMN_RANK_REQUEST)) {
        const { columnId: columnId } = action.payload;
        return (0, $7uUwQ.setIn)(state, [
            String(columnId),
            'isUpdating'
        ], true);
    }
    if (action.type === (0, $55fEr.COLUMN_RANK_SUCCESS) || action.type === (0, $55fEr.COLUMN_RANK_FAILURE)) {
        const { columnId: columnId } = action.payload;
        return (0, $7uUwQ.setIn)(state, [
            String(columnId),
            'isUpdating'
        ], false);
    }
    if (action.type === (0, $glGhK.COLUMN_CREATE_REQUEST)) {
        const { temporaryColumnId: temporaryColumnId } = action.payload;
        return (0, $7uUwQ.setIn)(state, [
            String(temporaryColumnId),
            'isUpdating'
        ], true);
    }
    if (action.type === (0, $63F6h.COLUMN_DELETE_REQUEST)) {
        const { closestColumn: closestColumn } = action.payload;
        if (closestColumn) return (0, $7uUwQ.setIn)(state, [
            String(closestColumn.id),
            'isUpdating'
        ], true);
    }
    if (action.type === (0, $63F6h.COLUMN_DELETE_SUCCESS)) {
        const { closestColumn: closestColumn } = action.payload;
        if (closestColumn) return (0, $7uUwQ.unset)(state, String(closestColumn.id));
    }
    if (action.type === (0, $glGhK.COLUMN_CREATE_SUCCESS) || action.type === (0, $glGhK.COLUMN_CREATE_FAILURE)) {
        const { temporaryColumnId: temporaryColumnId } = action.payload;
        const columnStates = (0, $7uUwQ.unset)(state[String(temporaryColumnId)], 'isUpdating');
        if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(columnStates)) return (0, $7uUwQ.unset)(state, String(temporaryColumnId));
        return (0, $7uUwQ.setIn)(state, [
            String(temporaryColumnId)
        ], columnStates);
    }
    return state;
};

});

parcelRegister("eRAwv", function(module, exports) {

$parcel$export(module.exports, "flagsReducer", () => $91d7a4795f84532d$export$64fc5b4c35b25733);

var $7uUwQ = parcelRequire("7uUwQ");

var $bkCF5 = parcelRequire("bkCF5");
const $91d7a4795f84532d$export$623276a11554670b = (state, flag)=>!!state.find((stateFlag)=>stateFlag.id === flag.id);
const $91d7a4795f84532d$export$64fc5b4c35b25733 = (state = [], action)=>{
    if (action.type === (0, $bkCF5.FLAG_DISMISSED)) {
        if (action.payload) {
            const { id: id } = action.payload;
            return (0, $7uUwQ.filter)((flag)=>flag.id !== id, state);
        }
    }
    // Add a flag to state if it is passed in the action's meta
    if (action.meta && action.meta.flag) {
        if (!$91d7a4795f84532d$export$623276a11554670b(state, action.meta.flag)) return state.concat(action.meta.flag);
    }
    return state;
};

});

parcelRegister("2hNE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $34af0c29c51d6f18$export$2e2bcd8739ae039);

var $blI7M = parcelRequire("blI7M");
const $34af0c29c51d6f18$var$defaultState = {
    isOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$34af0c29c51d6f18$export$2e2bcd8739ae039 = (state = $34af0c29c51d6f18$var$defaultState, action)=>{
    if (action.type === (0, $blI7M.OPEN_GLOBAL_ISSUE_CREATE)) return {
        isOpen: true,
        inputs: action.payload
    };
    if (action.type === (0, $blI7M.CLOSE_GLOBAL_ISSUE_CREATE)) return {
        isOpen: false
    };
    return state;
};

});
parcelRegister("blI7M", function(module, exports) {

$parcel$export(module.exports, "OPEN_GLOBAL_ISSUE_CREATE", () => $38473b0b2c8870f1$export$63ec531cc5ba8d9d);
$parcel$export(module.exports, "openGlobalIssueCreate", () => $38473b0b2c8870f1$export$85199c96cd869e6b);
$parcel$export(module.exports, "CLOSE_GLOBAL_ISSUE_CREATE", () => $38473b0b2c8870f1$export$3e9c51b746b35e9b);
$parcel$export(module.exports, "closeGlobalIssueCreate", () => $38473b0b2c8870f1$export$9a6ec6b262e11f76);
const $38473b0b2c8870f1$export$63ec531cc5ba8d9d = 'state.actions.global-issue-create.OPEN_GLOBAL_ISSUE_CREATE';
const $38473b0b2c8870f1$export$85199c96cd869e6b = (inputs)=>({
        type: $38473b0b2c8870f1$export$63ec531cc5ba8d9d,
        payload: inputs
    });
const $38473b0b2c8870f1$export$3e9c51b746b35e9b = 'state.actions.global-issue-create.CLOSE_GLOBAL_ISSUE_CREATE';
const $38473b0b2c8870f1$export$9a6ec6b262e11f76 = ()=>({
        type: $38473b0b2c8870f1$export$3e9c51b746b35e9b
    });

});


parcelRegister("jRjcj", function(module, exports) {

$parcel$export(module.exports, "default", () => $216d18064c0e67b5$export$2e2bcd8739ae039);

var $iaYF9 = parcelRequire("iaYF9");
const $216d18064c0e67b5$var$defaultState = {
    isOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$216d18064c0e67b5$export$2e2bcd8739ae039 = (state = $216d18064c0e67b5$var$defaultState, action)=>{
    if (action.type === (0, $iaYF9.SHOW_ISSUE_ADD_LABEL_MODAL)) return {
        isOpen: true,
        issueIds: action.payload
    };
    if (action.type === (0, $iaYF9.HIDE_ISSUE_ADD_LABEL_MODAL)) return {
        isOpen: false
    };
    return state;
};

});

parcelRegister("kVppN", function(module, exports) {

$parcel$export(module.exports, "issueDeleteModalReducer", () => $3f1f7edb9109e2d5$export$f375b7c512c770b9);

var $2f454 = parcelRequire("2f454");

var $kXqRJ = parcelRequire("kXqRJ");

var $5s6yC = parcelRequire("5s6yC");
const $3f1f7edb9109e2d5$export$f375b7c512c770b9 = (state = {
    isOpen: false
}, action)=>{
    if (action.type === (0, $5s6yC.ISSUE_DELETE_MODAL_OPEN)) {
        const { issueId: issueId } = action.payload;
        return {
            isOpen: true,
            issueId: issueId
        };
    }
    if (action.type === (0, $5s6yC.ISSUE_DELETE_MODAL_CLOSE)) return {
        isOpen: false
    };
    if (action.type === (0, $kXqRJ.ISSUE_DELETE_REQUEST) || action.type === (0, $2f454.CARD_DELETE)) return {
        isOpen: false
    };
    return state;
};

});

parcelRegister("i1NTq", function(module, exports) {

$parcel$export(module.exports, "issueFlagWithCommentModalReducer", () => $4cf26fba19e758c6$export$ee446224d0f5ef56);

var $7W4VK = parcelRequire("7W4VK");
const $4cf26fba19e758c6$var$defaultState = {
    isOpen: false
};
const $4cf26fba19e758c6$export$ee446224d0f5ef56 = (state = $4cf26fba19e758c6$var$defaultState, action)=>{
    if (action.type === (0, $7W4VK.SHOW_ISSUE_FLAG_WITH_COMMENT_MODAL)) return {
        isOpen: true,
        issueId: action.payload.issueId
    };
    if (action.type === (0, $7W4VK.HIDE_ISSUE_FLAG_WITH_COMMENT_MODAL)) return {
        isOpen: false
    };
    return state;
};

});
parcelRegister("7W4VK", function(module, exports) {

$parcel$export(module.exports, "SHOW_ISSUE_FLAG_WITH_COMMENT_MODAL", () => $7215d345484740d8$export$808b6606cd4c70af);
$parcel$export(module.exports, "showIssueFlagWithCommentModal", () => $7215d345484740d8$export$e4093de7ee2f0f39);
$parcel$export(module.exports, "HIDE_ISSUE_FLAG_WITH_COMMENT_MODAL", () => $7215d345484740d8$export$8f697207934c85c6);
$parcel$export(module.exports, "hideIssueFlagWithCommentModal", () => $7215d345484740d8$export$5c957528a61ef5de);
const $7215d345484740d8$export$808b6606cd4c70af = 'state.actions.issue.flag-with-comment-modal.SHOW_ISSUE_FLAG_WITH_COMMENT_MODAL';
const $7215d345484740d8$export$e4093de7ee2f0f39 = (issueId)=>({
        type: $7215d345484740d8$export$808b6606cd4c70af,
        payload: {
            issueId: issueId
        }
    });
const $7215d345484740d8$export$8f697207934c85c6 = 'state.actions.issue.flag-with-comment-modal.HIDE_ISSUE_FLAG_WITH_COMMENT_MODAL';
const $7215d345484740d8$export$5c957528a61ef5de = ()=>({
        type: $7215d345484740d8$export$8f697207934c85c6
    });

});


parcelRegister("ge2Re", function(module, exports) {

$parcel$export(module.exports, "issueModalReducer", () => $d562b13d393fa419$export$7353a8150fe3dca8);

var $7uUwQ = parcelRequire("7uUwQ");

var $7tJ5d = parcelRequire("7tJ5d");

var $dW1HX = parcelRequire("dW1HX");
const $d562b13d393fa419$var$initialState = (0, $7uUwQ.freeze)({
    selectedIssueKey: null,
    timestamp: 0,
    externalAction: undefined
});
const $d562b13d393fa419$export$7353a8150fe3dca8 = (state = $d562b13d393fa419$var$initialState, action)=>{
    if (action.type === (0, $dW1HX.OPEN_ISSUE_MODAL)) {
        if (state.selectedIssueKey !== action.payload.issueKey) return {
            ...state,
            selectedIssueKey: action.payload.issueKey,
            externalAction: action.payload.externalAction
        };
        return state;
    }
    if (action.type === (0, $7tJ5d.UPDATE_DETAIL_VIEW)) return {
        ...state,
        timestamp: Date.now()
    };
    if (action.type === (0, $dW1HX.CLOSE_ISSUE_MODAL)) return $d562b13d393fa419$var$initialState;
    if (action.type === (0, $dW1HX.RESET_EXTERNAL_ACTION)) return {
        ...state,
        externalAction: undefined
    };
    return state;
};

});

parcelRegister("iGgUa", function(module, exports) {

$parcel$export(module.exports, "default", () => $3442316de377b4a9$export$2e2bcd8739ae039);

var $1fh1A = parcelRequire("1fh1A");
const $3442316de377b4a9$var$defaultState = {
    isOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3442316de377b4a9$export$2e2bcd8739ae039 = (state = $3442316de377b4a9$var$defaultState, action)=>{
    if (action.type === (0, $1fh1A.OPEN_ISSUE_TRANSITION_MODAL)) return {
        isOpen: true,
        ...action.payload
    };
    if (action.type === (0, $1fh1A.CLOSE_ISSUE_TRANSITION_MODAL)) return {
        isOpen: false
    };
    return state;
};

});

parcelRegister("gXQl3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fceda3f618083c4a$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");


var $2ON1s = parcelRequire("2ON1s");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $fceda3f618083c4a$var$initialState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fceda3f618083c4a$export$2e2bcd8739ae039 = (state = $fceda3f618083c4a$var$initialState, action)=>{
    switch(action.type){
        case 0, $2ON1s.TOGGLE_PANEL:
            {
                const { payload: { panel: panel } } = action;
                // For other panels that exist in future, we can close them here if needed
                return state[panel] === true ? (0, $7uUwQ.unset)(state, panel) : (0, $7uUwQ.set)(state, panel, true);
            }
        case 0, $2ON1s.OPEN_INSIGHTS_PANEL:
            return (0, $7uUwQ.set)(state, (0, $8cd646738f5ee7ac$export$29d7f2210b16d662), true);
        case 0, $2ON1s.CLOSE_INSIGHTS_PANEL:
            return (0, $7uUwQ.unset)(state, (0, $8cd646738f5ee7ac$export$29d7f2210b16d662));
        case 0, $2ON1s.CLOSE_VIEW_SETTINGS_PANEL:
            return (0, $7uUwQ.unset)(state, (0, $8cd646738f5ee7ac$export$ba1da943283b9900));
        default:
            {
                // @ts-expect-error - TS2322: Type 'ShowErrorFlagAction | SetPersonAction | AddToSprintRequestAction | AddToSprintSuccessAction | ... 253 more ... | UnsupportedAction' is not assignable to type 'never'.
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
const $8cd646738f5ee7ac$export$29d7f2210b16d662 = 'INSIGHTS_PANEL';
const $8cd646738f5ee7ac$export$ba1da943283b9900 = 'VIEW_SETTINGS_PANEL';


parcelRegister("d9fmE", function(module, exports) {

$parcel$export(module.exports, "planIssueModalReducer", () => $3eccc506dbb1126a$export$56368bd004520bf4);

var $7uUwQ = parcelRequire("7uUwQ");

var $dW1HX = parcelRequire("dW1HX");
const $3eccc506dbb1126a$var$initialState = (0, $7uUwQ.freeze)({
    selectedIssueId: null
});
const $3eccc506dbb1126a$export$56368bd004520bf4 = (state = $3eccc506dbb1126a$var$initialState, action)=>{
    if (action.type === (0, $dW1HX.OPEN_PLAN_ISSUE_MODAL)) {
        if (state.selectedIssueId !== action.payload.issueId) return {
            ...state,
            selectedIssueId: action.payload.issueId
        };
        return state;
    }
    if (action.type === (0, $dW1HX.CLOSE_PLAN_ISSUE_MODAL)) return $3eccc506dbb1126a$var$initialState;
    return state;
};

});

parcelRegister("fJuCu", function(module, exports) {

$parcel$export(module.exports, "sprintAssociationModalReducer", () => $6889dbed4cdbc28d$export$2ef4e466a189fe0d);

var $jbAX5 = parcelRequire("jbAX5");
const $6889dbed4cdbc28d$var$defaultState = {
    isOpen: false
};
const $6889dbed4cdbc28d$export$2ef4e466a189fe0d = (state = $6889dbed4cdbc28d$var$defaultState, action)=>{
    if (action.type === (0, $jbAX5.OPEN_TEAM_SPRINT_ASSOCIATION_MODEL)) return {
        isOpen: true,
        ...action.payload
    };
    if (action.type === (0, $jbAX5.CLOSE_TEAM_SPRINT_ASSOCIATION_MODEL)) return {
        isOpen: false
    };
    return state;
};

});
parcelRegister("jbAX5", function(module, exports) {

$parcel$export(module.exports, "OPEN_TEAM_SPRINT_ASSOCIATION_MODEL", () => $e94921d318e3de92$export$a294b2632c80a061);
$parcel$export(module.exports, "openTeamAssociationModal", () => $e94921d318e3de92$export$f76f2b553b612cfa);
$parcel$export(module.exports, "CLOSE_TEAM_SPRINT_ASSOCIATION_MODEL", () => $e94921d318e3de92$export$9477d66d294f5655);
$parcel$export(module.exports, "closeTeamAssociationModal", () => $e94921d318e3de92$export$c00be92b9b94c0ab);
const $e94921d318e3de92$export$a294b2632c80a061 = 'state.actions.sprint.sprint-association-modal.OPEN_TEAM_SPRINT_ASSOCIATION_MODEL';
const $e94921d318e3de92$export$f76f2b553b612cfa = (teamId)=>({
        type: $e94921d318e3de92$export$a294b2632c80a061,
        payload: {
            teamId: teamId
        }
    });
const $e94921d318e3de92$export$9477d66d294f5655 = 'state.actions.sprint.sprint-association-modal.CLOSE_TEAM_SPRINT_ASSOCIATION_MODEL';
const $e94921d318e3de92$export$c00be92b9b94c0ab = ()=>({
        type: $e94921d318e3de92$export$9477d66d294f5655
    });

});


parcelRegister("6dO4m", function(module, exports) {

$parcel$export(module.exports, "sprintsReducer", () => $3b0a41db2272b0ce$export$4b86860ac786fd91);


var $cY26q = parcelRequire("cY26q");

var $dnW4F = parcelRequire("dnW4F");

var $Nogwi = parcelRequire("Nogwi");

var $aXi41 = parcelRequire("aXi41");
const $3b0a41db2272b0ce$export$4b86860ac786fd91 = (state = (0, $aXi41.initialSprintsState), action)=>{
    if (action.type === (0, $Nogwi.SELECT_SPRINTS)) {
        const { sprintFilterIds: sprintFilterIds } = action.payload;
        return {
            selected: sprintFilterIds
        };
    }
    if (action.type === (0, $Nogwi.CLEAR_SELECTED_SPRINTS) || action.type === (0, $cY26q.FILTERED_CARD_CLEAR)) return {
        selected: []
    };
    if (action.type === (0, $dnW4F.FILTERS_SET) && action.payload.filterType === 'SPRINT') {
        const { values: values } = action.payload;
        return {
            selected: Array.isArray(values) ? values : [
                values
            ]
        };
    }
    if (action.type === (0, $dnW4F.SET_ALL_FILTERS)) return {
        selected: action.payload.filters[0, $15a528573ccd89ae$export$a316570a0dbfd2b0] || []
    };
    return state;
};

});
parcelRegister("Nogwi", function(module, exports) {

$parcel$export(module.exports, "SELECT_SPRINTS", () => $827df433191f4525$export$e465b141afd3c3ea);
$parcel$export(module.exports, "selectSprint", () => $827df433191f4525$export$e075700f212b976d);
$parcel$export(module.exports, "CLEAR_SELECTED_SPRINTS", () => $827df433191f4525$export$c15dc8c4e6333b71);
const $827df433191f4525$export$e465b141afd3c3ea = 'state.actions.sprints.select.SELECT_SPRINTS';
const $827df433191f4525$export$e075700f212b976d = ({ sprintFilterIds: sprintFilterIds })=>({
        type: $827df433191f4525$export$e465b141afd3c3ea,
        payload: {
            sprintFilterIds: sprintFilterIds
        }
    });
const $827df433191f4525$export$c15dc8c4e6333b71 = 'state.actions.sprints.select.CLEAR_SELECTED_SPRINTS';

});


parcelRegister("8V3MB", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b85d16dd61ecdd$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $jFOhg = parcelRequire("jFOhg");

var $achtv = parcelRequire("achtv");
var $18b85d16dd61ecdd$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    collapsed: (0, $jFOhg.swimlanesCollapsedReducer),
    mode: (0, $achtv.swimlaneModeReducer)
});

});
parcelRegister("jFOhg", function(module, exports) {

$parcel$export(module.exports, "swimlanesCollapsedReducer", () => $9001dca2ff0fb738$export$46d9063a28b5d3fc);

var $7uUwQ = parcelRequire("7uUwQ");

var $k50Aq = parcelRequire("k50Aq");
const $9001dca2ff0fb738$export$46d9063a28b5d3fc = (state = [], action)=>{
    if (action.type === (0, $k50Aq.SWIMLANE_TOGGLE)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        const index = state.indexOf(payload);
        if (index === -1) return (0, $7uUwQ.push)(state, payload);
        return (0, $7uUwQ.splice)(state, index, 1);
    }
    if (action.type === (0, $k50Aq.SWIMLANES_TOGGLE)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        if (state.length === payload.length) return [];
        return payload;
    }
    if (action.type === (0, $k50Aq.SWIMLANES_EXPAND)) return [];
    if (action.type === (0, $k50Aq.SWIMLANES_COLLAPSE)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        return payload;
    }
    return state;
};

});

parcelRegister("achtv", function(module, exports) {

$parcel$export(module.exports, "swimlaneModeReducer", () => $c1ec1b5315c94439$export$be1415bc49b4143e);

var $iuuJH = parcelRequire("iuuJH");

var $k50Aq = parcelRequire("k50Aq");

var $cW3pH = parcelRequire("cW3pH");
const $c1ec1b5315c94439$export$be1415bc49b4143e = (state = (0, $iuuJH.NO_SWIMLANE).id, action)=>{
    if (action.type === (0, $k50Aq.SWIMLANE_MODE_CHANGE_REQUEST)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        return payload;
    }
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        return payload.swimlaneModeId;
    }
    return state;
};

});


parcelRegister("3Nx75", function(module, exports) {

$parcel$export(module.exports, "updateIssueParentModalReducer", () => $f445cfcba4d7248d$export$d3e9746491c4a22f);

var $cdcje = parcelRequire("cdcje");
const $f445cfcba4d7248d$export$d3e9746491c4a22f = (state = {
    isOpen: false
}, action)=>{
    if (action.type === (0, $cdcje.SHOW_UPDATE_ISSUE_PARENT_MODAL)) {
        const { issueParentId: issueParentId, transitions: transitions } = action.payload;
        return {
            isOpen: true,
            issueParentId: issueParentId,
            transitions: transitions
        };
    }
    if (action.type === (0, $cdcje.HIDE_UPDATE_ISSUE_PARENT_MODAL)) return {
        isOpen: false
    };
    return state;
};

});

parcelRegister("7N9ZT", function(module, exports) {

$parcel$export(module.exports, "workFiltersReducer", () => $fa3be4c7e8b97005$export$4315784b09c1b241);

var $7uUwQ = parcelRequire("7uUwQ");

var $dnW4F = parcelRequire("dnW4F");
const $fa3be4c7e8b97005$var$initialState = {
    values: {}
};
const $fa3be4c7e8b97005$export$4315784b09c1b241 = (state = $fa3be4c7e8b97005$var$initialState, action)=>{
    if (action.type === (0, $dnW4F.FILTERS_SET)) return (0, $7uUwQ.setIn)(state, [
        'values',
        action.payload.filterType
    ], action.payload.values);
    if (action.type === (0, $dnW4F.SET_ALL_FILTERS)) return (0, $7uUwQ.setIn)(state, [
        'values'
    ], action.payload.filters);
    return state;
};

});




parcelRegister("a9mbK", function(module, exports) {

$parcel$export(module.exports, "default", () => $84663b95f9134fad$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $daJ0i = parcelRequire("daJ0i");

var $8lxl7 = parcelRequire("8lxl7");

var $hZHze = parcelRequire("hZHze");

var $5rFbt = parcelRequire("5rFbt");


var $bC2fB = parcelRequire("bC2fB");

var $dFfIn = parcelRequire("dFfIn");

var $kxZPA = parcelRequire("kxZPA");

var $fqLDH = parcelRequire("fqLDH");

var $d2i8f = parcelRequire("d2i8f");

var $6g14V = parcelRequire("6g14V");

var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $45cXl = parcelRequire("45cXl");

var $cPGP0 = parcelRequire("cPGP0");

var $5mTgl = parcelRequire("5mTgl");

var $gfv3x = parcelRequire("gfv3x");

var $gGhzv = parcelRequire("gGhzv");

var $dHKcT = parcelRequire("dHKcT");

var $hOou0 = parcelRequire("hOou0");

var $gdLuI = parcelRequire("gdLuI");

var $lkgHI = parcelRequire("lkgHI");

var $7CZZJ = parcelRequire("7CZZJ");

var $eqAt8 = parcelRequire("eqAt8");

var $jFKZt = parcelRequire("jFKZt");

var $i9WnN = parcelRequire("i9WnN");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $84663b95f9134fad$var$AfterPaintModals = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("ignYi")), {
    ssr: false,
    moduleId: "./src/packages/software/board/src/view/modals/index.tsx"
});
const $84663b95f9134fad$var$incrementPlanningBoardAnalyticsAttributes = (state)=>{
    const issuesByColumn = (0, $d2i8f.getOrderedIssuesByColumn)(state);
    const totalUnplannedIssues = issuesByColumn[0, $5rFbt.UNSCHEDULED_COLUMN_ID] ? Object.keys(issuesByColumn[0, $5rFbt.UNSCHEDULED_COLUMN_ID]).length : 0;
    const boardScopeFilterType = (0, $67Z81.getBoardScopeFilterType)(state);
    return {
        teamsWithLinkedSprints: Object.keys((0, $cPGP0.getSprintCapacityInfo)(state)).length,
        appliedFilters: (0, $5mTgl.getWorkFilters)(state),
        boardScopeFilterType: boardScopeFilterType,
        totalIssues: Object.keys((0, $67Z81.getIssues)(state)).length,
        totalUnplannedIssues: totalUnplannedIssues
    };
};
// define separate analytics source and subject for JSW board and Plan program board (aka increment planning board)
const $84663b95f9134fad$var$BoardAnalyticsHOC = ()=>(WrappedComponent)=>(props)=>{
            const analyticsSource = props.isIncrementPlanningBoard ? 'programBoard' : 'board';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daJ0i.default), {
                data: {
                    actionSubject: analyticsSource,
                    source: `${analyticsSource}${(0, $4d5e0871c06cee03$export$f636b5b56f1d624a)}`
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props));
        };
const $84663b95f9134fad$var$App = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $bC2fB.connect)((state, ownProps)=>({
        isCacheHit: ownProps.isCacheHit,
        customFiltersQueryRef: ownProps.customFiltersQueryRef,
        Header: $7CZZJ.default,
        Modals: $84663b95f9134fad$var$AfterPaintModals,
        Flags: $gdLuI.default,
        Board: (0, $gfv3x.default),
        ViewTracker: $hZHze.default,
        DocumentTitle: $dHKcT.default,
        PrefetchIssues: (0, $eqAt8.default),
        DetailView: $gGhzv.default,
        Realtime: $jFKZt.default,
        AddBoardToHistory: $dFfIn.default,
        GlobalSearchTracker: $lkgHI.default,
        isInsightsPanelOpen: (0, $6g14V.getInsightsPanel)(state),
        baseUrl: (0, $67Z81.contextPathSelector)(state),
        projectKey: (0, $67Z81.projectKeySelector)(state),
        estimationStatistic: (0, $5mTgl.getEstimationStatistic)(state),
        currentUserAccountId: (0, $36pz7.getCurrentUserAccountId)(state),
        issueLimitExceeded: (0, $67Z81.getIssueLimitExceeded)(state),
        savedFilterId: (0, $67Z81.getSavedFilterId)(state),
        selectedSprintsOrAllSprints: (0, $ebHh7.getSelectedOrAllSprintsSelector)(state)
    }), {}), $84663b95f9134fad$var$BoardAnalyticsHOC(), (0, $8lxl7.default)((state)=>({
        containerType: 'project',
        containerId: String((0, $67Z81.projectIdSelector)(state)),
        attributes: {
            projectId: (0, $67Z81.projectIdSelector)(state),
            boardId: (0, $67Z81.rapidViewIdSelector)(state),
            isIssueDetailVisible: (0, $fqLDH.isIssueModalShowingSelector)(state),
            isUIF: true,
            isClassic: (0, $67Z81.getIsCMPBoard)(state),
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            isInactiveTab: document.hidden,
            boardType: (0, $67Z81.getBoardTypeForAnalytics)(state),
            projectType: (0, $67Z81.projectTypeSelector)(state),
            swimlaneMode: (0, $45cXl.getSwimlaneMode)(state),
            ...(0, $67Z81.getIsIncrementPlanningBoard)(state) ? $84663b95f9134fad$var$incrementPlanningBoardAnalyticsAttributes(state) : {}
        }
    })))((0, $i9WnN.default));
var $84663b95f9134fad$export$2e2bcd8739ae039 = (0, $hOou0.withViewExperienceTracker)($84663b95f9134fad$var$App);

});
parcelRegister("8lxl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3768e8b105140d5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $daJ0i = parcelRequire("daJ0i");

var $bC2fB = parcelRequire("bC2fB");

var $cAj1I = parcelRequire("cAj1I");

var $i4iBk = parcelRequire("i4iBk");
const $d3768e8b105140d5$var$ReduxAnalyticsData = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToAnalytics, connectOptions = {})=>(WrappedComponent)=>{
        // eslint-disable-next-line jira/react/no-class-components
        class ComponentWrappedInAnalytics extends (0, $5uXOq.Component) {
            static{
                this.displayName = `ReduxAnalyticsData(${WrappedComponent.displayName || WrappedComponent.name})`;
            }
            static{
                this.defaultProps = {
                    analyticsContext: {}
                };
            }
            render() {
                const { analyticsContext: analyticsContext, ...componentProps } = this.props;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daJ0i.default), {
                    data: analyticsContext
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, componentProps));
            }
        }
        const mapStateToPropsFactory = ()=>{
            const analyticsContextSelectorInstance = (0, $8QpSo.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            (state, ownProps)=>(0, $i4iBk.default)(mapStateToAnalytics(state, ownProps)));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (state, ownProps)=>({
                    analyticsContext: analyticsContextSelectorInstance(state, ownProps)
                });
        };
        return (0, $bC2fB.connect)(mapStateToPropsFactory, ()=>({}), null, {
            // to prevent connected component from unnecessary re-render
            areStatePropsEqual: (nextProps, prevProps)=>{
                const { attributes: prevAttributes, ...prevFields } = prevProps.analyticsContext;
                const { attributes: nextAttributes, ...nextFields } = nextProps.analyticsContext;
                return (0, $cAj1I.default)(prevAttributes, nextAttributes) && (0, $cAj1I.default)(prevFields, nextFields);
            },
            ...connectOptions
        })(ComponentWrappedInAnalytics);
    };
var $d3768e8b105140d5$export$2e2bcd8739ae039 = $d3768e8b105140d5$var$ReduxAnalyticsData;

});
parcelRegister("cAj1I", function(module, exports) {

$parcel$export(module.exports, "default", () => $95d580e76a13b783$export$2e2bcd8739ae039);
const $95d580e76a13b783$var$isArrayEqual = (array1 = [], array2 = [])=>{
    if (array1 === array2) return true;
    // check one level deep
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};
var // one level check to see if object references are equal
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$95d580e76a13b783$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'never[]'.
    if (!$95d580e76a13b783$var$isArrayEqual(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        const value = obj1[key];
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        // @ts-expect-error - TS2345 - Argument of type 'any[]' is not assignable to parameter of type 'never[]'.
        return Array.isArray(nextValue) && Array.isArray(value) && $95d580e76a13b783$var$isArrayEqual(value, nextValue);
    });
    return areValuesEqual;
};

});


parcelRegister("hZHze", function(module, exports) {

$parcel$export(module.exports, "default", () => $69dc4a27be9f367e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $gvRPW = parcelRequire("gvRPW");
// eslint-disable-next-line jira/react/no-class-components
class $69dc4a27be9f367e$var$ViewTracker extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $69dc4a27be9f367e$var$ViewTrackerWithAnalytics = (0, $994MI.default)({
    componentName: 'view-tracker'
})((0, $cb25w.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $gvRPW.PAGE_EVENT_ACTION)
        }).fire()
})($69dc4a27be9f367e$var$ViewTracker));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$69dc4a27be9f367e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($69dc4a27be9f367e$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    });

});

parcelRegister("dFfIn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c54faa42ed76e90b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1u3Jv = parcelRequire("1u3Jv");

var $cACkL = parcelRequire("cACkL");
const $c54faa42ed76e90b$var$AddBoardToHistory = ({ baseUrl: baseUrl, boardId: boardId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1u3Jv.default), {
        op: ()=>(0, $cACkL.addBoardToHistory)(baseUrl, boardId)
    });
var $c54faa42ed76e90b$export$2e2bcd8739ae039 = $c54faa42ed76e90b$var$AddBoardToHistory;

});
parcelRegister("cACkL", function(module, exports) {

$parcel$export(module.exports, "addBoardToHistory", () => $350fcc2e90657d19$export$eef897770c591084);

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");
const $350fcc2e90657d19$export$eef897770c591084 = (baseUrl, boardId)=>(0, $eusud.performPostRequest)(`${baseUrl}/rest/greenhopper/1.0/rapidview/addtohistory`, {
        body: JSON.stringify({
            rapidViewId: boardId
        })
    }).catch((e)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('software.view-history.src.services', 'Cannot add board to recent history', e);
    });

});


parcelRegister("6g14V", function(module, exports) {

$parcel$export(module.exports, "getInsightsPanel", () => $584bed1ec95aed7d$export$806d34b644f1954d);
$parcel$export(module.exports, "getViewSettingsPanel", () => $584bed1ec95aed7d$export$a0b20e22a1f77091);

const $584bed1ec95aed7d$export$be078297eeb6e8a2 = (state)=>state.ui.panels;
const $584bed1ec95aed7d$export$806d34b644f1954d = (state)=>state.ui.panels?.[0, $8cd646738f5ee7ac$export$29d7f2210b16d662] || false;
const $584bed1ec95aed7d$export$a0b20e22a1f77091 = (state)=>state.ui.panels?.[0, $8cd646738f5ee7ac$export$ba1da943283b9900] || false;

});

parcelRegister("gfv3x", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c40f3b7b1ffd9f0$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $8QpSo = parcelRequire("8QpSo");

var $jzjy1 = parcelRequire("jzjy1");

var $2OMDV = parcelRequire("2OMDV");

var $bC2fB = parcelRequire("bC2fB");

var $2xFXk = parcelRequire("2xFXk");


var $iuuJH = parcelRequire("iuuJH");

var $cTkW0 = parcelRequire("cTkW0");

var $cW3pH = parcelRequire("cW3pH");

var $1vXOx = parcelRequire("1vXOx");

var $k8auG = parcelRequire("k8auG");

var $kc6Ry = parcelRequire("kc6Ry");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");

var $3nIju = parcelRequire("3nIju");

var $gHXMJ = parcelRequire("gHXMJ");

var $aYlA2 = parcelRequire("aYlA2");

var $luiFO = parcelRequire("luiFO");

var $d6mgg = parcelRequire("d6mgg");

var $4z5Te = parcelRequire("4z5Te");

var $8ydSK = parcelRequire("8ydSK");

var $22mIG = parcelRequire("22mIG");

var $3nXC3 = parcelRequire("3nXC3");
const $7c40f3b7b1ffd9f0$export$c31df4bd766f9c35 = (state)=>{
    const permissions = (0, $1vXOx.getPermissionsSelector)(state);
    const hasSwimlanes = (0, $45cXl.getSwimlaneMode)(state) !== (0, $iuuJH.NO_SWIMLANE).id;
    const boardSessionId = (0, $67Z81.sessionIdSelector)(state);
    const isNonCriticalWorksetLoaded = (0, $5mTgl.isBoardConfigLoaded)(state);
    const locale = (0, $67Z81.getLocale)(state);
    const preventInlineEditing = (0, $k8auG.getPreventInlineEditing)(state);
    const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
    const isUnscheduledColumnVisible = isIncrementPlanningBoard ? (0, $5mTgl.getIsUnscheduledColumnVisible)(state) : undefined;
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    // This hides the ColumnConfiguration button for CMP
    const isColumnConfigurationButtonEnabled = !isCMPBoard;
    return {
        isColumnCreateAllowed: permissions[0, $e525e6c25695c9df$export$c5d82f9af027c432] || false,
        isInlineColumnEditEnabled: (0, $5mTgl.isInlineColumnEditEnabled)(state),
        isFlexibleColumns: (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).FLEXIBLE_BOARD_COLUMNS),
        hasSwimlanes: hasSwimlanes,
        isNonCriticalWorksetLoaded: isNonCriticalWorksetLoaded,
        boardSessionId: boardSessionId,
        locale: locale,
        preventInlineEditing: preventInlineEditing,
        shouldRenderSwimlane: (0, $k8auG.shouldRenderSwimlaneSelector)(state),
        isSprintsEnabled: (0, $ebHh7.isSprintsEnabled)(state),
        isIncrementPlanningBoard: isIncrementPlanningBoard,
        isColumnConfigurationButtonEnabled: isColumnConfigurationButtonEnabled,
        isUnscheduledColumnVisible: isUnscheduledColumnVisible
    };
};
const $7c40f3b7b1ffd9f0$export$9e6a17cf56877796 = (dispatch)=>({
        dispatch: dispatch
    });
const $7c40f3b7b1ffd9f0$var$onBoardNonCriticalViewedFactory = (0, $8QpSo.default)((dispatch)=>(analyticsEvent)=>// @ts-expect-error - Argument of type 'BoardNonCriticalViewAction' is not assignable to parameter of type 'Action'.
        dispatch((0, $cW3pH.boardNonCriticalView)(analyticsEvent)));
const $7c40f3b7b1ffd9f0$var$onPreventInlineEditingFactory = (0, $8QpSo.default)((dispatch)=>(shouldPreventInlineEditing)=>dispatch((0, $cTkW0.preventInlineEditingAction)(shouldPreventInlineEditing)));
const $7c40f3b7b1ffd9f0$var$mergeProps = (stateProps, dispatchProps, ownProps)=>{
    const { isCacheHit: isCacheHit } = ownProps;
    return {
        ...ownProps,
        ...stateProps,
        isCacheHit: isCacheHit,
        Board: $3nIju.default,
        BacklogIssueMoveDialog: $gHXMJ.default,
        KeyboardShortcuts: $d6mgg.default,
        ColumnCreate: $luiFO.default,
        ColumnConfigurationButton: $aYlA2.default,
        BoardMinimap: $4z5Te.default,
        SubmitApdex: $22mIG.default,
        ScrollObserver: $8ydSK.default,
        onBoardNonCriticalViewed: $7c40f3b7b1ffd9f0$var$onBoardNonCriticalViewedFactory(dispatchProps.dispatch),
        onPreventInlineEditing: $7c40f3b7b1ffd9f0$var$onPreventInlineEditingFactory(dispatchProps.dispatch)
    };
};
const $7c40f3b7b1ffd9f0$var$connector = (0, $bC2fB.connect)($7c40f3b7b1ffd9f0$export$c31df4bd766f9c35, $7c40f3b7b1ffd9f0$export$9e6a17cf56877796, $7c40f3b7b1ffd9f0$var$mergeProps);
var $7c40f3b7b1ffd9f0$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $2OMDV.AnalyticsEventToProps)('board', {
    onBoardNonCriticalViewed: 'viewed'
}), $7c40f3b7b1ffd9f0$var$connector, (0, $jzjy1.AnalyticsSubject)('boardNonCritical'))((0, $3nXC3.default));

});
parcelRegister("2OMDV", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $28422a5dfa4a4065$export$3e9ef96ba97ea9dc);

var $cb25w = parcelRequire("cb25w");
const $28422a5dfa4a4065$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $28422a5dfa4a4065$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $cb25w.default)($28422a5dfa4a4065$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

parcelRegister("3nIju", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad74bb09a2893594$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $8QpSo = parcelRequire("8QpSo");

var $2gCtH = parcelRequire("2gCtH");

var $5Emok = parcelRequire("5Emok");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");

var $bC2fB = parcelRequire("bC2fB");

var $2xFXk = parcelRequire("2xFXk");

var $cW3pH = parcelRequire("cW3pH");

var $kc6Ry = parcelRequire("kc6Ry");

var $fqLDH = parcelRequire("fqLDH");

var $6g14V = parcelRequire("6g14V");
const $ad74bb09a2893594$export$c31df4bd766f9c35 = (state)=>({
        getIssueKeyForModal: (0, $fqLDH.getIssueKeyForModal)(state),
        isInsightsPanelOpen: (0, $6g14V.getInsightsPanel)(state),
        flexibleColumns: (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).FLEXIBLE_BOARD_COLUMNS)
    });
const $ad74bb09a2893594$export$9e6a17cf56877796 = (dispatch)=>({
        dispatch: dispatch
    });
const $ad74bb09a2893594$var$onBoardViewFactory = (0, $8QpSo.default)((dispatch)=>(boardInfo, analyticsEvent)=>dispatch((0, $cW3pH.boardView)({
            ...boardInfo
        }, analyticsEvent)));
const $ad74bb09a2893594$var$onScrollFactory = (0, $8QpSo.default)(()=>(boardScrollInfo, analyticsEvent)=>{
        const { reachedLeftEdge: reachedLeftEdge, reachedRightEdge: reachedRightEdge } = boardScrollInfo;
        if (reachedLeftEdge || reachedRightEdge) {
            const payload = {
                reachedLeftEdge: reachedLeftEdge,
                reachedRightEdge: reachedRightEdge
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, payload);
        }
    });
const $ad74bb09a2893594$export$9d1611c77c2fe928 = (stateProps, dispatchProps, ownProps)=>({
        ...ownProps,
        getIssueKeyForModal: stateProps.getIssueKeyForModal,
        isInsightsPanelOpen: stateProps.isInsightsPanelOpen,
        flexibleColumns: stateProps.flexibleColumns,
        onBoardView: $ad74bb09a2893594$var$onBoardViewFactory(dispatchProps.dispatch),
        externalId: 'software.board',
        onScroll: $ad74bb09a2893594$var$onScrollFactory()
    });
const $ad74bb09a2893594$var$withOffsetRightPaddingByWidth = (WrappedComponent)=>(props)=>{
        const viewMode = (0, $2gCtH.useViewMode)();
        const { getIssueKeyForModal: getIssueKeyForModalProp, isInsightsPanelOpen: isInsightsPanelOpenProp, ...rest } = props;
        const offsetRightPaddingByWidth = viewMode === 'SIDEBAR' && getIssueKeyForModalProp || isInsightsPanelOpenProp;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...rest,
            offsetRightPaddingByWidth: offsetRightPaddingByWidth
        });
    };
const $ad74bb09a2893594$var$connector = (0, $bC2fB.connect)($ad74bb09a2893594$export$c31df4bd766f9c35, $ad74bb09a2893594$export$9e6a17cf56877796, $ad74bb09a2893594$export$9d1611c77c2fe928);
var $ad74bb09a2893594$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $2OMDV.AnalyticsEventToProps)('board', {
    onBoardView: 'viewed',
    onScroll: 'scrolled'
}), $ad74bb09a2893594$var$withOffsetRightPaddingByWidth, $ad74bb09a2893594$var$connector)((0, $5Emok.default));

});
parcelRegister("5Emok", function(module, exports) {

$parcel$export(module.exports, "default", () => $0618b4b5c0e926e8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $8Rkzz = parcelRequire("8Rkzz");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $dCm1o = parcelRequire("dCm1o");

var $645AZ = parcelRequire("645AZ");

var $43IRS = parcelRequire("43IRS");

var $d1Nys = parcelRequire("d1Nys");

var $haPqS = parcelRequire("haPqS");
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0618b4b5c0e926e8$var$BoardContainerControl = /*#__PURE__*/ (0, $47bDC.default).section.withConfig({
    componentId: "hszmvp-0"
})`display:flex;flex-flow:row nowrap;justify-content:flex-start;align-items:stretch;user-select:none;padding:${(props)=>{
    if (props.isVisualRefresh) return `0 ${props.offsetRightPaddingByWidth ? "var(--ds-space-300, 24px)" : '0'} ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-250, 20px)"}`;
    if (props.flexibleColumns) return `0 ${props.offsetRightPaddingByWidth ? "var(--ds-space-300, 1.5rem)" : `${(0, $645AZ.layout).boardBorderWidth}px`} ${(0, $645AZ.layout).boardBorderWidth}px ${(0, $645AZ.layout).boardBorderWidth - (0, $645AZ.layout).columnMargin}px`;
    return `0 0 ${(0, $645AZ.layout).boardBorderWidth}px ${(0, $645AZ.layout).boardBorderWidth - (0, $645AZ.layout).cardListRadius}px`;
}};${(props)=>props.noBottomPadding ? 'padding-bottom: 0' : ''};min-width:fit-content;`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0618b4b5c0e926e8$var$BoardContainerExperimentBase = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { flexibleColumns: flexibleColumns, noBottomPadding: noBottomPadding, isVisualRefresh: isVisualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1da43ya": (0, $lD23V.default)(!__cmplp.flexibleColumns && "var(--ds-space-0, 0px)")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _1n261q9c _1bah1y6m _4cvr1fhb _uiztglyw _ca0qze3t _u5f31r1l _1ul91ns9",
            __cmplp.noBottomPadding ? "_n3tdze3t" : __cmplp.isVisualRefresh ? "_n3td1ejb" : "_n3td1ylp",
            __cmplp.isVisualRefresh ? "_19bvv47k" : __cmplp.flexibleColumns ? "_19bv1u1b" : "_19bv1u1b",
            __cmplp.className
        ])
    });
});
const $0618b4b5c0e926e8$var$BoardContainerExperiment = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0618b4b5c0e926e8$var$BoardContainerExperimentBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.offsetRightPaddingByWidth || __cmplp.isVisualRefresh ? "_u5f3gfnj" : "_u5f31ylp",
            __cmplp.className
        ])
    });
}); // Reduced left padding for the board if we have both the unscheduled work panel
const $0618b4b5c0e926e8$var$BoardContainerWithUnscheduledWorkPanel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0618b4b5c0e926e8$var$BoardContainerExperiment, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bvutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0618b4b5c0e926e8$var$UnscheduledWorkBoardContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0618b4b5c0e926e8$var$BoardContainerExperiment, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bvze3t _u5f3ze3t",
            __cmplp.className
        ])
    });
});
const $0618b4b5c0e926e8$var$BoardContainer = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $0618b4b5c0e926e8$var$BoardContainerExperiment, $0618b4b5c0e926e8$var$BoardContainerControl);
class $0618b4b5c0e926e8$export$dc537a3a3893548e extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            offsetRightPaddingByWidth: false,
            offsetLeftPaddingByWidth: false,
            noBottomPadding: false,
            onScroll: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onBoardView: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            flexibleColumns: false,
            isDropDisabled: false,
            isUnscheduledWorkColumnPanel: false,
            isBoardWithVisibleUnscheduledWorkPanel: false
        };
    }
    render() {
        const { flexibleColumns: flexibleColumns, noBottomPadding: noBottomPadding, isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel, isBoardWithVisibleUnscheduledWorkPanel: isBoardWithVisibleUnscheduledWorkPanel } = this.props;
        const leftBorder = !flexibleColumns && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d1Nys.LeftBorder), {
            offsetLeftPaddingByWidth: this.props.offsetLeftPaddingByWidth
        });
        const rightBorder = !flexibleColumns && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d1Nys.RightBorder), {
            offsetRightPaddingByWidth: this.props.offsetRightPaddingByWidth
        });
        const boardContainerChild = flexibleColumns ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $43IRS.TransitionZoneIndicatorContainerProvider), null, leftBorder, this.props.children, rightBorder) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, leftBorder, this.props.children, rightBorder);
        const shouldUseBoardWithUnscheduledWorkPanelPadding = !isUnscheduledWorkColumnPanel && !!isBoardWithVisibleUnscheduledWorkPanel;
        const BoardContainerWithAdjustedPadding = shouldUseBoardWithUnscheduledWorkPanelPadding ? $0618b4b5c0e926e8$var$BoardContainerWithUnscheduledWorkPanel : $0618b4b5c0e926e8$var$BoardContainer;
        const Container = isUnscheduledWorkColumnPanel ? $0618b4b5c0e926e8$var$UnscheduledWorkBoardContainer : BoardContainerWithAdjustedPadding;
        const boardContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Container, {
            flexibleColumns: flexibleColumns,
            noBottomPadding: noBottomPadding,
            offsetRightPaddingByWidth: this.props.offsetRightPaddingByWidth,
            isVisualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
        }, boardContainerChild);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $haPqS.default), {
            innerRef: this.props.scrollRef,
            onScroll: this.onScroll,
            onInit: this.onScrollInit,
            flexibleColumns: flexibleColumns
        }, boardContainer);
    }
    constructor(...args){
        super(...args);
        this.topEdge = true;
        this.leftEdge = true;
        this.rightEdge = true;
        this.onScrollInit = ({ hasHorizontalScrollbar: hasHorizontalScrollbar })=>{
            this.props.onBoardView({
                hasHorizontalScrollbar: hasHorizontalScrollbar,
                isUnscheduledWorkColumnPanel: this.props.isUnscheduledWorkColumnPanel
            });
        };
        this.onScroll = (scrollInfo)=>{
            const { topEdge: topEdge, leftEdge: leftEdge, rightEdge: rightEdge } = this;
            if (scrollInfo.topEdge !== topEdge) this.topEdge = scrollInfo.topEdge;
            if (scrollInfo.leftEdge !== leftEdge) this.leftEdge = scrollInfo.leftEdge;
            if (scrollInfo.rightEdge !== rightEdge) this.rightEdge = scrollInfo.rightEdge;
            const boardScrollInfo = {
                scrollLeft: scrollInfo.scrollLeft,
                scrollTop: scrollInfo.scrollTop,
                scrollWidth: scrollInfo.scrollWidth,
                clientWidth: scrollInfo.clientWidth,
                reachedLeftEdge: !leftEdge && scrollInfo.leftEdge,
                reachedRightEdge: !rightEdge && scrollInfo.rightEdge
            };
            this.props.onScroll(boardScrollInfo);
        };
    }
}
var $0618b4b5c0e926e8$export$2e2bcd8739ae039 = $0618b4b5c0e926e8$export$dc537a3a3893548e;

});
parcelRegister("gSExi", function(module, exports) {

$parcel$export(module.exports, "styledComponentWithCondition", () => $cd06fcc13efa32a5$export$62d8d8fbf238d6af);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");
const $cd06fcc13efa32a5$export$62d8d8fbf238d6af = (useCompiled, CompiledComponent, StyledComponent)=>// Couldn't destructure like {innerRef, ...rest} as
    // typescript is suspcious on destructing generics
    ({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });
const $cd06fcc13efa32a5$export$f5b752428255ba78 = (useCompiled, CompiledComponent, StyledComponent)=>({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });

});

parcelRegister("43IRS", function(module, exports) {

$parcel$export(module.exports, "TransitionZoneIndicatorContainerContext", () => $6fa57b6df684876d$export$b355823f25623ef7);
$parcel$export(module.exports, "TransitionZoneIndicatorContainerProvider", () => $6fa57b6df684876d$export$ebac9eb10481c829);

var $5uXOq = parcelRequire("5uXOq");
const $6fa57b6df684876d$export$b355823f25623ef7 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $6fa57b6df684876d$export$ebac9eb10481c829 = ({ children: children })=>{
    const contextValue = (0, $5uXOq.useMemo)(()=>{
        const transitionZoneIndicatorRefMap = {};
        return {
            setRef: (id, ref)=>{
                transitionZoneIndicatorRefMap[id] = ref;
            },
            getRef: (id)=>transitionZoneIndicatorRefMap[id],
            removeRef: (id)=>{
                delete transitionZoneIndicatorRefMap[id];
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6fa57b6df684876d$export$b355823f25623ef7.Provider, {
        value: contextValue
    }, children);
};

});

parcelRegister("d1Nys", function(module, exports) {

$parcel$export(module.exports, "LeftBorder", () => $381c281f5cbbb40a$export$2fa3cb6a784774af);
$parcel$export(module.exports, "RightBorder", () => $381c281f5cbbb40a$export$e6fd94403eb46f0);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");


var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $dCm1o = parcelRequire("dCm1o");

var $645AZ = parcelRequire("645AZ");

var $ilwFs = parcelRequire("ilwFs");

var $euZim = parcelRequire("euZim");
const $381c281f5cbbb40a$var$shadowWidth = 7;
const $381c281f5cbbb40a$export$2fa3cb6a784774af = ({ offsetLeftPaddingByWidth: offsetLeftPaddingByWidth })=>{
    const [hasScrollLeft] = (0, $euZim.useBoardHasScrollLeft)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($381c281f5cbbb40a$var$BoardBorderLeftStyle, {
        isShadowVisible: hasScrollLeft,
        offsetLeftPaddingByWidth: offsetLeftPaddingByWidth,
        isVisualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    });
};
const $381c281f5cbbb40a$export$e6fd94403eb46f0 = ({ offsetRightPaddingByWidth: offsetRightPaddingByWidth })=>{
    const [isAtRightScrollEdge] = (0, $euZim.useBoardScrollIsAtRightEdge)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($381c281f5cbbb40a$var$BoardBorderRightStyle, {
        isShadowVisible: !isAtRightScrollEdge,
        offsetRightPaddingByWidth: offsetRightPaddingByWidth,
        isVisualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $381c281f5cbbb40a$var$BoardBorderStyleControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-18q9p5w-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        display: !(0, $ilwFs.isStickySupported) ? 'none' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-surface, ${(0, $829f609a65d26a98$exports).N0})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.isVisualRefresh ? "var(--ds-space-300, 24px)" : `${(0, $645AZ.layout).boardBorderWidth}px`,
        position: 'sticky',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.isShadowVisible ? 1 : 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        pointerEvents: props.isShadowVisible ? 'auto' : 'none',
        transition: 'opacity 0.2s',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $645AZ.zIndex).boardBorders
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $381c281f5cbbb40a$var$BoardBorderLeftStyleControl = /*#__PURE__*/ (0, $47bDC.default)($381c281f5cbbb40a$var$BoardBorderStyleControl).withConfig({
    componentId: "sc-18q9p5w-1"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        left: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginLeft: props.isVisualRefresh ? "var(--ds-space-negative-300, -24px)" : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        `${-(0, $645AZ.layout).boardBorderWidth}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 ${(0, $645AZ.layout).boardBorderWidth * 2}px 0
            ${"var(--ds-shadow-overflow-spread, #091e4229)"},
        5px -2px ${$381c281f5cbbb40a$var$shadowWidth}px ${"var(--ds-shadow-overflow-perimeter, #091e421f)"}`,
        clipPath: 'inset(0px -12px 0px 0)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.offsetLeftPaddingByWidth ? `${$381c281f5cbbb40a$var$shadowWidth}px` : ''
    })); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $381c281f5cbbb40a$var$BoardBorderRightStyleControl = /*#__PURE__*/ (0, $47bDC.default)($381c281f5cbbb40a$var$BoardBorderStyleControl).withConfig({
    componentId: "sc-18q9p5w-2"
})`box-shadow:0 ${(0, $645AZ.layout).boardBorderWidth * 2}px 0 ${"var(--ds-shadow-overflow-spread, #091e4229)"},-5px -2px ${$381c281f5cbbb40a$var$shadowWidth}px ${"var(--ds-shadow-overflow-perimeter, #091e421f)"};clip-path:inset(0px 0px 0px -12px);${(props)=>props.offsetRightPaddingByWidth ? `width: ${$381c281f5cbbb40a$var$shadowWidth}px; margin-left: ${-$381c281f5cbbb40a$var$shadowWidth}px; right: ${-$381c281f5cbbb40a$var$shadowWidth}px;` : 'right: 0;'};`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $381c281f5cbbb40a$var$BoardBorderStyleExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisualRefresh: isVisualRefresh, isShadowVisible: isShadowVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_x2xsiy": (0, $lD23V.default)(!(0, $ilwFs.isStickySupported) ? 'none' : '')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0ctqga _11q7vuon _kqsw1if8 _v5641p41 _1pby1yp1",
            __cmplp.isVisualRefresh ? "_1bsb1ejb" : "_1bsb1ylp",
            __cmplp.isShadowVisible ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.isShadowVisible ? "_lcxv1wug" : "_lcxvglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $381c281f5cbbb40a$var$BoardBorderLeftStyleExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $381c281f5cbbb40a$var$BoardBorderStyleExperiment, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ltvidpf _16qs10uo _mkrzvwc9",
            __cmplp.isVisualRefresh ? "_18u010v4" : "_18u010j7",
            __cmplp.offsetLeftPaddingByWidth && "_1bsb1v6z",
            __cmplp.className
        ])
    });
});
const $381c281f5cbbb40a$var$BoardBorderLeftStyle = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $381c281f5cbbb40a$var$BoardBorderLeftStyleExperiment, $381c281f5cbbb40a$var$BoardBorderLeftStyleControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $381c281f5cbbb40a$var$BoardBorderRightStyleExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $381c281f5cbbb40a$var$BoardBorderStyleExperiment, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16qs1ist _mkrz1998",
            __cmplp.offsetRightPaddingByWidth ? "_1bsb1v6z _18u016fl _1xi216fl" : "_1xi2idpf",
            __cmplp.className
        ])
    });
});
const $381c281f5cbbb40a$var$BoardBorderRightStyle = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $381c281f5cbbb40a$var$BoardBorderRightStyleExperiment, $381c281f5cbbb40a$var$BoardBorderRightStyleControl);

});
parcelRegister("ilwFs", function(module, exports) {

$parcel$export(module.exports, "isStickySupported", () => $8de077a9f4c8dc48$export$f0b84f0bbcabd5ca);
/**
 * Browsers allowed to run sticky position are:
 * Firefox (any version)
 * Chrome > 58
 * Any other which supports non prefixed version of sticky
 */ let $8de077a9f4c8dc48$var$isSupported = false;
const $8de077a9f4c8dc48$var$isCSSStickySupported = ()=>typeof window !== 'undefined' && window.CSS && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.CSS.supports && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.CSS.supports('position', 'sticky');
const $8de077a9f4c8dc48$var$chromeInfo = typeof navigator !== 'undefined' ? navigator.userAgent.match(/Chrome\/(\d+)/) : null;
if ($8de077a9f4c8dc48$var$chromeInfo) // Chrome <= 58 has buggy sticky support
{
    if (Array.isArray($8de077a9f4c8dc48$var$chromeInfo) && $8de077a9f4c8dc48$var$chromeInfo.length === 2) {
        const chromeVersion = Number($8de077a9f4c8dc48$var$chromeInfo[1]);
        const isBrowserBuggy = chromeVersion < 59;
        $8de077a9f4c8dc48$var$isSupported = !isBrowserBuggy && $8de077a9f4c8dc48$var$isCSSStickySupported();
    }
} else $8de077a9f4c8dc48$var$isSupported = $8de077a9f4c8dc48$var$isCSSStickySupported();
const $8de077a9f4c8dc48$export$f0b84f0bbcabd5ca = $8de077a9f4c8dc48$var$isSupported;

});

parcelRegister("euZim", function(module, exports) {

$parcel$export(module.exports, "useBoardScroll", () => $dbab512fdb684fa5$export$e8a9c7f59d1400dd);
$parcel$export(module.exports, "useBoardScrollLeft", () => $dbab512fdb684fa5$export$42c9508d539e562f);
$parcel$export(module.exports, "useBoardHasScrollLeft", () => $dbab512fdb684fa5$export$e9583811d4961272);
$parcel$export(module.exports, "useBoardScrollTop", () => $dbab512fdb684fa5$export$a4a2ab28f4bdd36b);
$parcel$export(module.exports, "useBoardHasScrollTop", () => $dbab512fdb684fa5$export$20ef285042532517);
$parcel$export(module.exports, "useBoardScrollIsAtRightEdge", () => $dbab512fdb684fa5$export$cac9ff2d8629bfb2);
$parcel$export(module.exports, "useBoardScrollApi", () => $dbab512fdb684fa5$export$be9b8d6afde7d0af);

var $7JoAD = parcelRequire("7JoAD");
const $dbab512fdb684fa5$var$actions = {
    getBoardScroll: ()=>({ getState: getState })=>{
            const { onHorizontalScroll: onHorizontalScroll, ...state } = getState();
            return state;
        },
    onBoardScroll: (boardScrollPosition)=>({ setState: setState })=>{
            setState(boardScrollPosition);
        },
    onBoardScrollInit: (boardScrollPosition, onHorizontalScroll)=>({ setState: setState })=>{
            setState({
                ...boardScrollPosition,
                onHorizontalScroll: onHorizontalScroll
            });
        },
    onHorizontalScroll: (scrollLeft)=>({ getState: getState })=>{
            const { onHorizontalScroll: onHorizontalScroll } = getState();
            onHorizontalScroll(scrollLeft);
        }
};
const $dbab512fdb684fa5$var$boardScrollStore = (0, $7JoAD.createStore)({
    name: 'board-scroll',
    initialState: {
        scrollLeft: 0,
        scrollTop: 0,
        scrollWidth: 0,
        clientWidth: 0,
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onHorizontalScroll: ()=>{}
    },
    actions: $dbab512fdb684fa5$var$actions
});
const $dbab512fdb684fa5$export$e8a9c7f59d1400dd = (0, $7JoAD.createHook)($dbab512fdb684fa5$var$boardScrollStore);
const $dbab512fdb684fa5$export$42c9508d539e562f = (0, $7JoAD.createHook)($dbab512fdb684fa5$var$boardScrollStore, {
    selector: ({ scrollLeft: scrollLeft })=>scrollLeft
});
const $dbab512fdb684fa5$export$e9583811d4961272 = (0, $7JoAD.createHook)($dbab512fdb684fa5$var$boardScrollStore, {
    selector: ({ scrollLeft: scrollLeft })=>!!scrollLeft
});
const $dbab512fdb684fa5$export$a4a2ab28f4bdd36b = (0, $7JoAD.createHook)($dbab512fdb684fa5$var$boardScrollStore, {
    selector: ({ scrollTop: scrollTop })=>scrollTop
});
const $dbab512fdb684fa5$export$20ef285042532517 = (0, $7JoAD.createHook)($dbab512fdb684fa5$var$boardScrollStore, {
    selector: ({ scrollTop: scrollTop })=>!!scrollTop
});
const $dbab512fdb684fa5$export$cac9ff2d8629bfb2 = (0, $7JoAD.createHook)($dbab512fdb684fa5$var$boardScrollStore, {
    selector: ({ clientWidth: clientWidth, scrollLeft: scrollLeft, scrollWidth: scrollWidth })=>scrollLeft === scrollWidth - clientWidth
});
const $dbab512fdb684fa5$export$be9b8d6afde7d0af = (0, $7JoAD.createHook)($dbab512fdb684fa5$var$boardScrollStore, {
    selector: null
});

});


parcelRegister("haPqS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c4966d4198ff79c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $3HwlS = parcelRequire("3HwlS");

var $b8gJu = parcelRequire("b8gJu");

var $645AZ = parcelRequire("645AZ");

var $euZim = parcelRequire("euZim");
class $7c4966d4198ff79c$export$142e061c8a488301 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        // scrollElementHeight is used to calculate the height of transition zone
        // set to minCardHeight by default
        this.state = {
            scrollElementHeight: (0, $645AZ.minCardHeight),
            scrollElementWidth: 0
        };
        this.scrollElementDimensionFrameId = null;
        this.scrollElementResizeCallback = ()=>{
            this.handleScrollEvent();
            this.setScrollElementDimension();
        };
        this.setScrollElementDimension = ()=>{
            if (!this.props.flexibleColumns) return;
            if (this.scrollElementDimensionFrameId != null) cancelAnimationFrame(this.scrollElementDimensionFrameId);
            this.scrollElementDimensionFrameId = requestAnimationFrame(()=>{
                const scrollElement = this.getScrollElement();
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(scrollElement) && (scrollElement.clientHeight !== this.state.scrollElementHeight || scrollElement.clientWidth !== this.state.scrollElementWidth)) {
                    if ((0, $3HwlS.getWillShowNav4)()) // When using Nav4 we need to subtract 32 from the height to prevent the scroll element height from
                    // infinitely growing, see https://jplat.atlassian.net/browse/BLU-3447
                    this.setState({
                        scrollElementHeight: scrollElement.clientHeight - 32,
                        scrollElementWidth: scrollElement.clientWidth
                    });
                    else this.setState({
                        scrollElementHeight: scrollElement.clientHeight,
                        scrollElementWidth: scrollElement.clientWidth
                    });
                }
            });
        };
        this.resizeObserver = null;
        this.getScrollElement = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, @typescript-eslint/no-non-null-assertion
            (!false ? this.scrollElRef.current : this.scrollEl) ?? window.document.body;
        this.onHorizontalScroll = (scrollLeft)=>{
            requestAnimationFrame(()=>{
                if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(this.getScrollElement())) return;
                this.getScrollElement().scrollLeft = scrollLeft;
            });
        };
        this.setScrollEl = (scrollEl)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(scrollEl)) return;
            if (!false) this.scrollElRef.current = scrollEl;
            else this.scrollEl = scrollEl;
            // Only notify any other listeners if we have any
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(this.props.innerRef)) return;
            const { innerRef: innerRef } = this.props;
            if (typeof innerRef === 'function') innerRef(this.getScrollElement()); // ref={ref => someRef = ref}
            else // WindowRef passed from BoardContainer -> Board -> This
            innerRef.current = this.getScrollElement();
        };
        this.getBoardScrollPosition = ()=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(this.getScrollElement())) return {
                scrollTop: 0,
                scrollLeft: 0,
                scrollWidth: 0,
                clientWidth: 0
            };
            const { scrollLeft: scrollLeft, scrollTop: scrollTop, scrollWidth: scrollWidth, clientWidth: clientWidth } = this.getScrollElement();
            return {
                scrollTop: scrollTop,
                scrollLeft: scrollLeft,
                scrollWidth: scrollWidth,
                clientWidth: clientWidth
            };
        };
        this.getLegacyBoardScrollInfo = ()=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(this.getScrollElement())) return {
                scrollTop: 0,
                scrollLeft: 0,
                scrollWidth: 0,
                clientWidth: 0,
                leftEdge: true,
                topEdge: true,
                rightEdge: false
            };
            const { scrollLeft: scrollLeft, scrollTop: scrollTop, scrollWidth: scrollWidth, clientWidth: clientWidth } = this.getScrollElement();
            return {
                scrollTop: scrollTop,
                scrollLeft: scrollLeft,
                scrollWidth: scrollWidth,
                clientWidth: clientWidth,
                leftEdge: scrollLeft === 0,
                topEdge: scrollTop === 0,
                rightEdge: scrollLeft === scrollWidth - clientWidth
            };
        };
        this.handleScrollEvent = ()=>{
            if (this.scrollMeasureFrameId != null) cancelAnimationFrame(this.scrollMeasureFrameId);
            this.scrollMeasureFrameId = requestAnimationFrame(()=>{
                this.props.onBoardScroll(this.getBoardScrollPosition());
                this.props.onScroll(this.getLegacyBoardScrollInfo());
            });
        };
        this.scrollMeasureFrameId = null;
        this.scrollEl = null;
        this.scrollElRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
    }
    componentDidMount() {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(this.getScrollElement())) this.getScrollElement().addEventListener('scroll', this.handleScrollEvent);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener((0, $b8gJu.UPDATE_BOARD_SCROLL_POSITION), this.handleScrollEvent);
        if (this.scrollElRef.current && typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(this.scrollElementResizeCallback);
            this.resizeObserver.observe(this.scrollElRef.current);
        }
        this.props.onBoardScrollInit(this.getBoardScrollPosition(), this.onHorizontalScroll);
        this.props.onInit({
            hasHorizontalScrollbar: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(this.getScrollElement()) && this.getScrollElement().scrollWidth > this.getScrollElement().clientWidth
        });
    }
    componentWillUnmount() {
        if (this.scrollMeasureFrameId != null) cancelAnimationFrame(this.scrollMeasureFrameId);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(this.getScrollElement())) this.getScrollElement().removeEventListener('scroll', this.handleScrollEvent);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener((0, $b8gJu.UPDATE_BOARD_SCROLL_POSITION), this.handleScrollEvent);
        this.resizeObserver?.disconnect();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c4966d4198ff79c$var$StyledBoard, {
            ref: this.setScrollEl,
            "data-testid": "platform-board-kit.ui.board.scroll.board-scroll",
            // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {
                '--board-scroll-element-height': this.state.scrollElementHeight,
                '--board-scroll-element-width': this.state.scrollElementWidth
            }
        }, this.props.children));
    }
}
const $7c4966d4198ff79c$var$BoardScrollMain = (props)=>{
    const [, { onBoardScroll: onBoardScroll, onBoardScrollInit: onBoardScrollInit }] = (0, $euZim.useBoardScrollApi)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c4966d4198ff79c$export$142e061c8a488301, {
        ...props,
        onBoardScrollInit: onBoardScrollInit,
        onBoardScroll: onBoardScroll
    });
};
var $7c4966d4198ff79c$export$2e2bcd8739ae039 = $7c4966d4198ff79c$var$BoardScrollMain;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c4966d4198ff79c$var$StyledBoard = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _c71l1osq _4t3i1osq _1reo1wug _18m91wug _16jlkb7n _1o9zkb7n _i0dlf1ug _kqswh2mm _m6k4brmi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("b8gJu", function(module, exports) {

$parcel$export(module.exports, "LOZENGE_APPEARANCE", () => $5730f4b91f5d7ebc$export$7e4a71985d57222c);
$parcel$export(module.exports, "CARD_CONTAINER_SELECTOR_NAME", () => $5730f4b91f5d7ebc$export$7608524551986a84);
$parcel$export(module.exports, "CARD_CONTAINER_SELECTOR", () => $5730f4b91f5d7ebc$export$fb374ae0d58ab29b);
$parcel$export(module.exports, "COLUMN_TITLE_SELECTOR_NAME", () => $5730f4b91f5d7ebc$export$c2a2d9d97661439b);
$parcel$export(module.exports, "COLUMN_TITLE_LOZENGES_SELECTOR_NAME", () => $5730f4b91f5d7ebc$export$675d25966b2d2499);
$parcel$export(module.exports, "COLUMN_WRAPPER_FORM_SELECTOR_NAME", () => $5730f4b91f5d7ebc$export$6c814df87e7543d5);
$parcel$export(module.exports, "DRAGGABLE_COLUMN_SELECTOR_NAME", () => $5730f4b91f5d7ebc$export$4167d13afb6ba84b);
$parcel$export(module.exports, "DRAGGABLE_COLUMN_SELECTOR", () => $5730f4b91f5d7ebc$export$9d54b3872a1af680);
$parcel$export(module.exports, "UPDATE_BOARD_SCROLL_POSITION", () => $5730f4b91f5d7ebc$export$d339f9637e1ca3b4);
$parcel$export(module.exports, "DATA_ANNOUNCED_IGNORE_DND_TYPE", () => $5730f4b91f5d7ebc$export$e1beb09058b7dca1);
$parcel$export(module.exports, "DATA_ANNOUNCED_COLUMN_HEADER", () => $5730f4b91f5d7ebc$export$eb11bcee172fa7de);
$parcel$export(module.exports, "DATA_ANNOUNCED_CARD_HEADER", () => $5730f4b91f5d7ebc$export$f06ed7eae652ab20);
$parcel$export(module.exports, "BoardView", () => $5730f4b91f5d7ebc$export$373e09b633948dc);

const $5730f4b91f5d7ebc$export$7e4a71985d57222c = {
    default: 'default',
    inprogress: 'inprogress',
    moved: 'moved',
    new: 'default',
    removed: 'removed',
    success: 'success'
};
const $5730f4b91f5d7ebc$export$7608524551986a84 = 'platform-board-kit.ui.card-container';
const $5730f4b91f5d7ebc$export$fb374ae0d58ab29b = `[data-component-selector="${$5730f4b91f5d7ebc$export$7608524551986a84}"]`;
const $5730f4b91f5d7ebc$export$c2a2d9d97661439b = 'platform-board-kit.ui.column-title';
const $5730f4b91f5d7ebc$export$bb13afdd2dbe0316 = `[data-component-selector="${$5730f4b91f5d7ebc$export$c2a2d9d97661439b}"]`;
const $5730f4b91f5d7ebc$export$675d25966b2d2499 = 'platform-board-kit.ui.column-title.lozenges';
const $5730f4b91f5d7ebc$export$1be96bcf0abb2b8e = `[data-component-selector="${$5730f4b91f5d7ebc$export$675d25966b2d2499}"]`;
const $5730f4b91f5d7ebc$export$6c814df87e7543d5 = 'platform-board-kit.ui.column.column-create.form.column-wrapper';
const $5730f4b91f5d7ebc$export$4167d13afb6ba84b = 'platform-board-kit.ui.column.draggable-column';
const $5730f4b91f5d7ebc$export$9d54b3872a1af680 = `[data-component-selector="${$5730f4b91f5d7ebc$export$4167d13afb6ba84b}"]`;
const $5730f4b91f5d7ebc$export$d339f9637e1ca3b4 = 'update-board-scroll-position';
const $5730f4b91f5d7ebc$export$e1beb09058b7dca1 = 'data-announced-ignore-dnd-type';
const $5730f4b91f5d7ebc$export$eb11bcee172fa7de = 'data-announced-column-header';
const $5730f4b91f5d7ebc$export$f06ed7eae652ab20 = 'data-announced-card-header';
const $5730f4b91f5d7ebc$export$373e09b633948dc = {
    JSW_BOARD: 'jsw-board',
    INCREMENT_PLANNING_BOARD: 'increment-planning-board',
    JSM_BOARD: 'jsm-board'
};

});




parcelRegister("gHXMJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0c05f281d0d42b3$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $doOdQ = parcelRequire("doOdQ");

var $absT5 = parcelRequire("absT5");

var $gDIL3 = parcelRequire("gDIL3");
var $f0c05f281d0d42b3$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state)=>({
        isOpen: (0, $absT5.isDialogVisibleSelector)(state)
    }), {
    onCancel: (0, $doOdQ.backlogIssueMoveCancel),
    onConfirm: (0, $doOdQ.backlogIssueMoveConfirm)
})((0, $gDIL3.default));

});
parcelRegister("gDIL3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4835bb9ec70dd0b9$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ldJSL = parcelRequire("ldJSL");
var $fVnbM = parcelRequire("fVnbM");

var $1dJ6S = parcelRequire("1dJ6S");

var $ctg8C = parcelRequire("ctg8C");

var $6s1PB = parcelRequire("6s1PB");

var $az4zD = parcelRequire("az4zD");

var $3hUhs = parcelRequire("3hUhs");

var $j3NDp = parcelRequire("j3NDp");
class $4835bb9ec70dd0b9$export$3ef6f240d074403 extends (0, $5uXOq.Component) {
    renderContent() {
        const { intl: intl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4835bb9ec70dd0b9$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1dJ6S.default), {
            size: "xsmall",
            as: "h5"
        }, intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $j3NDp.default).titleIssueTermRefresh : (0, $j3NDp.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4835bb9ec70dd0b9$var$DescriptionStyle, null, intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $j3NDp.default).descriptionIssueTermRefresh : (0, $j3NDp.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            onClick: this.onConfirm,
            appearance: "primary"
        }, intl.formatMessage((0, $j3NDp.default).confirm)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            onClick: this.onCancel,
            appearance: "subtle"
        }, intl.formatMessage((0, $j3NDp.default).cancel))));
    }
    render() {
        return this.props.isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4835bb9ec70dd0b9$var$StickyPosition, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), {
            content: this.renderContent(),
            isOpen: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null))) : null;
    }
    constructor(...args){
        super(...args);
        // Strip arguments from event handlers
        this.onConfirm = ()=>this.props.onConfirm();
        this.onCancel = ()=>this.props.onCancel();
    }
}
var $4835bb9ec70dd0b9$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($4835bb9ec70dd0b9$export$3ef6f240d074403);
const $4835bb9ec70dd0b9$var$columnDialogZindex = (0, $3hUhs.sharedStyles).zIndex.stickyHeaders + 1; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4835bb9ec70dd0b9$var$StickyPosition = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1cl78iz": (0, $lD23V.default)((0, $3hUhs.sharedStyles).columnWithMarginWidth / 2, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _154ipxbi _1ltvlz7i _w4h21if8 _z2g7pxbi _7bfnqfx8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4835bb9ec70dd0b9$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5724jg8 _11c81oud _1bsb13s2",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4835bb9ec70dd0b9$var$DescriptionStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3hUhs", function(module, exports) {

$parcel$export(module.exports, "sharedStyles", () => $3c6d8d54a7e2976d$export$c95b305c73224681);

var $645AZ = parcelRequire("645AZ");






































const $3c6d8d54a7e2976d$export$c95b305c73224681 = {
    columnWithMarginWidth: $645AZ.columnWithMarginWidth,
    zIndex: $645AZ.zIndex,
    columnFixedWidth: $645AZ.columnFixedWidth,
    columnMinWidth: $645AZ.columnMinWidth,
    columnHeaderHeight: $645AZ.columnHeaderHeight
};

});

parcelRegister("j3NDp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9282217a70d57e3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e9282217a70d57e3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software.main.board-container.board.backlog-issue-move-dialog.title",
        "defaultMessage": "Move your issues?"
    },
    description: {
        "id": "software.main.board-container.board.backlog-issue-move-dialog.description",
        "defaultMessage": "We can move your first column's issues straight into your new backlog."
    },
    confirm: {
        "id": "software.main.board-container.board.backlog-issue-move-dialog.confirm",
        "defaultMessage": "Yes, move"
    },
    cancel: {
        "id": "software.main.board-container.board.backlog-issue-move-dialog.cancel",
        "defaultMessage": "No thanks"
    },
    titleIssueTermRefresh: {
        "id": "software.main.board-container.board.backlog-issue-move-dialog.title-issue-term-refresh",
        "defaultMessage": "Move your issues?"
    },
    descriptionIssueTermRefresh: {
        "id": "software.main.board-container.board.backlog-issue-move-dialog.description-issue-term-refresh",
        "defaultMessage": "We can move your first column's issues straight into your new backlog."
    }
});

});



parcelRegister("aYlA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0cf70f53c95fbad$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $eph8m = parcelRequire("eph8m");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $gKiL2 = parcelRequire("gKiL2");
const $b0cf70f53c95fbad$var$mapStateToProps = (state)=>({
        url: (0, $eph8m.getColumnStatusMappingUrl)((0, $67Z81.projectKeySelector)(state), (0, $67Z81.rapidViewIdSelector)(state), (0, $67Z81.getIsCMPBoard)(state)),
        isKanbanBoard: !(0, $ebHh7.isSprintsEnabled)(state),
        isCMPBoard: (0, $67Z81.getIsCMPBoard)(state)
    });
const $b0cf70f53c95fbad$var$ConnectedColumnConfiguration = (0, $bC2fB.connect)($b0cf70f53c95fbad$var$mapStateToProps, {})((0, $gKiL2.default));
var $b0cf70f53c95fbad$export$2e2bcd8739ae039 = $b0cf70f53c95fbad$var$ConnectedColumnConfiguration;

});
parcelRegister("gKiL2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d2b154f39b85b4f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $cE2Qr = parcelRequire("cE2Qr");

var $geikO = parcelRequire("geikO");

var $8zOmE = parcelRequire("8zOmE");

var $lvgJK = parcelRequire("lvgJK");

var $3t5QD = parcelRequire("3t5QD");

var $4Z21W = parcelRequire("4Z21W");

var $dIdda = parcelRequire("dIdda");
const $9d2b154f39b85b4f$var$ColumnConfiguration = ({ url: url, isKanbanBoard: isKanbanBoard, isCMPBoard: isCMPBoard })=>{
    const { push: push } = (0, $dIdda.useRouterActions)();
    const [isOnboardingDismissed] = (0, $cE2Qr.useIsDismissed)();
    const onClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clickColumnConfigurationButton');
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        isCMPBoard ? window.open(url, '_self') : push(url);
    }, [
        push,
        url,
        isCMPBoard
    ]);
    const AsyncNudgeComponent = isKanbanBoard ? (0, $4Z21W.BoardCreateColumnKanbanTourNudgeAsync) : (0, $lvgJK.BoardCreateColumnButtonWrapperNudgeAsync);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        conditionsToApplyWrapper: (0, $4R6GH.fg)('board_create_column_nudge_conditional_load') ? !isOnboardingDismissed : true,
        Wrapper: AsyncNudgeComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $geikO.default), {
        onClick: onClick
    }));
};
var $9d2b154f39b85b4f$export$2e2bcd8739ae039 = $9d2b154f39b85b4f$var$ColumnConfiguration;

});
parcelRegister("geikO", function(module, exports) {

$parcel$export(module.exports, "default", () => $04d788fd7adea69a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $epOG5 = parcelRequire("epOG5");

var $lzUP9 = parcelRequire("lzUP9");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dTEu0 = parcelRequire("dTEu0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$04d788fd7adea69a$export$2e2bcd8739ae039 = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04d788fd7adea69a$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04d788fd7adea69a$var$Sticky, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $dTEu0.default).description)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "platform-board-kit.ui.column.column-configuration.button",
        "aria-label": formatMessage((0, $dTEu0.default).description),
        iconBefore: (0, $4R6GH.fg)('tnk-1614-visual-refresh-boardkit-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($epOG5))), {
            label: formatMessage((0, $dTEu0.default).description),
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($lzUP9))),
            LEGACY_size: "medium",
            color: "var(--ds-icon, #44546F)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lzUP9))), {
            label: formatMessage((0, $dTEu0.default).description),
            size: "medium"
        }),
        onClick: onClick
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04d788fd7adea69a$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1yt4yg4n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04d788fd7adea69a$var$Sticky = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _154iidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dTEu0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cc65c54df09db11$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0cc65c54df09db11$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    description: {
        "id": "platform-board-kit.column.column-configuration.description",
        "defaultMessage": "Configure board"
    }
});

});


parcelRegister("lvgJK", function(module, exports) {

$parcel$export(module.exports, "BoardCreateColumnButtonWrapperNudgeAsync", () => $600f4743e2a0ebd8$export$bf4765843368c29);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $600f4743e2a0ebd8$var$BoardCreateColumnButtonLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("kPbzI")).then((exportedModule)=>exportedModule.BoardCreateColumnButtonWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/board-create-column/index.tsx"
});
const $600f4743e2a0ebd8$export$bf4765843368c29 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $6784cbc7d62e5d7c$export$a8d62e500b59f31e),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$a8d62e500b59f31e)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-board-create-column-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($600f4743e2a0ebd8$var$BoardCreateColumnButtonLazy, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$a8d62e500b59f31e)
    }, children)));

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$eaf6b96a17b6476c = 'can-enroll-in-select-initial-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';

parcelRegister("kPbzI", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("7M38A").then(()=>parcelRequire('fw919'));

});


parcelRegister("3t5QD", function(module, exports) {

$parcel$export(module.exports, "ConditionalNudgeWrapper", () => $44a5067dcee1bfd9$export$56d544c4f479b7fb);

var $5uXOq = parcelRequire("5uXOq");
const $44a5067dcee1bfd9$export$56d544c4f479b7fb = ({ children: children, Wrapper: Wrapper, conditionsToApplyWrapper: conditionsToApplyWrapper, ...restProps })=>{
    if (conditionsToApplyWrapper && !false && children !== null && children !== false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, restProps, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};

});

parcelRegister("4Z21W", function(module, exports) {

$parcel$export(module.exports, "BoardCreateColumnKanbanTourNudgeAsync", () => $bf8f0652ab055ff6$export$f360ae4e917d43c0);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $bf8f0652ab055ff6$var$BoardCreateColumnNudgeLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("jzYPS")).then((exportedModule)=>exportedModule.BoardCreateColumnNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/kanban-onboarding-tour/board-create-column/index.tsx"
});
const $bf8f0652ab055ff6$export$f360ae4e917d43c0 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$f2fe211acb4aa81a),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$3366ddefe77d5112)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-kanban-onboarding-board-create-column-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bf8f0652ab055ff6$var$BoardCreateColumnNudgeLazy, null, children)));
$bf8f0652ab055ff6$export$f360ae4e917d43c0.displayName = 'BoardCreateColumnKanbanTourNudgeAsync';

});
const $dbbf68c32d8c4308$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';

parcelRegister("jzYPS", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("b1bZb").then(()=>parcelRequire('8iGYP'));

});




parcelRegister("luiFO", function(module, exports) {

$parcel$export(module.exports, "default", () => $85d8c1dd25ccb1d7$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $2NMNM = parcelRequire("2NMNM");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $39xOx = parcelRequire("39xOx");

var $4R6GH = parcelRequire("4R6GH");

var $fQlee = parcelRequire("fQlee");

var $cE2Qr = parcelRequire("cE2Qr");

var $ggqQe = parcelRequire("ggqQe");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");

var $dAfqg = parcelRequire("dAfqg");

var $bC2fB = parcelRequire("bC2fB");

var $9USr3 = parcelRequire("9USr3");

var $lvgJK = parcelRequire("lvgJK");

var $3t5QD = parcelRequire("3t5QD");

var $4Z21W = parcelRequire("4Z21W");


var $8fEhS = parcelRequire("8fEhS");

var $1PFZfW = parcelRequire("1PFZfW");

var $67sX6 = parcelRequire("67sX6");

var $glGhK = parcelRequire("glGhK");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $5mTgl = parcelRequire("5mTgl");
const $85d8c1dd25ccb1d7$var$connector = (0, $bC2fB.connect)((state)=>({
        // analytics
        externalId: 'software.board.column.add.title',
        onEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onEditCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        validate: (0, $fyeGd.makeValidateColumnSelector)(state),
        isDisabled: (0, $5mTgl.isAnyColumnUpdating)(state),
        isKanbanBoard: !(0, $ebHh7.isSprintsEnabled)(state)
    }), (dispatch, ownProps)=>({
        onSubmit: (temporaryColumnId, name, analyticsEvent)=>{
            const action = (0, $glGhK.columnCreateRequest)(temporaryColumnId, name, analyticsEvent, ownProps.isCMPBoard);
            dispatch(action);
        },
        onEditStart: (analyticsEvent)=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent),
        onEditCancel: (columnId, type, analyticsEvent)=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
                type: type,
                columnId: columnId
            })
    }));
const $85d8c1dd25ccb1d7$var$WorkflowNudge = ({ children: children })=>{
    const { ref: columnsNudgeRef } = (0, $9USr3.useRegisterNudgeTarget)((0, $f2c7d758dbca5ecb$export$97c38a17d2d4b39), true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "get-started-workflow-nudge",
        teamName: "Jlove-makkuro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ref: columnsNudgeRef,
        xcss: $85d8c1dd25ccb1d7$var$nudgeStyles
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PFZfW.WorkflowNudgeAsync), null));
};
const $85d8c1dd25ccb1d7$export$efb2b0a453ca73f6 = (WrappedComponent)=>(ownProps)=>{
        const [isOnboardingDismissed] = (0, $cE2Qr.useIsDismissed)();
        const { data: data } = (0, $dAfqg.useProjectContext)();
        const isEligibleForOneScreenOnboarding = (0, $fQlee.useIsOneScreenOnboardingEnabled)();
        const [{ nudgeId: nudgeId }] = (0, $8fEhS.useOnboardingGetStartedSingleNudge)();
        if (isEligibleForOneScreenOnboarding && ownProps.isKanbanBoard && data?.simplified && isOnboardingDismissed && nudgeId === (0, $f2c7d758dbca5ecb$export$97c38a17d2d4b39)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85d8c1dd25ccb1d7$var$WorkflowNudge, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, ownProps));
        const AsyncNudgeComponent = ownProps.isKanbanBoard ? (0, $4Z21W.BoardCreateColumnKanbanTourNudgeAsync) : (0, $lvgJK.BoardCreateColumnButtonWrapperNudgeAsync);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            conditionsToApplyWrapper: (0, $4R6GH.fg)('board_create_column_nudge_conditional_load') ? !isOnboardingDismissed : true,
            Wrapper: AsyncNudgeComponent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            grow: "hug"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, ownProps)));
    };
const $85d8c1dd25ccb1d7$var$ColumnCreate = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))($85d8c1dd25ccb1d7$export$efb2b0a453ca73f6, (0, $2OMDV.AnalyticsEventToProps)('columnCreate', {
    onEditStart: 'editStarted',
    onEditCancel: 'editCanceled'
}), $85d8c1dd25ccb1d7$var$connector)((0, $ggqQe.default));
const $85d8c1dd25ccb1d7$var$ColumnCreateWrapper = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isCMPBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsCMPBoard));
    (0, $5uXOq.useEffect)(()=>{
        if (isCMPBoard) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'columnCreateButton mounted');
        }
    }, [
        isCMPBoard,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85d8c1dd25ccb1d7$var$ColumnCreate, {
        isCMPBoard: isCMPBoard
    });
};
var $85d8c1dd25ccb1d7$export$2e2bcd8739ae039 = $85d8c1dd25ccb1d7$var$ColumnCreateWrapper;
const $85d8c1dd25ccb1d7$var$nudgeStyles = (0, $8CUq3.xcss)({
    alignSelf: 'start'
});

});
parcelRegister("fQlee", function(module, exports) {

$parcel$export(module.exports, "useIsOneScreenOnboardingEnabled", () => $c352b1947f2c10ed$export$47be9e1accfd2eb3);
$parcel$export(module.exports, "useIsOneScreenOnboardingEnabledWithFeaturesCheck", () => $c352b1947f2c10ed$export$708f8a122c2699bb);

var $6s1PB = parcelRequire("6s1PB");

var $43qGj = parcelRequire("43qGj");

var $dAfqg = parcelRequire("dAfqg");

var $itmJb = parcelRequire("itmJb");
const $c352b1947f2c10ed$export$47be9e1accfd2eb3 = ()=>{
    const isJiraAdmin = (0, $itmJb.useIsAdmin)();
    const projectContext = (0, $dAfqg.useProjectContext)();
    const isProjectAdmin = projectContext?.data?.isProjectAdmin;
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_one_screen_onboarding');
    const isVariation = expConfig.get('isEnabled', false);
    return (isJiraAdmin || isProjectAdmin) && isVariation;
};
const $c352b1947f2c10ed$export$708f8a122c2699bb = ()=>{
    const { data: features } = (0, $43qGj.useFeatures)();
    const isOneScreenOnboardingEnabled = $c352b1947f2c10ed$export$47be9e1accfd2eb3();
    return features?.hasGetStarted && isOneScreenOnboardingEnabled;
};

});
parcelRegister("43qGj", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $64d4caaed133b77d$export$4a39035bacc4ed76);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $4bPSV = parcelRequire("4bPSV");

var $hDSPU = parcelRequire("hDSPU");

var $iHqA4 = parcelRequire("iHqA4");

var $j8sa8 = parcelRequire("j8sa8");
const $64d4caaed133b77d$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const isEligibleForFeatureToggle = (0, $j8sa8.useShouldApplyFeatureToggle)();
    const [sidebarFeatureToggled] = (0, $hDSPU.useSidebarFeatureToggled)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $4bPSV.extractData)(data), [
        data
    ]);
    // merged feature status before navigation resource gets refreshed
    // if and only if there are features toggled and they are eligible for the feature
    const features = (0, $5uXOq.useMemo)(()=>{
        if (!extractedData || !isEligibleForFeatureToggle || !sidebarFeatureToggled) return extractedData;
        return {
            ...extractedData,
            ...sidebarFeatureToggled
        };
    }, [
        extractedData,
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    (0, $iHqA4.useClearSidebarToggled)();
    return {
        data: features,
        loading: loading,
        error: error
    };
};

});
parcelRegister("4bPSV", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $4795c1c4367ea315$export$9df5fa0a366163d2);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");
const $4795c1c4367ea315$export$9df5fa0a366163d2 = (navData)=>{
    const { permissionInfo: permissionInfo, hasBacklog: hasBacklog, hasBoard: hasBoard, hasCode: hasCode, hasGoals: hasGoals, hasGetStarted: hasGetStarted, hasSecurity: hasSecurity, hasDeployments: hasDeployments, hasList: hasList, hasOpsgenieSchedule: hasOpsgenieSchedule, hasPages: hasPages, hasReleases: hasReleases, hasRoadmap: hasRoadmap, hasReports: hasReports, hasRequests: hasRequests, hasIssues: hasIssues, hasSprint: hasSprint, hasIncidents: hasIncidents, hasCalendar: hasCalendar, hasForms: hasForms, hasSummaryPage: hasSummaryPage, aiInfo: aiInfo } = navData;
    const isProjectOrJiraAdmin = permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    return {
        hasBacklog: hasBacklog,
        hasBoard: hasBoard,
        hasRoadmap: hasRoadmap,
        hasCode: hasCode,
        hasGoals: hasGoals,
        hasGetStarted: isProjectOrJiraAdmin && hasGetStarted,
        hasSecurity: hasSecurity,
        hasDeployments: hasDeployments,
        hasList: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation') ? hasList : false,
        hasReleases: hasReleases,
        hasSIN: hasIssues,
        hasReports: hasReports,
        hasRequests: hasRequests,
        hasPages: hasPages,
        hasOpsgenie: hasOpsgenieSchedule,
        hasShortcutsAdd: isProjectOrJiraAdmin,
        hasSettings: isProjectOrJiraAdmin,
        hasSprint: hasSprint,
        hasIncidents: hasIncidents,
        hasCalendar: hasCalendar,
        hasForms: (0, $6s1PB.expValEquals)('forms_for_jsw_experiment', 'isEnabled', true) && hasForms,
        hasSummaryPage: (0, $4R6GH.fg)('enable_jsw_summary_page') && hasSummaryPage,
        hasAIInNIN: hasIssues && aiInfo?.isEnabledInIssueNavigator === true
    };
};

});

parcelRegister("hDSPU", function(module, exports) {

$parcel$export(module.exports, "useFeature", () => $605ea180d8f833cc$export$fc97652867e5867e);
$parcel$export(module.exports, "useEnablingFeature", () => $605ea180d8f833cc$export$207b461610a7fca6);
$parcel$export(module.exports, "useSidebarFeatureToggled", () => $605ea180d8f833cc$export$9eef668f94562feb);

var $7JoAD = parcelRequire("7JoAD");

var $6wyfe = parcelRequire("6wyfe");
const $605ea180d8f833cc$var$initialState = {
    features: [],
    isLoading: false,
    enablingFeatures: [],
    isFetchError: false,
    sidebarFeatureToggled: null
};
const $605ea180d8f833cc$var$store = (0, $7JoAD.createStore)({
    name: 'feature-toggle',
    initialState: $605ea180d8f833cc$var$initialState,
    actions: $6wyfe.actions
});
const $605ea180d8f833cc$export$fc97652867e5867e = (0, $7JoAD.createHook)($605ea180d8f833cc$var$store);
const $605ea180d8f833cc$export$207b461610a7fca6 = (0, $7JoAD.createHook)($605ea180d8f833cc$var$store, {
    selector: (state, { feature: feature })=>state.enablingFeatures.some((f)=>f === feature)
});
const $605ea180d8f833cc$export$e7699ed698eeb9ec = (0, $7JoAD.createHook)($605ea180d8f833cc$var$store, {
    selector: (state, { feature: feature })=>state.features.find((f)=>f.feature === feature)?.state
});
const $605ea180d8f833cc$export$9eef668f94562feb = (0, $7JoAD.createHook)($605ea180d8f833cc$var$store, {
    selector: (state)=>state.sidebarFeatureToggled
});

});
parcelRegister("6wyfe", function(module, exports) {

$parcel$export(module.exports, "actions", () => $158a47dbcbb0832b$export$e324594224ef24da);

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $8zOmE = parcelRequire("8zOmE");

var $3Jf4N = parcelRequire("3Jf4N");

var $czzsL = parcelRequire("czzsL");

var $iZZTd = parcelRequire("iZZTd");

var $ke207 = parcelRequire("ke207");
const $158a47dbcbb0832b$var$clearSiderbarFeatureToggled = ()=>({ setState: setState })=>{
        setState({
            sidebarFeatureToggled: null
        });
    };
const $158a47dbcbb0832b$var$fetchFeatures = (boardId)=>async ({ getState: getState, setState: setState })=>{
        const { features: features, isLoading: isLoading } = getState();
        if (isLoading) return;
        setState({
            isFetchError: false
        });
        try {
            if (features.length === 0) {
                setState({
                    isLoading: true
                });
                const data = await (0, $iZZTd.getBoardFeatures)(boardId);
                const filteredFeatures = (0, $czzsL.filterAndSort)(data);
                (0, $czzsL.fireErrorAnalyticsOnUnmatchFeatureKey)(filteredFeatures);
                setState({
                    isLoading: false,
                    features: filteredFeatures
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isFetchError: true,
                isLoading: false
            });
            (0, $jcw0u.default)({
                meta: {
                    ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                    id: 'fetchFeatures'
                },
                error: error
            });
        }
    };
const $158a47dbcbb0832b$var$syncFeatures = (sidebarFeatureStatus)=>({ getState: getState, setState: setState })=>{
        const { features: features } = getState();
        const featureMap = (0, $3Jf4N.getFeatureMap)({
            isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
        });
        const synced = features.map((f)=>{
            const id = f.feature;
            if (featureMap[id]) {
                const { statusKey: statusKey } = featureMap[id];
                return {
                    ...f,
                    state: sidebarFeatureStatus[statusKey] ? 'ENABLED' : 'DISABLED'
                };
            }
            return f;
        });
        setState({
            features: synced
        });
    };
const $158a47dbcbb0832b$var$updateFeature = ({ boardId: boardId, feature: feature, dependentFeature: dependentFeature, analyticsEvent: analyticsEvent, onError: onError, onAfterUpdate: onAfterUpdate })=>async ({ getState: getState, setState: setState })=>{
        const { features: features, enablingFeatures: enablingFeatures, sidebarFeatureToggled: sidebarFeatureToggled } = getState();
        let featureMap = (0, $3Jf4N.getFeatureMap)();
        if ((0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')) featureMap = {
            ...featureMap,
            ...(0, $3Jf4N.listFeature)
        };
        const currentStatus = features.find((f)=>f.feature === feature)?.state;
        const isEnabling = currentStatus === 'DISABLED';
        if (!boardId || feature.length === 0 || !currentStatus) return;
        try {
            // Optimistically update the toggle status before the API call finishes
            // and add feature to the enabling states
            setState({
                features: features.map((0, $czzsL.updateFeatureState)(feature, dependentFeature)),
                sidebarFeatureToggled: {
                    ...sidebarFeatureToggled ?? {},
                    [featureMap[feature].statusKey]: isEnabling,
                    ...dependentFeature && {
                        [featureMap[dependentFeature].statusKey]: isEnabling
                    }
                },
                ...isEnabling && {
                    enablingFeatures: [
                        ...enablingFeatures,
                        feature
                    ]
                }
            });
            await (0, $ke207.updateBoardFeature)({
                boardId: boardId,
                feature: feature,
                enabling: isEnabling
            });
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'featureStatus updated', {
                featureId: feature,
                newStatus: currentStatus
            });
            onAfterUpdate?.(feature, isEnabling);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onError?.();
            setState({
                features: features,
                sidebarFeatureToggled: sidebarFeatureToggled
            });
            (0, $jcw0u.default)({
                meta: {
                    ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                    id: 'updateFeature'
                },
                error: error
            });
        }
        if (isEnabling) setState({
            // feature has been enabled, remove from enabling state
            enablingFeatures: getState().enablingFeatures.filter((f)=>f !== feature)
        });
    };
const $158a47dbcbb0832b$export$e324594224ef24da = {
    fetchFeatures: $158a47dbcbb0832b$var$fetchFeatures,
    updateFeature: $158a47dbcbb0832b$var$updateFeature,
    syncFeatures: $158a47dbcbb0832b$var$syncFeatures,
    clearSiderbarFeatureToggled: $158a47dbcbb0832b$var$clearSiderbarFeatureToggled
};

});
parcelRegister("3Jf4N", function(module, exports) {

$parcel$export(module.exports, "commonErrorAnalyticsMeta", () => $d07f845012e39eac$export$47825241dc3c472c);
$parcel$export(module.exports, "MANAGE_FEATURE_MENU_ITEM_TEST_ID", () => $d07f845012e39eac$export$143e1d685830adbe);
$parcel$export(module.exports, "listFeature", () => $d07f845012e39eac$export$4ddfd7a9f5527982);
$parcel$export(module.exports, "getFeatureMap", () => $d07f845012e39eac$export$6ac50cf33852adb5);
$parcel$export(module.exports, "ERROR_FLAG_ID", () => $d07f845012e39eac$export$f5e4c120ac01b615);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8QpSo = parcelRequire("8QpSo");

var $adDD5 = parcelRequire("adDD5");

var $v8Zna = parcelRequire("v8Zna");

var $90gd1 = parcelRequire("90gd1");

var $8sgpE = parcelRequire("8sgpE");

var $eWXbg = parcelRequire("eWXbg");

var $i3vuN = parcelRequire("i3vuN");

var $65Ltd = parcelRequire("65Ltd");
const $d07f845012e39eac$export$47825241dc3c472c = {
    packageName: 'jiraTmpFeatureToggle',
    teamName: 'jlove-makkuro'
};
const $d07f845012e39eac$export$143e1d685830adbe = 'manage-feature-menu-item';
const $d07f845012e39eac$export$4ddfd7a9f5527982 = {
    'jsw.agility.list_view': {
        descriptionKey: 'listDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($90gd1))), {
            label: ""
        }),
        statusKey: 'hasList',
        order: 35,
        redirectOn: [
            (0, $65Ltd.ROUTE_NAMES_SOFTWARE_LIST)
        ]
    }
};
const $d07f845012e39eac$export$a712b1e96d47b856 = {
    'jsw.agility.simple-roadmap': {
        descriptionKey: 'timelineDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i3vuN))), {
            label: ""
        }),
        statusKey: 'hasRoadmap',
        order: 10,
        redirectOn: [
            (0, $65Ltd.ROUTE_NAMES_SOFTWARE_TIMELINE),
            (0, $65Ltd.ROUTE_NAMES_SOFTWARE_ROADMAP)
        ]
    },
    'jsw.agility.backlog': {
        descriptionKey: 'backlogDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($adDD5))), {
            label: ""
        }),
        statusKey: 'hasBacklog',
        order: 20,
        redirectOn: [
            (0, $65Ltd.ROUTE_NAMES_SOFTWARE_BACKLOG)
        ]
    },
    'jsw.agility.board': {
        descriptionKey: 'boardDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($v8Zna))), {
            label: ""
        }),
        statusKey: 'hasBoard',
        order: 30
    },
    'jsw.agility.issue_navigator': {
        descriptionKey: 'issueNavigatorDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8sgpE))), {
            label: ""
        }),
        statusKey: 'hasSIN',
        order: 40,
        redirectOn: [
            (0, $65Ltd.ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
            (0, $65Ltd.ROUTE_NAMES_ISSUE)
        ]
    },
    'jsw.agility.sprints': {
        descriptionKey: 'releasesDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        statusKey: 'hasSprint',
        order: 50,
        isHidden: true
    }
}; // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>
const $d07f845012e39eac$export$6ac50cf33852adb5 = (0, $8QpSo.default)(({ isSimplifyNavExperimentEnabled: isSimplifyNavExperimentEnabled, isListViewEnabled: isListViewEnabled } = {})=>({
        'jsw.agility.simple-roadmap': {
            descriptionKey: 'timelineDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i3vuN))), {
                label: ""
            }),
            statusKey: 'hasRoadmap',
            order: 10,
            redirectOn: [
                (0, $65Ltd.ROUTE_NAMES_SOFTWARE_TIMELINE),
                (0, $65Ltd.ROUTE_NAMES_SOFTWARE_ROADMAP)
            ]
        },
        'jsw.agility.backlog': {
            descriptionKey: 'backlogDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($adDD5))), {
                label: ""
            }),
            statusKey: 'hasBacklog',
            order: 20,
            redirectOn: [
                (0, $65Ltd.ROUTE_NAMES_SOFTWARE_BACKLOG)
            ]
        },
        'jsw.agility.board': {
            descriptionKey: 'boardDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($v8Zna))), {
                label: ""
            }),
            statusKey: 'hasBoard',
            order: 30
        },
        ...!isSimplifyNavExperimentEnabled && {
            'jsw.agility.issue_navigator': {
                descriptionKey: 'issueNavigatorDescription',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8sgpE))), {
                    label: ""
                }),
                statusKey: 'hasSIN',
                order: 40,
                redirectOn: [
                    (0, $65Ltd.ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
                    (0, $65Ltd.ROUTE_NAMES_ISSUE)
                ]
            }
        },
        'jsw.agility.sprints': {
            descriptionKey: 'releasesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
            statusKey: 'hasSprint',
            order: 50,
            isHidden: true
        },
        'jsw.agility.pages': {
            descriptionKey: 'projectPagesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eWXbg))), {
                label: ""
            }),
            statusKey: 'hasPages',
            order: 60,
            redirectOn: [
                (0, $65Ltd.ROUTE_NAMES_PROJECT_PAGES)
            ]
        },
        ...isListViewEnabled && $d07f845012e39eac$export$4ddfd7a9f5527982
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))); // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>;
const $d07f845012e39eac$export$f5e4c120ac01b615 = 'feature-toggle-error-flag';

});
parcelRegister("adDD5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7709dbddc6671c4c$var$_react = $7709dbddc6671c4c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7709dbddc6671c4c$var$_backlog = $7709dbddc6671c4c$var$_interopRequireDefault((parcelRequire("bRTCF")));
function $7709dbddc6671c4c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7709dbddc6671c4c$var$BacklogIcon = (props)=>/*#__PURE__*/ $7709dbddc6671c4c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.002C5 19 17 19 17 19v-2.002C17 17 5 17 5 17zm-2-2.004C3 15.894 3.895 15 4.994 15h12.012c1.101 0 1.994.898 1.994 1.998v2.004A1.997 1.997 0 0 1 17.006 21H4.994A2 2 0 0 1 3 19.002z"/><path d="M5 15h12v-2H5zm-2-4h16v6H3z"/><path d="M7 11.002C7 11 19 11 19 11V8.998C19 9 7 9 7 9zM5 8.998C5 7.894 5.895 7 6.994 7h12.012C20.107 7 21 7.898 21 8.998v2.004A1.997 1.997 0 0 1 19.006 13H6.994A2 2 0 0 1 5 11.002z"/><path d="M5 5v2h12V5zm-2-.002C3 3.894 3.895 3 4.994 3h12.012C18.107 3 19 3.898 19 4.998V9H3z"/></g></svg>`
    }, props, {
        newIcon: $7709dbddc6671c4c$var$_backlog.default
    }));
$7709dbddc6671c4c$var$BacklogIcon.displayName = 'BacklogIcon';
var $7709dbddc6671c4c$var$_default = module.exports.default = $7709dbddc6671c4c$var$BacklogIcon;

});
parcelRegister("bRTCF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9828cdad913f72731b88588e34b5df75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a3fca7537c506d3$var$_react = $8a3fca7537c506d3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8a3fca7537c506d3$var$_UNSAFE_baseNew = $8a3fca7537c506d3$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8a3fca7537c506d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a3fca7537c506d3$var$BacklogIcon = (props)=>/*#__PURE__*/ $8a3fca7537c506d3$var$_react.default.createElement($8a3fca7537c506d3$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 5.917V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v2.917m-12.5 0v4.166m0-4.166h12.5m-12.5 4.166V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-2.917m-12.5 0h12.5m0-4.166v4.166"/>`
    }, props));
$8a3fca7537c506d3$var$BacklogIcon.displayName = 'BacklogIcon';
var $8a3fca7537c506d3$var$_default = module.exports.default = $8a3fca7537c506d3$var$BacklogIcon;

});


parcelRegister("v8Zna", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05d9de5ec3a4369b$var$_react = $05d9de5ec3a4369b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $05d9de5ec3a4369b$var$_board = $05d9de5ec3a4369b$var$_interopRequireDefault((parcelRequire("8EsNC")));
function $05d9de5ec3a4369b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $05d9de5ec3a4369b$var$BoardIcon = (props)=>/*#__PURE__*/ $05d9de5ec3a4369b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M8 6v12h2V6zm6 0v12h2V6z"/></g></svg>`
    }, props, {
        newIcon: $05d9de5ec3a4369b$var$_board.default
    }));
$05d9de5ec3a4369b$var$BoardIcon.displayName = 'BoardIcon';
var $05d9de5ec3a4369b$var$_default = module.exports.default = $05d9de5ec3a4369b$var$BoardIcon;

});
parcelRegister("8EsNC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2dab6fa8ff371cf20578e3adf70cbf3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64c8661ab6d81803$var$_react = $64c8661ab6d81803$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $64c8661ab6d81803$var$_UNSAFE_baseNew = $64c8661ab6d81803$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $64c8661ab6d81803$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $64c8661ab6d81803$var$BoardIcon = (props)=>/*#__PURE__*/ $64c8661ab6d81803$var$_react.default.createElement($64c8661ab6d81803$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M5.583 2.75H2C1.31 2.75.75 3.31.75 4v8c0 .69.56 1.25 1.25 1.25h3.583m0-10.5v10.5m0-10.5h4.834m-4.834 10.5h4.834m0-10.5H14c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25h-3.583m0-10.5v10.5"/>`
    }, props));
$64c8661ab6d81803$var$BoardIcon.displayName = 'BoardIcon';
var $64c8661ab6d81803$var$_default = module.exports.default = $64c8661ab6d81803$var$BoardIcon;

});


parcelRegister("90gd1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68e0afe9fd548c5c$var$_react = $68e0afe9fd548c5c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $68e0afe9fd548c5c$var$_listBulleted = $68e0afe9fd548c5c$var$_interopRequireDefault((parcelRequire("bEjt9")));
function $68e0afe9fd548c5c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $68e0afe9fd548c5c$var$BulletListIcon = (props)=>/*#__PURE__*/ $68e0afe9fd548c5c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="10" y="15" rx="1"/><rect width="2" height="2" x="6" y="15" rx="1"/><rect width="8" height="2" x="10" y="11" rx="1"/><rect width="2" height="2" x="6" y="11" rx="1"/><rect width="8" height="2" x="10" y="7" rx="1"/><rect width="2" height="2" x="6" y="7" rx="1"/></g></svg>`
    }, props, {
        newIcon: $68e0afe9fd548c5c$var$_listBulleted.default
    }));
$68e0afe9fd548c5c$var$BulletListIcon.displayName = 'BulletListIcon';
var $68e0afe9fd548c5c$var$_default = module.exports.default = $68e0afe9fd548c5c$var$BulletListIcon;

});
parcelRegister("bEjt9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff718278f5b90796d34b75a3e59b4f33>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87b28849bcb64a34$var$_react = $87b28849bcb64a34$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87b28849bcb64a34$var$_UNSAFE_baseNew = $87b28849bcb64a34$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $87b28849bcb64a34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87b28849bcb64a34$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $87b28849bcb64a34$var$_react.default.createElement($87b28849bcb64a34$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.75 2.75a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M5 2.75h10M5 8h10M5 13.25h10M2.75 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0-10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`
    }, props));
$87b28849bcb64a34$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $87b28849bcb64a34$var$_default = module.exports.default = $87b28849bcb64a34$var$ListBulletedIcon;

});


parcelRegister("eWXbg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ae246388ea520792$var$_react = $ae246388ea520792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $ae246388ea520792$var$_page = $ae246388ea520792$var$_interopRequireDefault((parcelRequire("kdfZa")));
function $ae246388ea520792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ae246388ea520792$var$PageIcon = (props)=>/*#__PURE__*/ $ae246388ea520792$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
    }, props, {
        newIcon: $ae246388ea520792$var$_page.default
    }));
$ae246388ea520792$var$PageIcon.displayName = 'PageIcon';
var $ae246388ea520792$var$_default = module.exports.default = $ae246388ea520792$var$PageIcon;

});
parcelRegister("kdfZa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c63ce0083f2e9a73a4c7c0a839641a58>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb716bf3c984513d$var$_react = $eb716bf3c984513d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eb716bf3c984513d$var$_UNSAFE_baseNew = $eb716bf3c984513d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eb716bf3c984513d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb716bf3c984513d$var$PageIcon = (props)=>/*#__PURE__*/ $eb716bf3c984513d$var$_react.default.createElement($eb716bf3c984513d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 5.25h8m-8 3.5h6m-7 5.5h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$eb716bf3c984513d$var$PageIcon.displayName = 'PageIcon';
var $eb716bf3c984513d$var$_default = module.exports.default = $eb716bf3c984513d$var$PageIcon;

});


parcelRegister("i3vuN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d250f039686fbf24$var$_react = $d250f039686fbf24$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d250f039686fbf24$var$_roadmap = $d250f039686fbf24$var$_interopRequireDefault((parcelRequire("ifnb0")));
function $d250f039686fbf24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d250f039686fbf24$var$RoadmapIcon = (props)=>/*#__PURE__*/ $d250f039686fbf24$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 2h10a3 3 0 0 1 0 6H6a3 3 0 1 1 0-6m0 2a1 1 0 1 0 0 2h10a1 1 0 0 0 0-2zm4 5h8a3 3 0 0 1 0 6h-8a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zm-4 5h6a3 3 0 0 1 0 6H6a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        newIcon: $d250f039686fbf24$var$_roadmap.default
    }));
$d250f039686fbf24$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $d250f039686fbf24$var$_default = module.exports.default = $d250f039686fbf24$var$RoadmapIcon;

});
parcelRegister("ifnb0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf2cef03a1c42b52984c96f46580b3eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d48b9b12f073239d$var$_react = $d48b9b12f073239d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d48b9b12f073239d$var$_UNSAFE_baseNew = $d48b9b12f073239d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d48b9b12f073239d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d48b9b12f073239d$var$RoadmapIcon = (props)=>/*#__PURE__*/ $d48b9b12f073239d$var$_react.default.createElement($d48b9b12f073239d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M.75 4c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v1c0 .69-.56 1.25-1.25 1.25H2C1.31 6.25.75 5.69.75 5zm3 7c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v1c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25z"/>`
    }, props));
$d48b9b12f073239d$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $d48b9b12f073239d$var$_default = module.exports.default = $d48b9b12f073239d$var$RoadmapIcon;

});



parcelRegister("czzsL", function(module, exports) {

$parcel$export(module.exports, "filterAndSort", () => $0a04151ee5a00965$export$d0e0de50c701304c);
$parcel$export(module.exports, "findDependentFeature", () => $0a04151ee5a00965$export$4c8205136225a4e2);
$parcel$export(module.exports, "updateFeatureState", () => $0a04151ee5a00965$export$2bdeae30201d513c);
$parcel$export(module.exports, "fireErrorAnalyticsOnUnmatchFeatureKey", () => $0a04151ee5a00965$export$5da1e8c5ba5c0dc2);

var $hqTkp = parcelRequire("hqTkp");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $3Jf4N = parcelRequire("3Jf4N");
const $0a04151ee5a00965$export$b70265791d2079d4 = (hasFeature)=>hasFeature ? 'ENABLED' : 'DISABLED';
const $0a04151ee5a00965$export$d0e0de50c701304c = (features)=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
    const featureMap = (0, $3Jf4N.getFeatureMap)({
        isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
        isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
    });
    return features.filter((f)=>Object.keys(featureMap).includes(f.feature)).sort((a, b)=>featureMap[a.feature].order - featureMap[b.feature].order);
};
const $0a04151ee5a00965$export$4c8205136225a4e2 = (features, featureId)=>{
    const featureToDisable = features.find((f)=>f.feature === featureId);
    // Will only show the modal when the current status is enabled for both the feature to disable and the dependent feature
    if (featureToDisable?.state !== 'ENABLED') return undefined;
    // For the scope of the feature toggle, we assume there is only one dependency for now
    return features.find((f)=>f.prerequisites.includes(featureId) && f.state === 'ENABLED');
};
const $0a04151ee5a00965$export$2bdeae30201d513c = (featureId, dependentFeatureId)=>(feature)=>feature.feature === featureId || dependentFeatureId && feature.feature === dependentFeatureId ? {
            ...feature,
            state: feature.state === 'ENABLED' ? 'DISABLED' : 'ENABLED'
        } : feature;
const $0a04151ee5a00965$export$5da1e8c5ba5c0dc2 = (filteredFeatures)=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
    const featureMap = (0, $3Jf4N.getFeatureMap)({
        isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
        isListViewEnabled: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation')
    });
    if (filteredFeatures.length < Object.keys(featureMap).length) {
        const unmatchedFeatureKeys = (0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(Object.keys(featureMap), ...filteredFeatures.map((f)=>f.feature));
        (0, $jcw0u.default)({
            error: new Error("Some feature keys don't match . Please check API response"),
            meta: {
                ...(0, $3Jf4N.commonErrorAnalyticsMeta),
                id: 'unmatchFeatureKey'
            },
            attributes: {
                unmatchedFeatureKeys: unmatchedFeatureKeys.toString()
            }
        });
    }
};

});
parcelRegister("hqTkp", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $g7i7g = parcelRequire("g7i7g");

var $f3SOL = parcelRequire("f3SOL");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $cb0fc8686550aa11$var$without = $g7i7g(function(array, values) {
    return $f3SOL(array) ? $55pzo(array, values) : [];
});
module.exports = $cb0fc8686550aa11$var$without;

});


parcelRegister("iZZTd", function(module, exports) {

$parcel$export(module.exports, "getBoardFeatures", () => $140b4a0769fd2090$export$c20100b185d41ab0);

var $eusud = parcelRequire("eusud");

var $8djOx = parcelRequire("8djOx");
const $140b4a0769fd2090$export$c20100b185d41ab0 = async (boardId)=>{
    const data = await (0, $eusud.performGetRequest)((0, $8djOx.getBoardFeaturesUrl)(boardId));
    return data.features;
};

});
parcelRegister("8djOx", function(module, exports) {

$parcel$export(module.exports, "getBoardFeaturesUrl", () => $45a3789113fa4e8b$export$3f9939d302766b52);
const $45a3789113fa4e8b$export$3f9939d302766b52 = (boardId)=>`/rest/agile/latest/board/${boardId}/features`;

});


parcelRegister("ke207", function(module, exports) {

$parcel$export(module.exports, "updateBoardFeature", () => $1ce9149bd154bcf9$export$61f6bbb745b3a3);

var $eusud = parcelRequire("eusud");

var $8djOx = parcelRequire("8djOx");
const $1ce9149bd154bcf9$export$61f6bbb745b3a3 = async (request)=>{
    // it returns the board features array, but we don't use it for optimistic update
    // feature state is used instead to indicate if the updates successful or not
    const data = await (0, $eusud.performPutRequest)((0, $8djOx.getBoardFeaturesUrl)(request.boardId), {
        body: JSON.stringify(request)
    });
    const newState = data.features.find((f)=>f.feature === request.feature)?.state;
    return newState ?? (request.enabling ? 'ENABLED' : 'DISABLED');
};

});



parcelRegister("iHqA4", function(module, exports) {

$parcel$export(module.exports, "useClearSidebarToggled", () => $b80f211a69d994c6$export$2946f555c6f48127);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $1J3t1 = parcelRequire("1J3t1");

var $1XJ20 = parcelRequire("1XJ20");

var $hDSPU = parcelRequire("hDSPU");

var $j8sa8 = parcelRequire("j8sa8");
const $b80f211a69d994c6$export$2946f555c6f48127 = ()=>{
    const { data: data, refresh: refresh } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const [sidebarFeatureToggled, { clearSiderbarFeatureToggled: clearSiderbarFeatureToggled }] = (0, $hDSPU.useSidebarFeatureToggled)();
    const isEligibleForFeatureToggle = (0, $j8sa8.useShouldApplyFeatureToggle)();
    const sidebarHasChanged = (0, $5uXOq.useRef)(false);
    const previousData = (0, $1XJ20.usePreviousWithInitial)(data);
    // if resource data has changed since the last refresh then remove the sidebar toggled data.
    // i.e. whatever that has been toggled is reflected on the latest resource
    const shouldClear = (0, $5uXOq.useMemo)(()=>isEligibleForFeatureToggle && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(previousData, data), [
        isEligibleForFeatureToggle,
        previousData,
        data
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldClear) clearSiderbarFeatureToggled();
    }, [
        shouldClear,
        clearSiderbarFeatureToggled
    ]);
    (0, $5uXOq.useEffect)(()=>{
        sidebarHasChanged.current = isEligibleForFeatureToggle && !!sidebarFeatureToggled;
    }, [
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    // refresh the navigation resource if sidebar has changed
    (0, $5uXOq.useEffect)(()=>()=>{
            if (sidebarHasChanged.current) refresh();
        }, [
        refresh
    ]);
};

});
parcelRegister("j8sa8", function(module, exports) {

$parcel$export(module.exports, "useShouldApplyFeatureToggle", () => $d568e02a383436d9$export$7deca16ba2d9eb74);

var $2vSU6 = parcelRequire("2vSU6");

var $dAfqg = parcelRequire("dAfqg");

var $dkqym = parcelRequire("dkqym");
const $d568e02a383436d9$export$7deca16ba2d9eb74 = ()=>{
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const firstActivationDateMs = (0, $dkqym.useFirstActivationDateMs)() || 0;
    const isJSW = project?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const isTMP = !!project?.simplified;
    const isProjectAdmin = !!project?.isProjectAdmin;
    const isNewInstance = new Date(firstActivationDateMs) >= new Date('2023-09-25T15:00:00');
    return isJSW && isTMP && isProjectAdmin && isNewInstance;
};

});
parcelRegister("dkqym", function(module, exports) {

$parcel$export(module.exports, "useFirstActivationDateMs", () => $61794ef454831b86$export$9df3a539e50a284b);

var $9OXo1 = parcelRequire("9OXo1");
const $61794ef454831b86$export$9df3a539e50a284b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
};

});





parcelRegister("ggqQe", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfa60e0dd6b35d8f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $8Rkzz = parcelRequire("8Rkzz");

var $k9tnV = parcelRequire("k9tnV");

var $gwIPs = parcelRequire("gwIPs");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $645AZ = parcelRequire("645AZ");

var $ilwFs = parcelRequire("ilwFs");

var $eL3Mi = parcelRequire("eL3Mi");

var $4kZpX = parcelRequire("4kZpX");
const $cfa60e0dd6b35d8f$var$columnMarginRight = (0, $645AZ.layout).columnMargin * 2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfa60e0dd6b35d8f$var$StyledDivControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "pslf7a-0"
})({
    alignItems: 'stretch',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $645AZ.layout).cardListRadius}px`,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    '&::before': {
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $645AZ.layout).columnMargin}px`
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfa60e0dd6b35d8f$var$StyledDivExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1fhb _2rkoi2wt _1e0c1txw _2lx21bp4 _16jlkb7n _1n261q9c _1bah1y6m _1cs8stnw _1mp4i2wt",
            __cmplp.className
        ])
    });
});
const $cfa60e0dd6b35d8f$var$StyledDiv = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $cfa60e0dd6b35d8f$var$StyledDivExperiment, $cfa60e0dd6b35d8f$var$StyledDivControl);
class $cfa60e0dd6b35d8f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isDisabled: false,
            spotlightTargetId: '',
            onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.isFormVisible !== prevState.isFormVisible) this.scrollIntoView();
    }
    scrollIntoView() {
        if (!(0, $ilwFs.isStickySupported)) // Scroll the column into view with a method which works with IE11
        this.container.scrollIntoView();
        else {
            // padding required due to BoardScroll (32px wide + column margin(12px))
            this.container.style.paddingRight = `${(0, $gwIPs.gridSize) * 4 + $cfa60e0dd6b35d8f$var$columnMarginRight}px`;
            (0, $k9tnV.default)(this.container);
            this.container.style.paddingRight = '0px';
        }
    }
    render() {
        const { onEditStart: onEditStart, validate: validate, isDisabled: isDisabled, spotlightTargetId: spotlightTargetId, renderCustomButton: renderCustomButton, onCreateButtonClick: onCreateButtonClick } = this.props;
        const { isFormVisible: isFormVisible } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfa60e0dd6b35d8f$var$StyledDiv, {
            innerRef: this.setContainer
        }, isFormVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4kZpX.default), {
            onEditStart: onEditStart,
            onCancel: this.onCancel,
            onSubmit: this.onSubmit,
            validate: validate
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eL3Mi.ColumnCreateButtonWithEngagement), {
            targetId: spotlightTargetId,
            onClick: onCreateButtonClick || this.showForm,
            isDisabled: isDisabled,
            renderCustomButton: renderCustomButton
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isFormVisible: false
        };
        this.onSubmit = (temporaryId, name, analyticsEvent)=>{
            this.setState({
                isFormVisible: false
            });
            this.props.onSubmit(temporaryId, name, analyticsEvent);
        };
        this.onCancel = (columnId, type)=>{
            this.setState({
                isFormVisible: false
            });
            this.props.onEditCancel && this.props.onEditCancel(columnId, type);
        };
        this.setContainer = (ref)=>{
            this.container = ref;
        } // @ts-expect-error - TS2564 - Property 'container' has no initializer and is not definitely assigned in the constructor.
        ;
        this.showForm = ()=>{
            this.setState({
                isFormVisible: true
            });
        };
    }
}

});
parcelRegister("eL3Mi", function(module, exports) {

$parcel$export(module.exports, "ColumnCreateButtonWithEngagement", () => $a9e755b291cf91b8$export$549ac82938941987);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $dZbEw = parcelRequire("dZbEw");

var $7ymNM = parcelRequire("7ymNM");

var $3bDjY = parcelRequire("3bDjY");

var $iQv12 = parcelRequire("iQv12");

var $gSExi = parcelRequire("gSExi");

var $9vPRK = parcelRequire("9vPRK");

var $co1wz = parcelRequire("co1wz");

var $ousew = parcelRequire("ousew");

var $645AZ = parcelRequire("645AZ");

var $ilwFs = parcelRequire("ilwFs");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a9e755b291cf91b8$var$StyledStickyPlaceholderControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "j6by6c-0"
})({
    position: 'sticky',
    top: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $645AZ.zIndex).stickyHeaders
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a9e755b291cf91b8$var$StyledStickyPlaceholderExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _154iidpf _1pbyegat",
            __cmplp.className
        ])
    });
});
const $a9e755b291cf91b8$var$StyledStickyPlaceholder = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $a9e755b291cf91b8$var$StyledStickyPlaceholderExperiment, $a9e755b291cf91b8$var$StyledStickyPlaceholderControl);
class $a9e755b291cf91b8$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isDisabled: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(...args){
        super(...args);
        this.onClick = (event, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
        this.renderButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                id: "platform-board.column.add-button-tooltip",
                defaultMessage: "Create column"
            }, (formattedMessage)=>{
                const message = typeof formattedMessage[0] === 'string' ? formattedMessage[0] : 'Create column';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    position: "left",
                    content: message
                }, this.props.renderCustomButton ? this.props.renderCustomButton({
                    onClick: this.onClick,
                    testId: 'platform-board-kit.ui.column.column-create.button.styled-button',
                    isDisabled: this.props.isDisabled,
                    ariaLabel: message
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                    onClick: this.onClick,
                    testId: "platform-board-kit.ui.column.column-create.button.styled-button",
                    isDisabled: this.props.isDisabled,
                    "aria-label": message,
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                        label: "",
                        spacing: "spacious",
                        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7ymNM))),
                        LEGACY_size: "medium",
                        color: "var(--ds-icon, #44546F)"
                    })
                }));
            });
        this.render = ()=>{
            if (!(0, $ilwFs.isStickySupported)) return this.renderButton();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a9e755b291cf91b8$var$StyledStickyPlaceholder, null, this.renderButton());
        };
    }
}
const $a9e755b291cf91b8$var$ColumnCreateButtonWithAnalytics = (0, $iQv12.default)({
    onClick: ()=>({
            name: 'addColumn'
        })
})($a9e755b291cf91b8$export$2e2bcd8739ae039);
const $a9e755b291cf91b8$export$549ac82938941987 = (0, $9vPRK.default)($a9e755b291cf91b8$var$ColumnCreateButtonWithAnalytics);

});
parcelRegister("iQv12", function(module, exports) {

$parcel$export(module.exports, "default", () => $945500a9598c3ac2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gvRPW = parcelRequire("gvRPW");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $945500a9598c3ac2$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $5uXOq.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $945500a9598c3ac2$export$2e2bcd8739ae039 = $945500a9598c3ac2$var$fireWithUIAnalytics;

});

parcelRegister("9vPRK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7938f3de3467cdb8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $5Fk4Z = parcelRequire("5Fk4Z");
function $7938f3de3467cdb8$export$2e2bcd8739ae039(BaseComponent) {
    // eslint-disable-next-line jira/react/no-class-components
    return class WithEngagement extends (0, $5uXOq.Component) {
        render() {
            const { targetId: targetId, ...componentProps } = this.props;
            if (!targetId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BaseComponent, componentProps);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
                name: targetId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BaseComponent, componentProps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
                engagementId: targetId
            }));
        }
    };
}

});


parcelRegister("4kZpX", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc379fba6e707c79$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $8Rkzz = parcelRequire("8Rkzz");

var $b8gJu = parcelRequire("b8gJu");

var $7KmE2 = parcelRequire("7KmE2");

var $3kNE6 = parcelRequire("3kNE6");

var $g503o = parcelRequire("g503o");

var $6crUM = parcelRequire("6crUM");

var $5k6Fi = parcelRequire("5k6Fi");

var $16E0T = parcelRequire("16E0T");
class $fc379fba6e707c79$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(...args){
        super(...args);
        this.state = {
            column: (0, $7KmE2.newColumn)()
        };
        this.onColumnTitleEditChange = (isEditingTitle)=>{
            if (isEditingTitle && this.props.onEditStart) this.props.onEditStart();
        };
        this.render = ()=>{
            const columnTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6crUM.default), {
                text: "",
                columnId: this.state.column.id,
                isEditing: true,
                onConfirm: this.props.onSubmit,
                onCancel: this.props.onCancel,
                onEditChange: this.onColumnTitleEditChange,
                // @ts-expect-error - Type 'ValidateColumnCallback' is not assignable to type '() => { isValid: boolean; message: null; }'.
                validateColumn: this.props.validate
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47bDC.ThemeProvider), {
                theme: (0, $g503o.columnThemes).default
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g503o.ColumnWrapper), {
                "data-testid": (0, $b8gJu.COLUMN_WRAPPER_FORM_SELECTOR_NAME),
                appearance: (0, $3kNE6.ColumnTheme).Default
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16E0T.ColumnHeaderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5k6Fi.default), {
                id: this.state.column.id,
                title: columnTitle
            }))));
        };
    }
}

});
parcelRegister("7KmE2", function(module, exports) {

$parcel$export(module.exports, "newColumn", () => $7bb1f5607fb553eb$export$da89f2663ee4541c);
const $7bb1f5607fb553eb$var$INITIAL_COLUMN_ID = 0;
let $7bb1f5607fb553eb$var$lastColumnId = $7bb1f5607fb553eb$var$INITIAL_COLUMN_ID;
const $7bb1f5607fb553eb$var$generateId = ()=>{
    $7bb1f5607fb553eb$var$lastColumnId -= 1;
    return $7bb1f5607fb553eb$var$lastColumnId;
};
const $7bb1f5607fb553eb$export$da89f2663ee4541c = ()=>({
        id: $7bb1f5607fb553eb$var$generateId(),
        name: '',
        isDone: false,
        clearedOutCardsUrl: null,
        totalCardsCount: 0,
        isUpdating: true,
        isInitial: false
    });

});

parcelRegister("g503o", function(module, exports) {

$parcel$export(module.exports, "columnThemes", () => $fe22a2a49fd3e2ba$export$18626b6d0fe527f4);
$parcel$export(module.exports, "ColumnWrapperExperiment", () => $fe22a2a49fd3e2ba$export$8dea97a945e16f7);
$parcel$export(module.exports, "ColumnWrapperControl", () => $fe22a2a49fd3e2ba$export$9308abaf9d79120);
$parcel$export(module.exports, "ColumnWrapper", () => $fe22a2a49fd3e2ba$export$b904459935723643);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");


var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $645AZ = parcelRequire("645AZ");

var $3kNE6 = parcelRequire("3kNE6");
const $fe22a2a49fd3e2ba$export$18626b6d0fe527f4 = {
    [(0, $3kNE6.ColumnTheme).Default]: {
        background: `var(--ds-surface-sunken, ${(0, $829f609a65d26a98$exports).N20})`,
        headerHover: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$exports).N40})`,
        btnHover: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$exports).N40})`,
        btnActive: `var(--ds-background-neutral-pressed, ${(0, $829f609a65d26a98$exports).N50})`,
        btnIconHover: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$exports).N500})`,
        btnIconActive: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        titleEditHover: `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$exports).N20})`
    },
    [(0, $3kNE6.ColumnTheme).Warning]: {
        background: "var(--ds-background-accent-yellow-subtlest, #fff7d6)",
        headerHover: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$exports).Y100})`,
        btnHover: `var(--ds-background-warning-hovered, ${(0, $829f609a65d26a98$exports).Y75})`,
        btnActive: `var(--ds-background-warning-pressed, ${(0, $829f609a65d26a98$exports).Y300})`,
        btnIconHover: `var(--ds-background-neutral-bold, ${(0, $829f609a65d26a98$exports).N500})`,
        btnIconActive: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        titleEditHover: `var(--ds-background-warning-hovered, ${(0, $829f609a65d26a98$exports).Y50})`
    },
    [(0, $3kNE6.ColumnTheme).Danger]: {
        background: "var(--ds-background-accent-red-subtlest, #ffedeb)",
        headerHover: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$exports).Y100})`,
        btnHover: `var(--ds-background-warning-hovered, ${(0, $829f609a65d26a98$exports).Y75})`,
        btnActive: `var(--ds-background-warning-pressed, ${(0, $829f609a65d26a98$exports).Y300})`,
        btnIconHover: `var(--ds-background-neutral-bold, ${(0, $829f609a65d26a98$exports).N500})`,
        btnIconActive: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        titleEditHover: `var(--ds-background-warning-hovered, ${(0, $829f609a65d26a98$exports).Y50})`
    }
};
const $fe22a2a49fd3e2ba$export$8dea97a945e16f7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCollapsed: isCollapsed, isFlexible: isFlexible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1vk9aov": (0, $lD23V.default)($fe22a2a49fd3e2ba$export$18626b6d0fe527f4[(0, $3kNE6.ColumnTheme).Default]?.background ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            $fe22a2a49fd3e2ba$export$18626b6d0fe527f4[(0, $3kNE6.ColumnTheme).Default].background : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `var(--ds-surface-sunken, ${(0, $829f609a65d26a98$exports).N20})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhkahx4 _2rkoi2wt _kqswh2mm _1wpz1fhb _16jlkb7n _1o9zkb7n _i0dl1wug _v5643711 _1ul91ogy _p12f1ogy",
            __cmplp.isCollapsed && "_bfhk18uv _1ul91ylp _p12f1ylp",
            __cmplp.isFlexible && "_1ul91w81 _p12fglyw",
            __cmplp.isCollapsed && __cmplp.isFlexible && "_1ul91ylp _p12fglyw",
            __cmplp.className
        ])
    });
});
const $fe22a2a49fd3e2ba$export$9308abaf9d79120 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "pfibim-0"
})`background-color:${(props)=>{
    if (props.isCollapsed) return 'transparent';
    return $fe22a2a49fd3e2ba$export$18626b6d0fe527f4[(0, $3kNE6.ColumnTheme).Default].background;
}};border-radius:${(0, $645AZ.layout).cardListRadius}px;position:relative;align-self:stretch;flex:1 1 auto;transition:opacity 0.2s,min-width 300ms,max-width 300ms ease-in;min-width:${(props)=>{
    if (props.isCollapsed) return `${0, $645AZ.collapsedColumnFixedWidth}px`;
    return props.isFlexible ? `${0, $645AZ.columnMinWidth}px` : `${0, $645AZ.columnFixedWidth}px`;
}};max-width:${(props)=>{
    if (props.isFlexible) return 'none';
    return props.isCollapsed ? `${0, $645AZ.collapsedColumnFixedWidth}px` : `${0, $645AZ.columnFixedWidth}px`;
}};`;
const $fe22a2a49fd3e2ba$export$b904459935723643 = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $fe22a2a49fd3e2ba$export$8dea97a945e16f7, $fe22a2a49fd3e2ba$export$9308abaf9d79120);

});

parcelRegister("6crUM", function(module, exports) {

$parcel$export(module.exports, "default", () => $df4de5071d7a54c9$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $1dJ6S = parcelRequire("1dJ6S");

var $34Rrn = parcelRequire("34Rrn");

var $gtreQ = parcelRequire("gtreQ");

var $ctg8C = parcelRequire("ctg8C");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $kY99m = parcelRequire("kY99m");


var $dRKyO = parcelRequire("dRKyO");

var $gwIPs = parcelRequire("gwIPs");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $az4zD = parcelRequire("az4zD");

var $8zOmE = parcelRequire("8zOmE");

var $645AZ = parcelRequire("645AZ");

var $kbA3u = parcelRequire("kbA3u");

var $lVBgn = parcelRequire("lVBgn");

var $8BBAt = parcelRequire("8BBAt");
const $df4de5071d7a54c9$var$CANCEL_BUTTON_CLICKED = 'button-clicked';
const $df4de5071d7a54c9$var$CANCEL_CLICKED_OUT = 'clicked-out';
const $df4de5071d7a54c9$var$isBlank = (value)=>value.length === 0;
const $df4de5071d7a54c9$var$hasNotChanged = (current, previous)=>current === previous;
const $df4de5071d7a54c9$var$isNewColumn = (columnId)=>Number(columnId) < 0;
const $df4de5071d7a54c9$var$getCleanColumnName = (name)=>name.replace(/\s{2,}/g, ' ').trim();
const $df4de5071d7a54c9$export$cb9b233debb52c9f = 30;
const $df4de5071d7a54c9$export$86f9d799207827d5 = 200;
class $df4de5071d7a54c9$export$11c45455ee9d37df extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isDisabled: false,
            isDone: false,
            isEditing: false,
            totalCount: 0,
            visibleCount: 0,
            showTotalCount: false,
            validateColumn: ()=>({
                    isValid: true,
                    message: null
                }),
            onEditChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onConfirm: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            isCMPBoard: false,
            shouldRemoveSpaceForMenu: false
        };
    }
    render() {
        const { isEditing: isEditing } = this.state;
        const interactionProps = (0, $4R6GH.fg)('simplified_and_update_sprint_when_skip_extra') ? {
            onFocus: ()=>this.setState({
                    hasInteracted: true
                }),
            onMouseEnter: ()=>this.setState({
                    hasInteracted: true
                }),
            tabIndex: this.state.hasInteracted ? -1 : 0
        } : {};
        return (0, $4R6GH.fg)('tnk-1614-visual-refresh-boardkit') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $df4de5071d7a54c9$var$headerRowStyles,
            ref: this.setContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df4de5071d7a54c9$var$InlineEditPartWrapper, {
            "data-testid": "platform-board-kit.common.ui.column-header.editable-title.inline-edit-part-wrapper",
            isEditing: isEditing,
            shouldRemoveSpaceForMenu: this.props.shouldRemoveSpaceForMenu,
            ...interactionProps
        }, this.renderInlineEditPart())) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df4de5071d7a54c9$var$HeaderRow, {
            ref: this.setContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df4de5071d7a54c9$var$InlineEditPartWrapper, {
            "data-testid": "platform-board-kit.common.ui.column-header.editable-title.inline-edit-part-wrapper",
            isEditing: isEditing,
            shouldRemoveSpaceForMenu: this.props.shouldRemoveSpaceForMenu,
            ...interactionProps
        }, this.renderInlineEditPart()));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isEditing: this.props.isEditing || false,
            isValid: true,
            errorMessage: null,
            hasInteracted: false
        };
        this.onTitleOuterClick = (event)=>{
            if (!(event.target instanceof Node) || !this.container?.contains(event.target)) // cancel inline edit on outer click
            this.handleCancel($df4de5071d7a54c9$var$CANCEL_CLICKED_OUT);
        };
        this.onEditChange = (isEditing)=>{
            this.props.onEditChange(isEditing);
            this.setState({
                isEditing: isEditing
            });
        };
        this.setContainer = (container)=>{
            this.container = container;
        };
        this.validateColumn = (name)=>{
            const { isValid: isValid, message: message = null } = this.props.validateColumn(this.props.columnId, $df4de5071d7a54c9$var$getCleanColumnName(name));
            this.setState({
                isValid: isValid,
                errorMessage: message
            });
        };
        this.delayValidateColumn = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((name)=>{
            this.validateColumn(name);
        }, $df4de5071d7a54c9$export$86f9d799207827d5) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ;
        this.formatMessage = (message, values)=>{
            if (typeof message === 'string') return message;
            const result = this.props.intl.formatMessage(message, values);
            return result;
        };
        this.handleEditChange = ()=>{
            this.onEditChange(true);
        };
        this.handleConfirm = (value, analyticsEvent)=>{
            const { columnId: columnId, text: text } = this.props;
            const newValue = $df4de5071d7a54c9$var$getCleanColumnName(value);
            this.delayValidateColumn.cancel();
            const { isValid: isValid } = this.props.validateColumn(columnId, newValue);
            if (!isValid) return;
            if ($df4de5071d7a54c9$var$isBlank(newValue) || $df4de5071d7a54c9$var$hasNotChanged(newValue, text)) this.handleCancel($df4de5071d7a54c9$var$CANCEL_CLICKED_OUT);
            else {
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'column');
                this.props.onConfirm(columnId, newValue, analyticsEvent);
                this.onEditChange(false);
                this.setState({
                    isEditing: false
                });
            }
        };
        this.handleCancel = (type)=>{
            const { columnId: columnId } = this.props;
            if (!$df4de5071d7a54c9$var$isNewColumn(columnId)) this.onEditChange(false);
            this.setState({
                isValid: true,
                errorMessage: null
            });
            this.props.onCancel(columnId, type);
        };
        this.renderReadOnly = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $df4de5071d7a54c9$var$readOnlyStyles
            }, this.renderReadView());
        this.renderReadView = ()=>{
            const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kbA3u.default), {
                text: this.props.text,
                isEditing: this.state.isEditing,
                showTotalCount: this.props.showTotalCount,
                visibleCount: this.props.visibleCount,
                totalCount: this.props.totalCount,
                isDisabled: this.props.isDisabled,
                isCMPBoard: this.props.isCMPBoard
            }), this.props.lozenges, this.props.isDone && !this.props.isCMPBoard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lVBgn.default), null) : null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df4de5071d7a54c9$var$Reading, null, content);
        };
        this.renderEditView = ({ errorMessage: errorMessage, ...fieldProps })=>{
            const { isValid: isValid } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), {
                isOpen: !isValid,
                content: this.renderValidation(fieldProps.value),
                placement: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ...fieldProps,
                testId: "platform-board-kit.common.ui.column-header.editable-title.textfield",
                elemAfterInput: !isValid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df4de5071d7a54c9$var$WarningIconWrapper, null, (0, $4R6GH.fg)('tnk-1614-visual-refresh-boardkit-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($34Rrn))), {
                    label: "error",
                    color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y400})`,
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gtreQ))),
                    LEGACY_primaryColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y400})`
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gtreQ))), {
                    label: "error",
                    primaryColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y400})`
                })),
                maxLength: $df4de5071d7a54c9$export$cb9b233debb52c9f,
                autoFocus: true,
                autoComplete: "off"
            }));
        };
        this.formatErrorMessage = (message, values)=>{
            if (typeof message === 'string') return message;
            return this.props.intl.formatMessage(message, values);
        };
        this.renderValidation = (name)=>{
            const { isValid: isValid, errorMessage: errorMessage } = this.state;
            if (isValid || !errorMessage) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df4de5071d7a54c9$var$InlineDialogHeader, null, this.formatErrorMessage(errorMessage.title, {
                name: name.toUpperCase()
            })), (0, $4R6GH.fg)('tnk-1614-visual-refresh-boardkit') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $df4de5071d7a54c9$var$inlineDialogBodyStyles
            }, this.formatErrorMessage(errorMessage.description)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df4de5071d7a54c9$var$InlineDialogBody, null, this.formatErrorMessage(errorMessage.description)));
        };
        this.renderInlineEditPart = ()=>{
            const { isEditing: isEditing, isValid: isValid } = this.state;
            const { isDisabled: isDisabled, intl: intl, text: text, columnId: columnId } = this.props; // the readonly view will be rendered if the column is:
            // 1. disabled
            // 2. a new column (id < 0) and is no longer being edited
            // 3. an existing column and has not been interacted with
            const shouldRenderReadOnly = isDisabled || !$df4de5071d7a54c9$var$isNewColumn(columnId) && !this.state.hasInteracted && (0, $4R6GH.fg)('simplified_and_update_sprint_when_skip_extra') || $df4de5071d7a54c9$var$isNewColumn(columnId) && !isEditing;
            return shouldRenderReadOnly ? this.renderReadOnly() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8BBAt.default), {
                defaultValue: text,
                isEditing: isEditing,
                editView: this.renderEditView,
                validate: this.delayValidateColumn,
                readView: this.renderReadView,
                onConfirm: this.handleConfirm,
                onCancel: ()=>this.handleCancel($df4de5071d7a54c9$var$CANCEL_BUTTON_CLICKED),
                onEdit: this.handleEditChange,
                onOuterClick: this.onTitleOuterClick,
                hideActionButtons: !isValid,
                readViewFitContainerWidth: true,
                editButtonLabel: intl.formatMessage((0, $dRKyO.default).editButtonLabel, {
                    fieldName: ''
                }),
                confirmButtonLabel: intl.formatMessage((0, $dRKyO.default).confirmButtonLabel, {
                    fieldName: ''
                }),
                cancelButtonLabel: intl.formatMessage((0, $dRKyO.default).cancelButtonLabel, {
                    fieldName: ''
                })
            });
        };
    }
}
var // @ts-expect-error - Argument of type 'typeof ColumnEditableTitle' is not assignable to parameter of type 'ComponentType<WithIntlProvided<Props>> & typeof ColumnEditableTitle'.
$df4de5071d7a54c9$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($df4de5071d7a54c9$export$11c45455ee9d37df);
const $df4de5071d7a54c9$var$InlineDialogHeader = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1dJ6S.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df4de5071d7a54c9$var$InlineDialogHeaderInternal, props)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df4de5071d7a54c9$var$InlineDialogHeaderInternalOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81oud _19pkze3t _otyrutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df4de5071d7a54c9$var$InlineDialogHeaderInternalNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1wyb1oud _19pkze3t _otyrutpp",
            __cmplp.className
        ])
    });
});
const $df4de5071d7a54c9$var$InlineDialogHeaderInternal = (0, $gSExi.styledComponentWithCondition)(()=>(0, $4R6GH.fg)('tnk-1614-visual-refresh-boardkit'), $df4de5071d7a54c9$var$InlineDialogHeaderInternalNew, $df4de5071d7a54c9$var$InlineDialogHeaderInternalOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df4de5071d7a54c9$var$InlineDialogBody = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81oud _k48p1nn1 _1dyzqdok _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $df4de5071d7a54c9$var$inlineDialogBodyStyles = (0, $8CUq3.xcss)({
    fontSize: 'font.body',
    fontWeight: 400,
    letterSpacing: '-0.006em',
    color: 'color.text'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df4de5071d7a54c9$var$HeaderRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8qk37 _19bv14y2 _u5f314y2 _p12f1osq _vchhusvi",
            __cmplp.className
        ])
    });
});
const $df4de5071d7a54c9$var$headerRowStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.075',
    paddingRight: 'space.075',
    maxWidth: '100%',
    boxSizing: 'border-box'
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df4de5071d7a54c9$var$InlineEditPartWrapperControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1fjeglf-0"
})`${({ shouldRemoveSpaceForMenu: shouldRemoveSpaceForMenu })=>shouldRemoveSpaceForMenu ? 'max-width: auto;' : `max-width: calc(100% - ${32 + (0, $gwIPs.gridSize) + (0, $645AZ.layout).smallGutter}px);`};${({ isEditing: isEditing })=>isEditing ? `
        flex: 1;
        max-width: 100%;
        ` : `
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    `};`;
const $df4de5071d7a54c9$var$inlineEditPartWrapperEditingStyles = (0, $8CUq3.xcss)({
    flex: 1,
    maxWidth: '100%'
});
const $df4de5071d7a54c9$var$inlineEditPartWrapperNotEditingStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df4de5071d7a54c9$var$InlineEditPartWrapperExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldRemoveSpaceForMenu: shouldRemoveSpaceForMenu, isEditing: isEditing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.shouldRemoveSpaceForMenu ? "_p12f1wug" : "_p12fskta",
            __cmplp.className
        ])
    });
});
const $df4de5071d7a54c9$var$InlineEditPartWrapper = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $df4de5071d7a54c9$var$InlineEditPartWrapperExperiment, $df4de5071d7a54c9$var$InlineEditPartWrapperControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df4de5071d7a54c9$var$Reading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul9idpf _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df4de5071d7a54c9$var$WarningIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f312x7 _vwz41osq",
            __cmplp.className
        ])
    });
});
const $df4de5071d7a54c9$var$readOnlyStyles = (0, $8CUq3.xcss)({
    margin: 'space.025'
});

});
parcelRegister("kY99m", function(module, exports) {

$parcel$export(module.exports, "default", () => $509076ff0c6afa78$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6QvkM = parcelRequire("6QvkM");

var $hbrbl = parcelRequire("hbrbl");
const $509076ff0c6afa78$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $509076ff0c6afa78$var$Textfield = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $5uXOq.useRef)(null);
    const handleOnFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$509076ff0c6afa78$var$analyticsParams
    });
    const handleOnBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$509076ff0c6afa78$var$analyticsParams
    });
    const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $5uXOq.useMemo)(()=>(0, $hbrbl.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $hbrbl.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $509076ff0c6afa78$export$2e2bcd8739ae039 = $509076ff0c6afa78$var$Textfield;

});
parcelRegister("hbrbl", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $9b106cc21ace4b3b$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $9b106cc21ace4b3b$export$3eeb47dc8e6249d9);

const $9b106cc21ace4b3b$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $9b106cc21ace4b3b$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $9b106cc21ace4b3b$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $9b106cc21ace4b3b$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $9b106cc21ace4b3b$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $9b106cc21ace4b3b$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $9b106cc21ace4b3b$var$backgroundColor[appearance],
        borderColor: $9b106cc21ace4b3b$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $9b106cc21ace4b3b$var$backgroundColorHover[appearance],
            borderColor: $9b106cc21ace4b3b$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $9b106cc21ace4b3b$var$backgroundColorFocus[appearance],
            borderColor: $9b106cc21ace4b3b$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$9b106cc21ace4b3b$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $9b106cc21ace4b3b$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $9b106cc21ace4b3b$var$getMaxWidth = (width)=>!width ? `100%` : width in $9b106cc21ace4b3b$var$widthMap ? $9b106cc21ace4b3b$var$widthMap[width] : +width;
const $9b106cc21ace4b3b$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $9b106cc21ace4b3b$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $9b106cc21ace4b3b$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("dRKyO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6e52bd6588bf986$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d6e52bd6588bf986$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    confirmButtonLabel: {
        "id": "inline-edit.confirm-button-label",
        "defaultMessage": "Confirm {fieldName}"
    },
    cancelButtonLabel: {
        "id": "inline-edit.cancel-button-label",
        "defaultMessage": "Cancel {fieldName}"
    },
    editButtonLabel: {
        "id": "inline-edit.edit-button-label",
        "defaultMessage": "Edit {fieldName}"
    },
    addButtonLabel: {
        "id": "inline-edit.add-button-label",
        "defaultMessage": "Add {fieldName}"
    },
    extendedEditButtonLabel: {
        "id": "inline-edit.extended-edit-button-label",
        "defaultMessage": "{inputFieldValue}- edit {fieldName}"
    },
    disabledEditButtonLabel: {
        "id": "inline-edit.disabled-edit-button-label",
        "defaultMessage": "{fieldName} - can\u2019t be edited"
    },
    disabledReporterTooltip: {
        "id": "inline-edit.disabled-inline-edit-tooltip",
        "defaultMessage": "{fieldName} can\u2019t be edited"
    }
});

});

parcelRegister("kbA3u", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1c2bb1a174f6a8f$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ // On compiled.migration.jsw.tanuki FF cleanup, remove styled-component-order disable ^

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $kgoHi = parcelRequire("kgoHi");

var $3RZIb = parcelRequire("3RZIb");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $kVOOl = parcelRequire("kVOOl");

var $dCm1o = parcelRequire("dCm1o");

var $b8gJu = parcelRequire("b8gJu");

var $hvGbV = parcelRequire("hvGbV");
const $e1c2bb1a174f6a8f$var$ColumnTitle = ({ isDisabled: isDisabled, isEditing: isEditing, isCMPBoard: isCMPBoard, showTotalCount: showTotalCount, text: text, totalCount: totalCount, visibleCount: visibleCount })=>{
    const convertedText = text.split(' ').join('-').toLowerCase();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e1c2bb1a174f6a8f$export$5f1af8db9871e1d6, {
        isDisabled: isDisabled,
        "aria-label": text,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `__board-test-hook__column-title ${(0, (/*@__PURE__*/$parcel$interopDefault($kVOOl))).compactColumnTitle}`,
        "data-test-id": "platform-board-kit.common.ui.column-header.editable-title.column-title.column-title",
        "data-testid": "platform-board-kit.common.ui.column-header.editable-title.column-title.column-title",
        "data-component-selector": (0, $b8gJu.COLUMN_TITLE_SELECTOR_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e1c2bb1a174f6a8f$var$FlexWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e1c2bb1a174f6a8f$var$ColumnName, {
        title: text,
        "data-testid": "platform-board-kit.common.ui.column-header.editable-title.column-title.column-name",
        ...(0, $co1wz.ff)('backlog-active-sprints-list-markup-accessibility-fix_imavd') && {
            id: `platform-board-kit.ui.column-title-${convertedText}`
        }
    }, text), !!visibleCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e1c2bb1a174f6a8f$var$CountWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hvGbV.default), {
        isEditing: isEditing,
        showTotalCount: showTotalCount,
        totalCount: totalCount,
        visibleCount: visibleCount,
        isCMPBoard: isCMPBoard
    }))));
};
var $e1c2bb1a174f6a8f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $e1c2bb1a174f6a8f$var$ColumnTitle;
const $e1c2bb1a174f6a8f$var$ColumnNameControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "j6nxay-0"
})({
    display: 'inline-block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '.msie-11 &': {
        width: '100%'
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e1c2bb1a174f6a8f$var$ColumnNameExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _1reo15vq _18m915vq _o5721q9c _1bto1l2s _p12f1osq _wmna1osq",
            __cmplp.className
        ])
    });
});
const $e1c2bb1a174f6a8f$var$ColumnName = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $e1c2bb1a174f6a8f$var$ColumnNameExperiment, $e1c2bb1a174f6a8f$var$ColumnNameControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e1c2bb1a174f6a8f$var$CountWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _18u01b66 _1o9zidpf",
            __cmplp.className
        ])
    });
}); // FIXME: type error from typography mixin, typing on `fontWeight` too strict
const $e1c2bb1a174f6a8f$var$TextControl = /*#__PURE__*/ (0, $47bDC.default).h2.withConfig({
    componentId: "j6nxay-1"
})`${(0, $3RZIb).h400};display:flex;text-transform:uppercase;font-weight:500;color:${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N300})`};letter-spacing:normal;font-size:12px;height:100%;margin-left:${"var(--ds-space-100, 8px)"};margin-right:${"var(--ds-space-100, 8px)"};overflow:hidden;.msie-11 &{font-weight:600;}`; // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e1c2bb1a174f6a8f$var$TextExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1p1dangw _syaz1rc1 _11c816g6 _k48p1wq8 _4t3i1osq _18u0u2gc _2hwxu2gc _1reo15vq _18m915vq _1dyz4jg8 _1ahani7l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e1c2bb1a174f6a8f$export$5f1af8db9871e1d6 = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $e1c2bb1a174f6a8f$var$TextExperiment, $e1c2bb1a174f6a8f$var$TextControl); // When cleaning up compiled.migration.jsw.tanuki align, 'alignContent: center' could be added to the styled H2. It wasn't possible due to Eslint error when using isVisualRefreshEnabled()
const $e1c2bb1a174f6a8f$var$FlexWrapper = ({ children: children })=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center"
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);

});
parcelRegister("kVOOl", function(module, exports) {

$parcel$export(module.exports, "column-header", () => $f3d08b887804124f$export$7177d480608b4128, (v) => $f3d08b887804124f$export$7177d480608b4128 = v);
$parcel$export(module.exports, "compactColumnTitle", () => $f3d08b887804124f$export$b690eaa5578df8ab, (v) => $f3d08b887804124f$export$b690eaa5578df8ab = v);
$parcel$export(module.exports, "compactLozenge", () => $f3d08b887804124f$export$74295e7ce4ff29bf, (v) => $f3d08b887804124f$export$74295e7ce4ff29bf = v);
$parcel$export(module.exports, "defaultLozenge", () => $f3d08b887804124f$export$af9878e03870ea4a, (v) => $f3d08b887804124f$export$af9878e03870ea4a = v);
$parcel$export(module.exports, "defaultLozengeContainer", () => $f3d08b887804124f$export$8ed778aa4998d971, (v) => $f3d08b887804124f$export$8ed778aa4998d971 = v);
var $f3d08b887804124f$export$7177d480608b4128;
var $f3d08b887804124f$export$b690eaa5578df8ab;
var $f3d08b887804124f$export$74295e7ce4ff29bf;
var $f3d08b887804124f$export$af9878e03870ea4a;
var $f3d08b887804124f$export$8ed778aa4998d971;
$f3d08b887804124f$export$7177d480608b4128 = `j-BFpW_column-header`;
$f3d08b887804124f$export$b690eaa5578df8ab = `j-BFpW_compactColumnTitle`;
$f3d08b887804124f$export$74295e7ce4ff29bf = `j-BFpW_compactLozenge`;
$f3d08b887804124f$export$af9878e03870ea4a = `j-BFpW_defaultLozenge`;
$f3d08b887804124f$export$8ed778aa4998d971 = `j-BFpW_defaultLozengeContainer`;

});

parcelRegister("hvGbV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cf9b19799953994$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $16T6Y = parcelRequire("16T6Y");

var $ousew = parcelRequire("ousew");

var $dCm1o = parcelRequire("dCm1o");

var $ek9Ll = parcelRequire("ek9Ll");
const $1cf9b19799953994$var$ColumnCardCount = ({ isCMPBoard: isCMPBoard, isEditing: isEditing, totalCount: totalCount, showTotalCount: showTotalCount, visibleCount: visibleCount })=>{
    if (isEditing || totalCount === 0) return null;
    if (showTotalCount) {
        if (isCMPBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1cf9b19799953994$export$5c31959b0a6b6e24, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1cf9b19799953994$var$BadgeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            id: "platform-board.column-header-count-uif",
            defaultMessage: "{visibleCountNumber}/{totalCountNumber}",
            values: {
                visibleCountNumber: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ek9Ll))), null, visibleCount),
                totalCountNumber: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ek9Ll))), null, totalCount)
            }
        })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1cf9b19799953994$export$5c31959b0a6b6e24, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1cf9b19799953994$var$BadgeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            id: "platform-board.column-header-count",
            defaultMessage: "{visibleCountNumber} of {totalCountNumber}",
            values: {
                visibleCountNumber: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ek9Ll))), null, visibleCount),
                totalCountNumber: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ek9Ll))), null, totalCount)
            }
        })));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1cf9b19799953994$export$5c31959b0a6b6e24, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1cf9b19799953994$var$BadgeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ek9Ll))), null, visibleCount)));
};
var $1cf9b19799953994$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $1cf9b19799953994$var$ColumnCardCount;
const $1cf9b19799953994$export$5c31959b0a6b6e24 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1rc1 _1ul9idpf _16jlidpf _1o9zidpf _2hwx1b66",
            __cmplp.className
        ])
    });
});
const $1cf9b19799953994$var$BadgeWrapper = ({ children: children })=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), null, children, " ") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);

});
parcelRegister("16T6Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe7856b71523badd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $ehtcU = parcelRequire("ehtcU");
function $fe7856b71523badd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fe7856b71523badd$var$boxStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    blockSize: 'min-content',
    flexShrink: 0 // Text component can wrap text, this ensures it doesn't wrap in flex containers.
});
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $fe7856b71523badd$var$neutral300 = '#DDDEE1';
const $fe7856b71523badd$var$red300 = '#FD9891';
const $fe7856b71523badd$var$blue300 = '#8FB8F6';
const $fe7856b71523badd$var$neutral1000 = '#292A2E';
const $fe7856b71523badd$var$styles = {
    root: {
        name: "85bcg3",
        styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
    },
    added: {
        name: "4x7cmh",
        styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
    },
    default: /*#__PURE__*/ (0, $f8Sb3.css)({
        backgroundColor: $fe7856b71523badd$var$neutral300,
        color: $fe7856b71523badd$var$neutral1000
    }),
    important: /*#__PURE__*/ (0, $f8Sb3.css)({
        backgroundColor: $fe7856b71523badd$var$red300,
        color: $fe7856b71523badd$var$neutral1000
    }),
    primary: /*#__PURE__*/ (0, $f8Sb3.css)({
        backgroundColor: $fe7856b71523badd$var$blue300,
        color: $fe7856b71523badd$var$neutral1000
    }),
    primaryInverted: {
        name: "1425qmy",
        styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
    },
    removed: {
        name: "10hiq01",
        styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
    }
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $fe7856b71523badd$var$Badge = /*#__PURE__*/ (0, $5uXOq.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $VSDnB.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        "data-testid": testId,
        css: [
            $fe7856b71523badd$var$styles.root,
            $fe7856b71523badd$var$styles[appearance]
        ],
        style: {
            background: style?.backgroundColor,
            color: style?.color
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cgL5K.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, typeof children === 'number' && max ? (0, $ehtcU.formatValue)(children, max) : children));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        testId: testId,
        as: "span",
        backgroundColor: $fe7856b71523badd$var$backgroundColors[appearance],
        xcss: $fe7856b71523badd$var$boxStyles,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cgL5K.default), {
        size: "UNSAFE_small",
        align: "center",
        color: style?.color ? 'inherit' : $fe7856b71523badd$var$textColors[appearance]
    }, typeof children === 'number' && max ? (0, $ehtcU.formatValue)(children, max) : children));
});
$fe7856b71523badd$var$Badge.displayName = 'Badge';
var $fe7856b71523badd$export$2e2bcd8739ae039 = $fe7856b71523badd$var$Badge;
const $fe7856b71523badd$var$backgroundColors = {
    added: 'color.background.success',
    default: 'color.background.neutral',
    important: 'color.background.danger.bold',
    primary: 'color.background.brand.bold',
    primaryInverted: 'elevation.surface',
    removed: 'color.background.danger'
};
const $fe7856b71523badd$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("ehtcU", function(module, exports) {

$parcel$export(module.exports, "formatValue", () => $24d41a560822020b$export$7c4d25c0c3217d8c);
function $24d41a560822020b$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $24d41a560822020b$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $24d41a560822020b$var$getSafeValue(value);
    const safeMax = $24d41a560822020b$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("ek9Ll", function(module, exports) {

var $5uXOq = parcelRequire("5uXOq");
var $a6da819578d899ff$var$D = $5uXOq.createElement;

var $8NBjW = parcelRequire("8NBjW");

var $apVjs = parcelRequire("apVjs");
var $a6da819578d899ff$var$symbol = $5uXOq.createElement.bind(null, $apVjs);
var $a6da819578d899ff$var$TransitiveNumber = $8NBjW({
    getDefaultProps: function() {
        return {
            className: null,
            enableInitialAnimation: false
        };
    },
    render: function() {
        var value = this.props.children.toString();
        // Invert animation direction when negative number is supplied.
        var inverted = value[0] === '-';
        return $a6da819578d899ff$var$D('span', {
            className: this.props.className,
            style: {
                whiteSpace: 'pre'
            }
        }, value.split('').map(function(s, index) {
            return $a6da819578d899ff$var$symbol({
                symbol: s,
                inverted: inverted,
                enableInitialAnimation: this.props.enableInitialAnimation,
                key: index
            });
        }, this));
    }
});
module.exports = $a6da819578d899ff$var$TransitiveNumber;

});
parcelRegister("8NBjW", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $5uXOq = parcelRequire("5uXOq");

var $6Ksdh = parcelRequire("6Ksdh");
if (typeof $5uXOq === 'undefined') throw Error("create-react-class could not find the React object. If you are using script tags, make sure that React is being loaded before create-react-class.");
// Hack to grab NoopUpdateQueue from isomorphic React
var $667fd96c41381c5b$var$ReactNoopUpdateQueue = new $5uXOq.Component().updater;
module.exports = $6Ksdh($5uXOq.Component, $5uXOq.isValidElement, $667fd96c41381c5b$var$ReactNoopUpdateQueue);

});
parcelRegister("6Ksdh", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $9rcQv = parcelRequire("9rcQv");
// -- Inlined from fbjs --
var $4e9cec82047801f6$var$emptyObject = {};
var $4e9cec82047801f6$var$validateFormat = function validateFormat(format) {};
function $4e9cec82047801f6$var$_invariant(condition, format, a, b, c, d, e, f) {
    $4e9cec82047801f6$var$validateFormat(format);
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
}
var $4e9cec82047801f6$var$warning = function() {};
var $4e9cec82047801f6$var$printWarning;
// /-- Inlined from fbjs --
var $4e9cec82047801f6$var$MIXINS_KEY = 'mixins';
// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function $4e9cec82047801f6$var$identity(fn) {
    return fn;
}
var $4e9cec82047801f6$var$ReactPropTypeLocationNames;
$4e9cec82047801f6$var$ReactPropTypeLocationNames = {};
function $4e9cec82047801f6$var$factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
    /**
   * Policies that describe methods in `ReactClassInterface`.
   */ var injectedMixins = [];
    /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */ var ReactClassInterface = {
        /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */ mixins: 'DEFINE_MANY',
        /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */ statics: 'DEFINE_MANY',
        /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */ propTypes: 'DEFINE_MANY',
        /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */ contextTypes: 'DEFINE_MANY',
        /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */ childContextTypes: 'DEFINE_MANY',
        // ==== Definition methods ====
        /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */ getDefaultProps: 'DEFINE_MANY_MERGED',
        /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */ getInitialState: 'DEFINE_MANY_MERGED',
        /**
     * @return {object}
     * @optional
     */ getChildContext: 'DEFINE_MANY_MERGED',
        /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */ render: 'DEFINE_ONCE',
        // ==== Delegate methods ====
        /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */ componentWillMount: 'DEFINE_MANY',
        /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */ componentDidMount: 'DEFINE_MANY',
        /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */ componentWillReceiveProps: 'DEFINE_MANY',
        /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */ shouldComponentUpdate: 'DEFINE_ONCE',
        /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */ componentWillUpdate: 'DEFINE_MANY',
        /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */ componentDidUpdate: 'DEFINE_MANY',
        /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */ componentWillUnmount: 'DEFINE_MANY',
        /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */ UNSAFE_componentWillMount: 'DEFINE_MANY',
        /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */ UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
        /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */ UNSAFE_componentWillUpdate: 'DEFINE_MANY',
        // ==== Advanced methods ====
        /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */ updateComponent: 'OVERRIDE_BASE'
    };
    /**
   * Similar to ReactClassInterface but for static methods.
   */ var ReactClassStaticInterface = {
        /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */ getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
    };
    /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */ var RESERVED_SPEC_KEYS = {
        displayName: function(Constructor, displayName) {
            Constructor.displayName = displayName;
        },
        mixins: function(Constructor, mixins) {
            if (mixins) for(var i = 0; i < mixins.length; i++)mixSpecIntoComponent(Constructor, mixins[i]);
        },
        childContextTypes: function(Constructor, childContextTypes) {
            Constructor.childContextTypes = $9rcQv({}, Constructor.childContextTypes, childContextTypes);
        },
        contextTypes: function(Constructor, contextTypes) {
            Constructor.contextTypes = $9rcQv({}, Constructor.contextTypes, contextTypes);
        },
        /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */ getDefaultProps: function(Constructor, getDefaultProps) {
            if (Constructor.getDefaultProps) Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
            else Constructor.getDefaultProps = getDefaultProps;
        },
        propTypes: function(Constructor, propTypes) {
            Constructor.propTypes = $9rcQv({}, Constructor.propTypes, propTypes);
        },
        statics: function(Constructor, statics) {
            mixStaticSpecIntoComponent(Constructor, statics);
        },
        autobind: function() {}
    };
    function validateTypeDef(Constructor, typeDef, location) {
        for(var propName in typeDef)typeDef.hasOwnProperty(propName);
    }
    function validateMethodOverride(isAlreadyDefined, name) {
        var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
        // Disallow overriding of base class methods unless explicitly allowed.
        if (ReactClassMixin.hasOwnProperty(name)) $4e9cec82047801f6$var$_invariant(specPolicy === 'OVERRIDE_BASE', "ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.", name);
        // Disallow defining methods more than once unless explicitly allowed.
        if (isAlreadyDefined) $4e9cec82047801f6$var$_invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', "ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.", name);
    }
    /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */ function mixSpecIntoComponent(Constructor, spec) {
        if (!spec) {
            var typeofSpec, isMixinValid;
            return;
        }
        $4e9cec82047801f6$var$_invariant(typeof spec !== 'function', "ReactClass: You're attempting to use a component class or function as a mixin. Instead, just use a regular object.");
        $4e9cec82047801f6$var$_invariant(!isValidElement(spec), "ReactClass: You're attempting to use a component as a mixin. Instead, just use a regular object.");
        var proto = Constructor.prototype;
        var autoBindPairs = proto.__reactAutoBindPairs;
        // By handling mixins before any other properties, we ensure the same
        // chaining order is applied to methods with DEFINE_MANY policy, whether
        // mixins are listed before or after these methods in the spec.
        if (spec.hasOwnProperty($4e9cec82047801f6$var$MIXINS_KEY)) RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
        for(var name in spec){
            if (!spec.hasOwnProperty(name)) continue;
            if (name === $4e9cec82047801f6$var$MIXINS_KEY) continue;
            var property = spec[name];
            var isAlreadyDefined = proto.hasOwnProperty(name);
            validateMethodOverride(isAlreadyDefined, name);
            if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) RESERVED_SPEC_KEYS[name](Constructor, property);
            else {
                // Setup methods on prototype:
                // The following member methods should not be automatically bound:
                // 1. Expected ReactClass methods (in the "interface").
                // 2. Overridden methods (that were mixed in).
                var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
                var isFunction = typeof property === 'function';
                var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
                if (shouldAutoBind) {
                    autoBindPairs.push(name, property);
                    proto[name] = property;
                } else if (isAlreadyDefined) {
                    var specPolicy = ReactClassInterface[name];
                    // These cases should already be caught by validateMethodOverride.
                    $4e9cec82047801f6$var$_invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), "ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.", specPolicy, name);
                    // For methods which are defined more than once, call the existing
                    // methods before calling the new property, merging if appropriate.
                    if (specPolicy === 'DEFINE_MANY_MERGED') proto[name] = createMergedResultFunction(proto[name], property);
                    else if (specPolicy === 'DEFINE_MANY') proto[name] = createChainedFunction(proto[name], property);
                } else proto[name] = property;
            }
        }
    }
    function mixStaticSpecIntoComponent(Constructor, statics) {
        if (!statics) return;
        for(var name in statics){
            var property = statics[name];
            if (!statics.hasOwnProperty(name)) continue;
            var isReserved = name in RESERVED_SPEC_KEYS;
            $4e9cec82047801f6$var$_invariant(!isReserved, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name);
            var isAlreadyDefined = name in Constructor;
            if (isAlreadyDefined) {
                var specPolicy = ReactClassStaticInterface.hasOwnProperty(name) ? ReactClassStaticInterface[name] : null;
                $4e9cec82047801f6$var$_invariant(specPolicy === 'DEFINE_MANY_MERGED', "ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.", name);
                Constructor[name] = createMergedResultFunction(Constructor[name], property);
                return;
            }
            Constructor[name] = property;
        }
    }
    /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */ function mergeIntoWithNoDuplicateKeys(one, two) {
        $4e9cec82047801f6$var$_invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');
        for(var key in two)if (two.hasOwnProperty(key)) {
            $4e9cec82047801f6$var$_invariant(one[key] === undefined, "mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.", key);
            one[key] = two[key];
        }
        return one;
    }
    /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */ function createMergedResultFunction(one, two) {
        return function mergedResult() {
            var a = one.apply(this, arguments);
            var b = two.apply(this, arguments);
            if (a == null) return b;
            else if (b == null) return a;
            var c = {};
            mergeIntoWithNoDuplicateKeys(c, a);
            mergeIntoWithNoDuplicateKeys(c, b);
            return c;
        };
    }
    /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */ function createChainedFunction(one, two) {
        return function chainedFunction() {
            one.apply(this, arguments);
            two.apply(this, arguments);
        };
    }
    /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */ function bindAutoBindMethod(component, method) {
        var boundMethod = method.bind(component);
        var componentName, _bind;
        return boundMethod;
    }
    /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */ function bindAutoBindMethods(component) {
        var pairs = component.__reactAutoBindPairs;
        for(var i = 0; i < pairs.length; i += 2){
            var autoBindKey = pairs[i];
            var method = pairs[i + 1];
            component[autoBindKey] = bindAutoBindMethod(component, method);
        }
    }
    var IsMountedPreMixin = {
        componentDidMount: function() {
            this.__isMounted = true;
        }
    };
    var IsMountedPostMixin = {
        componentWillUnmount: function() {
            this.__isMounted = false;
        }
    };
    /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */ var ReactClassMixin = {
        /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */ replaceState: function(newState, callback) {
            this.updater.enqueueReplaceState(this, newState, callback);
        },
        /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */ isMounted: function() {
            return !!this.__isMounted;
        }
    };
    var ReactClassComponent = function() {};
    $9rcQv(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
    /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */ function createClass(spec) {
        // To keep our warnings more understandable, we'll use a little hack here to
        // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
        // unnecessarily identify a class without displayName as 'Constructor'.
        var Constructor = $4e9cec82047801f6$var$identity(function(props, context, updater) {
            // Wire up auto-binding
            if (this.__reactAutoBindPairs.length) bindAutoBindMethods(this);
            this.props = props;
            this.context = context;
            this.refs = $4e9cec82047801f6$var$emptyObject;
            this.updater = updater || ReactNoopUpdateQueue;
            this.state = null;
            // ReactClasses doesn't have constructors. Instead, they use the
            // getInitialState and componentWillMount methods for initialization.
            var initialState = this.getInitialState ? this.getInitialState() : null;
            $4e9cec82047801f6$var$_invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');
            this.state = initialState;
        });
        Constructor.prototype = new ReactClassComponent();
        Constructor.prototype.constructor = Constructor;
        Constructor.prototype.__reactAutoBindPairs = [];
        injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
        mixSpecIntoComponent(Constructor, IsMountedPreMixin);
        mixSpecIntoComponent(Constructor, spec);
        mixSpecIntoComponent(Constructor, IsMountedPostMixin);
        // Initialize the defaultProps property after all mixins have been merged.
        if (Constructor.getDefaultProps) Constructor.defaultProps = Constructor.getDefaultProps();
        $4e9cec82047801f6$var$_invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');
        // Reduce time spent doing lookups by setting these on the prototype.
        for(var methodName in ReactClassInterface)if (!Constructor.prototype[methodName]) Constructor.prototype[methodName] = null;
        return Constructor;
    }
    return createClass;
}
module.exports = $4e9cec82047801f6$var$factory;

});


parcelRegister("apVjs", function(module, exports) {

var $5uXOq = parcelRequire("5uXOq");
var $7958b2515b96b0db$var$D = $5uXOq.createElement;

var $7nsd3 = parcelRequire("7nsd3");
var $7958b2515b96b0db$require$findDOMNode = $7nsd3.findDOMNode;

var $8NBjW = parcelRequire("8NBjW");

var $4AVfd = parcelRequire("4AVfd");
var $7958b2515b96b0db$var$transition = $5uXOq.createElement.bind(null, $4AVfd);
var $7958b2515b96b0db$var$Symbol = $8NBjW({
    getInitialState: function() {
        return {
            previous: null,
            decrementing: false,
            initialRender: true
        };
    },
    componentDidMount: function() {
        $7958b2515b96b0db$require$findDOMNode(this).addEventListener('transitionend', this.removePrevious);
    },
    componentWillUnmount: function() {
        $7958b2515b96b0db$require$findDOMNode(this).removeEventListener('transitionend', this.removePrevious);
    },
    componentWillReceiveProps: function(nextProps) {
        if (nextProps.symbol !== this.props.symbol) {
            var decrementing = $7958b2515b96b0db$var$isDecrementing(this.props.symbol, nextProps.symbol);
            this.setState({
                previous: this.props.symbol,
                decrementing: this.props.inverted ? !decrementing : decrementing,
                initialRender: false
            });
        }
    },
    shouldComponentUpdate: function(nextProps, nextState) {
        return nextProps.symbol !== this.props.symbol || nextState.previous !== this.state.previous;
    },
    removePrevious: function() {
        this.setState({
            previous: null
        });
    },
    render: function() {
        return $7958b2515b96b0db$var$D('span', {
            style: {
                position: 'relative',
                display: 'inline-block'
            }
        }, // Have to render this transparent spacer span to mitigate the issue
        // when Safari would not animate transition if changing `position`
        // from `absolute` to `static`.
        this.renderSpacer(), this.renderTransitionIn(), this.renderTransitionOut());
    },
    renderSpacer: function() {
        return $7958b2515b96b0db$var$D('span', {
            style: {
                visibility: 'hidden'
            }
        }, this.props.symbol);
    },
    renderTransitionIn: function() {
        return $7958b2515b96b0db$var$transition({
            value: this.props.symbol,
            goingUp: this.state.decrementing,
            animateEntrance: this.state.initialRender ? this.props.enableInitialAnimation : true,
            key: this.props.symbol
        });
    },
    renderTransitionOut: function() {
        if (this.state.previous !== null) return $7958b2515b96b0db$var$transition({
            value: this.state.previous,
            goingUp: this.state.decrementing,
            out: true,
            key: this.state.previous
        });
        return null;
    }
});
module.exports = $7958b2515b96b0db$var$Symbol;
function $7958b2515b96b0db$var$isDecrementing(a, b) {
    var numberA = Number(a);
    var numberB = Number(b);
    // Special case when going from 9 or 6 to 0 (and back).
    if (Math.abs(numberB - numberA) !== 1) return numberA === 0;
    else return numberB < numberA;
}

});
parcelRegister("4AVfd", function(module, exports) {

var $5uXOq = parcelRequire("5uXOq");
var $3586edc556045d57$var$D = $5uXOq.createElement;

var $7nsd3 = parcelRequire("7nsd3");
var $3586edc556045d57$require$findDOMNode = $7nsd3.findDOMNode;

var $8NBjW = parcelRequire("8NBjW");
var $3586edc556045d57$var$Transition = $8NBjW({
    getInitialState: function() {
        return {
            in: this.props.out ? true : !this.props.animateEntrance
        };
    },
    componentDidMount: function() {
        this._timeout = $3586edc556045d57$var$raf(this.tada);
    },
    componentWillUnmount: function() {
        $3586edc556045d57$var$caf(this._timeout);
    },
    tada: function() {
        // Force element reflow to ensure correct animation in FF.
        $3586edc556045d57$require$findDOMNode(this).offsetWidth;
        this.setState({
            in: true
        });
    },
    getAppearance: function() {
        var transform = this.getTransform();
        return {
            display: 'inline-block',
            // Can't dynamically change `position` from `absolute` to `static` -
            // it will break transition animation in Safari.
            position: 'absolute',
            left: 0,
            WebkitTransition: '-webkit-transform 0.2s, opacity 0.2s',
            transition: 'transform 0.2s, opacity 0.2s',
            WebkitTransform: transform,
            transform: transform,
            opacity: this.isHidden() ? 0 : 1,
            pointerEvents: 'none'
        };
    },
    getTransform: function() {
        if (this.props.out) return $3586edc556045d57$var$translateY(this.props.goingUp);
        if (!this.state.in) return $3586edc556045d57$var$translateY(!this.props.goingUp);
        // This has better text rendering in FF than simply `none`.
        return 'translateY(0) translateZ(0)';
    },
    isHidden: function() {
        return this.props.out || !this.state.in;
    },
    render: function() {
        return $3586edc556045d57$var$D('span', {
            style: this.getAppearance()
        }, this.props.value);
    }
});
module.exports = $3586edc556045d57$var$Transition;
function $3586edc556045d57$var$raf(fn) {
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(fn);
    else return setTimeout(fn, 0);
}
function $3586edc556045d57$var$caf(timer) {
    if (typeof window.cancelAnimationFrame === 'function') return window.cancelAnimationFrame(timer);
    else return clearTimeout(timer);
}
function $3586edc556045d57$var$translateY(isUp) {
    return 'translateY(' + (isUp ? '-' : '') + '60%) translateZ(0)';
}

});





parcelRegister("lVBgn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9ad1ae8340c6e0a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bjo8S = parcelRequire("bjo8S");

var $kbxJz = parcelRequire("kbxJz");


var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $3eBvl = parcelRequire("3eBvl");
const $d9ad1ae8340c6e0a$var$DoneColumnTick = ()=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9ad1ae8340c6e0a$var$Container, {
        "data-test-id": "platform-board-kit.common.ui.column-header.editable-title.done-column-tick.done-column-tick",
        "data-testid": "platform-board-kit.common.ui.column-header.editable-title.done-column-tick.done-column-tick"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3eBvl.messages).doneTickTooltipIssueTermRefresh : (0, $3eBvl.messages).doneTickTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bjo8S))), {
        label: "",
        color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G400})`,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kbxJz))),
        LEGACY_primaryColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G400})`,
        LEGACY_size: "small"
    })));
};
var $d9ad1ae8340c6e0a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $d9ad1ae8340c6e0a$var$DoneColumnTick;
const $d9ad1ae8340c6e0a$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _vwz4kb7n _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::209317c625743d387bf26edea0c296a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_UNSAFE_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});

parcelRegister("kbxJz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb1f0098e5a023eb$var$_react = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $eb1f0098e5a023eb$var$_checkMark = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $eb1f0098e5a023eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eb1f0098e5a023eb$var$CheckIcon = (props)=>/*#__PURE__*/ $eb1f0098e5a023eb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $eb1f0098e5a023eb$var$_checkMark.default
    }));
$eb1f0098e5a023eb$var$CheckIcon.displayName = 'CheckIcon';
var $eb1f0098e5a023eb$var$_default = module.exports.default = $eb1f0098e5a023eb$var$CheckIcon;

});

parcelRegister("3eBvl", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f9d9c0ba3f191971$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f9d9c0ba3f191971$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    doneTickTooltip: {
        "id": "platform-board-kit.common.column-header.editable-title.done-column-tick.done-tick-tooltip",
        "defaultMessage": "Issues moved to this column are marked as done"
    },
    doneTickTooltipIssueTermRefresh: {
        "id": "platform-board-kit.common.column-header.editable-title.done-column-tick.done-tick-tooltip-issue-term-refresh",
        "defaultMessage": "Issues moved to this column are marked as done"
    }
});

});


parcelRegister("8BBAt", function(module, exports) {

$parcel$export(module.exports, "default", () => $47d471dd5033fa83$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $8Rkzz = parcelRequire("8Rkzz");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gSExi = parcelRequire("gSExi");

var $heNNl = parcelRequire("heNNl");

var $co1wz = parcelRequire("co1wz");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $47d471dd5033fa83$var$AsyncInlineEdit = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("egkNH")), {
    moduleId: "../platform/packages/design-system/inline-edit/src/index.ts"
});
class $47d471dd5033fa83$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            onOuterClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    componentDidMount() {
        if (this.props.isEditing) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('click', this.onWindowMouseClick, true);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.isEditing !== nextProps.isEditing) {
            if (nextProps.isEditing) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.addEventListener('click', this.onWindowMouseClick, true);
            else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('click', this.onWindowMouseClick, true);
        }
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('click', this.onWindowMouseClick, true);
    }
    render() {
        const { readView: readView, onConfirm: onConfirm, onCancel: onCancel, onOuterClick: onOuterClick, ...otherProps } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
            id: "async-column-inline-edit",
            packageName: "JiraPlatformBoardKit"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47d471dd5033fa83$var$InlineEditContainer, {
            innerRef: this.setContainer,
            onClick: (event)=>event.stopPropagation()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "async-board-inline-edit",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $47d471dd5033fa83$var$readViewWrapperStyles
            }, readView())
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47d471dd5033fa83$var$AsyncInlineEdit, {
            readView: readView,
            onCancel: onCancel,
            onConfirm: onConfirm,
            ...otherProps
        }))));
    }
    constructor(...args){
        super(...args);
        this.onWindowMouseClick = (event)=>{
            if (!(event.target instanceof Node) || !this.container?.contains(event.target)) this.props.onOuterClick(event);
        };
        this.setContainer = (container)=>{
            this.container = container;
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $47d471dd5033fa83$var$InlineEditContainerControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "xb0li-0"
})({
    maxWidth: '100%',
    marginTop: "var(--ds-space-negative-100, -8px)",
    /* hacking atlaskit to get ellipsis working properly */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '.msie-11 &': {
        marginBottom: "var(--ds-space-negative-050, -4px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'input:-ms-input-placeholder': {
            color: 'transparent'
        }
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $47d471dd5033fa83$var$InlineEditContainerExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1osq _19pkx0bf _1u1tidpf _b64vr5cr _mp8c3acm",
            __cmplp.className
        ])
    });
});
const $47d471dd5033fa83$var$InlineEditContainer = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $47d471dd5033fa83$var$InlineEditContainerExperiment, $47d471dd5033fa83$var$InlineEditContainerControl);
const $47d471dd5033fa83$var$readViewWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100',
    marginLeft: 'space.100',
    marginRight: 'space.025',
    paddingLeft: 'space.025'
});

});
parcelRegister("egkNH", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("jrgrr").then(()=>parcelRequire('97SvH'));

});



parcelRegister("5k6Fi", function(module, exports) {

$parcel$export(module.exports, "default", () => $6987b2aef6aceebd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $eZJjh = parcelRequire("eZJjh");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $645AZ = parcelRequire("645AZ");

var $3kNE6 = parcelRequire("3kNE6");

var $g503o = parcelRequire("g503o");
const $6987b2aef6aceebd$var$ColumnHeaderContainerControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1k8t1g3-0"
})((props)=>({
        userSelect: 'none',
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        height: `${0, $645AZ.columnHeaderHeight}px`,
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.theme.background,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderTopLeftRadius: `${(0, $645AZ.layout).cardListRadius}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderTopRightRadius: `${(0, $645AZ.layout).cardListRadius}px`,
        transition: 'background-color 0.2s ease',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: props.isDraggable ? 'grab' : 'default',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& .agility-column-menu-meatball': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            position: props.isMenuShown ? 'initial' : 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            visibility: props.isMenuShown ? 'initial' : 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            opacity: props.isMenuShown ? '1' : '0',
            transition: 'opacity 0s linear 0.3s',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& > div': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: props.theme.background
            }
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& .agility-column-menu-meatball': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                position: props.canShowMenu ? 'initial' : 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                visibility: props.canShowMenu ? 'initial' : 'hidden',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                opacity: props.canShowMenu ? '1' : '0'
            }
        }
    }));
const $6987b2aef6aceebd$var$ColumnHeaderContainerExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, isDraggable: isDraggable, isMenuShown: isMenuShown, canShowMenu: canShowMenu, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_bcgr60": (0, $lD23V.default)((0, $g503o.columnThemes)[__cmplp.appearance].background)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_uiztglyw _1bsb1osq _p12f1osq _vchhusvi _4t3ickbl _kqswh2mm _bfhketez _13lii2wt _qrwqi2wt _v564mfn2 _hhkl1j1k _1lvfetez",
            __cmplp.isDraggable ? "_80om1qgj" : "_80om73ad",
            __cmplp.isMenuShown ? "_1bwqpfqs" : "_1bwqstnw",
            __cmplp.isMenuShown ? "_pj6m18uv" : "_pj6m15vq",
            __cmplp.isMenuShown ? "_djaikb7n" : "_djaiidpf",
            __cmplp.canShowMenu ? "_1a1dpfqs" : "_1a1dstnw",
            __cmplp.canShowMenu ? "_1tye18uv" : "_1tye15vq",
            __cmplp.canShowMenu ? "_5d7zkb7n" : "_5d7zidpf",
            __cmplp.className
        ])
    });
});
const $6987b2aef6aceebd$var$ColumnHeaderContainer = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $6987b2aef6aceebd$var$ColumnHeaderContainerExperiment, $6987b2aef6aceebd$var$ColumnHeaderContainerControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6987b2aef6aceebd$var$ColumnHeaderActions = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswstnw _1xi2u2gc _154i1ejb _t9ec1i34",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6987b2aef6aceebd$var$SpinnerContainerControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1k8t1g3-1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingRight: `${(0, $645AZ.layout).gutter}px`
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6987b2aef6aceebd$var$SpinnerContainerExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f319bv",
            __cmplp.className
        ])
    });
});
const $6987b2aef6aceebd$var$SpinnerContainer = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $6987b2aef6aceebd$var$SpinnerContainerExperiment, $6987b2aef6aceebd$var$SpinnerContainerControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6987b2aef6aceebd$var$TitleWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _1bah1h6o _4cvr1fhb _16jlkb7n _1o9zkb7n _i0dl1wug _1wpz1wug _p12f1osq _1yt4zu5n _1bsb1osq _4t3i1j2a _7ehi2jkb _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});
class $6987b2aef6aceebd$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isDragging: false,
            isDraggable: false,
            isSpinnerVisible: false,
            isMenuEnabled: true,
            isEditingTitle: false
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.isDragging !== this.props.isDragging && nextProps.isDragging && this.state.isMenuOpen) this.setState({
            isMenuOpen: false
        });
    }
    render() {
        const { title: title, isSpinnerVisible: isSpinnerVisible, isDraggable: isDraggable, onClick: onClick, OverlayContent: OverlayContent, appearance: appearance } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6987b2aef6aceebd$var$ColumnHeaderContainer, {
            onClick: onClick,
            canShowMenu: this.canShowMenu(),
            isMenuShown: this.props.isMenuShown != null ? this.props.isMenuShown : this.state.isMenuOpen,
            isDraggable: isDraggable,
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            appearance: appearance ?? (0, $3kNE6.ColumnTheme).Default,
            "data-testid": "platform-board-kit.common.ui.column-header.header.column-header-container"
        }, OverlayContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OverlayContent, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6987b2aef6aceebd$var$TitleWrapper, null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6987b2aef6aceebd$var$ColumnHeaderActions // Prevent menu click to bubble up and fire header analytic event.
        , {
            onClick: (event)=>event.stopPropagation()
        }, this.renderMenu(), isSpinnerVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6987b2aef6aceebd$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "small"
        }))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isMenuOpen: false
        };
        this.timeoutId = null;
        this.onMenuOpenChange = (attrs)=>{
            this.setState({
                isMenuOpen: attrs.isOpen
            });
        };
        this.hasTemporaryId = ()=>Number(this.props.id) <= 0;
        this.canShowMenu = ()=>this.props.isMenuEnabled && !this.hasTemporaryId() && !this.props.isEditingTitle && !this.props.isDragging;
        this.renderMenu = ()=>{
            const { titleHeadingText: titleHeadingText } = this.props;
            if (this.props.menu) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            , {
                className: "agility-column-menu-meatball",
                "data-test-id": "platform-board-kit.common.ui.column-header.header.meatball",
                "data-testid": "platform-board-kit.common.ui.column-header.header.meatball"
            }, /*#__PURE__*/ (0, $5uXOq.cloneElement)(this.props.menu, {
                title: titleHeadingText,
                onOpenChange: this.onMenuOpenChange
            }));
            return null;
        };
        this.onFocus = ()=>{
            this.timeoutId && clearTimeout(this.timeoutId);
            if (!this.state.isMenuOpen && this.canShowMenu()) this.setState({
                isMenuOpen: true
            });
        };
        this.onBlur = ()=>{
            this.timeoutId = setTimeout(()=>{
                if (this.state.isMenuOpen) this.setState({
                    isMenuOpen: false
                });
            }, 0);
        };
    }
}

});

parcelRegister("16E0T", function(module, exports) {

$parcel$export(module.exports, "ColumnHeaderWrapper", () => $dfaa058e2b80d56e$export$381ca84651f316ee);
$parcel$export(module.exports, "default", () => $dfaa058e2b80d56e$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");


var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $kVOOl = parcelRequire("kVOOl");

var $euZim = parcelRequire("euZim");

var $645AZ = parcelRequire("645AZ");

var $3kNE6 = parcelRequire("3kNE6");

var $ilwFs = parcelRequire("ilwFs");

var $guHkC = parcelRequire("guHkC");

var $8gMyk = parcelRequire("8gMyk");

var $6crUM = parcelRequire("6crUM");

var $5k6Fi = parcelRequire("5k6Fi");
class $dfaa058e2b80d56e$export$5667c09b71ee0f05 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            isRenamable: true,
            isShadowVisible: false,
            isDragging: false,
            isUpdating: false,
            isDisabled: false,
            isDone: false,
            cardsCount: 0,
            totalCardsCount: 0,
            showTotalCardsCount: false,
            lozenges: null,
            validateRename: ()=>({
                    isValid: true,
                    message: null
                }),
            appearance: 'default',
            isCMPboard: false,
            isFlexibleColumns: false,
            shouldRemoveSpaceForMenu: false
        };
    }
    getColumnLozenges(lozenges) {
        if (!lozenges || lozenges.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8gMyk.default), {
            lozenges: lozenges,
            appearance: this.props.appearance
        });
    }
    render() {
        const { id: id, title: title, lozenges: lozenges, isShadowVisible: isShadowVisible, isUpdating: isUpdating, isDisabled: isDisabled, isDragging: isDragging, isRenamable: isRenamable, isDraggable: isDraggable, cardsCount: cardsCount, totalCardsCount: totalCardsCount, showTotalCardsCount: showTotalCardsCount, validateRename: validateRename, menu: menu, OverlayContent: OverlayContent, isMenuShown: isMenuShown, isDone: isDone, isCMPBoard: isCMPBoard, shouldRemoveSpaceForMenu: shouldRemoveSpaceForMenu, isFlexibleColumns: isFlexibleColumns } = this.props;
        const { isEditingTitle: isEditingTitle } = this.state;
        const isTitleDisabled = isDisabled || isDragging || !isRenamable;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dfaa058e2b80d56e$export$381ca84651f316ee, {
            isDragging: isDragging,
            isShadowVisible: isShadowVisible,
            isFlexibleColumns: isFlexibleColumns
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5k6Fi.default), {
            id: id,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6crUM.default), {
                columnId: id,
                text: title,
                visibleCount: cardsCount || 0,
                totalCount: totalCardsCount,
                showTotalCount: showTotalCardsCount,
                isDisabled: isTitleDisabled,
                onEditChange: this.onColumnTitleEditChange,
                onConfirm: this.props.onRename,
                onCancel: this.onColumnTitleEditCancel,
                lozenges: this.getColumnLozenges(lozenges),
                validateColumn: validateRename,
                isDone: isDone,
                isCMPBoard: isCMPBoard,
                shouldRemoveSpaceForMenu: shouldRemoveSpaceForMenu
            }),
            titleHeadingText: title,
            isEditingTitle: isEditingTitle,
            isMenuShown: isMenuShown,
            isSpinnerVisible: isUpdating,
            isDragging: isDragging,
            isDraggable: isDraggable,
            menu: menu,
            onClick: this.onHeaderClick,
            OverlayContent: OverlayContent,
            appearance: this.props.appearance
        }), (isUpdating || isDisabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $guHkC.Overlay), {
            appearance: this.props.appearance ?? (0, $3kNE6.ColumnTheme).Default
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isEditingTitle: false
        };
        this.onColumnTitleEditChange = (isEditingTitle)=>{
            this.setState({
                isEditingTitle: isEditingTitle
            });
            if (isEditingTitle && this.props.onEditStart) this.props.onEditStart();
        };
        this.onColumnTitleEditCancel = (columnId, type)=>{
            this.props.onEditCancel && this.props.onEditCancel(columnId, type);
        };
        this.onHeaderClick = ()=>{
            this.props.onHeaderClick && this.props.onHeaderClick();
        };
    }
}
const $dfaa058e2b80d56e$var$ColumnHeaderMain = ({ showShadowOnScroll: showShadowOnScroll, ...props })=>{
    const [hasScrollTop] = (0, $euZim.useBoardHasScrollTop)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dfaa058e2b80d56e$export$5667c09b71ee0f05, {
        ...props,
        isShadowVisible: showShadowOnScroll && hasScrollTop
    });
};
var $dfaa058e2b80d56e$export$2e2bcd8739ae039 // eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
 = $dfaa058e2b80d56e$var$ColumnHeaderMain;
const $dfaa058e2b80d56e$var$ColumnHeaderContainerBaseControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "pgq31z-0"
})((props)=>({
        height: 'unset',
        display: 'flex',
        flexFlow: 'column nowrap',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $645AZ.zIndex).stickyHeaders,
        container: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        props.isFlexibleColumns ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `${$kVOOl["column-header"]} / inline-size` : undefined
    })); // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $dfaa058e2b80d56e$var$getColumnHeaderContainerBackground = (isDragging)=>{
    if (isDragging) return 'none';
    return `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N0})`;
};
const $dfaa058e2b80d56e$var$ColumnHeaderWrapperControl = (0, $ilwFs.isStickySupported) ? (0, $47bDC.default)($dfaa058e2b80d56e$var$ColumnHeaderContainerBaseControl).withConfig({
    componentId: "pgq31z-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        position: props.isDragging ? 'relative' : 'sticky',
        /*
           When column has scroll top < 0, column content is displayed underneath header,
           and as column content has grey background, rounded corners are gone.
           background-color: white is used to overlay column content => keep header corners rounded.
         */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: $dfaa058e2b80d56e$var$getColumnHeaderContainerBackground(props.isDragging),
        top: 0,
        borderRadius: '6px',
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            opacity: props.isShadowVisible ? 0.2 : 0,
            transition: 'opacity 0.2s',
            content: "''",
            position: 'absolute',
            bottom: "var(--ds-space-negative-025, -2px)",
            left: 0,
            right: 0,
            height: '2px',
            pointerEvents: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor: `var(--ds-blanket, ${(0, $829f609a65d26a98$exports).N80})`
        }
    })) : (0, $47bDC.default)($dfaa058e2b80d56e$var$ColumnHeaderContainerBaseControl).withConfig({
    componentId: "pgq31z-2"
})({
    position: 'relative',
    borderRadius: '6px'
});
const $dfaa058e2b80d56e$var$ColumnHeaderWrapperBaseExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexibleColumns: isFlexibleColumns, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1o3jvi5": (0, $lD23V.default)($kVOOl["column-header"])
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3in7od _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _4cvr1fhb _1pbyegat",
            __cmplp.isFlexibleColumns && "_ylxr1dzp",
            __cmplp.className
        ])
    });
});
const $dfaa058e2b80d56e$var$ColumnHeaderWrapperExperiment = (0, $ilwFs.isStickySupported) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $dfaa058e2b80d56e$var$ColumnHeaderWrapperBaseExperiment, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7glyw _154iidpf _2rkoi2wt _pdyk1p41 _1kt9b3bt _1cs8stnw _19wo1i6y _qnecidpf _oounidpf _kfgtyh40 _dsq4glyw _1rus1wdb",
            __cmplp.isDragging ? "_kqswh2mm" : "_kqsw1if8",
            __cmplp.isShadowVisible ? "_154psxj9" : "_154pidpf",
            __cmplp.className
        ])
    });
}) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $dfaa058e2b80d56e$var$ColumnHeaderWrapperBaseExperiment, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _2rkoi2wt",
            __cmplp.className
        ])
    });
});
const $dfaa058e2b80d56e$export$381ca84651f316ee = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $dfaa058e2b80d56e$var$ColumnHeaderWrapperExperiment, $dfaa058e2b80d56e$var$ColumnHeaderWrapperControl);

});
parcelRegister("guHkC", function(module, exports) {

$parcel$export(module.exports, "Overlay", () => $424069e3781e7d10$export$c6fdb837b070b4ff);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $gSExi = parcelRequire("gSExi");

var $f9Owr = parcelRequire("f9Owr");

var $g503o = parcelRequire("g503o");
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $424069e3781e7d10$var$OverlayControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1ehg2v8-0"
})((props)=>({
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.theme.background,
        opacity: 0.5
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $424069e3781e7d10$var$OverlayExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_12nboa5": (0, $lD23V.default)((0, $g503o.columnThemes)[__cmplp.appearance].background)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf _tzy4105o",
            __cmplp.appearance ? "_bfhkqo2f" : "_bfhk73ad",
            __cmplp.className
        ])
    });
});
const $424069e3781e7d10$export$c6fdb837b070b4ff = (0, $gSExi.styledComponentWithCondition)(()=>(0, $f9Owr.ff)('compiled.migration.jsw.tanuki'), $424069e3781e7d10$var$OverlayExperiment, $424069e3781e7d10$var$OverlayControl);

});

parcelRegister("8gMyk", function(module, exports) {

$parcel$export(module.exports, "default", () => $47152e7cdab543be$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $lj8SI = parcelRequire("lj8SI");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $koVbs = parcelRequire("koVbs");

var $kVOOl = parcelRequire("kVOOl");

var $b8gJu = parcelRequire("b8gJu");

var $3kNE6 = parcelRequire("3kNE6");
const $47152e7cdab543be$var$lozengeTypeAppearance = {
    maximum: 'removed',
    minimum: 'moved'
};
const $47152e7cdab543be$var$lozengeAppearanceMap = {
    default: 'default',
    warning: 'moved',
    danger: 'removed'
};
function $47152e7cdab543be$export$89e31ef8e83a0330(message, formatMessage) {
    if (message instanceof Object) return formatMessage(message.tooltip);
    return String(message);
}
function $47152e7cdab543be$export$d1dcfd32a1d228ca(// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
columnAppearance, lozenge) {
    if (typeof lozenge !== 'object' || !('type' in lozenge)) return $47152e7cdab543be$var$lozengeAppearanceMap[columnAppearance ?? (0, $3kNE6.ColumnTheme).Default];
    if (columnAppearance === (0, $3kNE6.ColumnTheme).Default || lozenge.type == null) return 'default';
    const typeToAp = {
        maximum: 'danger',
        minimum: 'warning'
    };
    if (lozenge.type && typeToAp[lozenge.type] === columnAppearance) return $47152e7cdab543be$var$lozengeTypeAppearance[lozenge.type];
    return 'default';
}
function $47152e7cdab543be$export$4420ac7a34197e42(// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
columnAppearance, lozenge) {
    // We need to override warning colors on this case only because of design
    // system differences with our warning color design.
    const minimumBustedColumn = columnAppearance === (0, $3kNE6.ColumnTheme).Warning && typeof lozenge === 'object' && 'type' in lozenge && lozenge.type === 'minimum' && lozenge.busted;
    return minimumBustedColumn ? "var(--ds-background-warning-bold, #e2b203)" : undefined;
}
function $47152e7cdab543be$export$e69df631f99524e6(lozenge) {
    return typeof lozenge === 'object' && 'busted' in lozenge ? Boolean(lozenge.busted) : false;
}
function $47152e7cdab543be$export$7084996b13185bfe({ lozenge: lozenge, appearance: columnAppearance }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const lozengeAppearance = $47152e7cdab543be$export$d1dcfd32a1d228ca(columnAppearance, lozenge);
    const isBold = $47152e7cdab543be$export$e69df631f99524e6(lozenge);
    const style = {
        backgroundColor: $47152e7cdab543be$export$4420ac7a34197e42(columnAppearance, lozenge)
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: lozengeAppearance === 'default' ? (0, (/*@__PURE__*/$parcel$interopDefault($kVOOl))).defaultLozengeContainer : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: $47152e7cdab543be$export$89e31ef8e83a0330(lozenge, formatMessage)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: lozengeAppearance,
        isBold: isBold,
        testId: "platform-board-kit.common.ui.column-header.editable-title.column-title.lozanges.lozenge" // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        ,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($kVOOl))).defaultLozenge
    }, lozenge instanceof Object ? formatMessage(lozenge.descriptor, lozenge.values) : String(lozenge)), lozengeAppearance !== 'default' && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($kVOOl))).compactLozenge
    }, lozenge instanceof Object ? lozenge.values.count : String(lozenge))))));
}
function $47152e7cdab543be$var$ColumnTitleLozenges({ appearance: appearance, lozenges: lozenges }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47152e7cdab543be$var$LozengeWrapper, {
        "data-test-id": "platform-board-kit.common.ui.column-header.editable-title.column-title.lozanges.lozenge-wrapper",
        "data-testid": "platform-board-kit.common.ui.column-header.editable-title.column-title.lozanges.lozenge-wrapper",
        "data-component-selector": (0, $b8gJu.COLUMN_TITLE_LOZENGES_SELECTOR_NAME)
    }, lozenges.map((lozenge, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47152e7cdab543be$export$7084996b13185bfe, {
            appearance: appearance,
            lozenge: lozenge,
            key: index
        })));
}
var $47152e7cdab543be$export$2e2bcd8739ae039 // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
 = $47152e7cdab543be$var$ColumnTitleLozenges;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $47152e7cdab543be$var$LozengeWrapperControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1goqpa7-0"
})`display:flex;gap:${(0, $gwIPs.gridSize)}px;padding-left:${"var(--ds-space-100, 8px)"};`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $47152e7cdab543be$var$LozengeWrapperExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _zulpftgi _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $47152e7cdab543be$var$LozengeWrapper = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $47152e7cdab543be$var$LozengeWrapperExperiment, $47152e7cdab543be$var$LozengeWrapperControl);

});




parcelRegister("9USr3", function(module, exports) {

$parcel$export(module.exports, "useRegisterNudgeTarget", () => $1aa5136c8225a4e1$export$eb8a96124d659f2d);
$parcel$export(module.exports, "PortalledNudge", () => $1aa5136c8225a4e1$export$74f8d45d75dfda4f);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $fqbGj = parcelRequire("fqbGj");
/**
 * This class tracks nudge target HTML DOM elements by ID.
 * It also tracks subscribers to updates of these elements.
 */ class $1aa5136c8225a4e1$var$NudgeController {
    static{
        /**
	 * Singleton instance of this class.
	 * Alternatively multiple instances would be created and passed through context.
	 */ this.instance = new $1aa5136c8225a4e1$var$NudgeController();
    }
    /**
	 * Register the HTML DOM node for an ID
	 */ registerNudgeTarget(id, ref) {
        this.nudgeTargetsMap.set(id, ref);
        this.notifySubscribers(id);
        // Return a cleanup function that will remove this ID from the map
        return ()=>{
            this.nudgeTargetsMap.delete(id);
        };
    }
    /**
	 * Subscribe to updates to a certain DOM node
	 */ subscribe(id, callback) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.push(callback);
        this.subscribers.set(id, subscribers);
        // Return a cleanup function that will remove this callback from the list of subscribers
        return ()=>{
            const subscribersOnCleanup = this.subscribers.get(id) ?? [];
            this.subscribers.set(id, subscribersOnCleanup.filter((cb)=>cb !== callback));
        };
    }
    /**
	 * Notify subscribers that the HTML DOM node for an ID has been updated.
	 */ notifySubscribers(id) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.forEach((subscriber)=>{
            subscriber();
        });
    }
    constructor(){
        this.nudgeTargetsMap = new Map();
        this.subscribers = new Map();
    }
}
/**
 * Return the singleton controller
 */ const $1aa5136c8225a4e1$var$useNudgeController = ()=>$1aa5136c8225a4e1$var$NudgeController.instance;
const $1aa5136c8225a4e1$export$eb8a96124d659f2d = (id, shouldRegister = true)=>{
    const controller = $1aa5136c8225a4e1$var$useNudgeController();
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (shouldRegister) {
            const unregister = controller.registerNudgeTarget(id, ref);
            return ()=>{
                unregister();
            };
        }
    }, [
        controller,
        id,
        shouldRegister
    ]);
    return {
        ref: ref
    };
};
/**
 * Creates a subscription into this component, that will return a boolean stating if
 * the HTML DOM node is associated with a given target ID.
 */ const $1aa5136c8225a4e1$var$useHasNudgeTargetNode = (id)=>{
    const controller = $1aa5136c8225a4e1$var$useNudgeController();
    const [hasRefValue, setHasRefValue] = (0, $5uXOq.useState)(!!controller.nudgeTargetsMap.get(id)?.current);
    (0, $5uXOq.useLayoutEffect)(()=>{
        setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        const unsubscribe = controller.subscribe(id, ()=>{
            setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        controller,
        id
    ]);
    return hasRefValue;
};
/**
 * When the nudge is shown, get and track the rectangle of the target element.
 */ const $1aa5136c8225a4e1$var$useNudgeRectangle = (isShown, id, nudgeContainer)=>{
    const [innerRectangle, setInnerRectangle] = (0, $5uXOq.useState)(null);
    const frameId = (0, $5uXOq.useRef)(null);
    const controller = $1aa5136c8225a4e1$var$useNudgeController();
    const nudgeTarget = controller.nudgeTargetsMap.get(id)?.current;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!isShown || !nudgeTarget || !nudgeContainer.current) {
            // Reset rectangle to eliminate risk of Spotlight rendering at
            // old position when nudge is e.g. hidden then shown in a different place.
            if (innerRectangle !== null) setInnerRectangle(null);
            return undefined;
        }
        // This is one approach to tracking the elements moving. See https://hello.atlassian.net/wiki/spaces/JST/pages/1759637849/Rendering+performance+Async+component+wrappers
        // for other options.
        const loop = ()=>{
            const targetRectangle = controller.nudgeTargetsMap.get(id)?.current?.getBoundingClientRect();
            if (!targetRectangle) return undefined;
            const newRectangle = {
                top: targetRectangle.top,
                left: targetRectangle.left,
                width: targetRectangle.width,
                height: targetRectangle.height
            };
            if (innerRectangle == null || innerRectangle.top !== newRectangle.top || innerRectangle.left !== newRectangle.left || innerRectangle.width !== newRectangle.width || innerRectangle.height !== newRectangle.height) setInnerRectangle(newRectangle);
            else frameId.current = requestAnimationFrame(loop);
        };
        frameId.current = requestAnimationFrame(loop);
        return ()=>{
            if (frameId.current != null) cancelAnimationFrame(frameId.current);
        };
    }, [
        isShown,
        nudgeContainer,
        innerRectangle,
        nudgeTarget,
        controller.nudgeTargetsMap,
        id
    ]);
    return innerRectangle;
};
/**
 * Create and append a DOM node to use for the nudge. This is on a separate root to the rest of the app.
 */ const $1aa5136c8225a4e1$var$usePortalContainer = ()=>{
    const nudgeContainer = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!nudgeContainer.current) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            nudgeContainer.current = document.createElement('div');
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.body.appendChild(nudgeContainer.current);
        }
        return ()=>{
            if (nudgeContainer.current) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.body.removeChild(nudgeContainer.current);
        };
    }, []);
    return nudgeContainer;
};
const $1aa5136c8225a4e1$export$74f8d45d75dfda4f = (props)=>{
    const nudgeContainer = $1aa5136c8225a4e1$var$usePortalContainer();
    const hasRefValue = $1aa5136c8225a4e1$var$useHasNudgeTargetNode(props.nudgeTargetId);
    const innerRectangle = $1aa5136c8225a4e1$var$useNudgeRectangle(!props.hidden, props.nudgeTargetId, nudgeContainer);
    const innerRectanglePrevious = (0, $5uXOq.useRef)(innerRectangle);
    const spotlightRef = (0, $5uXOq.useRef)(null);
    // Force update the Popper spotlight when the innerRectangle (nudge position) changes
    (0, $5uXOq.useEffect)(()=>{
        if (innerRectangle !== null && innerRectanglePrevious.current !== innerRectangle && spotlightRef.current !== null) {
            innerRectanglePrevious.current = innerRectangle;
            if (spotlightRef.current.forceUpdateCardPosition) spotlightRef.current.forceUpdateCardPosition();
        }
    }, [
        innerRectangle
    ]);
    const hasNudgeTarget = hasRefValue;
    if (!nudgeContainer.current || !hasNudgeTarget || !innerRectangle) return null;
    return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'fixed',
            top: innerRectangle.top,
            left: innerRectangle.left,
            height: innerRectangle.height,
            width: innerRectangle.width,
            zIndex: props.zIndex
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fqbGj.NudgeSpotlight), {
        ...props,
        ref: spotlightRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            height: innerRectangle.height,
            width: innerRectangle.width
        }
    }))), nudgeContainer.current);
};

});

const $f2c7d758dbca5ecb$export$97c38a17d2d4b39 = 'workflowNudge';

parcelRegister("8fEhS", function(module, exports) {

$parcel$export(module.exports, "useOnboardingGetStartedSingleNudgeActions", () => $e5e08e8d9c426553$export$42d71b3d6683a465);
$parcel$export(module.exports, "useOnboardingGetStartedSingleNudge", () => $e5e08e8d9c426553$export$d23f40d5294362ef);

var $7JoAD = parcelRequire("7JoAD");
const $e5e08e8d9c426553$var$initialState = {
    nudgeId: undefined,
    projectKey: ''
};
const $e5e08e8d9c426553$var$actions = {
    setNudgeActive: (projectKey, nudgeId)=>({ setState: setState })=>setState({
                projectKey: projectKey,
                nudgeId: nudgeId
            }),
    dismissNudge: ()=>({ setState: setState })=>setState({
                nudgeId: undefined,
                projectKey: ''
            })
};
const $e5e08e8d9c426553$var$Store = (0, $7JoAD.createStore)({
    initialState: $e5e08e8d9c426553$var$initialState,
    actions: $e5e08e8d9c426553$var$actions,
    name: 'GetStartedSingleNudge'
});
const $e5e08e8d9c426553$export$42d71b3d6683a465 = (0, $7JoAD.createActionsHook)($e5e08e8d9c426553$var$Store);
const $e5e08e8d9c426553$export$d23f40d5294362ef = (0, $7JoAD.createHook)($e5e08e8d9c426553$var$Store);

});

parcelRegister("1PFZfW", function(module, exports) {

$parcel$export(module.exports, "WorkflowNudgeAsync", () => $5729c85e8ac0078f$export$23ba536243d24791);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");


var $kZwn7 = parcelRequire("kZwn7");
const $5729c85e8ac0078f$var$runtimeProps = {};
const $5729c85e8ac0078f$var$entryPointParams = {};
const $5729c85e8ac0078f$export$23ba536243d24791 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $kZwn7.workflowNudgeEntryPoint), $5729c85e8ac0078f$var$entryPointParams);
    // Can't put this in the trigger as if the trigger fired before page load, then no components of entrypoint are ready to load
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: (0, $f2c7d758dbca5ecb$export$97c38a17d2d4b39),
        packageName: "jiraBoardOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: $5729c85e8ac0078f$var$runtimeProps
    });
};

});
parcelRegister("kZwn7", function(module, exports) {

$parcel$export(module.exports, "workflowNudgeEntryPoint", () => $882805f696bdeb32$export$af7fe27e5a08af44);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $882805f696bdeb32$export$af7fe27e5a08af44 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("fYEe5")), {
        moduleId: "bfc58581"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fYEe5", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("9Tvyk").then(()=>parcelRequire('6RSlA'));

});




parcelRegister("d6mgg", function(module, exports) {

$parcel$export(module.exports, "default", () => $10e952bed2e94360$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $2NMNM = parcelRequire("2NMNM");

var $bC2fB = parcelRequire("bC2fB");

var $fUHZ2 = parcelRequire("fUHZ2");


var $iuuJH = parcelRequire("iuuJH");

var $bRqd3 = parcelRequire("bRqd3");

var $2f454 = parcelRequire("2f454");

var $cAxle = parcelRequire("cAxle");

var $dW1HX = parcelRequire("dW1HX");

var $71oFY = parcelRequire("71oFY");

var $k50Aq = parcelRequire("k50Aq");

var $9OPlz = parcelRequire("9OPlz");

var $fqLDH = parcelRequire("fqLDH");

var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");

var $5v2jP = parcelRequire("5v2jP");

var $gZTZk = parcelRequire("gZTZk");
const $10e952bed2e94360$export$c31df4bd766f9c35 = (state)=>{
    const activeIssueKey = (0, $9OPlz.getCardActiveKey)(state);
    const activeIssueId = (0, $9OPlz.getCardActive)(state);
    const activeIssueAssignee = (0, $9OPlz.getCardActiveAssignee)(state);
    const currentUserAccountId = (0, $36pz7.getCurrentUserAccountId)(state);
    const issueKeyForModal = (0, $fqLDH.getIssueKeyForModal)(state);
    const swimlaneIds = (0, $5mTgl.platformSwimlaneIdsSelector)(state);
    const hasSwimlanes = (0, $45cXl.getSwimlaneMode)(state) !== (0, $iuuJH.NO_SWIMLANE).id;
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    return {
        activeIssueKey: activeIssueKey,
        activeIssueId: activeIssueId,
        activeIssueAssignee: activeIssueAssignee,
        currentUserAccountId: currentUserAccountId,
        issueKeyForModal: issueKeyForModal,
        swimlaneIds: swimlaneIds,
        hasSwimlanes: hasSwimlanes,
        isCMPBoard: isCMPBoard
    };
};
const $10e952bed2e94360$var$bentoShortcutsAnalyticsMap = {
    [(0, $e7036201fc72e756$export$e2291655ce717023)]: 'assignIssueKeyboardShortcut',
    [(0, $e7036201fc72e756$export$4834da14f7c856f4)]: 'editIssueLabelsKeyboardShortcut',
    [(0, $e7036201fc72e756$export$1303babe27c61a83)]: 'commentIssueKeyboardShortcut'
};
const $10e952bed2e94360$export$9e6a17cf56877796 = (dispatch, { fireShortcutAnalytics: fireShortcutAnalytics, analyticsEvent: analyticsEvent })=>{
    const onNextIssue = ()=>{
        // @ts-expect-error - Argument of type '{ type: string; payload: { fireShortcutAnalyticsFn: FireShortcutAnalyticsFn; }; }' is not assignable to parameter of type 'Action'.
        dispatch((0, $2f454.cardNext)(fireShortcutAnalytics));
    };
    const onPrevIssue = ()=>{
        // @ts-expect-error - Argument of type '{ type: string; payload: { fireShortcutAnalyticsFn: FireShortcutAnalyticsFn; }; }' is not assignable to parameter of type 'Action'.
        dispatch((0, $2f454.cardPrev)(fireShortcutAnalytics));
    };
    const onNextColumn = ()=>{
        // @ts-expect-error - Argument of type '{ type: string; payload: { fireShortcutAnalyticsFn: FireShortcutAnalyticsFn; }; }' is not assignable to parameter of type 'Action'.
        dispatch((0, $2f454.cardNextColumn)(fireShortcutAnalytics));
    };
    const onPrevColumn = ()=>{
        // @ts-expect-error - Argument of type '{ type: string; payload: { fireShortcutAnalyticsFn: FireShortcutAnalyticsFn; }; }' is not assignable to parameter of type 'Action'.
        dispatch((0, $2f454.cardPrevColumn)(fireShortcutAnalytics));
    };
    // @ts-expect-error - TS7006 - Parameter 'placement' implicitly has an 'any' type.
    const onMoveToTopOrBottomOfContainer = (placement)=>{
        dispatch((0, $71oFY.issueMoveToTopOrBottomOfContainer)(placement, fireShortcutAnalytics, analyticsEvent));
    };
    const onAssignToMe = (activeIssueId, activeIssueAssignee, currentUserAccountId)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeIssueId)) return;
        const assigneeAccountId = currentUserAccountId === activeIssueAssignee ? null : currentUserAccountId;
        dispatch((0, $cAxle.assignToMeRequestThrottled)(activeIssueId, assigneeAccountId, fireShortcutAnalytics));
    };
    const onToggleBentoViewForFocusedCard = (activeIssueKey, issueKeyForModal, isDetailViewInSidebar)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeIssueKey)) return;
        let isOpeningDetailsView;
        if (issueKeyForModal === activeIssueKey) {
            // If modal is currently open, this shortcut does not close the modal,
            // (since Bento would be in control). This however will close an open sidebar.
            dispatch((0, $dW1HX.closeIssueModal)(activeIssueKey));
            isOpeningDetailsView = false;
        } else {
            dispatch((0, $dW1HX.openIssueModal)(activeIssueKey));
            isOpeningDetailsView = true;
        }
        fireShortcutAnalytics({
            key: 't',
            id: 'toggleDetailsViewKeyboardShortcut',
            attributes: {
                toggled: isOpeningDetailsView ? 'open' : 'closed',
                issueView: isDetailViewInSidebar ? 'sideView' : 'modalView'
            }
        });
    };
    const onOpenAndFocusBentoField = (shortcutKey, activeIssueKey)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeIssueKey)) return;
        const externalAction = (0, $5v2jP.getExternalActionForKey)(shortcutKey);
        if (!externalAction) return;
        dispatch((0, $dW1HX.openIssueModal)(activeIssueKey, externalAction));
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly a: "assignIssueKeyboardShortcut"; readonly l: "editIssueLabelsKeyboardShortcut"; readonly m: "commentIssueKeyboardShortcut"; }'.
        if ($10e952bed2e94360$var$bentoShortcutsAnalyticsMap[shortcutKey]) fireShortcutAnalytics({
            key: shortcutKey,
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly a: "assignIssueKeyboardShortcut"; readonly l: "editIssueLabelsKeyboardShortcut"; readonly m: "commentIssueKeyboardShortcut"; }'.
            id: $10e952bed2e94360$var$bentoShortcutsAnalyticsMap[shortcutKey]
        });
    };
    // remove onShowHideMenu when removing Capability.IS_TAB_NAVIGATION
    const onShowHideMenu = ()=>{
        dispatch((0, $bRqd3.toggleBoardMenus)());
        fireShortcutAnalytics({
            key: 'z',
            id: 'toggleMenuKeyboardShortcut'
        });
    };
    return {
        onNextIssue: onNextIssue,
        onPrevIssue: onPrevIssue,
        onNextColumn: onNextColumn,
        onPrevColumn: onPrevColumn,
        onAssignToMe: onAssignToMe,
        onToggleBentoViewForFocusedCard: onToggleBentoViewForFocusedCard,
        onOpenAndFocusBentoField: onOpenAndFocusBentoField,
        onMoveToTopOrBottomOfContainer: onMoveToTopOrBottomOfContainer,
        onSwimlanesToggle: (swimlaneIds)=>{
            dispatch((0, $k50Aq.swimlanesToggle)(swimlaneIds));
            fireShortcutAnalytics({
                id: 'toggleSwimlanesKeyboardShortcut',
                key: '-'
            });
        },
        onOpenFocusedCard: (activeIssueKey)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeIssueKey)) return;
            dispatch((0, $dW1HX.openIssueModal)(activeIssueKey));
            fireShortcutAnalytics({
                id: 'viewIssueKeyboardShortcut',
                key: 'o'
            });
        },
        onShowHideMenu: onShowHideMenu
    };
};
const $10e952bed2e94360$var$ConnectedKeyboardShortcuts = (0, $bC2fB.connect)($10e952bed2e94360$export$c31df4bd766f9c35, $10e952bed2e94360$export$9e6a17cf56877796)((0, $gZTZk.KeyboardShortcuts));
const $10e952bed2e94360$var$KeyboardShortcutsWithAnalytics = (props)=>{
    const fireShortcutAnalytics = (0, $fUHZ2.useShortcutAnalytics)('board');
    /*
        new analyticsEvent required to use existing card reranking actions
    */ const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        actionSubject: 'keyboardShortcut',
        action: 'pressed'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10e952bed2e94360$var$ConnectedKeyboardShortcuts, {
        ...props,
        fireShortcutAnalytics: fireShortcutAnalytics,
        analyticsEvent: analyticsEvent
    });
};
var $10e952bed2e94360$export$2e2bcd8739ae039 = $10e952bed2e94360$var$KeyboardShortcutsWithAnalytics;

});
parcelRegister("fUHZ2", function(module, exports) {

$parcel$export(module.exports, "useShortcutAnalytics", () => $a45625fee4d71e0e$export$cd482f0b72849b2c);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $8zOmE = parcelRequire("8zOmE");
const $a45625fee4d71e0e$export$56c266726b07692d = (createAnalyticsEvent, { id: id, key: key, attributes: attributes }, shortcutSource)=>{
    const attrs = {
        ...attributes,
        key: key,
        shortcutSource: shortcutSource,
        nextGenProject: true
    };
    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
        action: 'pressed',
        actionSubject: 'keyboardShortcut'
    }), id, attrs);
};
const $a45625fee4d71e0e$export$cd482f0b72849b2c = (shortcutSource)=>{
    // Will fix on FF cleanup
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        $a45625fee4d71e0e$export$56c266726b07692d(createAnalyticsEvent, payload, shortcutSource);
    }, [
        createAnalyticsEvent,
        shortcutSource
    ]);
    return fireAnalytics;
};

});

const $e7036201fc72e756$export$e2291655ce717023 = 'a';
const $e7036201fc72e756$export$4834da14f7c856f4 = 'l';
const $e7036201fc72e756$export$1303babe27c61a83 = 'm';

parcelRegister("5v2jP", function(module, exports) {

$parcel$export(module.exports, "getExternalActionForKey", () => $162c5bc4e348e7a8$export$c8673ee45279f35b);

var $d68jx = parcelRequire("d68jx");

var $5fc53 = parcelRequire("5fc53");

const $162c5bc4e348e7a8$export$c8673ee45279f35b = (key)=>{
    switch(key){
        case 0, $e7036201fc72e756$export$e2291655ce717023:
            return (0, $d68jx.externalEditFieldAction)((0, $5fc53.ASSIGNEE_TYPE));
        case 0, $e7036201fc72e756$export$4834da14f7c856f4:
            return (0, $d68jx.externalEditFieldAction)((0, $5fc53.LABELS_TYPE));
        case 0, $e7036201fc72e756$export$1303babe27c61a83:
            return (0, $d68jx.externalAddCommentAction)();
        default:
            return null;
    }
};

});
parcelRegister("d68jx", function(module, exports) {

$parcel$export(module.exports, "externalEditFieldAction", () => $9aec05de8de4c511$export$5d020593666779fc);
$parcel$export(module.exports, "externalAddCommentAction", () => $9aec05de8de4c511$export$c70036fd42f0ed99);
$parcel$export(module.exports, "externalAssignToMeAction", () => $9aec05de8de4c511$export$8f1d4f64b4b74146);
$parcel$export(module.exports, "FIELD_EDIT_REQUEST_EXTERNAL", () => $9aec05de8de4c511$export$c72c6bc149df5e02);
$parcel$export(module.exports, "ASSIGN_TO_ME_EXTERNAL", () => $9aec05de8de4c511$export$c60815f29b5cfb6d);
$parcel$export(module.exports, "transformExternalAction", () => $9aec05de8de4c511$export$78aa3108fdac0ac3);

var $akbnA = parcelRequire("akbnA");

var $8dFNe = parcelRequire("8dFNe");
const $9aec05de8de4c511$export$5834f946a995a2ca = 'REFRESH_ISSUE';
const $9aec05de8de4c511$export$316a97ea1161ac5a = (type)=>({
        type: $9aec05de8de4c511$export$5834f946a995a2ca,
        payload: {
            type: type
        }
    });
const $9aec05de8de4c511$export$256eddbefbf4b2ce = 'EDIT_FIELD';
const $9aec05de8de4c511$export$5d020593666779fc = (fieldId)=>({
        type: $9aec05de8de4c511$export$256eddbefbf4b2ce,
        payload: {
            fieldId: fieldId
        }
    });
const $9aec05de8de4c511$export$35aff3ed3a26081d = 'ADD_COMMENT';
const $9aec05de8de4c511$export$c70036fd42f0ed99 = ()=>({
        type: $9aec05de8de4c511$export$35aff3ed3a26081d
    });
const $9aec05de8de4c511$export$ae8a4274289f40bb = 'ASSIGN_TO_ME';
const $9aec05de8de4c511$export$8f1d4f64b4b74146 = ()=>({
        type: $9aec05de8de4c511$export$ae8a4274289f40bb
    });
const $9aec05de8de4c511$export$c72c6bc149df5e02 = 'FIELD_EDIT_REQUEST_EXTERNAL';
const $9aec05de8de4c511$export$c3ca6bc94e6e6b5c = (fieldId)=>({
        type: $9aec05de8de4c511$export$c72c6bc149df5e02,
        payload: {
            fieldId: fieldId
        }
    });
const $9aec05de8de4c511$export$c60815f29b5cfb6d = 'ASSIGN_TO_ME_EXTERNAL';
const $9aec05de8de4c511$export$e3035a7e8a739325 = ()=>({
        type: $9aec05de8de4c511$export$c60815f29b5cfb6d
    });
const $9aec05de8de4c511$export$78aa3108fdac0ac3 = (action)=>{
    switch(action.type){
        case $9aec05de8de4c511$export$35aff3ed3a26081d:
            return (0, $8dFNe.addCommentFormExpand)();
        case $9aec05de8de4c511$export$ae8a4274289f40bb:
            return $9aec05de8de4c511$export$e3035a7e8a739325();
        case $9aec05de8de4c511$export$256eddbefbf4b2ce:
            return $9aec05de8de4c511$export$c3ca6bc94e6e6b5c(action.payload.fieldId);
        case $9aec05de8de4c511$export$5834f946a995a2ca:
            return (0, $akbnA.refreshIssueRequest)({
                // todo: swap between soft reload and hard (aka on-demand)
                reason: 'ON_DEMAND'
            });
        default:
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
            throw new Error(`Unhandled external action type: ${action.type}`);
    }
};

});
parcelRegister("akbnA", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_REQUEST", () => $96f907481cd25e73$export$afc8565512ebbf99);
$parcel$export(module.exports, "fetchIssueRequest", () => $96f907481cd25e73$export$ff7cd1a46115d8ca);
$parcel$export(module.exports, "FETCH_ISSUE_SUCCESS", () => $96f907481cd25e73$export$c32d0e1f370b7914);
$parcel$export(module.exports, "fetchIssueSuccess", () => $96f907481cd25e73$export$1e39a30e3f37e9d1);
$parcel$export(module.exports, "FETCH_ISSUE_FAILURE", () => $96f907481cd25e73$export$700ca24f76d5bbe6);
$parcel$export(module.exports, "fetchIssueFailure", () => $96f907481cd25e73$export$625e6e61fad65793);
$parcel$export(module.exports, "REFRESH_ISSUE_REQUEST", () => $96f907481cd25e73$export$b48f53bf5b842d57);
$parcel$export(module.exports, "refreshIssueRequest", () => $96f907481cd25e73$export$ccd0db94940d9159);
$parcel$export(module.exports, "CANCEL_REFRESH_ISSUE_REQUEST", () => $96f907481cd25e73$export$6b6ca6acd76420d1);
$parcel$export(module.exports, "cancelRefreshIssueRequest", () => $96f907481cd25e73$export$a7629a657f902cbc);
$parcel$export(module.exports, "REFRESH_ISSUE_SUCCESS", () => $96f907481cd25e73$export$de11c913f06a7952);
$parcel$export(module.exports, "refreshIssueSuccess", () => $96f907481cd25e73$export$cbd1c08fb706639c);
$parcel$export(module.exports, "FETCH_FORGE_REQUEST", () => $96f907481cd25e73$export$36b76b7384d868f3);
$parcel$export(module.exports, "fetchForgeRequest", () => $96f907481cd25e73$export$6ce2430992033a55);
const $96f907481cd25e73$export$afc8565512ebbf99 = 'FETCH_ISSUE_REQUEST';
const $96f907481cd25e73$export$ff7cd1a46115d8ca = ()=>({
        type: $96f907481cd25e73$export$afc8565512ebbf99
    });
const $96f907481cd25e73$export$c32d0e1f370b7914 = 'FETCH_ISSUE_SUCCESS';
const $96f907481cd25e73$export$1e39a30e3f37e9d1 = (entities)=>({
        type: $96f907481cd25e73$export$c32d0e1f370b7914,
        payload: entities
    });
const $96f907481cd25e73$export$700ca24f76d5bbe6 = 'FETCH_ISSUE_FAILURE';
const $96f907481cd25e73$export$625e6e61fad65793 = (failureDescription)=>({
        type: $96f907481cd25e73$export$700ca24f76d5bbe6,
        payload: failureDescription
    });
const $96f907481cd25e73$export$b48f53bf5b842d57 = 'REFRESH_ISSUE_REQUEST';
const $96f907481cd25e73$export$ccd0db94940d9159 = (payload, meta)=>({
        type: $96f907481cd25e73$export$b48f53bf5b842d57,
        payload: payload,
        meta: meta
    });
const $96f907481cd25e73$export$6b6ca6acd76420d1 = 'CANCEL_REFRESH_ISSUE_REQUEST';
const $96f907481cd25e73$export$a7629a657f902cbc = ()=>({
        type: $96f907481cd25e73$export$6b6ca6acd76420d1
    });
const $96f907481cd25e73$export$de11c913f06a7952 = 'REFRESH_ISSUE_SUCCESS';
const $96f907481cd25e73$export$cbd1c08fb706639c = (entities)=>({
        type: $96f907481cd25e73$export$de11c913f06a7952,
        payload: entities
    });
const $96f907481cd25e73$export$36b76b7384d868f3 = 'FETCH_FORGE_REQUEST';
const $96f907481cd25e73$export$6ce2430992033a55 = ()=>({
        type: $96f907481cd25e73$export$36b76b7384d868f3
    });

});

parcelRegister("8dFNe", function(module, exports) {

$parcel$export(module.exports, "ADD_COMMENT_FORM_EXPAND", () => $17d2ae7757c211f3$export$71d398107e783d48);
$parcel$export(module.exports, "addCommentFormExpand", () => $17d2ae7757c211f3$export$2b19aad250b973d);
$parcel$export(module.exports, "ADD_COMMENT_FORM_COLLAPSE", () => $17d2ae7757c211f3$export$85ff14da4a33157b);
$parcel$export(module.exports, "addCommentFormCollapse", () => $17d2ae7757c211f3$export$835c1049633b19d4);
$parcel$export(module.exports, "ADD_COMMENT_FORM_CANCEL", () => $17d2ae7757c211f3$export$2a743018e170b1c5);
$parcel$export(module.exports, "addCommentFormCancel", () => $17d2ae7757c211f3$export$cbb43c6e2782f713);
$parcel$export(module.exports, "SAVE_COMMENT_RETRY", () => $17d2ae7757c211f3$export$f1da94dd8f2d20f8);
$parcel$export(module.exports, "saveCommentRetry", () => $17d2ae7757c211f3$export$8fe4d7a3b02197cb);
$parcel$export(module.exports, "SAVE_COMMENT_EDIT", () => $17d2ae7757c211f3$export$81e9c11b794a58cd);
$parcel$export(module.exports, "saveCommentEdit", () => $17d2ae7757c211f3$export$854252150d2da91c);
$parcel$export(module.exports, "saveCommentSuccessWithPastedContent", () => $17d2ae7757c211f3$export$74f24e144289c0bf);
$parcel$export(module.exports, "SAVE_COMMENT_REQUEST", () => $17d2ae7757c211f3$export$18d19e9df123c7d4);
$parcel$export(module.exports, "saveCommentRequest", () => $17d2ae7757c211f3$export$180890d02f5569ee);
$parcel$export(module.exports, "SAVE_COMMENT_SUCCESS", () => $17d2ae7757c211f3$export$68a9d3a587260864);
$parcel$export(module.exports, "saveCommentSuccess", () => $17d2ae7757c211f3$export$e25b399b9ba134a2);
$parcel$export(module.exports, "SAVE_COMMENT_FAILURE", () => $17d2ae7757c211f3$export$181640cafd83e422);
$parcel$export(module.exports, "saveCommentFailure", () => $17d2ae7757c211f3$export$c9acef2c154290a0);
$parcel$export(module.exports, "SAVE_COMMENT_CANCEL", () => $17d2ae7757c211f3$export$9188109a1be76d1a);
$parcel$export(module.exports, "saveCommentCancel", () => $17d2ae7757c211f3$export$6971a9cf19e7bff0);
$parcel$export(module.exports, "FETCH_OLDER_COMMENTS_REQUEST", () => $17d2ae7757c211f3$export$8759655e9c2c6d63);
$parcel$export(module.exports, "FETCH_NEWER_COMMENTS_REQUEST", () => $17d2ae7757c211f3$export$d55056f931f514de);
$parcel$export(module.exports, "fetchOlderCommentsRequest", () => $17d2ae7757c211f3$export$89824d2d0989262b);
$parcel$export(module.exports, "fetchNewerCommentsRequest", () => $17d2ae7757c211f3$export$ccf1730684d88fc7);
$parcel$export(module.exports, "FETCH_MORE_COMMENTS_SUCCESS", () => $17d2ae7757c211f3$export$1c31d581a6bc6013);
$parcel$export(module.exports, "fetchMoreCommentsSuccess", () => $17d2ae7757c211f3$export$a06e5ade6af52efd);
$parcel$export(module.exports, "FETCH_MORE_COMMENTS_FAILURE", () => $17d2ae7757c211f3$export$b0ac6cc6abb21a3c);
$parcel$export(module.exports, "fetchMoreCommentsFailure", () => $17d2ae7757c211f3$export$c3ffb947d06519d4);
$parcel$export(module.exports, "FETCH_SORTED_COMMENTS_REQUEST", () => $17d2ae7757c211f3$export$47acda4b8d2cc300);
$parcel$export(module.exports, "fetchSortedCommentsRequest", () => $17d2ae7757c211f3$export$4805c80809193e58);
$parcel$export(module.exports, "FETCH_SORTED_COMMENTS_SUCCESS", () => $17d2ae7757c211f3$export$f72e87877cdff1d3);
$parcel$export(module.exports, "fetchSortedCommentsSuccess", () => $17d2ae7757c211f3$export$248225c0816f92b1);
$parcel$export(module.exports, "fetchSortedCommentsFailure", () => $17d2ae7757c211f3$export$2f204bc36c94722d);
$parcel$export(module.exports, "CHANGE_COMMENT_VISIBILITY", () => $17d2ae7757c211f3$export$27e53ffab4bb4105);
$parcel$export(module.exports, "changeCommentVisibility", () => $17d2ae7757c211f3$export$bdd605e26cb557a);
$parcel$export(module.exports, "EDIT_COMMENT_BEGIN", () => $17d2ae7757c211f3$export$52ec13a9878fb210);
$parcel$export(module.exports, "editCommentBegin", () => $17d2ae7757c211f3$export$b59e3ef618f3f5a4);
$parcel$export(module.exports, "EDIT_COMMENT_COLLAPSE", () => $17d2ae7757c211f3$export$ee24a9af79550b9a);
$parcel$export(module.exports, "editCommentCollapse", () => $17d2ae7757c211f3$export$76f4fdc85b3c4983);
$parcel$export(module.exports, "EDIT_COMMENT_CANCEL", () => $17d2ae7757c211f3$export$34cbc41a86b4aebb);
$parcel$export(module.exports, "editCommentCancel", () => $17d2ae7757c211f3$export$b42a5c3d327fad1a);
$parcel$export(module.exports, "EDIT_COMMENT_UPDATE", () => $17d2ae7757c211f3$export$eae8689994a83d11);
$parcel$export(module.exports, "editCommentUpdate", () => $17d2ae7757c211f3$export$ccfcbe3e4607ec26);
$parcel$export(module.exports, "EDIT_COMMENT_VISIBILITY", () => $17d2ae7757c211f3$export$9a3bec84654d3d8b);
$parcel$export(module.exports, "editCommentVisibility", () => $17d2ae7757c211f3$export$2cbe8c5e21dff6d6);
$parcel$export(module.exports, "EDIT_COMMENT_EVENT_OCCURRED_AT", () => $17d2ae7757c211f3$export$f84d12595d214d0e);
$parcel$export(module.exports, "editCommentEventOccurredAt", () => $17d2ae7757c211f3$export$6b71370b88eec9f);
$parcel$export(module.exports, "DELETE_COMMENT_REQUEST", () => $17d2ae7757c211f3$export$32f9b2d50e470721);
$parcel$export(module.exports, "DELETE_COMMENT_SUCCESS", () => $17d2ae7757c211f3$export$ad9d0372e68e413d);
$parcel$export(module.exports, "deleteCommentSuccess", () => $17d2ae7757c211f3$export$88e6cb2a45e9c67b);
$parcel$export(module.exports, "DELETE_COMMENT_FAILURE", () => $17d2ae7757c211f3$export$17bfad3338f45e82);
$parcel$export(module.exports, "deleteCommentFailure", () => $17d2ae7757c211f3$export$f1282c6c2bcc0a44);
$parcel$export(module.exports, "PASTED_INTO_COMMENT_FORM", () => $17d2ae7757c211f3$export$7ef9a590ab69319e);
$parcel$export(module.exports, "pastedIntoCommentForm", () => $17d2ae7757c211f3$export$8ac8e8de3bb0d3);
$parcel$export(module.exports, "SET_COMMENT_ATTACHMENT_IN_PROGRESS", () => $17d2ae7757c211f3$export$ec38bcd617424c64);
$parcel$export(module.exports, "setCommentAttachmentInProgress", () => $17d2ae7757c211f3$export$d7ed3c847a4656f7);
$parcel$export(module.exports, "SET_COMMENT_VALUE", () => $17d2ae7757c211f3$export$66f932c47f92031b);
$parcel$export(module.exports, "setCommentValue", () => $17d2ae7757c211f3$export$ef0e64b81798a6f2);
$parcel$export(module.exports, "SET_COMMENT_SCROLL_STATUS", () => $17d2ae7757c211f3$export$f7592333993e8ac2);
$parcel$export(module.exports, "setCommentScrollStatus", () => $17d2ae7757c211f3$export$1dda1a9962bdad5f);
$parcel$export(module.exports, "REPLY_COMMENT_BEGIN", () => $17d2ae7757c211f3$export$d5ede80029a6397e);
$parcel$export(module.exports, "replyCommentBegin", () => $17d2ae7757c211f3$export$f1a18b29fe2549e9);
$parcel$export(module.exports, "REPLY_COMMENT_UPDATE", () => $17d2ae7757c211f3$export$25a7e12fd2d783a3);
$parcel$export(module.exports, "replyCommentUpdate", () => $17d2ae7757c211f3$export$ecea73f83f50bca0);
$parcel$export(module.exports, "REPLY_COMMENT_CANCEL", () => $17d2ae7757c211f3$export$f87250d72435d6b4);
$parcel$export(module.exports, "replyCommentCancel", () => $17d2ae7757c211f3$export$9dc83707765a3fa8);

var $fOGZN = parcelRequire("fOGZN");

var $7Vj9c = parcelRequire("7Vj9c");
const $17d2ae7757c211f3$export$71d398107e783d48 = 'ADD_COMMENT_FORM_EXPAND';
const $17d2ae7757c211f3$export$2b19aad250b973d = ()=>({
        type: $17d2ae7757c211f3$export$71d398107e783d48
    });
const $17d2ae7757c211f3$export$85ff14da4a33157b = 'ADD_COMMENT_FORM_COLLAPSE';
const $17d2ae7757c211f3$export$835c1049633b19d4 = ()=>({
        type: $17d2ae7757c211f3$export$85ff14da4a33157b
    });
const $17d2ae7757c211f3$export$2a743018e170b1c5 = 'ADD_COMMENT_FORM_CANCEL';
const $17d2ae7757c211f3$export$cbb43c6e2782f713 = ()=>({
        type: $17d2ae7757c211f3$export$2a743018e170b1c5
    });
const $17d2ae7757c211f3$export$f1da94dd8f2d20f8 = 'SAVE_COMMENT_RETRY';
const $17d2ae7757c211f3$export$8fe4d7a3b02197cb = (optimisticId, createdDate, isNewComment)=>({
        type: $17d2ae7757c211f3$export$f1da94dd8f2d20f8,
        payload: {
            optimisticId: optimisticId,
            createdDate: createdDate,
            isNewComment: isNewComment
        }
    });
const $17d2ae7757c211f3$export$81e9c11b794a58cd = 'SAVE_COMMENT_EDIT';
const $17d2ae7757c211f3$export$854252150d2da91c = (optimisticId)=>({
        type: $17d2ae7757c211f3$export$81e9c11b794a58cd,
        payload: {
            optimisticId: optimisticId
        }
    });
const $17d2ae7757c211f3$export$eca5dde908b0cf94 = 'SAVE_COMMENT_SUCCESS_WITH_PASTED_CONTENT';
const $17d2ae7757c211f3$export$74f24e144289c0bf = (comment, pastedContent)=>({
        type: $17d2ae7757c211f3$export$eca5dde908b0cf94,
        payload: {
            comment: comment,
            pastedContent: pastedContent
        }
    });
const $17d2ae7757c211f3$export$18d19e9df123c7d4 = 'SAVE_COMMENT_REQUEST';
const $17d2ae7757c211f3$export$180890d02f5569ee = (comment, analyticsEvent)=>({
        type: $17d2ae7757c211f3$export$18d19e9df123c7d4,
        payload: {
            comment: comment,
            analyticsEvent: analyticsEvent,
            updatedField: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$68a9d3a587260864 = 'SAVE_COMMENT_SUCCESS';
const $17d2ae7757c211f3$export$e25b399b9ba134a2 = (comment, optimisticId, isNewComment, analyticsEvent, meta, eventOccurredAt, jsdIncidentActivityViewHidden, fullIssueUrl, triggerIncidentSaveCommentFlag, parentId)=>({
        type: $17d2ae7757c211f3$export$68a9d3a587260864,
        payload: {
            fieldId: (0, $fOGZN.COMMENT),
            comment: comment,
            optimisticId: optimisticId,
            isNewComment: isNewComment,
            analyticsEvent: analyticsEvent,
            parentId: parentId,
            ...(0, $7Vj9c.isJsmTimelineEnabled)() ? {
                eventOccurredAt: eventOccurredAt
            } : {},
            ...(0, $7Vj9c.isJsmTimelineEnabled)() ? {
                jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden
            } : {},
            ...(0, $7Vj9c.isJsmTimelineEnabled)() && fullIssueUrl ? {
                fullIssueUrl: fullIssueUrl
            } : {},
            ...(0, $7Vj9c.isJsmTimelineEnabled)() ? {
                triggerIncidentSaveCommentFlag: triggerIncidentSaveCommentFlag
            } : {}
        },
        meta: meta
    });
const $17d2ae7757c211f3$export$181640cafd83e422 = 'SAVE_COMMENT_FAILURE';
const $17d2ae7757c211f3$export$c9acef2c154290a0 = (payload)=>({
        type: $17d2ae7757c211f3$export$181640cafd83e422,
        payload: payload
    });
const $17d2ae7757c211f3$export$9188109a1be76d1a = 'SAVE_COMMENT_CANCEL';
const $17d2ae7757c211f3$export$6971a9cf19e7bff0 = (optimisticId, isNewComment, parentId)=>({
        type: $17d2ae7757c211f3$export$9188109a1be76d1a,
        payload: {
            optimisticId: optimisticId,
            isNewComment: isNewComment,
            parentId: parentId
        }
    });
const $17d2ae7757c211f3$export$8759655e9c2c6d63 = 'FETCH_OLDER_COMMENTS_REQUEST';
const $17d2ae7757c211f3$export$d55056f931f514de = 'FETCH_NEWER_COMMENTS_REQUEST';
const $17d2ae7757c211f3$export$89824d2d0989262b = ()=>({
        type: $17d2ae7757c211f3$export$8759655e9c2c6d63
    });
const $17d2ae7757c211f3$export$ccf1730684d88fc7 = ()=>({
        type: $17d2ae7757c211f3$export$d55056f931f514de
    });
const $17d2ae7757c211f3$export$1c31d581a6bc6013 = 'FETCH_MORE_COMMENTS_SUCCESS';
const $17d2ae7757c211f3$export$a06e5ade6af52efd = (loadedComments)=>({
        type: $17d2ae7757c211f3$export$1c31d581a6bc6013,
        payload: loadedComments
    });
const $17d2ae7757c211f3$export$b0ac6cc6abb21a3c = 'FETCH_MORE_COMMENTS_FAILURE';
const $17d2ae7757c211f3$export$c3ffb947d06519d4 = ()=>({
        type: $17d2ae7757c211f3$export$b0ac6cc6abb21a3c
    });
const $17d2ae7757c211f3$export$47acda4b8d2cc300 = 'FETCH_SORTED_COMMENTS_REQUEST';
const $17d2ae7757c211f3$export$4805c80809193e58 = (commentId)=>({
        type: $17d2ae7757c211f3$export$47acda4b8d2cc300,
        payload: commentId
    });
const $17d2ae7757c211f3$export$f72e87877cdff1d3 = 'FETCH_SORTED_COMMENTS_SUCCESS';
const $17d2ae7757c211f3$export$248225c0816f92b1 = (loadedComments)=>({
        type: $17d2ae7757c211f3$export$f72e87877cdff1d3,
        payload: loadedComments
    });
const $17d2ae7757c211f3$export$5ae0e03aaca20486 = 'FETCH_SORTED_COMMENTS_FAILURE';
const $17d2ae7757c211f3$export$2f204bc36c94722d = ()=>({
        type: $17d2ae7757c211f3$export$5ae0e03aaca20486
    });
const $17d2ae7757c211f3$export$27e53ffab4bb4105 = 'CHANGE_COMMENT_VISIBILITY';
const $17d2ae7757c211f3$export$bdd605e26cb557a = (id, isInternal)=>({
        type: $17d2ae7757c211f3$export$27e53ffab4bb4105,
        payload: {
            id: id,
            isInternal: isInternal
        }
    });
const $17d2ae7757c211f3$export$52ec13a9878fb210 = 'EDIT_COMMENT_BEGIN';
const $17d2ae7757c211f3$export$b59e3ef618f3f5a4 = (id, isInternal)=>({
        type: $17d2ae7757c211f3$export$52ec13a9878fb210,
        payload: {
            id: id,
            isInternal: isInternal
        }
    });
const $17d2ae7757c211f3$export$ee24a9af79550b9a = 'EDIT_COMMENT_COLLAPSE';
const $17d2ae7757c211f3$export$76f4fdc85b3c4983 = (id)=>({
        type: $17d2ae7757c211f3$export$ee24a9af79550b9a,
        payload: {
            id: id,
            fieldId: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$34cbc41a86b4aebb = 'EDIT_COMMENT_CANCEL';
const $17d2ae7757c211f3$export$b42a5c3d327fad1a = (id)=>({
        type: $17d2ae7757c211f3$export$34cbc41a86b4aebb,
        payload: {
            id: id,
            fieldId: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$eae8689994a83d11 = 'EDIT_COMMENT_UPDATE';
const $17d2ae7757c211f3$export$ccfcbe3e4607ec26 = (id, value)=>({
        type: $17d2ae7757c211f3$export$eae8689994a83d11,
        payload: {
            id: id,
            value: value,
            fieldId: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$9a3bec84654d3d8b = 'EDIT_COMMENT_VISIBILITY';
const $17d2ae7757c211f3$export$2cbe8c5e21dff6d6 = (id, visibility)=>({
        type: $17d2ae7757c211f3$export$9a3bec84654d3d8b,
        payload: {
            id: id,
            visibility: visibility
        }
    });
const $17d2ae7757c211f3$export$f84d12595d214d0e = 'EDIT_COMMENT_EVENT_OCCURRED_AT';
const $17d2ae7757c211f3$export$6b71370b88eec9f = (id, eventOccurredAt)=>({
        type: $17d2ae7757c211f3$export$f84d12595d214d0e,
        payload: {
            id: id,
            eventOccurredAt: eventOccurredAt
        }
    });
const $17d2ae7757c211f3$export$32f9b2d50e470721 = 'DELETE_COMMENT_REQUEST';
const $17d2ae7757c211f3$export$ed74b3a5f1c036c2 = (id, analyticsEvent, parentId, hasReplies)=>({
        type: $17d2ae7757c211f3$export$32f9b2d50e470721,
        payload: {
            id: id,
            analyticsEvent: analyticsEvent,
            parentId: parentId,
            hasReplies: hasReplies,
            updatedField: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$ad9d0372e68e413d = 'DELETE_COMMENT_SUCCESS';
const $17d2ae7757c211f3$export$88e6cb2a45e9c67b = (id, parentId, hasReplies)=>({
        type: $17d2ae7757c211f3$export$ad9d0372e68e413d,
        payload: {
            id: id,
            fieldId: (0, $fOGZN.COMMENT),
            parentId: parentId,
            hasReplies: hasReplies
        }
    });
const $17d2ae7757c211f3$export$17bfad3338f45e82 = 'DELETE_COMMENT_FAILURE';
const $17d2ae7757c211f3$export$f1282c6c2bcc0a44 = (id)=>({
        type: $17d2ae7757c211f3$export$17bfad3338f45e82,
        payload: id
    });
const $17d2ae7757c211f3$export$7ef9a590ab69319e = 'PASTED_INTO_COMMENT_FORM';
const $17d2ae7757c211f3$export$8ac8e8de3bb0d3 = (id, pastedContent)=>({
        type: $17d2ae7757c211f3$export$7ef9a590ab69319e,
        payload: {
            id: id,
            pastedContent: pastedContent
        }
    });
const $17d2ae7757c211f3$export$ec38bcd617424c64 = 'SET_COMMENT_ATTACHMENT_IN_PROGRESS';
const $17d2ae7757c211f3$export$d7ed3c847a4656f7 = (isInProgress)=>({
        type: $17d2ae7757c211f3$export$ec38bcd617424c64,
        payload: {
            isInProgress: isInProgress
        }
    });
const $17d2ae7757c211f3$export$66f932c47f92031b = 'SET_COMMENT_VALUE';
const $17d2ae7757c211f3$export$ef0e64b81798a6f2 = (id, value)=>({
        type: $17d2ae7757c211f3$export$66f932c47f92031b,
        payload: {
            id: id,
            value: value,
            fieldId: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$f7592333993e8ac2 = 'SET_COMMENT_SCROLL_STATUS';
const $17d2ae7757c211f3$export$1dda1a9962bdad5f = (status)=>({
        type: $17d2ae7757c211f3$export$f7592333993e8ac2,
        payload: {
            status: status
        }
    });
const $17d2ae7757c211f3$export$d5ede80029a6397e = 'REPLY_COMMENT_BEGIN';
const $17d2ae7757c211f3$export$f1a18b29fe2549e9 = (commentId, authorId, authorDisplayName, visibility)=>({
        type: $17d2ae7757c211f3$export$d5ede80029a6397e,
        payload: {
            commentId: commentId,
            authorId: authorId,
            authorDisplayName: authorDisplayName,
            visibility: visibility
        }
    });
const $17d2ae7757c211f3$export$25a7e12fd2d783a3 = 'REPLY_COMMENT_UPDATE';
const $17d2ae7757c211f3$export$ecea73f83f50bca0 = (parentId, value)=>({
        type: $17d2ae7757c211f3$export$25a7e12fd2d783a3,
        payload: {
            parentId: parentId,
            value: value
        }
    });
const $17d2ae7757c211f3$export$f87250d72435d6b4 = 'REPLY_COMMENT_CANCEL';
const $17d2ae7757c211f3$export$9dc83707765a3fa8 = (parentId)=>({
        type: $17d2ae7757c211f3$export$f87250d72435d6b4,
        payload: {
            parentId: parentId
        }
    });

});
parcelRegister("fOGZN", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE", () => $1df76d38eb6e3f90$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_SUMMARY", () => $1df76d38eb6e3f90$export$a464614f8f5fe986);
$parcel$export(module.exports, "SUBTASK_PARENT", () => $1df76d38eb6e3f90$export$a311a3c9b207604e);
$parcel$export(module.exports, "WATCHES", () => $1df76d38eb6e3f90$export$289917d9a7031e1d);
$parcel$export(module.exports, "VOTES", () => $1df76d38eb6e3f90$export$81614f6dc3be5b00);
$parcel$export(module.exports, "SECURITY", () => $1df76d38eb6e3f90$export$72a5630aa398d6b4);
$parcel$export(module.exports, "ISSUE_RESTRICTION", () => $1df76d38eb6e3f90$export$caf1ff54fbdf44bf);
$parcel$export(module.exports, "ASSIGNEE", () => $1df76d38eb6e3f90$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "REPORTER", () => $1df76d38eb6e3f90$export$6d7021166edc895c);
$parcel$export(module.exports, "DUE_DATE", () => $1df76d38eb6e3f90$export$cf7e173386d30cdd);
$parcel$export(module.exports, "PRIORITY", () => $1df76d38eb6e3f90$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "LABELS", () => $1df76d38eb6e3f90$export$79b91d4669dcadcb);
$parcel$export(module.exports, "EPIC", () => $1df76d38eb6e3f90$export$3cb4a99a332e4186);
$parcel$export(module.exports, "FIX_VERSIONS", () => $1df76d38eb6e3f90$export$d7e18f5730074533);
$parcel$export(module.exports, "AFFECTS_VERSIONS", () => $1df76d38eb6e3f90$export$c435f0000304e508);
$parcel$export(module.exports, "TIME_TRACKING", () => $1df76d38eb6e3f90$export$ee99ef6ee562a446);
$parcel$export(module.exports, "TIME_ESTIMATE", () => $1df76d38eb6e3f90$export$a6a74b4bc927d39f);
$parcel$export(module.exports, "STATUS", () => $1df76d38eb6e3f90$export$e50006273435e7d4);
$parcel$export(module.exports, "CREATED", () => $1df76d38eb6e3f90$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $1df76d38eb6e3f90$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "SUMMARY", () => $1df76d38eb6e3f90$export$913055729e1380b2);
$parcel$export(module.exports, "DESCRIPTION", () => $1df76d38eb6e3f90$export$d44826c816b5619b);
$parcel$export(module.exports, "COMMENT", () => $1df76d38eb6e3f90$export$a29989082612d0d9);
$parcel$export(module.exports, "EPIC_ISSUES", () => $1df76d38eb6e3f90$export$8fe3d5be8cb17459);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $1df76d38eb6e3f90$export$3b3d0889022c85b3);
$parcel$export(module.exports, "ENVIRONMENT", () => $1df76d38eb6e3f90$export$be46596bc6608f3b);
$parcel$export(module.exports, "SUBTASKS", () => $1df76d38eb6e3f90$export$f528fadbfdb3c25e);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $1df76d38eb6e3f90$export$f10e53e8928b61bd);
$parcel$export(module.exports, "PARENT", () => $1df76d38eb6e3f90$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", () => $1df76d38eb6e3f90$export$aba22e09a66f6826);
$parcel$export(module.exports, "FLAG_ACTIONS", () => $1df76d38eb6e3f90$export$cdbd1eb3b05729e0);
$parcel$export(module.exports, "CARD_COVER_ACTIONS", () => $1df76d38eb6e3f90$export$c161a774ec2e7e56);
$parcel$export(module.exports, "specialFields", () => $1df76d38eb6e3f90$export$89e5c40c0f5c7561);
$parcel$export(module.exports, "ecosystemCustomFields", () => $1df76d38eb6e3f90$export$87934b3672715c91);
$parcel$export(module.exports, "customFieldsToDisplay", () => $1df76d38eb6e3f90$export$efd443bccc4c01ed);
$parcel$export(module.exports, "itemDocumentationUrls", () => $1df76d38eb6e3f90$export$a18b3a656ee9c709);
$parcel$export(module.exports, "emptyConfiguration", () => $1df76d38eb6e3f90$export$a52507e68e7aeeb);
$parcel$export(module.exports, "softwareConfiguration", () => $1df76d38eb6e3f90$export$27e0678365e5dcff);
$parcel$export(module.exports, "simpleSoftwareBoardConfiguration", () => $1df76d38eb6e3f90$export$aebf676dfa727a1c);
$parcel$export(module.exports, "standardRoadmapConfiguration", () => $1df76d38eb6e3f90$export$1afca4d3eb6b218b);
$parcel$export(module.exports, "bitbucketConfiguration", () => $1df76d38eb6e3f90$export$8a060ed6f66c43b0);
$parcel$export(module.exports, "mobileConfiguration", () => $1df76d38eb6e3f90$export$78a2cb921e46f5eb);
$parcel$export(module.exports, "serviceDeskConfiguration", () => $1df76d38eb6e3f90$export$db1115186532f6d5);
$parcel$export(module.exports, "connectConfiguration", () => $1df76d38eb6e3f90$export$557d5094ec5cf234);
$parcel$export(module.exports, "getIssueConfiguration", () => $1df76d38eb6e3f90$export$902f6c5cc939598a);

var $65mz3 = parcelRequire("65mz3");

var $2vSU6 = parcelRequire("2vSU6");

var $5fc53 = parcelRequire("5fc53");
const $1df76d38eb6e3f90$export$ebb48b08205007c5 = 'issuetype';
const $1df76d38eb6e3f90$export$a464614f8f5fe986 = 'summary';
const $1df76d38eb6e3f90$export$a311a3c9b207604e = 'parent';
const $1df76d38eb6e3f90$export$2a4f270075a033de = 'parent-issue';
const $1df76d38eb6e3f90$export$4561a4960baf1b2b = 'parent'; // new Hierarchy unification parent field
const $1df76d38eb6e3f90$export$289917d9a7031e1d = 'watches';
const $1df76d38eb6e3f90$export$81614f6dc3be5b00 = 'votes';
const $1df76d38eb6e3f90$export$72a5630aa398d6b4 = 'security';
const $1df76d38eb6e3f90$export$caf1ff54fbdf44bf = 'issuerestriction';
const $1df76d38eb6e3f90$export$f8f7545d2bb78afb = 'assignee';
const $1df76d38eb6e3f90$export$6d7021166edc895c = 'reporter';
const $1df76d38eb6e3f90$export$cf7e173386d30cdd = 'duedate';
const $1df76d38eb6e3f90$export$bb34f3538ba26c7e = 'priority';
const $1df76d38eb6e3f90$export$79b91d4669dcadcb = 'labels';
const $1df76d38eb6e3f90$export$cbedbfe2cd0caec7 = 'components';
const $1df76d38eb6e3f90$export$950d47e775e208ee = 'devSummary';
const $1df76d38eb6e3f90$export$f91d2bb4cc99fa5e = 'releases';
const $1df76d38eb6e3f90$export$a316570a0dbfd2b0 = 'sprint';
const $1df76d38eb6e3f90$export$405b6d72f2d243a9 = 'storyPointsField';
const $1df76d38eb6e3f90$export$3cb4a99a332e4186 = 'epic';
const $1df76d38eb6e3f90$export$d7e18f5730074533 = 'fixVersions';
const $1df76d38eb6e3f90$export$c435f0000304e508 = 'versions';
const $1df76d38eb6e3f90$export$ee99ef6ee562a446 = 'timetracking';
const $1df76d38eb6e3f90$export$a6a74b4bc927d39f = 'timeoriginalestimate';
const $1df76d38eb6e3f90$export$e50006273435e7d4 = 'status';
const $1df76d38eb6e3f90$export$f1a6ce22cbb7eb32 = 'resolution';
const $1df76d38eb6e3f90$export$ff39ebd4bb12b718 = 'created';
const $1df76d38eb6e3f90$export$cd8e68094cb5c3cb = 'updated';
const $1df76d38eb6e3f90$export$1d0e0bb6a21b800b = 'SLA_PANEL';
const $1df76d38eb6e3f90$export$340fac260c3e3637 = 'LINKED_ALERTS';
const $1df76d38eb6e3f90$export$24ec4dcc8e5b08ef = 'CHAT_CHANNEL';
const $1df76d38eb6e3f90$export$8631065e0909313 = 'MSTEAMS_CHANNEL';
const $1df76d38eb6e3f90$export$3c4dccba7d7e0acb = 'ZOOM_MEETING';
const $1df76d38eb6e3f90$export$cd5e9246357daec3 = 'CONFERENCE_CALL';
const $1df76d38eb6e3f90$export$203643a6fd9496a0 = 'KNOWLEDGE_BASE';
const $1df76d38eb6e3f90$export$9c83bd19c3ffd90d = 'SENTIMENT';
const $1df76d38eb6e3f90$export$c5c04443c6097d6e = 'ASSET_ONBOARDING';
const $1df76d38eb6e3f90$export$26d855f4cd7e5fe9 = 'MANAGE_STAKEHOLDERS';
const $1df76d38eb6e3f90$export$913055729e1380b2 = 'summary';
const $1df76d38eb6e3f90$export$d44826c816b5619b = 'description';
const $1df76d38eb6e3f90$export$a29989082612d0d9 = 'comment';
const $1df76d38eb6e3f90$export$8fe3d5be8cb17459 = 'epic-issues'; // this field is only served in classic projects
const $1df76d38eb6e3f90$export$3b3d0889022c85b3 = 'children-issues';
const $1df76d38eb6e3f90$export$be46596bc6608f3b = 'environment';
const $1df76d38eb6e3f90$export$f528fadbfdb3c25e = 'subtasks';
const $1df76d38eb6e3f90$export$f10e53e8928b61bd = 'dataclassification';
const $1df76d38eb6e3f90$export$e0dfb65d1047c53c = (0, $5fc53.PARENT_CF_TYPE);
const $1df76d38eb6e3f90$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $1df76d38eb6e3f90$export$cdbd1eb3b05729e0 = 'flagActions';
const $1df76d38eb6e3f90$export$c161a774ec2e7e56 = 'cardCoverActions';
const $1df76d38eb6e3f90$export$89e5c40c0f5c7561 = ()=>{
    const fields = {
        [$1df76d38eb6e3f90$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
        [$1df76d38eb6e3f90$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
        [$1df76d38eb6e3f90$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        [(0, $5fc53.TEAM_CF_TYPE)]: (0, $5fc53.TEAM_CF_TYPE),
        [(0, $5fc53.PARENT_CF_TYPE)]: (0, $5fc53.PARENT_CF_TYPE),
        [(0, $5fc53.BASELINE_START_CF_TYPE)]: (0, $5fc53.BASELINE_START_CF_TYPE),
        [(0, $5fc53.BASELINE_END_CF_TYPE)]: (0, $5fc53.BASELINE_END_CF_TYPE),
        [(0, $5fc53.COLOR_CF_TYPE)]: (0, $5fc53.COLOR_CF_TYPE),
        [(0, $5fc53.EPIC_COLOR_TYPE)]: (0, $5fc53.EPIC_COLOR_TYPE),
        [(0, $5fc53.EPIC_NAME_TYPE)]: (0, $5fc53.EPIC_NAME_TYPE)
    };
    return fields;
};
const $1df76d38eb6e3f90$export$87934b3672715c91 = [
    (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
];
const $1df76d38eb6e3f90$var$serviceDeskCustomFields = [
    (0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE),
    (0, $5fc53.ORGANIZATIONS_CF_TYPE),
    (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE),
    (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE),
    (0, $5fc53.APPROVALS_CF_TYPE),
    (0, $5fc53.APPROVERS_LIST_CF_TYPE),
    (0, $5fc53.REQUEST_TYPE_CF_TYPE),
    (0, $5fc53.CMDB_OBJECT_CF_TYPE),
    (0, $5fc53.RESPONDERS_CF_TYPE),
    (0, $5fc53.MAJOR_INCIDENT_CF_TYPE),
    (0, $5fc53.ENTITLEMENT_CF_TYPE),
    (0, $5fc53.SENTIMENT_CF_TYPE)
];
const $1df76d38eb6e3f90$export$efd443bccc4c01ed = ()=>[
        (0, $5fc53.LABELS_CF_TYPE),
        (0, $5fc53.TEXT_CF_TYPE),
        (0, $5fc53.MULTI_USER_CF_TYPE),
        (0, $5fc53.PARTICIPANTS_CF_TYPE),
        (0, $5fc53.URL_CF_TYPE),
        (0, $5fc53.NUMBER_CF_TYPE),
        (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE),
        (0, $5fc53.SELECT_CF_TYPE),
        (0, $5fc53.MULTI_SELECT_CF_TYPE),
        (0, $5fc53.VERSION_CF_TYPE),
        (0, $5fc53.TEXT_AREA_CF_TYPE),
        (0, $5fc53.MULTI_VERSION_CF_TYPE),
        (0, $5fc53.DATE_CF_TYPE),
        (0, $5fc53.GROUP_CF_TYPE),
        (0, $5fc53.MULTI_GROUP_CF_TYPE),
        (0, $5fc53.USER_CF_TYPE),
        (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
        (0, $5fc53.RADIO_BUTTONS_CF_TYPE),
        (0, $5fc53.DATETIME_CF_TYPE),
        (0, $5fc53.ASSETS_CF_TYPE),
        (0, $5fc53.SERVICE_ENTITY_CF_TYPE),
        (0, $5fc53.PEOPLE_CF_TYPE),
        (0, $5fc53.CASCADING_SELECT_CF_TYPE),
        (0, $5fc53.PROJECT_PICKER_CF_TYPE),
        (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
        (0, $5fc53.READ_ONLY_CF_TYPE),
        (0, $5fc53.EPIC_STATUS_TYPE),
        (0, $5fc53.MESSAGE_VIEW_CF_TYPE),
        (0, $5fc53.MESSAGE_EDIT_CF_TYPE),
        (0, $5fc53.CATEGORY_TYPE),
        (0, $5fc53.GOALS_CF_TYPE),
        ...$1df76d38eb6e3f90$export$87934b3672715c91,
        ...$1df76d38eb6e3f90$var$serviceDeskCustomFields
    ];
const $1df76d38eb6e3f90$export$a18b3a656ee9c709 = {
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
    [(0, $2vSU6.CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
};
const $1df76d38eb6e3f90$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $1df76d38eb6e3f90$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $65mz3.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $65mz3.default).SOFTWARE_ISSUE,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $65mz3.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0,
            $1df76d38eb6e3f90$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $65mz3.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $65mz3.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $1df76d38eb6e3f90$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $65mz3.default).MOBILE_ISSUE,
        issueActions: []
    });
const $1df76d38eb6e3f90$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $65mz3.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$557d5094ec5cf234 = ()=>({
        applicationKey: (0, $65mz3.default).CONNECT_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if (config.isSimplified) return $1df76d38eb6e3f90$export$aebf676dfa727a1c();
            return $1df76d38eb6e3f90$export$27e0678365e5dcff();
        case 0, $2vSU6.CORE_PROJECT:
            return $1df76d38eb6e3f90$export$381ce08838c53afa();
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $1df76d38eb6e3f90$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $1df76d38eb6e3f90$export$27e0678365e5dcff();
    }
    return $1df76d38eb6e3f90$export$27e0678365e5dcff();
};

});

parcelRegister("7Vj9c", function(module, exports) {

$parcel$export(module.exports, "isJsmTimelineEnabled", () => $bc9eb3af4e788bdb$export$575e1bf822db15b5);

var $co1wz = parcelRequire("co1wz");
const $bc9eb3af4e788bdb$export$575e1bf822db15b5 = ()=>(0, $co1wz.ff)('jsm-timelines-phase-2_70gja', false);

});




parcelRegister("gZTZk", function(module, exports) {

$parcel$export(module.exports, "KeyboardShortcuts", () => $6f06148fa1f95cf3$export$5176144edf2bef2b);

var $5uXOq = parcelRequire("5uXOq");

var $3Tty1 = parcelRequire("3Tty1");

var $2gCtH = parcelRequire("2gCtH");

var $8CVvd = parcelRequire("8CVvd");


const $6f06148fa1f95cf3$var$bentoShortcutKeys = [
    (0, $e7036201fc72e756$export$e2291655ce717023),
    (0, $e7036201fc72e756$export$4834da14f7c856f4),
    (0, $e7036201fc72e756$export$1303babe27c61a83)
];
const $6f06148fa1f95cf3$export$5176144edf2bef2b = ({ activeIssueId: activeIssueId, activeIssueKey: activeIssueKey, activeIssueAssignee: activeIssueAssignee, currentUserAccountId: currentUserAccountId, issueKeyForModal: issueKeyForModal, hasSwimlanes: hasSwimlanes, swimlaneIds: swimlaneIds, isCMPBoard: isCMPBoard, onOpenFocusedCard: onOpenFocusedCard, onToggleBentoViewForFocusedCard: onToggleBentoViewForFocusedCard, onSwimlanesToggle: onSwimlanesToggle, onNextIssue: onNextIssue, onPrevIssue: onPrevIssue, onNextColumn: onNextColumn, onPrevColumn: onPrevColumn, onOpenAndFocusBentoField: onOpenAndFocusBentoField, onAssignToMe: onAssignToMe, onMoveToTopOrBottomOfContainer: onMoveToTopOrBottomOfContainer, onShowHideMenu: onShowHideMenu })=>{
    const viewMode = (0, $2gCtH.useViewMode)();
    const isDetailViewInSidebar = viewMode === 'SIDEBAR';
    const keyMap = {
        ...hasSwimlanes && {
            '-': {
                callback: ()=>onSwimlanesToggle(swimlaneIds)
            }
        },
        o: {
            callback: ()=>onOpenFocusedCard(activeIssueKey)
        },
        t: {
            callback: ()=>onToggleBentoViewForFocusedCard(activeIssueKey, issueKeyForModal, isDetailViewInSidebar)
        },
        j: {
            callback: onNextIssue
        },
        k: {
            callback: onPrevIssue
        },
        n: {
            callback: onNextColumn
        },
        p: {
            callback: onPrevColumn
        },
        i: {
            callback: ()=>onAssignToMe(activeIssueId, activeIssueAssignee, currentUserAccountId)
        },
        // Show/Hide menu is also called Compact mode, this whole section should be removed when cleaning up getWillShowNav3
        // as the z key is already used for the FullscreenButton (see @atlassian/jira-fullscreen-button) and
        // compact mode does not exist in nav4
        ...(0, $8CVvd.getWillShowNav3)() && isCMPBoard ? {
            z: {
                callback: onShowHideMenu
            }
        } : {},
        's t': {
            callback: ()=>onMoveToTopOrBottomOfContainer((0, $dcbb2bce513725b3$export$e5bf25b985a7619d))
        },
        's b': {
            callback: ()=>onMoveToTopOrBottomOfContainer((0, $dcbb2bce513725b3$export$e044c7349fbdcb2))
        }
    };
    $6f06148fa1f95cf3$var$bentoShortcutKeys.forEach((shortcutKey)=>{
        keyMap[shortcutKey] = {
            callback: ()=>{
                onOpenAndFocusBentoField(shortcutKey, activeIssueKey);
            }
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: keyMap,
        location: "software.board.keyboard-shortcuts"
    });
};

});
parcelRegister("3Tty1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ba57d5dc6c0de0a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9IeM0 = parcelRequire("9IeM0");

var $h0GOb = parcelRequire("h0GOb");

var $4lkOX = parcelRequire("4lkOX");

var $k4r7E = parcelRequire("k4r7E");

var $9fuVs = parcelRequire("9fuVs");

var $kspvB = parcelRequire("kspvB");
let $6ba57d5dc6c0de0a$var$shortcutsCount = 0;
let $6ba57d5dc6c0de0a$var$subscription = null;
const $6ba57d5dc6c0de0a$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $5uXOq.useContext)((0, $9fuVs.ShortcutRegistryContext)) || (0, $k4r7E.rootRegistry);
    const addKeyMap = (0, $5uXOq.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $kspvB.bindKeyMapWithErrorHandling)(keyMap, location),
                label: label
            })), [
        label,
        parentRegistry,
        keyMap,
        location
    ]);
    (0, $5uXOq.useEffect)(()=>{
        $6ba57d5dc6c0de0a$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $6ba57d5dc6c0de0a$var$shortcutsCount -= 1;
            if ($6ba57d5dc6c0de0a$var$subscription && $6ba57d5dc6c0de0a$var$shortcutsCount === 0) {
                $6ba57d5dc6c0de0a$var$subscription.unsubscribe();
                $6ba57d5dc6c0de0a$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $5uXOq.useEffect)(()=>{
        $6ba57d5dc6c0de0a$var$subscription = $6ba57d5dc6c0de0a$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $h0GOb.default)().subscribe((0, $4lkOX.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6ba57d5dc6c0de0a$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $9IeM0.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ba57d5dc6c0de0a$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("9IeM0", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $dc712fc9bec05022$export$a33a81f1fc5458ad);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $j8DrX = parcelRequire("j8DrX");

var $8zOmE = parcelRequire("8zOmE");

var $7JoAD = parcelRequire("7JoAD");
const $dc712fc9bec05022$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $dc712fc9bec05022$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$dc712fc9bec05022$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $eusud.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $dc712fc9bec05022$var$Store = (0, $7JoAD.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $j8DrX.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $dc712fc9bec05022$export$b62f67be35e65859
    }
});
const $dc712fc9bec05022$export$a33a81f1fc5458ad = (0, $7JoAD.createHook)($dc712fc9bec05022$var$Store);

});

parcelRegister("h0GOb", function(module, exports) {

$parcel$export(module.exports, "default", () => $849cd54ac4017470$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $849cd54ac4017470$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $kVLXA = parcelRequire("kVLXA");

var $cab1K = parcelRequire("cab1K");
parcelRequire("jG6Un");
parcelRequire("eSGL3");
parcelRequire("1oQta");
parcelRequire("4kRRr");
parcelRequire("d0pqD");
parcelRequire("iQCJJ");
parcelRequire("fjPtF");
parcelRequire("2R2to");

var $lIZQG = parcelRequire("lIZQG");
const $849cd54ac4017470$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $849cd54ac4017470$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $849cd54ac4017470$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$849cd54ac4017470$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $849cd54ac4017470$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$849cd54ac4017470$var$isEditable(e.target) && !$849cd54ac4017470$var$ignoredKeys[e.key]);
const $849cd54ac4017470$export$25d1b8252b4c49b7 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $849cd54ac4017470$var$key$;
const $849cd54ac4017470$var$flush$ = new (0, $cab1K.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$849cd54ac4017470$export$2e2bcd8739ae039 = ()=>{
    if (!$849cd54ac4017470$var$key$) {
        $849cd54ac4017470$var$key$ = false ? new (0, $cab1K.Subject)() : (0, $kVLXA.Observable).fromEvent(document, 'keydown').filter($849cd54ac4017470$var$isRelevantKeyEvent).filter($849cd54ac4017470$export$25d1b8252b4c49b7).map((0, $lIZQG.toKeyWithModifiers));
        const sequence$ = $849cd54ac4017470$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $849cd54ac4017470$var$key$ = $849cd54ac4017470$var$key$.debounceTime(1000).startWith(null).merge($849cd54ac4017470$var$flush$).switchMapTo(sequence$);
    }
    return $849cd54ac4017470$var$key$;
};
const $849cd54ac4017470$export$4909b86c8034bf73 = ()=>{
    $849cd54ac4017470$var$flush$.next();
};

});
parcelRegister("lIZQG", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $ca3344250c7b7406$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $ca3344250c7b7406$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $ca3344250c7b7406$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $ca3344250c7b7406$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $ca3344250c7b7406$var$toKey = (e)=>{
    if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});


parcelRegister("4lkOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f11d50ddafbb6f85$export$2e2bcd8739ae039);

var $h0GOb = parcelRequire("h0GOb");

var $k4r7E = parcelRequire("k4r7E");
const $f11d50ddafbb6f85$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$f11d50ddafbb6f85$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $k4r7E.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $h0GOb.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($f11d50ddafbb6f85$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $h0GOb.flush)();
    }
};

});
parcelRegister("k4r7E", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $a65fecdbaed23de2$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $lbWm4 = parcelRequire("lbWm4");

var $561FV = parcelRequire("561FV");

var $hGgHi = parcelRequire("hGgHi");

var $FISJv = parcelRequire("FISJv");

var $lIZQG = parcelRequire("lIZQG");
const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $lIZQG.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $lIZQG.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $lIZQG.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($FISJv)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();

});


parcelRegister("9fuVs", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $1dd87679d9ca363b$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $1dd87679d9ca363b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $k4r7E = parcelRequire("k4r7E");
const $1dd87679d9ca363b$export$ebbb59327adb551a = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $k4r7E.rootRegistry));
const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $5uXOq.useMemo)(()=>new (0, $k4r7E.ShortcutRegistry)(), []);
    const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, $k4r7E.rootRegistry);
    (0, $5uXOq.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;

});

parcelRegister("kspvB", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $f9e30ab2465f6f16$export$77477772a9b904da);

var $dJl1T = parcelRequire("dJl1T");
const $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
        try {
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $f9e30ab2465f6f16$export$77477772a9b904da = (keyMap, location)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
            }
        }), {});

});




parcelRegister("4z5Te", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0d6e715a08c4bca$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $8QpSo = parcelRequire("8QpSo");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");

var $bC2fB = parcelRequire("bC2fB");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $ls5Mw = parcelRequire("ls5Mw");
const $a0d6e715a08c4bca$var$onScrollAttemptedFactory = (0, $8QpSo.default)((columnCount, rapidViewId)=>(scrollChanged, analyticsEvent)=>{
        analyticsEvent.update({
            action: scrollChanged ? 'scrolled' : 'clicked'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
            columnCount: columnCount,
            rapidViewId: rapidViewId
        });
    });
const $a0d6e715a08c4bca$var$onShowFactory = (0, $8QpSo.default)((columnCount, rapidViewId)=>(analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
            columnCount: columnCount,
            rapidViewId: rapidViewId
        });
    });
const $a0d6e715a08c4bca$var$mergeProps = (stateProps, dispatchProps, ownProps)=>{
    const { rapidViewId: rapidViewId, columnCount: columnCount } = stateProps;
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        onScrollAttempted: $a0d6e715a08c4bca$var$onScrollAttemptedFactory(columnCount, rapidViewId),
        onShow: $a0d6e715a08c4bca$var$onShowFactory(columnCount, rapidViewId)
    };
};
var $a0d6e715a08c4bca$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $2OMDV.AnalyticsEventToProps)('minimap', {
    onScrollAttempted: 'scrollAttempted',
    onShow: 'showed'
}), (0, $bC2fB.connect)((state)=>({
        externalId: 'software.board.minimap',
        rapidViewId: (0, $67Z81.rapidViewIdSelector)(state),
        columnCount: (0, $5mTgl.columnsWithResolutionSelector)(state).length
    }), null, $a0d6e715a08c4bca$var$mergeProps))((0, $ls5Mw.default));

});
parcelRegister("ls5Mw", function(module, exports) {

$parcel$export(module.exports, "default", () => $972f34c73d65dd85$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ // eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fr1K2 = parcelRequire("fr1K2");

var $fOVFI = parcelRequire("fOVFI");

var $39xOx = parcelRequire("39xOx");

var $axmY8 = parcelRequire("axmY8");

var $f8CI1 = parcelRequire("f8CI1");

var $lfTZh = parcelRequire("lfTZh");

var $b8gJu = parcelRequire("b8gJu");

var $8wbel = parcelRequire("8wbel");

var $29z1D = parcelRequire("29z1D");

const $972f34c73d65dd85$var$BoardMinimap = (props)=>{
    const { isOpen: isNextBestTaskPanelOpen } = (0, $f8CI1.useNextBestTaskPanel)();
    const didMountRef = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (didMountRef.current) // only execute the logic at state update, not on initial mount.
        // important to delay to wait the animation complete so we get accurate measure of NBT panel for scrollWidth !!!
        setTimeout(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        ()=>window.dispatchEvent(new Event((0, $b8gJu.UPDATE_BOARD_SCROLL_POSITION))), (0, $axmY8.ANIMATION_TIMEOUT) + 100);
        didMountRef.current = true;
    }, [
        isNextBestTaskPanelOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $29z1D.default), (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(props, 'columnCount'), isNextBestTaskPanelOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($972f34c73d65dd85$var$NextBestTaskColumn, null), (0, (/*@__PURE__*/$parcel$interopDefault($fOVFI)))(props.columnCount, (key)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wbel.default), {
            key: key
        })));
};
const $972f34c73d65dd85$var$MiniMap = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "board-minimap",
        packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        fallback: null,
        name: "board-minimap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($972f34c73d65dd85$var$BoardMinimap, props)));
var $972f34c73d65dd85$export$2e2bcd8739ae039 = $972f34c73d65dd85$var$MiniMap;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $972f34c73d65dd85$var$NextBestTaskColumn = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _16jlkb7n _1o9zidpf _i0dl1wug _1dqonqa1 _1h6d1yrq _bfhktxrc _2hwxv77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fOVFI", function(module, exports) {

var $l2xln = parcelRequire("l2xln");

var $2KOtB = parcelRequire("2KOtB");

var $kPZpS = parcelRequire("kPZpS");
/** Used as references for various `Number` constants. */ var $b84842ed891355b2$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used as references for the maximum length and index of an array. */ var $b84842ed891355b2$var$MAX_ARRAY_LENGTH = 4294967295;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b84842ed891355b2$var$nativeMin = Math.min;
/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */ function $b84842ed891355b2$var$times(n, iteratee) {
    n = $kPZpS(n);
    if (n < 1 || n > $b84842ed891355b2$var$MAX_SAFE_INTEGER) return [];
    var index = $b84842ed891355b2$var$MAX_ARRAY_LENGTH, length = $b84842ed891355b2$var$nativeMin(n, $b84842ed891355b2$var$MAX_ARRAY_LENGTH);
    iteratee = $2KOtB(iteratee);
    n -= $b84842ed891355b2$var$MAX_ARRAY_LENGTH;
    var result = $l2xln(length, iteratee);
    while(++index < n)iteratee(index);
    return result;
}
module.exports = $b84842ed891355b2$var$times;

});

parcelRegister("axmY8", function(module, exports) {

$parcel$export(module.exports, "NBT_TASK_TYPES", () => $1c70475fc99a2c16$export$c57a079f40d2a99d);
$parcel$export(module.exports, "WORK_SUGGESTIONS_TASK_TYPES", () => $1c70475fc99a2c16$export$3fee72c065a0af0e);
$parcel$export(module.exports, "ITEMS_PER_BATCH", () => $1c70475fc99a2c16$export$9e952e4d801fa8ed);
$parcel$export(module.exports, "NEXT_BEST_TASK_ANALYTICS", () => $1c70475fc99a2c16$export$55230ca85072e545);
$parcel$export(module.exports, "ERROR_BOUNDARY_PACKAGE", () => $1c70475fc99a2c16$export$e6c43e0cbc9a213a);
$parcel$export(module.exports, "PANEL_WIDTH", () => $1c70475fc99a2c16$export$e05cfff20e9274e6);
$parcel$export(module.exports, "PANEL_WIDTH_WITH_MARGIN", () => $1c70475fc99a2c16$export$8603bff3dda8aaad);
$parcel$export(module.exports, "PANEL_HEADER_HEIGHT", () => $1c70475fc99a2c16$export$c33dba4345ee2db8);
$parcel$export(module.exports, "ANIMATION_TIMEOUT", () => $1c70475fc99a2c16$export$fdd30d204cbe80e6);
$parcel$export(module.exports, "ARTICLE_ID", () => $1c70475fc99a2c16$export$7147685613ef9998);
$parcel$export(module.exports, "DEV_DETAILS_DIALOG_SCOPE_ID", () => $1c70475fc99a2c16$export$6bc465585d114926);
$parcel$export(module.exports, "DEV_DETAILS_DEPLOYMENT_PANEL_TYPE", () => $1c70475fc99a2c16$export$5653d49c1e9688e9);
$parcel$export(module.exports, "DEV_DETAILS_BUILD_PANEL_TYPE", () => $1c70475fc99a2c16$export$43925e5456315f);
$parcel$export(module.exports, "NEXT_BEST_TASK_USER_PROPERTIES_SCOPE", () => $1c70475fc99a2c16$export$ec5e18bceb05348c);
$parcel$export(module.exports, "WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_PANEL_NAME", () => $1c70475fc99a2c16$export$a038bf8f85264e8b);
$parcel$export(module.exports, "WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_VIEW_SETTINGS_STEP_NAME", () => $1c70475fc99a2c16$export$3a12d4773adf4b46);
$parcel$export(module.exports, "GITHUB_ONBOARDING_LOCAL_STORAGE_FINISHED_NAMESPACE", () => $1c70475fc99a2c16$export$a95989662296427);
$parcel$export(module.exports, "GITHUB_ONBOARDING_FINISHED_LOCAL_STORAGE_TTL_IN_MS", () => $1c70475fc99a2c16$export$4a742eb709905e27);
$parcel$export(module.exports, "WORK_SUGGESTIONS_SPOTLIGHT_MESSAGE_ID", () => $1c70475fc99a2c16$export$7d212d7793dfc186);


const $1c70475fc99a2c16$export$8b57ff3b8c315540 = {
    PULL_REQUEST_REVIEW: 'PR_REVIEW',
    PULL_REQUEST_NEEDS_WORK: 'PR_NEEDS_WORK',
    FAILED_DEPLOYMENT: 'DEPLOYMENT_FAILED',
    FAILED_BUILD: 'BUILD_FAILED',
    CRIT_VULN: 'CRIT_VULN',
    BLOCKING_ISSUE: 'BLOCKING_ISSUE',
    PR_DRAFT: 'PR_DRAFT',
    PR_STALE: 'PR_STALE',
    PR_MERGEABLE: 'PR_MERGEABLE',
    PR_COMMENTS: 'PR_COMMENTS'
};
const $1c70475fc99a2c16$export$c57a079f40d2a99d = {
    InsightsBuildTask: 'BUILD_FAILED',
    InsightsDeploymentTask: 'DEPLOYMENT_FAILED',
    InsightsPullRequestReviewTask: 'PR_REVIEW',
    InsightsPullRequestNeedsWorkTask: 'PR_NEEDS_WORK',
    InsightsCriticalVulnerabilityTask: 'CRIT_VULN',
    InsightsBlockingIssueTask: 'BLOCKING_ISSUE'
};
const $1c70475fc99a2c16$export$3fee72c065a0af0e = {
    WorkSuggestionsBuildTask: 'BUILD_FAILED',
    WorkSuggestionsDeploymentTask: 'DEPLOYMENT_FAILED',
    WorkSuggestionsPullRequestReviewTask: 'PR_REVIEW',
    WorkSuggestionsPullRequestNeedsWorkTask: 'PR_NEEDS_WORK',
    WorkSuggestionsCriticalVulnerabilityTask: 'CRIT_VULN',
    WorkSuggestionsBlockingIssueTask: 'BLOCKING_ISSUE',
    WorkSuggestionsPullRequestDraftTask: 'PR_DRAFT',
    WorkSuggestionsPullRequestInactiveTask: 'PR_STALE',
    WorkSuggestionsPRMergeableTask: 'PR_MERGEABLE',
    WorkSuggestionsPRCommentsTask: 'PR_COMMENTS'
};
const $1c70475fc99a2c16$export$206ba94a466bfde8 = {
    REPO: 'repo',
    APPROVALS: 'approvals',
    COMMENT: 'comment',
    ISSUEKEY: 'issuekey',
    ENVIRONMENT: 'environment',
    UPDATED: 'updated',
    SECURITY_CONTAINER_NAME: 'securityContainerName',
    STATUS: 'status',
    TITLE: 'title',
    INTRODUCED_DATE: 'introducedDate'
};
const $1c70475fc99a2c16$export$b8b9d90f9e5bd72b = 'jiraInsightsNextBestTask';
const $1c70475fc99a2c16$export$9e952e4d801fa8ed = 3;
const $1c70475fc99a2c16$export$b3f5ac625a3b4df0 = 'nextBestTask';
const $1c70475fc99a2c16$export$55230ca85072e545 = `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.${$1c70475fc99a2c16$export$b3f5ac625a3b4df0}`;
const $1c70475fc99a2c16$export$a03b7ee31a7850cc = {
    ACTION_SUBJECT: `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}`,
    ACTION_SUBJECT_ID: `${$1c70475fc99a2c16$export$b3f5ac625a3b4df0}`
};
const $1c70475fc99a2c16$export$8dfcc2329f051083 = `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.next-best-task`;
const $1c70475fc99a2c16$export$e6c43e0cbc9a213a = $1c70475fc99a2c16$export$8dfcc2329f051083;
const $1c70475fc99a2c16$export$e05cfff20e9274e6 = 272;
const $1c70475fc99a2c16$export$91fd62fa237e57ae = 450;
const $1c70475fc99a2c16$export$8603bff3dda8aaad = $1c70475fc99a2c16$export$e05cfff20e9274e6 + 2;
const $1c70475fc99a2c16$export$ea74a331a4211d3f = 49; // extra 1px for top border
const $1c70475fc99a2c16$export$c33dba4345ee2db8 = $1c70475fc99a2c16$export$ea74a331a4211d3f;
const $1c70475fc99a2c16$export$fdd30d204cbe80e6 = 600;
const $1c70475fc99a2c16$export$7147685613ef9998 = '2HtqtVTfYoilHIuYJIGD1T';
const $1c70475fc99a2c16$export$6bc465585d114926 = 'jira-insights-next-best-task';
const $1c70475fc99a2c16$export$5653d49c1e9688e9 = (0, $61a2cd6236d50c20$export$90cac6260ae9ced5);
const $1c70475fc99a2c16$export$43925e5456315f = (0, $61a2cd6236d50c20$export$74a388a09f2a004e);
const $1c70475fc99a2c16$export$677d2c355966ef8d = 'jira.insights.next-best-task.last-opened-task-ids';
const $1c70475fc99a2c16$export$ec5e18bceb05348c = 'jira.insights.next-best-task.user-properties';
const $1c70475fc99a2c16$export$8217db641c4c0a89 = 86400000;
const $1c70475fc99a2c16$export$6610ba860f2307cd = 14 * $1c70475fc99a2c16$export$8217db641c4c0a89;
const $1c70475fc99a2c16$export$b504dbc209245786 = 180 * $1c70475fc99a2c16$export$8217db641c4c0a89;
const $1c70475fc99a2c16$export$75cf347d8d9fe592 = 'jira-insights-next-best-task';
const $1c70475fc99a2c16$export$b94951a11282ae6a = 'work-suggestions-github-onboarding-hidden';
const $1c70475fc99a2c16$export$a038bf8f85264e8b = 'workSuggestionsViewSettingsSpotlightPanel';
const $1c70475fc99a2c16$export$3a12d4773adf4b46 = 'workSuggestionsViewSettingsSpotlightViewSettings';
const $1c70475fc99a2c16$export$a95989662296427 = 'work-suggestions-github-onboarding-finished';
const $1c70475fc99a2c16$export$4a742eb709905e27 = 259200000; // 3 days
const $1c70475fc99a2c16$export$7d212d7793dfc186 = 'jira-work-suggestions-spotlight';

});
const $61a2cd6236d50c20$export$e18d81f044132a0e = 'branch';
const $61a2cd6236d50c20$export$74a388a09f2a004e = 'build';
const $61a2cd6236d50c20$export$2e42513c7764d5f3 = 'repository';
const $61a2cd6236d50c20$export$3f1e2b276d607490 = 'review';
const $61a2cd6236d50c20$export$90cac6260ae9ced5 = 'deployment-environment';
const $61a2cd6236d50c20$export$6f74b53d652f13f3 = 'pullrequest';
const $61a2cd6236d50c20$export$c69477f358d30f7e = 'feature-flags';
const $61a2cd6236d50c20$export$56470bdd9cd798d0 = 'remote-links';
const $61a2cd6236d50c20$export$3da53566eda5eeef = 'jira.fe.issue.dev-details.time-to.load';
const $61a2cd6236d50c20$export$b4bb784d069c9ab = 'development.details.details-header';
const $61a2cd6236d50c20$export$74189cec821240a6 = 'development.details.remote-links';

const $b0e6fec6a4686296$export$d3996f57ffa8448f = 'jira.insights';
const $b0e6fec6a4686296$export$c9290acd1ba498ff = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.board`;
const $b0e6fec6a4686296$export$2fd6d7f902b01d67 = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.backlog`;
const $b0e6fec6a4686296$export$8e66b21ec141a0bd = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.board-simplified`;
const $b0e6fec6a4686296$export$75eb9639a5b0ba25 = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.backlog-simplified`;
const $b0e6fec6a4686296$export$1269ea4f2b198811 = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.error-boundary`;


parcelRegister("f8CI1", function(module, exports) {

$parcel$export(module.exports, "useNextBestTaskPanel", () => $077be93b9454ff5d$export$9fac49065b5c5925);

var $ipmBb = parcelRequire("ipmBb");

var $dIdda = parcelRequire("dIdda");

var $02beV = parcelRequire("02beV");
const $077be93b9454ff5d$export$9fac49065b5c5925 = ()=>{
    const [{ isAutoOpened: isAutoOpened, isHiddenByUser: isHiddenByUser, isNbtToggleButtonVisible: isNbtToggleButtonVisible, isOnlyCurrentUserSelected: isOnlyCurrentUserSelected }, { setIsAutoOpened: setIsAutoOpened, setIsNbtToggleButtonVisible: setIsNbtToggleButtonVisible }] = (0, $02beV.useNextBestTaskContainer)();
    const { data: isWorkSuggestionsEnabledData } = (0, $dIdda.useResource)((0, $ipmBb.nextBestTaskFeatureResource));
    const hasUserOptedIn = !!isWorkSuggestionsEnabledData?.hasUserOptedIn;
    const isReadyToFetchNBT = isOnlyCurrentUserSelected && hasUserOptedIn && !isHiddenByUser;
    const isOpen = isReadyToFetchNBT && isAutoOpened;
    return {
        isReadyToFetchNBT: isReadyToFetchNBT,
        isOpen: isOpen,
        isAutoOpened: isAutoOpened,
        isNbtToggleButtonVisible: isNbtToggleButtonVisible,
        setIsAutoOpened: setIsAutoOpened,
        isHiddenByUser: isHiddenByUser,
        setIsNbtToggleButtonVisible: setIsNbtToggleButtonVisible
    };
};

});
parcelRegister("02beV", function(module, exports) {

$parcel$export(module.exports, "NextBestTaskContainer", () => $b515259196675246$export$d36ece0b77b25b77);
$parcel$export(module.exports, "useNextBestTaskContainer", () => $b515259196675246$export$4e9c40fce9aa102);
$parcel$export(module.exports, "useNextBestTaskActions", () => $b515259196675246$export$7f6f764b43177343);

var $7JoAD = parcelRequire("7JoAD");

var $5VKYm = parcelRequire("5VKYm");
const $b515259196675246$export$7dd0e8f7db9f5f6f = [];
// This is the value of the store on initialisation
const $b515259196675246$var$initialState = {
    sprints: $b515259196675246$export$7dd0e8f7db9f5f6f,
    isAutoOpened: false,
    isNbtToggleButtonVisible: false,
    isOnlyCurrentUserSelected: false,
    isHiddenByUser: false,
    queryGithubOnboardingRef: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onIssueOpen: ()=>{},
    activeViewSettingsSpotlight: null,
    hasViewedViewSettingsSpotlight: true,
    openViewSettings: null,
    viewSettingsTogglePulses: false
};
const $b515259196675246$var$Store = (0, $7JoAD.createStore)({
    initialState: $b515259196675246$var$initialState,
    actions: $5VKYm.actions,
    name: 'jira.insights.next-best-task-store'
});
const $b515259196675246$export$78c85c0bf5f7e99b = ()=>(0, $7JoAD.defaultRegistry).deleteStore($b515259196675246$var$Store);
const $b515259196675246$var$handlePropsChange = ()=>({ setState: setState }, { accountId: accountId, boardId: boardId, isCMPBoard: isCMPBoard, sprints: sprints, onIssueOpen: onIssueOpen })=>{
        setState({
            accountId: accountId,
            boardId: boardId,
            isCMPBoard: isCMPBoard,
            sprints: sprints,
            onIssueOpen: onIssueOpen
        });
    };
const $b515259196675246$export$e26874c6341f398 = (0, $7JoAD.createHook)($b515259196675246$var$Store, {
    selector: (state)=>state.sprints || $b515259196675246$export$7dd0e8f7db9f5f6f
});
const $b515259196675246$export$d36ece0b77b25b77 = (0, $7JoAD.createContainer)($b515259196675246$var$Store, {
    onInit: $b515259196675246$var$handlePropsChange,
    onUpdate: $b515259196675246$var$handlePropsChange
});
const $b515259196675246$export$4e9c40fce9aa102 = (0, $7JoAD.createHook)($b515259196675246$var$Store);
const $b515259196675246$export$7f6f764b43177343 = (0, $7JoAD.createActionsHook)($b515259196675246$var$Store);

});
parcelRegister("5VKYm", function(module, exports) {

$parcel$export(module.exports, "actions", () => $c86e62d820c3f13d$export$e324594224ef24da);
const $c86e62d820c3f13d$export$e324594224ef24da = {
    setIsAutoOpened: (isAutoOpened)=>({ setState: setState })=>{
            setState({
                isAutoOpened: isAutoOpened
            });
        },
    setIsNbtToggleButtonVisible: (isNbtToggleButtonVisible)=>({ setState: setState })=>{
            setState({
                isNbtToggleButtonVisible: isNbtToggleButtonVisible
            });
        },
    setIsOnlyCurrentUserSelected: (isOnlyCurrentUserSelected)=>({ setState: setState })=>{
            if (!isOnlyCurrentUserSelected) setState({
                isOnlyCurrentUserSelected: isOnlyCurrentUserSelected,
                isAutoOpened: false,
                isHiddenByUser: false
            });
            else setState({
                isOnlyCurrentUserSelected: isOnlyCurrentUserSelected
            });
        },
    setQueryGithubOnboardingRef: (queryGithubOnboardingRef)=>({ getState: getState, setState: setState })=>{
            if (getState().queryGithubOnboardingRef == null) setState({
                queryGithubOnboardingRef: queryGithubOnboardingRef
            });
        },
    onViewSettingsSpotlightInit: ()=>({ setState: setState })=>{
            setState({
                hasViewedViewSettingsSpotlight: false
            });
        },
    onViewSettingsSpotlightStart: ()=>({ setState: setState })=>{
            setState({
                activeViewSettingsSpotlight: 0
            });
        },
    onViewSettingsSpotlightNext: ()=>({ setState: setState })=>{
            setState({
                activeViewSettingsSpotlight: 1
            });
        },
    onViewSettingsSpotlightEnd: ()=>({ setState: setState })=>{
            setState({
                hasViewedViewSettingsSpotlight: true,
                activeViewSettingsSpotlight: null
            });
        },
    setOpenViewSettings: (openViewSettingsCallback)=>({ getState: getState, setState: setState })=>{
            if (!getState().openViewSettings) setState({
                openViewSettings: openViewSettingsCallback
            });
        },
    setViewSettingsTogglePulses: (viewSettingsTogglePulses)=>({ setState: setState })=>{
            setState({
                viewSettingsTogglePulses: viewSettingsTogglePulses
            });
        },
    setIsHiddenByUser: (isHiddenByUser)=>({ setState: setState })=>{
            setState({
                isHiddenByUser: isHiddenByUser
            });
        }
};

});



parcelRegister("8wbel", function(module, exports) {

$parcel$export(module.exports, "default", () => $28fe4393b090c277$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");


var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $28fe4393b090c277$var$SC1Control = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1wm91pe-0"
})({
    borderRadius: '3px',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N30})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + div': {
        marginLeft: "var(--ds-space-025, 2px)"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $28fe4393b090c277$var$SC1Experiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _16jlkb7n _1o9zidpf _i0dl1wug _11q71yrq _1s87v77o",
            __cmplp.className
        ])
    });
});
const $28fe4393b090c277$var$SC1 = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $28fe4393b090c277$var$SC1Experiment, $28fe4393b090c277$var$SC1Control);
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$28fe4393b090c277$export$2e2bcd8739ae039 = $28fe4393b090c277$var$SC1;

});

parcelRegister("29z1D", function(module, exports) {

$parcel$export(module.exports, "default", () => $108e7ab3bfa0ea7c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $euZim = parcelRequire("euZim");


var $clPgE = parcelRequire("clPgE");
const $108e7ab3bfa0ea7c$var$shouldShowMap = ({ scrollWidth: scrollWidth, clientWidth: clientWidth })=>// @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
    scrollWidth / clientWidth > (0, $40c34f06e626eecd$export$7acdcdf60f910755);
class $108e7ab3bfa0ea7c$export$a8b4308ba35ee473 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            const { isShowing: isShowing } = this.state;
            const shouldShow = $108e7ab3bfa0ea7c$var$shouldShowMap(nextProps);
            if (shouldShow !== isShowing) {
                if (shouldShow) this.props.onShow();
                this.setState({
                    isShowing: shouldShow
                });
            }
        };
        this.onScroll = (newOffset)=>{
            const scalingFactor = this.getScalingFactor(this.props.scrollWidth);
            this.props.setHorizontalScroll(newOffset * scalingFactor);
        };
        this.getScalingFactor = (0, $8QpSo.default)((scrollWidth)=>{
            const maxSizeScalingFactor = scrollWidth / (0, $40c34f06e626eecd$export$35f810a0d3987157);
            return Math.max((0, $40c34f06e626eecd$export$a5b78b73dbea576), maxSizeScalingFactor);
        });
        const isShowing = $108e7ab3bfa0ea7c$var$shouldShowMap(props);
        if (isShowing) this.props.onShow();
        this.state = {
            isShowing: isShowing
        };
    }
    getDimensions() {
        const scalingFactor = this.getScalingFactor(this.props.scrollWidth);
        return {
            outerWidth: this.props.scrollWidth / scalingFactor,
            innerWidth: this.props.clientWidth / scalingFactor,
            innerOffset: this.props.scrollLeft / scalingFactor
        };
    }
    render() {
        if (!this.state.isShowing) return null;
        const { outerWidth: outerWidth, innerWidth: innerWidth, innerOffset: innerOffset } = this.getDimensions();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clPgE.default), {
            onScrollAttempted: this.props.onScrollAttempted,
            onScroll: this.onScroll,
            outerWidth: outerWidth,
            innerWidth: innerWidth,
            innerOffset: innerOffset
        }, this.props.children);
    }
}
const $108e7ab3bfa0ea7c$var$MinimapMain = (props)=>{
    const [{ clientWidth: clientWidth, scrollLeft: scrollLeft, scrollWidth: scrollWidth }, { onHorizontalScroll: onHorizontalScroll }] = (0, $euZim.useBoardScroll)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($108e7ab3bfa0ea7c$export$a8b4308ba35ee473, {
        clientWidth: clientWidth,
        scrollLeft: scrollLeft,
        scrollWidth: scrollWidth,
        setHorizontalScroll: onHorizontalScroll,
        ...props
    });
};
var $108e7ab3bfa0ea7c$export$2e2bcd8739ae039 = $108e7ab3bfa0ea7c$var$MinimapMain;

});
/**
 * The width of the map is determined by the board size / scaling factor.
 * A lower number means a wider minimap.
 * The map will not exceed the maxMapWidth defined below.
 */ const $40c34f06e626eecd$export$a5b78b73dbea576 = 14;
const $40c34f06e626eecd$export$35f810a0d3987157 = 100;
const $40c34f06e626eecd$export$7acdcdf60f910755 = 1.1;

parcelRegister("clPgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c221fc28899be2cf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");


var $9QpK7 = parcelRequire("9QpK7");

var $645AZ = parcelRequire("645AZ");

var $9TMLn = parcelRequire("9TMLn");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c221fc28899be2cf$var$RelativePositionStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $c221fc28899be2cf$var$MinimapStyleOld = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1oa7p3z-0"
})({
    display: 'inline-flex',
    padding: "var(--ds-space-075, 6px)",
    background: "var(--ds-surface-overlay, white)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    boxShadow: `var(--ds-shadow-overlay, ${`4px 8px 14px 0 ${(0, $829f609a65d26a98$exports).N50A}`})`,
    borderRadius: '3px'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c221fc28899be2cf$var$MinimapStyleNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _1yt412x7 _11q71bhr _16qsacve _2rkoftgi",
            __cmplp.className
        ])
    });
});
const $c221fc28899be2cf$export$60ba57ef3cc9f0b = (0, $9QpK7.componentWithFF)('compiled.migration.jsw.tanuki', $c221fc28899be2cf$var$MinimapStyleNew, $c221fc28899be2cf$var$MinimapStyleOld);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $c221fc28899be2cf$var$OuterViewStyleOld = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1oa7p3z-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${props.outerWidth}px`,
        border: `1px solid ${"var(--ds-surface-overlay, white)"}`,
        borderRadius: '3px',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${0, $645AZ.miniMapMapHeight}px`
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c221fc28899be2cf$var$OuterViewStyleNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { outerWidth: outerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_qlyx8j": (0, $lD23V.default)(`${__cmplp.outerWidth}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbrmio _2rko1l7b _189et94y _1h6d1bhr _1e0c1txw _4t3i14no",
            __cmplp.className
        ])
    });
});
const $c221fc28899be2cf$var$OuterViewStyle = (0, $9QpK7.componentWithFF)('compiled.migration.jsw.tanuki', $c221fc28899be2cf$var$OuterViewStyleNew, $c221fc28899be2cf$var$OuterViewStyleOld);
class $c221fc28899be2cf$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c221fc28899be2cf$export$60ba57ef3cc9f0b, {
            "data-testid": "platform-board-kit.ui.minimap"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c221fc28899be2cf$var$RelativePositionStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9TMLn.default), {
            onScroll: this.props.onScroll,
            onScrollAttempted: this.props.onScrollAttempted,
            innerOffset: this.props.innerOffset,
            innerWidth: this.props.innerWidth
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c221fc28899be2cf$var$OuterViewStyle, {
            outerWidth: this.props.outerWidth
        }, this.props.children));
    }
}

});
parcelRegister("9TMLn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c336701012e01494$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");


var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $645AZ = parcelRequire("645AZ");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c336701012e01494$var$InnerViewStyleControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "cg5gtg-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        top: "var(--ds-space-negative-025, -2px)",
        left: "var(--ds-space-negative-025, -2px)",
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        border: `2px solid ${`var(--ds-border-brand, ${(0, $829f609a65d26a98$exports).B100})`}`,
        borderRadius: '3px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${props.innerWidth}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${0, $645AZ.miniMapMapHeight}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderColor: props.isDragging ? // This looks different in dark mode but the colors used match between none/light/dark
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B200})` : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(--ds-border-brand, ${(0, $829f609a65d26a98$exports).B100})`,
        cursor: 'move'
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c336701012e01494$var$InnerViewStyleExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { innerWidth: innerWidth, isDragging: isDragging, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ekimo8": (0, $lD23V.default)(__cmplp.innerWidth, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_154i1i6y _1ltv1i6y _kqswstnw _19itypf5 _2rko1l7b _1bsb1mf3 _4t3i14no _80om15ng",
            __cmplp.isDragging ? "_1h6d194a" : "_1h6d1gvp",
            __cmplp.className
        ])
    });
});
const $c336701012e01494$var$InnerViewStyle = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $c336701012e01494$var$InnerViewStyleExperiment, $c336701012e01494$var$InnerViewStyleControl); // eslint-disable-next-line jira/react/no-class-components
class $c336701012e01494$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.onMouseDown = (e)=>{
            if (e.button === 0) this.setState({
                isDragging: true,
                mouseStart: e.clientX,
                initialOffset: this.props.innerOffset
            });
        };
        this.onMouseUp = ()=>{
            // Because we have two mouseup event handlers, this can be fired twice
            // if the mouseup is over the minimap square.
            if (this.state.isDragging) {
                const scrollChanged = this.props.innerOffset !== this.state.initialOffset;
                this.props.onScrollAttempted(scrollChanged);
                this.setState({
                    isDragging: false
                });
            }
        };
        this.onMouseMove = (e)=>{
            if (this.state.isDragging && this.state.mouseStart !== null) {
                const mouseCurrent = e.clientX;
                this.props.onScroll(this.state.initialOffset + mouseCurrent - this.state.mouseStart);
            }
        };
        this.setElement = (element)=>{
            this.element = element;
            this.updateInnerViewPosition();
        };
        this.updateInnerViewPosition = ()=>{
            if (this.element) this.element.style.marginLeft = `${this.props.innerOffset}px`;
        };
        this.element = null;
        this.state = {
            isDragging: false,
            mouseStart: null,
            initialOffset: 0
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.isDragging && !prevState.isDragging) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.addEventListener('mousemove', this.onMouseMove); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.addEventListener('mouseup', this.onMouseUp);
        } else if (!this.state.isDragging && !prevState.isDragging) this.cleanupListeners();
        this.updateInnerViewPosition();
    }
    componentWillUnmount() {
        this.cleanupListeners();
    }
    cleanupListeners() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('mousemove', this.onMouseMove); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('mouseup', this.onMouseUp);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c336701012e01494$var$InnerViewStyle, {
            "data-testid": "platform-board-kit.ui.minimap.inner-view",
            innerRef: this.setElement,
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            onMouseMove: this.onMouseMove,
            isDragging: this.state.isDragging,
            innerWidth: this.props.innerWidth
        });
    }
}

});





parcelRegister("8ydSK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd6e5a7a8081ebaf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7wqBZ = parcelRequire("7wqBZ");

var $i9qZF = parcelRequire("i9qZF");

var $4wg4d = parcelRequire("4wg4d");

var $bC2fB = parcelRequire("bC2fB");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");
const $bd6e5a7a8081ebaf$export$c7cad6b3e396923a = ({ columns: columns, swimlanes: swimlanes, boardSessionId: boardSessionId })=>{
    const onStartScrollingObserver = (0, $5uXOq.useCallback)(()=>{
        (0, $7wqBZ.getLongTasksMetrics)('scroll').start('board', undefined, {
            swimlaneCount: swimlanes.length,
            columnCount: columns.length,
            boardSessionId: boardSessionId
        });
    }, [
        swimlanes,
        columns,
        boardSessionId
    ]);
    const onStopScrollingObserver = (0, $5uXOq.useCallback)(()=>{
        (0, $7wqBZ.getLongTasksMetrics)('scroll').stop((0, $i9qZF.boardScrollReporter));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4wg4d.default), {
        onScrollStart: onStartScrollingObserver,
        onScrollStop: onStopScrollingObserver
    });
};
const $bd6e5a7a8081ebaf$var$mapStateToProps = (state)=>({
        columns: (0, $5mTgl.columnsWithResolutionSelector)(state),
        swimlanes: (0, $5mTgl.platformSwimlanesSelector)(state),
        boardSessionId: (0, $67Z81.sessionIdSelector)(state)
    });
const $bd6e5a7a8081ebaf$var$ScrollObserverConnected = (0, $bC2fB.connect)($bd6e5a7a8081ebaf$var$mapStateToProps, {})($bd6e5a7a8081ebaf$export$c7cad6b3e396923a);
var $bd6e5a7a8081ebaf$export$2e2bcd8739ae039 = $bd6e5a7a8081ebaf$var$ScrollObserverConnected;

});
parcelRegister("7wqBZ", function(module, exports) {

$parcel$export(module.exports, "getLongTasksMetrics", () => $f85af650a825558e$export$b092a8653a66aa5e);

var $gJBT6 = parcelRequire("gJBT6");

var $x9xyg = parcelRequire("x9xyg");

var $6RCeq = parcelRequire("6RCeq");

var $cJpFl = parcelRequire("cJpFl");
let $f85af650a825558e$var$observer = null;
const $f85af650a825558e$var$stopObserver = ()=>{
    if ($f85af650a825558e$var$observer) {
        $f85af650a825558e$var$observer.disconnect();
        $f85af650a825558e$var$observer = null;
    }
};
const $f85af650a825558e$export$b092a8653a66aa5e = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((type)=>{
    const clearData = {
        type: type
    };
    let isStarted = false;
    let observationData = {
        ...clearData
    };
    const isDnd = /dnd$/.test(type.toLowerCase());
    return {
        start: (appName, startPerformanceMark, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.PerformanceObserver && !isStarted) try {
                const startTimestamp = (0, $6RCeq.default).now();
                observationData = {
                    type: observationData.type,
                    startTimestamp: startTimestamp,
                    dragStartEndTimestamp: startTimestamp,
                    eventStartPerformanceMark: startPerformanceMark,
                    events: [],
                    appName: appName,
                    extra: extra
                };
                isStarted = true;
                $f85af650a825558e$var$stopObserver();
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                $f85af650a825558e$var$observer = new window.PerformanceObserver((list)=>{
                    list.getEntries().forEach((entry)=>{
                        if (entry.entryType === 'longtask') {
                            if (!(0, $cJpFl.isExpandedObservationData)(observationData) || observationData.events.find((item)=>item.timestamp === entry.startTime && item.duration === entry.duration)) return;
                            observationData.events.push({
                                timestamp: entry.startTime,
                                duration: entry.duration
                            });
                        } else if (entry.entryType === 'event' && entry.name === 'dragstart') /**
								 * Use the observed event to compute the "end" timestamp of the dragstart event,
								 * which will be used for splitting the long tasks for dragstart and dragmove.
								 */ observationData.dragStartEndTimestamp = entry.startTime + entry.duration;
                    });
                });
                $f85af650a825558e$var$observer.observe({
                    type: 'longtask'
                });
                if (isDnd) /**
						 * Observe events with >48ms duration.
						 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceObserver/observe
						 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                $f85af650a825558e$var$observer.observe({
                    type: 'event',
                    durationThreshold: 48
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
            } catch (e) {}
        },
        stop: (callback, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            if ((0, $6RCeq.default).now && isStarted) {
                const stopTimestamp = (0, $6RCeq.default).now();
                setTimeout(()=>{
                    $f85af650a825558e$var$stopObserver();
                    callback({
                        ...observationData
                    }, extra, stopTimestamp);
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                });
            }
        },
        stopIfNoMark: (performanceMark)=>{
            if ($f85af650a825558e$var$observer && performanceMark) {
                const perfMark = (0, $x9xyg.getMark)(performanceMark);
                if (!perfMark) {
                    $f85af650a825558e$var$stopObserver();
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                }
            }
        }
    };
});

});
parcelRegister("cJpFl", function(module, exports) {

$parcel$export(module.exports, "isExpandedObservationData", () => $3e1de7ace69512d1$export$3d38a87309e205a4);
const $3e1de7ace69512d1$export$3d38a87309e205a4 = (observationData)=>observationData !== undefined && 'events' in observationData && observationData.events !== undefined;

});


parcelRegister("i9qZF", function(module, exports) {

$parcel$export(module.exports, "boardScrollReporter", () => $c45b7a8a0198825d$export$8ac1de4fb430c833);

var $gZFbt = parcelRequire("gZFbt");

var $cJpFl = parcelRequire("cJpFl");

var $if7bx = parcelRequire("if7bx");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c45b7a8a0198825d$var$aggregatedDataTimeout = {};
const $c45b7a8a0198825d$export$8ac1de4fb430c833 = (observationData)=>{
    if ((0, $cJpFl.isExpandedObservationData)(observationData)) {
        const startTime = observationData.events.map((event)=>event.timestamp);
        const analyticsData = {
            ...(0, $if7bx.generateLongTaskAnalyticsContinuousActionSummary)('boardScroll', observationData.events),
            measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime)
        };
        const { appName: appName } = observationData;
        if ($c45b7a8a0198825d$var$aggregatedDataTimeout[`software.${appName}.boardScroll`]) $c45b7a8a0198825d$var$aggregatedDataTimeout[`software.${appName}.boardScroll`].data.push(analyticsData);
        else $c45b7a8a0198825d$var$aggregatedDataTimeout[`software.${appName}.boardScroll`] = {
            data: [
                analyticsData
            ],
            extra: observationData.extra,
            timeout: setTimeout(()=>{
                const { data: data, extra: extraData } = $c45b7a8a0198825d$var$aggregatedDataTimeout[`software.${appName}.boardScroll`];
                const triggerSoftwareAnalytics = (0, $if7bx.triggerAnalytics)(`software.${appName}`);
                triggerSoftwareAnalytics('long-tasks-board-scroll', {
                    ...(0, $if7bx.getAverageResultsFromContinuousActions)('boardScroll', data),
                    ...extraData,
                    avgScrollTimespan: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, 'measureTimespan')
                });
                delete $c45b7a8a0198825d$var$aggregatedDataTimeout[`software.${appName}.boardScroll`];
            }, 7000)
        };
    }
};

});
parcelRegister("gZFbt", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $520Yb = parcelRequire("520Yb");
/**
 * This method is like `_.mean` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be averaged.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the mean.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.meanBy(objects, function(o) { return o.n; });
 * // => 5
 *
 * // The `_.property` iteratee shorthand.
 * _.meanBy(objects, 'n');
 * // => 5
 */ function $c5f24a2590a3cbef$var$meanBy(array, iteratee) {
    return $520Yb(array, $bxDef(iteratee, 2));
}
module.exports = $c5f24a2590a3cbef$var$meanBy;

});
parcelRegister("520Yb", function(module, exports) {

var $gBzAF = parcelRequire("gBzAF");
/** Used as references for various `Number` constants. */ var $3a9de433504d679a$var$NAN = 0 / 0;
/**
 * The base implementation of `_.mean` and `_.meanBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the mean.
 */ function $3a9de433504d679a$var$baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? $gBzAF(array, iteratee) / length : $3a9de433504d679a$var$NAN;
}
module.exports = $3a9de433504d679a$var$baseMean;

});


parcelRegister("if7bx", function(module, exports) {

$parcel$export(module.exports, "triggerAnalytics", () => $3a39af364070fc96$export$2c57de8a70f64057);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummary", () => $3a39af364070fc96$export$2be2635781d23aab);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummaryWithSlo", () => $3a39af364070fc96$export$c674a20081e82c6a);
$parcel$export(module.exports, "getAverageResultsFromContinuousActions", () => $3a39af364070fc96$export$c36fdc326d0c207c);
$parcel$export(module.exports, "generateLongTaskAnalyticsContinuousActionSummary", () => $3a39af364070fc96$export$7e5f2df95eca342a);

var $gZFbt = parcelRequire("gZFbt");

var $iThRn = parcelRequire("iThRn");

var $6oxJH = parcelRequire("6oxJH");
const $3a39af364070fc96$export$2c57de8a70f64057 = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $3a39af364070fc96$export$2be2635781d23aab = (prefix, longTasks)=>{
    const durations = longTasks.map((task)=>task.duration);
    return {
        [`${prefix}LongTaskCount`]: longTasks.length,
        [`${prefix}LongTaskAvg`]: longTasks.length > 0 ? durations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0,
        [`${prefix}LongTaskMax`]: longTasks.length > 0 ? Math.max(...durations) : 0
    };
};
const $3a39af364070fc96$export$c674a20081e82c6a = (prefix, longTasks, sloSettings)=>{
    const summary = $3a39af364070fc96$export$2be2635781d23aab(prefix, longTasks);
    if (!sloSettings) return summary;
    const framerate = summary[`${prefix}LongTaskCount`] === 0 ? 20 : 1000 / summary[`${prefix}LongTaskAvg`];
    const blocktime = summary[`${prefix}LongTaskCount`] === 0 ? 0 : summary[`${prefix}LongTaskCount`] * summary[`${prefix}LongTaskAvg`];
    const isSuccess = framerate >= sloSettings.framerateThreshold && blocktime < sloSettings.blocktimeThreshold;
    return {
        [`${prefix}LongTaskSloIsSuccess`]: isSuccess,
        ...summary
    };
};
const $3a39af364070fc96$export$c36fdc326d0c207c = (prefix, data)=>({
        [`${prefix}ClusterCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($6oxJH)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterCountAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterAvg`) || 0,
        [`${prefix}ClusterDistanceAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterDistanceAvg`) || 0,
        [`${prefix}ClusterAvgLongTaskCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterAvgLongTaskCount`) || 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: data.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($iThRn)))(data.map((entry)=>entry[`${prefix}ClusterAvgLongTaskCount`] * entry[`${prefix}ClusterAvgLongTaskAvg`])) / (0, (/*@__PURE__*/$parcel$interopDefault($6oxJH)))(data, `${prefix}ClusterAvgLongTaskCount`) : 0,
        [`${prefix}Count`]: data.length
    });
const $3a39af364070fc96$export$7e5f2df95eca342a = (prefix, longTasks)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const clusters = longTasks.reduce((foundClusters, task)=>{
        if (foundClusters.length === 0) foundClusters.push({
            tasks: [],
            start: 0,
            stop: 0
        });
        const prevCluster = foundClusters[foundClusters.length - 1];
        const taskEnd = task.timestamp + task.duration;
        if (prevCluster.tasks.length === 0) {
            prevCluster.tasks.push(task);
            prevCluster.start = task.timestamp;
            prevCluster.stop = taskEnd;
        } else if (task.timestamp - prevCluster.stop < 100) {
            prevCluster.tasks.push(task);
            prevCluster.stop = taskEnd;
        } else foundClusters.push({
            tasks: [
                task
            ],
            start: task.timestamp,
            stop: taskEnd
        });
        return foundClusters;
    }, []);
    const clusterDurations = clusters.map((cluster)=>cluster.stop - cluster.start);
    const tasksDurations = longTasks.map((task)=>task.duration);
    const gapsBetweenClusters = clusters.length > 1 ? clusters // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((gaps, cluster, i)=>{
        if (gaps.length === 0) {
            gaps.push({
                start: cluster.stop,
                stop: null
            });
            return gaps;
        }
        // eslint-disable-next-line no-param-reassign
        gaps[gaps.length - 1].stop = cluster.start;
        if (i !== clusters.length - 1) gaps.push({
            start: cluster.stop,
            stop: null
        });
        return gaps;
    }, []).map((gap)=>gap.stop - gap.start) : [];
    return {
        [`${prefix}ClusterCount`]: clusters.length,
        [`${prefix}ClusterAvg`]: clusters.length > 0 ? clusterDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / clusters.length : 0,
        [`${prefix}ClusterDistanceAvg`]: gapsBetweenClusters.length > 0 ? gapsBetweenClusters.reduce((sumAcc, duration)=>sumAcc + duration, 0) / gapsBetweenClusters.length : 0,
        [`${prefix}ClusterAvgLongTaskCount`]: clusters.length > 0 ? clusters.map((cluster)=>cluster.tasks.length).reduce((sumAcc, count)=>sumAcc + count, 0) / clusters.length : 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: longTasks.length > 0 ? tasksDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0
    };
};

});


parcelRegister("4wg4d", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a090f1e04d3c553$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $euZim = parcelRequire("euZim");
const $2a090f1e04d3c553$var$MAX_GAP_BETWEEN_SCROLL_EVENTS = 500;
// eslint-disable-next-line jira/react/no-class-components
class $2a090f1e04d3c553$var$Notifier extends (0, $5uXOq.PureComponent) {
    componentDidUpdate(prevProps) {
        if (this.props.scrollTop === prevProps.scrollTop && this.props.scrollLeft === prevProps.scrollLeft) return;
        if (!this.scrollStarted) {
            this.scrollStarted = true;
            this.props.onScrollStart();
        }
        this.scrollStop();
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.scrollStarted = false;
        this.scrollStop = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            this.scrollStarted = false;
            this.props.onScrollStop();
        }, $2a090f1e04d3c553$var$MAX_GAP_BETWEEN_SCROLL_EVENTS);
    }
}
const $2a090f1e04d3c553$var$BoardScrollNotifier = (props)=>{
    const [scrollLeft] = (0, $euZim.useBoardScrollLeft)();
    const [scrollTop] = (0, $euZim.useBoardScrollTop)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a090f1e04d3c553$var$Notifier, {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        ...props
    });
};
var $2a090f1e04d3c553$export$2e2bcd8739ae039 = $2a090f1e04d3c553$var$BoardScrollNotifier;

});


parcelRegister("22mIG", function(module, exports) {

$parcel$export(module.exports, "default", () => $35bf80f71813811a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dGvGJ = parcelRequire("dGvGJ");

var $8QpSo = parcelRequire("8QpSo");

var $k12ix = parcelRequire("k12ix");

var $4R6GH = parcelRequire("4R6GH");

var $2gCtH = parcelRequire("2gCtH");

var $5rqex = parcelRequire("5rqex");

var $bC2fB = parcelRequire("bC2fB");

var $9wkw7 = parcelRequire("9wkw7");

var $6uzgj = parcelRequire("6uzgj");


var $b0yad = parcelRequire("b0yad");

var $dIdda = parcelRequire("dIdda");

var $iUagi = parcelRequire("iUagi");


var $hz3OZ = parcelRequire("hz3OZ");

var $1vXOx = parcelRequire("1vXOx");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");
const $35bf80f71813811a$var$getHasServiceWorkerController = ()=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return !!navigator?.serviceWorker?.controller;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return false;
    }
};
const $35bf80f71813811a$export$d7d8aff642f69970 = (filters)=>Object.entries(filters).filter(([, value])=>!!value && (!Array.isArray(value) || value.length > 0)).map(([key])=>key).join(',');
const $35bf80f71813811a$var$getExtra = (0, $8QpSo.default)((isCacheHit, issueNo, boardSessionId, boardId, allFeatures, isCMPBoard, canCompleteSprint, canEditColumns, filters, swimlaneMode)=>{
    const allFeaturesReadOnly = {
        ...allFeatures
    };
    return {
        ...(0, $k12ix.getNormalisedPerformanceFFs)(),
        ...allFeaturesReadOnly,
        isCacheHit: isCacheHit,
        cacheInvalidationReasons: (0, $b0yad.getAndClearInvalidationReasons)((0, $8631d6ce464ccf2e$export$9b8283d5878d2491)).join(','),
        issueNo: issueNo,
        boardSessionId: boardSessionId,
        boardId: boardId,
        hasServiceWorkerController: $35bf80f71813811a$var$getHasServiceWorkerController(),
        isSentryEnabled: (0, $iUagi.isErrorTrackingEnabledWithSentry)(),
        isPrefetchIssueDataByColumnLimitEnabled: (0, $iUagi.isPrefetchIssueDataByColumnLimitEnabled)(),
        isClassic: isCMPBoard,
        canCompleteSprint: canCompleteSprint,
        canEditColumns: canEditColumns,
        filters: $35bf80f71813811a$export$d7d8aff642f69970(filters),
        swimlaneMode: swimlaneMode
    };
});
const $35bf80f71813811a$var$getFeatureAnalyticsAttributesMemoized = ()=>(0, $dGvGJ.createSelector)((allFeatures)=>(0, $6uzgj.getFeatureAnalyticsAttributes)(allFeatures), (res)=>res);
const $35bf80f71813811a$export$c31df4bd766f9c35 = ()=>{
    const getFeatureAnalyticsAttributesInstance = $35bf80f71813811a$var$getFeatureAnalyticsAttributesMemoized();
    return (state, ownProps)=>{
        const { isCacheHit: isCacheHit } = ownProps;
        const issueNo = (0, $5mTgl.workIssuesSelector)(state).length;
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        const boardSessionId = (0, $67Z81.sessionIdSelector)(state);
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const allFeatures = getFeatureAnalyticsAttributesInstance((0, $67Z81.getBoardConfig)(state).allFeatures);
        const columns = (0, $5mTgl.columnsWithResolutionSelector)(state);
        const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        const canCompleteSprint = (0, $ebHh7.canCompleteSprintSelector)(state);
        const canEditColumns = (0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$b5cf1ddd753a0a1c] && (0, $5mTgl.isInlineColumnEditEnabled)(state);
        const filters = (0, $5mTgl.getWorkFilters)(state).values;
        const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state) ?? 'NO_SWIMLANE';
        return {
            extra: $35bf80f71813811a$var$getExtra(isCacheHit, issueNo, boardSessionId, boardId, allFeatures, isCMPBoard, canCompleteSprint, canEditColumns, filters, swimlaneMode),
            columns: columns,
            isCMPBoard: isCMPBoard,
            isIncrementPlanningBoard: isIncrementPlanningBoard
        };
    };
};
const $35bf80f71813811a$export$1c42276fb052f443 = ({ columns: columns, extra: extra, isCMPBoard: isCMPBoard, isIncrementPlanningBoard: isIncrementPlanningBoard })=>{
    const issueViewMode = (0, $2gCtH.useViewMode)() || '';
    const [issueKey] = (0, $dIdda.useQueryParam)('selectedIssue');
    const extraIssueViewData = (0, $5uXOq.useMemo)(()=>({
            issueViewMode: issueViewMode,
            isIssueViewOpen: !!issueKey
        }), [
        issueKey,
        issueViewMode
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isCMPBoard) (0, $9wkw7.pushEarlyMarksToBrowserMetrics)((0, $hz3OZ.uifBoardNewUiPageLoad));
        else if (isIncrementPlanningBoard) (0, $9wkw7.pushEarlyMarksToBrowserMetrics)((0, $hz3OZ.incrementPlanningBoardPageLoad));
        else (0, $9wkw7.pushEarlyMarksToBrowserMetrics)((0, $hz3OZ.nextGenBoardPageLoad));
    }, [
        isCMPBoard,
        isIncrementPlanningBoard
    ]);
    let metric;
    switch(true){
        case isCMPBoard:
            metric = (0, $hz3OZ.uifBoardNewUiPageLoad);
            break;
        case isIncrementPlanningBoard:
            metric = (0, $hz3OZ.incrementPlanningBoardPageLoad);
            break;
        default:
            metric = (0, $hz3OZ.nextGenBoardPageLoad);
    }
    if (columns.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        extra: (0, $4R6GH.fg)('add_issue_view_data_in_board_ufo_event') ? {
            ...extra,
            ...extraIssueViewData
        } : extra,
        appName: "software-board",
        // @ts-expect-error - TS2322 - Type 'PageLoadMetric' is not assignable to type 'BM3Metric'.
        metric: metric,
        emitOnAnimationFrame: (0, $iUagi.emitApdexOnAnimationFrame)(),
        testId: "software-board.board-container.submit-apdex.submit-apdex"
    });
    return null;
};
var $35bf80f71813811a$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($35bf80f71813811a$export$c31df4bd766f9c35, {})($35bf80f71813811a$export$1c42276fb052f443);

});
parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $co1wz = parcelRequire("co1wz");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $co1wz.ff)('uip.ufo') && (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $co1wz = parcelRequire("co1wz");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $co1wz.ff)('bm3.emit-on-raf.top-experiences') && (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $co1wz.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
            (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
            (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $co1wz.ff)('bm3.wait-for-long-task') ? (0, $21pfT.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $co1wz.ff)('bm3.emit-on-raf.top-experiences') && (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $co1wz.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                    (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                    (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                }
                if ((0, $co1wz.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $co1wz.ff)('bm3.emit-on-raf.top-experiences') && (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("9wkw7", function(module, exports) {

$parcel$export(module.exports, "pushEarlyMarksToBrowserMetrics", () => $18c0c41d8db3822c$export$b7c0f32f0c63e86b);
const $18c0c41d8db3822c$export$2f0748f9bcbd5ff0 = {
    'jira.fe-spa.software.early-preload:start': 'EARLY_FETCH_START',
    'jira.fe-spa.software.early-preload:end': 'EARLY_FETCH_END'
};
const $18c0c41d8db3822c$export$b7c0f32f0c63e86b = (metric, options)=>{
    const marks = {
        ...$18c0c41d8db3822c$export$2f0748f9bcbd5ff0,
        ...options?.marks ?? {}
    };
    Object.keys(marks).forEach((mark)=>{
        const startTime = performance.getEntriesByName(mark)[0]?.startTime;
        if (startTime != null) metric.mark(marks[mark], startTime);
    });
};

});


parcelRegister("3nXC3", function(module, exports) {

$parcel$export(module.exports, "default", () => $0efa9b497dd51ee9$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $8Rkzz = parcelRequire("8Rkzz");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $jzjy1 = parcelRequire("jzjy1");

var $7wqBZ = parcelRequire("7wqBZ");

var $k12ix = parcelRequire("k12ix");

var $dhsbO = parcelRequire("dhsbO");

var $gSExi = parcelRequire("gSExi");

var $6s1PB = parcelRequire("6s1PB");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $ACELo = parcelRequire("ACELo");

var $2BvBY = parcelRequire("2BvBY");

var $aTwsH = parcelRequire("aTwsH");

var $9Ik53 = parcelRequire("9Ik53");

var $g3RsK = parcelRequire("g3RsK");

var $l8ruj = parcelRequire("l8ruj");


var $47POI = parcelRequire("47POI");

var $gM0Co = parcelRequire("gM0Co");

var $btiFk = parcelRequire("btiFk");

var $aJnM9 = parcelRequire("aJnM9");

var $4lizL = parcelRequire("4lizL");

var $4uy3J = parcelRequire("4uy3J");

var $hnOnj = parcelRequire("hnOnj");

var $sZrZu = parcelRequire("sZrZu");
class $0efa9b497dd51ee9$var$SoftwareBoard extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            hasMinimap: true,
            onBoardNonCriticalViewed: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props);
        this.handleMouseEvents = (event)=>{
            if (event.metaKey || event.altKey || event.ctrlKey) this.props.onPreventInlineEditing(true);
            else if (this.props.preventInlineEditing) this.props.onPreventInlineEditing?.(false);
        };
        this.state = {
            scrollingElementRef: /*#__PURE__*/ (0, $5uXOq.createRef)(),
            boardNonCriticalViewEventFired: false
        };
        (0, $6s1PB.expVal)('jira_aa_test', 'cohort', 'not-enrolled');
        (0, $6s1PB.expVal)('jira_aa_test_with_targeting', 'cohort', 'not-enrolled');
    }
    componentDidMount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('mousedown', this.handleMouseEvents, true); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('mouseup', this.handleMouseEvents, true);
    }
    componentDidUpdate() {
        (0, $7wqBZ.getLongTasksMetrics)('filter').stop((0, $dhsbO.filterReporter), {
            boardSessionId: this.props.boardSessionId
        });
        if (!this.state.boardNonCriticalViewEventFired && this.props.isNonCriticalWorksetLoaded) {
            this.props.onBoardNonCriticalViewed();
            this.setState({
                boardNonCriticalViewEventFired: true
            });
        }
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('mousedown', this.handleMouseEvents); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('mouseup', this.handleMouseEvents);
    }
    render() {
        const { isCacheHit: isCacheHit, isColumnCreateAllowed: isColumnCreateAllowed, isInlineColumnEditEnabled: isInlineColumnEditEnabled, isFlexibleColumns: isFlexibleColumns, hasSwimlanes: hasSwimlanes, hasMinimap: hasMinimap, Board: Board, BacklogIssueMoveDialog: BacklogIssueMoveDialog, KeyboardShortcuts: KeyboardShortcuts, ColumnCreate: ColumnCreate, ColumnConfigurationButton: ColumnConfigurationButton, BoardMinimap: BoardMinimap, SubmitApdex: SubmitApdex, ScrollObserver: ScrollObserver, shouldRenderSwimlane: shouldRenderSwimlane, isColumnConfigurationButtonEnabled: isColumnConfigurationButtonEnabled, isUnscheduledColumnVisible: isUnscheduledColumnVisible, isIncrementPlanningBoard: isIncrementPlanningBoard } = this.props;
        const isBoardWithVisibleUnscheduledWorkPanel = isIncrementPlanningBoard && isUnscheduledColumnVisible;
        const boardChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Board, {
            scrollRef: this.state.scrollingElementRef,
            isBoardWithVisibleUnscheduledWorkPanel: isBoardWithVisibleUnscheduledWorkPanel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(KeyboardShortcuts // @ts-expect-error TS2322 - hasSwimlanes possibly is dead-code
        , {
            hasSwimlanes: hasSwimlanes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $btiFk.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BacklogIssueMoveDialog, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47POI.NextBestTaskPanel), null), this.props.isIncrementPlanningBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uy3J.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0efa9b497dd51ee9$export$d61fab72474d20f0, {
            isFlexible: isFlexibleColumns,
            ...isBoardWithVisibleUnscheduledWorkPanel && {
                'data-testid': 'software-board.board-container.scheduled-work-board'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ik53.ScrollStateContextProvider), {
            scrollRef: this.state.scrollingElementRef
        }, shouldRenderSwimlane ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hnOnj.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4lizL.default), {
            swimlaneId: null,
            isLastSwimlane: true,
            isUnscheduledWorkColumn: false
        }))), isColumnCreateAllowed && isInlineColumnEditEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ColumnCreate, null), isColumnCreateAllowed && !isInlineColumnEditEnabled && isColumnConfigurationButtonEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ColumnConfigurationButton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aTwsH.AsyncLazyScrollInterceptorWrapper), {
            scrollEl: this.state.scrollingElementRef.current
        }), (0, $4R6GH.fg)('jsw_refactor_long-tasks_monitoring') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g3RsK.LongTasksScrollObserver), {
            appName: (0, $7e733a5d4e4331fc$export$24f467771705aaff),
            scrollEl: this.state.scrollingElementRef.current,
            attributes: (0, $k12ix.getNormalisedPerformanceFFs)()
        })), hasMinimap && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ACELo.JiraBottomRightCornerOutlet), {
            orderFromRight: 2,
            id: "software-board-minimp"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BoardMinimap, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SubmitApdex, {
            isCacheHit: isCacheHit
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ScrollObserver, null), (0, $4R6GH.fg)('jira-tako-unassigned-filter-cta-killswitch') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $sZrZu.UnassignedFilterCTABoardAnalytics), null));
        const boardWithUnscheduledColumn = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            xcss: $0efa9b497dd51ee9$var$BoardWithUnscheduledColumnWrapperStyles
        }, isUnscheduledColumnVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gM0Co.UnscheduledWorkPanel), null), boardChildren);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
            name: "board-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0efa9b497dd51ee9$var$BoardWrapper, {
            "data-onboarding-observer-id": "board-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2BvBY.BoardProvider), null, isIncrementPlanningBoard && isUnscheduledColumnVisible ? boardWithUnscheduledColumn : boardChildren)));
    }
}
const $0efa9b497dd51ee9$var$SoftwareBoardWithDragDropContext = (props)=>{
    (0, $aJnM9.useBoardDragDropContext)({
        onDragEnd: props.onDragEnd
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0efa9b497dd51ee9$var$SoftwareBoard, props);
};
var $0efa9b497dd51ee9$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
 = (0, $jzjy1.AnalyticsSubject)('board')($0efa9b497dd51ee9$var$SoftwareBoardWithDragDropContext);
const $0efa9b497dd51ee9$var$BoardWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _1ul9idpf _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $0efa9b497dd51ee9$var$BoardWithUnscheduledColumnWrapperStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    width: '100%',
    height: '100%',
    paddingLeft: 'space.500'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $0efa9b497dd51ee9$var$BoardContainerControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "eyvlv8-0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        flex: props.isFlexible ? '1' : 'initial'
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0efa9b497dd51ee9$var$BoardContainerExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexible: isFlexible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isFlexible ? "_16jlkb7n _1o9zkb7n _i0dlf1ug" : "_16jlidpf _1o9zkb7n _i0dl1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0efa9b497dd51ee9$export$d61fab72474d20f0 = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $0efa9b497dd51ee9$var$BoardContainerExperiment, $0efa9b497dd51ee9$var$BoardContainerControl);

});
parcelRegister("dhsbO", function(module, exports) {

$parcel$export(module.exports, "filterReporter", () => $f7989144fec0a9cf$export$facf842185aa645c);

var $k12ix = parcelRequire("k12ix");

var $cJpFl = parcelRequire("cJpFl");

var $if7bx = parcelRequire("if7bx");
const $f7989144fec0a9cf$export$facf842185aa645c = (observationData, // eslint-disable-next-line @typescript-eslint/no-explicit-any
featureFlags = {})=>{
    if ((0, $cJpFl.isExpandedObservationData)(observationData)) {
        const triggerSoftwareAnalytics = (0, $if7bx.triggerAnalytics)(`software.${observationData.appName}`);
        const startTime = observationData.events.map((event)=>event.timestamp);
        const analyticsData = {
            ...(0, $if7bx.generateLongTaskAnalyticsSummary)('filter', observationData.events),
            measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime),
            ...featureFlags,
            performanceFFs: (0, $k12ix.getPerformanceFFsString)()
        };
        triggerSoftwareAnalytics('long-tasks-filter', analyticsData);
        try {
            performance.measure('filterBarResponsiveness', 'filterBarStart', 'filterBarStop');
            triggerSoftwareAnalytics('performance-filter-bar', performance.getEntriesByName('filterBarResponsiveness')[0]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
        // do nothing
        }
        try {
            performance.measure('oldFilterBarResponsiveness', 'oldFilterBarStart', 'oldFilterBarStop');
            triggerSoftwareAnalytics('performance-old-filter-bar', performance.getEntriesByName('oldFilterBarResponsiveness')[0]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
        // do nothing
        }
        performance.clearMeasures();
    }
};

});

parcelRegister("ACELo", function(module, exports) {

$parcel$export(module.exports, "JiraBottomRightCornerOutlet", () => $8d24666022201b4c$export$ee54e6ed235df65e);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7nsd3 = parcelRequire("7nsd3");

var $heNNl = parcelRequire("heNNl");

var $hvrWv = parcelRequire("hvrWv");
const $8d24666022201b4c$var$OutletWithPortal = ({ orderFromRight: orderFromRight, children: children, id: id })=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const portalWrapper = (0, $5uXOq.useRef)(document.createElement('div'));
    const container = (0, $hvrWv.useBottomRightCornerContainer)();
    if (!container) throw new Error('GlobalBottomRightContainer could not be found. Please ensure that this container was rendered on the page.');
    const { insertBottomRightCornerPortal: insertBottomRightCornerPortal, removeBottomRightCornerPortal: removeBottomRightCornerPortal } = (0, $hvrWv.useBottomRightCornerActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (container) {
            const indexToRender = insertBottomRightCornerPortal({
                orderFromRight: orderFromRight,
                id: id
            });
            // @ts-expect-error - TS2538 - Type 'Promise<void>' cannot be used as an index type. | TS2538 - Type 'void' cannot be used as an index type.
            container.insertBefore(portalWrapper.current, container.children[indexToRender]);
        }
        // required as eslint complains about the ref in cleanup function
        const portalCurrent = portalWrapper.current;
        return ()=>{
            container?.removeChild(portalCurrent);
            removeBottomRightCornerPortal(id);
        };
    }, [
        container,
        id,
        orderFromRight,
        insertBottomRightCornerPortal,
        removeBottomRightCornerPortal
    ]);
    return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8d24666022201b4c$var$StyledOutlet, null, children), portalWrapper.current);
};
const $8d24666022201b4c$export$ee54e6ed235df65e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "bottom-right-corner-outlet",
        packageName: "jira-bottom-right-corner-controller",
        extraEventData: {
            portalId: props.id
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8d24666022201b4c$var$OutletWithPortal, props));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8d24666022201b4c$var$StyledOutlet = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1vgl1wug _1ko9pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2BvBY", function(module, exports) {

$parcel$export(module.exports, "BoardProvider", () => $f3903c1d72f98e72$export$70255033b788b22c);

var $5uXOq = parcelRequire("5uXOq");

var $jD5no = parcelRequire("jD5no");

var $2Z6La = parcelRequire("2Z6La");
const $f3903c1d72f98e72$export$70255033b788b22c = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Z6La.IccProvider), null, children));
});

});
parcelRegister("2Z6La", function(module, exports) {

$parcel$export(module.exports, "IccContext", () => $093fa356b2a966b6$export$2f62d2dfd027123d);
$parcel$export(module.exports, "useIccContext", () => $093fa356b2a966b6$export$f7b8d088c9ea045e);
$parcel$export(module.exports, "IccProvider", () => $093fa356b2a966b6$export$4a7497397d7465fc);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $cSD7y = parcelRequire("cSD7y");
const $093fa356b2a966b6$export$2f62d2dfd027123d = /*#__PURE__*/ (0, $5uXOq.createContext)({
    initialSummary: '',
    initialCardTypeId: null,
    initialFieldValues: new Map(),
    initialProjectId: null,
    onChangeSummary: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeCardType: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeFieldValue: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeProject: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onCreate: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});
const $093fa356b2a966b6$export$f7b8d088c9ea045e = ()=>(0, $5uXOq.useContext)($093fa356b2a966b6$export$2f62d2dfd027123d);
// eslint-disable-next-line jira/react/no-class-components
class $093fa356b2a966b6$var$IccProviderOld extends (0, $5uXOq.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($093fa356b2a966b6$export$2f62d2dfd027123d.Provider, {
            value: {
                initialSummary: this.state.initialSummary,
                initialCardTypeId: this.state.initialCardTypeId,
                initialFieldValues: this.state.initialFieldValues,
                initialProjectId: this.state.initialProjectId,
                onChangeCardType: this.onChangeCardType,
                onChangeSummary: this.onChangeSummary,
                onChangeFieldValue: this.onChangeFieldValue,
                onChangeProject: this.onChangeProject,
                onCancel: this.onCancel,
                onCreate: this.onCreate
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            initialSummary: '',
            initialCardTypeId: null,
            initialFieldValues: new Map(),
            initialProjectId: null
        };
        this.onChangeSummary = (summary)=>{
            this.setState({
                initialSummary: summary
            });
        };
        this.onChangeProject = (projectId)=>{
            this.setState({
                initialProjectId: projectId
            });
        };
        this.onChangeCardType = (cardTypeId)=>{
            this.setState({
                initialCardTypeId: cardTypeId
            });
        };
        this.onChangeFieldValue = (fieldKey, fieldValue)=>{
            this.setState(({ initialFieldValues: initialFieldValues })=>({
                    initialFieldValues: initialFieldValues.set(fieldKey, fieldValue)
                }));
        };
        this.onCancel = ()=>{
            this.setState({
                initialSummary: '',
                initialCardTypeId: null
            });
        };
        this.onCreate = ()=>{
            this.setState({
                initialSummary: ''
            });
        };
    }
}
const $093fa356b2a966b6$var$IccProviderNew = (props)=>{
    const [state, setState] = (0, $5uXOq.useState)({
        initialSummary: '',
        initialCardTypeId: null,
        initialFieldValues: new Map(),
        initialProjectId: null
    });
    const onChangeSummary = (0, $5uXOq.useCallback)((summary)=>{
        setState((prevState)=>({
                ...prevState,
                initialSummary: summary
            }));
    }, []);
    const onChangeProject = (0, $5uXOq.useCallback)((projectId)=>{
        setState((prevState)=>({
                ...prevState,
                initialProjectId: projectId
            }));
    }, []);
    const onChangeCardType = (0, $5uXOq.useCallback)((cardTypeId)=>{
        setState((prevState)=>({
                ...prevState,
                initialCardTypeId: cardTypeId
            }));
    }, []);
    const onChangeFieldValue = (0, $5uXOq.useCallback)((fieldKey, fieldValue)=>{
        setState(({ initialFieldValues: initialFieldValues, ...prevState })=>({
                ...prevState,
                initialFieldValues: initialFieldValues.set(fieldKey, fieldValue)
            }));
    }, []);
    const onCancel = (0, $5uXOq.useCallback)(()=>{
        setState((prevState)=>({
                ...prevState,
                initialSummary: '',
                initialCardTypeId: null
            }));
    }, []);
    const onCreate = (0, $5uXOq.useCallback)(()=>{
        setState((prevState)=>({
                ...prevState,
                initialSummary: ''
            }));
    }, []);
    const values = (0, $5uXOq.useMemo)(()=>({
            initialSummary: state.initialSummary,
            initialCardTypeId: state.initialCardTypeId,
            initialFieldValues: state.initialFieldValues,
            initialProjectId: state.initialProjectId,
            onChangeCardType: onChangeCardType,
            onChangeSummary: onChangeSummary,
            onChangeFieldValue: onChangeFieldValue,
            onChangeProject: onChangeProject,
            onCancel: onCancel,
            onCreate: onCreate
        }), [
        state,
        onChangeCardType,
        onChangeSummary,
        onChangeFieldValue,
        onChangeProject,
        onCancel,
        onCreate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($093fa356b2a966b6$export$2f62d2dfd027123d.Provider, {
        value: values
    }, props.children);
};
const $093fa356b2a966b6$export$4a7497397d7465fc = (0, $cSD7y.componentWithFG)('board_rendering_optimisations', $093fa356b2a966b6$var$IccProviderNew, $093fa356b2a966b6$var$IccProviderOld);

});


parcelRegister("aTwsH", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyScrollInterceptorWrapper", () => $3c1f509e33b8d225$export$a2985ad8bf685540);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3c1f509e33b8d225$var$LazyScrollInterceptorWrapper = (0, $kxZPA.lazy)(()=>(parcelRequire("lKC7S")).then(({ ScrollInterceptorWrapper: ScrollInterceptorWrapper })=>ScrollInterceptorWrapper), {
    moduleId: "./src/packages/software/scroll-interceptor/src/ui/scroll-interceptor-wrapper/index.tsx"
});
const $3c1f509e33b8d225$export$a2985ad8bf685540 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "asyncScrollInterceptor",
        fallback: "unmount",
        packageName: "jira-scroll-interceptor",
        teamName: "jlove-makkuro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "scroll-interceptor",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c1f509e33b8d225$var$LazyScrollInterceptorWrapper, props)));

});
parcelRegister("lKC7S", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("hYkc1").then(()=>parcelRequire('gVCEQ'));

});


parcelRegister("9Ik53", function(module, exports) {

$parcel$export(module.exports, "useScrollState", () => $c77424cc0be42400$export$98084ad349e2edae);
$parcel$export(module.exports, "ScrollStateContextProvider", () => $c77424cc0be42400$export$7cc0055278d35041);
/*!
 * Adding too many scroll listeners adds overhead to both the initial
 * "bootstrap" phase, when the listeners are added, and all scroll events.
 *
 * Some virtualisation use-cases such as boards may have a large number of
 * virtual lists instances. Sharing a scroll element through context avoids
 * attaching one listener per list.
 */ 
var $5uXOq = parcelRequire("5uXOq");
const $c77424cc0be42400$export$50b6b7783d156e1b = 200;
const $c77424cc0be42400$var$INITIAL_SCROLL_STATE = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0,
    scrollTop: 0,
    scrollLeft: 0,
    isScrolling: false,
    scrollElement: null
};
const $c77424cc0be42400$var$ScrollStateContext = /*#__PURE__*/ (0, $5uXOq.createContext)($c77424cc0be42400$var$INITIAL_SCROLL_STATE);
const $c77424cc0be42400$export$98084ad349e2edae = ()=>(0, $5uXOq.useContext)($c77424cc0be42400$var$ScrollStateContext);
const $c77424cc0be42400$var$attachResizeObserver = (callback, targetEl)=>{
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!targetEl) return ()=>{};
    let resizeObserver = null;
    // SSR fix. Do not instantiate for SSR
    if (typeof ResizeObserver !== 'undefined') resizeObserver = new ResizeObserver(()=>callback());
    // When mounting our listener, if its the Window object, treat it as such.
    // This can happen in Storybook but not in any other scenario
    if (targetEl instanceof Window) targetEl.addEventListener('resize', callback);
    else resizeObserver?.observe(targetEl);
    return ()=>{
        // Cleanup the resize callback we have attached
        if (targetEl instanceof Window) targetEl.removeEventListener('resize', callback);
        else resizeObserver?.disconnect();
    };
};
/**
 * Listens for scroll events on the `HTMLElement` `scrollRef.current` and updates a state
 * variable with the scroll state, which is returned.
 */ const $c77424cc0be42400$var$useElementScrollState = (scrollRef)=>{
    const [scrollState, setScrollState] = (0, $5uXOq.useState)($c77424cc0be42400$var$INITIAL_SCROLL_STATE);
    (0, $5uXOq.useEffect)(()=>{
        const targetEl = scrollRef.current;
        if (!targetEl) return undefined;
        let clearScrollingTimeoutId;
        const onScroll = ()=>{
            setScrollState((state)=>({
                    ...state,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: true
                }));
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                setScrollState((state)=>({
                        ...state,
                        scrollTop: targetEl.scrollTop,
                        scrollLeft: targetEl.scrollLeft,
                        isScrolling: false
                    }));
            }, $c77424cc0be42400$export$50b6b7783d156e1b);
        };
        const onResize = ()=>{
            setScrollState((state)=>({
                    ...state,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    height: targetEl.clientHeight,
                    width: targetEl.clientWidth,
                    scrollHeight: targetEl.scrollHeight,
                    scrollWidth: targetEl.scrollWidth,
                    isScrolling: true
                }));
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                setScrollState((state)=>({
                        ...state,
                        scrollTop: targetEl.scrollTop,
                        scrollLeft: targetEl.scrollLeft,
                        isScrolling: false
                    }));
            }, $c77424cc0be42400$export$50b6b7783d156e1b);
        };
        // We want to know when the scroll element/container itself resizes as this impacts
        // the number of rows we show
        const cleanupResizeObserver = $c77424cc0be42400$var$attachResizeObserver(onResize, targetEl);
        targetEl.addEventListener('scroll', onScroll);
        setScrollState({
            height: targetEl.clientHeight,
            width: targetEl.clientWidth,
            scrollHeight: targetEl.scrollHeight,
            scrollWidth: targetEl.scrollWidth,
            scrollTop: targetEl.scrollTop,
            scrollLeft: targetEl.scrollLeft,
            isScrolling: false,
            scrollElement: targetEl
        });
        return ()=>{
            targetEl.removeEventListener('scroll', onScroll);
            cleanupResizeObserver();
            clearTimeout(clearScrollingTimeoutId);
        };
    }, [
        scrollRef
    ]);
    return scrollState;
};
const $c77424cc0be42400$export$7cc0055278d35041 = ({ scrollRef: scrollRef, children: children })=>{
    const scrollState = $c77424cc0be42400$var$useElementScrollState(scrollRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c77424cc0be42400$var$ScrollStateContext.Provider, {
        value: scrollState
    }, children);
};

});

parcelRegister("g3RsK", function(module, exports) {

$parcel$export(module.exports, "LongTasksScrollObserver", () => $fe64e9d70a250807$export$55bf40af27443842);

var $5uXOq = parcelRequire("5uXOq");

var $7wqBZ = parcelRequire("7wqBZ");

var $4R6GH = parcelRequire("4R6GH");

var $bv8GQ = parcelRequire("bv8GQ");

var $gi25H = parcelRequire("gi25H");
/**
 * Tracks long-tasks that happen while scrolling on a certain 'scrollEl'.
 */ const $fe64e9d70a250807$var$LongTasksScrollObserverBase = ({ observationType: observationType, attributes: attributes, appName: appName, ...rest })=>{
    const onScrollStart = (0, $5uXOq.useCallback)(()=>{
        (0, $7wqBZ.getLongTasksMetrics)(observationType).start(appName, undefined, attributes);
        if ((0, $4R6GH.fg)('jsw_refactor_long-tasks_monitoring')) performance.mark(`${appName}:scrolling-task:start`);
    }, [
        attributes,
        appName,
        observationType
    ]);
    const onScrollEnd = (0, $5uXOq.useCallback)((lastScrollTime)=>{
        (0, $7wqBZ.getLongTasksMetrics)(observationType).stop((0, $bv8GQ.softwareGenericLongTasksReporter)('scroll', lastScrollTime));
        if ((0, $4R6GH.fg)('jsw_refactor_long-tasks_monitoring')) {
            performance.mark(`${appName}:scrolling-task:end`);
            performance.measure(`${appName}:scrolling-task`, `${appName}:scrolling-task:start`, `${appName}:scrolling-task:end`);
        }
    }, [
        observationType,
        appName
    ]);
    (0, $gi25H.useScrollStateObserver)({
        ...rest,
        onScrollStart: onScrollStart,
        onScrollEnd: onScrollEnd
    });
    return null;
};
$fe64e9d70a250807$var$LongTasksScrollObserverBase.defaultProps = {
    observationType: 'scroll',
    attributes: {}
};
const $fe64e9d70a250807$export$55bf40af27443842 = /*#__PURE__*/ (0, $5uXOq.memo)($fe64e9d70a250807$var$LongTasksScrollObserverBase);

});
parcelRegister("bv8GQ", function(module, exports) {

$parcel$export(module.exports, "softwareGenericLongTasksReporter", () => $2795c9afa9443b8c$export$b78c92c0ba709033);

var $gZFbt = parcelRequire("gZFbt");

var $if7bx = parcelRequire("if7bx");

var $cJpFl = parcelRequire("cJpFl");

var $4R6GH = parcelRequire("4R6GH");


var $fjcgS = parcelRequire("fjcgS");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2795c9afa9443b8c$var$aggregatedDataTimeout = {};
const $2795c9afa9443b8c$export$b78c92c0ba709033 = (observationType, observationEndTime)=>(observationData)=>{
        if ((0, $4R6GH.fg)('jsw_refactor_long-tasks_monitoring')) {
            if (!(0, $cJpFl.isExpandedObservationData)(observationData) || !('appName' in observationData)) return;
            const { appName: appName, startTimestamp: startTimestamp, events: events } = observationData;
            const startTime = startTimestamp;
            const endTime = observationEndTime ?? performance.now();
            const duration = endTime - startTime;
            if (duration < 100) return;
            const rawLongTasks = events ?? [];
            const longTasks = rawLongTasks.filter((event)=>event.timestamp >= startTime && event.timestamp + event.duration <= endTime).map((event)=>({
                    timestamp: event.timestamp - startTime,
                    duration: event.duration
                }));
            const minimumBlockedDuration = longTasks.reduce((sum, longTask)=>sum + longTask.duration, 0);
            const frameRateTarget = 60;
            const budgetPerFrame = 1000 / frameRateTarget;
            const timeOverBudget = longTasks.map((event)=>event.duration - budgetPerFrame).reduce((sum, time)=>sum + time, 0);
            const summary = {
                qualityIndex: 1 - timeOverBudget / duration,
                hasLongTasks: longTasks.length > 0,
                hasExtraLongTasks: longTasks.filter((l)=>l.duration >= 100).length > 0,
                longTasks: longTasks,
                rawLongTaskCount: rawLongTasks.length,
                longTaskCount: longTasks.length,
                minimumBlockedDuration: minimumBlockedDuration,
                timeOverBudget: timeOverBudget,
                duration: duration,
                startTime: startTime,
                endTime: endTime
            };
            (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
                client.sendEvent({
                    type: (0, $4d5e0871c06cee03$export$12346a674644c156),
                    payload: {
                        source: appName,
                        action: 'longTask',
                        actionSubject: 'ui',
                        actionSubjectId: `${appName}-${observationType}`,
                        attributes: {
                            key: appName,
                            ...summary
                        }
                    }
                });
            });
        } else {
            if (!(0, $cJpFl.isExpandedObservationData)(observationData)) return;
            const startTime = observationData.events.map((event)=>event.timestamp);
            const analyticsData = {
                ...(0, $if7bx.generateLongTaskAnalyticsContinuousActionSummary)(observationType, observationData.events),
                measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime)
            };
            const { appName: appName } = observationData;
            if ($2795c9afa9443b8c$var$aggregatedDataTimeout[`software.${appName}.${observationType}`]) $2795c9afa9443b8c$var$aggregatedDataTimeout[`software.${appName}.${observationType}`].data.push(analyticsData);
            else $2795c9afa9443b8c$var$aggregatedDataTimeout[`software.${appName}.${observationType}`] = {
                data: [
                    analyticsData
                ],
                extra: observationData.extra,
                timeout: setTimeout(()=>{
                    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
                        const { data: data, extra: extraData } = $2795c9afa9443b8c$var$aggregatedDataTimeout[`software.${appName}.${observationType}`];
                        client.sendEvent({
                            type: (0, $4d5e0871c06cee03$export$12346a674644c156),
                            payload: {
                                source: appName,
                                action: 'longTask',
                                actionSubject: 'ui',
                                actionSubjectId: `${appName}-${observationType}`,
                                attributes: {
                                    key: appName,
                                    ...(0, $if7bx.getAverageResultsFromContinuousActions)(observationType, data),
                                    ...extraData,
                                    avgScrollTimespan: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, 'measureTimespan')
                                }
                            }
                        });
                        delete $2795c9afa9443b8c$var$aggregatedDataTimeout[`software.${appName}.${observationType}`];
                    });
                }, 7000)
            };
        }
    };

});

parcelRegister("gi25H", function(module, exports) {

$parcel$export(module.exports, "useScrollStateObserver", () => $5c14c3e1741ffda3$export$51374614020e4579);

var $5uXOq = parcelRequire("5uXOq");
const $5c14c3e1741ffda3$var$DEFAULT_SCROLL_STOP_INTERVAL_MS = 500;
const $5c14c3e1741ffda3$export$53d63bb2b7d56f77 = ({ onScrollStart: onScrollStart, onScrollEnd: onScrollEnd, scrollStopIntervalMs: scrollStopIntervalMs })=>{
    const isScrollingRef = (0, $5uXOq.useRef)(false);
    const scrollStopTimerRef = (0, $5uXOq.useRef)(null);
    const onScroll = (0, $5uXOq.useCallback)(()=>{
        if (!isScrollingRef.current) {
            isScrollingRef.current = true;
            onScrollStart();
        }
        const lastScrollTime = performance.now();
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(scrollStopTimerRef.current);
        scrollStopTimerRef.current = setTimeout(()=>{
            isScrollingRef.current = false;
            onScrollEnd(lastScrollTime);
        }, scrollStopIntervalMs);
        return ()=>{
            if (isScrollingRef.current) onScrollEnd(lastScrollTime);
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(scrollStopTimerRef.current);
        };
    }, [
        isScrollingRef,
        scrollStopTimerRef,
        scrollStopIntervalMs,
        onScrollStart,
        onScrollEnd
    ]);
    return {
        onScroll: onScroll,
        isScrollingRef: isScrollingRef
    };
};
const $5c14c3e1741ffda3$export$51374614020e4579 = ({ scrollStopIntervalMs: scrollStopIntervalMs, scrollElRef: scrollElRef, scrollEl: scrollEl, onScrollStart: onScrollStart, onScrollEnd: onScrollEnd })=>{
    const { onScroll: onScroll, isScrollingRef: isScrollingRef } = $5c14c3e1741ffda3$export$53d63bb2b7d56f77({
        onScrollStart: onScrollStart,
        onScrollEnd: onScrollEnd,
        scrollStopIntervalMs: scrollStopIntervalMs ?? $5c14c3e1741ffda3$var$DEFAULT_SCROLL_STOP_INTERVAL_MS
    });
    (0, $5uXOq.useEffect)(()=>{
        const el = scrollEl ?? scrollElRef?.current;
        if (!el) return undefined;
        el.addEventListener('scroll', onScroll);
        return ()=>{
            el.removeEventListener('scroll', onScroll);
        };
    }, [
        scrollEl,
        scrollElRef,
        isScrollingRef,
        onScroll,
        onScrollEnd
    ]);
};

});


parcelRegister("47POI", function(module, exports) {

$parcel$export(module.exports, "NextBestTaskPanel", () => $edae1958fffec47f$export$f8261b34b83700d1);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $aIZdc = parcelRequire("aIZdc");

var $39xOx = parcelRequire("39xOx");

var $kaHBi = parcelRequire("kaHBi");

var $4R6GH = parcelRequire("4R6GH");

var $fZneA = parcelRequire("fZneA");

var $4Fbrj = parcelRequire("4Fbrj");


var $hkiaF = parcelRequire("hkiaF");

var $axmY8 = parcelRequire("axmY8");

var $02beV = parcelRequire("02beV");

var $dF42q = parcelRequire("dF42q");

var $f8CI1 = parcelRequire("f8CI1");

var $aD3zD = parcelRequire("aD3zD");

var $4HjdZ = parcelRequire("4HjdZ");

var $25Q0f = parcelRequire("25Q0f");

var $lfTZh = parcelRequire("lfTZh");

var $br6MJ = parcelRequire("br6MJ");

var $ipmBb = parcelRequire("ipmBb");

var $01j5n = parcelRequire("01j5n");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $dIdda = parcelRequire("dIdda");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");
const $edae1958fffec47f$export$f2a226a16525c6e0 = ()=>{
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const boardId = (0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector));
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $axmY8.NEXT_BEST_TASK_ANALYTICS),
        analyticsSource: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f)
    });
    (0, $5uXOq.useEffect)(()=>{
        onStart();
    }, [
        onStart
    ]);
    return (0, $4R6GH.fg)('jira-work-suggestions-board-extra-pr-tasks-type') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4HjdZ.AsyncNBTPanel), {
        isSimplifiedProject: !isCMPBoard,
        boardId: boardId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $25Q0f.AsyncNBTPanel), {
        isSimplifiedProject: !isCMPBoard,
        boardId: boardId
    });
};
const $edae1958fffec47f$export$8b530858cadfa678 = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    if (!accountId) throw new Error('accountId could not be found');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkiaF.UserPropertiesContainer), {
        scope: (0, $axmY8.NEXT_BEST_TASK_USER_PROPERTIES_SCOPE),
        accountId: accountId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($edae1958fffec47f$export$f2a226a16525c6e0, null));
};
const $edae1958fffec47f$export$f8261b34b83700d1 = ()=>{
    const { data: data, loading: loading } = (0, $dIdda.useResource)((0, $ipmBb.nextBestTaskFeatureResource));
    const isOnlyCurrentUserSelected = (0, $67sX6.useBoardSelector)((0, $5mTgl.isFilterOnCurrentUserOnly)) || false;
    const cloudId = (0, $koeKL.useCloudId)();
    const { projectAri: projectAri } = (0, $dF42q.useContextAri)();
    const mountedNBTRef = (0, $5uXOq.useRef)(false);
    const isJSWBoard = (0, $63LqY.useIsJSWBoard)();
    const [queryRef, loadGitHubOnboardingQuery] = (0, $8Uumt.useQueryLoader)((0, $br6MJ.default));
    const { setQueryGithubOnboardingRef: setQueryGithubOnboardingRef } = (0, $02beV.useNextBestTaskActions)();
    const isOptedIn = !!data?.hasUserOptedIn;
    const isNBTEnabled = !loading && data != null && isOptedIn && isJSWBoard;
    const { isOpen: isOpen } = (0, $f8CI1.useNextBestTaskPanel)();
    if (isNBTEnabled && isOnlyCurrentUserSelected) mountedNBTRef.current = true;
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen && queryRef != null) setQueryGithubOnboardingRef(queryRef);
    }, [
        queryRef,
        setQueryGithubOnboardingRef,
        isOpen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isNBTEnabled && isOpen && projectAri && queryRef == null) loadGitHubOnboardingQuery({
            cloudId: cloudId,
            projectAri: projectAri
        });
    }, [
        isNBTEnabled,
        loadGitHubOnboardingQuery,
        cloudId,
        isOpen,
        queryRef,
        projectAri
    ]);
    const addAnalyticAttributes = (error)=>({
            isClientFetchError: (0, $fZneA.isClientFetchError)(error) || (0, $01j5n.isClientSideThirdPartyAppError)(error) || (0, $fZneA.isHttpClientErrorResponse)(error)
        });
    return isNBTEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "jira.insights.next-best-task-panel",
        packageName: (0, $4Fbrj.JIRA_INSIGHTS),
        fallback: "flag",
        attributes: addAnalyticAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD3zD.SafeNBTDataLoaderForOnlyCurrentUserSelected), {
        isOnlyCurrentUserSelected: isOnlyCurrentUserSelected
    }), mountedNBTRef.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        fallback: null,
        name: "next-best-task-panel"
    }, !(0, $aIZdc.isFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($edae1958fffec47f$export$8b530858cadfa678, null))) : null;
};

});
parcelRegister("4Fbrj", function(module, exports) {

$parcel$export(module.exports, "JIRA_INSIGHTS", () => $fea73e8d1542f4b4$export$74798a8d8755efe8);
$parcel$export(module.exports, "INSIGHTS_BEACON", () => $fea73e8d1542f4b4$export$36aafe55be325e9c);
$parcel$export(module.exports, "INSIGHTS_PANEL", () => $fea73e8d1542f4b4$export$29d7f2210b16d662);
$parcel$export(module.exports, "EXPERIENCE_TIMEOUT_MILLIS", () => $fea73e8d1542f4b4$export$b50c2fb16a87be63);
$parcel$export(module.exports, "DATA_FETCH_ACTION", () => $fea73e8d1542f4b4$export$4857a322416ea6fc);
$parcel$export(module.exports, "CLIENT_ERROR", () => $fea73e8d1542f4b4$export$cb2bfe2a50a1ece2);
$parcel$export(module.exports, "RENDER_ACTION", () => $fea73e8d1542f4b4$export$e902262516430940);
$parcel$export(module.exports, "dataFetchSuccess", () => $fea73e8d1542f4b4$export$d392c424a6c74b59);
$parcel$export(module.exports, "dataFetchFail", () => $fea73e8d1542f4b4$export$8d035b8b8e3383e);
$parcel$export(module.exports, "INSIGHTS_PANEL_EXPERIENCE", () => $fea73e8d1542f4b4$export$3ea7cf58d679b8d9);
$parcel$export(module.exports, "ERROR_BOUNDARY_HIT", () => $fea73e8d1542f4b4$export$680b36a84ba453e0);
$parcel$export(module.exports, "boardType", () => $fea73e8d1542f4b4$export$6796f2a60fb31770);
$parcel$export(module.exports, "BOARD_KANBAN_PANEL_EXPERIENCE", () => $fea73e8d1542f4b4$export$36467f64abcaaaa5);
$parcel$export(module.exports, "INSIGHTS_BUTTON", () => $fea73e8d1542f4b4$export$28ab2964530cf411);
$parcel$export(module.exports, "INSIGHTS_BUTTON_LG", () => $fea73e8d1542f4b4$export$8a355daa8d0cf830);
$parcel$export(module.exports, "INSIGHTS_BUTTON_SM", () => $fea73e8d1542f4b4$export$f8c16af1b950b647);
$parcel$export(module.exports, "INSIGHTS_BUTTON_RESPONSIVE", () => $fea73e8d1542f4b4$export$e80ae42ddabf80c5);

const $fea73e8d1542f4b4$export$74798a8d8755efe8 = (0, $b0e6fec6a4686296$export$d3996f57ffa8448f);
const $fea73e8d1542f4b4$export$36aafe55be325e9c = `${$fea73e8d1542f4b4$export$74798a8d8755efe8}.beacon`;
const $fea73e8d1542f4b4$export$29d7f2210b16d662 = `${$fea73e8d1542f4b4$export$74798a8d8755efe8}.panel`;
const $fea73e8d1542f4b4$export$8a1dfa6c0a610c5f = `${$fea73e8d1542f4b4$export$29d7f2210b16d662}.help`;
const $fea73e8d1542f4b4$export$956c91960ecaaf52 = `${$fea73e8d1542f4b4$export$74798a8d8755efe8}.location`;
const $fea73e8d1542f4b4$export$b50c2fb16a87be63 = 60000;
const $fea73e8d1542f4b4$export$4857a322416ea6fc = 'dataFetch';
const $fea73e8d1542f4b4$export$cb2bfe2a50a1ece2 = 'clientError';
const $fea73e8d1542f4b4$export$e902262516430940 = 'render';
const $fea73e8d1542f4b4$export$d392c424a6c74b59 = {
    successful: true
};
const $fea73e8d1542f4b4$export$8d035b8b8e3383e = {
    successful: false
};
const $fea73e8d1542f4b4$export$3ea7cf58d679b8d9 = 'panel';
const $fea73e8d1542f4b4$export$680b36a84ba453e0 = 'error-boundary-hit';
const $fea73e8d1542f4b4$export$6796f2a60fb31770 = {
    SCRUM: 'scrum',
    KANBAN: 'kanban'
};
const $fea73e8d1542f4b4$export$36467f64abcaaaa5 = `${$fea73e8d1542f4b4$export$74798a8d8755efe8}.board.${$fea73e8d1542f4b4$export$6796f2a60fb31770.KANBAN}-panel`;
const $fea73e8d1542f4b4$export$28ab2964530cf411 = 'insights-show-insights-button.ui.insights-button';
const $fea73e8d1542f4b4$export$8a355daa8d0cf830 = 'insights-show-insights-button.ui.insights-button-large';
const $fea73e8d1542f4b4$export$f8c16af1b950b647 = 'insights-show-insights-button.ui.insights-button-small';
const $fea73e8d1542f4b4$export$e80ae42ddabf80c5 = 'insights-show-insights-button.ui.insights-button-responsive';

});

parcelRegister("hkiaF", function(module, exports) {

$parcel$export(module.exports, "useUserPropertyObject", () => $0a661d6e69ba699f$export$665203e55622a29c);
$parcel$export(module.exports, "UserPropertiesContainer", () => $0a661d6e69ba699f$export$6a3da208e4d7c782);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $7JoAD = parcelRequire("7JoAD");

var $hcLTR = parcelRequire("hcLTR");
const $0a661d6e69ba699f$var$initialState = {
    properties: {}
};
const $0a661d6e69ba699f$export$42a9887a08055e31 = (0, $7JoAD.createStore)({
    initialState: $0a661d6e69ba699f$var$initialState,
    actions: $hcLTR.default,
    name: 'InsightsUserPropertiesStore'
});
const $0a661d6e69ba699f$export$8e7336a0b77711a8 = (0, $7JoAD.createActionsHook)($0a661d6e69ba699f$export$42a9887a08055e31);
const $0a661d6e69ba699f$export$fbe59e5a949d942d = (0, $7JoAD.createHook)($0a661d6e69ba699f$export$42a9887a08055e31, {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    selector: (state, propertyKey)=>{
        const isLoading = state.properties[propertyKey]?.isLoading;
        const currentValue = state.properties[propertyKey]?.value;
        const error = state.properties[propertyKey]?.error;
        const value = isLoading === false && currentValue !== undefined ? currentValue : null;
        return {
            value: value,
            isLoading: isLoading ?? false,
            error: error ?? null
        };
    }
});
const $0a661d6e69ba699f$export$4599ff36ff959988 = (propertyValue)=>{
    const currentDate = new Date().getTime();
    return Object.fromEntries(Object.entries(propertyValue).filter(([_, value])=>value.expireAt == null || new Date(value.expireAt).getTime() > currentDate));
};
const $0a661d6e69ba699f$var$getExpireAt = (ttl)=>new Date(new Date().getTime() + ttl).toISOString();
const $0a661d6e69ba699f$export$665203e55622a29c = (propertyKey, defaultTtlInMs)=>{
    const [{ value: propertyValue, isLoading: isLoading, error: error }, { saveProperty: saveProperty, loadProperty: loadProperty, savePropertyWithoutSendRequest: savePropertyWithoutSendRequest, sendUpdatePropertyRequest: sendUpdatePropertyRequest }] = $0a661d6e69ba699f$export$fbe59e5a949d942d(propertyKey);
    const debouncedSendUpdatePropertyRequestRef = (0, $5uXOq.useRef)(null);
    const save = (0, $5uXOq.useCallback)((saveKey, savePropertyValue, ttlInMs, options)=>{
        const ttl = ttlInMs || defaultTtlInMs || undefined;
        const newProperty = {
            ...propertyValue,
            [saveKey]: {
                value: savePropertyValue,
                ...ttl ? {
                    expireAt: $0a661d6e69ba699f$var$getExpireAt(ttl)
                } : {}
            }
        };
        const propertyValueNotExpired = $0a661d6e69ba699f$export$4599ff36ff959988(newProperty);
        if (options?.debounceMs) {
            if (debouncedSendUpdatePropertyRequestRef.current) debouncedSendUpdatePropertyRequestRef.current.cancel();
            debouncedSendUpdatePropertyRequestRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(sendUpdatePropertyRequest, options.debounceMs || 0);
            savePropertyWithoutSendRequest(propertyKey, propertyValueNotExpired);
            debouncedSendUpdatePropertyRequestRef.current(propertyKey, propertyValueNotExpired);
        } else saveProperty(propertyKey, propertyValueNotExpired, options?.isResetOnFailEnabled);
    }, [
        defaultTtlInMs,
        propertyValue,
        sendUpdatePropertyRequest,
        savePropertyWithoutSendRequest,
        propertyKey,
        saveProperty
    ]);
    const load = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args)=>loadProperty.bind(null, propertyKey)(...args), [
        loadProperty,
        propertyKey
    ]);
    if (!isLoading && !error && propertyValue != null) {
        const propertyValueNotExpired = $0a661d6e69ba699f$export$4599ff36ff959988(propertyValue);
        return [
            {
                value: propertyValueNotExpired,
                isLoading: isLoading,
                error: error
            },
            {
                save: save,
                loadProperty: load
            }
        ];
    }
    return [
        {
            value: propertyValue,
            isLoading: isLoading,
            error: error
        },
        {
            save: save,
            loadProperty: load
        }
    ];
};
const $0a661d6e69ba699f$var$handlePropsChange = ()=>({ dispatch: dispatch }, { preloadPropertyKeys: preloadPropertyKeys })=>{
        preloadPropertyKeys?.forEach((propertyKey)=>dispatch((0, $hcLTR.default).loadProperty(propertyKey)));
    };
const $0a661d6e69ba699f$export$6a3da208e4d7c782 = (0, $7JoAD.createContainer)($0a661d6e69ba699f$export$42a9887a08055e31, {
    onInit: $0a661d6e69ba699f$var$handlePropsChange,
    onUpdate: $0a661d6e69ba699f$var$handlePropsChange
});

});
parcelRegister("hcLTR", function(module, exports) {

$parcel$export(module.exports, "default", () => $360c6a312ca4d0b8$export$2e2bcd8739ae039);

var $307Mb = parcelRequire("307Mb");

var $3VioW = parcelRequire("3VioW");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$360c6a312ca4d0b8$export$2e2bcd8739ae039 = {
    loadProperty: $307Mb.loadProperty,
    saveProperty: $3VioW.saveProperty,
    savePropertyWithoutSendRequest: $3VioW.savePropertyWithoutSendRequest,
    sendUpdatePropertyRequest: $3VioW.sendUpdatePropertyRequest
};

});
parcelRegister("307Mb", function(module, exports) {

$parcel$export(module.exports, "loadProperty", () => $68074ed537d2904c$export$7bfbec0ee20deb4b);

var $89SaW = parcelRequire("89SaW");

var $dJl1T = parcelRequire("dJl1T");

var $jJZqs = parcelRequire("jJZqs");

const $68074ed537d2904c$export$7bfbec0ee20deb4b = (propertyKey, isRefetch = false)=>async ({ setState: setState, getState: getState }, { accountId: accountId })=>{
        if (!accountId) return;
        const property = getState().properties[propertyKey];
        const isLoading = property?.isLoading === true;
        const hasLoadedSuccessfully = property?.isLoading === false && property?.error == null;
        // skip, if already loaded or loading
        if (isLoading || hasLoadedSuccessfully && !isRefetch) return;
        setState({
            properties: {
                ...getState().properties,
                [propertyKey]: {
                    isLoading: true,
                    error: null,
                    value: null
                }
            }
        });
        try {
            const value = await (0, $89SaW.getUserProperty)(accountId, propertyKey);
            setState({
                properties: {
                    ...getState().properties,
                    [propertyKey]: {
                        isLoading: false,
                        error: null,
                        value: value
                    }
                }
            });
        } catch (error) {
            if (error instanceof (0, $jJZqs.default)) {
                setState({
                    properties: {
                        ...getState().properties,
                        [propertyKey]: {
                            isLoading: false,
                            error: error,
                            value: null
                        }
                    }
                });
                if (error.statusCode >= 500 && error.statusCode <= 599) (0, $dJl1T.default).safeErrorWithoutCustomerData(`${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.user-properties-error`, `Failed to load user property with key: ${propertyKey}`, error);
            } else throw error;
        }
    };

});

parcelRegister("3VioW", function(module, exports) {

$parcel$export(module.exports, "saveProperty", () => $5edadaba4936d90d$export$3d751d226e9d1512);
$parcel$export(module.exports, "savePropertyWithoutSendRequest", () => $5edadaba4936d90d$export$588b3a5c6ec210);
$parcel$export(module.exports, "sendUpdatePropertyRequest", () => $5edadaba4936d90d$export$f83f0aadc36cc25f);

var $dJl1T = parcelRequire("dJl1T");

var $jJZqs = parcelRequire("jJZqs");


var $cj007 = parcelRequire("cj007");
const $5edadaba4936d90d$export$3d751d226e9d1512 = (propertyKey, value, isResetOnFailEnabled = true)=>async ({ setState: setState, getState: getState }, { accountId: accountId })=>{
        if (!accountId) return;
        const oldValue = getState().properties[propertyKey]?.value;
        setState({
            properties: {
                ...getState().properties,
                [propertyKey]: {
                    value: value,
                    isLoading: false,
                    error: null
                }
            }
        });
        try {
            await (0, $cj007.setUserProperties)(accountId, propertyKey, value);
        } catch (error) {
            if (error instanceof (0, $jJZqs.default)) {
                // rollback optimistic update on setUserProperties failure
                if (isResetOnFailEnabled) setState({
                    properties: {
                        ...getState().properties,
                        [propertyKey]: {
                            value: oldValue,
                            isLoading: false,
                            error: null
                        }
                    }
                });
                if (error.statusCode >= 500 && error.statusCode <= 599) (0, $dJl1T.default).safeErrorWithoutCustomerData(`${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.user-properties-error`, `Failed to save user property with key: ${propertyKey}`, error);
            } else throw error;
        }
    };
const $5edadaba4936d90d$export$588b3a5c6ec210 = (propertyKey, value)=>({ setState: setState, getState: getState }, { accountId: accountId })=>{
        if (!accountId) return;
        setState({
            properties: {
                ...getState().properties,
                [propertyKey]: {
                    value: value,
                    isLoading: false,
                    error: null
                }
            }
        });
    };
const $5edadaba4936d90d$export$f83f0aadc36cc25f = (propertyKey, value)=>async (_, { accountId: accountId })=>{
        if (!accountId) return;
        try {
            await (0, $cj007.setUserProperties)(accountId, propertyKey, value);
        } catch (error) {
            if (error instanceof (0, $jJZqs.default)) {
                if (error.statusCode >= 500 && error.statusCode <= 599) (0, $dJl1T.default).safeErrorWithoutCustomerData(`${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.user-properties-error`, `Failed to save user property with key: ${propertyKey}`, error);
            } else throw error;
        }
    };

});
parcelRegister("cj007", function(module, exports) {

$parcel$export(module.exports, "setUserProperties", () => $a89ffbd38185429d$export$d0e176862bf869b8);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");
const $a89ffbd38185429d$export$d0e176862bf869b8 = async (accountId, propertyKey, value)=>{
    const res = await (0, $89SaW.setUserProperties)(accountId, propertyKey, JSON.stringify(value) || '');
    if (res.status >= 400 && res.status <= 599) {
        const errResp = await res.text();
        throw new (0, $jJZqs.default)(res.status, errResp);
    }
    return res;
};

});




parcelRegister("dF42q", function(module, exports) {

$parcel$export(module.exports, "useContextAri", () => $acd3615aed58e2d5$export$f461ed30dc3378ed);

var $5uXOq = parcelRequire("5uXOq");

var $dXq4S = parcelRequire("dXq4S");

var $dAfqg = parcelRequire("dAfqg");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");

var $02beV = parcelRequire("02beV");
const $acd3615aed58e2d5$export$f461ed30dc3378ed = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    const [{ sprints: activeSprints }] = (0, $02beV.useNextBestTaskContainer)();
    const { data: project, loading: loading, error: error } = (0, $dAfqg.useProjectContext)();
    const projectAri = (0, $5uXOq.useMemo)(()=>{
        if (project?.projectId && String(project?.projectId) !== 'undefined' && !loading && !error) return (0, $dXq4S.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project',
            resourceId: String(project?.projectId)
        });
        return null;
    }, [
        cloudId,
        error,
        loading,
        project?.projectId
    ]);
    const sprintAri = (0, $5uXOq.useMemo)(()=>{
        // Note: for now we only generate sprintAri if there is only one active sprint in the list
        if (activeSprints && activeSprints.length === 1) {
            const sprintId = activeSprints[0].id;
            return (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'sprint',
                activationId: activationId,
                resourceId: sprintId.toString()
            });
        }
        return null;
    }, [
        cloudId,
        activationId,
        activeSprints
    ]);
    return {
        sprintAri: sprintAri,
        projectAri: projectAri
    };
};

});

parcelRegister("aD3zD", function(module, exports) {

$parcel$export(module.exports, "SafeNBTDataLoaderForOnlyCurrentUserSelected", () => $e0198580478994e1$export$3b59968555fe80f7);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $axmY8 = parcelRequire("axmY8");

var $02beV = parcelRequire("02beV");
const $e0198580478994e1$var$NBTDataLoaderForOnlyCurrentUserSelected = ({ isOnlyCurrentUserSelected: isOnlyCurrentUserSelected })=>{
    const { setIsOnlyCurrentUserSelected: setIsOnlyCurrentUserSelected } = (0, $02beV.useNextBestTaskActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (setIsOnlyCurrentUserSelected != null) setIsOnlyCurrentUserSelected(isOnlyCurrentUserSelected);
    }, [
        isOnlyCurrentUserSelected,
        setIsOnlyCurrentUserSelected
    ]);
    return null;
};
const $e0198580478994e1$export$3b59968555fe80f7 = ({ isOnlyCurrentUserSelected: isOnlyCurrentUserSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "filter-data-loader",
        packageName: (0, $axmY8.ERROR_BOUNDARY_PACKAGE),
        fallback: "unmount",
        teamName: "nova"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e0198580478994e1$var$NBTDataLoaderForOnlyCurrentUserSelected, {
        isOnlyCurrentUserSelected: isOnlyCurrentUserSelected
    }));

});

parcelRegister("4HjdZ", function(module, exports) {

$parcel$export(module.exports, "AsyncNBTPanel", () => $aac7c2e9161bad1a$export$f4c33ceeb2de61e0);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $lfTZh = parcelRequire("lfTZh");

var $2cyaj = parcelRequire("2cyaj");

var $koeKL = parcelRequire("koeKL");

var $l8ruj = parcelRequire("l8ruj");

var $kxZPA = parcelRequire("kxZPA");

var $dF42q = parcelRequire("dF42q");

var $f8CI1 = parcelRequire("f8CI1");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $aac7c2e9161bad1a$var$LazyNBTPanel = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7vUaM")).then(({ TaskPanel: TaskPanel })=>TaskPanel), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/insights/next-best-task/src/ui/panel/index.tsx"
});

const $aac7c2e9161bad1a$export$ca79ad777943f23b = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7vUaM")).then(({ NewTaskPanel: NewTaskPanel })=>NewTaskPanel), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/insights/next-best-task/src/ui/panel/index.tsx"
});
const $aac7c2e9161bad1a$var$OldAsyncNBTPanel = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "next-best-task-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-nbt-panel",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aac7c2e9161bad1a$var$LazyNBTPanel, props)));
const $aac7c2e9161bad1a$var$NewAsyncNBTPanel = (props)=>{
    const [queryRef, loadQuery, dispose] = (0, $8Uumt.useQueryLoader)((0, $2cyaj.default));
    const { sprintAri: sprintAri, projectAri: projectAri } = (0, $dF42q.useContextAri)();
    const cloudId = (0, $koeKL.useCloudId)();
    const contextAri = (0, $5uXOq.useMemo)(()=>{
        if (projectAri == null) return null;
        const ari = sprintAri ? {
            sprintAri: sprintAri,
            projectAri: projectAri
        } : {
            projectAri: projectAri
        };
        return ari;
    }, [
        sprintAri,
        projectAri
    ]);
    const errorCallbackRef = (0, $5uXOq.useRef)(null);
    const { isReadyToFetchNBT: isReadyToFetchNBT } = (0, $f8CI1.useNextBestTaskPanel)();
    const hasPanelAnimation = props.isSimplifiedProject;
    const fetchGraphEndpoint = (0, $5uXOq.useCallback)(()=>{
        if (contextAri == null) return;
        loadQuery({
            cloudId: cloudId,
            projectAri: contextAri.projectAri,
            isPrRecentCommentEnabled: (0, $4R6GH.fg)('jira-board-work-suggestions-recent-pr-comments'),
            contextAri: contextAri,
            count: 12,
            cursor: null
        }, {
            fetchPolicy: 'network-only'
        });
    }, [
        loadQuery,
        contextAri,
        cloudId
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (isReadyToFetchNBT) {
            if (errorCallbackRef.current !== null) {
                errorCallbackRef.current();
                errorCallbackRef.current = null;
            }
            fetchGraphEndpoint();
        } else if (!hasPanelAnimation) // We will cleanup the data immediately because we don't need to wait for the animation to finish.
        dispose();
    }, [
        isReadyToFetchNBT,
        fetchGraphEndpoint,
        dispose,
        hasPanelAnimation,
        errorCallbackRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "next-best-task-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-nbt-panel",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aac7c2e9161bad1a$export$ca79ad777943f23b, {
        ...props,
        queryRef: queryRef,
        fetchGraphEndpoint: fetchGraphEndpoint,
        dispose: dispose,
        errorCallbackRef: errorCallbackRef
    })));
};
const $aac7c2e9161bad1a$export$f4c33ceeb2de61e0 = (0, $cSD7y.componentWithFG)('jira-board-work-suggestions-early-fire-query', $aac7c2e9161bad1a$var$NewAsyncNBTPanel, $aac7c2e9161bad1a$var$OldAsyncNBTPanel);

});
parcelRegister("2cyaj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c930680b1f6ba133$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<efc4d343dc6bc44c494944dfa9d0b122>>
 * @relayHash c9010014c463aca0f623240a9aceb3bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 530a24ec6df055c082bf409cf70ddea75f020e2c84cf5c910d3505a64ea804ba
const $c930680b1f6ba133$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contextAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cursor"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isPrRecentCommentEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectAri"
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = {
        "kind": "Variable",
        "name": "contextAri",
        "variableName": "contextAri"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        },
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "concreteType": "WorkSuggestionsOrderScore",
        "kind": "LinkedField",
        "name": "orderScore",
        "plural": false,
        "selections": [
            {
                "concreteType": "WorkSuggestionsOrderScores",
                "kind": "LinkedField",
                "name": "byTaskType",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "major"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "minor"
                    }
                ]
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "title"
    }, v13 = {
        "kind": "ScalarField",
        "name": "issueKey"
    }, v14 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v15 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v16 = {
        "kind": "ScalarField",
        "name": "url"
    }, v17 = {
        "kind": "ScalarField",
        "name": "approvalsCount"
    }, v18 = {
        "kind": "ScalarField",
        "name": "commentCount"
    }, v19 = {
        "kind": "ScalarField",
        "name": "repositoryName"
    }, v20 = {
        "kind": "ScalarField",
        "name": "providerName"
    }, v21 = [
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v16 /*: any*/ ,
        v17 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_boardWorkSuggestions_Query",
            "selections": [
                {
                    "args": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        },
                        {
                            "kind": "Variable",
                            "name": "cursor",
                            "variableName": "cursor"
                        },
                        {
                            "kind": "Variable",
                            "name": "isPrRecentCommentEnabled",
                            "variableName": "isPrRecentCommentEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectAri",
                            "variableName": "projectAri"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "main_insightsNextBestTask_TaskPanelController_dataGql"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_boardWorkSuggestions_Query",
            "selections": [
                {
                    "concreteType": "WorkSuggestions",
                    "kind": "LinkedField",
                    "name": "workSuggestions",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "WorkSuggestionsConnection",
                            "kind": "LinkedField",
                            "name": "workSuggestionsByContextAri",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "WorkSuggestionsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isWorkSuggestionsCommon"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "numberOfFailedBuilds"
                                                        },
                                                        v15 /*: any*/ 
                                                    ],
                                                    "type": "WorkSuggestionsBuildTask"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "numberOfFailedDeployments"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "environmentType"
                                                        },
                                                        v15 /*: any*/ 
                                                    ],
                                                    "type": "WorkSuggestionsDeploymentTask"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ],
                                                    "type": "WorkSuggestionsPullRequestReviewTask"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "needsWorkCount"
                                                        },
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ],
                                                    "type": "WorkSuggestionsPullRequestNeedsWorkTask"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "securityContainerName"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "status"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "introducedDate"
                                                        }
                                                    ],
                                                    "type": "WorkSuggestionsCriticalVulnerabilityTask"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        {
                                                            "concreteType": "WorkSuggestionsBlockedIssue",
                                                            "kind": "LinkedField",
                                                            "name": "blockedIssues",
                                                            "plural": true,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v12 /*: any*/ 
                                                            ]
                                                        },
                                                        v14 /*: any*/ 
                                                    ],
                                                    "type": "WorkSuggestionsBlockingIssueTask"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v8 /*: any*/ ,
                            "filters": [
                                "contextAri"
                            ],
                            "handle": "connection",
                            "key": "panel_workSuggestionsByContextAri",
                            "kind": "LinkedHandle",
                            "name": "workSuggestionsByContextAri"
                        },
                        {
                            "args": [
                                v6 /*: any*/ ,
                                {
                                    "items": [
                                        {
                                            "kind": "Variable",
                                            "name": "projectAris.0",
                                            "variableName": "projectAri"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "projectAris"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "sprintAutoDiscoveryLimit",
                                    "value": 0
                                }
                            ],
                            "concreteType": "WorkSuggestionsByProjectsResponse",
                            "kind": "LinkedField",
                            "name": "suggestionsByProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "WorkSuggestionsPullRequestDraftTask",
                                    "kind": "LinkedField",
                                    "name": "draftPRSuggestions",
                                    "plural": true,
                                    "selections": v21 /*: any*/ 
                                },
                                {
                                    "concreteType": "WorkSuggestionsPullRequestInactiveTask",
                                    "kind": "LinkedField",
                                    "name": "inactivePRSuggestions",
                                    "plural": true,
                                    "selections": v21 /*: any*/ 
                                },
                                {
                                    "concreteType": "WorkSuggestionsPullRequestSuggestionsResponse",
                                    "kind": "LinkedField",
                                    "name": "recentPullRequests",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "WorkSuggestionsPRMergeableTask",
                                            "kind": "LinkedField",
                                            "name": "mergeableSuggestions",
                                            "plural": true,
                                            "selections": v21 /*: any*/ 
                                        },
                                        {
                                            "condition": "isPrRecentCommentEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "WorkSuggestionsPRCommentsTask",
                                                    "kind": "LinkedField",
                                                    "name": "newCommentsSuggestions",
                                                    "plural": true,
                                                    "selections": v21 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "530a24ec6df055c082bf409cf70ddea75f020e2c84cf5c910d3505a64ea804ba",
            "metadata": {},
            "name": "main_boardWorkSuggestions_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c930680b1f6ba133$var$node.hash = "68b2757e594f76bde3b7cd56fc573b1f";
var $c930680b1f6ba133$export$2e2bcd8739ae039 = $c930680b1f6ba133$var$node;

});

parcelRegister("7vUaM", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("dsiAd"),
    $6fhBS("aKXDR")
]).then(()=>parcelRequire('59yQa'));

});


parcelRegister("25Q0f", function(module, exports) {

$parcel$export(module.exports, "AsyncNBTPanel", () => $f9ccf5d8edb377f4$export$f4c33ceeb2de61e0);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $l8ruj = parcelRequire("l8ruj");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f9ccf5d8edb377f4$var$LazyNBTPanel = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("fgEUR")).then(({ TaskPanel: TaskPanel })=>TaskPanel), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/insights/next-best-task/src/ui/task-panel/index.tsx"
});
const $f9ccf5d8edb377f4$export$f4c33ceeb2de61e0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "next-best-task-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-nbt-panel",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f9ccf5d8edb377f4$var$LazyNBTPanel, props)));

});
parcelRegister("fgEUR", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("dsiAd"),
    $6fhBS("5H2y2")
]).then(()=>parcelRequire('jxjkk'));

});


parcelRegister("br6MJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $02cb7cf8e445f0c9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8b6174806e3273ec17a26273d0870119>>
 * @relayHash 1cf2c68f8894ef74a759ab4fca4f0ec1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7424e0a7af234d3ba1a603f35b349be6af05ca53135b67e93abbc690fb04a466
const $02cb7cf8e445f0c9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ], v1 = [
        {
            "concreteType": "Insights",
            "kind": "LinkedField",
            "name": "insights",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectAri",
                            "variableName": "projectAri"
                        }
                    ],
                    "concreteType": "InsightsGithubOnboardingDetails",
                    "kind": "LinkedField",
                    "name": "githubOnboardingDetails",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "recommendationVisibility"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "outboundAuthUrl"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "footer_NBTgithubOnboardingDetails_Query",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "footer_NBTgithubOnboardingDetails_Query",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "7424e0a7af234d3ba1a603f35b349be6af05ca53135b67e93abbc690fb04a466",
            "metadata": {},
            "name": "footer_NBTgithubOnboardingDetails_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$02cb7cf8e445f0c9$var$node.hash = "f35e63616c932bb39cf8b019606404e9";
var $02cb7cf8e445f0c9$export$2e2bcd8739ae039 = $02cb7cf8e445f0c9$var$node;

});

parcelRegister("63LqY", function(module, exports) {

$parcel$export(module.exports, "useIsCMPBoard", () => $36d4379301ea45f0$export$73b6b1815a310030);
$parcel$export(module.exports, "useIsJSMBoard", () => $36d4379301ea45f0$export$caf439d171aab0ca);
$parcel$export(module.exports, "useCanEditBoard", () => $36d4379301ea45f0$export$310084e0477bf957);
$parcel$export(module.exports, "useIsJSWBoard", () => $36d4379301ea45f0$export$94abecd95414f165);
$parcel$export(module.exports, "useIsIncrementPlanningBoard", () => $36d4379301ea45f0$export$27d7b2052e1750a7);
$parcel$export(module.exports, "useCapability", () => $36d4379301ea45f0$export$12f4a5dc7ca76777);
/*!
 * This module contains a "CAPABILITIES" API and model for JSW UIF board.
 *
 * Any feature that is "gated" and only available on certain cases should be
 * added here.
 */ 
var $2vSU6 = parcelRequire("2vSU6");

var $2xFXk = parcelRequire("2xFXk");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");
function $36d4379301ea45f0$export$73b6b1815a310030() {
    return (0, $67sX6.useBoardSelector)((state)=>state.configuration.isCMPBoard);
}
function $36d4379301ea45f0$export$caf439d171aab0ca() {
    return (0, $67sX6.useBoardSelector)((0, $67Z81.projectTypeSelector)) === (0, $2vSU6.SERVICE_DESK_PROJECT);
}
function $36d4379301ea45f0$export$310084e0477bf957() {
    return (0, $67sX6.useBoardSelector)((0, $67Z81.getCanEditBoard));
}
function $36d4379301ea45f0$export$94abecd95414f165() {
    return (0, $67sX6.useBoardSelector)((0, $67Z81.projectTypeSelector)) === (0, $2vSU6.SOFTWARE_PROJECT);
}
function $36d4379301ea45f0$export$27d7b2052e1750a7() {
    return (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
}
function $36d4379301ea45f0$export$12f4a5dc7ca76777(key) {
    const isCMPBoard = $36d4379301ea45f0$export$73b6b1815a310030();
    const isIncrementPlanningBoard = $36d4379301ea45f0$export$27d7b2052e1750a7();
    const allFeatures = (0, $67sX6.useBoardSelector)((state)=>(0, $67Z81.getEntities)(state).board.config.allFeatures);
    const projectType = (0, $67sX6.useBoardSelector)((0, $67Z81.projectTypeSelector));
    return (0, $2xFXk.hasCapability)(key, isCMPBoard, isIncrementPlanningBoard, allFeatures, projectType);
}

});


parcelRegister("gM0Co", function(module, exports) {

$parcel$export(module.exports, "UnscheduledWorkPanel", () => $15bfb297b8d29908$export$dbae7400c5347762);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $645AZ = parcelRequire("645AZ");

var $aTwsH = parcelRequire("aTwsH");

var $9Ik53 = parcelRequire("9Ik53");

var $3nIju = parcelRequire("3nIju");

var $a6xVS = parcelRequire("a6xVS");

var $8ydSK = parcelRequire("8ydSK");
const $15bfb297b8d29908$export$dbae7400c5347762 = ()=>{
    const scrollingElementRef = (0, $5uXOq.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $15bfb297b8d29908$var$UnscheduledWorkContainerStyles,
        testId: "software-board.board-panels.unscheduled-work-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3nIju.default), {
        scrollRef: scrollingElementRef,
        isUnscheduledWorkColumnPanel: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ik53.ScrollStateContextProvider), {
        scrollRef: scrollingElementRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a6xVS.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aTwsH.AsyncLazyScrollInterceptorWrapper), {
        scrollEl: scrollingElementRef.current
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8ydSK.default), null)));
};
const $15bfb297b8d29908$var$UnscheduledWorkContainerStyles = (0, $8CUq3.xcss)({
    // Calculate inner content width plus padding on each side and scrollbar width
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `calc(${(0, $645AZ.unscheduledColumnWidth)} + ${(0, $645AZ.scrollbarWidth)} + (${"var(--ds-space-050, 4px)"} * 2))`,
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    display: 'flex',
    backgroundColor: 'elevation.surface',
    zIndex: 'card',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    border: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$exports).N40})`}`,
    borderRadius: 'border.radius.200',
    position: 'relative',
    flexShrink: 0
});

});
parcelRegister("a6xVS", function(module, exports) {

$parcel$export(module.exports, "default", () => $8874e22468986660$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $1dJ6S = parcelRequire("1dJ6S");

var $i28qQ = parcelRequire("i28qQ");

var $lLLkM = parcelRequire("lLLkM");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $4CeiT = parcelRequire("4CeiT");

var $92yNu = parcelRequire("92yNu");

var $guFRy = parcelRequire("guFRy");

var $iDGXn = parcelRequire("iDGXn");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $aH5JS = parcelRequire("aH5JS");

var $grktj = parcelRequire("grktj");

var $cxtbC = parcelRequire("cxtbC");
const $8874e22468986660$var$UnscheduledWorkSwimlanesContainer = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const swimlaneIds = (0, $67sX6.useBoardSelector)((0, $5mTgl.platformSwimlaneIdsSelector));
    const swimlaneHeights = (0, $67sX6.useBoardSelector)((0, $5mTgl.swimlaneHeightsSelector));
    const boardId = (0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector));
    const { setShowUnscheduledColumn: setShowUnscheduledColumn } = (0, $iDGXn.useViewSettingsActions)();
    const cacheOptions = (0, $5uXOq.useMemo)(()=>({
            cache: new Map(),
            getCacheKey: (index)=>swimlaneIds[index]
        }), [
        swimlaneIds
    ]);
    const { rows: rows, totalSize: totalSize, scrollTo: scrollTo } = (0, $guFRy.useVirtual)({
        rowCount: swimlaneIds.length,
        getDefaultRowSize: (index)=>swimlaneHeights[swimlaneIds[index]],
        offsetTop: 0,
        cacheOptions: cacheOptions
    });
    (0, $aH5JS.useAutoScrollSwimlane)(swimlaneIds, scrollTo);
    const renderSwimlanes = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, rows.map(({ index: index, top: top, forceRemeasure: forceRemeasure, measure: measure })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $grktj.default), {
                key: swimlaneIds[index],
                id: swimlaneIds[index],
                index: index,
                top: top,
                measure: measure,
                forceRemeasure: forceRemeasure,
                isLastSwimlane: index === swimlaneIds.length - 1,
                isUnscheduledWorkColumnPanel: true
            })));
    const renderButtonIcon = ()=>(0, $4R6GH.fg)('tnk-1613-jira-visual-refresh-jsw-board-icons-2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($lLLkM))),
            LEGACY_size: "small",
            label: formatMessage((0, $cxtbC.default).closeColumnLabel),
            color: "var(--ds-icon, #44546F)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lLLkM))), {
            size: "small",
            label: formatMessage((0, $cxtbC.default).closeColumnLabel)
        });
    const closeUnscheduledWork = ()=>setShowUnscheduledColumn(Number(boardId), false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8874e22468986660$var$UnscheduledWorkSwimlanesContainerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CeiT.SwimlaneColumnHeaderContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "space-between",
        xcss: $8874e22468986660$var$UnscheduledColumnHeaderContentStyles
    }, (0, $4R6GH.fg)('increment_board_a11y_fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1dJ6S.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cxtbC.default).columnHeaderIssueTermRefresh : (0, $cxtbC.default).columnHeader)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "large",
        weight: "semibold"
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cxtbC.default).columnHeaderIssueTermRefresh : (0, $cxtbC.default).columnHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "software-board.board-container.board.unscheduled-work-swimlanes-container.close-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: renderButtonIcon,
        label: formatMessage((0, $cxtbC.default).closeColumnLabel),
        appearance: "subtle",
        onClick: closeUnscheduledWork
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92yNu.default), {
        minHeight: totalSize,
        isVirtualised: true,
        hideTickMask: true
    }, renderSwimlanes()));
};
var $8874e22468986660$export$2e2bcd8739ae039 = $8874e22468986660$var$UnscheduledWorkSwimlanesContainer;
const $8874e22468986660$var$UnscheduledWorkSwimlanesContainerWrapperStyles = (0, $8CUq3.xcss)({
    height: '100%',
    width: '100%',
    paddingInline: 'space.050'
});
const $8874e22468986660$var$UnscheduledColumnHeaderContentStyles = (0, $8CUq3.xcss)({
    width: '100%',
    paddingBlock: 'space.200',
    paddingLeft: 'space.150',
    paddingRight: 'space.100',
    backgroundColor: 'elevation.surface'
});

});
parcelRegister("4CeiT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1be59ae149867274$export$2e2bcd8739ae039);
$parcel$export(module.exports, "SwimlaneColumnHeaderContainer", () => $1be59ae149867274$export$e7cea2f75fe1edbf);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $645AZ = parcelRequire("645AZ");

var $3kNE6 = parcelRequire("3kNE6");

var $g503o = parcelRequire("g503o");

var $5B6CN = parcelRequire("5B6CN");

var $43IRS = parcelRequire("43IRS");

var $gn6gY = parcelRequire("gn6gY");
const $1be59ae149867274$var$SwimlaneColumnHeader = (props)=>{
    const { id: id, header: header, isDraggable: isDraggable, appearance: appearance = (0, $3kNE6.ColumnTheme).Default, draggableIndex: draggableIndex, flexibleColumns: flexibleColumns } = props;
    const context = (0, $5uXOq.useContext)((0, $43IRS.TransitionZoneIndicatorContainerContext));
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const transitionZoneIndicatorContainerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (context) context.setRef(id, transitionZoneIndicatorContainerRef);
        return ()=>{
            if (context) // remove the ref from the context to prevent memory leak
            context.removeRef(id);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { dragPreview: dragPreview, closestEdge: closestEdge } = (0, $gn6gY.useDraggableColumn)({
        isDraggable: isDraggable,
        elementRef: wrapperRef,
        columnId: id,
        columnIndex: draggableIndex,
        renderPreview: ()=>header
    });
    const getTheme = (theme)=>{
        if (theme && (0, $g503o.columnThemes)[theme]) return (0, $g503o.columnThemes)[theme];
        return (0, $g503o.columnThemes).default;
    };
    const columnTheme = getTheme(appearance);
    const handleOnMouseDown = ()=>{
        // Clear any text selection to prevent unexpected dragging behaviour
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.getSelection()?.removeAllRanges();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1be59ae149867274$export$1f99da106a398c44, {
        innerRef: wrapperRef,
        flexibleColumns: flexibleColumns,
        onMouseDown: handleOnMouseDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1be59ae149867274$export$f7a080d02e441007, {
        flexibleColumns: flexibleColumns
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47bDC.ThemeProvider), {
        theme: columnTheme
    }, header && /*#__PURE__*/ (0, $5uXOq.cloneElement)(header, {
        appearance: appearance
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1be59ae149867274$var$TransitionZoneIndicatorContainer, {
        ref: transitionZoneIndicatorContainerRef
    })), closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5B6CN.ColumnDropIndicator), {
        edge: closestEdge
    }), dragPreview);
};
var $1be59ae149867274$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
 = $1be59ae149867274$var$SwimlaneColumnHeader;
const $1be59ae149867274$var$StyledWrapperControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "gnltj8-0"
})((props)=>({
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'auto',
        flex: '1 1 auto',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        minWidth: `${props.flexibleColumns ? (0, $645AZ.columnMinWithMarginWidth) : (0, $645AZ.columnWithMarginWidth)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        maxWidth: props.flexibleColumns ? '100%' : `${0, $645AZ.columnWithMarginWidth}px`
    }));
const $1be59ae149867274$var$StyledWrapperExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { flexibleColumns: flexibleColumns, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c1txw _2lx21bp4 _1wpz1wug _16jlkb7n _1o9zkb7n _i0dl1wug",
            __cmplp.flexibleColumns ? "_1ul91qnl" : "_1ul91t53",
            __cmplp.flexibleColumns ? "_p12f1osq" : "_p12f1t53",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $1be59ae149867274$export$1f99da106a398c44 = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $1be59ae149867274$var$StyledWrapperExperiment, $1be59ae149867274$var$StyledWrapperControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $1be59ae149867274$export$f7a080d02e441007 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { flexibleColumns: flexibleColumns, isDragging: isDragging, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8wvihs": (0, $lD23V.default)(__cmplp.flexibleColumns ? (0, $645AZ.columnMinWidth) : (0, $645AZ.columnFixedWidth), "px"),
            "--_a3w2g5": (0, $lD23V.default)(__cmplp.flexibleColumns ? '100%' : `${0, $645AZ.columnFixedWidth}px`),
            "--_1rh94qy": (0, $lD23V.default)(__cmplp.isDragging ? `0px 3px 3px 0px ${(0, $645AZ.colors).shadow}` : '')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoi2wt _18u0pdf9 _2hwxpdf9 _1e0c1txw _2lx21bp4 _1wpz1wug _16jlkb7n _1o9zkb7n _i0dl1wug _1ul91uck _p12fsdva _16qs1rk5",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1be59ae149867274$var$TransitionZoneIndicatorContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1pbyqfx8 _154i8ed9 _1ltvidpf _1xi2idpf",
            __cmplp.className
        ])
    });
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
const $1be59ae149867274$export$e7cea2f75fe1edbf = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "gnltj8-1"
})`display:${({ flexibleColumns: flexibleColumns })=>flexibleColumns ? 'grid' : 'flex'};grid-template-columns:${({ flexibleColumns: flexibleColumns })=>{
    if (!flexibleColumns) return 'initial';
    return `repeat(auto-fit,minmax(${0, $645AZ.columnMinWidth}px,1fr))`;
}};grid-auto-flow:column;flex-flow:row nowrap;position:sticky;top:0;z-index:${(0, $645AZ.zIndex).stickyHeaders};width:${({ flexibleColumns: flexibleColumns })=>flexibleColumns ? '100%' : 'auto'};`;

});
parcelRegister("5B6CN", function(module, exports) {

$parcel$export(module.exports, "ColumnDropIndicator", () => $9cca81087fb7633f$export$265e69d63cbbbb15);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $9cca81087fb7633f$export$265e69d63cbbbb15 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { edge: edge, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iu2gc _1bsbyh40 _1pbyqfx8 _bfhk1r2e _lcxvglyw _t9ecmdz7 _4t3i16ig _1kt9b3bt _1cs8stnw _1auk16fl _qnecj39m _kfgt1y44 _1mp41y44 _rfx31ssb _14h8oh42",
            __cmplp.edge === 'left' ? "_1ltvze3t" : "_1ltv1wug",
            __cmplp.edge === 'right' ? "_1xi2ywd4" : "_1xi21wug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gn6gY", function(module, exports) {

$parcel$export(module.exports, "useDraggableColumn", () => $c5ed4c81aa88a1f1$export$a2d73877a5476992);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7nsd3 = parcelRequire("7nsd3");

var $hGgHi = parcelRequire("hGgHi");

var $biEfA = parcelRequire("biEfA");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");
parcelRequire("erBEN");
var $kpXwZ = parcelRequire("kpXwZ");

var $1fZVH = parcelRequire("1fZVH");

var $7D59a = parcelRequire("7D59a");

var $i8wwL = parcelRequire("i8wwL");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5ed4c81aa88a1f1$var$ColumnDragPreviewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1bsb1ogy",
            __cmplp.className
        ])
    });
});
const $c5ed4c81aa88a1f1$var$defaultIsCardDroppable = ()=>false;
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $c5ed4c81aa88a1f1$var$defaultOnDragLeave = ()=>{};
const $c5ed4c81aa88a1f1$export$a2d73877a5476992 = ({ isDraggable: isDraggable, elementRef: elementRef, columnId: columnId, swimlaneId: swimlaneId, columnIndex: columnIndex, renderPreview: renderPreview, onDragLeave: onDragLeave = $c5ed4c81aa88a1f1$var$defaultOnDragLeave, isCardDroppable: isCardDroppable = $c5ed4c81aa88a1f1$var$defaultIsCardDroppable })=>{
    const autobatch = (0, $1fZVH.useAutobatch)();
    const [dragState, setDragState] = (0, $5uXOq.useState)({
        type: 'idle'
    });
    const batchSetDragState = (0, $5uXOq.useCallback)((state)=>autobatch(()=>setDragState(state)), [
        autobatch
    ]);
    const [closestEdge, setClosestEdge] = (0, $5uXOq.useState)(null);
    const batchSetClosestEdge = (0, $5uXOq.useCallback)((edge)=>autobatch(()=>setClosestEdge(edge)), [
        autobatch
    ]);
    const onDragLeaveStable = (0, $7D59a.useEvent)(onDragLeave);
    const isCardDroppableStable = (0, $7D59a.useEvent)(isCardDroppable);
    const { setIsOverColumn: setIsOverColumn } = (0, $i8wwL.useIsCardOverColumn)();
    (0, $5uXOq.useEffect)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(columnIndex) || !elementRef.current) return undefined;
        return (0, $4hDdm.combine)(isDraggable ? (0, $7gWdR.draggable)({
            element: elementRef.current,
            getInitialData: ()=>({
                    type: (0, $25c2ea87c2b04bf9$export$57d0ef745f304b91),
                    columnId: columnId,
                    swimlaneId: swimlaneId,
                    columnIndex: columnIndex
                }),
            onDrop: ()=>batchSetDragState({
                    type: 'idle'
                }),
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $kpXwZ.setCustomNativeDragPreview)({
                    getOffset: ()=>({
                            x: 8,
                            y: 8
                        }),
                    render ({ container: container }) {
                        batchSetDragState({
                            type: 'dragging',
                            container: container
                        });
                        return ()=>batchSetDragState({
                                type: 'idle'
                            });
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            }
        }) : // eslint-disable-next-line @typescript-eslint/no-empty-function
        ()=>{}, (0, $7gWdR.dropTargetForElements)({
            element: elementRef.current,
            getIsSticky: ()=>true,
            getData: ({ input: input, element: element })=>(0, $biEfA.attachClosestEdge)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    type: 'COLUMN',
                    columnId: columnId,
                    swimlaneId: swimlaneId,
                    columnIndex: columnIndex
                }, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'left',
                        'right'
                    ]
                }),
            canDrop: ({ source: source })=>{
                const { type: type } = source.data;
                if (type === (0, $25c2ea87c2b04bf9$export$57d0ef745f304b91)) return true;
                if (type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return isCardDroppableStable(source.data) ?? false;
                return false;
            },
            onDrag: ({ source: { data: data }, self: self, location: location })=>{
                if (data.type === (0, $25c2ea87c2b04bf9$export$57d0ef745f304b91) && data.columnId !== columnId) batchSetClosestEdge((0, $biEfA.extractClosestEdge)(self.data));
                if (data.type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c) && location.current.dropTargets[0]?.data.type === (0, $25c2ea87c2b04bf9$export$57d0ef745f304b91)) {
                    setIsOverColumn(true);
                    return;
                }
                setIsOverColumn(false);
            },
            onDragEnter: ({ source: { data: data }, self: self })=>{
                if (data.type === (0, $25c2ea87c2b04bf9$export$57d0ef745f304b91) && data.columnId !== columnId) batchSetClosestEdge((0, $biEfA.extractClosestEdge)(self.data));
            },
            onDragLeave: ({ source: { data: data } })=>{
                batchSetClosestEdge(null);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                onDragLeaveStable(data.type);
                setIsOverColumn(false);
            },
            onDrop: ()=>{
                batchSetClosestEdge(null);
                setIsOverColumn(false);
            }
        }));
    }, [
        batchSetClosestEdge,
        batchSetDragState,
        closestEdge,
        columnId,
        columnIndex,
        elementRef,
        isCardDroppableStable,
        isDraggable,
        onDragLeaveStable,
        swimlaneId,
        setIsOverColumn
    ]);
    return {
        dragPreview: dragState.type === 'dragging' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c5ed4c81aa88a1f1$var$ColumnDragPreviewContainer, null, renderPreview()), dragState.container) : null,
        closestEdge: closestEdge
    };
};

});
parcelRegister("biEfA", function(module, exports) {

$parcel$export(module.exports, "attachClosestEdge", () => $934cfe81468fb31a$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $934cfe81468fb31a$export$945a571f3b658bf);
const $934cfe81468fb31a$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $934cfe81468fb31a$var$uniqueKey = Symbol('closestEdge');
function $934cfe81468fb31a$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $934cfe81468fb31a$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$934cfe81468fb31a$var$uniqueKey]: addClosestEdge
    };
}
function $934cfe81468fb31a$export$945a571f3b658bf(userData) {
    return userData[$934cfe81468fb31a$var$uniqueKey] ?? null;
}

});

parcelRegister("erBEN", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("kpXwZ")).setCustomNativeDragPreview);

var $kpXwZ = parcelRequire("kpXwZ");

});
parcelRegister("kpXwZ", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => $39163240d699f88a$export$52d889c66db0f96e);

var $40DDD = parcelRequire("40DDD");

var $6aABs = parcelRequire("6aABs");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $39163240d699f88a$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $39163240d699f88a$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $39163240d699f88a$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $ff68169bc3de57ec$export$7d0a15ee70427305),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ if ((0, $6aABs.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $40DDD.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $ff68169bc3de57ec$export$7d0a15ee70427305 = 2147483647;



parcelRegister("1fZVH", function(module, exports) {

$parcel$export(module.exports, "autobatch", () => $befa27b0681ab6bc$export$46f5568dd7916109);
$parcel$export(module.exports, "useAutobatch", () => $befa27b0681ab6bc$export$5b8ae94abd7adcf);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $4R6GH = parcelRequire("4R6GH");
const $befa27b0681ab6bc$var$queue = new Set();
let $befa27b0681ab6bc$var$hasQueuedFlush = false;
function $befa27b0681ab6bc$var$flush() {
    const tasks = Array.from($befa27b0681ab6bc$var$queue);
    $befa27b0681ab6bc$var$queue.clear();
    (0, $7nsd3.unstable_batchedUpdates)(()=>{
        tasks.forEach((task)=>{
            task();
        });
    });
}
function $befa27b0681ab6bc$export$46f5568dd7916109(task) {
    $befa27b0681ab6bc$var$queue.add(task);
    if (!$befa27b0681ab6bc$var$hasQueuedFlush) {
        $befa27b0681ab6bc$var$hasQueuedFlush = true;
        queueMicrotask(()=>{
            $befa27b0681ab6bc$var$hasQueuedFlush = false;
            $befa27b0681ab6bc$var$flush();
        });
    }
    return ()=>{
        $befa27b0681ab6bc$var$queue.delete(task);
    };
}
function $befa27b0681ab6bc$export$5b8ae94abd7adcf() {
    if (!(0, $4R6GH.fg)('jsw_backlog_pragmatic_dnd_automatic_batching')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $5uXOq.useCallback)((task)=>task(), []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const cancelFunctions = (0, $5uXOq.useRef)([]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const batchingFunction = (0, $5uXOq.useCallback)((task)=>{
        const cancel = $befa27b0681ab6bc$export$46f5568dd7916109(task);
        cancelFunctions.current.push(cancel);
    }, []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>()=>{
            cancelFunctions.current.forEach((cancel)=>{
                cancel();
            });
        }, []);
    return batchingFunction;
}

});

parcelRegister("i8wwL", function(module, exports) {

$parcel$export(module.exports, "useIsCardOverColumn", () => $a176ed67c26fc146$export$4fc42d4fdca2b55c);
$parcel$export(module.exports, "ColumnEdgeContextProvider", () => $a176ed67c26fc146$export$582bb25f0ee3befd);

var $5uXOq = parcelRequire("5uXOq");

var $1fZVH = parcelRequire("1fZVH");
const $a176ed67c26fc146$var$ColumnEdgeContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isOverColumn: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIsOverColumn: ()=>{}
});
const $a176ed67c26fc146$export$4fc42d4fdca2b55c = ()=>(0, $5uXOq.useContext)($a176ed67c26fc146$var$ColumnEdgeContext);
const $a176ed67c26fc146$export$582bb25f0ee3befd = ({ children: children })=>{
    const autobatch = (0, $1fZVH.useAutobatch)();
    const [isOverColumn, setIsOverColumn] = (0, $5uXOq.useState)(false);
    const batchSetIsOverColumn = (0, $5uXOq.useCallback)((edge)=>autobatch(()=>setIsOverColumn(edge)), [
        autobatch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a176ed67c26fc146$var$ColumnEdgeContext.Provider, {
        value: {
            isOverColumn: isOverColumn,
            setIsOverColumn: batchSetIsOverColumn
        }
    }, children);
};

});

const $25c2ea87c2b04bf9$export$b05303cbde3e8c8c = 'CARD';
const $25c2ea87c2b04bf9$export$57d0ef745f304b91 = 'COLUMN';
const $25c2ea87c2b04bf9$export$2927f4d423091b16 = 'TRANSITION_ZONE';



parcelRegister("92yNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $66f2ba16fe3bc973$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
function $66f2ba16fe3bc973$export$2e2bcd8739ae039({ flexibleColumns: flexibleColumns, minHeight: minHeight, isVirtualised: isVirtualised, hideTickMask: hideTickMask, children: // Hide tick mask when the swimlane header is not rendered
children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($66f2ba16fe3bc973$var$Wrapper, {
        flexibleColumns: flexibleColumns,
        isVirtualised: isVirtualised,
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: isVirtualised && minHeight ? {
            minHeight: minHeight
        } : {}
    }, !hideTickMask && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($66f2ba16fe3bc973$var$SwimlaneTickMask, null), children);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $66f2ba16fe3bc973$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVirtualised: isVirtualised, flexibleColumns: flexibleColumns, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_m6k41e03",
            __cmplp.isVirtualised ? "_1e0c1ule" : "_1e0c1bgi",
            __cmplp.isVirtualised ? "_kqswh2mm" : "_kqswpfqs",
            __cmplp.flexibleColumns ? "_1bsb1osq" : "_1bsb1wug",
            __cmplp.className
        ])
    });
});
const $66f2ba16fe3bc973$var$SwimlaneTickMask = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _154iidpf _19pk1uiu _4t3ickbl _11q7117k _1pby11wp _18u0idpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("guFRy", function(module, exports) {

$parcel$export(module.exports, "useVirtual", () => $8a37cce55cc85701$export$ebc1863da693699a);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $4R6GH = parcelRequire("4R6GH");

var $itWjr = parcelRequire("itWjr");

var $9Ik53 = parcelRequire("9Ik53");

var $2PIRw = parcelRequire("2PIRw");
const $8a37cce55cc85701$export$c61d420d8ad72523 = (rowCount, offsetTop, getDefaultRowSize, cacheOptions)=>{
    const states = new Array(rowCount);
    let currentTop = offsetTop;
    for(let i = 0; i < rowCount; i += 1){
        const height = cacheOptions?.cache.get(cacheOptions.getCacheKey(i))?.height ?? getDefaultRowSize(i);
        const result = {
            height: height,
            top: currentTop,
            bottom: currentTop + height
        };
        currentTop = result.bottom;
        states[i] = result;
    }
    return states;
};
const $8a37cce55cc85701$var$MINIMUM_CARD_HEIGHT = 0.05;
function $8a37cce55cc85701$export$fd7df3dcf242e12a({ cacheOptions: cacheOptions, index: index, rowStates: rowStates, setRowHeight: setRowHeight, isVisible: isVisible }) {
    const forceRemeasure = (el, withCache = false)=>{
        if (!el) return;
        if (withCache && cacheOptions?.cache?.has(cacheOptions.getCacheKey(index))) return;
        const { height: height } = el.getBoundingClientRect();
        const roundedHeight = Math.round(height * 100) / 100;
        // TODO: React DnD will set row height to 0 on pick-up, that update must be ignored.
        // This is not a clean solution.
        if (roundedHeight > $8a37cce55cc85701$var$MINIMUM_CARD_HEIGHT && cacheOptions) {
            const cacheKey = cacheOptions.getCacheKey(index);
            if (cacheKey !== undefined) cacheOptions.cache.set(cacheKey, {
                height: height
            });
        }
        if (height != null && height > $8a37cce55cc85701$var$MINIMUM_CARD_HEIGHT && rowStates[index].height !== height) setRowHeight(index, height);
    };
    return {
        key: index,
        index: index,
        top: rowStates[index].top,
        isVisible: isVisible,
        measure (el) {
            forceRemeasure(el, true);
        },
        forceRemeasure: forceRemeasure
    };
}
const $8a37cce55cc85701$var$EMPTY_ROW_DESCRIPTOR = [];
function $8a37cce55cc85701$export$824e0ab10a990d7b({ start: start, end: end, rowStates: rowStates, cacheOptions: cacheOptions, setRowHeight: setRowHeight, startVisible: startVisible, endVisible: endVisible }) {
    if (start === end) return $8a37cce55cc85701$var$EMPTY_ROW_DESCRIPTOR;
    const numRows = end - start;
    // This code is structured in a way that allows it to be changed into stable indexes and support element recycling.
    const result = new Array(Math.max(numRows, 0));
    for(let offset = 0; offset < numRows; offset += 1){
        const index = start + offset;
        const isVisible = index >= startVisible && index <= endVisible;
        result[offset] = $8a37cce55cc85701$export$fd7df3dcf242e12a({
            cacheOptions: cacheOptions,
            index: index,
            rowStates: rowStates,
            setRowHeight: setRowHeight,
            isVisible: isVisible
        });
    }
    return result;
}
function $8a37cce55cc85701$var$useRows(scrollState, rowStates, // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
cacheOptions, setRowHeight, overscanHeight) {
    const { start: start, end: end } = (0, $5uXOq.useMemo)(()=>(0, $itWjr.getRenderedRange)(scrollState, rowStates, overscanHeight), [
        scrollState,
        rowStates,
        overscanHeight
    ]);
    const { start: startVisible, end: endVisible } = (0, $5uXOq.useMemo)(()=>(0, $itWjr.getRenderedRange)(scrollState, rowStates, 0), [
        scrollState,
        rowStates
    ]);
    return (0, $5uXOq.useMemo)(()=>$8a37cce55cc85701$export$824e0ab10a990d7b({
            start: start,
            end: end,
            rowStates: rowStates,
            cacheOptions: cacheOptions,
            setRowHeight: setRowHeight,
            startVisible: startVisible,
            endVisible: endVisible
        }), [
        start,
        end,
        rowStates,
        cacheOptions,
        setRowHeight,
        startVisible,
        endVisible
    ]);
}
function $8a37cce55cc85701$export$ebc1863da693699a({ rowCount: rowCount, getDefaultRowSize: getDefaultRowSize, offsetTop: offsetTop = 0, overscanHeight: overscanHeight = 0, cacheOptions: cacheOptions, version: version }) {
    const scrollState = (0, $9Ik53.useScrollState)();
    const [rowStates, setRowStates] = (0, $5uXOq.useState)(()=>$8a37cce55cc85701$export$c61d420d8ad72523(rowCount, offsetTop, getDefaultRowSize, cacheOptions));
    const reinitialize = ()=>setRowStates($8a37cce55cc85701$export$c61d420d8ad72523(rowCount, offsetTop, getDefaultRowSize, cacheOptions));
    const reinitializeRef = (0, $5uXOq.useRef)(reinitialize);
    reinitializeRef.current = reinitialize;
    const reinitializeCb = (0, $5uXOq.useCallback)(()=>reinitializeRef.current(), []);
    const lastOffsetTop = (0, $5uXOq.useRef)(null);
    const lastVersion = (0, $5uXOq.useRef)(null);
    /**
	 * checking rowCount, offsetTop and version to rebuild the rowStates
	 * if the version is undefined, null or empty string, it will not be used
	 */ const shouldRebuildRowStates = rowCount !== rowStates.length || offsetTop !== lastOffsetTop.current || !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(version) && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(version) && version !== lastVersion.current;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (shouldRebuildRowStates) {
            lastVersion.current = version;
            lastOffsetTop.current = offsetTop;
            const states = $8a37cce55cc85701$export$c61d420d8ad72523(rowCount, offsetTop, getDefaultRowSize, cacheOptions);
            setRowStates(states);
        }
    }, [
        rowStates,
        rowCount,
        offsetTop,
        cacheOptions,
        getDefaultRowSize,
        shouldRebuildRowStates,
        version
    ]);
    const scrollTo = (0, $2PIRw.useScrollTo)(rowStates);
    const setRowHeight = (0, $5uXOq.useCallback)((row, height)=>{
        setRowStates((currentRowStates)=>{
            let currentTop = offsetTop;
            return currentRowStates.map((state, index)=>{
                const newState = {
                    ...state
                };
                if (index === row) newState.height = height;
                newState.top = currentTop;
                newState.bottom = currentTop + newState.height;
                currentTop = newState.bottom;
                return newState;
            });
        });
    }, [
        offsetTop
    ]);
    const totalSize = (0, $5uXOq.useMemo)(()=>{
        if ((0, $4R6GH.fg)('board_rendering_optimisations')) // We don't want to end up with a totalSize that is floating point. It results in the
        // ResizeObserver in useElementOffset triggering for pixel changes below 1px
        return Math.ceil(rowStates.reduce((acc, { height: height })=>acc + height, 0));
        let sum = 0;
        rowStates.forEach(({ height: height })=>{
            sum += height; // This is a float
        });
        // We don't want to end up with a totalSize that is floating point. It results in the
        // ResizeObserver in useElementOffset triggering for pixel changes below 1px
        return Math.ceil(sum);
    }, [
        rowStates
    ]);
    const rows = $8a37cce55cc85701$var$useRows(scrollState, rowStates, cacheOptions, setRowHeight, overscanHeight);
    return (0, $5uXOq.useMemo)(()=>({
            rows: rows,
            rowStates: (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') ? rowStates : undefined,
            scrollTo: scrollTo,
            totalSize: totalSize,
            isScrolling: scrollState.isScrolling,
            reinitialize: reinitializeCb
        }), [
        rows,
        rowStates,
        scrollTo,
        totalSize,
        scrollState.isScrolling,
        reinitializeCb
    ]);
}

});
parcelRegister("itWjr", function(module, exports) {

$parcel$export(module.exports, "getRenderedRange", () => $cbe28e6cb7ea4dcb$export$303e1fc2567e8469);
/**
 * Binary search for the nearest value to a `needle`, given high and low indexes
 * and a `getValue` function to get the value at a certain index.
 */ const $cbe28e6cb7ea4dcb$export$b961f15adda64c7b = (lowIndexDontRead, highIndexDontRead, getValue, needle)=>{
    // JFE linting doesn't allow changing the arg as a local.
    let low = lowIndexDontRead;
    let high = highIndexDontRead;
    while(low < high){
        const middleIndex = Math.floor((high + low) / 2);
        const candidate = getValue(middleIndex);
        if (candidate > needle) high = middleIndex - 1;
        else if (candidate < needle) low = middleIndex + 1;
        else return middleIndex;
    }
    return low;
};
const $cbe28e6cb7ea4dcb$export$303e1fc2567e8469 = (viewportRectangle, rowPositions, overscanHeight)=>{
    if (rowPositions.length === 0) return {
        start: 0,
        end: 0
    };
    // Render elements starting at the top edge of the scroll container, minus
    // some overscan height.
    const startPositionTop = viewportRectangle.scrollTop - overscanHeight;
    // And up to elements at the bottom edge of the scroll container, plus some
    // overscan height.
    // NOTE: This needs to default to 0 otherwise it is NaN which means that isAbove is true.
    const endPositionTop = (viewportRectangle?.scrollTop ?? 0) + (viewportRectangle?.height ?? 0) + overscanHeight;
    // If the viewport fully above or under the rows, render nothing
    const isAbove = endPositionTop < rowPositions[0].top;
    const isUnder = startPositionTop > rowPositions[rowPositions.length - 1].bottom;
    if (isAbove || isUnder) return {
        start: 0,
        end: 0
    };
    const startIndex = $cbe28e6cb7ea4dcb$export$b961f15adda64c7b(0, rowPositions.length, (i)=>rowPositions[i].bottom, startPositionTop);
    let endIndex = startIndex;
    while(endIndex < rowPositions.length && rowPositions[endIndex].top <= endPositionTop)endIndex += 1;
    return {
        start: startIndex,
        end: endIndex
    };
};

});

parcelRegister("2PIRw", function(module, exports) {

$parcel$export(module.exports, "useScrollTo", () => $6575a25f747838db$export$d774db9fe736aa73);

var $5uXOq = parcelRequire("5uXOq");

var $9Ik53 = parcelRequire("9Ik53");

var $kTgNN = parcelRequire("kTgNN");
const $6575a25f747838db$export$e1700fccdc2280c5 = 80;
const $6575a25f747838db$var$SCROLLING_INTERVAL = 50;
const $6575a25f747838db$var$SCROLLING_ATTEMPT = 5;
const $6575a25f747838db$export$d774db9fe736aa73 = (rowStates)=>{
    // scrollState CONSTANTLY changes
    // Just grabbing out the scrollElement will hardly change
    const { scrollElement: scrollElement } = (0, $9Ik53.useScrollState)();
    // We do NOT want to regenerate the return function everytime so we should use REFs
    // here instead
    const scrollElementRef = (0, $5uXOq.useRef)(null);
    const rowStatesRef = (0, $5uXOq.useRef)([]);
    (0, $5uXOq.useEffect)(()=>{
        // Only bind to the scrollElementRef once. We don't need it anymore once we have it
        if (scrollElementRef.current === null && scrollElement) scrollElementRef.current = scrollElement;
        // Always ensure our rowStates ref is up to date
        rowStatesRef.current = rowStates ?? rowStatesRef.current;
    }, [
        rowStates,
        scrollElement
    ]);
    const scrollTo = (0, $5uXOq.useCallback)((index, options, attempt = 1)=>{
        let timeoutId = null;
        // Early termination for invalid data
        if (index === -1 || attempt > $6575a25f747838db$var$SCROLLING_ATTEMPT) {
            options?.onComplete?.();
            return;
        }
        if (rowStatesRef?.current == null || // Can be null on first pass
        scrollElementRef?.current == null || // Can be null on first pass
        index >= rowStatesRef.current.length) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            timeoutId = window.setTimeout(()=>{
                scrollTo(index, options, attempt + 1);
            }, $6575a25f747838db$var$SCROLLING_INTERVAL);
            return ()=>{
                timeoutId && clearTimeout(timeoutId);
            };
        }
        const scrollElementEl = scrollElementRef.current;
        const rowState = rowStatesRef.current;
        // Complete scrolling when the target is on screen.
        if ((0, $kTgNN.hasScrolledIntoView)(scrollElementRef.current, rowStatesRef.current[index])) {
            options?.onComplete?.();
            return;
        }
        const scrollToPosition = (0, $kTgNN.getScrollToPosition)(scrollElementEl, rowState[index], options);
        if (options?.immediate) scrollElementEl.scrollTop = scrollToPosition;
        else scrollElementEl.scrollTo({
            top: scrollToPosition,
            behavior: 'smooth'
        });
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        timeoutId = window.setTimeout(()=>scrollTo(index, options, attempt + 1), $6575a25f747838db$var$SCROLLING_INTERVAL);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        scrollElementRef,
        rowStatesRef
    ]);
    return scrollTo;
};

});
parcelRegister("kTgNN", function(module, exports) {

$parcel$export(module.exports, "hasScrolledIntoView", () => $abb1a9602db1b1f8$export$6ced3bc78dcece56);
$parcel$export(module.exports, "getScrollToPosition", () => $abb1a9602db1b1f8$export$dfe56cb366876f29);
const $abb1a9602db1b1f8$var$VIEWPORT_BUFFER = 50;
const $abb1a9602db1b1f8$export$6ced3bc78dcece56 = (scrollElementEl, rowState)=>{
    if (!scrollElementEl || !rowState) return false;
    const topOfRow = rowState.top;
    const bottomOfRow = rowState.top + rowState.height;
    // Make the viewport a bit smaller so the card won't stick to the edge of the screen
    const topOfView = scrollElementEl.scrollTop + $abb1a9602db1b1f8$var$VIEWPORT_BUFFER;
    const bottomOfView = scrollElementEl.scrollTop + scrollElementEl.clientHeight - $abb1a9602db1b1f8$var$VIEWPORT_BUFFER;
    return topOfRow > topOfView && topOfRow < bottomOfView || bottomOfRow > topOfView && bottomOfRow < bottomOfView || topOfRow < topOfView && bottomOfRow > bottomOfView;
};
const $abb1a9602db1b1f8$export$dfe56cb366876f29 = (scrollElementEl, rowState, options)=>{
    if (!scrollElementEl || !rowState) return 0;
    if (options?.hasVirtualisedChildren) return rowState.top - scrollElementEl.clientHeight;
    return rowState.top + rowState.height / 2 - scrollElementEl.clientHeight / 3;
};

});



parcelRegister("iDGXn", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsContainer", () => $ca78323127435ce7$export$920204d7413f6fe1);
$parcel$export(module.exports, "useViewSettings", () => $ca78323127435ce7$export$704cffd05c51e2b6);
$parcel$export(module.exports, "useViewSettingsActions", () => $ca78323127435ce7$export$d6a70239aff099b8);
$parcel$export(module.exports, "useIsFullscreen", () => $ca78323127435ce7$export$d397eccea5f37b0a);
$parcel$export(module.exports, "useShowVersionPanel", () => $ca78323127435ce7$export$459b400687bc0f20);
$parcel$export(module.exports, "useShowEpicPanel", () => $ca78323127435ce7$export$203c9a05aebea04a);
$parcel$export(module.exports, "useShowQuickFilters", () => $ca78323127435ce7$export$714ba21e90859f45);
$parcel$export(module.exports, "useShowCompactMode", () => $ca78323127435ce7$export$8a591bb42a805814);
$parcel$export(module.exports, "useShowPanels", () => $ca78323127435ce7$export$736bfa164a60e240);
$parcel$export(module.exports, "useShowEpics", () => $ca78323127435ce7$export$ecaca052f9755b4e);
$parcel$export(module.exports, "useShowVersions", () => $ca78323127435ce7$export$10178a1fc177e27a);
$parcel$export(module.exports, "useShowStatuses", () => $ca78323127435ce7$export$7a14d92e68e42de1);
$parcel$export(module.exports, "useShowUnscheduledColumn", () => $ca78323127435ce7$export$afb23457b0007ce7);
$parcel$export(module.exports, "useShowIssueLinksStats", () => $ca78323127435ce7$export$1d584d816be8e0fd);
$parcel$export(module.exports, "useShowAssignee", () => $ca78323127435ce7$export$be6bf1e24771efde);
$parcel$export(module.exports, "useShowCardCovers", () => $ca78323127435ce7$export$77ff271d002b6f7e);
$parcel$export(module.exports, "useHasCardExtraFields", () => $ca78323127435ce7$export$9e1ece2ef34a030);
$parcel$export(module.exports, "useCardFieldsSettings", () => $ca78323127435ce7$export$e41d531469117029);
$parcel$export(module.exports, "useShowOfftrackDependencyLines", () => $ca78323127435ce7$export$e709b26074f3a4a5);
$parcel$export(module.exports, "useIssueIdsToShowDependencies", () => $ca78323127435ce7$export$b6fb171038a9e77e);

var $7JoAD = parcelRequire("7JoAD");

var $duOMW = parcelRequire("duOMW");

var $6zihU = parcelRequire("6zihU");

var $ffHmx = parcelRequire("ffHmx");
const $ca78323127435ce7$var$Store = (0, $7JoAD.createStore)({
    name: 'ViewSettings',
    initialState: $duOMW.initialState,
    actions: $6zihU.actions
});
const $ca78323127435ce7$export$920204d7413f6fe1 = (0, $7JoAD.createContainer)($ca78323127435ce7$var$Store, {
    onInit: (0, $6zihU.actions).initState
});
const $ca78323127435ce7$export$704cffd05c51e2b6 = (0, $7JoAD.createHook)($ca78323127435ce7$var$Store);
const $ca78323127435ce7$export$d6a70239aff099b8 = (0, $7JoAD.createActionsHook)($ca78323127435ce7$var$Store);
const $ca78323127435ce7$export$d397eccea5f37b0a = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getIsFullscreen)
});
const $ca78323127435ce7$export$459b400687bc0f20 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowVersionPanel)
});
const $ca78323127435ce7$export$203c9a05aebea04a = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowEpicPanel)
});
const $ca78323127435ce7$export$714ba21e90859f45 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowQuickFilters)
});
const $ca78323127435ce7$export$8a591bb42a805814 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowCompactMode)
});
const $ca78323127435ce7$export$736bfa164a60e240 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowPanels)
});
const $ca78323127435ce7$export$ecaca052f9755b4e = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowEpics)
});
const $ca78323127435ce7$export$10178a1fc177e27a = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowVersions)
});
const $ca78323127435ce7$export$7a14d92e68e42de1 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowStatuses)
});
const $ca78323127435ce7$export$afb23457b0007ce7 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowUnscheduledColumn)
});
const $ca78323127435ce7$export$1d584d816be8e0fd = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowIssueLinksStats)
});
const $ca78323127435ce7$export$c94c02788702c7e4 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowIssueType)
});
const $ca78323127435ce7$export$8007ae8b25a75629 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowIssueKey)
});
const $ca78323127435ce7$export$75223d65852dc3c0 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowPriority)
});
const $ca78323127435ce7$export$eac20fb60c7f35ac = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowDevelopment)
});
const $ca78323127435ce7$export$be6bf1e24771efde = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowAssignee)
});
const $ca78323127435ce7$export$b5a76590347456cc = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowEstimate)
});
const $ca78323127435ce7$export$5e8e69c97a3cd45b = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowCardExtraField)
});
const $ca78323127435ce7$export$a53839ab3a916ce3 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowDaysInColumn)
});
const $ca78323127435ce7$export$77ff271d002b6f7e = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowCardCovers)
});
const $ca78323127435ce7$export$9e1ece2ef34a030 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getHasCardExtraFields)
});
const $ca78323127435ce7$export$e41d531469117029 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getCardFieldsSettings)
});
const $ca78323127435ce7$export$e709b26074f3a4a5 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowOfftrackDependencyLines)
});
const $ca78323127435ce7$export$b6fb171038a9e77e = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getIssueIdsToShowDependencies)
});

});
parcelRegister("6zihU", function(module, exports) {

$parcel$export(module.exports, "actions", () => $718ecccac1489fb2$export$e324594224ef24da);

var $3whhk = parcelRequire("3whhk");
const $718ecccac1489fb2$export$e324594224ef24da = {
    setViewSettings: $3whhk.setViewSettings,
    setIsFullscreen: $3whhk.setIsFullscreen,
    setViewSettingsPanels: $3whhk.setViewSettingsPanels,
    setViewSettingsQuickFilters: $3whhk.setViewSettingsQuickFilters,
    setViewSettingsCardDetails: $3whhk.setViewSettingsCardDetails,
    setViewSettingsCardExtraFields: $3whhk.setViewSettingsCardExtraFields,
    setViewSettingsCompactMode: $3whhk.setViewSettingsCompactMode,
    setShowUnscheduledColumn: $3whhk.setShowUnscheduledColumn,
    setShowOfftrackDependencyLines: $3whhk.setShowOfftrackDependencyLines,
    setIssueIdsToShowDependencies: $3whhk.setIssueIdsToShowDependencies,
    setViewSettingsShowCardCovers: $3whhk.setViewSettingsShowCardCovers,
    toggleViewSetting: $3whhk.toggleViewSetting,
    toggleShowEpics: $3whhk.toggleShowEpics,
    toggleShowVersions: $3whhk.toggleShowVersions,
    toggleShowStatuses: $3whhk.toggleShowStatuses,
    toggleShowLinkedIssuesStats: $3whhk.toggleShowLinkedIssuesStats,
    toggleExtraField: $3whhk.toggleExtraField,
    toggleShowDaysInColumn: $3whhk.toggleShowDaysInColumn,
    toggleShowDueDate: $3whhk.toggleShowDueDate,
    toggleShowLabels: $3whhk.toggleShowLabels,
    initState: $3whhk.initState
};

});
parcelRegister("3whhk", function(module, exports) {

$parcel$export(module.exports, "initState", () => $b6bf5ef387c9e297$export$f6196a6c6bb539b4);
$parcel$export(module.exports, "setViewSettings", () => $b6bf5ef387c9e297$export$99f2d9eb0b41b93);
$parcel$export(module.exports, "setIsFullscreen", () => $b6bf5ef387c9e297$export$9c73b2f282069160);
$parcel$export(module.exports, "setViewSettingsPanels", () => $b6bf5ef387c9e297$export$427f126b21640252);
$parcel$export(module.exports, "setViewSettingsQuickFilters", () => $b6bf5ef387c9e297$export$60d0caf3b1c59159);
$parcel$export(module.exports, "setViewSettingsCompactMode", () => $b6bf5ef387c9e297$export$9ca6e4490ca9b1fc);
$parcel$export(module.exports, "setViewSettingsCardDetails", () => $b6bf5ef387c9e297$export$af2e5a35023755b5);
$parcel$export(module.exports, "setViewSettingsCardExtraFields", () => $b6bf5ef387c9e297$export$b54537ba70def946);
$parcel$export(module.exports, "setViewSettingsShowCardCovers", () => $b6bf5ef387c9e297$export$d166622a8f3a93f0);
$parcel$export(module.exports, "toggleViewSetting", () => $b6bf5ef387c9e297$export$779d9a10b8826796);
$parcel$export(module.exports, "toggleShowEpics", () => $b6bf5ef387c9e297$export$c1bb93dcfa07c797);
$parcel$export(module.exports, "toggleShowVersions", () => $b6bf5ef387c9e297$export$582a65f6c8cb93ab);
$parcel$export(module.exports, "toggleShowStatuses", () => $b6bf5ef387c9e297$export$ac311ca7d5df1d03);
$parcel$export(module.exports, "toggleShowLinkedIssuesStats", () => $b6bf5ef387c9e297$export$580abda923c30dc5);
$parcel$export(module.exports, "setShowUnscheduledColumn", () => $b6bf5ef387c9e297$export$6edce735c6eb4cb0);
$parcel$export(module.exports, "toggleShowDaysInColumn", () => $b6bf5ef387c9e297$export$2849cc68d8e521b7);
$parcel$export(module.exports, "toggleShowDueDate", () => $b6bf5ef387c9e297$export$ef2b1a307fba6e8a);
$parcel$export(module.exports, "toggleShowLabels", () => $b6bf5ef387c9e297$export$229260fb852e61e0);
$parcel$export(module.exports, "toggleExtraField", () => $b6bf5ef387c9e297$export$6acb0c83c20a20);
$parcel$export(module.exports, "setShowOfftrackDependencyLines", () => $b6bf5ef387c9e297$export$2c48063cd4ef1ade);
$parcel$export(module.exports, "setIssueIdsToShowDependencies", () => $b6bf5ef387c9e297$export$f7b68cb584e33d77);

var $9pP0g = parcelRequire("9pP0g");

var $8zmNw = parcelRequire("8zmNw");
const $b6bf5ef387c9e297$export$f6196a6c6bb539b4 = ()=>({ setState: setState }, { view: view })=>{
        setState({
            view: view
        });
    };
const $b6bf5ef387c9e297$export$99f2d9eb0b41b93 = (newState)=>({ setState: setState })=>{
        setState(newState);
    };
const $b6bf5ef387c9e297$export$9c73b2f282069160 = ({ boardId: boardId, view: view, isFullscreen: isFullscreen })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsIsFullscreen({
            boardId: boardId,
            isFullscreen: isFullscreen,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            isFullscreen: isFullscreen
        });
    };
const $b6bf5ef387c9e297$export$427f126b21640252 = ({ boardId: boardId, view: view, panelState: panelState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsPanels({
            boardId: boardId,
            panelState: panelState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpicPanel: panelState.EPIC_PANEL,
            showVersionPanel: panelState.VERSION_PANEL
        });
    };
const $b6bf5ef387c9e297$export$60d0caf3b1c59159 = ({ boardId: boardId, view: view, showQuickFilters: showQuickFilters })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsQuickFilters({
            boardId: boardId,
            showQuickFilters: showQuickFilters,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showQuickFilters: showQuickFilters
        });
    };
const $b6bf5ef387c9e297$export$9ca6e4490ca9b1fc = ({ boardId: boardId, view: view, showCompactMode: showCompactMode })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsCompactMode({
            boardId: boardId,
            showCompactMode: showCompactMode,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showCompactMode: showCompactMode
        });
    };
const $b6bf5ef387c9e297$export$af2e5a35023755b5 = ({ boardId: boardId, view: view, cardDetailsState: cardDetailsState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsCardDetails({
            boardId: boardId,
            cardDetailsState: cardDetailsState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpics: cardDetailsState.SHOW_EPICS,
            showVersions: cardDetailsState.SHOW_VERSIONS,
            showStatuses: cardDetailsState.SHOW_STATUSES,
            showIssueLinksStats: cardDetailsState.SHOW_ISSUE_LINKS_STATS,
            showDaysInColumn: cardDetailsState.SHOW_DAYS_IN_COLUMN,
            showIssueType: cardDetailsState.SHOW_ISSUE_TYPE,
            showIssueKey: cardDetailsState.SHOW_ISSUE_KEY,
            showEstimate: cardDetailsState.SHOW_ESTIMATE,
            showPriority: cardDetailsState.SHOW_PRIORITY,
            showDevelopment: cardDetailsState.SHOW_DEVELOPMENT,
            showAssignee: cardDetailsState.SHOW_ASSIGNEE,
            showDueDate: cardDetailsState.SHOW_DUE_DATE,
            showLabels: cardDetailsState.SHOW_LABELS,
            showCardCovers: cardDetailsState.SHOW_CARD_COVERS
        });
    };
const $b6bf5ef387c9e297$export$b54537ba70def946 = ({ boardId: boardId, view: view, cardExtraFieldsState: cardExtraFieldsState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsCardExtraFields({
            boardId: boardId,
            cardExtraFieldsState: cardExtraFieldsState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            cardExtraFields: cardExtraFieldsState
        });
    };
const $b6bf5ef387c9e297$export$d166622a8f3a93f0 = ({ boardId: boardId, view: view, showCardCovers: showCardCovers })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        const newState = {
            ...currentSettings,
            showCardCovers: showCardCovers
        };
        $8zmNw.setViewSettings({
            boardId: boardId,
            state: newState,
            view: view || currentSettings.view || undefined
        });
        setState(newState);
    };
const $b6bf5ef387c9e297$export$779d9a10b8826796 = ({ boardId: boardId, view: view, setting: setting })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        const set = (newState)=>{
            setState(newState);
            $8zmNw.setViewSettings({
                boardId: boardId,
                state: newState,
                view: view || currentSettings.view || undefined
            });
        };
        switch(setting){
            case (0, $9pP0g.ViewSetting).VERSION_PANEL:
                set({
                    ...currentSettings,
                    showVersionPanel: !currentSettings.showVersionPanel
                });
                break;
            case (0, $9pP0g.ViewSetting).EPIC_PANEL:
                set({
                    ...currentSettings,
                    showEpicPanel: !currentSettings.showEpicPanel
                });
                break;
            case (0, $9pP0g.ViewSetting).QUICK_FILTERS:
                set({
                    ...currentSettings,
                    showQuickFilters: !currentSettings.showQuickFilters
                });
                break;
            case (0, $9pP0g.ViewSetting).COMPACT_MODE:
                set({
                    ...currentSettings,
                    showCompactMode: !currentSettings.showCompactMode
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_EPICS:
                set({
                    ...currentSettings,
                    showEpics: !currentSettings.showEpics
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_STATUSES:
                set({
                    ...currentSettings,
                    showStatuses: !currentSettings.showStatuses
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_VERSIONS:
                set({
                    ...currentSettings,
                    showVersions: !currentSettings.showVersions
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_UNSCHEDULED_COLUMN:
                set({
                    ...currentSettings,
                    showUnscheduledColumn: !currentSettings.showUnscheduledColumn
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY:
                set({
                    ...currentSettings,
                    showIssueKey: !currentSettings.showIssueKey
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE:
                set({
                    ...currentSettings,
                    showIssueType: !currentSettings.showIssueType
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_PRIORITY:
                set({
                    ...currentSettings,
                    showPriority: !currentSettings.showPriority
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_DEVELOPMENT:
                set({
                    ...currentSettings,
                    showDevelopment: !currentSettings.showDevelopment
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_ASSIGNEE:
                set({
                    ...currentSettings,
                    showAssignee: !currentSettings.showAssignee
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_ESTIMATE:
                set({
                    ...currentSettings,
                    showEstimate: !currentSettings.showEstimate
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_DAYS_IN_COLUMN:
                set({
                    ...currentSettings,
                    showDaysInColumn: !currentSettings.showDaysInColumn
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_DUE_DATE:
                set({
                    ...currentSettings,
                    showDueDate: !currentSettings.showDueDate
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_LABELS:
                set({
                    ...currentSettings,
                    showLabels: !currentSettings.showLabels
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_CARD_COVERS:
                set({
                    ...currentSettings,
                    showCardCovers: !currentSettings.showCardCovers
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_OFFTRACK_DEPENDENCY_LINES:
                set({
                    ...currentSettings,
                    showOfftrackDependencyLines: !currentSettings.showOfftrackDependencyLines
                });
                break;
            default:
                break;
        }
    };
const $b6bf5ef387c9e297$export$c1bb93dcfa07c797 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowEpics({
            boardId: boardId,
            showEpics: !currentSettings.showEpics,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpics: !currentSettings.showEpics
        });
    };
const $b6bf5ef387c9e297$export$582a65f6c8cb93ab = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowVersions({
            boardId: boardId,
            showVersions: !currentSettings.showVersions,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showVersions: !currentSettings.showVersions
        });
    };
const $b6bf5ef387c9e297$export$ac311ca7d5df1d03 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowStatuses({
            boardId: boardId,
            showStatuses: !currentSettings.showStatuses,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showStatuses: !currentSettings.showStatuses
        });
    };
const $b6bf5ef387c9e297$export$580abda923c30dc5 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowIssueLinksStats({
            boardId: boardId,
            showIssueLinksStats: !currentSettings.showIssueLinksStats,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showIssueLinksStats: !currentSettings.showIssueLinksStats
        });
    };
const $b6bf5ef387c9e297$export$6edce735c6eb4cb0 = (boardId, isVisible)=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowUnscheduledColumn({
            boardId: boardId,
            showUnscheduledColumn: isVisible
        });
        setState({
            ...currentSettings,
            showUnscheduledColumn: isVisible
        });
    };
const $b6bf5ef387c9e297$export$2849cc68d8e521b7 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowDaysInColumn({
            boardId: boardId,
            showDaysInColumn: !currentSettings.showDaysInColumn,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showDaysInColumn: !currentSettings.showDaysInColumn
        });
    };
const $b6bf5ef387c9e297$export$ef2b1a307fba6e8a = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowDueDate({
            boardId: boardId,
            showDueDate: !currentSettings.showDueDate,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showDueDate: !currentSettings.showDueDate
        });
    };
const $b6bf5ef387c9e297$export$229260fb852e61e0 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowLabels({
            boardId: boardId,
            showLabels: !currentSettings.showLabels,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showLabels: !currentSettings.showLabels
        });
    };
const $b6bf5ef387c9e297$export$6acb0c83c20a20 = ({ boardId: boardId, view: view, fieldId: fieldId })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        const currentExtraFields = currentSettings.cardExtraFields;
        $8zmNw.setExtraFields({
            boardId: boardId,
            cardExtraFields: {
                ...currentExtraFields,
                [fieldId]: !currentExtraFields[fieldId]
            },
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            cardExtraFields: {
                ...currentExtraFields,
                [fieldId]: !currentExtraFields[fieldId]
            }
        });
    };
const $b6bf5ef387c9e297$export$2c48063cd4ef1ade = (boardId, isVisible)=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowOfftrackDependencyLines({
            boardId: boardId,
            showOfftrackDependencyLines: isVisible
        });
        setState({
            ...currentSettings,
            showOfftrackDependencyLines: isVisible
        });
    };
const $b6bf5ef387c9e297$export$f7b68cb584e33d77 = (boardId, issueIds)=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setIssueIdsToShowDependencies({
            boardId: boardId,
            issueIds: issueIds
        });
        setState({
            ...currentSettings,
            issueIdsToShowDependencies: issueIds
        });
    };

});
parcelRegister("9pP0g", function(module, exports) {

$parcel$export(module.exports, "ViewSetting", () => $23bab0da4eba41c6$export$b6da678b61e4982c);

var $a4XJc = parcelRequire("a4XJc");

var $iJgHp = parcelRequire("iJgHp");
const $23bab0da4eba41c6$export$b6da678b61e4982c = {
    ...(0, $a4XJc.Panels),
    ...(0, $iJgHp.CardDetails),
    ...(0, $a4XJc.IncrementPlanningSettings),
    QUICK_FILTERS: $a4XJc.QUICK_FILTERS,
    COMPACT_MODE: $a4XJc.COMPACT_MODE
};

});
parcelRegister("iJgHp", function(module, exports) {

$parcel$export(module.exports, "CardDetails", () => $a1cb757db25241b3$export$741386389156bf07);

var $a4XJc = parcelRequire("a4XJc");
const $a1cb757db25241b3$export$741386389156bf07 = {
    SHOW_ISSUE_KEY: $a4XJc.SHOW_ISSUE_KEY,
    SHOW_ISSUE_TYPE: $a4XJc.SHOW_ISSUE_TYPE,
    SHOW_EPICS: $a4XJc.SHOW_EPICS,
    SHOW_STATUSES: $a4XJc.SHOW_STATUSES,
    SHOW_VERSIONS: $a4XJc.SHOW_VERSIONS,
    SHOW_ISSUE_LINKS_STATS: $a4XJc.SHOW_ISSUE_LINKS_STATS,
    SHOW_PRIORITY: $a4XJc.SHOW_PRIORITY,
    SHOW_DEVELOPMENT: $a4XJc.SHOW_DEVELOPMENT,
    SHOW_ASSIGNEE: $a4XJc.SHOW_ASSIGNEE,
    SHOW_ESTIMATE: $a4XJc.SHOW_ESTIMATE,
    SHOW_DAYS_IN_COLUMN: $a4XJc.SHOW_DAYS_IN_COLUMN,
    SHOW_DUE_DATE: $a4XJc.SHOW_DUE_DATE,
    SHOW_LABELS: $a4XJc.SHOW_LABELS,
    SHOW_CARD_COVERS: $a4XJc.SHOW_CARD_COVERS
};

});




parcelRegister("ffHmx", function(module, exports) {

$parcel$export(module.exports, "getIsFullscreen", () => $fc378329dceca517$export$b061161f83abaf15);
$parcel$export(module.exports, "getShowVersionPanel", () => $fc378329dceca517$export$cdf1158c8123d31c);
$parcel$export(module.exports, "getShowEpicPanel", () => $fc378329dceca517$export$fc9a39e5c1906367);
$parcel$export(module.exports, "getShowQuickFilters", () => $fc378329dceca517$export$732caa9fcae1c5ff);
$parcel$export(module.exports, "getShowCompactMode", () => $fc378329dceca517$export$72bae49530cc02bb);
$parcel$export(module.exports, "getShowPanels", () => $fc378329dceca517$export$e2483fb3e0d0ff4b);
$parcel$export(module.exports, "getShowEpics", () => $fc378329dceca517$export$b631ebb4887e6060);
$parcel$export(module.exports, "getShowVersions", () => $fc378329dceca517$export$2cb6de520195dbf5);
$parcel$export(module.exports, "getShowStatuses", () => $fc378329dceca517$export$b5f1c34af9498ea);
$parcel$export(module.exports, "getShowUnscheduledColumn", () => $fc378329dceca517$export$bf31a7b99f7bc62f);
$parcel$export(module.exports, "getShowIssueLinksStats", () => $fc378329dceca517$export$266785c43d094472);
$parcel$export(module.exports, "getShowIssueType", () => $fc378329dceca517$export$a079b5f709c4d237);
$parcel$export(module.exports, "getShowIssueKey", () => $fc378329dceca517$export$cb710ef8b1ccd94b);
$parcel$export(module.exports, "getShowPriority", () => $fc378329dceca517$export$5abfbf16fb2cec7b);
$parcel$export(module.exports, "getShowDevelopment", () => $fc378329dceca517$export$d89a1b3e54af627e);
$parcel$export(module.exports, "getShowAssignee", () => $fc378329dceca517$export$ad1a6d247a05049d);
$parcel$export(module.exports, "getShowEstimate", () => $fc378329dceca517$export$d21c0b83591460c9);
$parcel$export(module.exports, "getShowCardExtraField", () => $fc378329dceca517$export$7549550e839e6e0c);
$parcel$export(module.exports, "getShowDaysInColumn", () => $fc378329dceca517$export$9a608cd91e68c95c);
$parcel$export(module.exports, "getShowCardCovers", () => $fc378329dceca517$export$983376245b8547dc);
$parcel$export(module.exports, "getShowOfftrackDependencyLines", () => $fc378329dceca517$export$32c01395d25dfdcc);
$parcel$export(module.exports, "getIssueIdsToShowDependencies", () => $fc378329dceca517$export$67e6bba1326e537a);
$parcel$export(module.exports, "getCardFieldsSettings", () => $fc378329dceca517$export$e9dfc10bd434fabb);
$parcel$export(module.exports, "getHasCardExtraFields", () => $fc378329dceca517$export$1e24fae4497ff7e0);
const $fc378329dceca517$export$b061161f83abaf15 = (state)=>state.isFullscreen;
const $fc378329dceca517$export$cdf1158c8123d31c = (state)=>state.showVersionPanel;
const $fc378329dceca517$export$fc9a39e5c1906367 = (state)=>state.showEpicPanel;
const $fc378329dceca517$export$732caa9fcae1c5ff = (state)=>state.showQuickFilters;
const $fc378329dceca517$export$72bae49530cc02bb = (state)=>state.showCompactMode;
const $fc378329dceca517$export$e2483fb3e0d0ff4b = (state)=>({
        EPIC_PANEL: state.showEpicPanel,
        VERSION_PANEL: state.showVersionPanel
    });
const $fc378329dceca517$export$b631ebb4887e6060 = (state)=>state.showEpics;
const $fc378329dceca517$export$2cb6de520195dbf5 = (state)=>state.showVersions;
const $fc378329dceca517$export$b5f1c34af9498ea = (state)=>state.showStatuses;
const $fc378329dceca517$export$bf31a7b99f7bc62f = (state)=>state.showUnscheduledColumn;
const $fc378329dceca517$export$266785c43d094472 = (state)=>state.showIssueLinksStats;
const $fc378329dceca517$export$a079b5f709c4d237 = (state)=>state.showIssueType;
const $fc378329dceca517$export$cb710ef8b1ccd94b = (state)=>state.showIssueKey;
const $fc378329dceca517$export$5abfbf16fb2cec7b = (state)=>state.showPriority;
const $fc378329dceca517$export$d89a1b3e54af627e = (state)=>state.showDevelopment;
const $fc378329dceca517$export$ad1a6d247a05049d = (state)=>state.showAssignee;
const $fc378329dceca517$export$d21c0b83591460c9 = (state)=>state.showEstimate;
const $fc378329dceca517$export$7549550e839e6e0c = (state)=>state.cardExtraFields;
const $fc378329dceca517$export$9a608cd91e68c95c = (state)=>state.showDaysInColumn;
const $fc378329dceca517$export$983376245b8547dc = (state)=>state.showCardCovers;
const $fc378329dceca517$export$32c01395d25dfdcc = (state)=>state.showOfftrackDependencyLines;
const $fc378329dceca517$export$67e6bba1326e537a = (state)=>state.issueIdsToShowDependencies;
const $fc378329dceca517$export$e9dfc10bd434fabb = (state)=>({
        showIssueType: state.showIssueType,
        showIssueKey: state.showIssueKey,
        showPriority: state.showPriority,
        showDevelopment: state.showDevelopment,
        showAssignee: state.showAssignee,
        showEstimate: state.showEstimate,
        cardExtraFields: state.cardExtraFields,
        showDaysInColumn: state.showDaysInColumn,
        showDueDate: state.showDueDate,
        showLabels: state.showLabels,
        showCardCovers: state.showCardCovers
    });
const $fc378329dceca517$export$1e24fae4497ff7e0 = (state)=>Object.values(state.cardExtraFields).length > 0 && Object.values(state.cardExtraFields).some((value)=>value === true);

});


parcelRegister("aH5JS", function(module, exports) {

$parcel$export(module.exports, "useAutoScrollSwimlane", () => $94eba0273c8c9106$export$8760bae08e9c84b7);

var $5uXOq = parcelRequire("5uXOq");

var $67sX6 = parcelRequire("67sX6");

var $9OPlz = parcelRequire("9OPlz");

var $5mTgl = parcelRequire("5mTgl");
const $94eba0273c8c9106$export$8760bae08e9c84b7 = (swimlaneIds, scrollTo)=>{
    const autoScroll = (0, $67sX6.useBoardSelector)((0, $9OPlz.getCardAutoScroll));
    const getPlatformIssue = (0, $67sX6.useBoardSelector)((0, $5mTgl.platformIssueSelector));
    (0, $5uXOq.useEffect)(()=>{
        const autoScrollIssueId = autoScroll?.issueId;
        const autoScrollSwimlaneId = autoScrollIssueId ? getPlatformIssue(autoScrollIssueId)?.swimlaneId : undefined;
        if (!autoScrollSwimlaneId) return;
        const swimlaneIndex = swimlaneIds.indexOf(autoScrollSwimlaneId);
        if (swimlaneIndex === -1) return;
        return scrollTo(swimlaneIndex, {
            immediate: true,
            hasVirtualisedChildren: true
        });
    }, [
        autoScroll,
        getPlatformIssue,
        scrollTo,
        swimlaneIds
    ]);
};

});

parcelRegister("grktj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a2f76db5f44fdad$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $2m0b6 = parcelRequire("2m0b6");

var $7D59a = parcelRequire("7D59a");

var $kgiLc = parcelRequire("kgiLc");

var $63LqY = parcelRequire("63LqY");

var $4lizL = parcelRequire("4lizL");

var $hASys = parcelRequire("hASys");

var $f3HGL = parcelRequire("f3HGL");

var $ebF5k = parcelRequire("ebF5k");
const $2a2f76db5f44fdad$var$VirtualizedSwimlane = ({ id: id, index: index, top: top, measure: measure, forceRemeasure: forceRemeasure, isLastSwimlane: isLastSwimlane, isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel })=>{
    const [isCreateButtonVisible, setIsCreateButtonVisible] = (0, $5uXOq.useState)(false);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const onResize = (0, $7D59a.useEvent)(()=>{
        forceRemeasure(wrapperRef.current);
    });
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (wrapperRef.current) measure(wrapperRef.current);
    }, [
        wrapperRef,
        measure
    ]);
    (0, $2m0b6.useResizeObserver)({
        ref: wrapperRef,
        onResize: onResize
    });
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const showCreateButton = (0, $5uXOq.useCallback)(()=>{
        setIsCreateButtonVisible(true);
    }, [
        setIsCreateButtonVisible
    ]);
    const hideCreateButton = (0, $5uXOq.useCallback)(()=>{
        setIsCreateButtonVisible(false);
    }, [
        setIsCreateButtonVisible
    ]);
    const swimlaneId = isUnscheduledWorkColumnPanel ? (0, $kgiLc.appendUnscheduledWorkSwimlaneIdSuffix)(id) : id;
    const customRightContent = (0, $5uXOq.useMemo)(()=>{
        if (!isIPBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f3HGL.SwimlaneMoveToDoneButton), {
            id: id
        });
        if (isUnscheduledWorkColumnPanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: isCreateButtonVisible ? $2a2f76db5f44fdad$var$visibleButton : $2a2f76db5f44fdad$var$hiddenButton,
            testId: "software-board.board-container.board.virtualized-swimlane.create-unscheduled-issue-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebF5k.default), {
            teamId: swimlaneId
        }));
        return null;
    }, [
        id,
        swimlaneId,
        isCreateButtonVisible,
        isIPBoard,
        isUnscheduledWorkColumnPanel
    ]);
    const swimlane = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hASys.default), {
        id: swimlaneId,
        key: swimlaneId,
        isFirstSwimlane: index === 0,
        wrapperStyle: {
            position: 'absolute',
            width: '100%',
            top: top
        },
        innerRef: wrapperRef,
        customRightContent: customRightContent,
        hasShadow: !isIPBoard,
        isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4lizL.default), {
        swimlaneId: id,
        isLastSwimlane: isLastSwimlane,
        isFirstSwimlane: index === 0,
        offsetTop: top,
        isUnscheduledWorkColumn: isUnscheduledWorkColumnPanel
    }));
    return isUnscheduledWorkColumnPanel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        onMouseEnter: showCreateButton,
        onMouseLeave: hideCreateButton,
        onFocus: showCreateButton,
        onBlur: hideCreateButton
    }, swimlane) : swimlane;
};
const $2a2f76db5f44fdad$var$visibleButton = (0, $8CUq3.xcss)({
    opacity: 1
});
const $2a2f76db5f44fdad$var$hiddenButton = (0, $8CUq3.xcss)({
    opacity: 0
});
var $2a2f76db5f44fdad$export$2e2bcd8739ae039 = $2a2f76db5f44fdad$var$VirtualizedSwimlane;

});
parcelRegister("2m0b6", function(module, exports) {

$parcel$export(module.exports, "createResizeObserverHook", () => $072291c9ed048772$export$87a9d3e287304ae4);
$parcel$export(module.exports, "useResizeObserver", () => $072291c9ed048772$export$683480f191c0e3ea);
$parcel$export(module.exports, "flushResizeObservers", () => $072291c9ed048772$export$a181ef2a6d0a1bb6);
$parcel$export(module.exports, "useRectObserver", () => $072291c9ed048772$export$e58143dc89297272);

var $5uXOq = parcelRequire("5uXOq");

var $eUdQc = parcelRequire("eUdQc");
function $072291c9ed048772$export$87a9d3e287304ae4(params) {
    const group = new (0, $eUdQc.ResizeObserverGroup)(params?.debouncePeriod);
    /**
	 * This hook uses a shared ResizeObserver instance.
	 *
	 * When a resize notification comes in, a single batched React update will be
	 * dispatched after a debounce period only for the elements that have been
	 * resized.
	 *
	 * This does NOT react to updates to REF
	 */ function useResizeObserver({ ref: ref, onResize: onResize }) {
        const onResizeRef = (0, $5uXOq.useRef)(onResize);
        (0, $5uXOq.useEffect)(()=>{
            onResizeRef.current = onResize;
        });
        const stableOnResize = (0, $5uXOq.useCallback)(()=>onResizeRef.current(), []);
        (0, $5uXOq.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
            ref,
            stableOnResize
        ]);
    }
    return {
        useResizeObserver: useResizeObserver,
        flushResizeObservers: ()=>group.flush()
    };
}
const { useResizeObserver: $072291c9ed048772$export$683480f191c0e3ea, flushResizeObservers: $072291c9ed048772$export$a181ef2a6d0a1bb6 } = $072291c9ed048772$export$87a9d3e287304ae4();
function $072291c9ed048772$export$e58143dc89297272({ ref: ref, useResizeObserverDI: useResizeObserverDI = $072291c9ed048772$export$683480f191c0e3ea }) {
    const [rect, setRect] = (0, $5uXOq.useState)(null);
    const onResize = ()=>{
        if (ref.current) setRect(ref.current.getBoundingClientRect());
    };
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!ref.current) throw new Error([
            'useRectObserver: ref is not available on mount.',
            'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
            'This will not work properly. Please update your code so that refs are always attached to components on mount.'
        ].join('\n'));
        setRect(ref.current.getBoundingClientRect());
    }, [
        ref
    ]);
    useResizeObserverDI({
        ref: ref,
        onResize: onResize
    });
    return rect;
}

});
parcelRegister("eUdQc", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverGroup", () => $52e6ab4254804b44$export$607798bbe2869c0);

var $7nsd3 = parcelRequire("7nsd3");

var $lFKmC = parcelRequire("lFKmC");
class $52e6ab4254804b44$export$607798bbe2869c0 {
    constructor(debouncePeriod = 16){
        this.subscribers = new Map();
        this.pendingUpdates = new Map();
        this.onResize = (entries)=>{
            entries.forEach((entry)=>{
                const subscriber = this.subscribers.get(entry.target);
                if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
            });
            this.scheduleFlush();
        };
        this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
        this.scheduleFlush = debouncePeriod > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            this.flush();
        }, debouncePeriod, {
            trailing: true,
            maxWait: 32
        }) : ()=>{
            this.flush();
        };
    }
    observe(ref, callback) {
        if (!ref.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        this.subscribers.set(ref.current, {
            element: ref.current,
            callback: callback
        });
        this.observer?.observe(ref.current);
        return ()=>{
            if (!ref.current) return;
            this.subscribers.delete(ref.current);
            this.pendingUpdates.delete(ref.current);
            this.observer?.unobserve(ref.current);
        };
    }
    flush() {
        const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
        this.pendingUpdates.clear();
        (0, $7nsd3.unstable_batchedUpdates)(()=>{
            entries.forEach(({ callback: callback })=>{
                callback();
            });
        });
    }
}

});


parcelRegister("4lizL", function(module, exports) {

$parcel$export(module.exports, "default", () => $aed62d78335d31c0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $hGgHi = parcelRequire("hGgHi");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $3hUhs = parcelRequire("3hUhs");

var $2Z6La = parcelRequire("2Z6La");

var $2xFXk = parcelRequire("2xFXk");

var $fG4NG = parcelRequire("fG4NG");

var $iuuJH = parcelRequire("iuuJH");

var $67sX6 = parcelRequire("67sX6");

var $gXFr2 = parcelRequire("gXFr2");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");

var $8iBOe = parcelRequire("8iBOe");

var $1DV2S = parcelRequire("1DV2S");

var $aanra = parcelRequire("aanra");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $aed62d78335d31c0$var$shouldDisableVirtualisation = !!window.DISABLE_VIRTUALISATION;
const $aed62d78335d31c0$var$EMPTY_ARRAY = [];
const $aed62d78335d31c0$var$ColumnsContainer = ({ swimlaneId: swimlaneId, isLastSwimlane: isLastSwimlane, isFirstSwimlane: isFirstSwimlane, isUnscheduledWorkColumn: isUnscheduledWorkColumn = false, offsetTop: offsetTop = 0 })=>{
    const { sampleProjectDataNudgeRef: sampleProjectDataNudgeRef, shouldShowSampleProjectDataNudge: shouldShowSampleProjectDataNudge } = (0, $fG4NG.usePersonalizedSampleData)();
    const isFlexible = (0, $63LqY.useCapability)((0, $2xFXk.Capability).FLEXIBLE_BOARD_COLUMNS);
    const columns = (0, $67sX6.useBoardSelector)(isUnscheduledWorkColumn ? (0, $5mTgl.unscheduledColumnSelector) : (0, $5mTgl.columnsWithResolutionSelector));
    const lastFilteredIssueTypeId = (0, $67sX6.useBoardSelector)((0, $5mTgl.getLastFilteredIssueTypeId));
    const lastFilteredProjectId = (0, $67sX6.useBoardSelector)((0, $5mTgl.getLastFilteredProjectId));
    const defaultProjectId = (0, $67sX6.useBoardSelector)((0, $gXFr2.getDefaultProjectIdForIssueCreation));
    const swimlaneMode = (0, $67sX6.useBoardSelector)((0, $45cXl.getSwimlaneMode));
    const getProjectFromSwimlaneId = (0, $67sX6.useBoardSelector)((0, $5mTgl.platformSwimlaneSelector));
    const ref = (0, $5uXOq.useRef)(null);
    const { initialProjectId: projectId, onChangeCardType: onChangeCardType, onChangeProject: onChangeProject } = (0, $2Z6La.useIccContext)();
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const projectIdToSync = (0, $5uXOq.useMemo)(()=>{
        if (isIPBoard) {
            // Return the last filtered project ID if it exists
            if (lastFilteredProjectId) return lastFilteredProjectId;
             // Otherwise return defaultProjectId if projectId has not been set in inline card create context
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectId) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(defaultProjectId)) return defaultProjectId;
        }
        if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PROJECT).id && swimlaneId) {
            const swimlaneProjectId = getProjectFromSwimlaneId(swimlaneId)?.id;
            return swimlaneProjectId ? Number(swimlaneProjectId) : null;
        }
        return null;
    }, [
        isIPBoard,
        swimlaneMode,
        lastFilteredProjectId,
        projectId,
        defaultProjectId,
        getProjectFromSwimlaneId,
        swimlaneId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectIdToSync)) onChangeProject(projectIdToSync);
    }, [
        onChangeProject,
        projectIdToSync
    ]);
    const projectIdForIssueType = isIPBoard ? projectId : defaultProjectId;
    const getIssueTypesForIssueCreationFn = (0, $67sX6.useBoardSelector)((0, $gXFr2.getIssueTypesForIssueCreation));
    const issueTypes = (0, $67sX6.useBoardSelector)(()=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectIdForIssueType) ? getIssueTypesForIssueCreationFn(projectIdForIssueType) : $aed62d78335d31c0$var$EMPTY_ARRAY); // when the issue type filter changed, for IP board, will verify if the lastFilteredIssueTypeId is
    // the valid issue type of the project.
    (0, $5uXOq.useEffect)(()=>{
        if (isIPBoard) {
            const isValidIssueType = (issueType)=>issueTypes.filter((_issueType)=>Number(_issueType.id) === issueType).length > 0;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(lastFilteredIssueTypeId) && isValidIssueType(lastFilteredIssueTypeId)) onChangeCardType(lastFilteredIssueTypeId);
        } else onChangeCardType(lastFilteredIssueTypeId || null);
    }, [
        lastFilteredIssueTypeId,
        onChangeCardType,
        issueTypes,
        isIPBoard
    ]); // We need to check the local storage view mode value when navigating back from backlog where view mode is always set to sidebar
    (0, $aanra.useSetViewModeFromLocalStorage)();
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aed62d78335d31c0$export$d61fab72474d20f0, {
        innerRef: sampleProjectDataNudgeRef ?? ref,
        isFlexible: isFlexible,
        isSwimlaneMode: Boolean(swimlaneId),
        shouldShowSampleProjectDataNudge: shouldShowSampleProjectDataNudge
    }, columns.map((column, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DV2S.default), {
            useVirtualisation: !$aed62d78335d31c0$var$shouldDisableVirtualisation,
            key: column.id,
            columnIndex: index,
            column: column,
            swimlaneId: swimlaneId,
            isLastSwimlane: isLastSwimlane,
            isFirstSwimlane: isFirstSwimlane,
            offsetTop: offsetTop,
            isUnscheduledWorkColumnPanel: isUnscheduledWorkColumn
        })), shouldShowSampleProjectDataNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iBOe.SampleProjectDataNudgeWrapper), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aed62d78335d31c0$export$d61fab72474d20f0, {
        innerRef: sampleProjectDataNudgeRef ?? ref,
        isFlexible: isFlexible,
        isSwimlaneMode: Boolean(swimlaneId),
        shouldShowSampleProjectDataNudge: shouldShowSampleProjectDataNudge
    }, columns.map((column, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DV2S.default), {
            useVirtualisation: false,
            key: column.id,
            columnIndex: index,
            column: column,
            swimlaneId: swimlaneId,
            isLastSwimlane: isLastSwimlane,
            isFirstSwimlane: isFirstSwimlane,
            offsetTop: offsetTop,
            isUnscheduledWorkColumnPanel: isUnscheduledWorkColumn
        })), shouldShowSampleProjectDataNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iBOe.SampleProjectDataNudgeWrapper), null));
};
var $aed62d78335d31c0$export$2e2bcd8739ae039 // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
 = /*#__PURE__*/ (0, $5uXOq.memo)($aed62d78335d31c0$var$ColumnsContainer);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aed62d78335d31c0$var$BoardContainerControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-12fexja-0"
})`display:${(props)=>props.isFlexible ? 'grid' : 'flex'};grid-template-columns:${({ isFlexible: isFlexible })=>{
    if (!isFlexible) return 'initial';
    return `repeat(auto-fit,minmax(${(0, $3hUhs.sharedStyles).columnMinWidth}px,1fr))`;
}};grid-auto-flow:column;flex:1 1 auto;${({ isFlexible: isFlexible, isSwimlaneMode: isSwimlaneMode })=>isFlexible && !isSwimlaneMode && 'min-height: calc(var(--board-scroll-element-height) * 1px - 8px)'};width:${(shouldShowSampleProjectDataNudge)=>shouldShowSampleProjectDataNudge ? 'max-content' : undefined};`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $aed62d78335d31c0$var$BoardContainerExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexible: isFlexible, isSwimlaneMode: isSwimlaneMode, shouldShowSampleProjectDataNudge: shouldShowSampleProjectDataNudge, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_wij21bp4 _16jlkb7n _1o9zkb7n _i0dl1wug",
            __cmplp.isFlexible ? "_1e0c11p5" : "_1e0c1txw",
            !__cmplp.isFlexible ? "_yv0eglyw" : "_yv0e16td",
            __cmplp.isFlexible && !__cmplp.isSwimlaneMode && "_1tkei63v",
            __cmplp.shouldShowSampleProjectDataNudge && "_1bsb1ris",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $aed62d78335d31c0$export$d61fab72474d20f0 = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $aed62d78335d31c0$var$BoardContainerExperiment, $aed62d78335d31c0$var$BoardContainerControl);

});
parcelRegister("fG4NG", function(module, exports) {

$parcel$export(module.exports, "usePersonalizedSampleData", () => $6e8b9fa0b9fa34e4$export$137ac62e7360b6f6);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");


var $9yQlD = parcelRequire("9yQlD");

var $4pxa7 = parcelRequire("4pxa7");


var $9USr3 = parcelRequire("9USr3");
const $6e8b9fa0b9fa34e4$export$137ac62e7360b6f6 = ()=>{
    const isModalClosed = (0, $4pxa7.useKeepIccOpenState)();
    const { ref: sampleProjectDataNudgeRef } = (0, $9USr3.useRegisterNudgeTarget)((0, $dbbf68c32d8c4308$export$9749a972a54ad7ba), (0, $4R6GH.fg)('jfind-personalized-sample-data-kill-switch'));
    const result = (0, $5uXOq.useMemo)(()=>{
        if ((0, $4R6GH.fg)('jfind-personalized-sample-data-kill-switch') === false || isModalClosed === false) return {
            sampleProjectDataNudgeRef: sampleProjectDataNudgeRef,
            shouldShowSampleProjectDataNudge: false
        };
        const shouldShowSampleProjectDataNudge = (0, $9yQlD.sessionStorageProvider).get((0, $6784cbc7d62e5d7c$export$891ca65264b256bb));
        return {
            sampleProjectDataNudgeRef: sampleProjectDataNudgeRef,
            shouldShowSampleProjectDataNudge: shouldShowSampleProjectDataNudge
        };
    }, [
        isModalClosed,
        sampleProjectDataNudgeRef
    ]);
    return result;
};

});
parcelRegister("9yQlD", function(module, exports) {

$parcel$export(module.exports, "sessionStorage", () => $816fbeb16311dd64$export$f119d83aa936d634);
$parcel$export(module.exports, "sessionStorageProvider", () => $816fbeb16311dd64$export$5a24cb3021127ff7);
$parcel$export(module.exports, "localStorage", () => $816fbeb16311dd64$export$c2ed3351cac403d1);

var $bSSG7 = parcelRequire("bSSG7");

var $eNf8a = parcelRequire("eNf8a");




const $816fbeb16311dd64$export$f119d83aa936d634 = (0, $eNf8a.createSessionExpirableStorageProvider)('onboarding-core');
const $816fbeb16311dd64$export$5a24cb3021127ff7 = (0, $eNf8a.createSessionExpirableStorageProvider)('onboarding-core');
const $816fbeb16311dd64$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalExpirableStorageProvider)('onboarding-core');

});

parcelRegister("4pxa7", function(module, exports) {

$parcel$export(module.exports, "useKeepIccOpenState", () => $e01b50e33333395d$export$991bb5f828c64eee);
$parcel$export(module.exports, "useKeepIccOpenActions", () => $e01b50e33333395d$export$bbdeb5b20a0dc1c1);
$parcel$export(module.exports, "useTriggerEventState", () => $e01b50e33333395d$export$438ab5dbdf55872);


var $9yQlD = parcelRequire("9yQlD");

var $7JoAD = parcelRequire("7JoAD");

var $g7fKq = parcelRequire("g7fKq");
const $e01b50e33333395d$var$isModalVisible = (key)=>(0, $9yQlD.sessionStorage).get(key) !== undefined;
// If either modal is visible, then don't open the ICC
const $e01b50e33333395d$var$setInitialState = ()=>!($e01b50e33333395d$var$isModalVisible((0, $6784cbc7d62e5d7c$export$4e1360a3e7785935)) || $e01b50e33333395d$var$isModalVisible((0, $6784cbc7d62e5d7c$export$e3884212029f7bef)));
const $e01b50e33333395d$export$d4c72bab9d6cc13a = {
    keepIccOpen: $e01b50e33333395d$var$setInitialState(),
    hasCreatedIssueICC: true,
    triggerReason: 'emptyBoard'
};
const $e01b50e33333395d$var$store = (0, $7JoAD.createStore)({
    name: 'jsw-onboarding-keep-icc-open',
    initialState: $e01b50e33333395d$export$d4c72bab9d6cc13a,
    actions: $g7fKq.actions
});
const $e01b50e33333395d$export$991bb5f828c64eee = (0, $7JoAD.createStateHook)($e01b50e33333395d$var$store, {
    selector: (state)=>state.keepIccOpen
});
const $e01b50e33333395d$export$bbdeb5b20a0dc1c1 = (0, $7JoAD.createActionsHook)($e01b50e33333395d$var$store);
const $e01b50e33333395d$export$438ab5dbdf55872 = (0, $7JoAD.createStateHook)($e01b50e33333395d$var$store, {
    selector: (state)=>({
            hasCreatedIssueICC: state.hasCreatedIssueICC,
            triggerReason: state.triggerReason
        })
});

});
parcelRegister("g7fKq", function(module, exports) {

$parcel$export(module.exports, "actions", () => $22684fd1187cb60b$export$e324594224ef24da);

var $5hyrq = parcelRequire("5hyrq");

var $ePMUR = parcelRequire("ePMUR");

var $cr2Jb = parcelRequire("cr2Jb");

var $lWd86 = parcelRequire("lWd86");
const $22684fd1187cb60b$export$e324594224ef24da = {
    toggleKeepIccOpen: $lWd86.toggleKeepIccOpen,
    setHasCreatedIssueICC: $ePMUR.setHasCreatedIssueICC,
    setTriggerReason: $cr2Jb.setTriggerReason,
    closeICC: $5hyrq.closeICC
};

});
parcelRegister("5hyrq", function(module, exports) {

$parcel$export(module.exports, "closeICC", () => $a1f8bda87b6ffc9a$export$e6c10955f11a7b51);
const $a1f8bda87b6ffc9a$export$e6c10955f11a7b51 = ()=>({ setState: setState })=>{
        setState({
            keepIccOpen: false
        });
    };

});

parcelRegister("ePMUR", function(module, exports) {

$parcel$export(module.exports, "setHasCreatedIssueICC", () => $a1b9adc891c00dd5$export$4bb464fc9800c324);
const $a1b9adc891c00dd5$export$4bb464fc9800c324 = (hasCreatedIssueICC)=>({ getState: getState, setState: setState })=>{
        const { hasCreatedIssueICC: currentHasCreatedIssueICC } = getState();
        if (hasCreatedIssueICC === currentHasCreatedIssueICC) return;
        setState({
            hasCreatedIssueICC: hasCreatedIssueICC
        });
    };

});

parcelRegister("cr2Jb", function(module, exports) {

$parcel$export(module.exports, "setTriggerReason", () => $b662b9cea36b43af$export$8b8ceaca9e30bc48);
const $b662b9cea36b43af$export$8b8ceaca9e30bc48 = (triggerReason)=>({ getState: getState, setState: setState })=>{
        const { triggerReason: currentTriggerReason } = getState();
        if (triggerReason === currentTriggerReason) return;
        setState({
            triggerReason: triggerReason
        });
    };

});

parcelRegister("lWd86", function(module, exports) {

$parcel$export(module.exports, "toggleKeepIccOpen", () => $071bcdbf7bb018d8$export$d09b33ff198a059);
const $071bcdbf7bb018d8$export$d09b33ff198a059 = ()=>({ getState: getState, setState: setState })=>{
        const { keepIccOpen: iccOpenState } = getState();
        setState({
            keepIccOpen: !iccOpenState
        });
    };

});




parcelRegister("8iBOe", function(module, exports) {

$parcel$export(module.exports, "SampleProjectDataNudgeWrapper", () => $2b14675f156a1014$export$63e89a2bc57668b5);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");


var $1RLyf = parcelRequire("1RLyf");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");
const $2b14675f156a1014$export$63e89a2bc57668b5 = ()=>{
    const issueKey = (0, $67sX6.useBoardSelector)((0, $67Z81.getFirstNonEpicIssueInFirstColumn));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$d99767a37baddfc),
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$9749a972a54ad7ba)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1RLyf.SampleProjectDataNudge), {
        issueKey: issueKey
    }));
};

});
parcelRegister("1RLyf", function(module, exports) {

$parcel$export(module.exports, "SampleProjectDataNudge", () => $bd4b1eeb51b614f4$export$b3622ec7236b1f80);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");


var $9yQlD = parcelRequire("9yQlD");

var $8Bc5A = parcelRequire("8Bc5A");

var $cZ5k3 = parcelRequire("cZ5k3");

var $dAfqg = parcelRequire("dAfqg");

var $4pxa7 = parcelRequire("4pxa7");

var $dIdda = parcelRequire("dIdda");


var $ajlSd = parcelRequire("ajlSd");

var $iGBUU = parcelRequire("iGBUU");

var $hkYqK = parcelRequire("hkYqK");

var $gMHXs = parcelRequire("gMHXs");
const $bd4b1eeb51b614f4$var$position = (0, $cZ5k3.POSITION_RIGHT_START);
const $bd4b1eeb51b614f4$var$nudgeSpotlightProps = {
    width: (0, $8Bc5A.DEFAULT_NUDGE_WIDTH),
    position: $bd4b1eeb51b614f4$var$position
};
const $bd4b1eeb51b614f4$export$b3622ec7236b1f80 = ({ issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isHidden, setIsHidden] = (0, $5uXOq.useState)(false);
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const { push: push } = (0, $dIdda.useRouterActions)();
    const isModalClosed = (0, $4pxa7.useKeepIccOpenState)();
    const hide = (0, $5uXOq.useCallback)(()=>{
        (0, $9yQlD.sessionStorageProvider).remove((0, $6784cbc7d62e5d7c$export$891ca65264b256bb));
        setIsHidden(true);
    }, [
        setIsHidden
    ]);
    const openTicket = (0, $5uXOq.useCallback)(()=>{
        hide();
        if (window) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const redirectUrl = new URL(window.location.href);
            if (issueKey) redirectUrl.searchParams.set('selectedIssue', issueKey);
            else redirectUrl.searchParams.set('selectedIssue', `${data?.projectKey}-1`);
            push(redirectUrl.href);
        }
    }, [
        data,
        hide,
        push,
        issueKey
    ]);
    const onboardingSpotlightProps = {
        actions: [
            {
                content: formatMessage((0, $gMHXs.default).spotlightDismissActionNonFinal),
                onClick: hide,
                appearance: 'subtle'
            },
            {
                content: formatMessage((0, $gMHXs.default).spotlightCtaActionNonFinal),
                onClick: openTicket,
                appearance: 'primary'
            }
        ],
        headingMessage: formatMessage((0, $gMHXs.default).spotlightHeadingNonFinal),
        contentMessage: formatMessage((0, $gMHXs.default).spotlightContentNonFinal),
        image: (0, $hkYqK.ViewTooltipSvg)()
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iGBUU.PortalledNudge), {
        nudgeIdForAnalytics: (0, $dbbf68c32d8c4308$export$9749a972a54ad7ba),
        nudgeTargetId: (0, $dbbf68c32d8c4308$export$9749a972a54ad7ba),
        ...$bd4b1eeb51b614f4$var$nudgeSpotlightProps,
        hidden: isHidden,
        setHidden: hide,
        onOutsideClick: ()=>{
            if (!isModalClosed) return;
            hide();
        },
        spotlightCard: (0, $ajlSd.createOnboardingSpotlight)({
            ...onboardingSpotlightProps
        })
    });
};

});
parcelRegister("cZ5k3", function(module, exports) {

$parcel$export(module.exports, "POSITION_RIGHT", () => $450da094f06efa02$export$4ed9c122bcc20157);
$parcel$export(module.exports, "POSITION_BOTTOM", () => $450da094f06efa02$export$cec9b06edc71d96c);
$parcel$export(module.exports, "POSITION_TOP_START", () => $450da094f06efa02$export$3409cd2decbff80c);
$parcel$export(module.exports, "POSITION_TOP_END", () => $450da094f06efa02$export$1a430e6e8a1cbf17);
$parcel$export(module.exports, "POSITION_BOTTOM_START", () => $450da094f06efa02$export$663d1c5ad4215eb0);
$parcel$export(module.exports, "POSITION_BOTTOM_END", () => $450da094f06efa02$export$9c417155181792ae);
$parcel$export(module.exports, "POSITION_RIGHT_START", () => $450da094f06efa02$export$84a134a88de18270);
$parcel$export(module.exports, "POSITION_LEFT_END", () => $450da094f06efa02$export$9ed28c4aa79d6398);
$parcel$export(module.exports, "DEFAULT_SCROLL_TO_NUDGE", () => $450da094f06efa02$export$27ce92ea48cacd56);
const $450da094f06efa02$export$b0758137ee643e7 = 'left';
const $450da094f06efa02$export$4ed9c122bcc20157 = 'right';
const $450da094f06efa02$export$cec9b06edc71d96c = 'bottom';
const $450da094f06efa02$export$4fb34bdcd97adf85 = 'top';
const $450da094f06efa02$export$3409cd2decbff80c = 'top-start';
const $450da094f06efa02$export$1a430e6e8a1cbf17 = 'top-end';
const $450da094f06efa02$export$663d1c5ad4215eb0 = 'bottom-start';
const $450da094f06efa02$export$9c417155181792ae = 'bottom-end';
const $450da094f06efa02$export$84a134a88de18270 = 'right-start';
const $450da094f06efa02$export$b71f6a080452c5e8 = 'right-end';
const $450da094f06efa02$export$b67243f02ceac890 = 'left-start';
const $450da094f06efa02$export$9ed28c4aa79d6398 = 'left-end';
const $450da094f06efa02$export$27ce92ea48cacd56 = {
    scrollIntoViewOptions: {
        inline: 'end',
        behavior: 'smooth'
    }
};

});

parcelRegister("ajlSd", function(module, exports) {

$parcel$export(module.exports, "createOnboardingSpotlight", () => $208acef035d7cdaa$export$3de3bbc64fe39fe6);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $ao4Ml = parcelRequire("ao4Ml");

var $9yOBd = parcelRequire("9yOBd");
var $fVnbM = parcelRequire("fVnbM");

var $5ujeO = parcelRequire("5ujeO");


var $8Bc5A = parcelRequire("8Bc5A");
const $208acef035d7cdaa$var$NudgeHeading = ({ formattedMessage: formattedMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$Title, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$CustomHeading, null, formattedMessage));
const $208acef035d7cdaa$var$NudgeAction = ({ appearance: appearance, content: content, onClick: onClick })=>{
    // if appearance is primary, override styles with custom button
    // note CustomThemeButton is advised against and we need a better solution
    // (potentially even going with the blue button). Leaving this code for the experiment
    if (appearance === 'primary') {
        const customTheme = (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: `${"var(--ds-icon-discovery, #8270DB)"}`,
                    minWidth: '84px',
                    margin: `0 ${"var(--ds-space-050, 4px)"}`,
                    color: `${`var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`}`
                },
                spinnerStyles: spinnerStyles
            };
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
            appearance: appearance,
            onClick: onClick,
            theme: customTheme
        }, content);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: appearance,
        onClick: onClick
    }, content);
};
const $208acef035d7cdaa$var$NudgeActions = ({ actions: actions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$Footer, null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$NudgeAction, {
            key: index,
            ...action
        })));
const $208acef035d7cdaa$export$3de3bbc64fe39fe6 = ({ actions: actions, contentMessage: contentMessage, headingMessage: headingMessage, image: image, width: width = (0, $8Bc5A.DEFAULT_NUDGE_WIDTH), CustomWrapper: CustomWrapper, actionsBeforeElement: actionsBeforeElement })=>{
    const Wrapper = CustomWrapper || $208acef035d7cdaa$var$SpotlightCardWrapper;
    return /*#__PURE__*/ (0, $5uXOq.forwardRef)((_, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ujeO.default), {
            image: image,
            heading: headingMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$NudgeHeading, {
                formattedMessage: headingMessage
            }) : null,
            width: width,
            actionsBeforeElement: actionsBeforeElement
        }, contentMessage, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$NudgeActions, {
            actions: actions
        }))));
};
const $208acef035d7cdaa$export$cbbb2ee263b2a558 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ focusLock: focusLock, ...rest }, ref)=>{
    const Spotlight = $208acef035d7cdaa$export$3de3bbc64fe39fe6({
        ...rest
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), {
        disabled: !focusLock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Spotlight, {
        ref: ref
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $208acef035d7cdaa$var$SpotlightCardWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_fkwn1bhr _tml110s3 _19yu10s3",
            __cmplp.className
        ])
    });
});
const $208acef035d7cdaa$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $208acef035d7cdaa$var$CustomHeading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81bk4 _syaz10s3",
            __cmplp.className
        ])
    });
});
const $208acef035d7cdaa$var$Footer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o _ca0qu2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iGBUU", function(module, exports) {

$parcel$export(module.exports, "PortalledNudge", () => $12474d131146ee43$export$74f8d45d75dfda4f);

var $5uXOq = parcelRequire("5uXOq");

var $k5uoT = parcelRequire("k5uoT");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9USr3 = parcelRequire("9USr3");
const $12474d131146ee43$export$74f8d45d75dfda4f = ({ onRender: onRender, nudgeTargetId: nudgeTargetId, nudgeIdForAnalytics: nudgeIdForAnalytics, analyticsAttributes: analyticsAttributes = {}, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onRenderNudge = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({});
        (0, $8zOmE.fireUIAnalytics)(event, 'nudgeSpotlightCard viewed', nudgeIdForAnalytics, analyticsAttributes);
        if (onRender) onRender();
    }, [
        nudgeIdForAnalytics,
        analyticsAttributes,
        createAnalyticsEvent,
        onRender
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9USr3.PortalledNudge), {
        onRender: onRenderNudge,
        nudgeTargetId: nudgeTargetId,
        zIndex: (0, $k5uoT.layers).dialog(),
        ...props
    });
};

});

parcelRegister("hkYqK", function(module, exports) {

$parcel$export(module.exports, "ViewTooltipSvg", () => $1ad364a9db6c1b55$export$d4e6a9d2e665cf2);

var $5uXOq = parcelRequire("5uXOq");
const $1ad364a9db6c1b55$export$d4e6a9d2e665cf2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "320",
        height: "161",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0 0h320v161H0V0Z",
        fill: "#F7F8F9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#b)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M320 0H0v230.761h320V0Z",
        fill: "#C97CF4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
        id: "c",
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "320",
        height: "231"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M320 0H0v230.761h320V0Z",
        fill: "#fff"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        mask: "url(#c)",
        strokeWidth: "1.803",
        strokeMiterlimit: "10"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m36.27 60.944-4.365 98.603 335.128 166.326 4.947-111.748L36.27 60.945ZM76.568-1.634c.658-3.682 1.003-7.599 1.003-11.743 0-4.203-.347-8.171-1.017-11.9-3.982-22.198-19.398-35.884-41.018-39.408-3.69-.602-7.559-.91-11.583-.913-4.199 0-8.226.332-12.061.972-21.638 3.605-37.032 17.248-41.034 39.319-.677 3.73-1.028 7.698-1.03 11.9 0 4.143.342 8.06 1.003 11.744 3.961 22.046 19.362 35.72 41.034 39.342 3.835.64 7.86.976 12.06.976 4.026 0 7.895-.307 11.584-.904C57.167 34.236 72.604 20.534 76.57-1.634h-.002Z",
        stroke: "#D8A0F7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7.944 52.257c-27.14-4.284-59.155-14.132-83.906-30.504l-10.044 63.635c27.484 17.287 61.52 26.493 89.596 30.923 98.28 15.511 168.622-20.036 195.245-96.273L123.597 8.164C106.003 44.047 68.881 61.873 7.944 52.254v.003ZM267.923-35.671c-27.139-4.284-59.155-14.132-83.905-30.504L173.974-2.537c27.484 17.286 61.519 26.492 89.596 30.922C361.85 43.896 432.192 8.35 458.815-67.887l-75.239-11.874c-17.593 35.883-54.715 53.708-115.653 44.09Z",
        stroke: "#D8A0F7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M219.806-18.698v141.359h61.273V-18.697h-61.273Z",
        stroke: "#D8A0F7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M219.804 18.28v-36.975h61.273v49.44",
        stroke: "#BF63F3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m36.645 60.126-1.215-.554-2.612 58.999c.602.034 1.201.066 1.8.097l2.495-56.347 88.584 40.419c.665-.317 1.327-.637 1.985-.964.039-.018.077-.039.115-.059l-91.153-41.59Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M281.979 29.819c-.6-.057-1.202-.118-1.803-.18v1.813c.601.061 1.203.118 1.803.174v-1.81.003ZM220.705 17.505c-.599-.189-1.201-.383-1.803-.577v1.896c.602.193 1.204.383 1.803.572V17.505Z",
        fill: "#D8A0F7"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M33 23.889h222.867v153.1H33z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F7F8F9",
        d: "M46.507 37.396h50.809v18.476H46.507z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M100.693 37.396h68.13v18.476h-68.13z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M172.2 43.257h20.261v6.754H172.2zM195.838 43.257h20.261v6.754h-20.261zM219.475 43.257h20.261v6.754h-20.261zM46.507 60.937h60.782v102.545H46.507z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M49.884 64.314H85.68v4.619H49.884v-4.62Z",
        fill: "#D9D9D9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M49.884 72.31h54.028v27.013H49.884z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M54.949 77.375h47.345v2.309H54.949z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#82B536",
        d: "M54.949 89.193h6.754v6.754h-6.754z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M49.884 102.701h54.028v27.014H49.884z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M54.949 107.766h47.345v2.309H54.949z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#82B536",
        d: "M54.949 119.584h6.754v6.754h-6.754z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M49.884 133.091h54.028v27.014H49.884z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M54.949 138.157h47.345v2.309H54.949z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#FFA900",
        d: "M54.949 149.975h6.754v6.754h-6.754z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M114.043 60.937h60.782v102.545h-60.782z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M117.42 64.314h35.797v4.619H117.42v-4.62Z",
        fill: "#D9D9D9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M117.42 72.31h54.028v27.013H117.42z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M122.485 77.375h47.345v2.309h-47.345z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#0C66E4",
        d: "M122.485 89.193h6.754v6.754h-6.754z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M117.42 102.701h54.028v27.014H117.42z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M122.485 107.766h47.345v2.309h-47.345z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#0C66E4",
        d: "M122.485 119.584h6.754v6.754h-6.754z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M117.42 133.091h54.028v27.014H117.42z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M122.485 138.157h47.345v2.309h-47.345z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#82B536",
        d: "M122.485 149.975h6.754v6.754h-6.754z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M181.578 60.937h60.782v102.545h-60.782z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M184.955 64.314h35.797v4.619h-35.797v-4.62Z",
        fill: "#D9D9D9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M184.955 72.31h54.028v27.013h-54.028z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M190.02 77.375h47.345v2.309H190.02z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#82B536",
        d: "M190.02 89.193h6.754v6.754h-6.754z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M204.723 108.09h16.884v16.884h-16.884z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M213.798 115.899v-5.276h-1.267v5.276h-5.276v1.266h5.276v5.276h1.267v-5.276h5.276v-1.266h-5.276Z",
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M184.955 133.091h54.028v27.014h-54.028z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M190.02 138.157h47.345v2.309H190.02z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#0C66E4",
        d: "M190.02 149.975h6.754v6.754h-6.754z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M221.76 126.193c-.724-1.475-1.281-3.14-2.004-4.776l.504.277c.339.178.669.376.999.582l.261.161.275.135.561.266c.192.083.379.177.578.237.202.059.407.108.615.152.006-.113.079-.185.115-.118l-.047.131c.293-.008.539.048.78.074.238.027.458.07.68.109.22.034.439.074.666.056.229-.023.468-.082.724-.198 0 0-.119.178-.121.183 1.753-.003 3.813-.361 5.715-1.203a13.694 13.694 0 0 0 4.819-3.515h-.029l-.009-.021c-.084.036-.224.132-.391.243-.174.106-.376.233-.564.353l-.496.328c-.133.085-.221.13-.221.13.139-.305.295-.589.514-.812.212-.23.466-.419.712-.625.253-.202.528-.391.783-.597a5.46 5.46 0 0 0 .674-.696l.135.116a5.59 5.59 0 0 0-.69 1.06c.757-.668 1.795-1.829 2.502-3.192.729-1.348 1.158-2.832 1.242-3.813-.145.016-.011.675-.477.703.121-.475.202-.957.266-1.412.285.053.143.302.185.362.055-.093.154-.426.279-.94.07-.255.088-.563.134-.903.018-.172.042-.351.061-.54.011-.189.007-.385.01-.592.001-.408.015-.845-.056-1.296-.054-.45-.096-.922-.227-1.389l-.174-.708c-.056-.239-.162-.462-.242-.691-.089-.23-.173-.458-.26-.685-.094-.223-.216-.435-.326-.647-.882-1.702-2.09-3.006-2.918-3.574-.817-.601-1.139-.622-.673.259l-.171.043c.158.18.312.35.462.521.149.168.291.338.404.529.23.38.476.758.634 1.242.096.099.08.13.203.042.04.016.11.044.15-.006.287-.219.346.126.432.233-.263.119-.293.342-.193.608.094.273.272.617.514.955.061.086.121.171.187.259.054.088.109.18.159.27.112.179.217.349.312.506.208.307.324.575.341.683-.249.113-.204.316-.115.529.09.213.226.448.123.594-.023-.015-.155-.104-.18-.114-.076.074-.044.344.038.696.034.179.108.374.135.584.036.212.073.426.107.634.088.415.088.797.067 1-.024.207-.092.232-.237-.044-.101.268-.152.549-.262.834-.102.285-.197.58-.283.884-.226.596-.431 1.234-.718 1.873-.545 1.286-1.269 2.627-2.204 3.848-.932 1.218-2.074 2.308-3.302 3.089-.314.181-.612.385-.93.527-.319.143-.629.286-.938.404-.318.096-.627.182-.925.258-.299.072-.606.086-.886.114l.051.053c-.041-.008-.138.054-.183-.014-.177.186-.558.338-.89.478a6.763 6.763 0 0 1-.437.163l-.187.046-.624.181-.317.088-.322.057-.361-.036c-.222-.018-.532-.031-.861-.09a7.596 7.596 0 0 0-.513-.055c-.175-.013-.349-.018-.514-.047-.334-.04-.65-.047-.903.007-.278-.073-.532-.217-.797-.319-.261-.12-.534-.202-.777-.359-.348-.199-1.667-.799-2.578-1.262.931-.672 3.646-.932 4.14-1.744l1.35-.178c.791-.214 1.007-1.978-.23-1.601-2.156.727-5.142.706-6.949 2.574l.022.003s-.464.306-.47.234c-.199.241-.353.638-.353.638-.113 1.06.982 2.654 1.676 3.02-.248.038 2.829 5.395 3.238 3.591l.001.003Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "m225.817 78.054 63.459-6.2 3.039 31.106-63.46 6.199z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: "#F0F1F2",
        strokeWidth: "1.255",
        d: "m225.817 78.054 63.459-6.2 3.039 31.106-63.46 6.199z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "m231.791 82.964 39.182-3.812.186 1.91-39.182 3.813z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#FFA900",
        d: "m233.173 97.119 8.089-.79.79 8.088-8.089.79z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M0 0h320v161H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M0 0h320v230.763H0z"
    }))));

});

parcelRegister("gMHXs", function(module, exports) {

$parcel$export(module.exports, "default", () => $78ef2a6e39111a7c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $78ef2a6e39111a7c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    spotlightHeadingNonFinal: {
        "id": "software-onboarding-nudges--next.sample-project-data.spotlight-heading-non-final",
        "defaultMessage": "Let\u2019s start with your tasks"
    },
    spotlightContentNonFinal: {
        "id": "software-onboarding-nudges--next.sample-project-data.spotlight-content-non-final",
        "defaultMessage": "We\u2019ve created some starter tasks for you. Make them your own, or create a blank task to start tracking your work in Jira."
    },
    spotlightDismissActionNonFinal: {
        "id": "software-onboarding-nudges--next.sample-project-data.spotlight-dismiss-action-non-final",
        "defaultMessage": "Dismiss"
    },
    spotlightCtaActionNonFinal: {
        "id": "software-onboarding-nudges--next.sample-project-data.spotlight-cta-action-non-final",
        "defaultMessage": "View task"
    }
});

});



parcelRegister("1DV2S", function(module, exports) {

$parcel$export(module.exports, "default", () => $34bb2b89537ef497$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $bC2fB = parcelRequire("bC2fB");



var $1vXOx = parcelRequire("1vXOx");

var $k8auG = parcelRequire("k8auG");

var $gcoP6 = parcelRequire("gcoP6");

var $9UXXB = parcelRequire("9UXXB");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $59p3c = parcelRequire("59p3c");

var $5mTgl = parcelRequire("5mTgl");

var $23uyL = parcelRequire("23uyL");
const $34bb2b89537ef497$export$c31df4bd766f9c35 = ()=>{
    const getIssueEntries = (0, $5mTgl.makeGetIssueEntriesForColumnSelector)();
    return (state, { swimlaneId: swimlaneId, column: column, columnIndex: columnIndex, isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel, isFirstSwimlane: isFirstSwimlane })=>{
        const features = (0, $59p3c.getPlatformFeatures)(state);
        const permissions = (0, $1vXOx.getPermissionsSelector)(state);
        const issueEntries = getIssueEntries(state, {
            swimlaneId: swimlaneId,
            columnId: column.id,
            isUnscheduledWorkColumn: isUnscheduledWorkColumnPanel
        });
        const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        const isJSWBoard = (0, $67Z81.getIsJSWBoard)(state);
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        const isDropCardInstantlyBounceBackEnabled = isCMPBoard && (0, $45cXl.hasSwimlanes)(state);
        // remove when cleaning up board_column_issue_links_optimisation
        const issuesWithIssueLinksIds = isIncrementPlanningBoard && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') ? (0, $5mTgl.getIssuesWithIssueLinksInBoardIds)(state) : undefined;
        const shouldRenderUnassignedCTA = columnIndex === 0 && (!swimlaneId || !!isFirstSwimlane) && !isUnscheduledWorkColumnPanel && !isIncrementPlanningBoard && isJSWBoard && (0, $4R6GH.fg)('jira-collab-unassigned-filter-cta-gate');
        return {
            isBoardEmpty: (0, $k8auG.isBoardEmptySelector)(state),
            isDoneCardsButtonVisible: (0, $5mTgl.getBoardHasFilteredIssues)(state),
            isSprintsEnabled: features[0, $b2dceb3b951c6bc2$export$c298045b43b64630] || false,
            isUserAtLeastMember: (0, $k8auG.isUserAtLeastMemberOfProject)(state),
            canEditBoard: (permissions[0, $e525e6c25695c9df$export$aadc620ce91112df] || false) && !isCMPBoard,
            issueEntries: issueEntries,
            issuesWithIssueLinksIds: (0, $4R6GH.fg)('board_column_issue_links_optimisation') ? undefined : issuesWithIssueLinksIds,
            isCMPKanbanBoard: isCMPBoard && (0, $67Z81.getBoardType)(state) === 'KANBAN',
            isCMPBoard: isCMPBoard,
            isColumnIccEnabled: (0, $9UXXB.isIccEnabledForColumnOrSwimlane)(state, swimlaneId, column.id),
            isDropCardInstantlyBounceBackEnabled: isDropCardInstantlyBounceBackEnabled,
            placeholderType: (0, $gcoP6.makeShowPlaceHolderSelector)(state)(columnIndex),
            shouldRenderUnassignedCTA: shouldRenderUnassignedCTA
        };
    };
};
const $34bb2b89537ef497$var$ColumnConnected = (0, $bC2fB.connect)($34bb2b89537ef497$export$c31df4bd766f9c35, {})((0, $23uyL.default));
var $34bb2b89537ef497$export$2e2bcd8739ae039 = $34bb2b89537ef497$var$ColumnConnected;

});
const $b2dceb3b951c6bc2$export$c298045b43b64630 = 'IS_SPRINTS_ENABLED';
const $b2dceb3b951c6bc2$export$18bf536c6eb8b5b2 = 'IS_POLLING_ENABLED';
const $b2dceb3b951c6bc2$export$1aba2b155ad227f8 = 'IS_CARD_MEDIA_SWITCH_ENABLED';

parcelRegister("gcoP6", function(module, exports) {

$parcel$export(module.exports, "NO_ACTIVE_SPRINT_PLACEHOLDER", () => $377259b9e292890c$export$4a8150e8503dbe2d);
$parcel$export(module.exports, "NO_PLACEHOLDER", () => $377259b9e292890c$export$fcfc126393e31487);
$parcel$export(module.exports, "makeShowPlaceHolderSelector", () => $377259b9e292890c$export$6b890dc22b669e50);

var $dGvGJ = parcelRequire("dGvGJ");

var $gJBT6 = parcelRequire("gJBT6");

var $k8auG = parcelRequire("k8auG");

var $9UXXB = parcelRequire("9UXXB");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");
const $377259b9e292890c$export$4a8150e8503dbe2d = 'NO_ACTIVE_SPRINT';
const $377259b9e292890c$export$770895c648f5e479 = 'CMP_EMPTY_KANBAN';
const $377259b9e292890c$export$fcfc126393e31487 = 'NONE';
const $377259b9e292890c$export$6b890dc22b669e50 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIsCMPBoard),
    (0, $67Z81.getBoardType),
    (0, $k8auG.isBoardEmptySelector),
    (0, $9UXXB.hasInlineCardCreateConfig),
    (0, $ebHh7.hasNoActiveSprintStateSelector)
], (isCMPBoard, boardType, isBoardEmpty, hasInlineCardCreate, hasNoActiveSprint)=>{
    const makeShowPlaceholder = (columnIndex)=>{
        const isCMPKanbanBoard = isCMPBoard && boardType === 'KANBAN';
        const isFirstColumn = columnIndex === 0;
        if (!isFirstColumn) return $377259b9e292890c$export$fcfc126393e31487;
        if (isCMPKanbanBoard) return isBoardEmpty && !hasInlineCardCreate ? $377259b9e292890c$export$770895c648f5e479 : $377259b9e292890c$export$fcfc126393e31487;
        return hasNoActiveSprint ? $377259b9e292890c$export$4a8150e8503dbe2d : $377259b9e292890c$export$fcfc126393e31487;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(makeShowPlaceholder);
});

});

parcelRegister("59p3c", function(module, exports) {

$parcel$export(module.exports, "getPlatformFeatures", () => $bf8d0a87725f714b$export$a1ed8f6fbe38c842);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");


var $ebHh7 = parcelRequire("ebHh7");

var $5mTgl = parcelRequire("5mTgl");
const $bf8d0a87725f714b$export$a1ed8f6fbe38c842 = (0, $dGvGJ.createSelector)([
    (0, $ebHh7.isSprintsEnabled),
    (0, $5mTgl.isCardMediaAvailable)
], (isSprintsFeatureEnabled, isAnyCardMediaAvailable)=>(0, $7uUwQ.freeze)({
        [(0, $b2dceb3b951c6bc2$export$c298045b43b64630)]: isSprintsFeatureEnabled,
        [(0, $b2dceb3b951c6bc2$export$18bf536c6eb8b5b2)]: true,
        [(0, $b2dceb3b951c6bc2$export$1aba2b155ad227f8)]: isAnyCardMediaAvailable
    }));

});

parcelRegister("23uyL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a12eb39f16847da5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $8Rkzz = parcelRequire("8Rkzz");

var $7iJwP = parcelRequire("7iJwP");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $4jAPy = parcelRequire("4jAPy");

var $3eGwD = parcelRequire("3eGwD");


var $67sX6 = parcelRequire("67sX6");

var $gcoP6 = parcelRequire("gcoP6");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");

var $drQJq = parcelRequire("drQJq");

var $g94HQ = parcelRequire("g94HQ");

var $50AZv = parcelRequire("50AZv");

var $5nhUs = parcelRequire("5nhUs");

var $dRpFy = parcelRequire("dRpFy");

var $iTH7p = parcelRequire("iTH7p");

var $lBRY4 = parcelRequire("lBRY4");

var $hXOH1 = parcelRequire("hXOH1");

var $7meEu = parcelRequire("7meEu");

var $2lkEP = parcelRequire("2lkEP");

var $7p3wz = parcelRequire("7p3wz");
const $a12eb39f16847da5$var$EMPTY_ARRAY = [];
const $a12eb39f16847da5$var$Column = ({ column: column, columnIndex: columnIndex, swimlaneId: swimlaneId, isLastSwimlane: isLastSwimlane, isSprintsEnabled: isSprintsEnabled, isBoardEmpty: isBoardEmpty, isDoneCardsButtonVisible: isDoneCardsButtonVisible, isUserAtLeastMember: isUserAtLeastMember, canEditBoard: canEditBoard, useVirtualisation: useVirtualisation, issueEntries: issueEntries = [], issuesWithIssueLinksIds: issuesWithIssueLinksIdsOld = [], dropZoneType: dropZoneType, offsetTop: offsetTop, isCMPKanbanBoard: isCMPKanbanBoard, isCMPBoard: isCMPBoard, isColumnIccEnabled: isColumnIccEnabled, placeholderType: placeholderType, isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel, shouldRenderUnassignedCTA: shouldRenderUnassignedCTA })=>{
    // We use the ref of the header to make sure ICC doesn't render if it's under the header.
    const headerRef = (0, $5uXOq.useRef)(null);
    const { id: id, isInitial: isInitial, isDone: isDone, limitJql: limitJql, name: name } = column;
    const [menusShown, setMenusShowns] = (0, $5uXOq.useState)({});
    const setMenuVisibility = (columnId)=>(visible)=>{
            setMenusShowns({
                [columnId]: visible
            });
        };
    const MAX_CARDS_TO_SHOW_ICC_NUDGE = 3;
    const isIncrementPlanningBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
    const issuesWithIssueLinksIds = (0, $4R6GH.fg)('board_column_issue_links_optimisation') ? (0, $67sX6.useBoardSelector)((state)=>isIncrementPlanningBoard && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') ? (0, $5mTgl.getIssuesWithIssueLinksInBoardIds)(state) : $a12eb39f16847da5$var$EMPTY_ARRAY) : issuesWithIssueLinksIdsOld;
    const openInitialColumnIcc = isInitial && isBoardEmpty && isColumnIccEnabled;
    const showDoneCardsButtonCMP = isCMPKanbanBoard && isLastSwimlane && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(limitJql);
    const showDoneCardsButtonTMP = isDone && !isSprintsEnabled && isLastSwimlane && isDoneCardsButtonVisible;
    const showDoneCardsButton = isCMPBoard ? showDoneCardsButtonCMP : showDoneCardsButtonTMP;
    const canShowIccNudgeInBoard = isInitial && issueEntries.length > MAX_CARDS_TO_SHOW_ICC_NUDGE;
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const renderCardFunction = (0, $5uXOq.useCallback)((issueEntry, index, isScrolling, onResizeCallback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), cardOffsetTop)=>{
        const userCanViewMenu = canEditBoard || isUserAtLeastMember;
        if ((0, $3eGwD.isIssueEntryGroup)(issueEntry)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g94HQ.default), {
            key: issueEntry.issueIds.toString(),
            index: index,
            issueIdGroup: issueEntry,
            canShowIccNudge: false,
            columnId: id,
            isColumnIccEnabled: isColumnIccEnabled,
            swimlaneId: swimlaneId,
            isLastSwimlane: isLastSwimlane,
            userCanViewMenu: userCanViewMenu,
            onIssueChange: onResizeCallback,
            isScrolling: isScrolling,
            headerRef: headerRef,
            offsetTop: cardOffsetTop
        });
        const isIssueIdValid = (0, $3eGwD.getIsIssueIdValid)(issueEntry.issueId) || !(0, $4R6GH.fg)('avoid_invalid_issueid_in_board_context_menu');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $drQJq.default), {
            key: issueEntry.issueId,
            id: issueEntry.issueId,
            canShowIccNudge: canShowIccNudgeInBoard,
            columnId: id,
            index: index,
            isColumnIccEnabled: isColumnIccEnabled,
            swimlaneId: swimlaneId,
            isLastSwimlane: isLastSwimlane,
            userCanViewMenu: userCanViewMenu && isIssueIdValid,
            onIssueChange: onResizeCallback,
            isScrolling: isScrolling,
            headerRef: headerRef
        });
    }, [
        canEditBoard,
        id,
        isColumnIccEnabled,
        isLastSwimlane,
        isUserAtLeastMember,
        swimlaneId,
        canShowIccNudgeInBoard
    ]);
    const header = (0, $5uXOq.useMemo)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(swimlaneId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dRpFy.default), {
            id: id,
            isMenuShown: menusShown[id],
            menu: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iTH7p.default), {
                columnId: id,
                onVisibilityChange: setMenuVisibility(id)
            }),
            showShadowOnScroll: true
        });
        if (isIPBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
            id: "program-swimlane-column-header",
            packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
            sendToPrivacyUnsafeSplunk: true,
            teamName: (0, $4jAPy.ERROR_REPORTING_TEAM)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hXOH1.default), {
            swimlaneId: swimlaneId,
            columnId: id,
            count: issueEntries.length,
            isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel,
            ref: headerRef
        }));
        return null;
    }, [
        swimlaneId,
        id,
        menusShown,
        isIPBoard,
        isUnscheduledWorkColumnPanel,
        issueEntries.length
    ]);
    const footer = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7p3wz.default), {
            columnId: id,
            isInitialColumn: isInitial,
            canShowIccNudge: isInitial && issueEntries.length <= MAX_CARDS_TO_SHOW_ICC_NUDGE,
            showDoneCardsButton: showDoneCardsButton,
            isColumnIccEnabled: isColumnIccEnabled,
            isLastSwimlane: isLastSwimlane,
            cardIndex: issueEntries.length,
            openInitialColumnIcc: openInitialColumnIcc,
            swimlaneId: swimlaneId,
            limitJql: limitJql
        }), [
        id,
        isColumnIccEnabled,
        isInitial,
        isLastSwimlane,
        issueEntries.length,
        openInitialColumnIcc,
        showDoneCardsButton,
        swimlaneId,
        limitJql
    ]);
    const virtualListFooter = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, footer, placeholderType === (0, $gcoP6.NO_ACTIVE_SPRINT_PLACEHOLDER) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lBRY4.default), null)), [
        footer,
        placeholderType
    ]);
    const placeHolder = (0, $5uXOq.useMemo)(()=>{
        if (placeholderType === (0, $gcoP6.NO_PLACEHOLDER)) return null;
        return placeholderType === (0, $gcoP6.NO_ACTIVE_SPRINT_PLACEHOLDER) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lBRY4.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5nhUs.default), null);
    }, [
        placeholderType
    ]);
    if (!false && useVirtualisation) {
        if (shouldRenderUnassignedCTA) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $50AZv.default), {
            id: id,
            key: id,
            header: header,
            swimlaneId: swimlaneId ?? undefined,
            draggableIndex: columnIndex,
            footer: footer,
            isLastSwimlane: isLastSwimlane,
            dropZoneType: dropZoneType
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7meEu.UnassignedFilterCTA), null, (ctaHeight)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2lkEP.FastVirtualList), {
                    ...(0, $co1wz.ff)('backlog-active-sprints-list-markup-accessibility-fix_imavd') && {
                        name: name
                    },
                    showFooter: isColumnIccEnabled || showDoneCardsButton,
                    issueEntries: issueEntries,
                    issuesWithIssueLinksIds: issuesWithIssueLinksIds,
                    footer: virtualListFooter,
                    renderCard: renderCardFunction,
                    placeholder: placeHolder,
                    columnId: id,
                    swimlaneId: swimlaneId,
                    offsetTop: offsetTop + ctaHeight,
                    hasCTA: shouldRenderUnassignedCTA,
                    isUnscheduledWorkColumnPanel: (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') ? isUnscheduledWorkColumnPanel : undefined
                })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $50AZv.default), {
            id: id,
            key: id,
            header: header,
            swimlaneId: swimlaneId ?? undefined,
            draggableIndex: columnIndex,
            footer: footer,
            isLastSwimlane: isLastSwimlane,
            dropZoneType: dropZoneType
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2lkEP.FastVirtualList), {
                ...(0, $co1wz.ff)('backlog-active-sprints-list-markup-accessibility-fix_imavd') && {
                    name: name
                },
                showFooter: isColumnIccEnabled || showDoneCardsButton,
                issueEntries: issueEntries,
                issuesWithIssueLinksIds: issuesWithIssueLinksIds,
                footer: virtualListFooter,
                renderCard: renderCardFunction,
                placeholder: placeHolder,
                columnId: id,
                swimlaneId: swimlaneId,
                offsetTop: offsetTop,
                isUnscheduledWorkColumnPanel: (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') ? isUnscheduledWorkColumnPanel : undefined
            }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $50AZv.default), {
        id: id,
        key: id,
        header: (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(swimlaneId) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dRpFy.default), {
            id: id,
            menu: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iTH7p.default), {
                columnId: id
            }),
            showShadowOnScroll: true
        }) : null,
        swimlaneId: swimlaneId ?? undefined,
        draggableIndex: columnIndex,
        footer: footer,
        isLastSwimlane: isLastSwimlane
    }, shouldRenderUnassignedCTA ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7meEu.UnassignedFilterCTA), null) : null, issueEntries.map((issueEntry, index)=>{
        if ((0, $3eGwD.isIssueEntryGroup)(issueEntry)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g94HQ.default), {
            key: issueEntry.issueIds.toString(),
            index: index,
            issueIdGroup: issueEntry,
            canShowIccNudge: false,
            columnId: id,
            isColumnIccEnabled: isColumnIccEnabled,
            swimlaneId: swimlaneId,
            isLastSwimlane: isLastSwimlane,
            userCanViewMenu: canEditBoard || isUserAtLeastMember,
            onIssueChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            isScrolling: false,
            offsetTop: 0,
            headerRef: headerRef
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $drQJq.default), {
            key: issueEntry.issueId,
            id: issueEntry.issueId,
            columnId: id,
            canShowIccNudge: canShowIccNudgeInBoard,
            index: index,
            isColumnIccEnabled: isColumnIccEnabled,
            swimlaneId: swimlaneId,
            isLastSwimlane: isLastSwimlane,
            userCanViewMenu: canEditBoard || isUserAtLeastMember,
            onIssueChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            isScrolling: false,
            headerRef: headerRef
        });
    }), placeholderType === (0, $gcoP6.NO_ACTIVE_SPRINT_PLACEHOLDER) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lBRY4.default), null));
};
var $a12eb39f16847da5$export$2e2bcd8739ae039 = $a12eb39f16847da5$var$Column;

});
parcelRegister("drQJq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bd6e366c8f72404$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");


var $67sX6 = parcelRequire("67sX6");

var $1vXOx = parcelRequire("1vXOx");

var $9OPlz = parcelRequire("9OPlz");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $5KVmP = parcelRequire("5KVmP");

var $byfXQ = parcelRequire("byfXQ");

var $ljbvM = parcelRequire("ljbvM");

var $hsHM4 = parcelRequire("hsHM4");

var $1YTEX = parcelRequire("1YTEX");

var $52TPO = parcelRequire("52TPO");
const $4bd6e366c8f72404$var$CardPreview = ({ cardId: cardId })=>{
    const selectedCards = (0, $67sX6.useBoardSelector)((0, $9OPlz.getCardSelection));
    // Check that the card is in the selected cards in case there are some cards selected
    // and the user drags a different card.
    if (selectedCards.length > 1 && selectedCards.includes(cardId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4bd6e366c8f72404$var$CardPreviewContainer, {
        "data-count": selectedCards.length
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $byfXQ.default), {
        id: cardId
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $byfXQ.default), {
        id: cardId
    });
};
const $4bd6e366c8f72404$var$CardContainer = ({ id: id, index: index, columnId: columnId, swimlaneId: swimlaneId, userCanViewMenu: userCanViewMenu, isColumnIccEnabled: isColumnIccEnabled, isLastSwimlane: isLastSwimlane, onIssueChange: onIssueChange, isScrolling: isScrolling, canShowIccNudge: canShowIccNudge, isDraggable: isDraggable = true, groupParentId: groupParentId, headerRef: headerRef })=>{
    const shouldRenderCardLite = (0, $52TPO.useShouldRenderCardLite)(isScrolling);
    const canEditIssue = (0, $67sX6.useBoardSelector)((0, $1vXOx.getPermissionsSelector))[0, $e525e6c25695c9df$export$5cd553a40d575c6c];
    const isActiveCard = (0, $67sX6.useBoardSelector)((state)=>(0, $5mTgl.isActiveCardSelector)(state, {
            issueId: id
        }));
    const isSummaryEditing = (0, $67sX6.useBoardSelector)((state)=>(0, $9OPlz.getCardEditSummary)(state)(id));
    const isIPBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
    const isIncrementPlanningCardDraggable = (0, $67sX6.useBoardSelector)((state)=>!(0, $d2i8f.getIsIssueDoneInClosedSprint)(state, id));
    const isIPBoardReadOnly = (0, $67sX6.useBoardSelector)((0, $1vXOx.isIncrementPlanningReadOnly));
    let cardIsDraggable = isDraggable && !isSummaryEditing;
    if (isIPBoard) cardIsDraggable = cardIsDraggable && isIncrementPlanningCardDraggable && !isIPBoardReadOnly;
    if (shouldRenderCardLite) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $byfXQ.default), {
        id: id
    });
    const issueCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KVmP.default), {
        key: `card-${id}`,
        id: id,
        isLoading: // @ts-expect-error ([Part of upgrade 4.9-5.4]) - Operator '<=' cannot be applied to types 'CardId' and 'number'.
        id <= 0,
        draggableIndex: index,
        userCanViewMenu: userCanViewMenu,
        Cover: (0, $1YTEX.default),
        onIssueChange: onIssueChange ?? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        isDraggable: cardIsDraggable,
        columnId: columnId,
        swimlaneId: swimlaneId,
        CardPreview: $4bd6e366c8f72404$var$CardPreview,
        isActive: isActiveCard
    });
    const cardWithRich = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hsHM4.default), {
        key: `card-with-rich-${id}`,
        id: id,
        cardIndex: index,
        userCanViewMenu: userCanViewMenu,
        onIssueChange: onIssueChange,
        isDraggable: cardIsDraggable,
        columnId: columnId,
        swimlaneId: swimlaneId,
        CardPreview: $4bd6e366c8f72404$var$CardPreview
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ljbvM.CardWithIcc), {
        key: `card-with-icc-${id}`,
        isColumnIccEnabled: isColumnIccEnabled,
        id: id,
        cardIndex: index,
        columnId: columnId,
        swimlaneId: swimlaneId,
        isLastSwimlane: isLastSwimlane,
        onIssueChange: onIssueChange ?? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        canShowIccNudge: canShowIccNudge,
        forceIccRender: canShowIccNudge && index === 1,
        groupParentId: groupParentId,
        headerRef: headerRef
    }, canEditIssue ? cardWithRich : issueCard);
};
var $4bd6e366c8f72404$export$2e2bcd8739ae039 = $4bd6e366c8f72404$var$CardContainer;
// No real need to have the data attribute here, it's just for type safety
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4bd6e366c8f72404$var$CardPreviewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _otyrta7d _1kt9b3bt _1cs8stnw _cfu11ule _1tesidpf _1rus14es _kfgt1osq _1mpycxkx _7dwz3cjl _rfx316jk _txdo1lje _18postnw _1ywu1nu9 _15l2idpf _32rxidpf _aetr2r13 _clh31tul _16r2c8cv _18d31ppf _1eg9oqnp _14rn15cr _1lwzkb7n _14mjviql",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5KVmP", function(module, exports) {

$parcel$export(module.exports, "NewCard", () => $11fafa1598e26c74$export$909f8fb1bfc9b07);
$parcel$export(module.exports, "default", () => $11fafa1598e26c74$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $9XE6b = parcelRequire("9XE6b");

var $8QpSo = parcelRequire("8QpSo");

var $jzjy1 = parcelRequire("jzjy1");

var $2vSU6 = parcelRequire("2vSU6");

var $7wqBZ = parcelRequire("7wqBZ");

var $bC2fB = parcelRequire("bC2fB");


var $iuuJH = parcelRequire("iuuJH");

var $2f454 = parcelRequire("2f454");

var $dW1HX = parcelRequire("dW1HX");

var $2ON1s = parcelRequire("2ON1s");

var $9OPlz = parcelRequire("9OPlz");

var $3UY9S = parcelRequire("3UY9S");

var $bSSdD = parcelRequire("bSSdD");

var $fqLDH = parcelRequire("fqLDH");

var $d2i8f = parcelRequire("d2i8f");

var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");

var $7OmGs = parcelRequire("7OmGs");
const $11fafa1598e26c74$var$defaultHighlightLabelsOnCard = (0, $7uUwQ.freeze)([]);
const $11fafa1598e26c74$export$293240b492ab7f40 = ({ draggingCardData: draggingCardData, droppingCardData: droppingCardData, isCMPBoard: isCMPBoard, isRankable: isRankable, swimlaneMode: swimlaneMode, issueChildren: issueChildren, selectedCards: selectedCards, isIncrementPlanningBoard: isIncrementPlanningBoard })=>{
    // Childless cards cannot be moved to a subtask type swimlane and vice-versa
    const sourceSwimlaneId = draggingCardData.swimlaneId;
    const targetSwimlaneId = droppingCardData.swimlaneId;
    if (targetSwimlaneId === (0, $iuuJH.SWIMLANE_CHILDLESS) && sourceSwimlaneId !== (0, $iuuJH.SWIMLANE_CHILDLESS) || targetSwimlaneId !== (0, $iuuJH.SWIMLANE_CHILDLESS) && sourceSwimlaneId === (0, $iuuJH.SWIMLANE_CHILDLESS)) return false;
    // In Increment planning board, allow the user to rank issues by drop on card
    if (isIncrementPlanningBoard) return true;
    if (!isCMPBoard) return true;
    if (!isRankable) return false;
    if (draggingCardData.swimlaneId !== droppingCardData.swimlaneId) return false;
    if (swimlaneMode !== (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) {
        const draggingIssueChild = issueChildren[draggingCardData.cardId];
        const droppingIssueChild = issueChildren[droppingCardData.cardId];
        if (draggingIssueChild || droppingIssueChild) return draggingIssueChild?.parentId === droppingIssueChild?.parentId;
    }
    if (selectedCards?.includes(droppingCardData.cardId)) return false;
    return true;
};
const $11fafa1598e26c74$export$c31df4bd766f9c35 = ()=>{
    const isDroppableOnCardFactory = (0, $8QpSo.default)((isCMPBoard, isRankable, swimlaneMode, issueChildren, selectedCards, isIncrementPlanningBoard)=>(draggingCardData, droppingCardData)=>$11fafa1598e26c74$export$293240b492ab7f40({
                draggingCardData: draggingCardData,
                droppingCardData: droppingCardData,
                isCMPBoard: isCMPBoard,
                isRankable: isRankable,
                swimlaneMode: swimlaneMode,
                issueChildren: issueChildren,
                selectedCards: selectedCards,
                isIncrementPlanningBoard: isIncrementPlanningBoard
            }));
    return (state, ownProps)=>{
        const { id: id } = ownProps;
        const issue = (0, $5mTgl.platformIssueSelector)(state)(id);
        const highlight = (0, $5mTgl.platformHighlightScopeSelector)(state);
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        const issueParents = (0, $bSSdD.issueParentsSelector)(state);
        const availableIssueParentsForIssueProject = (0, $bSSdD.availableIssueParentsForIssueProjectSelector)(state)(issue?.projectId);
        const issueParentsObj = (0, $bSSdD.getIssueParents)(state);
        const isParent = id in issueParentsObj;
        const parentId = (()=>{
            if (!issue) return null;
            if (isParent) return id;
            return issue.parentId;
        })();
        const parent = parentId !== null ? (0, $bSSdD.makeIssueParentByIdSelector)(state)(parentId) : null;
        const isJSMBoard = (0, $67Z81.projectTypeSelector)(state) === (0, $2vSU6.SERVICE_DESK_PROJECT);
        const isRankable = (0, $67Z81.isBoardRankable)(state);
        const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
        const issueChildren = (0, $3UY9S.getIssueChildren)(state);
        const selectedCards = (0, $9OPlz.getCardSelection)(state);
        const projects = (0, $67Z81.getIssueProjects)(state);
        const projectKey = issue && Object.values(projects).find((project)=>project.id === issue.projectId)?.key;
        const isDroppableOnCard = isDroppableOnCardFactory(isCMPBoard, isRankable, swimlaneMode, issueChildren, selectedCards, isIncrementPlanningBoard);
        return {
            issue: issue,
            assignee: issue && issue?.assigneeAccountId !== null ? (0, $36pz7.getPerson)(state, issue.assigneeAccountId) : null,
            parent: parent,
            issueParents: isIncrementPlanningBoard ? availableIssueParentsForIssueProject : issueParents,
            estimate: (0, $5mTgl.getEstimateExtendedByIssueId)(state, {
                id: id
            }),
            shouldShowParent: (0, $9OPlz.getShouldShowParent)(state),
            shouldShowRipple: (0, $9OPlz.shouldCardShowRipple)(state)(id),
            isDone: (0, $d2i8f.isDoneIssueSelector)(state)(id),
            isSelected: (0, $9OPlz.isCardSelected)(state)(id),
            isFocused: (0, $9OPlz.isCardFocused)(state)(id),
            isFlagged: issue?.isFlagged || false,
            isIssueViewOpen: (0, $fqLDH.isIssueModalShowingSelector)(state),
            shouldRenderCardType: (0, $5mTgl.shouldRenderCardTypesSelector)(state),
            highlightTextOnCard: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(highlight, 'text', '') || '',
            // defaultHighlightLabelsOnCard is used to avoid unnecessary re-renderings.
            // If you use [] instead "Card" component would be re-rendered every time when connect function is executed
            highlightLabelsOnCard: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(highlight, 'labels', $11fafa1598e26c74$var$defaultHighlightLabelsOnCard) || $11fafa1598e26c74$var$defaultHighlightLabelsOnCard,
            isDragDisabled: (0, $5mTgl.isCardDragDisabled)(state)(id),
            hideEpic: isCMPBoard && state.ui.board.displayOptions.areEpicLabelsHidden,
            projectIds: (0, $67Z81.getIssueProjectIds)(state),
            projectKey: projectKey,
            isCMPBoard: isCMPBoard,
            status: isJSMBoard ? (0, $5mTgl.getStatusByIssueIdSelector)(state, {
                id: id
            }) ?? null : null,
            isDroppableOnCard: isDroppableOnCard
        };
    };
};
const $11fafa1598e26c74$export$9e6a17cf56877796 = (dispatch)=>({
        onClick: (id, withCmd, withShift, externalAction)=>{
            if (!withCmd && !withShift) (0, $7wqBZ.getLongTasksMetrics)('bento').start('board');
            dispatch((0, $2f454.cardClick)(id, withCmd, withShift, externalAction));
        },
        onEnterPress: (issueKey)=>{
            dispatch((0, $dW1HX.openIssueModal)(issueKey));
        },
        onMouseDown: ()=>{
            (0, $7wqBZ.getLongTasksMetrics)('dnd').start('board', (0, $dcbb2bce513725b3$export$67cc25959ff33188));
        },
        onMouseUp: ()=>{
            (0, $7wqBZ.getLongTasksMetrics)('dnd').stopIfNoMark((0, $dcbb2bce513725b3$export$67cc25959ff33188));
        },
        onRippleEnd: (id)=>{
            dispatch((0, $2f454.cardRemoveShowRipple)(id));
        },
        onFocus: (id)=>{
            dispatch((0, $2f454.cardFocus)(id));
        },
        onBlur: ()=>{
            dispatch((0, $2f454.cardBlur)());
        },
        onCloseOtherPanels: ()=>{
            dispatch((0, $2ON1s.closeInsightsPanel)());
            dispatch((0, $2ON1s.closeViewSettingsPanel)());
        }
    });
/**
 * Non editable card - Use NewCard if possible
 * */ const $11fafa1598e26c74$var$CardConnected = (0, $bC2fB.connect)($11fafa1598e26c74$export$c31df4bd766f9c35, $11fafa1598e26c74$export$9e6a17cf56877796)((0, $jzjy1.AnalyticsSubject)('issue')((0, $7OmGs.default)));
const $11fafa1598e26c74$export$909f8fb1bfc9b07 = (0, $bC2fB.connect)($11fafa1598e26c74$export$c31df4bd766f9c35, $11fafa1598e26c74$export$9e6a17cf56877796)((0, $jzjy1.AnalyticsSubject)('issue')((0, $7OmGs.NewCardWithNullableIssue)));
var $11fafa1598e26c74$export$2e2bcd8739ae039 = $11fafa1598e26c74$var$CardConnected;

});
parcelRegister("7OmGs", function(module, exports) {

$parcel$export(module.exports, "NewCardWithNullableIssue", () => $c4fa088541c3ca24$export$9f96343954949053);
$parcel$export(module.exports, "default", () => $c4fa088541c3ca24$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $2NMNM = parcelRequire("2NMNM");

var $imZsD = parcelRequire("imZsD");
var $k6T4f = parcelRequire("k6T4f");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $5rFbt = parcelRequire("5rFbt");

var $4R6GH = parcelRequire("4R6GH");

var $2gCtH = parcelRequire("2gCtH");

var $54wEF = parcelRequire("54wEF");

var $3fAi8 = parcelRequire("3fAi8");

var $b8gJu = parcelRequire("b8gJu");

var $58K4A = parcelRequire("58K4A");

var $iXVV6 = parcelRequire("iXVV6");



var $lu5k0 = parcelRequire("lu5k0");

var $iDGXn = parcelRequire("iDGXn");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $5GDqD = parcelRequire("5GDqD");

var $dCm1o = parcelRequire("dCm1o");

var $2xFXk = parcelRequire("2xFXk");

var $4kv6l = parcelRequire("4kv6l");

var $iUagi = parcelRequire("iUagi");


var $7mkyN = parcelRequire("7mkyN");

var $67sX6 = parcelRequire("67sX6");

var $4RVsR = parcelRequire("4RVsR");

var $1vXOx = parcelRequire("1vXOx");

var $gR0bs = parcelRequire("gR0bs");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");

var $5wBpE = parcelRequire("5wBpE");

var $jeb8M = parcelRequire("jeb8M");

var $kJtdN = parcelRequire("kJtdN");

var $aeiE5 = parcelRequire("aeiE5");

var $2H35T = parcelRequire("2H35T");

var $hnyd8 = parcelRequire("hnyd8");

var $fBeRa = parcelRequire("fBeRa");

var $2Gmm7 = parcelRequire("2Gmm7");

var $UJNvI = parcelRequire("UJNvI");

var $aLb7D = parcelRequire("aLb7D");
const $c4fa088541c3ca24$var$selectedCardIds = [];
const $c4fa088541c3ca24$export$2ad76717ee8b873f = ({ id: id, issue: issue, isFocused: isFocused, onEnterPress: onEnterPress, onFocus: onFocus, onRippleEnd: onRippleEnd, userCanViewMenu: userCanViewMenu, Cover: Cover, parent: parent, issueParents: issueParents, onIssueChange: onIssueChange, onClick: onClick, onCloseOtherPanels: onCloseOtherPanels, hideEpic: hideEpic, isCMPBoard: isCMPBoard, isFlagged: isFlagged, isActive: isActive = false, isIssueViewOpen: isIssueViewOpen, ...props })=>{
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)() ?? false;
    const isIPBoardReadOnly = (0, $67sX6.useBoardSelector)((0, $1vXOx.isIncrementPlanningReadOnly));
    const isJSWBoard = (0, $63LqY.useIsJSWBoard)() ?? false;
    const isJSMBoard = (0, $63LqY.useIsJSMBoard)() ?? false;
    const cloudId = (0, $koeKL.useCloudId)();
    const accountId = (0, $90yGq.useAccountId)();
    const { fetchTraits: fetchTraits } = (0, $5GDqD.useTraitsActions)();
    if ((0, $4R6GH.fg)('jsw_cmp_card_covers_changeboarding')) fetchTraits([
        'SITE_USER'
    ], {
        cloudId: cloudId,
        accountId: accountId
    });
    const isFirstIssue = issue.id === (0, $67sX6.useBoardSelector)((0, $gR0bs.getFirstSelectableIssueAscending));
    const shouldShowCardCoverChangeboarding = (0, $aLb7D.useShouldShowCardCoverChangeboarding)();
    const issueShouldShowCardCoverChangeboarding = isFirstIssue && shouldShowCardCoverChangeboarding;
    const viewSettings = (0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() ? (0, $iDGXn.useCardFieldsSettings)() : {
        showIssueType: true,
        showIssueKey: true,
        showEstimate: true,
        showPriority: true,
        showDevelopment: true,
        showAssignee: true,
        showDaysInColumn: true,
        showDueDate: true,
        showLabels: true,
        cardExtraFields: undefined
    };
    const returnFocusTo = (0, $lu5k0.useReturnFocusTo)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const menuTriggerRef = (0, $5uXOq.useRef)(null);
    const triggerIsFocused = Boolean(returnFocusTo?.current && menuTriggerRef.current && returnFocusTo?.current === menuTriggerRef.current);
    const handleMenuOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        if (isOpen && menuTriggerRef?.current) setReturnFocusTo(menuTriggerRef);
    }, [
        setReturnFocusTo
    ]);
    const { entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, $7mkyN.PlanModalEntrypointContext));
    const renderContextMenu = ()=>{
        if ((0, $4R6GH.fg)('board_card_context_menu_optimistic_card_fix')) // Do not render in optimistic cards
        return Number(issue.id) > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJtdN.ContextMenu), {
            issueId: issue.id,
            issueKey: issue.key,
            summary: issue.summary,
            selectedCardIds: $c4fa088541c3ca24$var$selectedCardIds,
            appearance: (0, $d9cdb1c71f9dbf8c$export$ee5015c6ad52cf0b),
            onOpenChange: handleMenuOpenChange,
            triggerRef: menuTriggerRef
        }) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJtdN.ContextMenu), {
            issueId: issue.id,
            issueKey: issue.key,
            summary: issue.summary,
            selectedCardIds: $c4fa088541c3ca24$var$selectedCardIds,
            appearance: (0, $d9cdb1c71f9dbf8c$export$ee5015c6ad52cf0b),
            onOpenChange: handleMenuOpenChange,
            triggerRef: menuTriggerRef
        });
    };
    const renderContextMenuWithSpotlight = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
            name: (0, $jeb8M.CARD_COVER_SPOTLIGHT_TARGET_ID)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
            radius: 3
        }, renderContextMenu())));
    const renderMenu = ()=>{
        if (!userCanViewMenu) return null;
        return issueShouldShowCardCoverChangeboarding ? renderContextMenuWithSpotlight() : renderContextMenu();
    };
    const onEnterPressCb = (0, $5uXOq.useCallback)(()=>{
        onEnterPress(issue.key);
    }, [
        onEnterPress,
        issue.key
    ]);
    const onFocusCb = (0, $5uXOq.useCallback)(()=>{
        onFocus(id);
    }, [
        id,
        onFocus
    ]);
    const onRippleEndCb = (0, $5uXOq.useCallback)(()=>{
        onRippleEnd(id);
    }, [
        id,
        onRippleEnd
    ]);
    const viewMode = (0, $2gCtH.useViewMode)();
    const onClickCb = (0, $5uXOq.useCallback)((issueId, withCmd, withShift, externalAction)=>{
        if (isIncrementPlanningBoard && !withCmd && !withShift && (0, $4R6GH.fg)('issue_view_in_program_board')) entryPointActions.load();
        onClick(issueId, withCmd, withShift, externalAction);
        if (viewMode === 'SIDEBAR' && !withCmd) onCloseOtherPanels();
    }, [
        entryPointActions,
        isIncrementPlanningBoard,
        onClick,
        onCloseOtherPanels,
        viewMode
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const cover = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Cover, {
            id: id,
            onImageLoad: onIssueChange
        }), [
        id,
        onIssueChange
    ]);
    const issueParent = (0, $5uXOq.useMemo)(()=>parent ? {
            ...parent,
            issueType: {
                ...parent.issueType
            }
        } : null, [
        parent
    ]);
    const shouldRenderEpic = (0, $iDGXn.useShowEpics)();
    const isFlexible = (0, $63LqY.useCapability)((0, $2xFXk.Capability).FLEXIBLE_BOARD_COLUMNS);
    const hasCompactIssueType = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_COMPACT_ISSUE_TYPE_ICON_ON_CARD);
    let dateFormat = null;
    if (issue?.dueDate) {
        if ((0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('jira_nav4_beta_drop_1')) dateFormat = 'dd MMM yyyy';
        else dateFormat = (0, $4kv6l.getDateFormat)(issue.dueDate);
    }
    const renderIssueLinksIndicator = (0, $5uXOq.useCallback)(()=>{
        if (!isIncrementPlanningBoard || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issue.issueLinks)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aeiE5.IssueLinksIndicator), {
            issueId: issue.id,
            issueKey: issue.key
        });
    }, [
        isIncrementPlanningBoard,
        issue.id,
        issue.key,
        issue.issueLinks
    ]);
    const onIssueUnlink = (0, $5uXOq.useCallback)((issueIds)=>dispatch((0, $4RVsR.fetchIssueLinksStats)(issueIds, {
            analyticsEvent: createAnalyticsEvent({})
        })), [
        createAnalyticsEvent,
        dispatch
    ]);
    // Card should not steal focus away from the issue view
    const shouldFocus = isFocused && !isIssueViewOpen;
    const renderIssueLinksStats = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2H35T.IssueLinksStats), {
            id: issue.id,
            issueKey: issue.key,
            summary: issue.summary,
            typeId: issue.typeId,
            onIssueUnlink: onIssueUnlink
        });
    const getBoardViewType = ()=>{
        if (isJSWBoard && !isIncrementPlanningBoard) return (0, $b8gJu.BoardView).JSW_BOARD;
        if (isIncrementPlanningBoard) return (0, $b8gJu.BoardView).INCREMENT_PLANNING_BOARD;
        if (isJSMBoard) return (0, $b8gJu.BoardView).JSM_BOARD;
        // default to JSW_BOARD
        return (0, $b8gJu.BoardView).JSW_BOARD;
    };
    const showLabelsOutsideOfCustomFieldsList = (0, $aLb7D.getShouldShowLabels)(viewSettings.showLabels, isCMPBoard);
    // change to just onClickCb on issue_view_in_program_board clean up
    const clickCbWithFG = ()=>{
        if ((0, $4R6GH.fg)('issue_view_in_program_board')) return onClickCb;
        return !isIPBoardReadOnly ? onClickCb : undefined;
    };
    const shouldPersistActions = issueShouldShowCardCoverChangeboarding || isActive || triggerIsFocused;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $58K4A.Card), {
        ...props,
        id: id,
        issue: issue,
        parent: shouldRenderEpic ? issueParent : null,
        shouldFocus: shouldFocus,
        isFlexible: isFlexible,
        onClick: clickCbWithFG(),
        onEnterPress: onEnterPressCb,
        onFocus: onFocusCb,
        onRippleEnd: onRippleEndCb,
        cover: cover,
        CustomContextMenu: !isIPBoardReadOnly && (!(0, $4R6GH.fg)('avoid_invalid_issueid_in_board_context_menu') || userCanViewMenu) ? (0, $kJtdN.ContextMenu) : undefined,
        renderCustomMenu: renderMenu,
        onSizeChange: onIssueChange,
        isCMPBoard: isCMPBoard,
        selectedCardIds: $c4fa088541c3ca24$var$selectedCardIds,
        dateFormat: dateFormat,
        hasCompactIssueType: hasCompactIssueType,
        isIPBoard: isIncrementPlanningBoard,
        isFlagged: !isIncrementPlanningBoard && isFlagged,
        renderIssueLinksIndicator: renderIssueLinksIndicator,
        renderIssueLinksStats: renderIssueLinksStats,
        persistActions: shouldPersistActions,
        showDaysInColumn: viewSettings.showDaysInColumn,
        shouldRenderCardType: viewSettings.showIssueType,
        showIssueKey: viewSettings.showIssueKey,
        showEstimate: viewSettings.showEstimate,
        showPriority: viewSettings.showPriority,
        showDevelopment: viewSettings.showDevelopment,
        showCardExtraFields: viewSettings.cardExtraFields,
        showAssignee: viewSettings.showAssignee,
        showDueDate: viewSettings.showDueDate,
        boardType: getBoardViewType(),
        showLabels: showLabelsOutsideOfCustomFieldsList
    });
};
const $c4fa088541c3ca24$export$909f8fb1bfc9b07 = (props)=>{
    const { issue: issue, assignee: assignee, parent: parent, issueParents: issueParents, onIssueChange: onIssueChange, shouldRenderRichCard: shouldRenderRichCard, projectIds: projectIds, isCMPBoard: isCMPBoard, estimate: estimateExtended, projectKey: projectKey } = props;
    const [isSummaryEditing, setIsSummaryEditing] = (0, $5uXOq.useState)(false);
    const [, { setIssue: setIssue }] = (0, $3fAi8.useFieldsValuesActions)();
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    // In the increment planning board, scenario issue keys do not yet have a numeric identifier as
    // they have not been created in Jira yet. In this case, the key is equal to the projectKey,
    // and thus not unique. Instead, we pass the issue id to the field config service (as it
    // requires a unique identifier for each issue).
    const key = isIncrementPlanningBoard && issue.key === projectKey ? `${issue.id}` : issue.key;
    const [issueFieldsValues] = (0, $3fAi8.useFieldsValues)(key);
    const [{ value: issueFieldConfig }] = (0, $54wEF.useIssueFieldConfigWithoutRefetch)(key);
    const [, { setIssueConfig: setIssueConfig }] = (0, $54wEF.useFieldConfigActions)();
    const canEditIssues = (0, $67sX6.useBoardSelector)((state)=>(0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$5cd553a40d575c6c]);
    const timeTrackingOptions = (0, $67sX6.useBoardSelector)((0, $5mTgl.getTimeTrackingOptions));
    const inlineEditPlacement = isIncrementPlanningBoard && issue.columnId === (0, $5rFbt.UNSCHEDULED_COLUMN_ID) ? 'top-end' : undefined;
    const renderSummary = (0, $5uXOq.useCallback)((renderSummaryProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $UJNvI.Summary), {
            issueId: issue.id,
            issueKey: key,
            onSizeChange: onIssueChange,
            isSummaryEditing: isSummaryEditing,
            setIsSummaryEditing: setIsSummaryEditing,
            shouldRenderRichField: shouldRenderRichCard,
            dialogPlacement: inlineEditPlacement,
            ...renderSummaryProps
        }), [
        issue.id,
        key,
        onIssueChange,
        isSummaryEditing,
        shouldRenderRichCard,
        inlineEditPlacement
    ]);
    const renderEstimateField = (0, $5uXOq.useCallback)(()=>{
        // when estimate feature is disabled
        if (!estimateExtended || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(estimateExtended.fieldId)) return null;
        if (estimateExtended.fieldId === (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fBeRa.OriginalEstimateField), {
            key: `card-estimate-${issue.estimate}`,
            issueId: issue.id,
            issueKey: issue.key,
            timeTrackingOptions: timeTrackingOptions,
            estimate: issue.estimate,
            shouldRenderRichField: shouldRenderRichCard
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Gmm7.StoryPointField), {
            key: `card-estimate-${issue.estimate}`,
            issueId: issue.id,
            issueKey: key,
            estimate: issue.estimate,
            storyPointFieldId: estimateExtended.fieldId,
            shouldRenderRichField: shouldRenderRichCard,
            dialogPlacement: inlineEditPlacement
        });
    }, [
        estimateExtended,
        issue.estimate,
        issue.id,
        issue.key,
        key,
        shouldRenderRichCard,
        timeTrackingOptions,
        inlineEditPlacement
    ]);
    const renderIssueParentField = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hnyd8.IssueParentField), {
            issueId: issue.id,
            issueKey: issue.key,
            currentProjectId: issue.projectId,
            projectIds: projectIds,
            isCompanyManaged: isCMPBoard,
            isIncrementPlanningBoard: isIncrementPlanningBoard,
            parentSummary: parent?.summary || null,
            parentColor: parent?.color || null,
            issueParents: issueParents,
            shouldRenderRichField: shouldRenderRichCard,
            projectKey: projectKey
        }), [
        isCMPBoard,
        issue.id,
        issue.key,
        issue.projectId,
        issueParents,
        parent,
        projectIds,
        shouldRenderRichCard,
        isIncrementPlanningBoard,
        projectKey
    ]);
    const renderAssignee = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5wBpE.AssigneeField), {
            issueKey: issue.key,
            assignee: assignee,
            shouldRenderRichField: shouldRenderRichCard,
            isCMPBoard: isCMPBoard,
            issueId: Number(issue.id)
        }), [
        issue.key,
        assignee,
        shouldRenderRichCard,
        isCMPBoard,
        issue.id
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldRenderRichCard && !issueFieldsValues) setIssue(key, (0, $aLb7D.transformToIssueFieldValues)({
            issue: issue,
            assignee: assignee,
            parent: parent,
            estimateExtended: estimateExtended
        }));
    }, [
        shouldRenderRichCard,
        issueFieldsValues,
        issue.key,
        setIssue,
        parent,
        issue,
        assignee,
        timeTrackingOptions,
        estimateExtended,
        key
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldRenderRichCard && !issueFieldConfig) setIssueConfig(key, (0, $aLb7D.transformToIssueFieldConfigValues)({
            issue: issue,
            estimateExtended: estimateExtended,
            isEditable: canEditIssues
        }));
    }, [
        canEditIssues,
        estimateExtended,
        issue,
        issueFieldConfig,
        parent,
        setIssueConfig,
        shouldRenderRichCard,
        key
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            issueId: props.issue.id
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c4fa088541c3ca24$export$2ad76717ee8b873f, {
        ...props,
        ...!isCMPBoard && {
            renderSummary: renderSummary,
            userCanViewMenu: props.userCanViewMenu && !isSummaryEditing
        },
        renderIssueParentField: isCMPBoard ? undefined : renderIssueParentField,
        renderAssignee: renderAssignee,
        ...!isCMPBoard && {
            renderEstimateField: renderEstimateField
        },
        isDragDisabled: props.isDragDisabled || isSummaryEditing
    }));
};
const $c4fa088541c3ca24$export$9f96343954949053 = (props)=>{
    const { issue: issue, ...rest } = props;
    if (issue !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c4fa088541c3ca24$export$909f8fb1bfc9b07, {
        ...rest,
        issue: issue
    });
    return null;
};
const $c4fa088541c3ca24$var$Card = (props)=>{
    const { issue: issue, ...rest } = props;
    if (issue !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c4fa088541c3ca24$export$2ad76717ee8b873f, {
        ...rest,
        issue: issue
    });
    return null;
};
var $c4fa088541c3ca24$export$2e2bcd8739ae039 = $c4fa088541c3ca24$var$Card;

});
parcelRegister("54wEF", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfig", () => $a5085d8f4019d625$export$5406c21e0d275680);
$parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", () => $a5085d8f4019d625$export$217a0e2f2962f4ae);
$parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", () => $a5085d8f4019d625$export$5f641a998c6dfa06);
$parcel$export(module.exports, "useFieldConfig", () => $a5085d8f4019d625$export$70da50df1be2dbe1);
$parcel$export(module.exports, "useFieldConfigWithoutRefetch", () => $a5085d8f4019d625$export$1eed575f8f3334eb);
$parcel$export(module.exports, "useFieldConfigActions", () => $a5085d8f4019d625$export$28a22fd0dedf31b7);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");

var $iZIvy = parcelRequire("iZIvy");

var $eDXka = parcelRequire("eDXka");

var $gXz4p = parcelRequire("gXz4p");

var $biQrn = parcelRequire("biQrn");

var $2N3tQ = parcelRequire("2N3tQ");
const $a5085d8f4019d625$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
const $a5085d8f4019d625$var$fetchDataOld = async (issueKey)=>{
    const response = await (0, $eusud.performPostRequest)((0, $iZIvy.getGraphQlUrl)('', (0, $eDXka.IssueViewFetchOperations).FIELD_CONFIGURATION), {
        body: JSON.stringify({
            query: $a5085d8f4019d625$export$9715ac6597e498fd(),
            variables: {
                issueKey: issueKey
            }
        })
    });
    if (response && response.data && response.data.issue && response.data.issue.fields) return response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
    (result, field)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [field.key]: {
                autoCompleteUrl: field.autoCompleteUrl,
                allowedValues: field.allowedValues,
                isEditable: field.editable,
                isRequired: field.required,
                schema: field.schema,
                title: field.title,
                ...field.description ? {
                    description: field.description
                } : {}
            }
        }), {});
    return null;
};
const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId })=>{
    const errorMessageItem = errorMessage != null ? {
        errorMessage: errorMessage
    } : {};
    const traceIdItem = traceId != null ? {
        traceId: traceId
    } : {};
    return {
        experience: (0, $eDXka.IssueViewFetchOperations).FIELD_CONFIGURATION,
        wasExperienceSuccesful: wasExperienceSuccessful,
        analyticsSource: 'Issue View Field Configuration Query',
        additionalAttributes: {
            method: 'GET',
            ...errorMessageItem,
            ...traceIdItem
        },
        application: null,
        edition: null
    };
};
const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking = ({ wasExperienceSuccessful: wasExperienceSuccessful, error: error })=>{
    (0, $gXz4p.sendExperienceAnalytics)($a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription({
        wasExperienceSuccessful: wasExperienceSuccessful,
        ...error?.message != null ? {
            errorMessage: error.message
        } : {},
        ...error instanceof (0, $jJZqs.default) && error.traceId != null ? {
            traceId: error.traceId
        } : {}
    }));
};
const $a5085d8f4019d625$var$fetchDataWithExperienceTracking = async (issueKey)=>{
    try {
        const response = await (0, $eusud.performPostRequest)((0, $iZIvy.getGraphQlUrl)('', (0, $eDXka.IssueViewFetchOperations).FIELD_CONFIGURATION), {
            body: JSON.stringify({
                query: $a5085d8f4019d625$export$9715ac6597e498fd(),
                variables: {
                    issueKey: issueKey
                }
            })
        });
        if (response?.data?.issue?.fields) {
            const fieldConfigData = response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
            (result, field)=>({
                    // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                    ...result,
                    [field.key]: {
                        autoCompleteUrl: field.autoCompleteUrl,
                        allowedValues: field.allowedValues,
                        isEditable: field.editable,
                        isRequired: field.required,
                        schema: field.schema,
                        title: field.title,
                        ...field.description ? {
                            description: field.description
                        } : {}
                    }
                }), {});
            $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
                wasExperienceSuccessful: true
            });
            return fieldConfigData;
        }
        $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: new Error('Unexpected field configuration response')
        });
        return null;
    } catch (error) {
        $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: error instanceof (0, $jJZqs.default) ? error : undefined
        });
        return null;
    }
};
const $a5085d8f4019d625$var$fetchData = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jiv-18890-field-configuration-query-exp-tracking'), $a5085d8f4019d625$var$fetchDataWithExperienceTracking, $a5085d8f4019d625$var$fetchDataOld);
const $a5085d8f4019d625$var$requestSet = new Set();
const $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions = {
    skipRefresh: false
};
const $a5085d8f4019d625$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
    const isMounted = (0, $biQrn.useIsMounted)();
    const [, { setIssueConfig: setIssueConfig }] = (0, $2N3tQ.useFieldConfigStoreActions)();
    const [loading, setLoading] = (0, $5uXOq.useState)(()=>!skipRefresh && value === undefined && !$a5085d8f4019d625$var$requestSet.has(issueKey));
    const getData = (0, $5uXOq.useCallback)(async ()=>{
        setLoading(true);
        $a5085d8f4019d625$var$requestSet.add(issueKey);
        const result = await $a5085d8f4019d625$var$fetchData(issueKey);
        setIssueConfig(issueKey, result);
        $a5085d8f4019d625$var$requestSet.delete(issueKey);
        if (isMounted.current) setLoading(false);
    }, [
        isMounted,
        issueKey,
        setIssueConfig
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const shouldGetData = !skipRefresh && !$a5085d8f4019d625$var$requestSet.has(issueKey) && value === undefined;
        if (shouldGetData) getData();
    }, [
        issueKey,
        value,
        getData,
        skipRefresh
    ]);
    return [
        {
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
    const [value] = (0, $2N3tQ.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [overrides] = (0, $2N3tQ.useIssueOverridesStore)({
        issueKey: issueKey
    });
    return (0, $5uXOq.useMemo)(()=>{
        if (// When fields configurations are not valid, we don't want overrides
        !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) && // We should not override if UI modifications is not available in general or for the field
        overrides !== undefined) {
            // Iteration over the base fields (`value`) prevents creation of partial configs with just UIM overrides.
            const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                acc[fieldKey] = {
                    ...fieldValues,
                    ...overrides[fieldKey]
                };
                return acc;
            }, {});
            return [
                issueWithOverrides
            ];
        }
        return [
            value
        ];
    }, [
        value,
        overrides
    ]);
};
const $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    const [value] = (0, $2N3tQ.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [overrides] = (0, $2N3tQ.useFieldOverridesStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    if (// When fields configurations are not valid, we don't want overrides
    !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) && // We should not override if UI modifications is not available in general or for the field
    overrides !== undefined) return [
        {
            ...value,
            ...overrides
        }
    ];
    return [
        value
    ];
};
const $a5085d8f4019d625$export$5406c21e0d275680 = (issueKey)=>{
    const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$217a0e2f2962f4ae = (issueKey)=>{
    const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    return [
        {
            value: value
        }
    ];
};
const $a5085d8f4019d625$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
    const [value] = (0, $2N3tQ.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
    const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value, options);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
    const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    return [
        {
            value: value
        }
    ];
};
const $a5085d8f4019d625$export$28a22fd0dedf31b7 = ()=>{
    const [, setIssueConfigActions] = (0, $2N3tQ.useFieldConfigStoreActions)();
    const actions = (0, $5uXOq.useMemo)(()=>{
        const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
        const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
        const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
        const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
        const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
        return {
            setIssueConfig: setIssueConfig,
            setIssuesConfig: setIssuesConfig,
            mergeIssueConfig: mergeIssueConfig,
            mergeIssuesConfig: mergeIssuesConfig,
            setFieldConfigValue: setFieldConfigValue
        };
    }, [
        setIssueConfigActions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("iZIvy", function(module, exports) {

$parcel$export(module.exports, "getGraphQlUrl", () => $ef2130f553e5234b$export$5647e6bbf2b3526f);
$parcel$export(module.exports, "getFieldDataOptions", () => $ef2130f553e5234b$export$f2fec0cacdfabaaf);

var $96nmc = parcelRequire("96nmc");

var $chLKn = parcelRequire("chLKn");
const $ef2130f553e5234b$export$5647e6bbf2b3526f = (baseUrl, operation)=>`${baseUrl}/rest/graphql/1/${(0, $96nmc.appendOperationQuery)(operation)}`;
const $ef2130f553e5234b$export$f2fec0cacdfabaaf = (issueKey, projectKey)=>({
        method: 'POST',
        body: JSON.stringify({
            query: (0, $chLKn.default)(issueKey, projectKey)
        })
    });

});
parcelRegister("chLKn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c7dcb170a6dfaf0$export$2e2bcd8739ae039);
const $2c7dcb170a6dfaf0$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};
const $2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery = ()=>`
    isHybridAgilityProject
    `;
const $2c7dcb170a6dfaf0$var$getEnvironmentQuery = ()=>`environmentAdf {
        value
    }`;
const $2c7dcb170a6dfaf0$var$getAgileQuery = ()=>`
    agile {
        epic {
          key
        },
    }`;
const $2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration = ()=>`configuration {
        key
        value
    }
    `;
const $2c7dcb170a6dfaf0$var$getProjectQuery = (projectKey)=>`
        project(projectIdOrKey: "${projectKey}") {
            id
            name
            key
            projectTypeKey
            simplified
            avatarUrls {
                key
                value
            }
            archived
            deleted
        }`;
var // Disable this eslint rule temporarily so we can query for configuration
// eslint-disable-next-line jira/import/no-anonymous-default-export
$2c7dcb170a6dfaf0$export$2e2bcd8739ae039 = (issueKey, projectKey)=>$2c7dcb170a6dfaf0$export$ecc155df19ba52ff`query issueDataQuery {
        issue(issueIdOrKey: "${issueKey}", latestVersion: true, screen: "view") {
            id
            viewScreenId
            fields {
                key
                title
                editable
                required
                autoCompleteUrl
                allowedValues
                content
                renderedContent
                schema {
                    custom
                    system
                    ${$2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration()}
                    items
                    type
                    renderer
                }
                configuration
            }
            expandAssigneeInSubtasks
            expandAssigneeInIssuelinks
            expandTimeTrackingInSubtasks
            systemFields {
                descriptionAdf {
                    value
                }
                ${$2c7dcb170a6dfaf0$var$getEnvironmentQuery()}
            }
            customFields {
                textareaAdf {
                    key
                    value
                }
            }
            ${$2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery()}
            ${$2c7dcb170a6dfaf0$var$getAgileQuery()}
        }
        ${$2c7dcb170a6dfaf0$var$getProjectQuery(projectKey)}
    }`;

});


parcelRegister("eDXka", function(module, exports) {

$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $9f0f96bc04f1e77a$export$b38f30d67f730bc4);
const $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $9f0f96bc04f1e77a$export$757f91ad408a28d4 = 'jira.user.issue.filter.hide-done-subtasks';
const $9f0f96bc04f1e77a$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
    VIEW_SCREEN_ID: 'viewScreenIdQuery',
    FIELD_CONFIGURATION: 'fieldConfigurationQuery',
    FIELD_DESCRIPTION: 'fieldDescriptionQuery',
    ATTACHMENT: 'attachmentsQuery'
};

});

parcelRegister("biQrn", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $c6adaed2787020bf$export$80c2a3957bcb42ea);

var $5uXOq = parcelRequire("5uXOq");
const $c6adaed2787020bf$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});

parcelRegister("2N3tQ", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfigStore", () => $0471f3f4df57179c$export$52f51db4e2b3da57);
$parcel$export(module.exports, "useFieldConfigStore", () => $0471f3f4df57179c$export$f9beb98c7488fd61);
$parcel$export(module.exports, "useFieldConfigStoreActions", () => $0471f3f4df57179c$export$314199caf05d245);
$parcel$export(module.exports, "useIssueOverridesStore", () => $0471f3f4df57179c$export$ff357cf5a96ec0c6);
$parcel$export(module.exports, "useFieldOverridesStore", () => $0471f3f4df57179c$export$6e41e9c34587d557);
$parcel$export(module.exports, "useFieldOverridesStoreWithLabel", () => $0471f3f4df57179c$export$e704d739927bd1d6);
$parcel$export(module.exports, "useOverridesStoreActions", () => $0471f3f4df57179c$export$d94ae842140da412);
$parcel$export(module.exports, "useFieldOptionsOverrides", () => $0471f3f4df57179c$export$bfea9bb9bad7bc8f);
$parcel$export(module.exports, "useIsFieldBusy", () => $0471f3f4df57179c$export$982ff1008c2e2780);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $dGvGJ = parcelRequire("dGvGJ");

var $1UikQ = parcelRequire("1UikQ");

var $7JoAD = parcelRequire("7JoAD");
const $0471f3f4df57179c$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: IssueConfiguration | null; }' is not assignable to parameter of type 'Partial<Partial<Record<string, IssueConfiguration>>>'.
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: issueConfiguration
        });
    };
const $0471f3f4df57179c$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState()[issueKey], issueConfiguration)
        });
    };
const $0471f3f4df57179c$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                ...acc,
                ...issue
            }), {});
        setState(newIssues);
    };
const $0471f3f4df57179c$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
        if (issuesWithConfigurations.length === 0) return;
        const newIssues = {};
        issuesWithConfigurations.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
    };
const $0471f3f4df57179c$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfiguration = getState()[issueKey];
        if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: {
                    ...getState()[issueKey][fieldKey],
                    ...fieldConfiguration
                }
            }
        });
    };
const $0471f3f4df57179c$var$actions = {
    setIssueConfig: $0471f3f4df57179c$var$setIssueConfig,
    setIssuesConfig: $0471f3f4df57179c$var$setIssuesConfig,
    mergeIssueConfig: $0471f3f4df57179c$var$mergeIssueConfig,
    mergeIssuesConfig: $0471f3f4df57179c$var$mergeIssuesConfig,
    setFieldConfigValue: $0471f3f4df57179c$var$setFieldConfigValue
};
// this is a global state
const $0471f3f4df57179c$var$store = (0, $7JoAD.createStore)({
    name: 'issue-field-config',
    initialState: {},
    actions: $0471f3f4df57179c$var$actions
});
const $0471f3f4df57179c$var$getIssueFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
const $0471f3f4df57179c$export$52f51db4e2b3da57 = (0, $7JoAD.createHook)($0471f3f4df57179c$var$store, {
    selector: $0471f3f4df57179c$var$getIssueFieldConfig
});
const $0471f3f4df57179c$var$getFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey] : null;
});
const $0471f3f4df57179c$var$getFieldConfigWithLabel = (0, $dGvGJ.createSelector)($0471f3f4df57179c$var$getFieldConfig, (fieldConfig)=>{
    if (fieldConfig?.title === undefined) return fieldConfig;
    return {
        ...fieldConfig,
        label: fieldConfig.title
    };
});
const $0471f3f4df57179c$var$getFieldOptionsOverrides = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
});
const $0471f3f4df57179c$export$f9beb98c7488fd61 = (0, $7JoAD.createHook)($0471f3f4df57179c$var$store, {
    selector: $0471f3f4df57179c$var$getFieldConfig
});
const $0471f3f4df57179c$export$314199caf05d245 = (0, $7JoAD.createHook)($0471f3f4df57179c$var$store, {
    selector: null
});
const $0471f3f4df57179c$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...issueKeyFieldConfigurationWithOverrides,
                [fieldKey]: {
                    ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                    ...fieldConfigOverrides
                }
            }
        });
    };
const $0471f3f4df57179c$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [issueKey]: undefined
        });
    };
const $0471f3f4df57179c$var$overridesActions = {
    setFieldConfigOverridesValue: $0471f3f4df57179c$var$setOverrides,
    resetOverridesStore: $0471f3f4df57179c$var$resetOverridesStore
};
// Store contains overrides to the field config. It is used by UI modifications to override field config properties by apps.
// UI modifications is a Forge extension point providing apps JS API to override field's properties: name, description, isEditable
// and limit visibility of select fields options.
const $0471f3f4df57179c$var$overridesStore = (0, $7JoAD.createStore)({
    name: 'issue-field-overrides',
    initialState: {},
    actions: $0471f3f4df57179c$var$overridesActions
});
const $0471f3f4df57179c$export$ff357cf5a96ec0c6 = (0, $7JoAD.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getIssueFieldConfig
});
const $0471f3f4df57179c$export$6e41e9c34587d557 = (0, $7JoAD.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldConfig
});
const $0471f3f4df57179c$export$e704d739927bd1d6 = (0, $7JoAD.createStateHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldConfigWithLabel
});
const $0471f3f4df57179c$export$d94ae842140da412 = (0, $7JoAD.createActionsHook)($0471f3f4df57179c$var$overridesStore);
const $0471f3f4df57179c$export$bfea9bb9bad7bc8f = (0, $7JoAD.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldOptionsOverrides
});
const $0471f3f4df57179c$var$getIsFieldBusySelector = (state, args)=>{
    const { fieldId: fieldId, issueKey: issueKey } = args;
    return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
};
const $0471f3f4df57179c$export$982ff1008c2e2780 = (0, $7JoAD.createStateHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getIsFieldBusySelector
});

});


parcelRegister("3fAi8", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $ddbc380ab4ee430c$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $ddbc380ab4ee430c$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useFieldValuesForIssues", () => $ddbc380ab4ee430c$export$ac289b84121829df);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $ddbc380ab4ee430c$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $ddbc380ab4ee430c$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $ddbc380ab4ee430c$export$612d9bcb0c9d8976);

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

var $7JoAD = parcelRequire("7JoAD");
const $ddbc380ab4ee430c$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $ddbc380ab4ee430c$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $ddbc380ab4ee430c$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $ddbc380ab4ee430c$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $ddbc380ab4ee430c$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState()[issueKey], fields)
        });
    };
const $ddbc380ab4ee430c$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
    };
const $ddbc380ab4ee430c$var$actions = {
    setFieldValue: $ddbc380ab4ee430c$var$setFieldValue,
    getFieldValue: $ddbc380ab4ee430c$var$getFieldValue,
    setIssue: $ddbc380ab4ee430c$var$setIssue,
    mergeIssue: $ddbc380ab4ee430c$var$mergeIssue,
    setIssues: $ddbc380ab4ee430c$var$setIssues,
    mergeIssues: $ddbc380ab4ee430c$export$11aa02e14fdf7753
};
// this is a global store
const $ddbc380ab4ee430c$var$store = (0, $7JoAD.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $ddbc380ab4ee430c$var$actions
});
const $ddbc380ab4ee430c$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$ddbc380ab4ee430c$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $ddbc380ab4ee430c$var$getAllFields = (state, issueKey)=>state[issueKey];
const $ddbc380ab4ee430c$export$b79fae7fbe3ac392 = (0, $7JoAD.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValueSelector
});
const $ddbc380ab4ee430c$export$25b73e671fe7a8fa = (0, $7JoAD.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getAllFields
});
const $ddbc380ab4ee430c$export$ac289b84121829df = (0, $7JoAD.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector
});
const $ddbc380ab4ee430c$export$915cdeec521b54f7 = (0, $7JoAD.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector
});
const $ddbc380ab4ee430c$export$4e5f1f4ed08d155e = (0, $7JoAD.createSubscriber)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValueSelector
});
const $ddbc380ab4ee430c$var$useFieldValueStoreActions = (0, $7JoAD.createHook)($ddbc380ab4ee430c$var$store, {
    selector: null
});
const $ddbc380ab4ee430c$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $ddbc380ab4ee430c$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $5uXOq.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});

parcelRegister("58K4A", function(module, exports) {

$parcel$export(module.exports, "Card", () => $fc23183dae006f40$export$60332b2344f7fe41);
$parcel$export(module.exports, "CardDropIndicator", () => $fc23183dae006f40$export$5a1a2d64cf6af79f);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $8Rkzz = parcelRequire("8Rkzz");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $b8gJu = parcelRequire("b8gJu");

var $fClFb = parcelRequire("fClFb");

var $3Lg0k = parcelRequire("3Lg0k");

var $gRpCe = parcelRequire("gRpCe");
const $fc23183dae006f40$export$60332b2344f7fe41 = ({ id: id, issue: issue, parent: parent, assignee: assignee, status: status, menu: menu, cover: cover, dateFormat: dateFormat, draggableIndex: draggableIndex, isDraggable: isDraggable, isDone: isDone = false, isSelected: isSelected = false, isLoading: isLoading = false, isFlagged: isFlagged = false, isFlexible: isFlexible = false, isPlaceholder: isPlaceholder = false, shouldShowParent: shouldShowParent = false, shouldShowRipple: shouldShowRipple = false, shouldRenderCardType: shouldRenderCardType = true, shouldFocus: shouldFocus = false, persistActions: persistActions = false, highlightTextOnCard: highlightTextOnCard = '', highlightLabelsOnCard: highlightLabelsOnCard = [], onClick: onClickProp, onEnterPress: onEnterPressProp, onMouseDown: onMouseDownProp, onMouseUp: onMouseUp = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onRippleEnd: onRippleEnd = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSizeChange: onSizeChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onFocus: onFocusProp, onBlur: onBlur, renderEstimateField: renderEstimateField, renderIssueParentField: renderIssueParentField, renderSummary: renderSummary, renderAssignee: renderAssignee, renderIssueLinksIndicator: renderIssueLinksIndicator, CustomContextMenu: CustomContextMenu, renderCustomMenu: renderCustomMenu, isCMPBoard: isCMPBoard = false, isIPBoard: isIPBoard = false, selectedCardIds: selectedCardIds = [], cardRef: cardRefProp, CardPreview: CardPreview, hasCompactIssueType: hasCompactIssueType, isDroppableOnCard: isDroppableOnCard, renderIssueLinksStats: renderIssueLinksStats, showDaysInColumn: showDaysInColumn, showIssueKey: showIssueKey, showEstimate: showEstimate, showPriority: showPriority, showDevelopment: showDevelopment, showDueDate: showDueDate, showAssignee: showAssignee, showLabels: showLabels, showCardExtraFields: showCardExtraFields, boardType: boardType })=>{
    const cardContainerRef = (0, $5uXOq.useRef)(null);
    const internalCardRef = (0, $5uXOq.useRef)(null);
    const cardRef = cardRefProp || internalCardRef;
    const { dragPreview: dragPreview, closestEdge: closestEdge } = (0, $gRpCe.useDraggableCard)({
        isDraggable: isDraggable ?? true,
        elementRef: (0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements') ? cardContainerRef : cardRef,
        cardId: id,
        cardIndex: draggableIndex,
        columnId: issue.columnId,
        swimlaneId: issue.swimlaneId,
        CardPreview: CardPreview,
        shouldShowRipple: shouldShowRipple,
        isDroppable: isDroppableOnCard
    });
    (0, $5uXOq.useEffect)(()=>{
        // In a virtualised environment we can't guarantee that these components
        // will exist when we focus them. As a result, we need to fire the focus
        // function on mount for scenarios where we focus an off screen element
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (shouldFocus && cardRef.current !== null && document.activeElement !== cardRef.current) cardRef.current.focus();
    }, [
        cardRef,
        shouldFocus
    ]);
    let mouseDownTarget = null;
    const onClick = (0, $5uXOq.useCallback)((e, externalAction)=>{
        e.stopPropagation();
        // best practice to use for react-beautiful-dnd (https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-use-dom-events.md)
        if (e.defaultPrevented === true && e.currentTarget?.nodeName !== 'A') return;
        // Prevent (eg) mouse down on text-field within card, then mouse up on card firing onClick unexpectedly
        if (mouseDownTarget && e.target !== mouseDownTarget) return;
        const withCmd = e.ctrlKey || e.metaKey;
        const withShift = e.shiftKey;
        onClickProp?.(id, withCmd, withShift, externalAction);
    }, [
        id,
        mouseDownTarget,
        onClickProp
    ]);
    const onMouseDown = (e)=>{
        // Clear any text selection to prevent unexpected dragging behaviour
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.getSelection()?.removeAllRanges();
        mouseDownTarget = e.target;
        onMouseDownProp?.();
    };
    const onKeyDown = (e)=>{
        if (e.key === 'Enter') {
            e.stopPropagation();
            onEnterPressProp?.(id);
        }
    };
    const onFocus = (0, $5uXOq.useCallback)((e)=>{
        // Ensure the focus event originated from the card container,
        // and didn't bubble up from an element within it
        if (!onFocusProp || cardRef.current === null || e.target !== cardRef.current) return;
        onFocusProp(e);
    }, [
        cardRef,
        onFocusProp
    ]);
    const cardProps = {
        id: id,
        issue: issue,
        shouldShowParent: shouldShowParent,
        parent: parent,
        assignee: assignee,
        isDone: isDone,
        isSelected: isSelected,
        isFlagged: isFlagged,
        isFlexible: isFlexible,
        shouldRenderCardType: shouldRenderCardType,
        highlightTextOnCard: highlightTextOnCard,
        highlightLabelsOnCard: highlightLabelsOnCard,
        menu: menu,
        cover: cover,
        dateFormat: dateFormat,
        isLoading: isLoading,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        cardRef: cardRef,
        ...(0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements') && {
            cardContainerRef: cardContainerRef
        },
        onSizeChange: onSizeChange,
        isPlaceholder: isPlaceholder,
        renderEstimateField: renderEstimateField,
        renderIssueParentField: renderIssueParentField,
        renderSummary: renderSummary,
        renderIssueLinksIndicator: renderIssueLinksIndicator,
        renderAssignee: renderAssignee,
        isCMPBoard: isCMPBoard,
        isIPBoard: isIPBoard,
        CustomContextMenu: CustomContextMenu,
        renderCustomMenu: renderCustomMenu,
        selectedCardIds: selectedCardIds,
        status: status,
        hasCompactIssueType: hasCompactIssueType,
        renderIssueLinksStats: renderIssueLinksStats,
        persistActions: persistActions,
        showDaysInColumn: showDaysInColumn,
        showIssueKey: showIssueKey,
        showEstimate: showEstimate,
        showPriority: showPriority,
        showDevelopment: showDevelopment,
        showDueDate: showDueDate,
        showAssignee: showAssignee,
        showLabels: showLabels,
        showCardExtraFields: showCardExtraFields,
        boardType: boardType
    };
    // @ts-expect-error - Type '{ onSizeChange: () => void; isPlaceholder: boolean; renderEstimateField: (() => ReactNode) | undefined; renderIssueParentField: (() => ReactNode) | undefined; renderSummary: RenderSummary | undefined; ... 42 more ...; key: string; }' is not assignable to type 'Pick<Pick<Omit<{ ref?: unknown; }, "intl">, "ref"> & InexactPartial<Pick<Omit<{ ref?: unknown; }, "intl">, never>> & InexactPartial<Pick<{ isDragging: boolean; isLoading: boolean; ... 41 more ...; shouldShowLozengeForOptimisticParent: boolean; }, "status" | ... 42 more ... | "shouldShowLozengeForOptimisticParent">> ...'.
    const jiraCardContents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fClFb.default), {
        key: `card-${issue.key}-card`,
        ...cardProps
    });
    if (!isDraggable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc23183dae006f40$export$8a23e74e5cf3ca41, {
        id: `card-${issue.key}`,
        key: `card-${issue.key}-container`,
        "data-testid": "platform-board-kit.ui.card.card",
        "aria-describedby": `card-description-${issue.key}`,
        optimistic: false
    }, jiraCardContents);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc23183dae006f40$export$8a23e74e5cf3ca41, {
        id: `card-${issue.key}`,
        key: `card-${issue.key}-container`,
        "data-component-selector": (0, $b8gJu.CARD_CONTAINER_SELECTOR_NAME),
        optimistic: false,
        isProcessing: false,
        "data-testid": "platform-board-kit.ui.card.card",
        onClick: onClick,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        "aria-describedby": `card-description-${issue.key}`,
        tabIndex: -1
    }, shouldShowRipple ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Lg0k.default), {
        onAnimationEnd: onRippleEnd
    }, jiraCardContents) : jiraCardContents, closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc23183dae006f40$export$5a1a2d64cf6af79f, {
        edge: closestEdge
    }), dragPreview);
};
const $fc23183dae006f40$export$5a1a2d64cf6af79f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { edge: edge, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1e0c1txw _1bah1y6m _1ltvidpf _1xi2idpf _4t3iyh40 _1pbycs5v _bfhk1r2e _lcxvglyw _1cs8stnw _1kt9b3bt _cfu11txw _6w5g1h6o _kfgt1y44 _1mp41y44 _qnecx0bf _rfx31ssb _14h8oh42",
            __cmplp.edge === 'bottom' && "_94n5j39m",
            __cmplp.edge === 'top' && "_154ij39m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $fc23183dae006f40$var$CardContainerControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "smzlwk-0"
})((props)=>({
        position: 'relative',
        margin: `${"var(--ds-space-025, 2px)"} 0`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginTop: props.optimistic ? 0 : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props.isProcessing ? 'none' : 'block'
    }));
const $fc23183dae006f40$var$CardContainerExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { optimistic: optimistic, isProcessing: isProcessing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _18s8x7n9",
            __cmplp.optimistic && "_19pkidpf",
            __cmplp.isProcessing ? "_1e0cglyw" : "_1e0c1ule",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $fc23183dae006f40$export$8a23e74e5cf3ca41 = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $fc23183dae006f40$var$CardContainerExperiment, $fc23183dae006f40$var$CardContainerControl);

});
parcelRegister("fClFb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1573e5e4e2e6fae4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");

var $8U6zd = parcelRequire("8U6zd");

var $3oUqw = parcelRequire("3oUqw");

var $3bDjY = parcelRequire("3bDjY");

var $gULOk = parcelRequire("gULOk");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $az4zD = parcelRequire("az4zD");

var $fQeLt = parcelRequire("fQeLt");

var $9JGeS = parcelRequire("9JGeS");

var $hOvWQ = parcelRequire("hOvWQ");

var $cfZh8 = parcelRequire("cfZh8");

var $f5Alb = parcelRequire("f5Alb");

var $itzcE = parcelRequire("itzcE");

var $akGDz = parcelRequire("akGDz");

var $dHqFt = parcelRequire("dHqFt");

var $l1jvZ = parcelRequire("l1jvZ");

var $20vaL = parcelRequire("20vaL");

var $9yMbF = parcelRequire("9yMbF");

var $2OMDV = parcelRequire("2OMDV");
var $iXVV6 = parcelRequire("iXVV6");


var $b8gJu = parcelRequire("b8gJu");

var $gjUWL = parcelRequire("gjUWL");
const $1573e5e4e2e6fae4$var$DropdownMenuWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('dropdown-menu', {
    onOpenChange: 'openChanged'
})((0, $BLPHT.default)); // eslint-disable-next-line jira/react/no-class-components
class $1573e5e4e2e6fae4$var$JiraCardContents extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            isDragging: false,
            isLoading: false,
            isDone: false,
            isSelected: false,
            isFlagged: false,
            isFlexible: false,
            isDisabled: false,
            hasTransitioned: false,
            shouldShowParent: false,
            shouldRenderCardType: true,
            persistActions: false,
            parent: null,
            assignee: null,
            highlightTextOnCard: '',
            highlightLabelsOnCard: [],
            labels: null,
            menu: null,
            selectedCardIds: [],
            CustomContextMenu: null,
            renderCustomMenu: null,
            cover: null,
            color: null,
            customFields: null,
            children: null,
            dateFormat: null,
            renderIssueParentField: null,
            renderSummary: null,
            renderIssueLinksIndicator: null,
            renderAssignee: null,
            renderEstimate: null,
            isCMPBoard: false,
            status: null,
            onSizeChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onEnterPress: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            showDaysInColumn: true,
            showDueDate: true,
            showIssueKey: true,
            showEstimate: true,
            showPriority: true,
            showDevelopment: true,
            showAssignee: true,
            showLabels: true,
            showCardExtraFields: null,
            shouldShowLozengeForOptimisticParent: false
        };
    }
    componentDidMount() {
        if (false) return;
        this.mounted = true; // Note whenever we drag or modify a list we'll fire this. The plus side of having it here is
        // when we render a proper card instead of the scrolling placeholder we'll store the real height in the
        // cache for our future placeholders
        (this.props.onSizeChange ?? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))))();
    }
    componentDidUpdate() {
        if (false) return;
         // Notify listeners of any update to this component. The CellCacheMeasurer remeasure
        // is faster than doing a deepEquals here.
        // NOTE: This actually gets procced via onFocus for unrelated cards due to some re-render shinanigans.
        this.notifyListenersOfSizeChange();
    }
    componentWillUnmount() {
        this.mounted = false;
        if (this.requestAnimationFrameId != null) cancelAnimationFrame(this.requestAnimationFrameId);
    }
    notifyListenersOfSizeChange() {
        (this.props.onSizeChange ?? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))))();
    }
    renderDevStatus() {
        const { issue: { id: id, devStatusField: devStatusField }, showDevelopment: showDevelopment } = this.props;
        if (!showDevelopment) return null;
        return devStatusField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5Alb.default), {
            issueId: id,
            key: `dev-status-${devStatusField.activity}-${devStatusField.count}`,
            type: devStatusField.activity,
            deploymentDetails: devStatusField.deploymentDetails
        }) : null;
    }
    renderIssueParent() {
        const { shouldShowParent: shouldShowParent, parent: parent, renderIssueParentField: renderIssueParentField } = this.props;
        if (!shouldShowParent || !parent) return null;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(renderIssueParentField)) return renderIssueParentField();
        return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            tag: $1573e5e4e2e6fae4$var$TooltipContainer,
            content: parent.summary
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1jvZ.CardLozenge), {
            color: parent.color
        }, parent.summary)));
    }
    renderChildIssuesMetadata() {
        const { issue: { numCompleteChildren: numCompleteChildren, numTotalChildren: numTotalChildren } } = this.props;
        if (numTotalChildren == null || numTotalChildren === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9JGeS.CardChildIssues), {
            key: `card-children-${numCompleteChildren}-${numTotalChildren}`,
            complete: numCompleteChildren,
            total: numTotalChildren
        });
    }
    renderLabels() {
        const { issue: { labels: labels }, highlightLabelsOnCard: highlightLabelsOnCard, isCMPBoard: isCMPBoard, showLabels: showLabels } = this.props;
        const shouldShowLabels = showLabels && !isCMPBoard;
        return labels && shouldShowLabels && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(labels) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHqFt.CardLabels), {
            labels: labels,
            highlight: highlightLabelsOnCard,
            isCMPBoard: isCMPBoard
        });
    }
    renderEstimate() {
        const { issue: { estimate: estimate, estimateUnit: estimateUnit }, showEstimate: showEstimate } = this.props;
        if (!showEstimate) return null;
        const { renderEstimateField: renderEstimateField } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(renderEstimateField)) return renderEstimateField();
        if (estimate == null) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $akGDz.CardEstimate), {
            key: `card-estimate-${estimate}`,
            estimate: estimate,
            units: estimateUnit ?? (0, $gjUWL.default).storyPointsUnitsPluralisedLabel
        });
    }
    renderPriority() {
        const { issue: { priority: priority }, showPriority: showPriority } = this.props;
        if (!showPriority) return null;
        return priority && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $20vaL.CardPriority), {
            key: `card-priority-${priority.name}`,
            name: priority.name,
            uri: priority.iconUrl
        });
    }
    renderDueDate() {
        const { issue: issue, isDone: isDone, dateFormat: dateFormat, showDueDate: showDueDate } = this.props;
        return showDueDate && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue.dueDate) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $itzcE.CardDueDate), {
            dateFormat: dateFormat,
            dueDate: issue.dueDate,
            isCompleted: isDone
        }) : null;
    }
    renderDaysInColumn() {
        const { issue: { daysInColumn: daysInColumn }, showDaysInColumn: showDaysInColumn } = this.props;
        return daysInColumn != null && daysInColumn > 1 && Boolean(showDaysInColumn) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cfZh8.CardDaysInColumn), {
            days: daysInColumn
        }) : null;
    }
    renderIcons() {
        const { boardType: boardType, renderIssueLinksIndicator: renderIssueLinksIndicator } = this.props;
        const isIPBoard = boardType === (0, $b8gJu.BoardView).INCREMENT_PLANNING_BOARD;
        if (isIPBoard) return [
            this.renderEstimate(),
            ...renderIssueLinksIndicator ? [
                renderIssueLinksIndicator()
            ] : [
                undefined
            ]
        ];
        return [
            this.renderEstimate(),
            this.renderDevStatus(),
            this.renderChildIssuesMetadata(),
            this.renderDaysInColumn(),
            this.renderPriority()
        ];
    }
    renderStatus() {
        const { status: status } = this.props;
        if (!status) return null;
        const statusField = {
            id: status.id.toString(),
            name: status.name,
            statusCategory: {
                id: (0, $gULOk.categoryIdForStatusCategory)(status.category)
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1573e5e4e2e6fae4$var$StatusContainer, {
            "data-testid": "platform-board-kit.ui.card.jira-card-contents.status"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            tag: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            $1573e5e4e2e6fae4$var$TooltipContainer,
            content: statusField.name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozenge), {
            value: statusField
        })));
    }
    render() {
        const { issue: issue, assignee: assignee, isSelected: isSelected, isDragging: isDragging, isFlagged: isFlagged, isFlexible: isFlexible, menu: menu, highlightTextOnCard: highlightTextOnCard, shouldRenderCardType: shouldRenderCardType, cover: cover, isDone: isDone, isLoading: isLoading, onBlur: onBlur, cardRef: cardRef, cardContainerRef: cardContainerRef, onSizeChange: onSizeChange, onClick: onClick, isDisabled: isDisabled, children: children, renderSummary: renderSummary, renderAssignee: renderAssignee, isCMPBoard: isCMPBoard, status: status, hasCompactIssueType: hasCompactIssueType, selectedCardIds: selectedCardIds, CustomContextMenu: CustomContextMenu, renderIssueLinksStats: renderIssueLinksStats, persistActions: persistActions, showIssueKey: showIssueKey, showCardExtraFields: showCardExtraFields, showAssignee: showAssignee, boardType: boardType } = this.props;
        const isIPBoard = this.props.boardType === (0, $b8gJu.BoardView).INCREMENT_PLANNING_BOARD;
        const { shouldRenderMenu: shouldRenderMenu, isMenuOpen: isMenuOpen } = this.state;
        if (boardType === (0, $b8gJu.BoardView).JSW_BOARD && persistActions && (0, $4R6GH.fg)('jsw_cmp_card_covers_changeboarding')) this.setShouldRenderMenu();
        const onContextMenuChange = (isContextMenuOpen)=>this.setState({
                shouldMenuOpen: !isContextMenuOpen
            });
        const typeUrl = issue.typeUrl !== undefined ? issue.typeUrl : null;
        const contextMenu = shouldRenderMenu ? menu : null;
        const dropdownMenu = shouldRenderMenu ? this.renderMenu() : null;
        const cardContents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yMbF.Card), {
            id: issue.id,
            summary: issue.summary,
            cardKey: showIssueKey ? issue.key : null,
            typeName: shouldRenderCardType ? issue.typeName : null,
            typeUri: shouldRenderCardType ? typeUrl : null,
            avatarUri: showAssignee ? assignee && assignee.avatarUrl : null,
            avatarName: showAssignee ? assignee && assignee.displayName : null,
            isSelected: isSelected || isDragging,
            isFlagged: isFlagged,
            isFlexible: isFlexible,
            isDone: isDone,
            actions: dropdownMenu,
            cover: cover,
            color: issue.cardColor,
            customFields: issue.customFields?.filter((field)=>showCardExtraFields?.[field.id] !== false),
            isLoading: isLoading,
            icons: this.renderIcons(),
            highlightText: highlightTextOnCard ? [
                highlightTextOnCard
            ] : undefined,
            onClick: onClick,
            onFocus: this.onFocus,
            onBlur: onBlur,
            onMouseEnter: this.setShouldRenderMenu,
            onSizeChange: onSizeChange,
            isDisabled: isDisabled,
            cardRef: cardRef,
            cardContainerRef: cardContainerRef,
            persistActions: persistActions || isMenuOpen,
            renderSummary: renderSummary,
            isCMPBoard: isCMPBoard,
            isIPBoard: isIPBoard,
            status: status,
            hasCompactIssueType: hasCompactIssueType,
            hasScenarioChanges: issue.hasScenarioChanges,
            renderIssueLinksStats: renderIssueLinksStats,
            renderAssignee: showAssignee ? renderAssignee : undefined,
            fixVersions: issue.fixVersions
        }, this.renderIssueParent(), children, status && this.renderStatus(), this.renderLabels(), !isIPBoard && this.renderDueDate());
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(CustomContextMenu)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomContextMenu, {
            appearance: (0, $d9cdb1c71f9dbf8c$export$bb79bd28759ee895),
            issueId: issue.id,
            issueKey: issue.key,
            selectedCardIds: selectedCardIds
        }, cardContents);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hOvWQ.default), {
            items: contextMenu,
            onContextMenuChange: onContextMenuChange
        }, cardContents);
    }
    constructor(...args){
        super(...args);
        this.state = {
            shouldMenuOpen: true,
            shouldRenderMenu: false,
            isMenuOpen: false
        };
        this.mounted = false;
        this.requestAnimationFrameId = null;
        this.setShouldRenderMenu = ()=>{
            this.setState({
                shouldRenderMenu: true
            });
        };
        this.onFocus = (event)=>{
            this.props.onFocus && this.props.onFocus(event);
            this.setShouldRenderMenu();
        };
        this.renderMenu = ()=>{
            const { menu: menu, issue: { summary: summary }, intl: { formatMessage: formatMessage }, renderCustomMenu: renderCustomMenu } = this.props;
            const { shouldMenuOpen: shouldMenuOpen } = this.state;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(renderCustomMenu)) return renderCustomMenu();
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(menu) || !shouldMenuOpen) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1573e5e4e2e6fae4$var$DropdownMenuWithAnalytics, {
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                        ...props,
                        ref: triggerRef,
                        iconBefore: (0, $4R6GH.fg)('tnk-1614-visual-refresh-boardkit-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
                            spacing: "spacious",
                            label: "Menu",
                            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))),
                            color: "var(--ds-icon, #44546F)"
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))), {
                            label: "Menu"
                        }),
                        "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gjUWL.default).actionsMenuTriggerLabelIssueTermRefresh : (0, $gjUWL.default).actionsMenuTriggerLabel, {
                            summary: summary
                        })
                    }),
                spacing: "compact",
                placement: "bottom-end",
                onOpenChange: ({ isOpen: isOpen })=>{
                    this.setState({
                        isMenuOpen: isOpen
                    });
                }
            }, menu));
        };
    }
}
var // @ts-expect-error - Argument of type 'typeof JiraCardContents' is not assignable to parameter of type 'ComponentType<WithIntlProvided<Props>> & typeof JiraCardContents'.
$1573e5e4e2e6fae4$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($1573e5e4e2e6fae4$var$JiraCardContents);
const $1573e5e4e2e6fae4$var$TooltipContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1573e5e4e2e6fae4$var$StatusContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1y6m _stfgagmp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fQeLt", function(module, exports) {

$parcel$export(module.exports, "StatusLozenge", () => $e065d549cea5a7d0$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "StatusLozengeWithDropdownIndicator", () => $e065d549cea5a7d0$export$9f5070a985b0679b);

var $5uXOq = parcelRequire("5uXOq");

var $17mYr = parcelRequire("17mYr");
const $e065d549cea5a7d0$export$f72db4ad1e9b3e6d = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17mYr.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false
    });
};
const $e065d549cea5a7d0$export$9f5070a985b0679b = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17mYr.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        shouldShowDropdownIndication: true
    });
};

});
parcelRegister("17mYr", function(module, exports) {

$parcel$export(module.exports, "TEST_ID_PREFIX", () => $390c5e7bc7d9c77b$export$9cbc201c09a37b3f);
$parcel$export(module.exports, "StatusLozenge", () => $390c5e7bc7d9c77b$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "WrappedStatusLozenge", () => $390c5e7bc7d9c77b$export$69ea4907eefa8e7b);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ // eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $9yOBd = parcelRequire("9yOBd");

var $5LWLA = parcelRequire("5LWLA");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");


var $aQhlk = parcelRequire("aQhlk");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $kGDYq = parcelRequire("kGDYq");

var $5Ax7l = parcelRequire("5Ax7l");

var $4YeLF = parcelRequire("4YeLF");
const $390c5e7bc7d9c77b$export$9cbc201c09a37b3f = 'issue.fields.status.common.ui.status-lozenge.';
const $390c5e7bc7d9c77b$var$CustomChevronDownGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: 12,
        height: 12,
        viewBox: "5 5 13 13"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $390c5e7bc7d9c77b$var$StatusLozengeNew = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusContentWrapper, {
        "data-testid": `${$390c5e7bc7d9c77b$export$9cbc201c09a37b3f}${statusCategory.id}`
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ax7l.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozengeContentWrapper, null, name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $390c5e7bc7d9c77b$var$CustomChevronDownGlyph,
        label: ""
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ax7l.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, name)), hasHoverState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $390c5e7bc7d9c77b$var$hoverOverlayStyles
    }));
const $390c5e7bc7d9c77b$var$WrappedStatusLozengeNew = (props)=>{
    const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, ...others } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        xcss: (0, $4R6GH.fg)('jira_nav4_eap_drop_2') ? $390c5e7bc7d9c77b$var$pressableStyles : $390c5e7bc7d9c77b$var$pressableStylesOld,
        ref: targetRef,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        ...(0, $4R6GH.fg)('issue-jiv-18579-status-field-interaction-name') ? {
            // When cleaning up we will need to disable the `jira/ufo/valid-labels` lint rule
            // because for this particular interaction we only want to track
            // opening the status popup.
            interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusLozengeNew, {
        ...others,
        isEditable: isEditable
    }));
};
const $390c5e7bc7d9c77b$var$EditableLozenge = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YeLF.LozengeOld), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozengeContentWrapper, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $390c5e7bc7d9c77b$var$CustomChevronDownGlyph,
        label: ""
    })));
const $390c5e7bc7d9c77b$var$StatusLozengeOld = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, targetRef: targetRef, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozenge, {
        hasHoverState: hasHoverState,
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusContentWrapper, {
        ref: targetRef,
        "data-testid": `${$390c5e7bc7d9c77b$export$9cbc201c09a37b3f}${statusCategory.id}`
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$EditableLozenge, null, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YeLF.LozengeOld), null, name)));
const $390c5e7bc7d9c77b$var$WrappedStatusLozengeOld = (props)=>{
    const { ariaLabel: ariaLabel, error: error, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, ...other } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        ref: targetRef,
        appearance: "subtle",
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: 'transparent',
                    margin: 0,
                    width: 'auto',
                    height: 'auto',
                    padding: 0,
                    border: `2px solid ${error ? `var(--ds-border-danger, ${(0, $829f609a65d26a98$exports).R300})` : 'transparent'}`,
                    borderRadius: '5px',
                    ...isEditable === true ? undefined : {
                        cursor: 'auto'
                    },
                    outline: 0,
                    boxShadow: `0 0 0 2px ${isOpen === true ? `var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B200})` : 'transparent'}`,
                    '& > span': {
                        margin: 0
                    },
                    '&:focus, &:focus-within': {
                        boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B200})`}`
                    }
                },
                spinnerStyles: spinnerStyles
            };
        },
        ...(0, $4R6GH.fg)('issue-jiv-18579-status-field-interaction-name') ? {
            // When cleaning up we will need to disable the `jira/ufo/valid-labels` lint rule
            // because for this particular interaction we only want to track
            // opening the status popup.
            interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined
        } : {
            interactionName: 'auto-generated.jira-issue-field-status.common.ui.status-lozenge.button'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusLozengeOld, {
        ...other,
        isEditable: isEditable
    }));
};
const $390c5e7bc7d9c77b$export$f72db4ad1e9b3e6d = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $390c5e7bc7d9c77b$var$StatusLozengeNew, $390c5e7bc7d9c77b$var$StatusLozengeOld);
const $390c5e7bc7d9c77b$export$69ea4907eefa8e7b = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $390c5e7bc7d9c77b$var$WrappedStatusLozengeNew, $390c5e7bc7d9c77b$var$WrappedStatusLozengeOld); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StyledLozenge = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "wv585u-0"
})`display:flex;align-items:center;> div{display:flex;line-height:initial;outline:0;> span{padding:${"var(--ds-space-025, 2px)"} 0;vertical-align:text-bottom;color:${(props)=>// eslint-disable-next-line no-nested-ternary
    props.isDisabled ? (0, $aQhlk.disabledColor).text : !(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual_refresh-status-text-color-changed') ? (0, $aQhlk.textColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]] : (0, $aQhlk.textColorOld)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};background-color:${(props)=>props.isDisabled ? (0, $aQhlk.disabledColor).bg : (0, $aQhlk.bgColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};${(props)=>props.hasHoverState ? `&:hover {
                        color: ${props.isDisabled ? (0, $aQhlk.disabledColor).text : (0, $aQhlk.textHoverColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};
                        background-color: ${props.isDisabled ? (0, $aQhlk.disabledColor).bg : (0, $aQhlk.bgHoverColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};
                    }` : ''};${(props)=>props.isDisabled && (0, $47bDC.css)({
        pointerEvents: 'none'
    })}}}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StyledLozengeContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o",
            (0, $kGDYq.isTabularGridFieldsEnabled)() ? "_1e0c1bgi" : "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StatusContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            (0, $kGDYq.isTabularGridFieldsEnabled)() ? "_1bsb1osq" : "_1bsb1wug",
            __cmplp.className
        ])
    });
});
const $390c5e7bc7d9c77b$var$pressableStylesOld = (0, $8CUq3.xcss)({
    border: 'none',
    padding: 'space.0',
    borderRadius: '3px',
    background: 'transparent',
    position: 'relative',
    width: '100%'
});
const $390c5e7bc7d9c77b$var$pressableStyles = (0, $8CUq3.xcss)({
    border: 'none',
    padding: 'space.0',
    borderRadius: '3px',
    background: 'transparent',
    position: 'relative',
    maxWidth: '100%'
});
const $390c5e7bc7d9c77b$var$hoverOverlayStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    inset: '0',
    borderRadius: '3px',
    marginRight: 'space.025',
    ':hover': {
        opacity: 0.3,
        backgroundColor: 'color.background.inverse.subtle'
    }
});

});
parcelRegister("aQhlk", function(module, exports) {

$parcel$export(module.exports, "statusCategoryToThemeMap", () => $58bc751e3aa4b554$export$d9e35f42afe1e488);
$parcel$export(module.exports, "bgColor", () => $58bc751e3aa4b554$export$7dcbec377a25efc6);
$parcel$export(module.exports, "textColor", () => $58bc751e3aa4b554$export$32f78bffcd82ff28);
$parcel$export(module.exports, "textColorOld", () => $58bc751e3aa4b554$export$26ac04004fa4ead4);
$parcel$export(module.exports, "bgHoverColor", () => $58bc751e3aa4b554$export$69fdf3ba928b4c77);
$parcel$export(module.exports, "textHoverColor", () => $58bc751e3aa4b554$export$99ec0cf2cf1b2082);
$parcel$export(module.exports, "disabledColor", () => $58bc751e3aa4b554$export$b70f10fc4a6ba453);

const $58bc751e3aa4b554$export$61137dce61763ec3 = 'default';
const $58bc751e3aa4b554$export$132676d06d92ad48 = 'success';
const $58bc751e3aa4b554$export$5c1f3b72419aa125 = 'inprogress';
const $58bc751e3aa4b554$export$d9e35f42afe1e488 = {
    '1': $58bc751e3aa4b554$export$61137dce61763ec3,
    '2': $58bc751e3aa4b554$export$61137dce61763ec3,
    '3': $58bc751e3aa4b554$export$132676d06d92ad48,
    '4': $58bc751e3aa4b554$export$5c1f3b72419aa125
};
const $58bc751e3aa4b554$export$7dcbec377a25efc6 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`,
    [$58bc751e3aa4b554$export$132676d06d92ad48]: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`
};
const $58bc751e3aa4b554$export$32f78bffcd82ff28 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
    [$58bc751e3aa4b554$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`,
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
};
const $58bc751e3aa4b554$export$26ac04004fa4ead4 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: `var(--ds-text, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
    [$58bc751e3aa4b554$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`,
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
};
const $58bc751e3aa4b554$export$69fdf3ba928b4c77 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
    [$58bc751e3aa4b554$export$132676d06d92ad48]: `var(--ds-background-success-hovered, ${(0, $829f609a65d26a98$export$a49394138f7b8e85)})`,
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: `var(--ds-background-information-hovered, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
};
const $58bc751e3aa4b554$export$99ec0cf2cf1b2082 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
    [$58bc751e3aa4b554$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
};
const $58bc751e3aa4b554$export$b70f10fc4a6ba453 = {
    bg: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`,
    text: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
};

});

parcelRegister("kGDYq", function(module, exports) {

$parcel$export(module.exports, "isTabularGridFieldsEnabled", () => $4b98d8a4e0ed63d5$export$9605b1d5fe0c238b);

var $co1wz = parcelRequire("co1wz");
const $4b98d8a4e0ed63d5$export$455240e4be839479 = 'jsw.uif.tmp.card.tabular.grid';
const $4b98d8a4e0ed63d5$export$9605b1d5fe0c238b = ()=>(0, $co1wz.ff)($4b98d8a4e0ed63d5$export$455240e4be839479, false); // </rkarki>
 // <bento>
 // </bento>

});

parcelRegister("5Ax7l", function(module, exports) {

$parcel$export(module.exports, "Lozenge", () => $bcba81c28add5d02$export$a31cbe1bf5463979);

var $5uXOq = parcelRequire("5uXOq");

var $lj8SI = parcelRequire("lj8SI");

var $aQhlk = parcelRequire("aQhlk");

const $bcba81c28add5d02$export$a31cbe1bf5463979 = ({ children: children, statusCategoryId: statusCategoryId, isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        appearance: (0, $aQhlk.statusCategoryToThemeMap)[statusCategoryId],
        isBold: true,
        ...isDisabled ? {
            style: {
                color: (0, $aQhlk.disabledColor).text,
                backgroundColor: (0, $aQhlk.disabledColor).bg
            }
        } : {}
    }, children);

});

parcelRegister("4YeLF", function(module, exports) {

$parcel$export(module.exports, "LozengeOld", () => $bbacf745a667099a$export$26089816624d22fc);
// TODO - delete this file when cleaning up visual-refresh

var $5uXOq = parcelRequire("5uXOq");
const $bbacf745a667099a$var$containerStyles = {
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    display: 'inline-block',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    maxWidth: '100%',
    padding: 0,
    textTransform: 'uppercase',
    verticalAlign: 'top'
};
const $bbacf745a667099a$var$contentStyles = {
    boxSizing: 'border-box',
    display: 'inline-block',
    maxWidth: 200,
    overflow: 'hidden',
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    width: '100%'
};
const $bbacf745a667099a$export$26089816624d22fc = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $bbacf745a667099a$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $bbacf745a667099a$var$contentStyles
    }, children));
$bbacf745a667099a$export$26089816624d22fc.displayName = 'Lozenge';

});



parcelRegister("9JGeS", function(module, exports) {

$parcel$export(module.exports, "CardChildIssues", () => $9342bd2080922354$export$34d755500cd8440e);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8uZt8 = parcelRequire("8uZt8");


var $fTggM = parcelRequire("fTggM");
const $9342bd2080922354$export$34d755500cd8440e = (props)=>{
    const { complete: complete, total: total } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (total === null || total === 0) return null;
    const message = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fTggM.default).childIssuesMetadataIssueTermRefresh : (0, $fTggM.default).childIssuesMetadata, {
        complete: complete,
        total: total
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9342bd2080922354$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8uZt8.default), {
        type: (0, $6d6eac2504286faf$export$3b43f1ca008dad23),
        label: message,
        primaryColor: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N100})`
    })));
};
var $9342bd2080922354$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $9342bd2080922354$export$34d755500cd8440e;
const $9342bd2080922354$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8uZt8", function(module, exports) {

$parcel$export(module.exports, "default", () => $72d11d6903be96d2$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $3fesp = parcelRequire("3fesp");

var $dC5iT = parcelRequire("dC5iT");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $dCm1o = parcelRequire("dCm1o");

var $6OCZm = parcelRequire("6OCZm");

const $72d11d6903be96d2$var$renderIcon = (type)=>{
    switch(type){
        case 0, $6d6eac2504286faf$export$3b43f1ca008dad23:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.ChildIssuesGlyph), null);
        case 0, $6d6eac2504286faf$export$aac403da0d127706:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.FlagGlyph), null);
        case 0, $6d6eac2504286faf$export$540a31b23d6b9abd:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.CheckGlyph), null);
        case 0, $6d6eac2504286faf$export$352da558a3a09227:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.UploadGlyph), null);
        case 0, $6d6eac2504286faf$export$178cb2e5b5fc68e8:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.BitbucketBranchesGlyph), null);
        case 0, $6d6eac2504286faf$export$a153e0417183b79:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.BitbucketCommitsGlyph), null);
        case 0, $6d6eac2504286faf$export$555f9a88a8c5f309:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.BitbucketPullrequestsGlyph), null);
        case 0, $6d6eac2504286faf$export$82a1ca282cb5e4e5:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.EmojiFrequentGlyph), null);
        case 0, $6d6eac2504286faf$export$423cd243bf1888bc:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.MoreGlyph), null);
        case 0, $6d6eac2504286faf$export$30a9be92cbb6f382:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.PersonGlyph), null);
        case 0, $6d6eac2504286faf$export$d4ee7b46933c494f:
            return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                paddingInlineEnd: "space.050",
                paddingBlock: "space.025"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fesp))), {
                label: "",
                color: "currentColor"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.DueDateGlyph), null);
        default:
            throw Error(`Invalid Icon type - ${type}`);
    }
};
const $72d11d6903be96d2$var$CardIcon = (props)=>{
    const { label: label, primaryColor: primaryColor, type: type } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($72d11d6903be96d2$var$Container, {
        role: "img",
        "aria-label": label,
        primaryColor: primaryColor
    }, $72d11d6903be96d2$var$renderIcon(type));
};
var $72d11d6903be96d2$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
 = $72d11d6903be96d2$var$CardIcon;
const $72d11d6903be96d2$var$ContainerControl = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "sc-1tuyf7k-0"
})((props)=>({
        display: 'inline-block',
        flexShrink: 0,
        lineHeight: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            verticalAlign: 'bottom',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: props.primaryColor || undefined
        }
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $72d11d6903be96d2$var$ContainerExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { primaryColor: primaryColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_yk4yla": (0, $lD23V.default)(__cmplp.primaryColor || undefined)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _1o9zidpf _vwz4kb7n _1veoyfq0 _1ksv19wz",
            __cmplp.className
        ])
    });
});
const $72d11d6903be96d2$var$Container = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $72d11d6903be96d2$var$ContainerExperiment, $72d11d6903be96d2$var$ContainerControl);

});
parcelRegister("3fesp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db9feac5032e1f6cb5923640df1c100>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $25cdfcb8bb836404$var$_UNSAFE_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25cdfcb8bb836404$var$CalendarIcon = (props)=>/*#__PURE__*/ $25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;

});

parcelRegister("6OCZm", function(module, exports) {

$parcel$export(module.exports, "ChildIssuesGlyph", () => $9f38e13816957edc$export$e45c85830644abc5);
$parcel$export(module.exports, "FlagGlyph", () => $9f38e13816957edc$export$cef8dc8280f1c02c);
$parcel$export(module.exports, "CheckGlyph", () => $9f38e13816957edc$export$50963481dc57ac5c);
$parcel$export(module.exports, "UploadGlyph", () => $9f38e13816957edc$export$330e95d855f0ff0);
$parcel$export(module.exports, "BitbucketBranchesGlyph", () => $9f38e13816957edc$export$5aa1ec710367c05);
$parcel$export(module.exports, "BitbucketCommitsGlyph", () => $9f38e13816957edc$export$4f751361dc2785a8);
$parcel$export(module.exports, "BitbucketPullrequestsGlyph", () => $9f38e13816957edc$export$314907f846d12b79);
$parcel$export(module.exports, "EmojiFrequentGlyph", () => $9f38e13816957edc$export$e6da30a8001300c0);
$parcel$export(module.exports, "MoreGlyph", () => $9f38e13816957edc$export$f291c054d6e2e898);
$parcel$export(module.exports, "PersonGlyph", () => $9f38e13816957edc$export$b59bd42a398a2b3c);
$parcel$export(module.exports, "DueDateGlyph", () => $9f38e13816957edc$export$45e4820251213456);

var $5uXOq = parcelRequire("5uXOq");
const $9f38e13816957edc$export$e45c85830644abc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7 11h10a1 1 0 011 1v1H6v-1a1 1 0 011-1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5 18v1h4v-1H5zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2H5a2 2 0 01-2-2v-1a2 2 0 012-2zm10 2v1h4v-1h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2v-1a2 2 0 012-2zM10 5v1h4V5h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2V5a2 2 0 012-2z",
        fillRule: "nonzero"
    })));
const $9f38e13816957edc$export$cef8dc8280f1c02c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.73 5.73 0 002.547-.567 1 1 0 00.563-.9V5.466a.998.998 0 00-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 006 5.466v6.769z",
        fill: "currentColor"
    }));
const $9f38e13816957edc$export$50963481dc57ac5c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6.735 12.322a1 1 0 00-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2335.638 2335.638 0 003.939-3.883l.04-.04a492.598 492.598 0 003.658-3.643 1 1 0 00-1.424-1.404 518.42 518.42 0 01-3.64 3.625l-.04.04a2049.114 2049.114 0 01-3.775 3.722l-3.098-3.363z",
        fill: "currentColor"
    }));
const $9f38e13816957edc$export$330e95d855f0ff0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "24",
        width: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11.208 9.32L9.29 11.253a1 1 0 000 1.409.982.982 0 001.397 0l1.29-1.301 1.336 1.347a.982.982 0 001.397.001 1.002 1.002 0 00.001-1.408l-1.965-1.98a1.08 1.08 0 00-1.538-.001z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11 10.007l.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7.938 5.481a4.8 4.8 0 00-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 014.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481z"
    })));
const $9f38e13816957edc$export$5aa1ec710367c05 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3zM8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1zm-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $9f38e13816957edc$export$4f751361dc2785a8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16 12c0-1.9-1.3-3.4-3-3.9V4c0-.6-.4-1-1-1s-1 .4-1 1v4.1c-1.7.4-3 2-3 3.9s1.3 3.4 3 3.9V20c0 .6.4 1 1 1s1-.4 1-1v-4.1c1.7-.5 3-2 3-3.9zm-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $9f38e13816957edc$export$314907f846d12b79 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M18 15.2V11c0-1.7-1.3-3-3-3h-1.9l.8-.8c.3-.3.3-.8 0-1.1-.3-.3-.8-.3-1.1 0l-2.3 2.3c-.3.4-.3.9 0 1.2l2.3 2.3c.2.2.3.2.5.2s.4-.1.6-.3c.3-.3.3-.8 0-1.1l-.7-.7H15c.6 0 1 .4 1 1v4.2c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8zM17 19c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zM7 3C5.4 3 4 4.3 4 6c0 1.3.8 2.4 2 2.8V20c0 .6.4 1 1 1s1-.4 1-1V8.8c1.2-.4 2-1.5 2-2.8 0-1.7-1.3-3-3-3zm0 4c-.5 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $9f38e13816957edc$export$e6da30a8001300c0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $9f38e13816957edc$export$f291c054d6e2e898 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "5",
        cy: "12",
        r: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "19",
        cy: "12",
        r: "2"
    })));
const $9f38e13816957edc$export$b59bd42a398a2b3c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "24",
        width: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0V14z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "12",
        cy: "7",
        r: "4"
    })));
const $9f38e13816957edc$export$45e4820251213456 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0119.005 21H4.995A1.995 1.995 0 013 19.006V6.994C3 5.893 3.892 5 4.995 5zM5 9v9a1 1 0 001 1h12a1 1 0 001-1V9H5zm1-5a1 1 0 012 0v1H6V4zm10 0a1 1 0 012 0v1h-2V4zm-9 9v-2.001h2V13H7zm8 0v-2.001h2V13h-2zm-4 0v-2.001h2.001V13H11zm-4 4v-2h2v2H7zm4 0v-2h2.001v2H11zm4 0v-2h2v2h-2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));

});

const $6d6eac2504286faf$export$3b43f1ca008dad23 = 'child-issues';
const $6d6eac2504286faf$export$aac403da0d127706 = 'flag';
const $6d6eac2504286faf$export$540a31b23d6b9abd = 'tick';
const $6d6eac2504286faf$export$352da558a3a09227 = 'upload';
const $6d6eac2504286faf$export$178cb2e5b5fc68e8 = 'bitbucket-branches';
const $6d6eac2504286faf$export$a153e0417183b79 = 'bitbucket-commits';
const $6d6eac2504286faf$export$555f9a88a8c5f309 = 'bitbucket-pullrequests';
const $6d6eac2504286faf$export$82a1ca282cb5e4e5 = 'emoji-frequent';
const $6d6eac2504286faf$export$423cd243bf1888bc = 'more';
const $6d6eac2504286faf$export$30a9be92cbb6f382 = 'person';
const $6d6eac2504286faf$export$d4ee7b46933c494f = 'due-date';


parcelRegister("fTggM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5dc23d8c9309847$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c5dc23d8c9309847$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    childIssuesMetadata: {
        "id": "card.common.child-issues.child-issues-metadata",
        "defaultMessage": "{complete} of {total} child issues complete"
    },
    childIssuesMetadataIssueTermRefresh: {
        "id": "card.common.child-issues.child-issues-metadata-issue-term-refresh",
        "defaultMessage": "{complete} of {total} child issues complete"
    }
});

});


parcelRegister("hOvWQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $375ebd4f2b182bd6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $az4zD = parcelRequire("az4zD");

var $2OMDV = parcelRequire("2OMDV");
var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");

var $7Vvqa = parcelRequire("7Vvqa");
const $375ebd4f2b182bd6$var$ContextMenuWrapper = ({ children: children, onClick: onClick, onSetRef: onSetRef, onContextMenu: onContextMenu })=>// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: onSetRef,
        onClick: onClick,
        onContextMenu: onContextMenu,
        "data-testid": "platform-card.common.ui.context-menu.wrapper"
    }, children);
const $375ebd4f2b182bd6$var$WrapperWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('contextMenu', {
    onContextMenu: 'open'
})($375ebd4f2b182bd6$var$ContextMenuWrapper); // eslint-disable-next-line jira/react/no-class-components
class $375ebd4f2b182bd6$var$CardContextMenu extends (0, $5uXOq.Component) {
    componentDidUpdate(prevProps, prevState) {
        if (prevState.isContextMenuOpen === false && this.state.isContextMenuOpen === true) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('mousedown', this.onMouseDownOutside);
        if (prevState.isContextMenuOpen === true && this.state.isContextMenuOpen === false) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('mousedown', this.onMouseDownOutside);
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('mousedown', this.onMouseDownOutside);
    }
    render() {
        const { children: children, items: items } = this.props;
        const { isContextMenuOpen: isContextMenuOpen, contextMenuPositionX: contextMenuPositionX, contextMenuPositionY: contextMenuPositionY } = this.state; /*
                    * First we don't have the ref anymore, so we can't detect clicks outside of the
                    	menu (this is made worse by the fact that the menu is in a portal, because
                    	previously the menu was inside of the card / container)
                    * Second, because the menu is in a portal, it does't update its position when
                    	the parent is moved
                    */ 
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($375ebd4f2b182bd6$var$WrapperWithAnalytics, {
            onSetRef: this.onWrapperRefSet,
            onContextMenu: this.onContextMenu
        }, items === null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($375ebd4f2b182bd6$var$ActionsSection, {
            x: contextMenuPositionX,
            y: contextMenuPositionY,
            onClick: this.onMouseDownInside
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
            key: `${contextMenuPositionX}:${contextMenuPositionY}`,
            spacing: "compact",
            isOpen: isContextMenuOpen,
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($375ebd4f2b182bd6$var$TriggerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                    ...props,
                    ref: triggerRef,
                    appearance: "subtle",
                    "aria-label": this.props.intl?.formatMessage((0, $7Vvqa.messages).label)
                })),
            onOpenChange: this.onOpenChange
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ref: this.onDropDownRefSet
        }, items))), children));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isContextMenuOpen: false,
            contextMenuPositionX: 0,
            contextMenuPositionY: 0
        };
        this.isClickOutside = (e)=>{
            if (!(e.target instanceof Node)) return true;
            const isClickInside = this.refWrapper && this.refWrapper.contains(e.target) || this.refDropDownMenu && this.refDropDownMenu.contains(e.target);
            return !isClickInside;
        };
        this.onMouseDownOutside = (e)=>{
            if (this.isClickOutside(e)) this.onContextMenuClose();
        };
        this.onMouseDownInside = (e)=>{
            // prevents click on the context menu item to bubble up and fire card click
            e.preventDefault();
            e.stopPropagation();
        };
        this.onContextMenu = (e, analyticsEvent)=>{
            if (this.isClickOutside(e)) return;
            e.stopPropagation();
            e.preventDefault();
            if (this.props.items === null) return;
            if (this.refWrapper) {
                const { onContextMenuChange: onContextMenuChange } = this.props;
                const { top: top, left: left } = this.refWrapper.getBoundingClientRect();
                this.setState({
                    isContextMenuOpen: true,
                    contextMenuPositionX: e.clientX - left,
                    contextMenuPositionY: e.clientY - top - 15
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openedContextMenu');
                onContextMenuChange(true);
            }
            if (this.refDropDownMenu) this.refDropDownMenu.focus();
        };
        this.onContextMenuClose = ()=>{
            const { onContextMenuChange: onContextMenuChange } = this.props;
            this.setState({
                isContextMenuOpen: false
            });
            onContextMenuChange(false);
        };
        this.onOpenChange = ({ isOpen: isOpen })=>{
            if (!isOpen) this.onContextMenuClose();
        };
        this.onWrapperRefSet = (ref)=>{
            this.refWrapper = ref;
        };
        this.onDropDownRefSet = (ref)=>{
            this.refDropDownMenu = ref;
        };
        this.refWrapper = null;
        this.refDropDownMenu = null;
    }
}
var $375ebd4f2b182bd6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($375ebd4f2b182bd6$var$CardContextMenu);
const $375ebd4f2b182bd6$var$TriggerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_jq8gidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $375ebd4f2b182bd6$var$ActionsSectionControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-13lmqvs-0"
})((props)=>({
        position: 'absolute',
        zIndex: 400,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: `${props.y}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: `${props.x}px`
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $375ebd4f2b182bd6$var$ActionsSectionExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_bajtf7": (0, $lD23V.default)(`${__cmplp.y}px`),
            "--_172sugn": (0, $lD23V.default)(`${__cmplp.x}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1pby1nn1 _154i1wux _1ltv1j37",
            __cmplp.className
        ])
    });
});
const $375ebd4f2b182bd6$var$ActionsSection = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $375ebd4f2b182bd6$var$ActionsSectionExperiment, $375ebd4f2b182bd6$var$ActionsSectionControl);

});
parcelRegister("7Vvqa", function(module, exports) {

$parcel$export(module.exports, "messages", () => $40b2c9c72867436a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $40b2c9c72867436a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    label: {
        "id": "card.common.context-menu.trigger-label",
        "defaultMessage": "Open card actions menu"
    }
});

});


parcelRegister("cfZh8", function(module, exports) {

$parcel$export(module.exports, "CardDaysInColumn", () => $ed1b32948e6895dc$export$f04590cce2f79373);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $h6USi = parcelRequire("h6USi");
function $ed1b32948e6895dc$export$f04590cce2f79373({ days: days }) {
    let dots = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    if (days >= 20) dots = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('danger')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('danger')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('danger')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('danger')
    }));
    else if (days >= 12) dots = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtle')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('danger')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('danger')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('danger')
    }));
    else if (days >= 8) dots = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtle')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtle')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('danger')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('danger')
    }));
    else if (days >= 5) dots = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtle')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtle')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtle')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('danger')
    }));
    else if (days >= 3) dots = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtle')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtle')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('warning')
    }));
    else if (days >= 2) dots = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtle')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtleDark')
    }));
    else if (days >= 1) dots = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtle')
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const content = formatMessage((0, $h6USi.messages).daysInColumn, {
        days: Math.floor(days)
    });
    return days < 1 ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$DaysInColumnContainer, (0, $4R6GH.fg)('tooltip_not_accessible') && {
        'aria-label': content,
        tabIndex: 0
    }, dots));
}
const $ed1b32948e6895dc$var$Circle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhk1cj8 _1bsbi2wt _4t3ii2wt _2rko1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed1b32948e6895dc$var$DaysInColumnContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o _zulpv77o",
            __cmplp.className
        ])
    });
});
const $ed1b32948e6895dc$var$getColor = (mode)=>{
    if (mode === 'danger') return "var(--ds-icon-danger, #d04437)";
    if (mode === 'warning') return "var(--ds-icon-warning, #f8c15b)";
    if (mode === 'subtleDark') return "var(--ds-background-accent-gray-subtle, rgb(133, 144, 162))";
    return "var(--ds-icon-disabled, rgba(9, 30, 66, 0.31))";
};

});
parcelRegister("h6USi", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0a0238dda0e414cf$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0a0238dda0e414cf$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    daysInColumn: {
        "id": "card.common.days-in-column.days-in-column",
        "defaultMessage": "{days, plural, one {# day} other {# days}} in this column"
    }
});

});


parcelRegister("f5Alb", function(module, exports) {

$parcel$export(module.exports, "default", () => $06e6b9674d7045f8$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $Iny5X = parcelRequire("Iny5X");

var $8phmQ = parcelRequire("8phmQ");
const $06e6b9674d7045f8$var$CardDevStatus = (props)=>{
    const { type: type, issueId: issueId, deploymentDetails: deploymentDetails } = props;
    const hasSupportedType = (0, $8phmQ.SUPPORTED_DEV_STATUSES).includes(type);
    if (!hasSupportedType) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($06e6b9674d7045f8$var$Container, null, issueId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Iny5X.default), {
        issueId: issueId,
        devInfoType: type,
        allowNativeContextMenu: true,
        deploymentDetails: deploymentDetails,
        location: (0, $4ebd35f903e92a1a$export$9b8283d5878d2491)
    }));
};
var $06e6b9674d7045f8$export$2e2bcd8739ae039 = $06e6b9674d7045f8$var$CardDevStatus;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06e6b9674d7045f8$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
const $4ebd35f903e92a1a$export$9b8283d5878d2491 = 'board';
const $4ebd35f903e92a1a$export$76a449e52fa0e1e8 = 'issue';
const $4ebd35f903e92a1a$export$ede40e627a0cbf14 = 'version_details';
const $4ebd35f903e92a1a$export$464c50016d069471 = 'issue_view_child_issues_list';
const $4ebd35f903e92a1a$export$3a46c5b594c0f84c = 'issue_view_linked_issues_list';

parcelRegister("Iny5X", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "DevInfoIconView", () => $a9451438a3e9bf76$export$b98af1fb6b8b345e);
$parcel$export(module.exports, "default", () => $a9451438a3e9bf76$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8QpSo = parcelRequire("8QpSo");

var $9yOBd = parcelRequire("9yOBd");

var $4iPF3 = parcelRequire("4iPF3");

var $ePJ5X = parcelRequire("ePJ5X");

var $bFklq = parcelRequire("bFklq");

var $ksIER = parcelRequire("ksIER");

var $91Cn3 = parcelRequire("91Cn3");

var $hXgVM = parcelRequire("hXgVM");

var $9XvX5 = parcelRequire("9XvX5");

var $1TUd3 = parcelRequire("1TUd3");

var $dMzAR = parcelRequire("dMzAR");

var $aPRJS = parcelRequire("aPRJS");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gwIPs = parcelRequire("gwIPs");

var $4gmb8 = parcelRequire("4gmb8");

var $dJl1T = parcelRequire("dJl1T");


var $8YTUU = parcelRequire("8YTUU");

var $lxrPB = parcelRequire("lxrPB");

var $kcaDR = parcelRequire("kcaDR");

var $7MIrF = parcelRequire("7MIrF");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $39xOx = parcelRequire("39xOx");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $4R6GH = parcelRequire("4R6GH");

var $lXSZ8 = parcelRequire("lXSZ8");

var $koVbs = parcelRequire("koVbs");

var $7IEKg = parcelRequire("7IEKg");

var $dXq4S = parcelRequire("dXq4S");

var $iXVV6 = parcelRequire("iXVV6");

var $fiv1r = parcelRequire("fiv1r");

var $a3HWu = parcelRequire("a3HWu");

var $kfztd = parcelRequire("kfztd");

var $9OXo1 = parcelRequire("9OXo1");

var $gicL9 = parcelRequire("gicL9");

var $4Dyci = parcelRequire("4Dyci");
const $a9451438a3e9bf76$var$DEV_INFO_BUTTON_ID = 'development-board-dev-info-icon.button-text';
const $a9451438a3e9bf76$var$DevInfoIconsMapping = (0, $8QpSo.default)((formatMessage)=>({
        [(0, $8YTUU.DevInfoTypes).BRANCH]: (0, $4R6GH.fg)('development-dev-info-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4iPF3))), {
            label: formatMessage((0, $4Dyci.default).branchIconLabel),
            color: "var(--ds-icon, #44546F)"
        }) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9XvX5))), (0, $gicL9.DevInfoIconPropsMapping)(formatMessage)[(0, $8YTUU.DevInfoTypes).BRANCH]),
        [(0, $8YTUU.DevInfoTypes).COMMIT]: (0, $4R6GH.fg)('development-dev-info-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bFklq))), {
            label: formatMessage((0, $4Dyci.default).commitIconLabel),
            color: "var(--ds-icon, #44546F)"
        }) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TUd3))), (0, $gicL9.DevInfoIconPropsMapping)(formatMessage)[(0, $8YTUU.DevInfoTypes).COMMIT]),
        [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: (0, $4R6GH.fg)('development-dev-info-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hXgVM))), {
            label: formatMessage((0, $4Dyci.default).openPullRequestIconLabel),
            color: "var(--ds-icon, #44546F)"
        }) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dMzAR))), (0, $gicL9.DevInfoIconPropsMapping)(formatMessage)[(0, $8YTUU.DevInfoTypes).PULLREQUEST]),
        [(0, $8YTUU.DevInfoTypes).DECLINED]: (0, $4R6GH.fg)('development-dev-info-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ksIER))), {
            label: formatMessage((0, $4Dyci.default).declinedPullRequestIconLabel),
            color: "var(--ds-icon, #44546F)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7MIrF.BitbucketPullrequestDeclined), (0, $gicL9.DevInfoIconPropsMapping)(formatMessage)[(0, $8YTUU.DevInfoTypes).DECLINED]),
        [(0, $8YTUU.DevInfoTypes).MERGED]: (0, $4R6GH.fg)('development-dev-info-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91Cn3))), {
            label: formatMessage((0, $4Dyci.default).mergedPullRequestIconLabel),
            color: "var(--ds-icon, #44546F)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7MIrF.BitbucketPullrequestMerged), (0, $gicL9.DevInfoIconPropsMapping)(formatMessage)[(0, $8YTUU.DevInfoTypes).MERGED]),
        [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: (0, $4R6GH.fg)('development-dev-info-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ePJ5X))), {
            label: formatMessage((0, $4Dyci.default).deploymentIconLabel),
            color: "var(--ds-icon, #44546F)"
        }) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aPRJS))), (0, $gicL9.DevInfoIconPropsMapping)(formatMessage)[(0, $8YTUU.DevInfoTypes).DEPLOYMENT]),
        [(0, $8YTUU.DevInfoTypes).DESIGN]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $a9451438a3e9bf76$var$DesignIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXSZ8.default), {
            label: formatMessage((0, $4Dyci.default).designIconLabel)
        }))
    }));
const $a9451438a3e9bf76$var$getDevInfoIcon = (devInfoType, formatMessage, deploymentDetails)=>{
    if (deploymentDetails?.deploymentState && deploymentDetails?.deploymentEnvironment) {
        if (deploymentDetails.deploymentEnvironment === (0, $gicL9.DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, $gicL9.DeploymentState).SUCCESSFUL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7MIrF.DeploymentProdSuccess), {
            size: "small",
            label: formatMessage((0, $4Dyci.default).deploymentProductionSuccessIconLabel)
        });
        if (deploymentDetails.deploymentEnvironment === (0, $gicL9.DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, $gicL9.DeploymentState).FAILED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7MIrF.DeploymentProdFailed), {
            size: "small",
            label: formatMessage((0, $4Dyci.default).deploymentProductionFailedIconLabel)
        });
        if (deploymentDetails.deploymentEnvironment !== (0, $gicL9.DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, $gicL9.DeploymentState).SUCCESSFUL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7MIrF.DeploymentNonProdSuccess), {
            size: "small",
            label: formatMessage((0, $4Dyci.default).deploymentNonProductionSuccessIconLabel)
        });
        if (deploymentDetails.deploymentEnvironment !== (0, $gicL9.DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, $gicL9.DeploymentState).FAILED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7MIrF.DeploymentNonProdFailed), {
            size: "small",
            label: formatMessage((0, $4Dyci.default).deploymentNonProductionFailedIconLabel)
        });
    }
    return $a9451438a3e9bf76$var$DevInfoIconsMapping(formatMessage)[devInfoType];
};
const $a9451438a3e9bf76$export$b98af1fb6b8b345e = ({ issueId: issueId, devInfoType: devInfoType, allowNativeContextMenu: allowNativeContextMenu, customTrigger: customTrigger, scopeId: scopeId, deploymentDetails: deploymentDetails, isStopPropagationOnClick: isStopPropagationOnClick = true, placement: placement = 'bottom-start', offset: offset, zIndex: /* Setting zIndex slighlty lower than the default so that other popups (like the right-click context menu) appear on top of this */ zIndex = (0, $gwIPs.layers).layer - 1 })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [isHoverMode, setIsHoverMode] = (0, $5uXOq.useState)(true);
    const [shouldAutoFocus, setShouldAutoFocus] = (0, $5uXOq.useState)(true);
    const timeoutRef = (0, $5uXOq.useRef)(undefined);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const issueAri = (0, $5uXOq.useMemo)(()=>(0, $kcaDR.createIssueAri)(cloudId, issueId.toString()), [
        cloudId,
        issueId
    ]);
    const siteAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        resourceType: 'site',
        resourceId: cloudId
    });
    const initialTrigger = (0, $5uXOq.useRef)(null);
    const devInfoIcon = $a9451438a3e9bf76$var$getDevInfoIcon(devInfoType, formatMessage, deploymentDetails);
    const popupType = devInfoType === (0, $8YTUU.DevInfoTypes).MERGED || devInfoType === (0, $8YTUU.DevInfoTypes).DECLINED ? (0, $8YTUU.DevInfoTypes).PULLREQUEST : devInfoType;
    const { id: experienceId, name: experienceName } = (0, $gicL9.experienceDetails)[popupType];
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: experienceName
    });
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            issueId: issueAri
        }), [
        issueAri
    ]); // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, $4mO32.useEntryPoint)((0, $gicL9.popupEntryPoints)[popupType], entryPointParams, (0, $gicL9.metrics)[popupType]); // Entry point for the design modal that is used in the design details popup
    const designEntrypoint = (0, $4mO32.useEntryPoint)((0, $7IEKg.designModalEntryPoint), {
        siteAri: siteAri,
        issueAri: issueAri,
        cloudId: cloudId
    });
    const designModalTriggerRef = (0, $47gW9.useEntryPointButtonTrigger)(designEntrypoint.entryPointActions);
    const entryPointErrorBoundaryProps = (0, $5uXOq.useMemo)(()=>({
            ...(0, $gicL9.packageDetails)[popupType],
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lxrPB.default), {
                    devInfoType: devInfoType,
                    issueAri: issueAri,
                    scopeId: scopeId
                })
        }), [
        devInfoType,
        issueAri,
        popupType,
        scopeId
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            issueAri: issueAri,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            devInfoType: devInfoType,
            trigger: initialTrigger.current ?? undefined,
            onReady: ()=>{
                stopMetric();
                onExperienceSuccess();
            },
            scopeId: scopeId,
            modalTriggerRef: devInfoType === (0, $8YTUU.DevInfoTypes).DESIGN ? designModalTriggerRef : undefined
        }), [
        issueAri,
        devInfoType,
        scopeId,
        designModalTriggerRef,
        stopMetric,
        onExperienceSuccess
    ]);
    const handleDevIconClick = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(timeoutRef.current);
        if (initialTrigger.current === null) initialTrigger.current = 'click';
        if (isOpen && isHoverMode) setIsHoverMode(false);
        else if (isOpen && !isHoverMode) {
            initialTrigger.current = null;
            setIsOpen(false);
            setIsHoverMode(true);
        } else {
            entryPointActions.load();
            setShouldAutoFocus(true);
            setIsOpen(true);
            setIsHoverMode(false);
        }
    }, [
        entryPointActions,
        isHoverMode,
        isOpen
    ]);
    const handleMouseEnter = ()=>{
        if (!isHoverMode) return;
        clearTimeout(timeoutRef.current);
        setShouldAutoFocus(false);
        if (!isOpen) {
            entryPointActions.preload();
            timeoutRef.current = undefined;
            timeoutRef.current = setTimeout(()=>{
                if (initialTrigger.current === null) initialTrigger.current = 'hover';
                entryPointActions.load();
                setIsOpen(true);
            }, (0, $gicL9.HOVER_TIMEOUT_MS));
        }
    };
    const handleMouseLeave = ()=>{
        if (!isHoverMode) return;
        clearTimeout(timeoutRef.current);
        entryPointActions.cancelPreload();
        timeoutRef.current = undefined;
        if (isOpen) timeoutRef.current = setTimeout(()=>{
            initialTrigger.current = null;
            setShouldAutoFocus(true);
            setIsHoverMode(true);
            setIsOpen(false);
        }, (0, $gicL9.HOVER_TIMEOUT_MS));
    };
    if ((0, $gicL9.iconColor)[devInfoType] === undefined) (0, $dJl1T.default).safeErrorWithoutCustomerData('packages.development.board.dev-info-icon', 'unexpected devInfoType', {
        devInfoType: devInfoType
    });
    const customTheme = (0, $4gmb8.getTheme)({
        buttonStyles: {
            subtle: {
                color: {
                    // @ts-expect-error - TS2322 - Type '{ color: { default: string | undefined; hover: string | undefined; active: string | undefined; }; }' is not assignable to type 'CSSInterpolation'. | TS2532 - Object is possibly 'undefined'.
                    default: (0, $gicL9.iconColor)[devInfoType][(0, $8YTUU.ButtonStatus).DEFAULT],
                    hover: (0, $gicL9.iconColor)[devInfoType][(0, $8YTUU.ButtonStatus).HOVER],
                    active: (0, $gicL9.iconColor)[devInfoType][(0, $8YTUU.ButtonStatus).ACTIVE]
                }
            }
        }
    });
    const devInfoTextId = `${$a9451438a3e9bf76$var$DEV_INFO_BUTTON_ID}-${issueId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        role: "presentation",
        "data-testid": "development-board-dev-info-icon.container",
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: (e)=>{
            // Prevents clicks on the icon from opening the Issue view
            if (isStopPropagationOnClick) e.stopPropagation();
        },
        onKeyDown: (e)=>{
            // Prevents using keyboard to open the Issue view
            e.stopPropagation();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        placement: placement,
        shouldFlip: true,
        autoFocus: shouldAutoFocus,
        shouldUseCaptureOnOutsideClick: true,
        testId: "development-board-dev-info-icon.popup",
        trigger: (triggerProps)=>customTrigger != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", triggerProps, customTrigger) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
                ...triggerProps,
                onClick: handleDevIconClick,
                isSelected: isOpen && !isHoverMode,
                theme: customTheme,
                appearance: "subtle",
                spacing: "compact",
                iconBefore: devInfoIcon,
                "aria-describedby": devInfoTextId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a9451438a3e9bf76$var$DevInfoButtonText, {
                id: devInfoTextId
            }, (0, $gicL9.DevInfoButtonLabelMapping)(formatMessage)[devInfoType])),
        isOpen: isOpen,
        onClose: ()=>{
            initialTrigger.current = null;
            setIsOpen(false);
            setIsHoverMode(true);
        },
        offset: offset,
        zIndex: zIndex,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // We are stopping right-click event propagation to not show the custom context menu from the Jira Issue Card
            , {
                // and instead use the event default
                onContextMenu: (event)=>{
                    if (!allowNativeContextMenu) event.preventDefault();
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kaHBi.ExperienceStart), {
                analyticsSource: experienceName,
                experience: experienceName,
                experienceId: experienceId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                ...entryPointErrorBoundaryProps,
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a3HWu.DevInfoDetailsPopupSkeleton), {
                    devinfoType: popupType
                }),
                runtimeProps: runtimeProps
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: designEntrypoint.entryPointReferenceSubject,
        id: "jiraDesignModal",
        packageName: "design-modal",
        entryPointActions: designEntrypoint.entryPointActions,
        runtimeProps: {
            initialSelectedDesign: 0
        }
    }));
};
const $a9451438a3e9bf76$var$ERROR_ID = 'renderDevInfoIcon';
const $a9451438a3e9bf76$var$PACKAGE_NAME = 'jiraDevelopmentBoardDevInfoIcon';
const $a9451438a3e9bf76$var$DevInfoIcon = ({ issueId: issueId, devInfoType: devInfoType, allowNativeContextMenu: allowNativeContextMenu, customTrigger: customTrigger, scopeId: scopeId, deploymentDetails: deploymentDetails, isStopPropagationOnClick: isStopPropagationOnClick = true, placement: placement, offset: offset, zIndex: zIndex, location: location = (0, $4ebd35f903e92a1a$export$9b8283d5878d2491) })=>{
    const attributes = {
        devInfoType: devInfoType ?? 'unexpected',
        location: location
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: $a9451438a3e9bf76$var$ERROR_ID,
        packageName: $a9451438a3e9bf76$var$PACKAGE_NAME,
        teamName: "fusion-isotopes",
        fallback: "unmount",
        attributes: attributes,
        extraEventData: attributes,
        sendToPrivacyUnsafeSplunk: true
    }, !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fiv1r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926),
        sourceName: "DevInfoIcon",
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a9451438a3e9bf76$export$b98af1fb6b8b345e, {
        issueId: issueId,
        devInfoType: devInfoType,
        allowNativeContextMenu: allowNativeContextMenu,
        customTrigger: customTrigger,
        scopeId: scopeId,
        deploymentDetails: deploymentDetails,
        isStopPropagationOnClick: isStopPropagationOnClick,
        placement: placement,
        offset: offset,
        zIndex: zIndex
    }))));
};
var $a9451438a3e9bf76$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $a9451438a3e9bf76$var$DevInfoIcon;
const $a9451438a3e9bf76$var$DevInfoButtonText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $a9451438a3e9bf76$var$DesignIconStyles = (0, $8CUq3.xcss)({
    height: '16px',
    width: '16px',
    display: 'flex',
    justifyContent: 'center'
});

});
parcelRegister("4iPF3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::819aaba4ce720b386ac455b06c3dfba2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3220eab15e59539d$var$_react = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3220eab15e59539d$var$_UNSAFE_baseNew = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3220eab15e59539d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3220eab15e59539d$var$BranchIcon = (props)=>/*#__PURE__*/ $3220eab15e59539d$var$_react.default.createElement($3220eab15e59539d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M4.25 4.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 0V9m1.5 3.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 0h3.5a2.5 2.5 0 0 0 2.5-2.5v-5.5m0 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>`
    }, props));
$3220eab15e59539d$var$BranchIcon.displayName = 'BranchIcon';
var $3220eab15e59539d$var$_default = module.exports.default = $3220eab15e59539d$var$BranchIcon;

});

parcelRegister("ePJ5X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6538c11424fcd7a335bc8ee8ba51483f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc8cf07db1d2dba$var$_react = $acc8cf07db1d2dba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $acc8cf07db1d2dba$var$_UNSAFE_baseNew = $acc8cf07db1d2dba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $acc8cf07db1d2dba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc8cf07db1d2dba$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $acc8cf07db1d2dba$var$_react.default.createElement($acc8cf07db1d2dba$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m4.429 3.18.217.718.358-.108.129-.35zm6.25.81-.723.2.151.55h.572zM8 8.75l.53-.53a.75.75 0 0 0-1.06 0zm2.405-5.754.723-.2zM2.5 6.5v-.482H1V6.5zm1.408-2.378.738-.224-.434-1.435-.738.223zm1.225-.683.157-.427-1.408-.517-.157.427zm4.549-.244.274.995 1.446-.398-.274-.995zm.997 1.546h1.191v-1.5h-1.19zM13.5 6.37v.13H15v-.13zm-7.97 5.91 3-3-1.06-1.06-3 3zm1.94-3 3 3 1.06-1.061-3-3zm-.22-.031V16h1.5V9.25zM13.5 6.5A1.5 1.5 0 0 1 12 8v1.5a3 3 0 0 0 3-3zm-6.044-5a2.31 2.31 0 0 1 2.226 1.695l1.446-.398A3.81 3.81 0 0 0 7.456 0zM5.29 3.012A2.31 2.31 0 0 1 7.456 1.5V0a3.81 3.81 0 0 0-3.574 2.495zm6.58 1.729c.9 0 1.63.73 1.63 1.63H15a3.13 3.13 0 0 0-3.13-3.13zM2.5 6.018a1.98 1.98 0 0 1 1.408-1.896l-.434-1.436A3.48 3.48 0 0 0 1 6.018zM4 8a1.5 1.5 0 0 1-1.5-1.5H1a3 3 0 0 0 3 3z"/>`
    }, props));
$acc8cf07db1d2dba$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $acc8cf07db1d2dba$var$_default = module.exports.default = $acc8cf07db1d2dba$var$CloudArrowUpIcon;

});

parcelRegister("bFklq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bf6838b72780d519bb539edbde68438>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87e34e0db8f20450$var$_react = $87e34e0db8f20450$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87e34e0db8f20450$var$_UNSAFE_baseNew = $87e34e0db8f20450$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $87e34e0db8f20450$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87e34e0db8f20450$var$CommitIcon = (props)=>/*#__PURE__*/ $87e34e0db8f20450$var$_react.default.createElement($87e34e0db8f20450$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 10a2 2 0 1 0 0-4m0 4a2 2 0 1 1 0-4m0 4v6M8 6V0"/>`
    }, props));
$87e34e0db8f20450$var$CommitIcon.displayName = 'CommitIcon';
var $87e34e0db8f20450$var$_default = module.exports.default = $87e34e0db8f20450$var$CommitIcon;

});

parcelRegister("ksIER", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ad48e901fe03e9767fb442db98217bf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee5910529ff74451$var$_react = $ee5910529ff74451$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ee5910529ff74451$var$_UNSAFE_baseNew = $ee5910529ff74451$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ee5910529ff74451$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "MergeFailure".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira that have failed to merge.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee5910529ff74451$var$MergeFailureIcon = (props)=>/*#__PURE__*/ $ee5910529ff74451$var$_react.default.createElement($ee5910529ff74451$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8.5 3.25h1.25a2 2 0 0 1 2 2v6M4.25 7.5v3.75m0 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm7.5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM2 1l2.25 2.25m0 0L6.5 5.5M4.25 3.25 6.5 1M4.25 3.25 2 5.5"/>`
    }, props));
$ee5910529ff74451$var$MergeFailureIcon.displayName = 'MergeFailureIcon';
var $ee5910529ff74451$var$_default = module.exports.default = $ee5910529ff74451$var$MergeFailureIcon;

});

parcelRegister("91Cn3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a4206b68c67f6c54a25165d427522e58>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6921f8b1fecd6128$var$_react = $6921f8b1fecd6128$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6921f8b1fecd6128$var$_UNSAFE_baseNew = $6921f8b1fecd6128$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $6921f8b1fecd6128$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "MergeSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira that have successfully merged.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6921f8b1fecd6128$var$MergeSuccessIcon = (props)=>/*#__PURE__*/ $6921f8b1fecd6128$var$_react.default.createElement($6921f8b1fecd6128$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8.5 3.25h1.25a2 2 0 0 1 2 2v6M4.25 7.5v3.75m0 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm7.5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-10-8 1.667 2 3.333-4"/>`
    }, props));
$6921f8b1fecd6128$var$MergeSuccessIcon.displayName = 'MergeSuccessIcon';
var $6921f8b1fecd6128$var$_default = module.exports.default = $6921f8b1fecd6128$var$MergeSuccessIcon;

});

parcelRegister("hXgVM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::40fc287887fb7d6bfe3f12ef5c4816a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1251477351c10fe$var$_react = $d1251477351c10fe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d1251477351c10fe$var$_UNSAFE_baseNew = $d1251477351c10fe$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d1251477351c10fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d1251477351c10fe$var$PullRequestIcon = (props)=>/*#__PURE__*/ $d1251477351c10fe$var$_react.default.createElement($d1251477351c10fe$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 3.25h1.75a2 2 0 0 1 2 2v6m-7.5-6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 0v6.5m0 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm7.5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"/>`
    }, props));
$d1251477351c10fe$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $d1251477351c10fe$var$_default = module.exports.default = $d1251477351c10fe$var$PullRequestIcon;

});

parcelRegister("9XvX5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $740268c474e86b43$var$_react = $740268c474e86b43$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $740268c474e86b43$var$_branch = $740268c474e86b43$var$_interopRequireDefault((parcelRequire("4iPF3")));
function $740268c474e86b43$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $740268c474e86b43$var$BitbucketBranchesIcon = (props)=>/*#__PURE__*/ $740268c474e86b43$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3M8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1"/></svg>`
    }, props, {
        newIcon: $740268c474e86b43$var$_branch.default
    }));
$740268c474e86b43$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
var $740268c474e86b43$var$_default = module.exports.default = $740268c474e86b43$var$BitbucketBranchesIcon;

});

parcelRegister("1TUd3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $162687911a858d49$var$_react = $162687911a858d49$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $162687911a858d49$var$_commit = $162687911a858d49$var$_interopRequireDefault((parcelRequire("bFklq")));
function $162687911a858d49$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $162687911a858d49$var$BitbucketCommitsIcon = (props)=>/*#__PURE__*/ $162687911a858d49$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16 12c0-1.9-1.3-3.4-3-3.9V4c0-.6-.4-1-1-1s-1 .4-1 1v4.1c-1.7.4-3 2-3 3.9s1.3 3.4 3 3.9V20c0 .6.4 1 1 1s1-.4 1-1v-4.1c1.7-.5 3-2 3-3.9m-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"/></svg>`
    }, props, {
        newIcon: $162687911a858d49$var$_commit.default
    }));
$162687911a858d49$var$BitbucketCommitsIcon.displayName = 'BitbucketCommitsIcon';
var $162687911a858d49$var$_default = module.exports.default = $162687911a858d49$var$BitbucketCommitsIcon;

});

parcelRegister("dMzAR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a08b5e30d2d36873$var$_react = $a08b5e30d2d36873$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $a08b5e30d2d36873$var$_pullRequest = $a08b5e30d2d36873$var$_interopRequireDefault((parcelRequire("hXgVM")));
function $a08b5e30d2d36873$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a08b5e30d2d36873$var$BitbucketPullrequestsIcon = (props)=>/*#__PURE__*/ $a08b5e30d2d36873$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M18 15.2V11c0-1.7-1.3-3-3-3h-1.9l.8-.8c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0l-2.3 2.3c-.3.4-.3.9 0 1.2l2.3 2.3c.2.2.3.2.5.2q.3 0 .6-.3c.3-.3.3-.8 0-1.1l-.7-.7H15c.6 0 1 .4 1 1v4.2c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8M17 19c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1M7 3C5.4 3 4 4.3 4 6c0 1.3.8 2.4 2 2.8V20c0 .6.4 1 1 1s1-.4 1-1V8.8c1.2-.4 2-1.5 2-2.8 0-1.7-1.3-3-3-3m0 4c-.5 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1"/></svg>`
    }, props, {
        newIcon: $a08b5e30d2d36873$var$_pullRequest.default
    }));
$a08b5e30d2d36873$var$BitbucketPullrequestsIcon.displayName = 'BitbucketPullrequestsIcon';
var $a08b5e30d2d36873$var$_default = module.exports.default = $a08b5e30d2d36873$var$BitbucketPullrequestsIcon;

});

parcelRegister("aPRJS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e385a40dadea6dc$var$_react = $7e385a40dadea6dc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7e385a40dadea6dc$var$_cloudArrowUp = $7e385a40dadea6dc$var$_interopRequireDefault((parcelRequire("ePJ5X")));
function $7e385a40dadea6dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7e385a40dadea6dc$var$UploadIcon = (props)=>/*#__PURE__*/ $7e385a40dadea6dc$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.208 9.32 9.29 11.253a1 1 0 0 0 0 1.409.98.98 0 0 0 1.397 0l1.29-1.301 1.336 1.347a.98.98 0 0 0 1.397.001 1 1 0 0 0 .001-1.408l-1.965-1.98a1.08 1.08 0 0 0-1.538-.001"/><path d="m11 10.007.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007"/><path d="M7.938 5.481a5 5 0 0 0-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 0 1 4.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481"/></g></svg>`
    }, props, {
        newIcon: $7e385a40dadea6dc$var$_cloudArrowUp.default
    }));
$7e385a40dadea6dc$var$UploadIcon.displayName = 'UploadIcon';
var $7e385a40dadea6dc$var$_default = module.exports.default = $7e385a40dadea6dc$var$UploadIcon;

});

parcelRegister("4gmb8", function(module, exports) {

$parcel$export(module.exports, "getTheme", () => $26e3b01c3b885768$export$89cbf1a0881c8b9c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // @ts-expect-error - TS2614 - Module '"@atlaskit/button"' has no exported member 'ButtonTheme'. Did you mean to use 'import ButtonTheme from "@atlaskit/button"' instead?

const $26e3b01c3b885768$export$9e61512f2dc2cbb0 = (currentTheme, props)=>{
    const { buttonStyles: buttonStyles, ...rest } = currentTheme(props);
    const theme = {
        ...rest,
        buttonStyles: {
            ...buttonStyles,
            backgroundColor: (0, $829f609a65d26a98$exports).P400,
            '> span': {
                color: (0, $829f609a65d26a98$exports).N0
            }
        }
    };
    return theme;
};
const $26e3b01c3b885768$export$f9380c9a627682d3 = (newTheme, themeProps)=>{
    const { appearance: appearance, mode: mode, state: state } = themeProps;
    if (!appearance || !newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    // @ts-expect-error - TS2739 - Type 'Record<string, any>' is missing the following properties from type 'ThemeTokens': buttonStyles, spinnerStyles
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!item) return;
            if (!node[item] && node[item] !== 0) return;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return;
            }
            // @ts-expect-error - TS2322 - Type 'string | number | { [key: string]: string | number; } | T' is not assignable to type '{ [key: string]: string | number; } | T'.
            node = node[item];
        });
        return acc;
    }, {});
};
const $26e3b01c3b885768$export$89cbf1a0881c8b9c = (overrides)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        // @ts-expect-error - TS2322 - Type 'Record<string, any>' is not assignable to type 'ThemeTokens'.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const styles = Object.entries(theme).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [key, value])=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            if (!overrides?.[key]) {
                acc[key] = value;
                return acc;
            }
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            const overriddenStyles = $26e3b01c3b885768$export$f9380c9a627682d3(overrides[key], themeProps);
            acc[key] = {
                ...value,
                ...overriddenStyles
            };
            return acc;
        }, {});
        return styles;
    };

});

parcelRegister("8YTUU", function(module, exports) {

$parcel$export(module.exports, "DevInfoTypes", () => $ba5542dc32884ee4$export$a100703e17b2650a);
$parcel$export(module.exports, "DevInfoTypeMap", () => $ba5542dc32884ee4$export$39c00ace65e13f2d);
$parcel$export(module.exports, "ButtonStatus", () => $ba5542dc32884ee4$export$477d4d2d93581a40);
const $ba5542dc32884ee4$export$a100703e17b2650a = Object.freeze({
    BRANCH: 'branch',
    COMMIT: 'commit',
    PULLREQUEST: 'pullrequest',
    DECLINED: 'declined',
    MERGED: 'merged',
    DEPLOYMENT: 'deployment',
    DESIGN: 'design'
});
const $ba5542dc32884ee4$export$39c00ace65e13f2d = {
    [$ba5542dc32884ee4$export$a100703e17b2650a.BRANCH]: 'branch',
    [$ba5542dc32884ee4$export$a100703e17b2650a.COMMIT]: 'commit',
    [$ba5542dc32884ee4$export$a100703e17b2650a.PULLREQUEST]: 'pull request',
    [$ba5542dc32884ee4$export$a100703e17b2650a.MERGED]: 'pull request',
    [$ba5542dc32884ee4$export$a100703e17b2650a.DECLINED]: 'pull request',
    [$ba5542dc32884ee4$export$a100703e17b2650a.DEPLOYMENT]: 'deployment',
    [$ba5542dc32884ee4$export$a100703e17b2650a.DESIGN]: 'design'
};
const $ba5542dc32884ee4$export$477d4d2d93581a40 = Object.freeze({
    ACTIVE: 'active',
    HOVER: 'hover',
    DEFAULT: 'default'
});

});

parcelRegister("lxrPB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfd87e1125ba31c4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $1dJ6S = parcelRequire("1dJ6S");

var $7nnPp = parcelRequire("7nnPp");


var $koVbs = parcelRequire("koVbs");

var $ifS9h = parcelRequire("ifS9h");

var $8YTUU = parcelRequire("8YTUU");

var $dt6Va = parcelRequire("dt6Va");

var $el2W3 = parcelRequire("el2W3");
const $cfd87e1125ba31c4$var$ErrorFallback = ({ devInfoType: devInfoType, issueAri: issueAri, scopeId: scopeId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showDevDetailDialogForPopup: showDevDetailDialogForPopup } = (0, $dt6Va.useShowDevDetailDialogForPopup)(scopeId);
    const handleLinkClick = ()=>{
        showDevDetailDialogForPopup(devInfoType, issueAri);
    };
    const devInfoTypeName = (0, $8YTUU.DevInfoTypeMap)[devInfoType];
    const errorMessage = devInfoType === (0, $8YTUU.DevInfoTypes).DESIGN ? formatMessage((0, $el2W3.default).designErrorDescription, {
        devInfoType: devInfoTypeName
    }) : formatMessage((0, $el2W3.default).errorDescription, {
        devInfoType: devInfoTypeName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifS9h.PopupContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifS9h.PopupTitle), null, formatMessage((0, $el2W3.default).errorPopupTitle, {
        devInfoType: (0, $8YTUU.DevInfoTypeMap)[devInfoType]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1dJ6S.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7nnPp))), {
        label: "",
        primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$Title, null, formatMessage((0, $el2W3.default).errorTitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$Description, null, errorMessage, devInfoType !== (0, $8YTUU.DevInfoTypes).DESIGN && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$StyledButton, {
        appearance: "link",
        onClick: handleLinkClick
    }, formatMessage((0, $el2W3.default).developmentErrorDescriptionCta))));
};
var $cfd87e1125ba31c4$export$2e2bcd8739ae039 = $cfd87e1125ba31c4$var$ErrorFallback;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfd87e1125ba31c4$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
const $cfd87e1125ba31c4$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1wmz _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $cfd87e1125ba31c4$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yxxidpf _12r21nn1 _if291ule _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf",
            __cmplp.className
        ])
    });
});
const $cfd87e1125ba31c4$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _syaz1wmz _19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ifS9h", function(module, exports) {

$parcel$export(module.exports, "PopupContainer", () => $88fc3594fd7e78a2$export$cca08eed9de89ba9);
$parcel$export(module.exports, "LinkContainer", () => $88fc3594fd7e78a2$export$af2ec3aa21d10ab7);
$parcel$export(module.exports, "PopupHeader", () => $88fc3594fd7e78a2$export$b11ea9d6e8111404);
$parcel$export(module.exports, "StyledDate", () => $88fc3594fd7e78a2$export$30301703d55848e7);
$parcel$export(module.exports, "RepositoryInfo", () => $88fc3594fd7e78a2$export$fde5e3d077213a6f);
$parcel$export(module.exports, "PopupTitle", () => $88fc3594fd7e78a2$export$b834616c6081368f);
$parcel$export(module.exports, "StyledLink", () => $88fc3594fd7e78a2$export$9048d548939551ee);
$parcel$export(module.exports, "PopupOverflowSection", () => $88fc3594fd7e78a2$export$9e3158dc6a3a0f92);
$parcel$export(module.exports, "PopupKeyline", () => $88fc3594fd7e78a2$export$a0765d4427758c62);
$parcel$export(module.exports, "PopupOverflowButton", () => $88fc3594fd7e78a2$export$aeb11758c9d29e5c);
$parcel$export(module.exports, "TimeDisplay", () => $88fc3594fd7e78a2$export$9b3df3d60caed5f9);
/* styled.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $1dJ6S = parcelRequire("1dJ6S");

var $41j30 = parcelRequire("41j30");
const $88fc3594fd7e78a2$export$cca08eed9de89ba9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4pxbi _1bsbnklw _1tkeys9h _vchhusvi",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$af2ec3aa21d10ab7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _otyr1b66",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$b11ea9d6e8111404 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$30301703d55848e7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1wmz _otyridpf _1e0c1txw _o5724jg8",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$fde5e3d077213a6f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1wmz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _o5724jg8",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$80b51772092eddc0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1wmz _1p1dangw _otyr1b66",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$b834616c6081368f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1dJ6S.default), {
        size: "xxsmall",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88fc3594fd7e78a2$export$80b51772092eddc0, props));
const $88fc3594fd7e78a2$export$9048d548939551ee = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $41j30.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81doa _k48p1igg _syaz1y58 _otyru2gc",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$9e3158dc6a3a0f92 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$a0765d4427758c62 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3it94y _bfhk1wws _otyrutpp",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$aeb11758c9d29e5c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yxxidpf _12r21nn1 _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$9b3df3d60caed5f9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66 _80omtlke",
            __cmplp.className
        ])
    });
});

});
parcelRegister("41j30", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c2f3c33a6194375$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8oe80 = parcelRequire("8oe80");

var $dIdda = parcelRequire("dIdda");
function $7c2f3c33a6194375$var$Link(props) {
    const { children: children, ...rest } = props;
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), rest, children);
}
var $7c2f3c33a6194375$export$2e2bcd8739ae039 = (0, $8oe80.default)('link', {
    onClick: 'clicked'
})($7c2f3c33a6194375$var$Link);

});


parcelRegister("dt6Va", function(module, exports) {

$parcel$export(module.exports, "useShowDevDetailDialogForPopup", () => $71478bde10e2ba46$export$cdc75a6c65207319);

var $4HJKb = parcelRequire("4HJKb");


var $dXq4S = parcelRequire("dXq4S");

var $8YTUU = parcelRequire("8YTUU");
const $71478bde10e2ba46$export$166d6c8e7de25541 = (issueAri)=>(0, $dXq4S.parseAri)(issueAri)?.resourceId;
const $71478bde10e2ba46$var$devInfoTypeToPanelDataType = (devInfoType)=>{
    if (devInfoType === (0, $8YTUU.DevInfoTypes).COMMIT) return 0, $61a2cd6236d50c20$export$2e42513c7764d5f3;
    if (devInfoType === (0, $8YTUU.DevInfoTypes).DEPLOYMENT) return 0, $61a2cd6236d50c20$export$90cac6260ae9ced5;
    return devInfoType;
};
function $71478bde10e2ba46$export$cdc75a6c65207319(scopeId) {
    const { showDevDetailDialog: showDevDetailDialog } = (0, $4HJKb.useDevOpsDetailsDialogLoaderActions)(scopeId || 'software-board.board');
    const showDevDetailDialogForPopup = (devInfoType, issueAri)=>{
        const type = $71478bde10e2ba46$var$devInfoTypeToPanelDataType(devInfoType);
        const issueId = $71478bde10e2ba46$export$166d6c8e7de25541(issueAri);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'PanelDataTypes'.
        showDevDetailDialog(type, undefined, '', issueId);
    };
    return {
        showDevDetailDialogForPopup: showDevDetailDialogForPopup
    };
}

});
parcelRegister("4HJKb", function(module, exports) {

$parcel$export(module.exports, "loadDialogBridge", () => $ccf4b85a4aaf3a68$export$7e12f7cd0f50fe5a);
$parcel$export(module.exports, "DevOpsDetailsDialogLoaderContainer", () => $ccf4b85a4aaf3a68$export$5e6e4cfb89bdcb55);
$parcel$export(module.exports, "DevOpsDetailsDialogLoaderSubscriber", () => $ccf4b85a4aaf3a68$export$693f51ab225dff94);
$parcel$export(module.exports, "useDevOpsDetailsDialogLoaderActions", () => $ccf4b85a4aaf3a68$export$506ad06ecf691cd3);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");


var $7JoAD = parcelRequire("7JoAD");

var $62M1I = parcelRequire("62M1I");
const $ccf4b85a4aaf3a68$export$7e12f7cd0f50fe5a = async ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $6BZYo.loadBridge)({
        name: (0, $62M1I.DEV_DETAILS_WRM_RESOURCE),
        wrmKeys: [
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-wrm',
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources'
        ]
    });
const $ccf4b85a4aaf3a68$export$e324594224ef24da = {
    resetState: (stateOverrides)=>({ setState: setState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                ...(0, $62M1I.INITIAL_STATE),
                ...stateOverrides
            });
        },
    updateState: (stateUpdates)=>({ getState: getState, setState: setState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                ...getState(),
                ...stateUpdates
            });
        },
    showDevDetailDialog: (itemType, legacyData, targetIssueKey, targetIssueId)=>({ setState: setState, getState: getState })=>{
            if (itemType === (0, $61a2cd6236d50c20$export$3f1e2b276d607490)) // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                legacyDevPanelDetailsDialogShownCounter: // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                getState().legacyDevPanelDetailsDialogShownCounter + 1,
                isDevPanelDetailsDialogShown: false,
                dataTypeSelected: itemType,
                legacyData: legacyData,
                issueKey: targetIssueKey,
                issueId: targetIssueId
            });
            else // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                isDevPanelDetailsDialogShown: true,
                dataTypeSelected: itemType,
                issueKey: targetIssueKey,
                issueId: targetIssueId
            });
        },
    closeDetailDialog: ()=>({ setState: setState, getState: getState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                // @ts-expect-error - TS2322 - Type '""' is not assignable to type 'PanelDataTypes | undefined'.
                dataTypeSelected: '',
                isDevPanelDetailsDialogShown: false,
                issueKey: undefined,
                issueId: undefined
            });
        }
};
const $ccf4b85a4aaf3a68$export$390f32400eaf98c9 = (0, $7JoAD.createStore)({
    name: 'DetailsDialogLoaderRemoteState',
    initialState: (0, $62M1I.INITIAL_STATE),
    actions: $ccf4b85a4aaf3a68$export$e324594224ef24da
});
const $ccf4b85a4aaf3a68$export$5e6e4cfb89bdcb55 = (0, $7JoAD.createContainer)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
const $ccf4b85a4aaf3a68$export$693f51ab225dff94 = (0, $7JoAD.createSubscriber)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
const $ccf4b85a4aaf3a68$export$550d4b3c29100112 = (0, $7JoAD.createHook)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
function $ccf4b85a4aaf3a68$export$506ad06ecf691cd3(scopeId) {
    return (0, $7JoAD.defaultRegistry).getStore($ccf4b85a4aaf3a68$export$390f32400eaf98c9, scopeId)?.actions;
}

});
parcelRegister("62M1I", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $bf37254db56efc10$export$36d128238e6b60f5);
$parcel$export(module.exports, "DEV_DETAILS_WRM_RESOURCE", () => $bf37254db56efc10$export$43a8ab4f373ff0ee);
const $bf37254db56efc10$export$36d128238e6b60f5 = {
    issueId: '',
    issueKey: undefined,
    locale: 'en_US',
    // @ts-expect-error - TS2322 - Type '""' is not assignable to type 'PanelDataTypes'.
    dataTypeSelected: '',
    legacyData: undefined,
    isDevPanelDetailsDialogShown: false,
    legacyDevPanelDetailsDialogShownCounter: 0
};
const $bf37254db56efc10$export$b5ed55f3ed234f95 = 'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources';
const $bf37254db56efc10$export$43a8ab4f373ff0ee = 'jira-development-status/releasereport/dev-status-dialog-bridge';
const $bf37254db56efc10$export$432f9ff6c01431e3 = 'jira-development-status/util/WRM';

});



parcelRegister("el2W3", function(module, exports) {

$parcel$export(module.exports, "default", () => $06bd70345536382a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $06bd70345536382a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorPopupTitle: {
        "id": "development-board-common.error-fallback.error-popup-title",
        "defaultMessage": "{devInfoType}"
    },
    errorTitle: {
        "id": "development-board-common.error-fallback.error-title",
        "defaultMessage": "Something went wrong"
    },
    errorDescription: {
        "id": "development-board-common.error-fallback.error-description",
        "defaultMessage": "For some reason we couldn't load this {devInfoType}."
    },
    developmentErrorDescriptionCta: {
        "id": "development-board-common.error-fallback.development-error-description-cta",
        "defaultMessage": "View all development information."
    },
    designErrorDescription: {
        "id": "development-board-common.error-fallback.design-error-description",
        "defaultMessage": "For some reason we couldn't load this design. Refresh your page to try again."
    }
});

});


parcelRegister("kcaDR", function(module, exports) {

$parcel$export(module.exports, "createIssueAri", () => $f1bea1631292edff$export$6b0ec881a3540845);

var $dXq4S = parcelRequire("dXq4S");
const $f1bea1631292edff$export$6b0ec881a3540845 = (cloudId, issueId)=>(0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId
    });

});

parcelRegister("7MIrF", function(module, exports) {

$parcel$export(module.exports, "BitbucketPullrequestMerged", () => $7a25946f9b14c935$export$3800ce670a7fa29b);
$parcel$export(module.exports, "BitbucketPullrequestDeclined", () => $7a25946f9b14c935$export$9a767285e35d722a);
$parcel$export(module.exports, "DeploymentProdSuccess", () => $7a25946f9b14c935$export$8409a6d16fd5ac8e);
$parcel$export(module.exports, "DeploymentNonProdSuccess", () => $7a25946f9b14c935$export$814ebe75b826c47b);
$parcel$export(module.exports, "DeploymentProdFailed", () => $7a25946f9b14c935$export$22f2b1620b38359);
$parcel$export(module.exports, "DeploymentNonProdFailed", () => $7a25946f9b14c935$export$5b461fe0712c5c45);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");


var $4R6GH = parcelRequire("4R6GH");
const $7a25946f9b14c935$export$3800ce670a7fa29b = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        size: size,
        label: label,
        glyph: ()=>(0, $4R6GH.fg)('optimise_development_and_deployment_icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24",
                width: "24",
                height: "24",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                d: "M0 0h24v24H0z",
                fillOpacity: ".01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
                fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
                clipRule: "evenodd",
                fillRule: "evenodd"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "M7 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM4 6a3 3 0 1 1 4 2.83V20a1 1 0 1 1-2 0V8.83A3.001 3.001 0 0 1 4 6z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "M7 7a1 1 0 0 1 1 1v2a7.001 7.001 0 0 0 6.188 6.953 3.001 3.001 0 1 1-.03 2.008A9.001 9.001 0 0 1 6 10V8a1 1 0 0 1 1-1zm10 10a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM20.707 4.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L16 7.586l3.293-3.293a1 1 0 0 1 1.414 0z"
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                fill: "none",
                height: "24",
                viewBox: "0 0 24 24",
                width: "24",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "m0 0h24v24h-24z",
                fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                fillOpacity: ".01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
                clipRule: "evenodd",
                fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
                fillRule: "evenodd"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "m7 5c-.55228 0-1 .44772-1 1s.44772 1 1 1 1-.44772 1-1-.44772-1-1-1zm-3 1c0-1.65685 1.34315-3 3-3s3 1.34315 3 3c0 1.30622-.83481 2.41746-2 2.82929v11.17071c0 .5523-.44772 1-1 1s-1-.4477-1-1v-11.17071c-1.16519-.41183-2-1.52307-2-2.82929z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "m7 7c.55228 0 1 .44772 1 1v2c0 3.5912 2.7043 6.5508 6.1876 6.9534.4247-1.1408 1.5237-1.9534 2.8124-1.9534 1.6569 0 3 1.3431 3 3s-1.3431 3-3 3c-1.3207 0-2.4421-.8534-2.8428-2.0389-4.57535-.4249-8.1572-4.2747-8.1572-8.9611v-2c0-.55228.44772-1 1-1zm10 10c-.5523 0-1 .4477-1 1s.4477 1 1 1 1-.4477 1-1-.4477-1-1-1z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "m20.7071 4.29289c.3905.39053.3905 1.02369 0 1.41422l-4 4c-.3905.39049-1.0237.39049-1.4142 0l-2-2c-.3905-.39053-.3905-1.02369 0-1.41422.3905-.39052 1.0237-.39052 1.4142 0l1.2929 1.2929 3.2929-3.2929c.3905-.39052 1.0237-.39052 1.4142 0z"
            })))
    });
const $7a25946f9b14c935$export$9a767285e35d722a = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        size: size,
        label: label,
        glyph: ()=>(0, $4R6GH.fg)('optimise_development_and_deployment_icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24",
                width: "24",
                height: "24",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                d: "M0 0h24v24H0z",
                fillOpacity: "0"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
                fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
                clipRule: "evenodd",
                fillRule: "evenodd"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "M7 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM4 6a3 3 0 1 1 4 2.8V20a1 1 0 1 1-2 0V8.8A3 3 0 0 1 4 6zM17 11c.6 0 1 .4 1 1v3.2a3 3 0 1 1-2 0V12c0-.6.4-1 1-1zm0 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM13.8 2.8a1 1 0 0 1 1.4 0L17 4.6l1.8-1.8a1 1 0 1 1 1.4 1.4L18.4 6l1.8 1.8a1 1 0 0 1-1.4 1.4L17 7.4l-1.8 1.8a1 1 0 1 1-1.4-1.4L15.6 6l-1.8-1.8a1 1 0 0 1 0-1.4z"
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                fill: "none",
                height: "24",
                viewBox: "0 0 24 24",
                width: "24",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "m0 0h24v24h-24z",
                fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                fillOpacity: ".01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
                clipRule: "evenodd",
                fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
                fillRule: "evenodd"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "m7 5c-.55228 0-1 .44772-1 1s.44772 1 1 1 1-.44772 1-1-.44772-1-1-1zm-3 1c0-1.65685 1.34315-3 3-3s3 1.34315 3 3c0 1.30622-.83481 2.41746-2 2.82929v11.17071c0 .5523-.44772 1-1 1s-1-.4477-1-1v-11.17071c-1.16519-.41183-2-1.52307-2-2.82929z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "m17 11c.5523 0 1 .4477 1 1v3.1707c1.1652.4118 2 1.5231 2 2.8293 0 1.6569-1.3431 3-3 3s-3-1.3431-3-3c0-1.3062.8348-2.4175 2-2.8293v-3.1707c0-.5523.4477-1 1-1zm0 6c-.5523 0-1 .4477-1 1s.4477 1 1 1 1-.4477 1-1-.4477-1-1-1z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "m13.7929 2.79289c.3905-.39052 1.0237-.39052 1.4142 0l1.7929 1.7929 1.7929-1.7929c.3905-.39052 1.0237-.39052 1.4142 0 .3905.39053.3905 1.02369 0 1.41422l-1.7929 1.79289 1.7929 1.79289c.3905.39053.3905 1.02369 0 1.41422-.3905.39052-1.0237.39052-1.4142 0l-1.7929-1.7929-1.7929 1.7929c-.3905.39052-1.0237.39052-1.4142 0-.3905-.39053-.3905-1.02369 0-1.41422l1.7929-1.79289-1.7929-1.79289c-.3905-.39053-.3905-1.02369 0-1.41422z"
            })))
    });
const $7a25946f9b14c935$export$8409a6d16fd5ac8e = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        size: size,
        label: label,
        glyph: ()=>(0, $4R6GH.fg)('optimise_development_and_deployment_icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 16 16",
                width: "16",
                height: "16",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                d: "M0 0h16v16H0z",
                fillOpacity: ".01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
                d: "M1 9.75a3.15 3.15 0 0 0 2.8 3.13v.02h8.4v-.02a3.15 3.15 0 0 0 .533-6.155 4.902 4.902 0 0 0-9.466 0A3.151 3.151 0 0 0 1 9.75Zm5.85-1.8a.669.669 0 1 0-.946.946l1.15 1.15a.67.67 0 0 0 .946 0l2.096-2.096a.67.67 0 1 0-.946-.946L7.527 8.627 6.85 7.95Z",
                clipRule: "evenodd",
                fillRule: "evenodd"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                width: "16",
                height: "16",
                fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                fillOpacity: "0.01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1 9.74998C1 11.3714 2.22503 12.7067 3.80003 12.8808V12.9H12.2V12.8807C13.775 12.7066 15 11.3713 15 9.74998C15 8.31668 14.0427 7.10697 12.7326 6.72531C12.1716 4.63715 10.2653 3.09998 8.00006 3.09998C5.73479 3.09998 3.82855 4.63713 3.2675 6.72527C1.95735 7.10688 1 8.31663 1 9.74998ZM6.84995 7.94994C6.78825 7.88606 6.71445 7.83511 6.63285 7.80005C6.55124 7.765 6.46348 7.74655 6.37467 7.74578C6.28586 7.745 6.19778 7.76193 6.11558 7.79556C6.03338 7.82919 5.9587 7.87885 5.8959 7.94165C5.8331 8.00445 5.78344 8.07913 5.74981 8.16133C5.71618 8.24353 5.69925 8.33161 5.70003 8.42042C5.7008 8.50923 5.71925 8.59699 5.7543 8.6786C5.78936 8.7602 5.84031 8.834 5.90419 8.8957L7.0542 10.0457C7.17963 10.171 7.34973 10.2415 7.52708 10.2415C7.70444 10.2415 7.87453 10.171 7.99996 10.0457L10.0958 7.94996C10.1597 7.88826 10.2106 7.81446 10.2457 7.73286C10.2808 7.65125 10.2992 7.56349 10.3 7.47467C10.3007 7.38586 10.2838 7.29779 10.2502 7.21559C10.2166 7.13339 10.1669 7.05871 10.1041 6.99591C10.0413 6.93311 9.96662 6.88345 9.88442 6.84982C9.80222 6.81619 9.71414 6.79926 9.62533 6.80003C9.53652 6.80081 9.44876 6.81926 9.36715 6.85431C9.28555 6.88936 9.21175 6.94032 9.15005 7.0042L7.52708 8.62702L6.84995 7.94994Z",
                fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`
            }))
    });
const $7a25946f9b14c935$export$814ebe75b826c47b = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        size: size,
        label: label,
        glyph: ()=>(0, $4R6GH.fg)('optimise_development_and_deployment_icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 16 16",
                width: "16",
                height: "16",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                d: "M0 0h16v16H0z",
                fillOpacity: "0"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
                id: "a",
                fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
                d: "M3.8 12.9a3.2 3.2 0 0 1-.5-6.2 4.9 4.9 0 0 1 9.4 0 3.2 3.2 0 0 1-.5 6.2H3.8Z",
                clipRule: "evenodd",
                fillRule: "evenodd"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
                d: "M3.8 12.9h1.5v-1.4L4 11.4l-.2 1.5Zm-.5-6.2.4 1.5.8-.3.2-.8-1.4-.4Zm9.4 0-1.4.4.2.8.8.3.4-1.5Zm-.5 6.2-.2-1.5-1.3.1V13h1.5Zm0 0v1.5h1.5v-1.5h-1.5Zm-8.4 0H2.3v1.5h1.5v-1.5Zm.2-1.5c-.9-.1-1.5-.8-1.5-1.7h-3c0 2.4 1.8 4.4 4.1 4.7l.4-3ZM2.5 9.7c0-.7.5-1.3 1.2-1.5l-.9-3C1 5.9-.5 7.7-.5 9.8h3Zm2.2-2.6A3.4 3.4 0 0 1 8 4.6v-3c-3 0-5.4 2-6.2 4.7l3 .8ZM8 4.6c1.6 0 2.9 1 3.3 2.5l2.9-.8A6.4 6.4 0 0 0 8 1.6v3Zm4.3 3.6c.7.2 1.2.8 1.2 1.5h3c0-2-1.4-3.9-3.3-4.4l-.9 2.9Zm1.2 1.5c0 .9-.6 1.6-1.5 1.7l.4 3a4.7 4.7 0 0 0 4.1-4.7h-3ZM10.7 13h3-3Zm1.5-1.5H3.8v3h8.4v-3Zm-6.9 1.5h-3 3Z",
                mask: "url(#a)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
                d: "M6.8 7.9 7 8l.6.6L9 7.2a.6.6 0 1 1 .8.8L8 9.8a.6.6 0 0 1-.8 0l-1-1a.6.6 0 0 1 .6-1Z"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                width: "16",
                height: "16",
                fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                fillOpacity: "0.01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
                id: "path-1-inside-1_81_24007",
                fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.80003 12.8808C2.22503 12.7067 1 11.3714 1 9.74998C1 8.31663 1.95735 7.10688 3.2675 6.72527C3.82855 4.63713 5.73479 3.09998 8.00006 3.09998C10.2653 3.09998 12.1716 4.63715 12.7326 6.72531C14.0427 7.10697 15 8.31668 15 9.74998C15 11.3713 13.775 12.7066 12.2 12.8807V12.9H3.80003V12.8808Z"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "M3.80003 12.8808H5.30003V11.5374L3.96483 11.3898L3.80003 12.8808ZM3.2675 6.72527L3.68698 8.16542L4.49716 7.92944L4.71613 7.11449L3.2675 6.72527ZM12.7326 6.72531L11.284 7.11452L11.5029 7.92943L12.3131 8.16544L12.7326 6.72531ZM12.2 12.8807L12.0352 11.3898L10.7 11.5374V12.8807H12.2ZM12.2 12.9V14.4H13.7V12.9H12.2ZM3.80003 12.9H2.30003V14.4H3.80003V12.9ZM3.96483 11.3898C3.14142 11.2988 2.5 10.5983 2.5 9.74998H-0.5C-0.5 12.1445 1.30864 14.1145 3.63523 14.3717L3.96483 11.3898ZM2.5 9.74998C2.5 9.00137 2.99976 8.36559 3.68698 8.16542L2.84803 5.28511C0.914937 5.84817 -0.5 7.63188 -0.5 9.74998H2.5ZM4.71613 7.11449C5.10556 5.66505 6.43035 4.59998 8.00006 4.59998V1.59998C5.03923 1.59998 2.55153 3.60922 1.81888 6.33605L4.71613 7.11449ZM8.00006 4.59998C9.56978 4.59998 10.8946 5.66506 11.284 7.11452L14.1812 6.33611C13.4486 3.60925 10.9609 1.59998 8.00006 1.59998V4.59998ZM12.3131 8.16544C13.0003 8.36564 13.5 9.0014 13.5 9.74998H16.5C16.5 7.63196 15.0851 5.8483 13.1522 5.28518L12.3131 8.16544ZM13.5 9.74998C13.5 10.5983 12.8586 11.2988 12.0352 11.3898L12.3649 14.3717C14.6914 14.1144 16.5 12.1444 16.5 9.74998H13.5ZM10.7 12.8807V12.9H13.7V12.8807H10.7ZM12.2 11.4H3.80003V14.4H12.2V11.4ZM5.30003 12.9V12.8808H2.30003V12.9H5.30003Z",
                fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
                mask: "url(#path-1-inside-1_81_24007)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "M6.81117 7.86961C6.88213 7.90009 6.94631 7.9444 6.99996 7.99995L7.58877 8.58871L9.00004 7.17757C9.05369 7.12202 9.11787 7.07771 9.18883 7.04723C9.25979 7.01674 9.33611 7.0007 9.41333 7.00003C9.49056 6.99936 9.56715 7.01407 9.63862 7.04332C9.7101 7.07256 9.77504 7.11575 9.82965 7.17036C9.88426 7.22497 9.92745 7.28991 9.95669 7.36138C9.98593 7.43286 10.0006 7.50945 9.99998 7.58667C9.99931 7.6639 9.98326 7.74022 9.95278 7.81118C9.9223 7.88214 9.87799 7.94632 9.82244 7.99997L7.99997 9.82231C7.8909 9.93135 7.74299 9.9926 7.58877 9.9926C7.43454 9.9926 7.28663 9.93135 7.17757 9.82231L6.17756 8.82235C6.12201 8.7687 6.0777 8.70452 6.04722 8.63356C6.01674 8.5626 6.00069 8.48628 6.00002 8.40906C5.99935 8.33183 6.01407 8.25525 6.04331 8.18377C6.07255 8.11229 6.11574 8.04735 6.17035 7.99274C6.22496 7.93813 6.2899 7.89495 6.36138 7.8657C6.43285 7.83646 6.50944 7.82174 6.58667 7.82241C6.66389 7.82308 6.74021 7.83913 6.81117 7.86961Z",
                fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`
            }))
    });
const $7a25946f9b14c935$export$22f2b1620b38359 = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        size: size,
        label: label,
        glyph: ()=>(0, $4R6GH.fg)('optimise_development_and_deployment_icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 16 16",
                width: "16",
                height: "16",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                d: "M0 0h16v16H0z",
                fillOpacity: ".01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
                d: "M3.8 12.88a3.15 3.15 0 0 1-.53-6.15 4.9 4.9 0 0 1 9.46 0 3.15 3.15 0 0 1-.53 6.15v.02H3.8v-.02Zm3.55-6.63a.75.75 0 0 1 1.5 0v2a.75.75 0 0 1-1.5 0v-2ZM8.1 9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z",
                clipRule: "evenodd",
                fillRule: "evenodd"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                width: "16",
                height: "16",
                fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                fillOpacity: "0.01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.80003 12.8808C2.22503 12.7067 1 11.3714 1 9.74998C1 8.31663 1.95735 7.10688 3.2675 6.72527C3.82855 4.63713 5.73479 3.09998 8.00006 3.09998C10.2653 3.09998 12.1716 4.63715 12.7326 6.72531C14.0427 7.10697 15 8.31668 15 9.74998C15 11.3713 13.775 12.7066 12.2 12.8807V12.9H3.80003V12.8808ZM7.35 6.25C7.35 5.83579 7.68579 5.5 8.1 5.5C8.51421 5.5 8.85 5.83579 8.85 6.25V8.25C8.85 8.66421 8.51421 9 8.1 9C7.68579 9 7.35 8.66421 7.35 8.25V6.25ZM8.1 9.5C7.68579 9.5 7.35 9.83579 7.35 10.25C7.35 10.6642 7.68579 11 8.1 11C8.51421 11 8.85 10.6642 8.85 10.25C8.85 9.83579 8.51421 9.5 8.1 9.5Z",
                fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`
            }))
    });
const $7a25946f9b14c935$export$5b461fe0712c5c45 = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        size: size,
        label: label,
        glyph: ()=>(0, $4R6GH.fg)('optimise_development_and_deployment_icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 16 16",
                width: "16",
                height: "16",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                d: "M0 0h16v16H0z",
                fillOpacity: "0"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
                id: "a",
                fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
                d: "M3.8 12.9a3.2 3.2 0 0 1-.5-6.2 4.9 4.9 0 0 1 9.4 0 3.2 3.2 0 0 1-.5 6.2H3.8Z",
                clipRule: "evenodd",
                fillRule: "evenodd"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
                d: "M3.8 12.9h1.5v-1.4L4 11.4l-.2 1.5Zm-.5-6.2.4 1.5.8-.3.2-.8-1.4-.4Zm9.4 0-1.4.4.2.8.8.3.4-1.5Zm-.5 6.2-.2-1.5-1.3.1V13h1.5Zm0 0v1.5h1.5v-1.5h-1.5Zm-8.4 0H2.3v1.5h1.5v-1.5Zm.2-1.5c-.9-.1-1.5-.8-1.5-1.7h-3c0 2.4 1.8 4.4 4.1 4.7l.4-3ZM2.5 9.7c0-.7.5-1.3 1.2-1.5l-.9-3C1 5.9-.5 7.7-.5 9.8h3Zm2.2-2.6A3.4 3.4 0 0 1 8 4.6v-3c-3 0-5.4 2-6.2 4.7l3 .8ZM8 4.6c1.6 0 2.9 1 3.3 2.5l2.9-.8A6.4 6.4 0 0 0 8 1.6v3Zm4.3 3.6c.7.2 1.2.8 1.2 1.5h3c0-2-1.4-3.9-3.3-4.4l-.9 2.9Zm1.2 1.5c0 .9-.6 1.6-1.5 1.7l.4 3a4.7 4.7 0 0 0 4.1-4.7h-3ZM10.7 13h3-3Zm1.5-1.5H3.8v3h8.4v-3Zm-6.9 1.5h-3 3Z",
                mask: "url(#a)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                width: "1.5",
                height: "3.5",
                x: "7.4",
                y: "5.5",
                fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
                rx: ".8"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                width: "1.5",
                height: "1.5",
                x: "7.4",
                y: "9.5",
                fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
                rx: ".8"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                width: "16",
                height: "16",
                fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                fillOpacity: "0.01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
                id: "path-1-inside-1_91_14760",
                fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
                d: "M3.80003 12.8808C2.22503 12.7067 1 11.3714 1 9.74998C1 8.31663 1.95735 7.10688 3.2675 6.72527C3.82855 4.63713 5.73479 3.09998 8.00006 3.09998C10.2653 3.09998 12.1716 4.63715 12.7326 6.72531C14.0427 7.10697 15 8.31668 15 9.74998C15 11.3713 13.775 12.7066 12.2 12.8807V12.9H3.80003V12.8808Z"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "M3.80003 12.8808H5.30003V11.5374L3.96483 11.3898L3.80003 12.8808ZM3.2675 6.72527L3.68698 8.16542L4.49716 7.92944L4.71613 7.11449L3.2675 6.72527ZM12.7326 6.72531L11.284 7.11452L11.5029 7.92943L12.3131 8.16544L12.7326 6.72531ZM12.2 12.8807L12.0352 11.3898L10.7 11.5374V12.8807H12.2ZM12.2 12.9V14.4H13.7V12.9H12.2ZM3.80003 12.9H2.30003V14.4H3.80003V12.9ZM3.96483 11.3898C3.14142 11.2988 2.5 10.5983 2.5 9.74998H-0.5C-0.5 12.1445 1.30864 14.1145 3.63523 14.3717L3.96483 11.3898ZM2.5 9.74998C2.5 9.00137 2.99976 8.36559 3.68698 8.16542L2.84803 5.28511C0.914937 5.84817 -0.5 7.63188 -0.5 9.74998H2.5ZM4.71613 7.11449C5.10556 5.66505 6.43035 4.59998 8.00006 4.59998V1.59998C5.03923 1.59998 2.55153 3.60922 1.81888 6.33605L4.71613 7.11449ZM8.00006 4.59998C9.56978 4.59998 10.8946 5.66506 11.284 7.11452L14.1812 6.33611C13.4486 3.60925 10.9609 1.59998 8.00006 1.59998V4.59998ZM12.3131 8.16544C13.0003 8.36564 13.5 9.0014 13.5 9.74998H16.5C16.5 7.63196 15.0851 5.8483 13.1522 5.28518L12.3131 8.16544ZM13.5 9.74998C13.5 10.5983 12.8586 11.2988 12.0352 11.3898L12.3649 14.3717C14.6914 14.1144 16.5 12.1444 16.5 9.74998H13.5ZM10.7 12.8807V12.9H13.7V12.8807H10.7ZM12.2 11.4H3.80003V14.4H12.2V11.4ZM5.30003 12.9V12.8808H2.30003V12.9H5.30003Z",
                fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
                mask: "url(#path-1-inside-1_91_14760)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                x: "7.3501",
                y: "5.5",
                width: "1.5",
                height: "3.5",
                rx: "0.75",
                fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                x: "7.3501",
                y: "9.5",
                width: "1.5",
                height: "1.5",
                rx: "0.75",
                fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`
            }))
    });

});

parcelRegister("47gW9", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $1be876415a945060$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $1be876415a945060$export$5f13515bd3a35325);

var $5uXOq = parcelRequire("5uXOq");

var $iRKpN = parcelRequire("iRKpN");
const $1be876415a945060$export$25d2524a63315ed = (actions, isActive = true, eventMap = $1be876415a945060$export$5f13515bd3a35325(actions))=>{
    const removePreviousListeners = (0, $5uXOq.useRef)(null);
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $5uXOq.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        if (element && isActive) {
            (0, $iRKpN.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: eventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $iRKpN.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: eventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        eventMap,
        isActive
    ]);
};
const $1be876415a945060$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("iRKpN", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $62bae43418420b8a$export$15257a36a7e3f9d6);
function $62bae43418420b8a$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});


parcelRegister("ivDCs", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointContainer", () => $832a9e21b9f9d7ff$export$4d67c6ee49f3d14d);

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $8Bm0k = parcelRequire("8Bm0k");

var $c5vfY = parcelRequire("c5vfY");
const $832a9e21b9f9d7ff$export$4d67c6ee49f3d14d = ({ entryPointActions: { unload: unload }, entryPointReferenceSubject: entryPointReferenceSubject, errorFallback: errorFallback, runtimeProps: runtimeProps, ...containerProps })=>{
    const entryPointReference = (0, $8Bm0k.useEntryPointSubscription)(entryPointReferenceSubject);
    const props = (0, $5uXOq.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            ...runtimeProps,
            onClose () {
                runtimeProps.onClose?.();
                unload();
            }
        }), [
        runtimeProps,
        unload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, entryPointReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5vfY.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        errorFallback: errorFallback || 'flag',
        placeholderName: "modal-entry-point-container",
        runtimeProps: props
    }));
};

});

parcelRegister("lXSZ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $bacacc98904ab4af$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $bacacc98904ab4af$var$DesignIconSVG = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "currentcolor",
        d: "M9.864 10.736c.77-.746 1.893-.536 2.72.265.826.8 1.043 1.888.273 2.634-1.816 1.76-5.482 2.002-4.765 1.207 1.587-1.76.578-2.949 1.772-4.106M19.968 4.03c.402.378-3.1 4.732-4.427 5.98-.659.62-1.012.826-1.276 1.016-.115.082-.15-.027-.177-.076a3.7 3.7 0 0 0-.63-.801c-.236-.222-.607-.445-.867-.572-.053-.025-.169-.058-.08-.166.201-.249.421-.58 1.08-1.2 1.327-1.247 5.974-4.56 6.377-4.181M18.38 19.946a1 1 0 0 1-.332.054.95.95 0 0 1-.913-.628c-.343-.957-1.14-1.642-2.257-1.933-2.182-.568-3.22-.264-5.053.995l-.16.11a9 9 0 0 1-1.049.644c-1.477.755-2.632.825-3.482.419-.586-.28-.989-.794-1.1-1.407-.254-1.403.93-2.647 2.602-3.156a.906.906 0 0 1 1.155.601.92.92 0 0 1-.62 1.186c-.33.1-.717.311-.978.533-.195.165-.33.355-.306.434.042.138.088.185.16.214.155.063.445.029.818-.096q.247-.083.524-.21c.196-.088.348-.165.58-.287.076-.04.177-.11.445-.303 1.09-.784 1.802-1.198 2.845-1.52 1.562-.482 3.18-.39 4.802.272 1.399.57 2.399 1.589 2.883 2.94.174.483-.07.97-.564 1.138"
    }));
const $bacacc98904ab4af$var$DesignIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        ...props,
        glyph: $bacacc98904ab4af$var$DesignIconSVG
    });
var $bacacc98904ab4af$export$2e2bcd8739ae039 = $bacacc98904ab4af$var$DesignIcon;

});

parcelRegister("7IEKg", function(module, exports) {

$parcel$export(module.exports, "designModalEntryPoint", () => $1a95bcb1a4c0b956$export$b98395a806b85a49);

var $69fJl = parcelRequire("69fJl");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $1a95bcb1a4c0b956$export$b98395a806b85a49 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("j0MGN")), {
        moduleId: "576d28f0"
    }),
    getPreloadProps: ({ siteAri: siteAri, issueAri: issueAri, cloudId: cloudId, designAri: designAri })=>({
            queries: {
                designModal: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $69fJl.default),
                    variables: {
                        siteAri: siteAri,
                        issueAri: issueAri,
                        cloudId: cloudId,
                        designAri: designAri
                    }
                }
            }
        })
});

});
parcelRegister("69fJl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c20e9923143cad3f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1775dc6f451f5aa08f2de993d8e993cc>>
 * @relayHash f75963656ac83b6e4f5b855b41942d4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5455aa42cc5ba971a154b4555e76f70cb6faf70a0f41a193d62856efb789841b
const $c20e9923143cad3f$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5455aa42cc5ba971a154b4555e76f70cb6faf70a0f41a193d62856efb789841b",
        "metadata": {},
        "name": "ui_DesignModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c20e9923143cad3f$export$2e2bcd8739ae039 = $c20e9923143cad3f$var$node;

});

parcelRegister("j0MGN", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("ddPfp")
]).then(()=>parcelRequire('ebk7x'));

});


parcelRegister("a3HWu", function(module, exports) {

$parcel$export(module.exports, "DevInfoDetailsPopupSkeleton", () => $93f34a824a74f869$export$9044eba4855892a5);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $gnABE = parcelRequire("gnABE");

var $kfBZt = parcelRequire("kfBZt");

var $if4PE = parcelRequire("if4PE");

var $gVTPk = parcelRequire("gVTPk");

var $i2tpm = parcelRequire("i2tpm");

var $5swzJ = parcelRequire("5swzJ");
// Try to keep SPA JS bundle as small as possible, skeletons should not have dependencies, so here we use hard coding instead of import gridSize
const $93f34a824a74f869$var$customCssStyles = null;
const $93f34a824a74f869$var$skeletonStyles = null;
const $93f34a824a74f869$export$ae7439e01588d047 = {
    BRANCH: 'branch',
    COMMIT: 'commit',
    PULLREQUEST: 'pullrequest',
    DEPLOYMENT: 'deployment',
    DESIGN: 'design'
};
const $93f34a824a74f869$var$skeletonAsset = {
    [$93f34a824a74f869$export$ae7439e01588d047.BRANCH]: (0, (/*@__PURE__*/$parcel$interopDefault($kfBZt))),
    [$93f34a824a74f869$export$ae7439e01588d047.COMMIT]: (0, (/*@__PURE__*/$parcel$interopDefault($if4PE))),
    [$93f34a824a74f869$export$ae7439e01588d047.PULLREQUEST]: (0, (/*@__PURE__*/$parcel$interopDefault($5swzJ))),
    [$93f34a824a74f869$export$ae7439e01588d047.DEPLOYMENT]: (0, (/*@__PURE__*/$parcel$interopDefault($gVTPk))),
    [$93f34a824a74f869$export$ae7439e01588d047.DESIGN]: (0, (/*@__PURE__*/$parcel$interopDefault($i2tpm)))
};
const $93f34a824a74f869$export$9044eba4855892a5 = ({ devinfoType: devinfoType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            devinfoType === $93f34a824a74f869$export$ae7439e01588d047.BRANCH && "_1bsbnklw _4t3i1lit _1yt41lhn _vchhusvi",
            devinfoType === $93f34a824a74f869$export$ae7439e01588d047.COMMIT && "_1bsbnklw _4t3i1lit _1yt41lhn _vchhusvi",
            devinfoType === $93f34a824a74f869$export$ae7439e01588d047.PULLREQUEST && "_1bsbnklw _1yt41lhn _vchhusvi _4t3imgvx",
            devinfoType === $93f34a824a74f869$export$ae7439e01588d047.DEPLOYMENT && "_1bsbnklw _4t3i1lit",
            devinfoType === $93f34a824a74f869$export$ae7439e01588d047.DESIGN && "_1bsbnklw _4t3i1lit _1yt41lhn _vchhusvi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gnABE.AppSkeletonImage), {
        src: $93f34a824a74f869$var$skeletonAsset[devinfoType],
        className: (0, $bwpsq.default)([
            "_1wgmglyw _rcujmgjw"
        ])
    }));

});
parcelRegister("kfBZt", function(module, exports) {
module.exports = new URL("branch-details-popup.tpl.90980aef.svg", import.meta.url).toString();

});

parcelRegister("if4PE", function(module, exports) {
module.exports = new URL("commit-details-popup.tpl.ef7b25c8.svg", import.meta.url).toString();

});

parcelRegister("gVTPk", function(module, exports) {
module.exports = new URL("deployment-details-popup.tpl.d0e045e6.svg", import.meta.url).toString();

});

parcelRegister("i2tpm", function(module, exports) {
module.exports = new URL("design-details-popup.tpl.da785a24.svg", import.meta.url).toString();

});

parcelRegister("5swzJ", function(module, exports) {
module.exports = new URL("pr-details-popup.tpl.2fd71422.svg", import.meta.url).toString();

});


parcelRegister("gicL9", function(module, exports) {

$parcel$export(module.exports, "HOVER_TIMEOUT_MS", () => $045105c41d1dfec6$export$bbec45119b804b4d);
$parcel$export(module.exports, "DevInfoIconPropsMapping", () => $045105c41d1dfec6$export$cd5138f3581ca0d5);
$parcel$export(module.exports, "DevInfoButtonLabelMapping", () => $045105c41d1dfec6$export$41f3316f17440396);
$parcel$export(module.exports, "iconColor", () => $045105c41d1dfec6$export$3797a580396e3639);
$parcel$export(module.exports, "experienceDetails", () => $045105c41d1dfec6$export$ba2604b0fdde2542);
$parcel$export(module.exports, "metrics", () => $045105c41d1dfec6$export$b0c5c2fac8144e54);
$parcel$export(module.exports, "packageDetails", () => $045105c41d1dfec6$export$48b44d9f3c6e15de);
$parcel$export(module.exports, "popupEntryPoints", () => $045105c41d1dfec6$export$1452632269dce6);
$parcel$export(module.exports, "DeploymentState", () => $045105c41d1dfec6$export$a12a01ce2571070a);
$parcel$export(module.exports, "DeploymentEnvironment", () => $045105c41d1dfec6$export$618f130aff825d2b);

var $8QpSo = parcelRequire("8QpSo");


var $4Dm5W = parcelRequire("4Dm5W");

var $6KTxo = parcelRequire("6KTxo");

var $8YTUU = parcelRequire("8YTUU");

var $6dYOr = parcelRequire("6dYOr");

var $jH32b = parcelRequire("jH32b");

var $890PS = parcelRequire("890PS");

var $4Dyci = parcelRequire("4Dyci");

var $8GnxT = parcelRequire("8GnxT");
const $045105c41d1dfec6$export$bbec45119b804b4d = 300;
const $045105c41d1dfec6$export$cd5138f3581ca0d5 = (0, $8QpSo.default)((formatMessage)=>({
        [(0, $8YTUU.DevInfoTypes).BRANCH]: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            size: 'small',
            label: formatMessage((0, $4Dyci.default).branchIconLabel)
        },
        [(0, $8YTUU.DevInfoTypes).COMMIT]: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            size: 'small',
            label: formatMessage((0, $4Dyci.default).commitIconLabel)
        },
        [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            size: 'small',
            label: formatMessage((0, $4Dyci.default).openPullRequestIconLabel)
        },
        [(0, $8YTUU.DevInfoTypes).DECLINED]: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            size: 'small',
            label: formatMessage((0, $4Dyci.default).declinedPullRequestIconLabel)
        },
        [(0, $8YTUU.DevInfoTypes).MERGED]: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            size: 'small',
            label: formatMessage((0, $4Dyci.default).mergedPullRequestIconLabel)
        },
        [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            size: 'small',
            label: formatMessage((0, $4Dyci.default).deploymentIconLabel)
        },
        [(0, $8YTUU.DevInfoTypes).DESIGN]: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            size: 'small',
            label: formatMessage((0, $4Dyci.default).designIconLabel)
        }
    }));
const $045105c41d1dfec6$export$41f3316f17440396 = (0, $8QpSo.default)((formatMessage)=>({
        [(0, $8YTUU.DevInfoTypes).BRANCH]: formatMessage((0, $4Dyci.default).branchIconButtonLabel),
        [(0, $8YTUU.DevInfoTypes).COMMIT]: formatMessage((0, $4Dyci.default).commitIconButtonLabel),
        [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: formatMessage((0, $4Dyci.default).pullRequestIconButtonLabel),
        [(0, $8YTUU.DevInfoTypes).MERGED]: formatMessage((0, $4Dyci.default).pullRequestIconButtonLabel),
        [(0, $8YTUU.DevInfoTypes).DECLINED]: formatMessage((0, $4Dyci.default).pullRequestIconButtonLabel),
        [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: formatMessage((0, $4Dyci.default).deploymentIconButtonLabel),
        [(0, $8YTUU.DevInfoTypes).DESIGN]: formatMessage((0, $4Dyci.default).designIconButtonLabel)
    }));
const $045105c41d1dfec6$export$3797a580396e3639 = {
    [(0, $8YTUU.DevInfoTypes).BRANCH]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        [(0, $8YTUU.ButtonStatus).HOVER]: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N500})`,
        [(0, $8YTUU.ButtonStatus).DEFAULT]: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N100})`
    },
    [(0, $8YTUU.DevInfoTypes).COMMIT]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        [(0, $8YTUU.ButtonStatus).HOVER]: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N500})`,
        [(0, $8YTUU.ButtonStatus).DEFAULT]: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N100})`
    },
    [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        [(0, $8YTUU.ButtonStatus).HOVER]: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N500})`,
        [(0, $8YTUU.ButtonStatus).DEFAULT]: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N100})`
    },
    [(0, $8YTUU.DevInfoTypes).MERGED]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G200})`,
        [(0, $8YTUU.ButtonStatus).HOVER]: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
        [(0, $8YTUU.ButtonStatus).DEFAULT]: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`
    },
    [(0, $8YTUU.DevInfoTypes).DECLINED]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R100})`,
        [(0, $8YTUU.ButtonStatus).HOVER]: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
        [(0, $8YTUU.ButtonStatus).DEFAULT]: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`
    },
    [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        [(0, $8YTUU.ButtonStatus).HOVER]: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N500})`,
        [(0, $8YTUU.ButtonStatus).DEFAULT]: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N100})`
    },
    [(0, $8YTUU.DevInfoTypes).DESIGN]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        [(0, $8YTUU.ButtonStatus).HOVER]: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N500})`,
        [(0, $8YTUU.ButtonStatus).DEFAULT]: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N100})`
    }
};
const $045105c41d1dfec6$export$ba2604b0fdde2542 = {
    [(0, $8YTUU.DevInfoTypes).BRANCH]: {
        id: 'branchDetailsPopup',
        name: 'jiraSoftwareBoardBranchDetailsPopup'
    },
    [(0, $8YTUU.DevInfoTypes).COMMIT]: {
        id: 'commitDetailsPopup',
        name: 'jiraSoftwareBoardCommitDetailsPopup'
    },
    [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: {
        id: 'deploymentDetailsPopup',
        name: 'jiraSoftwareBoardDeploymentDetailsPopup'
    },
    [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: {
        id: 'prDetailsPopup',
        name: 'jiraSoftwareBoardPrDetailsPopup'
    },
    [(0, $8YTUU.DevInfoTypes).DESIGN]: {
        id: 'designDetailsPopup',
        name: 'jiraSoftwareBoardDesignDetailsPopup'
    }
};
const $045105c41d1dfec6$export$b0c5c2fac8144e54 = {
    [(0, $8YTUU.DevInfoTypes).BRANCH]: (0, $8GnxT.branchDetailsPopupLoad),
    [(0, $8YTUU.DevInfoTypes).COMMIT]: (0, $8GnxT.commitDetailsPopupLoad),
    [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: (0, $8GnxT.deploymentDetailsPopupLoad),
    [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: (0, $8GnxT.prDetailsPopupLoad),
    [(0, $8YTUU.DevInfoTypes).DESIGN]: (0, $8GnxT.designDetailsPopupLoad)
};
const $045105c41d1dfec6$export$48b44d9f3c6e15de = {
    [(0, $8YTUU.DevInfoTypes).BRANCH]: {
        id: 'renderBranchDetailsPopup',
        packageName: 'jiraDevelopmentBoardBranchDetailsPopup',
        teamName: 'fusion-isotopes'
    },
    [(0, $8YTUU.DevInfoTypes).COMMIT]: {
        id: 'renderCommitDetailsPopup',
        packageName: 'jiraDevelopmentBoardCommitDetailsPopup',
        teamName: 'fusion-isotopes'
    },
    [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: {
        id: 'renderDeploymentDetailsPopup',
        packageName: 'jiraDevelopmentBoardDeploymentDetailsPopup',
        teamName: 'fusion-solaris'
    },
    [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: {
        id: 'renderPRDetailsPopup',
        packageName: 'jiraDevelopmentBoardPrDetailsPopup',
        teamName: 'fusion-isotopes'
    },
    [(0, $8YTUU.DevInfoTypes).DESIGN]: {
        id: 'renderDesignDetailsPopup',
        packageName: 'jiraDevelopmentBoardDesignDetailsPopup',
        teamName: 'helios-headcoach'
    }
};
const $045105c41d1dfec6$export$1452632269dce6 = {
    [(0, $8YTUU.DevInfoTypes).BRANCH]: (0, $4Dm5W.branchDetailsEntryPoint),
    [(0, $8YTUU.DevInfoTypes).COMMIT]: (0, $6KTxo.commitDetailsEntryPoint),
    [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: (0, $6dYOr.deploymentDetailsEntryPoint),
    [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: (0, $890PS.pullRequestDetailsEntryPoint),
    [(0, $8YTUU.DevInfoTypes).DESIGN]: (0, $jH32b.designDetailsEntryPoint)
};
const $045105c41d1dfec6$export$a12a01ce2571070a = Object.freeze({
    SUCCESSFUL: 'SUCCESSFUL',
    FAILED: 'FAILED'
});
const $045105c41d1dfec6$export$618f130aff825d2b = Object.freeze({
    PRODUCTION: 'PRODUCTION',
    STAGING: 'STAGING',
    TESTING: 'TESTING'
});

});
parcelRegister("4Dm5W", function(module, exports) {

$parcel$export(module.exports, "branchDetailsEntryPoint", () => $36e1f5ea1b2544c9$export$4e1fb223e6b994ad);

var $8lY7K = parcelRequire("8lY7K");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $36e1f5ea1b2544c9$export$4e1fb223e6b994ad = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("eynrL")), {
        moduleId: "24c6676c"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                branchDetailsForIssue: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $8lY7K.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("8lY7K", function(module, exports) {

$parcel$export(module.exports, "default", () => $1485287fd69790ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<53221fefa0f4443cf65a4215c479359b>>
 * @relayHash 369bf10bb8009c658a35cf0bdf685efa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 50d8c5a327ce393f92430f04532d211b7f0cc460a938b554e063e4a413b3c9b6
const $1485287fd69790ca$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "50d8c5a327ce393f92430f04532d211b7f0cc460a938b554e063e4a413b3c9b6",
        "metadata": {},
        "name": "mainJiraBoardFetchBranchDetailsForIssueQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1485287fd69790ca$export$2e2bcd8739ae039 = $1485287fd69790ca$var$node;

});

parcelRegister("eynrL", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("8tdzL").then(()=>parcelRequire('93XNc'));

});


parcelRegister("6KTxo", function(module, exports) {

$parcel$export(module.exports, "commitDetailsEntryPoint", () => $9842290edc643ca7$export$543707906869c79b);

var $kmK4e = parcelRequire("kmK4e");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $9842290edc643ca7$export$543707906869c79b = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("bppAv")), {
        moduleId: "c43c4a0f"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                commitDetailsForIssue: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $kmK4e.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("kmK4e", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a92de7c94d3b0d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1084bead4ae00878b2af2c8348929c25>>
 * @relayHash eed264a6d119fbca146eb1de817b2b96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ca7f0754b23691dc5194f86cd173cbad109ceb27dcdfea5465741efb60afa5b
const $e1a92de7c94d3b0d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2ca7f0754b23691dc5194f86cd173cbad109ceb27dcdfea5465741efb60afa5b",
        "metadata": {},
        "name": "mainJiraBoardFetchCommitDetailsForIssueQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e1a92de7c94d3b0d$export$2e2bcd8739ae039 = $e1a92de7c94d3b0d$var$node;

});

parcelRegister("bppAv", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("fxdbP").then(()=>parcelRequire('1ml2E'));

});


parcelRegister("6dYOr", function(module, exports) {

$parcel$export(module.exports, "deploymentDetailsEntryPoint", () => $f735f9faccd14399$export$bb44df517ead129f);

var $4R6GH = parcelRequire("4R6GH");

var $k022a = parcelRequire("k022a");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $f735f9faccd14399$export$bb44df517ead129f = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("jWRvY")), {
        moduleId: "12f43749"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                deployments: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $k022a.default,
                    variables: {
                        issueAris: [
                            issueId
                        ],
                        isDevOpsDataAgsMigrationOn: (0, $4R6GH.fg)('solaris_migrate_summurized_deployments_to_ags_re')
                    }
                }
            }
        })
});

});
parcelRegister("k022a", function(module, exports) {

$parcel$export(module.exports, "default", () => $efb931bb8db9b600$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<af679ec527d1981dcdaff0e5cc594ad9>>
 * @relayHash 0014097d1ce5fa1efc5b91a05152d101
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 45a6c6bb5a98d9a9c3dbcd9f289262fb7d192b97d36ffaa9a2819f875e9e95f4
const $efb931bb8db9b600$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "45a6c6bb5a98d9a9c3dbcd9f289262fb7d192b97d36ffaa9a2819f875e9e95f4",
        "metadata": {},
        "name": "uiDevOpsBoardQuery",
        "operationKind": "query",
        "text": null
    }
};
var $efb931bb8db9b600$export$2e2bcd8739ae039 = $efb931bb8db9b600$var$node;

});

parcelRegister("jWRvY", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("jOGOe").then(()=>parcelRequire('asD4H'));

});


parcelRegister("jH32b", function(module, exports) {

$parcel$export(module.exports, "designDetailsEntryPoint", () => $4f00e6184ecff192$export$9b838851ea165d28);

var $cN09Q = parcelRequire("cN09Q");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $4f00e6184ecff192$export$9b838851ea165d28 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("fqjFw")), {
        moduleId: "b9d22806"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                designDetailsPopup: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $cN09Q.default,
                    variables: {
                        issueAri: issueId
                    }
                }
            }
        })
});

});
parcelRegister("cN09Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $37545b8a0156af47$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5b69286dc3d574c4254b644a20345969>>
 * @relayHash 19dd9f9578703995725a17532527b663
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f1f10befcdb537dd4ab4ac9c44e5edcb51d6b3f4306fd285cc82de529ebae8db
const $37545b8a0156af47$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "f1f10befcdb537dd4ab4ac9c44e5edcb51d6b3f4306fd285cc82de529ebae8db",
        "metadata": {},
        "name": "uiDesignDetailsPopupQuery",
        "operationKind": "query",
        "text": null
    }
};
var $37545b8a0156af47$export$2e2bcd8739ae039 = $37545b8a0156af47$var$node;

});

parcelRegister("fqjFw", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("5vjTk").then(()=>parcelRequire('9bEVC'));

});


parcelRegister("890PS", function(module, exports) {

$parcel$export(module.exports, "pullRequestDetailsEntryPoint", () => $0896cca9b8d893af$export$37ab544e7066c095);

var $5E8Mw = parcelRequire("5E8Mw");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $0896cca9b8d893af$export$37ab544e7066c095 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("fRRC0")), {
        moduleId: "1b74db53"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                pullRequestDetailsForIssue: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $5E8Mw.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("5E8Mw", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a4d40ac042e33e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e18ba82933463bea77a039cb31341c83>>
 * @relayHash ec62760f3d36372780325706797b1fb2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 91484d5c2ad4c1c580a3b56066bfe36c5fe9798b2804e958c3c96ecd098886b0
const $6a4d40ac042e33e2$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "91484d5c2ad4c1c580a3b56066bfe36c5fe9798b2804e958c3c96ecd098886b0",
        "metadata": {},
        "name": "mainJiraBoardFetchPullRequestDetailsForIssueQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6a4d40ac042e33e2$export$2e2bcd8739ae039 = $6a4d40ac042e33e2$var$node;

});

parcelRegister("fRRC0", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("98n7j")
]).then(()=>parcelRequire('cnLAn'));

});


parcelRegister("4Dyci", function(module, exports) {

$parcel$export(module.exports, "default", () => $436dc0db7ef24cd0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $436dc0db7ef24cd0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    branchIconLabel: {
        "id": "development-board-dev-info-icon.branch-icon-label",
        "defaultMessage": "branch"
    },
    commitIconLabel: {
        "id": "development-board-dev-info-icon.commit-icon-label",
        "defaultMessage": "commit"
    },
    designIconLabel: {
        "id": "development-board-dev-info-icon.design-icon-label",
        "defaultMessage": "Linked design data"
    },
    deploymentIconLabel: {
        "id": "development-board-dev-info-icon.deployment-icon-label",
        "defaultMessage": "Linked deployment data."
    },
    deploymentProductionSuccessIconLabel: {
        "id": "development-board-dev-info-icon.deployment-production-success-icon-label",
        "defaultMessage": "Successful deployment to production."
    },
    deploymentProductionFailedIconLabel: {
        "id": "development-board-dev-info-icon.deployment-production-failed-icon-label",
        "defaultMessage": "Failed deployment to production."
    },
    deploymentNonProductionSuccessIconLabel: {
        "id": "development-board-dev-info-icon.deployment-non-production-success-icon-label",
        "defaultMessage": "Successful deployment to non-production environment."
    },
    deploymentNonProductionFailedIconLabel: {
        "id": "development-board-dev-info-icon.deployment-non-production-failed-icon-label",
        "defaultMessage": "Failed deployment to non-production environment."
    },
    openPullRequestIconLabel: {
        "id": "development-board-dev-info-icon.open-pull-request-icon-label",
        "defaultMessage": "pull request"
    },
    mergedPullRequestIconLabel: {
        "id": "development-board-dev-info-icon.merged-pull-request-icon-label",
        "defaultMessage": "merged pull request"
    },
    declinedPullRequestIconLabel: {
        "id": "development-board-dev-info-icon.declined-pull-request-icon-label",
        "defaultMessage": "declined pull request"
    },
    branchIconButtonLabel: {
        "id": "development-board-dev-info-icon.branch-icon-button-label",
        "defaultMessage": "Select to open branch details."
    },
    commitIconButtonLabel: {
        "id": "development-board-dev-info-icon.commit-icon-button-label",
        "defaultMessage": "Select to open commit details."
    },
    pullRequestIconButtonLabel: {
        "id": "development-board-dev-info-icon.pull-request-icon-button-label",
        "defaultMessage": "Select to open pull request details."
    },
    deploymentIconButtonLabel: {
        "id": "development-board-dev-info-icon.deployment-icon-button-label",
        "defaultMessage": "Select to open deployment details."
    },
    designIconButtonLabel: {
        "id": "development-board-dev-info-icon.design-icon-button-label",
        "defaultMessage": "Select to open design details."
    }
});

});

parcelRegister("8GnxT", function(module, exports) {

$parcel$export(module.exports, "branchDetailsPopupLoad", () => $a8d6a72aae83d56f$export$1e45f095e94fd8a);
$parcel$export(module.exports, "commitDetailsPopupLoad", () => $a8d6a72aae83d56f$export$e3af05dcf8f03d06);
$parcel$export(module.exports, "deploymentDetailsPopupLoad", () => $a8d6a72aae83d56f$export$205c7cad3de97a2);
$parcel$export(module.exports, "prDetailsPopupLoad", () => $a8d6a72aae83d56f$export$3ca761127f6f2822);
$parcel$export(module.exports, "designDetailsPopupLoad", () => $a8d6a72aae83d56f$export$935f70f8029ab734);

var $dGrdR = parcelRequire("dGrdR");
const $a8d6a72aae83d56f$export$1e45f095e94fd8a = (0, $dGrdR.metrics).interaction({
    key: 'board.branch-details-popup-load'
});
const $a8d6a72aae83d56f$export$e3af05dcf8f03d06 = (0, $dGrdR.metrics).interaction({
    key: 'board.commit-details-popup-load'
});
const $a8d6a72aae83d56f$export$205c7cad3de97a2 = (0, $dGrdR.metrics).interaction({
    key: 'board.deployment-details-popup-load'
});
const $a8d6a72aae83d56f$export$3ca761127f6f2822 = (0, $dGrdR.metrics).interaction({
    key: 'board.pr-details-popup-load'
});
const $a8d6a72aae83d56f$export$935f70f8029ab734 = (0, $dGrdR.metrics).interaction({
    key: 'board.design-details-popup-load'
});

});



parcelRegister("8phmQ", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_DEV_STATUSES", () => $688d85ce74250816$export$10747a90e85a7b42);
const $688d85ce74250816$export$5798ea324a4dbe0e = 'branch';
const $688d85ce74250816$export$3d5e90ff634296d7 = 'commit';
const $688d85ce74250816$export$986d2ff2c9fcfdae = 'pullrequest';
const $688d85ce74250816$export$2fda0856fe66a3c9 = 'declined';
const $688d85ce74250816$export$26d1e2e6f089e8e4 = 'merged';
const $688d85ce74250816$export$1d7b9dd92d94f047 = 'deployment';
const $688d85ce74250816$export$a568421f41916e78 = 'design';
const $688d85ce74250816$export$10747a90e85a7b42 = [
    $688d85ce74250816$export$5798ea324a4dbe0e,
    $688d85ce74250816$export$3d5e90ff634296d7,
    $688d85ce74250816$export$986d2ff2c9fcfdae,
    $688d85ce74250816$export$2fda0856fe66a3c9,
    $688d85ce74250816$export$26d1e2e6f089e8e4,
    $688d85ce74250816$export$1d7b9dd92d94f047,
    $688d85ce74250816$export$a568421f41916e78
];

});


parcelRegister("itzcE", function(module, exports) {

$parcel$export(module.exports, "CardDueDate", () => $1f73e6aec72eb1bf$export$9e242219cf1cc36c);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4mBKK = parcelRequire("4mBKK");
var $70Rr2 = parcelRequire("70Rr2");
var $k7m40 = parcelRequire("k7m40");
var $eZDAP = parcelRequire("eZDAP");
var $it1wb = parcelRequire("it1wb");

var $lj8SI = parcelRequire("lj8SI");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $3bDjY = parcelRequire("3bDjY");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $8uZt8 = parcelRequire("8uZt8");


var $eDs1Y = parcelRequire("eDs1Y");
const $1f73e6aec72eb1bf$export$9e242219cf1cc36c = (props)=>{
    const { isCompleted: isCompleted, dueDate: dueDate, dateFormat: dateFormat } = props;
    const dueDateEndOfDay = (0, $70Rr2.default)((0, $eZDAP.default)(dueDate));
    const currentDate = (0, $it1wb.default)(new Date());
    const diffInDays = (0, $4mBKK.default)(dueDateEndOfDay, currentDate);
    const isDueBeforeToday = diffInDays <= 0;
    const isOverDue = isCompleted !== true && isDueBeforeToday;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formattedDueDate = dateFormat !== undefined && dateFormat !== null ? (0, $k7m40.default)(dueDateEndOfDay, dateFormat) : (0, $k7m40.default)(dueDateEndOfDay, 'dd MMM');
    const formattedTooltip = formatMessage((0, $eDs1Y.messages).text, {
        date: (0, $k7m40.default)(dueDateEndOfDay, 'dd MMMM yyyy')
    });
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return dueDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $1f73e6aec72eb1bf$var$baseStyles,
            isOverDue ? $1f73e6aec72eb1bf$var$overdueStyles : $1f73e6aec72eb1bf$var$normalStyles
        ],
        testId: "platform-card.common.ui.due-date.box"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formattedTooltip,
        testId: "platform-card.common.ui.due-date.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f73e6aec72eb1bf$var$Content, {
        "aria-label": formattedTooltip,
        isVisualRefreshEAPDropEnabled: (0, $4R6GH.fg)('jira_nav4_eap_drop_2')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8uZt8.default), {
        type: (0, $6d6eac2504286faf$export$d4ee7b46933c494f),
        label: formattedTooltip
    }), formattedDueDate))) : null;
    /* eslint-disable jira/react/no-style-attribute */ return dueDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ), {
        style: $1f73e6aec72eb1bf$var$dueDateLozengeStyle(isOverDue),
        testId: "platform-card.common.ui.due-date.lozenge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formattedTooltip,
        testId: "platform-card.common.ui.due-date.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f73e6aec72eb1bf$var$Content, {
        "aria-label": formattedTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8uZt8.default), {
        type: (0, $6d6eac2504286faf$export$d4ee7b46933c494f),
        label: formattedTooltip
    }), formattedDueDate))) : null;
/* eslint-enable jira/react/no-style-attribute */ };
$1f73e6aec72eb1bf$export$9e242219cf1cc36c.defaultProps = {
    isCompleted: false
};
var $1f73e6aec72eb1bf$export$2e2bcd8739ae039 = $1f73e6aec72eb1bf$export$9e242219cf1cc36c;
const $1f73e6aec72eb1bf$var$baseStyles = (0, $8CUq3.xcss)({
    borderStyle: 'solid',
    borderRadius: 'border.radius',
    borderWidth: 'border.width',
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});
const $1f73e6aec72eb1bf$var$overdueStyles = (0, $8CUq3.xcss)({
    color: 'color.text.danger',
    borderColor: 'color.border.danger'
});
const $1f73e6aec72eb1bf$var$normalStyles = (0, $8CUq3.xcss)({
    color: 'color.text',
    borderColor: 'color.border'
});
const $1f73e6aec72eb1bf$var$dueDateLozengeStyle = (isOverDue)=>isOverDue ? {
        color: `var(--ds-text-accent-red, ${(0, $829f609a65d26a98$exports).R400})`,
        backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$exports).R50})`
    } : {
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N500})`,
        backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N20})`
    }; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f73e6aec72eb1bf$var$ContentOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1n261g80",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f73e6aec72eb1bf$var$ContentNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisualRefreshEAPDropEnabled: isVisualRefreshEAPDropEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1n261g80 _zulp1b66",
            __cmplp.isVisualRefreshEAPDropEnabled && "_1x821ts4 _1ul9t9kd",
            __cmplp.className
        ])
    });
});
const $1f73e6aec72eb1bf$var$Content = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $1f73e6aec72eb1bf$var$ContentNew, $1f73e6aec72eb1bf$var$ContentOld);

});
parcelRegister("eDs1Y", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9d2a4fa84ab79be6$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9d2a4fa84ab79be6$export$593a022a1631ee1e = 'Due Date: ';
const $9d2a4fa84ab79be6$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    text: {
        "id": "due-date.text",
        "defaultMessage": "Due Date: {date}"
    }
});

});


parcelRegister("akGDz", function(module, exports) {

$parcel$export(module.exports, "CardEstimate", () => $9413a1b03685da5e$export$b243ada76671bb54);
$parcel$export(module.exports, "Container", () => $9413a1b03685da5e$export$42a852a2b6b56249);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $16T6Y = parcelRequire("16T6Y");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");
const $9413a1b03685da5e$export$b243ada76671bb54 = (props)=>{
    const { estimate: estimate, units: units } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let tooltipContent = null;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(units)) tooltipContent = estimate;
    else if (typeof units === 'string') tooltipContent = `${estimate} ${units}`;
    else tooltipContent = formatMessage(units, {
        value: estimate
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9413a1b03685da5e$export$42a852a2b6b56249, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent,
        testId: "platform-card.common.ui.estimate.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        appearance: "default",
        testId: "platform-card.common.ui.estimate.badge"
    }, estimate.toString())));
};
var $9413a1b03685da5e$export$2e2bcd8739ae039 = $9413a1b03685da5e$export$b243ada76671bb54;
const $9413a1b03685da5e$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dHqFt", function(module, exports) {

$parcel$export(module.exports, "CardLabels", () => $6ba71143138ad30e$export$ece436c5ee6469bd);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gccSB = parcelRequire("gccSB");

var $3bDjY = parcelRequire("3bDjY");

var $arvGN = parcelRequire("arvGN");
const $6ba71143138ad30e$var$CmpCardLabels = ({ labels: labels, highlight: highlight = [] })=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(labels) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ba71143138ad30e$var$Overflow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: labels.join(', '),
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ba71143138ad30e$var$Gradient, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ba71143138ad30e$var$CmpContainer, null, labels.map((label, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $arvGN.CardLabel), {
            key: index,
            text: label,
            highlight: highlight
        })))))) : null;
const $6ba71143138ad30e$var$TmpCardLabels = ({ labels: labels, highlight: highlight = [] })=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(labels) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ba71143138ad30e$var$Container, null, labels.map((label, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $arvGN.CardLabel), {
            key: index,
            text: label,
            highlight: highlight
        }))) : null;
const $6ba71143138ad30e$export$ece436c5ee6469bd = ({ labels: labels, isCMPBoard: isCMPBoard = false, highlight: highlight = [] })=>isCMPBoard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ba71143138ad30e$var$CmpCardLabels, {
        labels: labels,
        highlight: highlight
    }) // now renders within custom fields
     : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ba71143138ad30e$var$TmpCardLabels, {
        labels: labels,
        highlight: highlight
    });
var $6ba71143138ad30e$export$2e2bcd8739ae039 = $6ba71143138ad30e$export$ece436c5ee6469bd;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6ba71143138ad30e$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_lcxvglyw _1e0c1txw _2lx2vrvc _1n261g80 _4cvr1h6o _18s8r5cr",
            __cmplp.className
        ])
    });
});
const $6ba71143138ad30e$var$CmpContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c116y _18s8r5cr _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $6ba71143138ad30e$var$Gradient = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _kqswh2mm _1reo15vq _18m915vq _aetrb3bt _15l2idpf _19doidpf _1ywu1ule _1qdg1osq _z0ai1osq _18postnw _qc5omo3v _16r23cth _e9q69hw4",
            __cmplp.className
        ])
    });
});
const $6ba71143138ad30e$var$Overflow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("arvGN", function(module, exports) {

$parcel$export(module.exports, "CardLabel", () => $a5ee2d76601b7fd8$export$e13aaac4037b0914);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");
const $a5ee2d76601b7fd8$export$e13aaac4037b0914 = (props)=>{
    const { text: text, highlight: highlight } = props;
    const isSelected = !!highlight && highlight.includes(text);
    if ((0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('jira_nav4_beta_drop_1')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: [
            $a5ee2d76601b7fd8$var$ContainerStyles,
            isSelected && $a5ee2d76601b7fd8$var$ContainerHighlightStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: $a5ee2d76601b7fd8$var$ContentStyles
    }, text));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a5ee2d76601b7fd8$var$Container, {
        isSelected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a5ee2d76601b7fd8$var$Content, null, text));
};
$a5ee2d76601b7fd8$export$e13aaac4037b0914.defaultProps = {
    highlight: []
};
var $a5ee2d76601b7fd8$export$2e2bcd8739ae039 = $a5ee2d76601b7fd8$export$e13aaac4037b0914;
const $a5ee2d76601b7fd8$var$ContainerStyles = (0, $8CUq3.xcss)({
    margin: 'space.050',
    cursor: 'default',
    font: 'font.body',
    overflow: 'hidden',
    borderRadius: '3px',
    border: '1px solid',
    borderColor: 'color.border'
});
const $a5ee2d76601b7fd8$var$ContainerHighlightStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a5ee2d76601b7fd8$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4t3igktf _18s81b66 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswh2mm _80om73ad _vwz4kb7n _1reo15vq _18m915vq _2rko1l7b",
            __cmplp.isSelected ? "_bfhkynhg" : "_bfhk1s4m",
            __cmplp.isSelected ? "_syazia9z" : "_syaz1fxt",
            __cmplp.className
        ])
    });
});
const $a5ee2d76601b7fd8$var$ContentStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $gwIPs.gridSize) * 22.5}px`,
    paddingBlock: 'space.025',
    paddingInline: 'space.050',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a5ee2d76601b7fd8$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12fmgvx _1yt4u49m _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});


parcelRegister("l1jvZ", function(module, exports) {

$parcel$export(module.exports, "CardLozenge", () => $4fdae51feb9c93fe$export$a89483470d2d782c);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $gwIPs = parcelRequire("gwIPs");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $kFsv3 = parcelRequire("kFsv3");

var $iHPnC = parcelRequire("iHPnC");
const $4fdae51feb9c93fe$export$a89483470d2d782c = (props)=>{
    const { color: color, children: children } = props;
    const epicLozengeStyle = color && $4fdae51feb9c93fe$var$epicLozengeThemes[color] || undefined; /* eslint-disable jira/react/no-style-attribute */ 
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4fdae51feb9c93fe$export$42a852a2b6b56249, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4fdae51feb9c93fe$var$LozengeContainer, {
        style: epicLozengeStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4fdae51feb9c93fe$var$LozengeContent, null, children)));
/* eslint-enable jira/react/no-style-attribute */ };
$4fdae51feb9c93fe$export$a89483470d2d782c.defaultProps = {
    // not using tokens - this is a key to get predefined color schema, not actual color string
    color: (0, $kFsv3.PURPLE)
};
var $4fdae51feb9c93fe$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $4fdae51feb9c93fe$export$a89483470d2d782c;
const $4fdae51feb9c93fe$var$ContainerControl = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "l1vxah-0"
})({
    maxWidth: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& span': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: `${(0, $gwIPs.gridSize) * 2}px`
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4fdae51feb9c93fe$var$ContainerExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1osq _1e0c1txw _1bah1y6m _4cvr1h6o _13t37vkz",
            __cmplp.className
        ])
    });
});
const $4fdae51feb9c93fe$export$42a852a2b6b56249 = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $4fdae51feb9c93fe$var$ContainerExperiment, $4fdae51feb9c93fe$var$ContainerControl);
const $4fdae51feb9c93fe$var$epicLozengeThemes = (0, $iHPnC.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4fdae51feb9c93fe$var$LozengeContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1osq _2rko1l7b _11c81vlj _k48pmoej _1p1dangw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4fdae51feb9c93fe$var$LozengeContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _1reo15vq _18m915vq _1bto1l2s _s7n4jp4b _o5721q9c _vchhusvi _p12f1osq _1yt4otz2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("20vaL", function(module, exports) {

$parcel$export(module.exports, "CardPriority", () => $cc5d64f9a1c4db88$export$92d93d4ee23c212c);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $koVbs = parcelRequire("koVbs");

var $jsE5o = parcelRequire("jsE5o");
const $cc5d64f9a1c4db88$export$92d93d4ee23c212c = (props)=>{
    const { name: name, uri: uri } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const priorityLevel = formatMessage((0, $jsE5o.default).priorityTooltip, {
        priorityLevel: name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc5d64f9a1c4db88$var$Icon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: priorityLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc5d64f9a1c4db88$export$3e431a229df88919, {
        alt: priorityLevel,
        src: uri
    })));
};
var $cc5d64f9a1c4db88$export$2e2bcd8739ae039 = $cc5d64f9a1c4db88$export$92d93d4ee23c212c;
const $cc5d64f9a1c4db88$var$iconSize = (0, $gwIPs.gridSize) * 2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc5d64f9a1c4db88$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $cc5d64f9a1c4db88$var$ImageControl = /*#__PURE__*/ (0, $47bDC.default).img.withConfig({
    componentId: "sc-18gtlq4-0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${$cc5d64f9a1c4db88$var$iconSize}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${$cc5d64f9a1c4db88$var$iconSize}px`,
    verticalAlign: 'text-bottom'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc5d64f9a1c4db88$var$ImageExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i7vkz _s7n41ndm",
            __cmplp.className
        ])
    });
});
const $cc5d64f9a1c4db88$export$3e431a229df88919 = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $cc5d64f9a1c4db88$var$ImageExperiment, $cc5d64f9a1c4db88$var$ImageControl);

});
parcelRegister("jsE5o", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd4384d9d4bf039b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fd4384d9d4bf039b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    priorityTooltip: {
        "id": "platform-ui-card.common.priority.priority-tooltip",
        "defaultMessage": "{priorityLevel} priority"
    }
});

});


parcelRegister("9yMbF", function(module, exports) {

$parcel$export(module.exports, "Card", () => $b4c35803d9223712$export$60332b2344f7fe41);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $hGgHi = parcelRequire("hGgHi");

var $8Rkzz = parcelRequire("8Rkzz");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $1NPPK = parcelRequire("1NPPK");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");

var $az4zD = parcelRequire("az4zD");

var $cm8xi = parcelRequire("cm8xi");

var $fCMrQ = parcelRequire("fCMrQ");

var $fXjor = parcelRequire("fXjor");

var $7YpGJ = parcelRequire("7YpGJ");

var $4And4 = parcelRequire("4And4");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b4c35803d9223712$var$stopPropagation = (event)=>event.stopPropagation();
class $b4c35803d9223712$export$60332b2344f7fe41 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isDisabled: false,
            isDone: false,
            isSelected: false,
            isFlagged: false,
            isLoading: false,
            persistActions: false,
            typeName: null,
            typeUri: null,
            cardKey: null,
            coverUri: null,
            cover: null,
            avatarName: null,
            avatarUri: null,
            icons: null,
            highlightText: [],
            actions: null,
            color: null,
            customFields: null,
            children: null,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onSizeChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            renderAssignee: undefined,
            isCMPBoard: false,
            isIPBoard: false,
            status: null,
            hasCompactIssueType: false,
            hasScenarioChanges: false,
            id: null,
            renderIssueLinksStats: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
        };
    }
    renderMenu() {
        const { actions: actions, isLoading: isLoading, persistActions: persistActions } = this.props;
        if ((0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements')) return !isLoading && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(actions) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            testId: "platform-card.ui.card.actions-section",
            "data-component-selector": $b4c35803d9223712$var$ACTIONS_SECTION_CONTENT_SELECTOR,
            onClick: $b4c35803d9223712$var$stopPropagation,
            xcss: [
                $b4c35803d9223712$var$actionsSectionStyles,
                persistActions ? $b4c35803d9223712$var$visibilityStyles.initial : $b4c35803d9223712$var$visibilityStyles.hidden
            ]
        }, actions);
        return !isLoading && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(actions) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b4c35803d9223712$var$ActionsSection, {
            "data-test-id": "platform-card.ui.card.actions-section",
            "data-testid": "platform-card.ui.card.actions-section",
            persistActions: persistActions,
            onClick: $b4c35803d9223712$var$stopPropagation
        }, actions);
    }
    renderCardColor() {
        const { color: color, hasScenarioChanges: hasScenarioChanges, isIPBoard: isIPBoard } = this.props; /**
                     * In increment planning boards, we render the card color only if the issue:
                     * * is a new issue created in Plans that doesn't yet exist in Jira
                     * * has scenario changes not yet saved to Jira
                     *
                     * The card color is wrapped with a tooltip to inform the user about the fact that
                     * changes only exist in Plans and need to be saved to Jira to be reflected there.
                     */ 
        if (isIPBoard) {
            if (hasScenarioChanges) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4And4.default).scenarioChangeTooltip)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8xi.CardColor), {
                color: color
            }));
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8xi.CardColor), {
            color: color
        });
    }
    render() {
        const { isDisabled: isDisabled, isDone: isDone, isFlagged: isFlagged, isSelected: isSelected, isFlexible: isFlexible, isLoading: isLoading, summary: summary, typeName: typeName, typeUri: typeUri, cardKey: cardKey, cardRef: cardRef, cardContainerRef: cardContainerRef, coverUri: coverUri, cover: cover, color: color, customFields: customFields, avatarName: avatarName, avatarUri: avatarUri, icons: icons, highlightText: highlightText, children: children, onSizeChange: onSizeChange, onBlur: onBlur, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, renderSummary: renderSummary, renderAssignee: renderAssignee, isCMPBoard: isCMPBoard, isIPBoard: isIPBoard, status: status, hasCompactIssueType: hasCompactIssueType, renderIssueLinksStats: renderIssueLinksStats, id: id, hasScenarioChanges: hasScenarioChanges, fixVersions: fixVersions } = this.props;
        if ((0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fCMrQ.Theme).Provider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1NPPK.default).Consumer, null, ({ mode: mode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fCMrQ.Theme).Consumer, {
                isDisabled: isDisabled,
                isSelected: isSelected,
                isFlagged: isFlagged,
                mode: mode
            }, ({ backgroundColor: backgroundColor, textColor: textColor, hoverBackgroundColor: hoverBackgroundColor, hoverTextColor: hoverTextColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b4c35803d9223712$var$ContainerNew // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                , {
                    ref: cardContainerRef,
                    isDisabled: isDisabled,
                    isFlexible: Boolean(isFlexible),
                    textColor: textColor,
                    backgroundColor: backgroundColor,
                    hoverBackgroundColor: hoverBackgroundColor,
                    hoverTextColor: hoverTextColor
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7YpGJ.InteractionLayer), {
                    onClick: this.onClick,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    onFocus: onFocus,
                    onBlur: onBlur,
                    cardRef: cardRef,
                    summary: summary,
                    cardKey: cardKey
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fXjor.CardContent), {
                    id: id,
                    isDone: isDone,
                    isFlagged: isFlagged,
                    isLoading: isLoading,
                    summary: summary,
                    typeName: typeName,
                    typeUri: typeUri,
                    cardKey: cardKey,
                    coverUri: coverUri,
                    cover: cover,
                    customFields: customFields,
                    avatarName: avatarName,
                    avatarUri: avatarUri,
                    icons: icons,
                    highlightText: highlightText,
                    onImageLoad: onSizeChange ?? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                    shouldMenuRender: true,
                    renderSummary: renderSummary,
                    onClick: this.onClick,
                    isCMPBoard: isCMPBoard,
                    isIPBoard: isIPBoard,
                    status: status,
                    hasCompactIssueType: hasCompactIssueType,
                    renderAssignee: renderAssignee,
                    renderIssueLinksStats: renderIssueLinksStats,
                    color: color,
                    hasScenarioChanges: hasScenarioChanges,
                    fixVersions: fixVersions
                }, children), !isLoading && this.renderMenu()))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fCMrQ.Theme).Provider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1NPPK.default).Consumer, null, ({ mode: mode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fCMrQ.Theme).Consumer, {
                isDisabled: isDisabled,
                isSelected: isSelected,
                isFlagged: isFlagged,
                mode: mode
            }, (themeTokens)=>// eslint-disable-next-line styled-components-a11y/click-events-have-key-events, styled-components-a11y/no-static-element-interactions
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b4c35803d9223712$var$Container, {
                    ...themeTokens,
                    isDisabled: isDisabled,
                    isFlexible: isFlexible,
                    onClick: this.onClick,
                    tabIndex: 0,
                    onFocus: onFocus,
                    onBlur: onBlur,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    innerRef: cardRef,
                    "data-test-id": "platform-card.ui.card.focus-container",
                    "data-testid": "platform-card.ui.card.focus-container"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fXjor.CardContent), {
                    id: id,
                    isDone: isDone,
                    isFlagged: isFlagged,
                    isLoading: isLoading,
                    summary: summary,
                    typeName: typeName,
                    typeUri: typeUri,
                    cardKey: cardKey,
                    coverUri: coverUri,
                    cover: cover,
                    customFields: customFields,
                    avatarName: avatarName,
                    avatarUri: avatarUri,
                    icons: icons,
                    highlightText: highlightText,
                    onImageLoad: onSizeChange ?? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                    shouldMenuRender: true,
                    renderSummary: renderSummary,
                    onClick: this.onClick,
                    isCMPBoard: isCMPBoard,
                    isIPBoard: isIPBoard,
                    status: status,
                    hasCompactIssueType: hasCompactIssueType,
                    renderAssignee: renderAssignee,
                    renderIssueLinksStats: renderIssueLinksStats,
                    color: color,
                    hasScenarioChanges: hasScenarioChanges,
                    fixVersions: fixVersions
                }, children), !isLoading && this.renderMenu()))));
    }
    constructor(...args){
        super(...args);
        this.onClick = (event, externalAction)=>{
            const { isDisabled: isDisabled, onClick: onClick } = this.props;
            if (!isDisabled) onClick(event, externalAction);
        };
    }
}
var // @ts-expect-error - Argument of type 'typeof Card' is not assignable to parameter of type 'ComponentType<WithIntlProvided<CardProps>> & typeof Card'.
$b4c35803d9223712$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($b4c35803d9223712$export$60332b2344f7fe41);
const $b4c35803d9223712$var$EDIT_ICON_CONTENT_SELECTOR = 'issue-field-summary-inline-edit.ui.read.edit-icon';
const $b4c35803d9223712$var$STATIC_SUMMARY_CONTENT_SELECTOR = 'issue-field-summary-inline-edit.ui.read.static-summary';
const $b4c35803d9223712$var$EDITABLE_SUMMARY_CONTENT_SELECTOR = 'issue-field-summary-inline-edit.ui.read.editable-summary';
const $b4c35803d9223712$var$ACTIONS_SECTION_CONTENT_SELECTOR = 'issue-field-summary-inline-edit.ui.read.actions-section';
const $b4c35803d9223712$var$maxCardWidth = 270;
const $b4c35803d9223712$var$boxShadow = "var(--ds-shadow-raised, 0 1px 1px rgba(23, 43, 77, 0.2), 0 0 1px rgba(23, 43, 77, 0.2))"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $b4c35803d9223712$var$ActionsSection = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1m44sy3-0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        visibility: props.persistActions ? 'initial' : 'hidden',
        position: 'absolute',
        right: "var(--ds-space-100, 8px)",
        top: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: `var(--ds-surface-raised, ${(0, $829f609a65d26a98$exports).N20})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${0, $gwIPs.borderRadius}px`
    }));
const $b4c35803d9223712$var$actionsSectionStyles = (0, $8CUq3.xcss)({
    pointerEvents: 'auto',
    position: 'absolute',
    right: 'space.100',
    top: 'space.100',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'border.radius'
}); // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $b4c35803d9223712$var$mixinVisibleActionsStyles = /*#__PURE__*/ (0, $47bDC.css)`${$b4c35803d9223712$var$ActionsSection}{visibility:visible;}`; // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b4c35803d9223712$var$Container = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1m44sy3-1"
})`cursor:pointer;user-select:none;box-sizing:border-box;display:flex;flex-direction:column;position:relative;margin:${"var(--ds-space-025, 2px)"} 0;border-radius:${(0, $gwIPs.borderRadius)}px;box-shadow:${$b4c35803d9223712$var$boxShadow};transition:background-color 140ms ease-in-out,color 140ms ease-in-out;background-color:${(props)=>props.backgroundColor};--jsw-card-background-color:${({ backgroundColor: backgroundColor, isDisabled: isDisabled })=>isDisabled ? "var(--ds-surface-raised, white)" : backgroundColor};color:${(props)=>props.textColor};filter:${(props)=>props.isDisabled ? 'grayscale(100%)' : 'none'};max-width:${(props)=>props.isFlexible ? '100%' : `${$b4c35803d9223712$var$maxCardWidth}px`};&:hover{background-color:${(props)=>props.hoverBackgroundColor};--jsw-card-background-color:${(props)=>props.hoverBackgroundColor};color:${(props)=>props.hoverTextColor};}&:focus{box-shadow:inset 0 0 0 ${(0, $gwIPs.gridSize) / 4}px ${`var(--ds-text-brand, ${(0, $829f609a65d26a98$exports).B100})`};outline:none;}&:hover,&:focus,&:focus-within{${$b4c35803d9223712$var$mixinVisibleActionsStyles};[data-component-selector='${$b4c35803d9223712$var$STATIC_SUMMARY_CONTENT_SELECTOR}']{display:none;}[data-component-selector='${$b4c35803d9223712$var$EDITABLE_SUMMARY_CONTENT_SELECTOR}'],[data-component-selector='${$b4c35803d9223712$var$EDIT_ICON_CONTENT_SELECTOR}']{display:inline;}}`;
const $b4c35803d9223712$var$containerStyles = null; // Rename when cleaning up fix_jira_board_card_nested_interactive_elements
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values
const $b4c35803d9223712$var$ContainerNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $lD23V.default)(__cmplp.backgroundColor),
            "--_1qrlcdp": (0, $lD23V.default)(__cmplp.textColor),
            "--_1so9372": (0, $lD23V.default)(__cmplp.hoverBackgroundColor),
            "--_13t8k8z": (0, $lD23V.default)(__cmplp.hoverTextColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_lcxvglyw _80omtlke _uiztglyw _vchhusvi _1e0c1txw _2lx21bp4 _19pkv77o _2rko1sit _16qssefo _v56419bn _bfhk3qkl _syazijt0 _7ehie5bg _nt751r31 _49pcglyw _1hvw1o36 _irr3gm1p _30l31t6v _1itrewfl _zd1zewfl _1x9aewfl _128oglyw _1ae2glyw _192yglyw _1ont1nu9 _83tc1nu9 _1n4l1nu9 _1ryf1nu9 _fyi61nu9 _f8hb1nu9",
            __cmplp.isDisabled ? "_kdam7g3v" : "_kdamglyw",
            __cmplp.isFlexible ? "_p12f1osq" : "_p12f1ogy",
            __cmplp.className
        ])
    });
});
const $b4c35803d9223712$var$visibilityStyles = {
    initial: (0, $8CUq3.xcss)({
        visibility: 'initial'
    }),
    visible: (0, $8CUq3.xcss)({
        visibility: 'visible'
    }),
    hidden: (0, $8CUq3.xcss)({
        visibility: 'hidden'
    })
};

});
parcelRegister("cm8xi", function(module, exports) {

$parcel$export(module.exports, "CardColor", () => $6a8934f3f04ad0f9$export$d6da217c85de72a2);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dNOob = parcelRequire("dNOob");
const $6a8934f3f04ad0f9$export$d6da217c85de72a2 = ({ color: color, testId: testId })=>{
    if (!color) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6a8934f3f04ad0f9$var$CardColorInner, {
        color: color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $dNOob.cardColorInner,
        ...testId ? {
            'data-testid': testId
        } : {}
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a8934f3f04ad0f9$var$CardColorInner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhk1cj8 _4t3i1osq _kqswstnw _1ltvidpf _154iidpf _1bsb1y44 _13li1l7b _mrkb1l7b",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dNOob", function(module, exports) {

$parcel$export(module.exports, "avatarContainer", () => $a0c6f02efc741c4a$export$4ea799498ef4a755, (v) => $a0c6f02efc741c4a$export$4ea799498ef4a755 = v);
$parcel$export(module.exports, "card-content-container", () => $a0c6f02efc741c4a$export$b097e1489ce64e3a, (v) => $a0c6f02efc741c4a$export$b097e1489ce64e3a = v);
$parcel$export(module.exports, "cardColorInner", () => $a0c6f02efc741c4a$export$e2907b219480f02f, (v) => $a0c6f02efc741c4a$export$e2907b219480f02f = v);
$parcel$export(module.exports, "cmpAvatar", () => $a0c6f02efc741c4a$export$114c94adbfe142fc, (v) => $a0c6f02efc741c4a$export$114c94adbfe142fc = v);
$parcel$export(module.exports, "content", () => $a0c6f02efc741c4a$export$a7db06668cad9adb, (v) => $a0c6f02efc741c4a$export$a7db06668cad9adb = v);
$parcel$export(module.exports, "customCardFieldList", () => $a0c6f02efc741c4a$export$8b6db2f2076ae2a6, (v) => $a0c6f02efc741c4a$export$8b6db2f2076ae2a6 = v);
$parcel$export(module.exports, "footer", () => $a0c6f02efc741c4a$export$adb608be33961c98, (v) => $a0c6f02efc741c4a$export$adb608be33961c98 = v);
$parcel$export(module.exports, "footerChildSection", () => $a0c6f02efc741c4a$export$1907b6af328e1b13, (v) => $a0c6f02efc741c4a$export$1907b6af328e1b13 = v);
$parcel$export(module.exports, "iconsPlaceHolder", () => $a0c6f02efc741c4a$export$3f4216a049dd4cce, (v) => $a0c6f02efc741c4a$export$3f4216a049dd4cce = v);
$parcel$export(module.exports, "primary", () => $a0c6f02efc741c4a$export$9ad721cf3b3debe0, (v) => $a0c6f02efc741c4a$export$9ad721cf3b3debe0 = v);
$parcel$export(module.exports, "secondary", () => $a0c6f02efc741c4a$export$745c6f71a1e0e6f7, (v) => $a0c6f02efc741c4a$export$745c6f71a1e0e6f7 = v);
$parcel$export(module.exports, "summary", () => $a0c6f02efc741c4a$export$9a2dbef7a17e2e58, (v) => $a0c6f02efc741c4a$export$9a2dbef7a17e2e58 = v);
$parcel$export(module.exports, "tertiary", () => $a0c6f02efc741c4a$export$5668677bb0c0ed27, (v) => $a0c6f02efc741c4a$export$5668677bb0c0ed27 = v);
var $a0c6f02efc741c4a$export$4ea799498ef4a755;
var $a0c6f02efc741c4a$export$b097e1489ce64e3a;
var $a0c6f02efc741c4a$export$e2907b219480f02f;
var $a0c6f02efc741c4a$export$114c94adbfe142fc;
var $a0c6f02efc741c4a$export$a7db06668cad9adb;
var $a0c6f02efc741c4a$export$8b6db2f2076ae2a6;
var $a0c6f02efc741c4a$export$adb608be33961c98;
var $a0c6f02efc741c4a$export$1907b6af328e1b13;
var $a0c6f02efc741c4a$export$3f4216a049dd4cce;
var $a0c6f02efc741c4a$export$9ad721cf3b3debe0;
var $a0c6f02efc741c4a$export$745c6f71a1e0e6f7;
var $a0c6f02efc741c4a$export$9a2dbef7a17e2e58;
var $a0c6f02efc741c4a$export$5668677bb0c0ed27;
$a0c6f02efc741c4a$export$4ea799498ef4a755 = `yse7za_avatarContainer`;
$a0c6f02efc741c4a$export$b097e1489ce64e3a = `yse7za_card-content-container`;
$a0c6f02efc741c4a$export$e2907b219480f02f = `yse7za_cardColorInner`;
$a0c6f02efc741c4a$export$114c94adbfe142fc = `yse7za_cmpAvatar`;
$a0c6f02efc741c4a$export$a7db06668cad9adb = `yse7za_content`;
$a0c6f02efc741c4a$export$8b6db2f2076ae2a6 = `yse7za_customCardFieldList`;
$a0c6f02efc741c4a$export$adb608be33961c98 = `yse7za_footer`;
$a0c6f02efc741c4a$export$1907b6af328e1b13 = `yse7za_footerChildSection`;
$a0c6f02efc741c4a$export$3f4216a049dd4cce = `yse7za_iconsPlaceHolder`;
$a0c6f02efc741c4a$export$9ad721cf3b3debe0 = `yse7za_primary`;
$a0c6f02efc741c4a$export$745c6f71a1e0e6f7 = `yse7za_secondary`;
$a0c6f02efc741c4a$export$9a2dbef7a17e2e58 = `yse7za_summary`;
$a0c6f02efc741c4a$export$5668677bb0c0ed27 = `yse7za_tertiary`;

});


parcelRegister("fCMrQ", function(module, exports) {

$parcel$export(module.exports, "Theme", () => $54ad41c8d271f56c$export$14faa19a0f3bbeb2);

var $82itC = parcelRequire("82itC");

// The hex code for the colour is used as that value does not exist in the colors from '@atlaskit/theme'
const $54ad41c8d271f56c$var$cardFlaggedColor = '#FFF7D6';
const $54ad41c8d271f56c$var$cardFlaggedAndHoveredColor = '#F8E6A0';
const $54ad41c8d271f56c$var$cardFlaggedAndSelectedColor = '#F5CD47';
const $54ad41c8d271f56c$var$selectedDisabledAndDefaultThemeState = {
    [(0, $244c28c342c7cd47$export$21e4c437265127a0)]: {
        [(0, $244c28c342c7cd47$export$d6fd561d6f3bd529)]: {
            [(0, $244c28c342c7cd47$export$61582641a3c37669)]: `var(--ds-background-selected, ${(0, $829f609a65d26a98$exports).B50})`,
            [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$exports).B500})`
        },
        [(0, $244c28c342c7cd47$export$b8f05781b7d4583c)]: {
            [(0, $244c28c342c7cd47$export$61582641a3c37669)]: `var(--ds-background-selected-hovered, ${(0, $829f609a65d26a98$exports).B75})`,
            [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: `var(--ds-background-neutral-bold-hovered, ${(0, $829f609a65d26a98$exports).B400})`
        }
    },
    [(0, $244c28c342c7cd47$export$2c03afff1a06da0a)]: {
        [(0, $244c28c342c7cd47$export$d6fd561d6f3bd529)]: {
            [(0, $244c28c342c7cd47$export$61582641a3c37669)]: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$exports).N0})`,
            [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$exports).N800})`
        },
        [(0, $244c28c342c7cd47$export$b8f05781b7d4583c)]: {
            [(0, $244c28c342c7cd47$export$61582641a3c37669)]: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$exports).N0})`,
            [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$exports).N800})`
        }
    },
    [(0, $244c28c342c7cd47$export$d9c479c03363a52b)]: {
        [(0, $244c28c342c7cd47$export$d6fd561d6f3bd529)]: {
            [(0, $244c28c342c7cd47$export$61582641a3c37669)]: `var(--ds-surface-raised, ${(0, $829f609a65d26a98$exports).N0})`,
            [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: `var(--ds-surface-raised, ${(0, $829f609a65d26a98$exports).DN30})`
        },
        [(0, $244c28c342c7cd47$export$b8f05781b7d4583c)]: {
            [(0, $244c28c342c7cd47$export$61582641a3c37669)]: `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$exports).N20})`,
            [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: `var(--ds-background-neutral-bold-hovered, ${(0, $829f609a65d26a98$exports).DN40})`
        }
    }
};
const $54ad41c8d271f56c$var$cardTheme = {
    [(0, $244c28c342c7cd47$export$9c09a6bee099a4c9)]: {
        [(0, $244c28c342c7cd47$export$fe8539b22f3ed137)]: {
            [(0, $244c28c342c7cd47$export$d6fd561d6f3bd529)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: `var(--ds-background-warning-pressed, ${$54ad41c8d271f56c$var$cardFlaggedAndSelectedColor})`,
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: `var(--ds-background-warning-pressed, ${$54ad41c8d271f56c$var$cardFlaggedAndSelectedColor})`
            },
            [(0, $244c28c342c7cd47$export$b8f05781b7d4583c)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: `var(--ds-background-warning-hovered, ${$54ad41c8d271f56c$var$cardFlaggedAndHoveredColor})`,
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: `var(--ds-background-warning-hovered, ${$54ad41c8d271f56c$var$cardFlaggedAndHoveredColor})`
            }
        },
        [(0, $244c28c342c7cd47$export$a64d05a08c3ad905)]: {
            [(0, $244c28c342c7cd47$export$d6fd561d6f3bd529)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: `var(--ds-background-warning, ${$54ad41c8d271f56c$var$cardFlaggedColor})`,
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: `var(--ds-background-warning, ${$54ad41c8d271f56c$var$cardFlaggedColor})`
            },
            [(0, $244c28c342c7cd47$export$b8f05781b7d4583c)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: `var(--ds-background-warning-hovered, ${$54ad41c8d271f56c$var$cardFlaggedAndHoveredColor})`,
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: `var(--ds-background-warning-hovered, ${$54ad41c8d271f56c$var$cardFlaggedAndHoveredColor})`
            }
        },
        ...$54ad41c8d271f56c$var$selectedDisabledAndDefaultThemeState
    },
    [(0, $244c28c342c7cd47$export$7a5e3175d433dcb5)]: {
        [(0, $244c28c342c7cd47$export$fe8539b22f3ed137)]: {
            [(0, $244c28c342c7cd47$export$d6fd561d6f3bd529)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`,
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: `var(--ds-text, ${(0, $829f609a65d26a98$exports).P50})`
            },
            [(0, $244c28c342c7cd47$export$b8f05781b7d4583c)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`,
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: `var(--ds-text, ${(0, $829f609a65d26a98$exports).P50})`
            }
        },
        [(0, $244c28c342c7cd47$export$a64d05a08c3ad905)]: {
            [(0, $244c28c342c7cd47$export$d6fd561d6f3bd529)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`,
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: `var(--ds-text, ${(0, $829f609a65d26a98$exports).R50})`
            },
            [(0, $244c28c342c7cd47$export$b8f05781b7d4583c)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`,
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: `var(--ds-text, ${(0, $829f609a65d26a98$exports).R50})`
            }
        },
        [(0, $244c28c342c7cd47$export$21e4c437265127a0)]: {
            [(0, $244c28c342c7cd47$export$d6fd561d6f3bd529)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`,
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: `var(--ds-text, ${(0, $829f609a65d26a98$exports).B50})`
            },
            [(0, $244c28c342c7cd47$export$b8f05781b7d4583c)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`,
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: `var(--ds-text, ${(0, $829f609a65d26a98$exports).B50})`
            }
        },
        [(0, $244c28c342c7cd47$export$2c03afff1a06da0a)]: {
            [(0, $244c28c342c7cd47$export$d6fd561d6f3bd529)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N80})`,
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N300})`
            },
            [(0, $244c28c342c7cd47$export$b8f05781b7d4583c)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N80})`,
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N300})`
            }
        },
        [(0, $244c28c342c7cd47$export$d9c479c03363a52b)]: {
            [(0, $244c28c342c7cd47$export$d6fd561d6f3bd529)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`,
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N80})`
            },
            [(0, $244c28c342c7cd47$export$b8f05781b7d4583c)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`,
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N80})`
            }
        }
    }
};
const $54ad41c8d271f56c$var$getCssPropValue = ({ cssProp: cssProp, isSelected: isSelected = false, isFlagged: isFlagged = false, isDisabled: isDisabled = false, hoverState: hoverState = (0, $244c28c342c7cd47$export$d6fd561d6f3bd529), mode: mode })=>{
    if (isFlagged && isSelected) return $54ad41c8d271f56c$var$cardTheme[cssProp][0, $244c28c342c7cd47$export$fe8539b22f3ed137][hoverState][mode];
    if (isFlagged) return $54ad41c8d271f56c$var$cardTheme[cssProp][0, $244c28c342c7cd47$export$a64d05a08c3ad905][hoverState][mode];
    if (isSelected) return $54ad41c8d271f56c$var$cardTheme[cssProp][0, $244c28c342c7cd47$export$21e4c437265127a0][hoverState][mode];
    if (isDisabled) return $54ad41c8d271f56c$var$cardTheme[cssProp][0, $244c28c342c7cd47$export$2c03afff1a06da0a][hoverState][mode];
    return $54ad41c8d271f56c$var$cardTheme[cssProp][0, $244c28c342c7cd47$export$d9c479c03363a52b][hoverState][mode];
};
const $54ad41c8d271f56c$var$getBackgroundColor = ({ isSelected: isSelected, isFlagged: isFlagged, isDisabled: isDisabled, mode: mode })=>$54ad41c8d271f56c$var$getCssPropValue({
        cssProp: (0, $244c28c342c7cd47$export$9c09a6bee099a4c9),
        isSelected: isSelected,
        isFlagged: isFlagged,
        isDisabled: isDisabled,
        mode: mode
    });
const $54ad41c8d271f56c$var$getTextColor = ({ isSelected: isSelected, isFlagged: isFlagged, isDisabled: isDisabled, mode: mode })=>$54ad41c8d271f56c$var$getCssPropValue({
        cssProp: (0, $244c28c342c7cd47$export$7a5e3175d433dcb5),
        isSelected: isSelected,
        isFlagged: isFlagged,
        isDisabled: isDisabled,
        mode: mode
    });
const $54ad41c8d271f56c$var$getHoverBackgroundColor = ({ isSelected: isSelected, isFlagged: isFlagged, isDisabled: isDisabled, mode: mode })=>$54ad41c8d271f56c$var$getCssPropValue({
        cssProp: (0, $244c28c342c7cd47$export$9c09a6bee099a4c9),
        isSelected: isSelected,
        isFlagged: isFlagged,
        isDisabled: isDisabled,
        mode: mode,
        hoverState: (0, $244c28c342c7cd47$export$b8f05781b7d4583c)
    });
const $54ad41c8d271f56c$var$getHoverTextColor = ({ isSelected: isSelected, isFlagged: isFlagged, isDisabled: isDisabled, mode: mode })=>$54ad41c8d271f56c$var$getCssPropValue({
        cssProp: (0, $244c28c342c7cd47$export$7a5e3175d433dcb5),
        isSelected: isSelected,
        isFlagged: isFlagged,
        isDisabled: isDisabled,
        mode: mode,
        hoverState: (0, $244c28c342c7cd47$export$b8f05781b7d4583c)
    });
const $54ad41c8d271f56c$var$defaultTheme = ({ isSelected: isSelected, isFlagged: isFlagged, isDisabled: isDisabled, mode: mode })=>({
        backgroundColor: $54ad41c8d271f56c$var$getBackgroundColor({
            isSelected: isSelected,
            isFlagged: isFlagged,
            isDisabled: isDisabled,
            mode: mode
        }),
        textColor: $54ad41c8d271f56c$var$getTextColor({
            isSelected: isSelected,
            isFlagged: isFlagged,
            isDisabled: isDisabled,
            mode: mode
        }),
        hoverBackgroundColor: $54ad41c8d271f56c$var$getHoverBackgroundColor({
            isSelected: isSelected,
            isFlagged: isFlagged,
            isDisabled: isDisabled,
            mode: mode
        }),
        hoverTextColor: $54ad41c8d271f56c$var$getHoverTextColor({
            isSelected: isSelected,
            isFlagged: isFlagged,
            isDisabled: isDisabled,
            mode: mode
        })
    });
const $54ad41c8d271f56c$export$14faa19a0f3bbeb2 = (0, $82itC.createTheme)($54ad41c8d271f56c$var$defaultTheme);

});
const $244c28c342c7cd47$export$61582641a3c37669 = 'light';
const $244c28c342c7cd47$export$af4146eb5bbb1672 = 'dark';
const $244c28c342c7cd47$export$fe8539b22f3ed137 = 'flaggedAndSelected';
const $244c28c342c7cd47$export$a64d05a08c3ad905 = 'flagged';
const $244c28c342c7cd47$export$21e4c437265127a0 = 'selected';
const $244c28c342c7cd47$export$2c03afff1a06da0a = 'disabled';
const $244c28c342c7cd47$export$d9c479c03363a52b = 'default';
const $244c28c342c7cd47$export$b8f05781b7d4583c = 'enter';
const $244c28c342c7cd47$export$d6fd561d6f3bd529 = 'leave';
const $244c28c342c7cd47$export$9c09a6bee099a4c9 = 'backgroundColor';
const $244c28c342c7cd47$export$7a5e3175d433dcb5 = 'textColor';
const $244c28c342c7cd47$export$b1cb468c302d21f9 = 'labels';


parcelRegister("fXjor", function(module, exports) {

$parcel$export(module.exports, "CardContent", () => $424382f922ab5f57$export$64ef9b8c11710c47);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $gccSB = parcelRequire("gccSB");

var $8Rkzz = parcelRequire("8Rkzz");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $gSExi = parcelRequire("gSExi");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");

var $dNOob = parcelRequire("dNOob");


var $cPpj5 = parcelRequire("cPpj5");

var $cm8xi = parcelRequire("cm8xi");

var $7K6nB = parcelRequire("7K6nB");

var $bbQQn = parcelRequire("bbQQn");

var $gRghR = parcelRequire("gRghR");

var $8nii0 = parcelRequire("8nii0");

var $k3Hho = parcelRequire("k3Hho");

var $fsT6h = parcelRequire("fsT6h");

var $1vEOb = parcelRequire("1vEOb");

var $1NiGE = parcelRequire("1NiGE");

var $1d3ex = parcelRequire("1d3ex");

var $4And4 = parcelRequire("4And4");
const $424382f922ab5f57$var$CONTENT_SECTION_SELECTOR = 'platform-card.ui.card.card-content.content-section'; // eslint-disable-next-line jira/react/no-class-components
class $424382f922ab5f57$export$64ef9b8c11710c47 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            isDone: false,
            isFlagged: false,
            isLoading: false,
            shouldMenuRender: false,
            typeName: null,
            typeUri: null,
            cardKey: null,
            coverUri: null,
            cover: null,
            avatarName: null,
            avatarUri: null,
            icons: null,
            highlightText: [],
            customFields: null,
            children: null,
            onImageLoad: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            isCMPBoard: false,
            isIPBoard: false,
            status: null,
            hasCompactIssueType: false,
            color: null,
            hasScenarioChanges: false
        };
    }
    shouldRenderFooter() {
        const { isFlagged: isFlagged, isDone: isDone, typeName: typeName, typeUri: typeUri, cardKey: cardKey, icons: icons, avatarName: avatarName, avatarUri: avatarUri, isLoading: isLoading, renderAssignee: renderAssignee } = this.props;
        if ((0, $4R6GH.fg)('jira_view_settings_additional_fields')) return [
            isFlagged,
            typeName,
            typeUri,
            cardKey,
            avatarName,
            avatarUri,
            isLoading,
            renderAssignee,
            !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(icons) && icons.some((icon)=>!!icon)
        ].some((component)=>!!component);
        return [
            isFlagged,
            isDone,
            typeName,
            typeUri,
            cardKey,
            !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(icons),
            avatarName,
            avatarUri,
            isLoading
        ].some((component)=>!!component);
    }
    renderCover() {
        const { coverUri: coverUri, cover: cover, onImageLoad: onImageLoad } = this.props;
        if (coverUri) return coverUri && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K6nB.CardCover), {
            onLoad: onImageLoad,
            uri: coverUri
        });
        return cover;
    }
    renderSummary() {
        if (this.props.renderSummary) {
            const { summary: text, highlightText: highlight, shouldMenuRender: shouldMenuRender, renderSummary: renderSummary } = this.props;
            if ((0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $424382f922ab5f57$var$contentSectionStyles,
                "data-component-selector": $424382f922ab5f57$var$CONTENT_SECTION_SELECTOR
            }, renderSummary({
                text: text,
                highlight: highlight,
                shouldMenuRender: shouldMenuRender
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$ContentSection, null, renderSummary({
                text: text,
                highlight: highlight,
                shouldMenuRender: shouldMenuRender
            }));
        }
        const { summary: summary, highlightText: highlightText, shouldMenuRender: shouldMenuRender, isCMPBoard: isCMPBoard } = this.props;
        if ((0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $424382f922ab5f57$var$contentSectionStyles,
            "data-component-selector": $424382f922ab5f57$var$CONTENT_SECTION_SELECTOR
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1vEOb.CardSummary), {
            text: summary,
            highlight: highlightText,
            shouldMenuRender: shouldMenuRender,
            shouldTruncate: Boolean(isCMPBoard)
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$ContentSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1vEOb.CardSummary), {
            text: summary,
            highlight: highlightText,
            shouldMenuRender: shouldMenuRender,
            shouldTruncate: Boolean(isCMPBoard)
        }));
    }
    renderFields() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))((0, $5uXOq.Children).toArray(children)) && (0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $424382f922ab5f57$var$contentSectionStyles,
            "data-component-selector": $424382f922ab5f57$var$CONTENT_SECTION_SELECTOR
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$FieldsSection, null, children));
        return !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))((0, $5uXOq.Children).toArray(children)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$ContentSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$FieldsSection, null, children));
    }
    renderCustomFields() {
        const { customFields: customFields, isCMPBoard: isCMPBoard, fixVersions: fixVersions } = this.props; // TMP labels are rendred directly from issues.lables in a fixed card position
        // CMP labels are reorderable in user settings and therefore need to come from custom fields
        const customFieldsToDisplay = isCMPBoard ? customFields : customFields?.filter((cf)=>cf.id !== (0, $244c28c342c7cd47$export$b1cb468c302d21f9));
        if ((0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(customFieldsToDisplay) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $424382f922ab5f57$var$contentSectionStyles,
            "data-component-selector": $424382f922ab5f57$var$CONTENT_SECTION_SELECTOR
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bbQQn.CardCustomFields), {
            fields: customFieldsToDisplay,
            isCMPBoard: isCMPBoard,
            fixVersions: fixVersions
        })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(customFieldsToDisplay) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$ContentSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bbQQn.CardCustomFields), {
            fields: customFieldsToDisplay,
            isCMPBoard: isCMPBoard,
            fixVersions: fixVersions
        })));
    }
    renderType() {
        const { typeName: typeName, typeUri: typeUri } = this.props;
        return typeName && typeUri && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1d3ex.CardType), {
            text: typeName,
            uri: typeUri
        });
    }
    renderKey() {
        const { cardKey: cardKey, highlightText: highlightText, isDone: isDone, isIPBoard: isIPBoard, onClick: onClick } = this.props;
        return cardKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3Hho.CardKey), {
            text: cardKey,
            highlight: highlightText,
            isDone: Boolean(isDone),
            onClick: onClick,
            openInNewTab: isIPBoard
        });
    }
    renderIcons() {
        const { isDone: isDone, isFlagged: isFlagged, icons: icons, isLoading: isLoading, isCMPBoard: isCMPBoard, isIPBoard: isIPBoard } = this.props;
        const hasIcons = icons?.some((icon)=>!!icon);
        return !isLoading && (isDone || isFlagged || hasIcons) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8nii0.CardIcons), null, !isCMPBoard && !isIPBoard && !isFlagged && isDone && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1NiGE.CardTick), {
            key: "card-ticked"
        }), isFlagged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gRghR.CardFlag), {
            key: "card-flagged"
        }), icons);
    }
    renderAvatar() {
        if (this.props.renderAssignee) return this.props.renderAssignee();
        const { avatarName: avatarName, avatarUri: avatarUri, highlightText: highlightText } = this.props;
        return avatarName && avatarUri && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPpj5.CardAvatar), {
            name: avatarName,
            uri: avatarUri,
            highlight: highlightText
        });
    }
    renderLoading() {
        const { isLoading: isLoading } = this.props;
        return isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fsT6h.CardSpinner), null);
    }
    renderIssueLinksStats() {
        return this.props.renderIssueLinksStats?.();
    }
    renderCardColor() {
        const { color: color, hasScenarioChanges: hasScenarioChanges, isIPBoard: isIPBoard } = this.props; /**
                     * In increment planning boards, we render the card color only if the issue:
                     * * is a new issue created in Plans that doesn't yet exist in Jira
                     * * has scenario changes not yet saved to Jira
                     *
                     * The card color is wrapped with a tooltip to inform the user about the fact that
                     * changes only exist in Plans and need to be saved to Jira to be reflected there.
                     */ 
        if (!isIPBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8xi.CardColor), {
            color: color
        });
        if (hasScenarioChanges) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4And4.default).scenarioChangeTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8xi.CardColor), {
            testId: "platform-card.ui.card.card-content.program-board-scenario-indicator",
            color: color
        }));
        return null;
    }
    renderFooter() {
        // When adding new items into the footer, remember to update the `shouldRenderFooter()`
        if (!this.shouldRenderFooter()) return null;
        const { hasCompactIssueType: hasCompactIssueType, isIPBoard: isIPBoard } = this.props;
        if ((0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            testId: "platform-card.ui.card.card-content.footer",
            "data-component-selector": $424382f922ab5f57$var$CONTENT_SECTION_SELECTOR,
            xcss: $424382f922ab5f57$var$contentSectionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$FooterSection, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).footer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$FooterPrimarySection, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).footerChildSection
        }, !hasCompactIssueType && this.renderType(), this.renderKey()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$FooterTertiarySection, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).footerChildSection
        }, this.renderIssueLinksStats(), Boolean(hasCompactIssueType) && this.renderType(), !isIPBoard && this.renderIcons()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$FooterSecondarySection, null, !isIPBoard && this.renderAvatar(), isIPBoard && this.renderIcons(), this.renderLoading())));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$ContentSection, {
            "data-testid": "platform-card.ui.card.card-content.footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$FooterSection, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).footer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$FooterPrimarySection, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).footerChildSection
        }, !hasCompactIssueType && this.renderType(), this.renderKey()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$FooterTertiarySection, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).footerChildSection
        }, this.renderIssueLinksStats(), Boolean(hasCompactIssueType) && this.renderType(), !isIPBoard && this.renderIcons()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$FooterSecondarySection, null, !isIPBoard && this.renderAvatar(), isIPBoard && this.renderIcons(), this.renderLoading())));
    }
    render() {
        const isCMPBoard = Boolean(this.props.isCMPBoard);
        const cardContent = (0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $424382f922ab5f57$var$containerStyles
        }, this.renderCover(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$Content // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).content,
            isCMPBoard: isCMPBoard,
            hasStatus: this.props.status !== null
        }, this.renderSummary(), this.renderFields(), this.renderCustomFields(), this.renderCardColor(), this.renderFooter())) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, this.renderCover(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$Content // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).content,
            isCMPBoard: isCMPBoard,
            hasStatus: this.props.status !== null
        }, this.renderSummary(), this.renderFields(), this.renderCustomFields(), this.renderCardColor(), this.renderFooter()));
        return isCMPBoard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $424382f922ab5f57$var$contentContainerStyles
        }, cardContent) : cardContent;
    }
}
var $424382f922ab5f57$export$2e2bcd8739ae039 // eslint-disable-next-line jira/styled/styled-component-order
 = $424382f922ab5f57$export$64ef9b8c11710c47;
const $424382f922ab5f57$var$contentContainerStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    container: `${(0, (/*@__PURE__*/$parcel$interopDefault($dNOob)))['card-content-container']} / inline-size`
});
const $424382f922ab5f57$var$gutterSize = (0, $gwIPs.gridSize) / 2;
const $424382f922ab5f57$var$footerMinHeight = 28;
const $424382f922ab5f57$var$gridareas = ()=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).primary && (0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).tertiary && (0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).secondary) return `"${(0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).primary} ${(0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).tertiary} ${(0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).secondary}"`;
    return '"primary tertiary secondary"';
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $424382f922ab5f57$var$ContentSection = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1e1lt9n-0"
})({
    display: 'flex',
    flexDirection: 'row',
    width: '100%'
});
const $424382f922ab5f57$var$contentSectionStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    position: 'relative',
    pointerEvents: 'auto'
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $424382f922ab5f57$var$ContentControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1e1lt9n-1"
})`box-sizing:border-box;display:flex;flex-direction:column;padding:${"var(--ds-space-150, 12px)"};${$424382f922ab5f57$var$ContentSection}{margin-bottom:${"var(--ds-space-100, 8px)"};&:last-child{margin-bottom:0;}${(props)=>!props.isCMPBoard && `&:nth-of-type(2):last-of-type {
            margin-top: ${"var(--ds-space-050, 4px)"};
        }`} ${(props)=>props.hasStatus && `&:nth-child(2) {
                margin-bottom: ${"var(--ds-space-050, 4px)"};
            }
            &:nth-last-child(2) {
                margin-bottom: ${"var(--ds-space-100, 8px)"};
            }
        `}}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $424382f922ab5f57$var$ContentExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCMPBoard: isCMPBoard, hasStatus: hasStatus, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vchhusvi _1e0c1txw _2lx21bp4 _1yt4utpp _7y2iu2gc _12tyidpf",
            !__cmplp.isCMPBoard && "_pg611b66",
            __cmplp.hasStatus && "_1dkc1b66",
            __cmplp.hasStatus && "_u0k4u2gc",
            __cmplp.className
        ])
    });
});
const $424382f922ab5f57$var$Content = (0, $gSExi.styledComponentWithCondition)(()=>(0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements'), $424382f922ab5f57$var$ContentExperiment, $424382f922ab5f57$var$ContentControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $424382f922ab5f57$var$FieldsSection = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1e1lt9n-2"
})({
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'center',
    gap: "var(--ds-space-100, 8px)",
    width: '100%'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $424382f922ab5f57$var$FooterSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1rr33ui": (0, $lD23V.default)($424382f922ab5f57$var$gridareas())
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c11p5 _1bsb1osq _zulpoqx6 _1tke1f4h _2z05hkll _yv0e1xhj _1lmc6ou8",
            __cmplp.className
        ])
    });
});
const $424382f922ab5f57$var$footerSectionMixinStyles = /*#__PURE__*/ (0, $47bDC.css)({
    boxSizing: 'border-box',
    display: 'grid',
    gridAutoFlow: 'column',
    alignItems: 'center',
    justifyContent: 'start',
    gap: "var(--ds-space-100, 8px)"
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $424382f922ab5f57$var$FooterPrimarySection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_yr074y": (0, $lD23V.default)((0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).primary ? (0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).primary : 'primary')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_nd5lkgrd _p12f1ns9 _vchhusvi _1e0c11p5 _wij21bp4 _4cvr1h6o _1bahv2br _zulp1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $424382f922ab5f57$var$FooterSecondarySection = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1e1lt9n-3"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).secondary ? (0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).secondary : 'secondary'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
()=>$424382f922ab5f57$var$footerSectionMixinStyles); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $424382f922ab5f57$var$FooterTertiarySection = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1e1lt9n-4"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).tertiary ? (0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).tertiary : 'tertiary',
    minHeight: '24px'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
()=>$424382f922ab5f57$var$footerSectionMixinStyles);
const $424382f922ab5f57$var$containerStyles = (0, $8CUq3.xcss)({
    pointerEvents: 'none'
});

});
parcelRegister("cPpj5", function(module, exports) {

$parcel$export(module.exports, "CardAvatar", () => $40c355940ac43905$export$96ed66090abd01b1);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");


var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $dNOob = parcelRequire("dNOob");

var $8uZt8 = parcelRequire("8uZt8");

const $40c355940ac43905$var$hasKeywords = (name)=>(keyword)=>name && keyword && name.toLowerCase().includes(keyword.toLowerCase());
const $40c355940ac43905$export$96ed66090abd01b1 = (props)=>{
    const { name: name, uri: uri, highlight: highlight } = props;
    const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
    const isImageValid = !!uri && !hasImageErrored;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40c355940ac43905$var$Container, {
        isHighlighted: highlight && highlight.some($40c355940ac43905$var$hasKeywords(name))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40c355940ac43905$var$AvatarContainer, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($dNOob))).avatarContainer
    }, isImageValid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40c355940ac43905$var$Image, {
        loading: "lazy",
        alt: name,
        src: uri,
        onError: ()=>setHasImageErrored(true)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8uZt8.default), {
        type: (0, $6d6eac2504286faf$export$30a9be92cbb6f382),
        label: name,
        primaryColor: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N90})`
    }))));
};
var $40c355940ac43905$export$2e2bcd8739ae039 = $40c355940ac43905$export$96ed66090abd01b1;
const $40c355940ac43905$var$size = (0, $gwIPs.gridSize) * 3; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $40c355940ac43905$var$AvatarContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4t3i1tcg _1bsb1tcg _18s8v77o _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswh2mm _80om73ad _vwz4kb7n _1reo15vq _18m915vq _2rko1l7b",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $40c355940ac43905$var$Image = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_s7n4nkob _1bsb1osq _4t3i1osq _2rko1ssb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $40c355940ac43905$var$ContainerControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "y78kp6-0"
})((props)=>({
        borderRadius: '50%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: props.isHighlighted ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `0px 0px 0px 3px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B75})`}` : 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            display: 'flex',
            flex: '0 1 auto',
            alignSelf: 'center',
            minWidth: 0
        }
    }));
const $40c355940ac43905$var$ContainerExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHighlighted: isHighlighted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _d0dz1txw _zdxoidpf _v5ynkb7n _13ls1wug _brcx1h6o _1ouwidpf",
            __cmplp.isHighlighted ? "_16qs7aa6" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $40c355940ac43905$var$Container = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $40c355940ac43905$var$ContainerExperiment, $40c355940ac43905$var$ContainerControl);
const $40c355940ac43905$export$7ed12d2a5241e393 = {
    Container: $40c355940ac43905$var$Container
};

});

parcelRegister("7K6nB", function(module, exports) {

$parcel$export(module.exports, "CardCover", () => $4ed524f132b65d0c$export$1a2d6d8c98d2c941);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $8Rkzz = parcelRequire("8Rkzz");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");
const $4ed524f132b65d0c$export$1a2d6d8c98d2c941 = (props)=>{
    const { uri: uri, onLoad: onLoad } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ed524f132b65d0c$var$Cover, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ed524f132b65d0c$var$Image, {
        src: uri,
        onLoad: onLoad ?? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        alt: ""
    }));
};
var $4ed524f132b65d0c$export$2e2bcd8739ae039 = $4ed524f132b65d0c$export$1a2d6d8c98d2c941;
const $4ed524f132b65d0c$var$coverMaxHeight = 260;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ed524f132b65d0c$var$Cover = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_lcxvglyw _1e0c1txw _1bah1h6o _1reo15vq _18m915vq _2rko1k7a",
            __cmplp.className
        ])
    });
});
const $4ed524f132b65d0c$var$ImageControl = /*#__PURE__*/ (0, $47bDC.default).img.withConfig({
    componentId: "sc-6nvsi2-0"
})({
    display: 'block',
    maxWidth: '100%',
    minWidth: 0,
    maxHeight: `${$4ed524f132b65d0c$var$coverMaxHeight}px`,
    minHeight: 0
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ed524f132b65d0c$var$ImageExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _p12f1osq _1ul9idpf _c71lgx0z _1tkeidpf",
            __cmplp.className
        ])
    });
});
const $4ed524f132b65d0c$var$Image = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $4ed524f132b65d0c$var$ImageExperiment, $4ed524f132b65d0c$var$ImageControl);

});

parcelRegister("bbQQn", function(module, exports) {

$parcel$export(module.exports, "CardCustomFields", () => $3d8f972b9298b134$export$9070bf61c3b8c828);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $heNNl = parcelRequire("heNNl");

var $dNOob = parcelRequire("dNOob");

var $1U6hS = parcelRequire("1U6hS");
const $3d8f972b9298b134$export$9070bf61c3b8c828 = ({ fields: fields, isCMPBoard: isCMPBoard, fixVersions: fixVersions })=>{
    if (!fields || fields.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "jira-platform-card-custom-field",
        packageName: "jira-platform-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3d8f972b9298b134$var$CustomCardFieldList, {
        "data-testid": "platform-card.common.ui.custom-fields.custom-card-field-list",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $dNOob.customCardFieldList
    }, fields.map((field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1U6hS.CardCustomField), {
            field: field,
            key: field.id,
            isCMPBoard: isCMPBoard,
            fixVersions: fixVersions
        }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3d8f972b9298b134$var$CustomCardFieldList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _p12f1osq _1e0c1txw _2lx21bp4 _zulp1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1U6hS", function(module, exports) {

$parcel$export(module.exports, "CardCustomField", () => $0c0d9ba3933dcea9$export$2059d37a79d2fa46);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $2rgYg = parcelRequire("2rgYg");

var $khuza = parcelRequire("khuza");

var $fczXD = parcelRequire("fczXD");

var $9yDQx = parcelRequire("9yDQx");

var $21RvA = parcelRequire("21RvA");

var $g3il2 = parcelRequire("g3il2");

var $jdK9h = parcelRequire("jdK9h");
const $0c0d9ba3933dcea9$export$2059d37a79d2fa46 = ({ field: field, isCMPBoard: isCMPBoard, fixVersions: fixVersions })=>{
    const content = (()=>{
        if (field.renderer === 'number') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yDQx.TextCardCustomFieldContent), {
            field: {
                text: field.value != null ? String(field.value) : undefined
            }
        });
        if (field.renderer === 'sla') return field.value !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rgYg.default), {
            ...field.value,
            "data-testid": "platform-card.common.ui.custom-fields.card-custom-field.sla"
        }) : null;
        // TMP renders labels outside of custom fields
        if (isCMPBoard && field.renderer === 'text' && field.id === (0, $g3il2.CUSTOM_FIELD_LABELS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g3il2.TextLabelCustomFieldContent), {
            field: field
        });
        if (field.renderer === 'text' && field.id === (0, $21RvA.CUSTOM_FIELD_FIX_VERSIONS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $21RvA.TextFixVersionsCustomFieldContent), {
            field: field,
            fixVersions: fixVersions
        });
        if (field.renderer === 'text' || field.renderer === 'status' || field.renderer === 'epiclink') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yDQx.TextCardCustomFieldContent), {
            field: field
        });
        if (field.renderer === 'url' && (0, $6s1PB.expValEquals)('jsw_perf_format-links-in-custom-fields', 'board-and-backlog', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdK9h.TextSmartLinkCustomFieldContent), {
            field: field
        });
        if (field.renderer === 'html' || field.renderer === 'date' || field.renderer === 'duration' || field.renderer === 'url') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fczXD.AsyncHtmlCardCustomFieldContent), {
            field: field
        });
        // This is a type assertion that will make TypeScript make sure all
        // `renderers` are checked above and that it's impossible to render
        // null for known types.
        const _unreachable = field;
        return null;
    })();
    if (content == null) return null;
    const isSmartLink = (0, $6s1PB.expValEquals)('jsw_perf_format-links-in-custom-fields', 'board-and-backlog', true) && field.renderer === 'url';
    // Hiding tooltip for html fields that already have tooltips
    const hideTooltip = field.label === 'Development' || isSmartLink;
    if (hideTooltip) return content;
    if (field.renderer === 'text' && field.id === (0, $21RvA.CUSTOM_FIELD_FIX_VERSIONS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: field.text,
        position: "bottom-start"
    }, content);
    // all type of custom fields have renderer of html
    // except the label custom field which has renderer of text
    return field.renderer === 'html' || field.renderer === 'text' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khuza.CustomFieldTooltip), {
        field: field
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: field.label
    }, content);
};

});
parcelRegister("2rgYg", function(module, exports) {

$parcel$export(module.exports, "Sla", () => $5236efa409cf0c4b$export$71bf8c15c1931c45);
$parcel$export(module.exports, "default", () => $5236efa409cf0c4b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $ewfjW = parcelRequire("ewfjW");

var $i6DtB = parcelRequire("i6DtB");
const $5236efa409cf0c4b$export$71bf8c15c1931c45 = (props)=>{
    const transformedSla = (0, $i6DtB.transformSlaResponse)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5236efa409cf0c4b$var$SlaContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ewfjW.AsyncLazySla), {
        value: transformedSla.value,
        viewMode: (0, $bb10fe9d5bb31c29$export$a63db8d18dae0c68)
    }));
};
var $5236efa409cf0c4b$export$2e2bcd8739ae039 = $5236efa409cf0c4b$export$71bf8c15c1931c45;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5236efa409cf0c4b$var$SlaContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1y6m",
            __cmplp.className
        ])
    });
});

});
const $bb10fe9d5bb31c29$export$a63db8d18dae0c68 = 'card';
const $bb10fe9d5bb31c29$export$2e5e3c3156fc4c3c = 'queue';

parcelRegister("ewfjW", function(module, exports) {

$parcel$export(module.exports, "AsyncLazySla", () => $becd35c254cf8313$export$e4c697b53a973eb5);

var $5uXOq = parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $heNNl = parcelRequire("heNNl");

var $kxZPA = parcelRequire("kxZPA");
var $7hSN4 = parcelRequire("7hSN4");

const $becd35c254cf8313$var$AsyncSla = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("3Vaqq")), {
    moduleId: "./src/packages/jira-issue-sla/src/ui/sla/main.tsx"
});
const $becd35c254cf8313$export$e4c697b53a973eb5 = (props)=>{
    const { viewMode: viewMode, onError: onError } = props;
    const boundary = (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(`sla ${viewMode} View`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: boundary,
        packageName: "jira-issue-sla",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7hSN4.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($becd35c254cf8313$var$AsyncSla, props)));
};

});
parcelRegister("3Vaqq", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("ethEL")
]).then(()=>parcelRequire('hN8Ee'));

});


parcelRegister("i6DtB", function(module, exports) {

$parcel$export(module.exports, "getStyles", () => $2be00e693919d411$export$ffd58b7f6f099a57);
$parcel$export(module.exports, "createUUID", () => $2be00e693919d411$export$5dbf9a24b655dde4);
$parcel$export(module.exports, "transformSlaResponse", () => $2be00e693919d411$export$40936768e55efbd7);

var $7Jxgt = parcelRequire("7Jxgt");

var $fkIan = parcelRequire("fkIan");

var $gVtcM = parcelRequire("gVtcM");

const $2be00e693919d411$export$ffd58b7f6f099a57 = (isBreached, status, timeRemainingInMinutes)=>{
    if (status === (0, $b25eb0ff361bcea0$export$fc332a617fd34192) && !isBreached) return 0, $fkIan.SUCCESS_STYLE;
    if (status === (0, $b25eb0ff361bcea0$export$fc332a617fd34192) && isBreached) return 0, $fkIan.FAILURE_STYLE;
    if (status === (0, $b25eb0ff361bcea0$export$3ad39751a33c16b8)) {
        if (timeRemainingInMinutes < 0) return 0, $fkIan.PAUSED_BREACHED_STYLE;
        if (timeRemainingInMinutes < 30) return 0, $fkIan.PAUSED_UNDER_THIRTY_REMAINING_STYLE;
        return 0, $fkIan.PAUSED_STYLE;
    }
    if (timeRemainingInMinutes < 0) return 0, $fkIan.ONGOING_BREACHED_STYLE;
    if (timeRemainingInMinutes < 30) return 0, $fkIan.ONGOING_UNDER_THIRTY_REMAINING_STYLE;
    return 0, $fkIan.ONGOING_STYLE;
};
const $2be00e693919d411$export$5dbf9a24b655dde4 = ()=>{
    //  Here session is one scroll, session is destroyed on component unmount.
    let sessionUuid;
    return (reset = false)=>{
        if (reset) sessionUuid = undefined;
        if (sessionUuid !== undefined) return sessionUuid;
        sessionUuid = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4();
        return sessionUuid;
    };
};
const $2be00e693919d411$export$40936768e55efbd7 = (slaProps)=>{
    const props = {
        storedValue: {
            // @ts-expect-error Type 'SlaFieldResponse' is not assignable to type 'Sla | SlaError'.ts(2322)
            value: slaProps
        }
    };
    return (0, $gVtcM.SlaFieldTransformer)(props);
};

});
parcelRegister("fkIan", function(module, exports) {

$parcel$export(module.exports, "SUCCESS_STYLE", () => $aed6bfb6da5b8978$export$e0b777e1e3a27f60);
$parcel$export(module.exports, "FAILURE_STYLE", () => $aed6bfb6da5b8978$export$979e63416456f996);
$parcel$export(module.exports, "PAUSED_STYLE", () => $aed6bfb6da5b8978$export$31c01b2337a4e7bc);
$parcel$export(module.exports, "PAUSED_BREACHED_STYLE", () => $aed6bfb6da5b8978$export$ca3b08ed23a07398);
$parcel$export(module.exports, "PAUSED_UNDER_THIRTY_REMAINING_STYLE", () => $aed6bfb6da5b8978$export$2866aae38e6ee5dc);
$parcel$export(module.exports, "ONGOING_STYLE", () => $aed6bfb6da5b8978$export$867e46b264a774ee);
$parcel$export(module.exports, "ONGOING_BREACHED_STYLE", () => $aed6bfb6da5b8978$export$a8f25d0554ec3ad7);
$parcel$export(module.exports, "ONGOING_UNDER_THIRTY_REMAINING_STYLE", () => $aed6bfb6da5b8978$export$700ee37c8cfc07d8);

const $aed6bfb6da5b8978$export$a7502422f07570ed = 'metric not found';
const $aed6bfb6da5b8978$var$SEMIBOLD = 600;
const $aed6bfb6da5b8978$export$4a177926f40a25ca = /No goal with this id \d+ for time metric \d+/;
const $aed6bfb6da5b8978$export$f790c24298ed441b = 'com.atlassian.servicedesk:sd-sla-field';
const $aed6bfb6da5b8978$var$defaultBackgroundColor = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $aed6bfb6da5b8978$var$successFailureBackgroundColor = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $aed6bfb6da5b8978$var$defaultTextColor = "var(--ds-text-subtle, #44546F)";
const $aed6bfb6da5b8978$export$e0b777e1e3a27f60 = {
    backgroundColor: $aed6bfb6da5b8978$var$successFailureBackgroundColor,
    textColor: $aed6bfb6da5b8978$var$defaultTextColor,
    iconColor: "var(--ds-icon-success, #22A06B)",
    fontWeight: 'bold',
    backgroundIconColor: 'transparent'
};
const $aed6bfb6da5b8978$export$979e63416456f996 = {
    backgroundColor: $aed6bfb6da5b8978$var$successFailureBackgroundColor,
    textColor: $aed6bfb6da5b8978$var$defaultTextColor,
    iconColor: "var(--ds-icon-danger, #E34935)",
    fontWeight: 'bold',
    backgroundIconColor: 'transparent'
};
const $aed6bfb6da5b8978$export$31c01b2337a4e7bc = {
    backgroundColor: $aed6bfb6da5b8978$var$defaultBackgroundColor,
    textColor: $aed6bfb6da5b8978$var$defaultTextColor,
    iconColor: "var(--ds-icon-subtle, #626F86)",
    fontWeight: $aed6bfb6da5b8978$var$SEMIBOLD,
    backgroundIconColor: 'transparent'
};
const $aed6bfb6da5b8978$export$ca3b08ed23a07398 = {
    backgroundColor: $aed6bfb6da5b8978$var$defaultBackgroundColor,
    textColor: $aed6bfb6da5b8978$var$defaultTextColor,
    fontWeight: $aed6bfb6da5b8978$var$SEMIBOLD,
    iconColor: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    backgroundIconColor: "var(--ds-icon-danger, #E34935)"
};
const $aed6bfb6da5b8978$export$2866aae38e6ee5dc = {
    backgroundColor: $aed6bfb6da5b8978$var$defaultBackgroundColor,
    textColor: $aed6bfb6da5b8978$var$defaultTextColor,
    fontWeight: $aed6bfb6da5b8978$var$SEMIBOLD,
    iconColor: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    backgroundIconColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y400})`
};
const $aed6bfb6da5b8978$export$867e46b264a774ee = {
    backgroundColor: $aed6bfb6da5b8978$var$defaultBackgroundColor,
    textColor: $aed6bfb6da5b8978$var$defaultTextColor,
    iconColor: "var(--ds-icon-subtle, #626F86)",
    fontWeight: $aed6bfb6da5b8978$var$SEMIBOLD,
    backgroundIconColor: 'transparent'
};
const $aed6bfb6da5b8978$export$a8f25d0554ec3ad7 = {
    backgroundColor: "var(--ds-background-danger-bold, #CA3521)",
    textColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    iconColor: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
    fontWeight: 'bold',
    backgroundIconColor: 'transparent'
};
const $aed6bfb6da5b8978$export$700ee37c8cfc07d8 = {
    backgroundColor: "var(--ds-background-warning-bold, #E2B203)",
    textColor: "var(--ds-text-warning-inverse, #172B4D)",
    iconColor: "var(--ds-text-warning-inverse, #172B4D)",
    fontWeight: 'bold',
    backgroundIconColor: 'transparent'
};

});

parcelRegister("gVtcM", function(module, exports) {

$parcel$export(module.exports, "SlaFieldTransformer", () => $2d5607b6fb0646db$export$631ca5fe503ed873);

var $gwejS = parcelRequire("gwejS");
var $it1wb = parcelRequire("it1wb");
var $pyK8a = parcelRequire("pyK8a");

var $dwDIK = parcelRequire("dwDIK");
var $7CMcV = parcelRequire("7CMcV");

var $dJl1T = parcelRequire("dJl1T");

var $aWse0 = parcelRequire("aWse0");


var $DVljb = parcelRequire("DVljb");

var $leRCk = parcelRequire("leRCk");

var $3UxsC = parcelRequire("3UxsC");

const $2d5607b6fb0646db$var$LOCATION = 'servicedesk.queues.selectors.fields-transformers.json-fields.custom-fields';
const $2d5607b6fb0646db$var$checkCycleValidity = (cycle)=>{
    const { remainingTime: remainingTime, goalDuration: goalDuration, elapsedTime: elapsedTime } = cycle;
    const undefinedValues = [];
    if (!remainingTime) undefinedValues.push('remainingTime');
    if (!goalDuration) undefinedValues.push('goalDuration');
    if (!elapsedTime) undefinedValues.push('elapsedTime');
    return undefinedValues;
};
const $2d5607b6fb0646db$var$isCompletedCycleValid = (cycle)=>{
    const undefinedValues = $2d5607b6fb0646db$var$checkCycleValidity(cycle);
    if (undefinedValues.length > 0) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData($2d5607b6fb0646db$var$LOCATION, `[FD-4303] CompletedCycle data is invalid: ${String(undefinedValues)}`);
        return false;
    }
    return true;
};
const $2d5607b6fb0646db$var$isOngoingCycleValid = (cycle)=>{
    const undefinedValues = $2d5607b6fb0646db$var$checkCycleValidity(cycle);
    if (undefinedValues.length > 0) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData($2d5607b6fb0646db$var$LOCATION, `[FD-4303] OngoingCycle data is invalid: ${String(undefinedValues)}`);
        return false;
    }
    return true;
};
const $2d5607b6fb0646db$var$getLastCompletedCycle = (completedCycles)=>{
    let lastCompletedCycle = completedCycles[0];
    completedCycles.forEach((cycle)=>{
        if (cycle.stopTime.epochMillis > lastCompletedCycle.stopTime.epochMillis) lastCompletedCycle = cycle;
    });
    return lastCompletedCycle;
};
const $2d5607b6fb0646db$var$getDays = (timezone)=>{
    const date = (0, $7CMcV.default)(new Date(), timezone);
    return [
        (0, $it1wb.default)(date),
        (0, $it1wb.default)((0, $gwejS.default)(date, 1)),
        (0, $it1wb.default)((0, $pyK8a.default)(date, 1))
    ];
};
// This shall be deleted when localised time shown feature is fully rolled out
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2d5607b6fb0646db$var$getMatchingDay = (receivedDate, timezone, formatMessage)=>{
    const [today, tomorrow, yesterday] = $2d5607b6fb0646db$var$getDays(timezone);
    const isSame = (dateOne, dateTwo)=>dateOne.getDate() === dateTwo.getDate() && dateOne.getMonth() === dateTwo.getMonth() && dateOne.getFullYear() === dateTwo.getFullYear();
    const isToday = isSame(today, receivedDate);
    const isTomorrow = isSame(tomorrow, receivedDate);
    const isYesterday = isSame(yesterday, receivedDate);
    let defaultDayFormat = (0, $dwDIK.default)(receivedDate, 'd MMM');
    isToday && (defaultDayFormat = formatMessage((0, $3UxsC.default).today));
    isTomorrow && (defaultDayFormat = formatMessage((0, $3UxsC.default).tomorrow));
    isYesterday && (defaultDayFormat = formatMessage((0, $3UxsC.default).yesterday));
    return defaultDayFormat;
};
const $2d5607b6fb0646db$export$9015300e6978c54b = (timeInEpochMillis, userTimezone, formatMessage)=>{
    if (timeInEpochMillis) {
        const breachTimeTz = (0, $7CMcV.default)(timeInEpochMillis, userTimezone);
        return `${$2d5607b6fb0646db$var$getMatchingDay(breachTimeTz, userTimezone, formatMessage)} ${(0, $dwDIK.default)(breachTimeTz, 'hh:mm a', {
            timeZone: userTimezone
        })}`;
    }
    return '';
};
const $2d5607b6fb0646db$export$631ca5fe503ed873 = ({ storedValue: storedValue })=>{
    const { value: responseValue } = storedValue;
    const [{ data: loggedInUser }] = (0, $leRCk.useUserSubscriber)();
    const userTimezone = loggedInUser?.timeZone || 'America/Toronto';
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $aWse0.useIntlV2)();
    let locale = (0, $DVljb.useLocale)();
    if (locale === undefined) locale = 'en_US';
    const localeString = locale.replace('_', '-');
    const dateTimeFormat = new Intl.DateTimeFormat(localeString, {
        hour: 'numeric'
    });
    const isBrowserLocale24h = ()=>!dateTimeFormat.format(0).match(/[A/P]M/);
    const getMatchingDayForLocale = (receivedDate, timeInEpochMillis)=>{
        const [today, tomorrow, yesterday] = $2d5607b6fb0646db$var$getDays(userTimezone);
        const isSame = (dateOne, dateTwo)=>dateOne.getDate() === dateTwo.getDate() && dateOne.getMonth() === dateTwo.getMonth() && dateOne.getFullYear() === dateTwo.getFullYear();
        const isToday = isSame(today, receivedDate);
        const isTomorrow = isSame(tomorrow, receivedDate);
        const isYesterday = isSame(yesterday, receivedDate);
        let defaultDayFormat = formatDate(timeInEpochMillis, {
            timeZone: userTimezone,
            day: '2-digit',
            month: 'short'
        });
        isToday && (defaultDayFormat = formatMessage((0, $3UxsC.default).today));
        isTomorrow && (defaultDayFormat = formatMessage((0, $3UxsC.default).tomorrow));
        isYesterday && (defaultDayFormat = formatMessage((0, $3UxsC.default).yesterday));
        return defaultDayFormat;
    };
    const getTimeInSlaFriendlierFormatForLocale = (timeInEpochMillis)=>{
        if (timeInEpochMillis) {
            const breachTimeTz = (0, $7CMcV.default)(timeInEpochMillis, userTimezone);
            return `${getMatchingDayForLocale(breachTimeTz, timeInEpochMillis)} ${formatDate(timeInEpochMillis, {
                hour12: !isBrowserLocale24h(),
                timeZone: userTimezone,
                hour: '2-digit',
                minute: '2-digit'
            })}`;
        }
        return '';
    };
    const getTimeRemainingInMinutes = (timeInHourSpaceMinutes)=>{
        const isTimeInMinus = timeInHourSpaceMinutes.indexOf('-') === 0;
        const absoluteTime = isTimeInMinus ? timeInHourSpaceMinutes.substring(1) : timeInHourSpaceMinutes;
        const millis = parseInt(absoluteTime, 10);
        const totalMinutes = millis / 60000;
        return isTimeInMinus ? -1 * totalMinutes : totalMinutes;
    };
    const getPercentageOfTimeTaken = (goalTime, remainingTime)=>{
        const goalTimeInMinutes = getTimeRemainingInMinutes(goalTime);
        const remainingTimeInMinutes = getTimeRemainingInMinutes(remainingTime);
        let percentage = (goalTimeInMinutes - remainingTimeInMinutes) / goalTimeInMinutes;
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'number'.
        percentage = (percentage * 100).toFixed(2);
        // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
        return Math.round(parseInt(percentage, 10)).toString();
    };
    const getBreachTimeInLocalStringForLocale = (breachTimeInEpochMillis)=>{
        if (breachTimeInEpochMillis) {
            const BREACH_DATE = (0, $7CMcV.default)(breachTimeInEpochMillis, userTimezone);
            return `${formatDate(breachTimeInEpochMillis, {
                hour12: !isBrowserLocale24h(),
                timeZone: userTimezone,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            })} GMT${(0, $dwDIK.default)(BREACH_DATE, 'xx', {
                timeZone: userTimezone
            })}`;
        }
        return `${formatMessage((0, $3UxsC.default).notApplicable)}`;
    };
    const getHoverContent = (closed, remainingTimeMillis, breachTime, goalTimeMillis, goalTimeLongFriendly, remainingTimeFriendly)=>{
        const isTimeInMinus = remainingTimeFriendly.indexOf('-') === 0;
        let remainingTimeString;
        let timeStatus;
        if (isTimeInMinus) {
            remainingTimeString = remainingTimeFriendly.substring(1);
            timeStatus = formatMessage((0, $3UxsC.default).past);
        } else {
            remainingTimeString = remainingTimeFriendly;
            timeStatus = formatMessage((0, $3UxsC.default).left);
        }
        if (closed === true) {
            timeStatus = isTimeInMinus ? formatMessage((0, $3UxsC.default).breached) : formatMessage((0, $3UxsC.default).met);
            const percentage = getPercentageOfTimeTaken(goalTimeMillis, remainingTimeMillis);
            const hoverContentCompleted = `${isTimeInMinus ? `-${remainingTimeString}` : remainingTimeString} ${timeStatus ?? ''} ${String.fromCodePoint(0x2022)} ${percentage}% of ${goalTimeLongFriendly} ${String.fromCodePoint(0x2022)} ${getBreachTimeInLocalStringForLocale(breachTime)}`;
            return hoverContentCompleted;
        }
        const hoverContent = `${remainingTimeString} ${timeStatus ?? ''} ${String.fromCodePoint(0x2022)} ${formatMessage((0, $3UxsC.default).due) ?? ''}: ${getBreachTimeInLocalStringForLocale(breachTime)}`;
        return hoverContent;
    };
    const friendlierHoverContent = (closed, remainingTimeMillis, breachTime, goalTimeMillis, goalTimeLongFriendly, remainingTimeFriendly, slaDisplayFormat)=>slaDisplayFormat === (0, $c8b70567b277fe50$export$13ecaaf97b049384) ? getHoverContent(closed, remainingTimeMillis, breachTime, goalTimeMillis, goalTimeLongFriendly, remainingTimeFriendly) : undefined;
    // @ts-expect-error - TS2339 - Property 'errorMessage' does not exist on type 'Sla | SlaError'.
    if (responseValue && responseValue.errorMessage) return {
        fieldType: (0, $b25eb0ff361bcea0$export$f790c24298ed441b),
        value: responseValue
    };
    if (responseValue && // @ts-expect-error - TS2339 - Property 'ongoingCycle' does not exist on type 'Sla | SlaError'.
    responseValue.ongoingCycle && // @ts-expect-error - TS2339 - Property 'ongoingCycle' does not exist on type 'Sla | SlaError'.
    $2d5607b6fb0646db$var$isOngoingCycleValid(responseValue.ongoingCycle)) {
        const { paused: paused, remainingTime: remainingTime, breached: breached, breachTime: breachTime, goalDuration: goalDuration, elapsedTime: elapsedTime, withinCalendarHours: withinCalendarHours } = responseValue.ongoingCycle;
        const slaDisplayFormat = // @ts-expect-error - TS2339 - Property 'slaDisplayFormat' does not exist on type 'Sla | SlaError'.
        responseValue.slaDisplayFormat ?? (0, $c8b70567b277fe50$export$13ecaaf97b049384);
        // When an SLA is paused due to being outside of working hours, the paused value is false
        const status = paused || !withinCalendarHours ? (0, $b25eb0ff361bcea0$export$3ad39751a33c16b8) : (0, $b25eb0ff361bcea0$export$d1917132a74c7b93);
        const timeRemainingInMinutes = Math.floor(remainingTime.millis / 60000);
        const breachTimeFriendly = breachTime ? breachTime.friendly : undefined;
        const timeInFriendlyFormat = ()=>getTimeInSlaFriendlierFormatForLocale(breachTime?.epochMillis).toString();
        return {
            fieldType: (0, $b25eb0ff361bcea0$export$f790c24298ed441b),
            value: {
                status: status,
                timeRemainingFriendly: slaDisplayFormat === (0, $c8b70567b277fe50$export$13ecaaf97b049384) ? timeInFriendlyFormat() : remainingTime.friendly,
                isBreached: breached,
                timeRemainingInMinutes: timeRemainingInMinutes,
                breachTime: breachTimeFriendly,
                elapsedTime: elapsedTime.friendly,
                goalDuration: goalDuration.friendly,
                withinCalendarHours: withinCalendarHours,
                hoverContent: friendlierHoverContent(false, `${remainingTime.millis}`, breachTime?.epochMillis, goalDuration.millis, goalDuration.friendly, remainingTime.friendly, slaDisplayFormat),
                slaDisplayFormat: slaDisplayFormat
            }
        };
    }
    if (responseValue && // @ts-expect-error - TS2339 - Property 'completedCycles' does not exist on type 'Sla | SlaError'.
    responseValue.completedCycles && // @ts-expect-error - TS2339 - Property 'completedCycles' does not exist on type 'Sla | SlaError'.
    responseValue.completedCycles.length !== 0) {
        const slaDisplayFormat = // @ts-expect-error - TS2339 - Property 'slaDisplayFormat' does not exist on type 'Sla | SlaError'.
        responseValue.slaDisplayFormat ?? (0, $c8b70567b277fe50$export$13ecaaf97b049384);
        // @ts-expect-error - TS2339 - Property 'completedCycles' does not exist on type 'Sla | SlaError'.
        const lastCompletedCycle = $2d5607b6fb0646db$var$getLastCompletedCycle(responseValue.completedCycles);
        if (!$2d5607b6fb0646db$var$isCompletedCycleValid(lastCompletedCycle)) return {
            fieldType: (0, $b25eb0ff361bcea0$export$f790c24298ed441b)
        };
        const timeRemainingInMinutes = Math.floor(lastCompletedCycle.remainingTime.millis / 60000);
        const { remainingTime: remainingTime, breached: breached, goalDuration: goalDuration, elapsedTime: elapsedTime, stopTime: stopTime, breachTime: breachTime } = lastCompletedCycle;
        const timeInFriendlyFormat = ()=>getTimeInSlaFriendlierFormatForLocale(stopTime.epochMillis).toString();
        return {
            fieldType: (0, $b25eb0ff361bcea0$export$f790c24298ed441b),
            value: {
                status: (0, $b25eb0ff361bcea0$export$fc332a617fd34192),
                timeRemainingFriendly: slaDisplayFormat === (0, $c8b70567b277fe50$export$13ecaaf97b049384) ? timeInFriendlyFormat() : remainingTime.friendly,
                isBreached: breached,
                timeRemainingInMinutes: timeRemainingInMinutes,
                // A completed cycle doesn't have a breachTime value
                breachTime: undefined,
                elapsedTime: elapsedTime.friendly,
                goalDuration: goalDuration.friendly,
                withinCalendarHours: undefined,
                hoverContent: friendlierHoverContent(true, `${remainingTime.millis}`, breachTime?.epochMillis, `${goalDuration.millis}`, goalDuration.friendly, remainingTime.friendly, slaDisplayFormat),
                slaDisplayFormat: slaDisplayFormat
            }
        };
    }
    return {
        fieldType: (0, $b25eb0ff361bcea0$export$f790c24298ed441b)
    };
};

});
const $c8b70567b277fe50$export$aad60a8e044b5914 = 'OLD_SLA_FORMAT';
const $c8b70567b277fe50$export$13ecaaf97b049384 = 'NEW_SLA_FORMAT';

parcelRegister("DVljb", function(module, exports) {

$parcel$export(module.exports, "useLocale", () => $7c760643dc748494$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $7c760643dc748494$export$31652d9c30d7d3f3);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $9OXo1 = parcelRequire("9OXo1");
const $7c760643dc748494$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $lzeFL.defaultLocale);
};
const $7c760643dc748494$export$31652d9c30d7d3f3 = ()=>{
    const locale = $7c760643dc748494$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $5uXOq.useMemo)(()=>(0, $lzeFL.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});

parcelRegister("3UxsC", function(module, exports) {

$parcel$export(module.exports, "default", () => $052279bee594c9ad$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $052279bee594c9ad$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    /* eslint-disable jira/i18n/id-named-by-package */ title: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.title",
        "defaultMessage": "SLAs"
    },
    past: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.past",
        "defaultMessage": "past"
    },
    left: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.left",
        "defaultMessage": "left"
    },
    met: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.met",
        "defaultMessage": "met"
    },
    breached: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.breached",
        "defaultMessage": "breached"
    },
    due: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.due",
        "defaultMessage": "Due"
    },
    today: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.today",
        "defaultMessage": "Today"
    },
    tomorrow: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.tomorrow",
        "defaultMessage": "Tomorrow"
    },
    yesterday: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.yesterday",
        "defaultMessage": "Yesterday"
    },
    notApplicable: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.not-applicable",
        "defaultMessage": "Breach time not found"
    }
});

});

const $b25eb0ff361bcea0$export$d1917132a74c7b93 = 'ONGOING';
const $b25eb0ff361bcea0$export$fc332a617fd34192 = 'COMPLETED';
const $b25eb0ff361bcea0$export$3ad39751a33c16b8 = 'PAUSED';
const $b25eb0ff361bcea0$export$f790c24298ed441b = 'com.atlassian.servicedesk:sd-sla-field';




parcelRegister("khuza", function(module, exports) {

$parcel$export(module.exports, "CustomFieldTooltip", () => $52d0364850dc7782$export$5ab920ffa0a3e029);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");
const $52d0364850dc7782$export$5ab920ffa0a3e029 = ({ field: field, children: children })=>{
    const { label: label } = field;
    const [tooltipContent, setTooltipContent] = (0, $5uXOq.useState)(label);
    const ref = (0, $5uXOq.useRef)(null);
    const onShow = ()=>{
        if (ref.current && ref.current.innerText) {
            const toolTipString = `${label}: ${ref.current.innerText}`;
            if (toolTipString !== tooltipContent) setTooltipContent(toolTipString);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        onShow: onShow,
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ref
    }, children));
};

});

parcelRegister("fczXD", function(module, exports) {

$parcel$export(module.exports, "AsyncHtmlCardCustomFieldContent", () => $344098861f5bd75a$export$b66a48885dbad832);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $344098861f5bd75a$var$LazyHtmlCardCustomFieldContent = (0, $kxZPA.lazy)(()=>Promise.resolve((parcelRequire("71sS1"))).then(({ HtmlCardCustomFieldContent: HtmlCardCustomFieldContent })=>HtmlCardCustomFieldContent), {
    moduleId: "./src/packages/platform/ui/card/src/common/ui/custom-fields/card-custom-field/html-card-custom-field-content/main.tsx"
});
const $344098861f5bd75a$export$b66a48885dbad832 = ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "async-board-card-html-field",
        packageName: "board-kit-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-html-card-custom-field-content",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($344098861f5bd75a$var$LazyHtmlCardCustomFieldContent, {
        field: field
    })));

});
parcelRegister("71sS1", function(module, exports) {

$parcel$export(module.exports, "HtmlCardCustomFieldContent", () => $1ee715bf797bb541$export$b0d54fd3c476d26b);
$parcel$export(module.exports, "CustomCardFieldContainer", () => $1ee715bf797bb541$export$6ba966c410f0ea4);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hXLCJ = parcelRequire("hXLCJ");
const $1ee715bf797bb541$export$b0d54fd3c476d26b = ({ field: field })=>{
    const stopIssueModalOpen = (event)=>{
        if (field.label === 'Development') event.stopPropagation();
    };
    // filter out jQuery LiveStamp hooks which replace desired time html with a relative date in CMP UIF Kanban
    const htmlWithJQueryLiveStampClassesRemoved = field?.html && field.html.replace('livestamp allow-future', '');
    return field.html ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ee715bf797bb541$export$6ba966c410f0ea4, {
        "data-testid": "platform-card.common.ui.custom-fields.card-custom-field.html-card-custom-field-content.html-field",
        "data-issuefieldid": field.id,
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($hXLCJ))).sanitize(htmlWithJQueryLiveStampClassesRemoved ?? '')
        },
        disablePointerEvents: field.id === 'thumbnail',
        onClick: stopIssueModalOpen
    }) : null;
};
const $1ee715bf797bb541$export$6ba966c410f0ea4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNone: isNone, disablePointerEvents: disablePointerEvents, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721q9c _1reo15vq _18m915vq _p12f1osq _2hwx1wug _1bto1l2s _syaz1e9r _1bsk1osq _1y8m1wug _1maq1b66 _14991b66 _w9a21wug _bbhg1wug _1rjkglyw _1rxbnkob _1jbznkob _w77h1osq _5rkt1l2s _umv415vq _wwzv15vq _1suh1wug _xnkt1wug _rtysuuw1 _19l353f4 _1md0idpf _1ci4idpf _1qwe1ule _1npa1y44 _pokj1osq _qehnidpf _18vridpf _1nlwidpf _12isidpf _ql9ct94y _gzx61wug _knrj1l7b _1urb1y44 _7998idpf _18pvidpf _11o7idpf _17l5idpf _1mmrt94y",
            __cmplp.isNone ? "_zg8l1m30" : "_zg8l1kw7",
            __cmplp.isNone ? "_tzy4txnc" : "_tzy4kb7n",
            __cmplp.disablePointerEvents ? "_lcxvglyw" : "_lcxv1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hXLCJ", function(module, exports) {
/*! @license DOMPurify 2.5.7 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.7/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.7';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});



parcelRegister("9yDQx", function(module, exports) {

$parcel$export(module.exports, "TextCardCustomFieldContent", () => $fdd358c8a9939852$export$7f2a6a62bcd53a5);

var $5uXOq = parcelRequire("5uXOq");

var $71sS1 = parcelRequire("71sS1");
const $fdd358c8a9939852$export$7f2a6a62bcd53a5 = ({ field: field })=>field.text ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $71sS1.CustomCardFieldContainer), {
        isNone: field.text === 'None',
        "data-testid": "platform-card.common.ui.custom-fields.card-custom-field.text-card-custom-field-content.field"
    }, field.text) : null;

});

parcelRegister("21RvA", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_FIELD_FIX_VERSIONS", () => $cd555e029573e1b8$export$24107c98bc621912);
$parcel$export(module.exports, "TextFixVersionsCustomFieldContent", () => $cd555e029573e1b8$export$e26fa5af79e17a9b);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $lj8SI = parcelRequire("lj8SI");

var $koVbs = parcelRequire("koVbs");

var $1mAp4 = parcelRequire("1mAp4");
const $cd555e029573e1b8$export$24107c98bc621912 = 'fixVersions';
const $cd555e029573e1b8$export$e26fa5af79e17a9b = ({ field: field, fixVersions: fixVersions = [] })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(field) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(field.text) || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(field.text)) return null;
    const versionsCount = fixVersions.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cd555e029573e1b8$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), null, versionsCount > 1 ? formatMessage((0, $1mAp4.messages).multipleVersionsContent, {
        versionsCount: versionsCount
    }) : field.text));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $cd555e029573e1b8$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1osq _1e0c1txw _1bah1y6m _4cvr1h6o _13t37vkz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1mAp4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $416469f8d99e1748$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $416469f8d99e1748$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    multipleVersionsContent: {
        "id": "card.common.custom-fields.card-custom-field.text-fix-versions-custom-field-content.multiple-versions-content",
        "defaultMessage": "{versionsCount} versions"
    }
});

});


parcelRegister("g3il2", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_FIELD_LABELS", () => $9874ac763561bf35$export$b1cb468c302d21f9);
$parcel$export(module.exports, "TextLabelCustomFieldContent", () => $9874ac763561bf35$export$1babf298bf81c364);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $dHqFt = parcelRequire("dHqFt");
const $9874ac763561bf35$export$b1cb468c302d21f9 = 'labels';
const $9874ac763561bf35$export$1babf298bf81c364 = ({ field: field })=>{
    if (!field?.text) return null;
    const labels = field.text.split(',');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9874ac763561bf35$var$overflowOuterStyles,
        "data-testId": "text-label-custom-field-content-card-labels"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9874ac763561bf35$var$overflowInnerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHqFt.CardLabels), {
        isCMPBoard: true,
        labels: labels
    })));
};
const $9874ac763561bf35$var$overflowOuterStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexDirection: 'row',
    overflow: 'hidden'
});
const $9874ac763561bf35$var$overflowInnerStyles = (0, $8CUq3.xcss)({
    boxAlign: 'center',
    flexFlow: 'row wrap',
    alignItems: 'center',
    maxWidth: '100%',
    gap: 'space.100'
});

});

parcelRegister("jdK9h", function(module, exports) {

$parcel$export(module.exports, "TextSmartLinkCustomFieldContent", () => $04b5197ce11033cf$export$ec046456ac8ae97b);

var $5uXOq = parcelRequire("5uXOq");

var $iZOJ9 = parcelRequire("iZOJ9");

var $1RMb0 = parcelRequire("1RMb0");

var $khuza = parcelRequire("khuza");

var $9yDQx = parcelRequire("9yDQx");
const $04b5197ce11033cf$export$ec046456ac8ae97b = ({ field: field })=>field.text && (0, $iZOJ9.isSafeUrl)(field.text) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1RMb0.LazySingleLineSmartLink), {
        anchorTarget: "_blank",
        url: field.text
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khuza.CustomFieldTooltip), {
        field: field
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yDQx.TextCardCustomFieldContent), {
        field: field
    }));

});
parcelRegister("iZOJ9", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $dd4545da25e52dce$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $dd4545da25e52dce$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $dd4545da25e52dce$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $dd4545da25e52dce$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $dd4545da25e52dce$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $dd4545da25e52dce$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $i6xkD = parcelRequire("i6xkD");
const $dd4545da25e52dce$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
const $dd4545da25e52dce$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $dd4545da25e52dce$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $dd4545da25e52dce$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($i6xkD)))();
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $dd4545da25e52dce$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('tel:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('file:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $dd4545da25e52dce$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $dd4545da25e52dce$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$dd4545da25e52dce$var$tlds.push($dd4545da25e52dce$var$tlds2Char);
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.tlds($dd4545da25e52dce$var$tlds, false);
const $dd4545da25e52dce$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $dd4545da25e52dce$export$6f7d7761b97f967 = (text)=>{
    if (!$dd4545da25e52dce$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($dd4545da25e52dce$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($dd4545da25e52dce$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $dd4545da25e52dce$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $dd4545da25e52dce$export$6f7d7761b97f967(str);
    if (!match.length) match = $dd4545da25e52dce$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $dd4545da25e52dce$export$6535eb414fa2c8b6(url) {
    const match = $dd4545da25e52dce$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $dd4545da25e52dce$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("i6xkD", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $d2e2a485107d561a$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d2e2a485107d561a$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d2e2a485107d561a$var$isString(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object String]';
}
function $d2e2a485107d561a$var$isObject(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object Object]';
}
function $d2e2a485107d561a$var$isRegExp(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object RegExp]';
}
function $d2e2a485107d561a$var$isFunction(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object Function]';
}
function $d2e2a485107d561a$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $d2e2a485107d561a$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d2e2a485107d561a$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $d2e2a485107d561a$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $d2e2a485107d561a$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $d2e2a485107d561a$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $d2e2a485107d561a$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $d2e2a485107d561a$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $d2e2a485107d561a$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d2e2a485107d561a$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $d2e2a485107d561a$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("9mKTr"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d2e2a485107d561a$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d2e2a485107d561a$var$isObject(val)) {
            if ($d2e2a485107d561a$var$isRegExp(val.validate)) compiled.validate = $d2e2a485107d561a$var$createValidator(val.validate);
            else if ($d2e2a485107d561a$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d2e2a485107d561a$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d2e2a485107d561a$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d2e2a485107d561a$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $d2e2a485107d561a$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d2e2a485107d561a$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
    //
    // Cleanup
    //
    $d2e2a485107d561a$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d2e2a485107d561a$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d2e2a485107d561a$var$createMatch(self, shift) {
    var match = new $d2e2a485107d561a$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d2e2a485107d561a$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d2e2a485107d561a$var$LinkifyIt)) return new $d2e2a485107d561a$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d2e2a485107d561a$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d2e2a485107d561a$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d2e2a485107d561a$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d2e2a485107d561a$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d2e2a485107d561a$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d2e2a485107d561a$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d2e2a485107d561a$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d2e2a485107d561a$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d2e2a485107d561a$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $d2e2a485107d561a$var$LinkifyIt;

});
parcelRegister("9mKTr", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("b9ep3")).source;
    re.src_Cc = (parcelRequire("23ErL")).source;
    re.src_Z = (parcelRequire("oRY4m")).source;
    re.src_P = (parcelRequire("9bBmm")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + // don't allow `--` in domain names, because:
    // - that can conflict with markdown &mdash; / &ndash;
    // - nobody use those anyway
    '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("b9ep3", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("23ErL", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("oRY4m", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

});

parcelRegister("9bBmm", function(module, exports) {
module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});




parcelRegister("1RMb0", function(module, exports) {

$parcel$export(module.exports, "LazySingleLineSmartLink", () => $1520f3a29774e13a$export$80092fcb07ccc4b4);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $7c22Q = parcelRequire("7c22Q");
const $1520f3a29774e13a$var$entryPointParams = {};
const $1520f3a29774e13a$export$80092fcb07ccc4b4 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $7c22Q.SingleLineSmartLinkEntryPoint), $1520f3a29774e13a$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira.issue-field.single-line-smart-link",
        packageName: "issue-field-smart-link",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};

});
parcelRegister("7c22Q", function(module, exports) {

$parcel$export(module.exports, "SingleLineSmartLinkEntryPoint", () => $5f4ae65db2a1976a$export$e236c9b35543c8d);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $5f4ae65db2a1976a$export$e236c9b35543c8d = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("bVBtc")).then((module)=>module.SingleLineSmartLink), {
        moduleId: "97818dc4"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bVBtc", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("dsiAd"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("jo8eM")
]).then(()=>parcelRequire('k2J4N'));

});






parcelRegister("gRghR", function(module, exports) {

$parcel$export(module.exports, "CardFlag", () => $215dcd50a4cec540$export$c551eb098ad78be9);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8uZt8 = parcelRequire("8uZt8");


var $9dnfu = parcelRequire("9dnfu");
const $215dcd50a4cec540$export$c551eb098ad78be9 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const message = formatMessage((0, $9dnfu.default).done);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($215dcd50a4cec540$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8uZt8.default), {
        type: (0, $6d6eac2504286faf$export$aac403da0d127706),
        label: message,
        primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`
    })));
};
var $215dcd50a4cec540$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $215dcd50a4cec540$export$c551eb098ad78be9;
const $215dcd50a4cec540$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9dnfu", function(module, exports) {

$parcel$export(module.exports, "default", () => $c30141b180911976$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c30141b180911976$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    done: {
        "id": "card.common.flag.done",
        "defaultMessage": "Flagged"
    }
});

});


parcelRegister("8nii0", function(module, exports) {

$parcel$export(module.exports, "CardIcons", () => $0e1e23d3fd48a837$export$27b853f1f7815a63);
$parcel$export(module.exports, "Container", () => $0e1e23d3fd48a837$export$42a852a2b6b56249);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");
const $0e1e23d3fd48a837$export$27b853f1f7815a63 = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0e1e23d3fd48a837$export$42a852a2b6b56249, null, children);
};
var $0e1e23d3fd48a837$export$2e2bcd8739ae039 = $0e1e23d3fd48a837$export$27b853f1f7815a63;
const $0e1e23d3fd48a837$export$8272f94056fe109a = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "yyd5zx-0"
})({
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& > *': {
        margin: `0 ${"var(--ds-space-050, 4px)"} 0 0`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '& > :last-child': {
        marginRight: 0
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0e1e23d3fd48a837$var$ContainerExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vchhusvi _1e0c1txw _1bah1b1v _4cvr1h6o _etbnm31d _fhioidpf",
            __cmplp.className
        ])
    });
});
const $0e1e23d3fd48a837$export$42a852a2b6b56249 = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $0e1e23d3fd48a837$var$ContainerExperiment, $0e1e23d3fd48a837$export$8272f94056fe109a);

});

parcelRegister("k3Hho", function(module, exports) {

$parcel$export(module.exports, "CardKey", () => $ff81caf4d7800ecf$export$5bcc49a1014b751b);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $gVhaI = parcelRequire("gVhaI");

var $g1YKS = parcelRequire("g1YKS");
const $ff81caf4d7800ecf$export$5bcc49a1014b751b = /*#__PURE__*/ (0, $5uXOq.memo)(({ text: text, highlight: highlight = [], onClick: onClick, isDone: isDone = false, stopEventPropagation: stopEventPropagation = true, openInNewTab: openInNewTab = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const highlightedText = highlight && (0, $gVhaI.shouldHighlightText)(text, highlight) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gVhaI.HighlightText), {
        phrases: highlight,
        content: text
    }) : text;
    const onClickKey = (0, $5uXOq.useCallback)((event)=>{
        const isModifierClick = event.ctrlKey || event.altKey || event.metaKey || event.shiftKey;
        stopEventPropagation && event.stopPropagation();
        if (!isModifierClick && !openInNewTab) {
            event.preventDefault();
            onClick?.(event);
        }
    }, [
        onClick,
        openInNewTab,
        stopEventPropagation
    ]);
    // prevent the context menu and Bento from opening
    const onContextMenu = (0, $5uXOq.useCallback)((event)=>event.stopPropagation(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ff81caf4d7800ecf$export$42a852a2b6b56249, {
        "data-testid": "platform-card.common.ui.key.key"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ff81caf4d7800ecf$var$StyledLink, {
        isLineThrough: Boolean(isDone),
        href: `/browse/${text}`,
        target: "_blank",
        onContextMenu: onContextMenu,
        onClick: onClickKey,
        ...Boolean(isDone) && {
            'aria-label': formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $g1YKS.default).labelIssueTermRefresh : (0, $g1YKS.default).label, {
                issueKey: text
            })
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ff81caf4d7800ecf$export$cd0f44441c3b7719, {
        className: (0, $bwpsq.default)([
            (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('jira_nav4_beta_drop_1') && "_k48p1wq8"
        ])
    }, highlightedText))));
});
var $ff81caf4d7800ecf$export$2e2bcd8739ae039 = $ff81caf4d7800ecf$export$5bcc49a1014b751b;
const $ff81caf4d7800ecf$var$StyledLink = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLineThrough: isLineThrough, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_uizt1wug _syaz1o15",
            __cmplp.isLineThrough ? "_4bfu18uv _1hms1911 _ajmmnqa1" : "_4bfu18uv _1hmsglyw _ajmmnqa1",
            __cmplp.isLineThrough ? "_1nrm18uv _1a3b18uv _9oik18uv _5bd618uv _1ydc18uv _c2wa1911 _4fpr1911 _1bnx1911 _13jx1911 _1x281911 _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1" : "_1nrm18uv _1a3b18uv _9oik18uv _5bd618uv _1ydc18uv _c2waglyw _4fprglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ff81caf4d7800ecf$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zkb7n _i0dl1wug _1eim1xrj _o5721q9c _1reo15vq _18m915vq _1e38mo4m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ff81caf4d7800ecf$export$cd0f44441c3b7719 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _1reo15vq _18m915vq _1bto1l2s _11c8qk37 _k48pni7l _syaz1o15",
            __cmplp.className
        ])
    });
});
const $ff81caf4d7800ecf$var$KeyRefreshStyles = null;

});
parcelRegister("gVhaI", function(module, exports) {

$parcel$export(module.exports, "shouldHighlightText", () => $07b54d3092611445$export$dceb4ab0bd0273b3);
$parcel$export(module.exports, "HighlightText", () => $07b54d3092611445$export$bb02e7bc6e1a7119);

var $5uXOq = parcelRequire("5uXOq");

var $1H6kL = parcelRequire("1H6kL");

var $k2wwp = parcelRequire("k2wwp");
const $07b54d3092611445$export$dceb4ab0bd0273b3 = (text = '', keywords = [])=>text && text.length > 0 && keywords.filter((keyword)=>keyword !== '').length > 0 && keywords.some((keyword)=>(0, $1H6kL.removeAccents)(text).toLowerCase().includes(keyword.toLowerCase()) || text.toLowerCase().includes(keyword.toLowerCase()));
const $07b54d3092611445$export$bb02e7bc6e1a7119 = ({ content: content, phrases: phrases })=>{
    if (!phrases || !phrases.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2wwp.default), {
        highlight: phrases,
        text: content
    });
};
var $07b54d3092611445$export$2e2bcd8739ae039 = $07b54d3092611445$export$bb02e7bc6e1a7119;

});
parcelRegister("1H6kL", function(module, exports) {

$parcel$export(module.exports, "removeAccents", () => $0b92ef830f5aa8e4$export$f3f2882e8b11d731);
$parcel$export(module.exports, "getParts", () => $0b92ef830f5aa8e4$export$a3aee8a24a54661f);

var $8QDwl = parcelRequire("8QDwl");

var $ajpes = parcelRequire("ajpes");

var $3JOCw = parcelRequire("3JOCw");

var $8QpSo = parcelRequire("8QpSo");
const $0b92ef830f5aa8e4$export$f3f2882e8b11d731 = (0, $8QpSo.default)((text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
const $0b92ef830f5aa8e4$export$1633667427d99697 = (0, $8QpSo.default)((highlight)=>{
    const escapedFilter = highlight.map((phrase)=>(0, (/*@__PURE__*/$parcel$interopDefault($8QDwl)))(phrase)).join('|');
    return new RegExp(escapedFilter, 'gmi');
}, (newArgs, lastArgs)=>{
    if (newArgs.length !== lastArgs.length) return false;
    const equalityFn = (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)));
    return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
});
const $0b92ef830f5aa8e4$export$2235873b95f89ea = (content)=>({
        type: 'text',
        content: content
    });
const $0b92ef830f5aa8e4$export$39ae7d355c29b45f = (content)=>({
        type: 'highlight',
        content: content
    });
const $0b92ef830f5aa8e4$export$c05c39859172f90c = (str, regExp)=>{
    const ms = [];
    let m = regExp.exec(str);
    while(m){
        ms.push(m);
        m = regExp.exec(str);
    }
    return ms;
};
const $0b92ef830f5aa8e4$export$a3aee8a24a54661f = (highlight, text)=>{
    if (highlight == null || highlight.filter((phrase)=>phrase !== '').length === 0) return [
        $0b92ef830f5aa8e4$export$2235873b95f89ea(text)
    ];
    const parts = [];
    // Long text lengths will cause "Invalid regular expression" error
    const truncatedHighlight = highlight.map((phrase)=>phrase.substring(0, 255));
    const highlightRegExp = $0b92ef830f5aa8e4$export$1633667427d99697(truncatedHighlight.filter((phrase)=>phrase !== ''));
    const textWithoutAccents = $0b92ef830f5aa8e4$export$f3f2882e8b11d731(text);
    const textMatches = $0b92ef830f5aa8e4$export$c05c39859172f90c(text, highlightRegExp);
    const textWithoutAccentsMatches = $0b92ef830f5aa8e4$export$c05c39859172f90c(textWithoutAccents, highlightRegExp);
    const highlightMatches = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
        ...textWithoutAccentsMatches,
        ...textMatches
    ], 'index');
    let currentPosition = 0;
    highlightMatches.forEach((match)=>{
        const matchText = text.slice(match.index, match.index + match[0].length);
        const leading = text.slice(currentPosition, match.index);
        if (leading !== '') parts.push($0b92ef830f5aa8e4$export$2235873b95f89ea(leading));
        parts.push($0b92ef830f5aa8e4$export$39ae7d355c29b45f(matchText));
        currentPosition = match.index + matchText.length;
    });
    const trailing = text.slice(currentPosition);
    if (trailing !== '') parts.push($0b92ef830f5aa8e4$export$2235873b95f89ea(trailing));
    return parts;
};

});

parcelRegister("k2wwp", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e37bd657627b5db$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1H6kL = parcelRequire("1H6kL");

var $cM7El = parcelRequire("cM7El");
const $5e37bd657627b5db$var$HighlightTextWithParser = /*#__PURE__*/ (0, $5uXOq.memo)(({ text: text, highlight: highlight })=>{
    const parts = (0, $1H6kL.getParts)(highlight, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cM7El.default), {
        parts: parts
    });
});
var $5e37bd657627b5db$export$2e2bcd8739ae039 = $5e37bd657627b5db$var$HighlightTextWithParser;

});
parcelRegister("cM7El", function(module, exports) {

$parcel$export(module.exports, "default", () => $328475be93221885$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $e9H98 = parcelRequire("e9H98");
const $328475be93221885$var$HighlightText = ({ parts: parts })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, parts.map((part, i)=>{
        if (part.type === 'text') return part.content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e9H98.Mark), {
            key: i
        }, part.content);
    }));
var $328475be93221885$export$2e2bcd8739ae039 = $328475be93221885$var$HighlightText;

});
parcelRegister("e9H98", function(module, exports) {

$parcel$export(module.exports, "Mark", () => $ef706e6c8afab51f$export$c9d15bcfc6d42044);
/* styled.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ef706e6c8afab51f$export$c9d15bcfc6d42044 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "mark", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhkwtfv _syaz1fxt",
            __cmplp.className
        ])
    });
});

});




parcelRegister("g1YKS", function(module, exports) {

$parcel$export(module.exports, "default", () => $812fbcd4b3060f19$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $812fbcd4b3060f19$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "platform-card.common.ui.key.key.styled-link.aria-label",
        "defaultMessage": "{issueKey} is resolved"
    },
    labelIssueTermRefresh: {
        "id": "platform-card.common.ui.key.key.styled-link.aria-label-issue-term-refresh",
        "defaultMessage": "{issueKey} is resolved"
    }
});

});


parcelRegister("fsT6h", function(module, exports) {

$parcel$export(module.exports, "CardSpinner", () => $d9514f248a861844$export$cbd2bb5b02f5fd3a);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $2h3PP = parcelRequire("2h3PP");
const $d9514f248a861844$export$cbd2bb5b02f5fd3a = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const message = formatMessage((0, $2h3PP.default).loading);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9514f248a861844$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        label: message,
        size: "small"
    })));
};
var $d9514f248a861844$export$2e2bcd8739ae039 = $d9514f248a861844$export$cbd2bb5b02f5fd3a;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d9514f248a861844$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2h3PP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c63e872e5284154$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5c63e872e5284154$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loading: {
        "id": "card.common.spinner.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("1vEOb", function(module, exports) {

$parcel$export(module.exports, "CardSummary", () => $fc0aeaf09a85019e$export$f2e6e773bb9ca12a);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $dNOob = parcelRequire("dNOob");

var $gVhaI = parcelRequire("gVhaI");
const $fc0aeaf09a85019e$export$f2e6e773bb9ca12a = ({ text: text, highlight: highlight, shouldMenuRender: shouldMenuRender, shouldTruncate: shouldTruncate = false })=>{
    const HighlightedText = highlight && (0, $gVhaI.shouldHighlightText)(text, highlight) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gVhaI.HighlightText), {
        phrases: highlight,
        content: text
    }) : text;
    const summary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc0aeaf09a85019e$var$Summary, {
        shouldMenuRender: shouldMenuRender || false,
        shouldTruncate: shouldTruncate,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $dNOob.summary
    }, HighlightedText);
    if (!shouldTruncate) return summary;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: text,
        position: "bottom"
    }, summary);
};
$fc0aeaf09a85019e$export$f2e6e773bb9ca12a.defaultProps = {
    shouldMenuRender: false,
    highlight: []
};
var $fc0aeaf09a85019e$export$2e2bcd8739ae039 = $fc0aeaf09a85019e$export$f2e6e773bb9ca12a;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fc0aeaf09a85019e$var$Summary = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldMenuRender: shouldMenuRender, shouldTruncate: shouldTruncate, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_slp31hna _1i4q1hna _1nmz1hna",
            __cmplp.shouldMenuRender ? "_u5f3xy5q" : "_u5f3ze3t",
            __cmplp.shouldTruncate ? "_1yyj11wp" : "_1yyjn7od",
            __cmplp.shouldTruncate ? "_1e0ccj1k" : "_1e0c1nu9",
            __cmplp.shouldTruncate ? "_1reo15vq _18m915vq" : "_1reon7od _18m9n7od",
            __cmplp.shouldTruncate ? "_sudp1e54" : "_sudpn7od",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1NiGE", function(module, exports) {

$parcel$export(module.exports, "CardTick", () => $5f276ea5833a7960$export$711ec40e911e6898);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8uZt8 = parcelRequire("8uZt8");


var $9lrvF = parcelRequire("9lrvF");
const $5f276ea5833a7960$export$711ec40e911e6898 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const message = formatMessage((0, $9lrvF.default).done);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f276ea5833a7960$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8uZt8.default), {
        type: (0, $6d6eac2504286faf$export$540a31b23d6b9abd),
        label: message,
        primaryColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G400})`
    })));
};
var $5f276ea5833a7960$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $5f276ea5833a7960$export$711ec40e911e6898;
const $5f276ea5833a7960$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9lrvF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba0be14bc0b262f9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ba0be14bc0b262f9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    done: {
        "id": "card.common.tick.done",
        "defaultMessage": "Done"
    }
});

});


parcelRegister("1d3ex", function(module, exports) {

$parcel$export(module.exports, "CardType", () => $af4046f987350b01$export$f1a79bffad3377cd);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $gSExi = parcelRequire("gSExi");

var $f9Owr = parcelRequire("f9Owr");
const $af4046f987350b01$export$f1a79bffad3377cd = /*#__PURE__*/ (0, $5uXOq.memo)(({ text: text, uri: uri })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af4046f987350b01$var$Icon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af4046f987350b01$export$3e431a229df88919, {
        alt: text,
        src: uri
    })));
});
var $af4046f987350b01$export$2e2bcd8739ae039 = $af4046f987350b01$export$f1a79bffad3377cd;
const $af4046f987350b01$var$iconSize = (0, $gwIPs.gridSize) * 2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af4046f987350b01$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $af4046f987350b01$var$ImageControl = /*#__PURE__*/ (0, $47bDC.default).img.withConfig({
    componentId: "sc-1oveq8w-0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${$af4046f987350b01$var$iconSize}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${$af4046f987350b01$var$iconSize}px`,
    verticalAlign: 'text-bottom'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af4046f987350b01$var$ImageExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i7vkz _s7n41ndm",
            __cmplp.className
        ])
    });
});
const $af4046f987350b01$export$3e431a229df88919 = (0, $gSExi.styledComponentWithCondition)(()=>(0, $f9Owr.ff)('compiled.migration.jsw.tanuki'), $af4046f987350b01$var$ImageExperiment, $af4046f987350b01$var$ImageControl);

});

parcelRegister("4And4", function(module, exports) {

$parcel$export(module.exports, "default", () => $480bb196a9a74550$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $480bb196a9a74550$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    scenarioChangeTooltip: {
        "id": "platform-card.card.scenario-change-tooltip",
        "defaultMessage": "This change is only saved in your plan. Review this change, then save it in Jira."
    }
});

});


parcelRegister("7YpGJ", function(module, exports) {

$parcel$export(module.exports, "InteractionLayer", () => $badc2a28b0033d9a$export$4b508ff96d264be7);

var $5uXOq = parcelRequire("5uXOq");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $6HLFF = parcelRequire("6HLFF");
const $badc2a28b0033d9a$export$4b508ff96d264be7 = ({ onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur, cardRef: cardRef, cardKey: cardKey, summary: summary })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleClick = (e)=>onClick && onClick(e);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "platform-card.ui.card.focus-container",
        "aria-label": formatMessage((0, $6HLFF.default).interactionLayerLabel, {
            issueKey: cardKey ?? '',
            issueSummary: summary
        }),
        onClick: handleClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur,
        ref: cardRef,
        xcss: $badc2a28b0033d9a$var$interactionLayerStyles
    });
};
const $badc2a28b0033d9a$var$interactionLayerStyles = (0, $8CUq3.xcss)({
    all: 'unset',
    pointerEvents: 'auto',
    position: 'absolute',
    left: 'space.0',
    right: 'space.0',
    top: 'space.0',
    bottom: 'space.0',
    borderRadius: 'border.radius',
    ':focus': {
        outlineOffset: 'space.0'
    },
    ':focus-visible': {
        outlineOffset: 'space.0'
    },
    ':focus-within': {
        outlineOffset: 'space.0'
    }
});

});
parcelRegister("6HLFF", function(module, exports) {

$parcel$export(module.exports, "default", () => $de20ccba60efa5f1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $de20ccba60efa5f1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    interactionLayerLabel: {
        "id": "platform-card.card.interaction-layer-label",
        "defaultMessage": "{issueKey} {issueSummary}. Use the enter key to load the issue view."
    }
});

});



const $d9cdb1c71f9dbf8c$export$b9e05b29ae05bdd9 = 32;
const $d9cdb1c71f9dbf8c$export$dce8cd449abd1f77 = 5;
const $d9cdb1c71f9dbf8c$export$1ec3328eed0aedd9 = 300;
const $d9cdb1c71f9dbf8c$export$6b4c950ad6cadf50 = 200;
const $d9cdb1c71f9dbf8c$export$bb89c9064245f005 = 500;
const $d9cdb1c71f9dbf8c$export$f4f3847a7eaec9e9 = 'software-context-menu.ui.context-menu-inner.context-menu-inner-container';
const $d9cdb1c71f9dbf8c$export$b3f11e5d123cdbe9 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-item.context-menu-submenu';
const $d9cdb1c71f9dbf8c$export$ef86d72244e00c00 = 'software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.chevron-icon';
const $d9cdb1c71f9dbf8c$export$8e765acf3440e0b = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-item.context-menu-item';
const $d9cdb1c71f9dbf8c$export$75f77b2251314894 = 'software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.overflow-visible-popup-container';
const $d9cdb1c71f9dbf8c$export$602eb83148423ac6 = 'software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.tooltip';
const $d9cdb1c71f9dbf8c$export$ae734f89618d3c5f = 'software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.context-menu-label';
const $d9cdb1c71f9dbf8c$export$90350df905144507 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-search';
const $d9cdb1c71f9dbf8c$export$328d05d650390cfd = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-search.content';
const $d9cdb1c71f9dbf8c$export$1245780b529c0d82 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-search.loading';
const $d9cdb1c71f9dbf8c$export$803f51dcf576f554 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-search.no-results';
const $d9cdb1c71f9dbf8c$export$bb79bd28759ee895 = 'context';
const $d9cdb1c71f9dbf8c$export$ee5015c6ad52cf0b = 'meatball';

parcelRegister("gjUWL", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ed3e610183061c2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8ed3e610183061c2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    actionsMenuTriggerLabel: {
        "id": "platform-board-kit.card.jira-card-contents.actions-menu-trigger-label",
        "defaultMessage": "issue actions, { summary }"
    },
    storyPointsUnitsLabel: {
        "id": "platform-board-kit.card.jira-card-contents.story-points-units-label",
        "defaultMessage": "story points"
    },
    storyPointsUnitsPluralisedLabel: {
        "id": "platform-board-kit.card.jira-card-contents.story-points-units-pluralised-label",
        "defaultMessage": "{value, plural, one {# story point} other {# story points}}"
    },
    actionsMenuTriggerLabelIssueTermRefresh: {
        "id": "platform-board-kit.card.jira-card-contents.actions-menu-trigger-label-issue-term-refresh",
        "defaultMessage": "issue actions, { summary }"
    }
});

});


parcelRegister("3Lg0k", function(module, exports) {

$parcel$export(module.exports, "default", () => $d474a688d3cc6a5a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $645AZ = parcelRequire("645AZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d474a688d3cc6a5a$export$2e2bcd8739ae039 = ({ onAnimationEnd: onAnimationEnd, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d474a688d3cc6a5a$var$RippleContainer, {
        onAnimationEnd: onAnimationEnd
    }, children);
const $d474a688d3cc6a5a$var$RippleAnimation = /*#__PURE__*/ (0, $47bDC.keyframes)({
    from: {
        boxShadow: '0 0 0 0 #14892c'
    },
    to: {
        boxShadow: '0 0 0 15px rgba(0, 0, 0, 0)'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d474a688d3cc6a5a$var$RippleContainer = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "p2za2h-0"
})({
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $645AZ.zIndex).cardDoneRipple ? (0, $645AZ.zIndex).cardDoneRipple : 'auto',
    borderRadius: '3px',
    animationName: $d474a688d3cc6a5a$var$RippleAnimation,
    animationDuration: '1.45s',
    animationIterationCount: 1,
    animationTimingFunction: 'cubic-bezier(0.14, 1.17, 0.95, 0.99)'
});

});

parcelRegister("gRpCe", function(module, exports) {

$parcel$export(module.exports, "useDraggableCard", () => $0a4eba09c94c83c9$export$ee9f6369c1b523a9);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $7nsd3 = parcelRequire("7nsd3");

var $hGgHi = parcelRequire("hGgHi");

var $biEfA = parcelRequire("biEfA");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");
parcelRequire("2Uxmu");
var $hJNa8 = parcelRequire("hJNa8");
parcelRequire("erBEN");
var $kpXwZ = parcelRequire("kpXwZ");

var $1fZVH = parcelRequire("1fZVH");

var $7D59a = parcelRequire("7D59a");

const $0a4eba09c94c83c9$var$MAX_CARD_WIDTH = 270;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a4eba09c94c83c9$var$CardDragPreviewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $lD23V.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1bsb1hdq",
            __cmplp.className
        ])
    });
});
const $0a4eba09c94c83c9$var$defaultIsDroppable = ()=>true;
const $0a4eba09c94c83c9$export$ee9f6369c1b523a9 = ({ isDraggable: isDraggable, elementRef: elementRef, cardId: cardId, cardIndex: cardIndex, columnId: columnId, swimlaneId: swimlaneId, CardPreview: CardPreview, shouldShowRipple: shouldShowRipple, isDroppable: isDroppable = $0a4eba09c94c83c9$var$defaultIsDroppable })=>{
    const autobatch = (0, $1fZVH.useAutobatch)();
    const [dragState, setDragState] = (0, $5uXOq.useState)({
        type: 'idle'
    });
    const batchSetDragState = (0, $5uXOq.useCallback)((state)=>autobatch(()=>setDragState(state)), [
        autobatch
    ]);
    const [closestEdge, setClosestEdge] = (0, $5uXOq.useState)(null);
    const batchSetClosestEdge = (0, $5uXOq.useCallback)((edge)=>autobatch(()=>setClosestEdge(edge)), [
        autobatch
    ]);
    const [cardWidth, setCardWidth] = (0, $5uXOq.useState)($0a4eba09c94c83c9$var$MAX_CARD_WIDTH);
    const batchSetCardWidth = (0, $5uXOq.useCallback)((width)=>autobatch(()=>setCardWidth(width)), [
        autobatch
    ]);
    const isDroppableStable = (0, $7D59a.useEvent)(isDroppable);
    (0, $5uXOq.useEffect)(()=>{
        if (!isDraggable || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(cardIndex) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(columnId) || !elementRef.current) return undefined;
        return (0, $4hDdm.combine)((0, $7gWdR.draggable)({
            element: elementRef.current,
            getInitialData: ()=>({
                    type: (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c),
                    cardId: cardId,
                    cardIndex: cardIndex,
                    columnId: columnId,
                    swimlaneId: swimlaneId
                }),
            onDrop: ()=>batchSetDragState({
                    type: 'idle'
                }),
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                const previewWidth = elementRef.current?.offsetWidth;
                if (previewWidth && previewWidth < $0a4eba09c94c83c9$var$MAX_CARD_WIDTH) batchSetCardWidth(previewWidth);
                (0, $kpXwZ.setCustomNativeDragPreview)({
                    getOffset: (0, $hJNa8.pointerOutsideOfPreview)({
                        x: '8px',
                        y: '8px'
                    }),
                    render ({ container: container }) {
                        batchSetDragState({
                            type: 'dragging',
                            container: container
                        });
                        return ()=>batchSetDragState({
                                type: 'idle'
                            });
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            canDrag: ()=>{
                if (typeof cardId === 'number') return cardId > 0;
                return !!cardId;
            }
        }), (0, $7gWdR.dropTargetForElements)({
            element: elementRef.current,
            getIsSticky: ()=>true,
            getData: ({ input: input, element: element })=>(0, $biEfA.attachClosestEdge)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    type: (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c),
                    cardId: cardId,
                    cardIndex: cardIndex,
                    columnId: columnId,
                    swimlaneId: swimlaneId
                }, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                }),
            canDrop: (args)=>{
                // If card is in optimistic state
                if (typeof cardId === 'number' && cardId < 0) return false;
                if (args.source.data.type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c)) return isDroppableStable(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                args.source.data, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    type: (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c),
                    cardId: cardId,
                    cardIndex: cardIndex,
                    columnId: columnId,
                    swimlaneId: swimlaneId
                }) ?? true;
                return false;
            },
            onDrag: ({ source: { data: data }, self: self })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                if (data.cardId !== cardId) batchSetClosestEdge((0, $biEfA.extractClosestEdge)(self.data));
            },
            onDragEnter: ({ source: { data: data }, self: self })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                if (data.cardId !== cardId) batchSetClosestEdge((0, $biEfA.extractClosestEdge)(self.data));
            },
            onDragLeave: ()=>batchSetClosestEdge(null),
            onDrop: ()=>batchSetClosestEdge(null)
        }));
    }, [
        cardId,
        cardIndex,
        closestEdge,
        columnId,
        elementRef,
        isDraggable,
        swimlaneId,
        shouldShowRipple,
        isDroppableStable,
        batchSetDragState,
        batchSetClosestEdge,
        batchSetCardWidth
    ]);
    return {
        dragPreview: dragState.type === 'dragging' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a4eba09c94c83c9$var$CardDragPreviewContainer, {
            width: cardWidth
        }, CardPreview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CardPreview, {
            cardId: cardId
        }) : null), dragState.container) : null,
        closestEdge: closestEdge
    };
};

});
parcelRegister("2Uxmu", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("hJNa8")).pointerOutsideOfPreview);

var $hJNa8 = parcelRequire("hJNa8");

});
parcelRegister("hJNa8", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => $4030604dbfde028c$export$427e20518819fabc);
function $4030604dbfde028c$export$427e20518819fabc(point) {
    return ({ container: container })=>{
        // Only reliable cross browser technique found to push a
        // drag preview away from the cursor is to use transparent borders on the container
        Object.assign(container.style, {
            borderLeft: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        return {
            x: 0,
            y: 0
        };
    };
}

});




const $e9be48d6d2c01760$export$e18419056f3d184a = 'assignee';
const $e9be48d6d2c01760$export$45cafdfd629c3ca1 = 'reporter';
const $e9be48d6d2c01760$export$d5bc879e3b748593 = 'description';
const $e9be48d6d2c01760$export$a68dbc90211df1a8 = 'fixVersions';
const $e9be48d6d2c01760$export$93605f2a09aa8d26 = 'labels';
const $e9be48d6d2c01760$export$4420b7468f889692 = 'status';
const $e9be48d6d2c01760$export$e7cf1830fe735d1f = 'summary';
const $e9be48d6d2c01760$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $e9be48d6d2c01760$export$a5fc282ab2bf9b89 = 'issuelinks';
const $e9be48d6d2c01760$export$b52547457d714bc0 = 'epic-issues';
const $e9be48d6d2c01760$export$3cca6e37a5823d5a = 'children-issues';
const $e9be48d6d2c01760$export$98a935eb30de54ab = 'components';

parcelRegister("lu5k0", function(module, exports) {

$parcel$export(module.exports, "useModalDialogActions", () => $5f429bdcb9dbbc95$export$3cf2e4b6d3541465);
$parcel$export(module.exports, "useReturnFocusTo", () => $5f429bdcb9dbbc95$export$217308a4ece853b2);

var $7JoAD = parcelRequire("7JoAD");

var $49R2H = parcelRequire("49R2H");

var $a3Qjd = parcelRequire("a3Qjd");

var $kIxMH = parcelRequire("kIxMH");
const $5f429bdcb9dbbc95$var$Store = (0, $7JoAD.createStore)({
    name: 'JiraSoftwareModalDialog',
    initialState: $49R2H.initialState,
    actions: $a3Qjd.actions
});
const $5f429bdcb9dbbc95$export$3cf2e4b6d3541465 = (0, $7JoAD.createActionsHook)($5f429bdcb9dbbc95$var$Store);
const $5f429bdcb9dbbc95$export$217308a4ece853b2 = (0, $7JoAD.createStateHook)($5f429bdcb9dbbc95$var$Store, {
    selector: (0, $kIxMH.getReturnFocusTo)
});

});
parcelRegister("49R2H", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $1a3a816977643252$export$d4c72bab9d6cc13a);
const $1a3a816977643252$export$d4c72bab9d6cc13a = {
    returnFocusTo: null
};

});

parcelRegister("a3Qjd", function(module, exports) {

$parcel$export(module.exports, "actions", () => $1886bc9c17d47b9b$export$e324594224ef24da);
const $1886bc9c17d47b9b$export$b263d1e638b131c2 = (returnFocusTo)=>({ setState: setState })=>{
        setState({
            returnFocusTo: returnFocusTo
        });
    };
const $1886bc9c17d47b9b$export$e324594224ef24da = {
    setReturnFocusTo: $1886bc9c17d47b9b$export$b263d1e638b131c2
};

});

parcelRegister("kIxMH", function(module, exports) {

$parcel$export(module.exports, "getReturnFocusTo", () => $cd4eb273a1fc9e15$export$d5f8692765ccd209);
const $cd4eb273a1fc9e15$export$d5f8692765ccd209 = (state)=>state.returnFocusTo;

});


parcelRegister("5GDqD", function(module, exports) {

$parcel$export(module.exports, "useTraitsActions", () => $5e4cf08f88a8a143$export$87f1d888def9d5a0);
$parcel$export(module.exports, "createTraitsSelector", () => $5e4cf08f88a8a143$export$fb8309e220d0dd3b);
$parcel$export(module.exports, "composeTraitsSelectors", () => $5e4cf08f88a8a143$export$e653f602b87eec56);

var $eusud = parcelRequire("eusud");

var $7JoAD = parcelRequire("7JoAD");

var $13UaH = parcelRequire("13UaH");

var $2LwjF = parcelRequire("2LwjF");
const $5e4cf08f88a8a143$var$addTrait = (traitType, trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        const state = currentUserTraits[traitType];
        if (!state.attributes) {
            setState({
                ...currentUserTraits,
                [traitType]: {
                    attributes: [
                        trait
                    ]
                }
            });
            return;
        }
        if (state.attributes.some((existingTrait)=>existingTrait.name === trait.name)) setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: state.attributes.map((existingTrait)=>existingTrait.name === trait.name ? trait : existingTrait)
            }
        });
        else setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: [
                    ...state.attributes,
                    trait
                ]
            }
        });
    };
const $5e4cf08f88a8a143$var$fetchTraits = (traitTypes, { cloudId: cloudId, accountId: accountId, orgId: orgId })=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        await Promise.all(traitTypes.map(async (traitType)=>{
            if (state[traitType].attributes === null || state[traitType].attributes?.length || state[traitType].loading) return;
            setState({
                ...state,
                [traitType]: {
                    ...state[traitType],
                    loading: true
                }
            });
            const traitEndpointEndingFragment = (0, $2LwjF.buildTraitEndpointEndingFragment)({
                traitType: traitType,
                accountId: accountId,
                cloudId: cloudId,
                orgId: orgId
            });
            if (!traitEndpointEndingFragment) return;
            const url = (0, $13UaH.TRAIT_ENDPOINT_STARTING_FRAGMENT) + traitEndpointEndingFragment;
            try {
                const fetchedTraits = await (0, $eusud.performGetRequest)(url);
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: fetchedTraits?.attributes?.length ? fetchedTraits.attributes : null,
                        loading: false
                    }
                });
            } catch  {
            // noop
            }
        }));
    };
const $5e4cf08f88a8a143$var$actions = {
    fetchTraits: $5e4cf08f88a8a143$var$fetchTraits,
    addTrait: $5e4cf08f88a8a143$var$addTrait
};
const $5e4cf08f88a8a143$var$initialState = {
    ATLASSIAN_ACCOUNT: {
        attributes: [],
        loading: false
    },
    SITE: {
        attributes: [],
        loading: false
    },
    SITE_USER: {
        attributes: [],
        loading: false
    },
    ORG: {
        attributes: [],
        loading: false
    },
    ORG_USER: {
        attributes: [],
        loading: false
    }
};
const $5e4cf08f88a8a143$export$5b11e13f463f4eb = (0, $7JoAD.createStore)({
    initialState: $5e4cf08f88a8a143$var$initialState,
    actions: $5e4cf08f88a8a143$var$actions,
    name: 'TraitsStore'
});
const $5e4cf08f88a8a143$export$243330301a7ccf01 = (0, $7JoAD.createHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb);
const $5e4cf08f88a8a143$export$87f1d888def9d5a0 = (0, $7JoAD.createActionsHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb);
const $5e4cf08f88a8a143$var$defaultSelector = (traitsType, selector)=>(0, $7JoAD.createSelector)((state)=>({
            attributes: state[traitsType]?.attributes,
            userCreatedAfter: (date)=>state[traitsType].attributes ? (0, $2LwjF.userCreatedAfter)(state, date) : null,
            getTraitByName: (name)=>state[traitsType].attributes ? (0, $2LwjF.getTraitByName)(state, name) : null
        }), selector);
const $5e4cf08f88a8a143$export$fb8309e220d0dd3b = (traitsType, selector)=>(0, $7JoAD.createHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb, {
        selector: $5e4cf08f88a8a143$var$defaultSelector(traitsType, selector)
    });
const $5e4cf08f88a8a143$export$e653f602b87eec56 = (traitTypes, hooks)=>({
        traitTypes: traitTypes,
        hooks: hooks
    });

});
parcelRegister("13UaH", function(module, exports) {

$parcel$export(module.exports, "ATLASSIAN_ACCOUNT", () => $c8223610b88d815b$export$eac8289d83d13c9e);
$parcel$export(module.exports, "SITE", () => $c8223610b88d815b$export$1f4740cb59ea887e);
$parcel$export(module.exports, "SITE_USER", () => $c8223610b88d815b$export$2b629adc0b711448);
$parcel$export(module.exports, "ORG", () => $c8223610b88d815b$export$c7bc89c720838974);
$parcel$export(module.exports, "ORG_USER", () => $c8223610b88d815b$export$872e93425a929c06);
$parcel$export(module.exports, "TRAIT_ENDPOINT_STARTING_FRAGMENT", () => $c8223610b88d815b$export$ff5c5bd50c21e9a4);
const $c8223610b88d815b$export$eac8289d83d13c9e = 'ATLASSIAN_ACCOUNT';
const $c8223610b88d815b$export$1f4740cb59ea887e = 'SITE';
const $c8223610b88d815b$export$2b629adc0b711448 = 'SITE_USER';
const $c8223610b88d815b$export$c7bc89c720838974 = 'ORG';
const $c8223610b88d815b$export$872e93425a929c06 = 'ORG_USER';
const $c8223610b88d815b$export$ff5c5bd50c21e9a4 = '/gateway/api/tap-delivery/api/v3/personalization/';
const $c8223610b88d815b$export$ab3e7784d2a104d4 = [
    $c8223610b88d815b$export$eac8289d83d13c9e,
    $c8223610b88d815b$export$1f4740cb59ea887e,
    $c8223610b88d815b$export$2b629adc0b711448,
    $c8223610b88d815b$export$c7bc89c720838974,
    $c8223610b88d815b$export$872e93425a929c06
];

});

parcelRegister("2LwjF", function(module, exports) {

$parcel$export(module.exports, "buildTraitEndpointEndingFragment", () => $a4882989c0079311$export$118c30eb4b4c51e8);
$parcel$export(module.exports, "getTraitByName", () => $a4882989c0079311$export$e5b0d140cf11f46a);
$parcel$export(module.exports, "userCreatedAfter", () => $a4882989c0079311$export$8388eb33623a9cff);

var $13UaH = parcelRequire("13UaH");
const $a4882989c0079311$export$e320a062b20fddc3 = (traitsData)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(traitsData).reduce((acc, [, val])=>{
        if (val?.attributes) acc.push(...val.attributes.map((singleTrait)=>singleTrait));
        return acc;
    }, []);
const $a4882989c0079311$export$118c30eb4b4c51e8 = ({ traitType: traitType, accountId: accountId, cloudId: cloudId, orgId: orgId })=>{
    switch(traitType){
        case 0, $13UaH.ATLASSIAN_ACCOUNT:
            return `user/${accountId}`;
        case 0, $13UaH.SITE:
            return `site/${cloudId}`;
        case 0, $13UaH.SITE_USER:
            return `site/${cloudId}/user/${accountId}`;
        case 0, $13UaH.ORG:
            return `org/${orgId}`;
        case 0, $13UaH.ORG_USER:
            return `org/${orgId}/user/${accountId}`;
        default:
            return null;
    }
};
function $a4882989c0079311$export$e5b0d140cf11f46a(traitsData, traitName) {
    return $a4882989c0079311$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName) ?? null;
}
const $a4882989c0079311$export$d2a3b2f9735b6874 = (traitsData, traitNames)=>$a4882989c0079311$export$e320a062b20fddc3(traitsData)?.filter((trait)=>traitNames.includes(trait.name));
const $a4882989c0079311$export$8388eb33623a9cff = (traitsData, date)=>{
    const accountCreationDate = $a4882989c0079311$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) > date;
};

});


parcelRegister("4kv6l", function(module, exports) {

$parcel$export(module.exports, "getDateFormat", () => $6f2828a68ab85a09$export$fa96065c64444af6);

var $iFXjF = parcelRequire("iFXjF");
var $2753q = parcelRequire("2753q");
const $6f2828a68ab85a09$var$DATE_FORMAT_CURRENT_YEAR = 'dd MMM';
const $6f2828a68ab85a09$var$DATE_FORMAT_NOT_CURRENT_YEAR = 'dd MMM yyyy';
const $6f2828a68ab85a09$export$fa96065c64444af6 = (dueDate)=>{
    const currentYear = (0, $iFXjF.default)(new Date());
    const parsedDateDueDateString = (0, $2753q.default)(dueDate, 'yyyy-mm-dd', new Date());
    const dueDateYear = (0, $iFXjF.default)(parsedDateDueDateString);
    return dueDateYear === currentYear ? $6f2828a68ab85a09$var$DATE_FORMAT_CURRENT_YEAR : $6f2828a68ab85a09$var$DATE_FORMAT_NOT_CURRENT_YEAR;
};

});

parcelRegister("7mkyN", function(module, exports) {

$parcel$export(module.exports, "PlanModalEntrypointContext", () => $cd73bf853ceccf39$export$226c547af23d8b2b);

var $l37qh = parcelRequire("l37qh");
const $cd73bf853ceccf39$export$226c547af23d8b2b = (0, $l37qh.createUseEntryPointContext)();

});
parcelRegister("l37qh", function(module, exports) {

$parcel$export(module.exports, "createUseEntryPointContext", () => $6e7e19c2d291c94c$export$41bce2223126846b);

var $5uXOq = parcelRequire("5uXOq");
const $6e7e19c2d291c94c$export$41bce2223126846b = ()=>/*#__PURE__*/ (0, $5uXOq.createContext)({
        entryPointActions: {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            cancelPreload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            load () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            preload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unload () {}
        },
        entryPointReferenceSubject: {
            getValue: ()=>null,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            subscribe: ()=>()=>{}
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stopMetric () {}
    });

});


parcelRegister("5wBpE", function(module, exports) {

$parcel$export(module.exports, "AssigneeField", () => $2e790c3544e64069$export$7c52097ee36bd91);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hepPB = parcelRequire("hepPB");

var $2eMTS = parcelRequire("2eMTS");

var $54wEF = parcelRequire("54wEF");

var $lfTZh = parcelRequire("lfTZh");

var $5fc53 = parcelRequire("5fc53");

var $iXVV6 = parcelRequire("iXVV6");

var $l8ruj = parcelRequire("l8ruj");

var $33c4b = parcelRequire("33c4b");

var $eGVUJ = parcelRequire("eGVUJ");


var $67sX6 = parcelRequire("67sX6");

var $2f454 = parcelRequire("2f454");

var $k8auG = parcelRequire("k8auG");

var $5mTgl = parcelRequire("5mTgl");

var $2yqcU = parcelRequire("2yqcU");

const $2e790c3544e64069$var$stopClickPropagation = (e)=>{
    e.stopPropagation();
};
const $2e790c3544e64069$var$fieldKey = 'assignee';
const $2e790c3544e64069$var$AssigneeFieldInner = ({ issueKey: issueKey, onSubmit: onSubmit, onUpdate: onUpdate, onFailure: onFailure, onOpen: onOpen, onClose: onClose })=>{
    const preventInlineEditing = (0, $67sX6.useBoardSelector)((state)=>(0, $k8auG.getPreventInlineEditing)(state));
    const shouldApplyInviteAndAssign = (0, $hepPB.useShouldApplyInviteAndAssign)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isInlineEditing: true,
            fieldKey: $2e790c3544e64069$var$fieldKey,
            fieldType: 'userpicker'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e790c3544e64069$var$AssigneeFieldWrapper, {
        role: "button",
        onClick: $2e790c3544e64069$var$stopClickPropagation,
        onKeyDown: $2e790c3544e64069$var$stopClickPropagation,
        "data-testid": (0, $60f83ce4791d4554$export$eb4bdbeb6f6a0217),
        disableClick: preventInlineEditing
    }, shouldApplyInviteAndAssign ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2yqcU.AsyncLazyIssueAssigneeFieldWithInviteAssign), {
        actionSubject: "inlineEdit",
        issueKey: issueKey,
        shouldPreloadAssignToMe: true,
        popupPlacement: "bottom-end",
        onSubmit: onSubmit,
        onUpdate: onUpdate,
        onFailure: onFailure,
        onOpen: onOpen,
        onClose: onClose
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2eMTS.AsyncLazyIssueAssigneeField), {
        actionSubject: "inlineEdit",
        issueKey: issueKey,
        shouldPreloadAssignToMe: true,
        popupPlacement: "bottom-end",
        onSubmit: onSubmit,
        onUpdate: onUpdate,
        onFailure: onFailure,
        onOpen: onOpen,
        onClose: onClose
    })));
};
const $2e790c3544e64069$export$7c52097ee36bd91 = ({ shouldRenderRichField: shouldRenderRichField, assignee: assignee, isCMPBoard: isCMPBoard, issueKey: issueKey, ...props })=>{
    const activeIssueKey = (0, $67sX6.useBoardSelector)((0, $5mTgl.getActiveIssueKey));
    const [{ value: assigneeFieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, (0, $5fc53.ASSIGNEE_TYPE), {
        skipRefresh: !isCMPBoard || activeIssueKey !== issueKey
    });
    const shouldRenderRich = Boolean(shouldRenderRichField && assigneeFieldConfig);
    const editableField = (0, $eGVUJ.useEditableField)({
        isExperienceAvailable: shouldRenderRich
    });
    const fallback = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $33c4b.AssigneeFieldStatic), {
            value: assignee
        }), [
        assignee
    ]);
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $2f454.setInlineEditing)('assignee', props.issueId, true));
    }, [
        dispatch,
        props.issueId
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $2f454.setInlineEditing)('assignee', props.issueId, false));
    }, [
        dispatch,
        props.issueId
    ]);
    if (shouldRenderRich) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2eMTS.IssueAssigneeFieldBoundary), {
        packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
        fallback: fallback,
        onError: editableField.onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "ng-board.inline-edit.assignee-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "assignee-field-inner",
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e790c3544e64069$var$AssigneeFieldInner, {
        ...props,
        ...editableField,
        issueKey: issueKey,
        onOpen: onOpen,
        onClose: onClose
    }))));
    return fallback;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2e790c3544e64069$var$AssigneeFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { disableClick: disableClick, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_80omtlke _1gp47079 _1di411wp",
            __cmplp.disableClick && "_lcxvglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hepPB", function(module, exports) {

$parcel$export(module.exports, "useShouldApplyInviteAndAssign", () => $22f2f1b13e03abbe$export$dd717a0a6d95d97d);

var $2vSU6 = parcelRequire("2vSU6");

var $dAfqg = parcelRequire("dAfqg");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");
const $22f2f1b13e03abbe$export$dd717a0a6d95d97d = ()=>{
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const { software: software } = (0, $k9JTq.useAppEditions)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isJSW = project?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const isTMP = !!project?.simplified;
    const isFreeInstance = software === (0, $ldyPw.FREE_EDITION);
    return isJSW && isFreeInstance && isTMP && isSiteAdmin;
};

});

parcelRegister("2eMTS", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyIssueAssigneeField", () => $40ac4b7314747a71$export$3eed76542de607d2);
$parcel$export(module.exports, "AsyncIssueAssigneeField", () => $40ac4b7314747a71$export$5cdab73b9e0803a1);
$parcel$export(module.exports, "IssueAssigneeFieldBoundary", () => $40ac4b7314747a71$export$9b541007f4ef3ffe);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $fE0Ry = parcelRequire("fE0Ry");

const $40ac4b7314747a71$export$3eed76542de607d2 = (0, $kxZPA.lazy)(()=>(parcelRequire("bMprb")), {
    moduleId: "./src/packages/issue/fields/assignee/src/ui/popover/index.tsx"
});
const $40ac4b7314747a71$export$5cdab73b9e0803a1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "issue-field-assignee",
        packageName: "jira-issue-field-assignee",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fE0Ry.AssigneePickerView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-assignee-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fE0Ry.AssigneePickerView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40ac4b7314747a71$export$3eed76542de607d2, props)));
const $40ac4b7314747a71$export$9b541007f4ef3ffe = ({ children: children, fallback: fallback, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "issue-assignee-field",
        packageName: packageName,
        fallback: fallback ? ()=>fallback : undefined,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-assignee-field-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("fE0Ry", function(module, exports) {

$parcel$export(module.exports, "AssigneePickerView", () => $7dd7529f3295a136$export$7df43f1214c1ab94);
$parcel$export(module.exports, "AvatarWrapper", () => $7dd7529f3295a136$export$f7513421c53ce141);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lLtod = parcelRequire("lLtod");

var $3bDjY = parcelRequire("3bDjY");

var $aWse0 = parcelRequire("aWse0");


var $fhSLy = parcelRequire("fhSLy");

var $evUrF = parcelRequire("evUrF");
const $7dd7529f3295a136$export$7df43f1214c1ab94 = ({ value: value })=>{
    const intl = (0, $aWse0.useIntlV2)();
    const unassigned = (0, $fhSLy.getUnassignedUser)(intl);
    const user = value || unassigned;
    const assigneeName = user.accountId === (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463) ? user.displayName : intl.formatMessage((0, $evUrF.default).assigneeTooltip, {
        name: user.displayName
    });
    const avatarUrl = (0, $fhSLy.getUserAvatarUrl)(user);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7dd7529f3295a136$export$f7513421c53ce141, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: assigneeName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLtod.default), {
        testId: "issue-field-assignee.common.ui.read-view.popover.avatar",
        size: "small",
        src: avatarUrl,
        name: assigneeName,
        borderColor: "transparent"
    })));
};
var $7dd7529f3295a136$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $7dd7529f3295a136$export$7df43f1214c1ab94;
const $7dd7529f3295a136$export$f7513421c53ce141 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1f4h _4t3i1f4h _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _80om73ad",
            __cmplp.className
        ])
    });
});

});
const $c1e3a0a8493b8e86$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $c1e3a0a8493b8e86$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $c1e3a0a8493b8e86$export$f5d5f6bb902f1027 = '-1';

parcelRegister("fhSLy", function(module, exports) {

$parcel$export(module.exports, "getUnassignedUser", () => $bdabf260f25df73f$export$42c5a0b65ef9ee80);
$parcel$export(module.exports, "getAutomaticUserOption", () => $bdabf260f25df73f$export$8d7a63500893c8c);
$parcel$export(module.exports, "getInvitePeopleOption", () => $bdabf260f25df73f$export$84a82764cf0a696e);
$parcel$export(module.exports, "getUserOptionFromUser", () => $bdabf260f25df73f$export$16086438354dcc85);
$parcel$export(module.exports, "getUserFromUserOption", () => $bdabf260f25df73f$export$78a8bcc5bd21caa2);
$parcel$export(module.exports, "getUserAvatarUrl", () => $bdabf260f25df73f$export$7d801d84202c7743);
$parcel$export(module.exports, "getUserShape", () => $bdabf260f25df73f$export$322b6ab8c29a006e);

var $7lGt2 = parcelRequire("7lGt2");

var $12ZsE = parcelRequire("12ZsE");

const $bdabf260f25df73f$export$42c5a0b65ef9ee80 = ({ formatMessage: formatMessage })=>({
        accountId: (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463),
        displayName: formatMessage((0, $7lGt2.default).unassignedOption),
        avatarUrls: {}
    });
const $bdabf260f25df73f$export$8d7a63500893c8c = ({ formatMessage: formatMessage })=>({
        accountId: (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027),
        displayName: formatMessage((0, $7lGt2.default).automaticOption),
        avatarUrls: {}
    });
const $bdabf260f25df73f$export$84a82764cf0a696e = ({ formatMessage: formatMessage }, isAdmin)=>({
        accountId: (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7),
        displayName: formatMessage(isAdmin ? (0, $7lGt2.default).invitePeopleOptionAdmin : (0, $7lGt2.default).invitePeopleOption),
        avatarUrls: {
            '48x48': (0, (/*@__PURE__*/$parcel$interopDefault($12ZsE)))
        }
    });
const $bdabf260f25df73f$export$16086438354dcc85 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls, emailAddress: emailAddress })=>({
        id: accountId || '',
        name: displayName,
        avatarUrl: avatarUrls['48x48'],
        // @ts-expect-error Will be part of JIV-13488; `user.emailAddress` returned by the REST API can be null depending on their privacy settings
        byline: emailAddress
    });
const $bdabf260f25df73f$export$78a8bcc5bd21caa2 = ({ id: id, name: name, avatarUrl: avatarUrl })=>({
        accountId: id,
        displayName: name,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });
const $bdabf260f25df73f$export$7d801d84202c7743 = ({ avatarUrls: avatarUrls })=>avatarUrls['48x48'];
const $bdabf260f25df73f$export$322b6ab8c29a006e = (accountId, displayName, avatarUrl)=>({
        accountId: accountId,
        displayName: displayName,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });

});
parcelRegister("7lGt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2aaed3328149e1d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e2aaed3328149e1d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    automaticOption: {
        "id": "issue-field-assignee.automatic-option",
        "defaultMessage": "Automatic"
    },
    assignToMe: {
        "id": "issue-field-assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    searchForAssignee: {
        "id": "issue-field-assignee.search-for-assignee",
        "defaultMessage": "Search for assignee"
    },
    invitePeopleOption: {
        "id": "issue-field-assignee.invite-people-option",
        "defaultMessage": "Add teammate to Jira"
    },
    invitePeopleOptionAdmin: {
        "id": "issue-field-assignee.invite-people-option-admin",
        "defaultMessage": "Invite teammate to Jira"
    }
});

});

parcelRegister("12ZsE", function(module, exports) {
module.exports = new URL("add.6dea82c4.png", import.meta.url).toString();

});


parcelRegister("evUrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $027660e13143d610$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $027660e13143d610$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    assigneeTooltip: {
        "id": "issue-field-assignee.common.read-view.popover.assignee-tooltip",
        "defaultMessage": "Assignee: {name}"
    }
});

});


parcelRegister("bMprb", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("amJuG")
]).then(()=>parcelRequire('278RC'));

});


parcelRegister("33c4b", function(module, exports) {

$parcel$export(module.exports, "AssigneeFieldStatic", () => $6457a47baf887e46$export$20dedc39b82b5168);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lLtod = parcelRequire("lLtod");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $5ovlb = parcelRequire("5ovlb");
const $6457a47baf887e46$export$20dedc39b82b5168 = ({ value: value })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const name = (0, $5uXOq.useMemo)(()=>value?.id ? formatMessage((0, $5ovlb.default).assigneeTooltip, {
            name: value.displayName
        }) : formatMessage((0, $5ovlb.default).assigneeTooltipUnassigned), [
        value,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6457a47baf887e46$var$AvatarWrapper, {
        "data-testid": "software-board.common.fields.assignee-field-static.avatar-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLtod.default), {
        src: value?.avatarUrl,
        name: name,
        size: "small",
        borderColor: "transparent"
    })));
};
var $6457a47baf887e46$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($6457a47baf887e46$export$20dedc39b82b5168);
const $6457a47baf887e46$var$AvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1f4h _80om73ad",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5ovlb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7591000e305eadbb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7591000e305eadbb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    assigneeTooltip: {
        "id": "software.main.common.fields.assignee-field-static.assignee-tooltip",
        "defaultMessage": "Assignee: {name}"
    },
    assigneeTooltipUnassigned: {
        "id": "software.main.common.fields.assignee-field-static.assignee-tooltip-unassigned",
        "defaultMessage": "Unassigned"
    }
});

});


parcelRegister("eGVUJ", function(module, exports) {

$parcel$export(module.exports, "useEditableField", () => $28a21524984548e7$export$1e71fae6ea31d88a);

var $5uXOq = parcelRequire("5uXOq");

var $67sX6 = parcelRequire("67sX6");

var $fNyAs = parcelRequire("fNyAs");

var $3F1Hq = parcelRequire("3F1Hq");
function $28a21524984548e7$export$1e71fae6ea31d88a({ isExperienceAvailable: isExperienceAvailable }) {
    const [experience] = (0, $5uXOq.useState)((0, $3F1Hq.getUpdateFieldExperience)());
    (0, $5uXOq.useEffect)(()=>{
        if (isExperienceAvailable) experience.start();
    }, [
        experience,
        isExperienceAvailable
    ]);
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const onSubmit = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $fNyAs.fieldUpdateOptimistic)());
    }, [
        dispatch
    ]);
    const onUpdate = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $fNyAs.fieldUpdateSuccess)());
        experience.success();
    }, [
        dispatch,
        experience
    ]);
    const onFailure = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $fNyAs.fieldUpdateFailure)());
        experience.failure();
    }, [
        dispatch,
        experience
    ]);
    /**
	 * onFailure will be due to an error from backend
	 * onError will be due to an error in frontend, so we dont want to rollback
	 * an update that succeeded in the backend (which we would do in the onFailure)
	 */ const onError = (0, $5uXOq.useCallback)(()=>{
        experience.failure();
    }, [
        experience
    ]);
    return {
        onSubmit: onSubmit,
        onUpdate: onUpdate,
        onFailure: onFailure,
        onError: onError
    };
}

});
parcelRegister("fNyAs", function(module, exports) {

$parcel$export(module.exports, "fieldUpdateOptimistic", () => $aab3ed3017a6c78a$export$d965a01bc4fa38c1);
$parcel$export(module.exports, "fieldUpdateSuccess", () => $aab3ed3017a6c78a$export$899485f80311f013);
$parcel$export(module.exports, "fieldUpdateFailure", () => $aab3ed3017a6c78a$export$8072373a4c28f6d7);

var $9rND4 = parcelRequire("9rND4");
const $aab3ed3017a6c78a$export$eae15d434a3467c2 = 'state.actions.issue.SET_FIELD_UPDATE_OPTIMISTIC';
const $aab3ed3017a6c78a$var$fieldUpdateOptimisticMeta = (0, $9rND4.beginOptimisticUiMeta)();
const $aab3ed3017a6c78a$export$d965a01bc4fa38c1 = ()=>({
        type: $aab3ed3017a6c78a$export$eae15d434a3467c2,
        meta: $aab3ed3017a6c78a$var$fieldUpdateOptimisticMeta
    });
const $aab3ed3017a6c78a$export$e5930a022fd09c89 = 'state.actions.issue.SET_FIELD_UPDATE_SUCCESS';
const $aab3ed3017a6c78a$export$899485f80311f013 = ()=>({
        type: $aab3ed3017a6c78a$export$e5930a022fd09c89,
        meta: (0, $9rND4.commitOptimisticUiMeta)($aab3ed3017a6c78a$var$fieldUpdateOptimisticMeta.optimistic.id)
    });
const $aab3ed3017a6c78a$export$b99b79c1483ed977 = 'state.actions.issue.SET_FIELD_UPDATE_FAILURE';
const $aab3ed3017a6c78a$export$8072373a4c28f6d7 = ()=>({
        type: $aab3ed3017a6c78a$export$b99b79c1483ed977,
        meta: (0, $9rND4.revertOptimisticUiMeta)($aab3ed3017a6c78a$var$fieldUpdateOptimisticMeta.optimistic.id)
    });

});

parcelRegister("3F1Hq", function(module, exports) {

$parcel$export(module.exports, "getUpdateFieldExperience", () => $8b4329ff101ead82$export$540f316847a4d488);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");

const $8b4329ff101ead82$export$540f316847a4d488 = ()=>new (0, $duUGa.UFOExperience)(`${(0, $dcbb2bce513725b3$export$fa0622448a6f265)}.field.update`, {
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
        type: (0, $atdLB.ExperienceTypes).Experience
    });

});


parcelRegister("2yqcU", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyIssueAssigneeFieldWithInviteAssign", () => $d08db32a683a93d6$export$abcd1fef1544cf07);

var $kxZPA = parcelRequire("kxZPA");

const $d08db32a683a93d6$export$abcd1fef1544cf07 = (0, $kxZPA.lazy)(()=>(parcelRequire("adRLN")).then(({ AssigneeFieldInviteAndAssignExperiment: AssigneeFieldInviteAndAssignExperiment })=>AssigneeFieldInviteAndAssignExperiment), {
    moduleId: "./src/packages/software/board/src/view/board-container/board/card-container/card/assignee-field/assignee-field-with-invite-assign/index.tsx"
});

});
parcelRegister("adRLN", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("d7us3")
]).then(()=>parcelRequire('g7CwV'));

});


const $60f83ce4791d4554$export$eb4bdbeb6f6a0217 = 'software-board.board-container.board.card-container.card.assignee-field.button';
const $60f83ce4791d4554$export$ba6ac93c5196802a = 'software-board.common.fields.assignee-field-static.avatar-wrapper';


parcelRegister("jeb8M", function(module, exports) {

$parcel$export(module.exports, "USER_FETCH_URL", () => $1021a6385a9ca75c$export$496c8518e21a3f4);
$parcel$export(module.exports, "SUMMARY_CONFIG_TITLE", () => $1021a6385a9ca75c$export$3b4b8fdfebc45db9);
$parcel$export(module.exports, "STORY_POINT_CONFIG_TITLE", () => $1021a6385a9ca75c$export$279da72db146d908);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_CONFIG_TITLE", () => $1021a6385a9ca75c$export$7708961ea0c1cd86);
$parcel$export(module.exports, "ASSIGNEE_CONFIG_TITLE", () => $1021a6385a9ca75c$export$90703b6e9220b971);
$parcel$export(module.exports, "PARENT_CONFIG_TITLE", () => $1021a6385a9ca75c$export$3fa469ea6c8e4dd4);
$parcel$export(module.exports, "CARD_COVER_SPOTLIGHT_TARGET_ID", () => $1021a6385a9ca75c$export$14dcadde24ed440f);

var $3hUhs = parcelRequire("3hUhs");
const $1021a6385a9ca75c$export$496c8518e21a3f4 = '/rest/api/2/user/assignable/search';
const $1021a6385a9ca75c$export$3b4b8fdfebc45db9 = 'Summary';
const $1021a6385a9ca75c$export$279da72db146d908 = 'Story point estimate';
const $1021a6385a9ca75c$export$7708961ea0c1cd86 = 'Original estimate';
const $1021a6385a9ca75c$export$90703b6e9220b971 = 'Assignee';
const $1021a6385a9ca75c$export$3fa469ea6c8e4dd4 = 'Parent';
const $1021a6385a9ca75c$export$3ec753f69f84781c = (0, $3hUhs.sharedStyles).zIndex.stickySwimlaneBar + 1;
const $1021a6385a9ca75c$export$14dcadde24ed440f = 'jsw-cmp-card-cover-meatball-menu-changeboarding-spotlight-target';

});

parcelRegister("kJtdN", function(module, exports) {

$parcel$export(module.exports, "ContextMenu", () => $6ec468c162141f11$export$8dc6765e8be191c7);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $7dRcU = parcelRequire("7dRcU");

var $4tD4f = parcelRequire("4tD4f");


var $5GDqD = parcelRequire("5GDqD");

var $2xFXk = parcelRequire("2xFXk");

var $67sX6 = parcelRequire("67sX6");

var $9OPlz = parcelRequire("9OPlz");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $63LqY = parcelRequire("63LqY");

var $aLb7D = parcelRequire("aLb7D");

var $9dYAD = parcelRequire("9dYAD");

var $6TWRP = parcelRequire("6TWRP");

var $dlx3i = parcelRequire("dlx3i");

var $jQS76 = parcelRequire("jQS76");

var $7RDtv = parcelRequire("7RDtv");

var $4HOBK = parcelRequire("4HOBK");

var $8cT3J = parcelRequire("8cT3J");

var $2Ogtn = parcelRequire("2Ogtn");

var $cMdeq = parcelRequire("cMdeq");

var $1Akg6 = parcelRequire("1Akg6");

var $3usya = parcelRequire("3usya");

var $9QvG1 = parcelRequire("9QvG1");

var $j49Di = parcelRequire("j49Di");

var $9gxbP = parcelRequire("9gxbP");

var $iokTG = parcelRequire("iokTG");

var $l1G1t = parcelRequire("l1G1t");

var $fg8U1 = parcelRequire("fg8U1");

var $kOuTq = parcelRequire("kOuTq");
const $6ec468c162141f11$export$c087a1fcddb96d21 = ({ issueId: issueId, issueKey: issueKey, selectedCardIds: selectedCardIds })=>{
    const cardIds = selectedCardIds.includes(issueId) ? selectedCardIds : [
        issueId
    ];
    const isMultiSelectMode = cardIds.length > 1;
    const projectType = (0, $67sX6.useBoardSelector)((state)=>(0, $67Z81.projectTypeSelector)(state));
    const isSoftwareProject = projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const header = (0, $3usya.useHeader)({
        selectedCards: cardIds
    });
    const shouldRenderMoveTo = (0, $67sX6.useBoardSelector)((state)=>(0, $67Z81.getCanRankByIssue)(state)(issueId));
    const moveTo = (0, $9gxbP.useMoveTo)({
        issueId: issueId,
        selectedCardIds: cardIds,
        isMultiSelectMode: isMultiSelectMode
    });
    const shouldRenderAddLabelCardMenu = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_ADD_LABEL_CARD_MENU_ITEM);
    const shouldRenderAddFlagCardMenu = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_ADD_FLAG_CARD_MENU_ITEM);
    const shouldRenderEditCoverCardMenu = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_EDIT_COVER);
    const label = (0, $9QvG1.useAddLabel)({
        issueId: issueId,
        selectedCardIds: cardIds
    });
    const flag = (0, $1Akg6.useFlag)({
        issueId: issueId
    });
    const linkIssue = (0, $j49Di.useLinkIssue)({
        issueId: issueId,
        issueKey: issueKey
    });
    const changeParent = (0, $jQS76.useChangeParent)({
        issueId: issueId,
        selectedCardIds: cardIds,
        isMultiSelectMode: isMultiSelectMode
    });
    const bulkChange = (0, $6TWRP.useBulkChange)({
        isMultiSelectMode: isMultiSelectMode
    });
    const editCover = (0, $cMdeq.useEditCover)({
        issueId: issueId
    });
    const copyIssueLink = (0, $8cT3J.useCopyIssueLink)({
        issueKey: issueKey,
        isMultiSelectMode: isMultiSelectMode
    });
    const copyIssueKey = (0, $4HOBK.useCopyIssueKey)({
        issueKey: issueKey,
        isMultiSelectMode: isMultiSelectMode
    });
    const viewInIssueSearch = (0, $fg8U1.useViewIssueSearch)({
        isMultiSelectMode: isMultiSelectMode
    });
    const removeFromSprint = (0, $iokTG.useRemoveFromSprint)({
        issueId: issueId
    });
    const archiveIssue = (0, $9dYAD.useArchiveIssue)({
        issueKey: issueKey,
        issueId: issueId,
        isMultiSelectMode: isMultiSelectMode
    });
    const deleteIssue = (0, $2Ogtn.useDeleteIssue)({
        issueId: issueId,
        isMultiSelectMode: isMultiSelectMode
    });
    const cardActions = [
        ...shouldRenderAddFlagCardMenu ? flag : [],
        ...shouldRenderAddLabelCardMenu ? label : [],
        ...isSoftwareProject && !isMultiSelectMode ? linkIssue : [],
        ...changeParent,
        ...bulkChange,
        ...shouldRenderEditCoverCardMenu && !isMultiSelectMode ? editCover : []
    ];
    const otherActions = [
        ...copyIssueLink,
        ...copyIssueKey,
        ...viewInIssueSearch
    ];
    const deletionActions = [
        ...removeFromSprint,
        ...(0, $co1wz.ff)('issue-unarchival_wdpb9') && archiveIssue || [],
        ...deleteIssue
    ];
    return [
        ...header,
        ...shouldRenderMoveTo ? moveTo : [],
        ...shouldRenderMoveTo && moveTo.length > 0 ? [
            (0, $l1G1t.createSeparator)('move-actions')
        ] : [],
        ...otherActions,
        ...otherActions.length > 0 && cardActions.length > 0 ? [
            (0, $l1G1t.createSeparator)('other-actions')
        ] : [],
        ...cardActions,
        ...deletionActions.length > 0 ? [
            (0, $l1G1t.createSeparator)('delete-actions')
        ] : [],
        ...deletionActions
    ];
};
const $6ec468c162141f11$export$6fdab4f20d43bd5c = ({ issueId: issueId, issueKey: issueKey, selectedCardIds: selectedCardIds, returnFocusRef: returnFocusRef })=>{
    const cardIds = selectedCardIds.includes(issueId) ? selectedCardIds : [
        issueId
    ];
    const isMultiSelectMode = cardIds.length > 1;
    const header = (0, $3usya.useHeader)({
        selectedCards: cardIds
    });
    const changeDateRange = (0, $dlx3i.useChangeDateRange)({
        issueId: issueId,
        selectedCardIds: cardIds,
        isMultiSelectMode: isMultiSelectMode
    });
    const isIssueDoneInClosedSprint = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIsIssueDoneInClosedSprint)(state, issueId));
    const linkIssueOld = (0, $j49Di.useLinkIssueIPBoard)({
        issueId: issueId,
        issueKey: issueKey
    });
    const linkIssueNew = (0, $j49Di.useLinkIssueIPBoard)({
        issueId: issueId,
        issueKey: issueKey,
        returnFocusRef: returnFocusRef
    });
    const linkIssue = (0, $4R6GH.fg)('increment_board_a11y_fix') ? linkIssueNew : linkIssueOld;
    const changeParent = (0, $jQS76.useChangeParent)({
        issueId: issueId,
        selectedCardIds: cardIds,
        isMultiSelectMode: isMultiSelectMode
    });
    const changeTeam = (0, $7RDtv.useChangeTeam)({
        issueId: issueId,
        selectedCardIds: cardIds,
        isMultiSelectMode: isMultiSelectMode
    });
    return [
        ...header,
        ...!isIssueDoneInClosedSprint ? changeDateRange : [],
        ...!isIssueDoneInClosedSprint && changeDateRange.length > 0 ? [
            (0, $l1G1t.createSeparator)('move-actions')
        ] : [],
        ...!isMultiSelectMode ? linkIssue : [],
        ...changeParent,
        ...!isIssueDoneInClosedSprint ? changeTeam : []
    ];
};
const $6ec468c162141f11$var$MenuRendererWithMenuItems = /*#__PURE__*/ (0, $5uXOq.memo)(({ issueId: issueId, issueKey: issueKey, scope: scope, triggerRef: triggerRef })=>{
    const selectedCardIdFromState = (0, $67sX6.useBoardSelector)((0, $9OPlz.getVisibleCardSelection));
    const shouldUseIncrementPlanningContextMenu = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_INCREMENT_PLANNING_CONTEXT_MENU);
    const useContextMenuItemsFn = shouldUseIncrementPlanningContextMenu ? $6ec468c162141f11$export$6fdab4f20d43bd5c : $6ec468c162141f11$export$c087a1fcddb96d21;
    const menuItems = useContextMenuItemsFn({
        issueId: issueId,
        issueKey: issueKey,
        selectedCardIds: selectedCardIdFromState,
        returnFocusRef: triggerRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4tD4f.AsyncMenuRenderer), {
        scope: scope,
        menuItems: menuItems,
        triggerRef: triggerRef,
        ...shouldUseIncrementPlanningContextMenu ? {
            shouldRenderToParent: false
        } : {}
    });
});
const $6ec468c162141f11$export$8dc6765e8be191c7 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { issueId: issueId, issueKey: issueKey, selectedCardIds: selectedCardIds, appearance: appearance } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { addTrait: addTrait } = (0, $5GDqD.useTraitsActions)();
    const { handleOnClose: handleOnIssueLinkedStatsClose } = (0, $7dRcU.useIssueLinkedStatsActions)();
    const shouldShowCardCoverChangeboarding = (0, $aLb7D.useShouldShowCardCoverChangeboarding)();
    const renderMenu = (0, $5uXOq.useCallback)((scope, menuTriggerRef)=>{
        handleOnIssueLinkedStatsClose();
        if (shouldShowCardCoverChangeboarding) addTrait('SITE_USER', {
            name: 'jira-software_ui_context-menu_opened_card-actions_board-screen_first_time',
            value: new Date().toISOString()
        });
        if (appearance === (0, $d9cdb1c71f9dbf8c$export$ee5015c6ad52cf0b)) {
            const { triggerRef: triggerRef } = props;
            if (triggerRef && menuTriggerRef?.current) triggerRef.current = menuTriggerRef.current;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ec468c162141f11$var$MenuRendererWithMenuItems, {
            scope: scope,
            issueId: issueId,
            issueKey: issueKey,
            triggerRef: menuTriggerRef
        });
    }, [
        handleOnIssueLinkedStatsClose,
        shouldShowCardCoverChangeboarding,
        appearance,
        issueId,
        issueKey,
        addTrait,
        props
    ]);
    if (appearance === (0, $d9cdb1c71f9dbf8c$export$bb79bd28759ee895)) {
        const { children: children } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4tD4f.AsyncContextMenu), {
            scope: `${issueId}`,
            renderMenu: renderMenu,
            selectedCardIds: selectedCardIds,
            cardId: issueId,
            jsErrorBoundaryProps: {
                id: 'boardCardContextMenu',
                packageName: 'software-board',
                teamName: 'a4t-tanuki'
            }
        }, children);
    }
    if (appearance === (0, $d9cdb1c71f9dbf8c$export$ee5015c6ad52cf0b)) {
        const { summary: summary, onOpenChange: onOpenChange } = props;
        const menuTriggerMoreCardsMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kOuTq.default).menuTriggerMoreCardsIssueTermRefresh : (0, $kOuTq.default).menuTriggerMoreCards;
        const menuTriggerOneCardMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kOuTq.default).menuTriggerOneCardIssueTermRefresh : (0, $kOuTq.default).menuTriggerOneCard;
        const ariaLabelMessage = formatMessage(selectedCardIds.length > 1 ? menuTriggerMoreCardsMessage : menuTriggerOneCardMessage, {
            summary: summary,
            issueKey: issueKey
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4tD4f.AsyncMeatballMenu), {
            scope: `${issueId}`,
            renderMenu: renderMenu,
            selectedCardIds: selectedCardIds,
            cardId: issueId,
            ariaLabel: ariaLabelMessage,
            onOpenChange: onOpenChange,
            jsErrorBoundaryProps: {
                id: 'boardCardMeatballMenu',
                packageName: 'software-board',
                teamName: 'a4t-tanuki'
            }
        });
    }
    return null;
});

});
parcelRegister("7dRcU", function(module, exports) {

$parcel$export(module.exports, "IssueLinkedStatsContainer", () => $9a68f043454281c4$export$505b706e3d6d12a5);
$parcel$export(module.exports, "useIsIssueLinkDetailsPopupOpen", () => $9a68f043454281c4$export$8676fe1451c567fe);
$parcel$export(module.exports, "useIssueLinkedStatsActions", () => $9a68f043454281c4$export$422d63f0d398cbef);

var $7JoAD = parcelRequire("7JoAD");

var $1N3ww = parcelRequire("1N3ww");
const $9a68f043454281c4$export$d4c72bab9d6cc13a = {
    openedIssueKey: ''
};
const $9a68f043454281c4$export$6f57813fe9f31bf9 = (0, $7JoAD.createStore)({
    initialState: $9a68f043454281c4$export$d4c72bab9d6cc13a,
    actions: $1N3ww.actions,
    name: 'issue-links-stats-store'
});
const $9a68f043454281c4$export$505b706e3d6d12a5 = (0, $7JoAD.createContainer)($9a68f043454281c4$export$6f57813fe9f31bf9, {
    onInit: ()=>({ setState: setState })=>{
            setState($9a68f043454281c4$export$d4c72bab9d6cc13a);
        }
});
const $9a68f043454281c4$var$getIsIssueLinkDetailsPopupOpen = (state, { openedIssueKey: openedIssueKey })=>state.openedIssueKey === openedIssueKey;
const $9a68f043454281c4$export$8676fe1451c567fe = (0, $7JoAD.createStateHook)($9a68f043454281c4$export$6f57813fe9f31bf9, {
    selector: $9a68f043454281c4$var$getIsIssueLinkDetailsPopupOpen
});
const $9a68f043454281c4$export$bcae2c091ad340de = (0, $7JoAD.createHook)($9a68f043454281c4$export$6f57813fe9f31bf9);
const $9a68f043454281c4$export$422d63f0d398cbef = (0, $7JoAD.createActionsHook)($9a68f043454281c4$export$6f57813fe9f31bf9);

});
parcelRegister("1N3ww", function(module, exports) {

$parcel$export(module.exports, "actions", () => $9033a4e50ad01cf1$export$e324594224ef24da);
const $9033a4e50ad01cf1$export$2c8fecc3dc2f2779 = ()=>({ setState: setState })=>{
        setState({
            openedIssueKey: ''
        });
    };
const $9033a4e50ad01cf1$export$a49541cb3ca2f8cf = (openedIssueKey)=>({ setState: setState })=>{
        setState({
            openedIssueKey: openedIssueKey
        });
    };
const $9033a4e50ad01cf1$export$e324594224ef24da = {
    handleOnClose: $9033a4e50ad01cf1$export$2c8fecc3dc2f2779,
    handleOnOpenLinkedIssueDetailsPopup: $9033a4e50ad01cf1$export$a49541cb3ca2f8cf
};

});


parcelRegister("4tD4f", function(module, exports) {

$parcel$export(module.exports, "AsyncContextMenu", () => $65fdd06020fea880$export$88c73a5747b508c6);
$parcel$export(module.exports, "AsyncMeatballMenu", () => $65fdd06020fea880$export$dad57d856f7c40e9);
$parcel$export(module.exports, "AsyncMenuRenderer", () => $65fdd06020fea880$export$481d980aecfdabe6);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $h9HNs = parcelRequire("h9HNs");

var $c1wAv = parcelRequire("c1wAv");

var $g5XcP = parcelRequire("g5XcP");

var $6GBq8 = parcelRequire("6GBq8");

/* istanbul ignore next */ // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $65fdd06020fea880$var$ContextMenuLazy = (0, $kxZPA.lazy)(()=>(parcelRequire("7xhPS")).then((module)=>module.ContextMenu), {
    moduleId: "./src/packages/software/context-menu/src/ui/index.tsx"
});

/* istanbul ignore next */ // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $65fdd06020fea880$var$MeatballMenuLazy = (0, $kxZPA.lazy)(()=>(parcelRequire("7xhPS")).then((module)=>module.MeatballMenu), {
    moduleId: "./src/packages/software/context-menu/src/ui/index.tsx"
});

/* istanbul ignore next */ // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $65fdd06020fea880$var$AsyncMenuRendererLazy = (0, $kxZPA.lazy)(()=>(parcelRequire("lPNYh")).then((module)=>module.MenuRenderer), {
    moduleId: "./src/packages/software/context-menu/src/ui/menu-renderer/index.tsx"
});
const $65fdd06020fea880$var$InternalAsyncContextMenu = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-software-context-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65fdd06020fea880$var$ContextMenuLazy, props));
const $65fdd06020fea880$var$InternalAsyncMeatballMenu = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-software-context-menu-meatball-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65fdd06020fea880$var$MeatballMenuLazy, props));
const $65fdd06020fea880$export$88c73a5747b508c6 = (props)=>{
    const openContextMenuRef = (0, $5uXOq.useRef)(null);
    const childrenRef = (0, $5uXOq.useRef)(null);
    const { onContextMenu: onContextMenu } = (0, $g5XcP.useOnContextMenu)({
        childrenRef: childrenRef,
        openContextMenuRef: openContextMenuRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1wAv.ChildrenWrapperWithAnalytics), {
        onChildrenContextMenu: onContextMenu,
        ref: childrenRef
    }, props.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h9HNs.ContextMenuErrorBoundary), {
        id: "jira-software-context-menu",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65fdd06020fea880$var$InternalAsyncContextMenu, {
        ...props,
        openContextMenuRef: openContextMenuRef
    })));
};
const $65fdd06020fea880$export$dad57d856f7c40e9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h9HNs.ContextMenuErrorBoundary), {
        id: "jira-software-context-menu-meatball-menu",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65fdd06020fea880$var$InternalAsyncMeatballMenu, props));
const $65fdd06020fea880$export$481d980aecfdabe6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-software-context-menu-menu-renderer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6GBq8.MenuRendererPlaceholder), {
            menuItems: props.menuItems
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65fdd06020fea880$var$AsyncMenuRendererLazy, props));

});
parcelRegister("h9HNs", function(module, exports) {

$parcel$export(module.exports, "ContextMenuErrorBoundary", () => $0bf642946ee45d6d$export$9253ba2022568501);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");
const $0bf642946ee45d6d$export$9253ba2022568501 = ({ id: id, children: children, fallback: fallback })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: id,
        packageName: "jiraSoftwareContextMenu",
        fallback: fallback || 'unmount',
        teamName: "deliveroo"
    }, children);

});

parcelRegister("c1wAv", function(module, exports) {

$parcel$export(module.exports, "ChildrenWrapperWithAnalytics", () => $5fcbc6bc21c0dd31$export$1249ce36e893a19b);

var $5uXOq = parcelRequire("5uXOq");

var $2OMDV = parcelRequire("2OMDV");
var $iXVV6 = parcelRequire("iXVV6");

const $5fcbc6bc21c0dd31$var$WrapperWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('contextMenu', {
    onContextMenu: 'opened'
})(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ createAnalyticsEvent: createAnalyticsEvent, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ...props,
        ref: ref
    })));
const $5fcbc6bc21c0dd31$export$1249ce36e893a19b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, onChildrenContextMenu: onChildrenContextMenu }, ref)=>{
    const WrapperWithAnalyticsComponent = $5fcbc6bc21c0dd31$var$WrapperWithAnalytics;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            inputSource: 'rightClick'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperWithAnalyticsComponent, {
        ref: ref,
        onContextMenu: onChildrenContextMenu,
        "data-testid": (0, $c261fa84ee29a782$export$1790245723dd00ad)
    }, children));
});

});
const $c261fa84ee29a782$export$1790245723dd00ad = 'software-context-menu.ui.context-menu.children-wrapper';


parcelRegister("g5XcP", function(module, exports) {

$parcel$export(module.exports, "useOnContextMenu", () => $f82fb67b9a97c056$export$ca7798d25343efd8);

var $jcw0u = parcelRequire("jcw0u");

var $7D59a = parcelRequire("7D59a");
const $f82fb67b9a97c056$export$ca7798d25343efd8 = ({ childrenRef: childrenRef, openContextMenuRef: openContextMenuRef })=>{
    const onContextMenu = (0, $7D59a.useEvent)((e, analyticsEvent)=>{
        e.stopPropagation();
        if (!childrenRef?.current || !openContextMenuRef?.current) {
            !childrenRef?.current && (0, $jcw0u.default)({
                error: new Error('Trying to open a context menu while childrenRef is undefined'),
                meta: {
                    id: 'jira-software-context-menu-controller-on-container-update-flow-start-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        e.preventDefault();
        const { top: top, left: left } = childrenRef.current.getBoundingClientRect();
        const position = {
            x: e.clientX - left,
            y: e.clientY - top
        };
        openContextMenuRef.current.onOpenContextMenu({
            position: position,
            analyticsEvent: analyticsEvent
        });
    });
    return {
        onContextMenu: onContextMenu
    };
};

});

parcelRegister("6GBq8", function(module, exports) {

$parcel$export(module.exports, "MenuRendererPlaceholder", () => $03bf8ee5a763f135$export$9c3503516e6b2b03);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $eZJjh = parcelRequire("eZJjh");

var $1HF4Y = parcelRequire("1HF4Y");

var $6ssLS = parcelRequire("6ssLS");

var $clxlA = parcelRequire("clxlA");
const $03bf8ee5a763f135$export$b12353dcfd2c40d3 = (menuItems)=>menuItems.reduce((acc, menuItem)=>{
        if (menuItem.type === (0, $1HF4Y.MenuNodeType).Separator) return acc + $clxlA.SEPARATOR_PLACEHOLDER_HEIGHT;
        if (menuItem.type === (0, $1HF4Y.MenuNodeType).Section) return acc + $clxlA.SECTION_HEADER_PLACEHOLDER_HEIGHT + $03bf8ee5a763f135$export$b12353dcfd2c40d3(menuItem.children || []);
        return acc + $clxlA.MENU_ITEM_PLACEHOLDER_HEIGHT;
    }, 0);
const $03bf8ee5a763f135$export$9c3503516e6b2b03 = /*#__PURE__*/ (0, $5uXOq.memo)(({ menuItems: menuItems })=>{
    const height = $03bf8ee5a763f135$export$b12353dcfd2c40d3(menuItems);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03bf8ee5a763f135$var$Container, {
        "data-testid": $clxlA.CONTEXT_MENU_PLACEHOLDER_TESTID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03bf8ee5a763f135$var$InnerItems, {
        height: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium"
    })));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $03bf8ee5a763f135$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $6ssLS.MenuContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bsbuuw1",
            __cmplp.className
        ])
    });
});
const $03bf8ee5a763f135$var$InnerItems = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i2nrh _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1HF4Y", function(module, exports) {

$parcel$export(module.exports, "MenuNodeType", () => $8e9d98803c1f1230$export$d6a3c2c57b227e3b);
const $8e9d98803c1f1230$export$d6a3c2c57b227e3b = {
    Item: 'item',
    Node: 'node',
    Separator: 'separator',
    Section: 'section',
    Search: 'search',
    BulkIndicator: 'bulkIndicator'
};

});

parcelRegister("6ssLS", function(module, exports) {

$parcel$export(module.exports, "MenuContainer", () => $c700ae4c66d12196$export$b286f91cddfedb5a);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $c700ae4c66d12196$export$b286f91cddfedb5a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul9uuw1 _c71ldgin _1yt4swc3 _2rko1l7b _vchhusvi _11q71bhr",
            __cmplp.className
        ])
    });
});

});

parcelRegister("clxlA", function(module, exports) {

$parcel$export(module.exports, "CONTEXT_MENU_PLACEHOLDER_TESTID", () => $be0729fb178ee569$export$d0775d7ba1f28e6);
$parcel$export(module.exports, "SEPARATOR_PLACEHOLDER_HEIGHT", () => $be0729fb178ee569$export$49b3e4b8a0edc9b7);
$parcel$export(module.exports, "SECTION_HEADER_PLACEHOLDER_HEIGHT", () => $be0729fb178ee569$export$71999dec35730ebd);
$parcel$export(module.exports, "MENU_ITEM_PLACEHOLDER_HEIGHT", () => $be0729fb178ee569$export$f9717b5566f9ac9f);

var $gwIPs = parcelRequire("gwIPs");

const $be0729fb178ee569$export$d0775d7ba1f28e6 = 'software-context-menu.ui.menu-renderer-placeholder';
const $be0729fb178ee569$export$49b3e4b8a0edc9b7 = (0, $gwIPs.gridSize) + 1;
const $be0729fb178ee569$export$71999dec35730ebd = (0, $gwIPs.gridSize) * 2;
const $be0729fb178ee569$export$f9717b5566f9ac9f = (0, $d9cdb1c71f9dbf8c$export$b9e05b29ae05bdd9);

});


parcelRegister("7xhPS", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("hsIMW").then(()=>parcelRequire('c0JwO'));

});

parcelRegister("lPNYh", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("5r9EF").then(()=>parcelRequire('6hc7I'));

});


parcelRegister("aLb7D", function(module, exports) {

$parcel$export(module.exports, "transformToIssueFieldValues", () => $ceb271d5f92ec596$export$b419a5d0413eaa90);
$parcel$export(module.exports, "transformToIssueFieldConfigValues", () => $ceb271d5f92ec596$export$f834c80091db4807);
$parcel$export(module.exports, "getShouldShowLabels", () => $ceb271d5f92ec596$export$d29f8cc4773bd66e);
$parcel$export(module.exports, "useShouldShowCardCoverChangeboarding", () => $ceb271d5f92ec596$export$f3f70a587c2fd214);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $fhSLy = parcelRequire("fhSLy");

var $7Fute = parcelRequire("7Fute");

var $5fc53 = parcelRequire("5fc53");


var $5GDqD = parcelRequire("5GDqD");

var $63LqY = parcelRequire("63LqY");

var $jeb8M = parcelRequire("jeb8M");
const $ceb271d5f92ec596$export$b419a5d0413eaa90 = ({ issue: { summary: summary }, assignee: assignee, parent: parent, estimateExtended: estimateExtended })=>({
        summary: summary,
        ...parent && {
            parent: (0, $7Fute.getParentShape)(String(parent.id), parent.key, parent.summary, {
                id: parent.issueType.id,
                name: parent.issueType.name,
                iconUrl: parent.issueType.iconUrl
            }, parent.color),
            [(0, $5fc53.HIERARCHY_LEVEL_ABOVE)]: (0, $7Fute.getHierarchyShape)({
                id: parent.issueType.id,
                name: parent.issueType.name,
                iconUrl: parent.issueType.iconUrl
            })
        },
        ...assignee && {
            assignee: (0, $fhSLy.getUserShape)(assignee.id, assignee.displayName, assignee.avatarUrl || '')
        },
        ...estimateExtended && estimateExtended.fieldId && {
            [estimateExtended.fieldId]: estimateExtended.value
        }
    });
const $ceb271d5f92ec596$export$f834c80091db4807 = ({ issue: { key: key, summary: summary }, estimateExtended: estimateExtended, isEditable: isEditable })=>{
    const summaryConfig = {
        autoCompleteUrl: null,
        allowedValues: [],
        isEditable: isEditable,
        isRequired: true,
        title: (0, $jeb8M.SUMMARY_CONFIG_TITLE),
        schema: {
            type: 'string',
            custom: null,
            customId: null,
            system: (0, $5fc53.SUMMARY_TYPE),
            renderer: 'jira-text-renderer'
        }
    };
    const storyPointConfig = {
        autoCompleteUrl: null,
        allowedValues: [],
        isEditable: isEditable,
        isRequired: true,
        title: (0, $jeb8M.STORY_POINT_CONFIG_TITLE),
        schema: {
            type: 'number',
            custom: (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE),
            customId: estimateExtended?.fieldId ? parseInt(estimateExtended.fieldId.replace('customfield_', ''), 10) : null,
            system: null,
            renderer: 'jira-text-renderer'
        }
    };
    const originalEstimateConfig = {
        autoCompleteUrl: null,
        allowedValues: [],
        isEditable: isEditable,
        isRequired: true,
        title: (0, $jeb8M.ORIGINAL_ESTIMATE_CONFIG_TITLE),
        schema: {
            type: 'number',
            custom: null,
            customId: null,
            system: (0, $5fc53.TIME_ESTIMATE_TYPE),
            renderer: null
        }
    };
    const assigneeConfig = {
        autoCompleteUrl: `${(0, $jeb8M.USER_FETCH_URL)}?issueKey=${key}&query=`,
        allowedValues: [],
        isEditable: isEditable,
        isRequired: true,
        title: (0, $jeb8M.ASSIGNEE_CONFIG_TITLE),
        schema: {
            type: 'user',
            custom: null,
            customId: null,
            system: (0, $5fc53.ASSIGNEE_TYPE),
            renderer: 'jira-text-renderer'
        }
    };
    const parentConfig = {
        autoCompleteUrl: null,
        allowedValues: [],
        isEditable: isEditable,
        isRequired: true,
        title: (0, $jeb8M.PARENT_CONFIG_TITLE),
        schema: {
            type: 'array',
            custom: null,
            customId: null,
            system: (0, $5fc53.PARENT_TYPE),
            renderer: null
        }
    };
    return {
        ...summary && {
            summary: summaryConfig
        },
        parent: parentConfig,
        assignee: assigneeConfig,
        ...estimateExtended?.fieldId && (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2) === estimateExtended.fieldId && {
            [estimateExtended.fieldId]: originalEstimateConfig
        },
        ...estimateExtended?.fieldId && (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2) !== estimateExtended.fieldId && {
            [estimateExtended.fieldId]: storyPointConfig
        }
    };
};
const $ceb271d5f92ec596$export$d29f8cc4773bd66e = (viewSettingsShowLabels, isCMPBoard)=>{
    // TMP
    if (!isCMPBoard) return viewSettingsShowLabels;
    // CMP
    return false; // disregard viewSettings.showLabel in CMP to avoid double labels // CMP now renders labels from custom fields
};
const $ceb271d5f92ec596$export$14c8617559a4dc59 = (0, $5GDqD.createTraitsSelector)('SITE_USER', ({ getTraitByName: getTraitByName })=>{
    if (!(0, $4R6GH.fg)('jsw_cmp_card_covers_changeboarding')) return false;
    const jswFirstActiveDate = getTraitByName('jira-software_first_active');
    if (!jswFirstActiveDate) return false;
    const hasSeenCardCoverOnboarding = getTraitByName('jira-software_ui_context-menu_opened_card-actions_board-screen_first_time');
    const over30DaysAgo = new Date(new Date().getTime() - 2592000000);
    return !hasSeenCardCoverOnboarding && new Date(String(jswFirstActiveDate.value)) < over30DaysAgo;
});
const $ceb271d5f92ec596$export$f3f70a587c2fd214 = ()=>{
    const [isCardCoversNew] = $ceb271d5f92ec596$export$14c8617559a4dc59();
    const isJSWBoard = (0, $63LqY.useIsJSWBoard)() ?? false;
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)() ?? false;
    if (!(0, $4R6GH.fg)('jsw_cmp_card_covers_changeboarding')) return false;
    // Return false for ineligible boards
    if (!isJSWBoard || !isCMPBoard || !isCardCoversNew) return false;
    return (0, $6s1PB.expVal)('jsw_cmp_card_cover_images_experiment', 'isCardCoverFeatureEnabled', false);
};

});
parcelRegister("7Fute", function(module, exports) {

$parcel$export(module.exports, "getLozengeThemeByColor", () => $92894d61150c3ebf$export$949dc67535a8ff2);
$parcel$export(module.exports, "getParentShape", () => $92894d61150c3ebf$export$1a0682c86bbf9e96);
$parcel$export(module.exports, "getHierarchyShape", () => $92894d61150c3ebf$export$5f81302d25451851);
$parcel$export(module.exports, "formatOptionList", () => $92894d61150c3ebf$export$48f827b6d0c5862);
$parcel$export(module.exports, "transformToEpic", () => $92894d61150c3ebf$export$11773371cf35c9f8);

var $iHPnC = parcelRequire("iHPnC");

var $k8qVk = parcelRequire("k8qVk");
const $92894d61150c3ebf$export$9b822862d986dfdf = (0, $iHPnC.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $92894d61150c3ebf$export$949dc67535a8ff2 = (color = (0, $k8qVk.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $92894d61150c3ebf$export$9b822862d986dfdf[color] ?? $92894d61150c3ebf$export$9b822862d986dfdf[0, $k8qVk.DEFAULT_EPIC_COLOR];
const $92894d61150c3ebf$export$1a0682c86bbf9e96 = (id, key, summary, issuetype, color)=>({
        id: id,
        key: key,
        color: color,
        fields: {
            summary: summary,
            issuetype: issuetype
        }
    });
const $92894d61150c3ebf$export$5f81302d25451851 = ({ id: id, name: name, iconUrl: iconUrl })=>({
        name: 'Epic',
        level: 1,
        issueTypeIds: [
            Number(id)
        ],
        issueTypes: [
            {
                id: id,
                name: name,
                iconUrl: iconUrl
            }
        ]
    });
const $92894d61150c3ebf$export$48f827b6d0c5862 = (unformattedOptions, currentParent, label)=>{
    const filteredOptions = unformattedOptions.filter((option)=>option.key !== currentParent);
    const parentList = filteredOptions.slice(0, (0, $k8qVk.MAX_SUGGESTIONS)).map((option)=>({
            label: `${option.key} ${option.fields.summary}`,
            value: option.fields.summary,
            iconUrl: option.fields.issuetype.iconUrl,
            ...option
        }));
    return {
        options: parentList.length > 0 ? [
            {
                label: label,
                options: parentList
            }
        ] : [],
        hasMoreOptions: filteredOptions.length > (0, $k8qVk.MAX_SUGGESTIONS)
    };
};
const $92894d61150c3ebf$export$11773371cf35c9f8 = ({ id: id, key: key, summary: summary, color: color, issueType: { id: issueTypeId, name: issueTypeName, iconUrl: iconUrl } })=>({
        id: id,
        key: key,
        summary: summary,
        color: color,
        issueType: {
            id: issueTypeId,
            name: issueTypeName,
            iconUrl: iconUrl
        }
    });

});
parcelRegister("k8qVk", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $93cb8f2923e7410b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $93cb8f2923e7410b$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAX_SUGGESTIONS", () => $93cb8f2923e7410b$export$eb8d067f048699c8);
$parcel$export(module.exports, "MENU_WIDTH", () => $93cb8f2923e7410b$export$2467bcf8f6d5c6b6);
$parcel$export(module.exports, "MENU_EMPTY_WIDTH", () => $93cb8f2923e7410b$export$84f510916a7dff2e);
$parcel$export(module.exports, "LONG_LABEL_LIMIT", () => $93cb8f2923e7410b$export$29ec59bc4d551a41);
$parcel$export(module.exports, "PARENT_SWITCHER_LOZENGE_TEST_ID", () => $93cb8f2923e7410b$export$680faa54dc6da799);
$parcel$export(module.exports, "PARENT_SWITCHER_LOADING_SPINNER_TEST_ID", () => $93cb8f2923e7410b$export$11e2185ebbcf7235);
$parcel$export(module.exports, "PARENT_SWITCHER_SUGGESTED_PARENTS_ACTIONS_TEST_ID", () => $93cb8f2923e7410b$export$2aa213773f04da8f);
$parcel$export(module.exports, "PARENT_SWITCHER_LABEL_TEST_ID", () => $93cb8f2923e7410b$export$bccc9d1ffeb474d3);
$parcel$export(module.exports, "PARENT_SWITCHER_ADD_PARENT_BUTTON_TEST_ID", () => $93cb8f2923e7410b$export$cc185b35b5eb5c92);
$parcel$export(module.exports, "PARENT_SWITCHER_SUGGESTED_PARENTS_REMOVE_PARENT_TEST_ID", () => $93cb8f2923e7410b$export$31b523708d2a8acb);
$parcel$export(module.exports, "PARENT_SWITCHER_SUGGESTED_PARENTS_VIEW_ALL_PARENTS_TEST_ID", () => $93cb8f2923e7410b$export$ac3a223c1d7cac9a);
$parcel$export(module.exports, "PARENT_SWITCHER_SUGGESTED_PARENTS_EMPTY_TEST_ID", () => $93cb8f2923e7410b$export$beb7535f4921d585);
$parcel$export(module.exports, "PARENT_SWITCHER_OPEN_ISSUE_CREATE_LINK_TEST_ID", () => $93cb8f2923e7410b$export$a019f396c99849dc);

var $kFsv3 = parcelRequire("kFsv3");

var $3XO6n = parcelRequire("3XO6n");
const $93cb8f2923e7410b$export$b8b9d90f9e5bd72b = (0, $3XO6n.toPackageName)('jiraParentSwitcherField');
const $93cb8f2923e7410b$export$c2357bec51c5cf5b = (0, $kFsv3.PURPLE);
const $93cb8f2923e7410b$export$eb8d067f048699c8 = 5;
const $93cb8f2923e7410b$export$2467bcf8f6d5c6b6 = 345;
const $93cb8f2923e7410b$export$84f510916a7dff2e = 180;
const $93cb8f2923e7410b$export$29ec59bc4d551a41 = 40;
const $93cb8f2923e7410b$export$680faa54dc6da799 = 'issue-field-parent-switcher.common.ui.epic-lozenge.epic-lozenge';
const $93cb8f2923e7410b$export$2082958b673f1f66 = 'issue-field-parent-switcher.common.ui.epic-tag.tag';
const $93cb8f2923e7410b$export$11813783c408cdf1 = `[data-testid="${$93cb8f2923e7410b$export$680faa54dc6da799}"]`;
const $93cb8f2923e7410b$export$11e2185ebbcf7235 = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.loading-content.parent-switcher-suggested-parents-loading-spinner';
const $93cb8f2923e7410b$export$2aa213773f04da8f = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.actions';
const $93cb8f2923e7410b$export$bccc9d1ffeb474d3 = 'issue-field-parent.edit-view.options.';
const $93cb8f2923e7410b$export$cc185b35b5eb5c92 = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.add-parent-button';
const $93cb8f2923e7410b$export$31b523708d2a8acb = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.remove-parent';
const $93cb8f2923e7410b$export$986b8ef30a6bdca7 = `[data-testid="${$93cb8f2923e7410b$export$31b523708d2a8acb}"]`;
const $93cb8f2923e7410b$export$ac3a223c1d7cac9a = 'issue-field-parent-switcher.ui.edit.view-all-parents';
const $93cb8f2923e7410b$export$6494872dab91ac11 = `[data-testid="${$93cb8f2923e7410b$export$ac3a223c1d7cac9a}"]`;
const $93cb8f2923e7410b$export$beb7535f4921d585 = 'issue-field-parent-switcher.ui.edit.empty-container';
const $93cb8f2923e7410b$export$c0432cfce03a69a8 = `[data-testid="${$93cb8f2923e7410b$export$beb7535f4921d585}"]`;
const $93cb8f2923e7410b$export$a019f396c99849dc = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.empty-content.open-issue-create';

});



parcelRegister("9dYAD", function(module, exports) {

$parcel$export(module.exports, "useArchiveIssue", () => $786d858708e6a24d$export$8726fa65ba085232);

var $co1wz = parcelRequire("co1wz");

var $koVbs = parcelRequire("koVbs");

var $5ING5 = parcelRequire("5ING5");

var $cDZaH = parcelRequire("cDZaH");

var $2gCtH = parcelRequire("2gCtH");

var $g4tDr = parcelRequire("g4tDr");

var $ldyPw = parcelRequire("ldyPw");

var $1HF4Y = parcelRequire("1HF4Y");

var $k9JTq = parcelRequire("k9JTq");



var $67sX6 = parcelRequire("67sX6");

var $cW3pH = parcelRequire("cW3pH");

var $1vXOx = parcelRequire("1vXOx");

var $d2i8f = parcelRequire("d2i8f");


var $kOuTq = parcelRequire("kOuTq");
const $786d858708e6a24d$export$c4b948cf20152586 = ({ isArchiveEnabled: isArchiveEnabled, onArchiveIssue: onArchiveIssue })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!isArchiveEnabled) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $kOuTq.default).archive),
            id: (0, $c96743ce387bce58$export$fc49978f895ec203),
            onClick: onArchiveIssue
        }
    ];
};
const $786d858708e6a24d$export$8726fa65ba085232 = ({ issueKey: issueKey, issueId: issueId, isMultiSelectMode: isMultiSelectMode })=>{
    const isArchived = (0, $2gCtH.useIsArchived)();
    const issueIdArg = issueId.toString();
    const hierarchyLevel = (0, $67sX6.useBoardSelector)((0, $d2i8f.getIssueTypeLevelForBoardIssue))(issueId);
    const isSubtask = (0, $g4tDr.isSubtaskHierarchyLevel)(hierarchyLevel);
    const canArchiveIssue = (0, $67sX6.useBoardSelector)((0, $1vXOx.getPermissionsSelector))?.[0, $e525e6c25695c9df$export$e6bcada406923d66];
    const edition = (0, $k9JTq.useAppEditions)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const isPremium = edition?.software === (0, $ldyPw.PREMIUM_EDITION);
    const canArchive = (0, $co1wz.ff)('issue-unarchival_wdpb9') && !isArchived && (canArchiveIssue ?? false) && !isSubtask && isPremium;
    const { openArchiveIssueModal: openArchiveIssueModal } = (0, $cDZaH.useArchiveIssueModalActions)();
    const onIssueArchiveSuccess = ()=>{
        dispatch((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$ccb7bcb751e6027e)));
    };
    return $786d858708e6a24d$export$c4b948cf20152586({
        isArchiveEnabled: canArchive && !isMultiSelectMode,
        onArchiveIssue: ()=>{
            openArchiveIssueModal({
                issueKey: issueKey,
                issueId: issueIdArg,
                triggerPointKey: (0, $5ING5.TRIGGER_POINT_KEY_BOARD_VIEW),
                onIssueArchiveSuccess: onIssueArchiveSuccess
            });
        }
    });
};

});
parcelRegister("5ING5", function(module, exports) {

$parcel$export(module.exports, "ARCHIVE_ISSUE_MODAL_WIDTH_CATEGORY", () => $f2d76d919b5758cc$export$2ac06baa43be057);
$parcel$export(module.exports, "ESC_KEY", () => $f2d76d919b5758cc$export$45f4d5e73efcfde8);
$parcel$export(module.exports, "ISSUE_VIEW_URL_REGEX", () => $f2d76d919b5758cc$export$cbf34536d6076514);
$parcel$export(module.exports, "ISSUE_ARCHIVE_API", () => $f2d76d919b5758cc$export$1c9d135d7bb1047);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_ISSUE_VIEW", () => $f2d76d919b5758cc$export$501c618f5224bbb);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_ISSUE_NAVIGATOR", () => $f2d76d919b5758cc$export$f64573f447a64548);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_BOARD_VIEW", () => $f2d76d919b5758cc$export$a1eb5fb00be2a7d1);
const $f2d76d919b5758cc$export$2ac06baa43be057 = 'small';
const $f2d76d919b5758cc$export$45f4d5e73efcfde8 = 'Escape';
const $f2d76d919b5758cc$export$cbf34536d6076514 = /.*\/browse\/[^/]+/;
const $f2d76d919b5758cc$export$1c9d135d7bb1047 = '/rest/api/2/issue/archive';
const $f2d76d919b5758cc$export$501c618f5224bbb = 'issue-view';
const $f2d76d919b5758cc$export$f64573f447a64548 = 'issue-navigator';
const $f2d76d919b5758cc$export$a1eb5fb00be2a7d1 = 'board-view';

});

parcelRegister("cDZaH", function(module, exports) {

$parcel$export(module.exports, "ArchiveIssueModalStore", () => $40459da096a405f9$export$c5cad849002b274b);
$parcel$export(module.exports, "useArchiveIssueModalActions", () => $40459da096a405f9$export$b7e685898567f722);

var $7JoAD = parcelRequire("7JoAD");

var $iP93q = parcelRequire("iP93q");

var $tr6Ns = parcelRequire("tr6Ns");
const $40459da096a405f9$export$c5cad849002b274b = (0, $7JoAD.createStore)({
    initialState: $tr6Ns.initialState,
    actions: (0, $iP93q.ArchiveIssueModalActions),
    name: 'archiveIssueModalStore'
});
const $40459da096a405f9$export$b7e685898567f722 = (0, $7JoAD.createActionsHook)($40459da096a405f9$export$c5cad849002b274b);

});
parcelRegister("iP93q", function(module, exports) {

$parcel$export(module.exports, "ArchiveIssueModalActions", () => $0edc0fbae339598b$export$69579d834733fb34);
const $0edc0fbae339598b$export$69579d834733fb34 = {
    openArchiveIssueModal: ({ issueKey: issueKey, issueId: issueId, onIssueArchiveSuccess: onIssueArchiveSuccess, onCloseIssueViewModal: onCloseIssueViewModal, triggerPointKey: triggerPointKey })=>({ setState: setState })=>{
            setState({
                isArchiveIssueModalOpen: true,
                issueKey: issueKey,
                issueId: issueId,
                onIssueArchiveSuccess: onIssueArchiveSuccess,
                onCloseIssueViewModal: onCloseIssueViewModal,
                triggerPointKey: triggerPointKey
            });
        },
    closeArchiveIssueModal: ()=>({ setState: setState })=>{
            setState({
                isArchiveIssueModalOpen: false,
                issueKey: null,
                issueId: null,
                onIssueArchiveSuccess: null,
                onCloseIssueViewModal: null,
                triggerPointKey: null
            });
        }
};

});

parcelRegister("tr6Ns", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $75b2be9671247dca$export$d4c72bab9d6cc13a);
const $75b2be9671247dca$export$d4c72bab9d6cc13a = {
    isArchiveIssueModalOpen: false,
    issueKey: null,
    issueId: null,
    onIssueArchiveSuccess: null,
    onCloseIssueViewModal: null,
    triggerPointKey: null
};

});


const $c96743ce387bce58$export$5645be38d58b5483 = 'actions/move-to';
const $c96743ce387bce58$export$b7199a4fda4563e9 = 'actions/move-to/top-of-column';
const $c96743ce387bce58$export$facab7e3869721f4 = 'actions/move-to/bottom-of-column';
const $c96743ce387bce58$export$32afee5bddfb614a = 'actions/move-to/backlog';
const $c96743ce387bce58$export$63cb4152f50d2665 = 'actions/flag';
const $c96743ce387bce58$export$efe455e4d4b4aca9 = 'actions/flag/add-flag';
const $c96743ce387bce58$export$356329b49381740c = 'actions/flag/remove-flag';
const $c96743ce387bce58$export$d0e98113904dfa9 = 'actions/add-label';
const $c96743ce387bce58$export$34b38d58090a7162 = 'actions/copy-issue-link';
const $c96743ce387bce58$export$2e74ac183d49087 = 'actions/copy-issue-key';
const $c96743ce387bce58$export$4231ab934953c1bc = 'actions/view-in-issue-search';
const $c96743ce387bce58$export$bdfa217711a39d8d = 'bulk-indicator';
const $c96743ce387bce58$export$b35363b92f22bb89 = 'actions/delete-issue';
const $c96743ce387bce58$export$fc49978f895ec203 = 'actions/archive-issue';
const $c96743ce387bce58$export$e47c565bdec2e2fb = 'actions/remove-from-sprint';
const $c96743ce387bce58$export$a62eb3479b356078 = 'actions/link-issue';
const $c96743ce387bce58$export$1fa1533b8d6efd51 = 'separator';
const $c96743ce387bce58$export$f823757fde5bc834 = 'actions/change-parent';
const $c96743ce387bce58$export$d8dbd75dd44821b = 'actions/bulk-change';
const $c96743ce387bce58$export$e51c7bc6816555b2 = 'actions/change-team';
const $c96743ce387bce58$export$9c672767be29c0ac = 'actions/change-team/search';
const $c96743ce387bce58$export$aea369fa6803ebd = 'actions/change-team/unassign';
const $c96743ce387bce58$export$1435067cc5065f6a = 'actions/change-date-range';
const $c96743ce387bce58$export$6d7ac6c2960a1ce6 = 'actions/change-date-range/unschedule';
const $c96743ce387bce58$export$d36e4a2ba747e549 = 'actions/change-date-range/schedule-column';
const $c96743ce387bce58$export$2e6bc5997111e31f = 'actions/edit-cover';

parcelRegister("kOuTq", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bd68f44a2c417d9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0bd68f44a2c417d9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moveTo: {
        "id": "software.main.board-container.board.card-container.card.context-menu.move-to",
        "defaultMessage": "Move to"
    },
    column: {
        "id": "software.main.board-container.board.card-container.card.context-menu.column",
        "defaultMessage": "Column {columnName}"
    },
    topOfTheColumn: {
        "id": "software.main.board-container.board.card-container.card.context-menu.top-of-the-column",
        "defaultMessage": "Top of column"
    },
    bottomOfTheColumn: {
        "id": "software.main.board-container.board.card-container.card.context-menu.bottom-of-the-column",
        "defaultMessage": "Bottom of column"
    },
    backlog: {
        "id": "software.main.board-container.board.card-container.card.context-menu.backlog",
        "defaultMessage": "Backlog"
    },
    viewInIssueSearch: {
        "id": "software.main.board-container.board.card-container.card.context-menu.view-in-issue-search",
        "defaultMessage": "View in issue search"
    },
    label: {
        "id": "software.main.board-container.board.card-container.card.context-menu.label",
        "defaultMessage": "Add label"
    },
    flag: {
        "id": "software.main.board-container.board.card-container.card.context-menu.flag",
        "defaultMessage": "Flag"
    },
    addFlag: {
        "id": "software.main.board-container.board.card-container.card.context-menu.add-flag",
        "defaultMessage": "Add flag"
    },
    removeFlag: {
        "id": "software.main.board-container.board.card-container.card.context-menu.remove-flag",
        "defaultMessage": "Remove flag"
    },
    addIssueParent: {
        "id": "software.main.board-container.board.card-container.card.context-menu.add-issue-parent",
        "defaultMessage": "Add parent"
    },
    changeIssueParent: {
        "id": "software.main.board-container.board.card-container.card.context-menu.change-issue-parent",
        "defaultMessage": "Change parent"
    },
    bulkChange: {
        "id": "software.main.board-container.board.card-container.card.context-menu.bulk-change",
        "defaultMessage": "Bulk change"
    },
    bulkChangeIconLabel: {
        "id": "software.main.board-container.board.card-container.card.context-menu.bulk-change-icon-label",
        "defaultMessage": "Open in new window"
    },
    removeFromSprint: {
        "id": "software.main.board-container.board.card-container.card.context-menu.remove-from-sprint",
        "defaultMessage": "Remove from sprint"
    },
    delete: {
        "id": "software.main.board-container.board.card-container.card.context-menu.delete",
        "defaultMessage": "Delete"
    },
    archive: {
        "id": "software.main.board-container.board.card-container.card.context-menu.archive",
        "defaultMessage": "Archive"
    },
    menuTriggerOneCard: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-trigger-one-card",
        "defaultMessage": "More actions for {issueKey} {summary}"
    },
    menuTriggerMoreCards: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-trigger-more-cards",
        "defaultMessage": "More actions for {issueKey} {summary} and other selected issues"
    },
    unscheduleIncrement: {
        "id": "software.main.board-container.board.card-container.card.context-menu.unschedule-increment",
        "defaultMessage": "Unschedule"
    },
    changeTeam: {
        "id": "software.main.board-container.board.card-container.card.context-menu.change-team",
        "defaultMessage": "Change team"
    },
    unassign: {
        "id": "software.main.board-container.board.card-container.card.context-menu.unassign",
        "defaultMessage": "Unassign"
    },
    viewInIssueSearchIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.view-in-issue-search-issue-term-refresh",
        "defaultMessage": "View in issue search"
    },
    menuTriggerOneCardIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-trigger-one-card-issue-term-refresh",
        "defaultMessage": "More actions for {issueKey} {summary}"
    },
    menuTriggerMoreCardsIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-trigger-more-cards-issue-term-refresh",
        "defaultMessage": "More actions for {issueKey} {summary} and other selected issues"
    }
});

});


parcelRegister("6TWRP", function(module, exports) {

$parcel$export(module.exports, "useBulkChange", () => $6b742bfb150e953b$export$5b8e045dd5a63047);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ggICg = parcelRequire("ggICg");

var $17Ngn = parcelRequire("17Ngn");


var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $67sX6 = parcelRequire("67sX6");

var $9OPlz = parcelRequire("9OPlz");


var $kOuTq = parcelRequire("kOuTq");
const $6b742bfb150e953b$export$8b35b75ab8090a99 = ({ onBulkChange: onBulkChange, isBulkChangeVisible: isBulkChangeVisible })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!isBulkChangeVisible) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6b742bfb150e953b$var$LabelWrapper, null, formatMessage((0, $kOuTq.default).bulkChange), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6b742bfb150e953b$var$IconWrapper, null, ((0, $4R6GH.fg)('enghealth-12479-jsw-board-visual-refresh'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ggICg))), {
                    LEGACY_size: "small",
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($17Ngn))),
                    LEGACY_primaryColor: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N800})`,
                    label: formatMessage((0, $kOuTq.default).bulkChangeIconLabel),
                    color: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N800})`
                })))),
            id: (0, $c96743ce387bce58$export$d8dbd75dd44821b),
            onClick: onBulkChange
        }
    ];
};
const $6b742bfb150e953b$export$5b8e045dd5a63047 = ({ isMultiSelectMode: isMultiSelectMode })=>{
    const selectedIssueKeys = (0, $67sX6.useBoardSelector)((0, $9OPlz.selectedIssueKeysSelector));
    const onBulkChange = ()=>{
        const url = `/secure/GHBulkChange.jspa?issueKeys=${encodeURIComponent(selectedIssueKeys.join(','))}`; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(url, '_blank');
    };
    return $6b742bfb150e953b$export$8b35b75ab8090a99({
        onBulkChange: onBulkChange,
        isBulkChangeVisible: isMultiSelectMode
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6b742bfb150e953b$var$LabelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _zulp1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6b742bfb150e953b$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _154iv77o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dlx3i", function(module, exports) {

$parcel$export(module.exports, "useChangeDateRange", () => $c2819c5f68a11a24$export$860b796192eb463e);

var $hGgHi = parcelRequire("hGgHi");

var $3spCR = parcelRequire("3spCR");

var $bwTbl = parcelRequire("bwTbl");

var $67sX6 = parcelRequire("67sX6");

var $5UXId = parcelRequire("5UXId");

var $fyeGd = parcelRequire("fyeGd");

var $vAfHD = parcelRequire("vAfHD");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $cPGP0 = parcelRequire("cPGP0");

var $2jlDO = parcelRequire("2jlDO");
const $c2819c5f68a11a24$export$860b796192eb463e = ({ issueId: issueId, selectedCardIds: selectedCardIds, isMultiSelectMode: isMultiSelectMode })=>{
    const allIssues = (0, $67sX6.useBoardSelector)((0, $vAfHD.boardIssuesSelector));
    const triggerIssue = allIssues[String(issueId)];
    const columns = (0, $67sX6.useBoardSelector)((0, $fyeGd.orderedColumnsSelector));
    const swimlaneMode = (0, $67sX6.useBoardSelector)((0, $45cXl.getSwimlaneMode));
    const swimlaneId = (0, $67sX6.useBoardSelector)((state)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(triggerIssue) ? (0, $bwTbl.getSwimlaneId)(swimlaneMode, (0, $4jZ56.getSwimlanes)(state), triggerIssue) : null);
    const teamSprintsForIterations = (0, $67sX6.useBoardSelector)((state)=>(0, $cPGP0.getTeamSprintsForIterations)(state, swimlaneId));
    let filteredColumns = isMultiSelectMode ? columns : columns.filter((column)=>column.id !== triggerIssue.columnId);
    if (teamSprintsForIterations !== null) /* if there are sprints associated with columns, we need an extra layer of filtering
            to remove closed sprints from the available options */ filteredColumns = filteredColumns.filter((column)=>teamSprintsForIterations[Number(column.id)]?.state !== (0, $3spCR.SPRINT_STATES).CLOSED);
    const onDateRangeChange = (0, $67sX6.useBoardActionCreator)((destinationColumn)=>(0, $5UXId.issueRankTeamDateRequest)({
            issueIds: selectedCardIds,
            sourceColumnId: triggerIssue.columnId,
            destinationColumnId: destinationColumn.id,
            rankBeforeIssueId: null,
            rankAfterIssueId: null,
            sourceSwimlaneId: swimlaneId,
            destinationSwimlaneId: swimlaneId
        }));
    return (0, $2jlDO.useChangeDateRangeContent)({
        onDateRangeChange: onDateRangeChange,
        columns: filteredColumns,
        teamSprintsForIterations: teamSprintsForIterations
    });
};

});
parcelRegister("2jlDO", function(module, exports) {

$parcel$export(module.exports, "useChangeDateRangeContent", () => $f59d5f2ddbf7c200$export$acdcc8c3b5267f9a);

var $ifg6x = parcelRequire("ifg6x");

var $5rFbt = parcelRequire("5rFbt");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");


var $kOuTq = parcelRequire("kOuTq");

var $l1G1t = parcelRequire("l1G1t");
const $f59d5f2ddbf7c200$export$acdcc8c3b5267f9a = ({ onDateRangeChange: onDateRangeChange, columns: columns, teamSprintsForIterations: teamSprintsForIterations })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [unplanned, planned] = (0, (/*@__PURE__*/$parcel$interopDefault($ifg6x)))(columns, (column)=>column.id === (0, $5rFbt.UNSCHEDULED_COLUMN_ID));
    const getLabelForDestinationColumn = (column)=>{
        const sprintForIterationName = teamSprintsForIterations?.[Number(column.id)]?.name;
        if (!sprintForIterationName) return formatMessage((0, $kOuTq.default).column, {
            columnName: column.name
        });
        return sprintForIterationName;
    };
    const scheduleActions = planned.map((column)=>({
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: `${0, $c96743ce387bce58$export$d36e4a2ba747e549}/${column.id}`,
            label: getLabelForDestinationColumn(column),
            onClick: ()=>onDateRangeChange(column)
        }));
    let unscheduleAction = [];
    if (unplanned.length > 0) unscheduleAction = [
        (0, $l1G1t.createSeparator)('unschedule-action'),
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: (0, $c96743ce387bce58$export$6d7ac6c2960a1ce6),
            label: formatMessage((0, $kOuTq.default).unscheduleIncrement),
            onClick: ()=>onDateRangeChange(unplanned[0])
        }
    ];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $kOuTq.default).moveTo),
            id: (0, $c96743ce387bce58$export$1435067cc5065f6a),
            children: [
                ...scheduleActions,
                ...unscheduleAction
            ]
        }
    ];
};

});
parcelRegister("l1G1t", function(module, exports) {

$parcel$export(module.exports, "createSeparator", () => $41b78e9fb023b9d3$export$2f446885d1462a2f);

var $gJBT6 = parcelRequire("gJBT6");

var $1HF4Y = parcelRequire("1HF4Y");

const $41b78e9fb023b9d3$export$2f446885d1462a2f = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((id)=>({
        id: `${0, $c96743ce387bce58$export$1fa1533b8d6efd51}/${id}`,
        type: (0, $1HF4Y.MenuNodeType).Separator
    }));

});



parcelRegister("jQS76", function(module, exports) {

$parcel$export(module.exports, "useChangeParent", () => $345fd96e65a4abbc$export$cdb4de092267a86b);

var $hGgHi = parcelRequire("hGgHi");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $67sX6 = parcelRequire("67sX6");

var $bZ9IJ = parcelRequire("bZ9IJ");

var $9OPlz = parcelRequire("9OPlz");

var $eDggU = parcelRequire("eDggU");

var $d2i8f = parcelRequire("d2i8f");


var $kOuTq = parcelRequire("kOuTq");
const $345fd96e65a4abbc$export$59801eb0ac139f86 = ({ onChangeParent: onChangeParent, isAssignParentVisible: isAssignParentVisible, isReassigning: isReassigning })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!isAssignParentVisible) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: isReassigning ? formatMessage((0, $kOuTq.default).changeIssueParent) : formatMessage((0, $kOuTq.default).addIssueParent),
            id: (0, $c96743ce387bce58$export$f823757fde5bc834),
            onClick: onChangeParent
        }
    ];
};
const $345fd96e65a4abbc$export$cdb4de092267a86b = ({ isMultiSelectMode: isMultiSelectMode, issueId: issueId, selectedCardIds: selectedCardIds })=>{
    const isSelected = (0, $67sX6.useBoardSelector)((0, $9OPlz.isCardSelected))(issueId);
    const selectedIds = isSelected ? selectedCardIds : [
        issueId
    ];
    const isReassigning = (0, $67sX6.useBoardSelector)((0, $d2i8f.isAssignedToIssueParent))(selectedIds);
    const issue = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIssueById)(state, issueId));
    const isAssignParentVisible = (0, $67sX6.useBoardSelector)((state)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue) && (0, $eDggU.isAssignIssueParentActionVisible)(state)(issue, isMultiSelectMode));
    const onChangeParent = (0, $67sX6.useBoardActionCreator)(()=>(0, $bZ9IJ.showAssignIssueParentModal)(selectedIds));
    return $345fd96e65a4abbc$export$59801eb0ac139f86({
        onChangeParent: onChangeParent,
        isAssignParentVisible: isAssignParentVisible,
        isReassigning: isReassigning
    });
};

});
parcelRegister("eDggU", function(module, exports) {

$parcel$export(module.exports, "isAssignIssueParentModalOpen", () => $ce18a23f10981df7$export$964aa9f8b115dff5);
$parcel$export(module.exports, "getSelectedIssues", () => $ce18a23f10981df7$export$5e52d79ee962d3c1);
$parcel$export(module.exports, "isAssignIssueParentActionVisible", () => $ce18a23f10981df7$export$743083fb6d05b9ac);
$parcel$export(module.exports, "areSelectedIssuesSubtasksSelector", () => $ce18a23f10981df7$export$52994f7db52fcd73);
$parcel$export(module.exports, "issueHierarchyLevelSelector", () => $ce18a23f10981df7$export$877c3c60e0259f4b);
$parcel$export(module.exports, "parentIssueLevelNameSelector", () => $ce18a23f10981df7$export$b217594d8e40ead5);
$parcel$export(module.exports, "getIssueParentsForReparentModal", () => $ce18a23f10981df7$export$1fbde0645e5442db);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $hGgHi = parcelRequire("hGgHi");


var $iuuJH = parcelRequire("iuuJH");

var $9OPlz = parcelRequire("9OPlz");

var $3UY9S = parcelRequire("3UY9S");

var $bSSdD = parcelRequire("bSSdD");

var $4gt6L = parcelRequire("4gt6L");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $vAfHD = parcelRequire("vAfHD");
const $ce18a23f10981df7$export$964aa9f8b115dff5 = (state)=>Boolean((0, $67Z81.getUi)(state).assignIssueParentModal?.isOpen);
const $ce18a23f10981df7$export$92346131cbbbfbec = (state)=>(0, $67Z81.getUi)(state).assignIssueParentModal?.issueIds ?? [];
const $ce18a23f10981df7$export$5e52d79ee962d3c1 = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $vAfHD.boardIssuesAndChildrenSelector),
    $ce18a23f10981df7$export$92346131cbbbfbec
], (boardIssues, boardIssuesAndChildren, selectedIssueIds)=>{
    if (selectedIssueIds) return selectedIssueIds.filter((id)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(boardIssuesAndChildren[id])).map((id)=>({
            id: boardIssuesAndChildren[id].id,
            key: boardIssuesAndChildren[id].key,
            parentId: boardIssuesAndChildren[id].parentId,
            projectId: boardIssuesAndChildren[id].projectId
        }));
    return (0, $7uUwQ.freeze)([]);
});
const $ce18a23f10981df7$export$23405beefba8b9e = (levelIssueTypeIds, typeIds)=>typeIds.every((typeId)=>levelIssueTypeIds.includes(String(typeId)));
const $ce18a23f10981df7$export$743083fb6d05b9ac = (0, $dGvGJ.createSelector)([
    (0, $9OPlz.getVisibleCardSelection),
    (0, $vAfHD.boardIssuesSelector),
    (0, $4gt6L.issueTypeIdsSelector),
    (0, $4gt6L.issueChildrenTypeIdsSelector),
    (0, $bSSdD.issueParentsSelector),
    (0, $67Z81.getIsCMPBoard),
    (0, $67Z81.getIsIncrementPlanningBoard)
], (visibleSelectedCards, boardIssues, baseIssueTypes, childrenIssueTypes, issueParents, isCMPBoard, isIncrementPlanningBoard)=>(issue, isMultiSelect)=>{
        const issueParentsPresent = issueParents.length > 0;
        const selectedCards = visibleSelectedCards;
        if (isCMPBoard && isMultiSelect) // Changing parent for cards in bulk is not supported yet in CMP projects
        return false;
        if ((isCMPBoard || isIncrementPlanningBoard) && issueParents.find((issueParent)=>issueParent.id === issue.id)) // This issue is already an issue parent (Epic). It doesn't support Add Parent feature
        return false;
        if (isIncrementPlanningBoard && isMultiSelect && selectedCards.some((id)=>issueParents.find((issueParent)=>issueParent.id === id))) // The increment planning board doesn't support Add Parent if any issue parent is included in the selection
        return false;
        if (!isMultiSelect) return baseIssueTypes.includes(String(issue.typeId)) ? issueParentsPresent : true;
        const typeIds = selectedCards.map((issueId)=>boardIssues[String(issueId)].typeId);
        return $ce18a23f10981df7$export$23405beefba8b9e(baseIssueTypes, typeIds) ? issueParentsPresent : $ce18a23f10981df7$export$23405beefba8b9e(childrenIssueTypes, typeIds);
    });
const $ce18a23f10981df7$export$52994f7db52fcd73 = (0, $dGvGJ.createSelector)([
    $ce18a23f10981df7$export$92346131cbbbfbec,
    (0, $3UY9S.getIssueChildren)
], (selectedIssueIds, issueChildren)=>selectedIssueIds && selectedIssueIds.length > 0 && selectedIssueIds.every((issueId)=>issueChildren[issueId]));
const $ce18a23f10981df7$export$877c3c60e0259f4b = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    $ce18a23f10981df7$export$52994f7db52fcd73,
    (0, $67Z81.getIsCMPBoard)
], (swimlaneMode, areSelectedIssuesSubtasks, isCMPBoard)=>{
    if (isCMPBoard && areSelectedIssuesSubtasks) return -1;
    // when you switch swimlanes and nothing is selected we still want the issueHierarchyLevel for ICC
    if (areSelectedIssuesSubtasks === undefined) return swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id ? -1 : 0;
    return swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && areSelectedIssuesSubtasks ? -1 : 0;
});
const $ce18a23f10981df7$export$b217594d8e40ead5 = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    $ce18a23f10981df7$export$52994f7db52fcd73,
    (0, $bSSdD.firstParentIssueTypeNameSelector),
    (0, $67Z81.getIsCMPBoard)
], (swimlaneMode, areSelectedIssuesSubtasks, firstParentIssueTypeName, isCMPBoard)=>{
    if (areSelectedIssuesSubtasks && (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id || isCMPBoard)) return 0, $dcbb2bce513725b3$export$d29cf9c8492f955d;
    return firstParentIssueTypeName;
});
const $ce18a23f10981df7$var$getNormalizedIssueType = (id, name, iconUrl)=>({
        id: id,
        name: name || '',
        iconUrl: iconUrl || ''
    });
const $ce18a23f10981df7$export$1fbde0645e5442db = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    (0, $bSSdD.issueParentsSelector),
    (0, $67Z81.getIssues),
    (0, $67Z81.getIssueProjects),
    $ce18a23f10981df7$export$5e52d79ee962d3c1,
    $ce18a23f10981df7$export$52994f7db52fcd73,
    (0, $67Z81.getIsCMPBoard),
    (0, $67Z81.getIsIncrementPlanningBoard)
], (swimlaneMode, issueParents, issues, projects, selectedIssues, areSelectedIssuesSubtasks, isCMPBoard, isIncrementPlanningBoard)=>{
    if (areSelectedIssuesSubtasks && (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id || isCMPBoard)) {
        // return base issues excluding epics as available parents for subtasks
        const issueParentKeys = issueParents.map((parent)=>parent.id.toString());
        return Object.keys(issues).filter((key)=>!issueParentKeys.includes(key)).map((key)=>issues[key]).map(({ id: id, summary: summary, key: key, typeId: typeId, typeName: typeName, typeUrl: typeUrl })=>({
                id: id,
                summary: summary,
                key: key,
                issueType: $ce18a23f10981df7$var$getNormalizedIssueType(typeId, typeName, typeUrl)
            }));
    }
    let filteredIssueParents = issueParents;
    if (isIncrementPlanningBoard) {
        const selectedProjects = selectedIssues.map((issue)=>issue.projectId ? projects[issue.projectId] : null);
        const selectedTmpProjects = selectedProjects.filter((project)=>project && !project.isCMP);
        const hasCmpProjectSelected = selectedProjects.some((project)=>project && project.isCMP);
        if (selectedTmpProjects.length > 0 && hasCmpProjectSelected || selectedTmpProjects.length > 1) // Return empty if there are mixed TMP and CMP issues selected or mixed TMP projects issues selected
        filteredIssueParents = [];
        else if (selectedTmpProjects.length === 1) // If there's only 1 TMP project on selected issues, filter the issue parents to be in the same project
        filteredIssueParents = issueParents.filter((parent)=>parent.projectId === selectedTmpProjects[0]?.id);
        else // Filter issue parents to be in CMP project
        filteredIssueParents = issueParents.filter((parent)=>{
            const parentProject = parent.projectId ? projects[parent.projectId] : null;
            return parentProject && parentProject.isCMP;
        });
    }
    return filteredIssueParents.map(({ id: id, summary: summary, key: key, issueType: issueType, projectId: projectId })=>({
            id: id,
            summary: summary,
            key: key,
            projectId: projectId,
            issueType: {
                id: parseInt(issueType.id, 10),
                name: issueType.name,
                iconUrl: issueType.iconUrl
            }
        }));
});

});


parcelRegister("7RDtv", function(module, exports) {

$parcel$export(module.exports, "useChangeTeam", () => $4e2dd0472a59c365$export$95c8804dc6557b12);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $lLtod = parcelRequire("lLtod");

var $c781K = parcelRequire("c781K");

var $h8cgU = parcelRequire("h8cgU");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $4jAPy = parcelRequire("4jAPy");

var $1HF4Y = parcelRequire("1HF4Y");

var $gu244 = parcelRequire("gu244");

var $bwTbl = parcelRequire("bwTbl");

var $67sX6 = parcelRequire("67sX6");

var $3vq48 = parcelRequire("3vq48");

var $vAfHD = parcelRequire("vAfHD");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");


var $kOuTq = parcelRequire("kOuTq");

var $9d0c4 = parcelRequire("9d0c4");
const $4e2dd0472a59c365$var$getTeamIcon = (imageUrl, name)=>{
    if (imageUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLtod.default), {
        size: "small",
        src: imageUrl,
        name: (0, $4R6GH.fg)('ip_remove_aria_labels_for_decorative_images') ? undefined : name || ''
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e2dd0472a59c365$var$PeopleIconWrapper, null, (0, $4R6GH.fg)('enghealth-12479-jsw-board-visual-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c781K))), {
        label: (0, $4R6GH.fg)('ip_remove_aria_labels_for_decorative_images') ? '' : name || '',
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($h8cgU))),
        LEGACY_size: "small",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h8cgU))), {
        label: name || '',
        size: "small"
    }));
};
const $4e2dd0472a59c365$export$95c8804dc6557b12 = ({ issueId: issueId, selectedCardIds: selectedCardIds })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const allIssues = (0, $67sX6.useBoardSelector)((0, $vAfHD.boardIssuesSelector));
    const triggerIssue = allIssues[String(issueId)];
    const swimlaneMode = (0, $67sX6.useBoardSelector)((0, $45cXl.getSwimlaneMode));
    const swimlaneId = (0, $67sX6.useBoardSelector)((state)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(triggerIssue) ? (0, $bwTbl.getSwimlaneId)(swimlaneMode, (0, $4jZ56.getSwimlanes)(state), triggerIssue) : null);
    const teams = Object.values((0, $67sX6.useBoardSelector)((0, $67Z81.getTeams))).filter(({ isPlanTeam: isPlanTeam, id: id })=>id !== swimlaneId && isPlanTeam);
    const options = teams.map((team)=>({
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: team.name,
            id: `${0, $c96743ce387bce58$export$e51c7bc6816555b2}/${team.id}`,
            onClick: ()=>onChangeTeam(team),
            icon: $4e2dd0472a59c365$var$getTeamIcon(team.avatarUrl, team.name)
        }));
    const unassignOption = {
        type: (0, $1HF4Y.MenuNodeType).Item,
        label: formatMessage((0, $kOuTq.default).unassign),
        id: (0, $c96743ce387bce58$export$aea369fa6803ebd),
        onClick: ()=>onChangeTeam()
    };
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(triggerIssue.teamId)) options.unshift(unassignOption);
     // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const transformOptionToString = ({ label: label })=>label;
    const [filteredOptions, updateFilter] = (0, $gu244.useTextFilter)(options, transformOptionToString);
    const onChangeTeam = (0, $67sX6.useBoardActionCreator)((destinationTeam)=>(0, $3vq48.issueChangeTeamRequest)({
            issueIds: selectedCardIds,
            sourceColumnId: triggerIssue.columnId,
            destinationColumnId: triggerIssue.columnId,
            rankBeforeIssueId: null,
            rankAfterIssueId: null,
            sourceSwimlaneId: swimlaneId,
            destinationSwimlaneId: destinationTeam === undefined ? (0, $4jAPy.SWIMLANE_TEAMLESS) : destinationTeam.id
        }));
    return (0, $9d0c4.useChangeTeamContent)({
        setQuery: updateFilter,
        options: filteredOptions
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e2dd0472a59c365$var$PeopleIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _1yt4u49m _bfhklecj _18s81nxw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h8cgU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c78cb3eb85357720$var$_react = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c78cb3eb85357720$var$_peopleGroup = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("fptva")));
function $c78cb3eb85357720$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c78cb3eb85357720$var$PeopleIcon = (props)=>/*#__PURE__*/ $c78cb3eb85357720$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props, {
        newIcon: $c78cb3eb85357720$var$_peopleGroup.default
    }));
$c78cb3eb85357720$var$PeopleIcon.displayName = 'PeopleIcon';
var $c78cb3eb85357720$var$_default = module.exports.default = $c78cb3eb85357720$var$PeopleIcon;

});

parcelRegister("gu244", function(module, exports) {

$parcel$export(module.exports, "useTextFilter", () => $5d5db767318aa751$export$de949492119ddd44);

var $5uXOq = parcelRequire("5uXOq");
const $5d5db767318aa751$var$removeAccents = (text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const $5d5db767318aa751$var$doesStringContainText = (itemString, text)=>itemString.toLowerCase().includes(text.toLowerCase()) || $5d5db767318aa751$var$removeAccents(itemString).toLowerCase().includes(text.toLowerCase());
const $5d5db767318aa751$export$de949492119ddd44 = (items, itemToStringTransformer, defaultFilterValue = '')=>{
    const [filterValue, setFilterValue] = (0, $5uXOq.useState)(defaultFilterValue);
    const filteredItems = (0, $5uXOq.useMemo)(()=>{
        if (!filterValue) return items;
        return items.filter((item)=>$5d5db767318aa751$var$doesStringContainText(itemToStringTransformer(item), filterValue));
    }, [
        filterValue,
        itemToStringTransformer,
        items
    ]);
    return [
        filteredItems,
        setFilterValue
    ];
};

});

parcelRegister("9d0c4", function(module, exports) {

$parcel$export(module.exports, "useChangeTeamContent", () => $95b9b47ef814f894$export$d4383f748ea8e1c4);

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");


var $kOuTq = parcelRequire("kOuTq");
const $95b9b47ef814f894$export$d4383f748ea8e1c4 = ({ setQuery: setQuery, options: options })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const subMenu = [
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            type: (0, $1HF4Y.MenuNodeType).Search,
            id: (0, $c96743ce387bce58$export$9c672767be29c0ac),
            children: options,
            hasSearch: true,
            isLoading: false,
            onChange: setQuery
        }
    ];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $kOuTq.default).changeTeam),
            id: (0, $c96743ce387bce58$export$e51c7bc6816555b2),
            submenuWidth: 284,
            children: subMenu
        }
    ];
};

});


parcelRegister("4HOBK", function(module, exports) {

$parcel$export(module.exports, "useCopyIssueKey", () => $aa01723f1053ec90$export$e5e3fbcc29675793);

var $6s1PB = parcelRequire("6s1PB");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");


var $3h2Of = parcelRequire("3h2Of");
const $aa01723f1053ec90$var$copySuccessfulFlagConfiguration = {
    type: 'success',
    title: (0, $3h2Of.default).copySuccessTitle,
    description: (0, $3h2Of.default).copySuccessMessage
};
const $aa01723f1053ec90$var$copySuccessfulFlagConfigurationIssueTermRefresh = {
    type: 'success',
    title: (0, $3h2Of.default).copySuccessTitleIssueTermRefresh,
    description: (0, $3h2Of.default).copySuccessMessageIssueTermRefresh
};
const $aa01723f1053ec90$var$copyFailureFlagConfiguration = {
    type: 'error',
    title: (0, $3h2Of.default).copyFailureTitle,
    description: (0, $3h2Of.default).copyFailureMessage
};
const $aa01723f1053ec90$var$copyFailureFlagConfigurationIssueTermRefresh = {
    type: 'error',
    title: (0, $3h2Of.default).copyFailureTitleIssueTermRefresh,
    description: (0, $3h2Of.default).copyFailureMessage
};
const $aa01723f1053ec90$export$41456a7ac047c934 = ({ isCopyKeyVisible: isCopyKeyVisible, onCopyIssueKey: onCopyIssueKey })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!isCopyKeyVisible) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3h2Of.default).copyIssueKeyIssueTermRefresh : (0, $3h2Of.default).copyIssueKey),
            id: (0, $c96743ce387bce58$export$2e74ac183d49087),
            onClick: onCopyIssueKey
        }
    ];
};
const $aa01723f1053ec90$export$e5e3fbcc29675793 = ({ isMultiSelectMode: isMultiSelectMode, issueKey: issueKey })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const onCopyIssueKey = async ()=>{
        try {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            await navigator.clipboard.writeText(issueKey);
            showFlag((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? $aa01723f1053ec90$var$copySuccessfulFlagConfigurationIssueTermRefresh : $aa01723f1053ec90$var$copySuccessfulFlagConfiguration);
        } catch (err) {
            showFlag((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? $aa01723f1053ec90$var$copyFailureFlagConfigurationIssueTermRefresh : $aa01723f1053ec90$var$copyFailureFlagConfiguration);
        }
    };
    return $aa01723f1053ec90$export$41456a7ac047c934({
        isCopyKeyVisible: !isMultiSelectMode,
        onCopyIssueKey: onCopyIssueKey
    });
};

});
parcelRegister("3h2Of", function(module, exports) {

$parcel$export(module.exports, "default", () => $07026daa28aaeca8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $07026daa28aaeca8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    copyIssueKey: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-issue-key",
        "defaultMessage": "Copy issue key"
    },
    copySuccessTitle: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-success-title",
        "defaultMessage": "Issue key copied"
    },
    copySuccessMessage: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-success-message",
        "defaultMessage": "You\u2019ve copied the issue key to your clipboard."
    },
    copyFailureTitle: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-failure-title",
        "defaultMessage": "We couldn\u2019t copy the issue key"
    },
    copyFailureMessage: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-failure-message",
        "defaultMessage": "Refresh the page or check your browser settings, then try again."
    },
    copyIssueKeyIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-issue-key-issue-term-refresh",
        "defaultMessage": "Copy issue key"
    },
    copySuccessTitleIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-success-title-issue-term-refresh",
        "defaultMessage": "Issue key copied"
    },
    copySuccessMessageIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-success-message-issue-term-refresh",
        "defaultMessage": "You\u2019ve copied the issue key to your clipboard."
    },
    copyFailureTitleIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-failure-title-issue-term-refresh",
        "defaultMessage": "We couldn\u2019t copy the issue key"
    }
});

});


parcelRegister("8cT3J", function(module, exports) {

$parcel$export(module.exports, "useCopyIssueLink", () => $7fc75373cb7684a8$export$8fa8485fafd17cef);

var $6s1PB = parcelRequire("6s1PB");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");


var $93IFw = parcelRequire("93IFw");
const $7fc75373cb7684a8$var$copySuccessfulFlagConfiguration = {
    type: 'success',
    title: (0, $93IFw.default).copySuccessTitle,
    description: (0, $93IFw.default).copySuccessMessage
};
const $7fc75373cb7684a8$var$copyFailureFlagConfiguration = {
    type: 'error',
    title: (0, $93IFw.default).copyFailureTitle,
    description: (0, $93IFw.default).copyFailureMessage
};
const $7fc75373cb7684a8$var$copySuccessfulFlagConfigurationIssueTerminologyRefresh = {
    type: 'success',
    title: (0, $93IFw.default).copySuccessTitleIssueTermRefresh,
    description: (0, $93IFw.default).copySuccessMessageIssueTermRefresh
};
const $7fc75373cb7684a8$var$copyFailureFlagConfigurationIssueTerminologyRefresh = {
    type: 'error',
    title: (0, $93IFw.default).copyFailureTitleIssueTermRefresh,
    description: (0, $93IFw.default).copyFailureMessage
};
const $7fc75373cb7684a8$export$30a9fe39fb33160d = ({ isCopyLinkVisible: isCopyLinkVisible, onCopyIssueLink: onCopyIssueLink })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!isCopyLinkVisible) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $93IFw.default).copyIssueLinkIssueTermRefresh : (0, $93IFw.default).copyIssueLink),
            id: (0, $c96743ce387bce58$export$34b38d58090a7162),
            onClick: onCopyIssueLink
        }
    ];
};
const $7fc75373cb7684a8$export$8fa8485fafd17cef = ({ isMultiSelectMode: isMultiSelectMode, issueKey: issueKey })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const onCopyIssueLink = async ()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const issueUrl = `${window.location.protocol}//${window.location.hostname}/browse/${issueKey}`;
        try {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            await navigator.clipboard.writeText(issueUrl);
            showFlag((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? $7fc75373cb7684a8$var$copySuccessfulFlagConfigurationIssueTerminologyRefresh : $7fc75373cb7684a8$var$copySuccessfulFlagConfiguration);
        } catch (err) {
            showFlag((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? $7fc75373cb7684a8$var$copyFailureFlagConfigurationIssueTerminologyRefresh : $7fc75373cb7684a8$var$copyFailureFlagConfiguration);
        }
    };
    return $7fc75373cb7684a8$export$30a9fe39fb33160d({
        isCopyLinkVisible: !isMultiSelectMode,
        onCopyIssueLink: onCopyIssueLink
    });
};

});
parcelRegister("93IFw", function(module, exports) {

$parcel$export(module.exports, "default", () => $312d8d1deb5e8415$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $312d8d1deb5e8415$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    copyIssueLink: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-issue-link",
        "defaultMessage": "Copy issue link"
    },
    copySuccessTitle: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-success-title",
        "defaultMessage": "Issue link copied"
    },
    copySuccessMessage: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-success-message",
        "defaultMessage": "You\u2019ve copied the issue link to your clipboard."
    },
    copyFailureTitle: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-failure-title",
        "defaultMessage": "We couldn\u2019t copy the issue link"
    },
    copyFailureMessage: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-failure-message",
        "defaultMessage": "Refresh the page or check your browser settings, then try again."
    },
    copyIssueLinkIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-issue-link-issue-term-refresh",
        "defaultMessage": "Copy issue link"
    },
    copySuccessTitleIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-success-title-issue-term-refresh",
        "defaultMessage": "Issue link copied"
    },
    copySuccessMessageIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-success-message-issue-term-refresh",
        "defaultMessage": "You\u2019ve copied the issue link to your clipboard."
    },
    copyFailureTitleIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-failure-title-issue-term-refresh",
        "defaultMessage": "We couldn\u2019t copy the issue link"
    }
});

});


parcelRegister("2Ogtn", function(module, exports) {

$parcel$export(module.exports, "useDeleteIssue", () => $2e9e341917d07813$export$43383fdc9fe04fe6);

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");


var $67sX6 = parcelRequire("67sX6");

var $5s6yC = parcelRequire("5s6yC");

var $1vXOx = parcelRequire("1vXOx");

var $fyeGd = parcelRequire("fyeGd");

var $d2i8f = parcelRequire("d2i8f");


var $kOuTq = parcelRequire("kOuTq");
const $2e9e341917d07813$export$33577be3a49c7499 = ({ isDeleteEnabled: isDeleteEnabled, onDeleteIssue: onDeleteIssue })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!isDeleteEnabled) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $kOuTq.default).delete),
            id: (0, $c96743ce387bce58$export$b35363b92f22bb89),
            onClick: onDeleteIssue
        }
    ];
};
const $2e9e341917d07813$export$43383fdc9fe04fe6 = ({ issueId: issueId, isMultiSelectMode: isMultiSelectMode })=>{
    const canDelete = (0, $67sX6.useBoardSelector)((0, $1vXOx.getPermissionsSelector))[0, $e525e6c25695c9df$export$d4845393d78ba468];
    const issue = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIssueById)(state, issueId));
    const columnIndex = (0, $67sX6.useBoardSelector)((state)=>(0, $fyeGd.getColumnIndex)(state, issue?.columnId));
    const onDeleteIssue = (0, $67sX6.useBoardActionCreator)(()=>(0, $5s6yC.issueDeleteModalOpen)(issueId, columnIndex));
    return $2e9e341917d07813$export$33577be3a49c7499({
        isDeleteEnabled: canDelete && !isMultiSelectMode,
        onDeleteIssue: onDeleteIssue
    });
};

});

parcelRegister("cMdeq", function(module, exports) {

$parcel$export(module.exports, "useEditCover", () => $b98301b87d0ea8f6$export$3ad2d6a068dd2f0e);

var $5uXOq = parcelRequire("5uXOq");

var $lj8SI = parcelRequire("lj8SI");

var $f5TWP = parcelRequire("f5TWP");

var $lJDxW = parcelRequire("lJDxW");

var $4yhWy = parcelRequire("4yhWy");

var $i5L4N = parcelRequire("i5L4N");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6MyIZ = parcelRequire("6MyIZ");

var $1HF4Y = parcelRequire("1HF4Y");

var $ewaBk = parcelRequire("ewaBk");

var $a4XJc = parcelRequire("a4XJc");

var $iDGXn = parcelRequire("iDGXn");

var $koeKL = parcelRequire("koeKL");


var $67sX6 = parcelRequire("67sX6");

var $2f454 = parcelRequire("2f454");

var $3n582 = parcelRequire("3n582");

var $67Z81 = parcelRequire("67Z81");


var $g9agn = parcelRequire("g9agn");

var $4mdFU = parcelRequire("4mdFU");
const $b98301b87d0ea8f6$export$58bbde0bd11b3269 = 900;
const $b98301b87d0ea8f6$export$c9056a07d77f30a8 = 65534;
const $b98301b87d0ea8f6$export$ea4bdeb9cc3af63d = 364;
const $b98301b87d0ea8f6$export$404b00ceb08967bc = /*#__PURE__*/ (0, $5uXOq.memo)(({ showNewLozenge: showNewLozenge })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.100"
    }, formatMessage((0, $4mdFU.default).editCover), showNewLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: "new"
    }, formatMessage((0, $4mdFU.default).newLozenge)));
});
const $b98301b87d0ea8f6$export$be56acfbf0fe3cb2 = /*#__PURE__*/ (0, $5uXOq.memo)(({ entryPointReferenceSubject: entryPointReferenceSubject, scope: scope, onUpdated: onUpdated, onAttachmentSuccess: onAttachmentSuccess })=>{
    const { closeSubMenu: closeSubMenu } = (0, $ewaBk.useContextMenuActions)();
    const onClose = (0, $5uXOq.useCallback)(()=>closeSubMenu(scope), [
        closeSubMenu,
        scope
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            durationInSeconds: $b98301b87d0ea8f6$export$58bbde0bd11b3269,
            maxTokenLength: $b98301b87d0ea8f6$export$c9056a07d77f30a8,
            onClose: onClose,
            onUpdated: onUpdated,
            onAttachmentSuccess: onAttachmentSuccess
        }), [
        onClose,
        onUpdated,
        onAttachmentSuccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira.board.context-menu.card-covers.popover",
        packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i5L4N.CardCoverSkeleton), null),
        errorFallback: "flag",
        runtimeProps: runtimeProps
    });
});
const $b98301b87d0ea8f6$export$619791f8b7ad4665 = ({ showNewLozenge: showNewLozenge, entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions, onUpdated: onUpdated, onAttachmentSuccess: onAttachmentSuccess })=>[
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: (0, $c96743ce387bce58$export$2e6bc5997111e31f),
            label: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b98301b87d0ea8f6$export$404b00ceb08967bc, {
                    showNewLozenge: showNewLozenge
                }),
            submenuWidth: $b98301b87d0ea8f6$export$ea4bdeb9cc3af63d,
            onMouseEnter: entryPointActions.preload,
            children: [
                {
                    type: (0, $1HF4Y.MenuNodeType).Node,
                    id: `${(0, $c96743ce387bce58$export$2e6bc5997111e31f)}/popover`,
                    node: ({ scope: scope })=>{
                        entryPointActions.load();
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b98301b87d0ea8f6$export$be56acfbf0fe3cb2, {
                            entryPointReferenceSubject: entryPointReferenceSubject,
                            scope: scope,
                            onUpdated: onUpdated,
                            onAttachmentSuccess: onAttachmentSuccess
                        });
                    }
                }
            ],
            analytics: {
                attributes: {
                    selectedOption: (0, $c96743ce387bce58$export$2e6bc5997111e31f)
                }
            }
        }
    ];
const $b98301b87d0ea8f6$export$3ad2d6a068dd2f0e = ({ issueId: issueId })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            durationInSeconds: $b98301b87d0ea8f6$export$58bbde0bd11b3269,
            maxTokenLength: $b98301b87d0ea8f6$export$c9056a07d77f30a8,
            issueId: (0, $lJDxW.JiraIssueAri).create({
                issueId: String(issueId),
                siteId: cloudId
            }).toString()
        }), [
        cloudId,
        issueId
    ]);
    // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $4yhWy.cardCoverManagerEntryPoint), entryPointParams);
    const [state, actions] = (0, $iDGXn.useViewSettings)();
    const { showCardCovers: showCardCovers } = state;
    const { setViewSettingsShowCardCovers: setViewSettingsShowCardCovers } = actions;
    const boardId = (0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6MyIZ.useAnalyticsEvents)();
    const setCardCoverAction = (0, $67sX6.useBoardActionCreator)((0, $2f454.cardMediaDataSet));
    const fetchCardCoversAction = (0, $67sX6.useBoardActionCreator)(()=>(0, $3n582.fetchCardCovers)([], {
            analyticsEvent: createAnalyticsEvent({})
        }));
    const showCardCoversRef = (0, $5uXOq.useRef)(showCardCovers);
    (0, $5uXOq.useEffect)(()=>{
        if (!showCardCoversRef.current && showCardCovers) // start fetching card cover data if the user turned on toggle
        fetchCardCoversAction();
        showCardCoversRef.current = showCardCovers;
    }, [
        showCardCovers,
        fetchCardCoversAction
    ]);
    const onUpdated = (coverMedia)=>{
        // update the stored card cover data for the issue that has been updated
        setCardCoverAction((0, $g9agn.transformCardCoverPopoverData)(coverMedia, String(issueId)));
    };
    const onAttachmentSuccess = ()=>{
        setViewSettingsShowCardCovers({
            boardId: Number(boardId),
            view: (0, $a4XJc.View).BOARD,
            showCardCovers: true
        });
    };
    return $b98301b87d0ea8f6$export$619791f8b7ad4665({
        showNewLozenge: (0, $4R6GH.fg)('jsw_cmp_card_covers_changeboarding'),
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        onUpdated: onUpdated,
        onAttachmentSuccess: onAttachmentSuccess
    });
};

});
parcelRegister("lJDxW", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAri", () => $fd2c7a05de251f83$export$1da6808e89ee03e);

var $bQ5aj = parcelRequire("bQ5aj");

var $fe7YR = parcelRequire("fe7YR");

var $224I1 = parcelRequire("224I1");
// src/jira/issue/manifest.ts
var $fd2c7a05de251f83$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $bQ5aj.JiraIssueAriResourceOwner),
    resourceType: (0, $bQ5aj.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $fd2c7a05de251f83$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $fe7YR.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $fd2c7a05de251f83$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $fd2c7a05de251f83$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $fd2c7a05de251f83$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $fd2c7a05de251f83$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $224I1.AriParser).fromOpts(derivedOpts, $fd2c7a05de251f83$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $224I1.AriParser).fromString(maybeAri, $fd2c7a05de251f83$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
};

});
parcelRegister("bQ5aj", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAriResourceOwner", () => $89e88ec215209f61$export$665a39f1b4e29e0a);
$parcel$export(module.exports, "JiraIssueAriResourceType", () => $89e88ec215209f61$export$76beb4d0da177ad4);
// src/jira/issue/types.ts
var $89e88ec215209f61$export$665a39f1b4e29e0a = "jira", $89e88ec215209f61$export$76beb4d0da177ad4 = "issue";

});


parcelRegister("4yhWy", function(module, exports) {

$parcel$export(module.exports, "cardCoverManagerEntryPoint", () => $49e978a3baf35b00$export$1bdd83c991cbfdc5);

var $3Ke8J = parcelRequire("3Ke8J");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $49e978a3baf35b00$export$1bdd83c991cbfdc5 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("bIhLH")).then((module)=>module.CardCoverManagerWithAnalyticsContext), {
        moduleId: "d44881bb",
        moduleName: "CardCoverManager"
    }),
    getPreloadProps: ({ cloudId: cloudId, issueId: issueId, durationInSeconds: durationInSeconds, maxTokenLength: maxTokenLength })=>({
            queries: {
                cardCoverManagerQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $3Ke8J.default),
                    variables: {
                        cloudId: cloudId,
                        issueId: issueId,
                        durationInSeconds: durationInSeconds,
                        maxTokenLength: maxTokenLength
                    }
                }
            }
        })
});

});
parcelRegister("3Ke8J", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e3967e552f45b17$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<418bda9720e122cfda1797cb611cf2dc>>
 * @relayHash b389da800a338761731ddd5b921c6b06
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6bc51194f353e74e01f5f4c7ebe3e05caf5a8fd91087cf93d55195051e742ceb
const $4e3967e552f45b17$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6bc51194f353e74e01f5f4c7ebe3e05caf5a8fd91087cf93d55195051e742ceb",
        "metadata": {},
        "name": "CardCoverManagerQuery",
        "operationKind": "query",
        "text": null
    }
};
var $4e3967e552f45b17$export$2e2bcd8739ae039 = $4e3967e552f45b17$var$node;

});

parcelRegister("bIhLH", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("aTlMX").then(()=>parcelRequire('2ImW2'));

});


parcelRegister("i5L4N", function(module, exports) {

$parcel$export(module.exports, "CardCoverSkeleton", () => $4d867edefedb5a1c$export$50810a0aaf8b3a16);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");
const $4d867edefedb5a1c$export$50810a0aaf8b3a16 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockStart: "space.100",
        paddingBlockEnd: "space.100",
        xcss: $4d867edefedb5a1c$var$skeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $4d867edefedb5a1c$var$skeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium"
    })));
const $4d867edefedb5a1c$var$skeletonStyles = (0, $8CUq3.xcss)({
    width: '366px',
    height: '300px'
});

});

parcelRegister("6MyIZ", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $4907e27f6a484433$export$5bf35293e545f20c);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");

const $4907e27f6a484433$var$AnalyticsContext = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
const $4907e27f6a484433$export$198470770171c65 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const data = (0, $iXVV6.extractContextualData)(props);
    // @ts-expect-error - TS2741 - Property 'children' is missing in type 'Dictionary<string | string[] | { [containerName: string]: Container; } | { [key: string]: any; } | undefined>' but required in type 'AnalyticsContextData'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4907e27f6a484433$var$AnalyticsContext, {
        data: data
    }, props.children);
});
const $4907e27f6a484433$export$64eb47d7b94ba089 = ()=>null;
const $4907e27f6a484433$export$5a67e7291fd4569e = (_props)=>null;
const $4907e27f6a484433$export$5f0d7aae8dfa8b86 = (_props)=>null;
const $4907e27f6a484433$export$b71c3ada5d4ec5da = (_props)=>null;
const $4907e27f6a484433$export$2ccf161b817b43b = (_props)=>null;
const $4907e27f6a484433$export$34ac71ce24cddec2 = (_event, _type, _payload = {})=>undefined;
const $4907e27f6a484433$export$79f423cc3fd39762 = (_event, ..._rest)=>undefined;
const $4907e27f6a484433$export$6bb7ef8f82969e8f = (_event, ..._rest)=>undefined;
const $4907e27f6a484433$export$6f46fb37ad7d962b = (_event, _attributes)=>undefined;
const $4907e27f6a484433$export$59b89d5a711a4fa = (_event, _attributes)=>undefined;
const $4907e27f6a484433$export$13990ad4625571ed = (_event, ..._rest)=>undefined;
const $4907e27f6a484433$export$b6c00a2e59d74c5e = (_event, ..._rest)=>undefined;
const $4907e27f6a484433$export$5d00cd31b1bf8e94 = (_event, ..._rest)=>undefined;
const $4907e27f6a484433$export$ee2085e97a04e027 = (_event)=>({
        type: undefined,
        payload: {}
    });
class $4907e27f6a484433$var$UIAnalyticsEventServer {
    constructor(){
        this.payload = {};
        this.context = [];
        this.handlers = [];
        this.hasFired = false;
        // @ts-expect-error TS2554: Expected 1 arguments, but got 0.
        this.clone = ()=>new $4907e27f6a484433$var$UIAnalyticsEventServer();
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.fire = (_channel)=>{};
        // @ts-expect-error TS2416: Property 'update' in type 'UIAnalyticsEventServer' is not assignable to the same property in base type 'UIAnalyticsEvent'. Type 'UIAnalyticsEventServer' is not assignable to type 'this'. 'UIAnalyticsEventServer' is assignable to the constraint of type 'this', but 'this' could be instantiated with a different subtype of constraint 'UIAnalyticsEventServer'.
        this.update = ()=>new $4907e27f6a484433$var$UIAnalyticsEventServer();
    }
}
const $4907e27f6a484433$var$createAnalyticsEvent = (_payload)=>// @ts-expect-error - Type 'UIAnalyticsEventServer' is not assignable to type 'UIAnalyticsEvent'.
    new $4907e27f6a484433$var$UIAnalyticsEventServer();
const $4907e27f6a484433$export$5bf35293e545f20c = ()=>({
        createAnalyticsEvent: $4907e27f6a484433$var$createAnalyticsEvent
    });
const $4907e27f6a484433$var$withAnalyticsEvents = ()=>(WrappedComponent)=>{
        const WithAnalyticsEvents = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>// @ts-expect-error Spread types may only be created from object types.ts(2698)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                ref: ref,
                createAnalyticsEvent: $4907e27f6a484433$var$createAnalyticsEvent
            }));
        WithAnalyticsEvents.displayName = 'WithAnalyticsEvents('.concat(WrappedComponent.displayName != null ? WrappedComponent.displayName : WrappedComponent.name || '', ')');
        return WithAnalyticsEvents;
    };
const $4907e27f6a484433$export$3e9ef96ba97ea9dc = (_componentName, _eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (component)=>$4907e27f6a484433$var$withAnalyticsEvents()(component);
const $4907e27f6a484433$var$MountEventComponent = ({ onMount: onMount })=>{
    // @ts-expect-error TS2554: Expected 1 arguments, but got 0.
    (0, $5uXOq.useLayoutEffect)(()=>onMount(new $4907e27f6a484433$var$UIAnalyticsEventServer()), [
        onMount
    ]);
    return null;
};
const $4907e27f6a484433$export$2c6963927dbc68f1 = $4907e27f6a484433$var$withAnalyticsEvents()($4907e27f6a484433$var$MountEventComponent);

});

parcelRegister("ewaBk", function(module, exports) {

$parcel$export(module.exports, "useContextMenuStore", () => $1b2687c2318490cf$export$d1b2e16030b3efbf);
$parcel$export(module.exports, "useContextMenuActions", () => $1b2687c2318490cf$export$fb508b9bcc816326);
$parcel$export(module.exports, "ContextMenuContainer", () => $1b2687c2318490cf$export$4f48a5067cf73390);
$parcel$export(module.exports, "useMenuItemCheckOpen", () => $1b2687c2318490cf$export$60c643cac8887fbe);
$parcel$export(module.exports, "useShouldForceFocus", () => $1b2687c2318490cf$export$ac348ec4828a6056);
$parcel$export(module.exports, "useIsMenuOpen", () => $1b2687c2318490cf$export$3eef7351bd308de1);
$parcel$export(module.exports, "useAnalyticsAttributes", () => $1b2687c2318490cf$export$1fd8522aeddaccda);
$parcel$export(module.exports, "useAnalyticsMapping", () => $1b2687c2318490cf$export$aeb28cc7c774c3ed);
$parcel$export(module.exports, "useIsAnyMenuOpen", () => $1b2687c2318490cf$export$91d90cb66ff7a71e);
$parcel$export(module.exports, "useIsPersistentFocus", () => $1b2687c2318490cf$export$1e85791d95627e79);

var $7JoAD = parcelRequire("7JoAD");

var $jwhNt = parcelRequire("jwhNt");

var $f19dW = parcelRequire("f19dW");

var $5tijM = parcelRequire("5tijM");
const $1b2687c2318490cf$var$ContextMenuStore = (0, $7JoAD.createStore)({
    name: 'software-context-menu',
    initialState: (0, $f19dW.getInitialState)(),
    actions: $f19dW.actions
});
const $1b2687c2318490cf$export$d1b2e16030b3efbf = (0, $7JoAD.createHook)($1b2687c2318490cf$var$ContextMenuStore);
const $1b2687c2318490cf$export$fb508b9bcc816326 = (0, $7JoAD.createActionsHook)($1b2687c2318490cf$var$ContextMenuStore);
const $1b2687c2318490cf$export$4f48a5067cf73390 = (0, $7JoAD.createContainer)($1b2687c2318490cf$var$ContextMenuStore, {
    onInit: (0, $5tijM.onContainerInit),
    onUpdate: (0, $5tijM.onContainerUpdate)
});
const $1b2687c2318490cf$var$getMenuItemOpen = (state, { menuItem: menuItem, scope: scope })=>state.menus[scope]?.openPath?.startsWith(menuItem.id);
const $1b2687c2318490cf$export$60c643cac8887fbe = (0, $7JoAD.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getMenuItemOpen
});
const $1b2687c2318490cf$var$getIsFocusForced = (state, { menuItem: menuItem, scope: scope })=>state.menus[scope]?.forcedFocusPath === menuItem.id;
const $1b2687c2318490cf$export$ac348ec4828a6056 = (0, $7JoAD.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getIsFocusForced
});
const $1b2687c2318490cf$var$getIsMenuOpen = (state, { scope: scope })=>state.openMenu === scope;
const $1b2687c2318490cf$export$3eef7351bd308de1 = (0, $7JoAD.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getIsMenuOpen
});
const $1b2687c2318490cf$var$getAnalyticsAttributes = (state, { scope: scope, cardId: cardId })=>{
    const isMenuOpen = $1b2687c2318490cf$var$getIsMenuOpen(state, {
        scope: scope
    });
    const { analytics: { selectedCardIds: selectedCardIds } } = state;
    return (0, $jwhNt.getCardSelectionAnalytics)(selectedCardIds, cardId, isMenuOpen);
};
const $1b2687c2318490cf$export$1fd8522aeddaccda = (0, $7JoAD.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getAnalyticsAttributes
});
const $1b2687c2318490cf$var$getAnalyticsMapping = (state)=>state.analytics.analyticsMapping;
const $1b2687c2318490cf$export$aeb28cc7c774c3ed = (0, $7JoAD.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getAnalyticsMapping
});
const $1b2687c2318490cf$export$d8b7614abf2894d6 = (state)=>!!state.openMenu;
const $1b2687c2318490cf$export$91d90cb66ff7a71e = (0, $7JoAD.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$export$d8b7614abf2894d6
});
const $1b2687c2318490cf$var$getIsPersistentFocus = (state)=>!!state?.persistentFocus;
const $1b2687c2318490cf$export$1e85791d95627e79 = (0, $7JoAD.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getIsPersistentFocus
});

});
parcelRegister("jwhNt", function(module, exports) {

$parcel$export(module.exports, "hasUserStartedSelecting", () => $17a2da3770fdd915$export$5195d9082487fa42);
$parcel$export(module.exports, "hasUserUnselectedAll", () => $17a2da3770fdd915$export$3b8cd3ffacc95e4f);
$parcel$export(module.exports, "getCardSelectionAnalytics", () => $17a2da3770fdd915$export$f96eca8ded123f8b);
$parcel$export(module.exports, "shouldFlowBeEnded", () => $17a2da3770fdd915$export$539307982a715ea8);
const $17a2da3770fdd915$export$5195d9082487fa42 = (analytics, contextMenuContainerAnalytics)=>analytics.selectedCardIds.length === 0 && contextMenuContainerAnalytics.selectedCardIds.length > 0;
const $17a2da3770fdd915$export$3b8cd3ffacc95e4f = (analytics, contextMenuContainerAnalytics)=>analytics.selectedCardIds.length > 0 && contextMenuContainerAnalytics.selectedCardIds.length === 0;
const $17a2da3770fdd915$export$f96eca8ded123f8b = (selectedCardIds, cardId, isMenuOpen)=>{
    let cardIds;
    if (isMenuOpen) cardIds = selectedCardIds.includes(cardId) ? selectedCardIds : [
        cardId
    ];
    else cardIds = selectedCardIds;
    const numSelectedCards = cardIds.length;
    return {
        numSelectedCards: numSelectedCards,
        issue_ids: cardIds,
        issue_id: cardId
    };
};
const $17a2da3770fdd915$export$539307982a715ea8 = (analytics, contextMenuContainerAnalytics, bulkOpsFlow)=>{
    const sessionID = !!bulkOpsFlow?.getFlowAttributes().bulkOpsSessionID;
    return sessionID && contextMenuContainerAnalytics.selectedCardIds.length === 0;
};

});

parcelRegister("f19dW", function(module, exports) {

$parcel$export(module.exports, "getInitialState", () => $c2d99694a10aebe1$export$53ac33307b5acee9);
$parcel$export(module.exports, "actions", () => $c2d99694a10aebe1$export$e324594224ef24da);

var $jcw0u = parcelRequire("jcw0u");

var $5tijM = parcelRequire("5tijM");
const $c2d99694a10aebe1$export$53ac33307b5acee9 = ()=>({
        menus: {},
        openMenu: null,
        analytics: {
            selectedCardIds: []
        },
        lastAction: {
            action: 'init',
            scope: undefined
        }
    });
const $c2d99694a10aebe1$export$aad8462122ac592b = (lastAction)=>({ setState: setState })=>{
        const { analytics: analytics, ...initialState } = $c2d99694a10aebe1$export$53ac33307b5acee9();
        initialState.lastAction = lastAction || {
            action: 'reset'
        };
        setState(initialState);
    };
const $c2d99694a10aebe1$var$setPersistentFocus = (persistentFocus)=>({ setState: setState })=>{
        setState({
            persistentFocus: persistentFocus
        });
    };
const $c2d99694a10aebe1$var$openMenu = ({ position: position, scope: scope, analyticsEvent: analyticsEvent, persistentFocus: persistentFocus, openedFrom: openedFrom })=>({ setState: setState }, { selectedCardIds: selectedCardIds, cardId: cardId })=>{
        (0, $5tijM.fireOpenMenuAnalyticsEvent)({
            event: analyticsEvent,
            selectedCardIds: selectedCardIds,
            cardId: cardId,
            openedFrom: openedFrom
        });
        setState({
            openMenu: scope,
            persistentFocus: persistentFocus,
            menus: {
                [scope]: {
                    openPath: undefined,
                    scope: scope,
                    position: position,
                    forcedFocusPath: undefined
                }
            },
            lastAction: {
                action: 'openMenu',
                scope: scope
            }
        });
    };
const $c2d99694a10aebe1$export$11ed9b7b8045d408 = (scope, menuItem)=>({ setState: setState, getState: getState })=>{
        const { menus: menus, lastAction: lastAction } = getState();
        const menuState = menus[scope];
        if (!menuState) {
            if (lastAction?.action === 'closeMenu') return;
            const errorMessage = `Menu state is not defined - last action(${lastAction?.action}) scopes(${lastAction?.scope}-${scope})`;
            const error = new Error(errorMessage);
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'jira-software-context-menu-controller-open-sub-menu-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        setState({
            menus: {
                [scope]: {
                    ...menuState,
                    openPath: menuItem.id
                }
            },
            lastAction: {
                action: 'openSubMenu',
                scope: scope
            }
        });
    };
const $c2d99694a10aebe1$export$69ff42680518db68 = (scope)=>({ getState: getState, dispatch: dispatch })=>{
        const { menus: menus, lastAction: lastAction } = getState();
        const menuState = menus[scope];
        if (!menuState) {
            if (lastAction?.action === 'closeMenu') return;
            const errorMessage = `Menu state is not defined - last action(${lastAction?.action}) scopes(${lastAction?.scope}-${scope})`;
            const error = new Error(errorMessage);
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'jira-software-context-menu-controller-close-menu-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        dispatch($c2d99694a10aebe1$export$aad8462122ac592b({
            action: 'closeMenu',
            scope: scope
        }));
    };
const $c2d99694a10aebe1$var$closeSubMenu = (scope)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const menuState = state.menus[scope];
        if (!menuState) {
            if (state.lastAction?.action === 'closeMenu') return;
            const errorMessage = `Menu state is not defined - last action(${state.lastAction?.action}) scopes(${state.lastAction?.scope}-${scope})`;
            const error = new Error(errorMessage);
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'jira-software-context-menu-controller-close-sub-menu-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        setState({
            menus: {
                [scope]: {
                    ...menuState,
                    openPath: undefined
                }
            },
            lastAction: {
                action: 'closeSubMenu',
                scope: scope
            }
        });
    };
const $c2d99694a10aebe1$var$setForcedFocusPath = (scope, id)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const menuState = state.menus[scope];
        if (!menuState) {
            if (state.lastAction?.action === 'closeMenu') return;
            const errorMessage = `Menu state is not defined - last action(${state.lastAction?.action}) scopes(${state.lastAction?.scope}-${scope}`;
            const error = new Error(errorMessage);
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'jira-software-context-menu-controller-set-focused-path-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        setState({
            menus: {
                [scope]: {
                    ...menuState,
                    forcedFocusPath: id
                }
            },
            lastAction: {
                action: 'setForcedFocusPath',
                scope: scope
            }
        });
    };
const $c2d99694a10aebe1$export$e324594224ef24da = {
    openMenu: $c2d99694a10aebe1$var$openMenu,
    closeMenu: $c2d99694a10aebe1$export$69ff42680518db68,
    openSubMenu: $c2d99694a10aebe1$export$11ed9b7b8045d408,
    closeSubMenu: $c2d99694a10aebe1$var$closeSubMenu,
    setForcedFocusPath: $c2d99694a10aebe1$var$setForcedFocusPath,
    reset: $c2d99694a10aebe1$export$aad8462122ac592b,
    setPersistentFocus: $c2d99694a10aebe1$var$setPersistentFocus
};

});
parcelRegister("5tijM", function(module, exports) {

$parcel$export(module.exports, "onContainerInit", () => $61c942cebc868b99$export$34f4621b58d3fbc8);
$parcel$export(module.exports, "onContainerUpdate", () => $61c942cebc868b99$export$ab8f0de40a3a2d2d);
$parcel$export(module.exports, "fireOpenMenuAnalyticsEvent", () => $61c942cebc868b99$export$d4ad71c555abd3c8);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $1phoV = parcelRequire("1phoV");

var $jwhNt = parcelRequire("jwhNt");
const $61c942cebc868b99$export$34f4621b58d3fbc8 = ()=>({ setState: setState, getState: getState }, { cardId: cardId, bulkOpsFlow: bulkOpsFlow, ...analyticsContainerProps })=>{
        const { analytics: analytics } = getState();
        setState({
            analytics: {
                ...analyticsContainerProps
            }
        });
        if (bulkOpsFlow && (0, $jwhNt.shouldFlowBeEnded)(analytics, analyticsContainerProps, bulkOpsFlow)) bulkOpsFlow?.end();
        else if (bulkOpsFlow && (0, $jwhNt.hasUserStartedSelecting)(analytics, analyticsContainerProps)) bulkOpsFlow?.start();
    };
const $61c942cebc868b99$export$ab8f0de40a3a2d2d = ()=>({ setState: setState, getState: getState }, { cardId: cardId, bulkOpsFlow: bulkOpsFlow, ...analyticsContainerProps })=>{
        const { analytics: analytics } = getState();
        if ((0, $jwhNt.hasUserStartedSelecting)(analytics, analyticsContainerProps)) {
            if (!bulkOpsFlow) (0, $jcw0u.default)({
                error: new Error('Trying to start a flow while bulkOpsSession is undefined'),
                meta: {
                    id: 'jira-software-context-menu-controller-on-container-update-flow-start-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            else bulkOpsFlow?.start();
        } else if ((0, $jwhNt.hasUserUnselectedAll)(analytics, analyticsContainerProps)) {
            if (!bulkOpsFlow) (0, $jcw0u.default)({
                error: new Error('Trying to end a flow while bulkOpsSession is undefined'),
                meta: {
                    id: 'jira-software-context-menu-controller-on-container-update-flow-end-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            else bulkOpsFlow?.end();
        }
        setState({
            analytics: {
                ...analytics,
                ...analyticsContainerProps
            }
        });
    };
const $61c942cebc868b99$export$d4ad71c555abd3c8 = ({ event: event, cardId: cardId, selectedCardIds: selectedCardIds, openedFrom: openedFrom })=>{
    const attributes = {
        ...(0, $jwhNt.getCardSelectionAnalytics)(selectedCardIds, cardId, true),
        isLinkIssueFromBoardCardEnabled: true,
        jswCmpCardCoverExpCohort: (0, $1phoV.getJswCmpCardCoversExpCohort)(event),
        openedFrom: openedFrom
    };
    // Attributes normally get merged together. We want to override the issue_ids attribute instead
    event.context.push({
        attributes: {
            issue_ids: null
        }
    });
    (0, $8zOmE.fireUIAnalytics)(event, 'cardActions', attributes);
};

});
parcelRegister("1phoV", function(module, exports) {

$parcel$export(module.exports, "getJswCmpCardCoversExpCohort", () => $1f09e6268def8d8a$export$e9d8735c68972d71);

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $39ajt = parcelRequire("39ajt");
const $1f09e6268def8d8a$export$e9d8735c68972d71 = (event)=>{
    if (!(0, $4R6GH.fg)('jsw_cmp_card_cover_images')) return 'feature-hidden';
    const { projectType: projectType, isClassic: isClassic } = (0, $39ajt.getAttributes)(event);
    const source = (0, $39ajt.getSource)(event);
    if (!(projectType === (0, $2vSU6.SOFTWARE_PROJECT) && isClassic && source === 'boardScreen')) return 'feature-hidden';
    if (!(0, $4R6GH.fg)('jsw_cmp_card_covers_changeboarding')) return 'changeboarding-disabled';
    return (0, $6s1PB.expVal)('jsw_cmp_card_cover_images_experiment', 'isCardCoverFeatureEnabled', false) ? 'experiment' : 'feature-hidden';
};

});




parcelRegister("g9agn", function(module, exports) {

$parcel$export(module.exports, "transformCardCoverPopoverData", () => $d210078ca02f0fb7$export$3e6afbc9f79f8ddc);

var $l5UTI = parcelRequire("l5UTI");
const $d210078ca02f0fb7$export$3e6afbc9f79f8ddc = (coverMedia, issueId)=>{
    if (!coverMedia) // Clear card cover data for the issue if coverMedia is null
    return {
        [issueId]: null
    };
    if (coverMedia.__typename !== 'JiraAttachmentBackground' || !coverMedia.mediaConfig) /*
		Don't do anything if we've received invalid or incomplete data. This could be because:
			1. a ColorCover gets passed in here. This is unlikely, but there's no typecheck preventing
			this from happening because type CoverMedia = ColorCover | AttachmentCover | null and CoverMedia
			is the prescribed input type for the onUpdated function that triggers this function call.
			2. coverMedia.mediaConfig is null. This is possible if we land here after uploading a new
			card cover because the data required to populate the mediaConfig might be missing.
		*/ return {};
    return {
        [issueId]: (0, $l5UTI.transformMediaDataForSingleIssue)(coverMedia.attachment, coverMedia.mediaConfig)
    };
};

});

parcelRegister("4mdFU", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbe3123d5d8a691d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bbe3123d5d8a691d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editCover: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.edit-cover.edit-cover",
        "defaultMessage": "Edit cover image"
    },
    newLozenge: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.edit-cover.new-lozenge",
        "defaultMessage": "New"
    }
});

});


parcelRegister("1Akg6", function(module, exports) {

$parcel$export(module.exports, "useFlag", () => $5b7f821cf9727350$export$983b9b54330812cb);

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $67sX6 = parcelRequire("67sX6");

var $7W4VK = parcelRequire("7W4VK");

var $d2i8f = parcelRequire("d2i8f");


var $kOuTq = parcelRequire("kOuTq");
const $5b7f821cf9727350$export$64037f4178ea2950 = ({ onToggleFlag: onToggleFlag, isFlagged: isFlagged })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: isFlagged ? formatMessage((0, $kOuTq.default).removeFlag) : formatMessage((0, $kOuTq.default).addFlag),
            id: (0, $c96743ce387bce58$export$63cb4152f50d2665),
            onClick: onToggleFlag
        }
    ];
};
const $5b7f821cf9727350$export$983b9b54330812cb = ({ issueId: issueId })=>{
    const isFlagged = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.isIssueFlagged)(state, issueId));
    const onToggleFlag = (0, $67sX6.useBoardActionCreator)(()=>(0, $7W4VK.showIssueFlagWithCommentModal)(issueId));
    return $5b7f821cf9727350$export$64037f4178ea2950({
        onToggleFlag: onToggleFlag,
        isFlagged: isFlagged
    });
};

});

parcelRegister("3usya", function(module, exports) {

$parcel$export(module.exports, "useHeader", () => $8ec3661e809a543d$export$ae602290ebd82f8e);

var $1HF4Y = parcelRequire("1HF4Y");


var $l1G1t = parcelRequire("l1G1t");
const $8ec3661e809a543d$export$ae602290ebd82f8e = ({ selectedCards: selectedCards })=>{
    const separator = (0, $l1G1t.createSeparator)((0, $c96743ce387bce58$export$bdfa217711a39d8d));
    return selectedCards?.length > 1 ? [
        {
            id: (0, $c96743ce387bce58$export$bdfa217711a39d8d),
            type: (0, $1HF4Y.MenuNodeType).BulkIndicator,
            selectedCount: selectedCards.length
        },
        separator
    ] : [];
};

});

parcelRegister("9QvG1", function(module, exports) {

$parcel$export(module.exports, "useAddLabel", () => $d623d901f7c55f34$export$36eeafb75308a374);

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $67sX6 = parcelRequire("67sX6");

var $iaYF9 = parcelRequire("iaYF9");

var $9OPlz = parcelRequire("9OPlz");


var $kOuTq = parcelRequire("kOuTq");
const $d623d901f7c55f34$export$36eeafb75308a374 = ({ issueId: issueId, selectedCardIds: selectedCardIds })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isSelected = (0, $67sX6.useBoardSelector)((state)=>(0, $9OPlz.isCardSelected)(state)(issueId));
    const onAddLabel = (0, $67sX6.useBoardActionCreator)(()=>{
        const issueIds = isSelected ? selectedCardIds : [
            issueId
        ];
        return (0, $iaYF9.showIssueAddLabelModal)(issueIds);
    });
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $kOuTq.default).label),
            id: (0, $c96743ce387bce58$export$d0e98113904dfa9),
            onClick: onAddLabel
        }
    ];
};

});

parcelRegister("j49Di", function(module, exports) {

$parcel$export(module.exports, "useLinkIssue", () => $d31a8940381f4f2b$export$8503aa22241098ff);
$parcel$export(module.exports, "useLinkIssueIPBoard", () => $d31a8940381f4f2b$export$a0a7145930e6bd78);

var $5uXOq = parcelRequire("5uXOq");

var $4mO32 = parcelRequire("4mO32");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $HeOPt = parcelRequire("HeOPt");

var $c1DxF = parcelRequire("c1DxF");

var $kgiLc = parcelRequire("kgiLc");

var $67sX6 = parcelRequire("67sX6");

var $6WzWZ = parcelRequire("6WzWZ");

var $j4MnI = parcelRequire("j4MnI");

var $4vVV6 = parcelRequire("4vVV6");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");


var $bd4XH = parcelRequire("bd4XH");

var $8KcVO = parcelRequire("8KcVO");
const $d31a8940381f4f2b$export$8503aa22241098ff = (props)=>{
    const { canUserLinkIssue: canUserLinkIssue, issueLinkTypes: issueLinkTypes } = (0, $67sX6.useBoardSelector)((state)=>(0, $4vVV6.getIssueLinksPermissions)(state));
    const { issue: issue, issueType: issueType } = (0, $67sX6.useBoardSelector)((state)=>{
        const issueItem = (0, $d2i8f.getIssueById)(state, props.issueId);
        if (!issueItem) return {
            issue: undefined,
            issueType: undefined
        };
        return {
            issue: issueItem,
            issueType: (0, $d2i8f.getIssueTypeById)(state, issueItem.typeId)
        };
    });
    const { entryPointActions: entryPointActions } = (0, $4mO32.useEntryPoint)((0, $c1DxF.linkIssueEntryPoint), {});
    const onMouseEnter = entryPointActions.preload;
    const { setIssueLinkModalEntryPointSubject: setIssueLinkModalEntryPointSubject } = (0, $HeOPt.useIssueLinkedModalEntrypointActions)();
    const onClick = ()=>{
        setIssueLinkModalEntryPointSubject({
            issueData: {
                issueId: String(issue?.id),
                issueKey: issue?.key,
                issueSummary: issue?.summary,
                issueType: issueType
            },
            trackOriginSource: 'fromJSWBoardCardContextMenu'
        });
    };
    const menuNodes = (0, $8KcVO.useLinkContent)({
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        canUserLinkIssue: canUserLinkIssue,
        hasIssueLinkTypes: issueLinkTypes.length > 0
    });
    // if issue or issue type are undefined the menu nodes may have issues so we return an empty list instead
    if (!issue || !issueType) return [];
    return menuNodes;
};
const $d31a8940381f4f2b$export$a0a7145930e6bd78 = (props)=>{
    const issue = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIssueById)(state, props.issueId));
    const issueType = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIssueTypeById)(state, issue.typeId));
    const issues = (0, $67sX6.useBoardSelector)((state)=>(0, $67Z81.getIssues)(state));
    const issuesArray = (0, $5uXOq.useMemo)(()=>Object.values(issues), [
        issues
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const title = formatMessage((0, $bd4XH.default).addDependencyKey);
    const confirmLabel = formatMessage((0, $bd4XH.default).addDependencyCta);
    const issueLinkTypes = (0, $67sX6.useBoardSelector)((state)=>(0, $67Z81.getIssueLinkTypes)(state));
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const issueLinkAndDirectionMap = (0, $67sX6.useBoardSelector)((state)=>(0, $j4MnI.getIssueLinksForDependenciesModal)(state)(props.issueId));
    const { setIssueLinkModalEntryPointSubject: setIssueLinkModalEntryPointSubject } = (0, $HeOPt.useIssueLinkedModalEntrypointActions)();
    const onLinkIssueRequest = (0, $5uXOq.useCallback)(async (issueId, newIssueLinks, issueLinkType)=>{
        const isInwards = issueLinkType.direction === (0, $7ea9780e1aa4575d$export$b5e2b68b0fa7f1c8);
        return Promise.all(newIssueLinks.map(({ value: value })=>(0, $kgiLc.wrapActionWithPromise)(dispatch, (0, $6WzWZ.issueLinkCreateRequest)({
                sourceItemKey: `${isInwards ? value : issueId}`,
                targetItemKey: `${isInwards ? issueId : value}`,
                type: Number(issueLinkType.id)
            }))));
    }, [
        dispatch
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        setIssueLinkModalEntryPointSubject({
            issueData: {
                issueId: String(issue.id),
                issueKey: issue.key,
                issueSummary: issue.summary,
                issueType: issueType
            },
            modalContent: {
                title: title,
                showDescription: false,
                showCreateIssueLinkButton: false,
                showFeedbackCollector: false,
                localIssuesOnly: true,
                confirmLabel: confirmLabel,
                issues: issuesArray,
                onLinkIssueRequest: onLinkIssueRequest,
                issueLinks: issueLinkAndDirectionMap,
                returnFocusRef: (0, $4R6GH.fg)('increment_board_a11y_fix') ? props.returnFocusRef : undefined
            }
        });
    }, [
        issue,
        title,
        confirmLabel,
        setIssueLinkModalEntryPointSubject,
        issuesArray,
        onLinkIssueRequest,
        issueType,
        issueLinkAndDirectionMap,
        props.returnFocusRef
    ]);
    const { entryPointActions: entryPointActions } = (0, $4mO32.useEntryPoint)((0, $c1DxF.linkIssueEntryPoint), {});
    const onMouseEnter = entryPointActions.preload;
    return (0, $8KcVO.useLinkContent)({
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        canUserLinkIssue: true,
        hasIssueLinkTypes: issueLinkTypes.length > 0,
        message: formatMessage((0, $bd4XH.default).addDependencyKey)
    });
};

});
parcelRegister("HeOPt", function(module, exports) {

$parcel$export(module.exports, "useIssueLinkedModalEntrypointActions", () => $ddf76c53d76224b8$export$c03a98393d952aa6);
$parcel$export(module.exports, "useIssueLinkedModalEntrypointStore", () => $ddf76c53d76224b8$export$84102b9a2118d337);

var $7JoAD = parcelRequire("7JoAD");

var $8ueAK = parcelRequire("8ueAK");
const $ddf76c53d76224b8$export$d4c72bab9d6cc13a = {
    issueData: undefined,
    modalContent: undefined
};
const $ddf76c53d76224b8$export$6f57813fe9f31bf9 = (0, $7JoAD.createStore)({
    initialState: $ddf76c53d76224b8$export$d4c72bab9d6cc13a,
    actions: $8ueAK.actions,
    name: 'issue-links-modal-entrypoint-store'
});
const $ddf76c53d76224b8$export$5f9d819cda534167 = (0, $7JoAD.createContainer)($ddf76c53d76224b8$export$6f57813fe9f31bf9, {
    onInit: ()=>({ setState: setState })=>{
            setState($ddf76c53d76224b8$export$d4c72bab9d6cc13a);
        }
});
const $ddf76c53d76224b8$export$c03a98393d952aa6 = (0, $7JoAD.createActionsHook)($ddf76c53d76224b8$export$6f57813fe9f31bf9);
const $ddf76c53d76224b8$export$84102b9a2118d337 = (0, $7JoAD.createHook)($ddf76c53d76224b8$export$6f57813fe9f31bf9);

});
parcelRegister("8ueAK", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5d5b9c6990e0d0e0$export$e324594224ef24da);
const $5d5b9c6990e0d0e0$export$ec7c0f6064933276 = ({ issueData: issueData, modalContent: modalContent, trackOriginSource: trackOriginSource })=>({ setState: setState })=>{
        setState({
            issueData: issueData,
            modalContent: modalContent,
            trackOriginSource: trackOriginSource
        });
    };
const $5d5b9c6990e0d0e0$export$e324594224ef24da = {
    setIssueLinkModalEntryPointSubject: $5d5b9c6990e0d0e0$export$ec7c0f6064933276
};

});


parcelRegister("c1DxF", function(module, exports) {

$parcel$export(module.exports, "linkIssueEntryPoint", () => $52b5893121b7514f$export$a6cecab8ef1c82a1);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $52b5893121b7514f$export$a6cecab8ef1c82a1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("7fxqQ")), {
        moduleId: "078752d7"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7fxqQ", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("9xmdP").then(()=>parcelRequire('b4pP3'));

});


parcelRegister("j4MnI", function(module, exports) {

$parcel$export(module.exports, "getIssueLinksForDependenciesFlyout", () => $00394967ab8d168e$export$1ba4fd422cd0d38a);
$parcel$export(module.exports, "getIssueLinksForDependenciesModal", () => $00394967ab8d168e$export$e1d999e347b7a491);
$parcel$export(module.exports, "getShowOfftrackDependencyLines", () => $00394967ab8d168e$export$32c01395d25dfdcc);
$parcel$export(module.exports, "getIssueIdsToShowDependencies", () => $00394967ab8d168e$export$67e6bba1326e537a);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $hGgHi = parcelRequire("hGgHi");

var $4Xk2W = parcelRequire("4Xk2W");

var $gULOk = parcelRequire("gULOk");

var $4R6GH = parcelRequire("4R6GH");

var $bkUsp = parcelRequire("bkUsp");

var $67Z81 = parcelRequire("67Z81");
const $00394967ab8d168e$export$5c81e28e234f06c2 = (issue, issueLinkId, { name: name, category: category }, offtrackLabel)=>({
        key: issue.key,
        issueTypeName: issue.typeName,
        issueTypeIconUrl: issue.typeUrl,
        text: issue.summary,
        statusCategoryId: `${(0, $gULOk.categoryIdForStatusCategory)(category)}`,
        statusName: name,
        issueLinkId: issueLinkId,
        offtrackLabel: offtrackLabel
    });
const $00394967ab8d168e$export$1ba4fd422cd0d38a = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getStatuses),
    (0, $67Z81.getIssueLinkTypes),
    (0, $67Z81.getIssues)
], (statuses, issueLinkTypes, issues)=>(issueId, offtrackLabel)=>{
        // todo - currently showing basic count for external issues (not in the board and not in the plan),
        // need to decided to how to handle the external issues https://hello.atlassian.net/wiki/spaces/AG/pages/3299676769/2024-01-30+IP+Weekly+Sync+Meeting+Notes
        const issue = issues[issueId];
        const issueLinks = issue?.issueLinks || [];
        const issueLinkTypesById = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(issueLinkTypes, 'id');
        const internalAndExternalIssueLinks = issueLinks.reduce((acc, issueLink)=>{
            const { id: id, sourceId: sourceId, destinationId: destinationId, linkTypeId: linkTypeId, isOfftrack: isOfftrack } = issueLink;
            // filter out the external issue
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issues[sourceId]) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issues[destinationId])) {
                acc.external += 1;
                return acc;
            }
            const direction = `${destinationId}` === `${issueId}` ? 'inward' : 'outward';
            const resultIssue = direction === 'inward' ? issues[sourceId] : issues[destinationId];
            const resultIssueStatus = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(resultIssue.statusId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(statuses[resultIssue.statusId]) ? {
                name: '',
                category: (0, $gULOk.UNDEFINED)
            } : statuses[resultIssue.statusId];
            const resultIssueLink = $00394967ab8d168e$export$5c81e28e234f06c2(resultIssue, id, resultIssueStatus, isOfftrack && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') ? offtrackLabel : undefined);
            const group = issueLinkTypesById[`${linkTypeId}`][direction];
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(acc.internal[group])) acc.internal[group] = [
                resultIssueLink
            ];
            else acc.internal[group].push(resultIssueLink);
            return acc;
        }, {
            internal: {},
            external: 0
        });
        return internalAndExternalIssueLinks;
    });
const $00394967ab8d168e$export$e1d999e347b7a491 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssueLinkTypes),
    (0, $67Z81.getIssues)
], (issueLinkTypes, issues)=>(issueId)=>{
        const issue = issues[issueId];
        const issueLinks = issue?.issueLinks || [];
        const issueLinkTypesById = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(issueLinkTypes, 'id');
        const issueLinksByTypeAndDirection = issueLinks.filter(({ sourceId: sourceId, destinationId: destinationId })=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issues[sourceId]) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issues[destinationId])).reduce((acc, issueLink)=>{
            const { sourceId: sourceId, destinationId: destinationId, linkTypeId: linkTypeId } = issueLink;
            const { isOutward: isOutward } = issueLinkTypesById[linkTypeId] ?? {};
            const direction = isOutward && sourceId === issueId || !isOutward && destinationId === issueId ? (0, $bkUsp.OUTWARD_LINK_DIRECTION) : (0, $bkUsp.INWARD_LINK_DIRECTION);
            const dependencyId = sourceId === issueId ? destinationId : sourceId;
            const updatedAcc = (0, $7uUwQ.setIn)(acc, [
                linkTypeId,
                direction
            ], [
                ...(0, $7uUwQ.getIn)(acc, [
                    linkTypeId,
                    direction
                ]) ?? [],
                dependencyId
            ]);
            return updatedAcc;
        }, {});
        return issueLinksByTypeAndDirection;
    });
const $00394967ab8d168e$export$32c01395d25dfdcc = (state)=>state.ui.board.displayOptions.showOfftrackDependencyLines;
const $00394967ab8d168e$export$67e6bba1326e537a = (state)=>state.ui.board.displayOptions.issueIdsToShowDependencies;

});
parcelRegister("bkUsp", function(module, exports) {

$parcel$export(module.exports, "INWARD_LINK_DIRECTION", () => $1e4a31a537751af2$export$b5e2b68b0fa7f1c8);
$parcel$export(module.exports, "OUTWARD_LINK_DIRECTION", () => $1e4a31a537751af2$export$5dec99d71ec794ba);
$parcel$export(module.exports, "BOTH_LINK_DIRECTION", () => $1e4a31a537751af2$export$6cdcf74878b11d34);
$parcel$export(module.exports, "IssueLinkDirectionTypes", () => $1e4a31a537751af2$export$4b7bcc27238c61b9);
const $1e4a31a537751af2$export$b5e2b68b0fa7f1c8 = 'INWARD';
const $1e4a31a537751af2$export$5dec99d71ec794ba = 'OUTWARD';
const $1e4a31a537751af2$export$6cdcf74878b11d34 = 'BOTH';
const $1e4a31a537751af2$export$4b7bcc27238c61b9 = {
    [$1e4a31a537751af2$export$b5e2b68b0fa7f1c8]: $1e4a31a537751af2$export$b5e2b68b0fa7f1c8,
    [$1e4a31a537751af2$export$5dec99d71ec794ba]: $1e4a31a537751af2$export$5dec99d71ec794ba,
    [$1e4a31a537751af2$export$6cdcf74878b11d34]: $1e4a31a537751af2$export$6cdcf74878b11d34
};

});


parcelRegister("4vVV6", function(module, exports) {

$parcel$export(module.exports, "getIssueLinksPermissions", () => $33c81f284084ea09$export$7b960698e444da91);

var $dGvGJ = parcelRequire("dGvGJ");

var $67Z81 = parcelRequire("67Z81");
const $33c81f284084ea09$export$63a1d96e57383a2 = (state)=>(0, $67Z81.getEntities)(state).issueLinksPermissions;
const $33c81f284084ea09$export$7b960698e444da91 = (0, $dGvGJ.createSelector)([
    $33c81f284084ea09$export$63a1d96e57383a2
], (issueLinksPermissions)=>issueLinksPermissions);

});

const $7ea9780e1aa4575d$export$b5e2b68b0fa7f1c8 = 'INWARD';
const $7ea9780e1aa4575d$export$5dec99d71ec794ba = 'OUTWARD';
const $7ea9780e1aa4575d$export$6cdcf74878b11d34 = 'BOTH';

parcelRegister("bd4XH", function(module, exports) {

$parcel$export(module.exports, "default", () => $68a644bc1e970d2d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $68a644bc1e970d2d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    linkIssueKey: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.link-issue.link-issue-key",
        "defaultMessage": "Link issue"
    },
    addDependencyKey: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.link-issue.add-dependency-key",
        "defaultMessage": "Add dependency"
    },
    addDependencyCta: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.link-issue.add-dependency-cta",
        "defaultMessage": "Add"
    },
    linkIssueKeyIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.link-issue.link-issue-key-issue-term-refresh",
        "defaultMessage": "Link issue"
    }
});

});

parcelRegister("8KcVO", function(module, exports) {

$parcel$export(module.exports, "useLinkContent", () => $407dda63ef57658a$export$a87cf02a22618b39);

var $5uXOq = parcelRequire("5uXOq");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");


var $bd4XH = parcelRequire("bd4XH");
const $407dda63ef57658a$export$a87cf02a22618b39 = ({ onClick: onClick, onMouseEnter: onMouseEnter, canUserLinkIssue: canUserLinkIssue, hasIssueLinkTypes: hasIssueLinkTypes, message: message })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return hasIssueLinkTypes && canUserLinkIssue ? [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                    alignBlock: "center",
                    space: "space.100",
                    xcss: $407dda63ef57658a$var$messageContainerStyles
                }, message ?? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bd4XH.default).linkIssueKeyIssueTermRefresh : (0, $bd4XH.default).linkIssueKey)),
            id: (0, $c96743ce387bce58$export$a62eb3479b356078),
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            analytics: {
                attributes: {
                    selectedOption: (0, $c96743ce387bce58$export$a62eb3479b356078)
                }
            }
        }
    ] : [];
};
const $407dda63ef57658a$var$messageContainerStyles = (0, $8CUq3.xcss)({
    lineHeight: '20px'
});

});


parcelRegister("9gxbP", function(module, exports) {

$parcel$export(module.exports, "useMoveTo", () => $0de9ffe9ad3e7cbb$export$f91d8f33a4d36cb0);

var $hGgHi = parcelRequire("hGgHi");

var $2NMNM = parcelRequire("2NMNM");

var $2xFXk = parcelRequire("2xFXk");

var $iuuJH = parcelRequire("iuuJH");

var $bwTbl = parcelRequire("bwTbl");

var $67sX6 = parcelRequire("67sX6");

var $cIqUn = parcelRequire("cIqUn");

var $71oFY = parcelRequire("71oFY");

var $k8auG = parcelRequire("k8auG");

var $9OPlz = parcelRequire("9OPlz");

var $3UY9S = parcelRequire("3UY9S");

var $vAfHD = parcelRequire("vAfHD");

var $cPmFH = parcelRequire("cPmFH");

var $d2i8f = parcelRequire("d2i8f");

var $ebHh7 = parcelRequire("ebHh7");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $63LqY = parcelRequire("63LqY");

var $iPDOH = parcelRequire("iPDOH");
const $0de9ffe9ad3e7cbb$export$f91d8f33a4d36cb0 = ({ issueId: issueId, selectedCardIds: selectedCardIds, isMultiSelectMode: isMultiSelectMode })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({});
    const allIssues = (0, $67sX6.useBoardSelector)((0, $vAfHD.boardIssuesSelector));
    const selectedIssue = allIssues[String(issueId)];
    const selectedCardsContainSubtasks = (0, $67sX6.useBoardSelector)((state)=>isMultiSelectMode ? (0, $9OPlz.areAnySelectedCardsIssueChildren)(state) : (0, $vAfHD.isBoardIssueAChild)(state)(issueId));
    const isSelected = (0, $67sX6.useBoardSelector)((0, $9OPlz.isCardSelected))(issueId);
    const swimlaneMode = (0, $67sX6.useBoardSelector)((0, $45cXl.getSwimlaneMode));
    const hasSwimlanes = swimlaneMode !== (0, $iuuJH.NO_SWIMLANE).id;
    const swimlaneId = (0, $67sX6.useBoardSelector)((state)=>hasSwimlanes && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(selectedIssue) ? (0, $bwTbl.getSwimlaneId)(swimlaneMode, (0, $4jZ56.getSwimlanes)(state), selectedIssue) : null);
    const issueChildren = (0, $67sX6.useBoardSelector)((0, $3UY9S.getIssueChildren));
    const isMoveGroupCard = swimlaneMode !== (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && issueId in issueChildren;
    const tryGetRankableIssueId = (id)=>{
        if (swimlaneMode !== (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && id && id in issueChildren) return issueChildren[id].parentId;
        return id;
    };
    const firstIssueChildInColumnByParent = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getFirstIssueChildInColumnByParent)(state, selectedIssue?.columnId, selectedIssue?.parentId));
    const lastIssueChildInColumnByParent = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getLastIssueChildInColumnByParent)(state, selectedIssue?.columnId, selectedIssue?.parentId));
    const firstIssueIdInColumn = (0, $67sX6.useBoardSelector)((state)=>!hasSwimlanes || !swimlaneId ? (0, $d2i8f.getFirstIssueInColumn)(state, selectedIssue?.columnId) : (0, $cPmFH.getFirstIssueIdInSwimlane)(state, selectedIssue?.columnId, swimlaneId));
    const lastIssueIdInColumn = (0, $67sX6.useBoardSelector)((state)=>!hasSwimlanes || !swimlaneId ? (0, $d2i8f.getLastIssueInColumn)(state, selectedIssue?.columnId) : (0, $cPmFH.getLastIssueIdInSwimlane)(state, selectedIssue?.columnId, swimlaneId));
    const firstIssueId = isMoveGroupCard ? firstIssueChildInColumnByParent : tryGetRankableIssueId(firstIssueIdInColumn);
    const lastIssueId = isMoveGroupCard ? lastIssueChildInColumnByParent : tryGetRankableIssueId(lastIssueIdInColumn);
    const isFirst = issueId === firstIssueId;
    const isLast = issueId === lastIssueId;
    const canMoveToBacklog = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_MOVE_TO_BACKLOG_CONTEXT_MENU_ITEM);
    const isMoveToBacklogEnabled = (0, $67sX6.useBoardSelector)((state)=>canMoveToBacklog && (0, $k8auG.isBacklogEnabled)(state) && !(0, $ebHh7.isSprintsEnabled)(state) && !selectedCardsContainSubtasks);
    const onMoveToBacklog = (0, $67sX6.useBoardActionCreator)(()=>{
        const issueIdsToMove = selectedCardIds;
        const issueKeysToMove = selectedCardIds.map((cardId)=>allIssues[String(cardId)].key);
        const firstColumnId = allIssues[String(selectedCardIds[0])].columnId;
        return (0, $cIqUn.issueMoveToBacklogRequest)(issueIdsToMove, issueKeysToMove, firstColumnId);
    });
    const onMoveToTop = (0, $67sX6.useBoardActionCreator)(()=>{
        if (isSelected && selectedCardIds.length > 1) return (0, $71oFY.bulkIssueRankTransitionRequest)({
            issueIds: selectedCardIds,
            sourceColumnId: selectedIssue.columnId,
            destinationColumnId: selectedIssue.columnId,
            rankBeforeIssueId: firstIssueId,
            rankAfterIssueId: null,
            sourceSwimlaneId: null,
            destinationSwimlaneId: null,
            isSourceDone: false,
            isDestinationDone: false,
            analyticsEvent: analyticsEvent
        });
        return (0, $71oFY.issueRankTransitionRequest)({
            issueIds: [
                issueId
            ],
            sourceColumnId: selectedIssue.columnId,
            destinationColumnId: selectedIssue.columnId,
            rankBeforeIssueId: firstIssueId,
            rankAfterIssueId: null,
            sourceSwimlaneId: null,
            destinationSwimlaneId: null,
            isSourceDone: false,
            isDestinationDone: false,
            analyticsEvent: analyticsEvent
        });
    });
    const onMoveToBottom = (0, $67sX6.useBoardActionCreator)(()=>{
        if (isSelected && selectedCardIds.length > 1) return (0, $71oFY.bulkIssueRankTransitionRequest)({
            issueIds: selectedCardIds,
            sourceColumnId: selectedIssue.columnId,
            destinationColumnId: selectedIssue.columnId,
            rankBeforeIssueId: null,
            rankAfterIssueId: lastIssueId,
            sourceSwimlaneId: null,
            destinationSwimlaneId: null,
            isSourceDone: false,
            isDestinationDone: false,
            analyticsEvent: analyticsEvent
        });
        return (0, $71oFY.issueRankTransitionRequest)({
            issueIds: [
                issueId
            ],
            sourceColumnId: selectedIssue.columnId,
            destinationColumnId: selectedIssue.columnId,
            rankBeforeIssueId: null,
            rankAfterIssueId: lastIssueId,
            sourceSwimlaneId: null,
            destinationSwimlaneId: null,
            isSourceDone: false,
            isDestinationDone: false,
            analyticsEvent: analyticsEvent
        });
    });
    return (0, $iPDOH.useMoveToContent)({
        isMoveToBacklogEnabled: isMoveToBacklogEnabled,
        isMoveToTopActionVisible: !isFirst,
        isMoveToBottomActionVisible: !isLast,
        onMoveToBacklog: onMoveToBacklog,
        onMoveToTop: onMoveToTop,
        onMoveToBottom: onMoveToBottom
    });
};

});
parcelRegister("iPDOH", function(module, exports) {

$parcel$export(module.exports, "useMoveToContent", () => $9f5450737192f911$export$ba5a2e46cd05ad01);

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");


var $kOuTq = parcelRequire("kOuTq");
const $9f5450737192f911$export$ba5a2e46cd05ad01 = ({ onMoveToBacklog: onMoveToBacklog, onMoveToTop: onMoveToTop, onMoveToBottom: onMoveToBottom, isMoveToBacklogEnabled: isMoveToBacklogEnabled, isMoveToTopActionVisible: isMoveToTopActionVisible, isMoveToBottomActionVisible: isMoveToBottomActionVisible })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const moveToActions = [];
    if (isMoveToBacklogEnabled) moveToActions.push({
        type: (0, $1HF4Y.MenuNodeType).Item,
        id: (0, $c96743ce387bce58$export$32afee5bddfb614a),
        label: formatMessage((0, $kOuTq.default).backlog),
        onClick: onMoveToBacklog
    });
    if (isMoveToTopActionVisible) moveToActions.push({
        type: (0, $1HF4Y.MenuNodeType).Item,
        id: (0, $c96743ce387bce58$export$b7199a4fda4563e9),
        label: formatMessage((0, $kOuTq.default).topOfTheColumn),
        onClick: onMoveToTop
    });
    if (isMoveToBottomActionVisible) moveToActions.push({
        type: (0, $1HF4Y.MenuNodeType).Item,
        id: (0, $c96743ce387bce58$export$facab7e3869721f4),
        label: formatMessage((0, $kOuTq.default).bottomOfTheColumn),
        onClick: onMoveToBottom
    });
    return moveToActions.length > 0 ? [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $kOuTq.default).moveTo),
            id: (0, $c96743ce387bce58$export$5645be38d58b5483),
            children: moveToActions
        }
    ] : [];
};

});


parcelRegister("iokTG", function(module, exports) {

$parcel$export(module.exports, "useRemoveFromSprint", () => $d535047d7535e08e$export$eafff7a110781470);

var $koVbs = parcelRequire("koVbs");

var $g4tDr = parcelRequire("g4tDr");

var $1HF4Y = parcelRequire("1HF4Y");

var $2xFXk = parcelRequire("2xFXk");

var $67sX6 = parcelRequire("67sX6");

var $5G4Hb = parcelRequire("5G4Hb");

var $kc6Ry = parcelRequire("kc6Ry");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");


var $kOuTq = parcelRequire("kOuTq");
const $d535047d7535e08e$export$24a921d394b5e6a = ({ isRemoveFromSprintEnabled: isRemoveFromSprintEnabled, onRemoveFromSprint: onRemoveFromSprint })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!isRemoveFromSprintEnabled) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $kOuTq.default).removeFromSprint),
            id: (0, $c96743ce387bce58$export$e47c565bdec2e2fb),
            onClick: onRemoveFromSprint
        }
    ];
};
const $d535047d7535e08e$export$eafff7a110781470 = ({ issueId: issueId })=>{
    const canRemoveFromSprint = (0, $67sX6.useBoardSelector)((state)=>(0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).REMOVE_FROM_SPRINT));
    const issue = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIssueById)(state, issueId));
    const isBaseType = (0, $67sX6.useBoardSelector)((0, $67Z81.getProjectIssueTypes))[issue?.typeId]?.hierarchyLevelType === (0, $g4tDr.BASE_HIERARCHY_TYPE);
    // TODO: add bulk remove from sprint once feature is added in UIF
    const onRemoveFromSprint = (0, $67sX6.useBoardActionCreator)(()=>(0, $5G4Hb.removeFromSprintRequest)(issueId));
    return $d535047d7535e08e$export$24a921d394b5e6a({
        isRemoveFromSprintEnabled: canRemoveFromSprint && isBaseType,
        onRemoveFromSprint: onRemoveFromSprint
    });
};

});

parcelRegister("fg8U1", function(module, exports) {

$parcel$export(module.exports, "useViewIssueSearch", () => $b1bd69fa79323c9d$export$25bfc6e740013d37);

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $dIdda = parcelRequire("dIdda");

var $67sX6 = parcelRequire("67sX6");

var $9OPlz = parcelRequire("9OPlz");


var $kOuTq = parcelRequire("kOuTq");
const $b1bd69fa79323c9d$export$e025d73d45de7b90 = ({ isViewInIssueSearchVisible: isViewInIssueSearchVisible, onViewIssueSearch: onViewIssueSearch })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!isViewInIssueSearchVisible) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kOuTq.default).viewInIssueSearchIssueTermRefresh : (0, $kOuTq.default).viewInIssueSearch),
            id: (0, $c96743ce387bce58$export$4231ab934953c1bc),
            onClick: onViewIssueSearch
        }
    ];
};
const $b1bd69fa79323c9d$export$25bfc6e740013d37 = ({ isMultiSelectMode: isMultiSelectMode })=>{
    const { push: push } = (0, $dIdda.useRouterActions)();
    const selectedIssueKeys = (0, $67sX6.useBoardSelector)((0, $9OPlz.selectedIssueKeysSelector));
    const onViewIssueSearch = ()=>{
        const url = `/issues/?jql=${encodeURIComponent(`key IN (${selectedIssueKeys.join(',')})`)}`;
        push(url);
    };
    return $b1bd69fa79323c9d$export$e025d73d45de7b90({
        onViewIssueSearch: onViewIssueSearch,
        isViewInIssueSearchVisible: isMultiSelectMode
    });
};

});


parcelRegister("aeiE5", function(module, exports) {

$parcel$export(module.exports, "IssueLinksIndicator", () => $c03398e8f4d51854$export$4be8a1ac20d299ac);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $1f9bV = parcelRequire("1f9bV");

var $7a6BY = parcelRequire("7a6BY");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");


var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $67sX6 = parcelRequire("67sX6");

var $j4MnI = parcelRequire("j4MnI");

var $d2i8f = parcelRequire("d2i8f");

var $49E4m = parcelRequire("49E4m");

var $dlhFx = parcelRequire("dlhFx");
const $c03398e8f4d51854$var$DependencyIndicatorContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isOfftrack: false,
    isSelected: false
});
const $c03398e8f4d51854$var$stopPropagation = (e)=>e.stopPropagation();
const $c03398e8f4d51854$var$DependencyIndicatorIcon = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isOfftrack: isOfftrack, isSelected: isSelected } = (0, $5uXOq.useContext)($c03398e8f4d51854$var$DependencyIndicatorContext);
    const message = formatMessage((0, $dlhFx.default).viewDependencyDetails);
    if (!(0, $dCm1o.isVisualRefreshEnabled)()) {
        const { primaryColor: primaryColor, secondaryColor: secondaryColor } = (()=>{
            if (!(0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) return {
                primaryColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N40})`,
                secondaryColor: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N700})`
            };
            if (isSelected) return {
                primaryColor: `var(--ds-icon-selected, ${(0, $829f609a65d26a98$exports).B75})`,
                secondaryColor: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`
            };
            if (isOfftrack) return {
                primaryColor: `var(--ds-background-accent-red-subtlest, ${(0, $829f609a65d26a98$exports).R100})`,
                secondaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R75})`
            };
            return {
                primaryColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N40})`,
                secondaryColor: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N700})`
            };
        })();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1f9bV))), {
            ...props,
            label: message,
            color: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N500})`,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7a6BY))),
            LEGACY_size: "medium",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor
        });
    }
    const iconColor = (()=>{
        if (!(0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) return `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N800})`;
        if (isSelected) // Setting the color to undefined will reset to the default behaviour to automatically adjust based on the background color
        return undefined;
        if (isOfftrack) return `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R500})`;
        return `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N800})`;
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1f9bV))), {
        ...props,
        label: message,
        color: iconColor
    });
};
const $c03398e8f4d51854$export$4be8a1ac20d299ac = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [popupOpen, setPopupOpen] = (0, $5uXOq.useState)(false);
    const isOfftrack = (0, $67sX6.useBoardSelector)((state)=>{
        if ((0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) {
            const issueLinks = (0, $d2i8f.getIssueById)(state, props.issueId)?.issueLinks || [];
            let flag = false;
            for(let i = 0; i < issueLinks.length; i++)if (issueLinks[i].isOfftrack) {
                flag = true;
                break;
            }
            return flag;
        }
        return false;
    });
    const isSelected = (0, $67sX6.useBoardSelector)((state)=>{
        if ((0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) return (0, $j4MnI.getIssueIdsToShowDependencies)(state).includes(`${props.issueId}`);
        return false;
    });
    const flyoutContent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $49E4m.default), {
            issueKey: props.issueKey,
            issueId: props.issueId
        }), [
        props.issueKey,
        props.issueId
    ]);
    const onIndicatorBtnClick = (0, $5uXOq.useCallback)(()=>{
        setPopupOpen(!popupOpen);
    }, [
        popupOpen,
        setPopupOpen
    ]);
    const onPopUpClose = (0, $5uXOq.useCallback)(()=>{
        setPopupOpen(false);
    }, [
        setPopupOpen
    ]);
    const trigger = (0, $5uXOq.useCallback)((triggerProps)=>{
        const message = formatMessage((0, $dlhFx.default).viewDependencyDetails);
        if ((0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c03398e8f4d51854$var$DependencyIndicatorContext.Provider, {
            value: {
                isOfftrack: isOfftrack,
                isSelected: isSelected
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            onClick: $c03398e8f4d51854$var$stopPropagation,
            onKeyDown: $c03398e8f4d51854$var$stopPropagation
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: message
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            ...triggerProps,
            appearance: isSelected && (0, $dCm1o.isVisualRefreshEnabled)() ? 'primary' : 'subtle',
            spacing: "compact",
            shape: "circle",
            onClick: onIndicatorBtnClick,
            isSelected: popupOpen,
            label: message,
            icon: $c03398e8f4d51854$var$DependencyIndicatorIcon,
            testId: "software-board.board-container.board.card-container.card.issue-links-indicator.icon-button"
        }))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: message
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            ...triggerProps,
            spacing: "compact",
            appearance: "subtle",
            shape: "circle",
            onClick: onIndicatorBtnClick,
            isSelected: popupOpen,
            label: message,
            icon: $c03398e8f4d51854$var$DependencyIndicatorIcon,
            testId: "software-board.board-container.board.card-container.card.issue-links-indicator.icon-button"
        }));
    }, [
        isOfftrack,
        isSelected,
        onIndicatorBtnClick,
        popupOpen,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c03398e8f4d51854$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: popupOpen,
        content: flyoutContent,
        trigger: trigger,
        onClose: onPopUpClose,
        shouldUseCaptureOnOutsideClick: true
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c03398e8f4d51854$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _vwz4kb7n",
            __cmplp.className
        ])
    });
});
var $c03398e8f4d51854$export$2e2bcd8739ae039 = $c03398e8f4d51854$export$4be8a1ac20d299ac;

});
parcelRegister("1f9bV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::af316a11070150755855d308e4656f28>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e7e525cdad15340$var$_UNSAFE_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0e7e525cdad15340$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e7e525cdad15340$var$LinkIcon = (props)=>/*#__PURE__*/ $0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
    }, props));
$0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;

});

parcelRegister("7a6BY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $536e987ca6b29465$var$_react = $536e987ca6b29465$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $536e987ca6b29465$var$_link = $536e987ca6b29465$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $536e987ca6b29465$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $536e987ca6b29465$var$LinkFilledIcon = (props)=>/*#__PURE__*/ $536e987ca6b29465$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m11.75 16.15.548-.537a.585.585 0 0 0 0-.838.61.61 0 0 0-.854 0l-.574.564c-.564.553-1.483.662-2.101.168a1.482 1.482 0 0 1-.119-2.223l1.694-1.663a1.543 1.543 0 0 1 2.156 0l.647.635.853-.839-.646-.635a2.775 2.775 0 0 0-3.863 0l-1.694 1.664a2.66 2.66 0 0 0 .208 3.979c1.104.884 2.738.715 3.746-.275"/><path fill="inherit" d="m12.25 7.85-.547.537a.585.585 0 0 0 0 .838.61.61 0 0 0 .853 0l.574-.564c.564-.553 1.483-.662 2.101-.168.71.57.75 1.603.119 2.223l-1.694 1.663a1.543 1.543 0 0 1-2.156 0l-.647-.635-.853.839.646.635a2.775 2.775 0 0 0 3.863 0l1.695-1.664a2.66 2.66 0 0 0-.209-3.979c-1.104-.884-2.738-.715-3.746.275"/></g></svg>`
    }, props, {
        newIcon: $536e987ca6b29465$var$_link.default
    }));
$536e987ca6b29465$var$LinkFilledIcon.displayName = 'LinkFilledIcon';
var $536e987ca6b29465$var$_default = module.exports.default = $536e987ca6b29465$var$LinkFilledIcon;

});

parcelRegister("49E4m", function(module, exports) {

$parcel$export(module.exports, "default", () => $4569487d8abf03f1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $183uB = parcelRequire("183uB");

var $2NMNM = parcelRequire("2NMNM");

var $dZbEw = parcelRequire("dZbEw");

var $7ymNM = parcelRequire("7ymNM");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $dTlW6 = parcelRequire("dTlW6");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $HeOPt = parcelRequire("HeOPt");

var $9kb7x = parcelRequire("9kb7x");

var $4jAPy = parcelRequire("4jAPy");

var $8zOmE = parcelRequire("8zOmE");

var $iDGXn = parcelRequire("iDGXn");

var $kgiLc = parcelRequire("kgiLc");

var $67sX6 = parcelRequire("67sX6");

var $6WzWZ = parcelRequire("6WzWZ");

var $1vXOx = parcelRequire("1vXOx");

var $j4MnI = parcelRequire("j4MnI");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");


var $2Nvkb = parcelRequire("2Nvkb");
const $4569487d8abf03f1$var$IssueLinksDetailsGroupWrapper = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const selectedIssueIdsForShowDependencyLines = (0, $iDGXn.useIssueIdsToShowDependencies)();
    const { setIssueIdsToShowDependencies: setIssueIdsToShowDependencies } = (0, $iDGXn.useViewSettingsActions)();
    const boardId = Number((0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector)));
    const [isShowLinesChecked, setIsShowLinesChecked] = (0, $5uXOq.useState)(selectedIssueIdsForShowDependencyLines.includes(`${props.issueId}`));
    const issue = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIssueById)(state, props.issueId));
    const issueType = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIssueTypeById)(state, issue.typeId));
    const issues = (0, $67sX6.useBoardSelector)((state)=>(0, $67Z81.getIssues)(state));
    const issuesArray = (0, $5uXOq.useMemo)(()=>Object.values(issues), [
        issues
    ]);
    const { internal: issueLinks, external: external } = (0, $67sX6.useBoardSelector)((state)=>(0, $j4MnI.getIssueLinksForDependenciesFlyout)(state)(props.issueId, (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') ? formatMessage((0, $2Nvkb.default).offtrackLabel) : undefined));
    const issueLinkAndDirectionMap = (0, $67sX6.useBoardSelector)((state)=>(0, $j4MnI.getIssueLinksForDependenciesModal)(state)(props.issueId));
    const [maxIssuesToDisplay, setMaxIssuesToDisplay] = (0, $5uXOq.useState)(undefined);
    const allInternalLinks = (0, (/*@__PURE__*/$parcel$interopDefault($183uB)))(Object.values(issueLinks));
    const isIPBoardReadOnly = (0, $67sX6.useBoardSelector)((0, $1vXOx.isIncrementPlanningReadOnly));
    const { setIssueLinkModalEntryPointSubject: setIssueLinkModalEntryPointSubject } = (0, $HeOPt.useIssueLinkedModalEntrypointActions)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onUnlinkIssueAction = (0, $67sX6.useBoardActionCreator)((boardIssueLink)=>(0, $6WzWZ.issueLinksRemoveRequest)({
            issueId: props.issueId,
            issueLink: boardIssueLink
        }));
    const onUnlinkIssue = (0, $5uXOq.useCallback)(async (issueLink)=>{
        if (issueLink.issueLinkId) {
            const boardIssueLink = issue.issueLinks ? issue.issueLinks.find((link)=>link.id === issueLink.issueLinkId) : undefined;
            if (boardIssueLink) {
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button'
                }), 'unlinkIssue');
                return onUnlinkIssueAction(boardIssueLink);
            }
        }
    }, [
        onUnlinkIssueAction,
        issue.issueLinks,
        createAnalyticsEvent
    ]);
    const onLinkIssueRequest = (0, $5uXOq.useCallback)(async (issueId, newIssueLinks, issueLinkType)=>{
        const isInwards = issueLinkType.direction === (0, $7ea9780e1aa4575d$export$b5e2b68b0fa7f1c8);
        return Promise.all(newIssueLinks.map(({ value: value })=>(0, $kgiLc.wrapActionWithPromise)(dispatch, (0, $6WzWZ.issueLinkCreateRequest)({
                sourceItemKey: `${isInwards ? value : issueId}`,
                targetItemKey: `${isInwards ? issueId : value}`,
                type: Number(issueLinkType.id)
            }))));
    }, [
        dispatch
    ]);
    const renderExternalLinksMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.050",
            xcss: [
                allInternalLinks.length > 0 && $4569487d8abf03f1$var$externalIssueLinksStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $4569487d8abf03f1$var$titleStyles
        }, formatMessage((0, $2Nvkb.default).externalIssueLinksTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            paddingBlockEnd: "space.075"
        }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2Nvkb.default).externalIssueLinksDescriptionIssueTermRefresh : (0, $2Nvkb.default).externalIssueLinksDescription, {
            externalIssueLinksCount: external
        })));
    const handleShowLinesToggleChange = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    (event, analyticsEvent)=>{
        const isChecked = event.target.checked;
        if (!isShowLinesChecked && selectedIssueIdsForShowDependencyLines.length >= (0, $4jAPy.MAX_SELECTED_ISSUES_FOR_DEPENDENCY_LINES)) {
            setIsShowLinesChecked(false);
            dispatch((0, $6WzWZ.reachDependencyLinesLimitInIPBoard)((0, $4jAPy.MAX_SELECTED_ISSUES_FOR_DEPENDENCY_LINES)));
            return;
        }
        setIsShowLinesChecked(isChecked);
        if (isChecked) {
            const newIds = [
                ...selectedIssueIdsForShowDependencyLines,
                `${props.issueId}`
            ];
            setIssueIdsToShowDependencies(boardId, Array.from(new Set(newIds)));
        } else setIssueIdsToShowDependencies(boardId, selectedIssueIdsForShowDependencyLines.filter((id)=>`${id}` !== `${props.issueId}`));
         // will review the analytics in the https://hello.jira.atlassian.cloud/browse/JPO-28989
    // fireUIAnalytics(analyticsEvent, 'toggleDependencyLines', { isChecked });
    }, [
        selectedIssueIdsForShowDependencyLines,
        dispatch,
        props.issueId,
        setIssueIdsToShowDependencies,
        boardId,
        isShowLinesChecked
    ]);
    const renderToggleDependencyLinesAction = ()=>{
        if (!(0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) return undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, $bwpsq.default)([
                "_syaz131l _1wyb1vlj"
            ])
        }, formatMessage((0, $2Nvkb.default).showLinesTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $2Nvkb.default).tooltipForShowLinesToggle)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
            isChecked: isShowLinesChecked,
            onChange: handleShowLinesToggleChange,
            label: formatMessage((0, $2Nvkb.default).labelForShowLinesToggle),
            testId: "software-board.board-container.board.card-container.card.issue-links-indicator.flyout.toggle"
        })));
    };
    const flyoutOnClick = (event)=>{
        // Stop the flyout from triggering the onClick of the issue card, preventing the issue view modal from appearing
        event.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.200",
        xcss: (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') && $4569487d8abf03f1$var$flyoutWrapper,
        onClick: (0, $4R6GH.fg)('issue_view_in_program_board') ? flyoutOnClick : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9kb7x.IssueLinksDetailsGroup), {
        unlinkIssueButtonTooltipText: formatMessage((0, $2Nvkb.default).removeDependency),
        title: formatMessage((0, $2Nvkb.default).title),
        onUnlinkIssue: onUnlinkIssue,
        showBlockedTime: false,
        maxIssuesToDisplay: maxIssuesToDisplay,
        exceedMaxSizeLinkOptions: {
            text: formatMessage((0, $2Nvkb.default).viewAllDependencies),
            onClick: ()=>{
                setMaxIssuesToDisplay(Infinity);
            }
        },
        leftFooterLinkOptions: !isIPBoardReadOnly ? {
            text: formatMessage((0, $2Nvkb.default).addDependency),
            icon: (0, $4R6GH.fg)('enghealth-12479-jsw-board-visual-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                label: formatMessage((0, $2Nvkb.default).unlinkIssues),
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7ymNM))),
                color: "var(--ds-icon, #44546F)"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ymNM))), {
                label: formatMessage((0, $2Nvkb.default).unlinkIssues)
            }),
            onClick: ()=>{
                setIssueLinkModalEntryPointSubject({
                    issueData: {
                        issueId: String(issue.id),
                        issueKey: issue.key,
                        issueSummary: issue.summary,
                        issueType: issueType
                    },
                    modalContent: {
                        title: formatMessage((0, $2Nvkb.default).addDependencyKey),
                        showDescription: false,
                        showCreateIssueLinkButton: false,
                        showFeedbackCollector: false,
                        localIssuesOnly: true,
                        confirmLabel: formatMessage((0, $2Nvkb.default).addDependencyCta),
                        issues: issuesArray,
                        onLinkIssueRequest: onLinkIssueRequest,
                        issueLinks: issueLinkAndDirectionMap
                    }
                });
            }
        } : undefined,
        issueLinkGroups: issueLinks,
        showFeedbackCollector: false,
        ...external > 0 && {
            renderExternalLinksMessage: renderExternalLinksMessage
        },
        hideTitleWhenEmpty: true,
        canUserLinkIssue: !isIPBoardReadOnly,
        rightHeaderActions: renderToggleDependencyLinesAction()
    }));
};
var $4569487d8abf03f1$export$2e2bcd8739ae039 = $4569487d8abf03f1$var$IssueLinksDetailsGroupWrapper;
const $4569487d8abf03f1$var$externalIssueLinksStyles = (0, $8CUq3.xcss)({
    paddingBlockStart: 'space.100'
});
const $4569487d8abf03f1$var$titleStyles = (0, $8CUq3.xcss)({
    textTransform: 'uppercase',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
const $4569487d8abf03f1$var$labelStyle = null;
const $4569487d8abf03f1$var$flyoutWrapper = (0, $8CUq3.xcss)({
    minWidth: '360px',
    maxWidth: '512px'
});

});
parcelRegister("dTlW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3db77843cf29c460$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $7fA4P = parcelRequire("7fA4P");

var $aFYTH = parcelRequire("aFYTH");

var $lahQ6 = parcelRequire("lahQ6");

var $hzG2v = parcelRequire("hzG2v");
const $3db77843cf29c460$var$noop = (0, $eGmKJ.default);
const $3db77843cf29c460$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $3db77843cf29c460$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ const $3db77843cf29c460$var$Toggle = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
    const handleBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleChange = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined
    };
    const toggleStyles = (0, $5uXOq.useMemo)(()=>(0, $hzG2v.getStyles)(size), [
        size
    ]);
    const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
    const labelId = (0, $9KnKW.useId)();
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("label", {
        ...controlProps,
        css: toggleStyles
    }, label ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: labelId,
        hidden: true
    }, label) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        ref: ref,
        checked: shouldChecked,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: "checkbox",
        value: value,
        "data-testid": testId && `${testId}--input`,
        "aria-labelledby": label ? labelId : undefined,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lahQ6.default), {
        size: size,
        isHidden: !shouldChecked,
        position: "left"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fA4P))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-check-icon`
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lahQ6.default), {
        size: size,
        isHidden: shouldChecked,
        position: "right"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aFYTH))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-cross-icon`
    }))));
}));
$3db77843cf29c460$var$Toggle.displayName = 'Toggle';
var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;

});
parcelRegister("7fA4P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::116024720ac5bfd6b5d0b476c677b799>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5475eb3f94e0b044$var$_react = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5475eb3f94e0b044$var$_checkMark = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("f22iM")));

var $5475eb3f94e0b044$var$_done = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("4DXCl")));
function $5475eb3f94e0b044$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5475eb3f94e0b044$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5475eb3f94e0b044$var$_react.default.createElement($5475eb3f94e0b044$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $5475eb3f94e0b044$var$_done.default
    }, props));
$5475eb3f94e0b044$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $5475eb3f94e0b044$var$_default = module.exports.default = $5475eb3f94e0b044$var$CheckMarkIcon;

});
parcelRegister("f22iM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d905e7dc6c2480f22f2a9081c36a5712>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af18d40ba5b744b4$var$_react = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $af18d40ba5b744b4$var$_UNSAFE_baseNew = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $af18d40ba5b744b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af18d40ba5b744b4$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $af18d40ba5b744b4$var$_react.default.createElement($af18d40ba5b744b4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 6 2.75 3.5 6.25-7"/>`,
        type: 'utility'
    }, props));
$af18d40ba5b744b4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $af18d40ba5b744b4$var$_default = module.exports.default = $af18d40ba5b744b4$var$CheckMarkIcon;

});

parcelRegister("4DXCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $36190cbd288fec69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36190cbd288fec69$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $36190cbd288fec69$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $36190cbd288fec69$var$_checkMark.default
    }));
$36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;

});


parcelRegister("aFYTH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77b0cdbbee1b52bd7575a4eda010b0e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c5cf8a572bea882$var$_react = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7c5cf8a572bea882$var$_cross = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("bjGSs")));

var $7c5cf8a572bea882$var$_close = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("2C7j9")));
function $7c5cf8a572bea882$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c5cf8a572bea882$var$CrossIcon = (props)=>/*#__PURE__*/ $7c5cf8a572bea882$var$_react.default.createElement($7c5cf8a572bea882$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $7c5cf8a572bea882$var$_close.default
    }, props));
$7c5cf8a572bea882$var$CrossIcon.Name = 'CrossIconMigration';
var $7c5cf8a572bea882$var$_default = module.exports.default = $7c5cf8a572bea882$var$CrossIcon;

});
parcelRegister("bjGSs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a2857e231b7db111b6bd9efbc440f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83d2ba975692c1a3$var$_react = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83d2ba975692c1a3$var$_UNSAFE_baseNew = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83d2ba975692c1a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83d2ba975692c1a3$var$CrossIcon = (props)=>/*#__PURE__*/ $83d2ba975692c1a3$var$_react.default.createElement($83d2ba975692c1a3$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$83d2ba975692c1a3$var$CrossIcon.displayName = 'CrossIcon';
var $83d2ba975692c1a3$var$_default = module.exports.default = $83d2ba975692c1a3$var$CrossIcon;

});

parcelRegister("2C7j9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e74cc92a54dd799$var$_react = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $1e74cc92a54dd799$var$_close = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("i28qQ")));
function $1e74cc92a54dd799$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1e74cc92a54dd799$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $1e74cc92a54dd799$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $1e74cc92a54dd799$var$_close.default
    }));
$1e74cc92a54dd799$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $1e74cc92a54dd799$var$_default = module.exports.default = $1e74cc92a54dd799$var$EditorCloseIcon;

});


parcelRegister("lahQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca1cdaa1eb34599d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $ca1cdaa1eb34599d$var$iconContainerStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 0.2s ease',
    position: 'absolute',
    insetBlockStart: 'space.025'
});
const $ca1cdaa1eb34599d$var$iconContainerRegularStyles = (0, $8CUq3.xcss)({
    width: '16px',
    height: '16px'
});
const $ca1cdaa1eb34599d$var$iconContainerLargeStyles = (0, $8CUq3.xcss)({
    width: '20px',
    height: '20px'
});
const $ca1cdaa1eb34599d$var$hiddenStyles = (0, $8CUq3.xcss)({
    opacity: 0
});
const $ca1cdaa1eb34599d$var$leftStyles = (0, $8CUq3.xcss)({
    insetInlineStart: '3px'
});
const $ca1cdaa1eb34599d$var$rightStyles = (0, $8CUq3.xcss)({
    insetInlineEnd: '3px'
});
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: [
            $ca1cdaa1eb34599d$var$iconContainerStyles,
            isHidden && (0, $VSDnB.fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$hiddenStyles,
            size === 'regular' && $ca1cdaa1eb34599d$var$iconContainerRegularStyles,
            size === 'large' && $ca1cdaa1eb34599d$var$iconContainerLargeStyles,
            position === 'left' && $ca1cdaa1eb34599d$var$leftStyles,
            position === 'right' && $ca1cdaa1eb34599d$var$rightStyles
        ]
    }, children);
};
var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;

});

parcelRegister("hzG2v", function(module, exports) {

$parcel$export(module.exports, "getStyles", () => $3af6a5b9114f4fd0$export$ffd58b7f6f099a57);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $k5uoT = parcelRequire("k5uoT");

var $3VjLl = parcelRequire("3VjLl");
const $3af6a5b9114f4fd0$var$globalGridSize = (0, $k5uoT.gridSize)();
const $3af6a5b9114f4fd0$var$dimensions = {
    regular: {
        height: $3af6a5b9114f4fd0$var$globalGridSize * 2,
        width: $3af6a5b9114f4fd0$var$globalGridSize * 4
    },
    large: {
        height: $3af6a5b9114f4fd0$var$globalGridSize * 2 + $3af6a5b9114f4fd0$var$globalGridSize / 2,
        width: $3af6a5b9114f4fd0$var$globalGridSize * 5
    }
};
const $3af6a5b9114f4fd0$var$getHeight = ({ size: size })=>$3af6a5b9114f4fd0$var$dimensions[size].height;
const $3af6a5b9114f4fd0$var$getWidth = ({ size: size })=>$3af6a5b9114f4fd0$var$dimensions[size].width;
const $3af6a5b9114f4fd0$var$borderWidth = 2;
const $3af6a5b9114f4fd0$var$paddingUnitless = $3af6a5b9114f4fd0$var$globalGridSize / 4;
const $3af6a5b9114f4fd0$var$transition = 'transform 0.2s ease';
const $3af6a5b9114f4fd0$export$ffd58b7f6f099a57 = (size)=>{
    const colors = (0, $3VjLl.getColors)();
    // TODO: Use tokens and reorganize to alphasemantic ordering (DSP-11769 DSP-11770)
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview,@repo/internal/styles/consistent-style-ordering */ return /*#__PURE__*/ (0, $f8Sb3.css)({
        boxSizing: 'content-box',
        display: 'inline-block',
        padding: $3af6a5b9114f4fd0$var$borderWidth,
        margin: $3af6a5b9114f4fd0$var$borderWidth,
        backgroundClip: 'content-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: colors.backgroundColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${$3af6a5b9114f4fd0$var$getHeight({
            size: size
        })}px`,
        border: `${$3af6a5b9114f4fd0$var$borderWidth}px solid transparent`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$3af6a5b9114f4fd0$var$getHeight({
            size: size
        })}px`,
        position: 'relative',
        transition: `${$3af6a5b9114f4fd0$var$transition}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${$3af6a5b9114f4fd0$var$getWidth({
            size: size
        })}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorChecked,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorChecked
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled][data-checked],&[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        '&:focus-within': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            border: `${$3af6a5b9114f4fd0$var$borderWidth}px solid ${colors.borderColorFocus}`
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover,
            cursor: 'pointer'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:hover,&[data-disabled][data-checked]:hover,&[data-disabled]:not([data-checked]):hover': {
            cursor: 'not-allowed'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: colors.iconColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled], &[data-disabled][data-checked], &[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorDisabled
        },
        // the input element underneath
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'input[type="checkbox"]': {
            opacity: 0,
            margin: 0,
            padding: 0,
            border: 'none',
            '&:focus': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
                outline: 'none !important'
            }
        },
        // slider
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColor,
            borderRadius: "var(--ds-border-radius-circle, 50%)",
            content: '""',
            position: 'absolute',
            transform: 'initial',
            transition: $3af6a5b9114f4fd0$var$transition,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetBlockEnd: `${2 * $3af6a5b9114f4fd0$var$paddingUnitless}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${$3af6a5b9114f4fd0$var$getHeight({
                size: size
            }) - $3af6a5b9114f4fd0$var$paddingUnitless * 2}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${$3af6a5b9114f4fd0$var$getHeight({
                size: size
            }) - $3af6a5b9114f4fd0$var$paddingUnitless * 2}px`,
            // initially we set left as left-most position
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetInlineStart: `${2 * $3af6a5b9114f4fd0$var$paddingUnitless}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorChecked,
            // when  it's checked, slide the pseudo-element to right-most postion
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transform: `translateX(${$3af6a5b9114f4fd0$var$getHeight({
                size: size
            })}px)`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorDisabled,
            zIndex: 1
        },
        // Remove during new icon flag cleanup. This is required to maintain the size of legacy icons.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...size === 'large' && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        !(0, $VSDnB.fg)('platform-visual-refresh-icons') && {
            '> span > span': {
                height: '20px',
                width: '20px'
            }
        },
        '@media screen and (forced-colors: active)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::before': {
                filter: 'grayscale(100%) invert(1)'
            },
            '&:focus-within': {
                outline: '1px solid'
            }
        }
    });
};

});
parcelRegister("3VjLl", function(module, exports) {

$parcel$export(module.exports, "getColors", () => $7761f9acd89472cc$export$6cee60e8aa85e528);

const $7761f9acd89472cc$var$colorMap = {
    backgroundColorChecked: `var(--ds-background-success-bold, ${(0, $829f609a65d26a98$export$a49394138f7b8e85)})`,
    backgroundColorCheckedHover: `var(--ds-background-success-bold-hovered, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`,
    backgroundColorCheckedDisabled: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
    backgroundColorUnchecked: `var(--ds-background-neutral-bold, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
    backgroundColorUncheckedHover: `var(--ds-background-neutral-bold-hovered, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`,
    backgroundColorUncheckedDisabled: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
    borderColorFocus: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
    iconColorChecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    iconColorDisabled: `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
    iconColorUnchecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    handleBackgroundColor: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    handleBackgroundColorChecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    handleBackgroundColorDisabled: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
};
const $7761f9acd89472cc$export$6cee60e8aa85e528 = ()=>$7761f9acd89472cc$var$colorMap;

});



parcelRegister("9kb7x", function(module, exports) {

$parcel$export(module.exports, "IssueLinksDetailsGroup", () => $0a0bb7c7aa37aeeb$export$3ce52db778d29451);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $fVnbM = parcelRequire("fVnbM");

var $1dJ6S = parcelRequire("1dJ6S");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $eGcSe = parcelRequire("eGcSe");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $kAFLN = parcelRequire("kAFLN");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");


var $a0Rqo = parcelRequire("a0Rqo");

var $QVt8g = parcelRequire("QVt8g");
const $0a0bb7c7aa37aeeb$export$3ce52db778d29451 = ({ issueLinkGroups: issueLinkGroups, title: title, maxIssuesToDisplay: maxIssuesToDisplay = 50, exceedMaxSizeLinkOptions: exceedMaxSizeLinkOptions, leftFooterLinkOptions: leftFooterLinkOptions, rightFooterLinkOptions: rightFooterLinkOptions, showFeedbackCollector: showFeedbackCollector = true, feedbackCollectorPrefix: feedbackCollectorPrefix, renderExternalLinksMessage: renderExternalLinksMessage, hideTitleWhenEmpty: hideTitleWhenEmpty = false, issueTypeName: issueTypeName, canUserLinkIssue: canUserLinkIssue, rightHeaderActions: rightHeaderActions, ...rest })=>{
    const totalIssuesCount = (0, $5uXOq.useMemo)(()=>issueLinkGroups ? Object.values(issueLinkGroups).reduce((count, value)=>count + value.length, 0) : 0, [
        issueLinkGroups
    ]);
    const shouldHideTitleBlock = totalIssuesCount === 0 && hideTitleWhenEmpty;
    const renderContent = ()=>{
        let count = 0;
        if (!issueLinkGroups) return null;
        return Object.entries(issueLinkGroups).map(([key, issueLinkGroup], index)=>{
            if (count < maxIssuesToDisplay) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
                key: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a0bb7c7aa37aeeb$var$GroupTitle, null, key), issueLinkGroup.map((issue)=>{
                if (count < maxIssuesToDisplay) {
                    count++;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $QVt8g.IssueLinksDetailsContent), {
                        ...rest,
                        key: issue.key,
                        issueLink: issue,
                        canUserLinkIssue: canUserLinkIssue
                    });
                }
                return null;
            }));
            return null;
        });
    };
    const screenAnalyticsAttributes = (0, $5uXOq.useMemo)(()=>{
        if (!issueLinkGroups) return {};
        const issueLinkGroupsKeys = Object.keys(issueLinkGroups);
        // Get number of issues for each issue status
        const issuesByStatus = {};
        issueLinkGroupsKeys.forEach((issueLinkType)=>{
            issueLinkGroups[issueLinkType].forEach((issue)=>{
                if (issue.statusName) {
                    const statusAttributeName = `status_${$0a0bb7c7aa37aeeb$var$safeStatusName(issue.statusName)}_issues_count`;
                    issuesByStatus[statusAttributeName] = issuesByStatus[statusAttributeName] + 1 || 1;
                }
            });
        });
        return {
            numberOfRelationships: issueLinkGroupsKeys.length,
            relationships: issueLinkGroupsKeys.map((0, $eGcSe.safeLinkTypeName)),
            totalIssuesCount: totalIssuesCount,
            issueTypeName: (0, $a0Rqo.getAnalyticsIssueType)(issueTypeName),
            ...issuesByStatus
        };
    }, [
        issueLinkGroups,
        totalIssuesCount,
        issueTypeName
    ]);
    const feedbackCollectorLocation = feedbackCollectorPrefix ? `${feedbackCollectorPrefix}-issue-links-popup` : 'issue-links-popup';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$d1123261ca8831d2),
        sourceName: "IssueLinksDetails"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "issue-links-details.ui.box"
    }, !shouldHideTitleBlock && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        xcss: (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(rightHeaderActions) && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') ? $0a0bb7c7aa37aeeb$var$headingStyles : $0a0bb7c7aa37aeeb$var$headingStyleForHeaderWithRightAction,
        spread: "space-between",
        alignInline: "start"
    }, (0, $4R6GH.fg)('increment_board_a11y_fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1dJ6S.default), {
        size: "xxsmall",
        as: "h2"
    }, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a0bb7c7aa37aeeb$var$Title, null, title), showFeedbackCollector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kAFLN.LinkIssueFeedbackCollector), {
        feedbackCollectorLocation: feedbackCollectorLocation,
        appearance: "icon"
    }), (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') && rightHeaderActions), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $0a0bb7c7aa37aeeb$var$bodyContainerStyles,
            shouldHideTitleBlock && $0a0bb7c7aa37aeeb$var$bodyContainerHeaderHiddenStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.050"
    }, renderContent()), renderExternalLinksMessage && (!exceedMaxSizeLinkOptions || exceedMaxSizeLinkOptions && totalIssuesCount <= maxIssuesToDisplay) && renderExternalLinksMessage(), exceedMaxSizeLinkOptions && totalIssuesCount >= maxIssuesToDisplay && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockEnd: "space.100",
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: (0, $bf53f283f093ab9b$export$d2a0b679ff0ef23d),
        onClick: exceedMaxSizeLinkOptions.onClick,
        appearance: "link",
        spacing: "none"
    }, exceedMaxSizeLinkOptions.text))), (leftFooterLinkOptions || rightFooterLinkOptions) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        xcss: [
            $0a0bb7c7aa37aeeb$var$footerStyles,
            shouldHideTitleBlock && !renderExternalLinksMessage && $0a0bb7c7aa37aeeb$var$footerHeaderHiddenStyles
        ],
        spread: leftFooterLinkOptions ? 'space-between' : undefined,
        alignInline: leftFooterLinkOptions ? 'start' : 'end'
    }, leftFooterLinkOptions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $0a0bb7c7aa37aeeb$var$leftFooterButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: (0, $bf53f283f093ab9b$export$1a190d368bdba126),
        ref: leftFooterLinkOptions?.ref,
        iconBefore: leftFooterLinkOptions.icon,
        onClick: leftFooterLinkOptions?.onClick,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $0a0bb7c7aa37aeeb$var$leftFooterButtonTextStyles
    }, leftFooterLinkOptions?.text))) : null, rightFooterLinkOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: (0, $bf53f283f093ab9b$export$75bada35ed68fe7c),
        onClick: rightFooterLinkOptions.onClick,
        iconBefore: rightFooterLinkOptions.icon,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $0a0bb7c7aa37aeeb$var$rightFooterButtonStyles
    }, rightFooterLinkOptions.text))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: screenAnalyticsAttributes
    })));
};
const $0a0bb7c7aa37aeeb$var$safeStatusName = (statusName)=>{
    const status = [
        'to do',
        'in progress',
        'done'
    ];
    return status.includes(statusName.toLowerCase()) ? statusName.toLowerCase().replaceAll(' ', '_') : 'custom';
};
const $0a0bb7c7aa37aeeb$var$bodyContainerStyles = (0, $8CUq3.xcss)({
    // @ts-expect-error - TS2322 - Type 'number' is not assignable to type 'AutoComplete<"100%" | "size.100" | "size.200" | "size.300" | "size.400" | "size.500" | "size.600" | "size.1000"> | undefined'.
    maxHeight: 310,
    marginTop: 'space.100',
    overflowY: 'auto',
    overflowX: 'hidden'
});
const $0a0bb7c7aa37aeeb$var$bodyContainerHeaderHiddenStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.0'
});
const $0a0bb7c7aa37aeeb$var$footerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $gwIPs.gridSize) * 50}px`
});
const $0a0bb7c7aa37aeeb$var$footerHeaderHiddenStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.0'
});
const $0a0bb7c7aa37aeeb$var$leftFooterButtonStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.negative.075'
});
const $0a0bb7c7aa37aeeb$var$leftFooterButtonTextStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.100'
});
const $0a0bb7c7aa37aeeb$var$rightFooterButtonStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a0bb7c7aa37aeeb$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1p1dangw _11c81vlj _k48p1fw0",
            __cmplp.className
        ])
    });
});
const $0a0bb7c7aa37aeeb$var$GroupTitle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l _11c81vlj",
            __cmplp.className
        ])
    });
});
const $0a0bb7c7aa37aeeb$var$headingStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $gwIPs.gridSize) * 64}px`,
    marginRight: 'space.100'
});
const $0a0bb7c7aa37aeeb$var$headingStyleForHeaderWithRightAction = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $gwIPs.gridSize) * 64}px`
});

});
parcelRegister("eGcSe", function(module, exports) {

$parcel$export(module.exports, "safeLinkTypeName", () => $91e1e3fc148721cd$export$3562d6fc9209c3a9);
const $91e1e3fc148721cd$var$LINK_IS_BLOCKED_BY = 'is blocked by';
const $91e1e3fc148721cd$var$LINK_IS_DUPLICATED_BY = 'is duplicated by';
const $91e1e3fc148721cd$var$LINK_BLOCKS = 'BLOCKS';
const $91e1e3fc148721cd$var$LINK_IS_CLONED_BY = 'is cloned by';
const $91e1e3fc148721cd$var$LINK_CLONES = 'clones';
const $91e1e3fc148721cd$var$LINK_IS_CAUSED_BY = 'is caused by';
const $91e1e3fc148721cd$var$LINK_CAUSES = 'causes';
const $91e1e3fc148721cd$var$LINK_RELATES_TO = 'relates to';
const $91e1e3fc148721cd$var$LINK_DUPLICATES = 'duplicates';
// use LINK_CUSTOM for all custom type name
const $91e1e3fc148721cd$var$LINK_CUSTOM = 'custom';
const $91e1e3fc148721cd$var$LINK_ISSUE_TYPE = [
    $91e1e3fc148721cd$var$LINK_IS_BLOCKED_BY,
    $91e1e3fc148721cd$var$LINK_IS_DUPLICATED_BY,
    $91e1e3fc148721cd$var$LINK_BLOCKS,
    $91e1e3fc148721cd$var$LINK_IS_CLONED_BY,
    $91e1e3fc148721cd$var$LINK_CLONES,
    $91e1e3fc148721cd$var$LINK_IS_CAUSED_BY,
    $91e1e3fc148721cd$var$LINK_CAUSES,
    $91e1e3fc148721cd$var$LINK_RELATES_TO,
    $91e1e3fc148721cd$var$LINK_DUPLICATES
];
const $91e1e3fc148721cd$export$3562d6fc9209c3a9 = (value)=>// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'LinkIssueType'.
    $91e1e3fc148721cd$var$LINK_ISSUE_TYPE.includes(value) ? value : $91e1e3fc148721cd$var$LINK_CUSTOM;

});

parcelRegister("kAFLN", function(module, exports) {

$parcel$export(module.exports, "LinkIssueFeedbackCollector", () => $0a7075a3dc3139de$export$feb08f9ac25c1d45);

var $5uXOq = parcelRequire("5uXOq");

var $7iULw = parcelRequire("7iULw");

var $coTzA = parcelRequire("coTzA");
const $0a7075a3dc3139de$export$feb08f9ac25c1d45 = ({ feedbackCollectorLocation: feedbackCollectorLocation, appearance: appearance })=>{
    const additionalFields = [
        {
            id: (0, $7iULw.EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
            value: feedbackCollectorLocation
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $coTzA.FeedbackCollectorButton), {
        entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT),
        feedbackGroupId: feedbackCollectorLocation,
        additionalFields: additionalFields,
        buttonAppearance: appearance
    });
};

});
parcelRegister("coTzA", function(module, exports) {

$parcel$export(module.exports, "FeedbackCollectorButton", () => $85f5e51eda76fbac$export$b39479f42d974760);

var $5uXOq = parcelRequire("5uXOq");

var $aEHvW = parcelRequire("aEHvW");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $4uMrp = parcelRequire("4uMrp");

var $78EsV = parcelRequire("78EsV");
const $85f5e51eda76fbac$var$TooltipWrapper = ({ children: children, appearance: appearance, customLabel: customLabel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (appearance === 'icon') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: customLabel || formatMessage((0, $4uMrp.messages).leaveFeedback),
        position: "top"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $85f5e51eda76fbac$export$b39479f42d974760 = ({ buttonAppearance: buttonAppearance = 'normal', testId: testId, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($aEHvW))), feedbackButtonCustomLabel: feedbackButtonCustomLabel, ...feedbackCollectorProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const buttonRef = (0, $5uXOq.useRef)(null);
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        // Check if feedbackContext already contains the cloud ID entry
        const hasCloudId = feedbackCollectorProps?.feedbackContext?.some((entry)=>entry.id === (0, $7iULw.EntryKeys).CLOUD_ID);
        // If not, add cloud id to feedback context
        const updatedFeedbackContext = hasCloudId ? feedbackCollectorProps.feedbackContext : [
            ...feedbackCollectorProps.feedbackContext || [],
            {
                id: (0, $7iULw.EntryKeys).CLOUD_ID,
                value: cloudId
            }
        ];
        openFeedbackCollector({
            ...feedbackCollectorProps,
            feedbackContext: updatedFeedbackContext,
            triggerRef: buttonRef
        });
    }, [
        cloudId,
        feedbackCollectorProps,
        openFeedbackCollector
    ]);
    const displayAsLink = buttonAppearance === 'link';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85f5e51eda76fbac$var$TooltipWrapper, {
        appearance: buttonAppearance,
        customLabel: feedbackButtonCustomLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $78EsV.StyledButton), {
        testId: testId,
        ref: buttonRef,
        appearance: displayAsLink ? 'link' : 'subtle',
        isHighlight: buttonAppearance === 'highlight',
        spacing: displayAsLink ? 'none' : 'default',
        onClick: onOpen,
        iconBefore: displayAsLink ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
            // typesupression below can be removed once icon migration completes
            // @ts-expect-error Property 'color' does not exist on type 'IntrinsicAttributes & IconProps'.ts(2322)
            color: buttonAppearance === 'highlight' ? "var(--ds-text-discovery, #5E4DB2)" : "var(--ds-text, #172B4D)",
            label: ""
        }),
        "aria-label": feedbackButtonCustomLabel || formatMessage((0, $4uMrp.messages).leaveFeedback)
    }, buttonAppearance !== 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $4uMrp.messages).leaveFeedback))));
};

});
parcelRegister("aEHvW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06b2b9eec310f6566d6d86916ad7e234>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c1f64cf4f9c421f$var$_react = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7c1f64cf4f9c421f$var$_feedback = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5dqGX")));

var $7c1f64cf4f9c421f$var$_feedback2 = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("3g1Fk")));
function $7c1f64cf4f9c421f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "FeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c1f64cf4f9c421f$var$FeedbackIcon = (props)=>/*#__PURE__*/ $7c1f64cf4f9c421f$var$_react.default.createElement($7c1f64cf4f9c421f$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $7c1f64cf4f9c421f$var$_feedback2.default
    }, props));
$7c1f64cf4f9c421f$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $7c1f64cf4f9c421f$var$_default = module.exports.default = $7c1f64cf4f9c421f$var$FeedbackIcon;

});
parcelRegister("5dqGX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8f50fdbec38c602b5aa9320deba7858>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3cc2df171aca9493$var$_UNSAFE_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3cc2df171aca9493$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3cc2df171aca9493$var$FeedbackIcon = (props)=>/*#__PURE__*/ $3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
    }, props));
$3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;

});

parcelRegister("3g1Fk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25f4287f17f73dc4$var$_react = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $25f4287f17f73dc4$var$_feedback = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5dqGX")));
function $25f4287f17f73dc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $25f4287f17f73dc4$var$FeedbackIcon = (props)=>/*#__PURE__*/ $25f4287f17f73dc4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $25f4287f17f73dc4$var$_feedback.default
    }));
$25f4287f17f73dc4$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $25f4287f17f73dc4$var$_default = module.exports.default = $25f4287f17f73dc4$var$FeedbackIcon;

});


parcelRegister("4uMrp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0c42512912e196d1$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0c42512912e196d1$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    leaveFeedback: {
        "id": "platform.feedback.feedback-collector.button.leave-feedback",
        "defaultMessage": "Give feedback"
    }
});

});

parcelRegister("78EsV", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $7dd11fab8c31bfcb$export$2d5d2ba3c7c8c40b);
/* styled.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");
const $7dd11fab8c31bfcb$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isHighlight && "_1w901gqr _16hg1y1p _1fh11gqr _u1mb1hhp _1l5a1gfe _r7sm8kjj",
            __cmplp.className
        ])
    });
});

});



const $bf53f283f093ab9b$export$8ec69a8a56d70607 = '@atlassian/jira-issue-links-details.ui.linked-issue-card-content.linked-issue-card-content';
const $bf53f283f093ab9b$export$d2a0b679ff0ef23d = '@atlassian/jira-issue-links-details.ui.linked-issue-card-group.exceed-max-size-button';
const $bf53f283f093ab9b$export$75bada35ed68fe7c = '@atlassian/jira-issue-links-details.ui.linked-issue-card-group.right-footer-button';
const $bf53f283f093ab9b$export$1a190d368bdba126 = '@atlassian/jira-issue-links-details.ui.linked-issue-card-group.left-footer-button';
const $bf53f283f093ab9b$export$3b6b525e30ff6d4b = '@atlassian/jira-issue-links-details.ui.linked-issue-card-content.unlink-button';
const $bf53f283f093ab9b$export$f9035ef9c11822fa = '@atlassian/jira-issue-links-details.ui.linked-issue-card-content.issue-link';
const $bf53f283f093ab9b$export$6d7abc7751f4e771 = '@atlassian/jira-issue-links-details.ui.linked-issue-card-group.spinner';
const $bf53f283f093ab9b$export$e7ecdd781ae061df = '@atlassian/jira-issue-links-details.ui.linked-issue-card-content.issue-due-date-lozenge';
const $bf53f283f093ab9b$export$beb0fe4c494e9224 = '@atlassian/jira-issue-links-details.ui.linked-issue-card-content.issue-status-lozenge';

parcelRegister("a0Rqo", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsIssueType", () => $7bcb330a0bb1411d$export$385bf01e57223a7c);
const $7bcb330a0bb1411d$var$allowedIssueTypeValues = [
    'bug',
    'story',
    'task',
    'subtask',
    'epic'
];
const $7bcb330a0bb1411d$export$385bf01e57223a7c = (issueType)=>{
    const issueTypeLabel = issueType?.toLowerCase();
    return issueTypeLabel && $7bcb330a0bb1411d$var$allowedIssueTypeValues.includes(issueTypeLabel) ? issueTypeLabel : 'custom';
};

});

parcelRegister("QVt8g", function(module, exports) {

$parcel$export(module.exports, "IssueLinksDetailsContent", () => $5e621e5008c354c5$export$84ac7728cacc4b04);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $5k1dC = parcelRequire("5k1dC");

var $lj8SI = parcelRequire("lj8SI");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $9mUbn = parcelRequire("9mUbn");

var $dZHIT = parcelRequire("dZHIT");

var $itzcE = parcelRequire("itzcE");

const $5e621e5008c354c5$var$unlinkButtonSelector = 'issue-links-details-content-unlink-button';
const $5e621e5008c354c5$export$84ac7728cacc4b04 = ({ issueLink: issueLink, onIssueClicked: onIssueClicked, onUnlinkIssue: onUnlinkIssue, unlinkIssueButtonTooltipText: unlinkIssueButtonTooltipText, showBlockedTime: showBlockedTime, canUserLinkIssue: canUserLinkIssue })=>{
    const onIssueClickedCallback = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        onIssueClicked?.(analyticsEvent);
    }, [
        onIssueClicked
    ]);
    const [isIssueFocused, setIsIssueFocused] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5e621e5008c354c5$var$IssueDetailsRow, {
        key: issueLink.key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.050",
        xcss: $5e621e5008c354c5$var$componentStyles,
        testId: (0, $bf53f283f093ab9b$export$8ec69a8a56d70607)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZHIT.IssueType), {
        issueTypeName: issueLink.issueTypeName,
        issueTypeIconUrl: issueLink.issueTypeIconUrl,
        isDraggable: false,
        isActionVisible: false,
        restrictedReorderingMessage: issueLink.issueTypeName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5e621e5008c354c5$var$issueContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        xcss: $5e621e5008c354c5$var$anchorStyles,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        href: `${window.location.protocol}//${window.location.hostname}/browse/${issueLink.key}`,
        target: "_blank",
        testId: (0, $bf53f283f093ab9b$export$f9035ef9c11822fa),
        onClick: onIssueClickedCallback,
        onFocus: ()=>setIsIssueFocused(true),
        onBlur: ()=>setIsIssueFocused(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: issueLink.key
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5e621e5008c354c5$var$IssueKey, tooltipProps, issueLink.key)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: issueLink.text
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5e621e5008c354c5$var$IssueText, tooltipProps, issueLink.text))))), issueLink.dueDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        testId: (0, $bf53f283f093ab9b$export$e7ecdd781ae061df),
        justifyContent: "end",
        gap: issueLink.offtrackLabel ? 'space.100' : undefined,
        xcss: $5e621e5008c354c5$var$dueDateStyles,
        alignItems: issueLink.offtrackLabel ? 'center' : undefined
    }, issueLink.offtrackLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.danger"
    }, " ", issueLink.offtrackLabel, " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $itzcE.CardDueDate), {
        dueDate: issueLink.dueDate
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        testId: (0, $bf53f283f093ab9b$export$beb0fe4c494e9224),
        justifyContent: "end",
        gap: issueLink.offtrackLabel ? 'space.100' : undefined,
        alignItems: issueLink.offtrackLabel ? 'center' : undefined,
        xcss: $5e621e5008c354c5$var$lozengeWrapperStyles
    }, !issueLink.dueDate && issueLink.offtrackLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.danger"
    }, " ", issueLink.offtrackLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: issueLink.statusName
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
            appearance: (0, $9mUbn.toAppearance)(issueLink.statusCategoryId)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", tooltipProps, issueLink.statusName)))), showBlockedTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5e621e5008c354c5$var$BlockedTimeText, null, issueLink.blockedTime), canUserLinkIssue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $5e621e5008c354c5$var$unlinkButtonContainerStyles,
            isIssueFocused && $5e621e5008c354c5$var$unlinkButtonContainerForceFocusStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: unlinkIssueButtonTooltipText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        "data-styled-selector": $5e621e5008c354c5$var$unlinkButtonSelector,
        testId: (0, $bf53f283f093ab9b$export$3b6b525e30ff6d4b),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5k1dC))),
        label: unlinkIssueButtonTooltipText,
        onClick: (event)=>onUnlinkIssue(issueLink, event),
        appearance: "subtle",
        spacing: "compact"
    })))));
};
const $5e621e5008c354c5$var$dueDateStyles = (0, $8CUq3.xcss)({
    flexShrink: 0
});
const $5e621e5008c354c5$var$lozengeWrapperStyles = (0, $8CUq3.xcss)({
    flexShrink: 0,
    flexGrow: 1
});
const $5e621e5008c354c5$var$componentStyles = (0, $8CUq3.xcss)({
    color: 'color.text',
    height: 'size.300',
    paddingRight: 'space.050'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $5e621e5008c354c5$var$BlockedTimeText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _11c81vlj _1bsbymf6 _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $5e621e5008c354c5$var$issueContainerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    minWidth: '0%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $5e621e5008c354c5$var$IssueText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syazloe7 _k48p4jg8 _1reo15vq _18m915vq _1bto1l2s _o5721q9c _y3gn1e5h _19pkidpf",
            __cmplp.className
        ])
    });
});
const $5e621e5008c354c5$var$IssueKey = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8qk37 _k48pbfng _4bfu18uv _1hmsglyw _ajmmnqa1 _o5721q9c _1bsb8vuz _1o9zidpf _1reo15vq _18m915vq _1bto1l2s _y3gn1e5h _1eim1xrj _syaz1y58 _ca0qv77o",
            __cmplp.className
        ])
    });
});
const $5e621e5008c354c5$var$unlinkButtonContainerStyles = (0, $8CUq3.xcss)({
    button: {
        opacity: 0,
        ':focus': {
            opacity: 1
        }
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @typescript-eslint/consistent-type-assertions, @atlaskit/design-system/consistent-css-prop-usage
const $5e621e5008c354c5$var$unlinkButtonContainerForceFocusStyles = (0, $8CUq3.xcss)({
    button: {
        opacity: 1
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e621e5008c354c5$var$IssueDetailsRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_dx7nkb7n",
            __cmplp.className
        ])
    });
});
const $5e621e5008c354c5$var$anchorStyles = (0, $8CUq3.xcss)({
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline'
    }
});

});
parcelRegister("5k1dC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f4bcbf3be79d58e8d29c69c413da605>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3dffc3febc1a6df3$var$_react = $3dffc3febc1a6df3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3dffc3febc1a6df3$var$_linkBroken = $3dffc3febc1a6df3$var$_interopRequireDefault((parcelRequire("90mMF")));

var $3dffc3febc1a6df3$var$_unlink = $3dffc3febc1a6df3$var$_interopRequireDefault((parcelRequire("fKe1H")));
function $3dffc3febc1a6df3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LinkBrokenIcon.
 * This component is LinkBrokenIcon, with `UNSAFE_fallbackIcon` set to "UnlinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3dffc3febc1a6df3$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $3dffc3febc1a6df3$var$_react.default.createElement($3dffc3febc1a6df3$var$_linkBroken.default, Object.assign({
        LEGACY_fallbackIcon: $3dffc3febc1a6df3$var$_unlink.default
    }, props));
$3dffc3febc1a6df3$var$LinkBrokenIcon.Name = 'LinkBrokenIconMigration';
var $3dffc3febc1a6df3$var$_default = module.exports.default = $3dffc3febc1a6df3$var$LinkBrokenIcon;

});
parcelRegister("90mMF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f9b1456f23f422657b1d47e7598e6030>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68e5c989bea2984f$var$_react = $68e5c989bea2984f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $68e5c989bea2984f$var$_UNSAFE_baseNew = $68e5c989bea2984f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $68e5c989bea2984f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LinkBroken".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $68e5c989bea2984f$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $68e5c989bea2984f$var$_react.default.createElement($68e5c989bea2984f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m3.5 8-.75.75a3.182 3.182 0 0 0 4.5 4.5L8 12.5m0-9 .75-.75a3.182 3.182 0 0 1 4.5 4.5L12.5 8M5.25 1v3M1 5.25h3m11 5.5h-3M10.75 15v-3"/>`
    }, props));
$68e5c989bea2984f$var$LinkBrokenIcon.displayName = 'LinkBrokenIcon';
var $68e5c989bea2984f$var$_default = module.exports.default = $68e5c989bea2984f$var$LinkBrokenIcon;

});

parcelRegister("fKe1H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b766083acbc37908$var$_react = $b766083acbc37908$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $b766083acbc37908$var$_linkBroken = $b766083acbc37908$var$_interopRequireDefault((parcelRequire("90mMF")));
function $b766083acbc37908$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b766083acbc37908$var$UnlinkIcon = (props)=>/*#__PURE__*/ $b766083acbc37908$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.72 14.43a.97.97 0 0 0-1.37 0l-2.09 2.06a1.93 1.93 0 0 1-1.37.57c-.59 0-1.13-.26-1.52-.74-.63-.78-.5-1.93.2-2.64l1.32-1.32.69-.69a.97.97 0 0 0 0-1.38.97.97 0 0 0-1.37 0l-2.07 2.07a3.89 3.89 0 0 0 0 5.5l.01.01A3.87 3.87 0 0 0 8.89 19a3.87 3.87 0 0 0 2.75-1.14l2.08-2.08a.95.95 0 0 0 0-1.34m-3.44-4.87a.97.97 0 0 0 1.37 0l2.09-2.06c.37-.37.85-.57 1.37-.57.59 0 1.14.26 1.53.74.63.78.51 1.93-.2 2.64l-1.32 1.32-.69.69a.97.97 0 0 0 0 1.38c.38.38 1 .38 1.38 0l2.07-2.07a3.89 3.89 0 0 0 0-5.5l-.01-.01A3.87 3.87 0 0 0 15.11 5a3.87 3.87 0 0 0-2.75 1.14l-2.08 2.09a.95.95 0 0 0 0 1.35M8.92 4.62l.4.97a1 1 0 1 1-1.85.77l-.4-.97a1 1 0 1 1 1.85-.76M5.38 7.08l.97.4a1 1 0 0 1-.77 1.85l-.97-.4a1 1 0 0 1 .77-1.85m9.94 10.41a1 1 0 0 0-.54 1.31l.4.97a1 1 0 1 0 1.84-.77l-.4-.97a1 1 0 0 0-1.31-.54m2.18-2.17a1 1 0 0 0 .54 1.31l.97.4a1 1 0 0 0 .77-1.85l-.97-.4a1 1 0 0 0-1.31.54"/></svg>`
    }, props, {
        newIcon: $b766083acbc37908$var$_linkBroken.default
    }));
$b766083acbc37908$var$UnlinkIcon.displayName = 'UnlinkIcon';
var $b766083acbc37908$var$_default = module.exports.default = $b766083acbc37908$var$UnlinkIcon;

});


parcelRegister("9mUbn", function(module, exports) {

$parcel$export(module.exports, "toAppearance", () => $9dc895705c6c17d4$export$cbc76b787f60c037);

var $gULOk = parcelRequire("gULOk");
const $9dc895705c6c17d4$var$appearanceMap = {
    [(0, $gULOk.UNDEFINED)]: 'default',
    [(0, $gULOk.TODO)]: 'default',
    [(0, $gULOk.DONE)]: 'success',
    [(0, $gULOk.IN_PROGRESS)]: 'inprogress'
};
const $9dc895705c6c17d4$export$cbc76b787f60c037 = (categoryId)=>categoryId ? $9dc895705c6c17d4$var$appearanceMap[(0, $gULOk.statusCategoryForId)(categoryId)] : $9dc895705c6c17d4$var$appearanceMap[0, $gULOk.UNDEFINED];

});

parcelRegister("dZHIT", function(module, exports) {

$parcel$export(module.exports, "IssueType", () => $e085c81809328c83$export$dce4ecf18820e992);

var $5uXOq = parcelRequire("5uXOq");

var $78tet = parcelRequire("78tet");


var $3bDjY = parcelRequire("3bDjY");

var $jjlQu = parcelRequire("jjlQu");

var $aWse0 = parcelRequire("aWse0");

var $dnq3H = parcelRequire("dnq3H");

var $6tuQE = parcelRequire("6tuQE");
const $e085c81809328c83$export$dce4ecf18820e992 = /*#__PURE__*/ (0, $5uXOq.memo)(({ issueTypeName: issueTypeName, issueTypeIconUrl: issueTypeIconUrl, isDraggable: isDraggable, isActionVisible: isActionVisible, restrictedReorderingMessage: restrictedReorderingMessage, onHandleUserClickAnalytics: onHandleUserClickAnalytics, reorderMenu: reorderMenu, issueTypeIcon: issueTypeIcon })=>{
    const intl = (0, $aWse0.useIntlV2)();
    const title = intl.formatMessage((0, $dnq3H.default).issueTypeTitle, {
        issueTypeName: issueTypeName
    });
    const hasValidRestrictedMessage = restrictedReorderingMessage !== '';
    const tooltipContent = issueTypeName || '';
    const action = reorderMenu || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($78tet))), {
        label: "",
        primaryColor: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`
    });
    // Using an intermediate div(TypeIconContainer) since AKTooltip needs an element to bind to
    // We aren't wrapping just ListIcon or AsyncIcon since AKTooltip is stateful
    // and we don't want it to unmount as the mouseHover changes
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: !isDraggable && hasValidRestrictedMessage ? String(restrictedReorderingMessage) : tooltipContent,
        hideTooltipOnMouseDown: isDraggable,
        position: "top",
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "issue-line-card.issue-type.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6tuQE.TypeIconContainer), {
        onClick: ()=>onHandleUserClickAnalytics?.('typeIcon'),
        "data-testid": "issue-line-card-issue-type.issue-type",
        isActionVisible: isDraggable && isActionVisible,
        isRestricted: hasValidRestrictedMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6tuQE.InnerIconContainer), null, issueTypeIcon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjlQu.default), {
        alt: title,
        url: issueTypeIconUrl
    })), isDraggable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6tuQE.InnerActionContainer), null, action)));
});

});
parcelRegister("78tet", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $531ff4bbcd008815$var$_react = $531ff4bbcd008815$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $531ff4bbcd008815$var$_dragHandle = $531ff4bbcd008815$var$_interopRequireDefault((parcelRequire("idRxN")));
function $531ff4bbcd008815$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $531ff4bbcd008815$var$DragHandlerIcon = (props)=>/*#__PURE__*/ $531ff4bbcd008815$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="10" cy="8" r="1"/><circle cx="14" cy="8" r="1"/><circle cx="10" cy="16" r="1"/><circle cx="14" cy="16" r="1"/><circle cx="10" cy="12" r="1"/><circle cx="14" cy="12" r="1"/></g></svg>`
    }, props, {
        newIcon: $531ff4bbcd008815$var$_dragHandle.default
    }));
$531ff4bbcd008815$var$DragHandlerIcon.displayName = 'DragHandlerIcon';
var $531ff4bbcd008815$var$_default = module.exports.default = $531ff4bbcd008815$var$DragHandlerIcon;

});
parcelRegister("idRxN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b639051269ef116e35808d9097e35bf1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d442f9a78d3217d7$var$_react = $d442f9a78d3217d7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d442f9a78d3217d7$var$_UNSAFE_baseNew = $d442f9a78d3217d7$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d442f9a78d3217d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "DragHandle".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for draggable elements.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d442f9a78d3217d7$var$DragHandleIcon = (props)=>/*#__PURE__*/ $d442f9a78d3217d7$var$_react.default.createElement($d442f9a78d3217d7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
$d442f9a78d3217d7$var$DragHandleIcon.displayName = 'DragHandleIcon';
var $d442f9a78d3217d7$var$_default = module.exports.default = $d442f9a78d3217d7$var$DragHandleIcon;

});


parcelRegister("jjlQu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7f7206d8a029d15$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ /* eslint-disable jira/react/handler-naming */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");
const $e7f7206d8a029d15$export$c6d2b2df39d78e5b = (0, $gwIPs.gridSize) * 2;
class $e7f7206d8a029d15$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            url: undefined,
            title: undefined,
            alt: undefined,
            width: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
            height: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
            fallback: undefined
        };
    }
    render() {
        const { title: title, url: url, alt: alt, fallback: fallback } = this.props;
        const width = this.convertSize(this.props.width);
        const height = this.convertSize(this.props.height);
        if (this.state.isBroken && fallback) return fallback();
        if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e7f7206d8a029d15$var$Image, {
            src: url,
            width: width,
            height: height,
            title: title ?? undefined,
            alt: alt ?? '',
            onError: this.onError,
            draggable: false
        });
        return (0, $4R6GH.fg)('jfp-1020-use-compiled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $e7f7206d8a029d15$var$placeholderStyles,
            style: {
                height: height,
                width: width
            },
            backgroundColor: "color.background.input.hovered",
            testId: "common-components-async-icon.placeholder"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e7f7206d8a029d15$var$ImagePlaceholder, {
            width: width,
            height: height,
            "data-testid": "common-components-async-icon.placeholder"
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isBroken: false
        };
        this.onError = ()=>{
            this.setState({
                isBroken: true
            });
        };
        this.convertSize = (size)=>size ? `${size}px` : '0';
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e7f7206d8a029d15$var$ImagePlaceholder = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "owe24v-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $829f609a65d26a98$exports).N30,
        borderRadius: '3px',
        display: 'flex',
        flex: 'none'
    }));
const $e7f7206d8a029d15$var$placeholderStyles = (0, $8CUq3.xcss)({
    borderRadius: '3px',
    display: 'flex',
    flex: 'none'
}); // Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e7f7206d8a029d15$var$Image = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dnq3H", function(module, exports) {

$parcel$export(module.exports, "default", () => $5472b54f8b4cd33c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5472b54f8b4cd33c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueTypeTitle: {
        "id": "issue-line-card-issue-type.issue-type-title",
        "defaultMessage": "Issue type: {issueTypeName}"
    }
});

});

parcelRegister("6tuQE", function(module, exports) {

$parcel$export(module.exports, "TypeIconContainer", () => $0bb1dbcb01f6349f$export$7c6a427e0041cef8);
$parcel$export(module.exports, "InnerIconContainer", () => $0bb1dbcb01f6349f$export$50e7a20632ac4b91);
$parcel$export(module.exports, "InnerActionContainer", () => $0bb1dbcb01f6349f$export$cef004ee3f680209);
/* styled.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $feYbq = parcelRequire("feYbq");
const $0bb1dbcb01f6349f$export$f2a139e5d18b9882 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $feYbq.FlexContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_80om1qgj",
            __cmplp.className
        ])
    });
});
const $0bb1dbcb01f6349f$export$c41c6e4e73f730b7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $feYbq.FlexContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_80om13gf _16l4105o",
            __cmplp.className
        ])
    });
});
const $0bb1dbcb01f6349f$export$7c6a427e0041cef8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActionVisible: isActionVisible, isRestricted: isRestricted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _1e0c11p5 _1lmc1n2u _4cvr1h6o _6a6z1h6o _otawkb7n _a8tgkb7n",
            __cmplp.isActionVisible ? "_1telkb7n" : "_1telidpf",
            __cmplp.isRestricted && "_80om13gf _16l4105o",
            __cmplp.className
        ])
    });
});
const $0bb1dbcb01f6349f$export$50e7a20632ac4b91 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_nd5l1n2u _1e0c116y _tzy41y4k _lcxvglyw",
            __cmplp.className
        ])
    });
});
const $0bb1dbcb01f6349f$export$cef004ee3f680209 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_nd5l1n2u _1e0c116y _4cvr1h6o _1bah1h6o _tzy41aa5",
            __cmplp.className
        ])
    });
});

});
parcelRegister("feYbq", function(module, exports) {

$parcel$export(module.exports, "FlexContainer", () => $1c7daba916c36974$export$124d4c7bf7db9715);
/* styled.tsx generated by @compiled/babel-plugin v0.31.0 */ // eslint-disable-next-line import/order

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $1c7daba916c36974$export$124d4c7bf7db9715 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $1c7daba916c36974$export$6ca3a7bb21565c7a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $1c7daba916c36974$export$124d4c7bf7db9715, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bvftgi",
            __cmplp.className
        ])
    });
});

});





parcelRegister("2Nvkb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c0c51f151bc35cd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c0c51f151bc35cd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.title",
        "defaultMessage": "DEPENDENCIES"
    },
    addDependency: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.add-dependency",
        "defaultMessage": "Add dependency"
    },
    viewAllDependencies: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.view-all-dependencies",
        "defaultMessage": "View all dependencies"
    },
    removeDependency: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.remove-dependency",
        "defaultMessage": "Remove dependency"
    },
    addDependencyKey: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.add-dependency-key",
        "defaultMessage": "Add dependency"
    },
    addDependencyCta: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.add-dependency-cta",
        "defaultMessage": "Add"
    },
    externalIssueLinksDescription: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.external-issue-links-description",
        "defaultMessage": "{externalIssueLinksCount} {externalIssueLinksCount, plural, one {dependency} other {dependencies}} not shown on this board"
    },
    externalIssueLinksTitle: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.external-issue-links-title",
        "defaultMessage": "Not on this board"
    },
    showLinesTitle: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.show-lines-title",
        "defaultMessage": "Show lines"
    },
    unlinkIssues: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.unlink-issues",
        "defaultMessage": "Unlink issues"
    },
    externalIssueLinksDescriptionIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.external-issue-links-description-issue-term-refresh",
        "defaultMessage": "{externalIssueLinksCount} {externalIssueLinksCount, plural, one {dependency} other {dependencies}} not shown on this board"
    },
    labelForShowLinesToggle: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.label-for-show-lines-toggle",
        "defaultMessage": "Changing this toggle will show or hide the dependency lines"
    },
    tooltipForShowLinesToggle: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.tooltip-for-show-lines-toggle",
        "defaultMessage": "Lines only show once an issue has been scheduled."
    },
    offtrackLabel: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.offtrack-label",
        "defaultMessage": "off-track"
    }
});

});


parcelRegister("dlhFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a40f7ef1d74e6fe9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a40f7ef1d74e6fe9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewDependencyDetails: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.view-dependency-details",
        "defaultMessage": "View dependency details"
    }
});

});


parcelRegister("2H35T", function(module, exports) {

$parcel$export(module.exports, "IssueLinksStats", () => $c0209f570fa75393$export$471e3cf08f140899);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $dzmFY = parcelRequire("dzmFY");

var $iDGXn = parcelRequire("iDGXn");

var $67sX6 = parcelRequire("67sX6");

var $4vVV6 = parcelRequire("4vVV6");

var $5tA4K = parcelRequire("5tA4K");

var $d2i8f = parcelRequire("d2i8f");
const $c0209f570fa75393$export$471e3cf08f140899 = ({ id: id, typeId: typeId, issueKey: issueKey, summary: summary, onIssueUnlink: onIssueUnlink })=>{
    const shouldShowIssueLinksStats = (0, $iDGXn.useShowIssueLinksStats)();
    const issueLinksCount = (0, $67sX6.useBoardSelector)((state)=>(0, $5tA4K.getIssueLinksStatsForCard)(state)(`${id}`));
    const isLoadingIssueLinkStats = (0, $67sX6.useBoardSelector)((state)=>(0, $5tA4K.getIsLoadingIssueLinksStatsForCard)(state)(`${id}`));
    const { canUserLinkIssue: canUserLinkIssue } = (0, $67sX6.useBoardSelector)((boardState)=>(0, $4vVV6.getIssueLinksPermissions)(boardState));
    const issueType = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIssueTypeById)(state, Number(typeId)));
    if (!id || !shouldShowIssueLinksStats || issueLinksCount <= 0 && !isLoadingIssueLinkStats) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dzmFY.IssueLinksStats), {
        issueLinksCount: issueLinksCount,
        issueKey: issueKey,
        issueId: `${id}`,
        issueSummary: summary,
        issueType: issueType,
        isLoading: isLoadingIssueLinkStats,
        feedbackCollectorPrefix: "board",
        onIssueUnlink: onIssueUnlink,
        canUserLinkIssue: canUserLinkIssue,
        withDueDate: false,
        sourceProductType: (0, $2vSU6.SOFTWARE_PROJECT)
    });
};

});
parcelRegister("dzmFY", function(module, exports) {

$parcel$export(module.exports, "IssueLinksStats", () => $d6d4cb6e75560e61$export$471e3cf08f140899);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $3APXE = parcelRequire("3APXE");
const $d6d4cb6e75560e61$export$471e3cf08f140899 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "jira-issue-links-stats",
        packageName: "jiraIssueLinksStats",
        teamName: "jira-werewolves",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3APXE.IssueLinksStats), props));

});
parcelRegister("3APXE", function(module, exports) {

$parcel$export(module.exports, "IssueLinksStats", () => $7d164ade27960df7$export$471e3cf08f140899);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $eaGfl = parcelRequire("eaGfl");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $iXVV6 = parcelRequire("iXVV6");

var $efvDm = parcelRequire("efvDm");

var $7dRcU = parcelRequire("7dRcU");

var $hq3QC = parcelRequire("hq3QC");

var $kL33h = parcelRequire("kL33h");

const $7d164ade27960df7$export$471e3cf08f140899 = ({ issueLinksCount: issueLinksCount, testId: testId, issueKey: issueKey, issueId: issueId, issueSummary: issueSummary, issueType: issueType, onIssueUnlink: onIssueUnlink, feedbackCollectorPrefix: feedbackCollectorPrefix, isLoading: isLoading = false, canUserLinkIssue: canUserLinkIssue, withDueDate: withDueDate = false, maxIssueLinksStatsCount: maxIssueLinksStatsCount = (0, $07ef59ce637b0eaa$export$1e94b9630d01edd3), sourceProductType: sourceProductType, isLinkIssuePopupEnabled: isLinkIssuePopupEnabled = false, onSuccessfulIssueLink: onSuccessfulIssueLink = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const { isFocusOnIssueLinksStats: isFocusOnIssueLinksStats, focusOnIssueLinks: focusOnIssueLinks } = (0, $hq3QC.useFocusOnIssueLinksStats)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "issueLinksStats",
        attributes: {
            application: sourceProductType && (0, $efvDm.getApplicationForProject)(sourceProductType)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7dRcU.IssueLinkedStatsContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7d164ade27960df7$var$issueStatsRowStyles,
        testId: testId,
        onClick: (event)=>event.stopPropagation(),
        onBlur: (event)=>event.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        shouldWrap: true,
        space: "space.050"
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7d164ade27960df7$var$skeletonLoaderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaGfl.default), {
        isShimmering: true,
        width: "100%",
        testId: testId ? `${testId}.skeleton-loader` : undefined
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kL33h.IssueLinksStatsButton), {
        issueKey: issueKey,
        issueId: issueId,
        issueSummary: issueSummary,
        issueType: issueType,
        issueLinkCount: issueLinksCount,
        isFocusOnTrigger: isFocusOnIssueLinksStats,
        feedbackCollectorPrefix: feedbackCollectorPrefix,
        onIssueUnlink: onIssueUnlink,
        onFocusToTrigger: focusOnIssueLinks,
        canUserLinkIssue: canUserLinkIssue,
        withDueDate: withDueDate,
        maxIssueLinksStatsCount: maxIssueLinksStatsCount,
        sourceProductType: sourceProductType,
        isLinkIssuePopupEnabled: isLinkIssuePopupEnabled,
        onSuccessfulIssueLink: onSuccessfulIssueLink
    })))));
};
const $7d164ade27960df7$var$issueStatsRowStyles = (0, $8CUq3.xcss)({
    cursor: 'default',
    borderTop: 'none'
});
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $7d164ade27960df7$var$skeletonLoaderStyles = (0, $8CUq3.xcss)({
    width: '29px',
    maxWidth: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    div: {
        width: '100%',
        padding: '0',
        '::after': {
            height: '23px',
            borderRadius: `${"var(--ds-border-radius-050, 3px)"}`
        }
    }
});

});
parcelRegister("hq3QC", function(module, exports) {

$parcel$export(module.exports, "useFocusOnIssueLinksStats", () => $4735d091759d52b4$export$1eb968fd055a41eb);
$parcel$export(module.exports, "useFocusOnIssueLinksStatsEffect", () => $4735d091759d52b4$export$21fe799ef0ecc038);

var $5uXOq = parcelRequire("5uXOq");
const $4735d091759d52b4$export$1eb968fd055a41eb = ()=>{
    const [isFocusOnIssueLinksStats, setIsFocusOnIssueLinksStats] = (0, $5uXOq.useState)(false);
    return {
        isFocusOnIssueLinksStats: isFocusOnIssueLinksStats,
        focusOnIssueLinks: setIsFocusOnIssueLinksStats
    };
};
const $4735d091759d52b4$export$21fe799ef0ecc038 = ({ isFocusOnTrigger: isFocusOnTrigger, onFocusToTrigger: onFocusToTrigger })=>{
    const openTriggerRef = (0, $5uXOq.useRef)(null);
    const updateRef = (0, $5uXOq.useCallback)((element)=>{
        openTriggerRef.current = element;
    }, [
        openTriggerRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isFocusOnTrigger) return;
        openTriggerRef.current?.focus();
        onFocusToTrigger(false);
    }, [
        isFocusOnTrigger,
        onFocusToTrigger,
        openTriggerRef
    ]);
    return updateRef;
};

});

parcelRegister("kL33h", function(module, exports) {

$parcel$export(module.exports, "IssueLinksStatsButton", () => $f6076da76b5bf322$export$dae0579b240a5f3b);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $7dRcU = parcelRequire("7dRcU");

var $lwYZK = parcelRequire("lwYZK");

var $5BMYo = parcelRequire("5BMYo");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $f6076da76b5bf322$var$noop = ()=>{};
const $f6076da76b5bf322$export$dae0579b240a5f3b = ({ issueLinkCount: issueLinkCount, issueKey: issueKey, issueId: issueId, issueSummary: issueSummary, issueType: issueType, isFocusOnTrigger: isFocusOnTrigger, feedbackCollectorPrefix: feedbackCollectorPrefix, onIssueUnlink: onIssueUnlink, onFocusToTrigger: onFocusToTrigger, canUserLinkIssue: canUserLinkIssue, withDueDate: withDueDate = false, maxIssueLinksStatsCount: maxIssueLinksStatsCount, sourceProductType: sourceProductType, onSuccessfulIssueLink: onSuccessfulIssueLink = $f6076da76b5bf322$var$noop, isLinkIssuePopupEnabled: isLinkIssuePopupEnabled = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isOpen = (0, $7dRcU.useIsIssueLinkDetailsPopupOpen)({
        openedIssueKey: issueKey
    });
    const issueLinkCountDisplay = issueLinkCount > maxIssueLinksStatsCount ? `${maxIssueLinksStatsCount}+` : issueLinkCount;
    const tooltipContent = issueLinkCount > maxIssueLinksStatsCount ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5BMYo.messages).genericMaxIssueLinksStatsTooltipLabelIssueTermRefresh : (0, $5BMYo.messages).genericMaxIssueLinksStatsTooltipLabel, {
        maxIssueLinksStatsCount: maxIssueLinksStatsCount
    }) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5BMYo.messages).issueLinksTooltipLabelIssueTermRefresh : (0, $5BMYo.messages).issueLinksTooltipLabel, {
        issueLinkCount: issueLinkCount
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: isOpen ? '' : tooltipContent,
        testId: "issue-links-stats.ui.issue-links-stats-button.linked-issue-stats-tooltip",
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lwYZK.IssueLinksDetailsPopupEntryPointContainer), {
        isOpen: isOpen,
        isFocusOnTrigger: isFocusOnTrigger,
        issueId: issueId,
        issueLinkCount: issueLinkCountDisplay,
        issueSummary: issueSummary,
        issueType: issueType,
        issueKey: issueKey,
        feedbackCollectorPrefix: feedbackCollectorPrefix,
        onIssueUnlink: onIssueUnlink,
        onFocusToTrigger: onFocusToTrigger,
        canUserLinkIssue: canUserLinkIssue,
        iconLabel: tooltipContent,
        withDueDate: withDueDate,
        sourceProductType: sourceProductType,
        onSuccessfulIssueLink: onSuccessfulIssueLink,
        isLinkIssuePopupEnabled: isLinkIssuePopupEnabled
    }));
};

});
parcelRegister("lwYZK", function(module, exports) {

$parcel$export(module.exports, "IssueLinksDetailsPopupEntryPointContainer", () => $f91362c69c59b48b$export$b0a7e2f26787ad5d);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $eyYcL = parcelRequire("eyYcL");

var $lJosW = parcelRequire("lJosW");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $dGrdR = parcelRequire("dGrdR");

var $gwIPs = parcelRequire("gwIPs");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $HeOPt = parcelRequire("HeOPt");

var $bMyiD = parcelRequire("bMyiD");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $dCm1o = parcelRequire("dCm1o");

var $7dRcU = parcelRequire("7dRcU");

var $hq3QC = parcelRequire("hq3QC");

var $aygpR = parcelRequire("aygpR");

var $cIlUQ = parcelRequire("cIlUQ");

var $7O6AD = parcelRequire("7O6AD");

var $9RuF6 = parcelRequire("9RuF6");

var $adSHj = parcelRequire("adSHj");
const $f91362c69c59b48b$var$MAX_ISSUE_LINKS_COUNT = 50;
const $f91362c69c59b48b$var$asyncIssueLinksDetailsLoad = (0, $dGrdR.metrics).interaction({
    key: 'issue-links-details-content-load'
});
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $f91362c69c59b48b$var$noop = ()=>{};
const $f91362c69c59b48b$export$b0a7e2f26787ad5d = ({ issueKey: issueKey, isOpen: isOpen, isFocusOnTrigger: isFocusOnTrigger = false, issueId: issueId, issueSummary: issueSummary, issueType: issueType, issueLinkCount: issueLinkCount, feedbackCollectorPrefix: feedbackCollectorPrefix, onIssueUnlink: onIssueUnlink, canUserLinkIssue: canUserLinkIssue, onFocusToTrigger: onFocusToTrigger = $f91362c69c59b48b$var$noop, iconLabel: iconLabel = '', withDueDate: withDueDate = false, sourceProductType: sourceProductType, onSuccessfulIssueLink: onSuccessfulIssueLink = $f91362c69c59b48b$var$noop, isLinkIssuePopupEnabled: isLinkIssuePopupEnabled = false })=>{
    const { handleOnClose: handleOnClose, handleOnOpenLinkedIssueDetailsPopup: handleOnOpenLinkedIssueDetailsPopup } = (0, $7dRcU.useIssueLinkedStatsActions)();
    const [state, { setIssueLinkModalEntryPointSubject: setIssueLinkModalEntryPointSubject }] = (0, $HeOPt.useIssueLinkedModalEntrypointStore)();
    const cloudId = (0, $koeKL.useCloudId)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            issueKey: issueKey,
            // Fetch 1 more than required so that we show view all linked issues button
            issueCount: $f91362c69c59b48b$var$MAX_ISSUE_LINKS_COUNT + 1,
            withDueDate: withDueDate,
            fields: [
                'issuetype',
                'summary',
                'status',
                ...withDueDate ? [
                    'duedate'
                ] : []
            ]
        }), [
        cloudId,
        issueKey,
        withDueDate
    ]);
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions, stopMetric: stopMetric } = (0, $4mO32.useEntryPoint)((0, $bMyiD.issueLinksDetailsContentEntryPoint), entryPointParams, $f91362c69c59b48b$var$asyncIssueLinksDetailsLoad);
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const handleButtonClicked = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        event.stopPropagation();
        setIssueLinkModalEntryPointSubject({
            issueData: null
        });
        // Click the button to open details popup, and click again to close it.
        if (isOpen) handleOnClose();
        else handleOnOpenLinkedIssueDetailsPopup(issueKey);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'issueLinksStats', {
            isToOpenPopup: !isOpen
        });
    }, [
        handleOnClose,
        handleOnOpenLinkedIssueDetailsPopup,
        isOpen,
        issueKey,
        setIssueLinkModalEntryPointSubject
    ]);
    const updateTriggerRefOnIssueLinksStatsClose = (0, $aygpR.useHandleOnIssueLinksStatsClose)({
        isIssueLinkStatsOpen: isOpen,
        isLinkIssueModalOpen: Boolean(state.issueData?.issueKey === issueKey)
    });
    const handleOnIssueUnlink = (0, $5uXOq.useCallback)((issueIds)=>{
        handleOnClose();
        onIssueUnlink?.(issueIds);
        onFocusToTrigger(true);
    }, [
        handleOnClose,
        onFocusToTrigger,
        onIssueUnlink
    ]);
    const stopEventPropagation = (event)=>event.stopPropagation();
    const onPopupKeyPressed = (0, $5uXOq.useCallback)((event)=>{
        stopEventPropagation(event);
        // According to the source code in Atlaskit/popup/src/use-close-manager.tsx#lines-61
        // The internal implementation of closing the Popup is exactly the same as below
        // And it triggers *no side effect* other than call the onClose callback directly,
        // which in this component simply calls handlePopupClose. This should be safe.
        // Review this in case any odd behaviours are observed when closing the popup with the escape key.
        if (event.key === 'Escape') handleOnClose();
    }, [
        handleOnClose
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            issueKey: issueKey,
            issueSummary: issueSummary,
            issueId: issueId,
            issueType: issueType,
            canUserLinkIssue: canUserLinkIssue,
            onIssueUnlink: handleOnIssueUnlink,
            onPopupClose: handleOnClose,
            maxIssuesToDisplay: $f91362c69c59b48b$var$MAX_ISSUE_LINKS_COUNT,
            feedbackCollectorPrefix: feedbackCollectorPrefix,
            onReady: stopMetric,
            sourceProductType: sourceProductType
        }), [
        feedbackCollectorPrefix,
        canUserLinkIssue,
        cloudId,
        handleOnClose,
        handleOnIssueUnlink,
        issueId,
        issueKey,
        issueSummary,
        issueType,
        sourceProductType,
        stopMetric
    ]);
    const openTriggerRef = (0, $hq3QC.useFocusOnIssueLinksStatsEffect)({
        isFocusOnTrigger: isFocusOnTrigger,
        onFocusToTrigger: onFocusToTrigger
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const triggerButton = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            ...triggerProps,
            appearance: "subtle",
            spacing: "compact",
            testId: `issue-links-stats.ui.issue-links-stats-button.custom-theme-button-${issueKey}`,
            ref: (element)=>{
                triggerRef(element);
                openTriggerRef(element);
                updateTriggerRefOnIssueLinksStatsClose(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref(element);
            },
            isSelected: isOpen,
            onClick: handleButtonClicked,
            onContextMenu: stopEventPropagation,
            onKeyDown: stopEventPropagation,
            onMouseDown: (event)=>{
                event.preventDefault();
                event.stopPropagation();
            },
            "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $adSHj.messages).issueLinksButtonIssueTermRefresh : (0, $adSHj.messages).issueLinksButton, {
                issueLinkCount: issueLinkCount
            }),
            iconBefore: ()=>(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('jira_nav4_beta_drop_1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eyYcL))), {
                    LEGACY_size: "small",
                    color: isOpen ? `var(--ds-icon-accent-blue, ${(0, $829f609a65d26a98$exports).B500})` : `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N500})`,
                    label: ""
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lJosW))), {
                    LEGACY_size: "small",
                    color: isOpen ? `var(--ds-icon-accent-blue, ${(0, $829f609a65d26a98$exports).B500})` : `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N500})`,
                    label: iconLabel
                })
        }, issueLinkCount), [
        issueKey,
        isOpen,
        handleButtonClicked,
        formatMessage,
        issueLinkCount,
        iconLabel,
        triggerRef,
        openTriggerRef,
        updateTriggerRefOnIssueLinksStatsClose
    ]);
    const showLinkIssuePopup = Boolean(canUserLinkIssue && isLinkIssuePopupEnabled && state.issueData?.issueId === String(issueId) && state.issueData?.issueKey === issueKey);
    const DetailsContent = (0, $5uXOq.useCallback)(()=>{
        if (showLinkIssuePopup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9RuF6.LinkIssuePopup), {
            onSuccessfulIssueLink: onSuccessfulIssueLink
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            padding: "space.200",
            paddingInlineEnd: "space.050",
            xcss: $f91362c69c59b48b$var$ContainerStyles,
            onContextMenu: stopEventPropagation,
            onKeyDown: onPopupKeyPressed
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "async-issue-links-details-content",
            runtimeProps: runtimeProps,
            packageName: "@atlassian/jira-issue-links-details-content",
            teamName: "jira-werewolves",
            errorFallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cIlUQ.IssueLinksDetailsErrorFallback), {
                    callback: handleOnClose,
                    error: error,
                    testId: "issue-links-stats.ui.issue-links-stats-button.issue-links-details-popup-entrypoint-container"
                }),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O6AD.IssueLinksDetailsPopupSkeleton), {
                noPadding: true,
                smallerWidth: true,
                testId: "issue-links-stats.ui.issue-links-stats-button.issue-links-details-popup-entrypoint-container.skeleton-loader"
            })
        }));
    }, [
        entryPointReferenceSubject,
        handleOnClose,
        onPopupKeyPressed,
        onSuccessfulIssueLink,
        runtimeProps,
        showLinkIssuePopup
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: isOpen || showLinkIssuePopup,
        onClose: handleOnClose,
        placement: "bottom-start",
        testId: "issue-links-stats.ui.issue-links-stats-button.issue-links-details-popup-entrypoint-container.popup",
        trigger: triggerButton,
        content: DetailsContent,
        label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $adSHj.messages).issueLinksPopupIssueTermRefresh : (0, $adSHj.messages).issueLinksPopup)
    });
};
$f91362c69c59b48b$export$b0a7e2f26787ad5d.displayName = 'IssueLinksDetailsPopupEntryPointContainer';
const $f91362c69c59b48b$var$ContainerStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $gwIPs.gridSize) * 64}px`
});

});
parcelRegister("eyYcL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a930f9e1b16994b650b756fe87e36eac>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9a2f11ac805a7dd$var$_react = $a9a2f11ac805a7dd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a9a2f11ac805a7dd$var$_issue = $a9a2f11ac805a7dd$var$_interopRequireDefault((parcelRequire("jB3w5")));

var $a9a2f11ac805a7dd$var$_issue2 = $a9a2f11ac805a7dd$var$_interopRequireDefault((parcelRequire("cWNOJ")));
function $a9a2f11ac805a7dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for IssueIcon.
 * This component is IssueIcon, with `UNSAFE_fallbackIcon` set to "IssueIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9a2f11ac805a7dd$var$IssueIcon = (props)=>/*#__PURE__*/ $a9a2f11ac805a7dd$var$_react.default.createElement($a9a2f11ac805a7dd$var$_issue.default, Object.assign({
        LEGACY_fallbackIcon: $a9a2f11ac805a7dd$var$_issue2.default
    }, props));
$a9a2f11ac805a7dd$var$IssueIcon.Name = 'IssueIconMigration';
var $a9a2f11ac805a7dd$var$_default = module.exports.default = $a9a2f11ac805a7dd$var$IssueIcon;

});
parcelRegister("jB3w5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dd150dbf1a5997823010d74213515611>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e44433503bdca276$var$_react = $e44433503bdca276$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e44433503bdca276$var$_UNSAFE_baseNew = $e44433503bdca276$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e44433503bdca276$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Issue".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e44433503bdca276$var$IssueIcon = (props)=>/*#__PURE__*/ $e44433503bdca276$var$_react.default.createElement($e44433503bdca276$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m5 7.875 2 2.375 4-4.75m-9 7.75h12c.69 0 1.25-.56 1.25-1.25V4c0-.69-.56-1.25-1.25-1.25H2C1.31 2.75.75 3.31.75 4v8c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$e44433503bdca276$var$IssueIcon.displayName = 'IssueIcon';
var $e44433503bdca276$var$_default = module.exports.default = $e44433503bdca276$var$IssueIcon;

});

parcelRegister("cWNOJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $96d18b825901141c$var$_react = $96d18b825901141c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $96d18b825901141c$var$_issue = $96d18b825901141c$var$_interopRequireDefault((parcelRequire("jB3w5")));
function $96d18b825901141c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $96d18b825901141c$var$IssueIcon = (props)=>/*#__PURE__*/ $96d18b825901141c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 15.991c0 .007 14.005.009 14.005.009C18.999 16 19 8.009 19 8.009 19 8.002 4.995 8 4.995 8 5.001 8 5 15.991 5 15.991M3 8.01C3 6.899 3.893 6 4.995 6h14.01C20.107 6 21 6.902 21 8.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 15.991z"/><path d="M10.674 14.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3z"/></g></svg>`
    }, props, {
        newIcon: $96d18b825901141c$var$_issue.default
    }));
$96d18b825901141c$var$IssueIcon.displayName = 'IssueIcon';
var $96d18b825901141c$var$_default = module.exports.default = $96d18b825901141c$var$IssueIcon;

});


parcelRegister("lJosW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fadf8272c4914ed4349f03b15a40b7eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd20c75a63e82b8e$var$_react = $fd20c75a63e82b8e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fd20c75a63e82b8e$var$_issues = $fd20c75a63e82b8e$var$_interopRequireDefault((parcelRequire("gmyWi")));

var $fd20c75a63e82b8e$var$_issues2 = $fd20c75a63e82b8e$var$_interopRequireDefault((parcelRequire("8sgpE")));
function $fd20c75a63e82b8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for IssuesIcon.
 * This component is IssuesIcon, with `UNSAFE_fallbackIcon` set to "IssuesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multiple issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fd20c75a63e82b8e$var$IssuesIcon = (props)=>/*#__PURE__*/ $fd20c75a63e82b8e$var$_react.default.createElement($fd20c75a63e82b8e$var$_issues.default, Object.assign({
        LEGACY_fallbackIcon: $fd20c75a63e82b8e$var$_issues2.default
    }, props));
$fd20c75a63e82b8e$var$IssuesIcon.Name = 'IssuesIconMigration';
var $fd20c75a63e82b8e$var$_default = module.exports.default = $fd20c75a63e82b8e$var$IssuesIcon;

});

parcelRegister("bMyiD", function(module, exports) {

$parcel$export(module.exports, "issueLinksDetailsContentEntryPoint", () => $46c7c2f756fce2b8$export$ed55e17b62c0c3b0);

var $jGqUc = parcelRequire("jGqUc");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $46c7c2f756fce2b8$export$ed55e17b62c0c3b0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("f4DhX")), {
        moduleId: "56ed134e"
    }),
    getPreloadProps: ({ cloudId: cloudId, issueKey: issueKey, issueCount: issueCount, withDueDate: withDueDate, fields: fields })=>({
            queries: {
                issueLinksDetailsPopup: {
                    // policy can be updated to store-or-network once we have issue linking mutation through relay
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $jGqUc.default,
                    variables: {
                        cloudId: cloudId,
                        issueKey: issueKey,
                        issueCount: issueCount,
                        withDueDate: withDueDate,
                        fields: fields
                    }
                }
            }
        })
});

});
parcelRegister("jGqUc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b5281d96509daab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3911672bf59cd9c5cbbd5af9f5777951>>
 * @relayHash a08180161ec6ab9c7e11d8f628199d37
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fb7810939eb3c247c90b6c590a41c138ba5abb1fafe8508efd4ed201487f6b41
const $3b5281d96509daab$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fb7810939eb3c247c90b6c590a41c138ba5abb1fafe8508efd4ed201487f6b41",
        "metadata": {},
        "name": "srcAsyncIssueLinksDetailsContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $3b5281d96509daab$export$2e2bcd8739ae039 = $3b5281d96509daab$var$node;

});

parcelRegister("f4DhX", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("hxloT").then(()=>parcelRequire('iD2bB'));

});


parcelRegister("aygpR", function(module, exports) {

$parcel$export(module.exports, "useHandleOnIssueLinksStatsClose", () => $206d363ff18ee153$export$99db27cbe204c383);

var $5uXOq = parcelRequire("5uXOq");

var $1XJ20 = parcelRequire("1XJ20");
const $206d363ff18ee153$export$99db27cbe204c383 = ({ isIssueLinkStatsOpen: isIssueLinkStatsOpen, isLinkIssueModalOpen: isLinkIssueModalOpen })=>{
    const openTriggerRef = (0, $5uXOq.useRef)(null);
    const previousIsIssueLinkStatsOpen = (0, $1XJ20.usePreviousWithInitial)(isIssueLinkStatsOpen);
    const previousisLinkIssueModalOpen = (0, $1XJ20.usePreviousWithInitial)(isLinkIssueModalOpen);
    const isIssueLinkStatsClosed = isIssueLinkStatsOpen === false && previousIsIssueLinkStatsOpen === true && // adding this condition here to prevent focus action when opening link issue modal from stats popup
    isLinkIssueModalOpen === false;
    const isIssueLinkModalClosed = isLinkIssueModalOpen === false && previousisLinkIssueModalOpen === true;
    const updateRef = (element)=>{
        openTriggerRef.current = element;
    };
    (0, $5uXOq.useEffect)(()=>{
        if (isIssueLinkStatsClosed || isIssueLinkModalClosed) openTriggerRef.current?.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isIssueLinkStatsOpen,
        isLinkIssueModalOpen
    ]);
    return updateRef;
};

});

parcelRegister("cIlUQ", function(module, exports) {

$parcel$export(module.exports, "IssueLinksDetailsErrorFallback", () => $98a00069e80b8f40$export$5489cdf86d4767fd);

var $5uXOq = parcelRequire("5uXOq");

var $fZneA = parcelRequire("fZneA");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $jDj3c = parcelRequire("jDj3c");
const $98a00069e80b8f40$export$5489cdf86d4767fd = ({ callback: callback, testId: testId, error: error })=>{
    callback && callback();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    showFlag({
        id: 'async-issue-links-details-entrypoint-flag',
        type: 'error',
        testId: testId,
        title: formatMessage((0, $jDj3c.messages).issueLinksDetailsErrorFlagTitle),
        description: formatMessage((0, $jDj3c.messages).issueLinksDetailsErrorFlagDescription),
        isAutoDismiss: true
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
        task: 'viewIssueLinksDetailsPopup',
        isClientFetchError: (0, $fZneA.isClientFetchError)(error)
    });
    // need to return an empty fragment as entrypoint fallback prop only accept ((props: { error: Error }) => ReactElement);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};

});
parcelRegister("jDj3c", function(module, exports) {

$parcel$export(module.exports, "messages", () => $299799d049ecd2fb$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $299799d049ecd2fb$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    issueLinksDetailsErrorFlagTitle: {
        "id": "issue-links-stats.issue-links-stats-button.issue-links-details-popup-entrypoint-container.issue-links-details-error-fallback.issue-links-details-error-flag-title",
        "defaultMessage": "We couldn't load your data"
    },
    issueLinksDetailsErrorFlagDescription: {
        "id": "issue-links-stats.issue-links-stats-button.issue-links-details-popup-entrypoint-container.issue-links-details-error-fallback.issue-links-details-error-flag-description",
        "defaultMessage": "Refresh the page and try again"
    }
});

});


parcelRegister("7O6AD", function(module, exports) {

$parcel$export(module.exports, "IssueLinksDetailsPopupSkeleton", () => $a2d3165178d11613$export$c2d4e4e846447365);

var $5uXOq = parcelRequire("5uXOq");

var $iwwXK = parcelRequire("iwwXK");

var $c8oLN = parcelRequire("c8oLN");
var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $a2d3165178d11613$export$c2d4e4e846447365 = ({ testId: testId, smallerWidth: smallerWidth, noPadding: noPadding = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: testId,
        xcss: smallerWidth ? $a2d3165178d11613$var$smallerWidthStyles : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c8oLN.default), {
        inline: noPadding ? 'space.200' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        width: "60%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        width: "100%",
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        width: "100%",
        hasIcon: true
    })));
const $a2d3165178d11613$var$smallerWidthStyles = (0, $8CUq3.xcss)({
    width: '80%'
});

});
parcelRegister("c8oLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e401c8401021557f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8CUq3 = parcelRequire("8CUq3");
function $e401c8401021557f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e401c8401021557f$var$baseStyles = {
    name: "1khn195",
    styles: "box-sizing:border-box"
};
const $e401c8401021557f$var$blockBleedMap = {
    'space.025': {
        name: "9w2fxh",
        styles: "margin-block:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "1qhe0y6",
        styles: "margin-block:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "s0o2nz",
        styles: "margin-block:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "151e4o3",
        styles: "margin-block:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "16sn062",
        styles: "margin-block:var(--ds-space-negative-200, -1rem)"
    }
};
const $e401c8401021557f$var$inlineBleedMap = {
    'space.025': {
        name: "16oxh68",
        styles: "margin-inline:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "tdc6fz",
        styles: "margin-inline:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "crujrn",
        styles: "margin-inline:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "y28d58",
        styles: "margin-inline:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "1vfkteg",
        styles: "margin-inline:var(--ds-space-negative-200, -1rem)"
    }
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ const $e401c8401021557f$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    const resolvedStyles = (0, $8CUq3.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $e401c8401021557f$var$baseStyles,
            (inline || all) && $e401c8401021557f$var$inlineBleedMap[inline || all],
            (block || all) && $e401c8401021557f$var$blockBleedMap[block || all],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
});
$e401c8401021557f$var$Bleed.displayName = 'Bleed';
var $e401c8401021557f$export$2e2bcd8739ae039 = $e401c8401021557f$var$Bleed;

});


parcelRegister("9RuF6", function(module, exports) {

$parcel$export(module.exports, "LinkIssuePopup", () => $d8217e7ea6ae19a8$export$2d260c101478261e);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $HeOPt = parcelRequire("HeOPt");

var $1uBR4 = parcelRequire("1uBR4");

var $koeKL = parcelRequire("koeKL");
const $d8217e7ea6ae19a8$export$2d260c101478261e = ({ onSuccessfulIssueLink: onSuccessfulIssueLink })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [state, { setIssueLinkModalEntryPointSubject: setIssueLinkModalEntryPointSubject }] = (0, $HeOPt.useIssueLinkedModalEntrypointStore)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $1uBR4.linkIssuePopupEntryPoint), {
        cloudId: cloudId
    });
    const handleClose = ()=>{
        setIssueLinkModalEntryPointSubject({
            issueData: null
        });
        entryPointActions.unload();
    };
    const handleSuccessfulIssueLink = ()=>{
        if (onSuccessfulIssueLink && state.issueData) onSuccessfulIssueLink(Number(state.issueData.issueId));
        handleClose();
    };
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (state.issueData) entryPointActions.load();
    }, [
        entryPointActions,
        state.issueData
    ]);
    if (!state.issueData || !state.issueData.issueId || !state.issueData.issueKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "businessLinkIssuePopupEntryPoint",
        packageName: "@atlassian/jira-link-issue-popup",
        teamName: "jira-werewolves" // TODO ownership will be changed after warranty period https://jbusiness.atlassian.net/browse/JSWMOON-936
        ,
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {
            issueId: state.issueData.issueId,
            issueKey: state.issueData.issueKey,
            onSuccessfulIssueLink: handleSuccessfulIssueLink,
            onClose: handleClose,
            trackOriginSource: 'JWM'
        }
    });
};

});
parcelRegister("1uBR4", function(module, exports) {

$parcel$export(module.exports, "linkIssuePopupEntryPoint", () => $54106a41849af366$export$537a4e334f2de676);

var $XczyX = parcelRequire("XczyX");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $54106a41849af366$export$537a4e334f2de676 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("kWnsl")), {
        moduleId: "e0e327f9"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                issueLinksTypes: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $XczyX.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("XczyX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b447dfe339c10fb6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2f031d559b6b4aa1484052708468df2c>>
 * @relayHash ef080d6ba522722031ef94e4887d4972
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 34d278c2e16727746e37236ed6b6c53c028ecbb07c23708312783363197eb20b
const $b447dfe339c10fb6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "inwards"
    }, v4 = {
        "kind": "ScalarField",
        "name": "outwards"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainAsyncIssueLinksTypesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueLinkTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueLinkTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueLinkTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueLinkType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v3 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.inwards"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v4 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.outwards"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainAsyncIssueLinksTypesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueLinkTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueLinkTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueLinkTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueLinkType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "34d278c2e16727746e37236ed6b6c53c028ecbb07c23708312783363197eb20b",
            "metadata": {},
            "name": "mainAsyncIssueLinksTypesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b447dfe339c10fb6$var$node.hash = "ad0bf63495377e340f30a9f1531b3f3c";
var $b447dfe339c10fb6$export$2e2bcd8739ae039 = $b447dfe339c10fb6$var$node;

});

parcelRegister("kWnsl", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("iYdSS").then(()=>parcelRequire('fSK3M'));

});



parcelRegister("adSHj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $551007571af18f3a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $551007571af18f3a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    issueLinksButton: {
        "id": "issue-links-stats.issue-links-stats-button.issue-links-details-popup-entrypoint-container.issue-links-button",
        "defaultMessage": "{issueLinkCount} linked {issueLinkCount, plural, one {issue} other {issues}}"
    },
    issueLinksPopup: {
        "id": "issue-links-stats.issue-links-stats-button.issue-links-details-popup-entrypoint-container.issue-links-popup",
        "defaultMessage": "Linked issues pop up"
    },
    issueLinksButtonIssueTermRefresh: {
        "id": "issue-links-stats.issue-links-stats-button.issue-links-details-popup-entrypoint-container.issue-links-button-issue-term-refresh",
        "defaultMessage": "{issueLinkCount} linked {issueLinkCount, plural, one {issue} other {issues}}"
    },
    issueLinksPopupIssueTermRefresh: {
        "id": "issue-links-stats.issue-links-stats-button.issue-links-details-popup-entrypoint-container.issue-links-popup-issue-term-refresh",
        "defaultMessage": "Linked issues pop up"
    }
});

});


parcelRegister("5BMYo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $92902d3d42d277dc$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $92902d3d42d277dc$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    issueLinksTooltipLabel: {
        "id": "issue-links-stats.issue-links-stats-button.issue-links-tooltip-label",
        "defaultMessage": "{issueLinkCount} linked {issueLinkCount, plural, one {issue} other {issues}}"
    },
    genericMaxIssueLinksStatsTooltipLabel: {
        "id": "issue-links-stats.issue-links-stats-button.generic-max-issue-links-stats-tooltip-label",
        "defaultMessage": "{maxIssueLinksStatsCount}+ linked issues"
    },
    issueLinksTooltipLabelIssueTermRefresh: {
        "id": "issue-links-stats.issue-links-stats-button.issue-links-tooltip-label-issue-term-refresh",
        "defaultMessage": "{issueLinkCount} linked {issueLinkCount, plural, one {issue} other {issues}}"
    },
    genericMaxIssueLinksStatsTooltipLabelIssueTermRefresh: {
        "id": "issue-links-stats.issue-links-stats-button.generic-max-issue-links-stats-tooltip-label-issue-term-refresh",
        "defaultMessage": "{maxIssueLinksStatsCount}+ linked issues"
    }
});

});


const $07ef59ce637b0eaa$export$1e94b9630d01edd3 = 9;



parcelRegister("5tA4K", function(module, exports) {

$parcel$export(module.exports, "getIsLoadingIssueLinksStatsForCard", () => $6dd795e7304f69ea$export$4af29e5efa918449);
$parcel$export(module.exports, "getIssueLinksStatsForCard", () => $6dd795e7304f69ea$export$773558ed63cf8de4);

var $dGvGJ = parcelRequire("dGvGJ");

var $67Z81 = parcelRequire("67Z81");
const $6dd795e7304f69ea$export$cbea1814e60866f1 = (state)=>(0, $67Z81.getEntities)(state).issueLinksStats;
const $6dd795e7304f69ea$export$4af29e5efa918449 = (0, $dGvGJ.createSelector)([
    $6dd795e7304f69ea$export$cbea1814e60866f1
], (linkedIssuesStats)=>(cardId)=>linkedIssuesStats?.loadingStatisticsItems?.includes(cardId) || linkedIssuesStats?.loadingStatisticsItems?.includes(Number(cardId)));
const $6dd795e7304f69ea$export$773558ed63cf8de4 = (0, $dGvGJ.createSelector)([
    $6dd795e7304f69ea$export$cbea1814e60866f1
], (linkedIssuesStats)=>(cardId)=>{
        const issueStats = linkedIssuesStats?.statisticItems[cardId];
        let issueLinkCountSum = 0;
        issueStats?.forEach((issueStat)=>{
            issueLinkCountSum += issueStat.issueLinkCount;
        });
        return issueLinkCountSum;
    });

});


parcelRegister("hnyd8", function(module, exports) {

$parcel$export(module.exports, "IssueParentField", () => $8b77fb21fa3f5c5c$export$f323718a039167f);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $54wEF = parcelRequire("54wEF");

var $3fAi8 = parcelRequire("3fAi8");

var $7Fute = parcelRequire("7Fute");

var $jRmmq = parcelRequire("jRmmq");

var $5fc53 = parcelRequire("5fc53");

var $iXVV6 = parcelRequire("iXVV6");

var $g5X3G = parcelRequire("g5X3G");

var $4SC5x = parcelRequire("4SC5x");

var $l8ruj = parcelRequire("l8ruj");

var $acAaD = parcelRequire("acAaD");

var $eGVUJ = parcelRequire("eGVUJ");


var $67sX6 = parcelRequire("67sX6");

var $evkwq = parcelRequire("evkwq");

var $k8auG = parcelRequire("k8auG");

const $8b77fb21fa3f5c5c$var$onParentFieldWrapperClick = (e)=>e.stopPropagation();
// Prevent enter from opening issue view
const $8b77fb21fa3f5c5c$var$stopEnterPropagation = (e)=>{
    if (e.key === 'Enter') e.stopPropagation();
};
const $8b77fb21fa3f5c5c$var$TooltipTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8b77fb21fa3f5c5c$var$TooltipWrapper, {
        ref: ref,
        ...props
    }));
const $8b77fb21fa3f5c5c$var$fieldKey = 'parent';
const $8b77fb21fa3f5c5c$var$IssueParentFieldInner = ({ issueId: issueId, issueKey: issueKey, currentProjectId: currentProjectId, projectIds: projectIds, issueParents: issueParents = [], isCompanyManaged: isCompanyManaged, parentSummary: parentSummary, onUpdate: onSuccess, onSubmit: onSubmit, onFailure: onFailure })=>{
    const parentFieldWrapperRef = (0, $5uXOq.useRef)(null);
    const preventInlineEditing = (0, $67sX6.useBoardSelector)((state)=>(0, $k8auG.getPreventInlineEditing)(state));
    const transformedEpics = (0, $5uXOq.useMemo)(()=>issueParents ? issueParents.map((issueParent)=>({
                ...(0, $7Fute.transformToEpic)({
                    ...issueParent,
                    id: (0, $g5X3G.toIssueId)(String(issueParent.id))
                }),
                id: (0, $g5X3G.toIssueId)(String(issueParent.id))
            })) : [], [
        issueParents
    ]);
    // It makes sure the tooltip showing on mouse over the trigger button, not mouse over dropdown items
    const handleMouseOver = (e)=>{
        const { relatedTarget: relatedTarget } = e;
        if (parentFieldWrapperRef.current && relatedTarget instanceof Node && !relatedTarget.contains(parentFieldWrapperRef.current)) e.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isInlineEditing: true,
            fieldKey: $8b77fb21fa3f5c5c$var$fieldKey,
            fieldType: 'parent'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: parentSummary,
        tag: $8b77fb21fa3f5c5c$var$TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8b77fb21fa3f5c5c$var$ParentFieldWrapper, {
        onClick: $8b77fb21fa3f5c5c$var$onParentFieldWrapperClick,
        onKeyDown: $8b77fb21fa3f5c5c$var$stopEnterPropagation,
        "data-testid": (0, $88c2d7648915eff7$export$83f1b0bcb0c1b3f8),
        disableClick: preventInlineEditing,
        onMouseOver: handleMouseOver,
        ref: parentFieldWrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jRmmq.AsyncLazyParentSwitcherField), {
        "data-testid": (0, $88c2d7648915eff7$export$dad6f927cf282b27),
        issueKey: (0, $g5X3G.toIssueKey)(issueKey),
        issueId: (0, $g5X3G.toIssueId)(String(issueId)),
        epics: transformedEpics,
        /* We cannot get permission when no issue view is opened by using the useProjectPermission hook in @atlassian/jira-project-permissions-service
         * So we have to pass canUserEditIssue from the backlog to the extracted epic field to force it to be editable
         * */ forceEditable: true,
        /** Same reason as above, we need the projectId in order to
         *  open the issue parent switcher modal */ // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        currentProjectId: currentProjectId,
        projectIds: projectIds,
        isSimplifiedProject: !isCompanyManaged,
        shouldHideIfNoParent: true,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        maxWidth: "100%"
    }))));
};
const $8b77fb21fa3f5c5c$var$entryPointParams = {};
const $8b77fb21fa3f5c5c$var$ProgramBoardIssueParentFieldInner = ({ uniqueKey: uniqueKey, issueId: issueId, issueParents: issueParents = [], onUpdate: onSuccess, onSubmit: onSubmit, onFailure: onFailure, fallback: fallback })=>{
    const preventInlineEditing = (0, $67sX6.useBoardSelector)((state)=>(0, $k8auG.getPreventInlineEditing)(state));
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $4SC5x.programBoardParentSwitcherEntryPoint), $8b77fb21fa3f5c5c$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            issueKey: uniqueKey,
            issueParents: issueParents,
            onSubmit: onSubmit,
            onSuccess: onSuccess,
            onFailure: onFailure,
            fallback: fallback,
            preventInlineEditing: preventInlineEditing,
            onSaveField: async (_, fieldId, fieldValue)=>{
                dispatch((0, $evkwq.issueIncrementPlanningUpdate)({
                    issueId: issueId,
                    fieldId: fieldId,
                    fieldValue: fieldValue ? fieldValue.id : null
                }));
            }
        }), [
        dispatch,
        fallback,
        issueId,
        uniqueKey,
        issueParents,
        onFailure,
        onSubmit,
        onSuccess,
        preventInlineEditing
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isInlineEditing: true,
            fieldKey: 'parent',
            fieldType: 'parent'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "program-board-parent-switcher",
        packageName: "jiraSoftwareBoard",
        runtimeProps: runtimeProps,
        fallback: fallback
    }));
};
const $8b77fb21fa3f5c5c$export$f323718a039167f = ({ shouldRenderRichField: shouldRenderRichField, isIncrementPlanningBoard: isIncrementPlanningBoard, ...props })=>{
    const uniqueKey = isIncrementPlanningBoard && props.issueKey === props.projectKey ? `${props.issueId}` : props.issueKey;
    const [issueParentFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: uniqueKey,
        fieldKey: (0, $5fc53.PARENT_TYPE)
    });
    const [{ value: parentFieldConfig }] = (0, $54wEF.useFieldConfigWithoutRefetch)(uniqueKey, (0, $5fc53.PARENT_TYPE));
    const shouldRenderRich = Boolean(shouldRenderRichField && props.currentProjectId && props.projectIds?.length && props?.issueParents?.length && issueParentFieldValue && parentFieldConfig && // on the increment planning board, we render the rich field only if the hierarchy level of issue is story
    issueParentFieldValue.id !== props.issueId);
    const editableField = (0, $eGVUJ.useEditableField)({
        isExperienceAvailable: shouldRenderRich
    });
    const fallback = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acAaD.IssueParentFieldStatic), {
            color: props.parentColor,
            summary: props.parentSummary,
            maxWidth: "100%"
        }), [
        props.parentColor,
        props.parentSummary
    ]);
    if (shouldRenderRich) {
        if (!isIncrementPlanningBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jRmmq.ParentSwitcherBoundary), {
            packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
            fallback: fallback,
            onError: editableField.onError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
            name: "ng-board.inline-edit.parent-field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8b77fb21fa3f5c5c$var$IssueParentFieldInner, {
            ...props,
            ...editableField
        })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8b77fb21fa3f5c5c$var$ProgramBoardIssueParentFieldInner, {
            ...props,
            fallback: fallback,
            ...editableField,
            uniqueKey: uniqueKey
        });
    }
    return fallback;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8b77fb21fa3f5c5c$var$ParentFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { disableClick: disableClick, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _kqswh2mm _80om73ad _vwz47vkz _1gp47079 _bz011wje _smb41h90 _ef5q1wng _686xagmp _1di411wp",
            __cmplp.disableClick && "_lcxvglyw",
            __cmplp.className
        ])
    });
});
const $8b77fb21fa3f5c5c$var$TooltipWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jRmmq", function(module, exports) {

$parcel$export(module.exports, "ParentSwitcherBoundary", () => $363a63430d7d18c1$export$5fd31a263aabeb24);
$parcel$export(module.exports, "AsyncLazyParentSwitcherField", () => $363a63430d7d18c1$export$690bf5ebb9d6daf8);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");
const $363a63430d7d18c1$export$5fd31a263aabeb24 = ({ children: children, fallback: fallback, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "issue-parent-switcher",
        packageName: packageName,
        fallback: fallback ? ()=>fallback : undefined,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-parent-switcher-boundary",
        fallback: fallback
    }, children));

const $363a63430d7d18c1$export$690bf5ebb9d6daf8 = (0, $kxZPA.lazy)(()=>(parcelRequire("fYVh2")).then(({ ParentSwitcherField: ParentSwitcherField })=>ParentSwitcherField), {
    moduleId: "./src/packages/issue/fields/parent-switcher/src/ui/main.tsx"
});

});
parcelRegister("fYVh2", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("511sN").then(()=>parcelRequire('1vozy'));

});


parcelRegister("4SC5x", function(module, exports) {

$parcel$export(module.exports, "programBoardParentSwitcherEntryPoint", () => $132ff5961d221c19$export$16f7c403be76b1);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $132ff5961d221c19$export$16f7c403be76b1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("5f97x")), {
        moduleId: "f91ea5b9"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5f97x", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("hH3be").then(()=>parcelRequire('kxY6j'));

});


parcelRegister("acAaD", function(module, exports) {

$parcel$export(module.exports, "IssueParentFieldStatic", () => $c0cd7d95915b3900$export$d366f2026d61a000);

var $5uXOq = parcelRequire("5uXOq");

var $koOOC = parcelRequire("koOOC");

var $bxSom = parcelRequire("bxSom");

var $dCm1o = parcelRequire("dCm1o");
const $c0cd7d95915b3900$export$d366f2026d61a000 = ({ color: color, summary: summary, maxWidth: maxWidth })=>{
    if (color === null || summary === null) return null;
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bxSom.EpicTag), {
        color: color,
        summary: summary,
        maxWidth: maxWidth
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $koOOC.EpicLozenge), {
        color: color,
        summary: summary,
        maxWidth: maxWidth
    });
};

});
parcelRegister("koOOC", function(module, exports) {

$parcel$export(module.exports, "EpicLozenge", () => $415a24051fa911e5$export$2e623d726e27c97);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $lj8SI = parcelRequire("lj8SI");

var $3bDjY = parcelRequire("3bDjY");

var $7XYc4 = parcelRequire("7XYc4");

var $iHPnC = parcelRequire("iHPnC");

var $dCm1o = parcelRequire("dCm1o");

var $k8qVk = parcelRequire("k8qVk");

var $7Fute = parcelRequire("7Fute");
const $415a24051fa911e5$export$2e623d726e27c97 = ({ color: color, summary: summary, maxWidth: maxWidth, isCompactView: isCompactView })=>{
    const paletteColorValues = (0, $iHPnC.transformColorToTheme)((colorSchema)=>colorSchema.primary);
    const selectedColor = color && paletteColorValues[color] || '';
    return isCompactView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: summary
    }, selectedColor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($415a24051fa911e5$export$d9d9ccbf5da84ba4, {
        "data-component-selector": "parent-switcher-epic-lozenge-wrapper",
        color: selectedColor
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($415a24051fa911e5$var$LozengeWrapper, {
        "data-component-selector": "parent-switcher-epic-lozenge-wrapper",
        "data-testid": (0, $k8qVk.PARENT_SWITCHER_LOZENGE_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: summary,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $7Fute.getLozengeThemeByColor)(color),
        maxWidth: maxWidth,
        testId: "issue-field-parent-switcher.common.ui.epic-lozenge.lozenge"
    }, summary)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $415a24051fa911e5$var$LozengeWrapperOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _p12f1osq _vwz4kb7n _6ndb1osq _1ksmjp4b",
            __cmplp.className
        ])
    });
});
const $415a24051fa911e5$var$LozengeWrapperNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _p12f1osq _vwz4kb7n _6ndb1osq _1ksmjp4b _1c11glyw",
            __cmplp.className
        ])
    });
});
const $415a24051fa911e5$var$LozengeWrapper = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $415a24051fa911e5$var$LozengeWrapperNew, $415a24051fa911e5$var$LozengeWrapperOld);
const $415a24051fa911e5$export$d9d9ccbf5da84ba4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1o9zidpf _1bsb7vkz _4t3i7vkz _2rko1l7b _11q71cj8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bxSom", function(module, exports) {

$parcel$export(module.exports, "EpicTag", () => $a31a219538287c5f$export$7152f0595ef00247);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bgrar = parcelRequire("bgrar");

var $d9xxV = parcelRequire("d9xxV");

var $3bDjY = parcelRequire("3bDjY");

var $iHPnC = parcelRequire("iHPnC");

var $k8qVk = parcelRequire("k8qVk");
const $a31a219538287c5f$var$colorIndicatorStyles = null;
const $a31a219538287c5f$export$9f3aea0d30ce7517 = ({ color: color })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: {
            backgroundColor: color
        },
        className: (0, $bwpsq.default)([
            "_1o9zidpf _1bsbpxbi _4t3ipxbi _2rko1l7b"
        ])
    });
};
const $a31a219538287c5f$export$7152f0595ef00247 = ({ color: color, summary: summary, isCompactView: isCompactView })=>{
    const paletteColorValues = (0, $iHPnC.transformColorToTheme)((colorSchema)=>colorSchema.primary);
    const selectedColor = color && paletteColorValues[color] || paletteColorValues.PURPLE;
    return isCompactView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: summary
    }, selectedColor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a31a219538287c5f$export$9f3aea0d30ce7517, {
        "data-component-selector": "parent-switcher-epic-lozenge-wrapper",
        color: selectedColor
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a31a219538287c5f$var$TagHack, {
        "data-component-selector": "parent-switcher-epic-lozenge-wrapper",
        "data-testid": (0, $k8qVk.PARENT_SWITCHER_LOZENGE_TEST_ID),
        tagColor: selectedColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: summary,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgrar.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
        testId: "issue-field-parent-switcher.common.ui.epic-tag.tag",
        text: summary
    }))));
};
//! This is used to override the default theme as Tag doesn't support custom styles.
const $a31a219538287c5f$var$tagHackStyles = null;
const $a31a219538287c5f$var$TagHack = ({ tagColor: tagColor, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @typescript-eslint/consistent-type-assertions
        style: {
            '--epic-tag-border-color': tagColor
        },
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _8xmeidpf _1iepidpf _1jvqidpf _uk5jidpf _fw2t1cyy _1axytlke"
        ])
    }, children);

});
parcelRegister("d9xxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $87927dab24395a15$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $5oSQr = parcelRequire("5oSQr");

var $aXLIT = parcelRequire("aXLIT");

var $eYXIO = parcelRequire("eYXIO");
const $87927dab24395a15$var$SimpleTagComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eYXIO.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5oSQr.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aXLIT.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $87927dab24395a15$var$SimpleTag = /*#__PURE__*/ (0, $5uXOq.memo)($87927dab24395a15$var$SimpleTagComponent);
var $87927dab24395a15$export$2e2bcd8739ae039 = $87927dab24395a15$var$SimpleTag;

});
parcelRegister("5oSQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $db35d9df42c66ff0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $e6s40 = parcelRequire("e6s40");

var $2hnSR = parcelRequire("2hnSR");
function $db35d9df42c66ff0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$baseStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $e6s40.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $e6s40.defaultMargin),
    padding: "var(--ds-space-0, 0px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $e6s40.cssVar).color.background.default})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $e6s40.cssVar).borderRadius})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $e6s40.cssVar).color.text.default})`,
    cursor: 'default'
});
const $db35d9df42c66ff0$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $e6s40.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $e6s40.defaultMargin),
    position: 'relative',
    alignItems: 'center',
    gap: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
    border: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderColor: `var(${(0, $e6s40.cssVar).color.borderColor})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    borderWidth: "var(--ds-border-width, 1px)",
    color: "var(--ds-text, #172B4D)",
    cursor: 'default',
    paddingInline: "var(--ds-space-050, 4px)"
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$interactiveStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $e6s40.cssVar).color.background.hover})`
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $e6s40.cssVar).color.background.active})`
    }
});
const $db35d9df42c66ff0$var$interactiveStyles = {
    name: "jcdcgl",
    styles: "&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #091E420F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #091E4224);}"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$focusRingStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 2px var(${(0, $e6s40.cssVar).color.focusRing})`,
        outline: 'none'
    }
});
const $db35d9df42c66ff0$var$focusRingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        outline: `2px solid ${$2hnSR.focusRingColors}`,
        outlineOffset: '2px '
    }
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$nonStandardLinkStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $e6s40.cssVar).color.text.active})`
    }
});
const $db35d9df42c66ff0$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? $2hnSR.textColors['standardLink'] : $2hnSR.textColors[color];
    const backgroundHoverColors = isRemovable && !isLink ? $2hnSR.backgroundColors[color] : $2hnSR.linkHoverBackgroundColors[color];
    const backgroundActiveColors = isRemovable && !isLink ? $2hnSR.backgroundColors[color] : $2hnSR.linkActiveBackgroundColors[color];
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ...other,
        ref: ref,
        css: [
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? $db35d9df42c66ff0$var$baseStyles : $db35d9df42c66ff0$var$baseStylesOld,
            isInteractive && ((0, $VSDnB.fg)('platform-component-visual-refresh') ? $db35d9df42c66ff0$var$focusRingStyles : $db35d9df42c66ff0$var$focusRingStylesOld),
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? isLink && $db35d9df42c66ff0$var$interactiveStyles : undefined,
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && $db35d9df42c66ff0$var$nonStandardLinkStyles,
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isInteractive && $db35d9df42c66ff0$var$interactiveStylesOld
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.borderColor]: $2hnSR.borderColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.text.default]: $2hnSR.textColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.text.hover]: $2hnSR.textHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.text.active]: $2hnSR.textActiveColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.text.link]: textLinkColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.background.default]: $2hnSR.backgroundColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.background.hover]: backgroundHoverColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.background.active]: backgroundActiveColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.focusRing]: $2hnSR.focusRingColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.removeButton.default]: $2hnSR.removeButtonColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.removeButton.hover]: $2hnSR.removeButtonHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).borderRadius]: $2hnSR.borderRadius[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$db35d9df42c66ff0$export$2e2bcd8739ae039 = $db35d9df42c66ff0$var$BaseTag;

});
parcelRegister("e6s40", function(module, exports) {

$parcel$export(module.exports, "tagHeight", () => $1dd8b7ac532261be$export$5b2b1030a679f37);
$parcel$export(module.exports, "buttonWidthUnitless", () => $1dd8b7ac532261be$export$c6f3ea2b4cffd0ca);
$parcel$export(module.exports, "maxTextWidthUnitless", () => $1dd8b7ac532261be$export$2e3bcb01bf928995);
$parcel$export(module.exports, "maxTextWidth", () => $1dd8b7ac532261be$export$982d4a1a6de11130);
$parcel$export(module.exports, "defaultBorderRadius", () => $1dd8b7ac532261be$export$35d5d1e251b985cf);
$parcel$export(module.exports, "defaultRoundedBorderRadius", () => $1dd8b7ac532261be$export$c49771100fee18c8);
$parcel$export(module.exports, "defaultMargin", () => $1dd8b7ac532261be$export$6728fea658cfb92e);
$parcel$export(module.exports, "defaultTextPadding", () => $1dd8b7ac532261be$export$c2d03c4c68282362);
$parcel$export(module.exports, "textPaddingRight", () => $1dd8b7ac532261be$export$b5686dedf408caa0);
$parcel$export(module.exports, "textMarginLeft", () => $1dd8b7ac532261be$export$b824cac86306f7a2);
$parcel$export(module.exports, "cssVar", () => $1dd8b7ac532261be$export$8b4981022bd80a4e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $k5uoT = parcelRequire("k5uoT");
const $1dd8b7ac532261be$var$gridSizeValue = (0, $k5uoT.gridSize)();
const $1dd8b7ac532261be$var$borderRadiusValue = (0, $k5uoT.borderRadius)();
const $1dd8b7ac532261be$export$b4d89c3994664204 = 2.5 * $1dd8b7ac532261be$var$gridSizeValue;
const $1dd8b7ac532261be$export$5b2b1030a679f37 = `var(--ds-space-250, ${`${$1dd8b7ac532261be$export$b4d89c3994664204}px`})`;
const $1dd8b7ac532261be$export$c6f3ea2b4cffd0ca = $1dd8b7ac532261be$export$b4d89c3994664204; // button should be square
const $1dd8b7ac532261be$export$aba002ef70684916 = $1dd8b7ac532261be$export$5b2b1030a679f37; // button should be square
const $1dd8b7ac532261be$export$d5949a2c2ea9dcea = 25 * $1dd8b7ac532261be$var$gridSizeValue;
const $1dd8b7ac532261be$export$488fda99655ff65a = `${$1dd8b7ac532261be$export$d5949a2c2ea9dcea}px`;
const $1dd8b7ac532261be$export$2e3bcb01bf928995 = $1dd8b7ac532261be$export$d5949a2c2ea9dcea - $1dd8b7ac532261be$export$b4d89c3994664204;
const $1dd8b7ac532261be$export$982d4a1a6de11130 = `${$1dd8b7ac532261be$export$2e3bcb01bf928995}px`;
const $1dd8b7ac532261be$export$35d5d1e251b985cf = `${$1dd8b7ac532261be$var$borderRadiusValue}px`;
const $1dd8b7ac532261be$export$c49771100fee18c8 = `${$1dd8b7ac532261be$export$c6f3ea2b4cffd0ca / 2}px`;
const $1dd8b7ac532261be$export$6728fea658cfb92e = `var(--ds-space-050, ${`${$1dd8b7ac532261be$var$gridSizeValue / 2}px`})`;
const $1dd8b7ac532261be$export$c2d03c4c68282362 = `var(--ds-space-050, ${`${$1dd8b7ac532261be$var$gridSizeValue / 2}px`})`;
const $1dd8b7ac532261be$export$b5686dedf408caa0 = `var(--ds-space-200, ${`${2 * $1dd8b7ac532261be$var$gridSizeValue}px`})`;
const $1dd8b7ac532261be$export$b824cac86306f7a2 = $1dd8b7ac532261be$export$5b2b1030a679f37;
const $1dd8b7ac532261be$export$8b4981022bd80a4e = {
    color: {
        background: {
            default: '--ds-cb',
            hover: '--ds-cbh',
            active: '--ds-cba'
        },
        borderColor: '--ds-bc',
        focusRing: '--ds-cfr',
        text: {
            default: '--ds-ct',
            hover: '--ds-cth',
            active: '--ds-ctp',
            link: '--ds-ctl'
        },
        removeButton: {
            default: '--ds-rb',
            hover: '--ds-rbh'
        }
    },
    borderRadius: '--ds-br'
};

});

parcelRegister("2hnSR", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $5b444d8505b9cc3c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $5b444d8505b9cc3c$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $5b444d8505b9cc3c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $5b444d8505b9cc3c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $5b444d8505b9cc3c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $5b444d8505b9cc3c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $5b444d8505b9cc3c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $5b444d8505b9cc3c$export$2a31dbe82788f940);
$parcel$export(module.exports, "borderRadius", () => $5b444d8505b9cc3c$export$7a57f79000377ca2);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $5b444d8505b9cc3c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $5b444d8505b9cc3c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $5b444d8505b9cc3c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $5b444d8505b9cc3c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $5b444d8505b9cc3c$export$b03fbc2a369c563e);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 

var $e6s40 = parcelRequire("e6s40");
const $5b444d8505b9cc3c$export$daa0ace263cb20d2 = {
    standard: `var(--ds-text, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
    standardLink: `var(--ds-link, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
};
const $5b444d8505b9cc3c$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $5b444d8505b9cc3c$export$7c7104a5f052cab7 = {
    standard: `var(--ds-link, ${$829f609a65d26a98$export$e62e8919cca44969})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
};
const $5b444d8505b9cc3c$export$382469baad253eb7 = {
    standard: `var(--ds-link-pressed, ${$829f609a65d26a98$export$e62e8919cca44969})`,
    blue: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
};
const $5b444d8505b9cc3c$export$b9d7c59a579c23c6 = {
    standard: `var(--ds-background-neutral, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
    blue: `var(--ds-background-accent-blue-subtle, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
    red: `var(--ds-background-accent-red-subtle, ${$829f609a65d26a98$export$be802dd0d8b57f35})`,
    yellow: `var(--ds-background-accent-yellow-subtle, ${$829f609a65d26a98$export$5aae31392d72caaa})`,
    green: `var(--ds-background-accent-green-subtle, ${$829f609a65d26a98$export$747d86715d4175de})`,
    teal: `var(--ds-background-accent-teal-subtle, ${$829f609a65d26a98$export$69cb3ca10c1e330e})`,
    purple: `var(--ds-background-accent-purple-subtle, ${$829f609a65d26a98$export$6011520a64d9a187})`,
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: `var(--ds-background-accent-gray-subtle, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    blueLight: `var(--ds-background-accent-blue-subtler, ${$829f609a65d26a98$export$8c13c2ee36917869})`,
    redLight: `var(--ds-background-accent-red-subtler, ${$829f609a65d26a98$export$b34b069eff244586})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler, ${$829f609a65d26a98$export$1cc05bbbf340e559})`,
    greenLight: `var(--ds-background-accent-green-subtler, ${$829f609a65d26a98$export$afbce1382ec95f73})`,
    tealLight: `var(--ds-background-accent-teal-subtler, ${$829f609a65d26a98$export$776c9c497ef08533})`,
    purpleLight: `var(--ds-background-accent-purple-subtler, ${$829f609a65d26a98$export$4b0a4417ed59760f})`,
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: `var(--ds-background-accent-gray-subtler, ${$829f609a65d26a98$export$3e51e8f1440314ba})`
};
const $5b444d8505b9cc3c$export$4410079763249c74 = {
    standard: `var(--ds-background-neutral-hovered, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
    blue: `var(--ds-background-accent-blue-subtle-hovered, ${$829f609a65d26a98$export$8c13c2ee36917869})`,
    red: `var(--ds-background-accent-red-subtle-hovered, ${$829f609a65d26a98$export$b34b069eff244586})`,
    yellow: `var(--ds-background-accent-yellow-subtle-hovered, ${$829f609a65d26a98$export$1cc05bbbf340e559})`,
    green: `var(--ds-background-accent-green-subtle-hovered, ${$829f609a65d26a98$export$afbce1382ec95f73})`,
    teal: `var(--ds-background-accent-teal-subtle-hovered, ${$829f609a65d26a98$export$776c9c497ef08533})`,
    purple: `var(--ds-background-accent-purple-subtle-hovered, ${$829f609a65d26a98$export$4b0a4417ed59760f})`,
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: `var(--ds-background-accent-gray-subtle-hovered, ${$829f609a65d26a98$export$eece5f492e429f08})`,
    blueLight: `var(--ds-background-accent-blue-subtler-hovered, ${$829f609a65d26a98$export$226de0355ed012f8})`,
    redLight: `var(--ds-background-accent-red-subtler-hovered, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-hovered, ${$829f609a65d26a98$export$41060a744ab0b7ae})`,
    greenLight: `var(--ds-background-accent-green-subtler-hovered, ${$829f609a65d26a98$export$69a3bf21b9686c2b})`,
    tealLight: `var(--ds-background-accent-teal-subtler-hovered, ${$829f609a65d26a98$export$7a8f4d33f6f9772c})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-hovered, ${$829f609a65d26a98$export$363e4475840015bb})`,
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: `var(--ds-background-accent-gray-subtler-hovered, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`
};
const $5b444d8505b9cc3c$export$76be99c5e13e3566 = {
    standard: `var(--ds-background-neutral-pressed, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
    blue: `var(--ds-background-accent-blue-subtle-pressed, ${$829f609a65d26a98$export$226de0355ed012f8})`,
    red: `var(--ds-background-accent-red-subtle-pressed, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`,
    yellow: `var(--ds-background-accent-yellow-subtle-pressed, ${$829f609a65d26a98$export$41060a744ab0b7ae})`,
    green: `var(--ds-background-accent-green-subtle-pressed, ${$829f609a65d26a98$export$69a3bf21b9686c2b})`,
    teal: `var(--ds-background-accent-teal-subtle-pressed, ${$829f609a65d26a98$export$7a8f4d33f6f9772c})`,
    purple: `var(--ds-background-accent-purple-subtle-pressed, ${$829f609a65d26a98$export$363e4475840015bb})`,
    grey: `var(--ds-background-accent-gray-subtle-pressed, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`,
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: `var(--ds-background-accent-blue-subtler-pressed, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
    redLight: `var(--ds-background-accent-red-subtler-pressed, ${$829f609a65d26a98$export$be802dd0d8b57f35})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-pressed, ${$829f609a65d26a98$export$5aae31392d72caaa})`,
    greenLight: `var(--ds-background-accent-green-subtler-pressed, ${$829f609a65d26a98$export$747d86715d4175de})`,
    tealLight: `var(--ds-background-accent-teal-subtler-pressed, ${$829f609a65d26a98$export$69cb3ca10c1e330e})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-pressed, ${$829f609a65d26a98$export$6011520a64d9a187})`,
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: `var(--ds-background-accent-gray-subtler-pressed, ${$829f609a65d26a98$export$8754fc7e6d8b3000})`
};
const $5b444d8505b9cc3c$export$2a31dbe82788f940 = `var(--ds-border-focused, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`;
const $5b444d8505b9cc3c$export$7a57f79000377ca2 = {
    default: (0, $e6s40.defaultBorderRadius),
    rounded: (0, $e6s40.defaultRoundedBorderRadius)
};
const $5b444d8505b9cc3c$export$1202b7eb21da7b58 = `var(--ds-background-danger, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`;
const $5b444d8505b9cc3c$export$62ace793ebb16bda = `var(--ds-background-danger-hovered, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`;
const $5b444d8505b9cc3c$export$17d206ccea111bbb = `var(--ds-text-danger, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`;
const $5b444d8505b9cc3c$export$f64c7641cbc22da7 = {
    standard: `var(--ds-text, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    lime: `var(--ds-text-accent-lime-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    magenta: `var(--ds-text-accent-magenta-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    orange: `var(--ds-text-accent-orange-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    limeLight: `var(--ds-text-accent-lime, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    magentaLight: `var(--ds-text-accent-magenta, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    orangeLight: `var(--ds-text-accent-orange, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
};
const $5b444d8505b9cc3c$export$b03fbc2a369c563e = {
    standard: `var(--ds-text-danger, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
    standardLink: `var(--ds-text-danger, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
    blue: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    red: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    green: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    lime: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    magenta: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    orange: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    grey: `var(--ds-text-danger, ${$829f609a65d26a98$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
    limeLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
    magentaLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
    orangeLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
    greyLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
};

});


parcelRegister("aXLIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b11e671062d0fc5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $e6s40 = parcelRequire("e6s40");
function $4b11e671062d0fc5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4b11e671062d0fc5$var$beforeElementStyles = {
    name: "cfjv6",
    styles: "display:flex;height:16px;align-items:center;justify-content:center;inset-block-start:var(--ds-space-0, 0px)"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $4b11e671062d0fc5$var$beforeElementStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $e6s40.cssVar).borderRadius})`,
    insetBlockStart: "var(--ds-space-0, 0px)"
});
const $4b11e671062d0fc5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: (0, $VSDnB.fg)('platform-component-visual-refresh') ? $4b11e671062d0fc5$var$beforeElementStyles : $4b11e671062d0fc5$var$beforeElementStylesOld
    }, elemBefore) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4b11e671062d0fc5$export$2e2bcd8739ae039 = $4b11e671062d0fc5$var$Before;

});

parcelRegister("eYXIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c46b06918fbe54e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $e6s40 = parcelRequire("e6s40");
function $c46b06918fbe54e8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$baseStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $e6s40.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $e6s40.defaultTextPadding),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineStart: (0, $e6s40.defaultTextPadding),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $c46b06918fbe54e8$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $e6s40.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$linkStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $e6s40.cssVar).color.text.link})`,
    pointerEvents: 'auto',
    textDecoration: 'none',
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $e6s40.cssVar).color.text.hover})`,
        textDecoration: 'underline'
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $e6s40.cssVar).color.text.active})`,
        textDecoration: 'underline'
    },
    '&:focus': {
        outline: 'none'
    }
});
const $c46b06918fbe54e8$var$linkStyles = {
    name: "1e5oc06",
    styles: "color:var(--ds-text, #172B4D);pointer-events:auto;text-decoration:none;&:hover{color:var(--ds-text, #172B4D);text-decoration:underline;}&:active{color:var(--ds-text, #172B4D);text-decoration:underline;}&:focus{outline:none;}"
};
const $c46b06918fbe54e8$var$hasAfterStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $e6s40.maxTextWidthUnitless) - (0, $e6s40.buttonWidthUnitless)}px`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $e6s40.textPaddingRight)
});
const $c46b06918fbe54e8$var$hasAfterStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $e6s40.maxTextWidthUnitless) - (0, $e6s40.buttonWidthUnitless)}px`
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$hasBeforeStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: (0, $e6s40.textMarginLeft)
});
const $c46b06918fbe54e8$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $f8Sb3.jsx)(Link, {
        href: href,
        "data-color": color,
        css: [
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$baseStyles : $c46b06918fbe54e8$var$baseStylesOld,
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$linkStyles : $c46b06918fbe54e8$var$linkStylesOld,
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && $c46b06918fbe54e8$var$hasBeforeStyles,
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStyles : undefined,
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStylesOld : undefined
        ]
    }, text);
    else return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$baseStyles : $c46b06918fbe54e8$var$baseStylesOld,
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && $c46b06918fbe54e8$var$hasBeforeStyles,
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStyles : undefined,
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStylesOld : undefined
        ]
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c46b06918fbe54e8$export$2e2bcd8739ae039 = $c46b06918fbe54e8$var$Content;

});




const $88c2d7648915eff7$export$dad6f927cf282b27 = 'software-board.board-container.board.card-container.card.issue-parent-field.parent-field-lazy';
const $88c2d7648915eff7$export$83f1b0bcb0c1b3f8 = 'software-board.board-container.board.card-container.card.issue-parent-field.parent-field-wrapper';


parcelRegister("fBeRa", function(module, exports) {

$parcel$export(module.exports, "OriginalEstimateField", () => $098b9bc6f7bd64cc$export$7a49800f92da6ebc);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $cSD7y = parcelRequire("cSD7y");

var $54wEF = parcelRequire("54wEF");

var $gRk25 = parcelRequire("gRk25");

var $dKhOa = parcelRequire("dKhOa");

var $iXVV6 = parcelRequire("iXVV6");


var $g5X3G = parcelRequire("g5X3G");

var $l8ruj = parcelRequire("l8ruj");

var $3l5XM = parcelRequire("3l5XM");

var $oOIFP = parcelRequire("oOIFP");

var $eGVUJ = parcelRequire("eGVUJ");

var $6HPvp = parcelRequire("6HPvp");

var $6wLTf = parcelRequire("6wLTf");


var $67sX6 = parcelRequire("67sX6");

var $k8auG = parcelRequire("k8auG");

const $098b9bc6f7bd64cc$var$stopPropagation = (e)=>e.stopPropagation();
const $098b9bc6f7bd64cc$var$fieldKey = 'timeoriginalestimate';
const $098b9bc6f7bd64cc$var$OriginalEstimateFieldInner = ({ issueId: issueId, issueKey: issueKey, timeTrackingOptions: timeTrackingOptions, estimate: estimate, onFailure: onFailure, ...props })=>{
    const preventInlineEditing = (0, $67sX6.useBoardSelector)((state)=>(0, $k8auG.getPreventInlineEditing)(state));
    const { fireInvalidFieldConfigError: fireInvalidFieldConfigError } = (0, $6HPvp.useFireInvalidFieldConfigError)();
    const onFailureFireError = (0, $5uXOq.useCallback)((error)=>{
        onFailure?.();
        fireInvalidFieldConfigError(error);
    }, [
        fireInvalidFieldConfigError,
        onFailure
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isInlineEditing: true,
            fieldKey: $098b9bc6f7bd64cc$var$fieldKey,
            fieldType: $098b9bc6f7bd64cc$var$fieldKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($098b9bc6f7bd64cc$var$OriginalEstimateWrapper, {
        "data-testid": (0, $3adc81d2d12051cc$export$f74bfca982b53573),
        hasValue: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(estimate),
        onClick: $098b9bc6f7bd64cc$var$stopPropagation,
        onKeyDown: $098b9bc6f7bd64cc$var$stopPropagation,
        disableClick: preventInlineEditing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gRk25.AsyncOriginalEstimateInlineEdit), {
        ...props,
        actionSubject: "inlineEdit",
        isMobile: false,
        issueId: (0, $g5X3G.toIssueId)(String(issueId)),
        issueKey: (0, $g5X3G.toIssueKey)(issueKey),
        config: (0, $6wLTf.timeTrackingConfigTransformer)(timeTrackingOptions),
        fieldId: (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2),
        isEditable: true,
        isFitContainerWidthReadView: true,
        placeholder: (0, $3adc81d2d12051cc$export$55fc5ffc49a23c34),
        onFailure: onFailureFireError,
        timeTrackingValue: {}
    })));
};
const $098b9bc6f7bd64cc$export$7a49800f92da6ebc = ({ shouldRenderRichField: shouldRenderRichField, ...props })=>{
    const [{ value: originalEstimateFieldConfig }] = (0, $54wEF.useFieldConfigWithoutRefetch)(props.issueKey, (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2));
    const shouldRenderRich = Boolean(shouldRenderRichField && originalEstimateFieldConfig);
    const editableField = (0, $eGVUJ.useEditableField)({
        isExperienceAvailable: shouldRenderRich
    });
    const fallback = props.estimate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3l5XM.EstimateFieldStatic), {
        value: props.estimate
    }) : null;
    if (shouldRenderRich) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dKhOa.OriginalEstimateInlineEditErrorBoundary), {
        packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
        fallback: fallback,
        onError: editableField.onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "ng-board.inline-edit.original-estimate-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($098b9bc6f7bd64cc$var$OriginalEstimateFieldInner, {
        ...props,
        ...editableField
    })));
    return fallback;
};
// prevents warning for usage of style composition - can be removed when https://product-fabric.atlassian.net/browse/APP-728 is done.
const $098b9bc6f7bd64cc$var$CompiledPropsForwarder = ({ disableClick: disableClick, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oOIFP.EstimateWrapper), rest);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $098b9bc6f7bd64cc$var$OriginalEstimateWrapperOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $098b9bc6f7bd64cc$var$CompiledPropsForwarder, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1xkuvov6 _gs1n11wp _1pme4jg8 _1bt6idpf _1bb7idpf _wv4jt94y _1nf9yh40 _11yukb7n",
            __cmplp.disableClick && "_lcxvglyw",
            __cmplp.className
        ])
    });
});
const $098b9bc6f7bd64cc$var$OriginalEstimateWrapperNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $098b9bc6f7bd64cc$var$CompiledPropsForwarder, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1xkuairk _gs1n11wp _1pme4jg8 _1bt6idpf _1bb7idpf _wv4jt94y _1nf9yh40 _11yukb7n",
            __cmplp.disableClick && "_lcxvglyw",
            __cmplp.className
        ])
    });
});
const $098b9bc6f7bd64cc$var$OriginalEstimateWrapper = (0, $cSD7y.componentWithFG)('fix_jira_board_card_nested_interactive_elements', $098b9bc6f7bd64cc$var$OriginalEstimateWrapperNew, $098b9bc6f7bd64cc$var$OriginalEstimateWrapperOld);

});
parcelRegister("gRk25", function(module, exports) {

$parcel$export(module.exports, "AsyncOriginalEstimateInlineEdit", () => $d12b967f73a6d5cc$export$4953f72b4b129e16);

var $kxZPA = parcelRequire("kxZPA");

const $d12b967f73a6d5cc$export$4953f72b4b129e16 = (0, $kxZPA.lazy)(()=>(parcelRequire("cT1Ns")), {
    moduleId: "./src/packages/issue/fields/original-estimate-inline-edit/inline-edit/src/ui/main.tsx"
});

});
parcelRegister("cT1Ns", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("hsP4X").then(()=>parcelRequire('hVDSB'));

});


parcelRegister("dKhOa", function(module, exports) {

$parcel$export(module.exports, "OriginalEstimateInlineEditErrorBoundary", () => $93a64576a35980c3$export$466499b8671a900);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");
const $93a64576a35980c3$export$466499b8671a900 = ({ fallback: fallback, children: children, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "original-estimate-inline-edit",
        packageName: packageName,
        teamName: "bento",
        fallback: "flag",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "original-estimate-inline-edit-error-boundary",
        fallback: fallback
    }, children));

});

parcelRegister("3l5XM", function(module, exports) {

$parcel$export(module.exports, "EstimateFieldStatic", () => $13b9f7a9ff5b1848$export$cc501740c0f7c27a);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $16T6Y = parcelRequire("16T6Y");

var $koVbs = parcelRequire("koVbs");

var $akGDz = parcelRequire("akGDz");
const $13b9f7a9ff5b1848$export$cc501740c0f7c27a = ({ value: value })=>{
    const { formatNumber: formatNumber } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13b9f7a9ff5b1848$var$EstimateWrapper, {
        "data-testid": "software-board.common.fields.estimate-field.static.estimate-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        appearance: "default"
    }, typeof value === 'number' ? formatNumber(value) : value));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $13b9f7a9ff5b1848$var$EstimateWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $akGDz.Container), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f3yh40",
            __cmplp.className
        ])
    });
});

});

parcelRegister("oOIFP", function(module, exports) {

$parcel$export(module.exports, "EstimateWrapper", () => $05689b28e4022562$export$1405ff72a0128840);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cSD7y = parcelRequire("cSD7y");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $05689b28e4022562$var$EstimateWrapperOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasValue: hasValue, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _1pxtutpp _1idistnw _gs1n11wp _13jz1txw _bssb1txw _1mhz1txw _1mi81txw",
            __cmplp.hasValue ? "_1e0c1txw" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $05689b28e4022562$var$EstimateWrapperNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasValue: hasValue, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _1idistnw _gs1n11wp _13jz1txw _bssb1txw _1mhz1txw _1mi81txw",
            __cmplp.hasValue ? "_1e0c1txw" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $05689b28e4022562$export$1405ff72a0128840 = (0, $cSD7y.componentWithFG)('fix_jira_board_card_nested_interactive_elements', $05689b28e4022562$var$EstimateWrapperNew, $05689b28e4022562$var$EstimateWrapperOld);

});

parcelRegister("6HPvp", function(module, exports) {

$parcel$export(module.exports, "useFireInvalidFieldConfigError", () => $795e126280e0f257$export$eb4917cb48fa47a4);

var $5uXOq = parcelRequire("5uXOq");

var $jJZqs = parcelRequire("jJZqs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
function $795e126280e0f257$export$eb4917cb48fa47a4() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireInvalidFieldConfigError = (0, $5uXOq.useCallback)((error)=>{
        if (error instanceof (0, $jJZqs.ValidationError)) {
            const removedEstimateError = error?.errors?.find((err)=>err?.error?.includes('It is not on the appropriate screen, or unknown.'));
            if (removedEstimateError) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'estimateField updateFailed', {
                field: removedEstimateError?.field,
                error: removedEstimateError?.error,
                isIncorrectFieldConfig: true
            });
        }
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireInvalidFieldConfigError: fireInvalidFieldConfigError
    };
}

});

parcelRegister("6wLTf", function(module, exports) {

$parcel$export(module.exports, "timeTrackingConfigTransformer", () => $93f9193f326154c7$export$5507631896590474);
const $93f9193f326154c7$export$5507631896590474 = ({ workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultUnit: defaultUnit, timeFormat: timeFormat })=>({
        isTimeTrackingEnabled: true,
        daysPerWeek: workingDaysPerWeek,
        hoursPerDay: workingHoursPerDay,
        defaultUnit: defaultUnit,
        format: timeFormat
    });

});

const $3adc81d2d12051cc$export$f74bfca982b53573 = 'software-board.board-container.board.card-container.card.original-estimate-field.wrapper';
const $3adc81d2d12051cc$export$55fc5ffc49a23c34 = '2w 4d 6h 45m';
const $3adc81d2d12051cc$export$9309e44d5544ea64 = 'software-board.common.fields.estimate-field.static.estimate-wrapper';


parcelRegister("2Gmm7", function(module, exports) {

$parcel$export(module.exports, "StoryPointField", () => $9ab8262f440c5e30$export$879127080cbdde1d);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $koVbs = parcelRequire("koVbs");

var $54wEF = parcelRequire("54wEF");

var $4AyyJ = parcelRequire("4AyyJ");

var $4dw4p = parcelRequire("4dw4p");

var $4jAPy = parcelRequire("4jAPy");

var $7hE3x = parcelRequire("7hE3x");

var $iXVV6 = parcelRequire("iXVV6");

var $g5X3G = parcelRequire("g5X3G");

var $gBj4V = parcelRequire("gBj4V");

var $l8ruj = parcelRequire("l8ruj");

var $3l5XM = parcelRequire("3l5XM");

var $oOIFP = parcelRequire("oOIFP");

var $eGVUJ = parcelRequire("eGVUJ");

var $6HPvp = parcelRequire("6HPvp");

var $6wLTf = parcelRequire("6wLTf");


var $67sX6 = parcelRequire("67sX6");

var $evkwq = parcelRequire("evkwq");

var $k8auG = parcelRequire("k8auG");

var $bSSdD = parcelRequire("bSSdD");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");


var $jiQZW = parcelRequire("jiQZW");
const $9ab8262f440c5e30$var$stopPropagation = (e)=>e.stopPropagation();
const $9ab8262f440c5e30$var$fieldKey = 'storyPoints';
const $9ab8262f440c5e30$var$StoryPointFieldInner = ({ issueId: issueId, issueKey: issueKey, storyPointFieldId: storyPointFieldId, estimate: estimate, onFailure: onFailure, dialogPlacement: dialogPlacement, ...props })=>{
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const timeTrackingOptions = (0, $67sX6.useBoardSelector)((state)=>(0, $5mTgl.getTimeTrackingOptions)(state));
    const planningUnit = (0, $67sX6.useBoardSelector)((state)=>(0, $67Z81.getPlanningUnit)(state));
    const preventInlineEditing = (0, $67sX6.useBoardSelector)((state)=>(0, $k8auG.getPreventInlineEditing)(state));
    const storyPointKey = storyPointFieldId || '';
    const { fireInvalidFieldConfigError: fireInvalidFieldConfigError } = (0, $6HPvp.useFireInvalidFieldConfigError)();
    const onFailureFireError = (0, $5uXOq.useCallback)((error)=>{
        onFailure?.();
        fireInvalidFieldConfigError(error);
    }, [
        fireInvalidFieldConfigError,
        onFailure
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isInlineEditing: true,
            fieldKey: $9ab8262f440c5e30$var$fieldKey,
            fieldType: 'number'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9ab8262f440c5e30$var$StorypointsEstimateWrapper, {
        "data-testid": (0, $189f09162dc8d67b$export$c872a8f05adaccec),
        onClick: $9ab8262f440c5e30$var$stopPropagation,
        onKeyDown: $9ab8262f440c5e30$var$stopPropagation,
        hasValue: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(estimate),
        disableClick: preventInlineEditing,
        isIncrementPlanningBoard: isIncrementPlanningBoard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4AyyJ.AsyncLazyNumberFieldInlineEdit), {
        editButtonLabel: formatMessage((0, $jiQZW.default).editButtonLabel, {
            storyPoints: estimate
        }),
        ...props,
        actionSubject: "inlineEdit",
        issueKey: (0, $g5X3G.toIssueKey)(issueKey),
        fieldKey: storyPointKey,
        analyticsFieldKeyAlias: "storyPoints",
        onFailure: onFailureFireError,
        dialogPlacement: dialogPlacement,
        ...isIncrementPlanningBoard && {
            min: 0,
            saveField: async (_, fieldId, fieldValue)=>{
                const getFieldValue = ()=>{
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(fieldValue) || fieldValue === '') return fieldValue;
                    if (planningUnit === (0, $4jAPy.IP_BOARD_HOURS_PLANNING_UNIT)) return Number(fieldValue) * (0, $gBj4V.SECONDS_PER_HOUR);
                    if (planningUnit === (0, $4jAPy.IP_BOARD_DAYS_PLANNING_UNIT)) {
                        const workingHoursPerDay = (0, $6wLTf.timeTrackingConfigTransformer)(timeTrackingOptions).hoursPerDay || (0, $gBj4V.defaultTimeTrackingOptions).workingHoursPerDay;
                        return Number(fieldValue) * workingHoursPerDay * (0, $gBj4V.SECONDS_PER_HOUR);
                    }
                    return fieldValue;
                };
                dispatch((0, $evkwq.issueIncrementPlanningUpdate)({
                    issueId: issueId,
                    fieldId: fieldId,
                    fieldValue: getFieldValue()
                })); // to make ts happy
                return undefined;
            }
        }
    })));
};
const $9ab8262f440c5e30$export$879127080cbdde1d = ({ shouldRenderRichField: shouldRenderRichField, ...props })=>{
    const storyPointKey = props.storyPointFieldId || '';
    const [{ value: storyPointFieldConfig }] = (0, $54wEF.useFieldConfigWithoutRefetch)(props.issueKey, storyPointKey);
    const shouldRenderRich = Boolean(shouldRenderRichField && storyPointFieldConfig);
    const editableField = (0, $eGVUJ.useEditableField)({
        isExperienceAvailable: shouldRenderRich
    });
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const issueParents = (0, $67sX6.useBoardSelector)((state)=>(0, $bSSdD.issueParentIdsSelector)(state));
    const isIssueParent = !!issueParents && issueParents.includes(`${props.issueId}`);
    if (isIncrementPlanningBoard && isIssueParent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7hE3x.default), {
        value: props.estimate
    });
    const fallback = props.estimate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3l5XM.EstimateFieldStatic), {
        value: props.estimate
    }) : null;
    if (shouldRenderRich) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dw4p.NumberInlineEditErrorBoundary), {
        packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
        fallback: fallback,
        onError: editableField.onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "ng-board.inline-edit.story-point-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9ab8262f440c5e30$var$StoryPointFieldInner, {
        ...props,
        ...editableField
    })));
    return fallback;
}; // prevents warning for usage of style composition - can be removed when https://product-fabric.atlassian.net/browse/APP-728 is done.
const $9ab8262f440c5e30$var$CompiledPropsForwarder = ({ disableClick: disableClick, isIncrementPlanningBoard: isIncrementPlanningBoard, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oOIFP.EstimateWrapper), rest); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9ab8262f440c5e30$var$StorypointsEstimateWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $9ab8262f440c5e30$var$CompiledPropsForwarder, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1f4h _gx371q9c _1bt612gs _1bb7idpf _wv4j1n1a _1nf9idpf _gs1n11wp",
            __cmplp.disableClick && "_lcxvglyw",
            __cmplp.isIncrementPlanningBoard && "_rhra8vuz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4AyyJ", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyNumberFieldInlineEdit", () => $48549bb820c37e94$export$914a596381b1e227);

var $kxZPA = parcelRequire("kxZPA");

const $48549bb820c37e94$export$914a596381b1e227 = (0, $kxZPA.lazy)(()=>(parcelRequire("lt99q")), {
    moduleId: "./src/packages/issue/fields/number-inline-edit/inline-edit/src/ui/index.tsx"
});

});
parcelRegister("lt99q", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("jfCur").then(()=>parcelRequire('8gjIO'));

});


parcelRegister("4dw4p", function(module, exports) {

$parcel$export(module.exports, "NumberInlineEditErrorBoundary", () => $5c0f4f3a40f5e6b4$export$3e0d6107a3584b0b);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");
const $5c0f4f3a40f5e6b4$export$3e0d6107a3584b0b = ({ fallback: fallback, children: children, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "number-inline-edit",
        packageName: packageName,
        teamName: "bento",
        fallback: "flag",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "number-inline-edit-error-boundary",
        fallback: fallback
    }, children));

});

parcelRegister("7hE3x", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf3f95453cbc0dbe$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $16T6Y = parcelRequire("16T6Y");

var $dC5iT = parcelRequire("dC5iT");


var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");


var $5KKS9 = parcelRequire("5KKS9");
const $cf3f95453cbc0dbe$var$EpicStoryPoint = ({ value: value })=>{
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $koVbs.default)();
    if (value === undefined) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInlineEnd: "space.025",
        testId: (0, $c936dea51a10e560$export$4e5fcfb49483954e)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5KKS9.default).tooltipIssueTermRefresh : (0, $5KKS9.default).tooltip),
        position: "auto"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        style: $cf3f95453cbc0dbe$var$badgeStyles
    }, formatNumber(Number(value)))));
};
var $cf3f95453cbc0dbe$export$2e2bcd8739ae039 = $cf3f95453cbc0dbe$var$EpicStoryPoint;
const $cf3f95453cbc0dbe$var$badgeStyles = {
    backgroundColor: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$exports).N20A})`,
    color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$exports).N100})`
};

});
const $c936dea51a10e560$export$4e5fcfb49483954e = 'portfolio-3-plan-increment-common.ui.epic-story-point.epic-story-point';

parcelRegister("5KKS9", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfbadea35953c7a8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bfbadea35953c7a8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "portfolio-3-plan-increment-common.ui.epic-story-point.tooltip",
        "defaultMessage": "This issue has been estimated, but isn't included in capacity calculations."
    },
    tooltipIssueTermRefresh: {
        "id": "portfolio-3-plan-increment-common.ui.epic-story-point.tooltip-issue-term-refresh",
        "defaultMessage": "This issue has been estimated, but isn't included in capacity calculations."
    }
});

});


const $189f09162dc8d67b$export$c872a8f05adaccec = 'software-board.board-container.board.card-container.card.story-point-field.wrapper';

parcelRegister("jiQZW", function(module, exports) {

$parcel$export(module.exports, "default", () => $bacf0c46e83690a6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bacf0c46e83690a6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editButtonLabel: {
        "id": "software.main.board-container.board.card-container.card.story-point-field.edit-button-label",
        "defaultMessage": "Story point estimate: {storyPoints}"
    }
});

});


parcelRegister("UJNvI", function(module, exports) {

$parcel$export(module.exports, "Summary", () => $2340dd6536b8099b$export$46453a0401d6cd1a);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $54wEF = parcelRequire("54wEF");

var $3fAi8 = parcelRequire("3fAi8");

var $eH4Q8 = parcelRequire("eH4Q8");

var $k2s1j = parcelRequire("k2s1j");

var $gVhaI = parcelRequire("gVhaI");

var $1vEOb = parcelRequire("1vEOb");

var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $l8ruj = parcelRequire("l8ruj");

var $eGVUJ = parcelRequire("eGVUJ");


var $67sX6 = parcelRequire("67sX6");

var $2f454 = parcelRequire("2f454");

var $evkwq = parcelRequire("evkwq");

var $k8auG = parcelRequire("k8auG");

var $63LqY = parcelRequire("63LqY");
const $2340dd6536b8099b$var$stopPropagation = (e)=>e.stopPropagation();
// Prevent enter from opening issue view
const $2340dd6536b8099b$var$stopEnterPropagation = (e)=>{
    if (e.key === 'Enter') e.stopPropagation();
};
const $2340dd6536b8099b$var$SummaryInner = ({ shouldMenuRender: shouldMenuRender, highlight: highlight, issueId: issueId, issueKey: issueKey, text: text, onSizeChange: onSizeChange, isSummaryEditing: isSummaryEditing, dialogPlacement: dialogPlacement, setIsSummaryEditing: setIsSummaryEditing, onSubmit: onSubmit, onUpdate: onUpdate, onFailure: onFailure })=>{
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const highlightText = (0, $5uXOq.useMemo)(()=>highlight && (0, $gVhaI.shouldHighlightText)(text, highlight) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gVhaI.HighlightText), {
            phrases: highlight,
            content: text
        }) : undefined, [
        highlight,
        text
    ]);
    const preventInlineEditing = (0, $67sX6.useBoardSelector)((state)=>(0, $k8auG.getPreventInlineEditing)(state));
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (onSizeChange) requestAnimationFrame(onSizeChange);
    }, [
        isSummaryEditing,
        onSizeChange
    ]);
    const onEditStateChange = (0, $5uXOq.useCallback)((newIsEditing)=>{
        dispatch((0, $2f454.setInlineEditing)('summary', issueId, newIsEditing));
        setIsSummaryEditing(newIsEditing);
    }, [
        setIsSummaryEditing,
        dispatch,
        issueId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2340dd6536b8099b$var$Wrapper, {
        shouldMenuRender: shouldMenuRender,
        isSummaryEditing: isSummaryEditing,
        onClick: isSummaryEditing ? $2340dd6536b8099b$var$stopPropagation : undefined,
        onKeyDown: $2340dd6536b8099b$var$stopEnterPropagation,
        disableClick: preventInlineEditing && !isSummaryEditing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eH4Q8.AsyncSummaryInlineEdit), {
        issueId: issueId.toString(),
        issueKey: issueKey,
        highlightText: highlightText,
        onChange: onSizeChange,
        onEditStateChange: onEditStateChange,
        onCancel: onSizeChange,
        onSubmit: onSubmit,
        onUpdate: onUpdate,
        onFailure: onFailure,
        dialogPlacement: dialogPlacement,
        ...isIncrementPlanningBoard && {
            disableSummaryUnderlineText: true,
            onSaveField: async (_, fieldId, fieldValue)=>{
                dispatch((0, $evkwq.issueIncrementPlanningUpdate)({
                    issueId: issueId,
                    fieldId: fieldId,
                    fieldValue: fieldValue
                }));
            }
        }
    }));
};
const $2340dd6536b8099b$export$46453a0401d6cd1a = ({ shouldRenderRichField: shouldRenderRichField, ...props })=>{
    const [issueSummaryFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: (0, $g5X3G.toIssueKey)(props.issueKey),
        fieldKey: (0, $5fc53.SUMMARY_TYPE)
    });
    const [{ value: summaryFieldConfig }] = (0, $54wEF.useFieldConfigWithoutRefetch)(props.issueKey, (0, $5fc53.SUMMARY_TYPE));
    const shouldRenderRich = shouldRenderRichField && issueSummaryFieldValue && summaryFieldConfig;
    const editableField = (0, $eGVUJ.useEditableField)({
        isExperienceAvailable: shouldRenderRich
    });
    const fallback = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1vEOb.CardSummary), props), [
        props
    ]);
    if (shouldRenderRich) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2s1j.SummaryInlineEditErrorBoundary), {
        packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
        fallback: fallback,
        onError: editableField.onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "ng-board.inline-edit.summary-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2340dd6536b8099b$var$SummaryInner, {
        ...props,
        ...editableField
    })));
    return fallback;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2340dd6536b8099b$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldMenuRender: shouldMenuRender, isSummaryEditing: isSummaryEditing, disableClick: disableClick, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _1x82h2mm _155o11wp _ogi711wp _1uv97079 _cbvav77o _p2gzr5cr",
            __cmplp.shouldMenuRender && !__cmplp.isSummaryEditing && "_2hwxxy5q",
            __cmplp.disableClick && "_lcxvglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eH4Q8", function(module, exports) {

$parcel$export(module.exports, "AsyncSummaryInlineEdit", () => $bc592fb83a4636c2$export$54e29fccbbfceca7);

var $kxZPA = parcelRequire("kxZPA");

const $bc592fb83a4636c2$export$54e29fccbbfceca7 = (0, $kxZPA.lazy)(()=>(parcelRequire("8D7l5")).then(({ SummaryInlineEdit: SummaryInlineEdit })=>SummaryInlineEdit), {
    moduleId: "./src/packages/issue/fields/summary-components/summary-inline-edit/src/ui/main.tsx"
});

});
parcelRegister("8D7l5", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("5PmoH").then(()=>parcelRequire('gZthY'));

});


parcelRegister("k2s1j", function(module, exports) {

$parcel$export(module.exports, "SummaryInlineEditErrorBoundary", () => $e1487f9683c49508$export$831a097b152bf340);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");
const $e1487f9683c49508$export$831a097b152bf340 = ({ fallback: fallback, children: children, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "summary-inline-edit",
        packageName: packageName,
        teamName: "bento",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fallback),
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "summary-inline-edit-error-boundary",
        fallback: fallback
    }, children));

});




parcelRegister("byfXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $08014dce77bdf55e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $hGgHi = parcelRequire("hGgHi");

var $1bKdn = parcelRequire("1bKdn");

var $j85Tc = parcelRequire("j85Tc");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");


var $3RZIb = parcelRequire("3RZIb");

var $2vSU6 = parcelRequire("2vSU6");

var $gULOk = parcelRequire("gULOk");

var $gwIPs = parcelRequire("gwIPs");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $iHPnC = parcelRequire("iHPnC");

var $fQeLt = parcelRequire("fQeLt");

var $cm8xi = parcelRequire("cm8xi");

var $bbQQn = parcelRequire("bbQQn");

var $cfZh8 = parcelRequire("cfZh8");

var $8nii0 = parcelRequire("8nii0");

var $dHqFt = parcelRequire("dHqFt");

var $bC2fB = parcelRequire("bC2fB");

var $dNOob = parcelRequire("dNOob");

var $iDGXn = parcelRequire("iDGXn");

var $dCm1o = parcelRequire("dCm1o");

var $2xFXk = parcelRequire("2xFXk");

var $acAaD = parcelRequire("acAaD");

var $iUagi = parcelRequire("iUagi");

var $iuuJH = parcelRequire("iuuJH");

var $bSSdD = parcelRequire("bSSdD");

var $2VkyK = parcelRequire("2VkyK");

var $d2i8f = parcelRequire("d2i8f");

var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");

var $aTBle = parcelRequire("aTBle");

var $aeiE5 = parcelRequire("aeiE5");

const $08014dce77bdf55e$export$43d19547b9847fe4 = ({ mediaId: mediaId, issue: issue, parentSummary: parentSummary, parentColor: parentColor, showParent: showParent, assignee: assignee, isCMPBoard: isCMPBoard, isDone: isDone, status: status })=>{
    const showEpicLabels = (0, $iDGXn.useShowEpics)();
    const shouldRenderEpic = showParent && showEpicLabels;
    const viewSettings = (0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $iDGXn.useCardFieldsSettings)() : {
        showIssueType: true,
        showIssueKey: true,
        showPriority: true,
        showDevelopment: true,
        showAssignee: true,
        showDaysInColumn: true,
        cardExtraFields: undefined
    };
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const hasCompactIssueType = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_COMPACT_ISSUE_TYPE_ICON_ON_CARD);
    if (!issue) return null;
    const shouldRenderIssueLinksIndicator = issue.issueLinks && issue.issueLinks.length > 0;
    const shouldShowCMPCardFooter = (0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() ? [
        viewSettings.showIssueType,
        viewSettings.showIssueKey,
        viewSettings.showPriority,
        viewSettings.showDevelopment,
        viewSettings.showAssignee && !!assignee?.avatarUrl,
        viewSettings.showDaysInColumn
    ].some((field)=>!!field) : true;
    const shouldShowTMPCardFooter = (0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() ? [
        viewSettings.showIssueType,
        viewSettings.showIssueKey,
        viewSettings.showAssignee,
        shouldRenderIssueLinksIndicator
    ].some((field)=>!!field) : true;
    const showLozengeContainer = shouldRenderEpic && parentSummary !== null && parentColor !== null;
    const showLabels = issue.labels !== undefined && issue.labels.length > 0;
    const customFields = issue?.customFields;
    const statusDetails = status?.id ? {
        id: status.id.toString(),
        name: status.name,
        statusCategory: {
            id: (0, $gULOk.categoryIdForStatusCategory)(status.category)
        }
    } : null;
    const tmpCardLite = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$CardLiteContainer, {
            isCMPBoard: Boolean(isCMPBoard),
            useContainerQuery: Boolean(!isIPBoard)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$CardLiteWrapper, {
            isFlagged: !isIPBoard && Boolean(issue.isFlagged)
        }, mediaId !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aTBle.default), {
            mediaId: mediaId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$CardLiteContent, {
            className: $dNOob.content
        }, !isIPBoard && issue.cardColor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8xi.CardColor), {
            color: issue.cardColor
        }), isIPBoard && issue.hasScenarioChanges && issue.cardColor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8xi.CardColor), {
            color: issue.cardColor
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$Summary, {
            shouldTruncate: false
        }, issue.summary), statusDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$3f380ec5cee53f21, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozenge), {
            value: statusDetails
        }))), (showLozengeContainer || showLabels && (0, $4R6GH.fg)('display_labels_on_lite_card_in_tmp_board')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$3f380ec5cee53f21, null, shouldRenderEpic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acAaD.IssueParentFieldStatic), {
            summary: parentSummary,
            color: parentColor,
            maxWidth: "100%"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHqFt.CardLabels), {
            labels: issue.labels ?? []
        })), shouldShowTMPCardFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$CardFooter, null, viewSettings.showIssueType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$f315b19fd9da0750, {
            src: issue.typeUrl
        }), viewSettings.showIssueKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$IssueKey, {
            isDone: isDone
        }, issue.key), !isIPBoard && viewSettings.showAssignee && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$a7c304b17e9dec26, {
            url: assignee?.avatarUrl
        }), isIPBoard && shouldRenderIssueLinksIndicator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aeiE5.IssueLinksIndicator), {
            issueId: issue.id,
            issueKey: issue.key
        })))));
    const cmpCardLite = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$CardLiteContainer, {
            isCMPBoard: Boolean(isCMPBoard),
            useContainerQuery: Boolean(!isIPBoard)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$CardLiteWrapper, {
            isFlagged: Boolean(issue.isFlagged)
        }, mediaId !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aTBle.default), {
            mediaId: mediaId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$CardLiteContentCMP, {
            className: $dNOob.content
        }, issue.cardColor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8xi.CardColor), {
            color: issue.cardColor
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$ContentSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$Summary, {
            shouldTruncate: true,
            className: $dNOob.summary
        }, issue.summary)), statusDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$3f380ec5cee53f21, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozenge), {
            value: statusDetails
        }))), showLozengeContainer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$3f380ec5cee53f21, null, shouldRenderEpic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$2e623d726e27c97, {
            summary: parentSummary,
            color: parentColor,
            maxWidth: "100%"
        })), customFields && customFields.some((config)=>config.id && ((0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() ? viewSettings.cardExtraFields?.[config.id] !== false : true)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$ContentSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bbQQn.CardCustomFields), {
            isCMPBoard: isCMPBoard,
            fields: customFields.filter((config)=>config.id && ((0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() ? viewSettings.cardExtraFields?.[config.id] !== false : true))
        })), shouldShowCMPCardFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$ContentSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$FooterSection, {
            className: $dNOob.footer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$FooterPrimarySection, {
            className: $dNOob.footerChildSection
        }, !hasCompactIssueType && viewSettings.showIssueType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$f315b19fd9da0750, {
            src: issue.typeUrl
        }), viewSettings.showIssueKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$IssueKey, {
            isDone: isDone
        }, issue.key)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$FooterTertiarySection, {
            className: $dNOob.footerChildSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8nii0.Container), null, hasCompactIssueType && viewSettings.showIssueType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$f315b19fd9da0750, {
            src: issue.typeUrl
        }), issue.devStatusField && viewSettings.showDevelopment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$DevStatusPlaceholder, {
            "data-testid": (0, $e5a504d18c288d62$export$eee2e9bddfbbaf6f)
        }), typeof issue.daysInColumn === 'number' && viewSettings.showDaysInColumn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cfZh8.CardDaysInColumn), {
            days: issue.daysInColumn
        }), issue.priority && viewSettings.showPriority && /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$IconWrapper, {
            "data-testid": "software-board.board-container.board.card-container.card-lite.priority-icon.wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$PriorityIcon, {
            alt: issue.priority.name,
            src: issue.priority?.iconUrl
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$FooterSecondarySection, null, assignee?.avatarUrl != null && viewSettings.showAssignee && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$CMPAvatar, {
            url: assignee?.avatarUrl,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $dNOob.cmpAvatar,
            "data-testid": "software-board.board-container.board.card-container.card-lite.cmp-avatar"
        })))))));
    return isCMPBoard ? cmpCardLite() : tmpCardLite();
};
function $08014dce77bdf55e$var$getShouldShowParent(state) {
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    if (isCMPBoard) return !state.ui.board.displayOptions.areEpicLabelsHidden;
    return (0, $45cXl.getSwimlaneMode)(state) !== (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id;
}
const $08014dce77bdf55e$export$c31df4bd766f9c35 = (state, { id: id })=>{
    const issue = (0, $5mTgl.platformIssueSelector)(state)(id);
    const issueParents = (0, $bSSdD.getIssueParents)(state);
    const parentId = (()=>{
        if (!issue) return null;
        if (id in issueParents) return id;
        return issue.parentId;
    })();
    const issueMedia = (0, $5mTgl.isCardMediaEnabled)(state) && !(0, $2VkyK.isIssueMediaHiddenByUser)(state, id) ? (0, $2VkyK.getIssueMedia)(state, id) : null;
    const mediaId = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueMedia) && 'attachmentMediaApiId' in issueMedia ? issueMedia.attachmentMediaApiId : null;
    const parent = parentId !== null ? (0, $bSSdD.makeIssueParentByIdSelector)(state)(parentId) : null;
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    const showParent = $08014dce77bdf55e$var$getShouldShowParent(state);
    const isJSMBoard = (0, $67Z81.projectTypeSelector)(state) === (0, $2vSU6.SERVICE_DESK_PROJECT);
    return {
        issue: issue,
        assignee: issue?.assigneeAccountId ? (0, $36pz7.getPerson)(state, issue.assigneeAccountId) : null,
        mediaId: mediaId,
        parentSummary: parent?.summary ?? null,
        parentColor: parent?.color ?? null,
        showParent: // Hide parent when grouping by epic
        showParent,
        isCMPBoard: isCMPBoard,
        status: isJSMBoard ? (0, $5mTgl.getStatusByIssueIdSelector)(state, {
            id: id
        }) ?? null : null,
        isDone: (0, $d2i8f.isDoneIssueSelector)(state)(id)
    };
};
const $08014dce77bdf55e$var$CardLiteConnected = (0, $bC2fB.connect)($08014dce77bdf55e$export$c31df4bd766f9c35, {})($08014dce77bdf55e$export$43d19547b9847fe4);
var $08014dce77bdf55e$export$2e2bcd8739ae039 = $08014dce77bdf55e$var$CardLiteConnected;
const $08014dce77bdf55e$var$LOZENGE_THEMES = (0, $iHPnC.transformColorToTheme)((colorSchema)=>({
        textColor: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $08014dce77bdf55e$export$3f380ec5cee53f21 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexDirection: 'row',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexFlow: 'row wrap',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            boxAlign: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            maxWidth: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            gap: "var(--ds-space-100, 8px)"
        }
    }, children));
const $08014dce77bdf55e$export$2e623d726e27c97 = ({ summary: summary, color: color, maxWidth: maxWidth })=>{
    if (summary !== null && color !== null) {
        // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
        const theme = $08014dce77bdf55e$var$LOZENGE_THEMES[color];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'inline-block',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                boxSizing: 'border-box',
                maxWidth: maxWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                textTransform: 'uppercase',
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                font: `var(--ds-font-body-small, ${(0, $3RZIb.fontFallback).body.small})`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                fontWeight: "var(--ds-font-weight-bold, 700)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                borderRadius: '3px',
                color: theme.textColor,
                background: theme.backgroundColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                whiteSpace: 'nowrap',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                textOverflow: 'ellipsis',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                overflow: 'hidden'
            }
        }, summary);
    }
    return null;
};
const $08014dce77bdf55e$export$c9ed62821215deda = ({ labels: labels })=>{
    if (labels == null || !labels.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'inline-flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            gap: "var(--ds-space-100, 8px)"
        }
    }, labels.map((label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$Label, {
            key: label
        }, label)));
};
const $08014dce77bdf55e$export$f315b19fd9da0750 = ({ src: src })=>{
    if (src !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: src,
        alt: "",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '16px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: '16px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            verticalAlign: 'text-bottom'
        }
    });
    return null;
};
const $08014dce77bdf55e$var$AvatarWrapperOld = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop
            backgroundColor: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N90})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: '50%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            justifyContent: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            alignItems: 'center'
        }
    }, children);
const $08014dce77bdf55e$var$AvatarWrapperNew = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $08014dce77bdf55e$var$AvatarWrapperStylesNew
    }, children);
const $08014dce77bdf55e$var$AvatarWrapper = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $08014dce77bdf55e$var$AvatarWrapperNew, $08014dce77bdf55e$var$AvatarWrapperOld);
const $08014dce77bdf55e$export$a7c304b17e9dec26 = ({ url: url })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '24px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: '24px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: "var(--ds-space-025, 2px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            justifyContent: 'center'
        },
        "data-testid": "software-board.board-container.board.card-container.card-lite.tmp-avatar"
    }, !url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$AvatarWrapper, null, (0, $4R6GH.fg)('enghealth-12479-jsw-board-visual-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bKdn))), {
        label: "",
        color: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N700})`,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($j85Tc))),
        LEGACY_primaryColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        LEGACY_secondaryColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N90})`
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j85Tc))), {
        primaryColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
        secondaryColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N90})`,
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: '50%',
            background: `url(${url})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundSize: 'cover',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%'
        }
    }));
const $08014dce77bdf55e$var$iconSize = (0, $gwIPs.gridSize) * 2;
const $08014dce77bdf55e$var$gridAreas = ()=>{
    if ($dNOob.primary && $dNOob.tertiary && $dNOob.secondary) return `"${$dNOob.primary} ${$dNOob.tertiary} ${$dNOob.secondary}"`;
    return '"primary tertiary secondary"';
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $08014dce77bdf55e$var$CardLiteContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCMPBoard: isCMPBoard, useContainerQuery: useContainerQuery, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_akq0kr": (0, $lD23V.default)($dNOob["card-content-container"])
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _vchhusvi",
            __cmplp.isCMPBoard ? "_1yt4ze3t" : "_1yt4zkqn",
            __cmplp.isCMPBoard ? "_18s8zkqn" : "_18s8ze3t",
            __cmplp.useContainerQuery && "_ylxr1hpx",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$CardLiteWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlagged: isFlagged, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _2rko1l7b _kqswh2mm _16qssefo",
            __cmplp.isFlagged ? "_11q71tzq" : "_11q7hp5a",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$CardLiteContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _vchhusvi _1e0c1txw _2lx21bp4 _1yt4utpp _zulpu2gc _lf631b66",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$Summary = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldTruncate: shouldTruncate, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f3xy5q _1nmz1hna _1i4q1hna _1wybdlk8",
            __cmplp.shouldTruncate ? "_1yyj11wp" : "_1yyjn7od",
            __cmplp.shouldTruncate ? "_1e0ccj1k" : "_1e0c1nu9",
            __cmplp.shouldTruncate ? "_1reo15vq _18m915vq" : "_1reon7od _18m9n7od",
            __cmplp.shouldTruncate ? "_sudp1e54" : "_sudpn7od",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$CardFooter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1tke1f4h _zulp1b66",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$IssueKey = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDone: isDone, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _4t3igktf _1reo15vq _18m915vq _1bto1l2s _11c816g6 _16jlkb7n _1o9zkb7n _i0dlf1ug _syaz1e9r",
            __cmplp.isDone ? "_4bfu18uv _1hms1911 _ajmmnqa1" : "_4bfu18uv _1hmsn7od _ajmmnqa1",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$CardLiteContentCMP = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _vchhusvi _1e0c1txw _2lx21bp4 _zulpu2gc _1yt4utpp",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$CMPAvatar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { url: url, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_12kfzft": (0, $lD23V.default)(`url(${__cmplp.url}) 0/cover`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1tcg _1bsb1tcg _18s8v77o _2rko1ssb _11q7gkke",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$ContentSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$FooterSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_o48r1v": (0, $lD23V.default)($08014dce77bdf55e$var$gridAreas())
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c11p5 _1bsb1osq _zulphyhw _1tke1f4h _2z05hkll _yv0e1xhj _1lmc1r3e",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$FooterPrimarySection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_yr074y": (0, $lD23V.default)($dNOob.primary ? $dNOob.primary : 'primary')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_nd5lkgrd _p12f1ns9 _vchhusvi _1e0c11p5 _wij21bp4 _4cvr1h6o _1bahv2br _zulp1b66",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$FooterSecondarySection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_y1a6xm": (0, $lD23V.default)($dNOob.secondary ? $dNOob.secondary : 'secondary')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_nd5l1vev _vchhusvi _1e0c11p5 _wij21bp4 _4cvr1h6o _1bahv2br _zulp1b66",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$FooterTertiarySection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_tgx8yt": (0, $lD23V.default)($dNOob.tertiary ? $dNOob.tertiary : 'tertiary')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_nd5l1xse _1tke1tcg _vchhusvi _1e0c11p5 _wij21bp4 _4cvr1h6o _1bahv2br _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$PriorityIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i7vkz",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$DevStatusPlaceholder = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1tcg _4t3i1tcg _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _vchhusvi _4t3igktf _vwz4kb7n _1wybdlk8 _1yt4u49m _2rko1l7b _p12fmgvx _1reo15vq _18m915vq _1bto1l2s _o5721q9c _bfhk1s4m _syazaj1x",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$AvatarWrapperStylesNew = (0, $8CUq3.xcss)({
    width: '100%',
    height: '100%',
    backgroundColor: 'color.background.accent.gray.subtler',
    borderRadius: '50%'
});

});
parcelRegister("aTBle", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0c8ddd8c062199c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6XiwG = parcelRequire("6XiwG");
const $d0c8ddd8c062199c$var$Placeholder = ({ mediaId: mediaId })=>{
    const [height] = (0, $6XiwG.useCardMediaHeightById)({
        mediaId: mediaId
    });
    if (height === null) return null;
    // eslint-disable-next-line jira/react/no-style-attribute
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d0c8ddd8c062199c$var$PlaceholderContainer, {
        style: {
            height: `${height}px`
        }
    });
};
var $d0c8ddd8c062199c$export$2e2bcd8739ae039 = $d0c8ddd8c062199c$var$Placeholder;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d0c8ddd8c062199c$var$PlaceholderContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _11q7zxtc _2rkome6u",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6XiwG", function(module, exports) {

$parcel$export(module.exports, "useCardMediaHeightById", () => $390f7f1ec234c9a0$export$32a8960ab7cdab5d);

var $7JoAD = parcelRequire("7JoAD");

var $bYSCr = parcelRequire("bYSCr");
const $390f7f1ec234c9a0$var$getCardMediaHeightById = (state, { mediaId: mediaId })=>{
    if (!state[mediaId]) return null;
    return state[mediaId].height;
};
const $390f7f1ec234c9a0$export$32a8960ab7cdab5d = (0, $7JoAD.createHook)((0, $bYSCr.Store), {
    selector: $390f7f1ec234c9a0$var$getCardMediaHeightById
});

});
parcelRegister("bYSCr", function(module, exports) {

$parcel$export(module.exports, "Store", () => $a8fc5a0390027126$export$390f32400eaf98c9);
$parcel$export(module.exports, "useCardMediaActions", () => $a8fc5a0390027126$export$b6c16ead0e8ed8e7);

var $7JoAD = parcelRequire("7JoAD");

var $iEhb0 = parcelRequire("iEhb0");

var $3DmOE = parcelRequire("3DmOE");
const $a8fc5a0390027126$export$390f32400eaf98c9 = (0, $7JoAD.createStore)({
    initialState: $3DmOE.initialState,
    actions: $iEhb0.default
});
const $a8fc5a0390027126$export$b6c16ead0e8ed8e7 = (0, $7JoAD.createHook)($a8fc5a0390027126$export$390f32400eaf98c9, {
    selector: null
});

});
parcelRegister("iEhb0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9520b52250d5694$export$2e2bcd8739ae039);

var $3DmOE = parcelRequire("3DmOE");
const $d9520b52250d5694$var$actions = {
    setMediaHeight: (mediaId, height)=>({ setState: setState })=>{
            setState({
                [mediaId]: {
                    height: height
                }
            });
        },
    clearCardMedia: ()=>({ setState: setState })=>setState((0, $3DmOE.initialState))
};
var $d9520b52250d5694$export$2e2bcd8739ae039 = $d9520b52250d5694$var$actions;

});
parcelRegister("3DmOE", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $253cc0fbdd4559f4$export$d4c72bab9d6cc13a);
const $253cc0fbdd4559f4$export$d4c72bab9d6cc13a = {};

});





const $e5a504d18c288d62$export$676116062bf0b86c = 'software-board.board-container.board.card-container.card-lite.priority-icon.wrapper';
const $e5a504d18c288d62$export$9b1957b51b1a5a8a = 'software-board.board-container.board.card-container.card-lite.cmp-avatar';
const $e5a504d18c288d62$export$15fb3e7bf3bea766 = 'software-board.board-container.board.card-container.card-lite.tmp-avatar';
const $e5a504d18c288d62$export$eee2e9bddfbbaf6f = 'software-board.board-container.board.card-container.card-lite.dev-status-placeholder';


parcelRegister("ljbvM", function(module, exports) {

$parcel$export(module.exports, "CardWithIcc", () => $93a4914688f2c5a7$export$828bc8c020948a5b);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $dC5iT = parcelRequire("dC5iT");


var $2Z6La = parcelRequire("2Z6La");

var $67sX6 = parcelRequire("67sX6");

var $2f454 = parcelRequire("2f454");

var $9OPlz = parcelRequire("9OPlz");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");

var $f8Y0z = parcelRequire("f8Y0z");

var $iC4Jt = parcelRequire("iC4Jt");

var $aBTGv = parcelRequire("aBTGv");
const $93a4914688f2c5a7$var$renderRichCardDelay = 200;
const $93a4914688f2c5a7$export$828bc8c020948a5b = (props)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const iccRef = (0, $aBTGv.useIccRef)();
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const { initialProjectId: projectId } = (0, $2Z6La.useIccContext)();
    const pendingHoverAction = (0, $5uXOq.useRef)(null);
    const hasRenderedIcc = (0, $5uXOq.useRef)(false);
    const { isColumnIccEnabled: isColumnIccEnabled, id: id, cardIndex: cardIndex, columnId: columnId, swimlaneId: swimlaneId, isLastSwimlane: isLastSwimlane, children: children = null, onIssueChange: onIssueChange, canShowIccNudge: canShowIccNudge, forceIccRender: forceIccRender, groupParentId: groupParentId, headerRef: headerRef } = props;
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const boardStore = (0, $67sX6.useBoardStore)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const isActualIcc = (0, $67sX6.useBoardSelector)((state)=>(0, $5mTgl.shouldRenderIcc)(state, {
            issueId: id
        }));
    const isAssigneeEditing = Boolean((0, $67sX6.useBoardSelector)((state)=>(0, $9OPlz.getCardEditAssignee)(state)(id)));
    (0, $5uXOq.useEffect)(()=>()=>{
            // Clean up timer
            if (pendingHoverAction.current != null) clearTimeout(pendingHoverAction.current);
        }, []);
    const onMouseOver = (0, $5uXOq.useCallback)(()=>{
        // Early return if card is rich already
        if ((0, $5mTgl.isActiveCardSelector)(boardStore.getState(), {
            issueId: id
        })) return;
        // Delay setting the richActiveCard to avoid unneccessary renders when scrolling or moving the mouse around
        pendingHoverAction.current = setTimeout(()=>{
            dispatch((0, $2f454.setActiveIssueWithIcc)(id));
        }, $93a4914688f2c5a7$var$renderRichCardDelay);
    }, [
        boardStore,
        id,
        dispatch
    ]);
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $2f454.setActiveIssueWithIcc)(id));
    }, [
        dispatch,
        id
    ]);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>{
        const containerElement = containerRef.current;
        if (!containerElement) return;
        // Remove pending setActiveIssueWithIcc if it hasn't already fired
        if (pendingHoverAction.current) {
            clearTimeout(pendingHoverAction.current);
            pendingHoverAction.current = null;
        }
        const activeElement = (0, $aBTGv.getActiveElement)();
        // Ignore event if focused on a child
        if (activeElement instanceof Node && containerElement.contains(activeElement)) return;
        dispatch((0, $2f454.setActiveIssueWithIcc)(null));
    }, [
        containerRef,
        dispatch
    ]);
    const onBlur = (0, $5uXOq.useCallback)((e)=>{
        const { relatedTarget: relatedTarget } = e;
        if (containerRef.current && relatedTarget instanceof Node && !containerRef.current.contains(relatedTarget)) dispatch((0, $2f454.setActiveIssueWithIcc)(null));
    }, [
        containerRef,
        dispatch
    ]);
    if (isActualIcc && !hasRenderedIcc.current) hasRenderedIcc.current = true;
    const canUseIcc = isIPBoard ? !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(id) : typeof id === 'number' && id > 0;
    const iccIntersectingWithHeader = isIPBoard && (0, $aBTGv.isIccIntersectingWithHeader)(headerRef, iccRef, cardIndex === 0);
    const shouldRenderIccAbove = canUseIcc && !iccIntersectingWithHeader && (cardIndex === 0 || forceIccRender || isActualIcc || hasRenderedIcc.current);
    const icc = isColumnIccEnabled && shouldRenderIccAbove ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f8Y0z.default), {
        canShowIccNudge: canShowIccNudge,
        columnId: columnId,
        swimlaneId: swimlaneId,
        cardIndex: cardIndex,
        triggerAppearance: (0, $7462c685f739ed5a$export$d2f7b3f0efb6e208),
        // TODO-BOARD-REFACTOR-TYPES
        // @ts-expect-error id is string but insertBefore is wanting a number
        insertBefore: id,
        isLastSwimlane: isLastSwimlane,
        onChangeFormVisible: onIssueChange,
        // TODO-BOARD-REFACTOR-TYPES
        // @ts-expect-error groupParentId is string but inline-card-create is wanting a number
        groupParentId: groupParentId,
        // TODO-BOARD-REFACTOR-TYPES
        // @ts-expect-error projectID expects number but it is number | null
        projectId: projectId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iC4Jt.ICCPlaceholder), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93a4914688f2c5a7$var$CardWithICC, {
        raiseCardForPopup: isAssigneeEditing,
        "data-testid": "software-board.board-container.board.card-container.card-with-icc",
        onFocus: onFocus,
        onBlur: onBlur,
        ref: containerRef,
        ...!isCMPBoard ? {
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave
        } : {
            onMouseEnter: onMouseOver,
            onMouseLeave: onMouseLeave
        }
    }, isIPBoard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ref: iccRef
    }, icc) : icc, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $93a4914688f2c5a7$var$CardWithICC = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { raiseCardForPopup: raiseCardForPopup, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _kqswh2mm",
            __cmplp.raiseCardForPopup ? "_1pbyb4wl" : "_1pby1wug",
            __cmplp.className
        ])
    });
});

});
const $7462c685f739ed5a$export$3789e4b2a10baa2b = 'full';
const $7462c685f739ed5a$export$db1cdb8627b81f84 = 'compact';
const $7462c685f739ed5a$export$aca095bc476d426f = 'simple';
const $7462c685f739ed5a$export$1aad44a7533f8ad8 = 'table_row';
const $7462c685f739ed5a$export$d2f7b3f0efb6e208 = 'hidden';
const $7462c685f739ed5a$export$dda6912361cddac9 = 'visible';
const $7462c685f739ed5a$export$565566e3df4dad53 = 'blur';
const $7462c685f739ed5a$export$806b905ec7df742f = 'enter';
const $7462c685f739ed5a$export$2bb790b9008907b4 = 'escape';
const $7462c685f739ed5a$export$ba9f60edfdf2e66 = 'create_button';
const $7462c685f739ed5a$export$193356664cd84c83 = 255;
const $7462c685f739ed5a$export$f9e3e7ede9ba929d = 500;
const $7462c685f739ed5a$export$e0bc602b327f818b = 'add-issue-type-option';

parcelRegister("f8Y0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbf48ee69da288e1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $gJBT6 = parcelRequire("gJBT6");

var $2hXfb = parcelRequire("2hXfb");


var $3bDjY = parcelRequire("3bDjY");

var $jzjy1 = parcelRequire("jzjy1");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $cE2Qr = parcelRequire("cE2Qr");


var $iXVV6 = parcelRequire("iXVV6");

var $3t5QD = parcelRequire("3t5QD");

var $2QOGE = parcelRequire("2QOGE");

var $67sX6 = parcelRequire("67sX6");

var $gXFr2 = parcelRequire("gXFr2");

var $fyeGd = parcelRequire("fyeGd");

var $9UXXB = parcelRequire("9UXXB");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $iGszW = parcelRequire("iGszW");

var $iC4Jt = parcelRequire("iC4Jt");

var $1JBgu = parcelRequire("1JBgu");

var $fwQRP = parcelRequire("fwQRP");

var $9fzgs = parcelRequire("9fzgs");
const $bbf48ee69da288e1$export$2f9c4649b3f871a3 = /*#__PURE__*/ (0, $5uXOq.memo)(({ canShowIccNudge: canShowIccNudge, issueHierarchyLevel: // TODO-BOARD-REFACTOR-TYPES: this isn't a type error yet, but this is not set anywhere although it's marked as required
// @ts-expect-error issueHierarchyLevel it was marked as required
issueHierarchyLevel, triggerAppearance: triggerAppearance = (0, $7462c685f739ed5a$export$dda6912361cddac9), cardIndex: cardIndex, columnId: columnId, swimlaneId: swimlaneId, groupParentId: groupParentId, isLastSwimlane: isLastSwimlane, onChangeFormVisible: onChangeFormVisible, insertBefore: insertBefore, projectId: projectId, showOnHover: showOnHover, isFooter: isFooter })=>{
    const [showInlineCardCreate, setInlineCardCreateVisibility] = (0, $5uXOq.useState)(false);
    const [isDismissed] = (0, $cE2Qr.useIsDismissed)();
    const isIPBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
    const config = (0, $67sX6.useBoardSelector)((0, $9UXXB.getInlineCardCreateConfig));
    const firstOpenSwimlaneId = (0, $67sX6.useBoardSelector)((0, $5mTgl.getFirstOpenSwimlaneIdSelector));
    const columnIndex = (0, $67sX6.useBoardSelector)((state)=>(0, $fyeGd.getColumnIndex)(state, columnId));
    const isTheFirstCurrentSwimlaneOpen = swimlaneId === null || firstOpenSwimlaneId === swimlaneId;
    const intl = (0, $koVbs.default)();
    const cardTypes = (0, $67sX6.useBoardSelector)((state)=>{
        if (isIPBoard) return (0, $gXFr2.getIssueTypesForIssueCreation)(state)(projectId).map((issueType)=>({
                ...issueType,
                isDisabled: false
            }));
        return (0, $gXFr2.allowedCardTypesForIccSelector)(state)(columnId, swimlaneId, !!groupParentId);
    });
    const mappedCardTypesOld = (0, $5uXOq.useMemo)(()=>cardTypes.map((cardType)=>(0, $fwQRP.mapInlineCardCreateCardType)({
                ...cardType,
                hasRequiredFields: (0, $fwQRP.isPartialIccMode)(columnId, cardType.id, config)
            })), [
        cardTypes,
        columnId,
        config
    ]);
    const mappedCardTypes = (0, $5uXOq.useMemo)(()=>cardTypes.map((cardType)=>(0, $fwQRP.mapInlineCardCreateCardType)(cardType)), [
        cardTypes
    ]);
    const externalValues = $bbf48ee69da288e1$var$getExternalValues(cardIndex, columnIndex);
    const renderAdditionalTypeSelectOptionContent = (0, $5uXOq.useCallback)((cardType)=>{
        if (!cardType.isDisabled) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: intl.formatMessage((0, $iGszW.default).disabledIssueTypeTooltip),
            position: "bottom-start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iC4Jt.TooltipIconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hXfb))), {
            primaryColor: `var(--ds-text-discovery, ${(0, $829f609a65d26a98$exports).P300})`,
            label: ""
        })));
    }, [
        intl
    ]);
    if (mappedCardTypes.length < 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iC4Jt.ICCPlaceholder), null);
    const showHiddenCardForNudge = ()=>{
        setInlineCardCreateVisibility(true);
    };
    const hideHiddenCardForNudge = ()=>{
        setInlineCardCreateVisibility(false);
    };
    const canDisplayNudge = (0, $fwQRP.shouldDisplayNudge)({
        isTheFirstCurrentSwimlaneOpen: isTheFirstCurrentSwimlaneOpen,
        triggerAppearance: triggerAppearance,
        canShowIccNudge: canShowIccNudge,
        cardIndex: externalValues.cardIndex,
        isDismissed: isDismissed
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            issueHierarchyLevel: issueHierarchyLevel
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        Wrapper: (0, $2QOGE.BoardKanbanCreateIssueNudgeAsync),
        conditionsToApplyWrapper: canDisplayNudge,
        onShow: showHiddenCardForNudge,
        onHide: hideHiddenCardForNudge,
        attributes: {
            triggerAppearance: triggerAppearance
        }
    }, showInlineCardCreate && triggerAppearance === (0, $7462c685f739ed5a$export$d2f7b3f0efb6e208) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        id: "platform-board.create-button-text.icon-label-v2",
        defaultMessage: "Create issue"
    }, (formattedMessage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1JBgu.Trigger), {
            onClick: hideHiddenCardForNudge,
            label: typeof formattedMessage[0] === 'string' ? formattedMessage[0] : 'Create issue'
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fzgs.VisibleIcc), {
        renderAdditionalTypeSelectOptionContent: renderAdditionalTypeSelectOptionContent,
        cardIndex: cardIndex,
        cardTypes: cardTypes,
        // TODO-BOARD-REFACTOR-TYPES
        // @ts-expect-error CardType is not compatible with BoardCardType
        mappedCardTypes: (0, $4R6GH.fg)('simplify_icc_summary_validation') ? mappedCardTypes : mappedCardTypesOld,
        columnId: columnId,
        groupParentId: groupParentId,
        swimlaneId: swimlaneId,
        triggerAppearance: triggerAppearance,
        isLastSwimlane: isLastSwimlane,
        insertBefore: insertBefore,
        onChangeFormVisible: onChangeFormVisible,
        showOnHover: showOnHover,
        projectId: projectId,
        isFooter: isFooter
    })));
});
const $bbf48ee69da288e1$var$getExternalValues = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardIndex, columnIndex)=>({
        cardIndex: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(cardIndex) ? cardIndex + 1 : null,
        columnIndex: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(columnIndex) ? columnIndex + 1 : null
    }), (cardIndex, columnIndex)=>`${cardIndex}.${columnIndex}`);
var $bbf48ee69da288e1$export$2e2bcd8739ae039 = (0, $jzjy1.AnalyticsSubject)('issue')($bbf48ee69da288e1$export$2f9c4649b3f871a3);

});
parcelRegister("2QOGE", function(module, exports) {

$parcel$export(module.exports, "BoardKanbanCreateIssueNudgeAsync", () => $98e223871a1aaf15$export$b06df4865174af62);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $98e223871a1aaf15$var$BoardAccordionNudgeLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("d4Ffg")).then((exportedModule)=>exportedModule.CreateIssueAccordionNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/kanban-onboarding-tour/board-create-issue/index.tsx"
});
const $98e223871a1aaf15$export$b06df4865174af62 = ({ children: children, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$f2fe211acb4aa81a),
        fallback: children,
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$a402f2c11da96cd7)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-kanban-onboarding-create-issues-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($98e223871a1aaf15$var$BoardAccordionNudgeLazy, restProps, children)));
$98e223871a1aaf15$export$b06df4865174af62.displayName = 'BoardKanbanCreateIssueNudgeAsync';

});
parcelRegister("d4Ffg", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("bI0oI").then(()=>parcelRequire('f0wJ8'));

});


parcelRegister("iGszW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8baf230ff450c07d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8baf230ff450c07d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    disabledIssueTypeTooltip: {
        "id": "software.main.board-container.board.inline-card-create.disabled-issue-type-tooltip",
        "defaultMessage": "Due to required fields, this issue type can only be created from the workflow's initial status"
    },
    disabledIccTriggerTooltip: {
        "id": "software.main.board-container.board.inline-card-create.disabled-icc-trigger-tooltip",
        "defaultMessage": "Due to required fields on all issue types, new issues can only be created from the workflow\u2019s initial status"
    }
});

});

parcelRegister("iC4Jt", function(module, exports) {

$parcel$export(module.exports, "ICCPlaceholder", () => $86f4dcea1a6cd6d9$export$7418306a16b7f3e6);
$parcel$export(module.exports, "TooltipIconWrapper", () => $86f4dcea1a6cd6d9$export$d8fe6814885155a8);
/* styled.tsx generated by @compiled/babel-plugin v0.31.0 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $86f4dcea1a6cd6d9$export$7418306a16b7f3e6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3iftgi _18s8p5ac _lcxvglyw _uiztglyw",
            __cmplp.className
        ])
    });
});
const $86f4dcea1a6cd6d9$export$d8fe6814885155a8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_80omtlke",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1JBgu", function(module, exports) {

$parcel$export(module.exports, "Trigger", () => $17ad1bba8a80a931$export$41fb9f06171c75f4);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $gBq9h = parcelRequire("gBq9h");
// z-index is because the trigger must appear above a focused card
const $17ad1bba8a80a931$var$triggerElementStyles = null;
const $17ad1bba8a80a931$var$TriggerWrapper = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1ule _kqswh2mm _1pbykb7n _18s8p5ac _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _4t3iftgi _1bsb1osq _bfhk18uv _tzy4kb7n _1pjhtlke _1mygkb7n _qj9aglyw _3feiglyw"
        ])
    });
const $17ad1bba8a80a931$export$41fb9f06171c75f4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gBq9h.default), {
        TriggerWrapper: $17ad1bba8a80a931$var$TriggerWrapper,
        ...props
    });

});
parcelRegister("gBq9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0a1afa644007482$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9lMrf = parcelRequire("9lMrf");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $3bDjY = parcelRequire("3bDjY");

const $e0a1afa644007482$var$fadeInAnimation = null;
const $e0a1afa644007482$var$triggerStyles = null;
const $e0a1afa644007482$var$buttonStyles = null;
// eslint-disable-next-line jira/styled/styled-component-order
const $e0a1afa644007482$var$centeredIconStyles = (0, $8CUq3.xcss)({
    margin: 'space.negative.025',
    height: "var(--ds-space-300, 24px)",
    width: "var(--ds-space-300, 24px)"
});
// eslint-disable-next-line jira/styled/styled-component-order
const $e0a1afa644007482$var$dividerStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    transform: 'translateY(3px)',
    height: "var(--ds-space-025, 2px)",
    width: '100%'
});
const $e0a1afa644007482$var$TriggerFallback = (props)=>/*#__PURE__*/ $5uXOq.createElement("div", {
        ...props,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _kqswh2mm _1pbykb7n _18s8p5ac _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _4t3iu2gc _1bsb1osq _bfhk18uv _tzy4idpf _1pjhtlke _1mygkb7n _qj9aglyw _d0altlke _11om1wwu _7psyfnf5 _1uy0fnf5 _bir2q7pw"
        ])
    });
const $e0a1afa644007482$export$9496cf78b8451731 = ({ label: label, onClick: onClick, TriggerWrapper: TriggerWrapper = $e0a1afa644007482$var$TriggerFallback, shouldFocusTrigger: shouldFocusTrigger = false })=>/*#__PURE__*/ $5uXOq.createElement(TriggerWrapper, {
        onClick: onClick
    }, /*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
        content: label,
        position: "left",
        delay: (0, $7462c685f739ed5a$export$f9e3e7ede9ba929d),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ $5uXOq.createElement("button", {
        "data-testid": "platform-inline-card-create.ui.trigger.hidden.button",
        autoFocus: shouldFocusTrigger,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _kqswstnw _t9ec1c9r _1pbykb7n _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu2glyw _12y31o36 _4t3iv47k _1bsbv47k _19itglyw _2rko1sit _bfhkq17z _80om1kw7"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $e0a1afa644007482$var$centeredIconStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9lMrf))), {
        label: label,
        primaryColor: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`
    })))), /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $e0a1afa644007482$var$dividerStyles,
        backgroundColor: "color.background.brand.bold"
    }));
var $e0a1afa644007482$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($e0a1afa644007482$export$9496cf78b8451731);

});


parcelRegister("fwQRP", function(module, exports) {

$parcel$export(module.exports, "shouldDisplayNudge", () => $9fd6bbea3aac6f96$export$fb74206c86afd6c8);
$parcel$export(module.exports, "mapInlineCardCreateCardType", () => $9fd6bbea3aac6f96$export$412240769d99b76c);
$parcel$export(module.exports, "isPartialIccMode", () => $9fd6bbea3aac6f96$export$41ec910c4a4c5cb4);

var $4R6GH = parcelRequire("4R6GH");

const $9fd6bbea3aac6f96$export$fb74206c86afd6c8 = ({ isTheFirstCurrentSwimlaneOpen: isTheFirstCurrentSwimlaneOpen, triggerAppearance: triggerAppearance, cardIndex: cardIndex, canShowIccNudge: canShowIccNudge, isDismissed: isDismissed })=>{
    if (!isTheFirstCurrentSwimlaneOpen || !canShowIccNudge) return false;
    if (isDismissed && (0, $4R6GH.fg)('board_column_footer_nudge_load_fix')) return false;
    const displayNudgeInBetweenCards = triggerAppearance === (0, $7462c685f739ed5a$export$d2f7b3f0efb6e208) && cardIndex === 2;
    const displayNudgeOnVisibleButton = triggerAppearance === (0, $7462c685f739ed5a$export$dda6912361cddac9);
    return displayNudgeInBetweenCards || displayNudgeOnVisibleButton;
};
const $9fd6bbea3aac6f96$export$412240769d99b76c = ({ id: id, name: name, iconUrl: iconUrl })=>({
        id: Number(id),
        name: name,
        iconUrl: iconUrl,
        isDisabled: false
    });
const $9fd6bbea3aac6f96$export$41ec910c4a4c5cb4 = (columnId, cardTypeId, config)=>config?.mode === 'PARTIAL' || config?.columns?.[columnId]?.mode === 'PARTIAL' || config?.columns?.[columnId]?.issueTypes?.[cardTypeId] === 'PARTIAL';

});

parcelRegister("9fzgs", function(module, exports) {

$parcel$export(module.exports, "VisibleIcc", () => $46a47ad99fef883e$export$b499b8d3bd236f88);

var $5uXOq = parcelRequire("5uXOq");

var $dMEgP = parcelRequire("dMEgP");

var $jzjy1 = parcelRequire("jzjy1");

var $5rFbt = parcelRequire("5rFbt");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $ajkcI = parcelRequire("ajkcI");

var $27WcV = parcelRequire("27WcV");

var $2Z6La = parcelRequire("2Z6La");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4pxa7 = parcelRequire("4pxa7");


var $67sX6 = parcelRequire("67sX6");

var $2f454 = parcelRequire("2f454");

var $l67YV = parcelRequire("l67YV");

var $1vXOx = parcelRequire("1vXOx");

var $k8auG = parcelRequire("k8auG");

var $gXFr2 = parcelRequire("gXFr2");

var $9OPlz = parcelRequire("9OPlz");

var $fyeGd = parcelRequire("fyeGd");

var $4gt6L = parcelRequire("4gt6L");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $b6Ykj = parcelRequire("b6Ykj");
const $46a47ad99fef883e$var$EMPTY_ARRAY = [];
const $46a47ad99fef883e$var$isInSimplifyIccBundleVariation = (fireExposureEvent = false)=>{
    const [expConfigM2, fireExposureM2] = (0, $6s1PB.UNSAFE_noExposureExp)('simplify_icc_bundle_m2');
    if (fireExposureEvent) fireExposureM2();
    const isInVariationM2 = expConfigM2.get('cohort', 'not-enrolled') === 'variation';
    return isInVariationM2;
};
const $46a47ad99fef883e$var$isEnrolledInSimplifyIccBundle = (fireExposureEvent = false)=>{
    const [expConfigM2, fireExposureM2] = (0, $6s1PB.UNSAFE_noExposureExp)('simplify_icc_bundle_m2');
    if (fireExposureEvent) fireExposureM2();
    const isInVariationM2 = expConfigM2.get('cohort', 'not-enrolled') !== 'not-enrolled';
    return isInVariationM2;
};
const $46a47ad99fef883e$var$EMPTY_PROJECTS_ARRAY = [];
const $46a47ad99fef883e$var$VisibleIccComponent = ({ columnId: columnId, cardTypes: cardTypes, cardIndex: cardIndex, insertBefore: insertBefore, isLastSwimlane: isLastSwimlane, projectId: projectId, swimlaneId: swimlaneId, groupParentId: groupParentId, mappedCardTypes: mappedCardTypes, onChangeFormVisible: onChangeFormVisible, showOnHover: showOnHover, triggerAppearance: triggerAppearance, renderAdditionalTypeSelectOptionContent: renderAdditionalTypeSelectOptionContent, isFooter: isFooter })=>{
    const [isFormVisible, setIsFormVisible] = (0, $5uXOq.useState)(false);
    const { initialCardTypeId: initialCardTypeId } = (0, $2Z6La.useIccContext)();
    const keepIccOpen = (0, $4pxa7.useKeepIccOpenState)();
    const { triggerReason: triggerReason } = (0, $4pxa7.useTriggerEventState)();
    const { setTriggerReason: setTriggerReason } = (0, $4pxa7.useKeepIccOpenActions)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const hasCustomFilters = (0, $67sX6.useBoardSelector)((0, $5mTgl.hasCustomFiltersSelector));
    const appliedFilterCount = (0, $67sX6.useBoardSelector)((state)=>hasCustomFilters ? 0 : (0, $5mTgl.filtersForInlineCardCreateCountSelector)(state));
    const isIPBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
    const canEditBoard = (0, $67sX6.useBoardSelector)((state)=>(0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df]);
    const manageIssueTypesLink = (0, $67sX6.useBoardSelector)((state)=>canEditBoard ? (0, $gXFr2.manageIssueTypesLinkSelector)(state) : null);
    const getStatusTransitions = (0, $67sX6.useBoardSelector)((0, $gXFr2.makeGetStatusTransitionsForType));
    const defaultIssueTypeId = (0, $67sX6.useBoardSelector)((0, $4gt6L.defaultIssueTypeIdSelector));
    const isUnscheduledColumn = isIPBoard && columnId === (0, $5rFbt.UNSCHEDULED_COLUMN_ID);
    const shouldStayOpen = (0, $67sX6.useBoardSelector)((state)=>{
        if (isUnscheduledColumn) return !!isFooter && (0, $9OPlz.isUnscheduledColumnICCOpen)(state, swimlaneId, columnId);
        if ((0, $k8auG.isEligibleForSimplifyIccBundleExperiment)(state) && $46a47ad99fef883e$var$isEnrolledInSimplifyIccBundle(true)) {
            if ((0, $k8auG.isBoardEmptySelector)(state) && (0, $fyeGd.getColumnIndex)(state, columnId) === 0 && (0, $9OPlz.getColumnIdToKeepICCOpen)(state) === null && (0, $9OPlz.getLastOpenedColumnId)(state) === null) {
                if (triggerReason !== 'emptyBoard') setTriggerReason('emptyBoard');
                if ($46a47ad99fef883e$var$isInSimplifyIccBundleVariation(true)) {
                    dispatch((0, $2f454.setIssueIdWithAboveICCOpen)(null, columnId));
                    return true;
                }
            }
            // This is an existing code path and is not part of the
            // changes in the variation cohort, so no checks needed
            if (insertBefore) return (0, $9OPlz.hasICCOpen)(state, insertBefore);
            if ($46a47ad99fef883e$var$isInSimplifyIccBundleVariation(true)) return (0, $9OPlz.keepICCOpenInColumn)(state, columnId);
        }
        return (0, $9OPlz.hasICCOpen)(state, insertBefore);
    });
    const projects = (0, $67sX6.useBoardSelector)((state)=>isIPBoard ? (0, (/*@__PURE__*/$parcel$interopDefault($dMEgP)))((0, $gXFr2.getIssueProjectsForIssueCreation)(state)) : $46a47ad99fef883e$var$EMPTY_PROJECTS_ARRAY);
    const issueTypeTransitions = (0, $67sX6.useBoardSelector)((state)=>!isIPBoard ? (0, $gXFr2.getInitialTransitionsForColumn)(state)(columnId) : undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onAutoOpen = (0, $5uXOq.useCallback)((sessionId)=>{
        // start event for auto open icc
        const startAutoOpenICCAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        // firing start event for icc that is auto open - same as onTriggerClickCallback
        // @ts-expect-error Second argument should be of format "actionSubject action"
        (0, $8zOmE.fireUIAnalytics)(startAutoOpenICCAnalyticsEvent, 'triggerClicked', 'triggerButton', {
            formWasOpen: isFormVisible,
            triggerAppearance: triggerAppearance,
            sessionId: sessionId,
            isInSimplifyIccBundleVariation: $46a47ad99fef883e$var$isInSimplifyIccBundleVariation(),
            isAutoOpen: true
        });
        dispatch((0, $l67YV.setInlineCreateSessionId)(sessionId));
    }, [
        createAnalyticsEvent,
        dispatch,
        isFormVisible,
        triggerAppearance
    ]);
    const onTriggerClick = (0, $5uXOq.useCallback)((sessionId)=>{
        if ($46a47ad99fef883e$var$isEnrolledInSimplifyIccBundle()) setIsFormVisible(true);
        if (isIPBoard) {
            // When other create button is clicked, close ICC in unscheduled column
            dispatch((0, $2f454.closeIccInUnscheduledColumn)());
            if (isUnscheduledColumn && isFooter && swimlaneId) // If the button clicked in unscheduled column and footer, sync the swimlane ID to the state
            // This is so the create button in the header is disabled
            dispatch((0, $2f454.openIccInUnscheduledColumn)(swimlaneId));
        }
        dispatch((0, $l67YV.setInlineCreateSessionId)(sessionId));
        dispatch((0, $2f454.setIssueIdWithAboveICCOpen)(insertBefore, columnId));
    }, [
        dispatch,
        insertBefore,
        columnId,
        swimlaneId,
        isIPBoard,
        isUnscheduledColumn,
        isFooter
    ]);
    const onCancelOrBlur = (0, $5uXOq.useCallback)(()=>{
        if ($46a47ad99fef883e$var$isEnrolledInSimplifyIccBundle() || isUnscheduledColumn) setIsFormVisible(false);
        if (isUnscheduledColumn) dispatch((0, $2f454.closeIccInUnscheduledColumn)());
        dispatch((0, $l67YV.clearInlineCreateSessionId)());
        dispatch((0, $2f454.setIssueIdWithAboveICCOpen)(null, null));
    }, [
        dispatch,
        isUnscheduledColumn
    ]);
    const onFormVisibleChange = (0, $5uXOq.useCallback)((formVisible)=>{
        setIsFormVisible(formVisible);
        onChangeFormVisible(formVisible);
    }, [
        onChangeFormVisible
    ]);
    const onCreate = (0, $b6Ykj.useOnCreate)({
        columnId: columnId,
        cardTypes: cardTypes,
        cardIndex: cardIndex,
        insertBefore: insertBefore,
        isLastSwimlane: isLastSwimlane,
        projectId: projectId,
        swimlaneId: swimlaneId,
        groupParentId: groupParentId,
        isUnscheduledColumn: isUnscheduledColumn
    });
    const statusTransitions = (0, $5uXOq.useMemo)(()=>{
        if ((shouldStayOpen || isFormVisible) && !isIPBoard) return getStatusTransitions(columnId, issueTypeTransitions, initialCardTypeId);
        return $46a47ad99fef883e$var$EMPTY_ARRAY;
    }, [
        columnId,
        getStatusTransitions,
        initialCardTypeId,
        isFormVisible,
        isIPBoard,
        issueTypeTransitions,
        shouldStayOpen
    ]);
    const shouldShowCreateButton = (0, $67sX6.useBoardSelector)((state)=>{
        if ((0, $k8auG.isEligibleForSimplifyIccBundleExperiment)(state) && $46a47ad99fef883e$var$isEnrolledInSimplifyIccBundle(true)) // Validation/warning message and Multicreate dialog can only be checked later (depends on user input)
        return projects.length === 0 && // this should only happen for IPBoards, including check to be safe
        $46a47ad99fef883e$var$isInSimplifyIccBundleVariation(true);
        return false;
    });
    (0, $5uXOq.useEffect)(()=>{
        if (isUnscheduledColumn) setIsFormVisible(shouldStayOpen);
        else if ($46a47ad99fef883e$var$isEnrolledInSimplifyIccBundle()) {
            // Checking if it's undefined here because we should still be setting it to
            // false if keepIccOpen is false
            if ($46a47ad99fef883e$var$isInSimplifyIccBundleVariation() && shouldStayOpen) setIsFormVisible(keepIccOpen);
            else setIsFormVisible(shouldStayOpen);
        }
    }, [
        keepIccOpen,
        shouldStayOpen,
        isUnscheduledColumn
    ]);
    const InlineCardCreate = (0, $4R6GH.fg)('board_icc_form_async_load') ? (0, $27WcV.default) : (0, $ajkcI.AsyncInlineCardCreate);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(InlineCardCreate, {
        defaultCardTypeId: defaultIssueTypeId,
        cardTypes: mappedCardTypes,
        // appliedFilterCount is used to show the info dialog with the X filters applied message
        // hide it if we have custom filters active as it'll be misleading
        appliedFilterCount: appliedFilterCount,
        manageIssueTypesLink: manageIssueTypesLink,
        shouldStayOpen: shouldStayOpen,
        isIPBoard: isIPBoard,
        statusTransitions: statusTransitions,
        isFormVisible: $46a47ad99fef883e$var$isEnrolledInSimplifyIccBundle() || isUnscheduledColumn ? isFormVisible : undefined,
        // TODO-BOARD-REFACTOR-TYPES
        // @ts-expect-error inconsistent types between IssueProject and Project
        projects: projects,
        onCreate: onCreate,
        onTriggerClick: onTriggerClick,
        onCancel: onCancelOrBlur,
        onBlur: onCancelOrBlur,
        onChangeFormVisible: $46a47ad99fef883e$var$isEnrolledInSimplifyIccBundle() ? onChangeFormVisible : onFormVisibleChange,
        renderAdditionalTypeSelectOptionContent: renderAdditionalTypeSelectOptionContent,
        showOnHover: showOnHover,
        triggerAppearance: triggerAppearance,
        shouldShowCreateButton: shouldShowCreateButton,
        ...isUnscheduledColumn && {
            shouldScrollIntoView: true
        },
        onAutoOpen: onAutoOpen
    });
};
const $46a47ad99fef883e$export$b499b8d3bd236f88 = (0, $jzjy1.AnalyticsSubject)('issue')($46a47ad99fef883e$var$VisibleIccComponent);

});
parcelRegister("ajkcI", function(module, exports) {

$parcel$export(module.exports, "AsyncInlineCardCreate", () => $48770c3f11d04f5a$export$441cdaed6235f1e9);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $48770c3f11d04f5a$var$AsyncInlineCardCreateComp = (0, $kxZPA.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("27WcV"))), {
    moduleId: "./src/packages/platform/ui/board-kit/src/ui/inline-card-create/index.tsx"
});
const $48770c3f11d04f5a$export$441cdaed6235f1e9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "async-inline-card-create",
        packageName: "JiraPlatformBoardKit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-inline-card-create",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($48770c3f11d04f5a$var$AsyncInlineCardCreateComp, props)));

});
parcelRegister("27WcV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "InlineCardCreateWithEngagement", () => $24371841a711ab69$export$d072fca0df9c8916);
$parcel$export(module.exports, "default", () => $24371841a711ab69$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $9vPRK = parcelRequire("9vPRK");

var $6s1PB = parcelRequire("6s1PB");


var $hNJJt = parcelRequire("hNJJt");

var $hIWd8 = parcelRequire("hIWd8");

var $cVImo = parcelRequire("cVImo");
const $24371841a711ab69$export$d072fca0df9c8916 = (0, $9vPRK.default)((0, $hIWd8.default));
const $24371841a711ab69$var$isEnrolledInSimplifyIccBundle = ()=>{
    const [expConfigM2] = (0, $6s1PB.UNSAFE_noExposureExp)('simplify_icc_bundle_m2');
    const isEnrolledM2 = expConfigM2.get('cohort', 'not-enrolled') !== 'not-enrolled';
    return isEnrolledM2;
};
const $24371841a711ab69$var$InlineCardCreate = (props)=>{
    const [isFormOpen, setIsFormOpen] = (0, $5uXOq.useState)(props.shouldStayOpen);
    const { shouldStayOpen: shouldStayOpen, isFormVisible: isFormVisibleProp, cardTypes: cardTypes, showOnHover: showOnHover, triggerAppearance: triggerAppearance, buttonSpotlightTargetId: buttonSpotlightTargetId, manageIssueTypesLink: manageIssueTypesLink, appliedFilterCount: appliedFilterCount, selectedCardTypeId: selectedCardTypeId, defaultCardTypeId: defaultCardTypeId, onTriggerClick: onTriggerClick, onChangeFormVisible: onChangeFormVisible, onCancel: onCancel, onBlur: onBlur, onCreate: onCreate, onChangeProject: onChangeProject, renderAdditionalTypeSelectOptionContent: renderAdditionalTypeSelectOptionContent, statusTransitions: statusTransitions, isIPBoard: isIPBoard, projects: projects, initialProjectId: initialProjectId, TypeSelect: TypeSelect, shouldKeepFormOpenOnClickOutside: shouldKeepFormOpenOnClickOutside, shouldShowCreateButton: shouldShowCreateButton, shouldScrollIntoView: shouldScrollIntoView, onAutoOpen: onAutoOpen } = props;
    const onCreateHandler = (0, $5uXOq.useCallback)((createPayload)=>{
        const createCallbackPayload = createPayload.map(({ summary: summary, cardTypeId: cardTypeId, fields: fields, projectId: projectId })=>{
            const project = isIPBoard ? {
                projectId: projectId
            } : {};
            return {
                summary: summary,
                cardType: String(cardTypeId),
                transition: fields?.get((0, $hNJJt.FIELD_KEY_STATUS_TRANSITIONS)),
                ...project
            };
        });
        onCreate(createCallbackPayload);
    }, [
        isIPBoard,
        onCreate
    ]);
    const onChangeFormVisibleHandler = (0, $5uXOq.useCallback)((isFormVisible)=>{
        onChangeFormVisible(isFormVisible);
        setIsFormOpen(isFormVisible);
    }, [
        onChangeFormVisible,
        setIsFormOpen
    ]);
    const extraItems = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(manageIssueTypesLink) ? [] : [
            {
                url: manageIssueTypesLink
            }
        ], [
        manageIssueTypesLink
    ]);
    if (false) return null;
    const IICComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($24371841a711ab69$export$d072fca0df9c8916, {
        // @ts-expect-error - TS2322 - Type '{ onAutoOpen: AutoOpenCallback | undefined; { cardTypes: CardTypeShape[]; extraItems: { url: string; }[]; numFilters: number; onCreate: (createPayload: CreatePayload) => void; appearance: "full"; triggerAppearance: TriggerAppearance; ... 10 more ...; renderAdditionalTypeSelectOptionContent: ((cardType: CardTypeShape) => ReactElement<...>) | undefined; }' is not assignable to type 'IntrinsicAttributes & WithEngagementProps & { children?: ReactNode; }'.
        cardTypes: cardTypes,
        shouldKeepFormOpenOnClickOutside: shouldKeepFormOpenOnClickOutside,
        extraItems: extraItems,
        TypeSelect: TypeSelect,
        numFilters: appliedFilterCount,
        onCreate: onCreateHandler,
        appearance: (0, $7462c685f739ed5a$export$3789e4b2a10baa2b),
        triggerAppearance: triggerAppearance,
        areActionButtonsVisible: true,
        isFormVisibleDefault: shouldStayOpen,
        isFormVisible: $24371841a711ab69$var$isEnrolledInSimplifyIccBundle() ? isFormVisibleProp : undefined,
        targetId: buttonSpotlightTargetId,
        selectedCardTypeId: selectedCardTypeId,
        defaultCardTypeId: defaultCardTypeId,
        onChangeFormVisible: onChangeFormVisibleHandler,
        onTriggerClick: onTriggerClick,
        onCancel: onCancel,
        onBlur: onBlur,
        renderAdditionalTypeSelectOptionContent: renderAdditionalTypeSelectOptionContent,
        statusTransitions: statusTransitions,
        projects: projects,
        initialProjectId: initialProjectId,
        onChangeProject: onChangeProject,
        shouldShowCreateButton: shouldShowCreateButton,
        onAutoOpen: onAutoOpen,
        shouldScrollIntoView: shouldScrollIntoView
    });
    return showOnHover ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cVImo.HiddenButtonWrapper), {
        isICCFormOpen: isFormOpen
    }, IICComponent) : IICComponent;
};
$24371841a711ab69$var$InlineCardCreate.defaultProps = {
    shouldStayOpen: false,
    appliedFilterCount: 0,
    cardTypes: [],
    statusTransitions: [],
    showOnHover: false,
    triggerAppearance: (0, $7462c685f739ed5a$export$dda6912361cddac9),
    buttonSpotlightTargetId: '',
    manageIssueTypesLink: null,
    selectedCardTypeId: undefined,
    defaultCardTypeId: undefined
};
var $24371841a711ab69$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($24371841a711ab69$var$InlineCardCreate);

});
parcelRegister("hNJJt", function(module, exports) {

$parcel$export(module.exports, "FIELD_KEY_STATUS_TRANSITIONS", () => $e682d994c4b3be50$export$9f9b866ee3adcf04);
$parcel$export(module.exports, "default", () => $e682d994c4b3be50$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gZL7V = parcelRequire("gZL7V");

var $c8Oei = parcelRequire("c8Oei");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");
var $b9dFI = parcelRequire("b9dFI");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $85BdV = parcelRequire("85BdV");
const $e682d994c4b3be50$var$ANALYTICS_SUBJECT = 'iccStatusSelect';
const $e682d994c4b3be50$export$9f9b866ee3adcf04 = 'statusTransitions';
const $e682d994c4b3be50$var$getStatusTheme = (id)=>$e682d994c4b3be50$var$statusCategoryToThemeMap[id] || 'default';
const $e682d994c4b3be50$var$statusCategoryToThemeMap = {
    '1': 'default',
    '2': 'default',
    '3': 'success',
    '4': 'inprogress'
};
const $e682d994c4b3be50$var$Option = ({ children: children, ...props })=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { statusInfo: statusInfo } = props.data;
    const buttonTheme = $e682d994c4b3be50$var$getStatusTheme(String(statusInfo?.statusCategoryId));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "platform-inline-card-create.ui.form.status-select.option",
        xcss: [
            $e682d994c4b3be50$var$optionContentStyles,
            $e682d994c4b3be50$var$buttonThemeStyle[buttonTheme]
        ]
    }, children));
};
const $e682d994c4b3be50$var$transformOptions = (statusTransitions, selectedTransitionId)=>{
    let value;
    const options = [];
    statusTransitions.forEach((transition)=>{
        const option = {
            label: transition.name,
            value: transition.transitionId,
            statusInfo: transition
        };
        if (transition.transitionId === selectedTransitionId) value = option;
        else options.push(option);
    });
    if (!value) value = options?.[0];
    return {
        options: options,
        value: value
    };
};
const $e682d994c4b3be50$var$buttonThemeStyle = {
    default: (0, $8CUq3.xcss)({
        backgroundColor: 'color.background.neutral',
        color: 'color.text',
        ':hover': {
            color: 'color.text',
            backgroundColor: 'color.background.neutral.hovered'
        }
    }),
    success: (0, $8CUq3.xcss)({
        backgroundColor: 'color.background.success',
        color: 'color.text.success',
        ':hover': {
            color: 'color.text.success',
            backgroundColor: 'color.background.success.hovered'
        }
    }),
    inprogress: (0, $8CUq3.xcss)({
        backgroundColor: 'color.background.information',
        color: 'color.text.information',
        ':hover': {
            color: 'color.text.information',
            backgroundColor: 'color.background.information.hovered'
        }
    })
};
const $e682d994c4b3be50$var$StatusTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ value: value, isOpen: isOpen, ...triggerProps }, ref)=>{
    const buttonTheme = $e682d994c4b3be50$var$getStatusTheme(String(value?.statusInfo?.statusCategoryId));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e682d994c4b3be50$var$statusContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e682d994c4b3be50$var$statusButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: value.label ?? null,
        delay: (0, $7462c685f739ed5a$export$f9e3e7ede9ba929d),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        key: "pressable",
        ...triggerProps,
        ref: ref,
        xcss: [
            $e682d994c4b3be50$var$buttonContentStyles,
            $e682d994c4b3be50$var$buttonThemeStyle[buttonTheme]
        ],
        "aria-label": formatMessage((0, $85BdV.default).ariaLabel, {
            value: value.label ?? formatMessage((0, $85BdV.default).invalid)
        }),
        testId: "platform-inline-card-create.ui.form.status-select.trigger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        maxLines: 1,
        weight: "bold",
        size: "small",
        color: "inherit"
    }, value.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e682d994c4b3be50$var$iconContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
        LEGACY_size: "medium",
        label: "",
        "aria-hidden": "true",
        color: "currentColor"
    }))))));
});
const $e682d994c4b3be50$var$StatusSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ statusTransitions: statusTransitions, selectedTransitionId: selectedTransitionId, onSelectTransition: onSelectTransition }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { value: value, options: options } = (0, $5uXOq.useMemo)(()=>$e682d994c4b3be50$var$transformOptions(statusTransitions, selectedTransitionId), [
        statusTransitions,
        selectedTransitionId
    ]);
    const onChange = (0, $5uXOq.useCallback)((option)=>{
        option && onSelectTransition(option.statusInfo.transitionId);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'dropdown changed',
            actionSubject: $e682d994c4b3be50$var$ANALYTICS_SUBJECT
        }), {});
    }, [
        createAnalyticsEvent,
        onSelectTransition
    ]);
    const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'dropdown opened',
            actionSubject: $e682d994c4b3be50$var$ANALYTICS_SUBJECT
        }), {});
    }, [
        createAnalyticsEvent
    ]);
    const setRefNode = (0, $5uXOq.useCallback)((popupSelectRef)=>{
        ref && popupSelectRef && (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(ref, 'current.node', popupSelectRef);
    }, [
        ref
    ]);
    const renderTrigger = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e682d994c4b3be50$var$StatusTrigger, {
            ...props,
            value: value
        }), [
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9dFI.default), {
        ref: setRefNode,
        components: {
            Option: $e682d994c4b3be50$var$Option
        },
        target: renderTrigger,
        options: options,
        value: value,
        onChange: onChange,
        onMenuOpen: onMenuOpen,
        isSearchable: false,
        // DSP-2990 - PopupSelect doesn't respect isSearchable, searchThreshold is required
        searchThreshold: Number.MAX_SAFE_INTEGER,
        minMenuWidth: "auto",
        classNamePrefix: "inline-card-create-status-select",
        testId: "platform-inline-card-create.ui.form.status-select.status-select"
    });
});
var $e682d994c4b3be50$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($e682d994c4b3be50$var$StatusSelect);
const $e682d994c4b3be50$var$statusContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    minWidth: '0px',
    position: 'relative'
});
const $e682d994c4b3be50$var$statusButtonWrapperStyles = (0, $8CUq3.xcss)({
    width: '100%',
    paddingLeft: 'space.100'
});
const $e682d994c4b3be50$export$548912fb31084970 = /*#__PURE__*/ (0, $5uXOq.memo)($e682d994c4b3be50$var$StatusSelect);
const $e682d994c4b3be50$var$buttonContentStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBlock: 'space.0',
    paddingLeft: 'space.100',
    paddingRight: 'space.0',
    textTransform: 'uppercase',
    borderRadius: "var(--ds-border-radius, 3px)",
    textAlign: 'left',
    width: '100%'
});
const $e682d994c4b3be50$var$iconContainerStyles = (0, $8CUq3.xcss)({
    minWidth: '24px',
    height: '24px',
    display: 'flex',
    flex: '1',
    alignItems: 'center',
    justifyContent: 'center'
});
const $e682d994c4b3be50$var$optionContentStyles = (0, $8CUq3.xcss)({
    display: 'inline-block',
    width: 'auto',
    textTransform: 'uppercase',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    paddingBlock: 'space.0',
    paddingInline: 'space.050',
    borderRadius: "var(--ds-border-radius, 3px)"
});

});
parcelRegister("bChGW", function(module, exports) {

$parcel$export(module.exports, "components", () => $ea75c1778b4e3ad2$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $ea75c1778b4e3ad2$export$71abc632aa29e6fe);

var $h1QWG = parcelRequire("h1QWG");

var $eZFhY = parcelRequire("eZFhY");

var $i48X9 = parcelRequire("i48X9");

var $95iuW = parcelRequire("95iuW");

var $dS5G5 = parcelRequire("dS5G5");

var $aA8TC = parcelRequire("aA8TC");

var $hqcPo = parcelRequire("hqcPo");

var $8l2RA = parcelRequire("8l2RA");

var $kKm82 = parcelRequire("kKm82");

var $hpcbi = parcelRequire("hpcbi");
const $ea75c1778b4e3ad2$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $95iuW.ClearIndicator),
    Control: (0, $eZFhY.default),
    DropdownIndicator: (0, $95iuW.DropdownIndicator),
    DownChevron: (0, $95iuW.DownChevron),
    CrossIcon: (0, $95iuW.CrossIcon),
    Group: (0, $i48X9.default),
    GroupHeading: (0, $i48X9.GroupHeading),
    IndicatorsContainer: (0, $h1QWG.IndicatorsContainer),
    IndicatorSeparator: (0, $95iuW.IndicatorSeparator),
    Input: (0, $dS5G5.default),
    LoadingIndicator: (0, $95iuW.LoadingIndicator),
    Menu: (0, $aA8TC.default),
    MenuList: (0, $aA8TC.MenuList),
    MenuPortal: (0, $aA8TC.MenuPortal),
    LoadingMessage: (0, $aA8TC.LoadingMessage),
    NoOptionsMessage: (0, $aA8TC.NoOptionsMessage),
    MultiValue: (0, $hqcPo.default),
    MultiValueContainer: (0, $hqcPo.MultiValueContainer),
    MultiValueLabel: (0, $hqcPo.MultiValueLabel),
    MultiValueRemove: (0, $hqcPo.MultiValueRemove),
    Option: (0, $8l2RA.default),
    Placeholder: (0, $kKm82.default),
    SelectContainer: (0, $h1QWG.SelectContainer),
    SingleValue: (0, $hpcbi.default),
    ValueContainer: (0, $h1QWG.ValueContainer)
};
const $ea75c1778b4e3ad2$export$71abc632aa29e6fe = (props)=>({
        ...$ea75c1778b4e3ad2$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("h1QWG", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $78186faf13ea75d3$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $78186faf13ea75d3$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $78186faf13ea75d3$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $78186faf13ea75d3$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $78186faf13ea75d3$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $78186faf13ea75d3$export$d0ffd7e649cab6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $78186faf13ea75d3$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    });
const $78186faf13ea75d3$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'container', {
            '--is-disabled': isDisabled,
            '--is-rtl': isRtl
        }),
        ...innerProps
    }, children);
};
const $78186faf13ea75d3$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } }, unstyled)=>({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden',
        ...unstyled ? {} : {
            padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
        }
    });
const $78186faf13ea75d3$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
    const styles = (0, $gyjU7.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles.css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: styles.className || 'value-container',
        ...innerProps
    }, children);
};
const $78186faf13ea75d3$export$9d74e3c8b5868ad7 = ()=>({
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    });
const $78186faf13ea75d3$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'indicatorsContainer', {
            indicators: true
        }),
        ...innerProps
    }, children);
};

});
parcelRegister("gyjU7", function(module, exports) {

$parcel$export(module.exports, "noop", () => $109d3f9af5469308$export$8793edee2d425525);
$parcel$export(module.exports, "classNames", () => $109d3f9af5469308$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "cleanValue", () => $109d3f9af5469308$export$33f062f47f21a01);
$parcel$export(module.exports, "cleanCommonProps", () => $109d3f9af5469308$export$8e9fd4287627890c);
$parcel$export(module.exports, "getStyleProps", () => $109d3f9af5469308$export$26417cabd806a658);
$parcel$export(module.exports, "handleInputChange", () => $109d3f9af5469308$export$2096bae78ecda911);
$parcel$export(module.exports, "isDocumentElement", () => $109d3f9af5469308$export$d8a62a489b442872);
$parcel$export(module.exports, "normalizedHeight", () => $109d3f9af5469308$export$2e0654fad740d2e4);
$parcel$export(module.exports, "getScrollTop", () => $109d3f9af5469308$export$c4a223a8ba9e4ea5);
$parcel$export(module.exports, "scrollTo", () => $109d3f9af5469308$export$3f99968195accfaf);
$parcel$export(module.exports, "getScrollParent", () => $109d3f9af5469308$export$cfa2225e87938781);
$parcel$export(module.exports, "animatedScrollTo", () => $109d3f9af5469308$export$858c30343199f3af);
$parcel$export(module.exports, "scrollIntoView", () => $109d3f9af5469308$export$53a0910f038337bd);
$parcel$export(module.exports, "getBoundingClientObj", () => $109d3f9af5469308$export$7807c2a424c2f6d1);
$parcel$export(module.exports, "isTouchCapable", () => $109d3f9af5469308$export$56963d77dbffdde7);
$parcel$export(module.exports, "isMobileDevice", () => $109d3f9af5469308$export$44f917bf91becd01);
$parcel$export(module.exports, "supportsPassiveEvents", () => $109d3f9af5469308$export$b0622a6911dbeaf5);
$parcel$export(module.exports, "notNullish", () => $109d3f9af5469308$export$aedb69ff3e31596c);
$parcel$export(module.exports, "valueTernary", () => $109d3f9af5469308$export$40fb9515c784cc3b);
$parcel$export(module.exports, "singleValueAsValue", () => $109d3f9af5469308$export$dea4763e29237f4c);
$parcel$export(module.exports, "multiValueAsValue", () => $109d3f9af5469308$export$d1ca752ec761b95b);
$parcel$export(module.exports, "removeProps", () => $109d3f9af5469308$export$4213b25a1c4e877);
const $109d3f9af5469308$export$8793edee2d425525 = ()=>{};
const $109d3f9af5469308$export$1643ccb46f49255c = ()=>'';
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $109d3f9af5469308$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $109d3f9af5469308$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$109d3f9af5469308$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}
const $109d3f9af5469308$export$33f062f47f21a01 = (value)=>{
    if ($109d3f9af5469308$export$43bee75e5e14138e(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
const $109d3f9af5469308$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
    return {
        ...innerProps
    };
};
const $109d3f9af5469308$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
function $109d3f9af5469308$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $109d3f9af5469308$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $109d3f9af5469308$export$2e0654fad740d2e4(el) {
    if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $109d3f9af5469308$export$c4a223a8ba9e4ea5(el) {
    if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $109d3f9af5469308$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($109d3f9af5469308$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $109d3f9af5469308$export$cfa2225e87938781(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $109d3f9af5469308$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $109d3f9af5469308$export$858c30343199f3af(element, to, duration = 200, callback = $109d3f9af5469308$export$8793edee2d425525) {
    const start = $109d3f9af5469308$export$c4a223a8ba9e4ea5(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $109d3f9af5469308$var$easeOutCubic(currentTime, start, change, duration);
        $109d3f9af5469308$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $109d3f9af5469308$export$53a0910f038337bd(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $109d3f9af5469308$export$7807c2a424c2f6d1(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $109d3f9af5469308$export$c0d0115e766e14c3(str) {
    return str.replace(/\W/g, '-');
}
function $109d3f9af5469308$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $109d3f9af5469308$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $109d3f9af5469308$var$passiveOptionAccessed = false;
const $109d3f9af5469308$var$options = {
    get passive () {
        return $109d3f9af5469308$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $109d3f9af5469308$var$w = typeof window !== 'undefined' ? window : {};
if ($109d3f9af5469308$var$w.addEventListener && $109d3f9af5469308$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $109d3f9af5469308$var$w.addEventListener('p', $109d3f9af5469308$export$8793edee2d425525, $109d3f9af5469308$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $109d3f9af5469308$var$w.removeEventListener('p', $109d3f9af5469308$export$8793edee2d425525, false);
}
const $109d3f9af5469308$export$b0622a6911dbeaf5 = $109d3f9af5469308$var$passiveOptionAccessed;
function $109d3f9af5469308$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $109d3f9af5469308$export$43bee75e5e14138e(arg) {
    return Array.isArray(arg);
}
function $109d3f9af5469308$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $109d3f9af5469308$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $109d3f9af5469308$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
const $109d3f9af5469308$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};

});


parcelRegister("eZFhY", function(module, exports) {

$parcel$export(module.exports, "css", () => $728816cb4150b6bc$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $728816cb4150b6bc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $728816cb4150b6bc$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } }, unstyled)=>({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms',
        ...unstyled ? {} : {
            backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
            borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
            borderRadius: borderRadius,
            borderStyle: 'solid',
            borderWidth: 1,
            boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
            '&:hover': {
                borderColor: isFocused ? colors.primary : colors.neutral30
            }
        }
    });
const $728816cb4150b6bc$var$Control = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        ...(0, $gyjU7.getStyleProps)(props, 'control', {
            control: true,
            'control--is-disabled': isDisabled,
            'control--is-focused': isFocused,
            'control--menu-is-open': menuIsOpen
        }),
        ...innerProps,
        "aria-disabled": isDisabled || undefined
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$728816cb4150b6bc$export$2e2bcd8739ae039 = $728816cb4150b6bc$var$Control;

});

parcelRegister("i48X9", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $902e86f4b4fe337b$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $902e86f4b4fe337b$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $902e86f4b4fe337b$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $902e86f4b4fe337b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $902e86f4b4fe337b$export$b6794329c1460634 = ({ theme: { spacing: spacing } }, unstyled)=>unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
const $902e86f4b4fe337b$var$Group = (props)=>{
    const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'group', {
            group: true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Heading, {
        ...headingProps,
        selectProps: selectProps,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }, label), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", null, children));
};
const $902e86f4b4fe337b$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } }, unstyled)=>({
        label: 'group',
        cursor: 'default',
        display: 'block',
        ...unstyled ? {} : {
            color: colors.neutral40,
            fontSize: '75%',
            fontWeight: 500,
            marginBottom: '0.25em',
            paddingLeft: spacing.baseUnit * 3,
            paddingRight: spacing.baseUnit * 3,
            textTransform: 'uppercase'
        }
    });
const $902e86f4b4fe337b$export$85c8b41a3cd87edc = (props)=>{
    const { data: data, ...innerProps } = (0, $gyjU7.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'groupHeading', {
            'group-heading': true
        }),
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$902e86f4b4fe337b$export$2e2bcd8739ae039 = $902e86f4b4fe337b$var$Group;

});

parcelRegister("95iuW", function(module, exports) {

$parcel$export(module.exports, "CrossIcon", () => $13f090f36c42825d$export$3b621d86b1566b2);
$parcel$export(module.exports, "DownChevron", () => $13f090f36c42825d$export$c5cbe1656ba71e6c);
$parcel$export(module.exports, "dropdownIndicatorCSS", () => $13f090f36c42825d$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $13f090f36c42825d$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $13f090f36c42825d$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $13f090f36c42825d$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "indicatorSeparatorCSS", () => $13f090f36c42825d$export$ec39646155d07fdd);
$parcel$export(module.exports, "IndicatorSeparator", () => $13f090f36c42825d$export$bd638c2ba7915668);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $13f090f36c42825d$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $13f090f36c42825d$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
function $13f090f36c42825d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
const $13f090f36c42825d$var$styles = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
const $13f090f36c42825d$var$Svg = ({ size: size, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $13f090f36c42825d$var$styles,
        ...props
    });
const $13f090f36c42825d$export$3b621d86b1566b2 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)($13f090f36c42825d$var$Svg, {
        size: 20,
        ...props
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
const $13f090f36c42825d$export$c5cbe1656ba71e6c = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)($13f090f36c42825d$var$Svg, {
        size: 20,
        ...props
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
const $13f090f36c42825d$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        ...unstyled ? {} : {
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2,
            ':hover': {
                color: isFocused ? colors.neutral80 : colors.neutral40
            }
        }
    });
const $13f090f36c42825d$export$e1687335805e1230 = $13f090f36c42825d$var$baseCSS;
const $13f090f36c42825d$export$ec98719d3db7f2e4 = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'dropdownIndicator', {
            indicator: true,
            'dropdown-indicator': true
        }),
        ...innerProps
    }, children || /*#__PURE__*/ (0, $f8Sb3.jsx)($13f090f36c42825d$export$c5cbe1656ba71e6c, null));
};
const $13f090f36c42825d$export$9c0419fd944c1def = $13f090f36c42825d$var$baseCSS;
const $13f090f36c42825d$export$ecf9cf59142dd54a = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'clearIndicator', {
            indicator: true,
            'clear-indicator': true
        }),
        ...innerProps
    }, children || /*#__PURE__*/ (0, $f8Sb3.jsx)($13f090f36c42825d$export$3b621d86b1566b2, null));
};
const $13f090f36c42825d$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1,
        ...unstyled ? {} : {
            backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
            marginBottom: baseUnit * 2,
            marginTop: baseUnit * 2
        }
    });
const $13f090f36c42825d$export$bd638c2ba7915668 = (props)=>{
    const { innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ...innerProps,
        ...(0, $gyjU7.getStyleProps)(props, 'indicatorSeparator', {
            'indicator-separator': true
        })
    });
};
// ==============================
// Loading
// ==============================
const $13f090f36c42825d$var$loadingDotAnimations = (0, $f8Sb3.keyframes)({
    '0%, 80%, 100%': {
        opacity: 0
    },
    '40%': {
        opacity: 1
    }
});
const $13f090f36c42825d$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } }, unstyled)=>({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle',
        ...unstyled ? {} : {
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2
        }
    });
const $13f090f36c42825d$var$LoadingDot = ({ delay: delay, offset: offset })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: (0, $f8Sb3.css)({
            animation: `${$13f090f36c42825d$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        })
    });
const $13f090f36c42825d$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)({
            ...restProps,
            innerProps: innerProps,
            isRtl: isRtl,
            size: size
        }, 'loadingIndicator', {
            indicator: true,
            'loading-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($13f090f36c42825d$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)($13f090f36c42825d$var$LoadingDot, {
        delay: 160,
        offset: true
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)($13f090f36c42825d$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};

});

parcelRegister("dS5G5", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $1c949ac6f5985b40$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $1c949ac6f5985b40$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $1c949ac6f5985b40$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : '',
        ...$1c949ac6f5985b40$var$containerStyle,
        ...unstyled ? {} : {
            margin: spacing.baseUnit / 2,
            paddingBottom: spacing.baseUnit / 2,
            paddingTop: spacing.baseUnit / 2,
            color: colors.neutral80
        }
    });
const $1c949ac6f5985b40$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
const $1c949ac6f5985b40$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': {
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre',
        ...$1c949ac6f5985b40$var$spacingStyle
    }
};
const $1c949ac6f5985b40$var$inputStyle = (isHidden)=>({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%',
        ...$1c949ac6f5985b40$var$spacingStyle
    });
const $1c949ac6f5985b40$var$Input = (props)=>{
    const { cx: cx, value: value } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, $gyjU7.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'input', {
            'input-container': true
        }),
        "data-value": value || ''
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $1c949ac6f5985b40$var$inputStyle(isHidden),
        disabled: isDisabled,
        ...innerProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1c949ac6f5985b40$export$2e2bcd8739ae039 = $1c949ac6f5985b40$var$Input;

});

parcelRegister("aA8TC", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $1fde8cb844828ae2$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $1fde8cb844828ae2$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $1fde8cb844828ae2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $1fde8cb844828ae2$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $1fde8cb844828ae2$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "noOptionsMessageCSS", () => $1fde8cb844828ae2$export$cf0e22534d8b0074);
$parcel$export(module.exports, "loadingMessageCSS", () => $1fde8cb844828ae2$export$98ec46397a8cb3cd);
$parcel$export(module.exports, "NoOptionsMessage", () => $1fde8cb844828ae2$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $1fde8cb844828ae2$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $1fde8cb844828ae2$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $1fde8cb844828ae2$export$793392f970497feb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ktgnN = parcelRequire("ktgnN");

var $7nsd3 = parcelRequire("7nsd3");

var $hrqx3 = parcelRequire("hrqx3");

var $gyjU7 = parcelRequire("gyjU7");
function $1fde8cb844828ae2$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $gyjU7.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $gyjU7.normalizedHeight)(scrollParent);
    const scrollTop = (0, $gyjU7.getScrollTop)(scrollParent);
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTop;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $gyjU7.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
function $1fde8cb844828ae2$var$alignToControl(placement) {
    const placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
const $1fde8cb844828ae2$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $1fde8cb844828ae2$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'menu',
        [$1fde8cb844828ae2$var$alignToControl(placement)]: '100%',
        position: 'absolute',
        width: '100%',
        zIndex: 1,
        ...unstyled ? {} : {
            backgroundColor: colors.neutral0,
            borderRadius: borderRadius,
            boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
            marginBottom: spacing.menuGutter,
            marginTop: spacing.menuGutter
        }
    });
const $1fde8cb844828ae2$var$PortalPlacementContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $1fde8cb844828ae2$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($1fde8cb844828ae2$var$PortalPlacementContext) || {};
    const ref = (0, $5uXOq.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $5uXOq.useState)(null);
    const { controlHeight: controlHeight } = theme.spacing;
    (0, $hrqx3.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $1fde8cb844828ae2$export$bd649b913ec78e4a({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $1fde8cb844828ae2$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $1fde8cb844828ae2$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'menu', {
            menu: true
        }),
        ref: innerRef,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1fde8cb844828ae2$export$2e2bcd8739ae039 = $1fde8cb844828ae2$var$Menu;
const $1fde8cb844828ae2$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } }, unstyled)=>({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch',
        ...unstyled ? {} : {
            paddingBottom: baseUnit,
            paddingTop: baseUnit
        }
    });
const $1fde8cb844828ae2$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'menuList', {
            'menu-list': true,
            'menu-list--is-multi': isMulti
        }),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1
    }, children);
};
// ==============================
// Menu Notices
// ==============================
const $1fde8cb844828ae2$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        textAlign: 'center',
        ...unstyled ? {} : {
            color: colors.neutral40,
            padding: `${baseUnit * 2}px ${baseUnit * 3}px`
        }
    });
const $1fde8cb844828ae2$export$cf0e22534d8b0074 = $1fde8cb844828ae2$var$noticeCSS;
const $1fde8cb844828ae2$export$98ec46397a8cb3cd = $1fde8cb844828ae2$var$noticeCSS;
const $1fde8cb844828ae2$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'noOptionsMessage', {
            'menu-notice': true,
            'menu-notice--no-options': true
        }),
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps
    }, children);
};
const $1fde8cb844828ae2$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'loadingMessage', {
            'menu-notice': true,
            'menu-notice--loading': true
        }),
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option"
    }, children);
};
const $1fde8cb844828ae2$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    });
const $1fde8cb844828ae2$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
    const menuPortalRef = (0, $5uXOq.useRef)(null);
    const cleanupRef = (0, $5uXOq.useRef)(null);
    const [placement, setPortalPlacement] = (0, $5uXOq.useState)($1fde8cb844828ae2$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
    const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $gyjU7.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $hrqx3.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $ktgnN.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $hrqx3.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: setMenuPortalElement,
        ...(0, $gyjU7.getStyleProps)({
            ...props,
            offset: computedPosition.offset,
            position: menuPosition,
            rect: computedPosition.rect
        }, 'menuPortal', {
            'menu-portal': true
        }),
        ...innerProps
    }, children);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($1fde8cb844828ae2$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

});
parcelRegister("ktgnN", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $ee7339595cce6cb1$export$deee3a793edee05f);

var $62nHC = parcelRequire("62nHC");
function $ee7339595cce6cb1$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $ee7339595cce6cb1$var$o(t) {
    return $ee7339595cce6cb1$var$n(t).getComputedStyle(t);
}
function $ee7339595cce6cb1$var$i(t) {
    return t instanceof $ee7339595cce6cb1$var$n(t).Node;
}
function $ee7339595cce6cb1$var$r(t) {
    return $ee7339595cce6cb1$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $ee7339595cce6cb1$var$l;
function $ee7339595cce6cb1$var$c() {
    if ($ee7339595cce6cb1$var$l) return $ee7339595cce6cb1$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($ee7339595cce6cb1$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $ee7339595cce6cb1$var$l) : navigator.userAgent;
}
function $ee7339595cce6cb1$var$s(t) {
    return t instanceof $ee7339595cce6cb1$var$n(t).HTMLElement;
}
function $ee7339595cce6cb1$var$f(t) {
    return t instanceof $ee7339595cce6cb1$var$n(t).Element;
}
function $ee7339595cce6cb1$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $ee7339595cce6cb1$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $ee7339595cce6cb1$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $ee7339595cce6cb1$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $ee7339595cce6cb1$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($ee7339595cce6cb1$var$r(t));
}
function $ee7339595cce6cb1$var$h(t) {
    const e = /firefox/i.test($ee7339595cce6cb1$var$c()), n = $ee7339595cce6cb1$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $ee7339595cce6cb1$var$p() {
    return /^((?!chrome|android).)*safari/i.test($ee7339595cce6cb1$var$c());
}
function $ee7339595cce6cb1$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($ee7339595cce6cb1$var$r(t));
}
const $ee7339595cce6cb1$var$m = Math.min, $ee7339595cce6cb1$var$y = Math.max, $ee7339595cce6cb1$var$x = Math.round;
function $ee7339595cce6cb1$var$w(t) {
    const e = $ee7339595cce6cb1$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $ee7339595cce6cb1$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $ee7339595cce6cb1$var$x(n) !== l || $ee7339595cce6cb1$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $ee7339595cce6cb1$var$v(t) {
    return $ee7339595cce6cb1$var$f(t) ? t : t.contextElement;
}
const $ee7339595cce6cb1$var$b = {
    x: 1,
    y: 1
};
function $ee7339595cce6cb1$var$L(t) {
    const e = $ee7339595cce6cb1$var$v(t);
    if (!$ee7339595cce6cb1$var$s(e)) return $ee7339595cce6cb1$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $ee7339595cce6cb1$var$w(e);
    let l = (r ? $ee7339595cce6cb1$var$x(n.width) : n.width) / o, c = (r ? $ee7339595cce6cb1$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $ee7339595cce6cb1$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $ee7339595cce6cb1$var$v(e);
    let a = $ee7339595cce6cb1$var$b;
    o && (r ? $ee7339595cce6cb1$var$f(r) && (a = $ee7339595cce6cb1$var$L(r)) : a = $ee7339595cce6cb1$var$L(e));
    const d = u ? $ee7339595cce6cb1$var$n(u) : window, h = $ee7339595cce6cb1$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $ee7339595cce6cb1$var$n(u), e = r && $ee7339595cce6cb1$var$f(r) ? $ee7339595cce6cb1$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $ee7339595cce6cb1$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $ee7339595cce6cb1$var$n(o).frameElement;
        }
    }
    return (0, $62nHC.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $ee7339595cce6cb1$var$T(t) {
    return (($ee7339595cce6cb1$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $ee7339595cce6cb1$var$R(t) {
    return $ee7339595cce6cb1$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $ee7339595cce6cb1$var$C(t) {
    return $ee7339595cce6cb1$var$E($ee7339595cce6cb1$var$T(t)).left + $ee7339595cce6cb1$var$R(t).scrollLeft;
}
function $ee7339595cce6cb1$var$F(t) {
    if ("html" === $ee7339595cce6cb1$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $ee7339595cce6cb1$var$u(t) && t.host || $ee7339595cce6cb1$var$T(t);
    return $ee7339595cce6cb1$var$u(e) ? e.host : e;
}
function $ee7339595cce6cb1$var$W(t) {
    const e = $ee7339595cce6cb1$var$F(t);
    return $ee7339595cce6cb1$var$g(e) ? e.ownerDocument.body : $ee7339595cce6cb1$var$s(e) && $ee7339595cce6cb1$var$a(e) ? e : $ee7339595cce6cb1$var$W(e);
}
function $ee7339595cce6cb1$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $ee7339595cce6cb1$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $ee7339595cce6cb1$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $ee7339595cce6cb1$var$a(i) ? i : []) : e.concat(i, $ee7339595cce6cb1$export$3b57c1601291186b(i));
}
function $ee7339595cce6cb1$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $ee7339595cce6cb1$var$n(t), i = $ee7339595cce6cb1$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $ee7339595cce6cb1$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $ee7339595cce6cb1$var$T(t), n = $ee7339595cce6cb1$var$R(t), i = t.ownerDocument.body, r = $ee7339595cce6cb1$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $ee7339595cce6cb1$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $ee7339595cce6cb1$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $ee7339595cce6cb1$var$o(i).direction && (c += $ee7339595cce6cb1$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($ee7339595cce6cb1$var$T(e));
    else if ($ee7339595cce6cb1$var$f(i)) l = function(t, e) {
        const n = $ee7339595cce6cb1$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $ee7339595cce6cb1$var$s(t) ? $ee7339595cce6cb1$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($ee7339595cce6cb1$var$p()) {
            var c, u;
            const o = $ee7339595cce6cb1$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $62nHC.rectToClientRect)(l);
}
function $ee7339595cce6cb1$var$A(t, e) {
    return $ee7339595cce6cb1$var$s(t) && "fixed" !== $ee7339595cce6cb1$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $ee7339595cce6cb1$var$H(t, e) {
    const i = $ee7339595cce6cb1$var$n(t);
    if (!$ee7339595cce6cb1$var$s(t)) return i;
    let l = $ee7339595cce6cb1$var$A(t, e);
    for(; l && $ee7339595cce6cb1$var$d(l) && "static" === $ee7339595cce6cb1$var$o(l).position;)l = $ee7339595cce6cb1$var$A(l, e);
    return l && ("html" === $ee7339595cce6cb1$var$r(l) || "body" === $ee7339595cce6cb1$var$r(l) && "static" === $ee7339595cce6cb1$var$o(l).position && !$ee7339595cce6cb1$var$h(l)) ? i : l || function(t) {
        let e = $ee7339595cce6cb1$var$F(t);
        for(; $ee7339595cce6cb1$var$s(e) && !$ee7339595cce6cb1$var$g(e);){
            if ($ee7339595cce6cb1$var$h(e)) return e;
            e = $ee7339595cce6cb1$var$F(e);
        }
        return null;
    }(t) || i;
}
function $ee7339595cce6cb1$var$V(t, e, n) {
    const o = $ee7339595cce6cb1$var$s(e), i = $ee7339595cce6cb1$var$T(e), l = $ee7339595cce6cb1$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $ee7339595cce6cb1$var$r(e) || $ee7339595cce6cb1$var$a(i)) && (c = $ee7339595cce6cb1$var$R(e)), $ee7339595cce6cb1$var$s(e)) {
            const t = $ee7339595cce6cb1$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $ee7339595cce6cb1$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $ee7339595cce6cb1$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $ee7339595cce6cb1$export$3b57c1601291186b(t).filter((t)=>$ee7339595cce6cb1$var$f(t) && "body" !== $ee7339595cce6cb1$var$r(t)), l = null;
            const c = "fixed" === $ee7339595cce6cb1$var$o(t).position;
            let s = c ? $ee7339595cce6cb1$var$F(t) : t;
            for(; $ee7339595cce6cb1$var$f(s) && !$ee7339595cce6cb1$var$g(s);){
                const t = $ee7339595cce6cb1$var$o(s), e = $ee7339595cce6cb1$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $ee7339595cce6cb1$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $ee7339595cce6cb1$var$S(e, n, l);
            return t.top = $ee7339595cce6cb1$var$y(o.top, t.top), t.right = $ee7339595cce6cb1$var$m(o.right, t.right), t.bottom = $ee7339595cce6cb1$var$m(o.bottom, t.bottom), t.left = $ee7339595cce6cb1$var$y(o.left, t.left), t;
        }, $ee7339595cce6cb1$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $ee7339595cce6cb1$var$s(n), l = $ee7339595cce6cb1$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $ee7339595cce6cb1$var$r(n) || $ee7339595cce6cb1$var$a(l)) && (c = $ee7339595cce6cb1$var$R(n)), $ee7339595cce6cb1$var$s(n))) {
            const t = $ee7339595cce6cb1$var$E(n);
            f = $ee7339595cce6cb1$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $ee7339595cce6cb1$var$f,
    getDimensions: function(t) {
        return $ee7339595cce6cb1$var$w(t);
    },
    getOffsetParent: $ee7339595cce6cb1$var$H,
    getDocumentElement: $ee7339595cce6cb1$var$T,
    getScale: $ee7339595cce6cb1$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $ee7339595cce6cb1$var$H, r = this.getDimensions;
        return {
            reference: $ee7339595cce6cb1$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $ee7339595cce6cb1$var$o(t).direction
};
function $ee7339595cce6cb1$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$ee7339595cce6cb1$var$f(t) ? $ee7339595cce6cb1$export$3b57c1601291186b(t) : t.contextElement ? $ee7339595cce6cb1$export$3b57c1601291186b(t.contextElement) : [],
        ...$ee7339595cce6cb1$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $ee7339595cce6cb1$var$f(t) && !c && d.observe(t), $ee7339595cce6cb1$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $ee7339595cce6cb1$var$E(t) : null;
    return c && function e() {
        const o = $ee7339595cce6cb1$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $ee7339595cce6cb1$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $ee7339595cce6cb1$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $62nHC.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("62nHC", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $465550d5da2db0f1$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $465550d5da2db0f1$export$ee05aea0aeecbad4);
function $465550d5da2db0f1$var$t(t) {
    return t.split("-")[1];
}
function $465550d5da2db0f1$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $465550d5da2db0f1$var$n(t) {
    return t.split("-")[0];
}
function $465550d5da2db0f1$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($465550d5da2db0f1$var$n(t)) ? "x" : "y";
}
function $465550d5da2db0f1$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $465550d5da2db0f1$var$o(r), u = $465550d5da2db0f1$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($465550d5da2db0f1$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($465550d5da2db0f1$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $465550d5da2db0f1$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $465550d5da2db0f1$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $465550d5da2db0f1$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $465550d5da2db0f1$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $465550d5da2db0f1$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $465550d5da2db0f1$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $465550d5da2db0f1$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $465550d5da2db0f1$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $465550d5da2db0f1$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $465550d5da2db0f1$var$c = Math.min, $465550d5da2db0f1$var$f = Math.max;
function $465550d5da2db0f1$var$m(t, e, n) {
    return $465550d5da2db0f1$var$f(t, $465550d5da2db0f1$var$c(e, n));
}
const $465550d5da2db0f1$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $465550d5da2db0f1$var$a(l), h = {
                x: s,
                y: c
            }, y = $465550d5da2db0f1$var$o(f), x = $465550d5da2db0f1$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $465550d5da2db0f1$var$m(k, B, O), H = null != $465550d5da2db0f1$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $465550d5da2db0f1$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $465550d5da2db0f1$var$d = $465550d5da2db0f1$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $465550d5da2db0f1$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $465550d5da2db0f1$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$465550d5da2db0f1$var$p[t]);
}
function $465550d5da2db0f1$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $465550d5da2db0f1$var$t(n), l = $465550d5da2db0f1$var$o(n), s = $465550d5da2db0f1$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $465550d5da2db0f1$var$h(c)), {
        main: c,
        cross: $465550d5da2db0f1$var$h(c)
    };
}
const $465550d5da2db0f1$var$x = {
    start: "end",
    end: "start"
};
function $465550d5da2db0f1$var$w(t) {
    return t.replace(/start|end/g, (t)=>$465550d5da2db0f1$var$x[t]);
}
const $465550d5da2db0f1$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $465550d5da2db0f1$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $465550d5da2db0f1$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$465550d5da2db0f1$var$t(n) === e),
                    ...i.filter((n)=>$465550d5da2db0f1$var$t(n) !== e)
                ] : i.filter((t)=>$465550d5da2db0f1$var$n(t) === t)).filter((n)=>!e || $465550d5da2db0f1$var$t(n) === e || !!o && $465550d5da2db0f1$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $465550d5da2db0f1$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $465550d5da2db0f1$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$465550d5da2db0f1$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $465550d5da2db0f1$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $465550d5da2db0f1$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $465550d5da2db0f1$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $465550d5da2db0f1$var$n(r), R = $465550d5da2db0f1$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $465550d5da2db0f1$var$h(c)
            ] : function(t) {
                const e = $465550d5da2db0f1$var$h(t);
                return [
                    $465550d5da2db0f1$var$w(t),
                    e,
                    $465550d5da2db0f1$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $465550d5da2db0f1$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($465550d5da2db0f1$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($465550d5da2db0f1$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $465550d5da2db0f1$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $465550d5da2db0f1$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $465550d5da2db0f1$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $465550d5da2db0f1$var$R(t) {
    return $465550d5da2db0f1$var$g.some((e)=>t[e] >= 0);
}
const $465550d5da2db0f1$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $465550d5da2db0f1$var$A(await $465550d5da2db0f1$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $465550d5da2db0f1$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $465550d5da2db0f1$var$A(await $465550d5da2db0f1$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $465550d5da2db0f1$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $465550d5da2db0f1$var$E(t) {
    const e = $465550d5da2db0f1$var$c(...t.map((t)=>t.left)), n = $465550d5da2db0f1$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $465550d5da2db0f1$var$f(...t.map((t)=>t.right)) - e,
        height: $465550d5da2db0f1$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $465550d5da2db0f1$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$465550d5da2db0f1$export$ee05aea0aeecbad4($465550d5da2db0f1$var$E(t)));
            }(h), x = $465550d5da2db0f1$export$ee05aea0aeecbad4($465550d5da2db0f1$var$E(h)), w = $465550d5da2db0f1$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $465550d5da2db0f1$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $465550d5da2db0f1$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $465550d5da2db0f1$var$n(i), e = $465550d5da2db0f1$var$f(...y.map((t)=>t.right)), r = $465550d5da2db0f1$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $465550d5da2db0f1$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $465550d5da2db0f1$var$n(r), f = $465550d5da2db0f1$var$t(r), m = "x" === $465550d5da2db0f1$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $465550d5da2db0f1$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $465550d5da2db0f1$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $465550d5da2db0f1$export$37b6bde19b108ecc(e, u), p = $465550d5da2db0f1$var$o($465550d5da2db0f1$var$n(a)), h = $465550d5da2db0f1$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $465550d5da2db0f1$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $465550d5da2db0f1$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $465550d5da2db0f1$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $465550d5da2db0f1$var$o(a), d = $465550d5da2db0f1$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($465550d5da2db0f1$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $465550d5da2db0f1$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $465550d5da2db0f1$export$37b6bde19b108ecc(i, g), p = $465550d5da2db0f1$var$n(r), h = $465550d5da2db0f1$var$t(r), y = "x" === $465550d5da2db0f1$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $465550d5da2db0f1$var$c(x - d.right - d.left, R) : P = $465550d5da2db0f1$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $465550d5da2db0f1$var$f(d.left, 0), e = $465550d5da2db0f1$var$f(d.right, 0), n = $465550d5da2db0f1$var$f(d.top, 0), o = $465550d5da2db0f1$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $465550d5da2db0f1$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $465550d5da2db0f1$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("hrqx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2989fd9beaabfa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var $cb2989fd9beaabfa$var$index = (0, $5uXOq.useLayoutEffect);
var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = $cb2989fd9beaabfa$var$index;

});


parcelRegister("hqcPo", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $20933ad7b05a0c37$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $20933ad7b05a0c37$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $20933ad7b05a0c37$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $20933ad7b05a0c37$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $20933ad7b05a0c37$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $20933ad7b05a0c37$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");

var $95iuW = parcelRequire("95iuW");
const $20933ad7b05a0c37$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } }, unstyled)=>({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0,
        // resolves flex/text-overflow bug
        ...unstyled ? {} : {
            backgroundColor: colors.neutral10,
            borderRadius: borderRadius / 2,
            margin: spacing.baseUnit / 2
        }
    });
const $20933ad7b05a0c37$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis }, unstyled)=>({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap',
        ...unstyled ? {} : {
            borderRadius: borderRadius / 2,
            color: colors.neutral80,
            fontSize: '85%',
            padding: 3,
            paddingLeft: 6
        }
    });
const $20933ad7b05a0c37$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused }, unstyled)=>({
        alignItems: 'center',
        display: 'flex',
        ...unstyled ? {} : {
            borderRadius: borderRadius / 2,
            backgroundColor: isFocused ? colors.dangerLight : undefined,
            paddingLeft: spacing.baseUnit,
            paddingRight: spacing.baseUnit,
            ':hover': {
                backgroundColor: colors.dangerLight,
                color: colors.danger
            }
        }
    });
const $20933ad7b05a0c37$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", innerProps, children);
const $20933ad7b05a0c37$export$cf9cf2a30a59265c = $20933ad7b05a0c37$export$e1de505c1242dc1a;
const $20933ad7b05a0c37$export$544aeea2a5ce08ee = $20933ad7b05a0c37$export$e1de505c1242dc1a;
function $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "button",
        ...innerProps
    }, children || /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $95iuW.CrossIcon), {
        size: 14
    }));
}
const $20933ad7b05a0c37$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Container, {
        data: data,
        innerProps: {
            ...(0, $gyjU7.getStyleProps)(props, 'multiValue', {
                'multi-value': true,
                'multi-value--is-disabled': isDisabled
            }),
            ...innerProps
        },
        selectProps: selectProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Label, {
        data: data,
        innerProps: {
            ...(0, $gyjU7.getStyleProps)(props, 'multiValueLabel', {
                'multi-value__label': true
            })
        },
        selectProps: selectProps
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)(Remove, {
        data: data,
        innerProps: {
            ...(0, $gyjU7.getStyleProps)(props, 'multiValueRemove', {
                'multi-value__remove': true
            }),
            'aria-label': `Remove ${children || 'option'}`,
            ...removeProps
        },
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$20933ad7b05a0c37$export$2e2bcd8739ae039 = $20933ad7b05a0c37$var$MultiValue;

});

parcelRegister("8l2RA", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $6e6d67a90b457dc1$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $6e6d67a90b457dc1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $6e6d67a90b457dc1$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        ...unstyled ? {} : {
            backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
            color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
            padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
            // provide some affordance on touch devices
            ':active': {
                backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
            }
        }
    });
const $6e6d67a90b457dc1$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'option', {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }),
        ref: innerRef,
        "aria-disabled": isDisabled,
        ...innerProps,
        tabIndex: -1
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6e6d67a90b457dc1$export$2e2bcd8739ae039 = $6e6d67a90b457dc1$var$Option;

});

parcelRegister("kKm82", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $889d652a9d0dc097$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $889d652a9d0dc097$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $889d652a9d0dc097$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3',
        ...unstyled ? {} : {
            color: colors.neutral50,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        }
    });
const $889d652a9d0dc097$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'placeholder', {
            placeholder: true
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$889d652a9d0dc097$export$2e2bcd8739ae039 = $889d652a9d0dc097$var$Placeholder;

});

parcelRegister("hpcbi", function(module, exports) {

$parcel$export(module.exports, "css", () => $aff94346c62a222f$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $aff94346c62a222f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $aff94346c62a222f$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ...unstyled ? {} : {
            color: isDisabled ? colors.neutral40 : colors.neutral80,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        }
    });
const $aff94346c62a222f$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'singleValue', {
            'single-value': true,
            'single-value--is-disabled': isDisabled
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$aff94346c62a222f$export$2e2bcd8739ae039 = $aff94346c62a222f$var$SingleValue;

});


parcelRegister("b9dFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $768d8504b373d7ff$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $ao4Ml = parcelRequire("ao4Ml");

var $9ZKDH = parcelRequire("9ZKDH");

var $dI393 = parcelRequire("dI393");

var $5n5w4 = parcelRequire("5n5w4");
var $283js = parcelRequire("283js");
var $iGDLS = parcelRequire("iGDLS");

var $4wJSY = parcelRequire("4wJSY");

var $9KnKW = parcelRequire("9KnKW");

var $VSDnB = parcelRequire("VSDnB");

var $7VXAu = parcelRequire("7VXAu");


var $7K5PP = parcelRequire("7K5PP");

var $eaXSR = parcelRequire("eaXSR");

var $1DATb = parcelRequire("1DATb");

var $hT6ku = parcelRequire("hT6ku");
/**
 * Are we rendering on the client or server?
 */ const $768d8504b373d7ff$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $768d8504b373d7ff$var$FocusLock = (0, $VSDnB.fg)('platform_dst_select-bump-react-focus-lock') ? (0, $9ZKDH.default) : (0, $ao4Ml.default);
const $768d8504b373d7ff$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $768d8504b373d7ff$var$defaultPopperProps = {
    modifiers: $768d8504b373d7ff$var$modifiers,
    placement: 'bottom-start'
};
const $768d8504b373d7ff$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $768d8504b373d7ff$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$768d8504b373d7ff$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $4wJSY.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $hT6ku.defaultComponents),
            ...props.components
        };
        if (!(0, $4wJSY.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$768d8504b373d7ff$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $cBeZP.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5n5w4.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9KnKW.IdProvider), {
            postfix: "-popup-select"
        }, ({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iGDLS.Reference), null, ({ ref: ref })=>target && target({
                    isOpen: isOpen,
                    onKeyDown: this.handleTargetKeyDown,
                    ref: this.resolveTargetRef(ref),
                    'aria-haspopup': 'true',
                    'aria-expanded': isOpen,
                    'aria-controls': isOpen ? id : undefined
                })), this.renderSelect(id))));
    }
    constructor(...args){
        super(...args);
        this.menuRef = null;
        this.selectRef = null;
        this.targetRef = null;
        this.unbindWindowClick = null;
        this.unbindWindowKeydown = null;
        this.defaultStyles = (0, $7VXAu.mergeStyles)((0, $eaXSR.default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$eaa8c8a70ac22806})`
                })
        });
        this.isOpenControlled = this.props.isOpen !== undefined;
        this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
        this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $hT6ku.defaultComponents),
            mergedPopperProps: $768d8504b373d7ff$var$defaultPopperProps
        };
        // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        };
        this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
            if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        };
        this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        };
        this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        };
        this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        };
        // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen && (0, $VSDnB.fg)('platform_design_system_team_select_node_resolver')) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $cBeZP.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        };
        /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            //@ts-ignore react-select unsupported props
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose && (0, $VSDnB.fg)('platform_design_system_team_select_node_resolver')) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        };
        // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            };
        this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            };
        this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        };
        this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        };
        // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        };
        // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const menuHandlers = !(0, $VSDnB.fg)('platform_design_system_team_select_node_resolver') ? {
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose
            } : {};
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $768d8504b373d7ff$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $hT6ku.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const providedAriaLabel = getLabel();
            const updateInputAriaLabel = (ariaLabelText)=>{
                // Update aria-label to get first announcement when popup opened.
                if (this.selectRef?.select?.inputRef) {
                    if (providedAriaLabel) ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                    this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                }
            };
            const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                const { focused: focused } = onFocusProps;
                const options = props?.options || [];
                const totalLength = options?.length;
                const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                const ariaLabelText = `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                // Option LABEL focused, 1 of 8. 8 results available.
                // Use Up and Down to choose options, press Enter to select the currently focused option,
                // press Escape to exit the menu.
                return ariaLabelText;
            };
            const onReactSelectFocus = (onFocusProps)=>{
                const ariaLabelSuffix = ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                let ariaLabelText = '';
                let ariaLiveMessage = '';
                if (props.options?.length) {
                    if ((0, $1DATb.isOptionsGrouped)(props.options)) {
                        const totalLength = (0, $1DATb.countAllOptions)(props.options);
                        ariaLiveMessage = (0, $1DATb.onFocus)(onFocusProps, props.options);
                        ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                    } else {
                        ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                        ariaLiveMessage = ariaLabelText;
                    }
                    updateInputAriaLabel(ariaLabelText);
                    return ariaLiveMessage;
                }
                return ariaLiveMessage;
            };
            const popper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $283js.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                }
            }, ({ placement: placement, ref: ref, style: style })=>// When the feature flag 'platform_design_system_team_select_node_resolver' is enabled,
                // we directly pass the ref to MenuDialog instead of wrapping it with NodeResolver.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($768d8504b373d7ff$var$ConditionalNodeResolverWrapper, {
                    hasNodeResolver: !(0, $VSDnB.fg)('platform_design_system_team_select_node_resolver'),
                    innerRef: this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hT6ku.MenuDialog), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: style,
                    "data-placement": placement,
                    minWidth: minMenuWidth,
                    maxWidth: maxMenuWidth,
                    id: id,
                    testId: testId,
                    ref: !(0, $VSDnB.fg)('platform_design_system_team_select_node_resolver') ? null : this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($768d8504b373d7ff$var$FocusLock, {
                    disabled: !focusLockEnabled,
                    returnFocus: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
                    "aria-label": providedAriaLabel,
                    backspaceRemovesValue: false,
                    controlShouldRenderValue: false,
                    isClearable: false,
                    tabSelectsValue: false,
                    menuIsOpen: true,
                    placeholder: placeholder,
                    ref: this.getSelectRef,
                    ...props,
                    ...menuHandlers,
                    isSearchable: showSearchControl,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    styles: (0, $7VXAu.mergeStyles)(this.defaultStyles, props.styles || {}),
                    maxMenuHeight: this.getMaxHeight(),
                    components: selectComponents,
                    onChange: this.handleSelectChange,
                    ariaLiveMessages: !showSearchControl ? {
                        // Overwriting ariaLiveMessages builtin onFocus method to announce selected option when popup has been opened
                        onFocus: onReactSelectFocus,
                        ...props.ariaLiveMessages // priority to use user handlers if provided
                    } : props.ariaLiveMessages
                }), footer))));
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $7nsd3.createPortal)(popper, portalDestination);
        };
    }
}
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, otherwise just the children.
 */ const $768d8504b373d7ff$var$ConditionalNodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    if (hasNodeResolver) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dI393))), {
        innerRef: innerRef
    }, children);
    return children;
};

});
parcelRegister("5n5w4", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $3e93612641040812$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $3e93612641040812$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $3e93612641040812$export$d0d38e7dec7a1a61);

var $5uXOq = parcelRequire("5uXOq");
var $3e93612641040812$export$3dbd3405086fec7b = $5uXOq.createContext();
var $3e93612641040812$export$cbabb21c2529b130 = $5uXOq.createContext();
function $3e93612641040812$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $5uXOq.useRef(false);
    $5uXOq.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $5uXOq.createElement($3e93612641040812$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $5uXOq.createElement($3e93612641040812$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("283js", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $18cee5f949ac4034$export$badac9ada3a0bdf9);

var $5uXOq = parcelRequire("5uXOq");

var $5n5w4 = parcelRequire("5n5w4");

var $eclLw = parcelRequire("eclLw");

var $fNOWl = parcelRequire("fNOWl");
var $18cee5f949ac4034$var$NOOP = function NOOP() {
    return void 0;
};
var $18cee5f949ac4034$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $18cee5f949ac4034$var$EMPTY_MODIFIERS = [];
function $18cee5f949ac4034$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $18cee5f949ac4034$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $5uXOq.useContext((0, $5n5w4.ManagerReferenceNodeContext));
    var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $5uXOq.useEffect(function() {
        (0, $eclLw.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $5uXOq.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $fNOWl.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $5uXOq.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $18cee5f949ac4034$var$NOOP,
            update: update || $18cee5f949ac4034$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $eclLw.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("eclLw", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $a56311d537d20f47$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $a56311d537d20f47$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $a56311d537d20f47$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $a56311d537d20f47$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $a56311d537d20f47$export$700979bc83e7db82);

var $5uXOq = parcelRequire("5uXOq");
var $a56311d537d20f47$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $a56311d537d20f47$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $a56311d537d20f47$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $a56311d537d20f47$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $a56311d537d20f47$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $a56311d537d20f47$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;

});

parcelRegister("fNOWl", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $b812f23d0bbb9e85$export$f4d5bf230a36dd6e);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $8Pv9O = parcelRequire("8Pv9O");

var $lHrkK = parcelRequire("lHrkK");

var $eclLw = parcelRequire("eclLw");
var $b812f23d0bbb9e85$var$EMPTY_MODIFIERS = [];
var $b812f23d0bbb9e85$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $5uXOq.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $b812f23d0bbb9e85$var$EMPTY_MODIFIERS
    };
    var _React$useState = $5uXOq.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $5uXOq.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $7nsd3.flushSync(function() {
                    setState({
                        styles: (0, $eclLw.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $eclLw.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $5uXOq.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $5uXOq.useRef();
    (0, $eclLw.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $eclLw.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $8Pv9O.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("8Pv9O", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $66db415bc009fd50$export$8f7491d57c8f97a9);

var $dsn8Y = parcelRequire("dsn8Y");

var $4TVC8 = parcelRequire("4TVC8");

var $j8nKB = parcelRequire("j8nKB");

var $baic6 = parcelRequire("baic6");

var $1AoLg = parcelRequire("1AoLg");

var $gy4Xr = parcelRequire("gy4Xr");

var $3dDWl = parcelRequire("3dDWl");

var $1DdSC = parcelRequire("1DdSC");

var $gzAfz = parcelRequire("gzAfz");

var $6iLAT = parcelRequire("6iLAT");


var $66db415bc009fd50$export$d34966752335dd47 = [
    (0, $4TVC8.default),
    (0, $j8nKB.default),
    (0, $baic6.default),
    (0, $1AoLg.default),
    (0, $gy4Xr.default),
    (0, $3dDWl.default),
    (0, $1DdSC.default),
    (0, $gzAfz.default),
    (0, $6iLAT.default)
];
var $66db415bc009fd50$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $dsn8Y.popperGenerator)({
    defaultModifiers: $66db415bc009fd50$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("dsn8Y", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $9cbfd7bdb6a4f3f1$export$ed5e13716264f202);

var $gvlia = parcelRequire("gvlia");

var $jkGDj = parcelRequire("jkGDj");

var $2r6BH = parcelRequire("2r6BH");

var $gbHJy = parcelRequire("gbHJy");

var $kcmIg = parcelRequire("kcmIg");

var $a8clb = parcelRequire("a8clb");

var $i9xH7 = parcelRequire("i9xH7");


var $gmkfg = parcelRequire("gmkfg");
var $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $9cbfd7bdb6a4f3f1$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $9cbfd7bdb6a4f3f1$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $gmkfg.isElement)(reference) ? (0, $2r6BH.default)(reference) : reference.contextElement ? (0, $2r6BH.default)(reference.contextElement) : [],
                    popper: (0, $2r6BH.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $kcmIg.default)((0, $i9xH7.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gvlia.default)(reference, (0, $gbHJy.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $jkGDj.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $a8clb.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $9cbfd7bdb6a4f3f1$export$8f7491d57c8f97a9 = /*#__PURE__*/ $9cbfd7bdb6a4f3f1$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gvlia", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0400ebb908e52cb$export$2e2bcd8739ae039);

var $g2O7Z = parcelRequire("g2O7Z");

var $9FFjG = parcelRequire("9FFjG");

var $f5IBt = parcelRequire("f5IBt");

var $gmkfg = parcelRequire("gmkfg");

var $imzt5 = parcelRequire("imzt5");

var $eVELE = parcelRequire("eVELE");

var $c6EdA = parcelRequire("c6EdA");

var $90xPK = parcelRequire("90xPK");
function $c0400ebb908e52cb$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $90xPK.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $90xPK.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $c0400ebb908e52cb$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $gmkfg.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $gmkfg.isHTMLElement)(offsetParent) && $c0400ebb908e52cb$var$isElementScaled(offsetParent);
    var documentElement = (0, $eVELE.default)(offsetParent);
    var rect = (0, $g2O7Z.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f5IBt.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $c6EdA.default)(documentElement)) scroll = (0, $9FFjG.default)(offsetParent);
        if ((0, $gmkfg.isHTMLElement)(offsetParent)) {
            offsets = (0, $g2O7Z.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $imzt5.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("g2O7Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $bae3b796a534b2cf$export$2e2bcd8739ae039);

var $gmkfg = parcelRequire("gmkfg");

var $90xPK = parcelRequire("90xPK");

var $1Prpe = parcelRequire("1Prpe");

var $d8bsQ = parcelRequire("d8bsQ");
function $bae3b796a534b2cf$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $gmkfg.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $90xPK.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $90xPK.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $gmkfg.isElement)(element) ? (0, $1Prpe.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $d8bsQ.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("gmkfg", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $be8e67adfa808002$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $be8e67adfa808002$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $be8e67adfa808002$export$af51f0f06c0f328a);

var $1Prpe = parcelRequire("1Prpe");
function $be8e67adfa808002$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $1Prpe.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $be8e67adfa808002$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $1Prpe.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $be8e67adfa808002$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $1Prpe.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("1Prpe", function(module, exports) {

$parcel$export(module.exports, "default", () => $154fd01b154b825f$export$2e2bcd8739ae039);
function $154fd01b154b825f$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("90xPK", function(module, exports) {

$parcel$export(module.exports, "max", () => $68ee5bce69e9df7e$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $68ee5bce69e9df7e$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $68ee5bce69e9df7e$export$2077e0241d6afd3c);
var $68ee5bce69e9df7e$export$8960430cfd85939f = Math.max;
var $68ee5bce69e9df7e$export$96ec731ed4dcb222 = Math.min;
var $68ee5bce69e9df7e$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("d8bsQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $98f4ea48bb7f7060$export$2e2bcd8739ae039);

var $j5Xhq = parcelRequire("j5Xhq");
function $98f4ea48bb7f7060$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $j5Xhq.default)());
}

});
parcelRegister("j5Xhq", function(module, exports) {

$parcel$export(module.exports, "default", () => $de6c77c242bcf4cf$export$2e2bcd8739ae039);
function $de6c77c242bcf4cf$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("9FFjG", function(module, exports) {

$parcel$export(module.exports, "default", () => $70a7fdf85bb2e8b8$export$2e2bcd8739ae039);

var $8YTLN = parcelRequire("8YTLN");

var $1Prpe = parcelRequire("1Prpe");

var $gmkfg = parcelRequire("gmkfg");

var $i1ad3 = parcelRequire("i1ad3");
function $70a7fdf85bb2e8b8$export$2e2bcd8739ae039(node) {
    if (node === (0, $1Prpe.default)(node) || !(0, $gmkfg.isHTMLElement)(node)) return (0, $8YTLN.default)(node);
    else return (0, $i1ad3.default)(node);
}

});
parcelRegister("8YTLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $689f300ec0defb42$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");
function $689f300ec0defb42$export$2e2bcd8739ae039(node) {
    var win = (0, $1Prpe.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("i1ad3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1e03d69dfb9832f$export$2e2bcd8739ae039);
function $d1e03d69dfb9832f$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("f5IBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $afc9ebf0aa1487e4$export$2e2bcd8739ae039);
function $afc9ebf0aa1487e4$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("imzt5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5e5cb506db8cdcb$export$2e2bcd8739ae039);

var $g2O7Z = parcelRequire("g2O7Z");

var $eVELE = parcelRequire("eVELE");

var $8YTLN = parcelRequire("8YTLN");
function $d5e5cb506db8cdcb$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $g2O7Z.default)((0, $eVELE.default)(element)).left + (0, $8YTLN.default)(element).scrollLeft;
}

});
parcelRegister("eVELE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ade6032ba4b824fe$export$2e2bcd8739ae039);

var $gmkfg = parcelRequire("gmkfg");
function $ade6032ba4b824fe$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $gmkfg.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("c6EdA", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d053e13cecc73ee$export$2e2bcd8739ae039);

var $1ix2F = parcelRequire("1ix2F");
function $8d053e13cecc73ee$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $1ix2F.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("1ix2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f211a5db2cb1d1b$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");
function $0f211a5db2cb1d1b$export$2e2bcd8739ae039(element) {
    return (0, $1Prpe.default)(element).getComputedStyle(element);
}

});



parcelRegister("jkGDj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e130f49f6e9ebcb4$export$2e2bcd8739ae039);

var $g2O7Z = parcelRequire("g2O7Z");
function $e130f49f6e9ebcb4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $g2O7Z.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("2r6BH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c633a6ac170841a$export$2e2bcd8739ae039);

var $k82dT = parcelRequire("k82dT");

var $eTUzl = parcelRequire("eTUzl");

var $1Prpe = parcelRequire("1Prpe");

var $c6EdA = parcelRequire("c6EdA");
function $1c633a6ac170841a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $k82dT.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $1Prpe.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $c6EdA.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($1c633a6ac170841a$export$2e2bcd8739ae039((0, $eTUzl.default)(target)));
}

});
parcelRegister("k82dT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea7647704a508683$export$2e2bcd8739ae039);

var $eTUzl = parcelRequire("eTUzl");

var $c6EdA = parcelRequire("c6EdA");

var $f5IBt = parcelRequire("f5IBt");

var $gmkfg = parcelRequire("gmkfg");
function $ea7647704a508683$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $f5IBt.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $gmkfg.isHTMLElement)(node) && (0, $c6EdA.default)(node)) return node;
    return $ea7647704a508683$export$2e2bcd8739ae039((0, $eTUzl.default)(node));
}

});
parcelRegister("eTUzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad921528f26834dd$export$2e2bcd8739ae039);

var $f5IBt = parcelRequire("f5IBt");

var $eVELE = parcelRequire("eVELE");

var $gmkfg = parcelRequire("gmkfg");
function $ad921528f26834dd$export$2e2bcd8739ae039(element) {
    if ((0, $f5IBt.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $gmkfg.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $eVELE.default)(element) // fallback
    );
}

});



parcelRegister("gbHJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc8f9908a1e4106f$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");

var $f5IBt = parcelRequire("f5IBt");

var $1ix2F = parcelRequire("1ix2F");

var $gmkfg = parcelRequire("gmkfg");

var $6hs9X = parcelRequire("6hs9X");

var $eTUzl = parcelRequire("eTUzl");

var $j5Xhq = parcelRequire("j5Xhq");
function $bc8f9908a1e4106f$var$getTrueOffsetParent(element) {
    if (!(0, $gmkfg.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $1ix2F.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $bc8f9908a1e4106f$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $j5Xhq.default)());
    var isIE = /Trident/i.test((0, $j5Xhq.default)());
    if (isIE && (0, $gmkfg.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $1ix2F.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $eTUzl.default)(element);
    if ((0, $gmkfg.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $gmkfg.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $f5IBt.default)(currentNode)) < 0){
        var css = (0, $1ix2F.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $bc8f9908a1e4106f$export$2e2bcd8739ae039(element) {
    var window = (0, $1Prpe.default)(element);
    var offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6hs9X.default)(offsetParent) && (0, $1ix2F.default)(offsetParent).position === 'static')offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $f5IBt.default)(offsetParent) === 'html' || (0, $f5IBt.default)(offsetParent) === 'body' && (0, $1ix2F.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $bc8f9908a1e4106f$var$getContainingBlock(element) || window;
}

});
parcelRegister("6hs9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $492a2c861940c94d$export$2e2bcd8739ae039);

var $f5IBt = parcelRequire("f5IBt");
function $492a2c861940c94d$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $f5IBt.default)(element)) >= 0;
}

});


parcelRegister("kcmIg", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb468bf0752088cc$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");
function $eb468bf0752088cc$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $eb468bf0752088cc$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $eb468bf0752088cc$var$order(modifiers); // order based on phase
    return (0, $kJPed.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("kJPed", function(module, exports) {

$parcel$export(module.exports, "top", () => $f18fbf7b212a7c8e$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $f18fbf7b212a7c8e$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $f18fbf7b212a7c8e$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $f18fbf7b212a7c8e$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $f18fbf7b212a7c8e$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $f18fbf7b212a7c8e$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $f18fbf7b212a7c8e$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $f18fbf7b212a7c8e$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $f18fbf7b212a7c8e$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $f18fbf7b212a7c8e$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $f18fbf7b212a7c8e$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $f18fbf7b212a7c8e$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $f18fbf7b212a7c8e$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $f18fbf7b212a7c8e$export$d087d3878fdf71d5);
var $f18fbf7b212a7c8e$export$1e95b668f3b82d = 'top';
var $f18fbf7b212a7c8e$export$40e543e69a8b3fbb = 'bottom';
var $f18fbf7b212a7c8e$export$79ffe56a765070d2 = 'right';
var $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4 = 'left';
var $f18fbf7b212a7c8e$export$dfb5619354ba860 = 'auto';
var $f18fbf7b212a7c8e$export$aec2ce47c367b8c3 = [
    $f18fbf7b212a7c8e$export$1e95b668f3b82d,
    $f18fbf7b212a7c8e$export$40e543e69a8b3fbb,
    $f18fbf7b212a7c8e$export$79ffe56a765070d2,
    $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4
];
var $f18fbf7b212a7c8e$export$b3571188c770cc5a = 'start';
var $f18fbf7b212a7c8e$export$bd5df0f255a350f8 = 'end';
var $f18fbf7b212a7c8e$export$390fd549c5303b4d = 'clippingParents';
var $f18fbf7b212a7c8e$export$d7b7311ec04a3e8f = 'viewport';
var $f18fbf7b212a7c8e$export$ae5ab1c730825774 = 'popper';
var $f18fbf7b212a7c8e$export$ca50aac9f3ba507f = 'reference';
var $f18fbf7b212a7c8e$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f18fbf7b212a7c8e$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
        placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
    ]);
}, []);
var $f18fbf7b212a7c8e$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f18fbf7b212a7c8e$export$aec2ce47c367b8c3, [
    $f18fbf7b212a7c8e$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
        placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f18fbf7b212a7c8e$export$421679a7c3d56e = 'beforeRead';
var $f18fbf7b212a7c8e$export$aafa59e2e03f2942 = 'read';
var $f18fbf7b212a7c8e$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $f18fbf7b212a7c8e$export$c65e99957a05207c = 'beforeMain';
var $f18fbf7b212a7c8e$export$f22da7240b7add18 = 'main';
var $f18fbf7b212a7c8e$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f18fbf7b212a7c8e$export$8d4d2d70e7d46032 = 'beforeWrite';
var $f18fbf7b212a7c8e$export$68d8715fc104d294 = 'write';
var $f18fbf7b212a7c8e$export$70a6e5159acce2e6 = 'afterWrite';
var $f18fbf7b212a7c8e$export$d087d3878fdf71d5 = [
    $f18fbf7b212a7c8e$export$421679a7c3d56e,
    $f18fbf7b212a7c8e$export$aafa59e2e03f2942,
    $f18fbf7b212a7c8e$export$6964f6c886723980,
    $f18fbf7b212a7c8e$export$c65e99957a05207c,
    $f18fbf7b212a7c8e$export$f22da7240b7add18,
    $f18fbf7b212a7c8e$export$bab79516f2d662fe,
    $f18fbf7b212a7c8e$export$8d4d2d70e7d46032,
    $f18fbf7b212a7c8e$export$68d8715fc104d294,
    $f18fbf7b212a7c8e$export$70a6e5159acce2e6
];

});


parcelRegister("a8clb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7604395822cc5d61$export$2e2bcd8739ae039);
function $7604395822cc5d61$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("i9xH7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3733441fcf2e882$export$2e2bcd8739ae039);
function $d3733441fcf2e882$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("4TVC8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3918fd6b815bcf57$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");
var $3918fd6b815bcf57$var$passive = {
    passive: true
};
function $3918fd6b815bcf57$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $1Prpe.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $3918fd6b815bcf57$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $3918fd6b815bcf57$var$effect,
    data: {}
};

});

parcelRegister("j8nKB", function(module, exports) {

$parcel$export(module.exports, "default", () => $dee1300a39219bb5$export$2e2bcd8739ae039);

var $dJ0Jl = parcelRequire("dJ0Jl");
function $dee1300a39219bb5$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $dJ0Jl.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $dee1300a39219bb5$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $dee1300a39219bb5$var$popperOffsets,
    data: {}
};

});
parcelRegister("dJ0Jl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fe00b5c334118ac$export$2e2bcd8739ae039);

var $QXpw1 = parcelRequire("QXpw1");

var $cGRJ4 = parcelRequire("cGRJ4");

var $9GF9F = parcelRequire("9GF9F");

var $kJPed = parcelRequire("kJPed");
function $9fe00b5c334118ac$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $QXpw1.default)(placement) : null;
    var variation = placement ? (0, $cGRJ4.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $kJPed.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $kJPed.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $kJPed.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $kJPed.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $9GF9F.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $kJPed.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $kJPed.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("QXpw1", function(module, exports) {

$parcel$export(module.exports, "default", () => $09f2f123ac4a9fdf$export$2e2bcd8739ae039);

function $09f2f123ac4a9fdf$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("cGRJ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $93d315208040ceed$export$2e2bcd8739ae039);
function $93d315208040ceed$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("9GF9F", function(module, exports) {

$parcel$export(module.exports, "default", () => $70d7f5cda4210aa3$export$2e2bcd8739ae039);
function $70d7f5cda4210aa3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("baic6", function(module, exports) {

$parcel$export(module.exports, "default", () => $820ebddbe0682e4f$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");

var $gbHJy = parcelRequire("gbHJy");

var $1Prpe = parcelRequire("1Prpe");

var $eVELE = parcelRequire("eVELE");

var $1ix2F = parcelRequire("1ix2F");

var $QXpw1 = parcelRequire("QXpw1");

var $cGRJ4 = parcelRequire("cGRJ4");

var $90xPK = parcelRequire("90xPK");
var $820ebddbe0682e4f$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $820ebddbe0682e4f$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $90xPK.round)(x * dpr) / dpr || 0,
        y: (0, $90xPK.round)(y * dpr) / dpr || 0
    };
}
function $820ebddbe0682e4f$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $kJPed.left);
    var sideY = (0, $kJPed.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $gbHJy.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $1Prpe.default)(popper)) {
            offsetParent = (0, $eVELE.default)(popper);
            if ((0, $1ix2F.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $kJPed.top) || (placement === (0, $kJPed.left) || placement === (0, $kJPed.right)) && variation === (0, $kJPed.end)) {
            sideY = (0, $kJPed.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $kJPed.left) || (placement === (0, $kJPed.top) || placement === (0, $kJPed.bottom)) && variation === (0, $kJPed.end)) {
            sideX = (0, $kJPed.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $820ebddbe0682e4f$var$unsetSides);
    var _ref4 = roundOffsets === true ? $820ebddbe0682e4f$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $1Prpe.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $820ebddbe0682e4f$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $QXpw1.default)(state.placement),
        variation: (0, $cGRJ4.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $820ebddbe0682e4f$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $820ebddbe0682e4f$var$computeStyles,
    data: {}
};

});

parcelRegister("1AoLg", function(module, exports) {

$parcel$export(module.exports, "default", () => $127c5c56b9511f5f$export$2e2bcd8739ae039);

var $f5IBt = parcelRequire("f5IBt");

var $gmkfg = parcelRequire("gmkfg");
// and applies them to the HTMLElements such as popper and arrow
function $127c5c56b9511f5f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $gmkfg.isHTMLElement)(element) || !(0, $f5IBt.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $127c5c56b9511f5f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $gmkfg.isHTMLElement)(element) || !(0, $f5IBt.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $127c5c56b9511f5f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $127c5c56b9511f5f$var$applyStyles,
    effect: $127c5c56b9511f5f$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("gy4Xr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0c3aad300d72ee1$export$2e2bcd8739ae039);

var $QXpw1 = parcelRequire("QXpw1");

var $kJPed = parcelRequire("kJPed");
function $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $QXpw1.default)(placement);
    var invertDistance = [
        (0, $kJPed.left),
        (0, $kJPed.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $kJPed.left),
        (0, $kJPed.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $c0c3aad300d72ee1$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $kJPed.placements).reduce(function(acc, placement) {
        acc[placement] = $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $c0c3aad300d72ee1$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $c0c3aad300d72ee1$var$offset
};

});

parcelRegister("3dDWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $258191447a7022df$export$2e2bcd8739ae039);

var $jwSgb = parcelRequire("jwSgb");

var $QXpw1 = parcelRequire("QXpw1");

var $4tIVJ = parcelRequire("4tIVJ");

var $kgkit = parcelRequire("kgkit");

var $cqF2x = parcelRequire("cqF2x");

var $kJPed = parcelRequire("kJPed");

var $cGRJ4 = parcelRequire("cGRJ4");
function $258191447a7022df$var$getExpandedFallbackPlacements(placement) {
    if ((0, $QXpw1.default)(placement) === (0, $kJPed.auto)) return [];
    var oppositePlacement = (0, $jwSgb.default)(placement);
    return [
        (0, $4tIVJ.default)(placement),
        oppositePlacement,
        (0, $4tIVJ.default)(oppositePlacement)
    ];
}
function $258191447a7022df$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $QXpw1.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $jwSgb.default)(preferredPlacement)
    ] : $258191447a7022df$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $QXpw1.default)(placement) === (0, $kJPed.auto) ? (0, $cqF2x.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $QXpw1.default)(placement);
        var isStartVariation = (0, $cGRJ4.default)(placement) === (0, $kJPed.start);
        var isVertical = [
            (0, $kJPed.top),
            (0, $kJPed.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $kgkit.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $kJPed.right) : (0, $kJPed.left) : isStartVariation ? (0, $kJPed.bottom) : (0, $kJPed.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $jwSgb.default)(mainVariationSide);
        var altVariationSide = (0, $jwSgb.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $258191447a7022df$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $258191447a7022df$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("jwSgb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e37b1862c86f39c4$export$2e2bcd8739ae039);
var $e37b1862c86f39c4$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $e37b1862c86f39c4$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $e37b1862c86f39c4$var$hash[matched];
    });
}

});

parcelRegister("4tIVJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $342cb90cb2622617$export$2e2bcd8739ae039);
var $342cb90cb2622617$var$hash = {
    start: 'end',
    end: 'start'
};
function $342cb90cb2622617$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $342cb90cb2622617$var$hash[matched];
    });
}

});

parcelRegister("kgkit", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec050bcf5e349283$export$2e2bcd8739ae039);

var $dknpr = parcelRequire("dknpr");

var $eVELE = parcelRequire("eVELE");

var $g2O7Z = parcelRequire("g2O7Z");

var $dJ0Jl = parcelRequire("dJ0Jl");

var $h8W1z = parcelRequire("h8W1z");

var $kJPed = parcelRequire("kJPed");

var $gmkfg = parcelRequire("gmkfg");

var $gIXWB = parcelRequire("gIXWB");

var $50KfK = parcelRequire("50KfK");
function $ec050bcf5e349283$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $kJPed.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $kJPed.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $kJPed.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $gIXWB.default)(typeof padding !== 'number' ? padding : (0, $50KfK.default)(padding, (0, $kJPed.basePlacements)));
    var altContext = elementContext === (0, $kJPed.popper) ? (0, $kJPed.reference) : (0, $kJPed.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $dknpr.default)((0, $gmkfg.isElement)(element) ? element : element.contextElement || (0, $eVELE.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $g2O7Z.default)(state.elements.reference);
    var popperOffsets = (0, $dJ0Jl.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $h8W1z.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $kJPed.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $kJPed.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $kJPed.right),
                (0, $kJPed.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $kJPed.top),
                (0, $kJPed.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("dknpr", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3f4d3932acb3b2$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");

var $3V2hG = parcelRequire("3V2hG");

var $9NXD7 = parcelRequire("9NXD7");

var $2r6BH = parcelRequire("2r6BH");

var $gbHJy = parcelRequire("gbHJy");

var $eVELE = parcelRequire("eVELE");

var $1ix2F = parcelRequire("1ix2F");

var $gmkfg = parcelRequire("gmkfg");

var $g2O7Z = parcelRequire("g2O7Z");

var $eTUzl = parcelRequire("eTUzl");

var $j6yPg = parcelRequire("j6yPg");

var $f5IBt = parcelRequire("f5IBt");

var $h8W1z = parcelRequire("h8W1z");

var $90xPK = parcelRequire("90xPK");
function $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $g2O7Z.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $kJPed.viewport) ? (0, $h8W1z.default)((0, $3V2hG.default)(element, strategy)) : (0, $gmkfg.isElement)(clippingParent) ? $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $h8W1z.default)((0, $9NXD7.default)((0, $eVELE.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $9b3f4d3932acb3b2$var$getClippingParents(element) {
    var clippingParents = (0, $2r6BH.default)((0, $eTUzl.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $1ix2F.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $gmkfg.isHTMLElement)(element) ? (0, $gbHJy.default)(element) : element;
    if (!(0, $gmkfg.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $gmkfg.isElement)(clippingParent) && (0, $j6yPg.default)(clippingParent, clipperElement) && (0, $f5IBt.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $9b3f4d3932acb3b2$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $9b3f4d3932acb3b2$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $90xPK.max)(rect.top, accRect.top);
        accRect.right = (0, $90xPK.min)(rect.right, accRect.right);
        accRect.bottom = (0, $90xPK.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $90xPK.max)(rect.left, accRect.left);
        return accRect;
    }, $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("3V2hG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2da877912142c34b$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");

var $eVELE = parcelRequire("eVELE");

var $imzt5 = parcelRequire("imzt5");

var $d8bsQ = parcelRequire("d8bsQ");
function $2da877912142c34b$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $1Prpe.default)(element);
    var html = (0, $eVELE.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $d8bsQ.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $imzt5.default)(element),
        y: y
    };
}

});

parcelRegister("9NXD7", function(module, exports) {

$parcel$export(module.exports, "default", () => $7236f1f1532b7fe8$export$2e2bcd8739ae039);

var $eVELE = parcelRequire("eVELE");

var $1ix2F = parcelRequire("1ix2F");

var $imzt5 = parcelRequire("imzt5");

var $8YTLN = parcelRequire("8YTLN");

var $90xPK = parcelRequire("90xPK");
function $7236f1f1532b7fe8$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $eVELE.default)(element);
    var winScroll = (0, $8YTLN.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $90xPK.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $90xPK.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $imzt5.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $1ix2F.default)(body || html).direction === 'rtl') x += (0, $90xPK.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("j6yPg", function(module, exports) {

$parcel$export(module.exports, "default", () => $de89978be23479c4$export$2e2bcd8739ae039);

var $gmkfg = parcelRequire("gmkfg");
function $de89978be23479c4$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $gmkfg.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("h8W1z", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7b0316bb2f8fd97$export$2e2bcd8739ae039);
function $c7b0316bb2f8fd97$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("gIXWB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2cf410c4fe133f4$export$2e2bcd8739ae039);

var $1ANH0 = parcelRequire("1ANH0");
function $c2cf410c4fe133f4$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $1ANH0.default)(), paddingObject);
}

});
parcelRegister("1ANH0", function(module, exports) {

$parcel$export(module.exports, "default", () => $128fb32b18b92ffa$export$2e2bcd8739ae039);
function $128fb32b18b92ffa$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("50KfK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a60d4b4ac4f93e5$export$2e2bcd8739ae039);
function $3a60d4b4ac4f93e5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("cqF2x", function(module, exports) {

$parcel$export(module.exports, "default", () => $90c7bf65fbdbec33$export$2e2bcd8739ae039);

var $cGRJ4 = parcelRequire("cGRJ4");

var $kJPed = parcelRequire("kJPed");

var $kgkit = parcelRequire("kgkit");

var $QXpw1 = parcelRequire("QXpw1");
function $90c7bf65fbdbec33$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $kJPed.placements) : _options$allowedAutoP;
    var variation = (0, $cGRJ4.default)(placement);
    var placements = variation ? flipVariations ? (0, $kJPed.variationPlacements) : (0, $kJPed.variationPlacements).filter(function(placement) {
        return (0, $cGRJ4.default)(placement) === variation;
    }) : (0, $kJPed.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $kgkit.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $QXpw1.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("1DdSC", function(module, exports) {

$parcel$export(module.exports, "default", () => $13043339457d5bc5$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");

var $QXpw1 = parcelRequire("QXpw1");

var $9GF9F = parcelRequire("9GF9F");

var $dNtrn = parcelRequire("dNtrn");

var $4WpIh = parcelRequire("4WpIh");

var $jkGDj = parcelRequire("jkGDj");

var $gbHJy = parcelRequire("gbHJy");

var $kgkit = parcelRequire("kgkit");

var $cGRJ4 = parcelRequire("cGRJ4");

var $1ANH0 = parcelRequire("1ANH0");

var $90xPK = parcelRequire("90xPK");
function $13043339457d5bc5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $kgkit.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $QXpw1.default)(state.placement);
    var variation = (0, $cGRJ4.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $9GF9F.default)(basePlacement);
    var altAxis = (0, $dNtrn.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $kJPed.top) : (0, $kJPed.left);
        var altSide = mainAxis === 'y' ? (0, $kJPed.bottom) : (0, $kJPed.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $kJPed.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $kJPed.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $jkGDj.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $1ANH0.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $4WpIh.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $gbHJy.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $4WpIh.within)(tether ? (0, $90xPK.min)(min, tetherMin) : min, offset, tether ? (0, $90xPK.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $kJPed.top) : (0, $kJPed.left);
        var _altSide = mainAxis === 'x' ? (0, $kJPed.bottom) : (0, $kJPed.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $kJPed.top),
            (0, $kJPed.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $4WpIh.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $4WpIh.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $13043339457d5bc5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $13043339457d5bc5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("dNtrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0b6b03fadcbdfd7$export$2e2bcd8739ae039);
function $a0b6b03fadcbdfd7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("4WpIh", function(module, exports) {

$parcel$export(module.exports, "within", () => $3990864f59117d05$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $3990864f59117d05$export$86c8af6d3ef0b4a);

var $90xPK = parcelRequire("90xPK");
function $3990864f59117d05$export$f28d906d67a997f3(min, value, max) {
    return (0, $90xPK.max)(min, (0, $90xPK.min)(value, max));
}
function $3990864f59117d05$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $3990864f59117d05$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("gzAfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c10c08bd5e0ed9fb$export$2e2bcd8739ae039);

var $QXpw1 = parcelRequire("QXpw1");

var $jkGDj = parcelRequire("jkGDj");

var $j6yPg = parcelRequire("j6yPg");

var $gbHJy = parcelRequire("gbHJy");

var $9GF9F = parcelRequire("9GF9F");

var $4WpIh = parcelRequire("4WpIh");

var $gIXWB = parcelRequire("gIXWB");

var $50KfK = parcelRequire("50KfK");

var $kJPed = parcelRequire("kJPed");
var $c10c08bd5e0ed9fb$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $gIXWB.default)(typeof padding !== 'number' ? padding : (0, $50KfK.default)(padding, (0, $kJPed.basePlacements)));
};
function $c10c08bd5e0ed9fb$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $QXpw1.default)(state.placement);
    var axis = (0, $9GF9F.default)(basePlacement);
    var isVertical = [
        (0, $kJPed.left),
        (0, $kJPed.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $c10c08bd5e0ed9fb$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $jkGDj.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $kJPed.top) : (0, $kJPed.left);
    var maxProp = axis === 'y' ? (0, $kJPed.bottom) : (0, $kJPed.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $gbHJy.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $4WpIh.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $c10c08bd5e0ed9fb$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $j6yPg.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $c10c08bd5e0ed9fb$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $c10c08bd5e0ed9fb$var$arrow,
    effect: $c10c08bd5e0ed9fb$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("6iLAT", function(module, exports) {

$parcel$export(module.exports, "default", () => $496957b0c691a0ed$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");

var $kgkit = parcelRequire("kgkit");
function $496957b0c691a0ed$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $496957b0c691a0ed$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $kJPed.top),
        (0, $kJPed.right),
        (0, $kJPed.bottom),
        (0, $kJPed.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $496957b0c691a0ed$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $kgkit.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $kgkit.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $496957b0c691a0ed$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $496957b0c691a0ed$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $496957b0c691a0ed$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $496957b0c691a0ed$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $496957b0c691a0ed$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $496957b0c691a0ed$var$hide
};

});




parcelRegister("iGDLS", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $d9aafffd117cbcc1$export$e0be378c32fb70a7);

var $5uXOq = parcelRequire("5uXOq");

var $hBYjV = parcelRequire("hBYjV");

var $5n5w4 = parcelRequire("5n5w4");

var $eclLw = parcelRequire("eclLw");
function $d9aafffd117cbcc1$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $5uXOq.useContext((0, $5n5w4.ManagerReferenceNodeSetterContext));
    var refHandler = $5uXOq.useCallback(function(node) {
        (0, $eclLw.setRef)(innerRef, node);
        (0, $eclLw.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $5uXOq.useEffect(function() {
        return function() {
            return (0, $eclLw.setRef)(innerRef, null);
        };
    }, []);
    $5uXOq.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $eclLw.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("4wJSY", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $34bdbe885d924a05$export$3e67810a3f0e9f1c);
function $34bdbe885d924a05$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $34bdbe885d924a05$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $34bdbe885d924a05$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $34bdbe885d924a05$export$967a6b9924a689f7(a, b);
    return $34bdbe885d924a05$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("7VXAu", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", () => $11d0fd648d1f51c0$export$214b055320e0bf32);
$parcel$export(module.exports, "mergeStyles", () => $11d0fd648d1f51c0$export$e618dc39ac9ad607);

var $h1QWG = parcelRequire("h1QWG");

var $eZFhY = parcelRequire("eZFhY");

var $i48X9 = parcelRequire("i48X9");

var $95iuW = parcelRequire("95iuW");

var $dS5G5 = parcelRequire("dS5G5");

var $aA8TC = parcelRequire("aA8TC");

var $hqcPo = parcelRequire("hqcPo");

var $8l2RA = parcelRequire("8l2RA");

var $kKm82 = parcelRequire("kKm82");

var $hpcbi = parcelRequire("hpcbi");
const $11d0fd648d1f51c0$export$214b055320e0bf32 = {
    clearIndicator: (0, $95iuW.clearIndicatorCSS),
    container: (0, $h1QWG.containerCSS),
    control: (0, $eZFhY.css),
    dropdownIndicator: (0, $95iuW.dropdownIndicatorCSS),
    group: (0, $i48X9.groupCSS),
    groupHeading: (0, $i48X9.groupHeadingCSS),
    indicatorsContainer: (0, $h1QWG.indicatorsContainerCSS),
    indicatorSeparator: (0, $95iuW.indicatorSeparatorCSS),
    input: (0, $dS5G5.inputCSS),
    loadingIndicator: (0, $95iuW.loadingIndicatorCSS),
    loadingMessage: (0, $aA8TC.loadingMessageCSS),
    menu: (0, $aA8TC.menuCSS),
    menuList: (0, $aA8TC.menuListCSS),
    menuPortal: (0, $aA8TC.menuPortalCSS),
    multiValue: (0, $hqcPo.multiValueCSS),
    multiValueLabel: (0, $hqcPo.multiValueLabelCSS),
    multiValueRemove: (0, $hqcPo.multiValueRemoveCSS),
    noOptionsMessage: (0, $aA8TC.noOptionsMessageCSS),
    option: (0, $8l2RA.optionCSS),
    placeholder: (0, $kKm82.placeholderCSS),
    singleValue: (0, $hpcbi.css),
    valueContainer: (0, $h1QWG.valueContainerCSS)
};
function $11d0fd648d1f51c0$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});

parcelRegister("7K5PP", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $c2d344e1481a2d3b$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $c2d344e1481a2d3b$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $h3gNz = parcelRequire("h3gNz");

var $3c98u = parcelRequire("3c98u");
const $c2d344e1481a2d3b$var$packageName = "platform-pkg";
const $c2d344e1481a2d3b$var$packageVersion = "0.0.0-use.local";
const $c2d344e1481a2d3b$export$d1de3b251ccaa8a3 = (0, $3c98u.default)((0, $h3gNz.default));
const $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit = (0, $gB4mS.default)('atlaskit');
const $c2d344e1481a2d3b$var$Select = (0, $994MI.default)({
    componentName: 'select',
    packageName: $c2d344e1481a2d3b$var$packageName,
    packageVersion: $c2d344e1481a2d3b$var$packageVersion
})((0, $cb25w.default)({
    onChange: $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $c2d344e1481a2d3b$var$packageName,
            packageVersion: $c2d344e1481a2d3b$var$packageVersion
        }
    })
})($c2d344e1481a2d3b$export$d1de3b251ccaa8a3));
var $c2d344e1481a2d3b$export$2e2bcd8739ae039 = $c2d344e1481a2d3b$var$Select;

});
parcelRegister("h3gNz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3cbc87a7256e0c1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2QhWf = parcelRequire("2QhWf");

var $9uJ4X = parcelRequire("9uJ4X");
const $a3cbc87a7256e0c1$var$StateManagedSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const baseSelectProps = (0, $9uJ4X.default)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2QhWf.default), {
        ref: ref,
        ...baseSelectProps
    });
});
var $a3cbc87a7256e0c1$export$2e2bcd8739ae039 = $a3cbc87a7256e0c1$var$StateManagedSelect;

});
parcelRegister("2QhWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8e863683b34816f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $aCMCu = parcelRequire("aCMCu");

var $eEtcC = parcelRequire("eEtcC");

var $bChGW = parcelRequire("bChGW");

var $jtVgE = parcelRequire("jtVgE");
var $9cRAr = parcelRequire("9cRAr");
var $galqx = parcelRequire("galqx");

var $81i5b = parcelRequire("81i5b");

var $aA8TC = parcelRequire("aA8TC");

var $5JAlL = parcelRequire("5JAlL");

var $7VXAu = parcelRequire("7VXAu");

var $5HBcW = parcelRequire("5HBcW");

var $gyjU7 = parcelRequire("gyjU7");
const $d8e863683b34816f$export$9c21a3269931e1e6 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $gyjU7.isTouchCapable)(),
    captureMenuScroll: !(0, $gyjU7.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $5JAlL.createFilter)(),
    formatGroupLabel: (0, $eEtcC.formatGroupLabel),
    getOptionLabel: (0, $eEtcC.getOptionLabel),
    getOptionValue: (0, $eEtcC.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $eEtcC.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $gyjU7.isMobileDevice)(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $d8e863683b34816f$var$isOptionSelected(props, option, selectValue);
    const label = $d8e863683b34816f$var$getOptionLabel(props, option);
    const value = $d8e863683b34816f$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $d8e863683b34816f$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$d8e863683b34816f$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $d8e863683b34816f$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $d8e863683b34816f$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $gyjU7.notNullish));
}
function $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $d8e863683b34816f$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) {
    return $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue));
}
function $d8e863683b34816f$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$d8e863683b34816f$var$shouldHideSelectedOptions(props) || !isSelected) && $d8e863683b34816f$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $d8e863683b34816f$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $d8e863683b34816f$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $d8e863683b34816f$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $d8e863683b34816f$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $d8e863683b34816f$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $d8e863683b34816f$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $d8e863683b34816f$var$getOptionValue(props, option);
    return selectValue.some((i)=>$d8e863683b34816f$var$getOptionValue(props, i) === candidate);
}
function $d8e863683b34816f$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $d8e863683b34816f$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $d8e863683b34816f$var$instanceId = 1;
class $d8e863683b34816f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $d8e863683b34816f$export$9c21a3269931e1e6;
    }
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props);
        this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false;
        this.isComposing = false;
        this.initialTouchX = 0;
        this.initialTouchY = 0;
        this.openAfterFocus = false;
        this.scrollToFocusedOptionOnUpdate = false;
        this.isAppleDevice = (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? (0, $aCMCu.isSafari)() : (0, $aCMCu.isAppleDevice)();
        // Refs
        // ------------------------------
        this.controlRef = null;
        this.getControlRef = (ref)=>{
            this.controlRef = ref;
        };
        this.focusedOptionRef = null;
        this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        };
        this.menuListRef = null;
        this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        };
        this.inputRef = null;
        this.getInputRef = (ref)=>{
            this.inputRef = ref;
        };
        // aliased for consumers
        this.focus = this.focusInput;
        this.blur = this.blurInput;
        this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $gyjU7.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $gyjU7.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $gyjU7.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $gyjU7.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        };
        this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $gyjU7.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        };
        this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $gyjU7.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $gyjU7.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        this.getFocusedOptionId = (focusedOption)=>{
            return $d8e863683b34816f$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        };
        this.getFocusableOptionsWithIds = ()=>{
            return $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        };
        this.getValue = ()=>this.state.selectValue;
        this.cx = (...args)=>(0, $gyjU7.classNames)(this.props.classNamePrefix, ...args);
        this.getOptionLabel = (data)=>{
            return $d8e863683b34816f$var$getOptionLabel(this.props, data);
        };
        this.getOptionValue = (data)=>{
            return $d8e863683b34816f$var$getOptionValue(this.props, data);
        };
        this.getStyles = (key, props)=>{
            const { unstyled: unstyled } = this.props;
            const base = (0, $7VXAu.defaultStyles)[key](props, unstyled);
            base.boxSizing = 'border-box';
            const custom = this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        this.getClassNames = (key, props)=>this.props.classNames[key]?.(props);
        this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        };
        this.getComponents = ()=>{
            return (0, $bChGW.defaultComponents)(this.props);
        };
        this.buildCategorizedOptions = ()=>$d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue);
        this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [];
        this.buildFocusableOptions = ()=>$d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions());
        this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [];
        // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        };
        // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        };
        this.onMenuMouseMove = (event)=>{
            this.blockOptionHover = false;
        };
        this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        };
        this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        };
        this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $gyjU7.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        };
        this.onCompositionStart = ()=>{
            this.isComposing = true;
        };
        this.onCompositionEnd = ()=>{
            this.isComposing = false;
        };
        this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        };
        this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        };
        this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        };
        this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        };
        this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        };
        // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        };
        this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        };
        this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        };
        this.shouldHideSelectedOptions = ()=>{
            return $d8e863683b34816f$var$shouldHideSelectedOptions(this.props);
        };
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        };
        // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$d8e863683b34816f$var$instanceId);
        this.state.selectValue = (0, $gyjU7.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen && this.state.selectValue.length) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $gyjU7.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $d8e863683b34816f$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $d8e863683b34816f$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $gyjU7.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $gyjU7.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            (0, $gyjU7.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusableOptions[openAtIndex],
            focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
        }, ()=>this.onMenuOpen());
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus]
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    // ==============================
    // Getters
    // ==============================
    getTheme() {
        // Use the default theme if there are no customisations.
        if (!this.props.theme) return 0, $5HBcW.defaultTheme;
        // If the theme prop is a function, assume the function
        // knows how to merge the passed-in default theme with
        // its own modifications.
        if (typeof this.props.theme === 'function') return this.props.theme((0, $5HBcW.defaultTheme));
        // Otherwise, if a plain theme object was passed in,
        // overlay it with the default theme.
        return {
            ...(0, $5HBcW.defaultTheme),
            ...this.props.theme
        };
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue,
            theme: this.getTheme()
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $d8e863683b34816f$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $d8e863683b34816f$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $d8e863683b34816f$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        } else return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0 } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        const description = this.props['aria-describedby'] || descriptionId;
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            'aria-autocomplete': 'both',
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            'aria-haspopup': 'listbox',
            'aria-describedby': description,
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.state.focusedOptionId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            ...!isSearchable && {
                'aria-readonly': true
            },
            ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                'aria-describedby': description ? [
                    description,
                    this.getElementId('live-region')
                ].join(' ') : this.getElementId('live-region')
            } : {
                'aria-describedby': description ? [
                    description,
                    this.getElementId('placeholder')
                ].join(' ') : this.getElementId('placeholder')
            }
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jtVgE.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: (0, $gyjU7.noop),
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            ...ariaAttributes
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder')
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    }
                },
                data: opt
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled
        }, this.formatOptionLabel(singleValue, 'value'));
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadingIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderIndicatorSeparator() {
        const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
        // separator doesn't make sense without the dropdown indicator
        if (!DropdownIndicator || !IndicatorSeparator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled } = this.props;
        const { isFocused: isFocused } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IndicatorSeparator, {
            ...commonProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled } = this.props;
        const { isFocused: isFocused } = this.state;
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: 'option',
                'aria-selected': !commonProps.isMulti && (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? isSelected || undefined : isSelected,
                'aria-describedby': (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? headingId : undefined
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadingMessage, commonProps, message);
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NoOptionsMessage, commonProps, message);
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aA8TC.MenuPlacer), {
            ...commonProps,
            ...menuPlacementProps
        }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Menu, {
                ...commonProps,
                ...menuPlacementProps,
                innerRef: ref,
                innerProps: {
                    onMouseDown: this.onMenuMouseDown,
                    onMouseMove: this.onMenuMouseMove,
                    id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                },
                isLoading: isLoading,
                placement: placement
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $galqx.default), {
                captureEnabled: captureMenuScroll,
                onTopArrive: onMenuScrollToTop,
                onBottomArrive: onMenuScrollToBottom,
                lockEnabled: menuShouldBlockScroll
            }, (scrollTargetRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuList, {
                    ...commonProps,
                    innerRef: (instance)=>{
                        this.getMenuListRef(instance);
                        scrollTargetRef(instance);
                    },
                    innerProps: {
                        role: 'listbox',
                        // don't add aria-multiselectable when ff is on and the value is false
                        'aria-multiselectable': (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? commonProps.isMulti || undefined : commonProps.isMulti,
                        id: this.getElementId('listbox'),
                        // add aditional label on listbox when ff is on
                        ...(0, $VSDnB.fg)('design_system_select-a11y-improvement') && {
                            'aria-label': label,
                            'aria-labelledby': labelId
                        }
                    },
                    isLoading: isLoading,
                    maxHeight: maxHeight,
                    focusedOption: focusedOption
                }, menuUI))));
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition
        }, menuElement) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9cRAr.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
                        key: `i-${i}`,
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, input);
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $81i5b.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            focusedOption: focusedOption,
            focusedValue: focusedValue,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions,
            isAppleDevice: this.isAppleDevice
        });
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown
            },
            isDisabled: isDisabled,
            isFocused: isFocused
        }, this.renderLiveRegion(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Control, {
            ...commonProps,
            innerRef: this.getControlRef,
            innerProps: {
                onMouseDown: this.onControlMouseDown,
                onTouchEnd: this.onControlTouchEnd
            },
            isDisabled: isDisabled,
            isFocused: isFocused,
            menuIsOpen: menuIsOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ValueContainer, {
            ...commonProps,
            isDisabled: isDisabled
        }, this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IndicatorsContainer, {
            ...commonProps,
            isDisabled: isDisabled
        }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
}

});
parcelRegister("aCMCu", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $150018e79a44f2ed$export$95df08bae54cb4df);
$parcel$export(module.exports, "isAppleDevice", () => $150018e79a44f2ed$export$e1865c3bedcd822b);
function $150018e79a44f2ed$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $150018e79a44f2ed$export$186c6964ca17d99() {
    return $150018e79a44f2ed$var$testPlatform(/^iPhone/i);
}
function $150018e79a44f2ed$export$95df08bae54cb4df() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('safari') && !ua.includes('chrome');
}
function $150018e79a44f2ed$export$9ac100e40613ea10() {
    return $150018e79a44f2ed$var$testPlatform(/^Mac/i);
}
function $150018e79a44f2ed$export$7bef049ce92e4224() {
    return $150018e79a44f2ed$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    // eslint-disable-next-line compat/compat
    $150018e79a44f2ed$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $150018e79a44f2ed$export$fedb369cb70207f1() {
    return $150018e79a44f2ed$export$186c6964ca17d99() || $150018e79a44f2ed$export$7bef049ce92e4224();
}
function $150018e79a44f2ed$export$e1865c3bedcd822b() {
    return $150018e79a44f2ed$export$9ac100e40613ea10() || $150018e79a44f2ed$export$fedb369cb70207f1();
}

});

parcelRegister("eEtcC", function(module, exports) {

$parcel$export(module.exports, "formatGroupLabel", () => $1a3d0f2eb875e1af$export$f4da216a6ca54656);
$parcel$export(module.exports, "getOptionLabel", () => $1a3d0f2eb875e1af$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $1a3d0f2eb875e1af$export$40be908210c5a79c);
$parcel$export(module.exports, "isOptionDisabled", () => $1a3d0f2eb875e1af$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $1a3d0f2eb875e1af$export$f4da216a6ca54656 = (group)=>group.label;
const $1a3d0f2eb875e1af$export$dac6ace3020563ca = (option)=>option.label;
const $1a3d0f2eb875e1af$export$40be908210c5a79c = (option)=>option.value;
const $1a3d0f2eb875e1af$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("jtVgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $afe53037961824c2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $afe53037961824c2$var$dummyInputStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 1,
    padding: 0,
    position: 'relative',
    background: 0,
    border: 0,
    caretColor: 'transparent',
    color: 'transparent',
    fontSize: 'inherit',
    gridArea: '1 / 1 / 2 / 3',
    insetInlineStart: -100,
    label: 'dummyInput',
    opacity: 0,
    outline: 0,
    transform: 'scale(.01)'
});
function $afe53037961824c2$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $gyjU7.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        ref: innerRef,
        ...filteredProps,
        css: $afe53037961824c2$var$dummyInputStyles
    });
}

});

parcelRegister("9cRAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a388fa48a9e96271$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $eGmKJ = parcelRequire("eGmKJ");
function $a388fa48a9e96271$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a388fa48a9e96271$var$styles = {
    name: "1fj9brw-requiredInput",
    styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
};
const $a388fa48a9e96271$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $a388fa48a9e96271$var$styles,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $eGmKJ.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a388fa48a9e96271$export$2e2bcd8739ae039 = $a388fa48a9e96271$var$RequiredInput;

});

parcelRegister("galqx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e15a49c0b3452f71$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $59IMp = parcelRequire("59IMp");

var $3jzRI = parcelRequire("3jzRI");
function $e15a49c0b3452f71$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e15a49c0b3452f71$var$styles = {
    name: "qzxev8",
    styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
};
const $e15a49c0b3452f71$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $e15a49c0b3452f71$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $59IMp.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $3jzRI.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, lockEnabled && // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        onClick: $e15a49c0b3452f71$var$blurSelectInput,
        css: $e15a49c0b3452f71$var$styles
    }), children(targetRef));
}

});
parcelRegister("59IMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $96c08116303d9e3a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gyjU7 = parcelRequire("gyjU7");
const $96c08116303d9e3a$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $96c08116303d9e3a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $5uXOq.useRef)(false);
    const isTop = (0, $5uXOq.useRef)(false);
    const touchStart = (0, $5uXOq.useRef)(0);
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $96c08116303d9e3a$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $5uXOq.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $gyjU7.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});

parcelRegister("3jzRI", function(module, exports) {

$parcel$export(module.exports, "default", () => $840302f0f43020c5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $840302f0f43020c5$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $840302f0f43020c5$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $840302f0f43020c5$var$preventTouchMove(e) {
    e.preventDefault();
}
function $840302f0f43020c5$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $840302f0f43020c5$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $840302f0f43020c5$var$isTouchDevice() {
    // eslint-disable-next-line compat/compat
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $840302f0f43020c5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $840302f0f43020c5$var$activeScrollLocks = 0;
const $840302f0f43020c5$var$listenerOptions = {
    capture: false,
    passive: false
};
function $840302f0f43020c5$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $5uXOq.useRef)({});
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$840302f0f43020c5$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($840302f0f43020c5$var$LOCK_STYLES).forEach((key)=>{
                const val = $840302f0f43020c5$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $840302f0f43020c5$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $840302f0f43020c5$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$840302f0f43020c5$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $840302f0f43020c5$var$activeScrollLocks = Math.max($840302f0f43020c5$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $840302f0f43020c5$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("81i5b", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3ccfcdca5695e58$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $dQlbw = parcelRequire("dQlbw");

var $bEd7d = parcelRequire("bEd7d");
// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $a3ccfcdca5695e58$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
    const ariaLabel = selectProps['aria-label'] || label;
    const ariaLive = selectProps['aria-live'];
    // for safari, we will use minimum support from aria-live region
    const isA11yImprovementEnabled = (0, $VSDnB.fg)('design_system_select-a11y-improvement') && !isAppleDevice;
    // Update aria live message configuration when prop changes
    const messages = (0, $5uXOq.useMemo)(()=>({
            ...(0, $dQlbw.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $5uXOq.useMemo)(()=>{
        let message = '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    const prevInputValue = (0, $5uXOq.useRef)('');
    const ariaFocused = (0, $5uXOq.useMemo)(()=>{
        let focusMsg = '';
        const focused = focusedOption || focusedValue;
        const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if ((!inputValue || inputValue === prevInputValue.current) && isA11yImprovementEnabled) // only announce focus option when searching when ff is on,
        // for safari, we will announce for all
        return '';
        prevInputValue.current = inputValue;
        if (focused && messages.onFocus) {
            const onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice,
                isMulti: isMulti
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        inputValue,
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice,
        isA11yImprovementEnabled,
        isMulti
    ]);
    const ariaResults = (0, $5uXOq.useMemo)(()=>{
        let resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const shouldAnnounceAvailableResults = !focusableOptions.length;
            if (shouldAnnounceAvailableResults && (0, $VSDnB.fg)('design_system_select-a11y-improvement') || !(0, $VSDnB.fg)('design_system_select-a11y-improvement')) {
                // only announce no option results when ff is on
                const resultsMessage = screenReaderStatus({
                    count: focusableOptions.length
                });
                resultsMsg = messages.onFilter({
                    inputValue: inputValue,
                    resultsMessage: resultsMessage
                });
            }
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
        if ((0, $VSDnB.fg)('design_system_select-a11y-improvement')) // don't announce guidance at all when ff is on
        return '';
        let guidanceMsg = '';
        if (messages.guidance) {
            const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    const ScreenReaderText = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-results"
    }, ariaResults), !(0, $VSDnB.fg)('design_system_select-a11y-improvement') && /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bEd7d.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bEd7d.default), {
        "aria-live": isA11yImprovementEnabled ? 'polite' : ariaLive,
        role: isA11yImprovementEnabled ? 'status' : 'log'
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a3ccfcdca5695e58$export$2e2bcd8739ae039 = $a3ccfcdca5695e58$var$LiveRegion;

});
parcelRegister("dQlbw", function(module, exports) {

$parcel$export(module.exports, "defaultAriaLiveMessages", () => $d3258ad64818881e$export$a7265767c78f9bae);

var $VSDnB = parcelRequire("VSDnB");
const $d3258ad64818881e$export$a7265767c78f9bae = {
    guidance: (props)=>{
        const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
        switch(context){
            case 'menu':
                return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
            case 'input':
                return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: (props)=>{
        const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return `option ${label}, deselected.`;
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
            case 'select-option':
                return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
            default:
                return '';
        }
    },
    onFocus: (props)=>{
        const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isMulti: isMulti, isDisabled: isDisabled, isSelected: isSelected, isAppleDevice: isAppleDevice } = props;
        const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
        if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
        if (context === 'menu' && isAppleDevice) {
            const disabled = isDisabled ? ' disabled' : '';
            // don't announce not selected for single selection
            const notSelectedStatus = !isMulti && (0, $VSDnB.fg)('design_system_select-a11y-improvement') ? '' : ' not selected';
            const status = `${isSelected ? ' selected' : notSelectedStatus}${disabled}`;
            return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
        }
        return '';
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
    }
};

});

parcelRegister("bEd7d", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cc43afa82d3c33b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $7cc43afa82d3c33b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
const $7cc43afa82d3c33b$var$styles = {
    name: "1j8j4w4-a11yText",
    styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
};
const $7cc43afa82d3c33b$var$A11yText = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $7cc43afa82d3c33b$var$styles,
        ...props
    });
var $7cc43afa82d3c33b$export$2e2bcd8739ae039 = $7cc43afa82d3c33b$var$A11yText;

});


parcelRegister("5JAlL", function(module, exports) {

$parcel$export(module.exports, "createFilter", () => $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf);

var $8QpSo = parcelRequire("8QpSo");

var $bXu2O = parcelRequire("bXu2O");
const $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput = (0, $8QpSo.default)((0, $bXu2O.stripDiacritics));
const $2c9d8148d5bbcfb3$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $2c9d8148d5bbcfb3$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $2c9d8148d5bbcfb3$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $2c9d8148d5bbcfb3$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $2c9d8148d5bbcfb3$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $bXu2O.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("bXu2O", function(module, exports) {

$parcel$export(module.exports, "stripDiacritics", () => $df93339199dda18e$export$b5bee4b27048330b);
const $df93339199dda18e$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $df93339199dda18e$var$anyDiacritic = new RegExp('[' + $df93339199dda18e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $df93339199dda18e$var$diacriticToBase = {};
for(let i = 0; i < $df93339199dda18e$var$diacritics.length; i++){
    let diacritic = $df93339199dda18e$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$df93339199dda18e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $df93339199dda18e$export$b5bee4b27048330b = (str)=>{
    return str.replace($df93339199dda18e$var$anyDiacritic, (match)=>$df93339199dda18e$var$diacriticToBase[match]);
};

});


parcelRegister("5HBcW", function(module, exports) {

$parcel$export(module.exports, "defaultTheme", () => $f64b5780144c9fe8$export$164de7ab8df77ef0);
const $f64b5780144c9fe8$export$8f45430ccf837300 = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
const $f64b5780144c9fe8$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
const $f64b5780144c9fe8$var$baseUnit = 4;
// The minimum height of the control
const $f64b5780144c9fe8$var$controlHeight = 38;
// The amount of space between the control and menu */
const $f64b5780144c9fe8$var$menuGutter = $f64b5780144c9fe8$var$baseUnit * 2;
const $f64b5780144c9fe8$export$5458b64234d1333c = {
    baseUnit: $f64b5780144c9fe8$var$baseUnit,
    controlHeight: $f64b5780144c9fe8$var$controlHeight,
    menuGutter: $f64b5780144c9fe8$var$menuGutter
};
const $f64b5780144c9fe8$export$164de7ab8df77ef0 = {
    borderRadius: $f64b5780144c9fe8$var$borderRadius,
    colors: $f64b5780144c9fe8$export$8f45430ccf837300,
    spacing: $f64b5780144c9fe8$export$5458b64234d1333c
};

});


parcelRegister("9uJ4X", function(module, exports) {

$parcel$export(module.exports, "default", () => $72b6d9d338d10de1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $72b6d9d338d10de1$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("3c98u", function(module, exports) {

$parcel$export(module.exports, "default", () => $628a0199069e875a$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $5uXOq = parcelRequire("5uXOq");

var $7VXAu = parcelRequire("7VXAu");

var $l4W7r = parcelRequire("l4W7r");
var $1k2at = parcelRequire("1k2at");

var $j1GDZ = parcelRequire("j1GDZ");

var $bA56e = parcelRequire("bA56e");

var $eaXSR = parcelRequire("eaXSR");

var $1DATb = parcelRequire("1DATb");
function $628a0199069e875a$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $5uXOq.useRef)(null);
        const components = (0, $5uXOq.useMemo)(()=>({
                ClearIndicator: $l4W7r.ClearIndicator,
                DropdownIndicator: $l4W7r.DropdownIndicator,
                LoadingIndicator: $l4W7r.LoadingIndicator,
                MultiValueRemove: $1k2at.MultiValueRemove,
                IndicatorSeparator: $1k2at.IndicatorSeparator,
                Input: $j1GDZ.Input,
                NoOptionsMessage: $bA56e.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $5uXOq.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $1DATb.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $1DATb.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $7VXAu.mergeStyles)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $eaXSR.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("l4W7r", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $9145857df3efc9da$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $9145857df3efc9da$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $9145857df3efc9da$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $c8Oei = parcelRequire("c8Oei");

var $cQz2U = parcelRequire("cQz2U");

var $f5TWP = parcelRequire("f5TWP");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");

var $eZJjh = parcelRequire("eZJjh");
const $9145857df3efc9da$var$iconContainerStyles = (0, $8CUq3.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $9145857df3efc9da$var$dropdownWrapperStyles = (0, $8CUq3.xcss)({
    padding: 'space.075'
});
const $9145857df3efc9da$export$ecf9cf59142dd54a = ({ clearControlLabel: clearControlLabel = 'clear', ...props })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5ILhZ.default), {
        xcss: $9145857df3efc9da$var$iconContainerStyles,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQz2U))), {
        label: "",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
};
const $9145857df3efc9da$export$ec98719d3db7f2e4 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).DropdownIndicator, props, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f5TWP.default), {
        as: "span",
        xcss: $9145857df3efc9da$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
const $9145857df3efc9da$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $f8Sb3.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eZJjh.default), {
        size: "small"
    })));
};

});
parcelRegister("cQz2U", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35e97232317682a60395e2ccf8df4ad7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95a586bfe482ffec$var$_react = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $95a586bfe482ffec$var$_crossCircle = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("47etd")));

var $95a586bfe482ffec$var$_selectClear = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("673MF")));
function $95a586bfe482ffec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $95a586bfe482ffec$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $95a586bfe482ffec$var$_react.default.createElement($95a586bfe482ffec$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $95a586bfe482ffec$var$_selectClear.default
    }, props));
$95a586bfe482ffec$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $95a586bfe482ffec$var$_default = module.exports.default = $95a586bfe482ffec$var$CrossCircleIcon;

});
parcelRegister("47etd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc42d217064fbe3eaef70b43f6c007b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ff30a5d9a7d32b6$var$_react = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2ff30a5d9a7d32b6$var$_UNSAFE_baseNew = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2ff30a5d9a7d32b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ff30a5d9a7d32b6$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $2ff30a5d9a7d32b6$var$_react.default.createElement($2ff30a5d9a7d32b6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$2ff30a5d9a7d32b6$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $2ff30a5d9a7d32b6$var$_default = module.exports.default = $2ff30a5d9a7d32b6$var$CrossCircleIcon;

});

parcelRegister("673MF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $473654f205f53fc4$var$_react = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $473654f205f53fc4$var$_crossCircle = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("hI6SY")));
function $473654f205f53fc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $473654f205f53fc4$var$SelectClearIcon = (props)=>/*#__PURE__*/ $473654f205f53fc4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $473654f205f53fc4$var$_crossCircle.default
    }));
$473654f205f53fc4$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $473654f205f53fc4$var$_default = module.exports.default = $473654f205f53fc4$var$SelectClearIcon;

});
parcelRegister("hI6SY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b195e70c8e4b45875c876105018c6db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce4be313f95bc8ed$var$_react = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ce4be313f95bc8ed$var$_UNSAFE_baseNew = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ce4be313f95bc8ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce4be313f95bc8ed$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $ce4be313f95bc8ed$var$_react.default.createElement($ce4be313f95bc8ed$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$ce4be313f95bc8ed$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $ce4be313f95bc8ed$var$_default = module.exports.default = $ce4be313f95bc8ed$var$CrossCircleIcon;

});




parcelRegister("1k2at", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $5fdfa3c8145f4e13$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $673MF = parcelRequire("673MF");

var $bjGSs = parcelRequire("bjGSs");

var $VSDnB = parcelRequire("VSDnB");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");

var $l4W7r = parcelRequire("l4W7r");
function $5fdfa3c8145f4e13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5fdfa3c8145f4e13$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $5fdfa3c8145f4e13$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $5fdfa3c8145f4e13$var$iconWrapperStyles = (0, $8CUq3.xcss)({
    padding: 'space.025'
});
const $5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    const renderIcon = ()=>{
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bjGSs))), {
            label: "Clear",
            color: "currentColor"
        });
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f5TWP.default), {
            xcss: $5fdfa3c8145f4e13$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bjGSs))), {
            label: "Clear",
            color: "currentColor"
        }));
        return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($673MF))), {
            label: "Clear",
            primaryColor: "transparent",
            size: "small",
            secondaryColor: "inherit"
        }));
    };
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).MultiValueRemove, props, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: isDisabled ? $5fdfa3c8145f4e13$var$disabledStyles : $5fdfa3c8145f4e13$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, renderIcon())));
};
const $5fdfa3c8145f4e13$export$bd638c2ba7915668 = null;

});

parcelRegister("j1GDZ", function(module, exports) {

$parcel$export(module.exports, "Input", () => $4cb02513bf42b58e$export$f5b8910cec6cf069);

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
function $4cb02513bf42b58e$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute = props['aria-describedby'];
    const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
    if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("bA56e", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $eeac7d0aa054dce2$export$d58b72b7d3c4072c);

var $5uXOq = parcelRequire("5uXOq");

var $cgL5K = parcelRequire("cgL5K");

var $bChGW = parcelRequire("bChGW");
const $eeac7d0aa054dce2$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.subtle"
    }, props.children || `No options`));
};

});

parcelRegister("eaXSR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7eb841defe611e3$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

function $b7eb841defe611e3$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                borderColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = (0, $VSDnB.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color,
                ...(0, $VSDnB.fg)('platform-component-visual-refresh') && {
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    // Hardcode this color for visual refresh as there is no token color yet
                    borderColor: '#B7B9BE',
                    borderWidth: "var(--ds-border-width, 1px)",
                    borderStyle: 'solid',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)",
                ...(0, $VSDnB.fg)('platform-component-visual-refresh') && {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: "var(--ds-space-050, 4px)"
                }
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $829f609a65d26a98$export$b34b069eff244586})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ...(0, $VSDnB.fg)('platform-component-visual-refresh') && {
                    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                    border: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    appearance: 'none',
                    borderRadius: "var(--ds-border-radius, 4px)",
                    color: "var(--ds-text, #172B4D)",
                    padding: "var(--ds-space-025, 2px)",
                    marginRight: "var(--ds-space-025, 2px)",
                    ':focus-visible': {
                        outlineOffset: "var(--ds-space-negative-025, -2px)"
                    },
                    ':hover': {
                        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                    },
                    ':active': {
                        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                    }
                }
            }),
        groupHeading: (css)=>({
                ...css,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                textTransform: 'none'
            })
    };
}

});

parcelRegister("1DATb", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $a998ee34d66f3da7$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $a998ee34d66f3da7$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $a998ee34d66f3da7$export$8ee33f304118fce4);
function $a998ee34d66f3da7$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $a998ee34d66f3da7$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $a998ee34d66f3da7$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("hT6ku", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $3f79b132df1e01ff$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $3f79b132df1e01ff$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $3f79b132df1e01ff$export$71abc632aa29e6fe);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $gMMNe = parcelRequire("gMMNe");

var $bChGW = parcelRequire("bChGW");


var $k5uoT = parcelRequire("k5uoT");

var $jldZL = parcelRequire("jldZL");
function $3f79b132df1e01ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3f79b132df1e01ff$var$menuDialogStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    zIndex: (0, $k5uoT.layers).modal(),
    backgroundColor: "var(--ds-surface-overlay, white)",
    borderRadius: "var(--ds-border-radius-100, 4px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}, 0 4px 11px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}`})`
});
const $3f79b132df1e01ff$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId }, ref)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: ref,
        css: [
            $3f79b132df1e01ff$var$menuDialogStyles,
            // There is not a limited amount of values for the widths, so they need
            // to remain dynamic.
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                maxWidth: maxWidth,
                minWidth: minWidth
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`
    }, children));
// ==============================
// Custom Components
// ==============================
const $3f79b132df1e01ff$var$dropdownStyles = {
    name: "7693z9",
    styles: "width:32px;margin-inline-end:var(--ds-space-025, 2px);text-align:center"
};
const $3f79b132df1e01ff$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $3f79b132df1e01ff$var$dropdownStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gMMNe))), {
        color: "currentColor",
        spacing: "spacious",
        label: "open"
    }));
const $3f79b132df1e01ff$var$controlStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
});
const $3f79b132df1e01ff$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        css: $3f79b132df1e01ff$var$controlStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).Control, {
        ...props,
        innerProps: innerProps
    }));
const $3f79b132df1e01ff$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jldZL.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).Control, props));
// NOTE `props` intentionally omitted from `Fragment`
const $3f79b132df1e01ff$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", innerProps, children);
const $3f79b132df1e01ff$var$IndicatorSeparator = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).IndicatorSeparator, props);
const $3f79b132df1e01ff$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).ClearIndicator, props);
const $3f79b132df1e01ff$var$MultiValueRemove = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).MultiValueRemove, props);
const $3f79b132df1e01ff$export$71abc632aa29e6fe = {
    Control: $3f79b132df1e01ff$var$Control,
    DropdownIndicator: $3f79b132df1e01ff$var$DropdownIndicator,
    Menu: $3f79b132df1e01ff$var$Menu,
    IndicatorSeparator: $3f79b132df1e01ff$var$IndicatorSeparator,
    ClearIndicator: $3f79b132df1e01ff$var$ClearIndicator,
    MultiValueRemove: $3f79b132df1e01ff$var$MultiValueRemove
};

});
parcelRegister("gMMNe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::96a381bb462d74e92d39bb265721c443>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c386fa4cb21167b0$var$_react = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c386fa4cb21167b0$var$_search = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("hyOJh")));

var $c386fa4cb21167b0$var$_search2 = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("77ZoC")));
function $c386fa4cb21167b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c386fa4cb21167b0$var$SearchIcon = (props)=>/*#__PURE__*/ $c386fa4cb21167b0$var$_react.default.createElement($c386fa4cb21167b0$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $c386fa4cb21167b0$var$_search2.default
    }, props));
$c386fa4cb21167b0$var$SearchIcon.Name = 'SearchIconMigration';
var $c386fa4cb21167b0$var$_default = module.exports.default = $c386fa4cb21167b0$var$SearchIcon;

});
parcelRegister("77ZoC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5308cfd5e45a5605$var$_react = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $5308cfd5e45a5605$var$_search = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("hyOJh")));
function $5308cfd5e45a5605$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5308cfd5e45a5605$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $5308cfd5e45a5605$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props, {
        newIcon: $5308cfd5e45a5605$var$_search.default
    }));
$5308cfd5e45a5605$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $5308cfd5e45a5605$var$_default = module.exports.default = $5308cfd5e45a5605$var$EditorSearchIcon;

});




parcelRegister("85BdV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dac99c767b21e7c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9dac99c767b21e7c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    ariaLabel: {
        "id": "inline-card-create.form.status-select.aria-label",
        "defaultMessage": "The current status is {value}. Press the 'Space' key to change the status."
    },
    invalid: {
        "id": "inline-card-create.form.status-select.invalid",
        "defaultMessage": "invalid"
    }
});

});


parcelRegister("hIWd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d06f081c1e675aa$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $7Jxgt = parcelRequire("7Jxgt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $1XJ20 = parcelRequire("1XJ20");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5knXz = parcelRequire("5knXz");

var $4pxa7 = parcelRequire("4pxa7");


var $2Z6La = parcelRequire("2Z6La");

var $dhszq = parcelRequire("dhszq");

var $kNtWa = parcelRequire("kNtWa");

var $hNJJt = parcelRequire("hNJJt");

var $l94uE = parcelRequire("l94uE");
const $0d06f081c1e675aa$var$isEnrolledInSimplifyIccBundle = ()=>{
    const [expConfigM2] = (0, $6s1PB.UNSAFE_noExposureExp)('simplify_icc_bundle_m2');
    const isEnrolledM2 = expConfigM2.get('cohort', 'not-enrolled') !== 'not-enrolled';
    return isEnrolledM2;
};
const $0d06f081c1e675aa$var$isInSimplifyIccBundleVariation = ()=>{
    const [expConfigM2] = (0, $6s1PB.UNSAFE_noExposureExp)('simplify_icc_bundle_m2');
    const isInVariationM2 = expConfigM2.get('cohort', 'not-enrolled') === 'variation';
    return isInVariationM2;
};
// exact trigger height
const $0d06f081c1e675aa$var$TRIGGER_HEIGHT = 40;
const $0d06f081c1e675aa$var$withMarginTopStyles = null;
const $0d06f081c1e675aa$var$withTransparentStyles = null;
const $0d06f081c1e675aa$export$c283de3a59c46bc6 = (cardTypes, cardTypeId, defaultCardTypeId)=>{
    const selectedCardType = cardTypes.find(({ id: id })=>id === cardTypeId);
    const fallbackCardTypeId = defaultCardTypeId && cardTypes.some(({ id: id, isDisabled: isDisabled })=>id === defaultCardTypeId && isDisabled !== true) ? defaultCardTypeId : null;
    if (selectedCardType?.isDisabled === true) return fallbackCardTypeId;
    // To prevent setting invalid value when user switches to another ICC component that have different cardTypes
    return selectedCardType !== undefined ? cardTypeId : fallbackCardTypeId;
};
const $0d06f081c1e675aa$var$InlineCardCreate = (props)=>{
    const { isFormVisible: isFormVisibleProp, isFormVisibleDefault: isFormVisibleDefault = false, isDisabled: isDisabled = false, shouldScrollIntoView: shouldScrollIntoView, onChangeFormVisible: onChangeFormVisible = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), triggerAppearance: triggerAppearance, onTriggerClick: onTriggerClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCancel: onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCreate: onCreate = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeCardType: onChangeCardType = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeSummary: onChangeSummary = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeStatusTransition: onChangeStatusTransition = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeProject: onChangeProject = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), cardTypes: cardTypes = [], defaultCardTypeId: defaultCardTypeId, autoFocus: autoFocus, extraItems: extraItems, shouldKeepFormOpenOnClickOutside: shouldKeepFormOpenOnClickOutside, triggerLabel: triggerLabel, ariaLabelledBy: ariaLabelledBy, appearance: appearance, placeholderText: placeholderText, numFilters: numFilters, messages: messages, saveOnBlur: saveOnBlur, renderAdditionalTypeSelectOptionContent: renderAdditionalTypeSelectOptionContent, renderAdditionalInlineCreateFooter: renderAdditionalInlineCreateFooter, onBlur: onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), TypeSelect: TypeSelect, StatusSelect: StatusSelect, statusTransitions: statusTransitions, projects: projects, isModalTrigger: isModalTrigger, shouldShowCreateButton: shouldShowCreateButton, onAutoOpen: onAutoOpen = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) } = props;
    const [isFormVisible, setIsFormVisible] = (0, $5uXOq.useState)(isFormVisibleProp ?? isFormVisibleDefault);
    const [triggerUnmountTimeoutId, setTriggerUnmountTimeoutId] = (0, $5uXOq.useState)(null);
    const previousIsFormVisibleProp = (0, $1XJ20.usePreviousWithInitial)(isFormVisibleProp);
    const previousIsFormVisible = (0, $1XJ20.usePreviousWithInitial)(isFormVisible);
    const [shouldFocusTrigger, setShouldFocusTrigger] = (0, $5uXOq.useState)(false);
    const setFocusOnTrigger = (0, $5uXOq.useCallback)(()=>{
        setShouldFocusTrigger(true);
    }, []);
    const { showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull } = (0, $5knXz.useStorageEnforcement)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // should be clean up with experiment simplify_icc_bundle_m2 or move up to src/packages/software/board/src/view/board-container/board/inline-card-create/visible-icc
    const { hasCreatedIssueICC: hasCreatedIssueICC, triggerReason: triggerReason } = $0d06f081c1e675aa$var$isEnrolledInSimplifyIccBundle() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4pxa7.useTriggerEventState)() : {
        hasCreatedIssueICC: false,
        triggerReason: undefined
    };
    const { setHasCreatedIssueICC: setHasCreatedIssueICC, setTriggerReason: setTriggerReason } = $0d06f081c1e675aa$var$isEnrolledInSimplifyIccBundle() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4pxa7.useKeepIccOpenActions)() : {
        setHasCreatedIssueICC: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        setTriggerReason: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    };
    (0, $5uXOq.useEffect)(()=>{
        if (!false && (previousIsFormVisibleProp !== isFormVisibleProp || previousIsFormVisible !== isFormVisible)) // invoke callback everytime isFormVisibleProp or internal isFormVisible state changes
        onChangeFormVisible(isFormVisibleProp ?? isFormVisible);
    }, [
        isFormVisible,
        isFormVisibleProp,
        onChangeFormVisible,
        previousIsFormVisible,
        previousIsFormVisibleProp
    ]);
    const onTriggerClickCallback = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        const sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4();
        if ($0d06f081c1e675aa$var$isEnrolledInSimplifyIccBundle()) setHasCreatedIssueICC(false);
        // @ts-expect-error Second argument should be of format "actionSubject action"
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'triggerClicked', 'triggerButton', {
            formWasOpen: isFormVisible,
            triggerAppearance: triggerAppearance,
            sessionId: sessionId,
            ...$0d06f081c1e675aa$var$isEnrolledInSimplifyIccBundle() && {
                isInSimplifyIccBundleVariation: $0d06f081c1e675aa$var$isInSimplifyIccBundleVariation()
            },
            isAutoOpen: false
        });
        if (isFormVisibleProp === undefined) {
            setTriggerUnmountTimeoutId(null);
            setIsFormVisible(true);
        }
        setShouldFocusTrigger(false);
        onTriggerClick(sessionId);
    }, [
        setHasCreatedIssueICC,
        isFormVisible,
        triggerAppearance,
        isFormVisibleProp,
        onTriggerClick
    ]);
    const onCancelCallback = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'blurred',
            actionSubject: 'inlineCardCreate'
        }), {
            cancelledBy: (0, $7462c685f739ed5a$export$2bb790b9008907b4)
        });
        if (isFormVisibleProp === undefined) {
            if (triggerUnmountTimeoutId) {
                clearTimeout(triggerUnmountTimeoutId);
                setTriggerUnmountTimeoutId(null);
            }
            setIsFormVisible(false);
        }
        onCancel();
    }, [
        createAnalyticsEvent,
        triggerUnmountTimeoutId,
        isFormVisibleProp,
        onCancel
    ]);
    const makeOnBlur = (0, $5uXOq.useCallback)((context)=>(summary)=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'blurred',
                actionSubject: 'inlineCardCreate'
            }), {
                cancelledBy: (0, $7462c685f739ed5a$export$565566e3df4dad53),
                ...$0d06f081c1e675aa$var$isEnrolledInSimplifyIccBundle() && {
                    withContent: !!summary,
                    isInSimplifyIccBundleVariation: $0d06f081c1e675aa$var$isInSimplifyIccBundleVariation()
                }
            });
            context.onChangeSummary(summary);
            if (isFormVisibleProp === undefined) {
                if (triggerUnmountTimeoutId) {
                    clearTimeout(triggerUnmountTimeoutId);
                    setTriggerUnmountTimeoutId(null);
                }
                setIsFormVisible(false);
            }
            onBlur();
            if ($0d06f081c1e675aa$var$isEnrolledInSimplifyIccBundle()) setHasCreatedIssueICC(true);
        }, [
        createAnalyticsEvent,
        isFormVisibleProp,
        onBlur,
        setHasCreatedIssueICC,
        triggerUnmountTimeoutId
    ]);
    const makeOnCreate = (0, $5uXOq.useCallback)((context)=>(issues, metadata)=>{
            // analytic event name will be changed in the future to match other events
            const analyticsEvent = createAnalyticsEvent({
                action: 'confirmed',
                actionSubject: 'input'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
                createdBy: metadata.createdBy
            });
            context.onCreate();
            onCreate(issues, metadata, analyticsEvent);
            showEnforcementIfStorageIsFull({
                touchpoint: 'inline-card-create'
            });
            if ($0d06f081c1e675aa$var$isEnrolledInSimplifyIccBundle()) {
                setHasCreatedIssueICC(true);
                setTriggerReason('lastIssueCreated');
            }
        }, [
        createAnalyticsEvent,
        onCreate,
        showEnforcementIfStorageIsFull,
        setHasCreatedIssueICC,
        setTriggerReason
    ]);
    const makeOnCancel = (0, $5uXOq.useCallback)((context)=>{
        if (context && context.onCancel) return ()=>{
            context.onCancel();
            onCancelCallback();
        };
        return onCancelCallback;
    }, [
        onCancelCallback
    ]);
    const makeOnChangeCardType = (0, $5uXOq.useCallback)((context)=>{
        if (context && context.onChangeCardType) return (issueTypeId)=>{
            context.onChangeCardType(issueTypeId);
            onChangeCardType(issueTypeId);
        };
        return onChangeCardType;
    }, [
        onChangeCardType
    ]);
    const makeOnChangeStatusTransition = (0, $5uXOq.useCallback)((context)=>{
        if (context && context.onChangeFieldValue) return (transitionId)=>{
            context.onChangeFieldValue((0, $hNJJt.FIELD_KEY_STATUS_TRANSITIONS), transitionId);
            onChangeStatusTransition(transitionId);
        };
        return onChangeStatusTransition;
    }, [
        onChangeStatusTransition
    ]);
    const makeOnChangeSummary = (0, $5uXOq.useCallback)((context)=>{
        if (context && context.onChangeSummary) return (summary)=>{
            context.onChangeSummary(summary);
            onChangeSummary(summary);
        };
        return onChangeSummary;
    }, [
        onChangeSummary
    ]);
    const makeOnChangeProject = (0, $5uXOq.useCallback)((context)=>{
        if (context && context.onChangeProject) return (projectId)=>{
            context.onChangeProject(projectId);
            onChangeProject(projectId);
        };
        return onChangeProject;
    }, [
        onChangeProject
    ]);
    const isCardTypesEmptyOrAllDisabled = cardTypes.every(({ isDisabled: isCardTypeDisabled })=>Boolean(isCardTypeDisabled));
    const isTriggerDisabled = cardTypes?.length ? isDisabled || isCardTypesEmptyOrAllDisabled : isDisabled;
    const shouldRenderForm = (isFormVisibleProp ?? isFormVisible) && !isTriggerDisabled;
    (0, $5uXOq.useEffect)(()=>{
        /* 	below block is intended for case where icc is automatically opened after icc issue
    	created when user opens originally opens icc in-between two existing issues */ if ($0d06f081c1e675aa$var$isEnrolledInSimplifyIccBundle() && shouldRenderForm === true && hasCreatedIssueICC) {
            // unique sessionId for each icc
            const sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4();
            // fires start event and sets sessionId for end event
            onAutoOpen(sessionId);
            const autoFocusAnalyticsEvent = createAnalyticsEvent({
                action: 'focused',
                actionSubject: 'input',
                actionSubjectId: 'inlineCreateCard'
            });
            (0, $8zOmE.fireUIAnalytics)(autoFocusAnalyticsEvent, {
                triggeredBy: 'autoFocus',
                reason: triggerReason,
                ...$0d06f081c1e675aa$var$isEnrolledInSimplifyIccBundle() && {
                    isInSimplifyIccBundleVariation: $0d06f081c1e675aa$var$isInSimplifyIccBundleVariation()
                }
            });
            setHasCreatedIssueICC(false);
        }
    }, [
        createAnalyticsEvent,
        hasCreatedIssueICC,
        setHasCreatedIssueICC,
        shouldRenderForm,
        triggerReason,
        isFormVisible,
        triggerAppearance,
        onTriggerClick,
        onAutoOpen
    ]);
    const ICCForm = (0, $4R6GH.fg)('board_icc_form_async_load') ? (0, $dhszq.AsyncInlineCardCreateForm) : (0, $kNtWa.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "inline-card-create",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            appearance: appearance,
            numFilters: numFilters
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $0d06f081c1e675aa$var$containerStyles,
            triggerUnmountTimeoutId !== null && $0d06f081c1e675aa$var$withTriggerUnmountStyles
        ],
        testId: "platform-inline-card-create.ui.container"
    }, shouldRenderForm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Z6La.IccContext).Consumer, null, (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ICCForm, {
            autoFocus: autoFocus ?? true,
            shouldScrollIntoView: shouldScrollIntoView ?? false,
            onSubmit: makeOnCreate(value),
            onCancel: makeOnCancel(value),
            onBlur: makeOnBlur(value),
            onChangeSummary: makeOnChangeSummary(value),
            numFilters: numFilters ?? 0,
            messages: messages ?? [],
            cardTypes: cardTypes,
            extraItems: extraItems,
            shouldKeepFormOpenOnClickOutside: shouldKeepFormOpenOnClickOutside,
            selectedCardTypeId: $0d06f081c1e675aa$export$c283de3a59c46bc6(cardTypes, value.initialCardTypeId, defaultCardTypeId),
            selectedFieldValues: value.initialFieldValues,
            appearance: appearance ?? 'full',
            placeholderText: placeholderText ?? '',
            saveOnBlur: saveOnBlur ?? false,
            onChangeCardType: makeOnChangeCardType(value),
            onChangeStatusTransition: makeOnChangeStatusTransition(value),
            onChangeProject: makeOnChangeProject(value),
            initialSummary: value.initialSummary,
            renderAdditionalTypeSelectOptionContent: renderAdditionalTypeSelectOptionContent,
            renderAdditionalInlineCreateFooter: renderAdditionalInlineCreateFooter,
            TypeSelect: TypeSelect,
            StatusSelect: StatusSelect,
            statusTransitions: statusTransitions,
            selectedProjectId: value.initialProjectId,
            projects: projects,
            shouldShowCreateButton: shouldShowCreateButton,
            setFocusOnTrigger: setFocusOnTrigger
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            triggerUnmountTimeoutId !== null && "_19pk10j7",
            !(!shouldRenderForm && triggerUnmountTimeoutId === null) && "_tzy4idpf"
        ])
    }, (!shouldRenderForm || triggerUnmountTimeoutId !== null) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l94uE.default), {
        isModalTrigger: isModalTrigger,
        isSticky: appearance === (0, $7462c685f739ed5a$export$aca095bc476d426f),
        triggerAppearance: triggerAppearance,
        label: triggerLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onTriggerClickCallback,
        isDisabled: isTriggerDisabled,
        shouldFocusTrigger: shouldFocusTrigger
    }))));
};
$0d06f081c1e675aa$var$InlineCardCreate.defaultProps = {
    isFormVisibleDefault: false,
    isDisabled: false,
    autoFocus: true,
    saveOnBlur: false,
    appearance: (0, $7462c685f739ed5a$export$3789e4b2a10baa2b),
    triggerAppearance: (0, $7462c685f739ed5a$export$dda6912361cddac9),
    triggerLabel: '',
    placeholderText: '',
    numFilters: 0,
    messages: [],
    cardTypes: [],
    extraItems: undefined,
    onCreate: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onTriggerClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeSummary: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeCardType: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeStatusTransition: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeFormVisible: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeProject: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onAutoOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    renderAdditionalInlineCreateFooter: undefined,
    shouldShowCreateButton: false
};
var $0d06f081c1e675aa$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($0d06f081c1e675aa$var$InlineCardCreate);
const $0d06f081c1e675aa$var$containerStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%'
});
const $0d06f081c1e675aa$var$withTriggerUnmountStyles = (0, $8CUq3.xcss)({
    minHeight: `${$0d06f081c1e675aa$var$TRIGGER_HEIGHT}px`
});

});
parcelRegister("5knXz", function(module, exports) {

$parcel$export(module.exports, "useStorageEnforcement", () => $a61178001d7e3bbc$export$fa2c25e1ed13a1a8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $dAfqg = parcelRequire("dAfqg");


var $RnWyv = parcelRequire("RnWyv");

var $l2AwX = parcelRequire("l2AwX");
const $a61178001d7e3bbc$var$MODAL_COOLDOWN_MS = 86400000; // 1 day in ms
const $a61178001d7e3bbc$export$fa2c25e1ed13a1a8 = ()=>{
    const [currentState, { setIsOpen: setEnforceStorageModalIsOpen }] = (0, $l2AwX.useEnforceStorageModal)();
    const issueViewMode = (0, $2gCtH.useViewMode)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const isInJSWProject = projectContextData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const openModalIfNotOnCooldown = (0, $5uXOq.useCallback)((touchpoint)=>{
        const isOnCooldown = Date.now() - ((0, $RnWyv.localStorage).get((0, $3f79643dcab1adf8$export$ed785d2382d0101d)) || 0) < $a61178001d7e3bbc$var$MODAL_COOLDOWN_MS;
        if (isOnCooldown) {
            if (currentState.isOpen === 'pending') // Reset pending state if modal is on cooldown when it should be shown
            setEnforceStorageModalIsOpen({
                isOpen: 'closed',
                touchpoint: undefined
            });
        } else setEnforceStorageModalIsOpen({
            isOpen: 'open',
            touchpoint: touchpoint
        });
    }, [
        setEnforceStorageModalIsOpen,
        currentState.isOpen
    ]);
    const showEnforcementIfStorageIsFull = (0, $5uXOq.useCallback)(({ delayShow: delayShow = false, shouldOnlyShowInJSWContext: shouldOnlyShowInJSWContext = true, touchpoint: touchpoint })=>{
        if (shouldOnlyShowInJSWContext && !isInJSWProject) return;
        // Issue view use case is checked internally here rather than passed in, to avoid polluting consumer code
        if (delayShow || issueViewMode === 'MODAL') setEnforceStorageModalIsOpen({
            isOpen: 'pending',
            touchpoint: touchpoint
        });
        else openModalIfNotOnCooldown(touchpoint);
    }, [
        isInJSWProject,
        issueViewMode,
        setEnforceStorageModalIsOpen,
        openModalIfNotOnCooldown
    ]);
    // Used to show enforcement modal after modals are dismissed, to avoid modal on modal UX
    const showEnforcementIfPendingToShow = (0, $5uXOq.useCallback)(()=>{
        if (currentState.isOpen === 'pending') // Use the trigger from created the JSW issue
        openModalIfNotOnCooldown(currentState.touchpoint);
    }, [
        currentState.isOpen,
        openModalIfNotOnCooldown,
        currentState.touchpoint
    ]);
    return {
        showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull,
        showEnforcementIfPendingToShow: showEnforcementIfPendingToShow
    };
};

});
const $3f79643dcab1adf8$export$b8b9d90f9e5bd72b = 'jira-enforce-storage-limits';
const $3f79643dcab1adf8$export$8f56a4ad6e1486ea = 10;
const $3f79643dcab1adf8$export$ed785d2382d0101d = 'lastStorageEnforcement';

parcelRegister("RnWyv", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $5fd7f3930a81124f$export$c2ed3351cac403d1);

var $bSSG7 = parcelRequire("bSSG7");
const $5fd7f3930a81124f$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('enforce-storage-limits');

});

parcelRegister("l2AwX", function(module, exports) {

$parcel$export(module.exports, "useEnforceStorageModal", () => $377250c350eb1ea3$export$56beb4c2629d6615);

var $7JoAD = parcelRequire("7JoAD");

var $7FEwN = parcelRequire("7FEwN");
const $377250c350eb1ea3$var$initialState = {
    isOpen: 'closed',
    touchpoint: undefined
};
const $377250c350eb1ea3$var$store = (0, $7JoAD.createStore)({
    name: 'jsw-enforce-storage-limit-modal',
    initialState: $377250c350eb1ea3$var$initialState,
    actions: $7FEwN.actions
});
const $377250c350eb1ea3$export$56beb4c2629d6615 = (0, $7JoAD.createHook)($377250c350eb1ea3$var$store);

});
parcelRegister("7FEwN", function(module, exports) {

$parcel$export(module.exports, "actions", () => $a1630f6ff8f7879d$export$e324594224ef24da);

var $aBMM9 = parcelRequire("aBMM9");
const $a1630f6ff8f7879d$export$e324594224ef24da = {
    setIsOpen: $aBMM9.setIsOpen
};

});
parcelRegister("aBMM9", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $bd4df525f1eeff62$export$dcf23146e0a40195);
const $bd4df525f1eeff62$export$dcf23146e0a40195 = (newState)=>({ setState: setState })=>{
        setState(newState);
    };

});




parcelRegister("dhszq", function(module, exports) {

$parcel$export(module.exports, "AsyncInlineCardCreateForm", () => $a64c6427d6c752bd$export$4f2abfdfd1993102);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $a64c6427d6c752bd$var$AsyncInlineCardCreateFormComp = (0, $kxZPA.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("kNtWa"))), {
    moduleId: "./src/packages/platform/ui/inline-card-create/src/ui/form/main.tsx"
});
const $a64c6427d6c752bd$export$4f2abfdfd1993102 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "async-inline-card-create-form",
        packageName: "JiraPlatformBoardKit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-inline-card-create-form",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a64c6427d6c752bd$var$AsyncInlineCardCreateFormComp, props)));

});
parcelRegister("kNtWa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getSelectedCardTypeId", () => $602e27e62ab6fe28$export$154199a7e659306d);
$parcel$export(module.exports, "isClickOutsideElement", () => $602e27e62ab6fe28$export$a662648a70e4e0d0);
$parcel$export(module.exports, "isClickOutsideSelect", () => $602e27e62ab6fe28$export$e3399e7287b8e45d);
$parcel$export(module.exports, "Form", () => $602e27e62ab6fe28$export$a7fed597f4b8afd8);
$parcel$export(module.exports, "default", () => $602e27e62ab6fe28$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");


var $az4zD = parcelRequire("az4zD");


var $3FdYO = parcelRequire("3FdYO");

var $k72ii = parcelRequire("k72ii");

var $3abEe = parcelRequire("3abEe");

var $2Q9me = parcelRequire("2Q9me");

var $cTb2j = parcelRequire("cTb2j");

var $hNJJt = parcelRequire("hNJJt");

var $cbChK = parcelRequire("cbChK");

var $h1sEN = parcelRequire("h1sEN");
const $602e27e62ab6fe28$export$154199a7e659306d = (initialSelectedCardTypeId, cardTypes)=>{
    if (initialSelectedCardTypeId) return initialSelectedCardTypeId;
    const filteredCardTypes = cardTypes.filter(({ isDisabled: isDisabled })=>!isDisabled);
    return filteredCardTypes.length > 0 ? filteredCardTypes[0].id : null;
};
const $602e27e62ab6fe28$export$a662648a70e4e0d0 = (target, ref)=>target instanceof Node && ref ? !ref.contains(target) : true;
const $602e27e62ab6fe28$export$e3399e7287b8e45d = (target, selectRef)=>target instanceof Node && selectRef?.node ? !selectRef.node.menuRef?.contains(target) && !selectRef.node.targetRef?.contains(target) : true;
class $602e27e62ab6fe28$export$a7fed597f4b8afd8 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            autoFocus: true,
            saveOnBlur: false,
            numFilters: 0,
            messages: [],
            cardTypes: [],
            TypeSelect: (0, $h1sEN.default),
            extraItems: undefined,
            shouldKeepFormOpenOnClickOutside: undefined,
            selectedCardTypeId: null,
            selectedFieldVaues: new Map(),
            appearance: (0, $7462c685f739ed5a$export$3789e4b2a10baa2b),
            placeholderText: '',
            initialSummary: '',
            onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onChangeSummary: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onChangeCardType: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onChangeStatusTransition: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onChangeProject: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            setFocusOnTrigger: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            renderAdditionalInlineCreateFooter: undefined,
            shouldShowCreateButton: false
        };
    }
    static getDerivedStateFromProps(props, state) {
        // Checks if the selectedCardTypeId still exists in the cardTypes array and refresh the value if it isn't
        // This is used in Program board where the cardTypes are updated when the project selector value changes
        const selectedCardType = props.cardTypes.find(({ id: id, isDisabled: isDisabled })=>id === state.selectedCardTypeId && !isDisabled);
        if (!selectedCardType) return {
            ...state,
            selectedCardTypeId: $602e27e62ab6fe28$export$154199a7e659306d(props.selectedCardTypeId, props.cardTypes)
        };
        return null;
    }
    componentDidMount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('mouseup', this.onMouseUp);
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('mouseup', this.onMouseUp);
        this.debouncedOnChangeSummary.flush();
    }
    render() {
        const { appearance: appearance, renderAdditionalInlineCreateFooter: renderAdditionalInlineCreateFooter } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$Container, {
            ref: this.form,
            appearance: appearance,
            "data-testid": "platform-inline-card-create.ui.form.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$StyledForm, {
            appearance: appearance
        }, appearance === (0, $7462c685f739ed5a$export$3789e4b2a10baa2b) ? this.renderFullViewContent(renderAdditionalInlineCreateFooter) : this.renderCompactViewContent()));
    }
    constructor(...args){
        super(...args);
        this.state = {
            validationError: (0, $cbChK.validateSummary)(this.props.initialSummary, this.props.intl),
            selectedCardTypeId: $602e27e62ab6fe28$export$154199a7e659306d(this.props.selectedCardTypeId, this.props.cardTypes),
            selectedTransitionId: Number(this.props.selectedFieldValues?.get((0, $hNJJt.FIELD_KEY_STATUS_TRANSITIONS))) || null,
            selectedProjectId: this.props.selectedProjectId,
            sanitisedSummary: (0, $cbChK.stripConsecutiveWhitespacesAndTrim)(this.props.initialSummary)
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ;
        this.onMouseUp = ({ target: target })=>{
            if (this.props.shouldKeepFormOpenOnClickOutside) return;
            if ($602e27e62ab6fe28$export$a662648a70e4e0d0(target, this.form.current) && $602e27e62ab6fe28$export$a662648a70e4e0d0(target, this.inlineMessagePopupRef.current) && $602e27e62ab6fe28$export$e3399e7287b8e45d(target, this.typeSelect.current) && $602e27e62ab6fe28$export$e3399e7287b8e45d(target, this.statusSelect.current) && $602e27e62ab6fe28$export$e3399e7287b8e45d(target, this.projectSelect.current)) this.onBlur();
        };
        this.onSubmit = ({ createdBy: createdBy = (0, $7462c685f739ed5a$export$806b905ec7df742f) } = {})=>()=>{
                const { sanitisedSummary: sanitisedSummary, selectedCardTypeId: selectedCardTypeId, selectedTransitionId: selectedTransitionId, selectedProjectId: selectedProjectId } = this.state;
                if (selectedCardTypeId === null) return;
                this.debouncedOnChangeSummary.flush();
                this.submitCounter += 1;
                const metadata = {
                    createdBy: createdBy
                }; // summaryData is a string
                const summaryData = sanitisedSummary;
                if (summaryData.length > 0) {
                    const fields = new Map();
                    fields.set((0, $hNJJt.FIELD_KEY_STATUS_TRANSITIONS), selectedTransitionId);
                    const summaryDataTransformed = {
                        summary: summaryData,
                        cardTypeId: selectedCardTypeId,
                        fields: fields,
                        projectId: selectedProjectId === null ? undefined : selectedProjectId
                    };
                    this.props.onSubmit([
                        summaryDataTransformed
                    ], metadata);
                } else this.props.onBlur('');
                this.setState({
                    validationError: (0, $3FdYO.emptyValidationError),
                    sanitisedSummary: ''
                });
            };
        this.onCancel = ()=>{
            this.debouncedOnChangeSummary.flush();
            this.props.onCancel();
            this.setState({
                validationError: (0, $3FdYO.emptyValidationError),
                sanitisedSummary: ''
            });
        };
        this.onSelectCardType = (cardTypeId)=>{
            this.props.onChangeCardType(cardTypeId);
            this.setState({
                selectedCardTypeId: cardTypeId
            });
        };
        this.onSelectProject = (projectId)=>{
            this.props.onChangeProject(projectId);
            this.setState({
                selectedProjectId: projectId
            });
        };
        this.onSelectTransition = (transitionId)=>{
            this.props.onChangeStatusTransition(transitionId);
            this.setState({
                selectedTransitionId: transitionId
            });
        };
        this.onChangeSummary = ({ summary: summary, validationError: validationError })=>{
            this.setState((prevState)=>({
                    sanitisedSummary: summary.replace('\n', ' '),
                    validationError: {
                        ...prevState.validationError,
                        ...validationError
                    }
                }));
            this.debouncedOnChangeSummary(summary);
        };
        this.onBlur = ()=>{
            if (this.props.saveOnBlur) this.onSubmit({
                isConcat: true,
                createdBy: (0, $7462c685f739ed5a$export$565566e3df4dad53)
            })();
            else this.props.onBlur(this.state.sanitisedSummary);
        };
        this.submitCounter = 0;
        this.initialSummary = this.props.initialSummary;
        this.form = /*#__PURE__*/ (0, $5uXOq.createRef)();
        this.typeSelect = /*#__PURE__*/ (0, $5uXOq.createRef)();
        this.statusSelect = /*#__PURE__*/ (0, $5uXOq.createRef)();
        this.projectSelect = /*#__PURE__*/ (0, $5uXOq.createRef)();
        this.inlineMessagePopupRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
        this.debouncedOnChangeSummary = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((summary)=>{
            this.props.onChangeSummary(summary);
        }, 250);
        this.getSelectedIssueType = ()=>{
            const { selectedCardTypeId: selectedCardTypeId } = this.state;
            const { cardTypes: cardTypes } = this.props;
            return cardTypes.find((type)=>type.id === selectedCardTypeId);
        };
        this.renderTypeDropdown = ()=>{
            const { cardTypes: cardTypes, extraItems: extraItems, TypeSelect: TypeSelect = (0, $h1sEN.default) } = this.props;
            const { selectedCardTypeId: selectedCardTypeId } = this.state;
            if (selectedCardTypeId === null) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TypeSelect, {
                ref: this.typeSelect,
                cardTypes: cardTypes,
                selectedCardTypeId: selectedCardTypeId,
                onSelectCardType: this.onSelectCardType,
                renderAdditionalOptionContent: this.props.renderAdditionalTypeSelectOptionContent,
                shouldRenderToParent: true,
                extraItems: extraItems
            });
        };
        this.renderProjectDropdown = ()=>{
            const { ProjectSelect: ProjectSelect = (0, $cTb2j.default), projects: projects } = this.props;
            const { selectedProjectId: selectedProjectId } = this.state;
            if ((projects?.length || 0) > 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProjectSelect, {
                ref: this.projectSelect,
                projects: projects || [],
                selectedProjectId: selectedProjectId,
                onSelectProject: this.onSelectProject
            });
            return null;
        };
        this.renderStatusDropdown = ()=>{
            const { StatusSelect: StatusSelect = (0, $hNJJt.default), statusTransitions: statusTransitions } = this.props;
            const { selectedTransitionId: selectedTransitionId } = this.state;
            if (!statusTransitions?.length) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StatusSelect, {
                ref: this.statusSelect,
                statusTransitions: statusTransitions,
                selectedTransitionId: selectedTransitionId || statusTransitions[0].transitionId,
                onSelectTransition: this.onSelectTransition
            });
        };
        this.renderSummary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$SummaryContainer, {
                appearance: this.props.appearance
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cbChK.default), {
                initialSummary: this.initialSummary,
                appearance: this.props.appearance,
                submitCounter: this.submitCounter,
                placeholderText: this.props.placeholderText,
                autoFocus: this.props.autoFocus,
                shouldScrollIntoView: this.props.shouldScrollIntoView,
                onChangeSummary: this.onChangeSummary,
                onSubmit: this.onSubmit(),
                onCancel: this.onCancel,
                selectedIssueType: this.getSelectedIssueType()?.name,
                setFocusOnTrigger: this.props.setFocusOnTrigger
            }));
        this.buildWarnings = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            const { sanitisedSummary: sanitisedSummary, validationError: validationError } = this.state;
            if (sanitisedSummary.length > 0) {
                const validationErrors = Object.values(validationError).reduce((accumulator, errorMessage)=>{
                    if (errorMessage) accumulator.push(String(errorMessage));
                    return accumulator;
                }, []);
                return validationErrors.map((error)=>({
                        title: formatMessage((0, $2Q9me.default).validationErrorTitle, {
                            validationErrorsNo: validationErrors.length
                        }),
                        description: error
                    }));
            }
            return [];
        };
        this.renderInlineMessageInfo = ()=>{
            const { numFilters: numFilters, messages: inlineMessages, intl: { formatMessage: formatMessage } } = this.props;
            const infos = inlineMessages.length > 0 ? [
                ...inlineMessages
            ] : [];
            const warnings = this.buildWarnings();
            if (numFilters) infos.push({
                title: formatMessage((0, $2Q9me.default).appliedFiltersTitleNew),
                description: formatMessage((0, $2Q9me.default).appliedFiltersDescription)
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3abEe.default), {
                infos: infos,
                warnings: warnings,
                innerRef: this.inlineMessagePopupRef
            });
        };
        this.renderCreateButton = ()=>{
            const isEmpty = this.state.sanitisedSummary.length === 0;
            return this.props.shouldShowCreateButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k72ii.CreateButton), {
                onClick: this.onSubmit({
                    isConcat: false,
                    createdBy: (0, $7462c685f739ed5a$export$ba9f60edfdf2e66)
                }),
                isEmpty: isEmpty,
                hasValidationError: (0, $cbChK.hasValidationError)(this.state.validationError)
            });
        };
        this.renderFullViewContent = (renderAdditionalInlineCreateFooter)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$FullContent, {
                isInvalid: (0, $cbChK.hasValidationError)(this.state.validationError)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$Body, {
                appearance: this.props.appearance
            }, this.renderSummary()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$FullFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$FooterSection, null, this.renderTypeDropdown(), this.renderProjectDropdown(), this.renderStatusDropdown()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$FooterSection, null, this.renderInlineMessageInfo(), " ", this.renderCreateButton())), renderAdditionalInlineCreateFooter);
        this.renderCompactViewContent = ()=>{
            const { appearance: appearance } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$CompactContent, {
                isInvalid: (0, $cbChK.hasValidationError)(this.state.validationError),
                appearance: appearance
            }, appearance !== (0, $7462c685f739ed5a$export$aca095bc476d426f) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$Header, null, this.renderTypeDropdown(), this.renderProjectDropdown()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$Body, {
                appearance: appearance
            }, this.renderSummary()), appearance !== (0, $7462c685f739ed5a$export$aca095bc476d426f) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$CompactFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$FooterSection, null, this.renderInlineMessageInfo())));
        };
    }
}
// AK icon is not vertically aligned AK-5620 so we have to hack the button
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $602e27e62ab6fe28$var$FooterSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _1ul9idpf _dpd31txw _1n14idpf",
            __cmplp.className
        ])
    });
});
var $602e27e62ab6fe28$export$2e2bcd8739ae039 /* Card layout */  = (0, $az4zD.injectIntlV2)($602e27e62ab6fe28$export$a7fed597f4b8afd8);
const $602e27e62ab6fe28$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c1txw _16jlkb7n _2lx21bp4 _bfhk18uv",
            __cmplp.appearance !== (0, $7462c685f739ed5a$export$3789e4b2a10baa2b) && "_1pby11wp",
            __cmplp.appearance === (0, $7462c685f739ed5a$export$3789e4b2a10baa2b) && "_19pkyh40 _2hwxidpf _otyryh40 _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $602e27e62ab6fe28$var$CompactContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isInvalid: isInvalid, appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1841qrf": (0, $lD23V.default)(__cmplp.isInvalid ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `var(--ds-border-danger, ${(0, $829f609a65d26a98$exports).R400})` : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B200})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c1txw _2lx2vrvc _4cvr1h6o _ca0q1b66 _n3td1b66 _19bvu2gc _u5f3u2gc _12ji1r31 _1qu2glyw _12y31o36 _16qs148r _vchhusvi _1bsb1osq _bfhkvuon _v56416gf",
            __cmplp.appearance === (0, $7462c685f739ed5a$export$db1cdb8627b81f84) && "_19bv7vkz",
            __cmplp.appearance === (0, $7462c685f739ed5a$export$db1cdb8627b81f84) && "_19bv1crf",
            __cmplp.appearance === (0, $7462c685f739ed5a$export$1aad44a7533f8ad8) && "_19bv1crf",
            __cmplp.appearance !== (0, $7462c685f739ed5a$export$db1cdb8627b81f84) && "_2rko1l7b",
            __cmplp.appearance === (0, $7462c685f739ed5a$export$1aad44a7533f8ad8) ? "_4t3i1osq" : "_4t3i1ylp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $602e27e62ab6fe28$var$FullContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $602e27e62ab6fe28$var$CompactContent, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx21bp4 _4cvrv2br _4t3i1wug _ca0qutpp _n3tdutpp _19bvutpp _u5f3utpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $602e27e62ab6fe28$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1y6m _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $602e27e62ab6fe28$var$Body = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _16jlkb7n",
            __cmplp.appearance === (0, $7462c685f739ed5a$export$3789e4b2a10baa2b) ? "_1bsb1osq" : "_1bsb1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $602e27e62ab6fe28$var$Footer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1y6m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $602e27e62ab6fe28$var$FullFooter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $602e27e62ab6fe28$var$Footer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1bah1yb4 _4t3i1f4h _vwz4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $602e27e62ab6fe28$var$CompactFooter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $602e27e62ab6fe28$var$Footer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bahesu3 _18u0u2gc",
            __cmplp.className
        ])
    });
}); /* Form */ 
const $602e27e62ab6fe28$var$StyledForm = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.appearance === (0, $7462c685f739ed5a$export$1aad44a7533f8ad8) && "_4t3izwfg",
            __cmplp.className
        ])
    });
}); /* Text area */ 
const $602e27e62ab6fe28$var$SummaryContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _16jlkb7n _1bahv2br _4cvr1h6o",
            __cmplp.appearance === (0, $7462c685f739ed5a$export$3789e4b2a10baa2b) && "_otyrftgi",
            (__cmplp.appearance === (0, $7462c685f739ed5a$export$db1cdb8627b81f84) || __cmplp.appearance === (0, $7462c685f739ed5a$export$1aad44a7533f8ad8)) && "_18u0ftgi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3FdYO", function(module, exports) {

$parcel$export(module.exports, "emptyValidationError", () => $d43814abe3fa7cf5$export$a691a8856deba80b);
const $d43814abe3fa7cf5$export$a691a8856deba80b = {
    summary: '',
    summaryConcat: ''
};

});

parcelRegister("k72ii", function(module, exports) {

$parcel$export(module.exports, "CreateButton", () => $5befc8db90207b42$export$6d3c345ce7c38fd9);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $1SjXn = parcelRequire("1SjXn");

var $MNEb2 = parcelRequire("MNEb2");
const $5befc8db90207b42$export$6d3c345ce7c38fd9 = ({ onClick: onClick, isEmpty: isEmpty, hasValidationError: hasValidationError })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isDisabled = isEmpty || hasValidationError;
    let tooltipContent = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1SjXn.default).createButtonTooltipIssueTermRefresh : (0, $1SjXn.default).createButtonTooltip, {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MNEb2.default), null)
    });
    if (isEmpty) tooltipContent = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1SjXn.default).createButtonTooltipContentEmptyIssueTermRefresh : (0, $1SjXn.default).createButtonTooltipContentEmpty);
    else if (hasValidationError) tooltipContent = undefined;
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5befc8db90207b42$var$createButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        spacing: "compact",
        type: "submit",
        isDisabled: isDisabled,
        onClick: (e)=>{
            e.preventDefault();
            onClick();
        },
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                color: "inherit",
                as: "span"
            }, "\u23CE"),
        label: formatMessage((0, $1SjXn.default).createButtonLabel)
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5befc8db90207b42$var$createButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "primary",
        spacing: "compact",
        type: "submit",
        isDisabled: isDisabled,
        onClick: (e)=>{
            e.preventDefault();
            onClick();
        }
    }, formatMessage((0, $1SjXn.default).createButtonLabel))));
};
const $5befc8db90207b42$var$createButtonStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("1SjXn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4eb430acd8b1b3e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d4eb430acd8b1b3e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createButtonLabel: {
        "id": "inline-card-create.form.create-button.create-button-label",
        "defaultMessage": "Create"
    },
    createButtonTooltip: {
        "id": "inline-card-create.form.create-button.create-button-tooltip",
        "defaultMessage": "Create issue <icon>return icon</icon>"
    },
    createButtonTooltipContentEmpty: {
        "id": "inline-card-create.form.create-button.create-button-tooltip-content-empty",
        "defaultMessage": "Type an issue summary"
    },
    createButtonTooltipIssueTermRefresh: {
        "id": "inline-card-create.form.create-button.create-button-tooltip-issue-term-refresh",
        "defaultMessage": "Create issue <icon>return icon</icon>"
    },
    createButtonTooltipContentEmptyIssueTermRefresh: {
        "id": "inline-card-create.form.create-button.create-button-tooltip-content-empty-issue-term-refresh",
        "defaultMessage": "Type an issue summary"
    }
});

});

parcelRegister("MNEb2", function(module, exports) {

$parcel$export(module.exports, "default", () => $253f5a50f101458c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $253f5a50f101458c$var$ReturnGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "16",
        height: "12",
        viewBox: "0 0 16 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "16",
        height: "12",
        rx: "2",
        fill: "var(--ds-background-accent-gray-bolder, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12.375 3.1875V4.4375C12.375 6.33597 10.836 7.875 8.9375 7.875H3.9375C3.41974 7.875 3 7.45526 3 6.9375C3 6.41974 3.41974 6 3.9375 6H8.9375C9.8005 6 10.5 5.30045 10.5 4.4375V3.1875C10.5 2.66974 10.9197 2.25 11.4375 2.25C11.9553 2.25 12.375 2.66974 12.375 3.1875Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4.60041 7.60041L6.78787 5.41291C7.154 5.0468 7.154 4.4532 6.78787 4.08708C6.42175 3.72097 5.82825 3.72097 5.46208 4.08708L3.27458 6.27459C2.90847 6.6407 2.90847 7.2343 3.27458 7.60041C3.6407 7.96652 4.2343 7.96652 4.60041 7.60041Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4.60041 6.27458L6.78787 8.46208C7.154 8.82825 7.154 9.42175 6.78787 9.78787C6.42175 10.154 5.82825 10.154 5.46208 9.78787L3.27458 7.60041C2.90847 7.2343 2.90847 6.6407 3.27458 6.27458C3.6407 5.90847 4.2343 5.90847 4.60041 6.27458Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }));
const $253f5a50f101458c$var$ReturnIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $253f5a50f101458c$var$ReturnGlyph,
        label: ""
    });
var $253f5a50f101458c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($253f5a50f101458c$var$ReturnIcon);

});


parcelRegister("3abEe", function(module, exports) {

$parcel$export(module.exports, "default", () => $14d46a6a1d0b2bee$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $1jWct = parcelRequire("1jWct");

var $bU3PY = parcelRequire("bU3PY");

var $1I7E8 = parcelRequire("1I7E8");

var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $cgL5K = parcelRequire("cgL5K");

const $14d46a6a1d0b2bee$var$OPACITY = 0.9;
const $14d46a6a1d0b2bee$var$iconWrapperStyles = null;
const $14d46a6a1d0b2bee$var$getColor = (type)=>{
    const types = {
        info: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$exports).P300})`,
        warning: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y300})`
    };
    return types[type];
};
const $14d46a6a1d0b2bee$var$typesMapping = {
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jWct))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))),
        defaultLabel: 'warning inline message'
    }
};
const $14d46a6a1d0b2bee$var$InlineMessages = ({ infos: infos = [], warnings: warnings = [], innerRef: innerRef, defaultIsOpen: defaultIsOpen = false })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    (0, $5uXOq.useEffect)(()=>{
        const onScroll = ()=>{
            setIsOpen(false);
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('scroll', onScroll, true);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('scroll', onScroll);
        };
    }, []);
    const renderMessage = (title, description, index, isLast)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            key: index,
            space: "space.100",
            xcss: !isLast && $14d46a6a1d0b2bee$var$separatorStyles
        }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p",
            weight: "bold",
            color: "inherit"
        }, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p",
            color: "inherit"
        }, description));
    };
    const renderInlineMessage = (messages, type)=>{
        const { [type]: { icon: SelectedIcon, defaultLabel: defaultLabel } } = $14d46a6a1d0b2bee$var$typesMapping;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($14d46a6a1d0b2bee$var$Wrapper, {
            "data-testid": `platform-inline-card-create.ui.form.inline-messages-${type}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-end",
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
                    xcss: $14d46a6a1d0b2bee$var$inlineMessageContentStyles,
                    space: "space.200",
                    ref: innerRef
                }, messages.map(({ title: title, description: description }, index)=>{
                    const isLast = index === messages.length - 1;
                    return (title || description) && renderMessage(title, description, index, isLast);
                })),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                    ...triggerProps,
                    appearance: "subtle-link",
                    spacing: "none",
                    onClick: ()=>setIsOpen(!isOpen)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                    // eslint-disable-next-line jira/react/no-style-attribute
                    style: {
                        opacity: isOpen ? $14d46a6a1d0b2bee$var$OPACITY : 1,
                        color: $14d46a6a1d0b2bee$var$getColor(type)
                    },
                    className: (0, $bwpsq.default)([
                        "_16l4q80t"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectedIcon, {
                    label: defaultLabel,
                    spacing: "spacious",
                    color: "currentColor"
                })))
        }));
    };
    if (warnings.length > 0) return renderInlineMessage(warnings, 'warning');
    if (infos.length > 0) return renderInlineMessage(infos, 'info');
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $14d46a6a1d0b2bee$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bvu2gc _2hwx1i6y",
            __cmplp.className
        ])
    });
});
var $14d46a6a1d0b2bee$export$2e2bcd8739ae039 = $14d46a6a1d0b2bee$var$InlineMessages;
const $14d46a6a1d0b2bee$var$inlineMessageContentStyles = (0, $8CUq3.xcss)({
    width: '200px',
    boxSizing: 'content-box',
    textAlign: 'left',
    paddingInline: 'space.300',
    paddingBlock: 'space.200'
});
const $14d46a6a1d0b2bee$var$separatorStyles = (0, $8CUq3.xcss)({
    paddingBlockEnd: 'space.200',
    borderBottomWidth: 'space.025',
    borderBottomStyle: 'solid',
    borderBottomColor: 'color.border'
});

});
parcelRegister("1jWct", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e457cb24ac9ea7300ef511f2118ffa6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f64b62884a9bedb$var$_react = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0f64b62884a9bedb$var$_information = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2Yv61")));

var $0f64b62884a9bedb$var$_info = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2hXfb")));
function $0f64b62884a9bedb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f64b62884a9bedb$var$InformationIcon = (props)=>/*#__PURE__*/ $0f64b62884a9bedb$var$_react.default.createElement($0f64b62884a9bedb$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $0f64b62884a9bedb$var$_info.default
    }, props));
$0f64b62884a9bedb$var$InformationIcon.Name = 'InformationIconMigration';
var $0f64b62884a9bedb$var$_default = module.exports.default = $0f64b62884a9bedb$var$InformationIcon;

});


parcelRegister("2Q9me", function(module, exports) {

$parcel$export(module.exports, "default", () => $cea1cf770feb64c3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cea1cf770feb64c3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    appliedFiltersTitleNew: {
        "id": "inline-card-create.form.inline-messages.applied-filters-title-new",
        "defaultMessage": "Filters applied"
    },
    appliedFiltersDescription: {
        "id": "inline-card-create.form.inline-messages.applied-filters-description",
        "defaultMessage": "We'll update this issue\u2019s fields to match your current filters."
    },
    willAffectSprintScopeTitle: {
        "id": "inline-card-create.form.inline-messages.will-affect-sprint-scope-title",
        "defaultMessage": "Sprint scope will be affected"
    },
    willAffectSprintScopeDescription: {
        "id": "inline-card-create.form.inline-messages.will-affect-sprint-scope-description",
        "defaultMessage": "Creating an issue in an active sprint will affect it's scope."
    },
    validationErrorTitle: {
        "id": "inline-card-create.form.inline-messages.validation-error-title",
        "defaultMessage": "{validationErrorsNo} {validationErrorsNo, plural, one {error} other {errors}} found"
    },
    appliedFiltersDescriptionIssueTermRefresh: {
        "id": "inline-card-create.form.inline-messages.applied-filters-description-issue-term-refresh",
        "defaultMessage": "We'll update this issue\u2019s fields to match your current filters."
    },
    willAffectSprintScopeDescriptionIssueTermRefresh: {
        "id": "inline-card-create.form.inline-messages.will-affect-sprint-scope-description-issue-term-refresh",
        "defaultMessage": "Creating an issue in an active sprint will affect it's scope."
    }
});

});

parcelRegister("cTb2j", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcf44ebc2a1cc212$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $gZL7V = parcelRequire("gZL7V");

var $lLtod = parcelRequire("lLtod");

var $fVnbM = parcelRequire("fVnbM");

var $6Ingq = parcelRequire("6Ingq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");
var $b9dFI = parcelRequire("b9dFI");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $7tjw9 = parcelRequire("7tjw9");
const $fcf44ebc2a1cc212$var$ANALYTICS_SUBJECT = 'iccProjectSelect';
const $fcf44ebc2a1cc212$var$Option = ({ children: children, ...props })=>{
    const { projectInfo: projectInfo } = props.data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fcf44ebc2a1cc212$var$OptionWrapper, {
        "data-testId": "platform-inline-card-create.ui.form.project-select.option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fcf44ebc2a1cc212$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLtod.default), {
        src: projectInfo.avatar,
        size: "xsmall"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fcf44ebc2a1cc212$var$LabelWrapper, null, projectInfo.name)));
};
const $fcf44ebc2a1cc212$var$transformOptions = (projects, selectedProjectId)=>{
    let value;
    const options = [];
    projects.forEach((project)=>{
        const option = {
            label: project.name,
            value: project.id,
            projectInfo: project
        };
        if (project.id === selectedProjectId) value = option;
        else options.push(option);
    });
    if (!value) value = null;
    return {
        options: options,
        value: value
    };
};
const $fcf44ebc2a1cc212$var$ProjectSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ projects: projects, selectedProjectId: selectedProjectId, onSelectProject: onSelectProject }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { value: value, options: options } = (0, $5uXOq.useMemo)(()=>$fcf44ebc2a1cc212$var$transformOptions(projects, selectedProjectId), [
        projects,
        selectedProjectId
    ]);
    const trigger = (0, $5uXOq.useCallback)(({ isOpen: isOpen, ...triggerProps })=>{
        const { label: label, projectInfo: projectInfo } = value || {
            label: undefined,
            projectInfo: {
                avatar: '',
                name: '',
                key: ''
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $fcf44ebc2a1cc212$var$projectContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $fcf44ebc2a1cc212$var$projectButtonWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: label ?? null,
            delay: (0, $7462c685f739ed5a$export$f9e3e7ede9ba929d),
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...triggerProps,
            appearance: "subtle",
            spacing: "none",
            isSelected: isOpen,
            "aria-label": formatMessage((0, $7tjw9.default).ariaLabel, {
                value: label ?? formatMessage((0, $7tjw9.default).invalid)
            }),
            testId: "platform-inline-card-create.ui.form.project-select.trigger"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fcf44ebc2a1cc212$var$OptionWrapper, null, (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectInfo) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fcf44ebc2a1cc212$var$PlaceholderWrapper, null, formatMessage((0, $7tjw9.default).placeholder)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fcf44ebc2a1cc212$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLtod.default), {
            src: projectInfo.avatar || '',
            size: "xsmall"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fcf44ebc2a1cc212$var$LabelWrapper, null, projectInfo.key), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))), {
            label: ""
        })))))));
    }, [
        formatMessage,
        value
    ]);
    const onChange = (0, $5uXOq.useCallback)((option)=>{
        option && onSelectProject(option.projectInfo.id);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'dropdown changed',
            actionSubject: $fcf44ebc2a1cc212$var$ANALYTICS_SUBJECT
        }), {});
    }, [
        createAnalyticsEvent,
        onSelectProject
    ]);
    const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'dropdown opened',
            actionSubject: $fcf44ebc2a1cc212$var$ANALYTICS_SUBJECT
        }), {});
    }, [
        createAnalyticsEvent
    ]);
    const setRefNode = (0, $5uXOq.useCallback)((popupSelectRef)=>{
        ref && popupSelectRef && (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(ref, 'current.node', popupSelectRef);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9dFI.default), {
        ref: setRefNode,
        components: {
            Option: $fcf44ebc2a1cc212$var$Option
        },
        target: trigger,
        options: options,
        value: value,
        onChange: onChange,
        onMenuOpen: onMenuOpen,
        isSearchable: false,
        searchThreshold: Number.MAX_SAFE_INTEGER,
        minMenuWidth: "auto",
        classNamePrefix: "inline-card-create-project-select",
        testId: "platform-inline-card-create.ui.form.project-select.project-select"
    });
});
const $fcf44ebc2a1cc212$var$projectContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    minWidth: '0px',
    position: 'relative'
});
const $fcf44ebc2a1cc212$var$projectButtonWrapperStyles = (0, $8CUq3.xcss)({
    width: '100%',
    paddingLeft: 'space.100',
    paddingRight: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fcf44ebc2a1cc212$var$PlaceholderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _syaz131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fcf44ebc2a1cc212$var$OptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _19bv1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fcf44ebc2a1cc212$var$AvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwx1b66 _vwz4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fcf44ebc2a1cc212$var$LabelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _1ul9idpf",
            __cmplp.className
        ])
    });
});
var $fcf44ebc2a1cc212$export$2e2bcd8739ae039 // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
 = /*#__PURE__*/ (0, $5uXOq.memo)($fcf44ebc2a1cc212$var$ProjectSelect);

});
parcelRegister("7tjw9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e61bdc6f2144dcf1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e61bdc6f2144dcf1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    ariaLabel: {
        "id": "inline-card-create.form.project-select.aria-label",
        "defaultMessage": "The current project is {value}. Press the 'Space' key to change the project."
    },
    invalid: {
        "id": "inline-card-create.form.project-select.invalid",
        "defaultMessage": "invalid"
    },
    placeholder: {
        "id": "inline-card-create.form.project-select.placeholder",
        "defaultMessage": "Select project"
    }
});

});


parcelRegister("cbChK", function(module, exports) {

$parcel$export(module.exports, "stripConsecutiveWhitespacesAndTrim", () => $b09eae22f5f1e6ca$export$ad399be9aa35d90a);
$parcel$export(module.exports, "validateSummary", () => $b09eae22f5f1e6ca$export$1b7a903b2450d74d);
$parcel$export(module.exports, "hasValidationError", () => $b09eae22f5f1e6ca$export$3100ac1da5e98644);
$parcel$export(module.exports, "default", () => $b09eae22f5f1e6ca$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $eTXmK = parcelRequire("eTXmK");

var $dqoiX = parcelRequire("dqoiX");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $az4zD = parcelRequire("az4zD");

var $2OMDV = parcelRequire("2OMDV");


var $3FdYO = parcelRequire("3FdYO");

var $iQa4Q = parcelRequire("iQa4Q");
const $b09eae22f5f1e6ca$var$textAreaStyles = null;
const $b09eae22f5f1e6ca$var$appearanceStyles = null;
const $b09eae22f5f1e6ca$export$ad399be9aa35d90a = (value)=>value.replace(/\s/g, ' ').replace(/  +/g, ' ').trim(); // splitSummary can be cleaned up with simplify_icc_summary_validation
const $b09eae22f5f1e6ca$var$splitSummary = (summary)=>summary.split('\n').reduce((summaries, item)=>{
        const trimmedItem = $b09eae22f5f1e6ca$export$ad399be9aa35d90a(item); // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        return [
            ...summaries,
            ...trimmedItem ? [
                trimmedItem
            ] : []
        ];
    }, []);
const $b09eae22f5f1e6ca$export$1b7a903b2450d74d = (summary, { formatMessage: formatMessage })=>{
    const trimmedSummary = $b09eae22f5f1e6ca$export$ad399be9aa35d90a(summary); // show a warning when summary has reached max length
    if (trimmedSummary.length >= (0, $7462c685f739ed5a$export$193356664cd84c83)) return {
        ...(0, $3FdYO.emptyValidationError),
        summary: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iQa4Q.default).maxLengthIssueTermRefresh : (0, $iQa4Q.default).maxLength)
    };
    return 0, $3FdYO.emptyValidationError;
};
const $b09eae22f5f1e6ca$export$3100ac1da5e98644 = (validationError)=>Object.values(validationError).filter((error)=>error).length > 0;
class $b09eae22f5f1e6ca$export$46453a0401d6cd1a extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            autoFocus: true,
            shouldScrollIntoView: false,
            initialSummary: '',
            placeholderText: '',
            appearance: (0, $7462c685f739ed5a$export$3789e4b2a10baa2b),
            submitCounter: 0,
            selectedIssueType: undefined,
            onChangeSummary: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            setFocusOnTrigger: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    // then setting the setSelectionRange in the textarea will send the cursor to the end of the textarea value.
    // And setting the textarea scrollHeight to scrollTop will send the cursor to the last line when add multiples.
    componentDidMount() {
        const { shouldScrollIntoView: shouldScrollIntoView, autoFocus: autoFocus } = this.props;
        const textArea = this.textAreaRef.current;
        if (textArea) {
            const { length: length } = textArea.value; // preventScroll used to prevent unwanted scrolling with virtualization mounting / re-mounting the component
            textArea.focus({
                preventScroll: !shouldScrollIntoView
            });
            textArea.setSelectionRange(length, length);
            textArea.scrollTop = textArea.scrollHeight;
            if (autoFocus) {
                textArea.focus();
                textArea.setSelectionRange(length, length);
                textArea.scrollTop = textArea.scrollHeight;
            }
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.submitCounter > prevProps.submitCounter) this.reset();
    }
    shouldSummarySubmit() {
        const { summary: summary, validationError: validationError } = this.state;
        if ((0, $4R6GH.fg)('simplify_icc_summary_validation')) return !$b09eae22f5f1e6ca$export$3100ac1da5e98644(validationError);
        const sanitisedSummaries = $b09eae22f5f1e6ca$var$splitSummary(summary); // the warning when summary has reached max length, should not block submit
        return (!$b09eae22f5f1e6ca$export$3100ac1da5e98644(validationError) || summary.length === (0, $7462c685f739ed5a$export$193356664cd84c83)) && sanitisedSummaries.length === 1;
    }
    reset() {
        this.setState({
            summary: '',
            validationError: (0, $3FdYO.emptyValidationError)
        });
    }
    render() {
        const { placeholderText: placeholderText, appearance: appearance, selectedIssueType: selectedIssueType, intl: { formatMessage: formatMessage } } = this.props;
        let ariaLabel;
        if (selectedIssueType) ariaLabel = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iQa4Q.default).ariaLabelSelectedTypeIssueTermRefresh : (0, $iQa4Q.default).ariaLabelSelectedType, {
            value: selectedIssueType
        });
        else ariaLabel = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iQa4Q.default).ariaLabelIssueTermRefresh : (0, $iQa4Q.default).ariaLabel);
        const accessibilityProps = {
            'aria-label': ariaLabel,
            'aria-required': true,
            'aria-invalid': !this.isValid()
        };
        const accessibilityMessage = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iQa4Q.default).issueWithNameCreatedSuccessfullyIssueTermRefresh : (0, $iQa4Q.default).issueWithNameCreatedSuccessfully, {
            name: this.state.ariaLive
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
            "aria-live": "assertive",
            id: "inline-card-create.form.summary.a11y.aria-live",
            "data-testid": "platform-inline-card-create.ui.form.summary.aria-live"
        }, this.state.ariaLive && accessibilityMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("textarea", {
            ref: this.textAreaRef,
            "data-testid": "platform-inline-card-create.ui.form.summary.styled-text-area",
            placeholder: placeholderText || formatMessage((0, $iQa4Q.default).prompt),
            value: this.state.summary,
            onChange: this.onChangeSummary,
            onKeyDown: this.onKeyDown,
            onKeyUp: this.onKeyUp,
            rows: appearance === (0, $7462c685f739ed5a$export$3789e4b2a10baa2b) ? 2 : 1,
            maxLength: (0, $7462c685f739ed5a$export$193356664cd84c83),
            tabIndex: 0,
            "aria-controls": "inline-card-create.form.summary.a11y.aria-live",
            ...accessibilityProps,
            className: (0, $bwpsq.default)([
                "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4t3i1jfw _1bsb1osq _14zgglyw _bfhkvuon _syaz1fxt _11c81oud _1idr1wmz _1wfakb7n",
                appearance !== (0, $7462c685f739ed5a$export$3789e4b2a10baa2b) && "_4t3iv47k _o572qvpr _1fjgglyw _4pckglyw _1cicglyw"
            ])
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            summary: this.props.initialSummary,
            validationError: $b09eae22f5f1e6ca$export$1b7a903b2450d74d(this.props.initialSummary, this.props.intl),
            ariaLive: ''
        } // For the cursor to be move to the end when the component remount, the textarea has to have focus first,
        ;
        this.textAreaRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
        this.onChangeSummary = (event)=>{
            const { onChangeSummary: onChangeSummary, intl: intl } = this.props;
            const summary = $b09eae22f5f1e6ca$export$ad399be9aa35d90a(event.target.value);
            const displayedSummary = event.target.value.replace(/[\n\r]+/g, ' ');
            const validationError = $b09eae22f5f1e6ca$export$1b7a903b2450d74d(summary, intl);
            onChangeSummary({
                summary: summary,
                validationError: validationError
            });
            this.setState({
                summary: displayedSummary,
                validationError: validationError,
                ariaLive: ''
            });
        };
        this.onKeyDown = (event)=>{
            event.stopPropagation();
            const { onSubmit: onSubmit } = this.props; // RTL tests cannot send event ASCII code but only the actual string `Enter` or `Escape`
            // ref: https://github.com/testing-library/user-event/blob/main/src/keyboard/keyMap.ts#L60C24-L60C35
            if (event.key === 'Enter' && !event.nativeEvent.isComposing) {
                event.preventDefault();
                if (this.shouldSummarySubmit()) {
                    (0, $eTXmK.default)('inline-card-create-submit', event.timeStamp);
                    onSubmit();
                    this.setState({
                        ariaLive: this.state.summary
                    });
                }
            }
        };
        this.onKeyUp = (event)=>{
            event.stopPropagation();
            const { onCancel: onCancel, setFocusOnTrigger: setFocusOnTrigger } = this.props; // nativeEvent isComposing check is here to prevent ICC from closing when IMEs are open
            // When an IME is open, pressing Escape should close the IME, but ICC should remain open
            if (event.key === 'Escape' && !event.nativeEvent.isComposing) {
                setFocusOnTrigger();
                return onCancel();
            }
        };
        this.isValid = ()=>{
            const { summary: summary, summaryConcat: summaryConcat } = this.state.validationError;
            return summary === '' && summaryConcat === '';
        };
    }
}
var $b09eae22f5f1e6ca$export$2e2bcd8739ae039 = (0, $2OMDV.AnalyticsEventToProps)('ICC-summary', {
    onSubmit: 'onSubmitSummary',
    onCancel: 'onCancelSummary'
})((0, $az4zD.injectIntlV2)($b09eae22f5f1e6ca$export$46453a0401d6cd1a));

});
parcelRegister("dqoiX", function(module, exports) {

$parcel$export(module.exports, "visuallyHiddenStyles", () => $11827e0613b04108$export$8dd524ceb40e3d16);
$parcel$export(module.exports, "ScreenReaderText", () => $11827e0613b04108$export$88fad6aa294f111c);
$parcel$export(module.exports, "ScreenReaderCaption", () => $11827e0613b04108$export$200c8e5d652aa9af);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ /**
 * Visible only to screenreaders. Use when there is a need
 * to provide more context to a non-sighted user.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $11827e0613b04108$export$8dd524ceb40e3d16 = {
    clip: 'rect(1px, 1px, 1px, 1px)',
    clipPath: 'inset(50%)',
    height: '1px',
    width: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute'
};
const $11827e0613b04108$export$88fad6aa294f111c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
            __cmplp.className
        ])
    });
});
const $11827e0613b04108$export$200c8e5d652aa9af = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iQa4Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b047ff7079bd97d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7b047ff7079bd97d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    prompt: {
        "id": "inline-card-create.form.summary.prompt",
        "defaultMessage": "What needs to be done?"
    },
    maxLength: {
        "id": "inline-card-create.form.summary.max-length",
        "defaultMessage": "The issue summary must be less than or equal to 255 characters."
    },
    maxLengthMultiple: {
        "id": "inline-card-create.form.summary.max-length-multiple",
        "defaultMessage": "The summary of every issue must be less than or equal to 255 characters."
    },
    issueWithNameCreatedSuccessfully: {
        "id": "inline-card-create.form.summary.issue-with-name-created-successfully",
        "defaultMessage": "Issue {name} created successfully"
    },
    ariaLabel: {
        "id": "inline-card-create.form.summary.aria-label",
        "defaultMessage": "Add your issue summary and then press Enter to submit. Use the Escape key to cancel."
    },
    ariaLabelSelectedType: {
        "id": "inline-card-create.form.summary.aria-label-selected-type",
        "defaultMessage": "{value} selected. Add your issue summary and then press Enter to submit. Use the Escape key to cancel."
    },
    maxLengthIssueTermRefresh: {
        "id": "inline-card-create.form.summary.max-length-issue-term-refresh",
        "defaultMessage": "The issue summary must be less than or equal to 255 characters."
    },
    maxLengthMultipleIssueTermRefresh: {
        "id": "inline-card-create.form.summary.max-length-multiple-issue-term-refresh",
        "defaultMessage": "The summary of every issue must be less than or equal to 255 characters."
    },
    issueWithNameCreatedSuccessfullyIssueTermRefresh: {
        "id": "inline-card-create.form.summary.issue-with-name-created-successfully-issue-term-refresh",
        "defaultMessage": "Issue {name} created successfully"
    },
    ariaLabelIssueTermRefresh: {
        "id": "inline-card-create.form.summary.aria-label-issue-term-refresh",
        "defaultMessage": "Add your issue summary and then press Enter to submit. Use the Escape key to cancel."
    },
    ariaLabelSelectedTypeIssueTermRefresh: {
        "id": "inline-card-create.form.summary.aria-label-selected-type-issue-term-refresh",
        "defaultMessage": "{value} selected. Add your issue summary and then press Enter to submit. Use the Escape key to cancel."
    }
});

});


parcelRegister("h1sEN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5ada8b7065598a5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $gccSB = parcelRequire("gccSB");

var $gZL7V = parcelRequire("gZL7V");

var $fVnbM = parcelRequire("fVnbM");

var $eCeGD = parcelRequire("eCeGD");

var $6Ingq = parcelRequire("6Ingq");

var $6Pmud = parcelRequire("6Pmud");

var $hORKG = parcelRequire("hORKG");

var $jj3Gi = parcelRequire("jj3Gi");

var $1wCbV = parcelRequire("1wCbV");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");
var $b9dFI = parcelRequire("b9dFI");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");


var $cjDfJ = parcelRequire("cjDfJ");

var $2ehBu = parcelRequire("2ehBu");
const $d5ada8b7065598a5$var$ANALYTICS_SUBJECT = 'iccTypeSelect'; // NOTE: Compiled/css rules needs to be defined at the top of the component (Otherwise Cypress tests failing)
// ----------------------------------------------------------------------------------------------------------
// kept here the negative margins from the original dropdown component but ideally these shouldn't exist
const $d5ada8b7065598a5$var$containerStyles = null;
const $d5ada8b7065598a5$var$optionWrapperStyles = null;
const $d5ada8b7065598a5$var$triggerContentStylesOld = null;
const $d5ada8b7065598a5$var$singValueContainerStyles = null;
const $d5ada8b7065598a5$var$extraLinksGroupStyles = null;
const $d5ada8b7065598a5$var$optionContentStyles = null;
const $d5ada8b7065598a5$var$Option = ({ children: children, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)(); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { cardType: cardType, renderAdditionalContent: renderAdditionalContent } = props.data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "platform-inline-card-create.ui.form.type-select.option",
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o"
        ])
    }, !!cardType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ehBu.default), {
        styles: {
            marginRight: "var(--ds-space-100, 8px)"
        },
        cardType: cardType
    }), !cardType && (0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d5ada8b7065598a5$var$manageTypesIconContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1wCbV))), {
        label: formatMessage((0, $cjDfJ.default).manageTypes),
        color: "var(--ds-icon, #44546F)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug"
        ])
    }, children), !!cardType && !!renderAdditionalContent && renderAdditionalContent(cardType)));
};
const $d5ada8b7065598a5$var$Group = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_x3dope8f _19pk1b66 _ca0q1b66"
        ])
    }, children);
const $d5ada8b7065598a5$var$COMPONENTS_OLD = {
    Option: $d5ada8b7065598a5$var$Option,
    Group: $d5ada8b7065598a5$var$Group
};
const $d5ada8b7065598a5$var$COMPONENTS = {
    Option: $d5ada8b7065598a5$var$Option
};
const $d5ada8b7065598a5$var$makeOption = (cardType, renderAdditionalContent)=>({
        label: cardType.name,
        value: cardType.id,
        cardType: cardType,
        optionType: 'card',
        renderAdditionalContent: renderAdditionalContent
    });
const $d5ada8b7065598a5$var$TypeSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ cardTypes: cardTypes, selectedCardTypeId: selectedCardTypeId, extraItems: extraItems, shouldRenderToParent: shouldRenderToParent = false, onSelectCardType: onSelectCardType, renderAdditionalOptionContent: renderAdditionalOptionContent }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isDefaultItem = cardTypes[0]?.id === selectedCardTypeId;
    const value = (0, $5uXOq.useMemo)(()=>{
        const selectedType = cardTypes.find((type)=>type.id === selectedCardTypeId);
        return selectedType ? $d5ada8b7065598a5$var$makeOption(selectedType, renderAdditionalOptionContent) : null;
    }, [
        cardTypes,
        selectedCardTypeId,
        renderAdditionalOptionContent
    ]);
    const options = (0, $5uXOq.useMemo)(()=>{
        const result = cardTypes.filter((type)=>type.id !== selectedCardTypeId).map((type)=>$d5ada8b7065598a5$var$makeOption(type, renderAdditionalOptionContent)); // add extra links if there are any
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(extraItems)) {
            let message;
            if ((0, $dCm1o.isVisualRefreshEnabled)()) message = (0, $cjDfJ.default).manageTypes;
            else message = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cjDfJ.default).manageIssueTypesIssueTermRefresh : (0, $cjDfJ.default).manageIssueTypes;
            const linkOptions = extraItems.map((item)=>({
                    label: item.name != null ? item.name : formatMessage(message),
                    value: item.url,
                    url: item.url,
                    onItemSelect: item.onItemSelect,
                    openNewTab: item.openNewTab ?? false,
                    optionType: 'link'
                })); // if there are no other options, or if visual-refresh is enabled, add them flat
            if ((0, $dCm1o.isVisualRefreshEnabled)() || !result.length) result.push(...linkOptions);
            else // if there are other options already, group the extra links in a new section
            result.push({
                options: linkOptions,
                optionType: 'links'
            });
        }
        return result;
    }, [
        cardTypes,
        extraItems,
        formatMessage,
        renderAdditionalOptionContent,
        selectedCardTypeId
    ]);
    const isOptionDisabled = (0, $5uXOq.useCallback)((option)=>option.optionType === 'card' && option.cardType.isDisabled === true, []);
    const trigger = (0, $5uXOq.useCallback)(({ isOpen: isOpen, ...triggerProps })=>{
        const triggerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: value?.label ?? null,
            delay: (0, $7462c685f739ed5a$export$f9e3e7ede9ba929d),
            hideTooltipOnClick: true
        }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            ...triggerProps,
            appearance: "subtle",
            isSelected: isOpen,
            "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cjDfJ.default).ariaLabelIssueTermRefresh : (0, $cjDfJ.default).ariaLabel, {
                value: value?.label ?? formatMessage((0, $cjDfJ.default).invalid)
            }),
            testId: "platform-inline-card-create.ui.form.type-select.trigger",
            spacing: "compact"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center",
            justifyContent: "center",
            gap: "space.075",
            xcss: $d5ada8b7065598a5$var$triggerContentStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ehBu.default), {
            cardType: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(value, 'cardType')
        }), isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jj3Gi))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_18u0r5cr _2hwxr5cr"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...triggerProps,
            appearance: "subtle",
            spacing: "none",
            isSelected: isOpen,
            "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cjDfJ.default).ariaLabelIssueTermRefresh : (0, $cjDfJ.default).ariaLabel, {
                value: value?.label ?? formatMessage((0, $cjDfJ.default).invalid)
            }),
            testId: "platform-inline-card-create.ui.form.type-select.trigger"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_1e0c1txw _4cvr1h6o _18u01b66"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ehBu.default), {
            cardType: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(value, 'cardType')
        }), isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Pmud))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))), {
            label: ""
        })))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $d5ada8b7065598a5$var$typeContainerStyles
        }, triggerContent);
    }, [
        formatMessage,
        value
    ]);
    const onChange = (0, $5uXOq.useCallback)((option)=>{
        if (option && 'cardType' in option && option.cardType != null) {
            onSelectCardType(option.cardType.id);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'selectedType',
                actionSubject: $d5ada8b7065598a5$var$ANALYTICS_SUBJECT
            }), {
                issueTypesCount: cardTypes.length
            });
        }
        if (option && 'url' in option && option.url != null) {
            if (option.openNewTab === true) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(option.url, '_blank');
            else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.href = option.url;
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'selectedExtraItem',
                actionSubject: $d5ada8b7065598a5$var$ANALYTICS_SUBJECT
            }), {
                issueTypesCount: cardTypes.length
            });
        }
        if (option && 'onItemSelect' in option && option.onItemSelect) option.onItemSelect();
    }, [
        cardTypes.length,
        createAnalyticsEvent,
        onSelectCardType
    ]);
    const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'opened',
            actionSubject: $d5ada8b7065598a5$var$ANALYTICS_SUBJECT
        }), {
            isDefaultItem: isDefaultItem
        });
    }, [
        createAnalyticsEvent,
        isDefaultItem
    ]);
    const setRefNode = (0, $5uXOq.useCallback)((popupSelectRef)=>{
        ref && popupSelectRef && (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(ref, 'current.node', popupSelectRef);
    }, [
        ref
    ]);
    if (cardTypes.length === 1 && (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(extraItems)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: value?.label ?? null,
        delay: (0, $7462c685f739ed5a$export$f9e3e7ede9ba929d)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_18u0r5cr _2hwxr5cr",
            "_1e0c116y _4cvr1h6o _1yt41b66"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ehBu.default), {
        cardType: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(value, 'cardType')
    })));
     // to render popup next to the trigger element to achieve DOM order
    const popupStrategy = shouldRenderToParent ? 'fixed' : 'absolute';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9dFI.default // @ts-expect-error — Type 'T | null' is not assignable to type 'PopupSelect<SelectOption, false, ModifierList>'
    ), {
        ref: setRefNode,
        components: (0, $dCm1o.isVisualRefreshEnabled)() ? $d5ada8b7065598a5$var$COMPONENTS : $d5ada8b7065598a5$var$COMPONENTS_OLD,
        target: trigger,
        options: options,
        isOptionDisabled: isOptionDisabled,
        value: value,
        onChange: onChange,
        onMenuOpen: onMenuOpen,
        isSearchable: false,
        searchThreshold: Number.MAX_SAFE_INTEGER,
        minMenuWidth: "auto",
        classNamePrefix: "inline-card-create-type-select",
        testId: "platform-inline-card-create.ui.form.type-select.type-select",
        popperProps: {
            strategy: popupStrategy
        }
    });
});
const $d5ada8b7065598a5$var$typeContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexShrink: 0
});
const $d5ada8b7065598a5$var$triggerContentStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.025'
});
const $d5ada8b7065598a5$var$manageTypesIconContainer = (0, $8CUq3.xcss)({
    paddingInline: 'space.025',
    marginRight: 'space.100'
});
var $d5ada8b7065598a5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($d5ada8b7065598a5$var$TypeSelect);

});
parcelRegister("6Pmud", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f88f2d3e506ed12$var$_react = $4f88f2d3e506ed12$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4f88f2d3e506ed12$var$_chevronUp = $4f88f2d3e506ed12$var$_interopRequireDefault((parcelRequire("jj3Gi")));
function $4f88f2d3e506ed12$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f88f2d3e506ed12$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $4f88f2d3e506ed12$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
    }, props, {
        newIcon: $4f88f2d3e506ed12$var$_chevronUp.default,
        iconType: "utility"
    }));
$4f88f2d3e506ed12$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $4f88f2d3e506ed12$var$_default = module.exports.default = $4f88f2d3e506ed12$var$ChevronUpIcon;

});

parcelRegister("1wCbV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5b544bb8861995e91922f92ab112b41>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $11c6679f8b16b181$var$_react = $11c6679f8b16b181$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $11c6679f8b16b181$var$_UNSAFE_baseNew = $11c6679f8b16b181$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $11c6679f8b16b181$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShowMoreHorizontal".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for secondary/tertiary more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $11c6679f8b16b181$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $11c6679f8b16b181$var$_react.default.createElement($11c6679f8b16b181$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.5 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m4.75 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-9.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M6.5 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.75 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-9.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`,
        type: 'utility'
    }, props));
$11c6679f8b16b181$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $11c6679f8b16b181$var$_default = module.exports.default = $11c6679f8b16b181$var$ShowMoreHorizontalIcon;

});

parcelRegister("cjDfJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $98179f22ec008310$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $98179f22ec008310$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    ariaLabel: {
        "id": "inline-card-create.form.type-select.aria-label",
        "defaultMessage": "The current issue type is {value}. Press the 'Space' key to change the issue type."
    },
    invalid: {
        "id": "inline-card-create.form.type-select.invalid",
        "defaultMessage": "invalid"
    },
    // Delete this message when cleaning up visual-refresh FG
    manageIssueTypes: {
        "id": "inline-card-create.form.type-select.manage-issue-types",
        "defaultMessage": "Manage issue types"
    },
    manageTypes: {
        "id": "inline-card-create.form.type-select.manage-types",
        "defaultMessage": "Manage types"
    },
    addIssueType: {
        "id": "inline-card-create.form.type-select.add-issue-type",
        "defaultMessage": "Add issue type"
    },
    ariaLabelIssueTermRefresh: {
        "id": "inline-card-create.form.type-select.aria-label-issue-term-refresh",
        "defaultMessage": "The current issue type is {value}. Press the 'Space' key to change the issue type."
    },
    manageIssueTypesIssueTermRefresh: {
        "id": "inline-card-create.form.type-select.manage-issue-types-issue-term-refresh",
        "defaultMessage": "Manage issue types"
    },
    addIssueTypeIssueTermRefresh: {
        "id": "inline-card-create.form.type-select.add-issue-type-issue-term-refresh",
        "defaultMessage": "Add issue type"
    }
});

});

parcelRegister("2ehBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9af3d59273fe1f1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ /* eslint-disable jira/react/no-style-attribute */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $f9af3d59273fe1f1$export$9fbe3594a958ae08 = '/icons/issuetypes/genericissue.svg';
const $f9af3d59273fe1f1$var$cardTypeImageStyles = null;
const $f9af3d59273fe1f1$var$TypeIcon = ({ cardType: cardType, styles: styles, className: className })=>cardType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: cardType.iconUrl,
        alt: cardType.name,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_4t3i7vkz _1bsb7vkz",
            className
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: styles
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        alt: "",
        src: $f9af3d59273fe1f1$export$9fbe3594a958ae08,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_4t3i7vkz _1bsb7vkz",
            className
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: styles
    });
var $f9af3d59273fe1f1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($f9af3d59273fe1f1$var$TypeIcon);

});




parcelRegister("l94uE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9719a5afff7fc59d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $6s1PB = parcelRequire("6s1PB");

var $az4zD = parcelRequire("az4zD");

var $2OMDV = parcelRequire("2OMDV");


var $gBq9h = parcelRequire("gBq9h");

var $egFHr = parcelRequire("egFHr");

var $5Qqfj = parcelRequire("5Qqfj");
function $9719a5afff7fc59d$export$41fb9f06171c75f4({ isDisabled: isDisabled, triggerAppearance: triggerAppearance, isSticky: isSticky, label: label, ariaLabelledBy: ariaLabelledBy, onClick: onClick, intl: { formatMessage: formatMessage }, isModalTrigger: isModalTrigger, shouldFocusTrigger: shouldFocusTrigger = false }) {
    const defaultLabel = label || formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $egFHr.default).labelIssueTermRefresh : (0, $egFHr.default).label);
    if (triggerAppearance === (0, $7462c685f739ed5a$export$dda6912361cddac9)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Qqfj.default), {
        isModalTrigger: isModalTrigger,
        isSticky: isSticky,
        label: defaultLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        isDisabled: isDisabled,
        shouldFocusTrigger: shouldFocusTrigger
    });
    if (isDisabled !== true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gBq9h.default), {
        label: defaultLabel,
        onClick: onClick,
        shouldFocusTrigger: shouldFocusTrigger
    });
    return null;
}
$9719a5afff7fc59d$export$41fb9f06171c75f4.defaultProps = {
    isDisabled: false,
    isSticky: false,
    triggerAppearance: (0, $7462c685f739ed5a$export$dda6912361cddac9),
    label: '',
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    shouldFocusTrigger: false
};
var $9719a5afff7fc59d$export$2e2bcd8739ae039 = (0, $2OMDV.AnalyticsEventToProps)('button', {
    onClick: 'clicked'
})((0, $az4zD.injectIntlV2)($9719a5afff7fc59d$export$41fb9f06171c75f4));

});
parcelRegister("egFHr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f56794831a7b04b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0f56794831a7b04b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "inline-card-create.trigger.label",
        "defaultMessage": "Create issue"
    },
    labelIssueTermRefresh: {
        "id": "inline-card-create.trigger.label-issue-term-refresh",
        "defaultMessage": "Create issue"
    }
});

});

parcelRegister("5Qqfj", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd137c52878495bb$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");

var $99M5v = parcelRequire("99M5v");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $iKdRC = parcelRequire("iKdRC");
const $cd137c52878495bb$var$labelWrapperStyles = null;
const $cd137c52878495bb$var$contentWrapperStyles = null;
const $cd137c52878495bb$export$305831e851c35a16 = ({ isDisabled: isDisabled = false, isSticky: isSticky = false, label: label, ariaLabelledBy: ariaLabelledBy, onClick: onClick, isModalTrigger: isModalTrigger, shouldFocusTrigger: shouldFocusTrigger = false })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const iccButtonTheme = (currentTheme, props)=>{
        const themeProps = {
            ...props
        };
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                marginTop: "var(--ds-space-025, 2px)",
                marginBottom: "var(--ds-space-025, 2px)",
                height: `${(0, $gwIPs.gridSize) * 4.5}px`,
                alignItems: 'center'
            },
            spinnerStyles: spinnerStyles
        };
    };
    const iconColor = isDisabled ? `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$exports).N70})` : `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N500})`;
    const shouldShowTooltip = label.length > 16;
    const renderStickyContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, $bwpsq.default)([
                "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1e5h"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
            testId: "platform-inline-card-create.ui.trigger.visible.add-icon",
            label: "",
            color: iconColor,
            LEGACY_size: "small"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_1e0c1ule _18u01b66 _1reo15vq _1wnr15vq"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $cd137c52878495bb$var$labelContextStyles,
            as: "span"
        }, label)));
    const ButtonComponent = isModalTrigger ? (0, $iKdRC.ModalTriggerButton) : (0, $9yOBd.default);
    const renderButtonComponent = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
            ...triggerProps,
            iconBefore: isSticky ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
                testId: "platform-inline-card-create.ui.trigger.visible.add-icon",
                label: "",
                color: iconColor,
                LEGACY_size: "small"
            }),
            appearance: "subtle",
            theme: iccButtonTheme,
            shouldFitContainer: true,
            onClick: onClick,
            isDisabled: isDisabled,
            testId: "platform-inline-card-create.ui.trigger.visible.button",
            "aria-labelledby": ariaLabelledBy,
            "aria-label": label,
            autoFocus: shouldFocusTrigger
        }, isSticky ? renderStickyContent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $cd137c52878495bb$var$labelContextStyles,
            as: "span"
        }, label));
    return shouldShowTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label,
        tag: "span"
    }, renderButtonComponent) : renderButtonComponent();
};
const $cd137c52878495bb$var$labelContextStyles = (0, $8CUq3.xcss)({
    display: 'block',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    overflowX: 'hidden'
});
var $cd137c52878495bb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($cd137c52878495bb$export$305831e851c35a16);

});
parcelRegister("99M5v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45e9dbc5862bfe91f01c54aec1c8b1e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6aaa418e9a366cd8$var$_react = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6aaa418e9a366cd8$var$_add = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("dZbEw")));

var $6aaa418e9a366cd8$var$_add2 = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("7ymNM")));
function $6aaa418e9a366cd8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "AddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6aaa418e9a366cd8$var$AddIcon = (props)=>/*#__PURE__*/ $6aaa418e9a366cd8$var$_react.default.createElement($6aaa418e9a366cd8$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $6aaa418e9a366cd8$var$_add2.default
    }, props));
$6aaa418e9a366cd8$var$AddIcon.Name = 'AddIconMigration';
var $6aaa418e9a366cd8$var$_default = module.exports.default = $6aaa418e9a366cd8$var$AddIcon;

});

parcelRegister("iKdRC", function(module, exports) {

$parcel$export(module.exports, "ModalTriggerButton", () => $dd7ef71db2053b80$export$f69d15d2f52857d);

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");
var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $lu5k0 = parcelRequire("lu5k0");
const $dd7ef71db2053b80$export$f69d15d2f52857d = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const internalRef = (0, $5uXOq.useRef)(null);
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const handleRef = (0, $5uXOq.useCallback)((element)=>{
        if (ref) {
            if (typeof ref === 'function') ref(element);
            else {
                // We need to proxy ref to avoid an eslint error (no-param-reassign)
                const mutableRef = ref;
                mutableRef.current = element;
            }
        }
        internalRef.current = element;
    }, [
        ref
    ]);
    const isIconProp = 'icon' in props;
    const onClickHandler = !isIconProp ? props.onClick : undefined;
    const iconButtonOnClickHandler = isIconProp ? props.onClick : undefined;
    const onClick = (0, $5uXOq.useCallback)((...args)=>{
        if (!isIconProp) {
            onClickHandler?.(...args);
            setReturnFocusTo(internalRef);
        }
    }, [
        isIconProp,
        setReturnFocusTo,
        internalRef,
        onClickHandler
    ]);
    const onIconButtonClick = (0, $5uXOq.useCallback)((...args)=>{
        if (isIconProp) {
            iconButtonOnClickHandler?.(...args);
            setReturnFocusTo(internalRef);
        }
    }, [
        isIconProp,
        setReturnFocusTo,
        internalRef,
        iconButtonOnClickHandler
    ]);
    if ('icon' in props) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...props,
        ref: handleRef,
        onClick: onIconButtonClick
    });
    if ('theme' in props) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        ...props,
        ref: handleRef,
        onClick: onClick
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ...props,
        ref: handleRef,
        onClick: onClick
    });
});

});




parcelRegister("cVImo", function(module, exports) {

$parcel$export(module.exports, "HiddenButtonWrapper", () => $0f59c12b565bfb9d$export$d0ba86f106688d98);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $dZbEw = parcelRequire("dZbEw");

var $7ymNM = parcelRequire("7ymNM");


var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");

var $645AZ = parcelRequire("645AZ");

var $g503o = parcelRequire("g503o");
const $0f59c12b565bfb9d$var$withToolTip = (component, message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f59c12b565bfb9d$var$StyledButton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: message,
        position: "bottom"
    }, component));
class $0f59c12b565bfb9d$export$d22c1bb6554a6b47 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            appearance: 'button'
        };
    }
    render() {
        const { appearance: appearance } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            id: "platform-board.create-button-text.icon-label-v2",
            defaultMessage: "Create issue"
        }, (formattedMessage)=>{
            const message = typeof formattedMessage[0] === 'string' ? formattedMessage[0] : 'Create issue';
            const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f59c12b565bfb9d$var$CreateButton, {
                onClick: this.props.onClick
            }, (0, $4R6GH.fg)('tnk-1614-visual-refresh-boardkit-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                label: message,
                color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N500})`,
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7ymNM))),
                LEGACY_size: "small",
                LEGACY_primaryColor: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N500})`
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ymNM))), {
                label: message,
                size: "small",
                primaryColor: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N500})`
            }));
            if (appearance === 'hidden-button') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f59c12b565bfb9d$export$d0ba86f106688d98, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f59c12b565bfb9d$var$ButtonWrapper, null, button));
            return $0f59c12b565bfb9d$var$withToolTip(button, String(message));
        });
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $0f59c12b565bfb9d$var$CreateButtonControl = /*#__PURE__*/ (0, $47bDC.default).button.withConfig({
    componentId: "sc-18h94vo-0"
})((props)=>({
        backgroundColor: 'transparent',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${(0, $gwIPs.gridSize) / 2}px`,
        border: 'none',
        width: '100%',
        padding: `${"var(--ds-space-050, 4px)"} 0`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $gwIPs.gridSize) * 3}px`,
        cursor: 'pointer',
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor: `var(--ds-background-neutral-hovered, ${props.theme.btnHover || (0, $829f609a65d26a98$exports).N40})`
        },
        '&:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B200})`}`,
            outline: 'none'
        }
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0f59c12b565bfb9d$var$CreateButtonExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhk18uv _2rko1y44 _19itglyw _1bsb1osq _1yt4swc3 _4t3i1tcg _80omtlke _7ehi1vt6 _nt751r31 _49pcglyw _1hvw1o36 _irr3hkel",
            __cmplp.className
        ])
    });
});
const $0f59c12b565bfb9d$var$CreateButton = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $0f59c12b565bfb9d$var$CreateButtonExperiment, $0f59c12b565bfb9d$var$CreateButtonControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0f59c12b565bfb9d$var$StyledButtonControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-18h94vo-1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginTop: `${(0, $645AZ.layout).smallGutter}px`
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0f59c12b565bfb9d$var$StyledButtonExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk14y2",
            __cmplp.className
        ])
    });
});
const $0f59c12b565bfb9d$var$StyledButton = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $0f59c12b565bfb9d$var$StyledButtonExperiment, $0f59c12b565bfb9d$var$StyledButtonControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0f59c12b565bfb9d$var$ButtonWrapperControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-18h94vo-2"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginTop: `${(0, $645AZ.layout).smallGutter}px`
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0f59c12b565bfb9d$var$ButtonWrapperExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk14y2",
            __cmplp.className
        ])
    });
});
const $0f59c12b565bfb9d$var$ButtonWrapper = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $0f59c12b565bfb9d$var$ButtonWrapperExperiment, $0f59c12b565bfb9d$var$ButtonWrapperControl); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0f59c12b565bfb9d$var$HiddenButtonWrapperControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-18h94vo-3"
})`opacity:${(props)=>props.isICCFormOpen ? 1 : 0};&:hover,&:focus,&:focus-within{opacity:1;}${(0, $g503o.ColumnWrapperControl)}:hover &{opacity:1;}${(0, $g503o.ColumnWrapperControl)}:focus &{opacity:1;}${(0, $g503o.ColumnWrapperControl)}:focus-within &{opacity:1;}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0f59c12b565bfb9d$var$HiddenButtonWrapperExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isICCFormOpen: isICCFormOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ep9kb7n _t7oxkb7n _173kkb7n _1h7hkb7n _1mygkb7n _16l4kb7n",
            __cmplp.isICCFormOpen ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0f59c12b565bfb9d$export$d0ba86f106688d98 = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $0f59c12b565bfb9d$var$HiddenButtonWrapperExperiment, $0f59c12b565bfb9d$var$HiddenButtonWrapperControl);

});



parcelRegister("b6Ykj", function(module, exports) {

$parcel$export(module.exports, "useOnCreate", () => $0cc1261bd7dd1bf5$export$b0b39ca6034d00d8);

var $5uXOq = parcelRequire("5uXOq");

var $7uUwQ = parcelRequire("7uUwQ");

var $9XE6b = parcelRequire("9XE6b");

var $iHPnC = parcelRequire("iHPnC");

var $g4tDr = parcelRequire("g4tDr");

var $2NMNM = parcelRequire("2NMNM");



var $iuuJH = parcelRequire("iuuJH");

var $c79wa = parcelRequire("c79wa");

var $bwTbl = parcelRequire("bwTbl");

var $cvIZ8 = parcelRequire("cvIZ8");

var $67sX6 = parcelRequire("67sX6");

var $2f454 = parcelRequire("2f454");

var $blI7M = parcelRequire("blI7M");

var $ls4NM = parcelRequire("ls4NM");

var $gXFr2 = parcelRequire("gXFr2");

var $fyeGd = parcelRequire("fyeGd");

var $9UXXB = parcelRequire("9UXXB");

var $3ZtL7 = parcelRequire("3ZtL7");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $5mTgl = parcelRequire("5mTgl");

var $fwQRP = parcelRequire("fwQRP");
const $0cc1261bd7dd1bf5$var$emptyObj = (0, $7uUwQ.freeze)({});
const $0cc1261bd7dd1bf5$export$b0b39ca6034d00d8 = ({ cardIndex: cardIndex, cardTypes: cardTypes, columnId: columnId, insertBefore: insertBefore, projectId: projectIdArg, swimlaneId: swimlaneId, groupParentId: groupParentId, isLastSwimlane: isLastSwimlane, isUnscheduledColumn: isUnscheduledColumn })=>{
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isIPBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
    const programBoardEstimateFieldId = (0, $67sX6.useBoardSelector)((0, $67Z81.getIncrementPlanningEstimateFieldId));
    const getSwimlaneValues = (0, $67sX6.useBoardSelector)((0, $4jZ56.makeSwimlaneValuesSelector));
    const inlineCreateSessionId = (0, $67sX6.useBoardSelector)((0, $9UXXB.getInlineCreateSessionId));
    const getInitialTransitionsForColumn = (0, $67sX6.useBoardSelector)((0, $gXFr2.getInitialTransitionsForColumn));
    const config = (0, $67sX6.useBoardSelector)((0, $9UXXB.getInlineCardCreateConfig));
    const getParentId = (0, $67sX6.useBoardSelector)((0, $gXFr2.getParentIdForIssueCreation));
    const assigneeAccountId = (0, $67sX6.useBoardSelector)((0, $3ZtL7.getAssigneeId));
    const getStatusIdsByColumnId = (0, $67sX6.useBoardSelector)((0, $fyeGd.getStatusIdsByColumnId));
    const scenarioColor = (0, $67sX6.useBoardSelector)((0, $67Z81.getScenarioColor));
    const labels = (0, $67sX6.useBoardSelector)((0, $3ZtL7.getAppliedLabelFilters));
    const lastFilteredSprintId = (0, $67sX6.useBoardSelector)((0, $3ZtL7.getLastFilteredSprintId));
    const columnStatusMapping = (0, $67sX6.useBoardSelector)((0, $fyeGd.columnStatusMappingSelector));
    const columnIndex = (0, $67sX6.useBoardSelector)((state)=>(0, $fyeGd.getColumnIndex)(state, columnId));
    const getCardDndType = (0, $67sX6.useBoardSelector)((0, $5mTgl.getCardDndType));
    const missingParents = (0, $67sX6.useBoardSelector)((0, $67Z81.getMissingParents));
    const swimlaneMode = (0, $67sX6.useBoardSelector)((0, $45cXl.getSwimlaneMode));
    const activeSprints = (0, $67sX6.useBoardSelector)((0, $ebHh7.activeSprintsSelector));
    const onCreate = (0, $5uXOq.useCallback)(// TODO-BOARD-REFACTOR-TYPES
    // @ts-expect-error inconsistent first argument
    (partialIssues)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'created'
        });
        let swimlaneFields = $0cc1261bd7dd1bf5$var$emptyObj;
        const swimlaneValues = swimlaneId ? getSwimlaneValues(swimlaneId) : null;
        const parentId = getParentId(projectIdArg);
        const cardDndType = groupParentId ? (0, $dcbb2bce513725b3$export$1f24f91824c6822f) : getCardDndType(isLastSwimlane);
        const isSubtaskMissingParent = groupParentId ? !!missingParents[groupParentId] : false;
        if (swimlaneValues && swimlaneValues.type === (0, $c79wa.ASSIGNEE)) swimlaneFields = (0, $bwTbl.getIssueAssignee)(swimlaneValues);
        // parent is epic
        if (swimlaneValues && swimlaneValues.type === (0, $c79wa.PARENT)) swimlaneFields = {
            parentId: swimlaneValues.parentId
        };
        // story is subtask
        if (swimlaneValues && swimlaneValues.type === (0, $c79wa.STORY) && swimlaneValues.parentId != null) swimlaneFields = {
            parentId: swimlaneValues.parentId
        };
        // in IP board
        if (swimlaneValues && swimlaneValues.type === (0, $c79wa.TEAM)) swimlaneFields = {
            teamId: swimlaneId
        };
        // Create subtask in issue group. It has to override the swimlane value.
        if (groupParentId) swimlaneFields = {
            ...swimlaneFields,
            parentId: groupParentId
        };
        const { cardType: cardType } = partialIssues[0];
        const cardTypeEntity = cardTypes.find(({ id: id })=>id === cardType);
        const isSubtask = cardTypeEntity?.hierarchyLevelType === (0, $g4tDr.CHILD_HIERARCHY_TYPE);
        let transitionEntity;
        const { transition: transition } = partialIssues[0];
        if (cardTypeEntity) {
            const issueTypeTransitions = !isIPBoard ? getInitialTransitionsForColumn(columnId) : null;
            transitionEntity = issueTypeTransitions?.[cardTypeEntity.id]?.find(({ id: id })=>id === transition);
        }
        let sprintId = '';
        if (activeSprints) {
            if (activeSprints.length === 1) sprintId = activeSprints[0].id.toString();
            else if (activeSprints.length > 1) sprintId = lastFilteredSprintId ?? '';
        }
        if ((0, $fwQRP.isPartialIccMode)(columnId, cardTypeEntity?.id ?? '', config)) {
            const statusIds = !isIPBoard ? getStatusIdsByColumnId(columnId) : undefined;
            dispatch((0, $blI7M.openGlobalIssueCreate)({
                cardSummary: partialIssues[0].summary,
                cardTypeId: Number(cardType),
                rankBeforeCardId: insertBefore || null,
                cardParentId: swimlaneFields.parentId || parentId,
                assigneeId: swimlaneFields.assigneeAccountId || assigneeAccountId,
                isSubtask: isSubtask,
                sessionId: inlineCreateSessionId,
                statusId: transitionEntity?.destinationStatusId || statusIds?.[0],
                ...sprintId ? {
                    sprintId: sprintId
                } : {},
                ...swimlaneId ? {
                    swimlaneId: swimlaneId
                } : {}
            }));
            return;
        }
        const issues = partialIssues.map((item)=>{
            const issueType = cardTypes.filter((c)=>Number(c.id) === Number(item.cardType));
            const issueParentId = (()=>{
                if (isIPBoard && issueType.length > 0 && issueType[0].hierarchyLevelType !== (0, $g4tDr.BASE_HIERARCHY_TYPE)) return null;
                return parentId;
            })();
            const cardColor = isIPBoard ? {
                cardColor: scenarioColor
            } : {};
            const hasScenarioChanges = isIPBoard ? {
                hasScenarioChanges: true
            } : {};
            const color = isIPBoard && issueType.length > 0 && issueType[0].hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE) ? {
                color: (0, $iHPnC.getRandomColor)()
            } : {};
            const projectId = (isIPBoard ? item.projectId : projectIdArg) || 0;
            const estimate = isIPBoard && programBoardEstimateFieldId ? {
                fieldId: programBoardEstimateFieldId,
                type: (0, $b383ed62f6689e0b$export$24c68738fb7a96c7),
                value: ''
            } : null;
            const issue = {
                id: (0, $cvIZ8.generateId)(),
                key: '',
                summary: item.summary,
                columnId: columnId,
                projectId: projectId,
                typeId: Number(item.cardType),
                statusId: 0,
                assigneeAccountId: assigneeAccountId,
                typeName: cardTypeEntity?.name,
                typeUrl: cardTypeEntity?.iconUrl,
                parentId: issueParentId,
                labels: labels,
                isDone: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(columnStatusMapping, [
                    String(columnId),
                    'isDone'
                ], false),
                estimate: estimate,
                priority: null,
                dueDate: null,
                numCompleteChildren: 0,
                numTotalChildren: 0,
                sprintId: sprintId,
                ...cardColor,
                ...hasScenarioChanges,
                ...swimlaneFields,
                ...color
            };
            return issue;
        });
        const issueIds = issues.map((issue)=>issue.id);
        const action = (0, $ls4NM.issueCreateRequest)({
            temporaryIssueIds: issueIds,
            issues: issues,
            insertBefore: insertBefore || null,
            columnIndex: columnIndex,
            cardIndex: cardIndex,
            swimlaneId: swimlaneId,
            type: cardDndType,
            isSubtaskMissingParent: isSubtaskMissingParent,
            analyticsEvent: analyticsEvent.update({
                swimlaneMode: swimlaneMode,
                swimlaneId: swimlaneId,
                sessionId: inlineCreateSessionId
            }),
            transitionInfo: transitionEntity ? {
                transitionId: String(transitionEntity.id),
                statusId: transitionEntity.destinationStatusId
            } : null,
            isSwimlaneByJql: swimlaneMode === (0, $iuuJH.SWIMLANE_BY_JQL).id
        });
        dispatch(action);
        if (isIPBoard && isUnscheduledColumn) dispatch((0, $2f454.closeIccInUnscheduledColumn)());
    }, [
        createAnalyticsEvent,
        swimlaneId,
        getSwimlaneValues,
        getParentId,
        projectIdArg,
        groupParentId,
        getCardDndType,
        isLastSwimlane,
        missingParents,
        cardTypes,
        activeSprints,
        columnId,
        config,
        insertBefore,
        columnIndex,
        cardIndex,
        swimlaneMode,
        dispatch,
        isIPBoard,
        getInitialTransitionsForColumn,
        lastFilteredSprintId,
        getStatusIdsByColumnId,
        assigneeAccountId,
        inlineCreateSessionId,
        scenarioColor,
        programBoardEstimateFieldId,
        labels,
        columnStatusMapping,
        isUnscheduledColumn
    ]);
    return onCreate;
};

});
parcelRegister("cvIZ8", function(module, exports) {

$parcel$export(module.exports, "generateId", () => $76839e08867b356b$export$567fc7097e064344);
// hacky way to generate optimistic issue id, not ideal but have to do it for now
// to react backwards compatibility with current ICC
let $76839e08867b356b$var$lastCardId = 0;
const $76839e08867b356b$export$567fc7097e064344 = ()=>{
    $76839e08867b356b$var$lastCardId -= 1;
    return $76839e08867b356b$var$lastCardId;
};

});

parcelRegister("3ZtL7", function(module, exports) {

$parcel$export(module.exports, "getAssigneeId", () => $b5078a902783c47f$export$5629498a3f321816);
$parcel$export(module.exports, "getAppliedLabelFilters", () => $b5078a902783c47f$export$60ee89f2718fc651);
$parcel$export(module.exports, "getLastFilteredSprintId", () => $b5078a902783c47f$export$1ba531d8735fc55c);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $9XE6b = parcelRequire("9XE6b");

var $hYfgW = parcelRequire("hYfgW");


var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $vAfHD = parcelRequire("vAfHD");

var $d2i8f = parcelRequire("d2i8f");
const $b5078a902783c47f$export$70530ceddeedcded = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getBoardConfig)
], (config)=>config.boardIssueListKey ? {
        issueList: {
            addTo: [
                config.boardIssueListKey
            ]
        }
    } : null);
const $b5078a902783c47f$var$getRankPayloadWithInsertBefore = (0, $dGvGJ.createSelector)([
    (0, $d2i8f.getRankConfig),
    (0, $vAfHD.boardIssuesSelector)
], (rankConfig, allIssues)=>(insertBefore)=>rankConfig.boardIsRankable ? {
            [`customfield_${rankConfig.rankCustomFieldId}`]: {
                rankBeforeIssue: allIssues[String(insertBefore)].key
            }
        } : null);
const $b5078a902783c47f$export$eb06069093b28292 = (state, insertBefore)=>insertBefore ? $b5078a902783c47f$var$getRankPayloadWithInsertBefore(state)(insertBefore) : null;
const $b5078a902783c47f$var$emptyArray = (0, $7uUwQ.freeze)([]);
const $b5078a902783c47f$var$getAppliedAssigneeFilters = (0, $dGvGJ.createSelector)([
    (0, $5mTgl.getWorkFilters)
], (filters)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$f8f7545d2bb78afb)
    ], $b5078a902783c47f$var$emptyArray));
const $b5078a902783c47f$export$a2066b677dcc0c86 = (0, $dGvGJ.createSelector)([
    $b5078a902783c47f$var$getAppliedAssigneeFilters,
    (0, $36pz7.getPeople)
], (assignees, people)=>{
    if (assignees.length > 0) {
        const { id: id } = people[assignees[assignees.length - 1]] || {};
        return id == null ? null : {
            assignee: {
                id: id
            }
        };
    }
    return null;
});
const $b5078a902783c47f$export$5629498a3f321816 = (state)=>$b5078a902783c47f$export$a2066b677dcc0c86(state)?.assignee?.id || null;
const $b5078a902783c47f$export$60ee89f2718fc651 = (0, $dGvGJ.createSelector)([
    (0, $5mTgl.getWorkFilters)
], (filters)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$37aee82a3cb1e8f7)
    ], $b5078a902783c47f$var$emptyArray));
const $b5078a902783c47f$export$1ba531d8735fc55c = (0, $dGvGJ.createSelector)([
    (0, $5mTgl.getWorkFilters)
], (filters)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$a316570a0dbfd2b0)
    ], $b5078a902783c47f$var$emptyArray)));

});




parcelRegister("aBTGv", function(module, exports) {

$parcel$export(module.exports, "getActiveElement", () => $a17f7972495a1d26$export$cd4e5573fbe2b576);
$parcel$export(module.exports, "useIccRef", () => $a17f7972495a1d26$export$f083cfcda40a4972);
$parcel$export(module.exports, "isIccIntersectingWithHeader", () => $a17f7972495a1d26$export$a0217b33347e94a9);

var $5uXOq = parcelRequire("5uXOq");
const $a17f7972495a1d26$export$cd4e5573fbe2b576 = ()=>document.activeElement;
const $a17f7972495a1d26$export$f083cfcda40a4972 = ()=>(0, $5uXOq.useRef)(null);
const $a17f7972495a1d26$export$a0217b33347e94a9 = (headerRefObject, iccRefObject, isFirstCard)=>{
    // We allow a small amount of margin if the ICC is above the first card because the header is overlapping it by default
    // we still want to allow the ICC to be rendered in this case.
    const FIRST_CARD_ICC_MARGIN = 5;
    if (headerRefObject.current && iccRefObject.current) {
        const headerRect = headerRefObject.current.getBoundingClientRect();
        const iccRect = iccRefObject.current.getBoundingClientRect();
        return !((isFirstCard ? headerRect.bottom - FIRST_CARD_ICC_MARGIN : headerRect.bottom) < iccRect.top);
    }
    return false;
};

});


parcelRegister("hsHM4", function(module, exports) {

$parcel$export(module.exports, "default", () => $81786a1fd1f1895d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $67sX6 = parcelRequire("67sX6");

var $5mTgl = parcelRequire("5mTgl");

var $5KVmP = parcelRequire("5KVmP");

var $1YTEX = parcelRequire("1YTEX");
const $81786a1fd1f1895d$var$CardWithRich = (props)=>{
    const hasRenderedRichCard = (0, $5uXOq.useRef)(false);
    const { id: id, cardIndex: cardIndex, onIssueChange: onIssueChange, userCanViewMenu: userCanViewMenu, isDraggable: isDraggable, columnId: columnId, swimlaneId: swimlaneId, CardPreview: CardPreview } = props;
    const isActiveCard = (0, $67sX6.useBoardSelector)((state)=>(0, $5mTgl.isActiveCardSelector)(state, {
            issueId: id
        }));
    // @ts-expect-error([Part of upgrade 4.9-5.4]) - Operator '<=' cannot be applied to types 'IssueId' and 'number'.
    const isLoading = id <= 0;
    const shouldRenderRichCardRequirements = isActiveCard && !isLoading;
    if (shouldRenderRichCardRequirements && !hasRenderedRichCard.current) hasRenderedRichCard.current = true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KVmP.NewCard), {
        key: id,
        id: id,
        isLoading: isLoading,
        draggableIndex: cardIndex,
        userCanViewMenu: userCanViewMenu,
        Cover: (0, $1YTEX.default),
        onIssueChange: onIssueChange,
        isDraggable: isDraggable,
        shouldRenderRichCard: shouldRenderRichCardRequirements || hasRenderedRichCard.current,
        isActive: isActiveCard,
        columnId: columnId,
        swimlaneId: swimlaneId,
        CardPreview: CardPreview
    });
};
var $81786a1fd1f1895d$export$2e2bcd8739ae039 = $81786a1fd1f1895d$var$CardWithRich;

});
parcelRegister("1YTEX", function(module, exports) {

$parcel$export(module.exports, "default", () => $d13ba9163b4ea7ca$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $8Rkzz = parcelRequire("8Rkzz");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $2vNgC = parcelRequire("2vNgC");

var $bTFSo = parcelRequire("bTFSo");

var $bC2fB = parcelRequire("bC2fB");

var $iDGXn = parcelRequire("iDGXn");

var $2VkyK = parcelRequire("2VkyK");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $bYSCr = parcelRequire("bYSCr");

var $aTBle = parcelRequire("aTBle");
class $d13ba9163b4ea7ca$export$e2eb4441932fd7a1 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isClassic: false,
            issueMedia: null,
            setMediaHeight: undefined,
            onImageLoad: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    renderPlaceholder() {
        const { issueMedia: issueMedia } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueMedia) && 'attachmentMediaApiId' in issueMedia && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueMedia.attachmentMediaApiId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aTBle.default), {
            mediaId: issueMedia.attachmentMediaApiId
        });
        return null;
    }
    render() {
        const { issueMedia: issueMedia, isClassic: isClassic } = this.props;
        if (isClassic && (0, $4R6GH.fg)('jsw_cmp_card_cover_images')) {
            if (!issueMedia || issueMedia.isHiddenByUser || !(0, $6s1PB.expVal)('jsw_cmp_card_cover_images_experiment', 'isCardCoverFeatureEnabled', false)) return null;
            const media = {
                fileName: issueMedia?.fileName,
                mediaApiFileId: issueMedia?.attachmentMediaApiId,
                mediaClientId: issueMedia?.clientId,
                mediaExternalEndpointUrl: issueMedia?.endpointUrl,
                mediaReadToken: issueMedia?.token,
                width: null
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2vNgC.CardCoverBackgroundImg), media);
        }
        if (issueMedia && !issueMedia.isHiddenByUser) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bTFSo.default), {
            mediaId: issueMedia.attachmentMediaApiId,
            clientId: issueMedia.clientId,
            token: issueMedia.token,
            serviceHost: issueMedia.endpointUrl,
            onImageLoad: this.onImageLoad,
            placeholder: this.renderPlaceholder()
        });
        return null;
    }
    constructor(...args){
        super(...args);
        this.onImageLoad = (e)=>{
            const { onImageLoad: onImageLoad, setMediaHeight: setMediaHeight, issueMedia: issueMedia } = this.props;
            onImageLoad();
            if (setMediaHeight && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueMedia) && 'attachmentMediaApiId' in issueMedia && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueMedia.attachmentMediaApiId)) setMediaHeight(issueMedia.attachmentMediaApiId, e.currentTarget.height);
        };
    }
}
const $d13ba9163b4ea7ca$export$c31df4bd766f9c35 = (state, ownProps)=>{
    const isClassic = (0, $67Z81.getIsCMPBoard)(state);
    if (isClassic && (0, $4R6GH.fg)('jsw_cmp_card_cover_images')) {
        if (!ownProps.showCardCovers) return {
            issueMedia: null
        };
        return {
            issueMedia: (0, $2VkyK.getIssueMedia)(state, ownProps.id),
            isClassic: isClassic
        };
    }
    return {
        issueMedia: (0, $5mTgl.isCardMediaEnabled)(state) && !(0, $2VkyK.isIssueMediaHiddenByUser)(state, ownProps.id) ? (0, $2VkyK.getIssueMedia)(state, ownProps.id) : null
    };
};
const $d13ba9163b4ea7ca$var$ConnectedComponent = (0, $bC2fB.connect)($d13ba9163b4ea7ca$export$c31df4bd766f9c35, {})($d13ba9163b4ea7ca$export$e2eb4441932fd7a1);
const $d13ba9163b4ea7ca$export$9a6bebe541d59c5d = (props)=>{
    const [, { setMediaHeight: setMediaHeight }] = (0, $bYSCr.useCardMediaActions)();
    const showCardCovers = (0, $iDGXn.useShowCardCovers)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d13ba9163b4ea7ca$var$ConnectedComponent, {
        ...props,
        setMediaHeight: setMediaHeight,
        showCardCovers: showCardCovers
    });
};
var $d13ba9163b4ea7ca$export$2e2bcd8739ae039 = $d13ba9163b4ea7ca$export$9a6bebe541d59c5d;

});
parcelRegister("2vNgC", function(module, exports) {

$parcel$export(module.exports, "CardCoverBackgroundImg", () => $20913bc98becf269$export$9dcd30985034eb6f);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $itjxJ = parcelRequire("itjxJ");

var $fHEdP = parcelRequire("fHEdP");
const $20913bc98becf269$var$CARD_COVER_IMAGE_HEIGHT = 140;
/**
 * A card in Software TMP & Business boards has fixed with (260px) at the moment,
 * but we want to load the image at a higher resolution and then scale it down to avoid blurry images.
 * If you use 260px, there will be a gap between the image and the card border.
 */ const $20913bc98becf269$var$COLUMN_FIXED_WIDTH = 270;
const $20913bc98becf269$export$9dcd30985034eb6f = ({ fileName: fileName, mediaApiFileId: mediaApiFileId, mediaClientId: mediaClientId, mediaExternalEndpointUrl: mediaExternalEndpointUrl, mediaReadToken: mediaReadToken, width: width = $20913bc98becf269$var$COLUMN_FIXED_WIDTH })=>{
    const imageRef = (0, $5uXOq.useRef)(null);
    const imgUrl = (0, $5uXOq.useMemo)(()=>{
        if (!mediaApiFileId || !mediaClientId || !mediaExternalEndpointUrl || !(0, $itjxJ.default)) return null;
        return (0, $fHEdP.generateMediaImageUrl)({
            mediaApiFileId: mediaApiFileId,
            mediaClientId: mediaClientId,
            mediaExternalEndpointUrl: mediaExternalEndpointUrl,
            token: mediaReadToken,
            mediaEndpoint: 'image',
            ...width && {
                width: width
            },
            'max-age': Number.MAX_SAFE_INTEGER
        });
    }, [
        mediaApiFileId,
        mediaClientId,
        mediaExternalEndpointUrl,
        mediaReadToken,
        width
    ]);
    if (!imgUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20913bc98becf269$var$MemoizedCardImageCover, {
        ref: imageRef,
        "data-testid": "platform-board-kit.ui.card.card-cover.background-img.card-cover-image",
        src: imgUrl,
        title: fileName
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20913bc98becf269$var$CardImageCoverImg = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $lD23V.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1itk2pcs _bfhkvdii _1lrw1dfr _12vemgnk _ouxl1ssb _4t3i11ux _1bsb1osq _13liglpi _qrwqglpi",
            __cmplp.className
        ])
    });
});
const $20913bc98becf269$var$urlWithoutToken = (url)=>{
    const parsedUrl = new URL(url);
    parsedUrl.searchParams.delete('token');
    return parsedUrl.toString();
}; /**
    * Since the board items are refetched after any board changes, we receive a new token
    * every time. As a result, the image is refetched and causes a flicker. We don't need
    * to rerender the image in that case. The cases we need to are when the image is removed
    * or added, in which case we will retrieve a token separately and rerender.
    */ 
const $20913bc98becf269$var$MemoizedCardImageCover = /*#__PURE__*/ (0, $5uXOq.memo)($20913bc98becf269$var$CardImageCoverImg, (prevProps, nextProps)=>$20913bc98becf269$var$urlWithoutToken(prevProps.src) === $20913bc98becf269$var$urlWithoutToken(nextProps.src));

});
parcelRegister("itjxJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $901dcd98bf2abc00$export$2e2bcd8739ae039);



var $hAKJr = parcelRequire("hAKJr");

var $f8twK = parcelRequire("f8twK");

var $6cAn5 = parcelRequire("6cAn5");
/**
 * Takes a dot-separated token name and an optional fallback, and returns the CSS custom property for the corresponding token.
 * This should be used to implement design decisions throughout your application.
 *
 * Note: With `@atlaskit/babel-plugin-tokens`, this function can be pre-compiled and a fallback value automatically inserted.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * <div
 *   css={{
 *     backgroundColor: token('elevation.surface.raised', N0),
 *     boxShadow: token('elevation.shadow.raised', `0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`),
 *     padding: token('spacing.scale.100', '8px'),
 *     fontWeight: token('font.weight.regular', '400'),
 *   }}
 * />
 * ```
 *
 */ function $901dcd98bf2abc00$var$token(path, fallback) {
    let token = (0, $hAKJr.default)[path];
    typeof $6cAn5;
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $f8twK.TOKEN_NOT_FOUND_CSS_VAR);
    const tokenCall = fallback ? `var(${token}, ${fallback})` : `var(${token})`;
    return tokenCall;
}
var $901dcd98bf2abc00$export$2e2bcd8739ae039 = $901dcd98bf2abc00$var$token;

});


parcelRegister("bTFSo", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbc7fc92a3761f95$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b9JiI = parcelRequire("b9JiI");

var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bbc7fc92a3761f95$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9JiI.default), props);

});
parcelRegister("b9JiI", function(module, exports) {

$parcel$export(module.exports, "Cover", () => $d9ca957b4df1ae3b$export$64da1bd56a7c875f);
$parcel$export(module.exports, "CoverContainer", () => $d9ca957b4df1ae3b$export$10346bc3559fd590);
$parcel$export(module.exports, "default", () => $d9ca957b4df1ae3b$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $8Rkzz = parcelRequire("8Rkzz");

var $kOLg6 = parcelRequire("kOLg6");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");
const $d9ca957b4df1ae3b$var$borderRadius = 2;
const $d9ca957b4df1ae3b$var$coverMaxSize = 260;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d9ca957b4df1ae3b$var$CoverControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "u79l80-0"
})({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    borderRadius: `${$d9ca957b4df1ae3b$var$borderRadius}px ${$d9ca957b4df1ae3b$var$borderRadius}px 0 0`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& div img': {
        display: 'block',
        maxWidth: '100%',
        maxHeight: `${$d9ca957b4df1ae3b$var$coverMaxSize}px`
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d9ca957b4df1ae3b$var$CoverExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _1reo15vq _18m915vq _2rkocoyv _1xdf1ule _1p611osq _axc3gx0z",
            __cmplp.className
        ])
    });
});
const $d9ca957b4df1ae3b$export$64da1bd56a7c875f = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $d9ca957b4df1ae3b$var$CoverExperiment, $d9ca957b4df1ae3b$var$CoverControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $d9ca957b4df1ae3b$export$10346bc3559fd590 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _6a6z1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
// HOT-90084: we want to reuse mediaClientConfigs across all CardCovers to avoid extra http requests
// MediaImage internally checks for object equality to prevent image refetch.
// That's why we need to check for the individual parameters equality at this level
// and prevent the property mediaClientConfig to change
const $d9ca957b4df1ae3b$var$mediaClientConfigs = new Map();
const $d9ca957b4df1ae3b$var$getMediaClientConfig = ({ token: authToken, clientId: clientId, serviceHost: serviceHost })=>{
    const key = `${authToken}:${clientId}:${serviceHost}`;
    if ($d9ca957b4df1ae3b$var$mediaClientConfigs.has(key)) return $d9ca957b4df1ae3b$var$mediaClientConfigs.get(key);
    const mediaClientConfig = {
        authProvider: ()=>{
            const auth = Promise.resolve({
                clientId: clientId,
                token: authToken,
                baseUrl: serviceHost
            });
            return auth;
        }
    };
    $d9ca957b4df1ae3b$var$mediaClientConfigs.set(key, mediaClientConfig);
    return mediaClientConfig;
};
const $d9ca957b4df1ae3b$var$hasAuth = ({ token: authToken, clientId: clientId, serviceHost: serviceHost })=>authToken && clientId && serviceHost; // eslint-disable-next-line jira/react/no-class-components
class $d9ca957b4df1ae3b$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const mediaClientConfig = $d9ca957b4df1ae3b$var$hasAuth(this.props) ? $d9ca957b4df1ae3b$var$getMediaClientConfig(this.props) : undefined;
        if (!mediaClientConfig) return null;
        const { mediaId: mediaId, collectionName: collectionName } = this.props;
        const mediaImageProps = {
            identifier: {
                mediaItemType: 'file',
                id: mediaId,
                collectionName: collectionName
            },
            mediaClientConfig: mediaClientConfig
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9ca957b4df1ae3b$export$64da1bd56a7c875f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9ca957b4df1ae3b$export$10346bc3559fd590, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kOLg6.MediaImageWithErrorBoundary), mediaImageProps, ({ loading: loading, error: error, data: data })=>{
            if (loading && this.prevScr) // eslint-disable-next-line jsx-a11y/alt-text
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
                src: this.prevScr
            });
            if (!data || loading || error) {
                if (this.props.placeholder !== undefined) return this.props.placeholder;
                return null;
            }
            // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
            this.prevScr = data.src;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
                src: data.src,
                onLoad: this.props.onImageLoad ?? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                alt: "",
                role: "presentation",
                "data-test-id": "platform-board-kit.ui.card.card-cover.card-cover-image",
                "data-testid": "platform-board-kit.ui.card.card-cover.card-cover-image"
            });
        })));
    }
}

});
parcelRegister("kOLg6", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithErrorBoundary", () => $27dd12b02502711d$export$758a2fef95a29ad0);

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $eYKm8 = parcelRequire("eYKm8");
const $27dd12b02502711d$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f4cXA.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children({
            loading: false,
            error: true
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYKm8.MediaImageWithMediaClient), props));

});
parcelRegister("f4cXA", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("5uXOq")));
})(module.exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("eYKm8", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithMediaClient", () => $eecef2c1b93fb3db$export$8acd7eecc88dfeb5);

var $5uXOq = parcelRequire("5uXOq");

var $iArlU = parcelRequire("iArlU");

var $10b0h = parcelRequire("10b0h");
const $eecef2c1b93fb3db$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, getSsrScriptProps: getSsrScriptProps } = (0, $10b0h.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview?.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children({
        loading: status === 'loading',
        error: status === 'error',
        data: status === 'succeeded' ? {
            status: status,
            src: preview?.dataURI
        } : undefined
    }), getSsrScriptProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("script", getSsrScriptProps()));
};
const $eecef2c1b93fb3db$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $5uXOq.useMemo)(()=>(0, $iArlU.withMediaClient)($eecef2c1b93fb3db$var$MediaImageBase), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MediaImageComponent, props);
};

});
parcelRegister("iArlU", function(module, exports) {

$parcel$export(module.exports, "withMediaClient", () => $104af301cec809a6$export$9f7977d4a2561bee);

var $5uXOq = parcelRequire("5uXOq");

var $cEHh7 = parcelRequire("cEHh7");
const $104af301cec809a6$export$9f7977d4a2561bee = (Component)=>({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEHh7.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                ...otherProps,
                mediaClient: value
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEHh7.MediaClientProvider), {
                clientConfig: mediaClientConfig
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEHh7.MediaClientContext).Consumer, null, (client)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                    ...otherProps,
                    mediaClient: client
                }))));

});
parcelRegister("cEHh7", function(module, exports) {

$parcel$export(module.exports, "MediaClientContext", () => $2a03c62fd3cc05ea$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "getMediaClient", () => $2a03c62fd3cc05ea$export$c9ecbc1b719fd417);
$parcel$export(module.exports, "MediaClientProvider", () => $2a03c62fd3cc05ea$export$5bff351c86f56d97);
$parcel$export(module.exports, "useMediaClient", () => $2a03c62fd3cc05ea$export$8b3e87ea56c3a345);

var $5uXOq = parcelRequire("5uXOq");

var $9z04W = parcelRequire("9z04W");
const $2a03c62fd3cc05ea$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $2a03c62fd3cc05ea$export$f92e83e86b03c398 = new Map();
const $2a03c62fd3cc05ea$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $9z04W.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $2a03c62fd3cc05ea$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $9z04W.MediaClient)(mediaClientConfig);
        $2a03c62fd3cc05ea$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};
const $2a03c62fd3cc05ea$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $5uXOq.useMemo)(()=>$2a03c62fd3cc05ea$export$c9ecbc1b719fd417(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a03c62fd3cc05ea$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient
    }, children);
};
const $2a03c62fd3cc05ea$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($2a03c62fd3cc05ea$export$ba5d7212f2b4619f);
    if (!mediaClient) throw new Error('No MediaClient set, use MediaClientProvider to set one');
    return mediaClient;
};

});
parcelRegister("9z04W", function(module, exports) {

$parcel$export(module.exports, "MediaClient", () => $a9f77c891230da5c$export$fba8b4ca6d386aec);

var $7n9mn = parcelRequire("7n9mn");
parcelRequire("LmkUS");
var $gPrGh = parcelRequire("gPrGh");

var $1FyHg = parcelRequire("1FyHg");

var $iKPaV = parcelRequire("iKPaV");

var $5eAc2 = parcelRequire("5eAc2");
parcelRequire("8HaZs");
var $fN64m = parcelRequire("fN64m");

class $a9f77c891230da5c$export$fba8b4ca6d386aec {
    constructor(mediaClientConfig, store = (0, $fN64m.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi ?? new (0, $1FyHg.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: mediaClientConfig.useSha256ForUploads ? (0, $gPrGh.ChunkHashAlgorithm).Sha256 : (0, $gPrGh.ChunkHashAlgorithm).Sha1,
            authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
        });
        this.config = mediaClientConfig;
        this.file = new (0, $iKPaV.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
        this.stargate = new (0, $5eAc2.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
	 * @internal
	 */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params) {
        return this.mediaStore.getFileImageURLSync(id, params);
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("hUEMO"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
}

});
parcelRegister("LmkUS", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => (parcelRequire("6a8j4")).mediaState);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("hQvj4")).isClientBasedAuth);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("hQvj4")).authToOwner);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("gPrGh")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $6a8j4 = parcelRequire("6a8j4");

var $hQvj4 = parcelRequire("hQvj4");

var $gPrGh = parcelRequire("gPrGh");

});
parcelRegister("6a8j4", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => $dc598dfdde7cc536$export$8cef61637918b288);

var $7n9mn = parcelRequire("7n9mn");

var $iwKVT = parcelRequire("iwKVT");
const $dc598dfdde7cc536$export$8cef61637918b288 = {
    streams: new (0, $iwKVT.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $7n9mn.EventEmitter2)()
};

});
parcelRegister("iwKVT", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("hQvj4", function(module, exports) {

$parcel$export(module.exports, "isClientBasedAuth", () => $449c85d7d5bc4f1f$export$6ba49fcac9c46e54);
$parcel$export(module.exports, "authToOwner", () => $449c85d7d5bc4f1f$export$17f6055767a8d96a);
function $449c85d7d5bc4f1f$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}
function $449c85d7d5bc4f1f$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}
const $449c85d7d5bc4f1f$export$17f6055767a8d96a = (auth)=>{
    if ($449c85d7d5bc4f1f$export$af1ab14f2246ef72(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});

parcelRegister("gPrGh", function(module, exports) {

$parcel$export(module.exports, "ChunkHashAlgorithm", () => $506f1dfda055692a$export$d3e73a50cc549c2e);
var $506f1dfda055692a$export$d3e73a50cc549c2e;
(function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha1"] = "sha1";
    ChunkHashAlgorithm["Sha256"] = "sha256";
})($506f1dfda055692a$export$d3e73a50cc549c2e || ($506f1dfda055692a$export$d3e73a50cc549c2e = {}));

});


parcelRegister("1FyHg", function(module, exports) {

$parcel$export(module.exports, "MediaStore", () => $5d0b8a2b8f8558c8$export$572b8a2a9fd7cbba);
$parcel$export(module.exports, "getMediaEnvironment", () => $5d0b8a2b8f8558c8$export$c8b741e18397852a);
$parcel$export(module.exports, "getMediaRegion", () => $5d0b8a2b8f8558c8$export$20f9315304dd6726);
parcelRequire("LmkUS");
var $gPrGh = parcelRequire("gPrGh");
var $hQvj4 = parcelRequire("hQvj4");

var $27T0s = parcelRequire("27T0s");

var $7E56q = parcelRequire("7E56q");

var $7LFAu = parcelRequire("7LFAu");

var $hzvnk = parcelRequire("hzvnk");

var $ale1y = parcelRequire("ale1y");

var $eeVEv = parcelRequire("eeVEv");

var $5cMkQ = parcelRequire("5cMkQ");

var $VSDnB = parcelRequire("VSDnB");

var $h2NC7 = parcelRequire("h2NC7");
const $5d0b8a2b8f8558c8$var$MEDIA_API_REGION = 'media-api-region';
const $5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
const $5d0b8a2b8f8558c8$var$extendImageParams = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': params?.['max-age'] ?? (0, $7E56q.FILE_CACHE_MAX_AGE),
        allowAnimated: params?.allowAnimated ?? true,
        mode: params?.mode ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $7E56q.MAX_RESOLUTION),
            height: (0, $7E56q.MAX_RESOLUTION)
        } : {}
    };
};
const $5d0b8a2b8f8558c8$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
const $5d0b8a2b8f8558c8$var$cdnFeatureFlag = (endpoint)=>{
    let result = endpoint;
    if ((0, $VSDnB.fg)('platform_media_cdn_delivery')) {
        if ((0, $h2NC7.isCommercial)()) result += '/cdn';
    }
    return result;
};
class $5d0b8a2b8f8558c8$export$572b8a2a9fd7cbba {
    constructor(config){
        this.config = config;
        this.resolveAuth = (authContext)=>(0, $5cMkQ.resolveAuth)(this.config.authProvider, authContext, this.config.authProviderTimeout);
        this.resolveInitialAuth = ()=>(0, $5cMkQ.resolveInitialAuth)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $gPrGh.ChunkHashAlgorithm).Sha1;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params);
    }
    createFileImageURL(id, auth, params) {
        const options = {
            params: $5d0b8a2b8f8558c8$var$extendImageParams(params),
            auth: auth
        };
        const imageEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('image');
        return (0, $eeVEv.mapToMediaCdnUrl)((0, $ale1y.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
    }
    async getFileBinary(id, collectionName, maxAge = (0, $7E56q.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('binary');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options, undefined, true).then((0, $ale1y.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $7E56q.FILE_CACHE_MAX_AGE)) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const binaryEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('binary');
        return (0, $eeVEv.mapToMediaCdnUrl)((0, $ale1y.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
    }
    async getArtifactURL(artifacts, artifactName, collectionName) {
        const artifactUrl = (0, $7LFAu.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': (0, $7E56q.FILE_CACHE_MAX_AGE)
            },
            auth: auth
        };
        return (0, $ale1y.createUrl)((0, $eeVEv.mapToMediaCdnUrl)(artifactUrl, auth.token), options);
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('image');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: $5d0b8a2b8f8558c8$var$extendImageParams(params, fetchMaxRes),
            headers: headers,
            traceContext: traceContext,
            addMediaClientParam: (0, $VSDnB.fg)('platform.media-card-performance-observer_a803k') && true
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, $ale1y.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify({
                descriptors: descriptors
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, options);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller, useMediaCdn) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam } = options;
        const auth = await this.resolveAuth(authContext);
        const clientId = (0, $hQvj4.isClientBasedAuth)(auth) ? auth.clientId : undefined;
        const extendedTraceContext = traceContext ? {
            ...traceContext,
            spanId: traceContext?.spanId || (0, $27T0s.getRandomHex)(8)
        } : undefined;
        let url = `${auth.baseUrl}${path}`;
        if (useMediaCdn) url = (0, $eeVEv.mapToMediaCdnUrl)(url, auth.token);
        const response = await (0, $hzvnk.request)(url, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: addMediaClientParam ? {
                ...params,
                clientId: clientId
            } : params,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
        $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
        return response;
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}
const $5d0b8a2b8f8558c8$var$getValueFromSessionStorage = (key)=>{
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
const $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage = (key, value)=>{
    if (!value || !(window && window.sessionStorage)) return;
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) window.sessionStorage.setItem(key, value);
};
const $5d0b8a2b8f8558c8$export$c8b741e18397852a = ()=>{
    return $5d0b8a2b8f8558c8$var$getValueFromSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT);
};
const $5d0b8a2b8f8558c8$export$20f9315304dd6726 = ()=>{
    return $5d0b8a2b8f8558c8$var$getValueFromSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_REGION);
};

});
parcelRegister("27T0s", function(module, exports) {

$parcel$export(module.exports, "isUndefined", () => $5713248736bc73bb$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $5713248736bc73bb$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $5713248736bc73bb$export$456b25e3a9b4a843);
const $5713248736bc73bb$export$fce6876652108ab = (value)=>value === undefined;
const $5713248736bc73bb$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $5713248736bc73bb$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $5713248736bc73bb$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $5713248736bc73bb$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $5713248736bc73bb$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $5713248736bc73bb$export$456b25e3a9b4a843(byte) {
    let randomHex;
    if (window?.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $5713248736bc73bb$var$getRandomHexValues(byte);
    }
    else randomHex = $5713248736bc73bb$var$getRandomHexValues(byte);
    return randomHex;
}

});

parcelRegister("7E56q", function(module, exports) {

$parcel$export(module.exports, "RECENTS_COLLECTION", () => $7a454a77a18dd963$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $7a454a77a18dd963$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $7a454a77a18dd963$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $7a454a77a18dd963$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $7a454a77a18dd963$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $7a454a77a18dd963$export$f14f521f3d306044);

var $749LC = parcelRequire("749LC");
const $7a454a77a18dd963$export$860a16125e30000b = 'recents';
const $7a454a77a18dd963$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $7a454a77a18dd963$export$6e70f30e392bc53f = 4096;
const $7a454a77a18dd963$export$c1abb8bab1e615cd = 5 * (0, $749LC.DATA_UNIT).MB;
const $7a454a77a18dd963$export$3d5157f0def70e54 = 1000;
const $7a454a77a18dd963$export$f14f521f3d306044 = 2 * (0, $749LC.DATA_UNIT).TB;

});
parcelRegister("749LC", function(module, exports) {

$parcel$export(module.exports, "DATA_UNIT", () => $330ebd66cbfb5bbe$export$76cfea4c354af843);
const $330ebd66cbfb5bbe$export$350ede7b7a6acf99 = (type)=>{
    const defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
var $330ebd66cbfb5bbe$export$76cfea4c354af843;
(function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
})($330ebd66cbfb5bbe$export$76cfea4c354af843 || ($330ebd66cbfb5bbe$export$76cfea4c354af843 = {}));

});


parcelRegister("7LFAu", function(module, exports) {

$parcel$export(module.exports, "getArtifactUrl", () => $cc56e843db2c0cea$export$1cc24defa44e7f84);

var $VSDnB = parcelRequire("VSDnB");

var $h2NC7 = parcelRequire("h2NC7");
const $cc56e843db2c0cea$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $h2NC7.isCommercial)() && (0, $VSDnB.fg)('platform_media_cdn_delivery') && artifacts[prop]?.url) return `${artifacts[prop]?.url}/cdn`;
    return artifacts[prop]?.url;
};

});
parcelRegister("h2NC7", function(module, exports) {

$parcel$export(module.exports, "isCommercial", () => $bc3c8a168b66c7db$export$df69ff6733e73e50);
function $bc3c8a168b66c7db$export$df69ff6733e73e50() {
    const global = globalThis;
    const perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (perimeter) // Note: reference to MICROS_PERIMETER can be found in: https://hello.atlassian.net/wiki/spaces/MICROS/pages/167212650/Runtime+configuration+environment+variables+and+adding+secrets#Micros-provided-variables
    return perimeter === 'commercial';
    // Return true if the current hostname does NOT match any of the forbidden patterns.
    return !global.location?.hostname?.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/);
}

});


parcelRegister("hzvnk", function(module, exports) {

$parcel$export(module.exports, "request", () => $ac16e0b7f5d65450$export$b5fe3f66a567bec0);

var $1As4I = parcelRequire("1As4I");

var $ale1y = parcelRequire("ale1y");
async function $ac16e0b7f5d65450$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $ale1y.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $ale1y.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $ale1y.createProcessFetchResponse)(metadata));
    return (0, $ale1y.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("1As4I", function(module, exports) {

$parcel$export(module.exports, "RequestError", () => $a9b96946563d0d09$export$43ee7d0e4f429743);
$parcel$export(module.exports, "isRequestError", () => $a9b96946563d0d09$export$3717b1ffef4428ea);

var $gFZHi = parcelRequire("gFZHi");
class $a9b96946563d0d09$export$43ee7d0e4f429743 extends (0, $gFZHi.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason);
        this.reason = reason;
        this.metadata = metadata;
        this.innerError = innerError;
    }
    get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            innerError: innerError
        };
    }
}
function $a9b96946563d0d09$export$3717b1ffef4428ea(err) {
    return err instanceof $a9b96946563d0d09$export$43ee7d0e4f429743;
}

});
parcelRegister("gFZHi", function(module, exports) {

$parcel$export(module.exports, "BaseMediaClientError", () => $fd6342ef86e499fe$export$2b0aca14d61c3190);

var $loYHr = parcelRequire("loYHr");
class $fd6342ef86e499fe$export$2b0aca14d61c3190 extends Error {
    constructor(message){
        super(message);
        this.message = message;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}

});
parcelRegister("loYHr", function(module, exports) {

$parcel$export(module.exports, "isMediaClientError", () => $8608a1f56c9594c2$export$2491e0bbdb59256e);
$parcel$export(module.exports, "getMediaClientErrorReason", () => $8608a1f56c9594c2$export$c15d72765ee2baa4);
function $8608a1f56c9594c2$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
function $8608a1f56c9594c2$export$c15d72765ee2baa4(err) {
    return $8608a1f56c9594c2$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
}

});



parcelRegister("ale1y", function(module, exports) {

$parcel$export(module.exports, "isRateLimitedError", () => $96f7b73b7943f312$export$bc96a6a479480590);
$parcel$export(module.exports, "createUrl", () => $96f7b73b7943f312$export$7138c24907de3954);
$parcel$export(module.exports, "extendHeaders", () => $96f7b73b7943f312$export$18cfbabc415d771c);
$parcel$export(module.exports, "createMapResponseToJson", () => $96f7b73b7943f312$export$e0519b126b73efa6);
$parcel$export(module.exports, "createMapResponseToBlob", () => $96f7b73b7943f312$export$5cc7b0795397da86);
$parcel$export(module.exports, "fetchRetry", () => $96f7b73b7943f312$export$782df2acbe10b22c);
$parcel$export(module.exports, "createRequestErrorReason", () => $96f7b73b7943f312$export$6397609af718d008);
$parcel$export(module.exports, "createProcessFetchResponse", () => $96f7b73b7943f312$export$6e2e477edb7d6032);
parcelRequire("LmkUS");
var $hQvj4 = parcelRequire("hQvj4");

var $3JV6R = parcelRequire("3JV6R");

var $1As4I = parcelRequire("1As4I");
function $96f7b73b7943f312$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $96f7b73b7943f312$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $96f7b73b7943f312$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $96f7b73b7943f312$export$bc96a6a479480590(error) {
    return !!error && (0, $1As4I.isRequestError)(error) && error.attributes.statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
const $96f7b73b7943f312$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $96f7b73b7943f312$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [$96f7b73b7943f312$export$922566b90d0535ce.traceId]: traceContext.traceId,
        [$96f7b73b7943f312$export$922566b90d0535ce.spanId]: traceContext.spanId
    } : {};
};
function $96f7b73b7943f312$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $hQvj4.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}
function $96f7b73b7943f312$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth?.baseUrl);
    const authParams = auth && (0, $3JV6R.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.append(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $96f7b73b7943f312$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...$96f7b73b7943f312$export$eaf4479116d2f925(auth),
        ...$96f7b73b7943f312$var$mapTraceIdToRequestHeaders(traceContext)
    };
}
function $96f7b73b7943f312$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $1As4I.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$96f7b73b7943f312$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
function $96f7b73b7943f312$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $1As4I.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$96f7b73b7943f312$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
const $96f7b73b7943f312$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    maxAttempts: 5,
    factor: 2
};
function $96f7b73b7943f312$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $1As4I.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}
async function $96f7b73b7943f312$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...$96f7b73b7943f312$export$c65cfa70960d8fe5,
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await $96f7b73b7943f312$export$80c51ea1e89203dd(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ($96f7b73b7943f312$export$de0b576cf7ce4a53(err)) throw new (0, $1As4I.RequestError)('clientAbortedRequest', metadata, err);
        if (!$96f7b73b7943f312$export$ad8c5cf7dd4c3caf(err) && !(0, $1As4I.isRequestError)(err) || (0, $1As4I.isRequestError)(err) && (!err.metadata || !err.metadata.statusCode || err.metadata.statusCode < 500)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $1As4I.isRequestError)(lastError)) throw $96f7b73b7943f312$export$359f19ca51f9eba1(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $1As4I.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}
function $96f7b73b7943f312$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $96f7b73b7943f312$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = $96f7b73b7943f312$export$6397609af718d008(statusCode);
    return new (0, $1As4I.RequestError)(reason, {
        ...metadata,
        ...$96f7b73b7943f312$export$ea175c0c5497224(response),
        statusCode: statusCode
    });
}
function $96f7b73b7943f312$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = $96f7b73b7943f312$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $96f7b73b7943f312$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});
parcelRegister("3JV6R", function(module, exports) {

$parcel$export(module.exports, "mapAuthToQueryParameters", () => $30be3f63a223d0a0$export$6833b130611df767);
parcelRequire("LmkUS");
var $hQvj4 = parcelRequire("hQvj4");
function $30be3f63a223d0a0$export$6833b130611df767(auth) {
    if ((0, $hQvj4.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});



parcelRegister("eeVEv", function(module, exports) {

$parcel$export(module.exports, "mapToMediaCdnUrl", () => $ac061c5da59ee1d7$export$fb88a576cf28364d);

var $VSDnB = parcelRequire("VSDnB");

var $h2NC7 = parcelRequire("h2NC7");
const $ac061c5da59ee1d7$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
// Cloudfront has a hard limit of 8,192 bytes
// https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/cloudfront-limits.html
// Assuming other parts of the URL make up a max of ~1000 (in reality it's lower), the token can be ~7000
const $ac061c5da59ee1d7$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
function $ac061c5da59ee1d7$export$fb88a576cf28364d(url, token) {
    const tokenLength = token?.length ?? 0;
    if (!(0, $h2NC7.isCommercial)() || tokenLength > $ac061c5da59ee1d7$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $VSDnB.fg)('platform_media_cdn_delivery') && (0, $VSDnB.fg)('platform_media_cdn_single_host')) try {
        const parsedUrl = new URL(url);
        const cdnHost = $ac061c5da59ee1d7$export$8a9b6ab3569a543a[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});

parcelRegister("5cMkQ", function(module, exports) {

$parcel$export(module.exports, "resolveAuth", () => $c6441b149d7d138c$export$4b4cec3dcdfce972);
$parcel$export(module.exports, "resolveInitialAuth", () => $c6441b149d7d138c$export$5211e1371264aec3);

var $ciNTb = parcelRequire("ciNTb");

var $irn0C = parcelRequire("irn0C");
const $c6441b149d7d138c$export$560085fe411c0660 = 10000;
const $c6441b149d7d138c$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $c6441b149d7d138c$export$560085fe411c0660)=>{
    let auth;
    try {
        auth = await Promise.race([
            authProvider(authContext),
            (0, $irn0C.rejectTimeout)(authProviderTimeout, new (0, $ciNTb.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        if (err instanceof (0, $ciNTb.MediaStoreError)) throw err;
        throw new (0, $ciNTb.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $ciNTb.MediaStoreError)('emptyAuth');
    /*
    We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
    Token expiration check in the frontend is a bad idea. Don't do it!
    More info:
    https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
    https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
  */ return auth;
};
const $c6441b149d7d138c$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $ciNTb.MediaStoreError)('missingInitialAuth');
    return auth;
};

});
parcelRegister("ciNTb", function(module, exports) {

$parcel$export(module.exports, "MediaStoreError", () => $63300db0f534a20c$export$b78480bd311630bc);
$parcel$export(module.exports, "isMediaStoreError", () => $63300db0f534a20c$export$8d2a9b675b2ce37a);

var $gFZHi = parcelRequire("gFZHi");
class $63300db0f534a20c$export$b78480bd311630bc extends (0, $gFZHi.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason);
        this.reason = reason;
        this.innerError = innerError;
    }
    get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}
function $63300db0f534a20c$export$8d2a9b675b2ce37a(err) {
    return err instanceof $63300db0f534a20c$export$b78480bd311630bc;
}

});

parcelRegister("irn0C", function(module, exports) {

$parcel$export(module.exports, "rejectTimeout", () => $974e005d07aa0732$export$cf2d2a1124beacb2);
const $974e005d07aa0732$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
        setTimeout(resolve, timeout, resolveWith);
    });
const $974e005d07aa0732$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});



parcelRegister("iKPaV", function(module, exports) {

$parcel$export(module.exports, "FileFetcherImpl", () => $acdec836078e8c40$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("gpU3c")).FileFetcherError);

var $aZdZn = parcelRequire("aZdZn");

var $cVFxd = parcelRequire("cVFxd");

var $bXrHm = parcelRequire("bXrHm");
parcelRequire("LmkUS");
var $hQvj4 = parcelRequire("hQvj4");

var $txcJN = parcelRequire("txcJN");

var $1FyHg = parcelRequire("1FyHg");

var $1Pp1U = parcelRequire("1Pp1U");

var $gpU3c = parcelRequire("gpU3c");

var $i57HF = parcelRequire("i57HF");

var $hkwMq = parcelRequire("hkwMq");

var $bfb59 = parcelRequire("bfb59");

var $7E56q = parcelRequire("7E56q");

var $6CZ6k = parcelRequire("6CZ6k");

var $7p3Ot = parcelRequire("7p3Ot");

var $lVahM = parcelRequire("lVahM");

var $dhdZw = parcelRequire("dhdZw");

var $gayAy = parcelRequire("gayAy");

var $j1BIJ = parcelRequire("j1BIJ");
var $lYDAe = parcelRequire("lYDAe");

var $29M1K = parcelRequire("29M1K");

var $2Mh8o = parcelRequire("2Mh8o");

var $jzW7G = parcelRequire("jzW7G");

var $gR4o6 = parcelRequire("gR4o6");

var $dJ905 = parcelRequire("dJ905");

var $9KWg9 = parcelRequire("9KWg9");
parcelRequire("8HaZs");
var $fN64m = parcelRequire("fN64m");
class $acdec836078e8c40$export$fe17eabf77aabacb {
    constructor(mediaApi, store = (0, $fN64m.mediaStore)){
        this.mediaApi = mediaApi;
        this.store = store;
        this.getErrorFileState = (error, id, occurrenceKey)=>typeof error === 'string' ? {
                status: 'error',
                id: id,
                reason: error,
                occurrenceKey: occurrenceKey,
                message: error
            } : {
                status: 'error',
                id: id,
                reason: error?.reason,
                details: error?.attributes,
                occurrenceKey: occurrenceKey,
                message: error?.message
            };
        this.setFileState = (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        };
        this.createDownloadFileStream = (id, collectionName, occurrenceKey)=>{
            const subject = (0, $2Mh8o.createMediaSubject)();
            const poll = new (0, $dJ905.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName
                });
                if (!response) throw new (0, $gpU3c.FileFetcherError)('emptyItems', id, {
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                });
                if ((0, $9KWg9.isEmptyFile)(response)) throw new (0, $gpU3c.FileFetcherError)('zeroVersionFile', id, {
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                });
                const fileState = (0, $1Pp1U.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        };
        this.getUploadingFileStateBase = (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $gayAy.convertBase64ToBlob)(file.content);
            const { content: content, name: name = '' } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $lVahM.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        };
        this.dataloader = (0, $7p3Ot.createFileDataloader)(mediaApi);
    }
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey } = options;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6CZ6k)))(id)) {
            const subject = (0, $2Mh8o.createMediaSubject)();
            const err = new (0, $gpU3c.FileFetcherError)('invalidFileId', id, {
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = {
                status: 'error',
                id: id,
                reason: err?.reason,
                message: err?.message,
                occurrenceKey: occurrenceKey,
                details: err?.attributes
            };
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $j1BIJ.fromObservable)(subject);
        }
        return (0, $j1BIJ.fromObservable)((0, $hkwMq.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $lYDAe.toPromise)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
    }
    touchFiles(descriptors, collection, traceContext) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext) {
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
        const occurrenceKey = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $2Mh8o.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const name = url.split('/').pop() || '';
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: name,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $hkwMq.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $jzW7G.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            let dimensions;
            try {
                dimensions = await (0, $29M1K.getDimensionsFromBlob)(mediaType, blob);
            } catch (error) {
                reject(error);
                return;
            }
            resolve({
                dimensions: dimensions,
                mimeType: type,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $2Mh8o.createMediaSubject)();
        (0, $hkwMq.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $aZdZn.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $cVFxd.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $dhdZw.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $i57HF.uploadFile)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller?.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $j1BIJ.fromObservable)(subject);
    }
    async downloadBinary(id, name = 'download', collectionName) {
        const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
        (0, $txcJN.downloadUrl)(url, {
            name: name
        });
        (0, $bfb59.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $7E56q.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const mediaStore = destination.mediaStore || new (0, $1FyHg.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $hQvj4.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const cache = (0, $hkwMq.getFileStreamsCache)();
        let processingSubscription;
        try {
            const { data: copiedFile } = await mediaStore.copyFileWithToken(body, params, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $jzW7G.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $1Pp1U.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $2Mh8o.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $1Pp1U.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $1Pp1U.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $gR4o6.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $dhdZw.overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $dhdZw.overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                            ...!(0, $1Pp1U.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $1Pp1U.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $1Pp1U.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $hkwMq.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $2Mh8o.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
}

});
parcelRegister("txcJN", function(module, exports) {

$parcel$export(module.exports, "downloadUrl", () => $4c4bd5defea17306$export$8a96edb1c96563f4);
const $4c4bd5defea17306$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("1Pp1U", function(module, exports) {

$parcel$export(module.exports, "isUploadingFileState", () => $8f64b07ac8c4c4df$export$70eb3481b487c668);
$parcel$export(module.exports, "isProcessingFileState", () => $8f64b07ac8c4c4df$export$5c30e6dd75278e66);
$parcel$export(module.exports, "isProcessedFileState", () => $8f64b07ac8c4c4df$export$1d17291aafa5f231);
$parcel$export(module.exports, "isErrorFileState", () => $8f64b07ac8c4c4df$export$f863e1e09c8a926);
$parcel$export(module.exports, "isPreviewableFileState", () => $8f64b07ac8c4c4df$export$92dd692b31e42e64);
$parcel$export(module.exports, "isFinalFileState", () => $8f64b07ac8c4c4df$export$270b3fc27120edd0);
$parcel$export(module.exports, "isImageRepresentationReady", () => $8f64b07ac8c4c4df$export$4e33ccde53b4f0bf);
$parcel$export(module.exports, "mapMediaFileToFileState", () => $8f64b07ac8c4c4df$export$ddfd67d20657322f);
$parcel$export(module.exports, "mapMediaItemToFileState", () => $8f64b07ac8c4c4df$export$ea3730792e8bebfb);
const $8f64b07ac8c4c4df$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
const $8f64b07ac8c4c4df$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
const $8f64b07ac8c4c4df$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
const $8f64b07ac8c4c4df$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
const $8f64b07ac8c4c4df$export$92dd692b31e42e64 = (fileState)=>!$8f64b07ac8c4c4df$export$f863e1e09c8a926(fileState) && !!fileState.preview;
const $8f64b07ac8c4c4df$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
const $8f64b07ac8c4c4df$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
const $8f64b07ac8c4c4df$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        metadataTraceContext: metadataTraceContext
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing'
            };
    }
};
const $8f64b07ac8c4c4df$export$ea3730792e8bebfb = (id, item)=>{
    return $8f64b07ac8c4c4df$export$ddfd67d20657322f({
        data: {
            id: id,
            ...item
        }
    });
};

});

parcelRegister("gpU3c", function(module, exports) {

$parcel$export(module.exports, "FileFetcherError", () => $5a4b48edf9ec6627$export$e3e60f0dab8641de);

var $gFZHi = parcelRequire("gFZHi");
class $5a4b48edf9ec6627$export$e3e60f0dab8641de extends (0, $gFZHi.BaseMediaClientError) {
    constructor(reason, id, metadata){
        super(reason);
        this.reason = reason;
        this.id = id;
        this.metadata = metadata;
    }
    get attributes() {
        const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey } = {} } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $5a4b48edf9ec6627$export$5c3435f75ce0ce70(err) {
    return err instanceof $5a4b48edf9ec6627$export$e3e60f0dab8641de;
}

});

parcelRegister("i57HF", function(module, exports) {

$parcel$export(module.exports, "uploadFile", () => $8cd2ca9b1610ac88$export$a5575dbeeffdad98);

var $fEpeZ = parcelRequire("fEpeZ");

var $gI62y = parcelRequire("gI62y");

var $ib0Rz = parcelRequire("ib0Rz");

var $f6rzU = parcelRequire("f6rzU");

var $20Dmg = parcelRequire("20Dmg");

var $7E56q = parcelRequire("7E56q");

var $empHz = parcelRequire("empHz");
const $8cd2ca9b1610ac88$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $f6rzU.createHasher)(hashAlgorithm);
    return hasher.hash(blob);
};
const $8cd2ca9b1610ac88$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $8cd2ca9b1610ac88$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $8cd2ca9b1610ac88$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext);
        offset += chunks.length;
    };
};
const $8cd2ca9b1610ac88$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    const body = file.size ? {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    } : {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType
    };
    return store.createFileFromUpload(body, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext);
};
const $8cd2ca9b1610ac88$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $7E56q.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $empHz.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $empHz.fileSizeError)) callbacks?.onUploadFinish(new (0, $20Dmg.UploaderError)(err.message, id, {
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks?.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $fEpeZ.chunkinator)(content, {
        hashingFunction: (blob)=>$8cd2ca9b1610ac88$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $8cd2ca9b1610ac88$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $7E56q.PROCESSING_BATCH_SIZE),
        processingFunction: $8cd2ca9b1610ac88$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $gI62y.from)(deferredUploadId).pipe((0, $ib0Rz.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $ib0Rz.concatMap)(()=>(0, $gI62y.from)($8cd2ca9b1610ac88$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $8cd2ca9b1610ac88$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);

});
parcelRegister("fEpeZ", function(module, exports) {

$parcel$export(module.exports, "chunkinator", () => $2c9b70a291565367$export$9ab6bef3838698f8);

var $j7Dz8 = parcelRequire("j7Dz8");

var $ib0Rz = parcelRequire("ib0Rz");

var $9RLLl = parcelRequire("9RLLl");

var $bXPjr = parcelRequire("bXPjr");

var $dglPr = parcelRequire("dglPr");

var $kDczJ = parcelRequire("kDczJ");

var $4Vmg1 = parcelRequire("4Vmg1");

var $6SPPN = parcelRequire("6SPPN");

var $RsgFX = parcelRequire("RsgFX");

var $gI62y = parcelRequire("gI62y");
const $2c9b70a291565367$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $bXPjr.fromPromise)((0, $RsgFX.fetchBlob)(file)).pipe((0, $ib0Rz.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $dglPr.slicenator)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $kDczJ.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $4Vmg1.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $j7Dz8.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $6SPPN.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $ib0Rz.concatMap)((batchedChunks)=>{
            return (0, $gI62y.from)(batchedChunks);
        }), (0, $9RLLl.bufferCount)(totalChunks));
    }));
const $2c9b70a291565367$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return $2c9b70a291565367$export$88e80b3a0bb31f63(file, options, callbacks);
};

});
parcelRegister("dglPr", function(module, exports) {

$parcel$export(module.exports, "slicenator", () => $f0508944ab60c7e6$export$5b92d769f2f57509);

var $eTa7E = parcelRequire("eTa7E");

var $cVFxd = parcelRequire("cVFxd");
const $f0508944ab60c7e6$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $eTa7E.range)(0, totalChunks).pipe((0, $cVFxd.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});

parcelRegister("kDczJ", function(module, exports) {

$parcel$export(module.exports, "hashinator", () => $3a9c605917062ecc$export$d5f5a550a38ec367);

var $RsgFX = parcelRequire("RsgFX");
const $3a9c605917062ecc$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));
const $3a9c605917062ecc$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $RsgFX.asyncMap)($3a9c605917062ecc$export$28a452a485721473(hasher), concurrency)(blobs$);

});
parcelRegister("RsgFX", function(module, exports) {

$parcel$export(module.exports, "fetchBlob", () => $32ba0ece4537a1a3$export$14e9cfd4a872cc1e);
$parcel$export(module.exports, "asyncMap", () => $32ba0ece4537a1a3$export$707ee4c4c95d39e3);

var $kVLXA = parcelRequire("kVLXA");

var $80gxR = parcelRequire("80gxR");
async function $32ba0ece4537a1a3$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}
const $32ba0ece4537a1a3$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $32ba0ece4537a1a3$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $kVLXA.Observable)((sub)=>{
            notifiers.push($32ba0ece4537a1a3$var$notify(project(value), sub, onReady));
        });
};
const $32ba0ece4537a1a3$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $80gxR.mergeMap)($32ba0ece4537a1a3$var$mapper(project), concurrent);

});


parcelRegister("4Vmg1", function(module, exports) {

$parcel$export(module.exports, "uploadinator", () => $a4f565ebdd47f0f4$export$94ce0f3fcf999415);

var $RsgFX = parcelRequire("RsgFX");
const $a4f565ebdd47f0f4$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $RsgFX.asyncMap)(upload, options.concurrency));
};

});

parcelRegister("6SPPN", function(module, exports) {

$parcel$export(module.exports, "processinator", () => $389997e3e47b2450$export$2f21790600302ed);

var $9RLLl = parcelRequire("9RLLl");

var $ib0Rz = parcelRequire("ib0Rz");
const $389997e3e47b2450$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $9RLLl.bufferCount)(options.batchSize)).pipe((0, $ib0Rz.concatMap)(process));
};

});


parcelRegister("f6rzU", function(module, exports) {

$parcel$export(module.exports, "createHasher", () => $8249c54a4574cd31$export$14b114effbc08b6b);
parcelRequire("LmkUS");
var $gPrGh = parcelRequire("gPrGh");
let $8249c54a4574cd31$var$hasher = null;
let $8249c54a4574cd31$var$sha256Hasher = null;
const $8249c54a4574cd31$export$b7d263e6bc26b29a = ()=>$8249c54a4574cd31$var$hasher = null;



const $8249c54a4574cd31$export$14b114effbc08b6b = async (algorithm)=>{
    const numWorkers = 3;
    if (algorithm === (0, $gPrGh.ChunkHashAlgorithm).Sha256) {
        if (!$8249c54a4574cd31$var$sha256Hasher) {
            // TODO this needs to support worker sha256 hasher as well
            const { SimpleHasher: SimpleHasher } = await (parcelRequire("gT6vU"));
            $8249c54a4574cd31$var$sha256Hasher = new SimpleHasher();
        }
        return $8249c54a4574cd31$var$sha256Hasher;
    } else if (!$8249c54a4574cd31$var$hasher) try {
        const { WorkerHasher: WorkerHasher } = await (parcelRequire("0c3mv"));
        $8249c54a4574cd31$var$hasher = new WorkerHasher(numWorkers);
    } catch (error) {
        const { SimpleHasher: SimpleHasher } = await (parcelRequire("4yBex"));
        $8249c54a4574cd31$var$hasher = new SimpleHasher();
    }
    return $8249c54a4574cd31$var$hasher;
};

});
parcelRegister("gT6vU", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("istkm").then(()=>parcelRequire('kXp7T'));

});

parcelRegister("0c3mv", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("l0S2x")
]).then(()=>parcelRequire('3Gx8H'));

});

parcelRegister("4yBex", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("iIdh2")
]).then(()=>parcelRequire('e4mxx'));

});


parcelRegister("20Dmg", function(module, exports) {

$parcel$export(module.exports, "UploaderError", () => $5ee433d2b5ace7bb$export$515240c3f059c807);

var $gFZHi = parcelRequire("gFZHi");
class $5ee433d2b5ace7bb$export$515240c3f059c807 extends (0, $gFZHi.BaseMediaClientError) {
    constructor(reason, id, metadata){
        super(reason);
        this.reason = reason;
        this.id = id;
        this.metadata = metadata;
    }
    get attributes() {
        const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey } = {} } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $5ee433d2b5ace7bb$export$80ee180172bc336(err) {
    return err instanceof $5ee433d2b5ace7bb$export$515240c3f059c807;
}

});

parcelRegister("empHz", function(module, exports) {

$parcel$export(module.exports, "fileSizeError", () => $247cdc788c0fb235$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $247cdc788c0fb235$export$71f452e02035c1e2);

var $749LC = parcelRequire("749LC");

var $7E56q = parcelRequire("7E56q");
const $247cdc788c0fb235$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $247cdc788c0fb235$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $7E56q.MAX_UPLOAD_FILE_SIZE)) throw new Error($247cdc788c0fb235$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $749LC.DATA_UNIT).GB) return 5 * (0, $749LC.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $749LC.DATA_UNIT).GB && fileSize <= 50 * (0, $749LC.DATA_UNIT).GB) return 50 * (0, $749LC.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $749LC.DATA_UNIT).GB && fileSize <= 0.95 * (0, $749LC.DATA_UNIT).TB) return 100 * (0, $749LC.DATA_UNIT).MB;
    return 210 * (0, $749LC.DATA_UNIT).MB;
};

});


parcelRegister("hkwMq", function(module, exports) {

$parcel$export(module.exports, "getFileStreamsCache", () => $451397184147c26f$export$f2f061938c1e6810);
class $451397184147c26f$export$4293896e79732236 {
    constructor(streams){
        this.streams = streams;
    }
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
}
let $451397184147c26f$var$streamCache;

const $451397184147c26f$export$f2f061938c1e6810 = ()=>{
    if (!$451397184147c26f$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("6a8j4")).mediaState;
        $451397184147c26f$var$streamCache = new $451397184147c26f$export$4293896e79732236(mediaState.streams);
    }
    return $451397184147c26f$var$streamCache;
};

});

parcelRegister("bfb59", function(module, exports) {

$parcel$export(module.exports, "globalMediaEventEmitter", () => $22065e01bf236cb8$export$68d003d3105952ad);
parcelRequire("LmkUS");
var $6a8j4 = parcelRequire("6a8j4");
const $22065e01bf236cb8$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $6a8j4.mediaState).eventEmitter) (0, $6a8j4.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $6a8j4.mediaState).eventEmitter) (0, $6a8j4.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $6a8j4.mediaState).eventEmitter) return (0, $6a8j4.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});

parcelRegister("6CZ6k", function(module, exports) {
// Regular expression used for basic parsing of the uuid.

var $5k7LC = parcelRequire("5k7LC");
var $4d35b0145f276bfe$require$Buffer = $5k7LC.Buffer;
var $4d35b0145f276bfe$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $4d35b0145f276bfe$var$_byteToHex = [];
for(var $4d35b0145f276bfe$var$i = 0; $4d35b0145f276bfe$var$i < 256; $4d35b0145f276bfe$var$i++)$4d35b0145f276bfe$var$_byteToHex[$4d35b0145f276bfe$var$i] = ($4d35b0145f276bfe$var$i + 0x100).toString(16).substr(1);
function $4d35b0145f276bfe$var$unparse(buf, offset) {
    var i = offset || 0, bth = $4d35b0145f276bfe$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ module.exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($4d35b0145f276bfe$require$Buffer.isBuffer(uuid)) parsedUuid = $4d35b0145f276bfe$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$4d35b0145f276bfe$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $4d35b0145f276bfe$var$extractVersion(parsedUuid);
    else if ($4d35b0145f276bfe$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                '8',
                '9',
                'a',
                'b'
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $4d35b0145f276bfe$var$extractVersion = module.exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};

});

parcelRegister("7p3Ot", function(module, exports) {

$parcel$export(module.exports, "createFileDataloader", () => $40dc831f91888cf8$export$ae188fee39529b82);

var $hhZW9 = parcelRequire("hhZW9");

var $27T0s = parcelRequire("27T0s");
const $40dc831f91888cf8$export$b79d95ee17a87a = 100;
const $40dc831f91888cf8$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $40dc831f91888cf8$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $40dc831f91888cf8$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $40dc831f91888cf8$var$makeCacheKey(id, collection);
        prev[key] = $40dc831f91888cf8$var$isBatchLoadingErrorResult(fileItem) ? fileItem.error : {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $40dc831f91888cf8$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || null;
    });
};
function $40dc831f91888cf8$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $27T0s.getRandomHex)(8),
                spanId: (0, $27T0s.getRandomHex)(8)
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return $40dc831f91888cf8$export$71cd2e8f8162d47b(keys, items);
    };
}
function $40dc831f91888cf8$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($hhZW9)))($40dc831f91888cf8$export$4a53beb129e8c49a(mediaStore), {
        maxBatchSize: $40dc831f91888cf8$export$b79d95ee17a87a
    });
}

});
parcelRegister("hhZW9", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $c964119340a5ebe3$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $c964119340a5ebe3$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $c964119340a5ebe3$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $c964119340a5ebe3$var$getValidCacheKeyFn(options);
        this._cacheMap = $c964119340a5ebe3$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $c964119340a5ebe3$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $c964119340a5ebe3$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$c964119340a5ebe3$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    } /**
   * The name given to this `DataLoader` instance. Useful for APM tools.
   *
   * Is `null` if not set in the constructor.
   */ ;
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $c964119340a5ebe3$var$enqueuePostPromiseJob = typeof $6cAn5 === 'object' && typeof $6cAn5.nextTick === 'function' ? function(fn) {
    if (!$c964119340a5ebe3$var$resolvedPromise) $c964119340a5ebe3$var$resolvedPromise = Promise.resolve();
    $c964119340a5ebe3$var$resolvedPromise.then(function() {
        $6cAn5.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $c964119340a5ebe3$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $c964119340a5ebe3$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $c964119340a5ebe3$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $c964119340a5ebe3$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $c964119340a5ebe3$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$c964119340a5ebe3$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $c964119340a5ebe3$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        $c964119340a5ebe3$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $c964119340a5ebe3$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $c964119340a5ebe3$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $c964119340a5ebe3$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $c964119340a5ebe3$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $c964119340a5ebe3$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $c964119340a5ebe3$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $c964119340a5ebe3$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $c964119340a5ebe3$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $c964119340a5ebe3$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $c964119340a5ebe3$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $c964119340a5ebe3$var$DataLoader;

});


parcelRegister("lVahM", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $748ba0ab0f854341$export$ac3214931ffd82af);

var $jzW7G = parcelRequire("jzW7G");
const $748ba0ab0f854341$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $jzW7G.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});
parcelRegister("jzW7G", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $08d056d70136c4e2$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("8GKRF")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("8GKRF")).isVideoMimeTypeSupportedByBrowser);

var $92ewp = parcelRequire("92ewp");

var $8GKRF = parcelRequire("8GKRF");

var $lF4MN = parcelRequire("lF4MN");
const $08d056d70136c4e2$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $92ewp.isArchive)(mimeType)) return 'archive';
    if ((0, $8GKRF.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $lF4MN.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $8GKRF.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $lF4MN.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $8GKRF.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $lF4MN.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $8GKRF.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $lF4MN.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("92ewp", function(module, exports) {

$parcel$export(module.exports, "isArchive", () => $addf45fda6198a62$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $addf45fda6198a62$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("8GKRF", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $3af4ecf7d6cb882c$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $3af4ecf7d6cb882c$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $3af4ecf7d6cb882c$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $3af4ecf7d6cb882c$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $3af4ecf7d6cb882c$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $3af4ecf7d6cb882c$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $3af4ecf7d6cb882c$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $3af4ecf7d6cb882c$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $3af4ecf7d6cb882c$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $3af4ecf7d6cb882c$export$55ca6cdaf6093034 = (mimeType)=>$3af4ecf7d6cb882c$export$74325e3c843a9555(mimeType) || $3af4ecf7d6cb882c$export$c021f2623a75015f(mimeType) || $3af4ecf7d6cb882c$export$ff36075ea755a717(mimeType) || $3af4ecf7d6cb882c$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("lF4MN", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $8b8147e427110cee$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $8b8147e427110cee$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $8b8147e427110cee$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $8b8147e427110cee$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $8b8147e427110cee$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $8b8147e427110cee$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $8b8147e427110cee$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $8b8147e427110cee$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $8b8147e427110cee$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $8b8147e427110cee$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $8b8147e427110cee$export$548d9148a80556a3 = (mimeType)=>$8b8147e427110cee$export$e9a065a80f76311e(mimeType) || $8b8147e427110cee$export$86baad7a89d908e9(mimeType) || $8b8147e427110cee$export$8cba23825d020bbb(mimeType) || $8b8147e427110cee$export$9c2b4de5fdca2ce3(mimeType) || $8b8147e427110cee$export$94e1479e01d2af53(mimeType);

});



parcelRegister("dhdZw", function(module, exports) {

$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $c0fce003746ff4f7$export$89097c0ec1e0dee1);

var $1Pp1U = parcelRequire("1Pp1U");
const $c0fce003746ff4f7$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $1Pp1U.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("gayAy", function(module, exports) {

$parcel$export(module.exports, "convertBase64ToBlob", () => $0fff1104576a2bb3$export$ed17558b11b88056);
const $0fff1104576a2bb3$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("j1BIJ", function(module, exports) {

$parcel$export(module.exports, "fromObservable", () => $6582fd60bc4bbd36$export$4b2432e2d8723823);

var $2Mh8o = parcelRequire("2Mh8o");
function $6582fd60bc4bbd36$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}
function $6582fd60bc4bbd36$export$8659d1f07d151381(item) {
    return $6582fd60bc4bbd36$export$4b2432e2d8723823((0, $2Mh8o.createMediaSubject)(item));
}

});
parcelRegister("2Mh8o", function(module, exports) {

$parcel$export(module.exports, "createMediaSubject", () => $c9b8fad0d34272f1$export$bc76d51553fa5e35);

var $dZ0DN = parcelRequire("dZ0DN");
function $c9b8fad0d34272f1$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $dZ0DN.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});


parcelRegister("lYDAe", function(module, exports) {

$parcel$export(module.exports, "toPromise", () => $44429e0ad2a9ded6$export$4dbaaf6c79705e6c);

var $aZdZn = parcelRequire("aZdZn");
const $44429e0ad2a9ded6$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $aZdZn.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));

});

parcelRegister("29M1K", function(module, exports) {

$parcel$export(module.exports, "getDimensionsFromBlob", () => $c92d9e8096a99b5b$export$71797c284d89a3e1);

var $8IWWt = parcelRequire("8IWWt");

var $5CbXO = parcelRequire("5CbXO");
const $c92d9e8096a99b5b$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $8IWWt.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $5CbXO.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("8IWWt", function(module, exports) {

$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $094f7e5912c5e863$export$a1c3205f28a20414);
const $094f7e5912c5e863$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("5CbXO", function(module, exports) {

$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $3629651e482443d2$export$62aabd5ff85d0451);
const $3629651e482443d2$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});


parcelRegister("gR4o6", function(module, exports) {

$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $81fca2ad541e7785$export$2ccdd6f9a9eba6a);

var $8GKRF = parcelRequire("8GKRF");
var $lF4MN = parcelRequire("lF4MN");

var $5CbXO = parcelRequire("5CbXO");
async function $81fca2ad541e7785$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $8GKRF.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $lF4MN.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $5CbXO.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}

});

parcelRegister("dJ905", function(module, exports) {

$parcel$export(module.exports, "PollingFunction", () => $a9b60fcbc1595cd8$export$4c54d536f8e37dc2);

var $j8kdR = parcelRequire("j8kdR");
const $a9b60fcbc1595cd8$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $a9b60fcbc1595cd8$export$4c54d536f8e37dc2 {
    constructor(options){
        this.poll_intervalMs = 0;
        this.attempt = 1;
        this.shouldIterate = true;
        this.timeoutId = 0;
        this.options = {
            ...$a9b60fcbc1595cd8$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $j8kdR.PollingError)('pollingMaxAttemptsExceeded', this.attempt));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $j8kdR.PollingError)('pollingMaxAttemptsExceeded', this.attempt));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
}

});
parcelRegister("j8kdR", function(module, exports) {

$parcel$export(module.exports, "PollingError", () => $ba72cde1b79a6066$export$c3748c310e92340a);
$parcel$export(module.exports, "isPollingError", () => $ba72cde1b79a6066$export$541e3e52eea6fece);

var $gFZHi = parcelRequire("gFZHi");
class $ba72cde1b79a6066$export$c3748c310e92340a extends (0, $gFZHi.BaseMediaClientError) {
    constructor(reason, attempts){
        super(reason);
        this.reason = reason;
        this.attempts = attempts;
    }
    get attributes() {
        const { reason: reason, attempts: attempts } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
}
function $ba72cde1b79a6066$export$541e3e52eea6fece(err) {
    return err instanceof $ba72cde1b79a6066$export$c3748c310e92340a;
}

});


parcelRegister("9KWg9", function(module, exports) {

$parcel$export(module.exports, "isEmptyFile", () => $6625df65da5f0486$export$728192ce8dd94659);
const $6625df65da5f0486$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $6625df65da5f0486$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $6625df65da5f0486$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("8HaZs", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => (parcelRequire("fN64m")).mediaStore);

var $fN64m = parcelRequire("fN64m");

});
parcelRegister("fN64m", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => $df71566ec1e8fa2a$export$5785580dea19518d);

var $bIv98 = parcelRequire("bIv98");

var $70n8Q = parcelRequire("70n8Q");

var $ee7sp = parcelRequire("ee7sp");
const $df71566ec1e8fa2a$var$mediaStoreWithoutDevtools = (0, $ee7sp.createStore)()((0, $bIv98.subscribeWithSelector)((0, $70n8Q.immer)(()=>({
        files: {}
    }))));
const $df71566ec1e8fa2a$var$mediaStoreWithDevtools = (0, $ee7sp.createStore)()((0, $bIv98.devtools)((0, $bIv98.subscribeWithSelector)((0, $70n8Q.immer)(()=>({
        files: {}
    })))));
const $df71566ec1e8fa2a$export$5785580dea19518d = $df71566ec1e8fa2a$var$mediaStoreWithoutDevtools;
const $df71566ec1e8fa2a$export$503459913a0dc356 = (initialStore)=>{
    return (0, $ee7sp.createStore)()((0, $bIv98.subscribeWithSelector)((0, $70n8Q.immer)(()=>({
            files: {},
            ...initialStore
        }))));
};

});
parcelRegister("bIv98", function(module, exports) {

$parcel$export(module.exports, "devtools", () => $887bf6c78f4461c3$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $887bf6c78f4461c3$export$5c593627aef9f076);
var $887bf6c78f4461c3$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $887bf6c78f4461c3$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $887bf6c78f4461c3$export$4feba8a1bc8e9afd = $887bf6c78f4461c3$var$reduxImpl;
const $887bf6c78f4461c3$var$trackedConnections = /* @__PURE__ */ new Map();
const $887bf6c78f4461c3$var$getTrackedConnectionState = (name)=>{
    const api = $887bf6c78f4461c3$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $887bf6c78f4461c3$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $887bf6c78f4461c3$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $887bf6c78f4461c3$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $887bf6c78f4461c3$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) {
            if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $887bf6c78f4461c3$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$887bf6c78f4461c3$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $887bf6c78f4461c3$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $887bf6c78f4461c3$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $887bf6c78f4461c3$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $887bf6c78f4461c3$export$6922d3b3a607469e = $887bf6c78f4461c3$var$devtoolsImpl;
const $887bf6c78f4461c3$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $887bf6c78f4461c3$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $887bf6c78f4461c3$export$5c593627aef9f076 = $887bf6c78f4461c3$var$subscribeWithSelectorImpl;
const $887bf6c78f4461c3$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $887bf6c78f4461c3$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $887bf6c78f4461c3$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $887bf6c78f4461c3$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $887bf6c78f4461c3$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $887bf6c78f4461c3$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $887bf6c78f4461c3$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $887bf6c78f4461c3$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $887bf6c78f4461c3$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $887bf6c78f4461c3$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $887bf6c78f4461c3$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $887bf6c78f4461c3$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $887bf6c78f4461c3$var$oldImpl(config, baseOptions);
    }
    return $887bf6c78f4461c3$var$newImpl(config, baseOptions);
};
const $887bf6c78f4461c3$export$9a6132153fba2e0 = $887bf6c78f4461c3$var$persistImpl;

});

parcelRegister("70n8Q", function(module, exports) {

$parcel$export(module.exports, "immer", () => $519a7bf2c276fd5a$export$428de7ec69ac95c);

var $86xFr = parcelRequire("86xFr");
const $519a7bf2c276fd5a$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $86xFr.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $519a7bf2c276fd5a$export$428de7ec69ac95c = $519a7bf2c276fd5a$var$immerImpl;

});
parcelRegister("86xFr", function(module, exports) {

$parcel$export(module.exports, "produce", () => fn);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $5e68ffea5fb572cb$export$2e2bcd8739ae039 = fn;

});


parcelRegister("ee7sp", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $a5b82856cfbd137f$export$f51a9068ac82ea43);
var $a5b82856cfbd137f$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $a5b82856cfbd137f$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($a5b82856cfbd137f$import_meta.env ? $a5b82856cfbd137f$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $a5b82856cfbd137f$export$f51a9068ac82ea43 = (createState)=>createState ? $a5b82856cfbd137f$var$createStoreImpl(createState) : $a5b82856cfbd137f$var$createStoreImpl;
var $a5b82856cfbd137f$export$2e2bcd8739ae039 = (createState)=>{
    if (($a5b82856cfbd137f$import_meta.env ? $a5b82856cfbd137f$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $a5b82856cfbd137f$export$f51a9068ac82ea43(createState);
};

});




parcelRegister("5eAc2", function(module, exports) {

$parcel$export(module.exports, "StargateClient", () => $0084b28d1d44d0da$export$c66ca190f89caaac);
class $0084b28d1d44d0da$export$c66ca190f89caaac {
    constructor(baseUrl){
        this.baseUrl = baseUrl || '/gateway/api';
    }
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
}

});

parcelRegister("hUEMO", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("ais1M").then(()=>parcelRequire('piTsY'));

});




parcelRegister("10b0h", function(module, exports) {

$parcel$export(module.exports, "useFilePreview", () => $baceb2843b357d39$export$4eaebdef02112fe4);

var $5uXOq = parcelRequire("5uXOq");

var $1Pp1U = parcelRequire("1Pp1U");

var $24tOd = parcelRequire("24tOd");
var $cEHh7 = parcelRequire("cEHh7");

var $8GKRF = parcelRequire("8GKRF");

var $VSDnB = parcelRequire("VSDnB");

var $kGpuq = parcelRequire("kGpuq");

var $01sWe = parcelRequire("01sWe");

var $3JWNV = parcelRequire("3JWNV");
var $4n1NZ = parcelRequire("4n1NZ");
var $7xRaJ = parcelRequire("7xRaJ");

var $3JZCV = parcelRequire("3JZCV");
var $jR4hE = parcelRequire("jR4hE");

var $8Kbwv = parcelRequire("8Kbwv");
const $baceb2843b357d39$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const [status, setStatus] = (0, $5uXOq.useState)('loading');
    const [error, setError] = (0, $5uXOq.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $5uXOq.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $5uXOq.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $5uXOq.useState)('not-resolved');
    const ssrReliabilityRef = (0, $5uXOq.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const requestDimensions = (0, $5uXOq.useMemo)(()=>dimensions ? (0, $8Kbwv.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $8Kbwv.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    if ((0, $VSDnB.fg)('platform.media-card-performance-observer_a803k')) imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $7xRaJ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $jR4hE.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $3JWNV.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $kGpuq.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $5uXOq.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $24tOd.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const fileStatus = fileState?.status;
    const isBackendPreviewReady = !!fileState && (0, $1Pp1U.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $5uXOq.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileStatus === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileStatus === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $01sWe.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileStatus === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $01sWe.MediaFilePreviewError)('metadata-fetch', new Error(fileStateErrorMessage)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileStatus,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $8Kbwv.useCurrentValueRef)(()=>{
        return (0, $3JWNV.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $5uXOq.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $8Kbwv.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $8Kbwv.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $5uXOq.useEffect)(()=>{
        const cachedPreview = (0, $7xRaJ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $8Kbwv.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $4n1NZ.isSupportedLocalPreview)(mediaType) && (0, $8GKRF.isMimeTypeSupportedByBrowser)(mimeType || '')) // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
        // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
        // Then, local Preview NOT available
        (0, $3JWNV.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
            setIsBannedLocalPreview(true);
            // CXP-2723 TODO: We might have to wrap this error in MediaCardError
            setNonCriticalError(e);
        });
        else if (!error && !nonCriticalError && (!preview || (0, $8Kbwv.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $3JWNV.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
            const wrappedError = (0, $01sWe.ensureMediaFilePreviewError)('preview-fetch', e);
            if (!preview) {
                setStatus('error');
                setError(wrappedError);
            } else // If there is already a preview, we consider it a non-critical error
            setNonCriticalError(wrappedError);
        });
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $5uXOq.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $3JWNV.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if ((0, $3JWNV.isSSRDataPreview)(failedPreview)) {
            ssrReliabilityRef.current.server = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $3JWNV.isLocalPreview)(failedPreview);
        const isRemote = (0, $3JWNV.isRemotePreview)(failedPreview);
        if (isLocal || isRemote) {
            const error = new (0, $01sWe.ImageLoadError)(failedPreview?.source);
            (0, $7xRaJ.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $5uXOq.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $3JWNV.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $3JWNV.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $3JZCV.generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps
    };
};

});
parcelRegister("24tOd", function(module, exports) {

$parcel$export(module.exports, "useFileState", () => $768d10f5fd62ab89$export$90ff537b0999afb);

var $5uXOq = parcelRequire("5uXOq");

var $cEHh7 = parcelRequire("cEHh7");

var $k4CmR = parcelRequire("k4CmR");
function $768d10f5fd62ab89$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false } = options;
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const fileState = (0, $k4CmR.useMediaStore)((state)=>state.files[id]);
    (0, $5uXOq.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("k4CmR", function(module, exports) {

$parcel$export(module.exports, "useMediaStore", () => $a907ffa2ecfaf54d$export$8a9cc8c330400af8);

var $6esDR = parcelRequire("6esDR");

var $cEHh7 = parcelRequire("cEHh7");
const $a907ffa2ecfaf54d$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $6esDR.useStore)(store, selector, equals);
function $a907ffa2ecfaf54d$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $a907ffa2ecfaf54d$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("6esDR", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $489a4492a45245b1$export$6ccbb43953eebf8);

var $ee7sp = parcelRequire("ee7sp");

var $5uXOq = parcelRequire("5uXOq");

var $lNQti = parcelRequire("lNQti");
var $489a4492a45245b1$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $489a4492a45245b1$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq)));
const { useSyncExternalStoreWithSelector: $489a4492a45245b1$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($lNQti)));
let $489a4492a45245b1$var$didWarnAboutEqualityFn = false;
const $489a4492a45245b1$var$identity = (arg)=>arg;
function $489a4492a45245b1$export$6ccbb43953eebf8(api, selector = $489a4492a45245b1$var$identity, equalityFn) {
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$489a4492a45245b1$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $489a4492a45245b1$var$didWarnAboutEqualityFn = true;
    }
    const slice = $489a4492a45245b1$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $489a4492a45245b1$var$useDebugValue(slice);
    return slice;
}
const $489a4492a45245b1$var$createImpl = (createState)=>{
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $ee7sp.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$489a4492a45245b1$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $489a4492a45245b1$export$185802fd694ee1f5 = (createState)=>createState ? $489a4492a45245b1$var$createImpl(createState) : $489a4492a45245b1$var$createImpl;
var $489a4492a45245b1$export$2e2bcd8739ae039 = (createState)=>{
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $489a4492a45245b1$export$185802fd694ee1f5(createState);
};

});
parcelRegister("lNQti", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hUiTL"));

});
parcelRegister("hUiTL", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $d096537a1780f6c5$export$bf730a2d8bf68b42, (v) => $d096537a1780f6c5$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d096537a1780f6c5$export$bf730a2d8bf68b42;
'use strict';

var $5uXOq = parcelRequire("5uXOq");

var $goz36 = parcelRequire("goz36");
function $d096537a1780f6c5$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d096537a1780f6c5$var$q = "function" === typeof Object.is ? Object.is : $d096537a1780f6c5$var$p, $d096537a1780f6c5$var$r = $goz36.useSyncExternalStore, $d096537a1780f6c5$var$t = $5uXOq.useRef, $d096537a1780f6c5$var$u = $5uXOq.useEffect, $d096537a1780f6c5$var$v = $5uXOq.useMemo, $d096537a1780f6c5$var$w = $5uXOq.useDebugValue;
$d096537a1780f6c5$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $d096537a1780f6c5$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $d096537a1780f6c5$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($d096537a1780f6c5$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $d096537a1780f6c5$var$r(a, c[0], c[1]);
    $d096537a1780f6c5$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $d096537a1780f6c5$var$w(d);
    return d;
};

});
parcelRegister("goz36", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jcmQl"));

});
parcelRegister("jcmQl", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $dfa0db7ec3fca60b$export$306c0aa65ff9ec16, (v) => $dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dfa0db7ec3fca60b$export$306c0aa65ff9ec16;
'use strict';

var $5uXOq = parcelRequire("5uXOq");
function $dfa0db7ec3fca60b$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $dfa0db7ec3fca60b$var$k = "function" === typeof Object.is ? Object.is : $dfa0db7ec3fca60b$var$h, $dfa0db7ec3fca60b$var$l = $5uXOq.useState, $dfa0db7ec3fca60b$var$m = $5uXOq.useEffect, $dfa0db7ec3fca60b$var$n = $5uXOq.useLayoutEffect, $dfa0db7ec3fca60b$var$p = $5uXOq.useDebugValue;
function $dfa0db7ec3fca60b$var$q(a, b) {
    var d = b(), f = $dfa0db7ec3fca60b$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $dfa0db7ec3fca60b$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $dfa0db7ec3fca60b$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $dfa0db7ec3fca60b$var$m(function() {
        $dfa0db7ec3fca60b$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $dfa0db7ec3fca60b$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $dfa0db7ec3fca60b$var$p(d);
    return d;
}
function $dfa0db7ec3fca60b$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$dfa0db7ec3fca60b$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $dfa0db7ec3fca60b$var$t(a, b) {
    return b();
}
var $dfa0db7ec3fca60b$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $dfa0db7ec3fca60b$var$t : $dfa0db7ec3fca60b$var$q;
$dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = void 0 !== $5uXOq.useSyncExternalStore ? $5uXOq.useSyncExternalStore : $dfa0db7ec3fca60b$var$u;

});







parcelRegister("kGpuq", function(module, exports) {

$parcel$export(module.exports, "extractErrorInfo", () => $d93d75d54376e990$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $d93d75d54376e990$export$768c370ed0dbaeb3);

var $loYHr = parcelRequire("loYHr");
var $1As4I = parcelRequire("1As4I");

var $01sWe = parcelRequire("01sWe");
const $d93d75d54376e990$export$29aa614726672b2e = (error)=>{
    if ((0, $01sWe.isMediaFilePreviewError)(error) && !!error.secondaryError) {
        if ((0, $1As4I.isRequestError)(error.secondaryError)) return error.secondaryError.metadata?.traceContext;
        else if ((0, $01sWe.isMediaFileStateError)(error.secondaryError)) return error.secondaryError.details?.metadata?.traceContext;
    }
};
const $d93d75d54376e990$export$4af9d71992e89714 = (error)=>{
    if ((0, $01sWe.isMediaFilePreviewError)(error)) return error.primaryReason;
    else return 'nativeError';
};
const $d93d75d54376e990$export$88c61dcad53762da = (error)=>{
    if ((0, $01sWe.isMediaFilePreviewError)(error) && error.secondaryError) {
        const mediaClientReason = (0, $01sWe.isMediaFileStateError)(error.secondaryError) ? (0, $01sWe.getFileStateErrorReason)(error.secondaryError) : (0, $loYHr.getMediaClientErrorReason)(error.secondaryError);
        if (mediaClientReason !== 'unknown') return mediaClientReason;
    }
    return 'nativeError';
};
const $d93d75d54376e990$export$9ccc5365d056da4b = (error)=>{
    if ((0, $01sWe.isMediaFilePreviewError)(error) && error.secondaryError) return error.secondaryError.message;
    else return error.message;
};
const $d93d75d54376e990$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $d93d75d54376e990$export$4af9d71992e89714(error),
        error: $d93d75d54376e990$export$88c61dcad53762da(error),
        errorDetail: $d93d75d54376e990$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $d93d75d54376e990$export$29aa614726672b2e(error)
    };
};
const $d93d75d54376e990$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$d93d75d54376e990$export$74aaf4784c2edb2c(new (0, $01sWe.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("01sWe", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreviewError", () => $fcceba16863dd854$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $fcceba16863dd854$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $fcceba16863dd854$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $fcceba16863dd854$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $fcceba16863dd854$export$d0a45ab59b4606b);
$parcel$export(module.exports, "isMediaFilePreviewError", () => $fcceba16863dd854$export$553696a6e769784c);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $fcceba16863dd854$export$7156ce7b78b49bd7);
$parcel$export(module.exports, "isMediaFileStateError", () => $fcceba16863dd854$export$166a250c03366459);
$parcel$export(module.exports, "getFileStateErrorReason", () => $fcceba16863dd854$export$2e87e6d20b09376d);

var $fVF5e = parcelRequire("fVF5e");
class $fcceba16863dd854$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $fcceba16863dd854$export$2c035820a31723e extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
    }
}
class $fcceba16863dd854$export$10ab445310d30114 extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
    }
}
class $fcceba16863dd854$export$18e89b7e50818288 extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
    }
}
const $fcceba16863dd854$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $fcceba16863dd854$export$d0a45ab59b4606b extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(source){
        super($fcceba16863dd854$var$getImageLoadPrimaryReason(source));
    }
}
function $fcceba16863dd854$export$553696a6e769784c(err) {
    return err instanceof $fcceba16863dd854$export$96e559194c287cf4;
}
const $fcceba16863dd854$export$b380593ba3516c6f = (err)=>err instanceof $fcceba16863dd854$export$2c035820a31723e;
const $fcceba16863dd854$export$e1d87830b3784f94 = (err)=>err instanceof $fcceba16863dd854$export$10ab445310d30114;
const $fcceba16863dd854$export$443aeb298d35d79d = (err)=>$fcceba16863dd854$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $fcceba16863dd854$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($fcceba16863dd854$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $fcceba16863dd854$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $fcceba16863dd854$export$96e559194c287cf4(primaryReason, error);
};
function $fcceba16863dd854$export$166a250c03366459(err) {
    return err instanceof (0, $fVF5e.MediaFileStateError);
}
function $fcceba16863dd854$export$2e87e6d20b09376d(err) {
    return err.details?.reason ?? 'unknown';
}

});
parcelRegister("fVF5e", function(module, exports) {

$parcel$export(module.exports, "MediaFileStateError", () => $2e194af23ca6b4a5$export$38242da09b559a);
class $2e194af23ca6b4a5$export$38242da09b559a extends Error {
    constructor(id, reason, message = '', details){
        super(reason);
        this.id = id;
        this.reason = reason;
        this.message = message;
        this.details = details;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}

});



parcelRegister("3JWNV", function(module, exports) {

$parcel$export(module.exports, "getSSRPreview", () => $609060e8f7210c63$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $609060e8f7210c63$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $609060e8f7210c63$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $609060e8f7210c63$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $609060e8f7210c63$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $609060e8f7210c63$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $609060e8f7210c63$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $609060e8f7210c63$export$98e935d981c884d);

var $9KG2L = parcelRequire("9KG2L");

var $01sWe = parcelRequire("01sWe");

var $7xRaJ = parcelRequire("7xRaJ");

var $4n1NZ = parcelRequire("4n1NZ");
const $609060e8f7210c63$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $9KG2L.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $7xRaJ.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $609060e8f7210c63$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    let dataURI;
    try {
        const rawDataURI = mediaClient.getImageUrlSync(id, params);
        // We want to embed some meta context into dataURI for Copy/Paste to work.
        dataURI = mediaBlobUrlAttrs ? (0, $9KG2L.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $01sWe.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $609060e8f7210c63$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $609060e8f7210c63$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $609060e8f7210c63$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $609060e8f7210c63$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $609060e8f7210c63$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $609060e8f7210c63$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $4n1NZ.getRemotePreview)(mediaClient, id, params, traceContext);
    return $609060e8f7210c63$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $609060e8f7210c63$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $4n1NZ.getLocalPreview)(filePreview);
    return $609060e8f7210c63$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("9KG2L", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrl", () => $3193ea5c2295e37f$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $3193ea5c2295e37f$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $3193ea5c2295e37f$export$e51a8146182600b8);
const $3193ea5c2295e37f$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $3193ea5c2295e37f$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$3193ea5c2295e37f$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $3193ea5c2295e37f$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $3193ea5c2295e37f$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $3193ea5c2295e37f$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $3193ea5c2295e37f$var$getStringFromParams(params, 'collection'),
        alt: $3193ea5c2295e37f$var$getStringFromParams(params, 'alt'),
        height: $3193ea5c2295e37f$var$getNumberFromParams(params, 'height'),
        width: $3193ea5c2295e37f$var$getNumberFromParams(params, 'width'),
        size: $3193ea5c2295e37f$var$getNumberFromParams(params, 'size'),
        name: $3193ea5c2295e37f$var$getStringFromParams(params, 'name'),
        mimeType: $3193ea5c2295e37f$var$getStringFromParams(params, 'mimeType')
    };
};
const $3193ea5c2295e37f$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $3193ea5c2295e37f$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$3193ea5c2295e37f$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $3193ea5c2295e37f$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("7xRaJ", function(module, exports) {

$parcel$export(module.exports, "mediaFilePreviewCache", () => $abbc266dbfedc514$export$b7e8ee3f7a41459);

var $aAIop = parcelRequire("aAIop");
const $abbc266dbfedc514$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $abbc266dbfedc514$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $abbc266dbfedc514$export$b7e8ee3f7a41459 = new $abbc266dbfedc514$export$7b50526c091bb915((0, $aAIop.createObjectURLCache)());

});
parcelRegister("aAIop", function(module, exports) {

$parcel$export(module.exports, "createObjectURLCache", () => $0cfc22aea6c15367$export$ba71be67d5c32535);

var $7n9mn = parcelRequire("7n9mn");

var $iwKVT = parcelRequire("iwKVT");
const $0cfc22aea6c15367$export$36d0f9859761643d = 50;
class $0cfc22aea6c15367$var$ExtendedLRUCache extends (0, $iwKVT.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $0cfc22aea6c15367$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $0cfc22aea6c15367$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $0cfc22aea6c15367$export$ba71be67d5c32535 = ()=>new $0cfc22aea6c15367$export$75d1c8c9ba1d0773($0cfc22aea6c15367$export$36d0f9859761643d);

});


parcelRegister("4n1NZ", function(module, exports) {

$parcel$export(module.exports, "isSupportedLocalPreview", () => $3b75ec6170865ae7$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $3b75ec6170865ae7$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $3b75ec6170865ae7$export$bfe20bd01db02b3);

var $jzW7G = parcelRequire("jzW7G");

var $48aIR = parcelRequire("48aIR");

var $01sWe = parcelRequire("01sWe");

var $Nl5sY = parcelRequire("Nl5sY");
const $3b75ec6170865ae7$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $3b75ec6170865ae7$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $48aIR.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $3b75ec6170865ae7$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $Nl5sY.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $3b75ec6170865ae7$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $jzW7G.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $3b75ec6170865ae7$var$getImageLocalPreview(value);
            case 'video':
                return $3b75ec6170865ae7$var$getVideoLocalPreview(value);
            default:
                throw new (0, $01sWe.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $01sWe.LocalPreviewError)('local-preview-unsupported');
};
const $3b75ec6170865ae7$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $01sWe.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("48aIR", function(module, exports) {

$parcel$export(module.exports, "getImageInfo", () => $93f6c931eebc2be3$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $93f6c931eebc2be3$export$67689507e8404821);

var $k9Ch0 = parcelRequire("k9Ch0");

var $5m9mt = parcelRequire("5m9mt");

var $1xbJn = parcelRequire("1xbJn");

var $hNjKA = parcelRequire("hNjKA");
const { Orientation: $93f6c931eebc2be3$var$Orientation, XResolution: $93f6c931eebc2be3$var$XResolution } = (0, $k9Ch0.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $93f6c931eebc2be3$var$DPI_WEB_BASELINE = 72;
async function $93f6c931eebc2be3$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $93f6c931eebc2be3$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $93f6c931eebc2be3$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $93f6c931eebc2be3$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $93f6c931eebc2be3$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $93f6c931eebc2be3$var$DPI_WEB_BASELINE;
        else return $93f6c931eebc2be3$export$268f92356524130b(tags, $93f6c931eebc2be3$var$XResolution, $93f6c931eebc2be3$var$DPI_WEB_BASELINE) / $93f6c931eebc2be3$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $93f6c931eebc2be3$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$93f6c931eebc2be3$var$Orientation]) {
        const tagValue = tags[$93f6c931eebc2be3$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $k9Ch0.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $93f6c931eebc2be3$export$67689507e8404821(file) {
    const tags = await (0, $5m9mt.readImageMetaTags)(file);
    return $93f6c931eebc2be3$var$getOrientationFromTags(tags);
}
function $93f6c931eebc2be3$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $93f6c931eebc2be3$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $93f6c931eebc2be3$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $5m9mt.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $93f6c931eebc2be3$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $93f6c931eebc2be3$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $1xbJn.loadImage)(src);
        const { width: width, height: height } = (0, $1xbJn.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("k9Ch0", function(module, exports) {

$parcel$export(module.exports, "ImageType", () => $8ba626f637ae3df3$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $8ba626f637ae3df3$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $8ba626f637ae3df3$export$f6ea0c89fd7d156);
var $8ba626f637ae3df3$export$48c85e6e32ef0825;
(function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
})($8ba626f637ae3df3$export$48c85e6e32ef0825 || ($8ba626f637ae3df3$export$48c85e6e32ef0825 = {}));
var $8ba626f637ae3df3$export$e369bb48cf33e564;
(function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
})($8ba626f637ae3df3$export$e369bb48cf33e564 || ($8ba626f637ae3df3$export$e369bb48cf33e564 = {}));
const $8ba626f637ae3df3$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("5m9mt", function(module, exports) {

$parcel$export(module.exports, "readImageMetaTags", () => $6da5c9a89db4de84$export$41982b5c7acb23c4);

var $k9Ch0 = parcelRequire("k9Ch0");

var $jkveD = parcelRequire("jkveD");

var $kINoG = parcelRequire("kINoG");

var $2edT6 = parcelRequire("2edT6");
async function $6da5c9a89db4de84$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $k9Ch0.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $kINoG.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $2edT6.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $k9Ch0.ImageType).JPEG) return await (0, $jkveD.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("jkveD", function(module, exports) {

$parcel$export(module.exports, "readJPEGExifMetaData", () => $537aa8dc852a8555$export$556b2ccec62d7f2a);

var $k9Ch0 = parcelRequire("k9Ch0");
const { XResolution: $537aa8dc852a8555$var$XResolution, YResolution: $537aa8dc852a8555$var$YResolution } = (0, $k9Ch0.SupportedImageMetaTag);
let $537aa8dc852a8555$var$loadImage;

function $537aa8dc852a8555$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$537aa8dc852a8555$var$loadImage) {
            const module = await (parcelRequire("kFwqQ"));
            $537aa8dc852a8555$var$loadImage = module.default || module;
        }
        $537aa8dc852a8555$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $537aa8dc852a8555$var$XResolution || key === $537aa8dc852a8555$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("kFwqQ", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("7lJbN").then(()=>parcelRequire('8aLn9'));

});


parcelRegister("kINoG", function(module, exports) {

$parcel$export(module.exports, "readPNGXMPMetaData", () => $013315ab2d0cc3cf$export$5fb37736440fca6f);

var $1xbJn = parcelRequire("1xbJn");
let $013315ab2d0cc3cf$var$pngChunksExtract;

async function $013315ab2d0cc3cf$export$5fb37736440fca6f(file) {
    if (!$013315ab2d0cc3cf$var$pngChunksExtract) {
        const module = await (parcelRequire("yWJlB"));
        $013315ab2d0cc3cf$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $1xbJn.fileToArrayBuffer)(file);
    const chunks = $013315ab2d0cc3cf$var$pngChunksExtract(buffer);
    return await $013315ab2d0cc3cf$export$9185743fdd58ce45(chunks);
}
async function $013315ab2d0cc3cf$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("1xbJn", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $3c9a3ebb8ee397f0$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $3c9a3ebb8ee397f0$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $3c9a3ebb8ee397f0$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $3c9a3ebb8ee397f0$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $3c9a3ebb8ee397f0$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $3c9a3ebb8ee397f0$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $3c9a3ebb8ee397f0$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $3c9a3ebb8ee397f0$export$61a1de0822e2820);

var $2tm8x = parcelRequire("2tm8x");

var $RiK2l = parcelRequire("RiK2l");

var $cHwqN = parcelRequire("cHwqN");

var $2sfBf = parcelRequire("2sfBf");

var $iABw2 = parcelRequire("iABw2");

var $7hpMa = parcelRequire("7hpMa");

var $dGYEZ = parcelRequire("dGYEZ");

var $iBOon = parcelRequire("iBOon");

var $jdlqN = parcelRequire("jdlqN");

var $c70Lr = parcelRequire("c70Lr");

var $2osAJ = parcelRequire("2osAJ");

var $7zjHG = parcelRequire("7zjHG");

var $8SPcB = parcelRequire("8SPcB");

var $es8mD = parcelRequire("es8mD");

var $gYsK7 = parcelRequire("gYsK7");

var $8RqHP = parcelRequire("8RqHP");
function $3c9a3ebb8ee397f0$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $3c9a3ebb8ee397f0$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $3c9a3ebb8ee397f0$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $3c9a3ebb8ee397f0$export$849633012686f7ee(file)
    };
}
async function $3c9a3ebb8ee397f0$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $3c9a3ebb8ee397f0$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $3c9a3ebb8ee397f0$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $3c9a3ebb8ee397f0$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $3c9a3ebb8ee397f0$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $3c9a3ebb8ee397f0$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $3c9a3ebb8ee397f0$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2tm8x)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdlqN)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2osAJ)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdlqN)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c70Lr)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iBOon)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2sfBf)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($es8mD)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHwqN)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($RiK2l)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8SPcB)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7zjHG)))
    }
];
function $3c9a3ebb8ee397f0$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $3c9a3ebb8ee397f0$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $8RqHP.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gYsK7)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iABw2)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7hpMa)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dGYEZ)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("2tm8x", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1ccf7616b127308b$var$_react = $1ccf7616b127308b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1ccf7616b127308b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ccf7616b127308b$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $1ccf7616b127308b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1ccf7616b127308b$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $1ccf7616b127308b$var$_default = module.exports.default = $1ccf7616b127308b$var$PdfDocument24Icon;

});

parcelRegister("RiK2l", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0a037d07967bfa4f$var$_react = $0a037d07967bfa4f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $0a037d07967bfa4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0a037d07967bfa4f$var$Gif24Icon = (props)=>/*#__PURE__*/ $0a037d07967bfa4f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$0a037d07967bfa4f$var$Gif24Icon.displayName = 'Gif24Icon';
var $0a037d07967bfa4f$var$_default = module.exports.default = $0a037d07967bfa4f$var$Gif24Icon;

});

parcelRegister("cHwqN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $93f2a85309224bbe$var$_react = $93f2a85309224bbe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $93f2a85309224bbe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $93f2a85309224bbe$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $93f2a85309224bbe$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$93f2a85309224bbe$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $93f2a85309224bbe$var$_default = module.exports.default = $93f2a85309224bbe$var$PowerpointPresentation24Icon;

});

parcelRegister("2sfBf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1c9a4c12d2fc4227$var$_react = $1c9a4c12d2fc4227$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1c9a4c12d2fc4227$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1c9a4c12d2fc4227$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $1c9a4c12d2fc4227$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1c9a4c12d2fc4227$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $1c9a4c12d2fc4227$var$_default = module.exports.default = $1c9a4c12d2fc4227$var$WordDocument24Icon;

});

parcelRegister("iABw2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d888b0a1557aa645$var$_react = $d888b0a1557aa645$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d888b0a1557aa645$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d888b0a1557aa645$var$Sketch24Icon = (props)=>/*#__PURE__*/ $d888b0a1557aa645$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d888b0a1557aa645$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $d888b0a1557aa645$var$_default = module.exports.default = $d888b0a1557aa645$var$Sketch24Icon;

});

parcelRegister("7hpMa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $54ce1d7bd56eb231$var$_react = $54ce1d7bd56eb231$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $54ce1d7bd56eb231$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $54ce1d7bd56eb231$var$Figma24Icon = (props)=>/*#__PURE__*/ $54ce1d7bd56eb231$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$54ce1d7bd56eb231$var$Figma24Icon.displayName = 'Figma24Icon';
var $54ce1d7bd56eb231$var$_default = module.exports.default = $54ce1d7bd56eb231$var$Figma24Icon;

});

parcelRegister("dGYEZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9f7e406d5bea49df$var$_react = $9f7e406d5bea49df$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9f7e406d5bea49df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9f7e406d5bea49df$var$Executable24Icon = (props)=>/*#__PURE__*/ $9f7e406d5bea49df$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9f7e406d5bea49df$var$Executable24Icon.displayName = 'Executable24Icon';
var $9f7e406d5bea49df$var$_default = module.exports.default = $9f7e406d5bea49df$var$Executable24Icon;

});

parcelRegister("iBOon", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d8c2c58dddf5fcc0$var$_react = $d8c2c58dddf5fcc0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d8c2c58dddf5fcc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d8c2c58dddf5fcc0$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $d8c2c58dddf5fcc0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d8c2c58dddf5fcc0$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $d8c2c58dddf5fcc0$var$_default = module.exports.default = $d8c2c58dddf5fcc0$var$GoogleDoc24Icon;

});

parcelRegister("jdlqN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $dfcfdb061c664b77$var$_react = $dfcfdb061c664b77$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $dfcfdb061c664b77$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dfcfdb061c664b77$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $dfcfdb061c664b77$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$dfcfdb061c664b77$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $dfcfdb061c664b77$var$_default = module.exports.default = $dfcfdb061c664b77$var$GoogleForm24Icon;

});

parcelRegister("c70Lr", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $8d16bb363c31083e$var$_react = $8d16bb363c31083e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $8d16bb363c31083e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8d16bb363c31083e$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $8d16bb363c31083e$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$8d16bb363c31083e$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $8d16bb363c31083e$var$_default = module.exports.default = $8d16bb363c31083e$var$GoogleSheet24Icon;

});

parcelRegister("2osAJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1be4005185ae78d9$var$_react = $1be4005185ae78d9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1be4005185ae78d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1be4005185ae78d9$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $1be4005185ae78d9$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1be4005185ae78d9$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $1be4005185ae78d9$var$_default = module.exports.default = $1be4005185ae78d9$var$GoogleSlide24Icon;

});

parcelRegister("7zjHG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $582b1603b710ea90$var$_react = $582b1603b710ea90$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $582b1603b710ea90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $582b1603b710ea90$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $582b1603b710ea90$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$582b1603b710ea90$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $582b1603b710ea90$var$_default = module.exports.default = $582b1603b710ea90$var$ExcelSpreadsheet24Icon;

});

parcelRegister("8SPcB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $677b15938c7d624c$var$_react = $677b15938c7d624c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $677b15938c7d624c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $677b15938c7d624c$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $677b15938c7d624c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$677b15938c7d624c$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $677b15938c7d624c$var$_default = module.exports.default = $677b15938c7d624c$var$Spreadsheet24Icon;

});

parcelRegister("es8mD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a85a2b23143ceb75$var$_react = $a85a2b23143ceb75$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $a85a2b23143ceb75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a85a2b23143ceb75$var$Presentation24Icon = (props)=>/*#__PURE__*/ $a85a2b23143ceb75$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$a85a2b23143ceb75$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $a85a2b23143ceb75$var$_default = module.exports.default = $a85a2b23143ceb75$var$Presentation24Icon;

});

parcelRegister("gYsK7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c5b88baa981b1084$var$_react = $c5b88baa981b1084$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $c5b88baa981b1084$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c5b88baa981b1084$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $c5b88baa981b1084$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c5b88baa981b1084$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $c5b88baa981b1084$var$_default = module.exports.default = $c5b88baa981b1084$var$SourceCode24Icon;

});

parcelRegister("8RqHP", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $60b93921782d6d1e$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $60b93921782d6d1e$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $60b93921782d6d1e$export$ba4368c844580f9e);
function $60b93921782d6d1e$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $60b93921782d6d1e$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $60b93921782d6d1e$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $60b93921782d6d1e$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $60b93921782d6d1e$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $60b93921782d6d1e$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $60b93921782d6d1e$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("yWJlB", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("jODAF").then(()=>parcelRequire('eYIux'));

});


parcelRegister("2edT6", function(module, exports) {

$parcel$export(module.exports, "parseXMPMetaData", () => $1cac606283e05089$export$55c3bc9841b19de2);
function $1cac606283e05089$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("hNjKA", function(module, exports) {

$parcel$export(module.exports, "isRotated", () => $81d3fceca65be0fc$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $81d3fceca65be0fc$export$43142f95b8de7a91);
const $81d3fceca65be0fc$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $81d3fceca65be0fc$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $81d3fceca65be0fc$export$43142f95b8de7a91 = (orientation)=>{
    return $81d3fceca65be0fc$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("Nl5sY", function(module, exports) {

$parcel$export(module.exports, "takeSnapshot", () => $33ec34d1173165de$export$4269d30173168e5c);
const $33ec34d1173165de$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("3JZCV", function(module, exports) {

$parcel$export(module.exports, "getMediaCardSSR", () => $293d53ca8ea6912a$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $293d53ca8ea6912a$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $293d53ca8ea6912a$export$de7c49925e44d75d);

var $1QRxp = parcelRequire("1QRxp");
const $293d53ca8ea6912a$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $293d53ca8ea6912a$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $293d53ca8ea6912a$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $293d53ca8ea6912a$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $293d53ca8ea6912a$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $293d53ca8ea6912a$var$dashed = (param)=>param ? `-${param}` : '';
const $293d53ca8ea6912a$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$293d53ca8ea6912a$var$dashed(collectionName)}${$293d53ca8ea6912a$var$dashed(occurrenceKey)}`;
const $293d53ca8ea6912a$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $293d53ca8ea6912a$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $293d53ca8ea6912a$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $1QRxp.printFunctionCall)($293d53ca8ea6912a$export$4310981e0aa4ce67, $293d53ca8ea6912a$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $1QRxp.printScript)([
        $293d53ca8ea6912a$export$ede93d4564eaa8da.toString(),
        $293d53ca8ea6912a$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $293d53ca8ea6912a$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $293d53ca8ea6912a$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });

});
parcelRegister("1QRxp", function(module, exports) {

$parcel$export(module.exports, "printFunctionCall", () => $56ce1649d25a132b$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $56ce1649d25a132b$export$8b902fb69a2f17c1);
const $56ce1649d25a132b$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $56ce1649d25a132b$var$printParams = (args)=>args.map((arg)=>$56ce1649d25a132b$var$printParam(arg)).join(',');
const $56ce1649d25a132b$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$56ce1649d25a132b$var$printParams(args)});`;
const $56ce1649d25a132b$export$8b902fb69a2f17c1 = (statements)=>`(function(){
  ${statements.join(';')}
})();
`;

});


parcelRegister("jR4hE", function(module, exports) {

$parcel$export(module.exports, "getSSRData", () => $815e3e27cebcb154$export$d3a890b0f7844b6f);

var $3JZCV = parcelRequire("3JZCV");
const $815e3e27cebcb154$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $3JZCV.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $3JZCV.getKey)(identifier)];
};

});

parcelRegister("8Kbwv", function(module, exports) {

$parcel$export(module.exports, "isBigger", () => $7b6d905fc3b6f0e9$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $7b6d905fc3b6f0e9$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $7b6d905fc3b6f0e9$export$b3e10e1f0fbb71db);

var $5uXOq = parcelRequire("5uXOq");
const $7b6d905fc3b6f0e9$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $7b6d905fc3b6f0e9$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $7b6d905fc3b6f0e9$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $7b6d905fc3b6f0e9$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $7b6d905fc3b6f0e9$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}

});








parcelRegister("52TPO", function(module, exports) {

$parcel$export(module.exports, "useShouldRenderCardLite", () => $ecc0d54d655bdd17$export$dfe7863e47060af4);

var $5uXOq = parcelRequire("5uXOq");

var $kir0S = parcelRequire("kir0S");
const $ecc0d54d655bdd17$export$dfe7863e47060af4 = (isScrolling)=>{
    const { isInitialRender: isInitialRender } = (0, $kir0S.default)();
    const previouslyRenderedLiteCard = (0, $5uXOq.useRef)(false);
    if (isScrolling && (isInitialRender || previouslyRenderedLiteCard.current)) {
        previouslyRenderedLiteCard.current = true;
        return true;
    }
    previouslyRenderedLiteCard.current = false;
    return false;
};

});
parcelRegister("kir0S", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a060b75ae68d73c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $9a060b75ae68d73c$var$useRenderState = ()=>{
    const isInitialRender = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        isInitialRender.current = false;
    }, []);
    return {
        isInitialRender: isInitialRender.current
    };
};
var $9a060b75ae68d73c$export$2e2bcd8739ae039 = $9a060b75ae68d73c$var$useRenderState;

});



parcelRegister("g94HQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $80b237a582f17b1a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $biEfA = parcelRequire("biEfA");

var $7gWdR = parcelRequire("7gWdR");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");


var $3eGwD = parcelRequire("3eGwD");

var $guFRy = parcelRequire("guFRy");

var $1fZVH = parcelRequire("1fZVH");

var $67sX6 = parcelRequire("67sX6");

var $3UY9S = parcelRequire("3UY9S");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $drQJq = parcelRequire("drQJq");

var $bQegf = parcelRequire("bQegf");


var $bvghy = parcelRequire("bvghy");
const $80b237a582f17b1a$var$CARD_PADDING = 14;
const $80b237a582f17b1a$var$CARD_GROUP_HEADER_HEIGHT_WITH_PARENT = 3;
const $80b237a582f17b1a$var$CARD_GROUP_HEADER_HEIGHT = 29;
const $80b237a582f17b1a$export$9acc0474485b44b2 = ({ issueIdGroup: { issueIds: issueIds, isAttachedToParent: isAttachedToParent, parentId: parentId }, parentKey: parentKey, parentSummary: parentSummary, isRankable: isRankable, index: cardGroupIndex, offsetTop: offsetTop, ...props })=>{
    const autobatch = (0, $1fZVH.useAutobatch)();
    const containerRef = (0, $5uXOq.useRef)(null);
    const [closestEdge, setClosestEdge] = (0, $5uXOq.useState)(null);
    const batchSetClosestEdge = (0, $5uXOq.useCallback)((edge)=>autobatch(()=>setClosestEdge(edge)), [
        autobatch
    ]);
    const getPlatformIssueById = (0, $67sX6.useBoardSelector)((0, $5mTgl.platformIssueSelector));
    const issueChildren = (0, $67sX6.useBoardSelector)((0, $3UY9S.getIssueChildren));
    const cardHeightCache = (0, $bvghy.useCardHeightCache)();
    const cacheOptions = (0, $5uXOq.useMemo)(()=>({
            cache: cardHeightCache,
            getCacheKey: (index)=>issueIds[index]
        }), [
        issueIds,
        cardHeightCache
    ]);
    const { rows: rows, totalSize: totalSize, isScrolling: isScrolling } = (0, $guFRy.useVirtual)({
        rowCount: issueIds.length,
        getDefaultRowSize: ()=>(0, $7455914ed26b7de2$export$428a1825e984a589),
        offsetTop: offsetTop + (isAttachedToParent ? $80b237a582f17b1a$var$CARD_GROUP_HEADER_HEIGHT_WITH_PARENT : $80b237a582f17b1a$var$CARD_GROUP_HEADER_HEIGHT),
        cacheOptions: cacheOptions
    });
    const cardContainerProps = (0, $5uXOq.useRef)(props);
    cardContainerProps.current = props;
    const renderCard = (0, $5uXOq.useCallback)((issueEntry, index)=>!(0, $3eGwD.isIssueEntryGroup)(issueEntry) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $drQJq.default), {
            ...cardContainerProps.current,
            key: issueEntry.issueId,
            id: issueEntry.issueId,
            index: index,
            groupParentId: parentId
        }), [
        parentId
    ]);
    const issueEntries = (0, $5uXOq.useMemo)(()=>issueIds.map((issueId)=>({
                type: 'issue',
                issueId: issueId
            })), [
        issueIds
    ]);
    const renderer = (0, $bQegf.useRowRenderer)({
        cardEntries: issueEntries,
        footer: null,
        footerIndex: issueEntries.length,
        placeholder: null,
        renderCard: renderCard,
        showFooter: false
    });
    (0, $5uXOq.useEffect)(()=>(0, $7gWdR.dropTargetForElements)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            element: containerRef.current,
            getIsSticky: ()=>true,
            getData: ({ input: input, element: element })=>{
                const issueChild = getPlatformIssueById(issueIds[0]);
                return (0, $biEfA.attachClosestEdge)({
                    type: (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c),
                    cardId: parentId,
                    cardIndex: cardGroupIndex,
                    columnId: issueChild?.columnId,
                    swimlaneId: issueChild?.swimlaneId
                }, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                });
            },
            canDrop: (args)=>args.source.data.type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c) && isRankable && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                !(args.source.data.cardId in issueChildren),
            onDrag: ({ self: self })=>{
                batchSetClosestEdge((0, $biEfA.extractClosestEdge)(self.data));
            },
            onDragEnter: ({ self: self })=>{
                batchSetClosestEdge((0, $biEfA.extractClosestEdge)(self.data));
            },
            onDragLeave: ()=>batchSetClosestEdge(null),
            onDrop: ()=>batchSetClosestEdge(null)
        }), [
        issueChildren,
        issueIds,
        parentId,
        cardGroupIndex,
        getPlatformIssueById,
        isRankable,
        batchSetClosestEdge
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80b237a582f17b1a$var$CardGroupContainer, {
        ref: containerRef,
        isAttachedToParent: isAttachedToParent,
        "data-testid": "software-board.board-container.board.card-group.card-group"
    }, !isAttachedToParent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: parentSummary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80b237a582f17b1a$var$CardGroupHeader, {
        "data-testid": "software-board.board-container.board.card-group.card-group-header",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80b237a582f17b1a$var$CardGroupHeaderKey, null, parentKey), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80b237a582f17b1a$var$CardGroupHeaderSummary, null, parentSummary))), (0, $4R6GH.fg)('board_subtasks_virtualisation') ? // eslint-disable-next-line jira/react/no-style-attribute
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80b237a582f17b1a$var$CardGroupDroppableContainer, {
        style: {
            minHeight: totalSize
        }
    }, (0, $4R6GH.fg)('board_rendering_optimisations') ? rows.map((row)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80b237a582f17b1a$var$CardRow, {
            ...row,
            key: row.key,
            offsetTop: offsetTop,
            isScrolling: isScrolling,
            Renderer: renderer
        })) : rows.map(({ index: index, top: top, forceRemeasure: forceRemeasure, measure: measure })=>renderer({
            index: index,
            isScrolling: isScrolling,
            forceRemeasure: forceRemeasure,
            measure: measure,
            offsetTop: top - offsetTop,
            style: {
                position: 'absolute',
                top: top - offsetTop,
                width: `calc(100% - ${$80b237a582f17b1a$var$CARD_PADDING}px)`,
                contain: 'style',
                marginTop: '0px'
            }
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80b237a582f17b1a$var$CardGroupDroppableContainer, null, issueIds.map((issueId, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $drQJq.default), {
            ...props,
            key: issueId,
            id: issueId,
            index: index,
            groupParentId: parentId
        }))), closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80b237a582f17b1a$var$CardGroupDropIndicator, {
        edge: closestEdge
    }));
};
const $80b237a582f17b1a$var$ConnectedCardGroup = (props)=>{
    const parent = (0, $67sX6.useBoardSelector)((state)=>{
        const { parentId: parentId } = props.issueIdGroup;
        return (0, $d2i8f.getIssueById)(state, parentId) || (0, $67Z81.getMissingParents)(state)[parentId];
    });
    const isRankable = (0, $67sX6.useBoardSelector)((0, $67Z81.isBoardRankable));
    return !!parent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80b237a582f17b1a$export$9acc0474485b44b2, {
        ...props,
        parentKey: parent.key,
        parentSummary: parent.summary,
        isRankable: isRankable
    });
};
var $80b237a582f17b1a$export$2e2bcd8739ae039 = $80b237a582f17b1a$var$ConnectedCardGroup;
const $80b237a582f17b1a$var$CardRow = /*#__PURE__*/ (0, $5uXOq.memo)(({ index: index, isScrolling: isScrolling, forceRemeasure: forceRemeasure, measure: measure, top: top, offsetTop: offsetTop, Renderer: Renderer })=>{
    const style = (0, $5uXOq.useMemo)(()=>({
            position: 'absolute',
            top: top - offsetTop,
            width: `calc(100% - ${$80b237a582f17b1a$var$CARD_PADDING}px)`,
            contain: 'style',
            marginTop: '0px'
        }), [
        top,
        offsetTop
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Renderer, {
        index: index,
        isScrolling: isScrolling,
        forceRemeasure: forceRemeasure,
        measure: measure,
        offsetTop: top,
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
        style: style
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $80b237a582f17b1a$var$CardGroupContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isAttachedToParent: isAttachedToParent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt412x7 _otyrv77o _bfhk4zhb _19ith6cr",
            __cmplp.isAttachedToParent ? "_2rkohyhq" : "_2rkoi2wt",
            __cmplp.isAttachedToParent ? "_19pkr5cr" : "_19pkv77o",
            __cmplp.className
        ])
    });
});
const $80b237a582f17b1a$var$CardGroupDroppableContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $80b237a582f17b1a$var$CardGroupHeaderKey = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwx1b66 _11c8qk37 _k48pmoej",
            __cmplp.className
        ])
    });
});
const $80b237a582f17b1a$var$CardGroupHeaderSummary = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1o8l _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $80b237a582f17b1a$var$CardGroupDropIndicator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { edge: edge, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1ltvidpf _1xi2idpf _4t3iyh40 _1pbycs5v _bfhk1r2e _lcxvglyw _1kt9b3bt _1cs8stnw _kfgt1y44 _1mp41y44 _1aukj39m _qnec16fl _rfx31ssb _14h8oh42",
            __cmplp.edge === 'bottom' && "_94n51n1a",
            __cmplp.edge === 'top' && "_154i1n1a",
            __cmplp.className
        ])
    });
});
const $80b237a582f17b1a$var$CardGroupHeader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyr1b66 _syaz1i3z _11c8qk37 _1e0c1txw _1n261q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bQegf", function(module, exports) {

$parcel$export(module.exports, "useRowRenderer", () => $51be9651e76214f7$export$809172435aa53585);

var $5uXOq = parcelRequire("5uXOq");

var $3eGwD = parcelRequire("3eGwD");


var $5gjnk = parcelRequire("5gjnk");
const $51be9651e76214f7$var$getKey = (index, footerIndex, cardEntry)=>{
    if (index === footerIndex) return 0, $7455914ed26b7de2$export$a57c8b25e45b243f;
    if (cardEntry) return (0, $3eGwD.isIssueEntryGroup)(cardEntry) ? (0, $3eGwD.getIssueEntryGroupKey)(cardEntry) : cardEntry.issueId;
    return 0, $7455914ed26b7de2$export$3eeaa9cdb48b7cc4;
};
const $51be9651e76214f7$export$809172435aa53585 = ({ cardEntries: cardEntries, footer: footer, renderCard: renderCard, footerIndex: footerIndex, placeholder: placeholder, showFooter: showFooter })=>(0, $5uXOq.useCallback)(({ index: index, isScrolling: isScrolling, style: style, measure: measure, forceRemeasure: forceRemeasure, offsetTop: offsetTop })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gjnk.default), {
            rowStyle: style,
            index: index,
            footerIndex: footerIndex,
            cardEntries: cardEntries,
            footer: footer,
            measure: measure,
            forceRemeasure: forceRemeasure,
            key: $51be9651e76214f7$var$getKey(index, footerIndex, cardEntries[index]),
            renderCard: renderCard,
            isScrolling: isScrolling,
            placeholder: placeholder,
            showFooter: showFooter,
            offsetTop: offsetTop
        }), [
        footerIndex,
        cardEntries,
        footer,
        renderCard,
        placeholder,
        showFooter
    ]);

});
parcelRegister("5gjnk", function(module, exports) {

$parcel$export(module.exports, "default", () => $0774629240aef2f4$export$2e2bcd8739ae039);
/* eslint-disable jira/react/no-style-attribute */ 
var $5uXOq = parcelRequire("5uXOq");

var $co1wz = parcelRequire("co1wz");

var $58K4A = parcelRequire("58K4A");

var $i8wwL = parcelRequire("i8wwL");

var $2m0b6 = parcelRequire("2m0b6");

var $7D59a = parcelRequire("7D59a");

var $1eicd = parcelRequire("1eicd");
const $0774629240aef2f4$var$RowRenderer = ({ index: index, footerIndex: footerIndex, cardEntries: cardEntries, rowStyle: rowStyle, forceRemeasure: forceRemeasure, measure: measure, footer: footer, renderCard: renderCard, isScrolling: isScrolling, placeholder: placeholder, showFooter: showFooter, offsetTop: offsetTop })=>{
    const onResize = (0, $7D59a.useEvent)(()=>{
        forceRemeasure(rowRef.current);
    });
    const rowRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (rowRef.current) measure(rowRef.current);
    }, [
        rowRef,
        measure
    ]);
    (0, $2m0b6.useResizeObserver)({
        ref: rowRef,
        onResize: onResize
    });
    const { isOverColumn: isOverColumn } = (0, $i8wwL.useIsCardOverColumn)();
    // If we have nothing to show except the placeholder
    if (cardEntries.length === 0 && !!placeholder && !showFooter) // Just measure the DIV once we have the ref which is good enough to determine its proper height
    return (0, $co1wz.ff)('backlog-active-sprints-list-markup-accessibility-fix_imavd') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
        style: rowStyle,
        ref: rowRef
    }, placeholder) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: rowStyle,
        ref: rowRef
    }, placeholder);
    // Handle the footer specific use case
    if (index === footerIndex) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eicd.ElementSizeMeasurer), {
        style: rowStyle,
        onResize: measure,
        showFooter: showFooter
    }, isOverColumn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $58K4A.CardDropIndicator), {
        edge: "top",
        style: {
            top: '-1px'
        }
    }), showFooter && footer));
    const cardEntry = cardEntries[index];
    // If there is no cardEntry
    // This will happen if we are attempting to render a footer but showFooter is false.
    if (cardEntry == null) return null;
    // Finally render a normal card
    return (0, $co1wz.ff)('backlog-active-sprints-list-markup-accessibility-fix_imavd') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
        style: rowStyle,
        ref: rowRef
    }, renderCard(cardEntry, index, isScrolling, onResize, offsetTop)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: rowStyle,
        ref: rowRef
    }, renderCard(cardEntry, index, isScrolling, onResize, offsetTop));
};
var $0774629240aef2f4$export$2e2bcd8739ae039 = $0774629240aef2f4$var$RowRenderer;

});
parcelRegister("1eicd", function(module, exports) {

$parcel$export(module.exports, "ElementSizeMeasurer", () => $54855d4096fe50af$export$fc67fd6b0f89895b);

var $5uXOq = parcelRequire("5uXOq");

var $co1wz = parcelRequire("co1wz");
const $54855d4096fe50af$export$fc67fd6b0f89895b = ({ onResize: onResize, children: children, style: style, showFooter: showFooter })=>{
    const resizeObserver = (0, $5uXOq.useRef)(null);
    const onElement = (0, $5uXOq.useCallback)((element)=>{
        // If we have an existing resize observer, disconnect it before we
        // re-create it
        resizeObserver.current?.disconnect();
        if (element == null) // Do nothing
        return;
        // Anytime we enter this function, we want to rebind the ResizeObserver since
        // our calback has changed (see below dependencies)
        resizeObserver.current = new ResizeObserver(()=>{
            onResize?.(element);
        });
        resizeObserver.current.observe(element);
    }, [
        resizeObserver,
        onResize
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // If we are unmounting, cleanup the resize observer by disconnecting it
            resizeObserver.current?.disconnect();
        }, [
        resizeObserver
    ]);
    if ((0, $co1wz.ff)('backlog-active-sprints-list-markup-accessibility-fix_imavd')) return showFooter ? // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
        style: style,
        ref: onElement
    }, children) : // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
        style: style,
        ref: onElement,
        "aria-hidden": "true"
    }, children);
    return(// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: style,
        ref: onElement
    }, children));
};

});



parcelRegister("bvghy", function(module, exports) {

$parcel$export(module.exports, "useCardHeightCache", () => $e49e2d845ff8f15a$export$bd41b84dc563782c);

var $5uXOq = parcelRequire("5uXOq");
const $e49e2d845ff8f15a$var$CARD_HEIGHTS_CACHE = new Map();
const $e49e2d845ff8f15a$export$bd41b84dc563782c = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $e49e2d845ff8f15a$var$CARD_HEIGHTS_CACHE;
const $e49e2d845ff8f15a$export$201114c49d4ccb5a = ()=>{
    (0, $5uXOq.useEffect)(()=>()=>{
            // Only run the cleanup if the FF is enabled.
            $e49e2d845ff8f15a$var$CARD_HEIGHTS_CACHE.clear();
        }, []);
};

});


parcelRegister("50AZv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b553d312e832c6de$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3f2cs = parcelRequire("3f2cs");

var $8QpSo = parcelRequire("8QpSo");

var $5rFbt = parcelRequire("5rFbt");

var $cSD7y = parcelRequire("cSD7y");


var $Gd7Ss = parcelRequire("Gd7Ss");

var $bC2fB = parcelRequire("bC2fB");

var $2xFXk = parcelRequire("2xFXk");


var $iuuJH = parcelRequire("iuuJH");

var $2f454 = parcelRequire("2f454");

var $63VRQ = parcelRequire("63VRQ");

var $67sX6 = parcelRequire("67sX6");

var $1vXOx = parcelRequire("1vXOx");

var $kc6Ry = parcelRequire("kc6Ry");

var $lIysR = parcelRequire("lIysR");

var $9OPlz = parcelRequire("9OPlz");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");


var $dwtg8 = parcelRequire("dwtg8");
const $b553d312e832c6de$var$isCardDroppableFactory = (0, $8QpSo.default)((isIncrementPlanningBoard, isCMPBoard, swimlaneId, isRankable, id, showTransitionZonesOnThisColumn, draggingCardHoverIntent)=>(draggableCardData)=>{
        if (isIncrementPlanningBoard) return true;
        if (isCMPBoard) {
            if (swimlaneId && draggableCardData.swimlaneId !== swimlaneId) return false;
            if (!isRankable && draggableCardData.columnId === id) return false;
        }
        if (showTransitionZonesOnThisColumn && !draggingCardHoverIntent) return false;
        // Childless cards cannot be moved to a subtask type swimlane and vice-versa
        const sourceSwimlaneId = draggableCardData.swimlaneId;
        if (swimlaneId && (swimlaneId === (0, $iuuJH.SWIMLANE_CHILDLESS) && sourceSwimlaneId !== (0, $iuuJH.SWIMLANE_CHILDLESS) || swimlaneId !== (0, $iuuJH.SWIMLANE_CHILDLESS) && sourceSwimlaneId === (0, $iuuJH.SWIMLANE_CHILDLESS))) return false;
        return true;
    });
const $b553d312e832c6de$export$c31df4bd766f9c35 = ()=>{
    return (state, ownProps)=>{
        const { id: id, isLastSwimlane: isLastSwimlane, swimlaneId: swimlaneId } = ownProps;
        const column = (0, $fyeGd.getColumnById)(state, id);
        const childrenDropZoneType = ownProps.dropZoneType || (0, $5mTgl.getCardDndType)(state)(isLastSwimlane);
        const draggingCardSourceColumnId = (0, $9OPlz.draggingCardSourceColumnIdSelector)(state);
        const draggingCardSourceSwimlaneId = (0, $9OPlz.draggingCardSourceSwimlaneIdSelector)(state);
        const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
        const anyColumnUpdating = (0, $5mTgl.isAnyColumnUpdating)(state);
        const hasDropZones = (0, $9OPlz.hasNonGlobalTransitions)(state) || (0, $fyeGd.hasMultipleStatusesPerColumn)(state) || (0, $lIysR.hasDifferentIssueTypeTransitionsInColumns)(state);
        const shouldShowDropZoneForSwimlane = ()=>{
            if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return (0, $5mTgl.isSwimlaneTransitionZoneEnabledForSubtask)(state)(isLastSwimlane);
            return true;
        };
        const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        const isRankable = (0, $67Z81.isBoardRankable)(state);
        const isDraggingSubtask = (0, $5mTgl.isDraggingSubtaskSelector)(state);
        const shouldDisableRank = !(0, $67Z81.isBoardRankable)(state);
        const hasNoTransition = isCMPBoard && (0, $9OPlz.hasNoTransitionSelector)(state);
        const isSourceColumn = draggingCardSourceColumnId === id;
        // for a multi-project board, when at lease one project is not rankable, we should show the transition zones
        const hasOneNotRankableProject = (0, $67Z81.isBoardRankable)(state) && Object.values((0, $67Z81.getIssueProjects)(state)).some((project)=>!project.canRank);
        // Software CMP projects are the only ones that can disable the transition in same column.
        const disableTransitionsInSameColumn = (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).DISABLE_TRANSITION_IN_SAME_COLUMN) && isSourceColumn;
        const disableTransitionAcrossSwimlane = swimlaneId && swimlaneId !== draggingCardSourceSwimlaneId;
        const shouldShowTransitionZones = ()=>{
            if (isIncrementPlanningBoard) return false;
            if (anyColumnUpdating || draggingCardSourceColumnId == null || !shouldShowDropZoneForSwimlane()) return false;
            if (isCMPBoard) {
                if (disableTransitionAcrossSwimlane || disableTransitionsInSameColumn) return false;
                if (isDraggingSubtask || shouldDisableRank || hasNoTransition || hasOneNotRankableProject) return true;
            }
            return hasDropZones || (0, $9OPlz.hasConditionsOnTransitions)(state);
        };
        const showTransitionZonesOnThisColumn = column?.type === (0, $5rFbt.ColumnType).STATUS && shouldShowTransitionZones();
        const draggingCardHoverIntent = (0, $9OPlz.draggingCardHoverIntentSelector)(state);
        const isDraggingOverThisColumnWithHoverIntent = showTransitionZonesOnThisColumn && (0, $9OPlz.draggingCardTargetColumnIdSelector)(state) === id && draggingCardHoverIntent;
        const TransitionZones = showTransitionZonesOnThisColumn ? (0, $dwtg8.default) : undefined;
        const shouldDisableDrop = ()=>{
            if (isIncrementPlanningBoard) return false;
            if (isCMPBoard) {
                if (shouldDisableRank && draggingCardSourceColumnId === id) return true;
                if (disableTransitionAcrossSwimlane) return true;
            }
            return anyColumnUpdating || (0, $9OPlz.isDragInSnapMode)(state) && hasDropZones || showTransitionZonesOnThisColumn && (0, $lIysR.shouldDisableDropOnColumn)(state)(id);
        };
        const isDraggable = (0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$1d4594bb2516d9ef] && !isIncrementPlanningBoard && !anyColumnUpdating && (0, $5mTgl.isInlineColumnEditEnabled)(state) && !swimlaneId && (0, $9OPlz.getAnyCardEditingSummary)(state) === false;
        return {
            isDraggable: isDraggable,
            appearance: (0, $5mTgl.getColumnTheme)(state, id),
            isUpdating: (0, $5mTgl.isColumnUpdating)(state)(id),
            isDone: (0, $fyeGd.isDoneColumn)(column),
            isFlexible: (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).FLEXIBLE_BOARD_COLUMNS),
            // passing ownProps
            id: ownProps.id,
            header: ownProps.header || null,
            children: ownProps.children || null,
            draggableIndex: ownProps.draggableIndex,
            footer: ownProps.footer || null,
            childrenDropZoneType: childrenDropZoneType,
            dropZoneMode: !false ? (0, $04f8b478903fce7b$export$32109232c094e11e) : (0, $04f8b478903fce7b$export$f64308b4d686711f),
            isLastSwimlane: ownProps.isLastSwimlane,
            isOutlined: isDraggingOverThisColumnWithHoverIntent,
            TransitionZones: TransitionZones,
            isDropDisabled: shouldDisableDrop(),
            swimlaneId: swimlaneId,
            isCardDroppable: $b553d312e832c6de$var$isCardDroppableFactory(isIncrementPlanningBoard, isCMPBoard, swimlaneId, isRankable, id, showTransitionZonesOnThisColumn, draggingCardHoverIntent)
        };
    };
};
const $b553d312e832c6de$var$mapDispatchToProps = (dispatch, ownProps)=>({
        dispatch: dispatch,
        onRename: (0, $3f2cs.bindActionCreators)((0, $63VRQ.columnRenameRequest), dispatch),
        onDragLeave: (dragType)=>{
            if (dragType === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c)) dispatch((0, $2f454.cardDragOverTransitionRequest)(null, ownProps.id, false));
        }
    });
const $b553d312e832c6de$var$ColumnNew = (props)=>{
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const onDragLeave = (0, $5uXOq.useCallback)((dragType)=>{
        if (dragType === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c)) dispatch((0, $2f454.cardDragOverTransitionRequest)(null, props.id, false));
    }, [
        dispatch,
        props.id
    ]);
    const { id: id, isLastSwimlane: isLastSwimlane, swimlaneId: swimlaneId } = props;
    const column = (0, $67sX6.useBoardSelector)((state)=>(0, $fyeGd.getColumnById)(state, id));
    const childrenDropZoneType = (0, $67sX6.useBoardSelector)((state)=>props.dropZoneType || (0, $5mTgl.getCardDndType)(state)(isLastSwimlane));
    const draggingCardSourceColumnId = (0, $67sX6.useBoardSelector)((0, $9OPlz.draggingCardSourceColumnIdSelector));
    const draggingCardSourceSwimlaneId = (0, $67sX6.useBoardSelector)((0, $9OPlz.draggingCardSourceSwimlaneIdSelector));
    const swimlaneMode = (0, $67sX6.useBoardSelector)((0, $45cXl.getSwimlaneMode));
    const anyColumnUpdating = (0, $67sX6.useBoardSelector)((0, $5mTgl.isAnyColumnUpdating));
    const hasDropZones = (0, $67sX6.useBoardSelector)((state)=>(0, $9OPlz.hasNonGlobalTransitions)(state) || (0, $fyeGd.hasMultipleStatusesPerColumn)(state) || (0, $lIysR.hasDifferentIssueTypeTransitionsInColumns)(state));
    const isSwimlaneTransitionZoneEnabledForSubtaskFn = (0, $67sX6.useBoardSelector)((0, $5mTgl.isSwimlaneTransitionZoneEnabledForSubtask));
    const shouldShowDropZoneForSwimlane = ()=>{
        if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return isSwimlaneTransitionZoneEnabledForSubtaskFn(isLastSwimlane);
        return true;
    };
    const isIncrementPlanningBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const isRankable = (0, $67sX6.useBoardSelector)((0, $67Z81.isBoardRankable));
    const isDraggingSubtask = (0, $67sX6.useBoardSelector)((0, $5mTgl.isDraggingSubtaskSelector));
    const shouldDisableRank = (0, $67sX6.useBoardSelector)((state)=>!(0, $67Z81.isBoardRankable)(state));
    const hasNoTransition = (0, $67sX6.useBoardSelector)((state)=>isCMPBoard && (0, $9OPlz.hasNoTransitionSelector)(state));
    const isSourceColumn = draggingCardSourceColumnId === id;
    // for a multi-project board, when at lease one project is not rankable, we should show the transition zones
    const hasOneNotRankableProject = (0, $67sX6.useBoardSelector)((state)=>(0, $67Z81.isBoardRankable)(state) && Object.values((0, $67Z81.getIssueProjects)(state)).some((project)=>!project.canRank));
    // Software CMP projects are the only ones that can disable the transition in same column.
    const disableTransitionsInSameColumn = (0, $67sX6.useBoardSelector)((state)=>(0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).DISABLE_TRANSITION_IN_SAME_COLUMN) && isSourceColumn);
    const disableTransitionAcrossSwimlane = swimlaneId && swimlaneId !== draggingCardSourceSwimlaneId;
    const hasConditionsOnTransitionsValue = (0, $67sX6.useBoardSelector)((0, $9OPlz.hasConditionsOnTransitions));
    const shouldShowTransitionZones = ()=>{
        if (isIncrementPlanningBoard) return false;
        if (anyColumnUpdating || draggingCardSourceColumnId == null || !shouldShowDropZoneForSwimlane()) return false;
        if (isCMPBoard) {
            if (disableTransitionAcrossSwimlane || disableTransitionsInSameColumn) return false;
            if (isDraggingSubtask || shouldDisableRank || hasNoTransition || hasOneNotRankableProject) return true;
        }
        return hasDropZones || hasConditionsOnTransitionsValue;
    };
    const showTransitionZonesOnThisColumn = column?.type === (0, $5rFbt.ColumnType).STATUS && shouldShowTransitionZones();
    const draggingCardHoverIntent = (0, $67sX6.useBoardSelector)((0, $9OPlz.draggingCardHoverIntentSelector));
    const isDraggingOverThisColumnWithHoverIntent = (0, $67sX6.useBoardSelector)((state)=>showTransitionZonesOnThisColumn && (0, $9OPlz.draggingCardTargetColumnIdSelector)(state) === id && draggingCardHoverIntent);
    const TransitionZones = showTransitionZonesOnThisColumn ? (0, $dwtg8.default) : undefined;
    const shouldDisableDrop = (0, $67sX6.useBoardSelector)((state)=>{
        if (isIncrementPlanningBoard) return false;
        if (isCMPBoard) {
            if (shouldDisableRank && draggingCardSourceColumnId === id) return true;
            if (disableTransitionAcrossSwimlane) return true;
        }
        return anyColumnUpdating || (0, $9OPlz.isDragInSnapMode)(state) && hasDropZones || showTransitionZonesOnThisColumn && (0, $lIysR.shouldDisableDropOnColumn)(state)(id);
    });
    const isDraggable = (0, $67sX6.useBoardSelector)((state)=>(0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$1d4594bb2516d9ef] && !isIncrementPlanningBoard && !anyColumnUpdating && (0, $5mTgl.isInlineColumnEditEnabled)(state) && !swimlaneId && (0, $9OPlz.getAnyCardEditingSummary)(state) === false);
    const isUpdating = (0, $67sX6.useBoardSelector)((state)=>(0, $5mTgl.isColumnUpdating)(state)(id));
    const isFlexible = (0, $67sX6.useBoardSelector)((state)=>(0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).FLEXIBLE_BOARD_COLUMNS));
    const appearance = (0, $67sX6.useBoardSelector)((state)=>(0, $5mTgl.getColumnTheme)(state, id));
    const isCardDroppable = (0, $5uXOq.useMemo)(()=>$b553d312e832c6de$var$isCardDroppableFactory(isIncrementPlanningBoard, isCMPBoard, swimlaneId, isRankable, id, showTransitionZonesOnThisColumn, draggingCardHoverIntent), [
        isIncrementPlanningBoard,
        isCMPBoard,
        swimlaneId,
        isRankable,
        id,
        showTransitionZonesOnThisColumn,
        draggingCardHoverIntent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Gd7Ss.default), {
        onDragLeave: onDragLeave,
        isDraggable: isDraggable,
        appearance: appearance,
        isUpdating: isUpdating,
        isDone: (0, $fyeGd.isDoneColumn)(column),
        isFlexible: isFlexible,
        // passing ownProps
        id: props.id,
        header: props.header || null,
        draggableIndex: props.draggableIndex,
        footer: props.footer || null,
        childrenDropZoneType: childrenDropZoneType,
        dropZoneMode: !false ? (0, $04f8b478903fce7b$export$32109232c094e11e) : (0, $04f8b478903fce7b$export$f64308b4d686711f),
        isOutlined: isDraggingOverThisColumnWithHoverIntent,
        TransitionZones: TransitionZones,
        isDropDisabled: shouldDisableDrop,
        swimlaneId: swimlaneId,
        isCardDroppable: isCardDroppable
    }, props.children);
};
var $b553d312e832c6de$export$2e2bcd8739ae039 = (0, $cSD7y.componentWithFG)('board_rendering_optimisations', $b553d312e832c6de$var$ColumnNew, (0, $bC2fB.connect)($b553d312e832c6de$export$c31df4bd766f9c35, $b553d312e832c6de$var$mapDispatchToProps)((0, $Gd7Ss.default)));

});
parcelRegister("Gd7Ss", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be4bd693aecce41$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $i8wwL = parcelRequire("i8wwL");

var $fPZsD = parcelRequire("fPZsD");
const $7be4bd693aecce41$var$DraggableColumnMain = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8wwL.ColumnEdgeContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fPZsD.DraggableColumn), props));
var $7be4bd693aecce41$export$2e2bcd8739ae039 = $7be4bd693aecce41$var$DraggableColumnMain;

});
parcelRegister("fPZsD", function(module, exports) {

$parcel$export(module.exports, "DraggableColumn", () => $6d54eab38a21fed6$export$a80792b86712355c);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");


var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $b8gJu = parcelRequire("b8gJu");

var $645AZ = parcelRequire("645AZ");

var $3kNE6 = parcelRequire("3kNE6");

var $5B6CN = parcelRequire("5B6CN");

var $gn6gY = parcelRequire("gn6gY");

var $lLx27 = parcelRequire("lLx27");
const $6d54eab38a21fed6$export$a80792b86712355c = (props)=>{
    const { id: id, isOutlined: isOutlined, swimlaneId: swimlaneId, TransitionZones: TransitionZones, isFlexible: isFlexible, isDraggable: isDraggable = false, isDropDisabled: isDropDisabled = false, isUpdating: isUpdating = false, isCollapsed: isCollapsed = false, header: header, draggableIndex: draggableIndex, appearance: appearance = (0, $3kNE6.ColumnTheme).Default, footer: footer = null, onDragLeave: onDragLeave, isCardDroppable: isCardDroppable, children: children } = props;
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const { dragPreview: dragPreview, closestEdge: closestEdge } = (0, $gn6gY.useDraggableColumn)({
        isDraggable: isDraggable,
        elementRef: wrapperRef,
        columnId: id,
        swimlaneId: swimlaneId,
        columnIndex: draggableIndex,
        renderPreview: ()=>header,
        onDragLeave: onDragLeave,
        isCardDroppable: isCardDroppable
    });
    const handleOnMouseDown = (0, $5uXOq.useCallback)(()=>{
        // Clear any text selection to prevent unexpected dragging behaviour
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.getSelection()?.removeAllRanges();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6d54eab38a21fed6$export$1f99da106a398c44, {
        innerRef: wrapperRef,
        isCollapsed: isCollapsed,
        isFlexible: isFlexible,
        "data-component-selector": (0, $b8gJu.DRAGGABLE_COLUMN_SELECTOR_NAME),
        onMouseDown: handleOnMouseDown,
        "data-testid": "platform-board-kit.ui.column.draggable-column.styled-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6d54eab38a21fed6$export$96bd54359ad61258, {
        isCollapsed: isCollapsed,
        isFlexible: isFlexible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLx27.default), {
        id: id,
        swimlaneId: swimlaneId,
        isDraggable: isDraggable,
        isDragging: false,
        isDropDisabled: isDropDisabled,
        isOutlined: isOutlined,
        isUpdating: isUpdating,
        appearance: appearance,
        header: header,
        footer: footer,
        TransitionZones: TransitionZones,
        isCollapsed: isCollapsed,
        isFlexible: isFlexible
    }, children)), closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5B6CN.ColumnDropIndicator), {
        edge: closestEdge
    }), dragPreview);
};
const $6d54eab38a21fed6$var$StyledWrapperExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexible: isFlexible, isCollapsed: isCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c1txw _2lx21bp4 _1wpz1wug _v564stkc _1ul91t53 _p12f1t53",
            __cmplp.isFlexible ? "_16jlkb7n _1o9zkb7n _i0dlf1ug" : "_16jlkb7n _1o9zkb7n _i0dl1wug",
            __cmplp.isCollapsed && !__cmplp.isFlexible && "_1ul91ex1 _p12f1ex1",
            __cmplp.isFlexible && "_1ul91qnl _p12f1osq",
            __cmplp.isCollapsed && __cmplp.isFlexible && "_1ul91ex1 _p12f1osq",
            __cmplp.className
        ])
    });
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
const $6d54eab38a21fed6$var$StyledWrapperControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "j176hd-0"
})`position:relative;display:flex;flex-direction:column;align-self:auto;flex:${(props)=>props.isFlexible ? '1 1' : '1 1 auto'};min-width:${(props)=>{
    if (props.isCollapsed) return 0, $645AZ.collapsedColumnWithMarginWidth;
    if (!props.isFlexible) return `${0, $645AZ.columnWithMarginWidth}`;
    return 0, $645AZ.columnMinWithMarginWidth;
}}px;max-width:${(props)=>{
    if (props.isFlexible) return '100%';
    return props.isCollapsed ? `${0, $645AZ.collapsedColumnWithMarginWidth}px` : `${0, $645AZ.columnWithMarginWidth}px`;
}};transition:min-width 300ms,max-width 300ms ease-in;`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $6d54eab38a21fed6$export$1f99da106a398c44 = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $6d54eab38a21fed6$var$StyledWrapperExperiment, $6d54eab38a21fed6$var$StyledWrapperControl); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6d54eab38a21fed6$var$StyledDraggableColumnControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "j176hd-1"
})`border-radius:${(0, $645AZ.layout).cardListRadius}px;display:flex;flex-direction:column;align-self:auto;contain:'style';flex:1 1 auto;margin-left:${"var(--ds-space-050, 0.25rem)"};margin-right:${"var(--ds-space-050, 0.25rem)"};min-width:${(props)=>{
    if (props.isCollapsed) return `${0, $645AZ.collapsedColumnFixedWidth}px`;
    return props.isFlexible ? `${0, $645AZ.columnMinWidth}px` : `${0, $645AZ.columnFixedWidth}px`;
}};max-width:${(props)=>{
    if (props.isFlexible) return 'none';
    return `${props.isCollapsed ? (0, $645AZ.collapsedColumnFixedWidth) : (0, $645AZ.columnFixedWidth)}px`;
}};box-shadow:${(props)=>props.isDragging ? `var(--ds-shadow-overlay, ${`0px 8px 12px ${(0, $829f609a65d26a98$exports).N50A}, 0 0 1px ${(0, $829f609a65d26a98$exports).N60A}`})` : 'initial'};background-color:${(props)=>props.isCollapsed ? 'transparent' : `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N20})`};transition:min-width 300ms,max-width 300ms ease-in;`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6d54eab38a21fed6$var$StyledDraggableColumnExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragging: isDragging, isCollapsed: isCollapsed, isFlexible: isFlexible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoi2wt _1e0c1txw _2lx21bp4 _1wpz1wug _njlpl5mv _16jlkb7n _1o9zkb7n _i0dl1wug _18u0pdf9 _2hwxpdf9 _1ul91ogy _p12f1ogy _v564stkc",
            __cmplp.isDragging ? "_16qsuwux" : "_16qsglyw",
            __cmplp.isCollapsed ? "_bfhk18uv" : "_bfhk1s4m",
            __cmplp.isCollapsed && !__cmplp.isFlexible && "_1ul91ylp _p12f1ylp",
            __cmplp.isFlexible && "_1ul91w81 _p12fglyw",
            __cmplp.isCollapsed && __cmplp.isFlexible && "_1ul91ylp _p12fglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $6d54eab38a21fed6$export$96bd54359ad61258 = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $6d54eab38a21fed6$var$StyledDraggableColumnExperiment, $6d54eab38a21fed6$var$StyledDraggableColumnControl);

});
parcelRegister("lLx27", function(module, exports) {

$parcel$export(module.exports, "default", () => $c37fcde6ece8122b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $7nsd3 = parcelRequire("7nsd3");

var $47bDC = parcelRequire("47bDC");

var $5vD8v = parcelRequire("5vD8v");

var $hGgHi = parcelRequire("hGgHi");


var $gwIPs = parcelRequire("gwIPs");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $645AZ = parcelRequire("645AZ");

var $3kNE6 = parcelRequire("3kNE6");

var $g503o = parcelRequire("g503o");

var $guHkC = parcelRequire("guHkC");

var $43IRS = parcelRequire("43IRS");
const $c37fcde6ece8122b$var$cardListCssClass = '__board-test-hook__column';
class $c37fcde6ece8122b$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isDragging: false,
            isDropDisabled: false,
            isUpdating: false,
            isOutlined: false,
            isCollapsed: false,
            appearance: 'default',
            footer: null
        };
    }
    static{
        this.contextType = (0, $43IRS.TransitionZoneIndicatorContainerContext);
    }
    renderPortalTransitionZone() {
        const { id: id, swimlaneId: swimlaneId, TransitionZones: TransitionZones } = this.props;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(TransitionZones)) return null;
        if (this.context) {
            const ref = this.context.getRef(id);
            if (ref && ref.current) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TransitionZones, {
                columnId: id,
                swimlaneId: swimlaneId
            }), ref.current);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TransitionZones, {
            columnId: id,
            swimlaneId: swimlaneId
        });
    }
    renderAkColumn(theme) {
        const { isDragging: isDragging, isDraggable: isDraggable, isOutlined: isOutlined, isUpdating: isUpdating, header: header, appearance: appearance, TransitionZones: TransitionZones, isCollapsed: isCollapsed, isFlexible: isFlexible } = this.props; // FIXME: This needs to be checked - done as part of typescript upgrade.
        // It can be more than ReactNode and typescript is not happy about this!
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const children = this.props.children;
        const renderChildren = ()=>{
            // If you want to use render props this component will give you back the props and some droppable
            // context for the external component to consume
            // Example: src/packages/software/board/board-container/board/columns-container/column/view.js
            if (!false && (0, (/*@__PURE__*/$parcel$interopDefault($5vD8v)))(this.props.children)) {
                // Our v-list under this column will need visibility over droppableProps
                const renderFunction = this.props.children || (()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null));
                return renderFunction(this.props);
            } // Fallback to generic non-virtualized implementation
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c37fcde6ece8122b$export$d969c1f3d7d90ef3 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            , {
                className: "__board-test-hook__card-list-container"
            }, children, this.props.footer);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47bDC.ThemeProvider), {
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c37fcde6ece8122b$var$StyledColumnWrapper // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: $c37fcde6ece8122b$var$cardListCssClass,
            isCollapsed: isCollapsed,
            isFlexible: isFlexible,
            appearance: appearance ?? (0, $3kNE6.ColumnTheme).Default
        }, header && /*#__PURE__*/ (0, $5uXOq.cloneElement)(header, {
            isDragging: isDragging,
            isDraggable: isDraggable,
            isUpdating: isUpdating,
            appearance: appearance
        }), TransitionZones && this.renderPortalTransitionZone(), renderChildren(), isOutlined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c37fcde6ece8122b$export$5beeae30d1389e5, {
            withHeader: header
        }), isUpdating && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $guHkC.Overlay), {
            appearance: appearance ?? (0, $3kNE6.ColumnTheme).Default
        })));
    }
    render() {
        const columnTheme = this.getTheme(this.props.appearance);
        return this.renderAkColumn(columnTheme);
    }
    constructor(...args){
        super(...args);
        this.getTheme = (theme)=>{
            if (theme && (0, $g503o.columnThemes)[theme]) return (0, $g503o.columnThemes)[theme];
            return (0, $g503o.columnThemes).default;
        };
    }
}
const $c37fcde6ece8122b$var$outlineWidth = 2; // eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c37fcde6ece8122b$var$OutlineControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1ef3ied-0"
})((props)=>({
        position: 'absolute',
        width: `calc(100% - ${$c37fcde6ece8122b$var$outlineWidth * 2}px)`,
        height: `calc(
${''}
        100% -${(props.withHeader ? (0, $645AZ.columnHeaderHeight) : 0) + $c37fcde6ece8122b$var$outlineWidth * 2}px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $645AZ.zIndex).icc,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        border: `${$c37fcde6ece8122b$var$outlineWidth}px solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B200})`}`,
        marginLeft: "var(--ds-space-negative-025, -2px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${(0, $645AZ.layout).cardListRadius}px`,
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        top: `${props.withHeader ? (0, $645AZ.columnHeaderHeight) : 0}px`,
        left: "var(--ds-space-025, 2px)"
    }));
const $c37fcde6ece8122b$var$OutlineExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withHeader: withHeader, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_xbj9jl": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `calc(100% - ${__cmplp.withHeader ? (0, $645AZ.columnHeaderHeight) : 0}) + ${$c37fcde6ece8122b$var$outlineWidth * 2}px)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1pbykb7n _19it24b2 _18u01i6y _2rko12x7 _lcxvglyw _1ltvv77o _1bsbmslj _4t3i78vx",
            __cmplp.withHeader ? "_154i1lfg" : "_154iidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c37fcde6ece8122b$export$5beeae30d1389e5 = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $c37fcde6ece8122b$var$OutlineExperiment, $c37fcde6ece8122b$var$OutlineControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $c37fcde6ece8122b$var$CardDroppableTargetControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1ef3ied-1"
})((props)=>({
        flex: '1 0 auto',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${(0, $645AZ.layout).smallGutter - (0, $gwIPs.gridSize) / 4}px ${(0, $645AZ.layout).smallGutter}px ${(0, $645AZ.layout).smallGutter}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minHeight: `${0, $645AZ.minCardHeight}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.isDisabled ? '0.5' : '1'
    }));
const $c37fcde6ece8122b$var$CardDroppableTargetExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _ca0q1l7b _u5f314y2 _n3td14y2 _19bv14y2 _1tkeys9h",
            __cmplp.isDisabled ? "_tzy4105o" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c37fcde6ece8122b$export$d969c1f3d7d90ef3 = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $c37fcde6ece8122b$var$CardDroppableTargetExperiment, $c37fcde6ece8122b$var$CardDroppableTargetControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c37fcde6ece8122b$var$StyledColumnWrapperControl = /*#__PURE__*/ (0, $47bDC.default)((0, $g503o.ColumnWrapperControl)).withConfig({
    componentId: "sc-1ef3ied-2"
})({
    display: 'flex',
    flexDirection: 'column'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c37fcde6ece8122b$var$StyledColumnWrapperExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $g503o.ColumnWrapperExperiment), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $c37fcde6ece8122b$var$StyledColumnWrapper = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $c37fcde6ece8122b$var$StyledColumnWrapperExperiment, $c37fcde6ece8122b$var$StyledColumnWrapperControl);

});



const $04f8b478903fce7b$export$32109232c094e11e = 'virtual';
const $04f8b478903fce7b$export$f64308b4d686711f = 'standard';

parcelRegister("dwtg8", function(module, exports) {

$parcel$export(module.exports, "default", () => $369d4c4f4f82e4b2$export$2e2bcd8739ae039);

var $3JOCw = parcelRequire("3JOCw");

var $vNXgH = parcelRequire("vNXgH");

var $8QpSo = parcelRequire("8QpSo");

var $6s1PB = parcelRequire("6s1PB");

var $lyM0I = parcelRequire("lyM0I");

var $bC2fB = parcelRequire("bC2fB");

var $iuuJH = parcelRequire("iuuJH");

var $2f454 = parcelRequire("2f454");

var $lIysR = parcelRequire("lIysR");

var $9OPlz = parcelRequire("9OPlz");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $3Rsmm = parcelRequire("3Rsmm");
const $369d4c4f4f82e4b2$var$checkIfTransitionIsEqual = (source, target)=>Object.keys(source).filter((key)=>key !== 'transitionId').every((key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        source[key] === // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        target[key]);
const $369d4c4f4f82e4b2$export$c31df4bd766f9c35 = ()=>{
    const deduplicatedTransitionsFactory = (0, $8QpSo.default)((transitions)=>(0, (/*@__PURE__*/$parcel$interopDefault($vNXgH)))(transitions, $369d4c4f4f82e4b2$var$checkIfTransitionIsEqual));
    return (state, ownProps)=>{
        const { columnId: columnId, swimlaneId: swimlaneId } = ownProps;
        const hasSwimlanes = (0, $45cXl.getSwimlaneMode)(state) !== (0, $iuuJH.NO_SWIMLANE).id;
        const sourceColumnId = (0, $9OPlz.draggingCardSourceColumnIdSelector)(state) || 0;
        const { transitions: transitions, isLoading: isLoading } = (0, $lIysR.draggingIssueTransitionsForColumnSelector)(state)(Number(columnId));
        const sourceStatus = (0, $9OPlz.draggingCardSourceStatusSelector)(state);
        const showAllTransitionZones = (0, $lIysR.makeGetShowAllTransitionZones)(state)(swimlaneId);
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        // Determine IF there are duplicate target dropzones. This can be done if there are multiple
        // transitions that have the same target status Id.
        const shouldShowTransitionNames = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(transitions, 'targetStatusId').length !== transitions.length;
        // We can still get duplicates here that we don't want to render. If they have the same transition name,
        // targetStatusId and isGlobal we DO NOT want to render them because they are fundamentally identical.
        const deduplicatedTransitions = deduplicatedTransitionsFactory(transitions);
        return {
            columnId: columnId,
            sourceColumnId: sourceColumnId,
            hasSwimlanes: hasSwimlanes,
            hoverIntent: (0, $9OPlz.draggingCardHoverIntentSelector)(state),
            columnDraggingOver: (0, $9OPlz.draggingCardTargetColumnIdSelector)(state) || null,
            notAvailableMessage: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3Rsmm.default).notAvailableMessageIssueTermRefresh : (0, $3Rsmm.default).notAvailableMessage,
            noTransitionMessage: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3Rsmm.default).noTransitionMessageIssueTermRefresh : (0, $3Rsmm.default).noTransitionMessage,
            transitions: deduplicatedTransitions,
            isLoading: isLoading,
            sourceStatus: sourceStatus,
            showAllTransitionZones: showAllTransitionZones,
            shouldRenderFullColumnTransitionZone: isCMPBoard,
            hideSourceStatusInLabel: !shouldShowTransitionNames
        };
    };
};
const $369d4c4f4f82e4b2$export$9e6a17cf56877796 = (dispatch, { columnId: columnId, swimlaneId: swimlaneId })=>({
        onCardDragOver: (transitionId, hoverIntent)=>dispatch((0, $2f454.cardDragOverTransitionRequest)(transitionId, Number(columnId), hoverIntent)),
        onTransitionSelected: (transitionId)=>dispatch((0, $2f454.cardDragSelectedTransition)(transitionId, Number(columnId), swimlaneId))
    });
const $369d4c4f4f82e4b2$var$ConnectedColumnTransitionZonesContainer = (0, $bC2fB.connect)($369d4c4f4f82e4b2$export$c31df4bd766f9c35, $369d4c4f4f82e4b2$export$9e6a17cf56877796)((0, $lyM0I.ColumnTransitionZonesContainer));
var $369d4c4f4f82e4b2$export$2e2bcd8739ae039 = $369d4c4f4f82e4b2$var$ConnectedColumnTransitionZonesContainer;

});
parcelRegister("lyM0I", function(module, exports) {

$parcel$export(module.exports, "ColumnTransitionZonesContainer", () => $35a2ac94dcf5015c$export$169a50ebb52c9a6);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $lFKmC = parcelRequire("lFKmC");

var $7gWdR = parcelRequire("7gWdR");

var $1fZVH = parcelRequire("1fZVH");

var $645AZ = parcelRequire("645AZ");

var $eEwGl = parcelRequire("eEwGl");

var $iVZBo = parcelRequire("iVZBo");

var $1oeFK = parcelRequire("1oeFK");


var $kMJOb = parcelRequire("kMJOb");
const $35a2ac94dcf5015c$export$169a50ebb52c9a6 = ({ columnId: columnId, swimlaneId: swimlaneId, columnDraggingOver: columnDraggingOver, onCardDragOver: onCardDragOver, hoverIntent: hoverIntent, onTransitionSelected: onTransitionSelected, hasSwimlanes: hasSwimlanes, sourceStatus: sourceStatus, notAvailableMessage: notAvailableMessage, noTransitionMessage: noTransitionMessage, isLoading: isLoading, shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone, hideSourceStatusInLabel: hideSourceStatusInLabel, transitions: allTransitions, sourceColumnId: sourceColumnId, showAllTransitionZones: showAllTransitionZones })=>{
    const autobatch = (0, $1fZVH.useAutobatch)();
    const [allowSelfColumnTransitions, setAllowSelfColumnTransitions] = (0, $5uXOq.useState)(false);
    const containerRef = (0, $5uXOq.useRef)(null);
    const hoverIntentOnThisColumn = hoverIntent && columnDraggingOver === columnId;
    const debouncedOnDragOverTransition = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((transitionId, hoverIntentOnZone)=>{
            if (!hoverIntentOnThisColumn) onCardDragOver(transitionId, hoverIntentOnZone);
        }, (0, $ff2886b69dd99cbd$export$c28377001f14d9d)), [
        hoverIntentOnThisColumn,
        onCardDragOver
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            debouncedOnDragOverTransition.cancel();
        }, [
        debouncedOnDragOverTransition
    ]);
    const onHoverOverTransitionToZone = (0, $5uXOq.useCallback)(()=>{
        setAllowSelfColumnTransitions(true);
    }, []);
    const renderTransitions = (transitions)=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eEwGl.LoadingContainer), null);
        if (transitions.length === 0 && noTransitionMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35a2ac94dcf5015c$export$819ff6ae0287a04, {
            hasSwimlanes: hasSwimlanes,
            zoneCount: transitions.length,
            shouldRenderFullColumnTransitionZone: Boolean(shouldRenderFullColumnTransitionZone),
            "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.inner-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iVZBo.NoTransitionContainer), {
            noTransitionMessage: noTransitionMessage
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35a2ac94dcf5015c$export$819ff6ae0287a04, {
            hasSwimlanes: hasSwimlanes,
            zoneCount: transitions.length,
            shouldRenderFullColumnTransitionZone: Boolean(shouldRenderFullColumnTransitionZone),
            "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.inner-container"
        }, transitions.map(({ transitionId: transitionId, transitionName: transitionName, targetStatusName: targetStatusName, targetStatusCategory: targetStatusCategory, isAvailable: isAvailable, targetStatusId: targetStatusId, isGlobal: isGlobal })=>{
            const filteredSourceStatus = sourceStatus?.id === targetStatusId ? null : sourceStatus;
            const filteredTransitionName = sourceStatus?.id === targetStatusId ? null : transitionName;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kMJOb.ColumnTransitionZone), {
                key: transitionId,
                isHidden: hoverIntent,
                transitionId: transitionId,
                transitionName: filteredTransitionName,
                targetStatusName: targetStatusName,
                onDragOver: debouncedOnDragOverTransition,
                targetStatusCategory: targetStatusCategory,
                isTransitionAvailable: isAvailable,
                isTransitionGlobal: isGlobal,
                notAvailableMessage: notAvailableMessage,
                sourceStatus: filteredSourceStatus,
                onTransitionSelection: onTransitionSelected,
                hideSourceStatusInLabel: hideSourceStatusInLabel,
                columnId: columnId,
                swimlaneId: swimlaneId
            });
        }));
    };
    (0, $5uXOq.useEffect)(()=>{
        if (!containerRef.current || isLoading || allTransitions.length === 0) return undefined;
        return (0, $7gWdR.dropTargetForElements)({
            element: containerRef.current,
            onDragLeave: ()=>{
                autobatch(()=>setAllowSelfColumnTransitions(false));
            }
        });
    }, [
        isLoading,
        allTransitions.length,
        allowSelfColumnTransitions,
        onCardDragOver,
        autobatch
    ]);
    let transitions = allTransitions;
    if (!showAllTransitionZones && columnId === sourceColumnId) {
        transitions = allTransitions.filter((t)=>!t.isGlobal || sourceStatus && t.targetStatusId !== sourceStatus.id);
        if (transitions.length === 0) return null;
    }
    if (!showAllTransitionZones && columnId === sourceColumnId && !allowSelfColumnTransitions && !hoverIntent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1oeFK.default), {
        onHover: onHoverOverTransitionToZone
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35a2ac94dcf5015c$export$fb3bf400d073b5dd, {
        "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.outer-transition-container",
        "data-testid": "platform-board-kit.ui.column.column-transition-zones-container.outer-container",
        isHidden: !shouldRenderFullColumnTransitionZone && hoverIntent,
        hasSwimlanes: hasSwimlanes,
        shouldRenderFullColumnTransitionZone: Boolean(shouldRenderFullColumnTransitionZone),
        innerRef: containerRef
    }, renderTransitions(transitions));
};
const $35a2ac94dcf5015c$export$819ff6ae0287a04 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1064em4-0"
})`--full-column-height:calc( var(--board-scroll-element-height) * 1px - ${(0, $645AZ.columnHeaderHeight) + 8}px );position:sticky;width:100%;display:flex;flex-direction:column;top:${({ hasSwimlanes: hasSwimlanes })=>hasSwimlanes ? (0, $645AZ.columnHeaderHeight) * 2 : (0, $645AZ.columnHeaderHeight)}px;transition:opacity 0.2s;background-color:${({ theme: theme })=>theme.background};height:${({ shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone })=>shouldRenderFullColumnTransitionZone ? 'var(--full-column-height)' : '100%'};max-height:${({ shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone, zoneCount: zoneCount })=>shouldRenderFullColumnTransitionZone ? 'var(--full-column-height)' : `${zoneCount * (0, $645AZ.columnHeaderHeight) * 2}px`};`;
const $35a2ac94dcf5015c$export$fb3bf400d073b5dd = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1064em4-1"
})`position:absolute;top:${({ hasSwimlanes: hasSwimlanes })=>hasSwimlanes ? 0 : (0, $645AZ.columnHeaderHeight)}px;height:100%;width:100%;z-index:${({ shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone })=>shouldRenderFullColumnTransitionZone ? (0, $645AZ.zIndex).fullColumnHeightTransitionZones : (0, $645AZ.zIndex).transitionZones};background-color:${({ theme: theme })=>theme.background};border-radius:${(0, $645AZ.layout).cardListRadius}px;${({ isHidden: isHidden })=>isHidden && 'display: none;'};`;

});
parcelRegister("eEwGl", function(module, exports) {

$parcel$export(module.exports, "LoadingContainer", () => $de32ae575a1b0c8f$export$5e3f251c730829);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");
function $de32ae575a1b0c8f$export$5e3f251c730829() {
    const [showSpinner, setShowSpinner] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        const timeoutId = setTimeout(()=>setShowSpinner(true), 1000);
        return ()=>clearTimeout(timeoutId);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de32ae575a1b0c8f$var$Wrapper, null, showSpinner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "small"
    }) : null);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $de32ae575a1b0c8f$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _1e0c1txw _4t3i16xz _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iVZBo", function(module, exports) {

$parcel$export(module.exports, "NoTransitionContainer", () => $160bf4691616f8f9$export$35d96e22ed839fc);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gSExi = parcelRequire("gSExi");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $fBvtC = parcelRequire("fBvtC");
function $160bf4691616f8f9$export$35d96e22ed839fc({ noTransitionMessage: noTransitionMessage }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const message = formatMessage(noTransitionMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($160bf4691616f8f9$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($160bf4691616f8f9$var$Img, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fBvtC))),
        role: "presentation",
        alt: message
    }), message);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $160bf4691616f8f9$var$WrapperOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _1e0c1txw _2lx21bp4 _4t3i16xz _4cvr1h6o _1bah1h6o _y3gn1h6o _11c81vlj _syaz131l _1yt41ejb",
            __cmplp.className
        ])
    });
});
const $160bf4691616f8f9$var$WrapperNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _1e0c1txw _2lx21bp4 _4t3i16xz _4cvr1h6o _1bah1h6o _y3gn1h6o _syaz131l _11c81vlj _1yt41ejb",
            __cmplp.className
        ])
    });
});
const $160bf4691616f8f9$var$Wrapper = (0, $gSExi.styledComponentWithCondition)(()=>(0, $4R6GH.fg)('tnk-1614-visual-refresh-boardkit'), $160bf4691616f8f9$var$WrapperNew, $160bf4691616f8f9$var$WrapperOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $160bf4691616f8f9$var$Img = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1tcg _1bsb1tcg _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fBvtC", function(module, exports) {
module.exports = new URL("restricted.65d4317c.svg", import.meta.url).toString();

});


parcelRegister("1oeFK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f746fcf61f7b3f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $lFKmC = parcelRequire("lFKmC");

var $7gWdR = parcelRequire("7gWdR");


var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $1fZVH = parcelRequire("1fZVH");

var $645AZ = parcelRequire("645AZ");
const $3f746fcf61f7b3f9$var$hoverIntentDelayMs = 100;
const $3f746fcf61f7b3f9$var$messages = (0, $7VHMR.defineMessages)({
    transitionTo: {
        "id": "platform-board-kit.column.column-transition-zones-container.transition-to-zone.transition-to",
        "defaultMessage": "Transition To..."
    }
});
const $3f746fcf61f7b3f9$var$ColumnTransitionToZone = ({ onHover: onHover })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const autobatch = (0, $1fZVH.useAutobatch)();
    const [isDraggingOver, setIsDraggingOver] = (0, $5uXOq.useState)(false);
    const batchSetIsDraggingOver = (0, $5uXOq.useCallback)((draggingOver)=>{
        autobatch(()=>setIsDraggingOver(draggingOver));
    }, [
        autobatch
    ]);
    const containerRef = (0, $5uXOq.useRef)(null);
    const previousInputPosition = (0, $5uXOq.useRef)(null);
    const debouncedHoverIntent = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(onHover, $3f746fcf61f7b3f9$var$hoverIntentDelayMs), [
        onHover
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!containerRef.current) return undefined;
        return (0, $7gWdR.dropTargetForElements)({
            element: containerRef.current,
            onDragEnter: ()=>{
                batchSetIsDraggingOver(true);
            },
            onDrag: ({ location: { current: { input: input } } })=>{
                if (previousInputPosition.current?.x !== input.clientX || previousInputPosition.current?.y !== input.clientY) {
                    debouncedHoverIntent();
                    previousInputPosition.current = {
                        x: input.clientX,
                        y: input.clientY
                    };
                }
            },
            onDragLeave: (_args)=>{
                debouncedHoverIntent.cancel();
                batchSetIsDraggingOver(false);
            }
        });
    }, [
        batchSetIsDraggingOver,
        debouncedHoverIntent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3f746fcf61f7b3f9$var$TransitionToZone, {
        isDraggingOver: isDraggingOver,
        innerRef: containerRef,
        "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.transition-to-zone.transition-to-zone",
        "data-testid": "platform-board-kit.ui.column.column-transition-zones-container.transition-to-zone"
    }, formatMessage($3f746fcf61f7b3f9$var$messages.transitionTo));
};
var $3f746fcf61f7b3f9$export$2e2bcd8739ae039 = $3f746fcf61f7b3f9$var$ColumnTransitionToZone;
const $3f746fcf61f7b3f9$var$ttZoneHeight = (0, $645AZ.minCardHeight) * 0.5 - 5;
const $3f746fcf61f7b3f9$var$ttZoneMargin = (0, $645AZ.layout).adg3smallGutter * 0.5;
const $3f746fcf61f7b3f9$var$ttZoneMarginTop = -($3f746fcf61f7b3f9$var$ttZoneHeight + (0, $645AZ.layout).adg3smallGutter); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3f746fcf61f7b3f9$var$TransitionToZoneControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-5ashvn-0"
})`position:sticky;text-align:center;pointer-events:all !important;top:0;margin:${$3f746fcf61f7b3f9$var$ttZoneMarginTop}px ${$3f746fcf61f7b3f9$var$ttZoneMargin}px ${$3f746fcf61f7b3f9$var$ttZoneMargin}px;border:2px solid ${(props)=>props.isDraggingOver ? `var(--ds-border-brand, ${(0, $829f609a65d26a98$exports).B300})` : `var(--ds-border-brand, ${(0, $829f609a65d26a98$exports).B100})`};background-color:${(props)=>props.isDraggingOver ? `var(--ds-background-selected-hovered, ${(0, $829f609a65d26a98$exports).B75})` : `var(--ds-background-selected, ${(0, $829f609a65d26a98$exports).B50})`};height:${$3f746fcf61f7b3f9$var$ttZoneHeight}px;line-height:${$3f746fcf61f7b3f9$var$ttZoneHeight}px;width:calc(100% - ${(0, $645AZ.layout).adg3smallGutter * 1.5}px);z-index:10;border-radius:${(0, $645AZ.layout).cardListRadius}px;`;
const $3f746fcf61f7b3f9$var$TransitionToZoneExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDraggingOver: isDraggingOver, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _y3gn1h6o _lcxv4shg _154iidpf _19pk13i4 _2hwx1y44 _otyr1y44 _18u01y44 _4t3ildb6 _vwz4ldb6 _1bsbzd3w _1pbyzo7u _2rkoi2wt",
            __cmplp.isDraggingOver ? "_19itoh42" : "_19itoh42",
            __cmplp.isDraggingOver ? "_bfhkwtfv" : "_bfhk29zg",
            __cmplp.className
        ])
    });
});
const $3f746fcf61f7b3f9$var$TransitionToZone = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $3f746fcf61f7b3f9$var$TransitionToZoneExperiment, $3f746fcf61f7b3f9$var$TransitionToZoneControl);

});

const $ff2886b69dd99cbd$export$c28377001f14d9d = 350;
const $ff2886b69dd99cbd$export$b2112118f902d683 = 45;

parcelRegister("kMJOb", function(module, exports) {

$parcel$export(module.exports, "ColumnTransitionZone", () => $93d5ae56cae270b2$export$627a5fcef77c9034);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $7gWdR = parcelRequire("7gWdR");


var $1fZVH = parcelRequire("1fZVH");

var $7D59a = parcelRequire("7D59a");


var $645AZ = parcelRequire("645AZ");

var $9EXcX = parcelRequire("9EXcX");
const $93d5ae56cae270b2$export$627a5fcef77c9034 = ({ onDragOver: onDragOverProp, transitionId: transitionId, isTransitionAvailable: isTransitionAvailable, isHidden: isHidden, LabelComponent: LabelComponent = (0, $9EXcX.default), targetStatusName: targetStatusName, transitionName: transitionName, targetStatusCategory: targetStatusCategory, sourceStatus: sourceStatus, isTransitionGlobal: isTransitionGlobal, notAvailableMessage: notAvailableMessage, hideSourceStatusInLabel: hideSourceStatusInLabel, onTransitionSelection: onTransitionSelection, columnId: columnId, swimlaneId: swimlaneId })=>{
    const zoneRef = (0, $5uXOq.useRef)(null);
    const previousInputPosition = (0, $5uXOq.useRef)(null);
    const autobatch = (0, $1fZVH.useAutobatch)();
    const onDragOver = (0, $7D59a.useEvent)(onDragOverProp);
    const [isDraggingOver, setIsDraggingOver] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!zoneRef.current) return undefined;
        return (0, $7gWdR.dropTargetForElements)({
            element: zoneRef.current,
            getData: ()=>({
                    type: (0, $25c2ea87c2b04bf9$export$2927f4d423091b16),
                    columnId: columnId,
                    swimlaneId: swimlaneId,
                    transitionId: transitionId
                }),
            onDragEnter: ()=>{
                onDragOver(transitionId, false);
                setIsDraggingOver(true);
            },
            onDrag: ({ location: { current: { input: input } } })=>{
                if (previousInputPosition.current?.x !== input.clientX || previousInputPosition.current?.y !== input.clientY) {
                    onDragOver(transitionId, true);
                    previousInputPosition.current = {
                        x: input.clientX,
                        y: input.clientY
                    };
                }
            },
            onDragLeave: (_args)=>{
                onDragOver(null, false);
                setIsDraggingOver(false);
            },
            onDrop: ()=>{
                if (isHidden || !isTransitionAvailable) return;
                autobatch(()=>onTransitionSelection(transitionId));
            }
        });
    }, [
        autobatch,
        columnId,
        isHidden,
        isTransitionAvailable,
        onTransitionSelection,
        swimlaneId,
        transitionId,
        onDragOver
    ]);
    const labelEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LabelComponent, {
        source: hideSourceStatusInLabel ? null : transitionName,
        sourceStatus: hideSourceStatusInLabel ? null : sourceStatus,
        target: targetStatusName,
        targetStatusCategory: targetStatusCategory,
        isTransitionAvailable: isTransitionAvailable,
        isTransitionGlobal: isTransitionGlobal,
        showMessage: false,
        notAvailableMessage: notAvailableMessage
    });
    const commonProps = {
        isDraggingOver: isDraggingOver,
        isTransitionAvailable: isTransitionAvailable
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93d5ae56cae270b2$export$2de257552dc02bf, {
        ref: zoneRef,
        ...commonProps,
        "data-testid": "platform-board-kit.ui.column.column-transition-zones-container.transition-zone.compiled-transition-zones-container",
        "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.transition-zone.compiled-transition-zones-container"
    }, labelEl);
};
const $93d5ae56cae270b2$var$borderWidth = 2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $93d5ae56cae270b2$var$borderRadius = `${(0, $645AZ.layout).cardListRadius}px`;
const $93d5ae56cae270b2$var$getAvailableBorderColour = (props)=>props.isDraggingOver ? `var(--ds-border-brand, ${(0, $829f609a65d26a98$exports).B300})` : `var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B200})`;
const $93d5ae56cae270b2$var$getDraggingBackgroundColour = (props)=>props.isDraggingOver ? `var(--ds-background-selected-hovered, ${(0, $829f609a65d26a98$exports).B75})` : `var(--ds-background-selected, ${(0, $829f609a65d26a98$exports).B50})`;
const $93d5ae56cae270b2$var$getBorder = (props)=>({
        border: `${$93d5ae56cae270b2$var$borderWidth}px solid ${!props.isTransitionAvailable ? `var(--ds-background-accent-red-subtler, ${(0, $829f609a65d26a98$exports).R75})` : $93d5ae56cae270b2$var$getAvailableBorderColour(props)}`
    });
const $93d5ae56cae270b2$var$getBackgroundColor = (props)=>({
        backgroundColor: `${!props.isTransitionAvailable ? `var(--ds-background-danger, ${(0, $829f609a65d26a98$exports).R50})` : $93d5ae56cae270b2$var$getDraggingBackgroundColour(props)}`
    });
const $93d5ae56cae270b2$export$2de257552dc02bf = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTransitionAvailable: isTransitionAvailable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_rkfzum": (0, $lD23V.default)(`${$93d5ae56cae270b2$var$borderWidth}px solid ${!__cmplp.isTransitionAvailable ? `var(--ds-background-accent-red-subtler, ${(0, $829f609a65d26a98$exports).R75})` : $93d5ae56cae270b2$var$getAvailableBorderColour(__cmplp)}`),
            "--_1v6vhty": (0, $lD23V.default)($93d5ae56cae270b2$var$getDraggingBackgroundColour(__cmplp)),
            "--_1lnby5": (0, $lD23V.default)($93d5ae56cae270b2$var$borderRadius)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _2lx21bp4 _1tkeidpf _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _ca0q14y2 _u5f314y2 _n3td14y2 _19bv14y2 _19it31oo _lcxv4shg _1jc111eo _e6mdhnez _kh711qt3 _am38glyw",
            !__cmplp.isTransitionAvailable ? "_bfhktaeo" : "_bfhkikgw",
            __cmplp.className
        ])
    });
});
const $93d5ae56cae270b2$export$7ed12d2a5241e393 = {
    getBackgroundColor: $93d5ae56cae270b2$var$getBackgroundColor,
    getBorder: $93d5ae56cae270b2$var$getBorder
};

});
parcelRegister("9EXcX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3a289d543cac7bd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $h1TKi = parcelRequire("h1TKi");

var $hMVoD = parcelRequire("hMVoD");

var $8RBk4 = parcelRequire("8RBk4");

var $7nnPp = parcelRequire("7nnPp");


var $2EwJD = parcelRequire("2EwJD");

var $az4zD = parcelRequire("az4zD");

var $54CvF = parcelRequire("54CvF");
const $a3a289d543cac7bd$var$ColumnTransitionLabel = /*#__PURE__*/ (0, $5uXOq.memo)(({ source: source, target: target, targetStatusCategory: targetStatusCategory, isTransitionAvailable: isTransitionAvailable, isTransitionGlobal: isTransitionGlobal, notAvailableMessage: notAvailableMessage, showMessage: showMessage, sourceStatus: sourceStatus, intl: { formatMessage: formatMessage } })=>{
    const shouldRenderSource = source || sourceStatus; /**
                                                      * check null against the source and the sourceStatus.
                                                      * if they are all null. Do not display the source and arrow
                                                      * e.g.
                                                      * label with source: TO DO -> IN PROGRESS
                                                      * label without source: IN PROGRESS
                                                      */ 
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$LabelPositioningWrapper, {
        "data-testid": "platform-board-kit.ui.column.column-transition-zones-container.transition-zone.label.label-positioning-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$TransitionRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$InlineWrapper, null, shouldRenderSource && isTransitionGlobal && sourceStatus?.category ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EwJD.default), {
        category: sourceStatus.category,
        name: sourceStatus.name
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, source)), shouldRenderSource && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$InlineWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h1TKi))), {
        label: "arrow",
        spacing: "spacious",
        color: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N800})`,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8RBk4))),
        LEGACY_size: "small",
        LEGACY_primaryColor: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$InlineFlex, null, !isTransitionAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$Img, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($54CvF))),
        role: "presentation",
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMVoD))), {
        label: formatMessage(notAvailableMessage),
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$exports).R500})`,
        spacing: "spacious",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7nnPp))),
        LEGACY_size: "small",
        LEGACY_primaryColor: `var(--ds-text-danger, ${(0, $829f609a65d26a98$exports).R500})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EwJD.default), {
        category: targetStatusCategory,
        name: target,
        isFullWidth: !shouldRenderSource
    }))), !isTransitionAvailable && showMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$LabelRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$LabelMessage, null, formatMessage(notAvailableMessage))));
});
var $a3a289d543cac7bd$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($a3a289d543cac7bd$var$ColumnTransitionLabel);
const $a3a289d543cac7bd$var$LabelRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _p12f1osq _1bto1l2s _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3a289d543cac7bd$var$LabelPositioningWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1h6o _p12f1osq _1bto1l2s _1n261g80",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3a289d543cac7bd$var$InlineWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _p12fn7od _o572n7od _1bto1l2s _s7n4nkob _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3a289d543cac7bd$var$TransitionRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _s7n4nkob _p12f1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3a289d543cac7bd$var$InlineFlex = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _o572n7od _1bto1l2s _s7n4nkob _p12f1osq _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3a289d543cac7bd$var$Img = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i7vkz _1bsb7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3a289d543cac7bd$var$LabelMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc _y3gn1h6o _11c81vlj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h1TKi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a0af1361c1c47b464cd1f3e8c2b50c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c65dc59efb96b35a$var$_UNSAFE_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
    }, props));
$c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;

});

parcelRegister("8RBk4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6740397d4ba98b13$var$_react = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $6740397d4ba98b13$var$_arrowRight = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("h1TKi")));
function $6740397d4ba98b13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6740397d4ba98b13$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $6740397d4ba98b13$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $6740397d4ba98b13$var$_arrowRight.default
    }));
$6740397d4ba98b13$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $6740397d4ba98b13$var$_default = module.exports.default = $6740397d4ba98b13$var$ArrowRightIcon;

});

parcelRegister("2EwJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd41c6095391bfc6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lj8SI = parcelRequire("lj8SI");

var $gULOk = parcelRequire("gULOk");
const $cd41c6095391bfc6$var$statusCategoryToAppearenceMap = {
    [(0, $gULOk.UNDEFINED)]: 'default',
    [(0, $gULOk.TODO)]: 'default',
    [(0, $gULOk.DONE)]: 'success',
    [(0, $gULOk.IN_PROGRESS)]: 'inprogress'
};
class $cd41c6095391bfc6$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isActive: false
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
            testId: "common-components-status-lozenge.status-lozenge",
            isBold: this.props.isActive,
            appearance: $cd41c6095391bfc6$var$statusCategoryToAppearenceMap[this.props.category],
            maxWidth: this.props.isFullWidth ? '100%' : undefined
        }, this.props.name);
    }
}

});

parcelRegister("54CvF", function(module, exports) {
module.exports = new URL("rule.b492f5a7.svg", import.meta.url).toString();

});




parcelRegister("3Rsmm", function(module, exports) {

$parcel$export(module.exports, "default", () => $481a687e8c533277$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $481a687e8c533277$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notAvailableMessage: {
        "id": "software.main.board-container.board.column.transition-zones-container.not-available-message",
        "defaultMessage": "A workflow rule prevents you from moving the issue this way."
    },
    noTransitionMessage: {
        "id": "software.main.board-container.board.column.transition-zones-container.no-transition-message",
        "defaultMessage": "You can't move this issue to this column due to workflow configurations or permissions."
    },
    notAvailableMessageIssueTermRefresh: {
        "id": "software.main.board-container.board.column.transition-zones-container.not-available-message-issue-term-refresh",
        "defaultMessage": "A workflow rule prevents you from moving the issue this way."
    },
    noTransitionMessageIssueTermRefresh: {
        "id": "software.main.board-container.board.column.transition-zones-container.no-transition-message-issue-term-refresh",
        "defaultMessage": "You can't move this issue to this column due to workflow configurations or permissions."
    }
});

});



parcelRegister("5nhUs", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f8f925568a0eb6d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $hULKg = parcelRequire("hULKg");

var $5rzqz = parcelRequire("5rzqz");

var $67sX6 = parcelRequire("67sX6");

var $k8auG = parcelRequire("k8auG");

var $67Z81 = parcelRequire("67Z81");

var $g2zSK = parcelRequire("g2zSK");

var $7CPxV = parcelRequire("7CPxV");
const $1f8f925568a0eb6d$var$EmptyCMPKanbanBoardMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { projectsWithCreatePermission: projectsWithCreatePermission } = (0, $67sX6.useBoardSelector)((0, $67Z81.getIssueProjectsPermissionGroup));
    const hasCreateIssuePermission = projectsWithCreatePermission.length > 0;
    const hasBacklog = (0, $67sX6.useBoardSelector)((0, $k8auG.isBacklogEnabled));
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const isJSMBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.projectTypeSelector)) === (0, $2vSU6.SERVICE_DESK_PROJECT);
    const renderTitleText = ()=>{
        if (isJSMBoard) return formatMessage((0, $7CPxV.default).jsmEmptyStateTitle);
        if (hasCreateIssuePermission) return hasBacklog ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7CPxV.default).titleWithPermissionAndBacklogIssueTermRefresh : (0, $7CPxV.default).titleWithPermissionAndBacklog) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7CPxV.default).titleWithPermissionNoBacklogIssueTermRefresh : (0, $7CPxV.default).titleWithPermissionNoBacklog);
        return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7CPxV.default).titleNoPermissionIssueTermRefresh : (0, $7CPxV.default).titleNoPermission);
    };
    const renderAction = ()=>{
        if (hasCreateIssuePermission) {
            const openIssueCreate = ()=>{
                openIssueCreateModal({
                    payload: {
                        project: {
                            projectId: String(projectsWithCreatePermission[0])
                        }
                    },
                    triggerPointKey: (0, $hULKg.CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW)
                });
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                onClick: openIssueCreate,
                testId: "software-board.board-container.board.column.empty-cmp-kanban-dialog.button"
            }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7CPxV.default).buttonIssueTermRefresh : (0, $7CPxV.default).button));
        }
        return isJSMBoard ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f8f925568a0eb6d$var$TextStyle, null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7CPxV.default).descriptionNoPermissionIssueTermRefresh : (0, $7CPxV.default).descriptionNoPermission));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f8f925568a0eb6d$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f8f925568a0eb6d$var$Image, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($g2zSK))),
        alt: "empty kanban board"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f8f925568a0eb6d$var$TitleStyle, {
        hasCreateIssuePermission: hasCreateIssuePermission,
        hasDescription: isJSMBoard
    }, renderTitleText()), isJSMBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f8f925568a0eb6d$var$DescriptionContainer, {
        hasCreateIssuePermission: hasCreateIssuePermission
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7CPxV.default).jsmEmptyStateDescriptionIssueTermRefresh : (0, $7CPxV.default).jsmEmptyStateDescription)), renderAction());
};
var $1f8f925568a0eb6d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $1f8f925568a0eb6d$var$EmptyCMPKanbanBoardMessage;
const $1f8f925568a0eb6d$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4xy5q _1e0c1txw _4cvr1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f8f925568a0eb6d$var$Image = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1qr7 _otyr1ejb",
            __cmplp.className
        ])
    });
});
const $1f8f925568a0eb6d$var$getMargin = (hasCreateIssuePermission, hasDescription)=>{
    if (hasDescription) return "var(--ds-space-100, 8px)";
    return hasCreateIssuePermission ? "var(--ds-space-300, 24px)" : "var(--ds-space-100, 8px)";
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f8f925568a0eb6d$var$TitleStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasCreateIssuePermission: hasCreateIssuePermission, hasDescription: hasDescription, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _k48p8n31 _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f8f925568a0eb6d$var$TextStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f8f925568a0eb6d$var$DescriptionContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasCreateIssuePermission: hasCreateIssuePermission, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o",
            __cmplp.hasCreateIssuePermission ? "_otyr1ejb" : "_otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5rzqz", function(module, exports) {

$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $0a31d64d52b4b5e9$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "useOpenIssueCreateModal", () => $0a31d64d52b4b5e9$export$47cf258b1046080b);
$parcel$export(module.exports, "withNewGICProvider", () => $0a31d64d52b4b5e9$export$558a195c5bfe3787);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $1Nspv = parcelRequire("1Nspv");

var $bGrWH = parcelRequire("bGrWH");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $f5nIZ = parcelRequire("f5nIZ");

var $dIdda = parcelRequire("dIdda");

var $7JoAD = parcelRequire("7JoAD");

var $hULKg = parcelRequire("hULKg");

var $cKWWX = parcelRequire("cKWWX");

var $6k7U1 = parcelRequire("6k7U1");
const $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $bGrWH.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $hULKg.TRIGGER_POINT_KEY_NOT_DEFINED),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // optional component - Renders external component above form fields
    ExternalControls: undefined,
    // Analytics property for board with custom filter and icc enabled
    isCustomBoardWithIcc: false,
    // optional ID of the jql swimlane we are creating issues in
    jqlSwimlaneId: undefined,
    // Analytics property for board with swimlane enabled
    swimlaneMode: undefined,
    // prefilled custom Fields if any
    prefilledCustomFields: {},
    // callback for ecosystem API to execute
    ecosystemCallback: undefined,
    // product where issue create anywhere modal is used
    product: undefined,
    // what's the consumer of the issue create anywhere modal in a product
    actionSource: undefined
};
const $0a31d64d52b4b5e9$export$e324594224ef24da = {
    restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) (0, $6k7U1.startGlobalIssueCreateMetrics)(isSubsequentLoad);
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                (0, $6k7U1.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $6k7U1.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $6k7U1.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                setState({
                    ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                    ...isDiscoverabilityPushEnabled && {
                        minimizableModalView: nextModalView,
                        persistentModalView: currentState.persistentModalView,
                        ...(0, $6k7U1.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                    },
                    inProgressIssueID: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4(),
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: currentState.isModalOpen,
                    ...nextState
                });
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $6k7U1.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                callbackPayload: undefined,
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $1Nspv.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                (0, $6k7U1.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            if (!(0, $co1wz.ff)('linked-alerts-in-gic_onvr6')) return;
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $0a31d64d52b4b5e9$var$store = (0, $7JoAD.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
    actions: $0a31d64d52b4b5e9$export$e324594224ef24da
});
const $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalState = (0, $7JoAD.createStateHook)($0a31d64d52b4b5e9$var$store);
const $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions = (0, $7JoAD.createActionsHook)($0a31d64d52b4b5e9$var$store);
const $0a31d64d52b4b5e9$export$71e0eb7b8a91a156 = ()=>{
    const createState = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalState();
    const createActions = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $5uXOq.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey,
            ...(0, $4R6GH.fg)('new-attributes-for-issue-create-anywhere') ? {
                ...nextState?.product ? {
                    product: nextState.product
                } : {},
                ...nextState?.actionSource ? {
                    actionSource: nextState.actionSource
                } : {}
            } : {}
        };
        (0, $8zOmE.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $0a31d64d52b4b5e9$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [, { setSitePickerState: setSitePickerState }] = (0, $cKWWX.useSitePickerContext)();
    return (0, $5uXOq.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey,
            ...(0, $4R6GH.fg)('new-attributes-for-issue-create-anywhere') ? {
                ...nextState?.product ? {
                    product: nextState.product
                } : {},
                ...nextState?.actionSource ? {
                    actionSource: nextState.actionSource
                } : {}
            } : {}
        };
        (0, $8zOmE.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        // overrideCloudId only used for embedded GIC
        if (nextState?.payload?.overrideCloudId && (0, $4R6GH.fg)('jira_ai_issue_create_site_user_preference')) // set cloudId inside the state if there's an override
        setSitePickerState({
            selectedCloudId: nextState?.payload?.overrideCloudId
        });
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal,
        setSitePickerState
    ]);
};
const $0a31d64d52b4b5e9$export$4c674fe824b8f278 = (0, $7JoAD.createSubscriber)($0a31d64d52b4b5e9$var$store);
function $0a31d64d52b4b5e9$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $0a31d64d52b4b5e9$export$71e0eb7b8a91a156();
        const { data: data } = (0, $dIdda.useResource)((0, $f5nIZ.gicOptInStatusResources));
        const currentIssueCreateVisibility = data && data?.gicOptInStatus;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
            ...props
        });
    };
}

});
parcelRegister("1Nspv", function(module, exports) {

$parcel$export(module.exports, "CreateIssueUFOExperience", () => $ff7fb599b8d98642$export$cd75c112ac11a83b);
$parcel$export(module.exports, "StatusFieldLoad", () => $ff7fb599b8d98642$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $ff7fb599b8d98642$export$70208657c8d471a7);
$parcel$export(module.exports, "EcosystemAPIPrefillingUFOExperience", () => $ff7fb599b8d98642$export$b2d8f8edec75f571);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $ff7fb599b8d98642$export$cd75c112ac11a83b = new (0, $duUGa.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $ff7fb599b8d98642$export$e890e797a25e655c = new (0, $duUGa.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $atdLB.ExperienceTypes).Load,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $ff7fb599b8d98642$export$70208657c8d471a7 = new (0, $duUGa.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'modern-global-issue-create.modal.issue-submit'
});
const $ff7fb599b8d98642$export$b2d8f8edec75f571 = new (0, $duUGa.UFOExperience)('ecosystem-api-new-gic-prefilling', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'ecosystem-api-new-gic-prefilling'
});

});

parcelRegister("bGrWH", function(module, exports) {

$parcel$export(module.exports, "REQUIRED", () => $4aabf2a0e09eb856$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $4aabf2a0e09eb856$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $4aabf2a0e09eb856$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $4aabf2a0e09eb856$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $4aabf2a0e09eb856$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $4aabf2a0e09eb856$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $4aabf2a0e09eb856$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $4aabf2a0e09eb856$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $4aabf2a0e09eb856$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $4aabf2a0e09eb856$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $4aabf2a0e09eb856$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $4aabf2a0e09eb856$export$8170252f0ea43511);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $4aabf2a0e09eb856$export$17bcab948893a9ba = 'worklog';
const $4aabf2a0e09eb856$export$b1c05b34d317c074 = 'REQUIRED';
const $4aabf2a0e09eb856$export$f10b32dfda12e96e = 'unknown';
const $4aabf2a0e09eb856$export$e5e4b8c32e68dd0b = 'networkError';
const $4aabf2a0e09eb856$export$2d06efb8146cd043 = 'graphQLError';
const $4aabf2a0e09eb856$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $4aabf2a0e09eb856$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $4aabf2a0e09eb856$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $4aabf2a0e09eb856$export$aac4661200ba4104 = 'worklog_startDate';
const $4aabf2a0e09eb856$export$a23c32d5cf54cba0 = 'worklog_description';
const $4aabf2a0e09eb856$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $4aabf2a0e09eb856$export$63fd567c1d0aca19 = [
    ...$4aabf2a0e09eb856$export$74ab3898ae683660,
    $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f,
    $4aabf2a0e09eb856$export$cf70f9220e6a2f50,
    $4aabf2a0e09eb856$export$aac4661200ba4104,
    $4aabf2a0e09eb856$export$a23c32d5cf54cba0
];
const $4aabf2a0e09eb856$export$983715bb9b0f9b2c = {
    [$4aabf2a0e09eb856$export$17bcab948893a9ba]: $4aabf2a0e09eb856$export$63fd567c1d0aca19
};
const $4aabf2a0e09eb856$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $4aabf2a0e09eb856$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $4aabf2a0e09eb856$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $4aabf2a0e09eb856$export$8170252f0ea43511 = 'QuickCreateIssue';

});

parcelRegister("cKWWX", function(module, exports) {

$parcel$export(module.exports, "useSitePickerContext", () => $c8055d212e869a3c$export$f8b5aae013e4cf77);

var $7JoAD = parcelRequire("7JoAD");
const $c8055d212e869a3c$export$d4c72bab9d6cc13a = {
    selectedCloudId: '',
    siteDomain: ''
};
const $c8055d212e869a3c$export$e324594224ef24da = {
    setSitePickerState: ({ selectedCloudId: selectedCloudId, siteDomain: siteDomain })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                selectedCloudId: selectedCloudId || '',
                siteDomain: siteDomain || ''
            });
        }
};
const $c8055d212e869a3c$export$6f57813fe9f31bf9 = (0, $7JoAD.createStore)({
    name: 'issue.fields.site-picker',
    initialState: $c8055d212e869a3c$export$d4c72bab9d6cc13a,
    actions: $c8055d212e869a3c$export$e324594224ef24da
});
const $c8055d212e869a3c$export$f8b5aae013e4cf77 = (0, $7JoAD.createHook)($c8055d212e869a3c$export$6f57813fe9f31bf9);

});

parcelRegister("6k7U1", function(module, exports) {

$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $8a2e4df39a48d5af$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $8a2e4df39a48d5af$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $8a2e4df39a48d5af$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $8a2e4df39a48d5af$export$720579602bb055a2);

var $eTXmK = parcelRequire("eTXmK");

var $1Nspv = parcelRequire("1Nspv");

var $gEaAu = parcelRequire("gEaAu");

var $huY3x = parcelRequire("huY3x");
const $8a2e4df39a48d5af$export$550b19803bc962ec = (isSubsequentLoad)=>{
    (0, $1Nspv.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $gEaAu.globalIssueCreateModalLoadSubsequent) : (0, $gEaAu.globalIssueCreateModalLoad);
    if (isSubsequentLoad) (0, $eTXmK.default)('global-issue.create-modal-subsequent');
    else (0, $eTXmK.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $huY3x.startGlobalIssueCreateTTIWithAdjustments)();
};
const $8a2e4df39a48d5af$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $8a2e4df39a48d5af$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $8a2e4df39a48d5af$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};

});
parcelRegister("gEaAu", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $ee246606338fc99e$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $ee246606338fc99e$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $ee246606338fc99e$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $ee246606338fc99e$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $ee246606338fc99e$export$c1592e4d8d98963e);

var $dGrdR = parcelRequire("dGrdR");
const $ee246606338fc99e$export$5a01a7fa84b239c8 = (0, $dGrdR.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $ee246606338fc99e$export$c50ad3c31b6fcfc6 = (0, $dGrdR.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $ee246606338fc99e$export$4b2382574525bb0f = (0, $dGrdR.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $ee246606338fc99e$export$7839bdaa2f6a2385 = (0, $dGrdR.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $ee246606338fc99e$export$c1592e4d8d98963e = (0, $dGrdR.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});

parcelRegister("huY3x", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $06c7e44c59602f0c$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $06c7e44c59602f0c$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $06c7e44c59602f0c$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $06c7e44c59602f0c$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $06c7e44c59602f0c$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $06c7e44c59602f0c$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $06c7e44c59602f0c$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $06c7e44c59602f0c$export$d86f4868694f2aa7);

var $dGrdR = parcelRequire("dGrdR");

var $a1HyB = parcelRequire("a1HyB");
const $06c7e44c59602f0c$export$9f3d6f17e1da7874 = (0, $dGrdR.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ],
    featureFlags: (0, $a1HyB.TTIFFs)
});
const $06c7e44c59602f0c$export$457c9fb71ad5b3a9 = ()=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.start();
};
const $06c7e44c59602f0c$export$ef664dac649a716c = ()=>$06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('gic-tti');
const $06c7e44c59602f0c$export$30ca4c461fab486c = (customData)=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $06c7e44c59602f0c$export$27f2445288b528c = ()=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.cancel();
};
const $06c7e44c59602f0c$export$7a2709fc1e33401a = ()=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $06c7e44c59602f0c$export$cf3893335c93e33b = ()=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $06c7e44c59602f0c$export$d86f4868694f2aa7 = ()=>{
    $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});
parcelRegister("a1HyB", function(module, exports) {

$parcel$export(module.exports, "TTIFFs", () => $aec371b77b607203$export$c396ba1504d97f3f);
const $aec371b77b607203$export$c396ba1504d97f3f = [];

});




parcelRegister("g2zSK", function(module, exports) {
module.exports = new URL("empty-cmp-kanban-board.d2af34d0.svg", import.meta.url).toString();

});

parcelRegister("7CPxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c97705f1f833a2e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1c97705f1f833a2e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    titleWithPermissionAndBacklog: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.title-with-permission-and-backlog",
        "defaultMessage": "Create and move issues from the backlog to get started."
    },
    titleWithPermissionNoBacklog: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.title-with-permission-no-backlog",
        "defaultMessage": "Create an issue to get started."
    },
    titleNoPermission: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.title-no-permission",
        "defaultMessage": "No issues yet"
    },
    descriptionNoPermission: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.description-no-permission",
        "defaultMessage": "Once your team has issues to work on, you'll see them here"
    },
    button: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.button",
        "defaultMessage": "Create issue"
    },
    jsmEmptyStateTitle: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.jsm-empty-state-title",
        "defaultMessage": "Visualize your work with a board"
    },
    jsmEmptyStateDescription: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.jsm-empty-state-description",
        "defaultMessage": "Track all issues in your project, or view specific issues using filters."
    },
    titleWithPermissionAndBacklogIssueTermRefresh: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.title-with-permission-and-backlog-issue-term-refresh",
        "defaultMessage": "Create and move issues from the backlog to get started."
    },
    titleWithPermissionNoBacklogIssueTermRefresh: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.title-with-permission-no-backlog-issue-term-refresh",
        "defaultMessage": "Create an issue to get started."
    },
    titleNoPermissionIssueTermRefresh: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.title-no-permission-issue-term-refresh",
        "defaultMessage": "No issues yet"
    },
    descriptionNoPermissionIssueTermRefresh: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.description-no-permission-issue-term-refresh",
        "defaultMessage": "Once your team has issues to work on, you'll see them here"
    },
    buttonIssueTermRefresh: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.button-issue-term-refresh",
        "defaultMessage": "Create issue"
    },
    jsmEmptyStateDescriptionIssueTermRefresh: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.jsm-empty-state-description-issue-term-refresh",
        "defaultMessage": "Track all issues in your project, or view specific issues using filters."
    }
});

});


parcelRegister("dRpFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f4fb246fb7165a4$export$2e2bcd8739ae039);

var $gJBT6 = parcelRequire("gJBT6");

var $8Rkzz = parcelRequire("8Rkzz");

var $5rFbt = parcelRequire("5rFbt");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");

var $bC2fB = parcelRequire("bC2fB");

var $2xFXk = parcelRequire("2xFXk");


var $63VRQ = parcelRequire("63VRQ");

var $1vXOx = parcelRequire("1vXOx");

var $kc6Ry = parcelRequire("kc6Ry");

var $9OPlz = parcelRequire("9OPlz");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $lBlo2 = parcelRequire("lBlo2");

var $9FKJv = parcelRequire("9FKJv");
const $0f4fb246fb7165a4$export$f6225909f8fcd89c = (0, $2OMDV.AnalyticsEventToProps)('columnHeader', {
    onEditStart: 'editStarted',
    onEditCancel: 'editCanceled',
    onHeaderClick: 'clicked'
})((0, $9FKJv.default));
const $0f4fb246fb7165a4$var$getExternalValues = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnIndex)=>({
        columnIndex: columnIndex + 1
    }));
const $0f4fb246fb7165a4$var$EMPTY_LIST = [];
const $0f4fb246fb7165a4$var$mapStateToProps = (state, ownProps)=>{
    const column = (0, $fyeGd.getColumnById)(state, ownProps.id);
    const columnIndex = (0, $fyeGd.getColumnIndex)(state, ownProps.id);
    const getCardsCount = ()=>{
        /**
		 * We do NOT display cards count in column headers of increment planning boards
		 * Therefore we set cardsCount={undefined} which eventually hides the issue count
		 * in board-kit/src/common/ui/column-header/editable-title/column-title ({!!visibleCount && <CountWrapper />})
		 * */ const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        if (isIncrementPlanningBoard) return undefined;
        // in non-incremental planning boards, the issue count is displayed in column headers
        return false ? (0, $5mTgl.getColumnIssuesCountWithLimit)(state, ownProps.id) : (0, $5mTgl.getColumnIssuesCount)(state, ownProps.id);
    };
    const totalCardsCount = (0, $5mTgl.getColumnTotalIssuesCount)(state, ownProps.id);
    const showTotalCardsCount = false || (0, $5mTgl.hasWorkFiltersSelector)(state);
    const lozenges = column?.type === (0, $5rFbt.ColumnType).STATUS ? (0, $fyeGd.getColumnLozenges)(totalCardsCount, column?.maxIssueCount, column?.minIssueCount) : $0f4fb246fb7165a4$var$EMPTY_LIST;
    const canRenameColumns = (0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$b5cf1ddd753a0a1c] && (0, $5mTgl.isInlineColumnEditEnabled)(state);
    const OverlayContent = !(0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).HIDE_COLUMN_HEADER_OVERLAY) && (0, $9OPlz.draggingCardTargetColumnIdSelector)(state) === ownProps.id && (0, $9OPlz.draggingCardHoverIntentSelector)(state) ? (0, $lBlo2.default) : undefined;
    return {
        title: column?.name ?? '',
        lozenges: lozenges,
        index: columnIndex,
        cardsCount: getCardsCount(),
        totalCardsCount: totalCardsCount,
        showTotalCardsCount: showTotalCardsCount,
        // disable "column edit" feature (for all columns) during column update.
        // JIRA API does not support multi columns updates at the same time
        isDone: (0, $fyeGd.isDoneColumn)(column),
        isRenamable: canRenameColumns && !(0, $5mTgl.isAnyColumnUpdating)(state),
        isDisabled: (0, $5mTgl.isAnyColumnUpdating)(state),
        // copy ownProps or set default values
        showShadowOnScroll: ownProps.showShadowOnScroll || false,
        menu: ownProps.menu || null,
        validateRename: (0, $fyeGd.makeValidateColumnSelector)(state),
        // analytics
        externalId: 'board.column-header',
        externalValues: $0f4fb246fb7165a4$var$getExternalValues(columnIndex),
        onEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onEditCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onHeaderClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        OverlayContent: OverlayContent,
        isLastColumn: (0, $fyeGd.isLastColumn)(state)(ownProps.id)
    };
};
const $0f4fb246fb7165a4$var$ConnectedHeaderWithAnalytics = (0, $bC2fB.connect)($0f4fb246fb7165a4$var$mapStateToProps, (dispatch)=>({
        onRename: (columnId, title, analyticsEvent)=>{
            dispatch((0, $63VRQ.columnRenameRequest)(columnId, title, analyticsEvent));
        },
        onEditStart: (analyticsEvent)=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent),
        onEditCancel: (columnId, type, analyticsEvent)=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
                columnId: columnId,
                type: type
            }),
        onHeaderClick: (analyticsEvent)=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent)
    }))($0f4fb246fb7165a4$export$f6225909f8fcd89c);
var $0f4fb246fb7165a4$export$2e2bcd8739ae039 = $0f4fb246fb7165a4$var$ConnectedHeaderWithAnalytics;

});
parcelRegister("lBlo2", function(module, exports) {

$parcel$export(module.exports, "default", () => $427a5a447ae7148b$export$2e2bcd8739ae039);

var $gULOk = parcelRequire("gULOk");

var $kkSEu = parcelRequire("kkSEu");

var $bC2fB = parcelRequire("bC2fB");

var $lIysR = parcelRequire("lIysR");

var $9OPlz = parcelRequire("9OPlz");
const $427a5a447ae7148b$var$mapStateToProps = (state)=>{
    const activeTransitionName = (0, $lIysR.activeTransitionNameSelector)(state);
    const destinationStatus = (0, $lIysR.activeTransitionDestinationStatusSelector)(state);
    return {
        source: activeTransitionName || '',
        sourceStatus: (0, $9OPlz.draggingCardSourceStatusSelector)(state),
        isTransitionGlobal: (0, $lIysR.isActiveTransitionGlobalSelector)(state),
        target: destinationStatus && destinationStatus.name || '',
        targetStatusCategory: destinationStatus && destinationStatus.category || (0, $gULOk.UNDEFINED)
    };
};
var $427a5a447ae7148b$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($427a5a447ae7148b$var$mapStateToProps, {})((0, $kkSEu.default));

});
parcelRegister("kkSEu", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dd9a8cfbc4fe651$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $h1TKi = parcelRequire("h1TKi");

var $8RBk4 = parcelRequire("8RBk4");

var $2EwJD = parcelRequire("2EwJD");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $645AZ = parcelRequire("645AZ");
const $1dd9a8cfbc4fe651$var$ColumnHeaderTransitionOverlay = /*#__PURE__*/ (0, $5uXOq.memo)(({ isTransitionGlobal: isTransitionGlobal, target: target, targetStatusCategory: targetStatusCategory, source: source, sourceStatus: sourceStatus })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1dd9a8cfbc4fe651$var$Container, {
        "data-testid": "platform-board-kit.ui.column.column-header-transition-overlay.container"
    }, isTransitionGlobal && sourceStatus && sourceStatus.category ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EwJD.default), {
        category: sourceStatus.category,
        name: sourceStatus.name
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1dd9a8cfbc4fe651$var$TransitionNameContainer, null, source), (0, $4R6GH.fg)('tnk-1614-visual-refresh-boardkit-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h1TKi))), {
        label: "",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8RBk4))),
        LEGACY_size: "small",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8RBk4))), {
        size: "small",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EwJD.default), {
        category: targetStatusCategory,
        name: target
    })));
var $1dd9a8cfbc4fe651$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $1dd9a8cfbc4fe651$var$ColumnHeaderTransitionOverlay;
const $1dd9a8cfbc4fe651$var$TransitionNameContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1p1dangw _k48pbfng _syaz1rc1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1dd9a8cfbc4fe651$var$ContainerControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-147e33u-0"
})({
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $645AZ.columnFixedWidth) - (0, $645AZ.layout).smallGutter * 4}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $645AZ.columnHeaderHeight)}px`,
    background: 'inherit',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $645AZ.zIndex).stickyHeaders,
    alignItems: 'center',
    justifyContent: 'left',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginLeft: `${(0, $645AZ.layout).smallGutter * 2}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $645AZ.columnHeaderFontSize)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& span': {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:last-child': {
            flex: '0 0 auto'
        }
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1dd9a8cfbc4fe651$var$ContainerExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1bsbr0r7 _4t3ickbl _11q71kw7 _1pbyegat _4cvr1h6o _1bah1e5h _1e0c1txw _18u019bv _1wyb1crf _x3fa1l2s _10ca1q9c _17kn15vq _1hrp15vq _pxtlidpf _136lidpf _1xi51wug",
            __cmplp.className
        ])
    });
});
const $1dd9a8cfbc4fe651$var$Container = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $1dd9a8cfbc4fe651$var$ContainerExperiment, $1dd9a8cfbc4fe651$var$ContainerControl);
const $1dd9a8cfbc4fe651$export$7ed12d2a5241e393 = {
    Container: $1dd9a8cfbc4fe651$var$Container
};

});


parcelRegister("9FKJv", function(module, exports) {

$parcel$export(module.exports, "default", () => $3aec8f195c0804ac$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $4R6GH = parcelRequire("4R6GH");

var $16E0T = parcelRequire("16E0T");

var $2xFXk = parcelRequire("2xFXk");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");

var $63LqY = parcelRequire("63LqY");
const $3aec8f195c0804ac$var$ColumnHeaderView = (props)=>{
    const { isDone: isDone, isLastColumn: isLastColumn, ...otherProps } = props;
    const isCMPBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsCMPBoard));
    const isIncrementPlanningBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
    const isFlexibleColumns = (0, $63LqY.useCapability)((0, $2xFXk.Capability).FLEXIBLE_BOARD_COLUMNS);
    const shouldRemoveSpaceForMenu = (0, $4R6GH.fg)('program_board_flexible_cadence') ? isCMPBoard || isIncrementPlanningBoard : isCMPBoard;
    const renderBoardKitColumnHeader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16E0T.default), {
            isDone: isDone,
            ...otherProps,
            isCMPBoard: isCMPBoard,
            shouldRemoveSpaceForMenu: shouldRemoveSpaceForMenu,
            isFlexibleColumns: isFlexibleColumns
        });
    if (isLastColumn) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "DoneNotLastColumnMessage"
    }, renderBoardKitColumnHeader()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: "DoneNotLastColumnMessage"
    }));
    if (isDone) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "DoneColumnMessage"
    }, renderBoardKitColumnHeader()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: "DoneColumnMessage"
    }));
    return renderBoardKitColumnHeader();
};
var $3aec8f195c0804ac$export$2e2bcd8739ae039 = $3aec8f195c0804ac$var$ColumnHeaderView;

});


parcelRegister("iTH7p", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea88f6081a2d2640$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $gJBT6 = parcelRequire("gJBT6");

var $az4zD = parcelRequire("az4zD");

var $2OMDV = parcelRequire("2OMDV");

var $bC2fB = parcelRequire("bC2fB");


var $1vXOx = parcelRequire("1vXOx");

var $fyeGd = parcelRequire("fyeGd");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $5mTgl = parcelRequire("5mTgl");

var $lw9Ef = parcelRequire("lw9Ef");
const $ea88f6081a2d2640$var$getExternalValues = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnIndex)=>({
        columnIndex: columnIndex + 1
    }));
const $ea88f6081a2d2640$export$c31df4bd766f9c35 = (state, ownProps)=>{
    const columnIndex = (0, $fyeGd.getColumnIndex)(state, ownProps.columnId);
    const hasDoneIssues = (0, $d2i8f.getDoneIssuesInColumn)(state)(ownProps.columnId).length > 0;
    const isClearDoneIssueVisible = !(0, $ebHh7.isSprintsEnabled)(state) && hasDoneIssues && !(0, $67Z81.getIsCMPBoard)(state);
    const anyColumnUpdating = (0, $5mTgl.isAnyColumnUpdating)(state);
    const isVisible = (0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df] && ((0, $5mTgl.isInlineColumnEditEnabled)(state) || isClearDoneIssueVisible) && !anyColumnUpdating;
    return {
        externalId: 'platform.board.column.meatball',
        externalValues: $ea88f6081a2d2640$var$getExternalValues(columnIndex),
        isDisabled: !isVisible
    };
};
const $ea88f6081a2d2640$var$connector = (0, $bC2fB.connect)($ea88f6081a2d2640$export$c31df4bd766f9c35, {});
const $ea88f6081a2d2640$var$ConnectedMenu = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $2OMDV.AnalyticsEventToProps)('dropdownMenuItem', {
    onOpenChange: 'opened'
}), $ea88f6081a2d2640$var$connector)((0, $lw9Ef.default));
const $ea88f6081a2d2640$var$MenuWithIntl = (0, $az4zD.injectIntlV2)($ea88f6081a2d2640$var$ConnectedMenu);
var $ea88f6081a2d2640$export$2e2bcd8739ae039 = $ea88f6081a2d2640$var$MenuWithIntl;

});
parcelRegister("lw9Ef", function(module, exports) {

$parcel$export(module.exports, "default", () => $4802bcd7783f0508$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $aRoVz = parcelRequire("aRoVz");

var $8U6zd = parcelRequire("8U6zd");

var $3oUqw = parcelRequire("3oUqw");


var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $cE2Qr = parcelRequire("cE2Qr");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $3t5QD = parcelRequire("3t5QD");

var $9kssn = parcelRequire("9kssn");

var $dCm1o = parcelRequire("dCm1o");

var $fMLbE = parcelRequire("fMLbE");

var $hyV8h = parcelRequire("hyV8h");

var $1dfpa = parcelRequire("1dfpa");

var $4Ys5a = parcelRequire("4Ys5a");
const $4802bcd7783f0508$export$63c08433f699fdb7 = (props)=>{
    const { columnId: columnId, externalValues: externalValues, title: title, onOpenChange: onOpenChange, onVisibilityChange: onVisibilityChange, intl: { formatMessage: formatMessage }, isDisabled: isDisabled = false, isDefaultOpen: isDefaultOpen = false } = props;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(isDefaultOpen);
    const [isOnboardingDismissed] = (0, $cE2Qr.useIsDismissed)();
    const handleOpenChange = (attrs)=>{
        setIsOpen(attrs.isOpen);
        onOpenChange(attrs);
    };
    const handleClick = ()=>{
        setIsOpen(false);
        onOpenChange({
            isOpen: false
        });
    };
    const toggleMenu = (open)=>()=>{
            if (onVisibilityChange) {
                onVisibilityChange(open);
                setIsOpen(open);
            }
        };
    const renderTrigger = ({ triggerRef: triggerRef, ...triggerProps })=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            ...triggerProps,
            ref: triggerRef,
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))),
            label: formatMessage((0, $4Ys5a.default).dropdownMenuAriaLabel, {
                heading: title
            })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...triggerProps,
            appearance: "subtle",
            iconBefore: (0, $4R6GH.fg)('enghealth-12479-jsw-board-visual-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
                label: "More actions",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))),
                color: "var(--ds-icon, #44546F)"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))), {
                label: "More actions"
            }),
            "aria-label": formatMessage((0, $4Ys5a.default).dropdownMenuAriaLabelOld, {
                heading: title
            }),
            ref: triggerRef
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4802bcd7783f0508$var$MeatballMenuButtonBackground, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "columnSettings",
        sourceType: (0, $4d5e0871c06cee03$export$d1123261ca8831d2),
        attributes: {
            columnId: columnId,
            columnIndex: externalValues.columnIndex
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        Wrapper: (0, $9kssn.BoardInProgressColumnNudgeAsync),
        conditionsToApplyWrapper: ((0, $4R6GH.fg)('board_in_progress_nudge_conditional_load') ? !isOnboardingDismissed : true) && externalValues.columnIndex === 2,
        onShow: toggleMenu(true),
        onHide: toggleMenu(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        trigger: renderTrigger,
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1dfpa.default), {
        columnId: columnId,
        isDisabled: isDisabled,
        onClick: handleClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fMLbE.default), {
        columnId: columnId,
        isDisabled: isDisabled,
        onClick: handleClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hyV8h.default), {
        columnId: columnId,
        isDisabled: isDisabled,
        onClick: handleClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        action: "toggled",
        actionSubject: "dropdownMenu"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null)))));
};
const $4802bcd7783f0508$export$684af8e980532017 = (Menu)=>(props)=>props.isDisabled ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Menu, props);
const $4802bcd7783f0508$export$5453d852c5696a78 = $4802bcd7783f0508$export$684af8e980532017($4802bcd7783f0508$export$63c08433f699fdb7);
var $4802bcd7783f0508$export$2e2bcd8739ae039 = $4802bcd7783f0508$export$5453d852c5696a78;
const $4802bcd7783f0508$var$MeatballBackgroundAnimation = /*#__PURE__*/ (0, $47bDC.keyframes)({
    '0%': {
        opacity: 0
    },
    '100%': {
        opacity: 1
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4802bcd7783f0508$var$MeatballMenuButtonBackground = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-150y470-0"
})({
    animation: `${$4802bcd7783f0508$var$MeatballBackgroundAnimation} 0.2s ease forwards`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N50})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $gwIPs.borderRadius)}px`
});

});
parcelRegister("aRoVz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c1f89f82839ba50$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9KnKW = parcelRequire("9KnKW");

var $9UCCQ = parcelRequire("9UCCQ");

var $k20lf = parcelRequire("k20lf");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $6c1f89f82839ba50$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $9KnKW.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k20lf.default), {
        id: titleId,
        title: title
    }), children);
});
var $6c1f89f82839ba50$export$2e2bcd8739ae039 = $6c1f89f82839ba50$var$DropdownMenuItemGroup;

});

parcelRegister("9kssn", function(module, exports) {

$parcel$export(module.exports, "BoardInProgressColumnNudgeAsync", () => $72c66e4455352260$export$3f0f67bcde6861c2);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $72c66e4455352260$var$BoardInProgressColumnNudgeLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("62it8")).then((exportedModule)=>exportedModule.BoardInProgressNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/kanban-onboarding-tour/board-in-progress-column/index.tsx"
});
const $72c66e4455352260$export$3f0f67bcde6861c2 = ({ children: children, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$f2fe211acb4aa81a),
        fallback: children,
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$4db327e1949c2108)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-kanban-onboarding-board-in-progress-column-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($72c66e4455352260$var$BoardInProgressColumnNudgeLazy, restProps, children)));
$72c66e4455352260$export$3f0f67bcde6861c2.displayName = 'BoardInProgressColumnNudgeAsync';

});
parcelRegister("62it8", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("4LPz2").then(()=>parcelRequire('jxAnH'));

});


parcelRegister("fMLbE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b89d206e63a02bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $chc6P = parcelRequire("chc6P");

var $8QpSo = parcelRequire("8QpSo");

var $7Jxgt = parcelRequire("7Jxgt");

var $k12ix = parcelRequire("k12ix");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");

var $bC2fB = parcelRequire("bC2fB");

var $aHYmi = parcelRequire("aHYmi");

var $4G04L = parcelRequire("4G04L");

var $iuuJH = parcelRequire("iuuJH");

var $hz3OZ = parcelRequire("hz3OZ");

var $hnvrw = parcelRequire("hnvrw");

var $2f454 = parcelRequire("2f454");

var $fyeGd = parcelRequire("fyeGd");

var $3UY9S = parcelRequire("3UY9S");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");

var $egWyf = parcelRequire("egWyf");
const $0b89d206e63a02bd$export$c31df4bd766f9c35 = ()=>{
    const doneCardsChildrenFactory = (0, $8QpSo.default)((doneCards, state)=>(0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(doneCards, (issue)=>(0, $3UY9S.getChildrenOfParent)(state)(issue.id)));
    return (state, ownProps)=>{
        const { columnId: columnId } = ownProps;
        const doneCards = (0, $d2i8f.getDoneIssuesInColumn)(state)(columnId);
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const resolvedIssuesUrl = (0, $hnvrw.getResolvedIssuesUrl)((0, $67Z81.contextPathSelector)(state), (0, $67Z81.projectKeySelector)(state));
        const columnIndex = (0, $fyeGd.getColumnIndex)(state, columnId);
        const column = (0, $fyeGd.getColumnById)(state, columnId);
        const isLastColumn = (0, $fyeGd.isDoneColumn)(column);
        const numColumnsOnBoard = (0, $5mTgl.workColumnsSelector)(state).length;
        // Indirectly these sub-tasks will be cleared, so we'll collect them to perform the optimistic
        // update
        const doneCardsChildren = doneCardsChildrenFactory(doneCards, state);
        const isVisible = !(0, $ebHh7.isSprintsEnabled)(state) && (0, $d2i8f.makeDoesColumnContainDoneCardsSelector)(state)(columnId) && !(0, $67Z81.getIsCMPBoard)(state);
        const isSubtaskSwimlaneModeSelected = (0, $45cXl.getSwimlaneMode)(state) === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id;
        const isDisabled = ownProps.isDisabled || isSubtaskSwimlaneModeSelected;
        return {
            isVisible: isVisible,
            isDisabled: isDisabled,
            isLastColumn: isLastColumn,
            doneCards: doneCards,
            doneCardsChildren: doneCardsChildren,
            boardId: boardId,
            resolvedIssuesUrl: resolvedIssuesUrl,
            columnIndex: columnIndex,
            numColumnsOnBoard: numColumnsOnBoard
        };
    };
};
const $0b89d206e63a02bd$export$9e6a17cf56877796 = (dispatch)=>({
        dispatch: dispatch
    });
const $0b89d206e63a02bd$var$onClickFactory = (0, $8QpSo.default)((doneCards, doneCardsChildren, dispatch, onClick, isLastColumn, columnIndex, numColumnsOnBoard, numDoneCards, numDoneCardsChildren, clearCards, boardId, resolvedIssuesUrl)=>(event, analyticsEvent)=>{
        const concurrentId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        (0, $hz3OZ.cardsClearInteraction)(concurrentId).start();
        const doneCardIds = doneCards.map((card)=>card.id);
        const action = (0, $2f454.cardClear)(doneCardIds, doneCardsChildren);
        const { meta: { optimistic: { id: optimisticId } } } = action;
        dispatch(action);
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $hz3OZ.cardsClearInteraction)(concurrentId).mark('feedback');
        });
        onClick(event, analyticsEvent);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clearIssueDropdownMenuItem', {
            isLastColumn: isLastColumn,
            columnIndex: columnIndex,
            numColumnsOnBoard: numColumnsOnBoard,
            numParentIssues: numDoneCards,
            numSubtasks: numDoneCardsChildren
        });
        clearCards({
            boardId: boardId,
            cardIds: doneCardIds,
            resolvedIssuesUrl: resolvedIssuesUrl,
            onUndo: (undoPromise, retry)=>{
                const undoConcurrentId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
                (0, $hz3OZ.cardsUnclearInteraction)(undoConcurrentId).start();
                dispatch((0, $2f454.cardClearUndo)(undoPromise, retry, optimisticId));
                (0, $4G04L.scheduleAfterRender)(()=>{
                    (0, $hz3OZ.cardsUnclearInteraction)(undoConcurrentId).mark('feedback');
                });
                undoPromise.then(()=>{
                    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issues uncleared', 'issuesUncleared', {
                        numParentIssues: numDoneCards,
                        numSubtasks: numDoneCardsChildren
                    });
                    (0, $4G04L.scheduleAfterRender)(()=>{
                        (0, $hz3OZ.cardsUnclearInteraction)(undoConcurrentId).stop({
                            customData: (0, $k12ix.getNormalisedPerformanceFFs)()
                        });
                    });
                }).catch(()=>{
                    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issues unclearFailed');
                });
            },
            onUndoFlagDismissed: ()=>{
                dispatch((0, $2f454.cardClearSuccess)(optimisticId));
            }
        }).then(()=>{
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issues cleared', 'issuesCleared', {
                numParentIssues: numDoneCards,
                numSubtasks: numDoneCardsChildren
            });
            (0, $4G04L.scheduleAfterRender)(()=>{
                (0, $hz3OZ.cardsClearInteraction)(concurrentId).stop({
                    customData: (0, $k12ix.getNormalisedPerformanceFFs)()
                });
            });
        }).catch(()=>{
            dispatch((0, $2f454.cardClearFailure)(optimisticId));
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issues clearFailed');
        });
    });
const $0b89d206e63a02bd$export$9d1611c77c2fe928 = (stateProps, dispatchProps, ownProps)=>{
    const { onClick: onClick, clearCards: clearCards } = ownProps;
    const { dispatch: dispatch } = dispatchProps;
    const { isVisible: isVisible, isDisabled: isDisabled, doneCards: doneCards, boardId: boardId, doneCardsChildren: doneCardsChildren, isLastColumn: isLastColumn, columnIndex: columnIndex, numColumnsOnBoard: numColumnsOnBoard, resolvedIssuesUrl: resolvedIssuesUrl } = stateProps;
    const numDoneCards = doneCards.length;
    const numDoneCardsChildren = doneCardsChildren.length;
    return {
        isVisible: isVisible,
        numDoneCards: numDoneCards,
        isDisabled: isDisabled,
        onClick: $0b89d206e63a02bd$var$onClickFactory(doneCards, doneCardsChildren, dispatch, onClick, isLastColumn, columnIndex, numColumnsOnBoard, numDoneCards, numDoneCardsChildren, clearCards, boardId, resolvedIssuesUrl)
    };
};
const $0b89d206e63a02bd$var$ItemClearAllWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('dropdownMenuItem', {
    onClick: 'clicked'
})((0, $egWyf.default));
const $0b89d206e63a02bd$var$HideableItem = ({ isVisible: isVisible, onClick: onClick, numDoneCards: numDoneCards, isDisabled: isDisabled })=>isVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0b89d206e63a02bd$var$ItemClearAllWithAnalytics, {
        onClick: onClick,
        numDoneCards: numDoneCards,
        isDisabled: isDisabled
    }) : null;
const $0b89d206e63a02bd$var$ConnectedClearMenuItem = (0, $bC2fB.connect)($0b89d206e63a02bd$export$c31df4bd766f9c35, $0b89d206e63a02bd$export$9e6a17cf56877796, $0b89d206e63a02bd$export$9d1611c77c2fe928)($0b89d206e63a02bd$var$HideableItem);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0b89d206e63a02bd$export$2e2bcd8739ae039 = (props)=>{
    const [clearCards] = (0, $aHYmi.useClearCards)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0b89d206e63a02bd$var$ConnectedClearMenuItem, {
        ...props,
        clearCards: clearCards
    });
};

});
parcelRegister("aHYmi", function(module, exports) {

$parcel$export(module.exports, "useClearCards", () => $500604bfe83c7b49$export$4536e3f12af4ca28);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $4tEQ4 = parcelRequire("4tEQ4");

var $lbgzx = parcelRequire("lbgzx");

var $1m9QN = parcelRequire("1m9QN");

var $5DKw8 = parcelRequire("5DKw8");
const $500604bfe83c7b49$export$4536e3f12af4ca28 = ()=>{
    const [clearMutation] = (0, $1m9QN.useClearCardsMutation)();
    const [unclearCards] = (0, $5DKw8.useUnclearCards)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const flagId = (0, $5uXOq.useRef)();
    const onDismissFlag = (0, $5uXOq.useCallback)(()=>{
        if (flagId.current) // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string'.
        dismissFlag(flagId.current);
    }, [
        dismissFlag
    ]);
    const callback = (0, $5uXOq.useCallback)(({ cardIds: cardIds, boardId: boardId, onUndo: onUndo, onUndoFlagDismissed: onUndoFlagDismissed, resolvedIssuesUrl: resolvedIssuesUrl })=>{
        const clearMutationPromise = clearMutation({
            variables: {
                cardIds: cardIds,
                boardId: boardId
            }
        });
        const onUndoCallback = ()=>{
            unclearCards({
                cardIds: cardIds,
                boardId: boardId,
                onUndo: onUndo
            });
        };
        clearMutationPromise.then(()=>{
            flagId.current = showFlag({
                render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lbgzx.default), {
                        resolvedIssuesUrl: resolvedIssuesUrl,
                        numDoneCards: cardIds.length,
                        onUndo: ()=>{
                            onUndoCallback();
                            onDismissFlag();
                        },
                        onDismiss: ()=>{
                            onUndoFlagDismissed && onUndoFlagDismissed();
                            onDismissFlag();
                        },
                        ...props
                    })
            });
        }).catch((error)=>{
            showFlag((0, $4tEQ4.getErrorFlag)(error));
        });
        return clearMutationPromise;
    }, [
        clearMutation,
        onDismissFlag,
        showFlag,
        unclearCards
    ]);
    return [
        callback
    ];
};

});
parcelRegister("lbgzx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9122bd0d211e432f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2Yv61 = parcelRequire("2Yv61");

var $2hXfb = parcelRequire("2hXfb");


var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $7R4eB = parcelRequire("7R4eB");

var $f2BYd = parcelRequire("f2BYd");

var $az4zD = parcelRequire("az4zD");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");

var $lDOSI = parcelRequire("lDOSI");
const $9122bd0d211e432f$var$UndoFlag = ({ intl: { formatMessage: formatMessage }, onUndo: onUndo, onDismiss: onDismiss, numDoneCards: numDoneCards, resolvedIssuesUrl: resolvedIssuesUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "flag",
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f2BYd.default), {
        onDismissed: onDismiss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7R4eB.default), {
        id: "software-board-clearing.ui.undo-flag",
        icon: (0, $4R6GH.fg)('tnk-1796-visual-refresh-tanuki-misc-packages') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Yv61))), {
            color: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$exports).P300})`,
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2hXfb))),
            LEGACY_primaryColor: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$exports).P300})`,
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hXfb))), {
            primaryColor: `var(--ds-text-discovery, ${(0, $829f609a65d26a98$exports).P300})`,
            label: ""
        }),
        actions: [
            {
                content: formatMessage((0, $lDOSI.default).undo),
                onClick: (_, analyticsEvent)=>{
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clearIssuesFlagUndoClearIssuesLink');
                    onUndo();
                }
            },
            {
                content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lDOSI.default).viewIssuesIssueTermRefresh : (0, $lDOSI.default).viewIssues),
                href: resolvedIssuesUrl,
                onClick: (_, analyticsEvent)=>{
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clearIssuesFlagViewIssuesLink');
                }
            }
        ],
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lDOSI.default).titleIssueTermRefresh : (0, $lDOSI.default).title, {
            numDoneCards: numDoneCards
        }),
        description: formatMessage((0, $lDOSI.default).description, {
            numDoneCards: numDoneCards
        })
    })));
var $9122bd0d211e432f$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($9122bd0d211e432f$var$UndoFlag);

});
parcelRegister("7R4eB", function(module, exports) {

$parcel$export(module.exports, "default", () => $435170f9f2349b2e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1eg3p = parcelRequire("1eg3p");

var $3KRpp = parcelRequire("3KRpp");
const $435170f9f2349b2e$var$AkAutoDismissFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.CommonFlag), {
        isAutoDismiss: true,
        ...props,
        flagType: "info"
    }));
var $435170f9f2349b2e$export$2e2bcd8739ae039 = $435170f9f2349b2e$var$AkAutoDismissFlag;

});

parcelRegister("f2BYd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3780c7e328dbb70e$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$3780c7e328dbb70e$export$2e2bcd8739ae039 = (0, $3KRpp.FlagGroup);

});

parcelRegister("lDOSI", function(module, exports) {

$parcel$export(module.exports, "default", () => $16186a699408e99d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $16186a699408e99d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software-board-clearing.common.undo-flag.title",
        "defaultMessage": "{numDoneCards, plural, one {Issue cleared from board} other {{numDoneCards} done issues cleared}}"
    },
    description: {
        "id": "software-board-clearing.common.undo-flag.description",
        "defaultMessage": "{numDoneCards, plural, one {It is still in your project, and you can search for it later if you need to.} other {They\u2019re still in your project, and you can search for them later if you need to.}}"
    },
    undo: {
        "id": "software-board-clearing.common.undo-flag.undo",
        "defaultMessage": "Undo"
    },
    viewIssues: {
        "id": "software-board-clearing.common.undo-flag.view-issues",
        "defaultMessage": "View done issues"
    },
    titleIssueTermRefresh: {
        "id": "software-board-clearing.common.undo-flag.title-issue-term-refresh",
        "defaultMessage": "{numDoneCards, plural, one {Issue cleared from board} other {{numDoneCards} done issues cleared}}"
    },
    viewIssuesIssueTermRefresh: {
        "id": "software-board-clearing.common.undo-flag.view-issues-issue-term-refresh",
        "defaultMessage": "View done issues"
    }
});

});


parcelRegister("1m9QN", function(module, exports) {

$parcel$export(module.exports, "useClearCardsMutation", () => $b86eb0f67d9b1f7f$export$8e192ef7c7961fa6);

var $5tTFS = parcelRequire("5tTFS");

var $5cllN = parcelRequire("5cllN");
const $b86eb0f67d9b1f7f$export$7473a9a03a67999e = (0, $5cllN.default)`
    mutation SoftwareBoardClearCards($boardId: ID!, $cardIds: [ID!]!) {
        clearCards(input: { boardId: $boardId, cardIds: $cardIds }) {
            clearedCardIds
        }
    }
`;
const $b86eb0f67d9b1f7f$export$8e192ef7c7961fa6 = ()=>(0, $5tTFS.useMutation)($b86eb0f67d9b1f7f$export$7473a9a03a67999e);

});

parcelRegister("5DKw8", function(module, exports) {

$parcel$export(module.exports, "useUnclearCards", () => $7e3afb1b0787ecbf$export$1fe06fa658396c74);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $cCTcJ = parcelRequire("cCTcJ");

var $5YqMH = parcelRequire("5YqMH");

var $39X7C = parcelRequire("39X7C");
const $7e3afb1b0787ecbf$export$1fe06fa658396c74 = ()=>{
    const [unclearMutation] = (0, $39X7C.useUnclearCardsMutation)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const errorFlagId = (0, $5uXOq.useRef)();
    const onDismissUndoErrorFlag = (0, $5uXOq.useCallback)(()=>{
        if (errorFlagId.current) // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string'.
        dismissFlag(errorFlagId.current);
    }, [
        dismissFlag
    ]);
    const callback = (0, $5uXOq.useCallback)(({ cardIds: cardIds, boardId: boardId, onUndo: onUndo, retry: retry })=>{
        const unclearMutationPromise = unclearMutation({
            variables: {
                cardIds: cardIds.map(String),
                boardId: String(boardId)
            }
        });
        unclearMutationPromise.then(()=>{
            retry === true && showFlag((0, $5YqMH.default));
        }).catch(()=>{
            errorFlagId.current = showFlag({
                render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cCTcJ.default), {
                        onDismissFlag: onDismissUndoErrorFlag,
                        onRetry: ()=>callback({
                                cardIds: cardIds,
                                boardId: boardId,
                                onUndo: onUndo,
                                retry: true
                            }),
                        ...props
                    })
            });
        });
        onUndo && onUndo(unclearMutationPromise, !!retry);
    }, [
        onDismissUndoErrorFlag,
        showFlag,
        unclearMutation
    ]);
    return [
        callback
    ];
};

});
parcelRegister("cCTcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f168e1da31227080$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $1wpPp = parcelRequire("1wpPp");

var $az4zD = parcelRequire("az4zD");

var $gPMiB = parcelRequire("gPMiB");
function $f168e1da31227080$var$UndoErrorFlag({ intl: { formatMessage: formatMessage }, onRetry: onRetry, onDismissFlag: onDismissFlag }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wpPp.default), {
        id: "undo-clear-error",
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gPMiB.default).titleIssueTermRefresh : (0, $gPMiB.default).title),
        description: formatMessage((0, $gPMiB.default).description),
        actions: [
            {
                content: formatMessage((0, $gPMiB.default).tryAgain),
                onClick: ()=>{
                    onRetry();
                    onDismissFlag();
                }
            }
        ]
    });
}
var $f168e1da31227080$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($f168e1da31227080$var$UndoErrorFlag);

});
parcelRegister("1wpPp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ebed3b5115fbfc5$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$2ebed3b5115fbfc5$export$2e2bcd8739ae039 = (0, $3KRpp.ErrorFlag);

});

parcelRegister("gPMiB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a686a0f1a58782f6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a686a0f1a58782f6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software-board-clearing.common.undo-error-flag.title",
        "defaultMessage": "We couldn\u2019t restore your cleared issues."
    },
    description: {
        "id": "software-board-clearing.common.undo-error-flag.description",
        "defaultMessage": "Please check your connection."
    },
    tryAgain: {
        "id": "software-board-clearing.common.undo-error-flag.try-again",
        "defaultMessage": "Try again"
    },
    titleIssueTermRefresh: {
        "id": "software-board-clearing.common.undo-error-flag.title-issue-term-refresh",
        "defaultMessage": "We couldn\u2019t restore your cleared issues."
    }
});

});


parcelRegister("5YqMH", function(module, exports) {

$parcel$export(module.exports, "default", () => $29857646ea9debd4$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");

var $e5wyW = parcelRequire("e5wyW");

var $lmI0r = parcelRequire("lmI0r");
const $29857646ea9debd4$var$UndoSuccessFlag = {
    title: (0, $lmI0r.default).title,
    type: 'success',
    isAutoDismiss: true
};
const $29857646ea9debd4$var$UndoSuccessFlagIssueTermRefresh = {
    title: (0, $lmI0r.default).titleIssueTermRefresh,
    type: 'success',
    isAutoDismiss: true
};
const $29857646ea9debd4$var$selector = (0, $e5wyW.functionWithCondition)(()=>(0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false), ()=>$29857646ea9debd4$var$UndoSuccessFlagIssueTermRefresh, ()=>$29857646ea9debd4$var$UndoSuccessFlag);
const $29857646ea9debd4$var$UndoSuccessFlagConfigurations = $29857646ea9debd4$var$selector();
var $29857646ea9debd4$export$2e2bcd8739ae039 = $29857646ea9debd4$var$UndoSuccessFlagConfigurations;

});
parcelRegister("lmI0r", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ba39561928a01ce$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1ba39561928a01ce$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software-board-clearing.common.undo-success-flag.title",
        "defaultMessage": "We have restored your cleared issues"
    },
    titleIssueTermRefresh: {
        "id": "software-board-clearing.common.undo-success-flag.title-issue-term-refresh",
        "defaultMessage": "We have restored your cleared issues"
    }
});

});


parcelRegister("39X7C", function(module, exports) {

$parcel$export(module.exports, "useUnclearCardsMutation", () => $4414cfd486952a48$export$be434ee83fc040d1);

var $5tTFS = parcelRequire("5tTFS");

var $5cllN = parcelRequire("5cllN");
const $4414cfd486952a48$export$7473a9a03a67999e = (0, $5cllN.default)`
    mutation SoftwareBoardUnclearCards($boardId: ID!, $cardIds: [ID!]!) {
        unclearCards(input: { boardId: $boardId, cardIds: $cardIds }) {
            message
            statusCode
        }
    }
`;
const $4414cfd486952a48$export$be434ee83fc040d1 = ()=>(0, $5tTFS.useMutation)($4414cfd486952a48$export$7473a9a03a67999e);

});



parcelRegister("hnvrw", function(module, exports) {

$parcel$export(module.exports, "getResolvedIssuesUrl", () => $fde7b6b408203dc7$export$1df843d83726e46b);
$parcel$export(module.exports, "getOldIssuesUrl", () => $fde7b6b408203dc7$export$6fc0da5ddeff094d);
const $fde7b6b408203dc7$var$appendAgilityReferrer = (url)=>`${url}&referrer=agility`;
const $fde7b6b408203dc7$export$628e089b9efd0cc4 = (contextPath, projectKey)=>`${contextPath}/projects/${projectKey}/issues`;
const $fde7b6b408203dc7$export$52a00adb39521b8b = (contextPath, projectKey)=>`${contextPath}/jira/software/projects/${projectKey}/issues/`;
const $fde7b6b408203dc7$export$1df843d83726e46b = (contextPath, projectKey)=>$fde7b6b408203dc7$var$appendAgilityReferrer(`${$fde7b6b408203dc7$export$52a00adb39521b8b(contextPath, projectKey)}?filter=doneissues`);
const $fde7b6b408203dc7$export$6fc0da5ddeff094d = (contextPath, projectKey)=>`${contextPath}/issues/?jql=${encodeURIComponent(`project = ${projectKey} AND (fixVersion in unreleasedVersions() OR fixVersion is EMPTY) AND statusCategory = Done AND updated <= -2w ORDER BY Rank ASC`)}`;

});

parcelRegister("egWyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0bfb7b8ca1e3e21$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $5e9QP = parcelRequire("5e9QP");
const $e0bfb7b8ca1e3e21$export$27a5bd065ad55220 = ({ onClick: onClick, numDoneCards: numDoneCards, isDisabled: isDisabled })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleOnClick = (event)=>{
        onClick(event, createAnalyticsEvent({
            actionSubject: 'dropdownMenuItem',
            action: 'clicked'
        }));
    };
    const menuItemClearAll = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: handleOnClick,
        isDisabled: isDisabled,
        "data-testid": "software-board.board-container.board.column.header.menu.item-clear-all"
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5e9QP.default).labelIssueTermRefresh : (0, $5e9QP.default).label, {
        numDoneCards: numDoneCards
    }));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $5e9QP.default).tooltip)
    }, menuItemClearAll);
    return menuItemClearAll;
};
var $e0bfb7b8ca1e3e21$export$2e2bcd8739ae039 = $e0bfb7b8ca1e3e21$export$27a5bd065ad55220;

});
parcelRegister("6B7KL", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ff85f737833a5bc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5JjdN = parcelRequire("5JjdN");

var $kJpBP = parcelRequire("kJpBP");

var $1aogK = parcelRequire("1aogK");

var $3Z96c = parcelRequire("3Z96c");

var $VSDnB = parcelRequire("VSDnB");

var $l7Q0F = parcelRequire("l7Q0F");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $9ff85f737833a5bc$var$DropdownMenuItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
    const itemRef = (0, $l7Q0F.default)();
    const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1aogK.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $5JjdN.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $VSDnB.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $5JjdN.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...(0, $VSDnB.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $5JjdN.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $VSDnB.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
});
var $9ff85f737833a5bc$export$2e2bcd8739ae039 = $9ff85f737833a5bc$var$DropdownMenuItem;

});

parcelRegister("5e9QP", function(module, exports) {

$parcel$export(module.exports, "default", () => $36518315b7680ab8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $36518315b7680ab8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software.main.board-container.board.column.header.menu.item-clear-all.label",
        "defaultMessage": "{numDoneCards, plural, one {Clear 1 Done issue} other {Clear {numDoneCards} Done issues}}"
    },
    tooltip: {
        "id": "software.main.board-container.board.column.header.menu.item-clear-all.tooltip",
        "defaultMessage": "Unavailable when grouping by subtask"
    },
    labelIssueTermRefresh: {
        "id": "software.main.board-container.board.column.header.menu.item-clear-all.label-issue-term-refresh",
        "defaultMessage": "{numDoneCards, plural, one {Clear 1 Done issue} other {Clear {numDoneCards} Done issues}}"
    }
});

});



parcelRegister("hyV8h", function(module, exports) {

$parcel$export(module.exports, "default", () => $557d95e634861f29$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $2OMDV = parcelRequire("2OMDV");

var $bC2fB = parcelRequire("bC2fB");


var $63F6h = parcelRequire("63F6h");

var $1vXOx = parcelRequire("1vXOx");

var $5mTgl = parcelRequire("5mTgl");

var $hopHY = parcelRequire("hopHY");
const $557d95e634861f29$var$mapStateToProps = (state, props)=>({
        isDisabled: props.isDisabled || !(0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df] || !(0, $5mTgl.isInlineColumnEditEnabled)(state),
        isLastRemainingColumn: (0, $5mTgl.isLastRemainingColumn)(state),
        hasIssues: (0, $5mTgl.doesColumnHaveIssuesSelector)(state)(props.columnId),
        hasIssuesNotOnBoard: (0, $5mTgl.hasIssuesNotOnBoard)(state)(props.columnId)
    });
const $557d95e634861f29$var$mapDispatchToProps = {
    columnDelete: $63F6h.columnDelete
};
const $557d95e634861f29$var$onClickFactory = (0, $8QpSo.default)((onClick, dispatchPropsColumnDelete, columnId, hasIssues, statePropsHasIssuesNotOnBoard)=>()=>{
        onClick();
        dispatchPropsColumnDelete(columnId, hasIssues, statePropsHasIssuesNotOnBoard);
    });
const $557d95e634861f29$var$mergeProps = (stateProps, dispatchProps, props)=>({
        isDisabled: stateProps.isDisabled,
        isLastRemainingColumn: stateProps.isLastRemainingColumn,
        onClick: $557d95e634861f29$var$onClickFactory(props.onClick, dispatchProps.columnDelete, props.columnId, stateProps.hasIssues, stateProps.hasIssuesNotOnBoard)
    });
const $557d95e634861f29$var$connector = (0, $bC2fB.connect)($557d95e634861f29$var$mapStateToProps, $557d95e634861f29$var$mapDispatchToProps, $557d95e634861f29$var$mergeProps);
const $557d95e634861f29$var$ColumnDeleteMenuItemWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('columnSettingsDeleteMenuItem', {
    onClick: 'clicked'
})((0, $hopHY.default));
var $557d95e634861f29$export$2e2bcd8739ae039 = $557d95e634861f29$var$connector($557d95e634861f29$var$ColumnDeleteMenuItemWithAnalytics);

});
parcelRegister("hopHY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b437cd12b63fd37e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ewsTZ = parcelRequire("ewsTZ");
const $b437cd12b63fd37e$var$DATA_TEST_ID = 'software-board.board-container.board.column.header.menu.item-delete.dropdown-item';
const $b437cd12b63fd37e$export$301cfb4be78b5e8c = ({ isLastRemainingColumn: isLastRemainingColumn, isDisabled: isDisabled, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        onClick();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'columnSettingsDeleteMenuItem',
            action: 'clicked'
        }));
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const renderDropdownItem = (0, $5uXOq.useCallback)((disabled)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            "data-testid": $b437cd12b63fd37e$var$DATA_TEST_ID,
            isDisabled: disabled,
            onClick: handleOnClick
        }, formatMessage((0, $ewsTZ.default).delete)), [
        formatMessage,
        handleOnClick
    ]);
    return isLastRemainingColumn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $ewsTZ.default).lastColumn)
    }, renderDropdownItem(true)) : renderDropdownItem(isDisabled);
};
const $b437cd12b63fd37e$var$hideableMenuItem = (MenuItem)=>(props)=>!props.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, props) : null;
var $b437cd12b63fd37e$export$2e2bcd8739ae039 = $b437cd12b63fd37e$var$hideableMenuItem($b437cd12b63fd37e$export$301cfb4be78b5e8c);

});
parcelRegister("ewsTZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa674a2de77eae11$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fa674a2de77eae11$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    delete: {
        "id": "software.main.board-container.board.column.header.menu.item-delete.delete",
        "defaultMessage": "Delete"
    },
    lastColumn: {
        "id": "software.main.board-container.board.column.header.menu.item-delete.last-column",
        "defaultMessage": "The last column can't be deleted"
    }
});

});



parcelRegister("1dfpa", function(module, exports) {

$parcel$export(module.exports, "default", () => $418b172c815c723d$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $bC2fB = parcelRequire("bC2fB");


var $9eeht = parcelRequire("9eeht");

var $1vXOx = parcelRequire("1vXOx");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $cbScZ = parcelRequire("cbScZ");
const $418b172c815c723d$export$c31df4bd766f9c35 = (state, props)=>({
        isDisabled: props.isDisabled || !(0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df] || !(0, $5mTgl.isInlineColumnEditEnabled)(state) || (0, $67Z81.getIsCMPBoard)(state) && !(0, $5mTgl.boardColumnConstraintTypeSelector)(state)
    });
const $418b172c815c723d$export$9e6a17cf56877796 = (dispatch)=>({
        dispatch: dispatch
    });
const $418b172c815c723d$var$onClickFactory = (0, $8QpSo.default)((dispatch, columnId, onClick)=>()=>{
        dispatch((0, $9eeht.columnOpenLimitsModal)(columnId));
        onClick();
    });
const $418b172c815c723d$export$9d1611c77c2fe928 = (stateProps, dispatchProps, ownProps)=>{
    const { columnId: columnId, onClick: onClick } = ownProps;
    const { dispatch: dispatch } = dispatchProps;
    const { isDisabled: isDisabled } = stateProps;
    return {
        isDisabled: isDisabled,
        onClick: $418b172c815c723d$var$onClickFactory(dispatch, columnId, onClick)
    };
};
const $418b172c815c723d$var$connector = (0, $bC2fB.connect)($418b172c815c723d$export$c31df4bd766f9c35, $418b172c815c723d$export$9e6a17cf56877796, $418b172c815c723d$export$9d1611c77c2fe928);
var $418b172c815c723d$export$2e2bcd8739ae039 = $418b172c815c723d$var$connector((0, $cbScZ.default));

});
parcelRegister("cbScZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9f3e674e825776f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $koVbs = parcelRequire("koVbs");

var $5vXbo = parcelRequire("5vXbo");
const $d9f3e674e825776f$export$2f25159957e16b83 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        "data-testid": "software-board.board-container.board.column.header.menu.item-limits",
        isDisabled: props.isDisabled,
        onClick: props.onClick
    }, formatMessage((0, $5vXbo.default).displayText));
};
const $d9f3e674e825776f$export$398d8a1ba03cb49f = (MenuItem)=>(props)=>!props.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, props) : null;
var $d9f3e674e825776f$export$2e2bcd8739ae039 = $d9f3e674e825776f$export$398d8a1ba03cb49f($d9f3e674e825776f$export$2f25159957e16b83);

});
parcelRegister("5vXbo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f5d70e141274817$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0f5d70e141274817$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    displayText: {
        "id": "software.main.board-container.board.column.header.menu.item-limits.display-text",
        "defaultMessage": "Set column limit"
    }
});

});



parcelRegister("4Ys5a", function(module, exports) {

$parcel$export(module.exports, "default", () => $94e65005fa282389$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $94e65005fa282389$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dropdownMenuAriaLabelOld: {
        "id": "software.main.board-container.board.column.header.menu.dropdown-menu-aria-label-old",
        "defaultMessage": "{heading} column"
    },
    dropdownMenuAriaLabel: {
        "id": "software.main.board-container.board.column.header.menu.dropdown-menu-aria-label",
        "defaultMessage": "{heading} column more actions"
    }
});

});



parcelRegister("lBRY4", function(module, exports) {

$parcel$export(module.exports, "default", () => $54056611b5d48913$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $dIdda = parcelRequire("dIdda");

var $aKlQV = parcelRequire("aKlQV");

var $5rtwe = parcelRequire("5rtwe");

var $1gnEU = parcelRequire("1gnEU");
const $54056611b5d48913$var$NoActiveSprintMessage = ()=>{
    const intl = (0, $koVbs.default)();
    const backlogUrl = (0, $aKlQV.useBacklogUrl)() || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($54056611b5d48913$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($54056611b5d48913$var$Image, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5rtwe))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($54056611b5d48913$var$TitleStyle, null, intl.formatMessage((0, $1gnEU.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($54056611b5d48913$var$TextStyle, null, intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1gnEU.default).descriptionIssueTermRefresh : (0, $1gnEU.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        component: (0, $dIdda.Link),
        href: backlogUrl
    }, intl.formatMessage((0, $1gnEU.default).button)));
};
var $54056611b5d48913$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $54056611b5d48913$var$NoActiveSprintMessage;
const $54056611b5d48913$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4xy5q _1e0c1txw _4cvr1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $54056611b5d48913$var$Image = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1qr7 _4t3i1qr7",
            __cmplp.className
        ])
    });
});
const $54056611b5d48913$var$TextStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _otyr1ejb",
            __cmplp.className
        ])
    });
});
const $54056611b5d48913$var$TitleStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $54056611b5d48913$var$TextStyle, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48p8n31 _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aKlQV", function(module, exports) {

$parcel$export(module.exports, "useBacklogUrl", () => $0e9c32fa4d0631b2$export$b5198977ee15e8a7);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $4DPZY = parcelRequire("4DPZY");

var $gSBIZ = parcelRequire("gSBIZ");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");
const $0e9c32fa4d0631b2$export$b5198977ee15e8a7 = (additionalParams = [])=>{
    const boardId = (0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector));
    const isCMPBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsCMPBoard));
    const contextPath = (0, $67sX6.useBoardSelector)((0, $67Z81.contextPathSelector));
    const [{ data: data, error: error }] = (0, $4DPZY.useContainerContext)();
    return (0, $5uXOq.useMemo)(()=>{
        if (!data || error) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('useBacklogUrl', 'Failed getting container context');
            return null;
        }
        const url = (0, $gSBIZ.isUserContext)(data) ? `${contextPath}/jira/people/${data.user.accountId}` : `${contextPath}/jira/software${isCMPBoard ? '/c' : ''}/projects/${data.project.key}`;
        return `${url}/boards/${boardId}/backlog${additionalParams.length ? `?${additionalParams.join('&')}` : ''}`;
    }, [
        additionalParams,
        boardId,
        contextPath,
        data,
        error,
        isCMPBoard
    ]);
};

});
parcelRegister("gSBIZ", function(module, exports) {

$parcel$export(module.exports, "isProjectContext", () => $3bb86183071b9984$export$d46e75e464bf2407);
$parcel$export(module.exports, "isUserContext", () => $3bb86183071b9984$export$8d1083037a4a6250);
const $3bb86183071b9984$export$d46e75e464bf2407 = (containerContext)=>containerContext.project !== undefined;
const $3bb86183071b9984$export$8d1083037a4a6250 = (containerContext)=>containerContext.user !== undefined;

});


parcelRegister("5rtwe", function(module, exports) {
module.exports = new URL("agile.52407441.svg", import.meta.url).toString();

});

parcelRegister("1gnEU", function(module, exports) {

$parcel$export(module.exports, "default", () => $14b2046274c87bd6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $14b2046274c87bd6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software.main.board-container.board.column.no-active-sprint-dialog.title",
        "defaultMessage": "Get started in the backlog"
    },
    description: {
        "id": "software.main.board-container.board.column.no-active-sprint-dialog.description",
        "defaultMessage": "Plan and start a sprint to see issues here."
    },
    button: {
        "id": "software.main.board-container.board.column.no-active-sprint-dialog.button",
        "defaultMessage": "Go to Backlog"
    },
    descriptionIssueTermRefresh: {
        "id": "software.main.board-container.board.column.no-active-sprint-dialog.description-issue-term-refresh",
        "defaultMessage": "Plan and start a sprint to see issues here."
    }
});

});


parcelRegister("hXOH1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3d132e84ce6bf43$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7uUwQ = parcelRequire("7uUwQ");

var $hGgHi = parcelRequire("hGgHi");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $645AZ = parcelRequire("645AZ");

var $4jAPy = parcelRequire("4jAPy");

var $jgcLy = parcelRequire("jgcLy");

var $iTu9h = parcelRequire("iTu9h");

var $esu6n = parcelRequire("esu6n");

var $67sX6 = parcelRequire("67sX6");

var $4kOHs = parcelRequire("4kOHs");

var $bL0WB = parcelRequire("bL0WB");

var $1vXOx = parcelRequire("1vXOx");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");

var $cPGP0 = parcelRequire("cPGP0");

var $5mTgl = parcelRequire("5mTgl");

var $eeRMo = parcelRequire("eeRMo");

var $8qFMV = parcelRequire("8qFMV");
const $c3d132e84ce6bf43$var$IterationColumnHeader = ({ swimlaneId: swimlaneId, columnId: columnId, planningUnit: planningUnit, workingHoursPerDay: workingHoursPerDay, capacityInfo: capacityInfo, hideTotalCapacity: hideTotalCapacity, isReadOnly: isReadOnly, totalIssues: totalIssues, visibleIssues: visibleIssues })=>{
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const { totalCapacity: totalCapacity, usedCapacity: usedCapacity, defaultCapacity: defaultCapacity } = capacityInfo;
    const onChangeCapacity = (0, $5uXOq.useCallback)((capacity)=>{
        dispatch((0, $bL0WB.updateIterationCapacityRequest)({
            capacity: capacity,
            planningUnit: planningUnit,
            workingHoursPerDay: workingHoursPerDay,
            iterationId: columnId,
            teamId: swimlaneId,
            totalCapacity: totalCapacity,
            defaultCapacity: defaultCapacity
        }));
    }, [
        dispatch,
        planningUnit,
        workingHoursPerDay,
        columnId,
        swimlaneId,
        totalCapacity,
        defaultCapacity
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgcLy.default), {
        columnId: columnId,
        totalCapacity: totalCapacity,
        usedCapacity: usedCapacity,
        defaultCapacity: defaultCapacity,
        planningConfig: {
            planningUnit: planningUnit,
            workingHoursPerDay: workingHoursPerDay
        },
        onChangeCapacity: onChangeCapacity,
        hideTotalCapacity: hideTotalCapacity,
        isReadOnly: isReadOnly,
        visibleIssues: visibleIssues,
        totalIssues: totalIssues
    });
};
const $c3d132e84ce6bf43$var$SprintColumnHeader = ({ sprint: sprint, swimlaneId: swimlaneId, columnId: columnId, planningUnit: planningUnit, workingHoursPerDay: workingHoursPerDay, sprintCapacity: sprintCapacity, isReadOnly: isReadOnly })=>{
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const overlappedSprintPerTeam = (0, $67sX6.useBoardSelector)((0, $cPGP0.getOverlappedSprintPerTeam));
    const overlappedSprints = (0, $7uUwQ.getIn)(overlappedSprintPerTeam, [
        swimlaneId,
        sprint.id
    ]);
    const column = (0, $67sX6.useBoardSelector)((state)=>(0, $esu6n.getDateRangeColumn)((0, $fyeGd.getColumnById)(state, columnId)));
    const onChangeCapacity = (0, $5uXOq.useCallback)((capacity)=>{
        dispatch((0, $4kOHs.updatePlannedCapacityRequest)({
            capacity: capacity,
            planningUnit: planningUnit,
            workingHoursPerDay: workingHoursPerDay,
            iterationId: sprint.id,
            teamId: swimlaneId,
            totalCapacity: sprintCapacity.totalCapacity,
            defaultCapacity: sprintCapacity.defaultCapacity
        }));
    }, [
        dispatch,
        planningUnit,
        workingHoursPerDay,
        sprint,
        swimlaneId,
        sprintCapacity.totalCapacity,
        sprintCapacity.defaultCapacity
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iTu9h.default), {
        sprint: sprint,
        totalCapacity: sprintCapacity.totalCapacity,
        usedCapacity: sprintCapacity.usedCapacity,
        doneCapacity: sprintCapacity.doneCapacity,
        defaultCapacity: sprintCapacity.defaultCapacity,
        planningConfig: {
            planningUnit: planningUnit,
            workingHoursPerDay: workingHoursPerDay
        },
        overlappedSprints: overlappedSprints,
        columnDateRange: column?.dateRange,
        onChangeCapacity: onChangeCapacity,
        isReadOnly: isReadOnly
    });
};
const $c3d132e84ce6bf43$var$ProgramSwimlaneColumnHeader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ count: count, columnId: columnId, swimlaneId: swimlaneId, isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel }, headerRef)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isReadOnly = (0, $67sX6.useBoardSelector)((0, $1vXOx.isIncrementPlanningReadOnly));
    const isExternalTeam = (0, $67sX6.useBoardSelector)((state)=>(0, $cPGP0.getTeamById)(state)(swimlaneId)?.isPlanTeam) === false;
    const isScenarioTeam = (0, $67sX6.useBoardSelector)((state)=>(0, $cPGP0.getTeamById)(state)(swimlaneId)?.isOnlyInScenario) === true;
    const sprint = (0, $67sX6.useBoardSelector)((state)=>(0, $5mTgl.getTeamSwimlaneColumnSprint)(state, columnId, swimlaneId));
    const sprintCapacityPerTeam = (0, $67sX6.useBoardSelector)((0, $cPGP0.getSprintCapacityInfo));
    const sprintCapacity = sprint && (0, $7uUwQ.getIn)(sprintCapacityPerTeam, [
        swimlaneId,
        sprint.id
    ]);
    const iterationCapacityPerTeam = (0, $67sX6.useBoardSelector)((0, $cPGP0.getIterationCapacityInfo));
    const capacity = (0, $7uUwQ.getIn)(iterationCapacityPerTeam, [
        swimlaneId,
        columnId
    ]);
    const { timeTrackingOptions: { workingHoursPerDay: workingHoursPerDay } } = (0, $67sX6.useBoardSelector)((0, $67Z81.getBoardConfig));
    const incrementConfig = (0, $67sX6.useBoardSelector)((0, $67Z81.getIncrementConfig));
    const total = (0, $67sX6.useBoardSelector)((state)=>(0, $5mTgl.getTeamSwimlaneColumnTotalIssuesCount)(state, columnId, swimlaneId));
    const visibleIssues = (0, $5uXOq.useMemo)(()=>count !== total ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $8qFMV.default).visibleIssueCountIssueTermRefresh : (0, $8qFMV.default).visibleIssueCount, {
            count: count,
            total: total
        }) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $8qFMV.default).totalIssueCountIssueTermRefresh : (0, $8qFMV.default).totalIssueCount, {
            total: total
        }), [
        count,
        total,
        formatMessage
    ]);
    const planningUnit = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(incrementConfig?.planningUnit) ? (0, $4jAPy.IP_BOARD_STORY_POINTS_PLANNING_UNIT) : incrementConfig.planningUnit;
    if (swimlaneId === (0, $4jAPy.SWIMLANE_TEAMLESS) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(sprint) && capacity) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ref: headerRef,
        xcss: isUnscheduledWorkColumnPanel ? [
            $c3d132e84ce6bf43$var$programSwimlaneColumnHeaderOuterStyles,
            $c3d132e84ce6bf43$var$unscheduledColumnHeaderOuterStyles
        ] : $c3d132e84ce6bf43$var$programSwimlaneColumnHeaderOuterStyles
    }, headerRef && typeof headerRef !== 'function' && headerRef.current && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eeRMo.HeaderMeasurement), {
        columnId: columnId,
        isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel,
        headerRef: headerRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c3d132e84ce6bf43$var$IterationColumnHeader, {
        visibleIssues: count,
        totalIssues: total,
        swimlaneId: swimlaneId,
        columnId: columnId,
        planningUnit: planningUnit,
        workingHoursPerDay: workingHoursPerDay,
        capacityInfo: capacity,
        hideTotalCapacity: isExternalTeam || swimlaneId === (0, $4jAPy.SWIMLANE_TEAMLESS) || isScenarioTeam,
        isReadOnly: isReadOnly
    }));
    if (sprint && sprintCapacity) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: isUnscheduledWorkColumnPanel ? [
            $c3d132e84ce6bf43$var$programSwimlaneColumnHeaderOuterStyles,
            $c3d132e84ce6bf43$var$unscheduledColumnHeaderOuterStyles
        ] : $c3d132e84ce6bf43$var$programSwimlaneColumnHeaderOuterStyles,
        ref: headerRef
    }, headerRef && typeof headerRef !== 'function' && headerRef.current && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eeRMo.HeaderMeasurement), {
        columnId: columnId,
        isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel,
        headerRef: headerRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c3d132e84ce6bf43$var$SprintColumnHeader, {
        sprint: sprint,
        swimlaneId: swimlaneId,
        columnId: columnId,
        planningUnit: planningUnit,
        workingHoursPerDay: workingHoursPerDay,
        sprintCapacity: sprintCapacity,
        isReadOnly: isReadOnly
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: isUnscheduledWorkColumnPanel ? [
            $c3d132e84ce6bf43$var$programSwimlaneColumnHeaderOuterStyles,
            $c3d132e84ce6bf43$var$unscheduledColumnHeaderOuterStyles
        ] : $c3d132e84ce6bf43$var$programSwimlaneColumnHeaderOuterStyles,
        ref: headerRef
    }, headerRef && typeof headerRef !== 'function' && headerRef.current && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eeRMo.HeaderMeasurement), {
        columnId: columnId,
        isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel,
        headerRef: headerRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $c3d132e84ce6bf43$var$columnHeaderWrapper,
            $c3d132e84ce6bf43$var$storyPointCapacityAndIssueCountStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c3d132e84ce6bf43$var$issueCountStyles
    }, visibleIssues)));
});
// main board columns header height, plus swimlane header height,
// minus the 8px gutter which gets removed from the top of the swimlane header on scroll
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $c3d132e84ce6bf43$var$stickyOffset = `calc(${(0, $645AZ.swimlaneHeaderHeight) + (0, $645AZ.columnHeaderHeight)}px - ${"var(--ds-space-100, 8px)"})`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $c3d132e84ce6bf43$var$unscheduledColumnStickyOffset = `calc(${(0, $645AZ.unscheduledColumnHeaderHeight) + (0, $645AZ.columnHeaderHeight)}px - ${"var(--ds-space-100, 8px)"})`;
const $c3d132e84ce6bf43$var$programSwimlaneColumnHeaderOuterStyles = (0, $8CUq3.xcss)({
    position: 'sticky',
    backgroundColor: 'elevation.surface',
    paddingTop: 'space.075',
    // zIndex of 1 is required to ensure the column header is above the column and below the swimlane header
    zIndex: '1',
    top: `${$c3d132e84ce6bf43$var$stickyOffset}`
});
const $c3d132e84ce6bf43$var$unscheduledColumnHeaderOuterStyles = (0, $8CUq3.xcss)({
    top: `${$c3d132e84ce6bf43$var$unscheduledColumnStickyOffset}`
});
const $c3d132e84ce6bf43$var$columnHeaderWrapper = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface.sunken',
    borderTopLeftRadius: 'border.radius.100',
    borderTopRightRadius: 'border.radius.100',
    paddingBlock: 'space.050'
});
const $c3d132e84ce6bf43$var$storyPointCapacityAndIssueCountStyles = (0, $8CUq3.xcss)({
    paddingInline: 'space.200'
});
const $c3d132e84ce6bf43$var$issueCountStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    paddingTop: 'space.075',
    paddingBottom: 'space.075',
    height: `${"var(--ds-space-400, 32px)"}`,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
var $c3d132e84ce6bf43$export$2e2bcd8739ae039 = $c3d132e84ce6bf43$var$ProgramSwimlaneColumnHeader;

});
parcelRegister("jgcLy", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcd711f0ad554261$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bopR4 = parcelRequire("bopR4");

var $c8oLN = parcelRequire("c8oLN");
var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $kY99m = parcelRequire("kY99m");

var $3bDjY = parcelRequire("3bDjY");

var $5rFbt = parcelRequire("5rFbt");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $4jAPy = parcelRequire("4jAPy");

var $gZK1Z = parcelRequire("gZK1Z");

var $bdYfL = parcelRequire("bdYfL");

var $1FRDE = parcelRequire("1FRDE");
const $dcd711f0ad554261$var$IterationColumnHeader = ({ columnId: columnId, totalCapacity: totalCapacity, usedCapacity: usedCapacity, defaultCapacity: defaultCapacity, planningConfig: { planningUnit: planningUnit, workingHoursPerDay: workingHoursPerDay }, onChangeCapacity: onChangeCapacity, isReadOnly: isReadOnly, hideTotalCapacity: hideTotalCapacity, visibleIssues: visibleIssues, totalIssues: totalIssues })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isEditViewMode, setIsEditViewMode] = (0, $5uXOq.useState)(false);
    const total = (0, $bdYfL.convertCapacity)(totalCapacity ?? defaultCapacity, planningUnit, workingHoursPerDay);
    const unitLabel = (0, $bdYfL.getCapacityUnitMessage)(planningUnit, formatMessage, total);
    const showOverCapacityStyle = usedCapacity > total;
    const visibleIssuesMsg = (0, $5uXOq.useMemo)(()=>{
        if (visibleIssues !== totalIssues) return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1FRDE.default).visibleIssueCountIssueTermRefresh : (0, $1FRDE.default).visibleIssueCount, {
            visibleIssues: visibleIssues,
            totalIssues: totalIssues
        });
        return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1FRDE.default).totalIssueCountIssueTermRefresh : (0, $1FRDE.default).totalIssueCount, {
            totalIssues: totalIssues
        });
    }, [
        visibleIssues,
        totalIssues,
        formatMessage
    ]);
    let innerContent;
    let tooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "center",
        shouldWrap: true,
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, usedCapacity), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, "/"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, total), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, unitLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, "(", visibleIssuesMsg, ")"));
    const unitContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "inherit",
        testId: "portfolio-3-plan-increment-common.ui.iteration-column-header.capacity-unit"
    }, unitLabel));
    const usedCapacityContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $dcd711f0ad554261$var$capacityWrapperStyle,
            $dcd711f0ad554261$var$usedCapacityWrapperStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "inherit",
        testId: "portfolio-3-plan-increment-common.ui.iteration-column-header.allocated-capacity"
    }, usedCapacity));
    if (columnId === (0, $5rFbt.UNSCHEDULED_COLUMN_ID) || hideTotalCapacity) {
        tooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            alignInline: "center",
            shouldWrap: true,
            space: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, usedCapacity), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, unitLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, "(", visibleIssuesMsg, ")"));
        innerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            alignBlock: "center",
            xcss: $dcd711f0ad554261$var$capacityContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $dcd711f0ad554261$var$capacityWrapperStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            color: "inherit",
            testId: "portfolio-3-plan-increment-common.ui.iteration-column-header.allocated-capacity"
        }, usedCapacity)), unitContent);
    } else if (isReadOnly) innerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        xcss: showOverCapacityStyle ? [
            $dcd711f0ad554261$var$overCapacityStyles,
            $dcd711f0ad554261$var$capacityContainerStyles
        ] : $dcd711f0ad554261$var$capacityContainerStyles
    }, usedCapacityContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, "/"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $dcd711f0ad554261$var$capacityWrapperStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "inherit",
        testId: "portfolio-3-plan-increment-common.ui.iteration-column-header.total-capacity-read-only"
    }, total)), unitContent);
    else innerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        xcss: showOverCapacityStyle ? [
            $dcd711f0ad554261$var$overCapacityStyles,
            $dcd711f0ad554261$var$capacityContainerStyles
        ] : $dcd711f0ad554261$var$capacityContainerStyles
    }, usedCapacityContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, "/"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c8oLN.default), {
        xcss: $dcd711f0ad554261$var$inlineEditStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bopR4.default), {
        defaultValue: total,
        keepEditViewOpenOnBlur: true,
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ...fieldProps,
                testId: "portfolio-3-plan-increment-common.ui.iteration-column-header.total-capacity-edit",
                min: 0,
                max: 99999,
                width: "60",
                "aria-label": formatMessage((0, $gZK1Z.default).editCapacityLabel),
                isCompact: true,
                autoFocus: true,
                type: "number",
                ...planningUnit === (0, $4jAPy.IP_BOARD_DAYS_PLANNING_UNIT) && {
                    step: 0.1
                }
            }),
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: showOverCapacityStyle ? [
                    $dcd711f0ad554261$var$readViewContainerStyles,
                    $dcd711f0ad554261$var$overCapacityStyles,
                    $dcd711f0ad554261$var$capacityWrapperStyle
                ] : [
                    $dcd711f0ad554261$var$readViewContainerStyles,
                    $dcd711f0ad554261$var$capacityWrapperStyle
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                color: "inherit",
                testId: "portfolio-3-plan-increment-common.ui.iteration-column-header.total-capacity-read-only"
            }, total)),
        onEdit: ()=>{
            setIsEditViewMode(true);
        },
        onCancel: ()=>{
            setIsEditViewMode(false);
        },
        onConfirm: (value)=>{
            setIsEditViewMode(false);
            onChangeCapacity(value);
        },
        editButtonLabel: formatMessage((0, $gZK1Z.default).editCapacityLabel),
        confirmButtonLabel: formatMessage((0, $gZK1Z.default).confirmButtonLabel),
        cancelButtonLabel: formatMessage((0, $gZK1Z.default).cancelButtonLabel)
    })), unitContent));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: isEditViewMode ? null : tooltipContent,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.100",
        xcss: [
            $dcd711f0ad554261$var$columnHeaderWrapper,
            $dcd711f0ad554261$var$storyPointCapacityAndIssueCountStyles
        ]
    }, innerContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $dcd711f0ad554261$var$issueCountStyles
    }, "(", visibleIssuesMsg, ")")));
};
const $dcd711f0ad554261$var$columnHeaderWrapper = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface.sunken',
    borderTopLeftRadius: 'border.radius.100',
    borderTopRightRadius: 'border.radius.100',
    paddingBlock: 'space.050'
});
const $dcd711f0ad554261$var$storyPointCapacityAndIssueCountStyles = (0, $8CUq3.xcss)({
    paddingInline: 'space.200'
});
const $dcd711f0ad554261$var$capacityContainerStyles = (0, $8CUq3.xcss)({
    whiteSpace: 'nowrap',
    flexShrink: 0,
    maxWidth: '100%',
    display: 'flex',
    gap: 'space.050',
    lineHeight: '20px'
});
const $dcd711f0ad554261$var$readViewContainerStyles = (0, $8CUq3.xcss)({
    lineHeight: '20px'
});
const $dcd711f0ad554261$var$capacityWrapperStyle = (0, $8CUq3.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $dcd711f0ad554261$var$usedCapacityWrapperStyle = (0, $8CUq3.xcss)({
    border: `${"var(--ds-space-025, 2px)"} solid transparent`
});
const $dcd711f0ad554261$var$overCapacityStyles = (0, $8CUq3.xcss)({
    color: 'color.text.warning'
});
const $dcd711f0ad554261$var$inlineEditStyles = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.negative.100',
    flexShrink: 0
});
const $dcd711f0ad554261$var$issueCountStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    paddingTop: 'space.075',
    paddingBottom: 'space.075',
    height: "var(--ds-space-400, 32px)",
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
var $dcd711f0ad554261$export$2e2bcd8739ae039 = $dcd711f0ad554261$var$IterationColumnHeader;

});
parcelRegister("bopR4", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fb3572edb783a8f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6QvkM = parcelRequire("6QvkM");

var $7O4UO = parcelRequire("7O4UO");

var $efXp3 = parcelRequire("efXp3");

var $VSDnB = parcelRequire("VSDnB");

var $5ILhZ = parcelRequire("5ILhZ");

var $jldZL = parcelRequire("jldZL");

var $1PDuf = parcelRequire("1PDuf");

var $pZGLJ = parcelRequire("pZGLJ");

var $6LLMl = parcelRequire("6LLMl");
function $9fb3572edb783a8f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9fb3572edb783a8f$var$fieldStyles = {
    name: "nziz0a",
    styles: "max-width:100%;position:relative"
};
const $9fb3572edb783a8f$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $9fb3572edb783a8f$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $5uXOq.useState)(startWithEditViewOpen);
    const timerRef = (0, $5uXOq.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $pZGLJ.default)(isEditing, isEditingState);
    const onCancel = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$9fb3572edb783a8f$var$analyticsAttributes
    });
    const onCancelClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]);
    /**
   * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
   *  confirms the value, if the focus is not transferred to the action buttons.
   *
   *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
   *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
   *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
   *  `autoSubmitWhenBlur`.
   *
   *  There are two paths here the function can be triggered:
   *
   *  - focus on input first, and then use keyboard to `submit`
   *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
   */ const onEditViewWrapperBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]);
    /**
   * Gets called when focus is transferred to the editView, or action buttons.
   *
   * There are three paths here the function can be called:
   *
   * - when a user click the `editView`
   * - when a user use keyboard to tab into `editView`
   * - when a user use keyboard to tab into `submit` when they were on input field.
   */ const onEditViewWrapperFocus = (0, $5uXOq.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6LLMl.default), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $efXp3.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit)
    }, ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("form", {
            /**
     * It is not normally acceptable to add key handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * to add support for keyboard functionality instead of creating an inaccessible
     * custom element, we can add role="presentation" so that there is no negative
     * impacts to assistive technologies.
     */ role: "presentation",
            onKeyDown: (e)=>{
                onKeyDown(e);
                if (e.key === 'Esc' || e.key === 'Escape') {
                    if ((0, $VSDnB.fg)('platform-design-system-inline-edit-reset-on-escape')) reset();
                    onCancel();
                }
            },
            onSubmit: onSubmit,
            ref: formRef
        }, shouldBeEditing ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7O4UO.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: defaultValue,
            validate: validate,
            isRequired: isRequired,
            key: "edit-view" // used for reset to default value
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                css: $9fb3572edb783a8f$var$fieldStyles,
                onBlur: (e)=>{
                    if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                },
                onFocus: onEditViewWrapperFocus
            }, editView({
                ...fieldProps,
                errorMessage: error
            }, editViewRef), !hideActionButtons ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1PDuf.default), {
                testId: testId,
                cancelButtonLabel: cancelButtonLabel,
                confirmButtonLabel: confirmButtonLabel,
                onMouseDown: ()=>{
                    /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                },
                onCancelClick: (e)=>{
                    reset();
                    onCancelClick(e);
                }
            }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5ILhZ.default), {
                hidden: true,
                type: "submit"
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jldZL.default), null, "Submit")))) : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7O4UO.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: "",
            isRequired: isRequired,
            key: "read-view" // used for reset to default value
        }, renderReadView)));
};
const $9fb3572edb783a8f$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($9fb3572edb783a8f$var$InnerInlineEdit, props);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9fb3572edb783a8f$export$2e2bcd8739ae039 = $9fb3572edb783a8f$var$InlineEdit;

});
parcelRegister("7O4UO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e20204ce79b642c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
parcelRequire("3joPi");

var $9KnKW = parcelRequire("9KnKW");

var $dRN65 = parcelRequire("dRN65");

var $efXp3 = parcelRequire("efXp3");

var $2x3Cb = parcelRequire("2x3Cb");

var $kxqHl = parcelRequire("kxqHl");

var $6cAn5 = parcelRequire("6cAn5");
function $7e20204ce79b642c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7e20204ce79b642c$var$fieldWrapperStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
function $7e20204ce79b642c$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $7e20204ce79b642c$var$isFunction(x) {
    return typeof x === 'function';
}
function $7e20204ce79b642c$var$usePreviousRef(current) {
    const ref = (0, $5uXOq.useRef)(current);
    // will be updated on the next render
    (0, $5uXOq.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $7e20204ce79b642c$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $7e20204ce79b642c$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, $efXp3.FormContext));
    const isDisabled = (0, $5uXOq.useContext)((0, $efXp3.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $7e20204ce79b642c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $7e20204ce79b642c$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$7e20204ce79b642c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $5uXOq.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $7e20204ce79b642c$var$usePreviousRef(state);
    (0, $5uXOq.useEffect)(()=>{
        typeof $6cAn5;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $7e20204ce79b642c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($7e20204ce79b642c$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const uid = (0, $9KnKW.useId)();
    const fieldId = (0, $5uXOq.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $7e20204ce79b642c$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2x3Cb.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kxqHl.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dRN65.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("dRN65", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $706cd4dbd4574fd7$export$3c4232819458a302);

var $5uXOq = parcelRequire("5uXOq");
const $706cd4dbd4574fd7$export$3c4232819458a302 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});

parcelRegister("efXp3", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $987e2ff089e89967$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $987e2ff089e89967$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $987e2ff089e89967$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lqWDn = parcelRequire("lqWDn");

var $8tHJX = parcelRequire("8tHJX");

var $gZL7V = parcelRequire("gZL7V");
const $987e2ff089e89967$export$c24727297075ec6a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $987e2ff089e89967$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
function $987e2ff089e89967$export$2e2bcd8739ae039(props) {
    const formRef = (0, $5uXOq.useRef)(null);
    const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $5uXOq.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $lqWDn.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $5uXOq.useState)({
        dirty: false,
        submitting: false
    });
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $5uXOq.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("lqWDn", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $f9a9822f8af64e2a$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $f9a9822f8af64e2a$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $f9a9822f8af64e2a$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $f9a9822f8af64e2a$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $f9a9822f8af64e2a$export$f681a8129d2e9d28);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");
//      
var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
var $f9a9822f8af64e2a$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
    string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f9a9822f8af64e2a$var$keysCache = {};
var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
    }
    return $f9a9822f8af64e2a$var$keysCache[key];
};
//      
var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f9a9822f8af64e2a$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
    var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $ddEsc.default)(current, [
                key
            ].map($f9a9822f8af64e2a$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
};
var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
    var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f9a9822f8af64e2a$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                    shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values)); // clone to avoid writing
            if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                    var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $bS32t.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $bS32t.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("8tHJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c2f612c5adb35a$export$2e2bcd8739ae039);

var $lqWDn = parcelRequire("lqWDn");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lqWDn.getIn)(errors, input.name);
    });
};
//      
var $62c2f612c5adb35a$var$noop = function noop() {};
var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;

});


parcelRegister("2x3Cb", function(module, exports) {

$parcel$export(module.exports, "Label", () => $987b76a5b7a0ea9b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $987b76a5b7a0ea9b$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $987b76a5b7a0ea9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = {
    name: "zjewl9",
    styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("label", {
        css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles,
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("legend", {
        css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles
    }, children);
};
var $987b76a5b7a0ea9b$export$2e2bcd8739ae039 = $987b76a5b7a0ea9b$export$b04be29aa201d4f5;

});

parcelRegister("kxqHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d55ac25356e81a33$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

const $d55ac25356e81a33$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d55ac25356e81a33$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $d55ac25356e81a33$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("1PDuf", function(module, exports) {

$parcel$export(module.exports, "default", () => $55d92d54fb10d87e$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
                                                                                                                                      * @jsxRuntime classic
                                                                                                                                      * @jsx jsx
                                                                                                                                      */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $42CjB = parcelRequire("42CjB");

var $kbxJz = parcelRequire("kbxJz");

var $lLLkM = parcelRequire("lLLkM");

function $55d92d54fb10d87e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $55d92d54fb10d87e$var$buttonsContainerStyles = {
    name: "ki22df",
    styles: "display:flex;position:absolute;flex-shrink:0;inset-block-start:100%;inset-inline-end:0;margin-block-start:var(--ds-space-075, 6px)"
};
const $55d92d54fb10d87e$var$buttonWrapperBaseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxSizing: 'border-box',
    width: "var(--ds-space-400, 32px)",
    zIndex: 200,
    backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:last-child': {
        marginInlineStart: "var(--ds-space-050, 4px)"
    },
    '& > button': {
        backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`
    },
    '& > button:hover': {
        backgroundColor: `var(--ds-surface-overlay-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`
    },
    '& > button:active': {
        backgroundColor: "var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6))",
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
    }
});
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Buttons__
 *
 * A buttons {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $55d92d54fb10d87e$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $55d92d54fb10d87e$var$buttonsContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $55d92d54fb10d87e$var$buttonWrapperBaseStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $42CjB.default), {
        type: "submit",
        icon: (iconProps)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kbxJz))), {
                ...iconProps,
                size: "small"
            }),
        onMouseDown: onMouseDown,
        label: confirmButtonLabel,
        testId: testId && `${testId}--confirm`
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $55d92d54fb10d87e$var$buttonWrapperBaseStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $42CjB.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lLLkM))), {
                ...iconProps,
                size: "small"
            }),
        label: cancelButtonLabel,
        onClick: onCancelClick,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}--cancel`
    })));
};
var $55d92d54fb10d87e$export$2e2bcd8739ae039 = $55d92d54fb10d87e$var$Buttons;

});

parcelRegister("pZGLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5aa752dd00081f6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $d5aa752dd00081f6$var$usePrevious = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $d5aa752dd00081f6$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $5uXOq.useRef)(null);
    const editViewRef = (0, $5uXOq.useRef)();
    const preventFocusOnEditButtonRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $d5aa752dd00081f6$var$usePrevious(shouldBeEditing);
    (0, $5uXOq.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $d5aa752dd00081f6$export$2e2bcd8739ae039 = $d5aa752dd00081f6$var$useButtonFocusHook;

});

parcelRegister("6LLMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ba9adf9a6463766$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

function $1ba9adf9a6463766$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1ba9adf9a6463766$var$readViewContainerStyles = {
    name: "1xe63ku",
    styles: "line-height:1"
};
const $1ba9adf9a6463766$var$editButtonStyles = (0, $8CUq3.xcss)({
    display: 'block',
    margin: 'space.0',
    padding: 'space.0',
    appearance: 'none',
    background: 'transparent',
    border: 0,
    lineHeight: 1,
    outline: 0,
    ':focus-visible': {
        outline: 0
    },
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ':focus + div': {
        borderColor: 'color.border.focused',
        borderWidth: 'border.width.outline',
        borderStyle: 'solid'
    }
});
const $1ba9adf9a6463766$var$readViewWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    border: '2px solid transparent',
    borderRadius: "var(--ds-border-radius, 3px)",
    transition: 'background 0.2s',
    '&:hover': {
        background: `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
    }
});
const $1ba9adf9a6463766$var$readViewFitContainerWidthStyles = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $1ba9adf9a6463766$var$DRAG_THRESHOLD = 5;
const $1ba9adf9a6463766$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $5uXOq.useRef)(0);
    const startY = (0, $5uXOq.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $1ba9adf9a6463766$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $1ba9adf9a6463766$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /**
     * If a link is clicked in the read view, default action should be taken
     */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $1ba9adf9a6463766$var$readViewContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5ILhZ.default), {
        xcss: $1ba9adf9a6463766$var$editButtonStyles,
        onClick: onEditRequested,
        ref: editButtonRef,
        testId: testId && `${testId}--edit-button`,
        "aria-label": editButtonLabel
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $1ba9adf9a6463766$var$readViewWrapperStyles,
            readViewFitContainerWidth && $1ba9adf9a6463766$var$readViewFitContainerWidthStyles
        ],
        /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
        onClick: onReadViewClick,
        onMouseDown: (e)=>{
            startX.current = e.clientX;
            startY.current = e.clientY;
        },
        "data-read-view-fit-container-width": readViewFitContainerWidth
    }, readView()));
};
var $1ba9adf9a6463766$export$2e2bcd8739ae039 = $1ba9adf9a6463766$var$ReadView;

});


parcelRegister("1FRDE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dc1d1a18332e8bc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4dc1d1a18332e8bc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    visibleIssueCount: {
        "id": "portfolio-3-plan-increment-common.ui.iteration-column-header.visible-issue-count",
        "defaultMessage": "{visibleIssues} / {totalIssues} {totalIssues, plural, one {issue} other {issues}}"
    },
    totalIssueCount: {
        "id": "portfolio-3-plan-increment-common.ui.iteration-column-header.total-issue-count",
        "defaultMessage": "{totalIssues} {totalIssues, plural, one {issue} other {issues}}"
    },
    visibleIssueCountIssueTermRefresh: {
        "id": "portfolio-3-plan-increment-common.ui.iteration-column-header.visible-issue-count-issue-term-refresh",
        "defaultMessage": "{visibleIssues} / {totalIssues} {totalIssues, plural, one {issue} other {issues}}"
    },
    totalIssueCountIssueTermRefresh: {
        "id": "portfolio-3-plan-increment-common.ui.iteration-column-header.total-issue-count-issue-term-refresh",
        "defaultMessage": "{totalIssues} {totalIssues, plural, one {issue} other {issues}}"
    }
});

});


parcelRegister("iTu9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $48abf14083456c29$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6icp6 = parcelRequire("6icp6");

var $hGgHi = parcelRequire("hGgHi");

var $2NMNM = parcelRequire("2NMNM");

var $fVnbM = parcelRequire("fVnbM");

var $gtreQ = parcelRequire("gtreQ");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");


var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $3spCR = parcelRequire("3spCR");

var $bdYfL = parcelRequire("bdYfL");

var $a5i1n = parcelRequire("a5i1n");

var $5jKdL = parcelRequire("5jKdL");

var $73G9T = parcelRequire("73G9T");
const $48abf14083456c29$var$getSprintStyles = (state, isOverloaded)=>{
    if (isOverloaded) return (0, $8CUq3.xcss)({
        backgroundColor: 'color.background.danger',
        color: 'color.text.danger',
        ':hover': {
            backgroundColor: 'color.background.danger.hovered'
        }
    });
    switch(state){
        case (0, $3spCR.SPRINT_STATES).CLOSED:
            return (0, $8CUq3.xcss)({
                backgroundColor: 'color.background.neutral',
                color: 'color.text.disabled',
                ':hover': {
                    backgroundColor: 'color.background.neutral.hovered'
                }
            });
        case (0, $3spCR.SPRINT_STATES).ACTIVE:
            return (0, $8CUq3.xcss)({
                backgroundColor: 'color.background.selected',
                color: 'color.text.brand',
                ':hover': {
                    backgroundColor: 'color.background.selected.hovered'
                }
            });
        case (0, $3spCR.SPRINT_STATES).FUTURE:
        default:
            return (0, $8CUq3.xcss)({
                backgroundColor: 'color.background.accent.gray.subtler',
                color: 'color.text.subtle',
                ':hover': {
                    backgroundColor: 'color.background.neutral.pressed'
                }
            });
    }
};
const $48abf14083456c29$var$CapacityBar = ({ totalCapacity: totalCapacity, usedCapacity: usedCapacity })=>{
    const isOverloadedBar = usedCapacity > totalCapacity;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_4t3iv47k _1bsb14y2 _2rko1l7b _bfhkvuon _1e0c1txw _4cvresu3 _2hwx12x7"
        ])
    }, isOverloadedBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_2rko14y2 _1bsb1osq _11q7doe3 _4t3i1osq"
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // eslint-disable-next-line jira/react/no-style-attribute
    , {
        style: {
            height: `${totalCapacity === 0 ? 100 : usedCapacity / totalCapacity * 100}%`
        },
        className: (0, $bwpsq.default)([
            "_2rko14y2 _1bsb1osq _11q7g4a2"
        ])
    }));
};
const $48abf14083456c29$var$OverlappedDatesWarningIcon = ({ sprint: sprint, overlappedSprints: overlappedSprints })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const warningIconTooltip = (()=>{
        let content;
        if (overlappedSprints.length === 1) content = formatMessage((0, $5jKdL.default).warningForSprintDatesOverlappedWithOneSprint, {
            sprintName: sprint.name,
            anotherSprintName: overlappedSprints[0].sprintName,
            days: (0, (/*@__PURE__*/$parcel$interopDefault($6icp6)))(overlappedSprints[0].time / 86400000, 1)
        });
        else content = formatMessage((0, $5jKdL.default).warningForSprintDatesOverlappedWithMoreThanOneSprint, {
            sprintName: sprint.name,
            otherSprints: overlappedSprints.slice(0, overlappedSprints.length - 1).map((s)=>s.sprintName).join(', '),
            lastSprint: overlappedSprints[overlappedSprints.length - 1].sprintName
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $48abf14083456c29$var$WarningTooltip,
            backgroundColor: "color.background.neutral.bold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "strong",
            size: "UNSAFE_small"
        }, formatMessage((0, $5jKdL.default).overlappingDatesWarningTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $48abf14083456c29$var$tooltipParagraphStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p",
            size: "UNSAFE_small"
        }, content)));
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    ), {
        xcss: (0, $8CUq3.xcss)({
            marginTop: 'space.025'
        }),
        testId: "portfolio-3-plan-increment-common.ui.sprint-column-header.overlapping-warning-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: warningIconTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gtreQ))), {
        primaryColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`,
        label: formatMessage((0, $5jKdL.default).overlappingDatesWarningLabel)
    })));
};
const $48abf14083456c29$var$SprintColumnHeader = ({ sprint: sprint, usedCapacity: usedCapacity, doneCapacity: doneCapacity, totalCapacity: totalCapacity, defaultCapacity: defaultCapacity, planningConfig: planningConfig, overlappedSprints: overlappedSprints, columnDateRange: columnDateRange, onChangeCapacity: onChangeCapacity, isReadOnly: isReadOnly })=>{
    const { planningUnit: planningUnit, workingHoursPerDay: workingHoursPerDay } = planningConfig;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formatDateRange = (0, $a5i1n.useFormatDateRange)();
    const [flyoutOpen, setFlyoutOpen] = (0, $5uXOq.useState)(false);
    const capacity = (0, $bdYfL.convertCapacity)(totalCapacity ?? defaultCapacity, planningUnit, workingHoursPerDay);
    const getSprintStateLabel = (state)=>{
        switch(state){
            case (0, $3spCR.SPRINT_STATES).CLOSED:
                return formatMessage((0, $5jKdL.default).completedSprint);
            case (0, $3spCR.SPRINT_STATES).ACTIVE:
                return formatMessage((0, $5jKdL.default).activeSprint);
            case (0, $3spCR.SPRINT_STATES).FUTURE:
            default:
                return formatMessage((0, $5jKdL.default).futureSprint);
        }
    };
    const endDate = sprint.completedDate ? sprint.completedDate : sprint.endDate;
    const dateRange = sprint.startDate && endDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatDateRange(sprint.startDate, endDate), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null)) : null;
    const capacityAllocatedLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $5jKdL.default).capacityAllocatedLabel, {
        usedCapacity: usedCapacity,
        totalCapacity: capacity,
        unit: (0, $bdYfL.getCapacityUnitMessage)(planningUnit, formatMessage, capacity)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), getSprintStateLabel(sprint.state));
    const tooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $48abf14083456c29$var$tooltipStyles,
        backgroundColor: "color.background.neutral.bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "strong",
        size: "UNSAFE_small"
    }, sprint.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p",
        size: "UNSAFE_small"
    }, dateRange), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $48abf14083456c29$var$tooltipParagraphStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p",
        size: "UNSAFE_small",
        testId: "portfolio-3-plan-increment-common.ui.sprint-column-header.allocated"
    }, capacityAllocatedLabel)));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: flyoutOpen,
        onClose: ()=>setFlyoutOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $73G9T.default), {
                onFlyoutClose: ()=>setFlyoutOpen(false),
                usedCapacity: usedCapacity,
                totalCapacity: totalCapacity,
                doneCapacity: doneCapacity,
                defaultCapacity: defaultCapacity,
                sprint: sprint,
                planningConfig: planningConfig,
                iterationEndDate: columnDateRange?.end,
                iterationStartDate: columnDateRange?.start,
                onChangeCapacity: onChangeCapacity,
                isReadOnly: isReadOnly
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                onClick: ()=>{
                    setFlyoutOpen(true);
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                        action: 'opened',
                        actionSubject: 'sprintFlyout'
                    }));
                },
                appearance: "subtle",
                spacing: "none",
                shouldFitContainer: true,
                testId: "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-column-header",
                ...triggerProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: [
                    $48abf14083456c29$var$columnHeaderWrapper,
                    $48abf14083456c29$var$sprintWrapperStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: tooltipContent,
                hideTooltipOnClick: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                alignBlock: "center" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                ,
                xcss: [
                    $48abf14083456c29$var$sprintBaseStyles,
                    $48abf14083456c29$var$getSprintStyles(sprint.state, usedCapacity > capacity)
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($48abf14083456c29$var$CapacityBar, {
                usedCapacity: usedCapacity,
                totalCapacity: capacity
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, $bwpsq.default)([
                    "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1o9zkb7n _i0dlf1ug _y3gn1e5h"
                ])
            }, sprint.name), !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(overlappedSprints) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($48abf14083456c29$var$OverlappedDatesWarningIcon, {
                sprint: sprint,
                overlappedSprints: overlappedSprints
            })))))
    });
};
const $48abf14083456c29$var$tooltipStyles = (0, $8CUq3.xcss)({
    textAlign: 'center'
});
const $48abf14083456c29$var$tooltipParagraphStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.150'
});
const $48abf14083456c29$var$sprintWrapperStyles = (0, $8CUq3.xcss)({
    padding: 'space.050'
});
const $48abf14083456c29$var$columnHeaderWrapper = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface.sunken',
    borderTopLeftRadius: 'border.radius.100',
    borderTopRightRadius: 'border.radius.100',
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $48abf14083456c29$var$sprintBaseStyles = (0, $8CUq3.xcss)({
    fontWeight: '500',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100',
    padding: 'space.075',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $48abf14083456c29$var$barWrapperStyle = null;
const $48abf14083456c29$var$usedCapacityStyle = null;
const $48abf14083456c29$var$overloadedCapacityStyle = null;
const $48abf14083456c29$var$sprintNameWrapperStyle = null;
const $48abf14083456c29$var$WarningTooltip = (0, $8CUq3.xcss)({
    padding: 'space.050'
});
var $48abf14083456c29$export$2e2bcd8739ae039 = $48abf14083456c29$var$SprintColumnHeader;

});
parcelRegister("a5i1n", function(module, exports) {

$parcel$export(module.exports, "useFormatDateUTC", () => $a4313f0c7db8b7e2$export$827a028fe155a73d);
$parcel$export(module.exports, "useFormatDateRange", () => $a4313f0c7db8b7e2$export$5db7b709812b7bc8);

var $5uXOq = parcelRequire("5uXOq");

var $1p96B = parcelRequire("1p96B");

var $aipk9 = parcelRequire("aipk9");

var $DVljb = parcelRequire("DVljb");
const $a4313f0c7db8b7e2$export$827a028fe155a73d = (intl, showYear = false, showTime = false, showTimeZoneName = false)=>(0, $5uXOq.useCallback)((date)=>{
        const dateTimeFormatOptions = {
            day: '2-digit',
            month: 'short',
            timeZone: 'UTC',
            ...showYear && {
                year: 'numeric'
            },
            ...showTime && {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
            },
            ...showTimeZoneName && {
                timeZoneName: 'short'
            }
        };
        return (0, $aipk9.formatTimestampWithIntl)(intl, date, dateTimeFormatOptions);
    }, [
        intl,
        showYear,
        showTime,
        showTimeZoneName
    ]);
const $a4313f0c7db8b7e2$export$fc5db2b57ab9d291 = ()=>{
    const locale = (0, $DVljb.useLocale)();
    return (0, $5uXOq.useCallback)((date, showYear = false)=>showYear ? (0, $1p96B.formatWithLocale)(date, 'd MMM yyyy', locale) : (0, $1p96B.formatWithLocale)(date, 'd MMM', locale), [
        locale
    ]);
};
const $a4313f0c7db8b7e2$export$5db7b709812b7bc8 = ()=>{
    const formatDate = $a4313f0c7db8b7e2$export$fc5db2b57ab9d291();
    return (0, $5uXOq.useCallback)((startDate, endDate)=>{
        const isDifferentYear = new Date(startDate).getUTCFullYear() !== new Date(endDate).getUTCFullYear();
        return `${formatDate(startDate, isDifferentYear)} \u{2013} ${formatDate(endDate, isDifferentYear)}`;
    }, [
        formatDate
    ]);
};

});
parcelRegister("aipk9", function(module, exports) {

$parcel$export(module.exports, "getDayLabel", () => $da1491eee903a2d8$export$77c6667acb2335c);
$parcel$export(module.exports, "getMonthLabel", () => $da1491eee903a2d8$export$5492c4ce9d26d774);
$parcel$export(module.exports, "formatDateUTC", () => $da1491eee903a2d8$export$f6ec9a122d9a3697);
$parcel$export(module.exports, "formatTimestampWithIntl", () => $da1491eee903a2d8$export$a70c08d756ec4ebf);
$parcel$export(module.exports, "formatDateWithIntl", () => $da1491eee903a2d8$export$41d39199b76e5fba);
$parcel$export(module.exports, "useDateFormatter", () => $da1491eee903a2d8$export$85fd5fdf27bacc79);

var $5uXOq = parcelRequire("5uXOq");

var $jovBr = parcelRequire("jovBr");

var $koVbs = parcelRequire("koVbs");

var $gh61P = parcelRequire("gh61P");
const $da1491eee903a2d8$export$32db56fbc0b29120 = (day)=>{
    switch(day){
        case 0:
            return 'Sunday';
        case 1:
            return 'Monday';
        case 2:
            return 'Tuesday';
        case 3:
            return 'Wednesday';
        case 4:
            return 'Thursday';
        case 5:
            return 'Friday';
        default:
            return 'Saturday';
    }
};
const $da1491eee903a2d8$export$e5b0222dbac9656 = (month)=>{
    switch(month){
        case 0:
            return 'January';
        case 1:
            return 'February';
        case 2:
            return 'March';
        case 3:
            return 'April';
        case 4:
            return 'May';
        case 5:
            return 'June';
        case 6:
            return 'July';
        case 7:
            return 'August';
        case 8:
            return 'September';
        case 9:
            return 'October';
        case 10:
            return 'November';
        default:
            return 'December';
    }
};
const $da1491eee903a2d8$export$77c6667acb2335c = (day)=>$da1491eee903a2d8$export$32db56fbc0b29120(day).substr(0, 3);
const $da1491eee903a2d8$export$5492c4ce9d26d774 = (month)=>$da1491eee903a2d8$export$e5b0222dbac9656(month).substr(0, 3);
const $da1491eee903a2d8$export$b27aef2de915d062 = (format)=>{
    let stringFormat = format;
    let match;
    let parts = [];
    const DATE_FORMATS_SPLIT = /((?:[^YMDHhmsaAZzE']+)|(?:'(?:[^']|'')*')|(?:E+|Y+|M+|D+|H+|h+|m+|s+|a|A|Z|z))(.*)/;
    const slice = [].slice;
    const concatMethod = (array1, array2, index)=>array1.concat(slice.call(array2, index));
    while(stringFormat){
        match = DATE_FORMATS_SPLIT.exec(stringFormat);
        if (match) {
            parts = concatMethod(parts, match, 1);
            stringFormat = parts.pop();
        } else {
            parts.push(format);
            stringFormat = null;
        }
    }
    return parts;
};
const $da1491eee903a2d8$export$f6ec9a122d9a3697 = (time, format)=>{
    const date = new Date(time);
    if (!(0, $jovBr.default)(date)) throw new Error('Date passed to formatDateUTC function is not valid');
    // get individual values
    const dayOfWeekIndex = date.getUTCDay();
    const month = date.getUTCMonth();
    const fullYear = date.getUTCFullYear().toString();
    const fullMonth = $da1491eee903a2d8$export$e5b0222dbac9656(month);
    const shortMonth = $da1491eee903a2d8$export$5492c4ce9d26d774(month);
    const digitMonth = month + 1;
    const hour = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();
    const formatArray = $da1491eee903a2d8$export$b27aef2de915d062(format);
    // TODO: getFormatVal is hardcoded to date-fns v.1.x.x format should be reimplemented by owners team
    // pick individual parts of the date format
    const getFormatVal = (part)=>{
        let val;
        switch(part){
            case 'YYYY':
                // 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
                val = fullYear.padStart(4, '0');
                break;
            case 'YY':
                // 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01)
                val = fullYear.padStart(4, '0').substr(-2);
                break;
            case 'MMMM':
                // Month in year (January-December)
                val = fullMonth;
                break;
            case 'MMM':
                // Month in year (Jan-Dec)
                val = shortMonth;
                break;
            case 'MM':
                // Month in year (01-12)
                val = digitMonth.toString().padStart(2, '0');
                break;
            case 'M':
                // Month in year (1-12)
                val = digitMonth;
                break;
            case 'EEEE':
                // Day in Week,(Sunday-Saturday)
                val = $da1491eee903a2d8$export$32db56fbc0b29120(dayOfWeekIndex);
                break;
            case 'EEE':
                // Day in Week, (Sun-Sat)
                val = $da1491eee903a2d8$export$77c6667acb2335c(dayOfWeekIndex);
                break;
            case 'DD':
                // Day in month (01-31)
                val = date.getUTCDate().toString().padStart(2, '0');
                break;
            case 'D':
                // Day in month (1-31)
                val = date.getUTCDate();
                break;
            case 'hh':
                // Hour in AM/PM (01-12)
                val = 12;
                if (hour !== 0) {
                    const diff = hour - 12;
                    val = diff > 0 ? diff.toString().padStart(2, '0') : hour.toString().padStart(2, '0');
                }
                break;
            case 'h':
                // Hour in AM/PM, (1-12)
                val = 12;
                if (hour !== 0) val = hour > 12 ? hour - 12 : hour;
                break;
            case 'HH':
                // Hour in day (00-23)
                val = hour.toString().padStart(2, '0');
                break;
            case 'H':
                // Hour in day (0-23)
                val = hour;
                break;
            case 'mm':
                // Minute in hour (00-59)
                val = minutes.toString().padStart(2, '0');
                break;
            case 'm':
                // Minute in hour (0-59)
                val = minutes;
                break;
            case 'ss':
                // Seconds in minute (00-59)
                val = seconds.toString().padStart(2, '0');
                break;
            case 's':
                // Seconds in minute (0-59)
                val = seconds;
                break;
            case 'a':
                val = hour >= 12 ? 'pm' : 'am';
                break;
            case 'A':
                val = hour >= 12 ? 'PM' : 'AM';
                break;
            default:
                val = part;
        }
        val = typeof val !== 'undefined' ? val.toString() : part;
        return val;
    };
    let dateVal = '';
    formatArray.forEach((part)=>{
        dateVal += getFormatVal(part);
    });
    return dateVal;
};
const $da1491eee903a2d8$export$a70c08d756ec4ebf = (intl, timestamp, // eslint-disable-next-line @typescript-eslint/no-explicit-any
formatOptions = (0, $gh61P.longDateFormat))=>intl.formatDate(timestamp, formatOptions);
const $da1491eee903a2d8$export$41d39199b76e5fba = (intl, iso, // eslint-disable-next-line @typescript-eslint/no-explicit-any
formatOptions = (0, $gh61P.longDateFormat))=>{
    const date = new Date(iso);
    return intl.formatDate(date.getTime(), formatOptions);
};
const $da1491eee903a2d8$export$85fd5fdf27bacc79 = ()=>{
    const intl = (0, $koVbs.default)();
    const formatTimestamp = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (timestamp, formatOptions)=>$da1491eee903a2d8$export$a70c08d756ec4ebf(intl, timestamp, formatOptions), [
        intl
    ]);
    const formatDate = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (iso, formatOptions)=>{
        const date = new Date(iso);
        return $da1491eee903a2d8$export$a70c08d756ec4ebf(intl, date.getTime(), formatOptions);
    }, [
        intl
    ]);
    return {
        formatTimestamp: formatTimestamp,
        formatDate: formatDate
    };
};

});
parcelRegister("gh61P", function(module, exports) {

$parcel$export(module.exports, "longDateFormat", () => $874bf1b243ba3957$export$7bc415832e79e22c);
$parcel$export(module.exports, "dateMonthFormat", () => $874bf1b243ba3957$export$f9c3f52e4a5f8635);
$parcel$export(module.exports, "longDateTimeFormat", () => $874bf1b243ba3957$export$f2f390060309965);
$parcel$export(module.exports, "shortDateFormat", () => $874bf1b243ba3957$export$1a445e44d9863af);
$parcel$export(module.exports, "weekdayFormat", () => $874bf1b243ba3957$export$faf60e60fca9bed1);
$parcel$export(module.exports, "weekdayFormatLong", () => $874bf1b243ba3957$export$a28e4d9035dd351c);
$parcel$export(module.exports, "DateUnits", () => $874bf1b243ba3957$export$c7e7da0fa6bb60a7);
$parcel$export(module.exports, "DATE_UNIT_MAX_VALUES", () => $874bf1b243ba3957$export$637d8b0948b783c7);
$parcel$export(module.exports, "CUSTOM_TIME_RANGE_TYPES", () => $874bf1b243ba3957$export$78e07fecfaf51c7b);
$parcel$export(module.exports, "DefaultDateFormat", () => $874bf1b243ba3957$export$14ae725d0cc7daa1);
$parcel$export(module.exports, "IsoDateFormat", () => $874bf1b243ba3957$export$7288711b5316ff78);
$parcel$export(module.exports, "DEFAULT_WEEK_START_DAY", () => $874bf1b243ba3957$export$845e1054649a85c2);
/**
 * UTC Long format of a date, eg "13 Jul 2023"
 */ const $874bf1b243ba3957$export$7bc415832e79e22c = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
};
const $874bf1b243ba3957$export$f9c3f52e4a5f8635 = {
    day: '2-digit',
    month: 'short',
    timeZone: 'UTC'
};
const $874bf1b243ba3957$export$352fb2bc78f82ff2 = {
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
};
const $874bf1b243ba3957$export$f2f390060309965 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone: 'UTC'
};
const $874bf1b243ba3957$export$1a445e44d9863af = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC'
};
const $874bf1b243ba3957$export$faf60e60fca9bed1 = {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
};
const $874bf1b243ba3957$export$a28e4d9035dd351c = {
    weekday: 'long',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC'
};
const $874bf1b243ba3957$export$c7e7da0fa6bb60a7 = {
    DAYS: 'days',
    MONTHS: 'months',
    WEEKS: 'weeks'
};
const $874bf1b243ba3957$export$637d8b0948b783c7 = {
    [$874bf1b243ba3957$export$c7e7da0fa6bb60a7.DAYS]: 3650,
    [$874bf1b243ba3957$export$c7e7da0fa6bb60a7.WEEKS]: 520,
    [$874bf1b243ba3957$export$c7e7da0fa6bb60a7.MONTHS]: 120
};
const $874bf1b243ba3957$export$78e07fecfaf51c7b = {
    FIXED: 'fixed',
    RELATIVE: 'relative'
};
const $874bf1b243ba3957$export$14ae725d0cc7daa1 = 'DD/MMM/YY';
const $874bf1b243ba3957$export$7288711b5316ff78 = 'YYYY-MM-DD';
const $874bf1b243ba3957$export$845e1054649a85c2 = 0; // Sunday

});



parcelRegister("5jKdL", function(module, exports) {

$parcel$export(module.exports, "default", () => $087cc8d537ef798f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $087cc8d537ef798f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    visibleIssueCount: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.visible-issue-count",
        "defaultMessage": "{count} / {total} {total, plural, one {issue} other {issues}}"
    },
    totalIssueCount: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.total-issue-count",
        "defaultMessage": "{total} {total, plural, one {issue} other {issues}}"
    },
    completedSprint: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.completed-sprint",
        "defaultMessage": "Completed sprint"
    },
    activeSprint: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.active-sprint",
        "defaultMessage": "Active sprint"
    },
    futureSprint: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.future-sprint",
        "defaultMessage": "Future sprint"
    },
    overlappingDatesWarningTitle: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.overlapping-dates-warning-title",
        "defaultMessage": "Overlapping sprint dates"
    },
    overlappingDatesWarningLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.overlapping-dates-warning-label",
        "defaultMessage": "Warning icon for the overlapping sprint dates"
    },
    warningForSprintDatesOverlappedWithOneSprint: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.warning-for-sprint-dates-overlapped-with-one-sprint",
        "defaultMessage": "{sprintName} overlaps with {anotherSprintName} by about {days} {days, plural, one {day} other {days}}"
    },
    warningForSprintDatesOverlappedWithMoreThanOneSprint: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.warning-for-sprint-dates-overlapped-with-more-than-one-sprint",
        "defaultMessage": "{sprintName} overlaps with {otherSprints} and {lastSprint}"
    },
    capacityAllocatedLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.capacity-allocated-label",
        "defaultMessage": "{usedCapacity}/{totalCapacity} {unit} allocated"
    },
    visibleIssueCountIssueTermRefresh: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.visible-issue-count-issue-term-refresh",
        "defaultMessage": "{count} / {total} {total, plural, one {issue} other {issues}}"
    },
    totalIssueCountIssueTermRefresh: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.total-issue-count-issue-term-refresh",
        "defaultMessage": "{total} {total, plural, one {issue} other {issues}}"
    }
});

});

parcelRegister("73G9T", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cc5b1f0251868be$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $42CjB = parcelRequire("42CjB");

var $1dJ6S = parcelRequire("1dJ6S");

var $2C7j9 = parcelRequire("2C7j9");

var $kkuz9 = parcelRequire("kkuz9");

var $KdRgS = parcelRequire("KdRgS");

var $iyo13 = parcelRequire("iyo13");

var $bopR4 = parcelRequire("bopR4");

var $lj8SI = parcelRequire("lj8SI");

var $c8oLN = parcelRequire("c8oLN");
var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");

var $kY99m = parcelRequire("kY99m");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $4jAPy = parcelRequire("4jAPy");

var $gZK1Z = parcelRequire("gZK1Z");

var $bdYfL = parcelRequire("bdYfL");

var $a5i1n = parcelRequire("a5i1n");

var $c26pB = parcelRequire("c26pB");
const $6cc5b1f0251868be$var$sprintStatusAppearanceMap = {
    ACTIVE: 'inprogress',
    CLOSED: 'success',
    FUTURE: 'default'
};
const $6cc5b1f0251868be$var$GOAL_LIMIT = 190;
const $6cc5b1f0251868be$var$percentage = (count, total)=>total === 0 ? 0 : Math.round(count / total * 100);
const $6cc5b1f0251868be$var$ProgressBar = ({ progressInfo: progressInfo, progressPercentage: progressPercentage, progressWidth: progressWidth, additionalBarStyles: additionalBarStyles })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        spread: "space-between",
        shouldWrap: true,
        rowSpace: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        weight: "semibold",
        testId: "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.progress-info"
    }, progressInfo), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        weight: "semibold"
    }, progressPercentage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $6cc5b1f0251868be$var$barStyles,
            $6cc5b1f0251868be$var$progressBarStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: [
            $6cc5b1f0251868be$var$barStyles,
            additionalBarStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: `${progressWidth}%`
        }
    })));
const $6cc5b1f0251868be$var$SprintDate = ({ dateLabel: dateLabel, hasSprintDate: hasSprintDate, date: date, tooltipContent: tooltipContent, iconLabel: iconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        shouldWrap: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        weight: "semibold",
        color: "color.text.subtle"
    }, dateLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        xcss: $6cc5b1f0251868be$var$dateContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: hasSprintDate ? 'span' : 'em'
    }, date), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkuz9))), {
        label: iconLabel,
        size: "medium",
        primaryColor: "var(--ds-icon, #44546F)"
    }))));
const $6cc5b1f0251868be$var$getProgressBarLabel = (planningUnit, isDone)=>{
    const labelType = isDone ? 'Done' : 'Allocated';
    switch(planningUnit){
        case 0, $4jAPy.IP_BOARD_DAYS_PLANNING_UNIT:
            return (0, $c26pB.default)[`sprintDays${labelType}Label`];
        case 0, $4jAPy.IP_BOARD_HOURS_PLANNING_UNIT:
            return (0, $c26pB.default)[`sprintHours${labelType}Label`];
        default:
            return (0, $c26pB.default)[`sprintPoints${labelType}Label`];
    }
};
const $6cc5b1f0251868be$var$Goal = ({ goal: goal })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!goal) return null;
    const isOverLimit = goal.length > $6cc5b1f0251868be$var$GOAL_LIMIT;
    return isOverLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: goal,
        position: "auto"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $c26pB.default).sprintGoalEllipsed, {
        goal: goal.substring(0, $6cc5b1f0251868be$var$GOAL_LIMIT).trim()
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, goal);
};
const $6cc5b1f0251868be$var$SprintCapacityFlyout = ({ onFlyoutClose: onFlyoutClose, sprint: sprint, totalCapacity: totalCapacity, usedCapacity: usedCapacity, doneCapacity: doneCapacity, defaultCapacity: defaultCapacity, iterationEndDate: iterationEndDate, iterationStartDate: iterationStartDate, planningConfig: { planningUnit: planningUnit, workingHoursPerDay: workingHoursPerDay }, onChangeCapacity: onChangeCapacity, isReadOnly: isReadOnly })=>{
    const intl = (0, $koVbs.default)();
    const total = (0, $bdYfL.convertCapacity)(totalCapacity ?? defaultCapacity, planningUnit, workingHoursPerDay);
    const allocatedPercentage = $6cc5b1f0251868be$var$percentage(usedCapacity, total);
    const donePercentage = $6cc5b1f0251868be$var$percentage(doneCapacity, usedCapacity);
    const formatDateBasic = (0, $a5i1n.useFormatDateUTC)(intl, true);
    const formatDateExtended = (0, $a5i1n.useFormatDateUTC)(intl, true, true, true);
    const sprintStart = sprint.startDate || iterationStartDate;
    const sprintEnd = sprint.completedDate || sprint.endDate || iterationEndDate;
    const sprintStateLabel = (0, $bdYfL.getSprintStateLabel)(sprint.state, intl.formatMessage);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.150",
        xcss: $6cc5b1f0251868be$var$stackStyles,
        testId: "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-flyout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iyo13))), {
        label: (0, $4R6GH.fg)('ip_remove_aria_labels_for_decorative_images') ? '' : intl.formatMessage((0, $c26pB.default).sprintIconLabel),
        size: "small",
        primaryColor: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        weight: "semibold",
        color: "color.text.subtlest"
    }, intl.formatMessage((0, $c26pB.default).titleForSprintCapacityFlyout))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        onClick: onFlyoutClose,
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2C7j9))),
        label: intl.formatMessage((0, $c26pB.default).closeIconLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: $6cc5b1f0251868be$var$sprintStatusAppearanceMap[sprint.state]
    }, sprintStateLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1dJ6S.default), {
        size: "small",
        as: (0, $4R6GH.fg)('increment_board_a11y_fix') ? 'h2' : undefined
    }, sprint.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6cc5b1f0251868be$var$Goal, {
        goal: sprint.goal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c8oLN.default), {
        block: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.150",
        spread: "space-between",
        grow: "fill",
        alignBlock: "center",
        xcss: $6cc5b1f0251868be$var$capacityInfoEditStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: $6cc5b1f0251868be$var$capacityInfoStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($KdRgS))), {
        label: intl.formatMessage((0, $c26pB.default).sprintCapacityOverviewLabel),
        size: "medium",
        primaryColor: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, intl.formatMessage((0, $c26pB.default).sprintCapacityLabel, {
        planningUnit: (0, $bdYfL.getCapacityUnitMessage)(planningUnit, intl.formatMessage)
    }))), isReadOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $6cc5b1f0251868be$var$readViewContainerStyles
        ]
    }, total) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bopR4.default), {
        defaultValue: total,
        keepEditViewOpenOnBlur: true,
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ...fieldProps,
                min: 0,
                max: 99999,
                width: "64",
                "aria-label": intl.formatMessage((0, $gZK1Z.default).editCapacityLabel),
                autoFocus: true,
                type: "number",
                isCompact: true,
                ...planningUnit === (0, $4jAPy.IP_BOARD_DAYS_PLANNING_UNIT) && {
                    step: 0.1
                }
            }),
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: [
                    $6cc5b1f0251868be$var$readViewContainerStyles
                ]
            }, total),
        onConfirm: (value)=>{
            onChangeCapacity(value);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'edited',
                actionSubject: 'sprintCapacity'
            }));
        },
        editButtonLabel: intl.formatMessage((0, $gZK1Z.default).editCapacityLabel),
        confirmButtonLabel: intl.formatMessage((0, $gZK1Z.default).confirmButtonLabel),
        cancelButtonLabel: intl.formatMessage((0, $gZK1Z.default).cancelButtonLabel)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6cc5b1f0251868be$var$ProgressBar, {
        progressInfo: intl.formatMessage($6cc5b1f0251868be$var$getProgressBarLabel(planningUnit, false), {
            numerator: usedCapacity,
            denominatorCount: total
        }),
        progressPercentage: `${allocatedPercentage}%`,
        progressWidth: usedCapacity < total ? allocatedPercentage : 100,
        additionalBarStyles: usedCapacity > total ? $6cc5b1f0251868be$var$overloadedBarStyles : $6cc5b1f0251868be$var$allocatedBarStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6cc5b1f0251868be$var$ProgressBar, {
        progressInfo: intl.formatMessage($6cc5b1f0251868be$var$getProgressBarLabel(planningUnit, true), {
            numerator: doneCapacity,
            denominatorCount: usedCapacity
        }),
        progressPercentage: `${donePercentage}%`,
        progressWidth: donePercentage,
        additionalBarStyles: $6cc5b1f0251868be$var$doneBarStyles
    }), sprintStart && sprintEnd && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.200",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6cc5b1f0251868be$var$SprintDate, {
        dateLabel: intl.formatMessage((0, $c26pB.default).sprintStartDateLabel),
        hasSprintDate: !!sprint.startDate,
        date: formatDateBasic(sprintStart),
        tooltipContent: formatDateExtended(sprintStart),
        iconLabel: intl.formatMessage((0, $c26pB.default).sprintStartDateInfoIconLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6cc5b1f0251868be$var$SprintDate, {
        dateLabel: intl.formatMessage((0, $c26pB.default).sprintEndDateLabel),
        hasSprintDate: !!sprint.endDate,
        date: formatDateBasic(sprintEnd),
        tooltipContent: formatDateExtended(sprintEnd),
        iconLabel: intl.formatMessage((0, $c26pB.default).sprintEndDateInfoIconLabel)
    })), (!sprint.startDate || !sprint.endDate) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), null, intl.formatMessage((0, $c26pB.default).sprintDatesMissing, {
        sprintName: sprint.name
    }))));
};
var $6cc5b1f0251868be$export$2e2bcd8739ae039 = $6cc5b1f0251868be$var$SprintCapacityFlyout;
const $6cc5b1f0251868be$var$capacityInfoEditStyles = (0, $8CUq3.xcss)({
    marginBlockEnd: 'space.200'
});
const $6cc5b1f0251868be$var$capacityInfoStyles = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.250'
});
const $6cc5b1f0251868be$var$readViewContainerStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.075',
    lineHeight: '20px'
});
const $6cc5b1f0251868be$var$stackStyles = (0, $8CUq3.xcss)({
    width: '290px',
    padding: 'space.150'
});
const $6cc5b1f0251868be$var$barStyles = (0, $8CUq3.xcss)({
    height: '6px',
    borderRadius: 'border.radius.100'
});
const $6cc5b1f0251868be$var$progressBarStyles = (0, $8CUq3.xcss)({
    width: '100%',
    backgroundColor: 'color.background.neutral'
});
const $6cc5b1f0251868be$var$allocatedBarStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral.bold'
});
const $6cc5b1f0251868be$var$doneBarStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.success.bold'
});
const $6cc5b1f0251868be$var$overloadedBarStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.danger.bold'
});
const $6cc5b1f0251868be$var$dateContainerStyles = (0, $8CUq3.xcss)({
    lineHeight: 1
});

});
parcelRegister("KdRgS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08af0bf1cbfb8ac8$var$_react = $08af0bf1cbfb8ac8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $08af0bf1cbfb8ac8$var$_alignLeft = $08af0bf1cbfb8ac8$var$_interopRequireDefault((parcelRequire("i6luQ")));
function $08af0bf1cbfb8ac8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $08af0bf1cbfb8ac8$var$OverviewIcon = (props)=>/*#__PURE__*/ $08af0bf1cbfb8ac8$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.01 18c.546 0 .99-.444.99-1a1 1 0 0 0-.99-1H3.99A.993.993 0 0 0 3 17a1 1 0 0 0 .99 1zM3 7c0 .552.445 1 .993 1h16.014A.994.994 0 0 0 21 7c0-.552-.445-1-.993-1H3.993A.994.994 0 0 0 3 7m10.998 6A1 1 0 0 0 15 12c0-.552-.456-1-1.002-1H4.002A1 1 0 0 0 3 12c0 .552.456 1 1.002 1z"/></svg>`
    }, props, {
        newIcon: $08af0bf1cbfb8ac8$var$_alignLeft.default
    }));
$08af0bf1cbfb8ac8$var$OverviewIcon.displayName = 'OverviewIcon';
var $08af0bf1cbfb8ac8$var$_default = module.exports.default = $08af0bf1cbfb8ac8$var$OverviewIcon;

});
parcelRegister("i6luQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b38d718ca9f4aa1019c5485273ebd51>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2d976446b240c09$var$_react = $d2d976446b240c09$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d2d976446b240c09$var$_UNSAFE_baseNew = $d2d976446b240c09$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d2d976446b240c09$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AlignLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d2d976446b240c09$var$AlignLeftIcon = (props)=>/*#__PURE__*/ $d2d976446b240c09$var$_react.default.createElement($d2d976446b240c09$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 2.75h14M1 13.25h7M1 8h14"/>`
    }, props));
$d2d976446b240c09$var$AlignLeftIcon.displayName = 'AlignLeftIcon';
var $d2d976446b240c09$var$_default = module.exports.default = $d2d976446b240c09$var$AlignLeftIcon;

});


parcelRegister("iyo13", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d81e080f0024ae1d$var$_react = $d81e080f0024ae1d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d81e080f0024ae1d$var$_sprint = $d81e080f0024ae1d$var$_interopRequireDefault((parcelRequire("8mG85")));
function $d81e080f0024ae1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d81e080f0024ae1d$var$SprintIcon = (props)=>/*#__PURE__*/ $d81e080f0024ae1d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m17.717 17.137-1.436-1.438a1.003 1.003 0 0 1 1.418-1.418l3.007 3.01a1 1 0 0 1 0 1.417l-3.007 3.01a1.003 1.003 0 0 1-1.417-1.42l1.3-1.3-6.072-.003A8 8 0 0 1 4 11.01C4 6.587 7.582 3 12 3s8 3.587 8 8.01a8 8 0 0 1-.789 3.451l-1.438-1.44a6.1 6.1 0 0 0 .345-2.01A6.12 6.12 0 0 0 12 4.884a6.12 6.12 0 0 0-6.118 6.125 6.12 6.12 0 0 0 5.647 6.102zm-12.163-.119c.561.759 1.456 1.49 2.457 1.981L3.937 19C3.42 19 3 18.552 3 18s.42-1 .937-1l1.614.005z"/></svg>`
    }, props, {
        newIcon: $d81e080f0024ae1d$var$_sprint.default
    }));
$d81e080f0024ae1d$var$SprintIcon.displayName = 'SprintIcon';
var $d81e080f0024ae1d$var$_default = module.exports.default = $d81e080f0024ae1d$var$SprintIcon;

});
parcelRegister("8mG85", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ac782676a50cd4df56827dce883b620>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61710ed7f2aa84a3$var$_react = $61710ed7f2aa84a3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $61710ed7f2aa84a3$var$_UNSAFE_baseNew = $61710ed7f2aa84a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $61710ed7f2aa84a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Sprint".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $61710ed7f2aa84a3$var$SprintIcon = (props)=>/*#__PURE__*/ $61710ed7f2aa84a3$var$_react.default.createElement($61710ed7f2aa84a3$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.5 6.25a5.5 5.5 0 1 0-5.5 5.5m0 0H0m8 0h6.75m-3-3.5 3.5 3.5-3.5 3.5"/>`
    }, props));
$61710ed7f2aa84a3$var$SprintIcon.displayName = 'SprintIcon';
var $61710ed7f2aa84a3$var$_default = module.exports.default = $61710ed7f2aa84a3$var$SprintIcon;

});


parcelRegister("92Z2l", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97355a0cc6aeb06$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1dJ6S = parcelRequire("1dJ6S");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $3HeRx = parcelRequire("3HeRx");
const $a97355a0cc6aeb06$var$containerStyles = (0, $8CUq3.xcss)({
    wordBreak: 'break-word',
    borderRadius: 'border.radius'
});
const $a97355a0cc6aeb06$var$bleedStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    marginBlock: 'space.negative.025'
});
const $a97355a0cc6aeb06$var$contentStyles = (0, $8CUq3.xcss)({
    color: 'color.text',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $a97355a0cc6aeb06$var$SectionMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $3HeRx.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "section",
        backgroundColor: $a97355a0cc6aeb06$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $a97355a0cc6aeb06$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a97355a0cc6aeb06$var$bleedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        testId: testId && `${testId}--content`
    }, !!title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1dJ6S.default), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a97355a0cc6aeb06$var$contentStyles
    }, children), actionsArray.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        shouldWrap: true,
        testId: testId && `${testId}--actions`,
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0",
        role: "list"
    }, actionsArray.map((action, id)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            role: "listitem",
            key: id
        }, action))))));
});
const $a97355a0cc6aeb06$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$a97355a0cc6aeb06$var$SectionMessage.displayName = 'SectionMessage';
var $a97355a0cc6aeb06$export$2e2bcd8739ae039 = $a97355a0cc6aeb06$var$SectionMessage;

});
parcelRegister("3HeRx", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f);

var $5uXOq = parcelRequire("5uXOq");

var $btivG = parcelRequire("btivG");

var $7nnPp = parcelRequire("7nnPp");

var $2hXfb = parcelRequire("2hXfb");

var $eJS47 = parcelRequire("eJS47");

var $gtreQ = parcelRequire("gtreQ");

const $d1d7dced94bb00f5$export$faa35441caff5bb6 = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hXfb))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gtreQ))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7nnPp))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($btivG))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $829f609a65d26a98$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eJS47))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$147899de772240ec)})`
    }
};
function $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $d1d7dced94bb00f5$export$faa35441caff5bb6[appearance] || $d1d7dced94bb00f5$export$faa35441caff5bb6.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(appearanceIconStyles.Icon, {
            size: size,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("btivG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85a0c2d39fdb2976$var$_react = $85a0c2d39fdb2976$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $85a0c2d39fdb2976$var$_success = $85a0c2d39fdb2976$var$_interopRequireDefault((parcelRequire("b0JGA")));
function $85a0c2d39fdb2976$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $85a0c2d39fdb2976$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $85a0c2d39fdb2976$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $85a0c2d39fdb2976$var$_success.default
    }));
$85a0c2d39fdb2976$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $85a0c2d39fdb2976$var$_default = module.exports.default = $85a0c2d39fdb2976$var$CheckCircleIcon;

});



parcelRegister("c26pB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8267e765f2d5d52a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8267e765f2d5d52a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sprintGoalEllipsed: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-goal-ellipsed",
        "defaultMessage": "{goal}..."
    },
    titleForSprintCapacityFlyout: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.title-for-sprint-capacity-flyout",
        "defaultMessage": "SPRINT"
    },
    sprintCapacityLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-capacity-label",
        "defaultMessage": "Sprint capacity ({planningUnit})"
    },
    sprintPointsAllocatedLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-points-allocated-label",
        "defaultMessage": "{numerator}/{denominatorCount, plural, one {# point allocated} other {# points allocated}}"
    },
    sprintPointsDoneLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-points-done-label",
        "defaultMessage": "{numerator}/{denominatorCount, plural, one {# point done} other {# points done}}"
    },
    sprintDaysAllocatedLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-days-allocated-label",
        "defaultMessage": "{numerator}/{denominatorCount, plural, one {# day allocated} other {# days allocated}}"
    },
    sprintDaysDoneLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-days-done-label",
        "defaultMessage": "{numerator}/{denominatorCount, plural, one {# day done} other {# days done}}"
    },
    sprintHoursAllocatedLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-hours-allocated-label",
        "defaultMessage": "{numerator}/{denominatorCount, plural, one {# hour allocated} other {# hours allocated}}"
    },
    sprintHoursDoneLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-hours-done-label",
        "defaultMessage": "{numerator}/{denominatorCount, plural, one {# hour done} other {# hours done}}"
    },
    sprintStartDateLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-start-date-label",
        "defaultMessage": "Sprint start date"
    },
    sprintEndDateLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-end-date-label",
        "defaultMessage": "Sprint end date"
    },
    sprintDatesMissing: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-dates-missing",
        "defaultMessage": "{sprintName} has no start or end date. We've inferred dates based on your program board."
    },
    // Delete this message when cleaning up the feature gate `ip_remove_aria_labels_for_decorative_images`
    sprintIconLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-icon-label",
        "defaultMessage": "Sprint"
    },
    sprintCapacityOverviewLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-capacity-overview-label",
        "defaultMessage": "Sprint capacity overview"
    },
    sprintStartDateInfoIconLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-start-date-info-icon-label",
        "defaultMessage": "Sprint start date info"
    },
    sprintEndDateInfoIconLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-end-date-info-icon-label",
        "defaultMessage": "Sprint end date info"
    },
    closeIconLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.close-icon-label",
        "defaultMessage": "Close"
    }
});

});



parcelRegister("eeRMo", function(module, exports) {

$parcel$export(module.exports, "HeaderMeasurement", () => $89293d32499e7ce9$export$9cfc0bf0e92f5e76);

var $5uXOq = parcelRequire("5uXOq");

var $600T9 = parcelRequire("600T9");

var $2m0b6 = parcelRequire("2m0b6");
const $89293d32499e7ce9$var$useMeasureHeaderForDependencies = ({ columnId: columnId, isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel, headerRef: headerRef })=>{
    const [_, { updateColumnPositionMap: updateColumnPositionMap }] = (0, $600T9.useDependencyLinks)();
    const measureAndUpdateHeaderPosition = (0, $5uXOq.useCallback)(()=>{
        if (!isUnscheduledWorkColumnPanel && headerRef && typeof headerRef !== 'function' && headerRef.current) {
            const { x: x, width: width, height: height } = headerRef.current.getBoundingClientRect();
            updateColumnPositionMap({
                x: x,
                width: width,
                height: height
            }, columnId);
        }
    }, [
        isUnscheduledWorkColumnPanel,
        columnId,
        headerRef,
        updateColumnPositionMap
    ]);
    (0, $5uXOq.useEffect)(()=>{
        measureAndUpdateHeaderPosition();
    }, [
        measureAndUpdateHeaderPosition
    ]);
    (0, $2m0b6.useResizeObserver)({
        ref: headerRef,
        onResize: measureAndUpdateHeaderPosition
    });
};
const $89293d32499e7ce9$export$9cfc0bf0e92f5e76 = ({ columnId: columnId, isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel, headerRef: headerRef })=>{
    $89293d32499e7ce9$var$useMeasureHeaderForDependencies({
        columnId: columnId,
        isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel,
        headerRef: headerRef
    });
    return null;
};

});
parcelRegister("600T9", function(module, exports) {

$parcel$export(module.exports, "useDependencyLinks", () => $0fc18713c0225ca6$export$c63c11963c509d47);
$parcel$export(module.exports, "useIPDependencyLines", () => $0fc18713c0225ca6$export$aadd1ba1a70b5a);

var $74ySO = parcelRequire("74ySO");

var $hGgHi = parcelRequire("hGgHi");

var $vNXgH = parcelRequire("vNXgH");

var $dJl1T = parcelRequire("dJl1T");

var $4R6GH = parcelRequire("4R6GH");

var $645AZ = parcelRequire("645AZ");

var $4jAPy = parcelRequire("4jAPy");

var $3eGwD = parcelRequire("3eGwD");

var $7JoAD = parcelRequire("7JoAD");
const $0fc18713c0225ca6$var$initialState = {
    dependencyLinesContainerPosition: {
        x: 0
    },
    issuesWithIssueLinkPositionMap: new Map(),
    swimlanePositionMap: new Map(),
    columnPositionMap: new Map(),
    activeLine: null
};
const $0fc18713c0225ca6$var$LINE_VERTICAL_OFFSET = 8;
const $0fc18713c0225ca6$var$actions = {
    // We save the board position because we want to draw lines relative to the board, not the viewport
    // Add the board's left and top positions from line calculations to offset the board
    updateDependencyLinesContainerPosition: (dependencyLinesContainerPosition)=>({ setState: setState })=>{
            setState({
                dependencyLinesContainerPosition: dependencyLinesContainerPosition
            });
        },
    updateIssuesWithIssueLinkPositions: (issueEntries, issuesWithIssueLinksIds, issuePositions, isUnscheduledWorkColumnPanel, swimlaneId)=>({ setState: setState, getState: getState })=>{
            if (!isUnscheduledWorkColumnPanel && issuePositions && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) {
                const { swimlanePositionMap: swimlanePositionMap } = getState();
                if (swimlanePositionMap === undefined || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(swimlaneId)) return;
                const swimlanePosition = swimlanePositionMap.get(swimlaneId);
                if (swimlanePosition === undefined) return;
                const issueIdsWithLinks = issueEntries.reduce((acc, issueEntry, index)=>{
                    if ((0, $3eGwD.isIssueEntryIssue)(issueEntry) && (0, (/*@__PURE__*/$parcel$interopDefault($74ySO)))(issuesWithIssueLinksIds, issueEntry.issueId)) acc.push({
                        issueId: String(issueEntry.issueId),
                        index: index
                    });
                    return acc;
                }, []);
                const { issuesWithIssueLinkPositionMap: issuesWithIssueLinkPositionMap } = getState();
                const newIssuesWithIssueLinkPositionMap = new Map(issuesWithIssueLinkPositionMap);
                issueIdsWithLinks.forEach(({ issueId: issueId, index: index })=>{
                    const issuePosition = issuePositions[index];
                    if (issuePosition) newIssuesWithIssueLinkPositionMap.set(issueId, {
                        ...issuePosition,
                        relativeTop: issuePosition.top - swimlanePosition.swimlanePosition.top
                    });
                });
                setState({
                    issuesWithIssueLinkPositionMap: newIssuesWithIssueLinkPositionMap
                });
            }
        },
    updateSwimlanePositions: (swimlanePositions, visibleSwimlanePositions, swimlaneIds, collapsedSwimlaneIds)=>({ setState: setState })=>{
            const newSwimlanePositionMap = new Map();
            swimlaneIds.forEach((swimlaneId, index)=>{
                const swimlanePosition = swimlanePositions[index];
                const isVisible = visibleSwimlanePositions.some((visibleSwimlane)=>visibleSwimlane.index === index);
                const isCollapsed = collapsedSwimlaneIds.includes(swimlaneId);
                if (swimlaneId && swimlanePosition) newSwimlanePositionMap.set(swimlaneId, {
                    isCollapsed: isCollapsed,
                    isVisible: isVisible,
                    swimlanePosition: swimlanePosition
                });
            });
            setState({
                swimlanePositionMap: newSwimlanePositionMap
            });
        },
    updateColumnPositionMap: (columnPosition, columnId)=>({ setState: setState, getState: getState })=>{
            const { columnPositionMap: columnPositionMap } = getState();
            const newColumnPositionMap = new Map(columnPositionMap);
            newColumnPositionMap.set(columnId, columnPosition);
            setState({
                columnPositionMap: newColumnPositionMap
            });
        },
    setActiveLine: (activeLine)=>({ setState: setState })=>{
            setState({
                activeLine: activeLine
            });
        }
};
const $0fc18713c0225ca6$var$Store = (0, $7JoAD.createStore)({
    name: 'dependencyLineStore',
    initialState: $0fc18713c0225ca6$var$initialState,
    actions: $0fc18713c0225ca6$var$actions
});
const $0fc18713c0225ca6$export$c63c11963c509d47 = (0, $7JoAD.createHook)($0fc18713c0225ca6$var$Store);
const $0fc18713c0225ca6$var$getYPosition = (issue, issuesWithIssueLinkPositionMap, swimlanePositionMap, columnPositionMap, edge)=>{
    const swimlaneId = issue.teamId ?? (0, $4jAPy.SWIMLANE_TEAMLESS);
    const swimlanePosition = swimlanePositionMap.get(swimlaneId);
    // When the page loads, it is possible that we try to get this data before it's ready - returning a default value to begin with
    if (issuesWithIssueLinkPositionMap === undefined || swimlanePosition === undefined) return 0;
    const issuePosition = issuesWithIssueLinkPositionMap.get(String(issue.id));
    // Due to a quirk with virtualisation sometimes we do get the position of a card before it's been scrolled onto screen during the initial renders
    // We have issue y positions that aren't strictly correct saved into state, and should only depend on this data once the swimlane that it is in
    // is actually scrolled onto screen. We aren't able to get the vertical position of those issues once everything has rendered onto the page
    // because the parent swimlane component doesn't try to virtualise its child issues list if it is itself virtualised (not rendered).
    if (issuePosition) {
        const columnHeight = columnPositionMap.get(issue.columnId)?.height ?? 0;
        const edgeOffset = edge === 'left' ? $0fc18713c0225ca6$var$LINE_VERTICAL_OFFSET : -$0fc18713c0225ca6$var$LINE_VERTICAL_OFFSET;
        const top = swimlanePosition.swimlanePosition.top + issuePosition.relativeTop + columnHeight + (0, $645AZ.swimlaneHeaderHeight);
        return top + issuePosition.height / 2 + edgeOffset;
    }
    // if the swimlane the issue belongs to is offscreen, we just draw the line to halfway down the swimlane.
    if (swimlanePosition.isVisible === false) return swimlanePosition.swimlanePosition.top + swimlanePosition.swimlanePosition.height / 2;
    // If the swimlane is visible, we should theoretically have the issue position and not gotten here.
    (0, $dJl1T.default).safeErrorWithoutCustomerData('plan-increment-common.useDependencyLinks.getYPosition', 'Failed to find the y position of an issue when calculating dependency line positions.');
    // Return a default value in case we can't find the y position of the card we're trying to draw to.
    return 0;
};
const $0fc18713c0225ca6$var$getXPosition = (issue, dependencyLinesContainerPosition, columnPositionMap, edge)=>{
    const columnPosition = columnPositionMap.get(issue.columnId);
    if (columnPosition) return columnPosition.x + (edge === 'left' ? 0 : columnPosition.width) - dependencyLinesContainerPosition.x;
    // Issues must belong to a column - we theoretically shouldn't have gotten here.
    (0, $dJl1T.default).safeErrorWithoutCustomerData('plan-increment-common.useDependencyLinks.getXPosition', 'Failed to find the x position of an issue when calculating dependency line positions.');
    return 0;
};
const $0fc18713c0225ca6$var$getIssuePosition = (state, issue, edge = 'right')=>{
    const { dependencyLinesContainerPosition: dependencyLinesContainerPosition, issuesWithIssueLinkPositionMap: issuesWithIssueLinkPositionMap, swimlanePositionMap: swimlanePositionMap, columnPositionMap: columnPositionMap } = state;
    const yPosition = $0fc18713c0225ca6$var$getYPosition(issue, issuesWithIssueLinkPositionMap, swimlanePositionMap, columnPositionMap, edge);
    const xPosition = $0fc18713c0225ca6$var$getXPosition(issue, dependencyLinesContainerPosition, columnPositionMap, edge);
    return {
        id: String(issue.id),
        y: yPosition,
        x: xPosition,
        color: 'DARK_GREY'
    };
};
// Arbitrary number - this affects the curvature of the drawn dependency line only.
const $0fc18713c0225ca6$var$ITEM_HEIGHT = 40;
const $0fc18713c0225ca6$var$getDependencyLine = ({ state: state, from: from, to: to, isOfftrack: isOfftrack })=>({
        itemHeight: $0fc18713c0225ca6$var$ITEM_HEIGHT,
        isOverlapping: isOfftrack,
        from: $0fc18713c0225ca6$var$getIssuePosition(state, from, 'right'),
        to: $0fc18713c0225ca6$var$getIssuePosition(state, to, 'left')
    });
// The list of issues passed in should have already filtered out issues from the unscheduled column.
// If either end of the issue link is undefined, those issues are not in the board.
const $0fc18713c0225ca6$var$issuesAreInBoard = (sourceIssue, destinationIssue)=>sourceIssue !== undefined && destinationIssue !== undefined;
// If either issue in the link belongs to a swimlane that is collapsed, we should not draw that line
const $0fc18713c0225ca6$var$issuesSwimlanesAreNotCollapsed = (sourceIssue, destinationIssue, swimlanePositionMap)=>{
    const sourceSwimlaneId = sourceIssue?.teamId ?? (0, $4jAPy.SWIMLANE_TEAMLESS);
    const destinationSwimlaneId = destinationIssue?.teamId ?? (0, $4jAPy.SWIMLANE_TEAMLESS);
    const sourceSwimlane = swimlanePositionMap.get(sourceSwimlaneId);
    const destinationSwimlane = swimlanePositionMap.get(destinationSwimlaneId);
    return sourceSwimlane && destinationSwimlane && !sourceSwimlane.isCollapsed && !destinationSwimlane.isCollapsed;
};
const $0fc18713c0225ca6$export$c9ae9143e2c98177 = (state, issuesWithLinksById, showOffTrackDependencies, issueIdsToShowDependencies)=>{
    const { swimlanePositionMap: swimlanePositionMap } = state;
    if (!issuesWithLinksById || Object.values(issuesWithLinksById).length === 0 || !showOffTrackDependencies && issueIdsToShowDependencies.length === 0) return [];
    const filteredIssues = [];
    if (issueIdsToShowDependencies.length) issueIdsToShowDependencies.forEach((id)=>{
        const issue = issuesWithLinksById[id];
        if (issue) filteredIssues.push(issue);
    });
    if (showOffTrackDependencies) Object.values(issuesWithLinksById).forEach((issue)=>{
        if (issue.issueLinks && issue.issueLinks.length) {
            const offTrackLinks = issue.issueLinks.filter((link)=>link.isOfftrack);
            if (offTrackLinks.length) {
                const issueWithOfftrackLinks = {
                    ...issue,
                    issueLinks: offTrackLinks
                };
                filteredIssues.push(issueWithOfftrackLinks);
            }
        }
    });
    const uniqueIssueLinkIds = new Set();
    const overlayDependencies = filteredIssues.reduce((acc, issue)=>{
        if (!issue.issueLinks) return acc;
         // We need to ensure we only include a single entry when there are multiple issue link types
        // between the same source and destination issue so that we don't unnecessarily render multiple lines.
        // We don't need to be opinionated about which one we choose, as the user can click on
        // the line to ascertain the details of the different issue links.
        const uniqueSourceDestinationIssueLinks = (0, (/*@__PURE__*/$parcel$interopDefault($vNXgH)))(issue.issueLinks, (a, b)=>a.sourceId === b.sourceId && a.destinationId === b.destinationId);
        uniqueSourceDestinationIssueLinks.forEach((issueLink)=>{
            // Every issue link appears twice, so we don't want to handle ones we have already handled.
            if (uniqueIssueLinkIds.has(issueLink.id)) return;
            uniqueIssueLinkIds.add(issueLink.id);
            const sourceIssue = issuesWithLinksById[issueLink.sourceId];
            const destinationIssue = issuesWithLinksById[issueLink.destinationId];
            if ($0fc18713c0225ca6$var$issuesAreInBoard(sourceIssue, destinationIssue) && $0fc18713c0225ca6$var$issuesSwimlanesAreNotCollapsed(sourceIssue, destinationIssue, swimlanePositionMap)) acc.push($0fc18713c0225ca6$var$getDependencyLine({
                state: state,
                from: sourceIssue,
                to: destinationIssue,
                isOfftrack: !!issueLink.isOfftrack
            }));
        });
        return acc;
    }, []);
    return overlayDependencies;
};
const $0fc18713c0225ca6$var$getDependencyLines = (0, $7JoAD.createSelector)((state)=>state, (_, props)=>props, (state, { issuesWithLinksById: issuesWithLinksById, showOffTrackDependencies: showOffTrackDependencies, issueIdsToShowDependencies: issueIdsToShowDependencies })=>{
    return $0fc18713c0225ca6$export$c9ae9143e2c98177(state, issuesWithLinksById, showOffTrackDependencies, issueIdsToShowDependencies);
});
const $0fc18713c0225ca6$export$aadd1ba1a70b5a = (0, $7JoAD.createHook)($0fc18713c0225ca6$var$Store, {
    selector: $0fc18713c0225ca6$var$getDependencyLines
});

});


parcelRegister("8qFMV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cace9106fadeb38d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cace9106fadeb38d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    visibleIssueCount: {
        "id": "software.main.board-container.board.column.program-swimlane-column-header.visible-issue-count",
        "defaultMessage": "{count} / {total} {total, plural, one {issue} other {issues}}"
    },
    totalIssueCount: {
        "id": "software.main.board-container.board.column.program-swimlane-column-header.total-issue-count",
        "defaultMessage": "{total} {total, plural, one {issue} other {issues}}"
    },
    completedSprint: {
        "id": "software.main.board-container.board.column.program-swimlane-column-header.completed-sprint",
        "defaultMessage": "Completed sprint"
    },
    activeSprint: {
        "id": "software.main.board-container.board.column.program-swimlane-column-header.active-sprint",
        "defaultMessage": "Active sprint"
    },
    futureSprint: {
        "id": "software.main.board-container.board.column.program-swimlane-column-header.future-sprint",
        "defaultMessage": "Future sprint"
    },
    visibleIssueCountIssueTermRefresh: {
        "id": "software.main.board-container.board.column.program-swimlane-column-header.visible-issue-count-issue-term-refresh",
        "defaultMessage": "{count} / {total} {total, plural, one {issue} other {issues}}"
    },
    totalIssueCountIssueTermRefresh: {
        "id": "software.main.board-container.board.column.program-swimlane-column-header.total-issue-count-issue-term-refresh",
        "defaultMessage": "{total} {total, plural, one {issue} other {issues}}"
    }
});

});


parcelRegister("7meEu", function(module, exports) {

$parcel$export(module.exports, "UnassignedFilterCTA", () => $00c0741c56fde3e5$export$e55f8bc7fe19ab47);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $22Gxp = parcelRequire("22Gxp");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");

var $2jwCH = parcelRequire("2jwCH");

var $35XSW = parcelRequire("35XSW");
var $4uxPN = parcelRequire("4uxPN");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $39xOx = parcelRequire("39xOx");

var $6s1PB = parcelRequire("6s1PB");

var $ousew = parcelRequire("ousew");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");



var $67sX6 = parcelRequire("67sX6");

var $dnW4F = parcelRequire("dnW4F");

var $4UXiN = parcelRequire("4UXiN");

var $9OPNP = parcelRequire("9OPNP");

var $5oTkT = parcelRequire("5oTkT");

var $2x2Gs = parcelRequire("2x2Gs");

var $2DCM9 = parcelRequire("2DCM9");
const $00c0741c56fde3e5$var$CTA_DEFAULT_HEIGHT = 126;
const $00c0741c56fde3e5$export$e55f8bc7fe19ab47 = ({ children: children })=>{
    const [ctaHeight, setCtaHeight] = (0, $5uXOq.useState)(0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "unassigned-filter-cta",
        packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
        withExperienceTracker: true,
        fallback: "unmount",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "viewUnassignedFilterCTA",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($00c0741c56fde3e5$var$InnerUnassignedFilterCTA, {
        setCtaHeight: setCtaHeight
    }))), children?.(ctaHeight));
};
const $00c0741c56fde3e5$var$InnerUnassignedFilterCTA = ({ setCtaHeight: setCtaHeight })=>{
    const { dismiss: dismiss, isDismissed: isDismissed, dismissCount: dismissCount } = (0, $2x2Gs.useDismissal)();
    const isBoardInTargetState = (0, $9OPNP.useShouldShowUnassignedFilterCTA)();
    const newFilters = (0, $67sX6.useBoardSelector)((0, $4UXiN.unassignedWorkFilterSelector));
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const id = (0, $22Gxp.useUID)();
    const ctaRef = (0, $5uXOq.useRef)(null);
    const isVisible = !isDismissed && isBoardInTargetState && (0, $6s1PB.expValEquals)('jira-collab-unassigned-filter-cta', 'isEnabled', true);
    const updateCtaHeight = (0, $5uXOq.useCallback)(()=>{
        const ctaHeightUpdated = ctaRef.current?.clientHeight ?? $00c0741c56fde3e5$var$CTA_DEFAULT_HEIGHT;
        setCtaHeight(isVisible ? ctaHeightUpdated : 0);
    }, [
        isVisible,
        setCtaHeight
    ]);
    const updateCtaHeightDebounced = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(updateCtaHeight, 100, {
            leading: false,
            trailing: true
        }), [
        updateCtaHeight
    ]);
    // Update height on CTA size change (e.g. window resize)
    (0, $2DCM9.useResizeObserver)(ctaRef.current, updateCtaHeightDebounced);
    // Update height on render display logic change (e.g. dismiss or filter change)
    // note: updateCtaHeight is recreated as isDismissed & shouldShow change
    (0, $5uXOq.useLayoutEffect)(()=>{
        updateCtaHeight();
    }, [
        updateCtaHeight
    ]);
    const handleFilterClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'filterBar'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'changeFilterBar', {
            isUnassignedSelected: true,
            isOnlyCurrentUserSelected: false,
            isUnassignedFilterCta: true,
            unassignedFilterDismissCount: dismissCount
        });
        return dispatch((0, $dnW4F.setAllFilters)(newFilters, (0, $15a528573ccd89ae$export$f8f7545d2bb78afb), analyticsEvent));
    };
    const dismissWithAnalytics = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'unassignedCTADismissed');
        dismiss();
    }, [
        dismiss
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            dismissCount: dismissCount
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $35XSW.default), {
        appear: true,
        exitThenEnter: true
    }, !isVisible ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uxPN.default), {
        entranceDirection: "top",
        exitDirection: "top"
    }, (fadeInProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ...fadeInProps,
            role: "group",
            "aria-labelledby": id,
            ref: ctaRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            xcss: $00c0741c56fde3e5$var$containerStyle,
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $00c0741c56fde3e5$var$titleStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            weight: "semibold",
            id: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5oTkT.default).unassignedFilterCtaTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5oTkT.default).unassignedFilterCtaDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            onClick: handleFilterClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5oTkT.default).unassignedFilterCtaButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $00c0741c56fde3e5$var$closeButtonStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2jwCH))),
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5oTkT.default).unassignedFilterCtaCloseButtonLabel),
            appearance: "subtle",
            spacing: "compact",
            onClick: dismissWithAnalytics
        })))))));
};
const $00c0741c56fde3e5$var$containerStyle = (0, $8CUq3.xcss)({
    position: 'relative',
    padding: 'space.200',
    margin: 'space.050',
    marginBottom: '0',
    backgroundColor: 'color.background.information',
    borderRadius: 'border.radius',
    boxShadow: 'elevation.shadow.raised'
});
const $00c0741c56fde3e5$var$titleStyle = (0, $8CUq3.xcss)({
    paddingRight: 'space.300'
});
const $00c0741c56fde3e5$var$closeButtonStyle = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: 'space.150',
    right: 'space.150'
});

});
parcelRegister("2jwCH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e966e44e10d4af587c95b714fe3851cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1af6a969f6ce5e7d$var$_react = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1af6a969f6ce5e7d$var$_close = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("i28qQ")));

var $1af6a969f6ce5e7d$var$_close2 = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("2C7j9")));
function $1af6a969f6ce5e7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1af6a969f6ce5e7d$var$CloseIcon = (props)=>/*#__PURE__*/ $1af6a969f6ce5e7d$var$_react.default.createElement($1af6a969f6ce5e7d$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $1af6a969f6ce5e7d$var$_close2.default
    }, props));
$1af6a969f6ce5e7d$var$CloseIcon.Name = 'CloseIconMigration';
var $1af6a969f6ce5e7d$var$_default = module.exports.default = $1af6a969f6ce5e7d$var$CloseIcon;

});

parcelRegister("4UXiN", function(module, exports) {

$parcel$export(module.exports, "unassignedWorkFilterSelector", () => $1ecb2e5ca409910b$export$ce997d9abe0b751d);
$parcel$export(module.exports, "userHasIncompleteAssignedIssuesSelector", () => $1ecb2e5ca409910b$export$9bc7220098bcf10);
$parcel$export(module.exports, "boardHasIncompleteUnassignedWorkSelector", () => $1ecb2e5ca409910b$export$e8008c7aa147a522);
$parcel$export(module.exports, "shouldShowUnassignedFilterCTASelector", () => $1ecb2e5ca409910b$export$f4e8b1068b980044);

var $dGvGJ = parcelRequire("dGvGJ");



var $iuuJH = parcelRequire("iuuJH");

var $3UY9S = parcelRequire("3UY9S");

var $iGIww = parcelRequire("iGIww");

var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");
const $1ecb2e5ca409910b$export$ce997d9abe0b751d = (0, $dGvGJ.createSelector)([
    (0, $5mTgl.getWorkFilters),
    (0, $36pz7.getCurrentUserAccountId)
], (workFilters, accountId)=>({
        ...workFilters.values,
        [(0, $dcff40112356dfc1$export$f8f7545d2bb78afb)]: [
            (0, $15a528573ccd89ae$export$12e572fd459c10dc),
            accountId
        ]
    }));
const $1ecb2e5ca409910b$export$cd131d92cfdfcfee = (0, $dGvGJ.createSelector)([
    $1ecb2e5ca409910b$export$ce997d9abe0b751d,
    (0, $5mTgl.workIssuesSelector),
    (0, $67Z81.getIssues),
    (0, $36pz7.getPeople),
    (0, $5mTgl.getFilteredCardIds)
], (unassignedFilter, issues, issueHash, people, filteredCardIds)=>(0, $iGIww.filter)(unassignedFilter, issues, issueHash, people, filteredCardIds || undefined));
const $1ecb2e5ca409910b$export$9bc7220098bcf10 = (0, $dGvGJ.createSelector)([
    (0, $5mTgl.workIssuesSelector),
    (0, $3UY9S.getIssueChildren),
    (0, $36pz7.getCurrentUserAccountId),
    (0, $45cXl.getSwimlaneMode)
], (issues, childrenIssue, accountId, swimlaneMode)=>{
    if (swimlaneMode !== (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return issues.some((issue)=>!issue.isDone && issue.assigneeAccountId === accountId);
    return [
        ...issues,
        ...Object.values(childrenIssue)
    ].some((issue)=>!issue.isDone && issue.assigneeAccountId === accountId);
});
const $1ecb2e5ca409910b$export$e8008c7aa147a522 = (0, $dGvGJ.createSelector)([
    $1ecb2e5ca409910b$export$cd131d92cfdfcfee
], (issues)=>issues.some((issue)=>!issue.isDone && (issue.assigneeAccountId === undefined || issue.assigneeAccountId === null)));
const $1ecb2e5ca409910b$export$ccb470d631ed335b = (0, $dGvGJ.createSelector)([
    (0, $5mTgl.getWorkFilters),
    (0, $36pz7.getCurrentUserAccountId)
], (workFilters, accountId)=>!workFilters.values[0, $dcff40112356dfc1$export$f8f7545d2bb78afb] || workFilters.values[0, $dcff40112356dfc1$export$f8f7545d2bb78afb].length === 1 && workFilters.values[0, $dcff40112356dfc1$export$f8f7545d2bb78afb][0] === accountId);
const $1ecb2e5ca409910b$export$f4e8b1068b980044 = (0, $dGvGJ.createSelector)([
    $1ecb2e5ca409910b$export$9bc7220098bcf10,
    $1ecb2e5ca409910b$export$e8008c7aa147a522,
    $1ecb2e5ca409910b$export$ccb470d631ed335b
], (userHasIncompleteAssignedIssues, boardHasIncompleteUnassignedWork, userFilterAppliedSelector)=>!userHasIncompleteAssignedIssues && boardHasIncompleteUnassignedWork && userFilterAppliedSelector);

});

parcelRegister("9OPNP", function(module, exports) {

$parcel$export(module.exports, "useShouldShowUnassignedFilterCTA", () => $9fc36c8f29d88f44$export$d5a139223fe10f60);

var $67sX6 = parcelRequire("67sX6");

var $4UXiN = parcelRequire("4UXiN");
function $9fc36c8f29d88f44$export$d5a139223fe10f60() {
    return (0, $67sX6.useBoardSelector)((0, $4UXiN.shouldShowUnassignedFilterCTASelector));
}

});

parcelRegister("5oTkT", function(module, exports) {

$parcel$export(module.exports, "default", () => $054407e0df792870$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $054407e0df792870$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filterIconLabel: {
        "id": "software.main.board-container.board.unassigned-filter-cta-experiment.filter-icon-label",
        "defaultMessage": "Filter"
    },
    unassignedFilterCtaCloseButtonLabel: {
        "id": "software.main.board-container.board.unassigned-filter-cta-experiment.unassigned-filter-cta-close-button-label",
        "defaultMessage": "Dismiss find available work faster message"
    },
    unassignedFilterCtaTitle: {
        "id": "software.main.board-container.board.unassigned-filter-cta-experiment.unassigned-filter-cta-title",
        "defaultMessage": "Find available work faster"
    },
    unassignedFilterCtaDescription: {
        "id": "software.main.board-container.board.unassigned-filter-cta-experiment.unassigned-filter-cta-description",
        "defaultMessage": "Only show unassigned work on the board."
    },
    unassignedFilterCtaButtonText: {
        "id": "software.main.board-container.board.unassigned-filter-cta-experiment.unassigned-filter-cta-button-text",
        "defaultMessage": "Turn on unassigned filter"
    }
});

});

parcelRegister("2x2Gs", function(module, exports) {

$parcel$export(module.exports, "useDismissal", () => $ab3595bedff8f6a2$export$b3877935e036662a);

var $5uXOq = parcelRequire("5uXOq");

var $9AdtW = parcelRequire("9AdtW");
const $ab3595bedff8f6a2$export$b3877935e036662a = ()=>{
    const [dismissalState, setDismissalState] = (0, $5uXOq.useState)();
    const isDismissed = (0, $5uXOq.useMemo)(()=>!dismissalState || dismissalState.count > 2 || dismissalState.dismissUntil >= Date.now(), [
        dismissalState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // reading the data from local storage in useEffect so we won't try to read it for SSR
        setDismissalState((0, $9AdtW.getDismissalLocalStorageState)());
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (dismissalState?.dismissUntil) (0, $9AdtW.setDismissalLocalStorageState)(dismissalState);
    }, [
        dismissalState
    ]);
    const dismiss = (0, $5uXOq.useCallback)(()=>{
        setDismissalState((prevState)=>({
                count: (prevState?.count ?? 0) + 1,
                dismissUntil: new Date().setHours(23, 59, 59, 999)
            }));
    }, []);
    return {
        isDismissed: isDismissed,
        dismiss: dismiss,
        dismissCount: dismissalState?.count ?? 0
    };
};

});
parcelRegister("9AdtW", function(module, exports) {

$parcel$export(module.exports, "getDismissalLocalStorageState", () => $84b1009b0ad01ea3$export$618769f4481a782d);
$parcel$export(module.exports, "setDismissalLocalStorageState", () => $84b1009b0ad01ea3$export$43925291024c3f94);

var $bSSG7 = parcelRequire("bSSG7");

const $84b1009b0ad01ea3$export$1621c8e1c66f77cd = (0, $bSSG7.createLocalStorageProvider)((0, $26d63227447f2db9$export$d1b7da9d58401934));
const $84b1009b0ad01ea3$export$618769f4481a782d = ()=>({
        count: $84b1009b0ad01ea3$export$1621c8e1c66f77cd.get((0, $26d63227447f2db9$export$1c5aea45d8141b3a)) ?? 0,
        dismissUntil: $84b1009b0ad01ea3$export$1621c8e1c66f77cd.get((0, $26d63227447f2db9$export$ef05e80525b51370)) ?? 0
    });
const $84b1009b0ad01ea3$export$43925291024c3f94 = (dismissalState)=>{
    $84b1009b0ad01ea3$export$1621c8e1c66f77cd.set((0, $26d63227447f2db9$export$1c5aea45d8141b3a), dismissalState.count);
    $84b1009b0ad01ea3$export$1621c8e1c66f77cd.set((0, $26d63227447f2db9$export$ef05e80525b51370), dismissalState.dismissUntil);
};

});
const $26d63227447f2db9$export$1c5aea45d8141b3a = 'dismissed-count';
const $26d63227447f2db9$export$ef05e80525b51370 = 'dismiss-until';
const $26d63227447f2db9$export$d1b7da9d58401934 = 'unassigned-filter-cta';



parcelRegister("2DCM9", function(module, exports) {

$parcel$export(module.exports, "useResizeObserver", () => $c1aef6f3db9e788e$export$683480f191c0e3ea);

var $5uXOq = parcelRequire("5uXOq");
const $c1aef6f3db9e788e$export$683480f191c0e3ea = (element, callback)=>{
    (0, $5uXOq.useEffect)(()=>{
        let resizeObserver;
        if (element && typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(callback);
            resizeObserver.observe(element);
        }
        return ()=>{
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        element,
        callback
    ]);
    return null;
};

});


parcelRegister("2lkEP", function(module, exports) {

$parcel$export(module.exports, "FastVirtualList", () => $4f0f63c9193536a4$export$32fc6f03ada9e09e);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $co1wz = parcelRequire("co1wz");

var $9QpK7 = parcelRequire("9QpK7");

var $4R6GH = parcelRequire("4R6GH");

var $g503o = parcelRequire("g503o");

var $600T9 = parcelRequire("600T9");

var $3eGwD = parcelRequire("3eGwD");

var $g7BZG = parcelRequire("g7BZG");

var $guFRy = parcelRequire("guFRy");

var $63LqY = parcelRequire("63LqY");

var $bQegf = parcelRequire("bQegf");


var $htqkB = parcelRequire("htqkB");

var $bvghy = parcelRequire("bvghy");

var $bfNGc = parcelRequire("bfNGc");

var $5b8dQ = parcelRequire("5b8dQ");
const $4f0f63c9193536a4$export$32fc6f03ada9e09e = ({ name: name, offsetTop: offsetTop, issueEntries: issueEntries = [], issuesWithIssueLinksIds: issuesWithIssueLinksIds = [], footer: footer, placeholder: placeholder, renderCard: renderCard, showFooter: showFooter, columnId: columnId, swimlaneId: swimlaneId, hasCTA: hasCTA, isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel })=>{
    const isIpBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const cardHeightCache = (0, $bvghy.useCardHeightCache)();
    const cacheOptions = (0, $5uXOq.useMemo)(()=>({
            cache: cardHeightCache,
            getCacheKey: (index)=>{
                const issueEntry = issueEntries[index];
                if (!issueEntry) return undefined;
                if ((0, $3eGwD.isIssueEntryGroup)(issueEntry)) return (0, $3eGwD.getIssueEntryGroupKey)(issueEntry);
                return issueEntry.issueId;
            }
        }), [
        issueEntries,
        cardHeightCache
    ]);
    const rowCount = (0, $bfNGc.useRowCount)({
        placeholder: placeholder,
        issues: issueEntries
    });
    /**
   * versioning by the order of issue ids order excluding subtasks
   */ const version = (0, $5uXOq.useMemo)(()=>issueEntries.map((issueEntry)=>(0, $3eGwD.isIssueEntryIssue)(issueEntry) ? issueEntry.issueId : issueEntry.parentId).toString(), [
        issueEntries
    ]);
    const defaultHeight = hasCTA ? (0, $7455914ed26b7de2$export$a93995a3737ff205) : (0, $7455914ed26b7de2$export$428a1825e984a589);
    const { rows: rows, totalSize: totalSize, scrollTo: scrollTo, isScrolling: isScrolling, rowStates: rowStates } = (0, $guFRy.useVirtual)({
        rowCount: rowCount,
        overscanHeight: defaultHeight,
        getDefaultRowSize: (index)=>index === issueEntries.length ? 0 : defaultHeight,
        offsetTop: offsetTop,
        cacheOptions: cacheOptions,
        version: version
    });
    (0, $g7BZG.useRemeasureOnResize)({
        rows: rows
    });
    (0, $htqkB.useAutoScrollCard)(issueEntries, scrollTo);
    (0, $5b8dQ.useScrollToUnscheduledColumnICC)(columnId, swimlaneId, issueEntries.length, scrollTo);
    const [_, { updateIssuesWithIssueLinkPositions: updateIssuesWithIssueLinkPositions }] = (0, $600T9.useDependencyLinks)();
    (0, $5uXOq.useEffect)(()=>{
        if (isIpBoard && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) updateIssuesWithIssueLinkPositions(issueEntries, issuesWithIssueLinksIds, rowStates, isUnscheduledWorkColumnPanel, swimlaneId);
    }, [
        isIpBoard,
        isUnscheduledWorkColumnPanel,
        issueEntries,
        issuesWithIssueLinksIds,
        swimlaneId,
        rowStates,
        updateIssuesWithIssueLinkPositions
    ]);
    // If there are no cards in a swimlane, it will be hidden. However, when we do render
    // columns and there is no ICC, placeholder or cards we want it to have a minimum
    // height to make it render in a cleaner fashion.
    const height = Math.max(defaultHeight, totalSize);
    const renderer = (0, $bQegf.useRowRenderer)({
        cardEntries: issueEntries,
        footer: footer,
        footerIndex: issueEntries.length,
        placeholder: placeholder,
        renderCard: renderCard,
        showFooter: showFooter
    });
    const style = (0, $5uXOq.useMemo)(()=>({
            minHeight: height,
            backgroundColor: (0, $g503o.columnThemes).default.background
        }), [
        height
    ]);
    const convertedName = name?.split(' ').join('-').toLowerCase() ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4f0f63c9193536a4$var$FastVirtualListWrapper, {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        ...(0, $co1wz.ff)('backlog-active-sprints-list-markup-accessibility-fix_imavd') && {
            'aria-labelledby': `platform-board-kit.ui.column-title-${convertedName}`
        },
        "data-testid": "software-board.board-container.board.virtual-board.fast-virtual-list.fast-virtual-list-wrapper"
    }, (0, $4R6GH.fg)('board_rendering_optimisations') ? rows.map((row)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4f0f63c9193536a4$var$CardRow, {
            ...row,
            key: row.key,
            offsetTop: offsetTop,
            isScrolling: isScrolling,
            Renderer: renderer
        })) : rows.map(({ index: index, top: top, forceRemeasure: forceRemeasure, measure: measure })=>renderer({
            index: index,
            isScrolling: isScrolling,
            forceRemeasure: forceRemeasure,
            measure: measure,
            offsetTop: top,
            style: {
                position: 'absolute',
                top: top - offsetTop,
                width: '100%',
                contain: 'style',
                ...(0, $co1wz.ff)('backlog-active-sprints-list-markup-accessibility-fix_imavd') && {
                    marginTop: '0px'
                }
            }
        })));
};
const $4f0f63c9193536a4$var$CardRow = ({ index: index, isScrolling: isScrolling, forceRemeasure: forceRemeasure, measure: measure, top: top, offsetTop: offsetTop, Renderer: Renderer })=>{
    const style = (0, $5uXOq.useMemo)(()=>({
            position: 'absolute',
            top: top - offsetTop,
            width: '100%',
            contain: 'style',
            ...(0, $co1wz.ff)('backlog-active-sprints-list-markup-accessibility-fix_imavd') && {
                marginTop: 0
            }
        }), [
        top,
        offsetTop
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Renderer, {
        index: index,
        isScrolling: isScrolling,
        forceRemeasure: forceRemeasure,
        measure: measure,
        offsetTop: top,
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
        style: style
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f0f63c9193536a4$var$FastVirtualListWrapperOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _18s81jus _njlpp9nq _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $4f0f63c9193536a4$var$FastVirtualListWrapperNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _18s81jus _njlpp9nq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw",
            __cmplp.className
        ])
    });
});
const $4f0f63c9193536a4$var$FastVirtualListWrapper = (0, $9QpK7.componentWithFF)('backlog-active-sprints-list-markup-accessibility-fix_imavd', $4f0f63c9193536a4$var$FastVirtualListWrapperNew, $4f0f63c9193536a4$var$FastVirtualListWrapperOld);

});
parcelRegister("g7BZG", function(module, exports) {

$parcel$export(module.exports, "useRemeasureOnResize", () => $249ff1189d8a41a0$export$b613f422d3967fcc);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $lFKmC = parcelRequire("lFKmC");

var $9Ik53 = parcelRequire("9Ik53");

var $4x4g5 = parcelRequire("4x4g5");
const $249ff1189d8a41a0$var$observerCount = new Map();
const $249ff1189d8a41a0$export$741acf1aabe74b99 = new Set();
const $249ff1189d8a41a0$export$62bdf76975b21c04 = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
    (0, $7nsd3.unstable_batchedUpdates)(()=>{
        $249ff1189d8a41a0$export$741acf1aabe74b99.forEach((remeasure)=>remeasure());
    });
}, 200);
const $249ff1189d8a41a0$var$resizeObserver = new (0, $4x4g5.RemeasureObserver)($249ff1189d8a41a0$export$62bdf76975b21c04);
function $249ff1189d8a41a0$export$b613f422d3967fcc({ rows: rows }) {
    const { scrollElement: scrollElement } = (0, $9Ik53.useScrollState)();
    (0, $5uXOq.useEffect)(()=>{
        if (!scrollElement) return undefined;
        const operations = rows.map((row)=>()=>row.forceRemeasure());
        operations.forEach((operation)=>{
            $249ff1189d8a41a0$export$741acf1aabe74b99.add(operation);
        });
        $249ff1189d8a41a0$var$resizeObserver.observe(scrollElement);
        $249ff1189d8a41a0$var$observerCount.set(scrollElement, ($249ff1189d8a41a0$var$observerCount.get(scrollElement) ?? 0) + 1);
        return ()=>{
            operations.forEach((operation)=>{
                $249ff1189d8a41a0$export$741acf1aabe74b99.delete(operation);
            });
            $249ff1189d8a41a0$var$observerCount.set(scrollElement, ($249ff1189d8a41a0$var$observerCount.get(scrollElement) ?? 0) - 1);
            const refCount = $249ff1189d8a41a0$var$observerCount.get(scrollElement) ?? 0;
            if (refCount <= 0) {
                $249ff1189d8a41a0$var$resizeObserver.unobserve(scrollElement);
                $249ff1189d8a41a0$var$observerCount.delete(scrollElement);
            }
        };
    }, [
        rows,
        scrollElement
    ]);
}

});
parcelRegister("4x4g5", function(module, exports) {

$parcel$export(module.exports, "RemeasureObserver", () => $84c7085ea2b075ea$export$7cd4445ae3acab20);
/**
 * Wrap resize observer for mocking on tests
 */ class $84c7085ea2b075ea$export$7cd4445ae3acab20 {
    constructor(callback){
        this.resizeObserver = null;
        if (typeof ResizeObserver !== 'undefined') this.resizeObserver = new ResizeObserver(callback);
    }
    observe(element) {
        this.resizeObserver?.observe(element);
    }
    unobserve(element) {
        this.resizeObserver?.unobserve(element);
    }
}

});


parcelRegister("htqkB", function(module, exports) {

$parcel$export(module.exports, "useAutoScrollCard", () => $e7fab663bec031c7$export$b61f82894f7693a4);

var $5uXOq = parcelRequire("5uXOq");

var $3eGwD = parcelRequire("3eGwD");

var $67sX6 = parcelRequire("67sX6");

var $d1i1b = parcelRequire("d1i1b");

var $9OPlz = parcelRequire("9OPlz");
const $e7fab663bec031c7$export$b61f82894f7693a4 = (issueEntries, scrollTo)=>{
    const autoScroll = (0, $67sX6.useBoardSelector)((0, $9OPlz.getCardAutoScroll));
    const dispatch = (0, $67sX6.useBoardDispatch)();
    (0, $5uXOq.useEffect)(()=>{
        const autoScrollIssueId = autoScroll?.issueId;
        if (!autoScrollIssueId) return;
        // NOTE: Auto scrolling to a subtask may not work as expected
        const issueIndex = issueEntries.findIndex((issueEntry)=>(0, $3eGwD.isIssueEntryGroup)(issueEntry) ? issueEntry.issueIds.includes(autoScrollIssueId) : issueEntry.issueId === autoScrollIssueId);
        if (issueIndex === -1) return;
        return scrollTo(issueIndex, {
            immediate: true,
            onComplete: ()=>dispatch((0, $d1i1b.cardAutoScroll)(null))
        });
    }, [
        autoScroll,
        dispatch,
        issueEntries,
        scrollTo
    ]);
};

});

parcelRegister("bfNGc", function(module, exports) {

$parcel$export(module.exports, "useRowCount", () => $ac1cfc1c897aa8a6$export$970871f1c0f66ab9);
const $ac1cfc1c897aa8a6$export$970871f1c0f66ab9 = ({ placeholder: placeholder, issues: issues })=>{
    const numberOfRows = issues.length + 1;
    // If we aren't provided with any rows, we want to render the placeholder. Just put the count as 1.
    if (numberOfRows === 0 && placeholder) return 1;
    return numberOfRows;
};

});

parcelRegister("5b8dQ", function(module, exports) {

$parcel$export(module.exports, "useScrollToUnscheduledColumnICC", () => $051cc55ef6160350$export$afd20280ad61fab9);

var $5uXOq = parcelRequire("5uXOq");

var $5rFbt = parcelRequire("5rFbt");

var $67sX6 = parcelRequire("67sX6");

var $d1i1b = parcelRequire("d1i1b");

var $9OPlz = parcelRequire("9OPlz");

var $67Z81 = parcelRequire("67Z81");
const $051cc55ef6160350$export$afd20280ad61fab9 = (columnId, swimlaneId, issueCount, scrollTo)=>{
    const isIncrementPlanningBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
    const autoScroll = (0, $67sX6.useBoardSelector)((0, $9OPlz.getCardAutoScroll));
    const autoScrollSwimlaneId = autoScroll?.unscheduledColumnSwimlaneId;
    const isImmediate = autoScroll?.isImmediate;
    const dispatch = (0, $67sX6.useBoardDispatch)();
    (0, $5uXOq.useEffect)(()=>{
        if (isIncrementPlanningBoard && autoScrollSwimlaneId && swimlaneId && columnId === (0, $5rFbt.UNSCHEDULED_COLUMN_ID) && swimlaneId === autoScrollSwimlaneId) scrollTo(issueCount, {
            immediate: isImmediate,
            hasVirtualisedChildren: true,
            onComplete: ()=>{
                dispatch((0, $d1i1b.cardAutoScrollUnscheduledColumnIcc)(null));
            }
        });
    }, [
        isIncrementPlanningBoard,
        autoScrollSwimlaneId,
        isImmediate,
        issueCount,
        scrollTo,
        columnId,
        swimlaneId,
        dispatch
    ]);
};

});


parcelRegister("7p3wz", function(module, exports) {

$parcel$export(module.exports, "default", () => $308e9ef4b82bad3f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $99gkn = parcelRequire("99gkn");


var $2Z6La = parcelRequire("2Z6La");

var $l8ruj = parcelRequire("l8ruj");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");

var $8FKBU = parcelRequire("8FKBU");

var $f8Y0z = parcelRequire("f8Y0z");
const $308e9ef4b82bad3f$var$Footer = ({ isLastSwimlane: isLastSwimlane, isInitialColumn: isInitialColumn, canShowIccNudge: canShowIccNudge, isColumnIccEnabled: isColumnIccEnabled, showDoneCardsButton: showDoneCardsButton, columnId: columnId, swimlaneId: swimlaneId, cardIndex: cardIndex, openInitialColumnIcc: openInitialColumnIcc, limitJql: limitJql })=>{
    const { initialProjectId: projectId } = (0, $2Z6La.useIccContext)();
    const isCompanyManaged = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsCMPBoard));
    if (!isColumnIccEnabled && !showDoneCardsButton) return null;
    const icc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f8Y0z.default), {
        showOnHover: !isInitialColumn,
        canShowIccNudge: canShowIccNudge,
        triggerAppearance: (0, $7462c685f739ed5a$export$dda6912361cddac9),
        columnId: columnId,
        swimlaneId: swimlaneId,
        cardIndex: cardIndex,
        // TODO-BOARD-REFACTOR-TYPES: should stay open is not a property you can pass in. It's calculated internally in the `mergeStateToProps`
        shouldStayOpen: openInitialColumnIcc,
        isLastSwimlane: isLastSwimlane,
        onChangeFormVisible: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        // TODO-BOARD-REFACTOR-TYPES
        // @ts-expect-error projectID expects number but it is number | null
        projectId: projectId,
        isFooter: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isColumnIccEnabled && (isInitialColumn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "icc-button-in-footer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
        data: {
            isCompanyManaged: isCompanyManaged
        }
    }), icc) : icc), showDoneCardsButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8FKBU.default), {
        limitJql: limitJql
    }));
};
var $308e9ef4b82bad3f$export$2e2bcd8739ae039 = $308e9ef4b82bad3f$var$Footer;

});
parcelRegister("8FKBU", function(module, exports) {

$parcel$export(module.exports, "default", () => $873e90b05562b927$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $hGgHi = parcelRequire("hGgHi");

var $5EjyB = parcelRequire("5EjyB");

var $bC2fB = parcelRequire("bC2fB");

var $hnvrw = parcelRequire("hnvrw");

var $e1q2I = parcelRequire("e1q2I");

var $67Z81 = parcelRequire("67Z81");
const $873e90b05562b927$export$987548e0054ee734 = (url)=>{
    const [path, jqlQuery] = url.split('?jql=');
    const encodedJqlQuery = encodeURIComponent(jqlQuery);
    return `${path}?jql=${encodedJqlQuery}`;
};
const $873e90b05562b927$export$c31df4bd766f9c35 = (state, ownProps)=>{
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    const { limitJql: limitJql } = ownProps;
    const getUrl = ()=>{
        if (isCMPBoard) {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(limitJql)) return $873e90b05562b927$export$987548e0054ee734(limitJql);
            return (0, $hnvrw.getOldIssuesUrl)((0, $67Z81.contextPathSelector)(state), (0, $67Z81.projectKeySelector)(state));
        }
        return (0, $hnvrw.getResolvedIssuesUrl)((0, $67Z81.contextPathSelector)(state), (0, $67Z81.projectKeySelector)(state));
    };
    return {
        url: getUrl(),
        isCMPBoard: isCMPBoard
    };
};
const $873e90b05562b927$var$connector = (0, $bC2fB.connect)($873e90b05562b927$export$c31df4bd766f9c35, (dispatch)=>({
        onClick: (0, $3f2cs.bindActionCreators)((0, $e1q2I.doneIssuesButtonClick), dispatch)
    }));
var $873e90b05562b927$export$2e2bcd8739ae039 = $873e90b05562b927$var$connector((0, $5EjyB.default));

});
parcelRegister("5EjyB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6d5fe5db4b4b3b7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $fVnbM = parcelRequire("fVnbM");

var $hyOJh = parcelRequire("hyOJh");

var $tvuR8 = parcelRequire("tvuR8");


var $3bDjY = parcelRequire("3bDjY");

var $gSExi = parcelRequire("gSExi");

var $6s1PB = parcelRequire("6s1PB");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $az4zD = parcelRequire("az4zD");

var $8zOmE = parcelRequire("8zOmE");

var $645AZ = parcelRequire("645AZ");

var $9Q22S = parcelRequire("9Q22S");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f6d5fe5db4b4b3b7$var$ContainerControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1l2p386-0"
})({
    textAlign: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `${(0, $645AZ.layout).gutter}px`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f6d5fe5db4b4b3b7$var$ContainerExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _1yt4u2gc",
            __cmplp.className
        ])
    });
});
const $f6d5fe5db4b4b3b7$var$Container = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $f6d5fe5db4b4b3b7$var$ContainerExperiment, $f6d5fe5db4b4b3b7$var$ContainerControl);
class $f6d5fe5db4b4b3b7$export$b1de088ebae9cb6c extends (0, $5uXOq.PureComponent) {
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onClick = (e, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'findClearedIssues');
            this.props.onClick();
        };
        this.renderButton = (intl)=>{
            const oldIssuesSearchLink = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9Q22S.default).oldIssuesSearchLinkIssueTermRefresh : (0, $9Q22S.default).oldIssuesSearchLink;
            const findDoneClearedCardsLink = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9Q22S.default).findDoneClearedCardsLinkIssueTermRefresh : (0, $9Q22S.default).findDoneClearedCardsLink;
            const message = intl.formatMessage(this.props.isCMPBoard ? oldIssuesSearchLink : findDoneClearedCardsLink);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "subtle",
                spacing: "compact",
                href: this.props.url,
                onClick: this.onClick,
                iconBefore: (0, $4R6GH.fg)('tnk-1614-visual-refresh-boardkit-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyOJh))), {
                    label: "",
                    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N400})`,
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($tvuR8))),
                    LEGACY_size: "small"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvuR8))), {
                    label: "",
                    size: "small"
                })
            }, message);
        };
        this.render = ()=>{
            const { intl: intl } = this.props;
            const oldIssuesSearchMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9Q22S.default).oldIssuesSearchMessageIssueTermRefresh : (0, $9Q22S.default).oldIssuesSearchMessage;
            const doneClearedCardsTooltip = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9Q22S.default).doneClearedCardsTooltipIssueTermRefresh : (0, $9Q22S.default).doneClearedCardsTooltip;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f6d5fe5db4b4b3b7$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: intl.formatMessage(this.props.isCMPBoard ? oldIssuesSearchMessage : doneClearedCardsTooltip)
            }, this.renderButton(intl)));
        };
    }
}
var $f6d5fe5db4b4b3b7$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($f6d5fe5db4b4b3b7$export$b1de088ebae9cb6c);

});
parcelRegister("9Q22S", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbaaa5f719e5fa57$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dbaaa5f719e5fa57$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    findDoneClearedCardsLink: {
        "id": "platform-board-kit.card.done-cards-button.find-done-cleared-cards-link",
        "defaultMessage": "See all Done issues"
    },
    doneClearedCardsTooltip: {
        "id": "platform-board-kit.card.done-cards-button.done-cleared-cards-tooltip",
        "defaultMessage": "Done issues cleared from the board can be viewed here."
    },
    oldIssuesSearchLink: {
        "id": "platform-board-kit.card.done-cards-button.old-issues-search-link",
        "defaultMessage": "See older issues"
    },
    oldIssuesSearchMessage: {
        "id": "platform-board-kit.card.done-cards-button.old-issues-search-message",
        "defaultMessage": "View older issues that have been cleared from the board"
    },
    findDoneClearedCardsLinkIssueTermRefresh: {
        "id": "platform-board-kit.card.done-cards-button.find-done-cleared-cards-link-issue-term-refresh",
        "defaultMessage": "See all Done issues"
    },
    doneClearedCardsTooltipIssueTermRefresh: {
        "id": "platform-board-kit.card.done-cards-button.done-cleared-cards-tooltip-issue-term-refresh",
        "defaultMessage": "Done issues cleared from the board can be viewed here."
    },
    oldIssuesSearchLinkIssueTermRefresh: {
        "id": "platform-board-kit.card.done-cards-button.old-issues-search-link-issue-term-refresh",
        "defaultMessage": "See older issues"
    },
    oldIssuesSearchMessageIssueTermRefresh: {
        "id": "platform-board-kit.card.done-cards-button.old-issues-search-message-issue-term-refresh",
        "defaultMessage": "View older issues that have been cleared from the board"
    }
});

});






parcelRegister("aanra", function(module, exports) {

$parcel$export(module.exports, "useSetViewModeFromLocalStorage", () => $2713765183b57c29$export$2ed50744becdad7d);

var $5uXOq = parcelRequire("5uXOq");

var $2gCtH = parcelRequire("2gCtH");

var $3eGwD = parcelRequire("3eGwD");
const $2713765183b57c29$export$2ed50744becdad7d = ()=>{
    const [, { setDetailViewAsModal: setDetailViewAsModal }] = (0, $2gCtH.useIssueContextActions)();
    const localStorageViewMode = (0, $3eGwD.getBoardDetailViewMode)();
    const viewMode = (0, $2gCtH.useViewMode)();
    (0, $5uXOq.useEffect)(()=>{
        if (localStorageViewMode === 'MODAL') setDetailViewAsModal();
    }, [
        localStorageViewMode,
        setDetailViewAsModal
    ]);
    // Sync the localStorage value with viewMode from jira-issue-context-service (the source of truth).
    (0, $5uXOq.useEffect)(()=>{
        if (viewMode && viewMode !== localStorageViewMode) (0, $3eGwD.setBoardDetailViewMode)(viewMode);
    }, [
        localStorageViewMode,
        viewMode
    ]);
};

});


parcelRegister("hASys", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3a9b932b2e638b8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $basmW = parcelRequire("basmW");

var $hGgHi = parcelRequire("hGgHi");

var $gJBT6 = parcelRequire("gJBT6");

var $8QpSo = parcelRequire("8QpSo");

var $lLtod = parcelRequire("lLtod");

var $c781K = parcelRequire("c781K");

var $h8cgU = parcelRequire("h8cgU");

var $lj8SI = parcelRequire("lj8SI");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $dOvpK = parcelRequire("dOvpK");

var $5rFbt = parcelRequire("5rFbt");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $az4zD = parcelRequire("az4zD");

var $eQFsF = parcelRequire("eQFsF");

var $4jAPy = parcelRequire("4jAPy");

var $1FeOe = parcelRequire("1FeOe");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");

var $bC2fB = parcelRequire("bC2fB");

var $kgiLc = parcelRequire("kgiLc");

var $iuuJH = parcelRequire("iuuJH");

var $c79wa = parcelRequire("c79wa");

var $dW1HX = parcelRequire("dW1HX");

var $k50Aq = parcelRequire("k50Aq");

var $1vXOx = parcelRequire("1vXOx");

var $fyeGd = parcelRequire("fyeGd");

var $bSSdD = parcelRequire("bSSdD");

var $d2i8f = parcelRequire("d2i8f");

var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $5mTgl = parcelRequire("5mTgl");

var $2FiSG = parcelRequire("2FiSG");

var $7xi98 = parcelRequire("7xi98");
const $b3a9b932b2e638b8$var$getExternalValues = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((boardId, projectId)=>({
        boardId: boardId,
        projectId: projectId
    }), (boardId, projectId)=>`${boardId}.${projectId}`);
const $b3a9b932b2e638b8$var$getIcon = (isCMPBoard, swimlaneMode, imageUrl)=>{
    if (!imageUrl) return null;
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE).id || swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST).id) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLtod.default), {
        size: "small",
        src: imageUrl,
        name: ""
    });
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id || swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3a9b932b2e638b8$var$IssueTypeIcon, {
        src: imageUrl,
        alt: ""
    });
    if (isCMPBoard && swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PROJECT).id) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3a9b932b2e638b8$var$ProjectIcon, {
        src: imageUrl,
        alt: ""
    });
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_REQUEST_TYPE).id) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3a9b932b2e638b8$var$RequestTypeIcon, {
        src: imageUrl,
        alt: ""
    });
    return null;
}; /**
    * Get team icon for increment planning board
    * @param imageUrl team avatar URL
    * @param name team name
    * @returns
    */ 
const $b3a9b932b2e638b8$var$getTeamIcon = (imageUrl, name)=>{
    if (imageUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLtod.default), {
        size: "small",
        src: imageUrl,
        name: (0, $4R6GH.fg)('ip_remove_aria_labels_for_decorative_images') ? undefined : name || ''
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3a9b932b2e638b8$var$PeopleIconWrapper, null, (0, $4R6GH.fg)('enghealth-12479-jsw-board-visual-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c781K))), {
        label: (0, $4R6GH.fg)('ip_remove_aria_labels_for_decorative_images') ? '' : name || '',
        LEGACY_size: "small",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($h8cgU))),
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h8cgU))), {
        label: name || '',
        size: "small"
    }));
}; /**
    * Get team lozenge for increment planning board
    * @param intl
    * @param isExternal if it's team not included in Advanced Roadmaps plan
    * @param isPlanOnly if it's team only exist in Advanced Roadmaps plan, ie doesn't exist in Teams in Jira
    * @param isTeamLessSwimlane if it's a swimlane for issues with no team
    * @returns
    */ 
const $b3a9b932b2e638b8$var$getTeamLozenge = (intl, isExternal, isPlanOnly, isTeamLessSwimlane, isKanban)=>{
    const lozengeContents = {
        external: {
            lozenge: (0, $1FeOe.default).externalLozenge,
            tooltipTitle: (0, $1FeOe.default).externalTeamTooltipTitle,
            tooltipContent: (0, $1FeOe.default).externalTeamTooltipContent,
            testId: 'software-board.board-container.board.swimlane.external'
        },
        planOnly: {
            lozenge: (0, $1FeOe.default).planOnlyLozenge,
            tooltipTitle: (0, $1FeOe.default).planOnlyTeamTooltipTitle,
            tooltipContent: (0, $1FeOe.default).planOnlyTeamTooltipContent,
            testId: 'software-board.board-container.board.swimlane.plan-only'
        },
        kanban: {
            lozenge: (0, $1FeOe.default).kanbanLozenge,
            tooltipTitle: undefined,
            tooltipContent: undefined,
            testId: 'software-board.board-container.board.swimlane.kanban'
        }
    };
    let lozengeContent;
    if (isExternal) lozengeContent = lozengeContents.external;
    else if (isKanban) lozengeContent = lozengeContents.kanban;
    else if (isPlanOnly && !isTeamLessSwimlane) lozengeContent = lozengeContents.planOnly;
    if (lozengeContent) {
        const { tooltipTitle: tooltipTitle, tooltipContent: tooltipContent, lozenge: lozenge, testId: testId } = lozengeContent;
        const lozengeComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
            testId: testId
        }, intl.formatMessage(lozenge));
        if (tooltipTitle && tooltipContent) {
            const tooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                padding: "space.100",
                xcss: $b3a9b932b2e638b8$var$teamTooltipStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "p",
                color: "inherit"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "strong"
            }, intl.formatMessage(tooltipTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "p"
            }, intl.formatMessage(tooltipContent))));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: tooltip
            }, lozengeComponent);
        }
        return lozengeComponent;
    }
    return null;
};
const $b3a9b932b2e638b8$var$SPOTLIGHT_TARGET_ID = 'board-swimlane-header';
const $b3a9b932b2e638b8$export$daa269000985481c = (message, intl, swimlaneMode, state)=>{
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id) return intl.formatMessage(message, {
        issueParentTypeName: (0, $bSSdD.firstParentIssueTypeNameSelector)(state)
    });
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return intl.formatMessage(message);
    return intl.formatMessage(message);
};
const $b3a9b932b2e638b8$export$3b1d11829730098 = (state, mode, issueId)=>{
    if (mode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id) {
        const swimlaneHeaderIssue = (0, $bSSdD.getIssueParents)(state)[issueId];
        return swimlaneHeaderIssue && swimlaneHeaderIssue.status ? swimlaneHeaderIssue.status : null;
    } // In CMP Kanplan, in a case of parent task in plan board but its subtasks in kanban board
    // when grouping by stories, swimlane header should look up in the the parent tasks (aka missing parent)
    if ((0, $67Z81.getIsCMPBoard)(state) && mode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) {
        const swimlaneHeaderMissingParent = (0, $67Z81.getMissingParents)(state)[Number(issueId)];
        if (swimlaneHeaderMissingParent) return swimlaneHeaderMissingParent.status;
    }
    const swimlaneHeaderIssue = (0, $67Z81.getIssues)(state)[issueId]; // Fetch the column that contains the given statusId
    const swimlaneHeaderIssueColumn = swimlaneHeaderIssue && swimlaneHeaderIssue.statusId ? // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
    (0, $fyeGd.columnByStatusIdSelector)(state, swimlaneHeaderIssue.statusId) : null; // Get the status for the swimlane header issue
    return (swimlaneHeaderIssueColumn && swimlaneHeaderIssueColumn.type === (0, $5rFbt.ColumnType).STATUS ? swimlaneHeaderIssueColumn.statuses : []).find((status)=>swimlaneHeaderIssue && status.id === swimlaneHeaderIssue.statusId) || null;
};
const $b3a9b932b2e638b8$export$280bd66a9186f8d5 = (swimlaneId, mode, intl)=>{
    if (mode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && swimlaneId === (0, $iuuJH.SWIMLANE_CHILDLESS)) return intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7xi98.default).childlessTooltipIssueTermRefresh : (0, $7xi98.default).childlessTooltip);
    return null;
};
const $b3a9b932b2e638b8$export$c31df4bd766f9c35 = ()=>{
    // memoization is used instead of weak map due to keys being potentially null
    const getIconFactory = (0, $8QpSo.default)((isIncrementPlanningBoard, swimlaneMode, imageUrl, name, isCMPBoard)=>isIncrementPlanningBoard && swimlaneMode === (0, $iuuJH.SWIMLANE_BY_TEAM).id ? $b3a9b932b2e638b8$var$getTeamIcon(imageUrl, name) : $b3a9b932b2e638b8$var$getIcon(isCMPBoard, swimlaneMode, imageUrl));
    const getTeamLozengeFactory = (0, $8QpSo.default)((isIncrementPlanningBoard, values, intl, id)=>isIncrementPlanningBoard && values && values.type === (0, $c79wa.TEAM) ? $b3a9b932b2e638b8$var$getTeamLozenge(intl, !values.isPlanTeam, (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(values.externalId), id === (0, $4jAPy.SWIMLANE_TEAMLESS) || id === (0, $kgiLc.appendUnscheduledWorkSwimlaneIdSuffix)((0, $4jAPy.SWIMLANE_TEAMLESS)), values.planningStyle === (0, $4jAPy.KANBAN_TEAM)) : null);
    const customLeftContentFactory = (0, $8QpSo.default)((isIncrementPlanningBoard, id, isIncrementPlanningBoardReadOnly, isUnscheduledWorkColumnPanel)=>{
        return !isUnscheduledWorkColumnPanel && isIncrementPlanningBoard && !isIncrementPlanningBoardReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2FiSG.default), {
            teamId: id
        });
    });
    const issueParentFactory = (0, $8QpSo.default)((issueParent)=>issueParent ? {
            summary: issueParent.summary,
            color: issueParent.color
        } : null);
    const assigneeFactory = (0, $8QpSo.default)((assignee)=>assignee ? {
            avatarUrl: assignee.avatarUrl,
            name: assignee.displayName
        } : null);
    return (state, ownProps)=>{
        const { intl: intl, isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel } = ownProps;
        const swimlaneId = (0, $kgiLc.truncateUnscheduledWorkSwimlaneId)(ownProps.id, isUnscheduledWorkColumnPanel);
        const { imageUrl: imageUrl, name: name, message: message, cardAmount: cardAmount, issueKey: issueKey, mode: mode, assigneeAccountId: assigneeAccountId, projectKey: projectKey, isFlagged: isFlagged, values: values } = (0, $5mTgl.platformSwimlaneSelector)(state)(swimlaneId) || {};
        const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
        const isSwimlaneHeaderClickable = mode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id || mode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id || mode === (0, $iuuJH.SWIMLANE_BY_PROJECT).id;
        const issuesWithoutSwimlaneHeaderName = message ? $b3a9b932b2e638b8$export$daa269000985481c(message, intl, swimlaneMode, state) : null;
        const getParent = (0, $5mTgl.makeGetIssueParentForSwimlaneHeader)(state);
        const issueParent = getParent(ownProps.id);
        const assignee = mode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && assigneeAccountId ? (0, $36pz7.getPerson)(state, assigneeAccountId) : null;
        const issueStatus = $b3a9b932b2e638b8$export$3b1d11829730098(state, mode, ownProps.id);
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state); // isDone here is used by the Swimlane component to show issue key strikethrough i.e. indicate issue resolution.
        // Moving away from `isSwimlaneBySubtaskParentDoneSelector` as it's very specific to covering all the edge cases required to correctly show the "Move to Done" button. It incorrectly strikethroughs issues when the issue is not resolved.
        // This change will also strikethrough here correctly for TMP (which previously we weren't doing at all).
        const isDone = (0, $d2i8f.isDoneIssueSelector)(state)(ownProps.id);
        const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        const isIncrementPlanningBoardReadOnly = (0, $1vXOx.isIncrementPlanningReadOnly)(state); // Get team icon on increment planning board and swimlaneMode is SWIMLANE_BY_TEAM
        const icon = getIconFactory(isIncrementPlanningBoard, swimlaneMode, imageUrl, name, isCMPBoard); // Get team lozenge on increment planning board
        const lozenge = getTeamLozengeFactory(isIncrementPlanningBoard, values, intl, ownProps.id);
        return {
            icon: icon,
            spotlightTargetId: ownProps.isFirstSwimlane && mode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id ? $b3a9b932b2e638b8$var$SPOTLIGHT_TARGET_ID : '',
            name: name || issuesWithoutSwimlaneHeaderName,
            // Don't show card amount for increment planning board
            showCardAmount: !isIncrementPlanningBoard,
            cardAmount: cardAmount,
            issueKey: issueKey,
            issueStatus: issueStatus,
            isSwimlaneHeaderClickable: isSwimlaneHeaderClickable,
            collapsed: (0, $4jZ56.isSwimlaneCollapsed)(state, ownProps.id),
            externalId: 'software.board.swimlane',
            externalValues: $b3a9b932b2e638b8$var$getExternalValues((0, $67Z81.rapidViewIdSelector)(state), (0, $67Z81.projectIdSelector)(state)),
            swimlaneMode: swimlaneMode,
            issueParent: issueParentFactory(issueParent),
            assignee: assigneeFactory(assignee),
            summaryTooltip: $b3a9b932b2e638b8$export$280bd66a9186f8d5(ownProps.id, swimlaneMode, intl),
            isSubtask: swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && ownProps.id !== (0, $c79wa.ChildlessSwimlane).id,
            link: isCMPBoard && swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PROJECT).id && projectKey ? `/browse/${projectKey}` : undefined,
            projectKey: projectKey,
            isFlagged: isFlagged,
            isDone: isDone,
            lozenge: lozenge,
            customLeftContent: customLeftContentFactory(isIncrementPlanningBoard, ownProps.id, isIncrementPlanningBoardReadOnly, ownProps.isUnscheduledWorkColumnPanel),
            customRightContent: ownProps.customRightContent
        };
    };
};
const $b3a9b932b2e638b8$var$mapDispatchToProps = {
    swimlaneToggle: $k50Aq.swimlaneToggle,
    openIssueModal: $dW1HX.openIssueModal
};
const $b3a9b932b2e638b8$var$onClickFactory = (0, $8QpSo.default)((issueKey, dispatchPropsOpenIssueModal, swimlaneMode)=>(analyticsEvent)=>{
        if (issueKey) dispatchPropsOpenIssueModal(issueKey);
        (0, $dOvpK.fireUiAnalytics)(analyticsEvent, {
            name: 'board',
            attributes: {
                swimlaneMode: swimlaneMode
            }
        });
    });
const $b3a9b932b2e638b8$var$onToggleFactory = (0, $8QpSo.default)((dispatchPropsWwimlaneToggle, id)=>(event, analyticsEvent)=>{
        dispatchPropsWwimlaneToggle(id);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'boardSwimlaneBar');
    });
const $b3a9b932b2e638b8$export$9d1611c77c2fe928 = (stateProps, dispatchProps, ownProps)=>({
        children: ownProps.children,
        wrapperStyle: ownProps.wrapperStyle,
        innerRef: ownProps.innerRef,
        hasShadow: ownProps.hasShadow,
        ...stateProps,
        onClick: $b3a9b932b2e638b8$var$onClickFactory(stateProps.issueKey, dispatchProps.openIssueModal, stateProps.swimlaneMode),
        onToggle: $b3a9b932b2e638b8$var$onToggleFactory(dispatchProps.swimlaneToggle, ownProps.id),
        isUnscheduledWorkColumnPanel: ownProps.isUnscheduledWorkColumnPanel
    });
var $b3a9b932b2e638b8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $2OMDV.AnalyticsEventToProps)('swimlaneBar', {
    onToggle: 'toggled'
}), (0, $bC2fB.connect)($b3a9b932b2e638b8$export$c31df4bd766f9c35, $b3a9b932b2e638b8$var$mapDispatchToProps, $b3a9b932b2e638b8$export$9d1611c77c2fe928), (0, $az4zD.injectIntlV2))((0, $eQFsF.default));
const $b3a9b932b2e638b8$var$IssueTypeIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_s7n4nkob _4t3i1k92",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a9b932b2e638b8$var$ProjectIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_s7n4nkob _2rko1l7b _1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a9b932b2e638b8$var$PeopleIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _1yt4u49m _bfhklecj _18s81nxw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a9b932b2e638b8$var$RequestTypeIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_s7n4nkob _4t3if6fq",
            __cmplp.className
        ])
    });
});
const $b3a9b932b2e638b8$var$teamTooltipStyles = (0, $8CUq3.xcss)({
    textAlign: 'center'
});

});
parcelRegister("eQFsF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cb655d4a4e9962b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $hGgHi = parcelRequire("hGgHi");

var $8Rkzz = parcelRequire("8Rkzz");

var $jZ4fr = parcelRequire("jZ4fr");

var $fW62l = parcelRequire("fW62l");

var $lLtod = parcelRequire("lLtod");

var $9ADwJ = parcelRequire("9ADwJ");

var $6Ingq = parcelRequire("6Ingq");

var $ebd3R = parcelRequire("ebd3R");

var $iyN9w = parcelRequire("iyN9w");

var $hORKG = parcelRequire("hORKG");

var $3dGN0 = parcelRequire("3dGN0");

var $lj8SI = parcelRequire("lj8SI");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");


var $3bDjY = parcelRequire("3bDjY");

var $dqoiX = parcelRequire("dqoiX");

var $8oe80 = parcelRequire("8oe80");

var $gULOk = parcelRequire("gULOk");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $az4zD = parcelRequire("az4zD");

var $kFsv3 = parcelRequire("kFsv3");

var $iHPnC = parcelRequire("iHPnC");

var $k3Hho = parcelRequire("k3Hho");

var $dCm1o = parcelRequire("dCm1o");

var $dIdda = parcelRequire("dIdda");

var $645AZ = parcelRequire("645AZ");

var $agZSd = parcelRequire("agZSd");

var $ijnF0 = parcelRequire("ijnF0");

var $eF5Y9 = parcelRequire("eF5Y9");

var $04c3l = parcelRequire("04c3l");
const $4cb655d4a4e9962b$var$AVATAR_BORDER_COLOR = 'transparent';
const $4cb655d4a4e9962b$var$LOZENGE_THEMES = (0, $iHPnC.transformColorToTheme)((colorSchema)=>colorSchema.textBackground);
const $4cb655d4a4e9962b$var$getLozengeThemeByColor = (color)=>// This uses schema from src/packages/issue/epic-color/src/common/constants.js
    $4cb655d4a4e9962b$var$LOZENGE_THEMES[color] || $4cb655d4a4e9962b$var$LOZENGE_THEMES[0, $kFsv3.PURPLE]; // eslint-disable-next-line jira/react/no-class-components
class $4cb655d4a4e9962b$var$Swimlane extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            issueKey: null,
            issueParent: null,
            issueStatus: null,
            isSwimlaneHeaderClickable: false,
            collapsed: false,
            spotlightTargetId: '',
            assignee: null,
            icon: null,
            customSwimlaneContent: null,
            customRightContent: null,
            summaryTooltip: null,
            onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            isSubtask: false,
            link: undefined,
            projectKey: undefined,
            isFlagged: false,
            isDone: false,
            wrapperStyles: {},
            lozenge: null,
            showCardAmount: true,
            hasShadow: true,
            isUnscheduledWorkColumnPanel: false
        };
    }
    getSwimlaneContent() {
        const { intl: { formatMessage: formatMessage }, showCardAmount: showCardAmount, cardAmount: cardAmount, icon: icon, name: name, collapsed: collapsed, isSwimlaneHeaderClickable: isSwimlaneHeaderClickable, issueKey: issueKey, issueParent: issueParent, issueStatus: issueStatus, assignee: assignee, customSwimlaneContent: customSwimlaneContent, summaryTooltip: summaryTooltip, isSubtask: isSubtask, link: link, projectKey: projectKey, isFlagged: isFlagged, isDone: isDone, lozenge: lozenge, swimlaneMode: swimlaneMode, customLeftContent: customLeftContent } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(customSwimlaneContent)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, customSwimlaneContent);
        const issueCountMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eF5Y9.default).issueCountIssueTermRefresh : (0, $eF5Y9.default).issueCount;
        const cardsAmountLabel = showCardAmount ? formatMessage(isSubtask ? (0, $eF5Y9.default).subtaskCount : issueCountMessage, {
            count: cardAmount || 0
        }) : null;
        const summary = projectKey ? `${name} (${projectKey})` : name;
        const headerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            gap: "space.100",
            alignItems: "center",
            xcss: $4cb655d4a4e9962b$var$headerContentStyles
        }, (icon || issueParent && swimlaneMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center",
            gap: "space.050"
        }, icon, issueParent && swimlaneMode === 'SWIMLANE_BY_PARENT_ISSUE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: issueParent.summary
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$ColorBox, {
            color: $4cb655d4a4e9962b$var$getLozengeThemeByColor(issueParent.color)
        }))), issueKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3Hho.CardKey), {
            text: issueKey,
            stopEventPropagation: false,
            isDone: isDone
        }), summaryTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: summaryTooltip,
            "data-testid": "platform-board-kit.ui.swimlane.tooltip"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$SummarySection, {
            "data-testid": "platform-board-kit.ui.swimlane.summary-section"
        }, summary)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $04c3l.TruncatedTooltip), {
            content: summary
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$SummarySection, {
                ref: ref,
                "data-testid": "platform-board-kit.ui.swimlane.summary-section"
            }, summary)), lozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$LozengeWrapper, null, lozenge), customLeftContent, showCardAmount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$SwimlaneIssuesAmount, null, `(${cardsAmountLabel})`), swimlaneMode !== 'SWIMLANE_BY_PARENT_ISSUE' && issueParent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijnF0.default), {
            color: issueParent.color
        }, issueParent.summary), issueStatus && (issueStatus.name || '').toString().length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$StatusSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), null, formatMessage((0, $eF5Y9.default).statusLozenge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: issueStatus.name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
            appearance: (0, $agZSd.getLozengeAppearanceByStatus)(issueStatus && issueStatus.category ? issueStatus.category : (0, $gULOk.UNDEFINED)),
            testId: "platform-board-kit.ui.swimlane.lozenge"
        }, issueStatus.name))), isFlagged && ((0, $4R6GH.fg)('tnk-1614-visual-refresh-boardkit-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9ADwJ))), {
            label: formatMessage((0, $eF5Y9.default).flagged),
            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($iyN9w))),
            LEGACY_primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
            LEGACY_size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iyN9w))), {
            label: formatMessage((0, $eF5Y9.default).flagged),
            primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
            size: "small"
        })), assignee && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: assignee.name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLtod.default), {
            src: assignee.avatarUrl,
            name: assignee.name,
            size: "small",
            borderColor: $4cb655d4a4e9962b$var$AVATAR_BORDER_COLOR
        }))));
        const renderHeader = ()=>{
            if (isSwimlaneHeaderClickable) {
                if (issueKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$LinkButtonWithAnalytics, {
                    "data-testid": "platform-board-kit.ui.swimlane.link-button",
                    onClick: this.onLinkClick,
                    onKeyDown: this.onSwimlaneHeaderKeyDown
                }, headerContent);
                if (link) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$LinkWithAnalytics, {
                    href: link,
                    onClick: this.onLinkClick,
                    onKeyDown: this.onSwimlaneHeaderKeyDown
                }, headerContent);
            }
            return headerContent;
        };
        const renderChevronIcon = ()=>{
            if (collapsed) return (0, $4R6GH.fg)('tnk-1614-visual-refresh-boardkit-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: (0, $dCm1o.isVisualRefreshEnabled)() && $4cb655d4a4e9962b$var$iconSpacing
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R))),
                LEGACY_primaryColor: "var(--ds-icon, #44546F)",
                color: "var(--ds-icon, #44546F)",
                label: ""
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebd3R))), {
                primaryColor: "var(--ds-icon, #44546F)",
                label: ""
            });
            return (0, $4R6GH.fg)('tnk-1614-visual-refresh-boardkit-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: (0, $dCm1o.isVisualRefreshEnabled)() && $4cb655d4a4e9962b$var$iconSpacing
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))),
                LEGACY_primaryColor: "var(--ds-icon, #44546F)",
                color: "var(--ds-icon, #44546F)",
                label: ""
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))), {
                primaryColor: "var(--ds-icon, #44546F)",
                label: ""
            });
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$SwimlaneContent, {
            "data-testid": "platform-board-kit.ui.swimlane.swimlane-content",
            role: "button" // @ts-expect-error Type '(event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type 'MouseEventHandler<HTMLDivElement>'.
            ,
            onClick: this.toggleColumns,
            tabIndex: 0,
            onKeyDown: this.onKeyDown,
            "aria-expanded": !collapsed
        }, renderChevronIcon(), renderHeader());
    }
    render() {
        const { children: children, collapsed: collapsed, wrapperStyle: wrapperStyle, innerRef: innerRef, hasShadow: hasShadow } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "platform-board-kit.ui.swimlane.swimlane-wrapper" // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ,
            style: wrapperStyle,
            ref: innerRef
        }, hasShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$SwimlaneShadow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$SwimlaneShadowMask, null)), this.renderSwimlaneBar(), !collapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            testId: "platform-board-kit.ui.swimlane.swimlane-columns"
        }, children));
    }
    constructor(...args){
        super(...args);
        this.onKeyDown = (event, analyticsEvent)=>{
            if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter') || event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('space')) {
                event.preventDefault();
                this.props.onToggle(analyticsEvent);
            }
        };
        this.onSwimlaneHeaderKeyDown = (event, analyticsEvent)=>{
            if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter') || event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('space')) {
                event.preventDefault();
                this.onLinkClick(event, analyticsEvent);
            }
        };
        this.onLinkClick = (e, analyticsEvent)=>{
            e.stopPropagation();
            this.props.onClick(analyticsEvent);
        };
        this.toggleColumns = (event, analyticsEvent)=>{
            this.props.onToggle(analyticsEvent);
        };
        this.renderSwimlaneInner = ()=>{
            const { isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel, spotlightTargetId: spotlightTargetId, customRightContent: customRightContent } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: [
                    $4cb655d4a4e9962b$var$SwimlaneInnerFullWidthStyles,
                    isUnscheduledWorkColumnPanel && $4cb655d4a4e9962b$var$SwimlaneInnerSingleColumnSizedStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
                name: spotlightTargetId
            }, this.getSwimlaneContent()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
                engagementId: spotlightTargetId
            }), Boolean(customRightContent) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$SwimlaneRightContentContainer, null, customRightContent));
        };
        this.renderSwimlaneBar = ()=>{
            const { isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, $bwpsq.default)([
                    "_1e0c1txw _4cvr1h6o _80omtlke _11q7vuon _2rko1l7b _kqsw1if8 _1pbycs5v _ca0qv77o _4t3i10mc _19pk1i6y _otyrv77o _154i1ylp _7ehi2jkb _nt751r31 _49pcglyw _1hvw1o36",
                    isUnscheduledWorkColumnPanel && "_154i1wqb"
                ])
            }, this.renderSwimlaneInner());
        };
    }
}
var $4cb655d4a4e9962b$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($4cb655d4a4e9962b$var$Swimlane);
const $4cb655d4a4e9962b$var$swimlaneShadowSize = 2;
const $4cb655d4a4e9962b$var$headerHeight = (0, $645AZ.swimlaneHeaderHeight); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$SwimlaneContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _4cvr1h6o _18u0v77o _p12f1osq",
            __cmplp.className
        ])
    });
});
const $4cb655d4a4e9962b$var$SwimlaneInnerSingleColumnSizedStyles = (0, $8CUq3.xcss)({
    minWidth: '100%',
    maxWidth: '100%'
});
const $4cb655d4a4e9962b$var$SwimlaneInnerFullWidthStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    flex: 1,
    // So things dont overlap on smaller screens
    minWidth: '700px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `min(100%, calc(var(--board-scroll-element-width, 2000) * 1px - ${(0, $645AZ.layout).boardBorderWidth}px))`
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$SwimlaneShadow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _11q71wdb _tzy4sxj9 _4t3iyh40 _kqsw1if8 _154iys9h _1pbycs5v _lcxvglyw _19pkidpf _2hwxi2wt _otyridpf _18u0i2wt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$SwimlaneShadowMask = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _11q7vuon _4t3iyh40 _kqswh2mm _154i1ylp _1pbycs5v _lcxvglyw _18s81v4c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$AvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1f4h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$SwimlaneIssuesAmount = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8qk37 _syaz1n3s",
            __cmplp.className
        ])
    });
});
const $4cb655d4a4e9962b$var$swimlaneBarStyles = null;
const $4cb655d4a4e9962b$var$swimlaneBarUnscheduledColumnStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$LinkButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7glyw _19itglyw _1yt41c8u _11c81kw7 _80omtlke _1ul9idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$Link = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $dIdda.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7glyw _19itglyw _1yt41c8u _11c81kw7 _80omtlke _4bfu18uv _9oik18uv _1hmsglyw _1bnxglyw _ajmmnqa1 _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$SummarySection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$StatusSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _13t37vkz _11ko1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$SwimlaneRightContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _1yt41c8u",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$LozengeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $4cb655d4a4e9962b$var$LinkButtonWithAnalytics = (0, $8oe80.default)('swimlaneHeader', {
    onClick: 'clicked'
})($4cb655d4a4e9962b$var$LinkButton);
const $4cb655d4a4e9962b$var$LinkWithAnalytics = (0, $8oe80.default)('swimlaneHeader', {
    onClick: 'clicked'
})($4cb655d4a4e9962b$var$Link); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$ColorBox = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhk1cj8 _1bsb1k92 _4t3i1k92 _2rko1hkb",
            __cmplp.className
        ])
    });
});
const $4cb655d4a4e9962b$var$headerContentStyles = (0, $8CUq3.xcss)({
    minWidth: '0'
});
const $4cb655d4a4e9962b$var$iconSpacing = (0, $8CUq3.xcss)({
    margin: 'space.050'
});

});
parcelRegister("fW62l", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});

parcelRegister("9ADwJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a2f79b68f83f7bee45defc51e10a7e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6fb6230d529aad86$var$_react = $6fb6230d529aad86$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6fb6230d529aad86$var$_UNSAFE_baseNew = $6fb6230d529aad86$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $6fb6230d529aad86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "FlagFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: active feature flags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6fb6230d529aad86$var$FlagFilledIcon = (props)=>/*#__PURE__*/ $6fb6230d529aad86$var$_react.default.createElement($6fb6230d529aad86$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14 1.75H2.75v8H14l-3-4z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.75 15V9.75m0 0v-8H14l-3 4 3 4z"/>`
    }, props));
$6fb6230d529aad86$var$FlagFilledIcon.displayName = 'FlagFilledIcon';
var $6fb6230d529aad86$var$_default = module.exports.default = $6fb6230d529aad86$var$FlagFilledIcon;

});

parcelRegister("iyN9w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d83187a0eb7b20f4$var$_react = $d83187a0eb7b20f4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d83187a0eb7b20f4$var$_flagFilled = $d83187a0eb7b20f4$var$_interopRequireDefault((parcelRequire("9ADwJ")));
function $d83187a0eb7b20f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d83187a0eb7b20f4$var$FlagFilledIcon = (props)=>/*#__PURE__*/ $d83187a0eb7b20f4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.7 5.7 0 0 0 2.547-.567 1 1 0 0 0 .563-.9V5.466a.998.998 0 0 0-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 0 0 6 5.466z"/></svg>`
    }, props, {
        newIcon: $d83187a0eb7b20f4$var$_flagFilled.default
    }));
$d83187a0eb7b20f4$var$FlagFilledIcon.displayName = 'FlagFilledIcon';
var $d83187a0eb7b20f4$var$_default = module.exports.default = $d83187a0eb7b20f4$var$FlagFilledIcon;

});

parcelRegister("agZSd", function(module, exports) {

$parcel$export(module.exports, "getLozengeAppearanceByStatus", () => $4b5deb45e4e97e76$export$d5b9b4e40fc0bd79);

var $gULOk = parcelRequire("gULOk");

var $b8gJu = parcelRequire("b8gJu");
const $4b5deb45e4e97e76$export$d5b9b4e40fc0bd79 = (statusCategory)=>{
    switch((0, $gULOk).categoryIdForStatusCategory(statusCategory)){
        case 3:
            return (0, $b8gJu.LOZENGE_APPEARANCE).success;
        case 4:
            return (0, $b8gJu.LOZENGE_APPEARANCE).inprogress;
        default:
            return (0, $b8gJu.LOZENGE_APPEARANCE).default;
    }
};

});

parcelRegister("ijnF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $60a16ddda3229b58$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $lj8SI = parcelRequire("lj8SI");

var $gwIPs = parcelRequire("gwIPs");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $kFsv3 = parcelRequire("kFsv3");

var $iHPnC = parcelRequire("iHPnC");
const $60a16ddda3229b58$var$LOZENGE_THEMES = (0, $iHPnC.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $60a16ddda3229b58$var$getLozengeThemeByColor = (color)=>// This uses schema from src/packages/issue/epic-color/src/common/constants.js
    $60a16ddda3229b58$var$LOZENGE_THEMES[color] || $60a16ddda3229b58$var$LOZENGE_THEMES[0, $kFsv3.PURPLE];
const $60a16ddda3229b58$var$CardEpic = (props)=>{
    // This uses schema from src/packages/issue/epic-color/src/common/constants.js
    const { color: color = (0, $kFsv3.PURPLE), children: children } = props; /* eslint-disable jira/react/no-style-attribute */ 
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60a16ddda3229b58$var$LozengeWrapper, {
        "data-test-id": "platform-board-kit.ui.swimlane.epic.lozenge",
        "data-testid": "platform-board-kit.ui.swimlane.epic.lozenge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        style: $60a16ddda3229b58$var$getLozengeThemeByColor(color)
    }, children)); /* eslint-enable jira/react/no-style-attribute */ 
};
var $60a16ddda3229b58$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $60a16ddda3229b58$var$CardEpic;
const $60a16ddda3229b58$var$LozengeWrapperControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1qr9bmp-0"
})({
    display: 'flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& span': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: `${(0, $gwIPs.gridSize) * 2}px`
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $60a16ddda3229b58$var$LozengeWrapperExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _13t37vkz",
            __cmplp.className
        ])
    });
});
const $60a16ddda3229b58$var$LozengeWrapper = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $60a16ddda3229b58$var$LozengeWrapperExperiment, $60a16ddda3229b58$var$LozengeWrapperControl);

});

parcelRegister("eF5Y9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fe6c107f7569dab$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $1fe6c107f7569dab$var$messages = (0, $7VHMR.defineMessages)({
    issueCount: {
        "id": "platform-board-kit.swimlane.issue-count",
        "defaultMessage": "{count, plural,\n            =0 {no issues}\n            one {# issue}\n            other {# issues}\n        }"
    },
    subtaskCount: {
        "id": "platform-board-kit.swimlane.subtask-count",
        "defaultMessage": "{count, plural,\n            =0 {no subtasks}\n            one {# subtask}\n            other {# subtasks}\n        }"
    },
    statusLozenge: {
        "id": "platform-board-kit.swimlane.status-lozenge",
        "defaultMessage": "status"
    },
    flagged: {
        "id": "platform-board-kit.swimlane.flagged",
        "defaultMessage": "Flagged"
    },
    issueCountIssueTermRefresh: {
        "id": "platform-board-kit.swimlane.issue-count-issue-term-refresh",
        "defaultMessage": "{count, plural,\n            =0 {no issues}\n            one {# issue}\n            other {# issues}\n        }"
    }
});
var $1fe6c107f7569dab$export$2e2bcd8739ae039 = $1fe6c107f7569dab$var$messages;

});

parcelRegister("04c3l", function(module, exports) {

$parcel$export(module.exports, "TruncatedTooltip", () => $5f43bb8a6d27d99a$export$ba96758b60231242);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");
const $5f43bb8a6d27d99a$export$ba96758b60231242 = ({ children: children, ...props })=>{
    const ref = (0, $5uXOq.useRef)(null);
    const [isOverflown, setIsOverflown] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!ref.current) return;
        const element = ref.current;
        setIsOverflown(element.scrollWidth > element.clientWidth);
    }, [
        ref,
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5f43bb8a6d27d99a$var$tooltipOverflowStyles
    }, isOverflown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), props, children({
        ref: ref
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children({
        ref: ref
    })));
};
const $5f43bb8a6d27d99a$var$tooltipOverflowStyles = (0, $8CUq3.xcss)({
    flex: 1,
    minWidth: '0'
});

});


parcelRegister("1FeOe", function(module, exports) {

$parcel$export(module.exports, "default", () => $c55bd7875b5fafe8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c55bd7875b5fafe8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    externalLozengeShort: {
        "id": "portfolio-3-plan-increment-common.external-lozenge-short",
        "defaultMessage": "EXT"
    },
    externalLozenge: {
        "id": "portfolio-3-plan-increment-common.external-lozenge",
        "defaultMessage": "EXTERNAL"
    },
    externalTeamTooltipTitle: {
        "id": "portfolio-3-plan-increment-common.external-team-tooltip-title",
        "defaultMessage": "Team currently not in this plan"
    },
    externalTeamTooltipContent: {
        "id": "portfolio-3-plan-increment-common.external-team-tooltip-content",
        "defaultMessage": "This team isn't included in your plan, but has issues assigned to it."
    },
    planOnlyLozenge: {
        "id": "portfolio-3-plan-increment-common.plan-only-lozenge",
        "defaultMessage": "PLAN-ONLY"
    },
    planOnlyTeamTooltipTitle: {
        "id": "portfolio-3-plan-increment-common.plan-only-team-tooltip-title",
        "defaultMessage": "Plan-only team"
    },
    planOnlyTeamTooltipContent: {
        "id": "portfolio-3-plan-increment-common.plan-only-team-tooltip-content",
        "defaultMessage": "A plan-only team can only be used within this plan. It won't appear in JQL filters or on your issue screens."
    },
    kanbanLozenge: {
        "id": "portfolio-3-plan-increment-common.kanban-lozenge",
        "defaultMessage": "KANBAN"
    },
    weeksOption: {
        "id": "portfolio-3-plan-increment-common.weeks-option",
        "defaultMessage": "{count} {count, plural, one {week} other {weeks}}"
    },
    externalTeamTooltipContentIssueTermRefresh: {
        "id": "portfolio-3-plan-increment-common.external-team-tooltip-content-issue-term-refresh",
        "defaultMessage": "This team isn't included in your plan, but has issues assigned to it."
    },
    planOnlyTeamTooltipContentIssueTermRefresh: {
        "id": "portfolio-3-plan-increment-common.plan-only-team-tooltip-content-issue-term-refresh",
        "defaultMessage": "A plan-only team can only be used within this plan. It won't appear in JQL filters or on your issue screens."
    }
});

});

parcelRegister("2FiSG", function(module, exports) {

$parcel$export(module.exports, "default", () => $a30dd9a5687ac795$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $2NMNM = parcelRequire("2NMNM");

var $fVnbM = parcelRequire("fVnbM");

var $8mG85 = parcelRequire("8mG85");

var $iyo13 = parcelRequire("iyo13");

var $e4yMr = parcelRequire("e4yMr");

var $cgL5K = parcelRequire("cgL5K");


var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $4jAPy = parcelRequire("4jAPy");

var $bdYfL = parcelRequire("bdYfL");

var $8zOmE = parcelRequire("8zOmE");

var $67sX6 = parcelRequire("67sX6");

var $jbAX5 = parcelRequire("jbAX5");

var $cPGP0 = parcelRequire("cPGP0");

var $9yiQF = parcelRequire("9yiQF");
const $a30dd9a5687ac795$var$SprintAssociationButton = ({ teamId: teamId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const team = (0, $67sX6.useBoardSelector)((0, $cPGP0.getTeamById))(teamId);
    const isAssociated = team?.sprintByIterationId && Object.keys(team?.sprintByIterationId).length > 0;
    const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
        // stop the click event bubble to prevent triggering the collapse of the swimlane header
        e.stopPropagation();
        dispatch((0, $jbAX5.openTeamAssociationModal)(teamId));
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'syncSprints', {
            mode: isAssociated ? 'change' : 'add'
        });
    }, [
        createAnalyticsEvent,
        isAssociated,
        dispatch,
        teamId
    ]);
    const onEnterHandler = (0, $5uXOq.useCallback)((e)=>{
        // stop the key enter event bubble to prevent triggering the collapse of the swimlane header
        if (e.key === 'Enter') onClickHandler(e);
    }, [
        onClickHandler
    ]); /**
                         * Not showing for
                         * -- Unassigned swimlane
                         * -- External teams (means outside of the plan)
                         * -- Kanban teams
                         * -- Undefined team - happens after a scenario team is committed to Jira
                         */ 
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(teamId) || teamId === (0, $4jAPy.SWIMLANE_TEAMLESS) || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(team) || !team.isPlanTeam || team.planningStyle === (0, $4jAPy.KANBAN_TEAM)) return null;
     // check if the team is a scenario added plan-only team, we will revisit the logic for the sceanrio TWP team in https://hello.jira.atlassian.cloud/browse/JPO-28308
    if ((0, $bdYfL.isScenarioPlanonlyTeamCheck)(teamId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p",
        color: "color.text.subtlest"
    }, formatMessage((0, $9yiQF.default).scenarioTeamWarning, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "strong"
            }, chunks)
    }));
    if (team.issueSourceType === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p",
        color: "color.text.subtlest"
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9yiQF.default).noIssueSourceWarningIssueTermRefresh : (0, $9yiQF.default).noIssueSourceWarning));
    if (team.planningStyle === (0, $4jAPy.SCRUM_TEAM) && team.issueSourceType !== (0, $4jAPy.BOARD_ISSUE_SOURCE)) {
        const helpOnClick = (e)=>{
            // stop the click event bubble to prevent triggering the collapse of the swimlane header
            e.stopPropagation();
        };
        const helpOnEnter = (e)=>{
            // stop the key enter event bubble to prevent triggering the collapse of the swimlane header
            if (e.key === 'Enter') e.stopPropagation();
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p",
            color: "color.text.subtlest"
        }, formatMessage((0, $9yiQF.default).nonBoardTeamWarning, {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.default), {
                    articleId: (0, $4jAPy.IPH_IDS).CAPACITY_PLANNING,
                    appearance: "link",
                    spacing: "none",
                    fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                        href: (0, $4jAPy.DOC_LINKS).CAPACITY_PLANNING,
                        target: "_blank"
                    }, chunks),
                    onClick: helpOnClick,
                    onKeyDown: helpOnEnter
                }, chunks)
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onClickHandler,
        onKeyDown: onEnterHandler,
        appearance: "subtle",
        spacing: "compact",
        iconBefore: (0, $4R6GH.fg)('enghealth-12479-jsw-board-visual-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8mG85))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($iyo13))),
            LEGACY_size: "small",
            label: "",
            LEGACY_primaryColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`,
            color: "var(--ds-icon, #44546F)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iyo13))), {
            size: "small",
            label: "",
            primaryColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: (0, $bwpsq.default)([
            "_1wybutpp _k48pbfng"
        ])
    }, formatMessage(isAssociated ? (0, $9yiQF.default).changeSprints : (0, $9yiQF.default).addSprints)));
};
var $a30dd9a5687ac795$export$2e2bcd8739ae039 = $a30dd9a5687ac795$var$SprintAssociationButton;
const $a30dd9a5687ac795$var$buttonStyles = null;

});
parcelRegister("5Zxxp", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $b0d1b3c2fea05784$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "default", () => $b0d1b3c2fea05784$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $bHDKL = parcelRequire("bHDKL");

var $e4yMr = parcelRequire("e4yMr");

var $jpY8v = parcelRequire("jpY8v");

var $4R6GH = parcelRequire("4R6GH");

var $6BNJk = parcelRequire("6BNJk");

var $kspz4 = parcelRequire("kspz4");

var $hsmeR = parcelRequire("hsmeR");
const $b0d1b3c2fea05784$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $kspz4.useHelpPanelActions)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $6BNJk.HELP_PANEL_ID), (0, $6BNJk.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: (0, $bHDKL.ARTICLE_TYPE)[type]
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: (0, $bHDKL.ARTICLE_TYPE)[type]
            }
        });
    };
    return !(0, $jpY8v.isIE11)() ? handleOnClick : undefined;
};
const $b0d1b3c2fea05784$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, href: href, ...props })=>{
    const onOpenInProductHelpArticle = $b0d1b3c2fea05784$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        if ((0, $4R6GH.fg)('help_panel_as_link')) event.preventDefault();
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle?.(articleId, (0, $bHDKL.ARTICLE_TYPE)[type]);
    };
    if ((0, $4R6GH.fg)('help_panel_as_link')) return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        ...props,
        onClick: handleOnClick,
        href: href ?? 'https://support.atlassian.com',
        appearance: "default",
        testId: props.testId
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fallbackComponent);
    return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ...props,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fallbackComponent);
};
var $b0d1b3c2fea05784$export$2e2bcd8739ae039 = $b0d1b3c2fea05784$var$HelpPanelLink;
const $b0d1b3c2fea05784$var$buttonWrapperStyles = null;

});

parcelRegister("9yiQF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2313818b2a3c2e15$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2313818b2a3c2e15$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noIssueSourceWarning: {
        "id": "software.main.board-container.board.swimlane.increment-planning-buttons.sprint-association-btn.no-issue-source-warning",
        "defaultMessage": "Associate this team with an issue source to view its iterations"
    },
    scenarioTeamWarning: {
        "id": "software.main.board-container.board.swimlane.increment-planning-buttons.sprint-association-btn.scenario-team-warning",
        "defaultMessage": "Save this team using the <strong>Review changes</strong> button to view their capacity"
    },
    nonBoardTeamWarning: {
        "id": "software.main.board-container.board.swimlane.increment-planning-buttons.sprint-association-btn.non-board-team-warning",
        "defaultMessage": "To plan with this team's sprints, <link>make sure your plan is setup for capacity planning.</link>"
    },
    changeSprints: {
        "id": "software.main.board-container.board.swimlane.increment-planning-buttons.sprint-association-btn.change-sprints",
        "defaultMessage": "Change sprints"
    },
    addSprints: {
        "id": "software.main.board-container.board.swimlane.increment-planning-buttons.sprint-association-btn.add-sprints",
        "defaultMessage": "Add sprints"
    },
    noIssueSourceWarningIssueTermRefresh: {
        "id": "software.main.board-container.board.swimlane.increment-planning-buttons.sprint-association-btn.no-issue-source-warning-issue-term-refresh",
        "defaultMessage": "Associate this team with an issue source to view its iterations"
    }
});

});


parcelRegister("7xi98", function(module, exports) {

$parcel$export(module.exports, "default", () => $59f36d3a8673cec7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $59f36d3a8673cec7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    childlessTooltip: {
        "id": "software.main.board-container.board.swimlane.childless-tooltip",
        "defaultMessage": "Issues without a subtask or visible parent"
    },
    childlessTooltipIssueTermRefresh: {
        "id": "software.main.board-container.board.swimlane.childless-tooltip-issue-term-refresh",
        "defaultMessage": "Issues without a subtask or visible parent"
    }
});

});


parcelRegister("f3HGL", function(module, exports) {

$parcel$export(module.exports, "SwimlaneMoveToDoneButton", () => $fbba48641cc9262b$export$71546524403b0606);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $koVbs = parcelRequire("koVbs");

var $c79wa = parcelRequire("c79wa");

var $67sX6 = parcelRequire("67sX6");

var $4gHuj = parcelRequire("4gHuj");

var $4jZ56 = parcelRequire("4jZ56");

var $5mTgl = parcelRequire("5mTgl");

var $aBJH6 = parcelRequire("aBJH6");
const $fbba48641cc9262b$export$71546524403b0606 = ({ id: id })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const { values: swimlaneValues } = (0, $67sX6.useBoardSelector)((0, $5mTgl.platformSwimlaneSelector))(id) || {};
    const openMoveToDoneModal = (0, $5uXOq.useCallback)(()=>{
        if (swimlaneValues?.type === (0, $c79wa.STORY) && swimlaneValues?.parentId) dispatch((0, $4gHuj.issueChildrenInFinalColumnRequest)(swimlaneValues.parentId));
    }, [
        dispatch,
        swimlaneValues
    ]);
    const isParentDone = (0, $67sX6.useBoardSelector)((0, $4jZ56.isSwimlaneBySubtaskParentDoneSelector))(id);
    const areAllParentChildrenDone = (0, $67sX6.useBoardSelector)((0, $4jZ56.areSwimlaneBySubtaskParentChildrenDoneSelector))(swimlaneValues);
    return !isParentDone && areAllParentChildrenDone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: openMoveToDoneModal
    }, formatMessage((0, $aBJH6.default).moveToDoneLabel)) : null;
};

});
parcelRegister("aBJH6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8a3a6fc7e8916a3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a8a3a6fc7e8916a3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moveToDoneLabel: {
        "id": "software.main.board-container.board.swimlane-move-to-done.move-to-done-label",
        "defaultMessage": "Move to Done"
    }
});

});


parcelRegister("ebF5k", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3e910274f5cdf85$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $dZbEw = parcelRequire("dZbEw");

var $5rFbt = parcelRequire("5rFbt");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $67sX6 = parcelRequire("67sX6");

var $2f454 = parcelRequire("2f454");

var $9OPlz = parcelRequire("9OPlz");

var $9UXXB = parcelRequire("9UXXB");

var $4jZ56 = parcelRequire("4jZ56");

var $7qhY9 = parcelRequire("7qhY9");
const $d3e910274f5cdf85$var$CreateUnscheduledIssueButton = ({ teamId: teamId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const isCollapsed = (0, $67sX6.useBoardSelector)((state)=>(0, $4jZ56.isSwimlaneCollapsed)(state, teamId));
    const isOpen = (0, $67sX6.useBoardSelector)((state)=>(0, $9OPlz.isUnscheduledColumnICCOpen)(state, teamId, (0, $5rFbt.UNSCHEDULED_COLUMN_ID)));
    const isIccEnabled = (0, $67sX6.useBoardSelector)((state)=>(0, $9UXXB.isIccEnabledForColumnOrSwimlane)(state, teamId, (0, $5rFbt.UNSCHEDULED_COLUMN_ID)));
    const onClick = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $2f454.initiateIccInUnscheduledColumn)(teamId, isCollapsed));
    }, [
        dispatch,
        teamId,
        isCollapsed
    ]);
    if (!isIccEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))),
        label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7qhY9.default).labelIssueTermRefresh : (0, $7qhY9.default).label),
        isTooltipDisabled: false,
        onClick: onClick,
        isDisabled: !isCollapsed && isOpen
    });
};
var $d3e910274f5cdf85$export$2e2bcd8739ae039 = $d3e910274f5cdf85$var$CreateUnscheduledIssueButton;

});
parcelRegister("7qhY9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5500bb8b1d4ce0f5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5500bb8b1d4ce0f5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software.main.board-container.board.swimlane.increment-planning-buttons.create-unscheduled-issue-button.label",
        "defaultMessage": "Create issue"
    },
    labelIssueTermRefresh: {
        "id": "software.main.board-container.board.swimlane.increment-planning-buttons.create-unscheduled-issue-button.label-issue-term-refresh",
        "defaultMessage": "Create issue"
    }
});

});



parcelRegister("cxtbC", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8481e06a31ed841$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e8481e06a31ed841$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    columnHeader: {
        "id": "software.main.board-container.board.unscheduled-work-swimlanes-container.column-header",
        "defaultMessage": "Drag issues to schedule"
    },
    closeColumnLabel: {
        "id": "software.main.board-container.board.unscheduled-work-swimlanes-container.close-column-label",
        "defaultMessage": "Hide unscheduled work"
    },
    columnHeaderIssueTermRefresh: {
        "id": "software.main.board-container.board.unscheduled-work-swimlanes-container.column-header-issue-term-refresh",
        "defaultMessage": "Drag issues to schedule"
    }
});

});



parcelRegister("btiFk", function(module, exports) {

$parcel$export(module.exports, "default", () => $33eba21358e49b67$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $2Ysq2 = parcelRequire("2Ysq2");

var $fruR3 = parcelRequire("fruR3");

var $fyeGd = parcelRequire("fyeGd");

var $1SUmd = parcelRequire("1SUmd");
const $33eba21358e49b67$var$mapDispatchToProps = (dispatch)=>{
    const onCancel = ()=>{
        dispatch((0, $2Ysq2.backlogEnableCancel)());
    };
    const onConfirm = (push, refresh)=>{
        dispatch((0, $2Ysq2.backlogEnableConfirm)(push, refresh));
    };
    return {
        onCancel: onCancel,
        onConfirm: onConfirm
    };
};
var $33eba21358e49b67$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state)=>({
        isOpen: (0, $fruR3.isDialogVisibleSelector)(state),
        initialColumn: (0, $fyeGd.initialColumnSelector)(state)
    }), $33eba21358e49b67$var$mapDispatchToProps)((0, $1SUmd.default));

});
parcelRegister("fruR3", function(module, exports) {

$parcel$export(module.exports, "isDialogVisibleSelector", () => $adadf4f5013ea46a$export$c130901f07b1d4e4);

var $dGvGJ = parcelRequire("dGvGJ");

var $iuuJH = parcelRequire("iuuJH");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $absT5 = parcelRequire("absT5");

var $k8auG = parcelRequire("k8auG");
const $adadf4f5013ea46a$export$eacfcc6aba3b8af4 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getUi)
], (ui)=>Boolean(ui.backlogEnableDialog?.isOpen));
const $adadf4f5013ea46a$export$c130901f07b1d4e4 = (0, $dGvGJ.createSelector)([
    $adadf4f5013ea46a$export$eacfcc6aba3b8af4,
    (0, $k8auG.isBacklogEnabled),
    (0, $absT5.getFirstColumnIssueIds),
    (0, $45cXl.getSwimlaneMode),
    (0, $67Z81.getIsCMPBoard)
], (isOpen, backlogEnabled, firstColumnIssueIds, swimlaneMode, isCMPBoard)=>{
    if (isCMPBoard) return false;
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return false;
    const firstColumnMoreThen19Issues = firstColumnIssueIds.length > 19;
    return isOpen && !backlogEnabled && firstColumnMoreThen19Issues;
});

});

parcelRegister("1SUmd", function(module, exports) {

$parcel$export(module.exports, "default", () => $efcd1b367eca4a68$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $ldJSL = parcelRequire("ldJSL");
var $fVnbM = parcelRequire("fVnbM");

var $1dJ6S = parcelRequire("1dJ6S");

var $ctg8C = parcelRequire("ctg8C");

var $gwIPs = parcelRequire("gwIPs");

var $eGLgs = parcelRequire("eGLgs");

var $heNNl = parcelRequire("heNNl");

var $7iJwP = parcelRequire("7iJwP");

var $az4zD = parcelRequire("az4zD");

var $1J3t1 = parcelRequire("1J3t1");

var $3hUhs = parcelRequire("3hUhs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $dIdda = parcelRequire("dIdda");

var $4oA6v = parcelRequire("4oA6v");
const $efcd1b367eca4a68$var$CoordinationStopProvider = ({ stop: stop = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), children: children })=>children(stop);
const $efcd1b367eca4a68$export$4a4175d839a85894 = ({ intl: intl, initialColumnName: initialColumnName, onCancel: onCancel, push: push, onConfirm: onConfirm, stop: stop })=>{
    const { refresh: refresh } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const title = intl.formatMessage((0, $4oA6v.default).title);
    const description = intl.formatMessage((0, $4oA6v.default).description, {
        initialColumnName: initialColumnName
    });
    const confirm = intl.formatMessage((0, $4oA6v.default).confirm);
    const cancel = intl.formatMessage((0, $4oA6v.default).cancel);
    const boldDescription = intl.formatMessage((0, $4oA6v.default).boldDescription);
    const onConfirmClicked = (e, analyticsEvent)=>{
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'backlogFeatureDialogConfirm clicked');
        stop();
        onConfirm(push, refresh);
    };
    const onCancelClicked = (e, analyticsEvent)=>{
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'backlogFeatureDialogCancel clicked');
        stop();
        onCancel();
    };
    const renderDialogContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($efcd1b367eca4a68$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1dJ6S.default), {
        size: "xsmall",
        as: "h5"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($efcd1b367eca4a68$var$DescriptionStyle, null, description, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($efcd1b367eca4a68$var$BoldDescriptionStyle, null, boldDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($efcd1b367eca4a68$var$ButtonGroupContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onCancelClicked,
        appearance: "subtle"
    }, cancel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onConfirmClicked,
        appearance: "primary"
    }, confirm))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), {
        content: renderDialogContent,
        isOpen: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null));
};
const $efcd1b367eca4a68$var$BacklogFeatureDialogWithRouter = ({ isOpen: isOpen, initialColumn: initialColumn, ...props })=>initialColumn && isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "backlogFeatureDialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "backlog-feature-dialog",
        packageName: "software-board"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "jira.board.backlog.feature.dialog",
        packageName: "jiraSoftwareBoard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.RouterActions), null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($efcd1b367eca4a68$var$StickyPosition, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
            messageId: "STG-EXT-459"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($efcd1b367eca4a68$var$CoordinationStopProvider, null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($efcd1b367eca4a68$export$4a4175d839a85894, {
                ...props,
                initialColumnName: initialColumn.name,
                stop: stop || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                push: push
            })))))))) : null;
var $efcd1b367eca4a68$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($efcd1b367eca4a68$var$BacklogFeatureDialogWithRouter);
const $efcd1b367eca4a68$var$COLUMN_DIALOG_Z_INDEX = (0, $3hUhs.sharedStyles).zIndex.stickyHeaders + 1;
const $efcd1b367eca4a68$var$CONTAINER_WIDTH = (0, $gwIPs.gridSize) * 42; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efcd1b367eca4a68$var$StickyPosition = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1cl78iz": (0, $lD23V.default)((0, $3hUhs.sharedStyles).columnWithMarginWidth / 2, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _154ipxbi _1ltvlz7i _w4h21if8 _z2g7pxbi _7bfnqfx8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efcd1b367eca4a68$var$ButtonGroupContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efcd1b367eca4a68$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5724jg8 _11c81oud _1bsb2hgv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efcd1b367eca4a68$var$DescriptionStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efcd1b367eca4a68$var$BoldDescriptionStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48p8n31",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eGLgs", function(module, exports) {

$parcel$export(module.exports, "CoordinationClient", () => $754c27d37ccd1133$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $754c27d37ccd1133$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iZhen = parcelRequire("iZhen");

var $jcYbC = parcelRequire("jcYbC");
var $8Mq6c = parcelRequire("8Mq6c");

var $TTRxY = parcelRequire("TTRxY");

var $ioD1B = parcelRequire("ioD1B");

var $fG5AJ = parcelRequire("fG5AJ");

var $10xFf = parcelRequire("10xFf");

var $4Pf62 = parcelRequire("4Pf62");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $14XJw = parcelRequire("14XJw");

var $7qPn9 = parcelRequire("7qPn9");
const $754c27d37ccd1133$var$isSyntheticTenant = ()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true';
class $754c27d37ccd1133$export$580a2294c917898c extends (0, $8Mq6c.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition, isAlreadyChoreographedAtAncestor = false){
        const environment = (0, $7qPn9.toEnvironment)((0, $j8DrX.default)('ajs-environment'));
        const getEnvironmentType = (env)=>{
            if (env === 'prod') return (0, $iZhen.envType).PROD;
            if (env === 'staging') return (0, $iZhen.envType).STAGING;
            return (0, $iZhen.envType).DEV;
        };
        // If a ancestor (e.g. CoordinationClient wraps CoordinationClient) is already choreographed,
        // we should not re-choreograph this CoordinationClient
        const enableChoreographer = (0, $10xFf.shouldBeChoreographed)({
            messageType: messageType
        }) && !isAlreadyChoreographedAtAncestor;
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: getEnvironmentType(environment),
            additionalData: {
                sourceProductId: (0, $TTRxY.ProductIds).JIRA
            }
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $754c27d37ccd1133$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        this.enableChoreographer = enableChoreographer;
        this.onMessageDisposition = onMessageDisposition;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $co1wz.ff)('ep-external-message-debug-mode') || (0, $4R6GH.fg)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, $TTRxY.MessageDeliveryStatus).STARTED : (0, $TTRxY.MessageDeliveryStatus).BLOCKED);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) {
                const didStop = await super.stop(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $TTRxY.MessageDeliveryStatus).STOPPED : (0, $TTRxY.MessageDeliveryStatus).BLOCKED);
            }
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId).then((didStart)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, $TTRxY.MessageDeliveryStatus).STARTED : (0, $TTRxY.MessageDeliveryStatus).BLOCKED);
            return didStart;
        });
    }
    async stop(messageId) {
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId).then((didStop)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $TTRxY.MessageDeliveryStatus).STOPPED : (0, $TTRxY.MessageDeliveryStatus).BLOCKED);
            return didStop;
        });
    }
}
function $754c27d37ccd1133$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $fG5AJ.useChoreographedStatusContext)();
    const client = new $754c27d37ccd1133$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition, isAlreadyChoreographedAtAncestor);
    const { fallback: fallback, messageId: messageId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: client.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jcYbC.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children));
}

});
parcelRegister("ioD1B", function(module, exports) {

$parcel$export(module.exports, "ChoreographerContextProvider", () => $c141e5ba3428702a$export$c3226151caaf2fbf);

var $5uXOq = parcelRequire("5uXOq");

var $fG5AJ = parcelRequire("fG5AJ");
const $c141e5ba3428702a$var$choreographedStatusContextValue = {
    isAlreadyChoreographedAtAncestor: true
};
const $c141e5ba3428702a$export$c3226151caaf2fbf = ({ isChoreographed: isChoreographed, children: children })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $fG5AJ.useChoreographedStatusContext)();
    const shouldUseChoreographerContextProvider = !isAlreadyChoreographedAtAncestor && isChoreographed;
    return shouldUseChoreographerContextProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fG5AJ.ChoreographedStatusContext).Provider, {
        value: $c141e5ba3428702a$var$choreographedStatusContextValue
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};

});


parcelRegister("4oA6v", function(module, exports) {

$parcel$export(module.exports, "default", () => $b644d43996c7dfd7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b644d43996c7dfd7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software.main.board-container.board.backlog-feature-dialog.title",
        "defaultMessage": "Free up your board"
    },
    description: {
        "id": "software.main.board-container.board.backlog-feature-dialog.description",
        "defaultMessage": "Your {initialColumnName} column is getting quite full. Would you like to try out the "
    },
    boldDescription: {
        "id": "software.main.board-container.board.backlog-feature-dialog.bold-description",
        "defaultMessage": "Backlog?"
    },
    confirm: {
        "id": "software.main.board-container.board.backlog-feature-dialog.confirm",
        "defaultMessage": "Enable the backlog"
    },
    cancel: {
        "id": "software.main.board-container.board.backlog-feature-dialog.cancel",
        "defaultMessage": "Ignore"
    }
});

});



parcelRegister("aJnM9", function(module, exports) {

$parcel$export(module.exports, "useBoardDragDropContext", () => $4137dd08082e26dd$export$44254c39eac89ba9);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $7wqBZ = parcelRequire("7wqBZ");

var $dmo3v = parcelRequire("dmo3v");

var $kUU4G = parcelRequire("kUU4G");

var $x9xyg = parcelRequire("x9xyg");


var $6oUms = parcelRequire("6oUms");

var $i8Gbw = parcelRequire("i8Gbw");

var $8zOmE = parcelRequire("8zOmE");



var $67sX6 = parcelRequire("67sX6");

var $eu61M = parcelRequire("eu61M");

var $2f454 = parcelRequire("2f454");

var $iDcEO = parcelRequire("iDcEO");

var $55fEr = parcelRequire("55fEr");

var $9OPlz = parcelRequire("9OPlz");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");
const $4137dd08082e26dd$export$44254c39eac89ba9 = ({ onDragEnd: onDragEndProp })=>{
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const orderedColumnIds = (0, $67sX6.useBoardSelector)((0, $67Z81.getOrderedColumnIds));
    const getSomeTransitionsHaveConditions = (0, $67sX6.useBoardSelector)((0, $9OPlz.makeGetHasConditions));
    const boardSessionId = (0, $67sX6.useBoardSelector)((0, $67Z81.sessionIdSelector));
    const boardStore = (0, $67sX6.useBoardStore)();
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const overTransitionId = (0, $67sX6.useBoardSelector)((state)=>(0, $9OPlz.getCardDragState)(state).overTransition?.transitionId);
    const selectedTransitionId = (0, $67sX6.useBoardSelector)((state)=>(0, $9OPlz.getSelectedTransition)(state)?.transitionId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const hasCustomTransitions = (0, $67sX6.useBoardSelector)((0, $9OPlz.hasNonGlobalTransitions));
    const hasMultipleStatuses = (0, $67sX6.useBoardSelector)((0, $fyeGd.hasMultipleStatusesPerColumn));
    const isHoverIntendedDuringDrag = (0, $67sX6.useBoardSelector)((state)=>hasCustomTransitions || hasMultipleStatuses ? (0, $9OPlz.isHoverIntended)(state) : false);
    const isTransitionSelected = (0, $67sX6.useBoardSelector)((state)=>{
        const transitionId = (0, $9OPlz.getSelectedTransition)(state)?.transitionId;
        return hasCustomTransitions || hasMultipleStatuses ? !!transitionId : false;
    });
    const onDragStart = (0, $5uXOq.useCallback)((draggableData)=>{
        (0, $kUU4G.default)((0, $dcbb2bce513725b3$export$67cc25959ff33188));
        (0, $x9xyg.setMark)((0, $dcbb2bce513725b3$export$67cc25959ff33188));
        const draggableId = draggableData.type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c) ? (0, $6oUms.getCardDescriptor)(draggableData.cardId) : (0, $6oUms.getColumnDescriptor)(draggableData.columnId, draggableData.swimlaneId ?? undefined);
        dispatch((0, $eu61M.dragStart)(draggableId, 'FLUID'));
        const analyticsEvent = createAnalyticsEvent({
            action: 'dragStarted',
            actionSubject: draggableData.type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c) ? 'card' : 'column'
        });
        if (!isIPBoard && draggableData.type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c)) {
            const { cardId: cardId } = draggableData;
            const hasConditions = getSomeTransitionsHaveConditions(cardId);
            if (hasConditions) dispatch((0, $2f454.cardGetIssueTransitions)(cardId, analyticsEvent));
        }
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, isIPBoard ? {
            source: (0, $7e733a5d4e4331fc$export$8a5f5fbe7aeddf5)
        } : {});
    }, [
        createAnalyticsEvent,
        dispatch,
        getSomeTransitionsHaveConditions,
        isIPBoard
    ]);
    const onDragEnd = (0, $5uXOq.useCallback)((draggableData, targetData)=>{
        onDragEndProp?.();
        (0, $7wqBZ.getLongTasksMetrics)('dnd').stop((0, $dmo3v.dndReporter), {
            type: draggableData.type,
            boardSessionId: boardSessionId,
            isPragmaticBoardEnabled: true
        });
        dispatch((0, $eu61M.dragEnd)());
        const analyticsEvent = createAnalyticsEvent({
            action: 'dragEnded',
            actionSubject: draggableData.type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c) ? 'card' : 'column'
        });
        let analyticAttributes;
        if (!isIPBoard) analyticAttributes = draggableData.type === 'CARD' ? {
            dndType: draggableData.type,
            hasNonGlobalTransitions: hasCustomTransitions,
            isTransitionSelected: isTransitionSelected,
            hoverIntent: isHoverIntendedDuringDrag,
            sameColumn: draggableData.columnId === targetData?.columnId
        } : {
            dndType: draggableData.type
        };
        else analyticAttributes = {
            source: (0, $7e733a5d4e4331fc$export$8a5f5fbe7aeddf5)
        };
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, analyticAttributes);
    }, [
        boardSessionId,
        dispatch,
        onDragEndProp,
        createAnalyticsEvent,
        isHoverIntendedDuringDrag,
        isTransitionSelected,
        hasCustomTransitions,
        isIPBoard
    ]);
    const onColumnMove = (0, $5uXOq.useCallback)((columnId, sourceColumnIndex, destinationColumnIndex)=>{
        if (!isIPBoard) {
            const analyticsEvent = createAnalyticsEvent({
                action: 'moved',
                actionSubject: 'column'
            });
            dispatch((0, $55fEr.columnRankRequest)(Number(columnId), orderedColumnIds[destinationColumnIndex], sourceColumnIndex, analyticsEvent));
        }
    }, [
        createAnalyticsEvent,
        dispatch,
        orderedColumnIds,
        isIPBoard
    ]);
    const onCardsMove = (0, $5uXOq.useCallback)(({ cardIds: cardIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, sourceCardIndex: sourceCardIndex, destinationCardIndex: destinationCardIndex, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'updated',
            actionSubject: 'issue'
        });
        if (overTransitionId && !selectedTransitionId) dispatch((0, $2f454.cardDragSelectedTransition)(overTransitionId, Number(destinationColumnId), destinationSwimlaneId ?? undefined));
        const finalDestinationCardIndex = Number.isInteger(destinationCardIndex) ? destinationCardIndex : (0, $5mTgl.getIssuesIdsForColumn)(boardStore.getState(), {
            swimlaneId: destinationSwimlaneId,
            columnId: Number(destinationColumnId)
        })?.length;
        dispatch((0, $iDcEO.cardsMove)({
            cardIds: cardIds,
            sourceColumnId: Number(sourceColumnId),
            destinationColumnId: Number(destinationColumnId),
            sourceCardIndex: sourceCardIndex,
            destinationCardIndex: finalDestinationCardIndex ?? 0,
            sourceSwimlaneId: sourceSwimlaneId,
            destinationSwimlaneId: destinationSwimlaneId,
            analyticsEvent: analyticsEvent
        }));
    }, [
        createAnalyticsEvent,
        dispatch,
        overTransitionId,
        selectedTransitionId,
        boardStore
    ]);
    (0, $i8Gbw.useBoardDragDropContext)({
        onDragStart: onDragStart,
        onDragEnd: onDragEnd,
        onColumnMove: onColumnMove,
        onCardsMove: onCardsMove
    });
};

});
parcelRegister("dmo3v", function(module, exports) {

$parcel$export(module.exports, "dndReporterWithSlo", () => $4a0e33c36c54a683$export$e5a00a4133cb3d76);
$parcel$export(module.exports, "dndReporter", () => $4a0e33c36c54a683$export$62f293b5c9d6890c);

var $kUU4G = parcelRequire("kUU4G");

var $fjcgS = parcelRequire("fjcgS");

var $k12ix = parcelRequire("k12ix");

var $cJpFl = parcelRequire("cJpFl");

var $if7bx = parcelRequire("if7bx");
const $4a0e33c36c54a683$export$e5a00a4133cb3d76 = (sloSettings)=>(observationData, extraProps, stopTimestamp)=>{
        if ((0, $cJpFl.isExpandedObservationData)(observationData)) {
            const { eventStartPerformanceMark: eventStartPerformanceMark } = observationData;
            if (eventStartPerformanceMark) (0, $kUU4G.default)(eventStartPerformanceMark);
            const startTimes = observationData.events.map((event)=>event.timestamp);
            const startLongTaskEndTimestamp = observationData.dragStartEndTimestamp;
            const startLongTasks = observationData.events.filter((event)=>event.timestamp < startLongTaskEndTimestamp);
            const movingLongTasks = observationData.events.filter((event)=>event.timestamp >= startLongTaskEndTimestamp && event.timestamp < stopTimestamp);
            const dropLongTasks = observationData.events.filter((event)=>event.timestamp >= stopTimestamp);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const analyticsData = {
                ...extraProps,
                ...(0, $if7bx.generateLongTaskAnalyticsSummaryWithSlo)('start', startLongTasks, sloSettings),
                ...(0, $if7bx.generateLongTaskAnalyticsSummaryWithSlo)('moving', movingLongTasks, sloSettings),
                ...(0, $if7bx.generateLongTaskAnalyticsSummaryWithSlo)('drop', dropLongTasks, sloSettings),
                type: observationData.type || 'unknown',
                measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTimes),
                performanceFFs: (0, $k12ix.getPerformanceFFsString)()
            };
            const triggerSoftwareAnalytics = (0, $if7bx.triggerAnalytics)(`software.${observationData.appName}`);
            triggerSoftwareAnalytics(`long-tasks-${observationData.type || 'dnd'}`, analyticsData);
            if (sloSettings) {
                const attributes = {
                    ...extraProps,
                    type: observationData.type || 'unknown',
                    startLongTaskSloIsSuccess: analyticsData.startLongTaskSloIsSuccess,
                    movingLongTaskSloIsSuccess: analyticsData.movingLongTaskSloIsSuccess,
                    dropLongTaskSloIsSuccess: analyticsData.dropLongTaskSloIsSuccess,
                    ...sloSettings
                };
                (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
                    const payload = {
                        source: observationData.appName,
                        action: 'complete',
                        actionSubject: 'dnd operation',
                        attributes: attributes
                    };
                    client.getInstance().sendOperationalEvent(payload);
                });
            }
        }
    };
const $4a0e33c36c54a683$export$62f293b5c9d6890c = $4a0e33c36c54a683$export$e5a00a4133cb3d76();

});

parcelRegister("i8Gbw", function(module, exports) {

$parcel$export(module.exports, "useBoardDragDropContext", () => $bece2cc482ad9c63$export$44254c39eac89ba9);

var $5uXOq = parcelRequire("5uXOq");

var $biEfA = parcelRequire("biEfA");

var $7gWdR = parcelRequire("7gWdR");


var $kChOb = parcelRequire("kChOb");
const $bece2cc482ad9c63$var$availableDNDTypes = [
    (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c),
    (0, $25c2ea87c2b04bf9$export$57d0ef745f304b91)
];
const $bece2cc482ad9c63$export$3931b9970036fda4 = (sourceColumnData, destinationColumnData, onColumnMove)=>{
    const { columnId: columnId, columnIndex: sourceColumnIndex } = sourceColumnData;
    if (!destinationColumnData || destinationColumnData.type !== (0, $25c2ea87c2b04bf9$export$57d0ef745f304b91) || columnId === destinationColumnData.columnId) return;
    const closestEdgeOfTarget = (0, $biEfA.extractClosestEdge)(destinationColumnData);
    if (!closestEdgeOfTarget) return;
    const destinationColumnIndex = (0, $kChOb.getDestinationColumnIndex)(closestEdgeOfTarget, sourceColumnIndex, destinationColumnData.columnIndex);
    if (sourceColumnIndex !== destinationColumnIndex) onColumnMove(columnId, sourceColumnIndex, destinationColumnIndex);
};
const $bece2cc482ad9c63$export$8af04b1252e03f45 = (cardData, targetData, onCardsMove)=>{
    const { cardId: cardId, cardIndex: sourceCardIndex, columnId: sourceColumnId, swimlaneId: sourceSwimlaneId } = cardData;
    if (!targetData) return;
    if (targetData.type === (0, $25c2ea87c2b04bf9$export$57d0ef745f304b91) || targetData.type === (0, $25c2ea87c2b04bf9$export$2927f4d423091b16)) {
        // Drop on column or transition zone
        onCardsMove({
            cardIds: [
                cardId
            ],
            sourceColumnId: sourceColumnId,
            destinationColumnId: targetData.columnId,
            sourceCardIndex: sourceCardIndex,
            sourceSwimlaneId: sourceSwimlaneId,
            destinationSwimlaneId: targetData.swimlaneId
        });
        return;
    }
    if (targetData.type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c)) {
        // Drop against a card
        const closestEdge = (0, $biEfA.extractClosestEdge)(targetData);
        if (!closestEdge) return;
        const isSameColumnAndSwimlane = sourceColumnId === targetData.columnId && sourceSwimlaneId === targetData.swimlaneId;
        const destinationCardIndex = (0, $kChOb.getDestinationCardIndex)({
            closestEdge: closestEdge,
            sourceCardIndex: sourceCardIndex,
            destinationCardIndex: targetData.cardIndex,
            isSameColumnAndSwimlane: isSameColumnAndSwimlane
        });
        if (isSameColumnAndSwimlane && (cardId === targetData.cardId || sourceCardIndex === destinationCardIndex)) return;
        onCardsMove({
            cardIds: [
                cardId
            ],
            sourceColumnId: sourceColumnId,
            destinationColumnId: targetData.columnId,
            sourceCardIndex: sourceCardIndex,
            destinationCardIndex: destinationCardIndex,
            sourceSwimlaneId: sourceSwimlaneId,
            destinationSwimlaneId: targetData.swimlaneId
        });
    }
};
const $bece2cc482ad9c63$export$44254c39eac89ba9 = ({ onDragStart: onDragStart, onDragEnd: onDragEnd, onColumnMove: onColumnMove, onCardsMove: onCardsMove })=>{
    (0, $5uXOq.useEffect)(()=>(0, $7gWdR.monitorForElements)({
            canMonitor: ({ source: source })=>$bece2cc482ad9c63$var$availableDNDTypes.includes(String(source.data.type)),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            onDragStart: ({ source: source })=>onDragStart(source.data),
            onDrop: ({ location: location, source: source })=>{
                onDragEnd(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                source.data, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                location.current.dropTargets[0]?.data);
                if (!location.current.dropTargets.length) return;
                if (source.data.type === (0, $25c2ea87c2b04bf9$export$57d0ef745f304b91)) $bece2cc482ad9c63$export$3931b9970036fda4(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                source.data, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                location.current.dropTargets[0]?.data, onColumnMove);
                if (source.data.type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c)) $bece2cc482ad9c63$export$8af04b1252e03f45(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                source.data, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                location.current.dropTargets[0]?.data, onCardsMove);
            }
        }), [
        onCardsMove,
        onColumnMove,
        onDragEnd,
        onDragStart
    ]);
};

});
parcelRegister("kChOb", function(module, exports) {

$parcel$export(module.exports, "getDestinationColumnIndex", () => $b99e3a1eb57bd2af$export$6effbf458397b60);
$parcel$export(module.exports, "getDestinationCardIndex", () => $b99e3a1eb57bd2af$export$730b48350489f9c4);
const $b99e3a1eb57bd2af$export$6effbf458397b60 = (closestEdge, sourceColumnIndex, destinationColumnIndex)=>{
    if (sourceColumnIndex < destinationColumnIndex) return closestEdge === 'left' ? destinationColumnIndex - 1 : destinationColumnIndex;
    return closestEdge === 'left' ? destinationColumnIndex : destinationColumnIndex + 1;
};
const $b99e3a1eb57bd2af$export$730b48350489f9c4 = ({ closestEdge: closestEdge, sourceCardIndex: sourceCardIndex, destinationCardIndex: destinationCardIndex, isSameColumnAndSwimlane: isSameColumnAndSwimlane })=>{
    if (isSameColumnAndSwimlane && sourceCardIndex < destinationCardIndex) return closestEdge === 'top' ? destinationCardIndex - 1 : destinationCardIndex;
    return closestEdge === 'top' ? destinationCardIndex : destinationCardIndex + 1;
};

});



parcelRegister("4uy3J", function(module, exports) {

$parcel$export(module.exports, "default", () => $f51523b0338b2b81$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $hzgHK = parcelRequire("hzgHK");

var $67sX6 = parcelRequire("67sX6");

var $jbAX5 = parcelRequire("jbAX5");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");

var $cPGP0 = parcelRequire("cPGP0");
const $f51523b0338b2b81$var$SprintAssociation = ()=>{
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const sprintAssociationModal = (0, $67sX6.useBoardSelector)((state)=>state.ui.sprintAssociationModal);
    const isOpen = sprintAssociationModal?.isOpen;
    const teamId = isOpen ? sprintAssociationModal?.teamId || '' : '';
    const team = (0, $67sX6.useBoardSelector)((0, $cPGP0.getTeamById))(teamId);
    const planId = (0, $67sX6.useBoardSelector)((0, $67Z81.getPlanId));
    const scenarioId = (0, $67sX6.useBoardSelector)((0, $67Z81.getScenarioId));
    const incrementId = (0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector));
    const columns = (0, $67sX6.useBoardSelector)((0, $fyeGd.getColumns));
    const onModalCloseHandler = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $jbAX5.closeTeamAssociationModal)());
    }, [
        dispatch
    ]);
    const iterations = (0, $5uXOq.useMemo)(()=>Object.values(columns || {}).filter((column)=>column.id !== 0).map((column)=>{
            if ('dateRange' in column) return {
                id: column.id,
                startDate: column.dateRange.start,
                endDate: column.dateRange.end,
                name: column.name
            };
            return {
                id: column.id,
                name: column.name,
                startDate: 0,
                endDate: 0
            };
        }), [
        columns
    ]);
    const incrementConfig = (0, $67sX6.useBoardSelector)((0, $67Z81.getIncrementConfig));
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hzgHK.default), {
        isOpen: true,
        teamId: teamId,
        planId: planId,
        scenarioId: scenarioId,
        teamAvatarUrl: team.avatarUrl || '',
        teamName: team.name,
        incrementId: incrementId,
        sprintByIterationId: team.sprintByIterationId,
        iterations: iterations,
        onModalclose: onModalCloseHandler,
        iterationLength: (0, $4R6GH.fg)('program_board_flexible_cadence') ? incrementConfig?.iterationLength : undefined
    });
};
var $f51523b0338b2b81$export$2e2bcd8739ae039 = $f51523b0338b2b81$var$SprintAssociation;

});
parcelRegister("hzgHK", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a5d1db0c6b8c38c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $4jAPy = parcelRequire("4jAPy");

var $d7X6q = parcelRequire("d7X6q");
const $4a5d1db0c6b8c38c$var$AsyncSprintAssociationDialog = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $d7X6q.syncSprintDialog), {});
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
        return ()=>{
            entryPointActions.unload();
        };
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "plan-increment-sprint-association-dialog",
        packageName: (0, $4jAPy.PACKAGE_NAME),
        teamName: (0, $4jAPy.ERROR_REPORTING_TEAM),
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};
var $4a5d1db0c6b8c38c$export$2e2bcd8739ae039 = $4a5d1db0c6b8c38c$var$AsyncSprintAssociationDialog;

});
parcelRegister("d7X6q", function(module, exports) {

$parcel$export(module.exports, "syncSprintDialog", () => $e6d696b10fe546fe$export$32b8d8af74925968);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $e6d696b10fe546fe$export$32b8d8af74925968 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("kmVHB")).then((module)=>module.AsyncSprintAssociationDialog), {
        moduleId: "a536e7e2"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kmVHB", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("khS0W").then(()=>parcelRequire('1bpWz'));

});




parcelRegister("hnOnj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3087206511b049cd$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4R6GH = parcelRequire("4R6GH");

var $645AZ = parcelRequire("645AZ");

var $4CeiT = parcelRequire("4CeiT");

var $92yNu = parcelRequire("92yNu");

var $600T9 = parcelRequire("600T9");

var $4fvP4 = parcelRequire("4fvP4");

var $guFRy = parcelRequire("guFRy");

var $2xFXk = parcelRequire("2xFXk");

var $67sX6 = parcelRequire("67sX6");

var $6WzWZ = parcelRequire("6WzWZ");

var $1vXOx = parcelRequire("1vXOx");

var $j4MnI = parcelRequire("j4MnI");

var $67Z81 = parcelRequire("67Z81");

var $4jZ56 = parcelRequire("4jZ56");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");

var $dRpFy = parcelRequire("dRpFy");

var $iTH7p = parcelRequire("iTH7p");

var $5AKFd = parcelRequire("5AKFd");

var $grktj = parcelRequire("grktj");

var $aH5JS = parcelRequire("aH5JS");
const $3087206511b049cd$var$SwimlanesContainer = ()=>{
    const columns = (0, $67sX6.useBoardSelector)((0, $5mTgl.columnsWithResolutionSelector));
    const swimlaneIds = (0, $67sX6.useBoardSelector)((0, $5mTgl.platformSwimlaneIdsSelector));
    const collapsedSwimlaneIds = (0, $67sX6.useBoardSelector)((0, $4jZ56.getCollapsedSwimlanes));
    const isIpBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const issuesWithLinksById = (0, $67sX6.useBoardSelector)((0, $5mTgl.getIssuesEntriesWithIssueLinksInBoard));
    const issueLinkTypes = (0, $67sX6.useBoardSelector)((0, $67Z81.getIssueLinkTypes));
    const showOffTrackDependencies = (0, $67sX6.useBoardSelector)((0, $j4MnI.getShowOfftrackDependencyLines));
    const issueIdsToShowDependencies = (0, $67sX6.useBoardSelector)((0, $j4MnI.getIssueIdsToShowDependencies));
    const hasDependenciesToShow = issueIdsToShowDependencies.length > 0 || showOffTrackDependencies;
    const [menusShown, setMenusShowns] = (0, $5uXOq.useState)({});
    const isFlexible = (0, $63LqY.useCapability)((0, $2xFXk.Capability).FLEXIBLE_BOARD_COLUMNS);
    const setMenuVisibility = (columnId)=>(visible)=>{
            setMenusShowns({
                [columnId]: visible
            });
        };
    const swimlaneHeights = (0, $67sX6.useBoardSelector)((0, $5mTgl.swimlaneHeightsSelector));
    const cacheOptions = (0, $5uXOq.useMemo)(()=>({
            cache: new Map(),
            getCacheKey: (index)=>swimlaneIds[index]
        }), [
        swimlaneIds
    ]);
    const { rows: rows, totalSize: totalSize, scrollTo: scrollTo, rowStates: rowStates } = (0, $guFRy.useVirtual)({
        rowCount: swimlaneIds.length,
        getDefaultRowSize: (index)=>swimlaneHeights[swimlaneIds[index]],
        offsetTop: (0, $645AZ.columnHeaderHeight),
        cacheOptions: cacheOptions
    });
    const [_, { updateSwimlanePositions: updateSwimlanePositions }] = (0, $600T9.useDependencyLinks)();
    (0, $5uXOq.useEffect)(()=>{
        if (isIpBoard && rowStates && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) updateSwimlanePositions(rowStates, rows, swimlaneIds, collapsedSwimlaneIds);
    }, [
        isIpBoard,
        updateSwimlanePositions,
        rows,
        rowStates,
        swimlaneIds,
        collapsedSwimlaneIds
    ]);
    (0, $aH5JS.useAutoScrollSwimlane)(swimlaneIds, scrollTo);
    const renderSwimlanes = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, rows.map(({ index: index, top: top, forceRemeasure: forceRemeasure, measure: measure })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $grktj.default), {
                key: swimlaneIds[index],
                id: swimlaneIds[index],
                index: index,
                top: top,
                measure: measure,
                forceRemeasure: forceRemeasure,
                isLastSwimlane: index === swimlaneIds.length - 1,
                isUnscheduledWorkColumnPanel: false
            })));
    const isIPBoardReadOnly = (0, $67sX6.useBoardSelector)((0, $1vXOx.isIncrementPlanningReadOnly));
    const onUnlinkIssueAction = (0, $67sX6.useBoardActionCreator)((issueLink, issueId)=>(0, $6WzWZ.issueLinksRemoveRequest)({
            issueId: issueId,
            issueLink: issueLink
        }));
    const onUnlinkIssue = (0, $5uXOq.useCallback)(async (dependencyModalIssueLink)=>{
        if (dependencyModalIssueLink) {
            const issueLink = {
                id: dependencyModalIssueLink.itemKey,
                sourceId: dependencyModalIssueLink.sourceItemKey,
                destinationId: dependencyModalIssueLink.targetItemKey,
                linkTypeId: dependencyModalIssueLink.type
            };
            return onUnlinkIssueAction(issueLink, issueLink.sourceId);
        }
    }, [
        onUnlinkIssueAction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3087206511b049cd$var$SwimlanesContainerWrapper, {
        isFlexible: isFlexible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CeiT.SwimlaneColumnHeaderContainer), {
        flexibleColumns: isFlexible
    }, columns.map(({ id: id }, columnIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5AKFd.default), {
            id: id,
            key: id,
            header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dRpFy.default), {
                id: id,
                isMenuShown: menusShown[id] || false,
                menu: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iTH7p.default), {
                    columnId: id,
                    onVisibilityChange: setMenuVisibility(id)
                })
            }),
            draggableIndex: columnIndex
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92yNu.default), {
        flexibleColumns: isFlexible,
        minHeight: totalSize + (0, $645AZ.columnHeaderHeight),
        isVirtualised: true
    }, renderSwimlanes()), isIpBoard && hasDependenciesToShow && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4fvP4.DependencyLines), {
        issuesWithLinksById: issuesWithLinksById,
        showOffTrackDependencies: showOffTrackDependencies,
        issueIdsToShowDependencies: issueIdsToShowDependencies,
        issueLinkTypes: issueLinkTypes,
        onUnlink: onUnlinkIssue,
        canDelete: !isIPBoardReadOnly
    }));
};
var $3087206511b049cd$export$2e2bcd8739ae039 = $3087206511b049cd$var$SwimlanesContainer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3087206511b049cd$var$SwimlanesContainerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexible: isFlexible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isFlexible ? "_1bsb1osq" : "_1bsb1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4fvP4", function(module, exports) {

$parcel$export(module.exports, "DependencyLines", () => $1ae1da9ec61b7fe8$export$4893c4c042062b2e);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $c32Ax = parcelRequire("c32Ax");

var $g1SUQ = parcelRequire("g1SUQ");

var $600T9 = parcelRequire("600T9");

var $2m0b6 = parcelRequire("2m0b6");
const $1ae1da9ec61b7fe8$export$4893c4c042062b2e = ({ issuesWithLinksById: issuesWithLinksById, issueLinkTypes: issueLinkTypes, onUnlink: onUnlink, canDelete: canDelete, showOffTrackDependencies: showOffTrackDependencies, issueIdsToShowDependencies: issueIdsToShowDependencies })=>{
    const [dependencyLinesData] = (0, $600T9.useIPDependencyLines)({
        issuesWithLinksById: issuesWithLinksById,
        showOffTrackDependencies: showOffTrackDependencies,
        issueIdsToShowDependencies: issueIdsToShowDependencies
    });
    const [{ activeLine: activeLine }, { updateDependencyLinesContainerPosition: updateDependencyLinesContainerPosition, setActiveLine: setActiveLine }] = (0, $600T9.useDependencyLinks)();
    // Hold the ref to the container of the dependency lines so we can account for panels pushing in from the left
    // E.g unscheduled work panel, nav sidebar being present/collapsed.
    const dependencyLinesContainerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (dependencyLinesContainerRef.current) {
            const { x: x } = dependencyLinesContainerRef.current.getBoundingClientRect();
            updateDependencyLinesContainerPosition({
                x: x
            });
        }
    }, [
        updateDependencyLinesContainerPosition,
        dependencyLinesContainerRef
    ]);
    (0, $2m0b6.useResizeObserver)({
        ref: dependencyLinesContainerRef,
        onResize: ()=>{
            if (dependencyLinesContainerRef.current) {
                const { x: x } = dependencyLinesContainerRef.current.getBoundingClientRect();
                updateDependencyLinesContainerPosition({
                    x: x
                });
            }
        }
    });
    const onDependencyClick = (event, params)=>{
        const clickedLine = {
            fromId: params.fromId,
            toId: params.toId,
            x: event.clientX,
            y: event.clientY
        };
        setActiveLine(clickedLine);
    };
    const formatLinksForModal = (links)=>{
        return links.filter((link)=>link.sourceId === activeLine?.fromId && link.destinationId === activeLine?.toId).map((link)=>{
            const { id: itemKey, sourceId: sourceId, destinationId: destinationId, isOfftrack: isOfftrack, linkTypeId: linkTypeId } = link;
            const getIssueMeta = (issue)=>{
                const { id: id, typeName: typeName, typeUrl: iconUrl, key: projectKey, summary: title } = issue;
                return {
                    id: id,
                    typeName: typeName,
                    iconUrl: iconUrl,
                    projectKey: projectKey,
                    title: title
                };
            };
            const issueLinkType = issueLinkTypes.find((type)=>type.id === linkTypeId);
            let outwardDescription = '';
            if (issueLinkType) {
                const { isOutward: isOutward, inward: inward, outward: outward } = issueLinkType;
                outwardDescription = isOutward ? outward : inward;
            }
            return {
                fromIssue: getIssueMeta(issuesWithLinksById[sourceId]),
                toIssue: getIssueMeta(issuesWithLinksById[destinationId]),
                issueLinkType: {
                    id: linkTypeId,
                    outward: outwardDescription
                },
                itemKey: itemKey,
                isOfftrack: isOfftrack
            };
        });
    };
    const currentLineLinks = activeLine ? formatLinksForModal(issuesWithLinksById[activeLine.fromId]?.issueLinks || []) : [];
    const selectedDependency = activeLine ? {
        fromId: activeLine.fromId,
        toId: activeLine.toId
    } : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c32Ax.default), {
        dependencies: dependencyLinesData,
        selectedDependency: selectedDependency,
        onDependencyClick: onDependencyClick
    }), activeLine && currentLineLinks.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1SUQ.default), {
        position: {
            left: activeLine.x,
            top: activeLine.y
        },
        links: currentLineLinks,
        canDelete: canDelete,
        onUnlink: onUnlink,
        onClose: ()=>setActiveLine(null),
        simpleOverlap: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ref: dependencyLinesContainerRef,
        xcss: $1ae1da9ec61b7fe8$var$measureDependencyLinesContainerStyles
    }));
};
const $1ae1da9ec61b7fe8$var$measureDependencyLinesContainerStyles = (0, $8CUq3.xcss)({
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: '0',
    left: '0',
    pointerEvents: 'none'
});

});
parcelRegister("c32Ax", function(module, exports) {

$parcel$export(module.exports, "default", () => $abcd90738f5b2cb5$export$2e2bcd8739ae039);
/* eslint-disable jira/restricted/styled-components-migration */ 
var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $8Rkzz = parcelRequire("8Rkzz");


var $9cikT = parcelRequire("9cikT");
const $abcd90738f5b2cb5$var$SvgOverlay = ({ dependencies: dependencies, selectedDependency: selectedDependency, onDependencyClick: onDependencyClick })=>{
    const selectedDependencyLine = selectedDependency && dependencies.find((dependency)=>dependency.from.id === selectedDependency.fromId && dependency.to.id === selectedDependency.toId && dependency.from.indexOnScope === selectedDependency.fromIndex && dependency.to.indexOnScope === selectedDependency.toIndex);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abcd90738f5b2cb5$var$SvgContainer, {
        className: (0, $0afb8a62e53619f1$export$1e54f8b472a07d8d)
    }, dependencies.map((dependency)=>{
        if (dependency !== selectedDependencyLine) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9cikT.default), {
            key: `${dependency.from.id}-${dependency.to.id}-${dependency.from.y}-${dependency.to.y}`,
            ...dependency,
            onClick: onDependencyClick,
            isSelected: false
        });
        return null;
    }), selectedDependencyLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9cikT.default), {
        ...selectedDependencyLine,
        onClick: onDependencyClick,
        isSelected: true
    })));
};
$abcd90738f5b2cb5$var$SvgOverlay.defaultProps = {
    selectedDependency: undefined,
    onDependencyClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    dependencies: []
};
var $abcd90738f5b2cb5$export$2e2bcd8739ae039 = $abcd90738f5b2cb5$var$SvgOverlay;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $abcd90738f5b2cb5$var$SvgContainer = /*#__PURE__*/ (0, $47bDC.default).svg.withConfig({
    componentId: "sc-7b34v9-0"
})({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    transition: 'opacity 0.2s ease-in-out',
    overflow: 'visible',
    pointerEvents: 'none'
});

});
/**
 * Style marshal classes
 */ const $0afb8a62e53619f1$export$1e54f8b472a07d8d = 'dependencies-overlay';
const $0afb8a62e53619f1$export$cd944e09ecad5145 = 'dependency-line';

parcelRegister("9cikT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dcd03412ef5592d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ajpes = parcelRequire("ajpes");

var $eTXmK = parcelRequire("eTXmK");


var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $iHPnC = parcelRequire("iHPnC");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $eGwbr = parcelRequire("eGwbr");

var $6k94P = parcelRequire("6k94P");
/* Even though this component represents a single line, multiple elements are used to achieve all of the requirements.
 * 1. An additional element with a larger surface area is used to capture interactions to improve the UX.
 * 2. Gradients cannot be applied to SVG elements using CSS. For this we use a linearGradient element.
 */ const $7dcd03412ef5592d$var$DependencyLine = ({ from: from, to: to, itemHeight: itemHeight, isOverlapping: isOverlapping, isSelected: isSelected, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const onPathClick = (0, $5uXOq.useCallback)((event)=>{
        (0, $eTXmK.default)('timeline-dependency-clicked', event.timeStamp);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'line'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'dependencyLine', {
            isOverlapping: isOverlapping
        });
        onClick(event, {
            fromId: from.id,
            toId: to.id,
            isOverlapping: isOverlapping,
            fromIndexOnScope: from.indexOnScope,
            toIndexOnScope: to.indexOnScope
        });
    }, [
        createAnalyticsEvent,
        isOverlapping,
        from,
        to,
        onClick
    ]);
    const onPathMouseEnter = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(true);
    }, []);
    const onPathMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(false);
    }, []);
    const path = (0, $6k94P.getPath)(from, to, itemHeight);
    const gradientId = `linear-gradient-${from.id}-${to.id}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (isHovered || isSelected) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: gradientId,
        x1: from.x,
        x2: to.x,
        y1: from.y,
        y2: to.y,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0%",
        stopColor: (0, $iHPnC.getValueFromColor)(from.color)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "100%",
        stopColor: (0, $iHPnC.getValueFromColor)(to.color)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: path,
        fill: "transparent",
        strokeWidth: "2",
        stroke: $7dcd03412ef5592d$export$a73db48ef11a2bc3({
            isOverlapping: isOverlapping,
            isSelected: isSelected,
            isHovered: isHovered,
            gradientId: gradientId
        }),
        pointerEvents: "none",
        "data-testid": "aais-dependency-lines-overlay.common.ui.line.dependency-line"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "mouse",
        mousePosition: "top",
        content: formatMessage((0, $eGwbr.default).viewDetail),
        tag: "g"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7dcd03412ef5592d$var$InteractivePath // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $0afb8a62e53619f1$export$cd944e09ecad5145),
        d: path,
        stroke: "transparent",
        strokeWidth: "9",
        fill: "none",
        cursor: "pointer",
        onClick: onPathClick,
        onMouseEnter: onPathMouseEnter,
        onMouseLeave: onPathMouseLeave,
        "data-testid": "aais-dependency-lines-overlay.common.ui.line.interactive-path"
    })));
};
$7dcd03412ef5592d$var$DependencyLine.whyDidYouRender = true; // Custom memo to handle common case where 'from' and 'to' objects change reference but not value
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$7dcd03412ef5592d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($7dcd03412ef5592d$var$DependencyLine, (0, (/*@__PURE__*/$parcel$interopDefault($ajpes))));
const $7dcd03412ef5592d$var$InteractivePath = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "path", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_lcxv1yxs",
            __cmplp.className
        ])
    });
});
const $7dcd03412ef5592d$export$a73db48ef11a2bc3 = ({ isOverlapping: isOverlapping, isSelected: isSelected, isHovered: isHovered, gradientId: gradientId })=>{
    const isHighlighted = isSelected || isHovered;
    if (isOverlapping) {
        if (isHighlighted) return `var(--ds-background-danger-bold-hovered, ${(0, $829f609a65d26a98$exports).R500})`;
        return `var(--ds-background-danger-bold, ${(0, $829f609a65d26a98$exports).R300})`;
    }
    if (isHighlighted) return `url(#${gradientId})`;
    return `var(--ds-border-bold, ${(0, $829f609a65d26a98$exports).N50})`;
};

});
parcelRegister("eGwbr", function(module, exports) {

$parcel$export(module.exports, "default", () => $188f0fa73c4b9066$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $188f0fa73c4b9066$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewDetail: {
        "id": "aais-dependency-lines-overlay.common.line.view-detail",
        "defaultMessage": "View dependency detail"
    }
});

});

parcelRegister("6k94P", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $eb5c0917a150e0bd$export$2aa3fd96c49a84a8);

var $8QpSo = parcelRequire("8QpSo");
const $eb5c0917a150e0bd$var$calculateMidPoint = (from, to)=>({
        x: (from.x + to.x) / 2,
        y: (from.y + to.y) / 2
    });
const $eb5c0917a150e0bd$var$getY = (p1, p2, x)=>{
    const m = (p2.y - p1.y) / (p2.x - p1.x);
    return m * (x - p1.x) + p1.y;
};
// Generates half of the complex segment
const $eb5c0917a150e0bd$var$generateSegment = (start, end, offset)=>{
    const c1 = {
        x: start.x + offset.x,
        y: start.y
    };
    const c2 = {
        x: start.x + offset.x,
        y: start.y + offset.y
    };
    const s1 = {
        x: start.x,
        y: $eb5c0917a150e0bd$var$getY(c2, end, start.x)
    };
    return `M${start.x} ${start.y} C${c1.x} ${c1.y} ${c2.x} ${c2.y} ${s1.x} ${s1.y} L${s1.x} ${s1.y} ${end.x} ${end.y}`;
};
const $eb5c0917a150e0bd$var$getSegmentOffsets = (from, to, halfItemHeight)=>{
    const fromOffset = {
        x: halfItemHeight,
        y: from.y <= to.y ? halfItemHeight : -halfItemHeight
    };
    const toOffset = {
        x: -fromOffset.x,
        y: -fromOffset.y
    };
    return [
        fromOffset,
        toOffset
    ];
};
// Generates a path made up of two segments for when the dependency start is after the end
const $eb5c0917a150e0bd$var$generateComplexPath = (from, to, halfItemHeight)=>{
    const middle = $eb5c0917a150e0bd$var$calculateMidPoint(from, to);
    const [fromOffset, toOffset] = $eb5c0917a150e0bd$var$getSegmentOffsets(from, to, halfItemHeight);
    return `${$eb5c0917a150e0bd$var$generateSegment(from, middle, fromOffset)} ${$eb5c0917a150e0bd$var$generateSegment(to, middle, toOffset)}`;
};
//  Generates a single path for when the dependency start is before the end (happy case)
const $eb5c0917a150e0bd$var$generateSinglePath = (from, to, itemHeight)=>{
    const diffX = Math.abs(from.x - to.x);
    const progression = itemHeight + diffX * 0.1;
    return `M${from.x} ${from.y} C${from.x + progression} ${from.y} ${to.x - progression} ${to.y} ${to.x} ${to.y}`;
};
const $eb5c0917a150e0bd$export$2aa3fd96c49a84a8 = (0, $8QpSo.default)((from, to, itemHeight)=>from.x > to.x ? $eb5c0917a150e0bd$var$generateComplexPath(from, to, itemHeight / 2) : $eb5c0917a150e0bd$var$generateSinglePath(from, to, itemHeight));

});



parcelRegister("g1SUQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $25bf1c89593464fa$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ // Note: We use block comment at top of the file because we get strange error in `SSR Image Build`
/* eslint-disable @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-dynamic-styles -- To migrate as part of go/ui-styling-standard */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $1I7E8 = parcelRequire("1I7E8");

var $co1wz = parcelRequire("co1wz");

var $2OMDV = parcelRequire("2OMDV");

var $1tKcG = parcelRequire("1tKcG");

var $egeYB = parcelRequire("egeYB");
class $25bf1c89593464fa$export$55aef0c69232da84 extends (0, $5uXOq.Component) {
    componentDidUpdate() {
        const { links: links, onClose: onClose } = this.props;
        // close modal if all dependencies were removed
        if (links.length === 0) onClose();
    }
    render() {
        const { position: position, ...contentProps } = this.props;
        if ((0, $co1wz.ff)('com.atlassian.rm.jpo.transposition.m2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
            isOpen: true,
            strategy: "absolute",
            onClose: contentProps.onClose,
            placement: "bottom-start",
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egeYB.default), contentProps),
            trigger: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25bf1c89593464fa$var$Anchor, {
                    top: position.top,
                    left: position.left,
                    ref: ref
                }),
            testId: "portfolio-3-dependency-line-detail.common.ui.modal.portfolio-dependency-line-detail-popup"
        });
        // Considering removing the chart modal component when cleaning com.atlassian.rm.jpo.transposition.m2
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1tKcG.default), {
            position: position,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egeYB.default), {
                ...contentProps,
                onClose: contentProps.onClose
            }),
            onClose: contentProps.onClose
        });
    }
}
var $25bf1c89593464fa$export$2e2bcd8739ae039 = (0, $2OMDV.AnalyticsEventToProps)('tooltip', {
    onUnlink: 'unlinked'
})($25bf1c89593464fa$export$55aef0c69232da84);
const $25bf1c89593464fa$var$Anchor = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { left: left, top: top, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_t50dub": (0, $lD23V.default)(`${__cmplp.left}px`),
            "--_1bsv5hl": (0, $lD23V.default)(`${__cmplp.top}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1n9t _1ltvdw55 _154ikz78",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1tKcG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce7d483365831907$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $J8W7q = parcelRequire("J8W7q");
/**
 * Modals in the Chart are portalled out into a fixed position, as not to be clipped.
 */ const $ce7d483365831907$var$ChartModal = ({ position: position, content: content, testId: testId, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce7d483365831907$var$InlineDialogWrapper, {
        // eslint-disable-next-line jira/integration/enforce-data-testid-usage
        "data-test-id": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $J8W7q.default), {
        isOpen: true,
        content: // We would like to re-enable pointer events on the content of the inline dialog to allow interaction with its content
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            xcss: (0, $8CUq3.xcss)({
                pointerEvents: 'initial'
            })
        }, content),
        onClose: onClose,
        closeOnScroll: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce7d483365831907$var$ModalAnchor, position)));
$ce7d483365831907$var$ChartModal.defaultProps = {
    testId: undefined
};
var $ce7d483365831907$export$2e2bcd8739ae039 = $ce7d483365831907$var$ChartModal;
// Child selector is for the nested inline dialog
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce7d483365831907$var$InlineDialogWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _lcxvglyw _ogwtidpf _6tinidpf _1cezidpf _m3zkidpf _hc7q15vq _njtz15vq _bp7o1ceh",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce7d483365831907$var$ModalAnchor = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { left: left, top: top, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_t50dub": (0, $lD23V.default)(`${__cmplp.left}px`),
            "--_1bsv5hl": (0, $lD23V.default)(`${__cmplp.top}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1n9t _1ltvdw55 _154ikz78",
            __cmplp.className
        ])
    });
});

});
parcelRegister("J8W7q", function(module, exports) {

$parcel$export(module.exports, "default", () => $866e6794e0ff4648$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $ctg8C = parcelRequire("ctg8C");
const $866e6794e0ff4648$var$INLINE_DIALOG_PADDING = 32;
const $866e6794e0ff4648$var$THRESHOLD = 50;
const $866e6794e0ff4648$var$TIMEOUT = 500;
function $866e6794e0ff4648$var$WithCloseOnScroll({ isOpen: isOpen, children: children }) {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const containerElement = document.body;
    const distanceXRef = (0, $5uXOq.useRef)(0);
    const distanceYRef = (0, $5uXOq.useRef)(0);
    const timeoutIdRef = (0, $5uXOq.useRef)();
    const shouldClose = ()=>Math.abs(distanceXRef.current) >= $866e6794e0ff4648$var$THRESHOLD || Math.abs(distanceYRef.current) >= $866e6794e0ff4648$var$THRESHOLD;
    const resetThresholdChecking = (0, $5uXOq.useCallback)(()=>{
        distanceYRef.current = 0;
        distanceXRef.current = 0;
        timeoutIdRef.current = undefined;
    }, []);
    const closeDialog = (0, $5uXOq.useCallback)(()=>containerElement?.click(), [
        containerElement
    ]);
    // Function will check if the scroll delta (both horizontal and vertical) is
    // larger than the threshold and close the dialog.
    // If the scroll delta is less than the threshold, we sum all scroll deltas in 500ms.
    // If the sum is larger than the threshold, we close the dialog.
    // Reasoning: want to prevent the dialog from closing immediately if the user accidentally scrolls a few pixels.
    const handleWheel = (0, $5uXOq.useCallback)((e)=>{
        e.stopPropagation();
        distanceXRef.current += e.deltaX;
        distanceYRef.current += e.deltaY;
        if (shouldClose()) {
            closeDialog();
            resetThresholdChecking();
        }
        if (!timeoutIdRef.current) timeoutIdRef.current = setTimeout(()=>{
            if (shouldClose()) closeDialog();
            resetThresholdChecking();
        }, $866e6794e0ff4648$var$TIMEOUT);
    }, [
        closeDialog,
        resetThresholdChecking
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('wheel', handleWheel, {
            passive: true
        });
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('wheel', handleWheel);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return ()=>window.removeEventListener('wheel', handleWheel);
    }, [
        isOpen,
        handleWheel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
}
class $866e6794e0ff4648$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            testId: 'data-inline-dialog-content'
        };
    }
    componentDidMount() {
        this.updateContainerStyles();
    }
    componentDidUpdate() {
        this.updateContainerStyles();
    }
    render() {
        return this.props.closeOnScroll ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($866e6794e0ff4648$var$WithCloseOnScroll, {
            isOpen: this.props.isOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), this.props)) : // @ts-expect-error - TS2741 - Property 'content' is missing in type '{ children?: ReactNode; }' but required in type 'Pick<Pick<PropsWithChildren<InlineDialogProps>, "children" | "content" | "testId" | "strategy" | "isOpen" | "placement" | "onContentBlur" | "onContentClick" | "onContentFocus" | "onClose"> & RefAttributes<...> & WithContextProps, "children" | ... 10 more ... | "onClose">'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), this.props);
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line react/sort-comp
        this.updateContainerStyles = ()=>{
            const { maxWidth: maxWidth, minWidth: minWidth, isOpen: isOpen, noPaddings: noPaddings, noHorizontalScroll: noHorizontalScroll, zIndex: zIndex, overflow: overflow } = this.props;
            if (!isOpen) return;
            // eslint-disable-next-line react/no-find-dom-node
            const node = (0, $7nsd3.findDOMNode)(this);
            // this should find dialog content container,
            // keep it updated as you upgrade @atlaskit/inline-dialog
            const container = node && node.nextElementSibling;
            if (!(container instanceof HTMLElement)) return;
            if (noPaddings) container.style.padding = '0';
            if (maxWidth) {
                const width = noPaddings ? maxWidth : maxWidth + $866e6794e0ff4648$var$INLINE_DIALOG_PADDING;
                container.style.maxWidth = `${width}px`;
                container.style.overflow = 'auto';
            }
            if (minWidth) {
                const width = noPaddings ? minWidth : minWidth + $866e6794e0ff4648$var$INLINE_DIALOG_PADDING;
                container.style.minWidth = `${width}px`;
                container.style.overflow = 'auto';
            }
            if (overflow) container.style.overflow = overflow;
            if (noHorizontalScroll) container.style.maxWidth = 'initial';
            container.style.maxHeight = 'initial';
            //  custom zIndex can be used only when we have 2 or more inline dialogs and has to define their priorities
            // initially it has been added because of https://bulldog.internal.atlassian.com/browse/JPOS-4104
            container.style.zIndex = zIndex;
        };
    }
}

});


parcelRegister("egeYB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fc7195c3567e862$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2kh23 = parcelRequire("2kh23");

var $8QpSo = parcelRequire("8QpSo");

var $gtreQ = parcelRequire("gtreQ");

var $cgL5K = parcelRequire("cgL5K");


var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $1p96B = parcelRequire("1p96B");

var $DVljb = parcelRequire("DVljb");

var $h7glD = parcelRequire("h7glD");

var $ejkLh = parcelRequire("ejkLh");

var $3wpeS = parcelRequire("3wpeS");

var $c9xwE = parcelRequire("c9xwE");
const $2fc7195c3567e862$var$createUnlinkHandler = (0, $8QpSo.default)((itemKey, type, fromId, toId, onUnlink, callback)=>()=>{
        onUnlink({
            itemKey: itemKey,
            type: type,
            sourceItemKey: fromId,
            targetItemKey: toId
        });
        if (callback) callback();
    });
const $2fc7195c3567e862$var$SimpleOverlapWarning = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$Warning, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$WarningIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gtreQ))), {
        size: "small",
        label: "",
        primaryColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "bold",
        color: "inherit"
    }, formatMessage((0, $3wpeS.default).offTrack)));
};
const $2fc7195c3567e862$var$OverlapWarning = ({ fromIssue: fromIssue, toIssue: toIssue })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const locale = (0, $DVljb.useLocale)();
    if (!(fromIssue && fromIssue.dueDate && fromIssue.dueDate > 0 && toIssue && toIssue.startDate && toIssue.startDate > 0)) return null;
    const leadTime = toIssue.startDate - fromIssue.dueDate;
    let overlapPeriod = null; // if "end date" of issue A is May 4, 2021 and "start date" of issue B is May 5, 2021, then leadTime = 1
    if (leadTime === 1) // we display a leadTimeMessage "less than a day"
    // note: we don't use distanceInWords as it would return 'less than a minute'
    overlapPeriod = formatMessage((0, $3wpeS.default).lessThanOneDayLeadTime);
    else overlapPeriod = (0, $2kh23.default)(fromIssue.dueDate, toIssue.startDate, {
        locale: (0, $1p96B.getLocale)(locale)
    });
    return overlapPeriod ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$Warning, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$WarningIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gtreQ))), {
        size: "small",
        label: "",
        primaryColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "bold",
        color: "inherit"
    }, `${formatMessage((0, $3wpeS.default).overlapDatesMessage)} (${overlapPeriod})`, ' ')) : null;
};
const $2fc7195c3567e862$var$ModalContent = (props)=>{
    const { links: links, onUnlink: onUnlink, onClose: onClose, canDelete: canDelete, isOverlapping: isOverlapping, id: id, simpleOverlap: simpleOverlap = false } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (links.length === 0) return null;
     // Each element in the array is a link with the same source and target
    const { fromIssue: fromIssue, toIssue: toIssue, isOfftrack: isOfftrack } = links[0];
    let isDependenciesDatesOverlapping = false;
    if (simpleOverlap && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) isDependenciesDatesOverlapping = isOfftrack ?? false;
    else if (isOverlapping) isDependenciesDatesOverlapping = isOverlapping(fromIssue.indexOnScope, toIssue.indexOnScope);
    const defaultOutwardDependencyDescription = formatMessage((0, $3wpeS.default).blocks);
    const shouldCloseOnUnlink = links.length <= 1;
    const dependenciesBlock = links.map((link, index)=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const { fromIssue: fromIssue, toIssue: toIssue, issueLinkType: issueLinkType, itemKey: itemKey } = link;
        const renderOverlapWarning = ()=>{
            if (simpleOverlap) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$SimpleOverlapWarning, null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$OverlapWarning, {
                fromIssue: fromIssue,
                toIssue: toIssue
            });
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            key: `${issueLinkType.id}_${fromIssue.id}_${toIssue.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h7glD.default), fromIssue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c9xwE.default), {
            label: issueLinkType.outward ?? defaultOutwardDependencyDescription,
            isOverlapping: isDependenciesDatesOverlapping,
            onUnlink: canDelete ? $2fc7195c3567e862$var$createUnlinkHandler(itemKey, issueLinkType.id, fromIssue.id, toIssue.id, onUnlink, shouldCloseOnUnlink ? onClose : undefined) : undefined
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h7glD.default), toIssue), isDependenciesDatesOverlapping && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') && renderOverlapWarning(), isDependenciesDatesOverlapping && !(0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$OverlapWarning, {
            fromIssue: fromIssue,
            toIssue: toIssue
        }), index < links.length - 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ejkLh.default), null) : null);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$Container, {
        id: id,
        "data-testid": "portfolio-3-dependency-line-detail.common.ui.content.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$Content, null, dependenciesBlock));
};
$2fc7195c3567e862$var$ModalContent.defaultProps = {
    onUnlink: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    canDelete: false
};
var $2fc7195c3567e862$export$2e2bcd8739ae039 = $2fc7195c3567e862$var$ModalContent;
const $2fc7195c3567e862$var$TOOLTIP_Z_INDEX = 13; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2fc7195c3567e862$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4pxbi _bfhkhp5a _1bsbp3fh _16qsanr3 _2rko1l7b _c71l1mjv _1reo1wug _18m91wug _1pbyilow",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2fc7195c3567e862$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2fc7195c3567e862$var$Warning = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _19pkutpp _zulp1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2fc7195c3567e862$var$WarningIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _ae4v1h6o _1n261g80",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h7glD", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa6aba85930eb9e5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8RXs9 = parcelRequire("8RXs9");

var $2FvnI = parcelRequire("2FvnI");

var $jVjIH = parcelRequire("jVjIH");

var $jceGp = parcelRequire("jceGp");
const $fa6aba85930eb9e5$var$DependencyCard = (props)=>{
    const { title: title, issueKey: issueKey, projectKey: projectKey, iconUrl: iconUrl, typeName: typeName, intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$ContentLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$TypeIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jVjIH.default), {
        src: iconUrl || '',
        alt: formatMessage((0, $jceGp.default).iconAltText, {
            typeName: typeName
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$IssueLinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2FvnI.default), {
        issueKey: issueKey,
        projectKey: projectKey
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$Title, {
        title: title
    }, title)))));
};
$fa6aba85930eb9e5$var$DependencyCard.displayName = 'DependencyCard';
var $fa6aba85930eb9e5$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $8RXs9.default)($fa6aba85930eb9e5$var$DependencyCard);
const $fa6aba85930eb9e5$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _kqswh2mm _1yt41pyq _bfhk1s4m",
            __cmplp.className
        ])
    });
});
const $fa6aba85930eb9e5$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $fa6aba85930eb9e5$var$ContentLeft = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $fa6aba85930eb9e5$var$TitleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _2lx2vrvc _4cvr1h6o _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $fa6aba85930eb9e5$var$TypeIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $fa6aba85930eb9e5$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81oud _vwz41tcg _syaz1fxt _1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $fa6aba85930eb9e5$var$IssueLinkContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y9ia1q9c _1txj12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2FvnI", function(module, exports) {

$parcel$export(module.exports, "default", () => $33a521d9c353e74c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jhmo0 = parcelRequire("jhmo0");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $fb9D1 = parcelRequire("fb9D1");
function $33a521d9c353e74c$export$2e2bcd8739ae039(props) {
    const { projectKey: projectKey, issueKey: issueKey, issueId: issueId, xcssStyles: xcssStyles, children: children } = props;
    const fullIssueKey = issueKey ? `${projectKey}-${issueKey}` : projectKey;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        href: (0, $fb9D1.proxyContextSafeUrl)(`/browse/${fullIssueKey}`),
        rel: "noopener noreferrer",
        id: issueId && `issue-link-${issueId}`,
        xcss: [
            $33a521d9c353e74c$var$anchorStyles,
            ...xcssStyles ? [
                xcssStyles
            ] : []
        ],
        target: "_blank",
        draggable: (0, $4R6GH.fg)('allows_dragging_an_issue_from_issue_link') ? false : undefined
    }, children || fullIssueKey);
}
const $33a521d9c353e74c$var$anchorStyles = (0, $8CUq3.xcss)({
    outlineOffset: 'space.0'
});

});
parcelRegister("fb9D1", function(module, exports) {

$parcel$export(module.exports, "proxyContextSafeUrl", () => $b99acc067b5c8cc7$export$ff2a151586ba6aa1);
/**
 * All API calls in the confluence macro need to be wrapped in a proxy if the Jira and Confluence have different base urls.
 * Note this should be used for api calls only, not for links.
 */ const $b99acc067b5c8cc7$export$ff2a151586ba6aa1 = (url)=>`${// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.integrationApiUrl || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.AJS && window.AJS.contextPath && window.AJS.contextPath() || ''}${url}`;

});


parcelRegister("jVjIH", function(module, exports) {

$parcel$export(module.exports, "default", () => $82127cf68330cc05$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $82127cf68330cc05$var$Icon = ({ src: src, alt: alt, size: size })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82127cf68330cc05$var$IconImage, {
        src: src,
        alt: alt,
        width: size,
        height: size
    });
$82127cf68330cc05$var$Icon.defaultProps = {
    alt: '',
    size: '16px'
};
var $82127cf68330cc05$export$2e2bcd8739ae039 = $82127cf68330cc05$var$Icon;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $82127cf68330cc05$var$IconImage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _2rko1l7b",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jceGp", function(module, exports) {

$parcel$export(module.exports, "default", () => $567d8624a9993f3b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $567d8624a9993f3b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    iconAltText: {
        "id": "portfolio-3-dependency-line-detail.common.ui.content.card.icon-alt-text",
        "defaultMessage": "{typeName} issue type"
    }
});

});


parcelRegister("ejkLh", function(module, exports) {

$parcel$export(module.exports, "default", () => $82cf6945d1e605c6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $82cf6945d1e605c6$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1yt4pxbi",
            __cmplp.className
        ])
    });
});
const $82cf6945d1e605c6$var$Line = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _vchhusvi _4t3it94y _1bsb1osq _19itukkb",
            __cmplp.className
        ])
    });
});
var $82cf6945d1e605c6$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82cf6945d1e605c6$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82cf6945d1e605c6$var$Line, null));

});

parcelRegister("3wpeS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8a703673539a6f1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d8a703673539a6f1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    blocks: {
        "id": "portfolio-3-dependency-line-detail.common.ui.content.blocks",
        "defaultMessage": "blocks"
    },
    overlapDatesMessage: {
        "id": "portfolio-3-dependency-line-detail.common.ui.content.overlap-dates-message",
        "defaultMessage": "Dates overlap"
    },
    lessThanOneDayLeadTime: {
        "id": "portfolio-3-dependency-line-detail.common.ui.content.less-than-one-day-lead-time",
        "defaultMessage": "less than 1 day"
    },
    offTrack: {
        "id": "portfolio-3-dependency-line-detail.common.ui.content.off-track",
        "defaultMessage": "Off-track"
    }
});

});

parcelRegister("c9xwE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cab14210217549d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $458iJ = parcelRequire("458iJ");


var $2ZvSj = parcelRequire("2ZvSj");
const $9cab14210217549d$var$Separator = ({ label: label, isOverlapping: isOverlapping, onUnlink: onUnlink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$SeparatorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$Line, {
        isOverlapping: isOverlapping
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$IconWrapper, {
        isOverlapping: isOverlapping
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($458iJ))), {
        size: "small",
        label: label,
        primaryColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$Line, {
        isOverlapping: isOverlapping
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$TextContainer, null, label), onUnlink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$UnlinkButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ZvSj.default), {
        onClick: onUnlink
    })));
var $9cab14210217549d$export$2e2bcd8739ae039 = $9cab14210217549d$var$Separator;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9cab14210217549d$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $9cab14210217549d$var$SeparatorContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _18u0pxbi _2hwxu2gc _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $9cab14210217549d$var$TextContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _16jlkb7n _4cvr1h6o _11c81oud _vwz4dlk8",
            __cmplp.className
        ])
    });
});
const $9cab14210217549d$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOverlapping: isOverlapping, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbgktf _4t3igktf _16qs14w9 _2rko1ssb",
            __cmplp.isOverlapping ? "_bfhkk8x7" : "_bfhk1849",
            __cmplp.className
        ])
    });
});
const $9cab14210217549d$var$Line = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOverlapping: isOverlapping, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i19bv _19it1hdd",
            __cmplp.isOverlapping ? "_1h6dk8x7" : "_1h6d1849",
            __cmplp.className
        ])
    });
});
const $9cab14210217549d$var$UnlinkButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _ae4v1h6o _1n261g80",
            __cmplp.className
        ])
    });
});

});
parcelRegister("458iJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f8e117d74b4de46$var$LinkIcon = (props)=>/*#__PURE__*/ $2f8e117d74b4de46$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $2f8e117d74b4de46$var$_link.default
    }));
$2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;

});

parcelRegister("2ZvSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fedf5e35b4f7698$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $fVnbM = parcelRequire("fVnbM");

var $fKe1H = parcelRequire("fKe1H");

var $3bDjY = parcelRequire("3bDjY");

var $8RXs9 = parcelRequire("8RXs9");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");


var $1qzuX = parcelRequire("1qzuX");
// eslint-disable-next-line jira/react/no-class-components
class $3fedf5e35b4f7698$var$UnlinkButton extends (0, $5uXOq.Component) {
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $1qzuX.default).unlink)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            testId: "portfolio-3-dependency-line-detail.common.ui.content.common.components.unlink-button.unlink-button",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fKe1H))), {
                label: formatMessage((0, $1qzuX.default).unlink),
                size: "medium"
            }),
            spacing: "compact",
            appearance: "subtle",
            onClick: this.onClick
        }));
    }
    constructor(...args){
        super(...args);
        this.onClick = (event, analyticsEvent)=>{
            event.stopPropagation();
            this.props.onClick();
            const [actionSubject, action] = (0, $39bd3c5308a092a2$export$de7a70543cfab9e).split(' ');
            const analyticsPayload = {
                source: 'dependencyLineDetail'
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent.update({
                action: action,
                actionSubject: actionSubject
            }), analyticsPayload);
        };
    }
}
var $3fedf5e35b4f7698$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $8RXs9.default), (0, $2OMDV.AnalyticsEventToProps)('button', {
    onClick: 'clicked'
}))($3fedf5e35b4f7698$var$UnlinkButton);

});
const $39bd3c5308a092a2$export$de7a70543cfab9e = 'issueDependencyLink deleted';

parcelRegister("1qzuX", function(module, exports) {

$parcel$export(module.exports, "default", () => $dac8baf8a85055d9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dac8baf8a85055d9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unlink: {
        "id": "portfolio-3-dependency-line-detail.common.ui.content.common.components.unlink-button.unlink",
        "defaultMessage": "Remove dependency"
    }
});

});






parcelRegister("5AKFd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8dbdd46bfa6ce7e$export$2e2bcd8739ae039);

var $4CeiT = parcelRequire("4CeiT");

var $bC2fB = parcelRequire("bC2fB");

var $2xFXk = parcelRequire("2xFXk");


var $1vXOx = parcelRequire("1vXOx");

var $kc6Ry = parcelRequire("kc6Ry");

var $5mTgl = parcelRequire("5mTgl");
const $c8dbdd46bfa6ce7e$export$c31df4bd766f9c35 = (state, ownProps)=>{
    const { id: id } = ownProps;
    const isDraggable = (0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$1d4594bb2516d9ef] && (0, $5mTgl.isInlineColumnEditEnabled)(state) || false;
    return {
        isDraggable: isDraggable,
        flexibleColumns: (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).FLEXIBLE_BOARD_COLUMNS),
        appearance: (0, $5mTgl.getColumnTheme)(state, Number(id)),
        isUpdating: (0, $5mTgl.isColumnUpdating)(state)(id),
        // passing ownProps
        id: ownProps.id,
        draggableIndex: ownProps.draggableIndex,
        header: ownProps.header || null
    };
};
var $c8dbdd46bfa6ce7e$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($c8dbdd46bfa6ce7e$export$c31df4bd766f9c35, {})((0, $4CeiT.default));

});


parcelRegister("sZrZu", function(module, exports) {

$parcel$export(module.exports, "UnassignedFilterCTABoardAnalytics", () => $6d90d8ac80b2e446$export$be236a5aac110186);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $67sX6 = parcelRequire("67sX6");

var $4UXiN = parcelRequire("4UXiN");
const $6d90d8ac80b2e446$export$be236a5aac110186 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const userHasIncompleteAssignedIssues = (0, $67sX6.useBoardSelector)((0, $4UXiN.userHasIncompleteAssignedIssuesSelector));
    const boardHasIncompleteUnassignedWork = (0, $67sX6.useBoardSelector)((0, $4UXiN.boardHasIncompleteUnassignedWorkSelector));
    (0, $5uXOq.useEffect)(()=>{
        const event = createAnalyticsEvent({});
        (0, $8zOmE.fireTrackAnalytics)(event, 'boardInState viewed', {
            userHasIncompleteAssignedIssues: userHasIncompleteAssignedIssues,
            boardHasIncompleteUnassignedWork: boardHasIncompleteUnassignedWork
        });
    }, [
        createAnalyticsEvent,
        userHasIncompleteAssignedIssues,
        boardHasIncompleteUnassignedWork
    ]);
    return null;
};

});



parcelRegister("gGhzv", function(module, exports) {

$parcel$export(module.exports, "default", () => $91db37837dd05a9a$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $bC2fB = parcelRequire("bC2fB");


var $2f454 = parcelRequire("2f454");

var $4gHuj = parcelRequire("4gHuj");

var $dW1HX = parcelRequire("dW1HX");

var $3n65g = parcelRequire("3n65g");

var $71oFY = parcelRequire("71oFY");

var $evkwq = parcelRequire("evkwq");

var $2ON1s = parcelRequire("2ON1s");

var $fqLDH = parcelRequire("fqLDH");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $5MBGv = parcelRequire("5MBGv");

var $hUbDe = parcelRequire("hUbDe");
const $91db37837dd05a9a$var$mapStateToProps = (state)=>({
        // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
        cardKey: (0, $fqLDH.getIssueKeyForModal)(state),
        cardId: (0, $fqLDH.getIssueIdForModal)(state),
        timestamp: (0, $fqLDH.getTimestampForModal)(state),
        externalAction: (0, $fqLDH.getExternalActionForModal)(state),
        boardSessionId: (0, $67Z81.sessionIdSelector)(state),
        activeSprints: (0, $ebHh7.activeSprintsSelector)(state),
        selectedSprints: (0, $ebHh7.getSelectedSprintsKeys)(state),
        isSprintsEnabled: (0, $ebHh7.isSprintsEnabled)(state),
        selectedIssueKey: (0, $fqLDH.getIssueKeyForModal)(state)
    });
const $91db37837dd05a9a$var$mapDispatchToProps = {
    closeIssueModal: $dW1HX.closeIssueModal,
    issueUpdateRequest: $evkwq.issueUpdateRequest,
    setIssueParentSummary: $3n65g.setIssueParentSummary,
    cardDelete: $2f454.cardDelete,
    cardDeleteOptimistic: $2f454.cardDeleteOptimistic,
    onTogglePanel: (0, $2ON1s.togglePanel),
    onCloseInsightsPanel: (0, $2ON1s.closeInsightsPanel),
    issueBentoUpdate: $evkwq.issueBentoUpdate,
    setIssueChildrenRank: $4gHuj.setIssueChildrenRank,
    setIssuesRank: $71oFY.setIssuesRank,
    onResetExternalAction: (0, $dW1HX.resetExternalAction)
};
const $91db37837dd05a9a$var$onDeleteFactory = (0, $8QpSo.default)((dispatchPropsCardDeleteOptimistic, cardId, dispatchPropsIssueUpdateRequest)=>({ issueId: issueId })=>{
        dispatchPropsCardDeleteOptimistic(Number(issueId));
        if (issueId && Number(issueId) !== cardId) dispatchPropsIssueUpdateRequest([
            cardId || 0
        ], (0, $f32ae13c2b9742f4$export$306c754c61954570));
    });
const $91db37837dd05a9a$var$onCloseFactory = (0, $8QpSo.default)((selectedIssueKey, dispatchPropsCloseIssueModal)=>()=>{
        selectedIssueKey && dispatchPropsCloseIssueModal(selectedIssueKey);
    });
const $91db37837dd05a9a$var$mergeProps = (stateProps, dispatchProps, ownProps)=>({
        ...ownProps,
        cardKey: stateProps.cardKey,
        timestamp: stateProps.timestamp,
        externalAction: stateProps.externalAction,
        boardSessionId: stateProps.boardSessionId,
        selectedIssueKey: stateProps.selectedIssueKey,
        cardId: stateProps.cardId,
        onDelete: $91db37837dd05a9a$var$onDeleteFactory(dispatchProps.cardDeleteOptimistic, stateProps.cardId, dispatchProps.issueUpdateRequest),
        onChange: dispatchProps.issueBentoUpdate,
        onClose: $91db37837dd05a9a$var$onCloseFactory(stateProps.selectedIssueKey, dispatchProps.closeIssueModal),
        onCloseInsightsClick: dispatchProps.onCloseInsightsPanel,
        onResetExternalAction: dispatchProps.onResetExternalAction,
        activeSprints: stateProps.activeSprints,
        selectedSprints: stateProps.selectedSprints,
        isSprintsEnabled: stateProps.isSprintsEnabled,
        IssueWrapper: (0, $5MBGv.default)
    });
const $91db37837dd05a9a$var$ConnectedDetailView = (0, $bC2fB.connect)($91db37837dd05a9a$var$mapStateToProps, $91db37837dd05a9a$var$mapDispatchToProps, $91db37837dd05a9a$var$mergeProps)((0, $hUbDe.default));
var $91db37837dd05a9a$export$2e2bcd8739ae039 = $91db37837dd05a9a$var$ConnectedDetailView;

});
parcelRegister("5MBGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc568eefd9719671$export$2e2bcd8739ae039);

var $dGvGJ = parcelRequire("dGvGJ");

var $bC2fB = parcelRequire("bC2fB");

var $ijnUs = parcelRequire("ijnUs");

var $67Z81 = parcelRequire("67Z81");

var $fpo1G = parcelRequire("fpo1G");
const $fc568eefd9719671$var$getBoardCardCountMemoized = ()=>(0, $dGvGJ.createSelector)((0, $ijnUs.getBoardCardCount), (res)=>res);
const $fc568eefd9719671$var$mapStateToPropsFactory = ()=>{
    const getBoardCardCountInstance = $fc568eefd9719671$var$getBoardCardCountMemoized();
    return (state)=>({
            boardCardCount: getBoardCardCountInstance(state),
            isCMPBoard: (0, $67Z81.getIsCMPBoard)(state)
        });
};
const $fc568eefd9719671$var$ConnectedIssueWrapper = (0, $bC2fB.connect)($fc568eefd9719671$var$mapStateToPropsFactory, {})((0, $fpo1G.default));
var $fc568eefd9719671$export$2e2bcd8739ae039 = $fc568eefd9719671$var$ConnectedIssueWrapper;

});
parcelRegister("ijnUs", function(module, exports) {

$parcel$export(module.exports, "getBoardCardCount", () => $b0f6b014cf626ab0$export$3c45ba0e35d4ef0a);

var $vAfHD = parcelRequire("vAfHD");

var $5mTgl = parcelRequire("5mTgl");
const $b0f6b014cf626ab0$export$3c45ba0e35d4ef0a = (state)=>({
        cardsCount: (0, $vAfHD.boardOrderedIssueIdsSelector)(state).length,
        visibleCardsCount: (0, $5mTgl.workFilteredIssuesSelector)(state).length
    });

});

parcelRegister("fpo1G", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7a9ddf7b63aaf97$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7wqBZ = parcelRequire("7wqBZ");

var $hUXfN = parcelRequire("hUXfN");

var $fOGZN = parcelRequire("fOGZN");

var $7eqRV = parcelRequire("7eqRV");


var $kxZPA = parcelRequire("kxZPA");

var $bWjJb = parcelRequire("bWjJb");

var $dWjj9 = parcelRequire("dWjj9");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c7a9ddf7b63aaf97$var$IssueApp = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("82uFl")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $c7a9ddf7b63aaf97$var$NEXT_GEN_BOARD_ANALYTICS_SOURCE = 'simple-software-board';
const $c7a9ddf7b63aaf97$var$IssueWrapper = ({ issueKey: issueKey, externalAction: externalAction, rapidViewId: rapidViewId, boardSessionId: boardSessionId, boardCardCount: boardCardCount, estimationStatistic: estimationStatistic, onResetExternalAction: onResetExternalAction, onChange: onChange, onClose: onClose, onSwitchToModal: onSwitchToModal, onIssueDeleteSuccess: onIssueDeleteSuccess, onIssueKeyChange: onIssueKeyChange, isCMPBoard: isCMPBoard })=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $bWjJb.setIssueViewOpenFeedbackMark)();
    }, [
        issueKey
    ]);
    const configWithAppKey = (0, $fOGZN.simpleSoftwareBoardConfiguration)();
    const { applicationKey: applicationKey, ...configWithoutAppKey } = configWithAppKey;
    // If there's an external action to be fired, dispatch it as soon as possible
    const onSetDispatchExternalActionRef = (0, $5uXOq.useCallback)((dispatchExternalActionRef)=>{
        if (dispatchExternalActionRef && externalAction) // If a keyboard shortcut was the trigger for this external action,
        // the key may propagate into a field that is focused in the
        // issue view. setTimeout prevents this.
        setTimeout(()=>{
            externalAction && dispatchExternalActionRef(externalAction);
            // remove optional checking when cleaning up DEE-930
            onResetExternalAction && onResetExternalAction();
        });
    }, [
        externalAction,
        onResetExternalAction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daJ0i.default), {
        data: {
            source: `boardIssueView${(0, $4d5e0871c06cee03$export$f636b5b56f1d624a)}`,
            attributes: {
                viewMode: 'SIDEBAR'
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c7a9ddf7b63aaf97$var$issueAppContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWjj9.PreIssueViewMountFeedbackMark), {
        issueKey: issueKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eqRV.IssueBoundary), {
        packageName: "software-board"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c7a9ddf7b63aaf97$var$IssueApp, {
        ...configWithoutAppKey,
        analyticsSource: $c7a9ddf7b63aaf97$var$NEXT_GEN_BOARD_ANALYTICS_SOURCE,
        isLoadedWithPage: true,
        issueKey: issueKey,
        onChange: onChange,
        onClose: onClose,
        rapidViewId: rapidViewId,
        viewModeOptions: {
            viewMode: 'SIDEBAR',
            viewModeSwitchEnabled: true,
            onSwitchToModal: onSwitchToModal
        },
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        shouldSetInitialFocus: true,
        shouldShowCloseButton: true,
        metrics: {
            onReadyForUser: ()=>{
                (0, $7wqBZ.getLongTasksMetrics)('bento').stop((0, $hUXfN.bentoReporter), {
                    type: 'sidebar',
                    boardSessionId: boardSessionId
                });
            },
            onInteractive: ()=>{
                (0, $bWjJb.setIssueViewOpenFinishMark)(true, boardCardCount, isCMPBoard);
            }
        },
        onIssueKeyChange: onIssueKeyChange,
        history: null,
        dispatchExternalActionRef: onSetDispatchExternalActionRef,
        estimationStatistic: estimationStatistic ?? undefined
    }))));
};
var $c7a9ddf7b63aaf97$export$2e2bcd8739ae039 = $c7a9ddf7b63aaf97$var$IssueWrapper;
const $c7a9ddf7b63aaf97$var$issueAppContainerStyles = (0, $8CUq3.xcss)({
    height: '100%'
});

});
parcelRegister("hUXfN", function(module, exports) {

$parcel$export(module.exports, "bentoReporter", () => $6bde48e393b34dc9$export$b4ea9d181d8adab2);

var $k12ix = parcelRequire("k12ix");

var $cJpFl = parcelRequire("cJpFl");

var $if7bx = parcelRequire("if7bx");
const $6bde48e393b34dc9$export$b4ea9d181d8adab2 = (observationData, extra)=>{
    if ((0, $cJpFl.isExpandedObservationData)(observationData)) {
        const triggerSoftwareAnalytics = (0, $if7bx.triggerAnalytics)(`software.${observationData.appName}`);
        const startTime = observationData.events.map((event)=>event.timestamp);
        const analyticsData = {
            ...extra,
            ...(0, $if7bx.generateLongTaskAnalyticsSummary)('bento', observationData.events),
            measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime),
            type: extra.type || 'unknown',
            performanceFFs: (0, $k12ix.getPerformanceFFsString)()
        };
        triggerSoftwareAnalytics('long-tasks-bento', analyticsData);
    }
};

});

parcelRegister("7eqRV", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $e3c8771effba3477$export$fbf48ede0cf52b5a);
$parcel$export(module.exports, "IssueModalBoundary", () => $e3c8771effba3477$export$74d408982642a541);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $gjEtj = parcelRequire("gjEtj");

var $lfTZh = parcelRequire("lfTZh");

var $c65JB = parcelRequire("c65JB");
const $e3c8771effba3477$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c65JB.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $e3c8771effba3477$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c65JB.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});
parcelRegister("gjEtj", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $c322f875acea1654$export$c3f500e812fb1bb3);

var $5uXOq = parcelRequire("5uXOq");

var $gAeCk = parcelRequire("gAeCk");

var $iqr2y = parcelRequire("iqr2y");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");
const $c322f875acea1654$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $5uXOq.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqr2y.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: id,
        fallback: fallback
    }, children));
};

});


parcelRegister("bWjJb", function(module, exports) {

$parcel$export(module.exports, "setIssueViewOpenFeedbackMark", () => $29f6b5adabb5126e$export$2c1211bae6c14a9);
$parcel$export(module.exports, "setIssueViewOpenFinishMark", () => $29f6b5adabb5126e$export$74c6496311688a4d);

var $k12ix = parcelRequire("k12ix");

var $hz3OZ = parcelRequire("hz3OZ");
const $29f6b5adabb5126e$export$2c1211bae6c14a9 = ()=>{
    (0, $hz3OZ.issueViewOpenInteraction).mark('feedback');
};
const $29f6b5adabb5126e$export$74c6496311688a4d = (isSideBar, boardCardCount, isCMPBoard)=>(0, $hz3OZ.issueViewOpenInteraction).stop({
        customData: {
            ...(0, $k12ix.getNormalisedPerformanceFFs)(),
            ...boardCardCount,
            isSideBar: isSideBar,
            isClassic: isCMPBoard
        }
    });

});

parcelRegister("dWjj9", function(module, exports) {

$parcel$export(module.exports, "PreIssueViewMountFeedbackMark", () => $60fb965de9301d5f$export$e17cfe6a40740e70);

var $5uXOq = parcelRequire("5uXOq");

var $hz3OZ = parcelRequire("hz3OZ");
const $60fb965de9301d5f$export$e17cfe6a40740e70 = ({ issueKey: issueKey })=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $hz3OZ.issueViewOpenInteraction).mark('feedbackPreMountEnd');
    }, [
        issueKey
    ]);
    return null;
};

});

parcelRegister("82uFl", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("92sUi"),
    $6fhBS("i5RRW"),
    $6fhBS("dsiAd"),
    $6fhBS("kWrFZ"),
    $6fhBS("2Lfdl"),
    $6fhBS("eNmuD"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cggv6")
]).then(()=>parcelRequire('6qbjz'));

});



parcelRegister("hUbDe", function(module, exports) {

$parcel$export(module.exports, "default", () => $e945a1a602f86336$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $2gCtH = parcelRequire("2gCtH");

var $9PAwV = parcelRequire("9PAwV");

var $g5X3G = parcelRequire("g5X3G");

var $jQ7vZ = parcelRequire("jQ7vZ");

var $iUagi = parcelRequire("iUagi");

var $67sX6 = parcelRequire("67sX6");

var $2ON1s = parcelRequire("2ON1s");

var $6g14V = parcelRequire("6g14V");

var $63LqY = parcelRequire("63LqY");

var $7RXC2 = parcelRequire("7RXC2");

var $8nkAM = parcelRequire("8nkAM");

var $ca5yC = parcelRequire("ca5yC");
const $e945a1a602f86336$export$d51fb174c0dd91e9 = ({ parentWidth: parentWidth, cardKey: cardKey, rapidViewId: rapidViewId, isDetailViewSidebar: isDetailViewSidebar, isInsightsPanelOpen: isInsightsPanelOpen, projectId: projectId, onClose: onClose, onChange: onChange, onDelete: onDelete, onCloseInsightsClick: onCloseInsightsClick, onResetExternalAction: onResetExternalAction, timestamp: timestamp, externalAction: externalAction, boardSessionId: boardSessionId, activeSprints: activeSprints, selectedSprints: selectedSprints, isSprintsEnabled: isSprintsEnabled, estimationStatistic: estimationStatistic, IssueWrapper: IssueWrapper })=>{
    const [issueKey, setIssueKey] = (0, $jQ7vZ.useQueryParam)('selectedIssue');
    const issueKeyOrCardKey = issueKey || cardKey;
    const onIssueKeyChange = (0, $5uXOq.useCallback)(({ toIssueKey: toIssueKey })=>setIssueKey(toIssueKey), [
        setIssueKey
    ]);
    const [, { setDetailViewAsModal: setDetailViewAsModal }] = (0, $2gCtH.useIssueContextActions)();
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const isViewSettingPanelOpen = (0, $67sX6.useBoardSelector)((0, $6g14V.getViewSettingsPanel));
    const onCloseViewSettingsPanel = (0, $67sX6.useBoardActionCreator)(()=>(0, $2ON1s.closeViewSettingsPanel)());
    if (!cardKey && !isInsightsPanelOpen && (!(0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() || !isViewSettingPanelOpen)) return null;
    const hasSprints = activeSprints != null && activeSprints.length > 0;
    return (0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() && isViewSettingPanelOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8nkAM.ViewSettingsPanel), {
        isPanelOpen: isViewSettingPanelOpen,
        onPanelClose: onCloseViewSettingsPanel
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9PAwV.JiraDetailPanel), null, (setDetailPanelWidth)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ca5yC.default), {
            parentWidth: parentWidth,
            useFixedMinWidth: false,
            onResize: setDetailPanelWidth
        }, cardKey && isDetailViewSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e945a1a602f86336$var$DetailsWrapper, {
            "data-testid": "software-board.detail-view.issue-wrapper",
            hide: isInsightsPanelOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IssueWrapper, {
            key: issueKeyOrCardKey + timestamp,
            issueKey: (0, $g5X3G.toIssueKey)(issueKeyOrCardKey),
            onClose: onClose,
            onChange: onChange,
            onIssueDeleteSuccess: onDelete,
            rapidViewId: Number(rapidViewId),
            onSwitchToModal: setDetailViewAsModal,
            onIssueKeyChange: onIssueKeyChange,
            externalAction: externalAction,
            boardSessionId: boardSessionId,
            estimationStatistic: estimationStatistic,
            onResetExternalAction: onResetExternalAction
        })), (!isSprintsEnabled || hasSprints) && isInsightsPanelOpen ? // `isSprintsEnabled` is to check whether it's kanban
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e945a1a602f86336$var$DetailsPanelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7RXC2.AsyncBoardInsightsPanel), {
            isSimplifiedProject: !isCMPBoard,
            isOpen: isInsightsPanelOpen,
            onClose: onCloseInsightsClick,
            rapidViewId: Number(rapidViewId),
            activeSprint: activeSprints?.[0],
            projectId: projectId,
            sprints: activeSprints,
            selectedSprints: selectedSprints,
            isSprintsEnabled: isSprintsEnabled
        }))) : null));
};
var $e945a1a602f86336$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
 = /*#__PURE__*/ (0, $5uXOq.memo)($e945a1a602f86336$export$d51fb174c0dd91e9);
const $e945a1a602f86336$var$DetailsWrapperControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "f0nhux-0"
})((props)=>({
        flex: 1,
        height: '100%',
        overflowX: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props.hide ? 'none' : undefined
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e945a1a602f86336$var$DetailsWrapperExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hide: hide, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _4t3i1osq _1reo15vq",
            __cmplp.hide && "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $e945a1a602f86336$var$DetailsWrapper = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $e945a1a602f86336$var$DetailsWrapperExperiment, $e945a1a602f86336$var$DetailsWrapperControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e945a1a602f86336$var$DetailsPanelContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _kqswh2mm _4t3i1osq _1reo15vq _18m915zi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9PAwV", function(module, exports) {

$parcel$export(module.exports, "JiraDetailPanel", () => $90f8c6fec93ae563$export$93acb63f4e179357);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $34ck9 = parcelRequire("34ck9");

var $heNNl = parcelRequire("heNNl");

var $5e5zm = parcelRequire("5e5zm");
const $90f8c6fec93ae563$var$DetailPanel = ({ children: children, panelWidth: panelWidth })=>{
    const { setWidth: setWidth } = (0, $5e5zm.useDetailPanelActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (panelWidth !== undefined) setWidth(panelWidth);
        return ()=>setWidth(0);
    }, [
        panelWidth,
        setWidth
    ]);
    const throttleSetWidth = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(setWidth, 50, {
            leading: true,
            trailing: true
        }), [
        setWidth
    ]);
    return typeof children === 'function' ? children(throttleSetWidth) : children;
};
const $90f8c6fec93ae563$export$93acb63f4e179357 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "jira-detail-panel",
        packageName: "jira-bottom-right-corner-controller",
        render: ()=>typeof props.children === 'function' ? props.children((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))) : props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($90f8c6fec93ae563$var$DetailPanel, props));

});

parcelRegister("7RXC2", function(module, exports) {

$parcel$export(module.exports, "AsyncBoardInsightsPanel", () => $f36a347b006f1cec$export$1ece9ee19d846df5);
/* async.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");

var $gwIPs = parcelRequire("gwIPs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $f36a347b006f1cec$var$LazyBoardInsightsPanel = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("4K1U2")), {
    moduleId: "./src/packages/software/board/src/view/board-panels/insights-panel/index.tsx"
});
const $f36a347b006f1cec$export$1ece9ee19d846df5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "board-insights-panel",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f36a347b006f1cec$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "large"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f36a347b006f1cec$var$LazyBoardInsightsPanel, props));
const $f36a347b006f1cec$var$maxWidth = (0, $gwIPs.gridSize) * 47; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f36a347b006f1cec$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n3tdv77o _18s8155u _vchhusvi _p12f4u42 _1bsb4u42",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4K1U2", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("5unop")
]).then(()=>parcelRequire('luBlw'));

});


parcelRegister("8nkAM", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsPanel", () => $129c8c1752459575$export$3a81a9760a380951);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $h9kUS = parcelRequire("h9kUS");
var $8CUq3 = parcelRequire("8CUq3");


var $d6YZC = parcelRequire("d6YZC");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ipmBb = parcelRequire("ipmBb");

var $a4XJc = parcelRequire("a4XJc");

var $jB6yt = parcelRequire("jB6yt");

var $dIdda = parcelRequire("dIdda");

var $iuuJH = parcelRequire("iuuJH");

var $67sX6 = parcelRequire("67sX6");

var $3n582 = parcelRequire("3n582");

var $4RVsR = parcelRequire("4RVsR");

var $k50Aq = parcelRequire("k50Aq");

var $4vVV6 = parcelRequire("4vVV6");

var $vAfHD = parcelRequire("vAfHD");

var $gR0bs = parcelRequire("gR0bs");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");
const $129c8c1752459575$export$3a81a9760a380951 = ({ isPanelOpen: isPanelOpen, onPanelClose: onPanelClose })=>{
    const rapidViewId = (0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector));
    const epicCustomName = (0, $67sX6.useBoardSelector)((0, $67Z81.getHierarchyNomenclature))?.firstLevelName;
    const hasSwimlanes = (0, $67sX6.useBoardSelector)((0, $45cXl.getSwimlaneMode)) !== (0, $iuuJH.NO_SWIMLANE).id;
    const swimlaneIds = (0, $67sX6.useBoardSelector)((0, $5mTgl.platformSwimlaneIdsSelector));
    const onSwimlaneExpandAll = (0, $67sX6.useBoardActionCreator)(()=>(0, $k50Aq.swimlanesExpand)());
    const onSwimlaneCollapseAll = (0, $67sX6.useBoardActionCreator)(()=>(0, $k50Aq.swimlanesCollapse)(swimlaneIds));
    const isCompanyManaged = (0, $63LqY.useIsCMPBoard)();
    const isQuickFilterAvailable = (0, $67sX6.useBoardSelector)((0, $5mTgl.getCustomFilters)).length > 0;
    const showFilterBarToggle = isCompanyManaged && isQuickFilterAvailable;
    const isDaysInColumnEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsDaysInColumnEnabled));
    const isEstimateEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsEstimateEnabled));
    const isDueDateEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsDueDateEnabled));
    const isLabelsEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIssueLabelsEnabled));
    const isPriorityEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsPriorityEnabled));
    const isDevelopmentEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsDevelopmentEnabled));
    const isJSWBoard = (0, $63LqY.useIsJSWBoard)();
    const cardExtraFields = (0, $67sX6.useBoardSelector)((0, $67Z81.getCardExtraFields));
    const firstSelectableIssueId = (0, $67sX6.useBoardSelector)((0, $gR0bs.getFirstSelectableIssueAscending));
    const { canUserLinkIssue: canUserLinkIssue, issueLinkTypes: issueLinkTypes } = (0, $67sX6.useBoardSelector)((0, $4vVV6.getIssueLinksPermissions));
    const isIssueLinkingEnabledOnInstance = canUserLinkIssue && issueLinkTypes?.length > 0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const boardIssueIds = (0, $67sX6.useBoardSelector)((0, $vAfHD.boardOrderedIssueIdsSelector));
    const onLinkedIssuesStatsToggledOn = (0, $67sX6.useBoardActionCreator)(()=>(0, $4RVsR.fetchIssueLinksStats)(boardIssueIds, {
            analyticsEvent: createAnalyticsEvent({})
        }));
    const onShowCardCoversToggledOn = (0, $67sX6.useBoardActionCreator)(()=>(0, $3n582.fetchCardCovers)(boardIssueIds, {
            analyticsEvent: createAnalyticsEvent({})
        }));
    const { data: isWorkSuggestionsEnabledData, update: updateWorkSuggestionsResource, loading: loadingWorkSuggestionsEnabled } = (0, $dIdda.useResource)((0, $ipmBb.nextBestTaskFeatureResource));
    const [, { doFetch: updateWorkSuggestionsEnabled }] = (0, $d6YZC.useNextBestTaskUserPreference)();
    const onToggleWorkSuggestions = (analyticsEvent)=>{
        const newOptInValue = !isWorkSuggestionsEnabledData?.hasUserOptedIn;
        updateWorkSuggestionsResource(()=>({
                hasUserOptedIn: newOptInValue
            }));
        updateWorkSuggestionsEnabled({
            hasUserOptedIn: newOptInValue
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $ba3e099a37b09fda$export$9957974f8b4d8f74), {
            hasUserOptedIn: newOptInValue
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $129c8c1752459575$var$ViewSettingWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jB6yt.default), {
        isViewPanelOpen: isPanelOpen,
        onViewPanelClose: onPanelClose,
        boardId: Number(rapidViewId),
        isClassic: isCompanyManaged,
        view: (0, $a4XJc.View).BOARD,
        viewAs: (0, $a4XJc.ViewAs).PANEL,
        epicCustomName: epicCustomName,
        // showdetails is true for JSW board
        showCardDetails: true,
        isSwimlanesEnabled: hasSwimlanes,
        onSwimlaneExpandAll: onSwimlaneExpandAll,
        onSwimlaneCollapseAll: onSwimlaneCollapseAll,
        showFilterBarToggle: showFilterBarToggle,
        isDaysInColumnEnabled: isDaysInColumnEnabled,
        isEstimateEnabled: isEstimateEnabled,
        onToggleWorkSuggestions: onToggleWorkSuggestions,
        isDueDateEnabled: isDueDateEnabled,
        isPriorityEnabled: isPriorityEnabled,
        isDevelopmentEnabled: isDevelopmentEnabled,
        isLabelsEnabled: !isCompanyManaged && isLabelsEnabled,
        isWorkSuggestionsEnabled: !!isWorkSuggestionsEnabledData?.hasUserOptedIn,
        showWorkSuggestions: isWorkSuggestionsEnabledData != null && !loadingWorkSuggestionsEnabled && isJSWBoard,
        showLinkedIssueStatsToggle: isIssueLinkingEnabledOnInstance && Boolean(firstSelectableIssueId),
        onLinkedIssuesStatsToggledOn: onLinkedIssuesStatsToggledOn,
        cardExtraFields: cardExtraFields,
        onShowCardCoversToggledOn: onShowCardCoversToggledOn
    }));
};
const $129c8c1752459575$var$ViewSettingWrapperStyles = (0, $8CUq3.xcss)({
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingRight: 'space.500',
    paddingBottom: 'space.300',
    minWidth: '330px',
    [(0, $h9kUS.media).above.lg]: {
        minWidth: '360px'
    }
});

});
const $ba3e099a37b09fda$export$bca1afd1dbd279c8 = '/rest/api/3/mypreferences?key=next-best-task-feature';
const $ba3e099a37b09fda$export$b8b9d90f9e5bd72b = 'jiraPersonalSettingsNextBestTask';
const $ba3e099a37b09fda$export$14a3a0c00f727781 = 'updateNextBestTaskOptInPreference';
const $ba3e099a37b09fda$export$7147685613ef9998 = '2HtqtVTfYoilHIuYJIGD1T';
const $ba3e099a37b09fda$export$14b33d63628336c2 = 'jsw.labs.next-best-task-opt-in';
const $ba3e099a37b09fda$export$9957974f8b4d8f74 = 'jira.insights.nextBestTask.optInToggle';

parcelRegister("d6YZC", function(module, exports) {

$parcel$export(module.exports, "useNextBestTaskUserPreference", () => $3eea00ee2b5a44ce$export$e898b74b14e8af9);

var $iuEfD = parcelRequire("iuEfD");

var $5IV0G = parcelRequire("5IV0G");

const $3eea00ee2b5a44ce$var$updateNbtOptInPreference = async (fetchOptions, payload)=>{
    const response = await (0, $5IV0G.performPutRequest)((0, $ba3e099a37b09fda$export$bca1afd1dbd279c8), {
        ...fetchOptions,
        body: JSON.stringify(payload)
    });
    return response;
};
const $3eea00ee2b5a44ce$export$e898b74b14e8af9 = ()=>(0, $iuEfD.useFetch)({
        onFetch: (fetchOptions, payload)=>$3eea00ee2b5a44ce$var$updateNbtOptInPreference(fetchOptions, payload),
        analyticsTracking: {
            actionSubject: `useFetch.${(0, $ba3e099a37b09fda$export$14a3a0c00f727781)}`,
            packageName: (0, $ba3e099a37b09fda$export$b8b9d90f9e5bd72b),
            action: 'dataUpdate'
        },
        loggingKey: `${(0, $ba3e099a37b09fda$export$b8b9d90f9e5bd72b)}.${(0, $ba3e099a37b09fda$export$14a3a0c00f727781)}`,
        isAutoFetchable: false
    }, []);

});
parcelRegister("iuEfD", function(module, exports) {

$parcel$export(module.exports, "useFetch", () => $082fa94a7a9fe60c$export$d852f5f778460fa4);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $aAhmV = parcelRequire("aAhmV");

var $d6Xq4 = parcelRequire("d6Xq4");

var $bYINM = parcelRequire("bYINM");

var $lUlda = parcelRequire("lUlda");

var $dg0bO = parcelRequire("dg0bO");

var $eW4Xh = parcelRequire("eW4Xh");
const $082fa94a7a9fe60c$export$d852f5f778460fa4 = ({ onFetch: onFetch, isAutoFetchable: isAutoFetchable = true, analyticsTracking: analyticsTracking, browserMetricsKey: browserMetricsKey, loggingKey: loggingKey, initialData: initialData, isAbortable: isAbortable = true }, fetchDependencies)=>{
    const [state, dispatch] = (0, $5uXOq.useReducer)((0, $bYINM.reducer), {
        ...(0, $dg0bO.initialState),
        data: initialData
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { initialized: initialized, fetched: fetched, loading: loading } = state;
    const abortControllerRef = (0, $5uXOq.useRef)();
    const fetchDependenciesRef = (0, $5uXOq.useRef)(fetchDependencies);
    const isMounted = (0, $5uXOq.useRef)(true);
    const getAbortController = (0, $5uXOq.useCallback)(()=>{
        const controller = abortControllerRef.current;
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        if (!abortControllerRef.current || controller?.signal.aborted) abortControllerRef.current = new AbortController();
        return abortControllerRef.current;
    }, []);
    const callFetch = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args)=>{
        // @ts-expect-error - TS2339 - Property 'signal' does not exist on type 'unknown'.
        const { signal: signal } = getAbortController();
        (0, $eW4Xh.thunks).fetch({
            onFetch: async ()=>{
                try {
                    return await onFetch({
                        signal: signal
                    }, ...args);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    throw new (0, $d6Xq4.UseFetchHandledError)(isMounted.current, e);
                }
            },
            analyticsTracking: analyticsTracking,
            createAnalyticsEvent: createAnalyticsEvent,
            browserMetricsKey: browserMetricsKey,
            loggingKey: loggingKey,
            signal: signal
        })({
            actions: (0, $aAhmV.buildActionDispatchers)(dispatch)
        });
    }, [
        onFetch,
        analyticsTracking,
        browserMetricsKey,
        createAnalyticsEvent,
        loggingKey,
        getAbortController
    ]);
    const doAbort = (0, $5uXOq.useCallback)(()=>{
        if (isAbortable) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        getAbortController().abort();
    }, [
        getAbortController,
        isAbortable
    ]);
    const doFetch = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args)=>{
        if (loading) doAbort();
        callFetch(...args);
    }, [
        loading,
        callFetch,
        doAbort
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const hasEffectsChanged = (0, $lUlda.isShallowDifferent)(fetchDependenciesRef.current, fetchDependencies);
        if (!initialized && !fetched || hasEffectsChanged) {
            if (hasEffectsChanged) fetchDependenciesRef.current = fetchDependencies;
            if (hasEffectsChanged) doAbort();
            if (isAutoFetchable) callFetch();
            else if (initialized && hasEffectsChanged) dispatch({
                type: 'resetInitialState',
                payload: null
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        initialized,
        doAbort,
        fetched,
        callFetch,
        isAutoFetchable,
        ...fetchDependencies
    ]);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            doAbort();
        };
    }, [
        doAbort
    ]);
    return [
        state,
        {
            doFetch: doFetch,
            doAbort: doAbort
        }
    ];
};

});
parcelRegister("aAhmV", function(module, exports) {

$parcel$export(module.exports, "buildActionDispatchers", () => $b5443ab87e9d487f$export$5297818927df1cbf);

var $aTJxm = parcelRequire("aTJxm");
const $b5443ab87e9d487f$export$5297818927df1cbf = (dispatch)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys((0, $aTJxm.strategies)).reduce((accumulator, strategy)=>{
        accumulator[strategy] = (payload)=>dispatch({
                type: strategy,
                payload: payload
            });
        return accumulator;
    }, {});
const $b5443ab87e9d487f$export$25b8423a7d935d64 = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys((0, $aTJxm.strategies)).reduce((accumulator, strategy)=>{
        accumulator[strategy] = (key, initialData, payload)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const sliceState = state.fetchables[key] || initialData;
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly resetInitialState: () => { readonly initialized: false; readonly loading: false; readonly fetched: false; readonly hasError: false; readonly aborted: false; readonly error: undefined; readonly data: undefined; }; ... 4 more ...; readonly default: (state: FetchState) => FetchState; }'.
                const nextSliceState = (0, $aTJxm.strategies)[strategy](sliceState, {
                    type: strategy,
                    payload: payload
                });
                const nextState = {
                    ...state,
                    fetchables: {
                        ...state.fetchables,
                        [key]: nextSliceState
                    }
                };
                setState(nextState);
            };
        return accumulator;
    }, {});
const $b5443ab87e9d487f$export$7f88d514aa0ad345 = ({ actions: actions, key: key, initialData: initialData })=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(actions).reduce((accumulator, strategy)=>{
        const actionExecutor = actions[strategy];
        accumulator[strategy] = (payload)=>{
            actionExecutor(key, initialData, payload);
        };
        return accumulator;
    }, {});

});
parcelRegister("aTJxm", function(module, exports) {

$parcel$export(module.exports, "strategies", () => $e708554df9e0cc9d$export$c5491a8691a23b9e);

var $dg0bO = parcelRequire("dg0bO");
const $e708554df9e0cc9d$var$resetInitialState = ()=>(0, $dg0bO.initialState);
const $e708554df9e0cc9d$var$setFetchStart = (state)=>({
        ...state,
        initialized: true,
        loading: true,
        fetched: false,
        hasError: false,
        aborted: false
    });
const $e708554df9e0cc9d$var$setFetchEnd = (_, action)=>({
        initialized: true,
        loading: false,
        fetched: true,
        hasError: false,
        aborted: false,
        data: action.payload
    });
const $e708554df9e0cc9d$var$setError = (_, action)=>({
        error: action.payload,
        initialized: true,
        loading: false,
        fetched: false,
        hasError: true,
        aborted: false
    });
const $e708554df9e0cc9d$var$setAborted = ()=>({
        initialized: true,
        loading: false,
        fetched: false,
        hasError: false,
        aborted: true
    });
const $e708554df9e0cc9d$var$setDefault = (state)=>state;
const $e708554df9e0cc9d$export$c5491a8691a23b9e = {
    resetInitialState: $e708554df9e0cc9d$var$resetInitialState,
    setFetchStart: $e708554df9e0cc9d$var$setFetchStart,
    setFetchEnd: $e708554df9e0cc9d$var$setFetchEnd,
    setError: $e708554df9e0cc9d$var$setError,
    setAborted: $e708554df9e0cc9d$var$setAborted,
    default: $e708554df9e0cc9d$var$setDefault
};

});
parcelRegister("dg0bO", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $147c98f07a60815a$export$d4c72bab9d6cc13a);
const $147c98f07a60815a$export$d4c72bab9d6cc13a = {
    initialized: false,
    loading: false,
    fetched: false,
    hasError: false,
    aborted: false,
    error: undefined,
    data: undefined
};

});



parcelRegister("d6Xq4", function(module, exports) {

$parcel$export(module.exports, "UseFetchHandledError", () => $7de9d917d4a5c394$export$2801d9c787d65a99);
class $7de9d917d4a5c394$export$2801d9c787d65a99 extends Error {
    constructor(componentMounted, e){
        super(e?.message || 'Unknown');
        this.originalError = e;
        this.componentMounted = !!componentMounted;
    }
}

});

parcelRegister("bYINM", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $82dfd012f8e9e396$export$1650419e431d3ba3);

var $aTJxm = parcelRequire("aTJxm");

var $dg0bO = parcelRequire("dg0bO");
const $82dfd012f8e9e396$export$1650419e431d3ba3 = (state = (0, $dg0bO.initialState), action)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly resetInitialState: () => { readonly initialized: false; readonly loading: false; readonly fetched: false; readonly hasError: false; readonly aborted: false; readonly error: undefined; readonly data: undefined; }; ... 4 more ...; readonly default: (state: FetchState) => FetchState; }'.
    const transformer = (0, $aTJxm.strategies)[action.type] || (0, $aTJxm.strategies).default;
    return transformer(state, action);
};

});

parcelRegister("lUlda", function(module, exports) {

$parcel$export(module.exports, "isShallowDifferent", () => $76bb872f5000fbec$export$a42e2ec7d66a0c03);
const $76bb872f5000fbec$export$a42e2ec7d66a0c03 = (arrayA, arrayB)=>arrayA.length !== arrayB.length || arrayA.some((currentElement, index)=>currentElement !== arrayB[index]);

});

parcelRegister("eW4Xh", function(module, exports) {

$parcel$export(module.exports, "thunks", () => $4eddb453cf1aa4e2$export$eb2332b8a94a914a);

var $eUcR1 = parcelRequire("eUcR1");

var $dTD3b = parcelRequire("dTD3b");

var $7lFwJ = parcelRequire("7lFwJ");
const $4eddb453cf1aa4e2$export$eb2332b8a94a914a = {
    fetch: ({ onFetch: onFetch, analyticsTracking: analyticsTracking, browserMetricsKey: browserMetricsKey, loggingKey: loggingKey, signal: signal, createAnalyticsEvent: createAnalyticsEvent })=>{
        const metricsTracker = (0, $eUcR1.trackBrowserMetricsForJira)({
            browserMetricsKey: browserMetricsKey
        });
        const logger = (0, $7lFwJ.loggingHandler)({
            loggingKey: loggingKey
        });
        return async ({ actions: actions })=>{
            const analyticsTracker = (0, $dTD3b.trackDataFetchAnalytics)({
                ...analyticsTracking,
                createAnalyticsEvent: createAnalyticsEvent
            });
            metricsTracker.start();
            analyticsTracker.start();
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            actions.setFetchStart();
            try {
                const data = await onFetch({
                    signal: signal
                });
                actions.setFetchEnd(data);
                metricsTracker.end();
                analyticsTracker.succeeded();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                metricsTracker.cancel();
                if (e.componentMounted) {
                    if (signal.aborted) {
                        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
                        actions.setAborted();
                        analyticsTracker.aborted();
                    } else {
                        const thrownError = e.originalError;
                        actions.setError(thrownError);
                        analyticsTracker.failed(thrownError);
                        logger.error(thrownError);
                    }
                }
            }
        };
    }
};

});
parcelRegister("eUcR1", function(module, exports) {

$parcel$export(module.exports, "trackBrowserMetricsForJira", () => $ce81c3c268f844ac$export$d8b2320f7d41dc1d);

var $dGrdR = parcelRequire("dGrdR");

var $30KM0 = parcelRequire("30KM0");
const $ce81c3c268f844ac$export$d8b2320f7d41dc1d = ({ browserMetricsKey: browserMetricsKey, attributes: attributes, histogram: // Define bucket sizes for histogram. e.g.: '100_500_1000_2500_5000_10000'. Default to '500_1000_1500_4000_7000'.
histogram })=>{
    if (browserMetricsKey === null || browserMetricsKey === undefined) return {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        start: ()=>{},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        end: ()=>{},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        cancel: ()=>{}
    };
    const bm3MetricsTracker = (0, $dGrdR.metrics).interaction({
        key: browserMetricsKey,
        // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string | undefined; }' but required in type 'InteractionHistogramConfig'.
        histogram: {
            result: histogram || (0, $30KM0.DEFAULT_HISTOGRAM_BUCKETS)
        }
    });
    const startHandler = ()=>{
        bm3MetricsTracker.start();
    };
    const endHandler = ()=>{
        bm3MetricsTracker.stop({
            customData: attributes
        });
    };
    const cancelHandler = ()=>{
        bm3MetricsTracker.cancel();
    };
    return {
        start: startHandler,
        end: endHandler,
        cancel: cancelHandler
    };
};

});
parcelRegister("30KM0", function(module, exports) {

$parcel$export(module.exports, "STORE_NAME", () => $b92906e2cd9ec8a5$export$cd79d01fb3d2f506);
$parcel$export(module.exports, "experiences", () => $b92906e2cd9ec8a5$export$9848ee2a7d21002f);
$parcel$export(module.exports, "TIMEOUT_IN_MS", () => $b92906e2cd9ec8a5$export$9ebf97d10ce21f3b);
$parcel$export(module.exports, "DEFAULT_HISTOGRAM_BUCKETS", () => $b92906e2cd9ec8a5$export$e3b77a602bc4d0e6);

const $b92906e2cd9ec8a5$export$cd79d01fb3d2f506 = `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.experience-tracker-store`;
const $b92906e2cd9ec8a5$export$9848ee2a7d21002f = {
    RENDER: 'render'
};
const $b92906e2cd9ec8a5$export$9ebf97d10ce21f3b = 7000;
const $b92906e2cd9ec8a5$export$e3b77a602bc4d0e6 = '500_1000_1500_4000_7000';

});


parcelRegister("dTD3b", function(module, exports) {

$parcel$export(module.exports, "trackDataFetchAnalytics", () => $e920ac60c98f1376$export$bc65acfb4b442c00);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");

var $93kZ7 = parcelRequire("93kZ7");
const $e920ac60c98f1376$export$d14e9b22afc87cb3 = (statusCode)=>{
    if (statusCode === null) return (0, $93kZ7.statusCodeGroups).UNKNOWN;
    if (statusCode >= 100 && statusCode <= 199) return (0, $93kZ7.statusCodeGroups).INFORMATIONAL_RESPONSES;
    if (statusCode >= 200 && statusCode <= 299) return (0, $93kZ7.statusCodeGroups).SUCCESS_RESPONSES;
    if (statusCode >= 300 && statusCode <= 399) return (0, $93kZ7.statusCodeGroups).REDIRECTS;
    if (statusCode >= 400 && statusCode <= 499) return (0, $93kZ7.statusCodeGroups).CLIENT_ERRORS;
    if (statusCode >= 500 && statusCode <= 599) return (0, $93kZ7.statusCodeGroups).SERVER_ERRORS;
    return (0, $93kZ7.statusCodeGroups).UNKNOWN;
};
const $e920ac60c98f1376$var$includeSample = (sampleRate)=>Math.random() <= 1 / sampleRate;
const $e920ac60c98f1376$var$noopAnalytics = Object.freeze({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    start: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    succeeded: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    failed: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    aborted: ()=>{}
});
const $e920ac60c98f1376$export$bc65acfb4b442c00 = ({ action: action = 'dataFetch', actionSubject: actionSubject, packageName: packageName, createAnalyticsEvent: createAnalyticsEvent, sampleRate: sampleRate })=>{
    if (actionSubject == null) return $e920ac60c98f1376$var$noopAnalytics;
    if (sampleRate != null && !$e920ac60c98f1376$var$includeSample(sampleRate)) return $e920ac60c98f1376$var$noopAnalytics;
    // Note: Operational analytics do NOT use actionSubjectId!
    const actionSubjectAndAction = `${actionSubject} ${action}`;
    return Object.freeze({
        start: ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                status: (0, $93kZ7.analyticsStatuses).STARTED,
                packageName: packageName
            });
        },
        succeeded: ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                statusCodeGroup: '2xx',
                status: (0, $93kZ7.analyticsStatuses).SUCCEEDED,
                packageName: packageName
            });
        },
        failed: (e)=>{
            const error = e !== null && e !== undefined ? e : new Error('Unknown error, e should be present');
            if (!(0, $fZneA.isClientFetchError)(e)) {
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                    statusCodeGroup: $e920ac60c98f1376$export$d14e9b22afc87cb3(error instanceof (0, $jJZqs.default) ? error.statusCode : -1),
                    status: (0, $93kZ7.analyticsStatuses).FAILED,
                    packageName: packageName
                });
                return;
            }
            // No network connection error
            (0, $jcw0u.default)({
                meta: {
                    id: actionSubject,
                    packageName: packageName
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        aborted: ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                status: (0, $93kZ7.analyticsStatuses).ABORTED,
                packageName: packageName
            });
        }
    });
};

});
parcelRegister("93kZ7", function(module, exports) {

$parcel$export(module.exports, "statusCodeGroups", () => $88683eadd8082ef6$export$fddea1bcaead87d5);
$parcel$export(module.exports, "analyticsStatuses", () => $88683eadd8082ef6$export$f0fa81eb65b496a1);
const $88683eadd8082ef6$export$fddea1bcaead87d5 = {
    INFORMATIONAL_RESPONSES: '1xx',
    SUCCESS_RESPONSES: '2xx',
    REDIRECTS: '3xx',
    CLIENT_ERRORS: '4xx',
    SERVER_ERRORS: '5xx',
    UNKNOWN: 'unknown'
};
const $88683eadd8082ef6$export$f0fa81eb65b496a1 = {
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    ABORTED: 'aborted',
    STARTED: 'started'
};

});


parcelRegister("7lFwJ", function(module, exports) {

$parcel$export(module.exports, "loggingHandler", () => $81689b1ad2d5cba4$export$f35316da257b76e4);

var $dJl1T = parcelRequire("dJl1T");

var $fZneA = parcelRequire("fZneA");
const $81689b1ad2d5cba4$export$f35316da257b76e4 = ({ loggingKey: loggingKey })=>{
    if (loggingKey === null || loggingKey === undefined) return {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        error: ()=>{}
    };
    const errorHandler = (thrownError)=>{
        if (!(0, $fZneA.isClientFetchError)(thrownError)) (0, $dJl1T.default).safeErrorWithoutCustomerData(loggingKey, 'Error fetching data', thrownError);
    };
    return {
        error: errorHandler
    };
};

});



parcelRegister("5IV0G", function(module, exports) {

$parcel$export(module.exports, "performPutRequest", () => $f34d0f87a908aa70$export$9ead1f9103e6de6b);

var $eusud = parcelRequire("eusud");

var $3wzQ9 = parcelRequire("3wzQ9");
const $f34d0f87a908aa70$export$9ead1f9103e6de6b = (url, options = {})=>(0, $eusud.performPutRequest)(url, options).catch((error)=>{
        throw new (0, $3wzQ9.FetchUrlError)(url, error);
    });

});
parcelRegister("3wzQ9", function(module, exports) {

$parcel$export(module.exports, "FetchUrlError", () => $f57667a2adaf29d3$export$5cdfc90b27d7ab6c);

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $bw7Gm = parcelRequire("bw7Gm");

var $kFy8J = parcelRequire("kFy8J");
const $f57667a2adaf29d3$var$getStatusCodeGroup = (statusCode)=>{
    if (statusCode === null) return (0, $kFy8J.statusCodeGroups).UNKNOWN;
    if (statusCode >= 100 && statusCode <= 199) return (0, $kFy8J.statusCodeGroups).INFORMATIONAL_RESPONSES;
    if (statusCode >= 200 && statusCode <= 299) return (0, $kFy8J.statusCodeGroups).SUCCESS_RESPONSES;
    if (statusCode >= 300 && statusCode <= 399) return (0, $kFy8J.statusCodeGroups).REDIRECTS;
    if (statusCode >= 400 && statusCode <= 499) return (0, $kFy8J.statusCodeGroups).CLIENT_ERRORS;
    if (statusCode >= 500 && statusCode <= 599) return (0, $kFy8J.statusCodeGroups).SERVER_ERRORS;
    return (0, $kFy8J.statusCodeGroups).UNKNOWN;
};
const $f57667a2adaf29d3$var$stringifySafe = (obj)=>{
    try {
        return JSON.stringify(obj);
    } catch  {
        return null;
    }
};
class $f57667a2adaf29d3$export$5cdfc90b27d7ab6c extends (0, $jJZqs.default) {
    constructor(url, fetchError){
        if (fetchError instanceof (0, $jJZqs.default)) super(fetchError.statusCode, fetchError.message, fetchError.traceId);
        else super(-1, fetchError.message);
        this.name = 'FetchUrlError';
        this.url = (0, $bw7Gm.default)(url);
        this.aborted = fetchError.name === (0, $jJZqs.ABORT_ERROR_NAME);
        this.isClientError = (0, $fZneA.isClientFetchError)(fetchError) || this.statusCode === -1;
        this.statusCodeGroup = $f57667a2adaf29d3$var$getStatusCodeGroup(fetchError instanceof (0, $jJZqs.default) ? fetchError.statusCode : null);
        // NOTE: logging does not support nested objects!
        this.cause = $f57667a2adaf29d3$var$stringifySafe(fetchError);
    }
}

});
parcelRegister("kFy8J", function(module, exports) {

$parcel$export(module.exports, "statusCodeGroups", () => $cb89e2c05d3c28e8$export$fddea1bcaead87d5);
const $cb89e2c05d3c28e8$export$fddea1bcaead87d5 = {
    INFORMATIONAL_RESPONSES: '1xx',
    SUCCESS_RESPONSES: '2xx',
    REDIRECTS: '3xx',
    CLIENT_ERRORS: '4xx',
    SERVER_ERRORS: '5xx',
    UNKNOWN: 'unknown'
};

});




parcelRegister("jB6yt", function(module, exports) {

$parcel$export(module.exports, "default", () => $36c97328c4dc150e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");

var $39xOx = parcelRequire("39xOx");

var $4R6GH = parcelRequire("4R6GH");

var $02beV = parcelRequire("02beV");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");

var $hchBL = parcelRequire("hchBL");

var $duOMW = parcelRequire("duOMW");

var $4cYhQ = parcelRequire("4cYhQ");

var $a4XJc = parcelRequire("a4XJc");

var $lngWe = parcelRequire("lngWe");

var $cYeCp = parcelRequire("cYeCp");

var $3uPqt = parcelRequire("3uPqt");

var $iDGXn = parcelRequire("iDGXn");

var $5iXkq = parcelRequire("5iXkq");

var $jCs82 = parcelRequire("jCs82");

var $1wxxD = parcelRequire("1wxxD");

var $8vQbt = parcelRequire("8vQbt");

var $3ykoc = parcelRequire("3ykoc");

var $38RF4 = parcelRequire("38RF4");

var $2ucDS = parcelRequire("2ucDS");

const $36c97328c4dc150e$var$ViewSettings = ({ view: view, boardId: boardId, isClassic: isClassic, epicCustomName: epicCustomName, showEpicAsPanel: showEpicAsPanel = false, showFilterBarToggle: showFilterBarToggle = false, showCardDetails: showCardDetails = true, isVersionsEnabled: isVersionsEnabled = false, viewAs: viewAs = (0, $a4XJc.ViewAs).POPUP, isViewPanelOpen: isViewPanelOpen = false, onViewPanelClose: onViewPanelClose = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), areSubtasksEnabled: areSubtasksEnabled, onSubtasksExpandAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksExpandAll = ()=>{}, onSubtasksCollapseAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksCollapseAll = ()=>{}, onToggleWorkSuggestions: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onToggleWorkSuggestions = ()=>{}, onLinkedIssuesStatsToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onLinkedIssuesStatsToggledOn = ()=>{}, onShowCardCoversToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onShowCardCoversToggledOn = ()=>{}, areAllSubtasksExpanded: areAllSubtasksExpanded = false, areAllSubtasksCollapsed: areAllSubtasksCollapsed = false, isSwimlanesEnabled: isSwimlanesEnabled = false, onSwimlaneExpandAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneExpandAll = ()=>{}, onSwimlaneCollapseAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneCollapseAll = ()=>{}, isDaysInColumnEnabled: isDaysInColumnEnabled = false, showLinkedIssueStatsToggle: showLinkedIssueStatsToggle = false, cardExtraFields: cardExtraFields = [], isEstimateEnabled: isEstimateEnabled = false, isDueDateEnabled: isDueDateEnabled = false, isLabelsEnabled: isLabelsEnabled = false, isPriorityEnabled: isPriorityEnabled = false, isDevelopmentEnabled: isDevelopmentEnabled = false, isWorkSuggestionsEnabled: isWorkSuggestionsEnabled = false, showWorkSuggestions: showWorkSuggestions = false, dependencyIssueOptions: dependencyIssueOptions = {} })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const sendAnalyticsEvent = (0, $3uPqt.useSendAnalyticsEvent)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const panelRef = (0, $5uXOq.useRef)(null);
    const [{ activeViewSettingsSpotlight: activeViewSettingsSpotlight }, { setOpenViewSettings: setOpenViewSettings, onViewSettingsSpotlightEnd: onViewSettingsSpotlightEnd }] = (0, $02beV.useNextBestTaskContainer)();
    const handleViewPanelClose = ()=>{
        onViewPanelClose();
    };
    const handleClose = ()=>{
        setIsOpen(false);
        if (activeViewSettingsSpotlight === 1 && onViewSettingsSpotlightEnd) // To end the spotlight if the popup is closed
        onViewSettingsSpotlightEnd();
    };
    const handleClick = ()=>{
        setIsOpen(!isOpen);
        sendAnalyticsEvent('clicked', 'button', (0, $4cYhQ.AnalyticsEvent).UI_EVENT, {
            isClassic: isClassic,
            app: view
        }, viewAs === (0, $a4XJc.ViewAs).PANEL && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? (0, $a4XJc.ViewAs).PANEL : 'popupMenu');
    };
    const openViewSettings = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) return;
        setIsOpen(true);
        sendAnalyticsEvent('clicked', 'button', (0, $4cYhQ.AnalyticsEvent).UI_EVENT, {
            isClassic: isClassic,
            app: view
        }, viewAs === (0, $a4XJc.ViewAs).PANEL && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? (0, $a4XJc.ViewAs).PANEL : 'popupMenu');
    }, [
        sendAnalyticsEvent,
        isClassic,
        view,
        viewAs,
        isOpen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (setOpenViewSettings) setOpenViewSettings(openViewSettings);
    }, [
        openViewSettings,
        setOpenViewSettings
    ]);
    const viewSettingsBtnLG = (0, $hchBL.useGlobalRef)((0, $duOMW.VIEW_SETTINGS_BUTTON_LG))[0];
    const viewSettingsBtnSM = (0, $hchBL.useGlobalRef)((0, $duOMW.VIEW_SETTINGS_BUTTON_SM))[0];
    const viewSettingsBtnResponsive = (0, $hchBL.useGlobalRef)((0, $duOMW.VIEW_SETTINGS_BUTTON_RESPONSIVE))[0];
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    (0, $5uXOq.useEffect)(()=>{
        // register view settings panel global ref
        register((0, $3795a016b6403547$export$989661c424340ff8), panelRef.current);
        const focusOnCloseButton = ()=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const closeButton = panelRef.current?.querySelector(`[data-testid="${(0, $duOMW.VIEW_SETTINGS_PANEL_CLOSE_BUTTON_TEST_ID)}"]`);
            closeButton?.focus();
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.activeElement === viewSettingsBtnLG) {
            focusOnCloseButton();
            return ()=>viewSettingsBtnLG?.focus();
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.activeElement === viewSettingsBtnSM) {
            focusOnCloseButton();
            return ()=>viewSettingsBtnSM?.focus();
        }
        if (// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.activeElement === viewSettingsBtnResponsive && (0, $4R6GH.fg)('view_settings_focus_for_responsive_button')) {
            focusOnCloseButton();
            return ()=>viewSettingsBtnResponsive?.focus();
        }
    }, [
        register,
        viewSettingsBtnLG,
        viewSettingsBtnResponsive,
        viewSettingsBtnSM
    ]);
    const conditionallyRenderViewSettingsButtonWithAria = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38RF4.ViewSettingsButton), {
            isSelected: isOpen,
            onClick: handleClick,
            ...props
        });
    const viewAsPopup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.Popup), {
        "data-testid": "software-view-settings.ui.popup",
        isOpen: isOpen,
        onClose: handleClose,
        placement: "bottom-end",
        content: (props)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ucDS.ViewSettingsMenu), {
                view: view,
                viewAs: (0, $a4XJc.ViewAs).POPUP,
                boardId: boardId,
                isClassic: isClassic,
                showFilterBarToggle: showFilterBarToggle,
                showEpicAsPanel: showEpicAsPanel,
                epicCustomName: epicCustomName,
                showCardDetails: showCardDetails,
                isWorkSuggestionsEnabled: isWorkSuggestionsEnabled,
                showWorkSuggestions: showWorkSuggestions,
                isVersionsEnabled: isVersionsEnabled,
                areSubtasksEnabled: areSubtasksEnabled,
                onSubtasksExpandAll: onSubtasksExpandAll,
                onSubtasksCollapseAll: onSubtasksCollapseAll,
                areAllSubtasksExpanded: areAllSubtasksExpanded,
                areAllSubtasksCollapsed: areAllSubtasksCollapsed,
                isSwimlanesEnabled: isSwimlanesEnabled,
                onSwimlaneExpandAll: onSwimlaneExpandAll,
                onSwimlaneCollapseAll: onSwimlaneCollapseAll,
                onToggleWorkSuggestions: onToggleWorkSuggestions,
                showLinkedIssueStatsToggle: showLinkedIssueStatsToggle,
                onLinkedIssuesStatsToggledOn: onLinkedIssuesStatsToggledOn,
                onShowCardCoversToggledOn: onShowCardCoversToggledOn,
                dependencyIssueOptions: dependencyIssueOptions,
                onUpdate: props.update
            });
        },
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                ref: ref
            }, conditionallyRenderViewSettingsButtonWithAria({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup
            }))
    });
    const viewAsPanel = isViewPanelOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: panelRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lngWe.Panel), {
        title: formatMessage((0, $3ykoc.default).panelTitle),
        onClose: handleViewPanelClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ucDS.ViewSettingsMenu), {
        view: view,
        viewAs: (0, $a4XJc.ViewAs).PANEL,
        boardId: boardId,
        isClassic: isClassic,
        showFilterBarToggle: showFilterBarToggle,
        showEpicAsPanel: showEpicAsPanel,
        epicCustomName: epicCustomName,
        showCardDetails: showCardDetails,
        isVersionsEnabled: isVersionsEnabled,
        isWorkSuggestionsEnabled: isWorkSuggestionsEnabled,
        showWorkSuggestions: showWorkSuggestions,
        areSubtasksEnabled: areSubtasksEnabled,
        onSubtasksExpandAll: onSubtasksExpandAll,
        onSubtasksCollapseAll: onSubtasksCollapseAll,
        areAllSubtasksExpanded: areAllSubtasksExpanded,
        areAllSubtasksCollapsed: areAllSubtasksCollapsed,
        isSwimlanesEnabled: isSwimlanesEnabled,
        onSwimlaneExpandAll: onSwimlaneExpandAll,
        onSwimlaneCollapseAll: onSwimlaneCollapseAll,
        onToggleWorkSuggestions: onToggleWorkSuggestions,
        isDaysInColumnEnabled: isDaysInColumnEnabled,
        showLinkedIssueStatsToggle: showLinkedIssueStatsToggle,
        cardExtraFields: cardExtraFields,
        isEstimateEnabled: isEstimateEnabled,
        isDueDateEnabled: isDueDateEnabled,
        isLabelsEnabled: isLabelsEnabled,
        isPriorityEnabled: isPriorityEnabled,
        isDevelopmentEnabled: isDevelopmentEnabled,
        onLinkedIssuesStatsToggledOn: onLinkedIssuesStatsToggledOn,
        onShowCardCoversToggledOn: onShowCardCoversToggledOn,
        dependencyIssueOptions: dependencyIssueOptions
    })));
    (0, $jCs82.useOnBacklog)(boardId, view, showEpicAsPanel, isVersionsEnabled);
    (0, $8vQbt.useSyncFromLocalStorage)(boardId, view, cardExtraFields, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled);
    (0, $5iXkq.useCardDetailsInitialState)(boardId, view, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled);
    // Initialise local storage for Increment Planning board
    (0, $1wxxD.useOnIncrementPlanningBoard)(boardId, view, dependencyIssueOptions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: viewAs === (0, $a4XJc.ViewAs).PANEL ? 'viewSettingsPanel' : 'viewSettingsMenu',
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDGXn.ViewSettingsContainer), {
        view: view,
        isGlobal: true
    }, viewAs === (0, $a4XJc.ViewAs).PANEL && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? viewAsPanel : viewAsPopup));
};
const $36c97328c4dc150e$var$ViewSettingsWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "errorBoundary",
        packageName: "jiraSoftwareViewSettings",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36c97328c4dc150e$var$ViewSettings, props));
var $36c97328c4dc150e$export$2e2bcd8739ae039 = $36c97328c4dc150e$var$ViewSettingsWithErrorBoundary;

});
parcelRegister("hchBL", function(module, exports) {

$parcel$export(module.exports, "useGlobalRef", () => $b03364e48d8512c5$export$361e4f658203e95);
$parcel$export(module.exports, "useGlobalRefStoreActions", () => $b03364e48d8512c5$export$3c6c6911d09d7d8a);
$parcel$export(module.exports, "withGlobalRef", () => $b03364e48d8512c5$export$6b4b878b04fd3017);

var $5uXOq = parcelRequire("5uXOq");

var $7JoAD = parcelRequire("7JoAD");
const $b03364e48d8512c5$var$store = (0, $7JoAD.createStore)({
    initialState: {},
    actions: {
        register: (key, ref)=>({ setState: setState })=>{
                setState({
                    [key]: ref || undefined
                });
            }
    },
    name: 'refs-store'
});
const $b03364e48d8512c5$export$4beaa3baa53198e4 = (0, $7JoAD.createContainer)($b03364e48d8512c5$var$store);
const $b03364e48d8512c5$var$useGlobalRefStateSelector = (0, $7JoAD.createStateHook)($b03364e48d8512c5$var$store, {
    selector: (state, key)=>state[key]
});
const $b03364e48d8512c5$export$361e4f658203e95 = (key)=>[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        $b03364e48d8512c5$var$useGlobalRefStateSelector(key)
    ];
const $b03364e48d8512c5$export$3c6c6911d09d7d8a = (0, $7JoAD.createHook)($b03364e48d8512c5$var$store, {
    selector: null
});
const $b03364e48d8512c5$export$6b4b878b04fd3017 = (propName, refName)=>(Component)=>(props)=>{
            const [ref] = $b03364e48d8512c5$export$361e4f658203e95(refName);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                [propName]: ref
            });
        };

});

parcelRegister("4cYhQ", function(module, exports) {

$parcel$export(module.exports, "Action", () => $9022cae0997d5594$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "ActionSubject", () => $9022cae0997d5594$export$7f97440769de1377);
$parcel$export(module.exports, "AnalyticsEvent", () => $9022cae0997d5594$export$30b7662faa307ee);
$parcel$export(module.exports, "ToggleKey", () => $9022cae0997d5594$export$3679582258ad0fad);
$parcel$export(module.exports, "IncrementPlanningAnalyticsKey", () => $9022cae0997d5594$export$75cb7f2b113e0230);
const $9022cae0997d5594$export$e19cd5f9376f8cee = {
    CLICKED: 'clicked',
    CHANGED: 'changed'
};
const $9022cae0997d5594$export$7f97440769de1377 = {
    BUTTON: 'button',
    TOGGLE: 'toggle',
    SELECT: 'select'
};
const $9022cae0997d5594$export$30b7662faa307ee = {
    UI_EVENT: 'UI_EVENT',
    OPERATIONAL_EVENT: 'OPERATIONAL_EVENT',
    TRACK_EVENT: 'TRACK_EVENT'
};
const $9022cae0997d5594$export$3679582258ad0fad = {
    VERSION_PANEL_TOGGLE: 'versionPanel',
    EPIC_PANEL_TOGGLE: 'epicPanel',
    QUICK_FILTERS_TOGGLE: 'quickFilters',
    COMPACT_MODE_TOGGLE: 'compactMode',
    CARD_DENSITY: 'cardDensity',
    SHOW_VERSIONS_TOGGLE: 'showVersions',
    SHOW_EPICS_TOGGLE: 'showEpics',
    SHOW_STATUSES_TOGGLE: 'showStatuses',
    SHOW_ISSUE_TYPE: 'showIssueType',
    SHOW_ISSUE_KEY: 'showIssueKey',
    SHOW_ESTIMATE: 'showEstimate',
    SHOW_PRIORITY: 'showPriority',
    SHOW_DEVELOPMENT: 'showDevelopment',
    SHOW_ASSIGNEE: 'showAssignee',
    SHOW_ISSUE_LINKS_STATS: 'showIssueLinksStats',
    OPEN_ISSUES_IN_SIDEBAR_TOGGLE: 'openIssuesInSidebar',
    SUBTASKS_EXPAND_ALL: 'subtasksExpandAll',
    SUBTASKS_COLLAPSE_ALL: 'subtasksCollapseAll',
    SWIMLANE_EXPAND_ALL: 'swimlaneExpandAll',
    SWIMLANE_COLLAPSE_ALL: 'swimlaneCollapseAll',
    SHOW_DAYS_IN_COLUMN: 'showDaysInColumn',
    SHOW_DUE_DATE: 'showDueDate',
    SHOW_LABELS: 'showLabels',
    SHOW_EXTRA_FIELD: 'showExtraField',
    WORK_SUGGESTIONS_TOGGLE: 'workSuggestions',
    SHOW_CARD_COVERS: 'showCardCovers'
};
const $9022cae0997d5594$export$75cb7f2b113e0230 = {
    UNSCHEDULED_COLUMN_TOGGLE: 'unscheduledColumnToggle',
    ISSUE_IDS_TO_SHOW_DEPENDENCIES: 'issueIdsToShowDependencies',
    SHOW_OFFTRACK_DEPENDENCY_LINES: 'showOfftrackDependencyLines'
};
const $9022cae0997d5594$export$d87506c7d891276d = {
    ...$9022cae0997d5594$export$3679582258ad0fad,
    ...$9022cae0997d5594$export$75cb7f2b113e0230
};

});

parcelRegister("lngWe", function(module, exports) {

$parcel$export(module.exports, "Panel", () => $a08ab407f5b09128$export$2ddb90ad54e5f587);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $1dJ6S = parcelRequire("1dJ6S");

var $lLLkM = parcelRequire("lLLkM");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $h9kUS = parcelRequire("h9kUS");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $duOMW = parcelRequire("duOMW");

var $jvrqw = parcelRequire("jvrqw");
const $a08ab407f5b09128$export$2ddb90ad54e5f587 = ({ title: title = '', onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a08ab407f5b09128$var$panelStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        grow: "fill",
        spread: "space-between",
        xcss: $a08ab407f5b09128$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1dJ6S.default), {
        size: "medium",
        as: "h2"
    }, title || formatMessage((0, $jvrqw.default).defaultTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a08ab407f5b09128$var$ButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        spacing: "none",
        onClick: onClose,
        testId: (0, $duOMW.VIEW_SETTINGS_PANEL_CLOSE_BUTTON_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a08ab407f5b09128$var$IconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lLLkM))), {
        label: formatMessage((0, $jvrqw.default).closeButtonLabel)
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, children)));
};
const $a08ab407f5b09128$var$headerStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.100'
});
const $a08ab407f5b09128$var$panelStyles = (0, $8CUq3.xcss)({
    border: `1px solid ${"var(--ds-border, #091E42)"}`,
    borderRadius: 'border.radius.200',
    width: '280px',
    padding: 'space.300',
    [(0, $h9kUS.media).above.lg]: {
        width: '300px'
    }
});
const $a08ab407f5b09128$var$ButtonWrapperStyles = (0, $8CUq3.xcss)({
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)"
});
const $a08ab407f5b09128$var$IconWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)"
});

});
parcelRegister("jvrqw", function(module, exports) {

$parcel$export(module.exports, "default", () => $12af5ef45aa68e18$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $12af5ef45aa68e18$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    defaultTitle: {
        "id": "software-view-settings.common.panel.default-title",
        "defaultMessage": "View settings"
    },
    closeButtonLabel: {
        "id": "software-view-settings.common.panel.close-button-label",
        "defaultMessage": "Close"
    }
});

});


parcelRegister("3uPqt", function(module, exports) {

$parcel$export(module.exports, "useSendAnalyticsEvent", () => $2125a8f3d8eb70be$export$4b1735907ca3ab2f);

var $fjcgS = parcelRequire("fjcgS");

var $4cYhQ = parcelRequire("4cYhQ");
const $2125a8f3d8eb70be$export$7d2f3f483d8e6742 = 'viewSettings';
const $2125a8f3d8eb70be$export$4b1735907ca3ab2f = ()=>{
    const sendAnalyticsEvent = (action, actionSubject, eventType, attributes = {}, source)=>{
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const analyticsClient = client.getInstance();
            if (!analyticsClient) return Promise.resolve();
            const event = {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: $2125a8f3d8eb70be$export$7d2f3f483d8e6742,
                attributes: {
                    ...attributes
                },
                source: source
            };
            switch(eventType){
                case (0, $4cYhQ.AnalyticsEvent).UI_EVENT:
                    return analyticsClient.sendUIEvent(event);
                case (0, $4cYhQ.AnalyticsEvent).OPERATIONAL_EVENT:
                    return analyticsClient.sendOperationalEvent(event);
                case (0, $4cYhQ.AnalyticsEvent).TRACK_EVENT:
                    return analyticsClient.sendTrackEvent(event);
                default:
            }
            return undefined;
        });
    };
    return sendAnalyticsEvent;
};

});

parcelRegister("5iXkq", function(module, exports) {

$parcel$export(module.exports, "useCardDetailsInitialState", () => $fd36b5bdce43621b$export$2e9f932053c78b66);

var $5uXOq = parcelRequire("5uXOq");

var $fr1K2 = parcelRequire("fr1K2");

var $dIdda = parcelRequire("dIdda");

var $duOMW = parcelRequire("duOMW");

var $9pP0g = parcelRequire("9pP0g");

var $cYeCp = parcelRequire("cYeCp");

var $8zmNw = parcelRequire("8zmNw");

var $iDGXn = parcelRequire("iDGXn");
const $fd36b5bdce43621b$export$428c87746d3e32da = {
    [(0, $9pP0g.ViewSetting).SHOW_EPICS]: 'showEpics',
    [(0, $9pP0g.ViewSetting).SHOW_STATUSES]: 'showStatuses',
    [(0, $9pP0g.ViewSetting).SHOW_VERSIONS]: 'showVersions',
    [(0, $9pP0g.ViewSetting).SHOW_ASSIGNEE]: 'showAssignee',
    [(0, $9pP0g.ViewSetting).SHOW_DAYS_IN_COLUMN]: 'showDaysInColumn',
    [(0, $9pP0g.ViewSetting).SHOW_ESTIMATE]: 'showEstimate',
    [(0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY]: 'showIssueKey',
    [(0, $9pP0g.ViewSetting).SHOW_ISSUE_LINKS_STATS]: 'showIssueLinksStats',
    [(0, $9pP0g.ViewSetting).SHOW_DUE_DATE]: 'showDueDate',
    [(0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE]: 'showIssueType',
    [(0, $9pP0g.ViewSetting).SHOW_PRIORITY]: 'showPriority',
    [(0, $9pP0g.ViewSetting).SHOW_DEVELOPMENT]: 'showDevelopment',
    [(0, $9pP0g.ViewSetting).SHOW_LABELS]: 'showLabels',
    [(0, $9pP0g.ViewSetting).SHOW_CARD_COVERS]: 'showCardCovers'
};
const $fd36b5bdce43621b$export$2e9f932053c78b66 = (boardId, view, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled)=>{
    const [{ location: location, query: query }, { replace: replace }] = (0, $dIdda.useRouter)();
    const { setViewSettingsCardDetails: setViewSettingsCardDetails } = (0, $iDGXn.useViewSettingsActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() || !query) return;
        const cardDetailsFromLocalStorage = (0, $8zmNw.getViewSettingsCardDetails)({
            boardId: boardId,
            view: view,
            isDaysInColumnEnabled: isDaysInColumnEnabled,
            isDueDateEnabled: isDueDateEnabled,
            isLabelsEnabled: isLabelsEnabled,
            isEstimateEnabled: isEstimateEnabled,
            isPriorityEnabled: isPriorityEnabled
        });
        const getInitialCardValue = (stateKey)=>{
            const queryKey = $fd36b5bdce43621b$export$428c87746d3e32da[stateKey];
            return query[queryKey] ? query[queryKey] === (0, $duOMW.QUERY_ENABLED_VALUE) : cardDetailsFromLocalStorage[stateKey];
        };
        const cardDetailsState = {
            [(0, $9pP0g.ViewSetting).SHOW_EPICS]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_EPICS),
            [(0, $9pP0g.ViewSetting).SHOW_STATUSES]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_STATUSES),
            [(0, $9pP0g.ViewSetting).SHOW_VERSIONS]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_VERSIONS),
            [(0, $9pP0g.ViewSetting).SHOW_ASSIGNEE]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_ASSIGNEE),
            [(0, $9pP0g.ViewSetting).SHOW_DAYS_IN_COLUMN]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_DAYS_IN_COLUMN),
            [(0, $9pP0g.ViewSetting).SHOW_ESTIMATE]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_ESTIMATE),
            [(0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY),
            [(0, $9pP0g.ViewSetting).SHOW_ISSUE_LINKS_STATS]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_ISSUE_LINKS_STATS),
            [(0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE),
            [(0, $9pP0g.ViewSetting).SHOW_PRIORITY]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_PRIORITY),
            [(0, $9pP0g.ViewSetting).SHOW_DEVELOPMENT]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_DEVELOPMENT),
            [(0, $9pP0g.ViewSetting).SHOW_DUE_DATE]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_DUE_DATE),
            [(0, $9pP0g.ViewSetting).SHOW_LABELS]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_LABELS),
            [(0, $9pP0g.ViewSetting).SHOW_CARD_COVERS]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_CARD_COVERS)
        };
        setViewSettingsCardDetails({
            boardId: boardId,
            view: view,
            cardDetailsState: cardDetailsState
        });
        // remove card view initial settings param
        replace({
            ...location,
            search: new URLSearchParams((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(query, Object.values($fd36b5bdce43621b$export$428c87746d3e32da))).toString()
        });
    // we want to run this hook on initial render only
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});

parcelRegister("jCs82", function(module, exports) {

$parcel$export(module.exports, "useOnBacklog", () => $39756d5f22d21cd8$export$9c6bcc9d56a57470);

var $5uXOq = parcelRequire("5uXOq");

var $dIdda = parcelRequire("dIdda");

var $a4XJc = parcelRequire("a4XJc");

var $cYeCp = parcelRequire("cYeCp");

var $8zmNw = parcelRequire("8zmNw");

var $iDGXn = parcelRequire("iDGXn");
const $39756d5f22d21cd8$export$9c6bcc9d56a57470 = (boardId, view, showEpicAsPanel = false, isVersionsEnabled = false)=>{
    const [{ location: location }] = (0, $dIdda.useRouter)();
    const showPanels = (0, $iDGXn.useShowPanels)();
    const { setViewSettingsPanels: setViewSettingsPanels } = (0, $iDGXn.useViewSettingsActions)();
    const { replace: replace } = (0, $dIdda.useRouterActions)();
    // Sync react-sweet-state store with URL or localStorage state on mount.
    (0, $5uXOq.useEffect)(()=>{
        if (view !== (0, $a4XJc.View).BACKLOG) return;
        const panelsFromQuery = (0, $cYeCp.parseSearchQuery)(location.search);
        const panelsFromLocalStorage = (0, $8zmNw.getViewSettingsPanels)({
            boardId: boardId,
            view: view
        });
        // Search query state takes precedence over localStorage state, which supersedes react-sweet-state state.
        // If there are panels from the search query, update localStorage and react-sweet-state.
        // If not, update react-sweet-state using localStorage instead.
        let panelState = panelsFromLocalStorage;
        if (Object.values(panelsFromQuery).filter(Boolean).length !== 0) {
            const queryPanelState = {
                EPIC_PANEL: panelsFromQuery.EPIC_PANEL ?? false,
                VERSION_PANEL: panelsFromQuery.VERSION_PANEL ?? false
            };
            panelState = queryPanelState;
        }
        setViewSettingsPanels({
            boardId: boardId,
            view: view,
            panelState: panelState
        });
    // Removed `location.search` from the dependency array since we only want this hook to fire once (on mount).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        boardId,
        isVersionsEnabled,
        setViewSettingsPanels,
        showEpicAsPanel,
        view
    ]);
    // Sync URL with react-sweet-state store on mount and when react-sweet-state store changes.
    (0, $5uXOq.useEffect)(()=>{
        if (view !== (0, $a4XJc.View).BACKLOG) return;
        const url = (0, $cYeCp.setPanels)(showPanels, location);
        if (location.search !== `?${url.search}`) replace(url);
    // `Location` has a `hash` attribute which causes unnecessary calls, so we are only using `search` in the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location.search,
        showPanels,
        replace,
        view
    ]);
};

});

parcelRegister("1wxxD", function(module, exports) {

$parcel$export(module.exports, "useOnIncrementPlanningBoard", () => $c2daf95593322126$export$14539b3beca7ada3);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $dIdda = parcelRequire("dIdda");

var $a4XJc = parcelRequire("a4XJc");

var $cYeCp = parcelRequire("cYeCp");

var $8zmNw = parcelRequire("8zmNw");

var $iDGXn = parcelRequire("iDGXn");
const $c2daf95593322126$export$14539b3beca7ada3 = (boardId, view, dependencyIssueOptions)=>{
    const { setShowUnscheduledColumn: setShowUnscheduledColumn, setShowOfftrackDependencyLines: setShowOfftrackDependencyLines, setIssueIdsToShowDependencies: setIssueIdsToShowDependencies } = (0, $iDGXn.useViewSettingsActions)();
    const [{ location: location }] = (0, $dIdda.useRouter)();
    const { replace: replace } = (0, $dIdda.useRouterActions)();
    const isUnscheduledColumnVisible = (0, $iDGXn.useShowUnscheduledColumn)();
    const isOfftrackDependencyLinesVisible = (0, $iDGXn.useShowOfftrackDependencyLines)();
    const issueIdsToShowDependencies = (0, $iDGXn.useIssueIdsToShowDependencies)();
    (0, $5uXOq.useEffect)(()=>{
        if (view !== (0, $a4XJc.View).INCREMENT_PLANNING_BOARD) return;
        const unscheduledColumnFromLocalStorage = (0, $8zmNw.getShowUnscheduledColumn)(boardId);
        const settingsFromQuery = (0, $cYeCp.parseSearchQueryForIPBoard)(location.search);
        // Search query state takes precedence over localStorage state, which supersedes react-sweet-state state.
        // If there are IP board settings from the search query, update localStorage and react-sweet-state.
        // If not, update react-sweet-state using localStorage instead.
        const showUnscheduledColumn = settingsFromQuery.SHOW_UNSCHEDULED_COLUMN !== undefined ? settingsFromQuery.SHOW_UNSCHEDULED_COLUMN : unscheduledColumnFromLocalStorage;
        setShowUnscheduledColumn(boardId, showUnscheduledColumn);
        if ((0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) {
            const offtrackDependencyLinesFromLocalStorage = (0, $8zmNw.getShowOfftrackDependencyLines)(boardId);
            const issueIdsToShowDependenciesFromLocalStorage = (0, $8zmNw.getIssueIdsToShowDependencies)(boardId);
            const showOfftrackDependencyLines = settingsFromQuery.SHOW_OFFTRACK_DEPENDENCY_LINES !== undefined ? settingsFromQuery.SHOW_OFFTRACK_DEPENDENCY_LINES : offtrackDependencyLinesFromLocalStorage;
            setShowOfftrackDependencyLines(boardId, showOfftrackDependencyLines);
            const issuesIdsToShowDependencies = settingsFromQuery.ISSUE_IDS_TO_SHOW_DEPENDENCIES && settingsFromQuery.ISSUE_IDS_TO_SHOW_DEPENDENCIES.length ? settingsFromQuery.ISSUE_IDS_TO_SHOW_DEPENDENCIES : issueIdsToShowDependenciesFromLocalStorage;
            const filteredIssueIds = Array.isArray(issuesIdsToShowDependencies) ? issuesIdsToShowDependencies.filter((issueId)=>dependencyIssueOptions[issueId] !== undefined) : [];
            setIssueIdsToShowDependencies(boardId, filteredIssueIds);
        }
    }, [
        boardId,
        view,
        dependencyIssueOptions,
        location.search,
        setShowUnscheduledColumn,
        setShowOfftrackDependencyLines,
        setIssueIdsToShowDependencies
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (view !== (0, $a4XJc.View).INCREMENT_PLANNING_BOARD) return;
        let url;
        if ((0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) url = (0, $cYeCp.setIncrementPlanningSettingsQuery)({
            SHOW_UNSCHEDULED_COLUMN: isUnscheduledColumnVisible,
            SHOW_OFFTRACK_DEPENDENCY_LINES: isOfftrackDependencyLinesVisible,
            ISSUE_IDS_TO_SHOW_DEPENDENCIES: issueIdsToShowDependencies
        }, location);
        else url = (0, $cYeCp.setIncrementPlanningSettingsQuery)({
            SHOW_UNSCHEDULED_COLUMN: isUnscheduledColumnVisible,
            SHOW_OFFTRACK_DEPENDENCY_LINES: false,
            ISSUE_IDS_TO_SHOW_DEPENDENCIES: []
        }, location);
        if (location.search !== `?${url.search}`) replace(url);
    // `Location` has a `hash` attribute which causes unnecessary calls, so we are only using `search` in the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        boardId,
        view,
        isUnscheduledColumnVisible,
        isOfftrackDependencyLinesVisible,
        issueIdsToShowDependencies,
        location.search,
        replace
    ]);
};

});

parcelRegister("8vQbt", function(module, exports) {

$parcel$export(module.exports, "useSyncFromLocalStorage", () => $9a1dab6fcae5bc71$export$88f2270d613c342b);

var $5uXOq = parcelRequire("5uXOq");

var $cYeCp = parcelRequire("cYeCp");

var $8zmNw = parcelRequire("8zmNw");

var $iDGXn = parcelRequire("iDGXn");
const $9a1dab6fcae5bc71$export$88f2270d613c342b = (boardId, view, cardExtraFields, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled)=>{
    const { setIsFullscreen: setIsFullscreen, setViewSettingsCardDetails: setViewSettingsCardDetails, setViewSettingsQuickFilters: setViewSettingsQuickFilters, setViewSettingsCompactMode: setViewSettingsCompactMode, setViewSettingsCardExtraFields: setViewSettingsCardExtraFields } = (0, $iDGXn.useViewSettingsActions)();
    (0, $5uXOq.useEffect)(()=>{
        // card details initial state moved to `useCardDetailsInitialState`
        if (!(0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) {
            const cardDetailsFromLocalStorage = (0, $8zmNw.getViewSettingsCardDetails)({
                boardId: boardId,
                view: view
            });
            setViewSettingsCardDetails({
                boardId: boardId,
                cardDetailsState: cardDetailsFromLocalStorage,
                view: view
            });
        }
        const quickFiltersFromLocalStorage = (0, $8zmNw.getViewSettingsQuickFilters)({
            boardId: boardId,
            view: view
        });
        setViewSettingsQuickFilters({
            boardId: boardId,
            view: view,
            showQuickFilters: quickFiltersFromLocalStorage
        });
        const compactModeFromLocalStorage = (0, $8zmNw.getViewSettingsCompactMode)({
            boardId: boardId,
            view: view
        });
        setViewSettingsCompactMode({
            boardId: boardId,
            view: view,
            showCompactMode: compactModeFromLocalStorage
        });
        const isFullscreenFromLocalStorage = (0, $8zmNw.getViewSettingsIsFullscreen)({
            boardId: boardId,
            view: view
        });
        setIsFullscreen({
            boardId: boardId,
            isFullscreen: isFullscreenFromLocalStorage,
            view: view
        });
    }, [
        boardId,
        view,
        isDaysInColumnEnabled,
        isDueDateEnabled,
        isLabelsEnabled,
        isEstimateEnabled,
        isPriorityEnabled,
        setIsFullscreen,
        setViewSettingsCardDetails,
        setViewSettingsCompactMode,
        setViewSettingsQuickFilters,
        setViewSettingsCardExtraFields
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const cardExtraFieldsFromLocalStorage = (0, $8zmNw.getViewSettingsCardExtraFields)({
            boardId: boardId,
            view: view,
            cardExtraFields: cardExtraFields
        });
        setViewSettingsCardExtraFields({
            boardId: boardId,
            cardExtraFieldsState: cardExtraFieldsFromLocalStorage,
            view: view
        });
    }, [
        boardId,
        view,
        cardExtraFields,
        setViewSettingsCardExtraFields
    ]);
};

});

parcelRegister("3ykoc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a98a1024295d65c6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a98a1024295d65c6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    panelTitle: {
        "id": "software-view-settings.panel-title",
        "defaultMessage": "View settings"
    }
});

});

parcelRegister("38RF4", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsSyncFromLocalStorageWrapper", () => $434e13d035e4d1d0$export$8c976c7ba46200ff);
$parcel$export(module.exports, "ViewSettingsButton", () => $434e13d035e4d1d0$export$805802ea39f3d804);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $4QAwn = parcelRequire("4QAwn");

var $5KZxU = parcelRequire("5KZxU");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $1kVqg = parcelRequire("1kVqg");


var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $02beV = parcelRequire("02beV");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $59KYj = parcelRequire("59KYj");

var $22OQR = parcelRequire("22OQR");

var $hchBL = parcelRequire("hchBL");

var $6lmg7 = parcelRequire("6lmg7");

var $dCm1o = parcelRequire("dCm1o");

var $duOMW = parcelRequire("duOMW");

var $5iXkq = parcelRequire("5iXkq");

var $jCs82 = parcelRequire("jCs82");

var $8vQbt = parcelRequire("8vQbt");

var $iIMX5 = parcelRequire("iIMX5");
const $434e13d035e4d1d0$export$8c976c7ba46200ff = ({ boardId: boardId, view: view, cardExtraFields: cardExtraFields = [], isDaysInColumnEnabled: isDaysInColumnEnabled = false, isDueDateEnabled: isDueDateEnabled = false, isLabelsEnabled: isLabelsEnabled = false, isEstimateEnabled: isEstimateEnabled = false, children: children, showEpicAsPanel: showEpicAsPanel = false, isVersionsEnabled: isVersionsEnabled = false, isPriorityEnabled: isPriorityEnabled = false })=>{
    (0, $jCs82.useOnBacklog)(boardId, view, showEpicAsPanel, isVersionsEnabled);
    (0, $8vQbt.useSyncFromLocalStorage)(boardId, view, cardExtraFields, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled);
    (0, $5iXkq.useCardDetailsInitialState)(boardId, view, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $434e13d035e4d1d0$export$805802ea39f3d804 = ({ isSelected: isSelected, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), removeMargins: removeMargins, ShowDI: ShowDI = (0, $1kVqg.Show), isThemedButton: isThemedButton = false, ...restProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(isSelected);
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'viewSettingsButton');
        setIsOpen(!isOpen);
        onClick(!isOpen);
    }, [
        createAnalyticsEvent,
        isOpen,
        onClick
    ]);
    const openViewSettings = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'viewSettingsButton');
        setIsOpen(true);
        setTimeout(()=>onClick(true));
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    const { setOpenViewSettings: setOpenViewSettings } = (0, $02beV.useNextBestTaskActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (setOpenViewSettings) setOpenViewSettings(openViewSettings);
    }, [
        openViewSettings,
        setOpenViewSettings
    ]);
    const onRefButtonLarge = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $duOMW.VIEW_SETTINGS_BUTTON_LG), ref);
    }, [
        register
    ]);
    const onRefButtonSmall = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $duOMW.VIEW_SETTINGS_BUTTON_SM), ref);
    }, [
        register
    ]);
    const onRefButtonResponsive = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $duOMW.VIEW_SETTINGS_BUTTON_RESPONSIVE), ref);
    }, [
        register
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setIsOpen(isSelected);
    }, [
        isSelected
    ]);
    const iconColor = isSelected ? `var(--ds-icon-selected, ${(0, $829f609a65d26a98$exports).B400})` : `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N300})`;
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return isThemedButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        testId: "software-view-settings.ui.view-settings-button.responsive-button",
        appearance: "default",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4QAwn))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        label: formatMessage((0, $iIMX5.default).buttonLabel),
        isSelected: isOpen,
        onClick: handleClick,
        ref: onRefButtonResponsive,
        "aria-label": formatMessage((0, $iIMX5.default).buttonLabel),
        "aria-expanded": restProps.ariaExpanded ?? isSelected,
        "aria-controls": restProps.ariaControls,
        "aria-haspopup": restProps.ariaHasPopup ?? true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        testId: "software-view-settings.ui.view-settings-button.icon-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4QAwn))),
        label: formatMessage((0, $iIMX5.default).buttonLabel),
        isSelected: isOpen,
        onClick: handleClick,
        ref: onRefButtonResponsive,
        "aria-expanded": restProps.ariaExpanded ?? isSelected,
        "aria-controls": restProps.ariaControls,
        "aria-haspopup": restProps.ariaHasPopup ?? true,
        ...(0, $4R6GH.fg)('jira_nav4_beta_drop_1') ? {
            isTooltipDisabled: false
        } : {}
    });
    if ((0, $4R6GH.fg)('jira-calendar-business-theme')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $59KYj.ResponsiveThemedButton), {
        testId: "software-view-settings.ui.view-settings-button.responsive-button",
        appearance: "default",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5KZxU))), {
            label: ""
        }),
        label: formatMessage((0, $iIMX5.default).buttonLabel),
        isSelected: isOpen,
        onClick: handleClick,
        ref: onRefButtonResponsive,
        "aria-label": formatMessage((0, $iIMX5.default).buttonLabel),
        "aria-expanded": restProps.ariaExpanded ?? isSelected,
        "aria-controls": restProps.ariaControls,
        "aria-haspopup": restProps.ariaHasPopup ?? true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6lmg7.ResponsiveButton), {
        testId: "software-view-settings.ui.view-settings-button.responsive-button",
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5KZxU))),
        label: formatMessage((0, $iIMX5.default).buttonLabel),
        isSelected: isOpen,
        onClick: handleClick,
        ref: onRefButtonResponsive,
        "aria-expanded": restProps.ariaExpanded ?? isSelected,
        "aria-controls": restProps.ariaControls,
        "aria-haspopup": restProps.ariaHasPopup ?? true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: removeMargins ? undefined : $434e13d035e4d1d0$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ShowDI, {
        above: "lg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "software-view-settings.ui.view-settings-button.large-button",
        appearance: "default",
        isSelected: isOpen,
        onClick: handleClick,
        ref: onRefButtonLarge,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4QAwn))), {
            label: formatMessage((0, $iIMX5.default).buttonLabel),
            color: iconColor,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($5KZxU))),
            LEGACY_primaryColor: iconColor
        }),
        "aria-label": formatMessage((0, $iIMX5.default).buttonLabel),
        "aria-expanded": restProps.ariaExpanded ?? isSelected,
        "aria-controls": restProps.ariaControls,
        "aria-haspopup": restProps.ariaHasPopup ?? true
    }, formatMessage((0, $iIMX5.default).buttonLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ShowDI, {
        below: "lg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $iIMX5.default).buttonLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "software-view-settings.ui.view-settings-button.small-button",
        appearance: "default",
        isSelected: isOpen,
        onClick: handleClick,
        spacing: "none",
        ref: onRefButtonSmall,
        "aria-expanded": restProps.ariaExpanded ?? isSelected,
        "aria-controls": restProps.ariaControls,
        "aria-haspopup": restProps.ariaHasPopup ?? true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $434e13d035e4d1d0$var$iconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4QAwn))), {
        label: formatMessage((0, $iIMX5.default).buttonLabel),
        color: iconColor,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($5KZxU))),
        LEGACY_primaryColor: iconColor
    })))))));
};
const $434e13d035e4d1d0$var$iconWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px'
});
const $434e13d035e4d1d0$var$buttonWrapperStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("4QAwn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::78335b71c0abb01e55fd286b4fa17edd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3878591d802e976a$var$_react = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3878591d802e976a$var$_UNSAFE_baseNew = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3878591d802e976a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3878591d802e976a$var$CustomizeIcon = (props)=>/*#__PURE__*/ $3878591d802e976a$var$_react.default.createElement($3878591d802e976a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.25 11.5V9.375a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625v4.25c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625zm0 0H16m-16 0h7.5m-3.75-7v2.125c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625v-4.25a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625zm0 0H0m16 0H8.5"/>`
    }, props));
$3878591d802e976a$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $3878591d802e976a$var$_default = module.exports.default = $3878591d802e976a$var$CustomizeIcon;

});

parcelRegister("5KZxU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4310fd5ff8fcaeb0$var$_react = $4310fd5ff8fcaeb0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4310fd5ff8fcaeb0$var$_customize = $4310fd5ff8fcaeb0$var$_interopRequireDefault((parcelRequire("4QAwn")));
function $4310fd5ff8fcaeb0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4310fd5ff8fcaeb0$var$PreferencesIcon = (props)=>/*#__PURE__*/ $4310fd5ff8fcaeb0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 7h3v2H3zm0 8h11v2H3zm7-8h11v2H10zm8 8h3v2h-3z"/><path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m10 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"/></g></svg>`
    }, props, {
        newIcon: $4310fd5ff8fcaeb0$var$_customize.default
    }));
$4310fd5ff8fcaeb0$var$PreferencesIcon.displayName = 'PreferencesIcon';
var $4310fd5ff8fcaeb0$var$_default = module.exports.default = $4310fd5ff8fcaeb0$var$PreferencesIcon;

});

parcelRegister("1kVqg", function(module, exports) {

$parcel$export(module.exports, "Show", () => $7b5b5f6fd54f1de9$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8CUq3 = parcelRequire("8CUq3");

var $2pf2j = parcelRequire("2pf2j");
function $7b5b5f6fd54f1de9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7b5b5f6fd54f1de9$var$showAboveQueries = (0, $2pf2j.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $7b5b5f6fd54f1de9$var$showBelowQueries = (0, $2pf2j.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $7b5b5f6fd54f1de9$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7b5b5f6fd54f1de9$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $8CUq3.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $7b5b5f6fd54f1de9$var$defaultHiddenStyles,
            above && $7b5b5f6fd54f1de9$var$showAboveQueries[above],
            below && $7b5b5f6fd54f1de9$var$showBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});
parcelRegister("2pf2j", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $f32e5b846e53517d$export$918f8818cfbbeb2c);
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $f32e5b846e53517d$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $eXt4g = parcelRequire("eXt4g");

var $h9kUS = parcelRequire("h9kUS");
const $f32e5b846e53517d$export$918f8818cfbbeb2c = (input)=>{
    return (0, $eXt4g.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $f8Sb3.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $h9kUS.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $f32e5b846e53517d$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $eXt4g.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $f8Sb3.css)({
                // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $h9kUS.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("eXt4g", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $3f07a1aff81e4a42$export$2d293d9871c38e91);
const $3f07a1aff81e4a42$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $3f07a1aff81e4a42$export$2d293d9871c38e91 = Object.keys($3f07a1aff81e4a42$export$e5ee4fe8b989fd09);
const $3f07a1aff81e4a42$export$b7ed752a57b4177b = $3f07a1aff81e4a42$export$2d293d9871c38e91[0];

});



parcelRegister("59KYj", function(module, exports) {

$parcel$export(module.exports, "ResponsiveThemedButton", () => $04660f59ffb4326c$export$6f42949f4ea1e733);
/* ResponsiveThemedButton.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $2rqOp = parcelRequire("2rqOp");

var $f5TWP = parcelRequire("f5TWP");

var $1kVqg = parcelRequire("1kVqg");
var $oGXFy = parcelRequire("oGXFy");

var $3bDjY = parcelRequire("3bDjY");
const $04660f59ffb4326c$export$4161299bcae84c4f = 'responsive-themed-button';
const $04660f59ffb4326c$export$6f42949f4ea1e733 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, ...props }, ref)=>{
    const { icon: icon, label: label, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $oGXFy.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        below: breakpoint ?? 'lg'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04660f59ffb4326c$var$CustomButton, {
        ...restProps,
        as: as,
        ref: !isAboveBreakpoint ? ref : undefined,
        appearance: appearance ?? 'default',
        iconBefore: icon,
        testId: `${testId ?? $04660f59ffb4326c$export$4161299bcae84c4f}.collapsed`,
        "aria-label": ariaLabel || label
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        above: breakpoint ?? 'lg'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04660f59ffb4326c$var$CustomButton, {
        ...restProps,
        as: as,
        ref: isAboveBreakpoint ? ref : undefined,
        appearance: appearance ?? 'default',
        iconBefore: icon,
        testId: `${testId ?? $04660f59ffb4326c$export$4161299bcae84c4f}.expanded`,
        "aria-label": ariaLabel || label
    }, label)));
}));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04660f59ffb4326c$var$CustomButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $2rqOp.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1qt31mi8 _1g9hu0za _1umftrgn _6l8rsb7u _9se51pfj _12ra13cp _zk5ur2ew _18vg1w6j _192e1czd _fnp71tko _1xjgkwex _jeie1c2q _nkzo63lg _1u0u1y8w _17z21063 _7n831c2q _n2ulgr9p _1cf15clp _1d7c63lg _nwukkwex _fsjdky8x _z1i3tvsq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("22OQR", function(module, exports) {

$parcel$export(module.exports, "ThemedButton", () => $87e6157378e1cf19$export$f67fb575035cc7d0);
/* ThemedButton.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $2rqOp = parcelRequire("2rqOp");
const $87e6157378e1cf19$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87e6157378e1cf19$var$CustomButton, {
        ...props,
        as: as,
        ref: ref
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87e6157378e1cf19$var$CustomButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $2rqOp.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1qt31mi8 _1g9hu0za _1umftrgn _6l8rsb7u _9se51pfj _12ra13cp _zk5ur2ew _18vg1w6j _192e1czd _fnp71tko _1xjgkwex _1u0u1y8w _17z21063 _7n831c2q _n2ulgr9p _1cf15clp _1d7c63lg _nwukkwex _fsjdky8x _z1i3tvsq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6lmg7", function(module, exports) {

$parcel$export(module.exports, "ResponsiveButton", () => $aeaed609d1db7293$export$47e82d861696e68c);
$parcel$export(module.exports, "ResponsiveLinkButton", () => $aeaed609d1db7293$export$50fd17babcd996ef);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");
var $1GGwS = parcelRequire("1GGwS");
var $krXdA = parcelRequire("krXdA");

var $f5TWP = parcelRequire("f5TWP");

var $1kVqg = parcelRequire("1kVqg");
var $oGXFy = parcelRequire("oGXFy");

var $3bDjY = parcelRequire("3bDjY");

const $aeaed609d1db7293$export$47e82d861696e68c = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $oGXFy.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        below: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.collapsed`,
        ref: !isAboveBreakpoint ? ref : undefined,
        spacing: iconButtonSpacing
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        above: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.expanded`,
        ref: isAboveBreakpoint ? ref : undefined,
        "aria-label": ariaLabel,
        spacing: buttonSpacing
    }, label)));
});
const $aeaed609d1db7293$export$50fd17babcd996ef = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $oGXFy.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        below: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $krXdA.default), {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.collapsed`,
        href: restProps.href,
        ref: !isAboveBreakpoint ? ref : undefined,
        spacing: iconButtonSpacing
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        above: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.expanded`,
        href: restProps.href,
        ref: isAboveBreakpoint ? ref : undefined,
        "aria-label": ariaLabel,
        spacing: buttonSpacing
    }, label)));
});

});
parcelRegister("1GGwS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9768e745d0380796$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jhmo0 = parcelRequire("jhmo0");

var $fuBHX = parcelRequire("fuBHX");
const $9768e745d0380796$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const baseProps = (0, $fuBHX.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'link',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        ...saferRest,
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        /**
			 * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
			 * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
			 */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? 'link' : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LinkButton"
    }, baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
const $9768e745d0380796$var$WithRef = /*#__PURE__*/ (0, $5uXOq.forwardRef)($9768e745d0380796$var$LinkButtonBase);
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $9768e745d0380796$var$LinkButton = /*#__PURE__*/ (0, $5uXOq.memo)($9768e745d0380796$var$WithRef);
var $9768e745d0380796$export$2e2bcd8739ae039 = $9768e745d0380796$var$LinkButton;

});

const $7c15fdea32a398a0$export$9c51afe8741be906 = 'responsive-button.ui.responsive-button';


parcelRegister("iIMX5", function(module, exports) {

$parcel$export(module.exports, "default", () => $77495ee3efb7180c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $77495ee3efb7180c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    buttonLabel: {
        "id": "software-view-settings.view-settings-button.button-label",
        "defaultMessage": "View settings"
    }
});

});


parcelRegister("2ucDS", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsMenu", () => $24ad572d0ea302a2$export$14138a347411ebf);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $4cYhQ = parcelRequire("4cYhQ");

var $a4XJc = parcelRequire("a4XJc");

var $3uPqt = parcelRequire("3uPqt");

var $jlxRF = parcelRequire("jlxRF");

var $140hX = parcelRequire("140hX");

var $1ESRw = parcelRequire("1ESRw");
const $24ad572d0ea302a2$export$14138a347411ebf = ({ boardId: boardId, isClassic: isClassic, view: view, viewAs: viewAs = (0, $a4XJc.ViewAs).POPUP, showEpicAsPanel: showEpicAsPanel, isVersionsEnabled: isVersionsEnabled, epicCustomName: epicCustomName = 'Epic', showFilterBarToggle: showFilterBarToggle = false, showCardDetails: showCardDetails = true, areSubtasksEnabled: areSubtasksEnabled = false, showWorkSuggestions: showWorkSuggestions = false, onSubtasksExpandAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksExpandAll = ()=>{}, onSubtasksCollapseAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksCollapseAll = ()=>{}, areAllSubtasksExpanded: areAllSubtasksExpanded = false, areAllSubtasksCollapsed: areAllSubtasksCollapsed = false, isSwimlanesEnabled: isSwimlanesEnabled = false, onSwimlaneExpandAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneExpandAll = ()=>{}, onSwimlaneCollapseAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneCollapseAll = ()=>{}, onToggleWorkSuggestions: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onToggleWorkSuggestions = ()=>{}, onLinkedIssuesStatsToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onLinkedIssuesStatsToggledOn = ()=>{}, onShowCardCoversToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onShowCardCoversToggledOn = ()=>{}, isDaysInColumnEnabled: isDaysInColumnEnabled = false, showLinkedIssueStatsToggle: showLinkedIssueStatsToggle = false, cardExtraFields: cardExtraFields = [], isEstimateEnabled: isEstimateEnabled = false, isDueDateEnabled: isDueDateEnabled = false, isLabelsEnabled: isLabelsEnabled = false, isPriorityEnabled: isPriorityEnabled = false, isDevelopmentEnabled: isDevelopmentEnabled = false, isWorkSuggestionsEnabled: isWorkSuggestionsEnabled = false, dependencyIssueOptions: dependencyIssueOptions = {}, onUpdate: onUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const sendAnalyticsEvent = (0, $3uPqt.useSendAnalyticsEvent)();
    const handleChange = (actionSubject, attributes)=>{
        sendAnalyticsEvent((0, $4cYhQ.Action).CLICKED, actionSubject, (0, $4cYhQ.AnalyticsEvent).UI_EVENT, {
            ...attributes,
            isClassic: isClassic
        }, view);
    };
    const incrementPlanningHandleChange = (actionSubject, attributes, action)=>{
        sendAnalyticsEvent(action ?? (0, $4cYhQ.Action).CLICKED, actionSubject, (0, $4cYhQ.AnalyticsEvent).UI_EVENT, {
            ...attributes,
            isClassic: isClassic
        }, view);
    };
    switch(view){
        case (0, $a4XJc.View).BACKLOG:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jlxRF.BacklogMenu), {
                viewAs: viewAs,
                boardId: boardId,
                onHandleChange: handleChange,
                showCardDetails: showCardDetails,
                isClassic: isClassic,
                isVersionsEnabled: isVersionsEnabled,
                showEpicAsPanel: showEpicAsPanel,
                showFilterBarToggle: showFilterBarToggle,
                epicCustomName: epicCustomName,
                areSubtasksEnabled: areSubtasksEnabled,
                areAllSubtasksExpanded: areAllSubtasksExpanded,
                areAllSubtasksCollapsed: areAllSubtasksCollapsed,
                onSubtasksExpandAll: onSubtasksExpandAll,
                onSubtasksCollapseAll: onSubtasksCollapseAll,
                cardExtraFields: cardExtraFields,
                isEstimateEnabled: isEstimateEnabled,
                isDueDateEnabled: isDueDateEnabled,
                isPriorityEnabled: isPriorityEnabled
            });
        case (0, $a4XJc.View).BOARD:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $140hX.BoardMenu), {
                viewAs: viewAs,
                boardId: boardId,
                isClassic: isClassic,
                isSwimlanesEnabled: isSwimlanesEnabled,
                onHandleChange: handleChange,
                onSwimlaneExpandAll: onSwimlaneExpandAll,
                onSwimlaneCollapseAll: onSwimlaneCollapseAll,
                showFilterBarToggle: showFilterBarToggle,
                showLinkedIssueStatsToggle: showLinkedIssueStatsToggle,
                showCardDetails: showCardDetails,
                epicCustomName: epicCustomName,
                isDaysInColumnEnabled: isDaysInColumnEnabled,
                cardExtraFields: cardExtraFields,
                isEstimateEnabled: isEstimateEnabled,
                isDueDateEnabled: isDueDateEnabled,
                isLabelsEnabled: isLabelsEnabled,
                isPriorityEnabled: isPriorityEnabled,
                isDevelopmentEnabled: isDevelopmentEnabled,
                showWorkSuggestions: showWorkSuggestions,
                onToggleWorkSuggestions: onToggleWorkSuggestions,
                isWorkSuggestionsEnabled: isWorkSuggestionsEnabled,
                onLinkedIssuesStatsToggledOn: onLinkedIssuesStatsToggledOn,
                onShowCardCoversToggledOn: onShowCardCoversToggledOn
            });
        case (0, $a4XJc.View).JSM_BOARD:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $140hX.BoardMenu), {
                viewAs: viewAs,
                boardId: boardId,
                isSwimlanesEnabled: isSwimlanesEnabled,
                onHandleChange: handleChange,
                showFilterBarToggle: showFilterBarToggle,
                showCardDetails: false,
                onSwimlaneExpandAll: onSwimlaneExpandAll,
                onSwimlaneCollapseAll: onSwimlaneCollapseAll
            });
        case (0, $a4XJc.View).INCREMENT_PLANNING_BOARD:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ESRw.IncrementPlanningBoardMenu), {
                viewAs: viewAs,
                boardId: boardId,
                isSwimlanesEnabled: isSwimlanesEnabled,
                dependencyIssueOptions: dependencyIssueOptions,
                onHandleChange: incrementPlanningHandleChange,
                onSwimlaneExpandAll: onSwimlaneExpandAll,
                onSwimlaneCollapseAll: onSwimlaneCollapseAll,
                onUpdate: onUpdate,
                epicCustomName: epicCustomName
            });
        default:
            return null;
    }
};

});
parcelRegister("jlxRF", function(module, exports) {

$parcel$export(module.exports, "BacklogMenu", () => $61210b60d484d0b3$export$baf646a48a139934);

var $5uXOq = parcelRequire("5uXOq");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");

var $duOMW = parcelRequire("duOMW");

var $cACY7 = parcelRequire("cACY7");

var $4cYhQ = parcelRequire("4cYhQ");

var $a4XJc = parcelRequire("a4XJc");

var $9pP0g = parcelRequire("9pP0g");

var $1wNfX = parcelRequire("1wNfX");

var $e2hHN = parcelRequire("e2hHN");

var $9EmtZ = parcelRequire("9EmtZ");

var $htuq0 = parcelRequire("htuq0");

var $cYeCp = parcelRequire("cYeCp");

var $iDGXn = parcelRequire("iDGXn");

var $evv5v = parcelRequire("evv5v");

var $lWTHR = parcelRequire("lWTHR");
const $61210b60d484d0b3$export$baf646a48a139934 = ({ viewAs: viewAs, boardId: boardId, isClassic: isClassic, isVersionsEnabled: isVersionsEnabled, showEpicAsPanel: showEpicAsPanel, showFilterBarToggle: showFilterBarToggle = false, epicCustomName: epicCustomName = 'Epic', areSubtasksEnabled: areSubtasksEnabled = false, areAllSubtasksExpanded: areAllSubtasksExpanded = false, areAllSubtasksCollapsed: areAllSubtasksCollapsed = false, showCardDetails: showCardDetails = true, isEstimateEnabled: isEstimateEnabled = false, onHandleChange: onHandleChange, onSubtasksExpandAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksExpandAll = ()=>{}, onSubtasksCollapseAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksCollapseAll = ()=>{}, cardExtraFields: cardExtraFields = [], isDueDateEnabled: isDueDateEnabled = false, isPriorityEnabled: isPriorityEnabled = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [state, actions] = (0, $iDGXn.useViewSettings)();
    const Section = viewAs === (0, $a4XJc.ViewAs).PANEL ? (0, $e2hHN.PanelSection) : (0, $9UCCQ.default);
    const Group = viewAs === (0, $a4XJc.ViewAs).PANEL ? (0, $1wNfX.PanelGroup) : (0, $eZUJu.default);
    const { toggleViewSetting: toggleViewSetting, toggleShowEpics: toggleShowEpics, toggleShowStatuses: toggleShowStatuses, toggleShowVersions: toggleShowVersions, setViewSettingsCompactMode: setViewSettingsCompactMode, toggleExtraField: toggleExtraField, toggleShowDueDate: toggleShowDueDate } = actions;
    const hasCardExtraFields = cardExtraFields.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Group, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, null, isVersionsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showVersionPanelToggle,
        title: formatMessage((0, $cACY7.default).versionPanel),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).VERSION_PANEL
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).VERSION_PANEL_TOGGLE,
                state: !state.showVersionPanel
            });
        },
        keyboardShortcut: (0, $a4XJc.KeyboardShortcut).VERSION_PANEL_SHORTCUT,
        isChecked: state.showVersionPanel,
        viewAs: viewAs
    }), showEpicAsPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showEpicPanelToggle,
        title: formatMessage((0, $cACY7.default).epicPanel, {
            epicName: epicCustomName
        }),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).EPIC_PANEL
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).EPIC_PANEL_TOGGLE,
                state: !state.showEpicPanel
            });
        },
        keyboardShortcut: (0, $a4XJc.KeyboardShortcut).ISSUE_PARENT_PANEL_SHORTCUT,
        isChecked: state.showEpicPanel,
        viewAs: viewAs
    }), showFilterBarToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showQuickFiltersToggle,
        title: formatMessage((0, $cACY7.default).quickFilters),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).QUICK_FILTERS
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).QUICK_FILTERS_TOGGLE,
                state: !state.showQuickFilters
            });
        },
        isChecked: state.showQuickFilters,
        viewAs: viewAs
    }), viewAs === (0, $a4XJc.ViewAs).PANEL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $cACY7.default).cardDensity),
        hasSeparator: true,
        "data-testId": (0, $duOMW.backlogViewTestIds).cardLayoutSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9EmtZ.ViewSettingsRadioGroup), {
        testId: (0, $duOMW.backlogViewTestIds).cardLayoutRadioGroup,
        onSelect: (value)=>{
            setViewSettingsCompactMode({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                showCompactMode: value === 'compact'
            });
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).CARD_DENSITY,
                state: value
            });
        },
        value: state.showCompactMode ? 'compact' : 'default',
        options: [
            {
                name: 'card-layout',
                value: 'default',
                label: 'Default',
                icon: (0, $lWTHR.CardLayoutDefaultIcon)
            },
            {
                name: 'card-layout',
                value: 'compact',
                label: 'Compact',
                icon: (0, $evv5v.CardLayoutCompactIcon)
            }
        ],
        viewAs: viewAs,
        ariaLabel: formatMessage((0, $cACY7.default).cardDensity)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showCompactModeToggle,
        title: formatMessage((0, $cACY7.default).compactMode),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).COMPACT_MODE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).COMPACT_MODE_TOGGLE,
                state: !state.showCompactMode
            });
        },
        isChecked: state.showCompactMode,
        viewAs: viewAs
    })), areSubtasksEnabled && viewAs !== (0, $a4XJc.ViewAs).PANEL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $cACY7.default).subtasks),
        hasSeparator: true,
        "data-testId": (0, $duOMW.backlogViewTestIds).subtaskSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        testId: (0, $duOMW.backlogViewTestIds).subtaskExpandAll,
        isDisabled: areAllSubtasksExpanded,
        onClick: ()=>{
            onSubtasksExpandAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SUBTASKS_EXPAND_ALL,
                state: (0, $a4XJc.ExpandableState).EXPANDED
            });
        }
    }, formatMessage((0, $cACY7.default).expandAllSubtasks)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        testId: (0, $duOMW.backlogViewTestIds).subtaskCollapseAll,
        isDisabled: areAllSubtasksCollapsed,
        onClick: ()=>{
            onSubtasksCollapseAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SUBTASKS_COLLAPSE_ALL,
                state: (0, $a4XJc.ExpandableState).COLLAPSED
            });
        }
    }, formatMessage((0, $cACY7.default).collapseAllSubtasks))), showCardDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        testId: (0, $duOMW.backlogViewTestIds).cardDetailsSection,
        title: viewAs === (0, $a4XJc.ViewAs).PANEL ? formatMessage((0, $cACY7.default).cardFields) : formatMessage((0, $cACY7.default).cardDetails),
        hasSeparator: true
    }, (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showIssueTypeToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).cardDetailIssueTypeIssueTermRefresh : (0, $cACY7.default).cardDetailIssueType),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_TYPE,
                state: !state.showIssueType
            });
        },
        isChecked: state.showIssueType,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showIssueKeyToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).cardDetailIssueKeyIssueTermRefresh : (0, $cACY7.default).cardDetailIssueKey),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_KEY,
                state: !state.showIssueKey
            });
        },
        isChecked: state.showIssueKey,
        viewAs: viewAs
    })), isVersionsEnabled && isClassic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showVersionsToggle,
        title: formatMessage((0, $cACY7.default).cardDetailVersion),
        onChange: ()=>{
            toggleShowVersions({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_VERSIONS_TOGGLE,
                state: !state.showVersions
            });
        },
        isChecked: state.showVersions,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showEpicsToggle,
        title: epicCustomName,
        onChange: ()=>{
            toggleShowEpics({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_EPICS_TOGGLE,
                state: !state.showEpics
            });
        },
        isChecked: state.showEpics,
        viewAs: viewAs
    }), (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && isDueDateEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showDueDateToggle,
        title: formatMessage((0, $cACY7.default).dueDate),
        onChange: ()=>{
            toggleShowDueDate({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_DUE_DATE,
                state: !state.showDueDate
            });
        },
        isChecked: state.showDueDate,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showStatusToggle,
        title: formatMessage((0, $cACY7.default).cardDetailStatus),
        onChange: ()=>{
            toggleShowStatuses({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_STATUSES_TOGGLE,
                state: !state.showStatuses
            });
        },
        isChecked: state.showStatuses,
        viewAs: viewAs
    }), (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isEstimateEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showEstimateToggle,
        title: formatMessage((0, $cACY7.default).cardDetailEstimate),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_ESTIMATE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ESTIMATE,
                state: !state.showEstimate
            });
        },
        isChecked: state.showEstimate,
        viewAs: viewAs
    }), isPriorityEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showPriorityToggle,
        title: formatMessage((0, $cACY7.default).cardDetailPriority),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_PRIORITY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_PRIORITY,
                state: !state.showPriority
            });
        },
        isChecked: state.showPriority,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showAssigneeToggle,
        title: formatMessage((0, $cACY7.default).cardDetailAssignee),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_ASSIGNEE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ASSIGNEE,
                state: !state.showAssignee
            });
        },
        isChecked: state.showAssignee,
        viewAs: viewAs
    }))), hasCardExtraFields && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        testId: (0, $duOMW.backlogViewTestIds).customFieldsSection,
        hasSeparator: true
    }, cardExtraFields.map((field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
            key: field.id,
            testId: `software-view-settings.ui.view-settings-menu.views.backlog.show-${field.id}-toggle-backlog`,
            title: field.label,
            onChange: ()=>{
                toggleExtraField({
                    boardId: boardId,
                    view: (0, $a4XJc.View).BACKLOG,
                    fieldId: field.id
                });
                onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                    key: `${(0, $4cYhQ.ToggleKey).SHOW_EXTRA_FIELD}_${field.id}`,
                    state: !state.cardExtraFields[field.id]
                });
            },
            isChecked: state.cardExtraFields[field.id],
            viewAs: viewAs
        }))), areSubtasksEnabled && viewAs === (0, $a4XJc.ViewAs).PANEL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $cACY7.default).subtasks),
        hasSeparator: true,
        "data-testId": (0, $duOMW.backlogViewTestIds).subtaskSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $61210b60d484d0b3$var$buttonItemContainerPanelModeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        testId: (0, $duOMW.backlogViewTestIds).subtaskExpandAll,
        isDisabled: areAllSubtasksExpanded,
        onClick: ()=>{
            onSubtasksExpandAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SUBTASKS_EXPAND_ALL,
                state: (0, $a4XJc.ExpandableState).EXPANDED
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInline: "space.100"
    }, formatMessage((0, $cACY7.default).expandAllSubtasks))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        testId: (0, $duOMW.backlogViewTestIds).subtaskCollapseAll,
        isDisabled: areAllSubtasksCollapsed,
        onClick: ()=>{
            onSubtasksCollapseAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SUBTASKS_COLLAPSE_ALL,
                state: (0, $a4XJc.ExpandableState).COLLAPSED
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInline: "space.100"
    }, formatMessage((0, $cACY7.default).collapseAllSubtasks)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            viewSettingsState: state
        }
    }));
};
const $61210b60d484d0b3$var$buttonItemContainerPanelModeStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    left: '-24px',
    width: 'calc(100% + 48px)'
});

});
parcelRegister("cACY7", function(module, exports) {

$parcel$export(module.exports, "default", () => $32380dcb5ffcf2df$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $32380dcb5ffcf2df$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    buttonLabel: {
        "id": "software-view-settings.common.button-label",
        "defaultMessage": "View settings"
    },
    panelSection: {
        "id": "software-view-settings.common.panel-section",
        "defaultMessage": "Panels"
    },
    versionPanel: {
        "id": "software-view-settings.common.version-panel",
        "defaultMessage": "Version panel"
    },
    epicPanel: {
        "id": "software-view-settings.common.epic-panel",
        "defaultMessage": "{epicName} panel"
    },
    quickFilters: {
        "id": "software-view-settings.common.quick-filters",
        "defaultMessage": "Quick filters"
    },
    workSuggestions: {
        "id": "software-view-settings.common.work-suggestions",
        "defaultMessage": "Work suggestions"
    },
    compactMode: {
        "id": "software-view-settings.common.compact-mode",
        "defaultMessage": "Compact mode"
    },
    cardDetails: {
        "id": "software-view-settings.common.card-details",
        "defaultMessage": "Card details"
    },
    cardFields: {
        "id": "software-view-settings.common.card-fields",
        "defaultMessage": "Fields"
    },
    cardDetailVersion: {
        "id": "software-view-settings.common.card-detail-version",
        "defaultMessage": "Version"
    },
    cardDetailStatus: {
        "id": "software-view-settings.common.card-detail-status",
        "defaultMessage": "Status"
    },
    cardDetailIssueType: {
        "id": "software-view-settings.common.card-detail-issue-type",
        "defaultMessage": "Issue type"
    },
    cardDetailIssueKey: {
        "id": "software-view-settings.common.card-detail-issue-key",
        "defaultMessage": "Issue key"
    },
    cardDetailEstimate: {
        "id": "software-view-settings.common.card-detail-estimate",
        "defaultMessage": "Estimate"
    },
    cardDetailPriority: {
        "id": "software-view-settings.common.card-detail-priority",
        "defaultMessage": "Priority"
    },
    cardDetailDevelopment: {
        "id": "software-view-settings.common.card-detail-development",
        "defaultMessage": "Development"
    },
    cardDetailAssignee: {
        "id": "software-view-settings.common.card-detail-assignee",
        "defaultMessage": "Assignee"
    },
    swimlanes: {
        "id": "software-view-settings.common.swimlanes",
        "defaultMessage": "Swimlanes"
    },
    expandAll: {
        "id": "software-view-settings.common.expand-all",
        "defaultMessage": "Expand all"
    },
    collapseAll: {
        "id": "software-view-settings.common.collapse-all",
        "defaultMessage": "Collapse all"
    },
    openIssuesInSidebar: {
        "id": "software-view-settings.common.open-issues-in-sidebar",
        "defaultMessage": "Open issues in sidebar"
    },
    subtasks: {
        "id": "software-view-settings.common.subtasks",
        "defaultMessage": "Subtasks"
    },
    expandAllSubtasks: {
        "id": "software-view-settings.common.expand-all-subtasks",
        "defaultMessage": "Expand all"
    },
    collapseAllSubtasks: {
        "id": "software-view-settings.common.collapse-all-subtasks",
        "defaultMessage": "Collapse all"
    },
    showUnscheduledWork: {
        "id": "software-view-settings.common.show-unscheduled-work",
        "defaultMessage": "Show unscheduled work"
    },
    cardLayout: {
        "id": "software-view-settings.common.card-layout",
        "defaultMessage": "Card layout"
    },
    cardDensity: {
        "id": "software-view-settings.common.card-density",
        "defaultMessage": "Density"
    },
    daysInColumn: {
        "id": "software-view-settings.common.days-in-column",
        "defaultMessage": "Days in column"
    },
    dueDate: {
        "id": "software-view-settings.common.due-date",
        "defaultMessage": "Due date"
    },
    labels: {
        "id": "software-view-settings.common.labels",
        "defaultMessage": "Labels"
    },
    linkedIssues: {
        "id": "software-view-settings.common.linked-issues",
        "defaultMessage": "Linked issues"
    },
    cardCovers: {
        "id": "software-view-settings.common.card-covers",
        "defaultMessage": "Cover images"
    },
    toggleHint: {
        "id": "software-view-settings.common.toggle-hint",
        "defaultMessage": "Press {key} to open and close {panel}"
    },
    beta: {
        "id": "software-view-settings.common.beta",
        "defaultMessage": "Beta"
    },
    maxDependenciesError: {
        "id": "software-view-settings.common.max-dependencies-error",
        "defaultMessage": "You can only show dependencies for {maxDeps, plural, one {# issue} other {# issues}} at one time"
    },
    maxDependenciesErrorIssueTermRefresh: {
        "id": "software-view-settings.common.max-dependencies-error-issue-term-refresh",
        "defaultMessage": "You can only show dependencies for {maxDeps, plural, one {# issue} other {# issues}} at one time"
    },
    cardDetailIssueTypeIssueTermRefresh: {
        "id": "software-view-settings.common.card-detail-issue-type-issue-term-refresh",
        "defaultMessage": "Issue type"
    },
    cardDetailIssueKeyIssueTermRefresh: {
        "id": "software-view-settings.common.card-detail-issue-key-issue-term-refresh",
        "defaultMessage": "Issue key"
    },
    openIssuesInSidebarIssueTermRefresh: {
        "id": "software-view-settings.common.open-issues-in-sidebar-issue-term-refresh",
        "defaultMessage": "Open issues in sidebar"
    },
    linkedIssuesIssueTermRefresh: {
        "id": "software-view-settings.common.linked-issues-issue-term-refresh",
        "defaultMessage": "Linked issues"
    }
});

});

parcelRegister("1wNfX", function(module, exports) {

$parcel$export(module.exports, "PanelGroup", () => $95e55479a51ab212$export$1d05749f6f573bb);

var $5uXOq = parcelRequire("5uXOq");
const $95e55479a51ab212$export$1d05749f6f573bb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);

});

parcelRegister("e2hHN", function(module, exports) {

$parcel$export(module.exports, "PanelSection", () => $52c1e5c9c03f984a$export$15906978feb79aa6);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");
const $52c1e5c9c03f984a$export$15906978feb79aa6 = ({ title: title, hasSeparator: hasSeparator, children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockEnd: title ? 'space.0' : 'space.050',
        testId: testId
    }, hasSeparator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($52c1e5c9c03f984a$var$Separator, null), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $52c1e5c9c03f984a$var$textStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "strong"
    }, title)), children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $52c1e5c9c03f984a$var$Separator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3dopdki _19pk12x7 _otyr12x7",
            __cmplp.className
        ])
    });
});
const $52c1e5c9c03f984a$var$textStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});

parcelRegister("9EmtZ", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsRadioGroup", () => $4233393bcdedbcd3$export$1e1eee2ec7833bf1);

var $5uXOq = parcelRequire("5uXOq");

var $51H8P = parcelRequire("51H8P");

var $5LWLA = parcelRequire("5LWLA");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $jouoW = parcelRequire("jouoW");

var $a4XJc = parcelRequire("a4XJc");
const $4233393bcdedbcd3$export$1e1eee2ec7833bf1 = ({ options: options, value: value, onSelect: onSelect, testId: testId, viewAs: viewAs = (0, $a4XJc.ViewAs).POPUP, ariaLabel: ariaLabel })=>{
    const onChange = (0, $5uXOq.useCallback)((e)=>{
        onSelect(e.target.value);
    }, [
        onSelect
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: viewAs === (0, $a4XJc.ViewAs).PANEL ? $4233393bcdedbcd3$var$panelContainerStyles : $4233393bcdedbcd3$var$popupContainerStyles,
        testId: testId,
        role: "radiogroup",
        "aria-label": ariaLabel
    }, options.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            xcss: $4233393bcdedbcd3$var$radioOptionContainerStyles,
            key: option.value
        }, option.value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jouoW.default), {
            isChecked: option.value === value,
            onChange: onChange,
            name: option.name,
            label: option.label,
            value: option.value
        }), option.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $4233393bcdedbcd3$var$iconContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            glyph: option.icon,
            label: "",
            primaryColor: `var(--ds-icon-subtle, ${(0, $51H8P.N300)})`
        })))));
};
const $4233393bcdedbcd3$var$popupContainerStyles = (0, $8CUq3.xcss)({
    marginBlock: '0',
    marginInline: 'space.200',
    minWidth: '200px'
});
const $4233393bcdedbcd3$var$panelContainerStyles = (0, $8CUq3.xcss)({
    marginBlock: 'space.100',
    marginInline: 'auto',
    minWidth: '200px'
});
const $4233393bcdedbcd3$var$radioOptionContainerStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.075',
    alignItems: 'center',
    justifyContent: 'space-between'
});
const $4233393bcdedbcd3$var$iconContainerStyles = (0, $8CUq3.xcss)({
    opacity: 0.3
});

});
parcelRegister("51H8P", function(module, exports) {

$parcel$export(module.exports, "R50", () => $3a8e82bcbd673dd1$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $3a8e82bcbd673dd1$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $3a8e82bcbd673dd1$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $3a8e82bcbd673dd1$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $3a8e82bcbd673dd1$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $3a8e82bcbd673dd1$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $3a8e82bcbd673dd1$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $3a8e82bcbd673dd1$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $3a8e82bcbd673dd1$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y400", () => $3a8e82bcbd673dd1$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $3a8e82bcbd673dd1$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $3a8e82bcbd673dd1$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $3a8e82bcbd673dd1$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $3a8e82bcbd673dd1$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $3a8e82bcbd673dd1$export$a49394138f7b8e85);
$parcel$export(module.exports, "G500", () => $3a8e82bcbd673dd1$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $3a8e82bcbd673dd1$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $3a8e82bcbd673dd1$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $3a8e82bcbd673dd1$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $3a8e82bcbd673dd1$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $3a8e82bcbd673dd1$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $3a8e82bcbd673dd1$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $3a8e82bcbd673dd1$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $3a8e82bcbd673dd1$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $3a8e82bcbd673dd1$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $3a8e82bcbd673dd1$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N50", () => $3a8e82bcbd673dd1$export$8754fc7e6d8b3000);
$parcel$export(module.exports, "N60", () => $3a8e82bcbd673dd1$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $3a8e82bcbd673dd1$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N200", () => $3a8e82bcbd673dd1$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $3a8e82bcbd673dd1$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "Neutral300", () => $3a8e82bcbd673dd1$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $3a8e82bcbd673dd1$export$13609db0e6812ab8);
$parcel$export(module.exports, "N500", () => $3a8e82bcbd673dd1$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $3a8e82bcbd673dd1$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $3a8e82bcbd673dd1$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $3a8e82bcbd673dd1$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $3a8e82bcbd673dd1$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $3a8e82bcbd673dd1$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $3a8e82bcbd673dd1$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $3a8e82bcbd673dd1$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $3a8e82bcbd673dd1$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $3a8e82bcbd673dd1$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $3a8e82bcbd673dd1$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $3a8e82bcbd673dd1$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $3a8e82bcbd673dd1$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $3a8e82bcbd673dd1$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $3a8e82bcbd673dd1$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $3a8e82bcbd673dd1$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $3a8e82bcbd673dd1$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $3a8e82bcbd673dd1$export$6036577f95c3877e);
$parcel$export(module.exports, "normalizeHexColor", () => $3a8e82bcbd673dd1$export$b61655071712e690);
$parcel$export(module.exports, "isHex", () => $3a8e82bcbd673dd1$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $3a8e82bcbd673dd1$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $3a8e82bcbd673dd1$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgb", () => $3a8e82bcbd673dd1$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToRgba", () => $3a8e82bcbd673dd1$export$9665a07d9187b414);

var $3nnJa = parcelRequire("3nnJa");
const $3a8e82bcbd673dd1$export$4b84fd0e2c617bd = '#FFEBE6';
const $3a8e82bcbd673dd1$export$b34b069eff244586 = '#FFBDAD';
const $3a8e82bcbd673dd1$export$be802dd0d8b57f35 = '#FF8F73';
const $3a8e82bcbd673dd1$export$4a7404f376229999 = '#FF5630';
const $3a8e82bcbd673dd1$export$2010d0fb4295b346 = '#DE350B';
const $3a8e82bcbd673dd1$export$2837b5a1a71d5c02 = '#BF2600';
const $3a8e82bcbd673dd1$export$8d9596b529bbb9cf = '#FFFAE6';
const $3a8e82bcbd673dd1$export$41060a744ab0b7ae = '#FFF0B3';
const $3a8e82bcbd673dd1$export$5aae31392d72caaa = '#FFC400';
const $3a8e82bcbd673dd1$export$59619663aa6500fb = '#FF991F';
const $3a8e82bcbd673dd1$export$874739ea9e379ab6 = '#FF8B00';
const $3a8e82bcbd673dd1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $3a8e82bcbd673dd1$export$69a3bf21b9686c2b = '#ABF5D1';
const $3a8e82bcbd673dd1$export$747d86715d4175de = '#57D9A3';
const $3a8e82bcbd673dd1$export$940e1f69e873f202 = '#36B37E';
const $3a8e82bcbd673dd1$export$a49394138f7b8e85 = '#00875A';
const $3a8e82bcbd673dd1$export$6fa04827ac68a4fb = '#006644';
const $3a8e82bcbd673dd1$export$226de0355ed012f8 = '#DEEBFF';
const $3a8e82bcbd673dd1$export$8c13c2ee36917869 = '#B3D4FF';
const $3a8e82bcbd673dd1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $3a8e82bcbd673dd1$export$b3de0ae08da2ce64 = '#0052CC';
const $3a8e82bcbd673dd1$export$a6ee3d71bc067634 = '#0747A6';
const $3a8e82bcbd673dd1$export$f72948ef771f6f15 = '#D3F1A7';
const $3a8e82bcbd673dd1$export$29a4f05edc054374 = '#FFFFFF';
const $3a8e82bcbd673dd1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $3a8e82bcbd673dd1$export$3e51e8f1440314ba = '#EBECF0';
const $3a8e82bcbd673dd1$export$1ce2d1575d444ceb = '#DFE1E6';
const $3a8e82bcbd673dd1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $3a8e82bcbd673dd1$export$c2e91cbeada39b8b = '#B3BAC5';
const $3a8e82bcbd673dd1$export$eaa8c8a70ac22806 = '#97A0AF';
const $3a8e82bcbd673dd1$export$7c87d337fb91a97d = '#8993A4';
const $3a8e82bcbd673dd1$export$f563ee71e9ee74cd = '#6B778C';
const $3a8e82bcbd673dd1$export$e2ef2124cf4024b1 = '#5E6C84';
const $3a8e82bcbd673dd1$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $3a8e82bcbd673dd1$export$13609db0e6812ab8 = '#091E4224';
const $3a8e82bcbd673dd1$export$c39c0fe0f26207ae = '#42526E';
const $3a8e82bcbd673dd1$export$7090862dc3038a9f = '#758195';
const $3a8e82bcbd673dd1$export$7d61b15e0da132af = '#172B4D';
const $3a8e82bcbd673dd1$export$f78789c8b01753cd = '#172B4D';
const $3a8e82bcbd673dd1$export$a19f0c33186f7767 = '#FDD0EC';
const $3a8e82bcbd673dd1$export$51716a84e62e022c = '#FEDEC8';
const $3a8e82bcbd673dd1$export$363e4475840015bb = '#EAE6FF';
const $3a8e82bcbd673dd1$export$4b0a4417ed59760f = '#C0B6F2';
const $3a8e82bcbd673dd1$export$6011520a64d9a187 = '#998DD9';
const $3a8e82bcbd673dd1$export$a7175d4e9206bc80 = '#DFD8FD';
const $3a8e82bcbd673dd1$export$b48405b95304b5a1 = '#6554C0';
const $3a8e82bcbd673dd1$export$c71e4279dd54a18d = '#5243AA';
const $3a8e82bcbd673dd1$export$147899de772240ec = '#403294';
const $3a8e82bcbd673dd1$export$2cf711fe14c66f06 = '#E6FCFF';
const $3a8e82bcbd673dd1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $3a8e82bcbd673dd1$export$776c9c497ef08533 = '#79E2F2';
const $3a8e82bcbd673dd1$export$69cb3ca10c1e330e = '#C6EDFB';
const $3a8e82bcbd673dd1$export$9dc1ef0f3f48059b = '#00B8D9';
const $3a8e82bcbd673dd1$export$6036577f95c3877e = '#008DA6';
function $3a8e82bcbd673dd1$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($3a8e82bcbd673dd1$export$e698776ec826343(color)) return $3a8e82bcbd673dd1$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($3nnJa.default && $3nnJa.default[color]) color = $3nnJa.default[color];
        else if ($3nnJa && $3nnJa[color]) color = $3nnJa[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $3a8e82bcbd673dd1$export$5a544e13ad4e1fa5(color) {
    if (!$3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    // eslint-disable-next-line no-bitwise
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $3a8e82bcbd673dd1$export$9665a07d9187b414(rawColor, alpha) {
    const color = $3a8e82bcbd673dd1$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $3a8e82bcbd673dd1$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $3a8e82bcbd673dd1$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("3nnJa", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});


parcelRegister("jouoW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d22fafff331be84$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

const $5d22fafff331be84$var$packageName = "platform-pkg";
const $5d22fafff331be84$var$packageVersion = "0.0.0-use.local";
const $5d22fafff331be84$var$noop = (0, $eGmKJ.default);
const $5d22fafff331be84$var$labelPaddingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`
});
const $5d22fafff331be84$var$labelStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'flex-start',
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-disabled]': {
        color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
        cursor: 'not-allowed'
    }
});
const $5d22fafff331be84$var$radioStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    // TODO https://product-fabric.atlassian.net/browse/DSP-10507 revisit and remove the scale of 14/24
    /*
     The circle should be 14px * 14px centred in a 24px * 24px box.
     This is inclusive of a 2px border and inner circle with 2px radius.
     There is a Chrome bug that makes the circle become an oval and the
     inner circle not be centred at various zoom levels. This bug is fixed
     in all browsers if a scale of 14/24 is applied.
   */ width: '24px',
    height: '24px',
    margin: "var(--ds-space-0, 0px)",
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: 'var(--radio-background-color)',
    /* Border should multiply by 24/14 to offset scale, a scale of 12 / 7 is to fix a Chrome bug that makes the circle become an oval and the
     inner circle not be centred at various zoom levels */ border: `${"var(--ds-border-width, 1px)"} solid var(--radio-border-color)`,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    MozAppearance: 'none',
    outline: 'none',
    /*
     Change the variables --radio-background-color, --radio-border-color,
     -radio-dot-color and -radio-dot-opacity according to user interactions.
     All other variables are constant
   */ '--radio-background-color': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
    '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
    '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
    '--radio-dot-opacity': 0,
    /* 24px * 7 / 12 === 14px height and width */ transform: 'scale(calc(7 / 12))',
    transition: 'border-color 0.2s ease-in-out, background-color 0.2s ease-in-out',
    verticalAlign: 'top',
    WebkitAppearance: 'none',
    '&::after': {
        /* Height and width should by 4px, multiply by 24/14 to offset scale */ width: 'calc(4px * 12 / 7)',
        height: 'calc(4px * 12 / 7)',
        position: 'absolute',
        background: 'var(--radio-dot-color)',
        // TODO Delete this comment after verifying spacing token -> previous value `'50%'`
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        content: "''",
        opacity: 'var(--radio-dot-opacity)',
        transition: 'background-color 0.2s ease-in-out, opacity 0.2s ease-in-out'
    },
    '&:hover': {
        '--radio-background-color': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`
    },
    '&:active': {
        '--radio-background-color': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
    },
    '&:focus': {
        outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-border-width-indicator, 3px)"
    },
    '&:checked': {
        '--radio-background-color': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--radio-border-color': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--radio-dot-opacity': 1
    },
    '&:checked:hover': {
        '--radio-background-color': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        '--radio-border-color': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`
    },
    '&:checked:active': {
        '--radio-background-color': `var(--ds-background-selected-bold-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
    },
    '&:checked:focus': {
        outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-border-width-indicator, 3px)"
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid], &:checked[data-invalid]': {
        '--radio-border-color': `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled, &:disabled:hover, &:disabled:focus, &:disabled:active, &:disabled[data-invalid]': {
        cursor: 'not-allowed',
        '--radio-background-color': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        '--radio-border-color': `var(--ds-border-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        '--radio-dot-color': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`
    }
});
const $5d22fafff331be84$var$InnerRadio = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $5d22fafff331be84$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $5d22fafff331be84$var$packageName,
        packageVersion: $5d22fafff331be84$var$packageVersion
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        css: $5d22fafff331be84$var$labelStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        ...rest,
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        "aria-label": ariaLabel,
        checked: isChecked,
        disabled: isDisabled,
        name: name,
        onChange: onChangeAnalytics,
        required: isRequired,
        type: "radio",
        value: value,
        "data-testid": testId && `${testId}--radio-input`,
        // isInvalid is used in a nonstandard way so cannot
        // use :invalid selector
        "data-invalid": isInvalid ? 'true' : undefined,
        css: $5d22fafff331be84$var$radioStyles,
        ref: ref
    }), label ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $5d22fafff331be84$var$labelPaddingStyles
    }, label) : null);
});
/**
 * __Radio__
 *
 * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
 *
 * - [Examples](https://atlassian.design/components/radio/examples)
 * - [Code](https://atlassian.design/components/radio/code)
 * - [Usage](https://atlassian.design/components/radio/usage)
 */ const $5d22fafff331be84$var$Radio = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($5d22fafff331be84$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $5d22fafff331be84$export$2e2bcd8739ae039 = $5d22fafff331be84$var$Radio;

});


parcelRegister("htuq0", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsToggle", () => $5bf54757b2a57348$export$aacc18ae911f8e05);

var $5uXOq = parcelRequire("5uXOq");

var $3T6Xo = parcelRequire("3T6Xo");

var $lj8SI = parcelRequire("lj8SI");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $dTlW6 = parcelRequire("dTlW6");

var $dqoiX = parcelRequire("dqoiX");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $cACY7 = parcelRequire("cACY7");

var $a4XJc = parcelRequire("a4XJc");

var $cYeCp = parcelRequire("cYeCp");
const $5bf54757b2a57348$export$aacc18ae911f8e05 = ({ title: title, isChecked: isChecked, isDisabled: isDisabled, onChange: onChange, keyboardShortcut: keyboardShortcut, subtitleLozenge: subtitleLozenge, testId: testId, viewAs: viewAs = (0, $a4XJc.ViewAs).POPUP, footer: footer })=>{
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(`jira-software-view-settings-${title}`);
    const descriptionId = `${id}-description`;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: viewAs === (0, $a4XJc.ViewAs).PANEL && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? $5bf54757b2a57348$var$panelContainerStyles : $5bf54757b2a57348$var$popupContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.200",
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        "data-testid": testId,
        htmlFor: id
    }, title), subtitleLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: "new"
    }, subtitleLozenge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5bf54757b2a57348$var$tooltipContainerStyles
    }, keyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), null, keyboardShortcut), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        id: id,
        isChecked: isChecked,
        onChange: onChange,
        isDisabled: isDisabled,
        ...keyboardShortcut && {
            descriptionId: descriptionId
        }
    }), keyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        id: descriptionId
    }, formatMessage((0, $cACY7.default).toggleHint, {
        key: keyboardShortcut,
        panel: title
    })))), (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') && footer);
};
const $5bf54757b2a57348$var$popupContainerStyles = (0, $8CUq3.xcss)({
    marginBlock: 'space.100',
    marginInline: 'space.200',
    minWidth: '200px'
});
const $5bf54757b2a57348$var$panelContainerStyles = (0, $8CUq3.xcss)({
    marginBlock: 'space.100',
    marginInline: 'auto',
    minWidth: '200px'
});
const $5bf54757b2a57348$var$tooltipContainerStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    whiteSpace: 'nowrap',
    lineHeight: 0
});

});

parcelRegister("evv5v", function(module, exports) {

$parcel$export(module.exports, "CardLayoutCompactIcon", () => $ca4072fbbcba385a$export$73c305db8d999c47);
// SVG with custom colours

var $5uXOq = parcelRequire("5uXOq");
const $ca4072fbbcba385a$export$73c305db8d999c47 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "58",
        height: "28",
        viewBox: "0 0 58 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H56C56.8284 0.5 57.5 1.17157 57.5 2V9.5H0.5V2Z",
        stroke: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M57 10V18H59V10H57ZM1 18V10H-1V18H1Z",
        fill: "currentColor",
        mask: "url(#path-2-inside-1_1311_59)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0.5 18.5H57.5V26C57.5 26.8284 56.8284 27.5 56 27.5H2C1.17157 27.5 0.5 26.8284 0.5 26V18.5Z",
        stroke: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "5",
        y: "3",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "5",
        y: "12",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "5",
        y: "21",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "12",
        y: "4",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "12",
        y: "13",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "12",
        y: "22",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }));

});

parcelRegister("lWTHR", function(module, exports) {

$parcel$export(module.exports, "CardLayoutDefaultIcon", () => $f330d0d9ada9ffbb$export$b1c73e945668f4c2);
// SVG with custom colours

var $5uXOq = parcelRequire("5uXOq");
const $f330d0d9ada9ffbb$export$b1c73e945668f4c2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "58",
        height: "27",
        viewBox: "0 0 58 27",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0 14H58H0ZM59 25C59 26.6569 57.6569 28 56 28H2C0.343146 28 -1 26.6569 -1 25H1C1 25.5523 1.44772 26 2 26H56C56.5523 26 57 25.5523 57 25H59ZM2 28C0.343146 28 -1 26.6569 -1 25V14H1V25C1 25.5523 1.44772 26 2 26V28ZM59 14V25C59 26.6569 57.6569 28 56 28V26C56.5523 26 57 25.5523 57 25V14H59Z",
        fill: "currentColor",
        mask: "url(#path-1-inside-1_1311_46)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H56C56.8284 0.5 57.5 1.17157 57.5 2V13.5H0.5V2Z",
        stroke: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "5",
        y: "5",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "5",
        y: "18",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "12",
        y: "6",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "12",
        y: "19",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }));

});


parcelRegister("140hX", function(module, exports) {

$parcel$export(module.exports, "BoardMenu", () => $0229f37a37892c4a$export$17445232de9c085a);

var $5uXOq = parcelRequire("5uXOq");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $aIZdc = parcelRequire("aIZdc");

var $6s1PB = parcelRequire("6s1PB");

var $axmY8 = parcelRequire("axmY8");

var $2DjOQ = parcelRequire("2DjOQ");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $5oFIy = parcelRequire("5oFIy");

var $duOMW = parcelRequire("duOMW");

var $cACY7 = parcelRequire("cACY7");

var $4cYhQ = parcelRequire("4cYhQ");

var $a4XJc = parcelRequire("a4XJc");

var $9pP0g = parcelRequire("9pP0g");

var $1wNfX = parcelRequire("1wNfX");

var $e2hHN = parcelRequire("e2hHN");

var $htuq0 = parcelRequire("htuq0");

var $cYeCp = parcelRequire("cYeCp");

var $iDGXn = parcelRequire("iDGXn");
const $0229f37a37892c4a$export$17445232de9c085a = ({ viewAs: viewAs, boardId: boardId, showFilterBarToggle: showFilterBarToggle = false, showLinkedIssueStatsToggle: showLinkedIssueStatsToggle = false, isSwimlanesEnabled: isSwimlanesEnabled = false, showCardDetails: showCardDetails = true, epicCustomName: epicCustomName = 'Epic', onHandleChange: onHandleChange, onSwimlaneExpandAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneExpandAll = ()=>{}, onSwimlaneCollapseAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneCollapseAll = ()=>{}, onToggleWorkSuggestions: // eslint-disable-next-line @typescript-eslint/no-empty-function
onToggleWorkSuggestions = ()=>{}, onLinkedIssuesStatsToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onLinkedIssuesStatsToggledOn = ()=>{}, onShowCardCoversToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onShowCardCoversToggledOn = ()=>{}, isClassic: isClassic = false, isDaysInColumnEnabled: isDaysInColumnEnabled = false, isEstimateEnabled: isEstimateEnabled = false, isDueDateEnabled: isDueDateEnabled = false, isLabelsEnabled: isLabelsEnabled = false, isPriorityEnabled: isPriorityEnabled = false, isDevelopmentEnabled: isDevelopmentEnabled = false, isWorkSuggestionsEnabled: isWorkSuggestionsEnabled = false, showWorkSuggestions: showWorkSuggestions = false, cardExtraFields: cardExtraFields = [] })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [state, actions] = (0, $iDGXn.useViewSettings)();
    const { view: view } = state;
    const { toggleViewSetting: toggleViewSetting, toggleShowEpics: toggleShowEpics, toggleShowLinkedIssuesStats: toggleShowLinkedIssuesStats, toggleShowDaysInColumn: toggleShowDaysInColumn, toggleShowDueDate: toggleShowDueDate, toggleExtraField: toggleExtraField, toggleShowLabels: toggleShowLabels } = actions;
    const viewMode = (0, $2gCtH.useViewMode)();
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, $2gCtH.useIssueContextActions)();
    const Section = viewAs === (0, $a4XJc.ViewAs).PANEL ? (0, $e2hHN.PanelSection) : (0, $9UCCQ.default);
    const Group = viewAs === (0, $a4XJc.ViewAs).PANEL ? (0, $1wNfX.PanelGroup) : (0, $eZUJu.default);
    const handleBoardViewModeClick = ()=>{
        if (viewMode === 'SIDEBAR') setDetailViewAsModal();
        else setDetailViewAsSidebar();
    };
    const hasCardExtraFields = cardExtraFields.length > 0;
    const handleLinkedIssuesStatsToggleChange = (0, $5uXOq.useCallback)(()=>{
        const showIssueLinksStatsState = state.showIssueLinksStats;
        toggleShowLinkedIssuesStats({
            boardId: boardId,
            view: (0, $a4XJc.View).BOARD
        });
        onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
            key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_LINKS_STATS,
            state: !showIssueLinksStatsState
        });
        // start fetching issue links stats if the user turned on toggle
        if (!showIssueLinksStatsState) onLinkedIssuesStatsToggledOn();
    }, [
        boardId,
        onHandleChange,
        onLinkedIssuesStatsToggledOn,
        state.showIssueLinksStats,
        toggleShowLinkedIssuesStats
    ]);
    const handleShowCardCoversToggleChange = (0, $5uXOq.useCallback)(()=>{
        const showCardCoversState = state.showCardCovers;
        toggleViewSetting({
            boardId: boardId,
            view: (0, $a4XJc.View).BOARD,
            setting: (0, $9pP0g.ViewSetting).SHOW_CARD_COVERS
        });
        onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
            key: (0, $4cYhQ.ToggleKey).SHOW_CARD_COVERS,
            state: !state.showCardCovers
        });
        // start fetching card cover data if the user turned on toggle
        if (!showCardCoversState) onShowCardCoversToggledOn();
    }, [
        boardId,
        onHandleChange,
        onShowCardCoversToggledOn,
        state.showCardCovers,
        toggleViewSetting
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Group, {
        "data-testId": (0, $duOMW.boardViewTestIds).viewSettingsBoardMenu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).openIssuesInSidebarToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).openIssuesInSidebarIssueTermRefresh : (0, $cACY7.default).openIssuesInSidebar),
        onChange: ()=>{
            handleBoardViewModeClick();
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).OPEN_ISSUES_IN_SIDEBAR_TOGGLE,
                state: viewMode === 'SIDEBAR' ? (0, $a4XJc.ViewLocation).MODAL : (0, $a4XJc.ViewLocation).SIDEBAR
            });
        },
        isChecked: viewMode === 'SIDEBAR',
        viewAs: viewAs
    }), showFilterBarToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showQuickFiltersToggle,
        title: formatMessage((0, $cACY7.default).quickFilters),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).QUICK_FILTERS
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).QUICK_FILTERS_TOGGLE,
                state: !state.showQuickFilters
            });
        },
        isChecked: state.showQuickFilters,
        viewAs: viewAs
    }), !(0, $aIZdc.isFedRamp)() && showWorkSuggestions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0229f37a37892c4a$var$WorkSuggestionsSpotlightTarget, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2DjOQ.ViewSettingsTogglePulse), {
        isPanelView: viewAs === (0, $a4XJc.ViewAs).PANEL
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showWorkSuggestionsToggle,
        title: formatMessage((0, $cACY7.default).workSuggestions),
        onChange: (_, analyticsEvent)=>{
            onToggleWorkSuggestions(analyticsEvent);
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).WORK_SUGGESTIONS_TOGGLE,
                state: !isWorkSuggestionsEnabled
            });
        },
        isChecked: isWorkSuggestionsEnabled,
        viewAs: viewAs
    })))), isSwimlanesEnabled && viewAs !== (0, $a4XJc.ViewAs).PANEL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $cACY7.default).swimlanes),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": (0, $duOMW.boardViewTestIds).swimlaneExpandAll,
        onClick: ()=>{
            onSwimlaneExpandAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_EXPAND_ALL,
                state: (0, $a4XJc.ExpandableState).EXPANDED
            });
        }
    }, formatMessage((0, $cACY7.default).expandAll)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": (0, $duOMW.boardViewTestIds).swimlaneCollapseAll,
        onClick: ()=>{
            onSwimlaneCollapseAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_COLLAPSE_ALL,
                state: (0, $a4XJc.ExpandableState).COLLAPSED
            });
        }
    }, formatMessage((0, $cACY7.default).collapseAll))), showCardDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        testId: (0, $duOMW.boardViewTestIds).cardDetailsSection,
        title: viewAs === (0, $a4XJc.ViewAs).PANEL ? formatMessage((0, $cACY7.default).cardFields) : formatMessage((0, $cACY7.default).cardDetails),
        hasSeparator: true
    }, view === (0, $a4XJc.View).BOARD && isClassic && (0, $6s1PB.expVal)('jsw_cmp_card_cover_images_experiment', 'isCardCoverFeatureEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showCardCoversToggle,
        title: formatMessage((0, $cACY7.default).cardCovers),
        onChange: handleShowCardCoversToggleChange,
        isChecked: state.showCardCovers,
        viewAs: viewAs
    }), view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showIssueTypeToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).cardDetailIssueTypeIssueTermRefresh : (0, $cACY7.default).cardDetailIssueType),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_TYPE,
                state: !state.showIssueType
            });
        },
        isChecked: state.showIssueType,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showIssueKeyToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).cardDetailIssueKeyIssueTermRefresh : (0, $cACY7.default).cardDetailIssueKey),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_KEY,
                state: !state.showIssueKey
            });
        },
        isChecked: state.showIssueKey,
        viewAs: viewAs
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showEpicsToggle,
        title: epicCustomName,
        onChange: ()=>{
            toggleShowEpics({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_EPICS_TOGGLE,
                state: !state.showEpics
            });
        },
        isChecked: state.showEpics,
        viewAs: viewAs
    }), isDueDateEnabled && view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showDueDateToggle,
        title: formatMessage((0, $cACY7.default).dueDate),
        onChange: ()=>{
            toggleShowDueDate({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_DUE_DATE,
                state: !state.showDueDate
            });
        },
        isChecked: state.showDueDate,
        viewAs: viewAs
    }), isLabelsEnabled && view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showLabelsToggle,
        title: formatMessage((0, $cACY7.default).labels),
        onChange: ()=>{
            toggleShowLabels({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_LABELS,
                state: !state.showLabels
            });
        },
        isChecked: state.showLabels,
        viewAs: viewAs
    }), isEstimateEnabled && view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showEstimateToggle,
        title: formatMessage((0, $cACY7.default).cardDetailEstimate),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ESTIMATE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ESTIMATE,
                state: !state.showEstimate
            });
        },
        isChecked: state.showEstimate,
        viewAs: viewAs
    }), isDaysInColumnEnabled && view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showDaysInColumnToggle,
        title: formatMessage((0, $cACY7.default).daysInColumn),
        onChange: ()=>{
            toggleShowDaysInColumn({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_DAYS_IN_COLUMN,
                state: !state.showDaysInColumn
            });
        },
        isChecked: state.showDaysInColumn,
        viewAs: viewAs
    }), showLinkedIssueStatsToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showLinkedIssueStatsToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).linkedIssuesIssueTermRefresh : (0, $cACY7.default).linkedIssues),
        onChange: handleLinkedIssuesStatsToggleChange,
        isChecked: state.showIssueLinksStats,
        viewAs: viewAs
    }), view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isDevelopmentEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showDevelopmentToggle,
        title: formatMessage((0, $cACY7.default).cardDetailDevelopment),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_DEVELOPMENT
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_DEVELOPMENT,
                state: !state.showDevelopment
            });
        },
        isChecked: state.showDevelopment,
        viewAs: viewAs
    }), isPriorityEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showPriorityToggle,
        title: formatMessage((0, $cACY7.default).cardDetailPriority),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_PRIORITY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_PRIORITY,
                state: !state.showPriority
            });
        },
        isChecked: state.showPriority,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showAssigneeToggle,
        title: formatMessage((0, $cACY7.default).cardDetailAssignee),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ASSIGNEE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ASSIGNEE,
                state: !state.showAssignee
            });
        },
        isChecked: state.showAssignee,
        viewAs: viewAs
    }))), hasCardExtraFields && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        testId: (0, $duOMW.boardViewTestIds).customFieldsSection,
        hasSeparator: true
    }, cardExtraFields.map((field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
            key: field.id,
            testId: `software-view-settings.ui.view-settings-menu.views.board.show-${field.id}-toggle-board`,
            title: field.label,
            onChange: ()=>{
                toggleExtraField({
                    boardId: boardId,
                    view: (0, $a4XJc.View).BOARD,
                    fieldId: field.id
                });
                onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                    key: `${(0, $4cYhQ.ToggleKey).SHOW_EXTRA_FIELD}_${field.id}`,
                    state: !state.cardExtraFields[field.id]
                });
            },
            isChecked: state.cardExtraFields[field.id],
            viewAs: viewAs
        }))), isSwimlanesEnabled && viewAs === (0, $a4XJc.ViewAs).PANEL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $cACY7.default).swimlanes),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0229f37a37892c4a$var$buttonItemContainerPanelModeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": (0, $duOMW.boardViewTestIds).swimlaneExpandAll,
        onClick: ()=>{
            onSwimlaneExpandAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_EXPAND_ALL,
                state: (0, $a4XJc.ExpandableState).EXPANDED
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInline: "space.100"
    }, formatMessage((0, $cACY7.default).expandAll))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": (0, $duOMW.boardViewTestIds).swimlaneCollapseAll,
        onClick: ()=>{
            onSwimlaneCollapseAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_COLLAPSE_ALL,
                state: (0, $a4XJc.ExpandableState).COLLAPSED
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInline: "space.100"
    }, formatMessage((0, $cACY7.default).collapseAll)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            viewSettingsState: state
        }
    }));
};
const $0229f37a37892c4a$var$WorkSuggestionsSpotlightTarget = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $axmY8.WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_VIEW_SETTINGS_STEP_NAME)
    }, children);
const $0229f37a37892c4a$var$buttonItemContainerPanelModeStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    left: '-24px',
    width: 'calc(100% + 48px)'
});

});
parcelRegister("2DjOQ", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsTogglePulse", () => $1beb4c3f15b5459d$export$1cb4eacfdb188bc8);

var $5uXOq = parcelRequire("5uXOq");

var $k6T4f = parcelRequire("k6T4f");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $02beV = parcelRequire("02beV");
const $1beb4c3f15b5459d$var$PULSE_DURATION = 7950;
const $1beb4c3f15b5459d$export$1cb4eacfdb188bc8 = ({ children: children, isPanelView: isPanelView })=>{
    const [{ viewSettingsTogglePulses: viewSettingsTogglePulses }, { setViewSettingsTogglePulses: setViewSettingsTogglePulses }] = (0, $02beV.useNextBestTaskContainer)();
    (0, $5uXOq.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setViewSettingsTogglePulses(false);
        }, $1beb4c3f15b5459d$var$PULSE_DURATION);
        return ()=>{
            clearTimeout(timeoutId);
            setViewSettingsTogglePulses(false);
        };
    }, [
        setViewSettingsTogglePulses
    ]);
    if (!viewSettingsTogglePulses) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return isPanelView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1beb4c3f15b5459d$var$negativePadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        radius: 5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1beb4c3f15b5459d$var$positivePadding
    }, children))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1beb4c3f15b5459d$var$positivePadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        radius: 5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1beb4c3f15b5459d$var$negativePadding
    }, children)));
};
const $1beb4c3f15b5459d$var$negativePadding = (0, $8CUq3.xcss)({
    marginLeft: 'space.negative.050',
    marginRight: 'space.negative.050'
});
const $1beb4c3f15b5459d$var$positivePadding = (0, $8CUq3.xcss)({
    marginLeft: 'space.050',
    marginRight: 'space.050'
});

});


parcelRegister("1ESRw", function(module, exports) {

$parcel$export(module.exports, "IncrementPlanningBoardMenu", () => $6f58092168c61151$export$9a207652c43c8852);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $42CjB = parcelRequire("42CjB");

var $820Wv = parcelRequire("820Wv");

var $5qRwM = parcelRequire("5qRwM");

var $e4yMr = parcelRequire("e4yMr");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $hsmeR = parcelRequire("hsmeR");

var $4jAPy = parcelRequire("4jAPy");

var $cACY7 = parcelRequire("cACY7");

var $4cYhQ = parcelRequire("4cYhQ");

var $a4XJc = parcelRequire("a4XJc");

var $9pP0g = parcelRequire("9pP0g");

var $kfO2I = parcelRequire("kfO2I");

var $htuq0 = parcelRequire("htuq0");

var $iDGXn = parcelRequire("iDGXn");

var $bkrRB = parcelRequire("bkrRB");
const $6f58092168c61151$var$MAX_OPTIONS_LENGTH = 20;
const $6f58092168c61151$var$InfoIconWithTooltip = ({ tooltipContent: tooltipContent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6f58092168c61151$var$infoIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($820Wv))),
        label: tooltipContent,
        appearance: "subtle",
        isTooltipDisabled: false,
        spacing: "compact"
    }));
const $6f58092168c61151$var$MAX_SELECTED_ISSUES = 10;
const $6f58092168c61151$export$9a207652c43c8852 = ({ viewAs: viewAs, boardId: boardId, isSwimlanesEnabled: isSwimlanesEnabled = false, epicCustomName: epicCustomName = 'Epic', onHandleChange: onHandleChange, onSwimlaneExpandAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneExpandAll = ()=>{}, onSwimlaneCollapseAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneCollapseAll = ()=>{}, dependencyIssueOptions: dependencyIssueOptions = {}, onUpdate: // eslint-disable-next-line @typescript-eslint/no-empty-function
onUpdate = ()=>{} })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [state, actions] = (0, $iDGXn.useViewSettings)();
    const rightPanelState = (0, $hsmeR.useActiveRightSidebarState)();
    const issueOptions = (0, $5uXOq.useMemo)(()=>{
        if ((0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) return Object.values(dependencyIssueOptions).map((issue)=>({
                value: issue.id,
                label: `${issue.key} ${issue.summary}`,
                iconUrl: issue.typeUrl
            }));
        return [];
    }, [
        dependencyIssueOptions
    ]);
    const [slicedOptions, setSlicedOptions] = (0, $5uXOq.useState)(issueOptions.slice(0, $6f58092168c61151$var$MAX_OPTIONS_LENGTH));
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(rightPanelState?.panelId) && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) onUpdate();
    }, [
        rightPanelState?.panelId,
        onUpdate
    ]);
    const { setShowUnscheduledColumn: setShowUnscheduledColumn, setShowOfftrackDependencyLines: setShowOfftrackDependencyLines, setIssueIdsToShowDependencies: setIssueIdsToShowDependencies, toggleViewSetting: toggleViewSetting } = actions;
    const onFormatOptionLabel = (option, formatOptionLabelMeta)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            space: "space.050",
            alignBlock: "start"
        }, option.iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: formatOptionLabelMeta.context === 'menu' ? $6f58092168c61151$var$menuIconStyles : $6f58092168c61151$var$valueIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: option.iconUrl,
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, option.label));
    };
    const selectedIssueOptions = (0, $5uXOq.useMemo)(()=>{
        if (Array.isArray(state.issueIdsToShowDependencies) && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) {
            const tempDefaultIssueOptions = [];
            state.issueIdsToShowDependencies.forEach((issueId)=>{
                const issue = dependencyIssueOptions[issueId];
                if (issue) tempDefaultIssueOptions.push({
                    value: issue.id,
                    label: `${issue.key} ${issue.summary}`,
                    iconUrl: issue.typeUrl
                });
            });
            return tempDefaultIssueOptions;
        }
        return [];
    }, [
        state.issueIdsToShowDependencies,
        dependencyIssueOptions
    ]);
    const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action === 'input-change') {
            if (newValue.trim().length === 0) setSlicedOptions(issueOptions.slice(0, $6f58092168c61151$var$MAX_OPTIONS_LENGTH));
            else {
                const filteredInOptions = issueOptions.filter((o)=>(o?.label || '').toLowerCase().includes(newValue.toLowerCase()));
                setSlicedOptions(filteredInOptions.slice(0, $6f58092168c61151$var$MAX_OPTIONS_LENGTH));
            }
        }
    }, [
        issueOptions,
        setSlicedOptions
    ]);
    const getViewSettingsValidationMessage = ()=>{
        if (state.issueIdsToShowDependencies.length > $6f58092168c61151$var$MAX_SELECTED_ISSUES) return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).maxDependenciesErrorIssueTermRefresh : (0, $cACY7.default).maxDependenciesError, {
            maxDeps: $6f58092168c61151$var$MAX_SELECTED_ISSUES
        });
        return undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
        "data-testId": "software-view-settings.ui.view-settings-menu.menu-increment-planning-board"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-unscheduled-column-toggle",
        title: formatMessage((0, $cACY7.default).showUnscheduledWork),
        onChange: ()=>{
            setShowUnscheduledColumn(boardId, !state.showUnscheduledColumn);
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.IncrementPlanningAnalyticsKey).UNSCHEDULED_COLUMN_TOGGLE,
                state: !state.showUnscheduledColumn
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showUnscheduledColumn,
        viewAs: viewAs
    })), isSwimlanesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        title: formatMessage((0, $cACY7.default).swimlanes),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": "software-view-settings.ui.view-settings-menu.views.increment-planning-board.expand-all",
        onClick: ()=>{
            onSwimlaneExpandAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_EXPAND_ALL,
                state: (0, $a4XJc.ExpandableState).EXPANDED
            }, (0, $4cYhQ.Action).CLICKED);
        }
    }, formatMessage((0, $cACY7.default).expandAll)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": "software-view-settings.ui.view-settings-menu.views.increment-planning-board.collapse-all",
        onClick: ()=>{
            onSwimlaneCollapseAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_COLLAPSE_ALL,
                state: (0, $a4XJc.ExpandableState).COLLAPSED
            }, (0, $4cYhQ.Action).CLICKED);
        }
    }, formatMessage((0, $cACY7.default).collapseAll))), (0, $4R6GH.fg)('issue_cards_in_program_board') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        title: formatMessage((0, $cACY7.default).cardFields),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-type-toggle",
        title: formatMessage((0, $cACY7.default).cardDetailIssueType),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_TYPE,
                state: !state.showIssueType
            });
        },
        isChecked: state.showIssueType,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-issue-key-toggle",
        title: formatMessage((0, $cACY7.default).cardDetailIssueKey),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_KEY,
                state: !state.showIssueKey
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showIssueKey,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-epics-toggle",
        title: epicCustomName,
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_EPICS
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_EPICS_TOGGLE,
                state: !state.showEpics
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showEpics,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-estimate-toggle",
        title: formatMessage((0, $cACY7.default).cardDetailEstimate),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ESTIMATE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ESTIMATE,
                state: !state.showEstimate
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showEstimate,
        viewAs: viewAs
    })), (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        title: formatMessage((0, $bkrRB.default).dependencyLinesSection),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.offtrack-dependencies-toggle",
        title: formatMessage((0, $bkrRB.default).showOfftrackDependencyLines),
        onChange: ()=>{
            setShowOfftrackDependencyLines(boardId, !state.showOfftrackDependencyLines);
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.IncrementPlanningAnalyticsKey).SHOW_OFFTRACK_DEPENDENCY_LINES,
                state: !state.showOfftrackDependencyLines
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showOfftrackDependencyLines,
        viewAs: viewAs,
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.default), {
            articleId: (0, $4jAPy.IPH_IDS).OFFTRACK_DEPENDENCIES,
            appearance: "link",
            spacing: "none",
            fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                href: (0, $4jAPy.DOC_LINKS).OFFTRACK_DEPENDENCIES,
                target: "_blank"
            }, formatMessage((0, $bkrRB.default).offtrackDependenciesHelpLink))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            color: "color.text.accent.blue"
        }, formatMessage((0, $bkrRB.default).offtrackDependenciesHelpLink)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6f58092168c61151$var$selectWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kfO2I.ViewSettingsSelect), {
        title: formatMessage((0, $bkrRB.default).showDependenciesOnIssues),
        titleIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f58092168c61151$var$InfoIconWithTooltip, {
            tooltipContent: formatMessage((0, $bkrRB.default).onlyShowScheduledIssueDependencyLinesTooltip)
        }),
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.dependency-lines-select",
        isMulti: true,
        isSearchable: true,
        options: slicedOptions,
        formatOptionLabel: onFormatOptionLabel,
        viewAs: viewAs,
        ...(0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') ? {
            value: selectedIssueOptions
        } : {
            defaultValue: selectedIssueOptions
        },
        placeholder: formatMessage((0, $bkrRB.default).chooseIssue),
        isInvalid: state.issueIdsToShowDependencies.length > $6f58092168c61151$var$MAX_SELECTED_ISSUES,
        validationErrorMessage: getViewSettingsValidationMessage(),
        menuIsOpen: // undefined is default value for menuIsOpen prop where it's controlled by the click. Setting it to false will prevent the menu from opening
        state.issueIdsToShowDependencies.length <= $6f58092168c61151$var$MAX_SELECTED_ISSUES ? undefined : false,
        onInputChange: onInputChange,
        onChange: (selectedOptions)=>{
            let selectedIssueIds = [];
            if (Array.isArray(selectedOptions)) selectedIssueIds = selectedOptions.map((option)=>option.value);
            else if (selectedOptions && 'value' in selectedOptions) selectedIssueIds = selectedOptions ? [
                selectedOptions.value
            ] : [];
            setIssueIdsToShowDependencies(boardId, selectedIssueIds);
            onHandleChange((0, $4cYhQ.ActionSubject).SELECT, {
                key: (0, $4cYhQ.IncrementPlanningAnalyticsKey).ISSUE_IDS_TO_SHOW_DEPENDENCIES,
                count: selectedIssueIds.length
            }, (0, $4cYhQ.Action).CHANGED);
        }
    }))));
};
const $6f58092168c61151$var$menuIconStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.025',
    width: '16px',
    minWidth: '16px',
    height: '16px',
    minHeight: '16px'
});
const $6f58092168c61151$var$valueIconStyles = (0, $8CUq3.xcss)({
    width: '16px',
    minWidth: '16px',
    height: '16px',
    minHeight: '16px'
});
const $6f58092168c61151$var$selectWrapper = (0, $8CUq3.xcss)({
    width: '450px'
});
const $6f58092168c61151$var$infoIconWrapperStyles = (0, $8CUq3.xcss)({
    height: '24px',
    display: 'flex',
    alignItems: 'center'
});

});
parcelRegister("820Wv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8b47c8580de559edd6a7f4245d87179>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d8f3dcf908a8bd0$var$_react = $5d8f3dcf908a8bd0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5d8f3dcf908a8bd0$var$_information = $5d8f3dcf908a8bd0$var$_interopRequireDefault((parcelRequire("jxZHv")));

var $5d8f3dcf908a8bd0$var$_panel = $5d8f3dcf908a8bd0$var$_interopRequireDefault((parcelRequire("kkuz9")));
function $5d8f3dcf908a8bd0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "EditorPanelIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d8f3dcf908a8bd0$var$InformationIcon = (props)=>/*#__PURE__*/ $5d8f3dcf908a8bd0$var$_react.default.createElement($5d8f3dcf908a8bd0$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $5d8f3dcf908a8bd0$var$_panel.default
    }, props));
$5d8f3dcf908a8bd0$var$InformationIcon.Name = 'InformationIconMigration';
var $5d8f3dcf908a8bd0$var$_default = module.exports.default = $5d8f3dcf908a8bd0$var$InformationIcon;

});
parcelRegister("jxZHv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e9b091e24458ded7dee3b5ff897b055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e3b0f5e112f2bb60$var$_react = $e3b0f5e112f2bb60$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e3b0f5e112f2bb60$var$_UNSAFE_baseNew = $e3b0f5e112f2bb60$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e3b0f5e112f2bb60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e3b0f5e112f2bb60$var$InformationIcon = (props)=>/*#__PURE__*/ $e3b0f5e112f2bb60$var$_react.default.createElement($e3b0f5e112f2bb60$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0m-7.5-.75H6a.75.75 0 0 1 .75.75v4h-1.5V6.75H4.5zM6 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$e3b0f5e112f2bb60$var$InformationIcon.displayName = 'InformationIcon';
var $e3b0f5e112f2bb60$var$_default = module.exports.default = $e3b0f5e112f2bb60$var$InformationIcon;

});


parcelRegister("kfO2I", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsSelect", () => $3769930931d22483$export$88e7b5a47d581b96);

var $5uXOq = parcelRequire("5uXOq");

var $3T6Xo = parcelRequire("3T6Xo");

var $qfj8c = parcelRequire("qfj8c");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $7K5PP = parcelRequire("7K5PP");

var $gwIPs = parcelRequire("gwIPs");

var $a4XJc = parcelRequire("a4XJc");

var $cYeCp = parcelRequire("cYeCp");
const $3769930931d22483$export$88e7b5a47d581b96 = ({ title: title, testId: testId, viewAs: viewAs = (0, $a4XJc.ViewAs).POPUP, validationErrorMessage: validationErrorMessage, titleIcon: titleIcon, ...restProps })=>{
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(`jira-software-view-settings-${title}`);
    const errorId = (0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(`jira-software-view-settings-${title}-error`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: viewAs === (0, $a4XJc.ViewAs).PANEL && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? $3769930931d22483$var$panelContainerStyles : $3769930931d22483$var$popupContainerStyles,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3769930931d22483$var$labelWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        htmlFor: id
    }, title), titleIcon)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        inputId: id,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        menuPortalTarget: document.body,
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: (0, $gwIPs.layers).layer
                })
        },
        "aria-invalid": !!validationErrorMessage,
        "aria-errormessage": errorId,
        ...restProps
    }), validationErrorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span",
        id: errorId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, validationErrorMessage)));
};
const $3769930931d22483$var$labelWrapperStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.050'
});
const $3769930931d22483$var$popupContainerStyles = (0, $8CUq3.xcss)({
    marginBlock: 'space.200',
    marginInline: 'space.200',
    minWidth: '200px'
});
const $3769930931d22483$var$panelContainerStyles = (0, $8CUq3.xcss)({
    marginBlock: 'space.200',
    marginInline: 'auto',
    minWidth: '200px'
});

});
parcelRegister("qfj8c", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $b2d5b368fed948c9$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $b2d5b368fed948c9$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $b2d5b368fed948c9$export$5505afb209a532c8);
$parcel$export(module.exports, "MessageWrapper", () => $b2d5b368fed948c9$export$ec445f12f63100a5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $059q9 = parcelRequire("059q9");

var $g4M8x = parcelRequire("g4M8x");


var $dRN65 = parcelRequire("dRN65");
function $b2d5b368fed948c9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b2d5b368fed948c9$var$messageStyles = {
    name: "drnq1s",
    styles: "display:flex;justify-content:baseline;gap:var(--ds-space-075, 6px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
};
const $b2d5b368fed948c9$var$messageAppearanceStyles = {
    default: /*#__PURE__*/ (0, $f8Sb3.css)({
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
    }),
    error: {
        name: "g75jq6",
        styles: "color:var(--ds-text-danger, #AE2A19)"
    },
    valid: {
        name: "118r6eb",
        styles: "color:var(--ds-text-success, #216E4E)"
    }
};
const $b2d5b368fed948c9$var$iconWrapperStyles = {
    name: "x5c876",
    styles: "display:flex;height:16px;align-items:center"
};
const $b2d5b368fed948c9$var$IconWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $b2d5b368fed948c9$var$iconWrapperStyles
    }, children);
};
const $b2d5b368fed948c9$var$messageIcons = {
    error: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g4M8x))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success"
    })
};
const $b2d5b368fed948c9$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $b2d5b368fed948c9$var$messageIcons[appearance];
    const messageRef = (0, $5uXOq.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
    const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($b2d5b368fed948c9$export$579aef2c392a54d4);
    (0, $5uXOq.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null, children);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $b2d5b368fed948c9$var$messageStyles,
            $b2d5b368fed948c9$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined
    }, icon && /*#__PURE__*/ (0, $f8Sb3.jsx)($b2d5b368fed948c9$var$IconWrapper, null, icon), content);
};
const $b2d5b368fed948c9$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dRN65.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $f8Sb3.jsx)($b2d5b368fed948c9$var$Message, {
            fieldId: fieldId ? `${fieldId}-helper` : undefined,
            testId: testId
        }, children));
const $b2d5b368fed948c9$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dRN65.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $f8Sb3.jsx)($b2d5b368fed948c9$var$Message, {
            appearance: "error",
            fieldId: fieldId ? `${fieldId}-error` : undefined,
            testId: testId
        }, children));
const $b2d5b368fed948c9$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dRN65.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $f8Sb3.jsx)($b2d5b368fed948c9$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? `${fieldId}-valid` : undefined,
            testId: testId
        }, children));
const $b2d5b368fed948c9$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isWrapper: false
});
const $b2d5b368fed948c9$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($b2d5b368fed948c9$export$579aef2c392a54d4.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

});
parcelRegister("059q9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f0499610e65a8e7f9250a345ef46c32f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00f7c68b1ac9eeb3$var$_react = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $00f7c68b1ac9eeb3$var$_error = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("hAZqC")));

var $00f7c68b1ac9eeb3$var$_error2 = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("7nnPp")));
function $00f7c68b1ac9eeb3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $00f7c68b1ac9eeb3$var$ErrorIcon = (props)=>/*#__PURE__*/ $00f7c68b1ac9eeb3$var$_react.default.createElement($00f7c68b1ac9eeb3$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $00f7c68b1ac9eeb3$var$_error2.default
    }, props));
$00f7c68b1ac9eeb3$var$ErrorIcon.Name = 'ErrorIconMigration';
var $00f7c68b1ac9eeb3$var$_default = module.exports.default = $00f7c68b1ac9eeb3$var$ErrorIcon;

});
parcelRegister("hAZqC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fbdb3f80d4bcdf634ad3eb6ad4125bf1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ccf572dfbabebdf7$var$_react = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ccf572dfbabebdf7$var$_UNSAFE_baseNew = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ccf572dfbabebdf7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Error".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ccf572dfbabebdf7$var$ErrorIcon = (props)=>/*#__PURE__*/ $ccf572dfbabebdf7$var$_react.default.createElement($ccf572dfbabebdf7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$ccf572dfbabebdf7$var$ErrorIcon.displayName = 'ErrorIcon';
var $ccf572dfbabebdf7$var$_default = module.exports.default = $ccf572dfbabebdf7$var$ErrorIcon;

});


parcelRegister("g4M8x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c91b2071a3b78298cdb1ab35dcf13197>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb425bfe72dc5677$var$_react = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bb425bfe72dc5677$var$_success = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("hs3k8")));

var $bb425bfe72dc5677$var$_success2 = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("kJ541")));
function $bb425bfe72dc5677$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb425bfe72dc5677$var$SuccessIcon = (props)=>/*#__PURE__*/ $bb425bfe72dc5677$var$_react.default.createElement($bb425bfe72dc5677$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $bb425bfe72dc5677$var$_success2.default
    }, props));
$bb425bfe72dc5677$var$SuccessIcon.Name = 'SuccessIconMigration';
var $bb425bfe72dc5677$var$_default = module.exports.default = $bb425bfe72dc5677$var$SuccessIcon;

});
parcelRegister("hs3k8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f46e0408994ee0eebe07fdde2651636>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0347594f5084a834$var$_react = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0347594f5084a834$var$_UNSAFE_baseNew = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0347594f5084a834$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0347594f5084a834$var$SuccessIcon = (props)=>/*#__PURE__*/ $0347594f5084a834$var$_react.default.createElement($0347594f5084a834$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$0347594f5084a834$var$SuccessIcon.displayName = 'SuccessIcon';
var $0347594f5084a834$var$_default = module.exports.default = $0347594f5084a834$var$SuccessIcon;

});




parcelRegister("bkrRB", function(module, exports) {

$parcel$export(module.exports, "default", () => $edba0a4edd60a46b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $edba0a4edd60a46b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dependencyLinesSection: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.dependency-lines-section",
        "defaultMessage": "Dependency lines"
    },
    showOfftrackDependencyLines: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.show-offtrack-dependency-lines",
        "defaultMessage": "Show lines for all off-track dependency lines"
    },
    offtrackDependenciesHelpLink: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.offtrack-dependencies-help-link",
        "defaultMessage": "What are off-track dependencies?"
    },
    showDependenciesOnIssues: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.show-dependencies-on-issues",
        "defaultMessage": "Show lines for dependencies linked to"
    },
    chooseIssue: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.choose-issue",
        "defaultMessage": "Choose issue..."
    },
    onlyShowScheduledIssueDependencyLinesTooltip: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.only-show-scheduled-issue-dependency-lines-tooltip",
        "defaultMessage": "Lines only show once an issue has been scheduled"
    }
});

});



const $3795a016b6403547$export$8be246eeba922980 = 'jsw-tailored-board-view-onboarding';
const $3795a016b6403547$export$a57856d4380e4bb8 = 'viewSettingsButtonTarget';
const $3795a016b6403547$export$989661c424340ff8 = 'viewSettingsPanelTarget';
const $3795a016b6403547$export$4a16d41d3ff730bf = 'addPeopleButtonTarget';



parcelRegister("ca5yC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b70939e8adcdb321$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $34ck9 = parcelRequire("34ck9");


var $gwIPs = parcelRequire("gwIPs");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $jQCwr = parcelRequire("jQCwr");
const $b70939e8adcdb321$export$b4e0432c87affda2 = 440;
const $b70939e8adcdb321$export$177615fff7f0b5c6 = 440;
const $b70939e8adcdb321$export$db1057b88f0c8a04 = 350;
const $b70939e8adcdb321$var$IS_DRAGGING_CLASS_NAME = 'ak-dnd-is-dragging';
class $b70939e8adcdb321$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onResize: undefined
        };
    }
    constructor(props){
        super(props);
        this.onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(()=>{
            const initValue = (0, $jQCwr.getDetailViewWidthRatio)();
            const newValue = Math.max(this.props.parentWidth * initValue, $b70939e8adcdb321$export$b4e0432c87affda2);
            if (newValue === this.state.width) return;
            this.setState({
                width: newValue
            });
        }, $b70939e8adcdb321$export$db1057b88f0c8a04);
        this.onMouseDown = (e)=>{
            this.startX = e.pageX + (this.state.width - $b70939e8adcdb321$export$b4e0432c87affda2); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.addEventListener('mousemove', this.onMouseMove); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.addEventListener('mouseup', this.onMouseUp); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.body.classList.add($b70939e8adcdb321$var$IS_DRAGGING_CLASS_NAME);
        };
        this.onMouseMove = (e)=>{
            this.extraWidth = Math.max(this.startX - e.pageX, 0);
            const newValue = Math.min($b70939e8adcdb321$export$b4e0432c87affda2 + this.extraWidth, this.props.parentWidth / 2);
            if (newValue === this.state.width) return;
            this.setState({
                width: newValue
            });
        };
        this.onMouseUp = ()=>{
            this.startX = 0; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('mousemove', this.onMouseMove); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('mouseup', this.onMouseUp); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.body.classList.remove($b70939e8adcdb321$var$IS_DRAGGING_CLASS_NAME);
            const widthRatio = this.state.width === $b70939e8adcdb321$export$b4e0432c87affda2 ? 0 : this.state.width / this.props.parentWidth;
            (0, $jQCwr.setDetailViewWidthRatio)(widthRatio);
        };
        this.extraWidth = 0;
        this.startX = 0;
        const initValue = (0, $jQCwr.getDetailViewWidthRatio)();
        this.state = {
            width: Math.max(props.parentWidth * initValue, $b70939e8adcdb321$export$b4e0432c87affda2),
            parentWidth: props.parentWidth
        };
    }
    static getDerivedStateFromProps(nextProps, state) {
        const { parentWidth: parentWidth } = nextProps;
        if (parentWidth !== state.parentWidth) {
            const initValue = (0, $jQCwr.getDetailViewWidthRatio)();
            return {
                width: Math.max(parentWidth * initValue, $b70939e8adcdb321$export$b4e0432c87affda2),
                parentWidth: parentWidth
            };
        }
        return state;
    }
    componentDidMount() {
        const { useFixedMinWidth: useFixedMinWidth, onResize: onResize } = this.props; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('resize', this.onWindowResize);
        onResize?.(useFixedMinWidth ? $b70939e8adcdb321$export$177615fff7f0b5c6 : this.state.width);
    }
    componentDidUpdate(prevProps, prevState) {
        const { onResize: onResize, useFixedMinWidth: useFixedMinWidth } = this.props;
        if (prevProps.useFixedMinWidth !== useFixedMinWidth || prevState.width !== this.state.width) onResize?.(useFixedMinWidth ? $b70939e8adcdb321$export$177615fff7f0b5c6 : this.state.width);
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('resize', this.onWindowResize);
    }
    render() {
        const { children: children, useFixedMinWidth: useFixedMinWidth } = this.props;
        return(// dynamic change of values
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b70939e8adcdb321$var$Container, {
            minWidth: useFixedMinWidth ? $b70939e8adcdb321$export$177615fff7f0b5c6 : this.state.width
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b70939e8adcdb321$var$ResizeHandle, {
            onMouseDown: this.onMouseDown,
            "data-testid": "software-board.detail-view.resizer.resize-handler"
        }), children));
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $b70939e8adcdb321$var$ContainerControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1r8h0cf-0"
})((props)=>({
        width: '400px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minWidth: `${props.minWidth || 400}px`,
        minHeight: '100%',
        maxHeight: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-surface, ${(0, $829f609a65d26a98$exports).N0})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $gwIPs.layers).card
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b70939e8adcdb321$var$ContainerExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { minWidth: minWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_7ypm2r": (0, $lD23V.default)(`${__cmplp.minWidth || 400}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1kdj _1ul9152j _1tke1osq _c71l1osq _18m91wug _1reo15vq _1e0c1txw _2lx2vrvc _4cvr1y6m _11q7vuon _1pbyb4wl",
            __cmplp.className
        ])
    });
});
const $b70939e8adcdb321$var$Container = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $b70939e8adcdb321$var$ContainerExperiment, $b70939e8adcdb321$var$ContainerControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b70939e8adcdb321$var$ResizeHandleControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1r8h0cf-1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $gwIPs.gridSize)}px`,
    cursor: 'ew-resize',
    position: 'relative',
    alignSelf: 'stretch',
    '&::after': {
        content: "''",
        width: '2px',
        height: '20px',
        top: '50%',
        transform: 'translateY(-50%)',
        left: "var(--ds-space-050, 4px)",
        transition: 'background 0.2s',
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-border, ${(0, $829f609a65d26a98$exports).N30})`
    },
    '&:hover::after, &:active::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$exports).B200})`,
        height: '100%'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b70939e8adcdb321$var$ResizeHandleExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbftgi _80omuf7j _kqswh2mm _1wpz1fhb _aetrb3bt _z0aiyh40 _1qdggktf _15l21ssb _clh31i34 _19do1b66 _qc5othzt _18postnw _16r2hloo _1jju1pom _5u1r1pom _1gvg1osq _1kmz1osq",
            __cmplp.className
        ])
    });
});
const $b70939e8adcdb321$var$ResizeHandle = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $b70939e8adcdb321$var$ResizeHandleExperiment, $b70939e8adcdb321$var$ResizeHandleControl);

});



parcelRegister("dHKcT", function(module, exports) {

$parcel$export(module.exports, "default", () => $de9b468cff93ea86$export$2e2bcd8739ae039);

var $az4zD = parcelRequire("az4zD");

var $bC2fB = parcelRequire("bC2fB");

var $6Pv6s = parcelRequire("6Pv6s");

var $ebHh7 = parcelRequire("ebHh7");

var $cSfDQ = parcelRequire("cSfDQ");
var $de9b468cff93ea86$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state)=>({
        boardName: (0, $6Pv6s.boardNameSelector)(state),
        sprints: (0, $ebHh7.getSelectedOrAllSprintsSelector)(state)
    }), {})((0, $az4zD.injectIntlV2)((0, $cSfDQ.default)));

});
parcelRegister("6Pv6s", function(module, exports) {

$parcel$export(module.exports, "boardNameSelector", () => $e5862aec7e26552e$export$6565b2df5446c7ba);
$parcel$export(module.exports, "boardTitleSelector", () => $e5862aec7e26552e$export$a7b2cfd83eec7d8b);
$parcel$export(module.exports, "isEditableSelector", () => $e5862aec7e26552e$export$c1ae0fa851a148a8);

var $dGvGJ = parcelRequire("dGvGJ");



var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $5mTgl = parcelRequire("5mTgl");

var $1vXOx = parcelRequire("1vXOx");
const $e5862aec7e26552e$export$6565b2df5446c7ba = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getBoardConfig)
], (boardConfig)=>boardConfig.name);
const $e5862aec7e26552e$export$a7b2cfd83eec7d8b = (0, $dGvGJ.createSelector)([
    (0, $ebHh7.getSprintEntities),
    (0, $67Z81.getBoardConfig),
    (0, $5mTgl.getWorkFilters)
], (activeSprints, boardConfig, workFilters)=>{
    const numOfActiveSprints = Object.keys(activeSprints).length;
    if (boardConfig.isSprintsEnabled === false || numOfActiveSprints === 0) return boardConfig.name;
    const selectedSprints = workFilters.values[0, $dcff40112356dfc1$export$a316570a0dbfd2b0] ?? [];
    const numOfSelectedSprints = selectedSprints?.length ?? 0;
    if (numOfActiveSprints === 1) return activeSprints[Object.keys(activeSprints)[0]].name;
    if (numOfSelectedSprints === 1 && activeSprints[selectedSprints[0]]) return activeSprints[selectedSprints[0]].name;
    if (numOfSelectedSprints > 1 && numOfSelectedSprints < numOfActiveSprints) return `${numOfSelectedSprints} sprints`;
    return 'All sprints';
});
const $e5862aec7e26552e$export$c1ae0fa851a148a8 = (0, $dGvGJ.createSelector)([
    (0, $ebHh7.activeSprintsSelector),
    (0, $1vXOx.getPermissionsSelector),
    (0, $67Z81.getIsCMPBoard)
], (activeSprints, permissions, isCMPBoard)=>(activeSprints === null || activeSprints.length === 0) && (permissions[0, $e525e6c25695c9df$export$aadc620ce91112df] || false) && !isCMPBoard);

});

parcelRegister("cSfDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc2ae0850ca32cc0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ew1Lk = parcelRequire("ew1Lk");

var $gN2Mn = parcelRequire("gN2Mn");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bc2ae0850ca32cc0$export$2e2bcd8739ae039 = ({ intl: intl, boardName: boardName, sprints: sprints })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew1Lk.DocumentTitle), {
        title: intl.formatMessage((0, $gN2Mn.default).pageTitleWithSprint, {
            boardName: boardName,
            sprintCount: sprints?.length || 0,
            sprintName: sprints?.length ? sprints[0].name : ''
        })
    });

});
parcelRegister("ew1Lk", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $41b549fa18234081$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $6nkVm = parcelRequire("6nkVm");

class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $6nkVm.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6nkVm.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("gN2Mn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2583f8d6e5a3c6d9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2583f8d6e5a3c6d9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pageTitle: {
        "id": "software.main.document-title.page-title",
        "defaultMessage": "{boardName} - Agile board"
    },
    pageTitleWithSprint: {
        "id": "software.main.document-title.page-title-with-sprint",
        "defaultMessage": "{sprintCount, plural, =0 {{boardName} - Agile Board} one {{sprintName} - {boardName} - Agile Board} other {# sprints - {boardName} - Agile Board}}"
    }
});

});



parcelRegister("hOou0", function(module, exports) {

$parcel$export(module.exports, "withViewExperienceTracker", () => $e6065608c6b6ea40$export$52092272c0483371);

var $5uXOq = parcelRequire("5uXOq");

var $aD4Nm = parcelRequire("aD4Nm");

const $e6065608c6b6ea40$export$52092272c0483371 = (ComponentBeingTracked)=>{
    const WithViewExperienceTracker = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD4Nm.ExperienceTracker), {
            location: (0, $dcbb2bce513725b3$export$fa0622448a6f265)
        }, ({ onExperienceSuccess: onExperienceSuccess })=>// @ts-expect-error - Type '{ onExperienceSuccess: () => void; } & Omit<T, "onExperienceSuccess">' is not assignable to type 'T'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentBeingTracked, {
                onExperienceSuccess: onExperienceSuccess,
                ...props
            }));
    return WithViewExperienceTracker;
};

});

parcelRegister("gdLuI", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfea86bc6a72f400$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $2OMDV = parcelRequire("2OMDV");

var $bC2fB = parcelRequire("bC2fB");

var $bkCF5 = parcelRequire("bkCF5");

var $dW1HX = parcelRequire("dW1HX");

var $2r32e = parcelRequire("2r32e");
var $bfea86bc6a72f400$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $bC2fB.connect)((state)=>({
        flags: state.ui.flags,
        externalId: 'software.board'
    }), {
    dismissFlag: $bkCF5.dismissFlag,
    openIssueModal: $dW1HX.openIssueModal
}), (0, $2OMDV.AnalyticsEventToProps)('Flags', {
    onPrimaryActionClick: 'primaryActionClicked'
}))((0, $2r32e.default));

});
parcelRegister("2r32e", function(module, exports) {

$parcel$export(module.exports, "default", () => $1842ebbe43eb05a1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1sWm7 = parcelRequire("1sWm7");

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $8Rkzz = parcelRequire("8Rkzz");

var $hMVoD = parcelRequire("hMVoD");

var $2Yv61 = parcelRequire("2Yv61");

var $b0JGA = parcelRequire("b0JGA");

var $34Rrn = parcelRequire("34Rrn");

var $btivG = parcelRequire("btivG");

var $7nnPp = parcelRequire("7nnPp");

var $2hXfb = parcelRequire("2hXfb");

var $gtreQ = parcelRequire("gtreQ");

var $e4yMr = parcelRequire("e4yMr");


var $4R6GH = parcelRequire("4R6GH");

var $7R4eB = parcelRequire("7R4eB");

var $f2BYd = parcelRequire("f2BYd");

var $az4zD = parcelRequire("az4zD");

var $8zOmE = parcelRequire("8zOmE");


var $bkCF5 = parcelRequire("bkCF5");

var $cW3pH = parcelRequire("cW3pH");

var $apkY5 = parcelRequire("apkY5");

var $7AVqz = parcelRequire("7AVqz");

var $3h5zX = parcelRequire("3h5zX");

var $2I1lL = parcelRequire("2I1lL");
class $1842ebbe43eb05a1$export$434ba092ed0eee4e extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            openIssueModal: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            createAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    getIconForFlag(flag) {
        switch(flag.type){
            case 0, $587ae274b8f0e917$export$3e8caae81220a92d:
                return (0, $4R6GH.fg)('tnk-1613-jira-visual-refresh-jsw-board-icons-2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($34Rrn))), {
                    color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y300})`,
                    spacing: "spacious",
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gtreQ))),
                    LEGACY_primaryColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y300})`,
                    label: this.props.intl.formatMessage((0, $7AVqz.default).warningLabel)
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gtreQ))), {
                    primaryColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y300})`,
                    label: this.props.intl.formatMessage((0, $7AVqz.default).warningLabel)
                });
            case 0, $587ae274b8f0e917$export$1d0740fae54799e6:
                return (0, $4R6GH.fg)('tnk-1613-jira-visual-refresh-jsw-board-icons-2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b0JGA))), {
                    label: "",
                    color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($btivG))),
                    LEGACY_primaryColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($btivG))), {
                    primaryColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
                    label: ""
                });
            case 0, $587ae274b8f0e917$export$b80f3194b3ff34b4:
                return (0, $4R6GH.fg)('tnk-1613-jira-visual-refresh-jsw-board-icons-2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Yv61))), {
                    label: "",
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2hXfb))),
                    color: "var(--ds-icon, #44546F)"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hXfb))), {
                    label: ""
                });
            case 0, $587ae274b8f0e917$export$b0516b50882e8fbc:
                return (0, $4R6GH.fg)('tnk-1613-jira-visual-refresh-jsw-board-icons-2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMVoD))), {
                    label: this.props.intl.formatMessage((0, $7AVqz.default).errorLabel),
                    color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R400})`,
                    spacing: "spacious",
                    // LEGACY_fallbackIcon={ErrorIconOld}
                    LEGACY_primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R400})`
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7nnPp))), {
                    label: this.props.intl.formatMessage((0, $7AVqz.default).errorLabel),
                    primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R400})`
                });
            case 0, $587ae274b8f0e917$export$f1471fc4e853391b:
                return (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Yv61))), {
                    spacing: "spacious",
                    label: "",
                    color: `var(--ds-icon-information, ${(0, $829f609a65d26a98$exports).B400})`
                }) : null;
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null);
        }
    }
    // render the error messages flag description as un-ordered list
    buildErrorMessagesNode(errorMessages) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", null, errorMessages.map((message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
                key: message
            }, message)));
    }
    getDescriptionForFlag(flag) {
        // for the flag, the description is optional, so it can be undefined,
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(flag.descriptionMessage) && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) return undefined;
        // this check is to make the ts happy. remove this condition check when clean up the fg('dependency_visualisation_program_board_fe_and_be')
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(flag.descriptionMessage)) {
            if (flag.type === (0, $587ae274b8f0e917$export$b0516b50882e8fbc) && flag.errorMessages && flag.errorMessages.length > 0) return this.buildErrorMessagesNode(flag.errorMessages);
            const { formatMessage: formatMessage } = this.props.intl;
            return flag.id === (0, $cW3pH.LOG_BACK_IN_SHOW) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage(flag.descriptionMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                href: flag.context && flag.context.url
            }, formatMessage((0, $7AVqz.default).logBackInAnchorText)))) : formatMessage(flag.descriptionMessage, flag.context);
        }
    }
    render() {
        return(// when clean up the fg dependency_visualisation_program_board_fe_and_be, we can safely remove this ts error comment
        // @ts-expect-error - TS2322 -  Type 'null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f2BYd.default), {
            onDismissed: this.dismissFlag
        }, this.props.flags.map(this.renderFlag)));
    }
    constructor(...args){
        super(...args);
        this.dismissFlag = (flagId)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const flag = (0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(this.props.flags, {
                id: flagId
            });
            if (flag) this.props.dismissFlag(flag);
        };
        this.renderFlag = (flag)=>{
            const { formatMessage: formatMessage } = this.props.intl;
            // remove this whole condition check block when clean up the FG dependency_visualisation_program_board_fe_and_be
            if (flag.type === (0, $587ae274b8f0e917$export$f1471fc4e853391b) && !(0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) return null;
            if (flag.type === (0, $587ae274b8f0e917$export$b80f3194b3ff34b4)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2I1lL.UndoFlag), {
                key: flag.id,
                flag: flag,
                icon: this.getIconForFlag(flag),
                onDismissFlag: this.dismissFlag
            });
            switch(flag.id){
                // Special render case for "Created issue is filtered" flag
                case 0, $bkCF5.FLAG_CREATED_ISSUE_IS_FILTERED:
                    {
                        const issueKey = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(flag, [
                            'context',
                            'issueKey'
                        ]);
                        return (0, $apkY5.default)({
                            id: flag.id,
                            issueKey: issueKey,
                            intl: this.props.intl,
                            onPrimaryActionClick: ()=>{
                                this.dismissFlag(flag.id);
                                const analyticsEvent = this.props.createAnalyticsEvent({
                                    action: 'issueOpened',
                                    actionSubject: 'flag'
                                });
                                const issueId = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(flag, [
                                    'context',
                                    'issueId'
                                ]);
                                // @ts-expect-error - Argument of type 'void | UIAnalyticsEvent' is not assignable to parameter of type 'UIAnalyticsEvent'.
                                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'newIssueFiltered', {
                                    issueId: issueId
                                });
                                this.props.openIssueModal(issueKey);
                            }
                        });
                    }
                case 0, $cW3pH.BOARD_LOAD_FAILURE_NO_COLUMN:
                    {
                        const canConfigureBoard = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(flag, [
                            'context',
                            'canConfigureBoard'
                        ]);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3h5zX.default), {
                            key: flag.id,
                            id: flag.id,
                            canUserConfigureBoard: canConfigureBoard,
                            onDismissed: this.dismissFlag
                        });
                    }
                default:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7R4eB.default), {
                        id: flag.id,
                        key: flag.id,
                        title: formatMessage(flag.titleMessage, flag.context),
                        description: flag.rawDescriptionMessage ?? this.getDescriptionForFlag(flag),
                        icon: this.getIconForFlag(flag)
                    });
            }
        };
    }
}
var $1842ebbe43eb05a1$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($1842ebbe43eb05a1$export$434ba092ed0eee4e);

});
parcelRegister("apkY5", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a9f0fe74b5e0197$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $34Rrn = parcelRequire("34Rrn");

var $gtreQ = parcelRequire("gtreQ");


var $4R6GH = parcelRequire("4R6GH");

var $7R4eB = parcelRequire("7R4eB");

var $7AVqz = parcelRequire("7AVqz");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8a9f0fe74b5e0197$export$2e2bcd8739ae039 = ({ id: id, issueKey: issueKey, intl: intl, onPrimaryActionClick: onPrimaryActionClick })=>{
    const { formatMessage: formatMessage } = intl;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7R4eB.default), {
        id: id,
        key: id,
        title: formatMessage((0, $7AVqz.default).createdIssueIsFilteredTitle, {
            issueKey: issueKey
        }),
        description: formatMessage((0, $7AVqz.default).createdIssueIsFilteredDescription),
        icon: (0, $4R6GH.fg)('tnk-1613-jira-visual-refresh-jsw-board-icons-2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($34Rrn))), {
            color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y300})`,
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gtreQ))),
            LEGACY_primaryColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y300})`,
            label: formatMessage((0, $7AVqz.default).warningLabel)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gtreQ))), {
            primaryColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y300})`,
            label: formatMessage((0, $7AVqz.default).warningLabel)
        }),
        actions: [
            {
                content: formatMessage((0, $7AVqz.default).createdIssueIsFilteredLink),
                onClick: ()=>{
                    onPrimaryActionClick(id);
                }
            }
        ]
    });
};

});

parcelRegister("3h5zX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2850163593582679$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $eph8m = parcelRequire("eph8m");

var $67Z81 = parcelRequire("67Z81");

var $9Frjj = parcelRequire("9Frjj");
const $2850163593582679$var$mapStateToProps = (state)=>({
        boardConfigUrl: (0, $eph8m.getColumnStatusMappingUrl)((0, $67Z81.projectKeySelector)(state), (0, $67Z81.rapidViewIdSelector)(state))
    });
var $2850163593582679$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($2850163593582679$var$mapStateToProps, {})((0, $9Frjj.default));

});
parcelRegister("9Frjj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f96fb1c45c919495$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $7AVqz = parcelRequire("7AVqz");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f96fb1c45c919495$export$2e2bcd8739ae039 = ({ onDismissed: onDismissed, id: id, boardConfigUrl: boardConfigUrl, canUserConfigureBoard: canUserConfigureBoard })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const actions = canUserConfigureBoard ? [
        {
            content: formatMessage((0, $7AVqz.default).manageStatusesLink),
            href: boardConfigUrl
        }
    ] : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.ErrorFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $7AVqz.default).noColumnFailureTitle),
        description: formatMessage(canUserConfigureBoard ? (0, $7AVqz.default).noColumnFailureAdminDescription : (0, $7AVqz.default).noColumnFailureNonAdminDescription),
        actions: actions
    });
};

});


parcelRegister("2I1lL", function(module, exports) {

$parcel$export(module.exports, "UndoFlag", () => $17c673306b86f3c5$export$bbd014b7afeff20f);

var $5uXOq = parcelRequire("5uXOq");

var $d4xRU = parcelRequire("d4xRU");

var $koVbs = parcelRequire("koVbs");

var $7D59a = parcelRequire("7D59a");

var $67sX6 = parcelRequire("67sX6");

var $bkCF5 = parcelRequire("bkCF5");

var $hv2Hm = parcelRequire("hv2Hm");
const $17c673306b86f3c5$var$DEFAULT_TIME_TO_COMPLETE = 8000;
function $17c673306b86f3c5$export$1cca3de68d9dd76a({ flag: flag, onDismissFlag: onDismissFlag }) {
    const hasDismissed = (0, $5uXOq.useRef)(false);
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const onClickUndo = (0, $7D59a.useEvent)(()=>{
        if (hasDismissed.current) return;
        hasDismissed.current = true;
        dispatch((0, $bkCF5.undoFlagPerformUndo)(flag.id));
        onDismissFlag(flag.id);
    });
    const onDismissed = (0, $7D59a.useEvent)(()=>{
        if (hasDismissed.current) return;
        hasDismissed.current = true;
        onDismissFlag(flag.id);
        dispatch((0, $bkCF5.undoFlagPerformCommit)(flag.id));
    });
    return {
        onClickUndo: onClickUndo,
        onDismissed: onDismissed
    };
}
function $17c673306b86f3c5$export$9d0f4ae0a47d1ddb(onDismissed) {
    (0, $5uXOq.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            onDismissed();
        }, $17c673306b86f3c5$var$DEFAULT_TIME_TO_COMPLETE);
        return ()=>{
            clearTimeout(timeoutId);
            onDismissed();
        };
    }, [
        onDismissed
    ]);
}
function $17c673306b86f3c5$export$bbd014b7afeff20f({ flag: flag, icon: icon, onDismissFlag: onDismissFlag }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { onClickUndo: onClickUndo, onDismissed: onDismissed } = $17c673306b86f3c5$export$1cca3de68d9dd76a({
        flag: flag,
        onDismissFlag: onDismissFlag
    });
    $17c673306b86f3c5$export$9d0f4ae0a47d1ddb(onDismissed);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4xRU.default), {
        id: flag.id,
        icon: icon,
        testId: "software-board.flags.undo-flag.ak-flag",
        title: formatMessage(flag.titleMessage, flag.context),
        description: formatMessage(flag.descriptionMessage, flag.context),
        actions: [
            ...flag.links.map((action)=>({
                    ...action,
                    content: formatMessage(action.content, flag.context),
                    target: '_blank'
                })),
            {
                testId: 'software-board.flags.undo-flag.ak-flag-undo-button',
                content: formatMessage((0, $hv2Hm.messages).revertChanges),
                onClick: onClickUndo
            }
        ],
        onDismissed: onDismissed
    });
}

});
parcelRegister("d4xRU", function(module, exports) {

$parcel$export(module.exports, "default", () => $61381db0e069bc03$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1eg3p = parcelRequire("1eg3p");

var $3KRpp = parcelRequire("3KRpp");
const $61381db0e069bc03$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.CommonFlag), {
        flagType: "info",
        ...props
    }));
var $61381db0e069bc03$export$2e2bcd8739ae039 = $61381db0e069bc03$var$AkFlag;

});

parcelRegister("hv2Hm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $56e5fa3c0865e8c3$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $56e5fa3c0865e8c3$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    revertChanges: {
        "id": "software.main.flags.undo-flag.revert-changes",
        "defaultMessage": "Undo"
    }
});

});




parcelRegister("lkgHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $eae5c0676be4d6ed$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $5mTgl = parcelRequire("5mTgl");

var $dtbmY = parcelRequire("dtbmY");
var $eae5c0676be4d6ed$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state)=>({
        numIssues: (0, $5mTgl.workIssuesSelector)(state).length
    }), {})((0, $dtbmY.default));

});
parcelRegister("dtbmY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4352167773cab047$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dF9Z3 = parcelRequire("dF9Z3");
function $4352167773cab047$export$2e2bcd8739ae039({ numIssues: numIssues }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dF9Z3.default), {
        analyticsAttributes: {
            numIssues: numIssues
        }
    });
}

});
parcelRegister("dF9Z3", function(module, exports) {

$parcel$export(module.exports, "isMacOS", () => $3300b05877fade72$export$6159e43e50a41987);
$parcel$export(module.exports, "useGlobalSearch", () => $3300b05877fade72$export$1df85516f1b3e335);
$parcel$export(module.exports, "default", () => $3300b05877fade72$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fW62l = parcelRequire("fW62l");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $3300b05877fade72$export$6159e43e50a41987 = ()=>Boolean(navigator && /^Mac/.test(navigator.platform));
const $3300b05877fade72$export$1df85516f1b3e335 = (/** Callback to be fired when global search is used */ callback, getGlobalDocument = ()=>document)=>{
    (0, $5uXOq.useEffect)(()=>{
        const trackGlobalSearch = (event)=>{
            const isMacOs = $3300b05877fade72$export$6159e43e50a41987();
            if (isMacOs && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('f') && event.metaKey || !isMacOs && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('f') && event.ctrlKey) callback({
                isMacOs: isMacOs,
                event: event
            });
        };
        getGlobalDocument().addEventListener('keydown', trackGlobalSearch);
        return ()=>getGlobalDocument().removeEventListener('keydown', trackGlobalSearch);
    }, [
        callback,
        getGlobalDocument
    ]);
};
const $3300b05877fade72$var$GlobalSearchTracker = ({ getGlobalDocument: getGlobalDocument = ()=>document, fireAnalytics: fireAnalytics = (0, $8zOmE.fireTrackAnalytics), analyticsAttributes: analyticsAttributes = {} })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onGlobalSearch = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'isMacOs' implicitly has an 'any' type.
    ({ isMacOs: isMacOs })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'triggered',
            actionSubject: 'globalSearch'
        });
        const attributes = {
            ...analyticsAttributes,
            isMacOs: isMacOs
        };
        fireAnalytics(analyticsEvent, 'globalSearch triggered', attributes);
    }, [
        analyticsAttributes,
        createAnalyticsEvent,
        fireAnalytics
    ]);
    $3300b05877fade72$export$1df85516f1b3e335(onGlobalSearch, getGlobalDocument);
    return null;
};
var $3300b05877fade72$export$2e2bcd8739ae039 = $3300b05877fade72$var$GlobalSearchTracker;

});



parcelRegister("7CZZJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d715143425ca28bf$export$2e2bcd8739ae039);

var $3llBT = parcelRequire("3llBT");

var $jS4lj = parcelRequire("jS4lj");

var $bC2fB = parcelRequire("bC2fB");

var $2xFXk = parcelRequire("2xFXk");

var $iUagi = parcelRequire("iUagi");


var $1vXOx = parcelRequire("1vXOx");

var $k8auG = parcelRequire("k8auG");

var $kc6Ry = parcelRequire("kc6Ry");

var $9OPlz = parcelRequire("9OPlz");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $5mTgl = parcelRequire("5mTgl");

var $7tZOY = parcelRequire("7tZOY");

var $3SShY = parcelRequire("3SShY");

var $XvlUo = parcelRequire("XvlUo");

var $lFerq = parcelRequire("lFerq");

var $7jxaT = parcelRequire("7jxaT");

var $7hxB7 = parcelRequire("7hxB7");

var $7lFcC = parcelRequire("7lFcC");

var $j3072 = parcelRequire("j3072");

var $9eTg7 = parcelRequire("9eTg7");

var $3NePp = parcelRequire("3NePp");
const $d715143425ca28bf$export$c31df4bd766f9c35 = (state)=>{
    const isTabNavigation = (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).IS_TAB_NAVIGATION);
    const isCompleteSprintButtonVisible = (0, $9eTg7.getIsCompleteSprintButtonVisible)(state);
    // We should remove Sprint Remaining Days entirely when removing Capability.IS_TAB_NAVIGATION
    const isSprintRemainingDaysVisible = !isTabNavigation && !!(0, $ebHh7.remainingDaysSelector)(state).remainingDays;
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
    const boardType = (0, $67Z81.getBoardType)(state);
    const isJSWBoard = (0, $67Z81.getIsJSWBoard)(state);
    return {
        baseUrl: (0, $67Z81.contextPathSelector)(state),
        locale: (0, $67Z81.getLocale)(state),
        sprintGoal: (0, $ebHh7.activeSprintGoalSelector)(state),
        isMenuVisible: !!(0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df] || isCMPBoard,
        isHeaderCompactMode: (0, $k8auG.getIsHeaderCompactMode)(state),
        isCMPBoard: isCMPBoard,
        isJSWBoard: isJSWBoard,
        isIncrementPlanningBoard: isIncrementPlanningBoard,
        rapidViewId: (0, $67Z81.rapidViewIdSelector)(state),
        Menu: $7jxaT.default,
        ReleaseVersion: $7hxB7.default,
        isReleaseVersionVisible: isCMPBoard && boardType === 'KANBAN' && (0, $5mTgl.isReleasesFeatureEnabled)(state),
        ControlsBar: $3SShY.default,
        Title: $j3072.default,
        // New AutomationMenu is NOT just for CMP now. We should use it for TMP as well
        AutomationMenu: (0, $iUagi.isNewAutomationMenuEnabled)() ? (0, $3llBT.BoardMenu) : (0, $3llBT.default),
        isCompleteSprintButtonVisible: isCompleteSprintButtonVisible,
        hasManageSprintPermission: (0, $ebHh7.hasManageSprintPermission)(state),
        CompleteSprintButton: $7tZOY.default,
        FavoriteButton: $lFerq.default,
        isSprintRemainingDaysVisible: isSprintRemainingDaysVisible,
        SprintRemainingDays: $7lFcC.default,
        BoardOperations: $XvlUo.default,
        BreadcrumbRenderer: $jS4lj.default,
        // For UIF this will always be true but the AutomationMenu is permission aware
        canManageAutomations: !!(0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$7c16e92435670968],
        projectKey: (0, $67Z81.projectKeySelector)(state),
        projectId: (0, $67Z81.projectIdSelector)(state),
        projectName: (0, $67Z81.projectNameSelector)(state),
        projectType: 'software',
        isSprintsEnabled: (0, $ebHh7.isSprintsEnabled)(state),
        hasActiveSprint: (0, $ebHh7.hasActiveSprintsSelector)(state),
        selectedIssueKeys: (0, $9OPlz.selectedIssueKeysSelector)(state),
        selectedIssueIds: (0, $9OPlz.selectedIssueIdsSelector)(state),
        boardName: (0, $67Z81.getBoardName)(state),
        shouldRenderFavouriteButton: (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).RENDER_BOARD_FAVOURITE_HEADER_BUTTON),
        shouldRenderAutomationButton: (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).RENDER_BOARD_AUTOMATION_HEADER_BUTTON),
        shouldRenderReleaseButton: (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).RENDER_BOARD_RELEASE_MENU_BUTON),
        shouldRenderFeedbackCollectorButton: (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).RENDER_BOARD_FEEDBACK_COLLECTOR_BUTTON),
        shouldRenderFullscreenButton: (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).RENDER_BOARD_FULLSCREEN_BUTTON),
        shouldRenderViewSettingsCardDetailsOption: (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).RENDER_VIEW_SETTINGS_CARD_DETAILS_OPTION),
        boardType: (0, $67Z81.getBoardTypeForAnalytics)(state),
        isTabNavigation: isTabNavigation
    };
};
var $d715143425ca28bf$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($d715143425ca28bf$export$c31df4bd766f9c35, {})((0, $3NePp.default));

});
parcelRegister("3llBT", function(module, exports) {

$parcel$export(module.exports, "BoardMenu", () => $539c0d3c46b99f36$export$17445232de9c085a);
$parcel$export(module.exports, "default", () => $539c0d3c46b99f36$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $heNNl = parcelRequire("heNNl");

var $co1wz = parcelRequire("co1wz");

var $2s6Sm = parcelRequire("2s6Sm");

var $kBike = parcelRequire("kBike");

var $iKM9r = parcelRequire("iKM9r");

var $7IeyM = parcelRequire("7IeyM");

var $iW6Ob = parcelRequire("iW6Ob");

var $jJ8Br = parcelRequire("jJ8Br");

var $3jcRv = parcelRequire("3jcRv");
const $539c0d3c46b99f36$var$TARGET_NAME = 'automation-menu-target';
const $539c0d3c46b99f36$var$WrappedMenuButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: $539c0d3c46b99f36$var$TARGET_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jJ8Br.default), {
        ...props,
        ref: ref
    })));
/**
 * TMP only automation menu
 * @deprecated - Use project aware menu always where possible.
 */ const $539c0d3c46b99f36$var$AutomationMenu = (props)=>{
    const { canManageAutomations: canManageAutomations = false, ...popupProps } = props;
    const popup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jcRv.default), {
        ...popupProps,
        Trigger: $539c0d3c46b99f36$var$WrappedMenuButton,
        canManageAutomations: canManageAutomations
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "automation-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kBike.MenuContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iKM9r.SelectedIssuesContainer), null, popup)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: $539c0d3c46b99f36$var$TARGET_NAME,
        variables: {
            projectId: props.projectId,
            projectKey: props.projectKey
        }
    })));
};
const $539c0d3c46b99f36$var$ProjectAwareAutomationMenu = (props)=>{
    const project = (0, $iW6Ob.useProjectService)();
    const { isProjectAdmin: isProjectAdmin } = (0, $7IeyM.usePermissionService)(project && project.projectId);
    if (project) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($539c0d3c46b99f36$var$AutomationMenu, {
        ...props,
        isSimplified: (0, $co1wz.ff)('jsw-replace-automationmenu-with-new-context-aware-menu_rltpk') ? project.isSimplified : false,
        isUIF: props.isUIF ?? false,
        projectType: project.projectType,
        projectId: project.projectId,
        projectKey: project.projectKey,
        canManageAutomations: isProjectAdmin
    });
    return null;
};
const $539c0d3c46b99f36$export$17445232de9c085a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($539c0d3c46b99f36$var$ProjectAwareAutomationMenu, {
        ...props,
        items: (0, $2s6Sm.boardMenuItems)
    });
var $539c0d3c46b99f36$export$2e2bcd8739ae039 = $539c0d3c46b99f36$var$AutomationMenu;

});
parcelRegister("2s6Sm", function(module, exports) {

$parcel$export(module.exports, "boardMenuItems", () => $6ca9e786e4f5c84b$export$d062faac00f93181);

var $dMzAR = parcelRequire("dMzAR");

var $cTemL = parcelRequire("cTemL");

var $cWNOJ = parcelRequire("cWNOJ");

var $aPRJS = parcelRequire("aPRJS");

var $dOzZz = parcelRequire("dOzZz");

var $ktvcB = parcelRequire("ktvcB");

var $koBIe = parcelRequire("koBIe");

var $1GEsl = parcelRequire("1GEsl");
const $6ca9e786e4f5c84b$export$d062faac00f93181 = [
    {
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cWNOJ))),
        title: (0, $koBIe.default).issueTitle,
        description: (0, $koBIe.default).issueDescription,
        filter: (0, $1GEsl.filters).CATEGORY_ISSUE
    },
    {
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dMzAR))),
        title: (0, $koBIe.default).devopsTitle,
        description: (0, $koBIe.default).devopsDescription,
        filter: (0, $1GEsl.filters).CATEGORY_DEVOPS
    },
    {
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aPRJS))),
        title: (0, $koBIe.default).devopsBuildAndDeployTitle,
        description: (0, $koBIe.default).devopsBuildAndDeployDescription,
        filter: (0, $1GEsl.filters).CATEGORY_DEVOPS
    },
    {
        Icon: (0, $ktvcB.WebhookIcon),
        title: (0, $koBIe.default).integrationTitle,
        description: (0, $koBIe.default).integrationDescription,
        filter: (0, $1GEsl.filters).CATEGORY_INTEGRATION
    },
    {
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cTemL))),
        title: (0, $koBIe.default).scheduleTitle,
        description: (0, $koBIe.default).scheduleDescription,
        filter: (0, $1GEsl.filters).CATEGORY_SCHEDULE
    },
    {
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dOzZz))),
        title: (0, $koBIe.default).allTriggersTitle,
        description: (0, $koBIe.default).allTriggersDescription,
        filter: (0, $1GEsl.filters).CATEGORY_ALL
    }
];

});
parcelRegister("cTemL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9625c3edd02eaf26$var$CalendarIcon = (props)=>/*#__PURE__*/ $9625c3edd02eaf26$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $9625c3edd02eaf26$var$_calendar.default
    }));
$9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;

});

parcelRegister("dOzZz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0298730d194eb3bc$var$_react = $0298730d194eb3bc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $0298730d194eb3bc$var$_videoPlay = $0298730d194eb3bc$var$_interopRequireDefault((parcelRequire("b7NAp")));
function $0298730d194eb3bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0298730d194eb3bc$var$VidPlayIcon = (props)=>/*#__PURE__*/ $0298730d194eb3bc$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.595 19.522C7.162 20.364 6 19.702 6 18.04V5.963C6 4.3 7.158 3.635 8.595 4.479l11.083 6.51c.951.559.958 1.46 0 2.023z"/></svg>`
    }, props, {
        newIcon: $0298730d194eb3bc$var$_videoPlay.default
    }));
$0298730d194eb3bc$var$VidPlayIcon.displayName = 'VidPlayIcon';
var $0298730d194eb3bc$var$_default = module.exports.default = $0298730d194eb3bc$var$VidPlayIcon;

});
parcelRegister("b7NAp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8b86a7f6ea930713512b48a6f9b584d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8196cfedfbf38b92$var$_react = $8196cfedfbf38b92$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8196cfedfbf38b92$var$_UNSAFE_baseNew = $8196cfedfbf38b92$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8196cfedfbf38b92$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "VideoPlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for play video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8196cfedfbf38b92$var$VideoPlayIcon = (props)=>/*#__PURE__*/ $8196cfedfbf38b92$var$_react.default.createElement($8196cfedfbf38b92$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.602 2.017 8.902 4.887a1.25 1.25 0 0 1 0 2.192l-8.902 4.887a1.25 1.25 0 0 1-1.852-1.095V3.112a1.25 1.25 0 0 1 1.852-1.095Z"/>`
    }, props));
$8196cfedfbf38b92$var$VideoPlayIcon.displayName = 'VideoPlayIcon';
var $8196cfedfbf38b92$var$_default = module.exports.default = $8196cfedfbf38b92$var$VideoPlayIcon;

});


parcelRegister("ktvcB", function(module, exports) {

$parcel$export(module.exports, "WebhookIcon", () => $5c349b888065cefe$export$3c46f390a1e1dd55);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $5c349b888065cefe$var$glyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        fill: "none",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#a)",
        fill: "#006644"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m7 19c1.1046 0 2-0.8954 2-2s-0.89543-2-2-2-2 0.8954-2 2 0.89543 2 2 2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m10.292 9.4664c0.5541 0.38447 0.9515 1.1146 0.6559 1.7208l-3.0487 6.2512-1.7976-0.8768 3.6792-7.5433c0.15274 0.16787 0.32422 0.31835 0.51122 0.44812zm2.3852-6.3867 1.7976 0.87674-0.418 0.85921c-0.4863-0.45793-1.1254-0.75531-1.8327-0.80745l0.4531-0.9285z",
        clipRule: "evenodd",
        fillRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m12 2c2.4213 0 4.4406 1.7211 4.9013 4.0066 0.1091 0.54134-0.3474 0.99368-0.8997 0.99356-0.5524-1.1e-4 -0.9853-0.46025-1.166-0.98224-0.4068-1.1745-1.5227-2.0179-2.8356-2.0179-1.6569 0-3 1.3432-3 3 0 0.99194 0.48143 1.8714 1.2234 2.4176l-1.0041 1.7385c-1.3384-0.8972-2.2193-2.4238-2.2193-4.1561 0-2.7614 2.2386-5 5-5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m10.403 5.7963c-0.66479 0.88215-0.48855 2.1362 0.3936 2.8009 0.8821 0.66474 2.1361 0.4885 2.8009-0.39365 0.6647-0.88214 0.4885-2.1362-0.3936-2.8009-0.8822-0.66474-2.1362-0.4885-2.8009 0.39364z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m16.036 14.163c-0.6405 0.2111-1.4628 0.0891-1.769-0.5117l-3.1576-6.1969 1.782-0.90798 3.8102 7.478c-0.226 0.021-0.4494 0.0674-0.6656 0.1386zm3.6652 5.7485-1.782 0.908-0.4346-0.8509c0.6583-0.1128 1.2804-0.4442 1.7478-0.9777l0.4688 0.9206z",
        clipRule: "evenodd",
        fillRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m20.97 20.02c-1.4572 1.9338-4.047 2.5107-6.1496 1.503-0.4979-0.2386-0.5843-0.8754-0.2519-1.3163 0.3325-0.441 0.9605-0.51 1.486-0.3402 1.1829 0.3821 2.5281-0.0015 3.3183-1.0501 0.9971-1.3233 0.7327-3.2043-0.5905-4.2014-0.7922-0.5969-1.7843-0.7418-2.667-0.4779l-0.7842-1.8481c1.522-0.5289 3.2714-0.3138 4.6548 0.7287 2.2054 1.6619 2.646 4.7969 0.9841 7.0023z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m12 9c1.1046 0 2-0.89543 2-2s-0.8954-2-2-2-2 0.89543-2 2 0.8954 2 2 2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m18.79 16.121c-0.4929-0.9885-1.6937-1.3903-2.6823-0.8975-0.9885 0.4929-1.3903 1.6938-0.8974 2.6823 0.4928 0.9885 1.6937 1.3903 2.6822 0.8975 0.9885-0.4929 1.3904-1.6938 0.8975-2.6823z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m9.9753 17.429c0.09691-0.6673 0.57301-1.3489 1.2473-1.3548l6.9548-0.0608 0.0174 1.9999-8.3924 0.0732c0.08208-0.2116 0.14022-0.4322 0.17291-0.6575zm-6.7799 0.7152-0.01745-1.9999 0.95543-0.0093c-0.19286 0.6395-0.17382 1.3441 0.09512 2.0004l-1.0331 0.0088z",
        clipRule: "evenodd",
        fillRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m2.5311 19.232c-1.0804-2.167-0.44111-4.7421 1.3x988-6.1742 0.43571-0.3391 1.0442-0.1322 1.2905 0.3619 0.24632 0.4943 0.02783 1.0871-0.3586 1.4817-0.86977 0.8881-1.1267 2.2632-0.54083 3.4382 0.73929 1.4828 2.5406 2.0855 4.0234 1.3462 0.88773-0.4426 1.46-1.2659 1.6177-2.1736l2.0038 0.1229c-0.2058 1.5981-1.1788 3.0676-2.7291 3.8406-2.4713 1.2321-5.4735 0.2276-6.7057-2.2437z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0 0H24V24H0V0Z",
        fill: "#fff"
    }))));
const $5c349b888065cefe$export$3c46f390a1e1dd55 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $5c349b888065cefe$var$glyph,
        ...props
    });

});

parcelRegister("koBIe", function(module, exports) {

$parcel$export(module.exports, "default", () => $52acd386256a9726$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $52acd386256a9726$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueTitle: {
        "id": "automation-menu.common.issue-title",
        "defaultMessage": "Issue"
    },
    issueDescription: {
        "id": "automation-menu.common.issue-description",
        "defaultMessage": "Created, transitioned, updated and more"
    },
    devopsTitle: {
        "id": "automation-menu.common.devops-title",
        "defaultMessage": "Branch, commit or pull requests "
    },
    devopsDescription: {
        "id": "automation-menu.common.devops-description",
        "defaultMessage": "Created, merged, declined"
    },
    devopsBuildAndDeployTitle: {
        "id": "automation-menu.common.devops-build-and-deploy-title",
        "defaultMessage": "Deployment or build"
    },
    devopsBuildAndDeployDescription: {
        "id": "automation-menu.common.devops-build-and-deploy-description",
        "defaultMessage": "Succeeded, failed and more"
    },
    integrationTitle: {
        "id": "automation-menu.common.integration-title",
        "defaultMessage": "Integration"
    },
    integrationDescription: {
        "id": "automation-menu.common.integration-description",
        "defaultMessage": "Trigger rules using incoming webhooks"
    },
    scheduleTitle: {
        "id": "automation-menu.common.schedule-title",
        "defaultMessage": "Schedule"
    },
    scheduleDescription: {
        "id": "automation-menu.common.schedule-description",
        "defaultMessage": "Trigger rules on a regular schedule"
    },
    allTriggersTitle: {
        "id": "automation-menu.common.all-triggers-title",
        "defaultMessage": "View all triggers"
    },
    allTriggersDescription: {
        "id": "automation-menu.common.all-triggers-description",
        "defaultMessage": "Sprints, versions and more"
    }
});

});

parcelRegister("1GEsl", function(module, exports) {

$parcel$export(module.exports, "filters", () => $c8d899017f019b40$export$82462a21aead86ed);
const $c8d899017f019b40$export$82462a21aead86ed = {
    CATEGORY_DEVOPS: 'CATEGORY_DEVOPS',
    CATEGORY_ISSUE: 'CATEGORY_ISSUE',
    CATEGORY_INTEGRATION: 'CATEGORY_INTEGRATION',
    CATEGORY_SCHEDULE: 'CATEGORY_SCHEDULE',
    CATEGORY_ALL: 'CATEGORY_ALL'
};

});


parcelRegister("kBike", function(module, exports) {

$parcel$export(module.exports, "MenuContextContainer", () => $6f10e4a5b599b146$export$316c3c2e4f41b5ad);
$parcel$export(module.exports, "useMenuContext", () => $6f10e4a5b599b146$export$21c7ab35b39f78ec);
$parcel$export(module.exports, "useMenuContextActions", () => $6f10e4a5b599b146$export$f672425f83782b78);
$parcel$export(module.exports, "useCanManageAutomations", () => $6f10e4a5b599b146$export$a073587d6223d86e);
$parcel$export(module.exports, "useProjectAri", () => $6f10e4a5b599b146$export$8688254b761eadc4);
$parcel$export(module.exports, "useBaseAutomationUrl", () => $6f10e4a5b599b146$export$7b0194c88f30ff4);

var $dXq4S = parcelRequire("dXq4S");

var $g5X3G = parcelRequire("g5X3G");

var $7JoAD = parcelRequire("7JoAD");
const $6f10e4a5b599b146$var$initialState = {
    canManageAutomations: false,
    projectAri: (0, $dXq4S.toAriOrDefault)(''),
    projectId: (0, $g5X3G.toProjectId)(''),
    baseAutomationUrl: ''
};
const $6f10e4a5b599b146$var$actions = {
    setMenuContext: (menuContext)=>({ setState: setState })=>setState(menuContext)
};
const $6f10e4a5b599b146$var$Store = (0, $7JoAD.createStore)({
    initialState: $6f10e4a5b599b146$var$initialState,
    actions: $6f10e4a5b599b146$var$actions,
    name: 'automation-menu.menu-context'
});
const $6f10e4a5b599b146$export$316c3c2e4f41b5ad = (0, $7JoAD.createContainer)($6f10e4a5b599b146$var$Store);
const $6f10e4a5b599b146$export$21c7ab35b39f78ec = (0, $7JoAD.createHook)($6f10e4a5b599b146$var$Store);
const $6f10e4a5b599b146$export$f672425f83782b78 = (0, $7JoAD.createHook)($6f10e4a5b599b146$var$Store, {
    selector: null
});
const $6f10e4a5b599b146$var$getCanManageAutomations = (state)=>state.canManageAutomations;
const $6f10e4a5b599b146$export$a073587d6223d86e = (0, $7JoAD.createHook)($6f10e4a5b599b146$var$Store, {
    selector: $6f10e4a5b599b146$var$getCanManageAutomations
});
const $6f10e4a5b599b146$var$getProjectAri = (state)=>state.projectAri;
const $6f10e4a5b599b146$export$8688254b761eadc4 = (0, $7JoAD.createHook)($6f10e4a5b599b146$var$Store, {
    selector: $6f10e4a5b599b146$var$getProjectAri
});
const $6f10e4a5b599b146$var$getBaseAutomationUrl = (state)=>state.baseAutomationUrl;
const $6f10e4a5b599b146$export$7b0194c88f30ff4 = (0, $7JoAD.createHook)($6f10e4a5b599b146$var$Store, {
    selector: $6f10e4a5b599b146$var$getBaseAutomationUrl
});

});

parcelRegister("iKM9r", function(module, exports) {

$parcel$export(module.exports, "SelectedIssuesContainer", () => $ea71b5558f33c193$export$738cdb08d2b14320);
$parcel$export(module.exports, "useSelectedIssues", () => $ea71b5558f33c193$export$a435421a00d3bee);
$parcel$export(module.exports, "useSelectedIssuesSubscription", () => $ea71b5558f33c193$export$4ccb9daade9f8d9e);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $7JoAD = parcelRequire("7JoAD");
const $ea71b5558f33c193$var$initialState = {
    selectedIssuesKeys: [],
    crossProjectSelection: false
};
const $ea71b5558f33c193$var$actions = {
    setSelectionDetails: (state)=>({ setState: setState })=>setState(state)
};
const $ea71b5558f33c193$var$Store = (0, $7JoAD.createStore)({
    initialState: $ea71b5558f33c193$var$initialState,
    actions: $ea71b5558f33c193$var$actions,
    name: 'automation-menu.selected-issues'
});
const $ea71b5558f33c193$export$738cdb08d2b14320 = (0, $7JoAD.createContainer)($ea71b5558f33c193$var$Store);
const $ea71b5558f33c193$var$isCrossProjectScope = (selectedIssueKeys, projectKey)=>selectedIssueKeys.find((issueKey)=>!issueKey.startsWith(`${projectKey}-`)) !== undefined;
const $ea71b5558f33c193$export$a435421a00d3bee = (0, $7JoAD.createHook)($ea71b5558f33c193$var$Store);
const $ea71b5558f33c193$var$useSelectedIssuesSubscriptionClassic = (initialIssuesSelection = [], projectKey)=>{
    const [state, { setSelectionDetails: setSelectionDetails }] = $ea71b5558f33c193$export$a435421a00d3bee();
    (0, $5uXOq.useEffect)(()=>setSelectionDetails({
            selectedIssuesKeys: initialIssuesSelection,
            crossProjectSelection: $ea71b5558f33c193$var$isCrossProjectScope(initialIssuesSelection, projectKey)
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        setSelectionDetails,
        projectKey
    ]);
    const onSelectedIssuesChanged = (0, $5uXOq.useCallback)(// make flow happy
    (event)=>{
        if (event instanceof CustomEvent) setSelectionDetails({
            selectedIssuesKeys: event.detail.selectedIssues,
            crossProjectSelection: $ea71b5558f33c193$var$isCrossProjectScope(event.detail.selectedIssues, projectKey)
        });
    }, [
        setSelectionDetails,
        projectKey
    ]);
    const subscriptionHandle = (0, $5uXOq.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))));
    (0, $5uXOq.useEffect)(()=>{
        if (typeof document !== 'undefined') {
            document.addEventListener('JiraAgile.selectedIssuesChanged', onSelectedIssuesChanged);
            subscriptionHandle.current = ()=>document.removeEventListener('JiraAgile.selectedIssuesChanged', onSelectedIssuesChanged);
        }
        return ()=>{
            subscriptionHandle.current();
            subscriptionHandle.current = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        };
    }, [
        onSelectedIssuesChanged
    ]);
    return state.selectedIssuesKeys;
};
const $ea71b5558f33c193$var$useSelectedIssuesSubscriptionNextGen = (selectedIssueKeys = [], projectKey)=>{
    const [state, { setSelectionDetails: setSelectionDetails }] = $ea71b5558f33c193$export$a435421a00d3bee();
    (0, $5uXOq.useEffect)(()=>setSelectionDetails({
            selectedIssuesKeys: selectedIssueKeys,
            crossProjectSelection: $ea71b5558f33c193$var$isCrossProjectScope(selectedIssueKeys, projectKey)
        }), [
        setSelectionDetails,
        selectedIssueKeys,
        projectKey
    ]);
    return state.selectedIssuesKeys;
};
const $ea71b5558f33c193$export$4ccb9daade9f8d9e = (isSimplified, initialIssuesSelection = [], selectedIssueKeys = [], projectKey)=>isSimplified ? $ea71b5558f33c193$var$useSelectedIssuesSubscriptionNextGen(selectedIssueKeys, projectKey) // eslint-disable-line react-hooks/rules-of-hooks
     : $ea71b5558f33c193$var$useSelectedIssuesSubscriptionClassic(initialIssuesSelection, projectKey); // eslint-disable-line react-hooks/rules-of-hooks

});

parcelRegister("7IeyM", function(module, exports) {

$parcel$export(module.exports, "usePermissionService", () => $615a9fd6df718b89$export$20b1e1fd563e20b6);

var $5uXOq = parcelRequire("5uXOq");

var $7f4tk = parcelRequire("7f4tk");

var $itmJb = parcelRequire("itmJb");
const $615a9fd6df718b89$var$PROJECT_ADMIN_PERMISSION = 'ADMINISTER_PROJECTS';
const $615a9fd6df718b89$var$fetchData = async (projectId)=>{
    const response = await (0, $7f4tk.default)(`/rest/api/2/mypermissions?permissions=${$615a9fd6df718b89$var$PROJECT_ADMIN_PERMISSION}&projectId=${projectId}`);
    if (response && response.permissions && response.permissions[$615a9fd6df718b89$var$PROJECT_ADMIN_PERMISSION]) return Boolean(response.permissions[$615a9fd6df718b89$var$PROJECT_ADMIN_PERMISSION].havePermission);
    return false;
};
const $615a9fd6df718b89$export$20b1e1fd563e20b6 = (projectId)=>{
    const [isProjectAdmin, setIsProjectAdmin] = (0, $5uXOq.useState)(false);
    const isGlobalAdmin = (0, $itmJb.useIsAdmin)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isGlobalAdmin && projectId != null) $615a9fd6df718b89$var$fetchData(projectId).then(setIsProjectAdmin);
    }, [
        isGlobalAdmin,
        projectId
    ]);
    return {
        isProjectAdmin: isProjectAdmin || isGlobalAdmin
    };
};

});

parcelRegister("iW6Ob", function(module, exports) {

$parcel$export(module.exports, "useProjectService", () => $a3aa0fe879fd4421$export$2f2d856d9fc7fad2);

var $4DPZY = parcelRequire("4DPZY");

var $g5X3G = parcelRequire("g5X3G");
const $a3aa0fe879fd4421$export$2f2d856d9fc7fad2 = ()=>{
    const [{ data: projectData }] = (0, $4DPZY.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (projectData && projectData.project) return {
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        projectKey: (0, $g5X3G.toProjectKey)(projectData.project.key),
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        projectId: (0, $g5X3G.toProjectId)(`${projectData.project.id}`),
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        projectType: projectData.project.type,
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        isSimplified: projectData.project.isSimplified
    };
    return null;
};

});

parcelRegister("jJ8Br", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff704efab144026a$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $5LWLA = parcelRequire("5LWLA");

var $4ldhu = parcelRequire("4ldhu");


var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");

var $22OQR = parcelRequire("22OQR");

var $dCm1o = parcelRequire("dCm1o");

var $hrfsZ = parcelRequire("hrfsZ");

var $eBN2x = parcelRequire("eBN2x");
const $ff704efab144026a$var$MenuButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isSelected: isSelected, onClick: onClick }, ref)=>{
    const onClickWithAnalytics = (0, $5uXOq.useCallback)((event, analytics)=>{
        (0, $8zOmE.fireUIAnalytics)(analytics, 'automationMenuButton');
        onClick();
    }, [
        onClick
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $eBN2x.default).menuButtonTooltip),
        position: "top"
    }, (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('common_project_actions_menu') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        ref: ref,
        appearance: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('jira_nav4_eap_drop_2') ? 'default' : 'subtle',
        onClick: onClickWithAnalytics,
        isSelected: isSelected,
        "data-testId": "automation-menu.ui.button.menu-button",
        id: "automation-menu.ui.popup" // @ts-expect-error - externalId does not exist on Button types
        ,
        externalId: "automation-menu.ui.button.menu-button",
        "aria-label": formatMessage((0, $eBN2x.default).menuButtonTooltip),
        "aria-expanded": isSelected,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ldhu))), {
            label: formatMessage((0, $eBN2x.default).automationsMenuButtonIcon),
            color: "currentColor",
            spacing: "spacious"
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ref: ref,
        appearance: "subtle",
        spacing: "none",
        isSelected: isSelected,
        onClick: onClickWithAnalytics,
        "data-testId": "automation-menu.ui.button.menu-button",
        id: "automation-menu.ui.popup" // @ts-expect-error - externalId does not exist on Button types
        ,
        externalId: "automation-menu.ui.button.menu-button",
        "aria-label": formatMessage((0, $eBN2x.default).menuButtonTooltip),
        "aria-expanded": isSelected,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ff704efab144026a$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            size: "medium",
            glyph: (0, $hrfsZ.AutomationGlyph),
            label: formatMessage((0, $eBN2x.default).automationsMenuButtonIcon),
            primaryColor: isSelected ? `var(--ds-icon-selected, ${(0, $829f609a65d26a98$exports).N20})` : undefined,
            secondaryColor: "none"
        }))
    }));
});
var $ff704efab144026a$export$2e2bcd8739ae039 = $ff704efab144026a$var$MenuButton;
const $ff704efab144026a$var$unselectedColor = `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N500})`;
const $ff704efab144026a$var$unselectedHoverColor = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N200})`;
const $ff704efab144026a$var$multiplier = 4; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ff704efab144026a$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_10u62xj": (0, $lD23V.default)($ff704efab144026a$var$unselectedColor),
            "--_1cs4a84": (0, $lD23V.default)($ff704efab144026a$var$unselectedHoverColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _syaz296t _30l31hcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4ldhu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c8adc7f07eb61d61efbf5eae5807c21>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32936cf628dec798$var$_react = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $32936cf628dec798$var$_UNSAFE_baseNew = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $32936cf628dec798$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $32936cf628dec798$var$AutomationIcon = (props)=>/*#__PURE__*/ $32936cf628dec798$var$_react.default.createElement($32936cf628dec798$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6 15.25-.723-.2a.75.75 0 0 0 1.253.73zM13.25 8l.53.53a.75.75 0 0 0-.53-1.28zM10 .75l.723.2A.75.75 0 0 0 9.47.22zM2.75 8l-.53-.53a.75.75 0 0 0 .53 1.28zm3.78 7.78 7.25-7.25-1.06-1.06-7.25 7.25zm6.72-8.53H8v1.5h5.25zm-4.527.95 2-7.25-1.446-.4-2 7.25zM9.47.22 2.22 7.47l1.06 1.06 7.25-7.25zM2.75 8.75H8v-1.5H2.75zm4.527-.95-2 7.25 1.446.4 2-7.25z"/>`
    }, props));
$32936cf628dec798$var$AutomationIcon.displayName = 'AutomationIcon';
var $32936cf628dec798$var$_default = module.exports.default = $32936cf628dec798$var$AutomationIcon;

});

parcelRegister("hrfsZ", function(module, exports) {

$parcel$export(module.exports, "AutomationGlyph", () => $7a6859ebc905c49b$export$3b6023946faff8bc);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");
const $7a6859ebc905c49b$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14 5L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14 5L7 12H17L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));

});

parcelRegister("eBN2x", function(module, exports) {

$parcel$export(module.exports, "default", () => $70fd4abbcff5ac1b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $70fd4abbcff5ac1b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    menuButtonTooltip: {
        "id": "automation-menu.button.menu-button-tooltip",
        "defaultMessage": "Automation"
    },
    automationsMenuButtonIcon: {
        "id": "automation-menu.button.automations-menu-button-icon",
        "defaultMessage": "automations-menu-button-icon"
    }
});

});


parcelRegister("3jcRv", function(module, exports) {

$parcel$export(module.exports, "default", () => $057a86da41029200$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1I7E8 = parcelRequire("1I7E8");

var $3jA9Y = parcelRequire("3jA9Y");

var $4R6GH = parcelRequire("4R6GH");

var $dXq4S = parcelRequire("dXq4S");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $gOS29 = parcelRequire("gOS29");

var $kBike = parcelRequire("kBike");

var $iKM9r = parcelRequire("iKM9r");

var $4a5pt = parcelRequire("4a5pt");
const $057a86da41029200$var$Popup = ({ Trigger: Trigger, projectKey: projectKey, projectId: projectId, projectType: projectType, isSimplified: isSimplified, isUIF: isUIF, initialIssuesSelection: initialIssuesSelection, selectedIssueKeys: selectedIssueKeys, selectedIssueIds: selectedIssueIds, canManageAutomations: canManageAutomations = false })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [, { setMenuContext: setMenuContext }] = (0, $kBike.useMenuContextActions)();
    const { environment: environment, cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        setMenuContext({
            canManageAutomations: canManageAutomations,
            projectAri: (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'project',
                resourceId: projectId
            }),
            projectId: projectId,
            // For the URL, we want the old one for UIF/CMP and the new one for TMP
            baseAutomationUrl: (0, $gOS29.getBaseAutomationUrl)({
                projectKey: projectKey,
                projectType: projectType,
                isSimplified: isSimplified
            })
        }); // Store in a sweet state store to avoid prop drilling.
    }, [
        setMenuContext,
        canManageAutomations,
        cloudId,
        projectId,
        projectKey,
        projectType,
        isSimplified
    ]);
    // If we have a TMP OR CMP/UIF project, we need to add the newer method of subscribing
    // to issue changes (which doesn't include using the legacy bridge)
    (0, $iKM9r.useSelectedIssuesSubscription)(isSimplified || isUIF, initialIssuesSelection, selectedIssueKeys, projectKey);
    const generateAkPopup = (initialised, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error, rules, executingRuleId, executeRule, triggerFetch)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-end",
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4a5pt.default), {
                    initialised: initialised,
                    error: error,
                    rules: rules,
                    executingRuleId: executingRuleId,
                    executeRule: executeRule,
                    triggerFetch: triggerFetch,
                    selectedIssueIds: selectedIssueIds,
                    setClosed: ()=>setIsOpen(false)
                }),
            trigger: ({ ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Trigger, {
                    ...triggerProps,
                    onClick: ()=>{
                        if (!isOpen) {
                            const analyticsEvent = createAnalyticsEvent({
                                actionSubject: 'automationBolt',
                                action: 'opened'
                            });
                            const attributes = (0, $4R6GH.fg)('selected-issue-id-limit') ? {
                                selectedIssueCount: selectedIssueIds?.length
                            } : {};
                            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
                        }
                        setIsOpen(!isOpen);
                    },
                    isSelected: isOpen
                })
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "automationMenu",
        sourceType: (0, $4d5e0871c06cee03$export$d1123261ca8831d2),
        attributes: {
            isSimplified: isSimplified,
            canManageAutomations: canManageAutomations
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
        action: "viewed",
        actionSubject: "button",
        actionSubjectId: "automationMenuButton"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jA9Y.ManualRulesContainer), {
        cloudId: cloudId,
        issueIds: selectedIssueIds ?? [],
        env: environment
    }, ({ triggerFetch: triggerFetch, initialised: initialised, error: error, rules: rules, invokingRuleId: invokingRuleId, invokeRuleOrShowDialog: invokeRuleOrShowDialog })=>generateAkPopup(initialised, error, rules, invokingRuleId, invokeRuleOrShowDialog, triggerFetch)));
};
var $057a86da41029200$export$2e2bcd8739ae039 = $057a86da41029200$var$Popup;

});
parcelRegister("3jA9Y", function(module, exports) {

$parcel$export(module.exports, "ManualRulesContainer", () => $7dbcf6c35b47cce5$export$eb0a81e78d942dba);

var $5uXOq = parcelRequire("5uXOq");

var $deUkU = parcelRequire("deUkU");

var $co1wz = parcelRequire("co1wz");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $k9To8 = parcelRequire("k9To8");
const $7dbcf6c35b47cce5$export$eb0a81e78d942dba = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { env: env, cloudId: cloudId, issueIds: issueIds } = props;
    let automationEnv = env;
    if (env === 'prod') automationEnv = (0, $co1wz.ff)('automation-dev-helper') ? 'pre-prod' : 'prod';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $deUkU.ManualRulesContainer), {
        site: (0, $dXq4S.createAri)({
            resourceOwner: 'jira',
            resourceType: 'site',
            resourceId: cloudId
        }),
        query: {
            objects: issueIds?.map((id)=>(0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'issue',
                    cloudId: cloudId,
                    resourceId: id.toString()
                }))
        },
        env: automationEnv,
        onInputsModalOpened: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'manualRuleModal',
                action: 'opened'
            });
            const attributes = {
                objectType: 'issue'
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
        },
        onRuleInvocationLifecycleStarted: (_, __, userInputs)=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'manualRule',
                action: 'tryInvoke'
            });
            const attributes = {
                objectType: 'issue',
                ruleHasInputs: Boolean(userInputs),
                objectsSelected: issueIds.length
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
        },
        onRuleInvocationSuccess: ()=>showFlag({
                type: 'info',
                title: formatMessage((0, $k9To8.default).successFlag),
                isAutoDismiss: true
            }),
        onRuleInvocationFailure: ()=>showFlag({
                type: 'error',
                title: formatMessage((0, $k9To8.default).failureFlagTitle),
                description: formatMessage((0, $k9To8.default).failureFlagDescription),
                isAutoDismiss: true
            })
    }, props.children);
};

});
parcelRegister("deUkU", function(module, exports) {

$parcel$export(module.exports, "ManualRulesContainer", () => $9495b2e06f8b54ff$export$eb0a81e78d942dba);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $i8Qvm = parcelRequire("i8Qvm");

var $3ozzK = parcelRequire("3ozzK");

var $gSw9T = parcelRequire("gSw9T");
const $9495b2e06f8b54ff$export$96513fc6544cb4e5 = (env, site, query)=>{
    const [initialised, setInitialised] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [rules, setRules] = (0, $5uXOq.useState)([]);
    const transformRules = (ruleResponse)=>{
        const rulesUnsorted = Object.values(ruleResponse);
        return rulesUnsorted.sort((rule1, rule2)=>rule1.name.localeCompare(rule2.name));
    };
    const triggerFetch = async ()=>{
        setInitialised(false);
        try {
            const fetchedRules = await (0, $3ozzK.searchManuallyTriggeredRules)(env, site, query);
            setError(null);
            setRules(transformRules(fetchedRules));
        } catch (e) {
            setError(e);
            setRules([]);
        } finally{
            setInitialised(true);
        }
    };
    return [
        triggerFetch,
        initialised,
        error,
        rules
    ];
};
const $9495b2e06f8b54ff$export$eb0a81e78d942dba = (props)=>{
    (0, $gKZoD.di)((0, $i8Qvm.default), (0, $gSw9T.default), (0, $3ozzK.invokeManuallyTriggeredRule), $9495b2e06f8b54ff$export$96513fc6544cb4e5, (0, $5uXOq.useMemo), (0, $5uXOq.useState));
    const { env: env, site: site, query: query, children: children, onInputsModalOpened: onInputsModalOpened, onInputsModalClosed: onInputsModalClosed, onRuleInvocationLifecycleStarted: onRuleInvocationLifecycleStarted, onRuleInvocationSuccess: onRuleInvocationSuccess, onRuleInvocationFailure: onRuleInvocationFailure, onRuleInvocationLifecycleDone: onRuleInvocationLifecycleDone } = props;
    // Initial data loading state
    const [triggerFetch, initialised, error, rules] = $9495b2e06f8b54ff$export$96513fc6544cb4e5(env, site, query);
    // We store a rule in state here if and only if a rule has user inputs, and thus
    // we need to preserve state while the input dialog is open.
    const [selectedRule, setSelectedRule] = (0, $5uXOq.useState)(null);
    const clearSelectedRule = ()=>{
        setSelectedRule(null);
    };
    // Value set when a rule is invoking, either from the dialog or without dialog
    const [invokingRuleId, setInvokingRuleId] = (0, $5uXOq.useState)(null);
    // Memoized projection of rules by id
    const rulesById = (0, $5uXOq.useMemo)(()=>rules.reduce((acc, rule)=>({
                // eslint-disable-next-line
                ...acc,
                [rule.id]: rule
            }), {}), [
        rules
    ]);
    const getRule = (id)=>rulesById[id];
    const ruleHasInputs = (rule)=>rule?.userInputPrompts?.length > 0;
    const getFailedObjects = (response)=>Object.keys(response).filter((object)=>response[object] !== 'SUCCESS');
    const getSuccessfulObjects = (response)=>Object.keys(response).filter((object)=>response[object] === 'SUCCESS');
    const handleInvocationFailure = (ruleId, successfulObjects, failedObjects)=>{
        if (onRuleInvocationFailure) onRuleInvocationFailure(ruleId, successfulObjects, failedObjects);
    };
    const invokeRule = async (ruleId, objects, userInputs)=>{
        const rule = getRule(ruleId);
        if (rule) {
            setInvokingRuleId(ruleId);
            try {
                if (onRuleInvocationLifecycleStarted) onRuleInvocationLifecycleStarted(ruleId, objects, userInputs);
                const response = await (0, $3ozzK.invokeManuallyTriggeredRule)(env, site, ruleId, objects, userInputs);
                const failedObjects = getFailedObjects(response);
                setInvokingRuleId(null);
                if (failedObjects.length === 0) {
                    if (onRuleInvocationSuccess) onRuleInvocationSuccess(ruleId, objects);
                } else {
                    const successfulObjects = getSuccessfulObjects(response);
                    handleInvocationFailure(ruleId, successfulObjects, failedObjects);
                }
            } catch (e) {
                handleInvocationFailure(ruleId, [], objects);
                setInvokingRuleId(null);
            }
        } else handleInvocationFailure(ruleId, [], objects);
        clearSelectedRule();
        if (onRuleInvocationLifecycleDone) onRuleInvocationLifecycleDone(ruleId, objects);
    };
    const invokeRuleOrShowDialog = (ruleId, objects)=>{
        const rule = getRule(ruleId);
        if (!rule) return handleInvocationFailure(ruleId, [], objects);
        if (ruleHasInputs(rule)) setSelectedRule({
            rule: rule,
            objects: objects
        });
        else invokeRule(ruleId, objects);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children({
        triggerFetch: triggerFetch,
        initialised: initialised,
        error: error,
        rules: rules,
        invokingRuleId: invokingRuleId,
        invokeRuleOrShowDialog: invokeRuleOrShowDialog
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, selectedRule && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gSw9T.default), {
        onInputsModalOpened: onInputsModalOpened,
        onInputsModalClosed: onInputsModalClosed,
        clearSelectedRule: clearSelectedRule,
        selectedRule: selectedRule,
        invokeRule: invokeRule
    })));
};

});
parcelRegister("3ozzK", function(module, exports) {

$parcel$export(module.exports, "searchManuallyTriggeredRules", () => $60d395c05d97bad7$export$11e317ae81dd4223);
$parcel$export(module.exports, "invokeManuallyTriggeredRule", () => $60d395c05d97bad7$export$9a0eb4136c6b46c);

var $8lImo = parcelRequire("8lImo");
const $60d395c05d97bad7$export$11e317ae81dd4223 = async (env, site, query)=>{
    const url = await (0, $8lImo.getSearchUrl)(env, site);
    // TODO this will in the new API be a GET request instead, with the above getSearchUrl method
    // constructing a URL with the appropriate query parameters. For now, instead, we pass the
    // destructured query through as a POST body.
    const response = await (0, $8lImo.performPostRequest)(url, {
        body: JSON.stringify(query)
    });
    return response.reduce((acc, { id: id, name: name, ruleScope: ruleScope, userInputs: userInputs })=>({
            // eslint-disable-next-line
            ...acc,
            [id]: {
                id: id,
                name: name,
                ruleScope: ruleScope,
                userInputPrompts: userInputs
            }
        }), {});
};
const $60d395c05d97bad7$export$9a0eb4136c6b46c = async (env, site, ruleId, objects, userInputs)=>{
    const url = await (0, $8lImo.getInvocationUrl)(env, site, ruleId);
    const bodyRaw = {
        objects: objects
    };
    if (userInputs) bodyRaw.userInputs = userInputs;
    return (0, $8lImo.performPostRequest)(url, {
        body: JSON.stringify(bodyRaw)
    });
};

});
parcelRegister("8lImo", function(module, exports) {

$parcel$export(module.exports, "getSearchUrl", () => $1ea2f24134ab0fcb$export$7d4675b206f57488);
$parcel$export(module.exports, "getInvocationUrl", () => $1ea2f24134ab0fcb$export$e62dcf5e32cec4bf);
$parcel$export(module.exports, "performPostRequest", () => $1ea2f24134ab0fcb$export$692a4d9808143175);

var $jbrzS = parcelRequire("jbrzS");

var $g3zK9 = parcelRequire("g3zK9");
const $1ea2f24134ab0fcb$export$1cb1c6bd5a8f1613 = (site)=>{
    let cloudId;
    let resourceOwner;
    let resourceType;
    try {
        const ari = (0, $jbrzS.ResourceIdentifier).parse(site);
        cloudId = ari.cloudId;
        resourceOwner = ari.resourceOwner;
        resourceType = ari.resourceType;
        // Keep backwards compatibility for platform site ARIs
        if (resourceOwner === 'platform') resourceOwner = 'jira';
    } catch (error) {
        throw new Error('Attempted to parse malformed ARI: ' + site);
    }
    if (resourceType !== 'site' || cloudId === undefined) throw new Error('Not a site ARI: ' + site);
    return {
        product: resourceOwner,
        cloudId: cloudId
    };
};
const $1ea2f24134ab0fcb$export$7d4675b206f57488 = async (env, site)=>{
    const { product: product, cloudId: cloudId } = $1ea2f24134ab0fcb$export$1cb1c6bd5a8f1613(site);
    const automationStack = await (0, $g3zK9.getAutomationStack)(env, cloudId);
    // TODO in the unified API, GET requests as according to Atlassian API standards will destructure the whole query into
    // query parameters as part of the URL. For now, this is considered a POST request instead and thus the query is used
    // later on as the request body.
    return `/gateway/api/automation/internal-api/${product}/${cloudId}/${automationStack}/rest/v1/rules/manual/search`;
};
const $1ea2f24134ab0fcb$export$e62dcf5e32cec4bf = async (env, site, ruleId)=>{
    const { product: product, cloudId: cloudId } = $1ea2f24134ab0fcb$export$1cb1c6bd5a8f1613(site);
    const automationStack = await (0, $g3zK9.getAutomationStack)(env, cloudId);
    return `/gateway/api/automation/internal-api/${product}/${cloudId}/${automationStack}/rest/v1/rules/manual/invocation/${ruleId}`;
};
const $1ea2f24134ab0fcb$var$DEFAULT_HEADER = {
    'Content-Type': 'application/json'
};
const $1ea2f24134ab0fcb$var$_performRequest = async (url, method, options = {
    headers: $1ea2f24134ab0fcb$var$DEFAULT_HEADER
})=>{
    const response = await fetch(url, {
        ...options,
        method: method
    });
    return response.json();
};
const $1ea2f24134ab0fcb$export$4a53ae1be8ec80c7 = async (url, options)=>{
    return $1ea2f24134ab0fcb$var$_performRequest(url, 'GET', options);
};
const $1ea2f24134ab0fcb$export$692a4d9808143175 = async (url, options)=>{
    return $1ea2f24134ab0fcb$var$_performRequest(url, 'POST', options);
};
const $1ea2f24134ab0fcb$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};

});
parcelRegister("jbrzS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFsf = parcelRequire("3VFsf");

var $aRXoY = parcelRequire("aRXoY");

$3VFsf.__exportStar((parcelRequire("8T6Ee")), module.exports);
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ class $df746fbe0ba5443e$var$InvalidAriError extends Error {
    /**
     * Construct an InvalidAriError given an error message
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {string|undefined} description - The error message
     */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $df746fbe0ba5443e$var$InvalidAriError.prototype);
    }
    /**
     * Construct an InvalidAriError given some constraint violations
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
     */ static withConstraintViolations(ariString, violations) {
        return new $df746fbe0ba5443e$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
}
module.exports.InvalidAriError = $df746fbe0ba5443e$var$InvalidAriError;
function $df746fbe0ba5443e$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $df746fbe0ba5443e$var$basicCharConstraint = $aRXoY.pattern(/^[a-z][a-z.-]*$/);
/**
 * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
 * It's a violation of the spec, but we still need to support that.
 * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
 */ const $df746fbe0ba5443e$var$resourceTypeCharConstraints = $aRXoY.pattern(/^[a-z][a-z.-]*$/i);
const $df746fbe0ba5443e$var$resourceOwnerConstraints = [
    $aRXoY.lengthBetween(3, 255),
    $df746fbe0ba5443e$var$basicCharConstraint
];
const $df746fbe0ba5443e$var$resourceTypeConstraints = [
    $aRXoY.lengthBetween(3, 255),
    $df746fbe0ba5443e$var$resourceTypeCharConstraints
];
const $df746fbe0ba5443e$var$cloudIdConstraints = [
    $aRXoY.lengthBetween(3, 255)
];
const $df746fbe0ba5443e$var$siteResourceType = 'site';
const $df746fbe0ba5443e$var$resourceIdChars = /[\w-._~:@#]/.source;
const $df746fbe0ba5443e$var$resourceIdConstraints = [
    $aRXoY.pattern(new RegExp(`^${$df746fbe0ba5443e$var$resourceIdChars}+(/${$df746fbe0ba5443e$var$resourceIdChars}*)*(;v=${$df746fbe0ba5443e$var$resourceIdChars}*)*$`))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $df746fbe0ba5443e$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $df746fbe0ba5443e$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $df746fbe0ba5443e$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $df746fbe0ba5443e$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    /**
     * Create a new Ari
     *
     * Only the resourceOwner is a required field, any other field can be omitted.
     * Older format types are converted on creation
     *
     * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
     * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
     * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
     * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
     *
     * @throws {InvalidAriError} if the provided segments fail to pass validation
     */ constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $df746fbe0ba5443e$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    /**
    * Parse a string as an Ari
    *
    * @param {string} ariString - the string to parse
    * @returns {Ari} the parsed ari
    * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
    */ static parse(ariString) {
        if (!ariString) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        const match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        return new $df746fbe0ba5443e$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $df746fbe0ba5443e$var$parse(decodeURIComponent(encodedAriString));
    }
    /**
     * Converts this Ari to a string.
     */ toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $df746fbe0ba5443e$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $df746fbe0ba5443e$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    /**
     * Converts this object to its json representation
     */ toJSON() {
        return this.toString();
    }
    /**
     * Checks if this context is the same as another context
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
     */ equals(other) {
        return other instanceof $df746fbe0ba5443e$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    /**
     * This method checks if the current context contains the other context.
     *
     * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
     * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
     *
     * @param {Ari} other
     * @returns {boolean}
     */ contains(other) {
        return this.matches(new $df746fbe0ba5443e$var$ResourceIdentifier(other));
    }
    /**
     * Checks if this context is the same as or contains the provided context.
     *
     * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
     *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
     *
     * e.g.
     * ```
     * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
     * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
     */ matches(other) {
        return $df746fbe0ba5443e$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $df746fbe0ba5443e$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $df746fbe0ba5443e$var$siteResourceType && !!other.resourceType || $df746fbe0ba5443e$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $df746fbe0ba5443e$var$siteResourceType && !!other.resourceType || $df746fbe0ba5443e$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $df746fbe0ba5443e$var$siteResourceType && !cloudId) return new $aRXoY.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            $aRXoY.validateField(this, 'resourceOwner', $df746fbe0ba5443e$var$resourceOwnerConstraints),
            $aRXoY.validateField(this, 'resourceType', $df746fbe0ba5443e$var$resourceTypeConstraints),
            $aRXoY.validateField(this, 'resourceId', $df746fbe0ba5443e$var$resourceIdConstraints),
            $aRXoY.validateField(this, 'cloudId', $df746fbe0ba5443e$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $df746fbe0ba5443e$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $df746fbe0ba5443e$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
}
module.exports.ResourceIdentifier = $df746fbe0ba5443e$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $df746fbe0ba5443e$var$parse(ariString) {
    return $df746fbe0ba5443e$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $df746fbe0ba5443e$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $df746fbe0ba5443e$var$parseEncoded(encodedAriString) {
    return $df746fbe0ba5443e$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $df746fbe0ba5443e$var$parseEncoded;

});
parcelRegister("aRXoY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aB0SS = parcelRequire("aB0SS");
class $7e9cee950eba220a$var$LengthConstraint {
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
}
module.exports.LengthConstraint = $7e9cee950eba220a$var$LengthConstraint;
class $7e9cee950eba220a$var$RegexConstraint {
    constructor(regex){
        this.regex = regex;
    }
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
}
module.exports.RegexConstraint = $7e9cee950eba220a$var$RegexConstraint;
class $7e9cee950eba220a$var$GeneralValidationError {
    constructor(error){
        this.error = error;
    }
    toString() {
        return this.error;
    }
}
module.exports.GeneralValidationError = $7e9cee950eba220a$var$GeneralValidationError;
class $7e9cee950eba220a$var$ConstraintViolation {
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
}
module.exports.ConstraintViolation = $7e9cee950eba220a$var$ConstraintViolation;
function $7e9cee950eba220a$var$lengthBetween(min, max) {
    return new $7e9cee950eba220a$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $7e9cee950eba220a$var$lengthBetween;
function $7e9cee950eba220a$var$pattern(regex) {
    return new $7e9cee950eba220a$var$RegexConstraint(regex);
}
module.exports.pattern = $7e9cee950eba220a$var$pattern;
function $7e9cee950eba220a$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($aB0SS.isDefined);
    return violatedConstraints.length > 0 ? new $7e9cee950eba220a$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $7e9cee950eba220a$var$validateField;

});
parcelRegister("aB0SS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValueAtKey = module.exports.hasPresentKey = module.exports.isFilled = module.exports.isDefined = module.exports.isPresent = void 0;
function $7b6e0ba147b061df$var$isPresent(t) {
    return t !== undefined && t !== null;
}
module.exports.isPresent = $7b6e0ba147b061df$var$isPresent;
function $7b6e0ba147b061df$var$isDefined(t) {
    return t !== undefined;
}
module.exports.isDefined = $7b6e0ba147b061df$var$isDefined;
function $7b6e0ba147b061df$var$isFilled(t) {
    return t !== null;
}
module.exports.isFilled = $7b6e0ba147b061df$var$isFilled;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a defined non-null value under the key `k`.
 *
 * @example
 * ```ts
 * const filesWithUrl = files.filter(file => file.url);
 * files[0].url // In this case, TS might still treat this as undefined/null
 *
 * const filesWithUrl = files.filter(hasPresentKey("url"));
 * files[0].url // TS will know that this is present
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $7b6e0ba147b061df$var$hasPresentKey(k) {
    return function(a) {
        return a[k] !== undefined && a[k] !== null;
    };
}
module.exports.hasPresentKey = $7b6e0ba147b061df$var$hasPresentKey;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a specific value V under a key `k`.
 *
 * @example
 * ```ts
 * type File = { type: "image", imageUrl: string } | { type: "pdf", pdfUrl: string };
 * const files: File[] = [];
 *
 * const imageFiles = files.filter(file => file.type === "image");
 * files[0].type // In this case, TS will still treat it  as `"image" | "pdf"`
 *
 * const filesWithUrl = files.filter(hasValueKey("type", "image" as const));
 * files[0].type // TS will now know that this is "image"
 * files[0].imageUrl // TS will know this is present, because already it excluded the other union members.
 *
 * Note: the cast `as const` is necessary, otherwise TS will only know that type is a string.
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $7b6e0ba147b061df$var$hasValueAtKey(k, v) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(a) {
        return a[k] === v;
    };
}
module.exports.hasValueAtKey = $7b6e0ba147b061df$var$hasValueAtKey;

});


parcelRegister("8T6Ee", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kQInL = parcelRequire("kQInL");
var $67889de6c03493da$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($67889de6c03493da$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
class $67889de6c03493da$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $67889de6c03493da$var$AppFamilyAriError;
class $67889de6c03493da$var$NotAppFamilyAriError extends $67889de6c03493da$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $67889de6c03493da$var$NotAppFamilyAriError;
class $67889de6c03493da$var$NotExpectedAppFamilyAriTypeError extends $67889de6c03493da$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $67889de6c03493da$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $67889de6c03493da$var$parseAppAri(ari) {
    return $kQInL.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $67889de6c03493da$var$parseAppAri;
function $67889de6c03493da$var$createAppAri(json) {
    return new $kQInL.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $67889de6c03493da$var$createAppAri;

});
parcelRegister("kQInL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8T6Ee = parcelRequire("8T6Ee");

var $jbrzS = parcelRequire("jbrzS");

var $aRXoY = parcelRequire("aRXoY");
const $f2db175f2d527230$var$versionPrefix = ';v=';
const $f2db175f2d527230$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $f2db175f2d527230$var$uuidConstraints = [
    $aRXoY.pattern(new RegExp(`^${$f2db175f2d527230$var$uuidRegExpString}$`, 'i'))
];
const $f2db175f2d527230$var$extensionGroupIdConstraints = [
    $aRXoY.pattern(new RegExp(`^(${$f2db175f2d527230$var$uuidRegExpString}|static)$`, 'i'))
];
class $f2db175f2d527230$var$AppFamilyAriImpl {
    constructor(json){
        this.json = json;
        this.validate();
    }
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $8T6Ee.AppFamilyAri.resourceOwner) throw new $8T6Ee.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$8T6Ee.AppFamilyAri.resourceOwner}`);
        if (!resourceType || $8T6Ee.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $8T6Ee.NotAppFamilyAriError(ari, `resourceType must be one of ${$8T6Ee.AppFamilyAri.appFamilyResourceTypes}`);
        if (!resourceId) throw new $8T6Ee.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($f2db175f2d527230$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($f2db175f2d527230$var$versionPrefix) > versionIndex) throw new $8T6Ee.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($f2db175f2d527230$var$versionPrefix);
        const segments = mainResourceId.split('/').map($f2db175f2d527230$var$stripToUndefined);
        if (segments.length > 4) throw new $8T6Ee.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        if (!appId) throw new $8T6Ee.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $8T6Ee.AppFamilyAri.extensionGroupResourceType || resourceType === $8T6Ee.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $8T6Ee.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$8T6Ee.AppFamilyAri.extensionResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$8T6Ee.AppFamilyAri.extensionGroupResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$8T6Ee.AppFamilyAri.environmentResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$8T6Ee.AppFamilyAri.environmentResourceType}`);
        return new $f2db175f2d527230$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $8T6Ee.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            $aRXoY.validateField(this, 'environmentId', $f2db175f2d527230$var$uuidConstraints),
            $aRXoY.validateField(this, 'appId', $f2db175f2d527230$var$uuidConstraints),
            $aRXoY.validateField(this, 'extensionGroupId', $f2db175f2d527230$var$extensionGroupIdConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $jbrzS.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $8T6Ee.AppFamilyAri.resourceOwner;
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$f2db175f2d527230$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
}
module.exports.AppFamilyAriImpl = $f2db175f2d527230$var$AppFamilyAriImpl;
function $f2db175f2d527230$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});



parcelRegister("g3zK9", function(module, exports) {

$parcel$export(module.exports, "getAutomationStack", () => $fad0c3bb22e40c28$export$6123178d3f5fb24d);
const $fad0c3bb22e40c28$var$AUTOMATION_LOCAL_STORAGE_PREFIX = 'automationPlatform';
const $fad0c3bb22e40c28$var$AUTOMATION_LOCAL_STORAGE_STACK = 'automationStack';
const $fad0c3bb22e40c28$var$AUTOMATION_DEV_STACK_URL = 'https://localhost:8082/devStack.json';
const $fad0c3bb22e40c28$var$getAutomationProdStackUrl = (cloudId)=>`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`;
const $fad0c3bb22e40c28$var$getLatestPreProdStack = async (cloudId)=>{
    try {
        const response = await fetch($fad0c3bb22e40c28$var$getAutomationProdStackUrl(cloudId));
        const stacksResponse = await response.json();
        const preProdStacks = stacksResponse.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        const [latestPreProdStack = null] = preProdStacks;
        return latestPreProdStack;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch pre-prod stack from ${$fad0c3bb22e40c28$var$getAutomationProdStackUrl(cloudId)} with error: ${e}`);
        return null;
    }
};
const $fad0c3bb22e40c28$var$_getAutomationKeyFromLocalStorage = (key)=>{
    return window.localStorage.getItem(`${$fad0c3bb22e40c28$var$AUTOMATION_LOCAL_STORAGE_PREFIX}:${key}`);
};
const $fad0c3bb22e40c28$var$getAutomationDevStackFromLocalServer = async ()=>{
    try {
        const devStackResponse = await fetch($fad0c3bb22e40c28$var$AUTOMATION_DEV_STACK_URL);
        const devStack = await devStackResponse.json();
        return devStack.name;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch dev stack from ${$fad0c3bb22e40c28$var$AUTOMATION_DEV_STACK_URL} with error: ${e}`);
        return null;
    }
};
const $fad0c3bb22e40c28$export$48cdb3ba720a47f6 = ()=>$fad0c3bb22e40c28$var$_getAutomationKeyFromLocalStorage($fad0c3bb22e40c28$var$AUTOMATION_LOCAL_STORAGE_STACK);
const $fad0c3bb22e40c28$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') return 'pro';
    if (env === 'pre-prod') {
        const stack = await $fad0c3bb22e40c28$var$getLatestPreProdStack(cloudId);
        return stack ?? 'pro';
    }
    // We fetch the dev stack name from local server (barrel webpack dev server) if it's available.
    // However, this requires that devWatch is running locally.
    // To use manual triggers without running devWatch, set the local storage value to your stack name e.g. devltan3. The full key is: automationPlatform:automationStack
    const stackOverride = await $fad0c3bb22e40c28$var$getAutomationDevStackFromLocalServer() || $fad0c3bb22e40c28$export$48cdb3ba720a47f6();
    return stackOverride || 'staging';
};

});



parcelRegister("gSw9T", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d4c6f1389454e60$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $eCeGD = parcelRequire("eCeGD");

var $efXp3 = parcelRequire("efXp3");
var $qfj8c = parcelRequire("qfj8c");
var $3lQ26 = parcelRequire("3lQ26");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $cFwyy = parcelRequire("cFwyy");

var $1vBpb = parcelRequire("1vBpb");

var $dZuta = parcelRequire("dZuta");

var $6WPAN = parcelRequire("6WPAN");

var $7mBJV = parcelRequire("7mBJV");

var $g9On4 = parcelRequire("g9On4");

var $bDNlV = parcelRequire("bDNlV");
const $2d4c6f1389454e60$var$UserInputForm = (props)=>{
    (0, $gKZoD.di)((0, $dZuta.default), (0, $eCeGD.default), (0, $qfj8c.ErrorMessage), (0, $efXp3.default), (0, $3lQ26.default), (0, $1R1Ge.default), (0, $7QSqG.default), (0, $juxqI.default), (0, $jgVsb.default), (0, $gofOI.default), (0, $6WPAN.default), (0, $g9On4.default), (0, $bDNlV.default));
    const { selectedRule: selectedRule, clearSelectedRule: clearSelectedRule, invokeRule: invokeRule, onInputsModalOpened: onInputsModalOpened, onInputsModalClosed: onInputsModalClosed } = props;
    const { rule: rule, objects: objects } = selectedRule;
    const { userInputPrompts: userInputPrompts } = rule;
    const getTypeOfInput = (key, prompts)=>prompts.find(({ variableName: variableName })=>variableName === key)?.inputType;
    const generateInputValue = (inputType, data)=>{
        switch(inputType){
            case (0, $1vBpb.UserInputType).DROPDOWN:
                return {
                    inputType: inputType,
                    value: data ? data.value : ''
                };
            case (0, $1vBpb.UserInputType).NUMBER:
                return {
                    inputType: inputType,
                    value: Number(data)
                };
            default:
                return {
                    inputType: inputType,
                    value: data
                };
        }
    };
    const handleSubmit = (data)=>{
        const output = Object.entries(data).reduce((acc, [key, value])=>{
            const inputType = getTypeOfInput(key, userInputPrompts);
            if (!inputType) return acc;
            acc[key] = generateInputValue(inputType, value);
            return acc;
        }, {});
        return invokeRule(rule.id, objects, output);
    };
    const handleOpen = ()=>{
        if (onInputsModalOpened) onInputsModalOpened();
    };
    const handleClose = ()=>{
        clearSelectedRule();
        if (onInputsModalClosed) onInputsModalClosed();
    };
    const generateUserInputForm = (inputPrompt)=>{
        switch(inputPrompt.inputType){
            case (0, $1vBpb.UserInputType).TEXT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bDNlV.default), {
                    key: inputPrompt.variableName,
                    userInputPrompt: inputPrompt
                });
            case (0, $1vBpb.UserInputType).NUMBER:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6WPAN.default), {
                    key: inputPrompt.variableName,
                    userInputPrompt: inputPrompt
                });
            case (0, $1vBpb.UserInputType).DROPDOWN:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g9On4.default), {
                    key: inputPrompt.variableName,
                    userInputPrompt: inputPrompt
                });
            case (0, $1vBpb.UserInputType).BOOLEAN:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZuta.default), {
                    key: inputPrompt.variableName,
                    userInputPrompt: inputPrompt
                });
            case (0, $1vBpb.UserInputType).PARAGRAPH:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7mBJV.default), {
                    key: inputPrompt.variableName,
                    userInputPrompt: inputPrompt
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, (0, $cFwyy.default).errorInputTypeIsNotSupported.defaultMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        "data-testid": "automation-platform.ui.manual-rules-container.manual-triggers-form.modal",
        onClose: handleClose,
        onOpenComplete: handleOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        onSubmit: handleSubmit
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, rule.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, (0, $cFwyy.default).inputRequiredForAction.defaultMessage, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3lQ26.default), null, userInputPrompts.map(generateUserInputForm))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            appearance: "subtle",
            onClick: handleClose,
            isDisabled: submitting
        }, (0, $cFwyy.default).cancelButtonTitle.defaultMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            appearance: "primary",
            type: "submit",
            isLoading: submitting,
            autoFocus: true
        }, (0, $cFwyy.default).continueButtonTitle.defaultMessage)))));
};
var $2d4c6f1389454e60$export$2e2bcd8739ae039 = $2d4c6f1389454e60$var$UserInputForm;

});
parcelRegister("3lQ26", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e71eeb72c100e3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $1dJ6S = parcelRequire("1dJ6S");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $b3e71eeb72c100e3$var$formSectionDescriptionStyles = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.100'
});
const $b3e71eeb72c100e3$var$formSectionWrapperStyles = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.300'
});
const $b3e71eeb72c100e3$var$FormSectionWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        xcss: $b3e71eeb72c100e3$var$formSectionWrapperStyles
    }, children);
};
const $b3e71eeb72c100e3$var$FormSectionDescription = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        xcss: $b3e71eeb72c100e3$var$formSectionDescriptionStyles
    }, children);
};
/**
 * __Form section__.
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $b3e71eeb72c100e3$var$FormSection = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($b3e71eeb72c100e3$var$FormSectionWrapper, null, title && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1dJ6S.default), {
        size: "medium"
    }, title), description && /*#__PURE__*/ (0, $f8Sb3.jsx)($b3e71eeb72c100e3$var$FormSectionDescription, null, description), children);
};
var $b3e71eeb72c100e3$export$2e2bcd8739ae039 = $b3e71eeb72c100e3$var$FormSection;

});

parcelRegister("cFwyy", function(module, exports) {

$parcel$export(module.exports, "default", () => $455d55ebd61a4abd$export$2e2bcd8739ae039);
const $455d55ebd61a4abd$var$messages = {
    successFlag: {
        id: 'automation-platform.common.success-flag',
        defaultMessage: 'Your automation is in progress',
        description: 'Text for a success flag when an automation rule has been triggered'
    },
    failureFlagTitle: {
        id: 'automation-platform.common.failure-flag-title',
        defaultMessage: 'Oops we ran into a problem',
        description: 'Title for an error flag when an automation rule failed to be triggered'
    },
    failureFlagDescription: {
        id: 'automation-platform.common.failure-flag-description',
        defaultMessage: "There was a problem and we couldn't run the automation '{0}'",
        description: 'Description for an error flag when an automation rule failed to be triggered'
    },
    partialFailureFlagDescription: {
        id: 'automation-platform.common.partial-failure-flag-description',
        defaultMessage: "Couldn't run the automation against issues {0}, please ensure you have permission to view these issues",
        description: 'Description for an error flag when some issues failed to invoke because user does not have view permission'
    },
    errorInputMustNotBeEmpty: {
        id: 'automation-platform.common.error-input-must-not-be-empty',
        defaultMessage: 'Input must not be empty',
        description: 'The error message to show the value of a required field is empty'
    },
    errorInputCharacterLimitReached: {
        id: 'automation-platform.common.error-input-character-limit-reached',
        defaultMessage: 'Provided value exceeds the character limit for the field.',
        description: 'The error message to show that the character limit has been reached for the field'
    },
    inputRequiredForAction: {
        id: 'automation-platform.common.input-required-for-action',
        defaultMessage: 'Your input is required to complete this action',
        description: 'The title of the modal for user inputs'
    },
    errorInputTypeIsNotSupported: {
        id: 'automation-platform.common.error-input-type-is-not-supported',
        defaultMessage: 'Input type not supported yet',
        description: 'The error message to show when the type of user input is not recognised'
    },
    errorValueIsNotValidNumber: {
        id: 'automation-platform.common.error-value-is-not-valid-number',
        defaultMessage: 'The value is not a valid number',
        description: 'The error message for when the type of user input is number but the value is not a valid number'
    },
    cancelButtonTitle: {
        id: 'automation-platform.common.cancel-button-title',
        defaultMessage: 'Cancel',
        description: 'The cancel button title'
    },
    continueButtonTitle: {
        id: 'automation-platform.common.continue-button-title',
        defaultMessage: 'Continue',
        description: 'The continue button title'
    }
};
var $455d55ebd61a4abd$export$2e2bcd8739ae039 = $455d55ebd61a4abd$var$messages;

});

parcelRegister("1vBpb", function(module, exports) {

$parcel$export(module.exports, "UserInputType", () => $7ba154a8ce2ccf9e$export$955ccc93b55d5904);
var $7ba154a8ce2ccf9e$export$955ccc93b55d5904;
(function(UserInputType) {
    UserInputType["NUMBER"] = "NUMBER";
    UserInputType["TEXT"] = "TEXT";
    UserInputType["BOOLEAN"] = "BOOLEAN";
    UserInputType["DROPDOWN"] = "DROPDOWN";
    UserInputType["PARAGRAPH"] = "PARAGRAPH";
})($7ba154a8ce2ccf9e$export$955ccc93b55d5904 || ($7ba154a8ce2ccf9e$export$955ccc93b55d5904 = {}));
const $7ba154a8ce2ccf9e$export$4b79f735ed858abe = 'business';
const $7ba154a8ce2ccf9e$export$417275bac62d38d2 = 'software';
const $7ba154a8ce2ccf9e$export$9c9c9eaf8c092006 = 'service_desk';
const $7ba154a8ce2ccf9e$export$e9fe9a39cc7f5103 = 'product_discovery';

});

parcelRegister("dZuta", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae94375b49c6df33$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $kkJfY = parcelRequire("kkJfY");

var $hp1g9 = parcelRequire("hp1g9");
const $ae94375b49c6df33$var$BooleanInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $gKZoD.di)((0, $kkJfY.default), (0, $hp1g9.default));
    const { variableName: variableName, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hp1g9.default), {
        name: variableName,
        defaultIsChecked: defaultValue || false
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
            ...fieldProps,
            label: displayName
        }));
};
var $ae94375b49c6df33$export$2e2bcd8739ae039 = $ae94375b49c6df33$var$BooleanInputPrompt;

});
parcelRegister("kkJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3106eb14f9b0a593$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");


var $kag1C = parcelRequire("kag1C");
var $7xteU = parcelRequire("7xteU");
var $hsLv2 = parcelRequire("hsLv2");
var $e62YQ = parcelRequire("e62YQ");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $3106eb14f9b0a593$var$checkboxStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:disabled:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $3106eb14f9b0a593$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $5JjdN.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7xteU.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $3106eb14f9b0a593$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kag1C.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hsLv2.default), null, label, isRequired && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e62YQ.default), null)));
}));
$3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;

});
parcelRegister("kag1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0746a27410bc168$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dV6Te = parcelRequire("dV6Te");
function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $f8Sb3.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $a0746a27410bc168$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dV6Te.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;

});

parcelRegister("7xteU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b368d644c230660$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

const $7b368d644c230660$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $7b368d644c230660$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $7b368d644c230660$var$disabledStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
    cursor: 'not-allowed'
});
const $7b368d644c230660$var$labelStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
    '--local-border-active': `var(--ds-border, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
    '--local-tick-rest': 'transparent'
});
function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $7b368d644c230660$var$baseStyles,
            label && $7b368d644c230660$var$textLabelLayoutStyles,
            isDisabled && $7b368d644c230660$var$disabledStyles,
            $7b368d644c230660$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("hsLv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce636d67b4ff1120$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $ce636d67b4ff1120$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ce636d67b4ff1120$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $ce636d67b4ff1120$var$labelTextStyles
    }, children);
}

});

parcelRegister("e62YQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2156c28a3894cac$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

const $d2156c28a3894cac$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d2156c28a3894cac$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $d2156c28a3894cac$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("hp1g9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ccbe97401ecc0bf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7O4UO = parcelRequire("7O4UO");
/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $9ccbe97401ecc0bf$var$CheckboxField = (props)=>{
    const { children: children, defaultIsChecked: defaultIsChecked = false, value: value, ...rest } = props;
    // Maintains a memoised list of the default values
    const defaultValue = (0, $5uXOq.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        ...rest,
        defaultValue: defaultValue,
        transform: (event, currentValue)=>event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value)
    }, ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
            fieldProps: {
                ...otherFieldProps,
                isChecked: !!fieldValue.find((v)=>v === value),
                value: value
            },
            ...others
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        ...rest,
        defaultValue: defaultIsChecked,
        transform: (event)=>event.currentTarget.checked
    }, ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
            fieldProps: {
                ...otherFieldProps,
                isChecked: fieldValue,
                value: value
            },
            ...others
        }));
};
$9ccbe97401ecc0bf$var$CheckboxField.defaultProps = {
    defaultIsChecked: false
};
var $9ccbe97401ecc0bf$export$2e2bcd8739ae039 = $9ccbe97401ecc0bf$var$CheckboxField;

});


parcelRegister("6WPAN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e22492a7312b03b7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $kY99m = parcelRequire("kY99m");

var $cFwyy = parcelRequire("cFwyy");
var $e22492a7312b03b7$export$b8e9cd941e8016ac;
(function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    Errors["INVALID_NUMBER"] = "INVALID_NUMBER";
})($e22492a7312b03b7$export$b8e9cd941e8016ac || ($e22492a7312b03b7$export$b8e9cd941e8016ac = {}));
const $e22492a7312b03b7$export$c6cbc3bbef9e5a54 = (isRequired, value)=>{
    if (isRequired && !value) return "EMPTY";
    if (value && Number.isNaN(Number(value))) return "INVALID_NUMBER";
    return undefined;
};
const $e22492a7312b03b7$var$NumberInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $gKZoD.di)((0, $qfj8c.ErrorMessage), (0, $7O4UO.default), (0, $kY99m.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const generateErrorMessage = (error)=>{
        switch(error){
            case "EMPTY":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, (0, $cFwyy.default).errorInputMustNotBeEmpty.defaultMessage);
            case "INVALID_NUMBER":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, (0, $cFwyy.default).errorValueIsNotValidNumber.defaultMessage);
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        key: variableName,
        "aria-required": required,
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: (value)=>$e22492a7312b03b7$export$c6cbc3bbef9e5a54(required, value)
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), fieldProps), generateErrorMessage(error)));
};
var $e22492a7312b03b7$export$2e2bcd8739ae039 = $e22492a7312b03b7$var$NumberInputPrompt;

});

parcelRegister("7mBJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c0425f45ac938ac$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $6LCpJ = parcelRequire("6LCpJ");

var $cFwyy = parcelRequire("cFwyy");
var $0c0425f45ac938ac$var$Errors;
(function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    Errors["CHARACTER_LIMIT"] = "CHARACTER_LIMIT";
})($0c0425f45ac938ac$var$Errors || ($0c0425f45ac938ac$var$Errors = {}));
const $0c0425f45ac938ac$var$MAX_PARAGRAPH_CHARACTER_LIMIT = 5000;
const $0c0425f45ac938ac$var$ParagraphInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $gKZoD.di)((0, $qfj8c.ErrorMessage), (0, $7O4UO.default), (0, $6LCpJ.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>{
        if (required && !value) return "EMPTY";
        if (value && value?.trim().length === 0) return "EMPTY";
        if (value && value.length > $0c0425f45ac938ac$var$MAX_PARAGRAPH_CHARACTER_LIMIT) return "CHARACTER_LIMIT";
        return undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: validate
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6LCpJ.default), fieldProps), error === "EMPTY" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, (0, $cFwyy.default).errorInputMustNotBeEmpty.defaultMessage), error === "CHARACTER_LIMIT" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, (0, $cFwyy.default).errorInputCharacterLimitReached.defaultMessage)));
};
var $0c0425f45ac938ac$export$2e2bcd8739ae039 = $0c0425f45ac938ac$var$ParagraphInputPrompt;

});
parcelRegister("6LCpJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $934f91ac04cc5aeb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6QvkM = parcelRequire("6QvkM");

var $1qQmi = parcelRequire("1qQmi");
const $934f91ac04cc5aeb$var$packageName = "platform-pkg";
const $934f91ac04cc5aeb$var$packageVersion = "0.0.0-use.local";
const $934f91ac04cc5aeb$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $934f91ac04cc5aeb$var$packageName,
    packageVersion: $934f91ac04cc5aeb$var$packageVersion
};
const $934f91ac04cc5aeb$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = (0, $1qQmi.borderWidth);
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $934f91ac04cc5aeb$var$InnerTextArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const ourRef = (0, $5uXOq.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
    (0, $5uXOq.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const baseStyles = (0, $5uXOq.useMemo)(()=>(0, $1qQmi.getBaseStyles)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        }), [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    const textAreaStyles = /*#__PURE__*/ (0, $f8Sb3.css)([
        baseStyles,
        (0, $1qQmi.dynamicStyles)(appearance)
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        // TODO refactor to follow emotion styling rules
        // see: https://product-fabric.atlassian.net/browse/DSP-6060
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: textAreaStyles,
        ...rest
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $934f91ac04cc5aeb$var$TextArea = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($934f91ac04cc5aeb$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$934f91ac04cc5aeb$var$TextArea.displayName = 'TextArea';
var $934f91ac04cc5aeb$export$2e2bcd8739ae039 = $934f91ac04cc5aeb$var$TextArea;

});
parcelRegister("1qQmi", function(module, exports) {

$parcel$export(module.exports, "borderWidth", () => $0f8aaecc0e682a20$export$12879c7697ed953d);
$parcel$export(module.exports, "getBaseStyles", () => $0f8aaecc0e682a20$export$bff8031d86bb089);
$parcel$export(module.exports, "dynamicStyles", () => $0f8aaecc0e682a20$export$98856a888ef36079);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iaE2J = parcelRequire("iaE2J");
function $0f8aaecc0e682a20$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0f8aaecc0e682a20$var$disabledRules = {
    backgroundColor: $iaE2J.disabledBackground,
    backgroundColorFocus: $iaE2J.disabledBackground,
    backgroundColorHover: $iaE2J.disabledBackground,
    borderColor: $iaE2J.disabledBorder,
    borderColorFocus: $iaE2J.defaultBorderColorFocus,
    textColor: $iaE2J.disabledTextColor
};
const $0f8aaecc0e682a20$var$invalidRules = {
    borderColor: $iaE2J.invalidBorderColor,
    borderColorFocus: $iaE2J.defaultBorderColorFocus,
    backgroundColor: $iaE2J.defaultBackgroundColor,
    backgroundColorFocus: $iaE2J.defaultBackgroundColorFocus,
    backgroundColorHover: $iaE2J.defaultBackgroundColorHover
};
const $0f8aaecc0e682a20$var$backgroundColor = {
    standard: $iaE2J.defaultBackgroundColor,
    subtle: $iaE2J.transparent,
    none: $iaE2J.transparent
};
const $0f8aaecc0e682a20$var$backgroundColorFocus = {
    standard: $iaE2J.defaultBackgroundColorFocus,
    subtle: $iaE2J.defaultBackgroundColorFocus,
    none: $iaE2J.transparent
};
const $0f8aaecc0e682a20$var$backgroundColorHover = {
    standard: $iaE2J.defaultBackgroundColorHover,
    subtle: $iaE2J.defaultBackgroundColorHover,
    none: $iaE2J.transparent
};
const $0f8aaecc0e682a20$var$borderColor = {
    standard: $iaE2J.defaultBorderColor,
    subtle: $iaE2J.transparent,
    none: $iaE2J.transparent
};
const $0f8aaecc0e682a20$var$borderColorFocus = {
    standard: $iaE2J.defaultBorderColorFocus,
    subtle: $iaE2J.defaultBorderColorFocus,
    none: $iaE2J.transparent
};
const $0f8aaecc0e682a20$var$borderColorHover = {
    standard: $iaE2J.defaultBorderColor,
    subtle: $iaE2J.subtleBorderColorHover,
    none: $iaE2J.transparent
};
const $0f8aaecc0e682a20$var$lineHeightBase = 20;
const $0f8aaecc0e682a20$var$lineHeightCompact = 16;
const $0f8aaecc0e682a20$var$compactVerticalPadding = 2;
const $0f8aaecc0e682a20$var$verticalPadding = 6;
const $0f8aaecc0e682a20$var$horizontalPadding = 8;
const $0f8aaecc0e682a20$var$transitionDuration = '0.2s';
const $0f8aaecc0e682a20$var$fontFamily = "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)";
const $0f8aaecc0e682a20$var$codeFontFamily = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $0f8aaecc0e682a20$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
const $0f8aaecc0e682a20$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: 'unset',
    WebkitOpacity: '1'
};
const $0f8aaecc0e682a20$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
    const contentHeight = $0f8aaecc0e682a20$var$lineHeightBase * minimumRows;
    return contentHeight + $0f8aaecc0e682a20$var$verticalPadding * 2 + borderHeight * 2;
};
const $0f8aaecc0e682a20$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
    const contentHeightCompact = $0f8aaecc0e682a20$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $0f8aaecc0e682a20$var$compactVerticalPadding * 2 + borderHeight * 2;
};
const $0f8aaecc0e682a20$var$bgAndBorderColorStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $f8Sb3.css)({
        '&:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $0f8aaecc0e682a20$var$backgroundColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $0f8aaecc0e682a20$var$borderColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$borderColorFocus[appearance]}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $0f8aaecc0e682a20$var$backgroundColor[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $0f8aaecc0e682a20$var$borderColor[appearance]
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColorFocus}`
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColor}`
        },
        // Disabled background and border styles should not be applied to components that
        // have either no background or transparent background to begin with
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...appearance === 'standard' ? {
            '&:disabled:focus': {
                backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColorFocus,
                borderColor: $0f8aaecc0e682a20$var$disabledRules.borderColorFocus
            },
            '&:disabled:not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColor,
                borderColor: $0f8aaecc0e682a20$var$disabledRules.borderColor
            }
        } : {}
    });
const $0f8aaecc0e682a20$var$placeholderStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $iaE2J.placeholderTextColor
    },
    '&:disabled::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $0f8aaecc0e682a20$var$disabledRules.textColor
    }
});
const $0f8aaecc0e682a20$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:hover:not(:read-only):not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $0f8aaecc0e682a20$var$backgroundColorHover[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $0f8aaecc0e682a20$var$borderColorHover[appearance],
            '&:disabled': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[data-invalid]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColorHover,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColor}`
            }
        }
    });
var $0f8aaecc0e682a20$var$_ref = {
    name: "utehjx",
    styles: "resize:none"
};
var $0f8aaecc0e682a20$var$_ref2 = {
    name: "bolgb9",
    styles: "resize:both"
};
const $0f8aaecc0e682a20$var$resizeStyle = (resize)=>{
    if (resize === 'horizontal' || resize === 'vertical') // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        resize: resize
    });
    if (resize === 'auto') return $0f8aaecc0e682a20$var$_ref2;
    return $0f8aaecc0e682a20$var$_ref;
};
const $0f8aaecc0e682a20$var$borderStyle = (appearance)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderStyle: appearance === 'none' ? 'none' : 'solid'
    });
const $0f8aaecc0e682a20$var$fontFamilyStyle = (isMonospaced)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontFamily: isMonospaced ? $0f8aaecc0e682a20$var$codeFontFamily : $0f8aaecc0e682a20$var$fontFamily
    });
const $0f8aaecc0e682a20$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
    const borderWidth = appearance !== 'none' ? 1 : 2;
    const horizontalPaddingWithoutBorderWidth = $0f8aaecc0e682a20$var$horizontalPadding - borderWidth;
    const borderHeight = borderWidth;
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-compact]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $0f8aaecc0e682a20$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$0f8aaecc0e682a20$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $0f8aaecc0e682a20$var$lineHeightCompact / 14
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-compact])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $0f8aaecc0e682a20$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$0f8aaecc0e682a20$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $0f8aaecc0e682a20$var$lineHeightBase / 14
        }
    });
};
const $0f8aaecc0e682a20$var$staticStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    margin: 0,
    position: 'relative',
    flex: '1 1 100%',
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: 1,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    outline: 'none',
    overflow: 'auto',
    transition: `background-color ${$0f8aaecc0e682a20$var$transitionDuration} ease-in-out,
               border-color ${$0f8aaecc0e682a20$var$transitionDuration} ease-in-out`,
    wordWrap: 'break-word',
    '&:disabled': {
        cursor: 'not-allowed',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$0f8aaecc0e682a20$var$overrideSafariDisabledStyles
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-ms-clear': {
        display: 'none'
    },
    '&:invalid': {
        boxShadow: 'none'
    }
});
const $0f8aaecc0e682a20$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$staticStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$borderPaddingAndHeightStyles(minimumRows, appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$resizeStyle(resize), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$borderStyle(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$fontFamilyStyle(isMonospaced), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    {
        maxHeight: maxHeight
    });
const $0f8aaecc0e682a20$export$98856a888ef36079 = (appearance)=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$bgAndBorderColorStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$hoverBackgroundAndBorderStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$placeholderStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $iaE2J.textColor,
        '&:disabled': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: $0f8aaecc0e682a20$var$disabledRules.textColor
        }
    });

});
parcelRegister("iaE2J", function(module, exports) {

$parcel$export(module.exports, "disabledBackground", () => $f788b902061573a8$export$ae3cba7672df0890);
$parcel$export(module.exports, "disabledBorder", () => $f788b902061573a8$export$fe505fe3c5edbdf6);
$parcel$export(module.exports, "invalidBorderColor", () => $f788b902061573a8$export$7f333bbf7ddab792);
$parcel$export(module.exports, "defaultBorderColor", () => $f788b902061573a8$export$dafd83031c202ca8);
$parcel$export(module.exports, "defaultBorderColorFocus", () => $f788b902061573a8$export$e8320c09dc1e4012);
$parcel$export(module.exports, "defaultBackgroundColor", () => $f788b902061573a8$export$b13414ee9ac9cae6);
$parcel$export(module.exports, "defaultBackgroundColorHover", () => $f788b902061573a8$export$bca15982c103d57b);
$parcel$export(module.exports, "defaultBackgroundColorFocus", () => $f788b902061573a8$export$21287e4b7f134f09);
$parcel$export(module.exports, "subtleBorderColorHover", () => $f788b902061573a8$export$a87538d56ee366ec);
$parcel$export(module.exports, "placeholderTextColor", () => $f788b902061573a8$export$5e076b2557ef7bbb);
$parcel$export(module.exports, "textColor", () => $f788b902061573a8$export$32f78bffcd82ff28);
$parcel$export(module.exports, "disabledTextColor", () => $f788b902061573a8$export$eb4a7d363eec53c8);
$parcel$export(module.exports, "transparent", () => $f788b902061573a8$export$f4d082c200a4b4b8);

const $f788b902061573a8$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
const $f788b902061573a8$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`;
const $f788b902061573a8$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`;
const $f788b902061573a8$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`;
const $f788b902061573a8$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`;
const $f788b902061573a8$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`;
const $f788b902061573a8$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
const $f788b902061573a8$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $f788b902061573a8$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
const $f788b902061573a8$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`;
const $f788b902061573a8$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`;
const $f788b902061573a8$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`;
const $f788b902061573a8$export$f4d082c200a4b4b8 = 'transparent';

});




parcelRegister("g9On4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b944eed42d17fa4b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $7K5PP = parcelRequire("7K5PP");

var $cFwyy = parcelRequire("cFwyy");
var $b944eed42d17fa4b$var$Errors;
(function(Errors) {
    Errors["EMPTY"] = "EMPTY";
})($b944eed42d17fa4b$var$Errors || ($b944eed42d17fa4b$var$Errors = {}));
const $b944eed42d17fa4b$var$SelectInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $gKZoD.di)((0, $qfj8c.ErrorMessage), (0, $7O4UO.default), (0, $7K5PP.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>{
        if (required && !value) return "EMPTY";
        return undefined;
    };
    const selectOptions = defaultValue.map((value)=>({
            label: value,
            value: value
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: variableName,
        label: displayName,
        isRequired: required,
        validate: validate
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
            isClearable: true,
            isSearchable: true,
            options: selectOptions,
            menuPosition: "fixed",
            ...fieldProps
        }), error === "EMPTY" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, (0, $cFwyy.default).errorInputMustNotBeEmpty.defaultMessage)));
};
var $b944eed42d17fa4b$export$2e2bcd8739ae039 = $b944eed42d17fa4b$var$SelectInputPrompt;

});

parcelRegister("bDNlV", function(module, exports) {

$parcel$export(module.exports, "default", () => $95844140411f95a2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $kY99m = parcelRequire("kY99m");

var $cFwyy = parcelRequire("cFwyy");
var $95844140411f95a2$var$Errors;
(function(Errors) {
    Errors["EMPTY"] = "EMPTY";
})($95844140411f95a2$var$Errors || ($95844140411f95a2$var$Errors = {}));
const $95844140411f95a2$var$TextInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $gKZoD.di)((0, $qfj8c.ErrorMessage), (0, $7O4UO.default), (0, $kY99m.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>required && !value ? "EMPTY" : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: validate
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), fieldProps), error === "EMPTY" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, (0, $cFwyy.default).errorInputMustNotBeEmpty.defaultMessage)));
};
var $95844140411f95a2$export$2e2bcd8739ae039 = $95844140411f95a2$var$TextInputPrompt;

});



parcelRegister("k9To8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef3572ada154aadf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ef3572ada154aadf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    successFlag: {
        "id": "automation-platform.common.success-flag",
        "defaultMessage": "Your automation is in progress"
    },
    failureFlagTitle: {
        "id": "automation-platform.common.failure-flag-title",
        "defaultMessage": "Oops we ran into a problem"
    },
    failureFlagDescription: {
        "id": "automation-platform.common.failure-flag-description",
        "defaultMessage": "There was a problem and we couldn't run the automation \"{0}\""
    },
    partialFailureFlagDescription: {
        "id": "automation-platform.common.partial-failure-flag-description",
        "defaultMessage": "Couldn't run the automation against issues \"{0}\", please ensure you have permission to view these issues"
    },
    errorInputMustNotBeEmpty: {
        "id": "automation-platform.common.error-input-must-not-be-empty",
        "defaultMessage": "Input must not be empty"
    },
    errorInputCharacterLimitReached: {
        "id": "automation-platform.common.error-input-character-limit-reached",
        "defaultMessage": "Provided value exceeds the character limit for the field."
    },
    inputRequiredForAction: {
        "id": "automation-platform.common.input-required-for-action",
        "defaultMessage": "Your input is required to complete this action"
    },
    errorInputTypeIsNotSupported: {
        "id": "automation-platform.common.error-input-type-is-not-supported",
        "defaultMessage": "Input type not supported yet"
    },
    errorValueIsNotValidNumber: {
        "id": "automation-platform.common.error-value-is-not-valid-number",
        "defaultMessage": "The value is not a valid number"
    },
    cancelButtonTitle: {
        "id": "automation-platform.common.cancel-button-title",
        "defaultMessage": "Cancel"
    },
    continueButtonTitle: {
        "id": "automation-platform.common.continue-button-title",
        "defaultMessage": "Continue"
    }
});

});


parcelRegister("4a5pt", function(module, exports) {

$parcel$export(module.exports, "default", () => $405c068c4e98f089$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $h5xhD = parcelRequire("h5xhD");

var $6K5bC = parcelRequire("6K5bC");

var $9LkAS = parcelRequire("9LkAS");

var $dpyBt = parcelRequire("dpyBt");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");

var $9OXo1 = parcelRequire("9OXo1");

var $hdfW8 = parcelRequire("hdfW8");

var $kBike = parcelRequire("kBike");

var $btB4j = parcelRequire("btB4j");

var $XHOES = parcelRequire("XHOES");
const $405c068c4e98f089$var$RunRule = (props)=>{
    const { initialised: initialised, error: rulesError, rules: rules, executingRuleId: executingRuleId, executeRule: executeRule, triggerFetch: triggerFetch, selectedIssueIds: selectedIssueIds, setClosed: setClosed } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ canManageAutomations: canManageAutomations, projectAri: projectAri }] = (0, $kBike.useMenuContext)();
    const { environment: environment, cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const [baseAutomationUrl] = (0, $kBike.useBaseAutomationUrl)();
    const [{ data: recommendations, error: recommendationsError, loading: loading, fetched: fetched }] = (0, $6K5bC.useAutomationRecommendations)({
        env: environment,
        cloudId: cloudId,
        target: projectAri,
        shouldFetch: canManageAutomations
    });
    // Note: fetched is false if the request errors
    const initialisedRecommendations = !loading && fetched || recommendationsError != null || !canManageAutomations;
    const hasRecommendation = !!(recommendations && recommendations?.data.length > 0);
    const error = rulesError || recommendationsError;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($405c068c4e98f089$var$Container, {
        role: "dialog",
        "aria-modal": "false",
        "aria-labelledby": "automation-menu.ui.popup",
        "data-testid": "automation-menu.ui.popup.run-rule.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: (event)=>(0, $8zOmE.fireOperationalAnalyticsDeferred)(event, 'automationMenuContent mounted')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($405c068c4e98f089$var$Header, {
        "data-testid": "automation-menu.ui.popup.run-rule.menu-header"
    }, formatMessage((0, $XHOES.default).automationHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h5xhD.default), null, selectedIssueIds && selectedIssueIds.length > 0 || error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $btB4j.default), {
        initialised: initialised && initialisedRecommendations,
        executingRuleId: executingRuleId,
        error: error,
        rules: rules,
        executeRule: executeRule,
        triggerFetch: triggerFetch,
        selectedIssueIds: selectedIssueIds,
        recommendations: recommendations?.data,
        setClosed: setClosed
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hdfW8.ConditionalRecommendation), {
        initialised: initialisedRecommendations,
        canManageAutomations: canManageAutomations,
        baseAutomationUrl: baseAutomationUrl,
        recommendations: recommendations?.data,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpyBt.NoIssueSelectedEmptyState), null),
        setClosed: setClosed
    }), canManageAutomations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9LkAS.default), {
        baseAutomationUrl: baseAutomationUrl,
        hasSeparator: !hasRecommendation
    })));
};
var $405c068c4e98f089$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $405c068c4e98f089$var$RunRule;
const $405c068c4e98f089$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qv47k _1bsbp59q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $405c068c4e98f089$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h5", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s8ie5z _syaz1be1 _1p1dangw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6K5bC", function(module, exports) {

$parcel$export(module.exports, "useAutomationRecommendations", () => $8e732ed9cb28fcc2$export$48a061abff796477);

var $iuEfD = parcelRequire("iuEfD");

var $48DMb = parcelRequire("48DMb");

var $c4l9J = parcelRequire("c4l9J");

var $c5wox = parcelRequire("c5wox");
const $8e732ed9cb28fcc2$var$fetchRecommendation = async ({ env: env, cloudId: cloudId, target: target }, options)=>{
    const url = await (0, $c5wox.getAutomationRecommendationsUrl)({
        env: env,
        cloudId: cloudId,
        target: target
    });
    const response = await (0, $48DMb.fetchJson)(url, options);
    return response;
};
const $8e732ed9cb28fcc2$export$48a061abff796477 = ({ env: env, cloudId: cloudId, target: target, shouldFetch: shouldFetch = true })=>(0, $iuEfD.useFetch)({
        onFetch: (options)=>$8e732ed9cb28fcc2$var$fetchRecommendation({
                env: env,
                cloudId: cloudId,
                target: target
            }, options),
        analyticsTracking: {
            actionSubject: `useFetch.${(0, $c4l9J.AUTOMATION_RECOMMENDATIONS_PREFIX)}`,
            packageName: (0, $c4l9J.PACKAGE_NAME)
        },
        loggingKey: `${(0, $c4l9J.PACKAGE_NAME)}.${(0, $c4l9J.AUTOMATION_RECOMMENDATIONS_PREFIX)}`,
        isAutoFetchable: shouldFetch
    }, [
        env,
        cloudId,
        target,
        shouldFetch
    ]);

});
parcelRegister("48DMb", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $cfd862e6e9d86034$export$6d71b655afe1638d);

var $7f4tk = parcelRequire("7f4tk");

var $3wzQ9 = parcelRequire("3wzQ9");
const $cfd862e6e9d86034$export$6d71b655afe1638d = async (url, options = {})=>(0, $7f4tk.default)(url, options).catch((error)=>{
        throw new (0, $3wzQ9.FetchUrlError)(url, error);
    });

});

parcelRegister("c4l9J", function(module, exports) {

$parcel$export(module.exports, "AUTOMATION_MORE_DETAILS_URL", () => $ac484d837db7bb47$export$6f6eeff13d6dfe71);
$parcel$export(module.exports, "templateRecommendationPriority", () => $ac484d837db7bb47$export$202bed908b983e2d);
$parcel$export(module.exports, "AUTOMATION_RECOMMENDATIONS_PREFIX", () => $ac484d837db7bb47$export$4c17f46a32923c89);
$parcel$export(module.exports, "PACKAGE_NAME", () => $ac484d837db7bb47$export$b8b9d90f9e5bd72b);
const $ac484d837db7bb47$export$6f6eeff13d6dfe71 = 'https://support.atlassian.com/cloud-automation/docs/jira-automation-triggers/#Manual-trigger-from-issue';
const $ac484d837db7bb47$export$202bed908b983e2d = [
    'devops_template_6',
    'security_template_1',
    'devops_template_10',
    'devops_template_8'
];
const $ac484d837db7bb47$export$edc604fbb1737616 = 'automation';
const $ac484d837db7bb47$export$4c17f46a32923c89 = `${$ac484d837db7bb47$export$edc604fbb1737616}.recommendations`;
const $ac484d837db7bb47$export$b8b9d90f9e5bd72b = 'jiraAutomationPlatform';

});

parcelRegister("c5wox", function(module, exports) {

$parcel$export(module.exports, "getAutomationRecommendationsUrl", () => $8833cfad9f41bd36$export$38f41aa7b608011d);
$parcel$export(module.exports, "getBaseAutomationUrl", () => $8833cfad9f41bd36$export$8e479e490e1e69bc);

var $bSSG7 = parcelRequire("bSSG7");

var $co1wz = parcelRequire("co1wz");
const $8833cfad9f41bd36$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('automation-menu');
const $8833cfad9f41bd36$var$getLatestStack = async (cloudId)=>fetch(`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`).then((response)=>response.json()).then((response)=>{
        const stacks = response.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        return stacks.length > 0 ? stacks[0] : null;
    }).catch(()=>null);
const $8833cfad9f41bd36$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') {
        if ((0, $co1wz.ff)('automation.platform.pre-prod.instance')) {
            const stack = await $8833cfad9f41bd36$var$getLatestStack(cloudId);
            return stack ?? 'pro';
        }
        return 'pro';
    }
    // Set this manually to your Automation dev stack e.g. devesukmajaya. The full key is: __storejs_automation-menu_automationStack
    const stackOverride = $8833cfad9f41bd36$var$localStorage.get('automationStack');
    return stackOverride || 'staging';
};
const $8833cfad9f41bd36$export$45ce04a98782e28a = async (env, cloudId, projectId)=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${projectId}`;
};
const $8833cfad9f41bd36$export$f8e019b45a22d26a = async (env, cloudId, ruleId)=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${ruleId}`;
};
const $8833cfad9f41bd36$export$38f41aa7b608011d = async ({ env: env, cloudId: cloudId, target: target })=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/v1/recommendation/templates?target=${target}`;
};
const $8833cfad9f41bd36$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};

});


parcelRegister("9LkAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eb68b9b7b7c2a06$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $23Uzi = parcelRequire("23Uzi");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $0eb68b9b7b7c2a06$export$a06f1c675e846f6f = ({ baseAutomationUrl: baseAutomationUrl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $23Uzi.default), {
        baseAutomationUrl: baseAutomationUrl,
        onCreateAutomationFooterLinkClicked: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'link',
                action: 'clicked'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu.adminFooter.createAutomation', {
                userType: 'admin'
            });
        },
        onManageAutomationsFooterLinkClicked: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'link',
                action: 'clicked'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu.adminFooter.manageAutomations', {
                userType: 'admin'
            });
        },
        onAuditLogFooterLinkClicked: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'link',
                action: 'clicked'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu.adminFooter.auditLog', {
                userType: 'admin'
            });
        }
    });
};
var $0eb68b9b7b7c2a06$export$2e2bcd8739ae039 = $0eb68b9b7b7c2a06$export$a06f1c675e846f6f;

});
parcelRegister("23Uzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $54004c2cfe1fb1a6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $5LWLA = parcelRequire("5LWLA");

var $7ymNM = parcelRequire("7ymNM");

var $6tSZM = parcelRequire("6tSZM");

var $dIWbq = parcelRequire("dIWbq");

var $KhPb4 = parcelRequire("KhPb4");

var $3Z96c = parcelRequire("3Z96c");
var $9UCCQ = parcelRequire("9UCCQ");

var $8M6yJ = parcelRequire("8M6yJ");

var $cVoxq = parcelRequire("cVoxq");
const $54004c2cfe1fb1a6$var$handleOptionalCallback = (optionalEvent)=>{
    if (optionalEvent) optionalEvent();
};
var $54004c2cfe1fb1a6$export$2e2bcd8739ae039 = ({ baseAutomationUrl: baseAutomationUrl, createAutomationComponentFilter: createAutomationComponentFilter, onCreateAutomationFooterLinkClicked: onCreateAutomationFooterLinkClicked, onManageAutomationsFooterLinkClicked: onManageAutomationsFooterLinkClicked, onAuditLogFooterLinkClicked: onAuditLogFooterLinkClicked })=>{
    (0, $gKZoD.di)((0, (/*@__PURE__*/$parcel$interopDefault($KhPb4))), (0, (/*@__PURE__*/$parcel$interopDefault($dIWbq))), (0, $5LWLA.default), (0, $8M6yJ.MenuIcon), (0, $9UCCQ.default));
    const componentFilter = createAutomationComponentFilter ? `?componentFilterCriteria=${createAutomationComponentFilter}` : '';
    const createNewRuleUrl = `${baseAutomationUrl}#/rule/new/__NEW__TRIGGER${componentFilter}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: true,
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        onClick: ()=>$54004c2cfe1fb1a6$var$handleOptionalCallback(onCreateAutomationFooterLinkClicked),
        href: createNewRuleUrl,
        testId: "create-automation-link",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8M6yJ.MenuIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dIWbq))), {
            LEGACY_size: "small",
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7ymNM))),
            color: "currentColor"
        }))
    }, (0, $cVoxq.default).createAutomationItem.defaultMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        onClick: ()=>$54004c2cfe1fb1a6$var$handleOptionalCallback(onManageAutomationsFooterLinkClicked),
        href: baseAutomationUrl,
        testId: "manage-automations-link",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8M6yJ.MenuIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8M6yJ.ManageRulesGlyph), null))
    }, (0, $cVoxq.default).manageAutomationsItem.defaultMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        onClick: ()=>{
            $54004c2cfe1fb1a6$var$handleOptionalCallback(onAuditLogFooterLinkClicked);
        },
        href: `${baseAutomationUrl}#tab/audit-log`,
        testId: "audit-log-link",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8M6yJ.MenuIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($KhPb4))), {
            LEGACY_size: "small",
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6tSZM))),
            color: "currentColor"
        }))
    }, (0, $cVoxq.default).auditLogItem.defaultMessage));
};

});
parcelRegister("6tSZM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b801c7587081e8b$var$_react = $4b801c7587081e8b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4b801c7587081e8b$var$_checkCircle = $4b801c7587081e8b$var$_interopRequireDefault((parcelRequire("34OIV")));
function $4b801c7587081e8b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4b801c7587081e8b$var$CheckCircleOutlineIcon = (props)=>/*#__PURE__*/ $4b801c7587081e8b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/><path d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $4b801c7587081e8b$var$_checkCircle.default
    }));
$4b801c7587081e8b$var$CheckCircleOutlineIcon.displayName = 'CheckCircleOutlineIcon';
var $4b801c7587081e8b$var$_default = module.exports.default = $4b801c7587081e8b$var$CheckCircleOutlineIcon;

});
parcelRegister("34OIV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::33c5439f087752870260bcf48e3a4598>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23d917767cf5e6f4$var$_react = $23d917767cf5e6f4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $23d917767cf5e6f4$var$_UNSAFE_baseNew = $23d917767cf5e6f4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $23d917767cf5e6f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: completed items, productivity emoji category. Completed task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23d917767cf5e6f4$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $23d917767cf5e6f4$var$_react.default.createElement($23d917767cf5e6f4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/>`
    }, props));
$23d917767cf5e6f4$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $23d917767cf5e6f4$var$_default = module.exports.default = $23d917767cf5e6f4$var$CheckCircleIcon;

});


parcelRegister("KhPb4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::96fa4d3d068726116211916d25154c83>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08b21f8e4cb7f21d$var$_react = $08b21f8e4cb7f21d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $08b21f8e4cb7f21d$var$_UNSAFE_baseNew = $08b21f8e4cb7f21d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $08b21f8e4cb7f21d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-circle
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $08b21f8e4cb7f21d$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $08b21f8e4cb7f21d$var$_react.default.createElement($08b21f8e4cb7f21d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m3.284 6 1.81 2.172 3.622-4.344M6 .75a5.25 5.25 0 1 0 0 10.5A5.25 5.25 0 0 0 6 .75Z"/>`,
        type: 'utility'
    }, props));
$08b21f8e4cb7f21d$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $08b21f8e4cb7f21d$var$_default = module.exports.default = $08b21f8e4cb7f21d$var$CheckCircleIcon;

});

parcelRegister("8M6yJ", function(module, exports) {

$parcel$export(module.exports, "MenuIcon", () => $401a40ce500dda11$export$46e1d66043f363e6);
$parcel$export(module.exports, "TriggerIcon", () => $401a40ce500dda11$export$1cb264166623d4aa);
$parcel$export(module.exports, "ManualTriggerGlyph", () => $401a40ce500dda11$export$4514e29f70245d75);
$parcel$export(module.exports, "ManageRulesGlyph", () => $401a40ce500dda11$export$85ca00d4fc5d86c3);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $4ldhu = parcelRequire("4ldhu");

var $7paD5 = parcelRequire("7paD5");

var $dp8JX = parcelRequire("dp8JX");

var $47V8T = parcelRequire("47V8T");
var $cKQOJ = parcelRequire("cKQOJ");

const $401a40ce500dda11$export$46e1d66043f363e6 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-81krfu-0"
})`width:32px;height:32px;display:flex;justify-content:center;align-items:center;`;
const $401a40ce500dda11$export$1cb264166623d4aa = /*#__PURE__*/ (0, $47bDC.default)($401a40ce500dda11$export$46e1d66043f363e6).withConfig({
    componentId: "sc-81krfu-1"
})`color:${$829f609a65d26a98$export$6fa04827ac68a4fb};background-color:${$829f609a65d26a98$export$8a6341c32b6a3ee6};`;
const $401a40ce500dda11$export$4514e29f70245d75 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dp8JX))), {
        color: "currentColor",
        ...props,
        LEGACY_fallbackIcon: (0, $cKQOJ.default)
    });
const $401a40ce500dda11$export$85ca00d4fc5d86c3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
        label: "",
        LEGACY_size: "small",
        ...props,
        color: "currentColor"
    });
const $401a40ce500dda11$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ldhu))), {
        color: "currentColor",
        LEGACY_fallbackIcon: (0, $47V8T.default),
        ...props
    });
const $401a40ce500dda11$export$fdd32c4638a0c3ae = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "black",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10.1838 4.78749C10.2664 4.61167 10.4433 4.49957 10.6375 4.5L17.0011 4.51406C17.1951 4.51449 17.3713 4.62709 17.4532 4.80294C17.5352 4.97879 17.508 5.18614 17.3835 5.33492L13.9446 9.44482H16.8597C17.0645 9.44482 17.2486 9.5697 17.3243 9.76C17.4 9.95029 17.352 10.1675 17.2032 10.3082L7.62319 19.3634C7.44433 19.5324 7.16903 19.5462 6.97421 19.3958C6.77938 19.2454 6.72297 18.9756 6.84122 18.7598L9.86254 13.2448H7C6.82891 13.2448 6.66969 13.1573 6.57795 13.0129C6.48621 12.8685 6.47469 12.6872 6.54741 12.5323L10.1838 4.78749Z",
        fill: "white"
    }));
const $401a40ce500dda11$export$9d08b452ddec60a4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10.1838 4.78749C10.2664 4.61167 10.4433 4.49957 10.6375 4.5L17.0011 4.51406C17.1951 4.51449 17.3713 4.62709 17.4532 4.80294C17.5352 4.97879 17.508 5.18614 17.3835 5.33492L13.9446 9.44482H16.8597C17.0645 9.44482 17.2486 9.5697 17.3243 9.76C17.4 9.95029 17.352 10.1675 17.2032 10.3082L7.62319 19.3634C7.44433 19.5324 7.16903 19.5462 6.97421 19.3958C6.77938 19.2454 6.72297 18.9756 6.84122 18.7598L9.86254 13.2448H7C6.82891 13.2448 6.66969 13.1573 6.57795 13.0129C6.48621 12.8685 6.47469 12.6872 6.54741 12.5323L10.1838 4.78749Z",
        fill: "black"
    }));

});
parcelRegister("dp8JX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f10942cdf812cc3ae0e2d06b6750428c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c2463c982d0f116$var$_react = $9c2463c982d0f116$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9c2463c982d0f116$var$_UNSAFE_baseNew = $9c2463c982d0f116$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9c2463c982d0f116$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PresenterMode".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for presenter mode in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c2463c982d0f116$var$PresenterModeIcon = (props)=>/*#__PURE__*/ $9c2463c982d0f116$var$_react.default.createElement($9c2463c982d0f116$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.75 3.527A3.159 3.159 0 1 0 3.527 7.75m1.723-2.5 3.25 9 1.625-4.125L14.25 8.5z"/>`
    }, props));
$9c2463c982d0f116$var$PresenterModeIcon.displayName = 'PresenterModeIcon';
var $9c2463c982d0f116$var$_default = module.exports.default = $9c2463c982d0f116$var$PresenterModeIcon;

});

parcelRegister("47V8T", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f5114f54d9406c9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $3f5114f54d9406c9$var$AutomationGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www .w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10.3789 4.62256C9.99914 4.62173 9.65331 4.84087 9.49192 5.18458L6.11523 12.3762C5.97308 12.679 5.9956 13.0334 6.17494 13.3157C6.35428 13.598 6.66553 13.7691 7 13.7691H8.79182L6.40251 18.1304C6.17135 18.5523 6.28163 19.0798 6.66249 19.3738C7.04335 19.6677 7.58152 19.6408 7.93117 19.3103L16.8269 10.902C17.1178 10.6269 17.2117 10.2023 17.0637 9.83032C16.9157 9.45832 16.5558 9.21418 16.1555 9.21418H14.547L17.0353 6.24031C17.2787 5.94947 17.3319 5.5441 17.1717 5.20034C17.0116 4.85658 16.6671 4.63646 16.2879 4.63562L10.3789 4.62256Z",
        stroke: "currentColor",
        strokeWidth: "1.95489",
        strokeLinejoin: "round"
    }));
/**
 * __AutomationIcon__
 */ const $3f5114f54d9406c9$var$AutomationIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $3f5114f54d9406c9$var$AutomationGlyph
    });
var $3f5114f54d9406c9$export$2e2bcd8739ae039 = $3f5114f54d9406c9$var$AutomationIcon;

});

parcelRegister("cKQOJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9f494eca2e5df22$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $a9f494eca2e5df22$var$ManualTriggerGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m21.192 19.778-4.9498-4.9498c-0.3905-0.3905-1.0237-0.3905-1.4142 0-0.3905 0.3906-0.3905 1.0237 0 1.4143l4.9498 4.9497c0.3905 0.3905 1.0237 0.3905 1.4142 0s0.3905-1.0237 0-1.4142z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m8.7738 8.1319 11.685 4.305c0.2591 0.0955 0.3917 0.3829 0.2963 0.6421-0.025 0.0679-0.0645 0.1295-0.1156 0.1807l-7.3802 7.3801c-0.1952 0.1953-0.5118 0.1953-0.7071 0-0.0511-0.0512-0.0906-0.1128-0.1156-0.1807l-4.3051-11.685c-0.09546-0.25911 0.03721-0.54656 0.29632-0.64202 0.11157-0.0411 0.23414-0.0411 0.34571 0z",
        clipRule: "evenodd",
        fill: "currentColor",
        fillRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m4.2218 4.2218c1.9526-1.9526 5.1184-1.9526 7.0711 0 0.5977 0.59776 1.0125 1.3092 1.2443 2.0648 0.1974 0.6437-0.4389 1.1502-1.0873 0.96899l-0.2172-0.06069c-0.3475-0.09709-0.6037-0.38008-0.7563-0.70702-0.1439-0.30836-0.3432-0.59728-0.59773-0.85184-1.1716-1.1716-3.0711-1.1716-4.2426 0-1.1716 1.1716-1.1716 3.0711 0 4.2426 0.2547 0.25469 0.54381 0.45399 0.85236 0.59799 0.32725 0.1527 0.61051 0.4091 0.70752 0.7569l0.06045 0.2168c0.18082 0.6483-0.32561 1.2843-0.96914 1.087-0.75578-0.2317-1.4675-0.6466-2.0654-1.2445-1.9526-1.9526-1.9526-5.1184 0-7.071z",
        clipRule: "evenodd",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
/**
 * __ManualTriggerIcon__
 */ const $a9f494eca2e5df22$var$ManualTriggerIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $a9f494eca2e5df22$var$ManualTriggerGlyph
    });
var $a9f494eca2e5df22$export$2e2bcd8739ae039 = $a9f494eca2e5df22$var$ManualTriggerIcon;

});


parcelRegister("cVoxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $91468585851f89bb$export$2e2bcd8739ae039);
const $91468585851f89bb$var$messages = {
    manageAutomationsItem: {
        id: 'automation-platform.footer.manage-automations-item',
        defaultMessage: 'Manage automations',
        description: 'Label for the manage automations item which is a link to project automation'
    },
    createAutomationItem: {
        id: 'automation-platform.footer.create-automation-item',
        defaultMessage: 'Create automation',
        description: 'Label for the create automation item which is a link to rule creation in project automation'
    },
    auditLogItem: {
        id: 'automation-platform.footer.audit-log-item',
        defaultMessage: 'Audit log',
        description: 'Label for the audit log item which is a link to audit log in project automation'
    }
};
var $91468585851f89bb$export$2e2bcd8739ae039 = $91468585851f89bb$var$messages;

});



parcelRegister("dpyBt", function(module, exports) {

$parcel$export(module.exports, "NoIssueSelectedEmptyState", () => $db7c56a98a7ee662$export$5acac91646e0441f);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cgL5K = parcelRequire("cgL5K");

var $ousew = parcelRequire("ousew");

var $496Xl = parcelRequire("496Xl");

var $3BRG9 = parcelRequire("3BRG9");
const $db7c56a98a7ee662$var$isMacOS = (platform)=>/Mac/i.test(platform);
const $db7c56a98a7ee662$var$getSelectKey = ()=>{
    if ($db7c56a98a7ee662$var$isMacOS(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    typeof window !== 'undefined' && window && window.navigator && window.navigator.platform || '')) return "\u2318";
    return 'Ctrl';
};
const $db7c56a98a7ee662$export$5acac91646e0441f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db7c56a98a7ee662$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db7c56a98a7ee662$var$EmptyState, null, (0, $496Xl.emptyState)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db7c56a98a7ee662$var$Message, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $3BRG9.default).noIssuesSelected,
        values: {
            ctrl: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    as: "strong"
                }, $db7c56a98a7ee662$var$getSelectKey()),
            click: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    as: "strong"
                }, chunks)
        }
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db7c56a98a7ee662$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12fp59q _n3td15tu",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db7c56a98a7ee662$var$EmptyState = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ipo3b _18s8u2gc _1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $db7c56a98a7ee662$var$Message = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4utpp _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("496Xl", function(module, exports) {

$parcel$export(module.exports, "emptyState", () => $f9ed1860665726da$export$252465da46a2ae40);

var $5uXOq = parcelRequire("5uXOq");
const $f9ed1860665726da$export$252465da46a2ae40 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
    width: "310",
    height: "216",
    viewBox: "0 0 310 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.796 0.793168C184.309 4.00611 210.67 26.1894 238.211 45.7988C267.21 66.447 301.878 85.3411 307.51 115.226C313.793 148.564 306.332 189.973 268.75 207.848C232.392 225.141 189.627 193.51 146.796 191.668C109.02 190.042 69.0787 214.216 37.9175 197.917C5.07549 180.738 1.68294 145.502 0.653 115.226C-0.411134 83.9451 3.45664 50.6107 32.1423 28.1492C61.1366 5.44611 105.414 -2.75118 146.796 0.793168Z",
    fill: "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
    filter: "url(#filter0_dd_1925_24982)"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "21",
    y: "15.3633",
    width: "268",
    height: "180",
    rx: "8",
    fill: "var(--ds-surface, white)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "249",
    y: "31.3633",
    width: "20",
    height: "20",
    rx: "4",
    fill: "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M260.334 36.6966L257.667 46.03",
    stroke: "var(--ds-link-pressed, #0055CC)",
    strokeWidth: "1.5",
    strokeLinecap: "round"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M260.334 36.6966L255.667 41.3633H262.334L257.667 46.03",
    stroke: "var(--ds-link-pressed, #0055CC)",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "37",
    y: "59.3633",
    width: "72",
    height: "84",
    rx: "4",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "41",
    y: "63.3633",
    width: "22",
    height: "4",
    rx: "2",
    fill: "var(--ds-background-accent-gray-subtlest, #DCDFE4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "42",
    y: "72.3633",
    width: "62",
    height: "30",
    rx: "3",
    fill: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    stroke: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
    strokeWidth: "2"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "47",
    y: "77.3633",
    width: "52",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "47",
    y: "85.3633",
    width: "24",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "89",
    y: "87.3633",
    width: "12",
    height: "12",
    rx: "6",
    fill: "url(#pattern0)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "41",
    y: "107.363",
    width: "64",
    height: "32",
    rx: "4",
    fill: "var(--ds-surface, white)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "47",
    y: "113.363",
    width: "52",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-gray-subtlest, #DCDFE4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "47",
    y: "121.363",
    width: "24",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-gray-subtlest, #DCDFE4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "117",
    y: "59.3633",
    width: "72",
    height: "120",
    rx: "4",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "121",
    y: "63.3633",
    width: "22",
    height: "4",
    rx: "2",
    fill: "var(--ds-background-accent-gray-subtlest, #DCDFE4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "121",
    y: "71.3633",
    width: "64",
    height: "32",
    rx: "4",
    fill: "var(--ds-surface, white)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "127",
    y: "77.3633",
    width: "52",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-gray-subtlest, #DCDFE4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "127",
    y: "85.3633",
    width: "24",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-gray-subtlest, #DCDFE4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "122",
    y: "108.363",
    width: "62",
    height: "30",
    rx: "3",
    fill: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    stroke: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
    strokeWidth: "2"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "127",
    y: "113.363",
    width: "52",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "127",
    y: "121.363",
    width: "24",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "169",
    y: "123.363",
    width: "12",
    height: "12",
    rx: "6",
    fill: "url(#pattern1)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "121",
    y: "143.363",
    width: "64",
    height: "32",
    rx: "4",
    fill: "var(--ds-surface, white)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "127",
    y: "149.363",
    width: "52",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-gray-subtlest, #DCDFE4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "127",
    y: "157.363",
    width: "24",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-gray-subtlest, #DCDFE4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "197",
    y: "59.3633",
    width: "72",
    height: "120",
    rx: "4",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "201",
    y: "63.3633",
    width: "22",
    height: "4",
    rx: "2",
    fill: "var(--ds-background-accent-gray-subtlest, #DCDFE4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "201",
    y: "71.3633",
    width: "64",
    height: "32",
    rx: "4",
    fill: "var(--ds-surface, white)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "207",
    y: "77.3633",
    width: "52",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-gray-subtlest, #DCDFE4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "207",
    y: "85.3633",
    width: "24",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-gray-subtlest, #DCDFE4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "202",
    y: "108.363",
    width: "62",
    height: "30",
    rx: "3",
    fill: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    stroke: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
    strokeWidth: "2"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "207",
    y: "113.363",
    width: "52",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "207",
    y: "121.363",
    width: "24",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "249",
    y: "123.363",
    width: "12",
    height: "12",
    rx: "6",
    fill: "url(#pattern2)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "201",
    y: "143.363",
    width: "64",
    height: "32",
    rx: "4",
    fill: "var(--ds-surface, white)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "207",
    y: "149.363",
    width: "52",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-gray-subtlest, #DCDFE4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "207",
    y: "157.363",
    width: "24",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-gray-subtlest, #DCDFE4)"
})), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("filter", {
    id: "filter0_dd_1925_24982",
    x: "9",
    y: "11.3633",
    width: "292",
    height: "204",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feGaussianBlur", {
    stdDeviation: "0.5"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1925_24982"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feOffset", {
    dy: "8"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feGaussianBlur", {
    stdDeviation: "6"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.15 0"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1925_24982",
    result: "effect2_dropShadow_1925_24982"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1925_24982",
    result: "shape"
})), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("use", {
    xlinkHref: "#image0_1925_24982",
    transform: "scale(0.0025)"
})), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("use", {
    xlinkHref: "#image1_1925_24982",
    transform: "scale(0.0025)"
})), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("use", {
    xlinkHref: "#image2_1925_24982",
    transform: "scale(0.0025)"
})), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("image", {
    id: "image0_1925_24982",
    width: "400",
    height: "400",
    xlinkHref: "data:image/jpeg;base64,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"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("image", {
    id: "image1_1925_24982",
    width: "400",
    height: "400",
    xlinkHref: "data:image/jpeg;base64,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"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("image", {
    id: "image2_1925_24982",
    width: "400",
    height: "400",
    xlinkHref: "data:image/jpeg;base64,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"
})));

});

parcelRegister("3BRG9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dbafbd5e43a25ee$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6dbafbd5e43a25ee$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noIssuesSelected: {
        "id": "automation-platform.no-issue-selected-empty-state.no-issues-selected",
        "defaultMessage": "To automate one or more issues, select them by holding <ctrl>Ctrl</ctrl> + <click>click</click>"
    }
});

});


parcelRegister("hdfW8", function(module, exports) {

$parcel$export(module.exports, "ConditionalRecommendation", () => $b39f4565e2a87f5f$export$9cb37ac3cdac20e0);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9UCCQ = parcelRequire("9UCCQ");

var $g677E = parcelRequire("g677E");

var $1f7yD = parcelRequire("1f7yD");
const $b39f4565e2a87f5f$export$9cb37ac3cdac20e0 = ({ initialised: initialised = true, canManageAutomations: canManageAutomations, baseAutomationUrl: baseAutomationUrl, setClosed: setClosed, recommendations: recommendations, fallback: fallback = null })=>{
    if (!initialised) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1f7yD.default), null);
    if (!canManageAutomations || !recommendations || recommendations.length === 0) return fallback != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, fallback) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b39f4565e2a87f5f$var$RecommendationSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g677E.AutomationRecommendation), {
        baseAutomationUrl: baseAutomationUrl,
        templates: recommendations,
        setClosed: setClosed
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b39f4565e2a87f5f$var$RecommendationSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $9UCCQ.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ywuglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("g677E", function(module, exports) {

$parcel$export(module.exports, "AutomationRecommendation", () => $bf63027f9142e78a$export$2b9d333083758335);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $5LWLA = parcelRequire("5LWLA");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");


var $39xOx = parcelRequire("39xOx");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dIdda = parcelRequire("dIdda");

var $672zM = parcelRequire("672zM");

var $c4l9J = parcelRequire("c4l9J");


var $5gact = parcelRequire("5gact");

var $cI3SV = parcelRequire("cI3SV");

var $9bjx6 = parcelRequire("9bjx6");

var $6Jatd = parcelRequire("6Jatd");
// atlaskit button passes type="button" to the component you specify which makes it render a button, this prevents that
const $bf63027f9142e78a$var$ForceLink = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
        ref: ref,
        ...props,
        type: "a"
    }));
const $bf63027f9142e78a$var$UnsafeAutomationRecommendation = ({ baseAutomationUrl: baseAutomationUrl, templates: templates, setClosed: setClosed })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const template = (0, $5uXOq.useMemo)(()=>(0, $6Jatd.findHighestPriorityTemplate)(templates), [
        templates
    ]);
    if (!template) return null;
    const handleBuildRuleClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, `${(0, $c4l9J.AUTOMATION_RECOMMENDATIONS_PREFIX)}.buildRuleLink`, {
            templateId: template.id.value
        });
        setClosed();
    };
    const handleTemplatesClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, `${(0, $c4l9J.AUTOMATION_RECOMMENDATIONS_PREFIX)}.templatesLink`, {
            templateId: template.id.value
        });
        setClosed();
    };
    const ruleUrl = `${baseAutomationUrl}#/rule/template?templateId=${template.id.value}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: (0, $7f26dd86084c5c4b$export$a3821bc63538b210),
        sourceType: (0, $4d5e0871c06cee03$export$d1123261ca8831d2),
        attributes: {
            templateId: template.id.value
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.250",
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        backgroundColor: 'color.background.information'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gact.ExplainerSection), {
        templateId: template.id.value
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9bjx6.TemplateSection), {
        template: template
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "primary",
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            size: "medium",
            glyph: (0, $672zM.AutomationGlyph),
            label: "",
            primaryColor: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N20})`,
            secondaryColor: "none"
        }),
        component: $bf63027f9142e78a$var$ForceLink,
        href: ruleUrl,
        onClick: handleBuildRuleClick
    }, formatMessage((0, $cI3SV.default).createRule)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
        href: `${baseAutomationUrl}#/tab/rule-library#`,
        onClick: handleTemplatesClick
    }, formatMessage((0, $cI3SV.default).viewTemplates))))));
};
const $bf63027f9142e78a$export$2b9d333083758335 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: `${(0, $c4l9J.AUTOMATION_RECOMMENDATIONS_PREFIX)}.panel`,
        packageName: (0, $c4l9J.PACKAGE_NAME),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bf63027f9142e78a$var$UnsafeAutomationRecommendation, props));

});
parcelRegister("672zM", function(module, exports) {

$parcel$export(module.exports, "AutomationGlyph", () => $a4448ef378c847a2$export$3b6023946faff8bc);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");
const $a4448ef378c847a2$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14 5L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14 5L7 12H17L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));

});

const $7f26dd86084c5c4b$export$a3821bc63538b210 = 'jiraAutomationRecommendationsPanel';

parcelRegister("5gact", function(module, exports) {

$parcel$export(module.exports, "ExplainerSection", () => $144a2fa485be937f$export$41c214c36f49000d);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $1dJ6S = parcelRequire("1dJ6S");

var $cgL5K = parcelRequire("cgL5K");

var $koVbs = parcelRequire("koVbs");

var $9hYQ4 = parcelRequire("9hYQ4");
const $144a2fa485be937f$export$41c214c36f49000d = ({ templateId: templateId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const heading = (0, $9hYQ4.headingMessagesMapping)[templateId];
    const description = (0, $9hYQ4.descriptionsMessagesMapping)[templateId];
    if (!heading || !description) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1dJ6S.default), {
        size: "xsmall",
        as: "div"
    }, formatMessage(heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage(description)));
};

});
parcelRegister("9hYQ4", function(module, exports) {

$parcel$export(module.exports, "headingMessagesMapping", () => $c8b40daff1a9ad47$export$48b39c5f71867b6f);
$parcel$export(module.exports, "descriptionsMessagesMapping", () => $c8b40daff1a9ad47$export$8aee906b64e36a66);

var $fB1iJ = parcelRequire("fB1iJ");
const $c8b40daff1a9ad47$export$48b39c5f71867b6f = {
    devops_template_10: (0, $fB1iJ.default).failedDeploymentsHeading,
    // deploymentFailsTemplate
    security_template_1: (0, $fB1iJ.default).criticalVulnerabilitiesHeading,
    // criticalVulnerabilityTemplate
    devops_template_8: (0, $fB1iJ.default).successfulDeploymentsHeading,
    // deploymentSuccessfulTemplate
    devops_template_6: (0, $fB1iJ.default).versionsCreatedHeading // versionCreatedTemplate
};
const $c8b40daff1a9ad47$export$8aee906b64e36a66 = {
    devops_template_10: (0, $fB1iJ.default).failedDeploymentsDescription,
    // deploymentFailsTemplate
    security_template_1: (0, $fB1iJ.default).criticalVulnerabilitiesDescription,
    // criticalVulnerabilityTemplate
    devops_template_8: (0, $fB1iJ.default).successfulDeploymentsDescription,
    // deploymentSuccessfulTemplate
    devops_template_6: (0, $fB1iJ.default).versionsCreatedDescription // versionCreatedTemplate
};

});
parcelRegister("fB1iJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $96986feff0a6e1b8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $96986feff0a6e1b8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    successfulDeploymentsHeading: {
        "id": "automation-platform.automation-recommendation.explainer-section.successful-deployments-heading",
        "defaultMessage": "Move issues to done for successful deployments"
    },
    failedDeploymentsHeading: {
        "id": "automation-platform.automation-recommendation.explainer-section.failed-deployments-heading",
        "defaultMessage": "Notify your team about failed deployments"
    },
    versionsCreatedHeading: {
        "id": "automation-platform.automation-recommendation.explainer-section.versions-created-heading",
        "defaultMessage": "Create feature flags for assigned versions"
    },
    criticalVulnerabilitiesHeading: {
        "id": "automation-platform.automation-recommendation.explainer-section.critical-vulnerabilities-heading",
        "defaultMessage": "Create issues for security vulnerabilities"
    },
    successfulDeploymentsDescription: {
        "id": "automation-platform.automation-recommendation.explainer-section.successful-deployments-description",
        "defaultMessage": "We found issues with successful deployments for this project. Create a rule to automatically move issues to done."
    },
    failedDeploymentsDescription: {
        "id": "automation-platform.automation-recommendation.explainer-section.failed-deployments-description",
        "defaultMessage": "We found issues with failed deployments in this project. Create a rule to automatically notify the right people when this happens."
    },
    versionsCreatedDescription: {
        "id": "automation-platform.automation-recommendation.explainer-section.versions-created-description",
        "defaultMessage": "We found issues with assigned versions for this project. Create a rule to automatically create feature flags."
    },
    criticalVulnerabilitiesDescription: {
        "id": "automation-platform.automation-recommendation.explainer-section.critical-vulnerabilities-description",
        "defaultMessage": "We found security vulnerabilities in this project. Create a rule to automatically create issues."
    }
});

});



parcelRegister("cI3SV", function(module, exports) {

$parcel$export(module.exports, "default", () => $668d5f2abe0d22a7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $668d5f2abe0d22a7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createRule: {
        "id": "automation-platform.automation-recommendation.create-rule",
        "defaultMessage": "Create rule"
    },
    viewTemplates: {
        "id": "automation-platform.automation-recommendation.view-templates",
        "defaultMessage": "See more templates"
    }
});

});

parcelRegister("9bjx6", function(module, exports) {

$parcel$export(module.exports, "TemplateSection", () => $683cf8d86854d6bb$export$139a945789e7fc73);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iyAO0 = parcelRequire("iyAO0");

var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $al3cm = parcelRequire("al3cm");
const $683cf8d86854d6bb$var$ElevatedIcon = ({ icons: icons })=>{
    // Fallback to a default if no icon found
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    const Icon = (0, $al3cm.templateIcons)[icons[0].src] || (0, (/*@__PURE__*/$parcel$interopDefault($iyAO0)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($683cf8d86854d6bb$var$ElevatedIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        label: icons[0].altText
    }));
};
const $683cf8d86854d6bb$export$139a945789e7fc73 = ({ template: template })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $683cf8d86854d6bb$var$iconContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($683cf8d86854d6bb$var$ElevatedIcon, {
        icons: template.trigger.icons
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($683cf8d86854d6bb$var$RightArrow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($683cf8d86854d6bb$var$ElevatedIcon, {
        icons: template.action.icons
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, template.description));
const $683cf8d86854d6bb$var$iconContainerStyles = (0, $8CUq3.xcss)({
    flexShrink: 0
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $683cf8d86854d6bb$var$ElevatedIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1jfw _1bsb1jfw _2rko19bv _bfhku67f _syazalr3 _16qs13qd",
            __cmplp.className
        ])
    });
});
const $683cf8d86854d6bb$var$RightArrow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1jfw _1bsb1ul9 _1e0c1txw _4cvr1h6o _1bah1h6o _11c81p5s _1kt9bjq5",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iyAO0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d827f3c4ac5b3696$var$_react = $d827f3c4ac5b3696$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d827f3c4ac5b3696$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d827f3c4ac5b3696$var$PresenceActiveIcon = (props)=>/*#__PURE__*/ $d827f3c4ac5b3696$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="6" fill="currentcolor" fill-rule="evenodd"/></svg>`
    }, props));
$d827f3c4ac5b3696$var$PresenceActiveIcon.displayName = 'PresenceActiveIcon';
var $d827f3c4ac5b3696$var$_default = module.exports.default = $d827f3c4ac5b3696$var$PresenceActiveIcon;

});

parcelRegister("al3cm", function(module, exports) {

$parcel$export(module.exports, "templateIcons", () => $59e51829b880161b$export$59e85fdfb9a6ad0);

var $9lMrf = parcelRequire("9lMrf");

var $aPRJS = parcelRequire("aPRJS");

var $dT90B = parcelRequire("dT90B");

var $kNp5F = parcelRequire("kNp5F");

var $5PBuP = parcelRequire("5PBuP");

var $gyKXQ = parcelRequire("gyKXQ");

var $gYis3 = parcelRequire("gYis3");
const $59e51829b880161b$export$59e85fdfb9a6ad0 = {
    LaunchDarklyIcon: $kNp5F.default,
    SecurityIcon: $5PBuP.default,
    SlackIcon: $gyKXQ.default,
    SoftwareIcon: (0, $dT90B.default),
    TransitionIcon: $gYis3.default,
    UploadIcon: // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    (/*@__PURE__*/$parcel$interopDefault($aPRJS)),
    EditorAddIcon: // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    (/*@__PURE__*/$parcel$interopDefault($9lMrf))
};

});
parcelRegister("dT90B", function(module, exports) {

$parcel$export(module.exports, "default", () => $c91f8566c4c1abe1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $h77XT = parcelRequire("h77XT");
// Because this is a logo it should be presented on white and design tokens are not used
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $c91f8566c4c1abe1$var$JiraGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h77XT.SVG), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        "clip-path": "url(#clip0_1159_30547)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M20.2546 3H11.0742C11.0742 5.24582 12.9315 7.07382 15.2134 7.07382H16.9115V8.66678C16.9115 10.9126 18.7688 12.7406 21.0506 12.7406V3.78343C21.0506 3.33948 20.7057 3 20.2546 3Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M15.7175 7.4917H6.53711C6.53711 9.73752 8.39442 11.5655 10.6763 11.5655H12.3744V13.1846C12.3744 15.4304 14.2317 17.2584 16.5135 17.2584V8.27513C16.5135 7.8573 16.1686 7.4917 15.7175 7.4917Z",
        fill: "url(#paint0_linear_1159_30547)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11.1804 12.0093H2C2 14.2551 3.85731 16.0831 6.13915 16.0831H7.83726V17.6761C7.83726 19.9219 9.69457 21.7499 11.9764 21.7499V12.7927C11.9764 12.3488 11.605 12.0093 11.1804 12.0093Z",
        fill: "url(#paint1_linear_1159_30547)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint0_linear_1159_30547",
        x1: "16.3182",
        y1: "7.51424",
        x2: "12.479",
        y2: "11.5369",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.176",
        "stop-color": "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        "stop-color": "#0C66E4"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint1_linear_1159_30547",
        x1: "12.0362",
        y1: "12.0393",
        x2: "7.59319",
        y2: "16.4316",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.176",
        "stop-color": "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        "stop-color": "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "clip0_1159_30547"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));
/* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ const $c91f8566c4c1abe1$var$JiraIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h77XT.default), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c91f8566c4c1abe1$var$JiraGlyph, null)
    });
var $c91f8566c4c1abe1$export$2e2bcd8739ae039 = $c91f8566c4c1abe1$var$JiraIcon;

});
parcelRegister("h77XT", function(module, exports) {

$parcel$export(module.exports, "default", () => $694f3d02d551890d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "SVG", () => $694f3d02d551890d$export$13f4b12aafeba5d6);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $694f3d02d551890d$var$CustomIcon = (props)=>{
    const { glyph: Glyph, testId: testId, label: label } = props;
    const glyphProps = {
        children: Glyph ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($694f3d02d551890d$export$be58b4326e23250f, {
        "data-testid": testId,
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        ...glyphProps
    });
};
var $694f3d02d551890d$export$2e2bcd8739ae039 = $694f3d02d551890d$var$CustomIcon;
const $694f3d02d551890d$export$13f4b12aafeba5d6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_c71l1osq _p12f1osq _1reo15vq _18m915vq _lcxvglyw _s7n4yfq0",
            __cmplp.className
        ])
    });
});
const $694f3d02d551890d$export$be58b4326e23250f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _1o9zidpf _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});


parcelRegister("kNp5F", function(module, exports) {

$parcel$export(module.exports, "default", () => $096dc7f76c3dd41e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $h77XT = parcelRequire("h77XT");
// Because this is a logo it should be presented on white and design tokens are not used
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $096dc7f76c3dd41e$var$LaunchDarklyGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h77XT.SVG), {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        height: "24px",
        width: "24px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#172B4D",
        fillRule: "nonzero",
        d: "M12.12 21.994a.448.448 0 0 1-.393-.247.422.422 0 0 1 .04-.448l4.654-6.468-8.154 3.365a.422.422 0 0 1-.175.038.44.44 0 0 1-.416-.316.427.427 0 0 1 .184-.485l7.166-4.27-12.62-.732a.435.435 0 0 1-.404-.436c0-.23.177-.42.404-.435l12.627-.732-7.17-4.27a.437.437 0 0 1 .237-.8c.06 0 .12.013.175.037l8.149 3.368-4.654-6.467a.427.427 0 0 1-.041-.45.446.446 0 0 1 .395-.246c.114 0 .223.048.302.131l9.276 9.362a.716.716 0 0 1 0 1.005l-9.28 9.365a.421.421 0 0 1-.302.131Z"
    }));
/* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ const $096dc7f76c3dd41e$var$LaunchDarklyIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h77XT.default), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($096dc7f76c3dd41e$var$LaunchDarklyGlyph, null)
    });
var $096dc7f76c3dd41e$export$2e2bcd8739ae039 = $096dc7f76c3dd41e$var$LaunchDarklyIcon;

});

parcelRegister("5PBuP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1889db2f995005fa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $h77XT = parcelRequire("h77XT");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $1889db2f995005fa$var$SecurityGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h77XT.SVG), {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        height: "24px",
        width: "24px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#000",
        fillRule: "nonzero",
        d: "M10.778 5.04 5.38 7.74l.556 5.007a5.555 5.555 0 0 0 2.293 3.908l2.549 1.82V5.04Zm2.222 0v13.435l2.55-1.82a5.556 5.556 0 0 0 2.292-3.908l.556-5.008L13 5.04ZM3 6.444 11.889 2l8.889 4.444-.728 6.549a7.778 7.778 0 0 1-3.21 5.47l-4.305 3.076a1.111 1.111 0 0 1-1.292 0l-4.306-3.076a7.778 7.778 0 0 1-3.21-5.47L3 6.444Z"
    }));
/* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ const $1889db2f995005fa$var$SecurityIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h77XT.default), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1889db2f995005fa$var$SecurityGlyph, null)
    });
var $1889db2f995005fa$export$2e2bcd8739ae039 = $1889db2f995005fa$var$SecurityIcon;

});

parcelRegister("gyKXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a9988a2c2f3c520$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $h77XT = parcelRequire("h77XT");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $2a9988a2c2f3c520$var$SlackGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h77XT.SVG), {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        height: "24px",
        width: "24px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "none",
        fillRule: "nonzero"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#E01E5A",
        d: "M6.258 14.613c0 1.145-.935 2.081-2.08 2.081a2.086 2.086 0 0 1-2.081-2.08c0-1.146.935-2.081 2.08-2.081h2.081v2.08ZM7.306 14.613c0-1.145.936-2.08 2.081-2.08s2.08.935 2.08 2.08v5.21c0 1.145-.935 2.08-2.08 2.08a2.086 2.086 0 0 1-2.08-2.08v-5.21Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#36C5F0",
        d: "M9.387 6.258a2.086 2.086 0 0 1-2.08-2.08c0-1.146.935-2.081 2.08-2.081s2.08.935 2.08 2.08v2.081h-2.08ZM9.387 7.306c1.145 0 2.08.936 2.08 2.081s-.935 2.08-2.08 2.08h-5.21a2.086 2.086 0 0 1-2.08-2.08c0-1.145.935-2.08 2.08-2.08h5.21Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#2EB67D",
        d: "M17.742 9.387c0-1.145.936-2.08 2.08-2.08 1.146 0 2.082.935 2.082 2.08s-.936 2.08-2.081 2.08h-2.08v-2.08ZM16.693 9.387c0 1.145-.935 2.08-2.08 2.08a2.086 2.086 0 0 1-2.081-2.08v-5.21c0-1.145.935-2.08 2.08-2.08 1.146 0 2.081.935 2.081 2.08v5.21Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#ECB22E",
        d: "M14.613 17.742c1.145 0 2.081.936 2.081 2.08 0 1.146-.936 2.082-2.08 2.082a2.086 2.086 0 0 1-2.081-2.081v-2.08h2.08ZM14.613 16.693a2.086 2.086 0 0 1-2.08-2.08c0-1.146.935-2.081 2.08-2.081h5.21c1.145 0 2.08.935 2.08 2.08 0 1.146-.935 2.081-2.08 2.081h-5.21Z"
    })));
/* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ const $2a9988a2c2f3c520$var$SlackIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h77XT.default), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a9988a2c2f3c520$var$SlackGlyph, null)
    });
var $2a9988a2c2f3c520$export$2e2bcd8739ae039 = $2a9988a2c2f3c520$var$SlackIcon;

});

parcelRegister("gYis3", function(module, exports) {

$parcel$export(module.exports, "default", () => $54c60324bc0ad48a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $h77XT = parcelRequire("h77XT");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $54c60324bc0ad48a$var$TransitionGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h77XT.SVG), {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        height: "24px",
        width: "24px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "#000",
        fillRule: "nonzero"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM19 16a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10 4a3 3 0 0 1 2.995 2.824L13 7v10a1 1 0 0 0 .883.993L14 18h3v2h-3a3 3 0 0 1-2.995-2.824L11 17V7a1 1 0 0 0-.883-.993L10 6H7V4h3Z"
    })));
/* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ const $54c60324bc0ad48a$var$TransitionIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h77XT.default), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($54c60324bc0ad48a$var$TransitionGlyph, null)
    });
var $54c60324bc0ad48a$export$2e2bcd8739ae039 = $54c60324bc0ad48a$var$TransitionIcon;

});



parcelRegister("6Jatd", function(module, exports) {

$parcel$export(module.exports, "findHighestPriorityTemplate", () => $55ee6ddbe8599deb$export$e6e3175570d5e4e);

var $c4l9J = parcelRequire("c4l9J");
const $55ee6ddbe8599deb$export$e6e3175570d5e4e = (templates)=>{
    const templateMap = Object.fromEntries(templates.map((template)=>[
            template.id.value,
            template
        ]));
    const templateId = (0, $c4l9J.templateRecommendationPriority).find((id)=>templateMap[id]);
    return templateId ? templateMap[templateId] : null;
};

});


parcelRegister("1f7yD", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1aaacaa2160f00c$export$2e2bcd8739ae039);
/* styled.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ehatR = parcelRequire("ehatR");
const $b1aaacaa2160f00c$var$SkeletonLine = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1aaacaa2160f00c$var$SkeletonContainer, {
        "data-testid": "automation-menu.common.ui.skeleton.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehatR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1aaacaa2160f00c$var$SkeletonIcon, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1aaacaa2160f00c$var$SkeletonText, null));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b1aaacaa2160f00c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1aaacaa2160f00c$var$SkeletonLine, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1aaacaa2160f00c$var$SkeletonLine, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1aaacaa2160f00c$var$SkeletonLine, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1aaacaa2160f00c$var$SkeletonLine, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1aaacaa2160f00c$var$SkeletonLine, null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b1aaacaa2160f00c$var$SkeletonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s813su _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $b1aaacaa2160f00c$var$SkeletonIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i7vkz _1e0c1o8l _2rkoyh40 _bfhk1r31 _19itj1ic _tzy4nh7s",
            __cmplp.className
        ])
    });
});
const $b1aaacaa2160f00c$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b1aaacaa2160f00c$var$SkeletonText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbp3fh _4t3i7vkz _19pk1b66 _18u0utpp _5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ehatR", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d70fc458c66b77$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $00d70fc458c66b77$var$MenuIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o _2rko1y44",
            __cmplp.className
        ])
    });
});
var $00d70fc458c66b77$export$2e2bcd8739ae039 = $00d70fc458c66b77$var$MenuIcon;

});



parcelRegister("btB4j", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd6eb028e3c61c3b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eae50 = parcelRequire("eae50");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $isuse = parcelRequire("isuse");

var $1f7yD = parcelRequire("1f7yD");

var $kBike = parcelRequire("kBike");

var $cIflZ = parcelRequire("cIflZ");

var $kRcYM = parcelRequire("kRcYM");

var $2OBLh = parcelRequire("2OBLh");
// Component is responsible for triggering the ManualRulesContainer HOC to fetch the rules
// when this mounts. This is how we ensure lazy load behaviour of the menu.
const $dd6eb028e3c61c3b$var$FetchRulesContainer = (props)=>{
    const { triggerFetch: triggerFetch, children: children } = props;
    (0, $5uXOq.useEffect)(()=>{
        triggerFetch();
    // Ignore exhaustive dep here to ensure no call to useEffect on re-render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $dd6eb028e3c61c3b$export$1d156886dc7aaa5b = 50;
const $dd6eb028e3c61c3b$var$ManualRules = (props)=>{
    const { triggerFetch: triggerFetch, initialised: initialised, error: error, rules: rules, executeRule: executeRule, setClosed: setClosed, executingRuleId: executingRuleId, selectedIssueIds: selectedIssueIds, recommendations: recommendations } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [canManageAutomations] = (0, $kBike.useCanManageAutomations)();
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2OBLh.ErrorStateContainer), {
        canManageAutomations: canManageAutomations
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: (event)=>(0, $8zOmE.fireOperationalAnalyticsDeferred)(event, 'ruleErrorState mounted')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eae50.default), {
        header: formatMessage((0, $cIflZ.default).errorHeader),
        description: formatMessage((0, $cIflZ.default).errorDescription),
        maxImageHeight: (0, $2OBLh.errorImageHeight)
    }));
    if (selectedIssueIds && selectedIssueIds.length > $dd6eb028e3c61c3b$export$1d156886dc7aaa5b && (0, $4R6GH.fg)('selected-issue-id-limit')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "selectedIssuesLimitExceeded",
        attributes: {
            selectedIssueCount: selectedIssueIds.length
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2OBLh.ErrorStateContainer), {
        canManageAutomations: canManageAutomations
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eae50.default), {
        header: formatMessage((0, $cIflZ.default).issueSelectionLimitExceededHeader),
        description: formatMessage((0, $cIflZ.default).issueSelectionLimitExceededDescription, {
            limit: $dd6eb028e3c61c3b$export$1d156886dc7aaa5b
        }),
        maxImageHeight: (0, $2OBLh.errorImageHeight)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd6eb028e3c61c3b$var$FetchRulesContainer, {
        triggerFetch: triggerFetch
    }, initialised ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kRcYM.default), {
        rules: rules,
        executingRuleId: executingRuleId,
        executeRule: executeRule,
        selectedIssueIds: selectedIssueIds,
        recommendations: recommendations,
        setClosed: setClosed
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1f7yD.default), null)));
};
var $dd6eb028e3c61c3b$export$2e2bcd8739ae039 = $dd6eb028e3c61c3b$var$ManualRules;

});
parcelRegister("eae50", function(module, exports) {

$parcel$export(module.exports, "default", () => $da809c0c454ce05f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $co1wz = parcelRequire("co1wz");

var $az4zD = parcelRequire("az4zD");

var $lB1Xg = parcelRequire("lB1Xg");

var $9Le4I = parcelRequire("9Le4I");

var $63TJV = parcelRequire("63TJV");
function $da809c0c454ce05f$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($lB1Xg))) : (0, (/*@__PURE__*/$parcel$interopDefault($9Le4I)));
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if ((0, $co1wz.ff)('jfe-asset-consolidation-itsm-agni_po996')) {
        if (renderErrorImage) imageUrl = undefined;
        else imageUrl = fallbackImage;
    } else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        testId: "common-components-error-state.empty-state",
        size: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage
    });
}
$da809c0c454ce05f$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $63TJV.default).retry
};
var $da809c0c454ce05f$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($da809c0c454ce05f$export$edf27be85e5f6da0);

});
parcelRegister("lB1Xg", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("9Le4I", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("63TJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbeb04399739f055$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cbeb04399739f055$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("cIflZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4845bc7e0af88c7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a4845bc7e0af88c7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorHeader: {
        "id": "automation-menu.popup.run-rule.manual-rules.error-header",
        "defaultMessage": "We're having some trouble"
    },
    errorDescription: {
        "id": "automation-menu.popup.run-rule.manual-rules.error-description",
        "defaultMessage": "It's taking us longer than expected to show this content. It's probably a temporary problem. Try refreshing or navigating to another page."
    },
    issueSelectionLimitExceededHeader: {
        "id": "automation-menu.popup.run-rule.manual-rules.issue-selection-limit-exceeded-header",
        "defaultMessage": "Too many issues selected"
    },
    issueSelectionLimitExceededDescription: {
        "id": "automation-menu.popup.run-rule.manual-rules.issue-selection-limit-exceeded-description",
        "defaultMessage": "The maximum amount of issues you can select on a board is {limit, number}. Please deselect some issues and try again."
    }
});

});

parcelRegister("kRcYM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e62bc5491b5d974$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7ymNM = parcelRequire("7ymNM");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");

var $hdfW8 = parcelRequire("hdfW8");

var $27KWI = parcelRequire("27KWI");

var $kBike = parcelRequire("kBike");

var $7Fexc = parcelRequire("7Fexc");

var $2DY8U = parcelRequire("2DY8U");

var $6qr2W = parcelRequire("6qr2W");

var $jcsnO = parcelRequire("jcsnO");
const $6e62bc5491b5d974$var$RuleList = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { rules: rules, executingRuleId: executingRuleId, executeRule: executeRule, setClosed: setClosed, selectedIssueIds: selectedIssueIds, recommendations: recommendations } = props;
    const [canManageAutomations] = (0, $kBike.useCanManageAutomations)();
    const [baseAutomationUrl] = (0, $kBike.useBaseAutomationUrl)();
    if (rules.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hdfW8.ConditionalRecommendation), {
        canManageAutomations: canManageAutomations,
        baseAutomationUrl: baseAutomationUrl,
        recommendations: recommendations,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Fexc.default), null),
        setClosed: setClosed
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jcsnO.RulesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: (event)=>(0, $8zOmE.fireOperationalAnalyticsDeferred)(event, 'ruleList mounted')
    }), rules.map((rule)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6qr2W.default), {
            key: `manual-rule-${rule.id}`,
            rule: rule,
            isExecuting: rule.id === executingRuleId,
            executeRule: executeRule,
            selectedIssueIds: selectedIssueIds
        })), canManageAutomations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $27KWI.default), {
        itemKey: "CREATE_MANUAL_RULE",
        href: `${baseAutomationUrl}#rule/new?componentFilterCriteria=QUICK_ACTIONS`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jcsnO.AddIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ymNM))), {
            size: "small",
            label: ""
        }))
    }, formatMessage((0, $2DY8U.default).createManualRule))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hdfW8.ConditionalRecommendation), {
        canManageAutomations: canManageAutomations,
        baseAutomationUrl: baseAutomationUrl,
        recommendations: recommendations,
        setClosed: setClosed
    }));
};
var $6e62bc5491b5d974$export$2e2bcd8739ae039 = $6e62bc5491b5d974$var$RuleList;

});
parcelRegister("27KWI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5616b0cf2eb85557$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3Z96c = parcelRequire("3Z96c");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");
const $5616b0cf2eb85557$var$LinkItemWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('link', {
    onClick: 'clicked'
})(({ createAnalyticsEvent: createAnalyticsEvent, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), otherProps));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5616b0cf2eb85557$export$2e2bcd8739ae039 = ({ itemKey: itemKey, onClick: onClick, ...otherProps })=>{
    const onClickWithAnalytics = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        onClick && onClick();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'automationMenuLinkItem', {
            itemKey: itemKey
        });
    }, [
        itemKey,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5616b0cf2eb85557$var$LinkItemWithAnalytics, {
        ...otherProps,
        onClick: onClickWithAnalytics
    });
};

});

parcelRegister("7Fexc", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0b693dca48adecf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9UCCQ = parcelRequire("9UCCQ");

var $ha3Dq = parcelRequire("ha3Dq");

var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");

var $kBike = parcelRequire("kBike");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b0b693dca48adecf$export$2e2bcd8739ae039 = ()=>{
    const [canManageAutomations] = (0, $kBike.useCanManageAutomations)();
    const [baseAutomationUrl] = (0, $kBike.useBaseAutomationUrl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: (event)=>(0, $8zOmE.fireOperationalAnalyticsDeferred)(event, 'ruleEmptyState mounted')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ha3Dq.NoRuleForSelectedIssuesEmptyState), {
        baseAutomationUrl: baseAutomationUrl,
        canManageAutomations: canManageAutomations
    })));
};

});
parcelRegister("ha3Dq", function(module, exports) {

$parcel$export(module.exports, "NoRuleForSelectedIssuesEmptyState", () => $76b4cb49ebd7ceef$export$7738f307426350cb);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $c4l9J = parcelRequire("c4l9J");

var $8Xv4X = parcelRequire("8Xv4X");

var $nK22f = parcelRequire("nK22f");
const $76b4cb49ebd7ceef$export$7738f307426350cb = (props)=>{
    const { baseAutomationUrl: baseAutomationUrl, canManageAutomations: canManageAutomations } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($76b4cb49ebd7ceef$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($76b4cb49ebd7ceef$var$EmptyState, null, (0, $8Xv4X.emptyState)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($76b4cb49ebd7ceef$var$Message, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $nK22f.default).noRuleForSelectedIssues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $76b4cb49ebd7ceef$var$buttonContainerStyles
    }, canManageAutomations ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "default",
        href: `${baseAutomationUrl}#rule/new?componentFilterCriteria=QUICK_ACTIONS`,
        onClick: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'button',
                action: 'clicked'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'emptyStateAddRuleButton');
        }
    }, formatMessage((0, $nK22f.default).addRuleCta)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        onClick: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'link',
                action: 'clicked'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu.emptyState.contantYourAdmin', {
                userType: 'endUser'
            });
        },
        href: (0, $c4l9J.AUTOMATION_MORE_DETAILS_URL)
    }, formatMessage((0, $nK22f.default).learnMoreAboutAutomation))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $76b4cb49ebd7ceef$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12fp59q _1e0c1ule _y3gn1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $76b4cb49ebd7ceef$var$EmptyState = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3it9kd _1bsbys9h _1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $76b4cb49ebd7ceef$var$Message = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4utpp _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $76b4cb49ebd7ceef$var$buttonContainerStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});

});
parcelRegister("8Xv4X", function(module, exports) {

$parcel$export(module.exports, "emptyState", () => $b679f47d798806d1$export$252465da46a2ae40);

var $5uXOq = parcelRequire("5uXOq");
const $b679f47d798806d1$export$252465da46a2ae40 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
    width: "80",
    height: "72",
    viewBox: "0 0 80 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
    clipPath: "url(#clip0_1935_27815)"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    width: "80",
    height: "72",
    fill: "var(--ds-surface, white)",
    fillOpacity: "0.01"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M40.6568 71.9811C40.2977 71.9924 39.9385 72 39.5794 72.0038C39.0773 72.0076 38.668 71.6094 38.668 71.1165C38.6641 70.6349 39.0542 70.2367 39.5446 70.2215C39.5523 70.2215 39.5639 70.2215 39.5716 70.2215C41.8617 70.2102 44.1864 69.9675 46.4224 69.501C46.9128 69.3987 47.3956 69.7058 47.4998 70.1874C47.6041 70.669 47.2913 71.143 46.8008 71.2454C44.7889 71.6587 42.7228 71.909 40.6568 71.9811Z",
    fill: "var(--ds-icon-disabled, #B3BAC5)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M34.6674 71.6815C34.6172 71.6815 34.5631 71.6815 34.509 71.6739C32.107 71.3478 29.7359 70.7752 27.4536 69.9713C26.9825 69.8044 26.7353 69.2963 26.9052 68.8298C27.0752 68.3672 27.5965 68.1245 28.0676 68.2914C30.2302 69.0536 32.4777 69.5958 34.7562 69.903C35.2543 69.9713 35.6019 70.4187 35.5324 70.9079C35.4745 71.3478 35.0999 71.6663 34.6674 71.6815Z",
    fill: "var(--ds-icon-disabled, #B3BAC5)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M51.3921 69.9106C51.0098 69.9219 50.6468 69.6982 50.5078 69.3266C50.334 68.864 50.5735 68.352 51.0446 68.1814C53.1994 67.4002 55.2771 66.3953 57.2273 65.197C57.652 64.9354 58.212 65.0605 58.4785 65.4776C58.7449 65.8948 58.6175 66.4446 58.1927 66.7063C56.1382 67.969 53.9448 69.0308 51.6779 69.8537C51.5814 69.8916 51.4887 69.9068 51.3921 69.9106Z",
    fill: "var(--ds-icon-disabled, #B3BAC5)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M23.2668 68.0563C23.1124 68.06 22.954 68.0297 22.8112 67.9539C20.6756 66.839 18.6443 65.5004 16.783 63.9798C16.3968 63.665 16.3427 63.1038 16.6633 62.7246C16.9838 62.3454 17.5553 62.2923 17.9415 62.6071C19.7102 64.0518 21.6333 65.3184 23.6607 66.3764C24.1048 66.6077 24.2709 67.1462 24.0353 67.5822C23.877 67.878 23.5796 68.0487 23.2668 68.0563Z",
    fill: "var(--ds-icon-disabled, #B3BAC5)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M13.8216 60.821C13.5629 60.8286 13.3003 60.73 13.1149 60.529C11.4891 58.7619 10.0448 56.8279 8.82451 54.7764C8.56964 54.3517 8.71638 53.8056 9.1489 53.5554C9.58141 53.3051 10.1375 53.4492 10.3924 53.8739C11.5509 55.8192 12.9218 57.6546 14.4627 59.3307C14.7986 59.6947 14.7716 60.2598 14.397 60.5897C14.231 60.7376 14.0263 60.8134 13.8216 60.821Z",
    fill: "var(--ds-icon-disabled, #B3BAC5)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M69.3952 54.9281C69.233 54.9319 69.0631 54.8978 68.9125 54.8106C68.4761 54.5641 68.3255 54.0218 68.5765 53.5933C69.7196 51.6328 70.658 49.551 71.3647 47.4084C71.5192 46.9382 72.0328 46.6842 72.5078 46.8358C72.9867 46.9875 73.2454 47.4919 73.0909 47.9583C72.3456 50.2184 71.3531 52.4102 70.1483 54.4769C69.9899 54.7575 69.7003 54.9167 69.3952 54.9281Z",
    fill: "var(--ds-icon-disabled, #B3BAC5)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M7.45285 50.863C7.08213 50.8744 6.72685 50.662 6.5801 50.3056C5.66873 48.1024 4.98906 45.8006 4.5604 43.4571C4.47158 42.9717 4.79983 42.5091 5.29414 42.4219C5.78844 42.3346 6.25957 42.657 6.34839 43.1424C6.75774 45.3645 7.40265 47.5487 8.26382 49.6382C8.45305 50.0932 8.22907 50.6165 7.76179 50.7985C7.66139 50.8365 7.55712 50.8592 7.45285 50.863Z",
    fill: "var(--ds-icon-disabled, #B3BAC5)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M73.4469 43.8515C73.3851 43.8553 73.3233 43.8515 73.2616 43.8401C72.7673 43.7567 72.4351 43.2978 72.5201 42.8124C72.9063 40.5979 73.0569 38.3264 72.9758 36.0626L72.9719 35.9867C72.9526 35.4937 73.3465 35.0804 73.8485 35.0652C74.3506 35.0463 74.7715 35.4331 74.7869 35.926L74.7908 36.0019C74.8758 38.3871 74.7136 40.7799 74.3081 43.1158C74.2347 43.5367 73.8679 43.8363 73.4469 43.8515Z",
    fill: "var(--ds-icon-disabled, #B3BAC5)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M4.95089 39.3389C4.44886 39.3579 4.02793 38.99 4.01249 38.4971V38.4591C3.92753 36.0853 4.08586 33.7039 4.48748 31.3831C4.57244 30.8978 5.03971 30.5716 5.53401 30.6513C6.02832 30.7347 6.36043 31.1935 6.27933 31.6789C5.90088 33.8821 5.74641 36.1422 5.82751 38.3909C5.84682 38.8877 5.45292 39.3199 4.95089 39.3389Z",
    fill: "var(--ds-icon-disabled, #B3BAC5)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M73.3733 32.0164C72.9292 32.0316 72.5315 31.7244 72.4504 31.2846C72.0371 29.0624 71.3922 26.8782 70.5272 24.7925C70.338 24.3375 70.562 23.8142 71.0254 23.6284C71.4888 23.4426 72.0217 23.6625 72.2109 24.1176C73.1223 26.317 73.8058 28.6225 74.2383 30.966C74.3272 31.4514 74.0028 31.9141 73.5085 32.0051C73.4621 32.0089 73.4197 32.0126 73.3733 32.0164Z",
    fill: "var(--ds-icon-disabled, #B3BAC5)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M6.59195 27.7011C6.48769 27.7049 6.38342 27.6897 6.27915 27.6594C5.8003 27.5077 5.54156 27.0033 5.69603 26.5369C6.44135 24.2768 7.42609 22.0812 8.63096 20.0145C8.87811 19.586 9.4342 19.4382 9.87058 19.6808C10.307 19.9235 10.4576 20.4696 10.2104 20.8981C9.0712 22.8586 8.13279 24.9404 7.42609 27.0868C7.30252 27.4508 6.96268 27.6897 6.59195 27.7011Z",
    fill: "var(--ds-icon-disabled, #B3BAC5)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M69.2106 20.9929C68.8862 21.0043 68.5696 20.845 68.3958 20.553C67.2334 18.6115 65.8625 16.7761 64.3178 15.1C63.9818 14.736 64.0088 14.1709 64.3834 13.841C64.7542 13.5111 65.3296 13.5377 65.6655 13.9055C67.2952 15.6726 68.7395 17.6028 69.9637 19.6505C70.2185 20.0752 70.0718 20.6213 69.6393 20.8715C69.5041 20.9474 69.3574 20.9853 69.2106 20.9929Z",
    fill: "var(--ds-icon-disabled, #B3BAC5)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M12.2073 17.307C12.0026 17.3146 11.7941 17.2539 11.6165 17.1174C11.2226 16.814 11.1492 16.2528 11.4581 15.866C12.9488 13.9889 14.6363 12.2597 16.4823 10.7202C16.8646 10.4016 17.4361 10.4471 17.7644 10.8226C18.0887 11.198 18.0424 11.7592 17.6601 12.0815C15.9107 13.5415 14.3042 15.1872 12.8908 16.9657C12.7209 17.1818 12.466 17.2994 12.2073 17.307Z",
    fill: "var(--ds-icon-disabled, #B3BAC5)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M61.4486 12.0322C61.2324 12.0398 61.0161 11.9716 60.8385 11.8275C59.0659 10.3865 57.1428 9.11993 55.1115 8.06195C54.6674 7.83063 54.4975 7.29216 54.7331 6.85607C54.9686 6.41998 55.517 6.25692 55.9611 6.48445C58.0966 7.59552 60.1279 8.93033 61.9931 10.4509C62.3793 10.7657 62.4334 11.3269 62.1129 11.7061C61.9429 11.9109 61.6958 12.0209 61.4486 12.0322Z",
    fill: "var(--ds-icon-disabled, #B3BAC5)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M21.0928 9.41569C20.78 9.42707 20.4711 9.27918 20.2896 8.99857C20.0231 8.58144 20.1505 8.03159 20.5753 7.76994C22.6298 6.50338 24.8194 5.44161 27.0901 4.61493C27.5612 4.44429 28.0826 4.6794 28.2564 5.14203C28.4301 5.60466 28.1907 6.11659 27.7196 6.28724C25.5686 7.0684 23.491 8.07709 21.5408 9.27918C21.4018 9.3664 21.2473 9.4119 21.0928 9.41569Z",
    fill: "var(--ds-icon-disabled, #B3BAC5)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M51.0371 6.20383C50.9251 6.20762 50.8092 6.19246 50.7011 6.15074C48.5385 5.39233 46.2871 4.85386 44.0087 4.5467C43.5105 4.47844 43.163 4.03098 43.2325 3.5418C43.302 3.05262 43.7615 2.71134 44.2558 2.77959C46.6579 3.10192 49.029 3.67073 51.3113 4.47086C51.7824 4.63771 52.0295 5.14585 51.8596 5.61227C51.7322 5.96493 51.3962 6.19246 51.0371 6.20383Z",
    fill: "var(--ds-icon-disabled, #B3BAC5)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M32.1911 4.99037C31.7586 5.00554 31.3647 4.71355 31.272 4.28505C31.1677 3.80346 31.4805 3.32945 31.971 3.22706C34.3305 2.73409 36.7789 2.47623 39.1886 2.45727C39.6906 2.45348 40.1 2.85165 40.1038 3.34462C40.1077 3.83 39.7176 4.22438 39.2272 4.24334C39.2195 4.24334 39.2079 4.24334 39.2002 4.24334C36.9102 4.25471 34.5854 4.50499 32.3494 4.97141C32.2954 4.98279 32.2413 4.98658 32.1911 4.99037Z",
    fill: "var(--ds-icon-disabled, #B3BAC5)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M73.6824 12.9651C73.5858 12.9385 73.5202 12.8513 73.5318 12.7527C73.5395 12.6958 73.5472 12.639 73.5549 12.5821C73.5742 12.4721 73.5974 12.3546 73.6283 12.2332C73.7442 11.7971 73.9566 11.4065 74.2616 11.0615C74.5667 10.7164 75.007 10.4282 75.5746 10.2045L76.5323 9.82146C77.1039 9.59773 77.4553 9.22611 77.5943 8.71418C77.6445 8.52837 77.66 8.33876 77.6407 8.14158C77.6214 7.94439 77.5634 7.75858 77.4592 7.58793C77.3549 7.41729 77.212 7.26182 77.0228 7.1253C76.8336 6.98879 76.6019 6.8864 76.3238 6.81435C76.0226 6.73851 75.7561 6.72713 75.5167 6.78022C75.2773 6.83331 75.0649 6.92811 74.8795 7.06084C74.6941 7.19356 74.5397 7.3642 74.4161 7.56897C74.2887 7.77374 74.196 7.99369 74.1342 8.22121C74.1149 8.28947 74.0994 8.35772 74.0879 8.4184C74.0531 8.59662 73.8716 8.7028 73.694 8.64971L72.2149 8.20604C72.0759 8.16433 71.9793 8.03161 71.9948 7.8913C71.9986 7.84579 72.0064 7.80029 72.0141 7.75479C72.0373 7.62585 72.0643 7.50451 72.0952 7.38316C72.211 6.94707 72.408 6.54132 72.686 6.16591C72.9641 5.79049 73.3078 5.48334 73.7171 5.24444C74.1265 5.00554 74.5899 4.85006 75.1151 4.77422C75.6403 4.69838 76.2118 4.74388 76.8336 4.90315C77.4785 5.07 78.0191 5.3089 78.4555 5.61985C78.8957 5.9308 79.2394 6.27967 79.4904 6.66267C79.7415 7.04946 79.8998 7.459 79.9616 7.89509C80.0234 8.33118 80.0002 8.75589 79.8882 9.16923C79.7144 9.82146 79.4132 10.341 78.9923 10.7278C78.5675 11.1146 78.0616 11.4179 77.4669 11.6341L76.6598 11.9336C76.4319 12.0057 76.0921 12.1536 75.8102 12.4569C75.7832 12.4873 75.6673 12.6124 75.5515 12.8058C75.4665 12.9499 75.4047 13.0902 75.3622 13.2116C75.3275 13.3102 75.2194 13.3633 75.1189 13.3367L73.6824 12.9651ZM72.5007 15.191C72.5972 14.8308 72.8058 14.5578 73.1301 14.3682C73.4545 14.1785 73.7982 14.1293 74.1651 14.2241C74.532 14.3189 74.81 14.5274 75.0031 14.8497C75.1962 15.1721 75.2425 15.5134 75.146 15.8736C75.0494 16.2338 74.837 16.5031 74.5088 16.6889C74.1805 16.8709 73.833 16.9164 73.47 16.8216C73.1031 16.7268 72.8251 16.522 72.6397 16.2073C72.4505 15.8888 72.4041 15.5513 72.5007 15.191Z",
    fill: "var(--ds-background-accent-gray-subtler, #C1C7D0)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M7.14805 8.0847C7.05537 8.05436 6.99358 7.95956 7.01289 7.86476C7.02447 7.80788 7.03606 7.751 7.04764 7.69412C7.07468 7.58415 7.10557 7.47038 7.14805 7.35283C7.2948 6.92433 7.53036 6.54891 7.86247 6.22659C8.19072 5.90047 8.64641 5.6464 9.23339 5.4568L10.2143 5.13826C10.7974 4.95245 11.1759 4.60737 11.3496 4.10303C11.4114 3.92101 11.4423 3.73141 11.4346 3.53422C11.4307 3.33703 11.3805 3.14743 11.2917 2.9692C11.2029 2.79097 11.0677 2.62791 10.8862 2.48002C10.7086 2.33213 10.4807 2.21458 10.2104 2.12357C9.91692 2.02497 9.6466 1.99843 9.40717 2.03635C9.16388 2.07427 8.94763 2.1539 8.75454 2.27525C8.56145 2.3966 8.39539 2.55586 8.25637 2.75305C8.10963 2.95024 8.0015 3.1626 7.92426 3.38633C7.90109 3.45458 7.88178 3.51905 7.86634 3.57972C7.81999 3.75416 7.63077 3.84896 7.45699 3.78449L6.0127 3.24602C5.87753 3.19672 5.79258 3.05642 5.81575 2.91611C5.82347 2.87061 5.83506 2.8251 5.84664 2.7796C5.87753 2.65446 5.91229 2.53311 5.95477 2.41556C6.10152 1.98705 6.3255 1.59647 6.63058 1.24002C6.93565 0.883562 7.29866 0.599157 7.71959 0.386801C8.14438 0.174445 8.61938 0.049307 9.14457 0.0113863C9.67363 -0.0265344 10.2413 0.0530991 10.8476 0.254079C11.4771 0.462642 12.0023 0.735671 12.4193 1.07696C12.8364 1.41824 13.1569 1.78607 13.3809 2.18803C13.6049 2.58999 13.7362 3.00712 13.7671 3.447C13.798 3.88688 13.7439 4.3078 13.6049 4.71355C13.3848 5.35441 13.0527 5.85117 12.6008 6.20763C12.1529 6.56408 11.6238 6.83332 11.0175 7.01154L10.1911 7.25424C9.9594 7.31112 9.60798 7.43626 9.30677 7.72066C9.27587 7.751 9.1523 7.86855 9.02486 8.05057C8.92832 8.19088 8.8588 8.3236 8.8086 8.44115C8.76998 8.53596 8.65799 8.58525 8.55759 8.55112L7.14805 8.0847ZM5.81575 10.2272C5.93546 9.87456 6.1633 9.6129 6.49928 9.44605C6.83525 9.2792 7.18281 9.25266 7.54195 9.37021C7.90109 9.48777 8.16369 9.71529 8.33361 10.049C8.50352 10.3827 8.52669 10.7278 8.40698 11.0804C8.28727 11.4331 8.05556 11.691 7.71573 11.8502C7.37589 12.0095 7.02834 12.0322 6.66919 11.9147C6.31005 11.7971 6.04745 11.5734 5.8814 11.2435C5.7192 10.9212 5.69603 10.5799 5.81575 10.2272Z",
    fill: "var(--ds-background-accent-gray-subtler, #C1C7D0)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M4.78519 68.4013C4.69251 68.4355 4.58438 68.4013 4.53804 68.3141C4.51101 68.2648 4.48397 68.2117 4.45694 68.1586C4.40674 68.0563 4.3604 67.9463 4.31406 67.8325C4.15572 67.4116 4.0978 66.9717 4.148 66.5167C4.1982 66.0616 4.38743 65.58 4.7234 65.0719L5.28336 64.2187C5.61933 63.7143 5.6927 63.21 5.50348 62.7132C5.43396 62.535 5.33742 62.3682 5.20612 62.2165C5.07482 62.0648 4.92035 61.9472 4.73499 61.8638C4.54962 61.7804 4.34109 61.7387 4.10552 61.7311C3.86996 61.7273 3.61894 61.7728 3.35248 61.8714C3.06285 61.9776 2.83501 62.1179 2.66895 62.2999C2.5029 62.4781 2.38704 62.6753 2.31367 62.8877C2.2403 63.1 2.21326 63.3275 2.22871 63.5664C2.24416 63.8053 2.29436 64.0367 2.37932 64.2604C2.40635 64.3287 2.42952 64.3893 2.45655 64.4462C2.53379 64.6093 2.44497 64.8027 2.27119 64.8595L0.803726 65.3298C0.664703 65.3753 0.510233 65.3184 0.440722 65.1932C0.417551 65.1515 0.398243 65.1098 0.375072 65.0681C0.317146 64.9505 0.266943 64.833 0.224464 64.7192C0.0661322 64.2983 -0.0111028 63.8546 -0.00337928 63.3882C0.00434421 62.9218 0.10475 62.4781 0.301699 62.0534C0.494786 61.6287 0.784418 61.2381 1.17059 60.8817C1.55677 60.5252 2.05107 60.237 2.6535 60.0209C3.27911 59.7933 3.85837 59.6834 4.39901 59.6909C4.93966 59.6985 5.42624 59.7895 5.85876 59.9602C6.29127 60.1346 6.65814 60.3811 6.96322 60.7034C7.26829 61.0258 7.49614 61.386 7.64675 61.788C7.88617 62.4212 7.9441 63.0166 7.82439 63.5702C7.70467 64.1239 7.46524 64.6586 7.1061 65.1743L6.61952 65.8758C6.47664 66.0654 6.28355 66.3764 6.22948 66.7821C6.22562 66.8238 6.20245 66.9907 6.22176 67.2106C6.23721 67.3775 6.2681 67.5254 6.30672 67.6467C6.33761 67.7453 6.27969 67.8515 6.17928 67.8894L4.78519 68.4013ZM5.12116 70.8889C4.98986 70.5401 5.00145 70.1988 5.15592 69.8575C5.31039 69.52 5.56526 69.2849 5.92054 69.156C6.27583 69.027 6.62724 69.0422 6.97094 69.1977C7.3185 69.3531 7.55793 69.6072 7.68922 69.9561C7.82052 70.3049 7.80508 70.6462 7.64288 70.9799C7.48069 71.3136 7.22195 71.545 6.87053 71.6739C6.51525 71.8028 6.1677 71.7914 5.82786 71.6398C5.48803 71.4881 5.25246 71.2378 5.12116 70.8889Z",
    fill: "var(--ds-background-accent-gray-subtler, #C1C7D0)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M57.6792 50.6582L54.9181 48.0303L51.1992 51.8034L53.9604 54.4313C54.6671 55.1025 55.1614 55.9558 55.3931 56.8924C55.6248 57.829 56.1229 58.6823 56.8258 59.3534L68.0364 70.0092C69.7356 71.6246 72.4427 71.5791 74.0878 69.9144C75.7329 68.2458 75.6866 65.5876 73.9913 63.9722L62.7806 53.3165C62.0739 52.6453 61.1896 52.1864 60.228 51.9893C59.2703 51.7883 58.3859 51.3256 57.6792 50.6582Z",
    fill: "var(--ds-background-accent-gray-subtler, #CFD4DB)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M60.1198 51.9551C59.2046 51.7466 58.3588 51.2991 57.683 50.6544L56.8412 49.8543C55.7792 48.8456 54.0878 48.8722 53.0605 49.915C52.0333 50.9578 52.0603 52.6187 53.1223 53.6274L53.9642 54.4275C54.64 55.0722 55.1227 55.8837 55.366 56.7748C56.2735 56.0998 57.1308 55.3528 57.9379 54.5337C58.7373 53.726 59.4633 52.8614 60.1198 51.9551Z",
    fill: "var(--ds-icon-disabled, #B3BAC5)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M39.3701 59.1563C33.396 59.2511 27.7424 57.0555 23.452 52.9752C14.5893 44.553 14.3614 30.621 22.9384 21.9182C27.0936 17.7052 32.6738 15.3313 38.6441 15.2327C44.6182 15.1379 50.2718 17.3336 54.5622 21.4138C58.8565 25.4941 61.2701 30.9736 61.3705 36.8362C61.467 42.7025 59.2311 48.2541 55.0758 52.4671C50.9245 56.6876 45.3442 59.0615 39.3701 59.1563ZM38.7329 20.4772C34.1838 20.5492 29.9397 22.358 26.7731 25.5661C20.2429 32.1909 20.4166 42.7973 27.1631 49.2097C30.4302 52.3154 34.736 53.9877 39.2852 53.9156C43.8343 53.8436 48.0784 52.0348 51.245 48.8267C54.4078 45.6186 56.1108 41.3904 56.0374 36.9234C55.964 32.4563 54.122 28.2888 50.855 25.1793C47.5841 22.0774 43.2821 20.4051 38.7329 20.4772Z",
    fill: "url(#paint0_linear_1935_27815)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M45.9242 32.316L43.862 30.3252C43.5569 30.0332 43.0703 30.037 42.7691 30.3365L38.9885 34.1172L35.1383 30.4048C34.8332 30.1128 34.3466 30.1166 34.0454 30.4162L32.018 32.4411C31.7207 32.7407 31.7245 33.2185 32.0296 33.5143L35.8798 37.2267L32.0991 41.0074C31.8018 41.307 31.8056 41.7848 32.1107 42.0806L34.1729 44.0714C34.4779 44.3634 34.9645 44.3596 35.2657 44.06L39.0464 40.2793L42.8966 43.9918C43.2016 44.2838 43.6882 44.28 43.9894 43.9804L46.0168 41.9554C46.3142 41.6559 46.3103 41.1781 46.0053 40.8823L42.1551 37.1698L45.9357 33.3892C46.2331 33.0896 46.2292 32.608 45.9242 32.316Z",
    fill: "var(--ds-background-accent-gray-subtler, #C1C7D0)"
})), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
    id: "paint0_linear_1935_27815",
    x1: "23.1941",
    y1: "52.727",
    x2: "54.2487",
    y2: "21.1016",
    gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
    offset: "0.5572",
    stopColor: "var(--ds-background-accent-gray-subtler, #C1C7D0)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
    offset: "0.966",
    stopColor: "var(--ds-background-accent-gray-subtler, #E9EBEF)",
    /* "#E9EBEF" */ stopOpacity: "0.5"
})), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
    id: "clip0_1935_27815"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    width: "80",
    height: "72",
    fill: "var(--ds-surface, white)"
}))));

});

parcelRegister("nK22f", function(module, exports) {

$parcel$export(module.exports, "default", () => $13f76caff4110611$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $13f76caff4110611$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noRuleForSelectedIssues: {
        "id": "automation-platform.no-rule-for-issues-empty-state.no-rule-for-selected-issues",
        "defaultMessage": "Available automations can't be used with the issues you've selected"
    },
    addRuleCta: {
        "id": "automation-platform.no-rule-for-issues-empty-state.add-rule-cta",
        "defaultMessage": "Add a manually triggered automation"
    },
    learnMoreAboutAutomation: {
        "id": "automation-platform.no-rule-for-issues-empty-state.learn-more-about-automation",
        "defaultMessage": "Learn more about Automation"
    }
});

});



parcelRegister("2DY8U", function(module, exports) {

$parcel$export(module.exports, "default", () => $a69fcab250eff39e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a69fcab250eff39e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createManualRule: {
        "id": "automation-menu.popup.run-rule.manual-rules.rule-list.create-manual-rule",
        "defaultMessage": "Add a manually triggered automation"
    }
});

});

parcelRegister("6qr2W", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b3fc400ff1e9739$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $eZJjh = parcelRequire("eZJjh");

var $1noc6 = parcelRequire("1noc6");

var $dXq4S = parcelRequire("dXq4S");

var $koeKL = parcelRequire("koeKL");

var $27KWI = parcelRequire("27KWI");

var $kBike = parcelRequire("kBike");

var $iKM9r = parcelRequire("iKM9r");
const $5b3fc400ff1e9739$var$isRuleDisabled = (rule, isExecuting, noIssuesSelected, crossProjectSelection, projectAri)=>{
    if (isExecuting || noIssuesSelected) return true;
    if (crossProjectSelection) {
        const scopeAris = rule.ruleScope.resources;
        // Disable if we have a cross project selection AND the rule is a SINGLE project rule.
        return scopeAris.length === 1 && scopeAris.includes(projectAri);
    }
    return false;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5b3fc400ff1e9739$export$2e2bcd8739ae039 = ({ isExecuting: isExecuting, rule: rule, executeRule: executeRule, selectedIssueIds: selectedIssueIds })=>{
    const [{ selectedIssuesKeys: selectedIssuesKeys, crossProjectSelection: crossProjectSelection }] = (0, $iKM9r.useSelectedIssues)();
    const [projectAri] = (0, $kBike.useProjectAri)();
    const cloudId = (0, $koeKL.useCloudId)();
    const selectedIssueAris = (selectedIssueIds ?? []).map((id)=>(0, $dXq4S.createAri)({
            resourceOwner: 'jira',
            resourceType: 'issue',
            cloudId: cloudId,
            resourceId: id.toString()
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $27KWI.default), {
        itemKey: "MANUAL_RULE",
        isDisabled: $5b3fc400ff1e9739$var$isRuleDisabled(rule, isExecuting, selectedIssuesKeys.length === 0, crossProjectSelection, projectAri),
        iconBefore: isExecuting ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1noc6.MenuIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "small"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1noc6.TriggerIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            size: "small",
            glyph: (0, $1noc6.ManualTriggerGlyph),
            label: ""
        })),
        onClick: ()=>executeRule(rule.id, selectedIssueAris)
    }, rule.name);
};

});
parcelRegister("1noc6", function(module, exports) {

$parcel$export(module.exports, "ManualTriggerGlyph", () => $6325cb76caa5baa0$export$4514e29f70245d75);
$parcel$export(module.exports, "AutomationGlyphBlack", () => $6325cb76caa5baa0$export$9d08b452ddec60a4);
$parcel$export(module.exports, "MenuIcon", () => $6325cb76caa5baa0$export$46e1d66043f363e6);
$parcel$export(module.exports, "TriggerIcon", () => $6325cb76caa5baa0$export$1cb264166623d4aa);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $17Ngn = parcelRequire("17Ngn");
const $6325cb76caa5baa0$export$4514e29f70245d75 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: 24,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m21.192 19.778-4.9498-4.9498c-0.3905-0.3905-1.0237-0.3905-1.4142 0-0.3905 0.3906-0.3905 1.0237 0 1.4143l4.9498 4.9497c0.3905 0.3905 1.0237 0.3905 1.4142 0s0.3905-1.0237 0-1.4142z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m8.7738 8.1319 11.685 4.305c0.2591 0.0955 0.3917 0.3829 0.2963 0.6421-0.025 0.0679-0.0645 0.1295-0.1156 0.1807l-7.3802 7.3801c-0.1952 0.1953-0.5118 0.1953-0.7071 0-0.0511-0.0512-0.0906-0.1128-0.1156-0.1807l-4.3051-11.685c-0.09546-0.25911 0.03721-0.54656 0.29632-0.64202 0.11157-0.0411 0.23414-0.0411 0.34571 0z",
        clipRule: "evenodd",
        fill: "currentColor",
        fillRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m4.2218 4.2218c1.9526-1.9526 5.1184-1.9526 7.0711 0 0.5977 0.59776 1.0125 1.3092 1.2443 2.0648 0.1974 0.6437-0.4389 1.1502-1.0873 0.96899l-0.2172-0.06069c-0.3475-0.09709-0.6037-0.38008-0.7563-0.70702-0.1439-0.30836-0.3432-0.59728-0.59773-0.85184-1.1716-1.1716-3.0711-1.1716-4.2426 0-1.1716 1.1716-1.1716 3.0711 0 4.2426 0.2547 0.25469 0.54381 0.45399 0.85236 0.59799 0.32725 0.1527 0.61051 0.4091 0.70752 0.7569l0.06045 0.2168c0.18082 0.6483-0.32561 1.2843-0.96914 1.087-0.75578-0.2317-1.4675-0.6466-2.0654-1.2445-1.9526-1.9526-1.9526-5.1184 0-7.071z",
        clipRule: "evenodd",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $6325cb76caa5baa0$export$85ca00d4fc5d86c3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($17Ngn))), {
        size: "small",
        ...props
    });
const $6325cb76caa5baa0$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10.3789 4.62256C9.99914 4.62173 9.65331 4.84087 9.49192 5.18458L6.11523 12.3762C5.97308 12.679 5.9956 13.0334 6.17494 13.3157C6.35428 13.598 6.66553 13.7691 7 13.7691H8.79182L6.40251 18.1304C6.17135 18.5523 6.28163 19.0798 6.66249 19.3738C7.04335 19.6677 7.58152 19.6408 7.93117 19.3103L16.8269 10.902C17.1178 10.6269 17.2117 10.2023 17.0637 9.83032C16.9157 9.45832 16.5558 9.21418 16.1555 9.21418H14.547L17.0353 6.24031C17.2787 5.94947 17.3319 5.5441 17.1717 5.20034C17.0116 4.85658 16.6671 4.63646 16.2879 4.63562L10.3789 4.62256Z",
        stroke: "currentColor",
        strokeWidth: "1.95489",
        strokeLinejoin: "round"
    }));
const $6325cb76caa5baa0$export$fdd32c4638a0c3ae = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10.1838 4.78749C10.2664 4.61167 10.4433 4.49957 10.6375 4.5L17.0011 4.51406C17.1951 4.51449 17.3713 4.62709 17.4532 4.80294C17.5352 4.97879 17.508 5.18614 17.3835 5.33492L13.9446 9.44482H16.8597C17.0645 9.44482 17.2486 9.5697 17.3243 9.76C17.4 9.95029 17.352 10.1675 17.2032 10.3082L7.62319 19.3634C7.44433 19.5324 7.16903 19.5462 6.97421 19.3958C6.77938 19.2454 6.72297 18.9756 6.84122 18.7598L9.86254 13.2448H7C6.82891 13.2448 6.66969 13.1573 6.57795 13.0129C6.48621 12.8685 6.47469 12.6872 6.54741 12.5323L10.1838 4.78749Z",
        fill: "var(--ds-text-inverse, white)"
    }));
const $6325cb76caa5baa0$export$9d08b452ddec60a4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10.1838 4.78749C10.2664 4.61167 10.4433 4.49957 10.6375 4.5L17.0011 4.51406C17.1951 4.51449 17.3713 4.62709 17.4532 4.80294C17.5352 4.97879 17.508 5.18614 17.3835 5.33492L13.9446 9.44482H16.8597C17.0645 9.44482 17.2486 9.5697 17.3243 9.76C17.4 9.95029 17.352 10.1675 17.2032 10.3082L7.62319 19.3634C7.44433 19.5324 7.16903 19.5462 6.97421 19.3958C6.77938 19.2454 6.72297 18.9756 6.84122 18.7598L9.86254 13.2448H7C6.82891 13.2448 6.66969 13.1573 6.57795 13.0129C6.48621 12.8685 6.47469 12.6872 6.54741 12.5323L10.1838 4.78749Z",
        fill: "var(--ds-text, black)"
    }));
const $6325cb76caa5baa0$export$46e1d66043f363e6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o _2rko1y44",
            __cmplp.className
        ])
    });
});
const $6325cb76caa5baa0$export$1cb264166623d4aa = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $6325cb76caa5baa0$export$46e1d66043f363e6, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syazawfz _bfhkn7zq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("jcsnO", function(module, exports) {

$parcel$export(module.exports, "AddIcon", () => $e67ec1f675dbdd30$export$a6b7c34d56975de0);
$parcel$export(module.exports, "RulesContainer", () => $e67ec1f675dbdd30$export$ad5e22901161325b);
/* styled.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9UCCQ = parcelRequire("9UCCQ");

var $ehatR = parcelRequire("ehatR");
const $e67ec1f675dbdd30$export$a6b7c34d56975de0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $ehatR.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhk10p6 _syazw9a8",
            __cmplp.className
        ])
    });
});
const $e67ec1f675dbdd30$export$ad5e22901161325b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $9UCCQ.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_c71l1feq _1reo1wug _18m91wug",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2OBLh", function(module, exports) {

$parcel$export(module.exports, "errorImageHeight", () => $813d9d6077efcbd3$export$2d8373672f57f277);
$parcel$export(module.exports, "ErrorStateContainer", () => $813d9d6077efcbd3$export$3c552bcab5076086);
/* styled.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9UCCQ = parcelRequire("9UCCQ");

var $gwIPs = parcelRequire("gwIPs");
const $813d9d6077efcbd3$export$2d8373672f57f277 = (0, $gwIPs.gridSize) * 14;
const $813d9d6077efcbd3$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $9UCCQ.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_c71l1feq _1reo1wug _18m91wug",
            __cmplp.className
        ])
    });
});
const $813d9d6077efcbd3$export$3c552bcab5076086 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $813d9d6077efcbd3$export$42a852a2b6b56249, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.canManageAutomations ? "_19pk1stb _2hwx7vkz _otyr1stb _18u07vkz" : "_19pkidpf _2hwx7vkz _otyridpf _18u07vkz",
            __cmplp.className
        ])
    });
});

});


parcelRegister("XHOES", function(module, exports) {

$parcel$export(module.exports, "default", () => $49e6343aa16ac86b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $49e6343aa16ac86b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    automationHeader: {
        "id": "automation-menu.popup.run-rule.automation-header",
        "defaultMessage": "Automation"
    }
});

});




parcelRegister("7tZOY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a854114828988163$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $5mTgl = parcelRequire("5mTgl");

var $gJ3ZJ = parcelRequire("gJ3ZJ");
const $a854114828988163$export$bd1899d755aff74a = (sprints)=>{
    // FIXME next dev actively working in this area
    // not urgent bc (null <= 0) => true so no crash
    // @ts-expect-error TS2531: Object is possibly 'null'.
    if (sprints && sprints[0]?.daysRemaining <= 0) return 'primary';
    return 'default';
};
const $a854114828988163$var$mapStateToProps = (state)=>{
    const activeSprints = (0, $ebHh7.activeSprintsSelector)(state);
    return {
        activeSprints: activeSprints,
        appearance: $a854114828988163$export$bd1899d755aff74a(activeSprints),
        boardId: (0, $67Z81.rapidViewIdSelector)(state),
        selectedSprintIds: (0, $ebHh7.getSelectedSprintsKeys)(state),
        sourceIssueNo: (0, $5mTgl.workIssuesSelector)(state).length,
        isCMPBoard: (0, $67Z81.getIsCMPBoard)(state)
    };
};
var $a854114828988163$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($a854114828988163$var$mapStateToProps, {})((0, $gJ3ZJ.CompleteSprintButton));

});
parcelRegister("gJ3ZJ", function(module, exports) {

$parcel$export(module.exports, "CompleteSprintButton", () => $9e150ec798a2c3f9$export$8d02575f5278cc77);

var $5uXOq = parcelRequire("5uXOq");

var $jj52j = parcelRequire("jj52j");
var $it1wb = parcelRequire("it1wb");
var $gn1v9 = parcelRequire("gn1v9");

var $hZ1SC = parcelRequire("hZ1SC");

var $47gW9 = parcelRequire("47gW9");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dAfqg = parcelRequire("dAfqg");

var $bOsIL = parcelRequire("bOsIL");

var $iKdRC = parcelRequire("iKdRC");


var $b0yad = parcelRequire("b0yad");

var $koeKL = parcelRequire("koeKL");

var $dIdda = parcelRequire("dIdda");

var $CFxE9 = parcelRequire("CFxE9");

var $aKlQV = parcelRequire("aKlQV");

var $ayk9K = parcelRequire("ayk9K");

var $lguBA = parcelRequire("lguBA");
const $9e150ec798a2c3f9$export$8d02575f5278cc77 = ({ activeSprints: activeSprints, appearance: appearance, boardId: boardId, selectedSprintIds: selectedSprintIds, sourceIssueNo: sourceIssueNo, isCMPBoard: isCMPBoard, isDisabled: isDisabled })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const jiraProjectAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'project',
        resourceId: String(project?.projectId)
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = (0, $dIdda.useRouterActions)();
    const boardIdAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: String(boardId)
    });
    const showRetrosModal = (0, $hZ1SC.useShowCreateRetroOrCrossSellModal)();
    const backlogUrl = (0, $aKlQV.useBacklogUrl)([
        'sprintCompleted'
    ]) || '';
    const onCompleted = (0, $5uXOq.useCallback)(()=>{
        push(backlogUrl);
        // Set the flag to load the retros modal when we get to the backlog if the checkbox was ticked
        showRetrosModal();
        // Since the sprint modals don't go through redux we need to fire their invalidations manually
        (0, $b0yad.triggerResourceCacheInvalidation)((0, $8631d6ce464ccf2e$export$9b8283d5878d2491), 'COMPLETE_SPRINT_MODAL_COMPLETE');
    }, [
        backlogUrl,
        push,
        showRetrosModal
    ]);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            jiraProjectAri: jiraProjectAri,
            // Date of 12 weeks ago as we want to fetch deployments date updated at most 12 weeks ago for deployments report nudge on sprint completion
            updatedFromDeploymentsDate: (0, $jj52j.default)((0, $it1wb.default)((0, $gn1v9.default)(Date.now(), {
                weeks: 12
            }))),
            boardId: boardIdAri,
            activeSprintIds: activeSprints?.map((sprint)=>(0, $dXq4S.createAri)({
                    cloudId: cloudId,
                    resourceId: String(sprint.id),
                    resourceOwner: 'jira-software',
                    resourceType: 'sprint'
                })) ?? [],
            isCompanyManaged: isCMPBoard
        }), [
        activeSprints,
        boardIdAri,
        cloudId,
        isCMPBoard,
        jiraProjectAri
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, $4mO32.useEntryPoint)((0, $bOsIL.completeSprintModalEntryPoint), entryPointParams, (0, $CFxE9.completeSprintModalLoad));
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    let sprintId = selectedSprintIds?.[0];
    if (!sprintId && activeSprints) sprintId = activeSprints?.[0]?.id.toString();
    const props = (0, $5uXOq.useMemo)(()=>({
            analyticsSource: 'simple-software-board',
            boardId: boardIdAri,
            onCompleted: onCompleted,
            sourceIssueNo: sourceIssueNo,
            sprintId: sprintId,
            selectedSprintIds: selectedSprintIds,
            onReady: stopMetric,
            isCompanyManaged: isCMPBoard
        }), [
        boardIdAri,
        onCompleted,
        sourceIssueNo,
        sprintId,
        selectedSprintIds,
        stopMetric,
        isCMPBoard
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (isCMPBoard) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'completeSprintButton mounted');
        }
    }, [
        isCMPBoard,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isDisabled && (0, $4R6GH.fg)('jsw-jet-yamato-fe-permissions-seq-sprint-actions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ayk9K.DisabledButtonHelper), null, formatMessage((0, $lguBA.default).completeSprintButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iKdRC.ModalTriggerButton), {
        testId: "software-board.header.complete-sprint-button",
        appearance: appearance,
        ref: triggerRef
    }, formatMessage((0, $lguBA.default).completeSprintButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "complete-sprint-modal",
        teamName: "a4t-pandora",
        packageName: "jiraSoftwareCompleteSprintModalRelay",
        entryPointActions: entryPointActions,
        runtimeProps: props
    }));
};

});
parcelRegister("hZ1SC", function(module, exports) {

$parcel$export(module.exports, "useShowCreateRetroOrCrossSellModal", () => $b6bc1441fa7da9d1$export$3918442dc3bc3c6b);

var $5uXOq = parcelRequire("5uXOq");

var $cyA39 = parcelRequire("cyA39");

var $hqBSi = parcelRequire("hqBSi");

var $84Uym = parcelRequire("84Uym");

var $9LoyA = parcelRequire("9LoyA");
const $b6bc1441fa7da9d1$export$3918442dc3bc3c6b = ()=>{
    const isCrossflowFFEnabled = (0, $84Uym.isCompleteSprintCrossFlowEnabled)();
    const isCrossjoinFFEnabled = (0, $84Uym.isCompleteSprintCrossJoinEnabled)();
    const [retrosState, retrosActions] = (0, $9LoyA.useRetros)();
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const { hasAccess: hasAccess } = (0, $cyA39.useUserHasConfluenceAccess)();
    return (0, $5uXOq.useCallback)(()=>{
        if (!retrosState.shouldCreateRetro) return;
        let action = retrosActions.setLoadCreateRetroModal;
        if (isCrossflowFFEnabled && isCrossjoinFFEnabled) {
            if (!licensedProducts.confluence) action = retrosActions.setLoadCrossFlowModal;
            else if (!hasAccess) action = retrosActions.setLoadCrossJoinModal;
        } else if (isCrossflowFFEnabled && !licensedProducts.confluence) action = retrosActions.setLoadCrossFlowModal;
        else if (isCrossjoinFFEnabled && licensedProducts.confluence && !hasAccess) action = retrosActions.setLoadCrossJoinModal;
        action(true);
    }, [
        isCrossflowFFEnabled,
        isCrossjoinFFEnabled,
        licensedProducts,
        hasAccess,
        retrosState.shouldCreateRetro,
        retrosActions
    ]);
};

});
parcelRegister("cyA39", function(module, exports) {

$parcel$export(module.exports, "useUserHasConfluenceAccess", () => $e1d1047ca6c0e736$export$bddce71054147149);

var $5uXOq = parcelRequire("5uXOq");

var $eNf8a = parcelRequire("eNf8a");

var $imVeH = parcelRequire("imVeH");

var $jcw0u = parcelRequire("jcw0u");

var $9OXo1 = parcelRequire("9OXo1");

var $9KYrx = parcelRequire("9KYrx");

var $cu7Vs = parcelRequire("cu7Vs");

var $cpyFY = parcelRequire("cpyFY");

var $8o1o1 = parcelRequire("8o1o1");
const $e1d1047ca6c0e736$var$TIME_TO_LIVE = 1800000; // 30 minutes
const $e1d1047ca6c0e736$var$storage = (0, $eNf8a.createSessionStorageProvider)((0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY));
const $e1d1047ca6c0e736$export$bddce71054147149 = (embeddedConfluenceSource, skip = false)=>{
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const fireAnalyticsEvent = (0, $8o1o1.useEmbeddedPageTracking)();
    const tenantHasConfluence = (0, $imVeH.useTenantHasConfluence)();
    const [hasAccess, setHasAccess] = (0, $5uXOq.useState)(false);
    const permitted = (0, $5uXOq.useMemo)(()=>(0, $cpyFY.getSessionStorageData)((0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY), $e1d1047ca6c0e736$var$storage)?.permitted, []);
    const getConfluencePermissions = (0, $5uXOq.useCallback)(async ()=>{
        try {
            const response = tenantHasConfluence ? await (0, $cu7Vs.fetchConfluenceUserPermissions)(cloudId) : {
                permitted: false
            };
            fireAnalyticsEvent({
                action: 'success',
                eventName: 'userConfluenceAccess',
                embeddedConfluenceSource: embeddedConfluenceSource
            });
            (0, $cpyFY.setSessionStorageData)({
                key: (0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY),
                value: response,
                ttl: $e1d1047ca6c0e736$var$TIME_TO_LIVE,
                storage: $e1d1047ca6c0e736$var$storage
            });
            setHasAccess(response?.permitted);
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'userConfluenceAccess',
                    teamName: 'confluence-better-together'
                },
                attributes: {
                    embeddedConfluenceSource: embeddedConfluenceSource
                },
                error: new Error(`Failed to get user confluence access status: ${error}`)
            });
        }
    }, [
        cloudId,
        embeddedConfluenceSource,
        fireAnalyticsEvent,
        tenantHasConfluence
    ]);
    const refetchHasAccess = (0, $5uXOq.useCallback)(async ()=>{
        (0, $cpyFY.setSessionStorageData)({
            key: (0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY),
            value: {},
            ttl: $e1d1047ca6c0e736$var$TIME_TO_LIVE,
            storage: $e1d1047ca6c0e736$var$storage
        });
        await getConfluencePermissions();
    }, [
        getConfluencePermissions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (skip) return;
        if (!(0, $cpyFY.getSessionStorageData)((0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY), $e1d1047ca6c0e736$var$storage)) (0, $cpyFY.setSessionStorageData)({
            key: (0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY),
            value: {},
            ttl: $e1d1047ca6c0e736$var$TIME_TO_LIVE,
            storage: $e1d1047ca6c0e736$var$storage
        });
        if (!(0, $cpyFY.isStorageKeyExpired)((0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY), $e1d1047ca6c0e736$var$storage) && permitted !== undefined) setHasAccess(permitted);
        else if (cloudId) getConfluencePermissions();
    }, [
        cloudId,
        embeddedConfluenceSource,
        fireAnalyticsEvent,
        getConfluencePermissions,
        permitted,
        skip
    ]);
    return {
        hasAccess: hasAccess,
        refetchHasAccess: refetchHasAccess
    };
};

});
parcelRegister("imVeH", function(module, exports) {

$parcel$export(module.exports, "useTenantHasConfluence", () => $734552c5f3b177b5$export$964fe2dd9242a588);

var $4Pf62 = parcelRequire("4Pf62");

var $hqBSi = parcelRequire("hqBSi");
const $734552c5f3b177b5$export$964fe2dd9242a588 = ()=>{
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    return Boolean(licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).CONFLUENCE]);
};

});

parcelRegister("cu7Vs", function(module, exports) {

$parcel$export(module.exports, "fetchConfluenceUserPermissions", () => $c0391b42dbea5292$export$e1aee708fe0c56c2);

var $7f4tk = parcelRequire("7f4tk");
const $c0391b42dbea5292$export$e1aee708fe0c56c2 = async (cloudId)=>{
    const response = await (0, $7f4tk.default)('/gateway/api/permissions/permitted', {
        method: 'POST',
        body: JSON.stringify({
            resourceId: `ari:cloud:confluence::site/${cloudId}`,
            permissionId: 'write'
        }),
        headers: {
            Accept: 'application/json'
        }
    });
    return response;
};

});

parcelRegister("cpyFY", function(module, exports) {

$parcel$export(module.exports, "getSessionStorageData", () => $bcceba29d01fe1ab$export$af84d82ff1eea56d);
$parcel$export(module.exports, "setSessionStorageData", () => $bcceba29d01fe1ab$export$be8cb7c8f1a1db6b);
$parcel$export(module.exports, "isStorageKeyExpired", () => $bcceba29d01fe1ab$export$59dd918a314efec0);
$parcel$export(module.exports, "clearSessionStorageData", () => $bcceba29d01fe1ab$export$47001de47bd4a961);
const $bcceba29d01fe1ab$var$createTTLTimestamp = (ttl)=>Date.now() + ttl;
const $bcceba29d01fe1ab$export$af84d82ff1eea56d = (key, storage)=>storage.get(key);
const $bcceba29d01fe1ab$export$be8cb7c8f1a1db6b = ({ key: key, value: value, ttl: ttl, storage: storage })=>{
    const expiresAt = $bcceba29d01fe1ab$var$createTTLTimestamp(ttl);
    storage.set(key, {
        ...value,
        expiresAt: expiresAt
    });
};
const $bcceba29d01fe1ab$export$59dd918a314efec0 = (key, storage)=>{
    if (!$bcceba29d01fe1ab$export$af84d82ff1eea56d(key, storage)) return true;
    const expiresAt = $bcceba29d01fe1ab$export$af84d82ff1eea56d(key, storage)?.expiresAt;
    return expiresAt ? new Date().getTime() >= expiresAt : true;
};
const $bcceba29d01fe1ab$export$47001de47bd4a961 = (key, storage)=>storage.remove(key);

});

parcelRegister("8o1o1", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPageTracking", () => $66febf67b379b5c1$export$9fcd107e4ed1de75);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $j8Srb = parcelRequire("j8Srb");
const $66febf67b379b5c1$var$getParentProduct = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $2vSU6.CORE_PROJECT:
            return 'JWM';
        default:
            return 'JSW';
    }
};
const $66febf67b379b5c1$export$9fcd107e4ed1de75 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const source = (0, $2gCtH.useAnalyticsSource)();
    const trackEmbeddedConfluence = (0, $5uXOq.useCallback)(({ eventName: eventName, action: action, actionSubject: actionSubject, projectType: projectType, embeddedConfluenceSource: embeddedConfluenceSource = 'jiraIssueView', eventType: eventType = 'ui', userHasConfluenceAccess: userHasConfluenceAccess, tenantHasConfluence: tenantHasConfluence, crossJoinStatus: crossJoinStatus, originProduct: originProduct, requestedProduct: requestedProduct })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject ?? `${eventName}`
        });
        const attributes = {
            parentProduct: $66febf67b379b5c1$var$getParentProduct(projectType),
            tenantEditions: tenantContext?.appEditions,
            productEntitlementDetails: tenantContext?.productEntitlementDetails,
            embeddedConfluenceSource: embeddedConfluenceSource,
            jiraIssueSurfaceArea: source,
            userHasConfluenceAccess: userHasConfluenceAccess,
            tenantHasConfluence: tenantHasConfluence,
            crossJoinStatus: crossJoinStatus,
            originProduct: originProduct,
            requestedProduct: requestedProduct
        };
        (0, $j8Srb.fireEmbeddedConfluenceAnalytics)({
            analyticsEvent: analyticsEvent,
            attributes: attributes,
            eventType: eventType,
            eventName: `${actionSubject ?? eventName} ${action}`
        });
    }, [
        source,
        tenantContext,
        createAnalyticsEvent
    ]);
    return trackEmbeddedConfluence;
};

});
parcelRegister("j8Srb", function(module, exports) {

$parcel$export(module.exports, "fireEmbeddedConfluenceAnalytics", () => $da71518e42bc9539$export$864bc2da9014e8e9);

var $8zOmE = parcelRequire("8zOmE");
const $da71518e42bc9539$export$864bc2da9014e8e9 = ({ analyticsEvent: analyticsEvent, attributes: attributes, eventType: eventType, eventName: eventName })=>{
    switch(eventType){
        case 'ui':
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
            break;
        case 'operational':
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        case 'track':
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        default:
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
            break;
    }
};

});



parcelRegister("84Uym", function(module, exports) {

$parcel$export(module.exports, "isCompleteSprintCrossFlowEnabled", () => $141b2b7a8812be56$export$85fbb2a414949eea);
$parcel$export(module.exports, "fireCompleteSprintCrossFlowExposureEventWhenEnrolled", () => $141b2b7a8812be56$export$f304ef0c9d0114d6);
$parcel$export(module.exports, "isCompleteSprintCrossJoinEnabled", () => $141b2b7a8812be56$export$80ecf97fd1ddd003);
$parcel$export(module.exports, "fireCompleteSprintCrossJoinExposureEventWhenEnrolled", () => $141b2b7a8812be56$export$4c5f2c8aff3c3599);

var $6s1PB = parcelRequire("6s1PB");

var $co1wz = parcelRequire("co1wz");

var $8zOmE = parcelRequire("8zOmE");
const $141b2b7a8812be56$export$69932781b42dd805 = 'jsw_sprint_completion_retro_cross_flow';
const $141b2b7a8812be56$export$6ae71ceef72281af = 'conf_jira_sprint_completion_cross_join_exp';
const $141b2b7a8812be56$export$3d370c33621572df = 'cohort';
const $141b2b7a8812be56$export$8ea6555e3e46f620 = 'not-enrolled';
const $141b2b7a8812be56$export$e9cae393a0b9eb85 = 'experiment';
const $141b2b7a8812be56$export$b3ba2b75eab4739d = 'control';
const $141b2b7a8812be56$export$85fbb2a414949eea = ()=>{
    const [completeSprintCrossFlowConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_sprint_completion_retro_cross_flow');
    return (0, $co1wz.ff)('sprint-completion-cross-flow') && completeSprintCrossFlowConfig.get($141b2b7a8812be56$export$3d370c33621572df, $141b2b7a8812be56$export$8ea6555e3e46f620) === $141b2b7a8812be56$export$e9cae393a0b9eb85;
};
const $141b2b7a8812be56$export$f304ef0c9d0114d6 = (createAnalyticsEvent)=>{
    const [completeSprintCrossFlowConfig, completeSprintCrossFlowFireExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_sprint_completion_retro_cross_flow');
    const completeSprintCrossFlowExperimentValue = completeSprintCrossFlowConfig.get($141b2b7a8812be56$export$3d370c33621572df, $141b2b7a8812be56$export$8ea6555e3e46f620);
    if ((0, $co1wz.ff)('sprint-completion-cross-flow') && completeSprintCrossFlowExperimentValue !== $141b2b7a8812be56$export$8ea6555e3e46f620) {
        completeSprintCrossFlowFireExposure();
        // manually fire for Socrates
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
            flagKey: $141b2b7a8812be56$export$69932781b42dd805,
            value: completeSprintCrossFlowExperimentValue,
            growthInitiative: 'cross-flow'
        });
    }
};
const $141b2b7a8812be56$export$80ecf97fd1ddd003 = ()=>{
    const [completeSprintCrossJoinConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('conf_jira_sprint_completion_cross_join_exp');
    return completeSprintCrossJoinConfig.get($141b2b7a8812be56$export$3d370c33621572df, $141b2b7a8812be56$export$8ea6555e3e46f620) === $141b2b7a8812be56$export$e9cae393a0b9eb85;
};
const $141b2b7a8812be56$export$4c5f2c8aff3c3599 = (createAnalyticsEvent)=>{
    const [completeSprintCrossJoinConfig, completeSprintCrossJoinFireExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('conf_jira_sprint_completion_cross_join_exp');
    const completeSprintCrossJoinExperimentValue = completeSprintCrossJoinConfig.get($141b2b7a8812be56$export$3d370c33621572df, $141b2b7a8812be56$export$8ea6555e3e46f620);
    if (completeSprintCrossJoinExperimentValue !== $141b2b7a8812be56$export$8ea6555e3e46f620) {
        completeSprintCrossJoinFireExposure();
        // manually fire for Socrates
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
            flagKey: $141b2b7a8812be56$export$6ae71ceef72281af,
            value: completeSprintCrossJoinExperimentValue,
            growthInitiative: 'cross-join'
        });
    }
};

});

parcelRegister("9LoyA", function(module, exports) {

$parcel$export(module.exports, "useRetros", () => $27c0746d7d3517fa$export$70e27f56232e4ea8);

var $7JoAD = parcelRequire("7JoAD");

var $bkZLr = parcelRequire("bkZLr");

var $c85ZN = parcelRequire("c85ZN");

const $27c0746d7d3517fa$export$390f32400eaf98c9 = (0, $7JoAD.createStore)({
    initialState: $c85ZN.initialState,
    actions: $bkZLr.default,
    name: 'create-retros'
});
const $27c0746d7d3517fa$export$70e27f56232e4ea8 = (0, $7JoAD.createHook)($27c0746d7d3517fa$export$390f32400eaf98c9);

});
parcelRegister("bkZLr", function(module, exports) {

$parcel$export(module.exports, "default", () => $48222d4aa85b1c99$export$2e2bcd8739ae039);

var $8LQ84 = parcelRequire("8LQ84");

var $1QOns = parcelRequire("1QOns");

var $agVdz = parcelRequire("agVdz");

var $jJZqs = parcelRequire("jJZqs");

var $42TYq = parcelRequire("42TYq");

var $b7gdg = parcelRequire("b7gdg");

var $c85ZN = parcelRequire("c85ZN");
const $48222d4aa85b1c99$var$resetState = ()=>({ setState: setState })=>{
        setState((0, $c85ZN.initialState));
    };
const $48222d4aa85b1c99$var$resetCreatedData = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            createRetroPage: (0, $c85ZN.initialState).createRetroPage,
            createWhiteboard: (0, $c85ZN.initialState).createWhiteboard
        });
    };
const $48222d4aa85b1c99$var$setSprintId = (sprintId)=>({ setState: setState })=>{
        setState({
            sprintId: sprintId
        });
    };
const $48222d4aa85b1c99$var$setShouldCreateRetro = (shouldCreateRetro)=>({ setState: setState })=>{
        setState({
            shouldCreateRetro: shouldCreateRetro
        });
    };
const $48222d4aa85b1c99$var$setLoadCreateRetroModal = (loadCreateRetroModal)=>({ setState: setState })=>{
        setState({
            loadCreateRetroModal: loadCreateRetroModal
        });
    };
const $48222d4aa85b1c99$var$setLoadCrossFlowModal = (loadCrossFlowModal)=>({ setState: setState })=>{
        setState({
            loadCrossFlowModal: loadCrossFlowModal
        });
    };
const $48222d4aa85b1c99$var$setLoadCrossJoinModal = (loadCrossJoinModal)=>({ setState: setState })=>{
        setState({
            loadCrossJoinModal: loadCrossJoinModal
        });
    };
const $48222d4aa85b1c99$var$setIsRetroLinked = (isRetroLinked)=>({ setState: setState })=>{
        setState({
            isRetroLinked: isRetroLinked
        });
    };
const $48222d4aa85b1c99$var$setIsRetroLinking = (isRetroLinking)=>({ setState: setState })=>{
        setState({
            isRetroLinking: isRetroLinking
        });
    };
const $48222d4aa85b1c99$var$setRetroLinkingError = (retroLinkingError)=>({ setState: setState })=>{
        setState({
            retroLinkingError: retroLinkingError
        });
    };
const $48222d4aa85b1c99$var$setIsRetroPublished = (isRetroPublished)=>({ setState: setState })=>{
        setState({
            isRetroPublished: isRetroPublished
        });
    };
const $48222d4aa85b1c99$var$setConfluenceData = (data)=>({ getState: getState, setState: setState })=>{
        const { confluenceData: confluenceData } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                ...data
            }
        });
    };
const $48222d4aa85b1c99$var$setRetroType = (retroType)=>({ setState: setState })=>{
        setState({
            retroType: retroType
        });
    };
const $48222d4aa85b1c99$var$createRetroPage = (cloudId, spaceKey, parentPageId, sprintId, blueprintId)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            createRetroPage: {
                ...state.createRetroPage,
                loading: true,
                error: undefined
            }
        });
        try {
            const retroPage = await (0, $42TYq.createRetro)(cloudId, spaceKey, parentPageId, sprintId, blueprintId);
            setState({
                createRetroPage: {
                    ...state.createRetroPage,
                    loading: false,
                    data: retroPage
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                createRetroPage: {
                    ...state.createRetroPage,
                    loading: false,
                    error: error
                }
            });
        }
    };
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $48222d4aa85b1c99$var$isConfluenceWhiteboardsError = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($1QOns)))(error) && (0, (/*@__PURE__*/$parcel$interopDefault($8LQ84)))(error.errors) && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error.errors.every((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($1QOns)))(e) && (0, (/*@__PURE__*/$parcel$interopDefault($agVdz)))(e.title) && (0, (/*@__PURE__*/$parcel$interopDefault($agVdz)))(e.code));
const $48222d4aa85b1c99$var$isConfluenceWhiteboardsDisabled = async (error)=>{
    if (!(error instanceof (0, $jJZqs.default) && error.originalResponse)) return false;
    const errorResponse = await error.originalResponse.json();
    // Check for title until more specific error code is available (CBT-3079)
    return $48222d4aa85b1c99$var$isConfluenceWhiteboardsError(errorResponse) && errorResponse.errors[0].title === 'Whiteboards are not enabled';
};
const $48222d4aa85b1c99$var$createRetroWhiteboard = (cloudId, spaceId, parentId, templateKey)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            createWhiteboard: {
                ...state.createWhiteboard,
                loading: true,
                error: undefined
            }
        });
        try {
            const whiteboard = await (0, $b7gdg.createWhiteboard)(cloudId, spaceId, parentId, templateKey);
            setState({
                createWhiteboard: {
                    ...state.createWhiteboard,
                    loading: false,
                    data: whiteboard
                }
            });
        } catch (error) {
            setState({
                isWhiteboardsDisabled: state.isWhiteboardsDisabled || await $48222d4aa85b1c99$var$isConfluenceWhiteboardsDisabled(error),
                createWhiteboard: {
                    ...state.createWhiteboard,
                    loading: false,
                    error: error instanceof Error ? error : undefined
                }
            });
        }
    };
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$48222d4aa85b1c99$export$2e2bcd8739ae039 = {
    resetState: $48222d4aa85b1c99$var$resetState,
    resetCreatedData: $48222d4aa85b1c99$var$resetCreatedData,
    setSprintId: $48222d4aa85b1c99$var$setSprintId,
    setShouldCreateRetro: $48222d4aa85b1c99$var$setShouldCreateRetro,
    setLoadCreateRetroModal: $48222d4aa85b1c99$var$setLoadCreateRetroModal,
    setLoadCrossFlowModal: $48222d4aa85b1c99$var$setLoadCrossFlowModal,
    setLoadCrossJoinModal: $48222d4aa85b1c99$var$setLoadCrossJoinModal,
    setIsRetroLinked: $48222d4aa85b1c99$var$setIsRetroLinked,
    setIsRetroLinking: $48222d4aa85b1c99$var$setIsRetroLinking,
    setRetroLinkingError: $48222d4aa85b1c99$var$setRetroLinkingError,
    setIsRetroPublished: $48222d4aa85b1c99$var$setIsRetroPublished,
    setConfluenceData: $48222d4aa85b1c99$var$setConfluenceData,
    createRetroPage: $48222d4aa85b1c99$var$createRetroPage,
    setRetroType: $48222d4aa85b1c99$var$setRetroType,
    createRetroWhiteboard: $48222d4aa85b1c99$var$createRetroWhiteboard
};

});
parcelRegister("42TYq", function(module, exports) {

$parcel$export(module.exports, "createRetro", () => $f4242736fa792950$export$a63913da797715a6);

var $7f4tk = parcelRequire("7f4tk");


var $cYuHt = parcelRequire("cYuHt");
const $f4242736fa792950$export$a63913da797715a6 = async (cloudId, spaceKey, parentPageId, sprintId, blueprintId)=>{
    const [sprint] = await Promise.all([
        (0, $cYuHt.getSprint)(sprintId)
    ]);
    const title = `Retrospective: ${sprint.name}`;
    if (!blueprintId) throw new Error('User attempted to create a Confluence page retro, but no retro blueprint was found');
    return (0, $7f4tk.default)(`/gateway/api/ex/confluence/${cloudId}/wiki/rest/create-dialog/1.0/content/blueprint/${(0, $63b79f4ff36af7f3$export$48a96ef844462313)}/instance`, {
        method: 'POST',
        body: JSON.stringify({
            content: {
                type: 'page',
                title: title,
                status: 'draft',
                ancestors: parentPageId ? [
                    {
                        id: parentPageId
                    }
                ] : undefined,
                space: {
                    key: spaceKey
                },
                // these values are required to create an NCS page
                metadata: {
                    properties: {
                        editor: {
                            value: 'v2'
                        }
                    },
                    frontend: {
                        embedded: true
                    }
                }
            },
            contentBlueprintSpec: {
                context: {
                    spaceKey: spaceKey,
                    parentPageId: parentPageId
                },
                blueprintId: blueprintId
            }
        })
    });
};

});
const $63b79f4ff36af7f3$export$48a96ef844462313 = 'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint';

parcelRegister("cYuHt", function(module, exports) {

$parcel$export(module.exports, "getSprint", () => $28d2a59892eb2d5b$export$4402d4ed26f26131);

var $7f4tk = parcelRequire("7f4tk");
const $28d2a59892eb2d5b$export$4402d4ed26f26131 = async (sprintId)=>(0, $7f4tk.default)(`/rest/agile/1.0/sprint/${sprintId}`);

});


parcelRegister("b7gdg", function(module, exports) {

$parcel$export(module.exports, "createWhiteboard", () => $ed7d58a2374be2eb$export$36ce0aac6b5c6804);

var $7f4tk = parcelRequire("7f4tk");
const $ed7d58a2374be2eb$export$36ce0aac6b5c6804 = async (cloudId, spaceId, parentId, templateKey)=>(0, $7f4tk.default)(`/gateway/api/ex/confluence/${cloudId}/wiki/api/v2/whiteboards`, {
        method: 'POST',
        body: JSON.stringify({
            spaceId: spaceId,
            parentId: parentId || null,
            templateKey: templateKey
        })
    });

});

parcelRegister("c85ZN", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $c4ef19a54ae6936a$export$d4c72bab9d6cc13a);

var $kGefV = parcelRequire("kGefV");
const $c4ef19a54ae6936a$export$d4c72bab9d6cc13a = {
    sprintId: undefined,
    shouldCreateRetro: false,
    loadCreateRetroModal: false,
    loadCrossFlowModal: false,
    loadCrossJoinModal: false,
    isRetroLinked: false,
    isRetroLinking: false,
    isRetroPublished: false,
    isWhiteboardsDisabled: false,
    retroLinkingError: undefined,
    retroType: (0, $kGefV.RetroTypes).WHITEBOARD,
    confluenceData: {
        spaceKey: undefined,
        parentPageId: undefined,
        spaceId: undefined
    },
    createRetroPage: {
        data: undefined,
        loading: false,
        error: undefined
    },
    createWhiteboard: {
        data: undefined,
        loading: false,
        error: undefined
    }
};

});
parcelRegister("kGefV", function(module, exports) {

$parcel$export(module.exports, "RetroTypes", () => $030b4200896d24ad$export$1da38a077679bab0);
const $030b4200896d24ad$export$1da38a077679bab0 = {
    WHITEBOARD: 'whiteboard',
    PAGE: 'page'
};

});





parcelRegister("bOsIL", function(module, exports) {

$parcel$export(module.exports, "completeSprintModalEntryPoint", () => $da8db933301c2e65$export$e19f219885fe8c5f);

var $j4C5v = parcelRequire("j4C5v");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $da8db933301c2e65$export$e19f219885fe8c5f = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("61yxy")), {
        moduleId: "3d417b0d"
    }),
    getPreloadProps: ({ jiraProjectAri: jiraProjectAri, updatedFromDeploymentsDate: updatedFromDeploymentsDate, boardId: boardId, activeSprintIds: activeSprintIds })=>({
            queries: {
                completeSprintMetadata: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $j4C5v.default,
                    variables: {
                        jiraProjectAri: jiraProjectAri,
                        updatedFromDeploymentsDate: updatedFromDeploymentsDate,
                        boardId: boardId,
                        activeSprintIds: activeSprintIds
                    }
                }
            }
        })
});

});
parcelRegister("j4C5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $65bc3007e99f5743$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6fa8139ab68de2adaf65c8eae3998ecd>>
 * @relayHash ea4312ab52f27e8938047934d2f94d9a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7136bf3a8b621191f5688b40ac28c430f5e6237f2ebcb6fea7a09680f67dff05
const $65bc3007e99f5743$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "7136bf3a8b621191f5688b40ac28c430f5e6237f2ebcb6fea7a09680f67dff05",
        "metadata": {},
        "name": "mainCompleteSprintMetadataQuery",
        "operationKind": "query",
        "text": null
    }
};
var $65bc3007e99f5743$export$2e2bcd8739ae039 = $65bc3007e99f5743$var$node;

});

parcelRegister("61yxy", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("1XW3O")
]).then(()=>parcelRequire('4gPTd'));

});


parcelRegister("ayk9K", function(module, exports) {

$parcel$export(module.exports, "DisabledButtonHelper", () => $12f5cf9ffee1da1f$export$7407340f59537358);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $1I7E8 = parcelRequire("1I7E8");

var $jldZL = parcelRequire("jldZL");

var $koVbs = parcelRequire("koVbs");

var $gWjRm = parcelRequire("gWjRm");

var $jBWTK = parcelRequire("jBWTK");
const $12f5cf9ffee1da1f$var$A11Y_HELPER_TEXT_ID = 'software-backlog.card-list.common.sprint-actions.disabled-button-helper.disabled-button-trigger.a11y-helper-text';
const $12f5cf9ffee1da1f$export$7407340f59537358 = (props)=>{
    const { children: children } = props;
    const [isDisabledButtonPopupOpen, setIsDisabledButtonPopupOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onDisabledButtonPopupClose = (0, $5uXOq.useCallback)(()=>{
        setIsDisabledButtonPopupOpen(false);
    }, []);
    const handleDisabledButtonClick = (0, $5uXOq.useCallback)(()=>{
        setIsDisabledButtonPopupOpen((prevState)=>!prevState);
    }, []);
    const disabledButtonTrigger = ({ ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            ...triggerProps,
            isSelected: isDisabledButtonPopupOpen,
            onClick: handleDisabledButtonClick,
            testId: "software-board.header.common.sprint-actions.disabled-button-helper.disabled-button-trigger",
            "aria-describedby": $12f5cf9ffee1da1f$var$A11Y_HELPER_TEXT_ID,
            "aria-disabled": true
        }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: isDisabledButtonPopupOpen,
        onClose: onDisabledButtonPopupClose,
        content: (0, $gWjRm.default),
        trigger: disabledButtonTrigger,
        placement: "bottom-end",
        testId: "software-board.header.common.sprint-actions.disabled-button-helper.disabled-button-popup"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), {
        id: $12f5cf9ffee1da1f$var$A11Y_HELPER_TEXT_ID,
        testId: "software-board.header.common.sprint-actions.disabled-button-helper.a-11-y-sr-text"
    }, formatMessage((0, $jBWTK.messages).disabledButtonHelperHeading), "\xa0", formatMessage((0, $jBWTK.messages).disabledButtonHelperBody)));
};

});
parcelRegister("gWjRm", function(module, exports) {

$parcel$export(module.exports, "default", () => $293b471ca2ad9fab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1dJ6S = parcelRequire("1dJ6S");

var $3G2gB = parcelRequire("3G2gB");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $jBWTK = parcelRequire("jBWTK");
const $293b471ca2ad9fab$var$DisabledButtonContent = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        xcss: $293b471ca2ad9fab$var$widthWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3G2gB))), {
        label: "",
        primaryColor: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockStart: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1dJ6S.default), {
        size: "xsmall",
        as: "h2"
    }, formatMessage((0, $jBWTK.messages).disabledButtonHelperHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $jBWTK.messages).disabledButtonHelperBody))));
};
const $293b471ca2ad9fab$var$widthWrapperStyles = (0, $8CUq3.xcss)({
    /**
   * fixed width to keep title on a single line
   */ width: '410px',
    padding: 'space.250'
});
var $293b471ca2ad9fab$export$2e2bcd8739ae039 = $293b471ca2ad9fab$var$DisabledButtonContent;

});
parcelRegister("3G2gB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ad70d7fd26028c0$var$_react = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2ad70d7fd26028c0$var$_lockLocked = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("bwyQI")));
function $2ad70d7fd26028c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2ad70d7fd26028c0$var$LockIcon = (props)=>/*#__PURE__*/ $2ad70d7fd26028c0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $2ad70d7fd26028c0$var$_lockLocked.default
    }));
$2ad70d7fd26028c0$var$LockIcon.displayName = 'LockIcon';
var $2ad70d7fd26028c0$var$_default = module.exports.default = $2ad70d7fd26028c0$var$LockIcon;

});
parcelRegister("bwyQI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::416fbcb8404b026ec5d40aeabfb0a441>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $863db7350f859785$var$_UNSAFE_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $863db7350f859785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $863db7350f859785$var$LockLockedIcon = (props)=>/*#__PURE__*/ $863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 7.75H4c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25h-.75m-6.5 0V4a3.25 3.25 0 1 1 6.5 0v3.75m-6.5 0h6.5M8 10v3"/>`
    }, props));
$863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;

});


parcelRegister("jBWTK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fc2900df644b4df1$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $fc2900df644b4df1$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    disabledButtonHelperHeading: {
        "id": "software.main.header.complete-sprint-button.complete-sprint-button-disabled-info-heading",
        "defaultMessage": "You don't have 'Manage sprints' permission"
    },
    disabledButtonHelperBody: {
        "id": "software.main.header.complete-sprint-button.complete-sprint-button-disabled-info-body",
        "defaultMessage": "Ask an administrator to grant you the permission for all projects in the board filter."
    }
});

});



parcelRegister("lguBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $28a5b44185024b93$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $28a5b44185024b93$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    completeSprintButton: {
        "id": "software.main.header.complete-sprint-button.complete-sprint-button",
        "defaultMessage": "Complete sprint"
    }
});

});



parcelRegister("3SShY", function(module, exports) {

$parcel$export(module.exports, "default", () => $acd9e78f3f54051f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $h9kUS = parcelRequire("h9kUS");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $2ZySJ = parcelRequire("2ZySJ");

var $iDGXn = parcelRequire("iDGXn");

var $1393U = parcelRequire("1393U");

var $k9JTq = parcelRequire("k9JTq");

var $2xFXk = parcelRequire("2xFXk");

var $gKBVc = parcelRequire("gKBVc");

var $63LqY = parcelRequire("63LqY");

var $69EQQ = parcelRequire("69EQQ");

var $9eTg7 = parcelRequire("9eTg7");

var $ikdur = parcelRequire("ikdur");

var $fUeOV = parcelRequire("fUeOV");

var $hkLPk = parcelRequire("hkLPk");

var $7Nytu = parcelRequire("7Nytu");

var $fjK71 = parcelRequire("fjK71");
const $acd9e78f3f54051f$var$ControlsBar = ({ rapidViewId: rapidViewId, isSprintsEnabled: isSprintsEnabled, hasActiveSprint: hasActiveSprint, customFiltersQueryRef: customFiltersQueryRef, leftHandSideActions: leftHandSideActions, showCardDetails: showCardDetails = true, isActiveStandup: isActiveStandup, setIsActiveStandup: setIsActiveStandup, boardType: boardType, children: children })=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const showInsightsButton = !isSprintsEnabled || hasActiveSprint;
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const isJSWBoard = (0, $63LqY.useIsJSWBoard)();
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const isFilterBarVisible = (0, $iDGXn.useShowQuickFilters)();
    const isTabNavigation = (0, $63LqY.useCapability)((0, $2xFXk.Capability).IS_TAB_NAVIGATION);
    const shouldRenderFullscreenMenuItem = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_BOARD_FULLSCREEN_MENU_ITEM);
    const shouldRenderFullscreenButton = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_BOARD_FULLSCREEN_BUTTON);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbedView = (0, $4R6GH.fg)('jira_board_smartlink_embed') ? (0, $gKBVc.useIsEmbedView)() : false;
    const isStandupDisabled = (0, $9eTg7.shouldDisableStandup)({
        boardType: boardType,
        isSprintsEnabled: isSprintsEnabled,
        hasActiveSprint: hasActiveSprint
    });
    const shouldRenderGroupBy = ()=>{
        /**
     * Increment Planning board only has one swimlane grouping - Team (rendered by default).
     * We don't allow users to switch to a different grouping therefore we're not rendering the SwimlaneSwitcher.
     */ if (isIncrementPlanningBoard) return false;
        return true;
    };
    /*
   * lg and above -> filter bar grows, actions do not shrink or grow. Actions at full size.
   * will adapt to screen size by putting things into more.
   * md -> lg: filter bar has basis of 70%, actions shrink and wrap onto two lines (with small buttons grouped together) if they can't fit in the remaining space.
   * sm and below -> actions grow and wraps above the filter bar. Filter bar and actions grow.
   */ if (isTabNavigation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $acd9e78f3f54051f$var$outerBoxStylesNewStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: (0, $4R6GH.fg)('jira_nav4_eap_drop_2') ? $acd9e78f3f54051f$var$combinedFilterAndActionStyles : $acd9e78f3f54051f$var$combinedFilterAndActionStylesOld,
        testId: "software-board.header.controls-bar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: (0, $4R6GH.fg)('jira_nav4_eap_drop_2') ? $acd9e78f3f54051f$var$filterBarWrapperStyles : $acd9e78f3f54051f$var$filterBarWrapperStylesOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ikdur.default), {
        isActiveStandup: isActiveStandup,
        customFiltersQueryRef: customFiltersQueryRef
    }), isFilterBarVisible && isCMPBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fUeOV.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: (0, $4R6GH.fg)('jira_nav4_eap_drop_2') ? $acd9e78f3f54051f$var$rightSideActionsStyles : $acd9e78f3f54051f$var$rightSideActionsStylesOld
    }, shouldRenderGroupBy() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Nytu.default), null), leftHandSideActions, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        justifyContent: "end",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ZySJ.ImportWorkButton), null), showInsightsButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69EQQ.default), {
        boardId: rapidViewId,
        edition: appEditions.software,
        isSprintsEnabled: isSprintsEnabled
    }), !shouldRenderFullscreenMenuItem && shouldRenderFullscreenButton && !isEmbedView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkLPk.FullscreenButton), {
        boardId: Number(rapidViewId),
        shouldRenderContent: !isActiveStandup
    }), !isIncrementPlanningBoard && isJSWBoard && (0, $6s1PB.expVal)('jira-in-product-standups', 'is_enabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1393U.StandupControlButtons), {
        isStandupDisabled: isStandupDisabled,
        isActiveStandup: isActiveStandup,
        setIsActiveStandup: setIsActiveStandup,
        boardId: Number(rapidViewId)
    }), !isActiveStandup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjK71.default), {
        showCardDetails: showCardDetails
    })), !isActiveStandup && children)));
    if (!(0, $4R6GH.fg)('fix_insight_button_spacing_on_board_and_backlog')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_otyrxy5q"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($acd9e78f3f54051f$var$Wrapper, {
        "data-testid": "software-board.header.controls-bar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($acd9e78f3f54051f$var$FilterBarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ikdur.default), {
        isActiveStandup: isActiveStandup,
        customFiltersQueryRef: customFiltersQueryRef
    })), shouldRenderGroupBy() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Nytu.default), null), leftHandSideActions, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $acd9e78f3f54051f$var$importWorkWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ZySJ.ImportWorkButton), null)), showInsightsButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($acd9e78f3f54051f$var$InsightsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69EQQ.default), {
        boardId: rapidViewId,
        edition: appEditions.software,
        isSprintsEnabled: isSprintsEnabled
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjK71.default), {
        showCardDetails: showCardDetails
    }), children), isFilterBarVisible && isCMPBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fUeOV.default), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_otyrxy5q"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        justifyContent: "end",
        alignItems: "center",
        testId: "software-board.header.controls-bar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($acd9e78f3f54051f$var$FilterBarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ikdur.default), {
        isActiveStandup: isActiveStandup,
        customFiltersQueryRef: customFiltersQueryRef
    })), shouldRenderGroupBy() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Nytu.default), null), leftHandSideActions, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ZySJ.ImportWorkButton), null), showInsightsButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69EQQ.default), {
        boardId: rapidViewId,
        edition: appEditions.software,
        isSprintsEnabled: isSprintsEnabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjK71.default), {
        showCardDetails: showCardDetails
    }), children), isFilterBarVisible && isCMPBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fUeOV.default), null));
};
var $acd9e78f3f54051f$export$2e2bcd8739ae039 = $acd9e78f3f54051f$var$ControlsBar;
const $acd9e78f3f54051f$var$outerBoxStylesNewStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});
const $acd9e78f3f54051f$var$styles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $acd9e78f3f54051f$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1osq _o5721q9c",
            __cmplp.className
        ])
    });
});
const $acd9e78f3f54051f$var$filterBarWrapperStylesOld = (0, $8CUq3.xcss)({
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    // minimum width required for expanded search + More button + clear filters
    minWidth: '468px',
    justifyContent: 'end',
    [(0, $h9kUS.media).above.md]: {
        flex: '0 1 70%'
    },
    [(0, $h9kUS.media).above.lg]: {
        flex: '1 1 auto'
    }
});
const $acd9e78f3f54051f$var$filterBarWrapperStyles = (0, $8CUq3.xcss)({
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    // minimum width required for expanded search + More button + clear filters
    minWidth: '468px',
    justifyContent: 'end'
});
const $acd9e78f3f54051f$var$rightSideActionsStylesOld = (0, $8CUq3.xcss)({
    display: 'flex',
    flex: '1 1 auto',
    gap: 'space.100',
    justifyContent: 'flex-end',
    alignItems: 'start',
    flexWrap: 'wrap',
    [(0, $h9kUS.media).above.md]: {
        flex: '0 1 auto'
    }
});
const $acd9e78f3f54051f$var$rightSideActionsStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flex: '1 0 auto',
    gap: 'space.100',
    justifyContent: 'flex-end',
    alignItems: 'start'
});
const $acd9e78f3f54051f$var$combinedFilterAndActionStylesOld = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    gap: 'space.100',
    flexWrap: 'wrap-reverse',
    alignItems: 'stretch',
    [(0, $h9kUS.media).above.md]: {
        flexWrap: 'nowrap'
    }
});
const $acd9e78f3f54051f$var$combinedFilterAndActionStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    gap: 'space.100',
    flexWrap: 'wrap-reverse',
    alignItems: 'stretch',
    [(0, $h9kUS.media).above.lg]: {
        flexWrap: 'nowrap'
    }
});
// If updating this component, also update filterBarWrapperStyles
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $acd9e78f3f54051f$var$FilterBarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $acd9e78f3f54051f$var$InsightsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u014y2",
            __cmplp.className
        ])
    });
});
const $acd9e78f3f54051f$var$importWorkWrapperStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.050'
});

});
parcelRegister("2ZySJ", function(module, exports) {

$parcel$export(module.exports, "ImportWorkButton", () => $650ab30d4dd366bc$export$311dc74043c51081);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $kxZPA = parcelRequire("kxZPA");


var $8kda3 = parcelRequire("8kda3");

const $650ab30d4dd366bc$export$1d333e4178627a87 = (0, $kxZPA.lazy)(()=>(parcelRequire("jpl8s")).then(({ ImportWorkButtonInternal: ImportWorkButtonInternal })=>ImportWorkButtonInternal), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-invites/src/ui/import-work-button/index.tsx"
});
const $650ab30d4dd366bc$var$ImportWorkButtonWithTargeting = ()=>{
    const isTargeted = (0, $8kda3.useIsTargetedForRaisingAwarenessOfImporter)();
    return isTargeted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($650ab30d4dd366bc$export$1d333e4178627a87, null) : null;
};
const $650ab30d4dd366bc$export$311dc74043c51081 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "importWorkButton",
        packageName: (0, $daef8268a41061ca$export$b8b9d90f9e5bd72b),
        teamName: (0, $daef8268a41061ca$export$d57b6b390e78d90f),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($650ab30d4dd366bc$var$ImportWorkButtonWithTargeting, null));

});
const $daef8268a41061ca$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingInvites';
const $daef8268a41061ca$export$d57b6b390e78d90f = 'jlove-makkuro';
const $daef8268a41061ca$export$719991a6cc456f06 = 'software-onboarding-invites.ui.import-work-button.button';

parcelRegister("8kda3", function(module, exports) {

$parcel$export(module.exports, "useIsTargetedForRaisingAwarenessOfImporter", () => $8571e29361584ab7$export$c45655b60f7ebf1c);

var $2vSU6 = parcelRequire("2vSU6");

var $9y6jE = parcelRequire("9y6jE");

var $dAfqg = parcelRequire("dAfqg");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");
const $8571e29361584ab7$export$c45655b60f7ebf1c = ()=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const { software: edition } = (0, $k9JTq.useAppEditions)();
    const isWithin30Day = (0, $9y6jE.useIsFirstActivationDateWithinLast30Days)();
    const isSoftwareProject = data?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    return data?.simplified && isSiteAdmin && isWithin30Day && edition === (0, $ldyPw.FREE_EDITION) && isSoftwareProject;
};

});
parcelRegister("9y6jE", function(module, exports) {

$parcel$export(module.exports, "useIsFirstActivationDateWithinLast30Days", () => $e7cd4e878e1b25bc$export$f561835faf21b733);

var $dkqym = parcelRequire("dkqym");

var $at4B6 = parcelRequire("at4B6");
const $e7cd4e878e1b25bc$export$f561835faf21b733 = ()=>{
    const firstActivationDate = (0, $dkqym.useFirstActivationDateMs)();
    return (0, $at4B6.isWithinLast30Days)(firstActivationDate);
};

});
parcelRegister("at4B6", function(module, exports) {

$parcel$export(module.exports, "isWithinLast30Days", () => $6d4f0d42d84e1d91$export$550dea1ca60eaa64);

var $iS3m6 = parcelRequire("iS3m6");
const $6d4f0d42d84e1d91$export$550dea1ca60eaa64 = (0, $iS3m6.isWithinLast)({
    days: 30
});

});
parcelRegister("iS3m6", function(module, exports) {

$parcel$export(module.exports, "isWithinLast", () => $8541d32f174f7876$export$15bc1a874225842d);

var $59y5F = parcelRequire("59y5F");

var $dQChl = parcelRequire("dQChl");

var $2xkYZ = parcelRequire("2xkYZ");
const $8541d32f174f7876$export$15bc1a874225842d = (duration)=>(date)=>{
        if (!(0, $59y5F.default)(date)) return false;
        const end = Date.now();
        const start = (0, $2xkYZ.default)(duration)(end);
        // `isValid` precludes a nullable date.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (0, $dQChl.default)({
            start: start,
            end: end
        })(date);
    };

});




parcelRegister("jpl8s", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("8bhUA").then(()=>parcelRequire('eK5YJ'));

});


parcelRegister("1393U", function(module, exports) {

$parcel$export(module.exports, "StandupControlButtons", () => $a4b50c953e845558$export$effd663aaa9a2bf4);

var $5uXOq = parcelRequire("5uXOq");

var $bPA7p = parcelRequire("bPA7p");

var $4t4Ir = parcelRequire("4t4Ir");
const $a4b50c953e845558$export$effd663aaa9a2bf4 = ({ isActiveStandup: isActiveStandup, setIsActiveStandup: setIsActiveStandup, isStandupDisabled: isStandupDisabled, boardId: boardId })=>{
    return isActiveStandup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bPA7p.EndStandupButton), {
        setIsActiveStandup: setIsActiveStandup,
        boardId: boardId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4t4Ir.StartStandupButton), {
        isStandupDisabled: isStandupDisabled,
        setIsActiveStandup: setIsActiveStandup,
        boardId: boardId
    });
};

});
parcelRegister("bPA7p", function(module, exports) {

$parcel$export(module.exports, "EndStandupButton", () => $f6c7407ca4cb16c0$export$2709cff9d915e6db);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $koVbs = parcelRequire("koVbs");

var $g7crU = parcelRequire("g7crU");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");

var $a4XJc = parcelRequire("a4XJc");

var $iDGXn = parcelRequire("iDGXn");

var $gbfZY = parcelRequire("gbfZY");
const $f6c7407ca4cb16c0$export$2709cff9d915e6db = ({ setIsActiveStandup: setIsActiveStandup, boardId: boardId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { setIsFullscreen: setIsFullscreenNav3 } = (0, $iDGXn.useViewSettingsActions)();
    const [, { setIsFullscreen: setIsFullscreen }] = (0, $g7crU.useIsFullscreen)();
    const exitFullscreen = (0, $5uXOq.useCallback)(()=>{
        (0, $3HwlS.getWillShowNav4)() ? setIsFullscreen(false) : setIsFullscreenNav3({
            boardId: boardId,
            isFullscreen: false,
            view: (0, $a4XJc.View).BOARD
        });
    }, [
        boardId,
        setIsFullscreen,
        setIsFullscreenNav3
    ]);
    const handleExitStandup = (analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'exitStandup');
        exitFullscreen();
        setIsActiveStandup(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        onClick: (__, analyticsEvent)=>handleExitStandup(analyticsEvent)
    }, formatMessage((0, $gbfZY.default).endStandupButton));
};

});
parcelRegister("gbfZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $af19942960201f27$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $af19942960201f27$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    endStandupButton: {
        "id": "standups.control-buttons.end-standup-button.end-standup-button",
        "defaultMessage": "End stand-up"
    }
});

});


parcelRegister("4t4Ir", function(module, exports) {

$parcel$export(module.exports, "StartStandupButton", () => $a39a5cfe8dd462a1$export$fe5db2ceb09d92ff);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $3bDjY = parcelRequire("3bDjY");

var $47gW9 = parcelRequire("47gW9");

var $koVbs = parcelRequire("koVbs");

var $g7crU = parcelRequire("g7crU");

var $3HwlS = parcelRequire("3HwlS");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $a4XJc = parcelRequire("a4XJc");

var $iDGXn = parcelRequire("iDGXn");

var $5E2gE = parcelRequire("5E2gE");

var $lIeg9 = parcelRequire("lIeg9");
const $a39a5cfe8dd462a1$export$fe5db2ceb09d92ff = ({ setIsActiveStandup: setIsActiveStandup, isStandupDisabled: isStandupDisabled, boardId: boardId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, $5E2gE.StandupEntryPointContext));
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const { setIsFullscreen: setIsFullscreenNav3 } = (0, $iDGXn.useViewSettingsActions)();
    const [, { setIsFullscreen: setIsFullscreen }] = (0, $g7crU.useIsFullscreen)();
    const enterFullscreen = (0, $5uXOq.useCallback)(()=>{
        (0, $3HwlS.getWillShowNav4)() ? setIsFullscreen(true) : setIsFullscreenNav3({
            boardId: boardId,
            isFullscreen: true,
            view: (0, $a4XJc.View).BOARD
        });
    }, [
        boardId,
        setIsFullscreen,
        setIsFullscreenNav3
    ]);
    const handleStartStandup = (analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'startStandup');
        enterFullscreen();
        setIsActiveStandup(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "jiraStandupsStartStandupButton",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: isStandupDisabled ? formatMessage((0, $lIeg9.default).disabledButtonTooltip) : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        isDisabled: isStandupDisabled,
        ref: triggerRef,
        onClick: (__, analyticsEvent)=>handleStartStandup(analyticsEvent)
    }, formatMessage((0, $lIeg9.default).startStandupButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            isStandupDisabled: isStandupDisabled
        }
    }));
};

});
parcelRegister("5E2gE", function(module, exports) {

$parcel$export(module.exports, "StandupEntryPointContext", () => $87450d443c36211f$export$66552b8e540e0b2b);
$parcel$export(module.exports, "StandupEntryPointContextProvider", () => $87450d443c36211f$export$943440c649300e6f);

var $5uXOq = parcelRequire("5uXOq");

var $4mO32 = parcelRequire("4mO32");

var $l37qh = parcelRequire("l37qh");

var $1mezY = parcelRequire("1mezY");
const $87450d443c36211f$export$66552b8e540e0b2b = (0, $l37qh.createUseEntryPointContext)();
const $87450d443c36211f$export$943440c649300e6f = ({ children: children })=>{
    const entryPointResult = (0, $4mO32.useEntryPoint)((0, $1mezY.jiraStandupEntryPoint), {});
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87450d443c36211f$export$66552b8e540e0b2b.Provider, {
        value: entryPointResult
    }, children);
};

});
parcelRegister("1mezY", function(module, exports) {

$parcel$export(module.exports, "jiraStandupEntryPoint", () => $20b2e16533aca3fb$export$e1b42fdba7af5e78);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $20b2e16533aca3fb$export$e1b42fdba7af5e78 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("3CuJb")), {
        moduleId: "1749eef2"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3CuJb", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("47UHW")
]).then(()=>parcelRequire('eN97g'));

});



parcelRegister("lIeg9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c302fcb244bfcbe4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c302fcb244bfcbe4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    startStandupButton: {
        "id": "standups.control-buttons.start-standup-button.start-standup-button",
        "defaultMessage": "Start stand-up"
    },
    disabledButtonTooltip: {
        "id": "standups.control-buttons.start-standup-button.disabled-button-tooltip",
        "defaultMessage": "A sprint needs to be started in the backlog before you can begin stand-up"
    }
});

});



parcelRegister("gKBVc", function(module, exports) {

$parcel$export(module.exports, "useIsEmbedView", () => $663910b24a55eb33$export$83ee417ebec96ced);

var $2gnjX = parcelRequire("2gnjX");

var $k7fxM = parcelRequire("k7fxM");

var $dIdda = parcelRequire("dIdda");
const $663910b24a55eb33$export$83ee417ebec96ced = ()=>{
    const [{ route: route }] = (0, $dIdda.useRouter)();
    return route.name === (0, $2gnjX.softwareBoardEmbedRoute).name || route.name === (0, $k7fxM.classicSoftwareBoardEmbedRoute).name;
};

});

parcelRegister("69EQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b988c799e1e8c3$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $bC2fB = parcelRequire("bC2fB");

var $2ON1s = parcelRequire("2ON1s");

var $k8auG = parcelRequire("k8auG");

var $6g14V = parcelRequire("6g14V");

var $hNzgP = parcelRequire("hNzgP");
const $31b988c799e1e8c3$var$mapStateToProps = (state, ownProps)=>({
        isInsightsPanelOpen: (0, $6g14V.getInsightsPanel)(state),
        boardId: ownProps.boardId,
        edition: ownProps?.edition,
        isSprintsEnabled: ownProps.isSprintsEnabled,
        isHeaderCompactMode: (0, $k8auG.getIsHeaderCompactMode)(state)
    });
const $31b988c799e1e8c3$var$mapDispatchToProps = {
    onToggleInsightsPanel: (0, $2ON1s.togglePanel)
};
var $31b988c799e1e8c3$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($31b988c799e1e8c3$var$mapStateToProps, $31b988c799e1e8c3$var$mapDispatchToProps)((0, $hNzgP.InsightsButton));

});
parcelRegister("hNzgP", function(module, exports) {

$parcel$export(module.exports, "InsightsButton", () => $c976da2056b8fe89$export$95e4a3c3bc863d9c);

var $5uXOq = parcelRequire("5uXOq");

var $co1wz = parcelRequire("co1wz");

var $4IRtU = parcelRequire("4IRtU");

var $5HeQO = parcelRequire("5HeQO");

var $7BuUr = parcelRequire("7BuUr");

var $dAfqg = parcelRequire("dAfqg");

var $046Kp = parcelRequire("046Kp");

var $2xFXk = parcelRequire("2xFXk");


var $67sX6 = parcelRequire("67sX6");

var $2ON1s = parcelRequire("2ON1s");

var $63LqY = parcelRequire("63LqY");
const $c976da2056b8fe89$var$InsightsButtonSofwareOnly = (props)=>{
    const isSupported = (0, $7BuUr.useIsCurrentBrowserSupported)();
    const isVisible = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_BOARD_INSIGHT_BUTTON);
    const closeViewSettingsPanelAction = (0, $67sX6.useBoardActionCreator)(()=>(0, $2ON1s.closeViewSettingsPanel)());
    const { isInsightsPanelOpen: isInsightsPanelOpen, onToggleInsightsPanel: onToggleInsightsPanel, boardId: boardId, edition: edition, isSprintsEnabled: isSprintsEnabled, isHeaderCompactMode: isHeaderCompactMode } = props;
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const onToggleInsightsPanelHandler = (0, $5uXOq.useCallback)(()=>{
        onToggleInsightsPanel((0, $8cd646738f5ee7ac$export$29d7f2210b16d662));
        closeViewSettingsPanelAction();
    }, [
        closeViewSettingsPanelAction,
        onToggleInsightsPanel
    ]);
    if (!isSupported || !isVisible) return null;
    // this is only because of flow, it will never happen
    if (!edition) return null;
    if (!isSprintsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HeQO.KanbanBoardInsightsButton), {
        isSimplifiedProject: !isCMPBoard,
        isOpen: isInsightsPanelOpen,
        isCompact: isHeaderCompactMode,
        boardId: Number(boardId),
        edition: edition,
        onToggle: onToggleInsightsPanelHandler
    });
    if (isSprintsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IRtU.BoardInsightsButton), {
        isSimplifiedProject: !isCMPBoard,
        isOpen: isInsightsPanelOpen,
        isCompact: isHeaderCompactMode,
        boardId: Number(boardId),
        edition: edition,
        onToggle: onToggleInsightsPanelHandler
    });
    return null;
};
const $c976da2056b8fe89$var$InsightsButtonCommon = (props)=>{
    const isSupported = (0, $7BuUr.useIsCurrentBrowserSupported)();
    const isVisibleForSoftware = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_BOARD_INSIGHT_BUTTON);
    const isVisibleForServiceDesk = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_JSM_BOARD_INSIGHT_BUTTON);
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const closeViewSettingsPanelAction = (0, $67sX6.useBoardActionCreator)(()=>(0, $2ON1s.closeViewSettingsPanel)());
    const { isInsightsPanelOpen: isInsightsPanelOpen, onToggleInsightsPanel: onToggleInsightsPanel, boardId: boardId, edition: edition, isSprintsEnabled: isSprintsEnabled, isHeaderCompactMode: isHeaderCompactMode } = props;
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const onToggleInsightsPanelHandler = (0, $5uXOq.useCallback)(()=>{
        onToggleInsightsPanel((0, $8cd646738f5ee7ac$export$29d7f2210b16d662));
        closeViewSettingsPanelAction();
    }, [
        closeViewSettingsPanelAction,
        onToggleInsightsPanel
    ]);
    if (!isSupported) return null;
    // this is only because of flow, it will never happen
    if (!edition) return null;
    if (isVisibleForServiceDesk) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $046Kp.ServicedeskBoardInsightsButton), {
        isSimplifiedProject: !isCMPBoard,
        isOpen: isInsightsPanelOpen,
        boardId: Number(boardId),
        edition: edition,
        projectId: project?.projectId,
        onToggle: onToggleInsightsPanelHandler
    });
    if (isVisibleForSoftware) {
        if (isSprintsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IRtU.BoardInsightsButton), {
            isSimplifiedProject: !isCMPBoard,
            isOpen: isInsightsPanelOpen,
            isCompact: isHeaderCompactMode,
            boardId: Number(boardId),
            edition: edition,
            onToggle: onToggleInsightsPanelHandler
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HeQO.KanbanBoardInsightsButton), {
            isSimplifiedProject: !isCMPBoard,
            isOpen: isInsightsPanelOpen,
            isCompact: isHeaderCompactMode,
            boardId: Number(boardId),
            edition: edition,
            onToggle: onToggleInsightsPanelHandler
        });
    }
    return null;
};
const $c976da2056b8fe89$export$95e4a3c3bc863d9c = (props)=>(0, $co1wz.ff)('jsm-board-insights-issues-for-attention_erwbg') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c976da2056b8fe89$var$InsightsButtonCommon, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c976da2056b8fe89$var$InsightsButtonSofwareOnly, props);

});
parcelRegister("4IRtU", function(module, exports) {

$parcel$export(module.exports, "BoardInsightsButton", () => $28fa7d49554cc6cb$export$804ff759e12a79a5);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $4Fbrj = parcelRequire("4Fbrj");


var $9Y7dM = parcelRequire("9Y7dM");

var $9YlLW = parcelRequire("9YlLW");

var $7BuUr = parcelRequire("7BuUr");

var $0241A = parcelRequire("0241A");

var $6OlO8 = parcelRequire("6OlO8");

var $cOddg = parcelRequire("cOddg");

var $1UEsW = parcelRequire("1UEsW");

var $gkPFQ = parcelRequire("gkPFQ");

var $2KxPr = parcelRequire("2KxPr");

var $6f6NP = parcelRequire("6f6NP");

var $ebnTF = parcelRequire("ebnTF");

var $apoVO = parcelRequire("apoVO");

var $g5uUm = parcelRequire("g5uUm");

var $koVbs = parcelRequire("koVbs");

var $cfDZ3 = parcelRequire("cfDZ3");

var $iXVV6 = parcelRequire("iXVV6");

var $l60Zc = parcelRequire("l60Zc");

var $hCKQh = parcelRequire("hCKQh");
const $28fa7d49554cc6cb$var$BoardInsightsButtonComponent = ({ isCompact: isCompact = false, isSimplifiedProject: isSimplifiedProject, isOpen: isOpen, boardId: boardId, onToggle: onToggle, edition: edition, projectId: projectId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const isSupported = (0, $7BuUr.useIsCurrentBrowserSupported)();
    const [isOnboardingApplicable, setIsOnboardingApplicable] = (0, $5uXOq.useState)(false);
    const markOnboardingApplicable = (0, $5uXOq.useCallback)(()=>setIsOnboardingApplicable(true), []);
    const markOnboardingInapplicable = (0, $5uXOq.useCallback)(()=>setIsOnboardingApplicable(false), []);
    const [{ info: { isAnyLevelOfAdmin: isAnyLevelOfAdmin, isProjectType: isProjectType, uniqueId: uniqueId }, data: { hasPermission: hasPermission } }, { onDataUpdatedCallback: onDataUpdatedCallback, refreshUniqueId: refreshUniqueId, updateIsDeepLinking: updateIsDeepLinking }] = (0, $6f6NP.useInsightsContainer)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen) updateIsDeepLinking(false);
    }, [
        updateIsDeepLinking,
        isOpen,
        isSimplifiedProject
    ]);
    // refresh experience when insights (panel) is closed
    (0, $0241A.useValueChangeEffect)({
        listener: isOpen,
        callback: (current, previous)=>{
            if (current === false && previous === true) refreshUniqueId();
        }
    }, [
        refreshUniqueId
    ]);
    const currentPermissionStatus = (0, $ebnTF.getTextValue)(hasPermission, (0, $9Y7dM.permissionStatus).LOADING);
    const renderTooltip = (0, $5uXOq.useCallback)(({ children: children })=>{
        const message = formatMessage((0, $hCKQh.default).tooltip);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: message
        }, children);
    }, [
        formatMessage
    ]);
    return isSupported ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            boardId: boardId,
            frameworkType: (0, $4Fbrj.boardType).SCRUM,
            edition: edition,
            experienceId: uniqueId,
            projectId: projectId,
            userLocation: userLocation
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gkPFQ.InsightsSpotlight), {
        onOpenInsightsPanel: ()=>!isOpen && onToggle(),
        onDismiss: markOnboardingInapplicable,
        isOnboardingApplicable: isOnboardingApplicable
    }), currentPermissionStatus === (0, $9Y7dM.permissionStatus).LOADING && (isSimplifiedProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOddg.CheckSimplifiedDataPermission), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOddg.CheckClassicViewAggregatedDataPermission), {
        boardId: boardId,
        userLocation: userLocation,
        onPermissionLoaded: onDataUpdatedCallback('hasPermission'),
        onInsightsEnabledWithoutPermission: markOnboardingApplicable
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g5uUm.InsightsButton), {
        isInsightsPanelOpen: isOpen,
        isCompact: isCompact,
        boardId: boardId,
        onToggle: onToggle,
        isAnyLevelOfAdmin: !isSimplifiedProject && isAnyLevelOfAdmin,
        isHidden: !isProjectType,
        isOnboardingDisabled: !isSimplifiedProject ? currentPermissionStatus !== (0, $9Y7dM.permissionStatus).ALLOWED : undefined,
        renderTooltip: renderTooltip
    }))) : null;
};
const $28fa7d49554cc6cb$var$BoardInsightsButtonWithContainer = (props)=>{
    const scope = (0, $6OlO8.buildBoardScopeName)({
        isSimplifiedProject: props.isSimplifiedProject,
        boardId: props.boardId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $apoVO.InsightsContainer), {
        scope: scope,
        packageName: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28fa7d49554cc6cb$var$BoardInsightsButtonComponent, props));
};
const $28fa7d49554cc6cb$var$BoardInsightsButtonFinal = $28fa7d49554cc6cb$var$BoardInsightsButtonWithContainer;
const $28fa7d49554cc6cb$var$SafeBoardInsightsButton = (0, $2KxPr.withComponentSafety)($28fa7d49554cc6cb$var$BoardInsightsButtonFinal, {
    condition: ({ boardId: boardId })=>(0, $9YlLW.isValidBoardId)({
            boardId: boardId
        }),
    location: (0, $l60Zc.BOARD_BUTTON_ID),
    message: ({ boardId: boardId })=>`Board button received invalid boardId: ${boardId}`
});
const $28fa7d49554cc6cb$export$804ff759e12a79a5 = (0, $1UEsW.WithInsightsErrorBoundary)($28fa7d49554cc6cb$var$SafeBoardInsightsButton, (0, $b0e6fec6a4686296$export$1269ea4f2b198811), (0, $b0e6fec6a4686296$export$d3996f57ffa8448f));

});
parcelRegister("9Y7dM", function(module, exports) {

$parcel$export(module.exports, "permissionStatus", () => $0d3bfc9bd66c1fa3$export$b7019a8563593449);
const $0d3bfc9bd66c1fa3$export$b7019a8563593449 = {
    LOADING: 'LOADING',
    ALLOWED: 'ALLOWED',
    DISALLOWED: 'DISALLOWED'
};

});

parcelRegister("9YlLW", function(module, exports) {

$parcel$export(module.exports, "getMessageFromEstimationUnit", () => $74b4eed620b03a26$export$680a8efbdf2f2020);
$parcel$export(module.exports, "getCommonMessageDescriptorFromEstimationUnit", () => $74b4eed620b03a26$export$c0f3281b1c14f2e6);
$parcel$export(module.exports, "getEstimatedUnit", () => $74b4eed620b03a26$export$120f64ac447e3a5a);
$parcel$export(module.exports, "getUpdatedEstimation", () => $74b4eed620b03a26$export$5ec90264a55fd048);
$parcel$export(module.exports, "getPermissionEnum", () => $74b4eed620b03a26$export$8e09a9f3c4b56097);
$parcel$export(module.exports, "isValidBoardId", () => $74b4eed620b03a26$export$e168d1e9d0082d6a);

var $e4eHl = parcelRequire("e4eHl");

var $6s1PB = parcelRequire("6s1PB");


var $cpUUk = parcelRequire("cpUUk");

var $8uXQO = parcelRequire("8uXQO");
const $74b4eed620b03a26$export$680a8efbdf2f2020 = ({ estimationUnit: estimationUnit, messages: messages })=>{
    if (!messages[estimationUnit]) throw new Error(`Unsupported estimationUnit: ${estimationUnit} for ${JSON.stringify(messages)}`);
    return messages[estimationUnit];
};
const $74b4eed620b03a26$export$c0f3281b1c14f2e6 = (estimationUnit)=>{
    let issueTermRefreshSuffix = '';
    if (estimationUnit === 'ISSUE_COUNT' && (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) issueTermRefreshSuffix = 'IssueTermRefresh';
    const estimationUnitCamelCase = (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(estimationUnit);
    const labelDescriptorName = `${estimationUnitCamelCase}Label${issueTermRefreshSuffix}`;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ issueCountLabel: MessageDescriptorV2; storyPointsLabel: MessageDescriptorV2; timeOriginalEstimateLabel: MessageDescriptorV2; sprints: MessageDescriptorV2; issueCount: MessageDescriptorV2; storyPoints: MessageDescriptorV2; }'.
    if (!(0, $8uXQO.messages)[labelDescriptorName]) throw new Error(`Unsupported estimationUnit: ${estimationUnit}, label not found for ${labelDescriptorName}} in ${JSON.stringify(Object.keys((0, $8uXQO.messages)))}`);
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ issueCountLabel: MessageDescriptorV2; storyPointsLabel: MessageDescriptorV2; timeOriginalEstimateLabel: MessageDescriptorV2; sprints: MessageDescriptorV2; issueCount: MessageDescriptorV2; storyPoints: MessageDescriptorV2; }'.
    return (0, $8uXQO.messages)[labelDescriptorName];
};
const $74b4eed620b03a26$export$120f64ac447e3a5a = (estimationUnit, estimation)=>{
    // these endpoints returning null shouldn't happen, so let's degrade gracefully
    switch(estimationUnit){
        case (0, $cpUUk.EstimationUnit).ISSUE_COUNT:
            return estimation.issueCount || 0;
        case (0, $cpUUk.EstimationUnit).STORY_POINTS:
            return estimation.storyPoints != null ? parseFloat(estimation.storyPoints.toFixed(1)) : 0;
        case (0, $cpUUk.EstimationUnit).TIME_TRACKING:
            return estimation.time || 0;
        default:
            throw new Error(`Unexpected estimation type: ${estimationUnit}`);
    }
};
const $74b4eed620b03a26$export$5ec90264a55fd048 = (estimationUnit, estimation, value)=>{
    switch(estimationUnit){
        case (0, $cpUUk.EstimationUnit).ISSUE_COUNT:
            return {
                ...estimation,
                issueCount: value
            };
        case (0, $cpUUk.EstimationUnit).STORY_POINTS:
            return {
                ...estimation,
                storyPoints: value
            };
        case (0, $cpUUk.EstimationUnit).TIME_TRACKING:
            return {
                ...estimation,
                time: value
            };
        default:
            throw new Error(`Unexpected estimation type: ${estimationUnit}`);
    }
};
const $74b4eed620b03a26$export$8e09a9f3c4b56097 = (value, defaultValue)=>value === null || value === undefined ? defaultValue : value;
const $74b4eed620b03a26$export$8081780e7051e8dd = (boardId)=>`print-halfway-alert-${boardId ?? (0, $b298cf836b53195d$export$bc8ae8b96c2da16b)}`;
const $74b4eed620b03a26$export$9eca4630c417f1b = (boardId)=>`auto-expand-halfway-alert-${boardId ?? (0, $b298cf836b53195d$export$bc8ae8b96c2da16b)}`;
const $74b4eed620b03a26$export$e168d1e9d0082d6a = ({ boardId: boardId })=>{
    // BoardId must be a positive integer
    if (boardId === undefined || boardId === null || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    !(Number.isInteger(boardId) && boardId > 0)) return false;
    return true;
};
const $74b4eed620b03a26$export$2e033b8f7ea3f02a = ({ boardId: boardId })=>{
    if (typeof boardId !== 'string') return false;
    return /^[0-9]+$/.test(boardId) && Number.parseInt(boardId, 10) > 0;
};

});
const $b298cf836b53195d$export$5c425db6689b9aae = 'no-account-id';
const $b298cf836b53195d$export$bc8ae8b96c2da16b = 'no-board-id';

parcelRegister("cpUUk", function(module, exports) {

$parcel$export(module.exports, "EstimationUnit", () => $e74c6047a4f07896$export$65cc899e447718b8);
const $e74c6047a4f07896$export$65cc899e447718b8 = {
    STORY_POINTS: 'STORY_POINTS',
    ISSUE_COUNT: 'ISSUE_COUNT',
    TIME_TRACKING: 'TIME_TRACKING',
    OTHER: 'OTHER'
};
const $e74c6047a4f07896$export$c17e0027053340c = 'OTHER';

});

parcelRegister("8uXQO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $34dd4dbb16b250cb$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $34dd4dbb16b250cb$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    storyPoints: {
        "id": "insights-common.common.story-points",
        "defaultMessage": "{value, plural, one {point} other {points}}"
    },
    issueCount: {
        "id": "insights-common.common.issue-count",
        "defaultMessage": "{value, plural, one {issue} other {issues}}"
    },
    sprints: {
        "id": "insights-common.common.sprints",
        "defaultMessage": "{sprintCount, plural, one {sprint} other {sprints}}"
    },
    timeTrackingLabel: {
        "id": "insights-common.common.time-tracking-label",
        "defaultMessage": "time estimation"
    },
    storyPointsLabel: {
        "id": "insights-common.common.story-points-label",
        "defaultMessage": "story points"
    },
    issueCountLabel: {
        "id": "insights-common.common.issue-count-label",
        "defaultMessage": "issue count"
    },
    issueCountIssueTermRefresh: {
        "id": "insights-common.common.issue-count-issue-term-refresh",
        "defaultMessage": "{value, plural, one {issue} other {issues}}"
    },
    issueCountLabelIssueTermRefresh: {
        "id": "insights-common.common.issue-count-label-issue-term-refresh",
        "defaultMessage": "issue count"
    }
});

});


parcelRegister("7BuUr", function(module, exports) {

$parcel$export(module.exports, "useIsCurrentBrowserSupported", () => $8c56e783e1a84cd8$export$e2f83ae69f04608f);

var $5uXOq = parcelRequire("5uXOq");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8c56e783e1a84cd8$var$isDefined = (value)=>value !== null && value !== undefined;
const $8c56e783e1a84cd8$var$isCurrentBrowserSupported = ()=>{
    // Supported from:
    // Chrome 66
    // Safari 12.1
    // Edge 16
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!$8c56e783e1a84cd8$var$isDefined(window?.AbortController)) return false;
    return true;
};
const $8c56e783e1a84cd8$export$e2f83ae69f04608f = ()=>{
    const isSupported = (0, $5uXOq.useMemo)(()=>$8c56e783e1a84cd8$var$isCurrentBrowserSupported(), []);
    return isSupported;
};

});

parcelRegister("0241A", function(module, exports) {

$parcel$export(module.exports, "useValueChangeEffect", () => $bc4d44bb107dee16$export$7dd9a2cc149d56b3);

var $5uXOq = parcelRequire("5uXOq");
const $bc4d44bb107dee16$export$7dd9a2cc149d56b3 = ({ listener: listener, callback: callback }, deps = [])=>{
    const previous = (0, $5uXOq.useRef)(listener);
    (0, $5uXOq.useEffect)(()=>{
        if (listener !== previous.current) callback(listener, previous.current);
        previous.current = listener;
    /* We do not memoize the callback as this will change every render
		 * But it is important to pass in all dependencies used in the callback */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        listener,
        ...deps
    ]);
};

});

parcelRegister("6OlO8", function(module, exports) {

$parcel$export(module.exports, "buildBoardScopeName", () => $9fd1aa0f281e7d95$export$7cfa8d622acbc99f);
$parcel$export(module.exports, "buildBacklogScopeName", () => $9fd1aa0f281e7d95$export$68610636ce5df399);

const $9fd1aa0f281e7d95$export$7cfa8d622acbc99f = ({ isSimplifiedProject: isSimplifiedProject, boardId: boardId })=>`${isSimplifiedProject ? (0, $b0e6fec6a4686296$export$8e66b21ec141a0bd) : (0, $b0e6fec6a4686296$export$c9290acd1ba498ff)}-boardId:${boardId}`;
const $9fd1aa0f281e7d95$export$68610636ce5df399 = ({ isSimplifiedProject: isSimplifiedProject, boardId: boardId })=>`${isSimplifiedProject ? (0, $b0e6fec6a4686296$export$75eb9639a5b0ba25) : (0, $b0e6fec6a4686296$export$2fd6d7f902b01d67)}-boardId:${boardId}`;

});

parcelRegister("cOddg", function(module, exports) {

$parcel$export(module.exports, "CheckClassicViewAggregatedDataPermission", () => $09f9796263d4f1f9$export$379f6e97a42d4a9d);
$parcel$export(module.exports, "CheckSimplifiedDataPermission", () => $09f9796263d4f1f9$export$b5e65dc6f010c84c);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");


var $9Y7dM = parcelRequire("9Y7dM");

var $dfjss = parcelRequire("dfjss");

var $iuEfD = parcelRequire("iuEfD");

var $6WV5x = parcelRequire("6WV5x");

var $47u1P = parcelRequire("47u1P");

const $09f9796263d4f1f9$export$379f6e97a42d4a9d = ({ boardId: boardId, userLocation: userLocation, onPermissionLoaded: onPermissionLoaded, onInsightsEnabledWithoutPermission: onInsightsEnabledWithoutPermission })=>{
    const eventFrom = (0, $dfjss.getBoardOrBacklogFromLocation)(userLocation);
    const actionSubject = `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.${eventFrom}`;
    const [{ data: permissionResult, loading: loading, fetched: fetched, aborted: aborted, hasError: hasError }] = (0, $iuEfD.useFetch)({
        onFetch: (options)=>(0, $6WV5x.fetchInsightPermission)({
                boardId: boardId
            }, options),
        browserMetricsKey: `${actionSubject}.${(0, $4de57a9072cf4c55$export$5dad270161d08a8c)}`,
        analyticsTracking: {
            actionSubject: `${actionSubject}.${(0, $4de57a9072cf4c55$export$5dad270161d08a8c)}`,
            packageName: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f)
        },
        loggingKey: (0, $4de57a9072cf4c55$export$5dad270161d08a8c)
    }, []);
    const [_, setShouldUseJQLData] = (0, $47u1P.useLocalStorage)('jira-insights-should-use-jql', 'shouldUseJQLQuery', {
        defaultValue: false
    });
    (0, $5uXOq.useEffect)(()=>{
        if (loading) onPermissionLoaded((0, $9Y7dM.permissionStatus).LOADING);
        if (fetched && !hasError && !aborted) {
            if (permissionResult) {
                onPermissionLoaded((0, $9Y7dM.permissionStatus).ALLOWED);
                setShouldUseJQLData((0, $4R6GH.fg)('insights-use_jql_query_for_enabled_users'));
            } else if ((0, $6s1PB.expVal)('jira_insights_open-insights', 'isEnabled', false)) {
                onPermissionLoaded((0, $9Y7dM.permissionStatus).ALLOWED);
                onInsightsEnabledWithoutPermission?.();
                setShouldUseJQLData(true);
            } else onPermissionLoaded((0, $9Y7dM.permissionStatus).DISALLOWED);
        }
        if (hasError || aborted) onPermissionLoaded((0, $9Y7dM.permissionStatus).DISALLOWED);
    }, [
        fetched,
        loading,
        aborted,
        permissionResult,
        hasError,
        onPermissionLoaded,
        setShouldUseJQLData,
        onInsightsEnabledWithoutPermission
    ]);
    return null;
};
const $09f9796263d4f1f9$export$b5e65dc6f010c84c = ()=>{
    const [_, setShouldUseJQLData] = (0, $47u1P.useLocalStorage)('jira-insights-should-use-jql', 'shouldUseJQLQuery', {
        defaultValue: false
    });
    (0, $5uXOq.useEffect)(()=>{
        setShouldUseJQLData((0, $4R6GH.fg)('insights-use_jql_query_for_enabled_users'));
    }, [
        setShouldUseJQLData
    ]);
    return null;
};

});
parcelRegister("dfjss", function(module, exports) {

$parcel$export(module.exports, "getBoardOrBacklogFromLocation", () => $8952e8de617aa53a$export$bb6a57ca7b7487bb);

const $8952e8de617aa53a$var$locations = {
    [(0, $b117e2ebd359768a$export$743304c0b847bdee)]: (0, $b117e2ebd359768a$export$dedbdcc35e955187),
    [(0, $b117e2ebd359768a$export$47ae5cd4a7ee5f2a)]: (0, $b117e2ebd359768a$export$dedbdcc35e955187),
    [(0, $b117e2ebd359768a$export$40705e2848d2f6a5)]: (0, $b117e2ebd359768a$export$9b8283d5878d2491),
    [(0, $b117e2ebd359768a$export$f995350d8da9bb90)]: (0, $b117e2ebd359768a$export$9b8283d5878d2491)
};
const $8952e8de617aa53a$export$bb6a57ca7b7487bb = (userLocation)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "software:software-backlog": "backlog"; readonly "classic-software:rapidboard-backlog": "backlog"; readonly "software:software-boards": "board"; readonly "classic-software:rapidboard-board": "board"; }'.
    $8952e8de617aa53a$var$locations[userLocation] || (0, $b117e2ebd359768a$export$5f4028218eaee319);

});
const $b117e2ebd359768a$export$dedbdcc35e955187 = 'backlog';
const $b117e2ebd359768a$export$9b8283d5878d2491 = 'board';
const $b117e2ebd359768a$export$5f4028218eaee319 = 'unknown';
const $b117e2ebd359768a$export$47ae5cd4a7ee5f2a = 'classic-software:rapidboard-backlog';
const $b117e2ebd359768a$export$f995350d8da9bb90 = 'classic-software:rapidboard-board';
const $b117e2ebd359768a$export$743304c0b847bdee = 'software:software-backlog';
const $b117e2ebd359768a$export$40705e2848d2f6a5 = 'software:software-boards';


parcelRegister("6WV5x", function(module, exports) {

$parcel$export(module.exports, "fetchInsightPermission", () => $3d7ce849d39a845d$export$a465feaffcf65c97);

var $48DMb = parcelRequire("48DMb");
const $3d7ce849d39a845d$export$a465feaffcf65c97 = async ({ boardId: boardId }, options)=>{
    const response = await (0, $48DMb.fetchJson)(`/rest/internal/board/${boardId}/insight-permission`, options);
    return response && response.allowed;
};

});

parcelRegister("47u1P", function(module, exports) {

$parcel$export(module.exports, "useLocalStorage", () => $4772a73a96e71e67$export$86e2cef2561044ac);
$parcel$export(module.exports, "useLocalStorageWithExpiry", () => $4772a73a96e71e67$export$9c89ac8256e92fbb);

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");
const $4772a73a96e71e67$var$isSetStateFunction = (setStateAction)=>typeof setStateAction === 'function';
const $4772a73a96e71e67$export$86e2cef2561044ac = (namespace, key, options)=>{
    const localStorage = (0, $bSSG7.createLocalStorageProvider)(namespace);
    const initialValue = localStorage.get(key) ?? options?.defaultValue;
    // used to trigger re-render of components
    const [value, setValueInState] = (0, $5uXOq.useState)(initialValue);
    const setValue = (0, $5uXOq.useCallback)((setStateAction)=>{
        if ($4772a73a96e71e67$var$isSetStateFunction(setStateAction)) setValueInState((prevVal)=>{
            const newVal = setStateAction(prevVal);
            localStorage.set(key, newVal);
            return newVal;
        });
        else {
            localStorage.set(key, setStateAction);
            setValueInState(setStateAction);
        }
    }, [
        key,
        localStorage
    ]);
    return [
        value,
        setValue
    ];
};
const $4772a73a96e71e67$export$9c89ac8256e92fbb = (namespace, key, ttlInMs, options)=>{
    const localStorage = (0, $bSSG7.createLocalExpirableStorageProvider)(namespace);
    const initialValue = localStorage.get(key) ?? options?.defaultValue;
    // used to trigger re-render of components
    const [value, setValueInState] = (0, $5uXOq.useState)(initialValue);
    const setValue = (0, $5uXOq.useCallback)((setStateAction)=>{
        if ($4772a73a96e71e67$var$isSetStateFunction(setStateAction)) setValueInState((prevVal)=>{
            const newVal = setStateAction(prevVal);
            localStorage.set(key, newVal, Date.now() + ttlInMs);
            return newVal;
        });
        else {
            localStorage.set(key, setStateAction, Date.now() + ttlInMs);
            setValueInState(setStateAction);
        }
    }, [
        key,
        localStorage,
        ttlInMs
    ]);
    return [
        value,
        setValue
    ];
};
const $4772a73a96e71e67$export$436c2fd92113c067 = (namespace, key, options)=>{
    const [state, setState] = $4772a73a96e71e67$export$86e2cef2561044ac(namespace, key, options);
    return [
        state,
        // This is for batch update
        (objectKey, value)=>setState((prevState)=>({
                    ...prevState,
                    [objectKey]: value
                }))
    ];
};
const $4772a73a96e71e67$export$db70e245473ac2a = (namespace, key, ttlInMs, options)=>{
    const [state, setState] = $4772a73a96e71e67$export$9c89ac8256e92fbb(namespace, key, ttlInMs, options);
    return [
        state,
        // This is for batch update
        (objectKey, value)=>setState((prevState)=>({
                    ...prevState,
                    [objectKey]: value
                }))
    ];
};

});

const $4de57a9072cf4c55$export$5dad270161d08a8c = 'check-insight-permission';


parcelRegister("1UEsW", function(module, exports) {

$parcel$export(module.exports, "WithInsightsErrorBoundary", () => $0d7082c2a6c6ecc7$export$b240a041e4bface8);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $39xOx = parcelRequire("39xOx");

var $93jKl = parcelRequire("93jKl");

var $jb5yn = parcelRequire("jb5yn");

var $f9Owr = parcelRequire("f9Owr");

var $4Fbrj = parcelRequire("4Fbrj");


var $1s62S = parcelRequire("1s62S");
const $0d7082c2a6c6ecc7$var$insightsExperience = {
    experience: (0, $4Fbrj.JIRA_INSIGHTS)
};
const $0d7082c2a6c6ecc7$export$eff352405fe6db90 = ({ id: id, packageName: packageName, children: children, onError: onError = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    if (!(0, $f9Owr.ff)('jsm-board-insights-issues-for-attention_erwbg')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: (0, $b0e6fec6a4686296$export$1269ea4f2b198811),
        packageName: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f),
        teamName: "helios-headcoach",
        fallback: "flag",
        onError: onError
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: "helios-headcoach",
        fallback: "flag",
        onError: onError
    }, children);
};
const $0d7082c2a6c6ecc7$var$BaseInsightsErrorBoundaryWithExperienceTracker = ({ children: children })=>{
    const onFail = (0, $93jKl.useExperienceFail)($0d7082c2a6c6ecc7$var$insightsExperience);
    const { fail: fail } = (0, $1s62S.useInsightsExperience)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d7082c2a6c6ecc7$export$eff352405fe6db90, {
        id: (0, $b0e6fec6a4686296$export$1269ea4f2b198811),
        packageName: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f),
        onError: (...args)=>{
            onFail(...args);
            const [, error] = args;
            fail((0, $4Fbrj.ERROR_BOUNDARY_HIT), error);
        }
    }, children);
};
const $0d7082c2a6c6ecc7$export$cf848bf84642a299 = ({ children: children, experienceIdsToTrack: experienceIdsToTrack = [] })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1s62S.InsightsExperienceTracker), {
        experienceId: (0, $4Fbrj.INSIGHTS_PANEL_EXPERIENCE),
        experienceIdsToCollect: experienceIdsToTrack || [],
        timeoutInMs: (0, $4Fbrj.EXPERIENCE_TIMEOUT_MILLIS)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jb5yn.ExperienceTrackerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d7082c2a6c6ecc7$var$BaseInsightsErrorBoundaryWithExperienceTracker, null, children)));
const $0d7082c2a6c6ecc7$export$b240a041e4bface8 = (Component, id, packageName)=>(props)=>{
        if (!(0, $f9Owr.ff)('jsm-board-insights-issues-for-attention_erwbg')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d7082c2a6c6ecc7$export$eff352405fe6db90, {
            id: (0, $b0e6fec6a4686296$export$1269ea4f2b198811),
            packageName: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d7082c2a6c6ecc7$export$eff352405fe6db90, {
            id: id,
            packageName: packageName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props));
    };

});
parcelRegister("1s62S", function(module, exports) {

$parcel$export(module.exports, "InsightsExperienceTracker", () => $86531a62d14892a7$export$9c32e0183f3330c4);
$parcel$export(module.exports, "useInsightsExperience", () => $86531a62d14892a7$export$6a440957407835a0);
$parcel$export(module.exports, "StartInsightsExperience", () => $86531a62d14892a7$export$d8f7e3f6742303b4);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $f9Owr = parcelRequire("f9Owr");


var $dfjss = parcelRequire("dfjss");

var $cfDZ3 = parcelRequire("cfDZ3");

var $30KM0 = parcelRequire("30KM0");

var $2Siis = parcelRequire("2Siis");

var $eUcR1 = parcelRequire("eUcR1");

var $2B9C9 = parcelRequire("2B9C9");

var $bSClU = parcelRequire("bSClU");

var $dfzOH = parcelRequire("dfzOH");
const $86531a62d14892a7$export$9c32e0183f3330c4 = ({ ufoExperience: ufoExperience, experienceId: experienceId, experienceIdsToCollect: experienceIdsToCollect, timeoutInMs: timeoutInMs = (0, $30KM0.TIMEOUT_IN_MS), attributes: attributes, children: children, packageName: packageName })=>{
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const eventFrom = (0, $dfjss.getBoardOrBacklogFromLocation)(userLocation);
    const ufoErrorLogger = (0, $dfzOH.useUfoErrorLogger)({
        eventFrom: eventFrom,
        ufoExperience: ufoExperience
    });
    const insightsPackage = (0, $f9Owr.ff)('jsm-board-insights-issues-for-attention_erwbg') && packageName ? packageName : (0, $b0e6fec6a4686296$export$d3996f57ffa8448f);
    const insightsExperience = `${insightsPackage}.${eventFrom}.${experienceId}`;
    const metricsTracker = (0, $bSClU.useMetricsMemo)(()=>{
        const browserMetricsKey = `${insightsExperience}.${(0, $30KM0.experiences).RENDER}`;
        const metricsAttributes = {
            ...attributes,
            userLocation: userLocation
        };
        const service = (0, $eUcR1.trackBrowserMetricsForJira)({
            browserMetricsKey: browserMetricsKey,
            attributes: metricsAttributes
        });
        return {
            start: ()=>{
                service.start();
                ufoExperience?.start().catch(ufoErrorLogger);
            },
            end: ()=>{
                service.end();
                ufoExperience?.success().catch(ufoErrorLogger);
            },
            cancel: (error)=>{
                // send message to splunk here
                if (error) (0, $dJl1T.default).safeErrorWithoutCustomerData(browserMetricsKey, 'Insights experience failed', new (0, $2Siis.ExperienceError)(error, metricsAttributes));
                service.cancel();
                ufoExperience?.failure().catch(ufoErrorLogger);
            }
        };
    }, [
        insightsExperience,
        userLocation,
        attributes,
        ufoExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2B9C9.InsightsExperienceTrackerStoreContainer), {
        scope: insightsExperience,
        experienceIdsToCollect: experienceIdsToCollect,
        timeoutInMs: timeoutInMs,
        metricsTracker: metricsTracker,
        ufoExperience: ufoExperience
    }, children);
};
const $86531a62d14892a7$export$6a440957407835a0 = ()=>{
    const [, actions] = (0, $2B9C9.useInsightsExperienceTracker)();
    const [isExperienceOwner, setExperienceOwner] = (0, $5uXOq.useState)(false);
    // we only need to expose start, fail and success
    const returnActions = (0, $5uXOq.useMemo)(()=>({
            start: ()=>{
                setExperienceOwner(true);
                actions.start();
            },
            fail: actions.fail,
            success: actions.success
        }), [
        actions,
        setExperienceOwner
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            if (isExperienceOwner === true) actions.reset();
        }, [
        isExperienceOwner,
        actions
    ]);
    return returnActions;
};
const $86531a62d14892a7$export$d8f7e3f6742303b4 = ()=>{
    const { start: start } = $86531a62d14892a7$export$6a440957407835a0();
    (0, $5uXOq.useLayoutEffect)(()=>{
        start();
    }, [
        start
    ]);
    return null;
};

});
parcelRegister("2Siis", function(module, exports) {

$parcel$export(module.exports, "ExperienceError", () => $e57b689d183ecfd7$export$14d796af4fae7309);
class $e57b689d183ecfd7$export$14d796af4fae7309 extends Error {
    constructor(error, extraProps){
        super(error.message);
        this.name = error.name;
        this.stack = error.stack;
        Object.assign(this, {
            ...error
        });
        Object.assign(this, extraProps);
    }
}

});

parcelRegister("2B9C9", function(module, exports) {

$parcel$export(module.exports, "InsightsExperienceTrackerStoreContainer", () => $aa56c148ed849f26$export$ed39ab6b8cf88c60);
$parcel$export(module.exports, "useInsightsExperienceTracker", () => $aa56c148ed849f26$export$941e72d49b686b93);

var $7JoAD = parcelRequire("7JoAD");

var $30KM0 = parcelRequire("30KM0");

var $fKAQw = parcelRequire("fKAQw");

var $k8iQN = parcelRequire("k8iQN");
const $aa56c148ed849f26$var$Store = (0, $7JoAD.createStore)({
    initialState: // @ts-expect-error - TS2322 - Type '{ readonly status: { readonly hasFailed: false; readonly hasCompleted: false; readonly hasStarted: false; readonly hasTimedOut: false; }; readonly timeoutId: null; readonly eventsSuccess: readonly []; readonly eventsFail: readonly []; }' is not assignable to type 'State'.
    $k8iQN.initialState,
    actions: $fKAQw.actions,
    name: (0, $30KM0.STORE_NAME)
});
const $aa56c148ed849f26$export$ed39ab6b8cf88c60 = (0, $7JoAD.createContainer)($aa56c148ed849f26$var$Store);
const $aa56c148ed849f26$export$941e72d49b686b93 = (0, $7JoAD.createHook)($aa56c148ed849f26$var$Store);

});
parcelRegister("fKAQw", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e0f25a0ee99bb826$export$e324594224ef24da);

var $4Fbrj = parcelRequire("4Fbrj");

var $k8iQN = parcelRequire("k8iQN");
const $e0f25a0ee99bb826$var$success = (experienceId)=>({ getState: getState, setState: setState }, { metricsTracker: metricsTracker, experienceIdsToCollect: experienceIdsToCollect, ufoExperience: ufoExperience })=>{
        const state = getState();
        const currentStatus = state.status;
        if (!experienceId) return;
        if (!currentStatus.hasStarted || currentStatus.hasCompleted || currentStatus.hasTimedOut) return;
        if (!experienceIdsToCollect.includes(experienceId)) return;
        if (state.eventsSuccess.includes(experienceId)) return;
        if (ufoExperience != null) ufoExperience.mark(`${experienceId}_success`);
        const nextEventsSuccess = [
            ...state.eventsSuccess,
            experienceId
        ];
        const shouldSetHasCompleted = nextEventsSuccess.length === experienceIdsToCollect.length && !currentStatus.hasCompleted;
        const nextState = {
            status: shouldSetHasCompleted ? {
                ...currentStatus,
                hasCompleted: true
            } : currentStatus,
            timeoutId: state.timeoutId,
            eventsSuccess: [
                ...state.eventsSuccess,
                experienceId
            ],
            eventsFail: state.eventsFail
        };
        setState(nextState);
        if (shouldSetHasCompleted) {
            if (state.timeoutId) clearTimeout(state.timeoutId);
            metricsTracker.end();
        }
    };
const $e0f25a0ee99bb826$var$fail = (experienceId, error)=>({ getState: getState, setState: setState }, { metricsTracker: metricsTracker, experienceIdsToCollect: experienceIdsToCollect, ufoExperience: ufoExperience })=>{
        const state = getState();
        const currentStatus = state.status;
        if (!experienceId) return;
        if (!currentStatus.hasStarted || currentStatus.hasCompleted) return;
        if (!experienceIdsToCollect.includes(experienceId) && // Panel level error boundary hits do not pass in an experienceId,
        // so we accept the constant "error-boundary-hit" in addition to the experienceIds
        // Note: Insight level error boundary hits do pass in experienceId
        experienceId !== (0, $4Fbrj.ERROR_BOUNDARY_HIT)) return;
        if (state.timeoutId) clearTimeout(state.timeoutId);
        if (ufoExperience != null) ufoExperience.mark(`${experienceId}_fail`);
        const nextEventsFail = [
            ...state.eventsFail,
            experienceId
        ];
        const nextState = {
            status: {
                ...currentStatus,
                hasFailed: true
            },
            timeoutId: state.timeoutId,
            eventsSuccess: state.eventsSuccess,
            eventsFail: nextEventsFail
        };
        setState(nextState);
        metricsTracker.cancel(error);
    };
const $e0f25a0ee99bb826$var$timeout = ()=>({ getState: getState, setState: setState }, { metricsTracker: metricsTracker })=>{
        const state = getState();
        const currentStatus = state.status;
        if (!currentStatus.hasStarted || currentStatus.hasCompleted || currentStatus.hasFailed) return;
        const nextState = {
            status: {
                ...currentStatus,
                hasFailed: true,
                hasTimedOut: true
            },
            eventsSuccess: state.eventsSuccess,
            eventsFail: state.eventsFail
        };
        setState(nextState);
        metricsTracker.cancel();
    };
const $e0f25a0ee99bb826$var$start = ()=>({ getState: getState, setState: setState, dispatch: dispatch }, { timeoutInMs: timeoutInMs, metricsTracker: metricsTracker, experienceIdsToCollect: experienceIdsToCollect })=>{
        const state = getState();
        const currentStatus = state.status;
        if (currentStatus.hasCompleted || currentStatus.hasStarted || currentStatus.hasFailed || currentStatus.hasTimedOut || experienceIdsToCollect.length === 0) return;
        const timeoutId = setTimeout(()=>{
            dispatch($e0f25a0ee99bb826$var$timeout());
        }, timeoutInMs);
        const nextState = {
            status: {
                ...currentStatus,
                hasStarted: true
            },
            timeoutId: timeoutId,
            eventsSuccess: [],
            eventsFail: []
        };
        // @ts-expect-error - TS2345 - Argument of type '{ status: { hasStarted: boolean; hasFailed: boolean; hasCompleted: boolean; hasTimedOut: boolean; }; timeoutId: NodeJS.Timeout; eventsSuccess: never[]; eventsFail: never[]; }' is not assignable to parameter of type 'Partial<State>'.
        setState(nextState);
        metricsTracker.start();
    };
const $e0f25a0ee99bb826$var$reset = ()=>({ getState: getState, setState: setState }, { metricsTracker: metricsTracker })=>{
        const state = getState();
        if (state.timeoutId) clearTimeout(state.timeoutId);
        const currentStatus = state.status;
        if (currentStatus.hasStarted && !currentStatus.hasCompleted && !currentStatus.hasFailed && !currentStatus.hasTimedOut) metricsTracker.cancel();
        // @ts-expect-error - TS2345 - Argument of type '{ readonly status: { readonly hasFailed: false; readonly hasCompleted: false; readonly hasStarted: false; readonly hasTimedOut: false; }; readonly timeoutId: null; readonly eventsSuccess: readonly []; readonly eventsFail: readonly []; }' is not assignable to parameter of type 'Partial<State>'.
        setState((0, $k8iQN.initialState));
    };
const $e0f25a0ee99bb826$export$e324594224ef24da = {
    reset: $e0f25a0ee99bb826$var$reset,
    start: $e0f25a0ee99bb826$var$start,
    timeout: $e0f25a0ee99bb826$var$timeout,
    success: $e0f25a0ee99bb826$var$success,
    fail: $e0f25a0ee99bb826$var$fail
};

});
parcelRegister("k8iQN", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $7bb650eee945c3d9$export$d4c72bab9d6cc13a);
const $7bb650eee945c3d9$export$d4c72bab9d6cc13a = {
    status: {
        hasFailed: false,
        hasCompleted: false,
        hasStarted: false,
        hasTimedOut: false
    },
    timeoutId: null,
    eventsSuccess: [],
    eventsFail: []
};

});



parcelRegister("bSClU", function(module, exports) {

$parcel$export(module.exports, "useMetricsMemo", () => $5617a8526f2df6be$export$f5d771045a704f1f);

var $5uXOq = parcelRequire("5uXOq");
const $5617a8526f2df6be$var$isShallowDifferent = (arrayA, arrayB)=>arrayA.length !== arrayB.length || arrayA.some((currentElement, index)=>currentElement !== arrayB[index]);
const $5617a8526f2df6be$export$f5d771045a704f1f = (f, deps)=>{
    const metricsTrackerRef = (0, $5uXOq.useRef)();
    const fetchDependenciesRef = (0, $5uXOq.useRef)(deps);
    (0, $5uXOq.useMemo)(()=>{
        const hasEffectsChanged = $5617a8526f2df6be$var$isShallowDifferent(fetchDependenciesRef.current, deps);
        if (!metricsTrackerRef.current || hasEffectsChanged) {
            if (hasEffectsChanged) fetchDependenciesRef.current = deps;
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            metricsTrackerRef.current = f();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'T'.
    return metricsTrackerRef.current;
};

});

parcelRegister("dfzOH", function(module, exports) {

$parcel$export(module.exports, "useUfoErrorLogger", () => $b799d4cddaf33695$export$688547a52c1d762b);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");


var $30KM0 = parcelRequire("30KM0");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $b799d4cddaf33695$var$noop = ()=>{};
const $b799d4cddaf33695$export$688547a52c1d762b = ({ eventFrom: eventFrom, ufoExperience: ufoExperience })=>{
    const ufoErrorLogger = (0, $5uXOq.useCallback)((error)=>(0, $dJl1T.default).safeErrorWithoutCustomerData(`${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.${eventFrom}.${ufoExperience?.id || 'unknown'}.${(0, $30KM0.experiences).RENDER}`, 'Insights experience failed', error), [
        eventFrom,
        ufoExperience
    ]);
    return ufoExperience ? ufoErrorLogger : $b799d4cddaf33695$var$noop;
};

});



parcelRegister("gkPFQ", function(module, exports) {

$parcel$export(module.exports, "InsightsSpotlight", () => $7a791a009d9ba36f$export$f441a5f6be0f18a);

var $5uXOq = parcelRequire("5uXOq");

var $1QiBP = parcelRequire("1QiBP");

var $eGLgs = parcelRequire("eGLgs");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $bMiSe = parcelRequire("bMiSe");
const $7a791a009d9ba36f$var$INSIGHTS_OPEN_UP_MESSAGE_ID = 'jira-insights-open-up-message';
const $7a791a009d9ba36f$export$f441a5f6be0f18a = ({ onOpenInsightsPanel: onOpenInsightsPanel, onDismiss: onDismiss, isOnboardingApplicable: isOnboardingApplicable })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, isOnboardingApplicable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: $7a791a009d9ba36f$var$INSIGHTS_OPEN_UP_MESSAGE_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a791a009d9ba36f$var$CoordinationStopProvider, null, (stopEngagementMessage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
            actions: [
                {
                    onClick: ()=>{
                        stopEngagementMessage?.();
                        onOpenInsightsPanel();
                        onDismiss();
                    },
                    text: formatMessage((0, $bMiSe.default).viewButtonLabel)
                },
                {
                    onClick: ()=>{
                        stopEngagementMessage?.();
                        onDismiss();
                    },
                    text: formatMessage((0, $bMiSe.default).skipButtonLabel)
                }
            ],
            messageType: "engagement",
            messageId: $7a791a009d9ba36f$var$INSIGHTS_OPEN_UP_MESSAGE_ID,
            target: "jira-insights-button",
            key: $7a791a009d9ba36f$var$INSIGHTS_OPEN_UP_MESSAGE_ID,
            targetRadius: 3,
            dialogPlacement: "bottom right"
        }, formatMessage((0, $bMiSe.default).spotlightContent)))));
};
const $7a791a009d9ba36f$var$CoordinationStopProvider = ({ stop: stop, children: children })=>children(stop);

});
parcelRegister("bMiSe", function(module, exports) {

$parcel$export(module.exports, "default", () => $b00d0f1af606d21a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b00d0f1af606d21a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    skipButtonLabel: {
        "id": "insights-common.insights-spotlight.skip-button-label",
        "defaultMessage": "Skip"
    },
    viewButtonLabel: {
        "id": "insights-common.insights-spotlight.view-button-label",
        "defaultMessage": "View insights"
    },
    spotlightContent: {
        "id": "insights-common.insights-spotlight.spotlight-content",
        "defaultMessage": "Insights have made it to your board and backlog, so you can monitor work and make informed decisions using real-time data."
    }
});

});


parcelRegister("2KxPr", function(module, exports) {

$parcel$export(module.exports, "withComponentSafety", () => $3fc106ae6756d120$export$cb70221ec28d89b);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");
/* condition must return true for component to render */ function $3fc106ae6756d120$export$cb70221ec28d89b(Component, { condition: condition, location: location, message: message = ()=>'withComponentSafety blocked render', Fallback: Fallback = ()=>null }) {
    return (props)=>{
        const isSafe = condition(props);
        const formattedMessage = message(props);
        (0, $5uXOq.useEffect)(()=>{
            if (!isSafe) (0, $dJl1T.default).safeErrorWithoutCustomerData(location, formattedMessage);
        }, [
            isSafe,
            formattedMessage
        ]);
        // @ts-expect-error - Type 'Props' is not assignable to type 'IntrinsicAttributes & Props'.
        return isSafe ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Fallback, props);
    };
}

});

parcelRegister("6f6NP", function(module, exports) {

$parcel$export(module.exports, "useInsightsContainer", () => $19bd560421a87b26$export$8ecf81d0c059927c);

var $5uXOq = parcelRequire("5uXOq");

var $1NrMQ = parcelRequire("1NrMQ");

var $j8sJY = parcelRequire("j8sJY");

var $5h4e8 = parcelRequire("5h4e8");
const $19bd560421a87b26$export$8ecf81d0c059927c = ()=>{
    const [state, actions] = (0, $j8sJY.useInsightsStoreContainer)();
    const memoCallbacksRef = (0, $5uXOq.useRef)({});
    const toggleAction = actions.toggleProp;
    (0, $1NrMQ.useIsAnyLevelOfAdmin)({
        onIsAnyLevelOfAdminUpdated: actions.setInfo
    });
    (0, $5h4e8.useIsProjectType)({
        onIsProjectTypeUpdated: actions.setInfo
    });
    /*
      This will create a memoized function callback scoped to the current scope + propName so we can easily
      call this function from the onClick of any of the composed components.
      ex:
        <InsightsContainer>
          {({ data: { isPanelOpen } }, { onToggleCallback }) => {
            <HidePanelButton onClick={onToggleCallback('isPanelOpen')}
            <Panel isPanelOpen={isPanelOpen} />
          }}
        <InsightsContainer>
    */ const onToggleCallback = (0, $5uXOq.useCallback)((propName)=>{
        if (!memoCallbacksRef.current) memoCallbacksRef.current = {};
        const callbacksMap = memoCallbacksRef.current;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        if (propName && !callbacksMap[propName]) // this will prevent recreate the callback on each render
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        callbacksMap[propName] = ()=>toggleAction(propName);
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        return callbacksMap[propName];
    }, [
        toggleAction
    ]);
    const updateContainerAction = actions.updateContainer;
    /*
      This will create a memoized function callback scoped to the current scope + propName so we can easily
      call this function from the onClick of any of the composed components.
      ex:
        <InsightsContainer>
          {({ data: { settings } }, { onDataUpdatedCallback }) => {
            <LoadPanelSettings onLoad={onDataUpdatedCallback('settings')}
            <Panel settings={settings} />
          }}
        <InsightsContainer>
    */ const onDataUpdatedCallback = (0, $5uXOq.useCallback)((propName)=>{
        if (!memoCallbacksRef.current) memoCallbacksRef.current = {};
        const callbacksMap = memoCallbacksRef.current;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        if (!callbacksMap[propName]) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        callbacksMap[propName] = (data)=>// this will prevent recreate the callback on each render
            updateContainerAction({
                [propName]: data
            });
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        return callbacksMap[propName];
    }, [
        updateContainerAction
    ]);
    return [
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        state,
        {
            onDataUpdatedCallback: // preferred usage is onDataUpdatedCallback and onToggleCallback
            onDataUpdatedCallback,
            onToggleCallback: onToggleCallback,
            // when we need a big customization and onDataUpdatedCallback and onToggleCallback do not fit
            // to solve the problem, we can use the original implementation onUpdate and onToggle
            doUpdate: actions.updateContainer,
            doToggle: actions.toggleProp,
            doClean: actions.cleanState,
            // pass through actions (from insights container)
            refreshUniqueId: actions.refreshUniqueId,
            updateIsDeepLinking: actions.updateIsDeepLinking
        }
    ];
};

});
parcelRegister("1NrMQ", function(module, exports) {

$parcel$export(module.exports, "useIsAnyLevelOfAdmin", () => $ca08f41fafaf028c$export$b29f514064315678);

var $5uXOq = parcelRequire("5uXOq");

var $dAfqg = parcelRequire("dAfqg");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");
const $ca08f41fafaf028c$export$b29f514064315678 = ({ onIsAnyLevelOfAdminUpdated: onIsAnyLevelOfAdminUpdated })=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isProjectAdmin = !!projectContext?.isProjectAdmin;
    (0, $5uXOq.useEffect)(()=>{
        onIsAnyLevelOfAdminUpdated({
            isAnyLevelOfAdmin: !!(isSiteAdmin || isAdmin || isProjectAdmin)
        });
    }, [
        isProjectAdmin,
        isSiteAdmin,
        isAdmin,
        onIsAnyLevelOfAdminUpdated
    ]);
};

});

parcelRegister("j8sJY", function(module, exports) {

$parcel$export(module.exports, "InsightsStoreContainer", () => $1089c091fa1f71a9$export$4b6f97ed14dce97c);
$parcel$export(module.exports, "useInsightsStoreContainer", () => $1089c091fa1f71a9$export$bd382fb3f9d0551e);

var $7JoAD = parcelRequire("7JoAD");


var $hXuQC = parcelRequire("hXuQC");

var $keDMh = parcelRequire("keDMh");
const $1089c091fa1f71a9$var$Store = (0, $7JoAD.createStore)({
    initialState: $keDMh.initialState,
    actions: $hXuQC.actions,
    name: (0, $622cc15065a8e93c$export$cd79d01fb3d2f506)
});
const $1089c091fa1f71a9$export$4b6f97ed14dce97c = (0, $7JoAD.createContainer)($1089c091fa1f71a9$var$Store);
const $1089c091fa1f71a9$export$bd382fb3f9d0551e = (0, $7JoAD.createHook)($1089c091fa1f71a9$var$Store);

});
const $622cc15065a8e93c$export$cd79d01fb3d2f506 = 'jira.insights.container-store';

parcelRegister("hXuQC", function(module, exports) {

$parcel$export(module.exports, "actions", () => $dfa05910dfd04d9d$export$e324594224ef24da);

var $7Jxgt = parcelRequire("7Jxgt");

var $keDMh = parcelRequire("keDMh");
const $dfa05910dfd04d9d$var$updateContainer = (data)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            info: state.info,
            data: {
                ...state.data,
                ...data
            }
        };
        setState(nextState);
    };
const $dfa05910dfd04d9d$var$toggleProp = (propsName)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            info: state.info,
            data: {
                ...state.data,
                [propsName]: !state.data[propsName]
            }
        };
        setState(nextState);
    };
const $dfa05910dfd04d9d$var$setInfo = (data)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            data: state.data,
            info: {
                ...state.info,
                ...data
            }
        };
        setState(nextState);
    };
const $dfa05910dfd04d9d$var$refreshUniqueId = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            data: state.data,
            info: {
                ...state.info,
                uniqueId: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4()
            }
        };
        setState(nextState);
    };
const $dfa05910dfd04d9d$var$cleanState = ()=>({ setState: setState })=>{
        setState((0, $keDMh.initialState));
    };
const $dfa05910dfd04d9d$var$updateIsDeepLinking = (isDeepLinking)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            data: state.data,
            info: {
                ...state.info,
                isDeepLinking: isDeepLinking
            }
        };
        setState(nextState);
    };
const $dfa05910dfd04d9d$export$e324594224ef24da = {
    setInfo: $dfa05910dfd04d9d$var$setInfo,
    cleanState: $dfa05910dfd04d9d$var$cleanState,
    toggleProp: $dfa05910dfd04d9d$var$toggleProp,
    updateContainer: $dfa05910dfd04d9d$var$updateContainer,
    refreshUniqueId: $dfa05910dfd04d9d$var$refreshUniqueId,
    updateIsDeepLinking: $dfa05910dfd04d9d$var$updateIsDeepLinking
};

});
parcelRegister("keDMh", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $2bb5e17d6b3cb888$export$d4c72bab9d6cc13a);

var $7Jxgt = parcelRequire("7Jxgt");
const $2bb5e17d6b3cb888$var$info = {
    uniqueId: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4(),
    isDeepLinking: true
};
const $2bb5e17d6b3cb888$export$d4c72bab9d6cc13a = {
    info: $2bb5e17d6b3cb888$var$info,
    data: {}
};

});



parcelRegister("5h4e8", function(module, exports) {

$parcel$export(module.exports, "useIsProjectType", () => $92c8eb9133a9a3c1$export$3b6950eab2454ef6);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $4DPZY = parcelRequire("4DPZY");
const $92c8eb9133a9a3c1$export$3b6950eab2454ef6 = ({ onIsProjectTypeUpdated: onIsProjectTypeUpdated })=>{
    const [{ data: containerContext }] = (0, $4DPZY.useContainerContext)();
    const isProjectType = containerContext?.contextType === 'project';
    const previousIsProjectType = (0, $5uXOq.useRef)();
    if (previousIsProjectType.current !== isProjectType && (0, $4R6GH.fg)('render_insights_button_immediately_when_ready')) {
        onIsProjectTypeUpdated({
            isProjectType: isProjectType
        });
        previousIsProjectType.current = isProjectType;
    }
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('render_insights_button_immediately_when_ready')) return;
        onIsProjectTypeUpdated({
            isProjectType: isProjectType
        });
    }, [
        isProjectType,
        onIsProjectTypeUpdated
    ]);
};

});


parcelRegister("ebnTF", function(module, exports) {

$parcel$export(module.exports, "getTextValue", () => $ab366a2319b78816$export$6ca03cb7b75bfa13);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ab366a2319b78816$var$isUndefinedOrNull = (value)=>value === null || value === undefined;
const $ab366a2319b78816$export$96252741c837b909 = (value, defaultValue)=>$ab366a2319b78816$var$isUndefinedOrNull(value) ? defaultValue : value;
const $ab366a2319b78816$export$22a0d6ac9d3db3b9 = (value, defaultValue)=>$ab366a2319b78816$var$isUndefinedOrNull(value) ? defaultValue : value;
const $ab366a2319b78816$export$6ca03cb7b75bfa13 = (value, defaultValue)=>$ab366a2319b78816$var$isUndefinedOrNull(value) ? defaultValue : value;
const $ab366a2319b78816$export$e1a3353b722e75de = (value, defaultValue)=>$ab366a2319b78816$var$isUndefinedOrNull(value) ? defaultValue : value;

});

parcelRegister("apoVO", function(module, exports) {

$parcel$export(module.exports, "InsightsContainer", () => $8769e024218efab1$export$af2273df1febba45);

var $5uXOq = parcelRequire("5uXOq");

var $j8sJY = parcelRequire("j8sJY");

var $6f6NP = parcelRequire("6f6NP");
const $8769e024218efab1$var$buildScopeName = (scope, packageName)=>`${scope}-${packageName}`;
const $8769e024218efab1$var$ChildrenWrapperWithHook = ({ children: children })=>{
    const [state, actions] = (0, $6f6NP.useInsightsContainer)();
    return children(state, actions);
};
const $8769e024218efab1$export$af2273df1febba45 = ({ scope: scope, packageName: packageName, children: children })=>{
    const insightsStoreContainerScope = $8769e024218efab1$var$buildScopeName(scope, packageName);
    if (typeof children === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8sJY.InsightsStoreContainer), {
        scope: insightsStoreContainerScope
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8769e024218efab1$var$ChildrenWrapperWithHook, null, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8sJY.InsightsStoreContainer), {
        scope: insightsStoreContainerScope
    }, children);
};

});

parcelRegister("g5uUm", function(module, exports) {

$parcel$export(module.exports, "InsightsButton", () => $98922b077d0d412f$export$943e069e37d25a04);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $bZNwM = parcelRequire("bZNwM");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $3TyLU = parcelRequire("3TyLU");
var $1kVqg = parcelRequire("1kVqg");


var $39xOx = parcelRequire("39xOx");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $4Fbrj = parcelRequire("4Fbrj");

var $7BuUr = parcelRequire("7BuUr");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $hchBL = parcelRequire("hchBL");

var $6lmg7 = parcelRequire("6lmg7");

var $dCm1o = parcelRequire("dCm1o");

var $2Mspb = parcelRequire("2Mspb");
const $98922b077d0d412f$var$actionSubjectId = 'toggleInsightsPanel';
const $98922b077d0d412f$var$TooltipWrapper = ({ children: children, render: render })=>render != null ? render({
        children: children
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
const $98922b077d0d412f$var$buttonTestId = 'insights-show-insights-button.ui.insights-button';
const $98922b077d0d412f$var$buttonForHiddenTestId = 'insights-show-insights-button.ui.button-test-id-hide';
const $98922b077d0d412f$export$2fdc3445dd252e1 = ({ clickEventAnalytics: clickEventAnalytics, iconAfter: iconAfter, isCompact: isCompact = false, isHidden: isHidden = false, isInsightsPanelOpen: isInsightsPanelOpen, isOnboardingDisabled: isOnboardingDisabled = false, onToggle: onToggle, renderTooltip: renderTooltip })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    const onRefSmall = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $4Fbrj.INSIGHTS_BUTTON_SM), ref);
    }, [
        register
    ]);
    const onRefButtonLarge = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $4Fbrj.INSIGHTS_BUTTON_LG), ref);
    }, [
        register
    ]);
    const onRefButtonResponsive = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $4Fbrj.INSIGHTS_BUTTON_RESPONSIVE), ref);
    }, [
        register
    ]);
    const onRefButton = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $4Fbrj.INSIGHTS_BUTTON), ref);
    }, [
        register
    ]);
    const isSupported = (0, $7BuUr.useIsCurrentBrowserSupported)();
    const isDisabled = isOnboardingDisabled;
    const onClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, $98922b077d0d412f$var$actionSubjectId, {
            action: isInsightsPanelOpen ? 'close' : 'open',
            isDisabled: isDisabled,
            ...clickEventAnalytics?.attributes || {}
        });
        onToggle(analyticsEvent);
    }, [
        clickEventAnalytics,
        isDisabled,
        isInsightsPanelOpen,
        onToggle
    ]);
    const label = isInsightsPanelOpen ? formatMessage((0, $2Mspb.default).hideInsights) : formatMessage((0, $2Mspb.default).showInsights);
    if (!isSupported) return null;
    const showInsightsButton = !isHidden;
    if (!showInsightsButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        action: "hidden",
        actionSubject: "button",
        actionSubjectId: $98922b077d0d412f$var$actionSubjectId
    });
    const iconColor = isInsightsPanelOpen ? undefined : `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N500})`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        action: "rendered",
        actionSubject: "button",
        actionSubjectId: $98922b077d0d412f$var$actionSubjectId
    }), (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "jira-insights-button"
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        interactionName: "show-insights-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))),
        label: label,
        isSelected: isInsightsPanelOpen,
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonTestId,
        ref: onRefButton,
        ...(0, $4R6GH.fg)('jira_nav4_beta_drop_1') ? {
            isTooltipDisabled: false
        } : {}
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6lmg7.ResponsiveButton), {
        interactionName: "show-insights-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))),
        label: label,
        iconAfter: typeof iconAfter === 'function' ? iconAfter : undefined,
        isSelected: isInsightsPanelOpen,
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonTestId,
        ref: onRefButtonResponsive
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($98922b077d0d412f$var$TooltipWrapper, {
        render: renderTooltip
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "jira-insights-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        interactionName: "show-insights-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))),
        label: label,
        isSelected: isInsightsPanelOpen,
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonTestId,
        ref: onRefButton
    })) : isCompact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "jira-insights-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        interactionName: "show-insights-button",
        appearance: "subtle",
        spacing: "none",
        isSelected: isInsightsPanelOpen,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))), {
            label: label,
            color: iconColor
        }),
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonTestId,
        ref: onRefSmall
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "jira-insights-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        above: "lg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        interactionName: "show-insights-button",
        isSelected: isInsightsPanelOpen,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))), {
            label: "",
            color: iconColor
        }),
        iconAfter: typeof iconAfter === 'object' ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        iconAfter : undefined,
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonTestId,
        ref: onRefButtonLarge
    }, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3TyLU.Hide), {
        above: "lg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        interactionName: "show-insights-button",
        isSelected: isInsightsPanelOpen,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))), {
            label: label,
            color: iconColor
        }),
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonForHiddenTestId,
        ref: onRefSmall
    }))))));
};
const $98922b077d0d412f$export$943e069e37d25a04 = (props)=>{
    const packageName = (0, $co1wz.ff)('jsm-board-insights-issues-for-attention_erwbg') && props && props.packageName ? props.packageName : (0, $4Fbrj.JIRA_INSIGHTS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "button",
        packageName: packageName,
        teamName: "helios-headcoach",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($98922b077d0d412f$export$2fdc3445dd252e1, props));
};

});
parcelRegister("bZNwM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3be954ea5d070f5903d5961389b0e8fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bbbcf5ce8764439$var$_react = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8bbbcf5ce8764439$var$_chartTrend = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("7EZ5v")));

var $8bbbcf5ce8764439$var$_graphLine = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("gSPJV")));
function $8bbbcf5ce8764439$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChartTrendIcon.
 * This component is ChartTrendIcon, with `UNSAFE_fallbackIcon` set to "GraphLineIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8bbbcf5ce8764439$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $8bbbcf5ce8764439$var$_react.default.createElement($8bbbcf5ce8764439$var$_chartTrend.default, Object.assign({
        LEGACY_fallbackIcon: $8bbbcf5ce8764439$var$_graphLine.default
    }, props));
$8bbbcf5ce8764439$var$ChartTrendIcon.Name = 'ChartTrendIconMigration';
var $8bbbcf5ce8764439$var$_default = module.exports.default = $8bbbcf5ce8764439$var$ChartTrendIcon;

});
parcelRegister("7EZ5v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c87cea19f3e54fed45de6b49a026def6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $593ba794a5c6525a$var$_react = $593ba794a5c6525a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $593ba794a5c6525a$var$_UNSAFE_baseNew = $593ba794a5c6525a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $593ba794a5c6525a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChartTrend".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $593ba794a5c6525a$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $593ba794a5c6525a$var$_react.default.createElement($593ba794a5c6525a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 1v9.75M15 14.25H3c-.69 0-1.25-.56-1.25-1.25v-2.25m0 0 4.5-4.5L8.5 8.5l5.25-5.25m.5 3.75V2.75H10"/>`
    }, props));
$593ba794a5c6525a$var$ChartTrendIcon.displayName = 'ChartTrendIcon';
var $593ba794a5c6525a$var$_default = module.exports.default = $593ba794a5c6525a$var$ChartTrendIcon;

});

parcelRegister("gSPJV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4a9d2eb82ff139c$var$_react = $c4a9d2eb82ff139c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c4a9d2eb82ff139c$var$_chartTrend = $c4a9d2eb82ff139c$var$_interopRequireDefault((parcelRequire("7EZ5v")));
function $c4a9d2eb82ff139c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c4a9d2eb82ff139c$var$GraphLineIcon = (props)=>/*#__PURE__*/ $c4a9d2eb82ff139c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M21 17H5c-.55 0-1-.45-1-1.01V6a1 1 0 1 0-2 0v9.99A3 3 0 0 0 5 19h16a1 1 0 0 0 0-2m-3-8v3a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="M13.293 13.707a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L14 11.586l-2.293-2.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L11 11.414z"/></g></svg>`
    }, props, {
        newIcon: $c4a9d2eb82ff139c$var$_chartTrend.default
    }));
$c4a9d2eb82ff139c$var$GraphLineIcon.displayName = 'GraphLineIcon';
var $c4a9d2eb82ff139c$var$_default = module.exports.default = $c4a9d2eb82ff139c$var$GraphLineIcon;

});


parcelRegister("3TyLU", function(module, exports) {

$parcel$export(module.exports, "Hide", () => $f53ed0348d5d3206$export$bed28288a051538);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8CUq3 = parcelRequire("8CUq3");

var $2pf2j = parcelRequire("2pf2j");
const $f53ed0348d5d3206$var$hideAboveQueries = (0, $2pf2j.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $f53ed0348d5d3206$var$hideBelowQueries = (0, $2pf2j.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $f53ed0348d5d3206$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $8CUq3.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $f53ed0348d5d3206$var$hideAboveQueries[above],
            below && $f53ed0348d5d3206$var$hideBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});

parcelRegister("2Mspb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c41f59518ad2b73$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c41f59518ad2b73$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showInsights: {
        "id": "insights-show-insights-button.show-insights",
        "defaultMessage": "Insights"
    },
    hideInsights: {
        "id": "insights-show-insights-button.hide-insights",
        "defaultMessage": "Insights"
    }
});

});


parcelRegister("l60Zc", function(module, exports) {

$parcel$export(module.exports, "BOARD_BUTTON_ID", () => $6c2b5aa903c2ea94$export$a964db0cf65f63e0);

const $6c2b5aa903c2ea94$export$a964db0cf65f63e0 = `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.board-button`;

});

parcelRegister("hCKQh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7678bdc7a84a3fea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7678bdc7a84a3fea$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "insights-board-button.tooltip",
        "defaultMessage": "Sprint insights"
    }
});

});


parcelRegister("5HeQO", function(module, exports) {

$parcel$export(module.exports, "KanbanBoardInsightsButton", () => $b668dbb2fb6c3ea3$export$42d054b6930214e);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $4Fbrj = parcelRequire("4Fbrj");


var $9Y7dM = parcelRequire("9Y7dM");

var $9YlLW = parcelRequire("9YlLW");

var $7BuUr = parcelRequire("7BuUr");

var $0241A = parcelRequire("0241A");

var $6OlO8 = parcelRequire("6OlO8");

var $cOddg = parcelRequire("cOddg");

var $1UEsW = parcelRequire("1UEsW");

var $gkPFQ = parcelRequire("gkPFQ");

var $2KxPr = parcelRequire("2KxPr");

var $6f6NP = parcelRequire("6f6NP");

var $ebnTF = parcelRequire("ebnTF");

var $apoVO = parcelRequire("apoVO");

var $g5uUm = parcelRequire("g5uUm");

var $koVbs = parcelRequire("koVbs");

var $cfDZ3 = parcelRequire("cfDZ3");

var $iXVV6 = parcelRequire("iXVV6");

var $l60Zc = parcelRequire("l60Zc");

var $lKVmh = parcelRequire("lKVmh");
const $b668dbb2fb6c3ea3$var$ButtonTooltip = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $lKVmh.default).tooltip)
    }, children);
};
const $b668dbb2fb6c3ea3$var$KanbanBoardInsightsButtonComponent = ({ isCompact: isCompact = false, isSimplifiedProject: isSimplifiedProject, isOpen: isOpen, boardId: boardId, onToggle: onToggle, edition: edition, projectId: projectId })=>{
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const isSupported = (0, $7BuUr.useIsCurrentBrowserSupported)();
    const [isOnboardingApplicable, setIsOnboardingApplicable] = (0, $5uXOq.useState)(false);
    const markOnboardingApplicable = (0, $5uXOq.useCallback)(()=>setIsOnboardingApplicable(true), []);
    const markOnboardingInapplicable = (0, $5uXOq.useCallback)(()=>setIsOnboardingApplicable(false), []);
    const [{ info: { isAnyLevelOfAdmin: isAnyLevelOfAdmin, isProjectType: isProjectType, uniqueId: uniqueId }, data: { hasPermission: hasPermission } }, { onDataUpdatedCallback: onDataUpdatedCallback, refreshUniqueId: refreshUniqueId, updateIsDeepLinking: updateIsDeepLinking }] = (0, $6f6NP.useInsightsContainer)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen) updateIsDeepLinking(false);
    }, [
        updateIsDeepLinking,
        isOpen,
        isSimplifiedProject
    ]);
    // refresh experience when insights (panel) is closed
    (0, $0241A.useValueChangeEffect)({
        listener: isOpen,
        callback: (current, previous)=>{
            if (current === false && previous === true) refreshUniqueId();
        }
    }, [
        refreshUniqueId
    ]);
    const currentPermissionStatus = (0, $ebnTF.getTextValue)(hasPermission, (0, $9Y7dM.permissionStatus).LOADING);
    return isSupported ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            edition: edition,
            boardId: boardId,
            userLocation: userLocation,
            projectId: projectId,
            frameworkType: (0, $4Fbrj.boardType).KANBAN,
            experienceId: uniqueId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gkPFQ.InsightsSpotlight), {
        onOpenInsightsPanel: ()=>!isOpen && onToggle(),
        onDismiss: markOnboardingInapplicable,
        isOnboardingApplicable: isOnboardingApplicable
    }), currentPermissionStatus === (0, $9Y7dM.permissionStatus).LOADING && (isSimplifiedProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOddg.CheckSimplifiedDataPermission), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOddg.CheckClassicViewAggregatedDataPermission), {
        boardId: boardId,
        userLocation: userLocation,
        onPermissionLoaded: onDataUpdatedCallback('hasPermission'),
        onInsightsEnabledWithoutPermission: markOnboardingApplicable
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g5uUm.InsightsButton), {
        isInsightsPanelOpen: isOpen,
        isCompact: isCompact,
        boardId: boardId,
        onToggle: onToggle,
        isAnyLevelOfAdmin: !isSimplifiedProject && isAnyLevelOfAdmin,
        isHidden: !isProjectType,
        isOnboardingDisabled: !isSimplifiedProject ? currentPermissionStatus !== (0, $9Y7dM.permissionStatus).ALLOWED : undefined,
        renderTooltip: $b668dbb2fb6c3ea3$var$ButtonTooltip
    }))) : null;
};
const $b668dbb2fb6c3ea3$var$KanbanBoardInsightsButtonWithContainer = (props)=>{
    const scope = (0, $6OlO8.buildBoardScopeName)({
        isSimplifiedProject: props.isSimplifiedProject,
        boardId: props.boardId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $apoVO.InsightsContainer), {
        scope: scope,
        packageName: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b668dbb2fb6c3ea3$var$KanbanBoardInsightsButtonComponent, props));
};
const $b668dbb2fb6c3ea3$var$SafeKanbanBoardInsightsButton = (0, $2KxPr.withComponentSafety)($b668dbb2fb6c3ea3$var$KanbanBoardInsightsButtonWithContainer, {
    condition: ({ boardId: boardId })=>(0, $9YlLW.isValidBoardId)({
            boardId: boardId
        }),
    location: (0, $l60Zc.BOARD_BUTTON_ID),
    message: ({ boardId: boardId })=>`Board button received invalid boardId: ${boardId}`
});
const $b668dbb2fb6c3ea3$export$42d054b6930214e = (0, $1UEsW.WithInsightsErrorBoundary)($b668dbb2fb6c3ea3$var$SafeKanbanBoardInsightsButton, (0, $b0e6fec6a4686296$export$1269ea4f2b198811), (0, $b0e6fec6a4686296$export$d3996f57ffa8448f));

});
parcelRegister("lKVmh", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb556a8eb9a8ceb8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $eb556a8eb9a8ceb8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "insights-board-button.kanban-button.tooltip",
        "defaultMessage": "Board insights"
    }
});

});


parcelRegister("046Kp", function(module, exports) {

$parcel$export(module.exports, "ServicedeskBoardInsightsButton", () => $db31cb55f3113dc9$export$6f71131b25281bb3);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $4Fbrj = parcelRequire("4Fbrj");

var $9YlLW = parcelRequire("9YlLW");

var $7BuUr = parcelRequire("7BuUr");

var $0241A = parcelRequire("0241A");

var $1UEsW = parcelRequire("1UEsW");

var $2KxPr = parcelRequire("2KxPr");

var $6f6NP = parcelRequire("6f6NP");

var $apoVO = parcelRequire("apoVO");

var $g5uUm = parcelRequire("g5uUm");

var $koVbs = parcelRequire("koVbs");

var $cfDZ3 = parcelRequire("cfDZ3");

var $iXVV6 = parcelRequire("iXVV6");

var $cngc7 = parcelRequire("cngc7");


var $lOogP = parcelRequire("lOogP");
const $db31cb55f3113dc9$var$ButtonTooltip = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $lOogP.default).tooltipNonFinal)
    }, children);
};
const $db31cb55f3113dc9$export$8d02a93abfd1986e = ({ isCompact: isCompact = false, isSimplifiedProject: isSimplifiedProject, isOpen: isOpen, boardId: boardId, onToggle: onToggle, edition: edition, projectId: projectId })=>{
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const isSupported = (0, $7BuUr.useIsCurrentBrowserSupported)();
    const [{ info: { isProjectType: isProjectType, uniqueId: uniqueId } }, { refreshUniqueId: refreshUniqueId, updateIsDeepLinking: updateIsDeepLinking }] = (0, $6f6NP.useInsightsContainer)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen) updateIsDeepLinking(false);
    }, [
        updateIsDeepLinking,
        isOpen,
        isSimplifiedProject
    ]);
    // refresh experience when insights (panel) is closed
    (0, $0241A.useValueChangeEffect)({
        listener: isOpen,
        callback: (current, previous)=>{
            if (current === false && previous === true) refreshUniqueId();
        }
    }, [
        refreshUniqueId
    ]);
    return isSupported ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            edition: edition,
            boardId: boardId,
            userLocation: userLocation,
            projectId: projectId,
            frameworkType: (0, $4Fbrj.boardType).KANBAN,
            experienceId: uniqueId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g5uUm.InsightsButton), {
        isInsightsPanelOpen: isOpen,
        isCompact: isCompact,
        boardId: boardId,
        onToggle: onToggle,
        isHidden: !isProjectType,
        renderTooltip: $db31cb55f3113dc9$var$ButtonTooltip
    }))) : null;
};
const $db31cb55f3113dc9$var$ServicedeskBoardInsightsButtonWithContainer = (props)=>{
    const scope = (0, $cngc7.buildBoardScopeName)({
        isSimplifiedProject: props.isSimplifiedProject,
        boardId: props.boardId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $db31cb55f3113dc9$var$serviceDeskInsightStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $apoVO.InsightsContainer), {
        scope: scope,
        packageName: (0, $c5cb7bd255e35dd6$export$d3996f57ffa8448f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db31cb55f3113dc9$export$8d02a93abfd1986e, props)));
};
const $db31cb55f3113dc9$var$SafeServicedeskBoardInsightsButton = (0, $2KxPr.withComponentSafety)($db31cb55f3113dc9$var$ServicedeskBoardInsightsButtonWithContainer, {
    condition: ({ boardId: boardId })=>(0, $9YlLW.isValidBoardId)({
            boardId: boardId
        }),
    location: (0, $c5cb7bd255e35dd6$export$a964db0cf65f63e0),
    message: ({ boardId: boardId })=>`Servicedesk Board button received invalid boardId: ${boardId}`
});
const $db31cb55f3113dc9$export$6f71131b25281bb3 = (0, $1UEsW.WithInsightsErrorBoundary)($db31cb55f3113dc9$var$SafeServicedeskBoardInsightsButton, (0, $c5cb7bd255e35dd6$export$98cd6374d35728ad), (0, $c5cb7bd255e35dd6$export$d3996f57ffa8448f));
const $db31cb55f3113dc9$var$serviceDeskInsightStyle = (0, $8CUq3.xcss)({
    marginRight: 'space.100'
});

});
parcelRegister("cngc7", function(module, exports) {

$parcel$export(module.exports, "buildBoardScopeName", () => $e2134cc890abde88$export$7cfa8d622acbc99f);

const $e2134cc890abde88$export$7cfa8d622acbc99f = ({ isSimplifiedProject: isSimplifiedProject, boardId: boardId })=>`${isSimplifiedProject ? (0, $c5cb7bd255e35dd6$export$8e66b21ec141a0bd) : (0, $c5cb7bd255e35dd6$export$c9290acd1ba498ff)}-boardId:${boardId}`;

});
const $c5cb7bd255e35dd6$export$d3996f57ffa8448f = 'servicedesk.insights';
const $c5cb7bd255e35dd6$export$c9290acd1ba498ff = `${$c5cb7bd255e35dd6$export$d3996f57ffa8448f}.board`;
const $c5cb7bd255e35dd6$export$8e66b21ec141a0bd = `${$c5cb7bd255e35dd6$export$d3996f57ffa8448f}.board-simplified`;
const $c5cb7bd255e35dd6$export$a964db0cf65f63e0 = `${$c5cb7bd255e35dd6$export$d3996f57ffa8448f}.board-button`;
const $c5cb7bd255e35dd6$export$98cd6374d35728ad = `${$c5cb7bd255e35dd6$export$d3996f57ffa8448f}.error-boundary`;


parcelRegister("lOogP", function(module, exports) {

$parcel$export(module.exports, "default", () => $08a91f27f343c4ee$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $08a91f27f343c4ee$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltipNonFinal: {
        "id": "servicedesk-board-button.tooltip-non-final",
        "defaultMessage": "Board insights"
    }
});

});




parcelRegister("9eTg7", function(module, exports) {

$parcel$export(module.exports, "shouldDisableStandup", () => $59c567bfc1207d3d$export$e534c1f6327a8e09);
$parcel$export(module.exports, "getIsCompleteSprintButtonVisible", () => $59c567bfc1207d3d$export$c683535c091a9e79);

var $4R6GH = parcelRequire("4R6GH");


var $1vXOx = parcelRequire("1vXOx");

var $ebHh7 = parcelRequire("ebHh7");
const $59c567bfc1207d3d$export$e534c1f6327a8e09 = ({ boardType: boardType, isSprintsEnabled: isSprintsEnabled, hasActiveSprint: hasActiveSprint })=>{
    if (boardType === 'Kanban') return false;
    return isSprintsEnabled && !hasActiveSprint;
};
function $59c567bfc1207d3d$export$c683535c091a9e79(state) {
    if ((0, $4R6GH.fg)('jsw-jet-yamato-fe-permissions-seq-sprint-actions')) // allow the render of a disabled button if no permissions to manage the sprint
    return (0, $ebHh7.hasActiveSprintsSelector)(state);
    return (0, $ebHh7.hasActiveSprintsSelector)(state) && !!(0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$112115098b6cf79b];
}

});

parcelRegister("ikdur", function(module, exports) {

$parcel$export(module.exports, "default", () => $51c4d7313dd1a25f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $8QpSo = parcelRequire("8QpSo");

var $7wqBZ = parcelRequire("7wqBZ");

var $6s1PB = parcelRequire("6s1PB");

var $co1wz = parcelRequire("co1wz");

var $2gCtH = parcelRequire("2gCtH");

var $bC2fB = parcelRequire("bC2fB");




var $d1i1b = parcelRequire("d1i1b");

var $cY26q = parcelRequire("cY26q");

var $dnW4F = parcelRequire("dnW4F");

var $Nogwi = parcelRequire("Nogwi");

var $1vXOx = parcelRequire("1vXOx");

var $bSSdD = parcelRequire("bSSdD");

var $fqLDH = parcelRequire("fqLDH");

var $d2i8f = parcelRequire("d2i8f");

var $6aPPq = parcelRequire("6aPPq");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $5mTgl = parcelRequire("5mTgl");

var $fFtOA = parcelRequire("fFtOA");

var $flbsC = parcelRequire("flbsC");
const $51c4d7313dd1a25f$var$isTMPBoardAddPeopleExperimentEnabled = (state)=>{
    const canInviteOthersToProject = (0, $67Z81.getCanInviteOthersToProject)(state);
    return canInviteOthersToProject && (0, $6s1PB.expValEquals)('open_invite_for_open_tmp_projects', 'cohort', 'experiment');
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $51c4d7313dd1a25f$var$EMPTY_LIST = [];
const $51c4d7313dd1a25f$export$c31df4bd766f9c35 = (state, ownProps)=>({
        customFiltersQueryRef: ownProps.customFiltersQueryRef,
        isActiveStandup: ownProps.isActiveStandup,
        assignees: (0, $67Z81.getIsCMPBoard)(state) ? (0, $5mTgl.orderedWorkAssigneesAlphabeticallySelector)(state) : (0, $5mTgl.orderedWorkAssigneesByAccountIdSelector)(state),
        filter: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $5mTgl.getWorkFilters)(state), [
            'values'
        ]),
        issueParentsLabel: (0, $67Z81.getHierarchyNomenclature)(state) ? (0, $67Z81.getHierarchyNomenclature)(state)?.firstLevelName : (0, $bSSdD.firstParentIssueTypeNameSelector)(state),
        issueParents: (0, $co1wz.ff)('jsw.perf.show-epics-with-only-subtasks-on-board-epic-dropdown') ? (0, $bSSdD.filteredIssueParentsToListItemSelectorNew)(state) : (0, $bSSdD.filteredIssueParentsToListItemSelector)(state),
        isAnyModalOpen: (0, $6aPPq.isAnyModalOpenSelector)(state),
        isIssueModalShowing: (0, $fqLDH.isIssueModalShowingSelector)(state),
        labels: (0, $d2i8f.issueLabelsSelector)(state),
        issueTypes: (0, $d2i8f.sortedIssueTypeSelector)(state),
        issueTypeGroups: (0, $67Z81.getIsIncrementPlanningBoard)(state) ? (0, $d2i8f.issueTypeGroupSelector)(state) : $51c4d7313dd1a25f$var$EMPTY_LIST,
        isGroupIssueTypesEnabled: (0, $67Z81.getIsIncrementPlanningBoard)(state),
        issueProjects: (0, $67Z81.getIssueProjects)(state),
        maxAvatars: (0, $7e733a5d4e4331fc$export$360e7ca29749d455),
        isAddPeopleButtonEnabled: (0, $67Z81.getIsCMPBoard)(state) ? (0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df] : (0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df] || $51c4d7313dd1a25f$var$isTMPBoardAddPeopleExperimentEnabled(state),
        isCustomFilterManageLinkEnabled: (0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df] && !(0, $67Z81.getIsCMPBoard)(state),
        isVersionFilterSpotlightEnabled: (0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df] && !(0, $67Z81.getIsCMPBoard)(state),
        AddPeopleModal: $fFtOA.default,
        externalId: 'software.board',
        projectId: (0, $67Z81.projectIdSelector)(state),
        projectName: (0, $67Z81.projectNameSelector)(state),
        projectKey: (0, $67Z81.projectKeySelector)(state),
        boardId: Number((0, $67Z81.rapidViewIdSelector)(state)),
        isCustomFiltersLoading: (0, $5mTgl.isFilteredCardsLoading)(state),
        sprints: (0, $ebHh7.getSprintsSelector)(state)
    });
const $51c4d7313dd1a25f$var$getOnChange = (0, $8QpSo.default)((dispatch)=>(filters, filterType, _, analyticsEvent)=>{
        if (filterType !== (0, $dcff40112356dfc1$export$68d693c35a8d8866)) (0, $7wqBZ.getLongTasksMetrics)('filter').start('board');
        if (filterType === (0, $dcff40112356dfc1$export$a316570a0dbfd2b0)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const sprintFilterIds = filters[0, $dcff40112356dfc1$export$a316570a0dbfd2b0];
            dispatch((0, $Nogwi.selectSprint)({
                sprintFilterIds: sprintFilterIds
            }));
        }
        return dispatch((0, $dnW4F.setAllFilters)(filters, filterType, analyticsEvent));
    });
const $51c4d7313dd1a25f$var$mapDispatchToProps = (dispatch)=>({
        onSearchFieldFocus: (...args)=>dispatch((0, $dnW4F.searchFieldFocus)(...args)),
        onExtraAvatarMenuOpen: (...args)=>dispatch((0, $dnW4F.extraAvatarMenuOpen)(...args)),
        onFilterPanelMounted: (...args)=>dispatch((0, $dnW4F.filterPanelMounted)(...args)),
        onChange: $51c4d7313dd1a25f$var$getOnChange(dispatch),
        onClearAllButtonClicked: ()=>{
            dispatch((0, $dnW4F.clearAllFiltersClicked)()); // used just for the analytics event, has no reducer
            dispatch((0, $cY26q.clearFilteredCards)());
            dispatch((0, $d1i1b.cardAutoScrollRequestOnFilter)());
        }
    });
const $51c4d7313dd1a25f$var$withAnyModalOpen = (WrappedComponent)=>(props)=>{
        const viewMode = (0, $2gCtH.useViewMode)();
        const isDetailViewModal = viewMode === 'MODAL';
        const { isAnyModalOpen: isAnyModalOpen, isIssueModalShowing: isIssueModalShowing, ...restProps } = props;
        const isIssueDetailViewModalOpen = isIssueModalShowing && isDetailViewModal;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...restProps,
            isAnyModalOpen: isIssueDetailViewModalOpen || isAnyModalOpen
        });
    };
var // @ts-expect-error - TS2345 - Property 'values' is missing in type 'Filters' but required in type 'FilterState'.
$51c4d7313dd1a25f$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($51c4d7313dd1a25f$export$c31df4bd766f9c35, $51c4d7313dd1a25f$var$mapDispatchToProps)($51c4d7313dd1a25f$var$withAnyModalOpen((0, $flbsC.default)));

});
parcelRegister("6aPPq", function(module, exports) {

$parcel$export(module.exports, "isAnyModalOpenSelector", () => $e3e52dc8e9842893$export$f3a16e4558c34e30);

var $dGvGJ = parcelRequire("dGvGJ");

var $fruR3 = parcelRequire("fruR3");

var $absT5 = parcelRequire("absT5");

var $fyeGd = parcelRequire("fyeGd");

var $eDggU = parcelRequire("eDggU");

var $9w3Ae = parcelRequire("9w3Ae");

var $iejYF = parcelRequire("iejYF");

var $fqLDH = parcelRequire("fqLDH");

var $5mTgl = parcelRequire("5mTgl");
const $e3e52dc8e9842893$export$f3a16e4558c34e30 = (0, $dGvGJ.createSelector)([
    (0, $fqLDH.isIssueModalShowingSelector),
    (0, $fruR3.isDialogVisibleSelector),
    (0, $absT5.isDialogVisibleSelector),
    (0, $5mTgl.getColumnDeleteModalIsOpen),
    (0, $5mTgl.isIssueDeleteModalOpen),
    (0, $9w3Ae.isAddLabelModalOpen),
    (0, $eDggU.isAssignIssueParentModalOpen),
    (0, $fyeGd.getUiColumnLimitsModalOpen),
    (0, $iejYF.isIssueFlagWithCommentModalOpen)
], (issueModalShowing, backlogIssueMoveDialogOpen, backlogEnableDialogOpen, columnDeleteModalIsOpen, issueDeleteModalOpen, addLabelModalOpen, assignIssueParentModalOpen, uiColumnLimitsModalOpen, issueFlagWithCommentModalOpen)=>backlogIssueMoveDialogOpen || backlogEnableDialogOpen || columnDeleteModalIsOpen || issueDeleteModalOpen || addLabelModalOpen || assignIssueParentModalOpen || uiColumnLimitsModalOpen || issueFlagWithCommentModalOpen);

});
parcelRegister("9w3Ae", function(module, exports) {

$parcel$export(module.exports, "isAddLabelModalOpen", () => $6f58d943d2694d80$export$b19f40379d7cd607);
$parcel$export(module.exports, "getIssuesForAddLabelModal", () => $6f58d943d2694d80$export$de028143a378279f);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $67Z81 = parcelRequire("67Z81");

var $vAfHD = parcelRequire("vAfHD");
const $6f58d943d2694d80$var$getUiAddLabelModal = (state)=>(0, $67Z81.getUi)(state).issueAddLabelModal;
const $6f58d943d2694d80$export$b19f40379d7cd607 = (state)=>Boolean($6f58d943d2694d80$var$getUiAddLabelModal(state)?.isOpen);
// @ts-expect-error - TS2339 - Property 'issueIds' does not exist on type 'AddLabelModalState'.
const $6f58d943d2694d80$var$getSelectedIssueIds = (state)=>$6f58d943d2694d80$var$getUiAddLabelModal(state).issueIds;
const $6f58d943d2694d80$var$noSelectedIssues = (0, $7uUwQ.freeze)([]);
const $6f58d943d2694d80$export$de028143a378279f = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    $6f58d943d2694d80$var$getSelectedIssueIds
], (allIssues, issueIds)=>{
    if (issueIds) return issueIds.map((id)=>({
            // Cast issueId here as number for now, until we need the add label feature in ARJ Increment planning board
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            id: allIssues[id].id,
            key: allIssues[id].key
        }));
    return $6f58d943d2694d80$var$noSelectedIssues;
});

});

parcelRegister("iejYF", function(module, exports) {

$parcel$export(module.exports, "isIssueFlagWithCommentModalOpen", () => $2ee44c2c343afad4$export$8dc99e4636e5b7d8);
$parcel$export(module.exports, "getFlagForFlagWithCommentModal", () => $2ee44c2c343afad4$export$13067e0b8f26b41d);
$parcel$export(module.exports, "getIssuesForFlagWithCommentModal", () => $2ee44c2c343afad4$export$ca31613ec956e54a);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $a4GLz = parcelRequire("a4GLz");

var $9OPlz = parcelRequire("9OPlz");

var $67Z81 = parcelRequire("67Z81");

var $vAfHD = parcelRequire("vAfHD");

var $d2i8f = parcelRequire("d2i8f");
const $2ee44c2c343afad4$var$getUiFlagWithCommentModal = (state)=>(0, $67Z81.getUi)(state).issueFlagWithCommentModal;
const $2ee44c2c343afad4$export$8dc99e4636e5b7d8 = (state)=>Boolean($2ee44c2c343afad4$var$getUiFlagWithCommentModal(state)?.isOpen);
const $2ee44c2c343afad4$var$getIssueId = (state)=>$2ee44c2c343afad4$var$getUiFlagWithCommentModal(state)?.issueId;
const $2ee44c2c343afad4$var$getSelectedIssueIds = (state)=>{
    const issueId = $2ee44c2c343afad4$var$getIssueId(state);
    if (issueId) return (0, $9OPlz.isCardSelected)(state)(issueId) ? (0, $9OPlz.getCardSelection)(state) : [
        issueId
    ];
    return undefined;
};
const $2ee44c2c343afad4$export$13067e0b8f26b41d = (state)=>{
    const issueId = $2ee44c2c343afad4$var$getIssueId(state);
    if (issueId) return (0, $d2i8f.isIssueFlagged)(state, issueId) ? (0, $a4GLz.REMOVE) : (0, $a4GLz.ADD);
    return 0, $a4GLz.ADD;
};
const $2ee44c2c343afad4$var$noSelectedIssues = (0, $7uUwQ.freeze)([]);
const $2ee44c2c343afad4$export$ca31613ec956e54a = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    $2ee44c2c343afad4$var$getSelectedIssueIds
], (allIssues, issueIds)=>{
    if (issueIds) return issueIds.map((id)=>({
            id: allIssues[id].id,
            key: allIssues[id].key,
            summary: allIssues[id].summary,
            type: {
                id: String(allIssues[id].typeId),
                name: allIssues[id].typeName ?? '',
                iconUrl: allIssues[id].typeUrl ?? ''
            }
        }));
    return $2ee44c2c343afad4$var$noSelectedIssues;
});

});
parcelRegister("a4GLz", function(module, exports) {

$parcel$export(module.exports, "ADD", () => $65b7e6dbe70f8139$export$bb6389024b71c2ae);
$parcel$export(module.exports, "REMOVE", () => $65b7e6dbe70f8139$export$29d55e1f664a246b);
$parcel$export(module.exports, "FLAG_REMOVED_PREFIX", () => $65b7e6dbe70f8139$export$43b00f69c32e9a5);
$parcel$export(module.exports, "FLAG_ADDED_PREFIX", () => $65b7e6dbe70f8139$export$625f394c78645dcd);
const $65b7e6dbe70f8139$export$bb6389024b71c2ae = 'ADD';
const $65b7e6dbe70f8139$export$29d55e1f664a246b = 'REMOVE';
const $65b7e6dbe70f8139$export$43b00f69c32e9a5 = {
    content: [
        {
            type: 'paragraph',
            content: [
                {
                    type: 'emoji',
                    attrs: {
                        shortName: ':flag_off:',
                        id: 'atlassian-flag_off',
                        text: ':flag_off:'
                    }
                },
                {
                    type: 'text',
                    text: ' Flag removed '
                }
            ]
        }
    ],
    type: 'doc',
    version: 1
};
const $65b7e6dbe70f8139$export$625f394c78645dcd = {
    content: [
        {
            type: 'paragraph',
            content: [
                {
                    type: 'emoji',
                    attrs: {
                        shortName: ':flag_on:',
                        id: 'atlassian-flag_on',
                        text: ':flag_on:'
                    }
                },
                {
                    type: 'text',
                    text: ' Flag added '
                }
            ]
        }
    ],
    type: 'doc',
    version: 1
};

});



parcelRegister("fFtOA", function(module, exports) {

$parcel$export(module.exports, "default", () => $cae350cfbd888e25$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $bC2fB = parcelRequire("bC2fB");

var $67Z81 = parcelRequire("67Z81");

var $2uACv = parcelRequire("2uACv");
var $cae350cfbd888e25$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state, ownProps)=>({
        projectId: (0, $67Z81.projectIdSelector)(state),
        projectKey: (0, $67Z81.projectKeySelector)(state),
        baseUrl: (0, $67Z81.contextPathSelector)(state),
        locale: (0, $67Z81.getLocale)(state),
        isOpen: ownProps.isOpen,
        onClose: ownProps.onClose || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        allowFlags: true,
        onAddSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }), ()=>({}))((0, $2uACv.default));

});
parcelRegister("2uACv", function(module, exports) {

$parcel$export(module.exports, "default", () => $23ef1a5b1befb75a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fjJ1B = parcelRequire("fjJ1B");

var $kxZPA = parcelRequire("kxZPA");
var $6Lg6A = parcelRequire("6Lg6A");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $23ef1a5b1befb75a$var$AddPeopleModal = (0, $kxZPA.lazy)(()=>(parcelRequire("7HRyA")), {
    moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$23ef1a5b1befb75a$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjJ1B.AddPeopleModalBoundary), {
        packageName: "software-board"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lg6A.LazyWait), {
        until: props.isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($23ef1a5b1befb75a$var$AddPeopleModal, {
        ...props,
        analyticsPrefix: "software.board",
        isAdmin: true,
        projectType: "software"
    })));

});
parcelRegister("fjJ1B", function(module, exports) {

$parcel$export(module.exports, "default", () => $05d4cefe384a250f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AddPeopleModalBoundary", () => $05d4cefe384a250f$export$374b95de0cd72a02);

var $5uXOq = parcelRequire("5uXOq");

var $gAeCk = parcelRequire("gAeCk");

var $39xOx = parcelRequire("39xOx");

var $gjEtj = parcelRequire("gjEtj");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


const $05d4cefe384a250f$var$LazyComponent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7HRyA")), {
    moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
});
const $05d4cefe384a250f$export$c4cbbeec160c9988 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "async-project-add-people-dialog",
        packageName: "project-add-people"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "project-add-people-dialog",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
            metricKey: (0, $f7307e9423a0bb88$export$b68a44ad9e8d6ce)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($05d4cefe384a250f$var$LazyComponent, props)));
var $05d4cefe384a250f$export$2e2bcd8739ae039 = $05d4cefe384a250f$export$c4cbbeec160c9988;
const $05d4cefe384a250f$export$374b95de0cd72a02 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "add-people-modal",
        metricKey: (0, $f7307e9423a0bb88$export$b68a44ad9e8d6ce),
        ...props
    }, children);

});
const $f7307e9423a0bb88$export$8fcd8ea7ed6539b1 = 'project-settings-apps.add-people-dialog';
const $f7307e9423a0bb88$export$b68a44ad9e8d6ce = 'ADD_PEOPLE_LOAD_START_MARK_KEY';
const $f7307e9423a0bb88$export$656613627a47a509 = 'ADD_PEOPLE_LOAD_END_MARK_KEY';
const $f7307e9423a0bb88$export$61762786d0849c64 = 'ADD_PEOPLE_READY_MARK_KEY';

parcelRegister("7HRyA", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("1TWxe")
]).then(()=>parcelRequire('jd2mv'));

});




parcelRegister("flbsC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8c1ccd5d67d8850$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $aD4Nm = parcelRequire("aD4Nm");

var $2i4sA = parcelRequire("2i4sA");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $efvDm = parcelRequire("efvDm");

var $8KmrC = parcelRequire("8KmrC");

var $9OXo1 = parcelRequire("9OXo1");

var $dCm1o = parcelRequire("dCm1o");

var $2xFXk = parcelRequire("2xFXk");

var $gNaDq = parcelRequire("gNaDq");

var $aGYrC = parcelRequire("aGYrC");

var $67sX6 = parcelRequire("67sX6");

var $1vXOx = parcelRequire("1vXOx");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $63LqY = parcelRequire("63LqY");

var $b9W8W = parcelRequire("b9W8W");


var $brhcU = parcelRequire("brhcU");
const $c8c1ccd5d67d8850$var$defaultProps = {
    versions: []
};
const $c8c1ccd5d67d8850$var$FilterBarWrapper = ({ customFiltersQueryRef: customFiltersQueryRef, isActiveStandup: isActiveStandup, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const isJSMBoard = (0, $63LqY.useIsJSMBoard)();
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const isVersionsFeatureEnabled = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_VERSIONS_FILTER);
    const isComponentsFeatureEnabled = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_COMPONENTS_FILTER);
    const isStatusCategoriesFeatureEnabled = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_STATUS_CATEGORIES_FILTER);
    const isIssueParentsFeatureEnabled = isIncrementPlanningBoard ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_ISSUE_PARENTS_FILTER) : undefined;
    const isLabelsFeatureEnabled = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_LABELS_FILTER);
    const isIssueProjectsFeatureEnabled = isIncrementPlanningBoard ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_ISSUE_PROJECTS_FILTER) : undefined;
    const isDependenciesFeatureEnabled = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_DEPENDENCIES_FILTER);
    const isIssueTypesFeatureEnabled = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_ISSUE_TYPES_FILTER);
    const isSprintsFeatureEnabled = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_SPRINTS_FILTER);
    const isRequestTypesFeatureEnabled = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_REQUEST_TYPES_FILTER);
    const isStatusesFeatureEnabled = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_STATUSES_FILTER);
    const projectType = (0, $67sX6.useBoardSelector)((0, $67Z81.projectTypeSelector));
    const requestTypes = (0, $67sX6.useBoardSelector)((0, $d2i8f.requestTypesSelector));
    const statuses = (0, $67sX6.useBoardSelector)((0, $d2i8f.statusesSelector));
    const isBoardSwitcherReadOnly = (0, $67sX6.useBoardSelector)((0, $1vXOx.isIncrementPlanningReadOnly));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2i4sA.ViewExperienceTrackingProvider), {
        experience: (0, $70866c33bb205617$export$d339888a30f06bf4),
        application: (0, $efvDm.getApplicationForProject)(projectType),
        edition: tenantContext.appEditions.software,
        analyticsSource: (0, $fcf97b7a09088940$export$cd16d39c55c569d0),
        experienceId: (0, $70866c33bb205617$export$b110169935468339),
        additionalAttributes: {
            isClassic: isCMPBoard,
            isUIF: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD4Nm.ExperienceTracker), {
        location: (0, $70866c33bb205617$export$dc37b1e8e15e9923)
    }, ({ onExperienceSuccess: onExperienceSuccess })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8KmrC.default), {
            ...$c8c1ccd5d67d8850$var$defaultProps,
            ...props,
            screenName: "board",
            isCompanyManaged: isCMPBoard,
            isJSMBoard: isJSMBoard,
            showSearchFilterChangeboarding: !isCMPBoard,
            hijackBrowserDefaultSearch: !isCMPBoard,
            onChangeInteractionFeedback: (0, $aGYrC.setInteractionFeedbackMark),
            onChangeInteractionStart: (0, $aGYrC.setInteractionStartMark),
            onCustomFilterChangeInteractionFeedback: (0, $gNaDq.setCustomFilterInteractionFeedbackMark),
            onCustomFilterChangeInteractionStart: (0, $gNaDq.setCustomFilterInteractionStartMark),
            customFiltersQueryRef: customFiltersQueryRef,
            // @ts-expect-error - TS2345 - Type 'CustomFiltersQueryRef | undefined' is not assignable to type 'PreloadedQuery<viewBoardCustomFiltersQuery, Record<string, unknown>>'.
            CustomFilter: (0, $b9W8W.BoardCustomFilter),
            showAssigneeFilter: !isIncrementPlanningBoard && !isActiveStandup,
            showBoardSwitcher: isIncrementPlanningBoard,
            isBoardSwitcherReadOnly: isBoardSwitcherReadOnly,
            showCustomFilters: isCMPBoard,
            onExperienceSuccess: onExperienceSuccess,
            placeholder: (0, $dCm1o.isVisualRefreshEnabled)() ? formatMessage((0, $brhcU.default).filterPlaceholder) : formatMessage((0, $brhcU.default).textFilter),
            screenReaderInstruction: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $brhcU.default).screenReaderInstructionIssueTermRefresh : (0, $brhcU.default).screenReaderInstruction),
            statuses: statuses,
            requestTypes: requestTypes,
            isUnassignedAssigneeOptionEnabled: true,
            isVersionsFeatureEnabled: isVersionsFeatureEnabled,
            isComponentsFeatureEnabled: isComponentsFeatureEnabled,
            isStatusCategoriesFeatureEnabled: isStatusCategoriesFeatureEnabled,
            isIssueParentsFeatureEnabled: isIssueParentsFeatureEnabled,
            isLabelsFeatureEnabled: isLabelsFeatureEnabled,
            isIssueProjectsFeatureEnabled: isIssueProjectsFeatureEnabled,
            isDependenciesFeatureEnabled: isDependenciesFeatureEnabled,
            isIssueTypesFeatureEnabled: isIssueTypesFeatureEnabled,
            isSprintsFeatureEnabled: isSprintsFeatureEnabled,
            isRequestTypesFeatureEnabled: isRequestTypesFeatureEnabled,
            isStatusesFeatureEnabled: isStatusesFeatureEnabled
        }))));
};
var $c8c1ccd5d67d8850$export$2e2bcd8739ae039 = $c8c1ccd5d67d8850$var$FilterBarWrapper;

});
const $fcf97b7a09088940$export$53d41ff2666118e1 = 'agility-backlog';
const $fcf97b7a09088940$export$7552fe2669628499 = 'bitbucket-issue';
const $fcf97b7a09088940$export$41a718da0a8636f4 = 'connect-issue';
const $fcf97b7a09088940$export$cebf0bc8b2ccaf57 = 'core-issue';
const $fcf97b7a09088940$export$5e91e17726e54450 = 'jiraCalendar';
const $fcf97b7a09088940$export$82540942fb014b0a = 'business-calendar';
const $fcf97b7a09088940$export$7ca28938a07e0c33 = 'business-list';
const $fcf97b7a09088940$export$f6cf06aaaeb58a54 = 'business-timeline';
const $fcf97b7a09088940$export$b2c0462ff17aa26e = 'business-board';
const $fcf97b7a09088940$export$a607850ebccd28ac = 'business-approvals';
const $fcf97b7a09088940$export$1da6cede3561048f = 'business-files';
const $fcf97b7a09088940$export$b19f949fb9713614 = 'full-issue';
const $fcf97b7a09088940$export$a5132300c5214280 = 'embed-issue';
const $fcf97b7a09088940$export$710114090a811b37 = 'global-issue-navigator-issue';
const $fcf97b7a09088940$export$ce88447986394f2d = 'mobile-issue';
const $fcf97b7a09088940$export$6a90d9196d330040 = 'project-issue-navigator';
const $fcf97b7a09088940$export$2247c9059c171db1 = 'roadmap-issue';
const $fcf97b7a09088940$export$cd16d39c55c569d0 = 'simple-software-board';
const $fcf97b7a09088940$export$f72626bf0d75dfad = 'software-backlog-issue';
const $fcf97b7a09088940$export$778b4609e784cb27 = 'software-deployments-issue';
const $fcf97b7a09088940$export$5b73d694a6048002 = 'version-detail-issue';
const $fcf97b7a09088940$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $fcf97b7a09088940$export$21b5b7189add7861 = 'software-incidents-issue';
const $fcf97b7a09088940$export$9c5d81b901471b27 = 'software-issue';
const $fcf97b7a09088940$export$1735f6ad917dc411 = 'change-calendar';
const $fcf97b7a09088940$export$7063ee6d0035a982 = 'queues-issue-view';
const $fcf97b7a09088940$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $fcf97b7a09088940$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $fcf97b7a09088940$export$14a8072f422804fd = 'issue-navigator-next';

parcelRegister("8KmrC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2622f927d259b739$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $ajpes = parcelRequire("ajpes");

var $8Rkzz = parcelRequire("8Rkzz");

var $fr1K2 = parcelRequire("fr1K2");

var $x9xyg = parcelRequire("x9xyg");

var $6RCeq = parcelRequire("6RCeq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $kbfkr = parcelRequire("kbfkr");

var $361on = parcelRequire("361on");
const $2622f927d259b739$var$clearAndSetPerformanceMark = (markKey)=>{
    if ((0, $6RCeq.default) && (0, $6RCeq.default).clearMarks) (0, $6RCeq.default).clearMarks(markKey);
    (0, $x9xyg.setMark)(markKey);
};
const $2622f927d259b739$var$useDebouncedOnChange = (onChange, createAnalyticsEvent)=>{
    const debouncedOnChange = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((filters, filterType, attributes)=>{
            if (createAnalyticsEvent) {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'changed',
                    actionSubject: 'filterBar'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'changeFilterBar', {
                    ...attributes,
                    filterType: filterType
                });
                onChange((0, $361on.getNormalizedFilters)(filters), filterType, attributes, analyticsEvent);
            } else onChange((0, $361on.getNormalizedFilters)(filters), filterType, attributes);
        }, 5), [
        onChange,
        createAnalyticsEvent
    ]);
    return debouncedOnChange;
};
const $2622f927d259b739$var$useOnChangeFilterValues = (filter, onChange, // @ts-expect-error - TS7006 - Parameter 'onChangeInteractionStart' implicitly has an 'any' type.
onChangeInteractionStart, // @ts-expect-error - TS7006 - Parameter 'onCustomFilterChangeInteractionStart' implicitly has an 'any' type.
onCustomFilterChangeInteractionStart, createAnalyticsEvent, onClearCustomFilterInteractionStart, isCompanyManaged)=>{
    const [localFilter, setFilters] = (0, $5uXOq.useState)(filter);
    (0, $5uXOq.useEffect)(()=>{
        setFilters(filter);
    }, [
        filter
    ]);
    const debouncedOnChange = $2622f927d259b739$var$useDebouncedOnChange(onChange, createAnalyticsEvent);
    const onChangeFilterValues = (0, $5uXOq.useCallback)((filters, fieldType, attributes)=>{
        if (fieldType !== null) {
            $2622f927d259b739$var$clearAndSetPerformanceMark('filterBarStart');
            (0, $361on.onFilterChangeStartInteraction)(fieldType, onChangeInteractionStart, onCustomFilterChangeInteractionStart);
            const values = filters[fieldType] ?? [];
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            let updatedFilter = {
                ...localFilter,
                [fieldType]: values
            };
            if (values.length === 0) {
                isCompanyManaged && onClearCustomFilterInteractionStart();
                updatedFilter = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(localFilter, fieldType);
            }
            setFilters(updatedFilter);
            // fieldType could in theory not be accurate on a final debounced call,
            // however there's only a 5ms window during which this may happen.
            debouncedOnChange(updatedFilter, fieldType, attributes);
        }
    }, [
        onChangeInteractionStart,
        onCustomFilterChangeInteractionStart,
        setFilters,
        localFilter,
        debouncedOnChange,
        isCompanyManaged,
        onClearCustomFilterInteractionStart
    ]);
    const clearFilter = (0, $5uXOq.useCallback)(()=>{
        const emptyFilters = {
            TEXT: undefined,
            ASSIGNEE: undefined,
            LABEL: undefined,
            SPRINT: undefined,
            ISSUE_PARENT: undefined,
            ISSUE_PROJECT: undefined,
            ISSUE_TYPE: undefined,
            VERSION: undefined,
            REQUEST_TYPE: undefined,
            STATUS_CATEGORY: undefined,
            STATUS: undefined,
            CUSTOM_FILTER: undefined,
            DEPENDENCIES: undefined
        };
        isCompanyManaged && onClearCustomFilterInteractionStart();
        setFilters(emptyFilters);
        // A 2nd `null` argument is required so that the analytics event doesn't get treated as the
        // filter type on filter analytics.
        onChange((0, $361on.getNormalizedFilters)(emptyFilters), null, undefined);
    }, [
        onChange,
        isCompanyManaged,
        onClearCustomFilterInteractionStart
    ]);
    return [
        localFilter,
        onChangeFilterValues,
        clearFilter
    ];
};
const $2622f927d259b739$var$SoftwareFilters = (props)=>{
    const { filter: filter, onChange: onChange, onClearAllButtonClicked: onClearAllButtonClicked, onChangeInteractionFeedback: onChangeInteractionFeedback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeInteractionStart: onChangeInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCustomFilterChangeInteractionFeedback: onCustomFilterChangeInteractionFeedback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCustomFilterChangeInteractionStart: onCustomFilterChangeInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onExperienceSuccess: onExperienceSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isCompanyManaged: isCompanyManaged = false, onClearCustomFilterInteractionStart: onClearCustomFilterInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [localFilters, onChangeFilterValues, clearFilter] = $2622f927d259b739$var$useOnChangeFilterValues(filter, onChange, onChangeInteractionStart, onCustomFilterChangeInteractionStart, createAnalyticsEvent, onClearCustomFilterInteractionStart, isCompanyManaged);
    (0, $5uXOq.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(filter, localFilters)) {
            $2622f927d259b739$var$clearAndSetPerformanceMark('filterBarStop');
            onChangeInteractionFeedback();
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(filter.CUSTOM_FILTER, localFilters.CUSTOM_FILTER)) onCustomFilterChangeInteractionFeedback();
        }
    }, [
        filter,
        localFilters,
        onChangeInteractionFeedback,
        onCustomFilterChangeInteractionFeedback
    ]);
    $2622f927d259b739$var$clearAndSetPerformanceMark('oldFilterBarStop');
    const onClear = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        // we always have to pass void entityType, so analytics events will always be as third argument
        clearFilter();
        onClearAllButtonClicked && onClearAllButtonClicked(event, analyticsEvent);
        const customAnalyticsEvent = createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'filterBar'
        });
        (0, $8zOmE.fireUIAnalytics)(customAnalyticsEvent, 'changeFilterBar', {
            filterType: (0, $15a528573ccd89ae$export$6c4d37c7f376a1de)
        });
    }, [
        clearFilter,
        onClearAllButtonClicked,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kbfkr.default), {
        ...props,
        filter: localFilters,
        onClearAllButtonClicked: onClear,
        onChange: onChangeFilterValues
    });
};
var $2622f927d259b739$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($2622f927d259b739$var$SoftwareFilters);

});
parcelRegister("kbfkr", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb7c802f0a442491$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $8Rkzz = parcelRequire("8Rkzz");

var $hqTkp = parcelRequire("hqTkp");

var $gKZoD = parcelRequire("gKZoD");

var $eWXbg = parcelRequire("eWXbg");

var $tvuR8 = parcelRequire("tvuR8");

var $dC5iT = parcelRequire("dC5iT");

var $eZJjh = parcelRequire("eZJjh");

var $kY99m = parcelRequire("kY99m");

var $dqoiX = parcelRequire("dqoiX");

var $5p1kJ = parcelRequire("5p1kJ");

var $5rVQI = parcelRequire("5rVQI");

var $eG9rp = parcelRequire("eG9rp");

var $879xD = parcelRequire("879xD");

var $joX8T = parcelRequire("joX8T");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $6CjZR = parcelRequire("6CjZR");

var $1beWO = parcelRequire("1beWO");

var $3oCwY = parcelRequire("3oCwY");

var $7j6PN = parcelRequire("7j6PN");

var $8bg0N = parcelRequire("8bg0N");

var $kgqZV = parcelRequire("kgqZV");

var $efv79 = parcelRequire("efv79");

var $jKPI1 = parcelRequire("jKPI1");

var $hHL6f = parcelRequire("hHL6f");

var $2fsdj = parcelRequire("2fsdj");

var $bLWKp = parcelRequire("bLWKp");

var $hpA0D = parcelRequire("hpA0D");

var $g65Ek = parcelRequire("g65Ek");

var $jdA4J = parcelRequire("jdA4J");

var $cSFZv = parcelRequire("cSFZv");

var $3f9TT = parcelRequire("3f9TT");

var $aMFc7 = parcelRequire("aMFc7");

var $fJnmW = parcelRequire("fJnmW");

var $koVbs = parcelRequire("koVbs");

var $cTi8P = parcelRequire("cTi8P");

var $2m0b6 = parcelRequire("2m0b6");

var $gtgKk = parcelRequire("gtgKk");

var $8vjSE = parcelRequire("8vjSE");

var $2WENx = parcelRequire("2WENx");

var $2xSAL = parcelRequire("2xSAL");

var $g5X3G = parcelRequire("g5X3G");

var $fUHZ2 = parcelRequire("fUHZ2");

var $90yGq = parcelRequire("90yGq");

var $dCm1o = parcelRequire("dCm1o");


var $cM4EP = parcelRequire("cM4EP");

var $2FvdY = parcelRequire("2FvdY");

var $kH9yv = parcelRequire("kH9yv");

var $bBMqL = parcelRequire("bBMqL");

var $l38sT = parcelRequire("l38sT");

var $649U3 = parcelRequire("649U3");
const $cb7c802f0a442491$var$EMPTY_ARRAY = [];
const $cb7c802f0a442491$var$MIN_VISIBLE_USERS = 2;
const $cb7c802f0a442491$var$USER_AVATAR_WIDTH = 30;
const $cb7c802f0a442491$var$DEFAULT_VISIBLE_USERS = 7;
const $cb7c802f0a442491$var$MIN_FILTER_BAR_WIDTH = 510;
const $cb7c802f0a442491$var$LARGE_SEARCH_FILTER_BREAKPOINT = 1440;
const $cb7c802f0a442491$var$SoftwareFiltersStateless = (props)=>{
    (0, $gKZoD.di)(requestAnimationFrame);
    const { filter: filter, issueParentsLabel: issueParentsLabel, assignees: assignees = [], issueParents: issueParents = [], versions: versions = [], components: components = [], labels: labels = [], issueProjects: issueProjects = {}, issueTypes: issueTypes = [], issueTypeGroups: issueTypeGroups = [], statuses: statuses = [], requestTypes: requestTypes = [], onChange: onChange, onSearchFieldFocus: onSearchFieldFocus = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onExtraAvatarMenuOpen: onExtraAvatarMenuOpen = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onFilterPanelMounted: onFilterPanelMounted = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onClearAllButtonClicked: onClearAllButtonClicked = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onToggleParentPanel: onToggleParentPanel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onToggleVersionsPanel: onToggleVersionsPanel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isIssueParentPanelToggleChecked: isIssueParentPanelToggleChecked = false, isVersionPanelToggleChecked: isVersionPanelToggleChecked = false, isAnyModalOpen: isAnyModalOpen = false, AddPeopleModal: AddPeopleModal, showPanelToggle: /**
     * @deprecated `showPanelToggle` used to control visibility of all panel toggles. Use `panelToggleVisibility` instead to control each panel toggle visibility.
     */ showPanelToggle = false, panelToggleVisibility: panelToggleVisibility, showParentIssueMenuIfValuesAreEmpty: showParentIssueMenuIfValuesAreEmpty = false, showSearchFilterChangeboarding: showSearchFilterChangeboarding = false, hijackBrowserDefaultSearch: hijackBrowserDefaultSearch = false, screenName: screenName, isVersionsFeatureEnabled: isVersionsFeatureEnabled = false, isComponentsFeatureEnabled: isComponentsFeatureEnabled = false, isStatusCategoriesFeatureEnabled: isStatusCategoriesFeatureEnabled = true, isIssueParentsFeatureEnabled: isIssueParentsFeatureEnabled = true, isLabelsFeatureEnabled: isLabelsFeatureEnabled = true, isIssueProjectsFeatureEnabled: isIssueProjectsFeatureEnabled = false, isIssueTypesFeatureEnabled: isIssueTypesFeatureEnabled = true, isSprintsFeatureEnabled: isSprintsFeatureEnabled = true, isRequestTypesFeatureEnabled: isRequestTypesFeatureEnabled = false, isStatusesFeatureEnabled: isStatusesFeatureEnabled = false, isGroupIssueTypesEnabled: isGroupIssueTypesEnabled = false, isDependenciesFeatureEnabled: isDependenciesFeatureEnabled = false, onChangeInteractionStart: onChangeInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), projectId: projectId, projectName: projectName, projectKey: projectKey, boardId: boardId, statusCategories: statusCategories = [], customFiltersQueryRef: customFiltersQueryRef, CustomFilter: CustomFilter, showAssigneeFilter: showAssigneeFilter = true, showCustomFilters: showCustomFilters = false, showBoardSwitcher: showBoardSwitcher = false, isBoardSwitcherReadOnly: isBoardSwitcherReadOnly = true, versionFilterRelayQueryRef: versionFilterRelayQueryRef, VersionFilterRelay: VersionFilterRelay, isVersionFilterRelayEnabled: isVersionFilterRelayEnabled = false, isUnassignedAssigneeOptionEnabled: isUnassignedAssigneeOptionEnabled = false, isUnassignedVersionOptionEnabled: isUnassignedVersionOptionEnabled = false, isUnassignedLabelOptionEnabled: isUnassignedLabelOptionEnabled = false, isUnassignedComponentOptionEnabled: isUnassignedComponentOptionEnabled = false, isCustomFiltersLoading: isCustomFiltersLoading = false, placeholder: placeholder = '', screenReaderInstruction: screenReaderInstruction = '', sprints: sprints = [], isAddPeopleButtonEnabled: isAddPeopleButtonEnabled = false, isCustomFilterManageLinkEnabled: isCustomFilterManageLinkEnabled = false, jqlFilters: jqlFilters = [], isCompanyManaged: isCompanyManaged = false, isJSMBoard: isJSMBoard = false, hasMultipleProjects: hasMultipleProjects = false, isGoalsFeatureOptionEnabled: isGoalsFeatureOptionEnabled = false, goals: goals = [] } = props;
    const accountId = (0, $90yGq.useAccountId)();
    const isAsyncFilterLoading = isCustomFiltersLoading;
    const [screenReaderInstructionForFilters, setScreenReaderInstructionForFilters] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const allAssignees = (0, $5uXOq.useMemo)(()=>{
        if (!isUnassignedAssigneeOptionEnabled) return assignees;
        const unassignedUser = {
            id: (0, $g5X3G.toAccountId)((0, $15a528573ccd89ae$export$12e572fd459c10dc)),
            displayName: formatMessage((0, $l38sT.default).unassignedAssigneeDisplayName),
            avatarUrl: undefined
        };
        if ((0, $4R6GH.fg)('jira-collab-unassigned-filter-cta-gate')) return [
            unassignedUser,
            ...assignees
        ];
        return [
            ...assignees,
            unassignedUser
        ];
    }, [
        assignees,
        isUnassignedAssigneeOptionEnabled,
        formatMessage
    ]);
    const allVersions = (0, $5uXOq.useMemo)(()=>isUnassignedVersionOptionEnabled && versions.length ? [
            {
                id: (0, $15a528573ccd89ae$export$ac95b4b2317d4b33),
                name: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l38sT.default).unassignedVersionLabelIssueTermRefresh : (0, $l38sT.default).unassignedVersionLabel)
            },
            ...versions
        ] : versions, [
        versions,
        isUnassignedVersionOptionEnabled,
        formatMessage
    ]);
    const unassignedOption = (0, $5uXOq.useMemo)(()=>({
            label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l38sT.default).unassignedLabelLabelIssueTermRefresh : (0, $l38sT.default).unassignedLabelLabel),
            value: (0, $15a528573ccd89ae$export$81ef49afbbead0a1)
        }), [
        formatMessage
    ]);
    const allComponents = (0, $5uXOq.useMemo)(()=>isUnassignedComponentOptionEnabled && components.length ? [
            {
                id: (0, $15a528573ccd89ae$export$4b7c755e61199a36),
                name: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l38sT.default).unassignedComponentLabelIssueTermRefresh : (0, $l38sT.default).unassignedComponentLabel)
            },
            ...components
        ] : components, [
        components,
        isUnassignedComponentOptionEnabled,
        formatMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        onFilterPanelMounted();
    }, [
        onFilterPanelMounted
    ]); // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onSearchChange = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((newText)=>{
        onChangeInteractionStart();
        onChange({
            [(0, $15a528573ccd89ae$export$d597759d33be802e)]: newText
        }, (0, $15a528573ccd89ae$export$d597759d33be802e), undefined);
    }, 300), [
        onChange,
        onChangeInteractionStart
    ]);
    const assigneeValue = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filter, [
            (0, $15a528573ccd89ae$export$f8f7545d2bb78afb)
        ], $cb7c802f0a442491$var$EMPTY_ARRAY), [
        filter
    ]);
    const onToggleAssignee = (0, $5uXOq.useCallback)((entryId)=>{
        setScreenReaderInstructionForFilters(true);
        setTimeout(()=>{
            setScreenReaderInstructionForFilters(false);
        });
        const withoutValue = (0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(assigneeValue, entryId);
        const newFilterValue = withoutValue.length === assigneeValue.length ? withoutValue.concat(entryId) : withoutValue;
        onChange({
            [(0, $15a528573ccd89ae$export$f8f7545d2bb78afb)]: (0, $g5X3G.toAccountIdArray)(newFilterValue)
        }, (0, $15a528573ccd89ae$export$f8f7545d2bb78afb), {
            isUnassignedFilterCta: false,
            // part of experiment jira-collab-unassigned-filter-cta
            isUnassignedSelected: newFilterValue.includes((0, $15a528573ccd89ae$export$12e572fd459c10dc)),
            isOnlyCurrentUserSelected: accountId && newFilterValue.length === 1 && newFilterValue[0] === accountId
        });
    }, [
        assigneeValue,
        onChange,
        accountId
    ]);
    const onChangeParents = (0, $5uXOq.useCallback)((parentIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$2a4f270075a033de)]: parentIds
        }, (0, $15a528573ccd89ae$export$2a4f270075a033de), attributes);
    }, [
        onChange
    ]);
    const onChangeVersions = (0, $5uXOq.useCallback)((versionIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$a4ad2735b021c132)]: (0, $g5X3G.toVersionIdArray)(versionIds)
        }, (0, $15a528573ccd89ae$export$a4ad2735b021c132), attributes);
    }, [
        onChange
    ]);
    const onChangeComponents = (0, $5uXOq.useCallback)((componentIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$af1e30ebbae9df3b)]: (0, $g5X3G.toComponentIdArray)(componentIds)
        }, (0, $15a528573ccd89ae$export$af1e30ebbae9df3b), attributes);
    }, [
        onChange
    ]);
    const onChangeLabels = (0, $5uXOq.useCallback)((newLabels, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$37aee82a3cb1e8f7)]: newLabels
        }, (0, $15a528573ccd89ae$export$37aee82a3cb1e8f7), attributes);
    }, [
        onChange
    ]);
    const onChangeIssueProjects = (0, $5uXOq.useCallback)((newProjects, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$401f4b6eda6a369c)]: newProjects
        }, (0, $15a528573ccd89ae$export$401f4b6eda6a369c), attributes);
    }, [
        onChange
    ]);
    const onChangeIssueTypes = (0, $5uXOq.useCallback)((issueTypeIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$ebb48b08205007c5)]: issueTypeIds
        }, (0, $15a528573ccd89ae$export$ebb48b08205007c5), attributes);
    }, [
        onChange
    ]);
    const onChangeStatusCategories = (0, $5uXOq.useCallback)((newStatusCategories, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$f863b019d19144f4)]: newStatusCategories
        }, (0, $15a528573ccd89ae$export$f863b019d19144f4), attributes);
    }, [
        onChange
    ]);
    const onChangeCustomFilters = (0, $5uXOq.useCallback)((newCustomFilters, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$68d693c35a8d8866)]: newCustomFilters
        }, (0, $15a528573ccd89ae$export$68d693c35a8d8866), attributes);
    }, [
        onChange
    ]);
    const onChangeSprints = (0, $5uXOq.useCallback)((newSprintIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$a316570a0dbfd2b0)]: newSprintIds
        }, (0, $15a528573ccd89ae$export$a316570a0dbfd2b0), attributes);
    }, [
        onChange
    ]);
    const onChangeStatuses = (0, $5uXOq.useCallback)((newStatuses, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$e50006273435e7d4)]: newStatuses
        }, (0, $15a528573ccd89ae$export$e50006273435e7d4), attributes);
    }, [
        onChange
    ]);
    const onChangeRequestTypes = (0, $5uXOq.useCallback)((newRequestTypeIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$92ab80c1dc9baf44)]: newRequestTypeIds
        }, (0, $15a528573ccd89ae$export$92ab80c1dc9baf44), attributes);
    }, [
        onChange
    ]);
    const onChangeQuickFilters = (0, $5uXOq.useCallback)((newQuickFilters, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$1ea95b94fb0c51d9)]: newQuickFilters
        }, (0, $15a528573ccd89ae$export$1ea95b94fb0c51d9), attributes);
    }, [
        onChange
    ]);
    const onChangeGoals = (0, $5uXOq.useCallback)((goalIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$871e58afc769b358)]: goalIds
        }, (0, $15a528573ccd89ae$export$871e58afc769b358), attributes);
    }, [
        onChange
    ]);
    const onChangeDependencies = (0, $5uXOq.useCallback)((dependencyOptions, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$db362e2d293fe52e)]: dependencyOptions
        }, (0, $15a528573ccd89ae$export$db362e2d293fe52e), attributes);
    }, [
        onChange
    ]);
    const isClearButtonVisible = (0, $5uXOq.useMemo)(()=>filter && Object.keys(filter).length > 0, [
        filter
    ]);
    const searchInputRef = (0, $5uXOq.useRef)(null);
    const fireShortcutAnalytics = (0, $fUHZ2.useShortcutAnalytics)(screenName);
    const focusSearchInput = (0, $6s1PB.expVal)('blu-3488_fix_jsw_filters_flickering', 'isEnabled', false) ? ()=>{
        if (!searchInputRef.current) return; // This is the same way the global search input prevents
        // the shortcut from being fed into the input
        // See: src/packages/navigation-apps/atlassian-navigation/src/ui/integrations/keyboard-shortcuts/index.tsx
        requestAnimationFrame(()=>{
            searchInputRef.current && searchInputRef.current.focus();
        });
        const analyticsPayload = {
            id: 'focusSearchField',
            key: 'f',
            attributes: {}
        };
        fireShortcutAnalytics(analyticsPayload);
    } : ()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(searchInputRef) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(searchInputRef.current)) {
            // This is the same way the global search input prevents
            // the shortcut from being fed into the input
            // See: src/packages/navigation-apps/atlassian-navigation/src/ui/integrations/keyboard-shortcuts/index.tsx
            requestAnimationFrame(()=>{
                searchInputRef.current && searchInputRef.current.focus();
            });
            const analyticsPayload = {
                id: 'focusSearchField',
                key: 'f',
                attributes: {}
            };
            fireShortcutAnalytics(analyticsPayload);
        }
    };
    const screenReaderDescriptionId = 'search-issue-description'; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const isUserBoard = window.location.pathname.startsWith('/jira/people/');
    const customFilterManageUrl = (0, $649U3.getManageCustomFiltersUrl)(projectKey, boardId.toString(), isCompanyManaged, isUserBoard, isJSMBoard);
    const showEpicPanelToggle = panelToggleVisibility ? panelToggleVisibility.showEpicPanelToggle : showPanelToggle;
    const isMounted = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (isMounted.current) {
            if (!isClearButtonVisible) {
                setScreenReaderInstructionForFilters(true);
                setTimeout(()=>{
                    setScreenReaderInstructionForFilters(false);
                }, 1000);
            }
        } else isMounted.current = true;
    }, [
        isClearButtonVisible
    ]);
    const parentFilter = {
        id: (0, $15a528573ccd89ae$export$2a4f270075a033de),
        isStatic: false,
        isHidden: !isIssueParentsFeatureEnabled,
        renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bLWKp.default), {
                key: "ParentFilter",
                isNested: isNested,
                label: issueParentsLabel,
                parents: issueParents,
                selectedParents: filter[0, $15a528573ccd89ae$export$2a4f270075a033de],
                isToggleChecked: isIssueParentPanelToggleChecked,
                onChange: onChangeParents,
                onTogglePanel: onToggleParentPanel,
                showPanelToggle: showEpicPanelToggle,
                showMenuIfValuesAreEmpty: showParentIssueMenuIfValuesAreEmpty
            })
    };
    const showVersionsPanelToggle = panelToggleVisibility ? panelToggleVisibility.showVersionsPanelToggle : showPanelToggle;
    const versionFilter = {
        id: (0, $15a528573ccd89ae$export$a4ad2735b021c132),
        isStatic: false,
        hidden: !isVersionsFeatureEnabled,
        renderer: (isNested)=>isVersionFilterRelayEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBMqL.default), {
                key: "VersionFilterRelayBoundary",
                screenName: screenName,
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aMFc7.default), {
                    isNested: isNested,
                    versions: $cb7c802f0a442491$var$EMPTY_ARRAY,
                    isToggleChecked: isVersionPanelToggleChecked,
                    onChange: onChangeVersions,
                    onTogglePanel: onToggleVersionsPanel,
                    selectedVersions: filter[0, $15a528573ccd89ae$export$a4ad2735b021c132] ?? $cb7c802f0a442491$var$EMPTY_ARRAY,
                    isSpotlightEnabled: false,
                    showPanelToggle: showVersionsPanelToggle,
                    isVersionsFeatureEnabled: isVersionsFeatureEnabled,
                    hasMultipleProjects: hasMultipleProjects,
                    isLoading: true
                })
            }, versionFilterRelayQueryRef != null && VersionFilterRelay != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(VersionFilterRelay, {
                isNested: isNested,
                isToggleChecked: isVersionPanelToggleChecked,
                onChange: onChangeVersions,
                onTogglePanel: onToggleVersionsPanel,
                selectedVersions: filter[0, $15a528573ccd89ae$export$a4ad2735b021c132] ?? $cb7c802f0a442491$var$EMPTY_ARRAY,
                isSpotlightEnabled: false,
                showPanelToggle: showVersionsPanelToggle,
                isVersionsFeatureEnabled: isVersionsFeatureEnabled,
                versionFilterRelayQueryRef: versionFilterRelayQueryRef,
                isUnassignedVersionOptionEnabled: isUnassignedVersionOptionEnabled,
                hasMultipleProjects: hasMultipleProjects
            }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aMFc7.default), {
                key: "VersionFilter",
                isNested: isNested,
                versions: allVersions,
                isToggleChecked: isVersionPanelToggleChecked,
                onChange: onChangeVersions,
                onTogglePanel: onToggleVersionsPanel,
                selectedVersions: filter[0, $15a528573ccd89ae$export$a4ad2735b021c132] ?? $cb7c802f0a442491$var$EMPTY_ARRAY,
                isSpotlightEnabled: false,
                showPanelToggle: showVersionsPanelToggle,
                isVersionsFeatureEnabled: isVersionsFeatureEnabled
            })
    };
    const overflowItemsBefore = [
        {
            id: (0, $15a528573ccd89ae$export$f863b019d19144f4),
            isStatic: false,
            isHidden: !isStatusCategoriesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cSFZv.default), {
                    key: "StatusCategoryFilter",
                    isNested: isNested,
                    statusCategories: statusCategories,
                    selectedStatusCategories: filter[0, $15a528573ccd89ae$export$f863b019d19144f4],
                    onChange: onChangeStatusCategories
                })
        },
        /**
   * the "Project" filter is currently only used by the Increment Planning board of Advanced Roadmaps
   * please refer to src/packages/software/board/src/services/filter/filter-url-bindings.tsx
   */ {
            id: (0, $15a528573ccd89ae$export$401f4b6eda6a369c),
            isStatic: false,
            isHidden: !isIssueProjectsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efv79.default), {
                    isNested: isNested,
                    issueProjects: issueProjects,
                    key: "IssueProjectFilter",
                    onChange: onChangeIssueProjects,
                    selectedProjects: filter[0, $15a528573ccd89ae$export$401f4b6eda6a369c]
                })
        },
        versionFilter,
        parentFilter,
        {
            id: (0, $15a528573ccd89ae$export$37aee82a3cb1e8f7),
            isStatic: false,
            isHidden: !isLabelsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2fsdj.default), {
                    key: "LabelFilter",
                    isNested: isNested,
                    ...isUnassignedLabelOptionEnabled && labels.length ? {
                        unassignedOption: unassignedOption
                    } : undefined,
                    labels: labels,
                    selectedLabels: filter[0, $15a528573ccd89ae$export$37aee82a3cb1e8f7],
                    onChange: onChangeLabels
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$ebb48b08205007c5),
            isStatic: false,
            isHidden: !isIssueTypesFeatureEnabled,
            renderer: (isNested)=>isGroupIssueTypesEnabled ? // In the program board, we could have multiple issue types with the same hierarchy level and names coming from multiple TWP project. We group them so there's no visually duplicated items in the dropdown
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jKPI1.default), {
                    key: "IssueTypeGroupFilter",
                    isNested: isNested,
                    issueTypeGroups: issueTypeGroups,
                    selectedIssueTypes: filter[0, $15a528573ccd89ae$export$ebb48b08205007c5],
                    onChange: onChangeIssueTypes
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hHL6f.default), {
                    key: "IssueTypeFilter",
                    isNested: isNested,
                    issueTypes: issueTypes,
                    selectedIssueTypes: filter[0, $15a528573ccd89ae$export$ebb48b08205007c5],
                    onChange: onChangeIssueTypes
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$af1e30ebbae9df3b),
            isStatic: false,
            isHidden: !isComponentsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7j6PN.default), {
                    key: "ComponentFilter",
                    isNested: isNested,
                    components: allComponents,
                    onChange: onChangeComponents,
                    selectedComponents: filter[0, $15a528573ccd89ae$export$af1e30ebbae9df3b]
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$a316570a0dbfd2b0),
            isStatic: false,
            isHidden: !isSprintsFeatureEnabled || sprints.length <= 1,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdA4J.default), {
                    key: "SprintFilter",
                    isNested: isNested,
                    sprints: sprints,
                    selectedSprints: filter[0, $15a528573ccd89ae$export$a316570a0dbfd2b0],
                    onChange: onChangeSprints
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$e50006273435e7d4),
            isStatic: false,
            isHidden: !isStatusesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3f9TT.default), {
                    key: "StatusFilter",
                    isNested: isNested,
                    statuses: statuses,
                    selectedStatuses: filter[0, $15a528573ccd89ae$export$e50006273435e7d4],
                    onChange: onChangeStatuses
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$92ab80c1dc9baf44),
            isStatic: false,
            isHidden: !isRequestTypesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g65Ek.default), {
                    key: "RequestTypeFilter",
                    isNested: isNested,
                    requestTypes: requestTypes,
                    selectedRequestTypes: filter[0, $15a528573ccd89ae$export$92ab80c1dc9baf44],
                    onChange: onChangeRequestTypes
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$68d693c35a8d8866),
            isStatic: false,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cM4EP.default), {
                    key: "CustomFilterBoundary",
                    screenName: screenName,
                    customFiltersQueryRef: customFiltersQueryRef
                }, (!!customFiltersQueryRef || showCustomFilters) && !!CustomFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomFilter, {
                    shouldReturnFocus: (0, $4R6GH.fg)('jsw_remove_the_auto_focus_on_custom_filter') ? undefined : isClearButtonVisible === false,
                    isNested: isNested,
                    customFiltersQueryRef: customFiltersQueryRef,
                    selectedFilters: filter[0, $15a528573ccd89ae$export$68d693c35a8d8866],
                    filters: jqlFilters,
                    onChange: onChangeCustomFilters,
                    showLink: isCustomFilterManageLinkEnabled,
                    manageUrl: customFilterManageUrl,
                    screenName: screenName
                }))
        },
        {
            id: (0, $15a528573ccd89ae$export$1ea95b94fb0c51d9),
            isStatic: false,
            isHidden: showCustomFilters,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hpA0D.default), {
                    key: "QuickFilter",
                    isNested: isNested,
                    filters: jqlFilters,
                    selectedFilters: filter[0, $15a528573ccd89ae$export$1ea95b94fb0c51d9],
                    onChange: onChangeQuickFilters
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$871e58afc769b358),
            isStatic: false,
            isHidden: !isGoalsFeatureOptionEnabled || goals.length === 0,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgqZV.default), {
                    key: "GoalFilter",
                    isNested: isNested,
                    goals: goals,
                    selectedGoals: filter[0, $15a528573ccd89ae$export$871e58afc769b358],
                    onChange: onChangeGoals
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$db362e2d293fe52e),
            isStatic: false,
            isHidden: (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') ? !isDependenciesFeatureEnabled : true,
            renderer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8bg0N.default), {
                    key: "DependenciesFilter",
                    onChange: onChangeDependencies,
                    selectedValues: filter[0, $15a528573ccd89ae$export$db362e2d293fe52e]
                })
        }
    ];
    const overflowItemsAfter = [
        {
            id: 'CLEAR_BUTTON',
            // The CLEAR_BUTTON should be non-static until a filter is added, else it causes the More button to appear
            // in the filter bar on small window sizes, due to overflow calculations in <OverflowHandler />
            isStatic: isClearButtonVisible,
            isHidden: !isClearButtonVisible,
            renderer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3oCwY.default), {
                    key: "ClearButton",
                    onClick: onClearAllButtonClicked
                })
        }
    ];
    if (isAsyncFilterLoading) overflowItemsAfter.push({
        id: 'SPINNER',
        isStatic: true,
        isHidden: !isAsyncFilterLoading,
        renderer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb7c802f0a442491$var$SpinnerContainer, {
                key: "SpinnerContainer"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                size: "small"
            }))
    });
    const { getKeywords: getKeywords } = (0, $eG9rp.useCommandKeywords)();
    const [maxVisibleUsers, setMaxVisibleUsers] = (0, $5uXOq.useState)($cb7c802f0a442491$var$DEFAULT_VISIBLE_USERS);
    const [showLargeSearchFilter, setShowLargeSearchFilter] = (0, $5uXOq.useState)(true);
    const filterBarRef = (0, $5uXOq.useRef)(null);
    const onResize = (0, $5uXOq.useCallback)(()=>{
        if (!filterBarRef.current || !searchInputRef.current) return;
        const completeFilterBarWidth = filterBarRef.current.offsetWidth; // complete bar with input + filter controls
        const searchInputWidth = searchInputRef.current.offsetWidth; // only the input
        const remainingWidth = completeFilterBarWidth - searchInputWidth; // remaining room for avatar, etc.
        // Handle avatar overflow
        if (remainingWidth < $cb7c802f0a442491$var$MIN_FILTER_BAR_WIDTH) {
            const usersToReduce = Math.ceil(($cb7c802f0a442491$var$MIN_FILTER_BAR_WIDTH - remainingWidth) / $cb7c802f0a442491$var$USER_AVATAR_WIDTH);
            const newMax = Math.max($cb7c802f0a442491$var$DEFAULT_VISIBLE_USERS - usersToReduce, $cb7c802f0a442491$var$MIN_VISIBLE_USERS);
            setMaxVisibleUsers(newMax);
        } else setMaxVisibleUsers($cb7c802f0a442491$var$DEFAULT_VISIBLE_USERS);
         // Handle search field width
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        setShowLargeSearchFilter(window.innerWidth >= $cb7c802f0a442491$var$LARGE_SEARCH_FILTER_BREAKPOINT);
    }, []);
    (0, $2m0b6.useResizeObserver)({
        ref: filterBarRef,
        onResize: onResize
    });
    (0, $2m0b6.useResizeObserver)({
        ref: searchInputRef,
        onResize: onResize
    });
    const { experimentCohort: experimentCohort } = (0, $2WENx.useRealtimePresenceExperiment)();
    const isRealtimePresenceEnabled = ()=>screenName === 'board' && experimentCohort === (0, $joX8T.VARIATION);
    if (screenName === 'board' && experimentCohort !== (0, $joX8T.NOT_ENROLLED)) {
        const [, fireExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_board_real-time_collaboration_through_presence');
        fireExposure();
    }
    const [{ participants: participants }] = (0, $8vjSE.useCollabStore)();
    const allUsersWithPresence = isRealtimePresenceEnabled() ? (0, $649U3.getAssigneesWithPresence)(allAssignees, participants) : allAssignees;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJnmW.FilterBar), {
        ref: filterBarRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $879xD.CommandShortcuts), {
        keyMap: {
            f: {
                callback: focusSearchInput,
                registerInCommandPalette: {
                    id: 'software-filters-stateless-focus-search-input',
                    name: formatMessage((0, $l38sT.default).searchCurrentPage),
                    keywords: getKeywords('pageSearchSynonyms'),
                    priority: (0, $5rVQI.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).searchOnCurrentPage,
                    section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).quickActions,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eWXbg))), {
                                label: formatMessage((0, $l38sT.default).searchCurrentPage)
                            })
                    },
                    analytics: {
                        action: 'searchCurrentPage'
                    }
                }
            }
        },
        location: "software.filters.keyboard-shortcuts"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        id: screenReaderDescriptionId
    }, screenReaderInstruction || formatMessage((0, $l38sT.default).screenReaderInstruction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, screenReaderInstructionForFilters ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        "data-testid": "software-filters.ui.stateless.screen-reader-instruction",
        id: "software-filters.ui.stateless.screen-reader-instruction",
        role: "status",
        "aria-relevant": "all"
    }, formatMessage((0, $l38sT.default).screenReaderInstructionForFilters)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        "data-testid": "software-filters.ui.stateless.screen-reader-instruction",
        id: "software-filters.ui.stateless.screen-reader-instruction",
        role: "status"
    })), hijackBrowserDefaultSearch === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2FvdY.default), {
        onFocusSearch: focusSearchInput,
        isAnyModalOpen: isAnyModalOpen
    }), showSearchFilterChangeboarding === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kH9yv.default), {
        hijackBrowserDefaultSearch: hijackBrowserDefaultSearch,
        screenName: screenName,
        isCompanyManaged: isCompanyManaged
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
        placeholderAlwaysVisible: true,
        describedById: screenReaderDescriptionId,
        isAlwaysExpanded: showLargeSearchFilter,
        searchIconVisible: false,
        renderCustomSearchField: $cb7c802f0a442491$var$CustomSearchInput,
        value: filter[0, $15a528573ccd89ae$export$d597759d33be802e] || '',
        placeholder: placeholder || formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l38sT.default).textFilterIssueTermRefresh : (0, $l38sT.default).textFilter),
        onChange: onSearchChange,
        onFocus: onSearchFieldFocus,
        inputRef: searchInputRef,
        maxLength: 255,
        testId: "software-filters.ui.stateless.search-field"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
        placeholderAlwaysVisible: true,
        describedById: screenReaderDescriptionId,
        isAlwaysExpanded: showLargeSearchFilter,
        searchIconVisible: false,
        renderCustomSearchField: $cb7c802f0a442491$var$CustomSearchInput,
        value: filter[0, $15a528573ccd89ae$export$d597759d33be802e] || '',
        placeholder: placeholder || formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l38sT.default).textFilterIssueTermRefresh : (0, $l38sT.default).textFilter),
        onChange: onSearchChange,
        onFocus: onSearchFieldFocus,
        inputRef: searchInputRef,
        maxLength: 255,
        testId: "software-filters.ui.stateless.search-field"
    }), showBoardSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cTi8P.default), {
        boardId: boardId,
        isReadOnly: isBoardSwitcherReadOnly
    }), showAssigneeFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1beWO.default), {
        maxUsers: maxVisibleUsers,
        users: allUsersWithPresence,
        screenName: screenName,
        selectedUsers: assigneeValue,
        onToggle: onToggleAssignee,
        onAssigneeMenuOpen: onExtraAvatarMenuOpen,
        AddPeopleModal: AddPeopleModal,
        projectId: projectId,
        projectName: projectName,
        isAddPeopleButtonEnabled: isAddPeopleButtonEnabled,
        projectKey: projectKey
    }), isRealtimePresenceEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gtgKk.CollabContainerAsync), {
        screenName: screenName,
        boardId: boardId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJnmW.ListFilterContainerNextGen // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    ), {
        "data-testid": "software-filters.ui.list-filter-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6CjZR.default), {
        itemsBefore: overflowItemsBefore,
        itemsAfter: overflowItemsAfter,
        selectedItems: filter
    })));
};
const $cb7c802f0a442491$var$customSearchInputStyles = null; // TODO: remove on visual-refresh cleanup
const $cb7c802f0a442491$var$customSearchInputStylesOld = null;
const $cb7c802f0a442491$var$CustomSearchInput = ({ textFieldProps: textFieldProps, searchIcon: searchIcon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        ...textFieldProps,
        elemAfterInput: searchIcon,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            paddingInlineStart: "space.100",
            paddingBlockStart: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvuR8))), {
            primaryColor: "var(--ds-icon, #44546F)",
            size: "small",
            label: ""
        })),
        autoComplete: "off",
        testId: "software-filters.ui.stateless.search-field",
        className: (0, $bwpsq.default)([
            (0, $dCm1o.isVisualRefreshEnabled)() ? "_1hxm12x7 _1twg1b66" : "_2rkoq1pp _1yt4ze3t _1rns1b66 _1srlxy5q"
        ])
    });
var $cb7c802f0a442491$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($cb7c802f0a442491$var$SoftwareFiltersStateless);
const $cb7c802f0a442491$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bv1b66 _4t3i1osq _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5p1kJ", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", () => $7691773a5eed3db6$export$16b06d29ef8f802b);
$parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", () => $7691773a5eed3db6$export$156ebd2354e25466);
$parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", () => $7691773a5eed3db6$export$7fe859528e87e623);
$parcel$export(module.exports, "COMMAND_PALETTE_ID", () => $7691773a5eed3db6$export$9f646ab88e1d2b14);
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", () => $7691773a5eed3db6$export$abf26cc5daebd2c8);
$parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", () => $7691773a5eed3db6$export$12514ca8899b0521);
$parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", () => $7691773a5eed3db6$export$5fa0bcf59f933c21);
$parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", () => $7691773a5eed3db6$export$7d9743be0b7d862f);
$parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", () => $7691773a5eed3db6$export$b4e1633c86db2b70);
$parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", () => $7691773a5eed3db6$export$5e5a87aac5d9771f);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $7691773a5eed3db6$export$16b06d29ef8f802b;
(function(COMMAND_PALETTE_SECTIONS) {
    COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
    COMMAND_PALETTE_SECTIONS["projectNavigation"] = "project-navigation";
    COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
    COMMAND_PALETTE_SECTIONS["help"] = "help";
    COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
    COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
    COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
    COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
})($7691773a5eed3db6$export$16b06d29ef8f802b || ($7691773a5eed3db6$export$16b06d29ef8f802b = {}));
const $7691773a5eed3db6$export$156ebd2354e25466 = 'issueActions';
const $7691773a5eed3db6$export$7fe859528e87e623 = {
    action: 'pressed',
    actionSubject: 'commandPaletteKeyboardShortcut'
};
const $7691773a5eed3db6$export$9f646ab88e1d2b14 = 'commandPalette';
var $7691773a5eed3db6$export$abf26cc5daebd2c8;
(function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["projectNavigation"] = 2] = "projectNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
})($7691773a5eed3db6$export$abf26cc5daebd2c8 || ($7691773a5eed3db6$export$abf26cc5daebd2c8 = {}));
var $7691773a5eed3db6$export$12514ca8899b0521;
(function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
})($7691773a5eed3db6$export$12514ca8899b0521 || ($7691773a5eed3db6$export$12514ca8899b0521 = {}));
var $7691773a5eed3db6$export$5fa0bcf59f933c21;
(function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
})($7691773a5eed3db6$export$5fa0bcf59f933c21 || ($7691773a5eed3db6$export$5fa0bcf59f933c21 = {}));
var $7691773a5eed3db6$export$7d9743be0b7d862f;
(function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
})($7691773a5eed3db6$export$7d9743be0b7d862f || ($7691773a5eed3db6$export$7d9743be0b7d862f = {}));
var $7691773a5eed3db6$export$b4e1633c86db2b70;
(function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
})($7691773a5eed3db6$export$b4e1633c86db2b70 || ($7691773a5eed3db6$export$b4e1633c86db2b70 = {}));
var $7691773a5eed3db6$export$5e5a87aac5d9771f;
(function(COMMAND_PALETTE_HELP_PRIORITY) {
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
})($7691773a5eed3db6$export$5e5a87aac5d9771f || ($7691773a5eed3db6$export$5e5a87aac5d9771f = {}));

});

parcelRegister("5rVQI", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY", () => $c7aab549acec9d6e$export$5ea2dca0a260365d);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $c7aab549acec9d6e$export$5ea2dca0a260365d;
(function(COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY) {
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["createIssue"] = 0] = "createIssue";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["searchOnCurrentPage"] = 1] = "searchOnCurrentPage";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openQuickSearch"] = 2] = "openQuickSearch";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["copyUrl"] = 3] = "copyUrl";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["checkNotifications"] = 4] = "checkNotifications";
})($c7aab549acec9d6e$export$5ea2dca0a260365d || ($c7aab549acec9d6e$export$5ea2dca0a260365d = {}));

});

parcelRegister("eG9rp", function(module, exports) {

$parcel$export(module.exports, "useCommandKeywords", () => $61ebfb9239c4f8e5$export$4d8fe3ef6385358);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dYWZb = parcelRequire("dYWZb");
const $61ebfb9239c4f8e5$export$4d8fe3ef6385358 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getKeywords = (0, $5uXOq.useCallback)((keywordGroup)=>(0, $dYWZb.messages)[keywordGroup] ? formatMessage((0, $dYWZb.messages)[keywordGroup]) : undefined, [
        formatMessage
    ]);
    return {
        getKeywords: getKeywords
    };
};

});
parcelRegister("dYWZb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $df7d7dd7b88156b7$export$defe85febe8b728c);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $7VHMR = parcelRequire("7VHMR");
const $df7d7dd7b88156b7$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    searchYourIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
        "defaultMessage": "Find my ideas tickets requests tasks work"
    },
    changeStatusSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
        "defaultMessage": "Move through workflow  Progress Done Complete transition"
    },
    assignToMeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
        "defaultMessage": "self"
    },
    assignIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
        "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
    },
    startWatchingIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
        "defaultMessage": "Follow work Track Unwatch Unfollow"
    },
    backlogSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
        "defaultMessage": "Inventory Go"
    },
    boardSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
        "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
    },
    reportsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
        "defaultMessage": "Summary Insights Burndown Go"
    },
    timelineSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
        "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
    },
    // TODO cleanup isCommandPaletteQuickSearchEnabled
    quickSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
        "defaultMessage": "Search products across Atlassian Go to"
    },
    pageSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
        "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
    },
    createIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
        "defaultMessage": "work Start idea New ticket task"
    },
    switchDarkThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
        "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    matchSystemThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
        "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    copyCurrentPageUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
        "defaultMessage": "link website address"
    },
    getHelpSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
        "defaultMessage": "In-product Support Documentation Questions Answers"
    },
    viewKeyboardShortcutsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
        "defaultMessage": "Hotkeys Show See"
    },
    editDescriptionSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
        "defaultMessage": "Completion criteria Info Information Details Add Write"
    },
    addAttachmentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
        "defaultMessage": "Attach Upload Document Media"
    },
    addCommentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
        "defaultMessage": "Write Message"
    },
    logWorkSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
        "defaultMessage": "Track Record hours Time spent"
    },
    addRemoveFlagSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
        "defaultMessage": "Unflag Mark Unmark Star Unstar"
    },
    cloneIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
        "defaultMessage": "Copy Duplicate Task Idea Request"
    },
    linkConfluencePageSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
        "defaultMessage": "Relate Add Connect"
    },
    addAUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
        "defaultMessage": "Connect Weblink Link Website Domain"
    },
    goToIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
        "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
    },
    goToPersonalSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
        "defaultMessage": "Preferences Notifications Theme Jira labs"
    },
    goToAccountSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
        "defaultMessage": "Preferences Privacy Profile Your details Personal information"
    },
    viewAllIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
        "defaultMessage": "Site issues JQL View all"
    },
    viewAllProjectsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllPlansSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllBoardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllFiltersSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllDashboardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
        "defaultMessage": "List Go"
    },
    checkNotificationsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
        "defaultMessage": "window See Updates"
    },
    goToUserManagementSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
        "defaultMessage": "Permissions"
    }
});

});


parcelRegister("879xD", function(module, exports) {

$parcel$export(module.exports, "CommandShortcuts", () => $6700f9962d7215c2$export$7ff7e4fe85a5960a);

var $5uXOq = parcelRequire("5uXOq");

var $1Kt4o = parcelRequire("1Kt4o");

var $556k7 = parcelRequire("556k7");

var $jh7L9 = parcelRequire("jh7L9");

var $3Tty1 = parcelRequire("3Tty1");
const $6700f9962d7215c2$export$7ff7e4fe85a5960a = (props)=>{
    const { keyMap: keyMap } = props;
    const mappedCommands = (0, $5uXOq.useMemo)(()=>{
        const commands = [];
        Object.entries(keyMap).forEach(([key, mapItem])=>{
            if (!mapItem.registerInCommandPalette) return;
            const { primaryAction: primaryAction, ...command } = mapItem.registerInCommandPalette;
            let shortcutPrimaryAction;
            if (primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST || primaryAction?.type === (0, $jh7L9.CommandActionType).PERFORM) shortcutPrimaryAction = primaryAction;
            else if (mapItem.callback) shortcutPrimaryAction = {
                type: (0, $jh7L9.CommandActionType).PERFORM,
                perform: ()=>mapItem.callback()
            };
            /**
			 * loadChildren function has the preference over the other actions
			 * followed by perform and then, if none set, the KeyMap callback
			 */ commands.push({
                id: `command-shortcut-${key}`,
                shortcut: key,
                ...command,
                primaryAction: shortcutPrimaryAction
            });
        });
        return commands;
    }, [
        keyMap
    ]);
    /**
	 * As mappedCommands is an object, it changes at every render.
	 * To memoise the commands properly in the command palette
	 * the ids are stringified and add as a dependency of the effect
	 */ const shortcutIds = (0, $5uXOq.useMemo)(()=>mappedCommands.map(({ id: id })=>id).toString(), [
        mappedCommands
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), props), !!mappedCommands.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $556k7.RegisterCommands), {
        registrationId: (0, $1Kt4o.COMMAND_PALETTE_REGISTRY_IDS).SHORTCUTS,
        commands: mappedCommands,
        deps: [
            shortcutIds
        ]
    }));
};

});
parcelRegister("1Kt4o", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $3add01bee0e3b846$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $3add01bee0e3b846$export$96f61eb1261e42c3);
// Documentation for contributing to command palette: go/compal
const $3add01bee0e3b846$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $3add01bee0e3b846$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $3add01bee0e3b846$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.COPY_URL,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.DESCRIPTION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.LOG_WORK,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.PARENT,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_ADD,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_SEARCH,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.SHORTCUTS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.STATUS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.STORY_POINTS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.THEME_MODE,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    }
};

});

parcelRegister("556k7", function(module, exports) {

$parcel$export(module.exports, "RegisterCommands", () => $ba0d6dd9c2ef02f6$export$cd555833c78729f1);

var $5uXOq = parcelRequire("5uXOq");

var $buHQa = parcelRequire("buHQa");
const $ba0d6dd9c2ef02f6$export$cd555833c78729f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $buHQa.RegisterCommandsWithRegistry), props);

});
parcelRegister("buHQa", function(module, exports) {

$parcel$export(module.exports, "RegisterCommandsWithRegistry", () => $3f4c8625aa6e8942$export$b8955a01360d2876);

var $6QoIp = parcelRequire("6QoIp");
function $3f4c8625aa6e8942$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
    (0, $6QoIp.useRegisterCommandsWithRegistry)(registrationId, commands, deps);
    return null;
}

});
parcelRegister("6QoIp", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommandsWithRegistry", () => $9d04f6fb396fa7c9$export$8a824ae164ff968d);

var $5uXOq = parcelRequire("5uXOq");

var $fIZf0 = parcelRequire("fIZf0");
function $9d04f6fb396fa7c9$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
    const subscribe = (0, $fIZf0.useSubscribeCommandsWithRegistry)();
    const commandCache = (0, $5uXOq.useRef)(commands);
    (0, $5uXOq.useEffect)(()=>{
        commandCache.current = commands;
    }, [
        commands
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>subscribe(registrationId, commandCache.current), [
        ...dependencies,
        subscribe
    ]);
}

});
parcelRegister("fIZf0", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $72118e9f2599bc72$export$880fc01e31710b27);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");
function $72118e9f2599bc72$export$880fc01e31710b27() {
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $d8lE2.useActionsCommandPalette)();
    const subscribe = (0, $5uXOq.useCallback)((registrationId, commands)=>{
        updateActiveRegistry(registrationId, commands);
        addCommands(commands);
        return ()=>{
            removeCommands(commands);
            removeFromActiveRegistry(registrationId, commands);
        };
    }, [
        addCommands,
        removeCommands,
        removeFromActiveRegistry,
        updateActiveRegistry
    ]);
    return subscribe;
}

});
parcelRegister("d8lE2", function(module, exports) {

$parcel$export(module.exports, "useCommandPalette", () => $f75514d959bfcca8$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $f75514d959bfcca8$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $f75514d959bfcca8$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $f75514d959bfcca8$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteHasChildPopup", () => $f75514d959bfcca8$export$a18633b655403b12);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $f75514d959bfcca8$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $f75514d959bfcca8$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $f75514d959bfcca8$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $f75514d959bfcca8$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $f75514d959bfcca8$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $f75514d959bfcca8$export$bbc05723eb144e03);

var $5uXOq = parcelRequire("5uXOq");

var $7JoAD = parcelRequire("7JoAD");

var $gM5ou = parcelRequire("gM5ou");

var $2sRNe = parcelRequire("2sRNe");
const $f75514d959bfcca8$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $f75514d959bfcca8$var$store = (0, $7JoAD.createStore)({
    initialState: $f75514d959bfcca8$var$initialState,
    actions: $2sRNe.actions,
    name: 'commandPalette'
});
const $f75514d959bfcca8$export$6b58f9610017fbb7 = (0, $7JoAD.createHook)($f75514d959bfcca8$var$store);
const $f75514d959bfcca8$export$72aa7bc7c6a83c36 = (0, $7JoAD.createActionsHook)($f75514d959bfcca8$var$store);
const $f75514d959bfcca8$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $f75514d959bfcca8$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $f75514d959bfcca8$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $gM5ou.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $gM5ou.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $gM5ou.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        relevancyModel: 'v2-string-similarity'
    });
const $f75514d959bfcca8$export$1f90c8f89f98110e = (0, $7JoAD.createHook)($f75514d959bfcca8$var$store, {
    selector: $f75514d959bfcca8$export$56f06313122d0aac
});
const $f75514d959bfcca8$export$cc979be9b69236df = (0, $7JoAD.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $f75514d959bfcca8$export$a18633b655403b12 = (0, $7JoAD.createStateHook)($f75514d959bfcca8$var$store, {
    selector: (state)=>state.hasPopupOverlay
});
const $f75514d959bfcca8$export$af8fd8cd4b048315 = (0, $7JoAD.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $f75514d959bfcca8$export$4372697329bd9cbe = (0, $7JoAD.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $f75514d959bfcca8$export$7422170a403e909 = (0, $7JoAD.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $f75514d959bfcca8$export$282aa48e4a3afada = (0, $7JoAD.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $f75514d959bfcca8$export$96819dfb22ad05d3 = (0, $7JoAD.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $f75514d959bfcca8$export$a40e8ae3e53feab0 = (0, $7JoAD.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $gM5ou.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $f75514d959bfcca8$export$f893891deedab3c6 = (0, $7JoAD.createHook)($f75514d959bfcca8$var$store, {
    selector: $f75514d959bfcca8$export$a40e8ae3e53feab0
});
const $f75514d959bfcca8$export$bbc05723eb144e03 = (0, $7JoAD.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("gM5ou", function(module, exports) {

$parcel$export(module.exports, "getRegistryData", () => $cf289af0c139712c$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $cf289af0c139712c$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $cf289af0c139712c$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $cf289af0c139712c$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $cf289af0c139712c$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $cf289af0c139712c$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $cf289af0c139712c$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $cf289af0c139712c$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $cf289af0c139712c$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $cf289af0c139712c$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $cf289af0c139712c$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $cf289af0c139712c$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $cf289af0c139712c$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $cf289af0c139712c$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $cf289af0c139712c$export$c3d20e8c1e93a572);

var $5uXOq = parcelRequire("5uXOq");

var $bdDiz = parcelRequire("bdDiz");

var $2f2jJ = parcelRequire("2f2jJ");

var $bcTvL = parcelRequire("bcTvL");

var $jh7L9 = parcelRequire("jh7L9");
const $cf289af0c139712c$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $cf289af0c139712c$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $cf289af0c139712c$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $cf289af0c139712c$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $cf289af0c139712c$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $cf289af0c139712c$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $cf289af0c139712c$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $cf289af0c139712c$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $cf289af0c139712c$export$389b0273703d5c48(sections)
    };
};
const $cf289af0c139712c$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $cf289af0c139712c$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...$cf289af0c139712c$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
        ...$cf289af0c139712c$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$cf289af0c139712c$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $cf289af0c139712c$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $cf289af0c139712c$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $cf289af0c139712c$export$daa5beabdf8d9fc3 = (event)=>(0, $2f2jJ.isMacOs)() ? event.metaKey : event.ctrlKey;
const $cf289af0c139712c$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $cf289af0c139712c$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $cf289af0c139712c$export$fa1c95a5ffa92036 = (str)=>(0, $bdDiz.createHash)().update(str).digest('hex');
const $cf289af0c139712c$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $cf289af0c139712c$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $cf289af0c139712c$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $cf289af0c139712c$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("2f2jJ", function(module, exports) {

$parcel$export(module.exports, "isMacOs", () => $6846128323867ebd$export$c5e71f489eb3970b);
$parcel$export(module.exports, "getShortcutModifierKey", () => $6846128323867ebd$export$fe66dae91c68619b);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $6846128323867ebd$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
const $6846128323867ebd$export$fe66dae91c68619b = ()=>$6846128323867ebd$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';

});

parcelRegister("bcTvL", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $3996a4302dca83b1$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $3996a4302dca83b1$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $3996a4302dca83b1$export$1ee9d153576afd13);
$parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", () => $3996a4302dca83b1$export$894e19fc96687503);
// EVENT TYPES
const $3996a4302dca83b1$export$a1562d08625f5d7e = 'UI';
const $3996a4302dca83b1$export$947dac6c72b26f81 = 'TRACK';
const $3996a4302dca83b1$export$f1d537d508d2945a = 'SCREEN';
const $3996a4302dca83b1$export$12346a674644c156 = 'OPERATIONAL';
var $3996a4302dca83b1$export$1ee9d153576afd13;
(function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
})($3996a4302dca83b1$export$1ee9d153576afd13 || ($3996a4302dca83b1$export$1ee9d153576afd13 = {}));
const $3996a4302dca83b1$export$894e19fc96687503 = 250;

});

parcelRegister("jh7L9", function(module, exports) {

$parcel$export(module.exports, "CommandActionType", () => $b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3);
var $b1e48ebd4c8d5e4e$export$f041b1b117ab382f;
(function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
})($b1e48ebd4c8d5e4e$export$f041b1b117ab382f || ($b1e48ebd4c8d5e4e$export$f041b1b117ab382f = {}));
const $b1e48ebd4c8d5e4e$export$3e448fd53031e13c = Object.values($b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
const $b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3 = [
    "command-list"
];

});


parcelRegister("2sRNe", function(module, exports) {

$parcel$export(module.exports, "actions", () => $4f4c9e92d50d4f24$export$e324594224ef24da);

var $kGsr8 = parcelRequire("kGsr8");

var $7Jxgt = parcelRequire("7Jxgt");

var $e7WVN = parcelRequire("e7WVN");

var $eTXmK = parcelRequire("eTXmK");

var $2f2jJ = parcelRequire("2f2jJ");

var $jcw0u = parcelRequire("jcw0u");

var $bcTvL = parcelRequire("bcTvL");

var $jh7L9 = parcelRequire("jh7L9");

var $gM5ou = parcelRequire("gM5ou");

var $4DwnT = parcelRequire("4DwnT");

var $h3eZO = parcelRequire("h3eZO");
const $4f4c9e92d50d4f24$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $4f4c9e92d50d4f24$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        setState({
            commandPaletteSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $4f4c9e92d50d4f24$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$4f4c9e92d50d4f24$var$rootCommands
        });
    };
const $4f4c9e92d50d4f24$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4() : '',
            ...!isOpen ? $4f4c9e92d50d4f24$var$rootCommands : {}
        });
    };
const $4f4c9e92d50d4f24$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $4f4c9e92d50d4f24$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $4f4c9e92d50d4f24$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $4f4c9e92d50d4f24$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $4f4c9e92d50d4f24$var$forceSearchValue = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            shouldForceSearchValue: true
        });
    };
const $4f4c9e92d50d4f24$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
        setState({
            shouldForceSearchValue: false
        });
    };
const $4f4c9e92d50d4f24$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $bcTvL.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $4f4c9e92d50d4f24$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $4f4c9e92d50d4f24$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $4f4c9e92d50d4f24$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $gM5ou.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $4f4c9e92d50d4f24$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $eTXmK.default)('command-palette-executed');
                    onClosePendingCommandAction.perform();
                    if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                        const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        onAnalytics(performAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                            attributes: onClosePendingCommandAction?.analyticsArgs
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $jcw0u.default)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $e7WVN.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $4f4c9e92d50d4f24$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $4DwnT.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $gM5ou.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        const currentCommandAction = (0, $gM5ou.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $gM5ou.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $jh7L9.CommandActionType).PERFORM;
        if (shouldLoadChildren) {
            (0, $eTXmK.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $h3eZO.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if (currentCommandAction.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $bcTvL.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            }
            if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $2f2jJ.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $eTXmK.default)('command-palette-executed');
                currentCommandAction.perform();
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const performAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'taskSucceeded',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(performAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $e7WVN.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analyticsAttributes,
                    createAnalyticsEvent: analytics?.createAnalyticsEvent
                }
            });
        }
    };
const $4f4c9e92d50d4f24$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $4f4c9e92d50d4f24$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $4f4c9e92d50d4f24$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $4f4c9e92d50d4f24$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $4f4c9e92d50d4f24$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $4f4c9e92d50d4f24$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $4f4c9e92d50d4f24$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $4f4c9e92d50d4f24$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $4f4c9e92d50d4f24$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $4f4c9e92d50d4f24$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $4f4c9e92d50d4f24$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $4f4c9e92d50d4f24$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $4f4c9e92d50d4f24$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
        setState({
            hasPopupOverlay: hasPopupOverlay
        });
    };
const $4f4c9e92d50d4f24$export$e324594224ef24da = {
    open: $4f4c9e92d50d4f24$var$open,
    toggle: $4f4c9e92d50d4f24$var$toggle,
    close: $4f4c9e92d50d4f24$var$close,
    addCommands: $4f4c9e92d50d4f24$var$addCommands,
    removeCommands: $4f4c9e92d50d4f24$var$removeCommands,
    handleSearch: $4f4c9e92d50d4f24$var$handleSearch,
    forceFocusSearch: $4f4c9e92d50d4f24$var$forceFocusSearch,
    setActiveIndex: $4f4c9e92d50d4f24$var$setActiveIndex,
    executeCommand: $4f4c9e92d50d4f24$var$executeCommand,
    goBackLevel: $4f4c9e92d50d4f24$var$goBackLevel,
    setChildCommands: $4f4c9e92d50d4f24$var$setChildCommands,
    setLoadingList: $4f4c9e92d50d4f24$var$setLoadingList,
    setFocusInput: $4f4c9e92d50d4f24$var$setFocusInput,
    registerSections: $4f4c9e92d50d4f24$var$registerSections,
    unregisterSections: $4f4c9e92d50d4f24$var$unregisterSections,
    markAsLoaded: $4f4c9e92d50d4f24$var$markAsLoaded,
    getAnalyticsAttributes: $4f4c9e92d50d4f24$var$getAnalyticsAttributes,
    setIsDisabled: $4f4c9e92d50d4f24$var$setIsDisabled,
    setRegistry: $4f4c9e92d50d4f24$var$setRegistry,
    updateActiveRegistry: $4f4c9e92d50d4f24$var$updateActiveRegistry,
    removeCommandsById: $4f4c9e92d50d4f24$var$removeCommandsById,
    removeFromActiveRegistry: $4f4c9e92d50d4f24$var$removeFromActiveRegistry,
    performDialogCloseCommand: $4f4c9e92d50d4f24$var$performDialogCloseCommand,
    setAnalytics: $4f4c9e92d50d4f24$var$setAnalytics,
    setFallbackOverride: $4f4c9e92d50d4f24$var$setFallbackOverride,
    setHasPopupOverlay: $4f4c9e92d50d4f24$var$setHasPopupOverlay,
    forceSearchValue: $4f4c9e92d50d4f24$var$forceSearchValue,
    resetShouldForceSearchValue: $4f4c9e92d50d4f24$var$resetShouldForceSearchValue
};

});
parcelRegister("4DwnT", function(module, exports) {

$parcel$export(module.exports, "getActiveCommandList", () => $b4088022dc3f5c54$export$639b7f41b0b47a01);

var $jh7L9 = parcelRequire("jh7L9");
const $b4088022dc3f5c54$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("h3eZO", function(module, exports) {

$parcel$export(module.exports, "isSearchableChildrenAction", () => $dd5db8363c7eeda7$export$d75616d77443fe4e);

var $jh7L9 = parcelRequire("jh7L9");
const $dd5db8363c7eeda7$export$d75616d77443fe4e = (action)=>action?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});








parcelRegister("6CjZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0aef8f88c53fc825$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $16T6Y = parcelRequire("16T6Y");

var $fVnbM = parcelRequire("fVnbM");

var $6Ingq = parcelRequire("6Ingq");

var $1I7E8 = parcelRequire("1I7E8");

var $3bDjY = parcelRequire("3bDjY");

var $gSExi = parcelRequire("gSExi");

var $6s1PB = parcelRequire("6s1PB");

var $co1wz = parcelRequire("co1wz");

var $koVbs = parcelRequire("koVbs");

var $2m0b6 = parcelRequire("2m0b6");

var $dCm1o = parcelRequire("dCm1o");

var $7Hgp8 = parcelRequire("7Hgp8");

var $AOaWd = parcelRequire("AOaWd");

var $5yCxu = parcelRequire("5yCxu");
const $0aef8f88c53fc825$var$OverflowHandler = ({ itemsBefore: itemsBefore, itemsAfter: itemsAfter, selectedItems: selectedItems = {} })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const overflowContainerRef = (0, $5uXOq.useRef)(null);
    const moreFilterRef = (0, $5uXOq.useRef)(null);
    const elementsRef = (0, $5uXOq.useRef)({});
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    // There is a flickering bug switching to/from the "more" button https://jplat.atlassian.net/browse/BLU-3488
    // Additional information can also be found in https://jbusiness.atlassian.net/browse/JVRQ-426
    // But can't reproduce in Storybook + lot of pending changes, so won't fix for now.
    // I suspect this is related to this out-of-rerender memorization of data.
    // Next person actively working on this file is welcome to check. See also investigation notes in the ticket above.
    const prevOverflowContainerWidthRef = (0, $5uXOq.useRef)(0);
    const elementsWidthRef = (0, $5uXOq.useRef)({});
    const visibleElementsRef = (0, $5uXOq.useRef)({});
    const prevElementsWidthRef = (0, $5uXOq.useRef)({});
    const [{ overflowableHideState: overflowableHideState, isMoreDropdownHidden: isMoreDropdownHidden }, setOverflowState] = (0, $5uXOq.useState)({
        overflowableHideState: {},
        isMoreDropdownHidden: true
    });
    const { renderedOverflowableItems: renderedOverflowableItems, staticItems: staticItems, renderedItemsBefore: renderedItemsBefore, renderedItemsAfter: renderedItemsAfter } = (0, $5uXOq.useMemo)(()=>{
        const theOverflowable = [];
        const theStatic = [];
        const theRenderedBefore = [];
        const theRenderedAfter = [];
        const categoriseItems = ({ isRenderedBefore: isRenderedBefore })=>{
            (isRenderedBefore ? itemsBefore : itemsAfter).forEach((item)=>{
                const { isStatic: isStatic, isHidden: isHidden = false } = item;
                // Exclude hidden overflowable items from rendering
                if (!isStatic && isHidden) return;
                (isStatic ? theStatic : theOverflowable).push(item);
                (isRenderedBefore ? theRenderedBefore : theRenderedAfter).push(item);
            });
        };
        categoriseItems({
            isRenderedBefore: true
        });
        categoriseItems({
            isRenderedBefore: false
        });
        return {
            renderedOverflowableItems: theOverflowable,
            staticItems: theStatic,
            renderedItemsBefore: theRenderedBefore,
            renderedItemsAfter: theRenderedAfter
        };
    }, [
        itemsBefore,
        itemsAfter
    ]);
    /**
   * Calculate the count for "More" dropdown.
   * It excludes the selected items of the visible items.
   */ const selectedOverflowItemsCount = (0, $5uXOq.useMemo)(()=>(0, $5yCxu.getSelectedItemsCount)(overflowableHideState, selectedItems), [
        overflowableHideState,
        selectedItems
    ]);
    const onResize = (0, $5uXOq.useCallback)(()=>{
        const { current: overflowContainer } = overflowContainerRef;
        const { current: moreFilter } = moreFilterRef;
        const shouldRecomputeOverflow = (0, $5yCxu.getShouldRecomputeOverflow)(prevOverflowContainerWidthRef.current, overflowContainer?.offsetWidth ?? 0, prevElementsWidthRef.current, elementsWidthRef.current);
        if (!overflowContainer || !moreFilter || !renderedOverflowableItems.length || !shouldRecomputeOverflow) return;
        // Store the widths for comparison
        prevOverflowContainerWidthRef.current = overflowContainer.offsetWidth;
        prevElementsWidthRef.current = {
            ...elementsWidthRef.current
        };
        setOverflowState((0, $5yCxu.calcOverflow)(overflowContainer, moreFilter, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        renderedOverflowableItems, staticItems, elementsRef.current));
    }, [
        renderedOverflowableItems,
        staticItems
    ]);
    if ((0, $6s1PB.expVal)('blu-3488_fix_jsw_filters_flickering', 'isEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2m0b6.useResizeObserver)({
        ref: overflowContainerRef,
        onResize: onResize
    });
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $AOaWd.useResizeObserver)(overflowContainerRef, onResize);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(!isOpen);
    }, [
        isOpen,
        setIsOpen
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const triggerLabel = formatMessage((0, $7Hgp8.default).more);
    const triggerTooltipText = formatMessage((0, $7Hgp8.default).moreFiltersTooltip);
    const buttonToolTip = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: triggerTooltipText,
            hideTooltipOnClick: true,
            tag: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$TriggerContainer, {
            "data-testid": "filters.common.ui.overflow-handler.trigger-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$TriggerLabel, null, triggerLabel), selectedOverflowItemsCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$BadgeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
            appearance: "primary"
        }, selectedOverflowItemsCount)))), [
        selectedOverflowItemsCount,
        triggerTooltipText,
        triggerLabel
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$PopupContainer, null, renderedOverflowableItems.map(({ id: id, renderer: renderer })=>Boolean(overflowableHideState[id]) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: id
            }, renderer(true)))), [
        renderedOverflowableItems,
        overflowableHideState
    ]);
    const renderItems = (items)=>items.map(({ id: id, isStatic: isStatic, isHidden: isHidden = false, renderer: renderer })=>{
            const isItemHidden = isStatic ? isHidden : Boolean(overflowableHideState[id]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$ItemWrapper, {
                key: id,
                innerRef: (element)=>{
                    elementsRef.current[id] = element;
                    if (element) {
                        elementsWidthRef.current[id] = element.offsetWidth;
                        if (!isHidden) visibleElementsRef.current[id] = {
                            width: element.offsetWidth,
                            height: element.offsetHeight
                        };
                    }
                },
                "aria-hidden": isItemHidden,
                isHidden: isItemHidden
            }, renderer(false));
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: overflowContainerRef,
        className: (0, $bwpsq.default)([
            (0, $dCm1o.isVisualRefreshEnabled)() ? "_1e0c1txw _1ul9idpf _18s83l1n" : "_1e0c1txw _1ul9idpf"
        ])
    }, renderItems(renderedItemsBefore), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$ItemWrapper, {
        innerRef: moreFilterRef,
        "aria-hidden": isMoreDropdownHidden,
        isHidden: isMoreDropdownHidden
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.Popup), {
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...triggerProps,
                appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
                isSelected: isOpen,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))), {
                    primaryColor: "var(--ds-icon, #44546F)",
                    label: triggerLabel
                }),
                onClick: onClick
            }, buttonToolTip),
        shouldRenderToParent: true,
        shouldFlip: true,
        isOpen: isOpen,
        placement: "bottom-start",
        content: content,
        onClose: onClose
    })), renderItems(renderedItemsAfter));
};
var $0aef8f88c53fc825$export$2e2bcd8739ae039 = $0aef8f88c53fc825$var$OverflowHandler;
const $0aef8f88c53fc825$var$overflowContainerStylesOld = null;
const $0aef8f88c53fc825$var$overflowContainerStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aef8f88c53fc825$var$PopupContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4swc3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aef8f88c53fc825$var$TriggerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aef8f88c53fc825$var$TriggerLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aef8f88c53fc825$var$BadgeContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _19bv1b66",
            __cmplp.className
        ])
    });
});
const $0aef8f88c53fc825$var$ItemWrapperControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1krxkwp-0"
})((props)=>({
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        order: props.isHidden ? 2 : 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        visibility: props.isHidden ? 'hidden' : 'visible',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        pointerEvents: props.isHidden ? 'none' : 'auto'
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aef8f88c53fc825$var$ItemWrapperExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1o9zidpf",
            __cmplp.isHidden ? "_1f49cs5v" : "_1f49kb7n",
            __cmplp.isHidden ? "_3um015vq" : "_3um0ewfl",
            __cmplp.isHidden ? "_lcxvglyw" : "_lcxv1wug",
            __cmplp.className
        ])
    });
});
const $0aef8f88c53fc825$var$ItemWrapper = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $0aef8f88c53fc825$var$ItemWrapperExperiment, $0aef8f88c53fc825$var$ItemWrapperControl);

});
parcelRegister("7Hgp8", function(module, exports) {

$parcel$export(module.exports, "default", () => $cea3021c9215d69b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cea3021c9215d69b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    more: {
        "id": "software-filters.common.overflow-handler.more",
        "defaultMessage": "More"
    },
    moreFiltersTooltip: {
        "id": "software-filters.common.overflow-handler.more-filters-tooltip",
        "defaultMessage": "More filters"
    }
});

});

parcelRegister("AOaWd", function(module, exports) {

$parcel$export(module.exports, "useResizeObserver", () => $d7fe9cd69e6a83c0$export$683480f191c0e3ea);

var $5uXOq = parcelRequire("5uXOq");
let $d7fe9cd69e6a83c0$var$resizeObserver;
const $d7fe9cd69e6a83c0$var$callbacks = new Map();
const $d7fe9cd69e6a83c0$var$runCallbacks = (entries)=>{
    entries.forEach((entry)=>{
        const { target: target } = entry;
        const callback = $d7fe9cd69e6a83c0$var$callbacks.get(target);
        callback?.(entry);
    });
};
const $d7fe9cd69e6a83c0$var$observeElement = (target, callback)=>{
    if (typeof ResizeObserver === 'undefined') return;
    if (!$d7fe9cd69e6a83c0$var$resizeObserver) $d7fe9cd69e6a83c0$var$resizeObserver = new ResizeObserver($d7fe9cd69e6a83c0$var$runCallbacks);
    $d7fe9cd69e6a83c0$var$callbacks.set(target, callback);
    $d7fe9cd69e6a83c0$var$resizeObserver.observe(target);
};
const $d7fe9cd69e6a83c0$var$unobserveElement = (target)=>{
    if (!$d7fe9cd69e6a83c0$var$resizeObserver) return;
    $d7fe9cd69e6a83c0$var$callbacks.delete(target);
    $d7fe9cd69e6a83c0$var$resizeObserver.unobserve(target);
};
const $d7fe9cd69e6a83c0$export$683480f191c0e3ea = (ref, callback)=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        const element = ref.current;
        element && $d7fe9cd69e6a83c0$var$observeElement(element, callback);
        return ()=>{
            element && $d7fe9cd69e6a83c0$var$unobserveElement(element);
        };
    }, [
        ref,
        callback
    ]);
};

});

parcelRegister("5yCxu", function(module, exports) {

$parcel$export(module.exports, "calcOverflow", () => $6dfc047016dbaaed$export$7128ab9dfe00f62e);
$parcel$export(module.exports, "getShouldRecomputeOverflow", () => $6dfc047016dbaaed$export$2544af09d06b9c65);
$parcel$export(module.exports, "getSelectedItemsCount", () => $6dfc047016dbaaed$export$b0e31612dc0df344);

var $gccSB = parcelRequire("gccSB");
const $6dfc047016dbaaed$export$1fed873882a661c5 = (items, itemElements, spaceLimit)=>{
    const hideState = {};
    let usedSpace = 0;
    let isOverflowingAssumed = false;
    items.forEach(({ id: id })=>{
        const element = itemElements[id];
        if (element) {
            const { offsetWidth: space } = element;
            if ((spaceLimit === undefined || usedSpace + space < spaceLimit) && !isOverflowingAssumed) usedSpace += space;
            else {
                if (!isOverflowingAssumed) isOverflowingAssumed = true;
                hideState[id] = true;
            }
        }
    });
    return {
        usedSpace: usedSpace,
        hideState: hideState
    };
};
const $6dfc047016dbaaed$export$7128ab9dfe00f62e = ({ offsetWidth: availableSpace }, { offsetWidth: moreFilterSpace }, renderedOverflowableItems, staticItems, itemElements)=>{
    const { usedSpace: staticSpace } = $6dfc047016dbaaed$export$1fed873882a661c5(staticItems, itemElements);
    const maxOverflowableSpace = renderedOverflowableItems.reduce((maxSpace, { id: id })=>maxSpace + (itemElements[id]?.offsetWidth ?? 0), 0);
    const isOverflowing = maxOverflowableSpace + staticSpace > availableSpace;
    let overflowableHideState = {};
    if (isOverflowing) {
        const spaceLimit = Math.max(availableSpace - moreFilterSpace - staticSpace, 0);
        const { hideState: hideState } = $6dfc047016dbaaed$export$1fed873882a661c5(renderedOverflowableItems, itemElements, spaceLimit);
        overflowableHideState = hideState;
    }
    return {
        overflowableHideState: overflowableHideState,
        isMoreDropdownHidden: !isOverflowing
    };
};
const $6dfc047016dbaaed$var$BADGE_WIDTH_THRESHOLD = 25; // Width of count badge
const $6dfc047016dbaaed$export$2544af09d06b9c65 = (prevContainerWidth, currContainerWidth, prevElementsWidthRef, currElementsWidthRef)=>{
    const currItemIds = Object.keys(currElementsWidthRef);
    const prevItemIds = Object.keys(prevElementsWidthRef);
    if (prevItemIds.length !== currItemIds.length || prevContainerWidth !== currContainerWidth) return true;
    const hasItemsWidthChange = currItemIds.some((id)=>prevElementsWidthRef[id] === undefined || Math.abs(prevElementsWidthRef[id] - currElementsWidthRef[id]) > $6dfc047016dbaaed$var$BADGE_WIDTH_THRESHOLD);
    return hasItemsWidthChange;
};
const $6dfc047016dbaaed$export$b0e31612dc0df344 = (itemsHiddenState, selectedItems)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(selectedItems) || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(itemsHiddenState)) return 0;
    return Object.entries(selectedItems).reduce((acc, [key, value])=>{
        if (value === undefined || itemsHiddenState[key] !== true) return acc;
        // selectedItem could be "any" value, if the value is not an Array, it will be counted as 1
        return Array.isArray(value) ? acc + value.length : acc + 1;
    }, 0);
};

});


parcelRegister("1beWO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f4b1966602deeb5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $7rViF = parcelRequire("7rViF");

var $caSh0 = parcelRequire("caSh0");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $12hlA = parcelRequire("12hlA");


var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $9OXo1 = parcelRequire("9OXo1");

var $cpQgt = parcelRequire("cpQgt");

var $j6etC = parcelRequire("j6etC");

var $eJpZk = parcelRequire("eJpZk");

var $lAu6N = parcelRequire("lAu6N");
const $6f4b1966602deeb5$var$StatelessAssigneeFilterWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('StatelessAssigneeFilterWithAnalytics', {
    onAddPeopleClick: 'clicked'
})((0, $lAu6N.default));
$6f4b1966602deeb5$var$StatelessAssigneeFilterWithAnalytics.displayName = 'StatelessAssigneeFilterWithAnalytics';
const $6f4b1966602deeb5$export$3ecb2c48b5973cac = ({ AddPeopleModal: AddPeopleModal, showAddPeopleModal: showAddPeopleModal, onAddPeopleModalClose: onAddPeopleModalClose, cloudId: cloudId, projectName: projectName, projectId: projectId, projectKey: projectKey, appEdition: appEdition, isSiteAdmin: isSiteAdmin, modalRef: modalRef })=>{
    if ((0, $caSh0.isCoreInvitesInJiraProjectsEnabled)(isSiteAdmin)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $12hlA.default), {
        inviteRef: modalRef,
        appEdition: appEdition,
        cloudId: cloudId,
        isOpen: (0, $4R6GH.fg)('jsw-perf-async-add-people-modal-load') ? true : showAddPeopleModal,
        onClose: onAddPeopleModalClose,
        jiraProjectName: projectName,
        projectId: projectId,
        jiraProjectKey: projectKey,
        isSiteAdmin: isSiteAdmin
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AddPeopleModal, {
        onClose: onAddPeopleModalClose,
        isOpen: (0, $4R6GH.fg)('jsw-perf-async-add-people-modal-load') ? true : showAddPeopleModal
    });
};
const $6f4b1966602deeb5$export$804bfdea59f89629 = (createAnalyticsEvent, baseUrl, setShowUpSell, showUpSell, setShowAddPeopleModal, showAddPeopleModal, jswEdition, analyticsEvent, isSiteAdmin, screenName, fireTriggerClickEvent)=>{
    const openAddPeopleModal = ()=>{
        (0, $7rViF.fireCoreInvitesInJiraProjectFeatureExposed)(createAnalyticsEvent, isSiteAdmin);
        setShowAddPeopleModal(!showAddPeopleModal);
    };
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
    if (jswEdition === (0, $ldyPw.toEdition)((0, $ldyPw.FREE_EDITION))) (0, $j6etC.getRemainingSeats)(baseUrl, (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)).then((remainingSeats)=>{
        if (remainingSeats === 0) {
            // When the JSW Free instance is at the user limit and
            // the user is enrolled in the auto-upgrade experiment, fire an exposure event
            if (expConfig.get('cohort', 'not-enrolled') !== 'not-enrolled') {
                const [, fireExposureEvent] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
                fireExposureEvent();
            }
            fireTriggerClickEvent();
            // If the user is in the auto-upgrade experiment variation cohort, show the invite modal.
            // Otherwise, show the upsell dialog.
            if (expConfig.get('cohort', 'not-enrolled') === 'variation') openAddPeopleModal();
            else {
                setShowUpSell(!showUpSell);
                if (!showUpSell) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, `${screenName}AssigneeFilterAddPeople`);
            }
        } else {
            fireTriggerClickEvent();
            openAddPeopleModal();
        }
    }).catch((e)=>{
        fireTriggerClickEvent();
        openAddPeopleModal();
        throw e;
    });
    else {
        fireTriggerClickEvent();
        // If not on JSW Free, always show the invite modal
        openAddPeopleModal();
    }
};
const $6f4b1966602deeb5$var$ConditionalUpsellDialogWrapper = (props)=>{
    const { children: children, showUpsellDialog: showUpsellDialog, setShowUpsellDialog: setShowUpsellDialog, screenName: screenName } = props;
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
    if (expConfig.get('cohort', 'not-enrolled') === 'variation') // When the user is in the experiment variation cohort, we won't be showing the upsell dialog.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    const onUpgradeDialogClose = ()=>{
        setShowUpsellDialog(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cpQgt.default), {
        isOpen: showUpsellDialog,
        onClose: onUpgradeDialogClose,
        touchpointId: `${screenName || ''}${screenName ? 'A' : 'a'}ssigneeFilterAddPeople`,
        onUpFlowDismiss: onUpgradeDialogClose
    }, children);
};
const $6f4b1966602deeb5$export$20e0939737a940df = (props)=>{
    const { users: users, maxUsers: maxUsers, AddPeopleModal: AddPeopleModal, screenName: screenName, selectedUsers: selectedUsers, onToggle: onToggle, projectId: projectId, isAddPeopleButtonEnabled: isAddPeopleButtonEnabled, projectName: projectName, projectKey: projectKey } = props;
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const [showAddPeopleModal, setShowAddPeopleModal] = (0, $5uXOq.useState)(false);
    const [showUpSell, setShowUpSell] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const appEdition = (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), tenantContext.appEditions);
    const onAddPeopleClick = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        const fireAddPeopleClickEvent = ()=>{
            // If neither the upsell dialog nor the invite modal is currently open,
            // then the user is trying to open one of them. When this happens,
            // we fire an analytics event.
            if (!showAddPeopleModal && !showUpSell) {
                const event = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    source: screenName
                });
                (0, $8zOmE.fireUIAnalytics)(event, 'assigneeFilterAddPeople');
            }
        };
        $6f4b1966602deeb5$export$804bfdea59f89629(createAnalyticsEvent, tenantContext.baseUrl, setShowUpSell, showUpSell, setShowAddPeopleModal, showAddPeopleModal, appEdition, analyticsEvent, tenantContext.isSiteAdmin, screenName || '', fireAddPeopleClickEvent);
    }, [
        createAnalyticsEvent,
        tenantContext.baseUrl,
        tenantContext.isSiteAdmin,
        showUpSell,
        showAddPeopleModal,
        appEdition,
        screenName
    ]);
    const onAddPeopleModalClose = (0, $5uXOq.useCallback)(()=>{
        setShowAddPeopleModal(false);
    }, []);
    const showAddPeopleButton = AddPeopleModal !== undefined && isAddPeopleButtonEnabled;
    const addButtonRef = (0, $5uXOq.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f4b1966602deeb5$var$ConditionalUpsellDialogWrapper, {
        showUpsellDialog: showUpSell,
        setShowUpsellDialog: setShowUpSell,
        screenName: screenName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f4b1966602deeb5$var$StatelessAssigneeFilterWithAnalytics, {
        peopleRef: addButtonRef,
        users: users,
        maxUsers: maxUsers,
        selectedUsers: selectedUsers,
        onToggle: onToggle,
        onAddPeopleClick: onAddPeopleClick,
        showAddPeopleButton: showAddPeopleButton,
        screenName: screenName || '',
        projectId: projectId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eJpZk.Analytics), {
        baseUrl: tenantContext.baseUrl,
        projectId: projectId,
        screenName: screenName || '',
        showAddPeopleButton: showAddPeopleButton
    }), AddPeopleModal && ((0, $4R6GH.fg)('jsw-perf-async-add-people-modal-load') ? true : showAddPeopleButton) && ((0, $4R6GH.fg)('jsw-perf-async-add-people-modal-load') ? showAddPeopleModal : true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f4b1966602deeb5$export$3ecb2c48b5973cac, {
        modalRef: addButtonRef,
        projectName: projectName,
        projectKey: projectKey,
        projectId: projectId,
        AddPeopleModal: AddPeopleModal,
        showAddPeopleModal: (0, $4R6GH.fg)('jsw-perf-async-add-people-modal-load') ? true : showAddPeopleModal,
        onAddPeopleModalClose: onAddPeopleModalClose,
        cloudId: tenantContext.cloudId,
        appEdition: appEdition,
        isSiteAdmin: tenantContext.isSiteAdmin
    }));
};
$6f4b1966602deeb5$export$20e0939737a940df.defaultProps = {
    users: [],
    selectedUsers: [],
    maxUsers: 5,
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onAssigneeMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    AddPeopleModal: undefined,
    isAddPeopleButtonEnabled: false,
    projectId: -1
};
const $6f4b1966602deeb5$var$AssigneeFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($6f4b1966602deeb5$export$20e0939737a940df);
$6f4b1966602deeb5$var$AssigneeFilterComponent.displayName = 'AssigneeFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<{ isAddPeopleButtonEnabled: boolean; readonly projectId: number; } & CommonAssigneeFilterProps & { AddPeopleModal: ComponentType<{ onClose: () => void; isOpen: boolean; }> | undefined; }>'.
$6f4b1966602deeb5$var$AssigneeFilterComponent.whyDidYouRender = true;
var $6f4b1966602deeb5$export$2e2bcd8739ae039 = $6f4b1966602deeb5$var$AssigneeFilterComponent;

});
parcelRegister("7rViF", function(module, exports) {

$parcel$export(module.exports, "fireCoreInvitesInJiraProjectFeatureExposed", () => $19157e19516eca78$export$2f2d4a4234531655);
$parcel$export(module.exports, "fireCoreInvitesInJsmProjectFeatureExposed", () => $19157e19516eca78$export$4ae66d6e56a5cb11);

var $co1wz = parcelRequire("co1wz");

var $8zOmE = parcelRequire("8zOmE");

var $caSh0 = parcelRequire("caSh0");
const $19157e19516eca78$var$getCoreInvitesInJiraProjects = ()=>(0, $co1wz.getMultivariateFeatureFlag)('core-invites-in-jira-projects', (0, $caSh0.CORE_INVITES_IN_JIRA_PROJECTS).NOT_ENROLLED, [
        (0, $caSh0.CORE_INVITES_IN_JIRA_PROJECTS).NOT_ENROLLED,
        (0, $caSh0.CORE_INVITES_IN_JIRA_PROJECTS).CONTROL,
        (0, $caSh0.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_ONLY,
        (0, $caSh0.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_ONLY_NOT_ENROLLED,
        (0, $caSh0.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_RA,
        (0, $caSh0.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_RA_NOT_ENROLLED
    ]);
const $19157e19516eca78$export$2f2d4a4234531655 = (createAnalyticsEvent, isSiteAdmin)=>{
    const featureFlagValue = $19157e19516eca78$var$getCoreInvitesInJiraProjects();
    const cohort = featureFlagValue;
    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
        flagKey: 'core-invites-in-jira-projects',
        value: featureFlagValue,
        cohort: cohort,
        isSiteAdmin: isSiteAdmin,
        ineligibilityReasons: [],
        growthInitiative: 'virality'
    });
};
const $19157e19516eca78$export$4ae66d6e56a5cb11 = (createAnalyticsEvent, coreInvitesJsmExpValue)=>{
    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
        flagKey: 'jsm_core_invites_experiment',
        cohort: coreInvitesJsmExpValue
    });
};

});
parcelRegister("caSh0", function(module, exports) {

$parcel$export(module.exports, "CORE_INVITES_IN_JIRA_PROJECTS", () => $c0c54262b44db685$export$3496ae3c3008d7e5);
$parcel$export(module.exports, "isCoreInvitesInJiraProjectsEnabled", () => $c0c54262b44db685$export$78d85fc0e603743c);
$parcel$export(module.exports, "isElligibleProject", () => $c0c54262b44db685$export$b0222359e25e154);
$parcel$export(module.exports, "isServiceProject", () => $c0c54262b44db685$export$f52f6e19ac3c110);

var $2vSU6 = parcelRequire("2vSU6");

var $co1wz = parcelRequire("co1wz");
const $c0c54262b44db685$export$3496ae3c3008d7e5 = {
    CONTROL: 'control',
    NOT_ENROLLED: 'not-enrolled',
    INVITE_ONLY: 'invite-only-variation',
    INVITE_ONLY_NOT_ENROLLED: 'invite-only-not-enrolled',
    INVITE_RA: 'invite-ra-variation',
    INVITE_RA_NOT_ENROLLED: 'invite-ra-variation'
};
const $c0c54262b44db685$var$getCoreInvitesInJiraProjects = ()=>(0, $co1wz.getMultivariateFeatureFlag)('core-invites-in-jira-projects', $c0c54262b44db685$export$3496ae3c3008d7e5.NOT_ENROLLED, [
        $c0c54262b44db685$export$3496ae3c3008d7e5.NOT_ENROLLED,
        $c0c54262b44db685$export$3496ae3c3008d7e5.CONTROL,
        $c0c54262b44db685$export$3496ae3c3008d7e5.INVITE_ONLY,
        $c0c54262b44db685$export$3496ae3c3008d7e5.INVITE_ONLY_NOT_ENROLLED,
        $c0c54262b44db685$export$3496ae3c3008d7e5.INVITE_RA,
        $c0c54262b44db685$export$3496ae3c3008d7e5.INVITE_RA_NOT_ENROLLED
    ]);
const $c0c54262b44db685$export$78d85fc0e603743c = (isSiteAdmin)=>{
    const flag = $c0c54262b44db685$var$getCoreInvitesInJiraProjects();
    return isSiteAdmin && flag === $c0c54262b44db685$export$3496ae3c3008d7e5.INVITE_ONLY || flag === $c0c54262b44db685$export$3496ae3c3008d7e5.INVITE_RA;
};
const $c0c54262b44db685$export$b0222359e25e154 = (projectType)=>projectType === (0, $2vSU6.CORE_PROJECT) || projectType === (0, $2vSU6.SOFTWARE_PROJECT);
const $c0c54262b44db685$export$f52f6e19ac3c110 = (projectType)=>projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);

});


parcelRegister("12hlA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bc8c7c74346f034$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $0bc8c7c74346f034$var$LazyComponent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("jWZZk")), {
    moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
});
const $0bc8c7c74346f034$export$6a02a79fa2b0ddab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "async-project-invite-people-modal",
        packageName: "jira-project-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "project-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0bc8c7c74346f034$var$LazyComponent, props)));
var $0bc8c7c74346f034$export$2e2bcd8739ae039 = $0bc8c7c74346f034$export$6a02a79fa2b0ddab;

});
parcelRegister("jWZZk", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("6C6tQ")
]).then(()=>parcelRequire('3dNZP'));

});


const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';

parcelRegister("cpQgt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fee2ed613b7661e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9yOBd = parcelRequire("9yOBd");

var $ctg8C = parcelRequire("ctg8C");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $iMd5l = parcelRequire("iMd5l");

var $cVzoY = parcelRequire("cVzoY");

var $34Vv8 = parcelRequire("34Vv8");

var $az4zD = parcelRequire("az4zD");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");


var $ldyPw = parcelRequire("ldyPw");

var $9OXo1 = parcelRequire("9OXo1");

var $2hXCB = parcelRequire("2hXCB");

var $02gpZ = parcelRequire("02gpZ");

var $4J6oz = parcelRequire("4J6oz");


var $de8ma = parcelRequire("de8ma");
const $1fee2ed613b7661e$var$fireCTAButtonAnalytics = (analyticsEvent, actionSubjectId, touchpointId, currentEdition)=>{
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, actionSubjectId, {
        currentEdition: currentEdition,
        touchpointId: touchpointId,
        targetEdition: (0, $4J6oz.applicationEditionToUpFlowEdition)((0, $ldyPw.STANDARD_EDITION)),
        isGrandfathered: false,
        isSiteAdmin: true,
        upFlowVariateFlag: 'experiment'
    });
};
const $1fee2ed613b7661e$var$showTryNowButton = (onClick, label, href, target)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        appearance: "primary",
        onClick: onClick,
        href: href,
        target: target,
        rel: "noopener"
    }, label);
const $1fee2ed613b7661e$var$showLearnMoreButton = (appearance, onClick, label, href, target)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        appearance: appearance,
        onClick: onClick,
        href: href,
        target: target,
        rel: "noopener"
    }, label); // TODO split this file in to proper tangerine app structure, it's getting too big
const $1fee2ed613b7661e$var$UpgradeToAddUsersDialog = (props)=>{
    const { children: children, isOpen: isOpen, onClose: onClose, intl: intl, touchpointId: touchpointId, onUpFlowDismiss: onUpFlowDismiss } = props;
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const explicitlyLicensedProducts = (0, $cVzoY.default)(tenantContext);
    const hasOnlyJSW = explicitlyLicensedProducts.length === 1 && explicitlyLicensedProducts[0] === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d);
    const [upFlowIframeState, setUpFlowIframeState] = (0, $5uXOq.useState)(null);
    const currentEdition = (0, $4J6oz.applicationEditionToUpFlowEdition)((0, $iMd5l.getProductEdition)(explicitlyLicensedProducts[0], tenantContext));
    const upgradeButtonOnClick = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        const actionSubjectId = (0, $2hXCB.mapActionIdFromType)[0, $2hXCB.UPGRADE];
        $1fee2ed613b7661e$var$fireCTAButtonAnalytics(analyticsEvent, actionSubjectId, touchpointId, currentEdition);
        hasOnlyJSW && setUpFlowIframeState((0, $2hXCB.UPGRADE));
    }, [
        currentEdition,
        hasOnlyJSW,
        touchpointId
    ]);
    const learnMoreButtonOnClick = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        const actionSubjectId = (0, $2hXCB.mapActionIdFromType)[0, $2hXCB.LEARN_MORE];
        $1fee2ed613b7661e$var$fireCTAButtonAnalytics(analyticsEvent, actionSubjectId, touchpointId, currentEdition);
        hasOnlyJSW && setUpFlowIframeState((0, $2hXCB.LEARN_MORE));
    }, [
        currentEdition,
        hasOnlyJSW,
        touchpointId
    ]);
    const onUpFlowIframeClose = (0, $5uXOq.useCallback)(()=>{
        setUpFlowIframeState(null);
        onUpFlowDismiss();
    }, [
        onUpFlowDismiss
    ]);
    const learnMoreButtonAppearance = tenantContext.isSiteAdmin ? 'link' : 'primary';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: touchpointId,
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            sourceName: "changeEditionGateway",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
            attributes: {
                isSiteAdmin: tenantContext.isSiteAdmin,
                source: touchpointId
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, intl.formatMessage((0, $de8ma.default).upgradeToAddUsersHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1fee2ed613b7661e$var$MultiLineParagraph, null, intl.formatMessage((0, $de8ma.default).upgradeToAddUsersContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $1fee2ed613b7661e$var$buttonBarStyles
        }, tenantContext.isSiteAdmin ? $1fee2ed613b7661e$var$showTryNowButton(// @ts-expect-error - TS2345 - Argument of type '(_: any, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to parameter of type '() => void'.
        upgradeButtonOnClick, intl.formatMessage((0, $de8ma.default).upgradeButtonLabel), hasOnlyJSW ? undefined : (0, $9996ddd22815931e$export$cfca87b5d4683694), hasOnlyJSW ? undefined : '_blank') : null, $1fee2ed613b7661e$var$showLearnMoreButton(learnMoreButtonAppearance, // @ts-expect-error - TS2345 - Argument of type '(_: any, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to parameter of type '() => void'.
        learnMoreButtonOnClick, intl.formatMessage((0, $de8ma.default).learnMoreButtonLabel), hasOnlyJSW ? undefined : (0, $9996ddd22815931e$export$997e23a0aec74966), hasOnlyJSW ? undefined : '_blank')), upFlowIframeState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $02gpZ.UpFlowIFrame), {
            targetEdition: (0, $ldyPw.STANDARD_EDITION),
            product: explicitlyLicensedProducts[0],
            flow: upFlowIframeState,
            touchpointId: touchpointId,
            experienceTrackingEnabled: true,
            onClose: onUpFlowIframeClose
        })),
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start"
    }, children));
};
var $1fee2ed613b7661e$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)((0, $34Vv8.default)($1fee2ed613b7661e$var$UpgradeToAddUsersDialog));
const $1fee2ed613b7661e$var$buttonBarStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1fee2ed613b7661e$var$MultiLineParagraph = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5726vc6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iMd5l", function(module, exports) {

$parcel$export(module.exports, "getProductEdition", () => $658df12da4e62335$export$53e066a63a960439);

const $658df12da4e62335$export$53e066a63a960439 = (product, tenantContext)=>{
    if (product === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)) return tenantContext.appEditions.software;
    if (product === (0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61)) return tenantContext.appEditions.serviceDesk;
    return tenantContext.appEditions.core;
};

});

parcelRegister("cVzoY", function(module, exports) {

$parcel$export(module.exports, "default", () => $386aacc800b616d8$export$2e2bcd8739ae039);

var // eslint-disable-next-line jira/import/no-anonymous-default-export
$386aacc800b616d8$export$2e2bcd8739ae039 = (tenantContext)=>{
    const { licensedProducts: licensedProducts } = tenantContext;
    const result = [];
    licensedProducts[0, $c06e1abca7c13910$export$db515c8cec1e6f79] && result.push((0, $c06e1abca7c13910$export$db515c8cec1e6f79));
    licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && result.push((0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61));
    licensedProducts[0, $c06e1abca7c13910$export$1346c9aa3cbb477d] && result.push((0, $c06e1abca7c13910$export$1346c9aa3cbb477d));
    licensedProducts[0, $c06e1abca7c13910$export$202f50ee62667e32] && result.push((0, $c06e1abca7c13910$export$202f50ee62667e32));
    return result;
};

});

parcelRegister("2hXCB", function(module, exports) {

$parcel$export(module.exports, "LEARN_MORE", () => $a61f434346a6f772$export$1979295cc80a7ec1);
$parcel$export(module.exports, "WORKFLOW_EDIT_PERMISSION_LEARN_MORE", () => $a61f434346a6f772$export$779203acbfa8bf12);
$parcel$export(module.exports, "UPGRADE", () => $a61f434346a6f772$export$fe5b785cab515b6e);
$parcel$export(module.exports, "mapActionIdFromType", () => $a61f434346a6f772$export$2bf527ee1645dc7d);
const $a61f434346a6f772$export$9ba2bc3b1bdc1519 = 'experiment';
const $a61f434346a6f772$export$5b7423264d48ab04 = 'not-enrolled';
const $a61f434346a6f772$export$43f367b3e957f219 = 'control';
const $a61f434346a6f772$export$1979295cc80a7ec1 = 'learn-more';
const $a61f434346a6f772$export$779203acbfa8bf12 = 'workflow-edit-permission-learn-more';
const $a61f434346a6f772$export$fe5b785cab515b6e = 'upgrade';
const $a61f434346a6f772$export$2bf527ee1645dc7d = {
    [$a61f434346a6f772$export$1979295cc80a7ec1]: 'freeLearnMore',
    [$a61f434346a6f772$export$779203acbfa8bf12]: 'workflowEditLearnMore',
    [$a61f434346a6f772$export$fe5b785cab515b6e]: 'freeTryNow'
};

});

parcelRegister("02gpZ", function(module, exports) {

$parcel$export(module.exports, "UpFlowIFrame", () => $6cdd801078d648f3$export$e9eafd8c579e773d);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


var $4J6oz = parcelRequire("4J6oz");

var $g6ckq = parcelRequire("g6ckq");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6cdd801078d648f3$var$UpFlowIFrameLazy = (0, $kxZPA.lazy)(()=>(parcelRequire("lQ4bZ")), {
    moduleId: "./src/packages/growth/up-flow/up-flow-iframe/src/main.tsx"
});
const $6cdd801078d648f3$export$e9eafd8c579e773d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: (0, $abaf639d63a27f10$export$c73007a11ea7e52),
        packageName: (0, $abaf639d63a27f10$export$c73007a11ea7e52),
        teamName: "luna-growth",
        fallback: (0, $g6ckq.ChunkLoadErrorFlag),
        attributes: (0, $4J6oz.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "flow-iframe-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6cdd801078d648f3$var$UpFlowIFrameLazy, props)));

});
const $abaf639d63a27f10$export$c73007a11ea7e52 = 'jiraUpFlowIframe';
const $abaf639d63a27f10$export$cb7e587097a78810 = 'upsell-edition';
const $abaf639d63a27f10$export$fb320338324d1328 = 'upflowIFrame';
const $abaf639d63a27f10$export$782491eab0c2154d = 'INITIATE_SPA_CLOSE';
const $abaf639d63a27f10$export$dc3263ec2276f3f3 = 'START_EDITION_POLLING';
const $abaf639d63a27f10$export$8a7c66f5574473bd = 'FINISH_EDITION_POLLING';
const $abaf639d63a27f10$export$c012ea75b4437aea = 'TRACK_EXPERIENCE_FAIL';
const $abaf639d63a27f10$export$1b2e801262ba754 = 'TRACK_EXPERIENCE_SUCCESS';
const $abaf639d63a27f10$export$b6cceaecfde9dc91 = 'SPA_READY';

parcelRegister("4J6oz", function(module, exports) {

$parcel$export(module.exports, "applicationEditionToUpFlowEdition", () => $7e87fb5ffa0cfceb$export$b48ea9d6b982b3e1);
$parcel$export(module.exports, "jiraUpFlowIframeUpgradePlanInteraction", () => $7e87fb5ffa0cfceb$export$7d4045a899f62dfd);
$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $7e87fb5ffa0cfceb$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "handleError", () => $7e87fb5ffa0cfceb$export$d3da1ecaf1206c58);

var $5uXOq = parcelRequire("5uXOq");

var $dGrdR = parcelRequire("dGrdR");

var $jcw0u = parcelRequire("jcw0u");

var $ldyPw = parcelRequire("ldyPw");

var $bCf8q = parcelRequire("bCf8q");



var $ajCo3 = parcelRequire("ajCo3");
const $7e87fb5ffa0cfceb$export$e4e69593f7c9f3b7 = (attributes, error)=>{
    (0, $jcw0u.default)({
        meta: {
            // We use the same ID for all errors in the package for easier
            // management in data portal, and use attributes to identify an error instead.
            id: (0, $abaf639d63a27f10$export$c73007a11ea7e52),
            packageName: (0, $abaf639d63a27f10$export$c73007a11ea7e52),
            teamName: 'luna-growth'
        },
        attributes: {
            ...attributes
        },
        error: error
    });
};
const $7e87fb5ffa0cfceb$export$b48ea9d6b982b3e1 = (applicationEdition)=>{
    if (applicationEdition === (0, $ldyPw.FREE_EDITION)) return 0, $4c0643787f48cf65$export$e69af2c4378638a2;
    if (applicationEdition === (0, $ldyPw.STANDARD_EDITION)) return 0, $4c0643787f48cf65$export$7bc7dd5faba7ad6b;
    return 0, $4c0643787f48cf65$export$3fd0bbb8c68dc4c7;
};
const $7e87fb5ffa0cfceb$export$7d4045a899f62dfd = (0, $dGrdR.metrics).interaction({
    key: `${(0, $abaf639d63a27f10$export$c73007a11ea7e52)}.upgrade.plan`
});
const $7e87fb5ffa0cfceb$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $bCf8q.isLoaderError)(error)
    });
const $7e87fb5ffa0cfceb$export$d3da1ecaf1206c58 = (subject, onClose, apiError)=>{
    $7e87fb5ffa0cfceb$export$e4e69593f7c9f3b7({
        subject: subject,
        message: apiError?.message || ''
    }, apiError);
    $7e87fb5ffa0cfceb$export$7d4045a899f62dfd.cancel();
    onClose();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ajCo3.CommerceApiErrorFlag), null);
};

});
const $4c0643787f48cf65$export$e69af2c4378638a2 = 'free';
const $4c0643787f48cf65$export$7bc7dd5faba7ad6b = 'standard';
const $4c0643787f48cf65$export$3fd0bbb8c68dc4c7 = 'premium';

parcelRegister("ajCo3", function(module, exports) {

$parcel$export(module.exports, "CommerceApiErrorFlag", () => $0ee877bbb47ef7cb$export$7ee77c445dd775b4);

var $pa9q9 = parcelRequire("pa9q9");

var $7HGHK = parcelRequire("7HGHK");

var $cPOtr = parcelRequire("cPOtr");
const $0ee877bbb47ef7cb$export$7ee77c445dd775b4 = ()=>{
    const flagKey = (0, $7HGHK.toFlagId)('commerce-api-error');
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    showFlag({
        id: flagKey,
        key: flagKey,
        type: 'error',
        title: (0, $cPOtr.default).title,
        description: (0, $cPOtr.default).description,
        isAutoDismiss: true
    });
    return null;
};

});
parcelRegister("cPOtr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8891414a165fed2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c8891414a165fed2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "up-flow-iframe.common.commerce-api-error-flag.title",
        "defaultMessage": "We can't upgrade your plan right now"
    },
    description: {
        "id": "up-flow-iframe.common.commerce-api-error-flag.description",
        "defaultMessage": "Try again, or if this keeps happening try contacting support"
    }
});

});



parcelRegister("g6ckq", function(module, exports) {

$parcel$export(module.exports, "ChunkLoadErrorFlag", () => $590350b4061b001a$export$7a9d9407b3a5f50e);

var $pa9q9 = parcelRequire("pa9q9");

var $7HGHK = parcelRequire("7HGHK");

var $bCf8q = parcelRequire("bCf8q");

var $kgvbW = parcelRequire("kgvbW");
const $590350b4061b001a$export$7a9d9407b3a5f50e = ({ error: error })=>{
    const flagKey = (0, $7HGHK.toFlagId)('chunk-load-error');
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    if ((0, $bCf8q.isLoaderError)(error)) showFlag({
        id: flagKey,
        key: flagKey,
        type: 'error',
        title: (0, $kgvbW.default).title,
        description: (0, $kgvbW.default).description,
        isAutoDismiss: true,
        actions: [
            {
                content: (0, $kgvbW.default).refreshPageButton,
                onClick: ()=>{
                    dismissFlag(flagKey);
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.location.reload();
                }
            }
        ]
    });
    return null;
};

});
parcelRegister("kgvbW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae312d01f0160cd3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ae312d01f0160cd3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "up-flow-iframe.chunk-load-error-flag.title",
        "defaultMessage": "Something went wrong"
    },
    description: {
        "id": "up-flow-iframe.chunk-load-error-flag.description",
        "defaultMessage": "Refresh the page and try again."
    },
    refreshPageButton: {
        "id": "up-flow-iframe.chunk-load-error-flag.refresh-page-button",
        "defaultMessage": "Refresh page"
    }
});

});


parcelRegister("lQ4bZ", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("9cUHu")
]).then(()=>parcelRequire('1W7nw'));

});


const $9996ddd22815931e$export$997e23a0aec74966 = 'https://confluence.atlassian.com/display/AdminJIRACloud/Jira+Cloud+plans';
const $9996ddd22815931e$export$30ce584c3652886c = 'https://support.atlassian.com/jira-cloud-administration/docs/permissions-for-company-managed-projects/#Edit-Workflows';
const $9996ddd22815931e$export$cfca87b5d4683694 = '/admin/billing/applications';

parcelRegister("de8ma", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc942e740b757f44$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fc942e740b757f44$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    upgradeToAddUsersHeader: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-to-add-users-header",
        "defaultMessage": "Upgrade to add users"
    },
    upgradeToAddUsersContent: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-to-add-users-content",
        "defaultMessage": "You've reached the maximum number of users for your plan.\nRemove existing users or upgrade to grow your team."
    },
    upgradeButtonLabel: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-button-label",
        "defaultMessage": "Try it now"
    },
    learnMoreButtonLabel: {
        "id": "up-flow-upgrade-to-add-users-dialog.learn-more-button-label",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("j6etC", function(module, exports) {

$parcel$export(module.exports, "getRemainingSeats", () => $1d52ab7e56655772$export$6397e3bbf35b34e3);

var $eusud = parcelRequire("eusud");
const $1d52ab7e56655772$var$toRemainingSeats = (json)=>json.remainingSeat;
const $1d52ab7e56655772$export$6397e3bbf35b34e3 = (baseUrl, applicationKey)=>(0, $eusud.performGetRequest)(`/rest/internal/2/invite-user/application/remaining-seat?key=${applicationKey}`).then((json)=>$1d52ab7e56655772$var$toRemainingSeats(json));

});

parcelRegister("eJpZk", function(module, exports) {

$parcel$export(module.exports, "Analytics", () => $981a920c7dd6e4e8$export$2b3af6baec22bd98);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $1sLR4 = parcelRequire("1sLR4");

var $1zwpK = parcelRequire("1zwpK");

var $iqJSe = parcelRequire("iqJSe");
const $981a920c7dd6e4e8$export$2b3af6baec22bd98 = (props)=>{
    const { projectId: projectId, baseUrl: baseUrl, showAddPeopleButton: showAddPeopleButton, screenName: screenName } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (projectId >= 0 && showAddPeopleButton) Promise.all([
            (0, $1zwpK.getUserProjectRoles)(baseUrl, projectId),
            (0, $1sLR4.getProjectAccessLevel)(baseUrl, projectId)
        ]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then(([roleData, projectAccessLevel])=>{
            const projectRoleNames = roleData === null || roleData.projectRoleNames === null ? null : (0, $iqJSe.reduceCustomRoles)(roleData.projectRoleNames);
            (0, $iqJSe.fireAddPeopleRenderedEvent)(createAnalyticsEvent, screenName, projectId, projectRoleNames, projectAccessLevel);
        });
    }, [
        baseUrl,
        createAnalyticsEvent,
        projectId,
        screenName,
        showAddPeopleButton
    ]);
    return null;
};

});
parcelRegister("1sLR4", function(module, exports) {

$parcel$export(module.exports, "getProjectAccessLevel", () => $6d37e68816b91c3b$export$f5f97c28ee230e06);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $6d37e68816b91c3b$export$128fa18b7194ef = (baseUrl, projectId)=>`${baseUrl}/rest/internal/simplified/1.0/accesslevel/project/${projectId}`;
const $6d37e68816b91c3b$var$transform = (data)=>data.value;
const $6d37e68816b91c3b$export$f5f97c28ee230e06 = (baseUrl, projectId)=>{
    const request = ()=>(0, $eusud.performGetRequest)($6d37e68816b91c3b$export$128fa18b7194ef(baseUrl, projectId));
    return request().then((data)=>$6d37e68816b91c3b$var$transform(data)).catch((error)=>{
        const attributes = error instanceof (0, $jJZqs.default) ? {
            statusCode: error.statusCode,
            traceId: error.traceId
        } : {
            errorMessage: error.message
        };
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchProjectAccessLevel',
                packageName: 'jiraFilters',
                teamName: 'a4t-tanuki'
            },
            error: error,
            attributes: attributes,
            sendToPrivacyUnsafeSplunk: true
        });
        return Promise.resolve(null);
    });
};

});

parcelRegister("1zwpK", function(module, exports) {

$parcel$export(module.exports, "getUserProjectRoles", () => $845d77939718574b$export$3b587d1e1fe73b9d);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $845d77939718574b$var$MEMBER_ROLE_NAME = 'Member';
const $845d77939718574b$var$VIEWER_ROLE_NAME = 'Viewer';
const $845d77939718574b$var$userProjectRoleNames = (data)=>data.map((projectRole)=>projectRole.name);
const $845d77939718574b$export$5a1a2e9d57f47aee = (data)=>data.some((role)=>role.name === $845d77939718574b$var$MEMBER_ROLE_NAME);
const $845d77939718574b$export$10eeb2d34050404e = (data)=>data.some((role)=>role.admin);
const $845d77939718574b$export$a4d7f3415bee4b75 = (data)=>data.some((role)=>role.name !== $845d77939718574b$var$VIEWER_ROLE_NAME && role.name !== $845d77939718574b$var$MEMBER_ROLE_NAME && !role.admin);
const $845d77939718574b$export$128fa18b7194ef = (baseUrl, projectId)=>`${baseUrl}/rest/api/3/project/${projectId}/roledetails?excludeConnectAddons=true&currentMember=true`;
const $845d77939718574b$export$3b587d1e1fe73b9d = (baseUrl, projectId)=>{
    const request = ()=>(0, $eusud.performGetRequest)($845d77939718574b$export$128fa18b7194ef(baseUrl, projectId));
    return request().then((data)=>({
            isMember: $845d77939718574b$export$5a1a2e9d57f47aee(data),
            isJiraAdmin: $845d77939718574b$export$10eeb2d34050404e(data),
            hasCustomRole: $845d77939718574b$export$a4d7f3415bee4b75(data),
            projectRoleNames: $845d77939718574b$var$userProjectRoleNames(data)
        })).catch((error)=>{
        const attributes = error instanceof (0, $jJZqs.default) ? {
            statusCode: error.statusCode,
            traceId: error.traceId
        } : {
            errorMessage: error.message
        };
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchUserProjectRoles',
                packageName: 'jiraFilters',
                teamName: 'a4t-tanuki'
            },
            error: error,
            attributes: attributes,
            sendToPrivacyUnsafeSplunk: true
        });
        return Promise.resolve(null);
    });
};

});

parcelRegister("iqJSe", function(module, exports) {

$parcel$export(module.exports, "fireAddPeopleRenderedEvent", () => $131644081500a421$export$8014b0c4810b7867);
$parcel$export(module.exports, "reduceCustomRoles", () => $131644081500a421$export$7f2d1c0dab5190f9);

var $8zOmE = parcelRequire("8zOmE");
const $131644081500a421$var$defaultProjectRoles = [
    'Administrator',
    'Member',
    'Viewer'
];
const $131644081500a421$export$ecf9824f02c8a125 = 'Custom Role';
const $131644081500a421$export$8014b0c4810b7867 = (createAnalyticsEvent, source, projectId, userProjectRoles, projectAccessLevel)=>{
    const analyticsEvent = createAnalyticsEvent({
        action: 'rendered',
        actionSubject: 'addPeopleButton',
        source: source
    });
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
        projectId: projectId,
        userProjectRoles: userProjectRoles,
        projectAccessLevel: projectAccessLevel
    });
};
const $131644081500a421$export$7f2d1c0dab5190f9 = (userProjectRoles)=>{
    let hasCustomRole = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const modifiedProjectRoles = userProjectRoles.reduce((acc, role)=>{
        const isDefaultRole = $131644081500a421$var$defaultProjectRoles.includes(role);
        hasCustomRole = hasCustomRole || !isDefaultRole;
        if (isDefaultRole) acc.push(role);
        return acc;
    }, []);
    if (hasCustomRole) modifiedProjectRoles.push($131644081500a421$export$ecf9824f02c8a125);
    return modifiedProjectRoles;
};

});


parcelRegister("lAu6N", function(module, exports) {

$parcel$export(module.exports, "default", () => $020a81e9686d5942$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $az4zD = parcelRequire("az4zD");

var $dCm1o = parcelRequire("dCm1o");

var $gQDFP = parcelRequire("gQDFP");

var $kfN7T = parcelRequire("kfN7T");

var $a43Dp = parcelRequire("a43Dp");

var $2eCzd = parcelRequire("2eCzd");

var $mafYu = parcelRequire("mafYu");
const $020a81e9686d5942$var$AssigneeFilter = (props)=>{
    const { users: users, selectedUsers: selectedUsers, maxUsers: maxUsers, onAddPeopleClick: onAddPeopleClick, showAddPeopleButton: showAddPeopleButton, onToggle: onToggle, onAssigneeMenuOpen: onAssigneeMenuOpen, intl: { formatMessage: formatMessage }, peopleRef: peopleRef } = props;
    const mainList = (0, $5uXOq.useMemo)(()=>users.length > maxUsers ? users.slice(0, maxUsers - 1) : users.slice(0), [
        users,
        maxUsers
    ]);
    const moreList = (0, $5uXOq.useMemo)(()=>users.length > maxUsers ? users.slice(maxUsers - 1) : [], [
        users,
        maxUsers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "fieldset",
        xcss: [
            (0, $dCm1o.isVisualRefreshEnabled)() ? $020a81e9686d5942$var$fieldsetStyles : $020a81e9686d5942$var$fieldsetStylesOld
        ],
        "data-test-id": "filters.ui.filters.assignee.stateless.assignee-filter",
        testId: "filters.ui.filters.assignee.stateless.assignee-filter" // eslint-disable-next-line jira/react/no-style-attribute
        ,
        style: {
            // Ensure layering of avatars does not conflict with anything else in the DOM tree
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            zIndex: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($020a81e9686d5942$var$AvatarFilterLegend, {
        id: (0, $gQDFP.FILTER_PREFIX)
    }, formatMessage((0, $2eCzd.default).label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($020a81e9686d5942$var$AvatarsList, null, mainList.map((user, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a43Dp.default), {
            key: user.id,
            zIndex: maxUsers - index,
            user: user,
            isSelected: selectedUsers.includes(user.id),
            onToggle: onToggle
        })), moreList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $mafYu.default), {
        users: moreList,
        selectedUsers: selectedUsers,
        onItemActivated: onToggle,
        onOpen: onAssigneeMenuOpen
    }), showAddPeopleButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kfN7T.default), {
        peopleButtonRef: peopleRef,
        onClick: onAddPeopleClick
    })));
};
$020a81e9686d5942$var$AssigneeFilter.defaultProps = {
    onAddPeopleClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onAssigneeMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    showAddPeopleButton: false
};
var $020a81e9686d5942$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($020a81e9686d5942$var$AssigneeFilter);
const $020a81e9686d5942$var$fieldsetStyles = (0, $8CUq3.xcss)({
    flexShrink: 0,
    border: 0
});
const $020a81e9686d5942$var$fieldsetStylesOld = (0, $8CUq3.xcss)({
    flexShrink: 0,
    border: 0,
    marginLeft: 'space.150'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $020a81e9686d5942$var$AvatarsList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $020a81e9686d5942$var$AvatarFilterLegend = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "legend", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _4t3it94y _1bsbt94y _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _ogto7mnp _1reo15vq _18m915vq _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gQDFP", function(module, exports) {

$parcel$export(module.exports, "FILTER_PREFIX", () => $4ab71e27db0ec1f1$export$d6acfe0d617669c3);
$parcel$export(module.exports, "Z_INDEX", () => $4ab71e27db0ec1f1$export$42310dd57a41067);
const $4ab71e27db0ec1f1$export$d6acfe0d617669c3 = 'assignee';
const $4ab71e27db0ec1f1$export$42310dd57a41067 = {
    SELECTED: 1,
    ADD: 2,
    MENU: 3,
    HOVER: 4
};
const $4ab71e27db0ec1f1$export$e70f7f4a08e4d8fb = 10;
const $4ab71e27db0ec1f1$export$75297e3804621b0 = 36;

});

parcelRegister("kfN7T", function(module, exports) {

$parcel$export(module.exports, "default", () => $66a6af3ecba65952$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $cjvpk = parcelRequire("cjvpk");

var $ijaND = parcelRequire("ijaND");

var $4R6GH = parcelRequire("4R6GH");

var $8RXs9 = parcelRequire("8RXs9");

var $cE2Qr = parcelRequire("cE2Qr");

var $hchBL = parcelRequire("hchBL");

var $2XCFo = parcelRequire("2XCFo");

var $k1LTw = parcelRequire("k1LTw");

var $gQDFP = parcelRequire("gQDFP");

var $cWMNe = parcelRequire("cWMNe");

var $7oMpD = parcelRequire("7oMpD");

var $ihiH5 = parcelRequire("ihiH5");
const $66a6af3ecba65952$var$ADD_PEOPLE_BUTTON_TARGET = 'addPeopleButtonTarget';
const $66a6af3ecba65952$var$AddUsersButton = (props)=>{
    const { intl: { formatMessage: formatMessage }, onClick: onClickProp, peopleButtonRef: peopleButtonRef } = props;
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        (0, $cWMNe.onBlur)(event);
        onClickProp();
    }, [
        onClickProp
    ]);
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    const onRef = (0, $5uXOq.useCallback)((ref)=>{
        register($66a6af3ecba65952$var$ADD_PEOPLE_BUTTON_TARGET, ref);
    }, [
        register
    ]);
    const [isDismissed] = (0, $cE2Qr.useIsDismissed)();
    const NudgeTooltip = !(0, $4R6GH.fg)('jsw-perf-async-add-people-modal-load') || !isDismissed ? (0, $2XCFo.AssigneeFilterAddPeopleButtonWrapperNudgeAsync) : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($66a6af3ecba65952$var$AddButtonWrapper, {
        ref: onRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NudgeTooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ihiH5.AddPeopleTooltip), {
        content: formatMessage((0, $7oMpD.default).addPeople)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($66a6af3ecba65952$var$ActionAvatarWrapper, {
        ref: peopleButtonRef,
        "data-test-id": "filters.ui.filters.assignee.stateless.add-button",
        "data-testid": "filters.ui.filters.assignee.stateless.add-button",
        "data-pollinator-filter-bar-add-people": true,
        id: `${(0, $gQDFP.FILTER_PREFIX)}-add-person`,
        "aria-label": formatMessage((0, $7oMpD.default).addPeople),
        onClick: onClick,
        "aria-describedby": (0, $gQDFP.FILTER_PREFIX)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($66a6af3ecba65952$var$AddButtonAvatarSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ijaND))), {
        size: "medium",
        label: formatMessage((0, $7oMpD.default).addPeople)
    }))))));
};
$66a6af3ecba65952$var$AddUsersButton.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $66a6af3ecba65952$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $8RXs9.default)($66a6af3ecba65952$var$AddUsersButton);
const $66a6af3ecba65952$var$AddButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $66a6af3ecba65952$var$ActionAvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $k1LTw.ActionAvatar), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $66a6af3ecba65952$var$AddButtonAvatarSpacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $k1LTw.ActionAvatarSpacer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1lu4wzb": (0, $lD23V.default)((0, $cjvpk.AVATAR_SIZES).medium, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko12pq _1ul912pq _1bsb1wug _1yt4otz2 _vchhusvi _bfhk1s4m _1p9v18uv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $66a6af3ecba65952$export$7ed12d2a5241e393 = {
    ActionAvatarWrapper: $66a6af3ecba65952$var$ActionAvatarWrapper
};

});
parcelRegister("ijaND", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d54260e58fec7f9a$var$_react = $d54260e58fec7f9a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d54260e58fec7f9a$var$_personAdd = $d54260e58fec7f9a$var$_interopRequireDefault((parcelRequire("fvfvk")));
function $d54260e58fec7f9a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d54260e58fec7f9a$var$InviteTeamIcon = (props)=>/*#__PURE__*/ $d54260e58fec7f9a$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="2" height="6" x="18" y="5" rx="1"/><rect width="6" height="2" x="16" y="7" rx="1"/><path d="M5 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="11" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $d54260e58fec7f9a$var$_personAdd.default
    }));
$d54260e58fec7f9a$var$InviteTeamIcon.displayName = 'InviteTeamIcon';
var $d54260e58fec7f9a$var$_default = module.exports.default = $d54260e58fec7f9a$var$InviteTeamIcon;

});
parcelRegister("fvfvk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c71910615fcdf3419bf276c45a2048a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b495c71cb30b2c7c$var$_react = $b495c71cb30b2c7c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b495c71cb30b2c7c$var$_UNSAFE_baseNew = $b495c71cb30b2c7c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b495c71cb30b2c7c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b495c71cb30b2c7c$var$PersonAddIcon = (props)=>/*#__PURE__*/ $b495c71cb30b2c7c$var$_react.default.createElement($b495c71cb30b2c7c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 15v-2.25a3 3 0 0 1 3-3h2.5a3 3 0 0 1 3 3V15M13 8V5m0 3v3m0-3h3m-3 0h-3M8.25 4a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$b495c71cb30b2c7c$var$PersonAddIcon.displayName = 'PersonAddIcon';
var $b495c71cb30b2c7c$var$_default = module.exports.default = $b495c71cb30b2c7c$var$PersonAddIcon;

});


parcelRegister("2XCFo", function(module, exports) {

$parcel$export(module.exports, "AssigneeFilterAddPeopleButtonWrapperNudgeAsync", () => $ca2358eaf62c0b1a$export$4e4097c2567f79b7);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ca2358eaf62c0b1a$var$AssigneeFilterAddPeopleButtonLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("1YfpH")).then((exportedModule)=>exportedModule.AssigneeFilterAddPeopleButtonWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/assignee-filter-add-people/index.tsx"
});
const $ca2358eaf62c0b1a$export$4e4097c2567f79b7 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-assignee-filter-add-people-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca2358eaf62c0b1a$var$AssigneeFilterAddPeopleButtonLazy, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98)
    }, children)));

});
parcelRegister("1YfpH", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("d744b")
]).then(()=>parcelRequire('1Pog6'));

});


parcelRegister("k1LTw", function(module, exports) {

$parcel$export(module.exports, "AvatarWrapper", () => $03be4aba8d3a8915$export$f7513421c53ce141);
$parcel$export(module.exports, "ActionAvatar", () => $03be4aba8d3a8915$export$1a5d4fdc8fa41cfb);
$parcel$export(module.exports, "ActionAvatarSpacer", () => $03be4aba8d3a8915$export$d1aac2da5f30c370);
$parcel$export(module.exports, "AvatarBorder", () => $03be4aba8d3a8915$export$398a7826f6fd570e);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $cjvpk = parcelRequire("cjvpk");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $gQDFP = parcelRequire("gQDFP");
const $03be4aba8d3a8915$export$483a2b43be170225 = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    padding: 0,
    border: 0,
    opacity: 0,
    overflow: 'hidden',
    'white-space': 'nowrap',
    cursor: 'pointer'
};
const $03be4aba8d3a8915$export$a3e8c7acf36da4c1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { zIndex: zIndex, jiggle: jiggle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10xi207": (0, $lD23V.default)(__cmplp.zIndex + (0, $gQDFP.Z_INDEX).SELECTED),
            "--_3qw8s9": (0, $lD23V.default)(__cmplp.zIndex),
            "--_1rh09jt": (0, $lD23V.default)(__cmplp.zIndex + (0, $gQDFP.Z_INDEX).HOVER)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _4t3i1ylp _kqswh2mm _18u014id _bfhk18uv _s7n4jp4b _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _v5644a6k _2rko1ssb _11cpidpf _rk8t1bgr _1dig1bgr _yt1x1bgr _qa15stnw _1tfxstnw _ixiwstnw _1wnsb3bt _h10pb3bt _1boqb3bt _328d1osq _cqfi1osq _rtz31osq _1mhnidpf _44x7idpf _l3jaidpf _1rky1n1a _1a071n1a _1wtq1n1a _1xpg1n1a _ti301n1a _1j2w1n1a _s1sf1mrw _1v981mrw _x2d61mrw _1pcqvab1 _1qb3vab1 _1b1bvab1 _vdzntlke _1virtlke _1y7ctlke",
            __cmplp.selected ? "_1pby1ho9" : "_1pby1hh6",
            __cmplp.jiggle ? "_1bvqr915 _66dkr915 _1llwr915" : "_1bvq1kli _66dk1kli _1llw1kli",
            __cmplp.jiggle ? "_n3lxmyb0 _gabdmyb0 _9di1myb0" : "_n3lxidpf _gabdidpf _9di1idpf",
            __cmplp.className
        ])
    });
});
const $03be4aba8d3a8915$export$7d5adb020315f211 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $03be4aba8d3a8915$export$a3e8c7acf36da4c1, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3in7od",
            __cmplp.className
        ])
    });
});
const $03be4aba8d3a8915$export$f7513421c53ce141 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $03be4aba8d3a8915$export$7d5adb020315f211, $03be4aba8d3a8915$export$a3e8c7acf36da4c1);
const $03be4aba8d3a8915$export$1a5d4fdc8fa41cfb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2rko1ssb _19it7zi8 _bfhk1s4m _v5644dm8 _80omtlke _7ehi12h7 _nt751r31 _49pcglyw _1hvw1o36 _irr3yucn",
            __cmplp.className
        ])
    });
});
const $03be4aba8d3a8915$export$d1aac2da5f30c370 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1lu4wzb": (0, $lD23V.default)((0, $cjvpk.AVATAR_SIZES).medium, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb12pq _4t3i12pq _bfhk18uv _syazi7uo _vwz412pq",
            __cmplp.className
        ])
    });
});
const $03be4aba8d3a8915$export$398a7826f6fd570e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _19itj1ic",
            __cmplp.selected ? "_1h6d1c86" : "_1h6d3acm",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cWMNe", function(module, exports) {

$parcel$export(module.exports, "onBlur", () => $3b2d077e6f2bec18$export$5e446bc31724fca4);
$parcel$export(module.exports, "useOnKeyPress", () => $3b2d077e6f2bec18$export$49f6dd346c7dfb52);

var $5uXOq = parcelRequire("5uXOq");
const $3b2d077e6f2bec18$export$5e446bc31724fca4 = (event)=>{
    event.currentTarget.blur();
};
const $3b2d077e6f2bec18$export$49f6dd346c7dfb52 = (callback)=>(0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Enter') callback(event);
    }, [
        callback
    ]);

});

parcelRegister("7oMpD", function(module, exports) {

$parcel$export(module.exports, "default", () => $84bb6f0a7c1ddc3e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $84bb6f0a7c1ddc3e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addPeople: {
        "id": "software-filters.filters.assignee.stateless.add-button.add-people",
        "defaultMessage": "Add people"
    }
});

});

parcelRegister("ihiH5", function(module, exports) {

$parcel$export(module.exports, "AddPeopleTooltip", () => $936c019622c243d2$export$7d4858372ded9f0e);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");
const $936c019622c243d2$export$7d4858372ded9f0e = ({ content: content, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($936c019622c243d2$var$TooltipWrapper, null, children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $936c019622c243d2$var$TooltipWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _kqswh2mm _12ji1r31 _1qu2glyw _12y3idpf _4t3i14no",
            __cmplp.className
        ])
    });
});

});


parcelRegister("a43Dp", function(module, exports) {

$parcel$export(module.exports, "default", () => $68ed3a89d7efd9a4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $lLtod = parcelRequire("lLtod");

var $3bDjY = parcelRequire("3bDjY");

var $joX8T = parcelRequire("joX8T");

var $4R6GH = parcelRequire("4R6GH");

var $8RXs9 = parcelRequire("8RXs9");

var $2WENx = parcelRequire("2WENx");

var $dCm1o = parcelRequire("dCm1o");

var $k1LTw = parcelRequire("k1LTw");

var $cWMNe = parcelRequire("cWMNe");

var $f0vy0 = parcelRequire("f0vy0");

var $iv6Wk = parcelRequire("iv6Wk");
const $68ed3a89d7efd9a4$var$type = 'assignee';
const $68ed3a89d7efd9a4$var$Avatar = (props)=>{
    const { user: user, isSelected: isSelected, zIndex: zIndex, intl: intl } = props;
    const { formatMessage: formatMessage } = intl;
    const userIdentifier = user.id;
    const checkboxId = `${$68ed3a89d7efd9a4$var$type}-${userIdentifier}`;
    const onToggle = (0, $5uXOq.useCallback)(()=>{
        props.onToggle(user.id);
    }, [
        props,
        user.id
    ]);
    const onKeyPress = (0, $cWMNe.useOnKeyPress)(onToggle);
    const { experimentCohort: experimentCohort } = (0, $2WENx.useRealtimePresenceExperiment)();
    const isRealtimePresenceEnabled = experimentCohort === (0, $joX8T.VARIATION);
    const altTextWithPresence = formatMessage(user.presence === 'online' ? (0, $iv6Wk.default).presenceOnlineLabel : (0, $iv6Wk.default).presenceOfflineLabel, {
        name: user.displayName
    });
    const avatarWithTooltip = isRealtimePresenceEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f0vy0.default), {
        content: user.displayName,
        presence: user.presence,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLtod.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('jira_nav4_eap_drop_1') ? 'small' : 'medium',
        as: "span",
        src: user.avatarUrl,
        name: user.presence ? altTextWithPresence : user.displayName,
        presence: user.presence
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: user.displayName,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLtod.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('jira_nav4_eap_drop_1') ? 'small' : 'medium',
        as: "span",
        src: user.avatarUrl,
        name: user.displayName,
        presence: user.presence
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1LTw.AvatarWrapper), {
        selected: isSelected,
        zIndex: zIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68ed3a89d7efd9a4$var$AvatarInputCheckbox, {
        "aria-label": formatMessage((0, $iv6Wk.default).avatarInputCheckboxLabel),
        type: "checkbox",
        id: checkboxId,
        name: $68ed3a89d7efd9a4$var$type,
        value: userIdentifier,
        defaultChecked: isSelected,
        onChange: onToggle,
        onKeyPress: onKeyPress,
        onClick: (0, $cWMNe.onBlur)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1LTw.AvatarBorder), {
        selected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68ed3a89d7efd9a4$var$AvatarLabel, {
        "data-test-id": "filters.ui.filters.assignee.stateless.avatar.assignee-filter-avatar",
        "data-testid": "filters.ui.filters.assignee.stateless.avatar.assignee-filter-avatar",
        htmlFor: checkboxId
    }, avatarWithTooltip)));
};
$68ed3a89d7efd9a4$var$Avatar.defaultProps = {
    isSelected: false,
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $68ed3a89d7efd9a4$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $8RXs9.default)($68ed3a89d7efd9a4$var$Avatar);
const $68ed3a89d7efd9a4$var$AvatarLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz4idpf _1e0c1ule _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $68ed3a89d7efd9a4$var$AvatarInputCheckbox = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _tzy4idpf _1reo15vq _18m915vq _o5721q9c _80omtlke _1xp4rg51",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $68ed3a89d7efd9a4$export$7ed12d2a5241e393 = {
    AvatarInputCheckbox: $68ed3a89d7efd9a4$var$AvatarInputCheckbox
};

});
parcelRegister("2WENx", function(module, exports) {

$parcel$export(module.exports, "useRealtimePresenceExperiment", () => $ef9e8ab383852170$export$ba964695877b24);

var $4mBKK = parcelRequire("4mBKK");

var $6s1PB = parcelRequire("6s1PB");

var $dkqym = parcelRequire("dkqym");
const $ef9e8ab383852170$export$ba964695877b24 = ()=>{
    const firstActivationDateMs = (0, $dkqym.useFirstActivationDateMs)();
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_board_real-time_collaboration_through_presence');
    return {
        experimentCohort: !firstActivationDateMs || (0, $4mBKK.default)(new Date(), firstActivationDateMs) < 30 ? 'not-enrolled' : expConfig.get('cohort', 'not-enrolled')
    };
};

});

parcelRegister("f0vy0", function(module, exports) {

$parcel$export(module.exports, "default", () => $fff18090899dca54$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $hf0Xf = parcelRequire("hf0Xf");
const $fff18090899dca54$var$PresenceTooltip = ({ presence: presence, content: content, children: children, ...restProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const contentWithPresence = presence === 'online' ? formatMessage((0, $hf0Xf.default).presenceToolTipOnline, {
        name: String(content)
    }) : formatMessage((0, $hf0Xf.default).presenceToolTipOffline, {
        name: String(content)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: presence ? contentWithPresence : content,
        ...restProps
    }, children);
};
var $fff18090899dca54$export$2e2bcd8739ae039 = $fff18090899dca54$var$PresenceTooltip;

});
parcelRegister("hf0Xf", function(module, exports) {

$parcel$export(module.exports, "default", () => $14a1fa5c7f46c36b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $14a1fa5c7f46c36b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    presenceToolTipOnline: {
        "id": "software-filters.common.presence-tooltip.presence-tool-tip-online",
        "defaultMessage": "{name} is online"
    },
    presenceToolTipOffline: {
        "id": "software-filters.common.presence-tooltip.presence-tool-tip-offline",
        "defaultMessage": "{name} is offline"
    }
});

});


parcelRegister("iv6Wk", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a7903d4e27c8480$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2a7903d4e27c8480$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    presenceOnlineLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.presence-online-label",
        "defaultMessage": "{name} (online)"
    },
    presenceOfflineLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.presence-offline-label",
        "defaultMessage": "{name} (offline)"
    },
    avatarInputCheckboxLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.avatar-input-checkbox-label",
        "defaultMessage": "assignee filter avatar"
    }
});

});


parcelRegister("2eCzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a3184a04c19fde7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0a3184a04c19fde7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.assignee.stateless.label",
        "defaultMessage": "Filter by assignee"
    },
    showMoreButton: {
        "id": "software-filters.filters.assignee.stateless.show-more",
        "defaultMessage": "Show more assignees"
    }
});

});

parcelRegister("mafYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb88f751cbd22241$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $cjvpk = parcelRequire("cjvpk");
var $lLtod = parcelRequire("lLtod");

var $BLPHT = parcelRequire("BLPHT");
var $jFrow = parcelRequire("jFrow");

var $3bDjY = parcelRequire("3bDjY");

var $joX8T = parcelRequire("joX8T");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2WENx = parcelRequire("2WENx");

var $g5X3G = parcelRequire("g5X3G");

var $dCm1o = parcelRequire("dCm1o");

var $k1LTw = parcelRequire("k1LTw");

var $gQDFP = parcelRequire("gQDFP");

var $cWMNe = parcelRequire("cWMNe");

var $f0vy0 = parcelRequire("f0vy0");

var $2eCzd = parcelRequire("2eCzd");
const $bb88f751cbd22241$var$ShowMoreButton = (props)=>{
    const { users: users, selectedUsers: selectedUsers, onOpen: onOpen, onItemActivated: onItemActivatedProps } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setOpenState] = (0, $5uXOq.useState)(false);
    const _onOpenChange = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (attrs)=>{
        setOpenState(attrs.isOpen);
        if (attrs.isOpen) onOpen();
    }, [
        setOpenState,
        onOpen
    ]);
    const isSelected = (0, $5uXOq.useMemo)(()=>users.some((user)=>selectedUsers.includes(user.id)), [
        users,
        selectedUsers
    ]);
    const { experimentCohort: experimentCohort } = (0, $2WENx.useRealtimePresenceExperiment)();
    const isRealtimePresenceEnabled = experimentCohort === (0, $joX8T.VARIATION);
    const dropdownItems = (0, $5uXOq.useMemo)(()=>users.map(({ id: id, displayName: displayName, avatarUrl: avatarUrl, presence: presence })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$ItemWrapper, {
                key: id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jFrow.default), {
                id: id,
                isSelected: selectedUsers.includes(id),
                onClick: ()=>{
                    onItemActivatedProps((0, $g5X3G.toAccountId)(String(id)));
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$ItemContent, null, isRealtimePresenceEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f0vy0.default), {
                content: displayName,
                presence: presence
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$DropdownAvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLtod.default), {
                size: "small",
                src: avatarUrl,
                name: displayName,
                presence: presence
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: displayName
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$DropdownAvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLtod.default), {
                size: "small",
                src: avatarUrl,
                name: displayName,
                presence: presence
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$TextContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$TextContent, null, displayName)))))), [
        users,
        selectedUsers,
        onItemActivatedProps,
        isRealtimePresenceEnabled
    ]);
    // On cleanup of 'jsw-filters-avatar-show-more-aria-fix' move these to the avatar wrapper styles
    const avatarWrapperStyle = {
        margin: 0,
        padding: 0,
        border: 0,
        borderRadius: '50%',
        background: 'none',
        outline: 0
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$DropdownMenuWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, 'aria-expanded': ariaExpanded, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1LTw.AvatarWrapper), {
                ...triggerProps,
                as: (0, $4R6GH.fg)('jsw-filters-avatar-show-more-aria-fix') ? 'button' : undefined,
                "aria-expanded": ariaExpanded,
                ref: triggerRef,
                zIndex: (0, $gQDFP.Z_INDEX).MENU,
                style: (0, $4R6GH.fg)('jsw-filters-avatar-show-more-aria-fix') ? avatarWrapperStyle : undefined,
                "data-testid": (0, $4R6GH.fg)('jsw-filters-avatar-show-more-aria-fix') ? 'filters.ui.filters.assignee.stateless.show-more-button.assignee-filter-show-more' : undefined
            }, !(0, $4R6GH.fg)('jsw-filters-avatar-show-more-aria-fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$ActionInputCheckbox, {
                "data-test-id": "filters.ui.filters.assignee.stateless.show-more-button.assignee-filter-show-more",
                "data-testid": "filters.ui.filters.assignee.stateless.show-more-button.assignee-filter-show-more",
                type: "checkbox",
                id: `${(0, $gQDFP.FILTER_PREFIX)}-show-more`,
                name: (0, $gQDFP.FILTER_PREFIX),
                value: `${(0, $gQDFP.FILTER_PREFIX)}-show-more`,
                defaultChecked: isOpen,
                "aria-expanded": ariaExpanded,
                "aria-label": formatMessage((0, $2eCzd.default).showMoreButton),
                onClick: (0, $cWMNe.onBlur)
            }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1LTw.AvatarBorder), {
                selected: isSelected
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1LTw.ActionAvatar), {
                as: (0, $4R6GH.fg)('jsw-filters-avatar-show-more-aria-fix') ? 'div' : undefined,
                tabIndex: -1
            }, (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('jira_nav4_eap_drop_1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$ShowMoreButtonAvatarSpacer, null, `+${users.length}`) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1LTw.ActionAvatarSpacer), null, `+${users.length}`))))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$DropdownItemsWrapper, null, dropdownItems)));
};
$bb88f751cbd22241$var$ShowMoreButton.defaultProps = {
    onItemActivated: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $bb88f751cbd22241$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $bb88f751cbd22241$var$ShowMoreButton;
const $bb88f751cbd22241$var$DropdownMenuWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _18u014id _1pbyidpf",
            __cmplp.className
        ])
    });
}); // The old menu dropdown has a max-width of 300px but the new one has 800px.
const $bb88f751cbd22241$var$DropdownItemsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1mjv _1yt4swc3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb88f751cbd22241$var$ItemWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1t4ug9d8 _k907ze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb88f751cbd22241$var$ItemContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb88f751cbd22241$var$DropdownAvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _18u0v77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb88f751cbd22241$var$TextContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _18s816r1 _1yt41w01 _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb88f751cbd22241$var$TextContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $bb88f751cbd22241$var$ActionInputCheckbox = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _tzy4idpf _1reo15vq _18m915vq _o5721q9c _80omtlke _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1glwzk5k _5o9f194a",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $bb88f751cbd22241$var$ShowMoreButtonAvatarSpacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $k1LTw.ActionAvatarSpacer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_wiw70x": (0, $lD23V.default)((0, $cjvpk.AVATAR_SIZES).small, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1yj7 _4t3i1yj7 _1wyb19bv _t9ec1win",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jFrow", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d90ebe7a2adf26d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $j7LBE = parcelRequire("j7LBE");

var $kJpBP = parcelRequire("kJpBP");

var $VSDnB = parcelRequire("VSDnB");

var $hEtee = parcelRequire("hEtee");

var $6PlGW = parcelRequire("6PlGW");

var $l7Q0F = parcelRequire("l7Q0F");

var $6cAn5 = parcelRequire("6cAn5");
/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $9d90ebe7a2adf26d$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $eGmKJ.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $6cAn5;
    const [selected, setSelected] = (0, $6PlGW.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $5uXOq.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $l7Q0F.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j7LBE.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hEtee.default), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: "menuitemcheckbox",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        ...(0, $VSDnB.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children));
};
var $9d90ebe7a2adf26d$export$2e2bcd8739ae039 = $9d90ebe7a2adf26d$var$DropdownItemCheckbox;

});
parcelRegister("hEtee", function(module, exports) {

$parcel$export(module.exports, "default", () => $181f17e87025e1b2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");

/**
 * __Checkbox icon__
 *
 * Used to visually represent the selected state in DropdownItemCheckbox
 *
 * @internal
 */ const $181f17e87025e1b2$var$CheckboxIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dV6Te.default), {
        label: "",
        size: "medium",
        primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
        secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : 'transparent'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2",
        stroke: checked ? `var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`,
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    })));
};
var $181f17e87025e1b2$export$2e2bcd8739ae039 = $181f17e87025e1b2$var$CheckboxIcon;

});

parcelRegister("6PlGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e2d30248a719600$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5MgQz = parcelRequire("5MgQz");

var $iY6id = parcelRequire("iY6id");
/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $3e2d30248a719600$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $5uXOq.useContext)((0, $iY6id.SelectionStoreContext));
    const groupId = (0, $5uXOq.useContext)((0, $5MgQz.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $5uXOq.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $5uXOq.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $3e2d30248a719600$export$2e2bcd8739ae039 = $3e2d30248a719600$var$useCheckboxState;

});
parcelRegister("5MgQz", function(module, exports) {

$parcel$export(module.exports, "CheckboxGroupContext", () => $155fc86a3d14dca7$export$baf37c4be89255b8);

var $5uXOq = parcelRequire("5uXOq");
const $155fc86a3d14dca7$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $5uXOq.createContext)('');

});






parcelRegister("3oCwY", function(module, exports) {

$parcel$export(module.exports, "default", () => $195137f112bf0000$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $aVUro = parcelRequire("aVUro");
const $195137f112bf0000$var$ClearFilterButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            !(0, $dCm1o.isVisualRefreshEnabled)() && $195137f112bf0000$var$styledClearFilterStyles
        ],
        "data-test-id": "filters.ui.filters.clear-button.ak-button",
        testId: "filters.ui.filters.clear-button.ak-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onClick: props.onClick
    }, props.label || formatMessage((0, $aVUro.default).label)));
};
$195137f112bf0000$var$ClearFilterButton.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $195137f112bf0000$export$2e2bcd8739ae039 = $195137f112bf0000$var$ClearFilterButton;
const $195137f112bf0000$var$styledClearFilterStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});

});
parcelRegister("aVUro", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfdad8f510b5e904$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dfdad8f510b5e904$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.clear-button.label",
        "defaultMessage": "Clear filters"
    }
});

});


parcelRegister("7j6PN", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf5bd4e554fcb50$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $g5X3G = parcelRequire("g5X3G");

var $96s6B = parcelRequire("96s6B");

var $cTznA = parcelRequire("cTznA");
const $1bf5bd4e554fcb50$var$ComponentFilter = ({ components: components = [], selectedComponents: selectedComponents = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>components.map((component)=>({
                label: component.name,
                // Casting to string normalises the id that may potentially be a number.
                value: String(component.id)
            })), [
        components
    ]);
    const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
            label: formatMessage((0, $cTznA.default).label),
            values: values,
            selectedValues: (0, $g5X3G.toStringArray)(selectedComponents),
            onChange: onChangeCallback,
            isNested: isNested
        }), [
        formatMessage,
        onChangeCallback,
        selectedComponents,
        values,
        isNested
    ]);
};
var $1bf5bd4e554fcb50$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($1bf5bd4e554fcb50$var$ComponentFilter);

});
parcelRegister("96s6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $51e7460acbb65361$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2NMNM = parcelRequire("2NMNM");

var $itpgN = parcelRequire("itpgN");
var $bChGW = parcelRequire("bChGW");
var $b9dFI = parcelRequire("b9dFI");


var $dqoiX = parcelRequire("dqoiX");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $8C9C3 = parcelRequire("8C9C3");

var $dF38k = parcelRequire("dF38k");

var $73s29 = parcelRequire("73s29");

var $d9hVL = parcelRequire("d9hVL");

var $4Mv0u = parcelRequire("4Mv0u");

var $ijTad = parcelRequire("ijTad");
const $51e7460acbb65361$var$MenuListWrapper = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "filters.common.ui.list.menu-list-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, rest, children));
const $51e7460acbb65361$export$fa71ab09534e6447 = ({ isOpen: defaultIsOpen, isTriggerDisabled: isTriggerDisabled, isNested: isNested, isLoading: isLoading, isAsyncSearch: isAsyncSearch, showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty, label: label, toggleLabel: toggleLabel, buttonType: buttonType, values: values, selectedValues: selectedValueIds, onChange: onChange, onInputChange: onInputChange, onOpenChange: onOpenChange, noOptionsMessage: noOptionsMessage, menuGroupTitle: menuGroupTitle, inputValue: inputValue, maxSelectionAllowed: maxSelectionAllowed, maxSelectionReachedTooltip: maxSelectionReachedTooltip, onMouseEnterToTriggerButton: onMouseEnterToTriggerButton, CustomOptionLabel: CustomOptionLabel, placeholder: placeholder, shouldReturnFocus: shouldReturnFocus, ...footerProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const firstRender = (0, $5uXOq.useRef)(true);
    const options = (0, $5uXOq.useMemo)(()=>(0, $ijTad.getOptionsFromProps)({
            values: values,
            menuGroupTitle: menuGroupTitle
        }), [
        values,
        menuGroupTitle
    ]);
    const { optionsWithSelectedSection: optionsWithSelectedSection, updateSelectedOptionGroup: updateSelectedOptionGroup, shouldTrackExperimentEvents: shouldTrackExperimentEvents } = (0, $ijTad.useGetOptionsWithSelectedOptionGroup)();
    if (firstRender.current === true && defaultIsOpen === true && (0, $4R6GH.fg)('jira-make-it-easier-to-deselect-filter-items-gate')) updateSelectedOptionGroup({
        isOpen: defaultIsOpen,
        options: options,
        selectedValueIds: selectedValueIds
    });
    if (firstRender.current === true) firstRender.current = false;
    const { selectedIdLookup: selectedIdLookup, selectedOptions: selectedOptions } = (0, $5uXOq.useMemo)(()=>(0, $ijTad.getSelectedOptionsFromProps)({
            values: values,
            selectedValueIds: selectedValueIds
        }), [
        values,
        selectedValueIds
    ]);
    const previousSelectedCount = (0, $5uXOq.useRef)(selectedValueIds.length);
    /* Cannot return null here for async search as this would cause the
   * filter to disappear completely when fetch returns no results.
   */ if (!showMenuIfValuesAreEmpty && !isAsyncSearch && values.length === 0) return null;
    // ================= //
    // === Callbacks === //
    // ================= //
    const onChangeHandler = (selected)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange(selected);
        // Temporary analytics for the experiment
        if (shouldTrackExperimentEvents.current === true && (0, $4R6GH.fg)('jira-make-it-easier-to-deselect-filter-items-gate')) {
            if (selected.length > previousSelectedCount.current) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'filterItem',
                action: 'selected',
                actionSubjectId: 'listFilter'
            }));
            else if (selected.length < previousSelectedCount.current) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'filterItem',
                action: 'deselected',
                actionSubjectId: 'listFilter'
            }));
            previousSelectedCount.current = selected.length;
        }
    };
    const onOpenChangeHandler = (isOpen)=>{
        const analyticsEvent = createAnalyticsEvent((0, $8C9C3.OPEN_CHANGE_PAYLOAD));
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $8C9C3.OPEN_CHANGE_SUBJECT_ID));
        onOpenChange(isOpen);
        updateSelectedOptionGroup({
            isOpen: isOpen,
            options: options,
            selectedValueIds: selectedValueIds
        });
    };
    const isOptionDisabled = (option)=>selectedOptions.length >= maxSelectionAllowed && !selectedIdLookup.has(option.value.toString());
    // ============== //
    // === RENDER === //
    // ============== //
    // Select expects a function that returns a string, rather than a string primitive
    const getNoOptionsMessage = noOptionsMessage === undefined ? noOptionsMessage : ()=>noOptionsMessage;
    const renderTrigger = (popupProps)=>(0, $4R6GH.fg)('allow_jplat_filter_list_to_be_disabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Mv0u.default), {
            ...popupProps,
            isDisabled: isTriggerDisabled,
            shouldReturnFocus: shouldReturnFocus,
            buttonType: buttonType,
            label: label,
            selectedCount: selectedOptions.length,
            isNested: isNested,
            onMouseEnter: onMouseEnterToTriggerButton
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Mv0u.default), {
            ...popupProps,
            shouldReturnFocus: shouldReturnFocus,
            buttonType: buttonType,
            label: label,
            selectedCount: selectedOptions.length,
            isNested: isNested,
            onMouseEnter: onMouseEnterToTriggerButton
        });
    const renderFooter = ()=>(footerProps.showLink || footerProps.showPanelToggle) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dF38k.default), {
            label: label,
            toggleLabel: toggleLabel,
            ...footerProps
        });
    const renderOption = (option)=>{
        const { label: optionLabel, iconUrl: iconUrl, subLabel: subLabel, value: value } = option;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9hVL.default), {
            label: optionLabel,
            subLabel: subLabel,
            iconUrl: iconUrl,
            value: String(value),
            isDisabled: isOptionDisabled(option),
            maxSelectionReachedTooltip: maxSelectionReachedTooltip,
            CustomOptionLabel: CustomOptionLabel ?? (0, $d9hVL.DefaultOptionLabel)
        });
    };
    const onKeyDown = (event)=>{
        if (event.key === 'Escape') event.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9dFI.default), {
        "aria-label": `Select ${label} filters`,
        // testId="filters.common.ui.list.menu-list-wrapper"
        isMulti: true,
        isLoading: isLoading,
        backspaceRemovesValue: true,
        hideSelectedOptions: false,
        closeMenuOnSelect: false,
        defaultIsOpen: defaultIsOpen,
        options: optionsWithSelectedSection || options,
        value: selectedOptions,
        inputValue: inputValue,
        noOptionsMessage: getNoOptionsMessage,
        placeholder: placeholder ?? formatMessage((0, $73s29.default).placeholder),
        target: renderTrigger,
        footer: renderFooter(),
        formatOptionLabel: renderOption,
        components: {
            Option: (0, $itpgN.CheckboxOption),
            DropdownIndicator: null,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            MenuList: $51e7460acbb65361$var$MenuListWrapper
        },
        popperProps: {
            placement: isNested ? 'right-start' : 'bottom-start',
            // to render popup next to the trigger element to achieve DOM order
            strategy: 'fixed'
        },
        onChange: onChangeHandler,
        onInputChange: onInputChange,
        isOptionDisabled: isOptionDisabled,
        onMenuOpen: ()=>onOpenChangeHandler(true),
        onMenuClose: ()=>onOpenChangeHandler(false),
        onKeyDown: onKeyDown,
        ...(0, $ijTad.getSearchableProps)({
            isAsyncSearch: isAsyncSearch,
            optionsCount: values.length,
            isNested: isNested
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        styles: optionsWithSelectedSection ? {
            group: (base, props)=>{
                const borderStyles = props.data.label === formatMessage((0, $73s29.default).selectedItemsGroupLabel) ? {
                    borderBottom: `1px solid ${`var(--ds-border, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`}`
                } : {};
                return {
                    ...base,
                    ...borderStyles,
                    padding: 0
                };
            },
            groupHeading: (base, props)=>{
                if (props.data.label === formatMessage((0, $73s29.default).selectedItemsGroupLabel)) // Make the text screen reader only
                return 0, $dqoiX.visuallyHiddenStyles;
                return base;
            }
        } : undefined
    });
};
$51e7460acbb65361$export$fa71ab09534e6447.defaultProps = {
    isOpen: false,
    isNested: false,
    isTriggerDisabled: false,
    isLoading: false,
    isAsyncSearch: false,
    isPanelToggleChecked: false,
    showLink: false,
    showPanelToggle: false,
    showMenuIfValuesAreEmpty: false,
    useHrefForUrl: false,
    values: [],
    selectedValues: [],
    menuGroupTitle: undefined,
    noOptionsMessage: undefined,
    maxSelectionAllowed: Number.MAX_SAFE_INTEGER,
    url: undefined,
    linkTitle: undefined,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onLinkItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onMouseEnterToTriggerButton: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    toggleRef: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $51e7460acbb65361$export$2e2bcd8739ae039 = $51e7460acbb65361$export$fa71ab09534e6447;

});
parcelRegister("itpgN", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $f5875245cd0ad0c1$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $f5875245cd0ad0c1$export$82ab7168879267a7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6aY6N = parcelRequire("6aY6N");

var $iQHJo = parcelRequire("iQHJo");

function $f5875245cd0ad0c1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f5875245cd0ad0c1$var$getPrimitiveStyles = (props)=>{
    const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
    const baseStyles = {
        alignItems: 'center',
        backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : 'transparent',
        color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
        display: 'flex ',
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-200, 16px)",
        paddingTop: "var(--ds-space-050, 4px)",
        // This 'none' needs to be present to ensure that style is not applied when
        // the option is selected but not focused.
        boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`}` : 'none',
        ':active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: isFocused ? '2px solid transparent' : ''
        }
    };
    const augmentedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...getStyles('option', props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...baseStyles
    });
    const bemClasses = {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    };
    // maintain react-select API
    return [
        augmentedStyles,
        cx(bemClasses, className)
    ];
};
// the primary color represents the outer or background element
const $f5875245cd0ad0c1$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$8d43898f60b96a82})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
    else if (isActive) return `var(--ds-background-selected-pressed, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $829f609a65d26a98$export$e62e8919cca44969})`;
    else if (isFocused) return `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
    return `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
};
// the secondary color represents the radio dot or checkmark
const $f5875245cd0ad0c1$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
    else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
    else if (!isSelected) return 'transparent';
    return `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
};
// the border color surrounds the checkbox/radio
const $f5875245cd0ad0c1$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
    else if (isActive) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
    else if (isFocused) return `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
    return `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
};
const $f5875245cd0ad0c1$var$baseIconStyles = {
    name: "35x0q3",
    styles: "display:flex ;align-items:center;flex-shrink:0;padding-inline-end:var(--ds-space-050, 4px);& svg rect, & svg circle:first-of-type{stroke-linejoin:round;stroke-width:var(--ds-border-width, 1px);}"
};
const $f5875245cd0ad0c1$var$baseOptionStyles = {
    name: "16e0ede",
    styles: "flex-grow:1;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
};
// eslint-disable-next-line @repo/internal/react/no-class-components
class $f5875245cd0ad0c1$var$ControlOption extends (0, $5uXOq.Component) {
    render() {
        const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
        // prop assignment
        const props = {
            ...innerProps,
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            onMouseLeave: this.onMouseLeave
        };
        const [styles, classes] = $f5875245cd0ad0c1$var$getPrimitiveStyles({
            getStyles: getStyles,
            ...rest
        });
        return(// These need to remain this way because `react-select` passes props with
        // styles inside, and that must be done dynamically.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: styles,
            className: classes,
            ref: innerRef,
            ...props
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $f5875245cd0ad0c1$var$baseIconStyles,
                // Here we are adding a border to the Checkbox and Radio SVG icons
                // This is an a11y fix for Select only for now but it may be rolled
                // into the `@atlaskit/icon` package's Checkbox and Radio SVGs later
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                {
                    // This can eventually be changed to static styles that are
                    // applied conditionally (e.g. `isActive && activeBorderStyles`),
                    // but considering there are multiple instances of `react-select`
                    // requiring styles to be generated dynamically, it seemed like a
                    // low priority.
                    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
                    '& svg rect, & svg circle:first-of-type': {
                        stroke: $f5875245cd0ad0c1$var$getBorderColor({
                            ...this.props,
                            ...this.state
                        })
                    }
                }
            ]
        }, !!Icon ? /*#__PURE__*/ (0, $f8Sb3.jsx)(Icon, {
            label: "",
            primaryColor: $f5875245cd0ad0c1$var$getPrimaryColor({
                ...this.props,
                ...this.state
            }),
            secondaryColor: $f5875245cd0ad0c1$var$getSecondaryColor({
                ...this.props,
                ...this.state
            }),
            isFacadeDisabled: true
        }) : null), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $f5875245cd0ad0c1$var$baseOptionStyles
        }, children)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isActive: false
        };
        this.onMouseDown = ()=>this.setState({
                isActive: true
            });
        this.onMouseUp = ()=>this.setState({
                isActive: false
            });
        this.onMouseLeave = ()=>this.setState({
                isActive: false
            });
    }
}
const $f5875245cd0ad0c1$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)($f5875245cd0ad0c1$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($6aY6N))),
        ...props
    });
const $f5875245cd0ad0c1$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons, @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)($f5875245cd0ad0c1$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($iQHJo))),
        ...props
    });

});
parcelRegister("6aY6N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47f24d9003b82760$var$_react = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $47f24d9003b82760$var$_checkboxChecked = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("aoKYM")));
function $47f24d9003b82760$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $47f24d9003b82760$var$CheckboxIcon = (props)=>/*#__PURE__*/ $47f24d9003b82760$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $47f24d9003b82760$var$_checkboxChecked.default
    }));
$47f24d9003b82760$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $47f24d9003b82760$var$_default = module.exports.default = $47f24d9003b82760$var$CheckboxIcon;

});
parcelRegister("aoKYM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d440225cc59c6a59918c0efc489d2095>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79209663d32c0c44$var$_react = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $79209663d32c0c44$var$_UNSAFE_baseNew = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $79209663d32c0c44$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $79209663d32c0c44$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $79209663d32c0c44$var$_react.default.createElement($79209663d32c0c44$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$79209663d32c0c44$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $79209663d32c0c44$var$_default = module.exports.default = $79209663d32c0c44$var$CheckboxCheckedIcon;

});


parcelRegister("iQHJo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db8f016a0af5fda9$var$_react = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $db8f016a0af5fda9$var$_radioChecked = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("kqGQn")));
function $db8f016a0af5fda9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $db8f016a0af5fda9$var$RadioIcon = (props)=>/*#__PURE__*/ $db8f016a0af5fda9$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $db8f016a0af5fda9$var$_radioChecked.default
    }));
$db8f016a0af5fda9$var$RadioIcon.displayName = 'RadioIcon';
var $db8f016a0af5fda9$var$_default = module.exports.default = $db8f016a0af5fda9$var$RadioIcon;

});
parcelRegister("kqGQn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa46e6d801ee3a3fb5cceaf32be49fab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $edf7783e719984ba$var$_react = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $edf7783e719984ba$var$_UNSAFE_baseNew = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $edf7783e719984ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "RadioChecked".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for the selected state of radio controls.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $edf7783e719984ba$var$RadioCheckedIcon = (props)=>/*#__PURE__*/ $edf7783e719984ba$var$_react.default.createElement($edf7783e719984ba$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
    }, props));
$edf7783e719984ba$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
var $edf7783e719984ba$var$_default = module.exports.default = $edf7783e719984ba$var$RadioCheckedIcon;

});



parcelRegister("8C9C3", function(module, exports) {

$parcel$export(module.exports, "FILTER_MENU_MIN_WIDTH", () => $e9228ce7bf573a8c$export$84ae3fb9fdba8a12);
$parcel$export(module.exports, "FILTER_MENU_MIN_WIDTH_ON_NESTED", () => $e9228ce7bf573a8c$export$920d89f17cd2fe3d);
$parcel$export(module.exports, "FILTER_MENU_MAX_WIDTH", () => $e9228ce7bf573a8c$export$6ea791ab71b8fa00);
$parcel$export(module.exports, "FILTER_SEARCH_THRESHOLD", () => $e9228ce7bf573a8c$export$1d287c6a8b81eb5b);
$parcel$export(module.exports, "OPEN_CHANGE_PAYLOAD", () => $e9228ce7bf573a8c$export$2f5981b7dbafe3a4);
$parcel$export(module.exports, "OPEN_CHANGE_SUBJECT_ID", () => $e9228ce7bf573a8c$export$b94e5dc1a8a1409);
$parcel$export(module.exports, "EXPERIMENT_MAKE_IT_EASIER_TO_DESELECT_FILTER_ITEMS_THRESHOLD", () => $e9228ce7bf573a8c$export$f63317e791502e67);

var $gwIPs = parcelRequire("gwIPs");
const $e9228ce7bf573a8c$export$84ae3fb9fdba8a12 = (0, $gwIPs.gridSize) * 21;
const $e9228ce7bf573a8c$export$920d89f17cd2fe3d = (0, $gwIPs.gridSize) * 25;
const $e9228ce7bf573a8c$export$6ea791ab71b8fa00 = (0, $gwIPs.gridSize) * 48;
const $e9228ce7bf573a8c$export$1d287c6a8b81eb5b = 9;
const $e9228ce7bf573a8c$export$2f5981b7dbafe3a4 = {
    action: 'clicked',
    actionSubject: 'dropdownMenu'
};
const $e9228ce7bf573a8c$export$b94e5dc1a8a1409 = 'filterList';
const $e9228ce7bf573a8c$export$f63317e791502e67 = 9;

});

parcelRegister("dF38k", function(module, exports) {

$parcel$export(module.exports, "default", () => $2deb009ebf7ebceb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8zOmE = parcelRequire("8zOmE");

var $8wifS = parcelRequire("8wifS");

var $l6YPM = parcelRequire("l6YPM");
const $2deb009ebf7ebceb$var$FilterListFooter = ({ isPanelToggleChecked: isPanelToggleChecked, showLink: showLink, showPanelToggle: showPanelToggle, useHrefForUrl: useHrefForUrl, url: url, label: label, toggleLabel: toggleLabel, linkTitle: linkTitle, toggleRef: toggleRef, onTogglePanel: onTogglePanel, onLinkItemClick: onLinkItemClick })=>{
    const onToggleHandler = (_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
        onTogglePanel();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (showPanelToggle || showLink && url && linkTitle) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2deb009ebf7ebceb$var$HorizontalSeparator, null), showPanelToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2deb009ebf7ebceb$var$PanelToggleContainer, {
        "data-testid": "filters.common.ui.list.footer.panel-toggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l6YPM.default), {
        label: toggleLabel || label,
        panelType: label,
        isChecked: isPanelToggleChecked,
        toggleRef: toggleRef,
        onToggle: onToggleHandler
    })), showLink && url && linkTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wifS.default), {
        url: url,
        linkTitle: linkTitle,
        onClick: onLinkItemClick,
        useHref: useHrefForUrl
    }));
};
$2deb009ebf7ebceb$var$FilterListFooter.defaultProps = {
    url: undefined,
    linkTitle: undefined,
    showPanel: false,
    showLink: false,
    toggleRef: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $2deb009ebf7ebceb$export$2e2bcd8739ae039 = $2deb009ebf7ebceb$var$FilterListFooter;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2deb009ebf7ebceb$var$HorizontalSeparator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "hr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itglyw _4t3iv77o _bfhkyucn _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $2deb009ebf7ebceb$var$PanelToggleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4wux3 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8wifS", function(module, exports) {

$parcel$export(module.exports, "default", () => $8743d62747e29a3c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $8oe80 = parcelRequire("8oe80");

var $8zOmE = parcelRequire("8zOmE");

var $dIdda = parcelRequire("dIdda");
const $8743d62747e29a3c$var$DropdownItem = (0, $8oe80.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $6B7KL.default));
const $8743d62747e29a3c$var$linkWrapperStyles = null;
const $8743d62747e29a3c$export$532cb6865ebe8946 = ({ url: url, linkTitle: linkTitle, onClick: onClick, useHref: useHref = false })=>{
    const { push: push } = (0, $dIdda.useRouterActions)();
    const onDropdownClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clickLinkFromFilters');
        onClick && onClick();
        if (!useHref) push(url);
    }, [
        useHref,
        onClick,
        push,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "menu",
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bsb1osq _n3td1b66 _n3ag1osq _1i3qd8e8 _hjpp1osq _c24d81pi"
        ])
    }, useHref ? /* @ts-expect-error - Type '(event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8743d62747e29a3c$var$DropdownItem, {
        href: url,
        onClick: onDropdownClick
    }, linkTitle) : /* @ts-expect-error - Type '(event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8743d62747e29a3c$var$DropdownItem, {
        onClick: onDropdownClick
    }, linkTitle));
};
var $8743d62747e29a3c$export$2e2bcd8739ae039 = $8743d62747e29a3c$export$532cb6865ebe8946;

});

parcelRegister("l6YPM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ad247e508ffc141$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $lj8SI = parcelRequire("lj8SI");

var $dTlW6 = parcelRequire("dTlW6");

var $8oe80 = parcelRequire("8oe80");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $3XFdo = parcelRequire("3XFdo");

var $gCuaO = parcelRequire("gCuaO");
const $4ad247e508ffc141$var$TOGGLE_CHECKBOX_ID = 'filters.common.ui.list.panel-toggle.toggle-checkbox';
const $4ad247e508ffc141$var$TOGGLE_HINT_ID = 'filters.common.ui.list.panel-toggle.toggle-hint';
const $4ad247e508ffc141$var$PanelToggle = (props)=>{
    const { isChecked: isChecked, panelType: panelType, onToggle: onToggle, ariaLabel: ariaLabel, intl: { formatMessage: formatMessage }, toggleRef: toggleRef = null, label: label } = props;
    const panelToggleKeyboardShortcut = (0, $3XFdo.getKeyboardShortcutForPanel)(panelType);
    const toggleLabel = label || formatMessage((0, $gCuaO.default).toggleLabel, {
        panelType: panelType
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ad247e508ffc141$var$PanelToggleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ad247e508ffc141$var$PanelToggleControl, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        label: ariaLabel,
        id: $4ad247e508ffc141$var$TOGGLE_CHECKBOX_ID,
        ref: toggleRef,
        onChange: onToggle,
        isChecked: isChecked,
        testId: "filters.common.ui.list.panel-toggle.panel-toggle",
        descriptionId: $4ad247e508ffc141$var$TOGGLE_HINT_ID
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ad247e508ffc141$var$PanelToggleLabel, {
        htmlFor: $4ad247e508ffc141$var$TOGGLE_CHECKBOX_ID
    }, toggleLabel)), panelToggleKeyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ad247e508ffc141$var$PanelToggleHint, {
        id: $4ad247e508ffc141$var$TOGGLE_HINT_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $gCuaO.default).toggleHint,
        values: {
            kbd: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), null, chunks),
            key: panelToggleKeyboardShortcut
        }
    })));
};
$4ad247e508ffc141$var$PanelToggle.defaultProps = {
    isChecked: false,
    panelType: '',
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $4ad247e508ffc141$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $8RXs9.default), (0, $5uXOq.memo), (0, $8oe80.default)('filterPanelToggle', {
    onToggle: 'toggled'
}))($4ad247e508ffc141$var$PanelToggle);
const $4ad247e508ffc141$var$PanelToggleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ad247e508ffc141$var$PanelToggleControl = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ad247e508ffc141$var$PanelToggleLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _18u0v77o _1reo15vq _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ad247e508ffc141$var$PanelToggleHint = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1wmz _o5721q9c _11c8qk37 _19pkidpf _19bv12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3XFdo", function(module, exports) {

$parcel$export(module.exports, "getKeyboardShortcutForPanel", () => $5bd9980697730d58$export$fa36ece4b5d88abc);

const $5bd9980697730d58$var$panelShortcuts = {
    Epic: (0, $570f28ac9bf58edd$export$9b094cdf6fd7589e),
    Version: (0, $570f28ac9bf58edd$export$6f416a1fb11a53d9)
};
const $5bd9980697730d58$export$fa36ece4b5d88abc = (panelType)=>$5bd9980697730d58$var$panelShortcuts[panelType];

});
const $570f28ac9bf58edd$export$a10c132b86ae798b = 'Epic';
const $570f28ac9bf58edd$export$41073ac826c57195 = 'Version';
const $570f28ac9bf58edd$export$9b094cdf6fd7589e = 'E';
const $570f28ac9bf58edd$export$6f416a1fb11a53d9 = 'V';


parcelRegister("gCuaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2063ebcfe536a9b7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2063ebcfe536a9b7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    toggleAccessibilityLabel: {
        "id": "software-filters.common.list.panel-toggle.toggle-accessibility-label",
        "defaultMessage": "Toggle panel"
    },
    toggleLabel: {
        "id": "software-filters.common.list.panel-toggle.toggle-label",
        "defaultMessage": "{panelType} panel"
    },
    toggleHint: {
        "id": "software-filters.common.list.panel-toggle.toggle-hint",
        "defaultMessage": "Press <kbd>{key}</kbd> to open and close"
    }
});

});



parcelRegister("73s29", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a49ecd68dc207cc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6a49ecd68dc207cc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "software-filters.common.list.placeholder",
        "defaultMessage": "Search filters\u2026"
    },
    anounceMessage: {
        "id": "software-filters.common.list.anounce-message",
        "defaultMessage": "When selecting from the {field} filter, content in the backlog board will automatically update"
    },
    selectedItemsGroupLabel: {
        "id": "software-filters.common.list.selected-items-group-label",
        "defaultMessage": "Selected Items"
    }
});

});

parcelRegister("d9hVL", function(module, exports) {

$parcel$export(module.exports, "DefaultOptionLabel", () => $3a4e6a305ebc1d35$export$86f820b2f37564e5);
$parcel$export(module.exports, "default", () => $3a4e6a305ebc1d35$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");
const $3a4e6a305ebc1d35$export$86f820b2f37564e5 = ({ label: label, iconUrl: iconUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, iconUrl !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a4e6a305ebc1d35$var$Icon, {
        src: iconUrl,
        role: "presentation"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a4e6a305ebc1d35$var$SelectOptionLabel, null, label));
const $3a4e6a305ebc1d35$var$ListFilterOption = ({ label: label, subLabel: subLabel, iconUrl: iconUrl, value: value, maxSelectionReachedTooltip: maxSelectionReachedTooltip, isDisabled: isDisabled, CustomOptionLabel: CustomOptionLabel })=>{
    const content = isDisabled && maxSelectionReachedTooltip ? maxSelectionReachedTooltip : label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a4e6a305ebc1d35$var$SelectOptionWrapper, {
        "data-testid": "filters.common.ui.list.option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomOptionLabel, {
        label: label,
        value: value,
        iconUrl: iconUrl
    })), subLabel !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a4e6a305ebc1d35$var$SelectOptionSubLabel, null, subLabel));
};
$3a4e6a305ebc1d35$var$ListFilterOption.defaultProps = {
    iconUrl: undefined,
    isDisabled: false
};
var $3a4e6a305ebc1d35$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($3a4e6a305ebc1d35$var$ListFilterOption);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a4e6a305ebc1d35$var$SelectOptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1y6m",
            __cmplp.className
        ])
    });
});
const $3a4e6a305ebc1d35$var$SelectOptionLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $3a4e6a305ebc1d35$var$SelectOptionSubLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _11c81vlj _syaz1e9r",
            __cmplp.className
        ])
    });
});
const $3a4e6a305ebc1d35$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_zb0g5d": (0, $lD23V.default)((0, $gwIPs.layout).issueIconSize, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1bsbwrp2 _4t3iwrp2 _u5f3u2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4Mv0u", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd436e148f99ab3e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $16T6Y = parcelRequire("16T6Y");

var $fVnbM = parcelRequire("fVnbM");

var $6Ingq = parcelRequire("6Ingq");

var $ebd3R = parcelRequire("ebd3R");

var $hORKG = parcelRequire("hORKG");

var $3dGN0 = parcelRequire("3dGN0");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $7mPT9 = parcelRequire("7mPT9");

var $iXVV6 = parcelRequire("iXVV6");

var $dCm1o = parcelRequire("dCm1o");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bd436e148f99ab3e$var$FilterListTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isOpen: isOpen, isNested: isNested, isDisabled: isDisabled, label: label, buttonType: buttonType, selectedCount: selectedCount, onMouseEnter: onMouseEnter, shouldReturnFocus: shouldReturnFocus, ...popupProps }, ref)=>{
    const testId = `filters.common.ui.list.${label.toLowerCase().replace(/ /g, '-')}-filter`;
    const primaryColor = isOpen ? "var(--ds-icon-selected, #0052CC)" : "var(--ds-icon, #44546F)";
    const IconComponent = isNested ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
        label: "",
        color: primaryColor,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R))),
        LEGACY_primaryColor: primaryColor
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
        label: "",
        color: primaryColor,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))),
        LEGACY_primaryColor: primaryColor
    });
    const inputRef = (0, $5uXOq.useRef)();
    const isMounted = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldReturnFocus && buttonType === 'QuickFilters' && isMounted.current) inputRef?.current?.focus();
        else isMounted.current = true;
    }, [
        shouldReturnFocus,
        buttonType
    ]);
    const conditionalRef = buttonType === 'QuickFilters' ? (0, $7mPT9.mergeRefs)(ref, inputRef) : ref;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            !isNested && $bd436e148f99ab3e$var$containerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "dropDownMenu",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            filterType: label
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd436e148f99ab3e$var$StyledButton, {
        ...popupProps,
        ref: conditionalRef,
        isNested: isNested,
        isSelected: isOpen || (0, $dCm1o.isVisualRefreshEnabled)() && selectedCount > 0,
        shouldFitContainer: isNested,
        appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onMouseEnter: onMouseEnter,
        iconAfter: (0, $dCm1o.isVisualRefreshEnabled)() && selectedCount > 0 ? undefined : IconComponent,
        ...(0, $4R6GH.fg)('allow_jplat_filter_list_to_be_disabled') && {
            isDisabled: isDisabled || false
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label,
        hideTooltipOnClick: true,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd436e148f99ab3e$var$TriggerContainer, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd436e148f99ab3e$var$TriggerLabel, null, label), selectedCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd436e148f99ab3e$var$CountWrapper, {
        isNested: isNested,
        "data-testid": `${testId}-badge`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        appearance: "primary"
    }, selectedCount)))))));
});
var $bd436e148f99ab3e$export$2e2bcd8739ae039 = $bd436e148f99ab3e$var$FilterListTrigger;
const $bd436e148f99ab3e$var$containerStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $bd436e148f99ab3e$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isNested && "_2rkogrf3 _u5f3ns44 _1bg412gs",
            __cmplp.className
        ])
    });
});
const $bd436e148f99ab3e$var$CountWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNested: isNested, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l",
            __cmplp.isNested ? "_18u01wug _19bvftgi" : "_19bv1y44",
            __cmplp.className
        ])
    });
});
const $bd436e148f99ab3e$var$TriggerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $bd436e148f99ab3e$var$TriggerLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f68cl _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7mPT9", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $d1da29f25d5b5e0a$export$c9058316764c140e);
$parcel$export(module.exports, "default", () => $d1da29f25d5b5e0a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $d1da29f25d5b5e0a$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref.current = value; // eslint-disable-line no-param-reassign
        });
    };
}
function $d1da29f25d5b5e0a$export$2e2bcd8739ae039(...refs) {
    return (0, $5uXOq.useMemo)(()=>$d1da29f25d5b5e0a$export$c9058316764c140e(...refs), // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}

});


parcelRegister("ijTad", function(module, exports) {

$parcel$export(module.exports, "getOptionsFromProps", () => $a5603fd49981b3bf$export$ecd68164c475a713);
$parcel$export(module.exports, "getSelectedOptionsFromProps", () => $a5603fd49981b3bf$export$94d5b7a6f69b418);
$parcel$export(module.exports, "getSearchableProps", () => $a5603fd49981b3bf$export$62d9d395b3dd2ae8);
$parcel$export(module.exports, "useGetOptionsWithSelectedOptionGroup", () => $a5603fd49981b3bf$export$2729924204b6e540);

var $5uXOq = parcelRequire("5uXOq");

var $5JAlL = parcelRequire("5JAlL");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8C9C3 = parcelRequire("8C9C3");

var $73s29 = parcelRequire("73s29");
const $a5603fd49981b3bf$var$isValueGroupOption = (value)=>'options' in value;
const $a5603fd49981b3bf$export$67e7296d7bc3550c = (values)=>values.every((value)=>!$a5603fd49981b3bf$var$isValueGroupOption(value));
const $a5603fd49981b3bf$export$ecd68164c475a713 = ({ values: values, menuGroupTitle: menuGroupTitle })=>{
    // menuGroupTitle should be deprecated
    if (menuGroupTitle && $a5603fd49981b3bf$export$67e7296d7bc3550c(values)) return [
        {
            label: menuGroupTitle,
            options: values
        }
    ];
    return values;
};
const $a5603fd49981b3bf$export$94d5b7a6f69b418 = ({ values: values, selectedValueIds: selectedValueIds })=>{
    const selectedIdLookup = selectedValueIds.reduce((acc, cur)=>{
        acc.add(cur);
        return acc;
    }, new Set());
    const valuesToLook = values.flatMap((value)=>$a5603fd49981b3bf$var$isValueGroupOption(value) ? value.options : [
            value
        ]);
    const selectedOptions = valuesToLook.filter(({ value: value })=>selectedIdLookup.has(value));
    return {
        selectedIdLookup: selectedIdLookup,
        selectedOptions: selectedOptions
    };
};
const $a5603fd49981b3bf$export$62d9d395b3dd2ae8 = ({ optionsCount: optionsCount, isAsyncSearch: isAsyncSearch, defaultSearchThreshold: defaultSearchThreshold = (0, $8C9C3.FILTER_SEARCH_THRESHOLD), isNested: isNested })=>{
    // Search input should always be visible for async selects
    const searchThreshold = isAsyncSearch ? -1 : defaultSearchThreshold;
    const isSearchable = optionsCount > searchThreshold;
    // Due to renderToParent the grid size will change so, incresing the min width for low resolutions
    const filterMenuMinWidth = isNested ? (0, $8C9C3.FILTER_MENU_MIN_WIDTH_ON_NESTED) : (0, $8C9C3.FILTER_MENU_MIN_WIDTH);
    const maxMenuWidth = (0, $8C9C3.FILTER_MENU_MAX_WIDTH);
    // Set the min and max width to be the same so updated search results don't cause the menu to resize
    const minMenuWidth = isSearchable ? maxMenuWidth : filterMenuMinWidth;
    // Don't filter anything on the frontend for async selects
    const filter = (0, $5JAlL.createFilter)({
        stringify: (option)=>option.label
    });
    const filterOption = isAsyncSearch ? undefined : filter;
    return {
        minMenuWidth: minMenuWidth,
        maxMenuWidth: maxMenuWidth,
        searchThreshold: searchThreshold,
        filterOption: filterOption
    };
};
const $a5603fd49981b3bf$export$2729924204b6e540 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [optionsWithSelectedSection, setOptionsWithSelectedSection] = (0, $5uXOq.useState)(null);
    const shouldTrackExperimentEvents = (0, $5uXOq.useRef)(false);
    const updateSelectedOptionGroup = ({ isOpen: isOpen, options: options, selectedValueIds: selectedValueIds })=>{
        if ((0, $4R6GH.fg)('jira-make-it-easier-to-deselect-filter-items-gate')) {
            if (// To avoid annoyingly shifting items around while the user has the dropdown open, when only shuffle items on an opening
            isOpen === true && // At least for now, scope this change so we only have a selected items section if the options don't have any existing groupings
            $a5603fd49981b3bf$export$67e7296d7bc3550c(options) && (options.length > (0, $8C9C3.EXPERIMENT_MAKE_IT_EASIER_TO_DESELECT_FILTER_ITEMS_THRESHOLD) || optionsWithSelectedSection !== null)) {
                if ((0, $6s1PB.expVal)('jira-make-it-easier-to-deselect-filter-items', 'isEnabled', false)) {
                    if (selectedValueIds.length === 0 || options.length <= (0, $8C9C3.EXPERIMENT_MAKE_IT_EASIER_TO_DESELECT_FILTER_ITEMS_THRESHOLD)) {
                        setOptionsWithSelectedSection(null);
                        shouldTrackExperimentEvents.current = false;
                    } else {
                        // reorder selected parents to be at the top
                        const selected = options.filter((option)=>selectedValueIds.includes(option.value));
                        const unselected = options.filter((option)=>!selectedValueIds.includes(option.value));
                        const optionsWithSelectedOptionGroup = [
                            {
                                label: formatMessage((0, $73s29.default).selectedItemsGroupLabel),
                                options: selected
                            },
                            {
                                label: '',
                                options: unselected
                            }
                        ];
                        setOptionsWithSelectedSection(optionsWithSelectedOptionGroup);
                        shouldTrackExperimentEvents.current = true;
                    }
                } else if (selectedValueIds.length === 0 || options.length <= (0, $8C9C3.EXPERIMENT_MAKE_IT_EASIER_TO_DESELECT_FILTER_ITEMS_THRESHOLD)) shouldTrackExperimentEvents.current = false;
                else shouldTrackExperimentEvents.current = true;
            }
        }
    };
    return {
        optionsWithSelectedSection: optionsWithSelectedSection,
        updateSelectedOptionGroup: updateSelectedOptionGroup,
        shouldTrackExperimentEvents: shouldTrackExperimentEvents
    };
};

});


parcelRegister("cTznA", function(module, exports) {

$parcel$export(module.exports, "default", () => $798caf1923191bc1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $798caf1923191bc1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.component.label",
        "defaultMessage": "Components"
    }
});

});


parcelRegister("8bg0N", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a3ccb8efb497741$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $96s6B = parcelRequire("96s6B");

var $1k18w = parcelRequire("1k18w");

var $kIDH3 = parcelRequire("kIDH3");
const $6a3ccb8efb497741$var$DependenciesFilter = ({ isOpen: isOpen = false, onChange: // only used for VR testing purposes
onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), selectedValues: selectedValues = [] })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onChangeValue = (0, $5uXOq.useCallback)((entries)=>{
        onChange(entries.map(({ value: value })=>value));
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        isOpen: isOpen,
        label: formatMessage((0, $1k18w.default).label),
        onChange: onChangeValue,
        values: [
            {
                label: formatMessage((0, $1k18w.default).dependencyType),
                options: [
                    {
                        label: formatMessage((0, $1k18w.default).offTrack),
                        value: (0, $kIDH3.DependencyFilterOption).OFF_TRACK
                    },
                    {
                        label: formatMessage((0, $1k18w.default).onTrack),
                        value: (0, $kIDH3.DependencyFilterOption).ON_TRACK
                    }
                ]
            }
        ],
        selectedValues: selectedValues
    });
};
$6a3ccb8efb497741$var$DependenciesFilter.displayName = 'DependenciesFilter';
$6a3ccb8efb497741$var$DependenciesFilter.whyDidYouRender = true;
var $6a3ccb8efb497741$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($6a3ccb8efb497741$var$DependenciesFilter);

});
parcelRegister("1k18w", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6bab5f988dfca5a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b6bab5f988dfca5a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.dependencies.label",
        "defaultMessage": "Dependencies"
    },
    dependencyType: {
        "id": "software-filters.filters.dependencies.dependency-type",
        "defaultMessage": "Dependency type"
    },
    offTrack: {
        "id": "software-filters.filters.dependencies.off-track",
        "defaultMessage": "Off-track"
    },
    onTrack: {
        "id": "software-filters.filters.dependencies.on-track",
        "defaultMessage": "On-track"
    }
});

});


parcelRegister("kgqZV", function(module, exports) {

$parcel$export(module.exports, "default", () => $089e7ae732d57721$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4Xk2W = parcelRequire("4Xk2W");

var $8Rkzz = parcelRequire("8Rkzz");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $2Ywmz = parcelRequire("2Ywmz");

var $3uePO = parcelRequire("3uePO");

var $96s6B = parcelRequire("96s6B");

var $9vXUM = parcelRequire("9vXUM");

var $BZHAT = parcelRequire("BZHAT");
const $089e7ae732d57721$var$EMPTY_ARRAY = [];
const $089e7ae732d57721$var$GoalCustomOptionLabel = ({ label: label, value: value })=>{
    const goalContext = (0, $5uXOq.useContext)((0, $9vXUM.GoalFilterContext));
    const goalState = goalContext.goals[value]?.state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.050",
        alignBlock: "center",
        alignInline: "start",
        grow: "fill"
    }, goalState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Ywmz.GoalIcon), {
        state: goalState.value
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: $089e7ae732d57721$var$goalLabelStyles
    }, label), goalState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3uePO.GoalTracker), {
        label: goalState.label,
        score: goalState.score,
        value: goalState.value
    }));
};
const $089e7ae732d57721$var$GoalFilter = ({ goals: goals, selectedGoals: selectedGoals = $089e7ae732d57721$var$EMPTY_ARRAY, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onInputChange: onInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onOpenChange: onOpenChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onMouseEnterToTriggerButton: onMouseEnterToTriggerButton = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty = false, inputValue: inputValue, isLoading: isLoading = false, isNested: isNested = false, isOpen: isOpen = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>goals.map((goal)=>({
                label: goal.name,
                value: goal.id,
                data: goal.state
            })), [
        goals
    ]);
    const goalsHash = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(goals, (goal)=>goal.id), [
        goals
    ]);
    const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9vXUM.GoalFilterContext).Provider, {
        value: {
            goals: goalsHash
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $BZHAT.default).label),
        values: values,
        isOpen: isOpen,
        selectedValues: selectedGoals,
        isPanelToggleChecked: false,
        onChange: onChangeCallback,
        inputValue: inputValue,
        isLoading: isLoading,
        onInputChange: onInputChange,
        onOpenChange: onOpenChange,
        noOptionsMessage: formatMessage((0, $BZHAT.default).noGoals),
        showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty,
        isAsyncSearch: false,
        isNested: isNested,
        onMouseEnterToTriggerButton: onMouseEnterToTriggerButton,
        placeholder: formatMessage((0, $BZHAT.default).placeholder),
        CustomOptionLabel: $089e7ae732d57721$var$GoalCustomOptionLabel,
        showPanelToggle: false,
        showLink: false,
        useHrefForUrl: false,
        maxSelectionAllowed: Number.MAX_SAFE_INTEGER,
        onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onLinkItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        toggleRef: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }));
};
var $089e7ae732d57721$export$2e2bcd8739ae039 = $089e7ae732d57721$var$GoalFilter;
const $089e7ae732d57721$var$goalLabelStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("2Ywmz", function(module, exports) {

$parcel$export(module.exports, "GoalIcon", () => $7be6a95607230c54$export$134cbcd70c6693b8);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $6yf6t = parcelRequire("6yf6t");

var $4UrMe = parcelRequire("4UrMe");
const $7be6a95607230c54$var$GoalGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9ZM18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9ZM13 9C13 11.2091 11.2091 13 9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9Z",
        fillRule: "evenodd"
    })));
const $7be6a95607230c54$export$134cbcd70c6693b8 = ({ state: state, ariaLabel: ariaLabel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7be6a95607230c54$var$iconContainerStyles,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $6yf6t.mapStateToBgColor)(state)
        },
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $7be6a95607230c54$var$GoalGlyph,
        label: formatMessage((0, $4UrMe.default).goalIconLabel),
        primaryColor: (0, $6yf6t.mapStateToColor)(state)
    }));
};
const $7be6a95607230c54$var$iconContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    minWidth: '24px',
    height: '24px',
    borderRadius: 'border.radius',
    marginRight: 'space.025'
});

});
parcelRegister("6yf6t", function(module, exports) {

$parcel$export(module.exports, "mapStateToBgColor", () => $6a435c3af325b8dc$export$931dac3fa53640b1);
$parcel$export(module.exports, "mapStateToColor", () => $6a435c3af325b8dc$export$163d1ee1b3b2aead);
$parcel$export(module.exports, "mapScoreToBgColor", () => $6a435c3af325b8dc$export$525ec0d5be9572a4);
$parcel$export(module.exports, "extractStatusLabelWithoutScore", () => $6a435c3af325b8dc$export$88bbcb3741dee92d);

const $6a435c3af325b8dc$export$931dac3fa53640b1 = (state)=>{
    switch(state){
        case 'off_track':
            return `var(--ds-background-accent-red-subtlest, ${(0, $829f609a65d26a98$exports).R50})`;
        case 'at_risk':
            return `var(--ds-background-accent-yellow-subtlest, ${(0, $829f609a65d26a98$exports).Y50})`;
        case 'on_track':
            return `var(--ds-background-accent-green-subtlest, ${(0, $829f609a65d26a98$exports).G50})`;
        case 'archived':
        case 'cancelled':
        case 'done':
        case 'paused':
        case 'pending':
        default:
            return `var(--ds-background-accent-gray-subtlest, ${(0, $829f609a65d26a98$exports).N20})`;
    }
};
const $6a435c3af325b8dc$export$163d1ee1b3b2aead = (state)=>{
    switch(state){
        case 'off_track':
            return `var(--ds-text-accent-red, ${(0, $829f609a65d26a98$exports).R500})`;
        case 'at_risk':
            return `var(--ds-text-accent-orange, ${(0, $829f609a65d26a98$exports).Y500})`;
        case 'on_track':
            return `var(--ds-text-accent-green, ${(0, $829f609a65d26a98$exports).G500})`;
        case 'archived':
        case 'cancelled':
        case 'done':
        case 'paused':
        case 'pending':
        default:
            return `var(--ds-text-accent-gray, ${(0, $829f609a65d26a98$exports).N500})`;
    }
};
const $6a435c3af325b8dc$export$525ec0d5be9572a4 = (score)=>{
    if (score < 0.4) return `var(--ds-background-danger-bold, ${(0, $829f609a65d26a98$exports).R500})`;
    if (score < 0.7) return `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y500})`;
    return `var(--ds-background-success-bold, ${(0, $829f609a65d26a98$exports).G500})`;
};
const $6a435c3af325b8dc$export$88bbcb3741dee92d = (fullLabel)=>fullLabel.split(' - ')[0];

});

parcelRegister("4UrMe", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ec31bd513378ade$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2ec31bd513378ade$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    goalIconLabel: {
        "id": "software-goals.goal.icon.goal-icon-label",
        "defaultMessage": "Goal"
    }
});

});


parcelRegister("3uePO", function(module, exports) {

$parcel$export(module.exports, "GoalTracker", () => $ec22661ff8271891$export$c0fdf469f92e8578);

var $5uXOq = parcelRequire("5uXOq");

var $6yf6t = parcelRequire("6yf6t");

var $aabh6 = parcelRequire("aabh6");

var $e0NSW = parcelRequire("e0NSW");
const $ec22661ff8271891$export$c0fdf469f92e8578 = ({ value: value, label: label, score: score })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0NSW.Tracker), {
        backgroundColor: (0, $6yf6t.mapStateToBgColor)(value),
        color: (0, $6yf6t.mapStateToColor)(value)
    }, (0, $6yf6t.extractStatusLabelWithoutScore)(label), score !== undefined && score !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aabh6.Score), {
        score: score
    }));

});
parcelRegister("aabh6", function(module, exports) {

$parcel$export(module.exports, "Score", () => $08dbd54fe256bc26$export$6735cf84ecd2736);

var $5uXOq = parcelRequire("5uXOq");

var $6yf6t = parcelRequire("6yf6t");

var $3b4jf = parcelRequire("3b4jf");
const $08dbd54fe256bc26$export$6735cf84ecd2736 = ({ score: score })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3b4jf.ScoreContainer), {
        backgroundColor: (0, $6yf6t.mapScoreToBgColor)(score)
    }, score);

});
parcelRegister("3b4jf", function(module, exports) {

$parcel$export(module.exports, "ScoreContainer", () => $c781656d37adaa64$export$32466e20de52fc97);
/* styled.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $c781656d37adaa64$export$32466e20de52fc97 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $lD23V.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _bfhk3qkl _syaz15cr _2rko1l7b _18u01b66 _1yt4otz2 _4t3i7vkz",
            __cmplp.className
        ])
    });
});

});


parcelRegister("e0NSW", function(module, exports) {

$parcel$export(module.exports, "Tracker", () => $5a7c474ebf7da8e1$export$254d9747e34ddc90);
/* styled.tsx generated by @compiled/babel-plugin v0.31.0 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $5a7c474ebf7da8e1$export$254d9747e34ddc90 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $lD23V.default)(__cmplp.backgroundColor),
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhk3qkl _2rko1l7b _1yt41b66 _11c81vlj _k48pmoej _syaz1cj8 _1p1dangw _3fcw1q9c _1e0c1ule _4t3i7vkz _vwz47vkz",
            __cmplp.className
        ])
    });
});

});


parcelRegister("9vXUM", function(module, exports) {

$parcel$export(module.exports, "GoalFilterContext", () => $c20e77c82f0ed08e$export$f656d92d95229cd2);

var $5uXOq = parcelRequire("5uXOq");
const $c20e77c82f0ed08e$export$f656d92d95229cd2 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    goals: {}
});

});

parcelRegister("BZHAT", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfb7fe3166051b6f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dfb7fe3166051b6f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noGoals: {
        "id": "software-filters.filters.goals.no-goals",
        "defaultMessage": "There are no matching goals"
    },
    placeholder: {
        "id": "software-filters.filters.goals.placeholder",
        "defaultMessage": "Choose goals"
    },
    label: {
        "id": "software-filters.filters.goals.label",
        "defaultMessage": "Goals"
    }
});

});


parcelRegister("efv79", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e07b1cd691dec67$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $g5X3G = parcelRequire("g5X3G");

var $96s6B = parcelRequire("96s6B");

var $4c4ZP = parcelRequire("4c4ZP");
const $7e07b1cd691dec67$var$IssueProjectFilter = ({ isOpen: isOpen = false, isNested: // only used for VR testing purposes
isNested = false, issueProjects: issueProjects = {}, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), selectedProjects: selectedProjects = [] })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>Object.values(issueProjects).map(({ avatar: avatar, id: id, name: name })=>({
                iconUrl: avatar,
                label: name,
                value: String(id)
            })).sort((a, b)=>a.label.localeCompare(b.label)), [
        issueProjects
    ]);
    const onChangeValue = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>(0, $g5X3G.toProjectId)(value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        isOpen: isOpen,
        isNested: isNested,
        label: formatMessage((0, $4c4ZP.default).label),
        onChange: onChangeValue,
        selectedValues: selectedProjects.map(String),
        values: values
    });
};
$7e07b1cd691dec67$var$IssueProjectFilter.displayName = 'IssueProjectFilter';
$7e07b1cd691dec67$var$IssueProjectFilter.whyDidYouRender = true;
var $7e07b1cd691dec67$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($7e07b1cd691dec67$var$IssueProjectFilter);

});
parcelRegister("4c4ZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $01676d3e9ff29bbf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $01676d3e9ff29bbf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.issue-project.label",
        "defaultMessage": "Project"
    }
});

});


parcelRegister("jKPI1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6442616aa336213b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $96s6B = parcelRequire("96s6B");

var $hF6jn = parcelRequire("hF6jn");
const $6442616aa336213b$var$IssueTypeGroupFilter = ({ isOpen: isOpen = false, issueTypeGroups: issueTypeGroups = [], selectedIssueTypes: selectedIssueTypes = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const issueTypeGroupByIssueType = (0, $5uXOq.useMemo)(()=>new Map(issueTypeGroups.flatMap((group)=>group.issueTypes.map((issueType)=>[
                    issueType,
                    group
                ]))), [
        issueTypeGroups
    ]);
    const issueTypeGroupByGroupKey = (0, $5uXOq.useMemo)(()=>new Map(issueTypeGroups.map((group)=>[
                group.key,
                group
            ])), [
        issueTypeGroups
    ]);
    const values = (0, $5uXOq.useMemo)(()=>issueTypeGroups.map((group)=>({
                label: group.name,
                value: group.key,
                iconUrl: group.iconUrl
            })), [
        issueTypeGroups
    ]);
    const selectGroupsByKeys = (0, $5uXOq.useCallback)((keys)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(keys.flatMap((key)=>issueTypeGroupByGroupKey.get(key)?.issueTypes).filter(Boolean), analyticAttributes);
    }, [
        onChange,
        issueTypeGroupByGroupKey,
        isNested
    ]);
    const selectedGroups = (0, $5uXOq.useMemo)(()=>Array.from(new Set(selectedIssueTypes.map((key)=>issueTypeGroupByIssueType.get(key)))), [
        issueTypeGroupByIssueType,
        selectedIssueTypes
    ]);
    const selectedGroupKeys = selectedGroups.map((group)=>group?.key).filter(Boolean);
    const selectedGroupsAllIssueTypes = selectedGroups.flatMap((group)=>group?.issueTypes).filter(Boolean);
    const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
        const entryValues = entries.map(({ value: value })=>value);
        selectGroupsByKeys(entryValues);
    }, [
        selectGroupsByKeys
    ]);
    // early exit if we have only one issue type group
    if (issueTypeGroups.length <= 1) return null;
    // if there's mismatch between the filters in the url and the issue groups, e.g. when the url is manually edited or when an issue of a new type is created, we would apply the whole group
    if (selectedGroupsAllIssueTypes.length !== selectedIssueTypes.length) {
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(selectedGroupsAllIssueTypes, analyticAttributes);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        isOpen: isOpen,
        label: formatMessage((0, $hF6jn.default).label),
        values: values,
        selectedValues: selectedGroupKeys,
        onChange: onChangeCallback,
        isNested: isNested
    });
};
$6442616aa336213b$var$IssueTypeGroupFilter.displayName = 'IssueTypeGroupFilter';
$6442616aa336213b$var$IssueTypeGroupFilter.whyDidYouRender = true;
var $6442616aa336213b$export$2e2bcd8739ae039 = $6442616aa336213b$var$IssueTypeGroupFilter;

});
parcelRegister("hF6jn", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d157749564d70c9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1d157749564d70c9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.issue-type-group.label",
        "defaultMessage": "Type"
    }
});

});


parcelRegister("hHL6f", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b5fa2dd02736e8c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $g5X3G = parcelRequire("g5X3G");

var $96s6B = parcelRequire("96s6B");

var $lcsGW = parcelRequire("lcsGW");
const $2b5fa2dd02736e8c$var$IssueTypeFilter = ({ issueTypes: issueTypes = [], selectedIssueTypes: selectedIssueTypes = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>issueTypes.map((issueType)=>({
                label: issueType.name,
                value: issueType.id,
                iconUrl: issueType.iconUrl
            })), [
        issueTypes
    ]);
    const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>(0, $g5X3G.toIssueTypeId)(entry.value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one issue type
    if (issueTypes.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $lcsGW.default).label),
        values: values,
        selectedValues: selectedIssueTypes.map(String),
        onChange: onChangeCallback,
        isNested: isNested
    });
};
const $2b5fa2dd02736e8c$var$IssueTypeFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($2b5fa2dd02736e8c$var$IssueTypeFilter);
$2b5fa2dd02736e8c$var$IssueTypeFilterComponent.displayName = 'IssueTypeFilter';
// @ts-expect-error TS2339: Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$2b5fa2dd02736e8c$var$IssueTypeFilterComponent.whyDidYouRender = true;
var $2b5fa2dd02736e8c$export$2e2bcd8739ae039 = $2b5fa2dd02736e8c$var$IssueTypeFilterComponent;

});
parcelRegister("lcsGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $418d852f97677c87$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $418d852f97677c87$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.issue-type.label",
        "defaultMessage": "Type"
    }
});

});


parcelRegister("2fsdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f5c968fce1f630e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $96s6B = parcelRequire("96s6B");

var $bvI90 = parcelRequire("bvI90");
const $2f5c968fce1f630e$var$LabelFilter = ({ labels: labels = [], selectedLabels: selectedLabels = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false, unassignedOption: unassignedOption })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>{
        const options = labels.map((label)=>({
                label: label,
                value: label
            }));
        unassignedOption && options.unshift(unassignedOption);
        return options;
    }, [
        labels,
        unassignedOption
    ]);
    const onChangeMapValues = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $bvI90.default).label),
        values: values,
        selectedValues: selectedLabels,
        onChange: onChangeMapValues,
        isNested: isNested
    });
};
const $2f5c968fce1f630e$var$LabelFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($2f5c968fce1f630e$var$LabelFilter);
$2f5c968fce1f630e$var$LabelFilterComponent.displayName = 'LabelFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$2f5c968fce1f630e$var$LabelFilterComponent.whyDidYouRender = true;
var $2f5c968fce1f630e$export$2e2bcd8739ae039 = $2f5c968fce1f630e$var$LabelFilterComponent;

});
parcelRegister("bvI90", function(module, exports) {

$parcel$export(module.exports, "default", () => $7299efb383111469$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7299efb383111469$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.label.label",
        "defaultMessage": "Label"
    }
});

});


parcelRegister("bLWKp", function(module, exports) {

$parcel$export(module.exports, "default", () => $31db5ca9c486657a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $az4zD = parcelRequire("az4zD");

var $iXVV6 = parcelRequire("iXVV6");

var $g5X3G = parcelRequire("g5X3G");

var $9pP0g = parcelRequire("9pP0g");

var $iDGXn = parcelRequire("iDGXn");

var $dIdda = parcelRequire("dIdda");

var $96s6B = parcelRequire("96s6B");

var $9oo3F = parcelRequire("9oo3F");
const $31db5ca9c486657a$var$ParentFilter = (props)=>{
    const { label: label, parents: parents, selectedParents: selectedParents, isToggleChecked: isToggleChecked, onTogglePanel: onTogglePanel, onInputChange: onInputChange, onOpenChange: onOpenChange, onMouseEnterToTriggerButton: onMouseEnterToTriggerButton, intl: { formatMessage: formatMessage }, showPanelToggle: showPanelToggle, showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty, inputValue: inputValue, isLoading: isLoading, isAsyncSearch: isAsyncSearch, isNested: isNested, isOpen: isOpen } = props;
    const [boardId] = (0, $dIdda.usePathParam)('boardId');
    const { toggleViewSetting: toggleViewSetting } = (0, $iDGXn.useViewSettingsActions)();
    const values = (0, $5uXOq.useMemo)(()=>parents.map((parent)=>({
                label: parent.name,
                value: parent.id,
                subLabel: parent.key
            })), [
        parents
    ]);
    const onChange = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        props.onChange(entries.map((entry)=>(0, $g5X3G.toIssueId)(entry.value)), analyticAttributes);
    }, [
        props,
        isNested
    ]);
    const handleTogglePanel = (0, $5uXOq.useCallback)(()=>{
        if (boardId) toggleViewSetting({
            boardId: Number(boardId),
            setting: (0, $9pP0g.ViewSetting).EPIC_PANEL
        });
        onTogglePanel();
    }, [
        boardId,
        onTogglePanel,
        toggleViewSetting
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "epicPanelToggle",
        attributes: {
            isOpen: !isToggleChecked,
            filterType: label
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: label,
        toggleLabel: formatMessage((0, $9oo3F.default).toggleLabel, {
            parentName: label?.toLowerCase()
        }),
        values: values,
        isOpen: isOpen,
        showPanelToggle: showPanelToggle,
        selectedValues: selectedParents.map(String),
        isPanelToggleChecked: isToggleChecked,
        onChange: onChange,
        inputValue: inputValue,
        isLoading: isLoading,
        onInputChange: onInputChange,
        onTogglePanel: handleTogglePanel,
        onOpenChange: onOpenChange,
        noOptionsMessage: formatMessage((0, $9oo3F.default).noParentIssues, {
            parentName: label
        }),
        showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty,
        isAsyncSearch: isAsyncSearch,
        isNested: isNested,
        onMouseEnterToTriggerButton: onMouseEnterToTriggerButton
    }));
};
$31db5ca9c486657a$var$ParentFilter.defaultProps = {
    selectedParents: [],
    isToggleChecked: false,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    showPanelToggle: false,
    showMenuIfValuesAreEmpty: false,
    isLoading: false,
    isAsyncSearch: false,
    isNested: false
};
var $31db5ca9c486657a$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($31db5ca9c486657a$var$ParentFilter);

});
parcelRegister("9oo3F", function(module, exports) {

$parcel$export(module.exports, "default", () => $9506229386ae6ee1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9506229386ae6ee1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noParentIssues: {
        "id": "software-filters.filters.parent.no-parent-issues",
        "defaultMessage": "Your project has no {parentName}"
    },
    toggleLabel: {
        "id": "software-filters.filters.parent.toggle-label",
        "defaultMessage": "Show {parentName} panel"
    }
});

});


parcelRegister("hpA0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $779f77cd70091738$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $aWse0 = parcelRequire("aWse0");

var $96s6B = parcelRequire("96s6B");

var $6DAJ4 = parcelRequire("6DAJ4");
const $779f77cd70091738$var$MAX_SELECTION_ALLOWED = 10;
const $779f77cd70091738$var$QuickFilter = ({ filters: filters = [], selectedFilters: selectedFilters = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const values = (0, $5uXOq.useMemo)(()=>filters.map((filter)=>({
                label: filter.name,
                value: filter.id
            })), [
        filters
    ]);
    const onChangeMapValues = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    const maxSelectionReachedTooltip = formatMessage((0, $6DAJ4.default).maxSelectionReachedTooltip, {
        maxSelectionAllowed: $779f77cd70091738$var$MAX_SELECTION_ALLOWED
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $6DAJ4.default).label),
        values: values,
        selectedValues: selectedFilters,
        onChange: onChangeMapValues,
        maxSelectionAllowed: $779f77cd70091738$var$MAX_SELECTION_ALLOWED,
        maxSelectionReachedTooltip: maxSelectionReachedTooltip,
        isNested: isNested
    });
};
const $779f77cd70091738$var$QuickFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($779f77cd70091738$var$QuickFilter);
$779f77cd70091738$var$QuickFilterComponent.displayName = 'QuickFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$779f77cd70091738$var$QuickFilterComponent.whyDidYouRender = true;
var $779f77cd70091738$export$2e2bcd8739ae039 = $779f77cd70091738$var$QuickFilterComponent;

});
parcelRegister("6DAJ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $28d3824050b576c4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $28d3824050b576c4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.quick.label",
        "defaultMessage": "Quick filters"
    },
    maxSelectionReachedTooltip: {
        "id": "software-filters.filters.quick.max-selection-reached-tooltip",
        "defaultMessage": "You can't select more than {maxSelectionAllowed, plural, one {# quick filter} other {# quick filters}}"
    }
});

});


parcelRegister("g65Ek", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccc78a455db68a11$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $96s6B = parcelRequire("96s6B");

var $e0XMB = parcelRequire("e0XMB");
const $ccc78a455db68a11$var$RequestTypeFilter = ({ requestTypes: requestTypes = [], selectedRequestTypes: selectedRequestTypes = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>requestTypes.map((requestType)=>({
                label: requestType.name,
                value: requestType.id,
                iconUrl: requestType.iconUrl
            })), [
        requestTypes
    ]);
    const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one option
    if (requestTypes.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $e0XMB.default).label),
        values: values,
        selectedValues: selectedRequestTypes.map(String),
        onChange: onChangeCallback,
        isNested: isNested
    });
};
const $ccc78a455db68a11$var$RequestTypeFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($ccc78a455db68a11$var$RequestTypeFilter);
$ccc78a455db68a11$var$RequestTypeFilterComponent.displayName = 'RequestTypeFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$ccc78a455db68a11$var$RequestTypeFilterComponent.whyDidYouRender = true;
var $ccc78a455db68a11$export$2e2bcd8739ae039 = $ccc78a455db68a11$var$RequestTypeFilterComponent;

});
parcelRegister("e0XMB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c7eddbc8ad682f0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4c7eddbc8ad682f0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.request-type.label",
        "defaultMessage": "Request type"
    }
});

});


parcelRegister("jdA4J", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6cedc5f723f1df5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $96s6B = parcelRequire("96s6B");

var $6TH6s = parcelRequire("6TH6s");
const $b6cedc5f723f1df5$var$SprintFilter = ({ sprints: sprints = [], selectedSprints: selectedSprints = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'sprintFilter rendered', {
            numberOfSprints: sprints.length
        });
    }, [
        createAnalyticsEvent,
        sprints
    ]);
    const values = (0, $5uXOq.useMemo)(()=>sprints.map((sprint)=>({
                label: sprint.name,
                value: sprint.id.toString()
            })), [
        sprints
    ]);
    const onChangeMapValues = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $6TH6s.default).label),
        values: values,
        selectedValues: selectedSprints,
        onChange: onChangeMapValues,
        isNested: isNested
    });
};
const $b6cedc5f723f1df5$var$SprintFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($b6cedc5f723f1df5$var$SprintFilter);
$b6cedc5f723f1df5$var$SprintFilterComponent.displayName = 'SprintFilter';
var $b6cedc5f723f1df5$export$2e2bcd8739ae039 = $b6cedc5f723f1df5$var$SprintFilterComponent;

});
parcelRegister("6TH6s", function(module, exports) {

$parcel$export(module.exports, "default", () => $a136882e810c6f5b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a136882e810c6f5b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.sprint.label",
        "defaultMessage": "Sprint"
    }
});

});


parcelRegister("cSFZv", function(module, exports) {

$parcel$export(module.exports, "default", () => $746f8d9f8aa82396$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $aWse0 = parcelRequire("aWse0");

var $g5X3G = parcelRequire("g5X3G");

var $96s6B = parcelRequire("96s6B");

var $5qiVm = parcelRequire("5qiVm");
const $746f8d9f8aa82396$var$StatusCategoryFilter = ({ statusCategories: statusCategories = [], selectedStatusCategories: selectedStatusCategories = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const values = (0, $5uXOq.useMemo)(()=>statusCategories.map(({ id: id, name: name })=>({
                label: name,
                value: id
            })), [
        statusCategories
    ]);
    const onChangeValue = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>(0, $g5X3G.toIssueStatusCategoryId)(value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one option
    if (values.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $5qiVm.default).label),
        values: values,
        selectedValues: selectedStatusCategories.map(String),
        onChange: onChangeValue,
        isNested: isNested
    });
};
const $746f8d9f8aa82396$var$StatusCategoryFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($746f8d9f8aa82396$var$StatusCategoryFilter);
$746f8d9f8aa82396$var$StatusCategoryFilterComponent.displayName = 'StatusCategoryFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$746f8d9f8aa82396$var$StatusCategoryFilterComponent.whyDidYouRender = true;
var $746f8d9f8aa82396$export$2e2bcd8739ae039 = $746f8d9f8aa82396$var$StatusCategoryFilterComponent;

});
parcelRegister("5qiVm", function(module, exports) {

$parcel$export(module.exports, "default", () => $16c5f1e62f5bac0b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $16c5f1e62f5bac0b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.status-category.label",
        "defaultMessage": "Status category"
    }
});

});


parcelRegister("3f9TT", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ecaaab2e5e2a52$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $g5X3G = parcelRequire("g5X3G");

var $96s6B = parcelRequire("96s6B");

var $33ioU = parcelRequire("33ioU");
const $45ecaaab2e5e2a52$var$StatusFilter = ({ statuses: statuses = [], selectedStatuses: selectedStatuses = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>statuses.map(({ id: id, name: name })=>({
                label: name,
                value: id
            })), [
        statuses
    ]);
    const onChangeValue = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>(0, $g5X3G.toIssueStatusId)(value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one option
    if (values.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $33ioU.default).label),
        values: values,
        selectedValues: selectedStatuses.map(String),
        onChange: onChangeValue,
        isNested: isNested
    });
};
const $45ecaaab2e5e2a52$var$StatusFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($45ecaaab2e5e2a52$var$StatusFilter);
$45ecaaab2e5e2a52$var$StatusFilterComponent.displayName = 'StatusFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$45ecaaab2e5e2a52$var$StatusFilterComponent.whyDidYouRender = true;
var $45ecaaab2e5e2a52$export$2e2bcd8739ae039 = $45ecaaab2e5e2a52$var$StatusFilterComponent;

});
parcelRegister("33ioU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee3eff355f28d572$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ee3eff355f28d572$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.status.label",
        "defaultMessage": "Status"
    }
});

});


parcelRegister("aMFc7", function(module, exports) {

$parcel$export(module.exports, "default", () => $119ce63ee3cabcee$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jZ4fr = parcelRequire("jZ4fr");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $heNNl = parcelRequire("heNNl");

var $7iJwP = parcelRequire("7iJwP");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $g5X3G = parcelRequire("g5X3G");

var $9pP0g = parcelRequire("9pP0g");

var $iDGXn = parcelRequire("iDGXn");

var $dIdda = parcelRequire("dIdda");

var $96s6B = parcelRequire("96s6B");

var $gfbKZ = parcelRequire("gfbKZ");
const $119ce63ee3cabcee$var$VersionFilter = (props)=>{
    const { versions: versions, selectedVersions: selectedVersions, isToggleChecked: isToggleChecked, onTogglePanel: onTogglePanel, isSpotlightEnabled: isSpotlightEnabled, showPanelToggle: showPanelToggle, isNested: isNested, toggleRef: toggleRef, hasMultipleProjects: hasMultipleProjects, isLoading: isLoading } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { toggleViewSetting: toggleViewSetting } = (0, $iDGXn.useViewSettingsActions)();
    const [boardId] = (0, $dIdda.usePathParam)('boardId');
    const values = (0, $5uXOq.useMemo)(()=>versions.map((version)=>({
                label: version.name,
                // Casting to string normalises the id that may potentially be a number.
                value: String(version.id),
                subLabel: hasMultipleProjects ? version.projectKey : undefined
            })), [
        versions,
        hasMultipleProjects
    ]);
    const onChange = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        props.onChange(entries.map(({ value: value })=>value), analyticAttributes);
    }, [
        props,
        isNested
    ]);
    const handleTogglePanel = (0, $5uXOq.useCallback)(()=>{
        if (boardId) toggleViewSetting({
            boardId: Number(boardId),
            setting: (0, $9pP0g.ViewSetting).VERSION_PANEL
        });
        onTogglePanel();
    }, [
        boardId,
        onTogglePanel,
        toggleViewSetting
    ]);
    const renderContent = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
            label: formatMessage((0, $gfbKZ.default).label),
            toggleLabel: formatMessage((0, $gfbKZ.default).toggleLabel),
            values: values,
            showPanelToggle: showPanelToggle,
            selectedValues: (0, $g5X3G.toStringArray)(selectedVersions),
            isPanelToggleChecked: isToggleChecked,
            onChange: onChange,
            onTogglePanel: handleTogglePanel,
            noOptionsMessage: formatMessage(values.length === 0 ? (0, $gfbKZ.default).noUnreleasedVersions : (0, $gfbKZ.default).noMatchingVersions),
            showMenuIfValuesAreEmpty: true,
            isNested: isNested,
            toggleRef: toggleRef,
            isLoading: isLoading
        }), [
        formatMessage,
        values,
        showPanelToggle,
        selectedVersions,
        isToggleChecked,
        onChange,
        isNested,
        toggleRef,
        handleTogglePanel,
        isLoading
    ]);
    if (isSpotlightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "fusionBacklogVersionsPanel"
    }, renderContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: "fusionBacklogVersionsPanel"
    })));
    return renderContent;
};
$119ce63ee3cabcee$var$VersionFilter.displayName = 'VersionFilter';
$119ce63ee3cabcee$var$VersionFilter.whyDidYouRender = true;
const $119ce63ee3cabcee$var$ErrorWrapper = (props)=>{
    if (!props.isVersionsFeatureEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "jira.backlog.version.filter",
        packageName: "jiraFilters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "jira.backlog.version.filter",
        packageName: "jiraFilters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "versionFilter",
        attributes: {
            isVersionPanelOpen: props.isToggleChecked
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($119ce63ee3cabcee$var$VersionFilter, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null))));
};
$119ce63ee3cabcee$var$ErrorWrapper.defaultProps = {
    versions: [],
    selectedVersions: [],
    isToggleChecked: false,
    isSpotlightEnabled: false,
    showPanelToggle: true,
    isVersionsFeatureEnabled: false,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    isNested: false
};
var $119ce63ee3cabcee$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($119ce63ee3cabcee$var$ErrorWrapper);

});
parcelRegister("gfbKZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f065e16be4d58f9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3f065e16be4d58f9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noUnreleasedVersions: {
        "id": "software-filters.filters.version.no-unreleased-versions",
        "defaultMessage": "No unreleased versions in this project"
    },
    noMatchingVersions: {
        "id": "software-filters.filters.version.no-matching-versions",
        "defaultMessage": "No matching versions"
    },
    label: {
        "id": "software-filters.filters.version.label",
        "defaultMessage": "Version"
    },
    toggleLabel: {
        "id": "software-filters.filters.version.toggle-label",
        "defaultMessage": "Show version panel"
    }
});

});


parcelRegister("fJnmW", function(module, exports) {

$parcel$export(module.exports, "FilterBar", () => $fcc1c800bf761f9d$export$56a20ec2552ffba2);
$parcel$export(module.exports, "ListFilterContainerNextGen", () => $fcc1c800bf761f9d$export$4a72bd88f9845459);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");
const $fcc1c800bf761f9d$export$9ea8cdcfa806101a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _4cvr1h6o _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $fcc1c800bf761f9d$export$35dfe29d505ceb8f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _4cvr1h6o _1ul9idpf _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $fcc1c800bf761f9d$export$56a20ec2552ffba2 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $fcc1c800bf761f9d$export$35dfe29d505ceb8f, $fcc1c800bf761f9d$export$9ea8cdcfa806101a);
const $fcc1c800bf761f9d$export$847557029097218a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jx1txw _1hftutpp _1uf81b66 _1o94h2mm _79vbb3bt _lpsrstnw _9uwn1ssb _41sd7vkz _be5h1i34 _4amot94y _1omzidpf _1sn01d4u",
            __cmplp.className
        ])
    });
});
const $fcc1c800bf761f9d$export$6fe98dc7be67e1c2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jx1txw _1hftv77o _1uf81b66 _1o94h2mm _yj55idpf",
            __cmplp.className
        ])
    });
});
const $fcc1c800bf761f9d$export$595be9b8d0603674 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jx1txw _1o94h2mm _yj55idpf",
            __cmplp.className
        ])
    });
});
const $fcc1c800bf761f9d$export$4a72bd88f9845459 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $fcc1c800bf761f9d$export$595be9b8d0603674, $fcc1c800bf761f9d$export$6fe98dc7be67e1c2);

});

parcelRegister("cTi8P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e898d158ecdd3c47$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $4jAPy = parcelRequire("4jAPy");

var $3Qsxg = parcelRequire("3Qsxg");
const $e898d158ecdd3c47$var$AsyncBoardSwitcher = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $3Qsxg.syncBoardSwitcher), {});
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
        return ()=>{
            entryPointActions.unload();
        };
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "plan-increment-board-switcher",
        packageName: (0, $4jAPy.PACKAGE_NAME),
        teamName: (0, $4jAPy.ERROR_REPORTING_TEAM),
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};
var $e898d158ecdd3c47$export$2e2bcd8739ae039 = $e898d158ecdd3c47$var$AsyncBoardSwitcher;

});
parcelRegister("3Qsxg", function(module, exports) {

$parcel$export(module.exports, "syncBoardSwitcher", () => $afceff36abed190f$export$e13b401cdb60e3ed);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $afceff36abed190f$export$e13b401cdb60e3ed = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("2C9Uz"))).then((module)=>module.AsyncBoardSwitcher), {
        moduleId: "2623f17b"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("gtgKk", function(module, exports) {

$parcel$export(module.exports, "CollabContainerAsync", () => $d8b06fe481f4b829$export$69b83fdf5027068d);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d8b06fe481f4b829$var$LazyCollabContainer = (0, $kxZPA.lazy)(()=>(parcelRequire("hSq0e")).then(({ CollabContainer: CollabContainer })=>CollabContainer), {
    moduleId: "./src/packages/software/real-time-presence/src/controllers/collab/index.tsx"
});
const $d8b06fe481f4b829$export$69b83fdf5027068d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "async-jira-software-real-time-presence",
        packageName: "jiraSoftwareRealtimePresence",
        teamName: "jira-werewolves",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-real-time-presence",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8b06fe481f4b829$var$LazyCollabContainer, props)));

});
parcelRegister("hSq0e", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("7IZwQ")
]).then(()=>parcelRequire('cwA3d'));

});


parcelRegister("8vjSE", function(module, exports) {

$parcel$export(module.exports, "useCollabStore", () => $4e59b4cbd57cc99d$export$4159ae80cfa2156);

var $3JOCw = parcelRequire("3JOCw");

var $7JoAD = parcelRequire("7JoAD");

const $4e59b4cbd57cc99d$var$updateUserInParticipants = (user)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            participants: state.participants.map((participant)=>{
                if (participant.clientId === user.userId) return {
                    ...participant,
                    avatar: user.avatar,
                    name: user.name,
                    email: user.email
                };
                return participant;
            })
        });
    };
const $4e59b4cbd57cc99d$var$participantsJoined = (joined)=>({ getState: getState, setState: setState })=>{
        const uniqueJoined = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(joined, ({ sessionId: sessionId })=>sessionId);
        const newParticipantSessionIds = uniqueJoined.map(({ sessionId: sessionId })=>sessionId);
        const state = getState();
        const { provider: provider } = state;
        const newParticipants = [
            ...state.participants.filter(({ sessionId: sessionId })=>!newParticipantSessionIds.includes(sessionId)),
            ...uniqueJoined
        ];
        // Collab team advised we should limit the number of max connections to control the load on collab service
        if (newParticipants.length >= (0, $4123025face0353e$export$3debf01bbfa135e5) && provider) {
            // sort users by last active (last joined)
            const sortedUsers = newParticipants.sort((userA, userB)=>userA.lastActive > userB.lastActive ? 1 : -1);
            const currentUser = sortedUsers.find((user)=>user.sessionId === provider.sessionId);
            const lastActiveUser = sortedUsers[sortedUsers.length - 1];
            // kick the last joined user out
            setState({
                ...state,
                participants: newParticipants.filter(({ sessionId: sessionId })=>sessionId !== lastActiveUser.sessionId)
            });
            if (lastActiveUser.sessionId === currentUser?.sessionId) provider.destroy();
            return;
        }
        setState({
            ...state,
            participants: newParticipants
        });
    };
const $4e59b4cbd57cc99d$var$participantsLeft = (left)=>({ getState: getState, setState: setState })=>{
        const leftSessionIds = left.map(({ sessionId: sessionId })=>sessionId);
        const state = getState();
        // cleanup user selection when they leave the session
        const newSelection = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            const selections = state.nodeSelection[nodeIdKey];
            if (selections.length > 0) {
                const filteredSelections = selections.filter((selection)=>!leftSessionIds.includes(selection.sessionId));
                if (filteredSelections.length === 0) return;
                newSelection[nodeIdKey] = filteredSelections;
            }
        });
        setState({
            ...state,
            participants: state.participants.filter(({ sessionId: sessionId })=>!leftSessionIds.includes(sessionId)),
            nodeSelection: newSelection
        });
    };
const $4e59b4cbd57cc99d$var$setProvider = (provider)=>({ getState: getState, setState: setState })=>setState({
            ...getState(),
            provider: provider
        });
const $4e59b4cbd57cc99d$var$sendNodeSelected = ({ nodeId: nodeId })=>({ getState: getState })=>{
        if (nodeId == null) return;
        const { provider: provider, participants: participants } = getState();
        if (participants.length <= 1) return;
        if (provider) provider.sendMessage({
            type: 'telepointer',
            sessionId: provider.sessionId,
            selection: {
                type: 'nodeSelection',
                anchor: JSON.stringify({
                    nodeId: nodeId
                })
            }
        });
    };
const $4e59b4cbd57cc99d$var$sendClearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams })=>({ getState: getState })=>{
        if (nodeId == null) return;
        const { provider: provider, participants: participants } = getState();
        if (participants.length <= 1) return;
        if (provider) provider.sendMessage({
            type: 'telepointer',
            sessionId: provider.sessionId,
            selection: {
                type: 'nodeSelection',
                head: JSON.stringify({
                    nodeId: nodeId,
                    dropParams: dropParams
                })
            }
        });
    };
const $4e59b4cbd57cc99d$var$setNodeSelection = ({ nodeId: nodeId, sessionId: sessionId, user: user })=>({ setState: setState, getState: getState })=>{
        const newSelection = {
            nodeId: nodeId,
            user: user,
            sessionId: sessionId
        };
        const state = getState();
        const dedupCurrentSelection = state.nodeSelection[nodeId] && state.nodeSelection[nodeId].filter((selection)=>selection.user.userId !== user.userId);
        const nodeSelection = dedupCurrentSelection ? [
            ...dedupCurrentSelection,
            newSelection
        ] : [
            newSelection
        ];
        // deduplicate selected nodes from this user, because each user can have only one selected node on the page
        const dedupOtherSelections = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            // keep selections from all other users
            const selections = state.nodeSelection[nodeIdKey];
            if (selections.length > 0) {
                const filteredSelections = selections.filter((selection)=>selection.user.userId !== user.userId);
                if (filteredSelections.length === 0) return;
                dedupOtherSelections[nodeIdKey] = filteredSelections;
            }
        });
        setState({
            ...state,
            nodeSelection: {
                ...dedupOtherSelections,
                [nodeId]: nodeSelection
            }
        });
    };
const $4e59b4cbd57cc99d$var$clearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams, userId: userId })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const newNodeSelection = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            if (nodeIdKey !== nodeId) newNodeSelection[nodeIdKey] = state.nodeSelection[nodeIdKey];
        });
        setState({
            ...state,
            nodeSelection: newNodeSelection,
            dragAnimation: dropParams && userId != null ? [
                ...state.dragAnimation,
                {
                    ...dropParams,
                    userId: userId
                }
            ] : state.dragAnimation
        });
    };
const $4e59b4cbd57cc99d$var$stopDragAnimation = ({ sourceNodeId: sourceNodeId })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            dragAnimation: state.dragAnimation.filter((animation)=>String(animation.sourceNodeId) !== String(sourceNodeId))
        });
    };
const $4e59b4cbd57cc99d$var$actions = {
    setProvider: $4e59b4cbd57cc99d$var$setProvider,
    participantsLeft: $4e59b4cbd57cc99d$var$participantsLeft,
    participantsJoined: $4e59b4cbd57cc99d$var$participantsJoined,
    updateUserInParticipants: $4e59b4cbd57cc99d$var$updateUserInParticipants,
    sendNodeSelected: $4e59b4cbd57cc99d$var$sendNodeSelected,
    sendClearNodeSelection: $4e59b4cbd57cc99d$var$sendClearNodeSelection,
    setNodeSelection: $4e59b4cbd57cc99d$var$setNodeSelection,
    clearNodeSelection: $4e59b4cbd57cc99d$var$clearNodeSelection,
    stopDragAnimation: $4e59b4cbd57cc99d$var$stopDragAnimation
};
const $4e59b4cbd57cc99d$var$Store = (0, $7JoAD.createStore)({
    initialState: {
        provider: null,
        participants: [],
        nodeSelection: {},
        dragAnimation: []
    },
    actions: $4e59b4cbd57cc99d$var$actions,
    name: 'JSWCollabStore'
});
const $4e59b4cbd57cc99d$export$4159ae80cfa2156 = (0, $7JoAD.createHook)($4e59b4cbd57cc99d$var$Store);

});
const $4123025face0353e$export$3debf01bbfa135e5 = 80;


parcelRegister("2xSAL", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $f115db1c327fbbaa$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fW62l = parcelRequire("fW62l");

var $2NMNM = parcelRequire("2NMNM");

var $kY99m = parcelRequire("kY99m");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $cBssJ = parcelRequire("cBssJ");

var $hJBhl = parcelRequire("hJBhl");

var $5yLnO = parcelRequire("5yLnO");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $f115db1c327fbbaa$var$className = 'ajs-dirty-warning-exempt';
const $f115db1c327fbbaa$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const [value, setValue] = (0, $5uXOq.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const textInput = (0, $5uXOq.useRef)(null);
    const previousValueRef = (0, $5uXOq.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $5uXOq.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $5uXOq.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $5uXOq.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $5uXOq.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder || formatMessage((0, $cBssJ.messages).search),
        'aria-describedby': describedById,
        type: 'text',
        // @ts-expect-error - TS2322 - Type '{ 'aria-label': string; 'aria-describedby': string; type: string; 'data-test-id': string; name: string; className: string; placeholder: string; onFocus: (event: React.SyntheticEvent<HTMLInputElement, Event>) => void; ... 9 more ...; maxLength: number | undefined; }' is not assignable to type 'TextfieldProps'.
        'data-test-id': 'searchfield',
        testId: testId ?? 'searchfield',
        name: 'search',
        className: $f115db1c327fbbaa$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5yLnO.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $cBssJ.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5yLnO.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJBhl.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $cBssJ.messages).clear)
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        increasedWidth: increasedWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        ...textFieldProps,
        elemBeforeInput: searchIcon,
        elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$f115db1c327fbbaa$var$SearchFieldUnmemoized.displayName = 'Search';
$f115db1c327fbbaa$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $f115db1c327fbbaa$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $5uXOq.memo)($f115db1c327fbbaa$var$SearchFieldUnmemoized);
$f115db1c327fbbaa$export$b94867ecbd698f21.displayName = 'Search'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f115db1c327fbbaa$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $f115db1c327fbbaa$var$InputWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $lD23V.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $lD23V.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $lD23V.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $lD23V.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $lD23V.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $lD23V.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $lD23V.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $lD23V.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _v564zpk5 _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cBssJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $08273d4fc2a6d6da$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $08273d4fc2a6d6da$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("hJBhl", function(module, exports) {

$parcel$export(module.exports, "ClearFieldIcon", () => $99940a7c159b00c0$export$84038b503874befa);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $i28qQ = parcelRequire("i28qQ");

var $dC5iT = parcelRequire("dC5iT");
var $h9kUS = parcelRequire("h9kUS");
var $8CUq3 = parcelRequire("8CUq3");
const $99940a7c159b00c0$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $99940a7c159b00c0$var$wrapperStylesCloseIcon
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i28qQ)))
    }));
const $99940a7c159b00c0$var$wrapperStylesCloseIcon = (0, $8CUq3.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $h9kUS.media).above.md]: {
        marginRight: 'space.050'
    }
});

});

parcelRegister("5yLnO", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIconDynamic", () => $71cc18983db63a0d$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $71cc18983db63a0d$export$8a82bff895521bd9);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $84THj = parcelRequire("84THj");

var $26g7Y = parcelRequire("26g7Y");

var $hyOJh = parcelRequire("hyOJh");

var $dC5iT = parcelRequire("dC5iT");
var $h9kUS = parcelRequire("h9kUS");
var $8CUq3 = parcelRequire("8CUq3");
const $71cc18983db63a0d$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y))), {
        LEGACY_size: "small",
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $71cc18983db63a0d$var$wrapperStyles,
            onlyIconSpacing && $71cc18983db63a0d$var$spacingStyles
        ]
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        spacing: "none",
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
            LEGACY_size: "small",
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $71cc18983db63a0d$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $71cc18983db63a0d$var$wrapperStylesBefore,
            onlyIconSpacing && $71cc18983db63a0d$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyOJh))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null));
const $71cc18983db63a0d$var$wrapperStyles = (0, $8CUq3.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex'
});
const $71cc18983db63a0d$var$spacingStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.075',
    [(0, $h9kUS.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $71cc18983db63a0d$var$wrapperStylesBefore = (0, $8CUq3.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $h9kUS.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $71cc18983db63a0d$var$spacingStylesBefore = (0, $8CUq3.xcss)({
    marginLeft: 'space.075',
    [(0, $h9kUS.media).above.md]: {
        marginLeft: 'space.100'
    }
});

});


parcelRegister("cM4EP", function(module, exports) {

$parcel$export(module.exports, "default", () => $93fab47741ff1022$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $iqr2y = parcelRequire("iqr2y");

var $kobfu = parcelRequire("kobfu");

var $fZneA = parcelRequire("fZneA");

var $lfTZh = parcelRequire("lfTZh");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $2NMNM = parcelRequire("2NMNM");

var $5a0Nh = parcelRequire("5a0Nh");

var $7Oku1 = parcelRequire("7Oku1");
class $93fab47741ff1022$export$876b3e4acf4df22c extends (0, $5uXOq.Component) {
    static{
        this.getDerivedStateFromError = (error)=>({
                error: error,
                isRelayValidationError: (0, $7Oku1.isRelayValidationError)(error)
            });
    }
    static getDerivedStateFromProps({ customFiltersQueryRef: customFiltersQueryRef }, state) {
        if (state.error && !state.aggErrors && customFiltersQueryRef) {
            const capturedGQLErrorsInfo = (0, $5a0Nh.stopCaptureGraphQlErrors)(customFiltersQueryRef.fetchKey.toString());
            const validGQLErrorsInfo = capturedGQLErrorsInfo.find((err)=>err.meta.operationName === customFiltersQueryRef.name);
            if (validGQLErrorsInfo?.errors.length) return {
                ...state,
                aggErrors: validGQLErrorsInfo.errors,
                aggErrorsMeta: validGQLErrorsInfo.meta
            };
        }
        return null;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null,
            aggErrors: null,
            aggErrorsMeta: null,
            isRelayValidationError: false
        };
    }
    getCommonErrorAttributes(error) {
        return {
            task: 'loadCustomFilters',
            screenName: this.props.screenName,
            isNetworkError: false,
            isRelayValidationError: this.state.isRelayValidationError,
            hash: (0, $kobfu.getErrorHash)(error) ?? '',
            errorMessage: error.message,
            stack: error.stack
        };
    }
    render() {
        const { error: error, aggErrors: aggErrors, aggErrorsMeta: aggErrorsMeta, isRelayValidationError: isRelayValidationError } = this.state;
        const { children: children } = this.props;
        if (!error) return children;
        if (aggErrors?.length) {
            const aggError = new (0, $7Oku1.AGGErrors)(aggErrors, aggErrorsMeta?.requestId);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
                eventName: "ui taskFail",
                attributes: {
                    traceId: aggError.traceId,
                    statusCode: aggError.statusCode,
                    ...this.getCommonErrorAttributes(aggError)
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqr2y.ErrorFlagRenderer), {
                id: "custom-filter-dropdown",
                error: aggError
            }));
        }
        if (isRelayValidationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
            eventName: "ui taskFail",
            attributes: {
                ...this.getCommonErrorAttributes(error)
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqr2y.ErrorFlagRenderer), {
            id: "custom-filter-dropdown",
            error: error
        }));
        // If this isn't an AGG or Relay error, let the upper error boundary handle it
        throw error;
    }
}
const $93fab47741ff1022$var$CustomFilterBoundary = (props)=>{
    const { children: children, screenName: screenName } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onError = (_, error)=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
            screenName: screenName,
            task: 'loadCustomFilters',
            isNetworkError: (0, $fZneA.isClientFetchError)(error),
            hash: (0, $kobfu.getErrorHash)(error) ?? '',
            errorMessage: error.message
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "custom-filter-dropdown",
        packageName: "software-filters",
        teamName: "a4t-tanuki",
        fallback: "flag",
        extraEventData: {
            screenName: screenName
        },
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93fab47741ff1022$export$876b3e4acf4df22c, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "custom-filter-boundary",
        fallback: null
    }, children)));
};
var $93fab47741ff1022$export$2e2bcd8739ae039 = $93fab47741ff1022$var$CustomFilterBoundary;

});
parcelRegister("7Oku1", function(module, exports) {

$parcel$export(module.exports, "isRelayValidationError", () => $8940bd8b67d2f481$export$f450dbe0abffdade);
$parcel$export(module.exports, "AGGErrors", () => $8940bd8b67d2f481$export$60d8267243755b9c);

var $ht021 = parcelRequire("ht021");
const $8940bd8b67d2f481$export$321834dc4377cb7 = 'Relay: Missing @required value at path';
const $8940bd8b67d2f481$export$f450dbe0abffdade = (error)=>error.message.includes($8940bd8b67d2f481$export$321834dc4377cb7);
class $8940bd8b67d2f481$export$60d8267243755b9c extends (0, $ht021.default) {
    constructor(errors, traceId){
        // this is used to generate same 'hash' for error flag and sla event attribute
        super(errors[0].message, {
            cause: errors[0]
        });
        this.name = 'AGGError';
        this.graphQLErrors = errors;
        this.traceId = traceId;
        this.statusCode = errors[0].extensions?.statusCode ?? undefined;
    }
}

});


parcelRegister("2FvdY", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1987110dd76b24$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dF9Z3 = parcelRequire("dF9Z3");
const $fb1987110dd76b24$var$HijackBrowserDefaultSearch = ({ onFocusSearch: onFocusSearch, isAnyModalOpen: isAnyModalOpen = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onGlobalSearch = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'event' implicitly has an 'any' type.
    ({ event: event })=>{
        // Do not hijack browser default search when any modal is open
        if (isAnyModalOpen) return;
        // Hijacks default browser search and directs user to search in filter bar
        event.preventDefault();
        onFocusSearch();
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'hijackBrowserDefaultSearch triggered');
    }, [
        createAnalyticsEvent,
        isAnyModalOpen,
        onFocusSearch
    ]);
    (0, $dF9Z3.useGlobalSearch)(onGlobalSearch);
    return null;
};
var $fb1987110dd76b24$export$2e2bcd8739ae039 = $fb1987110dd76b24$var$HijackBrowserDefaultSearch;

});

parcelRegister("kH9yv", function(module, exports) {

$parcel$export(module.exports, "default", () => $333f125f896ef4d8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5ujeO = parcelRequire("5ujeO");
var $k6T4f = parcelRequire("k6T4f");

var $dC5iT = parcelRequire("dC5iT");

var $6s1PB = parcelRequire("6s1PB");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dF9Z3 = parcelRequire("dF9Z3");

var $ew9g5 = parcelRequire("ew9g5");

var $gtlfw = parcelRequire("gtlfw");
const $333f125f896ef4d8$var$SearchFilterChangeboarding = ({ children: children, hijackBrowserDefaultSearch: hijackBrowserDefaultSearch = false, screenName: screenName, isCompanyManaged: isCompanyManaged = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isVisible, setIsVisible] = (0, $5uXOq.useState)(false);
    const hasShown = (0, $5uXOq.useRef)(false);
    const onGlobalSearch = (0, $5uXOq.useCallback)(()=>{
        if (!hasShown.current) {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'searchFilterChangeboarding shown', {
                isHijackBrowserDefaultSearchEnabled: hijackBrowserDefaultSearch
            });
            setIsVisible(true);
            hasShown.current = true;
            if (screenName === 'backlog' || screenName === 'board' || screenName === 'roadmap') (0, $ew9g5.setUserSeenSearchFieldChangeboarding)(screenName);
        }
    }, [
        createAnalyticsEvent,
        hijackBrowserDefaultSearch,
        screenName
    ]);
    const onDismiss = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'searchFilterChangeboarding dismissed', {
            isHijackBrowserDefaultSearchEnabled: hijackBrowserDefaultSearch
        });
        setIsVisible(false);
    }, [
        createAnalyticsEvent,
        hijackBrowserDefaultSearch
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>[
            {
                text: formatMessage((0, $gtlfw.default).changeboardingConfirmButton),
                onClick: onDismiss
            }
        ], [
        formatMessage,
        onDismiss
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const getUserSeenSearchFieldChangeboarding = async ()=>{
            if (screenName === 'backlog' || screenName === 'board' || screenName === 'roadmap') {
                const seen = await (0, $ew9g5.hasUserSeenSearchFieldChangeboarding)(createAnalyticsEvent({}), screenName);
                if (seen) hasShown.current = true;
            }
        };
        getUserSeenSearchFieldChangeboarding();
    }, [
        createAnalyticsEvent,
        hijackBrowserDefaultSearch,
        screenName
    ]);
    const changeBoardingMessage = ()=>{
        const ctrlKey = (0, $dF9Z3.isMacOS)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Code, null, "Cmnd") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Code, null, "Ctrl");
        return hijackBrowserDefaultSearch ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $gtlfw.default).hijackingDefaultSearchMessage,
            values: {
                key: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Code, null, "F"),
                ctrlKey: ctrlKey
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $gtlfw.default).changeboardingMessage,
            values: {
                key: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Code, null, "f")
            }
        });
    };
    let spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ujeO.default), {
        actions: actions,
        width: 300
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, changeBoardingMessage()));
    if (isCompanyManaged) spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ujeO.default), {
        heading: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gtlfw.default).changeboardingUifMessageHeadingIssueTermRefresh : (0, $gtlfw.default).changeboardingUifMessageHeading),
        actions: actions,
        width: 300
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gtlfw.default).changeboardingUifMessageIssueTermRefresh : (0, $gtlfw.default).changeboardingUifMessage)));
    (0, $dF9Z3.useGlobalSearch)(onGlobalSearch);
    if (isVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$ChangeboardingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Pulse, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$SpolightCardContainer, null, spotlightCard));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
var $333f125f896ef4d8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $333f125f896ef4d8$var$SearchFilterChangeboarding;
const $333f125f896ef4d8$var$Pulse = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $k6T4f.Pulse), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pbyowjs",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $333f125f896ef4d8$var$ChangeboardingContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $333f125f896ef4d8$var$spotlightAnimation = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $333f125f896ef4d8$var$SpolightCardContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1pbyowjs _19pku2gc _tzy4idpf _y44v18t4 _o5724jg8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $333f125f896ef4d8$var$Code = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "code", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8qk37 _11q7exu1 _syaz1fxt _2rko1l7b _1e0c1nu9 _1reo1wug _o5721jtm _1yt4u49m",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ew9g5", function(module, exports) {

$parcel$export(module.exports, "hasUserSeenSearchFieldChangeboarding", () => $f70c479b04e71cf2$export$b5010e3edd313ae1);
$parcel$export(module.exports, "setUserSeenSearchFieldChangeboarding", () => $f70c479b04e71cf2$export$fba51361338c8f18);

var $i205g = parcelRequire("i205g");

var $8zOmE = parcelRequire("8zOmE");
const $f70c479b04e71cf2$var$changeboardingFlags = {
    board: 'jsw.filters.board.search-field-changeboarding.shown',
    backlog: 'jsw.filters.backlog.search-field-changeboarding.shown'
};
const $f70c479b04e71cf2$var$CHANGEBOARDING_TTL_SEEN = 31536000000; // ~ 365 days
const $f70c479b04e71cf2$export$b5010e3edd313ae1 = (analyticsEvent, screenName)=>(0, $i205g.getFlags)({
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly board: "jsw.filters.board.search-field-changeboarding.shown"; readonly backlog: "jsw.filters.backlog.search-field-changeboarding.shown"; }'.
        [$f70c479b04e71cf2$var$changeboardingFlags[screenName]]: {}
    })// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly board: "jsw.filters.board.search-field-changeboarding.shown"; readonly backlog: "jsw.filters.backlog.search-field-changeboarding.shown"; }'.
    .then((res)=>res[$f70c479b04e71cf2$var$changeboardingFlags[screenName]].status).catch(()=>{
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'searchFilterChangeboarding checkSeenFailed');
        return false;
    });
const $f70c479b04e71cf2$export$fba51361338c8f18 = (screenName)=>(0, $i205g.setFlag)($f70c479b04e71cf2$var$changeboardingFlags[screenName], $f70c479b04e71cf2$var$CHANGEBOARDING_TTL_SEEN);

});
parcelRegister("i205g", function(module, exports) {

$parcel$export(module.exports, "getFlags", () => $2e5c55e74efea073$export$d5815430bcc75df0);
$parcel$export(module.exports, "setFlag", () => $2e5c55e74efea073$export$5e165df1e30a1331);

var $dPSWJ = parcelRequire("dPSWJ");

var $sLb2Q = parcelRequire("sLb2Q");

var $4Pf62 = parcelRequire("4Pf62");

var $1nokx = parcelRequire("1nokx");

var $7UyIQ = parcelRequire("7UyIQ");
const $2e5c55e74efea073$export$442e3330dfabd1f5 = 3600000; // 1 hour
const $2e5c55e74efea073$export$4d45fa66d41a8ca9 = 2592000000; // ~1 month
const $2e5c55e74efea073$export$d5815430bcc75df0 = async (request)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const flagKeys = Object.keys(request);
    const retrieveFlagKeysLookup = (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(flagKeys);
    if (!atlassianAccountId || isAnonymous) return (0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(retrieveFlagKeysLookup, ()=>({
            status: true,
            lastSeenDate: null
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flags = {};
    if (0, $7UyIQ.default) flagKeys.forEach((flagKey)=>{
        // @ts-expect-error - Object is possibly 'null'.
        const value = (0, $7UyIQ.default).get(flagKey);
        if (value) {
            delete retrieveFlagKeysLookup[flagKey];
            flags[flagKey] = value;
        }
    });
    const retrieveFlagKeys = Object.keys(retrieveFlagKeysLookup);
    if (retrieveFlagKeys.length > 0) Object.assign(flags, await (0, $1nokx.getFlags)(atlassianAccountId, retrieveFlagKeys));
    if (0, $7UyIQ.default) {
        const now = Date.now();
        retrieveFlagKeys.forEach((flagKey)=>{
            // Not sure whats going wrong here - but i assume `apiGetFlags` may not always return all `retrieveFalgKeys`
            // and so `flags[flagKey]` can be undefined - so we have to guard against it
            if (!flags[flagKey]) return;
            const { status: status } = flags[flagKey];
            const ttlNotSeen = request[flagKey].ttlNotSeen || $2e5c55e74efea073$export$442e3330dfabd1f5;
            const ttlSeen = request[flagKey].ttlSeen || $2e5c55e74efea073$export$4d45fa66d41a8ca9;
            // @ts-expect-error - TS2531: Object is possibly 'null'.
            (0, $7UyIQ.default).set(flagKey, flags[flagKey], now + (status ? ttlSeen : ttlNotSeen));
        });
    }
    return flags;
};
const $2e5c55e74efea073$export$5e165df1e30a1331 = async (flagKey, ttl = $2e5c55e74efea073$export$4d45fa66d41a8ca9)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (!atlassianAccountId || isAnonymous) return;
    if (0, $7UyIQ.default) {
        const value = (0, $7UyIQ.default).get(flagKey);
        if (value && value.status) return;
        const now = new Date();
        (0, $7UyIQ.default).set(flagKey, {
            status: true,
            lastSeenDate: now.toISOString()
        }, now.getTime() + ttl);
    }
    await (0, $1nokx.setFlag)(atlassianAccountId, flagKey);
};

});
parcelRegister("sLb2Q", function(module, exports) {

var $hsOo6 = parcelRequire("hsOo6");

var $dVL8S = parcelRequire("dVL8S");
/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */ function $056736098c9e0b45$var$zipObject(props, values) {
    return $dVL8S(props || [], values || [], $hsOo6);
}
module.exports = $056736098c9e0b45$var$zipObject;

});
parcelRegister("dVL8S", function(module, exports) {
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */ function $a2452aab1e6d9d16$var$baseZipObject(props, values, assignFunc) {
    var index = -1, length = props.length, valsLength = values.length, result = {};
    while(++index < length){
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
    }
    return result;
}
module.exports = $a2452aab1e6d9d16$var$baseZipObject;

});


parcelRegister("1nokx", function(module, exports) {

$parcel$export(module.exports, "setFlag", () => $4c27c5726c27889e$export$5e165df1e30a1331);
$parcel$export(module.exports, "getFlags", () => $4c27c5726c27889e$export$d5815430bcc75df0);

var $dPSWJ = parcelRequire("dPSWJ");

var $jJZqs = parcelRequire("jJZqs");
const $4c27c5726c27889e$export$c1f083639d344e75 = 'https://have-i-seen-it.us-east-1.prod.public.atl-paas.net';
const $4c27c5726c27889e$export$5e165df1e30a1331 = (userKey, flagKey)=>{
    const data = {
        userKey: userKey,
        flagKey: flagKey
    };
    return fetch(`${$4c27c5726c27889e$export$c1f083639d344e75}/flag`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
        return undefined;
    });
};
const $4c27c5726c27889e$var$convertToDates = (response)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(response, ({ status: status, lastSeenDate: lastSeenDate })=>({
            status: status,
            lastSeenDate: lastSeenDate ? new Date(lastSeenDate) : null
        }));
const $4c27c5726c27889e$export$d5815430bcc75df0 = (userKey, flagKeys)=>{
    const params = new URLSearchParams();
    flagKeys.forEach((flagKey)=>params.append('flagKey', flagKey));
    params.append('userKey', userKey);
    return fetch(`${$4c27c5726c27889e$export$c1f083639d344e75}/flags?${params.toString()}`).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
        return response.json();
    }).then((response)=>$4c27c5726c27889e$var$convertToDates(response));
};

});

parcelRegister("7UyIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $158da724691281b4$export$2e2bcd8739ae039);

var $eNf8a = parcelRequire("eNf8a");

var $4Pf62 = parcelRequire("4Pf62");

var $dJl1T = parcelRequire("dJl1T");
/**
 * Return an ExpirableStorage to be used with the "have i seen it" service.
 *
 * If the user is anonymous, return null.
 */ const $158da724691281b4$var$createStorage = ()=>{
    let storage = null;
    try {
        let context;
        try {
            context = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            return storage;
        }
        const { atlassianAccountId: atlassianAccountId } = context;
        if (atlassianAccountId) storage = (0, $eNf8a.createSessionExpirableStorageProvider)(`have-i-seen-it-${atlassianAccountId.replace(/:/g, '_')}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('have-i-seen-it.storage', 'Failed to initialize storage.');
    }
    return storage;
};
var $158da724691281b4$export$2e2bcd8739ae039 = $158da724691281b4$var$createStorage();

});



parcelRegister("gtlfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e167f73d4db9857$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8e167f73d4db9857$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    changeboardingMessage: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-message",
        "defaultMessage": "For quick access to search, use {key} on your keyboard anywhere in Jira. It takes you directly to the search field."
    },
    changeboardingUifMessageHeading: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message-heading",
        "defaultMessage": "Search for an issue"
    },
    changeboardingUifMessage: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message",
        "defaultMessage": "The backlog loads issues as you scroll to help increase performance. If you struggle to find results using a keyboard shortcut, try entering the keyword here instead."
    },
    hijackingDefaultSearchMessage: {
        "id": "software-filters.search-filter-changeboarding.hijacking-default-search-message",
        "defaultMessage": "{ ctrlKey } + { key } takes you directly to the search field, just like keyboard shortcut { key }. Both shortcuts give you quick access to our optimized search."
    },
    changeboardingConfirmButton: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-confirm-button",
        "defaultMessage": "OK"
    },
    changeboardingUifMessageHeadingIssueTermRefresh: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message-heading-issue-term-refresh",
        "defaultMessage": "Search for an issue"
    },
    changeboardingUifMessageIssueTermRefresh: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message-issue-term-refresh",
        "defaultMessage": "The backlog loads issues as you scroll to help increase performance. If you struggle to find results using a keyboard shortcut, try entering the keyword here instead."
    }
});

});


parcelRegister("bBMqL", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf4b1c241e667722$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");
const $cf4b1c241e667722$var$VersionFilterRelayBoundary = ({ fallback: fallback = null, children: children, screenName: screenName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "version-filter-relay-dropdown",
        packageName: "software-filters",
        teamName: "a4t-tanuki",
        fallback: "flag",
        extraEventData: {
            screenName: screenName
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "version-filter-relay-boundary",
        fallback: fallback
    }, children));
var $cf4b1c241e667722$export$2e2bcd8739ae039 = $cf4b1c241e667722$var$VersionFilterRelayBoundary;

});

parcelRegister("l38sT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c71ac6a8ffa9b82$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4c71ac6a8ffa9b82$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    textFilter: {
        "id": "software-filters.stateless.text-filter",
        "defaultMessage": "Filter issues"
    },
    screenReaderInstruction: {
        "id": "software-filters.stateless.screen-reader-instruction",
        "defaultMessage": "Results will be filtered below as you type to search or apply filters."
    },
    screenReaderInstructionForFilters: {
        "id": "software-filters.stateless.screen-reader-instruction-for-filters",
        "defaultMessage": "Content below has been updated"
    },
    searchCurrentPage: {
        "id": "software-filters.stateless.search-current-page",
        "defaultMessage": "Search on current page"
    },
    goToSection: {
        "id": "software-filters.stateless.go-to-section",
        "defaultMessage": "Go to"
    },
    unassignedAssigneeDisplayName: {
        "id": "software-filters.stateless.unassigned-assignee-display-name",
        "defaultMessage": "Unassigned"
    },
    unassignedVersionLabel: {
        "id": "software-filters.stateless.unassigned-version-label",
        "defaultMessage": "Issues without version"
    },
    unassignedLabelLabel: {
        "id": "software-filters.stateless.unassigned-label-label",
        "defaultMessage": "Issues without label"
    },
    unassignedComponentLabel: {
        "id": "software-filters.stateless.unassigned-component-label",
        "defaultMessage": "Issues without component"
    },
    textFilterIssueTermRefresh: {
        "id": "software-filters.stateless.text-filter-issue-term-refresh",
        "defaultMessage": "Filter issues"
    },
    unassignedVersionLabelIssueTermRefresh: {
        "id": "software-filters.stateless.unassigned-version-label-issue-term-refresh",
        "defaultMessage": "Issues without version"
    },
    unassignedLabelLabelIssueTermRefresh: {
        "id": "software-filters.stateless.unassigned-label-label-issue-term-refresh",
        "defaultMessage": "Issues without label"
    },
    unassignedComponentLabelIssueTermRefresh: {
        "id": "software-filters.stateless.unassigned-component-label-issue-term-refresh",
        "defaultMessage": "Issues without component"
    }
});

});

parcelRegister("649U3", function(module, exports) {

$parcel$export(module.exports, "getManageCustomFiltersUrl", () => $224b64cdfcbfd0e3$export$84a62bf03b005a81);
$parcel$export(module.exports, "getAssigneesWithPresence", () => $224b64cdfcbfd0e3$export$cd7b2f0d4c426239);

const $224b64cdfcbfd0e3$export$84a62bf03b005a81 = (projectKey, boardId, isCompanyManaged, isUserBoard, isJSMBoard, // For testing purposes
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
pathname = window.location.pathname)=>{
    if (isJSMBoard) return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}?config=quickFilters`;
    if (isCompanyManaged) {
        if (isUserBoard) return `${pathname}?config=quickFilters`;
        return `/jira/software/c/projects/${projectKey}/boards/${boardId}${pathname.endsWith('backlog') ? '/backlog' : ''}?config=quickFilters`;
    }
    return `/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;
};
const $224b64cdfcbfd0e3$export$cd7b2f0d4c426239 = (allAssignees, participants)=>allAssignees.map((assignee)=>{
        if (assignee.id === (0, $15a528573ccd89ae$export$12e572fd459c10dc)) return assignee;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            ...assignee,
            presence: participants.some((participant)=>participant.clientId === assignee.id) ? (0, $15a528573ccd89ae$export$7a105aa475396c65) : (0, $15a528573ccd89ae$export$c9408e3fb31ddc71)
        };
    }).sort((a, b)=>{
        // sort by presence & keep current user as the first
        if (a.id === allAssignees[0].id) return -1;
        if (b.id === allAssignees[0].id) return 1;
        if (a.presence === (0, $15a528573ccd89ae$export$7a105aa475396c65)) return -1;
        if (b.presence === (0, $15a528573ccd89ae$export$7a105aa475396c65)) return 1;
        return 0;
    });

});


parcelRegister("361on", function(module, exports) {

$parcel$export(module.exports, "getNormalizedFilters", () => $d5949234e82f3596$export$459be3406d78c3a5);
$parcel$export(module.exports, "onFilterChangeStartInteraction", () => $d5949234e82f3596$export$568db3ec08ca631b);

var $7uUwQ = parcelRequire("7uUwQ");

var $gccSB = parcelRequire("gccSB");

var $4R6GH = parcelRequire("4R6GH");

const $d5949234e82f3596$export$459be3406d78c3a5 = (filters)=>{
    const chainedFilters = (0, $7uUwQ.chain)({}).setIn([
        (0, $15a528573ccd89ae$export$d597759d33be802e)
    ], filters[0, $15a528573ccd89ae$export$d597759d33be802e] ? filters[0, $15a528573ccd89ae$export$d597759d33be802e] : undefined).setIn([
        (0, $15a528573ccd89ae$export$37aee82a3cb1e8f7)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$37aee82a3cb1e8f7]) ? filters[0, $15a528573ccd89ae$export$37aee82a3cb1e8f7] : undefined).setIn([
        (0, $15a528573ccd89ae$export$2a4f270075a033de)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$2a4f270075a033de]) ? filters[0, $15a528573ccd89ae$export$2a4f270075a033de] : undefined).setIn([
        (0, $15a528573ccd89ae$export$f8f7545d2bb78afb)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$f8f7545d2bb78afb]) ? filters[0, $15a528573ccd89ae$export$f8f7545d2bb78afb] : undefined).setIn([
        (0, $15a528573ccd89ae$export$ebb48b08205007c5)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$ebb48b08205007c5]) ? filters[0, $15a528573ccd89ae$export$ebb48b08205007c5] : undefined).setIn([
        (0, $15a528573ccd89ae$export$a4ad2735b021c132)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$a4ad2735b021c132]) ? filters[0, $15a528573ccd89ae$export$a4ad2735b021c132] : undefined).setIn([
        (0, $15a528573ccd89ae$export$a316570a0dbfd2b0)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$a316570a0dbfd2b0]) ? filters[0, $15a528573ccd89ae$export$a316570a0dbfd2b0] : undefined).setIn([
        (0, $15a528573ccd89ae$export$92ab80c1dc9baf44)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$92ab80c1dc9baf44]) ? filters[0, $15a528573ccd89ae$export$92ab80c1dc9baf44] : undefined).setIn([
        (0, $15a528573ccd89ae$export$e50006273435e7d4)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$e50006273435e7d4]) ? filters[0, $15a528573ccd89ae$export$e50006273435e7d4] : undefined).setIn([
        (0, $15a528573ccd89ae$export$68d693c35a8d8866)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$68d693c35a8d8866]) ? filters[0, $15a528573ccd89ae$export$68d693c35a8d8866] : undefined).setIn([
        (0, $15a528573ccd89ae$export$f863b019d19144f4)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$f863b019d19144f4]) ? filters[0, $15a528573ccd89ae$export$f863b019d19144f4] : undefined).setIn([
        (0, $15a528573ccd89ae$export$401f4b6eda6a369c)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$401f4b6eda6a369c]) ? filters[0, $15a528573ccd89ae$export$401f4b6eda6a369c] : undefined);
    if ((0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) chainedFilters.setIn([
        (0, $15a528573ccd89ae$export$db362e2d293fe52e)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$db362e2d293fe52e]) ? filters[0, $15a528573ccd89ae$export$db362e2d293fe52e] : undefined);
    return chainedFilters.value();
};
const $d5949234e82f3596$export$568db3ec08ca631b = (filterType, onChangeInteractionStart, onCustomFilterChangeInteractionStart)=>{
    if (filterType === (0, $15a528573ccd89ae$export$68d693c35a8d8866)) onCustomFilterChangeInteractionStart();
    else onChangeInteractionStart();
};

});


parcelRegister("aGYrC", function(module, exports) {

$parcel$export(module.exports, "setInteractionFeedbackMark", () => $8d93a4680b7cb24a$export$2a56340540433ea3);
$parcel$export(module.exports, "setInteractionStartMark", () => $8d93a4680b7cb24a$export$1da8f59ae62c0e17);

var $hz3OZ = parcelRequire("hz3OZ");
const $8d93a4680b7cb24a$export$2a56340540433ea3 = ()=>{
    (0, $hz3OZ.filterInteraction).mark('feedback');
};
const $8d93a4680b7cb24a$export$1da8f59ae62c0e17 = ()=>{
    (0, $hz3OZ.filterInteraction).start();
};

});

parcelRegister("b9W8W", function(module, exports) {

$parcel$export(module.exports, "BoardCustomFilter", () => $5c951ba878a18e63$export$cc2433dd642ef843);

var $5uXOq = parcelRequire("5uXOq");

var $9vASA = parcelRequire("9vASA");

var $a4XJc = parcelRequire("a4XJc");

var $9pP0g = parcelRequire("9pP0g");

var $iDGXn = parcelRequire("iDGXn");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");

var $ckZbM = parcelRequire("ckZbM");
const $5c951ba878a18e63$var$BoardCustomFilterRedux = (props)=>{
    const boardId = (0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector));
    const filters = (0, $67sX6.useBoardSelector)((0, $5mTgl.getCustomFilters));
    const isFilterBarVisible = (0, $iDGXn.useShowQuickFilters)();
    const { toggleViewSetting: toggleViewSetting } = (0, $iDGXn.useViewSettingsActions)();
    const onToggleIsFilterBarVisible = (0, $5uXOq.useCallback)(()=>{
        if (boardId) toggleViewSetting({
            boardId: Number(boardId),
            view: (0, $a4XJc.View).BOARD,
            setting: (0, $9pP0g.ViewSetting).QUICK_FILTERS
        });
    }, [
        boardId,
        toggleViewSetting
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9vASA.default), {
        ...props,
        filters: filters,
        isPanelToggleChecked: isFilterBarVisible,
        onTogglePanel: onToggleIsFilterBarVisible,
        showPanelToggle: props.isCompanyManaged
    });
};
const $5c951ba878a18e63$export$cc2433dd642ef843 = (props)=>{
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    if (isCMPBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5c951ba878a18e63$var$BoardCustomFilterRedux, {
        ...props,
        isCompanyManaged: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ckZbM.BoardCustomFilterRelay), props);
};

});
parcelRegister("9vASA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c0f814f674e18a1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $14uhY = parcelRequire("14uhY");

var $96s6B = parcelRequire("96s6B");

var $78uGw = parcelRequire("78uGw");
const $0c0f814f674e18a1$var$MAX_SELECTION_ALLOWED = 10;
const $0c0f814f674e18a1$var$CustomFilter = ({ filters: filters = [], selectedFilters: selectedFilters = [], showLink: showLink = false, manageUrl: manageUrl = '', onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false, isCompanyManaged: isCompanyManaged = false, isPanelToggleChecked: isPanelToggleChecked = false, onTogglePanel: onTogglePanel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), showPanelToggle: showPanelToggle = false, shouldReturnFocus: shouldReturnFocus })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>filters.map((filter)=>({
                label: filter.name,
                value: filter.id
            })), [
        filters
    ]);
    const onChangeMapValues = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    const maxSelectionReachedTooltip = formatMessage((0, $78uGw.default).maxSelectionReachedTooltip, {
        maxSelectionAllowed: $0c0f814f674e18a1$var$MAX_SELECTION_ALLOWED
    });
    const onLinkItemClick = (0, $5uXOq.useCallback)(()=>{
        (0, $14uhY.setReturnToProjectUrl)();
    }, []);
    const filterLabel = isCompanyManaged ? (0, $78uGw.default).labelCmp : (0, $78uGw.default).label;
    const manageLinkTitle = isCompanyManaged ? (0, $78uGw.default).manageLinkTitleCmp : (0, $78uGw.default).manageLinkTitle;
    const toggleLabel = isCompanyManaged ? formatMessage((0, $78uGw.default).toggleLabelCmp) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        shouldReturnFocus: shouldReturnFocus,
        buttonType: "QuickFilters",
        "data-testid": "filters.ui.filters.custom.assignee-filter",
        label: formatMessage(filterLabel),
        values: values,
        selectedValues: selectedFilters,
        onChange: onChangeMapValues,
        showLink: showLink,
        url: manageUrl,
        useHrefForUrl: isCompanyManaged,
        linkTitle: formatMessage(manageLinkTitle),
        maxSelectionAllowed: isCompanyManaged ? undefined : $0c0f814f674e18a1$var$MAX_SELECTION_ALLOWED,
        maxSelectionReachedTooltip: maxSelectionReachedTooltip,
        isNested: isNested,
        onLinkItemClick: onLinkItemClick,
        showPanelToggle: showPanelToggle,
        onTogglePanel: onTogglePanel,
        isPanelToggleChecked: isPanelToggleChecked,
        toggleLabel: toggleLabel
    });
};
const $0c0f814f674e18a1$var$CustomFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($0c0f814f674e18a1$var$CustomFilter);
$0c0f814f674e18a1$var$CustomFilterComponent.displayName = 'CustomFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$0c0f814f674e18a1$var$CustomFilterComponent.whyDidYouRender = true;
var $0c0f814f674e18a1$export$2e2bcd8739ae039 = $0c0f814f674e18a1$var$CustomFilterComponent;

});
parcelRegister("78uGw", function(module, exports) {

$parcel$export(module.exports, "default", () => $cad440f119fd51b3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cad440f119fd51b3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.custom.label",
        "defaultMessage": "Custom filters"
    },
    labelCmp: {
        "id": "software-filters.filters.custom.label-cmp",
        "defaultMessage": "Quick filters"
    },
    manageLinkTitle: {
        "id": "software-filters.filters.custom.manage-link-title",
        "defaultMessage": "Manage custom filters"
    },
    manageLinkTitleCmp: {
        "id": "software-filters.filters.custom.manage-link-title-cmp",
        "defaultMessage": "Manage quick filters"
    },
    maxSelectionReachedTooltip: {
        "id": "software-filters.filters.custom.max-selection-reached-tooltip",
        "defaultMessage": "You can't select more than {maxSelectionAllowed} custom filters"
    },
    toggleLabelCmp: {
        "id": "software-filters.filters.custom.toggle-label-cmp",
        "defaultMessage": "Show quick filters"
    }
});

});


parcelRegister("ckZbM", function(module, exports) {

$parcel$export(module.exports, "BoardCustomFilterRelay", () => $bfb3750039921446$export$1f37f3529982b959);

var $e59ii = parcelRequire("e59ii");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $05fhZ = parcelRequire("05fhZ");
const $bfb3750039921446$export$1f37f3529982b959 = ({ customFiltersQueryRef: customFiltersQueryRef, ...props })=>{
    const customFiltersFragmentRef = (0, $8Uumt.usePreloadedQuery)((0, $e59ii.default), customFiltersQueryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $05fhZ.default), {
        customFiltersFragmentRef: customFiltersFragmentRef,
        ...props
    });
};

});
parcelRegister("e59ii", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bec6ab78b3c2929$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d66617b87c0114dec14f52268752a6b1>>
 * @relayHash fa277d121f8f09e75035802d7ede6889
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b

var $eiowN = parcelRequire("eiowN");
const $1bec6ab78b3c2929$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewBoardCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "customFilter_softwareFilters_CustomFilterRelay"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewBoardCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b",
            "metadata": {},
            "name": "viewBoardCustomFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1bec6ab78b3c2929$var$node.hash = "059c408527e2b921d6b2e3d9305090e3";
(0, $eiowN.PreloadableQueryRegistry).set($1bec6ab78b3c2929$var$node.params.id, $1bec6ab78b3c2929$var$node);
var $1bec6ab78b3c2929$export$2e2bcd8739ae039 = $1bec6ab78b3c2929$var$node;

});

parcelRegister("05fhZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $17d2b93146d18158$export$2e2bcd8739ae039);

var $fKrqu = parcelRequire("fKrqu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $9vASA = parcelRequire("9vASA");

var $5oFIy = parcelRequire("5oFIy");
const $17d2b93146d18158$var$CustomFilterRelay = ({ customFiltersFragmentRef: customFiltersFragmentRef, screenName: screenName, ...props })=>{
    const { boardScope: boardScope } = (0, $8Uumt.useFragment)((0, $fKrqu.default), customFiltersFragmentRef);
    // each item in an array is nullable & an object's keys readonly in relay's generated type
    const filters = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ()=>boardScope?.customFilters.filter(Boolean) || [], [
        boardScope?.customFilters
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9vASA.default), {
        ...props,
        filters: filters
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        actionSubject: "ui",
        action: "taskSuccess",
        attributes: {
            screenName: screenName,
            task: 'loadCustomFilters',
            customFiltersCount: filters.length
        }
    }));
};
var $17d2b93146d18158$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($17d2b93146d18158$var$CustomFilterRelay);

});
parcelRegister("fKrqu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d300f59e5c1532b6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<27f6e515959b3fa71c98f3b9ea403490>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d300f59e5c1532b6$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ],
    "kind": "Fragment",
    "name": "customFilter_softwareFilters_CustomFilterRelay",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "boardId",
                        "variableName": "boardId"
                    }
                ],
                "concreteType": "BoardScope",
                "kind": "LinkedField",
                "name": "boardScope",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.customFilters.id"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.customFilters.name"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "boardScope.customFilters"
                    }
                ]
            },
            "action": "THROW",
            "path": "boardScope"
        }
    ],
    "type": "Query"
};
$d300f59e5c1532b6$var$node.hash = "ae7389daa2b7626fc0f4f542c785e41f";
var $d300f59e5c1532b6$export$2e2bcd8739ae039 = $d300f59e5c1532b6$var$node;

});




const $70866c33bb205617$export$d339888a30f06bf4 = 'viewBoardFilterBar';
const $70866c33bb205617$export$dc37b1e8e15e9923 = 'ng-board-filter-bar';
const $70866c33bb205617$export$b110169935468339 = 'ng-board-filter-bar';

parcelRegister("brhcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c33f97ad431348d9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c33f97ad431348d9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    textFilter: {
        "id": "software.main.header.controls-bar.filter-bar.text-filter",
        "defaultMessage": "Search"
    },
    screenReaderInstruction: {
        "id": "software.main.header.controls-bar.filter-bar.screen-reader-instruction",
        "defaultMessage": "As you type to search or apply filters, the board updates with issues to match."
    },
    filterPlaceholder: {
        "id": "software.main.header.controls-bar.filter-bar.filter-placeholder",
        "defaultMessage": "Search board"
    },
    screenReaderInstructionIssueTermRefresh: {
        "id": "software.main.header.controls-bar.filter-bar.screen-reader-instruction-issue-term-refresh",
        "defaultMessage": "As you type to search or apply filters, the board updates with issues to match."
    }
});

});



parcelRegister("fUeOV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0163544a3dd31482$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $iU0UM = parcelRequire("iU0UM");


var $67sX6 = parcelRequire("67sX6");

var $dnW4F = parcelRequire("dnW4F");

var $5mTgl = parcelRequire("5mTgl");
const $0163544a3dd31482$var$FilterSelectionBar = ()=>{
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const allSelectedWorkFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $67sX6.useBoardSelector)((0, $5mTgl.getWorkFilters)), 'values');
    const selectedCustomFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(allSelectedWorkFilters, (0, $dcff40112356dfc1$export$68d693c35a8d8866));
    const selectedCustomFiltersSet = (0, $5uXOq.useMemo)(()=>new Set(selectedCustomFilters), [
        selectedCustomFilters
    ]);
    const allCustomFilters = (0, $67sX6.useBoardSelector)((0, $5mTgl.getCustomFilters));
    const onChange = (0, $5uXOq.useCallback)((filters, analyticsEvent)=>{
        dispatch((0, $dnW4F.setAllFilters)({
            ...allSelectedWorkFilters,
            ...filters
        }, (0, $dcff40112356dfc1$export$68d693c35a8d8866), analyticsEvent));
    }, [
        allSelectedWorkFilters,
        dispatch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iU0UM.default), {
        filters: allCustomFilters,
        selectedFilters: selectedCustomFiltersSet,
        onChange: onChange
    });
};
var $0163544a3dd31482$export$2e2bcd8739ae039 = $0163544a3dd31482$var$FilterSelectionBar;

});
parcelRegister("iU0UM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8822a2681eb1c63b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $caqPj = parcelRequire("caqPj");

var $euWQZ = parcelRequire("euWQZ");
const $8822a2681eb1c63b$var$FilterSelectionBar = ({ onChange: onChange, selectedFilters: selectedFilters, filters: filters })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("fieldset", {
        "data-testid": "software-filters.ui.filter-selection-bar.filter-selection-bar",
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1reo1g80 _18m91g80 _1e0c1txw _zulpu2gc _19pku2gc _1n261g80 _qtt8glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("legend", {
        className: (0, $bwpsq.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw"
        ])
    }, formatMessage((0, $euWQZ.default).filterToolBarAriaLabel)), filters.map((filter)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $caqPj.default), {
            key: `filter-option-${filter.id}`,
            onChange: onChange,
            selectedFilters: selectedFilters,
            filter: filter
        })));
};
var $8822a2681eb1c63b$export$2e2bcd8739ae039 = $8822a2681eb1c63b$var$FilterSelectionBar;
const $8822a2681eb1c63b$var$styles = null;

});
parcelRegister("caqPj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ef490007e1102a8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $2NMNM = parcelRequire("2NMNM");

var $a38Ao = parcelRequire("a38Ao");

var $5MHig = parcelRequire("5MHig");
const $8ef490007e1102a8$var$FilterOption = (props)=>{
    const { onChange: onChange, selectedFilters: selectedFilters, filter: filter } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isSelected = (0, $5uXOq.useMemo)(()=>selectedFilters.has(filter.id), [
        selectedFilters,
        filter
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (isSelected) selectedFilters.delete(filter.id);
        else selectedFilters.add(filter.id);
        onChange({
            CUSTOM_FILTER: Array.from(selectedFilters)
        }, createAnalyticsEvent({}));
    }, [
        onChange,
        filter,
        isSelected,
        selectedFilters,
        createAnalyticsEvent
    ]);
    const id = `checkbox-id-${filter.name}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: filter.description,
        position: "bottom",
        "data-testid": "software-filters.ui.filter-selection-bar.filter-option.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8ef490007e1102a8$var$maxWidthWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a38Ao.default), {
        id: id,
        checked: isSelected,
        onChange: onClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        id: id,
        isSelected: isSelected,
        component: (0, $5MHig.default)
    }, filter.name)));
};
var $8ef490007e1102a8$export$2e2bcd8739ae039 = $8ef490007e1102a8$var$FilterOption;
const $8ef490007e1102a8$var$maxWidthWrapperStyles = (0, $8CUq3.xcss)({
    maxWidth: '380px'
});

});
parcelRegister("a38Ao", function(module, exports) {

$parcel$export(module.exports, "default", () => $9843dc35bcc8c6ea$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $9843dc35bcc8c6ea$var$HiddenCheckbox = (props)=>{
    const { id: id, checked: checked, onChange: onChange } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        id: id,
        type: "checkbox",
        checked: checked,
        onChange: onChange,
        className: (0, $bwpsq.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _81qx24b2 _ui4mv77o"
        ])
    });
};
var $9843dc35bcc8c6ea$export$2e2bcd8739ae039 = $9843dc35bcc8c6ea$var$HiddenCheckbox;
const $9843dc35bcc8c6ea$var$styles = null;

});

parcelRegister("5MHig", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd0acb68a7fed3bf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $dd0acb68a7fed3bf$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        ref: ref,
        htmlFor: props.id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_uiztglyw",
            props.className
        ]),
        // eslint-disable-next-line react/no-children-prop
        children: props.children
    }));
var $dd0acb68a7fed3bf$export$2e2bcd8739ae039 = $dd0acb68a7fed3bf$var$Label;
const $dd0acb68a7fed3bf$var$styles = null;

});


parcelRegister("euWQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d55c59fbc57ecf3b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d55c59fbc57ecf3b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filterToolBarAriaLabel: {
        "id": "software-filters.filter-selection-bar.filter-tool-bar-aria-label",
        "defaultMessage": "filter tool bar"
    }
});

});



parcelRegister("hkLPk", function(module, exports) {

$parcel$export(module.exports, "FullscreenButton", () => $491ac5a3bdbb4c25$export$305be705ce696d42);

var $5uXOq = parcelRequire("5uXOq");

var $99BAr = parcelRequire("99BAr");

var $iDGXn = parcelRequire("iDGXn");

var $2xFXk = parcelRequire("2xFXk");

var $63LqY = parcelRequire("63LqY");
const $491ac5a3bdbb4c25$var$getFullscreenRefs = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
    Array.from(document.querySelectorAll('[data-fullscreen-id]'));
const $491ac5a3bdbb4c25$export$305be705ce696d42 = ({ boardId: boardId, shouldRenderContent: shouldRenderContent })=>{
    const { setIsFullscreen: setIsFullscreen } = (0, $iDGXn.useViewSettingsActions)();
    const isFullscreen = (0, $iDGXn.useIsFullscreen)();
    const isTabNavigation = (0, $63LqY.useCapability)((0, $2xFXk.Capability).IS_TAB_NAVIGATION);
    const handleFullscreenToggle = (0, $5uXOq.useCallback)((wasFullscreen)=>{
        setIsFullscreen({
            boardId: boardId,
            isFullscreen: !wasFullscreen
        });
    }, [
        boardId,
        setIsFullscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99BAr.default), {
        testId: "software-board.header.controls-bar.fullscreen-button.fullscreen-button",
        getCustomRefs: $491ac5a3bdbb4c25$var$getFullscreenRefs,
        withContainerStyles: false,
        onToggle: handleFullscreenToggle,
        isFullscreen: isFullscreen,
        renderAsResponsiveButton: isTabNavigation,
        shouldRenderContent: shouldRenderContent
    });
};

});
parcelRegister("99BAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6d923fac0cd07eb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $gucb2 = parcelRequire("gucb2");

const $d6d923fac0cd07eb$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: analyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle })=>{
    const [isFullscreenState, setIsFullscreenState] = (0, $5uXOq.useState)(isFullscreenProp ?? defaultFullscreen);
    const isFullscreen = isFullscreenProp ?? isFullscreenState;
    const handleToggle = (wasFullscreen, globalStyle)=>{
        onToggle(wasFullscreen, globalStyle);
        setIsFullscreenState(!wasFullscreen);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gucb2.default), {
        testId: testId,
        onToggle: handleToggle,
        getCustomRefs: getCustomRefs,
        analyticsAttributes: analyticsAttributes,
        withContainerStyles: withContainerStyles,
        defaultFullscreen: defaultFullscreen,
        isFullscreen: isFullscreen,
        renderAsResponsiveButton: renderAsResponsiveButton,
        shouldRenderContent: shouldRenderContent,
        isSubtle: isSubtle
    });
};
$d6d923fac0cd07eb$var$FullscreenButton.defaultProps = {
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    getCustomRefs: ()=>[],
    analyticsAttributes: {}
};
var $d6d923fac0cd07eb$export$2e2bcd8739ae039 = $d6d923fac0cd07eb$var$FullscreenButton;

});
parcelRegister("gucb2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59079bf3589c5a6$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $5JpK2 = parcelRequire("5JpK2");

var $j2iKG = parcelRequire("j2iKG");

var $3bDjY = parcelRequire("3bDjY");

var $3Tty1 = parcelRequire("3Tty1");

var $koVbs = parcelRequire("koVbs");

var $g7crU = parcelRequire("g7crU");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");

var $6lmg7 = parcelRequire("6lmg7");

var $dCm1o = parcelRequire("dCm1o");

var $gydfO = parcelRequire("gydfO");
const $f59079bf3589c5a6$var$removeFullScreenStyle = (customRefs)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.getElementById('fullscreen-global-style')?.remove();
    if (customRefs) customRefs.forEach((ref)=>{
        if (ref !== null) ref.classList.remove('fullscreen');
    });
};
const $f59079bf3589c5a6$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: extraAnalyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const customRefElements = (0, $5uXOq.useRef)(null);
    const [isFullscreenLayout, { setIsFullscreen: setIsFullScreenLayout }] = (0, $g7crU.useIsFullscreen)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const globalStyle = document.createElement('style');
    const isFullscreen = (0, $3HwlS.getWillShowNav4)() ? isFullscreenLayout : isFullscreenProp;
    const handleKeysInFullScreen = (0, $5uXOq.useCallback)((e)=>{
        // Ignore if it looks like the user is typing something
        if (e.target instanceof HTMLElement && ([
            'INPUT',
            'TEXTAREA',
            'SELECT'
        ].includes(e.target.tagName.toUpperCase()) || e.target.hasAttribute('contenteditable'))) return;
         // Prevent shortcuts
        const shortcutKeysToPrevent = [
            '/',
            // search
            'h' // help
        ];
        if (shortcutKeysToPrevent.includes(e.key)) e.stopPropagation();
        const navigationShortcuts = [
            '1',
            '2',
            '3',
            '4' // number keys
        ];
        if (!(0, $3HwlS.getWillShowNav4)() && navigationShortcuts.includes(e.key)) {
            // In Nav4 these keyboard shortcuts are rendered by the tab navigation
            // so they are not available in fullscreen mode
            onToggle(true, globalStyle);
            const customRefs = customRefElements.current;
            $f59079bf3589c5a6$var$removeFullScreenStyle(customRefs);
        }
    }, [
        globalStyle,
        onToggle
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isFullscreen) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.addEventListener('keydown', handleKeysInFullScreen, true);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.removeEventListener('keydown', handleKeysInFullScreen, true);
         // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return ()=>window?.removeEventListener('keydown', handleKeysInFullScreen, true);
    }, [
        isFullscreen,
        handleKeysInFullScreen
    ]);
    const createFullScreenStyle = (0, $5uXOq.useCallback)(()=>{
        const customElements = customRefElements.current;
        const hiddenStyles = "#ak-jira-navigation, #ak-side-navigation, #right-sidebar-panel-wrapper, [data-skip-link-wrapper='true'] { display: none }"; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const hiddenStylesNode = document.createTextNode(hiddenStyles);
        globalStyle.id = 'fullscreen-global-style';
        globalStyle.appendChild(hiddenStylesNode);
        if (customElements) customElements.forEach((ref)=>{
            if (ref !== null) ref.classList.add('fullscreen');
        });
         // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.head?.appendChild(globalStyle);
    }, [
        globalStyle
    ]);
    const onClick = (event, analyticsEvent)=>{
        if ((0, $3HwlS.getWillShowNav4)()) {
            const analyticsAttributes = {
                ...extraAnalyticsAttributes,
                expandToFullscreen: !isFullscreenLayout
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
            setIsFullScreenLayout(!isFullscreenLayout);
            onToggle(!isFullscreenLayout);
        } else {
            customRefElements.current = getCustomRefs();
            const customElements = customRefElements.current;
            const analyticsAttributes = {
                ...extraAnalyticsAttributes,
                expandToFullscreen: !isFullscreen
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
            onToggle(isFullscreen, globalStyle);
            if (isFullscreen) $f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
            else createFullScreenStyle();
        }
    };
    (0, $5uXOq.useEffect)(()=>{
        customRefElements.current = getCustomRefs();
        const customElements = customRefElements.current;
        if (isFullscreen) createFullScreenStyle();
        else $f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
        return ()=>$f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
    }, [
        createFullScreenStyle,
        getCustomRefs,
        isFullscreen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (defaultFullscreen) createFullScreenStyle();
         // Empty dependency array to only apply fullscreen styling once (on mount).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        // exit fullscreen mode when moving to a different page
        return ()=>{
            if ((0, $3HwlS.getWillShowNav4)()) setIsFullScreenLayout(false);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const renderButtonWithTooltip = ()=>{
        if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            ...withContainerStyles ? {
                testId: testId
            } : {
                testId: 'platform.ui.fullscreen-button.fullscreen-button'
            },
            label: isFullscreen ? formatMessage((0, $gydfO.default).exitFullScreen) : formatMessage((0, $gydfO.default).enterFullScreen),
            onClick: onClick,
            icon: isFullscreen ? (0, (/*@__PURE__*/$parcel$interopDefault($j2iKG))) : (0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))),
            appearance: isSubtle ? 'subtle' : 'default',
            isTooltipDisabled: false
        });
        if (renderAsResponsiveButton && !(0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6lmg7.ResponsiveButton), {
            label: isFullscreen ? formatMessage((0, $gydfO.default).exitFullScreen) : formatMessage((0, $gydfO.default).enterFullScreen),
            icon: isFullscreen ? (0, (/*@__PURE__*/$parcel$interopDefault($j2iKG))) : (0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))),
            onClick: onClick,
            testId: testId ?? 'platform.ui.fullscreen-button.fullscreen-button'
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage(isFullscreen ? (0, $gydfO.default).exitFullScreen : (0, $gydfO.default).enterFullScreen),
            position: "top-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...withContainerStyles ? {
                testId: testId
            } : {
                testId: 'platform.ui.fullscreen-button.fullscreen-button'
            },
            appearance: "subtle",
            onClick: onClick,
            iconBefore: isFullscreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j2iKG))), {
                color: "var(--ds-icon, #44546F)",
                label: formatMessage((0, $gydfO.default).exitFullScreen),
                spacing: "spacious"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))), {
                color: "var(--ds-icon, #44546F)",
                label: formatMessage((0, $gydfO.default).enterFullScreen),
                spacing: "spacious"
            })
        }));
    };
    const keyMap = {
        z: {
            callback: ()=>{
                setIsFullScreenLayout(!isFullscreenLayout);
            }
        }
    };
    if (!shouldRenderContent) return null;
    return withContainerStyles ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f59079bf3589c5a6$var$FullscreenButtonContainer, {
        "data-testid": "platform.ui.fullscreen-button.fullscreen-button"
    }, renderButtonWithTooltip(), (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: keyMap
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderButtonWithTooltip(), (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: keyMap
    }));
};
var $f59079bf3589c5a6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f59079bf3589c5a6$var$FullscreenButton;
const $f59079bf3589c5a6$var$FullscreenButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _bfhk1bhr _16qsrs09 _2rko1sit",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5JpK2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a044223350e041031a35374685e9a4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42c51f70ef43f1c0$var$_react = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $42c51f70ef43f1c0$var$_growDiagonal = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("l14Zy")));

var $42c51f70ef43f1c0$var$_actualSize = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("6LXPU")));
function $42c51f70ef43f1c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42c51f70ef43f1c0$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $42c51f70ef43f1c0$var$_react.default.createElement($42c51f70ef43f1c0$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $42c51f70ef43f1c0$var$_actualSize.default
    }, props));
$42c51f70ef43f1c0$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $42c51f70ef43f1c0$var$_default = module.exports.default = $42c51f70ef43f1c0$var$GrowDiagonalIcon;

});
parcelRegister("l14Zy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f990ef7feacad13ce09338893186ed73>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f4cd903aabaa4c53$var$_react = $f4cd903aabaa4c53$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f4cd903aabaa4c53$var$_UNSAFE_baseNew = $f4cd903aabaa4c53$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $f4cd903aabaa4c53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f4cd903aabaa4c53$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $f4cd903aabaa4c53$var$_react.default.createElement($f4cd903aabaa4c53$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m7 9-4.75 4.75M9 7l4.75-4.75m-12 7.25v4.75H6.5m7.75-7.75V1.75H9.5"/>`
    }, props));
$f4cd903aabaa4c53$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $f4cd903aabaa4c53$var$_default = module.exports.default = $f4cd903aabaa4c53$var$GrowDiagonalIcon;

});

parcelRegister("6LXPU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4ee58c13163bfe09$var$_react = $4ee58c13163bfe09$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4ee58c13163bfe09$var$_growDiagonal = $4ee58c13163bfe09$var$_interopRequireDefault((parcelRequire("l14Zy")));
function $4ee58c13163bfe09$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4ee58c13163bfe09$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $4ee58c13163bfe09$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props, {
        newIcon: $4ee58c13163bfe09$var$_growDiagonal.default
    }));
$4ee58c13163bfe09$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $4ee58c13163bfe09$var$_default = module.exports.default = $4ee58c13163bfe09$var$MediaServicesActualSizeIcon;

});


parcelRegister("j2iKG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b2e8bb6e01e7e0a7a6c4696ef5279cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ddbcbff50c42c269$var$_react = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ddbcbff50c42c269$var$_shrinkDiagonal = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("8KRBa")));

var $ddbcbff50c42c269$var$_fitToPage = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("2bcm3")));
function $ddbcbff50c42c269$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShrinkDiagonalIcon.
 * This component is ShrinkDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesFitToPageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ddbcbff50c42c269$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $ddbcbff50c42c269$var$_react.default.createElement($ddbcbff50c42c269$var$_shrinkDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $ddbcbff50c42c269$var$_fitToPage.default
    }, props));
$ddbcbff50c42c269$var$ShrinkDiagonalIcon.Name = 'ShrinkDiagonalIconMigration';
var $ddbcbff50c42c269$var$_default = module.exports.default = $ddbcbff50c42c269$var$ShrinkDiagonalIcon;

});
parcelRegister("8KRBa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::093b1e9b17ed5e0dd45627fbe3b0508b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65fc322a3db160cb$var$_react = $65fc322a3db160cb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $65fc322a3db160cb$var$_UNSAFE_baseNew = $65fc322a3db160cb$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $65fc322a3db160cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShrinkDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $65fc322a3db160cb$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $65fc322a3db160cb$var$_react.default.createElement($65fc322a3db160cb$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 14.5 5.25-5.25M14.5 1.5 9.25 6.75M6.75 14V9.25H2M9.25 2v4.75H14"/>`
    }, props));
$65fc322a3db160cb$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
var $65fc322a3db160cb$var$_default = module.exports.default = $65fc322a3db160cb$var$ShrinkDiagonalIcon;

});

parcelRegister("2bcm3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1966313a87133c34$var$_react = $1966313a87133c34$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $1966313a87133c34$var$_shrinkDiagonal = $1966313a87133c34$var$_interopRequireDefault((parcelRequire("8KRBa")));
function $1966313a87133c34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1966313a87133c34$var$MediaServicesFitToPageIcon = (props)=>/*#__PURE__*/ $1966313a87133c34$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.413 8.997H18A1 1 0 0 1 18 11h-3.9l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 13 9.946V6.002a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374zm-8.826 6.006H6A1 1 0 0 1 6 13h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0v-1.587l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374z"/></svg>`
    }, props, {
        newIcon: $1966313a87133c34$var$_shrinkDiagonal.default
    }));
$1966313a87133c34$var$MediaServicesFitToPageIcon.displayName = 'MediaServicesFitToPageIcon';
var $1966313a87133c34$var$_default = module.exports.default = $1966313a87133c34$var$MediaServicesFitToPageIcon;

});


parcelRegister("gydfO", function(module, exports) {

$parcel$export(module.exports, "default", () => $50014cef8f43c127$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50014cef8f43c127$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    enterFullScreen: {
        "id": "platform.fullscreen-button.enter-full-screen",
        "defaultMessage": "Enter full screen"
    },
    exitFullScreen: {
        "id": "platform.fullscreen-button.exit-full-screen",
        "defaultMessage": "Exit full screen"
    }
});

});




parcelRegister("7Nytu", function(module, exports) {

$parcel$export(module.exports, "default", () => $0060f62fca5ba1d1$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $gJBT6 = parcelRequire("gJBT6");

var $bC2fB = parcelRequire("bC2fB");


var $k50Aq = parcelRequire("k50Aq");

var $1vXOx = parcelRequire("1vXOx");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $b22uy = parcelRequire("b22uy");
const $0060f62fca5ba1d1$var$getExternalValues = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((boardId, projectId)=>({
        boardId: boardId,
        projectId: projectId
    }), (boardId, projectId)=>`${boardId}.${projectId}`);
const $0060f62fca5ba1d1$var$connector = (0, $bC2fB.connect)((state)=>({
        externalId: 'software.board.swimlane',
        externalValues: $0060f62fca5ba1d1$var$getExternalValues((0, $67Z81.rapidViewIdSelector)(state), (0, $67Z81.projectIdSelector)(state)),
        swimlaneModes: (0, $45cXl.getSwimlaneModes)(state),
        currentSwimlaneMode: (0, $45cXl.getSwimlaneMode)(state),
        isUserProjectAdmin: (0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df] && !(0, $67Z81.getIsCMPBoard)(state)
    }), (dispatch)=>({
        setSwimlaneMode: (swimlaneModeId)=>{
            dispatch((0, $k50Aq.swimlaneModeChangeRequest)(swimlaneModeId));
        }
    }), (stateProps, dispatchProps, ownProps)=>{
    const { isUserProjectAdmin: isUserProjectAdmin, ...restStateProps } = stateProps;
    return {
        ...ownProps,
        ...dispatchProps,
        ...restStateProps
    };
});
var $0060f62fca5ba1d1$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))($0060f62fca5ba1d1$var$connector)((0, $b22uy.default));

});
parcelRegister("b22uy", function(module, exports) {

$parcel$export(module.exports, "default", () => $68ae893d6be01501$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $6Ingq = parcelRequire("6Ingq");

var $hORKG = parcelRequire("hORKG");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $iuuJH = parcelRequire("iuuJH");

var $f3Btq = parcelRequire("f3Btq");
const $68ae893d6be01501$var$SwimlaneSwitch = ({ swimlaneModes: swimlaneModes, setSwimlaneMode: setSwimlaneMode, currentSwimlaneMode: currentSwimlaneMode })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5uXOq.useState)(false);
    const dropdownMenuRef = (0, $5uXOq.useRef)(null);
    const onCloseFocusHandler = ()=>{
        requestAnimationFrame(()=>dropdownMenuRef.current?.querySelector('button')?.focus());
    };
    const onDropdownOpenChange = ({ isOpen: isOpen })=>{
        setIsDropdownOpen(isOpen);
        if (!isOpen) onCloseFocusHandler();
    };
    const renderTrigger = (0, $5uXOq.useCallback)(({ triggerRef: triggerRef, ...triggerProps })=>{
        const swimlaneMode = swimlaneModes.find(({ id: id })=>id === currentSwimlaneMode) || (0, $iuuJH.NO_SWIMLANE);
        let swimlaneModeText = formatMessage(swimlaneMode.message, swimlaneMode.values);
        if ((0, $dCm1o.isVisualRefreshEnabled)()) swimlaneModeText = swimlaneMode && swimlaneMode.id !== (0, $iuuJH.NO_SWIMLANE).id ? formatMessage(swimlaneMode.message, swimlaneMode.values) : '';
        // Hide the icon if there is swimlane mode text
        const iconAfter = // eslint-disable-next-line no-nested-ternary
        (0, $dCm1o.isVisualRefreshEnabled)() && swimlaneModeText ? undefined : (0, $4R6GH.fg)('tnk-1613-jira-visual-refresh-jsw-board-icons-2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))),
            LEGACY_size: "medium",
            color: "var(--ds-icon, #44546f)",
            LEGACY_primaryColor: "var(--ds-icon, #44546f)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))), {
            size: "medium",
            label: "",
            primaryColor: "var(--ds-icon, #44546f)"
        });
        const trigger = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...triggerProps,
            ref: triggerRef,
            id: "swimlane-switch-menu-trigger",
            "aria-label": (0, $dCm1o.isVisualRefreshEnabled)() ? formatMessage((0, $f3Btq.default).groupCardsByAccessability, {
                label: swimlaneModeText
            }) : undefined,
            iconAfter: iconAfter,
            isSelected: triggerProps.isSelected || (0, $dCm1o.isVisualRefreshEnabled)() && Boolean(swimlaneModeText)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68ae893d6be01501$var$TriggerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68ae893d6be01501$var$TriggerLabel, null, !(0, $dCm1o.isVisualRefreshEnabled)() && swimlaneModeText, (0, $dCm1o.isVisualRefreshEnabled)() && formatMessage((0, $f3Btq.default).groupCardsBy), swimlaneModeText && (0, $dCm1o.isVisualRefreshEnabled)() && `: ${swimlaneModeText}`)));
        return isDropdownOpen ? trigger : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: swimlaneModeText
        }, trigger);
    }, [
        currentSwimlaneMode,
        formatMessage,
        isDropdownOpen,
        swimlaneModes
    ]);
    const onDropdownItemClick = (0, $5uXOq.useCallback)((swimlaneModeId)=>()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'dropdownItem',
                action: 'clicked'
            }), {
                name: 'setSwimlaneMode',
                swimlaneMode: swimlaneModeId
            });
            setSwimlaneMode(swimlaneModeId);
        }, [
        setSwimlaneMode,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68ae893d6be01501$var$SwimlaneSwitchContainer, {
        "data-testid": "software-board.header.controls-bar.swimlane-switch",
        ref: dropdownMenuRef
    }, !(0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68ae893d6be01501$var$SwimlaneSwitchLabel, {
        htmlFor: "swimlane-switch-menu-trigger"
    }, formatMessage((0, $f3Btq.default).groupCardsByOld)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        isOpen: isDropdownOpen,
        onOpenChange: onDropdownOpenChange,
        trigger: renderTrigger,
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, swimlaneModes.map(({ id: id, message: message, values: values })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            key: id,
            "data-testid": "software-board.header.controls-bar.swimlane-switch.dropdown-item",
            onClick: onDropdownItemClick(id)
        }, formatMessage(message, values))))));
};
var $68ae893d6be01501$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $68ae893d6be01501$var$SwimlaneSwitch;
const $68ae893d6be01501$var$SwimlaneSwitchContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $68ae893d6be01501$var$SwimlaneSwitchLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81vlj _syaz131l _1p1dangw _1yt4h8dc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $68ae893d6be01501$var$TriggerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $68ae893d6be01501$var$TriggerLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f68cl _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("f3Btq", function(module, exports) {

$parcel$export(module.exports, "default", () => $233854cd8bbff9a4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $233854cd8bbff9a4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    groupCardsByOld: {
        "id": "software.main.header.controls-bar.swimlane-switch.group-cards-by-old",
        "defaultMessage": "Group by"
    },
    groupCardsBy: {
        "id": "software.main.header.controls-bar.swimlane-switch.group-cards-by",
        "defaultMessage": "Group"
    },
    groupCardsByAccessability: {
        "id": "software.main.header.controls-bar.swimlane-switch.group-cards-by-accessability",
        "defaultMessage": "Group by {label}"
    }
});

});



parcelRegister("fjK71", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a9dc3df02e64325$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $kgiLc = parcelRequire("kgiLc");


var $iuuJH = parcelRequire("iuuJH");

var $bRqd3 = parcelRequire("bRqd3");

var $2ON1s = parcelRequire("2ON1s");

var $k50Aq = parcelRequire("k50Aq");

var $6g14V = parcelRequire("6g14V");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");

var $7Rvok = parcelRequire("7Rvok");
const $0a9dc3df02e64325$export$c31df4bd766f9c35 = (state)=>{
    const hasSwimlanes = (0, $45cXl.getSwimlaneMode)(state) !== (0, $iuuJH.NO_SWIMLANE).id;
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    const isViewSettingPanelOpen = (0, $6g14V.getViewSettingsPanel)(state);
    return {
        rapidViewId: Number((0, $67Z81.rapidViewIdSelector)(state)),
        swimlaneIds: (0, $5mTgl.platformSwimlaneIdsSelector)(state),
        isClassic: isCMPBoard,
        hasSwimlanes: hasSwimlanes,
        epicCustomName: (0, $67Z81.getHierarchyNomenclature)(state)?.firstLevelName,
        isViewSettingPanelOpen: isViewSettingPanelOpen
    };
};
const $0a9dc3df02e64325$var$mapDispatchToProps = (dispatch)=>({
        onSwimlaneExpandAll: ()=>{
            dispatch((0, $k50Aq.swimlanesExpand)());
        },
        onSwimlaneCollapseAll: (swimlaneIds, isIPBoard)=>{
            // For the program board, we want to collapse all the swimlanes in the unplanned work column as well
            const swimlanesToCollapseIds = isIPBoard ? swimlaneIds.reduce((acc, id)=>{
                acc.push(id, (0, $kgiLc.appendUnscheduledWorkSwimlaneIdSuffix)(id));
                return acc;
            }, []) : swimlaneIds;
            dispatch((0, $k50Aq.swimlanesCollapse)(swimlanesToCollapseIds));
        },
        onSetShowUnscheduledColumn: (isVisible)=>{
            dispatch((0, $bRqd3.setShowUnscheduledColumn)(isVisible));
        },
        onSetShowOfftrackDependencyLines: (isVisible)=>{
            dispatch((0, $bRqd3.setShowOfftrackDependencyLines)(isVisible));
        },
        onSetIssueIdsToShowDependencies: (issueIds)=>{
            dispatch((0, $bRqd3.setIssueIdsToShowDependencies)(issueIds));
        },
        onTogglePanel: ()=>{
            dispatch((0, $2ON1s.togglePanel)((0, $8cd646738f5ee7ac$export$ba1da943283b9900)));
            dispatch((0, $2ON1s.closeInsightsPanel)());
        }
    });
var $0a9dc3df02e64325$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($0a9dc3df02e64325$export$c31df4bd766f9c35, $0a9dc3df02e64325$var$mapDispatchToProps)((0, $7Rvok.ViewSettings));

});
parcelRegister("7Rvok", function(module, exports) {

$parcel$export(module.exports, "ViewSettings", () => $8e553db342ec60bd$export$4d0b6d35abb3362d);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");


var $d6YZC = parcelRequire("d6YZC");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ipmBb = parcelRequire("ipmBb");

var $a4XJc = parcelRequire("a4XJc");

var $iDGXn = parcelRequire("iDGXn");

var $jB6yt = parcelRequire("jB6yt");

var $38RF4 = parcelRequire("38RF4");

var $8vM1G = parcelRequire("8vM1G");

var $dIdda = parcelRequire("dIdda");

var $iUagi = parcelRequire("iUagi");

var $67sX6 = parcelRequire("67sX6");

var $3n582 = parcelRequire("3n582");

var $4RVsR = parcelRequire("4RVsR");

var $4vVV6 = parcelRequire("4vVV6");

var $vAfHD = parcelRequire("vAfHD");

var $gR0bs = parcelRequire("gR0bs");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");
const $8e553db342ec60bd$export$caf439d171aab0ca = ()=>(0, $67sX6.useBoardSelector)((0, $67Z81.projectTypeSelector)) === (0, $2vSU6.SERVICE_DESK_PROJECT);
const $8e553db342ec60bd$export$4d0b6d35abb3362d = ({ rapidViewId: rapidViewId, isClassic: isClassic, hasSwimlanes: hasSwimlanes, showCardDetails: showCardDetails, epicCustomName: epicCustomName, swimlaneIds: swimlaneIds, isViewSettingPanelOpen: isViewSettingPanelOpen, onSwimlaneExpandAll: onSwimlaneExpandAll, onSwimlaneCollapseAll: onSwimlaneCollapseAll, onSetShowUnscheduledColumn: onSetShowUnscheduledColumn, onSetShowOfftrackDependencyLines: onSetShowOfftrackDependencyLines, onSetIssueIdsToShowDependencies: onSetIssueIdsToShowDependencies, onTogglePanel: onTogglePanel })=>{
    const isIPBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
    const handleSwimlaneCollapseAll = (0, $5uXOq.useCallback)(()=>{
        onSwimlaneCollapseAll(swimlaneIds, isIPBoard);
    }, [
        onSwimlaneCollapseAll,
        swimlaneIds,
        isIPBoard
    ]);
    const isCompanyManaged = (0, $63LqY.useIsCMPBoard)();
    const isQuickFilterAvailable = (0, $67sX6.useBoardSelector)((0, $5mTgl.getCustomFilters)).length > 0;
    const showFilterBarToggle = isCompanyManaged && (!(0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() || isQuickFilterAvailable);
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const isJSMBoard = $8e553db342ec60bd$export$caf439d171aab0ca();
    const isJSWBoard = (0, $63LqY.useIsJSWBoard)();
    const showUnscheduledColumn = (0, $iDGXn.useShowUnscheduledColumn)();
    const showOfftrackDependencyLines = (0, $iDGXn.useShowOfftrackDependencyLines)();
    const issueIdsToShowDependencies = (0, $iDGXn.useIssueIdsToShowDependencies)();
    const isDaysInColumnEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsDaysInColumnEnabled));
    const isDueDateEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsDueDateEnabled));
    const isLabelsEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIssueLabelsEnabled));
    const cardExtraFields = (0, $67sX6.useBoardSelector)((0, $67Z81.getCardExtraFields));
    const isEstimateEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsEstimateEnabled));
    const isPriorityEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsPriorityEnabled));
    const canEdit = (0, $67sX6.useBoardSelector)((0, $67Z81.getCanEditBoard));
    const canInvite = (0, $67sX6.useBoardSelector)((0, $67Z81.getCanInviteOthersToProject));
    const { canUserLinkIssue: canUserLinkIssue, issueLinkTypes: issueLinkTypes } = (0, $67sX6.useBoardSelector)((0, $4vVV6.getIssueLinksPermissions));
    const firstSelectableIssueId = (0, $67sX6.useBoardSelector)((0, $gR0bs.getFirstSelectableIssueAscending));
    const issues = (0, $67sX6.useBoardSelector)((0, $67Z81.getIssues));
    const isIssueLinkingEnabledOnInstance = canUserLinkIssue && issueLinkTypes?.length > 0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const boardIssueIds = (0, $67sX6.useBoardSelector)((0, $vAfHD.boardOrderedIssueIdsSelector));
    const onLinkedIssuesStatsToggledOn = (0, $67sX6.useBoardActionCreator)(()=>(0, $4RVsR.fetchIssueLinksStats)(boardIssueIds, {
            analyticsEvent: createAnalyticsEvent({})
        }));
    const onShowCardCoversToggledOn = (0, $67sX6.useBoardActionCreator)(()=>(0, $3n582.fetchCardCovers)(boardIssueIds, {
            analyticsEvent: createAnalyticsEvent({})
        }));
    const [, { doFetch: updateWorkSuggestionsEnabled }] = (0, $d6YZC.useNextBestTaskUserPreference)();
    const { data: isWorkSuggestionsEnabledData, update: updateWorkSuggestionsResource, loading: loadingWorkSuggestionsEnabled } = (0, $dIdda.useResource)((0, $ipmBb.nextBestTaskFeatureResource));
    const onToggleWorkSuggestions = (analyticsEvent)=>{
        const newOptInValue = !isWorkSuggestionsEnabledData?.hasUserOptedIn;
        updateWorkSuggestionsResource(()=>({
                hasUserOptedIn: newOptInValue
            }));
        updateWorkSuggestionsEnabled({
            hasUserOptedIn: newOptInValue
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $ba3e099a37b09fda$export$9957974f8b4d8f74), {
            hasUserOptedIn: newOptInValue
        });
    };
    (0, $5uXOq.useEffect)(()=>{
        // Setting the unscheduled column visibility state in IP board based on the value from view settings package
        if (isIncrementPlanningBoard) {
            onSetShowUnscheduledColumn(showUnscheduledColumn);
            onSetShowOfftrackDependencyLines(showOfftrackDependencyLines);
            onSetIssueIdsToShowDependencies(issueIdsToShowDependencies);
        }
    }, [
        isIncrementPlanningBoard,
        showUnscheduledColumn,
        showOfftrackDependencyLines,
        issueIdsToShowDependencies,
        onSetShowUnscheduledColumn,
        onSetShowOfftrackDependencyLines,
        onSetIssueIdsToShowDependencies
    ]);
    if (isIncrementPlanningBoard) // Increment planning settings only have unscheduled column toggle and swimlane expand/collapse
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jB6yt.default), {
        boardId: rapidViewId,
        isClassic: isClassic,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
        isSwimlanesEnabled: hasSwimlanes,
        onSwimlaneExpandAll: onSwimlaneExpandAll,
        onSwimlaneCollapseAll: handleSwimlaneCollapseAll,
        dependencyIssueOptions: issues,
        ...(0, $4R6GH.fg)('issue_cards_in_program_board') ? {
            epicCustomName: epicCustomName,
            isEstimateEnabled: isEstimateEnabled
        } : {}
    });
    if ((0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() && isJSMBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jB6yt.default), {
        boardId: rapidViewId,
        isClassic: isClassic,
        view: (0, $a4XJc.View).JSM_BOARD,
        epicCustomName: epicCustomName,
        showCardDetails: showCardDetails,
        isSwimlanesEnabled: hasSwimlanes,
        onSwimlaneExpandAll: onSwimlaneExpandAll,
        onSwimlaneCollapseAll: handleSwimlaneCollapseAll,
        showFilterBarToggle: showFilterBarToggle
    });
    const renderAdditionalFieldSpotlight = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38RF4.ViewSettingsSyncFromLocalStorageWrapper), {
            boardId: rapidViewId,
            view: (0, $a4XJc.View).BOARD,
            isDaysInColumnEnabled: isDaysInColumnEnabled,
            cardExtraFields: cardExtraFields,
            isDueDateEnabled: isDueDateEnabled,
            isLabelsEnabled: isLabelsEnabled,
            isEstimateEnabled: isEstimateEnabled,
            isPriorityEnabled: isPriorityEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38RF4.ViewSettingsButton), {
            isSelected: isViewSettingPanelOpen || false,
            onClick: onTogglePanel
        }));
    if ((0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8vM1G.ViewSettingsPanelOnboarding), {
        isViewSettingPanelOpen: isViewSettingPanelOpen,
        onTogglePanel: onTogglePanel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8vM1G.ViewSettingsPanelButtonSpotlight), null, renderAdditionalFieldSpotlight()));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jB6yt.default), {
        boardId: rapidViewId,
        isClassic: isClassic,
        view: (0, $a4XJc.View).BOARD,
        epicCustomName: epicCustomName,
        showCardDetails: showCardDetails,
        isSwimlanesEnabled: hasSwimlanes,
        onSwimlaneExpandAll: onSwimlaneExpandAll,
        onSwimlaneCollapseAll: handleSwimlaneCollapseAll,
        showFilterBarToggle: showFilterBarToggle,
        isWorkSuggestionsEnabled: !!isWorkSuggestionsEnabledData?.hasUserOptedIn,
        showWorkSuggestions: isWorkSuggestionsEnabledData != null && !loadingWorkSuggestionsEnabled && isJSWBoard,
        onToggleWorkSuggestions: onToggleWorkSuggestions,
        showLinkedIssueStatsToggle: isIssueLinkingEnabledOnInstance && Boolean(firstSelectableIssueId),
        onLinkedIssuesStatsToggledOn: onLinkedIssuesStatsToggledOn,
        isAddPeopleButtonEnabled: canEdit || canInvite && (0, $6s1PB.expValEquals)('open_invite_for_open_tmp_projects', 'cohort', 'experiment'),
        onShowCardCoversToggledOn: onShowCardCoversToggledOn
    });
};

});
parcelRegister("8vM1G", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsPanelOnboarding", () => $2f6bb1e464f0a6ca$export$215da70478ebbc7);
$parcel$export(module.exports, "ViewSettingsPanelButtonSpotlight", () => $2f6bb1e464f0a6ca$export$67c31a192079fb3c);

var $5uXOq = parcelRequire("5uXOq");

var $cjvpk = parcelRequire("cjvpk");

var $5Fk4Z = parcelRequire("5Fk4Z");
var $1QiBP = parcelRequire("1QiBP");


var $eGLgs = parcelRequire("eGLgs");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $hchBL = parcelRequire("hchBL");

var $ehdJY = parcelRequire("ehdJY");

var $cYeCp = parcelRequire("cYeCp");


var $jnjYD = parcelRequire("jnjYD");
const $2f6bb1e464f0a6ca$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
const $2f6bb1e464f0a6ca$var$ViewSettingsPanelOnboardingBase = ({ onTogglePanel: onTogglePanel, isViewSettingPanelOpen: isViewSettingPanelOpen })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [viewSettingsPanelRef] = (0, $hchBL.useGlobalRef)((0, $3795a016b6403547$export$989661c424340ff8));
    const [addPeopleButtonRef] = (0, $hchBL.useGlobalRef)((0, $3795a016b6403547$export$4a16d41d3ff730bf));
    const [activeSpotlight, setActiveSpotlight] = (0, $5uXOq.useState)(0);
    const next = (0, $5uXOq.useCallback)(()=>setActiveSpotlight((current)=>current !== null ? current + 1 : 0), []);
    const renderSpotlight = (0, $5uXOq.useCallback)((stop)=>{
        const finalStepActions = [
            {
                text: formatMessage((0, $jnjYD.default).doneStepButton),
                onClick: ()=>{
                    isViewSettingPanelOpen && onTogglePanel();
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightDone');
                    setActiveSpotlight(null);
                    stop && stop();
                }
            }
        ];
        const isAddPeopleButtonAvailable = Boolean(addPeopleButtonRef);
        const numberOfSpotlights = isAddPeopleButtonAvailable ? 3 : 2;
        const spotlights = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                key: (0, $3795a016b6403547$export$a57856d4380e4bb8),
                target: (0, $3795a016b6403547$export$a57856d4380e4bb8),
                heading: formatMessage((0, $jnjYD.default).viewSettingsButtonStepTitle),
                actionsBeforeElement: `1/${numberOfSpotlights}`,
                actions: [
                    {
                        text: formatMessage((0, $jnjYD.default).nextStepButton),
                        onClick: ()=>{
                            !isViewSettingPanelOpen && onTogglePanel();
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightNext');
                            next();
                        }
                    },
                    {
                        text: formatMessage((0, $jnjYD.default).dismissStepButton),
                        onClick: ()=>{
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightDismiss');
                            setActiveSpotlight(null);
                            stop && stop();
                        }
                    }
                ],
                targetRadius: 3,
                targetBgColor: `var(--ds-surface, ${(0, $829f609a65d26a98$exports).N0})`,
                dialogPlacement: "bottom right",
                messageId: "software-view-settings.ui.view-settings-panel-onboarding.jira-spotlight",
                messageType: "engagement"
            }, formatMessage((0, $jnjYD.default).viewSettingsButtonStepContent)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                key: (0, $3795a016b6403547$export$989661c424340ff8),
                targetNode: viewSettingsPanelRef,
                actionsBeforeElement: `2/${numberOfSpotlights}`,
                actions: isAddPeopleButtonAvailable ? [
                    {
                        text: formatMessage((0, $jnjYD.default).nextStepButton),
                        onClick: ()=>{
                            isViewSettingPanelOpen && onTogglePanel();
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightNext');
                            next();
                        }
                    },
                    {
                        text: formatMessage((0, $jnjYD.default).dismissStepButton),
                        onClick: ()=>{
                            isViewSettingPanelOpen && onTogglePanel();
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightDismiss');
                            setActiveSpotlight(null);
                            stop && stop();
                        }
                    }
                ] : finalStepActions,
                targetRadius: 10,
                targetBgColor: `var(--ds-surface, ${(0, $829f609a65d26a98$exports).N0})`,
                dialogPlacement: "left top",
                messageId: "software-view-settings.ui.view-settings-panel-onboarding.jira-spotlight.1",
                messageType: "engagement"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $jnjYD.default).viewSettingsPanelFirstPartContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jnjYD.default).viewSettingsPanelSecondPartContentIssueTermRefresh : (0, $jnjYD.default).viewSettingsPanelSecondPartContent)))),
            isAddPeopleButtonAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                key: (0, $3795a016b6403547$export$4a16d41d3ff730bf),
                targetNode: addPeopleButtonRef,
                heading: formatMessage((0, $jnjYD.default).addPeopleButtonStepTitle),
                actionsBeforeElement: `3/${numberOfSpotlights}`,
                actions: finalStepActions,
                targetRadius: (0, $cjvpk.AVATAR_SIZES).medium,
                targetBgColor: `var(--ds-surface, ${(0, $829f609a65d26a98$exports).N0})`,
                dialogPlacement: "bottom left",
                messageId: "software-view-settings.ui.view-settings-panel-onboarding.jira-spotlight.2",
                messageType: "engagement"
            }, formatMessage((0, $jnjYD.default).addPeopleButtonStepContent)) : null
        ];
        return activeSpotlight != null ? spotlights[activeSpotlight] : null;
    }, [
        activeSpotlight,
        createAnalyticsEvent,
        formatMessage,
        isViewSettingPanelOpen,
        next,
        onTogglePanel,
        viewSettingsPanelRef,
        addPeopleButtonRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: (0, $3795a016b6403547$export$8be246eeba922980),
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f6bb1e464f0a6ca$export$83d026e3dd5706d, null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, renderSpotlight(stop))));
};
const $2f6bb1e464f0a6ca$export$215da70478ebbc7 = (0, $7XYc4.componentWithCondition)((0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled), $2f6bb1e464f0a6ca$var$ViewSettingsPanelOnboardingBase, ()=>null);
const $2f6bb1e464f0a6ca$export$67c31a192079fb3c = ({ children: children })=>{
    if ((0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $3795a016b6403547$export$a57856d4380e4bb8)
    }, children);
    return children;
};

});
parcelRegister("jnjYD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d14ba5d33834aaf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6d14ba5d33834aaf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewSettingsButtonStepTitle: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-button-step-title",
        "defaultMessage": "Customize your view"
    },
    viewSettingsButtonStepContent: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-button-step-content",
        "defaultMessage": "Use view settings to simplify the look and feel of your board and backlog."
    },
    viewSettingsPanelFirstPartContent: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-panel-first-part-content",
        "defaultMessage": "Switch on what you need, and switch off what you don\u2019t."
    },
    viewSettingsPanelSecondPartContent: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-panel-second-part-content",
        "defaultMessage": "Choose to show or hide panels, filters, and issue fields, and change the density of your view."
    },
    addPeopleButtonStepTitle: {
        "id": "software-view-settings.view-settings-panel-onboarding.add-people-button-step-title",
        "defaultMessage": "Share your view"
    },
    addPeopleButtonStepContent: {
        "id": "software-view-settings.view-settings-panel-onboarding.add-people-button-step-content",
        "defaultMessage": "Now when you add a new teammate to Jira, you can share your view settings so they see what you see. Includes view settings and filters."
    },
    nextStepButton: {
        "id": "software-view-settings.view-settings-panel-onboarding.next-step-button",
        "defaultMessage": "Next"
    },
    dismissStepButton: {
        "id": "software-view-settings.view-settings-panel-onboarding.dismiss-step-button",
        "defaultMessage": "Dismiss"
    },
    doneStepButton: {
        "id": "software-view-settings.view-settings-panel-onboarding.done-step-button",
        "defaultMessage": "Done"
    },
    viewSettingsPanelSecondPartContentIssueTermRefresh: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-panel-second-part-content-issue-term-refresh",
        "defaultMessage": "Choose to show or hide panels, filters, and issue fields, and change the density of your view."
    }
});

});





parcelRegister("XvlUo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cf6aedc51c9a9b1$export$2e2bcd8739ae039);

var $eCgfP = parcelRequire("eCgfP");

var $bC2fB = parcelRequire("bC2fB");


var $cW3pH = parcelRequire("cW3pH");

var $k8auG = parcelRequire("k8auG");
const $9cf6aedc51c9a9b1$export$c31df4bd766f9c35 = (state)=>({
        operations: (0, $k8auG.operationsSelector)(state)
    });
const $9cf6aedc51c9a9b1$export$9e6a17cf56877796 = (dispatch)=>({
        onModalClose: ()=>{
            dispatch((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$a0b8ab2c9a9afaaa)));
        }
    });
const $9cf6aedc51c9a9b1$var$ConnectedExtension = (0, $bC2fB.connect)($9cf6aedc51c9a9b1$export$c31df4bd766f9c35, $9cf6aedc51c9a9b1$export$9e6a17cf56877796)((0, $eCgfP.default));
var $9cf6aedc51c9a9b1$export$2e2bcd8739ae039 = $9cf6aedc51c9a9b1$var$ConnectedExtension;

});
parcelRegister("eCgfP", function(module, exports) {

$parcel$export(module.exports, "default", () => $30adade8afbc4e74$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $3HwlS = parcelRequire("3HwlS");

var $9AYKy = parcelRequire("9AYKy");
function $30adade8afbc4e74$export$2e2bcd8739ae039(props) {
    if ((0, $3HwlS.getWillShowNav4)()) {
        if (props.operations.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.operations.map((op)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9AYKy.default), {
                key: op.url,
                operation: op,
                onModalClose: props.onModalClose
            })));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.operations.map((op)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($30adade8afbc4e74$var$OperationWrapper, {
            key: op.url
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9AYKy.default), {
            operation: op,
            onModalClose: props.onModalClose
        }))));
}
$30adade8afbc4e74$export$2e2bcd8739ae039.defaultProps = {
    operations: [],
    onModalClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $30adade8afbc4e74$var$OperationWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc _1xoqidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9AYKy", function(module, exports) {

$parcel$export(module.exports, "default", () => $40b405f55a447be3$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $hRf4g = parcelRequire("hRf4g");

var $apKqz = parcelRequire("apKqz");

var $kJpBP = parcelRequire("kJpBP");

var $3bDjY = parcelRequire("3bDjY");

var $jjlQu = parcelRequire("jjlQu");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");
const $40b405f55a447be3$var$iconSize = (0, $gwIPs.gridSize) * 3;
class $40b405f55a447be3$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            operation: {},
            onModalClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    static{
        this.getFallbackIcon = (name)=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRf4g))), {
                label: name,
                color: "var(--ds-icon, #44546F)"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($apKqz))), {
                size: "medium",
                label: name
            });
    }
    /*
   * ABE-22: The reason for using this 'invisible' anchor with an href is needed, instead of simply
   * passing the href to the component which would then have an underlying anchor, is that the
   * styleClasses list of classes here are needed to trigger the ecosystem addon modal to come
   * up on click. This is in contrast to the component behaviour of a vanilla anchor that
   * currently does not support custom classes, which would redirect to a Jira 404 error page.
   */ renderEcosystemModalLink() {
        const { url: url, styleClass: styleClass } = this.props.operation;
        return(// go/jfe-eslint
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
            href: url,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: styleClass,
            ref: this.setEcosystemModalLinkRef,
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'none'
            }
        }));
    }
    renderIcon() {
        const { icon: icon, name: name } = this.props.operation;
        return icon && icon.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjlQu.default), {
            title: name,
            url: icon.url,
            width: $40b405f55a447be3$var$iconSize,
            height: $40b405f55a447be3$var$iconSize,
            fallback: ()=>$40b405f55a447be3$export$2e2bcd8739ae039.getFallbackIcon(name || '')
        }) : $40b405f55a447be3$export$2e2bcd8739ae039.getFallbackIcon(name || '');
    }
    renderButton() {
        const { name: name } = this.props.operation;
        const icon = this.renderIcon();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            key: name,
            onClick: this.clickEcosystemModalLinkRef,
            // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactChild | undefined'.
            iconBefore: name ? icon : null
        }, name || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40b405f55a447be3$var$OnlyIconWrapper, null, icon), this.renderEcosystemModalLink());
    }
    renderMenuItem() {
        const { name: name } = this.props.operation;
        const icon = this.renderIcon();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
            key: name,
            onClick: this.clickEcosystemModalLinkRef,
            iconBefore: name ? icon : null
        }, name || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40b405f55a447be3$var$OnlyIconWrapper, null, icon), this.renderEcosystemModalLink());
    }
    render() {
        const { tooltip: tooltip } = this.props.operation;
        const content = (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') ? this.renderMenuItem() : this.renderButton();
        if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: tooltip
        }, content);
        return content;
    }
    constructor(...args){
        super(...args);
        /* not used yet TOTEM-818 */ this.onModalClose = ()=>this.props.onModalClose();
        this.setEcosystemModalLinkRef = (element)=>{
            this.ecosystemModalLinkRef = element;
        };
        this.clickEcosystemModalLinkRef = ()=>{
            this.ecosystemModalLinkRef && this.ecosystemModalLinkRef.click();
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $40b405f55a447be3$var$OnlyIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});



parcelRegister("lFerq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6be9ad20c9c4766b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $jzjy1 = parcelRequire("jzjy1");

var $hcObS = parcelRequire("hcObS");

var $4041n = parcelRequire("4041n");

var $2NMNM = parcelRequire("2NMNM");

var $67sX6 = parcelRequire("67sX6");

var $k8auG = parcelRequire("k8auG");
const $6be9ad20c9c4766b$export$8d5dab2ad1e19ea0 = (props)=>{
    const { itemId: itemId, itemType: itemType } = props;
    const isFavoriteInitial = (0, $67sX6.useBoardSelector)((0, $k8auG.isFavouriteSelector));
    const { items: items, changeFavorite: changeFavorite } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const changeItem = items[itemType]?.[itemId];
    const isFavorite = changeItem ? changeItem.value : isFavoriteInitial ?? false;
    const isPending = changeItem ? changeItem.pending : isFavoriteInitial === undefined;
    const skipAnimation = (0, $5uXOq.useRef)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (isFavoriteInitial !== undefined) {
            skipAnimation.current = false;
            const item = items[itemType];
            if (item && !item[itemId]) item[itemId] = {
                id: itemId,
                type: itemType,
                value: isFavoriteInitial,
                pending: false
            };
        }
    }, [
        isFavoriteInitial,
        itemId,
        itemType,
        items
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'favouriteButton'
        });
        changeFavorite({
            id: itemId,
            type: itemType,
            value: !isFavorite
        }, analyticsEvent);
    }, [
        changeFavorite,
        createAnalyticsEvent,
        isFavorite,
        itemId,
        itemType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), {
        ...props,
        isFavorite: isFavorite,
        pending: isPending,
        onClick: onClick,
        skipAnimation: skipAnimation.current
    });
};
var $6be9ad20c9c4766b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $jzjy1.AnalyticsSubject)('board'))($6be9ad20c9c4766b$export$8d5dab2ad1e19ea0);

});
parcelRegister("hcObS", function(module, exports) {

$parcel$export(module.exports, "FavoriteButtonWrapper", () => $0a68425ce3fc2fa8$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $0a68425ce3fc2fa8$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $dm1qi = parcelRequire("dm1qi");

var $dAf5R = parcelRequire("dAf5R");

var $5oTeF = parcelRequire("5oTeF");

var $bH1hf = parcelRequire("bH1hf");

var $7FtaJ = parcelRequire("7FtaJ");

var $1Cvrw = parcelRequire("1Cvrw");

var $fNobW = parcelRequire("fNobW");

var $3bDjY = parcelRequire("3bDjY");

var $iQv12 = parcelRequire("iQv12");

var $7XYc4 = parcelRequire("7XYc4");

var $az4zD = parcelRequire("az4zD");

var $dCm1o = parcelRequire("dCm1o");

var $6fQ6A = parcelRequire("6fQ6A");
const $0a68425ce3fc2fa8$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper';
class $0a68425ce3fc2fa8$export$f8ad2acf0ec4860f extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $0a68425ce3fc2fa8$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$export$db65185b5889c83, {
            "data-testid": $0a68425ce3fc2fa8$var$SKELETON_TEST_ID,
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const buttonContentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dm1qi))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bH1hf))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6fQ6A.default).removeFromStarred)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAf5R))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($5oTeF))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6fQ6A.default).addToStarred)
        }));
        const renderIcon = ()=>{
            const label = isFavorite ? formatMessage((0, $6fQ6A.default).removeFromStarred) : formatMessage((0, $6fQ6A.default).addToStarred);
            let StarIconComponent;
            if (isSmall) StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($7FtaJ))) : (0, (/*@__PURE__*/$parcel$interopDefault($1Cvrw)));
            else StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($dm1qi))) : (0, (/*@__PURE__*/$parcel$interopDefault($dAf5R)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StarIconComponent, {
                color: "currentColor",
                label: label
            });
        };
        const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, renderIcon());
        const tooltipContent = isFavorite ? formatMessage((0, $6fQ6A.default).removeFromStarred) : formatMessage((0, $6fQ6A.default).addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage((0, $6fQ6A.default).toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage((0, $6fQ6A.default).toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        }, (0, $dCm1o.isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isAnimating: false
        };
        this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        };
        this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
var $0a68425ce3fc2fa8$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $az4zD.injectIntlV2))($0a68425ce3fc2fa8$export$f8ad2acf0ec4860f);
const $0a68425ce3fc2fa8$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0a68425ce3fc2fa8$export$bb1478fee6cd5f0c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_11vn1ssb _1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
});
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBase = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseNew, $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0a68425ce3fc2fa8$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isFavorite ? "_syaz2kyj" : "_syaz2u25",
            __cmplp.isFavorite ? "_30l31ebw" : "_30l3w9a8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0a68425ce3fc2fa8$export$db65185b5889c83 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6fQ6A", function(module, exports) {

$parcel$export(module.exports, "default", () => $10bc2ec5d9a72db1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $10bc2ec5d9a72db1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addToStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
        "defaultMessage": "Add to Starred"
    },
    removeFromStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
        "defaultMessage": "Remove from Starred"
    },
    toggleStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
        "defaultMessage": "Star"
    },
    toggleStarredWithItemName: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
        "defaultMessage": "Star {itemName}"
    }
});

});



parcelRegister("7jxaT", function(module, exports) {

$parcel$export(module.exports, "default", () => $27d2c5865b3087c1$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $bC2fB = parcelRequire("bC2fB");

var $2xFXk = parcelRequire("2xFXk");


var $1vXOx = parcelRequire("1vXOx");

var $k8auG = parcelRequire("k8auG");

var $kc6Ry = parcelRequire("kc6Ry");

var $4gt6L = parcelRequire("4gt6L");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $5mTgl = parcelRequire("5mTgl");

var $a7rpP = parcelRequire("a7rpP");
const $27d2c5865b3087c1$export$c31df4bd766f9c35 = (state)=>{
    const permissions = (0, $1vXOx.getPermissionsSelector)(state);
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    const boardType = (0, $67Z81.getBoardType)(state);
    return {
        isDisabled: !permissions[0, $e525e6c25695c9df$export$aadc620ce91112df] || isCMPBoard,
        projectKey: (0, $67Z81.projectKeySelector)(state),
        issueTypeId: (0, $4gt6L.firstIssueTypeIdSelector)(state) || '',
        isEditSprintItemVisible: (0, $ebHh7.activeSprintsSelector)(state)?.[0]?.canUpdateSprint ?? false,
        isCardMediaSwitchEnabled: false,
        isConfigureBoardEnabled: permissions[0, $e525e6c25695c9df$export$aadc620ce91112df] === true && !isCMPBoard,
        isManageCustomFiltersEnabled: permissions[0, $e525e6c25695c9df$export$aadc620ce91112df] === true && !isCMPBoard,
        boardId: (0, $67Z81.rapidViewIdSelector)(state),
        sprintId: (0, $ebHh7.activeSprintsSelector)(state)?.[0]?.id,
        isReleaseVersionVisible: isCMPBoard && boardType === 'KANBAN' && (0, $5mTgl.isReleasesFeatureEnabled)(state) && (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).RENDER_BOARD_RELEASE_MENU_BUTON),
        hasOperations: (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('jira_nav4_eap_drop_2') && (0, $k8auG.operationsSelector)(state).length > 0
    };
};
const $27d2c5865b3087c1$export$9e6a17cf56877796 = {};
var $27d2c5865b3087c1$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($27d2c5865b3087c1$export$c31df4bd766f9c35, $27d2c5865b3087c1$export$9e6a17cf56877796)((0, $a7rpP.default));

});
parcelRegister("a7rpP", function(module, exports) {

$parcel$export(module.exports, "default", () => $8897bbc801abac9f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $8U6zd = parcelRequire("8U6zd");

var $3oUqw = parcelRequire("3oUqw");

var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $k6T4f = parcelRequire("k6T4f");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3Tty1 = parcelRequire("3Tty1");

var $47gW9 = parcelRequire("47gW9");

var $4mO32 = parcelRequire("4mO32");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $g7crU = parcelRequire("g7crU");

var $dXq4S = parcelRequire("dXq4S");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5QsHM = parcelRequire("5QsHM");

var $aCKi5 = parcelRequire("aCKi5");

var $e8X1M = parcelRequire("e8X1M");

var $bsWqi = parcelRequire("bsWqi");

var $34djr = parcelRequire("34djr");

var $koeKL = parcelRequire("koeKL");

var $itmJb = parcelRequire("itmJb");

var $dCm1o = parcelRequire("dCm1o");

var $2xFXk = parcelRequire("2xFXk");

var $hz3OZ = parcelRequire("hz3OZ");

var $63LqY = parcelRequire("63LqY");

var $XvlUo = parcelRequire("XvlUo");

var $90DyW = parcelRequire("90DyW");

var $eNd21 = parcelRequire("eNd21");

var $6w38i = parcelRequire("6w38i");

var $4TS2v = parcelRequire("4TS2v");

var $bdV6X = parcelRequire("bdV6X");

var $efqda = parcelRequire("efqda");

var $lLint = parcelRequire("lLint");

var $7EoeF = parcelRequire("7EoeF");

var $1YHJ6 = parcelRequire("1YHJ6");

var $gqdF8 = parcelRequire("gqdF8");


var $6tHP5 = parcelRequire("6tHP5");

var $c1wgv = parcelRequire("c1wgv");
const $8897bbc801abac9f$var$JSM_BOARD_MEATBALL_MENU_SEEN_STATUS_USER_PROPERTY_KEY = 'jsm-board-meatball-menu-seen-status';
const $8897bbc801abac9f$var$BoardMenu = ({ isCardMediaSwitchEnabled: isCardMediaSwitchEnabled, isConfigureBoardEnabled: isConfigureBoardEnabled, isDisabled: isDisabled, isEditSprintItemVisible: isEditSprintItemVisible, isManageCustomFiltersEnabled: isManageCustomFiltersEnabled, issueTypeId: issueTypeId, projectKey: projectKey, boardId: boardId, sprintId: sprintId, isReleaseVersionVisible: isReleaseVersionVisible, hasOperations: hasOperations })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [isPopupOpen, setIsPopupOpen] = (0, $5uXOq.useState)(false);
    const [shouldShowPulse, setShouldShowPulse] = (0, $5uXOq.useState)(false);
    const [shouldShowSpotlight, setShouldShowSpotlight] = (0, $5uXOq.useState)(false);
    const [hasSpotlightDisplayed, setHasSpotlightDisplayed] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isFullscreen, { setIsFullscreen: setIsFullscreen }] = (0, $g7crU.useIsFullscreen)();
    const isJSMBoard = (0, $63LqY.useIsJSMBoard)();
    const canEditBoard = (0, $63LqY.useCanEditBoard)();
    const isTabNavigation = (0, $63LqY.useCapability)((0, $2xFXk.Capability).IS_TAB_NAVIGATION);
    const shouldRenderBoardMoreMenuItem = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_BOARD_MORE_MENU_ITEM);
    // move the Enter Fullscreen action in dropdown if Nav4 && EAP for Software projects only
    const shouldRenderFullscreenMenuItem = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_BOARD_FULLSCREEN_MENU_ITEM);
    const shouldRenderBoardSettingsMenuItem = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_BOARD_SETTINGS_MENU_ITEM);
    const shouldRenderCreateBoardMenuItem = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_CREATE_BOARD_MENU_ITEM);
    const shouldRenderEditSprintMenuItem = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_EDIT_SPRINT_MENU_ITEM);
    const shouldRenderManageWorkflowMenuItem = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_MANAGE_WORKFLOW_MENU_ITEM);
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const cloudId = (0, $koeKL.useCloudId)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const [{ isSeen: hasSeenSpotlight }, { markAsSeen: markSpotlightAsSeen }] = (0, $5QsHM.useSeenStatus)({
        userPropertyKey: $8897bbc801abac9f$var$JSM_BOARD_MEATBALL_MENU_SEEN_STATUS_USER_PROPERTY_KEY,
        isSeenValue: true,
        packageName: 'jiraBoard',
        teamName: 'jsd-shield'
    });
    (0, $5uXOq.useEffect)(()=>{
        if (// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('jsm_boards_promo_gate') && isJSMBoard && isAdmin && !hasSeenSpotlight && !hasSpotlightDisplayed) setShouldShowPulse(!hasSeenSpotlight);
    }, [
        hasSeenSpotlight,
        hasSpotlightDisplayed,
        isAdmin,
        isJSMBoard
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const onOpenChangeOld = (0, $5uXOq.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'dropdownMenu',
            action: 'toggled'
        }), 'boardHeaderMenu');
    }, [
        setIsOpen,
        createAnalyticsEvent
    ]);
    const onOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
        if (isJSMBoard && isAdmin && !hasSeenSpotlight) {
            setShouldShowSpotlight(true);
            setShouldShowPulse(false);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'button',
                action: 'clicked'
            }), 'boardAdminOnboardingConfigPulse');
        } else {
            setIsOpen(attrs.isOpen);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'dropdownMenu',
                action: 'toggled'
            }), 'boardHeaderMenu');
        }
    }, [
        isJSMBoard,
        isAdmin,
        hasSeenSpotlight,
        createAnalyticsEvent
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setIsPopupOpen(false);
    }, [
        setIsPopupOpen
    ]);
    const onPopupClick = (0, $5uXOq.useCallback)(()=>{
        if (isJSMBoard && isAdmin && !hasSeenSpotlight) {
            setShouldShowSpotlight(true);
            setShouldShowPulse(false);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'button',
                action: 'clicked'
            }), 'boardAdminOnboardingConfigPulse');
        } else {
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'popupMenu',
                action: 'toggled'
            }), 'boardHeaderMenu');
            setIsPopupOpen(!isPopupOpen);
        }
    }, [
        isJSMBoard,
        isAdmin,
        hasSeenSpotlight,
        setIsPopupOpen,
        createAnalyticsEvent,
        isPopupOpen
    ]);
    const dropdownMenuTrigger = (0, $5uXOq.useCallback)(({ triggerRef: triggerRef, ...triggerProps })=>{
        if ((0, $dCm1o.isVisualRefreshEnabled)() || isTabNavigation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            ...triggerProps,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))),
            label: formatMessage((0, $gqdF8.default).iconButtonLabel),
            ref: triggerRef
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...triggerProps,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
                label: "More actions",
                color: "var(--ds-icon, #44546F)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))),
                LEGACY_primaryColor: "var(--ds-icon, #44546F)"
            }),
            "aria-label": formatMessage((0, $gqdF8.default).dropdownAriaLabel),
            ref: triggerRef
        });
    }, [
        formatMessage,
        isTabNavigation
    ]);
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>{
        if ((0, $dCm1o.isVisualRefreshEnabled)() || isTabNavigation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            ...triggerProps,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))),
            label: formatMessage((0, $gqdF8.default).iconButtonLabel),
            onClick: onPopupClick,
            testId: "software-board.header.menu.icon-button",
            isSelected: isPopupOpen
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...triggerProps,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
                label: "More actions",
                color: "var(--ds-icon, #44546F)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))),
                LEGACY_primaryColor: "var(--ds-icon, #44546F)"
            }),
            "aria-label": formatMessage((0, $gqdF8.default).dropdownAriaLabel),
            onClick: onPopupClick,
            isSelected: isPopupOpen,
            testId: "software-board.header.menu.button"
        });
    }, [
        formatMessage,
        onPopupClick,
        isPopupOpen,
        isTabNavigation
    ]);
    const boardAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: String(boardId)
    });
    const toggleFullscreen = (0, $5uXOq.useCallback)(()=>{
        setIsFullscreen(!isFullscreen);
    }, [
        isFullscreen,
        setIsFullscreen
    ]);
    const shortcutsKeyMap = {
        z: {
            callback: toggleFullscreen
        }
    };
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            boardId: boardAri,
            sprintId: (0, $dXq4S.createAri)({
                resourceOwner: 'jira-software',
                cloudId: cloudId,
                resourceType: 'sprint',
                resourceId: String(sprintId)
            }),
            fetchSprints: true,
            isCompanyManaged: isCMPBoard
        }), [
        boardAri,
        cloudId,
        sprintId,
        isCMPBoard
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, $4mO32.useEntryPoint)((0, $bsWqi.editSprintModalEntryPoint), entryPointParams, (0, $hz3OZ.editSprintModalLoad));
    const editSprintModalTriggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const renderReleaseDropdownItem = (0, $5uXOq.useCallback)(()=>isReleaseVersionVisible && isTabNavigation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1wgv.default), {
            rapidViewId: boardId
        }), [
        boardId,
        isReleaseVersionVisible,
        isTabNavigation
    ]);
    const popupContent = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
            maxWidth: isTabNavigation ? 240 : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, shouldRenderFullscreenMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCKi5.ShortcutLabel), {
                text: "Z"
            }),
            onClick: toggleFullscreen,
            "aria-keyshortcuts": "Z"
        }, isFullscreen ? formatMessage((0, $gqdF8.default).exitFullScreen) : formatMessage((0, $gqdF8.default).enterFullScreen)), isEditSprintItemVisible && shouldRenderEditSprintMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLint.EditSprintMenuItem), {
            ref: editSprintModalTriggerRef,
            onClick: onClick
        }), shouldRenderManageWorkflowMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34djr.default), {
            projectKey: projectKey,
            isDisabled: isDisabled,
            issueTypeId: issueTypeId
        }), !isCMPBoard && isManageCustomFiltersEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1YHJ6.default), null) : null, !isCMPBoard && isCardMediaSwitchEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $90DyW.default), {
            isDisabled: isDisabled,
            onClick: onClick
        }) : null, !isCMPBoard && isConfigureBoardEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6w38i.default), null) : null, shouldRenderBoardSettingsMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eNd21.default), null), isCMPBoard && !isTabNavigation && !(0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
            boardId: boardId,
            projectKey: projectKey,
            location: "board-tools-1",
            onClickWebItem: onClick,
            mode: "work"
        }), shouldRenderCreateBoardMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efqda.default), null), isCMPBoard && !isTabNavigation && !(0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
            boardId: boardId,
            projectKey: projectKey,
            location: "view-actions-work",
            mode: "work"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
            boardId: boardId,
            projectKey: projectKey,
            location: "view-actions-print",
            onClickWebItem: onClick,
            mode: "work"
        })), renderReleaseDropdownItem(), (0, $4R6GH.fg)('jira_nav4_eap_drop_2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isCMPBoard && isTabNavigation && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bdV6X.BoardConnectItems), {
            projectKey: projectKey,
            boardId: boardId,
            onClickWebItem: onClick
        }), !isCMPBoard && isTabNavigation && hasOperations && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
            hasSeparator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $XvlUo.default), null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isTabNavigation && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4TS2v.default), {
            projectKey: projectKey,
            boardId: boardId,
            onClickWebItem: onClick
        }))));
    }, [
        boardId,
        editSprintModalTriggerRef,
        hasOperations,
        isCMPBoard,
        isCardMediaSwitchEnabled,
        isConfigureBoardEnabled,
        isDisabled,
        isEditSprintItemVisible,
        isManageCustomFiltersEnabled,
        isTabNavigation,
        issueTypeId,
        onClick,
        projectKey,
        renderReleaseDropdownItem,
        shouldRenderBoardSettingsMenuItem,
        shouldRenderCreateBoardMenuItem,
        shouldRenderEditSprintMenuItem,
        shouldRenderManageWorkflowMenuItem,
        shouldRenderFullscreenMenuItem,
        isFullscreen,
        toggleFullscreen,
        formatMessage
    ]);
    // hide the meatball menu button if user doesn't have edit board permission for JSM project
    if (isJSMBoard && !canEditBoard) return null;
    const dropdownItemGroupContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, shouldRenderFullscreenMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCKi5.ShortcutLabel), {
            text: "Z"
        }),
        onClick: toggleFullscreen,
        "aria-keyshortcuts": "Z"
    }, isFullscreen ? formatMessage((0, $gqdF8.default).exitFullScreen) : formatMessage((0, $gqdF8.default).enterFullScreen)), isEditSprintItemVisible && shouldRenderEditSprintMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLint.EditSprintMenuItem), {
        ref: editSprintModalTriggerRef,
        onClick: onClick
    }), shouldRenderManageWorkflowMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34djr.default), {
        projectKey: projectKey,
        isDisabled: isDisabled,
        issueTypeId: issueTypeId
    }), !isCMPBoard && isManageCustomFiltersEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1YHJ6.default), null) : null, !isCMPBoard && isCardMediaSwitchEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $90DyW.default), {
        isDisabled: isDisabled,
        onClick: onClick
    }) : null, !isCMPBoard && isConfigureBoardEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6w38i.default), null) : null, shouldRenderBoardSettingsMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eNd21.default), null), isCMPBoard && !isTabNavigation && !(0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "board-tools-1",
        onClickWebItem: onClick,
        mode: "work"
    }), shouldRenderCreateBoardMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efqda.default), null), isCMPBoard && !isTabNavigation && !(0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "view-actions-work",
        mode: "work"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "view-actions-print",
        onClickWebItem: onClick,
        mode: "work"
    })), renderReleaseDropdownItem(), (0, $4R6GH.fg)('jira_nav4_eap_drop_2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isCMPBoard && isTabNavigation && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bdV6X.BoardConnectItems), {
        projectKey: projectKey,
        boardId: boardId,
        onClickWebItem: onClick
    }), !isCMPBoard && isTabNavigation && hasOperations && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $XvlUo.default), null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isTabNavigation && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4TS2v.default), {
        projectKey: projectKey,
        boardId: boardId,
        onClickWebItem: onClick
    })));
    const onAcknowledgeSpotlight = ()=>{
        markSpotlightAsSeen();
        setHasSpotlightDisplayed(true);
        setShouldShowSpotlight(false);
        setIsOpen(true);
        setIsPopupOpen(true);
    };
    if ((0, $4R6GH.fg)('make_board_menu_popup')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isEditSprintItemVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7EoeF.default), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        onReady: stopMetric
    }), (shouldRenderFullscreenMenuItem || shouldRenderBoardMoreMenuItem) && // eslint-disable-next-line jira/ff/no-preconditioning
    ((0, $4R6GH.fg)('jsm_boards_promo_gate') && isJSMBoard && isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $fd53e5cce0793701$export$3c389bd4d38f57a0),
        key: "add-form-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        radius: 3,
        pulse: shouldShowPulse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: isPopupOpen,
        onClose: onClose,
        placement: "bottom-end",
        content: popupContent,
        trigger: popupTrigger
    }), shouldRenderFullscreenMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: shortcutsKeyMap
    })), shouldShowSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6tHP5.OnboardingSpotlight), {
        onAcknowledge: onAcknowledgeSpotlight
    }), shouldShowPulse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "boardAdminOnboardingConfigPulse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            name: 'boardAdminOnboardingConfigPulse'
        }
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: isPopupOpen,
        onClose: onClose,
        placement: "bottom-end",
        content: popupContent,
        trigger: popupTrigger
    }), shouldRenderFullscreenMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: shortcutsKeyMap
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isEditSprintItemVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7EoeF.default), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        onReady: stopMetric
    }), (shouldRenderFullscreenMenuItem || shouldRenderBoardMoreMenuItem) && // eslint-disable-next-line jira/ff/no-preconditioning
    ((0, $4R6GH.fg)('jsm_boards_promo_gate') && isJSMBoard && isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $fd53e5cce0793701$export$3c389bd4d38f57a0),
        key: "add-form-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        radius: 3,
        pulse: shouldShowPulse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        placement: "bottom-end",
        isOpen: isOpen,
        testId: "software-board.header.menu.dropdown-menu",
        onOpenChange: onOpenChange,
        trigger: dropdownMenuTrigger,
        shouldRenderToParent: isTabNavigation
    }, isTabNavigation && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8897bbc801abac9f$var$dropdownMenuGroupStyles
    }, dropdownItemGroupContent) : dropdownItemGroupContent), shouldRenderFullscreenMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: shortcutsKeyMap
    })), shouldShowSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6tHP5.OnboardingSpotlight), {
        onAcknowledge: onAcknowledgeSpotlight
    }), shouldShowPulse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "boardAdminOnboardingConfigPulse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            name: 'boardAdminOnboardingConfigPulse'
        }
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        placement: "bottom-end",
        isOpen: isOpen,
        testId: "software-board.header.menu.dropdown-menu",
        onOpenChange: onOpenChangeOld,
        trigger: dropdownMenuTrigger,
        shouldRenderToParent: isTabNavigation
    }, isTabNavigation && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8897bbc801abac9f$var$dropdownMenuGroupStyles
    }, dropdownItemGroupContent) : dropdownItemGroupContent), shouldRenderFullscreenMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: shortcutsKeyMap
    }))));
};
const $8897bbc801abac9f$var$dropdownMenuGroupStyles = (0, $8CUq3.xcss)({
    maxWidth: '240px'
});
var $8897bbc801abac9f$export$2e2bcd8739ae039 = $8897bbc801abac9f$var$BoardMenu;

});
parcelRegister("5QsHM", function(module, exports) {

$parcel$export(module.exports, "useSeenStatus", () => $36807a4a4f35954c$export$12667e37571b0a02);

var $5uXOq = parcelRequire("5uXOq");


var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $j8DrX = parcelRequire("j8DrX");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");
const $36807a4a4f35954c$var$initialState = {
    isSeen: true,
    isLoading: false,
    error: undefined
};
const $36807a4a4f35954c$export$f7ab30339d40bcd = ()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true';
const $36807a4a4f35954c$export$12667e37571b0a02 = ({ userPropertyKey: userPropertyKey, isSeenValue: isSeenValue, packageName: packageName, teamName: teamName, skipOnboarding: skipOnboarding })=>{
    const [state, setState] = (0, $5uXOq.useState)($36807a4a4f35954c$var$initialState);
    const { atlassianAccountId: accountId } = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const reportErrorDeps = (0, $5uXOq.useRef)({
        packageName: packageName,
        teamName: teamName
    });
    reportErrorDeps.current = {
        packageName: packageName,
        teamName: teamName
    };
    const reportError = (0, $5uXOq.useCallback)((errorId, error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: errorId,
                ...reportErrorDeps.current
            },
            error: error,
            attributes: {
                isClientFetchError: (0, $fZneA.isClientFetchError)(error)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (accountId && !$36807a4a4f35954c$export$f7ab30339d40bcd() && !skipOnboarding) {
            setState((oldState)=>({
                    ...oldState,
                    isLoading: true
                }));
            (0, $89SaW.getUserProperty)(accountId, userPropertyKey).catch((error)=>{
                if (error.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef)) // user property has not been set
                return false;
                throw error;
            }).then((value)=>{
                setState((oldState)=>({
                        ...oldState,
                        isSeen: value === isSeenValue,
                        isLoading: false
                    }));
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useSeenStatus.fetchStatus succeeded', {
                    userPropertyKey: userPropertyKey
                });
            }).catch((error)=>{
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false,
                        error: error
                    }));
                reportError('useSeenStatus.fetchStatus', error);
            });
        }
    }, [
        userPropertyKey,
        accountId,
        isSeenValue,
        reportError,
        createAnalyticsEvent,
        skipOnboarding
    ]);
    const markAsSeen = (0, $5uXOq.useCallback)(()=>{
        if (accountId && !$36807a4a4f35954c$export$f7ab30339d40bcd() && !skipOnboarding) {
            setState((oldState)=>({
                    ...oldState,
                    isSeen: true,
                    isLoading: true
                }));
            (0, $89SaW.setUserProperties)(accountId, userPropertyKey, JSON.stringify(isSeenValue)).then((res)=>{
                if (!res.ok) return res.text().then((errResp)=>{
                    throw new (0, $jJZqs.default)(res.status, errResp);
                });
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false
                    }));
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'useSeenStatus.markAsSeen succeeded', {
                    userPropertyKey: userPropertyKey
                });
                return Promise.resolve();
            }).catch((error)=>{
                // leave `isSeen` as true. we don't want to block the user
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false,
                        error: error
                    }));
                reportError('useSeenStatus.markAsSeen', error);
            });
        }
    }, [
        accountId,
        userPropertyKey,
        isSeenValue,
        createAnalyticsEvent,
        reportError,
        skipOnboarding
    ]);
    return [
        state,
        {
            markAsSeen: markAsSeen
        }
    ];
};

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;


parcelRegister("aCKi5", function(module, exports) {

$parcel$export(module.exports, "ShortcutLabel", () => $e8926de4a65ad47f$export$dfa0cc182ab7b0c3);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $e8926de4a65ad47f$export$dfa0cc182ab7b0c3 = ({ text: text })=>// For A11y add `aria-keyshortcuts={yourShortcut}` to the element you are adding this label to
    // Added `aria-hidden` for the screen readers to ignore the label element
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        "aria-hidden": true,
        xcss: $e8926de4a65ad47f$var$ShortcutLabelComponentStyles
    }, text);
const $e8926de4a65ad47f$var$ShortcutLabelComponentStyles = (0, $8CUq3.xcss)({
    display: 'inline-block',
    backgroundColor: 'color.background.neutral',
    borderRadius: 'border.radius.100',
    fontSize: "var(--ds-space-150, 12px)",
    lineHeight: "var(--ds-space-150, 12px)",
    paddingTop: 'space.075',
    paddingBottom: 'space.075',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});

});

parcelRegister("e8X1M", function(module, exports) {

$parcel$export(module.exports, "BoardConnectMenuItems", () => $7ffeafe4bb5b3117$export$d8d46adb5b629caf);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $fjfkx = parcelRequire("fjfkx");

var $2NYED = parcelRequire("2NYED");

var $fNWqR = parcelRequire("fNWqR");

var $78UP2 = parcelRequire("78UP2");
function $7ffeafe4bb5b3117$var$BoardConnectMenuItemsInner({ projectKey: projectKey, boardId: boardId, location: location, mode: mode, onClickWebItem: onClickWebItem }) {
    const toolSections = (0, $fNWqR.useFetchedToolSections)({
        boardId: boardId,
        projectKey: projectKey,
        mode: mode
    });
    const targetSection = (0, $5uXOq.useMemo)(()=>toolSections && location && (0, $78UP2.findSection)(toolSections, location), [
        toolSections,
        location
    ]);
    if (!location && (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4')) return toolSections ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjfkx.BoardToolsView), {
        toolSections: toolSections,
        mode: "dropdown-item"
    }) : null;
    if (!toolSections || !targetSection) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, targetSection.subItems?.filter((item)=>item.id != null) // built-in items don't have IDs set
    .map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NYED.BoardToolSubItem), {
            onClickWebItem: onClickWebItem,
            key: item.id,
            subItem: item
        })) ?? null);
}
function $7ffeafe4bb5b3117$export$d8d46adb5b629caf(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "board-connect-toolbar",
        packageName: "@atlassian/jira-software-board-connect-menu-items",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7ffeafe4bb5b3117$var$BoardConnectMenuItemsInner, props));
}

});
parcelRegister("fjfkx", function(module, exports) {

$parcel$export(module.exports, "useConnectPluginSections", () => $761d5c3db4b1e977$export$9f557e5e5102c0b2);
$parcel$export(module.exports, "BoardToolsView", () => $761d5c3db4b1e977$export$a97914bd35ac0c68);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $88pw4 = parcelRequire("88pw4");

var $2NYED = parcelRequire("2NYED");
function $761d5c3db4b1e977$export$9f557e5e5102c0b2(toolSections) {
    return (0, $5uXOq.useMemo)(()=>toolSections?.filter((section)=>section.id !== 'board-tools-section'), [
        toolSections
    ]);
}
function $761d5c3db4b1e977$export$a97914bd35ac0c68({ toolSections: toolSections, mode: mode = 'button' }) {
    const relevantSections = $761d5c3db4b1e977$export$9f557e5e5102c0b2(toolSections);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, relevantSections?.map((section)=>section.type === 'webItem' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NYED.BoardToolWebItemView), {
            key: section.id,
            subItem: section,
            mode: mode
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $88pw4.BoardToolSectionView), {
            key: section.id,
            section: section,
            isMenuItem: mode === 'dropdown-item' && (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4')
        })));
}

});
parcelRegister("88pw4", function(module, exports) {

$parcel$export(module.exports, "BoardToolSectionView", () => $298a4a1ba5bb50fb$export$c57d75d82c2414d5);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $BLPHT = parcelRequire("BLPHT");

var $hRf4g = parcelRequire("hRf4g");

var $hORKG = parcelRequire("hORKG");

var $3dGN0 = parcelRequire("3dGN0");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $1I7E8 = parcelRequire("1I7E8");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $2NYED = parcelRequire("2NYED");
function $298a4a1ba5bb50fb$export$c57d75d82c2414d5({ section: section, isMenuItem: isMenuItem = false }) {
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    if ((0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4')) {
        const content = ()=>section.subItems?.map((subItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NYED.BoardToolSubItem), {
                    key: subItem.id,
                    subItem: subItem
                }));
        return isMenuItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "left-start",
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    content: section.label
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
                    ...triggerProps,
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRf4g))), {
                        label: section.label,
                        color: "var(--ds-icon, #44546F)"
                    }),
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                    onClick: ()=>setIsOpen(!isOpen),
                    testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.popup-menu-trigger"
                }, section.label)),
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
                    maxWidth: 240,
                    onClick: (e)=>e.stopPropagation()
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, content()))
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-end",
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    content: section.label
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
                    ...triggerProps,
                    isSelected: isOpen,
                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($hORKG))),
                    onClick: ()=>setIsOpen(!isOpen),
                    testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.popup-menu-trigger"
                }, section.label)),
            content: content
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        placement: "bottom-end",
        trigger: section.label,
        testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.dropdown-menu"
    }, section.subItems?.map((subItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NYED.BoardToolSubItem), {
            key: subItem.id,
            subItem: subItem
        })));
}

});
parcelRegister("2NYED", function(module, exports) {

$parcel$export(module.exports, "BoardToolWebItemView", () => $d8e9f6c964974fcf$export$37f386501b29905e);
$parcel$export(module.exports, "BoardToolSubItem", () => $d8e9f6c964974fcf$export$dbbc4e042bbab47e);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");

var $hRf4g = parcelRequire("hRf4g");

var $3dGN0 = parcelRequire("3dGN0");

var $kJpBP = parcelRequire("kJpBP");
var $3Z96c = parcelRequire("3Z96c");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $1I7E8 = parcelRequire("1I7E8");

var $3bDjY = parcelRequire("3bDjY");

var $39xOx = parcelRequire("39xOx");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $kxZPA = parcelRequire("kxZPA");
var $7hSN4 = parcelRequire("7hSN4");

const $d8e9f6c964974fcf$export$87f324ad8d8a087a = (0, $kxZPA.lazy)(()=>(parcelRequire("599op")).then(({ BoardToolWebPanelView: BoardToolWebPanelView })=>({
            default: BoardToolWebPanelView
        })), {
    moduleId: "./src/packages/software/connect-toolbar/src/common/ui/tool-sections/board-tool-section-view/board-tool-sub-item/board-tool-web-panel-view/index.tsx"
});
function $d8e9f6c964974fcf$export$37f386501b29905e({ subItem: subItem, mode: mode = 'dropdown-item', onClickWebItem: onClickWebItem }) {
    const webItemLinkRef = (0, $5uXOq.useRef)(null);
    const handleOnClickWebItem = (e)=>{
        e.preventDefault();
        webItemLinkRef.current?.click();
        if (onClickWebItem) onClickWebItem();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, mode === 'dropdown-item' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') ? subItem.label : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        "data-testid": "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.board-tool-sub-item.link-item",
        onClick: handleOnClickWebItem,
        iconBefore: (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRf4g))), {
            label: subItem.label,
            color: "var(--ds-icon, #44546F)"
        }) : undefined
    }, subItem.label)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.board-tool-sub-item.link-item",
        onClick: handleOnClickWebItem
    }, subItem.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8e9f6c964974fcf$var$HiddenLink, {
        ref: webItemLinkRef,
        href: subItem.url,
        className: subItem.cssClass ?? ''
    }, subItem.label));
}
function $d8e9f6c964974fcf$export$dbbc4e042bbab47e({ subItem: subItem, onClickWebItem: onClickWebItem }) {
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    if (subItem.type === 'webItem') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8e9f6c964974fcf$export$37f386501b29905e, {
        onClickWebItem: onClickWebItem,
        subItem: subItem
    });
    if (subItem.type === 'section') {
        const content = subItem.subItems?.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8e9f6c964974fcf$export$dbbc4e042bbab47e, {
                key: item.id,
                subItem: item
            }));
        if (subItem.label === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, content);
        if ((0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "left-start",
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    content: subItem.label
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
                    ...triggerProps,
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRf4g))), {
                        label: subItem.label,
                        color: "var(--ds-icon, #44546F)"
                    }),
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                    onClick: ()=>setIsOpen(!isOpen),
                    testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.board-tool-sub-item.popup-menu-trigger"
                }, subItem.label)),
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
                    maxWidth: 240,
                    onClick: (e)=>e.stopPropagation()
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, content))
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
            placement: "right-end",
            trigger: subItem.label,
            testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.board-tool-sub-item.dropdown-menu"
        }, content);
    }
    if (subItem.type === 'webPanel') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "board-tool-web-panel-view",
        packageName: "@atlassian/jira-software-connect-toolbar",
        teamName: "a4t-tanuki"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7hSN4.LazySuspense), {
        fallback: "Loading..."
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8e9f6c964974fcf$export$87f324ad8d8a087a, {
        webPanel: subItem
    })));
    return null;
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d8e9f6c964974fcf$var$HiddenLink = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("599op", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("6LO0W").then(()=>parcelRequire('cvEOi'));

});




parcelRegister("fNWqR", function(module, exports) {

$parcel$export(module.exports, "useFetchedToolSections", () => $08c1f6f26ff4abdf$export$32bd6c5ac0419028);
$parcel$export(module.exports, "useHasToolSections", () => $08c1f6f26ff4abdf$export$54be06d39c052cd5);
$parcel$export(module.exports, "useFetchedSprintActions", () => $08c1f6f26ff4abdf$export$d58666d3ff237ccd);

var $5uXOq = parcelRequire("5uXOq");

var $7JoAD = parcelRequire("7JoAD");

var $fjfkx = parcelRequire("fjfkx");

var $78UP2 = parcelRequire("78UP2");

var $lEUlW = parcelRequire("lEUlW");
const $08c1f6f26ff4abdf$export$390f32400eaf98c9 = (0, $7JoAD.createStore)({
    name: '@atlassian/jira-software-connect-toolbar',
    initialState: {
        toolSections: null,
        key: null,
        isLoading: false,
        sprintActions: null
    },
    actions: $lEUlW
});
const $08c1f6f26ff4abdf$export$d5aeb5eefb04c978 = (0, $7JoAD.createHook)($08c1f6f26ff4abdf$export$390f32400eaf98c9, {
    selector: (state)=>state.toolSections
});
function $08c1f6f26ff4abdf$export$32bd6c5ac0419028({ boardId: boardId, projectKey: projectKey, mode: mode = 'work' }) {
    const [toolSections, { fetchExtensionData: fetchExtensionData }] = $08c1f6f26ff4abdf$export$d5aeb5eefb04c978();
    (0, $5uXOq.useEffect)(()=>{
        fetchExtensionData({
            boardId: boardId,
            projectKey: projectKey,
            mode: mode
        });
    }, [
        boardId,
        fetchExtensionData,
        mode,
        projectKey
    ]);
    return toolSections;
}
function $08c1f6f26ff4abdf$export$54be06d39c052cd5({ boardId: boardId, projectKey: projectKey, mode: mode = 'work', itemLocations: itemLocations = [] }) {
    const toolSections = $08c1f6f26ff4abdf$export$32bd6c5ac0419028({
        boardId: boardId,
        projectKey: projectKey,
        mode: mode
    });
    const relevantSections = (0, $fjfkx.useConnectPluginSections)(toolSections ?? []);
    const hasRelevantSections = relevantSections ? relevantSections.length > 0 : false;
    const hasTargetSections = itemLocations.some((location)=>((toolSections && (0, $78UP2.findSection)(toolSections, location)?.subItems?.filter((item)=>item.id != null).length) ?? 0) > 0);
    return hasTargetSections || hasRelevantSections;
}
const $08c1f6f26ff4abdf$export$fa6cceef0215e684 = (0, $7JoAD.createHook)($08c1f6f26ff4abdf$export$390f32400eaf98c9, {
    selector: (state)=>state.sprintActions
});
const $08c1f6f26ff4abdf$export$d58666d3ff237ccd = ({ sprintId: sprintId })=>{
    const [sprintActions, { fetchSprintActionsData: fetchSprintActionsData }] = $08c1f6f26ff4abdf$export$fa6cceef0215e684();
    (0, $5uXOq.useEffect)(()=>{
        fetchSprintActionsData({
            sprintId: sprintId
        });
    }, [
        fetchSprintActionsData,
        sprintId
    ]);
    return sprintActions;
};

});
parcelRegister("78UP2", function(module, exports) {

$parcel$export(module.exports, "findSection", () => $003eeb674acde218$export$967ce3543c950aeb);
function $003eeb674acde218$export$967ce3543c950aeb(toolSections, location) {
    for(let i = 0; i < toolSections.length; i += 1){
        const item = toolSections[i];
        if (item.type === 'section' && item.id === location) return item;
        if (item.type === 'section' && item.subItems != null) {
            const candidate = $003eeb674acde218$export$967ce3543c950aeb(item.subItems, location);
            if (candidate != null) return candidate;
        }
    }
    return null;
}

});

parcelRegister("lEUlW", function(module, exports) {

$parcel$export(module.exports, "fetchExtensionData", () => $5344c8cf4b3b110f$export$5fe98ae96d282610);
$parcel$export(module.exports, "fetchSprintActionsData", () => $5344c8cf4b3b110f$export$d50a304a5f5a89a3);

var $dJl1T = parcelRequire("dJl1T");

var $agj21 = parcelRequire("agj21");

var $b1Aqw = parcelRequire("b1Aqw");
const $5344c8cf4b3b110f$export$5fe98ae96d282610 = ({ boardId: boardId, projectKey: projectKey, mode: mode = 'work' })=>async ({ getState: getState, setState: setState })=>{
        const key = JSON.stringify([
            projectKey,
            boardId,
            mode
        ]);
        const state = getState();
        if (state.key === key && state.isLoading) return;
        if (state.key !== key) setState({
            toolSections: null,
            isLoading: true,
            key: key
        });
        else setState({
            isLoading: true
        });
        try {
            const response = await (0, $b1Aqw.fetchCMPExtensionData)({
                boardId: boardId,
                projectKey: projectKey,
                mode: mode
            });
            setState({
                toolSections: response.sections,
                key: key,
                isLoading: false
            });
        } catch (error) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('software.extension.board-tools', error instanceof Error ? error.message : String(error), error instanceof Error ? error : undefined);
            setState({
                isLoading: false
            });
        }
    };
const $5344c8cf4b3b110f$export$d50a304a5f5a89a3 = ({ sprintId: sprintId })=>async ({ getState: getState, setState: setState })=>{
        const { sprintActions: sprintActions } = getState();
        const findActions = sprintActions?.[sprintId] || {
            isLoading: false,
            hasLoaded: false
        };
        if (findActions.isLoading || findActions.hasLoaded) return;
        // set loading to true to prevent multiple requests
        setState({
            sprintActions: {
                ...sprintActions,
                [sprintId]: {
                    isLoading: true,
                    hasLoaded: false
                }
            }
        });
        try {
            const response = await (0, $b1Aqw.fetchCMPSprintActionsData)({
                sprintId: sprintId
            });
            const actionsForSprint = (0, $agj21.transformSprintActionsResponse)(response);
            setState({
                sprintActions: {
                    ...getState().sprintActions,
                    [sprintId]: {
                        ...actionsForSprint,
                        isLoading: false,
                        hasLoaded: true
                    }
                }
            });
        } catch (error) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('software.extension.sprint-actions', error instanceof Error ? error.message : String(error), error instanceof Error ? error : undefined);
            setState({
                sprintActions: {
                    ...getState().sprintActions,
                    [sprintId]: {
                        isLoading: false,
                        hasLoaded: false
                    }
                }
            });
        }
    };

});
parcelRegister("agj21", function(module, exports) {

$parcel$export(module.exports, "transformSprintActionsResponse", () => $96e521c26ac919f8$export$bb626d8539383296);
const $96e521c26ac919f8$export$8b3475589327aa1c = (sprintAction)=>({
        id: sprintAction.id,
        type: 'webItem',
        label: sprintAction.name,
        url: sprintAction.url,
        cssClass: sprintAction.styleClass
    });
const $96e521c26ac919f8$export$5365f133b30aefb1 = (sprintAction)=>Boolean(sprintAction.url);
const $96e521c26ac919f8$export$1d427bb13100a4da = (section)=>section.groupId === 'sprint-move-actions' || section.groupId === 'sprint-edit-action' || section.groupId === 'sprint-delete-action';
const $96e521c26ac919f8$export$bb626d8539383296 = (sprintActionsResponse)=>{
    const result = {};
    sprintActionsResponse.sections.filter($96e521c26ac919f8$export$1d427bb13100a4da).forEach((section)=>{
        const actions = section.actions.filter($96e521c26ac919f8$export$5365f133b30aefb1).map($96e521c26ac919f8$export$8b3475589327aa1c);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        result[section.groupId] = actions;
    });
    return result;
};

});

parcelRegister("b1Aqw", function(module, exports) {

$parcel$export(module.exports, "fetchCMPExtensionData", () => $ce9155dcdaa49b1d$export$aa96aae4fab07720);
$parcel$export(module.exports, "fetchCMPSprintActionsData", () => $ce9155dcdaa49b1d$export$2a796a8235b7b986);

var $7f4tk = parcelRequire("7f4tk");
function $ce9155dcdaa49b1d$export$aa96aae4fab07720({ boardId: boardId, projectKey: projectKey, mode: mode = 'work' }) {
    return (0, $7f4tk.default)(`/rest/greenhopper/1.0/xboard/toolSections?mode=${mode}&rapidViewId=${boardId}&selectedProjectKey=${projectKey}&_=${Date.now()}`);
}
function $ce9155dcdaa49b1d$export$2a796a8235b7b986({ sprintId: sprintId }) {
    return (0, $7f4tk.default)(`/rest/greenhopper/1.0/xboard/plan/sprints/actions?sprintId=${sprintId}&_=${Date.now()}`);
}

});




parcelRegister("bsWqi", function(module, exports) {

$parcel$export(module.exports, "editSprintModalEntryPoint", () => $505b0c872e6b9936$export$62497640baecc927);

var $58I1r = parcelRequire("58I1r");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $505b0c872e6b9936$export$62497640baecc927 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("ebu5E")), {
        moduleId: "c7ce165f"
    }),
    getPreloadProps: ({ boardId: boardId, sprintId: sprintId, fetchSprints: fetchSprints })=>({
            queries: {
                editSprintModal: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $58I1r.default,
                    variables: {
                        boardId: boardId,
                        sprintId: sprintId,
                        fetchSprints: fetchSprints
                    }
                }
            }
        })
});

});
parcelRegister("58I1r", function(module, exports) {

$parcel$export(module.exports, "default", () => $b86022cd8e5ea5c2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a6471efb4cf0d88bef3ca4f275ac9826>>
 * @relayHash a7c5c4d6570548dfbbb896009ae5fc47
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 90bffcc09f8865bee8f7861946866baaa79e714bb9afc19568bc71a86050977b
const $b86022cd8e5ea5c2$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "90bffcc09f8865bee8f7861946866baaa79e714bb9afc19568bc71a86050977b",
        "metadata": {},
        "name": "uiJiraSoftwareEditSprintModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $b86022cd8e5ea5c2$export$2e2bcd8739ae039 = $b86022cd8e5ea5c2$var$node;

});

parcelRegister("ebu5E", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("3EQwu")
]).then(()=>parcelRequire('cqAIL'));

});


parcelRegister("34djr", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf4b01ed125ead2e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $6B7KL = parcelRequire("6B7KL");

var $kJpBP = parcelRequire("kJpBP");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $02Psx = parcelRequire("02Psx");

var $dIdda = parcelRequire("dIdda");

var $bD5EH = parcelRequire("bD5EH");
const $cf4b01ed125ead2e$var$ManageWorkflowMenuItem = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isDisabled: isDisabled, projectKey: projectKey, issueTypeId: issueTypeId } = props;
    return (0, $4R6GH.fg)('make_board_menu_popup') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.RouterActions), null, ({ push: push })=>{
        const onClick = issueTypeId ? ()=>push((0, $02Psx.getNextgenSettingsWorkflowUrl)((0, $2vSU6.SOFTWARE_PROJECT), projectKey, issueTypeId)) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
            isDisabled: isDisabled || !issueTypeId,
            onClick: onClick
        }, formatMessage((0, $bD5EH.default).displayText));
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.RouterActions), null, ({ push: push })=>{
        const onClick = issueTypeId ? ()=>push((0, $02Psx.getNextgenSettingsWorkflowUrl)((0, $2vSU6.SOFTWARE_PROJECT), projectKey, issueTypeId)) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            isDisabled: isDisabled || !issueTypeId,
            onClick: onClick
        }, formatMessage((0, $bD5EH.default).displayText));
    });
};
var $cf4b01ed125ead2e$export$2e2bcd8739ae039 = $cf4b01ed125ead2e$var$ManageWorkflowMenuItem;

});
parcelRegister("bD5EH", function(module, exports) {

$parcel$export(module.exports, "default", () => $da7e090061393796$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $da7e090061393796$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    displayText: {
        "id": "software-manage-workflow-menu-item.display-text",
        "defaultMessage": "Manage workflow"
    }
});

});


parcelRegister("90DyW", function(module, exports) {

$parcel$export(module.exports, "default", () => $bca6cd54de9a6900$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $8QpSo = parcelRequire("8QpSo");

var $bC2fB = parcelRequire("bC2fB");


var $bRqd3 = parcelRequire("bRqd3");

var $1vXOx = parcelRequire("1vXOx");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $9dhHU = parcelRequire("9dhHU");
const $bca6cd54de9a6900$export$c31df4bd766f9c35 = (state, props = {
    isDisabled: false,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
})=>({
        isMediaEnabled: (0, $5mTgl.isCardMediaEnabled)(state),
        isDisabled: props.isDisabled || !(0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df] || (0, $67Z81.getIsCMPBoard)(state)
    });
const $bca6cd54de9a6900$export$9e6a17cf56877796 = (dispatch)=>({
        dispatch: dispatch
    });
const $bca6cd54de9a6900$var$onClickFactory = (0, $8QpSo.default)((dispatch, isMediaEnabled, onClick)=>()=>{
        dispatch((0, $bRqd3.cardMediaToggleRequest)(!isMediaEnabled));
        onClick();
    });
const $bca6cd54de9a6900$export$9d1611c77c2fe928 = (stateProps, dispatchProps, ownProps)=>{
    const { isMediaEnabled: isMediaEnabled, isDisabled: isDisabled } = stateProps;
    const { dispatch: dispatch } = dispatchProps;
    const { onClick: onClick } = ownProps;
    return {
        isMediaEnabled: isMediaEnabled,
        isDisabled: isDisabled,
        onClick: $bca6cd54de9a6900$var$onClickFactory(dispatch, isMediaEnabled, onClick)
    };
};
const $bca6cd54de9a6900$var$connector = (0, $bC2fB.connect)($bca6cd54de9a6900$export$c31df4bd766f9c35, $bca6cd54de9a6900$export$9e6a17cf56877796, $bca6cd54de9a6900$export$9d1611c77c2fe928);
var $bca6cd54de9a6900$export$2e2bcd8739ae039 = $bca6cd54de9a6900$var$connector((0, $9dhHU.default));

});
parcelRegister("9dhHU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c71a2cd7b5093e7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $ousew = parcelRequire("ousew");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3Awmo = parcelRequire("3Awmo");
const $5c71a2cd7b5093e7$var$MediaCardEnableItem = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        key: "card-media-enable",
        isDisabled: props.isDisabled,
        onClick: props.onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $3Awmo.default).showCover));
const $5c71a2cd7b5093e7$var$MediaCardDisableItem = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        key: "card-media-disable",
        isDisabled: props.isDisabled,
        onClick: props.onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $3Awmo.default).hideCover));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5c71a2cd7b5093e7$export$2e2bcd8739ae039 = (props)=>{
    const { isMediaEnabled: isMediaEnabled, ...otherProps } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const mediaCardProps = {
        ...otherProps,
        onClick: ()=>{
            props.onClick();
            const event = createAnalyticsEvent({
                action: 'toggle',
                actionSubject: 'cardCoverImageVisibilityToggleDropdownMenuItem'
            });
            (0, $8zOmE.fireUIAnalytics)(event, {
                isEnabled: !isMediaEnabled
            });
        }
    };
    return isMediaEnabled ? $5c71a2cd7b5093e7$var$MediaCardDisableItem(mediaCardProps) : $5c71a2cd7b5093e7$var$MediaCardEnableItem(mediaCardProps);
};

});
parcelRegister("3Awmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $edfebe170e0504c5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $edfebe170e0504c5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showCover: {
        "id": "software.main.header.menu.card-media-item.show-cover",
        "defaultMessage": "Show cover images"
    },
    hideCover: {
        "id": "software.main.header.menu.card-media-item.hide-cover",
        "defaultMessage": "Hide cover images"
    }
});

});



parcelRegister("eNd21", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2a8ffa6d7137790$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $2vSU6 = parcelRequire("2vSU6");

var $koVbs = parcelRequire("koVbs");

var $4DPZY = parcelRequire("4DPZY");

var $gSBIZ = parcelRequire("gSBIZ");

var $67sX6 = parcelRequire("67sX6");

var $kv0Sc = parcelRequire("kv0Sc");
const $c2a8ffa6d7137790$export$444102a091dc311d = ()=>{
    const defaultValue = 'default';
    try {
        const value = localStorage.getItem('selectedConfigTab');
        return value ? JSON.parse(value) : defaultValue;
    } catch (err) {
        return defaultValue;
    }
};
function $c2a8ffa6d7137790$export$41cd2e3ea8f815d6({ containerData: containerData, boardId: boardId, selectedConfigTab: selectedConfigTab }) {
    // containerData should never be null, but we are being defensive here.
    if (containerData == null) return '';
    if ((0, $gSBIZ.isProjectContext)(containerData) && containerData.project.type === (0, $2vSU6.SERVICE_DESK_PROJECT)) return `/jira/servicedesk/projects/${containerData.project.key}/boards/${boardId}/?config=${selectedConfigTab}`;
    return (0, $gSBIZ.isUserContext)(containerData) ? `/jira/people/${containerData.user.accountId}/boards/${boardId}/?config=${selectedConfigTab}` : `/jira/software/c/projects/${containerData.project.key}/boards/${boardId}/?config=${selectedConfigTab}`;
}
function $c2a8ffa6d7137790$var$useConfigureBoardUrl() {
    const boardId = (0, $67sX6.useBoardSelector)((state)=>state.configuration.rapidViewId);
    // Read the current settings tab from localStorage to redirect.
    const selectedConfigTab = (0, $5uXOq.useMemo)($c2a8ffa6d7137790$export$444102a091dc311d, []);
    const [{ data: containerData }] = (0, $4DPZY.useContainerContext)();
    const configureBoardUrl = (0, $5uXOq.useMemo)(()=>$c2a8ffa6d7137790$export$41cd2e3ea8f815d6({
            containerData: containerData,
            boardId: boardId,
            selectedConfigTab: selectedConfigTab
        }), [
        boardId,
        containerData,
        selectedConfigTab
    ]);
    return configureBoardUrl;
}
const $c2a8ffa6d7137790$var$ConfigureBoardMenuItem = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const configureBoardUrl = $c2a8ffa6d7137790$var$useConfigureBoardUrl();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        href: configureBoardUrl,
        "data-testid": "software-board.header.menu.configure-board.custom-item"
    }, formatMessage((0, $kv0Sc.default).displayText));
};
var $c2a8ffa6d7137790$export$2e2bcd8739ae039 = $c2a8ffa6d7137790$var$ConfigureBoardMenuItem;

});
parcelRegister("kv0Sc", function(module, exports) {

$parcel$export(module.exports, "default", () => $b50cc02a262fb48e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b50cc02a262fb48e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    displayText: {
        "id": "software.main.header.menu.configure-board.display-text",
        "defaultMessage": "Configure board"
    }
});

});


parcelRegister("6w38i", function(module, exports) {

$parcel$export(module.exports, "default", () => $678d102715044776$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $eph8m = parcelRequire("eph8m");

var $67Z81 = parcelRequire("67Z81");

var $2dZ2i = parcelRequire("2dZ2i");
const $678d102715044776$var$mapStateToProps = (state)=>({
        url: (0, $eph8m.getColumnStatusMappingUrl)((0, $67Z81.projectKeySelector)(state), (0, $67Z81.rapidViewIdSelector)(state))
    });
var $678d102715044776$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($678d102715044776$var$mapStateToProps, {})((0, $2dZ2i.default));

});
parcelRegister("2dZ2i", function(module, exports) {

$parcel$export(module.exports, "default", () => $d46df2c8fd18d915$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $az4zD = parcelRequire("az4zD");

var $14uhY = parcelRequire("14uhY");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dIdda = parcelRequire("dIdda");

var $d1Bsi = parcelRequire("d1Bsi");
const $d46df2c8fd18d915$export$cc501cfa2aa02d4e = ({ intl: intl, url: url })=>{
    const { push: push } = (0, $dIdda.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'dropdownItem',
            action: 'clicked'
        }), 'clickConfigureBoardItem');
        (0, $14uhY.setReturnToProjectUrl)();
        push(url);
    }, [
        push,
        url,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: onClick
    }, intl.formatMessage((0, $d1Bsi.default).displayText));
};
var $d46df2c8fd18d915$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($d46df2c8fd18d915$export$cc501cfa2aa02d4e);

});
parcelRegister("d1Bsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e772f6c83682696$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5e772f6c83682696$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    displayText: {
        "id": "software.main.header.menu.configure-board-item.display-text",
        "defaultMessage": "Configure board"
    }
});

});



parcelRegister("4TS2v", function(module, exports) {

$parcel$export(module.exports, "default", () => $04b670b259c61041$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $k8auG = parcelRequire("k8auG");

var $cxogS = parcelRequire("cxogS");
const $04b670b259c61041$var$mapStateToProps = (state)=>({
        hasOperations: (0, $k8auG.operationsSelector)(state).length > 0
    });
var // delete file on 'jira_nav4_eap_drop_2' clean up
$04b670b259c61041$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($04b670b259c61041$var$mapStateToProps)((0, $cxogS.default));

});
parcelRegister("cxogS", function(module, exports) {

$parcel$export(module.exports, "default", () => $372e19927c9a912b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aRoVz = parcelRequire("aRoVz");

var $fNWqR = parcelRequire("fNWqR");

var $e8X1M = parcelRequire("e8X1M");

var $78UP2 = parcelRequire("78UP2");

var $63LqY = parcelRequire("63LqY");

var $XvlUo = parcelRequire("XvlUo");
const $372e19927c9a912b$var$BoardConnectItems = ({ projectKey: projectKey, boardId: boardId, onClickWebItem: onClickWebItem, hasOperations: hasOperations })=>{
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const toolSections = (0, $fNWqR.useFetchedToolSections)({
        boardId: boardId,
        projectKey: projectKey,
        mode: 'work'
    });
    const shouldRenderSection = (0, $5uXOq.useMemo)(()=>{
        const connectMenuItemLocations = [
            'board-tools-1',
            'view-actions-work',
            'view-actions-print'
        ];
        return Boolean(toolSections && (connectMenuItemLocations.map((location)=>((0, $78UP2.findSection)(toolSections, location)?.subItems?.filter((item)=>item.id != null).length ?? 0) > 0).includes(true) || toolSections?.filter((section)=>section.id !== 'board-tools-section').length > 0));
    }, [
        toolSections
    ]);
    return isCMPBoard ? shouldRenderSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "board-tools-1",
        onClickWebItem: onClickWebItem,
        mode: "work"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "view-actions-work",
        mode: "work"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "view-actions-print",
        onClickWebItem: onClickWebItem,
        mode: "work"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        mode: "work"
    })) : hasOperations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $XvlUo.default), null));
};
var // delete file on 'jira_nav4_eap_drop_2' clean up
$372e19927c9a912b$export$2e2bcd8739ae039 = $372e19927c9a912b$var$BoardConnectItems;

});


parcelRegister("bdV6X", function(module, exports) {

$parcel$export(module.exports, "BoardConnectItems", () => $1ed5b591520f1d61$export$2843ddf118c543ac);

var $5uXOq = parcelRequire("5uXOq");

var $aRoVz = parcelRequire("aRoVz");

var $fNWqR = parcelRequire("fNWqR");

var $e8X1M = parcelRequire("e8X1M");
const $1ed5b591520f1d61$export$2843ddf118c543ac = ({ projectKey: projectKey, boardId: boardId, onClickWebItem: onClickWebItem })=>{
    const itemLocations = [
        'board-tools-1',
        'view-actions-work',
        'view-actions-print'
    ];
    const hasToolSections = (0, $fNWqR.useHasToolSections)({
        boardId: boardId,
        projectKey: projectKey,
        mode: 'work',
        itemLocations: itemLocations
    });
    return hasToolSections && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "board-tools-1",
        onClickWebItem: onClickWebItem,
        mode: "work"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "view-actions-work",
        mode: "work"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "view-actions-print",
        onClickWebItem: onClickWebItem,
        mode: "work"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        mode: "work"
    }));
};

});

parcelRegister("efqda", function(module, exports) {

$parcel$export(module.exports, "default", () => $324183c5f56f46d8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kJpBP = parcelRequire("kJpBP");

var $1ADgn = parcelRequire("1ADgn");

var $koVbs = parcelRequire("koVbs");

var $khMyE = parcelRequire("khMyE");
const $324183c5f56f46d8$var$CreateBoardMenuItem = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClickCreateBoard = ()=>{
        (0, $1ADgn.default)();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": "software-board.header.menu.create-board.button-item",
        onClick: onClickCreateBoard
    }, formatMessage((0, $khMyE.default).displayText));
};
var $324183c5f56f46d8$export$2e2bcd8739ae039 = $324183c5f56f46d8$var$CreateBoardMenuItem;

});
parcelRegister("khMyE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce7cc2adf8eb6675$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ce7cc2adf8eb6675$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    displayText: {
        "id": "software.main.header.menu.create-board.display-text",
        "defaultMessage": "Create board"
    }
});

});


parcelRegister("lLint", function(module, exports) {

$parcel$export(module.exports, "EditSprintMenuItem", () => $0c56def4fd7ae197$export$89ed9bac4a921099);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $koVbs = parcelRequire("koVbs");

var $3aOh4 = parcelRequire("3aOh4");
const $0c56def4fd7ae197$export$89ed9bac4a921099 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        ref: ref,
        onClick: props.onClick
    }, formatMessage((0, $3aOh4.default).displayText));
});

});
parcelRegister("3aOh4", function(module, exports) {

$parcel$export(module.exports, "default", () => $150148a037e296f6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $150148a037e296f6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    displayText: {
        "id": "software.main.header.menu.edit-sprint-item.display-text",
        "defaultMessage": "Edit sprint"
    }
});

});


parcelRegister("7EoeF", function(module, exports) {

$parcel$export(module.exports, "default", () => $339808e1c6584852$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $8QpSo = parcelRequire("8QpSo");

var $bC2fB = parcelRequire("bC2fB");

var $e0GMz = parcelRequire("e0GMz");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $2yCiv = parcelRequire("2yCiv");
const $339808e1c6584852$var$mapStateToProps = (state)=>({
        boardId: Number((0, $67Z81.rapidViewIdSelector)(state)),
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        sprintId: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $ebHh7.activeSprintsSelector)(state), [
            0,
            'id'
        ])
    });
const $339808e1c6584852$export$9e6a17cf56877796 = (dispatch)=>({
        dispatch: dispatch
    });
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $339808e1c6584852$var$noop = ()=>{};
const $339808e1c6584852$var$onSubmitFactory = (0, $8QpSo.default)((dispatch)=>(data, submitPromise)=>{
        const { name: name, goal: goal, startDate: startDate, endDate: endDate, sprintId: sprintId } = data;
        const action = (0, $e0GMz.editSprintRequest)(sprintId, name, goal, startDate, endDate);
        const { meta: { optimistic: { id: optimisticId } } } = action;
        dispatch(action);
        submitPromise.then((response)=>{
            const daysRemaining = response.editSprint?.sprint?.daysRemaining;
            // @ts-expect-error TS2345: Argument of type 'number | null | undefined' is not assignable to parameter of type 'number'.
            dispatch((0, $e0GMz.editSprintSuccess)(optimisticId, sprintId, daysRemaining));
        }).catch(()=>{
            dispatch((0, $e0GMz.editSprintFailure)(optimisticId));
        });
    });
const $339808e1c6584852$export$9d1611c77c2fe928 = (stateProps, dispatchProps, ownProps)=>{
    const { dispatch: dispatch } = dispatchProps;
    return {
        ...stateProps,
        ...ownProps,
        onClose: $339808e1c6584852$var$noop,
        onSubmit: $339808e1c6584852$var$onSubmitFactory(dispatch)
    };
};
var $339808e1c6584852$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($339808e1c6584852$var$mapStateToProps, $339808e1c6584852$export$9e6a17cf56877796, $339808e1c6584852$export$9d1611c77c2fe928)((0, $2yCiv.EditSprintModalEntryPoint));

});
parcelRegister("2yCiv", function(module, exports) {

$parcel$export(module.exports, "EditSprintModalEntryPoint", () => $8c7b4e0d2e3c41f2$export$a12e2c4b0037e424);

var $5uXOq = parcelRequire("5uXOq");

var $ivDCs = parcelRequire("ivDCs");

var $dXq4S = parcelRequire("dXq4S");

var $koeKL = parcelRequire("koeKL");

var $63LqY = parcelRequire("63LqY");
const $8c7b4e0d2e3c41f2$export$a12e2c4b0037e424 = ({ boardId: boardId, onClose: onClose, onSubmit: onSubmit, entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, onReady: onReady })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const isCompanyManaged = (0, $63LqY.useIsCMPBoard)();
    const boardAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: String(boardId)
    });
    const props = (0, $5uXOq.useMemo)(()=>({
            boardAri: boardAri,
            onClose: onClose,
            onSubmit: onSubmit,
            fetchSprints: true,
            isCompanyManaged: isCompanyManaged,
            ...onReady ? {
                onReady: onReady
            } : undefined
        }), [
        boardAri,
        onClose,
        onSubmit,
        onReady,
        isCompanyManaged
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "edit-sprint-modal",
        teamName: "a4t-pandora",
        packageName: "jiraSoftwareEditSprintModalRelay",
        entryPointActions: entryPointActions,
        runtimeProps: props
    });
};

});


parcelRegister("1YHJ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $012fb41392553103$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $eph8m = parcelRequire("eph8m");

var $67Z81 = parcelRequire("67Z81");

var $3ObFy = parcelRequire("3ObFy");
const $012fb41392553103$var$mapStateToProps = (state)=>({
        url: (0, $eph8m.getManageCustomFiltersUrl)((0, $67Z81.projectKeySelector)(state), (0, $67Z81.rapidViewIdSelector)(state))
    });
var $012fb41392553103$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($012fb41392553103$var$mapStateToProps, {})((0, $3ObFy.default));

});
parcelRegister("3ObFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c4176b164ed573$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $koVbs = parcelRequire("koVbs");

var $14uhY = parcelRequire("14uhY");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dIdda = parcelRequire("dIdda");

var $gUhnv = parcelRequire("gUhnv");
const $67c4176b164ed573$export$538689bb697618b7 = ({ url: url })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = (0, $dIdda.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        (0, $14uhY.setReturnToProjectUrl)();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'dropdownItem',
            action: 'clicked'
        }), 'clickBoardManageCustomFilterItem');
        push(url);
    }, [
        push,
        url,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: onClick
    }, formatMessage((0, $gUhnv.default).displayText));
};
var $67c4176b164ed573$export$2e2bcd8739ae039 = $67c4176b164ed573$export$538689bb697618b7;

});
parcelRegister("gUhnv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac51b0d7e8a8b529$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ac51b0d7e8a8b529$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    displayText: {
        "id": "software.main.header.menu.manage-custom-filters-item.display-text",
        "defaultMessage": "Manage custom filters"
    }
});

});



parcelRegister("gqdF8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7410cc88dcfd0526$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7410cc88dcfd0526$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    buttonLabel: {
        "id": "software.main.header.menu.button-label",
        "defaultMessage": "More"
    },
    dropdownAriaLabel: {
        "id": "software.main.header.menu.dropdown-aria-label",
        "defaultMessage": "Board"
    },
    iconButtonLabel: {
        "id": "software.main.header.menu.icon-button-label",
        "defaultMessage": "Board menu"
    },
    enterFullScreen: {
        "id": "software.main.header.menu.enter-full-screen",
        "defaultMessage": "Enter full screen"
    },
    exitFullScreen: {
        "id": "software.main.header.menu.exit-full-screen",
        "defaultMessage": "Exit full screen"
    }
});

});

const $fd53e5cce0793701$export$1222b4ae9a94b9ec = 'jsm-boards-meatball-menu-changeboarding-spotlight';
const $fd53e5cce0793701$export$3c389bd4d38f57a0 = 'jsm-boards-meatball-menu-changeboarding-spotlight-target';

parcelRegister("6tHP5", function(module, exports) {

$parcel$export(module.exports, "OnboardingSpotlight", () => $cf094973e27d03c7$export$ddd62bccdbe21d75);

var $5uXOq = parcelRequire("5uXOq");

var $1QiBP = parcelRequire("1QiBP");


var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ehdJY = parcelRequire("ehdJY");

var $fvbCc = parcelRequire("fvbCc");


var $8TMRq = parcelRequire("8TMRq");
const $cf094973e27d03c7$export$ddd62bccdbe21d75 = ({ onAcknowledge: onAcknowledge })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "boardAdminOnboardingConfigSpotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: [
            {
                text: formatMessage((0, $8TMRq.default).ok),
                onClick: ()=>{
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'boardAdminOnboardingConfigSpotlightOk');
                    onAcknowledge();
                }
            }
        ],
        dialogPlacement: "bottom right",
        dialogWidth: 275,
        targetRadius: 3,
        target: (0, $fd53e5cce0793701$export$3c389bd4d38f57a0),
        key: (0, $fd53e5cce0793701$export$1222b4ae9a94b9ec),
        heading: formatMessage((0, $8TMRq.default).heading),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($fvbCc))),
        targetBgColor: `var(--ds-surface-raised, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        messageId: "software-board.header.menu.onboarding-spotlight.jira-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $8TMRq.default).description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};

});
parcelRegister("fvbCc", function(module, exports) {
module.exports = new URL("JSM-board-illustration.b7063fec.png", import.meta.url).toString();

});

parcelRegister("8TMRq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b293aaa02e3fedca$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $b293aaa02e3fedca$var$messages = (0, $7VHMR.defineMessages)({
    ok: {
        "id": "software.main.header.menu.onboarding-spotlight.ok",
        "defaultMessage": "OK"
    },
    heading: {
        "id": "software.main.header.menu.onboarding-spotlight.heading",
        "defaultMessage": "Customize your board"
    },
    description: {
        "id": "software.main.header.menu.onboarding-spotlight.description",
        "defaultMessage": "Add, rename, or remove columns on this board to match your team's preferred process. Create Quick filters or enable swimlanes."
    }
});
var $b293aaa02e3fedca$export$2e2bcd8739ae039 = $b293aaa02e3fedca$var$messages;

});


parcelRegister("c1wgv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0adf111359e2d498$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $dZbEw = parcelRequire("dZbEw");

var $7ymNM = parcelRequire("7ymNM");

var $ebd3R = parcelRequire("ebd3R");

var $3dGN0 = parcelRequire("3dGN0");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $7mPT9 = parcelRequire("7mPT9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lu5k0 = parcelRequire("lu5k0");


var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");

var $afSe5 = parcelRequire("afSe5");

var $ecPxM = parcelRequire("ecPxM");

var $49Sni = parcelRequire("49Sni");

var $25859 = parcelRequire("25859");
const $0adf111359e2d498$var$DROPDOWN_MENU_ITEM_TEST_ID = 'software-board.header.release-version.menu-item';
const $0adf111359e2d498$var$ReleaseVersion = ({ rapidViewId: rapidViewId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5uXOq.useState)(false);
    const [isNewVersionModalOpen, setIsNewVersionModalOpen] = (0, $5uXOq.useState)(false);
    const closeNewVersionReleaseModal = (0, $5uXOq.useCallback)(()=>setIsNewVersionModalOpen(false), [
        setIsNewVersionModalOpen
    ]);
    const isMultiProjectBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.hasMultipleProjects));
    const releaseButtonRef = (0, $5uXOq.useRef)(null);
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const [selectedVersion, setSelectedVersion] = (0, $5uXOq.useState)(null);
    const closeReleaseModal = ()=>setSelectedVersion(null);
    const { releaseState: releaseState, versionMenuItems: versionMenuItems, hasIssuesWithoutVersion: hasIssuesWithoutVersion, lastColumnName: lastColumnName } = (0, $67sX6.useBoardSelector)((0, $afSe5.getFilteredVersionsSelector));
    const dropdownMenuTrigger = (0, $5uXOq.useCallback)(({ triggerRef: triggerRef, ...triggerProps })=>{
        const isDisabled = releaseState === (0, $52aa71c793d1ece4$export$6d221b2e277927d7);
        setReturnFocusTo(releaseButtonRef);
        const tooltipContent = !isDropdownOpen && releaseState === (0, $52aa71c793d1ece4$export$e927a5d1b72f0b68) ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $25859.default).tooltipReleaseIssueTermRefresh : (0, $25859.default).tooltipRelease, {
            columnName: lastColumnName
        }) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: isDisabled ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $25859.default).tooltipDisabledIssueTermRefresh : (0, $25859.default).tooltipDisabled) : tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            ...triggerProps,
            "aria-label": formatMessage((0, $25859.default).title),
            ref: (0, $7mPT9.mergeRefs)(triggerRef, releaseButtonRef),
            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R))),
                LEGACY_size: "medium",
                label: "",
                color: "var(--ds-icon, #44546F)"
            }),
            isDisabled: isDisabled,
            testId: "software-board.header.menu.release-version.trigger"
        }, formatMessage((0, $25859.default).title)));
    }, [
        formatMessage,
        isDropdownOpen,
        lastColumnName,
        releaseState,
        setReturnFocusTo
    ]);
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
        if (attrs.isOpen) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'board.release.dropdown-open',
            action: 'button clicked'
        }));
        setIsDropdownOpen(attrs.isOpen);
    }, [
        createAnalyticsEvent
    ]);
    const handleNewVersionClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'board.release.create-new-version',
            action: 'menu item clicked'
        }));
        setIsNewVersionModalOpen(true);
        setIsDropdownOpen(false);
    }, [
        setIsDropdownOpen,
        setIsNewVersionModalOpen,
        createAnalyticsEvent
    ]);
    const versionMenuItemElems = (0, $5uXOq.useMemo)(()=>versionMenuItems.map((versionItem)=>{
            const handleClick = ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    actionSubject: 'board.release.version',
                    action: 'menu item clicked'
                }));
                setSelectedVersion(versionItem);
                setIsDropdownOpen(false);
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
                key: `${versionItem.id} ${versionItem.projectKey}`,
                onClick: handleClick,
                testId: $0adf111359e2d498$var$DROPDOWN_MENU_ITEM_TEST_ID
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: versionItem.name
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $0adf111359e2d498$var$versionMenuItemContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $0adf111359e2d498$var$versionNameContainer
            }, versionItem.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                color: "color.text.subtlest"
            }, isMultiProjectBoard && versionItem.projectKey))));
        }), [
        createAnalyticsEvent,
        isMultiProjectBoard,
        versionMenuItems
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, selectedVersion != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $49Sni.ReleaseVersionModal), {
        setModalClosed: closeReleaseModal,
        versionId: selectedVersion.id,
        versionName: selectedVersion.name,
        projectKey: selectedVersion.projectKey
    }), isNewVersionModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ecPxM.NewVersionReleaseModal), {
        boardId: rapidViewId,
        setModalClosed: closeNewVersionReleaseModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        placement: "left",
        isOpen: isDropdownOpen,
        onOpenChange: onDropdownOpenChange,
        trigger: dropdownMenuTrigger,
        shouldRenderToParent: true
    }, versionMenuItemElems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        testId: "software-board.header.menu.release-version.menu-group",
        title: formatMessage((0, $25859.default).version)
    }, versionMenuItemElems) : null, releaseState === (0, $52aa71c793d1ece4$export$119cd2a68105fcb3) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        isDisabled: true,
        testId: $0adf111359e2d498$var$DROPDOWN_MENU_ITEM_TEST_ID
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $25859.default).nothingToReleaseIssueTermRefresh : (0, $25859.default).nothingToRelease, {
        columnName: lastColumnName
    })) : null, hasIssuesWithoutVersion && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        hasSeparator: versionMenuItems.length > 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7ymNM))),
            LEGACY_size: "small",
            label: "",
            color: "var(--ds-icon, #44546F)"
        }),
        onClick: handleNewVersionClick,
        testId: $0adf111359e2d498$var$DROPDOWN_MENU_ITEM_TEST_ID
    }, formatMessage((0, $25859.default).menuItemCreateVersion)))));
};
var $0adf111359e2d498$export$2e2bcd8739ae039 = $0adf111359e2d498$var$ReleaseVersion;
const $0adf111359e2d498$var$versionMenuItemContainer = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    overflow: 'hidden',
    justifyContent: 'space-between',
    width: '100%'
});
const $0adf111359e2d498$var$versionNameContainer = (0, $8CUq3.xcss)({
    flexGrow: 1,
    marginRight: 'space.100',
    textOverflow: 'ellipsis',
    overflowX: 'hidden',
    whiteSpace: 'nowrap',
    width: '200px'
});

});
const $52aa71c793d1ece4$export$e927a5d1b72f0b68 = 'ENABLED';
const $52aa71c793d1ece4$export$6d221b2e277927d7 = 'NO_PERMISSION';
const $52aa71c793d1ece4$export$119cd2a68105fcb3 = 'NO_AVAILABLE_ISSUE_OR_VERSION';

parcelRegister("afSe5", function(module, exports) {

$parcel$export(module.exports, "getFilteredVersionsSelector", () => $f2c89b4fc8c3d1f0$export$f090f051a8da1de0);

var $dGvGJ = parcelRequire("dGvGJ");

var $gccSB = parcelRequire("gccSB");



var $1vXOx = parcelRequire("1vXOx");

var $fyeGd = parcelRequire("fyeGd");

var $vAfHD = parcelRequire("vAfHD");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");
const $f2c89b4fc8c3d1f0$export$db548bb45f42db43 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssueProjects),
    (0, $67Z81.getVersionData)
], (projects, versionData)=>{
    const { versionsPerProject: versionsPerProject } = versionData;
    const versionMenuItemEntities = {};
    Object.keys(versionsPerProject).flatMap((id)=>versionsPerProject[id].filter((version)=>version.released === false).forEach((activeVersion)=>{
            versionMenuItemEntities[activeVersion.id] = {
                id: activeVersion.id.toString(),
                name: activeVersion.name,
                projectKey: projects[id]?.key
            };
        }));
    return versionMenuItemEntities;
});
const $f2c89b4fc8c3d1f0$export$f090f051a8da1de0 = (0, $dGvGJ.createSelector)([
    $f2c89b4fc8c3d1f0$export$db548bb45f42db43,
    (0, $67Z81.getOrderedColumnIds),
    (0, $fyeGd.getColumns),
    (0, $5mTgl.getFilteredIssueIdsByColumn),
    (0, $vAfHD.boardIssuesSelector),
    (0, $1vXOx.getPermissionsSelector)
], (activeVersions, orderedColumnIds, allColumns, filteredIssueIdsByColumn, allIssues, boardPermissions)=>{
    // always release issues in the right most column
    const lastColumnId = orderedColumnIds[orderedColumnIds.length - 1];
    const lastColumnName = allColumns[lastColumnId]?.name;
    const canRelease = boardPermissions[0, $e525e6c25695c9df$export$172db259b98bcef1];
    if (!canRelease) return {
        releaseState: (0, $52aa71c793d1ece4$export$6d221b2e277927d7),
        versionMenuItems: [],
        hasIssuesWithoutVersion: false,
        lastColumnName: lastColumnName
    };
    const filteredIssueIds = filteredIssueIdsByColumn[lastColumnId];
    if (!filteredIssueIds || filteredIssueIds.length === 0 || !lastColumnId) return {
        releaseState: (0, $52aa71c793d1ece4$export$119cd2a68105fcb3),
        versionMenuItems: [],
        hasIssuesWithoutVersion: false,
        lastColumnName: lastColumnName
    };
    const hasIssuesWithoutVersion = filteredIssueIds.some((issueId)=>!allIssues[issueId]?.fixVersions?.length);
    const versionMenuItems = (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(activeVersions) ? new Set() : new Set(filteredIssueIds.flatMap((issueId)=>allIssues[issueId]?.fixVersions ?? []).map((versionId)=>activeVersions[versionId]).filter((version)=>version != null));
    return {
        releaseState: (0, $52aa71c793d1ece4$export$e927a5d1b72f0b68),
        versionMenuItems: [
            ...versionMenuItems
        ],
        hasIssuesWithoutVersion: hasIssuesWithoutVersion,
        lastColumnName: lastColumnName
    };
});

});

parcelRegister("ecPxM", function(module, exports) {

$parcel$export(module.exports, "NewVersionReleaseModal", () => $1fc039fa710414a6$export$7062404577e2a78d);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $k8Na9 = parcelRequire("k8Na9");


var $67sX6 = parcelRequire("67sX6");

var $cW3pH = parcelRequire("cW3pH");

var $67Z81 = parcelRequire("67Z81");

var $9TBWv = parcelRequire("9TBWv");
const $1fc039fa710414a6$export$7062404577e2a78d = ({ setModalClosed: setModalClosed, boardId: boardId })=>{
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const orderedColumnIds = (0, $67sX6.useBoardSelector)((0, $67Z81.getOrderedColumnIds));
    const lastColumnId = orderedColumnIds[orderedColumnIds.length - 1];
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [serverErrorsInState, setServerErrors] = (0, $5uXOq.useState)(undefined);
    const onNewVersionReleased = (0, $5uXOq.useCallback)((versionName)=>{
        dispatch((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$3b24bb12b5615667)));
        setModalClosed();
        showFlag({
            type: 'success',
            title: formatMessage((0, $9TBWv.default).releaseSuccessFlagTitle, {
                versionName: versionName
            }),
            isAutoDismiss: true
        });
    }, [
        dispatch,
        formatMessage,
        setModalClosed,
        showFlag
    ]);
    const onNewVersionReleaseError = (0, $5uXOq.useCallback)(async (serverErrors)=>{
        setServerErrors(serverErrors);
        if (!serverErrors?.name) {
            showFlag({
                type: 'error',
                title: formatMessage((0, $9TBWv.default).releaseFailedFlagTitle),
                description: serverErrors?.genericMessage ?? formatMessage((0, $9TBWv.default).releaseFailedFlagDescription),
                isAutoDismiss: true
            });
            // generally when this is the case, we created a version
            // but failed to release it/assign issues vissues to it
            setModalClosed();
        }
    }, [
        formatMessage,
        setModalClosed,
        setServerErrors,
        showFlag
    ]);
    const onFetchModalError = (0, $5uXOq.useCallback)(()=>{
        setModalClosed();
        showFlag({
            type: 'error',
            title: formatMessage((0, $9TBWv.default).releaseFailedFlagTitle),
            description: formatMessage((0, $9TBWv.default).releaseFailedFlagDescription),
            isAutoDismiss: true
        });
    }, [
        formatMessage,
        setModalClosed,
        showFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k8Na9.default), {
        boardId: boardId,
        columnId: lastColumnId.toString(),
        onCancel: setModalClosed,
        onSuccess: onNewVersionReleased,
        onError: onNewVersionReleaseError,
        onFetchModalError: onFetchModalError,
        serverErrors: serverErrorsInState
    });
};

});
parcelRegister("k8Na9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d41083831eec823$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6d41083831eec823$var$LazyNewVersionReleaseModal = (0, $kxZPA.lazy)(()=>(parcelRequire("6FoCk")).then((NewVersionReleaseModal)=>NewVersionReleaseModal), {
    moduleId: "./src/packages/software/new-version-release-modal/src/ui/index.tsx"
});
const $6d41083831eec823$var$NewVersionReleaseModalAsync = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "async-jira-software-new-version-release-modal",
        packageName: "jiraSoftwareNewVersionReleaseModal",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-new-version-release-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6d41083831eec823$var$LazyNewVersionReleaseModal, props)));
var $6d41083831eec823$export$2e2bcd8739ae039 = $6d41083831eec823$var$NewVersionReleaseModalAsync;

});
parcelRegister("6FoCk", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("8urde").then(()=>parcelRequire('5UanI'));

});


parcelRegister("9TBWv", function(module, exports) {

$parcel$export(module.exports, "default", () => $818e7676c2a8968e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $818e7676c2a8968e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dropdownAriaLabel: {
        "id": "software.main.header.release-version.dropdown-aria-label",
        "defaultMessage": "Release"
    },
    title: {
        "id": "software.main.header.release-version.title",
        "defaultMessage": "Release"
    },
    version: {
        "id": "software.main.header.release-version.version",
        "defaultMessage": "Version"
    },
    tooltipRelease: {
        "id": "software.main.header.release-version.tooltip-release",
        "defaultMessage": "Release a version with issues in the {columnName} column"
    },
    tooltipDisabled: {
        "id": "software.main.header.release-version.tooltip-disabled",
        "defaultMessage": "There are no issues to be released"
    },
    nothingToRelease: {
        "id": "software.main.header.release-version.nothing-to-release",
        "defaultMessage": "To release a version, move issues to the {columnName} column"
    },
    menuItemCreateVersion: {
        "id": "software.main.header.release-version.menu-item-create-version",
        "defaultMessage": "Create version"
    },
    releaseSuccessFlagTitle: {
        "id": "software.main.header.release-version.release-success-flag-title",
        "defaultMessage": "{versionName} released"
    },
    releaseFailedFlagTitle: {
        "id": "software.main.header.release-version.release-failed-flag-title",
        "defaultMessage": "Something went wrong"
    },
    releaseFailedFlagDescription: {
        "id": "software.main.header.release-version.release-failed-flag-description",
        "defaultMessage": "We weren\u2019t able to complete this release. Please refresh the page and try again."
    },
    tooltipReleaseIssueTermRefresh: {
        "id": "software.main.header.release-version.tooltip-release-issue-term-refresh",
        "defaultMessage": "Release a version with issues in the {columnName} column"
    },
    tooltipDisabledIssueTermRefresh: {
        "id": "software.main.header.release-version.tooltip-disabled-issue-term-refresh",
        "defaultMessage": "There are no issues to be released"
    },
    nothingToReleaseIssueTermRefresh: {
        "id": "software.main.header.release-version.nothing-to-release-issue-term-refresh",
        "defaultMessage": "To release a version, move issues to the {columnName} column"
    }
});

});


parcelRegister("49Sni", function(module, exports) {

$parcel$export(module.exports, "ReleaseVersionModal", () => $2b5ce79e2dfa47bd$export$92e7033ce50ddfd8);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $i8Qvm = parcelRequire("i8Qvm");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $30y8c = parcelRequire("30y8c");


var $67sX6 = parcelRequire("67sX6");

var $cW3pH = parcelRequire("cW3pH");

var $9TBWv = parcelRequire("9TBWv");
const $2b5ce79e2dfa47bd$export$92e7033ce50ddfd8 = ({ setModalClosed: setModalClosed, versionId: versionId, versionName: versionName, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const handleError = ()=>{
        showFlag({
            type: 'error',
            title: (0, $9TBWv.default).releaseFailedFlagTitle,
            description: (0, $9TBWv.default).releaseFailedFlagDescription,
            isAutoDismiss: true
        });
        setModalClosed();
    };
    const handleSuccess = ()=>{
        showFlag({
            type: 'success',
            title: formatMessage((0, $9TBWv.default).releaseSuccessFlagTitle, {
                versionName: versionName
            }),
            isAutoDismiss: true
        });
        dispatch((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$3b24bb12b5615667)));
        setModalClosed();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $30y8c.default), {
        // eslint-disable-next-line jira/deprecations/no-base-url
        baseUrl: "",
        projectKey: projectKey,
        versionId: versionId,
        onOpened: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onCancel: setModalClosed,
        onSuccess: handleSuccess,
        onError: handleError
    }));
};

});
parcelRegister("30y8c", function(module, exports) {

$parcel$export(module.exports, "default", () => $2147be28d3fbd035$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $kxZPA = parcelRequire("kxZPA");
var $7hSN4 = parcelRequire("7hSN4");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2147be28d3fbd035$var$ReleaseVersionModal = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("iHaMV")), {
    ssr: false,
    moduleId: "./src/packages/releases/versions/src/release-version-modal/index.tsx"
});
const $2147be28d3fbd035$var$AsyncReleaseVersionModal = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "async-jira-version-modals-release-version-modal",
        packageName: (0, $71a059cf91522abc$export$595d93fed3fb6b04),
        teamName: "fusion-solaris",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7hSN4.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2147be28d3fbd035$var$ReleaseVersionModal, props)));
var $2147be28d3fbd035$export$2e2bcd8739ae039 = $2147be28d3fbd035$var$AsyncReleaseVersionModal;

});
const $71a059cf91522abc$export$595d93fed3fb6b04 = 'jiraReleasesVersions';
const $71a059cf91522abc$export$6c87c1302bf5163c = 'directories.versions.error';

parcelRegister("iHaMV", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("9bhB7").then(()=>parcelRequire('lqWUw'));

});



parcelRegister("25859", function(module, exports) {

$parcel$export(module.exports, "default", () => $114f3d309367bf67$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $114f3d309367bf67$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software.main.header.menu.release-version.title",
        "defaultMessage": "Release"
    },
    version: {
        "id": "software.main.header.menu.release-version.version",
        "defaultMessage": "Version"
    },
    tooltipRelease: {
        "id": "software.main.header.menu.release-version.tooltip-release",
        "defaultMessage": "Release a version with issues in the {columnName} column"
    },
    tooltipDisabled: {
        "id": "software.main.header.menu.release-version.tooltip-disabled",
        "defaultMessage": "There are no issues to be released"
    },
    nothingToRelease: {
        "id": "software.main.header.menu.release-version.nothing-to-release",
        "defaultMessage": "To release a version, move issues to the {columnName} column"
    },
    menuItemCreateVersion: {
        "id": "software.main.header.menu.release-version.menu-item-create-version",
        "defaultMessage": "Create version"
    },
    releaseSuccessFlagTitle: {
        "id": "software.main.header.menu.release-version.release-success-flag-title",
        "defaultMessage": "{versionName} released"
    },
    releaseFailedFlagTitle: {
        "id": "software.main.header.menu.release-version.release-failed-flag-title",
        "defaultMessage": "Something went wrong"
    },
    releaseFailedFlagDescription: {
        "id": "software.main.header.menu.release-version.release-failed-flag-description",
        "defaultMessage": "We weren\u2019t able to complete this release. Please refresh the page and try again."
    },
    tooltipReleaseIssueTermRefresh: {
        "id": "software.main.header.menu.release-version.tooltip-release-issue-term-refresh",
        "defaultMessage": "Release a version with issues in the {columnName} column"
    },
    tooltipDisabledIssueTermRefresh: {
        "id": "software.main.header.menu.release-version.tooltip-disabled-issue-term-refresh",
        "defaultMessage": "There are no issues to be released"
    },
    nothingToReleaseIssueTermRefresh: {
        "id": "software.main.header.menu.release-version.nothing-to-release-issue-term-refresh",
        "defaultMessage": "To release a version, move issues to the {columnName} column"
    }
});

});




parcelRegister("7hxB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $83bc29dac12334ad$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $dZbEw = parcelRequire("dZbEw");

var $7ymNM = parcelRequire("7ymNM");

var $6Ingq = parcelRequire("6Ingq");

var $hORKG = parcelRequire("hORKG");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $7mPT9 = parcelRequire("7mPT9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lu5k0 = parcelRequire("lu5k0");


var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");

var $afSe5 = parcelRequire("afSe5");

var $ecPxM = parcelRequire("ecPxM");

var $49Sni = parcelRequire("49Sni");

var $9TBWv = parcelRequire("9TBWv");
const $83bc29dac12334ad$var$DROPDOWN_MENU_ITEM_TEST_ID = 'software-board.header.release-version.menu-item';
const $83bc29dac12334ad$var$ReleaseVersion = ({ rapidViewId: rapidViewId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5uXOq.useState)(false);
    const [isNewVersionModalOpen, setIsNewVersionModalOpen] = (0, $5uXOq.useState)(false);
    const closeNewVersionReleaseModal = (0, $5uXOq.useCallback)(()=>setIsNewVersionModalOpen(false), [
        setIsNewVersionModalOpen
    ]);
    const isMultiProjectBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.hasMultipleProjects));
    const releaseButtonRef = (0, $5uXOq.useRef)(null);
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const [selectedVersion, setSelectedVersion] = (0, $5uXOq.useState)(null);
    const closeReleaseModal = ()=>setSelectedVersion(null);
    const { releaseState: releaseState, versionMenuItems: versionMenuItems, hasIssuesWithoutVersion: hasIssuesWithoutVersion, lastColumnName: lastColumnName } = (0, $67sX6.useBoardSelector)((0, $afSe5.getFilteredVersionsSelector));
    const dropdownMenuTrigger = (0, $5uXOq.useCallback)(({ triggerRef: triggerRef, ...triggerProps })=>{
        const isDisabled = releaseState === (0, $52aa71c793d1ece4$export$6d221b2e277927d7);
        setReturnFocusTo(releaseButtonRef);
        const tooltipContent = !isDropdownOpen && releaseState === (0, $52aa71c793d1ece4$export$e927a5d1b72f0b68) ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9TBWv.default).tooltipReleaseIssueTermRefresh : (0, $9TBWv.default).tooltipRelease, {
            columnName: lastColumnName
        }) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: isDisabled ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9TBWv.default).tooltipDisabledIssueTermRefresh : (0, $9TBWv.default).tooltipDisabled) : tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...triggerProps,
            "aria-label": formatMessage((0, $9TBWv.default).dropdownAriaLabel),
            ref: (0, $7mPT9.mergeRefs)(triggerRef, releaseButtonRef),
            iconAfter: (0, $4R6GH.fg)('tnk-1613-jira-visual-refresh-jsw-board-icons-2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
                label: "",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))),
                LEGACY_size: "medium",
                color: "var(--ds-icon, #44546F)"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))), {
                size: "medium",
                label: ""
            }),
            isDisabled: isDisabled,
            testId: "software-board.header.release-version.trigger"
        }, formatMessage((0, $9TBWv.default).title)));
    }, [
        formatMessage,
        isDropdownOpen,
        lastColumnName,
        releaseState,
        setReturnFocusTo
    ]);
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
        if (attrs.isOpen) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'board.release.dropdown-open',
            action: 'button clicked'
        }));
        setIsDropdownOpen(attrs.isOpen);
    }, [
        createAnalyticsEvent
    ]);
    const handleNewVersionClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'board.release.create-new-version',
            action: 'menu item clicked'
        }));
        setIsNewVersionModalOpen(true);
        setIsDropdownOpen(false);
    }, [
        setIsDropdownOpen,
        setIsNewVersionModalOpen,
        createAnalyticsEvent
    ]);
    const versionMenuItemElems = (0, $5uXOq.useMemo)(()=>versionMenuItems.map((versionItem)=>{
            const handleClick = ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    actionSubject: 'board.release.version',
                    action: 'menu item clicked'
                }));
                setSelectedVersion(versionItem);
                setIsDropdownOpen(false);
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
                key: `${versionItem.id} ${versionItem.projectKey}`,
                onClick: handleClick,
                testId: $83bc29dac12334ad$var$DROPDOWN_MENU_ITEM_TEST_ID
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: versionItem.name
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($83bc29dac12334ad$var$VersionMenuItemContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($83bc29dac12334ad$var$VersionNameContainer, null, versionItem.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($83bc29dac12334ad$var$ProjectKeyContainer, null, isMultiProjectBoard && versionItem.projectKey))));
        }), [
        createAnalyticsEvent,
        isMultiProjectBoard,
        versionMenuItems
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, selectedVersion != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $49Sni.ReleaseVersionModal), {
        setModalClosed: closeReleaseModal,
        versionId: selectedVersion.id,
        versionName: selectedVersion.name,
        projectKey: selectedVersion.projectKey
    }), isNewVersionModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ecPxM.NewVersionReleaseModal), {
        boardId: rapidViewId,
        setModalClosed: closeNewVersionReleaseModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        placement: "bottom-end",
        isOpen: isDropdownOpen,
        onOpenChange: onDropdownOpenChange,
        trigger: dropdownMenuTrigger,
        shouldRenderToParent: true
    }, versionMenuItemElems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        testId: "software-board.header.release-version.menu-group",
        title: formatMessage((0, $9TBWv.default).version)
    }, versionMenuItemElems) : null, releaseState === (0, $52aa71c793d1ece4$export$119cd2a68105fcb3) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        isDisabled: true,
        testId: $83bc29dac12334ad$var$DROPDOWN_MENU_ITEM_TEST_ID
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9TBWv.default).nothingToReleaseIssueTermRefresh : (0, $9TBWv.default).nothingToRelease, {
        columnName: lastColumnName
    })) : null, hasIssuesWithoutVersion && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        hasSeparator: versionMenuItems.length > 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        elemBefore: (0, $4R6GH.fg)('tnk-1613-jira-visual-refresh-jsw-board-icons-2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7ymNM))),
            LEGACY_size: "small",
            color: "var(--ds-icon, #44546F)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ymNM))), {
            size: "small",
            label: ""
        }),
        onClick: handleNewVersionClick,
        testId: $83bc29dac12334ad$var$DROPDOWN_MENU_ITEM_TEST_ID
    }, formatMessage((0, $9TBWv.default).menuItemCreateVersion)))));
};
var $83bc29dac12334ad$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $83bc29dac12334ad$var$ReleaseVersion;
const $83bc29dac12334ad$var$VersionMenuItemContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _1reo15vq _18m915vq _1bah1yb4 _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $83bc29dac12334ad$var$VersionNameContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _2hwxu2gc _1bto1l2s _1reo15vq _o5721q9c _1bsbuuw1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $83bc29dac12334ad$var$ProjectKeyContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1wmz",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7lFcC", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb6348c67d3dccec$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $3t2Tt = parcelRequire("3t2Tt");
var $eb6348c67d3dccec$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state)=>{
    const { remainingDays: remainingDays, startDate: startDate, endDate: endDate } = (0, $ebHh7.remainingDaysSelector)(state);
    const locale = (0, $67Z81.getLocale)(state);
    return {
        remainingDays: remainingDays,
        startDate: startDate,
        endDate: endDate,
        locale: locale
    };
}, {})((0, $3t2Tt.default));

});
parcelRegister("3t2Tt", function(module, exports) {

$parcel$export(module.exports, "default", () => $9462eb0268ad061f$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $1dJ6S = parcelRequire("1dJ6S");

var $hyKRO = parcelRequire("hyKRO");

var $6uqJA = parcelRequire("6uqJA");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $3RZIb = parcelRequire("3RZIb");

var $3bDjY = parcelRequire("3bDjY");

var $lzeFL = parcelRequire("lzeFL");

var $gSExi = parcelRequire("gSExi");

var $heNNl = parcelRequire("heNNl");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $aWse0 = parcelRequire("aWse0");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $2xFXk = parcelRequire("2xFXk");

var $63LqY = parcelRequire("63LqY");

var $cRGYm = parcelRequire("cRGYm");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9462eb0268ad061f$var$AsyncTooltipContent = (0, $kxZPA.lazy)(()=>(parcelRequire("kvpFy")), {
    moduleId: "./src/packages/software/board/src/view/header/sprint-remaining-days/tooltip-content/index.tsx"
});
const $9462eb0268ad061f$var$RemainingDays = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9462eb0268ad061f$var$SprintRemainingDaysStyled, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9462eb0268ad061f$var$RecentIconWrapper, null, (0, $4R6GH.fg)('tnk-1613-jira-visual-refresh-jsw-board-icons-2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))), {
        label: label,
        spacing: "spacious",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6uqJA))),
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uqJA))), {
        label: label
    })), label);
const $9462eb0268ad061f$var$RemainingDaysNoIcon = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9462eb0268ad061f$var$SprintRemainingDaysStyled, null, label);
const $9462eb0268ad061f$export$76ca2692cceeb7eb = (props)=>{
    const intl = (0, $aWse0.useIntlV2)();
    const { remainingDays: remainingDays, startDate: startDate, endDate: endDate, locale: locale = (0, $lzeFL.defaultLocale) } = props;
    const isTabNavigation = (0, $63LqY.useCapability)((0, $2xFXk.Capability).IS_TAB_NAVIGATION);
    const contentHeader = intl.formatMessage((0, $cRGYm.default).remainingDays, {
        remainingDays: remainingDays
    });
    const label = !isTabNavigation ? intl.formatMessage((0, $cRGYm.default).remainingDaysLabel, {
        remainingDays: remainingDays
    }) : contentHeader;
    if (remainingDays === null) return null;
    if (startDate === null || endDate === null || locale === null) return isTabNavigation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9462eb0268ad061f$var$RemainingDaysNoIcon, {
        label: label
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9462eb0268ad061f$var$RemainingDays, {
        label: label
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
            id: "async.software-board.sprint-remaining-days",
            packageName: "software-board"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "software-board-sprint-remaining-tooltip",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                size: "small"
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9462eb0268ad061f$var$AsyncTooltipContent, {
            contentHeader: contentHeader,
            startDate: startDate,
            locale: locale,
            endDate: endDate
        })))
    }, isTabNavigation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9462eb0268ad061f$var$RemainingDaysNoIcon, {
        label: label
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9462eb0268ad061f$var$RemainingDays, {
        label: label
    }));
};
var $9462eb0268ad061f$export$2e2bcd8739ae039 = $9462eb0268ad061f$export$76ca2692cceeb7eb;
const $9462eb0268ad061f$var$SprintRemainingDaysStyledWrapper = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "div",
        xcss: $9462eb0268ad061f$var$sprintRemainingDaysWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1dJ6S.default), {
        size: "xxsmall",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9462eb0268ad061f$var$SprintRemainingDaysStyledExperiment, props)));
const $9462eb0268ad061f$var$sprintRemainingDaysWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.0',
    marginRight: 'space.100',
    marginLeft: 'space.050'
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9462eb0268ad061f$var$SprintRemainingDaysStyledControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "qyp7iu-0"
})`${(0, $3RZIb).h200()};display:flex;align-items:center;font-weight:normal;margin-top:0;font-size:12px;margin-right:${"var(--ds-space-100, 8px)"};margin-left:${"var(--ds-space-050, 4px)"};`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9462eb0268ad061f$var$SprintRemainingDaysStyledExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _11c8qk37",
            __cmplp.className
        ])
    });
});
const $9462eb0268ad061f$var$SprintRemainingDaysStyled = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $9462eb0268ad061f$var$SprintRemainingDaysStyledWrapper, $9462eb0268ad061f$var$SprintRemainingDaysStyledControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9462eb0268ad061f$var$RecentIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syazhwed _1e0c1txw _4cvr1h6o _u5f31b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6uqJA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b9a484973717fe2$var$_react = $4b9a484973717fe2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4b9a484973717fe2$var$_clock = $4b9a484973717fe2$var$_interopRequireDefault((parcelRequire("hyKRO")));
function $4b9a484973717fe2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4b9a484973717fe2$var$EmojiFrequentIcon = (props)=>/*#__PURE__*/ $4b9a484973717fe2$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222m.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.89.89 0 0 0 1.257 0 .89.89 0 0 0 0-1.256z"/></svg>`
    }, props, {
        newIcon: $4b9a484973717fe2$var$_clock.default
    }));
$4b9a484973717fe2$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
var $4b9a484973717fe2$var$_default = module.exports.default = $4b9a484973717fe2$var$EmojiFrequentIcon;

});

parcelRegister("cRGYm", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd993171ad6a1ae$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cbd993171ad6a1ae$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    remainingDaysLabel: {
        "id": "software.main.header.sprint-remaining-days.remaining-days-label",
        "defaultMessage": "{remainingDays} {remainingDays, plural, one {day} other {days}}"
    },
    remainingDays: {
        "id": "software.main.header.sprint-remaining-days.remaining-days",
        "defaultMessage": "{remainingDays} {remainingDays, plural, one {day} other {days}} remaining"
    },
    startDate: {
        "id": "software.main.header.sprint-remaining-days.start-date",
        "defaultMessage": "Start date:"
    },
    endDate: {
        "id": "software.main.header.sprint-remaining-days.end-date",
        "defaultMessage": "Projected end date:"
    },
    invalidDate: {
        "id": "software.main.header.sprint-remaining-days.invalid-date",
        "defaultMessage": "Invalid date"
    }
});

});

parcelRegister("kvpFy", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("4gb42").then(()=>parcelRequire('hcmRy'));

});



parcelRegister("j3072", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b43f922e98e2b49$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $7buQq = parcelRequire("7buQq");

var $6Pv6s = parcelRequire("6Pv6s");

var $e4D5B = parcelRequire("e4D5B");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6b43f922e98e2b49$var$mapStateToProps = (state)=>({
        canEdit: (0, $6Pv6s.isEditableSelector)(state),
        boardTitle: (0, $6Pv6s.boardTitleSelector)(state)
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6b43f922e98e2b49$var$mapDispatchToProps = (dispatch)=>({
        onSubmit: (title)=>{
            dispatch((0, $7buQq.renameBoardRequest)(title));
        }
    });
var $6b43f922e98e2b49$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($6b43f922e98e2b49$var$mapStateToProps, $6b43f922e98e2b49$var$mapDispatchToProps)((0, $e4D5B.default));

});
parcelRegister("e4D5B", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b647abde50484fb$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ // eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2nvJN = parcelRequire("2nvJN");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $kY99m = parcelRequire("kY99m");

var $heNNl = parcelRequire("heNNl");

var $az4zD = parcelRequire("az4zD");

var $lfTZh = parcelRequire("lfTZh");

var $8zOmE = parcelRequire("8zOmE");

var $kxZPA = parcelRequire("kxZPA");

var $8K1gU = parcelRequire("8K1gU");
const $9b647abde50484fb$var$boardTitleMaxChars = 30;

const $9b647abde50484fb$export$97bda0f90d93904c = (0, $kxZPA.lazy)(()=>(parcelRequire("egkNH")), {
    moduleId: "../platform/packages/design-system/inline-edit/src/index.ts"
}); // eslint-disable-next-line jira/react/no-class-components
class $9b647abde50484fb$var$Title extends (0, $5uXOq.Component) {
    render() {
        const { intl: { formatMessage: formatMessage }, canEdit: canEdit } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b647abde50484fb$var$LimitWidthStyle, {
            "data-testid": "software-board.header.title.container"
        }, canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b647abde50484fb$var$EditableMarginCorrect, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
            id: "inline-edit",
            packageName: "software-board",
            render: this.renderReadOnlyView
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "inline-edit",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $9b647abde50484fb$var$loadingEditorWrapperStyles
            }, this.renderReadView())
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b647abde50484fb$export$97bda0f90d93904c, {
            editView: this.renderEditView,
            readView: this.renderReadView,
            onConfirm: this.onConfirm,
            defaultValue: this.props.boardTitle,
            editButtonLabel: formatMessage((0, $8K1gU.default).currentTitleAriaLabel, {
                currentTitle: this.props.boardTitle
            }),
            label: "",
            hideActionButtons: true
        })))) : this.renderReadOnlyView());
    }
    constructor(...args){
        super(...args);
        this.onConfirm = (editValue, analyticsEvent)=>{
            const { boardTitle: boardTitle } = this.props;
            if (editValue !== null) {
                const newTitle = (0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(editValue);
                if (newTitle !== '' && newTitle !== boardTitle) {
                    this.props.onSubmit(newTitle);
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'boardName');
                }
            }
        };
        this.renderEditView = (fieldProps)=>{
            const { errorMessage: errorMessage, ...fieldPropsWithoutErrorMessage } = fieldProps;
            const { intl: { formatMessage: formatMessage }, boardTitle: boardTitle } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b647abde50484fb$var$TextFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ...fieldPropsWithoutErrorMessage,
                "aria-label": formatMessage((0, $8K1gU.default).currentTitleAriaLabel, {
                    currentTitle: boardTitle
                }),
                autoFocus: true,
                maxLength: $9b647abde50484fb$var$boardTitleMaxChars
            }));
        };
        this.renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b647abde50484fb$var$ReadContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b647abde50484fb$var$TruncatingTextStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b647abde50484fb$var$ReadHeading, null, this.props.boardTitle)));
        this.renderReadOnlyView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b647abde50484fb$var$TruncatingTextStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b647abde50484fb$var$HeadingStyle, null, this.props.boardTitle));
    }
}
var $9b647abde50484fb$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($9b647abde50484fb$var$Title);
const $9b647abde50484fb$var$boardTitleMaxWidth = 420; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b647abde50484fb$var$TextFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_13gg1wug _1nb51p5s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b647abde50484fb$var$LimitWidthStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1pna _19pkv77o _otyrv77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b647abde50484fb$var$ReadContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _vwz41kw7 _18s81bpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b647abde50484fb$var$TruncatingTextStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s _16jlidpf _1o9zkb7n _i0dl1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b647abde50484fb$var$EditableMarginCorrect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1l04",
            __cmplp.className
        ])
    });
});
const $9b647abde50484fb$var$loadingEditorWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.150',
    marginBottom: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b647abde50484fb$var$HeadingStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81p5s _k48pbfng _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b647abde50484fb$var$ReadHeading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81p5s _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2nvJN", function(module, exports) {

var $kHBB0 = parcelRequire("kHBB0");

var $6wH7T = parcelRequire("6wH7T");

var $gvFfr = parcelRequire("gvFfr");

var $4TR1Q = parcelRequire("4TR1Q");

var $c2mKc = parcelRequire("c2mKc");

var $jx6Tp = parcelRequire("jx6Tp");

var $jJVtR = parcelRequire("jJVtR");
/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */ function $1bb6592c97235e03$var$trim(string, chars, guard) {
    string = $jJVtR(string);
    if (string && (guard || chars === undefined)) return $6wH7T(string);
    if (!string || !(chars = $kHBB0(chars))) return string;
    var strSymbols = $jx6Tp(string), chrSymbols = $jx6Tp(chars), start = $c2mKc(strSymbols, chrSymbols), end = $4TR1Q(strSymbols, chrSymbols) + 1;
    return $gvFfr(strSymbols, start, end).join('');
}
module.exports = $1bb6592c97235e03$var$trim;

});
parcelRegister("4TR1Q", function(module, exports) {

var $2wwA6 = parcelRequire("2wwA6");
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */ function $39156edc40ecb497$var$charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while(index-- && $2wwA6(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $39156edc40ecb497$var$charsEndIndex;

});

parcelRegister("c2mKc", function(module, exports) {

var $2wwA6 = parcelRequire("2wwA6");
/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */ function $8c37507367fba30b$var$charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while(++index < length && $2wwA6(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $8c37507367fba30b$var$charsStartIndex;

});


parcelRegister("8K1gU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce37f0d1c4f30729$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ce37f0d1c4f30729$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    currentTitleAriaLabel: {
        "id": "software.main.header.title.current-title-aria-label",
        "defaultMessage": "{currentTitle}, edit board title"
    }
});

});



parcelRegister("3NePp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8da52fecfa0b4b84$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cb25w = parcelRequire("cb25w");

var $f5TWP = parcelRequire("f5TWP");

var $2s6Sm = parcelRequire("2s6Sm");

var $cS37j = parcelRequire("cS37j");

var $eXQym = parcelRequire("eXQym");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");

var $8qMCq = parcelRequire("8qMCq");

var $g5X3G = parcelRequire("g5X3G");

var $e0kZI = parcelRequire("e0kZI");

var $1393U = parcelRequire("1393U");

var $l8ruj = parcelRequire("l8ruj");

var $dCm1o = parcelRequire("dCm1o");

var $U0mgX = parcelRequire("U0mgX");

var $hpoCd = parcelRequire("hpoCd");

var $6OUMO = parcelRequire("6OUMO");

var $dNht2 = parcelRequire("dNht2");

var $7Zg4V = parcelRequire("7Zg4V");

var $58Nil = parcelRequire("58Nil");

var $9eTg7 = parcelRequire("9eTg7");
class $8da52fecfa0b4b84$export$8b251419efc915eb extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            sprintGoal: null,
            selectedIssueKeys: []
        };
    }
    renderSprintGoalNavV3() {
        return this.props.sprintGoal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $58Nil.SprintGoal), {
            goal: this.props.sprintGoal
        });
    }
    renderBaseActionsNavV3() {
        const { baseUrl: baseUrl, isCMPBoard: isCMPBoard, hasActiveSprint: hasActiveSprint, isSprintsEnabled: isSprintsEnabled, isIncrementPlanningBoard: isIncrementPlanningBoard, ReleaseVersion: ReleaseVersion, isCompleteSprintButtonVisible: isCompleteSprintButtonVisible, hasManageSprintPermission: hasManageSprintPermission, CompleteSprintButton: CompleteSprintButton, FavoriteButton: FavoriteButton, isSprintRemainingDaysVisible: isSprintRemainingDaysVisible, SprintRemainingDays: SprintRemainingDays, BoardOperations: BoardOperations, AutomationMenu: AutomationMenu, rapidViewId: rapidViewId, canManageAutomations: canManageAutomations, projectKey: projectKey, projectId: projectId, projectType: projectType, selectedIssueKeys: selectedIssueKeys, selectedIssueIds: selectedIssueIds, isReleaseVersionVisible: isReleaseVersionVisible, isHeaderCompactMode: isHeaderCompactMode, isEmbedView: isEmbedView, boardName: boardName, shouldRenderAutomationButton: shouldRenderAutomationButton, shouldRenderFavouriteButton: shouldRenderFavouriteButton, shouldRenderReleaseButton: shouldRenderReleaseButton, shouldRenderFeedbackCollectorButton: shouldRenderFeedbackCollectorButton, shouldRenderFullscreenButton: shouldRenderFullscreenButton, boardType: boardType, createAnalyticsEvent: createAnalyticsEvent, isJSWBoard: isJSWBoard, isActiveStandup: isActiveStandup, setIsActiveStandup: setIsActiveStandup } = this.props;
        const automationMenu = shouldRenderAutomationButton && !isActiveStandup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AutomationMenu, {
            items: (0, $2s6Sm.boardMenuItems),
            projectType: projectType,
            projectId: (0, $g5X3G.toProjectId)(`${projectId}`),
            projectKey: (0, $g5X3G.toProjectKey)(projectKey),
            isSimplified: true // Ignored in project aware BoardMenu
            ,
            isUIF: isCMPBoard,
            canManageAutomations: canManageAutomations,
            selectedIssueKeys: selectedIssueKeys,
            // Cast issueId as number[] for now, until we need AutomationMenu for ARJ Increment planning board
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            selectedIssueIds: selectedIssueIds,
            key: "automationButton"
        });
        const favButton = shouldRenderFavouriteButton && !isActiveStandup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FavoriteButton, {
            key: "favouriteButton",
            baseUrl: baseUrl,
            itemId: rapidViewId,
            itemType: (0, $eXQym.BOARDS_ITEM_TYPE),
            favoriteItemName: boardName,
            tooltipPosition: "top"
        });
        const fullscreenButton = shouldRenderFullscreenButton && !isEmbedView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hpoCd.FullscreenButton), {
            boardId: Number(rapidViewId),
            shouldRenderContent: !isActiveStandup,
            key: "fullscreenButton"
        }) : null;
        const showShareButton = !isIncrementPlanningBoard;
        const shareContentType = `${boardType}_board`;
        const onShareButtonClick = ()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'shareContentType', {
                contentType: shareContentType
            });
        };
        const shareButton = showShareButton && !isActiveStandup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dNht2.JswShareButton), {
            projectId: (0, $g5X3G.toProjectId)(`${projectId}`),
            key: "shareButton",
            shareContentType: shareContentType,
            onTriggerButtonClick: onShareButtonClick
        });
        const sprintRemainingDays = !isHeaderCompactMode && isSprintRemainingDaysVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SprintRemainingDays, {
            key: "SprintRemainingButton"
        });
        const isStandupDisabled = (0, $9eTg7.shouldDisableStandup)({
            boardType: boardType,
            isSprintsEnabled: isSprintsEnabled,
            hasActiveSprint: hasActiveSprint
        });
        const standupControlButton = !isIncrementPlanningBoard && isJSWBoard && (0, $6s1PB.expVal)('jira-in-product-standups', 'is_enabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1393U.StandupControlButtons), {
            isStandupDisabled: isStandupDisabled,
            isActiveStandup: isActiveStandup,
            setIsActiveStandup: setIsActiveStandup,
            boardId: Number(rapidViewId)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8da52fecfa0b4b84$var$ActionsWrapper, null, shouldRenderFeedbackCollectorButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $U0mgX.default), null), sprintRemainingDays, isSprintRemainingDaysVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OUMO.Separator), {
            key: "sprint-info-separator"
        }), (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            space: "space.100",
            alignInline: "center"
        }, [
            automationMenu,
            favButton,
            shareButton,
            fullscreenButton,
            standupControlButton
        ]) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8da52fecfa0b4b84$var$IconButtonWrapper, null, [
            automationMenu,
            favButton,
            shareButton,
            fullscreenButton,
            standupControlButton
        ]), !isEmbedView && !isHeaderCompactMode && isCompleteSprintButtonVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CompleteSprintButton, (0, $4R6GH.fg)('jsw-jet-yamato-fe-permissions-seq-sprint-actions') ? {
            isDisabled: !hasManageSprintPermission
        } : {}), !isHeaderCompactMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BoardOperations, null), shouldRenderReleaseButton && !isHeaderCompactMode && isReleaseVersionVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ReleaseVersion, {
            rapidViewId: rapidViewId
        }), !isHeaderCompactMode && isCMPBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0kZI.BoardConnectToolbar), {
            boardId: rapidViewId,
            projectKey: projectKey,
            mode: "work"
        }));
    }
    renderBaseActionsNavV4() {
        const { CompleteSprintButton: CompleteSprintButton, hasActiveSprint: hasActiveSprint, isCompleteSprintButtonVisible: isCompleteSprintButtonVisible, isEmbedView: isEmbedView, isHeaderCompactMode: isHeaderCompactMode, shouldRenderFeedbackCollectorButton: shouldRenderFeedbackCollectorButton, hasManageSprintPermission: hasManageSprintPermission } = this.props;
        const actions = [];
        if (shouldRenderFeedbackCollectorButton) actions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $U0mgX.default), {
            key: "feedbackButton"
        }));
        const shouldRenderSprintControls = hasActiveSprint; // TODO use capability?
        if (shouldRenderSprintControls) actions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Zg4V.SprintDetailsButton), {
            key: "sprintPopup"
        }));
        const shouldRenderCompleteSprintButton = !isEmbedView && !isHeaderCompactMode && isCompleteSprintButtonVisible;
        if (shouldRenderCompleteSprintButton) actions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CompleteSprintButton, {
            key: "completeSprintButton",
            ...(0, $4R6GH.fg)('jsw-jet-yamato-fe-permissions-seq-sprint-actions') ? {
                isDisabled: !hasManageSprintPermission
            } : {}
        }));
        if (actions.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8da52fecfa0b4b84$var$ActionsWrapper, null, actions);
    }
    renderMenu() {
        const { isEmbedView: isEmbedView, isMenuVisible: isMenuVisible, Menu: Menu } = this.props;
        if (!isMenuVisible || isEmbedView) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Menu, null);
    }
    renderBaseActionsAndMenu() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8da52fecfa0b4b84$var$ActionsWrapper, null, this.renderBaseActionsNavV3(), this.renderMenu());
    }
    render() {
        const { ControlsBar: ControlsBar, Title: Title, BreadcrumbRenderer: BreadcrumbRenderer, isSprintsEnabled: isSprintsEnabled, BoardOperations: BoardOperations, hasActiveSprint: hasActiveSprint, customFiltersQueryRef: customFiltersQueryRef, rapidViewId: rapidViewId, isHeaderCompactMode: isHeaderCompactMode, isIncrementPlanningBoard: isIncrementPlanningBoard, shouldRenderViewSettingsCardDetailsOption: shouldRenderViewSettingsCardDetailsOption, projectKey: projectKey, projectName: projectName, isTabNavigation: isTabNavigation, isCMPBoard: isCMPBoard, isActiveStandup: isActiveStandup, setIsActiveStandup: setIsActiveStandup, boardType: boardType } = this.props;
        /**
     * In Advanced Roadmaps, we're embedding the JSW board into an "Increment" page
     * which already has a <PageHeader /> with its own breadcrumbs and call-to-action buttons
     * therefore all we need is the <ControlsBar />, nothing else.
     */ if (isIncrementPlanningBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
            name: "software-board-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8da52fecfa0b4b84$var$IncrementPlanningHeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ControlsBar, {
            customFiltersQueryRef: null,
            hasActiveSprint: false,
            isSprintsEnabled: false,
            leftHandSideActions: isTabNavigation && (0, $4R6GH.fg)('remove_plans_fullscreen_button_in_tabs_nav') ? null : this.renderBaseActionsNavV3(),
            rapidViewId: Number(rapidViewId),
            showCardDetails: shouldRenderViewSettingsCardDetailsOption,
            isActiveStandup: isActiveStandup,
            setIsActiveStandup: setIsActiveStandup,
            boardType: boardType
        }, this.renderMenu())));
        const breadcrumbs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8da52fecfa0b4b84$export$c7432936d9c50db7, {
            "data-fullscreen-id": "fullscreen-board-breadcrumbs"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BreadcrumbRenderer, null), projectKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8qMCq.default), {
            projectKey: projectKey,
            projectName: projectName
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
            name: "software-board-header"
        }, isTabNavigation ? /* FY25 Nav v4 aka. Tab Nav caused the "reshuffle" of the header:
       * - automationMenu, favButton, shareButton => now above the tabs
       * - fullscreenButton => moved to <ControlBar>
       * - sprint details & controls => moved to a flyout under a new button
       * only needed things left = Connect extension points
       * ALSO we remove the "isHeaderCompactMode" logic = moved outside of this func
       */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8da52fecfa0b4b84$var$HeaderWrapperNavV4, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ControlsBar, {
            isSprintsEnabled: isSprintsEnabled,
            hasActiveSprint: hasActiveSprint,
            customFiltersQueryRef: customFiltersQueryRef,
            // @ts-expect-error TS2322 - RapidViewId is string but controls expect number
            rapidViewId: rapidViewId,
            leftHandSideActions: null,
            showCardDetails: shouldRenderViewSettingsCardDetailsOption,
            isActiveStandup: isActiveStandup,
            setIsActiveStandup: setIsActiveStandup,
            boardType: boardType
        }, !(0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BoardOperations, null), isCMPBoard && !(0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0kZI.BoardConnectToolbar), {
            boardId: rapidViewId,
            projectKey: projectKey,
            mode: "work"
        }), this.renderBaseActionsNavV4(), this.renderMenu())) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8da52fecfa0b4b84$var$HeaderWrapperNavV3, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
            truncateTitle: true,
            disableTitleStyles: true,
            bottomBar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ControlsBar, {
                isSprintsEnabled: isSprintsEnabled,
                hasActiveSprint: hasActiveSprint,
                customFiltersQueryRef: customFiltersQueryRef,
                // @ts-expect-error TS2322 - RapidViewId is string but controls expect number
                rapidViewId: rapidViewId,
                leftHandSideActions: isHeaderCompactMode && this.renderBaseActionsNavV3(),
                showCardDetails: shouldRenderViewSettingsCardDetailsOption,
                isActiveStandup: isActiveStandup,
                setIsActiveStandup: setIsActiveStandup,
                boardType: boardType
            }, isHeaderCompactMode && this.renderMenu()),
            actions: !isHeaderCompactMode && this.renderBaseActionsAndMenu(),
            breadcrumbs: breadcrumbs
        }, !isHeaderCompactMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Title, null), this.renderSprintGoalNavV3()))));
    }
}
var $8da52fecfa0b4b84$export$2e2bcd8739ae039 = (0, $cb25w.default)()($8da52fecfa0b4b84$export$8b251419efc915eb);
const $8da52fecfa0b4b84$export$c7432936d9c50db7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _11w3glyw",
            __cmplp.className
        ])
    });
});
const $8da52fecfa0b4b84$var$ActionsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $8da52fecfa0b4b84$var$HeaderWrapperNavV3Old = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4zdiv",
            __cmplp.className
        ])
    });
});
const $8da52fecfa0b4b84$var$HeaderWrapperNavV3New = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt41e2i",
            __cmplp.className
        ])
    });
});
const $8da52fecfa0b4b84$var$HeaderWrapperNavV3 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $8da52fecfa0b4b84$var$HeaderWrapperNavV3New, $8da52fecfa0b4b84$var$HeaderWrapperNavV3Old);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8da52fecfa0b4b84$var$HeaderWrapperNavV4Old = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt41w72",
            __cmplp.className
        ])
    });
});
const $8da52fecfa0b4b84$var$HeaderWrapperNavV4New = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt41dx7",
            __cmplp.className
        ])
    });
});
const $8da52fecfa0b4b84$var$HeaderWrapperNavV4 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $8da52fecfa0b4b84$var$HeaderWrapperNavV4New, $8da52fecfa0b4b84$var$HeaderWrapperNavV4Old);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8da52fecfa0b4b84$var$IncrementPlanningHeaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt41xhr",
            __cmplp.className
        ])
    });
});
const $8da52fecfa0b4b84$var$IconButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cS37j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a15efb09f101ecb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $57MwZ = parcelRequire("57MwZ");
const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57MwZ.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
    });
var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a15efb09f101ecb$var$ActionsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("57MwZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9694e728fd1ea060$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $5uXOq = parcelRequire("5uXOq");

var $eeGIy = parcelRequire("eeGIy");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $9694e728fd1ea060$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eeGIy.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eeGIy.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eeGIy.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eeGIy.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eeGIy.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eeGIy.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $9694e728fd1ea060$export$2e2bcd8739ae039 = $9694e728fd1ea060$var$PageHeader;

});
parcelRegister("eeGIy", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $0c196d37a4e8266c$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $0c196d37a4e8266c$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $0c196d37a4e8266c$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $0c196d37a4e8266c$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $0c196d37a4e8266c$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $0c196d37a4e8266c$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
function $0c196d37a4e8266c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0c196d37a4e8266c$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $0c196d37a4e8266c$var$outerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $0c196d37a4e8266c$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $0c196d37a4e8266c$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $0c196d37a4e8266c$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $0c196d37a4e8266c$var$titleContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $0c196d37a4e8266c$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $0c196d37a4e8266c$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $0c196d37a4e8266c$var$bottomBarStyles = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.200'
});
const $0c196d37a4e8266c$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $0c196d37a4e8266c$var$outerStyles
    }, children);
};
const $0c196d37a4e8266c$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("h1", {
        css: [
            $0c196d37a4e8266c$var$titleStyles,
            truncateTitle && $0c196d37a4e8266c$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $0c196d37a4e8266c$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $0c196d37a4e8266c$var$titleWrapperStyles,
            truncateTitle && $0c196d37a4e8266c$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $0c196d37a4e8266c$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $0c196d37a4e8266c$var$titleContainerStyles,
            truncateTitle && $0c196d37a4e8266c$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $0c196d37a4e8266c$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $0c196d37a4e8266c$var$actionStyles
    }, children);
};
const $0c196d37a4e8266c$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        xcss: $0c196d37a4e8266c$var$bottomBarStyles
    }, children);
};

});



parcelRegister("8qMCq", function(module, exports) {

$parcel$export(module.exports, "default", () => $87b5bc435d98c94f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lUz5s = parcelRequire("lUz5s");

var $hgsSB = parcelRequire("hgsSB");

var $2XiUm = parcelRequire("2XiUm");
const $87b5bc435d98c94f$var$ErrorBoundary = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        teamName: (0, $lUz5s.APP_TEAM_NAME),
        id: "projectCreateImportProgress",
        packageName: (0, $hgsSB.APP_IDENTIFIER),
        fallback: "unmount"
    }, children);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$87b5bc435d98c94f$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87b5bc435d98c94f$var$ErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2XiUm.default), props));

});
parcelRegister("lUz5s", function(module, exports) {

$parcel$export(module.exports, "X2C_SERVICE_URL_PREFIX", () => $c689fb2a7c606375$export$e8e1caec1dfda22c);
$parcel$export(module.exports, "APP_IDENTIFIER", () => $c689fb2a7c606375$export$2cea7f14750b8c19);
$parcel$export(module.exports, "APP_TEAM_NAME", () => $c689fb2a7c606375$export$a5a8ee89d936ca29);
$parcel$export(module.exports, "INITIAL_MIGRATION_STATUS", () => $c689fb2a7c606375$export$7198445d3ab0721e);
$parcel$export(module.exports, "FEEDBACK_GROUP_ID", () => $c689fb2a7c606375$export$14b33d63628336c2);
$parcel$export(module.exports, "IMPORT_TYPE_PARAM_KEY", () => $c689fb2a7c606375$export$85c452e39fc36d3d);
$parcel$export(module.exports, "WORKSPACE_ID_PARAM_KEY", () => $c689fb2a7c606375$export$ad63f63c74460d35);
$parcel$export(module.exports, "ENTITY_ID_PARAM_KEY", () => $c689fb2a7c606375$export$a14f08973e10eb93);

var $y3A0q = parcelRequire("y3A0q");
const $c689fb2a7c606375$export$e8e1caec1dfda22c = '/gateway/api/jira-x2c-service/api/v1';
const $c689fb2a7c606375$export$2cea7f14750b8c19 = 'jira-business.project-create-importer-common';
const $c689fb2a7c606375$export$a5a8ee89d936ca29 = 'x2c-wolverine';
const $c689fb2a7c606375$export$7198445d3ab0721e = {
    overallProgress: 0.05,
    overallStatus: (0, $y3A0q.Status).READY,
    createdIssues: 0,
    totalIssues: 0,
    detailedProgress: {
        dataTransformStatus: (0, $y3A0q.Status).READY,
        userImportStatus: (0, $y3A0q.Status).READY,
        projectCreateStatus: (0, $y3A0q.Status).READY
    }
};
const $c689fb2a7c606375$export$14b33d63628336c2 = 'jwm-feedback-importer';
const $c689fb2a7c606375$export$85c452e39fc36d3d = 'importType';
const $c689fb2a7c606375$export$ad63f63c74460d35 = 'workspaceId';
const $c689fb2a7c606375$export$a14f08973e10eb93 = 'entityId';

});
parcelRegister("y3A0q", function(module, exports) {

$parcel$export(module.exports, "Status", () => $c053cc3f623c4541$export$96e9906d6d93a972);
const $c053cc3f623c4541$export$96e9906d6d93a972 = {
    READY: 'READY',
    IN_PROGRESS: 'IN_PROGRESS',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED'
};

});


parcelRegister("hgsSB", function(module, exports) {

$parcel$export(module.exports, "IMPORT_IN_PROGRESS_FLAG_ID", () => $3f5b74842571fa2d$export$3ee01c364a42b386);
$parcel$export(module.exports, "IMPORT_SUCCESS_FLAG_ID", () => $3f5b74842571fa2d$export$b4a552f4abf9b350);
$parcel$export(module.exports, "IMPORT_PARTIAL_SUCCESS_FLAG_ID", () => $3f5b74842571fa2d$export$62eac7116dbcab91);
$parcel$export(module.exports, "IMPORT_ADVANCED_ERRORS_FLAG_ID", () => $3f5b74842571fa2d$export$18a16c13a76c4a32);
$parcel$export(module.exports, "BASE_POLLING_INTERVAL_MS", () => $3f5b74842571fa2d$export$aa34325aa01d2f38);
$parcel$export(module.exports, "APP_IDENTIFIER", () => $3f5b74842571fa2d$export$2cea7f14750b8c19);
$parcel$export(module.exports, "CONTACT_SUPPORT_URL", () => $3f5b74842571fa2d$export$2c16bd1d8b68b11f);
const $3f5b74842571fa2d$export$3ee01c364a42b386 = 'import-in-progress-flag';
const $3f5b74842571fa2d$export$b4a552f4abf9b350 = 'import-success-flag';
const $3f5b74842571fa2d$export$62eac7116dbcab91 = 'import-partial-success-flag';
const $3f5b74842571fa2d$export$18a16c13a76c4a32 = 'import-advanced-errors-error-flag';
const $3f5b74842571fa2d$export$aa34325aa01d2f38 = 5000;
const $3f5b74842571fa2d$export$2cea7f14750b8c19 = 'jira-business.project-create-import-progress';
const $3f5b74842571fa2d$export$2c16bd1d8b68b11f = 'https://support.atlassian.com/contact/#/?inquiry_category=technical_issues&is_cloud=true&product_key=jira-work-management&support_type=customer';

});

parcelRegister("2XiUm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f36303d1eb77403c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $dfBUy = parcelRequire("dfBUy");

var $1O9Yy = parcelRequire("1O9Yy");

var $gChKN = parcelRequire("gChKN");

var $9qb4V = parcelRequire("9qb4V");
const $f36303d1eb77403c$var$ImportProgressFlag = ({ migrationId: migrationId, onSuccess: onSuccess, onFail: onFail })=>{
    (0, $9qb4V.useTrackMigrationStatus)((0, $1O9Yy.EXPERIENCES).IMPORT_PART_2, migrationId, onSuccess, onFail);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $f36303d1eb77403c$var$ImportProgress = ({ projectKey: projectKey, projectName: projectName })=>{
    const { fetchMigrationId: fetchMigrationId, removeMigrationId: removeMigrationId } = (0, $dfBUy.useMigrationIdManager)();
    const [migrationId, setMigrationId] = (0, $5uXOq.useState)(undefined);
    const { onSuccess: onSuccess, onFail: onFail } = (0, $gChKN.useFlags)({
        projectKey: projectKey,
        projectName: projectName,
        migrationId: migrationId,
        removeMigrationId: removeMigrationId
    });
    (0, $5uXOq.useEffect)(()=>{
        setMigrationId(fetchMigrationId(projectKey));
    }, [
        fetchMigrationId,
        projectKey
    ]);
    if (!migrationId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: (0, $1O9Yy.X2C_SCREENS).ImportProgressBar,
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f36303d1eb77403c$var$ImportProgressFlag, {
        onSuccess: onSuccess,
        onFail: onFail,
        migrationId: migrationId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
var $f36303d1eb77403c$export$2e2bcd8739ae039 = $f36303d1eb77403c$var$ImportProgress;

});
parcelRegister("dfBUy", function(module, exports) {

$parcel$export(module.exports, "useMigrationIdManager", () => $89bd768709492155$export$b6df8a64ae5b060b);

var $5uXOq = parcelRequire("5uXOq");

var $7uUwQ = parcelRequire("7uUwQ");

var $9zHJW = parcelRequire("9zHJW");
const $89bd768709492155$export$b6df8a64ae5b060b = ()=>{
    const fetchMigrationId = (0, $5uXOq.useCallback)((projectKey)=>{
        const migrationIdStore = (0, $9zHJW.getMigrationIdStore)();
        return migrationIdStore[projectKey];
    }, []);
    const storeMigrationId = (0, $5uXOq.useCallback)((projectKey, migrationId)=>{
        const migrationIdStore = (0, $9zHJW.getMigrationIdStore)();
        (0, $9zHJW.setMigrationIdStore)({
            ...migrationIdStore,
            [projectKey]: migrationId
        });
    }, []);
    const removeMigrationId = (0, $5uXOq.useCallback)((projectKey)=>{
        const migrationIdStore = (0, $9zHJW.getMigrationIdStore)();
        if (!(projectKey in migrationIdStore)) return;
        const newMigrationIdStore = (0, $7uUwQ.unset)(migrationIdStore, projectKey);
        if (Object.keys(newMigrationIdStore).length === 0) {
            (0, $9zHJW.removeMigrationIdStore)();
            return;
        }
        (0, $9zHJW.setMigrationIdStore)(newMigrationIdStore);
    }, []);
    return {
        fetchMigrationId: fetchMigrationId,
        storeMigrationId: storeMigrationId,
        removeMigrationId: removeMigrationId
    };
};

});
parcelRegister("9zHJW", function(module, exports) {

$parcel$export(module.exports, "getMigrationIdStore", () => $7568774462293954$export$caa1665a7b4680f6);
$parcel$export(module.exports, "setMigrationIdStore", () => $7568774462293954$export$d5f201daa9ea05b7);
$parcel$export(module.exports, "removeMigrationIdStore", () => $7568774462293954$export$7a4ecb0a9136dcec);
const $7568774462293954$var$MIGRATION_ID_STORE_KEY = 'X2C-Migration-Id-Store';
const $7568774462293954$export$caa1665a7b4680f6 = ()=>JSON.parse(localStorage.getItem($7568774462293954$var$MIGRATION_ID_STORE_KEY) || '{}');
const $7568774462293954$export$d5f201daa9ea05b7 = (migrationIdStore)=>localStorage.setItem($7568774462293954$var$MIGRATION_ID_STORE_KEY, JSON.stringify(migrationIdStore));
const $7568774462293954$export$7a4ecb0a9136dcec = ()=>localStorage.removeItem($7568774462293954$var$MIGRATION_ID_STORE_KEY);

});


parcelRegister("1O9Yy", function(module, exports) {

$parcel$export(module.exports, "EXPERIENCES", () => $9a9e8a67185abd0f$export$a2008ed3b02411a3);
$parcel$export(module.exports, "X2C_SCREENS", () => $9a9e8a67185abd0f$export$ff4b3425b39a0344);
const $9a9e8a67185abd0f$export$a2008ed3b02411a3 = {
    IMPORT_PART_2: 'projectCreateImporterImportPart2',
    IMPORT_PART_JSW: 'projectCreateImporterImportPart2JSW'
};
const $9a9e8a67185abd0f$export$ff4b3425b39a0344 = {
    ImportProgressBar: 'projectCreateImportProgressBar'
};

});

parcelRegister("gChKN", function(module, exports) {

$parcel$export(module.exports, "useFlags", () => $29ab02dd8dae572d$export$2879604e6aec4ab);

var $5uXOq = parcelRequire("5uXOq");

var $jPxJ7 = parcelRequire("jPxJ7");

var $pa9q9 = parcelRequire("pa9q9");

var $lpwtK = parcelRequire("lpwtK");

var $hgsSB = parcelRequire("hgsSB");

var $fz15h = parcelRequire("fz15h");

var $blRqr = parcelRequire("blRqr");
const $29ab02dd8dae572d$export$2879604e6aec4ab = ({ projectKey: projectKey, projectName: projectName, migrationId: migrationId, removeMigrationId: removeMigrationId })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag, hasFlag: hasFlag } = (0, $pa9q9.useFlagsService)();
    const openFeedbackModal = (0, $jPxJ7.useFeedbackCollector)();
    const { data: data } = (0, $lpwtK.useProject)();
    const name = data?.name || '';
    const handleDownloadLogsClick = (0, $fz15h.useDownloadLogs)(migrationId, projectName || name);
    const dismissInProgressFlag = (0, $5uXOq.useCallback)(()=>{
        dismissFlag((0, $hgsSB.IMPORT_IN_PROGRESS_FLAG_ID));
    }, [
        dismissFlag
    ]);
    const onSuccess = (0, $5uXOq.useCallback)((migrationStatus)=>{
        if (!hasFlag?.((0, $hgsSB.IMPORT_SUCCESS_FLAG_ID))) {
            dismissInProgressFlag();
            removeMigrationId(projectKey || projectName);
            showFlag((0, $blRqr.getSuccessFlag)(migrationStatus, projectName || name, openFeedbackModal));
        }
    }, // omit openFeedbackModal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        dismissInProgressFlag,
        hasFlag,
        migrationId,
        projectKey,
        removeMigrationId,
        showFlag
    ]);
    const onFail = (0, $5uXOq.useCallback)((migrationStatus)=>{
        if (migrationStatus.hasErrorLogs) {
            if (!hasFlag?.((0, $hgsSB.IMPORT_ADVANCED_ERRORS_FLAG_ID)) && migrationId) {
                dismissInProgressFlag();
                removeMigrationId(projectKey);
                showFlag((0, $blRqr.getAdvancedErrorFlag)({
                    migrationStatus: migrationStatus,
                    projectName: projectName || name,
                    onDownloadLogsClick: handleDownloadLogsClick
                }));
            }
            return;
        }
        if (!hasFlag?.((0, $hgsSB.IMPORT_PARTIAL_SUCCESS_FLAG_ID))) {
            dismissInProgressFlag();
            removeMigrationId(projectKey);
            showFlag((0, $blRqr.getPartialSuccessFlag)(migrationStatus, openFeedbackModal));
        }
    }, // omit openFeedbackModal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        handleDownloadLogsClick,
        dismissInProgressFlag,
        hasFlag,
        migrationId,
        projectKey,
        removeMigrationId,
        showFlag
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            dismissFlag((0, $hgsSB.IMPORT_IN_PROGRESS_FLAG_ID));
            dismissFlag((0, $hgsSB.IMPORT_SUCCESS_FLAG_ID));
            dismissFlag((0, $hgsSB.IMPORT_PARTIAL_SUCCESS_FLAG_ID));
        }, [
        dismissFlag
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!migrationId || hasFlag?.((0, $hgsSB.IMPORT_IN_PROGRESS_FLAG_ID))) return;
        showFlag((0, $blRqr.getInProgressFlag)());
    }, [
        hasFlag,
        migrationId,
        showFlag
    ]);
    return {
        onSuccess: onSuccess,
        onFail: onFail
    };
};

});
parcelRegister("fz15h", function(module, exports) {

$parcel$export(module.exports, "useDownloadLogs", () => $6d31cbbfee4870f9$export$178888e79b080a89);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $bGO0w = parcelRequire("bGO0w");

var $koeKL = parcelRequire("koeKL");
const $6d31cbbfee4870f9$export$bb3b75778e3e272 = (fileUrl, fileName)=>{
    // Need to create a link to trigger the download instead of redirecting
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.click();
};
const $6d31cbbfee4870f9$export$178888e79b080a89 = (migrationId, projectName)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const fileName = (0, $bGO0w.useErrorLogFileName)(projectName);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)(()=>{
        if (!migrationId) return;
        const url = (0, $bGO0w.createDownloadLogsUrl)({
            cloudId: cloudId,
            migrationId: migrationId,
            fileName: fileName
        });
        const uiEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'downloadX2CLogsLink'
        });
        (0, $8zOmE.fireUIAnalytics)(uiEvent);
        $6d31cbbfee4870f9$export$bb3b75778e3e272(url, fileName);
    }, [
        migrationId,
        cloudId,
        createAnalyticsEvent,
        fileName
    ]);
};

});
parcelRegister("bGO0w", function(module, exports) {

$parcel$export(module.exports, "isSynthetic", () => $c62bab4235c79636$export$947749d756ccb0a);
$parcel$export(module.exports, "createDownloadLogsUrl", () => $c62bab4235c79636$export$441dc85364beea74);
$parcel$export(module.exports, "useErrorLogFileName", () => $c62bab4235c79636$export$b3518e4126b755e4);

var $co1wz = parcelRequire("co1wz");

var $j8DrX = parcelRequire("j8DrX");

var $koVbs = parcelRequire("koVbs");

var $lUz5s = parcelRequire("lUz5s");

var $gUE7k = parcelRequire("gUE7k");
const $c62bab4235c79636$export$947749d756ccb0a = ()=>// Filter out synthetic tests using all known ways
    (0, $j8DrX.default)('ajs-is-synthetic') === 'true' || (0, $co1wz.ff)('jsw.pollinator.tenants');
const $c62bab4235c79636$export$441dc85364beea74 = ({ cloudId: cloudId, migrationId: migrationId, fileName: fileName })=>`${0, $lUz5s.X2C_SERVICE_URL_PREFIX}/${cloudId}/import/${migrationId}/logs?${new URLSearchParams({
        fileName: fileName
    }).toString()}`;
const $c62bab4235c79636$export$b3518e4126b755e4 = (projectName)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return formatMessage((0, $gUE7k.default).errorLogFileName, {
        projectName: projectName.replace(/[&*()[\];'"?!() ]/g, '_')
    });
};

});
parcelRegister("gUE7k", function(module, exports) {

$parcel$export(module.exports, "default", () => $393e9c07e06134e1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $393e9c07e06134e1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorLogFileName: {
        "id": "project-create-importer-common.common.error-log-file-name",
        "defaultMessage": "{projectName}_import_error_log.zip"
    }
});

});



parcelRegister("blRqr", function(module, exports) {

$parcel$export(module.exports, "getSuccessFlag", () => $079ea54cd024905b$export$dbe4723f1df81b00);
$parcel$export(module.exports, "getAdvancedErrorFlag", () => $079ea54cd024905b$export$3bf6b82a650cc3f6);
$parcel$export(module.exports, "getPartialSuccessFlag", () => $079ea54cd024905b$export$368940990df88cd9);
$parcel$export(module.exports, "getInProgressFlag", () => $079ea54cd024905b$export$fc9c6c786fccb031);

var $6s1PB = parcelRequire("6s1PB");

var $lUz5s = parcelRequire("lUz5s");

var $hgsSB = parcelRequire("hgsSB");

var $2rCPm = parcelRequire("2rCPm");
const $079ea54cd024905b$export$dbe4723f1df81b00 = (migrationStatus, projectName, openFeedbackModal)=>({
        id: (0, $hgsSB.IMPORT_SUCCESS_FLAG_ID),
        type: 'success',
        isAutoDismiss: false,
        title: [
            (0, $2rCPm.default).importSuccessFlagTitle,
            {
                projectName: projectName
            }
        ],
        description: [
            (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2rCPm.default).importSuccessDescriptionIssueTermRefresh : (0, $2rCPm.default).importSuccessDescription,
            {
                count: migrationStatus.createdIssues
            }
        ],
        actions: [
            {
                content: (0, $2rCPm.default).refreshPage,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.reload()
            },
            {
                content: (0, $2rCPm.default).giveFeedback,
                onClick: ()=>openFeedbackModal((0, $lUz5s.FEEDBACK_GROUP_ID))
            }
        ]
    });
const $079ea54cd024905b$export$3bf6b82a650cc3f6 = ({ projectName: projectName, migrationStatus: migrationStatus, onDownloadLogsClick: onDownloadLogsClick })=>({
        id: (0, $hgsSB.IMPORT_ADVANCED_ERRORS_FLAG_ID),
        type: 'error',
        isAutoDismiss: false,
        title: (0, $2rCPm.default).importAdvancedErrorTitle,
        description: [
            (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2rCPm.default).importAdvancedErrorDescriptionIssueTermRefresh : (0, $2rCPm.default).importAdvancedErrorDescription,
            {
                failed: migrationStatus.totalIssues - migrationStatus.createdIssues,
                total: migrationStatus.totalIssues,
                projectName: projectName
            }
        ],
        actions: [
            {
                content: (0, $2rCPm.default).downloadLogs,
                onClick: onDownloadLogsClick
            },
            {
                content: (0, $2rCPm.default).contactSupport,
                href: (0, $hgsSB.CONTACT_SUPPORT_URL),
                target: '_blank'
            }
        ]
    });
const $079ea54cd024905b$export$368940990df88cd9 = (migrationStatus, openFeedbackModal)=>({
        id: (0, $hgsSB.IMPORT_PARTIAL_SUCCESS_FLAG_ID),
        type: 'info',
        isAutoDismiss: false,
        title: (0, $2rCPm.default).importPartialSuccessTitle,
        description: (0, $2rCPm.default).importPartialSuccessDescription,
        actions: [
            {
                content: (0, $2rCPm.default).contactSupport,
                href: (0, $hgsSB.CONTACT_SUPPORT_URL),
                target: '_blank'
            },
            {
                content: (0, $2rCPm.default).giveFeedback,
                onClick: ()=>openFeedbackModal((0, $lUz5s.FEEDBACK_GROUP_ID))
            }
        ]
    });
const $079ea54cd024905b$export$fc9c6c786fccb031 = ()=>({
        id: (0, $hgsSB.IMPORT_IN_PROGRESS_FLAG_ID),
        type: 'info',
        isAutoDismiss: false,
        title: (0, $2rCPm.default).importingInProgressTitle,
        description: (0, $2rCPm.default).importingInProgressDescription
    });

});
parcelRegister("2rCPm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9f9fa85f2d5ed95$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d9f9fa85f2d5ed95$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    importingInProgressTitle: {
        "id": "project-create-import-progress.common.utils.use-flags.importing-in-progress-title",
        "defaultMessage": "We\u2019re importing your data"
    },
    importingInProgressDescription: {
        "id": "project-create-import-progress.common.utils.use-flags.importing-in-progress-description",
        "defaultMessage": "You won't see any imported data yet, but feel free to work on other things while we get this done. Return to this page to check the progress of your import."
    },
    importSuccessDescription: {
        "id": "project-create-import-progress.common.utils.use-flags.import-success-description",
        "defaultMessage": "Refresh the page to see the {count, plural, one {# issue} other {# issues}} in your new project."
    },
    importSuccessFlagTitle: {
        "id": "project-create-import-progress.common.utils.use-flags.import-success-flag-title",
        "defaultMessage": "{projectName} is ready!"
    },
    importPartialSuccessTitle: {
        "id": "project-create-import-progress.common.utils.use-flags.import-partial-success-title",
        "defaultMessage": "We couldn\u2019t import all your data"
    },
    importAdvancedErrorTitle: {
        "id": "project-create-import-progress.common.utils.use-flags.import-advanced-error-title",
        "defaultMessage": "We can't seem to import all your data"
    },
    importAdvancedErrorDescription: {
        "id": "project-create-import-progress.common.utils.use-flags.import-advanced-error-description",
        "defaultMessage": "See the error log to understand why {failed} of your {total} {total, plural, one {issue} other {issues}} failed."
    },
    importPartialSuccessDescription: {
        "id": "project-create-import-progress.common.utils.use-flags.import-partial-success-description",
        "defaultMessage": "Try again in a few minutes. If you continue experiencing problems with your import, contact support."
    },
    contactSupport: {
        "id": "project-create-import-progress.common.utils.use-flags.contact-support",
        "defaultMessage": "Contact Support"
    },
    downloadLogs: {
        "id": "project-create-import-progress.common.utils.use-flags.download-logs",
        "defaultMessage": "Download logs"
    },
    giveFeedback: {
        "id": "project-create-import-progress.common.utils.use-flags.give-feedback",
        "defaultMessage": "Give feedback"
    },
    refreshPage: {
        "id": "project-create-import-progress.common.utils.use-flags.refresh-page",
        "defaultMessage": "Refresh page"
    },
    importSuccessDescriptionIssueTermRefresh: {
        "id": "project-create-import-progress.common.utils.use-flags.import-success-description-issue-term-refresh",
        "defaultMessage": "Refresh the page to see the {count, plural, one {# issue} other {# issues}} in your new project."
    },
    importAdvancedErrorDescriptionIssueTermRefresh: {
        "id": "project-create-import-progress.common.utils.use-flags.import-advanced-error-description-issue-term-refresh",
        "defaultMessage": "See the error log to understand why {failed} of your {total} {total, plural, one {issue} other {issues}} failed."
    }
});

});



parcelRegister("9qb4V", function(module, exports) {

$parcel$export(module.exports, "useTrackMigrationStatus", () => $b3e371579e4bd3ba$export$840ba962ebf22de);

var $5uXOq = parcelRequire("5uXOq");

var $y3A0q = parcelRequire("y3A0q");

var $av6CA = parcelRequire("av6CA");

var $97g70 = parcelRequire("97g70");

var $hgsSB = parcelRequire("hgsSB");
const $b3e371579e4bd3ba$export$840ba962ebf22de = (experience, migrationId, onSuccess, onFail)=>{
    const { migrationStatus: migrationStatus } = (0, $97g70.usePollMigrationStatus)(migrationId, (0, $hgsSB.BASE_POLLING_INTERVAL_MS));
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $av6CA.useExperienceTracker)(experience);
    (0, $5uXOq.useEffect)(()=>{
        onExperienceStart();
    }, [
        onExperienceStart
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (migrationStatus.overallStatus === (0, $y3A0q.Status).SUCCESS) {
            onExperienceSuccess();
            onSuccess && onSuccess(migrationStatus);
            return;
        }
        if (migrationStatus.overallStatus === (0, $y3A0q.Status).FAILED) {
            onExperienceFail((0, $hgsSB.APP_IDENTIFIER), {
                name: 'Import Failed',
                message: 'Issue Import Failed'
            }, {
                migrationId: migrationId
            });
            onFail && onFail(migrationStatus);
        }
    }, [
        migrationId,
        migrationStatus,
        onExperienceFail,
        onExperienceSuccess,
        onFail,
        onSuccess
    ]);
    return {
        migrationStatus: migrationStatus
    };
};

});
parcelRegister("av6CA", function(module, exports) {

$parcel$export(module.exports, "useExperienceTracker", () => $21b8d38806d1cf23$export$cdefb2a8b53f879f);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $fZneA = parcelRequire("fZneA");

var $lGpwc = parcelRequire("lGpwc");
const $21b8d38806d1cf23$var$analyticsSource = 'ProjectCreateImporter';
const $21b8d38806d1cf23$export$cdefb2a8b53f879f = (experience)=>{
    const onExperienceStart = (0, $kaHBi.useExperienceStart)({
        experienceId: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4(),
        experience: experience,
        analyticsSource: $21b8d38806d1cf23$var$analyticsSource
    });
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: experience,
        attributes: {}
    });
    const onFail = (0, $93jKl.useExperienceFail)({
        experience: experience,
        attributes: {}
    });
    const onExperienceFail = (0, $5uXOq.useCallback)((location, error, extraAttributes)=>{
        if ((0, $fZneA.isClientFetchError)(error) || (0, $fZneA.isHttpClientErrorResponse)(error)) {
            onExperienceSuccess();
            return;
        }
        onFail(location, error, {
            errorName: (0, $lGpwc.extractErrorName)(error),
            errorMessage: (0, $lGpwc.extractErrorMessage)(error),
            statusCode: (0, $lGpwc.extractStatusCode)(error),
            traceId: (0, $lGpwc.extractTraceId)(error),
            buildKey: (0, $lGpwc.getBuildKey)(),
            ...extraAttributes || {}
        });
    }, [
        onExperienceSuccess,
        onFail
    ]);
    return [
        onExperienceStart,
        onExperienceSuccess,
        onExperienceFail
    ];
};

});
parcelRegister("lGpwc", function(module, exports) {

$parcel$export(module.exports, "getBuildKey", () => $0b1b329ab61a1369$export$14551268fbd9a06f);
$parcel$export(module.exports, "extractStatusCode", () => $0b1b329ab61a1369$export$1fdf7c1c0741a7e7);
$parcel$export(module.exports, "extractTraceId", () => $0b1b329ab61a1369$export$431eacb6aecbacdf);
$parcel$export(module.exports, "extractErrorName", () => $0b1b329ab61a1369$export$ebcf8325c79b7706);
$parcel$export(module.exports, "extractErrorMessage", () => $0b1b329ab61a1369$export$8cc545829c7461b0);

var $9XE6b = parcelRequire("9XE6b");
const $0b1b329ab61a1369$export$ba068cc3610b559d = 'NOT_PRESENT';
const $0b1b329ab61a1369$export$14551268fbd9a06f = ()=>window.BUILD_KEY;
const $0b1b329ab61a1369$export$1fdf7c1c0741a7e7 = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'statusCode'
    ], $0b1b329ab61a1369$export$ba068cc3610b559d);
const $0b1b329ab61a1369$export$431eacb6aecbacdf = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'traceId'
    ], $0b1b329ab61a1369$export$ba068cc3610b559d);
const $0b1b329ab61a1369$export$ebcf8325c79b7706 = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'name'
    ], $0b1b329ab61a1369$export$ba068cc3610b559d);
const $0b1b329ab61a1369$export$8cc545829c7461b0 = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'message'
    ], $0b1b329ab61a1369$export$ba068cc3610b559d);

});


parcelRegister("97g70", function(module, exports) {

$parcel$export(module.exports, "usePollMigrationStatus", () => $4c6504a7ae7fd778$export$523c1933cb8cd7a6);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $koeKL = parcelRequire("koeKL");

var $lUz5s = parcelRequire("lUz5s");

var $9E3iL = parcelRequire("9E3iL");

var $y3A0q = parcelRequire("y3A0q");

var $bGO0w = parcelRequire("bGO0w");

var $av6CA = parcelRequire("av6CA");

var $5wfyT = parcelRequire("5wfyT");
const $4c6504a7ae7fd778$export$84e2f2da851426a9 = 1800000;
const $4c6504a7ae7fd778$export$a1301e284b39cd56 = 1.3;
const $4c6504a7ae7fd778$var$getX2CMigrationStatusUrl = (cloudId, migrationId)=>`${0, $lUz5s.X2C_SERVICE_URL_PREFIX}/${cloudId}/import/${migrationId}/status`;
const $4c6504a7ae7fd778$export$7edd275ea1b9d090 = (cloudId, migrationId)=>(0, $7f4tk.default)($4c6504a7ae7fd778$var$getX2CMigrationStatusUrl(cloudId, migrationId), {
        method: 'GET',
        headers: {
            'x-issynthetic-traffic': String((0, $bGO0w.isSynthetic)())
        }
    });
const $4c6504a7ae7fd778$export$523c1933cb8cd7a6 = (migrationId, basePollingIntervalMs)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [migrationStatus, setMigrationStatus] = (0, $5uXOq.useState)((0, $lUz5s.INITIAL_MIGRATION_STATUS));
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $av6CA.useExperienceTracker)((0, $9E3iL.EXPERIENCES).POLLING);
    const getPollingRetryStatus = (0, $5uXOq.useCallback)(async ()=>{
        if (!migrationId) return false;
        try {
            onExperienceStart();
            (0, $9E3iL.pollingInteractionMetric).start();
            const containerTransferStatus = await $4c6504a7ae7fd778$export$7edd275ea1b9d090(cloudId, migrationId);
            const status = (0, $5wfyT.calculateMigrationStatus)(containerTransferStatus);
            setMigrationStatus(status);
            (0, $9E3iL.pollingInteractionMetric).stop();
            onExperienceSuccess();
            return status.overallStatus !== (0, $y3A0q.Status).SUCCESS && status.overallStatus !== (0, $y3A0q.Status).FAILED;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9E3iL.pollingInteractionMetric).stop();
            onExperienceFail((0, $lUz5s.APP_IDENTIFIER), error, {
                migrationId: migrationId
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetch-migration-status-error',
                    packageName: (0, $lUz5s.APP_IDENTIFIER),
                    teamName: (0, $lUz5s.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            if ((0, $5wfyT.isRetryable)(error)) return true;
            setMigrationStatus({
                ...migrationStatus,
                overallStatus: (0, $y3A0q.Status).FAILED
            });
            return false;
        }
    }, [
        cloudId,
        migrationId,
        migrationStatus,
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (migrationId) (0, $5wfyT.withExponentialBackoff)(getPollingRetryStatus, basePollingIntervalMs, $4c6504a7ae7fd778$export$84e2f2da851426a9, $4c6504a7ae7fd778$export$a1301e284b39cd56);
    // Only setup new polling if migrationId or interval changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        migrationId,
        basePollingIntervalMs
    ]);
    return {
        migrationStatus: migrationStatus
    };
};

});
parcelRegister("9E3iL", function(module, exports) {

$parcel$export(module.exports, "EXPERIENCES", () => $19021017c40d5b8e$export$a2008ed3b02411a3);
$parcel$export(module.exports, "pollingInteractionMetric", () => $19021017c40d5b8e$export$40607ce86ffe9e76);

var $dGrdR = parcelRequire("dGrdR");

var $lUz5s = parcelRequire("lUz5s");
const $19021017c40d5b8e$export$a2008ed3b02411a3 = {
    POLLING: 'projectCreateImporterPolling'
};
const $19021017c40d5b8e$var$POLLING_ITERACTION_METRIC_KEY = `${(0, $lUz5s.APP_IDENTIFIER)}.polling`;
const $19021017c40d5b8e$export$40607ce86ffe9e76 = (0, $dGrdR.metrics).interaction({
    key: $19021017c40d5b8e$var$POLLING_ITERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});

});

parcelRegister("5wfyT", function(module, exports) {

$parcel$export(module.exports, "calculateMigrationStatus", () => $3eb6aec6bd421b16$export$214c69f9b592e736);
$parcel$export(module.exports, "isRetryable", () => $3eb6aec6bd421b16$export$f146c102d7613638);
$parcel$export(module.exports, "withExponentialBackoff", () => $3eb6aec6bd421b16$export$20eaa22f2295996f);

var $9XE6b = parcelRequire("9XE6b");

var $lUz5s = parcelRequire("lUz5s");

var $y3A0q = parcelRequire("y3A0q");

var $hmhzd = parcelRequire("hmhzd");
const $3eb6aec6bd421b16$var$JIRA_IMPORT_OPERATION_KEY = 'jiraImport';
const $3eb6aec6bd421b16$var$JIRA_IMPORT_V4_OPERATION_KEY = 'jiraX2CProjectImport';
const $3eb6aec6bd421b16$var$JIRA_DATA_TRANSFORM_OPERATION_KEY = 'jiraDataTransform';
const $3eb6aec6bd421b16$var$ALL_USER_IMPORT_OPERATION_KEY = 'allUserImport';
const $3eb6aec6bd421b16$var$PROJECT_ENTITY_KEY = 'jira/classic:project';
const $3eb6aec6bd421b16$var$ISSUE_ENTITY_KEY = 'jira:issue';
const $3eb6aec6bd421b16$var$PROGRESS_WEIGHTING = {
    jiraImport: 0.5,
    allUserImport: 0.3,
    jiraProjectFinalise: 0.1,
    jiraDataTransfer: 0.1
};
const $3eb6aec6bd421b16$var$isFailedStatus = (status)=>status === (0, $hmhzd.TransferStatus).FAILED || status === (0, $hmhzd.TransferStatus).INCOMPLETE || status === (0, $hmhzd.TransferStatus).CANCELLED || status === (0, $hmhzd.TransferStatus).SKIPPED;
const $3eb6aec6bd421b16$var$getCreatedJiraImportCountForEntity = (transfer, entityKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(transfer, [
        'progressProperties',
        'completedEntityCounts',
        entityKey,
        'completed',
        'created'
    ], 0);
const $3eb6aec6bd421b16$var$getFailedJiraImportCountForEntity = (transfer, entityKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(transfer, [
        'progressProperties',
        'completedEntityCounts',
        entityKey,
        'completed',
        'failed'
    ], 0);
const $3eb6aec6bd421b16$var$getTotalJiraImportCountForEntity = (transfer, entityKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(transfer, [
        'progressProperties',
        'completedEntityCounts',
        entityKey,
        'totalEntities'
    ], 0);
const $3eb6aec6bd421b16$export$37d331774442a79a = (containerTransferStatus)=>{
    const jiraImportTransfer = containerTransferStatus.transfers?.find((transfer)=>transfer.operationKey === $3eb6aec6bd421b16$var$JIRA_IMPORT_OPERATION_KEY || transfer.operationKey === $3eb6aec6bd421b16$var$JIRA_IMPORT_V4_OPERATION_KEY);
    if (!jiraImportTransfer) return {
        createdIssues: 0,
        totalIssues: 0
    };
    return {
        createdIssues: $3eb6aec6bd421b16$var$getCreatedJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$ISSUE_ENTITY_KEY),
        totalIssues: $3eb6aec6bd421b16$var$getTotalJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$ISSUE_ENTITY_KEY)
    };
};
const $3eb6aec6bd421b16$var$transformTranferStatusToStatus = (transferStatus)=>{
    if ($3eb6aec6bd421b16$var$isFailedStatus(transferStatus)) return (0, $y3A0q.Status).FAILED;
    if (transferStatus === (0, $hmhzd.TransferStatus).SUCCESS) return (0, $y3A0q.Status).SUCCESS;
    if (transferStatus === (0, $hmhzd.TransferStatus).IN_PROGRESS) return (0, $y3A0q.Status).IN_PROGRESS;
    return (0, $y3A0q.Status).READY;
};
const $3eb6aec6bd421b16$var$getStatusForOperation = (containerTransferStatus, operationKey)=>{
    const transfer = containerTransferStatus.transfers?.find((t)=>t.operationKey === operationKey);
    return transfer?.businessStatus ? $3eb6aec6bd421b16$var$transformTranferStatusToStatus(transfer.businessStatus) : (0, $y3A0q.Status).READY;
};
const $3eb6aec6bd421b16$var$getProjectCreateStatus = (containerTransferStatus)=>{
    const jiraImportTransfer = containerTransferStatus.transfers?.find((transfer)=>transfer.operationKey === $3eb6aec6bd421b16$var$JIRA_IMPORT_OPERATION_KEY || transfer.operationKey === $3eb6aec6bd421b16$var$JIRA_IMPORT_V4_OPERATION_KEY);
    if (!jiraImportTransfer) return (0, $y3A0q.Status).READY;
    const createdProjectEntities = $3eb6aec6bd421b16$var$getCreatedJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$PROJECT_ENTITY_KEY);
    const totalProjectEntities = $3eb6aec6bd421b16$var$getTotalJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$PROJECT_ENTITY_KEY);
    const failedProjectEntities = $3eb6aec6bd421b16$var$getFailedJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$PROJECT_ENTITY_KEY);
    if (failedProjectEntities !== 0) return (0, $y3A0q.Status).FAILED;
    if (createdProjectEntities === 0) return (0, $y3A0q.Status).READY;
    if (createdProjectEntities === totalProjectEntities) return (0, $y3A0q.Status).SUCCESS;
    return (0, $y3A0q.Status).IN_PROGRESS;
};
const $3eb6aec6bd421b16$export$ad5f54dfa4c25e4b = (containerTransferStatus)=>({
        dataTransformStatus: $3eb6aec6bd421b16$var$getStatusForOperation(containerTransferStatus, $3eb6aec6bd421b16$var$JIRA_DATA_TRANSFORM_OPERATION_KEY),
        userImportStatus: $3eb6aec6bd421b16$var$getStatusForOperation(containerTransferStatus, $3eb6aec6bd421b16$var$ALL_USER_IMPORT_OPERATION_KEY),
        projectCreateStatus: $3eb6aec6bd421b16$var$getProjectCreateStatus(containerTransferStatus)
    });
const $3eb6aec6bd421b16$var$getProgressForTransfer = (transfer)=>{
    if (transfer.businessStatus === (0, $hmhzd.TransferStatus).SUCCESS) return 1;
    if (transfer.businessStatus === (0, $hmhzd.TransferStatus).READY) return 0;
    if (transfer.progressProperties === undefined || transfer.progressProperties === null) return 0;
    const { createdEntities: createdEntities, totalEntities: totalEntities } = transfer.progressProperties;
    if (createdEntities === undefined || totalEntities === undefined) return 0;
    return createdEntities / totalEntities;
};
const $3eb6aec6bd421b16$var$calculateProgress = (containerTransferStatus)=>{
    let progress = 0;
    containerTransferStatus.transfers?.forEach((transfer)=>{
        const weighting = $3eb6aec6bd421b16$var$PROGRESS_WEIGHTING[transfer.operationKey] || 0;
        progress += $3eb6aec6bd421b16$var$getProgressForTransfer(transfer) * weighting;
    });
    return progress;
};
const $3eb6aec6bd421b16$export$214c69f9b592e736 = (containerTransferStatus)=>{
    if (containerTransferStatus.businessStatus === (0, $hmhzd.TransferStatus).READY) return 0, $lUz5s.INITIAL_MIGRATION_STATUS;
    const issueStats = $3eb6aec6bd421b16$export$37d331774442a79a(containerTransferStatus);
    const detailedProgress = $3eb6aec6bd421b16$export$ad5f54dfa4c25e4b(containerTransferStatus);
    if (containerTransferStatus.businessStatus === (0, $hmhzd.TransferStatus).SUCCESS) return {
        overallProgress: 1,
        overallStatus: (0, $y3A0q.Status).SUCCESS,
        detailedProgress: detailedProgress,
        ...issueStats
    };
    const progress = $3eb6aec6bd421b16$var$calculateProgress(containerTransferStatus);
    if ($3eb6aec6bd421b16$var$isFailedStatus(containerTransferStatus.businessStatus)) {
        const migrationFailedStatus = {
            overallProgress: progress,
            overallStatus: (0, $y3A0q.Status).FAILED,
            detailedProgress: detailedProgress,
            ...issueStats
        };
        return {
            ...migrationFailedStatus,
            hasErrorLogs: containerTransferStatus.hasErrorLogs
        };
    }
    return {
        overallProgress: progress,
        overallStatus: (0, $y3A0q.Status).IN_PROGRESS,
        detailedProgress: detailedProgress,
        ...issueStats
    };
};
const $3eb6aec6bd421b16$export$f146c102d7613638 = (error)=>error?.statusCode === 429 || error?.statusCode === 503 || error?.name === 'NetworkError';
const $3eb6aec6bd421b16$var$waitTimeMs = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $3eb6aec6bd421b16$export$c3c863e65cddb513 = (baseIntervalMs, maxPollingIntervalMs, exponentialBase, retryCount)=>{
    const time = baseIntervalMs * exponentialBase ** retryCount;
    return time > maxPollingIntervalMs ? maxPollingIntervalMs : time;
};
const $3eb6aec6bd421b16$export$20eaa22f2295996f = (callback, baseIntervalMs, maxPollingInterval, exponentialBase, retryCount = 0)=>callback().then((shouldRetry)=>shouldRetry && $3eb6aec6bd421b16$var$waitTimeMs($3eb6aec6bd421b16$export$c3c863e65cddb513(baseIntervalMs, maxPollingInterval, exponentialBase, retryCount)).then(()=>$3eb6aec6bd421b16$export$20eaa22f2295996f(callback, baseIntervalMs, maxPollingInterval, exponentialBase, retryCount + 1)));

});
parcelRegister("hmhzd", function(module, exports) {

$parcel$export(module.exports, "TransferStatus", () => $7f1b77f714ac571e$export$91301ebb6ad45fab);
const $7f1b77f714ac571e$export$7d7a98f44861e6f7 = {
    JIRA_PROJECT: 'JiraProject',
    SITE: 'Site'
};
const $7f1b77f714ac571e$export$91301ebb6ad45fab = {
    READY: 'READY',
    IN_PROGRESS: 'IN_PROGRESS',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
    SKIPPED: 'SKIPPED',
    INCOMPLETE: 'INCOMPLETE',
    CANCELLED: 'CANCELLED'
};

});






parcelRegister("e0kZI", function(module, exports) {

$parcel$export(module.exports, "BoardConnectToolbar", () => $4677f90b43f839a0$export$afbfa45d45a0cda1);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $fjfkx = parcelRequire("fjfkx");

var $fNWqR = parcelRequire("fNWqR");
function $4677f90b43f839a0$var$BoardConnectToolbarInner({ boardId: boardId, projectKey: projectKey, mode: mode }) {
    const toolSections = (0, $fNWqR.useFetchedToolSections)({
        boardId: boardId,
        projectKey: projectKey,
        mode: mode
    });
    if (!toolSections) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjfkx.BoardToolsView), {
        toolSections: toolSections
    });
}
function $4677f90b43f839a0$export$afbfa45d45a0cda1(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "board-connect-toolbar",
        packageName: "@atlassian/jira-software-board-connect-toolbar",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4677f90b43f839a0$var$BoardConnectToolbarInner, props));
}

});

parcelRegister("U0mgX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4ec8a787bc20212$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $5dqGX = parcelRequire("5dqGX");

var $3g1Fk = parcelRequire("3g1Fk");

var $1kVqg = parcelRequire("1kVqg");

var $3bDjY = parcelRequire("3bDjY");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $9OXo1 = parcelRequire("9OXo1");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");


var $8MbKE = parcelRequire("8MbKE");
const $e4ec8a787bc20212$var$getAdditionalFeedbackEntries = ({ isAdmin: isAdmin, isSiteAdmin: isSiteAdmin, projectType: projectType, boardType: boardType, environment: environment, cloudId: cloudId, boardId: boardId, appEdition: appEdition })=>[
        {
            id: (0, $7iULw.EntryKeys).IS_ADMIN,
            value: isAdmin.toString()
        },
        {
            id: (0, $7iULw.EntryKeys).IS_SITE_ADMIN,
            value: isSiteAdmin.toString()
        },
        {
            id: (0, $7iULw.EntryKeys).PROJECT_TYPE,
            value: projectType
        },
        {
            id: (0, $7iULw.EntryKeys).BOARD_TYPE,
            value: boardType
        },
        {
            id: 'ENV',
            value: environment
        },
        {
            id: 'CLOUD_ID',
            value: cloudId
        },
        {
            id: 'BOARD_ID',
            value: boardId
        },
        {
            id: 'JIRA_SOFTWARE_EDITION',
            value: appEdition
        }
    ];
const $e4ec8a787bc20212$var$FeedbackButton = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const projectType = (0, $67sX6.useBoardSelector)((0, $67Z81.projectTypeSelector));
    const isServiceDeskProject = projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
    // Details needed by JSW feedback collector
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin, environment: environment, cloudId: cloudId, appEditions: appEditions } = (0, $9OXo1.useTenantContext)();
    const boardType = (0, $67sX6.useBoardSelector)((0, $67Z81.getBoardTypeForAnalytics));
    const boardId = (0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector));
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const onClick = ()=>openFeedbackCollector({
            entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_PLATFORM),
            feedbackGroupId: isServiceDeskProject ? (0, $30a039470bd29ca5$export$719fab391286fbcd) : (0, $30a039470bd29ca5$export$e34a1c8584d4a8b3),
            feedbackContext: !isServiceDeskProject ? $e4ec8a787bc20212$var$getAdditionalFeedbackEntries({
                isAdmin: isAdmin,
                isSiteAdmin: isSiteAdmin,
                projectType: projectType,
                boardType: boardType,
                environment: environment ?? 'UNKNOWN',
                cloudId: cloudId,
                boardId: boardId,
                appEdition: appEditions.software
            }) : []
        });
    const compactFeedbackButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $8MbKE.default).feedbackButtonLabel),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        onClick: onClick,
        iconBefore: (0, $4R6GH.fg)('tnk-1613-jira-visual-refresh-jsw-board-icons-2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5dqGX))), {
            label: formatMessage((0, $8MbKE.default).feedbackButtonLabel),
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3g1Fk))),
            LEGACY_primaryColor: "var(--ds-icon, #44546F)",
            color: "var(--ds-icon, #44546F)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3g1Fk))), {
            label: formatMessage((0, $8MbKE.default).feedbackButtonLabel),
            primaryColor: "var(--ds-icon, #44546F)"
        }),
        testId: "software-board.header.feedback-collector-button.feedback-button"
    }));
    const fullscreenFeedbackButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        onClick: onClick,
        iconBefore: (0, $4R6GH.fg)('tnk-1613-jira-visual-refresh-jsw-board-icons-2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5dqGX))), {
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3g1Fk))),
            LEGACY_primaryColor: "var(--ds-icon, #44546F)",
            color: "var(--ds-icon, #44546F)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3g1Fk))), {
            label: "",
            primaryColor: "var(--ds-icon, #44546F)"
        }),
        testId: "software-board.header.feedback-collector-button.feedback-button"
    }, formatMessage((0, $8MbKE.default).feedbackButtonLabel));
    if (isServiceDeskProject) return compactFeedbackButton;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        below: "lg"
    }, compactFeedbackButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        above: "lg"
    }, fullscreenFeedbackButton));
};
var $e4ec8a787bc20212$export$2e2bcd8739ae039 = $e4ec8a787bc20212$var$FeedbackButton;

});
const $30a039470bd29ca5$export$719fab391286fbcd = 'jsm.board';
const $30a039470bd29ca5$export$e34a1c8584d4a8b3 = 'jsw.board';

parcelRegister("8MbKE", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc8976dda4abe2f2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bc8976dda4abe2f2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    feedbackButtonLabel: {
        "id": "software.main.header.feedback-collector-button.feedback-button-label",
        "defaultMessage": "Give feedback"
    }
});

});


parcelRegister("hpoCd", function(module, exports) {

$parcel$export(module.exports, "FullscreenButton", () => $381e6d1de1164ff8$export$305be705ce696d42);

var $5uXOq = parcelRequire("5uXOq");

var $99BAr = parcelRequire("99BAr");

var $a4XJc = parcelRequire("a4XJc");

var $iDGXn = parcelRequire("iDGXn");

var $63LqY = parcelRequire("63LqY");
const $381e6d1de1164ff8$var$getFullscreenRefs = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
    Array.from(document.querySelectorAll('[data-fullscreen-id]'));
const $381e6d1de1164ff8$export$305be705ce696d42 = ({ boardId: boardId, shouldRenderContent: shouldRenderContent })=>{
    const { setIsFullscreen: setIsFullscreen } = (0, $iDGXn.useViewSettingsActions)();
    const isFullscreen = (0, $iDGXn.useIsFullscreen)();
    const view = (0, $63LqY.useIsIncrementPlanningBoard)() ? (0, $a4XJc.View).INCREMENT_PLANNING_BOARD : (0, $a4XJc.View).BOARD;
    const handleFullscreenToggle = (0, $5uXOq.useCallback)((wasFullscreen)=>{
        setIsFullscreen({
            boardId: boardId,
            isFullscreen: !wasFullscreen,
            view: view
        });
    }, [
        boardId,
        setIsFullscreen,
        view
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99BAr.default), {
        testId: "software-board.header.fullscreen-button.fullscreen-button",
        getCustomRefs: $381e6d1de1164ff8$var$getFullscreenRefs,
        withContainerStyles: false,
        onToggle: handleFullscreenToggle,
        isFullscreen: isFullscreen,
        shouldRenderContent: shouldRenderContent
    });
};

});

parcelRegister("6OUMO", function(module, exports) {

$parcel$export(module.exports, "Separator", () => $8aeb6a9a658476c8$export$1ff3c3f08ae963c0);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

const $8aeb6a9a658476c8$export$1ff3c3f08ae963c0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8aeb6a9a658476c8$var$separatorStyles
    });
const $8aeb6a9a658476c8$var$separatorStyles = (0, $8CUq3.xcss)({
    height: "var(--ds-space-300, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderRight: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$exports).N40})`}`
});

});

parcelRegister("dNht2", function(module, exports) {

$parcel$export(module.exports, "JswShareButton", () => $9f4c91afe3771d74$export$54c54e47ce207cc8);

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $koVbs = parcelRequire("koVbs");

var $dXq4S = parcelRequire("dXq4S");

var $iL8EU = parcelRequire("iL8EU");

var $5GqLe = parcelRequire("5GqLe");

var $9j8is = parcelRequire("9j8is");

var $koeKL = parcelRequire("koeKL");

var $bdr6Y = parcelRequire("bdr6Y");
const $9f4c91afe3771d74$export$54c54e47ce207cc8 = ({ projectId: projectId, shareContentType: shareContentType, onTriggerButtonClick: onTriggerButtonClick })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { shareIntegrations: shareIntegrations } = (0, $9j8is.useShareIntegrations)('board');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "ccEcoBoardBacklogShare"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iL8EU.default), {
        integrationType: (0, $5GqLe.integrationTypes).CLASSIC_BOARD,
        triggerButtonStyle: "icon-only",
        productId: "jira",
        subProductId: "jira-software",
        shareTitle: formatMessage((0, $bdr6Y.default).shareTitle),
        shareFormTitle: formatMessage((0, $bdr6Y.default).shareFormTitle),
        shareContentType: shareContentType,
        objectAri: (0, $dXq4S.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project',
            resourceId: projectId
        }),
        copyTooltipText: formatMessage((0, $bdr6Y.default).shareTooltipText),
        shareIntegrations: shareIntegrations,
        shareFormHelperMessage: formatMessage((0, $bdr6Y.default).shareHelperMessage),
        onTriggerButtonClick: onTriggerButtonClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        name: "ccEcoBoardBacklogShare"
    })));
};

});
parcelRegister("iL8EU", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $4e5335f44d688bbf$export$5619d05bf511476b);
$parcel$export(module.exports, "default", () => $4e5335f44d688bbf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $jZX0t = parcelRequire("jZX0t");


var $heNNl = parcelRequire("heNNl");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $Kpokz = parcelRequire("Kpokz");
const $4e5335f44d688bbf$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jZX0t))), {
            size: "medium",
            label: formatMessage((0, $Kpokz.messages).shareTriggerButtonText),
            primaryColor: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N30})`
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $Kpokz.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4e5335f44d688bbf$var$ShareButton = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("jHQiG")), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4e5335f44d688bbf$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButton, props)));

});
parcelRegister("jZX0t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e8f17c524b03e26b$var$_react = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $e8f17c524b03e26b$var$_share = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("empdx")));
function $e8f17c524b03e26b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e8f17c524b03e26b$var$ShareIcon = (props)=>/*#__PURE__*/ $e8f17c524b03e26b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $e8f17c524b03e26b$var$_share.default
    }));
$e8f17c524b03e26b$var$ShareIcon.displayName = 'ShareIcon';
var $e8f17c524b03e26b$var$_default = module.exports.default = $e8f17c524b03e26b$var$ShareIcon;

});
parcelRegister("empdx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::530cf6124b77e826fb9d0e1e695d5d78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a746ae65a0e1944c$var$_react = $a746ae65a0e1944c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a746ae65a0e1944c$var$_UNSAFE_baseNew = $a746ae65a0e1944c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a746ae65a0e1944c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a746ae65a0e1944c$var$ShareIcon = (props)=>/*#__PURE__*/ $a746ae65a0e1944c$var$_react.default.createElement($a746ae65a0e1944c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
    }, props));
$a746ae65a0e1944c$var$ShareIcon.displayName = 'ShareIcon';
var $a746ae65a0e1944c$var$_default = module.exports.default = $a746ae65a0e1944c$var$ShareIcon;

});


parcelRegister("Kpokz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $026d1258a1c95d57$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $026d1258a1c95d57$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("jHQiG", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("bfk3F")
]).then(()=>parcelRequire('7aU9g'));

});


parcelRegister("5GqLe", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $0970fea694a8095f$export$a7359bcfb0ca8e98);
const $0970fea694a8095f$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments'
};

});

parcelRegister("9j8is", function(module, exports) {

$parcel$export(module.exports, "useShareIntegrations", () => $d021f3111fd4c646$export$58a9f7a7ab3466f4);

var $5uXOq = parcelRequire("5uXOq");

var $aIZdc = parcelRequire("aIZdc");

var $bCdIp = parcelRequire("bCdIp");

var $pa9q9 = parcelRequire("pa9q9");

var $koeKL = parcelRequire("koeKL");

var $2UEtd = parcelRequire("2UEtd");

var $aMZmw = parcelRequire("aMZmw");
const $d021f3111fd4c646$export$58a9f7a7ab3466f4 = (shareContentType)=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const cloudId = (0, $koeKL.useCloudId)();
    const ineligibilityReasons = (0, $5uXOq.useMemo)(()=>{
        const reasons = [];
        if ((0, $bCdIp.default)()) reasons.push('notDesktop');
        // All Share to Slack must be disabled in FedRAMP environment as
        // Slack Jira Integration app is not available in FedRAMP
        if ((0, $aIZdc.isFedRamp)()) reasons.push('isFedRAMP');
        return reasons;
    }, []);
    const shareIntegrations = (0, $5uXOq.useMemo)(()=>ineligibilityReasons.length === 0 ? [
            {
                type: 'Slack',
                Icon: (0, $aMZmw.default),
                Content: ({ onClose: onClose, changeTab: changeTab })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2UEtd.ShareToSlack), {
                        showFlag: showFlag,
                        product: "jira",
                        channel: "productAnalytics",
                        onClose: onClose,
                        cloudId: cloudId,
                        changeTab: changeTab,
                        shareContentType: shareContentType
                    })
            }
        ] : [], [
        ineligibilityReasons.length,
        showFlag,
        cloudId,
        shareContentType
    ]);
    return {
        shareIntegrations: shareIntegrations
    };
};

});
parcelRegister("2UEtd", function(module, exports) {

$parcel$export(module.exports, "ShareToSlack", () => $168b88234834bfea$export$2cc56764fd9edb21);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");

var $ldfcP = parcelRequire("ldfcP");

const $168b88234834bfea$export$2cc56764fd9edb21 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "async-share-to-slack",
        packageName: "integrations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-to-slack",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldfcP.StyledShareToSlackLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldfcP.StyledShareToSlack), props)));

});
parcelRegister("ldfcP", function(module, exports) {

$parcel$export(module.exports, "StyledShareToSlack", () => $d8ff40467b89e314$export$9aeb6210c91511b9);
$parcel$export(module.exports, "StyledShareToSlackLoader", () => $d8ff40467b89e314$export$d3f97cc63e3ee02);
/* styled.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");

var $3xc3R = parcelRequire("3xc3R");
const $d8ff40467b89e314$export$9aeb6210c91511b9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $3xc3R.LazyShareToSlack), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s8ax2b",
            __cmplp.className
        ])
    });
});
const $d8ff40467b89e314$export$d3f97cc63e3ee02 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $eZJjh.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3xc3R", function(module, exports) {

$parcel$export(module.exports, "LazyShareToSlack", () => $0733f18014b5074d$export$24281652e6b89b3b);

var $kxZPA = parcelRequire("kxZPA");

const $0733f18014b5074d$export$24281652e6b89b3b = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("3MPjw")), {
    ssr: false,
    moduleId: "../platform/packages/growth/integrations/src/share-to-slack/ui/index.tsx"
});

});
parcelRegister("3MPjw", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("mbt92")
]).then(()=>parcelRequire('2B8HF'));

});




parcelRegister("aMZmw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1ef732ae0096135$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a1ef732ae0096135$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7.50403 13.8563C7.50403 14.727 6.79278 15.4382 5.92212 15.4382C5.05146 15.4382 4.34021 14.727 4.34021 13.8563C4.34021 12.9857 5.05146 12.2744 5.92212 12.2744H7.50403V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M8.30115 13.8563C8.30115 12.9857 9.0124 12.2744 9.88307 12.2744C10.7537 12.2744 11.465 12.9857 11.465 13.8563V17.8172C11.465 18.6879 10.7537 19.3991 9.88307 19.3991C9.0124 19.3991 8.30115 18.6879 8.30115 17.8172V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M9.88307 7.50415C9.0124 7.50415 8.30115 6.79291 8.30115 5.92224C8.30115 5.05158 9.0124 4.34033 9.88307 4.34033C10.7537 4.34033 11.465 5.05158 11.465 5.92224V7.50415H9.88307Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M9.88304 8.30127C10.7537 8.30127 11.465 9.01251 11.465 9.88317C11.465 10.7538 10.7537 11.4651 9.88304 11.4651H5.92212C5.05146 11.4651 4.34021 10.7538 4.34021 9.88317C4.34021 9.01251 5.05146 8.30127 5.92212 8.30127H9.88304Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16.2354 9.88317C16.2354 9.01251 16.9466 8.30127 17.8172 8.30127C18.6879 8.30127 19.3991 9.01251 19.3991 9.88317C19.3991 10.7538 18.6879 11.4651 17.8172 11.4651H16.2354V9.88317Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M15.4381 9.88316C15.4381 10.7538 14.7269 11.4651 13.8562 11.4651C12.9855 11.4651 12.2743 10.7538 12.2743 9.88316V5.92225C12.2743 5.05158 12.9855 4.34033 13.8562 4.34033C14.7269 4.34033 15.4381 5.05158 15.4381 5.92225V9.88316Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13.8562 16.2354C14.7269 16.2354 15.4381 16.9466 15.4381 17.8172C15.4381 18.6879 14.7269 19.3991 13.8562 19.3991C12.9855 19.3991 12.2743 18.6879 12.2743 17.8172V16.2354H13.8562Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13.8562 15.4382C12.9855 15.4382 12.2743 14.727 12.2743 13.8563C12.2743 12.9857 12.9855 12.2744 13.8562 12.2744H17.8171C18.6878 12.2744 19.399 12.9857 19.399 13.8563C19.399 14.727 18.6878 15.4382 17.8171 15.4382H13.8562Z",
        fill: "#ECB22E"
    }));

});


parcelRegister("bdr6Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $35ed0bdfd14f71ae$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $35ed0bdfd14f71ae$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    shareTitle: {
        "id": "software.main.header.share-button.share-title",
        "defaultMessage": "Board"
    },
    shareFormTitle: {
        "id": "software.main.header.share-button.share-form-title",
        "defaultMessage": "Share"
    },
    shareTooltipText: {
        "id": "software.main.header.share-button.share-tooltip-text",
        "defaultMessage": "Embed this link in other Atlassian products such as Confluence"
    },
    shareHelperMessage: {
        "id": "software.main.header.share-button.share-helper-message",
        "defaultMessage": "This view, along with any applied groups and filters are shared"
    }
});

});


parcelRegister("7Zg4V", function(module, exports) {

$parcel$export(module.exports, "SprintDetailsButton", () => $3b80e396624f0689$export$b264f9dec3a284a5);

var $5uXOq = parcelRequire("5uXOq");

var $67sX6 = parcelRequire("67sX6");

var $ebHh7 = parcelRequire("ebHh7");

var $kQIxA = parcelRequire("kQIxA");
const $3b80e396624f0689$export$b264f9dec3a284a5 = ()=>{
    const selectedSprints = (0, $67sX6.useBoardSelector)((0, $ebHh7.getSelectedOrAllSprintsSelector));
    const activeSprints = (0, $67sX6.useBoardSelector)((0, $ebHh7.activeSprintsSelector));
    if (!activeSprints?.length) // can happen because our parent uses "hasActiveSprints" selector
    // which doesn't check if the array is empty (as of 2024/09)
    return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kQIxA.default), {
        activeSprints: activeSprints,
        selectedSprints: selectedSprints
    });
};

});
parcelRegister("kQIxA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5be944c29dbca8a4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1I7E8 = parcelRequire("1I7E8");

var $8L2oS = parcelRequire("8L2oS");

var $lbeD3 = parcelRequire("lbeD3");

var $bAl3b = parcelRequire("bAl3b");
function $5be944c29dbca8a4$var$SprintDetails(props) {
    const { activeSprints: activeSprints, selectedSprints: selectedSprints } = props;
    const [isOpen, togglePopup, closePopup] = (0, $8L2oS.usePopupController)();
    const renderPopupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>{
        function onClick() {
            // TODO BLU-4236 analytics
            togglePopup();
        }
        // the function is coming from useCallback() so it's not less stable than the caller
        // eslint-disable-next-line react/jsx-no-bind
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bAl3b.default), {
            ...triggerProps,
            isSelected: isOpen,
            onClick: onClick
        });
    }, [
        isOpen,
        togglePopup
    ]);
    const renderPopupContent = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lbeD3.default), {
            selectedSprints: selectedSprints,
            activeSprintCount: activeSprints.length
        });
    }, [
        selectedSprints,
        activeSprints
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: isOpen,
        onClose: closePopup,
        placement: "bottom-end",
        content: renderPopupContent,
        trigger: renderPopupTrigger
    });
}
var $5be944c29dbca8a4$export$2e2bcd8739ae039 = $5be944c29dbca8a4$var$SprintDetails;

});
parcelRegister("8L2oS", function(module, exports) {

$parcel$export(module.exports, "usePopupController", () => $2f9ec79b1227b61c$export$55fb67b4e2c495d8);

var $5uXOq = parcelRequire("5uXOq");
const $2f9ec79b1227b61c$export$55fb67b4e2c495d8 = (defaultState = false)=>{
    // TODO one day useBoolean https://hello.atlassian.net/wiki/spaces/JFP/blog/2024/09/01/4131392637/PSA+Write+less+code+-+useBoolean+hook
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultState);
    const togglePopup = (0, $5uXOq.useCallback)(()=>{
        setIsOpen((pendingIsOpen)=>!pendingIsOpen);
    }, [
        setIsOpen
    ]);
    const closePopup = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    return [
        isOpen,
        togglePopup,
        closePopup
    ];
};

});

parcelRegister("lbeD3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f8b7922ef61dda0$export$2e2bcd8739ae039);
/** Popup with active sprint details
 * spec: https://www.figma.com/design/YnMz1EvyBCySecvWX4FvHC/%F0%9F%A7%AD-%5BSpork%5D-Jira-navigation-refresh---Components-%26-patterns?node-id=11291-21447&node-type=FRAME&t=76M0RECVACsXpZVQ-0
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $jovBr = parcelRequire("jovBr");

var $7jns1 = parcelRequire("7jns1");

var $dC5iT = parcelRequire("dC5iT");
var $bgrar = parcelRequire("bgrar");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $1p96B = parcelRequire("1p96B");

var $leRCk = parcelRequire("leRCk");


var $j7XWQ = parcelRequire("j7XWQ");
const $5f8b7922ef61dda0$var$MS_IN_HOURS = 3600000;
const $5f8b7922ef61dda0$var$PopupContent = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { selectedSprints: selectedSprints, activeSprintCount: activeSprintCount = selectedSprints.length } = props;
    // TODO BLU-4236 empty state if no sprints https://atlassian.design/components/empty-state/examples
    // should never happen but it's cheap and resilient to add it
    const stackElements = [];
    if (activeSprintCount > 1) stackElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        key: "selectionIndicator",
        size: "small",
        weight: "bold",
        color: "color.text.subtlest"
    }, formatMessage((0, $j7XWQ.default).sprintSelection, {
        selectedCount: selectedSprints.length,
        totalCount: activeSprintCount
    })));
    if (selectedSprints.length === 1) stackElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f8b7922ef61dda0$export$2019f0e05924df02, {
        key: "singleSprint",
        sprint: selectedSprints[0]
    }));
    else stackElements.push(...selectedSprints.map((sprint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f8b7922ef61dda0$export$95842b7ac79e8187, {
            key: sprint.id,
            sprint: sprint
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.200",
        xcss: $5f8b7922ef61dda0$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, stackElements));
};
var $5f8b7922ef61dda0$export$2e2bcd8739ae039 = $5f8b7922ef61dda0$var$PopupContent;
function $5f8b7922ef61dda0$export$2019f0e05924df02({ sprint: sprint }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "article"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f8b7922ef61dda0$var$TitleDetailsStack, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "strong",
        maxLines: 1
    }, sprint.name), sprint.goal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        maxLines: 2
    }, sprint.goal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f8b7922ef61dda0$export$76ca2692cceeb7eb, {
        sprint: sprint
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f8b7922ef61dda0$export$ac179a0be748f2bb, {
        sprint: sprint
    })));
}
function $5f8b7922ef61dda0$export$95842b7ac79e8187({ sprint: sprint }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "article"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f8b7922ef61dda0$var$TitleDetailsStack, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "strong",
        maxLines: 1
    }, sprint.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f8b7922ef61dda0$export$76ca2692cceeb7eb, {
        sprint: sprint,
        color: "color.text.subtlest"
    }))));
}
function $5f8b7922ef61dda0$export$76ca2692cceeb7eb({ sprint: sprint, color: color = 'color.text' }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: color
    }, formatMessage((0, $j7XWQ.default).remainingDays, {
        remainingDays: sprint.daysRemaining
    })));
}
function $5f8b7922ef61dda0$export$ac179a0be748f2bb({ sprint: sprint }) {
    const { formatMessage: formatMessage, locale: locale } = (0, $koVbs.default)();
    const [{ data: loggedInUser }] = (0, $leRCk.useUserSubscriber)();
    // TODO BLU-4236 grid should be tighter
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgrar.default), {
        templateColumns: "1fr 1fr",
        gap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f8b7922ef61dda0$var$TitleDetailsStack, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        weight: "bold",
        color: "color.text.subtlest"
    }, formatMessage((0, $j7XWQ.default).startDate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, $5f8b7922ef61dda0$var$formatSprintDate({
        sprintDate: sprint.startDate,
        currentTimezone: loggedInUser?.timeZone,
        locale: locale,
        formatMessage: formatMessage
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f8b7922ef61dda0$var$TitleDetailsStack, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        weight: "bold",
        color: "color.text.subtlest"
    }, formatMessage((0, $j7XWQ.default).endDate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, $5f8b7922ef61dda0$var$formatSprintDate({
        sprintDate: sprint.endDate,
        currentTimezone: loggedInUser?.timeZone,
        locale: locale,
        formatMessage: formatMessage
    }))));
}
const $5f8b7922ef61dda0$var$TitleDetailsStack = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, children);
};
function $5f8b7922ef61dda0$var$formatSprintDate({ sprintDate: sprintDate, currentTimezone: currentTimezone, locale: locale, formatMessage: formatMessage }) {
    if (!sprintDate) // should never happen since we're dealing with active sprints
    // which get dates auto-assigned on start.
    // this test is for appeasing Typescript
    return '';
    // we're doing fancy date manipulation above, not worth blowing up the whole screen, so let's be resilient
    try {
        const utcOffsetInHours = Math.floor((0, $7jns1.default)(currentTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone || 'utc') / $5f8b7922ef61dda0$var$MS_IN_HOURS);
        const dateObject = (0, $1p96B.setNumberOffsetToISODate)(sprintDate, utcOffsetInHours);
        if (!(0, $jovBr.default)(dateObject)) {
            // should never happen, but some tests use invalid dates such as "yesterday"
            if (typeof sprintDate === 'string') return sprintDate; // better than nothing
            return formatMessage((0, $j7XWQ.default).invalidDate);
        }
        return (0, $1p96B.formatWithLocale)(dateObject, (0, $dcbb2bce513725b3$export$ad42fdc358b8c597), locale);
    } catch  {
        return formatMessage((0, $j7XWQ.default).invalidDate);
    }
}
const $5f8b7922ef61dda0$var$containerStyles = (0, $8CUq3.xcss)({
    width: '280px',
    maxBlockSize: '340px',
    // 5 sprints summary = no scroll, >5 = scroll
    overflowBlock: 'auto'
});

});
parcelRegister("j7XWQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $299b8da8af1dbb56$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $299b8da8af1dbb56$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sprintSelection: {
        "id": "software.main.header.sprint-controls.sprint-details.popup-content.sprint-selection",
        "defaultMessage": "{totalCount, plural, one {Sprints {selectedCount} of {totalCount}} other {Sprints {selectedCount} of {totalCount}}}"
    },
    remainingDays: {
        "id": "software.main.header.sprint-controls.sprint-details.popup-content.remaining-days",
        "defaultMessage": "{remainingDays} {remainingDays, plural, one {day} other {days}} left"
    },
    startDate: {
        "id": "software.main.header.sprint-controls.sprint-details.popup-content.start-date",
        "defaultMessage": "Start date"
    },
    endDate: {
        "id": "software.main.header.sprint-controls.sprint-details.popup-content.end-date",
        "defaultMessage": "End date"
    },
    invalidDate: {
        "id": "software.main.header.sprint-controls.sprint-details.popup-content.invalid-date",
        "defaultMessage": "Invalid date"
    }
});

});


parcelRegister("bAl3b", function(module, exports) {

$parcel$export(module.exports, "default", () => $b563359b2bdc6c83$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $iyo13 = parcelRequire("iyo13");

var $koVbs = parcelRequire("koVbs");

var $eisBO = parcelRequire("eisBO");
const $b563359b2bdc6c83$var$TOOLTIP_OPTIONS = {
    hideTooltipOnClick: true
};
const $b563359b2bdc6c83$var$SprintDetailsTriggerButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)((extraProps, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iyo13))),
        label: formatMessage((0, $eisBO.default).tooltip),
        isTooltipDisabled: false,
        tooltip: $b563359b2bdc6c83$var$TOOLTIP_OPTIONS,
        ...extraProps
    });
});
var $b563359b2bdc6c83$export$2e2bcd8739ae039 = $b563359b2bdc6c83$var$SprintDetailsTriggerButton;

});
parcelRegister("eisBO", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ff7454a1278e17$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f0ff7454a1278e17$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "software.main.header.sprint-controls.sprint-details.trigger-button.tooltip",
        "defaultMessage": "Sprint details"
    }
});

});




parcelRegister("58Nil", function(module, exports) {

$parcel$export(module.exports, "SprintGoal", () => $188cf19b94d308c9$export$c6e24e98bd6ba09c);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");
const $188cf19b94d308c9$export$c6e24e98bd6ba09c = ({ goal: goal })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: goal,
        position: "bottom-end"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($188cf19b94d308c9$var$SprintGoalContent, {
            tabIndex: 0,
            "aria-label": goal,
            ...tooltipProps
        }, goal));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $188cf19b94d308c9$var$SprintGoalContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bto1l2s _o5721q9c _1reo15vq _18m915vq _syaz131l _11c8qk37 _19pkv77o _otyrv77o _1bsb1ns9 _p12f1osq",
            __cmplp.className
        ])
    });
});

});



parcelRegister("eqAt8", function(module, exports) {

$parcel$export(module.exports, "default", () => $42f28e1393d0787c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $42f28e1393d0787c$var$AfterPaintPrefetchIssues = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("iJ2a2")), {
    ssr: false,
    moduleId: "./src/packages/software/board/src/view/prefetch-issues/index.tsx"
});
const $42f28e1393d0787c$export$2552ea6166f76129 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "async.software-board.prfetch-issues",
        packageName: "jiraSoftwareBoardPrefetchIssues"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "prefetch-issues",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42f28e1393d0787c$var$AfterPaintPrefetchIssues, null)));
var $42f28e1393d0787c$export$2e2bcd8739ae039 = $42f28e1393d0787c$export$2552ea6166f76129;

});
parcelRegister("iJ2a2", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("iJXQ5").then(()=>parcelRequire('92Qej'));

});


parcelRegister("jFKZt", function(module, exports) {

$parcel$export(module.exports, "default", () => $981a733f2c308762$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $8QpSo = parcelRequire("8QpSo");

var $bC2fB = parcelRequire("bC2fB");

var $dd8Xx = parcelRequire("dd8Xx");


var $5fK3R = parcelRequire("5fK3R");

var $d315K = parcelRequire("d315K");

var $8yiLS = parcelRequire("8yiLS");

var $irkFn = parcelRequire("irkFn");

var $67Z81 = parcelRequire("67Z81");
const $981a733f2c308762$var$mapStateToProps = (state)=>({
        cloudId: (0, $67Z81.cloudIdSelector)(state),
        projectId: (0, $67Z81.projectIdSelector)(state),
        boardId: (0, $67Z81.rapidViewIdSelector)(state),
        channels: (0, $irkFn.realtimeChannelSelector)(state),
        currentUserId: (0, $67Z81.currentUserAccountIdSelector)(state),
        // If custom filters is active on this board, we actually need to listen to the granular
        // issue create and issue update events since BSI updated event does not give us enough
        // context
        isCustomFiltersActive: (0, $8yiLS.isCustomFiltersActive)(state),
        isCMPBoard: (0, $67Z81.getIsCMPBoard)(state)
    });
const $981a733f2c308762$var$mapDispatchToProps = {
    createRealtimeEventAction: (0, $d315K.dispatchRealtimeEvent)
};
const $981a733f2c308762$var$onReceiveFactory = (0, $8QpSo.default)((createRealtimeEventAction)=>(event)=>{
        if (event) createRealtimeEventAction(event);
    });
const $981a733f2c308762$export$9d1611c77c2fe928 = (stateProps, dispatchProps)=>{
    let events = (0, $5fK3R.REALTIME_EVENTS); // issue events
    // If the FF is enabled for listening to BSI updated, we also need to determine if we need to
    // still listen to some of the old events specifically for custom filters
    if (!stateProps.isCMPBoard) events = stateProps.isCustomFiltersActive ? (0, $5fK3R.REALTIME_EVENTS_WITH_BSI // BSI + issue create + issue updated
    ) : (0, $5fK3R.BOARD_SCOPE_ISSUES_UPDATED_EVENT); // just BSI
    return {
        appId: (0, $dcbb2bce513725b3$export$d76071d5de2774fc),
        channels: stateProps.channels,
        events: // The board scope issues updated event is designed to replace all of the individual events and is produced by
        // barbel whenever it sees a SPRINT or issue specific change
        events,
        onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onReceive: $981a733f2c308762$var$onReceiveFactory(dispatchProps.createRealtimeEventAction),
        onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    };
};
var $981a733f2c308762$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($981a733f2c308762$var$mapStateToProps, $981a733f2c308762$var$mapDispatchToProps, $981a733f2c308762$export$9d1611c77c2fe928)((0, $dd8Xx.default));

});
parcelRegister("dd8Xx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a980bab3107478f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $b32lf = parcelRequire("b32lf");

var $jiRmc = parcelRequire("jiRmc");
class $9a980bab3107478f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onReceive: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    render() {
        const { appId: appId, events: events, onJoin: onJoin, onLeave: onLeave, channels: channels } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jiRmc.RealtimeProvider), {
            appId: appId,
            onJoin: onJoin,
            onLeave: onLeave,
            channels: channels
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b32lf.RealtimeClient), {
            events: events,
            onReceive: this.onEventReceive
        }));
    }
    constructor(...args){
        super(...args);
        this.onEventReceive = (eventType, payload)=>{
            const event = {
                type: eventType,
                payload: payload
            };
            this.props.onReceive(event);
        };
    }
}

});
parcelRegister("b32lf", function(module, exports) {

$parcel$export(module.exports, "RealtimeClient", () => $89de761bbc8dc49a$export$e680ceb7b9fcc184);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $2OMDV = parcelRequire("2OMDV");

var $50Ssb = parcelRequire("50Ssb");

var $iwG6l = parcelRequire("iwG6l");
// eslint-disable-next-line jira/react/no-class-components
class $89de761bbc8dc49a$var$RealtimeClientView extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            children: null
        };
    }
    componentDidMount() {
        this.subscribeToPropEvents();
    }
    componentDidUpdate(prevProps) {
        if (this.props.client !== prevProps.client || this.props.events !== prevProps.events) {
            const removedEvents = prevProps.events.filter((prevEvent)=>!this.props.events.includes(prevEvent));
            removedEvents.forEach(this.unSubscribeToEvent);
            this.subscribeToPropEvents();
        }
    }
    componentWillUnmount() {
        this.unsubscribeToPropEvents();
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.onReceiveEvent = (event, payload)=>{
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            this.props.onReceive(event, payload);
        };
        this.subscribeToEvent = (eventName)=>{
            this.props.client?.on(eventName, this.onReceiveEvent);
        };
        this.unSubscribeToEvent = (eventName)=>{
            this.props.client?.off(eventName, this.onReceiveEvent);
        };
        this.subscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.subscribeToEvent);
        };
        this.unsubscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.unSubscribeToEvent);
        };
    }
}
const $89de761bbc8dc49a$var$withAnalytics = (0, $2OMDV.AnalyticsEventToProps)('realtimeClient', {
    onReceive: 'eventReceived'
});
const $89de761bbc8dc49a$export$e680ceb7b9fcc184 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))($89de761bbc8dc49a$var$withAnalytics, (0, $iwG6l.withPubSubClient), (0, $50Ssb.asClientOnly))($89de761bbc8dc49a$var$RealtimeClientView);
var $89de761bbc8dc49a$export$2e2bcd8739ae039 = $89de761bbc8dc49a$export$e680ceb7b9fcc184;

});
parcelRegister("50Ssb", function(module, exports) {

$parcel$export(module.exports, "asClientOnly", () => $ccf1df230f4f0e4b$export$95cd02374de3431);

var $5uXOq = parcelRequire("5uXOq");
function $ccf1df230f4f0e4b$export$95cd02374de3431(WrappedComponent) {
    return (props)=>{
        if (false) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props);
    };
}
var $ccf1df230f4f0e4b$export$2e2bcd8739ae039 = $ccf1df230f4f0e4b$export$95cd02374de3431;

});

parcelRegister("iwG6l", function(module, exports) {

$parcel$export(module.exports, "withPubSubClient", () => $9fb4f4e8a5d3670b$export$32d968d4900ae3cd);

var $5uXOq = parcelRequire("5uXOq");

var $bYYrF = parcelRequire("bYYrF");
function $9fb4f4e8a5d3670b$export$32d968d4900ae3cd(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYYrF.Consumer), null, ({ client: client })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                client: client
            }));
}
var $9fb4f4e8a5d3670b$export$2e2bcd8739ae039 = $9fb4f4e8a5d3670b$export$32d968d4900ae3cd;

});
parcelRegister("bYYrF", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $9398e66c20b16e31$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $9398e66c20b16e31$export$b3bffd4bb7da6b8f);

var $5uXOq = parcelRequire("5uXOq");
const $9398e66c20b16e31$var$defaultContext = {
    client: null
};
const { Provider: $9398e66c20b16e31$export$2881499e37b75b9a, Consumer: $9398e66c20b16e31$export$b3bffd4bb7da6b8f } = /*#__PURE__*/ (0, $5uXOq.createContext)($9398e66c20b16e31$var$defaultContext);

});



parcelRegister("jiRmc", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $db014a952af56f77$export$64d242981d970821);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $dJl1T = parcelRequire("dJl1T");

var $2OMDV = parcelRequire("2OMDV");

var $fjcgS = parcelRequire("fjcgS");


var $bYYrF = parcelRequire("bYYrF");

var $1eGpy = parcelRequire("1eGpy");

var $FPIEb = parcelRequire("FPIEb");

const $db014a952af56f77$var$createPubSubClient = (host, analyticsClient)=>(parcelRequire("gXdhU")).then((module)=>{
        const Client = module.default;
        return new Client({
            product: (0, $dd367d66c147872b$export$13ac40d1a5475532),
            url: `${host}`,
            apsProtocol: {
                enabled: true
            },
            analyticsClient: analyticsClient
        });
    });
const $db014a952af56f77$export$c127c26e30518ed5 = (appId, client, channels, onHandler)=>client.join(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $dJl1T.default).safeErrorWithoutCustomerData('realtime.channel.join.failure', `Failed to join channel @ ${appId}`, error);
    });
const $db014a952af56f77$export$e6c41c8aa28ddeb9 = (appId, client, channels, onHandler)=>client.leave(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $dJl1T.default).safeErrorWithoutCustomerData('realtime.channel.leave.failure', `Failed to left channel @ ${appId}`, error);
    });
// eslint-disable-next-line jira/react/no-class-components
class $db014a952af56f77$var$RealtimeProviderView extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            host: (0, $dd367d66c147872b$export$92ffb25149c24a33),
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    componentDidMount() {
        const { appId: appId, host: host, channels: channels } = this.props;
        this.isComponentMounted = true;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((analyticsClient)=>$db014a952af56f77$var$createPubSubClient(host, analyticsClient.getInstance())).then((pubSubClient)=>$db014a952af56f77$export$c127c26e30518ed5(appId, pubSubClient, channels, this.onJoinChannel).then(()=>{
                if (this.isComponentMounted) this.setState({
                    client: pubSubClient
                });
            }));
    }
    componentDidUpdate({ channels: prevChannels }) {
        const { appId: appId, channels: newChannels } = this.props;
        const { client: client } = this.state;
        if (client && newChannels !== prevChannels) {
            const removedChannels = prevChannels.filter((channel)=>!newChannels.includes(channel));
            $db014a952af56f77$export$e6c41c8aa28ddeb9(appId, client, removedChannels, this.onLeaveChannel);
            $db014a952af56f77$export$c127c26e30518ed5(appId, client, newChannels, this.onJoinChannel);
        }
    }
    componentWillUnmount() {
        const { appId: appId, channels: channels } = this.props;
        const { client: client } = this.state;
        this.isComponentMounted = false;
        if (client) $db014a952af56f77$export$e6c41c8aa28ddeb9(appId, client, channels, this.onLeaveChannel);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYYrF.Provider), {
            value: {
                client: this.state.client
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            client: null
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onJoinChannel = (result)=>{
            const { onJoin: onJoin } = this.props;
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onJoin(Array.from(result.currentChannels));
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onLeaveChannel = (result)=>{
            const { onLeave: onLeave } = this.props;
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onLeave(Array.from(result.currentChannels));
        };
        this.isComponentMounted = false;
    }
}
const $db014a952af56f77$var$withAnalytics = (0, $2OMDV.AnalyticsEventToProps)('realtimeProvider', {
    onJoin: 'joinedChannel',
    onLeave: 'leftChannel'
});
const $db014a952af56f77$export$64d242981d970821 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))($db014a952af56f77$var$withAnalytics, (0, $1eGpy.withHost), (0, $FPIEb.withRuntimeProvider))($db014a952af56f77$var$RealtimeProviderView);
var $db014a952af56f77$export$2e2bcd8739ae039 = $db014a952af56f77$export$64d242981d970821;

});
const $dd367d66c147872b$export$92ffb25149c24a33 = '/gateway/api/pubsub';
const $dd367d66c147872b$export$13ac40d1a5475532 = 'JIRA';

parcelRegister("1eGpy", function(module, exports) {

$parcel$export(module.exports, "withHost", () => $af5e53f160713d44$export$b2d89aaea1461cd9);

var $5uXOq = parcelRequire("5uXOq");

var $4h0Jz = parcelRequire("4h0Jz");
function $af5e53f160713d44$export$b2d89aaea1461cd9(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            host: (0, $4h0Jz.getDefaultPubSubHost)()
        });
}
var $af5e53f160713d44$export$2e2bcd8739ae039 = $af5e53f160713d44$export$b2d89aaea1461cd9;

});
parcelRegister("4h0Jz", function(module, exports) {

$parcel$export(module.exports, "getDefaultPubSubHost", () => $15272668181566a5$export$f795b2d9ba365882);
$parcel$export(module.exports, "buildChannelString", () => $15272668181566a5$export$354e43de513ff5);

var $j8DrX = parcelRequire("j8DrX");

const $15272668181566a5$export$f795b2d9ba365882 = ()=>(0, $j8DrX.default)('ajs-fabric-realtime-url') || (0, $dd367d66c147872b$export$92ffb25149c24a33);
const $15272668181566a5$export$354e43de513ff5 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;

});


parcelRegister("FPIEb", function(module, exports) {

$parcel$export(module.exports, "withRuntimeProvider", () => $5962bf1fe62742cb$export$4b38d0b01368c3f4);

var $5uXOq = parcelRequire("5uXOq");
function $5962bf1fe62742cb$export$4b38d0b01368c3f4(WrappedComponent) {
    return (props)=>{
        if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props);
    };
}
var $5962bf1fe62742cb$export$2e2bcd8739ae039 = $5962bf1fe62742cb$export$4b38d0b01368c3f4;

});

parcelRegister("gXdhU", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("8c9ac")
]).then(()=>parcelRequire('9uh43'));

});



parcelRegister("5fK3R", function(module, exports) {

$parcel$export(module.exports, "REALTIME_EVENTS", () => $f9587590828c909c$export$a45e758f2a5806e6);
$parcel$export(module.exports, "REALTIME_EVENTS_WITH_BSI", () => $f9587590828c909c$export$6294460c3b78650e);
$parcel$export(module.exports, "BOARD_SCOPE_ISSUES_UPDATED_EVENT", () => $f9587590828c909c$export$94c8ec37f7a855a9);

const $f9587590828c909c$export$a45e758f2a5806e6 = [
    (0, $09d938f04e8899c4$export$86d416e8d15777d),
    (0, $09d938f04e8899c4$export$b22a14d5dac59664),
    (0, $09d938f04e8899c4$export$25fa37e5059c5a99),
    (0, $09d938f04e8899c4$export$d9bc8850eeef9f60),
    (0, $09d938f04e8899c4$export$b22142e61b3fdbee)
];
const $f9587590828c909c$export$6294460c3b78650e = [
    (0, $09d938f04e8899c4$export$b22a14d5dac59664),
    (0, $09d938f04e8899c4$export$b22142e61b3fdbee),
    (0, $09d938f04e8899c4$export$6024bd0c20931af3)
];
const $f9587590828c909c$export$94c8ec37f7a855a9 = [
    (0, $09d938f04e8899c4$export$6024bd0c20931af3)
];

});

parcelRegister("irkFn", function(module, exports) {

$parcel$export(module.exports, "realtimeChannelSelector", () => $136c021b0909277e$export$5a1e23dccf0fc573);

var $dGvGJ = parcelRequire("dGvGJ");

var $67Z81 = parcelRequire("67Z81");
const $136c021b0909277e$export$5a1e23dccf0fc573 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssueProjectIds),
    (0, $67Z81.cloudIdSelector)
], (projectIds, cloudId)=>projectIds.map((projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`));

});


parcelRegister("i9WnN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6415380cdd366f97$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ /* eslint-disable jira/deprecations/no-base-url */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $34ck9 = parcelRequire("34ck9");

var $41Tr4 = parcelRequire("41Tr4");

var $7gWdR = parcelRequire("7gWdR");


var $gJlZe = parcelRequire("gJlZe");

var $5ZW09 = parcelRequire("5ZW09");

var $hP2lu = parcelRequire("hP2lu");

var $44v1T = parcelRequire("44v1T");

var $x9xyg = parcelRequire("x9xyg");

var $gSExi = parcelRequire("gSExi");

var $7Q2kM = parcelRequire("7Q2kM");

var $iepkZ = parcelRequire("iepkZ");

var $4mO32 = parcelRequire("4mO32");

var $heNNl = parcelRequire("heNNl");

var $6s1PB = parcelRequire("6s1PB");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $hkiaF = parcelRequire("hkiaF");

var $axmY8 = parcelRequire("axmY8");

var $02beV = parcelRequire("02beV");

var $22vqd = parcelRequire("22vqd");

var $2gCtH = parcelRequire("2gCtH");

var $b052x = parcelRequire("b052x");

var $3HwlS = parcelRequire("3HwlS");

var $lfTZh = parcelRequire("lfTZh");

var $jqUpd = parcelRequire("jqUpd");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $f7Y15 = parcelRequire("f7Y15");

var $6awMq = parcelRequire("6awMq");

var $7LEyz = parcelRequire("7LEyz");

var $5fQw9 = parcelRequire("5fQw9");

var $9hLEH = parcelRequire("9hLEH");

var $jQ7vZ = parcelRequire("jQ7vZ");

var $4bO80 = parcelRequire("4bO80");

var $5E2gE = parcelRequire("5E2gE");

var $3U6yu = parcelRequire("3U6yu");

var $baPf2 = parcelRequire("baPf2");

var $2xFXk = parcelRequire("2xFXk");


var $8TCLJ = parcelRequire("8TCLJ");

var $7V9GI = parcelRequire("7V9GI");

var $gKBVc = parcelRequire("gKBVc");

var $4wbGn = parcelRequire("4wbGn");

var $gUmfi = parcelRequire("gUmfi");

var $iUagi = parcelRequire("iUagi");



var $7mkyN = parcelRequire("7mkyN");

var $67sX6 = parcelRequire("67sX6");

var $2f454 = parcelRequire("2f454");

var $dnW4F = parcelRequire("dnW4F");

var $dW1HX = parcelRequire("dW1HX");

var $2ON1s = parcelRequire("2ON1s");

var $6g14V = parcelRequire("6g14V");

var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");

var $bxz0l = parcelRequire("bxz0l");

var $8R2g1 = parcelRequire("8R2g1");
const $6415380cdd366f97$var$IssueLinksHandlerContainer = ({ children: children, onIssueOpen: onIssueOpen, isGlobal: isGlobal })=>{
    if (onIssueOpen && isGlobal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b052x.IssueLinksHandlerContainer), {
        onIssueOpen: onIssueOpen,
        isGlobal: isGlobal
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $6415380cdd366f97$var$usePpsSurveyEvent = (isReady)=>{
    const dontSendServeyEvent = (0, $5uXOq.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [selectedIssue] = (0, $jQ7vZ.useQueryParam)('selectedIssue');
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isReady || dontSendServeyEvent.current) return;
         // we only want this to run once
        dontSendServeyEvent.current = true;
        if (selectedIssue) // we are only interested in board view without issue selected
        return;
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'ppsSurvey ready', {
            experience: 'board',
            experienceType: isCMPBoard ? 'cmp' : 'tmp'
        });
    }, [
        isReady,
        isCMPBoard,
        createAnalyticsEvent,
        selectedIssue,
        dontSendServeyEvent
    ]);
};
const $6415380cdd366f97$export$27a5bd065ad55220 = (props)=>{
    const { isCacheHit: isCacheHit, hasModals: hasModals = true, hasFlags: hasFlags = true, rapidViewId: rapidViewId, estimationStatistic: estimationStatistic, DocumentTitle: DocumentTitle, Header: Header, Modals: Modals, Flags: Flags, ViewTracker: ViewTracker, xsrfToken: xsrfToken, PrefetchIssues: PrefetchIssues, Realtime: Realtime, baseUrl: baseUrl, AddBoardToHistory: AddBoardToHistory, projectKey: projectKey, GlobalSearchTracker: GlobalSearchTracker, hasMinimap: hasMinimap = true, isInsightsPanelOpen: isInsightsPanelOpen, Board: Board, DetailView: DetailView, customFiltersQueryRef: customFiltersQueryRef, projectId: projectId, currentUserAccountId: currentUserAccountId, issueLimitExceeded: issueLimitExceeded, savedFilterId: savedFilterId, selectedSprintsOrAllSprints: selectedSprintsOrAllSprints } = props;
    const { onExperienceSuccess: onExperienceSuccess } = props;
    const [width, setWidth] = (0, $5uXOq.useState)(0);
    const throttledSetWidth = (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(setWidth, 50);
    const viewMode = (0, $2gCtH.useViewMode)();
    const isDetailViewSidebar = viewMode === 'SIDEBAR';
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const canEditBoard = (0, $63LqY.useCanEditBoard)();
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const columnDropIndicatorContainerRef = (0, $5uXOq.useRef)(null);
    const isViewSettingPanelOpen = (0, $67sX6.useBoardSelector)((0, $6g14V.getViewSettingsPanel));
    const shouldShowAdminInaccessibleBoard = (0, $hP2lu.useShouldShowAdminInaccessibleBoard)((0, $f7Y15.uifBoardResource));
    const isJSWBoard = (0, $63LqY.useIsJSWBoard)(); // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbedView = (0, $4R6GH.fg)('jira_board_smartlink_embed') ? (0, $gKBVc.useIsEmbedView)() : false;
    const [isActiveStandup, setIsActiveStandup] = (0, $8TCLJ.useActiveStandup)();
    const shouldShowStandupPanel = isActiveStandup && !isIncrementPlanningBoard && isJSWBoard && (0, $6s1PB.expVal)('jira-in-product-standups', 'is_enabled', false);
    const issueCount = (0, $67sX6.useBoardSelector)((0, $67Z81.getIssueCount));
    const shouldShowIssueLimitFlags = (0, $63LqY.useCapability)((0, $2xFXk.Capability).SHOW_ISSUE_LIMIT_FLAGS);
    const isTabNavigation = (0, $63LqY.useCapability)((0, $2xFXk.Capability).IS_TAB_NAVIGATION);
    const [selectedIssue] = (0, $jQ7vZ.useQueryParam)('selectedIssue');
    const assignees = (0, $67sX6.useBoardSelector)((0, $36pz7.getPeople));
    const setAssigneeFilter = (0, $5uXOq.useCallback)((id)=>dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$f8f7545d2bb78afb), id ? [
            id
        ] : [])), [
        dispatch
    ]);
    const currentlyFilteredAssignee = (0, $67sX6.useBoardSelector)((state)=>state.ui.workFilters?.values?.ASSIGNEE?.[0] || null); // This change is added because on this branch there's no router resource
    const isLoaded = (0, $67sX6.useBoardSelector)((state)=>{
        return !state.configuration.isCMPBoard || (0, $5mTgl.isBoardConfigLoaded)(state);
    });
    const wrapperHeightOffset = isIncrementPlanningBoard ? `(${0, $44v1T.PAGE_LAYOUT_OFFSET_TOP} + ${0, $7e733a5d4e4331fc$export$85243b761a28eea7})` : (0, $44v1T.PAGE_LAYOUT_OFFSET_TOP); // Consolidate all of program board empty states into a hook
    const programBoardEmptyStates = (0, $gUmfi.useProgramBoardEmptyStates)(`calc(100vh - ${wrapperHeightOffset})`);
    $6415380cdd366f97$var$usePpsSurveyEvent(isLoaded);
    (0, $5uXOq.useEffect)(()=>{
        onExperienceSuccess(); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body?.classList.add('spb');
        (0, $x9xyg.setMark)((0, $dcbb2bce513725b3$export$e3639dbf0033629d));
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.body?.classList.remove('spb');
        };
    }, [
        onExperienceSuccess
    ]);
    (0, $5uXOq.useEffect)(()=>(0, $7gWdR.monitorForElements)({
            onDragStart: ({ location: location })=>{
                (0, $41Tr4.autoScroller).start({
                    input: location.current.input
                });
            },
            onDrop: ()=>{
                (0, $41Tr4.autoScroller).stop();
            },
            onDrag: ({ location: location })=>{
                (0, $41Tr4.autoScroller).updateInput({
                    input: location.current.input
                });
            }
        }), []);
    (0, $7V9GI.useGICSidebarForcer)();
    (0, $4wbGn.useOpenTeamAssociationModal)();
    const entryPointResult = (0, $4mO32.useEntryPoint)((0, $jqUpd.planIssueModal), {});
    const onIssueOpen = (0, $5uXOq.useCallback)((issueId, issueKey)=>{
        if (isDetailViewSidebar) {
            dispatch((0, $2ON1s.closeInsightsPanel)());
            (0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() && dispatch((0, $2ON1s.closeViewSettingsPanel)());
        } /**
       * If the issueKey is present, then the open modal action can be called directly.
       * used by Next Best Task to show issues that are not on the board.
       */ 
        if (issueKey) dispatch((0, $dW1HX.openIssueModal)(issueKey));
        else dispatch((0, $2f454.cardClick)(issueId, false, false));
    }, [
        dispatch,
        isDetailViewSidebar
    ]); // Only render the program board empty states if it's not null
    if (programBoardEmptyStates) return programBoardEmptyStates;
     // Show a message to admin users if the board is inaccessible due to filter permissions and how to update it
    if (shouldShowAdminInaccessibleBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ZW09.AsyncAdminInaccessibleBoard), {
        rapidViewId: rapidViewId,
        skeleton: (0, $6awMq.NextGenBoardSkeleton)
    });
     // TODO FEBO-357 Fix when skeleton appears
    if (!isLoaded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6awMq.NextGenBoardSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8R2g1.CmpBoardSlaTracker), null));
    const renderBoardSizeLimitEmptyState = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7LEyz.default), {
            projectKey: projectKey,
            isCMPBoard: isCMPBoard,
            savedFilterId: savedFilterId
        });
    const renderBoard = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6415380cdd366f97$var$SizeDetectorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gJlZe.WidthObserver), {
            setWidth: throttledSetWidth
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6415380cdd366f97$var$BoardArea, {
            "data-test-id": "software-board.board-area",
            "data-testid": "software-board.board-area"
        }, shouldShowStandupPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bO80.AsyncJiraStandups), {
            boardId: Number(rapidViewId),
            setIsActiveStandup: setIsActiveStandup,
            assignees: assignees,
            setAssigneeFilter: setAssigneeFilter,
            currentlyFilteredAssignee: currentlyFilteredAssignee
        }), Board && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Board, {
            hasMinimap: hasMinimap,
            isCacheHit: isCacheHit
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
            packageName: "jiraDevelopmentDetailsLoader",
            id: "devDetailsDialogLoader",
            extraEventData: {
                teamName: 'fusion-isotopes'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Q2kM.DevDetailsDialogLoaderAsync), {
            scopeId: "software-board.board"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bxz0l.ForceRecalculateSubscribers), null)), !isIncrementPlanningBoard && (isDetailViewSidebar || isInsightsPanelOpen || (0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() && isViewSettingPanelOpen) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DetailView, {
            isDetailViewSidebar: isDetailViewSidebar,
            isInsightsPanelOpen: isInsightsPanelOpen,
            xsrfToken: xsrfToken,
            rapidViewId: rapidViewId,
            parentWidth: width,
            projectId: projectId,
            estimationStatistic: estimationStatistic
        })));
    const boardContents = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isCMPBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8R2g1.CmpBoardSlaTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(GlobalSearchTracker, null), !isIncrementPlanningBoard && DocumentTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DocumentTitle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $02beV.NextBestTaskContainer), {
            accountId: currentUserAccountId,
            boardId: rapidViewId,
            isCMPBoard: isCMPBoard,
            sprints: selectedSprintsOrAllSprints,
            onIssueOpen: onIssueOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkiaF.UserPropertiesContainer), {
            scope: (0, $axmY8.NEXT_BEST_TASK_USER_PROPERTIES_SCOPE),
            accountId: currentUserAccountId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6415380cdd366f97$var$IssueLinksHandlerContainer, {
            onIssueOpen: onIssueOpen,
            isGlobal: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22vqd.ViewSettingsSpotlightContainer), {
            shouldShowSpotlight: (!selectedIssue || isDetailViewSidebar) && isJSWBoard
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5E2gE.StandupEntryPointContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6415380cdd366f97$var$ViewWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3U6yu.StorageLimitsBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $baPf2.UpFlowPersistentUpgradeBanner), {
            isBannerEnabled: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, {
            customFiltersQueryRef: customFiltersQueryRef,
            isEmbedView: isEmbedView,
            isActiveStandup: isActiveStandup,
            setIsActiveStandup: setIsActiveStandup
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6415380cdd366f97$var$ColumnDropIndicatorContainer, {
            ref: columnDropIndicatorContainerRef
        }), issueLimitExceeded ? renderBoardSizeLimitEmptyState() : renderBoard())))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PrefetchIssues, null), ViewTracker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ViewTracker, null), hasFlags && Flags && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Flags, null), hasModals && Modals && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
            id: "async-board-modals",
            packageName: "software-board"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "board-modals",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Modals, {
            rapidViewId: rapidViewId,
            xsrfToken: xsrfToken
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AddBoardToHistory, {
            baseUrl: baseUrl,
            boardId: rapidViewId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Realtime, null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6415380cdd366f97$var$Wrapper, {
        height: (0, $3HwlS.getWillShowNav4)() ? '100%' : `calc(100vh - ${wrapperHeightOffset})`,
        "data-test-id": "software-board.board",
        "data-testid": "software-board.board"
    }, isIncrementPlanningBoard && (0, $4R6GH.fg)('issue_view_in_program_board') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7mkyN.PlanModalEntrypointContext).Provider, {
        value: entryPointResult
    }, boardContents()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, boardContents())), shouldShowIssueLimitFlags && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5fQw9.default), {
        boardId: rapidViewId,
        isCMP: isCMPBoard,
        isProjectAdmin: canEditBoard,
        projectKey: projectKey,
        views: [
            {
                view: 'BOARD',
                issueCount: issueCount
            }
        ]
    }), !isTabNavigation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9hLEH.default), {
        boardId: rapidViewId,
        projectKey: projectKey,
        isCMPBoard: isCMPBoard
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iepkZ.AsyncLaunchToolchainSpotlight), {
        projectId: projectId,
        projectKey: projectKey
    }));
};
var $6415380cdd366f97$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
 = $6415380cdd366f97$export$27a5bd065ad55220;
const $6415380cdd366f97$var$WrapperControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-3vwzo1-0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        overflow: 'hidden',
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-surface, ${(0, $829f609a65d26a98$exports).N0})`,
        display: 'flex'
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6415380cdd366f97$var$WrapperExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1474 _1reo15vq _18m915vq _vchhusvi _11q7vuon _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $6415380cdd366f97$var$Wrapper = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $6415380cdd366f97$var$WrapperExperiment, $6415380cdd366f97$var$WrapperControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6415380cdd366f97$var$ViewWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _vchhusvi _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6415380cdd366f97$var$BoardArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6415380cdd366f97$var$SizeDetectorWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _c71l1osq _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6415380cdd366f97$var$ColumnDropIndicatorContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _4t3iidpf _1bsb1osq _18s8zdiv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("41Tr4", function(module, exports) {

$parcel$export(module.exports, "createAutoScroller", () => $109b883638d1460e$export$fbda4b72e803ec38);
$parcel$export(module.exports, "autoScroller", () => $109b883638d1460e$export$d19940cfc7560cd8);

var $bKki5 = parcelRequire("bKki5");
const $109b883638d1460e$var$scrollElement = (element, change)=>{
    element.scrollBy(change.x, change.y);
};
const $109b883638d1460e$var$scrollWindow = (change)=>{
    window.scrollBy(change.x, change.y);
};
const $109b883638d1460e$export$fbda4b72e803ec38 = ()=>{
    let dragging = null;
    function tryScroll(fakeScrollCallback) {
        if (dragging == null) return;
        (0, $bKki5.scroll)({
            input: dragging.latestInput,
            dragStartTime: dragging.dragStartTime,
            shouldUseTimeDampening: dragging.shouldUseTimeDampening,
            behavior: dragging.behavior,
            scrollElement: fakeScrollCallback ?? $109b883638d1460e$var$scrollElement,
            scrollWindow: fakeScrollCallback ?? $109b883638d1460e$var$scrollWindow
        });
    }
    // Every animation frame use the latest user input to scroll
    // We do this loop manually rather than in response to `onDrag`
    // events as `onDrag` can drop to 50-100ms between events when
    // the user is not actively moving their pointer
    function loop() {
        if (!dragging) return;
        dragging.loopFrameId = requestAnimationFrame(()=>{
            tryScroll();
            loop();
        });
    }
    const start = ({ input: input, behavior: behavior = 'window-then-container' })=>{
        const dragStartTime = Date.now();
        dragging = {
            dragStartTime: dragStartTime,
            latestInput: input,
            loopFrameId: null,
            shouldUseTimeDampening: false,
            behavior: behavior
        };
        // we only use time dampening when auto scrolling starts on lift.
        const fakeScrollCallback = ()=>{
            if (dragging) dragging.shouldUseTimeDampening = true;
        };
        tryScroll(fakeScrollCallback);
        loop();
    };
    function updateInput({ input: input }) {
        if (!dragging) return;
        dragging.latestInput = input;
    }
    const stop = ()=>{
        // can be called defensively
        if (!dragging) return;
        if (dragging.loopFrameId) cancelAnimationFrame(dragging.loopFrameId);
        dragging = null;
    };
    return {
        start: start,
        updateInput: updateInput,
        stop: stop
    };
};
const $109b883638d1460e$export$d19940cfc7560cd8 = $109b883638d1460e$export$fbda4b72e803ec38();

});
parcelRegister("bKki5", function(module, exports) {

$parcel$export(module.exports, "scroll", () => $fa05b34874c18386$export$209876d7b1ac8f3);
parcelRequire("i6e0j");
var $kKgsQ = parcelRequire("kKgsQ");

var $8IFZn = parcelRequire("8IFZn");

var $cd0ri = parcelRequire("cd0ri");

var $bUPhs = parcelRequire("bUPhs");

var $2tkrf = parcelRequire("2tkrf");

var $lVsVC = parcelRequire("lVsVC");
const $fa05b34874c18386$export$209876d7b1ac8f3 = ({ input: input, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, scrollElement: scrollElement, scrollWindow: scrollWindow, behavior: behavior })=>{
    const tryScrollWindow = ()=>{
        const viewport = (0, $lVsVC.default)();
        const windowScrollChange = (0, $2tkrf.default)({
            dragStartTime: dragStartTime,
            viewport: viewport,
            center: {
                x: input.clientX + viewport.scroll.current.x,
                y: input.clientY + viewport.scroll.current.y
            },
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (windowScrollChange) {
            scrollWindow(windowScrollChange);
            return true;
        }
        return false;
    };
    const tryScrollContainer = ()=>{
        const over = (0, $kKgsQ.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        });
        const closestScrollable = (0, $8IFZn.getClosestScrollableElement)(over);
        if (!closestScrollable) return false;
        const scrollable = (0, $cd0ri.getScrollable)({
            closestScrollable: closestScrollable
        });
        const scrollableScrollChange = (0, $bUPhs.default)({
            dragStartTime: dragStartTime,
            scrollable: scrollable,
            center: {
                x: input.clientX,
                y: input.clientY
            },
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (scrollableScrollChange) {
            scrollElement(closestScrollable, scrollableScrollChange);
            return true;
        }
        return false;
    };
    if (behavior === 'container-only') tryScrollContainer();
    if (behavior === 'window-only') tryScrollWindow();
    if (behavior === 'container-then-window') tryScrollContainer() || tryScrollWindow();
    if (behavior === 'window-then-container') tryScrollWindow() || tryScrollContainer();
};

});
parcelRegister("i6e0j", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("kKgsQ")).getElementFromPointWithoutHoneypot);

var $kKgsQ = parcelRequire("kKgsQ");

});

parcelRegister("8IFZn", function(module, exports) {

$parcel$export(module.exports, "getClosestScrollableElement", () => $d89049a655de884c$export$f39f407dd5a0ebdb);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $d89049a655de884c$var$isEqual = (base)=>(value)=>base === value;
const $d89049a655de884c$var$isScroll = $d89049a655de884c$var$isEqual('scroll');
const $d89049a655de884c$var$isAuto = $d89049a655de884c$var$isEqual('auto');
const $d89049a655de884c$var$isEither = (overflow, fn)=>fn(overflow.overflowX) || fn(overflow.overflowY);
const $d89049a655de884c$var$isElementScrollable = (el)=>{
    const style = window.getComputedStyle(el);
    const overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $d89049a655de884c$var$isEither(overflow, $d89049a655de884c$var$isScroll) || $d89049a655de884c$var$isEither(overflow, $d89049a655de884c$var$isAuto);
};
const $d89049a655de884c$export$f39f407dd5a0ebdb = (el)=>{
    // cannot do anything else!
    if (!el) return null;
    // not allowing us to go higher then body
    if (el === document.body || el === document.documentElement) return null;
    if (!$d89049a655de884c$var$isElementScrollable(el)) // keep recursing
    return $d89049a655de884c$export$f39f407dd5a0ebdb(el.parentElement);
    // success!
    return el;
};

});

parcelRegister("cd0ri", function(module, exports) {

$parcel$export(module.exports, "getScrollable", () => $3bb4723f24ee5351$export$9b7238c949d126e9);

var $3YKxB = parcelRequire("3YKxB");
const $3bb4723f24ee5351$export$9b7238c949d126e9 = ({ closestScrollable: closestScrollable })=>{
    const rect = closestScrollable.getBoundingClientRect();
    const scrollPosition = {
        x: closestScrollable.scrollLeft,
        y: closestScrollable.scrollTop
    };
    return {
        container: (0, $3YKxB.getRect)(rect),
        scroll: {
            current: scrollPosition,
            max: {
                x: closestScrollable.scrollWidth - closestScrollable.clientWidth,
                y: closestScrollable.scrollHeight - closestScrollable.clientHeight
            }
        }
    };
};

});
parcelRegister("3YKxB", function(module, exports) {

$parcel$export(module.exports, "getRect", () => $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe);
$parcel$export(module.exports, "expand", () => $2e5b13c1f6ee9f8a$export$9f77e0932fb78f72);
$parcel$export(module.exports, "createBox", () => $2e5b13c1f6ee9f8a$export$6459fc9e86be362e);
$parcel$export(module.exports, "offset", () => $2e5b13c1f6ee9f8a$export$cc800923e997bb8);
$parcel$export(module.exports, "withScroll", () => $2e5b13c1f6ee9f8a$export$1d0caec378d7d0ae);
$parcel$export(module.exports, "calculateBox", () => $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1);
$parcel$export(module.exports, "getBox", () => $2e5b13c1f6ee9f8a$export$34928e660d2a8702);

var $3joPi = parcelRequire("3joPi");
var $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $2e5b13c1f6ee9f8a$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $2e5b13c1f6ee9f8a$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $2e5b13c1f6ee9f8a$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $2e5b13c1f6ee9f8a$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $2e5b13c1f6ee9f8a$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$padding;
    var marginBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $2e5b13c1f6ee9f8a$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $3joPi.default)(false);
    return result;
};
var $2e5b13c1f6ee9f8a$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $2e5b13c1f6ee9f8a$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $2e5b13c1f6ee9f8a$var$shift(borderBox, change);
    return $2e5b13c1f6ee9f8a$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $2e5b13c1f6ee9f8a$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $2e5b13c1f6ee9f8a$var$getWindowScroll();
    return $2e5b13c1f6ee9f8a$export$cc800923e997bb8(original, scroll);
};
var $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.marginTop),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.marginRight),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.marginBottom),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.paddingTop),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.paddingRight),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.paddingBottom),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.borderTopWidth),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.borderRightWidth),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.borderBottomWidth),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.borderLeftWidth)
    };
    return $2e5b13c1f6ee9f8a$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $2e5b13c1f6ee9f8a$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1(borderBox, styles);
};

});


parcelRegister("bUPhs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac1c10c5ae151830$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $g2R1U = parcelRequire("g2R1U");

var $elgbz = parcelRequire("elgbz");
var $ac1c10c5ae151830$export$2e2bcd8739ae039 = ({ scrollable: scrollable, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $elgbz.default)({
        dragStartTime: dragStartTime,
        container: scrollable.container,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && (0, $g2R1U.canScrollScrollable)(scrollable, scroll) ? scroll : null;
};

});
parcelRegister("g2R1U", function(module, exports) {

$parcel$export(module.exports, "canScrollWindow", () => $e4b7c0460454dc35$export$cbd1e6fd5e887f10);
$parcel$export(module.exports, "canScrollScrollable", () => $e4b7c0460454dc35$export$57c21b61d76c9819);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $72Pcv = parcelRequire("72Pcv");
const $e4b7c0460454dc35$var$smallestSigned = (0, $72Pcv.apply)((value)=>{
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
const $e4b7c0460454dc35$export$6b13012b06f8f95b = (()=>{
    const getRemainder = (target, max)=>{
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return ({ current: current, max: max, change: change })=>{
        const targetScroll = (0, $72Pcv.add)(current, change);
        const overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ((0, $72Pcv.isEqual)(overlap, (0, $72Pcv.origin))) return null;
        return overlap;
    };
})();
const $e4b7c0460454dc35$export$dbc3ad6130556cf6 = ({ max: rawMax, current: current, change: change })=>{
    // It is possible for the max scroll to be greater than the current scroll
    // when there are scrollbars on the cross axis. We adjust for this by
    // increasing the max scroll point if needed
    // This will allow movements backwards even if the current scroll is greater than the max scroll
    const max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    // Only need to be able to move the smallest amount in the desired direction
    const smallestChange = $e4b7c0460454dc35$var$smallestSigned(change);
    const overlap = $e4b7c0460454dc35$export$6b13012b06f8f95b({
        max: max,
        current: current,
        change: smallestChange
    });
    // no overlap at all - we can move there!
    if (!overlap) return true;
    // if there was an x value, but there is no x overlap - then we can scroll on the x!
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    // if there was an y value, but there is no y overlap - then we can scroll on the y!
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
const $e4b7c0460454dc35$export$cbd1e6fd5e887f10 = (viewport, change)=>$e4b7c0460454dc35$export$dbc3ad6130556cf6({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
const $e4b7c0460454dc35$export$2f1f3b9e315c6096 = (viewport, change)=>{
    if (!$e4b7c0460454dc35$export$cbd1e6fd5e887f10(viewport, change)) return null;
    const max = viewport.scroll.max;
    const current = viewport.scroll.current;
    return $e4b7c0460454dc35$export$6b13012b06f8f95b({
        current: current,
        max: max,
        change: change
    });
};
const $e4b7c0460454dc35$export$57c21b61d76c9819 = (scrollable, change)=>{
    return $e4b7c0460454dc35$export$dbc3ad6130556cf6({
        current: scrollable.scroll.current,
        max: scrollable.scroll.max,
        change: change
    });
};
const $e4b7c0460454dc35$export$d88a6b2979421049 = (scrollable, change)=>{
    if (!$e4b7c0460454dc35$export$57c21b61d76c9819(scrollable, change)) return null;
    return $e4b7c0460454dc35$export$6b13012b06f8f95b({
        current: scrollable.scroll.current,
        max: scrollable.scroll.max,
        change: change
    });
};

});
parcelRegister("72Pcv", function(module, exports) {

$parcel$export(module.exports, "origin", () => $6ab9ddd38a038691$export$f710a83a91838a36);
$parcel$export(module.exports, "apply", () => $6ab9ddd38a038691$export$5635d7ef4b8fee1c);
$parcel$export(module.exports, "isEqual", () => $6ab9ddd38a038691$export$248d38f6296296c5);
$parcel$export(module.exports, "add", () => $6ab9ddd38a038691$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $6ab9ddd38a038691$export$4e2d2ead65e5f7e3);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $6ab9ddd38a038691$export$f710a83a91838a36 = {
    x: 0,
    y: 0
};
const $6ab9ddd38a038691$export$5635d7ef4b8fee1c = (fn)=>(point)=>({
            x: fn(point.x),
            y: fn(point.y)
        });
const $6ab9ddd38a038691$export$248d38f6296296c5 = (point1, point2)=>point1.x === point2.x && point1.y === point2.y;
const $6ab9ddd38a038691$export$e16d8520af44a096 = (point1, point2)=>({
        x: point1.x + point2.x,
        y: point1.y + point2.y
    });
const $6ab9ddd38a038691$export$4e2d2ead65e5f7e3 = (point1, point2)=>({
        x: point1.x - point2.x,
        y: point1.y - point2.y
    });

});


parcelRegister("elgbz", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bd53a776b729d8f$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $8x8E3 = parcelRequire("8x8E3");

var $72Pcv = parcelRequire("72Pcv");

var $3hu7o = parcelRequire("3hu7o");
// will replace -0 and replace with +0
const $7bd53a776b729d8f$var$clean = (0, $72Pcv.apply)((value)=>value === 0 ? 0 : value);
var $7bd53a776b729d8f$export$2e2bcd8739ae039 = ({ dragStartTime: dragStartTime, container: container, center: center, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    // get distance to each edge
    const distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    // 1. Figure out which x,y values are the best target
    // 2. Can the container scroll in that direction at all?
    // If no for both directions, then return null
    // 3. Is the center close enough to a edge to start a drag?
    // 4. Based on the distance, calculate the speed at which a scroll should occur
    // The lower distance value the faster the scroll should be.
    // Maximum speed value should be hit before the distance is 0
    // Negative values to not continue to increase the speed
    const y = (0, $3hu7o.default)({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: (0, $8x8E3.vertical),
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    const x = (0, $3hu7o.default)({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: (0, $8x8E3.horizontal),
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    const required = $7bd53a776b729d8f$var$clean({
        x: x,
        y: y
    });
    // nothing required
    if ((0, $72Pcv.isEqual)(required, (0, $72Pcv.origin))) return null;
    return required;
};

});
parcelRegister("8x8E3", function(module, exports) {

$parcel$export(module.exports, "minScroll", () => $bf32c7b0b1170f48$export$67e2de1e1e796844);
$parcel$export(module.exports, "vertical", () => $bf32c7b0b1170f48$export$32f8a6eb41d46820);
$parcel$export(module.exports, "horizontal", () => $bf32c7b0b1170f48$export$641ecd0b2bc39508);
const $bf32c7b0b1170f48$export$67e2de1e1e796844 = 1;
const $bf32c7b0b1170f48$export$32f8a6eb41d46820 = {
    direction: 'vertical',
    start: 'top',
    end: 'bottom',
    size: 'height',
    scrollAxis: 'scrollTop'
};
const $bf32c7b0b1170f48$export$641ecd0b2bc39508 = {
    direction: 'horizontal',
    start: 'left',
    end: 'right',
    size: 'width',
    scrollAxis: 'scrollLeft'
};
const $bf32c7b0b1170f48$export$1a8fc111f6979e7a = [
    $bf32c7b0b1170f48$export$641ecd0b2bc39508.direction,
    $bf32c7b0b1170f48$export$32f8a6eb41d46820.direction
];

});

parcelRegister("3hu7o", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9df84024ef20482$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $TN11L = parcelRequire("TN11L");

var $h91se = parcelRequire("h91se");
var $a9df84024ef20482$export$2e2bcd8739ae039 = ({ container: container, distanceToEdges: distanceToEdges, dragStartTime: dragStartTime, axis: axis, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const thresholds = (0, $TN11L.default)(container, axis);
    const isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return (0, $h91se.default)({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * (0, $h91se.default)({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};

});
parcelRegister("TN11L", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3b60bb9d8221ac4$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $2gHPS = parcelRequire("2gHPS");
const $e3b60bb9d8221ac4$export$79446fee27934459 = (container, axis)=>{
    const startScrollingFrom = container[axis.size] * (0, $2gHPS.default).startFromPercentage;
    const maxScrollValueAt = container[axis.size] * (0, $2gHPS.default).maxScrollAtPercentage;
    const thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $e3b60bb9d8221ac4$export$2e2bcd8739ae039 = $e3b60bb9d8221ac4$export$79446fee27934459;

});
parcelRegister("2gHPS", function(module, exports) {

$parcel$export(module.exports, "default", () => $372e7e4331f931a5$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd
// Values used to control how the fluid auto scroll feels
const $372e7e4331f931a5$var$config = {
    // percentage distance from edge of container:
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    // pixels per frame
    maxPixelScroll: 28,
    // A function used to ease a percentage value
    // A simple linear function would be: (percentage) => percentage;
    // percentage is between 0 and 1
    // result must be between 0 and 1
    ease: (percentage)=>Math.pow(percentage, 2),
    durationDampening: {
        // ms: how long to dampen the speed of an auto scroll from the start of a drag
        stopDampeningAt: 1200,
        // ms: when to start accelerating the reduction of duration dampening
        accelerateAt: 360
    }
};
var $372e7e4331f931a5$export$2e2bcd8739ae039 = $372e7e4331f931a5$var$config;

});


parcelRegister("h91se", function(module, exports) {

$parcel$export(module.exports, "default", () => $46ce8abe6474bdaa$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $8x8E3 = parcelRequire("8x8E3");

var $edWdS = parcelRequire("edWdS");

var $7vxL6 = parcelRequire("7vxL6");
const $46ce8abe6474bdaa$export$bf7199a9ebcb84a9 = ({ distanceToEdge: distanceToEdge, thresholds: thresholds, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $7vxL6.getValueFromDistance)(distanceToEdge, thresholds);
    // not enough distance to trigger a minimum scroll
    // we can bail here
    if (scroll === 0) return 0;
    // Dampen an auto scroll speed based on duration of drag
    if (!shouldUseTimeDampening) return scroll;
    // Once we know an auto scroll should occur based on distance,
    // we must let at least 1px through to trigger a scroll event an
    // another auto scroll call
    return Math.max((0, $edWdS.dampenValueByTime)(scroll, dragStartTime), (0, $8x8E3.minScroll));
};
var $46ce8abe6474bdaa$export$2e2bcd8739ae039 = $46ce8abe6474bdaa$export$bf7199a9ebcb84a9;

});
parcelRegister("edWdS", function(module, exports) {

$parcel$export(module.exports, "dampenValueByTime", () => $b46522d5c480b17a$export$2fe468ff7a999ed6);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $2gHPS = parcelRequire("2gHPS");

var $8x8E3 = parcelRequire("8x8E3");

var $5yDwA = parcelRequire("5yDwA");
const $b46522d5c480b17a$var$accelerateAt = (0, $2gHPS.default).durationDampening.accelerateAt;
const $b46522d5c480b17a$var$stopAt = (0, $2gHPS.default).durationDampening.stopDampeningAt;
const $b46522d5c480b17a$export$2fe468ff7a999ed6 = (proposedScroll, dragStartTime)=>{
    const startOfRange = dragStartTime;
    const endOfRange = $b46522d5c480b17a$var$stopAt;
    const now = Date.now();
    const runTime = now - startOfRange;
    // we have finished the time dampening period
    if (runTime >= $b46522d5c480b17a$var$stopAt) return proposedScroll;
    // Up to this point we know there is a proposed scroll
    // but we have not reached our accelerate point
    // Return the minimum amount of scroll
    if (runTime < $b46522d5c480b17a$var$accelerateAt) return 0, $8x8E3.minScroll;
    const betweenAccelerateAtAndStopAtPercentage = (0, $5yDwA.getPercentage)({
        startOfRange: $b46522d5c480b17a$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    const scroll = proposedScroll * (0, $2gHPS.default).ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};

});
parcelRegister("5yDwA", function(module, exports) {

$parcel$export(module.exports, "getPercentage", () => $9599504fdea7da9c$export$6712e0f6cd0ea03);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $9599504fdea7da9c$export$6712e0f6cd0ea03 = ({ startOfRange: startOfRange, endOfRange: endOfRange, current: current })=>{
    const range = endOfRange - startOfRange;
    if (range === 0) /**
		 * Detected distance range of 0 in the auto scroller
		 * This is unexpected and would cause a divide by 0 issue.
		 * Not allowing an auto scroll
		 */ return 0;
    const currentInRange = current - startOfRange;
    const percentage = currentInRange / range;
    return percentage;
};

});


parcelRegister("7vxL6", function(module, exports) {

$parcel$export(module.exports, "getValueFromDistance", () => $fa6f09f36cc6d31c$export$f3e495573a199c91);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $2gHPS = parcelRequire("2gHPS");

var $8x8E3 = parcelRequire("8x8E3");

var $5yDwA = parcelRequire("5yDwA");
const $fa6f09f36cc6d31c$export$f3e495573a199c91 = (distanceToEdge, thresholds)=>{
    /*
  // This function only looks at the distance to one edge
  // Example: looking at bottom edge
  |----------------------------------|
  |                                  |
  |                                  |
  |                                  |
  |                                  |
  |                                  | => no scroll in this range
  |                                  |
  |                                  |
  |  startScrollingFrom (eg 100px)   |
  |                                  |
  |                                  | => increased scroll value the closer to maxScrollValueAt
  |  maxScrollValueAt (eg 10px)      |
  |                                  | => max scroll value in this range
  |----------------------------------|
  */ // too far away to auto scroll
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    // use max speed when on or over boundary
    if (distanceToEdge <= thresholds.maxScrollValueAt) return (0, $2gHPS.default).maxPixelScroll;
    // when just going on the boundary return the minimum integer
    if (distanceToEdge === thresholds.startScrollingFrom) return 0, $8x8E3.minScroll;
    // to get the % past startScrollingFrom we will calculate
    // the % the value is from maxScrollValueAt and then invert it
    const percentageFromMaxScrollValueAt = (0, $5yDwA.getPercentage)({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    const percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    const scroll = (0, $2gHPS.default).maxPixelScroll * (0, $2gHPS.default).ease(percentageFromStartScrollingFrom);
    // scroll will always be a positive integer
    return Math.ceil(scroll);
};

});





parcelRegister("2tkrf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d272222f271a432a$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $g2R1U = parcelRequire("g2R1U");

var $elgbz = parcelRequire("elgbz");
var $d272222f271a432a$export$2e2bcd8739ae039 = ({ viewport: viewport, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $elgbz.default)({
        dragStartTime: dragStartTime,
        container: viewport.container,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && (0, $g2R1U.canScrollWindow)(viewport, scroll) ? scroll : null;
};

});

parcelRegister("lVsVC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3afd8185a3fe1873$export$2e2bcd8739ae039);

var $3YKxB = parcelRequire("3YKxB");

var $bsp0B = parcelRequire("bsp0B");

var $feNdz = parcelRequire("feNdz");
var $3afd8185a3fe1873$export$2e2bcd8739ae039 = ()=>{
    const scroll = (0, $feNdz.default)();
    const maxScroll = (0, $bsp0B.default)();
    const top = scroll.y;
    const left = scroll.x;
    // window.innerHeight: includes scrollbars (not what we want)
    // document.clientHeight gives us the correct value when using the html5 doctype
    const doc = document.documentElement;
    // Using these values as they do not consider scrollbars
    // padding box, without scrollbar
    const width = doc.clientWidth;
    const height = doc.clientHeight;
    // Computed
    const right = left + width;
    const bottom = top + height;
    const container = (0, $3YKxB.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    const viewport = {
        container: container,
        scroll: {
            current: scroll,
            max: maxScroll
        }
    };
    return viewport;
};

});
parcelRegister("bsp0B", function(module, exports) {

$parcel$export(module.exports, "default", () => $e50ed177aa05ce5d$export$2e2bcd8739ae039);

var $bX8yW = parcelRequire("bX8yW");
var $e50ed177aa05ce5d$export$2e2bcd8739ae039 = ()=>{
    const doc = document.documentElement;
    const maxScroll = (0, $bX8yW.default)({
        // unclipped padding box, with scrollbar
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        // clipped padding box, without scrollbar
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};

});
parcelRegister("bX8yW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2927a2a5ef61b637$export$2e2bcd8739ae039);

var $72Pcv = parcelRequire("72Pcv");
var $2927a2a5ef61b637$export$2e2bcd8739ae039 = ({ scrollHeight: scrollHeight, scrollWidth: scrollWidth, height: height, width: width })=>{
    const maxScroll = (0, $72Pcv.subtract)(// full size
    {
        x: scrollWidth,
        y: scrollHeight
    }, // viewport size
    {
        x: width,
        y: height
    });
    const adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};

});


parcelRegister("feNdz", function(module, exports) {

$parcel$export(module.exports, "default", () => $31ea253008c58ece$export$2e2bcd8739ae039);
var // The browsers update document.documentElement.scrollTop and window.pageYOffset
// differently as the window scrolls.
// Webkit
// documentElement.scrollTop: no update. Stays at 0
// window.pageYOffset: updates to whole number
// Chrome
// documentElement.scrollTop: update with fractional value
// window.pageYOffset: update with fractional value
// FireFox
// documentElement.scrollTop: updates to whole number
// window.pageYOffset: updates to whole number
// IE11 (same as firefox)
// documentElement.scrollTop: updates to whole number
// window.pageYOffset: updates to whole number
// Edge (same as webkit)
// documentElement.scrollTop: no update. Stays at 0
// window.pageYOffset: updates to whole number
$31ea253008c58ece$export$2e2bcd8739ae039 = ()=>({
        x: window.pageXOffset,
        y: window.pageYOffset
    });

});




parcelRegister("5ZW09", function(module, exports) {

$parcel$export(module.exports, "AsyncAdminInaccessibleBoard", () => $bcf1c6c59cc68dbc$export$516550003e785216);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $bcf1c6c59cc68dbc$var$AdminInaccessibleBoard = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("6f7T6")), {
    ssr: false,
    moduleId: "./src/packages/software/admin-inaccessible-board/src/ui/main.tsx"
});
const $bcf1c6c59cc68dbc$export$516550003e785216 = (props)=>{
    const Skeleton = props.skeleton;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        packageName: "jiraAdminInaccessibleBoard",
        id: "async-admin-inaccessible-board",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "admin-inaccessible-board",
        fallback: Skeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bcf1c6c59cc68dbc$var$AdminInaccessibleBoard, props)));
};

});
parcelRegister("6f7T6", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("iDEgf").then(()=>parcelRequire('2Bz5k'));

});


parcelRegister("hP2lu", function(module, exports) {

$parcel$export(module.exports, "useShouldShowAdminInaccessibleBoard", () => $7a289048e0431de9$export$1a15223f3cf409b4);

var $3vXOY = parcelRequire("3vXOY");

var $itmJb = parcelRequire("itmJb");

var $dIdda = parcelRequire("dIdda");
const $7a289048e0431de9$export$1a15223f3cf409b4 = (resource)=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const data = (0, $dIdda.useResource)(resource);
    const statusCode = data.error ? (0, $3vXOY.extractStatusCode)(data.error) : null;
    return isAdmin && statusCode === 404;
};

});

parcelRegister("7Q2kM", function(module, exports) {

$parcel$export(module.exports, "DevDetailsDialogLoaderAsync", () => $1e951f8230b07137$export$f5ffc0f323543e16);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1e951f8230b07137$var$DevDetailDialogLoaderWithContainer = (0, $kxZPA.lazy)(()=>(parcelRequire("g0ZeL")), {
    ssr: false,
    moduleId: "./src/packages/development/details-loader/src/ui/index.tsx"
});
const $1e951f8230b07137$export$f5ffc0f323543e16 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "dev-detail-dialog-loader-with-container",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1e951f8230b07137$var$DevDetailDialogLoaderWithContainer, props));
$1e951f8230b07137$export$f5ffc0f323543e16.defaultProps = {
    onCloseDevDetailDialog: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};

});
parcelRegister("g0ZeL", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("7P2LB")
]).then(()=>parcelRequire('ffvXN'));

});


parcelRegister("iepkZ", function(module, exports) {

$parcel$export(module.exports, "AsyncLaunchToolchainSpotlight", () => $744e85c113b2a238$export$9ef3659da7a0bb31);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $744e85c113b2a238$var$ContainerLinking = (0, $kxZPA.lazy)(()=>(parcelRequire("4slvf")), {
    moduleId: "./src/packages/devops/launch-toolchain-spotlight/src/ui/main.tsx"
});
const $744e85c113b2a238$export$9ef3659da7a0bb31 = ({ projectId: projectId, projectKey: projectKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "cotainer-linking",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($744e85c113b2a238$var$ContainerLinking, {
        projectId: projectId,
        projectKey: projectKey
    }));

});
parcelRegister("4slvf", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("8gDqy")
]).then(()=>parcelRequire('ikW1t'));

});


parcelRegister("22vqd", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsSpotlightContainer", () => $9998ac09b293c088$export$36e4c70f2ffee21d);

var $5uXOq = parcelRequire("5uXOq");

var $1QiBP = parcelRequire("1QiBP");

var $cgL5K = parcelRequire("cgL5K");


var $eGLgs = parcelRequire("eGLgs");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ipmBb = parcelRequire("ipmBb");

var $ehdJY = parcelRequire("ehdJY");

var $dIdda = parcelRequire("dIdda");

var $axmY8 = parcelRequire("axmY8");

var $02beV = parcelRequire("02beV");

var $ht7qk = parcelRequire("ht7qk");
const $9998ac09b293c088$var$ViewSettingsSpotlightContainerInner = ({ onStop: onStop })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const clickedOnNext = (0, $5uXOq.useRef)(false);
    const hadInitSpotlight = (0, $5uXOq.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ activeViewSettingsSpotlight: activeViewSettingsSpotlight, hasViewedViewSettingsSpotlight: hasViewedViewSettingsSpotlight, openViewSettings: openViewSettings }, { onViewSettingsSpotlightInit: onViewSettingsSpotlightInit, onViewSettingsSpotlightNext: onViewSettingsSpotlightNext, onViewSettingsSpotlightEnd: onViewSettingsSpotlightEnd }] = (0, $02beV.useNextBestTaskContainer)();
    const fireAnalytic = (action)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        }), `${(0, $axmY8.NEXT_BEST_TASK_ANALYTICS)}.spotlight.action`, {
            action: action
        });
    };
    const end = (action)=>{
        fireAnalytic(action);
        onViewSettingsSpotlightEnd();
        onStop?.();
    };
    const next = ()=>{
        fireAnalytic('next');
        if (clickedOnNext.current) // Don't want user to click on multiple times and re-trigger this.
        return;
        if (openViewSettings) {
            openViewSettings();
            // It has problem with view settings popup (not panel),
            // if we are not adding setTimeout in here for some reason
            setTimeout(()=>{
                onViewSettingsSpotlightNext();
            });
        }
        clickedOnNext.current = true;
    };
    const shouldIgnoreSpotlight = activeViewSettingsSpotlight === null || hasViewedViewSettingsSpotlight;
    (0, $5uXOq.useEffect)(()=>{
        // If we render this component we will set has view spotlight to false
        if (hasViewedViewSettingsSpotlight && !hadInitSpotlight.current) {
            onViewSettingsSpotlightInit();
            hadInitSpotlight.current = true;
        }
    }, [
        hasViewedViewSettingsSpotlight,
        onViewSettingsSpotlightInit
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!shouldIgnoreSpotlight) (0, $8zOmE.fireScreenAnalytics)(createAnalyticsEvent({}), {
            step: activeViewSettingsSpotlight + 1
        });
    }, [
        createAnalyticsEvent,
        shouldIgnoreSpotlight,
        activeViewSettingsSpotlight
    ]);
    const renderWorkSuggestionsSpotlight = ()=>{
        if (shouldIgnoreSpotlight) return null;
        const spotlights = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                // if no onOpenViewSettings callback only show one step and end
                actionsBeforeElement: openViewSettings ? '1/2' : '1/1',
                actions: openViewSettings ? [
                    // If we have view settings open callback show next button
                    // otherwise show ok button
                    {
                        onClick: ()=>next(),
                        text: formatMessage((0, $ht7qk.default).next)
                    }
                ] : [
                    {
                        onClick: ()=>end('dismiss'),
                        text: formatMessage((0, $ht7qk.default).dismiss)
                    }
                ],
                target: (0, $axmY8.WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_PANEL_NAME),
                key: (0, $axmY8.WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_PANEL_NAME),
                dialogPlacement: "right top",
                targetRadius: 8,
                messageId: "insights-next-best-task.ui.view-settings-spotlight.jira-spotlight",
                messageType: "engagement"
            }, formatMessage((0, $ht7qk.default).workSuggestionsViewSettingsPanelSpotlight)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                actionsBeforeElement: "2/2",
                actions: [
                    {
                        onClick: ()=>end('ok'),
                        text: formatMessage((0, $ht7qk.default).ok)
                    }
                ],
                target: (0, $axmY8.WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_VIEW_SETTINGS_STEP_NAME),
                key: (0, $axmY8.WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_VIEW_SETTINGS_STEP_NAME),
                targetRadius: 3,
                targetBgColor: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                dialogPlacement: "bottom right",
                messageId: "insights-next-best-task.ui.view-settings-spotlight.jira-spotlight.1",
                messageType: "engagement"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "span"
            }, formatMessage((0, $ht7qk.default).workSuggestionsViewSettingsSettingsSpotlight, {
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        weight: "bold",
                        as: "strong"
                    }, chunks)
            })))
        ];
        return spotlights[activeViewSettingsSpotlight];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !hasViewedViewSettingsSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, renderWorkSuggestionsSpotlight()));
};
const $9998ac09b293c088$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
const $9998ac09b293c088$export$36e4c70f2ffee21d = ({ children: children, shouldShowSpotlight: shouldShowSpotlight })=>{
    const { data: isWorkSuggestionsEnabledData, loading: loadingWorkSuggestionsEnabled } = (0, $dIdda.useResource)((0, $ipmBb.nextBestTaskFeatureResource));
    const hadOptedIn = !!isWorkSuggestionsEnabledData?.hasUserOptedIn;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children, shouldShowSpotlight && !loadingWorkSuggestionsEnabled && hadOptedIn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: (0, $axmY8.WORK_SUGGESTIONS_SPOTLIGHT_MESSAGE_ID),
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9998ac09b293c088$export$83d026e3dd5706d, null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            sourceName: "workSuggestionsSpotlight",
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9998ac09b293c088$var$ViewSettingsSpotlightContainerInner, {
            onStop: stop
        })))));
};

});
parcelRegister("ht7qk", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0429fecf856e9c0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c0429fecf856e9c0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    workSuggestionsViewSettingsPanelSpotlight: {
        "id": "insights-next-best-task.view-settings-spotlight.work-suggestions-view-settings-panel-spotlight",
        "defaultMessage": "If we have suggestions for what you can work on next, you\u2019ll see them on the board when you select your avatar."
    },
    workSuggestionsViewSettingsSettingsSpotlight: {
        "id": "insights-next-best-task.view-settings-spotlight.work-suggestions-view-settings-settings-spotlight",
        "defaultMessage": "To switch <b>Work suggestions</b> on or off, use the toggle in <b>View settings</b>."
    },
    next: {
        "id": "insights-next-best-task.view-settings-spotlight.next",
        "defaultMessage": "Next"
    },
    ok: {
        "id": "insights-next-best-task.view-settings-spotlight.ok",
        "defaultMessage": "OK"
    },
    dismiss: {
        "id": "insights-next-best-task.view-settings-spotlight.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});


parcelRegister("b052x", function(module, exports) {

$parcel$export(module.exports, "IssueLinksHandlerContainer", () => $bda04b2b06c21a24$export$a3ee14e17fe2bf67);
$parcel$export(module.exports, "useOnIssueOpen", () => $bda04b2b06c21a24$export$9bb7155db54ab61f);

var $7JoAD = parcelRequire("7JoAD");
const $bda04b2b06c21a24$export$d4c72bab9d6cc13a = {
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onIssueOpen: ()=>{}
};
const $bda04b2b06c21a24$var$actions = {};
const $bda04b2b06c21a24$export$6f57813fe9f31bf9 = (0, $7JoAD.createStore)({
    initialState: $bda04b2b06c21a24$export$d4c72bab9d6cc13a,
    actions: $bda04b2b06c21a24$var$actions,
    name: 'issue-links-handler-store'
});
const $bda04b2b06c21a24$var$onPropsChange = ({ setState: setState }, { onIssueOpen: onIssueOpen })=>{
    setState({
        onIssueOpen: onIssueOpen
    });
};
const $bda04b2b06c21a24$export$a3ee14e17fe2bf67 = (0, $7JoAD.createContainer)($bda04b2b06c21a24$export$6f57813fe9f31bf9, {
    onInit: ()=>$bda04b2b06c21a24$var$onPropsChange,
    onUpdate: ()=>$bda04b2b06c21a24$var$onPropsChange
});
const $bda04b2b06c21a24$export$9bb7155db54ab61f = (0, $7JoAD.createStateHook)($bda04b2b06c21a24$export$6f57813fe9f31bf9, {
    selector: (state)=>state.onIssueOpen
});

});

parcelRegister("jqUpd", function(module, exports) {

$parcel$export(module.exports, "planIssueModal", () => $5f9b3fe3781cec99$export$3975a421a6ca7502);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $5f9b3fe3781cec99$export$3975a421a6ca7502 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("blbEU")).then((module)=>module.AsyncPlanIssueModal), {
        moduleId: "6c079fa3"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("blbEU", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("9rd2C").then(()=>parcelRequire('hPbBf'));

});


parcelRegister("7LEyz", function(module, exports) {

$parcel$export(module.exports, "default", () => $85ba20431946ab6e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");

var $5QVhk = parcelRequire("5QVhk");
/**
 * @deprecated use generic version of SizeLimitErrorEmptyStateComponent component @atlassian/jira-software-size-limit-error-empty-state
 */ const $85ba20431946ab6e$var$BoardSizeLimitErrorEmptyStateWithBaseUrl = ({ projectKey: projectKey, savedFilterId: savedFilterId, isCMPBoard: isCMPBoard = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const { baseUrl: baseUrl } = tenantContext;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5QVhk.default), {
            projectKey: projectKey,
            baseUrl: baseUrl,
            isCMPBoard: isCMPBoard,
            savedFilterId: savedFilterId
        });
    });
var $85ba20431946ab6e$export$2e2bcd8739ae039 = $85ba20431946ab6e$var$BoardSizeLimitErrorEmptyStateWithBaseUrl;

});
parcelRegister("5QVhk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d46e677f9d568066$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $i4N7W = parcelRequire("i4N7W");

var $65Ltd = parcelRequire("65Ltd");

var $6s1PB = parcelRequire("6s1PB");

var $az4zD = parcelRequire("az4zD");

var $6jY6G = parcelRequire("6jY6G");

var $bMyyL = parcelRequire("bMyyL");

var $gzib5 = parcelRequire("gzib5");
const $d46e677f9d568066$var$BoardSizeLimitError = ({ intl: intl, projectKey: projectKey, baseUrl: baseUrl, isCMPBoard: isCMPBoard = false, savedFilterId: savedFilterId })=>{
    const description = isCMPBoard ? intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bMyyL.default).descriptionCmpIssueTermRefresh : (0, $bMyyL.default).descriptionCmp) : intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bMyyL.default).descriptionIssueTermRefresh : (0, $bMyyL.default).description);
    const url = isCMPBoard && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(savedFilterId) ? `${baseUrl}/issues/?filter=${savedFilterId}` : `${baseUrl}/issues/?jql=${encodeURIComponent(`project = ${projectKey} ORDER BY rank ASC`)}`;
    const buttonText = isCMPBoard ? intl.formatMessage((0, $bMyyL.default).editBoardFilter) : intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bMyyL.default).goToSearchIssueTermRefresh : (0, $bMyyL.default).goToSearch);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d46e677f9d568066$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($i4N7W))),
        header: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bMyyL.default).headerIssueTermRefresh : (0, $bMyyL.default).header),
        description: description,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            href: url,
            appearance: "primary"
        }, buttonText)
    }));
};
const $d46e677f9d568066$var$BoardSizeLimitErrorEmptyState = (props)=>{
    const { name: name } = (0, $6jY6G.useCurrentRoute)();
    const showErrorWithNoCTA = name === (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_BOARDS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d46e677f9d568066$var$Container, null, showErrorWithNoCTA ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzib5.BoardSizeLimitErrorWithNoCTA), {
        intl: props.intl
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d46e677f9d568066$var$BoardSizeLimitError, props));
};
const $d46e677f9d568066$var$BoardSizeLimitErrorEmptyStateWithIntl = (0, $az4zD.injectIntlV2)($d46e677f9d568066$var$BoardSizeLimitErrorEmptyState);
var $d46e677f9d568066$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $d46e677f9d568066$var$BoardSizeLimitErrorEmptyStateWithIntl;
const $d46e677f9d568066$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i4N7W", function(module, exports) {
module.exports = new URL("something-wrong.1260804e.svg", import.meta.url).toString();

});

parcelRegister("bMyyL", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfedbe69eb72a9f4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $dfedbe69eb72a9f4$var$messages = (0, $7VHMR.defineMessages)({
    header: {
        "id": "software-board-size-limit-error-empty-state.header",
        "defaultMessage": "Your board has too many issues"
    },
    goToSearch: {
        "id": "software-board-size-limit-error-empty-state.go-to-search",
        "defaultMessage": "See issues in search"
    },
    description: {
        "id": "software-board-size-limit-error-empty-state.description",
        "defaultMessage": "Boards can only display up to 5,000 issues at a time. Move or delete issues to continue using your board."
    },
    descriptionCmp: {
        "id": "software-board-size-limit-error-empty-state.description-cmp",
        "defaultMessage": "Boards can only display up to 5,000 issues at a time. Try editing your board's filter query to include fewer issues, or create an additional board."
    },
    editBoardFilter: {
        "id": "software-board-size-limit-error-empty-state.edit-board-filter",
        "defaultMessage": "Edit board filter"
    },
    headerIssueTermRefresh: {
        "id": "software-board-size-limit-error-empty-state.header-issue-term-refresh",
        "defaultMessage": "Your board has too many issues"
    },
    goToSearchIssueTermRefresh: {
        "id": "software-board-size-limit-error-empty-state.go-to-search-issue-term-refresh",
        "defaultMessage": "See issues in search"
    },
    descriptionIssueTermRefresh: {
        "id": "software-board-size-limit-error-empty-state.description-issue-term-refresh",
        "defaultMessage": "Boards can only display up to 5,000 issues at a time. Move or delete issues to continue using your board."
    },
    descriptionCmpIssueTermRefresh: {
        "id": "software-board-size-limit-error-empty-state.description-cmp-issue-term-refresh",
        "defaultMessage": "Boards can only display up to 5,000 issues at a time. Try editing your board's filter query to include fewer issues, or create an additional board."
    }
});
var $dfedbe69eb72a9f4$export$2e2bcd8739ae039 = $dfedbe69eb72a9f4$var$messages;

});

parcelRegister("gzib5", function(module, exports) {

$parcel$export(module.exports, "BoardSizeLimitErrorWithNoCTA", () => $6e3be43d7f71b8ae$export$67ed49fd05b7aff8);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $i4N7W = parcelRequire("i4N7W");

var $6s1PB = parcelRequire("6s1PB");

var $9NE02 = parcelRequire("9NE02");
const $6e3be43d7f71b8ae$export$67ed49fd05b7aff8 = ({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6e3be43d7f71b8ae$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($i4N7W))),
        header: intl.formatMessage((0, $9NE02.default).header),
        description: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9NE02.default).descriptionIssueTermRefresh : (0, $9NE02.default).description)
    }));
const $6e3be43d7f71b8ae$var$containerStyles = (0, $8CUq3.xcss)({
    width: '100%'
});

});
parcelRegister("9NE02", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e962dff92e62d1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $a9e962dff92e62d1$var$messages = (0, $7VHMR.defineMessages)({
    header: {
        "id": "software-board-size-limit-error-empty-state.size-limit-error-no-cta.header",
        "defaultMessage": "We couldn\u2019t load your board"
    },
    description: {
        "id": "software-board-size-limit-error-empty-state.size-limit-error-no-cta.description",
        "defaultMessage": "Boards only works in project with less than 5,000 issues. We\u2019re working on this and will let you know when it has changed."
    },
    descriptionIssueTermRefresh: {
        "id": "software-board-size-limit-error-empty-state.size-limit-error-no-cta.description-issue-term-refresh",
        "defaultMessage": "Boards only works in project with less than 5,000 issues. We\u2019re working on this and will let you know when it has changed."
    }
});
var $a9e962dff92e62d1$export$2e2bcd8739ae039 = $a9e962dff92e62d1$var$messages;

});




parcelRegister("5fQw9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cbb5d72cb5df9c7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $ijYb7 = parcelRequire("ijYb7");
const $9cbb5d72cb5df9c7$var$App = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "app",
        packageName: "jiraSoftwareIssueLimitFlags",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijYb7.IssueLimitFlags), props));
var $9cbb5d72cb5df9c7$export$2e2bcd8739ae039 = $9cbb5d72cb5df9c7$var$App;

});
parcelRegister("ijYb7", function(module, exports) {

$parcel$export(module.exports, "IssueLimitFlags", () => $07c13de1d345d403$export$739da16e22409e4d);

var $5uXOq = parcelRequire("5uXOq");

var $e2T54 = parcelRequire("e2T54");

var $ir9Ry = parcelRequire("ir9Ry");
const $07c13de1d345d403$var$ISSUE_APPROACHING_LIMIT = 4500;
const $07c13de1d345d403$var$ISSUE_REACHED_LIMIT = 5000;
const $07c13de1d345d403$export$739da16e22409e4d = ({ isProjectAdmin: isProjectAdmin, ...flagProps })=>{
    const [limitReachedFlagShown, setLimitReachedFlagShown] = (0, $5uXOq.useState)(false);
    const limitReachedViews = flagProps.views.filter((view)=>view.issueCount >= $07c13de1d345d403$var$ISSUE_REACHED_LIMIT);
    const limitApproachingViews = flagProps.views.filter((view)=>view.issueCount >= $07c13de1d345d403$var$ISSUE_APPROACHING_LIMIT && view.issueCount < $07c13de1d345d403$var$ISSUE_REACHED_LIMIT);
    const shouldShowLimitReachedFlag = limitReachedViews.length > 0;
    const shouldShowLimitApproachingFlag = limitApproachingViews.length > 0 && !limitReachedFlagShown;
    (0, $5uXOq.useEffect)(()=>{
        if (shouldShowLimitReachedFlag && !limitReachedFlagShown) setLimitReachedFlagShown(true);
    }, [
        limitReachedFlagShown,
        shouldShowLimitReachedFlag
    ]);
    // Check to ensure permission is defined. If value is not boolean, then it likely
    // means it has not yet been loaded
    if (typeof isProjectAdmin !== 'boolean') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldShowLimitApproachingFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e2T54.LimitApproachingFlag), {
        ...flagProps,
        isProjectAdmin: isProjectAdmin,
        views: limitApproachingViews
    }), shouldShowLimitReachedFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ir9Ry.LimitReachedFlag), {
        ...flagProps,
        isProjectAdmin: isProjectAdmin,
        views: limitReachedViews
    }));
};

});
parcelRegister("e2T54", function(module, exports) {

$parcel$export(module.exports, "LimitApproachingFlag", () => $da6681a9a2d62d46$export$c8f47c0b0c12451c);

var $5uXOq = parcelRequire("5uXOq");

var $2hXfb = parcelRequire("2hXfb");


var $6s1PB = parcelRequire("6s1PB");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $8g67F = parcelRequire("8g67F");

var $bvUMO = parcelRequire("bvUMO");
const $da6681a9a2d62d46$var$LIMIT_APPROACHING_FLAG_ID = 'jsw-issue-approaching-reached-flag';
const $da6681a9a2d62d46$export$c8f47c0b0c12451c = ({ isCMP: isCMP, isProjectAdmin: isProjectAdmin, projectKey: projectKey, views: flagViews })=>{
    const [flagShown, setFlagShown] = (0, $5uXOq.useState)(false);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const flagActions = (0, $8g67F.useFlagActions)({
        isProjectAdmin: isProjectAdmin,
        isCMP: isCMP,
        projectKey: projectKey,
        flagType: 'approaching'
    });
    const views = flagViews.map((v)=>v.view);
    (0, $5uXOq.useEffect)(()=>{
        const getFlagTitle = ()=>{
            if (isCMP) return views[0] === 'BOARD' ? (0, $bvUMO.default).boardLimitApproachingFlagTitle : (0, $bvUMO.default).backlogLimitApproachingFlagTitle;
            if (views.includes('BACKLOG') && views.includes('SPRINTS')) return (0, $bvUMO.default).tmpBacklogSprintsLimitApproachingFlagTitle;
            if (views.includes('BACKLOG') && views.includes('BOARD')) return (0, $bvUMO.default).tmpBacklogBoardLimitApproachingFlagTitle;
            if (views.includes('BACKLOG')) return (0, $bvUMO.default).tmpBacklogLimitApproachingFlagTitle;
            if (views.includes('SPRINTS')) return (0, $bvUMO.default).tmpSprintsLimitApproachingFlagTitle;
            if (views.includes('BOARD')) return (0, $bvUMO.default).boardLimitApproachingFlagTitle;
            return (0, $bvUMO.default).boardLimitApproachingFlagTitle;
        };
        const getFlagMessage = ()=>{
            if (isCMP) {
                if (views[0] === 'BOARD') {
                    const boardLimitApproachingAdminFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).boardLimitApproachingAdminFlagBodyIssueTermRefresh : (0, $bvUMO.default).boardLimitApproachingAdminFlagBody;
                    const boardLimitApproachingEndUserFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).boardLimitApproachingEndUserFlagBodyIssueTermRefresh : (0, $bvUMO.default).boardLimitApproachingEndUserFlagBody;
                    return isProjectAdmin ? boardLimitApproachingAdminFlagBodyMessage : boardLimitApproachingEndUserFlagBodyMessage;
                }
                const backlogLimitApproachingAdminFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).backlogLimitApproachingAdminFlagBodyIssueTermRefresh : (0, $bvUMO.default).backlogLimitApproachingAdminFlagBody;
                const backlogLimitApproachingEndUserFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).backlogLimitApproachingEndUserFlagBodyIssueTermRefresh : (0, $bvUMO.default).backlogLimitApproachingEndUserFlagBody;
                return isProjectAdmin ? backlogLimitApproachingAdminFlagBodyMessage : backlogLimitApproachingEndUserFlagBodyMessage;
            }
            if (views.includes('BACKLOG') && views.includes('SPRINTS')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpBacklogSprintsLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpBacklogSprintsLimitApproachingFlagBody;
            if (views.includes('BACKLOG') && views.includes('BOARD')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpBacklogBoardLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpBacklogBoardLimitApproachingFlagBody;
            if (views.includes('BACKLOG')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpBacklogLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpBacklogLimitApproachingFlagBody;
            if (views.includes('SPRINTS')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpSprintsLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpSprintsLimitApproachingFlagBody;
            if (views.includes('BOARD')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpBoardLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpBoardLimitApproachingFlagBody;
            return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpBoardLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpBoardLimitApproachingFlagBody;
        };
        const flagTitle = getFlagTitle();
        const flagDescription = getFlagMessage();
        if (!flagShown) {
            showFlag({
                id: $da6681a9a2d62d46$var$LIMIT_APPROACHING_FLAG_ID,
                type: 'info',
                title: flagTitle,
                description: flagDescription,
                isAutoDismiss: false,
                actions: flagActions,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hXfb))), {
                    primaryColor: `var(--ds-icon-information, ${(0, $829f609a65d26a98$exports).B300})`,
                    label: ""
                }),
                onDismissed: (_, analyticsEvent)=>{
                    if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'jswIssueLimitApproachingFlag');
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'flag shown', 'jswIssueLimitApproachingFlag');
        }
        setFlagShown(true);
    }, [
        showFlag,
        isProjectAdmin,
        flagActions,
        flagShown,
        createAnalyticsEvent,
        isCMP,
        views
    ]);
    return null;
};

});
parcelRegister("8g67F", function(module, exports) {

$parcel$export(module.exports, "useFlagActions", () => $fc75b95d4a7d68f1$export$38e4a892c359139d);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $e5wyW = parcelRequire("e5wyW");

var $5Zxxp = parcelRequire("5Zxxp");

var $8zOmE = parcelRequire("8zOmE");

var $fR4iU = parcelRequire("fR4iU");
const $fc75b95d4a7d68f1$var$CMP_ISSUE_LIMIT_SUPPORT_ARTICLE_URL = 'https://support.atlassian.com/jira-software-cloud/docs/issue-limits-in-company-managed-projects/';
const $fc75b95d4a7d68f1$var$CMP_ISSUE_LIMIT_IPH_ARTICLE_ID = '1KMwTxMBNiDPhaHMDlfT4u';
function $fc75b95d4a7d68f1$export$d53148a666867fe1(flagSource) {
    return {
        content: (0, $fR4iU.default).editFilterCta,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        href: `${window.location.pathname}?config=filter`,
        onClick: (_, analyticsEvent)=>{
            if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'editBoardFilter', {
                flagSource: flagSource
            });
        }
    };
}
function $fc75b95d4a7d68f1$export$72a228c0f924aef1(flagSource) {
    return {
        content: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fR4iU.default).viewMoreInfoCtaIssueTermRefresh : (0, $fR4iU.default).viewMoreInfoCta,
        href: $fc75b95d4a7d68f1$var$CMP_ISSUE_LIMIT_SUPPORT_ARTICLE_URL,
        target: '_blank',
        onClick: (_, analyticsEvent)=>{
            if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'cmpIssueLimitSupportArticle', {
                flagSource: flagSource
            });
        }
    };
}
function $fc75b95d4a7d68f1$export$d49a14b48e551259(flagSource, setIPHArticleId) {
    return {
        content: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fR4iU.default).viewMoreInfoCtaIssueTermRefresh : (0, $fR4iU.default).viewMoreInfoCta,
        onClick: (_, analyticsEvent)=>{
            setIPHArticleId?.($fc75b95d4a7d68f1$var$CMP_ISSUE_LIMIT_IPH_ARTICLE_ID);
            if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'cmpIssueLimitIph', {
                flagSource: flagSource
            });
        }
    };
}
const $fc75b95d4a7d68f1$export$226a1330ff7e389b = (projectKey)=>({
        content: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fR4iU.default).seeIssuesInSearchCtaIssueTermRefresh : (0, $fR4iU.default).seeIssuesInSearchCta,
        href: `/issues/?jql=${encodeURIComponent(`project = ${projectKey} ORDER BY rank ASC`)}`
    });
const $fc75b95d4a7d68f1$var$selector = (0, $e5wyW.functionWithCondition)(()=>(0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false), ()=>({
        content: (0, $fR4iU.default).viewMoreInfoCtaIssueTermRefresh,
        href: 'TBD'
    }), ()=>({
        content: (0, $fR4iU.default).viewMoreInfoCta,
        href: 'TBD'
    }));
const $fc75b95d4a7d68f1$export$2ca20f1de5f009d2 = $fc75b95d4a7d68f1$var$selector();
const $fc75b95d4a7d68f1$export$38e4a892c359139d = ({ isProjectAdmin: isProjectAdmin, isCMP: isCMP, projectKey: projectKey, flagType: flagType })=>{
    const setIPHArticleId = (0, $5Zxxp.useHelpPanelLink)();
    const flagSource = flagType === 'approaching' ? 'jswIssueLimitApproachingFlag' : 'jswIssueLimitReachedFlag';
    return (0, $5uXOq.useMemo)(()=>{
        if (isCMP) {
            if (isProjectAdmin) return [
                $fc75b95d4a7d68f1$export$d53148a666867fe1(flagSource),
                $fc75b95d4a7d68f1$export$d49a14b48e551259(flagSource, setIPHArticleId)
            ];
            return [
                $fc75b95d4a7d68f1$export$72a228c0f924aef1(flagSource)
            ];
        }
        return [
            $fc75b95d4a7d68f1$export$226a1330ff7e389b(projectKey),
            $fc75b95d4a7d68f1$export$2ca20f1de5f009d2
        ];
    }, [
        isCMP,
        projectKey,
        isProjectAdmin,
        flagSource,
        setIPHArticleId
    ]);
};

});
parcelRegister("fR4iU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a85e2fb64f1664f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8a85e2fb64f1664f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editFilterCta: {
        "id": "software-issue-limit-flags.common.edit-filter-cta",
        "defaultMessage": "Edit filter"
    },
    viewMoreInfoCta: {
        "id": "software-issue-limit-flags.common.view-more-info-cta",
        "defaultMessage": "More about issue limits"
    },
    seeIssuesInSearchCta: {
        "id": "software-issue-limit-flags.common.see-issues-in-search-cta",
        "defaultMessage": "See issues in search"
    },
    viewMoreInfoCtaIssueTermRefresh: {
        "id": "software-issue-limit-flags.common.view-more-info-cta-issue-term-refresh",
        "defaultMessage": "More about issue limits"
    },
    seeIssuesInSearchCtaIssueTermRefresh: {
        "id": "software-issue-limit-flags.common.see-issues-in-search-cta-issue-term-refresh",
        "defaultMessage": "See issues in search"
    }
});

});


parcelRegister("bvUMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae0496ade39ae6cf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ae0496ade39ae6cf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    backlogLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-flag-title",
        "defaultMessage": "Your backlog is almost full"
    },
    backlogLimitApproachingAdminFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-admin-flag-body",
        "defaultMessage": "The backlog can display up to 5000 issues. Edit your board filter to refine what's included and excluded."
    },
    backlogLimitApproachingEndUserFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-end-user-flag-body",
        "defaultMessage": "The backlog can display up to 5000 issues. The admin who created the board filter can refine what's included and excluded."
    },
    boardLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-flag-title",
        "defaultMessage": "Your board is almost full"
    },
    boardLimitApproachingAdminFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-admin-flag-body",
        "defaultMessage": "The board can display up to 5000 issues. Edit your board filter to refine what's included and excluded."
    },
    boardLimitApproachingEndUserFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-end-user-flag-body",
        "defaultMessage": "The board can display up to 5000 issues. The admin who created the board filter can refine what's included and excluded."
    },
    tmpBacklogLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-limit-approaching-flag-title",
        "defaultMessage": "Your backlog is almost full"
    },
    tmpSprintsLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-sprints-limit-approaching-flag-title",
        "defaultMessage": "Your sprint section is almost full"
    },
    tmpBacklogSprintsLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-sprints-limit-approaching-flag-title",
        "defaultMessage": "Your backlog and sprint sections are almost full"
    },
    tmpBacklogBoardLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-board-limit-approaching-flag-title",
        "defaultMessage": "Your backlog and board sections are almost full"
    },
    tmpBoardLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-board-limit-approaching-flag-body",
        "defaultMessage": "The board can only display up to 5000 issues. It might be time to move some issues."
    },
    tmpBacklogLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-limit-approaching-flag-body",
        "defaultMessage": "The backlog can display up to 5000 issues. It might be time to move some issues."
    },
    tmpSprintsLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-sprints-limit-approaching-flag-body",
        "defaultMessage": "We can only display up to 5000 issues across all your sprints. It might be time to move some issues."
    },
    tmpBacklogSprintsLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-sprints-limit-approaching-flag-body",
        "defaultMessage": "Your backlog and sprint sections can each only display up to 5000 issues. It might be time to move some issues."
    },
    tmpBacklogBoardLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-board-limit-approaching-flag-body",
        "defaultMessage": "Your backlog and board sections can each only display up to 5000 issues. It might be time to move some issues."
    },
    backlogLimitApproachingAdminFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-admin-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can display up to 5000 issues. Edit your board filter to refine what's included and excluded."
    },
    backlogLimitApproachingEndUserFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-end-user-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can display up to 5000 issues. The admin who created the board filter can refine what's included and excluded."
    },
    boardLimitApproachingAdminFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-admin-flag-body-issue-term-refresh",
        "defaultMessage": "The board can display up to 5000 issues. Edit your board filter to refine what's included and excluded."
    },
    boardLimitApproachingEndUserFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-end-user-flag-body-issue-term-refresh",
        "defaultMessage": "The board can display up to 5000 issues. The admin who created the board filter can refine what's included and excluded."
    },
    tmpBoardLimitApproachingFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-board-limit-approaching-flag-body-issue-term-refresh",
        "defaultMessage": "The board can only display up to 5000 issues. It might be time to move some issues."
    },
    tmpBacklogLimitApproachingFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-limit-approaching-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can display up to 5000 issues. It might be time to move some issues."
    },
    tmpSprintsLimitApproachingFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-sprints-limit-approaching-flag-body-issue-term-refresh",
        "defaultMessage": "We can only display up to 5000 issues across all your sprints. It might be time to move some issues."
    },
    tmpBacklogSprintsLimitApproachingFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-sprints-limit-approaching-flag-body-issue-term-refresh",
        "defaultMessage": "Your backlog and sprint sections can each only display up to 5000 issues. It might be time to move some issues."
    },
    tmpBacklogBoardLimitApproachingFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-board-limit-approaching-flag-body-issue-term-refresh",
        "defaultMessage": "Your backlog and board sections can each only display up to 5000 issues. It might be time to move some issues."
    }
});

});


parcelRegister("ir9Ry", function(module, exports) {

$parcel$export(module.exports, "LimitReachedFlag", () => $48372b37d055d7b1$export$b4f3bdfaaded5337);

var $a6ceQ = parcelRequire("a6ceQ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $k24Fu = parcelRequire("k24Fu");

var $6s1PB = parcelRequire("6s1PB");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $8g67F = parcelRequire("8g67F");

var $lSfuc = parcelRequire("lSfuc");
const $48372b37d055d7b1$var$LIMIT_REACHED_FLAG_ID = 'jsw-issue-limit-reached-flag';
const $48372b37d055d7b1$export$b4f3bdfaaded5337 = ({ boardId: boardId, isProjectAdmin: isProjectAdmin, isCMP: isCMP, projectKey: projectKey, views: flagViews })=>{
    const [flagShown, setFlagShown] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const views = flagViews.map((flagView)=>flagView.view);
    const shouldFetchTotalCount = views.length === 1 && [
        'BACKLOG',
        'BOARD'
    ].includes(views[0]);
    const data = (0, $8Uumt.useLazyLoadQuery)((0, $a6ceQ.default), {
        cloudId: cloudId,
        issueSearchInput: {
            customInput: {
                jiraSoftwareInput: {
                    context: views[0] === 'BOARD' ? 'BOARD' : 'BACKLOG',
                    jiraEntityId: (0, $k24Fu.JiraSoftwareBoardAri).create({
                        boardId: boardId.toString(),
                        siteId: cloudId
                    }).toString()
                }
            }
        },
        skip: !shouldFetchTotalCount
    }, {
        fetchPolicy: 'network-only'
    });
    const totalCount = data.jira?.issueSearchTotalCount;
    const flagActions = (0, $8g67F.useFlagActions)({
        isProjectAdmin: isProjectAdmin,
        isCMP: isCMP,
        projectKey: projectKey,
        flagType: 'reached'
    });
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFetchTotalCount && typeof totalCount !== 'number') return;
        const getFlagTitle = ()=>{
            if (isCMP) return views[0] === 'BOARD' ? (0, $lSfuc.default).boardLimitReachedFlagTitle : (0, $lSfuc.default).backlogLimitReachedFlagTitle;
            if (views.includes('BACKLOG') && views.includes('SPRINTS')) return (0, $lSfuc.default).tmpBacklogSprintsLimitReachedFlagTitle;
            if (views.includes('BACKLOG') && views.includes('BOARD')) return (0, $lSfuc.default).tmpBacklogBoardLimitReachedFlagTitle;
            if (views.includes('BACKLOG')) return (0, $lSfuc.default).tmpBacklogLimitReachedFlagTitle;
            if (views.includes('SPRINTS')) return (0, $lSfuc.default).tmpSprintsLimitReachedFlagTitle;
            if (views.includes('BOARD')) return (0, $lSfuc.default).boardLimitReachedFlagTitle;
            return (0, $lSfuc.default).boardLimitReachedFlagTitle;
        };
        const getFlagMessage = ()=>{
            if (isCMP) {
                if (views[0] === 'BOARD') {
                    const boardLimitReachedAdminFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).boardLimitReachedAdminFlagBodyIssueTermRefresh : (0, $lSfuc.default).boardLimitReachedAdminFlagBody;
                    const boardLimitReachedEndUserFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).boardLimitReachedEndUserFlagBodyIssueTermRefresh : (0, $lSfuc.default).boardLimitReachedEndUserFlagBody;
                    return isProjectAdmin ? boardLimitReachedAdminFlagBodyMessage : boardLimitReachedEndUserFlagBodyMessage;
                }
                const backlogLimitReachedAdminFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).backlogLimitReachedAdminFlagBodyIssueTermRefresh : (0, $lSfuc.default).backlogLimitReachedAdminFlagBody;
                const backlogLimitReachedEndUserFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).backlogLimitReachedEndUserFlagBodyIssueTermRefresh : (0, $lSfuc.default).backlogLimitReachedEndUserFlagBody;
                return isProjectAdmin ? backlogLimitReachedAdminFlagBodyMessage : backlogLimitReachedEndUserFlagBodyMessage;
            }
            if (views.includes('BACKLOG') && views.includes('SPRINTS')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpBacklogSprintsLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpBacklogSprintsLimitReachedFlagBody;
            if (views.includes('BACKLOG') && views.includes('BOARD')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpBacklogBoardLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpBacklogBoardLimitReachedFlagBody;
            if (views.includes('BACKLOG')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpBacklogLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpBacklogLimitReachedFlagBody;
            if (views.includes('SPRINTS')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpSprintsLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpSprintsLimitReachedFlagBody;
            if (views.includes('BOARD')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpBoardLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpBoardLimitReachedFlagBody;
            return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpBoardLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpBoardLimitReachedFlagBody;
        };
        const flagTitle = getFlagTitle();
        const flagDescription = getFlagMessage();
        if (!flagShown) {
            showFlag({
                id: $48372b37d055d7b1$var$LIMIT_REACHED_FLAG_ID,
                type: 'warning',
                title: flagTitle,
                description: formatMessage(flagDescription, {
                    issueCount: totalCount
                }),
                isAutoDismiss: false,
                actions: flagActions,
                onDismissed: (_, analyticsEvent)=>{
                    if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'jswIssueLimitReachedFlag', {
                        totalIssueCount: totalCount
                    });
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'flag shown', 'jswIssueLimitReachedFlag', {
                totalIssueCount: totalCount
            });
            setFlagShown(true);
        }
    }, [
        formatMessage,
        showFlag,
        isProjectAdmin,
        flagActions,
        totalCount,
        flagShown,
        createAnalyticsEvent,
        isCMP,
        shouldFetchTotalCount,
        views
    ]);
    return null;
};

});
parcelRegister("a6ceQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6258a09992b1b59$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5081ebe1b7c763d83be8f11da4336340>>
 * @relayHash 16968863187b798a94c81fb2f3c02587
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1d92172fafa12a38c14a21764204ae490c41baf36eb55b3ec10622230a6ef256
const $e6258a09992b1b59$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueSearchInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        }
    ], v1 = [
        {
            "condition": "skip",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "issueSearchTotalCount"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "limitReachedFlagTotalIssueCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "limitReachedFlagTotalIssueCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "1d92172fafa12a38c14a21764204ae490c41baf36eb55b3ec10622230a6ef256",
            "metadata": {},
            "name": "limitReachedFlagTotalIssueCountQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e6258a09992b1b59$var$node.hash = "1b2bcb6691b0c1b0f0f93eb3b32f4323";
var $e6258a09992b1b59$export$2e2bcd8739ae039 = $e6258a09992b1b59$var$node;

});

parcelRegister("lSfuc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cabc45eb3d95785$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3cabc45eb3d95785$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    backlogLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-flag-title",
        "defaultMessage": "Your backlog is full"
    },
    backlogLimitReachedAdminFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-admin-flag-body",
        "defaultMessage": "The backlog can only display 5000 issues, and your current filter contains {issueCount}. Edit your filter to refine what's included and excluded."
    },
    backlogLimitReachedEndUserFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-end-user-flag-body",
        "defaultMessage": "The backlog can only display 5000 issues, and the current filter contains {issueCount}. An admin will need to edit the board filter to refine what's included and excluded."
    },
    boardLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-flag-title",
        "defaultMessage": "Your board is full"
    },
    boardLimitReachedAdminFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-admin-flag-body",
        "defaultMessage": "The board can only display 5000 issues, and your current filter contains {issueCount}. Edit your filter to refine what's included and excluded."
    },
    boardLimitReachedEndUserFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-end-user-flag-body",
        "defaultMessage": "The board can only display 5000 issues, and the current filter contains {issueCount}. An admin will need to edit the board filter to refine what's included and excluded."
    },
    tmpBacklogSprintsLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-sprints-limit-reached-flag-title",
        "defaultMessage": "Your backlog and sprint sections are full"
    },
    tmpSprintsLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-sprints-limit-reached-flag-title",
        "defaultMessage": "Your sprint section is full"
    },
    tmpBacklogLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-limit-reached-flag-title",
        "defaultMessage": "Your backlog is full"
    },
    tmpBacklogBoardLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-board-limit-reached-flag-title",
        "defaultMessage": "Your backlog and board sections are full"
    },
    tmpBoardLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-board-limit-reached-flag-body",
        "defaultMessage": "The board can only display 5000 issues, and your current board contains {issueCount}. It's time to move some issues."
    },
    tmpBacklogSprintsLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-sprints-limit-reached-flag-body",
        "defaultMessage": "Your backlog and sprint sections can each only display 5000 issues. It's time to move some issues."
    },
    tmpSprintsLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-sprints-limit-reached-flag-body",
        "defaultMessage": "We can only display 5000 issues across all your sprints. It's time to move some issues."
    },
    tmpBacklogLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-limit-reached-flag-body",
        "defaultMessage": "The backlog can only display 5000 issues, and your current backlog contains {issueCount}. It's time to move some issues."
    },
    tmpBacklogBoardLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-board-limit-reached-flag-body",
        "defaultMessage": "Your backlog and board sections can each only display 5000 issues. It's time to move some issues."
    },
    backlogLimitReachedAdminFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-admin-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can only display 5000 issues, and your current filter contains {issueCount}. Edit your filter to refine what's included and excluded."
    },
    backlogLimitReachedEndUserFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-end-user-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can only display 5000 issues, and the current filter contains {issueCount}. An admin will need to edit the board filter to refine what's included and excluded."
    },
    boardLimitReachedAdminFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-admin-flag-body-issue-term-refresh",
        "defaultMessage": "The board can only display 5000 issues, and your current filter contains {issueCount}. Edit your filter to refine what's included and excluded."
    },
    boardLimitReachedEndUserFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-end-user-flag-body-issue-term-refresh",
        "defaultMessage": "The board can only display 5000 issues, and the current filter contains {issueCount}. An admin will need to edit the board filter to refine what's included and excluded."
    },
    tmpBoardLimitReachedFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-board-limit-reached-flag-body-issue-term-refresh",
        "defaultMessage": "The board can only display 5000 issues, and your current board contains {issueCount}. It's time to move some issues."
    },
    tmpBacklogSprintsLimitReachedFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-sprints-limit-reached-flag-body-issue-term-refresh",
        "defaultMessage": "Your backlog and sprint sections can each only display 5000 issues. It's time to move some issues."
    },
    tmpSprintsLimitReachedFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-sprints-limit-reached-flag-body-issue-term-refresh",
        "defaultMessage": "We can only display 5000 issues across all your sprints. It's time to move some issues."
    },
    tmpBacklogLimitReachedFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-limit-reached-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can only display 5000 issues, and your current backlog contains {issueCount}. It's time to move some issues."
    },
    tmpBacklogBoardLimitReachedFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-board-limit-reached-flag-body-issue-term-refresh",
        "defaultMessage": "Your backlog and board sections can each only display 5000 issues. It's time to move some issues."
    }
});

});




parcelRegister("9hLEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $25af9d0222a23099$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $25af9d0222a23099$var$LazyProjectKeyboardShortcuts = (0, $kxZPA.lazy)(()=>(parcelRequire("fVxX7")), {
    moduleId: "./src/packages/software/keyboard-shortcuts/src/ui/project-shortcuts/main.tsx"
});
/**
 * Binds keyboard shortcuts to navigate to the respective experience when enabled:
 * 1 - Backlog
 * 2 - Board
 * 3 - Reports
 * 4 - Timeline
 */ const $25af9d0222a23099$var$ProjectKeyboardShortcuts = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "jira-software-keyboard-shortcuts-project-shortcuts",
        packageName: "jira-software-keyboard-shortcuts",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-software-keyboard-shortcuts",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25af9d0222a23099$var$LazyProjectKeyboardShortcuts, props)));
var $25af9d0222a23099$export$2e2bcd8739ae039 = $25af9d0222a23099$var$ProjectKeyboardShortcuts;

});
parcelRegister("fVxX7", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("3gkNR")
]).then(()=>parcelRequire('9pQJj'));

});


parcelRegister("4bO80", function(module, exports) {

$parcel$export(module.exports, "AsyncJiraStandups", () => $05fe86126f017ca6$export$ef4254228f6901a);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $5E2gE = parcelRequire("5E2gE");

var $2k1C7 = parcelRequire("2k1C7");
const $05fe86126f017ca6$export$ef4254228f6901a = (props)=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = (0, $5uXOq.useContext)((0, $5E2gE.StandupEntryPointContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira-rituals-standups",
        packageName: "jiraRitualsStandups",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2k1C7.LoadingStandupPanel), null),
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};

});
parcelRegister("2k1C7", function(module, exports) {

$parcel$export(module.exports, "LoadingStandupPanel", () => $32c0a49d820a629b$export$e1d0857cb84b4ad3);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");
const $32c0a49d820a629b$export$e1d0857cb84b4ad3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $32c0a49d820a629b$var$spinnerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    }));
const $32c0a49d820a629b$var$spinnerWrapperStyles = (0, $8CUq3.xcss)({
    height: '100%',
    marginLeft: 'space.300',
    zIndex: 'card',
    minWidth: '272px',
    background: "var(--ds-surface, #FFFFFF)",
    borderRadius: 'border.radius.300',
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    marginRight: 'space.negative.300',
    alignItems: 'center',
    justifyContent: 'center'
});

});


parcelRegister("3U6yu", function(module, exports) {

$parcel$export(module.exports, "StorageLimitsBanner", () => $281484b8f4d3a170$export$3250e2c90ae56dd9);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $281484b8f4d3a170$var$LazyStorageLimitBanner = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("54Nx6")), {
    ssr: false,
    moduleId: "./src/packages/growth/storage-limits/src/ui/index.tsx"
});
const $281484b8f4d3a170$export$3250e2c90ae56dd9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: (0, $59503b90ac06f221$export$5dec3c05c01dac30),
        packageName: (0, $59503b90ac06f221$export$b8b9d90f9e5bd72b),
        teamName: "growth-tako",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "storage-limits-banner",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($281484b8f4d3a170$var$LazyStorageLimitBanner, props)));

});
const $59503b90ac06f221$export$bab748d4654ac4a5 = 0.9;
const $59503b90ac06f221$export$b8b9d90f9e5bd72b = 'jiraGrowthStorageLimits';
const $59503b90ac06f221$export$df9953733f41292a = 'storageLimitsBanner';
const $59503b90ac06f221$export$5dec3c05c01dac30 = 'asyncStorageLimitsBanner';
const $59503b90ac06f221$export$3aad3de2cc377789 = 'jira_software_free_is_ccp_billing_admins';

parcelRegister("54Nx6", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("8o7lR").then(()=>parcelRequire('iMYa9'));

});


parcelRegister("baPf2", function(module, exports) {

$parcel$export(module.exports, "UpFlowPersistentUpgradeBanner", () => $56fd693f7a702d43$export$39832316603e4613);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $eSynq = parcelRequire("eSynq");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $56fd693f7a702d43$var$LazyUpFlowPersistentUpgradeBanner = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("8QRNO")), {
    ssr: false,
    moduleId: "./src/packages/growth/up-flow/persistent-upgrade-banner/src/main.tsx"
});
const $56fd693f7a702d43$export$39832316603e4613 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: (0, $eSynq.PERSISTENT_UPGRADE_ANALYTICS_SOURCE),
        packageName: (0, $eSynq.PERSISTENT_UPGRADE_TOUCHPOINT_BANNER),
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "up-flow-persistent-upgrade-banner",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($56fd693f7a702d43$var$LazyUpFlowPersistentUpgradeBanner, props)));

});
parcelRegister("eSynq", function(module, exports) {

$parcel$export(module.exports, "PERSISTENT_UPGRADE_PRE_TRIAL_FREE_EDITION", () => $4cf197dc11aa7836$export$75e961f06f21e171);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_ANALYTICS_SOURCE", () => $4cf197dc11aa7836$export$bebf43b5d37dab0);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_ANALYTICS_UPGRADE_FLOW", () => $4cf197dc11aa7836$export$cbfd75a8d4af5ce5);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_UPFLOW_MODAL_FLOW", () => $4cf197dc11aa7836$export$a2684b22124cc502);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_TOUCHPOINT_BANNER", () => $4cf197dc11aa7836$export$e54a73280ddbd89);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_TOUCHPOINT_BANNER_VIEWED", () => $4cf197dc11aa7836$export$96913d5371f745ad);
$parcel$export(module.exports, "MAX_CADENCE_INDEX", () => $4cf197dc11aa7836$export$b8743c23616e54ee);
$parcel$export(module.exports, "KEY_USER_PROPERTIES_JSW", () => $4cf197dc11aa7836$export$6a69b5601e7d435);
$parcel$export(module.exports, "KEY_USER_PROPERTIES_JSM", () => $4cf197dc11aa7836$export$364c2b43630f5cb5);
$parcel$export(module.exports, "BANNER_CADENCE_INFO", () => $4cf197dc11aa7836$export$ec6ce1b450620e5c);
$parcel$export(module.exports, "SEND_OPERATIONAL_EVENT", () => $4cf197dc11aa7836$export$8b4682bf35504518);
$parcel$export(module.exports, "API_SUCCESS", () => $4cf197dc11aa7836$export$6d01cae610456af2);
$parcel$export(module.exports, "API_FAIL", () => $4cf197dc11aa7836$export$6a238c78062d3b8d);
$parcel$export(module.exports, "GET_USER_PROPERTY_API_CALL", () => $4cf197dc11aa7836$export$d094ee3fcda994eb);
$parcel$export(module.exports, "GET_USER_PROPERTY_API_CALL_SUCCESS", () => $4cf197dc11aa7836$export$8357ebd56fd8e5ea);
$parcel$export(module.exports, "GET_USER_PROPERTY_API_CALL_FAIL", () => $4cf197dc11aa7836$export$252ee5e4ed4943dc);
$parcel$export(module.exports, "SET_USER_PROPERTY_API_CALL", () => $4cf197dc11aa7836$export$f3310dd86ae4284b);
$parcel$export(module.exports, "SET_USER_PROPERTY_API_CALL_SUCCESS", () => $4cf197dc11aa7836$export$5e4635b476d2b497);
$parcel$export(module.exports, "SET_USER_PROPERTY_API_CALL_FAIL", () => $4cf197dc11aa7836$export$b49d6161d5ea4a0a);
$parcel$export(module.exports, "PERSISTENT_PRETRIAL_BANNER_CADENCES_MS", () => $4cf197dc11aa7836$export$55aa1fd7f74b53);
const $4cf197dc11aa7836$export$75e961f06f21e171 = 'pre-trial';
const $4cf197dc11aa7836$export$bebf43b5d37dab0 = 'persistentUpgrade';
const $4cf197dc11aa7836$export$cbfd75a8d4af5ce5 = 'upgradeFlow';
const $4cf197dc11aa7836$export$a2684b22124cc502 = 'persistent-upgrade';
const $4cf197dc11aa7836$export$e54a73280ddbd89 = 'persistentUpgradeBanner';
const $4cf197dc11aa7836$export$96913d5371f745ad = 'persistentUpgradeBanner viewed';
const $4cf197dc11aa7836$export$b8743c23616e54ee = 3;
const $4cf197dc11aa7836$export$6a69b5601e7d435 = 'growth-puet-banner-cadence';
const $4cf197dc11aa7836$export$364c2b43630f5cb5 = 'growth-puet-banner-cadence-jsm';
const $4cf197dc11aa7836$export$ec6ce1b450620e5c = 'Banner Cadence Info';
const $4cf197dc11aa7836$export$8b4682bf35504518 = 'sendOperationalEvent';
const $4cf197dc11aa7836$export$6d01cae610456af2 = 'success';
const $4cf197dc11aa7836$export$6a238c78062d3b8d = 'failed';
const $4cf197dc11aa7836$export$d094ee3fcda994eb = 'getUserPropertyApiCall';
const $4cf197dc11aa7836$export$8357ebd56fd8e5ea = 'getUserPropertyApiCall success';
const $4cf197dc11aa7836$export$252ee5e4ed4943dc = 'getUserPropertyApiCall failed';
const $4cf197dc11aa7836$export$f3310dd86ae4284b = 'setUserPropertyApiCall';
const $4cf197dc11aa7836$export$5e4635b476d2b497 = 'setUserPropertyApiCall success';
const $4cf197dc11aa7836$export$b49d6161d5ea4a0a = 'setUserPropertyApiCall failed';
const $4cf197dc11aa7836$export$55aa1fd7f74b53 = [
    0,
    604800000,
    1814400000,
    3628800000
];

});

parcelRegister("8QRNO", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("PpXIG").then(()=>parcelRequire('iLKFx'));

});


parcelRegister("8TCLJ", function(module, exports) {

$parcel$export(module.exports, "useActiveStandup", () => $cf2c386c440d0536$export$81669f46a3a180e0);

var $5uXOq = parcelRequire("5uXOq");
const $cf2c386c440d0536$export$81669f46a3a180e0 = ()=>{
    const [isActiveStandup, setIsActiveStandup] = (0, $5uXOq.useState)(false);
    return [
        isActiveStandup,
        setIsActiveStandup
    ];
};

});

parcelRegister("7V9GI", function(module, exports) {

$parcel$export(module.exports, "useGICSidebarForcer", () => $b9ee71960aa9a5de$export$23d2fbe817b1786c);

var $5uXOq = parcelRequire("5uXOq");

var $2gCtH = parcelRequire("2gCtH");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");

var $5rzqz = parcelRequire("5rzqz");
const $b9ee71960aa9a5de$export$23d2fbe817b1786c = ()=>{
    const [{ minimizableModalView: minimizableModalView, isModalOpen: isModalOpen }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, $2gCtH.useIssueContextActions)();
    const { subscribe: subscribe } = (0, $9svjh.useGICLifeCycleEvents)();
    /*
    Force issue view into sidebar when gic modal is docked or minimized.
    In the case where a gic modal is opened inside a issue view modal, we prevent forcing the issue view into sidebar as this causes weird visual artifacts.
    This is the only scenario where the issue view and gic modal are opened both simultaneously in modal state.
    */ (0, $5uXOq.useEffect)(()=>{
        if (isModalOpen && (minimizableModalView === 'mini' || minimizableModalView === 'minimized')) // Force TMP issue view into sidebar (without saving to local storage)
        setDetailViewAsSidebar(false);
    }, [
        isModalOpen,
        minimizableModalView,
        setDetailViewAsSidebar
    ]);
    (0, $5uXOq.useEffect)(()=>subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, async ()=>{
            // Reset TMP issue-view's view mode to its previous state
            resetDetailView();
        }), [
        resetDetailView,
        subscribe
    ]);
};

});
parcelRegister("5eGnF", function(module, exports) {

$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $700db8c378cd19d9$export$876003a5b887f37e);
const $700db8c378cd19d9$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("9svjh", function(module, exports) {

$parcel$export(module.exports, "useGICLifeCycleEvents", () => $d9b2e43e4699b192$export$e3ff72f196296fcc);

var $1mrD8 = parcelRequire("1mrD8");
const $d9b2e43e4699b192$var$GICLifeCycleEventsService = new (0, $1mrD8.PubSubHub)();
const $d9b2e43e4699b192$export$e3ff72f196296fcc = ()=>({
        ...$d9b2e43e4699b192$var$GICLifeCycleEventsService
    });

});
parcelRegister("1mrD8", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e);
class $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});



parcelRegister("4wbGn", function(module, exports) {

$parcel$export(module.exports, "useOpenTeamAssociationModal", () => $317ac2d769460958$export$e01903ed0148a5de);

var $5uXOq = parcelRequire("5uXOq");

var $67sX6 = parcelRequire("67sX6");

var $jbAX5 = parcelRequire("jbAX5");

var $fyeGd = parcelRequire("fyeGd");

var $cPGP0 = parcelRequire("cPGP0");

var $63LqY = parcelRequire("63LqY");
const $317ac2d769460958$export$e01903ed0148a5de = ()=>{
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const teams = (0, $67sX6.useBoardSelector)((0, $cPGP0.getTeams));
    const numberOfIterations = Object.keys((0, $67sX6.useBoardSelector)((0, $fyeGd.getColumns))).length - 1;
    const dispatch = (0, $67sX6.useBoardDispatch)();
    (0, $5uXOq.useEffect)(()=>{
        if (isIncrementPlanningBoard && teams) {
            const teamArray = Object.values(teams);
            if (teamArray.length > 0) for (const team of teamArray){
                const numberOfTeamIterations = team.sprintByIterationId && Object.keys(team.sprintByIterationId).length;
                if (numberOfTeamIterations && numberOfTeamIterations > 0 && numberOfTeamIterations < numberOfIterations) {
                    dispatch((0, $jbAX5.openTeamAssociationModal)(team.id));
                    return;
                }
            }
        }
    }, [
        dispatch,
        isIncrementPlanningBoard,
        numberOfIterations,
        teams
    ]);
};

});

parcelRegister("gUmfi", function(module, exports) {

$parcel$export(module.exports, "useProgramBoardEmptyStates", () => $88ede5aca63c85b8$export$f2d7e0ff237d24ef);

var $5uXOq = parcelRequire("5uXOq");

var $jgOYa = parcelRequire("jgOYa");

var $SDugp = parcelRequire("SDugp");

var $edBiZ = parcelRequire("edBiZ");

var $67sX6 = parcelRequire("67sX6");

var $1vXOx = parcelRequire("1vXOx");

var $k8auG = parcelRequire("k8auG");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");
const $88ede5aca63c85b8$export$f2d7e0ff237d24ef = (height)=>{
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const isIncrementPlanning404 = (0, $67sX6.useBoardSelector)((0, $k8auG.isIpBoardFailed));
    const planId = (0, $67sX6.useBoardSelector)((0, $67Z81.getPlanId));
    const boardScopeFilter = (0, $67sX6.useBoardSelector)((0, $67Z81.getBoardScopeFilter));
    const isReadOnly = (0, $67sX6.useBoardSelector)((0, $1vXOx.isIncrementPlanningReadOnly));
    // This change is added because on this branch there's no router resource
    const isLoaded = (0, $67sX6.useBoardSelector)((0, $5mTgl.isBoardConfigLoaded));
    return (0, $5uXOq.useMemo)(()=>{
        if (!isIncrementPlanningBoard) return null;
        if (isIncrementPlanning404) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $SDugp.default), null);
        /**
		 * In program boards of Plans, we always use the JSW board header in compact mode,
		 * therefore we use a different board skeleton which does NOT include placeholders
		 * for page breadcrumbs, page title and board top header actions.
		 */ if (!isLoaded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $edBiZ.ProgramBoardSkeleton), null);
        // Show error screen if custom field not set correctly in program board
        if (boardScopeFilter && boardScopeFilter.filterFieldError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgOYa.default), {
            height: height,
            planId: planId,
            boardScopeFilter: boardScopeFilter,
            isReadOnly: isReadOnly
        });
        return null;
    }, [
        isIncrementPlanningBoard,
        isIncrementPlanning404,
        isLoaded,
        boardScopeFilter,
        planId,
        isReadOnly,
        height
    ]);
};

});
parcelRegister("jgOYa", function(module, exports) {

$parcel$export(module.exports, "default", () => $23f67c0860ec24b3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $4jAPy = parcelRequire("4jAPy");

var $75MXX = parcelRequire("75MXX");

var $1waMP = parcelRequire("1waMP");

var $7Vlm5 = parcelRequire("7Vlm5");

var $9j19P = parcelRequire("9j19P");
const $23f67c0860ec24b3$var$ProgramBoardCustomFieldError = ({ planId: planId, height: height, boardScopeFilter: boardScopeFilter, isReadOnly: isReadOnly })=>{
    let errorScreen;
    switch(boardScopeFilter.filterFieldError){
        case (0, $4jAPy.FILTER_FIELD_ERROR).NOT_IN_PLAN:
            errorScreen = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1waMP.default), {
                planId: planId,
                customFieldId: boardScopeFilter.filterFieldId,
                customFieldName: boardScopeFilter.filterFieldName,
                isReadOnly: isReadOnly
            });
            break;
        case (0, $4jAPy.FILTER_FIELD_ERROR).OPTION_NOT_FOUND:
            errorScreen = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Vlm5.default), {
                customFieldName: boardScopeFilter.filterFieldName,
                isReadOnly: isReadOnly
            });
            break;
        case (0, $4jAPy.FILTER_FIELD_ERROR).NOT_FOUND:
            errorScreen = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $75MXX.default), {
                isReadOnly: isReadOnly
            });
            break;
        default:
            errorScreen = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9j19P.default), {
                customFieldName: boardScopeFilter.filterFieldName,
                isReadOnly: isReadOnly
            });
            break;
    }
    if (height) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($23f67c0860ec24b3$var$Wrapper, {
        height: height
    }, errorScreen);
    return errorScreen;
};
// Need to use style attribute as it's dynamic values.
// See https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-dynamic-styles/usage
const $23f67c0860ec24b3$var$styles = null;
const $23f67c0860ec24b3$var$Wrapper = ({ height: height, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: {
            height: height
        },
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o"
        ])
    }, children);
var $23f67c0860ec24b3$export$2e2bcd8739ae039 = $23f67c0860ec24b3$var$ProgramBoardCustomFieldError;

});
parcelRegister("75MXX", function(module, exports) {

$parcel$export(module.exports, "default", () => $05d7af701bfd033e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $c7i3D = parcelRequire("c7i3D");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $gZK1Z = parcelRequire("gZK1Z");

var $9TVV0 = parcelRequire("9TVV0");

var $2C9Uz = parcelRequire("2C9Uz");

var $4xTtj = parcelRequire("4xTtj");
const $05d7af701bfd033e$var$ProgramBoardCustomFieldNotFound = ({ isReadOnly: isReadOnly })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { incrementId: incrementId } = (0, $9TVV0.usePlanPathParams)();
    const renderPrimaryAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2C9Uz.default), {
            boardId: Number(incrementId),
            triggerLabel: formatMessage((0, $gZK1Z.default).backToBoards),
            isReadOnly: isReadOnly
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c7i3D.default)),
        header: formatMessage((0, $4xTtj.default).title),
        description: formatMessage((0, $4xTtj.default).description),
        primaryAction: renderPrimaryAction()
    }));
};
var $05d7af701bfd033e$export$2e2bcd8739ae039 = $05d7af701bfd033e$var$ProgramBoardCustomFieldNotFound;

});
parcelRegister("c7i3D", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6eff2dc5f73fdbc$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("5BNLu")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $dCLgq = parcelRequire("dCLgq");

var $f3FKt = parcelRequire("f3FKt");

var $5BNLu = parcelRequire("5BNLu");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $e6eff2dc5f73fdbc$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5BNLu)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($f3FKt))
});
var $e6eff2dc5f73fdbc$export$2e2bcd8739ae039 = $e6eff2dc5f73fdbc$var$Illustration;
// for advanced use only
const $e6eff2dc5f73fdbc$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    190
];

});
parcelRegister("f3FKt", function(module, exports) {
module.exports = new URL("search-no-results-darkmode.41158025.svg", import.meta.url).toString();

});

parcelRegister("5BNLu", function(module, exports) {
module.exports = new URL("search-no-results.10b14394.svg", import.meta.url).toString();

});


parcelRegister("9TVV0", function(module, exports) {

$parcel$export(module.exports, "useIncrementsLink", () => $9c909061939eb868$export$a07f720473256a7f);
$parcel$export(module.exports, "usePlanPathParams", () => $9c909061939eb868$export$c7baf9eb4a95d70);

var $dIdda = parcelRequire("dIdda");
const $9c909061939eb868$export$a07f720473256a7f = ()=>{
    const [planId] = (0, $dIdda.usePathParam)('planId');
    const [scenarioId] = (0, $dIdda.usePathParam)('scenarioId');
    return `/jira/plans/${planId}/scenarios/${scenarioId}/program`;
};
const $9c909061939eb868$export$c7baf9eb4a95d70 = ()=>{
    const [planId] = (0, $dIdda.usePathParam)('planId');
    const [scenarioId] = (0, $dIdda.usePathParam)('scenarioId');
    const [incrementId] = (0, $dIdda.usePathParam)('incrementId');
    return {
        planId: planId,
        scenarioId: scenarioId,
        incrementId: incrementId
    };
};

});

parcelRegister("2C9Uz", function(module, exports) {

$parcel$export(module.exports, "default", () => $61593dc1a66f4fa0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AsyncBoardSwitcher", () => $61593dc1a66f4fa0$export$a950beb4c411b3b6);

var $5uXOq = parcelRequire("5uXOq");

var $fn8B5 = parcelRequire("fn8B5");

var $2NMNM = parcelRequire("2NMNM");

var $2rqOp = parcelRequire("2rqOp");

var $eCeGD = parcelRequire("eCeGD");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $6Ingq = parcelRequire("6Ingq");

var $dC5iT = parcelRequire("dC5iT");
var $h9kUS = parcelRequire("h9kUS");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $dIdda = parcelRequire("dIdda");

var $4jAPy = parcelRequire("4jAPy");

var $bdYfL = parcelRequire("bdYfL");

var $6hxv7 = parcelRequire("6hxv7");

var $IewZo = parcelRequire("IewZo");

var $fzC6q = parcelRequire("fzC6q");
const $61593dc1a66f4fa0$var$BoardItem = ({ board: { id: id, name: name }, currentId: currentId, analyticsEvent: analyticsEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        isSelected: id === currentId,
        key: `active-board-${id}`,
        href: (0, $bdYfL.getBoardUrl)(id),
        title: name,
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'switchProgramBoard');
        },
        UNSAFE_shouldDisableRouterLink: true
    }, name);
const $61593dc1a66f4fa0$export$35db6e1ecbb84429 = ({ boardId: boardId, defaultOpen: defaultOpen, onOpenCreateModal: onOpenCreateModal, triggerLabel: triggerLabel, isReadOnly: isReadOnly, returnFocusRef: returnFocusRef })=>{
    const [planId] = (0, $dIdda.usePathParam)('planId');
    const [scenarioId] = (0, $dIdda.usePathParam)('scenarioId');
    const { increments: increments, isLoading: isLoading } = (0, $6hxv7.useFetchIncrements)({
        planId: planId
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'dropdownItem'
    });
    const currentBoard = (0, $5uXOq.useMemo)(()=>increments?.find(({ id: id })=>id === boardId), [
        increments,
        boardId
    ]);
    const groupedOptions = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(increments, 'status'), [
        increments
    ]);
    const activeOptions = groupedOptions.ACTIVE;
    const pastOptions = groupedOptions.PAST;
    const triggerContent = triggerLabel ?? currentBoard?.name;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                ref: triggerRef,
                xcss: $61593dc1a66f4fa0$var$triggerStyles
            }, (0, $4R6GH.fg)('increment_board_a11y_fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
                ...props,
                ref: returnFocusRef,
                isLoading: isLoading,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($6Ingq)))
            }, triggerContent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $61593dc1a66f4fa0$var$placeholderStyles
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
                ...props,
                isLoading: isLoading,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))), {
                    label: ""
                })
            }, triggerContent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $61593dc1a66f4fa0$var$placeholderStyles
            }))),
        returnFocusRef: returnFocusRef,
        shouldRenderToParent: true,
        isLoading: isLoading,
        placement: "bottom-start",
        defaultOpen: defaultOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $61593dc1a66f4fa0$var$boardGroupStyles
    }, activeOptions && activeOptions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        title: `${formatMessage((0, $fzC6q.default).activeGroupLabel)} (${activeOptions.length}/${(0, $4jAPy.MAX_ACTIVE_BOARDS)})`
    }, activeOptions.map((board)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($61593dc1a66f4fa0$var$BoardItem, {
            key: `active-board-${board.id}`,
            board: board,
            currentId: currentBoard?.id,
            analyticsEvent: analyticsEvent
        }))), pastOptions && pastOptions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        title: formatMessage((0, $fzC6q.default).pastGroupLabel)
    }, pastOptions.map((board)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($61593dc1a66f4fa0$var$BoardItem, {
            key: `past-board-${board.id}`,
            board: board,
            currentId: currentBoard?.id,
            analyticsEvent: analyticsEvent
        })))), !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        testId: "portfolio-3-plan-increment-common.ui.board-switcher.create-button",
        isDisabled: activeOptions && activeOptions.length >= (0, $4jAPy.MAX_ACTIVE_BOARDS),
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createProgramBoard');
            onOpenCreateModal();
        }
    }, formatMessage((0, $fzC6q.default).createProgramBoard)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        href: (0, $bdYfL.getManageBoardSettingsUrl)(planId, scenarioId),
        title: formatMessage((0, $fzC6q.default).manageProgramBoardsTitle),
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'manageProgramBoards');
        },
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $fzC6q.default).manageProgramBoards))));
};
const $61593dc1a66f4fa0$var$BoardSwitcher = ({ boardId: boardId, defaultOpen: defaultOpen, triggerLabel: triggerLabel, isReadOnly: isReadOnly })=>{
    const [isCreateBoardModalOpen, setIsCreateBoardModalOpen] = (0, $5uXOq.useState)(false);
    const openCreateBoardModal = ()=>{
        setIsCreateBoardModalOpen(true);
    };
    const closeCreateBoardModal = ()=>{
        setIsCreateBoardModalOpen(false);
    };
    const onIncrementCreated = (newBoard)=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.replace((0, $bdYfL.getBoardUrl)(newBoard.id));
    };
    const returnFocusRef = (0, $5uXOq.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $IewZo.default), {
        onIncrementCreated: onIncrementCreated,
        isOpen: isCreateBoardModalOpen,
        onClose: closeCreateBoardModal,
        returnFocusRef: (0, $4R6GH.fg)('increment_board_a11y_fix') ? returnFocusRef : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($61593dc1a66f4fa0$export$35db6e1ecbb84429, {
        boardId: boardId,
        defaultOpen: defaultOpen,
        onOpenCreateModal: openCreateBoardModal,
        triggerLabel: triggerLabel,
        isReadOnly: isReadOnly,
        returnFocusRef: (0, $4R6GH.fg)('increment_board_a11y_fix') ? returnFocusRef : undefined
    }));
};
var $61593dc1a66f4fa0$export$2e2bcd8739ae039 = $61593dc1a66f4fa0$var$BoardSwitcher;
const $61593dc1a66f4fa0$export$a950beb4c411b3b6 = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($61593dc1a66f4fa0$var$BoardSwitcher, props);
const $61593dc1a66f4fa0$var$boardGroupStyles = (0, $8CUq3.xcss)({
    maxHeight: '600px',
    overflow: 'auto',
    textAlign: 'left'
});
const $61593dc1a66f4fa0$var$triggerStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.200',
    maxWidth: '175px',
    [(0, $h9kUS.media).above.md]: {
        maxWidth: '240px'
    },
    [(0, $h9kUS.media).above.lg]: {
        maxWidth: '280px'
    }
});
const $61593dc1a66f4fa0$var$placeholderStyles = (0, $8CUq3.xcss)({
    width: '80px'
});

});
parcelRegister("6hxv7", function(module, exports) {

$parcel$export(module.exports, "useFetchIncrements", () => $8d1e4e92884d6028$export$6a3590fbd5adac6d);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $4jAPy = parcelRequire("4jAPy");
const $8d1e4e92884d6028$export$6a3590fbd5adac6d = ({ planId: planId })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const [increments, setIncrements] = (0, $5uXOq.useState)(null);
    const removeIncrement = (incrementId)=>{
        if (!increments) return;
        const index = increments?.findIndex((increment)=>increment.id === incrementId);
        if (index !== undefined && index > -1) {
            const newIncrements = [
                ...increments
            ];
            newIncrements.splice(index, 1);
            setIncrements(newIncrements);
        }
    };
    const updateIncrement = ({ incrementId: incrementId, newName: newName })=>{
        if (!increments) return;
        const index = increments?.findIndex((increment)=>increment.id === incrementId);
        if (index !== undefined && index > -1 && increments[index].name !== newName) {
            const newIncrements = [
                ...increments
            ];
            newIncrements[index] = {
                ...newIncrements[index],
                name: newName
            };
            setIncrements(newIncrements);
        }
    };
    (0, $5uXOq.useEffect)(()=>{
        (async ()=>{
            try {
                if (!planId) throw new Error('planId is empty in the fetch increments request');
                const res = await (0, $eusud.performGetRequest)(`/rest/jpo/2.0/plans/${planId}/increments`);
                if (res && Array.isArray(res)) setIncrements(res);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useLinkSprints',
                        packageName: (0, $4jAPy.PACKAGE_NAME),
                        teamName: (0, $4jAPy.ERROR_REPORTING_TEAM)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            } finally{
                setIsLoading(false);
            }
        })();
    }, [
        setIncrements,
        setIsLoading,
        planId
    ]);
    return {
        isLoading: isLoading,
        increments: increments,
        removeIncrement: removeIncrement,
        updateIncrement: updateIncrement
    };
};

});

parcelRegister("IewZo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebca1acda4a784ab$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fWqG2 = parcelRequire("fWqG2");

var $2NMNM = parcelRequire("2NMNM");

var $fVnbM = parcelRequire("fVnbM");

var $ldJSL = parcelRequire("ldJSL");

var $htnpT = parcelRequire("htnpT");

var $efXp3 = parcelRequire("efXp3");
var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");
var $3lQ26 = parcelRequire("3lQ26");

var $1dJ6S = parcelRequire("1dJ6S");

var $lLLkM = parcelRequire("lLLkM");

var $e4yMr = parcelRequire("e4yMr");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");

var $7K5PP = parcelRequire("7K5PP");

var $kY99m = parcelRequire("kY99m");


var $hO2mG = parcelRequire("hO2mG");

var $gwIPs = parcelRequire("gwIPs");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $DVljb = parcelRequire("DVljb");

var $4jAPy = parcelRequire("4jAPy");

var $1FeOe = parcelRequire("1FeOe");

var $ivHJ6 = parcelRequire("ivHJ6");

var $h9qPG = parcelRequire("h9qPG");

var $1bxch = parcelRequire("1bxch");

var $7pWV1 = parcelRequire("7pWV1");

var $84ylG = parcelRequire("84ylG");

var $7gW1a = parcelRequire("7gW1a");

var $iHezY = parcelRequire("iHezY");
const $ebca1acda4a784ab$var$DOC_LINK = 'https://support.atlassian.com/jira-software-cloud/docs/create-a-new-program-board-in-your-plan/';
const $ebca1acda4a784ab$var$IncrementCreation = ({ onIncrementCreated: onIncrementCreated, isOpen: isOpen = false, onClose: onClose, returnFocusRef: returnFocusRef })=>{
    const { saving: saving, error: error, save: save } = (0, $ivHJ6.useIncrementCreationService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const locale = (0, $DVljb.useLocale)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleCancelButtonClick = (0, $5uXOq.useCallback)(()=>{
        onClose();
    }, [
        onClose
    ]);
    const focusRef = (0, $5uXOq.useRef)();
    const getStartDate = (0, $5uXOq.useCallback)(()=>(0, $7gW1a.getNextQuarterStartDate)(new Date()), []);
    const handleSubmitForm = (0, $5uXOq.useCallback)(async (data)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errorMessages = {};
        if ((data.name?.length || 0) < 1) errorMessages.name = formatMessage((0, $iHezY.default).nameEmptyError);
        if ((data.start?.length || 0) < 1) errorMessages.start = formatMessage((0, $iHezY.default).startDateEmptyError);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(data.filterFieldId) && (0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(data.filterFieldValue)) errorMessages.filterFieldValue = formatMessage((0, $iHezY.default).fieldValueEmptyError);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(data.name) || (0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(data.start) || Object.keys(errorMessages).length > 0) return errorMessages;
        const newBoard = {
            name: data.name,
            start: new Date(data.start).getTime(),
            iterationsCount: (0, $4R6GH.fg)('program_board_flexible_cadence') ? data.iterationsCount?.value : (0, $4jAPy.DEFAULT_ITERATIONS_COUNT),
            iterationLength: (0, $4R6GH.fg)('program_board_flexible_cadence') ? data.iterationLength?.value : (0, $4jAPy.DEFAULT_ITERATION_LENGTH),
            filterFieldId: data.filterFieldId?.value,
            filterFieldValue: data.filterFieldValue?.value
        };
        const result = await save(newBoard);
        if (result !== undefined) {
            const attributes = (0, $4R6GH.fg)('program_board_flexible_cadence') ? {
                iterationLength: data.iterationLength?.value,
                iterationsCount: data.iterationsCount?.value
            } : {};
            onIncrementCreated(result);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'added',
                actionSubject: 'programBoard'
            }), {
                ...attributes
            });
            onClose();
        }
    }, [
        save,
        onIncrementCreated,
        onClose,
        formatMessage,
        createAnalyticsEvent
    ]);
    const scopeFilterMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iHezY.default).scopeFilterDescriptionIssueTermRefresh : (0, $iHezY.default).scopeFilterDescription;
    const scopeFilterDescription = formatMessage(scopeFilterMessage, {
        bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, chunks)
    });
    const iterationLengthOptions = [
        {
            label: formatMessage((0, $1FeOe.default).weeksOption, {
                count: 1
            }),
            value: 1
        },
        {
            label: formatMessage((0, $1FeOe.default).weeksOption, {
                count: 2
            }),
            value: 2
        },
        {
            label: formatMessage((0, $1FeOe.default).weeksOption, {
                count: 3
            }),
            value: 3
        },
        {
            label: formatMessage((0, $1FeOe.default).weeksOption, {
                count: 4
            }),
            value: 4
        }
    ];
    const defaultLengthOption = iterationLengthOptions.find(({ value: value })=>value === (0, $4jAPy.DEFAULT_ITERATION_LENGTH));
    const filterHeadingMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iHezY.default).scopeFilterHeadingIssueTermRefresh : (0, $iHezY.default).scopeFilterHeading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "incrementCreation",
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        onClose: handleCancelButtonClick,
        autoFocus: focusRef,
        shouldReturnFocus: returnFocusRef && (0, $4R6GH.fg)('increment_board_a11y_fix') ? returnFocusRef : true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, formatMessage((0, $iHezY.default).addIncrementTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ebca1acda4a784ab$var$paragraphStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $4R6GH.fg)('program_board_flexible_cadence') ? (0, $iHezY.default).addIncrementDescriptionNew : (0, $iHezY.default).addIncrementDescription), (0, $4R6GH.fg)('program_board_flexible_cadence') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: $ebca1acda4a784ab$var$DOC_LINK,
        target: "_blank"
    }, formatMessage((0, $iHezY.default).doclink)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ebca1acda4a784ab$var$ModalClose, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        spacing: "none",
        onClick: handleCancelButtonClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lLLkM))), {
        label: formatMessage((0, $iHezY.default).closeModal),
        primaryColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        onSubmit: handleSubmitForm
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ebca1acda4a784ab$var$FormStyled, formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, (0, $4R6GH.fg)('program_board_flexible_cadence') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $ebca1acda4a784ab$var$FieldBoxStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            "aria-required": true,
            name: "name",
            testId: "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.name-field",
            label: formatMessage((0, $4R6GH.fg)('program_board_flexible_cadence') ? (0, $iHezY.default).nameShort : (0, $iHezY.default).name),
            defaultValue: ""
        }, // eslint-disable-next-line @typescript-eslint/no-shadow
        ({ fieldProps: fieldProps, error: error, valid: valid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                autoComplete: "off",
                placeholder: formatMessage((0, $iHezY.default).namePlaceholder),
                maxLength: 255,
                ...fieldProps,
                ref: focusRef
            }), valid || error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), {
                testId: "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.user-submission-error"
            }, error)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $ebca1acda4a784ab$var$FieldBoxStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            "aria-required": true,
            name: "start",
            testId: "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.start-date-field",
            label: formatMessage((0, $4R6GH.fg)('program_board_flexible_cadence') ? (0, $iHezY.default).startDateShort : (0, $iHezY.default).startDate),
            defaultValue: getStartDate()
        }, // eslint-disable-next-line @typescript-eslint/no-shadow
        ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htnpT.default), {
                ...fieldProps,
                locale: locale,
                datePickerProps: {
                    weekStartDay: (0, $7gW1a.getWeekStartDay)(locale)
                },
                timePickerProps: {
                    times: (0, $hO2mG.getDefaultTimes)()
                },
                testId: "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.start-date-picker"
            }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, error))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $ebca1acda4a784ab$var$FieldBoxStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            label: formatMessage((0, $iHezY.default).iterationLength),
            name: "iterationLength",
            defaultValue: defaultLengthOption
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
                ...fieldProps,
                options: iterationLengthOptions,
                styles: {
                    menuPortal: (base)=>({
                            ...base,
                            zIndex: (0, $gwIPs.layers).modal
                        })
                },
                menuPortalTarget: document.body
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $ebca1acda4a784ab$var$FieldBoxStyles
        }, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            label: formatMessage((0, $iHezY.default).iterationsCount),
            name: "iterationsCount",
            defaultValue: (0, $4jAPy.ITERATIONS_COUNT_OPTIONS).find(({ value: value })=>value === (0, $4jAPy.DEFAULT_ITERATIONS_COUNT))
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $84ylG.default), fieldProps))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1bxch.default), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            "aria-required": true,
            name: "name",
            testId: "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.name-field",
            label: formatMessage((0, $iHezY.default).name),
            defaultValue: ""
        }, // eslint-disable-next-line @typescript-eslint/no-shadow
        ({ fieldProps: fieldProps, error: error, valid: valid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                autoComplete: "off",
                placeholder: formatMessage((0, $iHezY.default).namePlaceholder),
                maxLength: 255,
                ...fieldProps,
                ref: focusRef
            }), valid || error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), {
                testId: "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.user-submission-error"
            }, error))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            "aria-required": true,
            name: "start",
            testId: "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.start-date-field",
            label: formatMessage((0, $iHezY.default).startDate),
            defaultValue: getStartDate()
        }, // eslint-disable-next-line @typescript-eslint/no-shadow
        ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htnpT.default), {
                ...fieldProps,
                locale: locale,
                datePickerProps: {
                    weekStartDay: (0, $7gW1a.getWeekStartDay)(locale)
                },
                timePickerProps: {
                    times: (0, $hO2mG.getDefaultTimes)()
                },
                testId: "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.start-date-picker"
            }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, error)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3lQ26.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1dJ6S.default), {
            size: "medium",
            as: (0, $4R6GH.fg)('increment_board_a11y_fix') ? 'h2' : undefined
        }, formatMessage(filterHeadingMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $ebca1acda4a784ab$var$paragraphStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p"
        }, scopeFilterDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            spread: "space-between",
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h9qPG.ScopeFilterField), {
            shouldFetchCustomFields: isOpen
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h9qPG.ScopeFilterValue), null))), !(0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(error) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3lQ26.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
            appearance: "error"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $ebca1acda4a784ab$var$paragraphStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p"
        }, formatMessage((0, $iHezY.default).errorLabel)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7pWV1.default), {
            initialStartDate: getStartDate()
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            testId: "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.cancel-button",
            onClick: handleCancelButtonClick,
            isDisabled: saving || submitting
        }, formatMessage((0, $iHezY.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            type: "submit",
            testId: "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.submit-button",
            appearance: "primary",
            isDisabled: saving || submitting
        }, formatMessage((0, $iHezY.default).submit)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null))));
};
var $ebca1acda4a784ab$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $ebca1acda4a784ab$var$IncrementCreation;
const $ebca1acda4a784ab$var$ModalClose = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1wpz1y6m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ebca1acda4a784ab$var$FormStyled = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf",
            __cmplp.className
        ])
    });
});
const $ebca1acda4a784ab$var$FieldBoxStyles = (0, $8CUq3.xcss)({
    width: '50%'
});
const $ebca1acda4a784ab$var$paragraphStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.150'
});

});
parcelRegister("fWqG2", function(module, exports) {

var $lVx1a = parcelRequire("lVx1a");


var $b9b0f74db222943d$var$func = $lVx1a('isNil', (parcelRequire("hGgHi")), (parcelRequire("bUoRH")));

$b9b0f74db222943d$var$func.placeholder = (parcelRequire("aPsMW"));
module.exports = $b9b0f74db222943d$var$func;

});
parcelRegister("lVx1a", function(module, exports) {

var $iIayQ = parcelRequire("iIayQ");

var $7sR67 = parcelRequire("7sR67");
/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $ff688881095ae098$var$convert(name, func, options) {
    return $iIayQ($7sR67, name, func, options);
}
module.exports = $ff688881095ae098$var$convert;

});
parcelRegister("iIayQ", function(module, exports) {

var $lTdwm = parcelRequire("lTdwm");

var $aPsMW = parcelRequire("aPsMW");
/** Built-in value reference. */ var $d9f487426e0f9b59$var$push = Array.prototype.push;
/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */ function $d9f487426e0f9b59$var$baseArity(func, n) {
    return n == 2 ? function(a, b) {
        return func.apply(undefined, arguments);
    } : function(a) {
        return func.apply(undefined, arguments);
    };
}
/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */ function $d9f487426e0f9b59$var$baseAry(func, n) {
    return n == 2 ? function(a, b) {
        return func(a, b);
    } : function(a) {
        return func(a);
    };
}
/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */ function $d9f487426e0f9b59$var$cloneArray(array) {
    var length = array ? array.length : 0, result = Array(length);
    while(length--)result[length] = array[length];
    return result;
}
/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */ function $d9f487426e0f9b59$var$createCloner(func) {
    return function(object) {
        return func({}, object);
    };
}
/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */ function $d9f487426e0f9b59$var$flatSpread(func, start) {
    return function() {
        var length = arguments.length, lastIndex = length - 1, args = Array(length);
        while(length--)args[length] = arguments[length];
        var array = args[start], otherArgs = args.slice(0, start);
        if (array) $d9f487426e0f9b59$var$push.apply(otherArgs, array);
        if (start != lastIndex) $d9f487426e0f9b59$var$push.apply(otherArgs, args.slice(start + 1));
        return func.apply(this, otherArgs);
    };
}
/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */ function $d9f487426e0f9b59$var$wrapImmutable(func, cloner) {
    return function() {
        var length = arguments.length;
        if (!length) return;
        var args = Array(length);
        while(length--)args[length] = arguments[length];
        var result = args[0] = cloner.apply(undefined, args);
        func.apply(undefined, args);
        return result;
    };
}
/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $d9f487426e0f9b59$var$baseConvert(util, name, func, options) {
    var isLib = typeof name == 'function', isObj = name === Object(name);
    if (isObj) {
        options = func;
        func = name;
        name = undefined;
    }
    if (func == null) throw new TypeError;
    options || (options = {});
    var config = {
        'cap': 'cap' in options ? options.cap : true,
        'curry': 'curry' in options ? options.curry : true,
        'fixed': 'fixed' in options ? options.fixed : true,
        'immutable': 'immutable' in options ? options.immutable : true,
        'rearg': 'rearg' in options ? options.rearg : true
    };
    var defaultHolder = isLib ? func : $aPsMW, forceCurry = 'curry' in options && options.curry, forceFixed = 'fixed' in options && options.fixed, forceRearg = 'rearg' in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
    var helpers = isLib ? func : {
        'ary': util.ary,
        'assign': util.assign,
        'clone': util.clone,
        'curry': util.curry,
        'forEach': util.forEach,
        'isArray': util.isArray,
        'isError': util.isError,
        'isFunction': util.isFunction,
        'isWeakMap': util.isWeakMap,
        'iteratee': util.iteratee,
        'keys': util.keys,
        'rearg': util.rearg,
        'toInteger': util.toInteger,
        'toPath': util.toPath
    };
    var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
    var aryMethodKeys = keys($lTdwm.aryMethod);
    var wrappers = {
        'castArray': function(castArray) {
            return function() {
                var value = arguments[0];
                return isArray(value) ? castArray($d9f487426e0f9b59$var$cloneArray(value)) : castArray.apply(undefined, arguments);
            };
        },
        'iteratee': function(iteratee) {
            return function() {
                var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                if (config.cap && typeof arity == 'number') {
                    arity = arity > 2 ? arity - 2 : 1;
                    return length && length <= arity ? result : $d9f487426e0f9b59$var$baseAry(result, arity);
                }
                return result;
            };
        },
        'mixin': function(mixin) {
            return function(source) {
                var func = this;
                if (!isFunction(func)) return mixin(func, Object(source));
                var pairs = [];
                each(keys(source), function(key) {
                    if (isFunction(source[key])) pairs.push([
                        key,
                        func.prototype[key]
                    ]);
                });
                mixin(func, Object(source));
                each(pairs, function(pair) {
                    var value = pair[1];
                    if (isFunction(value)) func.prototype[pair[0]] = value;
                    else delete func.prototype[pair[0]];
                });
                return func;
            };
        },
        'nthArg': function(nthArg) {
            return function(n) {
                var arity = n < 0 ? 1 : toInteger(n) + 1;
                return curry(nthArg(n), arity);
            };
        },
        'rearg': function(rearg) {
            return function(func, indexes) {
                var arity = indexes ? indexes.length : 0;
                return curry(rearg(func, indexes), arity);
            };
        },
        'runInContext': function(runInContext) {
            return function(context) {
                return $d9f487426e0f9b59$var$baseConvert(util, runInContext(context), options);
            };
        }
    };
    /*--------------------------------------------------------------------------*/ /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */ function castCap(name, func) {
        if (config.cap) {
            var indexes = $lTdwm.iterateeRearg[name];
            if (indexes) return iterateeRearg(func, indexes);
            var n = !isLib && $lTdwm.iterateeAry[name];
            if (n) return iterateeAry(func, n);
        }
        return func;
    }
    /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castCurry(name, func, n) {
        return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
    }
    /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */ function castFixed(name, func, n) {
        if (config.fixed && (forceFixed || !$lTdwm.skipFixed[name])) {
            var data = $lTdwm.methodSpread[name], start = data && data.start;
            return start === undefined ? ary(func, n) : $d9f487426e0f9b59$var$flatSpread(func, start);
        }
        return func;
    }
    /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castRearg(name, func, n) {
        return config.rearg && n > 1 && (forceRearg || !$lTdwm.skipRearg[name]) ? rearg(func, $lTdwm.methodRearg[name] || $lTdwm.aryRearg[n]) : func;
    }
    /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */ function cloneByPath(object, path) {
        path = toPath(path);
        var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
        while(nested != null && ++index < length){
            var key = path[index], value = nested[key];
            if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
            nested = nested[key];
        }
        return result;
    }
    /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */ function convertLib(options) {
        return _.runInContext.convert(options)(undefined);
    }
    /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */ function createConverter(name, func) {
        var realName = $lTdwm.aliasToReal[name] || name, methodName = $lTdwm.remap[realName] || realName, oldOptions = options;
        return function(options) {
            var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
            return $d9f487426e0f9b59$var$baseConvert(newUtil, realName, newFunc, newOptions);
        };
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */ function iterateeAry(func, n) {
        return overArg(func, function(func) {
            return typeof func == 'function' ? $d9f487426e0f9b59$var$baseAry(func, n) : func;
        });
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */ function iterateeRearg(func, indexes) {
        return overArg(func, function(func) {
            var n = indexes.length;
            return $d9f487426e0f9b59$var$baseArity(rearg($d9f487426e0f9b59$var$baseAry(func, n), indexes), n);
        });
    }
    /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function() {
            var length = arguments.length;
            if (!length) return func();
            var args = Array(length);
            while(length--)args[length] = arguments[length];
            var index = config.rearg ? 0 : length - 1;
            args[index] = transform(args[index]);
            return func.apply(undefined, args);
        };
    }
    /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */ function wrap(name, func, placeholder) {
        var result, realName = $lTdwm.aliasToReal[name] || name, wrapped = func, wrapper = wrappers[realName];
        if (wrapper) wrapped = wrapper(func);
        else if (config.immutable) {
            if ($lTdwm.mutate.array[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, $d9f487426e0f9b59$var$cloneArray);
            else if ($lTdwm.mutate.object[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, $d9f487426e0f9b59$var$createCloner(func));
            else if ($lTdwm.mutate.set[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, cloneByPath);
        }
        each(aryMethodKeys, function(aryKey) {
            each($lTdwm.aryMethod[aryKey], function(otherName) {
                if (realName == otherName) {
                    var data = $lTdwm.methodSpread[realName], afterRearg = data && data.afterRearg;
                    result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                    result = castCap(realName, result);
                    result = castCurry(realName, result, aryKey);
                    return false;
                }
            });
            return !result;
        });
        result || (result = wrapped);
        if (result == func) result = forceCurry ? curry(result, 1) : function() {
            return func.apply(this, arguments);
        };
        result.convert = createConverter(realName, func);
        result.placeholder = func.placeholder = placeholder;
        return result;
    }
    /*--------------------------------------------------------------------------*/ if (!isObj) return wrap(name, func, defaultHolder);
    var _ = func;
    // Convert methods by ary cap.
    var pairs = [];
    each(aryMethodKeys, function(aryKey) {
        each($lTdwm.aryMethod[aryKey], function(key) {
            var func = _[$lTdwm.remap[key] || key];
            if (func) pairs.push([
                key,
                wrap(key, func, _)
            ]);
        });
    });
    // Convert remaining methods.
    each(keys(_), function(key) {
        var func = _[key];
        if (typeof func == 'function') {
            var length = pairs.length;
            while(length--){
                if (pairs[length][0] == key) return;
            }
            func.convert = createConverter(key, func);
            pairs.push([
                key,
                func
            ]);
        }
    });
    // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
    each(pairs, function(pair) {
        _[pair[0]] = pair[1];
    });
    _.convert = convertLib;
    _.placeholder = _;
    // Assign aliases.
    each(keys(_), function(key) {
        each($lTdwm.realToAlias[key] || [], function(alias) {
            _[alias] = _[key];
        });
    });
    return _;
}
module.exports = $d9f487426e0f9b59$var$baseConvert;

});
parcelRegister("lTdwm", function(module, exports) {

$parcel$export(module.exports, "aliasToReal", () => $fef938fb92c31507$export$bd0f5e6e44efa6b4, (v) => $fef938fb92c31507$export$bd0f5e6e44efa6b4 = v);
$parcel$export(module.exports, "aryMethod", () => $fef938fb92c31507$export$85c665b4d7da9cb4, (v) => $fef938fb92c31507$export$85c665b4d7da9cb4 = v);
$parcel$export(module.exports, "aryRearg", () => $fef938fb92c31507$export$42564e045b285e32, (v) => $fef938fb92c31507$export$42564e045b285e32 = v);
$parcel$export(module.exports, "iterateeAry", () => $fef938fb92c31507$export$81e17196e6a22b07, (v) => $fef938fb92c31507$export$81e17196e6a22b07 = v);
$parcel$export(module.exports, "iterateeRearg", () => $fef938fb92c31507$export$30975ceb42167ebd, (v) => $fef938fb92c31507$export$30975ceb42167ebd = v);
$parcel$export(module.exports, "methodRearg", () => $fef938fb92c31507$export$8ceb0ad7e94d3801, (v) => $fef938fb92c31507$export$8ceb0ad7e94d3801 = v);
$parcel$export(module.exports, "methodSpread", () => $fef938fb92c31507$export$fbaeb3f87df3cf26, (v) => $fef938fb92c31507$export$fbaeb3f87df3cf26 = v);
$parcel$export(module.exports, "mutate", () => $fef938fb92c31507$export$57e795267c26e600, (v) => $fef938fb92c31507$export$57e795267c26e600 = v);
$parcel$export(module.exports, "realToAlias", () => $fef938fb92c31507$export$1eb71a7e27943e71, (v) => $fef938fb92c31507$export$1eb71a7e27943e71 = v);
$parcel$export(module.exports, "remap", () => $fef938fb92c31507$export$aee1dbae5de2db9d, (v) => $fef938fb92c31507$export$aee1dbae5de2db9d = v);
$parcel$export(module.exports, "skipFixed", () => $fef938fb92c31507$export$87ffbe4821a5d5e0, (v) => $fef938fb92c31507$export$87ffbe4821a5d5e0 = v);
$parcel$export(module.exports, "skipRearg", () => $fef938fb92c31507$export$b4d07413ce528c90, (v) => $fef938fb92c31507$export$b4d07413ce528c90 = v);
/** Used to map aliases to their real names. */ var $fef938fb92c31507$export$bd0f5e6e44efa6b4;
/** Used to map ary to method names. */ var $fef938fb92c31507$export$85c665b4d7da9cb4;
/** Used to map ary to rearg configs. */ var $fef938fb92c31507$export$42564e045b285e32;
/** Used to map method names to their iteratee ary. */ var $fef938fb92c31507$export$81e17196e6a22b07;
/** Used to map method names to iteratee rearg configs. */ var $fef938fb92c31507$export$30975ceb42167ebd;
/** Used to map method names to rearg configs. */ var $fef938fb92c31507$export$8ceb0ad7e94d3801;
/** Used to map method names to spread configs. */ var $fef938fb92c31507$export$fbaeb3f87df3cf26;
/** Used to identify methods which mutate arrays or objects. */ var $fef938fb92c31507$export$57e795267c26e600;
/** Used to map real names to their aliases. */ var $fef938fb92c31507$export$1eb71a7e27943e71;
/** Used to map method names to other names. */ var $fef938fb92c31507$export$aee1dbae5de2db9d;
/** Used to track methods that skip fixing their arity. */ var $fef938fb92c31507$export$87ffbe4821a5d5e0;
/** Used to track methods that skip rearranging arguments. */ var $fef938fb92c31507$export$b4d07413ce528c90;
$fef938fb92c31507$export$bd0f5e6e44efa6b4 = {
    // Lodash aliases.
    'each': 'forEach',
    'eachRight': 'forEachRight',
    'entries': 'toPairs',
    'entriesIn': 'toPairsIn',
    'extend': 'assignIn',
    'extendAll': 'assignInAll',
    'extendAllWith': 'assignInAllWith',
    'extendWith': 'assignInWith',
    'first': 'head',
    // Methods that are curried variants of others.
    'conforms': 'conformsTo',
    'matches': 'isMatch',
    'property': 'get',
    // Ramda aliases.
    '__': 'placeholder',
    'F': 'stubFalse',
    'T': 'stubTrue',
    'all': 'every',
    'allPass': 'overEvery',
    'always': 'constant',
    'any': 'some',
    'anyPass': 'overSome',
    'apply': 'spread',
    'assoc': 'set',
    'assocPath': 'set',
    'complement': 'negate',
    'compose': 'flowRight',
    'contains': 'includes',
    'dissoc': 'unset',
    'dissocPath': 'unset',
    'dropLast': 'dropRight',
    'dropLastWhile': 'dropRightWhile',
    'equals': 'isEqual',
    'identical': 'eq',
    'indexBy': 'keyBy',
    'init': 'initial',
    'invertObj': 'invert',
    'juxt': 'over',
    'omitAll': 'omit',
    'nAry': 'ary',
    'path': 'get',
    'pathEq': 'matchesProperty',
    'pathOr': 'getOr',
    'paths': 'at',
    'pickAll': 'pick',
    'pipe': 'flow',
    'pluck': 'map',
    'prop': 'get',
    'propEq': 'matchesProperty',
    'propOr': 'getOr',
    'props': 'at',
    'symmetricDifference': 'xor',
    'symmetricDifferenceBy': 'xorBy',
    'symmetricDifferenceWith': 'xorWith',
    'takeLast': 'takeRight',
    'takeLastWhile': 'takeRightWhile',
    'unapply': 'rest',
    'unnest': 'flatten',
    'useWith': 'overArgs',
    'where': 'conformsTo',
    'whereEq': 'isMatch',
    'zipObj': 'zipObject'
};
$fef938fb92c31507$export$85c665b4d7da9cb4 = {
    '1': [
        'assignAll',
        'assignInAll',
        'attempt',
        'castArray',
        'ceil',
        'create',
        'curry',
        'curryRight',
        'defaultsAll',
        'defaultsDeepAll',
        'floor',
        'flow',
        'flowRight',
        'fromPairs',
        'invert',
        'iteratee',
        'memoize',
        'method',
        'mergeAll',
        'methodOf',
        'mixin',
        'nthArg',
        'over',
        'overEvery',
        'overSome',
        'rest',
        'reverse',
        'round',
        'runInContext',
        'spread',
        'template',
        'trim',
        'trimEnd',
        'trimStart',
        'uniqueId',
        'words',
        'zipAll'
    ],
    '2': [
        'add',
        'after',
        'ary',
        'assign',
        'assignAllWith',
        'assignIn',
        'assignInAllWith',
        'at',
        'before',
        'bind',
        'bindAll',
        'bindKey',
        'chunk',
        'cloneDeepWith',
        'cloneWith',
        'concat',
        'conformsTo',
        'countBy',
        'curryN',
        'curryRightN',
        'debounce',
        'defaults',
        'defaultsDeep',
        'defaultTo',
        'delay',
        'difference',
        'divide',
        'drop',
        'dropRight',
        'dropRightWhile',
        'dropWhile',
        'endsWith',
        'eq',
        'every',
        'filter',
        'find',
        'findIndex',
        'findKey',
        'findLast',
        'findLastIndex',
        'findLastKey',
        'flatMap',
        'flatMapDeep',
        'flattenDepth',
        'forEach',
        'forEachRight',
        'forIn',
        'forInRight',
        'forOwn',
        'forOwnRight',
        'get',
        'groupBy',
        'gt',
        'gte',
        'has',
        'hasIn',
        'includes',
        'indexOf',
        'intersection',
        'invertBy',
        'invoke',
        'invokeMap',
        'isEqual',
        'isMatch',
        'join',
        'keyBy',
        'lastIndexOf',
        'lt',
        'lte',
        'map',
        'mapKeys',
        'mapValues',
        'matchesProperty',
        'maxBy',
        'meanBy',
        'merge',
        'mergeAllWith',
        'minBy',
        'multiply',
        'nth',
        'omit',
        'omitBy',
        'overArgs',
        'pad',
        'padEnd',
        'padStart',
        'parseInt',
        'partial',
        'partialRight',
        'partition',
        'pick',
        'pickBy',
        'propertyOf',
        'pull',
        'pullAll',
        'pullAt',
        'random',
        'range',
        'rangeRight',
        'rearg',
        'reject',
        'remove',
        'repeat',
        'restFrom',
        'result',
        'sampleSize',
        'some',
        'sortBy',
        'sortedIndex',
        'sortedIndexOf',
        'sortedLastIndex',
        'sortedLastIndexOf',
        'sortedUniqBy',
        'split',
        'spreadFrom',
        'startsWith',
        'subtract',
        'sumBy',
        'take',
        'takeRight',
        'takeRightWhile',
        'takeWhile',
        'tap',
        'throttle',
        'thru',
        'times',
        'trimChars',
        'trimCharsEnd',
        'trimCharsStart',
        'truncate',
        'union',
        'uniqBy',
        'uniqWith',
        'unset',
        'unzipWith',
        'without',
        'wrap',
        'xor',
        'zip',
        'zipObject',
        'zipObjectDeep'
    ],
    '3': [
        'assignInWith',
        'assignWith',
        'clamp',
        'differenceBy',
        'differenceWith',
        'findFrom',
        'findIndexFrom',
        'findLastFrom',
        'findLastIndexFrom',
        'getOr',
        'includesFrom',
        'indexOfFrom',
        'inRange',
        'intersectionBy',
        'intersectionWith',
        'invokeArgs',
        'invokeArgsMap',
        'isEqualWith',
        'isMatchWith',
        'flatMapDepth',
        'lastIndexOfFrom',
        'mergeWith',
        'orderBy',
        'padChars',
        'padCharsEnd',
        'padCharsStart',
        'pullAllBy',
        'pullAllWith',
        'rangeStep',
        'rangeStepRight',
        'reduce',
        'reduceRight',
        'replace',
        'set',
        'slice',
        'sortedIndexBy',
        'sortedLastIndexBy',
        'transform',
        'unionBy',
        'unionWith',
        'update',
        'xorBy',
        'xorWith',
        'zipWith'
    ],
    '4': [
        'fill',
        'setWith',
        'updateWith'
    ]
};
$fef938fb92c31507$export$42564e045b285e32 = {
    '2': [
        1,
        0
    ],
    '3': [
        2,
        0,
        1
    ],
    '4': [
        3,
        2,
        0,
        1
    ]
};
$fef938fb92c31507$export$81e17196e6a22b07 = {
    'dropRightWhile': 1,
    'dropWhile': 1,
    'every': 1,
    'filter': 1,
    'find': 1,
    'findFrom': 1,
    'findIndex': 1,
    'findIndexFrom': 1,
    'findKey': 1,
    'findLast': 1,
    'findLastFrom': 1,
    'findLastIndex': 1,
    'findLastIndexFrom': 1,
    'findLastKey': 1,
    'flatMap': 1,
    'flatMapDeep': 1,
    'flatMapDepth': 1,
    'forEach': 1,
    'forEachRight': 1,
    'forIn': 1,
    'forInRight': 1,
    'forOwn': 1,
    'forOwnRight': 1,
    'map': 1,
    'mapKeys': 1,
    'mapValues': 1,
    'partition': 1,
    'reduce': 2,
    'reduceRight': 2,
    'reject': 1,
    'remove': 1,
    'some': 1,
    'takeRightWhile': 1,
    'takeWhile': 1,
    'times': 1,
    'transform': 2
};
$fef938fb92c31507$export$30975ceb42167ebd = {
    'mapKeys': [
        1
    ],
    'reduceRight': [
        1,
        0
    ]
};
$fef938fb92c31507$export$8ceb0ad7e94d3801 = {
    'assignInAllWith': [
        1,
        0
    ],
    'assignInWith': [
        1,
        2,
        0
    ],
    'assignAllWith': [
        1,
        0
    ],
    'assignWith': [
        1,
        2,
        0
    ],
    'differenceBy': [
        1,
        2,
        0
    ],
    'differenceWith': [
        1,
        2,
        0
    ],
    'getOr': [
        2,
        1,
        0
    ],
    'intersectionBy': [
        1,
        2,
        0
    ],
    'intersectionWith': [
        1,
        2,
        0
    ],
    'isEqualWith': [
        1,
        2,
        0
    ],
    'isMatchWith': [
        2,
        1,
        0
    ],
    'mergeAllWith': [
        1,
        0
    ],
    'mergeWith': [
        1,
        2,
        0
    ],
    'padChars': [
        2,
        1,
        0
    ],
    'padCharsEnd': [
        2,
        1,
        0
    ],
    'padCharsStart': [
        2,
        1,
        0
    ],
    'pullAllBy': [
        2,
        1,
        0
    ],
    'pullAllWith': [
        2,
        1,
        0
    ],
    'rangeStep': [
        1,
        2,
        0
    ],
    'rangeStepRight': [
        1,
        2,
        0
    ],
    'setWith': [
        3,
        1,
        2,
        0
    ],
    'sortedIndexBy': [
        2,
        1,
        0
    ],
    'sortedLastIndexBy': [
        2,
        1,
        0
    ],
    'unionBy': [
        1,
        2,
        0
    ],
    'unionWith': [
        1,
        2,
        0
    ],
    'updateWith': [
        3,
        1,
        2,
        0
    ],
    'xorBy': [
        1,
        2,
        0
    ],
    'xorWith': [
        1,
        2,
        0
    ],
    'zipWith': [
        1,
        2,
        0
    ]
};
$fef938fb92c31507$export$fbaeb3f87df3cf26 = {
    'assignAll': {
        'start': 0
    },
    'assignAllWith': {
        'start': 0
    },
    'assignInAll': {
        'start': 0
    },
    'assignInAllWith': {
        'start': 0
    },
    'defaultsAll': {
        'start': 0
    },
    'defaultsDeepAll': {
        'start': 0
    },
    'invokeArgs': {
        'start': 2
    },
    'invokeArgsMap': {
        'start': 2
    },
    'mergeAll': {
        'start': 0
    },
    'mergeAllWith': {
        'start': 0
    },
    'partial': {
        'start': 1
    },
    'partialRight': {
        'start': 1
    },
    'without': {
        'start': 1
    },
    'zipAll': {
        'start': 0
    }
};
$fef938fb92c31507$export$57e795267c26e600 = {
    'array': {
        'fill': true,
        'pull': true,
        'pullAll': true,
        'pullAllBy': true,
        'pullAllWith': true,
        'pullAt': true,
        'remove': true,
        'reverse': true
    },
    'object': {
        'assign': true,
        'assignAll': true,
        'assignAllWith': true,
        'assignIn': true,
        'assignInAll': true,
        'assignInAllWith': true,
        'assignInWith': true,
        'assignWith': true,
        'defaults': true,
        'defaultsAll': true,
        'defaultsDeep': true,
        'defaultsDeepAll': true,
        'merge': true,
        'mergeAll': true,
        'mergeAllWith': true,
        'mergeWith': true
    },
    'set': {
        'set': true,
        'setWith': true,
        'unset': true,
        'update': true,
        'updateWith': true
    }
};
$fef938fb92c31507$export$1eb71a7e27943e71 = function() {
    var hasOwnProperty = Object.prototype.hasOwnProperty, object = $fef938fb92c31507$export$bd0f5e6e44efa6b4, result = {};
    for(var key in object){
        var value = object[key];
        if (hasOwnProperty.call(result, value)) result[value].push(key);
        else result[value] = [
            key
        ];
    }
    return result;
}();
$fef938fb92c31507$export$aee1dbae5de2db9d = {
    'assignAll': 'assign',
    'assignAllWith': 'assignWith',
    'assignInAll': 'assignIn',
    'assignInAllWith': 'assignInWith',
    'curryN': 'curry',
    'curryRightN': 'curryRight',
    'defaultsAll': 'defaults',
    'defaultsDeepAll': 'defaultsDeep',
    'findFrom': 'find',
    'findIndexFrom': 'findIndex',
    'findLastFrom': 'findLast',
    'findLastIndexFrom': 'findLastIndex',
    'getOr': 'get',
    'includesFrom': 'includes',
    'indexOfFrom': 'indexOf',
    'invokeArgs': 'invoke',
    'invokeArgsMap': 'invokeMap',
    'lastIndexOfFrom': 'lastIndexOf',
    'mergeAll': 'merge',
    'mergeAllWith': 'mergeWith',
    'padChars': 'pad',
    'padCharsEnd': 'padEnd',
    'padCharsStart': 'padStart',
    'propertyOf': 'get',
    'rangeStep': 'range',
    'rangeStepRight': 'rangeRight',
    'restFrom': 'rest',
    'spreadFrom': 'spread',
    'trimChars': 'trim',
    'trimCharsEnd': 'trimEnd',
    'trimCharsStart': 'trimStart',
    'zipAll': 'zip'
};
$fef938fb92c31507$export$87ffbe4821a5d5e0 = {
    'castArray': true,
    'flow': true,
    'flowRight': true,
    'iteratee': true,
    'mixin': true,
    'rearg': true,
    'runInContext': true
};
$fef938fb92c31507$export$b4d07413ce528c90 = {
    'add': true,
    'assign': true,
    'assignIn': true,
    'bind': true,
    'bindKey': true,
    'concat': true,
    'difference': true,
    'divide': true,
    'eq': true,
    'gt': true,
    'gte': true,
    'isEqual': true,
    'lt': true,
    'lte': true,
    'matchesProperty': true,
    'merge': true,
    'multiply': true,
    'overArgs': true,
    'partial': true,
    'partialRight': true,
    'propertyOf': true,
    'random': true,
    'range': true,
    'rangeRight': true,
    'subtract': true,
    'zip': true,
    'zipObject': true,
    'zipObjectDeep': true
};

});

parcelRegister("aPsMW", function(module, exports) {
/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */ module.exports = {};

});


parcelRegister("7sR67", function(module, exports) {














module.exports = {
    'ary': (parcelRequire("lEyvi")),
    'assign': (parcelRequire("bqJNK")),
    'clone': (parcelRequire("91VA7")),
    'curry': (parcelRequire("a7NzZ")),
    'forEach': (parcelRequire("fmP8r")),
    'isArray': (parcelRequire("8LQ84")),
    'isError': (parcelRequire("aZFhV")),
    'isFunction': (parcelRequire("5vD8v")),
    'isWeakMap': (parcelRequire("5UxIS")),
    'iteratee': (parcelRequire("5qDt4")),
    'keys': (parcelRequire("hR3Ue")),
    'rearg': (parcelRequire("iZlmO")),
    'toInteger': (parcelRequire("kPZpS")),
    'toPath': (parcelRequire("6TYHJ"))
};

});
parcelRegister("lEyvi", function(module, exports) {

var $5oTQF = parcelRequire("5oTQF");
/** Used to compose bitmasks for function metadata. */ var $fc3819207d6eebc6$var$WRAP_ARY_FLAG = 128;
/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */ function $fc3819207d6eebc6$var$ary(func, n, guard) {
    n = guard ? undefined : n;
    n = func && n == null ? func.length : n;
    return $5oTQF(func, $fc3819207d6eebc6$var$WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}
module.exports = $fc3819207d6eebc6$var$ary;

});
parcelRegister("5oTQF", function(module, exports) {

var $g1o5k = parcelRequire("g1o5k");

var $1BSxH = parcelRequire("1BSxH");

var $gQoGK = parcelRequire("gQoGK");

var $2pq1V = parcelRequire("2pq1V");

var $cwXqG = parcelRequire("cwXqG");

var $dzqxs = parcelRequire("dzqxs");

var $c8pf3 = parcelRequire("c8pf3");

var $4EzKU = parcelRequire("4EzKU");

var $iKqmZ = parcelRequire("iKqmZ");

var $kPZpS = parcelRequire("kPZpS");
/** Error message constants. */ var $3eea84024a50d6cf$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $3eea84024a50d6cf$var$WRAP_BIND_FLAG = 1, $3eea84024a50d6cf$var$WRAP_BIND_KEY_FLAG = 2, $3eea84024a50d6cf$var$WRAP_CURRY_FLAG = 8, $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG = 16, $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG = 32, $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3eea84024a50d6cf$var$nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $3eea84024a50d6cf$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & $3eea84024a50d6cf$var$WRAP_BIND_KEY_FLAG;
    if (!isBindKey && typeof func != 'function') throw new TypeError($3eea84024a50d6cf$var$FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~($3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG | $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    ary = ary === undefined ? ary : $3eea84024a50d6cf$var$nativeMax($kPZpS(ary), 0);
    arity = arity === undefined ? arity : $kPZpS(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : $dzqxs(func);
    var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) $c8pf3(newData, data);
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $3eea84024a50d6cf$var$nativeMax(newData[9] - length, 0);
    if (!arity && bitmask & ($3eea84024a50d6cf$var$WRAP_CURRY_FLAG | $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($3eea84024a50d6cf$var$WRAP_CURRY_FLAG | $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG);
    if (!bitmask || bitmask == $3eea84024a50d6cf$var$WRAP_BIND_FLAG) var result = $1BSxH(func, bitmask, thisArg);
    else if (bitmask == $3eea84024a50d6cf$var$WRAP_CURRY_FLAG || bitmask == $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG) result = $gQoGK(func, bitmask, arity);
    else if ((bitmask == $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG || bitmask == ($3eea84024a50d6cf$var$WRAP_BIND_FLAG | $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $cwXqG(func, bitmask, thisArg, partials);
    else result = $2pq1V.apply(undefined, newData);
    var setter = data ? $g1o5k : $4EzKU;
    return $iKqmZ(setter(result, newData), func, bitmask);
}
module.exports = $3eea84024a50d6cf$var$createWrap;

});
parcelRegister("g1o5k", function(module, exports) {

var $etyzk = parcelRequire("etyzk");

var $hQCy5 = parcelRequire("hQCy5");
/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $ba9f6c1d52531584$var$baseSetData = !$hQCy5 ? $etyzk : function(func, data) {
    $hQCy5.set(func, data);
    return func;
};
module.exports = $ba9f6c1d52531584$var$baseSetData;

});

parcelRegister("1BSxH", function(module, exports) {

var $iJkMv = parcelRequire("iJkMv");

var $1V15E = parcelRequire("1V15E");
/** Used to compose bitmasks for function metadata. */ var $12c38e2c5009183b$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $12c38e2c5009183b$var$createBind(func, bitmask, thisArg) {
    var isBind = bitmask & $12c38e2c5009183b$var$WRAP_BIND_FLAG, Ctor = $iJkMv(func);
    function wrapper() {
        var fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
}
module.exports = $12c38e2c5009183b$var$createBind;

});
parcelRegister("iJkMv", function(module, exports) {

var $ady43 = parcelRequire("ady43");

var $k0qYG = parcelRequire("k0qYG");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function $da2c8caf7ae3955a$var$createCtor(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = $ady43(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return $k0qYG(result) ? result : thisBinding;
    };
}
module.exports = $da2c8caf7ae3955a$var$createCtor;

});


parcelRegister("gQoGK", function(module, exports) {

var $hlchF = parcelRequire("hlchF");

var $iJkMv = parcelRequire("iJkMv");

var $2pq1V = parcelRequire("2pq1V");

var $6fuEo = parcelRequire("6fuEo");

var $8ZIC5 = parcelRequire("8ZIC5");

var $kBUUu = parcelRequire("kBUUu");

var $1V15E = parcelRequire("1V15E");
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $c434a7442e0e841e$var$createCurry(func, bitmask, arity) {
    var Ctor = $iJkMv(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length, placeholder = $8ZIC5(wrapper);
        while(index--)args[index] = arguments[index];
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $kBUUu(args, placeholder);
        length -= holders.length;
        if (length < arity) return $6fuEo(func, bitmask, $2pq1V, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        var fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
        return $hlchF(fn, this, args);
    }
    return wrapper;
}
module.exports = $c434a7442e0e841e$var$createCurry;

});
parcelRegister("2pq1V", function(module, exports) {

var $k8MLc = parcelRequire("k8MLc");

var $eqXBf = parcelRequire("eqXBf");

var $khpbX = parcelRequire("khpbX");

var $iJkMv = parcelRequire("iJkMv");

var $6fuEo = parcelRequire("6fuEo");

var $8ZIC5 = parcelRequire("8ZIC5");

var $3Prcz = parcelRequire("3Prcz");

var $kBUUu = parcelRequire("kBUUu");

var $1V15E = parcelRequire("1V15E");
/** Used to compose bitmasks for function metadata. */ var $1c121b92b9034c1f$var$WRAP_BIND_FLAG = 1, $1c121b92b9034c1f$var$WRAP_BIND_KEY_FLAG = 2, $1c121b92b9034c1f$var$WRAP_CURRY_FLAG = 8, $1c121b92b9034c1f$var$WRAP_CURRY_RIGHT_FLAG = 16, $1c121b92b9034c1f$var$WRAP_ARY_FLAG = 128, $1c121b92b9034c1f$var$WRAP_FLIP_FLAG = 512;
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $1c121b92b9034c1f$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & $1c121b92b9034c1f$var$WRAP_ARY_FLAG, isBind = bitmask & $1c121b92b9034c1f$var$WRAP_BIND_FLAG, isBindKey = bitmask & $1c121b92b9034c1f$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($1c121b92b9034c1f$var$WRAP_CURRY_FLAG | $1c121b92b9034c1f$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $1c121b92b9034c1f$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $iJkMv(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length;
        while(index--)args[index] = arguments[index];
        if (isCurried) var placeholder = $8ZIC5(wrapper), holdersCount = $khpbX(args, placeholder);
        if (partials) args = $k8MLc(args, partials, holders, isCurried);
        if (partialsRight) args = $eqXBf(args, partialsRight, holdersRight, isCurried);
        length -= holdersCount;
        if (isCurried && length < arity) {
            var newHolders = $kBUUu(args, placeholder);
            return $6fuEo(func, bitmask, $1c121b92b9034c1f$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) args = $3Prcz(args, argPos);
        else if (isFlip && length > 1) args.reverse();
        if (isAry && ary < length) args.length = ary;
        if (this && this !== $1V15E && this instanceof wrapper) fn = Ctor || $iJkMv(fn);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = $1c121b92b9034c1f$var$createHybrid;

});
parcelRegister("k8MLc", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ea9a60ca966f8da9$var$nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $ea9a60ca966f8da9$var$composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $ea9a60ca966f8da9$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
    while(rangeLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = $ea9a60ca966f8da9$var$composeArgs;

});

parcelRegister("eqXBf", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a821b9ab167c5b82$var$nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $a821b9ab167c5b82$var$composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $a821b9ab167c5b82$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = $a821b9ab167c5b82$var$composeArgsRight;

});

parcelRegister("khpbX", function(module, exports) {
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function $ec38efbc1ab3f809$var$countHolders(array, placeholder) {
    var length = array.length, result = 0;
    while(length--)if (array[length] === placeholder) ++result;
    return result;
}
module.exports = $ec38efbc1ab3f809$var$countHolders;

});

parcelRegister("6fuEo", function(module, exports) {

var $2dCKt = parcelRequire("2dCKt");

var $4EzKU = parcelRequire("4EzKU");

var $iKqmZ = parcelRequire("iKqmZ");
/** Used to compose bitmasks for function metadata. */ var $48cbeb57943323d5$var$WRAP_BIND_FLAG = 1, $48cbeb57943323d5$var$WRAP_BIND_KEY_FLAG = 2, $48cbeb57943323d5$var$WRAP_CURRY_BOUND_FLAG = 4, $48cbeb57943323d5$var$WRAP_CURRY_FLAG = 8, $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG = 32, $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $48cbeb57943323d5$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
    var isCurry = bitmask & $48cbeb57943323d5$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
    bitmask |= isCurry ? $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG : $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG;
    bitmask &= ~(isCurry ? $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG : $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG);
    if (!(bitmask & $48cbeb57943323d5$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($48cbeb57943323d5$var$WRAP_BIND_FLAG | $48cbeb57943323d5$var$WRAP_BIND_KEY_FLAG);
    var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
    ];
    var result = wrapFunc.apply(undefined, newData);
    if ($2dCKt(func)) $4EzKU(result, newData);
    result.placeholder = placeholder;
    return $iKqmZ(result, func, bitmask);
}
module.exports = $48cbeb57943323d5$var$createRecurry;

});
parcelRegister("4EzKU", function(module, exports) {

var $g1o5k = parcelRequire("g1o5k");

var $eqv0t = parcelRequire("eqv0t");
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $3636a22a88d50b78$var$setData = $eqv0t($g1o5k);
module.exports = $3636a22a88d50b78$var$setData;

});

parcelRegister("iKqmZ", function(module, exports) {

var $d25DY = parcelRequire("d25DY");

var $iPKwQ = parcelRequire("iPKwQ");

var $8pgNR = parcelRequire("8pgNR");

var $1ZcUe = parcelRequire("1ZcUe");
/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function $da60fa5a8c702882$var$setWrapToString(wrapper, reference, bitmask) {
    var source = reference + '';
    return $8pgNR(wrapper, $iPKwQ(source, $1ZcUe($d25DY(source), bitmask)));
}
module.exports = $da60fa5a8c702882$var$setWrapToString;

});
parcelRegister("d25DY", function(module, exports) {
/** Used to match wrap detail comments. */ var $97cfd7023a392295$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $97cfd7023a392295$var$reSplitDetails = /,? & /;
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function $97cfd7023a392295$var$getWrapDetails(source) {
    var match = source.match($97cfd7023a392295$var$reWrapDetails);
    return match ? match[1].split($97cfd7023a392295$var$reSplitDetails) : [];
}
module.exports = $97cfd7023a392295$var$getWrapDetails;

});

parcelRegister("iPKwQ", function(module, exports) {
/** Used to match wrap detail comments. */ var $db61150bcd231438$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function $db61150bcd231438$var$insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) return source;
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
    details = details.join(length > 2 ? ', ' : ' ');
    return source.replace($db61150bcd231438$var$reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}
module.exports = $db61150bcd231438$var$insertWrapDetails;

});

parcelRegister("1ZcUe", function(module, exports) {

var $fmP8r = parcelRequire("fmP8r");

var $fUP98 = parcelRequire("fUP98");
/** Used to compose bitmasks for function metadata. */ var $17257fcfcc231370$var$WRAP_BIND_FLAG = 1, $17257fcfcc231370$var$WRAP_BIND_KEY_FLAG = 2, $17257fcfcc231370$var$WRAP_CURRY_FLAG = 8, $17257fcfcc231370$var$WRAP_CURRY_RIGHT_FLAG = 16, $17257fcfcc231370$var$WRAP_PARTIAL_FLAG = 32, $17257fcfcc231370$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $17257fcfcc231370$var$WRAP_ARY_FLAG = 128, $17257fcfcc231370$var$WRAP_REARG_FLAG = 256, $17257fcfcc231370$var$WRAP_FLIP_FLAG = 512;
/** Used to associate wrap methods with their bit flags. */ var $17257fcfcc231370$var$wrapFlags = [
    [
        'ary',
        $17257fcfcc231370$var$WRAP_ARY_FLAG
    ],
    [
        'bind',
        $17257fcfcc231370$var$WRAP_BIND_FLAG
    ],
    [
        'bindKey',
        $17257fcfcc231370$var$WRAP_BIND_KEY_FLAG
    ],
    [
        'curry',
        $17257fcfcc231370$var$WRAP_CURRY_FLAG
    ],
    [
        'curryRight',
        $17257fcfcc231370$var$WRAP_CURRY_RIGHT_FLAG
    ],
    [
        'flip',
        $17257fcfcc231370$var$WRAP_FLIP_FLAG
    ],
    [
        'partial',
        $17257fcfcc231370$var$WRAP_PARTIAL_FLAG
    ],
    [
        'partialRight',
        $17257fcfcc231370$var$WRAP_PARTIAL_RIGHT_FLAG
    ],
    [
        'rearg',
        $17257fcfcc231370$var$WRAP_REARG_FLAG
    ]
];
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function $17257fcfcc231370$var$updateWrapDetails(details, bitmask) {
    $fmP8r($17257fcfcc231370$var$wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if (bitmask & pair[1] && !$fUP98(details, value)) details.push(value);
    });
    return details.sort();
}
module.exports = $17257fcfcc231370$var$updateWrapDetails;

});



parcelRegister("8ZIC5", function(module, exports) {
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function $68c6a086039b9437$var$getHolder(func) {
    var object = func;
    return object.placeholder;
}
module.exports = $68c6a086039b9437$var$getHolder;

});

parcelRegister("3Prcz", function(module, exports) {

var $jHlUS = parcelRequire("jHlUS");

var $e8U1z = parcelRequire("e8U1z");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2c9b3c36ffa24094$var$nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function $2c9b3c36ffa24094$var$reorder(array, indexes) {
    var arrLength = array.length, length = $2c9b3c36ffa24094$var$nativeMin(indexes.length, arrLength), oldArray = $jHlUS(array);
    while(length--){
        var index = indexes[length];
        array[length] = $e8U1z(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = $2c9b3c36ffa24094$var$reorder;

});

parcelRegister("kBUUu", function(module, exports) {
/** Used as the internal argument placeholder. */ var $f0136883d4267917$var$PLACEHOLDER = '__lodash_placeholder__';
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function $f0136883d4267917$var$replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value === placeholder || value === $f0136883d4267917$var$PLACEHOLDER) {
            array[index] = $f0136883d4267917$var$PLACEHOLDER;
            result[resIndex++] = index;
        }
    }
    return result;
}
module.exports = $f0136883d4267917$var$replaceHolders;

});



parcelRegister("cwXqG", function(module, exports) {

var $hlchF = parcelRequire("hlchF");

var $iJkMv = parcelRequire("iJkMv");

var $1V15E = parcelRequire("1V15E");
/** Used to compose bitmasks for function metadata. */ var $91f6929c17575724$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function $91f6929c17575724$var$createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & $91f6929c17575724$var$WRAP_BIND_FLAG, Ctor = $iJkMv(func);
    function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        return $hlchF(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = $91f6929c17575724$var$createPartial;

});

parcelRegister("c8pf3", function(module, exports) {

var $k8MLc = parcelRequire("k8MLc");

var $eqXBf = parcelRequire("eqXBf");

var $kBUUu = parcelRequire("kBUUu");
/** Used as the internal argument placeholder. */ var $8d59cfe3586d6695$var$PLACEHOLDER = '__lodash_placeholder__';
/** Used to compose bitmasks for function metadata. */ var $8d59cfe3586d6695$var$WRAP_BIND_FLAG = 1, $8d59cfe3586d6695$var$WRAP_BIND_KEY_FLAG = 2, $8d59cfe3586d6695$var$WRAP_CURRY_BOUND_FLAG = 4, $8d59cfe3586d6695$var$WRAP_CURRY_FLAG = 8, $8d59cfe3586d6695$var$WRAP_ARY_FLAG = 128, $8d59cfe3586d6695$var$WRAP_REARG_FLAG = 256;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8d59cfe3586d6695$var$nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function $8d59cfe3586d6695$var$mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($8d59cfe3586d6695$var$WRAP_BIND_FLAG | $8d59cfe3586d6695$var$WRAP_BIND_KEY_FLAG | $8d59cfe3586d6695$var$WRAP_ARY_FLAG);
    var isCombo = srcBitmask == $8d59cfe3586d6695$var$WRAP_ARY_FLAG && bitmask == $8d59cfe3586d6695$var$WRAP_CURRY_FLAG || srcBitmask == $8d59cfe3586d6695$var$WRAP_ARY_FLAG && bitmask == $8d59cfe3586d6695$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($8d59cfe3586d6695$var$WRAP_ARY_FLAG | $8d59cfe3586d6695$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $8d59cfe3586d6695$var$WRAP_CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & $8d59cfe3586d6695$var$WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & $8d59cfe3586d6695$var$WRAP_BIND_FLAG ? 0 : $8d59cfe3586d6695$var$WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? $k8MLc(partials, value, source[4]) : value;
        data[4] = partials ? $kBUUu(data[3], $8d59cfe3586d6695$var$PLACEHOLDER) : source[4];
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? $eqXBf(partials, value, source[6]) : value;
        data[6] = partials ? $kBUUu(data[5], $8d59cfe3586d6695$var$PLACEHOLDER) : source[6];
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = value;
    // Use source `ary` if it's smaller.
    if (srcBitmask & $8d59cfe3586d6695$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $8d59cfe3586d6695$var$nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = $8d59cfe3586d6695$var$mergeData;

});



parcelRegister("a7NzZ", function(module, exports) {

var $5oTQF = parcelRequire("5oTQF");
/** Used to compose bitmasks for function metadata. */ var $75f10447dad5f8f2$var$WRAP_CURRY_FLAG = 8;
/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */ function $75f10447dad5f8f2$var$curry(func, arity, guard) {
    arity = guard ? undefined : arity;
    var result = $5oTQF(func, $75f10447dad5f8f2$var$WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
    result.placeholder = $75f10447dad5f8f2$var$curry.placeholder;
    return result;
}
// Assign default placeholders.
$75f10447dad5f8f2$var$curry.placeholder = {};
module.exports = $75f10447dad5f8f2$var$curry;

});

parcelRegister("5UxIS", function(module, exports) {

var $jtBGw = parcelRequire("jtBGw");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $44dc5758474a5c9f$var$weakMapTag = '[object WeakMap]';
/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */ function $44dc5758474a5c9f$var$isWeakMap(value) {
    return $fC1Kz(value) && $jtBGw(value) == $44dc5758474a5c9f$var$weakMapTag;
}
module.exports = $44dc5758474a5c9f$var$isWeakMap;

});

parcelRegister("5qDt4", function(module, exports) {

var $7MmCC = parcelRequire("7MmCC");

var $bxDef = parcelRequire("bxDef");
/** Used to compose bitmasks for cloning. */ var $3f3dfefad45dde4d$var$CLONE_DEEP_FLAG = 1;
/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */ function $3f3dfefad45dde4d$var$iteratee(func) {
    return $bxDef(typeof func == 'function' ? func : $7MmCC(func, $3f3dfefad45dde4d$var$CLONE_DEEP_FLAG));
}
module.exports = $3f3dfefad45dde4d$var$iteratee;

});

parcelRegister("iZlmO", function(module, exports) {

var $5oTQF = parcelRequire("5oTQF");

var $9SRAA = parcelRequire("9SRAA");
/** Used to compose bitmasks for function metadata. */ var $dd2e7f874e5ccea3$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */ var $dd2e7f874e5ccea3$var$rearg = $9SRAA(function(func, indexes) {
    return $5oTQF(func, $dd2e7f874e5ccea3$var$WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});
module.exports = $dd2e7f874e5ccea3$var$rearg;

});

parcelRegister("6TYHJ", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $jHlUS = parcelRequire("jHlUS");

var $8LQ84 = parcelRequire("8LQ84");

var $4faK3 = parcelRequire("4faK3");

var $h5JBK = parcelRequire("h5JBK");

var $gzebZ = parcelRequire("gzebZ");

var $jJVtR = parcelRequire("jJVtR");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $5066f7c1bc1a55ec$var$toPath(value) {
    if ($8LQ84(value)) return $1nIHN(value, $gzebZ);
    return $4faK3(value) ? [
        value
    ] : $jHlUS($h5JBK($jJVtR(value)));
}
module.exports = $5066f7c1bc1a55ec$var$toPath;

});



parcelRegister("bUoRH", function(module, exports) {
module.exports = {
    'cap': false,
    'curry': false,
    'fixed': false,
    'immutable': false,
    'rearg': false
};

});


parcelRegister("htnpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa2698ee0cdd579e$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $cKsfY = parcelRequire("cKsfY");

var $9Lqvx = parcelRequire("9Lqvx");

var $hB1kl = parcelRequire("hB1kl");
const $fa2698ee0cdd579e$var$DateTimePicker = (0, $cKsfY.componentWithCondition)(()=>(0, $VSDnB.fg)('dst-date-time-picker-use-functional-component'), (0, $hB1kl.default), (0, $9Lqvx.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fa2698ee0cdd579e$export$2e2bcd8739ae039 = $fa2698ee0cdd579e$var$DateTimePicker;

});
parcelRegister("cKsfY", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $8f027f90da2b6bac$export$6e8ea24b15199873);

var $5uXOq = parcelRequire("5uXOq");
function $8f027f90da2b6bac$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});

parcelRegister("9Lqvx", function(module, exports) {

$parcel$export(module.exports, "default", () => $597f1543018f8252$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $cQz2U = parcelRequire("cQz2U");

var $VSDnB = parcelRequire("VSDnB");

var $7VXAu = parcelRequire("7VXAu");


var $jHBnA = parcelRequire("jHBnA");

var $8JNJx = parcelRequire("8JNJx");

var $cKsfY = parcelRequire("cKsfY");

var $2ucUe = parcelRequire("2ucUe");

var $2TI0z = parcelRequire("2TI0z");

var $jcbUF = parcelRequire("jcbUF");

var $jdTq6 = parcelRequire("jdTq6");
function $597f1543018f8252$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $597f1543018f8252$var$DatePicker = (0, $cKsfY.componentWithCondition)(()=>(0, $VSDnB.fg)('dst-date-picker-use-functional-component'), (0, $jcbUF.default), (0, $2TI0z.default));
const $597f1543018f8252$var$packageName = "platform-pkg";
const $597f1543018f8252$var$packageVersion = "0.0.0-use.local";
// Make DatePicker 50% the width of DateTimePicker
// If rendering an icon container, shrink the TimePicker
const $597f1543018f8252$var$datePickerContainerStyles = {
    name: "d1cmrh",
    styles: "flex-basis:50%;flex-grow:1;flex-shrink:0"
};
const $597f1543018f8252$var$timePickerContainerStyles = {
    name: "zwso5s",
    styles: "flex-basis:50%;flex-grow:1"
};
const $597f1543018f8252$var$iconContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    margin: "var(--ds-border-width, 1px)",
    alignItems: 'center',
    flexBasis: 'inherit',
    backgroundColor: 'inherit',
    border: 'none',
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
    paddingBlockEnd: "var(--ds-space-075, 6px)",
    paddingBlockStart: "var(--ds-space-075, 6px)",
    paddingInlineEnd: "var(--ds-space-100, 8px)",
    paddingInlineStart: "var(--ds-space-050, 4px)",
    transition: `color 150ms`,
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
    }
});
// react-select overrides (via @atlaskit/select).
const $597f1543018f8252$var$styles = {
    control: (style)=>({
            ...style,
            backgroundColor: 'transparent',
            border: 2,
            borderRadius: 0,
            paddingLeft: 0,
            ':hover': {
                backgroundColor: 'transparent',
                cursor: 'inherit'
            }
        })
};
const $597f1543018f8252$var$dateTimePickerDefaultProps = {
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{}
};
const $597f1543018f8252$export$3b559a1219cb3c27 = 'Date';
const $597f1543018f8252$export$d82cc7e53d68a428 = 'Time';
class $597f1543018f8252$export$732a1726f0a3523b extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = $597f1543018f8252$var$dateTimePickerDefaultProps;
    }
    parseValue(value, dateValue, timeValue, zoneValue) {
        if (this.props.parseValue) {
            const parsedFromFn = this.props.parseValue(value, dateValue, timeValue, zoneValue);
            // This handles cases found in Jira where the parse function actually does
            // nothing and returns undefined. The previous `getSafeState` function
            // just spread the values over the state, but if it returned `undefined`,
            // it would just rely on the previous state values. Considering this is
            // what is input to this function anyway, this is a safe way to handle
            // this, colocate the behavior, and not rely on `getSafeState`.
            return parsedFromFn || {
                dateValue: dateValue,
                timeValue: timeValue,
                zoneValue: zoneValue
            };
        }
        const parsed = (0, $eZDAP.default)(value);
        return (0, $jovBr.default)(parsed) ? {
            dateValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('YYYY-MM-DD')),
            timeValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('HH:mm')),
            zoneValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('ZZ'))
        } : {
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        };
    }
    onValueChange({ dateValue: dateValue, timeValue: timeValue, zoneValue: zoneValue }) {
        this.setState({
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        });
        if (dateValue && timeValue) {
            const value = (0, $jHBnA.formatDateTimeZoneIntoIso)(dateValue, timeValue, zoneValue);
            const { zoneValue: parsedZone } = this.parseValue(value, dateValue, timeValue, zoneValue);
            const valueWithValidZone = (0, $jHBnA.formatDateTimeZoneIntoIso)(dateValue, timeValue, parsedZone);
            this.setState({
                value: valueWithValidZone
            });
            this.props.onChange?.(valueWithValidZone);
        // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (this.getValue()) {
            this.setState({
                value: ''
            });
            this.props.onChange?.('');
        }
    }
    render() {
        const { 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerProps = {}, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, locale: locale = 'en-US', name: name = '', spacing: spacing = 'default', testId: testId, timePickerProps: timePickerProps = {} } = this.props;
        const value = this.getValue();
        const { isFocused: isFocused } = this.state;
        const parsedValues = this.getParsedValues();
        const dateValue = parsedValues?.dateValue;
        const timeValue = parsedValues?.timeValue;
        const datePickerSelectProps = datePickerProps?.selectProps;
        const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
        const datePickerLabel = datePickerProps.label || $597f1543018f8252$export$3b559a1219cb3c27;
        const mergedDatePickerSelectProps = {
            ...datePickerSelectProps,
            styles: (0, $7VXAu.mergeStyles)($597f1543018f8252$var$styles, datePickerSelectProps?.styles)
        };
        const timePickerSelectProps = timePickerProps?.selectProps;
        const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
        const timePickerLabel = timePickerProps.label || $597f1543018f8252$export$d82cc7e53d68a428;
        const mergedTimePickerSelectProps = {
            ...timePickerSelectProps,
            styles: (0, $7VXAu.mergeStyles)($597f1543018f8252$var$styles, timePickerSelectProps?.styles)
        };
        // Render DateTimePicker's IconContainer when a value has been filled
        // Don't use Date or TimePicker's because they can't be customised
        const isClearable = Boolean(dateValue || timeValue);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8JNJx.DateTimePickerContainer), {
            appearance: appearance,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isInvalid: isInvalid,
            testId: testId,
            innerProps: innerProps
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $597f1543018f8252$var$datePickerContainerStyles
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)($597f1543018f8252$var$DatePicker, {
            appearance: appearance,
            "aria-describedby": datePickerAriaDescribedBy,
            autoFocus: datePickerProps.autoFocus || autoFocus,
            dateFormat: datePickerProps.dateFormat,
            defaultIsOpen: datePickerProps.defaultIsOpen,
            defaultValue: datePickerProps.defaultValue,
            disabled: datePickerProps.disabled,
            disabledDateFilter: datePickerProps.disabledDateFilter,
            formatDisplayLabel: datePickerProps.formatDisplayLabel,
            hideIcon: datePickerProps.hideIcon || true,
            icon: datePickerProps.icon,
            id: datePickerProps.id || id,
            innerProps: datePickerProps.innerProps,
            isDisabled: datePickerProps.isDisabled || isDisabled,
            isInvalid: datePickerProps.isInvalid || isInvalid,
            isRequired: datePickerProps.isRequired || isRequired,
            isOpen: datePickerProps.isOpen,
            label: datePickerLabel,
            locale: datePickerProps.locale || locale,
            maxDate: datePickerProps.maxDate,
            minDate: datePickerProps.minDate,
            name: datePickerProps.name,
            nextMonthLabel: datePickerProps.nextMonthLabel,
            onBlur: this.onDateBlur,
            onChange: this.onDateChange,
            onFocus: this.onDateFocus,
            parseInputValue: datePickerProps.parseInputValue,
            placeholder: datePickerProps.placeholder,
            previousMonthLabel: datePickerProps.previousMonthLabel,
            selectProps: mergedDatePickerSelectProps,
            shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
            spacing: datePickerProps.spacing || spacing,
            testId: testId && `${testId}--datepicker` || datePickerProps.testId,
            value: dateValue,
            weekStartDay: datePickerProps.weekStartDay
        })), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $597f1543018f8252$var$timePickerContainerStyles
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jdTq6.default), {
            appearance: timePickerProps.appearance || appearance,
            "aria-describedby": timePickerAriaDescribedBy,
            autoFocus: timePickerProps.autoFocus,
            defaultIsOpen: timePickerProps.defaultIsOpen,
            defaultValue: timePickerProps.defaultValue,
            formatDisplayLabel: timePickerProps.formatDisplayLabel,
            hideIcon: timePickerProps.hideIcon || true,
            id: timePickerProps.id,
            innerProps: timePickerProps.innerProps,
            isDisabled: timePickerProps.isDisabled || isDisabled,
            isInvalid: timePickerProps.isInvalid || isInvalid,
            isOpen: timePickerProps.isOpen,
            isRequired: timePickerProps.isRequired || isRequired,
            label: timePickerLabel,
            locale: timePickerProps.locale || locale,
            name: timePickerProps.name,
            onBlur: this.onTimeBlur,
            onChange: this.onTimeChange,
            onFocus: this.onTimeFocus,
            parseInputValue: timePickerProps.parseInputValue,
            placeholder: timePickerProps.placeholder,
            selectProps: mergedTimePickerSelectProps,
            spacing: timePickerProps.spacing || spacing,
            testId: timePickerProps.testId || testId && `${testId}--timepicker`,
            timeFormat: timePickerProps.timeFormat,
            timeIsEditable: timePickerProps.timeIsEditable,
            times: timePickerProps.times,
            value: timeValue
        })), isClearable && !isDisabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
            css: $597f1543018f8252$var$iconContainerStyles,
            onClick: this.onClear,
            "data-testid": testId && `${testId}--icon--container`,
            tabIndex: -1,
            type: "button"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQz2U))), {
            LEGACY_size: "small",
            color: "currentColor",
            label: clearControlLabel
        }), ' ') : null);
    }
    constructor(...args){
        super(...args);
        this.state = {
            dateValue: this.props.datePickerProps?.defaultValue || '',
            isFocused: false,
            timeValue: this.props.timePickerProps?.defaultValue || '',
            value: this.props.defaultValue || '',
            zoneValue: ''
        };
        // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        this.getParsedValues = ()=>this.parseValue(this.getValue(), this.state.dateValue, this.state.timeValue, this.state.zoneValue);
        this.getValue = ()=>this.props.value ?? this.state.value;
        this.onDateBlur = (event)=>{
            this.setState({
                isFocused: false
            });
            this.props.onBlur?.(event);
            if (this.props.datePickerProps?.onBlur) this.props.datePickerProps.onBlur(event);
        };
        this.onTimeBlur = (event)=>{
            this.setState({
                isFocused: false
            });
            this.props.onBlur?.(event);
            if (this.props.timePickerProps?.onBlur) this.props.timePickerProps.onBlur(event);
        };
        this.onDateFocus = (event)=>{
            this.setState({
                isFocused: true
            });
            this.props.onFocus?.(event);
            if (this.props.datePickerProps?.onFocus) this.props.datePickerProps.onFocus(event);
        };
        this.onTimeFocus = (event)=>{
            this.setState({
                isFocused: true
            });
            this.props.onFocus?.(event);
            if (this.props.timePickerProps?.onFocus) this.props.timePickerProps.onFocus(event);
        };
        this.onDateChange = (dateValue)=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: dateValue,
                timeValue: parsedValues.timeValue,
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.datePickerProps?.onChange) this.props.datePickerProps.onChange(dateValue);
        };
        this.onTimeChange = (timeValue)=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: parsedValues.dateValue,
                timeValue: timeValue,
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.timePickerProps?.onChange) this.props.timePickerProps.onChange(timeValue);
        };
        this.onClear = ()=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: '',
                timeValue: '',
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.datePickerProps?.onChange) this.props.datePickerProps.onChange('');
            if (this.props.timePickerProps?.onChange) this.props.timePickerProps.onChange('');
        };
    }
}
/**
 * __Date time picker__
 *
 * A date time picker allows the user to select an associated date and time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/usage)
 */ const $597f1543018f8252$var$DateTimePicker = (0, $994MI.default)({
    componentName: 'dateTimePicker',
    packageName: $597f1543018f8252$var$packageName,
    packageVersion: $597f1543018f8252$var$packageVersion
})((0, $cb25w.default)({
    onChange: (0, $gB4mS.default)('atlaskit')({
        action: 'changed',
        actionSubject: 'dateTimePicker',
        attributes: {
            componentName: 'dateTimePicker',
            packageName: $597f1543018f8252$var$packageName,
            packageVersion: $597f1543018f8252$var$packageVersion
        }
    })
})($597f1543018f8252$export$732a1726f0a3523b));
var $597f1543018f8252$export$2e2bcd8739ae039 = $597f1543018f8252$var$DateTimePicker;

});
parcelRegister("jHBnA", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $91948b176ea23188$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $91948b176ea23188$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $91948b176ea23188$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $91948b176ea23188$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $91948b176ea23188$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $91948b176ea23188$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $91948b176ea23188$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $91948b176ea23188$export$5e30e9a24d6c1203 = ()=>null;
const $91948b176ea23188$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $91948b176ea23188$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $91948b176ea23188$export$9e6d8fcf62256b85 = 'h:mma';
const $91948b176ea23188$export$75032c84f56650eb = 'YYYY/MM/DD';
function $91948b176ea23188$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $91948b176ea23188$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("8JNJx", function(module, exports) {

$parcel$export(module.exports, "DateTimePickerContainer", () => $346cb403038f00ec$export$83034b1f07ab0b20);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

function $346cb403038f00ec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $346cb403038f00ec$var$isInvalidBorderStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderColor: `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
});
const $346cb403038f00ec$var$isFocusedBorderStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`
});
const $346cb403038f00ec$var$isFocusedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    backgroundColor: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
});
const $346cb403038f00ec$var$subtleBgStyles = {
    name: "1wrome1",
    styles: "background-color:transparent;border-color:transparent"
};
const $346cb403038f00ec$var$subtleFocusedBgStyles = {
    name: "17swi1q",
    styles: "background-color:var(--ds-background-input-pressed, transparent);border-color:transparent"
};
const $346cb403038f00ec$var$noBgStyles = {
    name: "14n6qpm",
    styles: "background-color:transparent;border-color:transparent;&:hover{background-color:transparent;border-color:transparent;}"
};
const $346cb403038f00ec$var$hoverStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        borderColor: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`
    }
});
const $346cb403038f00ec$var$isInvalidHoverStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        borderColor: `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
    }
});
const $346cb403038f00ec$var$isDisabledStyles = {
    name: "1xp4bos",
    styles: "&:hover{cursor:default;}"
};
const $346cb403038f00ec$var$newBorderStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    border: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`}`
});
const $346cb403038f00ec$var$baseContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    backgroundColor: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
    border: `2px solid ${`var(--ds-border-input, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`}`,
    borderRadius: "var(--ds-border-radius, 3px)",
    transition: 'background-color 200ms ease-in-out, border-color 200ms ease-in-out',
    '&:hover': {
        cursor: 'pointer'
    }
});
const $346cb403038f00ec$export$83034b1f07ab0b20 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isDisabled: isDisabled, isFocused: isFocused, appearance: appearance, isInvalid: isInvalid, innerProps: innerProps, testId: testId }, ref)=>{
    const notFocusedOrIsDisabled = !(isFocused || isDisabled);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $346cb403038f00ec$var$baseContainerStyles,
            $346cb403038f00ec$var$newBorderStyles,
            isDisabled && $346cb403038f00ec$var$isDisabledStyles,
            isFocused && $346cb403038f00ec$var$isFocusedStyles,
            appearance === 'subtle' && (isFocused ? $346cb403038f00ec$var$subtleFocusedBgStyles : $346cb403038f00ec$var$subtleBgStyles),
            isFocused && $346cb403038f00ec$var$isFocusedBorderStyles,
            isInvalid && $346cb403038f00ec$var$isInvalidBorderStyles,
            notFocusedOrIsDisabled && (isInvalid ? $346cb403038f00ec$var$isInvalidHoverStyles : $346cb403038f00ec$var$hoverStyles),
            appearance === 'none' && $346cb403038f00ec$var$noBgStyles
        ],
        ...innerProps,
        "data-testid": testId,
        ref: ref
    }, children);
});

});

parcelRegister("2ucUe", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $ca6f20a476eda5dc$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $ca6f20a476eda5dc$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $ca6f20a476eda5dc$var$v1tokens = Object.keys($ca6f20a476eda5dc$var$tokensMap).sort().reverse();
const $ca6f20a476eda5dc$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$ca6f20a476eda5dc$var$v1tokens.join('|') + '|.)', 'g');
function $ca6f20a476eda5dc$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($ca6f20a476eda5dc$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $ca6f20a476eda5dc$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});

parcelRegister("2TI0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $19201d0a1f7d7d54$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $3r9ww = parcelRequire("3r9ww");

var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $acknU = parcelRequire("acknU");

var $cTemL = parcelRequire("cTemL");

var $7qZ1x = parcelRequire("7qZ1x");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");


var $jldZL = parcelRequire("jldZL");

var $jHBnA = parcelRequire("jHBnA");

var $5RLF6 = parcelRequire("5RLF6");

var $iaQLg = parcelRequire("iaQLg");

var $gtijU = parcelRequire("gtijU");

var $6AqCE = parcelRequire("6AqCE");

var $dBs4v = parcelRequire("dBs4v");
function $19201d0a1f7d7d54$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $19201d0a1f7d7d54$var$packageName = "platform-pkg";
const $19201d0a1f7d7d54$var$packageVersion = "0.0.0-use.local";
const $19201d0a1f7d7d54$var$dropdownIndicatorStyles = (0, $8CUq3.xcss)({
    minWidth: "var(--ds-space-300, 24px)",
    minHeight: "var(--ds-space-300, 24px)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $19201d0a1f7d7d54$var$CalendarIcon = (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') ? (0, (/*@__PURE__*/$parcel$interopDefault($acknU))) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
(0, (/*@__PURE__*/$parcel$interopDefault($cTemL)));
const $19201d0a1f7d7d54$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{}
};
const $19201d0a1f7d7d54$var$pickerContainerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $19201d0a1f7d7d54$var$iconContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    height: '100%',
    position: 'absolute',
    alignItems: 'center',
    flexBasis: 'inherit',
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
    insetBlockStart: 0,
    insetInlineEnd: 0,
    transition: `color 150ms`,
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
    }
});
const $19201d0a1f7d7d54$var$iconSpacingWithClearButtonStyles = {
    name: "jd0mtf",
    styles: "margin-inline-end:var(--ds-space-400, 2rem)"
};
const $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStylesNew = {
    name: "129q61y",
    styles: "margin-inline-end:var(--ds-space-050, 0.25rem)"
};
const $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStyles = {
    name: "sz3drw",
    styles: "margin-inline-end:var(--ds-space-025, 0.125rem)"
};
const $19201d0a1f7d7d54$var$calendarButtonFixedSizeStyles = (0, $8CUq3.xcss)({
    width: `${32 / 14}em`,
    height: `${32 / 14}em`
});
const $19201d0a1f7d7d54$var$calendarButtonStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $19201d0a1f7d7d54$export$df43d21f5faca9f7 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $19201d0a1f7d7d54$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props);
        this.containerRef = null;
        this.calendarRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
        this.calendarButtonRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
        // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value;
        this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen;
        this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $5RLF6.getParsedISO)({
                    iso: iso
                })
            });
        };
        this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso,
                wasOpenedFromCalendarButton: false
            });
            this.props.onChange(iso);
            // Yes, this is not ideal. The alternative is to be able to place a ref
            // on the inner input of Select itself, which would require a lot of
            // extra stuff in the Select component for only this one thing. While
            // this would be more "React-y", it doesn't seem to pose any other
            // benefits. Performance-wise, we are only searching within the
            // container, so it's quick.
            if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
            else {
                const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            this.setState({
                isOpen: false
            });
        };
        this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        };
        this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onBlur(event);
            }
        };
        this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        };
        this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false,
                wasOpenedFromCalendarButton: false
            });
        };
        this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                // Don't open when focused into via keyboard if the calendar button is present
                isOpen: !this.props.shouldShowCalendarButton,
                calendarValue: value,
                isFocused: true,
                wasOpenedFromCalendarButton: false
            });
            this.props.onFocus(event);
        };
        this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $5RLF6.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                });
                // Only try to set the date if we have month & day
                if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $6AqCE.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        };
        this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase();
            // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                    // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $5RLF6.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $6AqCE.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue,
                            wasOpenedFromCalendarButton: false
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (this.state.isOpen && !this.state.shouldSetFocusOnCurrentDay) this.setState({
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        };
        this.onCalendarButtonKeyDown = (e)=>{
            // We want to stop this from triggering other keydown events, particularly
            // for space and enter presses. Otherwise, it opens and then closes
            // immediately.
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                this.setState({
                    isKeyDown: true,
                    wasOpenedFromCalendarButton: true
                });
            }
        };
        // This event handler is triggered from both keydown and click. It's weird.
        this.onCalendarButtonClick = (e)=>{
            this.setState({
                isOpen: !this.state.isOpen,
                wasOpenedFromCalendarButton: true
            }, ()=>{
                // We don't want the focus to move if this is a click event
                if (!this.state.isKeyDown) return;
                this.setState({
                    isKeyDown: false
                });
                // Focus on the first button within the calendar
                this.calendarRef?.current?.querySelector('button')?.focus();
            });
            e.stopPropagation();
        };
        this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $6AqCE.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        };
        // `unknown` is used because `value` is unused so it does not matter.
        this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        };
        this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        };
        this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref;
            // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isKeyDown: false,
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $6AqCE.getShortISOString)(new Date()),
            l10n: (0, $7qZ1x.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false,
            wasOpenedFromCalendarButton: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $7qZ1x.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = $19201d0a1f7d7d54$var$CalendarIcon, id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        let clearIndicator = Icon;
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration')) clearIndicator = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                xcss: $19201d0a1f7d7d54$var$dropdownIndicatorStyles
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Icon, props));
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, $dBs4v.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, $jHBnA.EmptyComponent) : dropDownIcon,
            // Only use this new container component if the calendar button is shown.
            // Otherwise, it throws errors downstream for some reason
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iaQLg.IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: $gtijU.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $jHBnA.EmptyComponent)
            }
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: this.calendarRef,
            calendarValue: value && (0, $6AqCE.getShortISOString)((0, $eZDAP.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay
        };
        // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
        const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $5RLF6.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null;
        // `label` takes precedence of the `inputLabel`
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel} , ${openCalendarLabel}` : openCalendarLabel;
        return(// These event handlers must be on this element because the events come
        // from different child elements.
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            ...innerProps,
            css: $19201d0a1f7d7d54$var$pickerContainerStyles,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7K5PP.default), {
            appearance: this.props.appearance,
            "aria-describedby": ariaDescribedBy,
            "aria-label": label || undefined,
            autoFocus: autoFocus,
            clearControlLabel: clearControlLabel,
            closeMenuOnSelect: true,
            // FOr some reason, this and the below `styles` type error _only_ show
            // up when you alter some of the properties in the `selectComponents`
            // object. These errors are still present, and I suspect have always
            // been present, without changing the unrelated code. Ignoring as the
            // component still works as expected despite this error. And also
            // because the select refresh team may solve it later.
            components: selectComponents,
            enableAnimation: false,
            inputId: id,
            inputValue: actualSelectInputValue,
            isDisabled: isDisabled,
            isRequired: isRequired,
            menuIsOpen: menuIsOpen,
            onBlur: this.onSelectBlur,
            onChange: this.onSelectChange,
            onFocus: this.onSelectFocus,
            onInputChange: this.handleSelectInputChange,
            placeholder: (0, $5RLF6.getPlaceholder)({
                placeholder: this.props.placeholder,
                l10n: this.state.l10n
            }),
            styles: mergedStyles,
            value: initialValue,
            ...selectProps,
            // These are below the spread because I don't know what is in
            // selectProps or not and what wil be overwritten
            isClearable: true,
            isInvalid: isInvalid,
            spacing: spacing,
            testId: testId,
            // These aren't part of `Select`'s API, but we're using them here.
            // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
            calendarContainerRef: calendarProps.calendarContainerRef,
            calendarDisabled: calendarProps.calendarDisabled,
            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
            calendarLocale: calendarProps.calendarLocale,
            calendarMaxDate: calendarProps.calendarMaxDate,
            calendarMinDate: calendarProps.calendarMinDate,
            calendarRef: calendarProps.calendarRef,
            calendarValue: calendarProps.calendarValue,
            calendarView: calendarProps.calendarView,
            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
            nextMonthLabel: nextMonthLabel,
            onCalendarChange: calendarProps.onCalendarChange,
            onCalendarSelect: calendarProps.onCalendarSelect,
            previousMonthLabel: previousMonthLabel,
            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
        }), shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3r9ww.UID), {
            name: (id)=>`open-calendar-label--${id}`
        }, (openCalendarLabelId)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                css: [
                    $19201d0a1f7d7d54$var$iconContainerStyles,
                    value && !hideIcon ? $19201d0a1f7d7d54$var$iconSpacingWithClearButtonStyles : (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') ? $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStylesNew : $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStyles
                ]
            }, inputLabelId && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jldZL.default), {
                id: openCalendarLabelId
            }, ", ", openCalendarLabel), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5ILhZ.default), {
                ...inputLabelId ? {
                    'aria-labelledby': `${inputLabelId} ${openCalendarLabelId}`
                } : {
                    'aria-label': fullopenCalendarLabel
                },
                onClick: this.onCalendarButtonClick,
                onKeyDown: this.onCalendarButtonKeyDown,
                ref: this.calendarButtonRef,
                testId: testId && `${testId}--open-calendar-button`,
                type: "button",
                backgroundColor: "color.background.neutral.subtle",
                padding: (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') ? 'space.0' : 'space.050',
                xcss: [
                    $19201d0a1f7d7d54$var$calendarButtonStyles,
                    (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') && $19201d0a1f7d7d54$var$calendarButtonFixedSizeStyles
                ]
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)($19201d0a1f7d7d54$var$CalendarIcon, {
                label: "",
                ...(0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') ? {
                    color: "var(--ds-icon, #44546F)"
                } : {
                    primaryColor: "var(--ds-icon, #44546F)"
                }
            })))) : null));
    }
}
/**
 * __Date picker__
 *
 * A date picker allows the user to select a particular date.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
 */ const $19201d0a1f7d7d54$var$DatePicker = (0, $994MI.default)({
    componentName: 'datePicker',
    packageName: $19201d0a1f7d7d54$var$packageName,
    packageVersion: $19201d0a1f7d7d54$var$packageVersion
})((0, $cb25w.default)({
    onChange: (0, $gB4mS.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $19201d0a1f7d7d54$var$packageName,
            packageVersion: $19201d0a1f7d7d54$var$packageVersion
        }
    })
})($19201d0a1f7d7d54$export$df43d21f5faca9f7));
var $19201d0a1f7d7d54$export$2e2bcd8739ae039 = $19201d0a1f7d7d54$var$DatePicker;

});
parcelRegister("3r9ww", function(module, exports) {

$parcel$export(module.exports, "UID", () => $280b47e13191fcdf$export$c8b4a4d253b84ce0);

var $3VFsf = parcelRequire("3VFsf");

var $5uXOq = parcelRequire("5uXOq");

var $7aHWJ = parcelRequire("7aHWJ");
// --------------------------------------------
var $280b47e13191fcdf$var$prefixId = function(id, prefix, name) {
    var uid = prefix + id;
    return String(name ? name(uid) : uid);
};
/**
 * @deprecated
 * UID in form of renderProps (not SSR friendly)
 * @see https://github.com/thearnica/react-uid#react-components
 * @example
 * // get UID to connect label to input
 * <UID>
 *   {(id)} => <label htmlFor={id}><input id={id}/>}
 * </UID>
 *
 * // get uid to generate uid for a keys in a list
 * <UID>
 *   {(, uid)} => items.map(item => <li key={uid(item) />)}
 * </UID>
 */ var $280b47e13191fcdf$export$c8b4a4d253b84ce0 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(UID, _super);
    function UID() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            quartz: _this.props.idSource || (0, $7aHWJ.counter),
            prefix: (0, $7aHWJ.getPrefix)(_this.props.idSource),
            id: (0, $7aHWJ.getId)(_this.props.idSource || (0, $7aHWJ.counter))
        };
        _this.uid = function(item) {
            return $280b47e13191fcdf$var$prefixId(_this.state.id + '-' + _this.state.quartz.uid(item), _this.state.prefix, _this.props.name);
        };
        return _this;
    }
    UID.prototype.render = function() {
        var _a = this.props, children = _a.children, name = _a.name;
        var _b = this.state, id = _b.id, prefix = _b.prefix;
        return children($280b47e13191fcdf$var$prefixId(id, prefix, name), this.uid);
    };
    return UID;
}($5uXOq.Component);

});

parcelRegister("acknU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab6a74d5dbe2e66f9a6df60fb0887ec0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76cad653a4883392$var$_react = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $76cad653a4883392$var$_calendar = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("3fesp")));

var $76cad653a4883392$var$_calendar2 = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("cTemL")));
function $76cad653a4883392$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76cad653a4883392$var$CalendarIcon = (props)=>/*#__PURE__*/ $76cad653a4883392$var$_react.default.createElement($76cad653a4883392$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $76cad653a4883392$var$_calendar2.default
    }, props));
$76cad653a4883392$var$CalendarIcon.Name = 'CalendarIconMigration';
var $76cad653a4883392$var$_default = module.exports.default = $76cad653a4883392$var$CalendarIcon;

});

parcelRegister("7qZ1x", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $71bdd27445bf5301$export$ea56ca58f08ffa52);

var $lCAti = parcelRequire("lCAti");

var $is0Fy = parcelRequire("is0Fy");

var $1cWOp = parcelRequire("1cWOp");
const $71bdd27445bf5301$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date)=>(0, $is0Fy.createDateParser)(normalizedLocale)(date);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("lCAti", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $13af55a9724edafd$export$dca0327c9b9c6498);
const $13af55a9724edafd$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("is0Fy", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $d8bb223589902df4$export$cfa2ef2687faeda2);

var $3wYKB = parcelRequire("3wYKB");

var $lCAti = parcelRequire("lCAti");
const $d8bb223589902df4$var$INVALID_DATE = new Date(NaN);
const $d8bb223589902df4$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $d8bb223589902df4$var$INVARIANT_DATE = (0, $3wYKB.toDate)($d8bb223589902df4$var$INVARIANT);
const $d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $d8bb223589902df4$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $d8bb223589902df4$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $d8bb223589902df4$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $d8bb223589902df4$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($d8bb223589902df4$var$INVARIANT_DATE);
    const shortDate = $d8bb223589902df4$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $d8bb223589902df4$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.day);
    return (date)=>{
        const dateMatch = $d8bb223589902df4$var$stripExtras(date).match($d8bb223589902df4$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $d8bb223589902df4$var$INVALID_DATE;
        const dateParts = $d8bb223589902df4$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $3wYKB.normalizeDate)(extractedDate);
        if (!(0, $3wYKB.isValid)(normalizedDate)) return $d8bb223589902df4$var$INVALID_DATE;
        return (0, $3wYKB.toDate)(normalizedDate);
    };
};

});
parcelRegister("3wYKB", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $121d324fc62f760d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $121d324fc62f760d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $121d324fc62f760d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $121d324fc62f760d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $121d324fc62f760d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $121d324fc62f760d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $121d324fc62f760d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $121d324fc62f760d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $121d324fc62f760d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $121d324fc62f760d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $121d324fc62f760d$export$fcc71269590ba0a8 = (date)=>{
    const now = $121d324fc62f760d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("1cWOp", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $56bd04270448c035$export$9b7ca29af37c192);
const $56bd04270448c035$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("5RLF6", function(module, exports) {

$parcel$export(module.exports, "isDateDisabled", () => $e0db4b6edb7dbfac$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $e0db4b6edb7dbfac$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $e0db4b6edb7dbfac$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $e0db4b6edb7dbfac$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $k7m40 = parcelRequire("k7m40");
var $5I2ju = parcelRequire("5I2ju");
var $eZDAP = parcelRequire("eZDAP");

var $2ucUe = parcelRequire("2ucUe");

var $jHBnA = parcelRequire("jHBnA");
const $e0db4b6edb7dbfac$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $e0db4b6edb7dbfac$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $5I2ju.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $jHBnA.padToTwo)(parsedMonth)}-${(0, $jHBnA.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $jHBnA.padToTwo)(parsedMonth)}-${(0, $jHBnA.padToTwo)(parsedDate)}`;
    return newIso;
};
const $e0db4b6edb7dbfac$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $jHBnA.defaultDateFormat));
    return l10n.parseDate(date);
};
const $e0db4b6edb7dbfac$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $jHBnA.defaultDateFormat));
    const date = (0, $eZDAP.default)(value);
    return dateFormat ? (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $jHBnA.placeholderDatetime));
};

});

parcelRegister("iaQLg", function(module, exports) {

$parcel$export(module.exports, "IndicatorsContainer", () => $d73476b891de3e0c$export$d0ffd7e649cab6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $bChGW = parcelRequire("bChGW");
function $d73476b891de3e0c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d73476b891de3e0c$var$calendarButtonInclusionStyles = {
    name: "i3e4rp",
    styles: "margin-inline-start:var(--ds-space-400, 32px)"
};
const $d73476b891de3e0c$var$calendarButtonOnlyInclusionStyles = {
    name: "19a3ait",
    styles: "margin-inline-start:var(--ds-space-300, 24px)"
};
const $d73476b891de3e0c$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: showClearIndicator ? $d73476b891de3e0c$var$calendarButtonInclusionStyles : $d73476b891de3e0c$var$calendarButtonOnlyInclusionStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).IndicatorsContainer, rest));

});

parcelRegister("gtijU", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $e800a879ee1613fc$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $1f0Hs = parcelRequire("1f0Hs");

var $9MHPe = parcelRequire("9MHPe");


var $k5uoT = parcelRequire("k5uoT");

var $avHVh = parcelRequire("avHVh");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $e800a879ee1613fc$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $eZDAP.default)(iso);
        return (0, $jovBr.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $e800a879ee1613fc$var$menuStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    zIndex: (0, $k5uoT.layers).dialog(),
    backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
    overflow: 'hidden'
});
const $e800a879ee1613fc$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView } = selectProps;
    const { day: day, month: month, year: year } = $e800a879ee1613fc$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9MHPe.UNSAFE_LAYERING), {
        isDisabled: false
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $avHVh.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.calendarContainerRef,
        content: /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $e800a879ee1613fc$var$menuStyles,
            ...innerProps
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1f0Hs.default), {
            day: day,
            month: month,
            year: year,
            disabled: selectProps.calendarDisabled,
            disabledDateFilter: selectProps.calendarDisabledDateFilter,
            minDate: selectProps.calendarMinDate,
            maxDate: selectProps.calendarMaxDate,
            nextMonthLabel: selectProps.nextMonthLabel,
            onChange: selectProps.onCalendarChange,
            onSelect: selectProps.onCalendarSelect,
            previousMonthLabel: selectProps.previousMonthLabel,
            ref: selectProps.calendarRef,
            selected: [
                selectProps.calendarValue
            ],
            shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
            locale: selectProps.calendarLocale,
            testId: selectProps.testId && `${selectProps.testId}--calendar`,
            weekStartDay: selectProps.calendarWeekStartDay
        })),
        testId: selectProps.testId
    }));
};

});
parcelRegister("1f0Hs", function(module, exports) {

$parcel$export(module.exports, "default", () => $16abbcd9b9109722$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $ePz3p = parcelRequire("ePz3p");

var $lJWdi = parcelRequire("lJWdi");

var $avO9B = parcelRequire("avO9B");

var $iioJV = parcelRequire("iioJV");

var $jihAA = parcelRequire("jihAA");

var $bbnGB = parcelRequire("bbnGB");

var $hbcve = parcelRequire("hbcve");

var $2TGJ3 = parcelRequire("2TGJ3");

var $f9D1v = parcelRequire("f9D1v");

var $9efze = parcelRequire("9efze");
const $16abbcd9b9109722$var$boxStyles = (0, $8CUq3.xcss)({
    display: 'inline-block',
    userSelect: 'none'
});
const $16abbcd9b9109722$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $16abbcd9b9109722$var$InnerCalendar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $iioJV.blankStringArray), defaultSelected: defaultSelected = (0, $iioJV.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $eGmKJ.default), onChange: onChange = (0, $eGmKJ.default), onFocus: onFocus = (0, $eGmKJ.default), onSelect: onSelect = (0, $eGmKJ.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $jihAA.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $5uXOq.useState)(false);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNext: handleClickNext, handleClickPrev: handleClickPrev } = (0, $2TGJ3.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $f9D1v.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $bbnGB.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $9efze.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $hbcve.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getPreviousHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const headerId = (0, $9KnKW.useId)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        xcss: $16abbcd9b9109722$var$boxStyles,
        padding: "space.200",
        "aria-label": "calendar",
        testId: testId && `${testId}--calendar`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $luBm6.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ePz3p.default), {
        // The month number needs to be translated to index in the month
        // name array e.g. 1 (January) -> 0
        monthLongTitle: monthsLong[monthValue - 1],
        year: yearValue,
        nextMonthLabel: nextMonthLabel,
        previousMonthLabel: previousMonthLabel,
        nextHeading: getNextHeading(),
        previousHeading: getPreviousHeading(),
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev,
        headerId: headerId,
        tabIndex: tabIndex,
        testId: testId
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        role: "grid",
        onKeyDown: handleContainerKeyDown,
        "aria-labelledby": headerId,
        testId: testId && `${testId}--calendar-dates`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $avO9B.default), {
        daysShort: daysShort,
        testId: testId
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lJWdi.default), {
        weeks: weeks,
        handleClickDay: handleClickDay,
        monthsLong: monthsLong,
        shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
        tabIndex: tabIndex,
        testId: testId
    })))));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $16abbcd9b9109722$var$Calendar = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($16abbcd9b9109722$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$16abbcd9b9109722$var$Calendar.displayName = 'Calendar';
var $16abbcd9b9109722$export$2e2bcd8739ae039 = $16abbcd9b9109722$var$Calendar;

});
parcelRegister("ePz3p", function(module, exports) {

$parcel$export(module.exports, "default", () => $995afee12cb828f6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $42CjB = parcelRequire("42CjB");

var $9KnKW = parcelRequire("9KnKW");

var $1dJ6S = parcelRequire("1dJ6S");

var $fmJTX = parcelRequire("fmJTX");

var $6s76W = parcelRequire("6s76W");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
const $995afee12cb828f6$var$Header = /*#__PURE__*/ (0, $5uXOq.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousHeading: previousHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextHeading: nextHeading, handleClickPrev: handleClickPrev, handleClickNext: handleClickNext, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $9KnKW.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonth, setHasInteractedWithMonth] = (0, $5uXOq.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickPrev(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickNext(e);
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f5TWP.default), {
        space: "space.0",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevMonthInteraction,
        testId: testId && `${testId}--previous-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fmJTX))),
        label: `${previousMonthLabel}, ${previousHeading}`
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        "aria-live": hasInteractedWithMonth ? 'polite' : undefined,
        id: announceId,
        testId: testId && `${testId}--current-month-year--container`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1dJ6S.default), {
        size: "xsmall",
        as: "h2",
        id: headerId,
        testId: testId && `${testId}--current-month-year`
    }, `${monthLongTitle} ${year}`)), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextMonthInteraction,
        testId: testId && `${testId}--next-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6s76W))),
        label: `${nextMonthLabel}, ${nextHeading}`
    })));
});
$995afee12cb828f6$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$995afee12cb828f6$export$2e2bcd8739ae039 = $995afee12cb828f6$var$Header;

});
parcelRegister("fmJTX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17932ebf54d3f380634494a3a0e710ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));

var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
function $b2fc843461eabf96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
    }, props));
$b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;

});
parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_UNSAFE_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});

parcelRegister("a88oa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
function $7601289634e055f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $7601289634e055f6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $7601289634e055f6$var$_chevronLeft.default,
        iconType: "utility"
    }));
$7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;

});


parcelRegister("6s76W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ef383524276f158d595d267ad16f45a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));

var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
function $4b2adfad98efb792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
    }, props));
$4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;

});
parcelRegister("h1toL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
function $c6495598d3d7027d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $c6495598d3d7027d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $c6495598d3d7027d$var$_chevronRight.default,
        iconType: "utility"
    }));
$c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;

});



parcelRegister("lJWdi", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f22a52ec309eeb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dC5iT = parcelRequire("dC5iT");

var $1q4y8 = parcelRequire("1q4y8");

var $h581D = parcelRequire("h581D");
const $43f22a52ec309eeb$var$WeekDays = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`
    }, weeks.map((week, i)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $h581D.default), {
            key: i,
            testId: testId && `${testId}--week`
        }, week.values.map((weekDay)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1q4y8.default), {
                key: `${week.id}-${weekDay.id}`,
                isDisabled: weekDay.isDisabled,
                isFocused: weekDay.isFocused,
                isToday: weekDay.isToday,
                dayLong: weekDay.weekDayName,
                month: weekDay.month,
                monthLong: monthsLong[weekDay.month - 1],
                onClick: handleClickDay,
                isPreviouslySelected: weekDay.isPreviouslySelected,
                isSelected: weekDay.isSelected,
                isSibling: weekDay.isSiblingMonth,
                year: weekDay.year,
                shouldSetFocus: shouldSetFocus,
                tabIndex: tabIndex,
                testId: testId
            }, weekDay.day)))));
});
$43f22a52ec309eeb$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$43f22a52ec309eeb$export$2e2bcd8739ae039 = $43f22a52ec309eeb$var$WeekDays;

});
parcelRegister("1q4y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70b02566a310b79$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $eGmKJ = parcelRequire("eGmKJ");

var $bgrar = parcelRequire("bgrar");

var $h0WbJ = parcelRequire("h0WbJ");
const $d70b02566a310b79$var$Date = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $eGmKJ.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $5uXOq.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const dateCellStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $h0WbJ.dateCellStyles)());
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bgrar.default), {
        role: "gridcell",
        alignItems: "center"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: dateCellStyles,
        "aria-current": isToday ? 'date' : undefined,
        "aria-disabled": isDisabled || undefined,
        "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
        "aria-pressed": isSelected ? 'true' : 'false',
        tabIndex: isFocused ? tabIndex : -1,
        type: "button",
        onClick: handleClick,
        ref: focusRef,
        "data-disabled": isDisabled || undefined,
        "data-focused": isFocused || undefined,
        "data-prev-selected": isPreviouslySelected || undefined,
        "data-selected": isSelected || undefined,
        "data-sibling": isSibling || undefined,
        "data-today": isToday || undefined,
        "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`)
    }, day));
}));
$d70b02566a310b79$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d70b02566a310b79$export$2e2bcd8739ae039 = $d70b02566a310b79$var$Date;

});
parcelRegister("h0WbJ", function(module, exports) {

$parcel$export(module.exports, "dateCellStyles", () => $a52fc59169f9ec00$export$f62807af68630d86);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

const $a52fc59169f9ec00$export$f62807af68630d86 = ()=>({
        all: 'unset',
        display: 'block',
        padding: `${"var(--ds-space-050, 4px)"} 9px`,
        position: 'relative',
        backgroundColor: 'transparent',
        border: '2px solid transparent',
        borderRadius: 3,
        color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
        cursor: 'pointer',
        flexGrow: 1,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        textAlign: 'center',
        '&[data-sibling]': {
            color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
        },
        '&[data-today]': {
            color: `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`,
            fontWeight: "var(--ds-font-weight-bold, bold)",
            '&::after': {
                display: 'block',
                height: 2,
                position: 'absolute',
                right: "var(--ds-space-025, 2px)",
                bottom: "var(--ds-space-025, 2px)",
                left: "var(--ds-space-025, 2px)",
                backgroundColor: 'currentColor',
                content: '""'
            }
        },
        '&[data-prev-selected]': {
            backgroundColor: `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`,
            color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$7090862dc3038a9f})`
        },
        '&[data-selected]': {
            backgroundColor: `var(--ds-background-selected, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`,
            color: `var(--ds-text-selected, ${0, $829f609a65d26a98$export$29a4f05edc054374})`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`,
            cursor: 'not-allowed'
        },
        '&:focus-visible': {
            border: `2px solid ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
        },
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`,
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$226de0355ed012f8})`,
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`
        },
        '&[data-selected]:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${0, $829f609a65d26a98$export$226de0355ed012f8})`,
            color: `var(--ds-text-selected, ${0, $829f609a65d26a98$export$7090862dc3038a9f})`
        },
        '&[data-prev-selected]:hover': {
            color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$7090862dc3038a9f})`
        },
        '&[data-sibling]:hover': {
            color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
        },
        '&[data-disabled]:hover': {
            backgroundColor: 'transparent',
            color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`
        }
    });

});


parcelRegister("h581D", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c8aba25f4ae00ff$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $bgrar = parcelRequire("bgrar");
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $5c8aba25f4ae00ff$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bgrar.default), {
        testId: testId,
        templateColumns: "repeat(7, minmax(max-content, 1fr))",
        role: "row"
    }, children);
    return isHidden ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "aria-hidden": "true"
    }, row) : row;
};
var $5c8aba25f4ae00ff$export$2e2bcd8739ae039 = $5c8aba25f4ae00ff$var$WeekDayGrid;

});


parcelRegister("avO9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $f29b1b1295ce3a84$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $h581D = parcelRequire("h581D");
const $f29b1b1295ce3a84$var$columnHeaderStyles = (0, $8CUq3.xcss)({
    minWidth: 'size.400',
    // Account for languages with short week day names
    whiteSpace: 'nowrap',
    // Account for languages with long week day names
    display: 'flex',
    justifyContent: 'center'
});
const $f29b1b1295ce3a84$var$WeekHeader = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $h581D.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`
    }, daysShort.map((shortDay)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
            padding: "space.100",
            xcss: $f29b1b1295ce3a84$var$columnHeaderStyles,
            key: shortDay,
            role: "columnheader",
            testId: testId && `${testId}--column-header`
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cgL5K.default), {
            weight: "bold",
            size: "UNSAFE_small",
            align: "center",
            color: "color.text.subtle"
        }, shortDay))));
});
$f29b1b1295ce3a84$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f29b1b1295ce3a84$export$2e2bcd8739ae039 = $f29b1b1295ce3a84$var$WeekHeader;

});

parcelRegister("iioJV", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $85c2ac8e9452c4bf$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $85c2ac8e9452c4bf$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $85c2ac8e9452c4bf$export$8fa20d70624f8b9d);
const $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $85c2ac8e9452c4bf$export$3ae905d9742bef55 = 7;
const $85c2ac8e9452c4bf$export$c9b7c010035d60c6 = 12;
const $85c2ac8e9452c4bf$export$8fa20d70624f8b9d = [];

});

parcelRegister("jihAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $654a69afe715a212$export$2e2bcd8739ae039);

var $33etG = parcelRequire("33etG");

var $f8qry = parcelRequire("f8qry");

var $3EtUb = parcelRequire("3EtUb");
function $654a69afe715a212$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $f8qry.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $33etG.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $33etG.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $33etG.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $33etG.default)(today, ()=>today || `${thisYear}-${(0, $3EtUb.default)(thisMonth)}-${(0, $3EtUb.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $33etG.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $33etG.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("3EtUb", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd804e1790f6d755$export$2e2bcd8739ae039);
function $cd804e1790f6d755$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("bbnGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ccb38b64bb63461$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $8ccb38b64bb63461$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $5uXOq.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $5uXOq.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("hbcve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fe53b5f3382c02e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eZDAP = parcelRequire("eZDAP");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $5wbTt = parcelRequire("5wbTt");
function $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $5uXOq.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $iioJV.daysPerWeek) : 0;
            return (0, $5wbTt.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $iioJV.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $0fe53b5f3382c02e$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $5uXOq.useMemo)(()=>(0, $5wbTt.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $eZDAP.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $eZDAP.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $5uXOq.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $6ASl9.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $eZDAP.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("6ASl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6ae62fd51c4538f$export$2e2bcd8739ae039);

var $3EtUb = parcelRequire("3EtUb");
function $b6ae62fd51c4538f$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $3EtUb.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $3EtUb.default)(date.day)}`;
}

});

parcelRegister("5wbTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dff1ed1384abe91$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $iioJV = parcelRequire("iioJV");

var $9Zmg7 = parcelRequire("9Zmg7");
function $3dff1ed1384abe91$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $iioJV.daysPerWeek) - weekStartDay + firstDay) % (0, $iioJV.daysPerWeek));
    const lastDate = (0, $9Zmg7.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $iioJV.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $9Zmg7.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $iioJV.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $iioJV.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $iioJV.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $iioJV.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $iioJV.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("9Zmg7", function(module, exports) {

$parcel$export(module.exports, "default", () => $878800070b837d93$export$2e2bcd8739ae039);
function $878800070b837d93$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("2TGJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $caae4eff24f6e8d0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $9Zmg7 = parcelRequire("9Zmg7");
const $caae4eff24f6e8d0$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $iioJV.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $caae4eff24f6e8d0$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $iioJV.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $caae4eff24f6e8d0$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $5uXOq.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $iioJV.daysPerWeek);
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $iioJV.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNext = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'next'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrev = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prev'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev
    };
}

});

parcelRegister("f9D1v", function(module, exports) {

$parcel$export(module.exports, "default", () => $42ec54640e7b9de4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");
function $42ec54640e7b9de4$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $iioJV.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("9efze", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbd6f430b06675a1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7qZ1x = parcelRequire("7qZ1x");
function $fbd6f430b06675a1$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $5uXOq.useMemo)(()=>(0, $7qZ1x.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $5uXOq.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $5uXOq.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $5uXOq.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("avHVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac07968b7cb494a9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $5owSH = parcelRequire("5owSH");

var $gkD4s = parcelRequire("gkD4s");
var $4oNEb = parcelRequire("4oNEb");
var $1V7PR = parcelRequire("1V7PR");

var $k5uoT = parcelRequire("k5uoT");
class $ac07968b7cb494a9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null);
        const divStyles = {
            background: 'transparent',
            position: 'absolute',
            top: 0,
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $5owSH.sizes).small.slice(0, -2)) - (0, $k5uoT.gridSize)()
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
			 * We need to set the intial top value to where the container is and zIndex so that it still
			 * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gkD4s.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1V7PR.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: ref,
                "data-layer-child": true,
                style: divStyles
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oNEb.Popper), null, ({ ref: ref, style: style, update: update })=>{
            this.update = update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: ref,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    ...style,
                    zIndex: (0, $k5uoT.layers).dialog()
                },
                "data-testid": testId && `${testId}--popper--container`
            }, content);
        })));
    }
    constructor(...args){
        super(...args);
        this.update = (0, $eGmKJ.default);
    }
}

});


parcelRegister("6AqCE", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $caee16c105163c22$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $caee16c105163c22$export$ff525416014fb67d);

var $k7m40 = parcelRequire("k7m40");

var $2ucUe = parcelRequire("2ucUe");
function $caee16c105163c22$export$77d5bc49fed7ef14(date) {
    return (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)('YYYY-MM-DD'));
}
function $caee16c105163c22$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $caee16c105163c22$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("dBs4v", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $9661917c82165ad2$export$6e30bf8cb1347b56);

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
const $9661917c82165ad2$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...rest })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
            theme: theme
        }, children);
    };

});


parcelRegister("jcbUF", function(module, exports) {

$parcel$export(module.exports, "default", () => $48f5b21daaca02ab$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $22Gxp = parcelRequire("22Gxp");

var $6QvkM = parcelRequire("6QvkM");

var $acknU = parcelRequire("acknU");

var $cTemL = parcelRequire("cTemL");

var $7qZ1x = parcelRequire("7qZ1x");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");


var $jldZL = parcelRequire("jldZL");

var $jHBnA = parcelRequire("jHBnA");

var $5RLF6 = parcelRequire("5RLF6");

var $iaQLg = parcelRequire("iaQLg");

var $gtijU = parcelRequire("gtijU");

var $6AqCE = parcelRequire("6AqCE");

var $dBs4v = parcelRequire("dBs4v");
function $48f5b21daaca02ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $48f5b21daaca02ab$var$packageName = "platform-pkg";
const $48f5b21daaca02ab$var$packageVersion = "0.0.0-use.local";
const $48f5b21daaca02ab$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $48f5b21daaca02ab$var$packageName,
    packageVersion: $48f5b21daaca02ab$var$packageVersion
};
const $48f5b21daaca02ab$var$pickerContainerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $48f5b21daaca02ab$var$dropdownIndicatorStyles = (0, $8CUq3.xcss)({
    minWidth: "var(--ds-space-300, 24px)",
    minHeight: "var(--ds-space-300, 24px)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $48f5b21daaca02ab$var$CalendarIcon = (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') ? (0, (/*@__PURE__*/$parcel$interopDefault($acknU))) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
(0, (/*@__PURE__*/$parcel$interopDefault($cTemL)));
const $48f5b21daaca02ab$var$iconContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    height: '100%',
    position: 'absolute',
    alignItems: 'center',
    flexBasis: 'inherit',
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
    insetBlockStart: 0,
    insetInlineEnd: 0,
    transition: `color 150ms`,
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
    }
});
const $48f5b21daaca02ab$var$iconSpacingWithClearButtonStyles = {
    name: "jd0mtf",
    styles: "margin-inline-end:var(--ds-space-400, 2rem)"
};
const $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStylesNew = {
    name: "129q61y",
    styles: "margin-inline-end:var(--ds-space-050, 0.25rem)"
};
const $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStyles = {
    name: "sz3drw",
    styles: "margin-inline-end:var(--ds-space-025, 0.125rem)"
};
const $48f5b21daaca02ab$var$calendarButtonFixedSizeStyles = (0, $8CUq3.xcss)({
    width: `${32 / 14}em`,
    height: `${32 / 14}em`
});
const $48f5b21daaca02ab$var$calendarButtonStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
/**
 * __Date picker__
 *
 * A date picker allows the user to select a particular date.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
 */ const $48f5b21daaca02ab$var$DatePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, forwardedRef)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const calendarRef = (0, $5uXOq.useRef)(null);
    const calendarButtonRef = (0, $5uXOq.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = $48f5b21daaca02ab$var$CalendarIcon, id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: // eslint-disable-next-line @repo/internal/react/use-noop
    onBlur = (_event)=>{}, // eslint-disable-next-line @repo/internal/react/use-noop
    onChange: onChangeProp = (_value)=>{}, onFocus: // eslint-disable-next-line @repo/internal/react/use-noop
    onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $5uXOq.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $5uXOq.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $5uXOq.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $5uXOq.useState)(propValue || defaultValue || (0, $6AqCE.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $5uXOq.useState)((0, $7qZ1x.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $5uXOq.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $5uXOq.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $5uXOq.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $5uXOq.useState)(false);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$48f5b21daaca02ab$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $7qZ1x.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $5uXOq.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false);
            // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $5RLF6.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso);
        // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $5RLF6.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            });
            // Only try to set the date if we have month & day
            if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $6AqCE.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase();
        // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $5RLF6.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $6AqCE.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (isOpen && !shouldSetFocusOnCurrentDay) setShouldSetFocusOnCurrentDay(true);
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    };
    // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen(!isOpen);
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $6AqCE.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    };
    // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $5uXOq.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref;
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = Icon;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration')) clearIndicator = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
            xcss: $48f5b21daaca02ab$var$dropdownIndicatorStyles
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Icon, props));
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const SingleValue = (0, $dBs4v.makeSingleValue)({
        lang: propLocale
    });
    const selectComponents = {
        DropdownIndicator: shouldShowCalendarButton ? (0, $jHBnA.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iaQLg.IndicatorsContainer), {
                    ...props,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: $gtijU.Menu,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $jHBnA.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, inherit)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $6AqCE.getShortISOString)((0, $eZDAP.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay
    };
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $5RLF6.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null;
    // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel} , ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $22Gxp.useUID)()}`;
    return(// These event handlers must be on this element because the events come
    // from different child elements.
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...innerProps,
        css: $48f5b21daaca02ab$var$pickerContainerStyles,
        role: "presentation",
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        "data-testid": testId && `${testId}--container`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        name: name,
        type: "hidden",
        value: getterValue,
        "data-testid": testId && `${testId}--input`
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7K5PP.default), {
        appearance: appearance,
        "aria-describedby": ariaDescribedBy,
        "aria-label": label || undefined,
        autoFocus: autoFocus,
        clearControlLabel: clearControlLabel,
        closeMenuOnSelect: true,
        // For some reason, this and the below `styles` type error _only_ show
        // up when you alter some of the properties in the `selectComponents`
        // object. These errors are still present, and I suspect have always
        // been present, without changing the unrelated code. Ignoring as the
        // component still works as expected despite this error. And also
        // because the select refresh team may solve it later.
        components: selectComponents,
        enableAnimation: false,
        inputId: id,
        inputValue: actualSelectInputValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        menuIsOpen: menuIsOpen,
        onBlur: onSelectBlur,
        onChange: onSelectChange,
        onFocus: onSelectFocus,
        onInputChange: handleSelectInputChange,
        placeholder: (0, $5RLF6.getPlaceholder)({
            placeholder: placeholder,
            l10n: l10n
        }),
        styles: mergedStyles,
        value: initialValue,
        ...selectProps,
        // These are below the spread because I don't know what is in
        // selectProps or not and what wil be overwritten
        isClearable: true,
        isInvalid: isInvalid,
        spacing: spacing,
        testId: testId,
        // These aren't part of `Select`'s API, but we're using them here.
        // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
        calendarContainerRef: calendarProps.calendarContainerRef,
        calendarDisabled: calendarProps.calendarDisabled,
        calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
        calendarLocale: calendarProps.calendarLocale,
        calendarMaxDate: calendarProps.calendarMaxDate,
        calendarMinDate: calendarProps.calendarMinDate,
        calendarRef: calendarProps.calendarRef,
        calendarValue: calendarProps.calendarValue,
        calendarView: calendarProps.calendarView,
        calendarWeekStartDay: calendarProps.calendarWeekStartDay,
        nextMonthLabel: nextMonthLabel,
        onCalendarChange: calendarProps.onCalendarChange,
        onCalendarSelect: calendarProps.onCalendarSelect,
        previousMonthLabel: previousMonthLabel,
        shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
    }), shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $48f5b21daaca02ab$var$iconContainerStyles,
            value && !hideIcon ? $48f5b21daaca02ab$var$iconSpacingWithClearButtonStyles : (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') ? $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStylesNew : $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStyles
        ]
    }, inputLabelId && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jldZL.default), {
        id: openCalendarLabelId
    }, ", ", openCalendarLabel), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5ILhZ.default), {
        ...inputLabelId ? {
            'aria-labelledby': `${inputLabelId} ${openCalendarLabelId}`
        } : {
            'aria-label': fullopenCalendarLabel
        },
        onClick: onCalendarButtonClick,
        onKeyDown: onCalendarButtonKeyDown,
        ref: calendarButtonRef,
        testId: testId && `${testId}--open-calendar-button`,
        type: "button",
        backgroundColor: "color.background.neutral.subtle",
        padding: (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') ? 'space.0' : 'space.050',
        xcss: [
            $48f5b21daaca02ab$var$calendarButtonStyles,
            (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') && $48f5b21daaca02ab$var$calendarButtonFixedSizeStyles
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($48f5b21daaca02ab$var$CalendarIcon, {
        label: "",
        ...(0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') ? {
            color: "var(--ds-icon, #44546F)"
        } : {
            primaryColor: "var(--ds-icon, #44546F)"
        }
    }))) : null));
});
var $48f5b21daaca02ab$export$2e2bcd8739ae039 = $48f5b21daaca02ab$var$DatePicker;

});

parcelRegister("jdTq6", function(module, exports) {

$parcel$export(module.exports, "default", () => $420c0ce16dc216b4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $7qZ1x = parcelRequire("7qZ1x");

var $iOwNT = parcelRequire("iOwNT");
var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $imOgG = parcelRequire("imOgG");

var $j537G = parcelRequire("j537G");

var $2ucUe = parcelRequire("2ucUe");

var $dBs4v = parcelRequire("dBs4v");
const $420c0ce16dc216b4$var$packageName = "platform-pkg";
const $420c0ce16dc216b4$var$packageVersion = "0.0.0-use.local";
const $420c0ce16dc216b4$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $420c0ce16dc216b4$var$analyticsAttributes = {
    componentName: 'timePicker',
    packageName: $420c0ce16dc216b4$var$packageName,
    packageVersion: $420c0ce16dc216b4$var$packageVersion
};
/**
 * __Time picker__
 *
 * A time picker allows the user to select a specific time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/time-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/time-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/time-picker/usage)
 */ const $420c0ce16dc216b4$var$TimePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, $eGmKJ.default), onChange: providedOnChange = (0, $eGmKJ.default), onFocus: providedOnFocus = (0, $eGmKJ.default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, $j537G.default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, $jHBnA.defaultTimes), value: providedValue }, ref)=>{
    const [containerRef, setContainerRef] = (0, $5uXOq.useState)(null);
    /**
   * When being cleared from the icon the TimePicker is blurred.
   * This variable defines whether the default onMenuOpen or onMenuClose
   * events should behave as normal
   */ const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
    // TODO: Remove isFocused? Does it do anything?
    const [_, setIsFocused] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    const [value, setValue] = (0, $5uXOq.useState)(defaultValue);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>x + 1, 0);
    const providedOnChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnChange,
        action: 'selectedTime',
        ...$420c0ce16dc216b4$var$analyticsAttributes
    });
    (0, $5uXOq.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (providedIsOpen) setIsOpen(providedIsOpen);
    }, [
        providedIsOpen
    ]);
    const onChange = (0, $5uXOq.useCallback)((newValue, action)=>{
        const rawValue = newValue ? newValue.value || newValue : '';
        const finalValue = rawValue.toString();
        setValue(finalValue);
        if (action && action.action === 'clear') setClearingFromIcon(true);
        providedOnChangeWithAnalytics(finalValue);
    }, [
        providedOnChangeWithAnalytics
    ]);
    /**
   * Only allow custom times if timeIsEditable prop is true
   */ const onCreateOption = (inputValue)=>{
        if (timeIsEditable) {
            let sanitizedInput;
            try {
                sanitizedInput = parseInputValue(inputValue, timeFormat || (0, $jHBnA.defaultTimeFormat));
            } catch (e) {
                return; // do nothing, the main validation should happen in the form
            }
            const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
            const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
            const formattedValue = (0, $k7m40.default)(sanitizedInput, formatFormat) || '';
            setValue(formattedValue);
            providedOnChangeWithAnalytics(formattedValue);
        } else providedOnChangeWithAnalytics(inputValue);
    };
    const onMenuOpen = ()=>{
        // Don't open menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(true);
    };
    const onMenuClose = ()=>{
        // Don't close menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(false);
    };
    const setInternalContainerRef = (ref)=>{
        const oldRef = containerRef;
        setContainerRef(ref);
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef === null && ref !== null) forceUpdate();
    };
    const onBlur = (event)=>{
        setIsFocused(false);
        providedOnBlur(event);
    };
    const onFocus = (event)=>{
        setIsFocused(true);
        providedOnFocus(event);
    };
    const onSelectKeyDown = (event)=>{
        const { key: key } = event;
        const keyPressed = key.toLowerCase();
        if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
        setClearingFromIcon(false);
    };
    const ICON_PADDING = 2;
    const GRID_SIZE = 8;
    const l10n = (0, $7qZ1x.createLocalizationProvider)(locale);
    const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
    const SelectComponent = timeIsEditable ? (0, $iOwNT.default) : (0, $7K5PP.default);
    /**
   * There are multiple props that can change how the time is formatted.
   * The priority of props used is:
   *   1. formatDisplayLabel
   *   2. timeFormat
   *   3. locale
   */ const formatTime = (time)=>{
        if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, $jHBnA.defaultTimeFormat));
        const date = (0, $j537G.default)(time);
        if (!(date instanceof Date)) return '';
        if (!(0, $jovBr.default)(date)) return time;
        if (timeFormat) return (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)(timeFormat));
        return l10n.formatTime(date);
    };
    const options = times.map((time)=>{
        return {
            label: formatTime(time),
            value: time
        };
    });
    let initialValue;
    if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
        label: formatTime(providedValue),
        value: providedValue
    };
    else if (providedValue !== '' && value) initialValue = {
        label: formatTime(value),
        value: value
    };
    else initialValue = null;
    const SingleValue = (0, $dBs4v.makeSingleValue)({
        lang: locale
    });
    const selectComponents = {
        DropdownIndicator: (0, $jHBnA.EmptyComponent),
        Menu: (0, $imOgG.FixedLayerMenu),
        SingleValue: SingleValue,
        ...hideIcon && {
            ClearIndicator: (0, $jHBnA.EmptyComponent)
        }
    };
    const renderIconContainer = Boolean(!hideIcon && value);
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base
            }),
        menu: (base)=>({
                ...base,
                ...$420c0ce16dc216b4$var$menuStyles,
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
            })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ...innerProps,
        ref: setInternalContainerRef,
        "data-testid": testId && `${testId}--container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        name: name,
        type: "hidden",
        value: value,
        "data-testid": testId && `${testId}--input`,
        onKeyDown: onSelectKeyDown
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectComponent, {
        "aria-describedby": ariaDescribedBy,
        "aria-label": label || undefined,
        appearance: appearance,
        // we need this disabled as we might need focus to move to the select
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus: autoFocus,
        clearControlLabel: clearControlLabel,
        components: selectComponents,
        inputId: id,
        isClearable: true,
        isDisabled: isDisabled,
        isRequired: isRequired,
        menuIsOpen: isOpen && !isDisabled,
        menuPlacement: "auto",
        openMenuOnFocus: true,
        onBlur: onBlur,
        onCreateOption: onCreateOption,
        onChange: onChange,
        options: options,
        onFocus: onFocus,
        onMenuOpen: onMenuOpen,
        onMenuClose: onMenuClose,
        placeholder: placeholder || l10n.formatTime((0, $jHBnA.placeholderDatetime)),
        styles: mergedStyles,
        value: initialValue,
        spacing: spacing,
        // We need this to get things to work, even though it's not supported.
        // @ts-ignore
        fixedLayerRef: containerRef,
        isInvalid: isInvalid,
        testId: testId,
        ...otherSelectProps
    }));
});
var $420c0ce16dc216b4$export$2e2bcd8739ae039 = $420c0ce16dc216b4$var$TimePicker;

});
parcelRegister("iOwNT", function(module, exports) {

$parcel$export(module.exports, "default", () => $59b6485f0cb008dd$export$2e2bcd8739ae039);

var $9OU1i = parcelRequire("9OU1i");

var $3c98u = parcelRequire("3c98u");
const $59b6485f0cb008dd$var$CreatableSelect = (0, $3c98u.default)((0, $9OU1i.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$59b6485f0cb008dd$export$2e2bcd8739ae039 = $59b6485f0cb008dd$var$CreatableSelect;

});
parcelRegister("9OU1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $b29f1caecd9c7d5a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("2HH7Y")).default);

var $5uXOq = parcelRequire("5uXOq");

var $2QhWf = parcelRequire("2QhWf");

var $2HH7Y = parcelRequire("2HH7Y");

var $9uJ4X = parcelRequire("9uJ4X");
const $b29f1caecd9c7d5a$var$CreatableSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const creatableProps = (0, $9uJ4X.default)(props);
    const selectProps = (0, $2HH7Y.default)(creatableProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2QhWf.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b29f1caecd9c7d5a$export$2e2bcd8739ae039 = $b29f1caecd9c7d5a$var$CreatableSelect;

});
parcelRegister("2HH7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $994aeb783b6f955a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eEtcC = parcelRequire("eEtcC");

var $gyjU7 = parcelRequire("gyjU7");
const $994aeb783b6f955a$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $994aeb783b6f955a$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $994aeb783b6f955a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $994aeb783b6f955a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $994aeb783b6f955a$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $994aeb783b6f955a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $eEtcC.getOptionValue), getOptionLabel: getOptionLabel = (0, $eEtcC.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $5uXOq.useMemo)(()=>isValidNewOption(inputValue, (0, $gyjU7.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $5uXOq.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $gyjU7.valueTernary)(isMulti, [
                    ...(0, $gyjU7.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});



parcelRegister("imOgG", function(module, exports) {

$parcel$export(module.exports, "FixedLayerMenu", () => $cf860f703ecf4b3d$export$982ad994195b4356);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $bChGW = parcelRequire("bChGW");

var $avHVh = parcelRequire("avHVh");
const $cf860f703ecf4b3d$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, children: children, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $avHVh.default), {
        inputValue: selectProps.inputValue,
        //@ts-ignore react-select unsupported props
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).Menu, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
            theme: theme
        }, children),
        //@ts-ignore react-select unsupported props
        testId: selectProps.testId
    });

});

parcelRegister("j537G", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5e493719c30ce57$export$2e2bcd8739ae039);
const $b5e493719c30ce57$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $b5e493719c30ce57$export$1ea939691cdc45b8(timeString) {
    /**
	 * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
	 */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
	 * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
	 */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
	 * Convert `2:34:56 pm` down to `23456`
	 */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
function $b5e493719c30ce57$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
function $b5e493719c30ce57$export$c38a243baf9c6083(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $b5e493719c30ce57$export$ed20539f7181c701(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $b5e493719c30ce57$var$map24[hour];
    return hour;
}
function $b5e493719c30ce57$export$4077529dfc44a251(value) {
    if (value > '59') return null;
    return value;
}
function $b5e493719c30ce57$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $b5e493719c30ce57$export$c38a243baf9c6083(timeArray[0].trim());
    const hour = $b5e493719c30ce57$export$ed20539f7181c701(semi24.substring(0, 2), meridiem);
    const minute = $b5e493719c30ce57$export$4077529dfc44a251(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $b5e493719c30ce57$export$4077529dfc44a251(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
function $b5e493719c30ce57$export$865db99128311580(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $b5e493719c30ce57$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!$b5e493719c30ce57$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
    const time1 = $b5e493719c30ce57$export$49c81d9f91c512ce(trimmedTime);
    const time2 = $b5e493719c30ce57$export$6137ce2c9c5166bb(time1);
    if (!time2) throw RangeError('invalid time format');
    return $b5e493719c30ce57$export$865db99128311580(time2);
}

});



parcelRegister("hB1kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d24b25c52c40a49$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $6QvkM = parcelRequire("6QvkM");

var $cQz2U = parcelRequire("cQz2U");

var $VSDnB = parcelRequire("VSDnB");

var $7VXAu = parcelRequire("7VXAu");


var $jHBnA = parcelRequire("jHBnA");

var $8JNJx = parcelRequire("8JNJx");

var $cKsfY = parcelRequire("cKsfY");

var $2ucUe = parcelRequire("2ucUe");

var $2TI0z = parcelRequire("2TI0z");

var $jcbUF = parcelRequire("jcbUF");

var $jdTq6 = parcelRequire("jdTq6");
function $9d24b25c52c40a49$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9d24b25c52c40a49$var$DatePicker = (0, $cKsfY.componentWithCondition)(()=>(0, $VSDnB.fg)('dst-date-picker-use-functional-component'), (0, $jcbUF.default), (0, $2TI0z.default));
const $9d24b25c52c40a49$var$packageName = "platform-pkg";
const $9d24b25c52c40a49$var$packageVersion = "0.0.0-use.local";
const $9d24b25c52c40a49$var$analyticsAttributes = {
    componentName: 'dateTimePicker',
    packageName: $9d24b25c52c40a49$var$packageName,
    packageVersion: $9d24b25c52c40a49$var$packageVersion
};
// Make DatePicker 50% the width of DateTimePicker
// If rendering an icon container, shrink the TimePicker
const $9d24b25c52c40a49$var$datePickerContainerStyles = {
    name: "d1cmrh",
    styles: "flex-basis:50%;flex-grow:1;flex-shrink:0"
};
const $9d24b25c52c40a49$var$timePickerContainerStyles = {
    name: "zwso5s",
    styles: "flex-basis:50%;flex-grow:1"
};
const $9d24b25c52c40a49$var$iconContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    margin: "var(--ds-border-width, 1px)",
    alignItems: 'center',
    flexBasis: 'inherit',
    backgroundColor: 'inherit',
    border: 'none',
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
    paddingBlockEnd: "var(--ds-space-075, 6px)",
    paddingBlockStart: "var(--ds-space-075, 6px)",
    paddingInlineEnd: "var(--ds-space-100, 8px)",
    paddingInlineStart: "var(--ds-space-050, 4px)",
    transition: `color 150ms`,
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
    }
});
// react-select overrides (via @atlaskit/select).
const $9d24b25c52c40a49$var$styles = {
    control: (style)=>({
            ...style,
            backgroundColor: 'transparent',
            border: 2,
            borderRadius: 0,
            paddingLeft: 0,
            ':hover': {
                backgroundColor: 'transparent',
                cursor: 'inherit'
            }
        })
};
const $9d24b25c52c40a49$export$3b559a1219cb3c27 = 'Date';
const $9d24b25c52c40a49$export$d82cc7e53d68a428 = 'Time';
/**
 * __Date time picker__
 *
 * A date time picker allows the user to select an associated date and time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/usage)
 */ const $9d24b25c52c40a49$var$DateTimePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerPropsWithSelectProps = {}, defaultValue: defaultValue = '', id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, name: name = '', onBlur: // These disables are here for proper typing when used as defaults. They
// should *not* use the `noop` function.
/* eslint-disable @repo/internal/react/use-noop */ onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, /* eslint-enable @repo/internal/react/use-noop */ parseValue: providedParseValue, spacing: spacing = 'default', locale: locale = 'en-US', testId: testId, timePickerProps: timePickerPropsWithSelectProps = {}, value: providedValue }, ref)=>{
    const [dateValue, setDateValue] = (0, $5uXOq.useState)(datePickerPropsWithSelectProps?.defaultValue || '');
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const [timeValue, setTimeValue] = (0, $5uXOq.useState)(timePickerPropsWithSelectProps?.defaultValue || '');
    const [value, setValue] = (0, $5uXOq.useState)(defaultValue || '');
    const [zoneValue, setZoneValue] = (0, $5uXOq.useState)('');
    (0, $5uXOq.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    const parseValue = (0, $5uXOq.useCallback)((value, providedDateValue, providedTimeValue, providedZoneValue)=>{
        if (providedParseValue) {
            const parsedFromFn = providedParseValue(value, providedDateValue, providedTimeValue, providedZoneValue);
            // This handles cases found in Jira where the parse function actually does
            // nothing and returns undefined. The previous `getSafeState` function
            // just spread the values over the state, but if it returned `undefined`,
            // it would just rely on the previous state values. Considering this is
            // what is input to this function anyway, this is a safe way to handle
            // this, colocate the behavior, and not rely on `getSafeState`.
            return parsedFromFn || {
                dateValue: providedDateValue,
                timeValue: providedTimeValue,
                zoneValue: providedZoneValue
            };
        }
        const parsed = (0, $eZDAP.default)(value);
        return (0, $jovBr.default)(parsed) ? {
            dateValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('YYYY-MM-DD')),
            timeValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('HH:mm')),
            zoneValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('ZZ'))
        } : {
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        };
    }, [
        providedParseValue,
        dateValue,
        timeValue,
        zoneValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        setDateValue(parsedValues.dateValue);
        setTimeValue(parsedValues.timeValue);
        setZoneValue(parsedValues.zoneValue);
    }, [
        value,
        dateValue,
        timeValue,
        zoneValue,
        parseValue
    ]);
    const onDateBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (datePickerPropsWithSelectProps?.onBlur) datePickerPropsWithSelectProps.onBlur(event);
    };
    const onTimeBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (timePickerPropsWithSelectProps?.onBlur) timePickerPropsWithSelectProps.onBlur(event);
    };
    const onDateFocus = (event)=>{
        setIsFocused(false);
        onFocus(event);
        if (datePickerPropsWithSelectProps?.onFocus) datePickerPropsWithSelectProps.onFocus(event);
    };
    const onTimeFocus = (event)=>{
        setIsFocused(false);
        onFocus(event);
        if (timePickerPropsWithSelectProps?.onFocus) timePickerPropsWithSelectProps.onFocus(event);
    };
    const onDateChange = (dateValue)=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: dateValue,
            providedTimeValue: parsedValues.timeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange(dateValue);
    };
    const onTimeChange = (timeValue)=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: parsedValues.dateValue,
            providedTimeValue: timeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange(timeValue);
    };
    const onClear = ()=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: '',
            providedTimeValue: '',
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange('');
        if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange('');
    };
    const onChangePropWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$9d24b25c52c40a49$var$analyticsAttributes
    });
    const onValueChange = ({ providedDateValue: providedDateValue, providedTimeValue: providedTimeValue, providedZoneValue: providedZoneValue })=>{
        setDateValue(providedDateValue);
        setTimeValue(providedTimeValue);
        setZoneValue(providedZoneValue);
        if (providedDateValue && providedTimeValue) {
            const value = (0, $jHBnA.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, providedZoneValue);
            const { zoneValue: parsedZone } = parseValue(value, providedDateValue, providedTimeValue, providedZoneValue);
            const valueWithValidZone = (0, $jHBnA.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, parsedZone);
            setValue(valueWithValidZone);
            onChangePropWithAnalytics(valueWithValidZone);
        // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (value) {
            setValue('');
            onChangePropWithAnalytics('');
        }
    };
    const { selectProps: datePickerSelectProps, ...datePickerProps } = datePickerPropsWithSelectProps;
    const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
    const datePickerLabel = datePickerProps.label || $9d24b25c52c40a49$export$3b559a1219cb3c27;
    const mergedDatePickerSelectProps = {
        ...datePickerSelectProps,
        styles: (0, $7VXAu.mergeStyles)($9d24b25c52c40a49$var$styles, datePickerSelectProps?.styles)
    };
    const { selectProps: timePickerSelectProps, ...timePickerProps } = timePickerPropsWithSelectProps;
    const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
    const timePickerLabel = timePickerProps.label || $9d24b25c52c40a49$export$d82cc7e53d68a428;
    const mergedTimePickerSelectProps = {
        ...timePickerSelectProps,
        styles: (0, $7VXAu.mergeStyles)($9d24b25c52c40a49$var$styles, timePickerSelectProps?.styles)
    };
    // Render DateTimePicker's IconContainer when a value has been filled
    // Don't use Date or TimePicker's because they can't be customised
    const isClearable = Boolean(dateValue || timeValue);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8JNJx.DateTimePickerContainer), {
        appearance: appearance,
        isDisabled: isDisabled,
        isFocused: isFocused,
        isInvalid: isInvalid,
        testId: testId,
        innerProps: innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        name: name,
        type: "hidden",
        value: value,
        "data-testid": testId && `${testId}--input`
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $9d24b25c52c40a49$var$datePickerContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($9d24b25c52c40a49$var$DatePicker, {
        appearance: appearance,
        "aria-describedby": datePickerAriaDescribedBy,
        autoFocus: datePickerProps.autoFocus || autoFocus,
        dateFormat: datePickerProps.dateFormat,
        defaultIsOpen: datePickerProps.defaultIsOpen,
        defaultValue: datePickerProps.defaultValue,
        disabled: datePickerProps.disabled,
        disabledDateFilter: datePickerProps.disabledDateFilter,
        formatDisplayLabel: datePickerProps.formatDisplayLabel,
        hideIcon: datePickerProps.hideIcon || true,
        icon: datePickerProps.icon,
        id: datePickerProps.id || id,
        innerProps: datePickerProps.innerProps,
        isDisabled: datePickerProps.isDisabled || isDisabled,
        isInvalid: datePickerProps.isInvalid || isInvalid,
        isOpen: datePickerProps.isOpen,
        isRequired: datePickerProps.isRequired || isRequired,
        label: datePickerLabel,
        locale: datePickerProps.locale || locale,
        maxDate: datePickerProps.maxDate,
        minDate: datePickerProps.minDate,
        name: datePickerProps.name,
        nextMonthLabel: datePickerProps.nextMonthLabel,
        onBlur: onDateBlur,
        onChange: onDateChange,
        onFocus: onDateFocus,
        parseInputValue: datePickerProps.parseInputValue,
        placeholder: datePickerProps.placeholder,
        previousMonthLabel: datePickerProps.previousMonthLabel,
        selectProps: mergedDatePickerSelectProps,
        spacing: datePickerProps.spacing || spacing,
        testId: testId && `${testId}--datepicker` || datePickerProps.testId,
        value: dateValue,
        weekStartDay: datePickerProps.weekStartDay
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $9d24b25c52c40a49$var$timePickerContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jdTq6.default), {
        appearance: timePickerProps.appearance || appearance,
        "aria-describedby": timePickerAriaDescribedBy,
        autoFocus: timePickerProps.autoFocus,
        defaultIsOpen: timePickerProps.defaultIsOpen,
        defaultValue: timePickerProps.defaultValue,
        formatDisplayLabel: timePickerProps.formatDisplayLabel,
        hideIcon: timePickerProps.hideIcon || true,
        id: timePickerProps.id,
        innerProps: timePickerProps.innerProps,
        isDisabled: timePickerProps.isDisabled || isDisabled,
        isInvalid: timePickerProps.isInvalid || isInvalid,
        isOpen: timePickerProps.isOpen,
        isRequired: timePickerProps.isRequired || isRequired,
        label: timePickerLabel,
        locale: timePickerProps.locale || locale,
        name: timePickerProps.name,
        onBlur: onTimeBlur,
        onChange: onTimeChange,
        onFocus: onTimeFocus,
        parseInputValue: timePickerProps.parseInputValue,
        placeholder: timePickerProps.placeholder,
        selectProps: mergedTimePickerSelectProps,
        spacing: timePickerProps.spacing || spacing,
        testId: timePickerProps.testId || testId && `${testId}--timepicker`,
        timeFormat: timePickerProps.timeFormat,
        timeIsEditable: timePickerProps.timeIsEditable,
        times: timePickerProps.times,
        value: timeValue
    })), isClearable && !isDisabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        css: $9d24b25c52c40a49$var$iconContainerStyles,
        onClick: onClear,
        "data-testid": testId && `${testId}--icon--container`,
        tabIndex: -1,
        type: "button"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQz2U))), {
        LEGACY_size: "small",
        color: "currentColor",
        label: clearControlLabel
    }), ' ') : null);
});
var $9d24b25c52c40a49$export$2e2bcd8739ae039 = $9d24b25c52c40a49$var$DateTimePicker;

});


parcelRegister("hO2mG", function(module, exports) {

$parcel$export(module.exports, "getDayOptions", () => $b6e9dfed9f9dd9c8$export$c9a4384ba880408a);
$parcel$export(module.exports, "getDefaultTimes", () => $b6e9dfed9f9dd9c8$export$951e947e785c998d);
$parcel$export(module.exports, "createEmptyIntervalValue", () => $b6e9dfed9f9dd9c8$export$f1cb5eeb3e4452b1);
$parcel$export(module.exports, "getDayValue", () => $b6e9dfed9f9dd9c8$export$3a1562e64a58f62b);
$parcel$export(module.exports, "getTimeValue", () => $b6e9dfed9f9dd9c8$export$9ea65b90e29638cb);

var $gwejS = parcelRequire("gwejS");

var $k7m40 = parcelRequire("k7m40");

var $1GF3c = parcelRequire("1GF3c");
const $b6e9dfed9f9dd9c8$var$dayLabelFormat = {
    default: 'EEEE',
    compact: 'EEE'
};
const $b6e9dfed9f9dd9c8$export$c9a4384ba880408a = (params = {
    weekStartDay: 1
}, variant = 'default')=>{
    if (params.weekStartDay > 8) params.weekStartDay = params.weekStartDay % 8;
    const firstDOW = (0, $1GF3c.default)(new Date(), {
        weekStartsOn: params.weekStartDay - 1
    });
    const weekDays = Array.from(Array(7)).map((e, i)=>({
            label: (0, $k7m40.default)((0, $gwejS.default)(firstDOW, i), $b6e9dfed9f9dd9c8$var$dayLabelFormat[variant]),
            value: (i + params.weekStartDay - 1) % 7 + 1
        }));
    return weekDays;
};
const $b6e9dfed9f9dd9c8$export$951e947e785c998d = ()=>{
    return [
        ...Array(24).keys()
    ].map((time)=>{
        let newTime = time.toString();
        if (newTime.length === 1) newTime = `0${time}`;
        return [
            `${newTime}:00`,
            `${newTime}:30`
        ];
    }).flatMap((time)=>time);
};
const $b6e9dfed9f9dd9c8$export$f1cb5eeb3e4452b1 = ()=>{
    return {
        startDay: null,
        startHour: null,
        startMinute: null,
        endDay: null,
        endHour: null,
        endMinute: null
    };
};
const $b6e9dfed9f9dd9c8$export$3a1562e64a58f62b = (value, variant = 'default')=>{
    if (value) {
        if (value.day) {
            const dayOptions = $b6e9dfed9f9dd9c8$export$c9a4384ba880408a(undefined, variant);
            const dayValue = dayOptions.find((day)=>day.value === value.day);
            return dayValue || undefined;
        }
    }
    return undefined;
};
const $b6e9dfed9f9dd9c8$export$9ea65b90e29638cb = (value)=>{
    if (value) {
        const isTimeSet = (value.hour || value.hour === 0) && (value.minute || value.minute === 0);
        if (isTimeSet) {
            if (value.hour > 24 || value.minute > 60) return undefined;
            const formattedTimeValue = `${value.hour || '00'}:${value.minute || '00'}`;
            return formattedTimeValue || undefined;
        }
    }
    return undefined;
};

});

parcelRegister("ivHJ6", function(module, exports) {

$parcel$export(module.exports, "useIncrementCreationService", () => $48d17f38e228d167$export$cd3734bd633c5dea);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");

var $dIdda = parcelRequire("dIdda");
const $48d17f38e228d167$export$cd3734bd633c5dea = ()=>{
    const [planId] = (0, $dIdda.usePathParam)('planId');
    const request = (0, $5uXOq.useCallback)((requestData)=>(0, $eusud.performPostRequest)(`/rest/jpo/2.0/plans/${planId}/increments`, {
            body: JSON.stringify(requestData)
        }), [
        planId
    ]);
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $ld2hZ.useService)(request);
    return {
        saving: loading,
        error: error,
        data: data,
        save: fetch
    };
};

});
parcelRegister("ld2hZ", function(module, exports) {

$parcel$export(module.exports, "useService", () => $b3ad55f76ff82cb6$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useLoadingStatusService", () => $b3ad55f76ff82cb6$export$c963713a27525aaf);

var $5uXOq = parcelRequire("5uXOq");
const $b3ad55f76ff82cb6$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setState] = (0, $5uXOq.useState)({
        loading: false,
        data: undefined,
        error: undefined,
        ...initialState
    });
    const fetch = (0, $5uXOq.useCallback)(async (requestData)=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request(requestData);
            setState({
                loading: false,
                error: undefined,
                data: data
            });
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
            return undefined;
        }
    }, [
        request
    ]);
    return {
        ...state,
        fetch: fetch
    };
};
const $b3ad55f76ff82cb6$export$c963713a27525aaf = (request, initialState = {})=>{
    const [loadingStatus, setLoadingStatus] = (0, $5uXOq.useState)('idle');
    const { data: data, loading: loading, error: error, fetch: fetch } = $b3ad55f76ff82cb6$export$6de4685a6c88b4e9(request, initialState);
    (0, $5uXOq.useEffect)(()=>{
        if (loading) setLoadingStatus('started');
        else if (error) setLoadingStatus('error');
        else if (data) setLoadingStatus('success');
    }, [
        data,
        loading,
        error
    ]);
    return {
        data: data,
        loadingStatus: loadingStatus,
        error: error,
        fetch: fetch
    };
};

});


parcelRegister("h9qPG", function(module, exports) {

$parcel$export(module.exports, "ScopeFilterValue", () => $e78f1b983b9b97c5$export$c05b3e6305ac65cd);
$parcel$export(module.exports, "ScopeFilterField", () => $e78f1b983b9b97c5$export$7f20c193b296fdf0);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $fWqG2 = parcelRequire("fWqG2");

var $lLtod = parcelRequire("lLtod");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");
var $bUa6y = parcelRequire("bUa6y");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");
var $7K5PP = parcelRequire("7K5PP");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $5sUih = parcelRequire("5sUih");

var $4OuBK = parcelRequire("4OuBK");

var $emGA4 = parcelRequire("emGA4");

var $3hAHQ = parcelRequire("3hAHQ");
const $e78f1b983b9b97c5$var$OptionComponent = ({ project: project, label: label })=>{
    const projectElements = !(0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(project) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span"
    }, "\xa0("), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLtod.default), {
        appearance: "square",
        size: "xsmall",
        name: project.key,
        src: project.avatar
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span"
    }, "\xa0", project.key, ")"));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e78f1b983b9b97c5$var$OptionStyles
    }, label), projectElements);
};
const $e78f1b983b9b97c5$var$BoardScopeFilterControl = ({ children: children, ...props })=>{
    const selectedValue = props.getValue();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: selectedValue.length > 0 && selectedValue[0].label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Control, props, children));
};
const $e78f1b983b9b97c5$var$BoardScopeFilterSingleValue = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e78f1b983b9b97c5$var$OptionComponent, {
        label: props.data.label,
        project: props.data.project
    }));
const $e78f1b983b9b97c5$var$BoardScopeFilterOption = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: props.data.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e78f1b983b9b97c5$var$OptionComponent, {
        label: props.data.label,
        project: props.data.project
    })));
const $e78f1b983b9b97c5$export$c05b3e6305ac65cd = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { planId: planId, scenarioId: scenarioId } = (0, $5uXOq.useContext)((0, $5sUih.default));
    const formState = (0, $bUa6y.useFormState)();
    const previousFieldId = (0, $5uXOq.useRef)(undefined);
    const fieldId = formState?.values?.filterFieldId?.value;
    const { values: customFieldValues, isLoading: isLoading, fetchCustomFieldValues: fetchCustomFieldValues } = (0, $4OuBK.useFetchCustomFieldValues)({
        planId: planId,
        scenarioId: scenarioId,
        fieldId: fieldId
    });
    const currentFieldValue = formState?.values.filterFieldValue;
    const debouncedLoadOptions = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((query)=>{
            fetchCustomFieldValues(query);
        }, 200), [
        fetchCustomFieldValues
    ]);
    const customFieldValueOptions = (0, $5uXOq.useMemo)(()=>(customFieldValues || []).map((v)=>({
                label: v.value,
                value: v.value
            })), [
        customFieldValues
    ]);
    const valueOfSelect = (0, $5uXOq.useMemo)(()=>customFieldValueOptions.find((v)=>v.value === currentFieldValue?.value), [
        customFieldValueOptions,
        currentFieldValue
    ]);
    const onInputChangeHandler = (0, $5uXOq.useCallback)((query, actionMeta)=>{
        if (actionMeta.action !== 'input-change') return;
        debouncedLoadOptions(query);
    }, [
        debouncedLoadOptions
    ]);
    const onChangeHandler = (0, $5uXOq.useCallback)((newValue, actionMeta, onChange)=>{
        if (actionMeta.action === 'clear') debouncedLoadOptions('');
        onChange(newValue, actionMeta);
    }, [
        debouncedLoadOptions
    ]);
    const onFocusHandler = (0, $5uXOq.useCallback)((event, onFocus)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(valueOfSelect)) {
            debouncedLoadOptions('');
            onFocus(event);
        }
    }, [
        debouncedLoadOptions,
        valueOfSelect
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (previousFieldId.current !== fieldId) {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(fieldId)) debouncedLoadOptions('');
            previousFieldId.current = fieldId;
        }
    }, [
        fieldId,
        debouncedLoadOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e78f1b983b9b97c5$var$FieldBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        "aria-required": true,
        name: "filterFieldValue",
        testId: "portfolio-3-plan-increment-common.ui.increment-forms.board-scope-filter.custom-field-value",
        label: formatMessage((0, $3hAHQ.default).scopeFilterFieldValueLabel),
        isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(fieldId)
    }, ({ fieldProps: { id: id, value: value, onChange: onChange, onFocus: onFocus, ...rest }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
            isLoading: isLoading,
            isClearable: true,
            inputId: id,
            closeMenuOnScroll: true,
            openMenuOnFocus: true,
            options: customFieldValueOptions,
            onInputChange: onInputChangeHandler,
            value: valueOfSelect,
            styles: {
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $gwIPs.layers).modal
                    })
            },
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            menuPortalTarget: document.body,
            placeholder: formatMessage((0, $3hAHQ.default).scopeFilterFieldValuePlaceholder),
            controlShouldRenderValue: !(0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(valueOfSelect),
            components: {
                ...(0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(valueOfSelect) && {
                    ClearIndicator: ()=>null
                }
            },
            "aria-label": formatMessage((0, $3hAHQ.default).scopeFilterFieldValueLabel),
            onChange: (newValue, actionMeta)=>onChangeHandler(newValue, actionMeta, onChange),
            onFocus: (event)=>onFocusHandler(event, onFocus),
            filterOption: ()=>true,
            ...rest
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, error))));
};
const $e78f1b983b9b97c5$export$7f20c193b296fdf0 = ({ shouldFetchCustomFields: shouldFetchCustomFields })=>{
    const { planId: planId } = (0, $5uXOq.useContext)((0, $5sUih.default));
    const { customFields: customFields, fetchCustomFields: fetchCustomFields, isLoading: isLoadingCustomFields } = (0, $emGA4.useFetchCustomFields)({
        planId: planId
    });
    const customFieldOptions = (0, $5uXOq.useMemo)(()=>{
        if (isLoadingCustomFields) return [];
        return (customFields || []).map((f)=>({
                label: f.title,
                value: f.id,
                project: f.project
            }));
    }, [
        customFields,
        isLoadingCustomFields
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFetchCustomFields) fetchCustomFields();
    }, [
        fetchCustomFields,
        shouldFetchCustomFields
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e78f1b983b9b97c5$var$FieldBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        "aria-required": true,
        name: "filterFieldId",
        testId: "portfolio-3-plan-increment-common.ui.increment-forms.board-scope-filter.custom-field",
        label: formatMessage((0, $3hAHQ.default).scopeFilterFieldLabel)
    }, ({ fieldProps: { id: id, ...rest }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
            inputId: id,
            isLoading: isLoadingCustomFields,
            isClearable: true,
            isSearchable: true,
            closeMenuOnScroll: true,
            styles: {
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $gwIPs.layers).modal
                    })
            },
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            menuPortalTarget: document.body,
            placeholder: formatMessage((0, $3hAHQ.default).scopeFilterFieldPlaceholder),
            options: customFieldOptions,
            components: {
                Option: $e78f1b983b9b97c5$var$BoardScopeFilterOption,
                SingleValue: $e78f1b983b9b97c5$var$BoardScopeFilterSingleValue,
                Control: $e78f1b983b9b97c5$var$BoardScopeFilterControl
            },
            ...rest
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, error))));
};
const $e78f1b983b9b97c5$var$FieldBoxStyles = (0, $8CUq3.xcss)({
    width: '50%'
});
const $e78f1b983b9b97c5$var$OptionStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("bUa6y", function(module, exports) {

$parcel$export(module.exports, "useFormState", () => $0ed03f14f588391e$export$606f11b2eb45ecc6);

var $5uXOq = parcelRequire("5uXOq");

var $efXp3 = parcelRequire("efXp3");
// Constantized to avoid a new object reference built every call
const $0ed03f14f588391e$var$defaultSubscriptionConfig = {
    values: true
};
/**
 * Build a simple hash for a given subscription object for use in a `useMemo` dependencies array.
 * This is because `{ values: true } !== { values: true }`, but `'values:true|' === 'values:true|'`
 *
 * @example { values: true, dirty: false } => 'values:true|dirty:false|'
 */ const $0ed03f14f588391e$var$getSubscriptionHash = (subscriptionConfig)=>{
    let hash = '';
    for(const key in subscriptionConfig)if (subscriptionConfig.hasOwnProperty(key)) hash += `${key}:${subscriptionConfig[key]}|`;
    return hash;
};
const $0ed03f14f588391e$export$606f11b2eb45ecc6 = (subscriptionConfig = $0ed03f14f588391e$var$defaultSubscriptionConfig)=>{
    const { subscribe: subscribe } = (0, $5uXOq.useContext)((0, $efXp3.FormContext));
    const [state, setState] = (0, $5uXOq.useState)();
    /**
	 * A hash for us to shallow compare the subscriptionConfig object to react to shallow changes, but avoid referential changes.
	 * We avoid computing the hash if the subscription config has referential equality altogether.
	 */ const subscriptionConfigHash = (0, $5uXOq.useMemo)(()=>$0ed03f14f588391e$var$getSubscriptionHash(subscriptionConfig), [
        subscriptionConfig
    ]);
    /**
	 * Return a memoized version of the subscription config to only react to shallow changes, not referential changes.
	 * Eg. calling `useFormState({ values: true })` twice will result in two different objects by reference, but not by shallow comparison.
	 * This will ensure we don't re-subscribe to the form state when the subscription config is the same.
	 */ const config = (0, $5uXOq.useMemo)(()=>subscriptionConfig, // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally controlled with a hash to have an explicit shallow comparison
    [
        subscriptionConfigHash
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = subscribe((formState)=>{
            setState(formState);
        }, config);
        return ()=>unsubscribe();
    }, [
        subscribe,
        config
    ]);
    return state;
};

});

parcelRegister("4OuBK", function(module, exports) {

$parcel$export(module.exports, "useFetchCustomFieldValues", () => $453183d0cc86877a$export$4fffb4b733c3194d);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $4jAPy = parcelRequire("4jAPy");
const $453183d0cc86877a$export$4fffb4b733c3194d = ({ planId: planId, scenarioId: scenarioId, fieldId: fieldId })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [values, setValues] = (0, $5uXOq.useState)(null);
    const fetchCustomFieldValues = (0, $5uXOq.useCallback)(async (query = '')=>{
        try {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(planId)) throw new Error('planId is empty in the creation IP board');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(scenarioId)) throw new Error('scenarioId is empty in the creation IP board');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(fieldId)) throw new Error('fieldId is empty in the creation IP board');
            setIsLoading(true);
            const url = `/rest/jpo/2.0/plans/${planId}/increments/scenarios/${scenarioId}/fieldId/${fieldId}/scopeFilterValues?query=${query}`;
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const values = await (0, $eusud.performGetRequest)(url);
            setValues(values || []);
            setError(null);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'useFetchCustomFieldValues',
                    packageName: (0, $4jAPy.PACKAGE_NAME),
                    teamName: (0, $4jAPy.ERROR_REPORTING_TEAM)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setError(error);
            setValues(null);
        } finally{
            setIsLoading(false);
        }
    }, [
        planId,
        scenarioId,
        fieldId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(fieldId)) setValues(null);
    }, [
        fieldId
    ]);
    return {
        isLoading: isLoading,
        error: error,
        values: values,
        fetchCustomFieldValues: fetchCustomFieldValues
    };
};

});

parcelRegister("emGA4", function(module, exports) {

$parcel$export(module.exports, "useFetchCustomFields", () => $d9a80884ad89eec5$export$61fa1c8b082f394e);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $4jAPy = parcelRequire("4jAPy");
const $d9a80884ad89eec5$export$61fa1c8b082f394e = ({ planId: planId })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [customFields, setCustomFields] = (0, $5uXOq.useState)(null);
    const fetchCustomFields = (0, $5uXOq.useCallback)(async ()=>{
        try {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(planId)) throw new Error('planId is empty in the fetch custom fields request');
            setIsLoading(true);
            const rawCustomFields = await (0, $eusud.performGetRequest)(`/rest/jpo/2.0/plans/${planId}/increments/scopeFilterFields`);
            setCustomFields(rawCustomFields || []);
            setError(null);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'useFetchCustomFields',
                    packageName: (0, $4jAPy.PACKAGE_NAME),
                    teamName: (0, $4jAPy.ERROR_REPORTING_TEAM)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setError(error);
            setCustomFields(null);
        } finally{
            setIsLoading(false);
        }
    }, [
        planId
    ]);
    return {
        isLoading: isLoading,
        error: error,
        customFields: customFields,
        fetchCustomFields: fetchCustomFields
    };
};

});

parcelRegister("3hAHQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb8b6a4ca7c13973$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $cb8b6a4ca7c13973$var$messages = (0, $7VHMR.defineMessages)({
    scopeFilterFieldValueLabel: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.board-scope-filter.scope-filter-field-value-label",
        "defaultMessage": "Value"
    },
    scopeFilterFieldValuePlaceholder: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.board-scope-filter.scope-filter-field-value-placeholder",
        "defaultMessage": "Select value"
    },
    scopeFilterFieldLabel: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.board-scope-filter.scope-filter-field-label",
        "defaultMessage": "Field"
    },
    scopeFilterFieldPlaceholder: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.board-scope-filter.scope-filter-field-placeholder",
        "defaultMessage": "Select field"
    }
});
var $cb8b6a4ca7c13973$export$2e2bcd8739ae039 = $cb8b6a4ca7c13973$var$messages;

});


parcelRegister("1bxch", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e0056041ef7689f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bUa6y = parcelRequire("bUa6y");

var $cgL5K = parcelRequire("cgL5K");

var $koVbs = parcelRequire("koVbs");

var $aipk9 = parcelRequire("aipk9");

var $kjUWA = parcelRequire("kjUWA");
const $8e0056041ef7689f$var$CalculatedBoardEndDate = ()=>{
    const intl = (0, $koVbs.default)();
    const formState = (0, $bUa6y.useFormState)({
        values: true,
        pristine: true,
        dirty: true
    });
    const columnDuration = formState?.values?.iterationLength?.value;
    const numberOfColumns = formState?.values?.iterationsCount?.value;
    const start = formState?.values?.start;
    const getEndDate = ()=>{
        if (!columnDuration || !numberOfColumns || !start) return null;
        const startDate = new Date(start);
        const programDurationMS = columnDuration * numberOfColumns * 604800000;
        return (0, $aipk9.formatDateWithIntl)(intl, startDate.getTime() + programDurationMS);
    };
    return columnDuration && numberOfColumns && start && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        as: "p"
    }, intl.formatMessage((0, $kjUWA.default).estimatedEndDate), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "semibold",
        size: "small"
    }, getEndDate()));
};
var $8e0056041ef7689f$export$2e2bcd8739ae039 = $8e0056041ef7689f$var$CalculatedBoardEndDate;

});
parcelRegister("kjUWA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f3dbe5e8ba5cfea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $6f3dbe5e8ba5cfea$var$messages = (0, $7VHMR.defineMessages)({
    estimatedEndDate: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.calculated-end-date.estimated-end-date",
        "defaultMessage": "Estimated board end date:"
    }
});
var $6f3dbe5e8ba5cfea$export$2e2bcd8739ae039 = $6f3dbe5e8ba5cfea$var$messages;

});


parcelRegister("7pWV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8e067dd53de6e3a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bUa6y = parcelRequire("bUa6y");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $koVbs = parcelRequire("koVbs");

var $4jAPy = parcelRequire("4jAPy");

var $5sUih = parcelRequire("5sUih");

var $7GiTF = parcelRequire("7GiTF");

var $jiKCm = parcelRequire("jiKCm");
const $b8e067dd53de6e3a$var$IssueCountText = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b8e067dd53de6e3a$var$issueCountStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, children));
const $b8e067dd53de6e3a$var$shouldRefetchIssueCount = (startDate, issueCountVisible, filterFieldId, filterFieldValue, lastStartDate, lastFilterFieldValue)=>{
    // startDate is always required
    if (!startDate) return false;
    const filterIsValid = !filterFieldId || filterFieldId && filterFieldValue;
    const countEmptyOrValuesChanged = !issueCountVisible || lastStartDate.current !== startDate || !!filterFieldId && !!filterFieldValue && lastFilterFieldValue.current !== filterFieldValue;
    if (// Fetch field values if count is empty (initial state) or values is changed, and the filter field and values are valid
    countEmptyOrValuesChanged && filterIsValid) return true;
    return false;
};
const $b8e067dd53de6e3a$var$IssueCount = ({ initialStartDate: initialStartDate })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { planId: planId, scenarioId: scenarioId } = (0, $5uXOq.useContext)((0, $5sUih.default));
    const formState = (0, $bUa6y.useFormState)();
    const [issueCountVisible, setIssueCountVisible] = (0, $5uXOq.useState)(false);
    const startDate = formState?.values?.start;
    const filterFieldId = formState?.values?.filterFieldId?.value;
    const filterFieldValue = formState?.values?.filterFieldValue?.value;
    const lastStartDate = (0, $5uXOq.useRef)(initialStartDate);
    const lastFilterField = (0, $5uXOq.useRef)(undefined);
    const lastFilterFieldValue = (0, $5uXOq.useRef)(undefined);
    const { issueCount: issueCount, fetchIssueCount: fetchIssueCount, isLoading: isLoadingIssueCount } = (0, $7GiTF.useFetchIssueCount)({
        planId: planId,
        scenarioId: scenarioId,
        // iterationsCount and iterationLength are not used by the backend when counting issues, hence only default value is needed
        iterationsCount: (0, $4jAPy.DEFAULT_ITERATIONS_COUNT),
        iterationLength: (0, $4jAPy.DEFAULT_ITERATION_LENGTH),
        start: new Date(startDate).getTime(),
        filterFieldId: filterFieldId,
        filterFieldValue: filterFieldValue
    });
    (0, $5uXOq.useEffect)(()=>{
        if ($b8e067dd53de6e3a$var$shouldRefetchIssueCount(startDate, issueCountVisible, filterFieldId, filterFieldValue, lastStartDate, lastFilterFieldValue)) {
            fetchIssueCount();
            setIssueCountVisible(true);
            if (lastStartDate.current !== startDate) lastStartDate.current = startDate;
            if (lastFilterField.current !== filterFieldId) lastFilterField.current = filterFieldId;
            if (lastFilterFieldValue.current !== filterFieldValue) lastFilterFieldValue.current = filterFieldValue;
        }
    }, [
        fetchIssueCount,
        filterFieldId,
        lastFilterField,
        filterFieldValue,
        lastFilterFieldValue,
        issueCountVisible,
        lastStartDate,
        startDate
    ]);
    // hide issue count if any values were cleared, otherwise the count is not accurate
    (0, $5uXOq.useEffect)(()=>{
        if (!startDate || // check if it was fetched and then cleared for the below two fields
        !filterFieldId && lastFilterField.current || !filterFieldValue && lastFilterFieldValue.current) setIssueCountVisible(false);
    }, [
        startDate,
        filterFieldId,
        lastFilterField,
        filterFieldValue,
        lastFilterFieldValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8e067dd53de6e3a$var$IssueCountText, null, formatMessage((0, $jiKCm.default).issueCount), ' ', isLoadingIssueCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "strong"
    }, issueCountVisible ? issueCount : '-'));
};
var $b8e067dd53de6e3a$export$2e2bcd8739ae039 = $b8e067dd53de6e3a$var$IssueCount;
const $b8e067dd53de6e3a$var$issueCountStyles = (0, $8CUq3.xcss)({
    marginRight: 'auto'
});

});
parcelRegister("7GiTF", function(module, exports) {

$parcel$export(module.exports, "useFetchIssueCount", () => $c031d978f0ab7ef2$export$4690e93e2d7a84f9);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $4jAPy = parcelRequire("4jAPy");
const $c031d978f0ab7ef2$export$4690e93e2d7a84f9 = ({ planId: planId, scenarioId: scenarioId, start: start, iterationsCount: iterationsCount, iterationLength: iterationLength, filterFieldId: filterFieldId, filterFieldValue: filterFieldValue })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [issueCount, setIssueCount] = (0, $5uXOq.useState)(null);
    const fetchIssueCount = (0, $5uXOq.useCallback)(async ()=>{
        try {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(planId)) throw new Error('planId is empty in the fetch issue count request');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(scenarioId)) throw new Error('scenarioId is empty in the fetch issue count request');
            setIsLoading(true);
            const payload = {
                start: start,
                iterationsCount: iterationsCount,
                iterationLength: iterationLength,
                filterFieldId: filterFieldId,
                filterFieldValue: // We don't clear the field value if the filter field is not set, so we should only send the value when the field id is defined
                filterFieldId ? filterFieldValue : undefined
            };
            const options = {
                body: JSON.stringify(payload)
            };
            const { issueCount: responseIssueCount } = await (0, $eusud.performPostRequest)(`/rest/jpo/2.0/plans/${planId}/increment/board/preview/scenarios/${scenarioId}/countIssues`, options);
            setIssueCount(responseIssueCount);
            setError(null);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'useFetchIssueCount',
                    packageName: (0, $4jAPy.PACKAGE_NAME),
                    teamName: (0, $4jAPy.ERROR_REPORTING_TEAM)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setError(error);
            setIssueCount(null);
        } finally{
            setIsLoading(false);
        }
    }, [
        planId,
        scenarioId,
        start,
        iterationsCount,
        iterationLength,
        filterFieldId,
        filterFieldValue
    ]);
    return {
        isLoading: isLoading,
        error: error,
        issueCount: issueCount,
        fetchIssueCount: fetchIssueCount
    };
};

});

parcelRegister("jiKCm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad5c16479c4854f4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $ad5c16479c4854f4$var$messages = (0, $7VHMR.defineMessages)({
    issueCount: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.issue-count.issue-count",
        "defaultMessage": "Issue count:"
    }
});
var $ad5c16479c4854f4$export$2e2bcd8739ae039 = $ad5c16479c4854f4$var$messages;

});


parcelRegister("84ylG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c485b4be4a973372$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bUa6y = parcelRequire("bUa6y");

var $7K5PP = parcelRequire("7K5PP");

var $gwIPs = parcelRequire("gwIPs");

var $4jAPy = parcelRequire("4jAPy");

var $2Ukhf = parcelRequire("2Ukhf");
function $c485b4be4a973372$var$isObjKey(key) {
    return key in (0, $2Ukhf.iterationLengthCountOptionsMap);
}
const $c485b4be4a973372$var$IterationsCountField = (fieldProps)=>{
    const formState = (0, $bUa6y.useFormState)();
    const selectedDuration = Number(formState?.values?.iterationLength?.value ?? (0, $4jAPy.DEFAULT_ITERATION_LENGTH));
    const prevDuration = (0, $5uXOq.useRef)(selectedDuration);
    const optionsForSelectedDuration = (0, $5uXOq.useMemo)(()=>{
        const optionsSettings = $c485b4be4a973372$var$isObjKey(selectedDuration) && (0, $2Ukhf.iterationLengthCountOptionsMap)[selectedDuration];
        const options = optionsSettings ? (0, $4jAPy.ITERATIONS_COUNT_OPTIONS).filter((o)=>o.value >= optionsSettings.min && o.value <= optionsSettings.max) : [];
        return options;
    }, [
        selectedDuration
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (prevDuration.current !== selectedDuration) {
            const defaultValue = $c485b4be4a973372$var$isObjKey(selectedDuration) ? (0, $2Ukhf.iterationLengthCountOptionsMap)[selectedDuration].default : (0, $4jAPy.DEFAULT_ITERATIONS_COUNT);
            const defaultOption = (0, $4jAPy.ITERATIONS_COUNT_OPTIONS).find((o)=>o.value === defaultValue);
            if (defaultOption) {
                fieldProps.onChange(defaultOption);
                prevDuration.current = selectedDuration;
            }
        }
    }, [
        selectedDuration,
        fieldProps,
        optionsForSelectedDuration
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        ...fieldProps,
        options: optionsForSelectedDuration,
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: (0, $gwIPs.layers).modal
                })
        },
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        menuPortalTarget: document.body
    });
};
var $c485b4be4a973372$export$2e2bcd8739ae039 = $c485b4be4a973372$var$IterationsCountField;

});
parcelRegister("2Ukhf", function(module, exports) {

$parcel$export(module.exports, "iterationLengthCountOptionsMap", () => $2d792066a3160e4e$export$14cde6092cffa40f);
const $2d792066a3160e4e$export$14cde6092cffa40f = {
    1: {
        min: 7,
        max: 13,
        default: 12
    },
    2: {
        min: 5,
        max: 8,
        default: 6
    },
    3: {
        min: 4,
        max: 5,
        default: 4
    },
    4: {
        min: 3,
        max: 4,
        default: 3
    }
};

});


parcelRegister("7gW1a", function(module, exports) {

$parcel$export(module.exports, "getWeekStartDay", () => $74e5775b893e9e56$export$99291c0265ff1d37);
$parcel$export(module.exports, "getNextQuarterStartDate", () => $74e5775b893e9e56$export$31c7b6297e06a9e);

var $1p96B = parcelRequire("1p96B");
const $74e5775b893e9e56$export$99291c0265ff1d37 = (locale)=>(0, $1p96B.getLocale)(locale)?.options?.weekStartsOn || 0;
const $74e5775b893e9e56$export$31c7b6297e06a9e = (date)=>{
    const today = date ?? new Date();
    const QUARTER_STARTS = [
        1,
        4,
        7,
        10
    ];
    let month;
    let isNextYear = false;
    // if today is the start of a quarter, return today, otherwise return the start of the next quarter
    if (today.getDate() === 1 && QUARTER_STARTS.includes(today.getMonth() + 1)) month = today.getMonth() + 1;
    else {
        const nextStart = QUARTER_STARTS.find((q)=>q > today.getMonth());
        month = nextStart ?? QUARTER_STARTS[0];
        isNextYear = month === QUARTER_STARTS[0];
    }
    const year = today.getFullYear() + (isNextYear ? 1 : 0);
    return `${year}-${`0${month}`.slice(-2)}-01T12:00:00`;
};

});

parcelRegister("iHezY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3fa946ecd4fb771$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $e3fa946ecd4fb771$var$messages = (0, $7VHMR.defineMessages)({
    addIncrementTitle: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.add-increment-title",
        "defaultMessage": "Create a program board"
    },
    addIncrementDescription: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.add-increment-description",
        "defaultMessage": "Schedule work for the next quarter into six iterations, each spanning two weeks. "
    },
    addIncrementDescriptionNew: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.add-increment-description-new",
        "defaultMessage": "Schedule work across multiple teams and iterations for the next quarter. "
    },
    doclink: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.doclink",
        "defaultMessage": "See how to configure your program board"
    },
    name: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.name",
        "defaultMessage": "Name of your board (required)"
    },
    nameShort: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.name-short",
        "defaultMessage": "Board name (required)"
    },
    startDate: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.start-date",
        "defaultMessage": "Start date (required)"
    },
    startDateShort: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.start-date-short",
        "defaultMessage": "Start date"
    },
    namePlaceholder: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.name-placeholder",
        "defaultMessage": "e.g.Q1FY24"
    },
    submit: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.submit",
        "defaultMessage": "Create"
    },
    cancel: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.cancel",
        "defaultMessage": "Cancel"
    },
    errorLabel: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.error-label",
        "defaultMessage": "We couldn\u2019t create your board. Refresh the page and try again. "
    },
    closeModal: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.close-modal",
        "defaultMessage": "Close modal"
    },
    scopeFilterHeading: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.scope-filter-heading",
        "defaultMessage": "What issues do you want to include?"
    },
    scopeFilterHeadingIssueTermRefresh: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.scope-filter-heading-issue-term-refresh",
        "defaultMessage": "What issues do you want to include?"
    },
    scopeFilterDescription: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.scope-filter-description",
        "defaultMessage": "Select a field to filter which issues are added to your program board. If you choose none, all issues with statuses in the <bold>To do </bold> or <bold>In progress</bold> categories will show on your board. "
    },
    scopeFilterDescriptionIssueTermRefresh: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.scope-filter-description-issue-term-refresh",
        "defaultMessage": "Select a field to filter which issues are added to your program board. If you choose none, all issues with statuses in the <bold>To do </bold> or <bold>In progress</bold> categories will show on your board. "
    },
    nameEmptyError: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.name-empty-error",
        "defaultMessage": "Name is required"
    },
    startDateEmptyError: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.start-date-empty-error",
        "defaultMessage": "Start date is required"
    },
    fieldValueEmptyError: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.field-value-empty-error",
        "defaultMessage": "Field value is required when you select Field"
    },
    iterationLength: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.iteration-length",
        "defaultMessage": "Column duration"
    },
    iterationsCount: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.iterations-count",
        "defaultMessage": "Number of columns"
    }
});
var $e3fa946ecd4fb771$export$2e2bcd8739ae039 = $e3fa946ecd4fb771$var$messages;

});


parcelRegister("fzC6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $98227ef8895a8a29$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $98227ef8895a8a29$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    activeGroupLabel: {
        "id": "portfolio-3-plan-increment-common.ui.board-switcher.active-group-label",
        "defaultMessage": "Active"
    },
    pastGroupLabel: {
        "id": "portfolio-3-plan-increment-common.ui.board-switcher.past-group-label",
        "defaultMessage": "Past"
    },
    createProgramBoard: {
        "id": "portfolio-3-plan-increment-common.ui.board-switcher.create-program-board",
        "defaultMessage": "Create a new program board"
    },
    manageProgramBoards: {
        "id": "portfolio-3-plan-increment-common.ui.board-switcher.manage-program-boards",
        "defaultMessage": "Manage program boards"
    },
    manageProgramBoardsTitle: {
        "id": "portfolio-3-plan-increment-common.ui.board-switcher.manage-program-boards-title",
        "defaultMessage": "Navigate to Program board settings page"
    }
});

});


parcelRegister("4xTtj", function(module, exports) {

$parcel$export(module.exports, "default", () => $142cf36e132bee65$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $142cf36e132bee65$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-found.title",
        "defaultMessage": "This board\u2019s custom field has been deleted."
    },
    description: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-found.description",
        "defaultMessage": "The custom field used to create this board has been deleted from your site by an administrator, and can\u2019t be restored."
    },
    createNewBoard: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-found.create-new-board",
        "defaultMessage": "Create new board"
    },
    imgAlt: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-found.img-alt",
        "defaultMessage": "Drawing of a magnifying glass with a cross mark"
    }
});

});


parcelRegister("1waMP", function(module, exports) {

$parcel$export(module.exports, "default", () => $00e38a48db5d2286$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $hTEpF = parcelRequire("hTEpF");

var $pa9q9 = parcelRequire("pa9q9");

var $kJXh6 = parcelRequire("kJXh6");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $gZK1Z = parcelRequire("gZK1Z");

var $9TVV0 = parcelRequire("9TVV0");

var $6TZ9z = parcelRequire("6TZ9z");

var $2C9Uz = parcelRequire("2C9Uz");

var $dD7Gs = parcelRequire("dD7Gs");
const $00e38a48db5d2286$var$ProgramBoardCustomFieldNotInPlan = ({ planId: planId, customFieldId: customFieldId, customFieldName: customFieldName, isReadOnly: isReadOnly })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const customFieldIdRegex = /\d+/g;
    const customFieldIdMatch = customFieldId.match(customFieldIdRegex);
    const { isLoading: isRestoringField, error: error, isSuccessful: isSuccessful, restoreCustomField: restoreCustomField } = (0, $6TZ9z.useRestoreCustomField)({
        planId: planId,
        customFieldId: customFieldIdMatch && customFieldIdMatch.length > 0 ? customFieldIdMatch[0] : undefined
    });
    const { incrementId: incrementId } = (0, $9TVV0.usePlanPathParams)();
    const flagId = 'ip-board-custom-field-not-in-plan-error-flag';
    (0, $5uXOq.useEffect)(()=>{
        if (isSuccessful) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    }, [
        isSuccessful
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (error) showFlag({
            id: flagId,
            description: formatMessage((0, $dD7Gs.default).errorFlagDescription),
            title: formatMessage((0, $dD7Gs.default).errorFlagTitle),
            isAutoDismiss: true,
            appearance: 'error',
            type: 'error'
        });
    }, [
        error,
        showFlag,
        formatMessage
    ]);
    const renderPrimaryAction = ()=>{
        if (isReadOnly) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            appearance: "primary",
            isDisabled: isRestoringField,
            onClick: ()=>{
                restoreCustomField();
            }
        }, formatMessage((0, $dD7Gs.default).restoreField));
    };
    const renderSecondaryAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2C9Uz.default), {
            boardId: Number(incrementId),
            triggerLabel: formatMessage((0, $gZK1Z.default).backToBoards),
            isReadOnly: isReadOnly
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $kJXh6.default)),
        header: formatMessage((0, $dD7Gs.default).title, {
            fieldName: customFieldName
        }),
        description: formatMessage((0, $dD7Gs.default).description),
        maxImageWidth: 300,
        primaryAction: renderPrimaryAction(),
        secondaryAction: renderSecondaryAction()
    });
};
var $00e38a48db5d2286$export$2e2bcd8739ae039 = $00e38a48db5d2286$var$ProgramBoardCustomFieldNotInPlan;

});
parcelRegister("kJXh6", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a2101bcb4b9e7b0$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = xhrhgx9ztn67hcmphgkp38fw
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/xhrhgx9ztn67hcmphgkp38fw

var $dCLgq = parcelRequire("dCLgq");

var $9igjG = parcelRequire("9igjG");
const $1a2101bcb4b9e7b0$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($9igjG)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($9igjG))
});
var $1a2101bcb4b9e7b0$export$2e2bcd8739ae039 = $1a2101bcb4b9e7b0$var$Illustration;
// for advanced use only
const $1a2101bcb4b9e7b0$export$a179c88182cb9d56 = [
    0,
    0,
    565,
    267
];

});
parcelRegister("9igjG", function(module, exports) {
module.exports = new URL("integration.4d030b1d.svg", import.meta.url).toString();

});


parcelRegister("6TZ9z", function(module, exports) {

$parcel$export(module.exports, "useRestoreCustomField", () => $ed1ff562953eadc4$export$94fceaa5994f25d5);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $4jAPy = parcelRequire("4jAPy");
const $ed1ff562953eadc4$export$94fceaa5994f25d5 = ({ planId: planId, customFieldId: customFieldId })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    const [isSuccessful, setIsSuccessful] = (0, $5uXOq.useState)(false);
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const handleError = (error)=>{
        setIsSuccessful(false);
        setError(error);
        (0, $jcw0u.default)({
            meta: {
                id: 'restoreCustomField',
                packageName: (0, $4jAPy.PACKAGE_NAME),
                teamName: (0, $4jAPy.ERROR_REPORTING_TEAM)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const restoreCustomField = async ()=>{
        if (isLoading) return;
        if (!planId) {
            handleError(new Error('planId is empty in the restore custom field request'));
            return;
        }
        if (!customFieldId) {
            handleError(new Error('customFieldId is empty in the restore custom field request'));
            return;
        }
        setIsLoading(true);
        try {
            await (0, $eusud.performPostRequest)('/rest/jpo/1.0/customfield/add', {
                body: JSON.stringify({
                    planId: planId,
                    planCustomFields: [
                        {
                            customFieldId: customFieldId,
                            filteringAllowed: true
                        }
                    ]
                })
            });
            setIsSuccessful(true);
        // eslint-disable-next-line @typescript-eslint/no-shadow
        } catch (error) {
            handleError(new Error('Failed to restore custom field in Program board', {
                cause: error
            }));
        } finally{
            setIsLoading(false);
        }
    };
    return {
        restoreCustomField: restoreCustomField,
        isLoading: isLoading,
        isSuccessful: isSuccessful,
        error: error
    };
};

});

parcelRegister("dD7Gs", function(module, exports) {

$parcel$export(module.exports, "default", () => $8988c65e6011c124$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8988c65e6011c124$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-in-plan.title",
        "defaultMessage": "The custom field \"{fieldName}\" was removed from your plan."
    },
    description: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-in-plan.description",
        "defaultMessage": "Without this field, your program board can't load."
    },
    restoreField: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-in-plan.restore-field",
        "defaultMessage": "Restore this field"
    },
    imgAlt: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-in-plan.img-alt",
        "defaultMessage": "Drawing of two people connecting plugs"
    },
    errorFlagTitle: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-in-plan.error-flag-title",
        "defaultMessage": "Something went wrong"
    },
    errorFlagDescription: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-in-plan.error-flag-description",
        "defaultMessage": "There was an error when restoring custom field in program board. Please try refreshing the page."
    }
});

});


parcelRegister("7Vlm5", function(module, exports) {

$parcel$export(module.exports, "default", () => $641b25fcd25dadec$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $c7i3D = parcelRequire("c7i3D");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $gZK1Z = parcelRequire("gZK1Z");

var $9TVV0 = parcelRequire("9TVV0");

var $2C9Uz = parcelRequire("2C9Uz");

var $5caHe = parcelRequire("5caHe");
const $641b25fcd25dadec$var$ProgramBoardCustomFieldOptionNotFound = ({ customFieldName: customFieldName, isReadOnly: isReadOnly })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { incrementId: incrementId } = (0, $9TVV0.usePlanPathParams)();
    const renderPrimaryAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2C9Uz.default), {
            boardId: Number(incrementId),
            triggerLabel: formatMessage((0, $gZK1Z.default).backToBoards),
            isReadOnly: isReadOnly
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c7i3D.default)),
        header: formatMessage((0, $5caHe.default).title, {
            fieldName: customFieldName
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $5caHe.default).description, {
            fieldName: customFieldName
        })),
        primaryAction: renderPrimaryAction()
    });
};
var $641b25fcd25dadec$export$2e2bcd8739ae039 = $641b25fcd25dadec$var$ProgramBoardCustomFieldOptionNotFound;

});
parcelRegister("5caHe", function(module, exports) {

$parcel$export(module.exports, "default", () => $f03151f1cf451863$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f03151f1cf451863$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.option-not-found.title",
        "defaultMessage": "The custom field \"{fieldName}\" has changed."
    },
    description: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.option-not-found.description",
        "defaultMessage": "The custom field \"{fieldName}\" was used to create your board, but it\u2019s since been edited. In order to use your board, your site administrator needs to update the \"{fieldName}\" field configuration."
    },
    imgAlt: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.option-not-found.img-alt",
        "defaultMessage": "Drawing of a magnifying glass with a cross mark"
    }
});

});


parcelRegister("9j19P", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd9d70855f1855a5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $c7i3D = parcelRequire("c7i3D");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $gZK1Z = parcelRequire("gZK1Z");

var $9TVV0 = parcelRequire("9TVV0");

var $2C9Uz = parcelRequire("2C9Uz");

var $ioiHo = parcelRequire("ioiHo");
const $bd9d70855f1855a5$var$ProgramBoardCustomFieldTrashed = ({ customFieldName: customFieldName, isReadOnly: isReadOnly })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { incrementId: incrementId } = (0, $9TVV0.usePlanPathParams)();
    const renderPrimaryAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2C9Uz.default), {
            boardId: Number(incrementId),
            triggerLabel: formatMessage((0, $gZK1Z.default).backToBoards),
            isReadOnly: isReadOnly
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c7i3D.default)),
        header: formatMessage((0, $ioiHo.default).title, {
            fieldName: customFieldName
        }),
        description: formatMessage((0, $ioiHo.default).description, {
            Paragraph: (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, content),
            fieldName: customFieldName
        }),
        primaryAction: renderPrimaryAction()
    });
};
var $bd9d70855f1855a5$export$2e2bcd8739ae039 = $bd9d70855f1855a5$var$ProgramBoardCustomFieldTrashed;

});
parcelRegister("ioiHo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9708ca471f23227a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9708ca471f23227a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.trashed.title",
        "defaultMessage": "The custom field \"{fieldName}\" has been deleted from your site."
    },
    description: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.trashed.description",
        "defaultMessage": "<Paragraph>This board was configured using the \"{fieldName}\" custom field, which has been deleted from your site by an administrator.</Paragraph><Paragraph>Custom fields can be restored for up to 60 days after they were moved to the trash. Contact your site administrator to see if this is possible in order to restore your board. If the custom field was deleted more than 60 days ago, you\u2019ll need to make a new board.</Paragraph>"
    },
    imgAlt: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.trashed.img-alt",
        "defaultMessage": "Drawing of a magnifying glass with a cross mark"
    }
});

});



parcelRegister("SDugp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f7f1d6838d59fea$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1GGwS = parcelRequire("1GGwS");

var $hTEpF = parcelRequire("hTEpF");

var $kgoHi = parcelRequire("kgoHi");

var $fqCXD = parcelRequire("fqCXD");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $c3WQb = parcelRequire("c3WQb");

var $dIdda = parcelRequire("dIdda");

var $bdYfL = parcelRequire("bdYfL");

var $9TVV0 = parcelRequire("9TVV0");

var $cGhMs = parcelRequire("cGhMs");
const $4f7f1d6838d59fea$var$ProgramBoard404 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const planId = (0, $bdYfL.getPlanId)();
    // If the user lands on the 404 page we should invalidate the cache of the last visited
    // program board and refetch a valid one from the server so they are routed to the appropriate
    // program board when next accessing /program route
    const { refresh: refetchLastViewedProgramBoardId } = (0, $dIdda.useResource)((0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource));
    const incrementsLink = (0, $9TVV0.useIncrementsLink)();
    (0, $5uXOq.useEffect)(()=>{
        refetchLastViewedProgramBoardId();
    }, [
        refetchLastViewedProgramBoardId
    ]);
    const renderPrimaryAction = ()=>{
        if (planId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
            href: incrementsLink,
            appearance: "primary"
        }, formatMessage((0, $cGhMs.default).viewCurrentBoard));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
            href: (0, $bdYfL.urls).managePortfolio,
            appearance: "primary"
        }, formatMessage((0, $cGhMs.default).viewAllPlans));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $fqCXD.default)),
        header: formatMessage((0, $cGhMs.default).title404),
        description: formatMessage((0, $cGhMs.default).description404),
        primaryAction: renderPrimaryAction()
    }));
};
var $4f7f1d6838d59fea$export$2e2bcd8739ae039 = $4f7f1d6838d59fea$var$ProgramBoard404;

});
parcelRegister("fqCXD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e09649ccf4cf5eef$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = xj97zncrmb3cj96ggxfn
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/xj97zncrmb3cj96ggxfn

var $dCLgq = parcelRequire("dCLgq");

var $9y6MM = parcelRequire("9y6MM");

var $f07PL = parcelRequire("f07PL");
const $e09649ccf4cf5eef$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($f07PL)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($9y6MM))
});
var $e09649ccf4cf5eef$export$2e2bcd8739ae039 = $e09649ccf4cf5eef$var$Illustration;
// for advanced use only
const $e09649ccf4cf5eef$export$a179c88182cb9d56 = [
    0,
    0,
    245,
    180
];

});
parcelRegister("9y6MM", function(module, exports) {
module.exports = new URL("map-darkmode.65c31cec.svg", import.meta.url).toString();

});

parcelRegister("f07PL", function(module, exports) {
module.exports = new URL("map.d526d3ce.svg", import.meta.url).toString();

});


parcelRegister("cGhMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7622546e3a8a37dc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7622546e3a8a37dc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title404: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.empty-404.title-404",
        "defaultMessage": "Where\u2019d it go?"
    },
    description404: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.empty-404.description-404",
        "defaultMessage": "We couldn\u2019t find that program board. It might have been deleted by its owner or the URL might be wrong."
    },
    viewAllPlans: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.empty-404.view-all-plans",
        "defaultMessage": "View all plans"
    },
    viewCurrentBoard: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.empty-404.view-current-board",
        "defaultMessage": "View current board"
    }
});

});


parcelRegister("edBiZ", function(module, exports) {

$parcel$export(module.exports, "ProgramBoardSkeleton", () => $4f16b1f997d94ac6$export$c41c6e2b3c2381b3);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $gnABE = parcelRequire("gnABE");

var $kn6bU = parcelRequire("kn6bU");
const $4f16b1f997d94ac6$var$customCssStyles = null;
const $4f16b1f997d94ac6$export$c41c6e2b3c2381b3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gnABE.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kn6bU))),
        className: (0, $bwpsq.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("kn6bU", function(module, exports) {
module.exports = new URL("program-board-app-skeleton.tpl.74f398b1.svg", import.meta.url).toString();

});



parcelRegister("bxz0l", function(module, exports) {

$parcel$export(module.exports, "ForceRecalculateSubscribers", () => $d2a57e612cbb128d$export$7e571696ac12cb6f);

var $5uXOq = parcelRequire("5uXOq");

var $687vG = parcelRequire("687vG");

var $67sX6 = parcelRequire("67sX6");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $5mTgl = parcelRequire("5mTgl");
const $d2a57e612cbb128d$export$7e571696ac12cb6f = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const filteredCards = (0, $67sX6.useBoardSelector)((0, $5mTgl.workFilteredIssuesSelector));
    const swimlaneMode = (0, $67sX6.useBoardSelector)((0, $45cXl.getSwimlaneMode));
    const collapsedSwimlaneIds = (0, $67sX6.useBoardSelector)((0, $4jZ56.getCollapsedSwimlanes));
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $687vG.runRecalculateSubscribers)();
    }, [
        filteredCards,
        swimlaneMode,
        collapsedSwimlaneIds
    ]);
    return null;
});

});
parcelRegister("687vG", function(module, exports) {

$parcel$export(module.exports, "runRecalculateSubscribers", () => $c63364c275b5d8f7$export$c385874db128c328);
$parcel$export(module.exports, "useElementOffset", () => $c63364c275b5d8f7$export$35f58fcda6094144);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $lFKmC = parcelRequire("lFKmC");

var $iASWI = parcelRequire("iASWI");

var $9Ik53 = parcelRequire("9Ik53");
const $c63364c275b5d8f7$var$MINIMUM_OFFSET_DIFF = 0.05;
const $c63364c275b5d8f7$export$658605f405ffebd5 = new Set();
const $c63364c275b5d8f7$export$c385874db128c328 = ()=>{
    const recalculateSubscribersArr = Array.from($c63364c275b5d8f7$export$658605f405ffebd5);
    const changes = recalculateSubscribersArr.map((subscriber)=>({
            newOffsetTop: subscriber.measureOffsetTop(),
            subscriber: subscriber
        })).filter(({ subscriber: subscriber, newOffsetTop: newOffsetTop })=>Math.abs((subscriber.offsetTopRef.current ?? 0) - newOffsetTop) > $c63364c275b5d8f7$var$MINIMUM_OFFSET_DIFF);
    if (!changes.length) return 0;
    (0, $7nsd3.unstable_batchedUpdates)(()=>{
        changes.forEach(({ subscriber: subscriber, newOffsetTop: newOffsetTop })=>{
            subscriber.onChange(newOffsetTop);
        });
    });
    return changes.length;
};
// Debounced version of the call used because during DND, the ResizeObserver can
// crash due to being triggered too much
const $c63364c275b5d8f7$var$debouncedRunRecalculateSubscribers = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))($c63364c275b5d8f7$export$c385874db128c328, 50);
let $c63364c275b5d8f7$var$resizeObserver = null;
if (typeof ResizeObserver !== 'undefined') $c63364c275b5d8f7$var$resizeObserver = new ResizeObserver($c63364c275b5d8f7$var$debouncedRunRecalculateSubscribers);
let $c63364c275b5d8f7$var$intersectionObserver = null;
if (typeof IntersectionObserver !== 'undefined') $c63364c275b5d8f7$var$intersectionObserver = new IntersectionObserver($c63364c275b5d8f7$export$c385874db128c328, {
    // Will fire every 1/5000 size visibility change.
    // A list with more than 5000 rows will fail to detect single row
    // changes.
    // A list with 5000 rows will only detect 1 row shifts at a time.
    threshold: (0, (/*@__PURE__*/$parcel$interopDefault($iASWI)))(5000).map((i, _, arr)=>i / arr.length)
});
function $c63364c275b5d8f7$export$99c4e73123d23bda({ initialOffset: initialOffset, ref: ref }) {
    const [offsetTop, setOffsetTop] = (0, $5uXOq.useState)(initialOffset);
    const previousOffsetTopRef = (0, $5uXOq.useRef)(initialOffset);
    const { scrollElement: scrollElement } = (0, $9Ik53.useScrollState)();
    (0, $5uXOq.useEffect)(()=>{
        const el = ref.current;
        if (!el) throw new Error('Invariant failed, observed element is null on mount');
        const onChange = (size)=>{
            setOffsetTop(size);
            previousOffsetTopRef.current = size;
        };
        const measureOffsetTop = ()=>{
            if (!el || !scrollElement) return previousOffsetTopRef.current;
            // scrollElement defaults to Window.
            // This default value is normally only seen in Storybook.
            if (scrollElement instanceof Window || // FIXME JIV-14148 - unclear behavior in Storybook mount strict - Window is not Window
            !scrollElement.getBoundingClientRect) return 0;
            return el.getBoundingClientRect().top - scrollElement.getBoundingClientRect().top + scrollElement.scrollTop;
        };
        onChange(measureOffsetTop());
        const recalculateGroup = {
            measureOffsetTop: measureOffsetTop,
            onChange: onChange,
            offsetTop: previousOffsetTopRef.current,
            offsetTopRef: previousOffsetTopRef
        };
        $c63364c275b5d8f7$export$658605f405ffebd5.add(recalculateGroup);
        $c63364c275b5d8f7$var$resizeObserver?.observe(el);
        $c63364c275b5d8f7$var$intersectionObserver?.observe(el);
        const onResize = ()=>{
            $c63364c275b5d8f7$var$debouncedRunRecalculateSubscribers();
        };
        if ($c63364c275b5d8f7$export$658605f405ffebd5.size === 1) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('resize', onResize);
        return ()=>{
            $c63364c275b5d8f7$export$658605f405ffebd5.delete(recalculateGroup);
            $c63364c275b5d8f7$var$resizeObserver?.unobserve(el);
            $c63364c275b5d8f7$var$intersectionObserver?.unobserve(el);
            if ($c63364c275b5d8f7$export$658605f405ffebd5.size === 0) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('resize', onResize);
            // Fire once when we clean this up since when we unmount an element we also
            // want to trigger the callback (e.g. removing a column or cardlist)
            $c63364c275b5d8f7$var$debouncedRunRecalculateSubscribers();
        };
    }, [
        ref,
        scrollElement
    ]);
    return offsetTop;
}
function $c63364c275b5d8f7$export$35f58fcda6094144({ initialOffset: initialOffset }) {
    const ref = (0, $5uXOq.useRef)(null);
    const offsetTop = $c63364c275b5d8f7$export$99c4e73123d23bda({
        initialOffset: initialOffset,
        ref: ref
    });
    return {
        ref: ref,
        offsetTop: offsetTop
    };
}

});
parcelRegister("iASWI", function(module, exports) {

var $irTmi = parcelRequire("irTmi");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $d89635f071f7433a$var$range = $irTmi();
module.exports = $d89635f071f7433a$var$range;

});
parcelRegister("irTmi", function(module, exports) {

var $7DMj9 = parcelRequire("7DMj9");

var $4rDUz = parcelRequire("4rDUz");

var $kJ0Lf = parcelRequire("kJ0Lf");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $d6e5b0af0cc26ead$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $4rDUz(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $kJ0Lf(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $kJ0Lf(end);
        step = step === undefined ? start < end ? 1 : -1 : $kJ0Lf(step);
        return $7DMj9(start, end, step, fromRight);
    };
}
module.exports = $d6e5b0af0cc26ead$var$createRange;

});
parcelRegister("7DMj9", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5901a5dd7694a169$var$nativeCeil = Math.ceil, $5901a5dd7694a169$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $5901a5dd7694a169$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $5901a5dd7694a169$var$nativeMax($5901a5dd7694a169$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = $5901a5dd7694a169$var$baseRange;

});





parcelRegister("8R2g1", function(module, exports) {

$parcel$export(module.exports, "BoardSlaTracker", () => $26d2bc915d9cd7ab$export$149af6dcca3f86a2);
$parcel$export(module.exports, "CmpBoardSlaTracker", () => $26d2bc915d9cd7ab$export$66ca48f8a9bbca65);

var $5uXOq = parcelRequire("5uXOq");

var $f7Y15 = parcelRequire("f7Y15");

var $01j5n = parcelRequire("01j5n");

var $dIdda = parcelRequire("dIdda");

const $26d2bc915d9cd7ab$export$149af6dcca3f86a2 = (props)=>{
    if (!props.boardData) return null;
    const { boardData: { error: boardDataError, loading: boardDataLoading }, location: location } = props;
    // do nothing until all endpoints are loaded
    if (boardDataLoading === true) return null;
    if (boardDataError) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return (0, $01j5n.default)(boardDataError, location ?? (0, $dcbb2bce513725b3$export$fa0622448a6f265));
    // return null when no errors
    return null;
};
const $26d2bc915d9cd7ab$export$66ca48f8a9bbca65 = ()=>{
    const boardData = (0, $dIdda.useResource)((0, $f7Y15.uifBoardResource));
    const hasFired = (0, $5uXOq.useRef)(false);
    if (hasFired.current || !boardData || !boardData.error || boardData.data || boardData.loading) return null;
    hasFired.current = true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($26d2bc915d9cd7ab$export$149af6dcca3f86a2, {
        boardData: boardData,
        location: (0, $dcbb2bce513725b3$export$3ccc579abb61693b)
    });
};

});


parcelRegister("ignYi", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("g3Ehu").then(()=>parcelRequire('8DdSU'));

});


parcelRegister("b5JVP", function(module, exports) {

$parcel$export(module.exports, "AllFieldsSync", () => $2f7e3abd37eb7923$export$1d61766e46edfc2e);

var $5uXOq = parcelRequire("5uXOq");


var $67sX6 = parcelRequire("67sX6");

var $1vXOx = parcelRequire("1vXOx");

var $vAfHD = parcelRequire("vAfHD");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");

var $gFlSp = parcelRequire("gFlSp");
const $2f7e3abd37eb7923$var$CMP_SYNC_SETTINGS = {
    syncAssignee: true,
    syncEstimate: false,
    syncParent: false,
    syncSummary: false
};
const $2f7e3abd37eb7923$export$1d61766e46edfc2e = ()=>{
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const canEditCards = (0, $67sX6.useBoardSelector)((0, $1vXOx.getPermissionsSelector))[0, $e525e6c25695c9df$export$5cd553a40d575c6c] === true;
    const allIssueIds = (0, $67sX6.useBoardSelector)((state)=>(0, $vAfHD.boardOrderedIssueIdsSelector)(state));
    const activeCardId = (0, $67sX6.useBoardSelector)((0, $5mTgl.getActiveIssueWithIcc));
    const richCards = (0, $5uXOq.useRef)(new Set());
    if (!canEditCards) return null;
    if (activeCardId != null) richCards.current?.add(activeCardId);
    // to exclude deleted rich cards
    const ids = allIssueIds.filter((id)=>richCards.current.has(id));
    /**
	 * For TMP all fields will be synced by default
	 * Note - CMP will abort above when jsw.uif.board.cmp-inline-editable-assignee is disabled
	 * */ const syncSettings = isCMPBoard ? $2f7e3abd37eb7923$var$CMP_SYNC_SETTINGS : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, ids.map((id)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFlSp.FieldSync), {
            key: id,
            issueId: id,
            ...syncSettings
        })));
};

});
parcelRegister("gFlSp", function(module, exports) {

$parcel$export(module.exports, "FieldSync", () => $4f1f5db90d381e85$export$9ca22efe8785da27);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $co1wz = parcelRequire("co1wz");

var $67sX6 = parcelRequire("67sX6");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $ajjUL = parcelRequire("ajjUL");

var $2CN17 = parcelRequire("2CN17");

var $d7KqV = parcelRequire("d7KqV");

var $7MspI = parcelRequire("7MspI");
const $4f1f5db90d381e85$export$9ca22efe8785da27 = ({ issueId: issueId, syncAssignee: syncAssignee = true, syncEstimate: syncEstimate = true, syncParent: syncParent = true, syncSummary: syncSummary = true })=>{
    const issue = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIssueById)(state, issueId));
    const isIPBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
    const estimationStatistic = (0, $67sX6.useBoardSelector)((0, $5mTgl.getEstimationStatistic));
    const incrementPlanningEstimateFieldId = (0, $67sX6.useBoardSelector)((0, $67Z81.getIncrementPlanningEstimateFieldId));
    const estimateFieldId = isIPBoard ? incrementPlanningEstimateFieldId : estimationStatistic;
    const projects = (0, $67sX6.useBoardSelector)((0, $67Z81.getIssueProjects));
    const projectKey = issue && projects[issue.projectId]?.key;
    if (!issue) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (!(0, $co1wz.ff)('relay-migration-issue-fields-summary_eog1v') || isIPBoard) && syncSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7MspI.FieldSyncSummary), {
        issue: issue,
        projectKey: projectKey
    }), syncParent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7KqV.FieldSyncParent), {
        issue: issue,
        projectKey: projectKey
    }), syncAssignee && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ajjUL.FieldSyncAssignee), {
        issue: issue
    }), syncEstimate && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(estimateFieldId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CN17.FieldSyncEstimate), {
        issue: issue,
        estimateFieldId: estimateFieldId,
        projectKey: projectKey
    }));
};

});
parcelRegister("ajjUL", function(module, exports) {

$parcel$export(module.exports, "FieldSyncAssignee", () => $db25ad5a6a5695e7$export$3b271f574456338d);

var $5uXOq = parcelRequire("5uXOq");

var $fhSLy = parcelRequire("fhSLy");

var $3fAi8 = parcelRequire("3fAi8");

var $5fc53 = parcelRequire("5fc53");

var $2P7AF = parcelRequire("2P7AF");


var $67sX6 = parcelRequire("67sX6");

var $2f454 = parcelRequire("2f454");

var $36pz7 = parcelRequire("36pz7");
const $db25ad5a6a5695e7$export$3b271f574456338d = ({ issue: issue })=>{
    const { key: key, assigneeAccountId: assigneeAccountId } = issue;
    const assigneeIdFromBoard = (0, $5uXOq.useMemo)(()=>assigneeAccountId ? String(assigneeAccountId) : '', [
        assigneeAccountId
    ]);
    const assigneeFromBoard = (0, $67sX6.useBoardSelector)((state)=>(0, $36pz7.getPerson)(state, assigneeIdFromBoard));
    const setAssigneeInBoard = (0, $67sX6.useBoardActionCreator)((assignee)=>(0, $2f454.cardDataSet)({
            ...issue,
            assigneeAccountId: assignee?.id ?? null
        }, assignee, (0, $f32ae13c2b9742f4$export$c1d71ceefe04e35a)));
    const [assigneeFromIssueField, { setFieldValue: setAssigneeInIssueField }] = (0, $3fAi8.useFieldValue)({
        issueKey: key,
        fieldKey: (0, $5fc53.ASSIGNEE_TYPE)
    });
    const assigneeIdFromIssueField = (0, $5uXOq.useMemo)(()=>assigneeFromIssueField?.accountId || null, [
        assigneeFromIssueField?.accountId
    ]);
    const assigneeFromBoardChanged = (0, $2P7AF.useDiffCheck)([
        assigneeIdFromBoard
    ]);
    const assigneeFromIssueFieldChanged = (0, $2P7AF.useDiffCheck)([
        assigneeIdFromIssueField
    ]);
    const storesNeedToSync = assigneeIdFromBoard !== assigneeIdFromIssueField;
    // Board -> Issue Field Sync
    (0, $5uXOq.useEffect)(()=>{
        if (assigneeFromBoardChanged && storesNeedToSync) setAssigneeInIssueField(key, (0, $5fc53.ASSIGNEE_TYPE), assigneeFromBoard ? (0, $fhSLy.getUserShape)(assigneeFromBoard.id, assigneeFromBoard.displayName, assigneeFromBoard.avatarUrl || '') : null);
    }, [
        key,
        assigneeFromBoardChanged,
        storesNeedToSync,
        setAssigneeInIssueField,
        assigneeFromBoard
    ]);
    // Issue Field -> Board Sync
    (0, $5uXOq.useEffect)(()=>{
        if (!assigneeFromBoardChanged && assigneeFromIssueFieldChanged && storesNeedToSync) {
            const issueFieldPerson = assigneeFromIssueField ? {
                ...assigneeFromIssueField,
                avatarUrl: assigneeFromIssueField?.avatarUrls?.['48x48'],
                id: assigneeFromIssueField.accountId
            } : null;
            setAssigneeInBoard(issueFieldPerson);
        }
    }, [
        assigneeFromBoardChanged,
        assigneeFromIssueField,
        assigneeFromIssueFieldChanged,
        setAssigneeInBoard,
        storesNeedToSync
    ]);
    return null;
};

});
parcelRegister("2P7AF", function(module, exports) {

$parcel$export(module.exports, "useDiffCheck", () => $a41630f4c93ddc10$export$5ade32966816005f);

var $5uXOq = parcelRequire("5uXOq");
const $a41630f4c93ddc10$export$5ade32966816005f = (nextValues = [])=>{
    const ref = (0, $5uXOq.useRef)([]);
    const prevValues = ref.current;
    (0, $5uXOq.useEffect)(()=>{
        ref.current = nextValues;
    }, [
        nextValues
    ]);
    return prevValues.length ? prevValues.some((value, i)=>nextValues[i] !== value) : false;
};

});


parcelRegister("2CN17", function(module, exports) {

$parcel$export(module.exports, "FieldSyncEstimate", () => $fe40f4fda2aacd3a$export$4539ee47feb9709a);

var $5uXOq = parcelRequire("5uXOq");


var $gNIhI = parcelRequire("gNIhI");

var $eNXt6 = parcelRequire("eNXt6");
const $fe40f4fda2aacd3a$export$4539ee47feb9709a = ({ issue: issue, estimateFieldId: estimateFieldId, projectKey: projectKey })=>{
    if (estimateFieldId === (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gNIhI.FieldSyncOriginalEstimate), {
        issue: issue,
        originalEstimateFieldId: estimateFieldId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eNXt6.FieldSyncStoryPoint), {
        issue: issue,
        storypointsFieldId: estimateFieldId,
        projectKey: projectKey
    });
};

});
parcelRegister("gNIhI", function(module, exports) {

$parcel$export(module.exports, "FieldSyncOriginalEstimate", () => $b152a2e0f20a9e95$export$f3b2ab9abc70b1c8);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $koVbs = parcelRequire("koVbs");

var $3fAi8 = parcelRequire("3fAi8");

var $etKNj = parcelRequire("etKNj");

var $2P7AF = parcelRequire("2P7AF");


var $67sX6 = parcelRequire("67sX6");

var $9jMeJ = parcelRequire("9jMeJ");

var $5mTgl = parcelRequire("5mTgl");
const $b152a2e0f20a9e95$export$f3b2ab9abc70b1c8 = ({ issue: { id: id, key: key, estimate: estimate }, originalEstimateFieldId: originalEstimateFieldId })=>{
    const intl = (0, $koVbs.default)();
    const timeTrackingOptions = (0, $67sX6.useBoardSelector)((0, $5mTgl.getTimeTrackingOptions));
    const setEstimateInBoard = (0, $67sX6.useBoardActionCreator)((issueId, value)=>(0, $9jMeJ.setEstimate)(issueId, value));
    const originalEstimateFromBoard = estimate?.value ?? null;
    const [originalEstimateFromIssueField, { setFieldValue: setOriginalEstimateInExtractedField }] = (0, $3fAi8.useFieldValue)({
        issueKey: key,
        fieldKey: originalEstimateFieldId
    });
    const originalEstimateFromBoardChanged = (0, $2P7AF.useDiffCheck)([
        originalEstimateFromBoard
    ]);
    const originalEstimateFromIssueFieldChanged = (0, $2P7AF.useDiffCheck)([
        originalEstimateFromIssueField
    ]);
    const storesNeedToSync = originalEstimateFromBoard !== originalEstimateFromIssueField;
    (0, $5uXOq.useEffect)(()=>{
        // Board -> Issue Field Sync
        if (originalEstimateFromBoardChanged && storesNeedToSync) setOriginalEstimateInExtractedField(key, originalEstimateFieldId, originalEstimateFromBoard);
    }, [
        key,
        originalEstimateFromBoard,
        originalEstimateFromBoardChanged,
        originalEstimateFieldId,
        setOriginalEstimateInExtractedField,
        storesNeedToSync,
        timeTrackingOptions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Issue Field -> Board Sync
        if (// Ensure no sync will be called by Board as Board is the driver
        !originalEstimateFromBoardChanged && originalEstimateFromIssueFieldChanged && storesNeedToSync) setEstimateInBoard(id, !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(originalEstimateFromIssueField) ? {
            type: (0, $b383ed62f6689e0b$export$73bc902d1e240cad),
            fieldId: originalEstimateFieldId,
            value: originalEstimateFromIssueField,
            valueAsText: (0, $etKNj.timeTrackingFormatter)(originalEstimateFromIssueField, timeTrackingOptions, intl)
        } : null);
    }, [
        id,
        setEstimateInBoard,
        storesNeedToSync,
        originalEstimateFromBoardChanged,
        originalEstimateFromIssueField,
        originalEstimateFromIssueFieldChanged,
        timeTrackingOptions,
        intl,
        originalEstimateFieldId
    ]);
    return null;
};

});
parcelRegister("etKNj", function(module, exports) {

$parcel$export(module.exports, "timeTrackingFormatter", () => $5d7d4350edc91a82$export$5169d8c8f9327e33);
$parcel$export(module.exports, "timeTrackingFormatterWithDefaults", () => $5d7d4350edc91a82$export$71be3aa954f6065b);
$parcel$export(module.exports, "timeTrackingFormatterLongForm", () => $5d7d4350edc91a82$export$bb4e82d8c2aeeff1);
$parcel$export(module.exports, "transformAGGToJiraTimeFormat", () => $5d7d4350edc91a82$export$9dccd3a07969375d);
$parcel$export(module.exports, "transformAGGToJiraTimeUnit", () => $5d7d4350edc91a82$export$8516173ab945b52f);

var $gBj4V = parcelRequire("gBj4V");

var $lgkxY = parcelRequire("lgkxY");

var $4TB2x = parcelRequire("4TB2x");
const $5d7d4350edc91a82$var$validate = (condition)=>(distance)=>condition ? distance : 0;
// Format time to be 2 decimal places without trailing zeros
const $5d7d4350edc91a82$var$timeFormatter = (time, unit)=>time > 0 ? `${time.toFixed(2).replace(/\.?0+$/, '')}${unit}` : `0${unit}`;
const $5d7d4350edc91a82$var$timePrettyFormatter = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0${formatMessage(units[3].suffix)}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 0 ? `${timeObj.time} ${currentTimeValue}${formatMessage(unit.suffix)}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $5d7d4350edc91a82$var$timePrettyFormatterLongForm = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0 ${formatMessage(units[3].suffix, {
        [units[3].type]: 0
    })}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const { suffix: suffix, type: type } = unit;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        if (currentTimeValue === 1) return {
            secondsRemaining: timeObj.secondsRemaining % unit.seconds,
            time: `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
                [type]: currentTimeValue
            })}`
        };
        const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 1 ? `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
            [type]: currentTimeValue
        })}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $5d7d4350edc91a82$export$5169d8c8f9327e33 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $gBj4V.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $4TB2x.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $lgkxY.default).timeUnitWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $lgkxY.default).timeUnitDay,
            transform: $5d7d4350edc91a82$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $lgkxY.default).timeUnitHour,
            transform: $5d7d4350edc91a82$var$validate(isTimeValid),
            seconds: (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $lgkxY.default).timeUnitMinute,
            seconds: (0, $gBj4V.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $gBj4V.TimeFormats).DAYS:
            return $5d7d4350edc91a82$var$timeFormatter(units[1].time, formatMessage(units[1].suffix));
        case (0, $gBj4V.TimeFormats).HOURS:
            return $5d7d4350edc91a82$var$timeFormatter(units[2].time, formatMessage(units[2].suffix));
        case (0, $gBj4V.TimeFormats).PRETTY:
        default:
            return $5d7d4350edc91a82$var$timePrettyFormatter(timeInSeconds, units, formatMessage);
    }
};
const $5d7d4350edc91a82$export$71be3aa954f6065b = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat }, intl)=>{
    const timeTrackingSettings = {
        workingHoursPerDay: workingHoursPerDay || (0, $gBj4V.defaultTimeTrackingOptions).workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek || (0, $gBj4V.defaultTimeTrackingOptions).workingDaysPerWeek,
        timeFormat: timeFormat || (0, $gBj4V.defaultTimeTrackingOptions).timeFormat,
        defaultUnit: (0, $gBj4V.defaultTimeTrackingOptions).defaultUnit
    };
    return $5d7d4350edc91a82$export$5169d8c8f9327e33(timeInSeconds || 0, timeTrackingSettings, intl);
};
const $5d7d4350edc91a82$export$bb4e82d8c2aeeff1 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $gBj4V.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $4TB2x.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $lgkxY.default).timeUnitLongWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $lgkxY.default).timeUnitLongDay,
            transform: $5d7d4350edc91a82$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $lgkxY.default).timeUnitLongHour,
            transform: $5d7d4350edc91a82$var$validate(isTimeValid),
            seconds: (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $lgkxY.default).timeUnitLongMinute,
            seconds: (0, $gBj4V.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $gBj4V.TimeFormats).DAYS:
            return $5d7d4350edc91a82$var$timeFormatter(units[1].time, ` ${formatMessage(units[1].suffix, {
                day: units[1].time
            })}`);
        case (0, $gBj4V.TimeFormats).HOURS:
            return $5d7d4350edc91a82$var$timeFormatter(units[2].time, ` ${formatMessage(units[2].suffix, {
                hour: units[2].time
            })}`);
        case (0, $gBj4V.TimeFormats).PRETTY:
        default:
            return $5d7d4350edc91a82$var$timePrettyFormatterLongForm(timeInSeconds, units, formatMessage);
    }
};
const $5d7d4350edc91a82$export$9dccd3a07969375d = (format)=>{
    switch(String(format).toLowerCase()){
        case (0, $gBj4V.TimeFormats).DAYS:
            return (0, $gBj4V.TimeFormats).DAYS;
        case (0, $gBj4V.TimeFormats).HOURS:
            return (0, $gBj4V.TimeFormats).HOURS;
        case (0, $gBj4V.TimeFormats).PRETTY:
            return (0, $gBj4V.TimeFormats).PRETTY;
        default:
            return (0, $gBj4V.TimeFormats).DAYS;
    }
};
const $5d7d4350edc91a82$export$8516173ab945b52f = (defaultUnit)=>{
    switch(String(defaultUnit).toLowerCase()){
        case (0, $gBj4V.TimeUnits).DAY:
            return (0, $gBj4V.TimeUnits).DAY;
        case (0, $gBj4V.TimeUnits).HOUR:
            return (0, $gBj4V.TimeUnits).HOUR;
        case (0, $gBj4V.TimeUnits).MINUTE:
            return (0, $gBj4V.TimeUnits).MINUTE;
        case (0, $gBj4V.TimeUnits).WEEK:
            return (0, $gBj4V.TimeUnits).WEEK;
        default:
            return (0, $gBj4V.TimeUnits).DAY;
    }
};

});
parcelRegister("lgkxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $00e424f4a1d744f3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $00e424f4a1d744f3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    timeUnitWeek: {
        "id": "time-tracking-formatter.time-unit-week",
        "defaultMessage": "w"
    },
    timeUnitDay: {
        "id": "time-tracking-formatter.time-unit-day",
        "defaultMessage": "d"
    },
    timeUnitHour: {
        "id": "time-tracking-formatter.time-unit-hour",
        "defaultMessage": "h"
    },
    timeUnitMinute: {
        "id": "time-tracking-formatter.time-unit-minute",
        "defaultMessage": "m"
    },
    timeUnitLongWeek: {
        "id": "time-tracking-formatter.time-unit-long-week",
        "defaultMessage": "{week, plural, zero {weeks} one {week} other {weeks} }"
    },
    timeUnitLongDay: {
        "id": "time-tracking-formatter.time-unit-long-day",
        "defaultMessage": "{day, plural, zero {days} one {day} other {days} }"
    },
    timeUnitLongHour: {
        "id": "time-tracking-formatter.time-unit-long-hour",
        "defaultMessage": "{hour, plural, zero {hours} one {hour} other {hours} }"
    },
    timeUnitLongMinute: {
        "id": "time-tracking-formatter.time-unit-long-minute",
        "defaultMessage": "{minute, plural, zero {minutes} one {minute} other {minutes} }"
    }
});

});

parcelRegister("4TB2x", function(module, exports) {

$parcel$export(module.exports, "createUnit", () => $d8f5ee4c356dec74$export$aab44654646f3ccc);
const $d8f5ee4c356dec74$export$aab44654646f3ccc = (timeInSeconds)=>({ suffix: suffix, seconds: seconds, type: type, transform: transform })=>{
        const distance = timeInSeconds / seconds;
        const time = transform ? transform(distance) : distance;
        return {
            seconds: seconds,
            suffix: suffix,
            time: time,
            type: type
        };
    };

});



parcelRegister("eNXt6", function(module, exports) {

$parcel$export(module.exports, "FieldSyncStoryPoint", () => $f04848d24e7c0dcc$export$82efc4b6933fada0);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $3fAi8 = parcelRequire("3fAi8");

var $2P7AF = parcelRequire("2P7AF");


var $67sX6 = parcelRequire("67sX6");

var $9jMeJ = parcelRequire("9jMeJ");

var $63LqY = parcelRequire("63LqY");
const $f04848d24e7c0dcc$export$82efc4b6933fada0 = ({ issue: { id: id, key: key, estimate: estimate }, storypointsFieldId: storypointsFieldId, projectKey: projectKey })=>{
    const setEstimateInBoard = (0, $67sX6.useBoardActionCreator)((issueId, value)=>(0, $9jMeJ.setEstimate)(issueId, value));
    const storyPointFromBoard = estimate?.value ?? null;
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    // In the increment planning board, scenario issue keys do not yet have a numeric identifier as
    // they have not been created in Jira yet. In this case, the key is equal to the projectKey,
    // and thus not unique. Instead, we pass the issue id to the field config service (as it
    // requires a unique identifier for each issue).
    const uniqueKey = isIPBoard && key === projectKey ? `${id}` : key;
    const [storyPointFromIssueField, { setFieldValue: setStoryPointInExtractedFields }] = (0, $3fAi8.useFieldValue)({
        issueKey: uniqueKey,
        fieldKey: storypointsFieldId
    });
    const storyPointFromBoardChanged = (0, $2P7AF.useDiffCheck)([
        storyPointFromBoard
    ]);
    const storyPointFromIssueFieldChanged = (0, $2P7AF.useDiffCheck)([
        storyPointFromIssueField
    ]);
    const storesNeedToSync = storyPointFromBoard !== storyPointFromIssueField;
    (0, $5uXOq.useEffect)(()=>{
        // Board -> Issue Field Sync
        if (storyPointFromBoardChanged && storesNeedToSync) setStoryPointInExtractedFields(uniqueKey, storypointsFieldId, storyPointFromBoard);
    }, [
        storypointsFieldId,
        key,
        setStoryPointInExtractedFields,
        storesNeedToSync,
        storyPointFromBoard,
        storyPointFromBoardChanged,
        uniqueKey
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Issue Field -> Board Sync
        if (// Ensure no sync will be called by Board as Board is the driver
        !storyPointFromBoardChanged && storyPointFromIssueFieldChanged && storesNeedToSync) {
            let estimateFieldValue = null;
            if (isIPBoard) estimateFieldValue = {
                type: (0, $b383ed62f6689e0b$export$24c68738fb7a96c7),
                fieldId: storypointsFieldId,
                value: storyPointFromIssueField || ''
            };
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(storyPointFromIssueField)) estimateFieldValue = {
                type: (0, $b383ed62f6689e0b$export$a092d6877c35430e),
                fieldId: storypointsFieldId,
                value: storyPointFromIssueField
            };
            setEstimateInBoard(id, estimateFieldValue);
        }
    }, [
        storypointsFieldId,
        id,
        setEstimateInBoard,
        storesNeedToSync,
        storyPointFromBoardChanged,
        storyPointFromIssueField,
        storyPointFromIssueFieldChanged,
        isIPBoard
    ]);
    return null;
};

});


parcelRegister("d7KqV", function(module, exports) {

$parcel$export(module.exports, "FieldSyncParent", () => $40be629fe9e48f30$export$68e0e835c0241644);

var $5uXOq = parcelRequire("5uXOq");

var $3fAi8 = parcelRequire("3fAi8");

var $7Fute = parcelRequire("7Fute");

var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $2P7AF = parcelRequire("2P7AF");

var $67sX6 = parcelRequire("67sX6");

var $evkwq = parcelRequire("evkwq");

var $bSSdD = parcelRequire("bSSdD");

var $63LqY = parcelRequire("63LqY");
const $40be629fe9e48f30$export$68e0e835c0241644 = ({ issue: { id: id, key: key, parentId: parentId }, projectKey: projectKey })=>{
    const parentIdFromBoard = (0, $5uXOq.useMemo)(()=>parentId ? String(parentId) : null, [
        parentId
    ]);
    const issueParentFromBoard = (0, $67sX6.useBoardSelector)((state)=>(0, $bSSdD.makeIssueParentByIdSelector)(state)(parentIdFromBoard));
    const setParentInBoard = (0, $67sX6.useBoardActionCreator)((issueId, issueParentId)=>(0, $evkwq.setIssueParent)(issueId, issueParentId));
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    // In the increment planning board, scenario issue keys do not yet have a numeric identifier as
    // they have not been created in Jira yet. In this case, the key is equal to the projectKey,
    // and thus not unique. Instead, we pass the issue id to the field config service (as it
    // requires a unique identifier for each issue).
    const uniqueKey = isIPBoard && key === projectKey ? `${id}` : key;
    const [parentFromIssueField, { setFieldValue: setParentInExtractedFields }] = (0, $3fAi8.useFieldValue)({
        issueKey: uniqueKey,
        fieldKey: (0, $5fc53.PARENT_TYPE)
    });
    const [, { setFieldValue: setValueInExtractedField }] = (0, $3fAi8.useFieldsValuesActions)();
    const parentIdFromIssueField = (0, $5uXOq.useMemo)(()=>parentFromIssueField?.id || null, [
        parentFromIssueField?.id
    ]);
    const parentFromBoardChanged = (0, $2P7AF.useDiffCheck)([
        parentIdFromBoard
    ]);
    const parentFromIssueFieldChanged = (0, $2P7AF.useDiffCheck)([
        parentIdFromIssueField
    ]);
    // parent field should only sync on increment planning board for story level issues
    const issueIsParentInIPBoard = (parentIdFromBoard === id || parentIdFromIssueField === id) && isIPBoard;
    const storesNeedToSync = parentIdFromBoard !== parentIdFromIssueField && !issueIsParentInIPBoard;
    // PARENT SYNC: BOARD -> EXTRACTED FIELDS
    (0, $5uXOq.useEffect)(()=>{
        if (parentFromBoardChanged && storesNeedToSync) {
            setParentInExtractedFields(uniqueKey, (0, $5fc53.PARENT_TYPE), issueParentFromBoard ? (0, $7Fute.getParentShape)((0, $g5X3G.toIssueId)(String(issueParentFromBoard.id)), issueParentFromBoard.key, issueParentFromBoard.summary, {
                id: issueParentFromBoard.issueType.id,
                name: issueParentFromBoard.issueType.name,
                iconUrl: issueParentFromBoard.issueType.iconUrl
            }, issueParentFromBoard.color) : null);
            if (issueParentFromBoard) setValueInExtractedField(uniqueKey, (0, $5fc53.HIERARCHY_LEVEL_ABOVE), (0, $7Fute.getHierarchyShape)({
                id: issueParentFromBoard.issueType.id,
                name: issueParentFromBoard.issueType.name,
                iconUrl: issueParentFromBoard.issueType.iconUrl
            }));
        }
    }, [
        issueParentFromBoard,
        parentFromBoardChanged,
        setValueInExtractedField,
        setParentInExtractedFields,
        storesNeedToSync,
        uniqueKey
    ]);
    // PARENT SYNC: EXTRACTED FIELDS -> BOARD
    (0, $5uXOq.useEffect)(()=>{
        if (!parentFromBoardChanged && parentFromIssueFieldChanged && storesNeedToSync) setParentInBoard(id, parentFromIssueField?.id || null);
    }, [
        id,
        parentFromBoardChanged,
        parentFromIssueField?.id,
        parentFromIssueFieldChanged,
        setParentInBoard,
        storesNeedToSync
    ]);
    return null;
};

});

parcelRegister("7MspI", function(module, exports) {

$parcel$export(module.exports, "FieldSyncSummary", () => $f38acd997060fe0a$export$e5eb14bcd03ae390);

var $5uXOq = parcelRequire("5uXOq");

var $3fAi8 = parcelRequire("3fAi8");

var $5fc53 = parcelRequire("5fc53");

var $2P7AF = parcelRequire("2P7AF");

var $67sX6 = parcelRequire("67sX6");

var $4l4AL = parcelRequire("4l4AL");

var $63LqY = parcelRequire("63LqY");
const $f38acd997060fe0a$export$e5eb14bcd03ae390 = ({ issue: { id: id, key: key, summary: summaryFromBoard }, projectKey: projectKey })=>{
    const setSummaryInBoard = (0, $67sX6.useBoardActionCreator)((issueId, summary)=>(0, $4l4AL.setSummary)(issueId, summary));
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    // In the increment planning board, scenario issue keys do not yet have a numeric identifier as
    // they have not been created in Jira yet. In this case, the key is equal to the projectKey,
    // and thus not unique. Instead, we pass the issue id to the field config service (as it
    // requires a unique identifier for each issue).
    const uniqueKey = isIPBoard && key === projectKey ? `${id}` : key;
    const [summaryFromIssueField, { setFieldValue: setSummaryInExtractedFields }] = (0, $3fAi8.useFieldValue)({
        issueKey: uniqueKey,
        fieldKey: (0, $5fc53.SUMMARY_TYPE)
    });
    const summaryFromBoardChanged = (0, $2P7AF.useDiffCheck)([
        summaryFromBoard
    ]);
    const summaryFromIssueFieldChanged = (0, $2P7AF.useDiffCheck)([
        summaryFromIssueField
    ]);
    const storesNeedToSync = summaryFromBoard !== summaryFromIssueField;
    // SUMMARY SYNC: BOARD -> EXTRACTED FIELDS
    (0, $5uXOq.useEffect)(()=>{
        if (summaryFromBoardChanged && storesNeedToSync) setSummaryInExtractedFields(uniqueKey, (0, $5fc53.SUMMARY_TYPE), summaryFromBoard);
    }, [
        uniqueKey,
        setSummaryInExtractedFields,
        storesNeedToSync,
        summaryFromBoard,
        summaryFromBoardChanged
    ]);
    // SUMMARY SYNC: EXTRACTED FIELDS -> BOARD
    (0, $5uXOq.useEffect)(()=>{
        if (!summaryFromBoardChanged && summaryFromIssueFieldChanged && storesNeedToSync) setSummaryInBoard(id, summaryFromIssueField);
    }, [
        id,
        setSummaryInBoard,
        storesNeedToSync,
        summaryFromBoardChanged,
        summaryFromIssueField,
        summaryFromIssueFieldChanged
    ]);
    return null;
};

});



parcelRegister("j0iXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d7abc75528822b9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $67sX6 = parcelRequire("67sX6");

var $cW3pH = parcelRequire("cW3pH");
const $5d7abc75528822b9$var$BoardAPI = ({ boardApiRef: boardApiRef })=>{
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const boardApi = (0, $5uXOq.useMemo)(()=>({
            refresh: ()=>dispatch((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$17d7097367e94100)))
        }), [
        dispatch
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line no-param-reassign
        boardApiRef.current = boardApi;
    }, [
        boardApiRef,
        boardApi
    ]);
    return null;
};
var $5d7abc75528822b9$export$2e2bcd8739ae039 = $5d7abc75528822b9$var$BoardAPI;

});

parcelRegister("gru50", function(module, exports) {

$parcel$export(module.exports, "FiltersStorage", () => $1a2ece435715d48f$export$311c7d3073893ae);

var $5uXOq = parcelRequire("5uXOq");

var $wKznQ = parcelRequire("wKznQ");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");

var $63LqY = parcelRequire("63LqY");
const $1a2ece435715d48f$export$311c7d3073893ae = ()=>{
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const boardId = (0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector));
    const filters = (0, $67sX6.useBoardSelector)((state)=>state.ui.workFilters?.values);
    (0, $5uXOq.useEffect)(()=>{
        if (isCMPBoard) (0, $wKznQ.setCachedFilters)('board', boardId, filters);
    }, [
        boardId,
        filters,
        isCMPBoard
    ]);
    return null;
};

});

parcelRegister("buSp0", function(module, exports) {

$parcel$export(module.exports, "SwimlaneModeFromUrl", () => $7f8ae55f4a029bda$export$4f8eefe54ea059b8);

var $5uXOq = parcelRequire("5uXOq");

var $fr1K2 = parcelRequire("fr1K2");

var $dIdda = parcelRequire("dIdda");

var $cjoN4 = parcelRequire("cjoN4");

var $67sX6 = parcelRequire("67sX6");

var $k50Aq = parcelRequire("k50Aq");

var $45cXl = parcelRequire("45cXl");
const $7f8ae55f4a029bda$export$176805c664ae8df3 = 'groupBy';
const $7f8ae55f4a029bda$export$4f8eefe54ea059b8 = ()=>{
    const [{ location: location, query: query }, { replace: replace }] = (0, $dIdda.useRouter)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const availableSwimlanes = (0, $67sX6.useBoardSelector)((0, $45cXl.getSwimlaneModes));
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const queryValue = query[$7f8ae55f4a029bda$export$176805c664ae8df3];
        if (!queryValue) return;
        const swimlaneModeId = (0, $cjoN4.swimlaneStrategiesToMode)[queryValue] || null;
        if (availableSwimlanes.find((swimlane)=>swimlane.id === swimlaneModeId)) dispatch((0, $k50Aq.swimlaneModeChangeRequest)(swimlaneModeId));
        // Remove groupBy from search params
        replace({
            ...location,
            search: new URLSearchParams((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(query, $7f8ae55f4a029bda$export$176805c664ae8df3)).toString()
        });
    }, [
        availableSwimlanes,
        dispatch,
        location,
        query,
        replace
    ]);
    return null;
};

});

parcelRegister("4zzhM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ead5ebe25ede66e1$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $dW1HX = parcelRequire("dW1HX");

var $gNhLO = parcelRequire("gNhLO");
const $ead5ebe25ede66e1$var$mapDispatchToProps = {
    onOpenIssueModal: (0, $dW1HX.openIssueModal),
    onCloseIssueModal: (0, $dW1HX.closeIssueModal)
};
var $ead5ebe25ede66e1$export$2e2bcd8739ae039 = (0, $bC2fB.connect)(null, $ead5ebe25ede66e1$var$mapDispatchToProps)((0, $gNhLO.default));

});
parcelRegister("gNhLO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c5e468b97351ce9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jQ7vZ = parcelRequire("jQ7vZ");

var $67sX6 = parcelRequire("67sX6");

var $fqLDH = parcelRequire("fqLDH");
const $2c5e468b97351ce9$export$6cfa8b91c03902d6 = ({ onOpenIssueModal: onOpenIssueModal = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCloseIssueModal: onCloseIssueModal = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const isInitialMount = (0, $5uXOq.useRef)(true);
    const [selectedIssue] = (0, $jQ7vZ.useQueryParam)('selectedIssue');
    const issueModal = (0, $67sX6.useBoardSelector)((0, $fqLDH.getIssueModal));
    const issueModalRef = (0, $5uXOq.useRef)(issueModal);
    (0, $5uXOq.useEffect)(()=>{
        if (issueModalRef.current !== issueModal) issueModalRef.current = issueModal;
    }, [
        issueModal
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isInitialMount.current) isInitialMount.current = false;
        else if (selectedIssue) {
            if (issueModalRef?.current?.selectedIssueKey) onOpenIssueModal(selectedIssue, issueModalRef?.current?.externalAction);
            else onOpenIssueModal(selectedIssue);
        } else onCloseIssueModal(null);
    }, [
        selectedIssue,
        onOpenIssueModal,
        onCloseIssueModal
    ]);
    return null;
};
var $2c5e468b97351ce9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($2c5e468b97351ce9$export$6cfa8b91c03902d6);

});



parcelRegister("5sgUt", function(module, exports) {

$parcel$export(module.exports, "isBoardSizeLimitError", () => $9689f51629af798e$export$c72e0becab2a28fe);

var $9XE6b = parcelRequire("9XE6b");
const $9689f51629af798e$export$c72e0becab2a28fe = (error)=>error != null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    error.graphQLErrors != null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    Array.isArray(error.graphQLErrors) && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    error.graphQLErrors.length > 0 && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    error.graphQLErrors[0] != null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error.graphQLErrors[0], [
        'extensions',
        'statusCode'
    ]) && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error.graphQLErrors[0], [
        'extensions',
        'errorType'
    ]) === 'jsw.board-size-limit-exceeded';

});


parcelRegister("8XaG5", function(module, exports) {

$parcel$export(module.exports, "NoSoftwareLicense", () => $a7a9d469bc380dc9$export$97e3c9c160f8ea89);

var $5uXOq = parcelRequire("5uXOq");

var $g0Gtc = parcelRequire("g0Gtc");

var $d31Su = parcelRequire("d31Su");
const $a7a9d469bc380dc9$export$97e3c9c160f8ea89 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceSuccessTracker), {
        location: "ng-board-context-query"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d31Su.AsyncNoSoftwareLicense), null));

});
parcelRegister("d31Su", function(module, exports) {

$parcel$export(module.exports, "AsyncNoSoftwareLicense", () => $dcd2c1aef082694d$export$52d8964299339cae);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $dcd2c1aef082694d$var$LazyNoSoftwareLicense = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("1qjZt")), {
    moduleId: "./src/packages/spa-apps/common/src/error-screens/no-software-license/index.tsx"
});
const $dcd2c1aef082694d$export$52d8964299339cae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "no-software-license",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dcd2c1aef082694d$var$LazyNoSoftwareLicense, null));

});
parcelRegister("1qjZt", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("lzKF1").then(()=>parcelRequire('eX102'));

});




parcelRegister("54XqP", function(module, exports) {

$parcel$export(module.exports, "BoardWithRouterCMP", () => $67067dc5743ca4c0$export$1966567fd19f5c06);

var $5uXOq = parcelRequire("5uXOq");

var $aaV7S = parcelRequire("aaV7S");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $3mYHL = parcelRequire("3mYHL");

var $f7Y15 = parcelRequire("f7Y15");

var $9dbF6 = parcelRequire("9dbF6");

var $gqLmL = parcelRequire("gqLmL");

var $9OXo1 = parcelRequire("9OXo1");

var $dIdda = parcelRequire("dIdda");


var $k6PKo = parcelRequire("k6PKo");

var $8XaG5 = parcelRequire("8XaG5");

var $eantU = parcelRequire("eantU");
const $67067dc5743ca4c0$export$1966567fd19f5c06 = ({ hasSoftwareLicense: hasSoftwareLicense })=>{
    const [paramBoardId] = (0, $dIdda.usePathParam)('boardId');
    const [projectKey] = (0, $dIdda.usePathParam)('projectKey');
    const cmpBoardData = (0, $dIdda.useResource)((0, $f7Y15.uifBoardResource));
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const boardId = Number(paramBoardId);
    const { loading: loading, data: data, error: error } = cmpBoardData;
    const boardLocation = data?.result?.boardLocation;
    const { key: key, id: id, name: name } = boardLocation ?? {};
    const projectDetails = {
        key: key,
        id: id,
        name: name
    };
    const projectKeyFromContext = projectDetails.key || projectKey || '';
    const history = (0, $dIdda.useRouterActions)();
    // for locationless boards with old style links like: https://domain.com/secure/RapidBoard.jspa?rapidView=10&useStoredSettings=true&locationless=true
    const [rapidViewBoardIdString] = (0, $dIdda.useQueryParam)('rapidView');
    const rapidViewBoardId = Number(rapidViewBoardIdString);
    const [locationlessFromRapidBoardLink] = (0, $dIdda.useQueryParam)('locationless');
    const isLocationlessRapidBoardLink = rapidViewBoardId && locationlessFromRapidBoardLink === 'true';
    const isCacheHit = Boolean(data?.isCacheHit);
    const hasShownBoardWithUnmappedErrorFlag = (0, $5uXOq.useRef)(false);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const renderBoard = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gqLmL.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
            subProduct: "software"
        }), (0, $k6PKo.renderBoardApp)({
            rapidViewId: boardId,
            projectKey: projectKeyFromContext,
            projectType: (0, $2vSU6.SOFTWARE_PROJECT),
            context: {
                tenantContext: tenantContext
            },
            cmpBoardData: cmpBoardData,
            boardData: null,
            history: history,
            isCacheHit: isCacheHit,
            isCMPBoard: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mYHL.default), {
            projectKey: projectKey || projectKeyFromContext || null
        }));
    const showBoardWithUnmappedColumnWarningFlag = ()=>{
        showFlag({
            id: (0, $7HGHK.toFlagId)('board_with_unmapped_column_flag'),
            type: 'warning',
            title: formatMessage((0, $eantU.default).boardWithUnmappedColumnFlagTitle),
            isAutoDismiss: false,
            description: tenantContext.isAdmin ? formatMessage((0, $eantU.default).boardWithUnmappedColumnFlagDescriptionForAdmin) : formatMessage((0, $eantU.default).boardWithUnmappedColumnFlagDescriptionForUser),
            actions: tenantContext.isAdmin ? [
                {
                    content: formatMessage((0, $eantU.default).navigateToBoardSettingsCta),
                    href: '?config=columns',
                    target: '_self'
                }
            ] : []
        });
        hasShownBoardWithUnmappedErrorFlag.current = true;
    };
    if (hasSoftwareLicense) {
        if (!loading && error && error.message === (0, $d7cba9080a5695ea$export$912d9029af46d426)) return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: "/jira/projects?showFlag=jsw.project-not-found"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aaV7S.AsyncLocationlessDialog), {
            rapidViewId: boardId
        });
        if (!loading && error && error.message === (0, $d7cba9080a5695ea$export$759edcab449d5404) && !hasShownBoardWithUnmappedErrorFlag.current && (0, $4R6GH.fg)('show_board_with_unmapped_column_error_flag')) showBoardWithUnmappedColumnWarningFlag();
        if (isLocationlessRapidBoardLink) return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: "/jira/projects?showFlag=jsw.project-not-found"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aaV7S.AsyncLocationlessDialog), {
            rapidViewId: rapidViewBoardId,
            classicLocationless: isLocationlessRapidBoardLink
        });
        return renderBoard();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8XaG5.NoSoftwareLicense), null);
};

});
parcelRegister("aaV7S", function(module, exports) {

$parcel$export(module.exports, "AsyncLocationlessDialog", () => $5875e6aa9017967d$export$15ccbdebadffcb56);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// TODO: FEBA-214 - convert to use EntryPoint (see https://hello.atlassian.net/wiki/spaces/UAF/pages/2333138307/Tutorial+How+to+create+an+EntryPoint)
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5875e6aa9017967d$var$LazyComponent = (0, $kxZPA.lazy)(()=>(parcelRequire("kQH2l")), {
    moduleId: "./src/packages/board-location-dialogs/locationless/src/app.tsx"
});
const $5875e6aa9017967d$export$15ccbdebadffcb56 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "bundle-async-locationless-dialog",
        teamName: "a4t-pandora",
        packageName: "jiraBoardLocationDialogsLocationless"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "locationless-dialog-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5875e6aa9017967d$var$LazyComponent, {
        baseUrl: "",
        ...props
    })));

});
parcelRegister("kQH2l", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("boUnd")
]).then(()=>parcelRequire('h6olf'));

});


parcelRegister("gqLmL", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", () => $89b567f441a32e03$export$2dc68d50d56fbbd);

var $5uXOq = parcelRequire("5uXOq");

var $4DPZY = parcelRequire("4DPZY");

var $gSBIZ = parcelRequire("gSBIZ");

var $jgyQq = parcelRequire("jgyQq");

var $7waah = parcelRequire("7waah");

var $liUyW = parcelRequire("liUyW");
const $89b567f441a32e03$export$2dc68d50d56fbbd = ()=>{
    const [{ data: data, error: error }] = (0, $4DPZY.useContainerContext)();
    const { chartView: chartView, boardId: boardId, isBoardLocationless: isBoardLocationless, isReportsView: isReportsView, accountId: accountId } = (0, $jgyQq.useUrlState)();
    if (!data || error) return null;
    const boardName = data.scope && data.scope.name || '';
    if ((0, $gSBIZ.isUserContext)(data) && accountId) {
        const { user: user } = data;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $liUyW.UserBreadcrumbs), {
            accountId: accountId,
            boardId: Number(boardId),
            boardName: boardName,
            isReportsView: isReportsView,
            profileUrl: user.profileUrl,
            userName: user.name,
            chart: chartView,
            isLocationlessBoard: isBoardLocationless
        });
    }
    if ((0, $gSBIZ.isProjectContext)(data)) {
        const { project: project } = data;
        const projectKey = project.key;
        const projectName = project.name;
        const projectId = project.id;
        const isSimplifiedProject = project.isSimplified;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7waah.ProjectBreadcrumbs), {
            baseUrl: "",
            boardId: Number(boardId),
            boardName: boardName,
            chart: chartView,
            projectKey: projectKey,
            projectName: projectName,
            projectId: projectId,
            isSimplifiedProject: isSimplifiedProject
        });
    }
    return null;
};

});
parcelRegister("jgyQq", function(module, exports) {

$parcel$export(module.exports, "useUrlState", () => $1c5a5dbec5fedd96$export$6a582373474709af);

var $dIdda = parcelRequire("dIdda");

var $eZFkq = parcelRequire("eZFkq");
const $1c5a5dbec5fedd96$export$6a582373474709af = ()=>{
    const [{ query: query, route: route, match: match }] = (0, $dIdda.useRouter)();
    const { rapidView: rapidView, chart: chart, view: view, config: config, projectKey: queryProjectKey, locationless: locationless } = query;
    const { accountId: accountId } = match.params;
    const isBoardLocationless = !!locationless;
    const shouldUsePrettyUrlState = !isBoardLocationless;
    const mode = shouldUsePrettyUrlState ? (0, $eZFkq.getModeV2)(route) : (0, $eZFkq.getMode)(view);
    const boardId = shouldUsePrettyUrlState ? match.params.boardId : rapidView;
    const projectKey = shouldUsePrettyUrlState ? match.params.projectKey : queryProjectKey;
    const chartView = shouldUsePrettyUrlState ? (0, $eZFkq.toCamelCaseChartView)(match.params.chartView || '') : chart;
    const isReportsView = query && query.view === 'reporting';
    return {
        accountId: accountId,
        mode: mode,
        boardId: boardId,
        chartView: chartView,
        projectKey: projectKey,
        routeName: route.name,
        config: config,
        isBoardLocationless: isBoardLocationless,
        isReportsView: isReportsView
    };
};

});
parcelRegister("eZFkq", function(module, exports) {

$parcel$export(module.exports, "toCamelCaseChartView", () => $8f9b588eed549686$export$f1cb745981250009);
$parcel$export(module.exports, "getMode", () => $8f9b588eed549686$export$1fc0f6205829e19c);
$parcel$export(module.exports, "getModeV2", () => $8f9b588eed549686$export$cc65f5a30b63da10);

var $e4eHl = parcelRequire("e4eHl");

var $65Ltd = parcelRequire("65Ltd");

const $8f9b588eed549686$export$f1cb745981250009 = (chartView)=>(0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(chartView);
const $8f9b588eed549686$export$1fc0f6205829e19c = (view)=>{
    switch(view){
        case 'planning':
        case 'planning.nodetail':
            return 0, $257789568f7508a4$export$c303e491e026ebc6;
        case 'reporting':
            return 0, $257789568f7508a4$export$e3d31417f21c1ce7;
        default:
            return 0, $257789568f7508a4$export$77d6f70978850641;
    }
};
const $8f9b588eed549686$export$cc65f5a30b63da10 = (route)=>{
    if (!route) return 0, $257789568f7508a4$export$77d6f70978850641;
    switch(route.name){
        case 0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_BACKLOG:
        case 0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG:
            return 0, $257789568f7508a4$export$c303e491e026ebc6;
        case 0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_REPORT:
        case 0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_USER_REPORT:
            return 0, $257789568f7508a4$export$e3d31417f21c1ce7;
        default:
            return 0, $257789568f7508a4$export$77d6f70978850641;
    }
};

});
const $257789568f7508a4$export$77d6f70978850641 = 'work';
const $257789568f7508a4$export$c303e491e026ebc6 = 'plan';
const $257789568f7508a4$export$e3d31417f21c1ce7 = 'report';



parcelRegister("7waah", function(module, exports) {

$parcel$export(module.exports, "ProjectBreadcrumbs", () => $8abb6938d84ad6f7$export$38f8c59e2af08a87);

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");

var $gEFwt = parcelRequire("gEFwt");

var $koVbs = parcelRequire("koVbs");

var $4Fx92 = parcelRequire("4Fx92");
const $8abb6938d84ad6f7$export$38f8c59e2af08a87 = /*#__PURE__*/ (0, $5uXOq.memo)(({ baseUrl: baseUrl, boardId: boardId, boardName: boardName, projectKey: projectKey, projectName: projectName, projectId: projectId, isSimplifiedProject: isSimplifiedProject, chart: chart })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectName: projectName,
        projectId: projectId,
        isSimplifiedProject: isSimplifiedProject
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: boardName,
            href: `/jira/software/c/projects/${projectKey}/boards/${boardId}`,
            type: 'boardName',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToSubProject',
                containerId: projectId,
                containerType: 'project'
            }
        }
    }, chart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: formatMessage((0, $4Fx92.messages).projectReportBreadcrumb),
            href: `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`
        }
    })));
});

});
parcelRegister("4Fx92", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5aafea47193ed555$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5aafea47193ed555$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    projectReportBreadcrumb: {
        "id": "spa-apps-software-breadcrumbs.project.project-report-breadcrumb",
        "defaultMessage": "Reports"
    }
});

});


parcelRegister("liUyW", function(module, exports) {

$parcel$export(module.exports, "UserBreadcrumbs", () => $3727e2d15103e5d8$export$74fdd5a0187b08ef);

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");

var $75PvK = parcelRequire("75PvK");

var $koVbs = parcelRequire("koVbs");

var $ikP65 = parcelRequire("ikP65");
const $3727e2d15103e5d8$export$74fdd5a0187b08ef = /*#__PURE__*/ (0, $5uXOq.memo)(({ accountId: accountId, boardId: boardId, boardName: boardName, profileUrl: profileUrl, userName: userName, chart: chart, isLocationlessBoard: isLocationlessBoard })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (isLocationlessBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $75PvK.default), {
        profileUrl: profileUrl,
        name: userName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: boardName,
            href: `/secure/RapidBoard.jspa?rapidView=${boardId}&locationless=true`,
            type: 'boardName'
        }
    }, chart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: formatMessage((0, $ikP65.messages).userReportBreadcrumb),
            href: `/secure/RapidBoard.jspa?rapidView=${boardId}&view=reporting&chart=${chart}&locationless=true`
        }
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $75PvK.default), {
        profileUrl: profileUrl,
        name: userName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: boardName,
            href: `/jira/people/${accountId}/boards/${boardId}`,
            type: 'boardName'
        }
    }, chart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: formatMessage((0, $ikP65.messages).userReportBreadcrumb),
            href: `/jira/people/${accountId}/boards/${boardId}/reports/${chart}`
        }
    })));
});

});
parcelRegister("ikP65", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0a2e9bc5bc00af22$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0a2e9bc5bc00af22$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    userReportBreadcrumb: {
        "id": "spa-apps-software-breadcrumbs.user.user-report-breadcrumb",
        "defaultMessage": "Reports"
    }
});

});



const $d7cba9080a5695ea$export$912d9029af46d426 = 'Board is locationless';
const $d7cba9080a5695ea$export$759edcab449d5404 = 'This board has no columns with a mapped status.';

parcelRegister("eantU", function(module, exports) {

$parcel$export(module.exports, "default", () => $464e02af7f354def$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $464e02af7f354def$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    boardWithUnmappedColumnFlagTitle: {
        "id": "spa-apps.next-gen-board.board.board-with-router-cmp.board-with-unmapped-column-flag-title",
        "defaultMessage": "We couldn't load your board"
    },
    boardWithUnmappedColumnFlagDescriptionForUser: {
        "id": "spa-apps.next-gen-board.board.board-with-router-cmp.board-with-unmapped-column-flag-description-for-user",
        "defaultMessage": "The board doesn't have any statuses mapped to its columns. Ask your admin to map statuses to columns in board settings."
    },
    boardWithUnmappedColumnFlagDescriptionForAdmin: {
        "id": "spa-apps.next-gen-board.board.board-with-router-cmp.board-with-unmapped-column-flag-description-for-admin",
        "defaultMessage": "The board doesn't have any statuses mapped to its columns. Ensure that at least 1 status is mapped to a column."
    },
    navigateToBoardSettingsCta: {
        "id": "spa-apps.next-gen-board.board.board-with-router-cmp.navigate-to-board-settings-cta",
        "defaultMessage": "Board settings"
    }
});

});


parcelRegister("kCEVs", function(module, exports) {

$parcel$export(module.exports, "BoardWithRouterRelay", () => $0b48d943eb448fb6$export$97d4107e2ddca4c2);

var $29r6q = parcelRequire("29r6q");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $gEFwt = parcelRequire("gEFwt");

var $2vSU6 = parcelRequire("2vSU6");

var $3mYHL = parcelRequire("3mYHL");

var $ao2h1 = parcelRequire("ao2h1");

var $5qQ9I = parcelRequire("5qQ9I");

var $9kARR = parcelRequire("9kARR");

var $9dbF6 = parcelRequire("9dbF6");

var $6XsPQ = parcelRequire("6XsPQ");

var $9OXo1 = parcelRequire("9OXo1");

var $dIdda = parcelRequire("dIdda");

var $7FT8M = parcelRequire("7FT8M");

var $k6PKo = parcelRequire("k6PKo");

var $8XaG5 = parcelRequire("8XaG5");
const $0b48d943eb448fb6$export$97d4107e2ddca4c2 = ({ hasSoftwareLicense: hasSoftwareLicense, boardQueryReference: boardQueryReference })=>{
    const [paramBoardId] = (0, $dIdda.usePathParam)('boardId');
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const boardId = Number(paramBoardId);
    const aggData = (0, $8Uumt.usePreloadedQuery)(/* eslint-disable @atlassian/relay/unused-fields */ (0, $29r6q.default), /* eslint-enable @atlassian/relay/unused-fields */ boardQueryReference);
    const boardData = {
        data: (0, $7FT8M.transformAggToSwagData)(aggData),
        loading: false,
        error: null
    };
    const isCacheMiss = (0, $9kARR.useGetHasSuspended)();
    const isCacheHit = !isCacheMiss;
    const { projectLocation: projectLocation } = boardData.data || {};
    const response = (0, $ao2h1.useRelayResource)((0, $5qQ9I.customFiltersResource));
    const customFiltersQueryRef = response.queryReference;
    if (!hasSoftwareLicense) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8XaG5.NoSoftwareLicense), null);
    return(// @ts-expect-error - TS2739 - Type '{ children: (history: any) => Element; }' is missing the following properties from type 'RouteContext': location, query, route, match, action
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6XsPQ.HistoryAdapter), null, (history)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
            /* eslint-disable-next-line jira/deprecations/no-base-url */ baseUrl: tenantContext.baseUrl,
            projectKey: projectLocation.key,
            projectName: projectLocation.name,
            projectId: projectLocation.id,
            isSimplifiedProject: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
            subProduct: "software"
        }), (0, $k6PKo.renderBoardApp)({
            rapidViewId: boardId,
            projectKey: projectLocation.key,
            projectType: (0, $2vSU6.SOFTWARE_PROJECT),
            context: {
                tenantContext: tenantContext
            },
            boardData: boardData,
            history: history,
            isCacheHit: isCacheHit,
            customFiltersQueryRef: customFiltersQueryRef
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mYHL.default), {
            projectKey: projectLocation.key
        })))));
};

});
parcelRegister("29r6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $821625877dab08cc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3a7e7a486467a3013ee642ee950bfe70>>
 * @relayHash 1b45667561f9430ea4e961757485983b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67

var $eiowN = parcelRequire("eiowN");
const $821625877dab08cc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "userSwimlaneStrategy"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "swimlaneStrategy"
    }, v5 = {
        "kind": "ScalarField",
        "name": "hasClearedCards"
    }, v6 = {
        "kind": "ScalarField",
        "name": "rankCustomFieldId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "maxCardCount"
    }, v11 = {
        "kind": "ScalarField",
        "name": "category"
    }, v12 = {
        "kind": "ScalarField",
        "name": "transitionId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "isGlobal"
    }, v14 = {
        "kind": "ScalarField",
        "name": "isInitial"
    }, v15 = {
        "kind": "ScalarField",
        "name": "hasConditions"
    }, v16 = {
        "kind": "ScalarField",
        "name": "isDone"
    }, v17 = {
        "kind": "ScalarField",
        "name": "flagged"
    }, v18 = {
        "kind": "ScalarField",
        "name": "done"
    }, v19 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "storyPoints"
    }, v21 = {
        "kind": "ScalarField",
        "name": "value"
    }, v22 = {
        "kind": "ScalarField",
        "name": "valueAsText"
    }, v23 = {
        "kind": "ScalarField",
        "name": "key"
    }, v24 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v25 = {
        "kind": "ScalarField",
        "name": "labels"
    }, v26 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v27 = {
        "kind": "ScalarField",
        "name": "dueDate"
    }, v28 = {
        "kind": "ScalarField",
        "name": "complete"
    }, v29 = {
        "kind": "ScalarField",
        "name": "total"
    }, v30 = {
        "kind": "ScalarField",
        "name": "hierarchyLevelType"
    }, v31 = {
        "kind": "ScalarField",
        "name": "enabled"
    }, v32 = [
        {
            "kind": "Literal",
            "name": "state",
            "value": [
                "ACTIVE"
            ]
        }
    ], v33 = {
        "kind": "ScalarField",
        "name": "goal"
    }, v34 = {
        "kind": "ScalarField",
        "name": "startDate"
    }, v35 = {
        "kind": "ScalarField",
        "name": "endDate"
    }, v36 = {
        "kind": "ScalarField",
        "name": "daysRemaining"
    }, v37 = {
        "kind": "ScalarField",
        "name": "status"
    }, v38 = {
        "kind": "ScalarField",
        "name": "toggle"
    }, v39 = {
        "kind": "ScalarField",
        "name": "color"
    }, v40 = {
        "kind": "ScalarField",
        "name": "permissions"
    }, v41 = {
        "concreteType": "EstimationConfig",
        "kind": "LinkedField",
        "name": "estimation",
        "plural": false,
        "selections": [
            {
                "concreteType": "CurrentEstimation",
                "kind": "LinkedField",
                "name": "current",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "customFieldId"
                    }
                ]
            }
        ]
    }, v42 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v43 = [
        v42 /*: any*/ ,
        v7 /*: any*/ ,
        v3 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ 
    ], v44 = {
        "concreteType": "CardStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            v3 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v45 = [
        v9 /*: any*/ 
    ], v46 = {
        "concreteType": "CardStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": v45 /*: any*/ 
    }, v47 = {
        "concreteType": "Estimate",
        "kind": "LinkedField",
        "name": "estimate",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            {
                "concreteType": "OriginalEstimate",
                "kind": "LinkedField",
                "name": "originalEstimate",
                "plural": false,
                "selections": [
                    v21 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            }
        ]
    }, v48 = [
        v9 /*: any*/ ,
        v3 /*: any*/ ,
        v26 /*: any*/ 
    ], v49 = {
        "concreteType": "CardType",
        "kind": "LinkedField",
        "name": "type",
        "plural": false,
        "selections": v48 /*: any*/ 
    }, v50 = {
        "concreteType": "CardPriority",
        "kind": "LinkedField",
        "name": "priority",
        "plural": false,
        "selections": [
            v3 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v51 = {
        "concreteType": "CardType",
        "kind": "LinkedField",
        "name": "cardTypes",
        "plural": true,
        "selections": [
            v9 /*: any*/ ,
            v3 /*: any*/ ,
            v26 /*: any*/ ,
            v30 /*: any*/ 
        ]
    }, v52 = [
        v31 /*: any*/ 
    ], v53 = {
        "concreteType": "InlineCardCreateConfig",
        "kind": "LinkedField",
        "name": "inlineCardCreate",
        "plural": false,
        "selections": v52 /*: any*/ 
    }, v54 = {
        "concreteType": "SoftwareCard",
        "kind": "LinkedField",
        "name": "cards",
        "plural": true,
        "selections": v45 /*: any*/ 
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "boardWithRouterRelayQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareBoard",
                                    "kind": "LinkedField",
                                    "name": "board",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.board.name"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.board.swimlaneStrategy"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v5 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.board.hasClearedCards"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v6 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.board.rankCustomFieldId"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "LinkedField",
                                                "name": "assignees",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v7 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.assignees.accountId"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.assignees.name"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v8 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.assignees.picture"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.assignees"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "Column",
                                                "kind": "LinkedField",
                                                "name": "columns",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.name"
                                                    },
                                                    v10 /*: any*/ ,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "ColumnStatus",
                                                            "kind": "LinkedField",
                                                            "name": "columnStatus",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "CardStatus",
                                                                        "kind": "LinkedField",
                                                                        "name": "status",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v9 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.status.id"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v3 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.status.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v11 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.status.category"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.columnStatus.status"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "SoftwareCardTypeTransition",
                                                                        "kind": "LinkedField",
                                                                        "name": "cardTypeTransitions",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v12 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.transitionId"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v3 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "CardStatus",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "status",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v9 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.status.id"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.status"
                                                                            },
                                                                            {
                                                                                "concreteType": "CardStatus",
                                                                                "kind": "LinkedField",
                                                                                "name": "originStatus",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v9 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.originStatus.id"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "CardType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "cardType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v9 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.cardType.id"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.cardType"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v13 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.isGlobal"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v14 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.isInitial"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v15 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.hasConditions"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.columnStatus.cardTypeTransitions"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.columnStatus"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v16 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.isDone"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v14 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.isInitial"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "SoftwareCard",
                                                            "kind": "LinkedField",
                                                            "name": "cards",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v9 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v17 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.flagged"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v18 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.done"
                                                                },
                                                                v19 /*: any*/ ,
                                                                {
                                                                    "concreteType": "Sprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "activeSprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v9 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.columns.cards.activeSprint.id"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "Estimate",
                                                                    "kind": "LinkedField",
                                                                    "name": "estimate",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "OriginalEstimate",
                                                                            "kind": "LinkedField",
                                                                            "name": "originalEstimate",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v21 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "boardScope.board.columns.cards.estimate.originalEstimate.value"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v22 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "boardScope.board.columns.cards.estimate.originalEstimate.valueAsText"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v23 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.key"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v24 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.summary"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v25 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.labels"
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "assignee",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v7 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.columns.cards.assignee.accountId"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "CardType",
                                                                        "kind": "LinkedField",
                                                                        "name": "type",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v9 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.cards.type.id"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v3 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.cards.type.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v26 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.cards.type.iconUrl"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.type"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "CardStatus",
                                                                        "kind": "LinkedField",
                                                                        "name": "status",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v9 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.cards.status.id"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.status"
                                                                },
                                                                {
                                                                    "concreteType": "CardPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v3 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.columns.cards.priority.name"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v26 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.columns.cards.priority.iconUrl"
                                                                        }
                                                                    ]
                                                                },
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "concreteType": "ChildCardsMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "childCardsMetadata",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v28 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.columns.cards.childCardsMetadata.complete"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v29 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.columns.cards.childCardsMetadata.total"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.cards"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.columns"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CardType",
                                                "kind": "LinkedField",
                                                "name": "cardTypes",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardTypes.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardTypes.name"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v26 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardTypes.iconUrl"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v30 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardTypes.hierarchyLevelType"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.cardTypes"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "InlineCardCreateConfig",
                                                "kind": "LinkedField",
                                                "name": "inlineCardCreate",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v31 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.inlineCardCreate.enabled"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.inlineCardCreate"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "SoftwareCard",
                                                "kind": "LinkedField",
                                                "name": "cardChildren",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v17 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.flagged"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v18 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.done"
                                                    },
                                                    v19 /*: any*/ ,
                                                    {
                                                        "concreteType": "Estimate",
                                                        "kind": "LinkedField",
                                                        "name": "estimate",
                                                        "plural": false,
                                                        "selections": [
                                                            v20 /*: any*/ ,
                                                            {
                                                                "concreteType": "OriginalEstimate",
                                                                "kind": "LinkedField",
                                                                "name": "originalEstimate",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v21 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cardChildren.estimate.originalEstimate.value"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v22 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cardChildren.estimate.originalEstimate.valueAsText"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v23 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.key"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v24 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.summary"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v25 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.labels"
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "assignee",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v7 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cardChildren.assignee.accountId"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v3 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cardChildren.assignee.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v8 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cardChildren.assignee.picture"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CardType",
                                                            "kind": "LinkedField",
                                                            "name": "type",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v9 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cardChildren.type.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cardChildren.type.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v26 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cardChildren.type.iconUrl"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.type"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CardStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v9 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cardChildren.status.id"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.status"
                                                    },
                                                    {
                                                        "concreteType": "CardPriority",
                                                        "kind": "LinkedField",
                                                        "name": "priority",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v3 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cardChildren.priority.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v26 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cardChildren.priority.iconUrl"
                                                            }
                                                        ]
                                                    },
                                                    v27 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.cardChildren"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "SoftwareCard",
                                                "kind": "LinkedField",
                                                "name": "cards",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cards.id"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.cards"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "BoardEditConfig",
                                                "kind": "LinkedField",
                                                "name": "editConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "InlineColumnEditConfig",
                                                            "kind": "LinkedField",
                                                            "name": "inlineColumnEdit",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v31 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.editConfig.inlineColumnEdit.enabled"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.editConfig.inlineColumnEdit"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "InlineCardCreateConfig",
                                                            "kind": "LinkedField",
                                                            "name": "inlineCardCreate",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v31 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.editConfig.inlineCardCreate.enabled"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.editConfig.inlineCardCreate"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.editConfig"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.board"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v32 /*: any*/ ,
                                    "concreteType": "Sprint",
                                    "kind": "LinkedField",
                                    "name": "sprints",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.name"
                                        },
                                        v33 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v34 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.startDate"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v35 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.endDate"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v36 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.daysRemaining"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "SoftwareCard",
                                                "kind": "LinkedField",
                                                "name": "cards",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.id"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.sprints.cards"
                                        }
                                    ],
                                    "storageKey": "sprints(state:[\"ACTIVE\"])"
                                },
                                "action": "THROW",
                                "path": "boardScope.sprints"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "BoardFeature",
                                    "kind": "LinkedField",
                                    "name": "features",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v23 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.key"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v37 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.status"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v38 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.toggle"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v11 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.category"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.features"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareProject",
                                    "kind": "LinkedField",
                                    "name": "projectLocation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.projectLocation.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v23 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.projectLocation.key"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.projectLocation.name"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CardType",
                                                "kind": "LinkedField",
                                                "name": "cardTypes",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.name"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v26 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.iconUrl"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v30 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.hierarchyLevelType"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.projectLocation.cardTypes"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.projectLocation"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CardParent",
                                    "kind": "LinkedField",
                                    "name": "cardParents",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.cardParents.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v23 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.cardParents.key"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v24 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.cardParents.summary"
                                        },
                                        {
                                            "concreteType": "CardStatus",
                                            "kind": "LinkedField",
                                            "name": "status",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v9 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.cardParents.status.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v3 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.cardParents.status.name"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v11 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.cardParents.status.category"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CardType",
                                                "kind": "LinkedField",
                                                "name": "cardType",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.cardParents.cardType.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.cardParents.cardType.name"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v26 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.cardParents.cardType.iconUrl"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.cardParents.cardType"
                                        },
                                        v39 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.cardParents"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CurrentUser",
                                    "kind": "LinkedField",
                                    "name": "currentUser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v40 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.currentUser.permissions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.currentUser"
                            },
                            v41 /*: any*/ 
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "boardWithRouterRelayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "SoftwareBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "assignees",
                                    "plural": true,
                                    "selections": v43 /*: any*/ 
                                },
                                {
                                    "concreteType": "Column",
                                    "kind": "LinkedField",
                                    "name": "columns",
                                    "plural": true,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "ColumnStatus",
                                            "kind": "LinkedField",
                                            "name": "columnStatus",
                                            "plural": true,
                                            "selections": [
                                                v44 /*: any*/ ,
                                                {
                                                    "concreteType": "SoftwareCardTypeTransition",
                                                    "kind": "LinkedField",
                                                    "name": "cardTypeTransitions",
                                                    "plural": true,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v46 /*: any*/ ,
                                                        {
                                                            "concreteType": "CardStatus",
                                                            "kind": "LinkedField",
                                                            "name": "originStatus",
                                                            "plural": false,
                                                            "selections": v45 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "CardType",
                                                            "kind": "LinkedField",
                                                            "name": "cardType",
                                                            "plural": false,
                                                            "selections": v45 /*: any*/ 
                                                        },
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "SoftwareCard",
                                            "kind": "LinkedField",
                                            "name": "cards",
                                            "plural": true,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "concreteType": "Sprint",
                                                    "kind": "LinkedField",
                                                    "name": "activeSprint",
                                                    "plural": false,
                                                    "selections": v45 /*: any*/ 
                                                },
                                                v47 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "assignee",
                                                    "plural": false,
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                },
                                                v49 /*: any*/ ,
                                                v46 /*: any*/ ,
                                                v50 /*: any*/ ,
                                                v27 /*: any*/ ,
                                                {
                                                    "concreteType": "ChildCardsMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "childCardsMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        v28 /*: any*/ ,
                                                        v29 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v51 /*: any*/ ,
                                v53 /*: any*/ ,
                                {
                                    "concreteType": "SoftwareCard",
                                    "kind": "LinkedField",
                                    "name": "cardChildren",
                                    "plural": true,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v47 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "assignee",
                                            "plural": false,
                                            "selections": v43 /*: any*/ 
                                        },
                                        v49 /*: any*/ ,
                                        v46 /*: any*/ ,
                                        v50 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                },
                                v54 /*: any*/ ,
                                {
                                    "concreteType": "BoardEditConfig",
                                    "kind": "LinkedField",
                                    "name": "editConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "InlineColumnEditConfig",
                                            "kind": "LinkedField",
                                            "name": "inlineColumnEdit",
                                            "plural": false,
                                            "selections": v52 /*: any*/ 
                                        },
                                        v53 /*: any*/ 
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "args": v32 /*: any*/ ,
                            "concreteType": "Sprint",
                            "kind": "LinkedField",
                            "name": "sprints",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v3 /*: any*/ ,
                                v33 /*: any*/ ,
                                v34 /*: any*/ ,
                                v35 /*: any*/ ,
                                v36 /*: any*/ ,
                                v54 /*: any*/ 
                            ],
                            "storageKey": "sprints(state:[\"ACTIVE\"])"
                        },
                        {
                            "concreteType": "BoardFeature",
                            "kind": "LinkedField",
                            "name": "features",
                            "plural": true,
                            "selections": [
                                v23 /*: any*/ ,
                                v37 /*: any*/ ,
                                v38 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "SoftwareProject",
                            "kind": "LinkedField",
                            "name": "projectLocation",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v23 /*: any*/ ,
                                v3 /*: any*/ ,
                                v51 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "CardParent",
                            "kind": "LinkedField",
                            "name": "cardParents",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v44 /*: any*/ ,
                                {
                                    "concreteType": "CardType",
                                    "kind": "LinkedField",
                                    "name": "cardType",
                                    "plural": false,
                                    "selections": v48 /*: any*/ 
                                },
                                v39 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "CurrentUser",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                v40 /*: any*/ 
                            ]
                        },
                        v41 /*: any*/ ,
                        v9 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67",
            "metadata": {},
            "name": "boardWithRouterRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$821625877dab08cc$var$node.hash = "72f5b0ae535a7d894e92c5d09606d166";
(0, $eiowN.PreloadableQueryRegistry).set($821625877dab08cc$var$node.params.id, $821625877dab08cc$var$node);
var $821625877dab08cc$export$2e2bcd8739ae039 = $821625877dab08cc$var$node;

});

parcelRegister("7FT8M", function(module, exports) {

$parcel$export(module.exports, "transformAggToSwagData", () => $0967d8b4618688d9$export$7285a1393f8c650c);

var $8QpSo = parcelRequire("8QpSo");

var $dXq4S = parcelRequire("dXq4S");
const $0967d8b4618688d9$export$79640a85913af5aa = (ari)=>{
    const possibleAri = (0, $dXq4S.toAri)(ari);
    if (possibleAri) return (0, $dXq4S.getAriConfig)(possibleAri).resourceId;
    return ari;
};
const $0967d8b4618688d9$var$getBoard = (data)=>{
    const { boardScope: { board: board } } = data;
    return {
        name: board.name,
        swimlaneStrategy: board.swimlaneStrategy,
        rankCustomFieldId: board.rankCustomFieldId,
        assignees: board.assignees.filter(Boolean).map((assignee)=>({
                accountId: assignee.accountId,
                displayName: assignee.name,
                avatarUrl: assignee.picture
            })),
        // @ts-expect-error - TS2322 - Type '{ id: string; name: string; maxIssueCount: number | null; status: { id: string; name: string; }[]; columnStatus: { status: { readonly category: string; readonly id: string; readonly name: string; }; transitions: { ...; }[]; }[]; isInitial: boolean; isDone: boolean; cards: { ...; }[]; }[]' is not assignable to type 'readonly ColumnWithCardsGQL[]'.
        columns: board.columns.filter(Boolean).map((column)=>({
                id: column.id,
                name: column.name,
                maxIssueCount: column.maxCardCount,
                status: column.columnStatus.map((cs)=>({
                        id: cs.status.id,
                        name: cs.status.name
                    })),
                columnStatus: column.columnStatus.map((cs)=>({
                        status: cs.status,
                        transitions: cs.cardTypeTransitions.map((transition)=>({
                                id: transition.transitionId,
                                name: transition.name,
                                status: transition.status,
                                originStatus: transition.originStatus,
                                cardType: transition.cardType,
                                isGlobal: transition.isGlobal,
                                isInitial: transition.isInitial,
                                hasConditions: transition.hasConditions
                            }))
                    })),
                isInitial: column.isInitial,
                isDone: column.isDone,
                cards: column.cards.filter(Boolean).map((card)=>({
                        id: $0967d8b4618688d9$export$79640a85913af5aa(card.id),
                        activeSprint: card.activeSprint ? {
                            id: $0967d8b4618688d9$export$79640a85913af5aa(card.activeSprint.id)
                        } : null,
                        issue: {
                            id: $0967d8b4618688d9$export$79640a85913af5aa(card.id),
                            key: card.key,
                            summary: card.summary,
                            labels: card.labels.filter(Boolean),
                            type: card.type,
                            status: card.status,
                            assignee: card.assignee ? {
                                accountId: card.assignee.accountId
                            } : null
                        },
                        flagged: card.flagged,
                        done: card.done,
                        parentId: card.parentId != null ? $0967d8b4618688d9$export$79640a85913af5aa(card.parentId) : null,
                        estimate: card.estimate ? card.estimate : null,
                        priority: card.priority,
                        dueDate: card.dueDate,
                        childIssuesMetadata: card.childCardsMetadata
                    }))
            })),
        // @ts-expect-error - TS2322 - Type '({ readonly hierarchyLevelType: AGG$CardTypeHierarchyLevelType; readonly iconUrl: string; readonly id: string; readonly name: string; } | null)[]' is not assignable to type 'readonly IssueTypeGQL[]'.
        issueTypes: board.cardTypes.filter(Boolean),
        // @ts-expect-error - TS2322 - Type '{ id: string; issue: { assignee: { accountId: string; displayName: string; avatarUrl: AGG$URL; } | null; id: string; key: string; summary: string; labels: (string | null)[]; status: { readonly id: string; }; type: { ...; }; }; ... 5 more ...; dueDate: string | null; }[]' is not assignable to type 'readonly CardChildGQL[]'.
        issueChildren: board.cardChildren.filter(Boolean).map((card)=>({
                id: $0967d8b4618688d9$export$79640a85913af5aa(card.id),
                issue: {
                    assignee: card.assignee != null ? {
                        accountId: card.assignee.accountId,
                        displayName: card.assignee.name,
                        avatarUrl: card.assignee.picture
                    } : null,
                    id: $0967d8b4618688d9$export$79640a85913af5aa(card.id),
                    key: card.key,
                    summary: card.summary,
                    labels: card.labels.filter(Boolean),
                    status: card.status,
                    type: card.type
                },
                flagged: card.flagged,
                done: card.done,
                parentId: card.parentId != null ? $0967d8b4618688d9$export$79640a85913af5aa(card.parentId) : null,
                estimate: card.estimate ? card.estimate : null,
                priority: card.priority,
                dueDate: card.dueDate
            })),
        cards: board.cards.filter(Boolean).map((card)=>({
                id: $0967d8b4618688d9$export$79640a85913af5aa(card.id)
            })),
        editConfig: {
            inlineColumnEdit: board.editConfig.inlineColumnEdit,
            inlineIssueCreate: board.editConfig.inlineCardCreate
        },
        hasClearedIssues: board.hasClearedCards,
        inlineIssueCreate: board.inlineCardCreate
    };
};
const $0967d8b4618688d9$export$7285a1393f8c650c = (0, $8QpSo.default)((data)=>{
    const { boardScope: boardScope } = data;
    return {
        userSwimlaneStrategy: boardScope.userSwimlaneStrategy,
        board: $0967d8b4618688d9$var$getBoard(data),
        sprints: boardScope.sprints.filter(Boolean).map((sprint)=>({
                ...sprint,
                goal: sprint.goal || '',
                id: $0967d8b4618688d9$export$79640a85913af5aa(sprint.id),
                cards: sprint.cards.filter(Boolean)
            })),
        // @ts-expect-error - TS2322 - Type '({ readonly category: string; readonly key: AGG$SoftwareBoardFeatureKey; readonly status: BoardFeatureStatus; readonly toggle: BoardFeatureToggleStatus; } | null)[]' is not assignable to type 'readonly BoardFeatureGQL[]'.
        features: boardScope.features.filter(Boolean),
        projectLocation: {
            id: $0967d8b4618688d9$export$79640a85913af5aa(boardScope.projectLocation.id),
            key: boardScope.projectLocation.key,
            name: boardScope.projectLocation.name,
            isSimplifiedProject: true,
            // @ts-expect-error - TS2322 - Type '({ readonly hierarchyLevelType: AGG$CardTypeHierarchyLevelType; readonly iconUrl: string; readonly id: string; readonly name: string; } | null)[]' is not assignable to type 'readonly IssueTypeGQL[]'.
            issueTypes: boardScope.projectLocation.cardTypes.filter(Boolean)
        },
        issueParents: boardScope.cardParents.filter(Boolean).map((cardParent)=>({
                id: $0967d8b4618688d9$export$79640a85913af5aa(cardParent.id),
                key: cardParent.key,
                summary: cardParent.summary,
                issue: {
                    status: cardParent.status
                },
                issueType: cardParent.cardType,
                color: cardParent.color
            })),
        currentUser: {
            permissions: boardScope.currentUser.permissions.filter(Boolean)
        },
        estimation: boardScope.estimation
    };
});

});




// error types
const $4cff3ad70ea80f75$export$6c8cb487d6ffc522 = 'QueryError';
const $4cff3ad70ea80f75$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $4cff3ad70ea80f75$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $4cff3ad70ea80f75$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $4cff3ad70ea80f75$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $4cff3ad70ea80f75$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $4cff3ad70ea80f75$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $4cff3ad70ea80f75$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $4cff3ad70ea80f75$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $4cff3ad70ea80f75$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $4cff3ad70ea80f75$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $4cff3ad70ea80f75$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';


//# sourceMappingURL=async-next-gen-board.d4a1306f.js.map
